(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 32289:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*

The MIT License (MIT)

Original Library
  - Copyright (c) Marak Squires

Additional functionality
 - Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/

var colors = {};
module['exports'] = colors;

colors.themes = {};

var util = __webpack_require__(79720);
var ansiStyles = colors.styles = __webpack_require__(38982);
var defineProps = Object.defineProperties;
var newLineRegex = new RegExp(/[\r\n]+/g);

colors.supportsColor = (__webpack_require__(48136).supportsColor);

if (typeof colors.enabled === 'undefined') {
  colors.enabled = colors.supportsColor() !== false;
}

colors.enable = function() {
  colors.enabled = true;
};

colors.disable = function() {
  colors.enabled = false;
};

colors.stripColors = colors.strip = function(str) {
  return ('' + str).replace(/\x1B\[\d+m/g, '');
};

// eslint-disable-next-line no-unused-vars
var stylize = colors.stylize = function stylize(str, style) {
  if (!colors.enabled) {
    return str+'';
  }

  var styleMap = ansiStyles[style];

  // Stylize should work for non-ANSI styles, too
  if (!styleMap && style in colors) {
    // Style maps like trap operate as functions on strings;
    // they don't have properties like open or close.
    return colors[style](str);
  }

  return styleMap.open + str + styleMap.close;
};

var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;
var escapeStringRegexp = function(str) {
  if (typeof str !== 'string') {
    throw new TypeError('Expected a string');
  }
  return str.replace(matchOperatorsRe, '\\$&');
};

function build(_styles) {
  var builder = function builder() {
    return applyStyle.apply(builder, arguments);
  };
  builder._styles = _styles;
  // __proto__ is used because we must return a function, but there is
  // no way to create a function with a different prototype.
  builder.__proto__ = proto;
  return builder;
}

var styles = (function() {
  var ret = {};
  ansiStyles.grey = ansiStyles.gray;
  Object.keys(ansiStyles).forEach(function(key) {
    ansiStyles[key].closeRe =
      new RegExp(escapeStringRegexp(ansiStyles[key].close), 'g');
    ret[key] = {
      get: function() {
        return build(this._styles.concat(key));
      },
    };
  });
  return ret;
})();

var proto = defineProps(function colors() {}, styles);

function applyStyle() {
  var args = Array.prototype.slice.call(arguments);

  var str = args.map(function(arg) {
    // Use weak equality check so we can colorize null/undefined in safe mode
    if (arg != null && arg.constructor === String) {
      return arg;
    } else {
      return util.inspect(arg);
    }
  }).join(' ');

  if (!colors.enabled || !str) {
    return str;
  }

  var newLinesPresent = str.indexOf('\n') != -1;

  var nestedStyles = this._styles;

  var i = nestedStyles.length;
  while (i--) {
    var code = ansiStyles[nestedStyles[i]];
    str = code.open + str.replace(code.closeRe, code.open) + code.close;
    if (newLinesPresent) {
      str = str.replace(newLineRegex, function(match) {
        return code.close + match + code.open;
      });
    }
  }

  return str;
}

colors.setTheme = function(theme) {
  if (typeof theme === 'string') {
    console.log('colors.setTheme now only accepts an object, not a string.  ' +
      'If you are trying to set a theme from a file, it is now your (the ' +
      'caller\'s) responsibility to require the file.  The old syntax ' +
      'looked like colors.setTheme(__dirname + ' +
      '\'/../themes/generic-logging.js\'); The new syntax looks like '+
      'colors.setTheme(require(__dirname + ' +
      '\'/../themes/generic-logging.js\'));');
    return;
  }
  for (var style in theme) {
    (function(style) {
      colors[style] = function(str) {
        if (typeof theme[style] === 'object') {
          var out = str;
          for (var i in theme[style]) {
            out = colors[theme[style][i]](out);
          }
          return out;
        }
        return colors[theme[style]](str);
      };
    })(style);
  }
};

function init() {
  var ret = {};
  Object.keys(styles).forEach(function(name) {
    ret[name] = {
      get: function() {
        return build([name]);
      },
    };
  });
  return ret;
}

var sequencer = function sequencer(map, str) {
  var exploded = str.split('');
  exploded = exploded.map(map);
  return exploded.join('');
};

// custom formatter methods
colors.trap = __webpack_require__(58763);
colors.zalgo = __webpack_require__(50750);

// maps
colors.maps = {};
colors.maps.america = __webpack_require__(36278)(colors);
colors.maps.zebra = __webpack_require__(90848)(colors);
colors.maps.rainbow = __webpack_require__(38823)(colors);
colors.maps.random = __webpack_require__(79353)(colors);

for (var map in colors.maps) {
  (function(map) {
    colors[map] = function(str) {
      return sequencer(colors.maps[map], str);
    };
  })(map);
}

defineProps(colors, init());


/***/ }),

/***/ 58763:
/***/ (function(module) {

module['exports'] = function runTheTrap(text, options) {
  var result = '';
  text = text || 'Run the trap, drop the bass';
  text = text.split('');
  var trap = {
    a: ['\u0040', '\u0104', '\u023a', '\u0245', '\u0394', '\u039b', '\u0414'],
    b: ['\u00df', '\u0181', '\u0243', '\u026e', '\u03b2', '\u0e3f'],
    c: ['\u00a9', '\u023b', '\u03fe'],
    d: ['\u00d0', '\u018a', '\u0500', '\u0501', '\u0502', '\u0503'],
    e: ['\u00cb', '\u0115', '\u018e', '\u0258', '\u03a3', '\u03be', '\u04bc',
      '\u0a6c'],
    f: ['\u04fa'],
    g: ['\u0262'],
    h: ['\u0126', '\u0195', '\u04a2', '\u04ba', '\u04c7', '\u050a'],
    i: ['\u0f0f'],
    j: ['\u0134'],
    k: ['\u0138', '\u04a0', '\u04c3', '\u051e'],
    l: ['\u0139'],
    m: ['\u028d', '\u04cd', '\u04ce', '\u0520', '\u0521', '\u0d69'],
    n: ['\u00d1', '\u014b', '\u019d', '\u0376', '\u03a0', '\u048a'],
    o: ['\u00d8', '\u00f5', '\u00f8', '\u01fe', '\u0298', '\u047a', '\u05dd',
      '\u06dd', '\u0e4f'],
    p: ['\u01f7', '\u048e'],
    q: ['\u09cd'],
    r: ['\u00ae', '\u01a6', '\u0210', '\u024c', '\u0280', '\u042f'],
    s: ['\u00a7', '\u03de', '\u03df', '\u03e8'],
    t: ['\u0141', '\u0166', '\u0373'],
    u: ['\u01b1', '\u054d'],
    v: ['\u05d8'],
    w: ['\u0428', '\u0460', '\u047c', '\u0d70'],
    x: ['\u04b2', '\u04fe', '\u04fc', '\u04fd'],
    y: ['\u00a5', '\u04b0', '\u04cb'],
    z: ['\u01b5', '\u0240'],
  };
  text.forEach(function(c) {
    c = c.toLowerCase();
    var chars = trap[c] || [' '];
    var rand = Math.floor(Math.random() * chars.length);
    if (typeof trap[c] !== 'undefined') {
      result += trap[c][rand];
    } else {
      result += c;
    }
  });
  return result;
};


/***/ }),

/***/ 50750:
/***/ (function(module) {

// please no
module['exports'] = function zalgo(text, options) {
  text = text || '   he is here   ';
  var soul = {
    'up': [
      '̍', '̎', '̄', '̅',
      '̿', '̑', '̆', '̐',
      '͒', '͗', '͑', '̇',
      '̈', '̊', '͂', '̓',
      '̈', '͊', '͋', '͌',
      '̃', '̂', '̌', '͐',
      '̀', '́', '̋', '̏',
      '̒', '̓', '̔', '̽',
      '̉', 'ͣ', 'ͤ', 'ͥ',
      'ͦ', 'ͧ', 'ͨ', 'ͩ',
      'ͪ', 'ͫ', 'ͬ', 'ͭ',
      'ͮ', 'ͯ', '̾', '͛',
      '͆', '̚',
    ],
    'down': [
      '̖', '̗', '̘', '̙',
      '̜', '̝', '̞', '̟',
      '̠', '̤', '̥', '̦',
      '̩', '̪', '̫', '̬',
      '̭', '̮', '̯', '̰',
      '̱', '̲', '̳', '̹',
      '̺', '̻', '̼', 'ͅ',
      '͇', '͈', '͉', '͍',
      '͎', '͓', '͔', '͕',
      '͖', '͙', '͚', '̣',
    ],
    'mid': [
      '̕', '̛', '̀', '́',
      '͘', '̡', '̢', '̧',
      '̨', '̴', '̵', '̶',
      '͜', '͝', '͞',
      '͟', '͠', '͢', '̸',
      '̷', '͡', ' ҉',
    ],
  };
  var all = [].concat(soul.up, soul.down, soul.mid);

  function randomNumber(range) {
    var r = Math.floor(Math.random() * range);
    return r;
  }

  function isChar(character) {
    var bool = false;
    all.filter(function(i) {
      bool = (i === character);
    });
    return bool;
  }


  function heComes(text, options) {
    var result = '';
    var counts;
    var l;
    options = options || {};
    options['up'] =
      typeof options['up'] !== 'undefined' ? options['up'] : true;
    options['mid'] =
      typeof options['mid'] !== 'undefined' ? options['mid'] : true;
    options['down'] =
      typeof options['down'] !== 'undefined' ? options['down'] : true;
    options['size'] =
      typeof options['size'] !== 'undefined' ? options['size'] : 'maxi';
    text = text.split('');
    for (l in text) {
      if (isChar(l)) {
        continue;
      }
      result = result + text[l];
      counts = {'up': 0, 'down': 0, 'mid': 0};
      switch (options.size) {
        case 'mini':
          counts.up = randomNumber(8);
          counts.mid = randomNumber(2);
          counts.down = randomNumber(8);
          break;
        case 'maxi':
          counts.up = randomNumber(16) + 3;
          counts.mid = randomNumber(4) + 1;
          counts.down = randomNumber(64) + 3;
          break;
        default:
          counts.up = randomNumber(8) + 1;
          counts.mid = randomNumber(6) / 2;
          counts.down = randomNumber(8) + 1;
          break;
      }

      var arr = ['up', 'mid', 'down'];
      for (var d in arr) {
        var index = arr[d];
        for (var i = 0; i <= counts[index]; i++) {
          if (options[index]) {
            result = result + soul[index][randomNumber(soul[index].length)];
          }
        }
      }
    }
    return result;
  }
  // don't summon him
  return heComes(text, options);
};



/***/ }),

/***/ 36278:
/***/ (function(module) {

module['exports'] = function(colors) {
  return function(letter, i, exploded) {
    if (letter === ' ') return letter;
    switch (i%3) {
      case 0: return colors.red(letter);
      case 1: return colors.white(letter);
      case 2: return colors.blue(letter);
    }
  };
};


/***/ }),

/***/ 38823:
/***/ (function(module) {

module['exports'] = function(colors) {
  // RoY G BiV
  var rainbowColors = ['red', 'yellow', 'green', 'blue', 'magenta'];
  return function(letter, i, exploded) {
    if (letter === ' ') {
      return letter;
    } else {
      return colors[rainbowColors[i++ % rainbowColors.length]](letter);
    }
  };
};



/***/ }),

/***/ 79353:
/***/ (function(module) {

module['exports'] = function(colors) {
  var available = ['underline', 'inverse', 'grey', 'yellow', 'red', 'green',
    'blue', 'white', 'cyan', 'magenta', 'brightYellow', 'brightRed',
    'brightGreen', 'brightBlue', 'brightWhite', 'brightCyan', 'brightMagenta'];
  return function(letter, i, exploded) {
    return letter === ' ' ? letter :
      colors[
          available[Math.round(Math.random() * (available.length - 2))]
      ](letter);
  };
};


/***/ }),

/***/ 90848:
/***/ (function(module) {

module['exports'] = function(colors) {
  return function(letter, i, exploded) {
    return i % 2 === 0 ? letter : colors.inverse(letter);
  };
};


/***/ }),

/***/ 38982:
/***/ (function(module) {

/*
The MIT License (MIT)

Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/

var styles = {};
module['exports'] = styles;

var codes = {
  reset: [0, 0],

  bold: [1, 22],
  dim: [2, 22],
  italic: [3, 23],
  underline: [4, 24],
  inverse: [7, 27],
  hidden: [8, 28],
  strikethrough: [9, 29],

  black: [30, 39],
  red: [31, 39],
  green: [32, 39],
  yellow: [33, 39],
  blue: [34, 39],
  magenta: [35, 39],
  cyan: [36, 39],
  white: [37, 39],
  gray: [90, 39],
  grey: [90, 39],

  brightRed: [91, 39],
  brightGreen: [92, 39],
  brightYellow: [93, 39],
  brightBlue: [94, 39],
  brightMagenta: [95, 39],
  brightCyan: [96, 39],
  brightWhite: [97, 39],

  bgBlack: [40, 49],
  bgRed: [41, 49],
  bgGreen: [42, 49],
  bgYellow: [43, 49],
  bgBlue: [44, 49],
  bgMagenta: [45, 49],
  bgCyan: [46, 49],
  bgWhite: [47, 49],
  bgGray: [100, 49],
  bgGrey: [100, 49],

  bgBrightRed: [101, 49],
  bgBrightGreen: [102, 49],
  bgBrightYellow: [103, 49],
  bgBrightBlue: [104, 49],
  bgBrightMagenta: [105, 49],
  bgBrightCyan: [106, 49],
  bgBrightWhite: [107, 49],

  // legacy styles for colors pre v1.0.0
  blackBG: [40, 49],
  redBG: [41, 49],
  greenBG: [42, 49],
  yellowBG: [43, 49],
  blueBG: [44, 49],
  magentaBG: [45, 49],
  cyanBG: [46, 49],
  whiteBG: [47, 49],

};

Object.keys(codes).forEach(function(key) {
  var val = codes[key];
  var style = styles[key] = [];
  style.open = '\u001b[' + val[0] + 'm';
  style.close = '\u001b[' + val[1] + 'm';
});


/***/ }),

/***/ 43719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);
/*
MIT License

Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

Permission is hereby granted, free of charge, to any person obtaining a copy of
this software and associated documentation files (the "Software"), to deal in
the Software without restriction, including without limitation the rights to
use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
of the Software, and to permit persons to whom the Software is furnished to do
so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/



module.exports = function(flag, argv) {
  argv = argv || process.argv || [];

  var terminatorPos = argv.indexOf('--');
  var prefix = /^-{1,2}/.test(flag) ? '' : '--';
  var pos = argv.indexOf(prefix + flag);

  return pos !== -1 && (terminatorPos === -1 ? true : pos < terminatorPos);
};


/***/ }),

/***/ 48136:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);
/*
The MIT License (MIT)

Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/



var os = __webpack_require__(73461);
var hasFlag = __webpack_require__(43719);

var env = process.env;

var forceColor = void 0;
if (hasFlag('no-color') || hasFlag('no-colors') || hasFlag('color=false')) {
  forceColor = false;
} else if (hasFlag('color') || hasFlag('colors') || hasFlag('color=true')
           || hasFlag('color=always')) {
  forceColor = true;
}
if ('FORCE_COLOR' in env) {
  forceColor = env.FORCE_COLOR.length === 0
    || parseInt(env.FORCE_COLOR, 10) !== 0;
}

function translateLevel(level) {
  if (level === 0) {
    return false;
  }

  return {
    level: level,
    hasBasic: true,
    has256: level >= 2,
    has16m: level >= 3,
  };
}

function supportsColor(stream) {
  if (forceColor === false) {
    return 0;
  }

  if (hasFlag('color=16m') || hasFlag('color=full')
      || hasFlag('color=truecolor')) {
    return 3;
  }

  if (hasFlag('color=256')) {
    return 2;
  }

  if (stream && !stream.isTTY && forceColor !== true) {
    return 0;
  }

  var min = forceColor ? 1 : 0;

  if (process.platform === 'win32') {
    // Node.js 7.5.0 is the first version of Node.js to include a patch to
    // libuv that enables 256 color output on Windows. Anything earlier and it
    // won't work. However, here we target Node.js 8 at minimum as it is an LTS
    // release, and Node.js 7 is not. Windows 10 build 10586 is the first
    // Windows release that supports 256 colors. Windows 10 build 14931 is the
    // first release that supports 16m/TrueColor.
    var osRelease = os.release().split('.');
    if (Number(process.versions.node.split('.')[0]) >= 8
        && Number(osRelease[0]) >= 10 && Number(osRelease[2]) >= 10586) {
      return Number(osRelease[2]) >= 14931 ? 3 : 2;
    }

    return 1;
  }

  if ('CI' in env) {
    if (['TRAVIS', 'CIRCLECI', 'APPVEYOR', 'GITLAB_CI'].some(function(sign) {
      return sign in env;
    }) || env.CI_NAME === 'codeship') {
      return 1;
    }

    return min;
  }

  if ('TEAMCITY_VERSION' in env) {
    return (/^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(env.TEAMCITY_VERSION) ? 1 : 0
    );
  }

  if ('TERM_PROGRAM' in env) {
    var version = parseInt((env.TERM_PROGRAM_VERSION || '').split('.')[0], 10);

    switch (env.TERM_PROGRAM) {
      case 'iTerm.app':
        return version >= 3 ? 3 : 2;
      case 'Hyper':
        return 3;
      case 'Apple_Terminal':
        return 2;
      // No default
    }
  }

  if (/-256(color)?$/i.test(env.TERM)) {
    return 2;
  }

  if (/^screen|^xterm|^vt100|^rxvt|color|ansi|cygwin|linux/i.test(env.TERM)) {
    return 1;
  }

  if ('COLORTERM' in env) {
    return 1;
  }

  if (env.TERM === 'dumb') {
    return min;
  }

  return min;
}

function getSupportLevel(stream) {
  var level = supportsColor(stream);
  return translateLevel(level);
}

module.exports = {
  supportsColor: getSupportLevel,
  stdout: getSupportLevel(process.stdout),
  stderr: getSupportLevel(process.stderr),
};


/***/ }),

/***/ 33645:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

//
// Remark: Requiring this file will use the "safe" colors API,
// which will not touch String.prototype.
//
//   var colors = require('colors/safe');
//   colors.red("foo")
//
//
var colors = __webpack_require__(32289);
module['exports'] = colors;


/***/ }),

/***/ 12524:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

//
// Select the correct build version depending on the environment.
//
if (true) {
  module.exports = __webpack_require__(10519);
} else {}


/***/ }),

/***/ 10519:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var create = __webpack_require__(4099);

/**
 * Create a new diagnostics logger.
 *
 * @param {String} namespace The namespace it should enable.
 * @param {Object} options Additional options.
 * @returns {Function} The logger.
 * @public
 */
var diagnostics = create(function prod(namespace, options) {
  options = options || {};
  options.namespace = namespace;
  options.prod = true;
  options.dev = false;

  if (!(options.force || prod.force)) return prod.nope(options);
  return prod.yep(options);
});

//
// Expose the diagnostics logger.
//
module.exports = diagnostics;


/***/ }),

/***/ 4099:
/***/ (function(module) {

/**
 * Contains all configured adapters for the given environment.
 *
 * @type {Array}
 * @public
 */
var adapters = [];

/**
 * Contains all modifier functions.
 *
 * @typs {Array}
 * @public
 */
var modifiers = [];

/**
 * Our default logger.
 *
 * @public
 */
var logger = function devnull() {};

/**
 * Register a new adapter that will used to find environments.
 *
 * @param {Function} adapter A function that will return the possible env.
 * @returns {Boolean} Indication of a successful add.
 * @public
 */
function use(adapter) {
  if (~adapters.indexOf(adapter)) return false;

  adapters.push(adapter);
  return true;
}

/**
 * Assign a new log method.
 *
 * @param {Function} custom The log method.
 * @public
 */
function set(custom) {
  logger = custom;
}

/**
 * Check if the namespace is allowed by any of our adapters.
 *
 * @param {String} namespace The namespace that needs to be enabled
 * @returns {Boolean|Promise} Indication if the namespace is enabled by our adapters.
 * @public
 */
function enabled(namespace) {
  var async = [];

  for (var i = 0; i < adapters.length; i++) {
    if (adapters[i].async) {
      async.push(adapters[i]);
      continue;
    }

    if (adapters[i](namespace)) return true;
  }

  if (!async.length) return false;

  //
  // Now that we know that we Async functions, we know we run in an ES6
  // environment and can use all the API's that they offer, in this case
  // we want to return a Promise so that we can `await` in React-Native
  // for an async adapter.
  //
  return new Promise(function pinky(resolve) {
    Promise.all(
      async.map(function prebind(fn) {
        return fn(namespace);
      })
    ).then(function resolved(values) {
      resolve(values.some(Boolean));
    });
  });
}

/**
 * Add a new message modifier to the debugger.
 *
 * @param {Function} fn Modification function.
 * @returns {Boolean} Indication of a successful add.
 * @public
 */
function modify(fn) {
  if (~modifiers.indexOf(fn)) return false;

  modifiers.push(fn);
  return true;
}

/**
 * Write data to the supplied logger.
 *
 * @param {Object} meta Meta information about the log.
 * @param {Array} args Arguments for console.log.
 * @public
 */
function write() {
  logger.apply(logger, arguments);
}

/**
 * Process the message with the modifiers.
 *
 * @param {Mixed} message The message to be transformed by modifers.
 * @returns {String} Transformed message.
 * @public
 */
function process(message) {
  for (var i = 0; i < modifiers.length; i++) {
    message = modifiers[i].apply(modifiers[i], arguments);
  }

  return message;
}

/**
 * Introduce options to the logger function.
 *
 * @param {Function} fn Calback function.
 * @param {Object} options Properties to introduce on fn.
 * @returns {Function} The passed function
 * @public
 */
function introduce(fn, options) {
  var has = Object.prototype.hasOwnProperty;

  for (var key in options) {
    if (has.call(options, key)) {
      fn[key] = options[key];
    }
  }

  return fn;
}

/**
 * Nope, we're not allowed to write messages.
 *
 * @returns {Boolean} false
 * @public
 */
function nope(options) {
  options.enabled = false;
  options.modify = modify;
  options.set = set;
  options.use = use;

  return introduce(function diagnopes() {
    return false;
  }, options);
}

/**
 * Yep, we're allowed to write debug messages.
 *
 * @param {Object} options The options for the process.
 * @returns {Function} The function that does the logging.
 * @public
 */
function yep(options) {
  /**
   * The function that receives the actual debug information.
   *
   * @returns {Boolean} indication that we're logging.
   * @public
   */
  function diagnostics() {
    var args = Array.prototype.slice.call(arguments, 0);

    write.call(write, options, process(args, options));
    return true;
  }

  options.enabled = true;
  options.modify = modify;
  options.set = set;
  options.use = use;

  return introduce(diagnostics, options);
}

/**
 * Simple helper function to introduce various of helper methods to our given
 * diagnostics function.
 *
 * @param {Function} diagnostics The diagnostics function.
 * @returns {Function} diagnostics
 * @public
 */
module.exports = function create(diagnostics) {
  diagnostics.introduce = introduce;
  diagnostics.enabled = enabled;
  diagnostics.process = process;
  diagnostics.modify = modify;
  diagnostics.write = write;
  diagnostics.nope = nope;
  diagnostics.yep = yep;
  diagnostics.set = set;
  diagnostics.use = use;

  return diagnostics;
}


/***/ }),

/***/ 28996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createCache; }
});

;// CONCATENATED MODULE: ./node_modules/@emotion/cache/node_modules/@emotion/sheet/dist/emotion-sheet.browser.esm.js
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (false) { var isImportRule; }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (false) {}
  };

  return StyleSheet;
}();



;// CONCATENATED MODULE: ./node_modules/stylis/src/Utility.js
/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs

/**
 * @param {number}
 * @return {string}
 */
var Utility_from = String.fromCharCode

/**
 * @param {object}
 * @return {object}
 */
var Utility_assign = Object.assign

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return Utility_charat(value, 0) ^ 45 ? (((((((length << 2) ^ Utility_charat(value, 0)) << 2) ^ Utility_charat(value, 1)) << 2) ^ Utility_charat(value, 2)) << 2) ^ Utility_charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function Utility_match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function Utility_replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function Utility_charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function Utility_substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function Utility_strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function Utility_sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function Utility_append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function Utility_combine (array, callback) {
	return array.map(callback).join('')
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Tokenizer.js


var line = 1
var column = 1
var Tokenizer_length = 0
var position = 0
var character = 0
var characters = ''

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function Tokenizer_copy (root, props) {
	return Utility_assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function Tokenizer_char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? Utility_charat(characters, --position) : 0

	if (column--, character === 10)
		column = 1, line--

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < Tokenizer_length ? Utility_charat(characters, position++) : 0

	if (column++, character === 10)
		column = 1, line++

	return character
}

/**
 * @return {number}
 */
function peek () {
	return Utility_charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return Utility_substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, Tokenizer_length = Utility_strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {string} value
 * @return {string[]}
 */
function Tokenizer_tokenize (value) {
	return dealloc(tokenizer(alloc(value)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next()
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer (children) {
	while (next())
		switch (token(character)) {
			case 0: append(identifier(position - 1), children)
				break
			case 2: append(delimit(character), children)
				break
			default: append(from(character), children)
		}

	return children
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character)
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type)
				break
			// \
			case 92:
				next()
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + Utility_from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next()

	return slice(index, position)
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Enum.js
var Enum_MS = '-ms-'
var Enum_MOZ = '-moz-'
var Enum_WEBKIT = '-webkit-'

var COMMENT = 'comm'
var Enum_RULESET = 'rule'
var Enum_DECLARATION = 'decl'

var PAGE = '@page'
var MEDIA = '@media'
var IMPORT = '@import'
var CHARSET = '@charset'
var VIEWPORT = '@viewport'
var SUPPORTS = '@supports'
var DOCUMENT = '@document'
var NAMESPACE = '@namespace'
var Enum_KEYFRAMES = '@keyframes'
var FONT_FACE = '@font-face'
var COUNTER_STYLE = '@counter-style'
var FONT_FEATURE_VALUES = '@font-feature-values'
var LAYER = '@layer'

;// CONCATENATED MODULE: ./node_modules/stylis/src/Serializer.js



/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function Serializer_serialize (children, callback) {
	var output = ''
	var length = Utility_sizeof(children)

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || ''

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case LAYER: if (element.children.length) break
		case IMPORT: case Enum_DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case Enum_KEYFRAMES: return element.return = element.value + '{' + Serializer_serialize(element.children, callback) + '}'
		case Enum_RULESET: element.value = element.props.join(',')
	}

	return Utility_strlen(children = Serializer_serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Middleware.js






/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = Utility_sizeof(collection)

	return function (element, index, children, callback) {
		var output = ''

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || ''

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element)
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix(element.value, element.length, children)
					return
				case KEYFRAMES:
					return serialize([copy(element, {value: replace(element.value, '@', '@' + WEBKIT)})], callback)
				case RULESET:
					if (element.length)
						return combine(element.props, function (value) {
							switch (match(value, /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									return serialize([copy(element, {props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]})], callback)
								// :placeholder
								case '::placeholder':
									return serialize([
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]})
									], callback)
							}

							return ''
						})
			}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */
function namespace (element) {
	switch (element.type) {
		case RULESET:
			element.props = element.props.map(function (value) {
				return combine(tokenize(value), function (value, index, children) {
					switch (charat(value, 0)) {
						// \f
						case 12:
							return substr(value, 1, strlen(value))
						// \0 ( + > ~
						case 0: case 40: case 43: case 62: case 126:
							return value
						// :
						case 58:
							if (children[++index] === 'global')
								children[index] = '', children[++index] = '\f' + substr(children[index], index = 1, -1)
						// \s
						case 32:
							return index === 1 ? '' : value
						default:
							switch (index) {
								case 0: element = value
									return sizeof(children) > 1 ? '' : value
								case index = sizeof(children) - 1: case 2:
									return index === 2 ? value + element + element : value + element
								default:
									return value
							}
					}
				})
			})
	}
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Parser.js




/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0
	var offset = 0
	var length = pseudo
	var atrule = 0
	var property = 0
	var previous = 0
	var variable = 1
	var scanning = 1
	var ampersand = 1
	var character = 0
	var type = ''
	var props = rules
	var children = rulesets
	var reference = rule
	var characters = type

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && Utility_charat(characters, length - 1) == 58) {
					if (indexof(characters += Utility_replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character)
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous)
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7)
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						Utility_append(comment(commenter(next(), caret()), root, parent), declarations)
						break
					default:
						characters += '/'
				}
				break
			// {
			case 123 * variable:
				points[index++] = Utility_strlen(characters) * ampersand
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0
					// ;
					case 59 + offset: if (ampersand == -1) characters = Utility_replace(characters, /\f/g, '')
						if (property > 0 && (Utility_strlen(characters) - length))
							Utility_append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(Utility_replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations)
						break
					// @ ;
					case 59: characters += ';'
					// { rule/at-rule
					default:
						Utility_append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets)

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children)
							else
								switch (atrule === 99 && Utility_charat(characters, 3) === 110 ? 100 : atrule) {
									// d l m s
									case 100: case 108: case 109: case 115:
										parse(value, reference, reference, rule && Utility_append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children)
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children)
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo
				break
			// :
			case 58:
				length = 1 + Utility_strlen(characters), property = previous
			default:
				if (variable < 1)
					if (character == 123)
						--variable
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += Utility_from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1)
						break
					// ,
					case 44:
						points[index++] = (Utility_strlen(characters) - 1) * ampersand, ampersand = 1
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next())

						atrule = peek(), offset = length = Utility_strlen(type = characters += identifier(caret())), character++
						break
					// -
					case 45:
						if (previous === 45 && Utility_strlen(characters) == 2)
							variable = 0
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1
	var rule = offset === 0 ? rules : ['']
	var size = Utility_sizeof(rule)

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = Utility_substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : Utility_replace(y, /&\f/g, rule[x])))
				props[k++] = z

	return node(value, root, parent, offset === 0 ? Enum_RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, Utility_from(Tokenizer_char()), Utility_substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, Enum_DECLARATION, Utility_substr(value, 0, length), Utility_substr(value, length + 1, -1), length)
}

;// CONCATENATED MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js





var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += Utility_from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule' || cache.compat) return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses) {
      var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
      //
      // considering this input:
      // .a {
      //   .b /* comm */ {}
      //   color: hotpink;
      // }
      // we get output corresponding to this:
      // .a {
      //   & {
      //     /* comm */
      //     color: hotpink;
      //   }
      //   .b {}
      // }

      var commentContainer = isNested ? element.parent.children : // global rule at the root level
      children;

      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node = commentContainer[i];

        if (node.line < element.line) {
          break;
        } // it is quite weird but comments are *usually* put at `column: element.column - 1`
        // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
        // this will also match inputs like this:
        // .a {
        //   /* comm */
        //   .b {}
        // }
        //
        // but that is fine
        //
        // it would be the easiest to change the placement of the comment to be the first child of the rule:
        // .a {
        //   .b { /* comm */ }
        // }
        // with such inputs we wouldn't have to search for the comment at all
        // TODO: consider changing this comment placement in the next major version


        if (node.column < element.column) {
          if (isIgnoringComment(node)) {
            return;
          }

          break;
        }
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

/* eslint-disable no-fallthrough */

function emotion_cache_browser_esm_prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return Enum_WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Enum_WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Enum_WEBKIT + value + Enum_MOZ + value + Enum_MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return Enum_WEBKIT + value + Enum_MS + value + value;
    // order

    case 6165:
      return Enum_WEBKIT + value + Enum_MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return Enum_WEBKIT + value + Utility_replace(value, /(\w+).+(:[^]+)/, Enum_WEBKIT + 'box-$1$2' + Enum_MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return Enum_WEBKIT + value + Enum_MS + 'flex-item-' + Utility_replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return Enum_WEBKIT + value + Enum_MS + 'flex-line-pack' + Utility_replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return Enum_WEBKIT + 'box-' + Utility_replace(value, '-grow', '') + Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return Enum_WEBKIT + Utility_replace(value, /([^-])(transform)/g, '$1' + Enum_WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return Utility_replace(Utility_replace(Utility_replace(value, /(zoom-|grab)/, Enum_WEBKIT + '$1'), /(image-set)/, Enum_WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return Utility_replace(value, /(image-set\([^]*)/, Enum_WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return Utility_replace(Utility_replace(value, /(.+:)(flex-)?(.*)/, Enum_WEBKIT + 'box-pack:$3' + Enum_MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + Enum_WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Utility_replace(value, /(.+)-inline(.+)/, Enum_WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (Utility_strlen(value) - 1 - length > 6) switch (Utility_charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (Utility_charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return Utility_replace(value, /(.+:)(.+)-([^]+)/, '$1' + Enum_WEBKIT + '$2-$3' + '$1' + Enum_MOZ + (Utility_charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? emotion_cache_browser_esm_prefix(Utility_replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (Utility_charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (Utility_charat(value, Utility_strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return Utility_replace(value, ':', ':' + Enum_WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return Utility_replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + Enum_WEBKIT + (Utility_charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + Enum_WEBKIT + '$2$3' + '$1' + Enum_MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (Utility_charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return Enum_WEBKIT + value + Enum_MS + value + value;
  }

  return value;
}

var emotion_cache_browser_esm_prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case Enum_DECLARATION:
      element["return"] = emotion_cache_browser_esm_prefix(element.value, element.length);
      break;

    case Enum_KEYFRAMES:
      return Serializer_serialize([Tokenizer_copy(element, {
        value: Utility_replace(element.value, '@', '@' + Enum_WEBKIT)
      })], callback);

    case Enum_RULESET:
      if (element.length) return Utility_combine(element.props, function (value) {
        switch (Utility_match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(read-\w+)/, ':' + Enum_MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_WEBKIT + 'input-$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_MOZ + '$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, Enum_MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var defaultStylisPlugins = [emotion_cache_browser_esm_prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (false) {}

  if (key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (false) {}

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (false) {}

  {
    var currentSheet;
    var finalizingPlugins = [stringify,  false ? 0 : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return Serializer_serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (false) {}

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};




/***/ }),

/***/ 71068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isPropValid; }
/* harmony export */ });
/* harmony import */ var _emotion_memoize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45042);


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */(0,_emotion_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);




/***/ }),

/***/ 45042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ memoize; }
/* harmony export */ });
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}




/***/ }),

/***/ 75260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ ThemeContext; },
/* harmony export */   "i": function() { return /* binding */ isBrowser; },
/* harmony export */   "w": function() { return /* binding */ withEmotionCache; }
/* harmony export */ });
/* unused harmony exports C, E, _, a, b, c, h, u */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28996);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35394);
/* harmony import */ var _emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27278);










var isBrowser = "object" !== 'undefined';
var hasOwnProperty = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */react__WEBPACK_IMPORTED_MODULE_0__.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */(0,_emotion_cache__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
  key: 'css'
}) : null);

if (false) {}

var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
  return useContext(EmotionCacheContext);
};

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (props, ref) {
    // the cache will never be null in the browser
    var cache = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

if (!isBrowser) {
  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      var cache = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(EmotionCacheContext);

      if (cache === null) {
        // yes, we're potentially creating this on every render
        // it doesn't actually matter though since it's only on the server
        // so there will only every be a single render
        // that could change in the future because of suspense and etc. but for now,
        // this works and i don't want to optimise for a future thing that we aren't sure about
        cache = (0,_emotion_cache__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
          key: 'css'
        });
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(EmotionCacheContext.Provider, {
          value: cache
        }, func(props, cache));
      } else {
        return func(props, cache);
      }
    };
  };
}

var ThemeContext = /* #__PURE__ */react__WEBPACK_IMPORTED_MODULE_0__.createContext({});

if (false) {}

var useTheme = function useTheme() {
  return React.useContext(ThemeContext);
};

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    if (false) {}

    return mergedTheme;
  }

  if (false) {}

  return _extends({}, outerTheme, theme);
};

var createCacheWithTheme = /* #__PURE__ */(/* unused pure expression or super */ null && (weakMemoize(function (outerTheme) {
  return weakMemoize(function (theme) {
    return getTheme(outerTheme, theme);
  });
})));
var ThemeProvider = function ThemeProvider(props) {
  var theme = React.useContext(ThemeContext);

  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }

  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: theme
  }, props.children);
};
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';

  var render = function render(props, ref) {
    var theme = React.useContext(ThemeContext);
    return /*#__PURE__*/React.createElement(Component, _extends({
      theme: theme,
      ref: ref
    }, props));
  }; // $FlowFixMe


  var WithTheme = /*#__PURE__*/React.forwardRef(render);
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return hoistNonReactStatics(WithTheme, Component);
}

var getLastPart = function getLastPart(functionName) {
  // The match may be something like 'Object.createEmotionProps' or
  // 'Loader.prototype.render'
  var parts = functionName.split('.');
  return parts[parts.length - 1];
};

var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
  // V8
  var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
  if (match) return getLastPart(match[1]); // Safari / Firefox

  match = /^([A-Za-z0-9$.]+)@/.exec(line);
  if (match) return getLastPart(match[1]);
  return undefined;
};

var internalReactFunctionNames = /* #__PURE__ */new Set(['renderWithHooks', 'processChild', 'finishClassComponent', 'renderToString']); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
  if (!stackTrace) return undefined;
  var lines = stackTrace.split('\n');

  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"

    if (!functionName) continue; // If we reach one of these, we have gone too far and should quit

    if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
    // uppercase letter

    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }

  return undefined;
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {}

  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
  // the label hasn't already been computed

  if (false) { var label; }

  return newProps;
};

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  useInsertionEffectAlwaysWithSyncFallback(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  return null;
};

var Emotion = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles, undefined, React.useContext(ThemeContext));

  if (false) { var labelFromStack; }

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ( true || 0)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Insertion, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/React.createElement(WrappedComponent, newProps));
})));

if (false) {}

var Emotion$1 = (/* unused pure expression or super */ null && (Emotion));




/***/ }),

/***/ 98012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xB": function() { return /* binding */ Global; },
  "iv": function() { return /* binding */ css; },
  "F4": function() { return /* binding */ keyframes; }
});

// UNUSED EXPORTS: CacheProvider, ClassNames, ThemeContext, ThemeProvider, __unsafe_useEmotionCache, createElement, jsx, useTheme, withEmotionCache, withTheme

// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js
var emotion_element_c39617d8_browser_esm = __webpack_require__(75260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@emotion/react/node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var isBrowser = "object" !== 'undefined';
function emotion_utils_browser_esm_getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var emotion_utils_browser_esm_registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var emotion_utils_browser_esm_insertStyles = function insertStyles(cache, serialized, isStringTag) {
  emotion_utils_browser_esm_registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};



// EXTERNAL MODULE: ./node_modules/@emotion/use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.browser.esm.js
var emotion_use_insertion_effect_with_fallbacks_browser_esm = __webpack_require__(27278);
// EXTERNAL MODULE: ./node_modules/@emotion/react/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js + 2 modules
var emotion_serialize_browser_esm = __webpack_require__(35394);
// EXTERNAL MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js + 7 modules
var emotion_cache_browser_esm = __webpack_require__(28996);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
;// CONCATENATED MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js












var pkg = {
	name: "@emotion/react",
	version: "11.11.1",
	main: "dist/emotion-react.cjs.js",
	module: "dist/emotion-react.esm.js",
	browser: {
		"./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
	},
	exports: {
		".": {
			module: {
				worker: "./dist/emotion-react.worker.esm.js",
				browser: "./dist/emotion-react.browser.esm.js",
				"default": "./dist/emotion-react.esm.js"
			},
			"import": "./dist/emotion-react.cjs.mjs",
			"default": "./dist/emotion-react.cjs.js"
		},
		"./jsx-runtime": {
			module: {
				worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
				browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
				"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
			},
			"import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
			"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
		},
		"./_isolated-hnrs": {
			module: {
				worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
				browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
				"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
			},
			"import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
			"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
		},
		"./jsx-dev-runtime": {
			module: {
				worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
				browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
				"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
			},
			"import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
			"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
		},
		"./package.json": "./package.json",
		"./types/css-prop": "./types/css-prop.d.ts",
		"./macro": {
			types: {
				"import": "./macro.d.mts",
				"default": "./macro.d.ts"
			},
			"default": "./macro.js"
		}
	},
	types: "types/index.d.ts",
	files: [
		"src",
		"dist",
		"jsx-runtime",
		"jsx-dev-runtime",
		"_isolated-hnrs",
		"types/*.d.ts",
		"macro.*"
	],
	sideEffects: false,
	author: "Emotion Contributors",
	license: "MIT",
	scripts: {
		"test:typescript": "dtslint types"
	},
	dependencies: {
		"@babel/runtime": "^7.18.3",
		"@emotion/babel-plugin": "^11.11.0",
		"@emotion/cache": "^11.11.0",
		"@emotion/serialize": "^1.1.2",
		"@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
		"@emotion/utils": "^1.2.1",
		"@emotion/weak-memoize": "^0.3.1",
		"hoist-non-react-statics": "^3.3.1"
	},
	peerDependencies: {
		react: ">=16.8.0"
	},
	peerDependenciesMeta: {
		"@types/react": {
			optional: true
		}
	},
	devDependencies: {
		"@definitelytyped/dtslint": "0.0.112",
		"@emotion/css": "11.11.0",
		"@emotion/css-prettifier": "1.1.3",
		"@emotion/server": "11.11.0",
		"@emotion/styled": "11.11.0",
		"html-tag-names": "^1.1.2",
		react: "16.14.0",
		"svg-tag-names": "^1.1.1",
		typescript: "^4.5.5"
	},
	repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
	publishConfig: {
		access: "public"
	},
	"umd:main": "dist/emotion-react.umd.min.js",
	preconstruct: {
		entrypoints: [
			"./index.js",
			"./jsx-runtime.js",
			"./jsx-dev-runtime.js",
			"./_isolated-hnrs.js"
		],
		umdName: "emotionReact",
		exports: {
			envConditions: [
				"browser",
				"worker"
			],
			extra: {
				"./types/css-prop": "./types/css-prop.d.ts",
				"./macro": {
					types: {
						"import": "./macro.d.mts",
						"default": "./macro.d.ts"
					},
					"default": "./macro.js"
				}
			}
		}
	}
};

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !hasOwnProperty.call(props, 'css')) {
    // $FlowFixMe
    return React.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return React.createElement.apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */(0,emotion_element_c39617d8_browser_esm.w)(function (props, cache) {
  if (false) {}

  var styles = props.styles;
  var serialized = (0,emotion_serialize_browser_esm/* serializeStyles */.O)([styles], undefined, react.useContext(emotion_element_c39617d8_browser_esm.T));

  if (!emotion_element_c39617d8_browser_esm.i) {
    var _ref;

    var serializedNames = serialized.name;
    var serializedStyles = serialized.styles;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      serializedStyles += next.styles;
      next = next.next;
    }

    var shouldCache = cache.compat === true;
    var rules = cache.insert("", {
      name: serializedNames,
      styles: serializedStyles
    }, cache.sheet, shouldCache);

    if (shouldCache) {
      return null;
    }

    return /*#__PURE__*/react.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref));
  } // yes, i know these hooks are used conditionally
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = react.useRef();
  (0,emotion_use_insertion_effect_with_fallbacks_browser_esm/* useInsertionEffectWithLayoutFallback */.j)(function () {
    var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

    var sheet = new cache.sheet.constructor({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  (0,emotion_use_insertion_effect_with_fallbacks_browser_esm/* useInsertionEffectWithLayoutFallback */.j)(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      emotion_utils_browser_esm_insertStyles(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});

if (false) {}

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (0,emotion_serialize_browser_esm/* serializeStyles */.O)(args);
}

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (false) {}

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serializedArr = _ref.serializedArr;
  useInsertionEffectAlwaysWithSyncFallback(function () {

    for (var i = 0; i < serializedArr.length; i++) {
      insertStyles(cache, serializedArr[i], false);
    }
  });

  return null;
};

var ClassNames = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];

  var css = function css() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge(cache.registered, css, classnames(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: React.useContext(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Insertion, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
})));

if (false) {}

if (false) { var globalKey, globalContext, isTestEnv, emotion_react_browser_esm_isBrowser; }




/***/ }),

/***/ 35394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ serializeStyles; }
});

;// CONCATENATED MODULE: ./node_modules/@emotion/react/node_modules/@emotion/hash/dist/emotion-hash.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}



;// CONCATENATED MODULE: ./node_modules/@emotion/react/node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};



// EXTERNAL MODULE: ./node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
var emotion_memoize_esm = __webpack_require__(45042);
;// CONCATENATED MODULE: ./node_modules/@emotion/react/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */(0,emotion_memoize_esm/* default */.Z)(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

var noComponentSelectorMessage = (/* unused pure expression or super */ null && ('Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.'));

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),

/***/ 27278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useInsertionEffectAlwaysWithSyncFallback; },
/* harmony export */   "j": function() { return /* binding */ useInsertionEffectWithLayoutFallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] ? /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;




/***/ }),

/***/ 38862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Composite": function() { return /* binding */ Composite; },
  "CompositeItem": function() { return /* binding */ CompositeItem; },
  "FloatingArrow": function() { return /* binding */ FloatingArrow; },
  "FloatingDelayGroup": function() { return /* binding */ FloatingDelayGroup; },
  "FloatingFocusManager": function() { return /* binding */ FloatingFocusManager; },
  "FloatingList": function() { return /* binding */ FloatingList; },
  "FloatingNode": function() { return /* binding */ FloatingNode; },
  "FloatingOverlay": function() { return /* binding */ FloatingOverlay; },
  "FloatingPortal": function() { return /* binding */ FloatingPortal; },
  "FloatingTree": function() { return /* binding */ FloatingTree; },
  "arrow": function() { return /* reexport */ floating_ui_react_dom_arrow; },
  "autoPlacement": function() { return /* reexport */ floating_ui_dom_autoPlacement; },
  "autoUpdate": function() { return /* reexport */ autoUpdate; },
  "computePosition": function() { return /* reexport */ floating_ui_dom_computePosition; },
  "detectOverflow": function() { return /* reexport */ detectOverflow; },
  "flip": function() { return /* reexport */ floating_ui_dom_flip; },
  "getOverflowAncestors": function() { return /* reexport */ getOverflowAncestors; },
  "hide": function() { return /* reexport */ floating_ui_dom_hide; },
  "inline": function() { return /* reexport */ floating_ui_dom_inline; },
  "inner": function() { return /* binding */ inner; },
  "limitShift": function() { return /* reexport */ floating_ui_dom_limitShift; },
  "offset": function() { return /* reexport */ offset; },
  "platform": function() { return /* reexport */ platform; },
  "safePolygon": function() { return /* binding */ safePolygon; },
  "shift": function() { return /* reexport */ floating_ui_dom_shift; },
  "size": function() { return /* reexport */ floating_ui_dom_size; },
  "useClick": function() { return /* binding */ useClick; },
  "useClientPoint": function() { return /* binding */ useClientPoint; },
  "useDelayGroup": function() { return /* binding */ useDelayGroup; },
  "useDelayGroupContext": function() { return /* binding */ useDelayGroupContext; },
  "useDismiss": function() { return /* binding */ useDismiss; },
  "useFloating": function() { return /* binding */ floating_ui_react_esm_useFloating; },
  "useFloatingNodeId": function() { return /* binding */ useFloatingNodeId; },
  "useFloatingParentNodeId": function() { return /* binding */ useFloatingParentNodeId; },
  "useFloatingPortalNode": function() { return /* binding */ useFloatingPortalNode; },
  "useFloatingTree": function() { return /* binding */ useFloatingTree; },
  "useFocus": function() { return /* binding */ useFocus; },
  "useHover": function() { return /* binding */ useHover; },
  "useId": function() { return /* binding */ useId; },
  "useInnerOffset": function() { return /* binding */ useInnerOffset; },
  "useInteractions": function() { return /* binding */ useInteractions; },
  "useListItem": function() { return /* binding */ useListItem; },
  "useListNavigation": function() { return /* binding */ useListNavigation; },
  "useMergeRefs": function() { return /* binding */ useMergeRefs; },
  "useRole": function() { return /* binding */ useRole; },
  "useTransitionStatus": function() { return /* binding */ useTransitionStatus; },
  "useTransitionStyles": function() { return /* binding */ useTransitionStyles; },
  "useTypeahead": function() { return /* binding */ useTypeahead; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
;// CONCATENATED MODULE: ./node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || '').toLowerCase();
  }
  // Mocked nodes in testing environments may not be instances of Node. By
  // returning `#document` an infinite loop won't occur.
  // https://github.com/floating-ui/floating-ui/issues/2317
  return '#document';
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  // Browsers without `ShadowRoot` support.
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = floating_ui_utils_dom_getComputedStyle(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !['inline', 'contents'].includes(display);
}
function isTableElement(element) {
  return ['table', 'td', 'th'].includes(getNodeName(element));
}
function isContainingBlock(element) {
  const webkit = isWebKit();
  const css = floating_ui_utils_dom_getComputedStyle(element);

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || ['transform', 'perspective', 'filter'].some(value => (css.willChange || '').includes(value)) || ['paint', 'layout', 'strict', 'content'].some(value => (css.contain || '').includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else {
      currentNode = getParentNode(currentNode);
    }
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === 'undefined' || !CSS.supports) return false;
  return CSS.supports('-webkit-backdrop-filter', 'none');
}
function isLastTraversableNode(node) {
  return ['html', 'body', '#document'].includes(getNodeName(node));
}
function floating_ui_utils_dom_getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.pageXOffset,
    scrollTop: element.pageYOffset
  };
}
function getParentNode(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }
  const result =
  // Step into the shadow DOM of the parent of a slotted node.
  node.assignedSlot ||
  // DOM Element detected.
  node.parentNode ||
  // ShadowRoot detected.
  isShadowRoot(node) && node.host ||
  // Fallback.
  getDocumentElement(node);
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? getOverflowAncestors(win.frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}



;// CONCATENATED MODULE: ./node_modules/@floating-ui/react/dist/floating-ui.react.utils.mjs


function activeElement(doc) {
  let activeElement = doc.activeElement;
  while (((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null) {
    var _activeElement;
    activeElement = activeElement.shadowRoot.activeElement;
  }
  return activeElement;
}
function contains(parent, child) {
  if (!parent || !child) {
    return false;
  }
  const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();

  // First, attempt with faster native method
  if (parent.contains(child)) {
    return true;
  }

  // then fallback to custom implementation with Shadow DOM support
  if (rootNode && isShadowRoot(rootNode)) {
    let next = child;
    while (next) {
      if (parent === next) {
        return true;
      }
      // @ts-ignore
      next = next.parentNode || next.host;
    }
  }

  // Give up, the result is false
  return false;
}
// Avoid Chrome DevTools blue warning.
function getPlatform() {
  const uaData = navigator.userAgentData;
  if (uaData != null && uaData.platform) {
    return uaData.platform;
  }
  return navigator.platform;
}
function getUserAgent() {
  const uaData = navigator.userAgentData;
  if (uaData && Array.isArray(uaData.brands)) {
    return uaData.brands.map(_ref => {
      let {
        brand,
        version
      } = _ref;
      return brand + "/" + version;
    }).join(' ');
  }
  return navigator.userAgent;
}

// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function isVirtualClick(event) {
  // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
  // Try to find a workaround for this. `react-aria` source still has the check.
  if (event.mozInputSource === 0 && event.isTrusted) {
    return true;
  }
  if (isAndroid() && event.pointerType) {
    return event.type === 'click' && event.buttons === 1;
  }
  return event.detail === 0 && !event.pointerType;
}
function isVirtualPointerEvent(event) {
  if (isJSDOM()) return false;
  return !isAndroid() && event.width === 0 && event.height === 0 || isAndroid() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse' ||
  // iOS VoiceOver returns 0.333• for width/height.
  event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'touch';
}
function isSafari() {
  // Chrome DevTools does not complain about navigator.vendor
  return /apple/i.test(navigator.vendor);
}
function isAndroid() {
  const re = /android/i;
  return re.test(getPlatform()) || re.test(getUserAgent());
}
function isMac() {
  return getPlatform().toLowerCase().startsWith('mac') && !navigator.maxTouchPoints;
}
function isJSDOM() {
  return getUserAgent().includes('jsdom/');
}
function isMouseLikePointerType(pointerType, strict) {
  // On some Linux machines with Chromium, mouse inputs return a `pointerType`
  // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
  const values = ['mouse', 'pen'];
  if (!strict) {
    values.push('', undefined);
  }
  return values.includes(pointerType);
}
function isReactEvent(event) {
  return 'nativeEvent' in event;
}
function isRootElement(element) {
  return element.matches('html,body');
}
function getDocument(node) {
  return (node == null ? void 0 : node.ownerDocument) || document;
}
function isEventTargetWithin(event, node) {
  if (node == null) {
    return false;
  }
  if ('composedPath' in event) {
    return event.composedPath().includes(node);
  }

  // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
  const e = event;
  return e.target != null && node.contains(e.target);
}
function getTarget(event) {
  if ('composedPath' in event) {
    return event.composedPath()[0];
  }

  // TS thinks `event` is of type never as it assumes all browsers support
  // `composedPath()`, but browsers without shadow DOM don't.
  return event.target;
}
const TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled])," + "[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function isTypeableElement(element) {
  return isHTMLElement(element) && element.matches(TYPEABLE_SELECTOR);
}
function stopEvent(event) {
  event.preventDefault();
  event.stopPropagation();
}
function isTypeableCombobox(element) {
  if (!element) return false;
  return element.getAttribute('role') === 'combobox' && isTypeableElement(element);
}



;// CONCATENATED MODULE: ./node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */

const sides = ['top', 'right', 'bottom', 'left'];
const alignments = ['start', 'end'];
const placements = /*#__PURE__*/sides.reduce((acc, side) => acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), []);
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = v => ({
  x: v,
  y: v
});
const oppositeSideMap = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
const oppositeAlignmentMap = {
  start: 'end',
  end: 'start'
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
  return placement.split('-')[0];
}
function getAlignment(placement) {
  return placement.split('-')[1];
}
function getOppositeAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
  return axis === 'y' ? 'height' : 'width';
}
function getSideAxis(placement) {
  return ['top', 'bottom'].includes(getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, alignment => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ['left', 'right'];
  const rl = ['right', 'left'];
  const tb = ['top', 'bottom'];
  const bt = ['bottom', 'top'];
  switch (side) {
    case 'top':
    case 'bottom':
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case 'left':
    case 'right':
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === 'start', rtl);
  if (alignment) {
    list = list.map(side => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, side => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== 'number' ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  return {
    ...rect,
    top: rect.y,
    left: rect.x,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  };
}



;// CONCATENATED MODULE: ./node_modules/@floating-ui/core/dist/floating-ui.core.mjs



function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === 'y';
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case 'top':
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case 'bottom':
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case 'right':
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case 'left':
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case 'start':
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case 'end':
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */
const computePosition = async (reference, floating, config) => {
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
  let rects = await platform.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === 'object') {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = 'clippingAncestors',
    rootBoundary = 'viewport',
    elementContext = 'floating',
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === 'floating' ? 'reference' : 'floating';
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform.getClippingRect({
    element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || (await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating))),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === 'floating' ? {
    ...rects.floating,
    x,
    y
  } : rects.reference;
  const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
  const offsetScale = (await (platform.isElement == null ? void 0 : platform.isElement(offsetParent))) ? (await (platform.getScale == null ? void 0 : platform.getScale(offsetParent))) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = options => ({
  name: 'arrow',
  options,
  async fn(state) {
    const {
      x,
      y,
      placement,
      rects,
      platform,
      elements,
      middlewareData
    } = state;
    // Since `element` is required, we don't Partial<> the type.
    const {
      element,
      padding = 0
    } = evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x,
      y
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform.getDimensions(element);
    const isYAxis = axis === 'y';
    const minProp = isYAxis ? 'top' : 'left';
    const maxProp = isYAxis ? 'bottom' : 'right';
    const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;

    // DOM platform can return `window` as the `offsetParent`.
    if (!clientSize || !(await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;

    // If the padding is large enough that it causes the arrow to no longer be
    // centered, modify the padding so that it is centered.
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min(paddingObject[maxProp], largestPossiblePadding);

    // Make sure the arrow doesn't overflow the floating element if the center
    // point is outside the floating element's bounds.
    const min$1 = minPadding;
    const max = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset = clamp(min$1, center, max);

    // If the reference is small enough that the arrow's padding causes it to
    // to point to nothing for an aligned placement, adjust the offset of the
    // floating element itself. To ensure `shift()` continues to take action,
    // a single reset is performed when this is true.
    const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset,
        centerOffset: center - offset - alignmentOffset,
        ...(shouldAddOffset && {
          alignmentOffset
        })
      },
      reset: shouldAddOffset
    };
  }
});

function getPlacementList(alignment, autoAlignment, allowedPlacements) {
  const allowedPlacementsSortedByAlignment = alignment ? [...allowedPlacements.filter(placement => getAlignment(placement) === alignment), ...allowedPlacements.filter(placement => getAlignment(placement) !== alignment)] : allowedPlacements.filter(placement => getSide(placement) === placement);
  return allowedPlacementsSortedByAlignment.filter(placement => {
    if (alignment) {
      return getAlignment(placement) === alignment || (autoAlignment ? getOppositeAlignmentPlacement(placement) !== placement : false);
    }
    return true;
  });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const autoPlacement = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'autoPlacement',
    options,
    async fn(state) {
      var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
      const {
        rects,
        middlewareData,
        placement,
        platform,
        elements
      } = state;
      const {
        crossAxis = false,
        alignment,
        allowedPlacements = placements,
        autoAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      const placements$1 = alignment !== undefined || allowedPlacements === placements ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
      const currentPlacement = placements$1[currentIndex];
      if (currentPlacement == null) {
        return {};
      }
      const alignmentSides = getAlignmentSides(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));

      // Make `computeCoords` start from the right place.
      if (placement !== currentPlacement) {
        return {
          reset: {
            placement: placements$1[0]
          }
        };
      }
      const currentOverflows = [overflow[getSide(currentPlacement)], overflow[alignmentSides[0]], overflow[alignmentSides[1]]];
      const allOverflows = [...(((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || []), {
        placement: currentPlacement,
        overflows: currentOverflows
      }];
      const nextPlacement = placements$1[currentIndex + 1];

      // There are more placements to check.
      if (nextPlacement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: nextPlacement
          }
        };
      }
      const placementsSortedByMostSpace = allOverflows.map(d => {
        const alignment = getAlignment(d.placement);
        return [d.placement, alignment && crossAxis ?
        // Check along the mainAxis and main crossAxis side.
        d.overflows.slice(0, 2).reduce((acc, v) => acc + v, 0) :
        // Check only the mainAxis.
        d.overflows[0], d.overflows];
      }).sort((a, b) => a[1] - b[1]);
      const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter(d => d[2].slice(0,
      // Aligned placements should not check their opposite crossAxis
      // side.
      getAlignment(d[0]) ? 2 : 3).every(v => v <= 0));
      const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
      if (resetPlacement !== placement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: resetPlacement
          }
        };
      }
      return {};
    }
  };
};

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'flip',
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = 'bestFit',
        fallbackAxisSideDirection = 'none',
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);

      // If a reset by the arrow was caused due to an alignment offset being
      // added, we should skip any logic now since `flip()` has already done its
      // work.
      // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== 'none') {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];

      // One or more sides is overflowing.
      if (!overflows.every(side => side <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          // Try next placement and re-run the lifecycle.
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }

        // First, find the candidates that fit on the mainAxis side of overflow,
        // then find the placement that fits the best on the main crossAxis side.
        let resetPlacement = (_overflowsData$filter = overflowsData.filter(d => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;

        // Otherwise fallback.
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case 'bestFit':
              {
                var _overflowsData$map$so;
                const placement = (_overflowsData$map$so = overflowsData.map(d => [d.placement, d.overflows.filter(overflow => overflow > 0).reduce((acc, overflow) => acc + overflow, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                if (placement) {
                  resetPlacement = placement;
                }
                break;
              }
            case 'initialPlacement':
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};

function getSideOffsets(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}
function isAnySideFullyClipped(overflow) {
  return sides.some(side => overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const hide = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'hide',
    options,
    async fn(state) {
      const {
        rects
      } = state;
      const {
        strategy = 'referenceHidden',
        ...detectOverflowOptions
      } = evaluate(options, state);
      switch (strategy) {
        case 'referenceHidden':
          {
            const overflow = await detectOverflow(state, {
              ...detectOverflowOptions,
              elementContext: 'reference'
            });
            const offsets = getSideOffsets(overflow, rects.reference);
            return {
              data: {
                referenceHiddenOffsets: offsets,
                referenceHidden: isAnySideFullyClipped(offsets)
              }
            };
          }
        case 'escaped':
          {
            const overflow = await detectOverflow(state, {
              ...detectOverflowOptions,
              altBoundary: true
            });
            const offsets = getSideOffsets(overflow, rects.floating);
            return {
              data: {
                escapedOffsets: offsets,
                escaped: isAnySideFullyClipped(offsets)
              }
            };
          }
        default:
          {
            return {};
          }
      }
    }
  };
};

function getBoundingRect(rects) {
  const minX = min(...rects.map(rect => rect.left));
  const minY = min(...rects.map(rect => rect.top));
  const maxX = max(...rects.map(rect => rect.right));
  const maxY = max(...rects.map(rect => rect.bottom));
  return {
    x: minX,
    y: minY,
    width: maxX - minX,
    height: maxY - minY
  };
}
function getRectsByLine(rects) {
  const sortedRects = rects.slice().sort((a, b) => a.y - b.y);
  const groups = [];
  let prevRect = null;
  for (let i = 0; i < sortedRects.length; i++) {
    const rect = sortedRects[i];
    if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) {
      groups.push([rect]);
    } else {
      groups[groups.length - 1].push(rect);
    }
    prevRect = rect;
  }
  return groups.map(rect => rectToClientRect(getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
const inline = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'inline',
    options,
    async fn(state) {
      const {
        placement,
        elements,
        rects,
        platform,
        strategy
      } = state;
      // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
      // ClientRect's bounds, despite the event listener being triggered. A
      // padding of 2 seems to handle this issue.
      const {
        padding = 2,
        x,
        y
      } = evaluate(options, state);
      const nativeClientRects = Array.from((await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference))) || []);
      const clientRects = getRectsByLine(nativeClientRects);
      const fallback = rectToClientRect(getBoundingRect(nativeClientRects));
      const paddingObject = getPaddingObject(padding);
      function getBoundingClientRect() {
        // There are two rects and they are disjoined.
        if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) {
          // Find the first rect in which the point is fully inside.
          return clientRects.find(rect => x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
        }

        // There are 2 or more connected rects.
        if (clientRects.length >= 2) {
          if (getSideAxis(placement) === 'y') {
            const firstRect = clientRects[0];
            const lastRect = clientRects[clientRects.length - 1];
            const isTop = getSide(placement) === 'top';
            const top = firstRect.top;
            const bottom = lastRect.bottom;
            const left = isTop ? firstRect.left : lastRect.left;
            const right = isTop ? firstRect.right : lastRect.right;
            const width = right - left;
            const height = bottom - top;
            return {
              top,
              bottom,
              left,
              right,
              width,
              height,
              x: left,
              y: top
            };
          }
          const isLeftSide = getSide(placement) === 'left';
          const maxRight = max(...clientRects.map(rect => rect.right));
          const minLeft = min(...clientRects.map(rect => rect.left));
          const measureRects = clientRects.filter(rect => isLeftSide ? rect.left === minLeft : rect.right === maxRight);
          const top = measureRects[0].top;
          const bottom = measureRects[measureRects.length - 1].bottom;
          const left = minLeft;
          const right = maxRight;
          const width = right - left;
          const height = bottom - top;
          return {
            top,
            bottom,
            left,
            right,
            width,
            height,
            x: left,
            y: top
          };
        }
        return fallback;
      }
      const resetRects = await platform.getElementRects({
        reference: {
          getBoundingClientRect
        },
        floating: elements.floating,
        strategy
      });
      if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) {
        return {
          reset: {
            rects: resetRects
          }
        };
      }
      return {};
    }
  };
};

// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.

async function convertValueToCoords(state, options) {
  const {
    placement,
    platform,
    elements
  } = state;
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === 'y';
  const mainAxisMulti = ['left', 'top'].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === 'number' ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...rawValue
  };
  if (alignment && typeof alignmentAxis === 'number') {
    crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset = function (options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: 'offset',
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x,
        y,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);

      // If the placement is the same and the arrow caused an alignment offset
      // then we don't need to change the positioning coordinates.
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'shift',
    options,
    async fn(state) {
      const {
        x,
        y,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: _ref => {
            let {
              x,
              y
            } = _ref;
            return {
              x,
              y
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === 'y' ? 'top' : 'left';
        const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
        const min = mainAxisCoord + overflow[minSide];
        const max = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min, mainAxisCoord, max);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === 'y' ? 'top' : 'left';
        const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
        const min = crossAxisCoord + overflow[minSide];
        const max = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min, crossAxisCoord, max);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y
        }
      };
    }
  };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const limitShift = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    options,
    fn(state) {
      const {
        x,
        y,
        placement,
        rects,
        middlewareData
      } = state;
      const {
        offset = 0,
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const crossAxis = getSideAxis(placement);
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const rawOffset = evaluate(offset, state);
      const computedOffset = typeof rawOffset === 'number' ? {
        mainAxis: rawOffset,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...rawOffset
      };
      if (checkMainAxis) {
        const len = mainAxis === 'y' ? 'height' : 'width';
        const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
        const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
        if (mainAxisCoord < limitMin) {
          mainAxisCoord = limitMin;
        } else if (mainAxisCoord > limitMax) {
          mainAxisCoord = limitMax;
        }
      }
      if (checkCrossAxis) {
        var _middlewareData$offse, _middlewareData$offse2;
        const len = mainAxis === 'y' ? 'width' : 'height';
        const isOriginSide = ['top', 'left'].includes(getSide(placement));
        const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
        const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
        if (crossAxisCoord < limitMin) {
          crossAxisCoord = limitMin;
        } else if (crossAxisCoord > limitMax) {
          crossAxisCoord = limitMax;
        }
      }
      return {
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      };
    }
  };
};

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const size = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'size',
    options,
    async fn(state) {
      const {
        placement,
        rects,
        platform,
        elements
      } = state;
      const {
        apply = () => {},
        ...detectOverflowOptions
      } = evaluate(options, state);
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const side = getSide(placement);
      const alignment = getAlignment(placement);
      const isYAxis = getSideAxis(placement) === 'y';
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === 'top' || side === 'bottom') {
        heightSide = side;
        widthSide = alignment === ((await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating))) ? 'start' : 'end') ? 'left' : 'right';
      } else {
        widthSide = side;
        heightSide = alignment === 'end' ? 'top' : 'bottom';
      }
      const overflowAvailableHeight = height - overflow[heightSide];
      const overflowAvailableWidth = width - overflow[widthSide];
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if (isYAxis) {
        const maximumClippingWidth = width - overflow.left - overflow.right;
        availableWidth = alignment || noShift ? min(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
      } else {
        const maximumClippingHeight = height - overflow.top - overflow.bottom;
        availableHeight = alignment || noShift ? min(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = max(overflow.left, 0);
        const xMax = max(overflow.right, 0);
        const yMin = max(overflow.top, 0);
        const yMax = max(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max(overflow.left, overflow.right));
        } else {
          availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max(overflow.top, overflow.bottom));
        }
      }
      await apply({
        ...state,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};



;// CONCATENATED MODULE: ./node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs






function getCssDimensions(element) {
  const css = floating_ui_utils_dom_getComputedStyle(element);
  // In testing environments, the `width` and `height` properties are empty
  // strings for SVG elements, returning NaN. Fallback to `0` in this case.
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}

function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}

function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;

  // 0, NaN, or Infinity should always fallback to 1.

  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}

const noOffsets = /*#__PURE__*/createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}

function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = currentWin.frameElement;
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = floating_ui_utils_dom_getComputedStyle(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = currentWin.frameElement;
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}

const topLayerSelectors = [':popover-open', ':modal'];
function isTopLayer(floating) {
  return topLayerSelectors.some(selector => {
    try {
      return floating.matches(selector);
    } catch (e) {
      return false;
    }
  });
}

function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === 'fixed';
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
  };
}

function getClientRects(element) {
  return Array.from(element.getClientRects());
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  return getBoundingClientRect(getDocumentElement(element)).left + getNodeScroll(element).scrollLeft;
}

// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (floating_ui_utils_dom_getComputedStyle(body).direction === 'rtl') {
    x += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}

function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}

// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === 'viewport') {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === 'document') {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      ...clippingAncestor,
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return floating_ui_utils_dom_getComputedStyle(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}

// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter(el => isElement(el) && getNodeName(el) !== 'body');
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = floating_ui_utils_dom_getComputedStyle(element).position === 'fixed';
  let currentNode = elementIsFixed ? getParentNode(element) : element;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = floating_ui_utils_dom_getComputedStyle(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === 'fixed') {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && ['absolute', 'fixed'].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      // Drop non-containing blocks.
      result = result.filter(ancestor => ancestor !== currentNode);
    } else {
      // Record last containing block for next iteration.
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}

// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === 'clippingAncestors' ? getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}

function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}

function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === 'fixed';
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  const x = rect.left + scroll.scrollLeft - offsets.x;
  const y = rect.top + scroll.scrollTop - offsets.y;
  return {
    x,
    y,
    width: rect.width,
    height: rect.height
  };
}

function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || floating_ui_utils_dom_getComputedStyle(element).position === 'fixed') {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  return element.offsetParent;
}

// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
  const window = getWindow(element);
  if (!isHTMLElement(element) || isTopLayer(element)) {
    return window;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && floating_ui_utils_dom_getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && floating_ui_utils_dom_getComputedStyle(offsetParent).position === 'static' && !isContainingBlock(offsetParent))) {
    return window;
  }
  return offsetParent || getContainingBlock(element) || window;
}

const getElementRects = async function (data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      ...(await getDimensionsFn(data.floating))
    }
  };
};

function isRTL(element) {
  return floating_ui_utils_dom_getComputedStyle(element).direction === 'rtl';
}

const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement: getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement: isElement,
  isRTL
};

// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const {
      left,
      top,
      width,
      height
    } = element.getBoundingClientRect();
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 100);
        } else {
          refresh(false, ratio);
        }
      }
      isFirstUpdate = false;
    }

    // Older browsers don't support a `document` as the root and will throw an
    // error.
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}

/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === 'function',
    layoutShift = typeof IntersectionObserver === 'function',
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...(referenceEl ? getOverflowAncestors(referenceEl) : []), ...getOverflowAncestors(floating)] : [];
  ancestors.forEach(ancestor => {
    ancestorScroll && ancestor.addEventListener('scroll', update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener('resize', update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver(_ref => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        // Prevent update loops when using the `size` middleware.
        // https://github.com/floating-ui/floating-ui/issues/1740
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach(ancestor => {
      ancestorScroll && ancestor.removeEventListener('scroll', update);
      ancestorResize && ancestor.removeEventListener('resize', update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}

/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const floating_ui_dom_autoPlacement = autoPlacement;

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const floating_ui_dom_shift = shift;

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const floating_ui_dom_flip = flip;

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const floating_ui_dom_size = size;

/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const floating_ui_dom_hide = hide;

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const floating_ui_dom_arrow = arrow;

/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
const floating_ui_dom_inline = inline;

/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const floating_ui_dom_limitShift = limitShift;

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */
const floating_ui_dom_computePosition = (reference, floating, options) => {
  // This caches the expensive `getClippingElementAncestors` function so that
  // multiple lifecycle resets re-use the same result. It only lives for a
  // single call. If other functions become expensive, we can add them as well.
  const cache = new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};



// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.mjs






/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */
const floating_ui_react_dom_arrow = options => {
  function isRef(value) {
    return {}.hasOwnProperty.call(value, 'current');
  }
  return {
    name: 'arrow',
    options,
    fn(state) {
      const {
        element,
        padding
      } = typeof options === 'function' ? options(state) : options;
      if (element && isRef(element)) {
        if (element.current != null) {
          return floating_ui_dom_arrow({
            element: element.current,
            padding
          }).fn(state);
        }
        return {};
      }
      if (element) {
        return floating_ui_dom_arrow({
          element,
          padding
        }).fn(state);
      }
      return {};
    }
  };
};

var index = typeof document !== 'undefined' ? react.useLayoutEffect : react.useEffect;

// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (typeof a === 'function' && a.toString() === b.toString()) {
    return true;
  }
  let length;
  let i;
  let keys;
  if (a && b && typeof a === 'object') {
    if (Array.isArray(a)) {
      length = a.length;
      if (length !== b.length) return false;
      for (i = length; i-- !== 0;) {
        if (!deepEqual(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (i = length; i-- !== 0;) {
      if (!{}.hasOwnProperty.call(b, keys[i])) {
        return false;
      }
    }
    for (i = length; i-- !== 0;) {
      const key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        continue;
      }
      if (!deepEqual(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }

  // biome-ignore lint/suspicious/noSelfCompare: in source
  return a !== a && b !== b;
}

function getDPR(element) {
  if (typeof window === 'undefined') {
    return 1;
  }
  const win = element.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}

function roundByDPR(element, value) {
  const dpr = getDPR(element);
  return Math.round(value * dpr) / dpr;
}

function useLatestRef(value) {
  const ref = react.useRef(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}

/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open
  } = options;
  const [data, setData] = react.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = react.useState(middleware);
  if (!deepEqual(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const [_reference, _setReference] = react.useState(null);
  const [_floating, _setFloating] = react.useState(null);
  const setReference = react.useCallback(node => {
    if (node !== referenceRef.current) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, []);
  const setFloating = react.useCallback(node => {
    if (node !== floatingRef.current) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, []);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = react.useRef(null);
  const floatingRef = react.useRef(null);
  const dataRef = react.useRef(data);
  const hasWhileElementsMounted = whileElementsMounted != null;
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const platformRef = useLatestRef(platform);
  const update = react.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config.platform = platformRef.current;
    }
    floating_ui_dom_computePosition(referenceRef.current, floatingRef.current, config).then(data => {
      const fullData = {
        ...data,
        isPositioned: true
      };
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        react_dom.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef]);
  index(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData(data => ({
        ...data,
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = react.useRef(false);
  index(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: `hasWhileElementsMounted` is intentionally included.
  index(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      }
      update();
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef, hasWhileElementsMounted]);
  const refs = react.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = react.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = react.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x = roundByDPR(elements.floating, data.x);
    const y = roundByDPR(elements.floating, data.y);
    if (transform) {
      return {
        ...initialStyles,
        transform: "translate(" + x + "px, " + y + "px)",
        ...(getDPR(elements.floating) >= 1.5 && {
          willChange: 'transform'
        })
      };
    }
    return {
      position: strategy,
      left: x,
      top: y
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return react.useMemo(() => ({
    ...data,
    update,
    refs,
    elements,
    floatingStyles
  }), [data, update, refs, elements, floatingStyles]);
}



;// CONCATENATED MODULE: ./node_modules/tabbable/dist/index.esm.js
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
// NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var candidateSelectors = ['input:not([inert])', 'select:not([inert])', 'textarea:not([inert])', 'a[href]:not([inert])', 'button:not([inert])', '[tabindex]:not(slot):not([inert])', 'audio[controls]:not([inert])', 'video[controls]:not([inert])', '[contenteditable]:not([contenteditable="false"]):not([inert])', 'details>summary:first-of-type:not([inert])', 'details:not([inert])'];
var candidateSelector = /* #__PURE__ */candidateSelectors.join(',');
var NoElement = typeof Element === 'undefined';
var matches = NoElement ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function (element) {
  var _element$getRootNode;
  return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function (element) {
  return element === null || element === void 0 ? void 0 : element.ownerDocument;
};

/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */
var isInert = function isInert(node, lookUp) {
  var _node$getAttribute;
  if (lookUp === void 0) {
    lookUp = true;
  }
  // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
  //  JS API property; we have to check the attribute, which can either be empty or 'true';
  //  if it's `null` (not specified) or 'false', it's an active element
  var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
  var inert = inertAtt === '' || inertAtt === 'true';

  // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
  //  if it weren't for `matches()` not being a function on shadow roots; the following
  //  code works for any kind of node
  // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
  //  so it likely would not support `:is([inert] *)` either...
  var result = inert || lookUp && node && isInert(node.parentNode); // recursive

  return result;
};

/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */
var isContentEditable = function isContentEditable(node) {
  var _node$getAttribute2;
  // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
  //  to use the attribute directly to check for this, which can either be empty or 'true';
  //  if it's `null` (not specified) or 'false', it's a non-editable element
  var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
  return attValue === '' || attValue === 'true';
};

/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */
var getCandidates = function getCandidates(el, includeContainer, filter) {
  // even if `includeContainer=false`, we still have to check it for inertness because
  //  if it's inert, all its children are inert
  if (isInert(el)) {
    return [];
  }
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }
  candidates = candidates.filter(filter);
  return candidates;
};

/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */

/**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */

/**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */

/**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */

/**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */
var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);
  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();
    if (isInert(element, false)) {
      // no need to look up since we're drilling down
      // anything inside this container will also be inert
      continue;
    }
    if (element.tagName === 'SLOT') {
      // add shadow dom slot scope (slot itself cannot be focusable)
      var assigned = element.assignedElements();
      var content = assigned.length ? assigned : element.children;
      var nestedCandidates = getCandidatesIteratively(content, true, options);
      if (options.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scopeParent: element,
          candidates: nestedCandidates
        });
      }
    } else {
      // check candidate element
      var validCandidate = matches.call(element, candidateSelector);
      if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      }

      // iterate over shadow content if possible
      var shadowRoot = element.shadowRoot ||
      // check for an undisclosed shadow
      typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);

      // no inert look up because we're already drilling down and checking for inertness
      //  on the way down, so all containers to this root node should have already been
      //  vetted as non-inert
      var validShadowRoot = !isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
      if (shadowRoot && validShadowRoot) {
        // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
        //  shadow exists, so look at light dom children as fallback BUT create a scope for any
        //  child candidates found because they're likely slotted elements (elements that are
        //  children of the web component element (which has the shadow), in the light dom, but
        //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
        //  _after_ we return from this recursive call
        var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
        if (options.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scopeParent: element,
            candidates: _nestedCandidates
          });
        }
      } else {
        // there's not shadow so just dig into the element's (light dom) children
        //  __without__ giving the element special scope treatment
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }
  return candidates;
};

/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */
var hasTabIndex = function hasTabIndex(node) {
  return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};

/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */
var getTabIndex = function getTabIndex(node) {
  if (!node) {
    throw new Error('No node provided');
  }
  if (node.tabIndex < 0) {
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    // yet they are still part of the regular tab order; in FF, they get a default
    // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    // order, consider their tab index to be 0.
    // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || isContentEditable(node)) && !hasTabIndex(node)) {
      return 0;
    }
  }
  return node.tabIndex;
};

/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */
var getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
  var tabIndex = getTabIndex(node);
  if (tabIndex < 0 && isScope && !hasTabIndex(node)) {
    return 0;
  }
  return tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput(node) {
  return node.tagName === 'INPUT';
};
var isHiddenInput = function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
};
var isDetailsWithSummary = function isDetailsWithSummary(node) {
  var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
    return child.tagName === 'SUMMARY';
  });
  return r;
};
var getCheckedRadio = function getCheckedRadio(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};
var isTabbableRadio = function isTabbableRadio(node) {
  if (!node.name) {
    return true;
  }
  var radioScope = node.form || getRootNode(node);
  var queryRadios = function queryRadios(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };
  var radioSet;
  if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
      return false;
    }
  }
  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};
var isRadio = function isRadio(node) {
  return isInput(node) && node.type === 'radio';
};
var isNonTabbableRadio = function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
};

// determines if a node is ultimately attached to the window's document
var isNodeAttached = function isNodeAttached(node) {
  var _nodeRoot;
  // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
  //  (but NOT _the_ document; see second 'If' comment below for more).
  // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
  //  is attached, and the one we need to check if it's in the document or not (because the
  //  shadow, and all nodes it contains, is never considered in the document since shadows
  //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
  //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
  //  visibility, including all the nodes it contains). The host could be any normal node,
  //  or a custom element (i.e. web component). Either way, that's the one that is considered
  //  part of the document, not the shadow root, nor any of its children (i.e. the node being
  //  tested).
  // To further complicate things, we have to look all the way up until we find a shadow HOST
  //  that is attached (or find none) because the node might be in nested shadows...
  // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
  //  document (per the docs) and while it's a Document-type object, that document does not
  //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
  //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
  //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
  //  node is actually detached.
  // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
  //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
  //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
  //  `ownerDocument` will be `null`, hence the optional chaining on it.
  var nodeRoot = node && getRootNode(node);
  var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;

  // in some cases, a detached node will return itself as the root instead of a document or
  //  shadow root object, in which case, we shouldn't try to look further up the host chain
  var attached = false;
  if (nodeRoot && nodeRoot !== node) {
    var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
    attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
    while (!attached && nodeRootHost) {
      var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
      // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
      //  which means we need to get the host's host and check if that parent host is contained
      //  in (i.e. attached to) the document
      nodeRoot = getRootNode(nodeRootHost);
      nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
      attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
    }
  }
  return attached;
};
var isZeroArea = function isZeroArea(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
    width = _node$getBoundingClie.width,
    height = _node$getBoundingClie.height;
  return width === 0 && height === 0;
};
var isHidden = function isHidden(node, _ref) {
  var displayCheck = _ref.displayCheck,
    getShadowRoot = _ref.getShadowRoot;
  // NOTE: visibility will be `undefined` if node is detached from the document
  //  (see notes about this further down), which means we will consider it visible
  //  (this is legacy behavior from a very long way back)
  // NOTE: we check this regardless of `displayCheck="none"` because this is a
  //  _visibility_ check, not a _display_ check
  if (getComputedStyle(node).visibility === 'hidden') {
    return true;
  }
  var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
  if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
    return true;
  }
  if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
    if (typeof getShadowRoot === 'function') {
      // figure out if we should consider the node to be in an undisclosed shadow and use the
      //  'non-zero-area' fallback
      var originalNode = node;
      while (node) {
        var parentElement = node.parentElement;
        var rootNode = getRootNode(node);
        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
        ) {
          // node has an undisclosed shadow which means we can only treat it as a black box, so we
          //  fall back to a non-zero-area test
          return isZeroArea(node);
        } else if (node.assignedSlot) {
          // iterate up slot
          node = node.assignedSlot;
        } else if (!parentElement && rootNode !== node.ownerDocument) {
          // cross shadow boundary
          node = rootNode.host;
        } else {
          // iterate up normal dom
          node = parentElement;
        }
      }
      node = originalNode;
    }
    // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
    //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
    //  it might be a falsy value, which means shadow DOM support is disabled

    // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
    //  now we can just test to see if it would normally be visible or not, provided it's
    //  attached to the main document.
    // NOTE: We must consider case where node is inside a shadow DOM and given directly to
    //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.

    if (isNodeAttached(node)) {
      // this works wherever the node is: if there's at least one client rect, it's
      //  somehow displayed; it also covers the CSS 'display: contents' case where the
      //  node itself is hidden in place of its contents; and there's no need to search
      //  up the hierarchy either
      return !node.getClientRects().length;
    }

    // Else, the node isn't attached to the document, which means the `getClientRects()`
    //  API will __always__ return zero rects (this can happen, for example, if React
    //  is used to render nodes onto a detached tree, as confirmed in this thread:
    //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
    //
    // It also means that even window.getComputedStyle(node).display will return `undefined`
    //  because styles are only computed for nodes that are in the document.
    //
    // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
    //  somehow. Though it was never stated officially, anyone who has ever used tabbable
    //  APIs on nodes in detached containers has actually implicitly used tabbable in what
    //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
    //  considering __everything__ to be visible because of the innability to determine styles.
    //
    // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
    //  nodes as visible with the 'none' fallback.__
    if (displayCheck !== 'legacy-full') {
      return true; // hidden
    }
    // else, fallback to 'none' mode and consider the node visible
  } else if (displayCheck === 'non-zero-area') {
    // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return isZeroArea(node);
  }

  // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
  //  it's visible
  return false;
};

// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
    var parentNode = node.parentElement;
    // check if `node` is contained in a disabled <fieldset>
    while (parentNode) {
      if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
        // look for the first <legend> among the children of the disabled <fieldset>
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);
          // when the first <legend> (in document order) is found
          if (child.tagName === 'LEGEND') {
            // if its parent <fieldset> is not nested in another disabled <fieldset>,
            // return whether `node` is a descendant of its first <legend>
            return matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
          }
        }
        // the disabled <fieldset> containing `node` has no <legend>
        return true;
      }
      parentNode = parentNode.parentElement;
    }
  }

  // else, node's tabbable/focusable state should not be affected by a fieldset's
  //  enabled/disabled state
  return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
  if (node.disabled ||
  // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  isInert(node) || isHiddenInput(node) || isHidden(node, options) ||
  // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }
  return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
  if (isNonTabbableRadio(node) || getTabIndex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
    return false;
  }
  return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
  var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
  if (isNaN(tabIndex) || tabIndex >= 0) {
    return true;
  }
  // If a custom element has an explicit negative tabindex,
  // browsers will not allow tab targeting said element's children.
  return false;
};

/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */
var sortByOrder = function sortByOrder(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function (item, i) {
    var isScope = !!item.scopeParent;
    var element = isScope ? item.scopeParent : item;
    var candidateTabindex = getSortOrderTabIndex(element, isScope);
    var elements = isScope ? sortByOrder(item.candidates) : element;
    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        item: item,
        isScope: isScope,
        content: elements
      });
    }
  });
  return orderedTabbables.sort(sortOrderedTabbables).reduce(function (acc, sortable) {
    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
    return acc;
  }, []).concat(regularTabbables);
};
var tabbable = function tabbable(container, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([container], options.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options),
      flatten: false,
      getShadowRoot: options.getShadowRoot,
      shadowRootFilter: isValidShadowRootTabbable
    });
  } else {
    candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  }
  return sortByOrder(candidates);
};
var focusable = function focusable(container, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([container], options.includeContainer, {
      filter: isNodeMatchingSelectorFocusable.bind(null, options),
      flatten: true,
      getShadowRoot: options.getShadowRoot
    });
  } else {
    candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
  }
  return candidates;
};
var isTabbable = function isTabbable(node, options) {
  options = options || {};
  if (!node) {
    throw new Error('No node provided');
  }
  if (matches.call(node, candidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* #__PURE__ */(/* unused pure expression or super */ null && (candidateSelectors.concat('iframe').join(',')));
var isFocusable = function isFocusable(node, options) {
  options = options || {};
  if (!node) {
    throw new Error('No node provided');
  }
  if (matches.call(node, focusableCandidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorFocusable(options, node);
};


//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ./node_modules/@floating-ui/react/dist/floating-ui.react.esm.js










/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */
function useMergeRefs(refs) {
  // biome-ignore lint/correctness/useExhaustiveDependencies: intentional
  return react.useMemo(() => {
    if (refs.every(ref => ref == null)) {
      return null;
    }
    return value => {
      refs.forEach(ref => {
        if (typeof ref === 'function') {
          ref(value);
        } else if (ref != null) {
          ref.current = value;
        }
      });
    };
  }, refs);
}

// `toString()` prevents bundlers from trying to `import { useInsertionEffect } from 'react'`
const useInsertionEffect = react_namespaceObject[/*#__PURE__*/'useInsertionEffect'.toString()];
const useSafeInsertionEffect = useInsertionEffect || (fn => fn());
function useEffectEvent(callback) {
  const ref = react.useRef(() => {
    if (false) {}
  });
  useSafeInsertionEffect(() => {
    ref.current = callback;
  });
  return react.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current == null ? void 0 : ref.current(...args);
  }, []);
}

const ARROW_UP = 'ArrowUp';
const ARROW_DOWN = 'ArrowDown';
const ARROW_LEFT = 'ArrowLeft';
const ARROW_RIGHT = 'ArrowRight';
function isDifferentRow(index, cols, prevRow) {
  return Math.floor(index / cols) !== prevRow;
}
function isIndexOutOfBounds(listRef, index) {
  return index < 0 || index >= listRef.current.length;
}
function getMinIndex(listRef, disabledIndices) {
  return findNonDisabledIndex(listRef, {
    disabledIndices
  });
}
function getMaxIndex(listRef, disabledIndices) {
  return findNonDisabledIndex(listRef, {
    decrement: true,
    startingIndex: listRef.current.length,
    disabledIndices
  });
}
function findNonDisabledIndex(listRef, _temp) {
  let {
    startingIndex = -1,
    decrement = false,
    disabledIndices,
    amount = 1
  } = _temp === void 0 ? {} : _temp;
  const list = listRef.current;
  const isDisabledIndex = disabledIndices ? index => disabledIndices.includes(index) : index => {
    const element = list[index];
    return element == null || element.hasAttribute('disabled') || element.getAttribute('aria-disabled') === 'true';
  };
  let index = startingIndex;
  do {
    index += decrement ? -amount : amount;
  } while (index >= 0 && index <= list.length - 1 && isDisabledIndex(index));
  return index;
}
function getGridNavigatedIndex(elementsRef, _ref) {
  let {
    event,
    orientation,
    loop,
    cols,
    disabledIndices,
    minIndex,
    maxIndex,
    prevIndex,
    stopEvent: stop = false
  } = _ref;
  let nextIndex = prevIndex;
  if (event.key === ARROW_UP) {
    stop && stopEvent(event);
    if (prevIndex === -1) {
      nextIndex = maxIndex;
    } else {
      nextIndex = findNonDisabledIndex(elementsRef, {
        startingIndex: nextIndex,
        amount: cols,
        decrement: true,
        disabledIndices
      });
      if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
        const col = prevIndex % cols;
        const maxCol = maxIndex % cols;
        const offset = maxIndex - (maxCol - col);
        if (maxCol === col) {
          nextIndex = maxIndex;
        } else {
          nextIndex = maxCol > col ? offset : offset - cols;
        }
      }
    }
    if (isIndexOutOfBounds(elementsRef, nextIndex)) {
      nextIndex = prevIndex;
    }
  }
  if (event.key === ARROW_DOWN) {
    stop && stopEvent(event);
    if (prevIndex === -1) {
      nextIndex = minIndex;
    } else {
      nextIndex = findNonDisabledIndex(elementsRef, {
        startingIndex: prevIndex,
        amount: cols,
        disabledIndices
      });
      if (loop && prevIndex + cols > maxIndex) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex % cols - cols,
          amount: cols,
          disabledIndices
        });
      }
    }
    if (isIndexOutOfBounds(elementsRef, nextIndex)) {
      nextIndex = prevIndex;
    }
  }

  // Remains on the same row/column.
  if (orientation === 'both') {
    const prevRow = floor(prevIndex / cols);
    if (event.key === ARROW_RIGHT) {
      stop && stopEvent(event);
      if (prevIndex % cols !== cols - 1) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex,
          disabledIndices
        });
        if (loop && isDifferentRow(nextIndex, cols, prevRow)) {
          nextIndex = findNonDisabledIndex(elementsRef, {
            startingIndex: prevIndex - prevIndex % cols - 1,
            disabledIndices
          });
        }
      } else if (loop) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex - prevIndex % cols - 1,
          disabledIndices
        });
      }
      if (isDifferentRow(nextIndex, cols, prevRow)) {
        nextIndex = prevIndex;
      }
    }
    if (event.key === ARROW_LEFT) {
      stop && stopEvent(event);
      if (prevIndex % cols !== 0) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex,
          disabledIndices,
          decrement: true
        });
        if (loop && isDifferentRow(nextIndex, cols, prevRow)) {
          nextIndex = findNonDisabledIndex(elementsRef, {
            startingIndex: prevIndex + (cols - prevIndex % cols),
            decrement: true,
            disabledIndices
          });
        }
      } else if (loop) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex + (cols - prevIndex % cols),
          decrement: true,
          disabledIndices
        });
      }
      if (isDifferentRow(nextIndex, cols, prevRow)) {
        nextIndex = prevIndex;
      }
    }
    const lastRow = floor(maxIndex / cols) === prevRow;
    if (isIndexOutOfBounds(elementsRef, nextIndex)) {
      if (loop && lastRow) {
        nextIndex = event.key === ARROW_LEFT ? maxIndex : findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex - prevIndex % cols - 1,
          disabledIndices
        });
      } else {
        nextIndex = prevIndex;
      }
    }
  }
  return nextIndex;
}

/** For each cell index, gets the item index that occupies that cell */
function buildCellMap(sizes, cols, dense) {
  const cellMap = [];
  let startIndex = 0;
  sizes.forEach((_ref2, index) => {
    let {
      width,
      height
    } = _ref2;
    if (width > cols) {
      if (false) {}
    }
    let itemPlaced = false;
    if (dense) {
      startIndex = 0;
    }
    while (!itemPlaced) {
      const targetCells = [];
      for (let i = 0; i < width; i++) {
        for (let j = 0; j < height; j++) {
          targetCells.push(startIndex + i + j * cols);
        }
      }
      if (startIndex % cols + width <= cols && targetCells.every(cell => cellMap[cell] == null)) {
        targetCells.forEach(cell => {
          cellMap[cell] = index;
        });
        itemPlaced = true;
      } else {
        startIndex++;
      }
    }
  });

  // convert into a non-sparse array
  return [...cellMap];
}

/** Gets cell index of an item's corner or -1 when index is -1. */
function getCellIndexOfCorner(index, sizes, cellMap, cols, corner) {
  if (index === -1) return -1;
  const firstCellIndex = cellMap.indexOf(index);
  switch (corner) {
    case 'tl':
      return firstCellIndex;
    case 'tr':
      return firstCellIndex + sizes[index].width - 1;
    case 'bl':
      return firstCellIndex + (sizes[index].height - 1) * cols;
    case 'br':
      return cellMap.lastIndexOf(index);
  }
}

/** Gets all cell indices that correspond to the specified indices */
function getCellIndices(indices, cellMap) {
  return cellMap.flatMap((index, cellIndex) => indices.includes(index) ? [cellIndex] : []);
}

let rafId = 0;
function enqueueFocus(el, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    preventScroll = false,
    cancelPrevious = true,
    sync = false
  } = options;
  cancelPrevious && cancelAnimationFrame(rafId);
  const exec = () => el == null ? void 0 : el.focus({
    preventScroll
  });
  if (sync) {
    exec();
  } else {
    rafId = requestAnimationFrame(exec);
  }
}

var floating_ui_react_esm_index = typeof document !== 'undefined' ? react.useLayoutEffect : react.useEffect;

function sortByDocumentPosition(a, b) {
  const position = a.compareDocumentPosition(b);
  if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
    return -1;
  }
  if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) {
    return 1;
  }
  return 0;
}
function areMapsEqual(map1, map2) {
  if (map1.size !== map2.size) {
    return false;
  }
  for (const [key, value] of map1.entries()) {
    if (value !== map2.get(key)) {
      return false;
    }
  }
  return true;
}
const FloatingListContext = /*#__PURE__*/react.createContext({
  register: () => {},
  unregister: () => {},
  map: /*#__PURE__*/new Map(),
  elementsRef: {
    current: []
  }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */
function FloatingList(_ref) {
  let {
    children,
    elementsRef,
    labelsRef
  } = _ref;
  const [map, setMap] = react.useState(() => new Map());
  const register = react.useCallback(node => {
    setMap(prevMap => new Map(prevMap).set(node, null));
  }, []);
  const unregister = react.useCallback(node => {
    setMap(prevMap => {
      const map = new Map(prevMap);
      map.delete(node);
      return map;
    });
  }, []);
  floating_ui_react_esm_index(() => {
    const newMap = new Map(map);
    const nodes = Array.from(newMap.keys()).sort(sortByDocumentPosition);
    nodes.forEach((node, index) => {
      newMap.set(node, index);
    });
    if (!areMapsEqual(map, newMap)) {
      setMap(newMap);
    }
  }, [map]);
  return /*#__PURE__*/react.createElement(FloatingListContext.Provider, {
    value: react.useMemo(() => ({
      register,
      unregister,
      map,
      elementsRef,
      labelsRef
    }), [register, unregister, map, elementsRef, labelsRef])
  }, children);
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */
function useListItem(_temp) {
  let {
    label
  } = _temp === void 0 ? {} : _temp;
  const [index$1, setIndex] = react.useState(null);
  const componentRef = react.useRef(null);
  const {
    register,
    unregister,
    map,
    elementsRef,
    labelsRef
  } = react.useContext(FloatingListContext);
  const ref = react.useCallback(node => {
    componentRef.current = node;
    if (index$1 !== null) {
      elementsRef.current[index$1] = node;
      if (labelsRef) {
        var _node$textContent;
        const isLabelDefined = label !== undefined;
        labelsRef.current[index$1] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
      }
    }
  }, [index$1, elementsRef, labelsRef, label]);
  floating_ui_react_esm_index(() => {
    const node = componentRef.current;
    if (node) {
      register(node);
      return () => {
        unregister(node);
      };
    }
  }, [register, unregister]);
  floating_ui_react_esm_index(() => {
    const index = componentRef.current ? map.get(componentRef.current) : null;
    if (index != null) {
      setIndex(index);
    }
  }, [map]);
  return react.useMemo(() => ({
    ref,
    index: index$1 == null ? -1 : index$1
  }), [index$1, ref]);
}

function renderJsx(render, computedProps) {
  if (typeof render === 'function') {
    return render(computedProps);
  }
  if (render) {
    return /*#__PURE__*/react.cloneElement(render, computedProps);
  }
  return /*#__PURE__*/react.createElement("div", computedProps);
}
const CompositeContext = /*#__PURE__*/react.createContext({
  activeIndex: 0,
  onNavigate: () => {}
});
const horizontalKeys = [ARROW_LEFT, ARROW_RIGHT];
const verticalKeys = [ARROW_UP, ARROW_DOWN];
const allKeys = [...horizontalKeys, ...verticalKeys];

/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */
const Composite = /*#__PURE__*/react.forwardRef(function Composite(_ref, forwardedRef) {
  let {
    render,
    orientation = 'both',
    loop = true,
    cols = 1,
    disabledIndices = [],
    activeIndex: externalActiveIndex,
    onNavigate: externalSetActiveIndex,
    itemSizes,
    dense = false,
    ...props
  } = _ref;
  const [internalActiveIndex, internalSetActiveIndex] = react.useState(0);
  const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
  const onNavigate = useEffectEvent(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
  const elementsRef = react.useRef([]);
  const renderElementProps = render && typeof render !== 'function' ? render.props : {};
  const contextValue = react.useMemo(() => ({
    activeIndex,
    onNavigate
  }), [activeIndex, onNavigate]);
  const isGrid = cols > 1;
  function handleKeyDown(event) {
    if (!allKeys.includes(event.key)) return;
    let nextIndex = activeIndex;
    if (isGrid) {
      const sizes = itemSizes || Array.from({
        length: elementsRef.current.length
      }, () => ({
        width: 1,
        height: 1
      }));
      // To calculate movements on the grid, we use hypothetical cell indices
      // as if every item was 1x1, then convert back to real indices.
      const cellMap = buildCellMap(sizes, cols, dense);
      const minGridIndex = cellMap.findIndex(index => index != null && !disabledIndices.includes(index));
      // last enabled index
      const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex) => index != null && !(disabledIndices != null && disabledIndices.includes(index)) ? cellIndex : foundIndex, -1);
      nextIndex = cellMap[getGridNavigatedIndex({
        current: cellMap.map(itemIndex => itemIndex ? elementsRef.current[itemIndex] : null)
      }, {
        event,
        orientation,
        loop,
        cols,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: getCellIndices([...disabledIndices, undefined], cellMap),
        minIndex: minGridIndex,
        maxIndex: maxGridIndex,
        prevIndex: getCellIndexOfCorner(activeIndex, sizes, cellMap, cols,
        // use a corner matching the edge closest to the direction we're
        // moving in so we don't end up in the same item. Prefer
        // top/left over bottom/right.
        event.key === ARROW_DOWN ? 'bl' : event.key === ARROW_RIGHT ? 'tr' : 'tl')
      })]; // navigated cell will never be nullish
    }
    const minIndex = getMinIndex(elementsRef, disabledIndices);
    const maxIndex = getMaxIndex(elementsRef, disabledIndices);
    const toEndKeys = {
      horizontal: [ARROW_RIGHT],
      vertical: [ARROW_DOWN],
      both: [ARROW_RIGHT, ARROW_DOWN]
    }[orientation];
    const toStartKeys = {
      horizontal: [ARROW_LEFT],
      vertical: [ARROW_UP],
      both: [ARROW_LEFT, ARROW_UP]
    }[orientation];
    const preventedKeys = isGrid ? allKeys : {
      horizontal: horizontalKeys,
      vertical: verticalKeys,
      both: allKeys
    }[orientation];
    if (nextIndex === activeIndex && [...toEndKeys, ...toStartKeys].includes(event.key)) {
      if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) {
        nextIndex = minIndex;
      } else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) {
        nextIndex = maxIndex;
      } else {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: nextIndex,
          decrement: toStartKeys.includes(event.key),
          disabledIndices
        });
      }
    }
    if (nextIndex !== activeIndex && !isIndexOutOfBounds(elementsRef, nextIndex)) {
      event.stopPropagation();
      if (preventedKeys.includes(event.key)) {
        event.preventDefault();
      }
      onNavigate(nextIndex);

      // Wait for FocusManager `returnFocus` to execute.
      queueMicrotask(() => {
        enqueueFocus(elementsRef.current[nextIndex]);
      });
    }
  }
  const computedProps = {
    ...props,
    ...renderElementProps,
    ref: forwardedRef,
    'aria-orientation': orientation === 'both' ? undefined : orientation,
    onKeyDown(e) {
      props.onKeyDown == null || props.onKeyDown(e);
      renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
      handleKeyDown(e);
    }
  };
  return /*#__PURE__*/react.createElement(CompositeContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/react.createElement(FloatingList, {
    elementsRef: elementsRef
  }, renderJsx(render, computedProps)));
});
/**
 * @see https://floating-ui.com/docs/Composite
 */
const CompositeItem = /*#__PURE__*/react.forwardRef(function CompositeItem(_ref2, forwardedRef) {
  let {
    render,
    ...props
  } = _ref2;
  const renderElementProps = render && typeof render !== 'function' ? render.props : {};
  const {
    activeIndex,
    onNavigate
  } = react.useContext(CompositeContext);
  const {
    ref,
    index
  } = useListItem();
  const mergedRef = useMergeRefs([ref, forwardedRef, renderElementProps.ref]);
  const isActive = activeIndex === index;
  const computedProps = {
    ...props,
    ...renderElementProps,
    ref: mergedRef,
    tabIndex: isActive ? 0 : -1,
    'data-active': isActive ? '' : undefined,
    onFocus(e) {
      props.onFocus == null || props.onFocus(e);
      renderElementProps.onFocus == null || renderElementProps.onFocus(e);
      onNavigate(index);
    }
  };
  return renderJsx(render, computedProps);
});

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

let serverHandoffComplete = false;
let count = 0;
const genId = () => "floating-ui-" + count++;
function useFloatingId() {
  const [id, setId] = react.useState(() => serverHandoffComplete ? genId() : undefined);

  // biome-ignore lint/correctness/useExhaustiveDependencies: intentional
  floating_ui_react_esm_index(() => {
    if (id == null) {
      setId(genId());
    }
  }, []);
  react.useEffect(() => {
    if (!serverHandoffComplete) {
      serverHandoffComplete = true;
    }
  }, []);
  return id;
}

// `toString()` prevents bundlers from trying to `import { useId } from 'react'`
const useReactId = react_namespaceObject[/*#__PURE__*/'useId'.toString()];

/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */
const useId = useReactId || useFloatingId;

/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */
const FloatingArrow = /*#__PURE__*/react.forwardRef(function FloatingArrow(_ref, ref) {
  let {
    context: {
      placement,
      elements: {
        floating
      },
      middlewareData: {
        arrow
      }
    },
    width = 14,
    height = 7,
    tipRadius = 0,
    strokeWidth = 0,
    staticOffset,
    stroke,
    d,
    style: {
      transform,
      ...restStyle
    } = {},
    ...rest
  } = _ref;
  if (false) {}
  const clipPathId = useId();
  if (!floating) {
    return null;
  }

  // Strokes must be double the border width, this ensures the stroke's width
  // works as you'd expect.
  strokeWidth *= 2;
  const halfStrokeWidth = strokeWidth / 2;
  const svgX = width / 2 * (tipRadius / -8 + 1);
  const svgY = height / 2 * tipRadius / 4;
  const [side, alignment] = placement.split('-');
  const isRTL = platform.isRTL(floating);
  const isCustomShape = !!d;
  const isVerticalSide = side === 'top' || side === 'bottom';
  const yOffsetProp = staticOffset && alignment === 'end' ? 'bottom' : 'top';
  let xOffsetProp = staticOffset && alignment === 'end' ? 'right' : 'left';
  if (staticOffset && isRTL) {
    xOffsetProp = alignment === 'end' ? 'left' : 'right';
  }
  const arrowX = (arrow == null ? void 0 : arrow.x) != null ? staticOffset || arrow.x : '';
  const arrowY = (arrow == null ? void 0 : arrow.y) != null ? staticOffset || arrow.y : '';
  const dValue = d ||
  // biome-ignore lint/style/useTemplate: readability
  'M0,0' + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + ' Z';
  const rotation = {
    top: isCustomShape ? 'rotate(180deg)' : '',
    left: isCustomShape ? 'rotate(90deg)' : 'rotate(-90deg)',
    bottom: isCustomShape ? '' : 'rotate(180deg)',
    right: isCustomShape ? 'rotate(-90deg)' : 'rotate(90deg)'
  }[side];
  return /*#__PURE__*/react.createElement("svg", _extends({}, rest, {
    "aria-hidden": true,
    ref: ref,
    width: isCustomShape ? width : width + strokeWidth,
    height: width,
    viewBox: "0 0 " + width + " " + (height > width ? height : width),
    style: {
      position: 'absolute',
      pointerEvents: 'none',
      [xOffsetProp]: arrowX,
      [yOffsetProp]: arrowY,
      [side]: isVerticalSide || isCustomShape ? '100%' : "calc(100% - " + strokeWidth / 2 + "px)",
      transform: "" + rotation + (transform != null ? transform : ''),
      ...restStyle
    }
  }), strokeWidth > 0 && /*#__PURE__*/react.createElement("path", {
    clipPath: "url(#" + clipPathId + ")",
    fill: "none",
    stroke: stroke
    // Account for the stroke on the fill path rendered below.
    ,
    strokeWidth: strokeWidth + (d ? 0 : 1),
    d: dValue
  }), /*#__PURE__*/react.createElement("path", {
    stroke: strokeWidth && !d ? rest.fill : 'none',
    d: dValue
  }), /*#__PURE__*/react.createElement("clipPath", {
    id: clipPathId
  }, /*#__PURE__*/react.createElement("rect", {
    x: -halfStrokeWidth,
    y: halfStrokeWidth * (isCustomShape ? -1 : 1),
    width: width + strokeWidth,
    height: width
  })));
});

function createPubSub() {
  const map = new Map();
  return {
    emit(event, data) {
      var _map$get;
      (_map$get = map.get(event)) == null || _map$get.forEach(handler => handler(data));
    },
    on(event, listener) {
      map.set(event, [...(map.get(event) || []), listener]);
    },
    off(event, listener) {
      var _map$get2;
      map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter(l => l !== listener)) || []);
    }
  };
}

const FloatingNodeContext = /*#__PURE__*/react.createContext(null);
const FloatingTreeContext = /*#__PURE__*/react.createContext(null);

/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */
const useFloatingParentNodeId = () => {
  var _React$useContext;
  return ((_React$useContext = react.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};

/**
 * Returns the nearest floating tree context, if available.
 */
const useFloatingTree = () => react.useContext(FloatingTreeContext);

/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */
function useFloatingNodeId(customParentId) {
  const id = useId();
  const tree = useFloatingTree();
  const reactParentId = useFloatingParentNodeId();
  const parentId = customParentId || reactParentId;
  floating_ui_react_esm_index(() => {
    const node = {
      id,
      parentId
    };
    tree == null || tree.addNode(node);
    return () => {
      tree == null || tree.removeNode(node);
    };
  }, [tree, id, parentId]);
  return id;
}

/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */
function FloatingNode(_ref) {
  let {
    children,
    id
  } = _ref;
  const parentId = useFloatingParentNodeId();
  return /*#__PURE__*/react.createElement(FloatingNodeContext.Provider, {
    value: react.useMemo(() => ({
      id,
      parentId
    }), [id, parentId])
  }, children);
}

/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */
function FloatingTree(_ref2) {
  let {
    children
  } = _ref2;
  const nodesRef = react.useRef([]);
  const addNode = react.useCallback(node => {
    nodesRef.current = [...nodesRef.current, node];
  }, []);
  const removeNode = react.useCallback(node => {
    nodesRef.current = nodesRef.current.filter(n => n !== node);
  }, []);
  const events = react.useState(() => createPubSub())[0];
  return /*#__PURE__*/react.createElement(FloatingTreeContext.Provider, {
    value: react.useMemo(() => ({
      nodesRef,
      addNode,
      removeNode,
      events
    }), [addNode, removeNode, events])
  }, children);
}

function createAttribute(name) {
  return "data-floating-ui-" + name;
}

function floating_ui_react_esm_useLatestRef(value) {
  const ref = (0,react.useRef)(value);
  floating_ui_react_esm_index(() => {
    ref.current = value;
  });
  return ref;
}

const safePolygonIdentifier = /*#__PURE__*/createAttribute('safe-polygon');
function getDelay(value, prop, pointerType) {
  if (pointerType && !isMouseLikePointerType(pointerType)) {
    return 0;
  }
  if (typeof value === 'number') {
    return value;
  }
  return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */
function useHover(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    dataRef,
    events,
    elements: {
      domReference,
      floating
    },
    refs
  } = context;
  const {
    enabled = true,
    delay = 0,
    handleClose = null,
    mouseOnly = false,
    restMs = 0,
    move = true
  } = props;
  const tree = useFloatingTree();
  const parentId = useFloatingParentNodeId();
  const handleCloseRef = floating_ui_react_esm_useLatestRef(handleClose);
  const delayRef = floating_ui_react_esm_useLatestRef(delay);
  const pointerTypeRef = react.useRef();
  const timeoutRef = react.useRef();
  const handlerRef = react.useRef();
  const restTimeoutRef = react.useRef();
  const blockMouseMoveRef = react.useRef(true);
  const performedPointerEventsMutationRef = react.useRef(false);
  const unbindMouseMoveRef = react.useRef(() => {});
  const isHoverOpen = react.useCallback(() => {
    var _dataRef$current$open;
    const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
    return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
  }, [dataRef]);

  // When closing before opening, clear the delay timeouts to cancel it
  // from showing.
  react.useEffect(() => {
    if (!enabled) {
      return;
    }
    function onOpenChange(_ref) {
      let {
        open
      } = _ref;
      if (!open) {
        clearTimeout(timeoutRef.current);
        clearTimeout(restTimeoutRef.current);
        blockMouseMoveRef.current = true;
      }
    }
    events.on('openchange', onOpenChange);
    return () => {
      events.off('openchange', onOpenChange);
    };
  }, [enabled, events]);
  react.useEffect(() => {
    if (!enabled || !handleCloseRef.current || !open) {
      return;
    }
    function onLeave(event) {
      if (isHoverOpen()) {
        onOpenChange(false, event, 'hover');
      }
    }
    const html = getDocument(floating).documentElement;
    html.addEventListener('mouseleave', onLeave);
    return () => {
      html.removeEventListener('mouseleave', onLeave);
    };
  }, [floating, open, onOpenChange, enabled, handleCloseRef, isHoverOpen]);
  const closeWithDelay = react.useCallback(function (event, runElseBranch, reason) {
    if (runElseBranch === void 0) {
      runElseBranch = true;
    }
    if (reason === void 0) {
      reason = 'hover';
    }
    const closeDelay = getDelay(delayRef.current, 'close', pointerTypeRef.current);
    if (closeDelay && !handlerRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => onOpenChange(false, event, reason), closeDelay);
    } else if (runElseBranch) {
      clearTimeout(timeoutRef.current);
      onOpenChange(false, event, reason);
    }
  }, [delayRef, onOpenChange]);
  const cleanupMouseMoveHandler = react.useCallback(() => {
    unbindMouseMoveRef.current();
    handlerRef.current = undefined;
  }, []);
  const clearPointerEvents = react.useCallback(() => {
    if (performedPointerEventsMutationRef.current) {
      const body = getDocument(refs.floating.current).body;
      body.style.pointerEvents = '';
      body.removeAttribute(safePolygonIdentifier);
      performedPointerEventsMutationRef.current = false;
    }
  }, [refs]);

  // Registering the mouse events on the reference directly to bypass React's
  // delegation system. If the cursor was on a disabled element and then entered
  // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
  react.useEffect(() => {
    if (!enabled) {
      return;
    }
    function isClickLikeOpenEvent() {
      return dataRef.current.openEvent ? ['click', 'mousedown'].includes(dataRef.current.openEvent.type) : false;
    }
    function onMouseEnter(event) {
      clearTimeout(timeoutRef.current);
      blockMouseMoveRef.current = false;
      if (mouseOnly && !isMouseLikePointerType(pointerTypeRef.current) || restMs > 0 && getDelay(delayRef.current, 'open') === 0) {
        return;
      }
      const openDelay = getDelay(delayRef.current, 'open', pointerTypeRef.current);
      if (openDelay) {
        timeoutRef.current = setTimeout(() => {
          onOpenChange(true, event, 'hover');
        }, openDelay);
      } else {
        onOpenChange(true, event, 'hover');
      }
    }
    function onMouseLeave(event) {
      if (isClickLikeOpenEvent()) {
        return;
      }
      unbindMouseMoveRef.current();
      const doc = getDocument(floating);
      clearTimeout(restTimeoutRef.current);
      if (handleCloseRef.current) {
        // Prevent clearing `onScrollMouseLeave` timeout.
        if (!open) {
          clearTimeout(timeoutRef.current);
        }
        handlerRef.current = handleCloseRef.current({
          ...context,
          tree,
          x: event.clientX,
          y: event.clientY,
          onClose() {
            clearPointerEvents();
            cleanupMouseMoveHandler();
            closeWithDelay(event, true, 'safe-polygon');
          }
        });
        const handler = handlerRef.current;
        doc.addEventListener('mousemove', handler);
        unbindMouseMoveRef.current = () => {
          doc.removeEventListener('mousemove', handler);
        };
        return;
      }

      // Allow interactivity without `safePolygon` on touch devices. With a
      // pointer, a short close delay is an alternative, so it should work
      // consistently.
      const shouldClose = pointerTypeRef.current === 'touch' ? !contains(floating, event.relatedTarget) : true;
      if (shouldClose) {
        closeWithDelay(event);
      }
    }

    // Ensure the floating element closes after scrolling even if the pointer
    // did not move.
    // https://github.com/floating-ui/floating-ui/discussions/1692
    function onScrollMouseLeave(event) {
      if (isClickLikeOpenEvent()) {
        return;
      }
      handleCloseRef.current == null || handleCloseRef.current({
        ...context,
        tree,
        x: event.clientX,
        y: event.clientY,
        onClose() {
          clearPointerEvents();
          cleanupMouseMoveHandler();
          closeWithDelay(event);
        }
      })(event);
    }
    if (isElement(domReference)) {
      const ref = domReference;
      open && ref.addEventListener('mouseleave', onScrollMouseLeave);
      floating == null || floating.addEventListener('mouseleave', onScrollMouseLeave);
      move && ref.addEventListener('mousemove', onMouseEnter, {
        once: true
      });
      ref.addEventListener('mouseenter', onMouseEnter);
      ref.addEventListener('mouseleave', onMouseLeave);
      return () => {
        open && ref.removeEventListener('mouseleave', onScrollMouseLeave);
        floating == null || floating.removeEventListener('mouseleave', onScrollMouseLeave);
        move && ref.removeEventListener('mousemove', onMouseEnter);
        ref.removeEventListener('mouseenter', onMouseEnter);
        ref.removeEventListener('mouseleave', onMouseLeave);
      };
    }
  }, [domReference, floating, enabled, context, mouseOnly, restMs, move, closeWithDelay, cleanupMouseMoveHandler, clearPointerEvents, onOpenChange, open, tree, delayRef, handleCloseRef, dataRef]);

  // Block pointer-events of every element other than the reference and floating
  // while the floating element is open and has a `handleClose` handler. Also
  // handles nested floating elements.
  // https://github.com/floating-ui/floating-ui/issues/1722
  floating_ui_react_esm_index(() => {
    var _handleCloseRef$curre;
    if (!enabled) {
      return;
    }
    if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
      const body = getDocument(floating).body;
      body.setAttribute(safePolygonIdentifier, '');
      body.style.pointerEvents = 'none';
      performedPointerEventsMutationRef.current = true;
      if (isElement(domReference) && floating) {
        var _tree$nodesRef$curren;
        const ref = domReference;
        const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find(node => node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
        if (parentFloating) {
          parentFloating.style.pointerEvents = '';
        }
        ref.style.pointerEvents = 'auto';
        floating.style.pointerEvents = 'auto';
        return () => {
          ref.style.pointerEvents = '';
          floating.style.pointerEvents = '';
        };
      }
    }
  }, [enabled, open, parentId, floating, domReference, tree, handleCloseRef, isHoverOpen]);
  floating_ui_react_esm_index(() => {
    if (!open) {
      pointerTypeRef.current = undefined;
      cleanupMouseMoveHandler();
      clearPointerEvents();
    }
  }, [open, cleanupMouseMoveHandler, clearPointerEvents]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: intentional
  react.useEffect(() => {
    return () => {
      cleanupMouseMoveHandler();
      clearTimeout(timeoutRef.current);
      clearTimeout(restTimeoutRef.current);
      clearPointerEvents();
    };
  }, [enabled, domReference, cleanupMouseMoveHandler, clearPointerEvents]);
  return react.useMemo(() => {
    if (!enabled) {
      return {};
    }
    function setPointerRef(event) {
      pointerTypeRef.current = event.pointerType;
    }
    return {
      reference: {
        onPointerDown: setPointerRef,
        onPointerEnter: setPointerRef,
        onMouseMove(event) {
          if (open || restMs === 0) {
            return;
          }
          clearTimeout(restTimeoutRef.current);
          restTimeoutRef.current = setTimeout(() => {
            if (!blockMouseMoveRef.current) {
              onOpenChange(true, event.nativeEvent, 'hover');
            }
          }, restMs);
        }
      },
      floating: {
        onMouseEnter() {
          clearTimeout(timeoutRef.current);
        },
        onMouseLeave(event) {
          closeWithDelay(event.nativeEvent, false);
        }
      }
    };
  }, [enabled, restMs, open, onOpenChange, closeWithDelay]);
}

const FloatingDelayGroupContext = /*#__PURE__*/react.createContext({
  delay: 0,
  initialDelay: 0,
  timeoutMs: 0,
  currentId: null,
  setCurrentId: () => {},
  setState: () => {},
  isInstantPhase: false
});
const useDelayGroupContext = () => react.useContext(FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */
const FloatingDelayGroup = _ref => {
  let {
    children,
    delay,
    timeoutMs = 0
  } = _ref;
  const [state, setState] = react.useReducer((prev, next) => ({
    ...prev,
    ...next
  }), {
    delay,
    timeoutMs,
    initialDelay: delay,
    currentId: null,
    isInstantPhase: false
  });
  const initialCurrentIdRef = react.useRef(null);
  const setCurrentId = react.useCallback(currentId => {
    setState({
      currentId
    });
  }, []);
  floating_ui_react_esm_index(() => {
    if (state.currentId) {
      if (initialCurrentIdRef.current === null) {
        initialCurrentIdRef.current = state.currentId;
      } else {
        setState({
          isInstantPhase: true
        });
      }
    } else {
      setState({
        isInstantPhase: false
      });
      initialCurrentIdRef.current = null;
    }
  }, [state.currentId]);
  return /*#__PURE__*/react.createElement(FloatingDelayGroupContext.Provider, {
    value: react.useMemo(() => ({
      ...state,
      setState,
      setCurrentId
    }), [state, setCurrentId])
  }, children);
};
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */
const useDelayGroup = (_ref2, _ref3) => {
  let {
    open,
    onOpenChange
  } = _ref2;
  let {
    id
  } = _ref3;
  const {
    currentId,
    setCurrentId,
    initialDelay,
    setState,
    timeoutMs
  } = useDelayGroupContext();
  floating_ui_react_esm_index(() => {
    if (currentId) {
      setState({
        delay: {
          open: 1,
          close: getDelay(initialDelay, 'close')
        }
      });
      if (currentId !== id) {
        onOpenChange(false);
      }
    }
  }, [id, onOpenChange, setState, currentId, initialDelay]);
  floating_ui_react_esm_index(() => {
    function unset() {
      onOpenChange(false);
      setState({
        delay: initialDelay,
        currentId: null
      });
    }
    if (!open && currentId === id) {
      if (timeoutMs) {
        const timeout = window.setTimeout(unset, timeoutMs);
        return () => {
          clearTimeout(timeout);
        };
      }
      unset();
    }
  }, [open, setState, currentId, id, onOpenChange, initialDelay, timeoutMs]);
  floating_ui_react_esm_index(() => {
    if (open) {
      setCurrentId(id);
    }
  }, [open, setCurrentId, id]);
};

function getAncestors(nodes, id) {
  var _nodes$find;
  let allAncestors = [];
  let currentParentId = (_nodes$find = nodes.find(node => node.id === id)) == null ? void 0 : _nodes$find.parentId;
  while (currentParentId) {
    const currentNode = nodes.find(node => node.id === currentParentId);
    currentParentId = currentNode == null ? void 0 : currentNode.parentId;
    if (currentNode) {
      allAncestors = allAncestors.concat(currentNode);
    }
  }
  return allAncestors;
}

function getChildren(nodes, id) {
  let allChildren = nodes.filter(node => {
    var _node$context;
    return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
  });
  let currentChildren = allChildren;
  while (currentChildren.length) {
    currentChildren = nodes.filter(node => {
      var _currentChildren;
      return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some(n => {
        var _node$context2;
        return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
      });
    });
    allChildren = allChildren.concat(currentChildren);
  }
  return allChildren;
}
function getDeepestNode(nodes, id) {
  let deepestNodeId;
  let maxDepth = -1;
  function findDeepest(nodeId, depth) {
    if (depth > maxDepth) {
      deepestNodeId = nodeId;
      maxDepth = depth;
    }
    const children = getChildren(nodes, nodeId);
    children.forEach(child => {
      findDeepest(child.id, depth + 1);
    });
  }
  findDeepest(id, 0);
  return nodes.find(node => node.id === deepestNodeId);
}

// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
let counterMap = /*#__PURE__*/new WeakMap();
let uncontrolledElementsSet = /*#__PURE__*/new WeakSet();
let markerMap = {};
let lockCount = 0;
const supportsInert = () => typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
const unwrapHost = node => node && (node.host || unwrapHost(node.parentNode));
const correctElements = (parent, targets) => targets.map(target => {
  if (parent.contains(target)) {
    return target;
  }
  const correctedTarget = unwrapHost(target);
  if (parent.contains(correctedTarget)) {
    return correctedTarget;
  }
  return null;
}).filter(x => x != null);
function applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
  const markerName = 'data-floating-ui-inert';
  const controlAttribute = inert ? 'inert' : ariaHidden ? 'aria-hidden' : null;
  const avoidElements = correctElements(body, uncorrectedAvoidElements);
  const elementsToKeep = new Set();
  const elementsToStop = new Set(avoidElements);
  const hiddenElements = [];
  if (!markerMap[markerName]) {
    markerMap[markerName] = new WeakMap();
  }
  const markerCounter = markerMap[markerName];
  avoidElements.forEach(keep);
  deep(body);
  elementsToKeep.clear();
  function keep(el) {
    if (!el || elementsToKeep.has(el)) {
      return;
    }
    elementsToKeep.add(el);
    el.parentNode && keep(el.parentNode);
  }
  function deep(parent) {
    if (!parent || elementsToStop.has(parent)) {
      return;
    }
    Array.prototype.forEach.call(parent.children, node => {
      if (elementsToKeep.has(node)) {
        deep(node);
      } else {
        const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
        const alreadyHidden = attr !== null && attr !== 'false';
        const counterValue = (counterMap.get(node) || 0) + 1;
        const markerValue = (markerCounter.get(node) || 0) + 1;
        counterMap.set(node, counterValue);
        markerCounter.set(node, markerValue);
        hiddenElements.push(node);
        if (counterValue === 1 && alreadyHidden) {
          uncontrolledElementsSet.add(node);
        }
        if (markerValue === 1) {
          node.setAttribute(markerName, '');
        }
        if (!alreadyHidden && controlAttribute) {
          node.setAttribute(controlAttribute, 'true');
        }
      }
    });
  }
  lockCount++;
  return () => {
    hiddenElements.forEach(element => {
      const counterValue = (counterMap.get(element) || 0) - 1;
      const markerValue = (markerCounter.get(element) || 0) - 1;
      counterMap.set(element, counterValue);
      markerCounter.set(element, markerValue);
      if (!counterValue) {
        if (!uncontrolledElementsSet.has(element) && controlAttribute) {
          element.removeAttribute(controlAttribute);
        }
        uncontrolledElementsSet.delete(element);
      }
      if (!markerValue) {
        element.removeAttribute(markerName);
      }
    });
    lockCount--;
    if (!lockCount) {
      counterMap = new WeakMap();
      counterMap = new WeakMap();
      uncontrolledElementsSet = new WeakSet();
      markerMap = {};
    }
  };
}
function markOthers(avoidElements, ariaHidden, inert) {
  if (ariaHidden === void 0) {
    ariaHidden = false;
  }
  if (inert === void 0) {
    inert = false;
  }
  const body = getDocument(avoidElements[0]).body;
  return applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll('[aria-live]'))), body, ariaHidden, inert);
}

const getTabbableOptions = () => ({
  getShadowRoot: true,
  displayCheck:
  // JSDOM does not support the `tabbable` library. To solve this we can
  // check if `ResizeObserver` is a real function (not polyfilled), which
  // determines if the current environment is JSDOM-like.
  typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
});
function getTabbableIn(container, direction) {
  const allTabbable = tabbable(container, getTabbableOptions());
  if (direction === 'prev') {
    allTabbable.reverse();
  }
  const activeIndex = allTabbable.indexOf(activeElement(getDocument(container)));
  const nextTabbableElements = allTabbable.slice(activeIndex + 1);
  return nextTabbableElements[0];
}
function getNextTabbable() {
  return getTabbableIn(document.body, 'next');
}
function getPreviousTabbable() {
  return getTabbableIn(document.body, 'prev');
}
function isOutsideEvent(event, container) {
  const containerElement = container || event.currentTarget;
  const relatedTarget = event.relatedTarget;
  return !relatedTarget || !contains(containerElement, relatedTarget);
}
function disableFocusInside(container) {
  const tabbableElements = tabbable(container, getTabbableOptions());
  tabbableElements.forEach(element => {
    element.dataset.tabindex = element.getAttribute('tabindex') || '';
    element.setAttribute('tabindex', '-1');
  });
}
function enableFocusInside(container) {
  const elements = container.querySelectorAll('[data-tabindex]');
  elements.forEach(element => {
    const tabindex = element.dataset.tabindex;
    // biome-ignore lint/performance/noDelete: purity
    delete element.dataset.tabindex;
    if (tabindex) {
      element.setAttribute('tabindex', tabindex);
    } else {
      element.removeAttribute('tabindex');
    }
  });
}

// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx

const HIDDEN_STYLES = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'fixed',
  whiteSpace: 'nowrap',
  width: '1px',
  top: 0,
  left: 0
};
let timeoutId;
function setActiveElementOnTab(event) {
  if (event.key === 'Tab') {
    event.target;
    clearTimeout(timeoutId);
  }
}
const FocusGuard = /*#__PURE__*/react.forwardRef(function FocusGuard(props, ref) {
  const [role, setRole] = react.useState();
  floating_ui_react_esm_index(() => {
    if (isSafari()) {
      // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
      // on VoiceOver does trigger the onFocus event, so we can use the focus
      // trap element. On Safari, only buttons trigger the onFocus event.
      // NB: "group" role in the Sandbox no longer appears to work, must be a
      // button role.
      setRole('button');
    }
    document.addEventListener('keydown', setActiveElementOnTab);
    return () => {
      document.removeEventListener('keydown', setActiveElementOnTab);
    };
  }, []);
  const restProps = {
    ref,
    tabIndex: 0,
    // Role is only for VoiceOver
    role,
    'aria-hidden': role ? undefined : true,
    [createAttribute('focus-guard')]: '',
    style: HIDDEN_STYLES
  };
  return /*#__PURE__*/react.createElement("span", _extends({}, props, restProps));
});

const PortalContext = /*#__PURE__*/react.createContext(null);
const attr = /*#__PURE__*/createAttribute('portal');

/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */
function useFloatingPortalNode(_temp) {
  let {
    id,
    root
  } = _temp === void 0 ? {} : _temp;
  const [portalNode, setPortalNode] = react.useState(null);
  const uniqueId = useId();
  const portalContext = usePortalContext();
  const portalNodeRef = react.useRef(null);
  floating_ui_react_esm_index(() => {
    return () => {
      portalNode == null || portalNode.remove();
      // Allow the subsequent layout effects to create a new node on updates.
      // The portal node will still be cleaned up on unmount.
      // https://github.com/floating-ui/floating-ui/issues/2454
      queueMicrotask(() => {
        portalNodeRef.current = null;
      });
    };
  }, [portalNode]);
  floating_ui_react_esm_index(() => {
    if (portalNodeRef.current) return;
    const existingIdRoot = id ? document.getElementById(id) : null;
    if (!existingIdRoot) return;
    const subRoot = document.createElement('div');
    subRoot.id = uniqueId;
    subRoot.setAttribute(attr, '');
    existingIdRoot.appendChild(subRoot);
    portalNodeRef.current = subRoot;
    setPortalNode(subRoot);
  }, [id, uniqueId]);
  floating_ui_react_esm_index(() => {
    if (portalNodeRef.current) return;
    let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
    if (container && !isElement(container)) container = container.current;
    container = container || document.body;
    let idWrapper = null;
    if (id) {
      idWrapper = document.createElement('div');
      idWrapper.id = id;
      container.appendChild(idWrapper);
    }
    const subRoot = document.createElement('div');
    subRoot.id = uniqueId;
    subRoot.setAttribute(attr, '');
    container = idWrapper || container;
    container.appendChild(subRoot);
    portalNodeRef.current = subRoot;
    setPortalNode(subRoot);
  }, [id, root, uniqueId, portalContext]);
  return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */
function FloatingPortal(_ref) {
  let {
    children,
    id,
    root = null,
    preserveTabOrder = true
  } = _ref;
  const portalNode = useFloatingPortalNode({
    id,
    root
  });
  const [focusManagerState, setFocusManagerState] = react.useState(null);
  const beforeOutsideRef = react.useRef(null);
  const afterOutsideRef = react.useRef(null);
  const beforeInsideRef = react.useRef(null);
  const afterInsideRef = react.useRef(null);
  const shouldRenderGuards =
  // The FocusManager and therefore floating element are currently open/
  // rendered.
  !!focusManagerState &&
  // Guards are only for non-modal focus management.
  !focusManagerState.modal &&
  // Don't render if unmount is transitioning.
  focusManagerState.open && preserveTabOrder && !!(root || portalNode);

  // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
  react.useEffect(() => {
    if (!portalNode || !preserveTabOrder || focusManagerState != null && focusManagerState.modal) {
      return;
    }

    // Make sure elements inside the portal element are tabbable only when the
    // portal has already been focused, either by tabbing into a focus trap
    // element outside or using the mouse.
    function onFocus(event) {
      if (portalNode && isOutsideEvent(event)) {
        const focusing = event.type === 'focusin';
        const manageFocus = focusing ? enableFocusInside : disableFocusInside;
        manageFocus(portalNode);
      }
    }
    // Listen to the event on the capture phase so they run before the focus
    // trap elements onFocus prop is called.
    portalNode.addEventListener('focusin', onFocus, true);
    portalNode.addEventListener('focusout', onFocus, true);
    return () => {
      portalNode.removeEventListener('focusin', onFocus, true);
      portalNode.removeEventListener('focusout', onFocus, true);
    };
  }, [portalNode, preserveTabOrder, focusManagerState == null ? void 0 : focusManagerState.modal]);
  return /*#__PURE__*/react.createElement(PortalContext.Provider, {
    value: react.useMemo(() => ({
      preserveTabOrder,
      beforeOutsideRef,
      afterOutsideRef,
      beforeInsideRef,
      afterInsideRef,
      portalNode,
      setFocusManagerState
    }), [preserveTabOrder, portalNode])
  }, shouldRenderGuards && portalNode && /*#__PURE__*/react.createElement(FocusGuard, {
    "data-type": "outside",
    ref: beforeOutsideRef,
    onFocus: event => {
      if (isOutsideEvent(event, portalNode)) {
        var _beforeInsideRef$curr;
        (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
      } else {
        const prevTabbable = getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
        prevTabbable == null || prevTabbable.focus();
      }
    }
  }), shouldRenderGuards && portalNode && /*#__PURE__*/react.createElement("span", {
    "aria-owns": portalNode.id,
    style: HIDDEN_STYLES
  }), portalNode && /*#__PURE__*/(0,react_dom.createPortal)(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/react.createElement(FocusGuard, {
    "data-type": "outside",
    ref: afterOutsideRef,
    onFocus: event => {
      if (isOutsideEvent(event, portalNode)) {
        var _afterInsideRef$curre;
        (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
      } else {
        const nextTabbable = getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
        nextTabbable == null || nextTabbable.focus();
        (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null ? void 0 : focusManagerState.onOpenChange(false, event.nativeEvent));
      }
    }
  }));
}
const usePortalContext = () => react.useContext(PortalContext);

const LIST_LIMIT = 20;
let previouslyFocusedElements = [];
function addPreviouslyFocusedElement(element) {
  previouslyFocusedElements = previouslyFocusedElements.filter(el => el.isConnected);
  if (element && getNodeName(element) !== 'body') {
    previouslyFocusedElements.push(element);
    if (previouslyFocusedElements.length > LIST_LIMIT) {
      previouslyFocusedElements = previouslyFocusedElements.slice(-LIST_LIMIT);
    }
  }
}
function getPreviouslyFocusedElement() {
  return previouslyFocusedElements.slice().reverse().find(el => el.isConnected);
}
const VisuallyHiddenDismiss = /*#__PURE__*/react.forwardRef(function VisuallyHiddenDismiss(props, ref) {
  return /*#__PURE__*/react.createElement("button", _extends({}, props, {
    type: "button",
    ref: ref,
    tabIndex: -1,
    style: HIDDEN_STYLES
  }));
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */
function FloatingFocusManager(props) {
  const {
    context,
    children,
    disabled = false,
    order = ['content'],
    guards: _guards = true,
    initialFocus = 0,
    returnFocus = true,
    modal = true,
    visuallyHiddenDismiss = false,
    closeOnFocusOut = true
  } = props;
  const {
    open,
    refs,
    nodeId,
    onOpenChange,
    events,
    dataRef,
    elements: {
      domReference,
      floating
    }
  } = context;
  const ignoreInitialFocus = typeof initialFocus === 'number' && initialFocus < 0;
  // If the reference is a combobox and is typeable (e.g. input/textarea),
  // there are different focus semantics. The guards should not be rendered, but
  // aria-hidden should be applied to all nodes still. Further, the visually
  // hidden dismiss button should only appear at the end of the list, not the
  // start.
  const isUntrappedTypeableCombobox = isTypeableCombobox(domReference) && ignoreInitialFocus;

  // Force the guards to be rendered if the `inert` attribute is not supported.
  const guards = supportsInert() ? _guards : true;
  const orderRef = floating_ui_react_esm_useLatestRef(order);
  const initialFocusRef = floating_ui_react_esm_useLatestRef(initialFocus);
  const returnFocusRef = floating_ui_react_esm_useLatestRef(returnFocus);
  const tree = useFloatingTree();
  const portalContext = usePortalContext();
  const startDismissButtonRef = react.useRef(null);
  const endDismissButtonRef = react.useRef(null);
  const preventReturnFocusRef = react.useRef(false);
  const isPointerDownRef = react.useRef(false);
  const isInsidePortal = portalContext != null;
  const getTabbableContent = react.useCallback(function (container) {
    if (container === void 0) {
      container = floating;
    }
    return container ? tabbable(container, getTabbableOptions()) : [];
  }, [floating]);
  const getTabbableElements = react.useCallback(container => {
    const content = getTabbableContent(container);
    return orderRef.current.map(type => {
      if (domReference && type === 'reference') {
        return domReference;
      }
      if (floating && type === 'floating') {
        return floating;
      }
      return content;
    }).filter(Boolean).flat();
  }, [domReference, floating, orderRef, getTabbableContent]);
  react.useEffect(() => {
    if (disabled || !modal) return;
    function onKeyDown(event) {
      if (event.key === 'Tab') {
        // The focus guards have nothing to focus, so we need to stop the event.
        if (contains(floating, activeElement(getDocument(floating))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) {
          stopEvent(event);
        }
        const els = getTabbableElements();
        const target = getTarget(event);
        if (orderRef.current[0] === 'reference' && target === domReference) {
          stopEvent(event);
          if (event.shiftKey) {
            enqueueFocus(els[els.length - 1]);
          } else {
            enqueueFocus(els[1]);
          }
        }
        if (orderRef.current[1] === 'floating' && target === floating && event.shiftKey) {
          stopEvent(event);
          enqueueFocus(els[0]);
        }
      }
    }
    const doc = getDocument(floating);
    doc.addEventListener('keydown', onKeyDown);
    return () => {
      doc.removeEventListener('keydown', onKeyDown);
    };
  }, [disabled, domReference, floating, modal, orderRef, isUntrappedTypeableCombobox, getTabbableContent, getTabbableElements]);
  react.useEffect(() => {
    if (disabled || !closeOnFocusOut) return;

    // In Safari, buttons lose focus when pressing them.
    function handlePointerDown() {
      isPointerDownRef.current = true;
      setTimeout(() => {
        isPointerDownRef.current = false;
      });
    }
    function handleFocusOutside(event) {
      const relatedTarget = event.relatedTarget;
      queueMicrotask(() => {
        const movedToUnrelatedNode = !(contains(domReference, relatedTarget) || contains(floating, relatedTarget) || contains(relatedTarget, floating) || contains(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute(createAttribute('focus-guard')) || tree && (getChildren(tree.nodesRef.current, nodeId).find(node => {
          var _node$context, _node$context2;
          return contains((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || contains((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
        }) || getAncestors(tree.nodesRef.current, nodeId).find(node => {
          var _node$context3, _node$context4;
          return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
        })));

        // Focus did not move inside the floating tree, and there are no tabbable
        // portal guards to handle closing.
        if (relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current &&
        // Fix React 18 Strict Mode returnFocus due to double rendering.
        relatedTarget !== getPreviouslyFocusedElement()) {
          preventReturnFocusRef.current = true;
          onOpenChange(false, event);
        }
      });
    }
    if (floating && isHTMLElement(domReference)) {
      domReference.addEventListener('focusout', handleFocusOutside);
      domReference.addEventListener('pointerdown', handlePointerDown);
      !modal && floating.addEventListener('focusout', handleFocusOutside);
      return () => {
        domReference.removeEventListener('focusout', handleFocusOutside);
        domReference.removeEventListener('pointerdown', handlePointerDown);
        !modal && floating.removeEventListener('focusout', handleFocusOutside);
      };
    }
  }, [disabled, domReference, floating, modal, nodeId, tree, portalContext, onOpenChange, closeOnFocusOut]);
  react.useEffect(() => {
    var _portalContext$portal;
    if (disabled) return;

    // Don't hide portals nested within the parent portal.
    const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + createAttribute('portal') + "]")) || []);
    if (floating) {
      const insideElements = [floating, ...portalNodes, startDismissButtonRef.current, endDismissButtonRef.current, orderRef.current.includes('reference') || isUntrappedTypeableCombobox ? domReference : null].filter(x => x != null);
      const cleanup = modal || isUntrappedTypeableCombobox ? markOthers(insideElements, guards, !guards) : markOthers(insideElements);
      return () => {
        cleanup();
      };
    }
  }, [disabled, domReference, floating, modal, orderRef, portalContext, isUntrappedTypeableCombobox, guards]);
  floating_ui_react_esm_index(() => {
    if (disabled || !floating) return;
    const doc = getDocument(floating);
    const previouslyFocusedElement = activeElement(doc);

    // Wait for any layout effect state setters to execute to set `tabIndex`.
    queueMicrotask(() => {
      const focusableElements = getTabbableElements(floating);
      const initialFocusValue = initialFocusRef.current;
      const elToFocus = (typeof initialFocusValue === 'number' ? focusableElements[initialFocusValue] : initialFocusValue.current) || floating;
      const focusAlreadyInsideFloatingEl = contains(floating, previouslyFocusedElement);
      if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) {
        enqueueFocus(elToFocus, {
          preventScroll: elToFocus === floating
        });
      }
    });
  }, [disabled, open, floating, ignoreInitialFocus, getTabbableElements, initialFocusRef]);
  floating_ui_react_esm_index(() => {
    if (disabled || !floating) return;
    let preventReturnFocusScroll = false;
    const doc = getDocument(floating);
    const previouslyFocusedElement = activeElement(doc);
    const contextData = dataRef.current;
    addPreviouslyFocusedElement(previouslyFocusedElement);

    // Dismissing via outside press should always ignore `returnFocus` to
    // prevent unwanted scrolling.
    function onOpenChange(_ref) {
      let {
        reason,
        event,
        nested
      } = _ref;
      if (reason === 'escape-key' && refs.domReference.current) {
        addPreviouslyFocusedElement(refs.domReference.current);
      }
      if (reason === 'hover' && event.type === 'mouseleave') {
        preventReturnFocusRef.current = true;
      }
      if (reason !== 'outside-press') return;
      if (nested) {
        preventReturnFocusRef.current = false;
        preventReturnFocusScroll = true;
      } else {
        preventReturnFocusRef.current = !(isVirtualClick(event) || isVirtualPointerEvent(event));
      }
    }
    events.on('openchange', onOpenChange);
    return () => {
      events.off('openchange', onOpenChange);
      const activeEl = activeElement(doc);
      const isFocusInsideFloatingTree = contains(floating, activeEl) || tree && getChildren(tree.nodesRef.current, nodeId).some(node => {
        var _node$context5;
        return contains((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.floating, activeEl);
      });
      const shouldFocusReference = isFocusInsideFloatingTree || contextData.openEvent && ['click', 'mousedown'].includes(contextData.openEvent.type);
      if (shouldFocusReference && refs.domReference.current) {
        addPreviouslyFocusedElement(refs.domReference.current);
      }
      const returnElement = getPreviouslyFocusedElement();
      if (returnFocusRef.current && !preventReturnFocusRef.current && isHTMLElement(returnElement) && (
      // If the focus moved somewhere else after mount, avoid returning focus
      // since it likely entered a different element which should be
      // respected: https://github.com/floating-ui/floating-ui/issues/2607
      returnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) {
        enqueueFocus(returnElement, {
          // When dismissing nested floating elements, by the time the rAF has
          // executed, the menus will all have been unmounted. When they try
          // to get focused, the calls get ignored — leaving the root
          // reference focused as desired.
          cancelPrevious: false,
          preventScroll: preventReturnFocusScroll
        });
      }
    };
  }, [disabled, floating, returnFocusRef, dataRef, refs, events, tree, nodeId]);

  // Synchronize the `context` & `modal` value to the FloatingPortal context.
  // It will decide whether or not it needs to render its own guards.
  floating_ui_react_esm_index(() => {
    if (disabled || !portalContext) return;
    portalContext.setFocusManagerState({
      modal,
      closeOnFocusOut,
      open,
      onOpenChange,
      refs
    });
    return () => {
      portalContext.setFocusManagerState(null);
    };
  }, [disabled, portalContext, modal, open, onOpenChange, refs, closeOnFocusOut]);
  floating_ui_react_esm_index(() => {
    if (disabled || !floating || typeof MutationObserver !== 'function' || ignoreInitialFocus) {
      return;
    }
    const handleMutation = () => {
      const tabIndex = floating.getAttribute('tabindex');
      if (orderRef.current.includes('floating') || activeElement(getDocument(floating)) !== refs.domReference.current && getTabbableContent().length === 0) {
        if (tabIndex !== '0') {
          floating.setAttribute('tabindex', '0');
        }
      } else if (tabIndex !== '-1') {
        floating.setAttribute('tabindex', '-1');
      }
    };
    handleMutation();
    const observer = new MutationObserver(handleMutation);
    observer.observe(floating, {
      childList: true,
      subtree: true,
      attributes: true
    });
    return () => {
      observer.disconnect();
    };
  }, [disabled, floating, refs, orderRef, getTabbableContent, ignoreInitialFocus]);
  function renderDismissButton(location) {
    if (disabled || !visuallyHiddenDismiss || !modal) {
      return null;
    }
    return /*#__PURE__*/react.createElement(VisuallyHiddenDismiss, {
      ref: location === 'start' ? startDismissButtonRef : endDismissButtonRef,
      onClick: event => onOpenChange(false, event.nativeEvent)
    }, typeof visuallyHiddenDismiss === 'string' ? visuallyHiddenDismiss : 'Dismiss');
  }
  const shouldRenderGuards = !disabled && guards && (isInsidePortal || modal);
  return /*#__PURE__*/react.createElement(react.Fragment, null, shouldRenderGuards && /*#__PURE__*/react.createElement(FocusGuard, {
    "data-type": "inside",
    ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
    onFocus: event => {
      if (modal) {
        const els = getTabbableElements();
        enqueueFocus(order[0] === 'reference' ? els[0] : els[els.length - 1]);
      } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
        preventReturnFocusRef.current = false;
        if (isOutsideEvent(event, portalContext.portalNode)) {
          const nextTabbable = getNextTabbable() || domReference;
          nextTabbable == null || nextTabbable.focus();
        } else {
          var _portalContext$before;
          (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
        }
      }
    }
  }), !isUntrappedTypeableCombobox && renderDismissButton('start'), children, renderDismissButton('end'), shouldRenderGuards && /*#__PURE__*/react.createElement(FocusGuard, {
    "data-type": "inside",
    ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
    onFocus: event => {
      if (modal) {
        enqueueFocus(getTabbableElements()[0]);
      } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
        if (closeOnFocusOut) {
          preventReturnFocusRef.current = true;
        }
        if (isOutsideEvent(event, portalContext.portalNode)) {
          const prevTabbable = getPreviousTabbable() || domReference;
          prevTabbable == null || prevTabbable.focus();
        } else {
          var _portalContext$afterO;
          (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
        }
      }
    }
  }));
}

const activeLocks = /*#__PURE__*/new Set();
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */
const FloatingOverlay = /*#__PURE__*/react.forwardRef(function FloatingOverlay(_ref, ref) {
  let {
    lockScroll = false,
    ...rest
  } = _ref;
  const lockId = useId();
  floating_ui_react_esm_index(() => {
    if (!lockScroll) return;
    activeLocks.add(lockId);
    const isIOS = /iP(hone|ad|od)|iOS/.test(getPlatform());
    const bodyStyle = document.body.style;
    // RTL <body> scrollbar
    const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    const paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.pageXOffset;
    const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.pageYOffset;
    bodyStyle.overflow = 'hidden';
    if (scrollbarWidth) {
      bodyStyle[paddingProp] = scrollbarWidth + "px";
    }

    // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.
    if (isIOS) {
      var _window$visualViewpor, _window$visualViewpor2;
      // iOS 12 does not support `visualViewport`.
      const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
      const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
      Object.assign(bodyStyle, {
        position: 'fixed',
        top: -(scrollY - Math.floor(offsetTop)) + "px",
        left: -(scrollX - Math.floor(offsetLeft)) + "px",
        right: '0'
      });
    }
    return () => {
      activeLocks.delete(lockId);
      if (activeLocks.size === 0) {
        Object.assign(bodyStyle, {
          overflow: '',
          [paddingProp]: ''
        });
        if (isIOS) {
          Object.assign(bodyStyle, {
            position: '',
            top: '',
            left: '',
            right: ''
          });
          window.scrollTo(scrollX, scrollY);
        }
      }
    };
  }, [lockId, lockScroll]);
  return /*#__PURE__*/react.createElement("div", _extends({
    ref: ref
  }, rest, {
    style: {
      position: 'fixed',
      overflow: 'auto',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      ...rest.style
    }
  }));
});

function isButtonTarget(event) {
  return isHTMLElement(event.target) && event.target.tagName === 'BUTTON';
}
function isSpaceIgnored(element) {
  return isTypeableElement(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */
function useClick(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    dataRef,
    elements: {
      domReference
    }
  } = context;
  const {
    enabled = true,
    event: eventOption = 'click',
    toggle = true,
    ignoreMouse = false,
    keyboardHandlers = true
  } = props;
  const pointerTypeRef = react.useRef();
  const didKeyDownRef = react.useRef(false);
  return react.useMemo(() => {
    if (!enabled) return {};
    return {
      reference: {
        onPointerDown(event) {
          pointerTypeRef.current = event.pointerType;
        },
        onMouseDown(event) {
          // Ignore all buttons except for the "main" button.
          // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
          if (event.button !== 0) {
            return;
          }
          if (isMouseLikePointerType(pointerTypeRef.current, true) && ignoreMouse) {
            return;
          }
          if (eventOption === 'click') {
            return;
          }
          if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === 'mousedown' : true)) {
            onOpenChange(false, event.nativeEvent, 'click');
          } else {
            // Prevent stealing focus from the floating element
            event.preventDefault();
            onOpenChange(true, event.nativeEvent, 'click');
          }
        },
        onClick(event) {
          if (eventOption === 'mousedown' && pointerTypeRef.current) {
            pointerTypeRef.current = undefined;
            return;
          }
          if (isMouseLikePointerType(pointerTypeRef.current, true) && ignoreMouse) {
            return;
          }
          if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === 'click' : true)) {
            onOpenChange(false, event.nativeEvent, 'click');
          } else {
            onOpenChange(true, event.nativeEvent, 'click');
          }
        },
        onKeyDown(event) {
          pointerTypeRef.current = undefined;
          if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event)) {
            return;
          }
          if (event.key === ' ' && !isSpaceIgnored(domReference)) {
            // Prevent scrolling
            event.preventDefault();
            didKeyDownRef.current = true;
          }
          if (event.key === 'Enter') {
            if (open && toggle) {
              onOpenChange(false, event.nativeEvent, 'click');
            } else {
              onOpenChange(true, event.nativeEvent, 'click');
            }
          }
        },
        onKeyUp(event) {
          if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event) || isSpaceIgnored(domReference)) {
            return;
          }
          if (event.key === ' ' && didKeyDownRef.current) {
            didKeyDownRef.current = false;
            if (open && toggle) {
              onOpenChange(false, event.nativeEvent, 'click');
            } else {
              onOpenChange(true, event.nativeEvent, 'click');
            }
          }
        }
      }
    };
  }, [enabled, dataRef, eventOption, ignoreMouse, keyboardHandlers, domReference, toggle, open, onOpenChange]);
}

function createVirtualElement(domRef, data) {
  let offsetX = null;
  let offsetY = null;
  let isAutoUpdateEvent = false;
  return {
    contextElement: domRef.current || undefined,
    getBoundingClientRect() {
      var _domRef$current, _data$dataRef$current;
      const domRect = ((_domRef$current = domRef.current) == null ? void 0 : _domRef$current.getBoundingClientRect()) || {
        width: 0,
        height: 0,
        x: 0,
        y: 0
      };
      const isXAxis = data.axis === 'x' || data.axis === 'both';
      const isYAxis = data.axis === 'y' || data.axis === 'both';
      const canTrackCursorOnAutoUpdate = ['mouseenter', 'mousemove'].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || '') && data.pointerType !== 'touch';
      let width = domRect.width;
      let height = domRect.height;
      let x = domRect.x;
      let y = domRect.y;
      if (offsetX == null && data.x && isXAxis) {
        offsetX = domRect.x - data.x;
      }
      if (offsetY == null && data.y && isYAxis) {
        offsetY = domRect.y - data.y;
      }
      x -= offsetX || 0;
      y -= offsetY || 0;
      width = 0;
      height = 0;
      if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
        width = data.axis === 'y' ? domRect.width : 0;
        height = data.axis === 'x' ? domRect.height : 0;
        x = isXAxis && data.x != null ? data.x : x;
        y = isYAxis && data.y != null ? data.y : y;
      } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
        height = data.axis === 'x' ? domRect.height : height;
        width = data.axis === 'y' ? domRect.width : width;
      }
      isAutoUpdateEvent = true;
      return {
        width,
        height,
        x,
        y,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x
      };
    }
  };
}
function isMouseBasedEvent(event) {
  return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */
function useClientPoint(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    refs,
    dataRef,
    elements: {
      floating
    }
  } = context;
  const {
    enabled = true,
    axis = 'both',
    x = null,
    y = null
  } = props;
  const initialRef = react.useRef(false);
  const cleanupListenerRef = react.useRef(null);
  const [pointerType, setPointerType] = react.useState();
  const [reactive, setReactive] = react.useState([]);
  const setReference = useEffectEvent((x, y) => {
    if (initialRef.current) return;

    // Prevent setting if the open event was not a mouse-like one
    // (e.g. focus to open, then hover over the reference element).
    // Only apply if the event exists.
    if (dataRef.current.openEvent && !isMouseBasedEvent(dataRef.current.openEvent)) {
      return;
    }
    refs.setPositionReference(createVirtualElement(refs.domReference, {
      x,
      y,
      axis,
      dataRef,
      pointerType
    }));
  });
  const handleReferenceEnterOrMove = useEffectEvent(event => {
    if (x != null || y != null) return;
    if (!open) {
      setReference(event.clientX, event.clientY);
    } else if (!cleanupListenerRef.current) {
      // If there's no cleanup, there's no listener, but we want to ensure
      // we add the listener if the cursor landed on the floating element and
      // then back on the reference (i.e. it's interactive).
      setReactive([]);
    }
  });

  // If the pointer is a mouse-like pointer, we want to continue following the
  // mouse even if the floating element is transitioning out. On touch
  // devices, this is undesirable because the floating element will move to
  // the dismissal touch point.
  const openCheck = isMouseLikePointerType(pointerType) ? floating : open;
  const addListener = react.useCallback(() => {
    // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
    if (!openCheck || !enabled || x != null || y != null) return;
    const win = getWindow(refs.floating.current);
    function handleMouseMove(event) {
      const target = getTarget(event);
      if (!contains(refs.floating.current, target)) {
        setReference(event.clientX, event.clientY);
      } else {
        win.removeEventListener('mousemove', handleMouseMove);
        cleanupListenerRef.current = null;
      }
    }
    if (!dataRef.current.openEvent || isMouseBasedEvent(dataRef.current.openEvent)) {
      win.addEventListener('mousemove', handleMouseMove);
      const cleanup = () => {
        win.removeEventListener('mousemove', handleMouseMove);
        cleanupListenerRef.current = null;
      };
      cleanupListenerRef.current = cleanup;
      return cleanup;
    }
    refs.setPositionReference(refs.domReference.current);
  }, [dataRef, enabled, openCheck, refs, setReference, x, y]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: intentionally specifying `reactive`
  react.useEffect(() => {
    return addListener();
  }, [addListener, reactive]);
  react.useEffect(() => {
    if (enabled && !floating) {
      initialRef.current = false;
    }
  }, [enabled, floating]);
  react.useEffect(() => {
    if (!enabled && open) {
      initialRef.current = true;
    }
  }, [enabled, open]);
  floating_ui_react_esm_index(() => {
    if (enabled && (x != null || y != null)) {
      initialRef.current = false;
      setReference(x, y);
    }
  }, [enabled, x, y, setReference]);
  return react.useMemo(() => {
    if (!enabled) return {};
    function setPointerTypeRef(_ref) {
      let {
        pointerType
      } = _ref;
      setPointerType(pointerType);
    }
    return {
      reference: {
        onPointerDown: setPointerTypeRef,
        onPointerEnter: setPointerTypeRef,
        onMouseMove: handleReferenceEnterOrMove,
        onMouseEnter: handleReferenceEnterOrMove
      }
    };
  }, [enabled, handleReferenceEnterOrMove]);
}

const bubbleHandlerKeys = {
  pointerdown: 'onPointerDown',
  mousedown: 'onMouseDown',
  click: 'onClick'
};
const captureHandlerKeys = {
  pointerdown: 'onPointerDownCapture',
  mousedown: 'onMouseDownCapture',
  click: 'onClickCapture'
};
const normalizeProp = normalizable => {
  var _normalizable$escapeK, _normalizable$outside;
  return {
    escapeKey: typeof normalizable === 'boolean' ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
    outsidePress: typeof normalizable === 'boolean' ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
  };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */
function useDismiss(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    nodeId,
    elements: {
      reference,
      domReference,
      floating
    },
    dataRef
  } = context;
  const {
    enabled = true,
    escapeKey = true,
    outsidePress: unstable_outsidePress = true,
    outsidePressEvent = 'pointerdown',
    referencePress = false,
    referencePressEvent = 'pointerdown',
    ancestorScroll = false,
    bubbles,
    capture
  } = props;
  const tree = useFloatingTree();
  const outsidePressFn = useEffectEvent(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : () => false);
  const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
  const insideReactTreeRef = react.useRef(false);
  const endedOrStartedInsideRef = react.useRef(false);
  const {
    escapeKey: escapeKeyBubbles,
    outsidePress: outsidePressBubbles
  } = normalizeProp(bubbles);
  const {
    escapeKey: escapeKeyCapture,
    outsidePress: outsidePressCapture
  } = normalizeProp(capture);
  const closeOnEscapeKeyDown = useEffectEvent(event => {
    if (!open || !enabled || !escapeKey || event.key !== 'Escape') {
      return;
    }
    const children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
    if (!escapeKeyBubbles) {
      event.stopPropagation();
      if (children.length > 0) {
        let shouldDismiss = true;
        children.forEach(child => {
          var _child$context;
          if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
            shouldDismiss = false;
            return;
          }
        });
        if (!shouldDismiss) {
          return;
        }
      }
    }
    onOpenChange(false, isReactEvent(event) ? event.nativeEvent : event, 'escape-key');
  });
  const closeOnEscapeKeyDownCapture = useEffectEvent(event => {
    var _getTarget2;
    const callback = () => {
      var _getTarget;
      closeOnEscapeKeyDown(event);
      (_getTarget = getTarget(event)) == null || _getTarget.removeEventListener('keydown', callback);
    };
    (_getTarget2 = getTarget(event)) == null || _getTarget2.addEventListener('keydown', callback);
  });
  const closeOnPressOutside = useEffectEvent(event => {
    // Given developers can stop the propagation of the synthetic event,
    // we can only be confident with a positive value.
    const insideReactTree = insideReactTreeRef.current;
    insideReactTreeRef.current = false;

    // When click outside is lazy (`click` event), handle dragging.
    // Don't close if:
    // - The click started inside the floating element.
    // - The click ended inside the floating element.
    const endedOrStartedInside = endedOrStartedInsideRef.current;
    endedOrStartedInsideRef.current = false;
    if (outsidePressEvent === 'click' && endedOrStartedInside) {
      return;
    }
    if (insideReactTree) {
      return;
    }
    if (typeof outsidePress === 'function' && !outsidePress(event)) {
      return;
    }
    const target = getTarget(event);
    const inertSelector = "[" + createAttribute('inert') + "]";
    const markers = getDocument(floating).querySelectorAll(inertSelector);
    let targetRootAncestor = isElement(target) ? target : null;
    while (targetRootAncestor && !isLastTraversableNode(targetRootAncestor)) {
      const nextParent = getParentNode(targetRootAncestor);
      if (isLastTraversableNode(nextParent) || !isElement(nextParent)) {
        break;
      }
      targetRootAncestor = nextParent;
    }

    // Check if the click occurred on a third-party element injected after the
    // floating element rendered.
    if (markers.length && isElement(target) && !isRootElement(target) &&
    // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !contains(target, floating) &&
    // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(markers).every(marker => !contains(targetRootAncestor, marker))) {
      return;
    }

    // Check if the click occurred on the scrollbar
    if (isHTMLElement(target) && floating) {
      // In Firefox, `target.scrollWidth > target.clientWidth` for inline
      // elements.
      const canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
      const canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
      let xCond = canScrollY && event.offsetX > target.clientWidth;

      // In some browsers it is possible to change the <body> (or window)
      // scrollbar to the left side, but is very rare and is difficult to
      // check for. Plus, for modal dialogs with backdrops, it is more
      // important that the backdrop is checked but not so much the window.
      if (canScrollY) {
        const isRTL = floating_ui_utils_dom_getComputedStyle(target).direction === 'rtl';
        if (isRTL) {
          xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
        }
      }
      if (xCond || canScrollX && event.offsetY > target.clientHeight) {
        return;
      }
    }
    const targetIsInsideChildren = tree && getChildren(tree.nodesRef.current, nodeId).some(node => {
      var _node$context;
      return isEventTargetWithin(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
    });
    if (isEventTargetWithin(event, floating) || isEventTargetWithin(event, domReference) || targetIsInsideChildren) {
      return;
    }
    const children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
    if (children.length > 0) {
      let shouldDismiss = true;
      children.forEach(child => {
        var _child$context2;
        if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
          shouldDismiss = false;
          return;
        }
      });
      if (!shouldDismiss) {
        return;
      }
    }
    onOpenChange(false, event, 'outside-press');
  });
  const closeOnPressOutsideCapture = useEffectEvent(event => {
    var _getTarget4;
    const callback = () => {
      var _getTarget3;
      closeOnPressOutside(event);
      (_getTarget3 = getTarget(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
    };
    (_getTarget4 = getTarget(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
  });
  react.useEffect(() => {
    if (!open || !enabled) {
      return;
    }
    dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
    dataRef.current.__outsidePressBubbles = outsidePressBubbles;
    function onScroll(event) {
      onOpenChange(false, event, 'ancestor-scroll');
    }
    const doc = getDocument(floating);
    escapeKey && doc.addEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
    outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
    let ancestors = [];
    if (ancestorScroll) {
      if (isElement(domReference)) {
        ancestors = getOverflowAncestors(domReference);
      }
      if (isElement(floating)) {
        ancestors = ancestors.concat(getOverflowAncestors(floating));
      }
      if (!isElement(reference) && reference && reference.contextElement) {
        ancestors = ancestors.concat(getOverflowAncestors(reference.contextElement));
      }
    }

    // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
    ancestors = ancestors.filter(ancestor => {
      var _doc$defaultView;
      return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
    });
    ancestors.forEach(ancestor => {
      ancestor.addEventListener('scroll', onScroll, {
        passive: true
      });
    });
    return () => {
      escapeKey && doc.removeEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
      outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
      ancestors.forEach(ancestor => {
        ancestor.removeEventListener('scroll', onScroll);
      });
    };
  }, [dataRef, floating, domReference, reference, escapeKey, outsidePress, outsidePressEvent, open, onOpenChange, ancestorScroll, enabled, escapeKeyBubbles, outsidePressBubbles, closeOnEscapeKeyDown, escapeKeyCapture, closeOnEscapeKeyDownCapture, closeOnPressOutside, outsidePressCapture, closeOnPressOutsideCapture]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: intentional
  react.useEffect(() => {
    insideReactTreeRef.current = false;
  }, [outsidePress, outsidePressEvent]);
  return react.useMemo(() => {
    if (!enabled) {
      return {};
    }
    return {
      reference: {
        onKeyDown: closeOnEscapeKeyDown,
        [bubbleHandlerKeys[referencePressEvent]]: event => {
          if (referencePress) {
            onOpenChange(false, event.nativeEvent, 'reference-press');
          }
        }
      },
      floating: {
        onKeyDown: closeOnEscapeKeyDown,
        onMouseDown() {
          endedOrStartedInsideRef.current = true;
        },
        onMouseUp() {
          endedOrStartedInsideRef.current = true;
        },
        [captureHandlerKeys[outsidePressEvent]]: () => {
          insideReactTreeRef.current = true;
        }
      }
    };
  }, [enabled, referencePress, outsidePressEvent, referencePressEvent, onOpenChange, closeOnEscapeKeyDown]);
}

let devMessageSet;
if (false) {}

/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */
function floating_ui_react_esm_useFloating(options) {
  var _options$elements2;
  if (options === void 0) {
    options = {};
  }
  const {
    open = false,
    onOpenChange: unstable_onOpenChange,
    nodeId
  } = options;
  if (false) { var _devMessageSet2, _devMessageSet, _options$elements; }
  const [_domReference, setDomReference] = react.useState(null);
  const domReference = ((_options$elements2 = options.elements) == null ? void 0 : _options$elements2.reference) || _domReference;
  const position = useFloating(options);
  const tree = useFloatingTree();
  const nested = useFloatingParentNodeId() != null;
  const onOpenChange = useEffectEvent((open, event, reason) => {
    if (open) {
      dataRef.current.openEvent = event;
    }
    events.emit('openchange', {
      open,
      event,
      reason,
      nested
    });
    unstable_onOpenChange == null || unstable_onOpenChange(open, event, reason);
  });
  const domReferenceRef = react.useRef(null);
  const dataRef = react.useRef({});
  const events = react.useState(() => createPubSub())[0];
  const floatingId = useId();
  const setPositionReference = react.useCallback(node => {
    const positionReference = isElement(node) ? {
      getBoundingClientRect: () => node.getBoundingClientRect(),
      contextElement: node
    } : node;
    position.refs.setReference(positionReference);
  }, [position.refs]);
  const setReference = react.useCallback(node => {
    if (isElement(node) || node === null) {
      domReferenceRef.current = node;
      setDomReference(node);
    }

    // Backwards-compatibility for passing a virtual element to `reference`
    // after it has set the DOM reference.
    if (isElement(position.refs.reference.current) || position.refs.reference.current === null ||
    // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    node !== null && !isElement(node)) {
      position.refs.setReference(node);
    }
  }, [position.refs]);
  const refs = react.useMemo(() => ({
    ...position.refs,
    setReference,
    setPositionReference,
    domReference: domReferenceRef
  }), [position.refs, setReference, setPositionReference]);
  const elements = react.useMemo(() => ({
    ...position.elements,
    domReference: domReference
  }), [position.elements, domReference]);
  const context = react.useMemo(() => ({
    ...position,
    refs,
    elements,
    dataRef,
    nodeId,
    floatingId,
    events,
    open,
    onOpenChange
  }), [position, nodeId, floatingId, events, open, onOpenChange, refs, elements]);
  floating_ui_react_esm_index(() => {
    const node = tree == null ? void 0 : tree.nodesRef.current.find(node => node.id === nodeId);
    if (node) {
      node.context = context;
    }
  });
  return react.useMemo(() => ({
    ...position,
    context,
    refs,
    elements
  }), [position, refs, elements, context]);
}

/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */
function useFocus(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    events,
    refs,
    elements: {
      domReference
    }
  } = context;
  const {
    enabled = true,
    visibleOnly = true
  } = props;
  const blockFocusRef = react.useRef(false);
  const timeoutRef = react.useRef();
  const keyboardModalityRef = react.useRef(true);
  react.useEffect(() => {
    if (!enabled) {
      return;
    }
    const win = getWindow(domReference);

    // If the reference was focused and the user left the tab/window, and the
    // floating element was not open, the focus should be blocked when they
    // return to the tab/window.
    function onBlur() {
      if (!open && isHTMLElement(domReference) && domReference === activeElement(getDocument(domReference))) {
        blockFocusRef.current = true;
      }
    }
    function onKeyDown() {
      keyboardModalityRef.current = true;
    }
    win.addEventListener('blur', onBlur);
    win.addEventListener('keydown', onKeyDown, true);
    return () => {
      win.removeEventListener('blur', onBlur);
      win.removeEventListener('keydown', onKeyDown, true);
    };
  }, [domReference, open, enabled]);
  react.useEffect(() => {
    if (!enabled) {
      return;
    }
    function onOpenChange(_ref) {
      let {
        reason
      } = _ref;
      if (reason === 'reference-press' || reason === 'escape-key') {
        blockFocusRef.current = true;
      }
    }
    events.on('openchange', onOpenChange);
    return () => {
      events.off('openchange', onOpenChange);
    };
  }, [events, enabled]);
  react.useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);
  return react.useMemo(() => {
    if (!enabled) {
      return {};
    }
    return {
      reference: {
        onPointerDown(event) {
          if (isVirtualPointerEvent(event.nativeEvent)) return;
          keyboardModalityRef.current = false;
        },
        onMouseLeave() {
          blockFocusRef.current = false;
        },
        onFocus(event) {
          if (blockFocusRef.current) return;
          const target = getTarget(event.nativeEvent);
          if (visibleOnly && isElement(target)) {
            try {
              // Mac Safari unreliably matches `:focus-visible` on the reference
              // if focus was outside the page initially - use the fallback
              // instead.
              if (isSafari() && isMac()) throw Error();
              if (!target.matches(':focus-visible')) return;
            } catch (e) {
              // Old browsers will throw an error when using `:focus-visible`.
              if (!keyboardModalityRef.current && !isTypeableElement(target)) {
                return;
              }
            }
          }
          onOpenChange(true, event.nativeEvent, 'focus');
        },
        onBlur(event) {
          blockFocusRef.current = false;
          const relatedTarget = event.relatedTarget;

          // Hit the non-modal focus management portal guard. Focus will be
          // moved into the floating element immediately after.
          const movedToFocusGuard = isElement(relatedTarget) && relatedTarget.hasAttribute(createAttribute('focus-guard')) && relatedTarget.getAttribute('data-type') === 'outside';

          // Wait for the window blur listener to fire.
          timeoutRef.current = window.setTimeout(() => {
            const activeEl = activeElement(domReference ? domReference.ownerDocument : document);

            // Focus left the page, keep it open.
            if (!relatedTarget && activeEl === domReference) return;

            // When focusing the reference element (e.g. regular click), then
            // clicking into the floating element, prevent it from hiding.
            // Note: it must be focusable, e.g. `tabindex="-1"`.
            // We can not rely on relatedTarget to point to the correct element
            // as it will only point to the shadow host of the newly focused element
            // and not the element that actually has received focus if it is located
            // inside a shadow root.
            if (contains(refs.floating.current, activeEl) || contains(domReference, activeEl) || movedToFocusGuard) {
              return;
            }
            onOpenChange(false, event.nativeEvent, 'focus');
          });
        }
      }
    };
  }, [enabled, visibleOnly, domReference, refs, onOpenChange]);
}

const ACTIVE_KEY = 'active';
const SELECTED_KEY = 'selected';
function mergeProps(userProps, propsList, elementKey) {
  const map = new Map();
  const isItem = elementKey === 'item';
  let domUserProps = userProps;
  if (isItem && userProps) {
    const {
      [ACTIVE_KEY]: _,
      [SELECTED_KEY]: __,
      ...validProps
    } = userProps;
    domUserProps = validProps;
  }
  return {
    ...(elementKey === 'floating' && {
      tabIndex: -1
    }),
    ...domUserProps,
    ...propsList.map(value => {
      const propsOrGetProps = value ? value[elementKey] : null;
      if (typeof propsOrGetProps === 'function') {
        return userProps ? propsOrGetProps(userProps) : null;
      }
      return propsOrGetProps;
    }).concat(userProps).reduce((acc, props) => {
      if (!props) {
        return acc;
      }
      Object.entries(props).forEach(_ref => {
        let [key, value] = _ref;
        if (isItem && [ACTIVE_KEY, SELECTED_KEY].includes(key)) {
          return;
        }
        if (key.indexOf('on') === 0) {
          if (!map.has(key)) {
            map.set(key, []);
          }
          if (typeof value === 'function') {
            var _map$get;
            (_map$get = map.get(key)) == null || _map$get.push(value);
            acc[key] = function () {
              var _map$get2;
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map(fn => fn(...args)).find(val => val !== undefined);
            };
          }
        } else {
          acc[key] = value;
        }
      });
      return acc;
    }, {})
  };
}

/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */
function useInteractions(propsList) {
  if (propsList === void 0) {
    propsList = [];
  }
  // The dependencies are a dynamic array, so we can't use the linter's
  // suggestion to add it to the deps array.
  const deps = propsList;

  // biome-ignore lint/correctness/useExhaustiveDependencies: intentional
  const getReferenceProps = react.useCallback(userProps => mergeProps(userProps, propsList, 'reference'), deps);

  // biome-ignore lint/correctness/useExhaustiveDependencies: intentional
  const getFloatingProps = react.useCallback(userProps => mergeProps(userProps, propsList, 'floating'), deps);

  // biome-ignore lint/correctness/useExhaustiveDependencies: intentional
  const getItemProps = react.useCallback(userProps => mergeProps(userProps, propsList, 'item'),
  // Granularly check for `item` changes, because the `getItemProps` getter
  // should be as referentially stable as possible since it may be passed as
  // a prop to many components. All `item` key values must therefore be
  // memoized.
  propsList.map(key => key == null ? void 0 : key.item));
  return react.useMemo(() => ({
    getReferenceProps,
    getFloatingProps,
    getItemProps
  }), [getReferenceProps, getFloatingProps, getItemProps]);
}

let isPreventScrollSupported = false;
function doSwitch(orientation, vertical, horizontal) {
  switch (orientation) {
    case 'vertical':
      return vertical;
    case 'horizontal':
      return horizontal;
    default:
      return vertical || horizontal;
  }
}
function isMainOrientationKey(key, orientation) {
  const vertical = key === ARROW_UP || key === ARROW_DOWN;
  const horizontal = key === ARROW_LEFT || key === ARROW_RIGHT;
  return doSwitch(orientation, vertical, horizontal);
}
function isMainOrientationToEndKey(key, orientation, rtl) {
  const vertical = key === ARROW_DOWN;
  const horizontal = rtl ? key === ARROW_LEFT : key === ARROW_RIGHT;
  return doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key === ' ' || key === '';
}
function isCrossOrientationOpenKey(key, orientation, rtl) {
  const vertical = rtl ? key === ARROW_LEFT : key === ARROW_RIGHT;
  const horizontal = key === ARROW_DOWN;
  return doSwitch(orientation, vertical, horizontal);
}
function isCrossOrientationCloseKey(key, orientation, rtl) {
  const vertical = rtl ? key === ARROW_RIGHT : key === ARROW_LEFT;
  const horizontal = key === ARROW_UP;
  return doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */
function useListNavigation(context, props) {
  const {
    open,
    onOpenChange,
    refs,
    elements: {
      domReference,
      floating
    }
  } = context;
  const {
    listRef,
    activeIndex,
    onNavigate: unstable_onNavigate = () => {},
    enabled = true,
    selectedIndex = null,
    allowEscape = false,
    loop = false,
    nested = false,
    rtl = false,
    virtual = false,
    focusItemOnOpen = 'auto',
    focusItemOnHover = true,
    openOnArrowKeyDown = true,
    disabledIndices = undefined,
    orientation = 'vertical',
    cols = 1,
    scrollItemIntoView = true,
    virtualItemRef,
    itemSizes,
    dense = false
  } = props;
  if (false) {}
  const parentId = useFloatingParentNodeId();
  const tree = useFloatingTree();
  const onNavigate = useEffectEvent(unstable_onNavigate);
  const focusItemOnOpenRef = react.useRef(focusItemOnOpen);
  const indexRef = react.useRef(selectedIndex != null ? selectedIndex : -1);
  const keyRef = react.useRef(null);
  const isPointerModalityRef = react.useRef(true);
  const previousOnNavigateRef = react.useRef(onNavigate);
  const previousMountedRef = react.useRef(!!floating);
  const forceSyncFocus = react.useRef(false);
  const forceScrollIntoViewRef = react.useRef(false);
  const disabledIndicesRef = floating_ui_react_esm_useLatestRef(disabledIndices);
  const latestOpenRef = floating_ui_react_esm_useLatestRef(open);
  const scrollItemIntoViewRef = floating_ui_react_esm_useLatestRef(scrollItemIntoView);
  const [activeId, setActiveId] = react.useState();
  const [virtualId, setVirtualId] = react.useState();
  const focusItem = useEffectEvent(function (listRef, indexRef, forceScrollIntoView) {
    if (forceScrollIntoView === void 0) {
      forceScrollIntoView = false;
    }
    const item = listRef.current[indexRef.current];
    if (!item) return;
    if (virtual) {
      setActiveId(item.id);
      tree == null || tree.events.emit('virtualfocus', item);
      if (virtualItemRef) {
        virtualItemRef.current = item;
      }
    } else {
      enqueueFocus(item, {
        preventScroll: true,
        // Mac Safari does not move the virtual cursor unless the focus call
        // is sync. However, for the very first focus call, we need to wait
        // for the position to be ready in order to prevent unwanted
        // scrolling. This means the virtual cursor will not move to the first
        // item when first opening the floating element, but will on
        // subsequent calls. `preventScroll` is supported in modern Safari,
        // so we can use that instead.
        // iOS Safari must be async or the first item will not be focused.
        sync: isMac() && isSafari() ? isPreventScrollSupported || forceSyncFocus.current : false
      });
    }
    requestAnimationFrame(() => {
      const scrollIntoViewOptions = scrollItemIntoViewRef.current;
      const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
      if (shouldScrollIntoView) {
        // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
        // by all browsers.
        item.scrollIntoView == null || item.scrollIntoView(typeof scrollIntoViewOptions === 'boolean' ? {
          block: 'nearest',
          inline: 'nearest'
        } : scrollIntoViewOptions);
      }
    });
  });
  floating_ui_react_esm_index(() => {
    document.createElement('div').focus({
      get preventScroll() {
        isPreventScrollSupported = true;
        return false;
      }
    });
  }, []);

  // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
  // element. Also, reset `activeIndex` upon closing the floating element.
  floating_ui_react_esm_index(() => {
    if (!enabled) {
      return;
    }
    if (open && floating) {
      if (focusItemOnOpenRef.current && selectedIndex != null) {
        // Regardless of the pointer modality, we want to ensure the selected
        // item comes into view when the floating element is opened.
        forceScrollIntoViewRef.current = true;
        indexRef.current = selectedIndex;
        onNavigate(selectedIndex);
      }
    } else if (previousMountedRef.current) {
      // Since the user can specify `onNavigate` conditionally
      // (onNavigate: open ? setActiveIndex : setSelectedIndex),
      // we store and call the previous function.
      indexRef.current = -1;
      previousOnNavigateRef.current(null);
    }
  }, [enabled, open, floating, selectedIndex, onNavigate]);

  // Sync `activeIndex` to be the focused item while the floating element is
  // open.
  floating_ui_react_esm_index(() => {
    if (!enabled) {
      return;
    }
    if (open && floating) {
      if (activeIndex == null) {
        forceSyncFocus.current = false;
        if (selectedIndex != null) {
          return;
        }

        // Reset while the floating element was open (e.g. the list changed).
        if (previousMountedRef.current) {
          indexRef.current = -1;
          focusItem(listRef, indexRef);
        }

        // Initial sync.
        if (!previousMountedRef.current && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
          let runs = 0;
          const waitForListPopulated = () => {
            if (listRef.current[0] == null) {
              // Avoid letting the browser paint if possible on the first try,
              // otherwise use rAF. Don't try more than twice, since something
              // is wrong otherwise.
              if (runs < 2) {
                const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                scheduler(waitForListPopulated);
              }
              runs++;
            } else {
              indexRef.current = keyRef.current == null || isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? getMinIndex(listRef, disabledIndicesRef.current) : getMaxIndex(listRef, disabledIndicesRef.current);
              keyRef.current = null;
              onNavigate(indexRef.current);
            }
          };
          waitForListPopulated();
        }
      } else if (!isIndexOutOfBounds(listRef, activeIndex)) {
        indexRef.current = activeIndex;
        focusItem(listRef, indexRef, forceScrollIntoViewRef.current);
        forceScrollIntoViewRef.current = false;
      }
    }
  }, [enabled, open, floating, activeIndex, selectedIndex, nested, listRef, orientation, rtl, onNavigate, focusItem, disabledIndicesRef]);

  // Ensure the parent floating element has focus when a nested child closes
  // to allow arrow key navigation to work after the pointer leaves the child.
  floating_ui_react_esm_index(() => {
    var _nodes$find;
    if (!enabled || floating || !tree || virtual || !previousMountedRef.current) {
      return;
    }
    const nodes = tree.nodesRef.current;
    const parent = (_nodes$find = nodes.find(node => node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
    const activeEl = activeElement(getDocument(floating));
    const treeContainsActiveEl = nodes.some(node => node.context && contains(node.context.elements.floating, activeEl));
    if (parent && !treeContainsActiveEl && isPointerModalityRef.current) {
      parent.focus({
        preventScroll: true
      });
    }
  }, [enabled, floating, tree, parentId, virtual]);
  floating_ui_react_esm_index(() => {
    if (!enabled || !tree || !virtual || parentId) return;
    function handleVirtualFocus(item) {
      setVirtualId(item.id);
      if (virtualItemRef) {
        virtualItemRef.current = item;
      }
    }
    tree.events.on('virtualfocus', handleVirtualFocus);
    return () => {
      tree.events.off('virtualfocus', handleVirtualFocus);
    };
  }, [enabled, tree, virtual, parentId, virtualItemRef]);
  floating_ui_react_esm_index(() => {
    previousOnNavigateRef.current = onNavigate;
    previousMountedRef.current = !!floating;
  });
  floating_ui_react_esm_index(() => {
    if (!open) {
      keyRef.current = null;
    }
  }, [open]);
  const hasActiveIndex = activeIndex != null;
  const item = react.useMemo(() => {
    function syncCurrentTarget(currentTarget) {
      if (!open) return;
      const index = listRef.current.indexOf(currentTarget);
      if (index !== -1) {
        onNavigate(index);
      }
    }
    const props = {
      onFocus(_ref) {
        let {
          currentTarget
        } = _ref;
        syncCurrentTarget(currentTarget);
      },
      onClick: _ref2 => {
        let {
          currentTarget
        } = _ref2;
        return currentTarget.focus({
          preventScroll: true
        });
      },
      // Safari
      ...(focusItemOnHover && {
        onMouseMove(_ref3) {
          let {
            currentTarget
          } = _ref3;
          syncCurrentTarget(currentTarget);
        },
        onPointerLeave(_ref4) {
          let {
            pointerType
          } = _ref4;
          if (!isPointerModalityRef.current || pointerType === 'touch') {
            return;
          }
          indexRef.current = -1;
          focusItem(listRef, indexRef);
          onNavigate(null);
          if (!virtual) {
            enqueueFocus(refs.floating.current, {
              preventScroll: true
            });
          }
        }
      })
    };
    return props;
  }, [open, refs, focusItem, focusItemOnHover, listRef, onNavigate, virtual]);
  return react.useMemo(() => {
    if (!enabled) {
      return {};
    }
    const disabledIndices = disabledIndicesRef.current;
    function onKeyDown(event) {
      isPointerModalityRef.current = false;
      forceSyncFocus.current = true;

      // If the floating element is animating out, ignore navigation. Otherwise,
      // the `activeIndex` gets set to 0 despite not being open so the next time
      // the user ArrowDowns, the first item won't be focused.
      if (!latestOpenRef.current && event.currentTarget === refs.floating.current) {
        return;
      }
      if (nested && isCrossOrientationCloseKey(event.key, orientation, rtl)) {
        stopEvent(event);
        onOpenChange(false, event.nativeEvent, 'list-navigation');
        if (isHTMLElement(domReference) && !virtual) {
          domReference.focus();
        }
        return;
      }
      const currentIndex = indexRef.current;
      const minIndex = getMinIndex(listRef, disabledIndices);
      const maxIndex = getMaxIndex(listRef, disabledIndices);
      if (event.key === 'Home') {
        stopEvent(event);
        indexRef.current = minIndex;
        onNavigate(indexRef.current);
      }
      if (event.key === 'End') {
        stopEvent(event);
        indexRef.current = maxIndex;
        onNavigate(indexRef.current);
      }

      // Grid navigation.
      if (cols > 1) {
        const sizes = itemSizes || Array.from({
          length: listRef.current.length
        }, () => ({
          width: 1,
          height: 1
        }));
        // To calculate movements on the grid, we use hypothetical cell indices
        // as if every item was 1x1, then convert back to real indices.
        const cellMap = buildCellMap(sizes, cols, dense);
        const minGridIndex = cellMap.findIndex(index => index != null && !(disabledIndices != null && disabledIndices.includes(index)));
        // last enabled index
        const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex) => index != null && !(disabledIndices != null && disabledIndices.includes(index)) ? cellIndex : foundIndex, -1);
        indexRef.current = cellMap[getGridNavigatedIndex({
          current: cellMap.map(itemIndex => itemIndex != null ? listRef.current[itemIndex] : null)
        }, {
          event,
          orientation,
          loop,
          cols,
          // treat undefined (empty grid spaces) as disabled indices so we
          // don't end up in them
          disabledIndices: getCellIndices([...(disabledIndices || []), undefined], cellMap),
          minIndex: minGridIndex,
          maxIndex: maxGridIndex,
          prevIndex: getCellIndexOfCorner(indexRef.current, sizes, cellMap, cols,
          // use a corner matching the edge closest to the direction
          // we're moving in so we don't end up in the same item. Prefer
          // top/left over bottom/right.
          event.key === ARROW_DOWN ? 'bl' : event.key === ARROW_RIGHT ? 'tr' : 'tl'),
          stopEvent: true
        })]; // navigated cell will never be nullish

        onNavigate(indexRef.current);
        if (orientation === 'both') {
          return;
        }
      }
      if (isMainOrientationKey(event.key, orientation)) {
        stopEvent(event);

        // Reset the index if no item is focused.
        if (open && !virtual && activeElement(event.currentTarget.ownerDocument) === event.currentTarget) {
          indexRef.current = isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
          onNavigate(indexRef.current);
          return;
        }
        if (isMainOrientationToEndKey(event.key, orientation, rtl)) {
          if (loop) {
            indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : findNonDisabledIndex(listRef, {
              startingIndex: currentIndex,
              disabledIndices
            });
          } else {
            indexRef.current = Math.min(maxIndex, findNonDisabledIndex(listRef, {
              startingIndex: currentIndex,
              disabledIndices
            }));
          }
        } else {
          if (loop) {
            indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : findNonDisabledIndex(listRef, {
              startingIndex: currentIndex,
              decrement: true,
              disabledIndices
            });
          } else {
            indexRef.current = Math.max(minIndex, findNonDisabledIndex(listRef, {
              startingIndex: currentIndex,
              decrement: true,
              disabledIndices
            }));
          }
        }
        if (isIndexOutOfBounds(listRef, indexRef.current)) {
          onNavigate(null);
        } else {
          onNavigate(indexRef.current);
        }
      }
    }
    function checkVirtualMouse(event) {
      if (focusItemOnOpen === 'auto' && isVirtualClick(event.nativeEvent)) {
        focusItemOnOpenRef.current = true;
      }
    }
    function checkVirtualPointer(event) {
      // `pointerdown` fires first, reset the state then perform the checks.
      focusItemOnOpenRef.current = focusItemOnOpen;
      if (focusItemOnOpen === 'auto' && isVirtualPointerEvent(event.nativeEvent)) {
        focusItemOnOpenRef.current = true;
      }
    }
    const ariaActiveDescendantProp = virtual && open && hasActiveIndex && {
      'aria-activedescendant': virtualId || activeId
    };
    const activeItem = listRef.current.find(item => (item == null ? void 0 : item.id) === activeId);
    return {
      reference: {
        ...ariaActiveDescendantProp,
        onKeyDown(event) {
          isPointerModalityRef.current = false;
          const isArrowKey = event.key.indexOf('Arrow') === 0;
          const isCrossOpenKey = isCrossOrientationOpenKey(event.key, orientation, rtl);
          const isCrossCloseKey = isCrossOrientationCloseKey(event.key, orientation, rtl);
          const isMainKey = isMainOrientationKey(event.key, orientation);
          const isNavigationKey = (nested ? isCrossOpenKey : isMainKey) || event.key === 'Enter' || event.key.trim() === '';
          if (virtual && open) {
            const rootNode = tree == null ? void 0 : tree.nodesRef.current.find(node => node.parentId == null);
            const deepestNode = tree && rootNode ? getDeepestNode(tree.nodesRef.current, rootNode.id) : null;
            if (isArrowKey && deepestNode && virtualItemRef) {
              const eventObject = new KeyboardEvent('keydown', {
                key: event.key,
                bubbles: true
              });
              if (isCrossOpenKey || isCrossCloseKey) {
                var _deepestNode$context, _deepestNode$context2;
                const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? activeItem : null;
                if (dispatchItem) {
                  stopEvent(event);
                  dispatchItem.dispatchEvent(eventObject);
                  setVirtualId(undefined);
                }
              }
              if (isMainKey && deepestNode.context) {
                if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                  var _deepestNode$context$;
                  stopEvent(event);
                  (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                  return;
                }
              }
            }
            return onKeyDown(event);
          }

          // If a floating element should not open on arrow key down, avoid
          // setting `activeIndex` while it's closed.
          if (!open && !openOnArrowKeyDown && isArrowKey) {
            return;
          }
          if (isNavigationKey) {
            keyRef.current = nested && isMainKey ? null : event.key;
          }
          if (nested) {
            if (isCrossOpenKey) {
              stopEvent(event);
              if (open) {
                indexRef.current = getMinIndex(listRef, disabledIndices);
                onNavigate(indexRef.current);
              } else {
                onOpenChange(true, event.nativeEvent, 'list-navigation');
              }
            }
            return;
          }
          if (isMainKey) {
            if (selectedIndex != null) {
              indexRef.current = selectedIndex;
            }
            stopEvent(event);
            if (!open && openOnArrowKeyDown) {
              onOpenChange(true, event.nativeEvent, 'list-navigation');
            } else {
              onKeyDown(event);
            }
            if (open) {
              onNavigate(indexRef.current);
            }
          }
        },
        onFocus() {
          if (open) {
            onNavigate(null);
          }
        },
        onPointerDown: checkVirtualPointer,
        onMouseDown: checkVirtualMouse,
        onClick: checkVirtualMouse
      },
      floating: {
        'aria-orientation': orientation === 'both' ? undefined : orientation,
        ...(!isTypeableCombobox(domReference) && ariaActiveDescendantProp),
        onKeyDown,
        onPointerMove() {
          isPointerModalityRef.current = true;
        }
      },
      item
    };
  }, [domReference, refs, activeId, virtualId, disabledIndicesRef, latestOpenRef, listRef, enabled, orientation, rtl, virtual, open, hasActiveIndex, nested, selectedIndex, openOnArrowKeyDown, allowEscape, cols, loop, focusItemOnOpen, onNavigate, onOpenChange, item, tree, virtualItemRef, itemSizes, dense]);
}

const componentRoleToAriaRoleMap = /*#__PURE__*/new Map([['select', 'listbox'], ['combobox', 'listbox'], ['label', false]]);

/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */
function useRole(context, props) {
  var _componentRoleToAriaR;
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    floatingId
  } = context;
  const {
    enabled = true,
    role = 'dialog'
  } = props;
  const ariaRole = (_componentRoleToAriaR = componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
  const referenceId = useId();
  const parentId = useFloatingParentNodeId();
  const isNested = parentId != null;
  return react.useMemo(() => {
    if (!enabled) return {};
    const floatingProps = {
      id: floatingId,
      ...(ariaRole && {
        role: ariaRole
      })
    };
    if (ariaRole === 'tooltip' || role === 'label') {
      return {
        reference: {
          ["aria-" + (role === 'label' ? 'labelledby' : 'describedby')]: open ? floatingId : undefined
        },
        floating: floatingProps
      };
    }
    return {
      reference: {
        'aria-expanded': open ? 'true' : 'false',
        'aria-haspopup': ariaRole === 'alertdialog' ? 'dialog' : ariaRole,
        'aria-controls': open ? floatingId : undefined,
        ...(ariaRole === 'listbox' && {
          role: 'combobox'
        }),
        ...(ariaRole === 'menu' && {
          id: referenceId
        }),
        ...(ariaRole === 'menu' && isNested && {
          role: 'menuitem'
        }),
        ...(role === 'select' && {
          'aria-autocomplete': 'none'
        }),
        ...(role === 'combobox' && {
          'aria-autocomplete': 'list'
        })
      },
      floating: {
        ...floatingProps,
        ...(ariaRole === 'menu' && {
          'aria-labelledby': referenceId
        })
      },
      item(_ref) {
        let {
          active,
          selected
        } = _ref;
        const commonProps = {
          role: 'option',
          ...(active && {
            id: floatingId + "-option"
          })
        };

        // For `menu`, we are unable to tell if the item is a `menuitemradio`
        // or `menuitemcheckbox`. For backwards-compatibility reasons, also
        // avoid defaulting to `menuitem` as it may overwrite custom role props.
        switch (role) {
          case 'select':
            return {
              ...commonProps,
              'aria-selected': active && selected
            };
          case 'combobox':
            {
              return {
                ...commonProps,
                ...(active && {
                  'aria-selected': true
                })
              };
            }
        }
        return {};
      }
    };
  }, [enabled, role, ariaRole, open, floatingId, referenceId, isNested]);
}

// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const camelCaseToKebabCase = str => str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? '-' : '') + $.toLowerCase());
function execWithArgsOrReturn(valueOrFn, args) {
  return typeof valueOrFn === 'function' ? valueOrFn(args) : valueOrFn;
}
function useDelayUnmount(open, durationMs) {
  const [isMounted, setIsMounted] = react.useState(open);
  if (open && !isMounted) {
    setIsMounted(true);
  }
  react.useEffect(() => {
    if (!open) {
      const timeout = setTimeout(() => setIsMounted(false), durationMs);
      return () => clearTimeout(timeout);
    }
  }, [open, durationMs]);
  return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */
function useTransitionStatus(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    elements: {
      floating
    }
  } = context;
  const {
    duration = 250
  } = props;
  const isNumberDuration = typeof duration === 'number';
  const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
  const [initiated, setInitiated] = react.useState(false);
  const [status, setStatus] = react.useState('unmounted');
  const isMounted = useDelayUnmount(open, closeDuration);

  // `initiated` check prevents this `setState` call from breaking
  // <FloatingPortal />. This call is necessary to ensure subsequent opens
  // after the initial one allows the correct side animation to play when the
  // placement has changed.
  floating_ui_react_esm_index(() => {
    if (initiated && !isMounted) {
      setStatus('unmounted');
    }
  }, [initiated, isMounted]);
  floating_ui_react_esm_index(() => {
    if (!floating) return;
    if (open) {
      setStatus('initial');
      const frame = requestAnimationFrame(() => {
        setStatus('open');
      });
      return () => {
        cancelAnimationFrame(frame);
      };
    }
    setInitiated(true);
    setStatus('close');
  }, [open, floating]);
  return {
    isMounted,
    status
  };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */
function useTransitionStyles(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    initial: unstable_initial = {
      opacity: 0
    },
    open: unstable_open,
    close: unstable_close,
    common: unstable_common,
    duration = 250
  } = props;
  const placement = context.placement;
  const side = placement.split('-')[0];
  const fnArgs = react.useMemo(() => ({
    side,
    placement
  }), [side, placement]);
  const isNumberDuration = typeof duration === 'number';
  const openDuration = (isNumberDuration ? duration : duration.open) || 0;
  const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
  const [styles, setStyles] = react.useState(() => ({
    ...execWithArgsOrReturn(unstable_common, fnArgs),
    ...execWithArgsOrReturn(unstable_initial, fnArgs)
  }));
  const {
    isMounted,
    status
  } = useTransitionStatus(context, {
    duration
  });
  const initialRef = floating_ui_react_esm_useLatestRef(unstable_initial);
  const openRef = floating_ui_react_esm_useLatestRef(unstable_open);
  const closeRef = floating_ui_react_esm_useLatestRef(unstable_close);
  const commonRef = floating_ui_react_esm_useLatestRef(unstable_common);
  floating_ui_react_esm_index(() => {
    const initialStyles = execWithArgsOrReturn(initialRef.current, fnArgs);
    const closeStyles = execWithArgsOrReturn(closeRef.current, fnArgs);
    const commonStyles = execWithArgsOrReturn(commonRef.current, fnArgs);
    const openStyles = execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key) => {
      acc[key] = '';
      return acc;
    }, {});
    if (status === 'initial') {
      setStyles(styles => ({
        transitionProperty: styles.transitionProperty,
        ...commonStyles,
        ...initialStyles
      }));
    }
    if (status === 'open') {
      setStyles({
        transitionProperty: Object.keys(openStyles).map(camelCaseToKebabCase).join(','),
        transitionDuration: openDuration + "ms",
        ...commonStyles,
        ...openStyles
      });
    }
    if (status === 'close') {
      const styles = closeStyles || initialStyles;
      setStyles({
        transitionProperty: Object.keys(styles).map(camelCaseToKebabCase).join(','),
        transitionDuration: closeDuration + "ms",
        ...commonStyles,
        ...styles
      });
    }
  }, [closeDuration, closeRef, initialRef, openRef, commonRef, openDuration, status, fnArgs]);
  return {
    isMounted,
    styles
  };
}

/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */
function useTypeahead(context, props) {
  var _ref;
  const {
    open,
    dataRef
  } = context;
  const {
    listRef,
    activeIndex,
    onMatch: unstable_onMatch,
    onTypingChange: unstable_onTypingChange,
    enabled = true,
    findMatch = null,
    resetMs = 750,
    ignoreKeys = [],
    selectedIndex = null
  } = props;
  const timeoutIdRef = react.useRef();
  const stringRef = react.useRef('');
  const prevIndexRef = react.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
  const matchIndexRef = react.useRef(null);
  const onMatch = useEffectEvent(unstable_onMatch);
  const onTypingChange = useEffectEvent(unstable_onTypingChange);
  const findMatchRef = floating_ui_react_esm_useLatestRef(findMatch);
  const ignoreKeysRef = floating_ui_react_esm_useLatestRef(ignoreKeys);
  floating_ui_react_esm_index(() => {
    if (open) {
      clearTimeout(timeoutIdRef.current);
      matchIndexRef.current = null;
      stringRef.current = '';
    }
  }, [open]);
  floating_ui_react_esm_index(() => {
    // Sync arrow key navigation but not typeahead navigation.
    if (open && stringRef.current === '') {
      var _ref2;
      prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
    }
  }, [open, selectedIndex, activeIndex]);
  return react.useMemo(() => {
    if (!enabled) {
      return {};
    }
    function setTypingChange(value) {
      if (value) {
        if (!dataRef.current.typing) {
          dataRef.current.typing = value;
          onTypingChange(value);
        }
      } else {
        if (dataRef.current.typing) {
          dataRef.current.typing = value;
          onTypingChange(value);
        }
      }
    }
    function getMatchingIndex(list, orderedList, string) {
      const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find(text => (text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
      return str ? list.indexOf(str) : -1;
    }
    function onKeyDown(event) {
      const listContent = listRef.current;
      if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
        if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) {
          setTypingChange(false);
        } else if (event.key === ' ') {
          stopEvent(event);
        }
      }
      if (listContent == null || ignoreKeysRef.current.includes(event.key) ||
      // Character key.
      event.key.length !== 1 ||
      // Modifier key.
      event.ctrlKey || event.metaKey || event.altKey) {
        return;
      }
      if (open && event.key !== ' ') {
        stopEvent(event);
        setTypingChange(true);
      }

      // Bail out if the list contains a word like "llama" or "aaron". TODO:
      // allow it in this case, too.
      const allowRapidSuccessionOfFirstLetter = listContent.every(text => {
        var _text$, _text$2;
        return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
      });

      // Allows the user to cycle through items that start with the same letter
      // in rapid succession.
      if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
        stringRef.current = '';
        prevIndexRef.current = matchIndexRef.current;
      }
      stringRef.current += event.key;
      clearTimeout(timeoutIdRef.current);
      timeoutIdRef.current = setTimeout(() => {
        stringRef.current = '';
        prevIndexRef.current = matchIndexRef.current;
        setTypingChange(false);
      }, resetMs);
      const prevIndex = prevIndexRef.current;
      const index = getMatchingIndex(listContent, [...listContent.slice((prevIndex || 0) + 1), ...listContent.slice(0, (prevIndex || 0) + 1)], stringRef.current);
      if (index !== -1) {
        onMatch(index);
        matchIndexRef.current = index;
      } else if (event.key !== ' ') {
        stringRef.current = '';
        setTypingChange(false);
      }
    }
    return {
      reference: {
        onKeyDown
      },
      floating: {
        onKeyDown,
        onKeyUp(event) {
          if (event.key === ' ') {
            setTypingChange(false);
          }
        }
      }
    };
  }, [enabled, open, dataRef, listRef, resetMs, ignoreKeysRef, findMatchRef, onMatch, onTypingChange]);
}

function getArgsWithCustomFloatingHeight(state, height) {
  return {
    ...state,
    rects: {
      ...state.rects,
      floating: {
        ...state.rects.floating,
        height
      }
    }
  };
}
/**
 * Positions the floating element such that an inner element inside
 * of it is anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 */
const inner = props => ({
  name: 'inner',
  options: props,
  async fn(state) {
    const {
      listRef,
      overflowRef,
      onFallbackChange,
      offset: innerOffset = 0,
      index = 0,
      minItemsVisible = 4,
      referenceOverflowThreshold = 0,
      scrollRef,
      ...detectOverflowOptions
    } = props;
    const {
      rects,
      elements: {
        floating
      }
    } = state;
    const item = listRef.current[index];
    if (false) {}
    if (!item) {
      return {};
    }
    const nextArgs = {
      ...state,
      ...(await offset(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state))
    };
    const el = (scrollRef == null ? void 0 : scrollRef.current) || floating;
    const overflow = await detectOverflow(getArgsWithCustomFloatingHeight(nextArgs, el.scrollHeight), detectOverflowOptions);
    const refOverflow = await detectOverflow(nextArgs, {
      ...detectOverflowOptions,
      elementContext: 'reference'
    });
    const diffY = Math.max(0, overflow.top);
    const nextY = nextArgs.y + diffY;
    const maxHeight = Math.max(0, el.scrollHeight - diffY - Math.max(0, overflow.bottom));
    el.style.maxHeight = maxHeight + "px";
    el.scrollTop = diffY;

    // There is not enough space, fallback to standard anchored positioning
    if (onFallbackChange) {
      if (el.offsetHeight < item.offsetHeight * Math.min(minItemsVisible, listRef.current.length - 1) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold) {
        (0,react_dom.flushSync)(() => onFallbackChange(true));
      } else {
        (0,react_dom.flushSync)(() => onFallbackChange(false));
      }
    }
    if (overflowRef) {
      overflowRef.current = await detectOverflow(getArgsWithCustomFloatingHeight({
        ...nextArgs,
        y: nextY
      }, el.offsetHeight), detectOverflowOptions);
    }
    return {
      y: nextY
    };
  }
});
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 */
function useInnerOffset(context, props) {
  const {
    open,
    elements
  } = context;
  const {
    enabled = true,
    overflowRef,
    scrollRef,
    onChange: unstable_onChange
  } = props;
  const onChange = useEffectEvent(unstable_onChange);
  const controlledScrollingRef = react.useRef(false);
  const prevScrollTopRef = react.useRef(null);
  const initialOverflowRef = react.useRef(null);
  react.useEffect(() => {
    if (!enabled) {
      return;
    }
    function onWheel(e) {
      if (e.ctrlKey || !el || overflowRef.current == null) {
        return;
      }
      const dY = e.deltaY;
      const isAtTop = overflowRef.current.top >= -0.5;
      const isAtBottom = overflowRef.current.bottom >= -0.5;
      const remainingScroll = el.scrollHeight - el.clientHeight;
      const sign = dY < 0 ? -1 : 1;
      const method = dY < 0 ? 'max' : 'min';
      if (el.scrollHeight <= el.clientHeight) {
        return;
      }
      if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
        e.preventDefault();
        (0,react_dom.flushSync)(() => {
          onChange(d => d + Math[method](dY, remainingScroll * sign));
        });
      } else if (/firefox/i.test(getUserAgent())) {
        // Needed to propagate scrolling during momentum scrolling phase once
        // it gets limited by the boundary. UX improvement, not critical.
        el.scrollTop += dY;
      }
    }
    const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
    if (open && el) {
      el.addEventListener('wheel', onWheel);

      // Wait for the position to be ready.
      requestAnimationFrame(() => {
        prevScrollTopRef.current = el.scrollTop;
        if (overflowRef.current != null) {
          initialOverflowRef.current = {
            ...overflowRef.current
          };
        }
      });
      return () => {
        prevScrollTopRef.current = null;
        initialOverflowRef.current = null;
        el.removeEventListener('wheel', onWheel);
      };
    }
  }, [enabled, open, elements.floating, overflowRef, scrollRef, onChange]);
  return react.useMemo(() => {
    if (!enabled) {
      return {};
    }
    return {
      floating: {
        onKeyDown() {
          controlledScrollingRef.current = true;
        },
        onWheel() {
          controlledScrollingRef.current = false;
        },
        onPointerMove() {
          controlledScrollingRef.current = false;
        },
        onScroll() {
          const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
          if (!overflowRef.current || !el || !controlledScrollingRef.current) {
            return;
          }
          if (prevScrollTopRef.current !== null) {
            const scrollDiff = el.scrollTop - prevScrollTopRef.current;
            if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) {
              (0,react_dom.flushSync)(() => onChange(d => d + scrollDiff));
            }
          }

          // [Firefox] Wait for the height change to have been applied.
          requestAnimationFrame(() => {
            prevScrollTopRef.current = el.scrollTop;
          });
        }
      }
    };
  }, [enabled, overflowRef, elements.floating, scrollRef, onChange]);
}

function isPointInPolygon(point, polygon) {
  const [x, y] = point;
  let isInside = false;
  const length = polygon.length;
  for (let i = 0, j = length - 1; i < length; j = i++) {
    const [xi, yi] = polygon[i] || [0, 0];
    const [xj, yj] = polygon[j] || [0, 0];
    const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
    if (intersect) {
      isInside = !isInside;
    }
  }
  return isInside;
}
function isInside(point, rect) {
  return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */
function safePolygon(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    buffer = 0.5,
    blockPointerEvents = false,
    requireIntent = true
  } = options;
  let timeoutId;
  let hasLanded = false;
  let lastX = null;
  let lastY = null;
  let lastCursorTime = performance.now();
  function getCursorSpeed(x, y) {
    const currentTime = performance.now();
    const elapsedTime = currentTime - lastCursorTime;
    if (lastX === null || lastY === null || elapsedTime === 0) {
      lastX = x;
      lastY = y;
      lastCursorTime = currentTime;
      return null;
    }
    const deltaX = x - lastX;
    const deltaY = y - lastY;
    const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
    const speed = distance / elapsedTime; // px / ms

    lastX = x;
    lastY = y;
    lastCursorTime = currentTime;
    return speed;
  }
  const fn = _ref => {
    let {
      x,
      y,
      placement,
      elements,
      onClose,
      nodeId,
      tree
    } = _ref;
    return function onMouseMove(event) {
      function close() {
        clearTimeout(timeoutId);
        onClose();
      }
      clearTimeout(timeoutId);
      if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) {
        return;
      }
      const {
        clientX,
        clientY
      } = event;
      const clientPoint = [clientX, clientY];
      const target = getTarget(event);
      const isLeave = event.type === 'mouseleave';
      const isOverFloatingEl = contains(elements.floating, target);
      const isOverReferenceEl = contains(elements.domReference, target);
      const refRect = elements.domReference.getBoundingClientRect();
      const rect = elements.floating.getBoundingClientRect();
      const side = placement.split('-')[0];
      const cursorLeaveFromRight = x > rect.right - rect.width / 2;
      const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
      const isOverReferenceRect = isInside(clientPoint, refRect);
      const isFloatingWider = rect.width > refRect.width;
      const isFloatingTaller = rect.height > refRect.height;
      const left = (isFloatingWider ? refRect : rect).left;
      const right = (isFloatingWider ? refRect : rect).right;
      const top = (isFloatingTaller ? refRect : rect).top;
      const bottom = (isFloatingTaller ? refRect : rect).bottom;
      if (isOverFloatingEl) {
        hasLanded = true;
        if (!isLeave) {
          return;
        }
      }
      if (isOverReferenceEl) {
        hasLanded = false;
      }
      if (isOverReferenceEl && !isLeave) {
        hasLanded = true;
        return;
      }

      // Prevent overlapping floating element from being stuck in an open-close
      // loop: https://github.com/floating-ui/floating-ui/issues/1910
      if (isLeave && isElement(event.relatedTarget) && contains(elements.floating, event.relatedTarget)) {
        return;
      }

      // If any nested child is open, abort.
      if (tree && getChildren(tree.nodesRef.current, nodeId).some(_ref2 => {
        let {
          context
        } = _ref2;
        return context == null ? void 0 : context.open;
      })) {
        return;
      }

      // If the pointer is leaving from the opposite side, the "buffer" logic
      // creates a point where the floating element remains open, but should be
      // ignored.
      // A constant of 1 handles floating point rounding errors.
      if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) {
        return close();
      }

      // Ignore when the cursor is within the rectangular trough between the
      // two elements. Since the triangle is created from the cursor point,
      // which can start beyond the ref element's edge, traversing back and
      // forth from the ref to the floating element can cause it to close. This
      // ensures it always remains open in that case.
      let rectPoly = [];
      switch (side) {
        case 'top':
          rectPoly = [[left, refRect.top + 1], [left, rect.bottom - 1], [right, rect.bottom - 1], [right, refRect.top + 1]];
          break;
        case 'bottom':
          rectPoly = [[left, rect.top + 1], [left, refRect.bottom - 1], [right, refRect.bottom - 1], [right, rect.top + 1]];
          break;
        case 'left':
          rectPoly = [[rect.right - 1, bottom], [rect.right - 1, top], [refRect.left + 1, top], [refRect.left + 1, bottom]];
          break;
        case 'right':
          rectPoly = [[refRect.right - 1, bottom], [refRect.right - 1, top], [rect.left + 1, top], [rect.left + 1, bottom]];
          break;
      }
      function getPolygon(_ref3) {
        let [x, y] = _ref3;
        switch (side) {
          case 'top':
            {
              const cursorPointOne = [isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y + buffer + 1];
              const cursorPointTwo = [isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y + buffer + 1];
              const commonPoints = [[rect.left, cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top], [rect.right, cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer]];
              return [cursorPointOne, cursorPointTwo, ...commonPoints];
            }
          case 'bottom':
            {
              const cursorPointOne = [isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y - buffer];
              const cursorPointTwo = [isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y - buffer];
              const commonPoints = [[rect.left, cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom], [rect.right, cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer]];
              return [cursorPointOne, cursorPointTwo, ...commonPoints];
            }
          case 'left':
            {
              const cursorPointOne = [x + buffer + 1, isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const cursorPointTwo = [x + buffer + 1, isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const commonPoints = [[cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left, rect.top], [cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer, rect.bottom]];
              return [...commonPoints, cursorPointOne, cursorPointTwo];
            }
          case 'right':
            {
              const cursorPointOne = [x - buffer, isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const cursorPointTwo = [x - buffer, isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const commonPoints = [[cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right, rect.top], [cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer, rect.bottom]];
              return [cursorPointOne, cursorPointTwo, ...commonPoints];
            }
        }
      }
      if (isPointInPolygon([clientX, clientY], rectPoly)) {
        return;
      }
      if (hasLanded && !isOverReferenceRect) {
        return close();
      }
      if (!isLeave && requireIntent) {
        const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
        const cursorSpeedThreshold = 0.1;
        if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) {
          return close();
        }
      }
      if (!isPointInPolygon([clientX, clientY], getPolygon([x, y]))) {
        close();
      } else if (!hasLanded && requireIntent) {
        timeoutId = window.setTimeout(close, 40);
      }
    };
  };
  fn.__options = {
    blockPointerEvents
  };
  return fn;
}




/***/ }),

/***/ 32692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52543);
/* harmony import */ var _Fade__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73637);







var styles = {
  /* Styles applied to the root element. */
  root: {
    // Improve scrollable dialog support.
    zIndex: -1,
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent'
  },

  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: 'transparent'
  }
};
var Backdrop = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Backdrop(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$invisible = props.invisible,
      invisible = _props$invisible === void 0 ? false : _props$invisible,
      open = props.open,
      transitionDuration = props.transitionDuration,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? _Fade__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z : _props$TransitionComp,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["children", "classes", "className", "invisible", "open", "transitionDuration", "TransitionComponent"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(TransitionComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    in: open,
    timeout: transitionDuration
  }, other), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, className, invisible && classes.invisible),
    "aria-hidden": true,
    ref: ref
  }, children));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(styles, {
  name: 'MuiBackdrop'
})(Backdrop));

/***/ }),

/***/ 73637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97685);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98885);
/* harmony import */ var _styles_transitions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43366);
/* harmony import */ var _styles_useTheme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8920);
/* harmony import */ var _transitions_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5653);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17294);










var styles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};
var defaultTimeout = {
  enter: _styles_transitions__WEBPACK_IMPORTED_MODULE_1__/* .duration.enteringScreen */ .x9.enteringScreen,
  exit: _styles_transitions__WEBPACK_IMPORTED_MODULE_1__/* .duration.leavingScreen */ .x9.leavingScreen
};
/**
 * The Fade transition is used by the [Modal](/components/modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Fade = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Fade(props, ref) {
  var children = props.children,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? react_transition_group__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP : _props$TransitionComp,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "TransitionComponent", "timeout"]);

  var theme = (0,_styles_useTheme__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  var foreignRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(children.ref, ref);
  var handleRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEntering = normalizedTransitionCallback(onEntering);
  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_7__/* .reflow */ .n)(node); // So the animation always start from the start.

    var transitionProps = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_7__/* .getTransitionProps */ .C)({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var transitionProps = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_7__/* .getTransitionProps */ .C)({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(TransitionComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
    appear: true,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    timeout: timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
      style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        opacity: 0,
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, styles[state], style, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Fade);

/***/ }),

/***/ 5566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Modal_Modal; }
});

// UNUSED EXPORTS: styles

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/useTheme/useTheme.js
var useTheme = __webpack_require__(159);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/getThemeProps/getThemeProps.js
var getThemeProps = __webpack_require__(93869);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerDocument.js
var ownerDocument = __webpack_require__(30626);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Portal/Portal.js
var Portal = __webpack_require__(76234);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createChainedFunction.js
var createChainedFunction = __webpack_require__(42959);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(17294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useEventCallback.js
var useEventCallback = __webpack_require__(55192);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/zIndex.js
var zIndex = __webpack_require__(92781);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(74902);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/getScrollbarSize.js
var getScrollbarSize = __webpack_require__(75840);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerWindow.js
var ownerWindow = __webpack_require__(80713);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Modal/ModalManager.js





 // Is a vertical scrollbar displayed?

function isOverflowing(container) {
  var doc = (0,ownerDocument/* default */.Z)(container);

  if (doc.body === container) {
    return (0,ownerWindow/* default */.Z)(doc).innerWidth > doc.documentElement.clientWidth;
  }

  return container.scrollHeight > container.clientHeight;
}

function ariaHidden(node, show) {
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function getPaddingRight(node) {
  return parseInt(window.getComputedStyle(node)['padding-right'], 10) || 0;
}

function ariaHiddenSiblings(container, mountNode, currentNode) {
  var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var show = arguments.length > 4 ? arguments[4] : undefined;
  var blacklist = [mountNode, currentNode].concat((0,toConsumableArray/* default */.Z)(nodesToExclude));
  var blacklistTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE'];
  [].forEach.call(container.children, function (node) {
    if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) {
      ariaHidden(node, show);
    }
  });
}

function findIndexOf(containerInfo, callback) {
  var idx = -1;
  containerInfo.some(function (item, index) {
    if (callback(item)) {
      idx = index;
      return true;
    }

    return false;
  });
  return idx;
}

function handleContainer(containerInfo, props) {
  var restoreStyle = [];
  var restorePaddings = [];
  var container = containerInfo.container;
  var fixedNodes;

  if (!props.disableScrollLock) {
    if (isOverflowing(container)) {
      // Compute the size before applying overflow hidden to avoid any scroll jumps.
      var scrollbarSize = (0,getScrollbarSize/* default */.Z)();
      restoreStyle.push({
        value: container.style.paddingRight,
        key: 'padding-right',
        el: container
      }); // Use computed style, here to get the real padding to add our scrollbar width.

      container.style['padding-right'] = "".concat(getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.

      fixedNodes = (0,ownerDocument/* default */.Z)(container).querySelectorAll('.mui-fixed');
      [].forEach.call(fixedNodes, function (node) {
        restorePaddings.push(node.style.paddingRight);
        node.style.paddingRight = "".concat(getPaddingRight(node) + scrollbarSize, "px");
      });
    } // Improve Gatsby support
    // https://css-tricks.com/snippets/css/force-vertical-scrollbar/


    var parent = container.parentElement;
    var scrollContainer = parent.nodeName === 'HTML' && window.getComputedStyle(parent)['overflow-y'] === 'scroll' ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
    // screensize shrink.

    restoreStyle.push({
      value: scrollContainer.style.overflow,
      key: 'overflow',
      el: scrollContainer
    });
    scrollContainer.style.overflow = 'hidden';
  }

  var restore = function restore() {
    if (fixedNodes) {
      [].forEach.call(fixedNodes, function (node, i) {
        if (restorePaddings[i]) {
          node.style.paddingRight = restorePaddings[i];
        } else {
          node.style.removeProperty('padding-right');
        }
      });
    }

    restoreStyle.forEach(function (_ref) {
      var value = _ref.value,
          el = _ref.el,
          key = _ref.key;

      if (value) {
        el.style.setProperty(key, value);
      } else {
        el.style.removeProperty(key);
      }
    });
  };

  return restore;
}

function getHiddenSiblings(container) {
  var hiddenSiblings = [];
  [].forEach.call(container.children, function (node) {
    if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
      hiddenSiblings.push(node);
    }
  });
  return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */


var ModalManager = /*#__PURE__*/function () {
  function ModalManager() {
    (0,classCallCheck/* default */.Z)(this, ModalManager);

    // this.modals[modalIndex] = modal
    this.modals = []; // this.containers[containerIndex] = {
    //   modals: [],
    //   container,
    //   restore: null,
    // }

    this.containers = [];
  }

  (0,createClass/* default */.Z)(ModalManager, [{
    key: "add",
    value: function add(modal, container) {
      var modalIndex = this.modals.indexOf(modal);

      if (modalIndex !== -1) {
        return modalIndex;
      }

      modalIndex = this.modals.length;
      this.modals.push(modal); // If the modal we are adding is already in the DOM.

      if (modal.modalRef) {
        ariaHidden(modal.modalRef, false);
      }

      var hiddenSiblingNodes = getHiddenSiblings(container);
      ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.container === container;
      });

      if (containerIndex !== -1) {
        this.containers[containerIndex].modals.push(modal);
        return modalIndex;
      }

      this.containers.push({
        modals: [modal],
        container: container,
        restore: null,
        hiddenSiblingNodes: hiddenSiblingNodes
      });
      return modalIndex;
    }
  }, {
    key: "mount",
    value: function mount(modal, props) {
      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var containerInfo = this.containers[containerIndex];

      if (!containerInfo.restore) {
        containerInfo.restore = handleContainer(containerInfo, props);
      }
    }
  }, {
    key: "remove",
    value: function remove(modal) {
      var modalIndex = this.modals.indexOf(modal);

      if (modalIndex === -1) {
        return modalIndex;
      }

      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var containerInfo = this.containers[containerIndex];
      containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
      this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.

      if (containerInfo.modals.length === 0) {
        // The modal might be closed before it had the chance to be mounted in the DOM.
        if (containerInfo.restore) {
          containerInfo.restore();
        }

        if (modal.modalRef) {
          // In case the modal wasn't in the DOM yet.
          ariaHidden(modal.modalRef, true);
        }

        ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
        this.containers.splice(containerIndex, 1);
      } else {
        // Otherwise make sure the next top modal is visible to a screen reader.
        var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
        // aria-hidden because the dom element doesn't exist either
        // when modal was unmounted before modalRef gets null

        if (nextTop.modalRef) {
          ariaHidden(nextTop.modalRef, false);
        }
      }

      return modalIndex;
    }
  }, {
    key: "isTopModal",
    value: function isTopModal(modal) {
      return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
  }]);

  return ModalManager;
}();


;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Unstable_TrapFocus/Unstable_TrapFocus.js
/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex, camelcase */






/**
 * Utility component that locks focus inside the component.
 */

function Unstable_TrapFocus(props) {
  var children = props.children,
      _props$disableAutoFoc = props.disableAutoFocus,
      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$disableEnforce = props.disableEnforceFocus,
      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
      _props$disableRestore = props.disableRestoreFocus,
      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
      getDoc = props.getDoc,
      isEnabled = props.isEnabled,
      open = props.open;
  var ignoreNextEnforceFocus = react.useRef();
  var sentinelStart = react.useRef(null);
  var sentinelEnd = react.useRef(null);
  var nodeToRestore = react.useRef();
  var rootRef = react.useRef(null); // can be removed once we drop support for non ref forwarding class components

  var handleOwnRef = react.useCallback(function (instance) {
    // #StrictMode ready
    rootRef.current = react_dom.findDOMNode(instance);
  }, []);
  var handleRef = (0,useForkRef/* default */.Z)(children.ref, handleOwnRef);
  var prevOpenRef = react.useRef();
  react.useEffect(function () {
    prevOpenRef.current = open;
  }, [open]);

  if (!prevOpenRef.current && open && typeof window !== 'undefined') {
    // WARNING: Potentially unsafe in concurrent mode.
    // The way the read on `nodeToRestore` is setup could make this actually safe.
    // Say we render `open={false}` -> `open={true}` but never commit.
    // We have now written a state that wasn't committed. But no committed effect
    // will read this wrong value. We only read from `nodeToRestore` in effects
    // that were committed on `open={true}`
    // WARNING: Prevents the instance from being garbage collected. Should only
    // hold a weak ref.
    nodeToRestore.current = getDoc().activeElement;
  }

  react.useEffect(function () {
    if (!open) {
      return;
    }

    var doc = (0,ownerDocument/* default */.Z)(rootRef.current); // We might render an empty child.

    if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
      if (!rootRef.current.hasAttribute('tabIndex')) {
        if (false) {}

        rootRef.current.setAttribute('tabIndex', -1);
      }

      rootRef.current.focus();
    }

    var contain = function contain() {
      var rootElement = rootRef.current; // Cleanup functions are executed lazily in React 17.
      // Contain can be called between the component being unmounted and its cleanup function being run.

      if (rootElement === null) {
        return;
      }

      if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
        ignoreNextEnforceFocus.current = false;
        return;
      }

      if (rootRef.current && !rootRef.current.contains(doc.activeElement)) {
        rootRef.current.focus();
      }
    };

    var loopFocus = function loopFocus(event) {
      // 9 = Tab
      if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) {
        return;
      } // Make sure the next tab starts from the right place.


      if (doc.activeElement === rootRef.current) {
        // We need to ignore the next contain as
        // it will try to move the focus back to the rootRef element.
        ignoreNextEnforceFocus.current = true;

        if (event.shiftKey) {
          sentinelEnd.current.focus();
        } else {
          sentinelStart.current.focus();
        }
      }
    };

    doc.addEventListener('focus', contain, true);
    doc.addEventListener('keydown', loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
    // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
    //
    // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
    // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.

    var interval = setInterval(function () {
      contain();
    }, 50);
    return function () {
      clearInterval(interval);
      doc.removeEventListener('focus', contain, true);
      doc.removeEventListener('keydown', loopFocus, true); // restoreLastFocus()

      if (!disableRestoreFocus) {
        // In IE 11 it is possible for document.activeElement to be null resulting
        // in nodeToRestore.current being null.
        // Not all elements in IE 11 have a focus method.
        // Once IE 11 support is dropped the focus() call can be unconditional.
        if (nodeToRestore.current && nodeToRestore.current.focus) {
          nodeToRestore.current.focus();
        }

        nodeToRestore.current = null;
      }
    };
  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open]);
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    tabIndex: 0,
    ref: sentinelStart,
    "data-test": "sentinelStart"
  }), /*#__PURE__*/react.cloneElement(children, {
    ref: handleRef
  }), /*#__PURE__*/react.createElement("div", {
    tabIndex: 0,
    ref: sentinelEnd,
    "data-test": "sentinelEnd"
  }));
}

 false ? 0 : void 0;

if (false) {}

/* harmony default export */ var Unstable_TrapFocus_Unstable_TrapFocus = (Unstable_TrapFocus);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Modal/SimpleBackdrop.js




var styles = {
  /* Styles applied to the root element. */
  root: {
    zIndex: -1,
    position: 'fixed',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent'
  },

  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: 'transparent'
  }
};
/**
 * @ignore - internal component.
 */

var SimpleBackdrop = /*#__PURE__*/react.forwardRef(function SimpleBackdrop(props, ref) {
  var _props$invisible = props.invisible,
      invisible = _props$invisible === void 0 ? false : _props$invisible,
      open = props.open,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["invisible", "open"]);

  return open ? /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    "aria-hidden": true,
    ref: ref
  }, other, {
    style: (0,esm_extends/* default */.Z)({}, styles.root, invisible ? styles.invisible : {}, other.style)
  })) : null;
});
 false ? 0 : void 0;
/* harmony default export */ var Modal_SimpleBackdrop = (SimpleBackdrop);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Modal/Modal.js


















function getContainer(container) {
  container = typeof container === 'function' ? container() : container;
  return react_dom.findDOMNode(container);
}

function getHasTransition(props) {
  return props.children ? props.children.props.hasOwnProperty('in') : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.


var defaultManager = new ModalManager();
var Modal_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'fixed',
      zIndex: theme.zIndex.modal,
      right: 0,
      bottom: 0,
      top: 0,
      left: 0
    },

    /* Styles applied to the root element if the `Modal` has exited. */
    hidden: {
      visibility: 'hidden'
    }
  };
};
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */

var Modal = /*#__PURE__*/react.forwardRef(function Modal(inProps, ref) {
  var theme = (0,useTheme/* default */.Z)();
  var props = (0,getThemeProps/* default */.Z)({
    name: 'MuiModal',
    props: (0,esm_extends/* default */.Z)({}, inProps),
    theme: theme
  });

  var _props$BackdropCompon = props.BackdropComponent,
      BackdropComponent = _props$BackdropCompon === void 0 ? Modal_SimpleBackdrop : _props$BackdropCompon,
      BackdropProps = props.BackdropProps,
      children = props.children,
      _props$closeAfterTran = props.closeAfterTransition,
      closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran,
      container = props.container,
      _props$disableAutoFoc = props.disableAutoFocus,
      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$disableBackdro = props.disableBackdropClick,
      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
      _props$disableEnforce = props.disableEnforceFocus,
      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
      _props$disableEscapeK = props.disableEscapeKeyDown,
      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      _props$disableRestore = props.disableRestoreFocus,
      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
      _props$disableScrollL = props.disableScrollLock,
      disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL,
      _props$hideBackdrop = props.hideBackdrop,
      hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop,
      _props$keepMounted = props.keepMounted,
      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
      _props$manager = props.manager,
      manager = _props$manager === void 0 ? defaultManager : _props$manager,
      onBackdropClick = props.onBackdropClick,
      onClose = props.onClose,
      onEscapeKeyDown = props.onEscapeKeyDown,
      onRendered = props.onRendered,
      open = props.open,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["BackdropComponent", "BackdropProps", "children", "closeAfterTransition", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]);

  var _React$useState = react.useState(true),
      exited = _React$useState[0],
      setExited = _React$useState[1];

  var modal = react.useRef({});
  var mountNodeRef = react.useRef(null);
  var modalRef = react.useRef(null);
  var handleRef = (0,useForkRef/* default */.Z)(modalRef, ref);
  var hasTransition = getHasTransition(props);

  var getDoc = function getDoc() {
    return (0,ownerDocument/* default */.Z)(mountNodeRef.current);
  };

  var getModal = function getModal() {
    modal.current.modalRef = modalRef.current;
    modal.current.mountNode = mountNodeRef.current;
    return modal.current;
  };

  var handleMounted = function handleMounted() {
    manager.mount(getModal(), {
      disableScrollLock: disableScrollLock
    }); // Fix a bug on Chrome where the scroll isn't initially 0.

    modalRef.current.scrollTop = 0;
  };

  var handleOpen = (0,useEventCallback/* default */.Z)(function () {
    var resolvedContainer = getContainer(container) || getDoc().body;
    manager.add(getModal(), resolvedContainer); // The element was already mounted.

    if (modalRef.current) {
      handleMounted();
    }
  });
  var isTopModal = react.useCallback(function () {
    return manager.isTopModal(getModal());
  }, [manager]);
  var handlePortalRef = (0,useEventCallback/* default */.Z)(function (node) {
    mountNodeRef.current = node;

    if (!node) {
      return;
    }

    if (onRendered) {
      onRendered();
    }

    if (open && isTopModal()) {
      handleMounted();
    } else {
      ariaHidden(modalRef.current, true);
    }
  });
  var handleClose = react.useCallback(function () {
    manager.remove(getModal());
  }, [manager]);
  react.useEffect(function () {
    return function () {
      handleClose();
    };
  }, [handleClose]);
  react.useEffect(function () {
    if (open) {
      handleOpen();
    } else if (!hasTransition || !closeAfterTransition) {
      handleClose();
    }
  }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);

  if (!keepMounted && !open && (!hasTransition || exited)) {
    return null;
  }

  var handleEnter = function handleEnter() {
    setExited(false);
  };

  var handleExited = function handleExited() {
    setExited(true);

    if (closeAfterTransition) {
      handleClose();
    }
  };

  var handleBackdropClick = function handleBackdropClick(event) {
    if (event.target !== event.currentTarget) {
      return;
    }

    if (onBackdropClick) {
      onBackdropClick(event);
    }

    if (!disableBackdropClick && onClose) {
      onClose(event, 'backdropClick');
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviours like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    if (event.key !== 'Escape' || !isTopModal()) {
      return;
    }

    if (onEscapeKeyDown) {
      onEscapeKeyDown(event);
    }

    if (!disableEscapeKeyDown) {
      // Swallow the event, in case someone is listening for the escape key on the body.
      event.stopPropagation();

      if (onClose) {
        onClose(event, 'escapeKeyDown');
      }
    }
  };

  var inlineStyle = Modal_styles(theme || {
    zIndex: zIndex/* default */.Z
  });
  var childProps = {};

  if (children.props.tabIndex === undefined) {
    childProps.tabIndex = children.props.tabIndex || '-1';
  } // It's a Transition like component


  if (hasTransition) {
    childProps.onEnter = (0,createChainedFunction/* default */.Z)(handleEnter, children.props.onEnter);
    childProps.onExited = (0,createChainedFunction/* default */.Z)(handleExited, children.props.onExited);
  }

  return /*#__PURE__*/react.createElement(Portal/* default */.Z, {
    ref: handlePortalRef,
    container: container,
    disablePortal: disablePortal
  }, /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    ref: handleRef,
    onKeyDown: handleKeyDown,
    role: "presentation"
  }, other, {
    style: (0,esm_extends/* default */.Z)({}, inlineStyle.root, !open && exited ? inlineStyle.hidden : {}, other.style)
  }), hideBackdrop ? null : /*#__PURE__*/react.createElement(BackdropComponent, (0,esm_extends/* default */.Z)({
    open: open,
    onClick: handleBackdropClick
  }, BackdropProps)), /*#__PURE__*/react.createElement(Unstable_TrapFocus_Unstable_TrapFocus, {
    disableEnforceFocus: disableEnforceFocus,
    disableAutoFocus: disableAutoFocus,
    disableRestoreFocus: disableRestoreFocus,
    getDoc: getDoc,
    isEnabled: isTopModal,
    open: open
  }, /*#__PURE__*/react.cloneElement(children, childProps))));
});
 false ? 0 : void 0;
/* harmony default export */ var Modal_Modal = (Modal);

/***/ }),

/***/ 76234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
/* harmony import */ var _utils_setRef__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34236);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17294);








function getContainer(container) {
  container = typeof container === 'function' ? container() : container; // #StrictMode ready

  return react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode(container);
}

var useEnhancedEffect = typeof window !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */

var Portal = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Portal(props, ref) {
  var children = props.children,
      container = props.container,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      onRendered = props.onRendered;

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(null),
      mountNode = _React$useState[0],
      setMountNode = _React$useState[1];

  var handleRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(children) ? children.ref : null, ref);
  useEnhancedEffect(function () {
    if (!disablePortal) {
      setMountNode(getContainer(container) || document.body);
    }
  }, [container, disablePortal]);
  useEnhancedEffect(function () {
    if (mountNode && !disablePortal) {
      (0,_utils_setRef__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ref, mountNode);
      return function () {
        (0,_utils_setRef__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ref, null);
      };
    }

    return undefined;
  }, [ref, mountNode, disablePortal]);
  useEnhancedEffect(function () {
    if (onRendered && (mountNode || disablePortal)) {
      onRendered();
    }
  }, [onRendered, mountNode, disablePortal]);

  if (disablePortal) {
    if ( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(children)) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, {
        ref: handleRef
      });
    }

    return children;
  }

  return mountNode ? /*#__PURE__*/react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal(children, mountNode) : mountNode;
});
 false ? 0 : void 0;

if (false) {}

/* harmony default export */ __webpack_exports__["Z"] = (Portal);

/***/ }),

/***/ 59693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$n": function() { return /* binding */ lighten; },
/* harmony export */   "Fq": function() { return /* binding */ alpha; },
/* harmony export */   "_4": function() { return /* binding */ emphasize; },
/* harmony export */   "_j": function() { return /* binding */ darken; },
/* harmony export */   "mi": function() { return /* binding */ getContrastRatio; }
/* harmony export */ });
/* unused harmony exports hexToRgb, rgbToHex, hslToRgb, decomposeColor, recomposeColor, getLuminance, fade */
/* harmony import */ var _material_ui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60288);


/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (false) {}

  return Math.min(Math.max(min, value), max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function hexToRgb(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function (n, index) {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', '), ")") : '';
}

function intToHex(int) {
  var hex = int.toString(16);
  return hex.length === 1 ? "0".concat(hex) : hex;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 *
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */


function rgbToHex(color) {
  // Idempotent
  if (color.indexOf('#') === 0) {
    return color;
  }

  var _decomposeColor = decomposeColor(color),
      values = _decomposeColor.values;

  return "#".concat(values.map(function (n) {
    return intToHex(n);
  }).join(''));
}
/**
 * Converts a color from hsl format to rgb format.
 *
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */

function hslToRgb(color) {
  color = decomposeColor(color);
  var _color = color,
      values = _color.values;
  var h = values[0];
  var s = values[1] / 100;
  var l = values[2] / 100;
  var a = s * Math.min(l, 1 - l);

  var f = function f(n) {
    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };

  var type = 'rgb';
  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];

  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }

  return recomposeColor({
    type: type,
    values: rgb
  });
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */

function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }

  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);

  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
    throw new Error( false ? 0 : (0,_material_ui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(3, color));
  }

  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });
  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */

function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */

function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */

function getLuminance(color) {
  color = decomposeColor(color);
  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(function (val) {
    val /= 255; // normalized

    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
  }); // Truncate at 3 digits

  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
var warnedOnce = false;
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 *
 * @deprecated
 * Use `import { alpha } from '@material-ui/core/styles'` instead.
 */

function fade(color, value) {
  if (false) {}

  return alpha(color, value);
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha value is overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0-1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function alpha(color, value) {
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

/***/ }),

/***/ 83559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ styles_createTheme; }
});

// UNUSED EXPORTS: createMuiTheme

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/deepmerge.js
var deepmerge = __webpack_require__(35953);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createBreakpoints.js


// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = (0,objectWithoutProperties/* default */.Z)(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end);

    if (endIndex === keys.length - 1) {
      return up(start);
    }

    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === 'number' ? values[keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  var warnedOnce = false;

  function width(key) {
    if (false) {}

    return values[key];
  }

  return (0,esm_extends/* default */.Z)({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createMixins.js


function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return (0,esm_extends/* default */.Z)({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      console.warn(['Material-UI: theme.mixins.gutters() is deprecated.', 'You can use the source of the mixin directly:', "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "].join('\n'));
      return (0,esm_extends/* default */.Z)({
        paddingLeft: spacing(2),
        paddingRight: spacing(2)
      }, styles, (0,defineProperty/* default */.Z)({}, breakpoints.up('sm'), (0,esm_extends/* default */.Z)({
        paddingLeft: spacing(3),
        paddingRight: spacing(3)
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, (0,defineProperty/* default */.Z)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), (0,defineProperty/* default */.Z)(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}
// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/formatMuiErrorMessage.js
var formatMuiErrorMessage = __webpack_require__(60288);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/common.js
var common = {
  black: '#000',
  white: '#fff'
};
/* harmony default export */ var colors_common = (common);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/grey.js
var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};
/* harmony default export */ var colors_grey = (grey);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/indigo.js
var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};
/* harmony default export */ var colors_indigo = (indigo);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/pink.js
var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};
/* harmony default export */ var colors_pink = (pink);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/red.js
var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
/* harmony default export */ var colors_red = (red);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/orange.js
var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
/* harmony default export */ var colors_orange = (orange);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/blue.js
var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
/* harmony default export */ var colors_blue = (blue);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/green.js
var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
/* harmony default export */ var colors_green = (green);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/colorManipulator.js
var colorManipulator = __webpack_require__(59693);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createPalette.js













var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: colors_common.white,
    default: colors_grey[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
var dark = {
  text: {
    primary: colors_common.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: colors_grey[800],
    default: '#303030'
  },
  action: {
    active: colors_common.white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};

function addLightOrDark(intent, direction, shade, tonalOffset) {
  var tonalOffsetLight = tonalOffset.light || tonalOffset;
  var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;

  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = (0,colorManipulator/* lighten */.$n)(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = (0,colorManipulator/* darken */._j)(intent.main, tonalOffsetDark);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: colors_indigo[300],
    main: colors_indigo[500],
    dark: colors_indigo[700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: colors_pink.A200,
    main: colors_pink.A400,
    dark: colors_pink.A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: colors_red[300],
    main: colors_red[500],
    dark: colors_red[700]
  } : _palette$error,
      _palette$warning = palette.warning,
      warning = _palette$warning === void 0 ? {
    light: colors_orange[300],
    main: colors_orange[500],
    dark: colors_orange[700]
  } : _palette$warning,
      _palette$info = palette.info,
      info = _palette$info === void 0 ? {
    light: colors_blue[300],
    main: colors_blue[500],
    dark: colors_blue[700]
  } : _palette$info,
      _palette$success = palette.success,
      success = _palette$success === void 0 ? {
    light: colors_green[300],
    main: colors_green[500],
    dark: colors_green[700]
  } : _palette$success,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = (0,objectWithoutProperties/* default */.Z)(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54


  function getContrastText(background) {
    var contrastText = (0,colorManipulator/* getContrastRatio */.mi)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (false) { var contrast; }

    return contrastText;
  }

  var augmentColor = function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
    color = (0,esm_extends/* default */.Z)({}, color);

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (!color.main) {
      throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(4, mainShade));
    }

    if (typeof color.main !== 'string') {
      throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(5, JSON.stringify(color.main)));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  };

  var types = {
    dark: dark,
    light: light
  };

  if (false) {}

  var paletteOutput = (0,deepmerge/* default */.Z)((0,esm_extends/* default */.Z)({
    // A collection of common colors.
    common: colors_common,
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor(primary),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor(error),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor(warning),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor(info),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor(success),
    // The grey colors.
    grey: colors_grey,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other);
  return paletteOutput;
}
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createTypography.js




function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

var warnedOnce = false;

function roundWithDeprecationWarning(value) {
  if (false) {}

  return round(value);
}

var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$fontWeightBold = _ref.fontWeightBold,
      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      allVariants = _ref.allVariants,
      pxToRem2 = _ref.pxToRem,
      other = (0,objectWithoutProperties/* default */.Z)(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);

  if (false) {}

  var coef = fontSize / 14;

  var pxToRem = pxToRem2 || function (size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };

  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return (0,esm_extends/* default */.Z)({
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(letterSpacing / size), "em")
    } : {}, casing, allVariants);
  };

  var variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return (0,deepmerge/* default */.Z)((0,esm_extends/* default */.Z)({
    htmlFontSize: htmlFontSize,
    pxToRem: pxToRem,
    round: roundWithDeprecationWarning,
    // TODO v5: remove
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    fontWeightBold: fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep

  });
}
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/shadows.js
var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss


var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
/* harmony default export */ var styles_shadows = (shadows);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/shape.js
var shape = {
  borderRadius: 4
};
/* harmony default export */ var styles_shape = (shape);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/spacing.js + 1 modules
var esm_spacing = __webpack_require__(27122);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createSpacing.js

var warnOnce;
function createSpacing() {
  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
  // Smaller components, such as icons and type, can align to a 4dp grid.
  // https://material.io/design/layout/understanding-layout.html#usage


  var transform = (0,esm_spacing/* createUnarySpacing */.h)({
    spacing: spacingInput
  });

  var spacing = function spacing() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (false) {}

    if (args.length === 0) {
      return transform(1);
    }

    if (args.length === 1) {
      return transform(args[0]);
    }

    return args.map(function (argument) {
      if (typeof argument === 'string') {
        return argument;
      }

      var output = transform(argument);
      return typeof output === 'number' ? "".concat(output, "px") : output;
    }).join(' ');
  }; // Backward compatibility, to remove in v5.


  Object.defineProperty(spacing, 'unit', {
    get: function get() {
      if (false) {}

      return spacingInput;
    }
  });
  spacing.mui = true;
  return spacing;
}
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/transitions.js
var transitions = __webpack_require__(43366);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/zIndex.js
var zIndex = __webpack_require__(92781);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createTheme.js













function createTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      spacingInput = options.spacing,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = (0,objectWithoutProperties/* default */.Z)(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);

  var palette = createPalette(paletteInput);
  var breakpoints = createBreakpoints(breakpointsInput);
  var spacing = createSpacing(spacingInput);
  var muiTheme = (0,deepmerge/* default */.Z)({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: createMixins(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Provide default props
    shadows: styles_shadows,
    typography: createTypography(palette, typographyInput),
    spacing: spacing,
    shape: styles_shape,
    transitions: transitions/* default */.ZP,
    zIndex: zIndex/* default */.Z
  }, other);

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  muiTheme = args.reduce(function (acc, argument) {
    return (0,deepmerge/* default */.Z)(acc, argument);
  }, muiTheme);

  if (false) { var traverse, pseudoClasses; }

  return muiTheme;
}

var createTheme_warnedOnce = false;
function createMuiTheme() {
  if (false) {}

  return createTheme.apply(void 0, arguments);
}
/* harmony default export */ var styles_createTheme = (createTheme);

/***/ }),

/***/ 99700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _createTheme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83559);

var defaultTheme = (0,_createTheme__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
/* harmony default export */ __webpack_exports__["Z"] = (defaultTheme);

/***/ }),

/***/ 43366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x9": function() { return /* binding */ duration; }
/* harmony export */ });
/* unused harmony export easing */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45987);

// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};

function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
}
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */


/* harmony default export */ __webpack_exports__["ZP"] = ({
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay,
        other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(options, ["duration", "easing", "delay"]);

    if (false) { var isNumber, isString; }

    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
});

/***/ }),

/***/ 8920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTheme; }
/* harmony export */ });
/* harmony import */ var _material_ui_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(159);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _defaultTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99700);



function useTheme() {
  var theme = (0,_material_ui_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)() || _defaultTheme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z;

  if (false) {}

  return theme;
}

/***/ }),

/***/ 52543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var _material_ui_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38920);
/* harmony import */ var _defaultTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99700);




function withStyles(stylesOrCreator, options) {
  return (0,_material_ui_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(stylesOrCreator, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    defaultTheme: _defaultTheme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
  }, options));
}

/* harmony default export */ __webpack_exports__["Z"] = (withStyles);

/***/ }),

/***/ 92781:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
/* harmony default export */ __webpack_exports__["Z"] = (zIndex);

/***/ }),

/***/ 5653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ getTransitionProps; },
/* harmony export */   "n": function() { return /* binding */ reflow; }
/* harmony export */ });
var reflow = function reflow(node) {
  return node.scrollTop;
};
function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
    delay: style.transitionDelay
  };
}

/***/ }),

/***/ 42959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ createChainedFunction; }
/* harmony export */ });
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (acc, func) {
    if (func == null) {
      return acc;
    }

    if (false) {}

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

/***/ }),

/***/ 75840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getScrollbarSize; }
/* harmony export */ });
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
function getScrollbarSize() {
  var scrollDiv = document.createElement('div');
  scrollDiv.style.width = '99px';
  scrollDiv.style.height = '99px';
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarSize;
}

/***/ }),

/***/ 30626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ownerDocument; }
/* harmony export */ });
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

/***/ }),

/***/ 80713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ownerWindow; }
/* harmony export */ });
/* harmony import */ var _ownerDocument__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30626);

function ownerWindow(node) {
  var doc = (0,_ownerDocument__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(node);
  return doc.defaultView || window;
}

/***/ }),

/***/ 34236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ setRef; }
/* harmony export */ });
// TODO v5: consider to make it private
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

/***/ }),

/***/ 55192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useEventCallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useEnhancedEffect = typeof window !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
/**
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 *
 * @param {function} fn
 */

function useEventCallback(fn) {
  var ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef(fn);
  useEnhancedEffect(function () {
    ref.current = fn;
  });
  return react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function () {
    return (0, ref.current).apply(void 0, arguments);
  }, []);
}

/***/ }),

/***/ 17294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useForkRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _setRef__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34236);


function useForkRef(refA, refB) {
  /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function () {
    if (refA == null && refB == null) {
      return null;
    }

    return function (refValue) {
      (0,_setRef__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(refA, refValue);
      (0,_setRef__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(refB, refValue);
    };
  }, [refA, refB]);
}

/***/ }),

/***/ 26975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NU": function() { return /* binding */ StylesContext; },
/* harmony export */   "ZP": function() { return /* binding */ StylesProvider; },
/* harmony export */   "tP": function() { return /* binding */ sheetsManager; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _createGenerateClassName__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5034);
/* harmony import */ var jss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54013);
/* harmony import */ var _jssPreset__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54620);







 // Default JSS instance.

var jss = (0,jss__WEBPACK_IMPORTED_MODULE_1__/* .create */ .Ue)((0,_jssPreset__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.

var generateClassName = (0,_createGenerateClassName__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(); // Exported for test purposes

var sheetsManager = new Map();
var defaultOptions = {
  disableGeneration: false,
  generateClassName: generateClassName,
  jss: jss,
  sheetsCache: null,
  sheetsManager: sheetsManager,
  sheetsRegistry: null
};
var StylesContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(defaultOptions);

if (false) {}

var injectFirstNode;
function StylesProvider(props) {
  var children = props.children,
      _props$injectFirst = props.injectFirst,
      injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst,
      _props$disableGenerat = props.disableGeneration,
      disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat,
      localOptions = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, ["children", "injectFirst", "disableGeneration"]);

  var outerOptions = react__WEBPACK_IMPORTED_MODULE_0__.useContext(StylesContext);

  var context = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, outerOptions, {
    disableGeneration: disableGeneration
  }, localOptions);

  if (false) {}

  if (false) {}

  if (false) {}

  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
    if (!injectFirstNode) {
      var head = document.head;
      injectFirstNode = document.createComment('mui-inject-first');
      head.insertBefore(injectFirstNode, head.firstChild);
    }

    context.jss = (0,jss__WEBPACK_IMPORTED_MODULE_1__/* .create */ .Ue)({
      plugins: (0,_jssPreset__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().plugins,
      insertionPoint: injectFirstNode
    });
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(StylesContext.Provider, {
    value: context
  }, children);
}
 false ? 0 : void 0;

if (false) {}

/***/ }),

/***/ 17076:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
/* harmony default export */ __webpack_exports__["Z"] = (hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__');

/***/ }),

/***/ 5034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ createGenerateClassName; }
/* harmony export */ });
/* harmony import */ var _ThemeProvider_nested__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17076);

/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */

var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js

function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$disableGloba = options.disableGlobal,
      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
      _options$seed = options.seed,
      seed = _options$seed === void 0 ? '' : _options$seed;
  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
  var ruleCounter = 0;

  var getNextCounterId = function getNextCounterId() {
    ruleCounter += 1;

    if (false) {}

    return ruleCounter;
  };

  return function (rule, styleSheet) {
    var name = styleSheet.options.name; // Is a global static MUI style?

    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
      // We can use a shorthand class name, we never use the keys to style the components.
      if (pseudoClasses.indexOf(rule.key) !== -1) {
        return "Mui-".concat(rule.key);
      }

      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);

      if (!styleSheet.options.theme[_ThemeProvider_nested__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z] || seed !== '') {
        return prefix;
      }

      return "".concat(prefix, "-").concat(getNextCounterId());
    }

    if (true) {
      return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    }

    var suffix = "".concat(rule.key, "-").concat(getNextCounterId()); // Help with debuggability.

    if (styleSheet.options.classNamePrefix) {
      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
    }

    return "".concat(seedPrefix).concat(suffix);
  };
}

/***/ }),

/***/ 93869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getThemeProps; }
/* harmony export */ });
/* eslint-disable no-restricted-syntax */
function getThemeProps(params) {
  var theme = params.theme,
      name = params.name,
      props = params.props;

  if (!theme || !theme.props || !theme.props[name]) {
    return props;
  } // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221


  var defaultProps = theme.props[name];
  var propName;

  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }

  return props;
}

/***/ }),

/***/ 54620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ jssPreset; }
/* harmony export */ });
/* harmony import */ var jss_plugin_rule_value_function__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27202);
/* harmony import */ var jss_plugin_global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5019);
/* harmony import */ var jss_plugin_nested__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63057);
/* harmony import */ var jss_plugin_camel_case__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16345);
/* harmony import */ var jss_plugin_default_unit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83961);
/* harmony import */ var jss_plugin_vendor_prefixer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3203);
/* harmony import */ var jss_plugin_props_sort__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26895);






 // Subset of jss-preset-default with only the plugins the Material-UI components are using.

function jssPreset() {
  return {
    plugins: [(0,jss_plugin_rule_value_function__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(), (0,jss_plugin_global__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(), (0,jss_plugin_nested__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(), (0,jss_plugin_camel_case__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(), (0,jss_plugin_default_unit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(), // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : (0,jss_plugin_vendor_prefixer__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(), (0,jss_plugin_props_sort__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)()]
  };
}

/***/ }),

/***/ 11719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ makeStyles; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/jss/dist/jss.esm.js
var jss_esm = __webpack_require__(54013);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/mergeClasses/mergeClasses.js
var mergeClasses = __webpack_require__(65835);
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/makeStyles/multiKeyStore.js
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);

    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }

    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  delete: function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache.delete(key2);
  }
};
/* harmony default export */ var makeStyles_multiKeyStore = (multiKeyStore);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/useTheme/useTheme.js
var useTheme = __webpack_require__(159);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/StylesProvider/StylesProvider.js
var StylesProvider = __webpack_require__(26975);
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/makeStyles/indexCounter.js
/* eslint-disable import/prefer-default-export */
// Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var indexCounter = -1e9;
function increment() {
  indexCounter += 1;

  if (false) {}

  return indexCounter;
}
// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/deepmerge.js
var deepmerge = __webpack_require__(35953);
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/getStylesCreator/getStylesCreator.js




function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';

  if (false) {}

  return {
    create: function create(theme, name) {
      var styles;

      try {
        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
      } catch (err) {
        if (false) {}

        throw err;
      }

      if (!name || !theme.overrides || !theme.overrides[name]) {
        return styles;
      }

      var overrides = theme.overrides[name];

      var stylesWithOverrides = (0,esm_extends/* default */.Z)({}, styles);

      Object.keys(overrides).forEach(function (key) {
        if (false) {}

        stylesWithOverrides[key] = (0,deepmerge/* default */.Z)(stylesWithOverrides[key], overrides[key]);
      });
      return stylesWithOverrides;
    },
    options: {}
  };
}
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/getStylesCreator/noopTheme.js
// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme = {};
/* harmony default export */ var getStylesCreator_noopTheme = (noopTheme);
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/makeStyles/makeStyles.js












function getClasses(_ref, classes, Component) {
  var state = _ref.state,
      stylesOptions = _ref.stylesOptions;

  if (stylesOptions.disableGeneration) {
    return classes || {};
  }

  if (!state.cacheClasses) {
    state.cacheClasses = {
      // Cache for the finalized classes value.
      value: null,
      // Cache for the last used classes prop pointer.
      lastProp: null,
      // Cache for the last used rendered classes pointer.
      lastJSS: {}
    };
  } // Tracks if either the rendered classes or classes prop has changed,
  // requiring the generation of a new finalized classes object.


  var generate = false;

  if (state.classes !== state.cacheClasses.lastJSS) {
    state.cacheClasses.lastJSS = state.classes;
    generate = true;
  }

  if (classes !== state.cacheClasses.lastProp) {
    state.cacheClasses.lastProp = classes;
    generate = true;
  }

  if (generate) {
    state.cacheClasses.value = (0,mergeClasses/* default */.Z)({
      baseClasses: state.cacheClasses.lastJSS,
      newClasses: classes,
      Component: Component
    });
  }

  return state.cacheClasses.value;
}

function attach(_ref2, props) {
  var state = _ref2.state,
      theme = _ref2.theme,
      stylesOptions = _ref2.stylesOptions,
      stylesCreator = _ref2.stylesCreator,
      name = _ref2.name;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = makeStyles_multiKeyStore.get(stylesOptions.sheetsManager, stylesCreator, theme);

  if (!sheetManager) {
    sheetManager = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    };
    makeStyles_multiKeyStore.set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
  }

  var options = (0,esm_extends/* default */.Z)({}, stylesCreator.options, stylesOptions, {
    theme: theme,
    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
  });

  options.generateId = options.serverGenerateClassName || options.generateClassName;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    var staticSheet;

    if (stylesOptions.sheetsCache) {
      staticSheet = makeStyles_multiKeyStore.get(stylesOptions.sheetsCache, stylesCreator, theme);
    }

    var styles = stylesCreator.create(theme, name);

    if (!staticSheet) {
      staticSheet = stylesOptions.jss.createStyleSheet(styles, (0,esm_extends/* default */.Z)({
        link: false
      }, options));
      staticSheet.attach();

      if (stylesOptions.sheetsCache) {
        makeStyles_multiKeyStore.set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
      }
    }

    if (sheetsRegistry) {
      sheetsRegistry.add(staticSheet);
    }

    sheetManager.staticSheet = staticSheet;
    sheetManager.dynamicStyles = (0,jss_esm/* getDynamicStyles */._$)(styles);
  }

  if (sheetManager.dynamicStyles) {
    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0,esm_extends/* default */.Z)({
      link: true
    }, options));
    dynamicSheet.update(props);
    dynamicSheet.attach();
    state.dynamicSheet = dynamicSheet;
    state.classes = (0,mergeClasses/* default */.Z)({
      baseClasses: sheetManager.staticSheet.classes,
      newClasses: dynamicSheet.classes
    });

    if (sheetsRegistry) {
      sheetsRegistry.add(dynamicSheet);
    }
  } else {
    state.classes = sheetManager.staticSheet.classes;
  }

  sheetManager.refs += 1;
}

function update(_ref3, props) {
  var state = _ref3.state;

  if (state.dynamicSheet) {
    state.dynamicSheet.update(props);
  }
}

function detach(_ref4) {
  var state = _ref4.state,
      theme = _ref4.theme,
      stylesOptions = _ref4.stylesOptions,
      stylesCreator = _ref4.stylesCreator;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = makeStyles_multiKeyStore.get(stylesOptions.sheetsManager, stylesCreator, theme);
  sheetManager.refs -= 1;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    makeStyles_multiKeyStore["delete"](stylesOptions.sheetsManager, stylesCreator, theme);
    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(sheetManager.staticSheet);
    }
  }

  if (state.dynamicSheet) {
    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(state.dynamicSheet);
    }
  }
}

function useSynchronousEffect(func, values) {
  var key = react.useRef([]);
  var output; // Store "generation" key. Just returns a new object every time

  var currentKey = react.useMemo(function () {
    return {};
  }, values); // eslint-disable-line react-hooks/exhaustive-deps
  // "the first render", or "memo dropped the value"

  if (key.current !== currentKey) {
    key.current = currentKey;
    output = func();
  }

  react.useEffect(function () {
    return function () {
      if (output) {
        output();
      }
    };
  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
  );
}

function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var name = options.name,
      classNamePrefixOption = options.classNamePrefix,
      Component = options.Component,
      _options$defaultTheme = options.defaultTheme,
      defaultTheme = _options$defaultTheme === void 0 ? getStylesCreator_noopTheme : _options$defaultTheme,
      stylesOptions2 = (0,objectWithoutProperties/* default */.Z)(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);

  var stylesCreator = getStylesCreator(stylesOrCreator);
  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
  stylesCreator.options = {
    index: increment(),
    name: name,
    meta: classNamePrefix,
    classNamePrefix: classNamePrefix
  };

  var useStyles = function useStyles() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var theme = (0,useTheme/* default */.Z)() || defaultTheme;

    var stylesOptions = (0,esm_extends/* default */.Z)({}, react.useContext(StylesProvider/* StylesContext */.NU), stylesOptions2);

    var instance = react.useRef();
    var shouldUpdate = react.useRef();
    useSynchronousEffect(function () {
      var current = {
        name: name,
        state: {},
        stylesCreator: stylesCreator,
        stylesOptions: stylesOptions,
        theme: theme
      };
      attach(current, props);
      shouldUpdate.current = false;
      instance.current = current;
      return function () {
        detach(current);
      };
    }, [theme, stylesCreator]);
    react.useEffect(function () {
      if (shouldUpdate.current) {
        update(instance.current, props);
      }

      shouldUpdate.current = true;
    });
    var classes = getClasses(instance.current, props.classes, Component);

    if (false) {}

    return classes;
  };

  return useStyles;
}

/***/ }),

/***/ 65835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ mergeClasses; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87462);


function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses,
      Component = options.Component;

  if (!newClasses) {
    return baseClasses;
  }

  var nextClasses = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, baseClasses);

  if (false) {}

  Object.keys(newClasses).forEach(function (key) {
    if (false) {}

    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}

/***/ }),

/***/ 83800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var ThemeContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);

if (false) {}

/* harmony default export */ __webpack_exports__["Z"] = (ThemeContext);

/***/ }),

/***/ 159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTheme; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _ThemeContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83800);


function useTheme() {
  var theme = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_ThemeContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);

  if (false) {}

  return theme;
}

/***/ }),

/***/ 38920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8679);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _makeStyles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11719);
/* harmony import */ var _getThemeProps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93869);
/* harmony import */ var _useTheme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(159);








 // Link a style sheet with a component.
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.

var withStyles = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var defaultTheme = options.defaultTheme,
        _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        name = options.name,
        stylesOptions = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(options, ["defaultTheme", "withTheme", "name"]);

    if (false) {}

    var classNamePrefix = name;

    if (false) { var displayName; }

    var useStyles = (0,_makeStyles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(stylesOrCreator, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
      defaultTheme: defaultTheme,
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var WithStyles = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function WithStyles(props, ref) {
      var classesProp = props.classes,
          innerRef = props.innerRef,
          other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["classes", "innerRef"]); // The wrapper receives only user supplied props, which could be a subset of
      // the actual props Component might receive due to merging with defaultProps.
      // So copying it here would give us the same result in the wrapper as well.


      var classes = useStyles((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, Component.defaultProps, props));
      var theme;
      var more = other;

      if (typeof name === 'string' || withTheme) {
        // name and withTheme are invariant in the outer scope
        // eslint-disable-next-line react-hooks/rules-of-hooks
        theme = (0,_useTheme__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)() || defaultTheme;

        if (name) {
          more = (0,_getThemeProps__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            theme: theme,
            name: name,
            props: other
          });
        } // Provide the theme to the wrapped component.
        // So we don't have to use the `withTheme()` Higher-order Component.


        if (withTheme && !more.theme) {
          more.theme = theme;
        }
      }

      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: innerRef || ref,
        classes: classes
      }, more));
    });
     false ? 0 : void 0;

    if (false) {}

    hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1___default()(WithStyles, Component);

    if (false) {}

    return WithStyles;
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (withStyles);

/***/ }),

/***/ 71410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ handleBreakpoints; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74902);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71002);
/* harmony import */ var _merge__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19668);




 // The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.

var values = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
};
var defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: function up(key) {
    return "@media (min-width:".concat(values[key], "px)");
  }
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  if (false) {}

  if (Array.isArray(propValue)) {
    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    return propValue.reduce(function (acc, item, index) {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }

  if ((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(propValue) === 'object') {
    var _themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;

    return Object.keys(propValue).reduce(function (acc, breakpoint) {
      acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
      return acc;
    }, {});
  }

  var output = styleFromPropValue(propValue);
  return output;
}

function breakpoints(styleFunction) {
  var newStyleFunction = function newStyleFunction(props) {
    var base = styleFunction(props);
    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    var extended = themeBreakpoints.keys.reduce(function (acc, key) {
      if (props[key]) {
        acc = acc || {};
        acc[themeBreakpoints.up(key)] = styleFunction((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
          theme: props.theme
        }, props[key]));
      }

      return acc;
    }, null);
    return (0,_merge__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(base, extended);
  };

  newStyleFunction.propTypes =  false ? 0 : {};
  newStyleFunction.filterProps = ['xs', 'sm', 'md', 'lg', 'xl'].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(styleFunction.filterProps));
  return newStyleFunction;
}

/* harmony default export */ __webpack_exports__["Z"] = (breakpoints);

/***/ }),

/***/ 19668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _material_ui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35953);


function merge(acc, item) {
  if (!item) {
    return acc;
  }

  return (0,_material_ui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(acc, item, {
    clone: false // No need to clone deep, it's way faster.

  });
}

/* harmony default export */ __webpack_exports__["Z"] = (merge);

/***/ }),

/***/ 27122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ createUnarySpacing; },
  "Z": function() { return /* binding */ esm_spacing; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/breakpoints.js
var breakpoints = __webpack_require__(71410);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/merge.js
var merge = __webpack_require__(19668);
;// CONCATENATED MODULE: ./node_modules/@material-ui/system/esm/memoize.js
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }

    return cache[arg];
  };
}
;// CONCATENATED MODULE: ./node_modules/@material-ui/system/esm/spacing.js





var properties = {
  m: 'margin',
  p: 'padding'
};
var directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
var aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec

var getCssProperties = memoize(function (prop) {
  // It's not a shorthand notation.
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }

  var _prop$split = prop.split(''),
      _prop$split2 = (0,slicedToArray/* default */.Z)(_prop$split, 2),
      a = _prop$split2[0],
      b = _prop$split2[1];

  var property = properties[a];
  var direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(function (dir) {
    return property + dir;
  }) : [property + direction];
});
var spacingKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY'];
function createUnarySpacing(theme) {
  var themeSpacing = theme.spacing || 8;

  if (typeof themeSpacing === 'number') {
    return function (abs) {
      if (false) {}

      return themeSpacing * abs;
    };
  }

  if (Array.isArray(themeSpacing)) {
    return function (abs) {
      if (false) {}

      return themeSpacing[abs];
    };
  }

  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }

  if (false) {}

  return function () {
    return undefined;
  };
}

function getValue(transformer, propValue) {
  if (typeof propValue === 'string' || propValue == null) {
    return propValue;
  }

  var abs = Math.abs(propValue);
  var transformed = transformer(abs);

  if (propValue >= 0) {
    return transformed;
  }

  if (typeof transformed === 'number') {
    return -transformed;
  }

  return "-".concat(transformed);
}

function getStyleFromPropValue(cssProperties, transformer) {
  return function (propValue) {
    return cssProperties.reduce(function (acc, cssProperty) {
      acc[cssProperty] = getValue(transformer, propValue);
      return acc;
    }, {});
  };
}

function spacing(props) {
  var theme = props.theme;
  var transformer = createUnarySpacing(theme);
  return Object.keys(props).map(function (prop) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (spacingKeys.indexOf(prop) === -1) {
      return null;
    }

    var cssProperties = getCssProperties(prop);
    var styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
    var propValue = props[prop];
    return (0,breakpoints/* handleBreakpoints */.k)(props, propValue, styleFromPropValue);
  }).reduce(merge/* default */.Z, {});
}

spacing.propTypes =  false ? 0 : {};
spacing.filterProps = spacingKeys;
/* harmony default export */ var esm_spacing = (spacing);

/***/ }),

/***/ 35953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ deepmerge; }
/* harmony export */ });
/* unused harmony export isPlainObject */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71002);


function isPlainObject(item) {
  return item && (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(item) === 'object' && item.constructor === Object;
}
function deepmerge(target, source) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    clone: true
  };
  var output = options.clone ? (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, target) : target;

  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(function (key) {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }

      if (isPlainObject(source[key]) && key in target) {
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
}

/***/ }),

/***/ 60288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ formatMuiErrorMessage; }
/* harmony export */ });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe iff we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose

  /* eslint-disable prefer-template */
  var url = 'https://mui.com/production-error/?code=' + code;

  for (var i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }

  return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

/***/ }),

/***/ 98456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CircularProgress_CircularProgress; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js + 1 modules
var emotion_react_browser_esm = __webpack_require__(98012);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CircularProgress/circularProgressClasses.js


function getCircularProgressUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCircularProgress', slot);
}
const circularProgressClasses = (0,generateUtilityClasses/* default */.Z)('MuiCircularProgress', ['root', 'determinate', 'indeterminate', 'colorPrimary', 'colorSecondary', 'svg', 'circle', 'circleDeterminate', 'circleIndeterminate', 'circleDisableShrink']);
/* harmony default export */ var CircularProgress_circularProgressClasses = ((/* unused pure expression or super */ null && (circularProgressClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js


const _excluded = ["className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"];
let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4;











const SIZE = 44;
const circularRotateKeyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t || (_t = _`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const circularDashKeyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t2 || (_t2 = _`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const useUtilityClasses = ownerState => {
  const {
    classes,
    variant,
    color,
    disableShrink
  } = ownerState;
  const slots = {
    root: ['root', variant, `color${(0,capitalize/* default */.Z)(color)}`],
    svg: ['svg'],
    circle: ['circle', `circle${(0,capitalize/* default */.Z)(variant)}`, disableShrink && 'circleDisableShrink']
  };
  return (0,composeClasses/* default */.Z)(slots, getCircularProgressUtilityClass, classes);
};
const CircularProgressRoot = (0,styled/* default */.ZP)('span', {
  name: 'MuiCircularProgress',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`color${(0,capitalize/* default */.Z)(ownerState.color)}`]];
  }
})(({
  ownerState,
  theme
}) => (0,esm_extends/* default */.Z)({
  display: 'inline-block'
}, ownerState.variant === 'determinate' && {
  transition: theme.transitions.create('transform')
}, ownerState.color !== 'inherit' && {
  color: (theme.vars || theme).palette[ownerState.color].main
}), ({
  ownerState
}) => ownerState.variant === 'indeterminate' && (0,emotion_react_browser_esm/* css */.iv)(_t3 || (_t3 = _`
      animation: ${0} 1.4s linear infinite;
    `), circularRotateKeyframe));
const CircularProgressSVG = (0,styled/* default */.ZP)('svg', {
  name: 'MuiCircularProgress',
  slot: 'Svg',
  overridesResolver: (props, styles) => styles.svg
})({
  display: 'block' // Keeps the progress centered
});

const CircularProgressCircle = (0,styled/* default */.ZP)('circle', {
  name: 'MuiCircularProgress',
  slot: 'Circle',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.circle, styles[`circle${(0,capitalize/* default */.Z)(ownerState.variant)}`], ownerState.disableShrink && styles.circleDisableShrink];
  }
})(({
  ownerState,
  theme
}) => (0,esm_extends/* default */.Z)({
  stroke: 'currentColor'
}, ownerState.variant === 'determinate' && {
  transition: theme.transitions.create('stroke-dashoffset')
}, ownerState.variant === 'indeterminate' && {
  // Some default value that looks fine waiting for the animation to kicks in.
  strokeDasharray: '80px, 200px',
  strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
}), ({
  ownerState
}) => ownerState.variant === 'indeterminate' && !ownerState.disableShrink && (0,emotion_react_browser_esm/* css */.iv)(_t4 || (_t4 = _`
      animation: ${0} 1.4s ease-in-out infinite;
    `), circularDashKeyframe));

/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */
const CircularProgress = /*#__PURE__*/react.forwardRef(function CircularProgress(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCircularProgress'
  });
  const {
      className,
      color = 'primary',
      disableShrink = false,
      size = 40,
      style,
      thickness = 3.6,
      value = 0,
      variant = 'indeterminate'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    disableShrink,
    size,
    thickness,
    value,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  const circleStyle = {};
  const rootStyle = {};
  const rootProps = {};
  if (variant === 'determinate') {
    const circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);
    circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
    rootStyle.transform = 'rotate(-90deg)';
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CircularProgressRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    style: (0,esm_extends/* default */.Z)({
      width: size,
      height: size
    }, rootStyle, style),
    ownerState: ownerState,
    ref: ref,
    role: "progressbar"
  }, rootProps, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircularProgressSVG, {
      className: classes.svg,
      ownerState: ownerState,
      viewBox: `${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircularProgressCircle, {
        className: classes.circle,
        style: circleStyle,
        ownerState: ownerState,
        cx: SIZE,
        cy: SIZE,
        r: (SIZE - thickness) / 2,
        fill: "none",
        strokeWidth: thickness
      })
    })
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var CircularProgress_CircularProgress = (CircularProgress);

/***/ }),

/***/ 47036:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#f5f5f5',
  A200: '#eeeeee',
  A400: '#bdbdbd',
  A700: '#616161'
};
/* harmony default export */ __webpack_exports__["Z"] = (grey);

/***/ }),

/***/ 47650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ styles_createTheme; }
});

// UNUSED EXPORTS: createMuiTheme

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/formatMuiErrorMessage.js
var formatMuiErrorMessage = __webpack_require__(71387);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/deepmerge.js
var deepmerge = __webpack_require__(59766);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/createTheme/createTheme.js + 3 modules
var createTheme = __webpack_require__(66500);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/defaultSxConfig.js + 5 modules
var defaultSxConfig = __webpack_require__(44920);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/styleFunctionSx.js
var styleFunctionSx = __webpack_require__(86523);
;// CONCATENATED MODULE: ./node_modules/@mui/material/styles/createMixins.js

function createMixins(breakpoints, mixins) {
  return (0,esm_extends/* default */.Z)({
    toolbar: {
      minHeight: 56,
      [breakpoints.up('xs')]: {
        '@media (orientation: landscape)': {
          minHeight: 48
        }
      },
      [breakpoints.up('sm')]: {
        minHeight: 64
      }
    }
  }, mixins);
}
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
;// CONCATENATED MODULE: ./node_modules/@mui/material/colors/common.js
const common = {
  black: '#000',
  white: '#fff'
};
/* harmony default export */ var colors_common = (common);
// EXTERNAL MODULE: ./node_modules/@mui/material/colors/grey.js
var grey = __webpack_require__(47036);
;// CONCATENATED MODULE: ./node_modules/@mui/material/colors/purple.js
const purple = {
  50: '#f3e5f5',
  100: '#e1bee7',
  200: '#ce93d8',
  300: '#ba68c8',
  400: '#ab47bc',
  500: '#9c27b0',
  600: '#8e24aa',
  700: '#7b1fa2',
  800: '#6a1b9a',
  900: '#4a148c',
  A100: '#ea80fc',
  A200: '#e040fb',
  A400: '#d500f9',
  A700: '#aa00ff'
};
/* harmony default export */ var colors_purple = (purple);
;// CONCATENATED MODULE: ./node_modules/@mui/material/colors/red.js
const red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
/* harmony default export */ var colors_red = (red);
;// CONCATENATED MODULE: ./node_modules/@mui/material/colors/orange.js
const orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
/* harmony default export */ var colors_orange = (orange);
;// CONCATENATED MODULE: ./node_modules/@mui/material/colors/blue.js
const blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
/* harmony default export */ var colors_blue = (blue);
;// CONCATENATED MODULE: ./node_modules/@mui/material/colors/lightBlue.js
const lightBlue = {
  50: '#e1f5fe',
  100: '#b3e5fc',
  200: '#81d4fa',
  300: '#4fc3f7',
  400: '#29b6f6',
  500: '#03a9f4',
  600: '#039be5',
  700: '#0288d1',
  800: '#0277bd',
  900: '#01579b',
  A100: '#80d8ff',
  A200: '#40c4ff',
  A400: '#00b0ff',
  A700: '#0091ea'
};
/* harmony default export */ var colors_lightBlue = (lightBlue);
;// CONCATENATED MODULE: ./node_modules/@mui/material/colors/green.js
const green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
/* harmony default export */ var colors_green = (green);
;// CONCATENATED MODULE: ./node_modules/@mui/material/styles/createPalette.js



const _excluded = ["mode", "contrastThreshold", "tonalOffset"];










const light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.6)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: colors_common.white,
    default: colors_common.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
const dark = {
  text: {
    primary: colors_common.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: '#121212',
    default: '#121212'
  },
  action: {
    active: colors_common.white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function addLightOrDark(intent, direction, shade, tonalOffset) {
  const tonalOffsetLight = tonalOffset.light || tonalOffset;
  const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = (0,colorManipulator/* lighten */.$n)(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = (0,colorManipulator/* darken */._j)(intent.main, tonalOffsetDark);
    }
  }
}
function getDefaultPrimary(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: colors_blue[200],
      light: colors_blue[50],
      dark: colors_blue[400]
    };
  }
  return {
    main: colors_blue[700],
    light: colors_blue[400],
    dark: colors_blue[800]
  };
}
function getDefaultSecondary(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: colors_purple[200],
      light: colors_purple[50],
      dark: colors_purple[400]
    };
  }
  return {
    main: colors_purple[500],
    light: colors_purple[300],
    dark: colors_purple[700]
  };
}
function getDefaultError(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: colors_red[500],
      light: colors_red[300],
      dark: colors_red[700]
    };
  }
  return {
    main: colors_red[700],
    light: colors_red[400],
    dark: colors_red[800]
  };
}
function getDefaultInfo(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: colors_lightBlue[400],
      light: colors_lightBlue[300],
      dark: colors_lightBlue[700]
    };
  }
  return {
    main: colors_lightBlue[700],
    light: colors_lightBlue[500],
    dark: colors_lightBlue[900]
  };
}
function getDefaultSuccess(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: colors_green[400],
      light: colors_green[300],
      dark: colors_green[700]
    };
  }
  return {
    main: colors_green[800],
    light: colors_green[500],
    dark: colors_green[900]
  };
}
function getDefaultWarning(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: colors_orange[400],
      light: colors_orange[300],
      dark: colors_orange[700]
    };
  }
  return {
    main: '#ed6c02',
    // closest to orange[800] that pass 3:1.
    light: colors_orange[500],
    dark: colors_orange[900]
  };
}
function createPalette(palette) {
  const {
      mode = 'light',
      contrastThreshold = 3,
      tonalOffset = 0.2
    } = palette,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(palette, _excluded);
  const primary = palette.primary || getDefaultPrimary(mode);
  const secondary = palette.secondary || getDefaultSecondary(mode);
  const error = palette.error || getDefaultError(mode);
  const info = palette.info || getDefaultInfo(mode);
  const success = palette.success || getDefaultSuccess(mode);
  const warning = palette.warning || getDefaultWarning(mode);

  // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
  function getContrastText(background) {
    const contrastText = (0,colorManipulator/* getContrastRatio */.mi)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
    if (false) {}
    return contrastText;
  }
  const augmentColor = ({
    color,
    name,
    mainShade = 500,
    lightShade = 300,
    darkShade = 700
  }) => {
    color = (0,esm_extends/* default */.Z)({}, color);
    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }
    if (!color.hasOwnProperty('main')) {
      throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(11, name ? ` (${name})` : '', mainShade));
    }
    if (typeof color.main !== 'string') {
      throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
    }
    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);
    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }
    return color;
  };
  const modes = {
    dark,
    light
  };
  if (false) {}
  const paletteOutput = (0,deepmerge/* default */.Z)((0,esm_extends/* default */.Z)({
    // A collection of common colors.
    common: (0,esm_extends/* default */.Z)({}, colors_common),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor({
      color: primary,
      name: 'primary'
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor({
      color: secondary,
      name: 'secondary',
      mainShade: 'A400',
      lightShade: 'A200',
      darkShade: 'A700'
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor({
      color: error,
      name: 'error'
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor({
      color: warning,
      name: 'warning'
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor({
      color: info,
      name: 'info'
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor({
      color: success,
      name: 'success'
    }),
    // The grey colors.
    grey: grey/* default */.Z,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText,
    // Generate a rich color object.
    augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset
  }, modes[mode]), other);
  return paletteOutput;
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/styles/createTypography.js


const createTypography_excluded = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];

function round(value) {
  return Math.round(value * 1e5) / 1e5;
}
const caseAllCaps = {
  textTransform: 'uppercase'
};
const defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';

/**
 * @see @link{https://m2.material.io/design/typography/the-type-system.html}
 * @see @link{https://m2.material.io/design/typography/understanding-typography.html}
 */
function createTypography(palette, typography) {
  const _ref = typeof typography === 'function' ? typography(palette) : typography,
    {
      fontFamily = defaultFontFamily,
      // The default font size of the Material Specification.
      fontSize = 14,
      // px
      fontWeightLight = 300,
      fontWeightRegular = 400,
      fontWeightMedium = 500,
      fontWeightBold = 700,
      // Tell MUI what's the font-size on the html element.
      // 16px is the default font-size used by browsers.
      htmlFontSize = 16,
      // Apply the CSS properties to all the variants.
      allVariants,
      pxToRem: pxToRem2
    } = _ref,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, createTypography_excluded);
  if (false) {}
  const coef = fontSize / 14;
  const pxToRem = pxToRem2 || (size => `${size / htmlFontSize * coef}rem`);
  const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing) => (0,esm_extends/* default */.Z)({
    fontFamily,
    fontWeight,
    fontSize: pxToRem(size),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight
  }, fontFamily === defaultFontFamily ? {
    letterSpacing: `${round(letterSpacing / size)}em`
  } : {}, casing, allVariants);
  const variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps),
    inherit: {
      fontFamily: 'inherit',
      fontWeight: 'inherit',
      fontSize: 'inherit',
      lineHeight: 'inherit',
      letterSpacing: 'inherit'
    }
  };
  return (0,deepmerge/* default */.Z)((0,esm_extends/* default */.Z)({
    htmlFontSize,
    pxToRem,
    fontFamily,
    fontSize,
    fontWeightLight,
    fontWeightRegular,
    fontWeightMedium,
    fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep
  });
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/styles/shadows.js
const shadowKeyUmbraOpacity = 0.2;
const shadowKeyPenumbraOpacity = 0.14;
const shadowAmbientShadowOpacity = 0.12;
function createShadow(...px) {
  return [`${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`, `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`, `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`].join(',');
}

// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
/* harmony default export */ var styles_shadows = (shadows);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/createTransitions.js
var createTransitions = __webpack_require__(96067);
;// CONCATENATED MODULE: ./node_modules/@mui/material/styles/zIndex.js
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const zIndex = {
  mobileStepper: 1000,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
/* harmony default export */ var styles_zIndex = (zIndex);
;// CONCATENATED MODULE: ./node_modules/@mui/material/styles/createTheme.js



const createTheme_excluded = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];









function createTheme_createTheme(options = {}, ...args) {
  const {
      mixins: mixinsInput = {},
      palette: paletteInput = {},
      transitions: transitionsInput = {},
      typography: typographyInput = {}
    } = options,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(options, createTheme_excluded);
  if (options.vars) {
    throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(18));
  }
  const palette = createPalette(paletteInput);
  const systemTheme = (0,createTheme/* default */.Z)(options);
  let muiTheme = (0,deepmerge/* default */.Z)(systemTheme, {
    mixins: createMixins(systemTheme.breakpoints, mixinsInput),
    palette,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: styles_shadows.slice(),
    typography: createTypography(palette, typographyInput),
    transitions: (0,createTransitions/* default */.ZP)(transitionsInput),
    zIndex: (0,esm_extends/* default */.Z)({}, styles_zIndex)
  });
  muiTheme = (0,deepmerge/* default */.Z)(muiTheme, other);
  muiTheme = args.reduce((acc, argument) => (0,deepmerge/* default */.Z)(acc, argument), muiTheme);
  if (false) {}
  muiTheme.unstable_sxConfig = (0,esm_extends/* default */.Z)({}, defaultSxConfig/* default */.Z, other == null ? void 0 : other.unstable_sxConfig);
  muiTheme.unstable_sx = function sx(props) {
    return (0,styleFunctionSx/* default */.Z)({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}
let warnedOnce = false;
function createMuiTheme(...args) {
  if (false) {}
  return createTheme_createTheme(...args);
}
/* harmony default export */ var styles_createTheme = (createTheme_createTheme);

/***/ }),

/***/ 96067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ createTransitions; },
/* harmony export */   "x9": function() { return /* binding */ duration; }
/* harmony export */ });
/* unused harmony export easing */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63366);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87462);


const _excluded = ["duration", "easing", "delay"];
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};

// Follow https://m2.material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing
const duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function formatMs(milliseconds) {
  return `${Math.round(milliseconds)}ms`;
}
function getAutoHeightDuration(height) {
  if (!height) {
    return 0;
  }
  const constant = height / 36;

  // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
  return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function createTransitions(inputTransitions) {
  const mergedEasing = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, easing, inputTransitions.easing);
  const mergedDuration = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, duration, inputTransitions.duration);
  const create = (props = ['all'], options = {}) => {
    const {
        duration: durationOption = mergedDuration.standard,
        easing: easingOption = mergedEasing.easeInOut,
        delay = 0
      } = options,
      other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(options, _excluded);
    if (false) {}
    return (Array.isArray(props) ? props : [props]).map(animatedProp => `${animatedProp} ${typeof durationOption === 'string' ? durationOption : formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : formatMs(delay)}`).join(',');
  };
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    getAutoHeightDuration,
    create
  }, inputTransitions, {
    easing: mergedEasing,
    duration: mergedDuration
  });
}

/***/ }),

/***/ 90247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _createTheme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47650);

const defaultTheme = (0,_createTheme__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
/* harmony default export */ __webpack_exports__["Z"] = (defaultTheme);

/***/ }),

/***/ 10606:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ('$$material');

/***/ }),

/***/ 11496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ styles_styled; },
  "FO": function() { return /* binding */ rootShouldForwardProp; },
  "Dz": function() { return /* binding */ slotShouldForwardProp; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@mui/styled-engine/index.js + 6 modules
var styled_engine = __webpack_require__(59158);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/createTheme/createTheme.js + 3 modules
var createTheme = __webpack_require__(66500);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/capitalize.js
var capitalize = __webpack_require__(28320);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/propsToClassKey.js

const _excluded = ["variant"];

function isEmpty(string) {
  return string.length === 0;
}

/**
 * Generates string classKey based on the properties provided. It starts with the
 * variant if defined, and then it appends all other properties in alphabetical order.
 * @param {object} props - the properties for which the classKey should be created.
 */
function propsToClassKey(props) {
  const {
      variant
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  let classKey = variant || '';
  Object.keys(other).sort().forEach(key => {
    if (key === 'color') {
      classKey += isEmpty(classKey) ? props[key] : (0,capitalize/* default */.Z)(props[key]);
    } else {
      classKey += `${isEmpty(classKey) ? key : (0,capitalize/* default */.Z)(key)}${(0,capitalize/* default */.Z)(props[key].toString())}`;
    }
  });
  return classKey;
}
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/styleFunctionSx.js
var styleFunctionSx = __webpack_require__(86523);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/createStyled.js


const createStyled_excluded = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
/* eslint-disable no-underscore-dangle */





function createStyled_isEmpty(obj) {
  return Object.keys(obj).length === 0;
}

// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function isStringTag(tag) {
  return typeof tag === 'string' &&
  // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96;
}
const getStyleOverrides = (name, theme) => {
  if (theme.components && theme.components[name] && theme.components[name].styleOverrides) {
    return theme.components[name].styleOverrides;
  }
  return null;
};
const getVariantStyles = (name, theme) => {
  let variants = [];
  if (theme && theme.components && theme.components[name] && theme.components[name].variants) {
    variants = theme.components[name].variants;
  }
  const variantsStyles = {};
  variants.forEach(definition => {
    const key = propsToClassKey(definition.props);
    variantsStyles[key] = definition.style;
  });
  return variantsStyles;
};
const variantsResolver = (props, styles, theme, name) => {
  var _theme$components, _theme$components$nam;
  const {
    ownerState = {}
  } = props;
  const variantsStyles = [];
  const themeVariants = theme == null ? void 0 : (_theme$components = theme.components) == null ? void 0 : (_theme$components$nam = _theme$components[name]) == null ? void 0 : _theme$components$nam.variants;
  if (themeVariants) {
    themeVariants.forEach(themeVariant => {
      let isMatch = true;
      Object.keys(themeVariant.props).forEach(key => {
        if (ownerState[key] !== themeVariant.props[key] && props[key] !== themeVariant.props[key]) {
          isMatch = false;
        }
      });
      if (isMatch) {
        variantsStyles.push(styles[propsToClassKey(themeVariant.props)]);
      }
    });
  }
  return variantsStyles;
};

// Update /system/styled/#api in case if this changes
function shouldForwardProp(prop) {
  return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const systemDefaultTheme = (0,createTheme/* default */.Z)();
const lowercaseFirstLetter = string => {
  return string.charAt(0).toLowerCase() + string.slice(1);
};
function resolveTheme({
  defaultTheme,
  theme,
  themeId
}) {
  return createStyled_isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function createStyled(input = {}) {
  const {
    themeId,
    defaultTheme = systemDefaultTheme,
    rootShouldForwardProp = shouldForwardProp,
    slotShouldForwardProp = shouldForwardProp
  } = input;
  const systemSx = props => {
    return (0,styleFunctionSx/* default */.Z)((0,esm_extends/* default */.Z)({}, props, {
      theme: resolveTheme((0,esm_extends/* default */.Z)({}, props, {
        defaultTheme,
        themeId
      }))
    }));
  };
  systemSx.__mui_systemSx = true;
  return (tag, inputOptions = {}) => {
    // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
    (0,styled_engine/* internal_processStyles */.Co)(tag, styles => styles.filter(style => !(style != null && style.__mui_systemSx)));
    const {
        name: componentName,
        slot: componentSlot,
        skipVariantsResolver: inputSkipVariantsResolver,
        skipSx: inputSkipSx,
        overridesResolver
      } = inputOptions,
      options = (0,objectWithoutPropertiesLoose/* default */.Z)(inputOptions, createStyled_excluded);

    // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
    const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : componentSlot && componentSlot !== 'Root' || false;
    const skipSx = inputSkipSx || false;
    let label;
    if (false) {}
    let shouldForwardPropOption = shouldForwardProp;
    if (componentSlot === 'Root') {
      shouldForwardPropOption = rootShouldForwardProp;
    } else if (componentSlot) {
      // any other slot specified
      shouldForwardPropOption = slotShouldForwardProp;
    } else if (isStringTag(tag)) {
      // for string (html) tag, preserve the behavior in emotion & styled-components.
      shouldForwardPropOption = undefined;
    }
    const defaultStyledResolver = (0,styled_engine/* default */.ZP)(tag, (0,esm_extends/* default */.Z)({
      shouldForwardProp: shouldForwardPropOption,
      label
    }, options));
    const muiStyledResolver = (styleArg, ...expressions) => {
      const expressionsWithDefaultTheme = expressions ? expressions.map(stylesArg => {
        // On the server Emotion doesn't use React.forwardRef for creating components, so the created
        // component stays as a function. This condition makes sure that we do not interpolate functions
        // which are basically components used as a selectors.
        return typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg ? props => {
          return stylesArg((0,esm_extends/* default */.Z)({}, props, {
            theme: resolveTheme((0,esm_extends/* default */.Z)({}, props, {
              defaultTheme,
              themeId
            }))
          }));
        } : stylesArg;
      }) : [];
      let transformedStyleArg = styleArg;
      if (componentName && overridesResolver) {
        expressionsWithDefaultTheme.push(props => {
          const theme = resolveTheme((0,esm_extends/* default */.Z)({}, props, {
            defaultTheme,
            themeId
          }));
          const styleOverrides = getStyleOverrides(componentName, theme);
          if (styleOverrides) {
            const resolvedStyleOverrides = {};
            Object.entries(styleOverrides).forEach(([slotKey, slotStyle]) => {
              resolvedStyleOverrides[slotKey] = typeof slotStyle === 'function' ? slotStyle((0,esm_extends/* default */.Z)({}, props, {
                theme
              })) : slotStyle;
            });
            return overridesResolver(props, resolvedStyleOverrides);
          }
          return null;
        });
      }
      if (componentName && !skipVariantsResolver) {
        expressionsWithDefaultTheme.push(props => {
          const theme = resolveTheme((0,esm_extends/* default */.Z)({}, props, {
            defaultTheme,
            themeId
          }));
          return variantsResolver(props, getVariantStyles(componentName, theme), theme, componentName);
        });
      }
      if (!skipSx) {
        expressionsWithDefaultTheme.push(systemSx);
      }
      const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
      if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
        const placeholders = new Array(numOfCustomFnsApplied).fill('');
        // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
        transformedStyleArg = [...styleArg, ...placeholders];
        transformedStyleArg.raw = [...styleArg.raw, ...placeholders];
      } else if (typeof styleArg === 'function' &&
      // On the server Emotion doesn't use React.forwardRef for creating components, so the created
      // component stays as a function. This condition makes sure that we do not interpolate functions
      // which are basically components used as a selectors.
      styleArg.__emotion_real !== styleArg) {
        // If the type is function, we need to define the default theme.
        transformedStyleArg = props => styleArg((0,esm_extends/* default */.Z)({}, props, {
          theme: resolveTheme((0,esm_extends/* default */.Z)({}, props, {
            defaultTheme,
            themeId
          }))
        }));
      }
      const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
      if (false) {}
      if (tag.muiName) {
        Component.muiName = tag.muiName;
      }
      return Component;
    };
    if (defaultStyledResolver.withConfig) {
      muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
    }
    return muiStyledResolver;
  };
}
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/defaultTheme.js
var defaultTheme = __webpack_require__(90247);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/identifier.js
var identifier = __webpack_require__(10606);
;// CONCATENATED MODULE: ./node_modules/@mui/material/styles/styled.js



const rootShouldForwardProp = prop => shouldForwardProp(prop) && prop !== 'classes';
const slotShouldForwardProp = shouldForwardProp;
const styled = createStyled({
  themeId: identifier/* default */.Z,
  defaultTheme: defaultTheme/* default */.Z,
  rootShouldForwardProp
});
/* harmony default export */ var styles_styled = (styled);

/***/ }),

/***/ 71657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useThemeProps; }
/* harmony export */ });
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29628);
/* harmony import */ var _defaultTheme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90247);
/* harmony import */ var _identifier__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10606);



function useThemeProps({
  props,
  name
}) {
  return (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    props,
    name,
    defaultTheme: _defaultTheme__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
    themeId: _identifier__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
  });
}

/***/ }),

/***/ 98216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28320);

/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 59158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ styled; },
  "Co": function() { return /* binding */ internal_processStyles; }
});

// UNUSED EXPORTS: GlobalStyles, StyledEngineProvider, ThemeContext, css, keyframes

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js
var emotion_is_prop_valid_esm = __webpack_require__(71068);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js
var emotion_element_c39617d8_browser_esm = __webpack_require__(75260);
;// CONCATENATED MODULE: ./node_modules/@emotion/styled/node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};



;// CONCATENATED MODULE: ./node_modules/@emotion/styled/node_modules/@emotion/hash/dist/emotion-hash.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}



;// CONCATENATED MODULE: ./node_modules/@emotion/styled/node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};



// EXTERNAL MODULE: ./node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
var emotion_memoize_esm = __webpack_require__(45042);
;// CONCATENATED MODULE: ./node_modules/@emotion/styled/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */(0,emotion_memoize_esm/* default */.Z)(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

var noComponentSelectorMessage = (/* unused pure expression or super */ null && ('Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.'));

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};



// EXTERNAL MODULE: ./node_modules/@emotion/use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.browser.esm.js
var emotion_use_insertion_effect_with_fallbacks_browser_esm = __webpack_require__(27278);
;// CONCATENATED MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js








var testOmitPropsOnStringTag = emotion_is_prop_valid_esm/* default */.Z;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
  var shouldForwardProp;

  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  return shouldForwardProp;
};

var emotion_styled_base_browser_esm_ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  (0,emotion_use_insertion_effect_with_fallbacks_browser_esm/* useInsertionEffectAlwaysWithSyncFallback */.L)(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  return null;
};

var createStyled = function createStyled(tag, options) {
  if (false) {}

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }

  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (false) {}

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (false) {}

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = (0,emotion_element_c39617d8_browser_esm.w)(function (props, cache, ref) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;

      if (props.theme == null) {
        mergedProps = {};

        for (var key in props) {
          mergedProps[key] = props[key];
        }

        mergedProps.theme = react.useContext(emotion_element_c39617d8_browser_esm.T);
      }

      if (typeof props.className === 'string') {
        className = getRegisteredStyles(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }

      var serialized = serializeStyles(styles.concat(classInterpolations), cache.registered, mergedProps);
      className += cache.key + "-" + serialized.name;

      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }

      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};

      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;

        if ( // $FlowFixMe
        finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }

      newProps.className = className;
      newProps.ref = ref;
      return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof FinalTag === 'string'
      }), /*#__PURE__*/react.createElement(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && "production" !== 'production') {} // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, (0,esm_extends/* default */.Z)({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };

    return Styled;
  };
};



;// CONCATENATED MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js









var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

var newStyled = createStyled.bind();
tags.forEach(function (tagName) {
  // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
  newStyled[tagName] = newStyled(tagName);
});



;// CONCATENATED MODULE: ./node_modules/@mui/styled-engine/index.js
/**
 * @mui/styled-engine v5.13.2
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/* eslint-disable no-underscore-dangle */

function styled(tag, options) {
  const stylesFactory = newStyled(tag, options);
  if (false) {}
  return stylesFactory;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const internal_processStyles = (tag, processor) => {
  // Emotion attaches all the styles as `__emotion_styles`.
  // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
  if (Array.isArray(tag.__emotion_styles)) {
    tag.__emotion_styles = processor(tag.__emotion_styles);
  }
};




/***/ }),

/***/ 95408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L7": function() { return /* binding */ removeUnusedBreakpoints; },
/* harmony export */   "VO": function() { return /* binding */ values; },
/* harmony export */   "W8": function() { return /* binding */ createEmptyBreakpointObject; },
/* harmony export */   "k9": function() { return /* binding */ handleBreakpoints; }
/* harmony export */ });
/* unused harmony exports mergeBreakpointsInOrder, computeBreakpointsBase, resolveBreakpointValues */





// The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.
const values = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536 // large screen
};

const defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: key => `@media (min-width:${values[key]}px)`
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  const theme = props.theme || {};
  if (Array.isArray(propValue)) {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return propValue.reduce((acc, item, index) => {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }
  if (typeof propValue === 'object') {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return Object.keys(propValue).reduce((acc, breakpoint) => {
      // key is breakpoint
      if (Object.keys(themeBreakpoints.values || values).indexOf(breakpoint) !== -1) {
        const mediaKey = themeBreakpoints.up(breakpoint);
        acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
      } else {
        const cssKey = breakpoint;
        acc[cssKey] = propValue[cssKey];
      }
      return acc;
    }, {});
  }
  const output = styleFromPropValue(propValue);
  return output;
}
function breakpoints(styleFunction) {
  // false positive
  // eslint-disable-next-line react/function-component-definition
  const newStyleFunction = props => {
    const theme = props.theme || {};
    const base = styleFunction(props);
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    const extended = themeBreakpoints.keys.reduce((acc, key) => {
      if (props[key]) {
        acc = acc || {};
        acc[themeBreakpoints.up(key)] = styleFunction(_extends({
          theme
        }, props[key]));
      }
      return acc;
    }, null);
    return merge(base, extended);
  };
  newStyleFunction.propTypes =  false ? 0 : {};
  newStyleFunction.filterProps = ['xs', 'sm', 'md', 'lg', 'xl', ...styleFunction.filterProps];
  return newStyleFunction;
}
function createEmptyBreakpointObject(breakpointsInput = {}) {
  var _breakpointsInput$key;
  const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key) => {
    const breakpointStyleKey = breakpointsInput.up(key);
    acc[breakpointStyleKey] = {};
    return acc;
  }, {});
  return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style) {
  return breakpointKeys.reduce((acc, key) => {
    const breakpointOutput = acc[key];
    const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
    if (isBreakpointUnused) {
      delete acc[key];
    }
    return acc;
  }, style);
}
function mergeBreakpointsInOrder(breakpointsInput, ...styles) {
  const emptyBreakpoints = createEmptyBreakpointObject(breakpointsInput);
  const mergedOutput = [emptyBreakpoints, ...styles].reduce((prev, next) => deepmerge(prev, next), {});
  return removeUnusedBreakpoints(Object.keys(emptyBreakpoints), mergedOutput);
}

// compute base for responsive values; e.g.,
// [1,2,3] => {xs: true, sm: true, md: true}
// {xs: 1, sm: 2, md: 3} => {xs: true, sm: true, md: true}
function computeBreakpointsBase(breakpointValues, themeBreakpoints) {
  // fixed value
  if (typeof breakpointValues !== 'object') {
    return {};
  }
  const base = {};
  const breakpointsKeys = Object.keys(themeBreakpoints);
  if (Array.isArray(breakpointValues)) {
    breakpointsKeys.forEach((breakpoint, i) => {
      if (i < breakpointValues.length) {
        base[breakpoint] = true;
      }
    });
  } else {
    breakpointsKeys.forEach(breakpoint => {
      if (breakpointValues[breakpoint] != null) {
        base[breakpoint] = true;
      }
    });
  }
  return base;
}
function resolveBreakpointValues({
  values: breakpointValues,
  breakpoints: themeBreakpoints,
  base: customBase
}) {
  const base = customBase || computeBreakpointsBase(breakpointValues, themeBreakpoints);
  const keys = Object.keys(base);
  if (keys.length === 0) {
    return breakpointValues;
  }
  let previous;
  return keys.reduce((acc, breakpoint, i) => {
    if (Array.isArray(breakpointValues)) {
      acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
      previous = i;
    } else if (typeof breakpointValues === 'object') {
      acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
      previous = breakpoint;
    } else {
      acc[breakpoint] = breakpointValues;
    }
    return acc;
  }, {});
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (breakpoints)));

/***/ }),

/***/ 41796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$n": function() { return /* binding */ lighten; },
/* harmony export */   "Fq": function() { return /* binding */ alpha; },
/* harmony export */   "_j": function() { return /* binding */ darken; },
/* harmony export */   "mi": function() { return /* binding */ getContrastRatio; }
/* harmony export */ });
/* unused harmony exports hexToRgb, decomposeColor, colorChannel, private_safeColorChannel, recomposeColor, rgbToHex, hslToRgb, getLuminance, private_safeAlpha, private_safeDarken, private_safeLighten, emphasize, private_safeEmphasize */
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71387);

/* eslint-disable @typescript-eslint/naming-convention */
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value, min = 0, max = 1) {
  if (false) {}
  return Math.min(Math.max(min, value), max);
}

/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */
function hexToRgb(color) {
  color = color.slice(1);
  const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
  let colors = color.match(re);
  if (colors && colors[0].length === 1) {
    colors = colors.map(n => n + n);
  }
  return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index) => {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', ')})` : '';
}
function intToHex(int) {
  const hex = int.toString(16);
  return hex.length === 1 ? `0${hex}` : hex;
}

/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */
function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }
  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }
  const marker = color.indexOf('(');
  const type = color.substring(0, marker);
  if (['rgb', 'rgba', 'hsl', 'hsla', 'color'].indexOf(type) === -1) {
    throw new Error( false ? 0 : (0,_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(9, color));
  }
  let values = color.substring(marker + 1, color.length - 1);
  let colorSpace;
  if (type === 'color') {
    values = values.split(' ');
    colorSpace = values.shift();
    if (values.length === 4 && values[3].charAt(0) === '/') {
      values[3] = values[3].slice(1);
    }
    if (['srgb', 'display-p3', 'a98-rgb', 'prophoto-rgb', 'rec-2020'].indexOf(colorSpace) === -1) {
      throw new Error( false ? 0 : (0,_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(10, colorSpace));
    }
  } else {
    values = values.split(',');
  }
  values = values.map(value => parseFloat(value));
  return {
    type,
    values,
    colorSpace
  };
}

/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */
const colorChannel = color => {
  const decomposedColor = decomposeColor(color);
  return decomposedColor.values.slice(0, 3).map((val, idx) => decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
const private_safeColorChannel = (color, warning) => {
  try {
    return colorChannel(color);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
};

/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */
function recomposeColor(color) {
  const {
    type,
    colorSpace
  } = color;
  let {
    values
  } = color;
  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i) => i < 3 ? parseInt(n, 10) : n);
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = `${values[1]}%`;
    values[2] = `${values[2]}%`;
  }
  if (type.indexOf('color') !== -1) {
    values = `${colorSpace} ${values.join(' ')}`;
  } else {
    values = `${values.join(', ')}`;
  }
  return `${type}(${values})`;
}

/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */
function rgbToHex(color) {
  // Idempotent
  if (color.indexOf('#') === 0) {
    return color;
  }
  const {
    values
  } = decomposeColor(color);
  return `#${values.map((n, i) => intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}

/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */
function hslToRgb(color) {
  color = decomposeColor(color);
  const {
    values
  } = color;
  const h = values[0];
  const s = values[1] / 100;
  const l = values[2] / 100;
  const a = s * Math.min(l, 1 - l);
  const f = (n, k = (n + h / 30) % 12) => l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  let type = 'rgb';
  const rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }
  return recomposeColor({
    type,
    values: rgb
  });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */
function getLuminance(color) {
  color = decomposeColor(color);
  let rgb = color.type === 'hsl' || color.type === 'hsla' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(val => {
    if (color.type !== 'color') {
      val /= 255; // normalized
    }

    return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
  });

  // Truncate at 3 digits
  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}

/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */
function getContrastRatio(foreground, background) {
  const lumA = getLuminance(foreground);
  const lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}

/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function alpha(color, value) {
  color = decomposeColor(color);
  value = clamp(value);
  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }
  if (color.type === 'color') {
    color.values[3] = `/${value}`;
  } else {
    color.values[3] = value;
  }
  return recomposeColor(color);
}
function private_safeAlpha(color, value, warning) {
  try {
    return alpha(color, value);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
}

/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);
  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return recomposeColor(color);
}
function private_safeDarken(color, coefficient, warning) {
  try {
    return darken(color, coefficient);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
}

/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);
  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  } else if (color.type.indexOf('color') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] += (1 - color.values[i]) * coefficient;
    }
  }
  return recomposeColor(color);
}
function private_safeLighten(color, coefficient, warning) {
  try {
    return lighten(color, coefficient);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
}

/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function emphasize(color, coefficient = 0.15) {
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
function private_safeEmphasize(color, coefficient, warning) {
  try {
    return private_safeEmphasize(color, coefficient);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
}

/***/ }),

/***/ 66500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createTheme_createTheme; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/deepmerge.js
var deepmerge = __webpack_require__(59766);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/createTheme/createBreakpoints.js


const _excluded = ["values", "unit", "step"];
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const breakpointKeys = (/* unused pure expression or super */ null && (['xs', 'sm', 'md', 'lg', 'xl']));
const sortBreakpointsValues = values => {
  const breakpointsAsArray = Object.keys(values).map(key => ({
    key,
    val: values[key]
  })) || [];
  // Sort in ascending order
  breakpointsAsArray.sort((breakpoint1, breakpoint2) => breakpoint1.val - breakpoint2.val);
  return breakpointsAsArray.reduce((acc, obj) => {
    return (0,esm_extends/* default */.Z)({}, acc, {
      [obj.key]: obj.val
    });
  }, {});
};

// Keep in mind that @media is inclusive by the CSS specification.
function createBreakpoints(breakpoints) {
  const {
      // The breakpoint **start** at this value.
      // For instance with the first breakpoint xs: [xs, sm).
      values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
      },

      unit = 'px',
      step = 5
    } = breakpoints,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(breakpoints, _excluded);
  const sortedValues = sortBreakpointsValues(values);
  const keys = Object.keys(sortedValues);
  function up(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (min-width:${value}${unit})`;
  }
  function down(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (max-width:${value - step / 100}${unit})`;
  }
  function between(start, end) {
    const endIndex = keys.indexOf(end);
    return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
  }
  function only(key) {
    if (keys.indexOf(key) + 1 < keys.length) {
      return between(key, keys[keys.indexOf(key) + 1]);
    }
    return up(key);
  }
  function not(key) {
    // handle first and last key separately, for better readability
    const keyIndex = keys.indexOf(key);
    if (keyIndex === 0) {
      return up(keys[1]);
    }
    if (keyIndex === keys.length - 1) {
      return down(keys[keyIndex]);
    }
    return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
  }
  return (0,esm_extends/* default */.Z)({
    keys,
    values: sortedValues,
    up,
    down,
    between,
    only,
    not,
    unit
  }, other);
}
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/createTheme/shape.js
const shape = {
  borderRadius: 4
};
/* harmony default export */ var createTheme_shape = (shape);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/spacing.js + 1 modules
var esm_spacing = __webpack_require__(98700);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/createTheme/createSpacing.js


// The different signatures imply different meaning for their arguments that can't be expressed structurally.
// We express the difference with variable names.
/* tslint:disable:unified-signatures */
/* tslint:enable:unified-signatures */

function createSpacing(spacingInput = 8) {
  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  }

  // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
  // Smaller components, such as icons, can align to a 4dp grid.
  // https://m2.material.io/design/layout/understanding-layout.html
  const transform = (0,esm_spacing/* createUnarySpacing */.hB)({
    spacing: spacingInput
  });
  const spacing = (...argsInput) => {
    if (false) {}
    const args = argsInput.length === 0 ? [1] : argsInput;
    return args.map(argument => {
      const output = transform(argument);
      return typeof output === 'number' ? `${output}px` : output;
    }).join(' ');
  };
  spacing.mui = true;
  return spacing;
}
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/styleFunctionSx.js
var styleFunctionSx = __webpack_require__(86523);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/defaultSxConfig.js + 5 modules
var defaultSxConfig = __webpack_require__(44920);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/createTheme/createTheme.js


const createTheme_excluded = ["breakpoints", "palette", "spacing", "shape"];






function createTheme(options = {}, ...args) {
  const {
      breakpoints: breakpointsInput = {},
      palette: paletteInput = {},
      spacing: spacingInput,
      shape: shapeInput = {}
    } = options,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(options, createTheme_excluded);
  const breakpoints = createBreakpoints(breakpointsInput);
  const spacing = createSpacing(spacingInput);
  let muiTheme = (0,deepmerge/* default */.Z)({
    breakpoints,
    direction: 'ltr',
    components: {},
    // Inject component definitions.
    palette: (0,esm_extends/* default */.Z)({
      mode: 'light'
    }, paletteInput),
    spacing,
    shape: (0,esm_extends/* default */.Z)({}, createTheme_shape, shapeInput)
  }, other);
  muiTheme = args.reduce((acc, argument) => (0,deepmerge/* default */.Z)(acc, argument), muiTheme);
  muiTheme.unstable_sxConfig = (0,esm_extends/* default */.Z)({}, defaultSxConfig/* default */.Z, other == null ? void 0 : other.unstable_sxConfig);
  muiTheme.unstable_sx = function sx(props) {
    return (0,styleFunctionSx/* default */.Z)({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}
/* harmony default export */ var createTheme_createTheme = (createTheme);

/***/ }),

/***/ 47730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59766);

function merge(acc, item) {
  if (!item) {
    return acc;
  }
  return (0,_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(acc, item, {
    clone: false // No need to clone deep, it's way faster.
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (merge);

/***/ }),

/***/ 98700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hB": function() { return /* binding */ createUnarySpacing; },
  "eI": function() { return /* binding */ createUnaryUnit; },
  "NA": function() { return /* binding */ getValue; },
  "e6": function() { return /* binding */ margin; },
  "o3": function() { return /* binding */ padding; }
});

// UNUSED EXPORTS: default, getStyleFromPropValue, marginKeys, paddingKeys

// EXTERNAL MODULE: ./node_modules/@mui/system/esm/breakpoints.js
var breakpoints = __webpack_require__(95408);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/style.js
var style = __webpack_require__(54844);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/merge.js
var merge = __webpack_require__(47730);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/memoize.js
function memoize(fn) {
  const cache = {};
  return arg => {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }
    return cache[arg];
  };
}
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/spacing.js





const properties = {
  m: 'margin',
  p: 'padding'
};
const directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
const aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
};

// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const getCssProperties = memoize(prop => {
  // It's not a shorthand notation.
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }
  const [a, b] = prop.split('');
  const property = properties[a];
  const direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(dir => property + dir) : [property + direction];
});
const marginKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'marginInline', 'marginInlineStart', 'marginInlineEnd', 'marginBlock', 'marginBlockStart', 'marginBlockEnd'];
const paddingKeys = ['p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY', 'paddingInline', 'paddingInlineStart', 'paddingInlineEnd', 'paddingBlock', 'paddingBlockStart', 'paddingBlockEnd'];
const spacingKeys = [...marginKeys, ...paddingKeys];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
  var _getPath;
  const themeSpacing = (_getPath = (0,style/* getPath */.DW)(theme, themeKey, false)) != null ? _getPath : defaultValue;
  if (typeof themeSpacing === 'number') {
    return abs => {
      if (typeof abs === 'string') {
        return abs;
      }
      if (false) {}
      return themeSpacing * abs;
    };
  }
  if (Array.isArray(themeSpacing)) {
    return abs => {
      if (typeof abs === 'string') {
        return abs;
      }
      if (false) {}
      return themeSpacing[abs];
    };
  }
  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }
  if (false) {}
  return () => undefined;
}
function createUnarySpacing(theme) {
  return createUnaryUnit(theme, 'spacing', 8, 'spacing');
}
function getValue(transformer, propValue) {
  if (typeof propValue === 'string' || propValue == null) {
    return propValue;
  }
  const abs = Math.abs(propValue);
  const transformed = transformer(abs);
  if (propValue >= 0) {
    return transformed;
  }
  if (typeof transformed === 'number') {
    return -transformed;
  }
  return `-${transformed}`;
}
function getStyleFromPropValue(cssProperties, transformer) {
  return propValue => cssProperties.reduce((acc, cssProperty) => {
    acc[cssProperty] = getValue(transformer, propValue);
    return acc;
  }, {});
}
function resolveCssProperty(props, keys, prop, transformer) {
  // Using a hash computation over an array iteration could be faster, but with only 28 items,
  // it's doesn't worth the bundle size.
  if (keys.indexOf(prop) === -1) {
    return null;
  }
  const cssProperties = getCssProperties(prop);
  const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
  const propValue = props[prop];
  return (0,breakpoints/* handleBreakpoints */.k9)(props, propValue, styleFromPropValue);
}
function spacing_style(props, keys) {
  const transformer = createUnarySpacing(props.theme);
  return Object.keys(props).map(prop => resolveCssProperty(props, keys, prop, transformer)).reduce(merge/* default */.Z, {});
}
function margin(props) {
  return spacing_style(props, marginKeys);
}
margin.propTypes =  false ? 0 : {};
margin.filterProps = marginKeys;
function padding(props) {
  return spacing_style(props, paddingKeys);
}
padding.propTypes =  false ? 0 : {};
padding.filterProps = paddingKeys;
function spacing(props) {
  return spacing_style(props, spacingKeys);
}
spacing.propTypes =  false ? 0 : {};
spacing.filterProps = spacingKeys;
/* harmony default export */ var esm_spacing = ((/* unused pure expression or super */ null && (spacing)));

/***/ }),

/***/ 54844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DW": function() { return /* binding */ getPath; },
/* harmony export */   "Jq": function() { return /* binding */ getStyleValue; }
/* harmony export */ });
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28320);
/* harmony import */ var _breakpoints__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95408);



function getPath(obj, path, checkVars = true) {
  if (!path || typeof path !== 'string') {
    return null;
  }

  // Check if CSS variables are used
  if (obj && obj.vars && checkVars) {
    const val = `vars.${path}`.split('.').reduce((acc, item) => acc && acc[item] ? acc[item] : null, obj);
    if (val != null) {
      return val;
    }
  }
  return path.split('.').reduce((acc, item) => {
    if (acc && acc[item] != null) {
      return acc[item];
    }
    return null;
  }, obj);
}
function getStyleValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
  let value;
  if (typeof themeMapping === 'function') {
    value = themeMapping(propValueFinal);
  } else if (Array.isArray(themeMapping)) {
    value = themeMapping[propValueFinal] || userValue;
  } else {
    value = getPath(themeMapping, propValueFinal) || userValue;
  }
  if (transform) {
    value = transform(value, userValue, themeMapping);
  }
  return value;
}
function style(options) {
  const {
    prop,
    cssProperty = options.prop,
    themeKey,
    transform
  } = options;

  // false positive
  // eslint-disable-next-line react/function-component-definition
  const fn = props => {
    if (props[prop] == null) {
      return null;
    }
    const propValue = props[prop];
    const theme = props.theme;
    const themeMapping = getPath(theme, themeKey) || {};
    const styleFromPropValue = propValueFinal => {
      let value = getStyleValue(themeMapping, transform, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === 'string') {
        // Haven't found value
        value = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0,_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return (0,_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .handleBreakpoints */ .k9)(props, propValue, styleFromPropValue);
  };
  fn.propTypes =  false ? 0 : {};
  fn.filterProps = [prop];
  return fn;
}
/* harmony default export */ __webpack_exports__["ZP"] = (style);

/***/ }),

/***/ 44920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ styleFunctionSx_defaultSxConfig; }
});

// EXTERNAL MODULE: ./node_modules/@mui/system/esm/spacing.js + 1 modules
var spacing = __webpack_require__(98700);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/style.js
var style = __webpack_require__(54844);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/merge.js
var merge = __webpack_require__(47730);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/compose.js

function compose(...styles) {
  const handlers = styles.reduce((acc, style) => {
    style.filterProps.forEach(prop => {
      acc[prop] = style;
    });
    return acc;
  }, {});

  // false positive
  // eslint-disable-next-line react/function-component-definition
  const fn = props => {
    return Object.keys(props).reduce((acc, prop) => {
      if (handlers[prop]) {
        return (0,merge/* default */.Z)(acc, handlers[prop](props));
      }
      return acc;
    }, {});
  };
  fn.propTypes =  false ? 0 : {};
  fn.filterProps = styles.reduce((acc, style) => acc.concat(style.filterProps), []);
  return fn;
}
/* harmony default export */ var esm_compose = (compose);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/breakpoints.js
var breakpoints = __webpack_require__(95408);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/borders.js





function borderTransform(value) {
  if (typeof value !== 'number') {
    return value;
  }
  return `${value}px solid`;
}
const border = (0,style/* default */.ZP)({
  prop: 'border',
  themeKey: 'borders',
  transform: borderTransform
});
const borderTop = (0,style/* default */.ZP)({
  prop: 'borderTop',
  themeKey: 'borders',
  transform: borderTransform
});
const borderRight = (0,style/* default */.ZP)({
  prop: 'borderRight',
  themeKey: 'borders',
  transform: borderTransform
});
const borderBottom = (0,style/* default */.ZP)({
  prop: 'borderBottom',
  themeKey: 'borders',
  transform: borderTransform
});
const borderLeft = (0,style/* default */.ZP)({
  prop: 'borderLeft',
  themeKey: 'borders',
  transform: borderTransform
});
const borderColor = (0,style/* default */.ZP)({
  prop: 'borderColor',
  themeKey: 'palette'
});
const borderTopColor = (0,style/* default */.ZP)({
  prop: 'borderTopColor',
  themeKey: 'palette'
});
const borderRightColor = (0,style/* default */.ZP)({
  prop: 'borderRightColor',
  themeKey: 'palette'
});
const borderBottomColor = (0,style/* default */.ZP)({
  prop: 'borderBottomColor',
  themeKey: 'palette'
});
const borderLeftColor = (0,style/* default */.ZP)({
  prop: 'borderLeftColor',
  themeKey: 'palette'
});

// false positive
// eslint-disable-next-line react/function-component-definition
const borderRadius = props => {
  if (props.borderRadius !== undefined && props.borderRadius !== null) {
    const transformer = (0,spacing/* createUnaryUnit */.eI)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
    const styleFromPropValue = propValue => ({
      borderRadius: (0,spacing/* getValue */.NA)(transformer, propValue)
    });
    return (0,breakpoints/* handleBreakpoints */.k9)(props, props.borderRadius, styleFromPropValue);
  }
  return null;
};
borderRadius.propTypes =  false ? 0 : {};
borderRadius.filterProps = ['borderRadius'];
const borders = esm_compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius);
/* harmony default export */ var esm_borders = ((/* unused pure expression or super */ null && (borders)));
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/cssGrid.js






// false positive
// eslint-disable-next-line react/function-component-definition
const gap = props => {
  if (props.gap !== undefined && props.gap !== null) {
    const transformer = (0,spacing/* createUnaryUnit */.eI)(props.theme, 'spacing', 8, 'gap');
    const styleFromPropValue = propValue => ({
      gap: (0,spacing/* getValue */.NA)(transformer, propValue)
    });
    return (0,breakpoints/* handleBreakpoints */.k9)(props, props.gap, styleFromPropValue);
  }
  return null;
};
gap.propTypes =  false ? 0 : {};
gap.filterProps = ['gap'];

// false positive
// eslint-disable-next-line react/function-component-definition
const columnGap = props => {
  if (props.columnGap !== undefined && props.columnGap !== null) {
    const transformer = (0,spacing/* createUnaryUnit */.eI)(props.theme, 'spacing', 8, 'columnGap');
    const styleFromPropValue = propValue => ({
      columnGap: (0,spacing/* getValue */.NA)(transformer, propValue)
    });
    return (0,breakpoints/* handleBreakpoints */.k9)(props, props.columnGap, styleFromPropValue);
  }
  return null;
};
columnGap.propTypes =  false ? 0 : {};
columnGap.filterProps = ['columnGap'];

// false positive
// eslint-disable-next-line react/function-component-definition
const rowGap = props => {
  if (props.rowGap !== undefined && props.rowGap !== null) {
    const transformer = (0,spacing/* createUnaryUnit */.eI)(props.theme, 'spacing', 8, 'rowGap');
    const styleFromPropValue = propValue => ({
      rowGap: (0,spacing/* getValue */.NA)(transformer, propValue)
    });
    return (0,breakpoints/* handleBreakpoints */.k9)(props, props.rowGap, styleFromPropValue);
  }
  return null;
};
rowGap.propTypes =  false ? 0 : {};
rowGap.filterProps = ['rowGap'];
const gridColumn = (0,style/* default */.ZP)({
  prop: 'gridColumn'
});
const gridRow = (0,style/* default */.ZP)({
  prop: 'gridRow'
});
const gridAutoFlow = (0,style/* default */.ZP)({
  prop: 'gridAutoFlow'
});
const gridAutoColumns = (0,style/* default */.ZP)({
  prop: 'gridAutoColumns'
});
const gridAutoRows = (0,style/* default */.ZP)({
  prop: 'gridAutoRows'
});
const gridTemplateColumns = (0,style/* default */.ZP)({
  prop: 'gridTemplateColumns'
});
const gridTemplateRows = (0,style/* default */.ZP)({
  prop: 'gridTemplateRows'
});
const gridTemplateAreas = (0,style/* default */.ZP)({
  prop: 'gridTemplateAreas'
});
const gridArea = (0,style/* default */.ZP)({
  prop: 'gridArea'
});
const grid = esm_compose(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
/* harmony default export */ var cssGrid = ((/* unused pure expression or super */ null && (grid)));
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/palette.js


function paletteTransform(value, userValue) {
  if (userValue === 'grey') {
    return userValue;
  }
  return value;
}
const color = (0,style/* default */.ZP)({
  prop: 'color',
  themeKey: 'palette',
  transform: paletteTransform
});
const bgcolor = (0,style/* default */.ZP)({
  prop: 'bgcolor',
  cssProperty: 'backgroundColor',
  themeKey: 'palette',
  transform: paletteTransform
});
const backgroundColor = (0,style/* default */.ZP)({
  prop: 'backgroundColor',
  themeKey: 'palette',
  transform: paletteTransform
});
const palette = esm_compose(color, bgcolor, backgroundColor);
/* harmony default export */ var esm_palette = ((/* unused pure expression or super */ null && (palette)));
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/sizing.js



function sizingTransform(value) {
  return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const width = (0,style/* default */.ZP)({
  prop: 'width',
  transform: sizingTransform
});
const maxWidth = props => {
  if (props.maxWidth !== undefined && props.maxWidth !== null) {
    const styleFromPropValue = propValue => {
      var _props$theme, _props$theme$breakpoi, _props$theme$breakpoi2;
      const breakpoint = ((_props$theme = props.theme) == null ? void 0 : (_props$theme$breakpoi = _props$theme.breakpoints) == null ? void 0 : (_props$theme$breakpoi2 = _props$theme$breakpoi.values) == null ? void 0 : _props$theme$breakpoi2[propValue]) || breakpoints/* values */.VO[propValue];
      return {
        maxWidth: breakpoint || sizingTransform(propValue)
      };
    };
    return (0,breakpoints/* handleBreakpoints */.k9)(props, props.maxWidth, styleFromPropValue);
  }
  return null;
};
maxWidth.filterProps = ['maxWidth'];
const minWidth = (0,style/* default */.ZP)({
  prop: 'minWidth',
  transform: sizingTransform
});
const height = (0,style/* default */.ZP)({
  prop: 'height',
  transform: sizingTransform
});
const maxHeight = (0,style/* default */.ZP)({
  prop: 'maxHeight',
  transform: sizingTransform
});
const minHeight = (0,style/* default */.ZP)({
  prop: 'minHeight',
  transform: sizingTransform
});
const sizeWidth = (0,style/* default */.ZP)({
  prop: 'size',
  cssProperty: 'width',
  transform: sizingTransform
});
const sizeHeight = (0,style/* default */.ZP)({
  prop: 'size',
  cssProperty: 'height',
  transform: sizingTransform
});
const boxSizing = (0,style/* default */.ZP)({
  prop: 'boxSizing'
});
const sizing = esm_compose(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
/* harmony default export */ var esm_sizing = ((/* unused pure expression or super */ null && (sizing)));
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/defaultSxConfig.js





const defaultSxConfig = {
  // borders
  border: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderTop: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderRight: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderBottom: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderLeft: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderColor: {
    themeKey: 'palette'
  },
  borderTopColor: {
    themeKey: 'palette'
  },
  borderRightColor: {
    themeKey: 'palette'
  },
  borderBottomColor: {
    themeKey: 'palette'
  },
  borderLeftColor: {
    themeKey: 'palette'
  },
  borderRadius: {
    themeKey: 'shape.borderRadius',
    style: borderRadius
  },
  // palette
  color: {
    themeKey: 'palette',
    transform: paletteTransform
  },
  bgcolor: {
    themeKey: 'palette',
    cssProperty: 'backgroundColor',
    transform: paletteTransform
  },
  backgroundColor: {
    themeKey: 'palette',
    transform: paletteTransform
  },
  // spacing
  p: {
    style: spacing/* padding */.o3
  },
  pt: {
    style: spacing/* padding */.o3
  },
  pr: {
    style: spacing/* padding */.o3
  },
  pb: {
    style: spacing/* padding */.o3
  },
  pl: {
    style: spacing/* padding */.o3
  },
  px: {
    style: spacing/* padding */.o3
  },
  py: {
    style: spacing/* padding */.o3
  },
  padding: {
    style: spacing/* padding */.o3
  },
  paddingTop: {
    style: spacing/* padding */.o3
  },
  paddingRight: {
    style: spacing/* padding */.o3
  },
  paddingBottom: {
    style: spacing/* padding */.o3
  },
  paddingLeft: {
    style: spacing/* padding */.o3
  },
  paddingX: {
    style: spacing/* padding */.o3
  },
  paddingY: {
    style: spacing/* padding */.o3
  },
  paddingInline: {
    style: spacing/* padding */.o3
  },
  paddingInlineStart: {
    style: spacing/* padding */.o3
  },
  paddingInlineEnd: {
    style: spacing/* padding */.o3
  },
  paddingBlock: {
    style: spacing/* padding */.o3
  },
  paddingBlockStart: {
    style: spacing/* padding */.o3
  },
  paddingBlockEnd: {
    style: spacing/* padding */.o3
  },
  m: {
    style: spacing/* margin */.e6
  },
  mt: {
    style: spacing/* margin */.e6
  },
  mr: {
    style: spacing/* margin */.e6
  },
  mb: {
    style: spacing/* margin */.e6
  },
  ml: {
    style: spacing/* margin */.e6
  },
  mx: {
    style: spacing/* margin */.e6
  },
  my: {
    style: spacing/* margin */.e6
  },
  margin: {
    style: spacing/* margin */.e6
  },
  marginTop: {
    style: spacing/* margin */.e6
  },
  marginRight: {
    style: spacing/* margin */.e6
  },
  marginBottom: {
    style: spacing/* margin */.e6
  },
  marginLeft: {
    style: spacing/* margin */.e6
  },
  marginX: {
    style: spacing/* margin */.e6
  },
  marginY: {
    style: spacing/* margin */.e6
  },
  marginInline: {
    style: spacing/* margin */.e6
  },
  marginInlineStart: {
    style: spacing/* margin */.e6
  },
  marginInlineEnd: {
    style: spacing/* margin */.e6
  },
  marginBlock: {
    style: spacing/* margin */.e6
  },
  marginBlockStart: {
    style: spacing/* margin */.e6
  },
  marginBlockEnd: {
    style: spacing/* margin */.e6
  },
  // display
  displayPrint: {
    cssProperty: false,
    transform: value => ({
      '@media print': {
        display: value
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: gap
  },
  rowGap: {
    style: rowGap
  },
  columnGap: {
    style: columnGap
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: 'zIndex'
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: 'shadows'
  },
  // sizing
  width: {
    transform: sizingTransform
  },
  maxWidth: {
    style: maxWidth
  },
  minWidth: {
    transform: sizingTransform
  },
  height: {
    transform: sizingTransform
  },
  maxHeight: {
    transform: sizingTransform
  },
  minHeight: {
    transform: sizingTransform
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: 'typography'
  },
  fontSize: {
    themeKey: 'typography'
  },
  fontStyle: {
    themeKey: 'typography'
  },
  fontWeight: {
    themeKey: 'typography'
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: false,
    themeKey: 'typography'
  }
};
/* harmony default export */ var styleFunctionSx_defaultSxConfig = (defaultSxConfig);

/***/ }),

/***/ 86523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export unstable_createStyleFunctionSx */
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28320);
/* harmony import */ var _merge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47730);
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54844);
/* harmony import */ var _breakpoints__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95408);
/* harmony import */ var _defaultSxConfig__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44920);





function objectsHaveSameKeys(...objects) {
  const allKeys = objects.reduce((keys, object) => keys.concat(Object.keys(object)), []);
  const union = new Set(allKeys);
  return objects.every(object => union.size === Object.keys(object).length);
}
function callIfFn(maybeFn, arg) {
  return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
function unstable_createStyleFunctionSx() {
  function getThemeValue(prop, val, theme, config) {
    const props = {
      [prop]: val,
      theme
    };
    const options = config[prop];
    if (!options) {
      return {
        [prop]: val
      };
    }
    const {
      cssProperty = prop,
      themeKey,
      transform,
      style
    } = options;
    if (val == null) {
      return null;
    }
    if (themeKey === 'typography' && val === 'inherit') {
      return {
        [prop]: val
      };
    }
    const themeMapping = (0,_style__WEBPACK_IMPORTED_MODULE_0__/* .getPath */ .DW)(theme, themeKey) || {};
    if (style) {
      return style(props);
    }
    const styleFromPropValue = propValueFinal => {
      let value = (0,_style__WEBPACK_IMPORTED_MODULE_0__/* .getStyleValue */ .Jq)(themeMapping, transform, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === 'string') {
        // Haven't found value
        value = (0,_style__WEBPACK_IMPORTED_MODULE_0__/* .getStyleValue */ .Jq)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0,_mui_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return (0,_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .handleBreakpoints */ .k9)(props, val, styleFromPropValue);
  }
  function styleFunctionSx(props) {
    var _theme$unstable_sxCon;
    const {
      sx,
      theme = {}
    } = props || {};
    if (!sx) {
      return null; // Emotion & styled-components will neglect null
    }

    const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : _defaultSxConfig__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z;

    /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */
    function traverse(sxInput) {
      let sxObject = sxInput;
      if (typeof sxInput === 'function') {
        sxObject = sxInput(theme);
      } else if (typeof sxInput !== 'object') {
        // value
        return sxInput;
      }
      if (!sxObject) {
        return null;
      }
      const emptyBreakpoints = (0,_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .createEmptyBreakpointObject */ .W8)(theme.breakpoints);
      const breakpointsKeys = Object.keys(emptyBreakpoints);
      let css = emptyBreakpoints;
      Object.keys(sxObject).forEach(styleKey => {
        const value = callIfFn(sxObject[styleKey], theme);
        if (value !== null && value !== undefined) {
          if (typeof value === 'object') {
            if (config[styleKey]) {
              css = (0,_merge__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(css, getThemeValue(styleKey, value, theme, config));
            } else {
              const breakpointsValues = (0,_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .handleBreakpoints */ .k9)({
                theme
              }, value, x => ({
                [styleKey]: x
              }));
              if (objectsHaveSameKeys(breakpointsValues, value)) {
                css[styleKey] = styleFunctionSx({
                  sx: value,
                  theme
                });
              } else {
                css = (0,_merge__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(css, breakpointsValues);
              }
            }
          } else {
            css = (0,_merge__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(css, getThemeValue(styleKey, value, theme, config));
          }
        }
      });
      return (0,_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .removeUnusedBreakpoints */ .L7)(breakpointsKeys, css);
    }
    return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
  }
  return styleFunctionSx;
}
const styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = ['sx'];
/* harmony default export */ __webpack_exports__["Z"] = (styleFunctionSx);

/***/ }),

/***/ 96682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export systemDefaultTheme */
/* harmony import */ var _createTheme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66500);
/* harmony import */ var _useThemeWithoutDefault__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34168);


const systemDefaultTheme = (0,_createTheme__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
function useTheme(defaultTheme = systemDefaultTheme) {
  return (0,_useThemeWithoutDefault__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(defaultTheme);
}
/* harmony default export */ __webpack_exports__["Z"] = (useTheme);

/***/ }),

/***/ 1014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getThemeProps; }
});

;// CONCATENATED MODULE: ./node_modules/@mui/utils/esm/resolveProps.js
/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param {object} defaultProps
 * @param {object} props
 * @returns {object} resolved props
 */
function resolveProps(defaultProps, props) {
  const output = {
    ...props
  };
  Object.keys(defaultProps).forEach(propName => {
    if (propName.toString().match(/^(components|slots)$/)) {
      output[propName] = {
        ...defaultProps[propName],
        ...output[propName]
      };
    } else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
      const defaultSlotProps = defaultProps[propName] || {};
      const slotProps = props[propName];
      output[propName] = {};
      if (!slotProps || !Object.keys(slotProps)) {
        // Reduce the iteration if the slot props is empty
        output[propName] = defaultSlotProps;
      } else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) {
        // Reduce the iteration if the default slot props is empty
        output[propName] = slotProps;
      } else {
        output[propName] = {
          ...slotProps
        };
        Object.keys(defaultSlotProps).forEach(slotPropName => {
          output[propName][slotPropName] = resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName]);
        });
      }
    } else if (output[propName] === undefined) {
      output[propName] = defaultProps[propName];
    }
  });
  return output;
}
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/useThemeProps/getThemeProps.js

function getThemeProps(params) {
  const {
    theme,
    name,
    props
  } = params;
  if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) {
    return props;
  }
  return resolveProps(theme.components[name].defaultProps, props);
}

/***/ }),

/***/ 29628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useThemeProps; }
/* harmony export */ });
/* harmony import */ var _getThemeProps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1014);
/* harmony import */ var _useTheme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96682);


function useThemeProps({
  props,
  name,
  defaultTheme,
  themeId
}) {
  let theme = (0,_useTheme__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(defaultTheme);
  if (themeId) {
    theme = theme[themeId] || theme;
  }
  const mergedProps = (0,_getThemeProps__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    theme,
    name,
    props
  });
  return mergedProps;
}

/***/ }),

/***/ 34168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_styled_engine__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75260);


function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0;
}
function useTheme(defaultTheme = null) {
  const contextTheme = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_mui_styled_engine__WEBPACK_IMPORTED_MODULE_1__.T);
  return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
/* harmony default export */ __webpack_exports__["Z"] = (useTheme);

/***/ }),

/***/ 37078:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const defaultGenerator = componentName => componentName;
const createClassNameGenerator = () => {
  let generate = defaultGenerator;
  return {
    configure(generator) {
      generate = generator;
    },
    generate(componentName) {
      return generate(componentName);
    },
    reset() {
      generate = defaultGenerator;
    }
  };
};
const ClassNameGenerator = createClassNameGenerator();
/* harmony default export */ __webpack_exports__["Z"] = (ClassNameGenerator);

/***/ }),

/***/ 28320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ capitalize; }
/* harmony export */ });
/* harmony import */ var _formatMuiErrorMessage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71387);

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function capitalize(string) {
  if (typeof string !== 'string') {
    throw new Error( false ? 0 : (0,_formatMuiErrorMessage__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(7));
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/***/ }),

/***/ 94780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ composeClasses; }
/* harmony export */ });
function composeClasses(slots, getUtilityClass, classes = undefined) {
  const output = {};
  Object.keys(slots).forEach(
  // `Objet.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
  // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
  slot => {
    output[slot] = slots[slot].reduce((acc, key) => {
      if (key) {
        const utilityClass = getUtilityClass(key);
        if (utilityClass !== '') {
          acc.push(utilityClass);
        }
        if (classes && classes[key]) {
          acc.push(classes[key]);
        }
      }
      return acc;
    }, []).join(' ');
  });
  return output;
}

/***/ }),

/***/ 59766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ isPlainObject; },
/* harmony export */   "Z": function() { return /* binding */ deepmerge; }
/* harmony export */ });
function isPlainObject(item) {
  return item !== null && typeof item === 'object' && item.constructor === Object;
}
function deepClone(source) {
  if (!isPlainObject(source)) {
    return source;
  }
  const output = {};
  Object.keys(source).forEach(key => {
    output[key] = deepClone(source[key]);
  });
  return output;
}
function deepmerge(target, source, options = {
  clone: true
}) {
  const output = options.clone ? {
    ...target
  } : target;
  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(key => {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }
      if (isPlainObject(source[key]) && key in target && isPlainObject(target[key])) {
        // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = deepmerge(target[key], source[key], options);
      } else if (options.clone) {
        output[key] = isPlainObject(source[key]) ? deepClone(source[key]) : source[key];
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
}

/***/ }),

/***/ 71387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ formatMuiErrorMessage; }
/* harmony export */ });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe iff we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
  /* eslint-disable prefer-template */
  let url = 'https://mui.com/production-error/?code=' + code;
  for (let i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }
  return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

/***/ }),

/***/ 34867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ generateUtilityClass; }
/* harmony export */ });
/* harmony import */ var _ClassNameGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37078);

const globalStateClassesMapping = {
  active: 'active',
  checked: 'checked',
  completed: 'completed',
  disabled: 'disabled',
  readOnly: 'readOnly',
  error: 'error',
  expanded: 'expanded',
  focused: 'focused',
  focusVisible: 'focusVisible',
  required: 'required',
  selected: 'selected'
};
function generateUtilityClass(componentName, slot, globalStatePrefix = 'Mui') {
  const globalStateClass = globalStateClassesMapping[slot];
  return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${_ClassNameGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"].generate */ .Z.generate(componentName)}-${slot}`;
}

/***/ }),

/***/ 1588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ generateUtilityClasses; }
/* harmony export */ });
/* harmony import */ var _generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34867);

function generateUtilityClasses(componentName, slots, globalStatePrefix = 'Mui') {
  const result = {};
  slots.forEach(slot => {
    result[slot] = (0,_generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(componentName, slot, globalStatePrefix);
  });
  return result;
}

/***/ }),

/***/ 83959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ ALL; },
  "B": function() { return /* binding */ logError; },
  "C": function() { return /* binding */ CALL; },
  "D": function() { return /* binding */ wrapSagaDispatch; },
  "E": function() { return /* binding */ identity; },
  "F": function() { return /* binding */ FORK; },
  "G": function() { return /* binding */ GET_CONTEXT; },
  "J": function() { return /* binding */ JOIN; },
  "K": function() { return /* binding */ take; },
  "L": function() { return /* binding */ fork; },
  "M": function() { return /* binding */ cancel; },
  "N": function() { return /* binding */ call; },
  "P": function() { return /* binding */ PUT; },
  "R": function() { return /* binding */ RACE; },
  "S": function() { return /* binding */ SELECT; },
  "T": function() { return /* binding */ TAKE; },
  "Y": function() { return /* binding */ put; },
  "_": function() { return /* binding */ io_c3792963_all; },
  "a": function() { return /* binding */ CPS; },
  "a3": function() { return /* binding */ io_c3792963_select; },
  "b": function() { return /* binding */ CANCEL; },
  "d": function() { return /* binding */ ACTION_CHANNEL; },
  "e": function() { return /* binding */ expanding; },
  "f": function() { return /* binding */ CANCELLED; },
  "g": function() { return /* binding */ FLUSH; },
  "h": function() { return /* binding */ SET_CONTEXT; },
  "i": function() { return /* binding */ internalErr; },
  "j": function() { return /* binding */ getMetaInfo; },
  "k": function() { return /* binding */ kTrue; },
  "l": function() { return /* binding */ createAllStyleChildCallbacks; },
  "m": function() { return /* binding */ createEmptyArray; },
  "o": function() { return /* binding */ once; },
  "p": function() { return /* binding */ assignWithSymbols; },
  "q": function() { return /* binding */ makeIterator; },
  "r": function() { return /* binding */ remove; },
  "s": function() { return /* binding */ shouldComplete; },
  "t": function() { return /* binding */ noop; },
  "u": function() { return /* binding */ flatMap; },
  "v": function() { return /* binding */ getLocation; },
  "y": function() { return /* binding */ shouldCancel; },
  "z": function() { return /* binding */ shouldTerminate; }
});

// UNUSED EXPORTS: $, H, I, O, Q, U, V, W, X, Z, a0, a1, a2, a4, a5, a6, a7, c, n, w, x

// EXTERNAL MODULE: ./node_modules/@redux-saga/symbols/dist/redux-saga-symbols.esm.js
var redux_saga_symbols_esm = __webpack_require__(12470);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@redux-saga/is/dist/redux-saga-is.esm.js
var redux_saga_is_esm = __webpack_require__(52847);
;// CONCATENATED MODULE: ./node_modules/@redux-saga/delay-p/dist/redux-saga-delay-p.esm.js


var MAX_SIGNED_INT = 2147483647;
function delayP(ms, val) {
  if (val === void 0) {
    val = true;
  }

  // https://developer.mozilla.org/en-US/docs/Web/API/setTimeout#maximum_delay_value
  if (false) {}

  var timeoutId;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(resolve, Math.min(MAX_SIGNED_INT, ms), val);
  });

  promise[redux_saga_symbols_esm/* CANCEL */.n1] = function () {
    clearTimeout(timeoutId);
  };

  return promise;
}

/* harmony default export */ var redux_saga_delay_p_esm = (delayP);

;// CONCATENATED MODULE: ./node_modules/@redux-saga/core/dist/io-c3792963.js





var konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue =
/*#__PURE__*/
konst(true);

var noop = function noop() {};

if (false) {}
var identity = function identity(v) {
  return v;
};
var hasSymbol = typeof Symbol === 'function';
var asyncIteratorSymbol = hasSymbol && Symbol.asyncIterator ? Symbol.asyncIterator : '@@asyncIterator';
function check(value, predicate, error) {
  if (!predicate(value)) {
    throw new Error(error);
  }
}
var assignWithSymbols = function assignWithSymbols(target, source) {
  (0,esm_extends/* default */.Z)(target, source);

  if (Object.getOwnPropertySymbols) {
    Object.getOwnPropertySymbols(source).forEach(function (s) {
      target[s] = source[s];
    });
  }
};
var flatMap = function flatMap(mapper, arr) {
  var _ref;

  return (_ref = []).concat.apply(_ref, arr.map(mapper));
};
function remove(array, item) {
  var index = array.indexOf(item);

  if (index >= 0) {
    array.splice(index, 1);
  }
}
function once(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }

    called = true;
    fn();
  };
}

var kThrow = function kThrow(err) {
  throw err;
};

var kReturn = function kReturn(value) {
  return {
    value: value,
    done: true
  };
};

function makeIterator(next, thro, name) {
  if (thro === void 0) {
    thro = kThrow;
  }

  if (name === void 0) {
    name = 'iterator';
  }

  var iterator = {
    meta: {
      name: name
    },
    next: next,
    throw: thro,
    return: kReturn,
    isSagaIterator: true
  };

  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }

  return iterator;
}
function logError(error, _ref2) {
  var sagaStack = _ref2.sagaStack;

  /*eslint-disable no-console*/
  console.error(error);
  console.error(sagaStack);
}
var internalErr = function internalErr(err) {
  return new Error("\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project's github repo.\n  Error: " + err + "\n");
};
var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + "setContext(props): argument " + props + " is not a plain object";
};
var FROZEN_ACTION_ERROR = "You can't put (a.k.a. dispatch from saga) frozen actions.\nWe have to define a special non-enumerable property on those actions for scheduling purposes.\nOtherwise you wouldn't be able to communicate properly between sagas & other subscribers (action ordering would become far less predictable).\nIf you are using redux and you care about this behaviour (frozen actions),\nthen you might want to switch to freezing actions in a middleware rather than in action creator.\nExample implementation:\n\nconst freezeActions = store => next => action => next(Object.freeze(action))\n"; // creates empty, but not-holey array

var createEmptyArray = function createEmptyArray(n) {
  return Array.apply(null, new Array(n));
};
var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    if (false) {}

    return dispatch(Object.defineProperty(action, redux_saga_symbols_esm/* SAGA_ACTION */.Nm, {
      value: true
    }));
  };
};
var shouldTerminate = function shouldTerminate(res) {
  return res === redux_saga_symbols_esm/* TERMINATE */.EO;
};
var shouldCancel = function shouldCancel(res) {
  return res === redux_saga_symbols_esm/* TASK_CANCEL */.Wd;
};
var shouldComplete = function shouldComplete(res) {
  return shouldTerminate(res) || shouldCancel(res);
};
function createAllStyleChildCallbacks(shape, parentCallback) {
  var keys = Object.keys(shape);
  var totalCount = keys.length;

  if (false) {}

  var completedCount = 0;
  var completed;
  var results = (0,redux_saga_is_esm/* array */.IX)(shape) ? createEmptyArray(totalCount) : {};
  var childCallbacks = {};

  function checkEnd() {
    if (completedCount === totalCount) {
      completed = true;
      parentCallback(results);
    }
  }

  keys.forEach(function (key) {
    var chCbAtKey = function chCbAtKey(res, isErr) {
      if (completed) {
        return;
      }

      if (isErr || shouldComplete(res)) {
        parentCallback.cancel();
        parentCallback(res, isErr);
      } else {
        results[key] = res;
        completedCount++;
        checkEnd();
      }
    };

    chCbAtKey.cancel = noop;
    childCallbacks[key] = chCbAtKey;
  });

  parentCallback.cancel = function () {
    if (!completed) {
      completed = true;
      keys.forEach(function (key) {
        return childCallbacks[key].cancel();
      });
    }
  };

  return childCallbacks;
}
function getMetaInfo(fn) {
  return {
    name: fn.name || 'anonymous',
    location: getLocation(fn)
  };
}
function getLocation(instrumented) {
  return instrumented[redux_saga_symbols_esm/* SAGA_LOCATION */.b_];
}

var BUFFER_OVERFLOW = "Channel's Buffer overflow!";
var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;
var zeroBuffer = {
  isEmpty: kTrue,
  put: noop,
  take: noop
};

function ringBuffer(limit, overflowAction) {
  if (limit === void 0) {
    limit = 10;
  }

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];

    while (length) {
      items.push(take());
    }

    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit;

        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);

          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;

          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;
            arr = flush();
            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;
            arr.length = doubledLimit;
            limit = doubledLimit;
            push(it);
            break;

          default: // DROP

        }
      }
    },
    take: take,
    flush: flush
  };
}

var none = function none() {
  return zeroBuffer;
};
var fixed = function fixed(limit) {
  return ringBuffer(limit, ON_OVERFLOW_THROW);
};
var dropping = function dropping(limit) {
  return ringBuffer(limit, ON_OVERFLOW_DROP);
};
var sliding = function sliding(limit) {
  return ringBuffer(limit, ON_OVERFLOW_SLIDE);
};
var expanding = function expanding(initialSize) {
  return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
};

var buffers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  none: none,
  fixed: fixed,
  dropping: dropping,
  sliding: sliding,
  expanding: expanding
});

var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';

var effectTypes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  TAKE: TAKE,
  PUT: PUT,
  ALL: ALL,
  RACE: RACE,
  CALL: CALL,
  CPS: CPS,
  FORK: FORK,
  JOIN: JOIN,
  CANCEL: CANCEL,
  SELECT: SELECT,
  ACTION_CHANNEL: ACTION_CHANNEL,
  CANCELLED: CANCELLED,
  FLUSH: FLUSH,
  GET_CONTEXT: GET_CONTEXT,
  SET_CONTEXT: SET_CONTEXT
});

var TEST_HINT = '\n(HINT: if you are getting these errors in tests, consider using createMockTask from @redux-saga/testing-utils)';

var makeEffect = function makeEffect(type, payload) {
  var _ref;

  return _ref = {}, _ref[redux_saga_symbols_esm.IO] = true, _ref.combinator = false, _ref.type = type, _ref.payload = payload, _ref;
};

var isForkEffect = function isForkEffect(eff) {
  return effect(eff) && eff.type === FORK;
};

var detach = function detach(eff) {
  if (false) {}

  return makeEffect(FORK, _extends({}, eff.payload, {
    detached: true
  }));
};
function take(patternOrChannel, multicastPattern) {
  if (patternOrChannel === void 0) {
    patternOrChannel = '*';
  }

  if (false) {}

  if ((0,redux_saga_is_esm/* pattern */.uj)(patternOrChannel)) {
    if ((0,redux_saga_is_esm/* notUndef */.d5)(multicastPattern)) {
      /* eslint-disable no-console */
      console.warn("take(pattern) takes one argument but two were provided. Consider passing an array for listening to several action types");
    }

    return makeEffect(TAKE, {
      pattern: patternOrChannel
    });
  }

  if ((0,redux_saga_is_esm/* multicast */.Om)(patternOrChannel) && (0,redux_saga_is_esm/* notUndef */.d5)(multicastPattern) && (0,redux_saga_is_esm/* pattern */.uj)(multicastPattern)) {
    return makeEffect(TAKE, {
      channel: patternOrChannel,
      pattern: multicastPattern
    });
  }

  if ((0,redux_saga_is_esm/* channel */.CE)(patternOrChannel)) {
    if ((0,redux_saga_is_esm/* notUndef */.d5)(multicastPattern)) {
      /* eslint-disable no-console */
      console.warn("take(channel) takes one argument but two were provided. Second argument is ignored.");
    }

    return makeEffect(TAKE, {
      channel: patternOrChannel
    });
  }

  if (false) {}
}
var takeMaybe = function takeMaybe() {
  var eff = take.apply(void 0, arguments);
  eff.payload.maybe = true;
  return eff;
};
function put(channel$1, action) {
  if (false) {}

  if ((0,redux_saga_is_esm/* undef */.sR)(action)) {
    action = channel$1; // `undefined` instead of `null` to make default parameter work

    channel$1 = undefined;
  }

  return makeEffect(PUT, {
    channel: channel$1,
    action: action
  });
}
var putResolve = function putResolve() {
  var eff = put.apply(void 0, arguments);
  eff.payload.resolve = true;
  return eff;
};
function io_c3792963_all(effects) {
  var eff = makeEffect(ALL, effects);
  eff.combinator = true;
  return eff;
}
function race(effects) {
  var eff = makeEffect(RACE, effects);
  eff.combinator = true;
  return eff;
} // this match getFnCallDescriptor logic

var validateFnDescriptor = function validateFnDescriptor(effectName, fnDescriptor) {
  check(fnDescriptor, notUndef, effectName + ": argument fn is undefined or null");

  if (func(fnDescriptor)) {
    return;
  }

  var context = null;
  var fn;

  if (array(fnDescriptor)) {
    context = fnDescriptor[0];
    fn = fnDescriptor[1];
    check(fn, notUndef, effectName + ": argument of type [context, fn] has undefined or null `fn`");
  } else if (object(fnDescriptor)) {
    context = fnDescriptor.context;
    fn = fnDescriptor.fn;
    check(fn, notUndef, effectName + ": argument of type {context, fn} has undefined or null `fn`");
  } else {
    check(fnDescriptor, func, effectName + ": argument fn is not function");
    return;
  }

  if (context && string(fn)) {
    check(context[fn], func, effectName + ": context arguments has no such method - \"" + fn + "\"");
    return;
  }

  check(fn, func, effectName + ": unpacked fn argument (from [context, fn] or {context, fn}) is not a function");
};

function getFnCallDescriptor(fnDescriptor, args) {
  var context = null;
  var fn;

  if ((0,redux_saga_is_esm/* func */.Yl)(fnDescriptor)) {
    fn = fnDescriptor;
  } else {
    if ((0,redux_saga_is_esm/* array */.IX)(fnDescriptor)) {
      context = fnDescriptor[0];
      fn = fnDescriptor[1];
    } else {
      context = fnDescriptor.context;
      fn = fnDescriptor.fn;
    }

    if (context && (0,redux_saga_is_esm/* string */.Z_)(fn) && (0,redux_saga_is_esm/* func */.Yl)(context[fn])) {
      fn = context[fn];
    }
  }

  return {
    context: context,
    fn: fn,
    args: args
  };
}

var isNotDelayEffect = function isNotDelayEffect(fn) {
  return fn !== delay;
};

function call(fnDescriptor) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (false) { var arg0; }

  return makeEffect(CALL, getFnCallDescriptor(fnDescriptor, args));
}
function apply(context, fn, args) {
  if (args === void 0) {
    args = [];
  }

  var fnDescriptor = [context, fn];

  if (false) {}

  return makeEffect(CALL, getFnCallDescriptor([context, fn], args));
}
function cps(fnDescriptor) {
  if (false) {}

  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return makeEffect(CPS, getFnCallDescriptor(fnDescriptor, args));
}
function fork(fnDescriptor) {
  if (false) {}

  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return makeEffect(FORK, getFnCallDescriptor(fnDescriptor, args));
}
function spawn(fnDescriptor) {
  if (false) {}

  for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  return detach(fork.apply(void 0, [fnDescriptor].concat(args)));
}
function join(taskOrTasks) {
  if (false) {}

  return makeEffect(JOIN, taskOrTasks);
}
function cancel(taskOrTasks) {
  if (taskOrTasks === void 0) {
    taskOrTasks = redux_saga_symbols_esm/* SELF_CANCELLATION */.sC;
  }

  if (false) {}

  return makeEffect(CANCEL, taskOrTasks);
}
function io_c3792963_select(selector) {
  if (selector === void 0) {
    selector = identity;
  }

  for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    args[_key5 - 1] = arguments[_key5];
  }

  if (false) {}

  return makeEffect(SELECT, {
    selector: selector,
    args: args
  });
}
/**
  channel(pattern, [buffer])    => creates a proxy channel for store actions
**/

function actionChannel(pattern$1, buffer$1) {
  if (false) {}

  return makeEffect(ACTION_CHANNEL, {
    pattern: pattern$1,
    buffer: buffer$1
  });
}
function cancelled() {
  return makeEffect(CANCELLED, {});
}
function flush(channel$1) {
  if (false) {}

  return makeEffect(FLUSH, channel$1);
}
function getContext(prop) {
  if (false) {}

  return makeEffect(GET_CONTEXT, prop);
}
function setContext(props) {
  if (false) {}

  return makeEffect(SET_CONTEXT, props);
}
var delay =
/*#__PURE__*/
call.bind(null, redux_saga_delay_p_esm);




/***/ }),

/***/ 52847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CE": function() { return /* binding */ channel; },
/* harmony export */   "IX": function() { return /* binding */ array; },
/* harmony export */   "MC": function() { return /* binding */ promise; },
/* harmony export */   "NA": function() { return /* binding */ symbol; },
/* harmony export */   "Om": function() { return /* binding */ multicast; },
/* harmony export */   "Yl": function() { return /* binding */ func; },
/* harmony export */   "Z_": function() { return /* binding */ string; },
/* harmony export */   "d5": function() { return /* binding */ notUndef; },
/* harmony export */   "eR": function() { return /* binding */ stringableFunc; },
/* harmony export */   "hZ": function() { return /* binding */ iterator; },
/* harmony export */   "sR": function() { return /* binding */ undef; },
/* harmony export */   "uj": function() { return /* binding */ pattern; }
/* harmony export */ });
/* unused harmony exports buffer, effect, iterable, number, object, observable, sagaAction, task */
/* harmony import */ var _redux_saga_symbols__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12470);


var undef = function undef(v) {
  return v === null || v === undefined;
};
var notUndef = function notUndef(v) {
  return v !== null && v !== undefined;
};
var func = function func(f) {
  return typeof f === 'function';
};
var number = function number(n) {
  return typeof n === 'number';
};
var string = function string(s) {
  return typeof s === 'string';
};
var array = Array.isArray;
var object = function object(obj) {
  return obj && !array(obj) && typeof obj === 'object';
};
var promise = function promise(p) {
  return p && func(p.then);
};
var iterator = function iterator(it) {
  return it && func(it.next) && func(it.throw);
};
var iterable = function iterable(it) {
  return it && func(Symbol) ? func(it[Symbol.iterator]) : array(it);
};
var task = function task(t) {
  return t && t[TASK];
};
var sagaAction = function sagaAction(a) {
  return Boolean(a && a[SAGA_ACTION]);
};
var observable = function observable(ob) {
  return ob && func(ob.subscribe);
};
var buffer = function buffer(buf) {
  return buf && func(buf.isEmpty) && func(buf.take) && func(buf.put);
};
var pattern = function pattern(pat) {
  return pat && (string(pat) || symbol(pat) || func(pat) || array(pat) && pat.every(pattern));
};
var channel = function channel(ch) {
  return ch && func(ch.take) && func(ch.close);
};
var stringableFunc = function stringableFunc(f) {
  return func(f) && f.hasOwnProperty('toString');
};
var symbol = function symbol(sym) {
  return Boolean(sym) && typeof Symbol === 'function' && sym.constructor === Symbol && sym !== Symbol.prototype;
};
var multicast = function multicast(ch) {
  return channel(ch) && ch[_redux_saga_symbols__WEBPACK_IMPORTED_MODULE_0__/* .MULTICAST */ .AS];
};
var effect = function effect(eff) {
  return eff && eff[IO];
};




/***/ }),

/***/ 12470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AS": function() { return /* binding */ MULTICAST; },
/* harmony export */   "Cs": function() { return /* binding */ TASK; },
/* harmony export */   "EO": function() { return /* binding */ TERMINATE; },
/* harmony export */   "IO": function() { return /* binding */ IO; },
/* harmony export */   "Nm": function() { return /* binding */ SAGA_ACTION; },
/* harmony export */   "Wd": function() { return /* binding */ TASK_CANCEL; },
/* harmony export */   "b_": function() { return /* binding */ SAGA_LOCATION; },
/* harmony export */   "n1": function() { return /* binding */ CANCEL; },
/* harmony export */   "sC": function() { return /* binding */ SELF_CANCELLATION; },
/* harmony export */   "sZ": function() { return /* binding */ CHANNEL_END_TYPE; },
/* harmony export */   "uq": function() { return /* binding */ MATCH; }
/* harmony export */ });
var createSymbol = function createSymbol(name) {
  return "@@redux-saga/" + name;
};

var CANCEL =
/*#__PURE__*/
createSymbol('CANCEL_PROMISE');
var CHANNEL_END_TYPE =
/*#__PURE__*/
createSymbol('CHANNEL_END');
var IO =
/*#__PURE__*/
createSymbol('IO');
var MATCH =
/*#__PURE__*/
createSymbol('MATCH');
var MULTICAST =
/*#__PURE__*/
createSymbol('MULTICAST');
var SAGA_ACTION =
/*#__PURE__*/
createSymbol('SAGA_ACTION');
var SELF_CANCELLATION =
/*#__PURE__*/
createSymbol('SELF_CANCELLATION');
var TASK =
/*#__PURE__*/
createSymbol('TASK');
var TASK_CANCEL =
/*#__PURE__*/
createSymbol('TASK_CANCEL');
var TERMINATE =
/*#__PURE__*/
createSymbol('TERMINATE');
var SAGA_LOCATION =
/*#__PURE__*/
createSymbol('LOCATION');




/***/ }),

/***/ 27272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "PH": function() { return /* binding */ createAction; },
  "oM": function() { return /* binding */ createSlice; },
  "x0": function() { return /* binding */ nanoid; }
});

// UNUSED EXPORTS: EnhancerArray, MiddlewareArray, SHOULD_AUTOBATCH, TaskAbortError, __DO_NOT_USE__ActionTypes, addListener, applyMiddleware, autoBatchEnhancer, bindActionCreators, clearAllListeners, combineReducers, compose, configureStore, createAsyncThunk, createDraftSafeSelector, createEntityAdapter, createImmutableStateInvariantMiddleware, createListenerMiddleware, createNextState, createReducer, createSelector, createSerializableStateInvariantMiddleware, createStore, current, findNonSerializableValue, freeze, getDefaultMiddleware, getType, isAction, isAllOf, isAnyOf, isAsyncThunkAction, isDraft, isFluxStandardAction, isFulfilled, isImmutableDefault, isPending, isPlain, isPlainObject, isRejected, isRejectedWithValue, legacy_createStore, miniSerializeError, original, prepareAutoBatched, removeListener, unwrapResult

;// CONCATENATED MODULE: ./node_modules/immer/dist/immer.esm.mjs
function n(n){for(var r=arguments.length,t=Array(r>1?r-1:0),e=1;e<r;e++)t[e-1]=arguments[e];if(false){ var i, o; }throw Error("[Immer] minified error nr: "+n+(t.length?" "+t.map((function(n){return"'"+n+"'"})).join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function r(n){return!!n&&!!n[Q]}function t(n){var r;return!!n&&(function(n){if(!n||"object"!=typeof n)return!1;var r=Object.getPrototypeOf(n);if(null===r)return!0;var t=Object.hasOwnProperty.call(r,"constructor")&&r.constructor;return t===Object||"function"==typeof t&&Function.toString.call(t)===Z}(n)||Array.isArray(n)||!!n[L]||!!(null===(r=n.constructor)||void 0===r?void 0:r[L])||s(n)||v(n))}function e(t){return r(t)||n(23,t),t[Q].t}function i(n,r,t){void 0===t&&(t=!1),0===o(n)?(t?Object.keys:nn)(n).forEach((function(e){t&&"symbol"==typeof e||r(e,n[e],n)})):n.forEach((function(t,e){return r(e,t,n)}))}function o(n){var r=n[Q];return r?r.i>3?r.i-4:r.i:Array.isArray(n)?1:s(n)?2:v(n)?3:0}function u(n,r){return 2===o(n)?n.has(r):Object.prototype.hasOwnProperty.call(n,r)}function a(n,r){return 2===o(n)?n.get(r):n[r]}function f(n,r,t){var e=o(n);2===e?n.set(r,t):3===e?n.add(t):n[r]=t}function c(n,r){return n===r?0!==n||1/n==1/r:n!=n&&r!=r}function s(n){return X&&n instanceof Map}function v(n){return q&&n instanceof Set}function p(n){return n.o||n.t}function l(n){if(Array.isArray(n))return Array.prototype.slice.call(n);var r=rn(n);delete r[Q];for(var t=nn(r),e=0;e<t.length;e++){var i=t[e],o=r[i];!1===o.writable&&(o.writable=!0,o.configurable=!0),(o.get||o.set)&&(r[i]={configurable:!0,writable:!0,enumerable:o.enumerable,value:n[i]})}return Object.create(Object.getPrototypeOf(n),r)}function d(n,e){return void 0===e&&(e=!1),y(n)||r(n)||!t(n)||(o(n)>1&&(n.set=n.add=n.clear=n.delete=h),Object.freeze(n),e&&i(n,(function(n,r){return d(r,!0)}),!0)),n}function h(){n(2)}function y(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function b(r){var t=tn[r];return t||n(18,r),t}function m(n,r){tn[n]||(tn[n]=r)}function _(){return true||0,U}function j(n,r){r&&(b("Patches"),n.u=[],n.s=[],n.v=r)}function g(n){O(n),n.p.forEach(S),n.p=null}function O(n){n===U&&(U=n.l)}function w(n){return U={p:[],l:U,h:n,m:!0,_:0}}function S(n){var r=n[Q];0===r.i||1===r.i?r.j():r.g=!0}function P(r,e){e._=e.p.length;var i=e.p[0],o=void 0!==r&&r!==i;return e.h.O||b("ES5").S(e,r,o),o?(i[Q].P&&(g(e),n(4)),t(r)&&(r=M(e,r),e.l||x(e,r)),e.u&&b("Patches").M(i[Q].t,r,e.u,e.s)):r=M(e,i,[]),g(e),e.u&&e.v(e.u,e.s),r!==H?r:void 0}function M(n,r,t){if(y(r))return r;var e=r[Q];if(!e)return i(r,(function(i,o){return A(n,e,r,i,o,t)}),!0),r;if(e.A!==n)return r;if(!e.P)return x(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=l(e.k):e.o,u=o,a=!1;3===e.i&&(u=new Set(o),o.clear(),a=!0),i(u,(function(r,i){return A(n,e,o,r,i,t,a)})),x(n,o,!1),t&&n.u&&b("Patches").N(e,t,n.u,n.s)}return e.o}function A(e,i,o,a,c,s,v){if( false&&0,r(c)){var p=M(e,c,s&&i&&3!==i.i&&!u(i.R,a)?s.concat(a):void 0);if(f(o,a,p),!r(p))return;e.m=!1}else v&&o.add(c);if(t(c)&&!y(c)){if(!e.h.D&&e._<1)return;M(e,c),i&&i.A.l||x(e,c)}}function x(n,r,t){void 0===t&&(t=!1),!n.l&&n.h.D&&n.m&&d(r,t)}function z(n,r){var t=n[Q];return(t?p(t):n)[r]}function I(n,r){if(r in n)for(var t=Object.getPrototypeOf(n);t;){var e=Object.getOwnPropertyDescriptor(t,r);if(e)return e;t=Object.getPrototypeOf(t)}}function k(n){n.P||(n.P=!0,n.l&&k(n.l))}function E(n){n.o||(n.o=l(n.t))}function N(n,r,t){var e=s(r)?b("MapSet").F(r,t):v(r)?b("MapSet").T(r,t):n.O?function(n,r){var t=Array.isArray(n),e={i:t?1:0,A:r?r.A:_(),P:!1,I:!1,R:{},l:r,t:n,k:null,o:null,j:null,C:!1},i=e,o=en;t&&(i=[e],o=on);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(r,t):b("ES5").J(r,t);return(t?t.A:_()).p.push(e),e}function R(e){return r(e)||n(22,e),function n(r){if(!t(r))return r;var e,u=r[Q],c=o(r);if(u){if(!u.P&&(u.i<4||!b("ES5").K(u)))return u.t;u.I=!0,e=D(r,c),u.I=!1}else e=D(r,c);return i(e,(function(r,t){u&&a(u.t,r)===t||f(e,r,n(t))})),3===c?new Set(e):e}(e)}function D(n,r){switch(r){case 2:return new Map(n);case 3:return Array.from(n)}return l(n)}function F(){function t(n,r){var t=s[n];return t?t.enumerable=r:s[n]=t={configurable:!0,enumerable:r,get:function(){var r=this[Q];return false&&0,en.get(r,n)},set:function(r){var t=this[Q]; false&&0,en.set(t,n,r)}},t}function e(n){for(var r=n.length-1;r>=0;r--){var t=n[r][Q];if(!t.P)switch(t.i){case 5:a(t)&&k(t);break;case 4:o(t)&&k(t)}}}function o(n){for(var r=n.t,t=n.k,e=nn(t),i=e.length-1;i>=0;i--){var o=e[i];if(o!==Q){var a=r[o];if(void 0===a&&!u(r,o))return!0;var f=t[o],s=f&&f[Q];if(s?s.t!==a:!c(f,a))return!0}}var v=!!r[Q];return e.length!==nn(r).length+(v?0:1)}function a(n){var r=n.k;if(r.length!==n.t.length)return!0;var t=Object.getOwnPropertyDescriptor(r,r.length-1);if(t&&!t.get)return!0;for(var e=0;e<r.length;e++)if(!r.hasOwnProperty(e))return!0;return!1}function f(r){r.g&&n(3,JSON.stringify(p(r)))}var s={};m("ES5",{J:function(n,r){var e=Array.isArray(n),i=function(n,r){if(n){for(var e=Array(r.length),i=0;i<r.length;i++)Object.defineProperty(e,""+i,t(i,!0));return e}var o=rn(r);delete o[Q];for(var u=nn(o),a=0;a<u.length;a++){var f=u[a];o[f]=t(f,n||!!o[f].enumerable)}return Object.create(Object.getPrototypeOf(r),o)}(e,n),o={i:e?5:4,A:r?r.A:_(),P:!1,I:!1,R:{},l:r,t:n,k:i,o:null,g:!1,C:!1};return Object.defineProperty(i,Q,{value:o,writable:!0}),i},S:function(n,t,o){o?r(t)&&t[Q].A===n&&e(n.p):(n.u&&function n(r){if(r&&"object"==typeof r){var t=r[Q];if(t){var e=t.t,o=t.k,f=t.R,c=t.i;if(4===c)i(o,(function(r){r!==Q&&(void 0!==e[r]||u(e,r)?f[r]||n(o[r]):(f[r]=!0,k(t)))})),i(e,(function(n){void 0!==o[n]||u(o,n)||(f[n]=!1,k(t))}));else if(5===c){if(a(t)&&(k(t),f.length=!0),o.length<e.length)for(var s=o.length;s<e.length;s++)f[s]=!1;else for(var v=e.length;v<o.length;v++)f[v]=!0;for(var p=Math.min(o.length,e.length),l=0;l<p;l++)o.hasOwnProperty(l)||(f[l]=!0),void 0===f[l]&&n(o[l])}}}}(n.p[0]),e(n.p))},K:function(n){return 4===n.i?o(n):a(n)}})}function T(){function e(n){if(!t(n))return n;if(Array.isArray(n))return n.map(e);if(s(n))return new Map(Array.from(n.entries()).map((function(n){return[n[0],e(n[1])]})));if(v(n))return new Set(Array.from(n).map(e));var r=Object.create(Object.getPrototypeOf(n));for(var i in n)r[i]=e(n[i]);return u(n,L)&&(r[L]=n[L]),r}function f(n){return r(n)?e(n):n}var c="add";m("Patches",{$:function(r,t){return t.forEach((function(t){for(var i=t.path,u=t.op,f=r,s=0;s<i.length-1;s++){var v=o(f),p=i[s];"string"!=typeof p&&"number"!=typeof p&&(p=""+p),0!==v&&1!==v||"__proto__"!==p&&"constructor"!==p||n(24),"function"==typeof f&&"prototype"===p&&n(24),"object"!=typeof(f=a(f,p))&&n(15,i.join("/"))}var l=o(f),d=e(t.value),h=i[i.length-1];switch(u){case"replace":switch(l){case 2:return f.set(h,d);case 3:n(16);default:return f[h]=d}case c:switch(l){case 1:return"-"===h?f.push(d):f.splice(h,0,d);case 2:return f.set(h,d);case 3:return f.add(d);default:return f[h]=d}case"remove":switch(l){case 1:return f.splice(h,1);case 2:return f.delete(h);case 3:return f.delete(t.value);default:return delete f[h]}default:n(17,u)}})),r},N:function(n,r,t,e){switch(n.i){case 0:case 4:case 2:return function(n,r,t,e){var o=n.t,s=n.o;i(n.R,(function(n,i){var v=a(o,n),p=a(s,n),l=i?u(o,n)?"replace":c:"remove";if(v!==p||"replace"!==l){var d=r.concat(n);t.push("remove"===l?{op:l,path:d}:{op:l,path:d,value:p}),e.push(l===c?{op:"remove",path:d}:"remove"===l?{op:c,path:d,value:f(v)}:{op:"replace",path:d,value:f(v)})}}))}(n,r,t,e);case 5:case 1:return function(n,r,t,e){var i=n.t,o=n.R,u=n.o;if(u.length<i.length){var a=[u,i];i=a[0],u=a[1];var s=[e,t];t=s[0],e=s[1]}for(var v=0;v<i.length;v++)if(o[v]&&u[v]!==i[v]){var p=r.concat([v]);t.push({op:"replace",path:p,value:f(u[v])}),e.push({op:"replace",path:p,value:f(i[v])})}for(var l=i.length;l<u.length;l++){var d=r.concat([l]);t.push({op:c,path:d,value:f(u[l])})}i.length<u.length&&e.push({op:"replace",path:r.concat(["length"]),value:i.length})}(n,r,t,e);case 3:return function(n,r,t,e){var i=n.t,o=n.o,u=0;i.forEach((function(n){if(!o.has(n)){var i=r.concat([u]);t.push({op:"remove",path:i,value:n}),e.unshift({op:c,path:i,value:n})}u++})),u=0,o.forEach((function(n){if(!i.has(n)){var o=r.concat([u]);t.push({op:c,path:o,value:n}),e.unshift({op:"remove",path:o,value:n})}u++}))}(n,r,t,e)}},M:function(n,r,t,e){t.push({op:"replace",path:[],value:r===H?void 0:r}),e.push({op:"replace",path:[],value:n})}})}function C(){function r(n,r){function t(){this.constructor=n}a(n,r),n.prototype=(t.prototype=r.prototype,new t)}function e(n){n.o||(n.R=new Map,n.o=new Map(n.t))}function o(n){n.o||(n.o=new Set,n.t.forEach((function(r){if(t(r)){var e=N(n.A.h,r,n);n.p.set(r,e),n.o.add(e)}else n.o.add(r)})))}function u(r){r.g&&n(3,JSON.stringify(p(r)))}var a=function(n,r){return(a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(n,r){n.__proto__=r}||function(n,r){for(var t in r)r.hasOwnProperty(t)&&(n[t]=r[t])})(n,r)},f=function(){function n(n,r){return this[Q]={i:2,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,R:void 0,t:n,k:this,C:!1,g:!1},this}r(n,Map);var o=n.prototype;return Object.defineProperty(o,"size",{get:function(){return p(this[Q]).size}}),o.has=function(n){return p(this[Q]).has(n)},o.set=function(n,r){var t=this[Q];return u(t),p(t).has(n)&&p(t).get(n)===r||(e(t),k(t),t.R.set(n,!0),t.o.set(n,r),t.R.set(n,!0)),this},o.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),e(r),k(r),r.t.has(n)?r.R.set(n,!1):r.R.delete(n),r.o.delete(n),!0},o.clear=function(){var n=this[Q];u(n),p(n).size&&(e(n),k(n),n.R=new Map,i(n.t,(function(r){n.R.set(r,!1)})),n.o.clear())},o.forEach=function(n,r){var t=this;p(this[Q]).forEach((function(e,i){n.call(r,t.get(i),i,t)}))},o.get=function(n){var r=this[Q];u(r);var i=p(r).get(n);if(r.I||!t(i))return i;if(i!==r.t.get(n))return i;var o=N(r.A.h,i,r);return e(r),r.o.set(n,o),o},o.keys=function(){return p(this[Q]).keys()},o.values=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.values()},n.next=function(){var n=t.next();return n.done?n:{done:!1,value:r.get(n.value)}},n},o.entries=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.entries()},n.next=function(){var n=t.next();if(n.done)return n;var e=r.get(n.value);return{done:!1,value:[n.value,e]}},n},o[V]=function(){return this.entries()},n}(),c=function(){function n(n,r){return this[Q]={i:3,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,t:n,k:this,p:new Map,g:!1,C:!1},this}r(n,Set);var t=n.prototype;return Object.defineProperty(t,"size",{get:function(){return p(this[Q]).size}}),t.has=function(n){var r=this[Q];return u(r),r.o?!!r.o.has(n)||!(!r.p.has(n)||!r.o.has(r.p.get(n))):r.t.has(n)},t.add=function(n){var r=this[Q];return u(r),this.has(n)||(o(r),k(r),r.o.add(n)),this},t.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),o(r),k(r),r.o.delete(n)||!!r.p.has(n)&&r.o.delete(r.p.get(n))},t.clear=function(){var n=this[Q];u(n),p(n).size&&(o(n),k(n),n.o.clear())},t.values=function(){var n=this[Q];return u(n),o(n),n.o.values()},t.entries=function(){var n=this[Q];return u(n),o(n),n.o.entries()},t.keys=function(){return this.values()},t[V]=function(){return this.values()},t.forEach=function(n,r){for(var t=this.values(),e=t.next();!e.done;)n.call(r,e.value,e.value,this),e=t.next()},n}();m("MapSet",{F:function(n,r){return new f(n,r)},T:function(n,r){return new c(n,r)}})}function J(){F(),C(),T()}function K(n){return n}function $(n){return n}var G,U,W="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),X="undefined"!=typeof Map,q="undefined"!=typeof Set,B="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,H=W?Symbol.for("immer-nothing"):((G={})["immer-nothing"]=!0,G),L=W?Symbol.for("immer-draftable"):"__$immer_draftable",Q=W?Symbol.for("immer-state"):"__$immer_state",V="undefined"!=typeof Symbol&&Symbol.iterator||"@@iterator",Y={0:"Illegal state",1:"Immer drafts cannot have computed properties",2:"This object has been frozen and should not be mutated",3:function(n){return"Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? "+n},4:"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",5:"Immer forbids circular references",6:"The first or second argument to `produce` must be a function",7:"The third argument to `produce` must be a function or undefined",8:"First argument to `createDraft` must be a plain object, an array, or an immerable object",9:"First argument to `finishDraft` must be a draft returned by `createDraft`",10:"The given draft is already finalized",11:"Object.defineProperty() cannot be used on an Immer draft",12:"Object.setPrototypeOf() cannot be used on an Immer draft",13:"Immer only supports deleting array indices",14:"Immer only supports setting array indices and the 'length' property",15:function(n){return"Cannot apply patch, path doesn't resolve: "+n},16:'Sets cannot have "replace" patches.',17:function(n){return"Unsupported patch operation: "+n},18:function(n){return"The plugin for '"+n+"' has not been loaded into Immer. To enable the plugin, import and call `enable"+n+"()` when initializing your application."},20:"Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",21:function(n){return"produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '"+n+"'"},22:function(n){return"'current' expects a draft, got: "+n},23:function(n){return"'original' expects a draft, got: "+n},24:"Patching reserved attributes like __proto__, prototype and constructor is not allowed"},Z=""+Object.prototype.constructor,nn="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,rn=Object.getOwnPropertyDescriptors||function(n){var r={};return nn(n).forEach((function(t){r[t]=Object.getOwnPropertyDescriptor(n,t)})),r},tn={},en={get:function(n,r){if(r===Q)return n;var e=p(n);if(!u(e,r))return function(n,r,t){var e,i=I(r,t);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,r);var i=e[r];return n.I||!t(i)?i:i===z(n.t,r)?(E(n),n.o[r]=N(n.A.h,i,n)):i},has:function(n,r){return r in p(n)},ownKeys:function(n){return Reflect.ownKeys(p(n))},set:function(n,r,t){var e=I(p(n),r);if(null==e?void 0:e.set)return e.set.call(n.k,t),!0;if(!n.P){var i=z(p(n),r),o=null==i?void 0:i[Q];if(o&&o.t===t)return n.o[r]=t,n.R[r]=!1,!0;if(c(t,i)&&(void 0!==t||u(n.t,r)))return!0;E(n),k(n)}return n.o[r]===t&&(void 0!==t||r in n.o)||Number.isNaN(t)&&Number.isNaN(n.o[r])||(n.o[r]=t,n.R[r]=!0),!0},deleteProperty:function(n,r){return void 0!==z(n.t,r)||r in n.t?(n.R[r]=!1,E(n),k(n)):delete n.R[r],n.o&&delete n.o[r],!0},getOwnPropertyDescriptor:function(n,r){var t=p(n),e=Reflect.getOwnPropertyDescriptor(t,r);return e?{writable:!0,configurable:1!==n.i||"length"!==r,enumerable:e.enumerable,value:t[r]}:e},defineProperty:function(){n(11)},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n(12)}},on={};i(en,(function(n,r){on[n]=function(){return arguments[0]=arguments[0][0],r.apply(this,arguments)}})),on.deleteProperty=function(r,t){return false&&0,on.set.call(this,r,t,void 0)},on.set=function(r,t,e){return false&&0,en.set.call(this,r[0],t,e,r[0])};var un=function(){function e(r){var e=this;this.O=B,this.D=!0,this.produce=function(r,i,o){if("function"==typeof r&&"function"!=typeof i){var u=i;i=r;var a=e;return function(n){var r=this;void 0===n&&(n=u);for(var t=arguments.length,e=Array(t>1?t-1:0),o=1;o<t;o++)e[o-1]=arguments[o];return a.produce(n,(function(n){var t;return(t=i).call.apply(t,[r,n].concat(e))}))}}var f;if("function"!=typeof i&&n(6),void 0!==o&&"function"!=typeof o&&n(7),t(r)){var c=w(e),s=N(e,r,void 0),v=!0;try{f=i(s),v=!1}finally{v?g(c):O(c)}return"undefined"!=typeof Promise&&f instanceof Promise?f.then((function(n){return j(c,o),P(n,c)}),(function(n){throw g(c),n})):(j(c,o),P(f,c))}if(!r||"object"!=typeof r){if(void 0===(f=i(r))&&(f=r),f===H&&(f=void 0),e.D&&d(f,!0),o){var p=[],l=[];b("Patches").M(r,f,p,l),o(p,l)}return f}n(21,r)},this.produceWithPatches=function(n,r){if("function"==typeof n)return function(r){for(var t=arguments.length,i=Array(t>1?t-1:0),o=1;o<t;o++)i[o-1]=arguments[o];return e.produceWithPatches(r,(function(r){return n.apply(void 0,[r].concat(i))}))};var t,i,o=e.produce(n,r,(function(n,r){t=n,i=r}));return"undefined"!=typeof Promise&&o instanceof Promise?o.then((function(n){return[n,t,i]})):[o,t,i]},"boolean"==typeof(null==r?void 0:r.useProxies)&&this.setUseProxies(r.useProxies),"boolean"==typeof(null==r?void 0:r.autoFreeze)&&this.setAutoFreeze(r.autoFreeze)}var i=e.prototype;return i.createDraft=function(e){t(e)||n(8),r(e)&&(e=R(e));var i=w(this),o=N(this,e,void 0);return o[Q].C=!0,O(i),o},i.finishDraft=function(r,t){var e=r&&r[Q]; false&&(0);var i=e.A;return j(i,t),P(void 0,i)},i.setAutoFreeze=function(n){this.D=n},i.setUseProxies=function(r){r&&!B&&n(20),this.O=r},i.applyPatches=function(n,t){var e;for(e=t.length-1;e>=0;e--){var i=t[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}e>-1&&(t=t.slice(e+1));var o=b("Patches").$;return r(n)?o(n,t):this.produce(n,(function(n){return o(n,t)}))},e}(),an=new un,fn=an.produce,cn=an.produceWithPatches.bind(an),sn=an.setAutoFreeze.bind(an),vn=an.setUseProxies.bind(an),pn=an.applyPatches.bind(an),ln=an.createDraft.bind(an),dn=an.finishDraft.bind(an);/* harmony default export */ var immer_esm = (fn);
//# sourceMappingURL=immer.esm.js.map

// EXTERNAL MODULE: ./node_modules/redux/es/redux.js + 1 modules
var redux = __webpack_require__(45217);
;// CONCATENATED MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js
/* provided dependency */ var process = __webpack_require__(83454);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function (obj, key, value) { return key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value; };
var __spreadValues = function (a, b) {
    for (var prop in b || (b = {}))
        if (__hasOwnProp.call(b, prop))
            __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols)
        for (var _i = 0, _c = __getOwnPropSymbols(b); _i < _c.length; _i++) {
            var prop = _c[_i];
            if (__propIsEnum.call(b, prop))
                __defNormalProp(a, prop, b[prop]);
        }
    return a;
};
var __spreadProps = function (a, b) { return __defProps(a, __getOwnPropDescs(b)); };
var __async = function (__this, __arguments, generator) {
    return new Promise(function (resolve, reject) {
        var fulfilled = function (value) {
            try {
                step(generator.next(value));
            }
            catch (e) {
                reject(e);
            }
        };
        var rejected = function (value) {
            try {
                step(generator.throw(value));
            }
            catch (e) {
                reject(e);
            }
        };
        var step = function (x) { return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected); };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
// src/index.ts




// src/createDraftSafeSelector.ts


var createDraftSafeSelector = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var selector = createSelector.apply(void 0, args);
    var wrappedSelector = function (value) {
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        return selector.apply(void 0, __spreadArray([isDraft(value) ? current(value) : value], rest));
    };
    return wrappedSelector;
};
// src/configureStore.ts

// src/devtoolsExtension.ts

var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function () {
    if (arguments.length === 0)
        return void 0;
    if (typeof arguments[0] === "object")
        return redux/* compose */.qC;
    return redux/* compose.apply */.qC.apply(null, arguments);
};
var devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function () {
    return function (noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function isPlainObject(value) {
    if (typeof value !== "object" || value === null)
        return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null)
        return true;
    var baseProto = proto;
    while (Object.getPrototypeOf(baseProto) !== null) {
        baseProto = Object.getPrototypeOf(baseProto);
    }
    return proto === baseProto;
}
// src/getDefaultMiddleware.ts

// src/utils.ts

function getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function (fn) {
            var started = Date.now();
            try {
                return fn();
            }
            finally {
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function () {
            if (elapsed > maxDelay) {
                console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
            }
        }
    };
}
var MiddlewareArray = /** @class */ (function (_super) {
    __extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function () {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        if (arr.length === 1 && Array.isArray(arr[0])) {
            return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([void 0], arr[0].concat(this))))();
        }
        return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([void 0], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array));
var EnhancerArray = /** @class */ (function (_super) {
    __extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function () {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        if (arr.length === 1 && Array.isArray(arr[0])) {
            return new (EnhancerArray.bind.apply(EnhancerArray, __spreadArray([void 0], arr[0].concat(this))))();
        }
        return new (EnhancerArray.bind.apply(EnhancerArray, __spreadArray([void 0], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array));
function freezeDraftable(val) {
    return t(val) ? immer_esm(val, function () {
    }) : val;
}
// src/immutableStateInvariantMiddleware.ts
var isProduction = (/* unused pure expression or super */ null && ("production" === "production"));
var prefix = "Invariant failed";
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ""));
}
function stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, getSerialize(serializer, decycler), indent);
}
function getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler)
        decycler = function (_, value) {
            if (stack[0] === value)
                return "[Circular ~]";
            return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
        };
    return function (key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value))
                value = decycler.call(this, key, value);
        }
        else
            stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function isImmutableDefault(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function () {
            return detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function trackProperties(isImmutable, ignorePaths, obj, path) {
    if (ignorePaths === void 0) { ignorePaths = []; }
    if (path === void 0) { path = ""; }
    var tracked = { value: obj };
    if (!isImmutable(obj)) {
        tracked.children = {};
        for (var key in obj) {
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) {
                continue;
            }
            tracked.children[key] = trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) { ignoredPaths = []; }
    if (sameParentRef === void 0) { sameParentRef = false; }
    if (path === void 0) { path = ""; }
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) {
        return { wasMutated: true, path: path };
    }
    if (isImmutable(prevObj) || isImmutable(obj)) {
        return { wasMutated: false };
    }
    var keysToDetect = {};
    for (var key in trackedProperty.children) {
        keysToDetect[key] = true;
    }
    for (var key in obj) {
        keysToDetect[key] = true;
    }
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function (key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function (ignored) {
                if (ignored instanceof RegExp) {
                    return ignored.test(nestedPath);
                }
                return nestedPath === ignored;
            });
            if (hasMatches) {
                return "continue";
            }
        }
        var result = detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) {
            return { value: result };
        }
    };
    for (var key in keysToDetect) {
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object")
            return state_1.value;
    }
    return { wasMutated: false };
}
function createImmutableStateInvariantMiddleware(options) {
    if (options === void 0) { options = {}; }
    if (true) {
        return function () { return function (next) { return function (action) { return next(action); }; }; };
    }
    var _c = options.isImmutable, isImmutable = _c === void 0 ? isImmutableDefault : _c, ignoredPaths = options.ignoredPaths, _d = options.warnAfter, warnAfter = _d === void 0 ? 32 : _d, ignore = options.ignore;
    ignoredPaths = ignoredPaths || ignore;
    var track = trackForMutations.bind(null, isImmutable, ignoredPaths);
    return function (_c) {
        var getState = _c.getState;
        var state = getState();
        var tracker = track(state);
        var result;
        return function (next) { return function (action) {
            var measureUtils = getTimeMeasureUtils(warnAfter, "ImmutableStateInvariantMiddleware");
            measureUtils.measureTime(function () {
                state = getState();
                result = tracker.detectMutations();
                tracker = track(state);
                invariant(!result.wasMutated, "A state mutation was detected between dispatches, in the path '" + (result.path || "") + "'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
            });
            var dispatchedAction = next(action);
            measureUtils.measureTime(function () {
                state = getState();
                result = tracker.detectMutations();
                tracker = track(state);
                result.wasMutated && invariant(!result.wasMutated, "A state mutation was detected inside a dispatch, in the path: " + (result.path || "") + ". Take a look at the reducer(s) handling the action " + stringify(action) + ". (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
            });
            measureUtils.warnIfExceeded();
            return dispatchedAction;
        }; };
    };
}
// src/serializableStateInvariantMiddleware.ts
function isPlain(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || isPlainObject(val);
}
function findNonSerializableValue(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) { path = ""; }
    if (isSerializable === void 0) { isSerializable = isPlain; }
    if (ignoredPaths === void 0) { ignoredPaths = []; }
    var foundNestedSerializable;
    if (!isSerializable(value)) {
        return {
            keyPath: path || "<root>",
            value: value
        };
    }
    if (typeof value !== "object" || value === null) {
        return false;
    }
    if (cache == null ? void 0 : cache.has(value))
        return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function (key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function (ignored) {
                if (ignored instanceof RegExp) {
                    return ignored.test(nestedPath);
                }
                return nestedPath === ignored;
            });
            if (hasMatches) {
                return "continue";
            }
        }
        if (!isSerializable(nestedValue)) {
            return { value: {
                    keyPath: nestedPath,
                    value: nestedValue
                } };
        }
        if (typeof nestedValue === "object") {
            foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) {
                return { value: foundNestedSerializable };
            }
        }
    };
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object")
            return state_2.value;
    }
    if (cache && isNestedFrozen(value))
        cache.add(value);
    return false;
}
function isNestedFrozen(value) {
    if (!Object.isFrozen(value))
        return false;
    for (var _i = 0, _c = Object.values(value); _i < _c.length; _i++) {
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null)
            continue;
        if (!isNestedFrozen(nestedValue))
            return false;
    }
    return true;
}
function createSerializableStateInvariantMiddleware(options) {
    if (options === void 0) { options = {}; }
    if (true) {
        return function () { return function (next) { return function (action) { return next(action); }; }; };
    }
    var _c = options.isSerializable, isSerializable = _c === void 0 ? isPlain : _c, getEntries = options.getEntries, _d = options.ignoredActions, ignoredActions = _d === void 0 ? [] : _d, _e = options.ignoredActionPaths, ignoredActionPaths = _e === void 0 ? ["meta.arg", "meta.baseQueryMeta"] : _e, _f = options.ignoredPaths, ignoredPaths = _f === void 0 ? [] : _f, _g = options.warnAfter, warnAfter = _g === void 0 ? 32 : _g, _h = options.ignoreState, ignoreState = _h === void 0 ? false : _h, _j = options.ignoreActions, ignoreActions = _j === void 0 ? false : _j, _k = options.disableCache, disableCache = _k === void 0 ? false : _k;
    var cache = !disableCache && WeakSet ? new WeakSet() : void 0;
    return function (storeAPI) { return function (next) { return function (action) {
        var result = next(action);
        var measureUtils = getTimeMeasureUtils(warnAfter, "SerializableStateInvariantMiddleware");
        if (!ignoreActions && !(ignoredActions.length && ignoredActions.indexOf(action.type) !== -1)) {
            measureUtils.measureTime(function () {
                var foundActionNonSerializableValue = findNonSerializableValue(action, "", isSerializable, getEntries, ignoredActionPaths, cache);
                if (foundActionNonSerializableValue) {
                    var keyPath = foundActionNonSerializableValue.keyPath, value = foundActionNonSerializableValue.value;
                    console.error("A non-serializable value was detected in an action, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the logic that dispatched this action: ", action, "\n(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)", "\n(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)");
                }
            });
        }
        if (!ignoreState) {
            measureUtils.measureTime(function () {
                var state = storeAPI.getState();
                var foundStateNonSerializableValue = findNonSerializableValue(state, "", isSerializable, getEntries, ignoredPaths, cache);
                if (foundStateNonSerializableValue) {
                    var keyPath = foundStateNonSerializableValue.keyPath, value = foundStateNonSerializableValue.value;
                    console.error("A non-serializable value was detected in the state, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the reducer(s) handling this action type: " + action.type + ".\n(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)");
                }
            });
            measureUtils.warnIfExceeded();
        }
        return result;
    }; }; };
}
// src/getDefaultMiddleware.ts
function isBoolean(x) {
    return typeof x === "boolean";
}
function curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return getDefaultMiddleware(options);
    };
}
function getDefaultMiddleware(options) {
    if (options === void 0) { options = {}; }
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e;
    var middlewareArray = new MiddlewareArray();
    if (thunk) {
        if (isBoolean(thunk)) {
            middlewareArray.push(thunkMiddleware);
        }
        else {
            middlewareArray.push(thunkMiddleware.withExtraArgument(thunk.extraArgument));
        }
    }
    if (false) { var serializableOptions, immutableOptions; }
    return middlewareArray;
}
// src/configureStore.ts
var IS_PRODUCTION = (/* unused pure expression or super */ null && ("production" === "production"));
function configureStore(options) {
    var curriedGetDefaultMiddleware = curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") {
        rootReducer = reducer;
    }
    else if (isPlainObject(reducer)) {
        rootReducer = combineReducers(reducer);
    }
    else {
        throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    }
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!IS_PRODUCTION && !Array.isArray(finalMiddleware)) {
            throw new Error("when using a middleware builder function, an array of middleware must be returned");
        }
    }
    if (!IS_PRODUCTION && finalMiddleware.some(function (item) { return typeof item !== "function"; })) {
        throw new Error("each middleware provided to configureStore must be a function");
    }
    var middlewareEnhancer = applyMiddleware.apply(void 0, finalMiddleware);
    var finalCompose = compose2;
    if (devTools) {
        finalCompose = composeWithDevTools(__spreadValues({
            trace: !IS_PRODUCTION
        }, typeof devTools === "object" && devTools));
    }
    var defaultEnhancers = new EnhancerArray(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) {
        storeEnhancers = __spreadArray([middlewareEnhancer], enhancers);
    }
    else if (typeof enhancers === "function") {
        storeEnhancers = enhancers(defaultEnhancers);
    }
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return createStore(rootReducer, preloadedState, composedEnhancer);
}
// src/createAction.ts
function createAction(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) {
                throw new Error("prepareAction did not return an object");
            }
            return __spreadValues(__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && { meta: prepared.meta }), "error" in prepared && { error: prepared.error });
        }
        return { type: type, payload: args[0] };
    }
    actionCreator.toString = function () { return "" + type; };
    actionCreator.type = type;
    actionCreator.match = function (action) { return action.type === type; };
    return actionCreator;
}
function isAction(action) {
    return isPlainObject(action) && "type" in action;
}
function isFSA(action) {
    return isAction(action) && typeof action.type === "string" && Object.keys(action).every(isValidKey);
}
function isValidKey(key) {
    return ["type", "payload", "error", "meta"].indexOf(key) > -1;
}
function getType(actionCreator) {
    return "" + actionCreator;
}
// src/createReducer.ts

// src/mapBuilders.ts
function executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function (typeOrActionCreator, reducer) {
            if (false) {}
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (type in actionsMap) {
                throw new Error("addCase cannot be called with two reducers for the same action type");
            }
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function (matcher, reducer) {
            if (false) {}
            actionMatchers.push({ matcher: matcher, reducer: reducer });
            return builder;
        },
        addDefaultCase: function (reducer) {
            if (false) {}
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [actionsMap, actionMatchers, defaultCaseReducer];
}
// src/createReducer.ts
function isStateFunction(x) {
    return typeof x === "function";
}
var hasWarnedAboutObjectNotation = false;
function createReducer(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) { actionMatchers = []; }
    if (false) {}
    var _c = typeof mapOrBuilderCallback === "function" ? executeReducerBuilderCallback(mapOrBuilderCallback) : [mapOrBuilderCallback, actionMatchers, defaultCaseReducer], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if (isStateFunction(initialState)) {
        getInitialState = function () { return freezeDraftable(initialState()); };
    }
    else {
        var frozenInitialState_1 = freezeDraftable(initialState);
        getInitialState = function () { return frozenInitialState_1; };
    }
    function reducer(state, action) {
        if (state === void 0) { state = getInitialState(); }
        var caseReducers = __spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function (_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function (_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function (cr) { return !!cr; }).length === 0) {
            caseReducers = [finalDefaultCaseReducer];
        }
        return caseReducers.reduce(function (previousState, caseReducer) {
            if (caseReducer) {
                if (r(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) {
                        return previousState;
                    }
                    return result;
                }
                else if (!t(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) {
                            return previousState;
                        }
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                }
                else {
                    return immer_esm(previousState, function (draft) {
                        return caseReducer(draft, action);
                    });
                }
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var hasWarnedAboutObjectNotation2 = false;
function getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function createSlice(options) {
    var name = options.name;
    if (!name) {
        throw new Error("`name` is a required option for createSlice");
    }
    if (typeof process !== "undefined" && "production" === "development") {}
    var initialState = typeof options.initialState == "function" ? options.initialState : freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function (reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        }
        else {
            caseReducer = maybeReducerWithPrepare;
        }
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? createAction(type, prepareCallback) : createAction(type);
    });
    function buildReducer() {
        if (false) {}
        var _c = typeof options.extraReducers === "function" ? executeReducerBuilderCallback(options.extraReducers) : [options.extraReducers], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = __spreadValues(__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return createReducer(initialState, function (builder) {
            for (var key in finalCaseReducers) {
                builder.addCase(key, finalCaseReducers[key]);
            }
            for (var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++) {
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) {
                builder.addDefaultCase(defaultCaseReducer);
            }
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function (state, action) {
            if (!_reducer)
                _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function () {
            if (!_reducer)
                _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) { additionalState = {}; }
        return Object.assign(getInitialEntityState(), additionalState);
    }
    return { getInitialState: getInitialState };
}
// src/entities/state_selectors.ts
function createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function (state) { return state.ids; };
        var selectEntities = function (state) { return state.entities; };
        var selectAll = createDraftSafeSelector(selectIds, selectEntities, function (ids, entities) { return ids.map(function (id) { return entities[id]; }); });
        var selectId = function (_, id) { return id; };
        var selectById = function (entities, id) { return entities[id]; };
        var selectTotal = createDraftSafeSelector(selectIds, function (ids) { return ids.length; });
        if (!selectState) {
            return {
                selectIds: selectIds,
                selectEntities: selectEntities,
                selectAll: selectAll,
                selectTotal: selectTotal,
                selectById: createDraftSafeSelector(selectEntities, selectId, selectById)
            };
        }
        var selectGlobalizedEntities = createDraftSafeSelector(selectState, selectEntities);
        return {
            selectIds: createDraftSafeSelector(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createDraftSafeSelector(selectState, selectAll),
            selectTotal: createDraftSafeSelector(selectState, selectTotal),
            selectById: createDraftSafeSelector(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return { getSelectors: getSelectors };
}
// src/entities/state_adapter.ts

function createSingleArgumentStateOperator(mutator) {
    var operator = createStateOperator(function (_, state) { return mutator(state); });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return isFSA(arg2);
        }
        var runMutator = function (draft) {
            if (isPayloadActionArgument(arg)) {
                mutator(arg.payload, draft);
            }
            else {
                mutator(arg, draft);
            }
        };
        if (isDraft3(state)) {
            runMutator(state);
            return state;
        }
        else {
            return createNextState3(state, runMutator);
        }
    };
}
// src/entities/utils.ts
function selectIdValue(entity, selectId) {
    var key = selectId(entity);
    if (false) {}
    return key;
}
function ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) {
        entities = Object.values(entities);
    }
    return entities;
}
function splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for (var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++) {
        var entity = newEntities_1[_i];
        var id = selectIdValue(entity, selectId);
        if (id in state.entities) {
            updated.push({ id: id, changes: entity });
        }
        else {
            added.push(entity);
        }
    }
    return [added, updated];
}
// src/entities/unsorted_state_adapter.ts
function createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = selectIdValue(entity, selectId);
        if (key in state.entities) {
            return;
        }
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for (var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++) {
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = selectIdValue(entity, selectId);
        if (!(key in state.entities)) {
            state.ids.push(key);
        }
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for (var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++) {
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([key], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function (key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) {
            state.ids = state.ids.filter(function (id) { return id in state.entities; });
        }
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([update], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function (update) {
            if (update.id in state.entities) {
                updatesPerEntity[update.id] = {
                    id: update.id,
                    changes: __spreadValues(__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
                };
            }
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function (update) { return takeNewKey(newKeys, update, state); }).length > 0;
            if (didMutateIds) {
                state.ids = Object.keys(state.entities);
            }
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([entity], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: createSingleArgumentStateOperator(removeAllMutably),
        addOne: createStateOperator(addOneMutably),
        addMany: createStateOperator(addManyMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        updateOne: createStateOperator(updateOneMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        upsertMany: createStateOperator(upsertManyMutably),
        removeOne: createStateOperator(removeOneMutably),
        removeMany: createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function createSortedStateAdapter(selectId, sort) {
    var _c = createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([entity], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function (model) { return !(selectIdValue(model, selectId) in state.entities); });
        if (models.length !== 0) {
            merge(models, state);
        }
    }
    function setOneMutably(entity, state) {
        return setManyMutably([entity], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            merge(newEntities, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([update], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for (var _i = 0, updates_1 = updates; _i < updates_1.length; _i++) {
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) {
                continue;
            }
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) {
            resortEntities(state);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([entity], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) {
            return false;
        }
        for (var i = 0; i < a.length && i < b.length; i++) {
            if (a[i] === b[i]) {
                continue;
            }
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function (model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) {
            state.ids = newSortedIds;
        }
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: createStateOperator(addOneMutably),
        updateOne: createStateOperator(updateOneMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        addMany: createStateOperator(addManyMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertMany: createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function createEntityAdapter(options) {
    if (options === void 0) { options = {}; }
    var _c = __spreadValues({
        sortComparer: false,
        selectId: function (instance) { return instance.id; }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = createInitialStateFactory();
    var selectorsFactory = createSelectorsFactory();
    var stateAdapter = sortComparer ? createSortedStateAdapter(selectId, sortComparer) : createUnsortedStateAdapter(selectId);
    return __spreadValues(__spreadValues(__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = function (size) {
    if (size === void 0) { size = 21; }
    var id = "";
    var i = size;
    while (i--) {
        id += urlAlphabet[Math.random() * 64 | 0];
    }
    return id;
};
// src/createAsyncThunk.ts
var commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var RejectWithValue = /** @class */ (function () {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}());
var FulfillWithMeta = /** @class */ (function () {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}());
var miniSerializeError = function (value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for (var _i = 0, commonProperties_1 = commonProperties; _i < commonProperties_1.length; _i++) {
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") {
                simpleError[property] = value[property];
            }
        }
        return simpleError;
    }
    return { message: String(value) };
};
var createAsyncThunk = (function () {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = createAction(typePrefix + "/fulfilled", function (payload, requestId, arg, meta) { return ({
            payload: payload,
            meta: __spreadProps(__spreadValues({}, meta || {}), {
                arg: arg,
                requestId: requestId,
                requestStatus: "fulfilled"
            })
        }); });
        var pending = createAction(typePrefix + "/pending", function (requestId, arg, meta) { return ({
            payload: void 0,
            meta: __spreadProps(__spreadValues({}, meta || {}), {
                arg: arg,
                requestId: requestId,
                requestStatus: "pending"
            })
        }); });
        var rejected = createAction(typePrefix + "/rejected", function (error, requestId, arg, payload, meta) { return ({
            payload: payload,
            error: (options && options.serializeError || miniSerializeError)(error || "Rejected"),
            meta: __spreadProps(__spreadValues({}, meta || {}), {
                arg: arg,
                requestId: requestId,
                rejectedWithValue: !!payload,
                requestStatus: "rejected",
                aborted: (error == null ? void 0 : error.name) === "AbortError",
                condition: (error == null ? void 0 : error.name) === "ConditionError"
            })
        }); });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ (function () {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function () {
                    },
                    dispatchEvent: function () {
                        return false;
                    },
                    onabort: function () {
                    },
                    removeEventListener: function () {
                    },
                    reason: void 0,
                    throwIfAborted: function () {
                    }
                };
            }
            class_1.prototype.abort = function () {
                if (false) {}
            };
            return class_1;
        }());
        function actionCreator(arg) {
            return function (dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : nanoid();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function () {
                    return __async(this, null, function () {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    _c.trys.push([0, 4, , 5]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, { getState: getState, extra: extra });
                                    if (!isThenable(conditionResult)) return [3 /*break*/, 2];
                                    return [4 /*yield*/, conditionResult];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) {
                                        throw {
                                            name: "ConditionError",
                                            message: "Aborted due to condition callback returning false."
                                        };
                                    }
                                    started = true;
                                    abortedPromise = new Promise(function (_, reject) { return abortController.signal.addEventListener("abort", function () { return reject({
                                        name: "AbortError",
                                        message: abortReason || "Aborted"
                                    }); }); });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, { requestId: requestId, arg: arg }, { getState: getState, extra: extra })));
                                    return [4 /*yield*/, Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function (value, meta) {
                                                    return new RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function (value, meta) {
                                                    return new FulfillWithMeta(value, meta);
                                                }
                                            })).then(function (result) {
                                                if (result instanceof RejectWithValue) {
                                                    throw result;
                                                }
                                                if (result instanceof FulfillWithMeta) {
                                                    return fulfilled(result.payload, requestId, arg, result.meta);
                                                }
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])];
                                case 3:
                                    finalAction = _c.sent();
                                    return [3 /*break*/, 5];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [3 /*break*/, 5];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) {
                                        dispatch(finalAction);
                                    }
                                    return [2 /*return*/, finalAction];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function () {
                        return promise2.then(unwrapResult);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function () { return createAsyncThunk2; };
    return createAsyncThunk2;
})();
function unwrapResult(action) {
    if (action.meta && action.meta.rejectedWithValue) {
        throw action.payload;
    }
    if (action.error) {
        throw action.error;
    }
    return action.payload;
}
function isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/tsHelpers.ts
var hasMatchFunction = function (v) {
    return v && typeof v.match === "function";
};
// src/matchers.ts
var matches = function (matcher, action) {
    if (hasMatchFunction(matcher)) {
        return matcher.match(action);
    }
    else {
        return matcher(action);
    }
};
function isAnyOf() {
    var matchers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        matchers[_i] = arguments[_i];
    }
    return function (action) {
        return matchers.some(function (matcher) { return matches(matcher, action); });
    };
}
function isAllOf() {
    var matchers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        matchers[_i] = arguments[_i];
    }
    return function (action) {
        return matchers.every(function (matcher) { return matches(matcher, action); });
    };
}
function hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta)
        return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function isPending() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["pending"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isPending()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = asyncThunks.map(function (asyncThunk) { return asyncThunk.pending; });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isRejected() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["rejected"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isRejected()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = asyncThunks.map(function (asyncThunk) { return asyncThunk.rejected; });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isRejectedWithValue() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    var hasFlag = function (action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) {
        return function (action) {
            var combinedMatcher = isAllOf(isRejected.apply(void 0, asyncThunks), hasFlag);
            return combinedMatcher(action);
        };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isRejectedWithValue()(asyncThunks[0]);
    }
    return function (action) {
        var combinedMatcher = isAllOf(isRejected.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function isFulfilled() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["fulfilled"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isFulfilled()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = asyncThunks.map(function (asyncThunk) { return asyncThunk.fulfilled; });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isAsyncThunkAction() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["pending", "fulfilled", "rejected"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isAsyncThunkAction()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = [];
        for (var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++) {
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var assertFunction = function (func, expected) {
    if (typeof func !== "function") {
        throw new TypeError(expected + " is not a function");
    }
};
var noop = function () {
};
var catchRejection = function (promise2, onError) {
    if (onError === void 0) { onError = noop; }
    promise2.catch(onError);
    return promise2;
};
var addAbortSignalListener = function (abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, { once: true });
    return function () { return abortSignal.removeEventListener("abort", callback); };
};
var abortControllerWithReason = function (abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) {
        return;
    }
    if (!("reason" in signal)) {
        Object.defineProperty(signal, "reason", {
            enumerable: true,
            value: reason,
            configurable: true,
            writable: true
        });
    }
    ;
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var task = "task";
var listener = "listener";
var completed = "completed";
var cancelled = "cancelled";
var taskCancelled = "task-" + cancelled;
var taskCompleted = "task-" + completed;
var listenerCancelled = listener + "-" + cancelled;
var listenerCompleted = listener + "-" + completed;
var TaskAbortError = /** @class */ (function () {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = task + " " + cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}());
// src/listenerMiddleware/task.ts
var validateActive = function (signal) {
    if (signal.aborted) {
        throw new TaskAbortError(signal.reason);
    }
};
function raceWithSignal(signal, promise2) {
    var cleanup = noop;
    return new Promise(function (resolve, reject) {
        var notifyRejection = function () { return reject(new TaskAbortError(signal.reason)); };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function () { return cleanup(); }).then(resolve, reject);
    }).finally(function () {
        cleanup = noop;
    });
}
var runTask = function (task2, cleanUp) { return __async(void 0, null, function () {
    var value, error_1;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, 4, 5]);
                return [4 /*yield*/, Promise.resolve()];
            case 1:
                _c.sent();
                return [4 /*yield*/, task2()];
            case 2:
                value = _c.sent();
                return [2 /*return*/, {
                        status: "ok",
                        value: value
                    }];
            case 3:
                error_1 = _c.sent();
                return [2 /*return*/, {
                        status: error_1 instanceof TaskAbortError ? "cancelled" : "rejected",
                        error: error_1
                    }];
            case 4:
                cleanUp == null ? void 0 : cleanUp();
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); };
var createPause = function (signal) {
    return function (promise2) {
        return catchRejection(raceWithSignal(signal, promise2).then(function (output) {
            validateActive(signal);
            return output;
        }));
    };
};
var createDelay = function (signal) {
    var pause = createPause(signal);
    return function (timeoutMs) {
        return pause(new Promise(function (resolve) { return setTimeout(resolve, timeoutMs); }));
    };
};
// src/listenerMiddleware/index.ts
var redux_toolkit_esm_assign = Object.assign;
var INTERNAL_NIL_TOKEN = {};
var alm = "listenerMiddleware";
var createFork = function (parentAbortSignal) {
    var linkControllers = function (controller) { return addAbortSignalListener(parentAbortSignal, function () { return abortControllerWithReason(controller, parentAbortSignal.reason); }); };
    return function (taskExecutor) {
        assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = runTask(function () { return __async(void 0, null, function () {
            var result2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        validateActive(parentAbortSignal);
                        validateActive(childAbortController.signal);
                        return [4 /*yield*/, taskExecutor({
                                pause: createPause(childAbortController.signal),
                                delay: createDelay(childAbortController.signal),
                                signal: childAbortController.signal
                            })];
                    case 1:
                        result2 = _c.sent();
                        validateActive(childAbortController.signal);
                        return [2 /*return*/, result2];
                }
            });
        }); }, function () { return abortControllerWithReason(childAbortController, taskCompleted); });
        return {
            result: createPause(parentAbortSignal)(result),
            cancel: function () {
                abortControllerWithReason(childAbortController, taskCancelled);
            }
        };
    };
};
var createTakePattern = function (startListening, signal) {
    var take = function (predicate, timeout) { return __async(void 0, null, function () {
        var unsubscribe, tuplePromise, promises, output;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    validateActive(signal);
                    unsubscribe = function () {
                    };
                    tuplePromise = new Promise(function (resolve, reject) {
                        var stopListening = startListening({
                            predicate: predicate,
                            effect: function (action, listenerApi) {
                                listenerApi.unsubscribe();
                                resolve([
                                    action,
                                    listenerApi.getState(),
                                    listenerApi.getOriginalState()
                                ]);
                            }
                        });
                        unsubscribe = function () {
                            stopListening();
                            reject();
                        };
                    });
                    promises = [
                        tuplePromise
                    ];
                    if (timeout != null) {
                        promises.push(new Promise(function (resolve) { return setTimeout(resolve, timeout, null); }));
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, raceWithSignal(signal, Promise.race(promises))];
                case 2:
                    output = _c.sent();
                    validateActive(signal);
                    return [2 /*return*/, output];
                case 3:
                    unsubscribe();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return function (predicate, timeout) { return catchRejection(take(predicate, timeout)); };
};
var getListenerEntryPropsFrom = function (options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) {
        predicate = createAction(type).match;
    }
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    }
    else if (matcher) {
        predicate = matcher;
    }
    else if (predicate) {
    }
    else {
        throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    }
    assertFunction(effect, "options.listener");
    return { predicate: predicate, type: type, effect: effect };
};
var createListenerEntry = function (options) {
    var _c = getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = nanoid();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function () {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var cancelActiveListeners = function (entry) {
    entry.pending.forEach(function (controller) {
        abortControllerWithReason(controller, listenerCancelled);
    });
};
var createClearListenerMiddleware = function (listenerMap) {
    return function () {
        listenerMap.forEach(cancelActiveListeners);
        listenerMap.clear();
    };
};
var safelyNotifyError = function (errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    }
    catch (errorHandlerError) {
        setTimeout(function () {
            throw errorHandlerError;
        }, 0);
    }
};
var addListener = createAction(alm + "/add");
var clearAllListeners = createAction(alm + "/removeAll");
var removeListener = createAction(alm + "/remove");
var defaultErrorHandler = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    console.error.apply(console, __spreadArray([alm + "/error"], args));
};
function createListenerMiddleware(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) { middlewareOptions = {}; }
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? defaultErrorHandler : _c;
    assertFunction(onError, "onError");
    var insertEntry = function (entry) {
        entry.unsubscribe = function () { return listenerMap.delete(entry.id); };
        listenerMap.set(entry.id, entry);
        return function (cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) {
                cancelActiveListeners(entry);
            }
        };
    };
    var findListenerEntry = function (comparator) {
        for (var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++) {
            var entry = _c[_i];
            if (comparator(entry)) {
                return entry;
            }
        }
        return void 0;
    };
    var startListening = function (options) {
        var entry = findListenerEntry(function (existingEntry) { return existingEntry.effect === options.effect; });
        if (!entry) {
            entry = createListenerEntry(options);
        }
        return insertEntry(entry);
    };
    var stopListening = function (options) {
        var _c = getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function (entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) {
                cancelActiveListeners(entry);
            }
        }
        return !!entry;
    };
    var notifyListener = function (entry, action, api, getOriginalState) { return __async(_this, null, function () {
        var internalTaskController, take, listenerError_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    internalTaskController = new AbortController();
                    take = createTakePattern(startListening, internalTaskController.signal);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    entry.pending.add(internalTaskController);
                    return [4 /*yield*/, Promise.resolve(entry.effect(action, redux_toolkit_esm_assign({}, api, {
                            getOriginalState: getOriginalState,
                            condition: function (predicate, timeout) { return take(predicate, timeout).then(Boolean); },
                            take: take,
                            delay: createDelay(internalTaskController.signal),
                            pause: createPause(internalTaskController.signal),
                            extra: extra,
                            signal: internalTaskController.signal,
                            fork: createFork(internalTaskController.signal),
                            unsubscribe: entry.unsubscribe,
                            subscribe: function () {
                                listenerMap.set(entry.id, entry);
                            },
                            cancelActiveListeners: function () {
                                entry.pending.forEach(function (controller, _, set) {
                                    if (controller !== internalTaskController) {
                                        abortControllerWithReason(controller, listenerCancelled);
                                        set.delete(controller);
                                    }
                                });
                            }
                        })))];
                case 2:
                    _c.sent();
                    return [3 /*break*/, 5];
                case 3:
                    listenerError_1 = _c.sent();
                    if (!(listenerError_1 instanceof TaskAbortError)) {
                        safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                    }
                    return [3 /*break*/, 5];
                case 4:
                    abortControllerWithReason(internalTaskController, listenerCompleted);
                    entry.pending.delete(internalTaskController);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var clearListenerMiddleware = createClearListenerMiddleware(listenerMap);
    var middleware = function (api) { return function (next) { return function (action) {
        if (!isAction(action)) {
            return next(action);
        }
        if (addListener.match(action)) {
            return startListening(action.payload);
        }
        if (clearAllListeners.match(action)) {
            clearListenerMiddleware();
            return;
        }
        if (removeListener.match(action)) {
            return stopListening(action.payload);
        }
        var originalState = api.getState();
        var getOriginalState = function () {
            if (originalState === INTERNAL_NIL_TOKEN) {
                throw new Error(alm + ": getOriginalState can only be called synchronously");
            }
            return originalState;
        };
        var result;
        try {
            result = next(action);
            if (listenerMap.size > 0) {
                var currentState = api.getState();
                var listenerEntries = Array.from(listenerMap.values());
                for (var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++) {
                    var entry = listenerEntries_1[_i];
                    var runListener = false;
                    try {
                        runListener = entry.predicate(action, currentState, originalState);
                    }
                    catch (predicateError) {
                        runListener = false;
                        safelyNotifyError(onError, predicateError, {
                            raisedBy: "predicate"
                        });
                    }
                    if (!runListener) {
                        continue;
                    }
                    notifyListener(entry, action, api, getOriginalState);
                }
            }
        }
        finally {
            originalState = INTERNAL_NIL_TOKEN;
        }
        return result;
    }; }; };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var SHOULD_AUTOBATCH = "RTK_autoBatch";
var prepareAutoBatched = function () { return function (payload) {
    var _c;
    return ({
        payload: payload,
        meta: (_c = {}, _c[SHOULD_AUTOBATCH] = true, _c)
    });
}; };
var promise;
var queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof __webpack_require__.g !== "undefined" ? __webpack_require__.g : globalThis) : function (cb) { return (promise || (promise = Promise.resolve())).then(cb).catch(function (err) { return setTimeout(function () {
    throw err;
}, 0); }); };
var createQueueWithTimer = function (timeout) {
    return function (notify) {
        setTimeout(notify, timeout);
    };
};
var rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : createQueueWithTimer(10);
var autoBatchEnhancer = function (options) {
    if (options === void 0) { options = { type: "raf" }; }
    return function (next) { return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var store = next.apply(void 0, args);
        var notifying = true;
        var shouldNotifyAtEndOfTick = false;
        var notificationQueued = false;
        var listeners = new Set();
        var queueCallback = options.type === "tick" ? queueMicrotaskShim : options.type === "raf" ? rAF : options.type === "callback" ? options.queueNotification : createQueueWithTimer(options.timeout);
        var notifyListeners = function () {
            notificationQueued = false;
            if (shouldNotifyAtEndOfTick) {
                shouldNotifyAtEndOfTick = false;
                listeners.forEach(function (l) { return l(); });
            }
        };
        return Object.assign({}, store, {
            subscribe: function (listener2) {
                var wrappedListener = function () { return notifying && listener2(); };
                var unsubscribe = store.subscribe(wrappedListener);
                listeners.add(listener2);
                return function () {
                    unsubscribe();
                    listeners.delete(listener2);
                };
            },
            dispatch: function (action) {
                var _a;
                try {
                    notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[SHOULD_AUTOBATCH]);
                    shouldNotifyAtEndOfTick = !notifying;
                    if (shouldNotifyAtEndOfTick) {
                        if (!notificationQueued) {
                            notificationQueued = true;
                            queueCallback(notifyListeners);
                        }
                    }
                    return store.dispatch(action);
                }
                finally {
                    notifying = true;
                }
            }
        });
    }; };
};
// src/index.ts
F();

//# sourceMappingURL=redux-toolkit.esm.js.map

/***/ }),

/***/ 86891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Wz": function() { return /* binding */ shouldIgnoreOnError; },
/* harmony export */   "m9": function() { return /* binding */ WINDOW; },
/* harmony export */   "re": function() { return /* binding */ wrap; }
/* harmony export */ });
/* unused harmony export ignoreNextOnError */
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64487);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71235);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20535);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62844);



const WINDOW = _sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2 ;

let ignoreOnError = 0;

/**
 * @hidden
 */
function shouldIgnoreOnError() {
  return ignoreOnError > 0;
}

/**
 * @hidden
 */
function ignoreNextOnError() {
  // onerror should trigger before setTimeout
  ignoreOnError++;
  setTimeout(() => {
    ignoreOnError--;
  });
}

/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(
  fn,
  options

 = {},
  before,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
  // for future readers what this does is wrap a function and then create
  // a bi-directional wrapping between them.
  //
  // example: wrapped = wrap(original);
  //  original.__sentry_wrapped__ -> wrapped
  //  wrapped.__sentry_original__ -> original

  if (typeof fn !== 'function') {
    return fn;
  }

  try {
    // if we're dealing with a function that was previously wrapped, return
    // the original wrapper.
    const wrapper = fn.__sentry_wrapped__;
    if (wrapper) {
      return wrapper;
    }

    // We don't wanna wrap it twice
    if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .getOriginalFunction */ .HK)(fn)) {
      return fn;
    }
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    // Bail on wrapping and return the function as-is (defers to window.onerror).
    return fn;
  }

  /* eslint-disable prefer-rest-params */
  // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
  const sentryWrapped = function () {
    const args = Array.prototype.slice.call(arguments);

    try {
      if (before && typeof before === 'function') {
        before.apply(this, arguments);
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
      const wrappedArguments = args.map((arg) => wrap(arg, options));

      // Attempt to invoke user-land function
      // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
      //       means the sentry.javascript SDK caught an error invoking your application code. This
      //       is expected behavior and NOT indicative of a bug with sentry.javascript.
      return fn.apply(this, wrappedArguments);
    } catch (ex) {
      ignoreNextOnError();

      (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .withScope */ .$e)((scope) => {
        scope.addEventProcessor((event) => {
          if (options.mechanism) {
            (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionTypeValue */ .Db)(event, undefined, undefined);
            (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionMechanism */ .EG)(event, options.mechanism);
          }

          event.extra = {
            ...event.extra,
            arguments: args,
          };

          return event;
        });

        (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .captureException */ .Tb)(ex);
      });

      throw ex;
    }
  };
  /* eslint-enable prefer-rest-params */

  // Accessing some objects may throw
  // ref: https://github.com/getsentry/sentry-javascript/issues/1168
  try {
    for (const property in fn) {
      if (Object.prototype.hasOwnProperty.call(fn, property)) {
        sentryWrapped[property] = fn[property];
      }
    }
  } catch (_oO) {} // eslint-disable-line no-empty

  // Signal that this function has been wrapped/filled already
  // for both debugging and to prevent it to being wrapped/filled twice
  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .markFunctionWrapped */ .$Q)(sentryWrapped, fn);

  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .addNonEnumerableProperty */ .xp)(fn, '__sentry_wrapped__', sentryWrapped);

  // Restore original function name (not all browsers allow that)
  try {
    const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name') ;
    if (descriptor.configurable) {
      Object.defineProperty(sentryWrapped, 'name', {
        get() {
          return fn.name;
        },
      });
    }
    // eslint-disable-next-line no-empty
  } catch (_oO) {}

  return sentryWrapped;
}

/**
 * All properties the report dialog supports
 */


//# sourceMappingURL=helpers.js.map


/***/ }),

/***/ 64210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yl": function() { return /* binding */ flush; },
  "S1": function() { return /* binding */ init; }
});

// UNUSED EXPORTS: captureUserFeedback, close, defaultIntegrations, forceLoad, lastEventId, onLoad, showReportDialog, wrap

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var esm_logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(62844);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(57321);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/inboundfilters.js


// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];

const DEFAULT_IGNORE_TRANSACTIONS = [
  /^.*healthcheck.*$/,
  /^.*healthy.*$/,
  /^.*live.*$/,
  /^.*ready.*$/,
  /^.*heartbeat.*$/,
  /^.*\/health$/,
  /^.*\/healthz$/,
];

/** Options for the InboundFilters integration */

/** Inbound filters configurable by the user */
class InboundFilters  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'InboundFilters';}

  /**
   * @inheritDoc
   */
   __init() {this.name = InboundFilters.id;}

   constructor(  _options = {}) {this._options = _options;InboundFilters.prototype.__init.call(this);}

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    const eventProcess = (event) => {
      const hub = getCurrentHub();
      if (hub) {
        const self = hub.getIntegration(InboundFilters);
        if (self) {
          const client = hub.getClient();
          const clientOptions = client ? client.getOptions() : {};
          const options = _mergeOptions(self._options, clientOptions);
          return _shouldDropEvent(event, options) ? null : event;
        }
      }
      return event;
    };

    eventProcess.id = this.name;
    addGlobalEventProcessor(eventProcess);
  }
} InboundFilters.__initStatic();

/** JSDoc */
function _mergeOptions(
  internalOptions = {},
  clientOptions = {},
) {
  return {
    allowUrls: [...(internalOptions.allowUrls || []), ...(clientOptions.allowUrls || [])],
    denyUrls: [...(internalOptions.denyUrls || []), ...(clientOptions.denyUrls || [])],
    ignoreErrors: [
      ...(internalOptions.ignoreErrors || []),
      ...(clientOptions.ignoreErrors || []),
      ...(internalOptions.disableErrorDefaults ? [] : DEFAULT_IGNORE_ERRORS),
    ],
    ignoreTransactions: [
      ...(internalOptions.ignoreTransactions || []),
      ...(clientOptions.ignoreTransactions || []),
      ...(internalOptions.disableTransactionDefaults ? [] : DEFAULT_IGNORE_TRANSACTIONS),
    ],
    ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true,
  };
}

/** JSDoc */
function _shouldDropEvent(event, options) {
  if (options.ignoreInternal && _isSentryError(event)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`);
    return true;
  }
  if (_isIgnoredError(event, options.ignoreErrors)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`,
      );
    return true;
  }
  if (_isIgnoredTransaction(event, options.ignoreTransactions)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`,
      );
    return true;
  }
  if (_isDeniedUrl(event, options.denyUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  if (!_isAllowedUrl(event, options.allowUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  return false;
}

function _isIgnoredError(event, ignoreErrors) {
  // If event.type, this is not an error
  if (event.type || !ignoreErrors || !ignoreErrors.length) {
    return false;
  }

  return _getPossibleEventMessages(event).some(message => (0,string/* stringMatchesSomePattern */.U0)(message, ignoreErrors));
}

function _isIgnoredTransaction(event, ignoreTransactions) {
  if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) {
    return false;
  }

  const name = event.transaction;
  return name ? (0,string/* stringMatchesSomePattern */.U0)(name, ignoreTransactions) : false;
}

function _isDeniedUrl(event, denyUrls) {
  // TODO: Use Glob instead?
  if (!denyUrls || !denyUrls.length) {
    return false;
  }
  const url = _getEventFilterUrl(event);
  return !url ? false : (0,string/* stringMatchesSomePattern */.U0)(url, denyUrls);
}

function _isAllowedUrl(event, allowUrls) {
  // TODO: Use Glob instead?
  if (!allowUrls || !allowUrls.length) {
    return true;
  }
  const url = _getEventFilterUrl(event);
  return !url ? true : (0,string/* stringMatchesSomePattern */.U0)(url, allowUrls);
}

function _getPossibleEventMessages(event) {
  if (event.message) {
    return [event.message];
  }
  if (event.exception) {
    const { values } = event.exception;
    try {
      const { type = '', value = '' } = (values && values[values.length - 1]) || {};
      return [`${value}`, `${type}: ${value}`];
    } catch (oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(`Cannot extract message for event ${(0,misc/* getEventDescription */.jH)(event)}`);
      return [];
    }
  }
  return [];
}

function _isSentryError(event) {
  try {
    // @ts-ignore can't be a sentry error if undefined
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return event.exception.values[0].type === 'SentryError';
  } catch (e) {
    // ignore
  }
  return false;
}

function _getLastValidUrl(frames = []) {
  for (let i = frames.length - 1; i >= 0; i--) {
    const frame = frames[i];

    if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
      return frame.filename || null;
    }
  }

  return null;
}

function _getEventFilterUrl(event) {
  try {
    let frames;
    try {
      // @ts-ignore we only care about frames if the whole thing here is defined
      frames = event.exception.values[0].stacktrace.frames;
    } catch (e) {
      // ignore
    }
    return frames ? _getLastValidUrl(frames) : null;
  } catch (oO) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(`Cannot extract url for event ${(0,misc/* getEventDescription */.jH)(event)}`);
    return null;
  }
}


//# sourceMappingURL=inboundfilters.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(20535);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/functiontostring.js


let originalFunctionToString;

/** Patch toString calls to return proper name for wrapped functions */
class FunctionToString  {constructor() { FunctionToString.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'FunctionToString';}

  /**
   * @inheritDoc
   */
   __init() {this.name = FunctionToString.id;}

  /**
   * @inheritDoc
   */
   setupOnce() {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    originalFunctionToString = Function.prototype.toString;

    // intrinsics (like Function.prototype) might be immutable in some environments
    // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      Function.prototype.toString = function ( ...args) {
        const context = (0,object/* getOriginalFunction */.HK)(this) || this;
        return originalFunctionToString.apply(context, args);
      };
    } catch (e) {
      // ignore errors here, just don't patch this
    }
  }
} FunctionToString.__initStatic();


//# sourceMappingURL=functiontostring.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js
var esm_hub = __webpack_require__(95659);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/scope.js
var esm_scope = __webpack_require__(10350);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integration.js




const installedIntegrations = [];

/** Map of integrations assigned to a client */

/**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */
function filterDuplicates(integrations) {
  const integrationsByName = {};

  integrations.forEach(currentInstance => {
    const { name } = currentInstance;

    const existingInstance = integrationsByName[name];

    // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
    // default instance to overwrite an existing user instance
    if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) {
      return;
    }

    integrationsByName[name] = currentInstance;
  });

  return Object.keys(integrationsByName).map(k => integrationsByName[k]);
}

/** Gets integrations to install */
function getIntegrationsToSetup(options) {
  const defaultIntegrations = options.defaultIntegrations || [];
  const userIntegrations = options.integrations;

  // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
  defaultIntegrations.forEach(integration => {
    integration.isDefaultInstance = true;
  });

  let integrations;

  if (Array.isArray(userIntegrations)) {
    integrations = [...defaultIntegrations, ...userIntegrations];
  } else if (typeof userIntegrations === 'function') {
    integrations = (0,misc/* arrayify */.lE)(userIntegrations(defaultIntegrations));
  } else {
    integrations = defaultIntegrations;
  }

  const finalIntegrations = filterDuplicates(integrations);

  // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
  // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
  // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
  // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
  const debugIndex = findIndex(finalIntegrations, integration => integration.name === 'Debug');
  if (debugIndex !== -1) {
    const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
    finalIntegrations.push(debugInstance);
  }

  return finalIntegrations;
}

/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(integrations) {
  const integrationIndex = {};

  integrations.forEach(integration => {
    // guard against empty provided integrations
    if (integration) {
      setupIntegration(integration, integrationIndex);
    }
  });

  return integrationIndex;
}

/** Setup a single integration.  */
function setupIntegration(integration, integrationIndex) {
  integrationIndex[integration.name] = integration;

  if (installedIntegrations.indexOf(integration.name) === -1) {
    integration.setupOnce(esm_scope/* addGlobalEventProcessor */.c, esm_hub/* getCurrentHub */.Gd);
    installedIntegrations.push(integration.name);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Integration installed: ${integration.name}`);
  }
}

// Polyfill for Array.findIndex(), which is not supported in ES5
function findIndex(arr, callback) {
  for (let i = 0; i < arr.length; i++) {
    if (callback(arr[i]) === true) {
      return i;
    }
  }

  return -1;
}


//# sourceMappingURL=integration.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/sdk.js



/** A class object that can instantiate Client objects. */

/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(
  clientClass,
  options,
) {
  if (options.debug === true) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      esm_logger/* logger.enable */.kg.enable();
    } else {
      // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
      // eslint-disable-next-line no-console
      console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
  }
  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const scope = hub.getScope();
  scope.update(options.initialScope);

  const client = new clientClass(options);
  hub.bindClient(client);
}


//# sourceMappingURL=sdk.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(30360);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/supports.js
var supports = __webpack_require__(8823);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(96893);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument.js + 1 modules
var instrument = __webpack_require__(35648);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/dsn.js
var esm_dsn = __webpack_require__(30292);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/memo.js
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Helper to decycle json objects
 */
function memoBuilder() {
  const hasWeakSet = typeof WeakSet === 'function';
  const inner = hasWeakSet ? new WeakSet() : [];
  function memoize(obj) {
    if (hasWeakSet) {
      if (inner.has(obj)) {
        return true;
      }
      inner.add(obj);
      return false;
    }
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < inner.length; i++) {
      const value = inner[i];
      if (value === obj) {
        return true;
      }
    }
    inner.push(obj);
    return false;
  }

  function unmemoize(obj) {
    if (hasWeakSet) {
      inner.delete(obj);
    } else {
      for (let i = 0; i < inner.length; i++) {
        if (inner[i] === obj) {
          inner.splice(i, 1);
          break;
        }
      }
    }
  }
  return [memoize, unmemoize];
}


//# sourceMappingURL=memo.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/normalize.js





/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalize(input, depth = 100, maxProperties = +Infinity) {
  try {
    // since we're at the outermost level, we don't provide a key
    return visit('', input, depth, maxProperties);
  } catch (err) {
    return { ERROR: `**non-serializable** (${err})` };
  }
}

/** JSDoc */
function normalizeToSize(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  object,
  // Default Node.js REPL depth
  depth = 3,
  // 100kB, as 200kB is max payload size, so half sounds reasonable
  maxSize = 100 * 1024,
) {
  const normalized = normalize(object, depth);

  if (jsonSize(normalized) > maxSize) {
    return normalizeToSize(object, depth - 1, maxSize);
  }

  return normalized ;
}

/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */
function visit(
  key,
  value,
  depth = +Infinity,
  maxProperties = +Infinity,
  memo = memoBuilder(),
) {
  const [memoize, unmemoize] = memo;

  // Get the simple cases out of the way first
  if (
    value == null || // this matches null and undefined -> eqeq not eqeqeq
    (['number', 'boolean', 'string'].includes(typeof value) && !(0,is/* isNaN */.i2)(value))
  ) {
    return value ;
  }

  const stringified = stringifyValue(key, value);

  // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
  // Everything else will have already been serialized, so if we don't see that pattern, we're done.
  if (!stringified.startsWith('[object ')) {
    return stringified;
  }

  // From here on, we can assert that `value` is either an object or an array.

  // Do not normalize objects that we know have already been normalized. As a general rule, the
  // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
  // have already been normalized.
  if ((value )['__sentry_skip_normalization__']) {
    return value ;
  }

  // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
  // We keep a certain amount of depth.
  // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
  const remainingDepth =
    typeof (value )['__sentry_override_normalization_depth__'] === 'number'
      ? ((value )['__sentry_override_normalization_depth__'] )
      : depth;

  // We're also done if we've reached the max depth
  if (remainingDepth === 0) {
    // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
  }

  // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
  if (memoize(value)) {
    return '[Circular ~]';
  }

  // If the value has a `toJSON` method, we call it to extract more information
  const valueWithToJSON = value ;
  if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') {
    try {
      const jsonValue = valueWithToJSON.toJSON();
      // We need to normalize the return value of `.toJSON()` in case it has circular references
      return visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
      // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
  }

  // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
  // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
  // property/entry, and keep track of the number of items we add to it.
  const normalized = (Array.isArray(value) ? [] : {}) ;
  let numAdded = 0;

  // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
  // properties are non-enumerable and otherwise would get missed.
  const visitable = (0,object/* convertToPlainObject */.Sh)(value );

  for (const visitKey in visitable) {
    // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
    if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
      continue;
    }

    if (numAdded >= maxProperties) {
      normalized[visitKey] = '[MaxProperties ~]';
      break;
    }

    // Recursively visit all the child nodes
    const visitValue = visitable[visitKey];
    normalized[visitKey] = visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);

    numAdded++;
  }

  // Once we've visited all the branches, remove the parent from memo storage
  unmemoize(value);

  // Return accumulated values
  return normalized;
}

/* eslint-disable complexity */
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */
function stringifyValue(
  key,
  // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
  // our internal use, it'll do
  value,
) {
  try {
    if (key === 'domain' && value && typeof value === 'object' && (value )._events) {
      return '[Domain]';
    }

    if (key === 'domainEmitter') {
      return '[DomainEmitter]';
    }

    // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
    // which won't throw if they are not present.

    if (typeof __webpack_require__.g !== 'undefined' && value === __webpack_require__.g) {
      return '[Global]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof window !== 'undefined' && value === window) {
      return '[Window]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof document !== 'undefined' && value === document) {
      return '[Document]';
    }

    // React's SyntheticEvent thingy
    if ((0,is/* isSyntheticEvent */.Cy)(value)) {
      return '[SyntheticEvent]';
    }

    if (typeof value === 'number' && value !== value) {
      return '[NaN]';
    }

    if (typeof value === 'function') {
      return `[Function: ${(0,stacktrace/* getFunctionName */.$P)(value)}]`;
    }

    if (typeof value === 'symbol') {
      return `[${String(value)}]`;
    }

    // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
    if (typeof value === 'bigint') {
      return `[BigInt: ${String(value)}]`;
    }

    // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
    // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
    // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
    // we can make sure that only plain objects come out that way.
    const objName = getConstructorName(value);

    // Handle HTML Elements
    if (/^HTML(\w*)Element$/.test(objName)) {
      return `[HTMLElement: ${objName}]`;
    }

    return `[object ${objName}]`;
  } catch (err) {
    return `**non-serializable** (${err})`;
  }
}
/* eslint-enable complexity */

function getConstructorName(value) {
  const prototype = Object.getPrototypeOf(value);

  return prototype ? prototype.constructor.name : 'null prototype';
}

/** Calculates bytes size of input string */
function utf8Length(value) {
  // eslint-disable-next-line no-bitwise
  return ~-encodeURI(value).split(/%..|./).length;
}

/** Calculates bytes size of input object */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}


//# sourceMappingURL=normalize.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/envelope.js




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function createEnvelope(headers, items = []) {
  return [headers, items] ;
}

/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function addItemToEnvelope(envelope, newItem) {
  const [headers, items] = envelope;
  return [headers, [...items, newItem]] ;
}

/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */
function forEachEnvelopeItem(
  envelope,
  callback,
) {
  const envelopeItems = envelope[1];

  for (const envelopeItem of envelopeItems) {
    const envelopeItemType = envelopeItem[0].type;
    const result = callback(envelopeItem, envelopeItemType);

    if (result) {
      return true;
    }
  }

  return false;
}

/**
 * Returns true if the envelope contains any of the given envelope item types
 */
function envelopeContainsItemType(envelope, types) {
  return forEachEnvelopeItem(envelope, (_, type) => types.includes(type));
}

/**
 * Encode a string to UTF8.
 */
function encodeUTF8(input, textEncoder) {
  const utf8 = textEncoder || new TextEncoder();
  return utf8.encode(input);
}

/**
 * Serializes an envelope.
 */
function serializeEnvelope(envelope, textEncoder) {
  const [envHeaders, items] = envelope;

  // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
  let parts = JSON.stringify(envHeaders);

  function append(next) {
    if (typeof parts === 'string') {
      parts = typeof next === 'string' ? parts + next : [encodeUTF8(parts, textEncoder), next];
    } else {
      parts.push(typeof next === 'string' ? encodeUTF8(next, textEncoder) : next);
    }
  }

  for (const item of items) {
    const [itemHeaders, payload] = item;

    append(`\n${JSON.stringify(itemHeaders)}\n`);

    if (typeof payload === 'string' || payload instanceof Uint8Array) {
      append(payload);
    } else {
      let stringifiedPayload;
      try {
        stringifiedPayload = JSON.stringify(payload);
      } catch (e) {
        // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
        // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
        // performance impact but in this case a performance hit is better than throwing.
        stringifiedPayload = JSON.stringify(normalize(payload));
      }
      append(stringifiedPayload);
    }
  }

  return typeof parts === 'string' ? parts : concatBuffers(parts);
}

function concatBuffers(buffers) {
  const totalLength = buffers.reduce((acc, buf) => acc + buf.length, 0);

  const merged = new Uint8Array(totalLength);
  let offset = 0;
  for (const buffer of buffers) {
    merged.set(buffer, offset);
    offset += buffer.length;
  }

  return merged;
}

/**
 * Parses an envelope
 */
function parseEnvelope(
  env,
  textEncoder,
  textDecoder,
) {
  let buffer = typeof env === 'string' ? textEncoder.encode(env) : env;

  function readBinary(length) {
    const bin = buffer.subarray(0, length);
    // Replace the buffer with the remaining data excluding trailing newline
    buffer = buffer.subarray(length + 1);
    return bin;
  }

  function readJson() {
    let i = buffer.indexOf(0xa);
    // If we couldn't find a newline, we must have found the end of the buffer
    if (i < 0) {
      i = buffer.length;
    }

    return JSON.parse(textDecoder.decode(readBinary(i))) ;
  }

  const envelopeHeader = readJson();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const items = [];

  while (buffer.length) {
    const itemHeader = readJson();
    const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;

    items.push([itemHeader, binaryLength ? readBinary(binaryLength) : readJson()]);
  }

  return [envelopeHeader, items];
}

/**
 * Creates attachment envelope items
 */
function createAttachmentEnvelopeItem(
  attachment,
  textEncoder,
) {
  const buffer = typeof attachment.data === 'string' ? encodeUTF8(attachment.data, textEncoder) : attachment.data;

  return [
    (0,object/* dropUndefinedKeys */.Jr)({
      type: 'attachment',
      length: buffer.length,
      filename: attachment.filename,
      content_type: attachment.contentType,
      attachment_type: attachment.attachmentType,
    }),
    buffer,
  ];
}

const ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
  session: 'session',
  sessions: 'session',
  attachment: 'attachment',
  transaction: 'transaction',
  event: 'error',
  client_report: 'internal',
  user_report: 'default',
  profile: 'profile',
  replay_event: 'replay',
  replay_recording: 'replay',
  check_in: 'monitor',
};

/**
 * Maps the type of an envelope item to a data category.
 */
function envelopeItemTypeToDataCategory(type) {
  return ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}

/** Extracts the minimal SDK info from from the metadata or an events */
function getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
  if (!metadataOrEvent || !metadataOrEvent.sdk) {
    return;
  }
  const { name, version } = metadataOrEvent.sdk;
  return { name, version };
}

/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */
function createEventEnvelopeHeaders(
  event,
  sdkInfo,
  tunnel,
  dsn,
) {
  const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
  return {
    event_id: event.event_id ,
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && { dsn: (0,esm_dsn/* dsnToString */.RA)(dsn) }),
    ...(dynamicSamplingContext && {
      trace: (0,object/* dropUndefinedKeys */.Jr)({ ...dynamicSamplingContext }),
    }),
  };
}


//# sourceMappingURL=envelope.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/error.js
/** An error emitted by Sentry SDKs and related utilities. */
class SentryError extends Error {
  /** Display name of this error instance. */

   constructor( message, logLevel = 'warn') {
    super(message);this.message = message;
    this.name = new.target.prototype.constructor.name;
    // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
    // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
    // instances of `SentryError` fail `obj instanceof SentryError` checks.
    Object.setPrototypeOf(this, new.target.prototype);
    this.logLevel = logLevel;
  }
}


//# sourceMappingURL=error.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/api.js


const SENTRY_API_VERSION = '7';

/** Returns the prefix to construct Sentry ingestion API endpoints. */
function getBaseApiEndpoint(dsn) {
  const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
  const port = dsn.port ? `:${dsn.port}` : '';
  return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}

/** Returns the ingest API endpoint for target. */
function _getIngestEndpoint(dsn) {
  return `${getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}

/** Returns a URL-encoded string with auth config suitable for a query string. */
function _encodedAuth(dsn, sdkInfo) {
  return (0,object/* urlEncode */._j)({
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    sentry_key: dsn.publicKey,
    sentry_version: SENTRY_API_VERSION,
    ...(sdkInfo && { sentry_client: `${sdkInfo.name}/${sdkInfo.version}` }),
  });
}

/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getEnvelopeEndpointWithUrlEncodedAuth(
  dsn,
  // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
  // options: ClientOptions = {} as ClientOptions,
  tunnelOrOptions = {} ,
) {
  // TODO (v8): Use this code instead
  // const { tunnel, _metadata = {} } = options;
  // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;

  const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
  const sdkInfo =
    typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;

  return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, sdkInfo)}`;
}

/** Returns the url to the report dialog endpoint. */
function api_getReportDialogEndpoint(
  dsnLike,
  dialogOptions

,
) {
  const dsn = makeDsn(dsnLike);
  if (!dsn) {
    return '';
  }

  const endpoint = `${getBaseApiEndpoint(dsn)}embed/error-page/`;

  let encodedOptions = `dsn=${dsnToString(dsn)}`;
  for (const key in dialogOptions) {
    if (key === 'dsn') {
      continue;
    }

    if (key === 'user') {
      const user = dialogOptions.user;
      if (!user) {
        continue;
      }
      if (user.name) {
        encodedOptions += `&name=${encodeURIComponent(user.name)}`;
      }
      if (user.email) {
        encodedOptions += `&email=${encodeURIComponent(user.email)}`;
      }
    } else {
      encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key] )}`;
    }
  }

  return `${endpoint}?${encodedOptions}`;
}


//# sourceMappingURL=api.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/envelope.js


/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/
function enhanceEventWithSdkInfo(event, sdkInfo) {
  if (!sdkInfo) {
    return event;
  }
  event.sdk = event.sdk || {};
  event.sdk.name = event.sdk.name || sdkInfo.name;
  event.sdk.version = event.sdk.version || sdkInfo.version;
  event.sdk.integrations = [...(event.sdk.integrations || []), ...(sdkInfo.integrations || [])];
  event.sdk.packages = [...(event.sdk.packages || []), ...(sdkInfo.packages || [])];
  return event;
}

/** Creates an envelope from a Session */
function createSessionEnvelope(
  session,
  dsn,
  metadata,
  tunnel,
) {
  const sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);
  const envelopeHeaders = {
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && { dsn: (0,esm_dsn/* dsnToString */.RA)(dsn) }),
  };

  const envelopeItem =
    'aggregates' in session ? [{ type: 'sessions' }, session] : [{ type: 'session' }, session.toJSON()];

  return createEnvelope(envelopeHeaders, [envelopeItem]);
}

/**
 * Create an Envelope from an event.
 */
function createEventEnvelope(
  event,
  dsn,
  metadata,
  tunnel,
) {
  const sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);

  /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */
  const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';

  enhanceEventWithSdkInfo(event, metadata && metadata.sdk);

  const envelopeHeaders = createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);

  // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
  // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
  // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
  // of this `delete`, lest we miss putting it back in the next time the property is in use.)
  delete event.sdkProcessingMetadata;

  const eventItem = [{ type: eventType }, event];
  return createEnvelope(envelopeHeaders, [eventItem]);
}


//# sourceMappingURL=envelope.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/session.js
var esm_session = __webpack_require__(9015);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(21170);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(71235);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/constants.js
var constants = __webpack_require__(51131);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/utils/prepareEvent.js




/**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */
function prepareEvent(
  options,
  event,
  hint,
  scope,
) {
  const { normalizeDepth = 3, normalizeMaxBreadth = 1000 } = options;
  const prepared = {
    ...event,
    event_id: event.event_id || hint.event_id || (0,misc/* uuid4 */.DM)(),
    timestamp: event.timestamp || (0,time/* dateTimestampInSeconds */.yW)(),
  };
  const integrations = hint.integrations || options.integrations.map(i => i.name);

  applyClientOptions(prepared, options);
  applyIntegrationsMetadata(prepared, integrations);

  // Only apply debug metadata to error events.
  if (event.type === undefined) {
    applyDebugMetadata(prepared, options.stackParser);
  }

  // If we have scope given to us, use it as the base for further modifications.
  // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
  let finalScope = scope;
  if (hint.captureContext) {
    finalScope = esm_scope/* Scope.clone */.s.clone(finalScope).update(hint.captureContext);
  }

  // We prepare the result here with a resolved Event.
  let result = (0,syncpromise/* resolvedSyncPromise */.WD)(prepared);

  // This should be the last thing called, since we want that
  // {@link Hub.addEventProcessor} gets the finished prepared event.
  //
  // We need to check for the existence of `finalScope.getAttachments`
  // because `getAttachments` can be undefined if users are using an older version
  // of `@sentry/core` that does not have the `getAttachments` method.
  // See: https://github.com/getsentry/sentry-javascript/issues/5229
  if (finalScope) {
    // Collect attachments from the hint and scope
    if (finalScope.getAttachments) {
      const attachments = [...(hint.attachments || []), ...finalScope.getAttachments()];

      if (attachments.length) {
        hint.attachments = attachments;
      }
    }

    // In case we have a hub we reassign it.
    result = finalScope.applyToEvent(prepared, hint);
  }

  return result.then(evt => {
    if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
      return normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
    }
    return evt;
  });
}

/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */
function applyClientOptions(event, options) {
  const { environment, release, dist, maxValueLength = 250 } = options;

  if (!('environment' in event)) {
    event.environment = 'environment' in options ? environment : constants/* DEFAULT_ENVIRONMENT */.J;
  }

  if (event.release === undefined && release !== undefined) {
    event.release = release;
  }

  if (event.dist === undefined && dist !== undefined) {
    event.dist = dist;
  }

  if (event.message) {
    event.message = (0,string/* truncate */.$G)(event.message, maxValueLength);
  }

  const exception = event.exception && event.exception.values && event.exception.values[0];
  if (exception && exception.value) {
    exception.value = (0,string/* truncate */.$G)(exception.value, maxValueLength);
  }

  const request = event.request;
  if (request && request.url) {
    request.url = (0,string/* truncate */.$G)(request.url, maxValueLength);
  }
}

const debugIdStackParserCache = new WeakMap();

/**
 * Applies debug metadata images to the event in order to apply source maps by looking up their debug ID.
 */
function applyDebugMetadata(event, stackParser) {
  const debugIdMap = worldwide/* GLOBAL_OBJ._sentryDebugIds */.n2._sentryDebugIds;

  if (!debugIdMap) {
    return;
  }

  let debugIdStackFramesCache;
  const cachedDebugIdStackFrameCache = debugIdStackParserCache.get(stackParser);
  if (cachedDebugIdStackFrameCache) {
    debugIdStackFramesCache = cachedDebugIdStackFrameCache;
  } else {
    debugIdStackFramesCache = new Map();
    debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
  }

  // Build a map of filename -> debug_id
  const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace) => {
    let parsedStack;
    const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
    if (cachedParsedStack) {
      parsedStack = cachedParsedStack;
    } else {
      parsedStack = stackParser(debugIdStackTrace);
      debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
    }

    for (let i = parsedStack.length - 1; i >= 0; i--) {
      const stackFrame = parsedStack[i];
      if (stackFrame.filename) {
        acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
        break;
      }
    }
    return acc;
  }, {});

  // Get a Set of filenames in the stack trace
  const errorFileNames = new Set();
  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    event.exception.values.forEach(exception => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      exception.stacktrace.frames.forEach(frame => {
        if (frame.filename) {
          errorFileNames.add(frame.filename);
        }
      });
    });
  } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
  }

  // Fill debug_meta information
  event.debug_meta = event.debug_meta || {};
  event.debug_meta.images = event.debug_meta.images || [];
  const images = event.debug_meta.images;
  errorFileNames.forEach(filename => {
    if (filenameDebugIdMap[filename]) {
      images.push({
        type: 'sourcemap',
        code_file: filename,
        debug_id: filenameDebugIdMap[filename],
      });
    }
  });
}

/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */
function applyIntegrationsMetadata(event, integrationNames) {
  if (integrationNames.length > 0) {
    event.sdk = event.sdk || {};
    event.sdk.integrations = [...(event.sdk.integrations || []), ...integrationNames];
  }
}

/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */
function normalizeEvent(event, depth, maxBreadth) {
  if (!event) {
    return null;
  }

  const normalized = {
    ...event,
    ...(event.breadcrumbs && {
      breadcrumbs: event.breadcrumbs.map(b => ({
        ...b,
        ...(b.data && {
          data: normalize(b.data, depth, maxBreadth),
        }),
      })),
    }),
    ...(event.user && {
      user: normalize(event.user, depth, maxBreadth),
    }),
    ...(event.contexts && {
      contexts: normalize(event.contexts, depth, maxBreadth),
    }),
    ...(event.extra && {
      extra: normalize(event.extra, depth, maxBreadth),
    }),
  };

  // event.contexts.trace stores information about a Transaction. Similarly,
  // event.spans[] stores information about child Spans. Given that a
  // Transaction is conceptually a Span, normalization should apply to both
  // Transactions and Spans consistently.
  // For now the decision is to skip normalization of Transactions and Spans,
  // so this block overwrites the normalized event to add back the original
  // Transaction information prior to normalization.
  if (event.contexts && event.contexts.trace && normalized.contexts) {
    normalized.contexts.trace = event.contexts.trace;

    // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
    if (event.contexts.trace.data) {
      normalized.contexts.trace.data = normalize(event.contexts.trace.data, depth, maxBreadth);
    }
  }

  // event.spans[].data may contain circular/dangerous data so we need to normalize it
  if (event.spans) {
    normalized.spans = event.spans.map(span => {
      // We cannot use the spread operator here because `toJSON` on `span` is non-enumerable
      if (span.data) {
        span.data = normalize(span.data, depth, maxBreadth);
      }
      return span;
    });
  }

  return normalized;
}


//# sourceMappingURL=prepareEvent.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/baseclient.js







const ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";

/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */
class BaseClient {
  /** Options passed to the SDK. */

  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */

  /** Array of set up integrations. */
   __init() {this._integrations = {};}

  /** Indicates whether this client's integrations have been set up. */
   __init2() {this._integrationsInitialized = false;}

  /** Number of calls being processed */
   __init3() {this._numProcessing = 0;}

  /** Holds flushable  */
   __init4() {this._outcomes = {};}

  // eslint-disable-next-line @typescript-eslint/ban-types
   __init5() {this._hooks = {};}

  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
   constructor(options) {BaseClient.prototype.__init.call(this);BaseClient.prototype.__init2.call(this);BaseClient.prototype.__init3.call(this);BaseClient.prototype.__init4.call(this);BaseClient.prototype.__init5.call(this);
    this._options = options;

    if (options.dsn) {
      this._dsn = (0,esm_dsn/* makeDsn */.vK)(options.dsn);
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('No DSN provided, client will not do anything.');
    }

    if (this._dsn) {
      const url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options);
      this._transport = options.transport({
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...options.transportOptions,
        url,
      });
    }
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   captureException(exception, hint, scope) {
    // ensure we haven't captured this very object before
    if ((0,misc/* checkOrSetAlreadyCaught */.YO)(exception)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this.eventFromException(exception, hint)
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
    scope,
  ) {
    let eventId = hint && hint.event_id;

    const promisedEvent = (0,is/* isPrimitive */.pt)(message)
      ? this.eventFromMessage(String(message), level, hint)
      : this.eventFromException(message, hint);

    this._process(
      promisedEvent
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint, scope) {
    // ensure we haven't captured this very object before
    if (hint && hint.originalException && (0,misc/* checkOrSetAlreadyCaught */.YO)(hint.originalException)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this._captureEvent(event, hint, scope).then(result => {
        eventId = result;
      }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureSession(session) {
    if (!this._isEnabled()) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('SDK not enabled, will not capture session.');
      return;
    }

    if (!(typeof session.release === 'string')) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Discarded session because of missing or non-string release');
    } else {
      this.sendSession(session);
      // After sending, we set init false to indicate it's not the first occurrence
      (0,esm_session/* updateSession */.CT)(session, { init: false });
    }
  }

  /**
   * @inheritDoc
   */
   getDsn() {
    return this._dsn;
  }

  /**
   * @inheritDoc
   */
   getOptions() {
    return this._options;
  }

  /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */
   getSdkMetadata() {
    return this._options._metadata;
  }

  /**
   * @inheritDoc
   */
   getTransport() {
    return this._transport;
  }

  /**
   * @inheritDoc
   */
   flush(timeout) {
    const transport = this._transport;
    if (transport) {
      return this._isClientDoneProcessing(timeout).then(clientFinished => {
        return transport.flush(timeout).then(transportFlushed => clientFinished && transportFlushed);
      });
    } else {
      return (0,syncpromise/* resolvedSyncPromise */.WD)(true);
    }
  }

  /**
   * @inheritDoc
   */
   close(timeout) {
    return this.flush(timeout).then(result => {
      this.getOptions().enabled = false;
      return result;
    });
  }

  /**
   * Sets up the integrations
   */
   setupIntegrations() {
    if (this._isEnabled() && !this._integrationsInitialized) {
      this._integrations = setupIntegrations(this._options.integrations);
      this._integrationsInitialized = true;
    }
  }

  /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   */
   getIntegrationById(integrationId) {
    return this._integrations[integrationId];
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    try {
      return (this._integrations[integration.id] ) || null;
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(`Cannot retrieve integration ${integration.id} from the current Client`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   addIntegration(integration) {
    setupIntegration(integration, this._integrations);
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint = {}) {
    if (this._dsn) {
      let env = createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);

      for (const attachment of hint.attachments || []) {
        env = addItemToEnvelope(
          env,
          createAttachmentEnvelopeItem(
            attachment,
            this._options.transportOptions && this._options.transportOptions.textEncoder,
          ),
        );
      }

      const promise = this._sendEnvelope(env);
      if (promise) {
        promise.then(sendResponse => this.emit('afterSendEvent', event, sendResponse), null);
      }
    }
  }

  /**
   * @inheritDoc
   */
   sendSession(session) {
    if (this._dsn) {
      const env = createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
      void this._sendEnvelope(env);
    }
  }

  /**
   * @inheritDoc
   */
   recordDroppedEvent(reason, category, _event) {
    // Note: we use `event` in replay, where we overwrite this hook.

    if (this._options.sendClientReports) {
      // We want to track each category (error, transaction, session, replay_event) separately
      // but still keep the distinction between different type of outcomes.
      // We could use nested maps, but it's much easier to read and type this way.
      // A correct type for map-based implementation if we want to go that route
      // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
      // With typescript 4.1 we could even use template literal types
      const key = `${reason}:${category}`;
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Adding outcome: "${key}"`);

      // The following works because undefined + 1 === NaN and NaN is falsy
      this._outcomes[key] = this._outcomes[key] + 1 || 1;
    }
  }

  // Keep on() & emit() signatures in sync with types' client.ts interface

  /** @inheritdoc */

  /** @inheritdoc */
   on(hook, callback) {
    if (!this._hooks[hook]) {
      this._hooks[hook] = [];
    }

    // @ts-ignore We assue the types are correct
    this._hooks[hook].push(callback);
  }

  /** @inheritdoc */

  /** @inheritdoc */
   emit(hook, ...rest) {
    if (this._hooks[hook]) {
      // @ts-ignore we cannot enforce the callback to match the hook
      this._hooks[hook].forEach(callback => callback(...rest));
    }
  }

  /** Updates existing session based on the provided event */
   _updateSessionFromEvent(session, event) {
    let crashed = false;
    let errored = false;
    const exceptions = event.exception && event.exception.values;

    if (exceptions) {
      errored = true;

      for (const ex of exceptions) {
        const mechanism = ex.mechanism;
        if (mechanism && mechanism.handled === false) {
          crashed = true;
          break;
        }
      }
    }

    // A session is updated and that session update is sent in only one of the two following scenarios:
    // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
    // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
    const sessionNonTerminal = session.status === 'ok';
    const shouldUpdateAndSend = (sessionNonTerminal && session.errors === 0) || (sessionNonTerminal && crashed);

    if (shouldUpdateAndSend) {
      (0,esm_session/* updateSession */.CT)(session, {
        ...(crashed && { status: 'crashed' }),
        errors: session.errors || Number(errored || crashed),
      });
      this.captureSession(session);
    }
  }

  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
   _isClientDoneProcessing(timeout) {
    return new syncpromise/* SyncPromise */.cW(resolve => {
      let ticked = 0;
      const tick = 1;

      const interval = setInterval(() => {
        if (this._numProcessing == 0) {
          clearInterval(interval);
          resolve(true);
        } else {
          ticked += tick;
          if (timeout && ticked >= timeout) {
            clearInterval(interval);
            resolve(false);
          }
        }
      }, tick);
    });
  }

  /** Determines whether this SDK is enabled and a valid Dsn is present. */
   _isEnabled() {
    return this.getOptions().enabled !== false && this._dsn !== undefined;
  }

  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */
   _prepareEvent(event, hint, scope) {
    const options = this.getOptions();
    const integrations = Object.keys(this._integrations);
    if (!hint.integrations && integrations.length > 0) {
      hint.integrations = integrations;
    }
    return prepareEvent(options, event, hint, scope);
  }

  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
   _captureEvent(event, hint = {}, scope) {
    return this._processEvent(event, hint, scope).then(
      finalEvent => {
        return finalEvent.event_id;
      },
      reason => {
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
          // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
          // control flow, log just the message (no stack) as a log-level log.
          const sentryError = reason ;
          if (sentryError.logLevel === 'log') {
            esm_logger/* logger.log */.kg.log(sentryError.message);
          } else {
            esm_logger/* logger.warn */.kg.warn(sentryError);
          }
        }
        return undefined;
      },
    );
  }

  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
   _processEvent(event, hint, scope) {
    const options = this.getOptions();
    const { sampleRate } = options;

    if (!this._isEnabled()) {
      return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError('SDK not enabled, will not capture event.', 'log'));
    }

    const isTransaction = isTransactionEvent(event);
    const isError = isErrorEvent(event);
    const eventType = event.type || 'error';
    const beforeSendLabel = `before send for type \`${eventType}\``;

    // 1.0 === 100% events are sent
    // 0.0 === 0% events are sent
    // Sampling for transaction happens somewhere else
    if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
      this.recordDroppedEvent('sample_rate', 'error', event);
      return (0,syncpromise/* rejectedSyncPromise */.$2)(
        new SentryError(
          `Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`,
          'log',
        ),
      );
    }

    const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;

    return this._prepareEvent(event, hint, scope)
      .then(prepared => {
        if (prepared === null) {
          this.recordDroppedEvent('event_processor', dataCategory, event);
          throw new SentryError('An event processor returned `null`, will not send event.', 'log');
        }

        const isInternalException = hint.data && (hint.data ).__sentry__ === true;
        if (isInternalException) {
          return prepared;
        }

        const result = processBeforeSend(options, prepared, hint);
        return _validateBeforeSendResult(result, beforeSendLabel);
      })
      .then(processedEvent => {
        if (processedEvent === null) {
          this.recordDroppedEvent('before_send', dataCategory, event);
          throw new SentryError(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
        }

        const session = scope && scope.getSession();
        if (!isTransaction && session) {
          this._updateSessionFromEvent(session, processedEvent);
        }

        // None of the Sentry built event processor will update transaction name,
        // so if the transaction name has been changed by an event processor, we know
        // it has to come from custom event processor added by a user
        const transactionInfo = processedEvent.transaction_info;
        if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
          const source = 'custom';
          processedEvent.transaction_info = {
            ...transactionInfo,
            source,
          };
        }

        this.sendEvent(processedEvent, hint);
        return processedEvent;
      })
      .then(null, reason => {
        if (reason instanceof SentryError) {
          throw reason;
        }

        this.captureException(reason, {
          data: {
            __sentry__: true,
          },
          originalException: reason,
        });
        throw new SentryError(
          `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`,
        );
      });
  }

  /**
   * Occupies the client with processing and event
   */
   _process(promise) {
    this._numProcessing++;
    void promise.then(
      value => {
        this._numProcessing--;
        return value;
      },
      reason => {
        this._numProcessing--;
        return reason;
      },
    );
  }

  /**
   * @inheritdoc
   */
   _sendEnvelope(envelope) {
    if (this._transport && this._dsn) {
      this.emit('beforeEnvelope', envelope);

      return this._transport.send(envelope).then(null, reason => {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Error while sending event:', reason);
      });
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Transport disabled');
    }
  }

  /**
   * Clears outcomes on this client and returns them.
   */
   _clearOutcomes() {
    const outcomes = this._outcomes;
    this._outcomes = {};
    return Object.keys(outcomes).map(key => {
      const [reason, category] = key.split(':') ;
      return {
        reason,
        category,
        quantity: outcomes[key],
      };
    });
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types

}

/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */
function _validateBeforeSendResult(
  beforeSendResult,
  beforeSendLabel,
) {
  const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
  if ((0,is/* isThenable */.J8)(beforeSendResult)) {
    return beforeSendResult.then(
      event => {
        if (!(0,is/* isPlainObject */.PO)(event) && event !== null) {
          throw new SentryError(invalidValueError);
        }
        return event;
      },
      e => {
        throw new SentryError(`${beforeSendLabel} rejected with ${e}`);
      },
    );
  } else if (!(0,is/* isPlainObject */.PO)(beforeSendResult) && beforeSendResult !== null) {
    throw new SentryError(invalidValueError);
  }
  return beforeSendResult;
}

/**
 * Process the matching `beforeSendXXX` callback.
 */
function processBeforeSend(
  options,
  event,
  hint,
) {
  const { beforeSend, beforeSendTransaction } = options;

  if (isErrorEvent(event) && beforeSend) {
    return beforeSend(event, hint);
  }

  if (isTransactionEvent(event) && beforeSendTransaction) {
    return beforeSendTransaction(event, hint);
  }

  return event;
}

function isErrorEvent(event) {
  return event.type === undefined;
}

function isTransactionEvent(event) {
  return event.type === 'transaction';
}


//# sourceMappingURL=baseclient.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/version.js
var version = __webpack_require__(40105);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/env.js
var env = __webpack_require__(68518);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/clientreport.js



/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */
function createClientReportEnvelope(
  discarded_events,
  dsn,
  timestamp,
) {
  const clientReportItem = [
    { type: 'client_report' },
    {
      timestamp: timestamp || (0,time/* dateTimestampInSeconds */.yW)(),
      discarded_events,
    },
  ];
  return createEnvelope(dsn ? { dsn } : {}, [clientReportItem]);
}


//# sourceMappingURL=clientreport.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/eventbuilder.js



/**
 * This function creates an exception from a JavaScript Error
 */
function exceptionFromError(stackParser, ex) {
  // Get the frames first since Opera can lose the stack if we touch anything else first
  const frames = parseStackFrames(stackParser, ex);

  const exception = {
    type: ex && ex.name,
    value: extractMessage(ex),
  };

  if (frames.length) {
    exception.stacktrace = { frames };
  }

  if (exception.type === undefined && exception.value === '') {
    exception.value = 'Unrecoverable error caught';
  }

  return exception;
}

/**
 * @hidden
 */
function eventFromPlainObject(
  stackParser,
  exception,
  syntheticException,
  isUnhandledRejection,
) {
  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const client = hub.getClient();
  const normalizeDepth = client && client.getOptions().normalizeDepth;

  const event = {
    exception: {
      values: [
        {
          type: (0,is/* isEvent */.cO)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
          value: `Non-Error ${
            isUnhandledRejection ? 'promise rejection' : 'exception'
          } captured with keys: ${(0,object/* extractExceptionKeysForMessage */.zf)(exception)}`,
        },
      ],
    },
    extra: {
      __serialized__: normalizeToSize(exception, normalizeDepth),
    },
  };

  if (syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      // event.exception.values[0] has been set above
      (event.exception ).values[0].stacktrace = { frames };
    }
  }

  return event;
}

/**
 * @hidden
 */
function eventFromError(stackParser, ex) {
  return {
    exception: {
      values: [exceptionFromError(stackParser, ex)],
    },
  };
}

/** Parses stack frames from an error */
function parseStackFrames(
  stackParser,
  ex,
) {
  // Access and store the stacktrace property before doing ANYTHING
  // else to it because Opera is not very good at providing it
  // reliably in other circumstances.
  const stacktrace = ex.stacktrace || ex.stack || '';

  const popSize = getPopSize(ex);

  try {
    return stackParser(stacktrace, popSize);
  } catch (e) {
    // no-empty
  }

  return [];
}

// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const reactMinifiedRegexp = /Minified React error #\d+;/i;

function getPopSize(ex) {
  if (ex) {
    if (typeof ex.framesToPop === 'number') {
      return ex.framesToPop;
    }

    if (reactMinifiedRegexp.test(ex.message)) {
      return 1;
    }
  }

  return 0;
}

/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
function extractMessage(ex) {
  const message = ex && ex.message;
  if (!message) {
    return 'No error message';
  }
  if (message.error && typeof message.error.message === 'string') {
    return message.error.message;
  }
  return message;
}

/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */
function eventFromException(
  stackParser,
  exception,
  hint,
  attachStacktrace,
) {
  const syntheticException = (hint && hint.syntheticException) || undefined;
  const event = eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace);
  (0,misc/* addExceptionMechanism */.EG)(event); // defaults to { type: 'generic', handled: true }
  event.level = 'error';
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}

/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(
  stackParser,
  message,
  // eslint-disable-next-line deprecation/deprecation
  level = 'info',
  hint,
  attachStacktrace,
) {
  const syntheticException = (hint && hint.syntheticException) || undefined;
  const event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
  event.level = level;
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}

/**
 * @hidden
 */
function eventFromUnknownInput(
  stackParser,
  exception,
  syntheticException,
  attachStacktrace,
  isUnhandledRejection,
) {
  let event;

  if ((0,is/* isErrorEvent */.VW)(exception ) && (exception ).error) {
    // If it is an ErrorEvent with `error` property, extract it to get actual Error
    const errorEvent = exception ;
    return eventFromError(stackParser, errorEvent.error );
  }

  // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
  // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
  // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
  //
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
  // https://webidl.spec.whatwg.org/#es-DOMException-specialness
  if ((0,is/* isDOMError */.TX)(exception ) || (0,is/* isDOMException */.fm)(exception )) {
    const domException = exception ;

    if ('stack' in (exception )) {
      event = eventFromError(stackParser, exception );
    } else {
      const name = domException.name || ((0,is/* isDOMError */.TX)(domException) ? 'DOMError' : 'DOMException');
      const message = domException.message ? `${name}: ${domException.message}` : name;
      event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
      (0,misc/* addExceptionTypeValue */.Db)(event, message);
    }
    if ('code' in domException) {
      event.tags = { ...event.tags, 'DOMException.code': `${domException.code}` };
    }

    return event;
  }
  if ((0,is/* isError */.VZ)(exception)) {
    // we have a real Error object, do nothing
    return eventFromError(stackParser, exception);
  }
  if ((0,is/* isPlainObject */.PO)(exception) || (0,is/* isEvent */.cO)(exception)) {
    // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
    // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
    // group on any key/value change.
    const objectException = exception ;
    event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
    (0,misc/* addExceptionMechanism */.EG)(event, {
      synthetic: true,
    });
    return event;
  }

  // If none of previous checks were valid, then it means that it's not:
  // - an instance of DOMError
  // - an instance of DOMException
  // - an instance of Event
  // - an instance of Error
  // - a valid ErrorEvent (one with an error property)
  // - a plain Object
  //
  // So bail out and capture it as a simple message:
  event = eventFromString(stackParser, exception , syntheticException, attachStacktrace);
  (0,misc/* addExceptionTypeValue */.Db)(event, `${exception}`, undefined);
  (0,misc/* addExceptionMechanism */.EG)(event, {
    synthetic: true,
  });

  return event;
}

/**
 * @hidden
 */
function eventFromString(
  stackParser,
  input,
  syntheticException,
  attachStacktrace,
) {
  const event = {
    message: input,
  };

  if (attachStacktrace && syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      event.exception = {
        values: [{ value: input, stacktrace: { frames } }],
      };
    }
  }

  return event;
}


//# sourceMappingURL=eventbuilder.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/helpers.js
var helpers = __webpack_require__(86891);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(58464);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/severity.js
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.

const validSeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug'];

/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */
function severityFromString(level) {
  return severityLevelFromString(level) ;
}

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */
function severityLevelFromString(level) {
  return (level === 'warn' ? 'warning' : validSeverityLevels.includes(level) ? level : 'log') ;
}


//# sourceMappingURL=severity.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/url.js
var url = __webpack_require__(26956);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/breadcrumbs.js




/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */
const MAX_ALLOWED_STRING_LENGTH = 1024;

const BREADCRUMB_INTEGRATION_ID = 'Breadcrumbs';

/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
class Breadcrumbs  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = BREADCRUMB_INTEGRATION_ID;}

  /**
   * @inheritDoc
   */
   __init() {this.name = Breadcrumbs.id;}

  /**
   * Options of the breadcrumbs integration.
   */
  // This field is public, because we use it in the browser client to check if the `sentry` option is enabled.

  /**
   * @inheritDoc
   */
   constructor(options) {Breadcrumbs.prototype.__init.call(this);
    this.options = {
      console: true,
      dom: true,
      fetch: true,
      history: true,
      sentry: true,
      xhr: true,
      ...options,
    };
  }

  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - Console API
   *  - DOM API (click/typing)
   *  - XMLHttpRequest API
   *  - Fetch API
   *  - History API
   */
   setupOnce() {
    if (this.options.console) {
      (0,instrument/* addInstrumentationHandler */.oq)('console', _consoleBreadcrumb);
    }
    if (this.options.dom) {
      (0,instrument/* addInstrumentationHandler */.oq)('dom', _domBreadcrumb(this.options.dom));
    }
    if (this.options.xhr) {
      (0,instrument/* addInstrumentationHandler */.oq)('xhr', _xhrBreadcrumb);
    }
    if (this.options.fetch) {
      (0,instrument/* addInstrumentationHandler */.oq)('fetch', _fetchBreadcrumb);
    }
    if (this.options.history) {
      (0,instrument/* addInstrumentationHandler */.oq)('history', _historyBreadcrumb);
    }
  }

  /**
   * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
   */
   addSentryBreadcrumb(event) {
    if (this.options.sentry) {
      (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
        {
          category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
          event_id: event.event_id,
          level: event.level,
          message: (0,misc/* getEventDescription */.jH)(event),
        },
        {
          event,
        },
      );
    }
  }
} Breadcrumbs.__initStatic();

/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */
function _domBreadcrumb(dom) {
  function _innerDomBreadcrumb(handlerData) {
    let target;
    let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;

    let maxStringLength =
      typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
    if (maxStringLength && maxStringLength > MAX_ALLOWED_STRING_LENGTH) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn(
          `\`dom.maxStringLength\` cannot exceed ${MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${MAX_ALLOWED_STRING_LENGTH} instead.`,
        );
      maxStringLength = MAX_ALLOWED_STRING_LENGTH;
    }

    if (typeof keyAttrs === 'string') {
      keyAttrs = [keyAttrs];
    }

    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
      const event = handlerData.event ;
      target = _isEvent(event)
        ? (0,browser/* htmlTreeAsString */.Rt)(event.target, { keyAttrs, maxStringLength })
        : (0,browser/* htmlTreeAsString */.Rt)(event, { keyAttrs, maxStringLength });
    } catch (e) {
      target = '<unknown>';
    }

    if (target.length === 0) {
      return;
    }

    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: `ui.${handlerData.name}`,
        message: target,
      },
      {
        event: handlerData.event,
        name: handlerData.name,
        global: handlerData.global,
      },
    );
  }

  return _innerDomBreadcrumb;
}

/**
 * Creates breadcrumbs from console API calls
 */
function _consoleBreadcrumb(handlerData) {
  // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
  // console warnings. This happens when a Vue template is rendered with
  // an undeclared variable, which we try to stringify, ultimately causing
  // Vue to issue another warning which repeats indefinitely.
  // see: https://github.com/getsentry/sentry-javascript/pull/6010
  // see: https://github.com/getsentry/sentry-javascript/issues/5916
  for (let i = 0; i < handlerData.args.length; i++) {
    if (handlerData.args[i] === 'ref=Ref<') {
      handlerData.args[i + 1] = 'viewRef';
      break;
    }
  }
  const breadcrumb = {
    category: 'console',
    data: {
      arguments: handlerData.args,
      logger: 'console',
    },
    level: severityLevelFromString(handlerData.level),
    message: (0,string/* safeJoin */.nK)(handlerData.args, ' '),
  };

  if (handlerData.level === 'assert') {
    if (handlerData.args[0] === false) {
      breadcrumb.message = `Assertion failed: ${(0,string/* safeJoin */.nK)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
      breadcrumb.data.arguments = handlerData.args.slice(1);
    } else {
      // Don't capture a breadcrumb for passed assertions
      return;
    }
  }

  (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(breadcrumb, {
    input: handlerData.args,
    level: handlerData.level,
  });
}

/**
 * Creates breadcrumbs from XHR API calls
 */
function _xhrBreadcrumb(handlerData) {
  const { startTimestamp, endTimestamp } = handlerData;

  const sentryXhrData = handlerData.xhr[instrument/* SENTRY_XHR_DATA_KEY */.xU];

  // We only capture complete, non-sentry requests
  if (!startTimestamp || !endTimestamp || !sentryXhrData) {
    return;
  }

  const { method, url, status_code, body } = sentryXhrData;

  const data = {
    method,
    url,
    status_code,
  };

  const hint = {
    xhr: handlerData.xhr,
    input: body,
    startTimestamp,
    endTimestamp,
  };

  (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
    {
      category: 'xhr',
      data,
      type: 'http',
    },
    hint,
  );
}

/**
 * Creates breadcrumbs from fetch API calls
 */
function _fetchBreadcrumb(handlerData) {
  const { startTimestamp, endTimestamp } = handlerData;

  // We only capture complete fetch requests
  if (!endTimestamp) {
    return;
  }

  if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
    // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
  }

  if (handlerData.error) {
    const data = handlerData.fetchData;
    const hint = {
      data: handlerData.error,
      input: handlerData.args,
      startTimestamp,
      endTimestamp,
    };

    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'fetch',
        data,
        level: 'error',
        type: 'http',
      },
      hint,
    );
  } else {
    const data = {
      ...handlerData.fetchData,
      status_code: handlerData.response && handlerData.response.status,
    };
    const hint = {
      input: handlerData.args,
      response: handlerData.response,
      startTimestamp,
      endTimestamp,
    };
    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'fetch',
        data,
        type: 'http',
      },
      hint,
    );
  }
}

/**
 * Creates breadcrumbs from history API calls
 */
function _historyBreadcrumb(handlerData) {
  let from = handlerData.from;
  let to = handlerData.to;
  const parsedLoc = (0,url/* parseUrl */.en)(helpers/* WINDOW.location.href */.m9.location.href);
  let parsedFrom = (0,url/* parseUrl */.en)(from);
  const parsedTo = (0,url/* parseUrl */.en)(to);

  // Initial pushState doesn't provide `from` information
  if (!parsedFrom.path) {
    parsedFrom = parsedLoc;
  }

  // Use only the path component of the URL if the URL matches the current
  // document (almost all the time when using pushState)
  if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
    to = parsedTo.relative;
  }
  if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
    from = parsedFrom.relative;
  }

  (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb({
    category: 'navigation',
    data: {
      from,
      to,
    },
  });
}

function _isEvent(event) {
  return event && !!(event ).target;
}


//# sourceMappingURL=breadcrumbs.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/userfeedback.js


/**
 * Creates an envelope from a user feedback.
 */
function createUserFeedbackEnvelope(
  feedback,
  {
    metadata,
    tunnel,
    dsn,
  }

,
) {
  const headers = {
    event_id: feedback.event_id,
    sent_at: new Date().toISOString(),
    ...(metadata &&
      metadata.sdk && {
        sdk: {
          name: metadata.sdk.name,
          version: metadata.sdk.version,
        },
      }),
    ...(!!tunnel && !!dsn && { dsn: (0,esm_dsn/* dsnToString */.RA)(dsn) }),
  };
  const item = createUserFeedbackEnvelopeItem(feedback);

  return createEnvelope(headers, [item]);
}

function createUserFeedbackEnvelopeItem(feedback) {
  const feedbackHeaders = {
    type: 'user_report',
  };
  return [feedbackHeaders, feedback];
}


//# sourceMappingURL=userfeedback.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/client.js







/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
class BrowserClient extends BaseClient {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
   constructor(options) {
    const sdkSource = helpers/* WINDOW.SENTRY_SDK_SOURCE */.m9.SENTRY_SDK_SOURCE || (0,env/* getSDKSource */.S)();

    options._metadata = options._metadata || {};
    options._metadata.sdk = options._metadata.sdk || {
      name: 'sentry.javascript.browser',
      packages: [
        {
          name: `${sdkSource}:@sentry/browser`,
          version: version/* SDK_VERSION */.J,
        },
      ],
      version: version/* SDK_VERSION */.J,
    };

    super(options);

    if (options.sendClientReports && helpers/* WINDOW.document */.m9.document) {
      helpers/* WINDOW.document.addEventListener */.m9.document.addEventListener('visibilitychange', () => {
        if (helpers/* WINDOW.document.visibilityState */.m9.document.visibilityState === 'hidden') {
          this._flushOutcomes();
        }
      });
    }
  }

  /**
   * @inheritDoc
   */
   eventFromException(exception, hint) {
    return eventFromException(this._options.stackParser, exception, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   eventFromMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level = 'info',
    hint,
  ) {
    return eventFromMessage(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint) {
    // We only want to add the sentry event breadcrumb when the user has the breadcrumb integration installed and
    // activated its `sentry` option.
    // We also do not want to use the `Breadcrumbs` class here directly, because we do not want it to be included in
    // bundles, if it is not used by the SDK.
    // This all sadly is a bit ugly, but we currently don't have a "pre-send" hook on the integrations so we do it this
    // way for now.
    const breadcrumbIntegration = this.getIntegrationById(BREADCRUMB_INTEGRATION_ID) ;
    // We check for definedness of `addSentryBreadcrumb` in case users provided their own integration with id
    // "Breadcrumbs" that does not have this function.
    if (breadcrumbIntegration && breadcrumbIntegration.addSentryBreadcrumb) {
      breadcrumbIntegration.addSentryBreadcrumb(event);
    }

    super.sendEvent(event, hint);
  }

  /**
   * Sends user feedback to Sentry.
   */
   captureUserFeedback(feedback) {
    if (!this._isEnabled()) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('SDK not enabled, will not capture user feedback.');
      return;
    }

    const envelope = createUserFeedbackEnvelope(feedback, {
      metadata: this.getSdkMetadata(),
      dsn: this.getDsn(),
      tunnel: this.getOptions().tunnel,
    });
    void this._sendEnvelope(envelope);
  }

  /**
   * @inheritDoc
   */
   _prepareEvent(event, hint, scope) {
    event.platform = event.platform || 'javascript';
    return super._prepareEvent(event, hint, scope);
  }

  /**
   * Sends client reports as an envelope.
   */
   _flushOutcomes() {
    const outcomes = this._clearOutcomes();

    if (outcomes.length === 0) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('No outcomes to send');
      return;
    }

    if (!this._dsn) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('No dsn provided, will not send outcomes');
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('Sending outcomes:', outcomes);

    const envelope = createClientReportEnvelope(outcomes, this._options.tunnel && (0,esm_dsn/* dsnToString */.RA)(this._dsn));
    void this._sendEnvelope(envelope);
  }
}


//# sourceMappingURL=client.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/globalhandlers.js





/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/** Global handlers */
class GlobalHandlers  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'GlobalHandlers';}

  /**
   * @inheritDoc
   */
   __init() {this.name = GlobalHandlers.id;}

  /** JSDoc */

  /**
   * Stores references functions to installing handlers. Will set to undefined
   * after they have been run so that they are not used twice.
   */
   __init2() {this._installFunc = {
    onerror: _installGlobalOnErrorHandler,
    onunhandledrejection: _installGlobalOnUnhandledRejectionHandler,
  };}

  /** JSDoc */
   constructor(options) {GlobalHandlers.prototype.__init.call(this);GlobalHandlers.prototype.__init2.call(this);
    this._options = {
      onerror: true,
      onunhandledrejection: true,
      ...options,
    };
  }
  /**
   * @inheritDoc
   */
   setupOnce() {
    Error.stackTraceLimit = 50;
    const options = this._options;

    // We can disable guard-for-in as we construct the options object above + do checks against
    // `this._installFunc` for the property.
    // eslint-disable-next-line guard-for-in
    for (const key in options) {
      const installFunc = this._installFunc[key ];
      if (installFunc && options[key ]) {
        globalHandlerLog(key);
        installFunc();
        this._installFunc[key ] = undefined;
      }
    }
  }
} GlobalHandlers.__initStatic();

/** JSDoc */
function _installGlobalOnErrorHandler() {
  (0,instrument/* addInstrumentationHandler */.oq)(
    'error',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (data) => {
      const [hub, stackParser, attachStacktrace] = getHubAndOptions();
      if (!hub.getIntegration(GlobalHandlers)) {
        return;
      }
      const { msg, url, line, column, error } = data;
      if ((0,helpers/* shouldIgnoreOnError */.Wz)() || (error && error.__sentry_own_request__)) {
        return;
      }

      const event =
        error === undefined && (0,is/* isString */.HD)(msg)
          ? _eventFromIncompleteOnError(msg, url, line, column)
          : _enhanceEventWithInitialFrame(
              eventFromUnknownInput(stackParser, error || msg, undefined, attachStacktrace, false),
              url,
              line,
              column,
            );

      event.level = 'error';

      addMechanismAndCapture(hub, error, event, 'onerror');
    },
  );
}

/** JSDoc */
function _installGlobalOnUnhandledRejectionHandler() {
  (0,instrument/* addInstrumentationHandler */.oq)(
    'unhandledrejection',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e) => {
      const [hub, stackParser, attachStacktrace] = getHubAndOptions();
      if (!hub.getIntegration(GlobalHandlers)) {
        return;
      }
      let error = e;

      // dig the object of the rejection out of known event types
      try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) {
          error = e.reason;
        }
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        else if ('detail' in e && 'reason' in e.detail) {
          error = e.detail.reason;
        }
      } catch (_oO) {
        // no-empty
      }

      if ((0,helpers/* shouldIgnoreOnError */.Wz)() || (error && error.__sentry_own_request__)) {
        return true;
      }

      const event = (0,is/* isPrimitive */.pt)(error)
        ? _eventFromRejectionWithPrimitive(error)
        : eventFromUnknownInput(stackParser, error, undefined, attachStacktrace, true);

      event.level = 'error';

      addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
      return;
    },
  );
}

/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */
function _eventFromRejectionWithPrimitive(reason) {
  return {
    exception: {
      values: [
        {
          type: 'UnhandledRejection',
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(reason)}`,
        },
      ],
    },
  };
}

/**
 * This function creates a stack from an old, error-less onerror handler.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _eventFromIncompleteOnError(msg, url, line, column) {
  const ERROR_TYPES_RE =
    /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;

  // If 'message' is ErrorEvent, get real message from inside
  let message = (0,is/* isErrorEvent */.VW)(msg) ? msg.message : msg;
  let name = 'Error';

  const groups = message.match(ERROR_TYPES_RE);
  if (groups) {
    name = groups[1];
    message = groups[2];
  }

  const event = {
    exception: {
      values: [
        {
          type: name,
          value: message,
        },
      ],
    },
  };

  return _enhanceEventWithInitialFrame(event, url, line, column);
}

/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enhanceEventWithInitialFrame(event, url, line, column) {
  // event.exception
  const e = (event.exception = event.exception || {});
  // event.exception.values
  const ev = (e.values = e.values || []);
  // event.exception.values[0]
  const ev0 = (ev[0] = ev[0] || {});
  // event.exception.values[0].stacktrace
  const ev0s = (ev0.stacktrace = ev0.stacktrace || {});
  // event.exception.values[0].stacktrace.frames
  const ev0sf = (ev0s.frames = ev0s.frames || []);

  const colno = isNaN(parseInt(column, 10)) ? undefined : column;
  const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
  const filename = (0,is/* isString */.HD)(url) && url.length > 0 ? url : (0,browser/* getLocationHref */.l4)();

  // event.exception.values[0].stacktrace.frames
  if (ev0sf.length === 0) {
    ev0sf.push({
      colno,
      filename,
      function: '?',
      in_app: true,
      lineno,
    });
  }

  return event;
}

function globalHandlerLog(type) {
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Global Handler attached: ${type}`);
}

function addMechanismAndCapture(hub, error, event, type) {
  (0,misc/* addExceptionMechanism */.EG)(event, {
    handled: false,
    type,
  });
  hub.captureEvent(event, {
    originalException: error,
  });
}

function getHubAndOptions() {
  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const client = hub.getClient();
  const options = (client && client.getOptions()) || {
    stackParser: () => [],
    attachStacktrace: false,
  };
  return [hub, options.stackParser, options.attachStacktrace];
}


//# sourceMappingURL=globalhandlers.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/trycatch.js



const DEFAULT_EVENT_TARGET = [
  'EventTarget',
  'Window',
  'Node',
  'ApplicationCache',
  'AudioTrackList',
  'ChannelMergerNode',
  'CryptoOperation',
  'EventSource',
  'FileReader',
  'HTMLUnknownElement',
  'IDBDatabase',
  'IDBRequest',
  'IDBTransaction',
  'KeyOperation',
  'MediaController',
  'MessagePort',
  'ModalWindow',
  'Notification',
  'SVGElementInstance',
  'Screen',
  'TextTrack',
  'TextTrackCue',
  'TextTrackList',
  'WebSocket',
  'WebSocketWorker',
  'Worker',
  'XMLHttpRequest',
  'XMLHttpRequestEventTarget',
  'XMLHttpRequestUpload',
];

/** Wrap timer functions and event targets to catch errors and provide better meta data */
class TryCatch  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'TryCatch';}

  /**
   * @inheritDoc
   */
   __init() {this.name = TryCatch.id;}

  /** JSDoc */

  /**
   * @inheritDoc
   */
   constructor(options) {TryCatch.prototype.__init.call(this);
    this._options = {
      XMLHttpRequest: true,
      eventTarget: true,
      requestAnimationFrame: true,
      setInterval: true,
      setTimeout: true,
      ...options,
    };
  }

  /**
   * Wrap timer functions and event targets to catch errors
   * and provide better metadata.
   */
   setupOnce() {
    if (this._options.setTimeout) {
      (0,object/* fill */.hl)(helpers/* WINDOW */.m9, 'setTimeout', _wrapTimeFunction);
    }

    if (this._options.setInterval) {
      (0,object/* fill */.hl)(helpers/* WINDOW */.m9, 'setInterval', _wrapTimeFunction);
    }

    if (this._options.requestAnimationFrame) {
      (0,object/* fill */.hl)(helpers/* WINDOW */.m9, 'requestAnimationFrame', _wrapRAF);
    }

    if (this._options.XMLHttpRequest && "XMLHttpRequest" in helpers/* WINDOW */.m9) {
      (0,object/* fill */.hl)(XMLHttpRequest.prototype, 'send', _wrapXHR);
    }

    const eventTargetOption = this._options.eventTarget;
    if (eventTargetOption) {
      const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
      eventTarget.forEach(_wrapEventTarget);
    }
  }
} TryCatch.__initStatic();

/** JSDoc */
function _wrapTimeFunction(original) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( ...args) {
    const originalCallback = args[0];
    args[0] = (0,helpers/* wrap */.re)(originalCallback, {
      mechanism: {
        data: { function: (0,stacktrace/* getFunctionName */.$P)(original) },
        handled: true,
        type: 'instrument',
      },
    });
    return original.apply(this, args);
  };
}

/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _wrapRAF(original) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( callback) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return original.apply(this, [
      (0,helpers/* wrap */.re)(callback, {
        mechanism: {
          data: {
            function: 'requestAnimationFrame',
            handler: (0,stacktrace/* getFunctionName */.$P)(original),
          },
          handled: true,
          type: 'instrument',
        },
      }),
    ]);
  };
}

/** JSDoc */
function _wrapXHR(originalSend) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( ...args) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const xhr = this;
    const xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];

    xmlHttpRequestProps.forEach(prop => {
      if (prop in xhr && typeof xhr[prop] === 'function') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0,object/* fill */.hl)(xhr, prop, function (original) {
          const wrapOptions = {
            mechanism: {
              data: {
                function: prop,
                handler: (0,stacktrace/* getFunctionName */.$P)(original),
              },
              handled: true,
              type: 'instrument',
            },
          };

          // If Instrument integration has been called before TryCatch, get the name of original function
          const originalFunction = (0,object/* getOriginalFunction */.HK)(original);
          if (originalFunction) {
            wrapOptions.mechanism.data.handler = (0,stacktrace/* getFunctionName */.$P)(originalFunction);
          }

          // Otherwise wrap directly
          return (0,helpers/* wrap */.re)(original, wrapOptions);
        });
      }
    });

    return originalSend.apply(this, args);
  };
}

/** JSDoc */
function _wrapEventTarget(target) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const globalObject = helpers/* WINDOW */.m9 ;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const proto = globalObject[target] && globalObject[target].prototype;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
  if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
    return;
  }

  (0,object/* fill */.hl)(proto, 'addEventListener', function (original)

 {
    return function (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any

      eventName,
      fn,
      options,
    ) {
      try {
        if (typeof fn.handleEvent === 'function') {
          // ESlint disable explanation:
          //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
          //  introduce a bug here, because bind returns a new function that doesn't have our
          //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
          //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
          // eslint-disable-next-line @typescript-eslint/unbound-method
          fn.handleEvent = (0,helpers/* wrap */.re)(fn.handleEvent, {
            mechanism: {
              data: {
                function: 'handleEvent',
                handler: (0,stacktrace/* getFunctionName */.$P)(fn),
                target,
              },
              handled: true,
              type: 'instrument',
            },
          });
        }
      } catch (err) {
        // can sometimes get 'Permission denied to access property "handle Event'
      }

      return original.apply(this, [
        eventName,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0,helpers/* wrap */.re)(fn , {
          mechanism: {
            data: {
              function: 'addEventListener',
              handler: (0,stacktrace/* getFunctionName */.$P)(fn),
              target,
            },
            handled: true,
            type: 'instrument',
          },
        }),
        options,
      ]);
    };
  });

  (0,object/* fill */.hl)(
    proto,
    'removeEventListener',
    function (
      originalRemoveEventListener,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) {
      return function (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any

        eventName,
        fn,
        options,
      ) {
        /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */
        const wrappedEventHandler = fn ;
        try {
          const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
          if (originalEventHandler) {
            originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
          }
        } catch (e) {
          // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
        }
        return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
      };
    },
  );
}


//# sourceMappingURL=trycatch.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/linkederrors.js




const DEFAULT_KEY = 'cause';
const DEFAULT_LIMIT = 5;

/** Adds SDK info to an event. */
class LinkedErrors  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'LinkedErrors';}

  /**
   * @inheritDoc
   */
    __init() {this.name = LinkedErrors.id;}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   constructor(options = {}) {LinkedErrors.prototype.__init.call(this);
    this._key = options.key || DEFAULT_KEY;
    this._limit = options.limit || DEFAULT_LIMIT;
  }

  /**
   * @inheritDoc
   */
   setupOnce() {
    const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
    if (!client) {
      return;
    }
    (0,esm_scope/* addGlobalEventProcessor */.c)((event, hint) => {
      const self = (0,esm_hub/* getCurrentHub */.Gd)().getIntegration(LinkedErrors);
      return self ? _handler(client.getOptions().stackParser, self._key, self._limit, event, hint) : event;
    });
  }
} LinkedErrors.__initStatic();

/**
 * @inheritDoc
 */
function _handler(
  parser,
  key,
  limit,
  event,
  hint,
) {
  if (!event.exception || !event.exception.values || !hint || !(0,is/* isInstanceOf */.V9)(hint.originalException, Error)) {
    return event;
  }
  const linkedErrors = _walkErrorTree(parser, limit, hint.originalException , key);
  event.exception.values = [...linkedErrors, ...event.exception.values];
  return event;
}

/**
 * JSDOC
 */
function _walkErrorTree(
  parser,
  limit,
  error,
  key,
  stack = [],
) {
  if (!(0,is/* isInstanceOf */.V9)(error[key], Error) || stack.length + 1 >= limit) {
    return stack;
  }
  const exception = exceptionFromError(parser, error[key]);
  return _walkErrorTree(parser, limit, error[key], key, [exception, ...stack]);
}


//# sourceMappingURL=linkederrors.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/httpcontext.js



/** HttpContext integration collects information about HTTP request headers */
class HttpContext  {constructor() { HttpContext.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'HttpContext';}

  /**
   * @inheritDoc
   */
   __init() {this.name = HttpContext.id;}

  /**
   * @inheritDoc
   */
   setupOnce() {
    (0,esm_scope/* addGlobalEventProcessor */.c)((event) => {
      if ((0,esm_hub/* getCurrentHub */.Gd)().getIntegration(HttpContext)) {
        // if none of the information we want exists, don't bother
        if (!helpers/* WINDOW.navigator */.m9.navigator && !helpers/* WINDOW.location */.m9.location && !helpers/* WINDOW.document */.m9.document) {
          return event;
        }

        // grab as much info as exists and add it to the event
        const url = (event.request && event.request.url) || (helpers/* WINDOW.location */.m9.location && helpers/* WINDOW.location.href */.m9.location.href);
        const { referrer } = helpers/* WINDOW.document */.m9.document || {};
        const { userAgent } = helpers/* WINDOW.navigator */.m9.navigator || {};

        const headers = {
          ...(event.request && event.request.headers),
          ...(referrer && { Referer: referrer }),
          ...(userAgent && { 'User-Agent': userAgent }),
        };
        const request = { ...event.request, ...(url && { url }), headers };

        return { ...event, request };
      }
      return event;
    });
  }
} HttpContext.__initStatic();


//# sourceMappingURL=httpcontext.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/dedupe.js


/** Deduplication filter */
class Dedupe  {constructor() { Dedupe.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Dedupe';}

  /**
   * @inheritDoc
   */
   __init() {this.name = Dedupe.id;}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    const eventProcessor = currentEvent => {
      // We want to ignore any non-error type events, e.g. transactions or replays
      // These should never be deduped, and also not be compared against as _previousEvent.
      if (currentEvent.type) {
        return currentEvent;
      }

      const self = getCurrentHub().getIntegration(Dedupe);
      if (self) {
        // Juuust in case something goes wrong
        try {
          if (dedupe_shouldDropEvent(currentEvent, self._previousEvent)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Event dropped due to being a duplicate of previously captured event.');
            return null;
          }
        } catch (_oO) {
          return (self._previousEvent = currentEvent);
        }

        return (self._previousEvent = currentEvent);
      }
      return currentEvent;
    };

    eventProcessor.id = this.name;
    addGlobalEventProcessor(eventProcessor);
  }
} Dedupe.__initStatic();

/** JSDoc */
function dedupe_shouldDropEvent(currentEvent, previousEvent) {
  if (!previousEvent) {
    return false;
  }

  if (_isSameMessageEvent(currentEvent, previousEvent)) {
    return true;
  }

  if (_isSameExceptionEvent(currentEvent, previousEvent)) {
    return true;
  }

  return false;
}

/** JSDoc */
function _isSameMessageEvent(currentEvent, previousEvent) {
  const currentMessage = currentEvent.message;
  const previousMessage = previousEvent.message;

  // If neither event has a message property, they were both exceptions, so bail out
  if (!currentMessage && !previousMessage) {
    return false;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
    return false;
  }

  if (currentMessage !== previousMessage) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

/** JSDoc */
function _isSameExceptionEvent(currentEvent, previousEvent) {
  const previousException = _getExceptionFromEvent(previousEvent);
  const currentException = _getExceptionFromEvent(currentEvent);

  if (!previousException || !currentException) {
    return false;
  }

  if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

/** JSDoc */
function _isSameStacktrace(currentEvent, previousEvent) {
  let currentFrames = _getFramesFromEvent(currentEvent);
  let previousFrames = _getFramesFromEvent(previousEvent);

  // If neither event has a stacktrace, they are assumed to be the same
  if (!currentFrames && !previousFrames) {
    return true;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
    return false;
  }

  currentFrames = currentFrames ;
  previousFrames = previousFrames ;

  // If number of frames differ, they are not the same
  if (previousFrames.length !== currentFrames.length) {
    return false;
  }

  // Otherwise, compare the two
  for (let i = 0; i < previousFrames.length; i++) {
    const frameA = previousFrames[i];
    const frameB = currentFrames[i];

    if (
      frameA.filename !== frameB.filename ||
      frameA.lineno !== frameB.lineno ||
      frameA.colno !== frameB.colno ||
      frameA.function !== frameB.function
    ) {
      return false;
    }
  }

  return true;
}

/** JSDoc */
function _isSameFingerprint(currentEvent, previousEvent) {
  let currentFingerprint = currentEvent.fingerprint;
  let previousFingerprint = previousEvent.fingerprint;

  // If neither event has a fingerprint, they are assumed to be the same
  if (!currentFingerprint && !previousFingerprint) {
    return true;
  }

  // If only one event has a fingerprint, but not the other one, they are not the same
  if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
    return false;
  }

  currentFingerprint = currentFingerprint ;
  previousFingerprint = previousFingerprint ;

  // Otherwise, compare the two
  try {
    return !!(currentFingerprint.join('') === previousFingerprint.join(''));
  } catch (_oO) {
    return false;
  }
}

/** JSDoc */
function _getExceptionFromEvent(event) {
  return event.exception && event.exception.values && event.exception.values[0];
}

/** JSDoc */
function _getFramesFromEvent(event) {
  const exception = event.exception;

  if (exception) {
    try {
      // @ts-ignore Object could be undefined
      return exception.values[0].stacktrace.frames;
    } catch (_oO) {
      return undefined;
    }
  }
  return undefined;
}


//# sourceMappingURL=dedupe.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/stack-parsers.js


// global reference to slice
const UNKNOWN_FUNCTION = '?';

const OPERA10_PRIORITY = 10;
const OPERA11_PRIORITY = 20;
const CHROME_PRIORITY = 30;
const WINJS_PRIORITY = 40;
const GECKO_PRIORITY = 50;

function createFrame(filename, func, lineno, colno) {
  const frame = {
    filename,
    function: func,
    in_app: true, // All browser frames are considered in_app
  };

  if (lineno !== undefined) {
    frame.lineno = lineno;
  }

  if (colno !== undefined) {
    frame.colno = colno;
  }

  return frame;
}

// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const chromeRegex =
  /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;

const chrome = line => {
  const parts = chromeRegex.exec(line);

  if (parts) {
    const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line

    if (isEval) {
      const subMatch = chromeEvalRegex.exec(parts[2]);

      if (subMatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = subMatch[1]; // url
        parts[3] = subMatch[2]; // line
        parts[4] = subMatch[3]; // column
      }
    }

    // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
    // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
    const [func, filename] = extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]);

    return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
  }

  return;
};

const chromeStackLineParser = [CHROME_PRIORITY, chrome];

// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const geckoREgex =
  /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;

const gecko = line => {
  const parts = geckoREgex.exec(line);

  if (parts) {
    const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    if (isEval) {
      const subMatch = geckoEvalRegex.exec(parts[3]);

      if (subMatch) {
        // throw out eval line/column and use top-most line number
        parts[1] = parts[1] || 'eval';
        parts[3] = subMatch[1];
        parts[4] = subMatch[2];
        parts[5] = ''; // no column when eval
      }
    }

    let filename = parts[3];
    let func = parts[1] || UNKNOWN_FUNCTION;
    [func, filename] = extractSafariExtensionDetails(func, filename);

    return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
  }

  return;
};

const geckoStackLineParser = [GECKO_PRIORITY, gecko];

const winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;

const winjs = line => {
  const parts = winjsRegex.exec(line);

  return parts
    ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined)
    : undefined;
};

const winjsStackLineParser = [WINJS_PRIORITY, winjs];

const opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;

const opera10 = line => {
  const parts = opera10Regex.exec(line);
  return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};

const opera10StackLineParser = [OPERA10_PRIORITY, opera10];

const opera11Regex =
  / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;

const opera11 = line => {
  const parts = opera11Regex.exec(line);
  return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};

const opera11StackLineParser = [OPERA11_PRIORITY, opera11];

const defaultStackLineParsers = [chromeStackLineParser, geckoStackLineParser, winjsStackLineParser];

const defaultStackParser = (0,stacktrace/* createStackParser */.pE)(...defaultStackLineParsers);

/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */
const extractSafariExtensionDetails = (func, filename) => {
  const isSafariExtension = func.indexOf('safari-extension') !== -1;
  const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;

  return isSafariExtension || isSafariWebExtension
    ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`,
      ]
    : [func, filename];
};


//# sourceMappingURL=stack-parsers.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/promisebuffer.js



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */
function makePromiseBuffer(limit) {
  const buffer = [];

  function isReady() {
    return limit === undefined || buffer.length < limit;
  }

  /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */
  function remove(task) {
    return buffer.splice(buffer.indexOf(task), 1)[0];
  }

  /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */
  function add(taskProducer) {
    if (!isReady()) {
      return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError('Not adding Promise because buffer limit was reached.'));
    }

    // start the task and add its promise to the queue
    const task = taskProducer();
    if (buffer.indexOf(task) === -1) {
      buffer.push(task);
    }
    void task
      .then(() => remove(task))
      // Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
      // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
      // have promises, so TS has to polyfill when down-compiling.)
      .then(null, () =>
        remove(task).then(null, () => {
          // We have to add another catch here because `remove()` starts a new promise chain.
        }),
      );
    return task;
  }

  /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */
  function drain(timeout) {
    return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
      let counter = buffer.length;

      if (!counter) {
        return resolve(true);
      }

      // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
      const capturedSetTimeout = setTimeout(() => {
        if (timeout && timeout > 0) {
          resolve(false);
        }
      }, timeout);

      // if all promises resolve in time, cancel the timer and resolve to `true`
      buffer.forEach(item => {
        void (0,syncpromise/* resolvedSyncPromise */.WD)(item).then(() => {
          if (!--counter) {
            clearTimeout(capturedSetTimeout);
            resolve(true);
          }
        }, reject);
      });
    });
  }

  return {
    $: buffer,
    add,
    drain,
  };
}


//# sourceMappingURL=promisebuffer.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/ratelimit.js
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend

const DEFAULT_RETRY_AFTER = 60 * 1000; // 60 seconds

/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */
function parseRetryAfterHeader(header, now = Date.now()) {
  const headerDelay = parseInt(`${header}`, 10);
  if (!isNaN(headerDelay)) {
    return headerDelay * 1000;
  }

  const headerDate = Date.parse(`${header}`);
  if (!isNaN(headerDate)) {
    return headerDate - now;
  }

  return DEFAULT_RETRY_AFTER;
}

/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */
function disabledUntil(limits, category) {
  return limits[category] || limits.all || 0;
}

/**
 * Checks if a category is rate limited
 */
function isRateLimited(limits, category, now = Date.now()) {
  return disabledUntil(limits, category) > now;
}

/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */
function updateRateLimits(
  limits,
  { statusCode, headers },
  now = Date.now(),
) {
  const updatedRateLimits = {
    ...limits,
  };

  // "The name is case-insensitive."
  // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
  const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
  const retryAfterHeader = headers && headers['retry-after'];

  if (rateLimitHeader) {
    /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     */
    for (const limit of rateLimitHeader.trim().split(',')) {
      const [retryAfter, categories] = limit.split(':', 2);
      const headerDelay = parseInt(retryAfter, 10);
      const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
      if (!categories) {
        updatedRateLimits.all = now + delay;
      } else {
        for (const category of categories.split(';')) {
          updatedRateLimits[category] = now + delay;
        }
      }
    }
  } else if (retryAfterHeader) {
    updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
  } else if (statusCode === 429) {
    updatedRateLimits.all = now + 60 * 1000;
  }

  return updatedRateLimits;
}


//# sourceMappingURL=ratelimit.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/transports/base.js


const DEFAULT_TRANSPORT_BUFFER_SIZE = 30;

/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */
function createTransport(
  options,
  makeRequest,
  buffer = makePromiseBuffer(
    options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE,
  ),
) {
  let rateLimits = {};
  const flush = (timeout) => buffer.drain(timeout);

  function send(envelope) {
    const filteredEnvelopeItems = [];

    // Drop rate limited items from envelope
    forEachEnvelopeItem(envelope, (item, type) => {
      const envelopeItemDataCategory = envelopeItemTypeToDataCategory(type);
      if (isRateLimited(rateLimits, envelopeItemDataCategory)) {
        const event = getEventForEnvelopeItem(item, type);
        options.recordDroppedEvent('ratelimit_backoff', envelopeItemDataCategory, event);
      } else {
        filteredEnvelopeItems.push(item);
      }
    });

    // Skip sending if envelope is empty after filtering out rate limited events
    if (filteredEnvelopeItems.length === 0) {
      return (0,syncpromise/* resolvedSyncPromise */.WD)();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const filteredEnvelope = createEnvelope(envelope[0], filteredEnvelopeItems );

    // Creates client report for each item in an envelope
    const recordEnvelopeLoss = (reason) => {
      forEachEnvelopeItem(filteredEnvelope, (item, type) => {
        const event = getEventForEnvelopeItem(item, type);
        options.recordDroppedEvent(reason, envelopeItemTypeToDataCategory(type), event);
      });
    };

    const requestTask = () =>
      makeRequest({ body: serializeEnvelope(filteredEnvelope, options.textEncoder) }).then(
        response => {
          // We don't want to throw on NOK responses, but we want to at least log them
          if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
          }

          rateLimits = updateRateLimits(rateLimits, response);
          return response;
        },
        error => {
          recordEnvelopeLoss('network_error');
          throw error;
        },
      );

    return buffer.add(requestTask).then(
      result => result,
      error => {
        if (error instanceof SentryError) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Skipped sending event because buffer is full.');
          recordEnvelopeLoss('queue_overflow');
          return (0,syncpromise/* resolvedSyncPromise */.WD)();
        } else {
          throw error;
        }
      },
    );
  }

  // We use this to identifify if the transport is the base transport
  // TODO (v8): Remove this again as we'll no longer need it
  send.__sentry__baseTransport__ = true;

  return {
    send,
    flush,
  };
}

function getEventForEnvelopeItem(item, type) {
  if (type !== 'event' && type !== 'transaction') {
    return undefined;
  }

  return Array.isArray(item) ? (item )[1] : undefined;
}


//# sourceMappingURL=base.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/utils.js



let cachedFetchImpl = undefined;

/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */
function getNativeFetchImplementation() {
  if (cachedFetchImpl) {
    return cachedFetchImpl;
  }

  /* eslint-disable @typescript-eslint/unbound-method */

  // Fast path to avoid DOM I/O
  if ((0,supports/* isNativeFetch */.Du)(helpers/* WINDOW.fetch */.m9.fetch)) {
    return (cachedFetchImpl = helpers/* WINDOW.fetch.bind */.m9.fetch.bind(helpers/* WINDOW */.m9));
  }

  const document = helpers/* WINDOW.document */.m9.document;
  let fetchImpl = helpers/* WINDOW.fetch */.m9.fetch;
  // eslint-disable-next-line deprecation/deprecation
  if (document && typeof document.createElement === 'function') {
    try {
      const sandbox = document.createElement('iframe');
      sandbox.hidden = true;
      document.head.appendChild(sandbox);
      const contentWindow = sandbox.contentWindow;
      if (contentWindow && contentWindow.fetch) {
        fetchImpl = contentWindow.fetch;
      }
      document.head.removeChild(sandbox);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
  }

  return (cachedFetchImpl = fetchImpl.bind(helpers/* WINDOW */.m9));
  /* eslint-enable @typescript-eslint/unbound-method */
}

/** Clears cached fetch impl */
function clearCachedFetchImplementation() {
  cachedFetchImpl = undefined;
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/fetch.js




/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */
function makeFetchTransport(
  options,
  nativeFetch = getNativeFetchImplementation(),
) {
  let pendingBodySize = 0;
  let pendingCount = 0;

  function makeRequest(request) {
    const requestSize = request.body.length;
    pendingBodySize += requestSize;
    pendingCount++;

    const requestOptions = {
      body: request.body,
      method: 'POST',
      referrerPolicy: 'origin',
      headers: options.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
      //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
      //   We will therefore only activate the flag when we're below that limit.
      // There is also a limit of requests that can be open at the same time, so we also limit this to 15
      // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
      keepalive: pendingBodySize <= 60000 && pendingCount < 15,
      ...options.fetchOptions,
    };

    try {
      return nativeFetch(options.url, requestOptions).then(response => {
        pendingBodySize -= requestSize;
        pendingCount--;
        return {
          statusCode: response.status,
          headers: {
            'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
            'retry-after': response.headers.get('Retry-After'),
          },
        };
      });
    } catch (e) {
      clearCachedFetchImplementation();
      pendingBodySize -= requestSize;
      pendingCount--;
      return (0,syncpromise/* rejectedSyncPromise */.$2)(e);
    }
  }

  return createTransport(options, makeRequest);
}


//# sourceMappingURL=fetch.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/xhr.js



/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */
const XHR_READYSTATE_DONE = 4;

/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */
function makeXHRTransport(options) {
  function makeRequest(request) {
    return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.onerror = reject;

      xhr.onreadystatechange = () => {
        if (xhr.readyState === XHR_READYSTATE_DONE) {
          resolve({
            statusCode: xhr.status,
            headers: {
              'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
              'retry-after': xhr.getResponseHeader('Retry-After'),
            },
          });
        }
      };

      xhr.open('POST', options.url);

      for (const header in options.headers) {
        if (Object.prototype.hasOwnProperty.call(options.headers, header)) {
          xhr.setRequestHeader(header, options.headers[header]);
        }
      }

      xhr.send(request.body);
    });
  }

  return createTransport(options, makeRequest);
}


//# sourceMappingURL=xhr.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/sdk.js














const defaultIntegrations = [
  new InboundFilters(),
  new FunctionToString(),
  new TryCatch(),
  new Breadcrumbs(),
  new GlobalHandlers(),
  new LinkedErrors(),
  new Dedupe(),
  new HttpContext(),
];

/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options = {}) {
  if (options.defaultIntegrations === undefined) {
    options.defaultIntegrations = defaultIntegrations;
  }
  if (options.release === undefined) {
    // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
    if (typeof __SENTRY_RELEASE__ === 'string') {
      options.release = __SENTRY_RELEASE__;
    }

    // This supports the variable that sentry-webpack-plugin injects
    if (helpers/* WINDOW.SENTRY_RELEASE */.m9.SENTRY_RELEASE && helpers/* WINDOW.SENTRY_RELEASE.id */.m9.SENTRY_RELEASE.id) {
      options.release = helpers/* WINDOW.SENTRY_RELEASE.id */.m9.SENTRY_RELEASE.id;
    }
  }
  if (options.autoSessionTracking === undefined) {
    options.autoSessionTracking = true;
  }
  if (options.sendClientReports === undefined) {
    options.sendClientReports = true;
  }

  const clientOptions = {
    ...options,
    stackParser: (0,stacktrace/* stackParserFromStackParserOptions */.Sq)(options.stackParser || defaultStackParser),
    integrations: getIntegrationsToSetup(options),
    transport: options.transport || ((0,supports/* supportsFetch */.Ak)() ? makeFetchTransport : makeXHRTransport),
  };

  initAndBind(BrowserClient, clientOptions);

  if (options.autoSessionTracking) {
    startSessionTracking();
  }
}

/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options = {}, hub = getCurrentHub()) {
  // doesn't work without a document (React Native)
  if (!WINDOW.document) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Global document not defined in showReportDialog call');
    return;
  }

  const { client, scope } = hub.getStackTop();
  const dsn = options.dsn || (client && client.getDsn());
  if (!dsn) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('DSN not configured for showReportDialog call');
    return;
  }

  if (scope) {
    options.user = {
      ...scope.getUser(),
      ...options.user,
    };
  }

  if (!options.eventId) {
    options.eventId = hub.lastEventId();
  }

  const script = WINDOW.document.createElement('script');
  script.async = true;
  script.src = getReportDialogEndpoint(dsn, options);

  if (options.onLoad) {
    script.onload = options.onLoad;
  }

  const injectionPoint = WINDOW.document.head || WINDOW.document.body;
  if (injectionPoint) {
    injectionPoint.appendChild(script);
  } else {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Not injecting report dialog. No injection point found in HTML');
  }
}

/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
  return getCurrentHub().lastEventId();
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
  // Noop
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
  callback();
}

/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function flush(timeout) {
  const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
  if (client) {
    return client.flush(timeout);
  }
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Cannot flush events. No client defined.');
  return (0,syncpromise/* resolvedSyncPromise */.WD)(false);
}

/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function sdk_close(timeout) {
  const client = getCurrentHub().getClient();
  if (client) {
    return client.close(timeout);
  }
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot flush events and disable SDK. No client defined.');
  return resolvedSyncPromise(false);
}

/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function wrap(fn) {
  return wrap$1(fn)();
}

function startSessionOnHub(hub) {
  hub.startSession({ ignoreDuration: true });
  hub.captureSession();
}

/**
 * Enable automatic Session Tracking for the initial page load.
 */
function startSessionTracking() {
  if (typeof helpers/* WINDOW.document */.m9.document === 'undefined') {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
    return;
  }

  const hub = (0,esm_hub/* getCurrentHub */.Gd)();

  // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
  // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
  // pinned at the same version in package.json, but there are edge cases where it's possible. See
  // https://github.com/getsentry/sentry-javascript/issues/3207 and
  // https://github.com/getsentry/sentry-javascript/issues/3234 and
  // https://github.com/getsentry/sentry-javascript/issues/3278.
  if (!hub.captureSession) {
    return;
  }

  // The session duration for browser sessions does not track a meaningful
  // concept that can be used as a metric.
  // Automatically captured sessions are akin to page views, and thus we
  // discard their duration.
  startSessionOnHub(hub);

  // We want to create a session for every navigation as well
  (0,instrument/* addInstrumentationHandler */.oq)('history', ({ from, to }) => {
    // Don't create an additional session for the initial route or if the location did not change
    if (!(from === undefined || from === to)) {
      startSessionOnHub((0,esm_hub/* getCurrentHub */.Gd)());
    }
  });
}

/**
 * Captures user feedback and sends it to Sentry.
 */
function captureUserFeedback(feedback) {
  const client = getCurrentHub().getClient();
  if (client) {
    client.captureUserFeedback(feedback);
  }
}


//# sourceMappingURL=sdk.js.map


/***/ }),

/***/ 51131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ DEFAULT_ENVIRONMENT; }
/* harmony export */ });
const DEFAULT_ENVIRONMENT = 'production';


//# sourceMappingURL=constants.js.map


/***/ }),

/***/ 64487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ withScope; },
/* harmony export */   "Tb": function() { return /* binding */ captureException; },
/* harmony export */   "av": function() { return /* binding */ setUser; },
/* harmony export */   "e": function() { return /* binding */ configureScope; }
/* harmony export */ });
/* unused harmony exports addBreadcrumb, captureCheckIn, captureEvent, captureMessage, setContext, setExtra, setExtras, setTag, setTags, startTransaction */
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95659);



// Note: All functions in this file are typed with a return value of `ReturnType<Hub[HUB_FUNCTION]>`,
// where HUB_FUNCTION is some method on the Hub class.
//
// This is done to make sure the top level SDK methods stay in sync with the hub methods.
// Although every method here has an explicit return type, some of them (that map to void returns) do not
// contain `return` keywords. This is done to save on bundle size, as `return` is not minifiable.

/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @param captureContext Additional scope data to apply to exception event.
 * @returns The generated eventId.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function captureException(exception, captureContext) {
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureException(exception, { captureContext });
}

/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(
  message,
  // eslint-disable-next-line deprecation/deprecation
  captureContext,
) {
  // This is necessary to provide explicit scopes upgrade, without changing the original
  // arity of the `captureMessage(message, level)` method.
  const level = typeof captureContext === 'string' ? captureContext : undefined;
  const context = typeof captureContext !== 'string' ? { captureContext } : undefined;
  return getCurrentHub().captureMessage(message, level, context);
}

/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event, hint) {
  return getCurrentHub().captureEvent(event, hint);
}

/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().configureScope(callback);
}

/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
  getCurrentHub().addBreadcrumb(breadcrumb);
}

/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setContext(name, context) {
  getCurrentHub().setContext(name, context);
}

/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
  getCurrentHub().setExtras(extras);
}

/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
function setExtra(key, extra) {
  getCurrentHub().setExtra(key, extra);
}

/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
  getCurrentHub().setTags(tags);
}

/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */
function setTag(key, value) {
  getCurrentHub().setTag(key, value);
}

/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setUser(user);
}

/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().withScope(callback);
}

/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */
function startTransaction(
  context,
  customSamplingContext,
) {
  return getCurrentHub().startTransaction({ ...context }, customSamplingContext);
}

/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */
function captureCheckIn(checkIn, upsertMonitorConfig) {
  const client = getCurrentHub().getClient();
  if (!client) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot capture check-in. No client defined.');
  } else if (!client.captureCheckIn) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot capture check-in. Client does not support sending check-ins.');
  } else {
    return client.captureCheckIn(checkIn, upsertMonitorConfig);
  }

  return uuid4();
}


//# sourceMappingURL=exports.js.map


/***/ }),

/***/ 95659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gd": function() { return /* binding */ getCurrentHub; },
/* harmony export */   "cu": function() { return /* binding */ getMainCarrier; }
/* harmony export */ });
/* unused harmony exports API_VERSION, Hub, ensureHubOnCarrier, getHubFromCarrier, makeMain, runWithAsyncContext, setAsyncContextStrategy, setHubOnCarrier */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71235);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51131);
/* harmony import */ var _scope_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10350);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9015);





/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
const API_VERSION = 4;

/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
const DEFAULT_BREADCRUMBS = 100;

/**
 * @inheritDoc
 */
class Hub  {
  /** Is a {@link Layer}[] containing the client and scope */

  /** Contains the last event id of a captured event.  */

  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */
   constructor(client, scope = new _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope */ .s(),   _version = API_VERSION) {this._version = _version;
    this._stack = [{ scope }];
    if (client) {
      this.bindClient(client);
    }
  }

  /**
   * @inheritDoc
   */
   isOlderThan(version) {
    return this._version < version;
  }

  /**
   * @inheritDoc
   */
   bindClient(client) {
    const top = this.getStackTop();
    top.client = client;
    if (client && client.setupIntegrations) {
      client.setupIntegrations();
    }
  }

  /**
   * @inheritDoc
   */
   pushScope() {
    // We want to clone the content of prev scope
    const scope = _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope.clone */ .s.clone(this.getScope());
    this.getStack().push({
      client: this.getClient(),
      scope,
    });
    return scope;
  }

  /**
   * @inheritDoc
   */
   popScope() {
    if (this.getStack().length <= 1) return false;
    return !!this.getStack().pop();
  }

  /**
   * @inheritDoc
   */
   withScope(callback) {
    const scope = this.pushScope();
    try {
      callback(scope);
    } finally {
      this.popScope();
    }
  }

  /**
   * @inheritDoc
   */
   getClient() {
    return this.getStackTop().client ;
  }

  /** Returns the scope of the top stack. */
   getScope() {
    return this.getStackTop().scope;
  }

  /** Returns the scope stack for domains or the process. */
   getStack() {
    return this._stack;
  }

  /** Returns the topmost scope layer in the order domain > local > process. */
   getStackTop() {
    return this._stack[this._stack.length - 1];
  }

  /**
   * @inheritDoc
   */
   captureException(exception, hint) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)());
    const syntheticException = new Error('Sentry syntheticException');
    this._withClient((client, scope) => {
      client.captureException(
        exception,
        {
          originalException: exception,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
  ) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)());
    const syntheticException = new Error(message);
    this._withClient((client, scope) => {
      client.captureMessage(
        message,
        level,
        {
          originalException: message,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
    if (!event.type) {
      this._lastEventId = eventId;
    }

    this._withClient((client, scope) => {
      client.captureEvent(event, { ...hint, event_id: eventId }, scope);
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   lastEventId() {
    return this._lastEventId;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, hint) {
    const { scope, client } = this.getStackTop();

    if (!client) return;

    const { beforeBreadcrumb = null, maxBreadcrumbs = DEFAULT_BREADCRUMBS } =
      (client.getOptions && client.getOptions()) || {};

    if (maxBreadcrumbs <= 0) return;

    const timestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)();
    const mergedBreadcrumb = { timestamp, ...breadcrumb };
    const finalBreadcrumb = beforeBreadcrumb
      ? ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .consoleSandbox */ .Cf)(() => beforeBreadcrumb(mergedBreadcrumb, hint)) )
      : mergedBreadcrumb;

    if (finalBreadcrumb === null) return;

    if (client.emit) {
      client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    }

    scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    this.getScope().setUser(user);
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    this.getScope().setTags(tags);
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    this.getScope().setExtras(extras);
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this.getScope().setTag(key, value);
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    this.getScope().setExtra(key, extra);
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   setContext(name, context) {
    this.getScope().setContext(name, context);
  }

  /**
   * @inheritDoc
   */
   configureScope(callback) {
    const { scope, client } = this.getStackTop();
    if (client) {
      callback(scope);
    }
  }

  /**
   * @inheritDoc
   */
   run(callback) {
    const oldHub = makeMain(this);
    try {
      callback(this);
    } finally {
      makeMain(oldHub);
    }
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    const client = this.getClient();
    if (!client) return null;
    try {
      return client.getIntegration(integration);
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   startTransaction(context, customSamplingContext) {
    const result = this._callExtensionMethod('startTransaction', context, customSamplingContext);

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && !result) {
      // eslint-disable-next-line no-console
      console.warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
    }

    return result;
  }

  /**
   * @inheritDoc
   */
   traceHeaders() {
    return this._callExtensionMethod('traceHeaders');
  }

  /**
   * @inheritDoc
   */
   captureSession(endSession = false) {
    // both send the update and pull the session from the scope
    if (endSession) {
      return this.endSession();
    }

    // only send the update
    this._sendSessionUpdate();
  }

  /**
   * @inheritDoc
   */
   endSession() {
    const layer = this.getStackTop();
    const scope = layer.scope;
    const session = scope.getSession();
    if (session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .closeSession */ .RJ)(session);
    }
    this._sendSessionUpdate();

    // the session is over; take it off of the scope
    scope.setSession();
  }

  /**
   * @inheritDoc
   */
   startSession(context) {
    const { scope, client } = this.getStackTop();
    const { release, environment = _constants_js__WEBPACK_IMPORTED_MODULE_5__/* .DEFAULT_ENVIRONMENT */ .J } = (client && client.getOptions()) || {};

    // Will fetch userAgent if called from browser sdk
    const { userAgent } = _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .GLOBAL_OBJ.navigator */ .n2.navigator || {};

    const session = (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .makeSession */ .Hv)({
      release,
      environment,
      user: scope.getUser(),
      ...(userAgent && { userAgent }),
      ...context,
    });

    // End existing session if there's one
    const currentSession = scope.getSession && scope.getSession();
    if (currentSession && currentSession.status === 'ok') {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .updateSession */ .CT)(currentSession, { status: 'exited' });
    }
    this.endSession();

    // Afterwards we set the new session on the scope
    scope.setSession(session);

    return session;
  }

  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */
   shouldSendDefaultPii() {
    const client = this.getClient();
    const options = client && client.getOptions();
    return Boolean(options && options.sendDefaultPii);
  }

  /**
   * Sends the current Session on the scope
   */
   _sendSessionUpdate() {
    const { scope, client } = this.getStackTop();

    const session = scope.getSession();
    if (session && client && client.captureSession) {
      client.captureSession(session);
    }
  }

  /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */
   _withClient(callback) {
    const { scope, client } = this.getStackTop();
    if (client) {
      callback(client, scope);
    }
  }

  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   _callExtensionMethod(method, ...args) {
    const carrier = getMainCarrier();
    const sentry = carrier.__SENTRY__;
    if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
      return sentry.extensions[method].apply(this, args);
    }
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn(`Extension method ${method} couldn't be found, doing nothing.`);
  }
}

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
  _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .GLOBAL_OBJ.__SENTRY__ */ .n2.__SENTRY__ = _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .GLOBAL_OBJ.__SENTRY__ */ .n2.__SENTRY__ || {
    extensions: {},
    hub: undefined,
  };
  return _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .GLOBAL_OBJ */ .n2;
}

/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
  const registry = getMainCarrier();
  const oldHub = getHubFromCarrier(registry);
  setHubOnCarrier(registry, hub);
  return oldHub;
}

/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
  // Get main carrier (global for every environment)
  const registry = getMainCarrier();

  if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
    const hub = registry.__SENTRY__.acs.getCurrentHub();

    if (hub) {
      return hub;
    }
  }

  // Return hub that lives on a global object
  return getGlobalHub(registry);
}

function getGlobalHub(registry = getMainCarrier()) {
  // If there's no hub, or its an old API, assign a new one
  if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
    setHubOnCarrier(registry, new Hub());
  }

  // Return hub that lives on a global object
  return getHubFromCarrier(registry);
}

/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */
function ensureHubOnCarrier(carrier, parent = getGlobalHub()) {
  // If there's no hub on current domain, or it's an old API, assign a new one
  if (!hasHubOnCarrier(carrier) || getHubFromCarrier(carrier).isOlderThan(API_VERSION)) {
    const globalHubTopStack = parent.getStackTop();
    setHubOnCarrier(carrier, new Hub(globalHubTopStack.client, Scope.clone(globalHubTopStack.scope)));
  }
}

/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */
function setAsyncContextStrategy(strategy) {
  // Get main carrier (global for every environment)
  const registry = getMainCarrier();
  registry.__SENTRY__ = registry.__SENTRY__ || {};
  registry.__SENTRY__.acs = strategy;
}

/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */
function runWithAsyncContext(callback, options = {}) {
  const registry = getMainCarrier();

  if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
    return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
  }

  // if there was no strategy, fallback to just calling the callback
  return callback();
}

/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
  return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}

/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .getGlobalSingleton */ .YO)('hub', () => new Hub(), carrier);
}

/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
function setHubOnCarrier(carrier, hub) {
  if (!carrier) return false;
  const __SENTRY__ = (carrier.__SENTRY__ = carrier.__SENTRY__ || {});
  __SENTRY__.hub = hub;
  return true;
}


//# sourceMappingURL=hub.js.map


/***/ }),

/***/ 10350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ addGlobalEventProcessor; },
/* harmony export */   "s": function() { return /* binding */ Scope; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96893);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71235);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9015);



/**
 * Default value for maximum number of breadcrumbs added to an event.
 */
const DEFAULT_MAX_BREADCRUMBS = 100;

/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
class Scope  {
  /** Flag if notifying is happening. */

  /** Callback for client to receive scope changes. */

  /** Callback list that will be called after {@link applyToEvent}. */

  /** Array of breadcrumbs. */

  /** User */

  /** Tags */

  /** Extra */

  /** Contexts */

  /** Attachments */

  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */

  /** Fingerprint */

  /** Severity */
  // eslint-disable-next-line deprecation/deprecation

  /** Transaction Name */

  /** Span */

  /** Session */

  /** Request Mode Session Status */

  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.

   constructor() {
    this._notifyingListeners = false;
    this._scopeListeners = [];
    this._eventProcessors = [];
    this._breadcrumbs = [];
    this._attachments = [];
    this._user = {};
    this._tags = {};
    this._extra = {};
    this._contexts = {};
    this._sdkProcessingMetadata = {};
  }

  /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */
   static clone(scope) {
    const newScope = new Scope();
    if (scope) {
      newScope._breadcrumbs = [...scope._breadcrumbs];
      newScope._tags = { ...scope._tags };
      newScope._extra = { ...scope._extra };
      newScope._contexts = { ...scope._contexts };
      newScope._user = scope._user;
      newScope._level = scope._level;
      newScope._span = scope._span;
      newScope._session = scope._session;
      newScope._transactionName = scope._transactionName;
      newScope._fingerprint = scope._fingerprint;
      newScope._eventProcessors = [...scope._eventProcessors];
      newScope._requestSession = scope._requestSession;
      newScope._attachments = [...scope._attachments];
      newScope._sdkProcessingMetadata = { ...scope._sdkProcessingMetadata };
    }
    return newScope;
  }

  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
   addScopeListener(callback) {
    this._scopeListeners.push(callback);
  }

  /**
   * @inheritDoc
   */
   addEventProcessor(callback) {
    this._eventProcessors.push(callback);
    return this;
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    this._user = user || {};
    if (this._session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_0__/* .updateSession */ .CT)(this._session, { user });
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getUser() {
    return this._user;
  }

  /**
   * @inheritDoc
   */
   getRequestSession() {
    return this._requestSession;
  }

  /**
   * @inheritDoc
   */
   setRequestSession(requestSession) {
    this._requestSession = requestSession;
    return this;
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    this._tags = {
      ...this._tags,
      ...tags,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this._tags = { ...this._tags, [key]: value };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    this._extra = {
      ...this._extra,
      ...extras,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    this._extra = { ...this._extra, [key]: extra };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setFingerprint(fingerprint) {
    this._fingerprint = fingerprint;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setLevel(
    // eslint-disable-next-line deprecation/deprecation
    level,
  ) {
    this._level = level;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTransactionName(name) {
    this._transactionName = name;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }

    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setSpan(span) {
    this._span = span;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSpan() {
    return this._span;
  }

  /**
   * @inheritDoc
   */
   getTransaction() {
    // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
    // have a pointer to the currently-active transaction.
    const span = this.getSpan();
    return span && span.transaction;
  }

  /**
   * @inheritDoc
   */
   setSession(session) {
    if (!session) {
      delete this._session;
    } else {
      this._session = session;
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSession() {
    return this._session;
  }

  /**
   * @inheritDoc
   */
   update(captureContext) {
    if (!captureContext) {
      return this;
    }

    if (typeof captureContext === 'function') {
      const updatedScope = (captureContext )(this);
      return updatedScope instanceof Scope ? updatedScope : this;
    }

    if (captureContext instanceof Scope) {
      this._tags = { ...this._tags, ...captureContext._tags };
      this._extra = { ...this._extra, ...captureContext._extra };
      this._contexts = { ...this._contexts, ...captureContext._contexts };
      if (captureContext._user && Object.keys(captureContext._user).length) {
        this._user = captureContext._user;
      }
      if (captureContext._level) {
        this._level = captureContext._level;
      }
      if (captureContext._fingerprint) {
        this._fingerprint = captureContext._fingerprint;
      }
      if (captureContext._requestSession) {
        this._requestSession = captureContext._requestSession;
      }
    } else if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isPlainObject */ .PO)(captureContext)) {
      // eslint-disable-next-line no-param-reassign
      captureContext = captureContext ;
      this._tags = { ...this._tags, ...captureContext.tags };
      this._extra = { ...this._extra, ...captureContext.extra };
      this._contexts = { ...this._contexts, ...captureContext.contexts };
      if (captureContext.user) {
        this._user = captureContext.user;
      }
      if (captureContext.level) {
        this._level = captureContext.level;
      }
      if (captureContext.fingerprint) {
        this._fingerprint = captureContext.fingerprint;
      }
      if (captureContext.requestSession) {
        this._requestSession = captureContext.requestSession;
      }
    }

    return this;
  }

  /**
   * @inheritDoc
   */
   clear() {
    this._breadcrumbs = [];
    this._tags = {};
    this._extra = {};
    this._user = {};
    this._contexts = {};
    this._level = undefined;
    this._transactionName = undefined;
    this._fingerprint = undefined;
    this._requestSession = undefined;
    this._span = undefined;
    this._session = undefined;
    this._notifyScopeListeners();
    this._attachments = [];
    return this;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, maxBreadcrumbs) {
    const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;

    // No data has been changed, so don't notify scope listeners
    if (maxCrumbs <= 0) {
      return this;
    }

    const mergedBreadcrumb = {
      timestamp: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)(),
      ...breadcrumb,
    };
    this._breadcrumbs = [...this._breadcrumbs, mergedBreadcrumb].slice(-maxCrumbs);
    this._notifyScopeListeners();

    return this;
  }

  /**
   * @inheritDoc
   */
   getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }

  /**
   * @inheritDoc
   */
   clearBreadcrumbs() {
    this._breadcrumbs = [];
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   addAttachment(attachment) {
    this._attachments.push(attachment);
    return this;
  }

  /**
   * @inheritDoc
   */
   getAttachments() {
    return this._attachments;
  }

  /**
   * @inheritDoc
   */
   clearAttachments() {
    this._attachments = [];
    return this;
  }

  /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */
   applyToEvent(event, hint = {}) {
    if (this._extra && Object.keys(this._extra).length) {
      event.extra = { ...this._extra, ...event.extra };
    }
    if (this._tags && Object.keys(this._tags).length) {
      event.tags = { ...this._tags, ...event.tags };
    }
    if (this._user && Object.keys(this._user).length) {
      event.user = { ...this._user, ...event.user };
    }
    if (this._contexts && Object.keys(this._contexts).length) {
      event.contexts = { ...this._contexts, ...event.contexts };
    }
    if (this._level) {
      event.level = this._level;
    }
    if (this._transactionName) {
      event.transaction = this._transactionName;
    }

    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (this._span) {
      event.contexts = { trace: this._span.getTraceContext(), ...event.contexts };
      const transaction = this._span.transaction;
      if (transaction) {
        event.sdkProcessingMetadata = {
          dynamicSamplingContext: transaction.getDynamicSamplingContext(),
          ...event.sdkProcessingMetadata,
        };
        const transactionName = transaction.name;
        if (transactionName) {
          event.tags = { transaction: transactionName, ...event.tags };
        }
      }
    }

    this._applyFingerprint(event);

    event.breadcrumbs = [...(event.breadcrumbs || []), ...this._breadcrumbs];
    event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;

    event.sdkProcessingMetadata = { ...event.sdkProcessingMetadata, ...this._sdkProcessingMetadata };

    return this._notifyEventProcessors([...getGlobalEventProcessors(), ...this._eventProcessors], event, hint);
  }

  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
   setSDKProcessingMetadata(newData) {
    this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...newData };

    return this;
  }

  /**
   * This will be called after {@link applyToEvent} is finished.
   */
   _notifyEventProcessors(
    processors,
    event,
    hint,
    index = 0,
  ) {
    return new _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .SyncPromise */ .cW((resolve, reject) => {
      const processor = processors[index];
      if (event === null || typeof processor !== 'function') {
        resolve(event);
      } else {
        const result = processor({ ...event }, hint) ;

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          processor.id &&
          result === null &&
          _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log(`Event processor "${processor.id}" dropped event`);

        if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isThenable */ .J8)(result)) {
          void result
            .then(final => this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve))
            .then(null, reject);
        } else {
          void this._notifyEventProcessors(processors, result, hint, index + 1)
            .then(resolve)
            .then(null, reject);
        }
      }
    });
  }

  /**
   * This will be called on every set call.
   */
   _notifyScopeListeners() {
    // We need this check for this._notifyingListeners to be able to work on scope during updates
    // If this check is not here we'll produce endless recursion when something is done with the scope
    // during the callback.
    if (!this._notifyingListeners) {
      this._notifyingListeners = true;
      this._scopeListeners.forEach(callback => {
        callback(this);
      });
      this._notifyingListeners = false;
    }
  }

  /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */
   _applyFingerprint(event) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .arrayify */ .lE)(event.fingerprint) : [];

    // If we have something on the scope, then merge it with event
    if (this._fingerprint) {
      event.fingerprint = event.fingerprint.concat(this._fingerprint);
    }

    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) {
      delete event.fingerprint;
    }
  }
}

/**
 * Returns the global event processors.
 */
function getGlobalEventProcessors() {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .getGlobalSingleton */ .YO)('globalEventProcessors', () => []);
}

/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
  getGlobalEventProcessors().push(callback);
}


//# sourceMappingURL=scope.js.map


/***/ }),

/***/ 9015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ updateSession; },
/* harmony export */   "Hv": function() { return /* binding */ makeSession; },
/* harmony export */   "RJ": function() { return /* binding */ closeSession; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20535);


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */
function makeSession(context) {
  // Both timestamp and started are in seconds since the UNIX epoch.
  const startingTime = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  const session = {
    sid: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
    init: true,
    timestamp: startingTime,
    started: startingTime,
    duration: 0,
    status: 'ok',
    errors: 0,
    ignoreDuration: false,
    toJSON: () => sessionToJSON(session),
  };

  if (context) {
    updateSession(session, context);
  }

  return session;
}

/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */
// eslint-disable-next-line complexity
function updateSession(session, context = {}) {
  if (context.user) {
    if (!session.ipAddress && context.user.ip_address) {
      session.ipAddress = context.user.ip_address;
    }

    if (!session.did && !context.did) {
      session.did = context.user.id || context.user.email || context.user.username;
    }
  }

  session.timestamp = context.timestamp || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  if (context.ignoreDuration) {
    session.ignoreDuration = context.ignoreDuration;
  }
  if (context.sid) {
    // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
  }
  if (context.init !== undefined) {
    session.init = context.init;
  }
  if (!session.did && context.did) {
    session.did = `${context.did}`;
  }
  if (typeof context.started === 'number') {
    session.started = context.started;
  }
  if (session.ignoreDuration) {
    session.duration = undefined;
  } else if (typeof context.duration === 'number') {
    session.duration = context.duration;
  } else {
    const duration = session.timestamp - session.started;
    session.duration = duration >= 0 ? duration : 0;
  }
  if (context.release) {
    session.release = context.release;
  }
  if (context.environment) {
    session.environment = context.environment;
  }
  if (!session.ipAddress && context.ipAddress) {
    session.ipAddress = context.ipAddress;
  }
  if (!session.userAgent && context.userAgent) {
    session.userAgent = context.userAgent;
  }
  if (typeof context.errors === 'number') {
    session.errors = context.errors;
  }
  if (context.status) {
    session.status = context.status;
  }
}

/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */
function closeSession(session, status) {
  let context = {};
  if (status) {
    context = { status };
  } else if (session.status === 'ok') {
    context = { status: 'exited' };
  }

  updateSession(session, context);
}

/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */
function sessionToJSON(session) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)({
    sid: `${session.sid}`,
    init: session.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(session.started * 1000).toISOString(),
    timestamp: new Date(session.timestamp * 1000).toISOString(),
    status: session.status,
    errors: session.errors,
    did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
    duration: session.duration,
    attrs: {
      release: session.release,
      environment: session.environment,
      ip_address: session.ipAddress,
      user_agent: session.userAgent,
    },
  });
}


//# sourceMappingURL=session.js.map


/***/ }),

/***/ 40105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ SDK_VERSION; }
/* harmony export */ });
const SDK_VERSION = '7.54.0';


//# sourceMappingURL=version.js.map


/***/ }),

/***/ 58464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rt": function() { return /* binding */ htmlTreeAsString; },
/* harmony export */   "l4": function() { return /* binding */ getLocationHref; },
/* harmony export */   "qT": function() { return /* binding */ getDomElement; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71235);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

const DEFAULT_MAX_STRING_LENGTH = 80;

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(
  elem,
  options = {},
) {

  // try/catch both:
  // - accessing event.target (see getsentry/raven-js#838, #768)
  // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
  // - can throw an exception in some circumstances.
  try {
    let currentElem = elem ;
    const MAX_TRAVERSE_HEIGHT = 5;
    const out = [];
    let height = 0;
    let len = 0;
    const separator = ' > ';
    const sepLength = separator.length;
    let nextStr;
    const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
    const maxStringLength = (!Array.isArray(options) && options.maxStringLength) || DEFAULT_MAX_STRING_LENGTH;

    while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
      nextStr = _htmlElementAsString(currentElem, keyAttrs);
      // bail out if
      // - nextStr is the 'html' element
      // - the length of the string that would be created exceeds maxStringLength
      //   (ignore this limit if we are on the first iteration)
      if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength)) {
        break;
      }

      out.push(nextStr);

      len += nextStr.length;
      currentElem = currentElem.parentNode;
    }

    return out.reverse().join(separator);
  } catch (_oO) {
    return '<unknown>';
  }
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el, keyAttrs) {
  const elem = el

;

  const out = [];
  let className;
  let classes;
  let key;
  let attr;
  let i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());

  // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
  const keyAttrPairs =
    keyAttrs && keyAttrs.length
      ? keyAttrs.filter(keyAttr => elem.getAttribute(keyAttr)).map(keyAttr => [keyAttr, elem.getAttribute(keyAttr)])
      : null;

  if (keyAttrPairs && keyAttrPairs.length) {
    keyAttrPairs.forEach(keyAttrPair => {
      out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
  } else {
    if (elem.id) {
      out.push(`#${elem.id}`);
    }

    // eslint-disable-next-line prefer-const
    className = elem.className;
    if (className && (0,_is_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .HD)(className)) {
      classes = className.split(/\s+/);
      for (i = 0; i < classes.length; i++) {
        out.push(`.${classes[i]}`);
      }
    }
  }
  const allowedAttrs = ['aria-label', 'type', 'name', 'title', 'alt'];
  for (i = 0; i < allowedAttrs.length; i++) {
    key = allowedAttrs[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push(`[${key}="${attr}"]`);
    }
  }
  return out.join('');
}

/**
 * A safe form of location.href
 */
function getLocationHref() {
  try {
    return WINDOW.document.location.href;
  } catch (oO) {
    return '';
  }
}

/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getDomElement(selector) {
  if (WINDOW.document && WINDOW.document.querySelector) {
    return WINDOW.document.querySelector(selector) ;
  }
  return null;
}


//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 30292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RA": function() { return /* binding */ dsnToString; },
/* harmony export */   "U4": function() { return /* binding */ dsnFromString; },
/* harmony export */   "vK": function() { return /* binding */ makeDsn; }
/* harmony export */ });
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12343);


/** Regular expression used to parse a Dsn. */
const DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;

function isValidProtocol(protocol) {
  return protocol === 'http' || protocol === 'https';
}

/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */
function dsnToString(dsn, withPassword = false) {
  const { host, path, pass, port, projectId, protocol, publicKey } = dsn;
  return (
    `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` +
    `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`
  );
}

/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */
function dsnFromString(str) {
  const match = DSN_REGEX.exec(str);

  if (!match) {
    // This should be logged to the console
    // eslint-disable-next-line no-console
    console.error(`Invalid Sentry Dsn: ${str}`);
    return undefined;
  }

  const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
  let path = '';
  let projectId = lastPath;

  const split = projectId.split('/');
  if (split.length > 1) {
    path = split.slice(0, -1).join('/');
    projectId = split.pop() ;
  }

  if (projectId) {
    const projectMatch = projectId.match(/^\d+/);
    if (projectMatch) {
      projectId = projectMatch[0];
    }
  }

  return dsnFromComponents({ host, pass, path, projectId, port, protocol: protocol , publicKey });
}

function dsnFromComponents(components) {
  return {
    protocol: components.protocol,
    publicKey: components.publicKey || '',
    pass: components.pass || '',
    host: components.host,
    port: components.port || '',
    path: components.path || '',
    projectId: components.projectId,
  };
}

function validateDsn(dsn) {
  if (!(typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    return true;
  }

  const { port, projectId, protocol } = dsn;

  const requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
  const hasMissingRequiredComponent = requiredComponents.find(component => {
    if (!dsn[component]) {
      _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .kg.error(`Invalid Sentry Dsn: ${component} missing`);
      return true;
    }
    return false;
  });

  if (hasMissingRequiredComponent) {
    return false;
  }

  if (!projectId.match(/^\d+$/)) {
    _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .kg.error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
    return false;
  }

  if (!isValidProtocol(protocol)) {
    _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .kg.error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
    return false;
  }

  if (port && isNaN(parseInt(port, 10))) {
    _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .kg.error(`Invalid Sentry Dsn: Invalid port ${port}`);
    return false;
  }

  return true;
}

/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */
function makeDsn(from) {
  const components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
  if (!components || !validateDsn(components)) {
    return undefined;
  }
  return components;
}


//# sourceMappingURL=dsn.js.map


/***/ }),

/***/ 68518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ getSDKSource; },
/* harmony export */   "n": function() { return /* binding */ isBrowserBundle; }
/* harmony export */ });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */

/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
  return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

/**
 * Get source of SDK.
 */
function getSDKSource() {
  // @ts-ignore "npm" is injected by rollup during build process
  return "npm";
}


//# sourceMappingURL=env.js.map


/***/ }),

/***/ 35648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xU": function() { return /* binding */ SENTRY_XHR_DATA_KEY; },
  "oq": function() { return /* binding */ addInstrumentationHandler; }
});

// UNUSED EXPORTS: parseFetchArgs

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(20535);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(30360);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/supports.js
var supports = __webpack_require__(8823);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(71235);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/vendor/supportsHistory.js


// Based on https://github.com/angular/angular.js/pull/13945/files

// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,worldwide/* getGlobalObject */.Rf)();

/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
  // NOTE: in Chrome App environment, touching history.pushState, *even inside
  //       a try/catch block*, will cause Chrome to output an error to console.error
  // borrowed from: https://github.com/angular/angular.js/pull/13945/files
  /* eslint-disable @typescript-eslint/no-unsafe-member-access */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const chrome = (WINDOW ).chrome;
  const isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
  /* eslint-enable @typescript-eslint/no-unsafe-member-access */
  const hasHistoryApi = 'history' in WINDOW && !!WINDOW.history.pushState && !!WINDOW.history.replaceState;

  return !isChromePackagedApp && hasHistoryApi;
}


//# sourceMappingURL=supportsHistory.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/instrument.js








// eslint-disable-next-line deprecation/deprecation
const instrument_WINDOW = (0,worldwide/* getGlobalObject */.Rf)();

const SENTRY_XHR_DATA_KEY = '__sentry_xhr_v2__';

/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */

const handlers = {};
const instrumented = {};

/** Instruments given API */
function instrument(type) {
  if (instrumented[type]) {
    return;
  }

  instrumented[type] = true;

  switch (type) {
    case 'console':
      instrumentConsole();
      break;
    case 'dom':
      instrumentDOM();
      break;
    case 'xhr':
      instrumentXHR();
      break;
    case 'fetch':
      instrumentFetch();
      break;
    case 'history':
      instrumentHistory();
      break;
    case 'error':
      instrumentError();
      break;
    case 'unhandledrejection':
      instrumentUnhandledRejection();
      break;
    default:
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('unknown instrumentation type:', type);
      return;
  }
}

/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(type, callback) {
  handlers[type] = handlers[type] || [];
  (handlers[type] ).push(callback);
  instrument(type);
}

/** JSDoc */
function triggerHandlers(type, data) {
  if (!type || !handlers[type]) {
    return;
  }

  for (const handler of handlers[type] || []) {
    try {
      handler(data);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.error */.kg.error(
          `Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0,stacktrace/* getFunctionName */.$P)(handler)}\nError:`,
          e,
        );
    }
  }
}

/** JSDoc */
function instrumentConsole() {
  if (!('console' in instrument_WINDOW)) {
    return;
  }

  logger/* CONSOLE_LEVELS.forEach */.RU.forEach(function (level) {
    if (!(level in instrument_WINDOW.console)) {
      return;
    }

    (0,object/* fill */.hl)(instrument_WINDOW.console, level, function (originalConsoleMethod) {
      return function (...args) {
        triggerHandlers('console', { args, level });

        // this fails for some browsers. :(
        if (originalConsoleMethod) {
          originalConsoleMethod.apply(instrument_WINDOW.console, args);
        }
      };
    });
  });
}

/** JSDoc */
function instrumentFetch() {
  if (!(0,supports/* supportsNativeFetch */.t$)()) {
    return;
  }

  (0,object/* fill */.hl)(instrument_WINDOW, 'fetch', function (originalFetch) {
    return function (...args) {
      const { method, url } = parseFetchArgs(args);

      const handlerData = {
        args,
        fetchData: {
          method,
          url,
        },
        startTimestamp: Date.now(),
      };

      triggerHandlers('fetch', {
        ...handlerData,
      });

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      return originalFetch.apply(instrument_WINDOW, args).then(
        (response) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            response,
          });
          return response;
        },
        (error) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            error,
          });
          // NOTE: If you are a Sentry user, and you are seeing this stack frame,
          //       it means the sentry.javascript SDK caught an error invoking your application code.
          //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
          throw error;
        },
      );
    };
  });
}

function hasProp(obj, prop) {
  return !!obj && typeof obj === 'object' && !!(obj )[prop];
}

function getUrlFromResource(resource) {
  if (typeof resource === 'string') {
    return resource;
  }

  if (!resource) {
    return '';
  }

  if (hasProp(resource, 'url')) {
    return resource.url;
  }

  if (resource.toString) {
    return resource.toString();
  }

  return '';
}

/**
 * Parses the fetch arguments to find the used Http method and the url of the request
 */
function parseFetchArgs(fetchArgs) {
  if (fetchArgs.length === 0) {
    return { method: 'GET', url: '' };
  }

  if (fetchArgs.length === 2) {
    const [url, options] = fetchArgs ;

    return {
      url: getUrlFromResource(url),
      method: hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET',
    };
  }

  const arg = fetchArgs[0];
  return {
    url: getUrlFromResource(arg ),
    method: hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET',
  };
}

/** JSDoc */
function instrumentXHR() {
  if (!('XMLHttpRequest' in instrument_WINDOW)) {
    return;
  }

  const xhrproto = XMLHttpRequest.prototype;

  (0,object/* fill */.hl)(xhrproto, 'open', function (originalOpen) {
    return function ( ...args) {
      const url = args[1];
      const xhrInfo = (this[SENTRY_XHR_DATA_KEY] = {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        method: (0,is/* isString */.HD)(args[0]) ? args[0].toUpperCase() : args[0],
        url: args[1],
        request_headers: {},
      });

      // if Sentry key appears in URL, don't capture it as a request
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if ((0,is/* isString */.HD)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) {
        this.__sentry_own_request__ = true;
      }

      const onreadystatechangeHandler = () => {
        // For whatever reason, this is not the same instance here as from the outer method
        const xhrInfo = this[SENTRY_XHR_DATA_KEY];

        if (!xhrInfo) {
          return;
        }

        if (this.readyState === 4) {
          try {
            // touching statusCode in some platforms throws
            // an exception
            xhrInfo.status_code = this.status;
          } catch (e) {
            /* do nothing */
          }

          triggerHandlers('xhr', {
            args: args ,
            endTimestamp: Date.now(),
            startTimestamp: Date.now(),
            xhr: this,
          } );
        }
      };

      if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') {
        (0,object/* fill */.hl)(this, 'onreadystatechange', function (original) {
          return function ( ...readyStateArgs) {
            onreadystatechangeHandler();
            return original.apply(this, readyStateArgs);
          };
        });
      } else {
        this.addEventListener('readystatechange', onreadystatechangeHandler);
      }

      // Intercepting `setRequestHeader` to access the request headers of XHR instance.
      // This will only work for user/library defined headers, not for the default/browser-assigned headers.
      // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
      (0,object/* fill */.hl)(this, 'setRequestHeader', function (original) {
        return function ( ...setRequestHeaderArgs) {
          const [header, value] = setRequestHeaderArgs ;

          const xhrInfo = this[SENTRY_XHR_DATA_KEY];

          if (xhrInfo) {
            xhrInfo.request_headers[header.toLowerCase()] = value;
          }

          return original.apply(this, setRequestHeaderArgs);
        };
      });

      return originalOpen.apply(this, args);
    };
  });

  (0,object/* fill */.hl)(xhrproto, 'send', function (originalSend) {
    return function ( ...args) {
      const sentryXhrData = this[SENTRY_XHR_DATA_KEY];
      if (sentryXhrData && args[0] !== undefined) {
        sentryXhrData.body = args[0];
      }

      triggerHandlers('xhr', {
        args,
        startTimestamp: Date.now(),
        xhr: this,
      });

      return originalSend.apply(this, args);
    };
  });
}

let lastHref;

/** JSDoc */
function instrumentHistory() {
  if (!supportsHistory()) {
    return;
  }

  const oldOnPopState = instrument_WINDOW.onpopstate;
  instrument_WINDOW.onpopstate = function ( ...args) {
    const to = instrument_WINDOW.location.href;
    // keep track of the current URL state, as we always receive only the updated state
    const from = lastHref;
    lastHref = to;
    triggerHandlers('history', {
      from,
      to,
    });
    if (oldOnPopState) {
      // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
      // https://github.com/getsentry/sentry-javascript/issues/3344
      // https://github.com/bugsnag/bugsnag-js/issues/469
      try {
        return oldOnPopState.apply(this, args);
      } catch (_oO) {
        // no-empty
      }
    }
  };

  /** @hidden */
  function historyReplacementFunction(originalHistoryFunction) {
    return function ( ...args) {
      const url = args.length > 2 ? args[2] : undefined;
      if (url) {
        // coerce to string (this is what pushState does)
        const from = lastHref;
        const to = String(url);
        // keep track of the current URL state, as we always receive only the updated state
        lastHref = to;
        triggerHandlers('history', {
          from,
          to,
        });
      }
      return originalHistoryFunction.apply(this, args);
    };
  }

  (0,object/* fill */.hl)(instrument_WINDOW.history, 'pushState', historyReplacementFunction);
  (0,object/* fill */.hl)(instrument_WINDOW.history, 'replaceState', historyReplacementFunction);
}

const debounceDuration = 1000;
let debounceTimerID;
let lastCapturedEvent;

/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */
function shouldShortcircuitPreviousDebounce(previous, current) {
  // If there was no previous event, it should always be swapped for the new one.
  if (!previous) {
    return true;
  }

  // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
  if (previous.type !== current.type) {
    return true;
  }

  try {
    // If both events have the same type, it's still possible that actions were performed on different targets.
    // e.g. 2 clicks on different buttons.
    if (previous.target !== current.target) {
      return true;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
  // to which an event listener was attached), we treat them as the same action, as we want to capture
  // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
  return false;
}

/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(event) {
  // We are only interested in filtering `keypress` events for now.
  if (event.type !== 'keypress') {
    return false;
  }

  try {
    const target = event.target ;

    if (!target || !target.tagName) {
      return true;
    }

    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
      return false;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  return true;
}

/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function makeDOMEventHandler(handler, globalListener = false) {
  return (event) => {
    // It's possible this handler might trigger multiple times for the same
    // event (e.g. event propagation through node ancestors).
    // Ignore if we've already captured that event.
    if (!event || lastCapturedEvent === event) {
      return;
    }

    // We always want to skip _some_ events.
    if (shouldSkipDOMEvent(event)) {
      return;
    }

    const name = event.type === 'keypress' ? 'input' : event.type;

    // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
    if (debounceTimerID === undefined) {
      handler({
        event: event,
        name,
        global: globalListener,
      });
      lastCapturedEvent = event;
    }
    // If there is a debounce awaiting, see if the new event is different enough to treat it as a unique one.
    // If that's the case, emit the previous event and store locally the newly-captured DOM event.
    else if (shouldShortcircuitPreviousDebounce(lastCapturedEvent, event)) {
      handler({
        event: event,
        name,
        global: globalListener,
      });
      lastCapturedEvent = event;
    }

    // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
    clearTimeout(debounceTimerID);
    debounceTimerID = instrument_WINDOW.setTimeout(() => {
      debounceTimerID = undefined;
    }, debounceDuration);
  };
}

/** JSDoc */
function instrumentDOM() {
  if (!('document' in instrument_WINDOW)) {
    return;
  }

  // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
  // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
  // we instrument `addEventListener` so that we don't end up attaching this handler twice.
  const triggerDOMHandler = triggerHandlers.bind(null, 'dom');
  const globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
  instrument_WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
  instrument_WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);

  // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
  // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
  // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
  // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
  // guaranteed to fire at least once.)
  ['EventTarget', 'Node'].forEach((target) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = (instrument_WINDOW )[target] && (instrument_WINDOW )[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
      return;
    }

    (0,object/* fill */.hl)(proto, 'addEventListener', function (originalAddEventListener) {
      return function (

        type,
        listener,
        options,
      ) {
        if (type === 'click' || type == 'keypress') {
          try {
            const el = this ;
            const handlers = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
            const handlerForType = (handlers[type] = handlers[type] || { refCount: 0 });

            if (!handlerForType.handler) {
              const handler = makeDOMEventHandler(triggerDOMHandler);
              handlerForType.handler = handler;
              originalAddEventListener.call(this, type, handler, options);
            }

            handlerForType.refCount++;
          } catch (e) {
            // Accessing dom properties is always fragile.
            // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
          }
        }

        return originalAddEventListener.call(this, type, listener, options);
      };
    });

    (0,object/* fill */.hl)(
      proto,
      'removeEventListener',
      function (originalRemoveEventListener) {
        return function (

          type,
          listener,
          options,
        ) {
          if (type === 'click' || type == 'keypress') {
            try {
              const el = this ;
              const handlers = el.__sentry_instrumentation_handlers__ || {};
              const handlerForType = handlers[type];

              if (handlerForType) {
                handlerForType.refCount--;
                // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                if (handlerForType.refCount <= 0) {
                  originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                  handlerForType.handler = undefined;
                  delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                }

                // If there are no longer any custom handlers of any type on this element, cleanup everything.
                if (Object.keys(handlers).length === 0) {
                  delete el.__sentry_instrumentation_handlers__;
                }
              }
            } catch (e) {
              // Accessing dom properties is always fragile.
              // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
            }
          }

          return originalRemoveEventListener.call(this, type, listener, options);
        };
      },
    );
  });
}

let _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
  _oldOnErrorHandler = instrument_WINDOW.onerror;

  instrument_WINDOW.onerror = function (msg, url, line, column, error) {
    triggerHandlers('error', {
      column,
      error,
      line,
      msg,
      url,
    });

    if (_oldOnErrorHandler && !_oldOnErrorHandler.__SENTRY_LOADER__) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnErrorHandler.apply(this, arguments);
    }

    return false;
  };

  instrument_WINDOW.onerror.__SENTRY_INSTRUMENTED__ = true;
}

let _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
  _oldOnUnhandledRejectionHandler = instrument_WINDOW.onunhandledrejection;

  instrument_WINDOW.onunhandledrejection = function (e) {
    triggerHandlers('unhandledrejection', e);

    if (_oldOnUnhandledRejectionHandler && !_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnUnhandledRejectionHandler.apply(this, arguments);
    }

    return true;
  };

  instrument_WINDOW.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}


//# sourceMappingURL=instrument.js.map


/***/ }),

/***/ 67597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cy": function() { return /* binding */ isSyntheticEvent; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "J8": function() { return /* binding */ isThenable; },
/* harmony export */   "Kj": function() { return /* binding */ isRegExp; },
/* harmony export */   "PO": function() { return /* binding */ isPlainObject; },
/* harmony export */   "TX": function() { return /* binding */ isDOMError; },
/* harmony export */   "V9": function() { return /* binding */ isInstanceOf; },
/* harmony export */   "VW": function() { return /* binding */ isErrorEvent; },
/* harmony export */   "VZ": function() { return /* binding */ isError; },
/* harmony export */   "cO": function() { return /* binding */ isEvent; },
/* harmony export */   "fm": function() { return /* binding */ isDOMException; },
/* harmony export */   "i2": function() { return /* binding */ isNaN; },
/* harmony export */   "kK": function() { return /* binding */ isElement; },
/* harmony export */   "pt": function() { return /* binding */ isPrimitive; }
/* harmony export */ });
// eslint-disable-next-line @typescript-eslint/unbound-method
const objectToString = Object.prototype.toString;

/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
  switch (objectToString.call(wat)) {
    case '[object Error]':
    case '[object Exception]':
    case '[object DOMException]':
      return true;
    default:
      return isInstanceOf(wat, Error);
  }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */
function isBuiltin(wat, className) {
  return objectToString.call(wat) === `[object ${className}]`;
}

/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
  return isBuiltin(wat, 'ErrorEvent');
}

/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
  return isBuiltin(wat, 'DOMError');
}

/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
  return isBuiltin(wat, 'DOMException');
}

/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
  return isBuiltin(wat, 'String');
}

/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
  return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}

/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
  return isBuiltin(wat, 'Object');
}

/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
  return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}

/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
  return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}

/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
  return isBuiltin(wat, 'RegExp');
}

/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return Boolean(wat && wat.then && typeof wat.then === 'function');
}

/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
  return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}

/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isNaN(wat) {
  return typeof wat === 'number' && wat !== wat;
}

/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
  try {
    return wat instanceof base;
  } catch (_e) {
    return false;
  }
}


//# sourceMappingURL=is.js.map


/***/ }),

/***/ 12343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cf": function() { return /* binding */ consoleSandbox; },
/* harmony export */   "RU": function() { return /* binding */ CONSOLE_LEVELS; },
/* harmony export */   "kg": function() { return /* binding */ logger; }
/* harmony export */ });
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71235);


/** Prefix for logging strings */
const PREFIX = 'Sentry Logger ';

const CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'] ;

/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
  if (!("console" in _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2)) {
    return callback();
  }

  const originalConsole = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console ;
  const wrappedLevels = {};

  // Restore all wrapped console methods
  CONSOLE_LEVELS.forEach(level => {
    // TODO(v7): Remove this check as it's only needed for Node 6
    const originalWrappedFunc =
      originalConsole[level] && (originalConsole[level] ).__sentry_original__;
    if (level in originalConsole && originalWrappedFunc) {
      wrappedLevels[level] = originalConsole[level] ;
      originalConsole[level] = originalWrappedFunc ;
    }
  });

  try {
    return callback();
  } finally {
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(level => {
      originalConsole[level] = wrappedLevels[level ];
    });
  }
}

function makeLogger() {
  let enabled = false;
  const logger = {
    enable: () => {
      enabled = true;
    },
    disable: () => {
      enabled = false;
    },
  };

  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    CONSOLE_LEVELS.forEach(name => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      logger[name] = (...args) => {
        if (enabled) {
          consoleSandbox(() => {
            _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console[name](`${PREFIX}[${name}]:`, ...args);
          });
        }
      };
    });
  } else {
    CONSOLE_LEVELS.forEach(name => {
      logger[name] = () => undefined;
    });
  }

  return logger ;
}

// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
let logger;
if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
  logger = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalSingleton */ .YO)('logger', makeLogger);
} else {
  logger = makeLogger();
}


//# sourceMappingURL=logger.js.map


/***/ }),

/***/ 62844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ uuid4; },
/* harmony export */   "Db": function() { return /* binding */ addExceptionTypeValue; },
/* harmony export */   "EG": function() { return /* binding */ addExceptionMechanism; },
/* harmony export */   "YO": function() { return /* binding */ checkOrSetAlreadyCaught; },
/* harmony export */   "jH": function() { return /* binding */ getEventDescription; },
/* harmony export */   "lE": function() { return /* binding */ arrayify; }
/* harmony export */ });
/* unused harmony exports addContextToFrame, parseSemver */
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20535);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71235);




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
  const gbl = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2 ;
  const crypto = gbl.crypto || gbl.msCrypto;

  if (crypto && crypto.randomUUID) {
    return crypto.randomUUID().replace(/-/g, '');
  }

  const getRandomByte =
    crypto && crypto.getRandomValues ? () => crypto.getRandomValues(new Uint8Array(1))[0] : () => Math.random() * 16;

  // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
  // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
  return (([1e7] ) + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, c =>
    // eslint-disable-next-line no-bitwise
    ((c ) ^ ((getRandomByte() & 15) >> ((c ) / 4))).toString(16),
  );
}

function getFirstException(event) {
  return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}

/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
  const { message, event_id: eventId } = event;
  if (message) {
    return message;
  }

  const firstException = getFirstException(event);
  if (firstException) {
    if (firstException.type && firstException.value) {
      return `${firstException.type}: ${firstException.value}`;
    }
    return firstException.type || firstException.value || eventId || '<unknown>';
  }
  return eventId || '<unknown>';
}

/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
  const exception = (event.exception = event.exception || {});
  const values = (exception.values = exception.values || []);
  const firstException = (values[0] = values[0] || {});
  if (!firstException.value) {
    firstException.value = value || '';
  }
  if (!firstException.type) {
    firstException.type = type || 'Error';
  }
}

/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function addExceptionMechanism(event, newMechanism) {
  const firstException = getFirstException(event);
  if (!firstException) {
    return;
  }

  const defaultMechanism = { type: 'generic', handled: true };
  const currentMechanism = firstException.mechanism;
  firstException.mechanism = { ...defaultMechanism, ...currentMechanism, ...newMechanism };

  if (newMechanism && 'data' in newMechanism) {
    const mergedData = { ...(currentMechanism && currentMechanism.data), ...newMechanism.data };
    firstException.mechanism.data = mergedData;
  }
}

// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const SEMVER_REGEXP =
  /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;

/**
 * Represents Semantic Versioning object
 */

/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
  const match = input.match(SEMVER_REGEXP) || [];
  const major = parseInt(match[1], 10);
  const minor = parseInt(match[2], 10);
  const patch = parseInt(match[3], 10);
  return {
    buildmetadata: match[5],
    major: isNaN(major) ? undefined : major,
    minor: isNaN(minor) ? undefined : minor,
    patch: isNaN(patch) ? undefined : patch,
    prerelease: match[4],
  };
}

/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext = 5) {
  // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
  if (frame.lineno === undefined) {
    return;
  }

  const maxLines = lines.length;
  const sourceLine = Math.max(Math.min(maxLines, frame.lineno - 1), 0);

  frame.pre_context = lines
    .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
    .map((line) => snipLine(line, 0));

  frame.context_line = snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);

  frame.post_context = lines
    .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
    .map((line) => snipLine(line, 0));
}

/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (exception && (exception ).__sentry_captured__) {
    return true;
  }

  try {
    // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
    // `ExtraErrorData` integration
    (0,_object_js__WEBPACK_IMPORTED_MODULE_1__/* .addNonEnumerableProperty */ .xp)(exception , '__sentry_captured__', true);
  } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
  }

  return false;
}

/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */
function arrayify(maybeArray) {
  return Array.isArray(maybeArray) ? maybeArray : [maybeArray];
}


//# sourceMappingURL=misc.js.map


/***/ }),

/***/ 61422:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KV": function() { return /* binding */ isNodeEnv; },
/* harmony export */   "l$": function() { return /* binding */ dynamicRequire; }
/* harmony export */ });
/* unused harmony export loadModule */
/* harmony import */ var _env_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68518);
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(83454);


/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
  // explicitly check for browser bundles as those can be optimized statically
  // by terser/rollup.
  return (
    !(0,_env_js__WEBPACK_IMPORTED_MODULE_0__/* .isBrowserBundle */ .n)() &&
    Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]'
  );
}

/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return mod.require(request);
}

/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */
function loadModule(moduleName) {
  let mod;

  try {
    mod = dynamicRequire(module, moduleName);
  } catch (e) {
    // no-empty
  }

  try {
    const { cwd } = dynamicRequire(module, 'process');
    mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`) ;
  } catch (e) {
    // no-empty
  }

  return mod;
}


//# sourceMappingURL=node.js.map


/***/ }),

/***/ 20535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Q": function() { return /* binding */ markFunctionWrapped; },
/* harmony export */   "HK": function() { return /* binding */ getOriginalFunction; },
/* harmony export */   "Jr": function() { return /* binding */ dropUndefinedKeys; },
/* harmony export */   "Sh": function() { return /* binding */ convertToPlainObject; },
/* harmony export */   "_j": function() { return /* binding */ urlEncode; },
/* harmony export */   "hl": function() { return /* binding */ fill; },
/* harmony export */   "xp": function() { return /* binding */ addNonEnumerableProperty; },
/* harmony export */   "zf": function() { return /* binding */ extractExceptionKeysForMessage; }
/* harmony export */ });
/* unused harmony export objectify */
/* harmony import */ var _browser_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58464);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57321);




/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
  if (!(name in source)) {
    return;
  }

  const original = source[name] ;
  const wrapped = replacementFactory(original) ;

  // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
  // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
  if (typeof wrapped === 'function') {
    try {
      markFunctionWrapped(wrapped, original);
    } catch (_Oo) {
      // This can throw if multiple fill happens on a global object like XMLHttpRequest
      // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
  }

  source[name] = wrapped;
}

/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function addNonEnumerableProperty(obj, name, value) {
  Object.defineProperty(obj, name, {
    // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
    value: value,
    writable: true,
    configurable: true,
  });
}

/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function markFunctionWrapped(wrapped, original) {
  const proto = original.prototype || {};
  wrapped.prototype = original.prototype = proto;
  addNonEnumerableProperty(wrapped, '__sentry_original__', original);
}

/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
function getOriginalFunction(func) {
  return func.__sentry_original__;
}

/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
  return Object.keys(object)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`)
    .join('&');
}

/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */
function convertToPlainObject(value)

 {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isError */ .VZ)(value)) {
    return {
      message: value.message,
      name: value.name,
      stack: value.stack,
      ...getOwnProperties(value),
    };
  } else if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isEvent */ .cO)(value)) {
    const newObj

 = {
      type: value.type,
      target: serializeEventTarget(value.target),
      currentTarget: serializeEventTarget(value.currentTarget),
      ...getOwnProperties(value),
    };

    if (typeof CustomEvent !== 'undefined' && (0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isInstanceOf */ .V9)(value, CustomEvent)) {
      newObj.detail = value.detail;
    }

    return newObj;
  } else {
    return value;
  }
}

/** Creates a string representation of the target of an `Event` object */
function serializeEventTarget(target) {
  try {
    return (0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isElement */ .kK)(target) ? (0,_browser_js__WEBPACK_IMPORTED_MODULE_1__/* .htmlTreeAsString */ .Rt)(target) : Object.prototype.toString.call(target);
  } catch (_oO) {
    return '<unknown>';
  }
}

/** Filters out all but an object's own properties */
function getOwnProperties(obj) {
  if (typeof obj === 'object' && obj !== null) {
    const extractedProps = {};
    for (const property in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, property)) {
        extractedProps[property] = (obj )[property];
      }
    }
    return extractedProps;
  } else {
    return {};
  }
}

/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
function extractExceptionKeysForMessage(exception, maxLength = 40) {
  const keys = Object.keys(convertToPlainObject(exception));
  keys.sort();

  if (!keys.length) {
    return '[object has no keys]';
  }

  if (keys[0].length >= maxLength) {
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .truncate */ .$G)(keys[0], maxLength);
  }

  for (let includedKeys = keys.length; includedKeys > 0; includedKeys--) {
    const serialized = keys.slice(0, includedKeys).join(', ');
    if (serialized.length > maxLength) {
      continue;
    }
    if (includedKeys === keys.length) {
      return serialized;
    }
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .truncate */ .$G)(serialized, maxLength);
  }

  return '';
}

/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */
function dropUndefinedKeys(inputValue) {
  // This map keeps track of what already visited nodes map to.
  // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
  // references as the input object.
  const memoizationMap = new Map();

  // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
  return _dropUndefinedKeys(inputValue, memoizationMap);
}

function _dropUndefinedKeys(inputValue, memoizationMap) {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .PO)(inputValue)) {
    // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = {};
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    for (const key of Object.keys(inputValue)) {
      if (typeof inputValue[key] !== 'undefined') {
        returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
      }
    }

    return returnValue ;
  }

  if (Array.isArray(inputValue)) {
    // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = [];
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    inputValue.forEach((item) => {
      returnValue.push(_dropUndefinedKeys(item, memoizationMap));
    });

    return returnValue ;
  }

  return inputValue;
}

/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */
function objectify(wat) {
  let objectified;
  switch (true) {
    case wat === undefined || wat === null:
      objectified = new String(wat);
      break;

    // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
    // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
    // an object in order to wrap it.
    case typeof wat === 'symbol' || typeof wat === 'bigint':
      objectified = Object(wat);
      break;

    // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
    case isPrimitive(wat):
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      objectified = new (wat ).constructor(wat);
      break;

    // by process of elimination, at this point we know that `wat` must already be an object
    default:
      objectified = wat;
      break;
  }
  return objectified;
}


//# sourceMappingURL=object.js.map


/***/ }),

/***/ 30360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": function() { return /* binding */ getFunctionName; },
/* harmony export */   "Sq": function() { return /* binding */ stackParserFromStackParserOptions; },
/* harmony export */   "pE": function() { return /* binding */ createStackParser; }
/* harmony export */ });
/* unused harmony exports nodeStackLineParser, stripSentryFramesAndReverse */


const STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;

/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */
function createStackParser(...parsers) {
  const sortedParsers = parsers.sort((a, b) => a[0] - b[0]).map(p => p[1]);

  return (stack, skipFirst = 0) => {
    const frames = [];
    const lines = stack.split('\n');

    for (let i = skipFirst; i < lines.length; i++) {
      const line = lines[i];
      // Ignore lines over 1kb as they are unlikely to be stack frames.
      // Many of the regular expressions use backtracking which results in run time that increases exponentially with
      // input size. Huge strings can result in hangs/Denial of Service:
      // https://github.com/getsentry/sentry-javascript/issues/2286
      if (line.length > 1024) {
        continue;
      }

      // https://github.com/getsentry/sentry-javascript/issues/5459
      // Remove webpack (error: *) wrappers
      const cleanedLine = WEBPACK_ERROR_REGEXP.test(line) ? line.replace(WEBPACK_ERROR_REGEXP, '$1') : line;

      // https://github.com/getsentry/sentry-javascript/issues/7813
      // Skip Error: lines
      if (cleanedLine.match(/\S*Error: /)) {
        continue;
      }

      for (const parser of sortedParsers) {
        const frame = parser(cleanedLine);

        if (frame) {
          frames.push(frame);
          break;
        }
      }

      if (frames.length >= STACKTRACE_FRAME_LIMIT) {
        break;
      }
    }

    return stripSentryFramesAndReverse(frames);
  };
}

/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */
function stackParserFromStackParserOptions(stackParser) {
  if (Array.isArray(stackParser)) {
    return createStackParser(...stackParser);
  }
  return stackParser;
}

/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */
function stripSentryFramesAndReverse(stack) {
  if (!stack.length) {
    return [];
  }

  const localStack = stack.slice(0, STACKTRACE_FRAME_LIMIT);

  const lastFrameFunction = localStack[localStack.length - 1].function;
  // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
  if (lastFrameFunction && /sentryWrapped/.test(lastFrameFunction)) {
    localStack.pop();
  }

  // Reversing in the middle of the procedure allows us to just pop the values off the stack
  localStack.reverse();

  const firstFrameFunction = localStack[localStack.length - 1].function;
  // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
  if (firstFrameFunction && /captureMessage|captureException/.test(firstFrameFunction)) {
    localStack.pop();
  }

  return localStack.map(frame => ({
    ...frame,
    filename: frame.filename || localStack[localStack.length - 1].filename,
    function: frame.function || '?',
  }));
}

const defaultFunctionName = '<anonymous>';

/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
  try {
    if (!fn || typeof fn !== 'function') {
      return defaultFunctionName;
    }
    return fn.name || defaultFunctionName;
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    return defaultFunctionName;
  }
}

/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */
function nodeStackLineParser(getModule) {
  return [90, node(getModule)];
}


//# sourceMappingURL=stacktrace.js.map


/***/ }),

/***/ 57321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ truncate; },
/* harmony export */   "U0": function() { return /* binding */ stringMatchesSomePattern; },
/* harmony export */   "nK": function() { return /* binding */ safeJoin; }
/* harmony export */ });
/* unused harmony exports isMatchingPattern, snipLine */
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);


/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function truncate(str, max = 0) {
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : `${str.slice(0, max)}...`;
}

/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
  let newLine = line;
  const lineLength = newLine.length;
  if (lineLength <= 150) {
    return newLine;
  }
  if (colno > lineLength) {
    // eslint-disable-next-line no-param-reassign
    colno = lineLength;
  }

  let start = Math.max(colno - 60, 0);
  if (start < 5) {
    start = 0;
  }

  let end = Math.min(start + 140, lineLength);
  if (end > lineLength - 5) {
    end = lineLength;
  }
  if (end === lineLength) {
    start = Math.max(end - 140, 0);
  }

  newLine = newLine.slice(start, end);
  if (start > 0) {
    newLine = `'{snip} ${newLine}`;
  }
  if (end < lineLength) {
    newLine += ' {snip}';
  }

  return newLine;
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
  if (!Array.isArray(input)) {
    return '';
  }

  const output = [];
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < input.length; i++) {
    const value = input[i];
    try {
      output.push(String(value));
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */
function isMatchingPattern(
  value,
  pattern,
  requireExactStringMatch = false,
) {
  if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(value)) {
    return false;
  }

  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isRegExp */ .Kj)(pattern)) {
    return pattern.test(value);
  }
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(pattern)) {
    return requireExactStringMatch ? value === pattern : value.includes(pattern);
  }

  return false;
}

/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */
function stringMatchesSomePattern(
  testString,
  patterns = [],
  requireExactStringMatch = false,
) {
  return patterns.some(pattern => isMatchingPattern(testString, pattern, requireExactStringMatch));
}


//# sourceMappingURL=string.js.map


/***/ }),

/***/ 8823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ak": function() { return /* binding */ supportsFetch; },
/* harmony export */   "Du": function() { return /* binding */ isNativeFetch; },
/* harmony export */   "t$": function() { return /* binding */ supportsNativeFetch; }
/* harmony export */ });
/* unused harmony exports supportsDOMError, supportsDOMException, supportsErrorEvent, supportsReferrerPolicy, supportsReportingObserver */
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12343);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71235);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
  try {
    new ErrorEvent('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
  try {
    // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
    // 1 argument required, but only 0 present.
    // @ts-ignore It really needs 1 argument, not 0.
    new DOMError('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
  try {
    new DOMException('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
  if (!('fetch' in WINDOW)) {
    return false;
  }

  try {
    new Headers();
    new Request('http://www.example.com');
    new Response();
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
  return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}

/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
  if (!supportsFetch()) {
    return false;
  }

  // Fast path to avoid DOM I/O
  // eslint-disable-next-line @typescript-eslint/unbound-method
  if (isNativeFetch(WINDOW.fetch)) {
    return true;
  }

  // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
  // so create a "pure" iframe to see if that has native fetch
  let result = false;
  const doc = WINDOW.document;
  // eslint-disable-next-line deprecation/deprecation
  if (doc && typeof (doc.createElement ) === 'function') {
    try {
      const sandbox = doc.createElement('iframe');
      sandbox.hidden = true;
      doc.head.appendChild(sandbox);
      if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        result = isNativeFetch(sandbox.contentWindow.fetch);
      }
      doc.head.removeChild(sandbox);
    } catch (err) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.warn */ .kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
  }

  return result;
}

/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
  return 'ReportingObserver' in WINDOW;
}

/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
  // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
  // (see https://caniuse.com/#feat=referrer-policy),
  // it doesn't. And it throws an exception instead of ignoring this parameter...
  // REF: https://github.com/getsentry/raven-js/issues/1233

  if (!supportsFetch()) {
    return false;
  }

  try {
    new Request('_', {
      referrerPolicy: 'origin' ,
    });
    return true;
  } catch (e) {
    return false;
  }
}


//# sourceMappingURL=supports.js.map


/***/ }),

/***/ 96893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ rejectedSyncPromise; },
/* harmony export */   "WD": function() { return /* binding */ resolvedSyncPromise; },
/* harmony export */   "cW": function() { return /* binding */ SyncPromise; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);


/* eslint-disable @typescript-eslint/explicit-function-return-type */

/** SyncPromise internal states */
var States; (function (States) {
  /** Pending */
  const PENDING = 0; States[States["PENDING"] = PENDING] = "PENDING";
  /** Resolved / OK */
  const RESOLVED = 1; States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
  /** Rejected / Error */
  const REJECTED = 2; States[States["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));

// Overloads so we can call resolvedSyncPromise without arguments and generic argument

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function resolvedSyncPromise(value) {
  return new SyncPromise(resolve => {
    resolve(value);
  });
}

/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
  return new SyncPromise((_, reject) => {
    reject(reason);
  });
}

/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
class SyncPromise {
   __init() {this._state = States.PENDING;}
   __init2() {this._handlers = [];}

   constructor(
    executor,
  ) {SyncPromise.prototype.__init.call(this);SyncPromise.prototype.__init2.call(this);SyncPromise.prototype.__init3.call(this);SyncPromise.prototype.__init4.call(this);SyncPromise.prototype.__init5.call(this);SyncPromise.prototype.__init6.call(this);
    try {
      executor(this._resolve, this._reject);
    } catch (e) {
      this._reject(e);
    }
  }

  /** JSDoc */
   then(
    onfulfilled,
    onrejected,
  ) {
    return new SyncPromise((resolve, reject) => {
      this._handlers.push([
        false,
        result => {
          if (!onfulfilled) {
            // TODO: ¯\_(ツ)_/¯
            // TODO: FIXME
            resolve(result );
          } else {
            try {
              resolve(onfulfilled(result));
            } catch (e) {
              reject(e);
            }
          }
        },
        reason => {
          if (!onrejected) {
            reject(reason);
          } else {
            try {
              resolve(onrejected(reason));
            } catch (e) {
              reject(e);
            }
          }
        },
      ]);
      this._executeHandlers();
    });
  }

  /** JSDoc */
   catch(
    onrejected,
  ) {
    return this.then(val => val, onrejected);
  }

  /** JSDoc */
   finally(onfinally) {
    return new SyncPromise((resolve, reject) => {
      let val;
      let isRejected;

      return this.then(
        value => {
          isRejected = false;
          val = value;
          if (onfinally) {
            onfinally();
          }
        },
        reason => {
          isRejected = true;
          val = reason;
          if (onfinally) {
            onfinally();
          }
        },
      ).then(() => {
        if (isRejected) {
          reject(val);
          return;
        }

        resolve(val );
      });
    });
  }

  /** JSDoc */
    __init3() {this._resolve = (value) => {
    this._setResult(States.RESOLVED, value);
  };}

  /** JSDoc */
    __init4() {this._reject = (reason) => {
    this._setResult(States.REJECTED, reason);
  };}

  /** JSDoc */
    __init5() {this._setResult = (state, value) => {
    if (this._state !== States.PENDING) {
      return;
    }

    if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isThenable */ .J8)(value)) {
      void (value ).then(this._resolve, this._reject);
      return;
    }

    this._state = state;
    this._value = value;

    this._executeHandlers();
  };}

  /** JSDoc */
    __init6() {this._executeHandlers = () => {
    if (this._state === States.PENDING) {
      return;
    }

    const cachedHandlers = this._handlers.slice();
    this._handlers = [];

    cachedHandlers.forEach(handler => {
      if (handler[0]) {
        return;
      }

      if (this._state === States.RESOLVED) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        handler[1](this._value );
      }

      if (this._state === States.REJECTED) {
        handler[2](this._value);
      }

      handler[0] = true;
    });
  };}
}


//# sourceMappingURL=syncpromise.js.map


/***/ }),

/***/ 21170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z1": function() { return /* binding */ browserPerformanceTimeOrigin; },
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; },
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; }
/* harmony export */ });
/* unused harmony exports _browserPerformanceTimeOriginMode, timestampWithMs, usingPerformanceAPI */
/* harmony import */ var _node_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61422);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71235);
/* module decorator */ module = __webpack_require__.hmd(module);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
const dateTimestampSource = {
  nowSeconds: () => Date.now() / 1000,
};

/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */

/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    return undefined;
  }

  // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
  //
  // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
  // performance.now() gives a date arbitrarily in the past.
  //
  // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
  // undefined.
  //
  // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
  // interact with data coming out of performance entries.
  //
  // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
  // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
  // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
  // observed skews that can be as long as days, weeks or months.
  //
  // See https://github.com/getsentry/sentry-javascript/issues/2590.
  //
  // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
  // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
  // transactions of long-lived web pages.
  const timeOrigin = Date.now() - performance.now();

  return {
    now: () => performance.now(),
    timeOrigin,
  };
}

/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
  try {
    const perfHooks = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .dynamicRequire */ .l$)(module, 'perf_hooks') ;
    return perfHooks.performance;
  } catch (_) {
    return undefined;
  }
}

/**
 * The Performance API implementation for the current platform, if available.
 */
const platformPerformance = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .isNodeEnv */ .KV)() ? getNodePerformance() : getBrowserPerformance();

const timestampSource =
  platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: () => (platformPerformance.timeOrigin + platformPerformance.now()) / 1000,
      };

/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
const dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);

/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
const timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);

/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */
const timestampWithMs = (/* unused pure expression or super */ null && (timestampInSeconds));

/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */
const usingPerformanceAPI = platformPerformance !== undefined;

/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */
let _browserPerformanceTimeOriginMode;

/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
const browserPerformanceTimeOrigin = (() => {
  // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
  // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
  // data as reliable if they are within a reasonable threshold of the current time.

  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    _browserPerformanceTimeOriginMode = 'none';
    return undefined;
  }

  const threshold = 3600 * 1000;
  const performanceNow = performance.now();
  const dateNow = Date.now();

  // if timeOrigin isn't available set delta to threshold so it isn't used
  const timeOriginDelta = performance.timeOrigin
    ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
    : threshold;
  const timeOriginIsReliable = timeOriginDelta < threshold;

  // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
  // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
  // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
  // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
  // Date API.
  // eslint-disable-next-line deprecation/deprecation
  const navigationStart = performance.timing && performance.timing.navigationStart;
  const hasNavigationStart = typeof navigationStart === 'number';
  // if navigationStart isn't available set delta to threshold so it isn't used
  const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
  const navigationStartIsReliable = navigationStartDelta < threshold;

  if (timeOriginIsReliable || navigationStartIsReliable) {
    // Use the more reliable time origin
    if (timeOriginDelta <= navigationStartDelta) {
      _browserPerformanceTimeOriginMode = 'timeOrigin';
      return performance.timeOrigin;
    } else {
      _browserPerformanceTimeOriginMode = 'navigationStart';
      return navigationStart;
    }
  }

  // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
  _browserPerformanceTimeOriginMode = 'dateNow';
  return dateNow;
})();


//# sourceMappingURL=time.js.map


/***/ }),

/***/ 26956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "en": function() { return /* binding */ parseUrl; },
/* harmony export */   "rt": function() { return /* binding */ stripUrlQueryAndFragment; }
/* harmony export */ });
/* unused harmony exports getNumberOfUrlSegments, getSanitizedUrlString */
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url) {
  if (!url) {
    return {};
  }

  const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  if (!match) {
    return {};
  }

  // coerce to undefined values to empty string so we don't get 'undefined'
  const query = match[6] || '';
  const fragment = match[8] || '';
  return {
    host: match[4],
    path: match[5],
    protocol: match[2],
    search: query,
    hash: fragment,
    relative: match[5] + query + fragment, // everything minus origin
  };
}

/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function stripUrlQueryAndFragment(urlPath) {
  // eslint-disable-next-line no-useless-escape
  return urlPath.split(/[\?#]/, 1)[0];
}

/**
 * Returns number of URL segments of a passed string URL.
 */
function getNumberOfUrlSegments(url) {
  // split at '/' or at '\/' to split regex urls correctly
  return url.split(/\\?\//).filter(s => s.length > 0 && s !== ',').length;
}

/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */
function getSanitizedUrlString(url) {
  const { protocol, host, path } = url;

  const filteredHost =
    (host &&
      host
        // Always filter out authority
        .replace(/^.*@/, '[filtered]:[filtered]@')
        // Don't show standard :80 (http) and :443 (https) ports to reduce the noise
        .replace(':80', '')
        .replace(':443', '')) ||
    '';

  return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}


//# sourceMappingURL=url.js.map


/***/ }),

/***/ 71235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rf": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "YO": function() { return /* binding */ getGlobalSingleton; },
/* harmony export */   "n2": function() { return /* binding */ GLOBAL_OBJ; }
/* harmony export */ });
/** Internal global with common properties and Sentry extensions  */

// The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

/** Returns 'obj' if it's the global object, otherwise returns undefined */
function isGlobalObj(obj) {
  return obj && obj.Math == Math ? obj : undefined;
}

/** Get's the global object for the current JavaScript runtime */
const GLOBAL_OBJ =
  (typeof globalThis == 'object' && isGlobalObj(globalThis)) ||
  // eslint-disable-next-line no-restricted-globals
  (typeof window == 'object' && isGlobalObj(window)) ||
  (typeof self == 'object' && isGlobalObj(self)) ||
  (typeof __webpack_require__.g == 'object' && isGlobalObj(__webpack_require__.g)) ||
  (function () {
    return this;
  })() ||
  {};

/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */
function getGlobalObject() {
  return GLOBAL_OBJ ;
}

/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */
function getGlobalSingleton(name, creator, obj) {
  const gbl = (obj || GLOBAL_OBJ) ;
  const __SENTRY__ = (gbl.__SENTRY__ = gbl.__SENTRY__ || {});
  const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
  return singleton;
}


//# sourceMappingURL=worldwide.js.map


/***/ }),

/***/ 79361:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.Z = _defineProperty;
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/***/ }),

/***/ 44409:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = asyncify;

var _initialParams = __webpack_require__(43519);

var _initialParams2 = _interopRequireDefault(_initialParams);

var _setImmediate = __webpack_require__(3111);

var _setImmediate2 = _interopRequireDefault(_setImmediate);

var _wrapAsync = __webpack_require__(28993);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Take a sync function and make it async, passing its return value to a
 * callback. This is useful for plugging sync functions into a waterfall,
 * series, or other async functions. Any arguments passed to the generated
 * function will be passed to the wrapped function (except for the final
 * callback argument). Errors thrown will be passed to the callback.
 *
 * If the function passed to `asyncify` returns a Promise, that promises's
 * resolved/rejected state will be used to call the callback, rather than simply
 * the synchronous return value.
 *
 * This also means you can asyncify ES2017 `async` functions.
 *
 * @name asyncify
 * @static
 * @memberOf module:Utils
 * @method
 * @alias wrapSync
 * @category Util
 * @param {Function} func - The synchronous function, or Promise-returning
 * function to convert to an {@link AsyncFunction}.
 * @returns {AsyncFunction} An asynchronous wrapper of the `func`. To be
 * invoked with `(args..., callback)`.
 * @example
 *
 * // passing a regular synchronous function
 * async.waterfall([
 *     async.apply(fs.readFile, filename, "utf8"),
 *     async.asyncify(JSON.parse),
 *     function (data, next) {
 *         // data is the result of parsing the text.
 *         // If there was a parsing error, it would have been caught.
 *     }
 * ], callback);
 *
 * // passing a function returning a promise
 * async.waterfall([
 *     async.apply(fs.readFile, filename, "utf8"),
 *     async.asyncify(function (contents) {
 *         return db.model.create(contents);
 *     }),
 *     function (model, next) {
 *         // `model` is the instantiated model object.
 *         // If there was an error, this function would be skipped.
 *     }
 * ], callback);
 *
 * // es2017 example, though `asyncify` is not needed if your JS environment
 * // supports async functions out of the box
 * var q = async.queue(async.asyncify(async function(file) {
 *     var intermediateStep = await processFile(file);
 *     return await somePromise(intermediateStep)
 * }));
 *
 * q.push(files);
 */
function asyncify(func) {
    if ((0, _wrapAsync.isAsync)(func)) {
        return function (...args /*, callback*/) {
            const callback = args.pop();
            const promise = func.apply(this, args);
            return handlePromise(promise, callback);
        };
    }

    return (0, _initialParams2.default)(function (args, callback) {
        var result;
        try {
            result = func.apply(this, args);
        } catch (e) {
            return callback(e);
        }
        // if result is Promise object
        if (result && typeof result.then === 'function') {
            return handlePromise(result, callback);
        } else {
            callback(null, result);
        }
    });
}

function handlePromise(promise, callback) {
    return promise.then(value => {
        invokeCallback(callback, null, value);
    }, err => {
        invokeCallback(callback, err && (err instanceof Error || err.message) ? err : new Error(err));
    });
}

function invokeCallback(callback, error, value) {
    try {
        callback(error, value);
    } catch (err) {
        (0, _setImmediate2.default)(e => {
            throw e;
        }, err);
    }
}
module.exports = exports.default;

/***/ }),

/***/ 71846:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));

var _isArrayLike = __webpack_require__(95616);

var _isArrayLike2 = _interopRequireDefault(_isArrayLike);

var _breakLoop = __webpack_require__(1605);

var _breakLoop2 = _interopRequireDefault(_breakLoop);

var _eachOfLimit = __webpack_require__(97388);

var _eachOfLimit2 = _interopRequireDefault(_eachOfLimit);

var _once = __webpack_require__(46979);

var _once2 = _interopRequireDefault(_once);

var _onlyOnce = __webpack_require__(13362);

var _onlyOnce2 = _interopRequireDefault(_onlyOnce);

var _wrapAsync = __webpack_require__(28993);

var _wrapAsync2 = _interopRequireDefault(_wrapAsync);

var _awaitify = __webpack_require__(2795);

var _awaitify2 = _interopRequireDefault(_awaitify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eachOf implementation optimized for array-likes
function eachOfArrayLike(coll, iteratee, callback) {
    callback = (0, _once2.default)(callback);
    var index = 0,
        completed = 0,
        { length } = coll,
        canceled = false;
    if (length === 0) {
        callback(null);
    }

    function iteratorCallback(err, value) {
        if (err === false) {
            canceled = true;
        }
        if (canceled === true) return;
        if (err) {
            callback(err);
        } else if (++completed === length || value === _breakLoop2.default) {
            callback(null);
        }
    }

    for (; index < length; index++) {
        iteratee(coll[index], index, (0, _onlyOnce2.default)(iteratorCallback));
    }
}

// a generic version of eachOf which can handle array, object, and iterator cases.
function eachOfGeneric(coll, iteratee, callback) {
    return (0, _eachOfLimit2.default)(coll, Infinity, iteratee, callback);
}

/**
 * Like [`each`]{@link module:Collections.each}, except that it passes the key (or index) as the second argument
 * to the iteratee.
 *
 * @name eachOf
 * @static
 * @memberOf module:Collections
 * @method
 * @alias forEachOf
 * @category Collection
 * @see [async.each]{@link module:Collections.each}
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A function to apply to each
 * item in `coll`.
 * The `key` is the item's key, or index in the case of an array.
 * Invoked with (item, key, callback).
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 * @returns {Promise} a promise, if a callback is omitted
 * @example
 *
 * // dev.json is a file containing a valid json object config for dev environment
 * // dev.json is a file containing a valid json object config for test environment
 * // prod.json is a file containing a valid json object config for prod environment
 * // invalid.json is a file with a malformed json object
 *
 * let configs = {}; //global variable
 * let validConfigFileMap = {dev: 'dev.json', test: 'test.json', prod: 'prod.json'};
 * let invalidConfigFileMap = {dev: 'dev.json', test: 'test.json', invalid: 'invalid.json'};
 *
 * // asynchronous function that reads a json file and parses the contents as json object
 * function parseFile(file, key, callback) {
 *     fs.readFile(file, "utf8", function(err, data) {
 *         if (err) return calback(err);
 *         try {
 *             configs[key] = JSON.parse(data);
 *         } catch (e) {
 *             return callback(e);
 *         }
 *         callback();
 *     });
 * }
 *
 * // Using callbacks
 * async.forEachOf(validConfigFileMap, parseFile, function (err) {
 *     if (err) {
 *         console.error(err);
 *     } else {
 *         console.log(configs);
 *         // configs is now a map of JSON data, e.g.
 *         // { dev: //parsed dev.json, test: //parsed test.json, prod: //parsed prod.json}
 *     }
 * });
 *
 * //Error handing
 * async.forEachOf(invalidConfigFileMap, parseFile, function (err) {
 *     if (err) {
 *         console.error(err);
 *         // JSON parse error exception
 *     } else {
 *         console.log(configs);
 *     }
 * });
 *
 * // Using Promises
 * async.forEachOf(validConfigFileMap, parseFile)
 * .then( () => {
 *     console.log(configs);
 *     // configs is now a map of JSON data, e.g.
 *     // { dev: //parsed dev.json, test: //parsed test.json, prod: //parsed prod.json}
 * }).catch( err => {
 *     console.error(err);
 * });
 *
 * //Error handing
 * async.forEachOf(invalidConfigFileMap, parseFile)
 * .then( () => {
 *     console.log(configs);
 * }).catch( err => {
 *     console.error(err);
 *     // JSON parse error exception
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         let result = await async.forEachOf(validConfigFileMap, parseFile);
 *         console.log(configs);
 *         // configs is now a map of JSON data, e.g.
 *         // { dev: //parsed dev.json, test: //parsed test.json, prod: //parsed prod.json}
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 * //Error handing
 * async () => {
 *     try {
 *         let result = await async.forEachOf(invalidConfigFileMap, parseFile);
 *         console.log(configs);
 *     }
 *     catch (err) {
 *         console.log(err);
 *         // JSON parse error exception
 *     }
 * }
 *
 */
function eachOf(coll, iteratee, callback) {
    var eachOfImplementation = (0, _isArrayLike2.default)(coll) ? eachOfArrayLike : eachOfGeneric;
    return eachOfImplementation(coll, (0, _wrapAsync2.default)(iteratee), callback);
}

exports["default"] = (0, _awaitify2.default)(eachOf, 3);
module.exports = exports.default;

/***/ }),

/***/ 97388:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));

var _eachOfLimit2 = __webpack_require__(56954);

var _eachOfLimit3 = _interopRequireDefault(_eachOfLimit2);

var _wrapAsync = __webpack_require__(28993);

var _wrapAsync2 = _interopRequireDefault(_wrapAsync);

var _awaitify = __webpack_require__(2795);

var _awaitify2 = _interopRequireDefault(_awaitify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The same as [`eachOf`]{@link module:Collections.eachOf} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name eachOfLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.eachOf]{@link module:Collections.eachOf}
 * @alias forEachOfLimit
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async function to apply to each
 * item in `coll`. The `key` is the item's key, or index in the case of an
 * array.
 * Invoked with (item, key, callback).
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 * @returns {Promise} a promise, if a callback is omitted
 */
function eachOfLimit(coll, limit, iteratee, callback) {
    return (0, _eachOfLimit3.default)(limit)(coll, (0, _wrapAsync2.default)(iteratee), callback);
}

exports["default"] = (0, _awaitify2.default)(eachOfLimit, 4);
module.exports = exports.default;

/***/ }),

/***/ 20667:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));

var _eachOfLimit = __webpack_require__(97388);

var _eachOfLimit2 = _interopRequireDefault(_eachOfLimit);

var _awaitify = __webpack_require__(2795);

var _awaitify2 = _interopRequireDefault(_awaitify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The same as [`eachOf`]{@link module:Collections.eachOf} but runs only a single async operation at a time.
 *
 * @name eachOfSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.eachOf]{@link module:Collections.eachOf}
 * @alias forEachOfSeries
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * Invoked with (item, key, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Invoked with (err).
 * @returns {Promise} a promise, if a callback is omitted
 */
function eachOfSeries(coll, iteratee, callback) {
    return (0, _eachOfLimit2.default)(coll, 1, iteratee, callback);
}
exports["default"] = (0, _awaitify2.default)(eachOfSeries, 3);
module.exports = exports.default;

/***/ }),

/***/ 78058:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));

var _eachOf = __webpack_require__(71846);

var _eachOf2 = _interopRequireDefault(_eachOf);

var _withoutIndex = __webpack_require__(41562);

var _withoutIndex2 = _interopRequireDefault(_withoutIndex);

var _wrapAsync = __webpack_require__(28993);

var _wrapAsync2 = _interopRequireDefault(_wrapAsync);

var _awaitify = __webpack_require__(2795);

var _awaitify2 = _interopRequireDefault(_awaitify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Applies the function `iteratee` to each item in `coll`, in parallel.
 * The `iteratee` is called with an item from the list, and a callback for when
 * it has finished. If the `iteratee` passes an error to its `callback`, the
 * main `callback` (for the `each` function) is immediately called with the
 * error.
 *
 * Note, that since this function applies `iteratee` to each item in parallel,
 * there is no guarantee that the iteratee functions will complete in order.
 *
 * @name each
 * @static
 * @memberOf module:Collections
 * @method
 * @alias forEach
 * @category Collection
 * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to
 * each item in `coll`. Invoked with (item, callback).
 * The array index is not passed to the iteratee.
 * If you need the index, use `eachOf`.
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 * @returns {Promise} a promise, if a callback is omitted
 * @example
 *
 * // dir1 is a directory that contains file1.txt, file2.txt
 * // dir2 is a directory that contains file3.txt, file4.txt
 * // dir3 is a directory that contains file5.txt
 * // dir4 does not exist
 *
 * const fileList = [ 'dir1/file2.txt', 'dir2/file3.txt', 'dir/file5.txt'];
 * const withMissingFileList = ['dir1/file1.txt', 'dir4/file2.txt'];
 *
 * // asynchronous function that deletes a file
 * const deleteFile = function(file, callback) {
 *     fs.unlink(file, callback);
 * };
 *
 * // Using callbacks
 * async.each(fileList, deleteFile, function(err) {
 *     if( err ) {
 *         console.log(err);
 *     } else {
 *         console.log('All files have been deleted successfully');
 *     }
 * });
 *
 * // Error Handling
 * async.each(withMissingFileList, deleteFile, function(err){
 *     console.log(err);
 *     // [ Error: ENOENT: no such file or directory ]
 *     // since dir4/file2.txt does not exist
 *     // dir1/file1.txt could have been deleted
 * });
 *
 * // Using Promises
 * async.each(fileList, deleteFile)
 * .then( () => {
 *     console.log('All files have been deleted successfully');
 * }).catch( err => {
 *     console.log(err);
 * });
 *
 * // Error Handling
 * async.each(fileList, deleteFile)
 * .then( () => {
 *     console.log('All files have been deleted successfully');
 * }).catch( err => {
 *     console.log(err);
 *     // [ Error: ENOENT: no such file or directory ]
 *     // since dir4/file2.txt does not exist
 *     // dir1/file1.txt could have been deleted
 * });
 *
 * // Using async/await
 * async () => {
 *     try {
 *         await async.each(files, deleteFile);
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 * // Error Handling
 * async () => {
 *     try {
 *         await async.each(withMissingFileList, deleteFile);
 *     }
 *     catch (err) {
 *         console.log(err);
 *         // [ Error: ENOENT: no such file or directory ]
 *         // since dir4/file2.txt does not exist
 *         // dir1/file1.txt could have been deleted
 *     }
 * }
 *
 */
function eachLimit(coll, iteratee, callback) {
    return (0, _eachOf2.default)(coll, (0, _withoutIndex2.default)((0, _wrapAsync2.default)(iteratee)), callback);
}

exports["default"] = (0, _awaitify2.default)(eachLimit, 3);
module.exports = exports.default;

/***/ }),

/***/ 58617:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = asyncEachOfLimit;

var _breakLoop = __webpack_require__(1605);

var _breakLoop2 = _interopRequireDefault(_breakLoop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// for async generators
function asyncEachOfLimit(generator, limit, iteratee, callback) {
    let done = false;
    let canceled = false;
    let awaiting = false;
    let running = 0;
    let idx = 0;

    function replenish() {
        //console.log('replenish')
        if (running >= limit || awaiting || done) return;
        //console.log('replenish awaiting')
        awaiting = true;
        generator.next().then(({ value, done: iterDone }) => {
            //console.log('got value', value)
            if (canceled || done) return;
            awaiting = false;
            if (iterDone) {
                done = true;
                if (running <= 0) {
                    //console.log('done nextCb')
                    callback(null);
                }
                return;
            }
            running++;
            iteratee(value, idx, iterateeCallback);
            idx++;
            replenish();
        }).catch(handleError);
    }

    function iterateeCallback(err, result) {
        //console.log('iterateeCallback')
        running -= 1;
        if (canceled) return;
        if (err) return handleError(err);

        if (err === false) {
            done = true;
            canceled = true;
            return;
        }

        if (result === _breakLoop2.default || done && running <= 0) {
            done = true;
            //console.log('done iterCb')
            return callback(null);
        }
        replenish();
    }

    function handleError(err) {
        if (canceled) return;
        awaiting = false;
        done = true;
        callback(err);
    }

    replenish();
}
module.exports = exports.default;

/***/ }),

/***/ 2795:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = awaitify;
// conditionally promisify a function.
// only return a promise if a callback is omitted
function awaitify(asyncFn, arity) {
    if (!arity) arity = asyncFn.length;
    if (!arity) throw new Error('arity is undefined');
    function awaitable(...args) {
        if (typeof args[arity - 1] === 'function') {
            return asyncFn.apply(this, args);
        }

        return new Promise((resolve, reject) => {
            args[arity - 1] = (err, ...cbArgs) => {
                if (err) return reject(err);
                resolve(cbArgs.length > 1 ? cbArgs : cbArgs[0]);
            };
            asyncFn.apply(this, args);
        });
    }

    return awaitable;
}
module.exports = exports.default;

/***/ }),

/***/ 1605:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
// A temporary value used to identify if the loop should be broken.
// See #1064, #1293
const breakLoop = {};
exports["default"] = breakLoop;
module.exports = exports.default;

/***/ }),

/***/ 56954:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));

var _once = __webpack_require__(46979);

var _once2 = _interopRequireDefault(_once);

var _iterator = __webpack_require__(9733);

var _iterator2 = _interopRequireDefault(_iterator);

var _onlyOnce = __webpack_require__(13362);

var _onlyOnce2 = _interopRequireDefault(_onlyOnce);

var _wrapAsync = __webpack_require__(28993);

var _asyncEachOfLimit = __webpack_require__(58617);

var _asyncEachOfLimit2 = _interopRequireDefault(_asyncEachOfLimit);

var _breakLoop = __webpack_require__(1605);

var _breakLoop2 = _interopRequireDefault(_breakLoop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = limit => {
    return (obj, iteratee, callback) => {
        callback = (0, _once2.default)(callback);
        if (limit <= 0) {
            throw new RangeError('concurrency limit cannot be less than 1');
        }
        if (!obj) {
            return callback(null);
        }
        if ((0, _wrapAsync.isAsyncGenerator)(obj)) {
            return (0, _asyncEachOfLimit2.default)(obj, limit, iteratee, callback);
        }
        if ((0, _wrapAsync.isAsyncIterable)(obj)) {
            return (0, _asyncEachOfLimit2.default)(obj[Symbol.asyncIterator](), limit, iteratee, callback);
        }
        var nextElem = (0, _iterator2.default)(obj);
        var done = false;
        var canceled = false;
        var running = 0;
        var looping = false;

        function iterateeCallback(err, value) {
            if (canceled) return;
            running -= 1;
            if (err) {
                done = true;
                callback(err);
            } else if (err === false) {
                done = true;
                canceled = true;
            } else if (value === _breakLoop2.default || done && running <= 0) {
                done = true;
                return callback(null);
            } else if (!looping) {
                replenish();
            }
        }

        function replenish() {
            looping = true;
            while (running < limit && !done) {
                var elem = nextElem();
                if (elem === null) {
                    done = true;
                    if (running <= 0) {
                        callback(null);
                    }
                    return;
                }
                running += 1;
                iteratee(elem.value, elem.key, (0, _onlyOnce2.default)(iterateeCallback));
            }
            looping = false;
        }

        replenish();
    };
};

module.exports = exports.default;

/***/ }),

/***/ 37818:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));

exports["default"] = function (coll) {
    return coll[Symbol.iterator] && coll[Symbol.iterator]();
};

module.exports = exports.default;

/***/ }),

/***/ 43519:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));

exports["default"] = function (fn) {
    return function (...args /*, callback*/) {
        var callback = args.pop();
        return fn.call(this, args, callback);
    };
};

module.exports = exports.default;

/***/ }),

/***/ 95616:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = isArrayLike;
function isArrayLike(value) {
    return value && typeof value.length === 'number' && value.length >= 0 && value.length % 1 === 0;
}
module.exports = exports.default;

/***/ }),

/***/ 9733:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = createIterator;

var _isArrayLike = __webpack_require__(95616);

var _isArrayLike2 = _interopRequireDefault(_isArrayLike);

var _getIterator = __webpack_require__(37818);

var _getIterator2 = _interopRequireDefault(_getIterator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createArrayIterator(coll) {
    var i = -1;
    var len = coll.length;
    return function next() {
        return ++i < len ? { value: coll[i], key: i } : null;
    };
}

function createES2015Iterator(iterator) {
    var i = -1;
    return function next() {
        var item = iterator.next();
        if (item.done) return null;
        i++;
        return { value: item.value, key: i };
    };
}

function createObjectIterator(obj) {
    var okeys = obj ? Object.keys(obj) : [];
    var i = -1;
    var len = okeys.length;
    return function next() {
        var key = okeys[++i];
        if (key === '__proto__') {
            return next();
        }
        return i < len ? { value: obj[key], key } : null;
    };
}

function createIterator(coll) {
    if ((0, _isArrayLike2.default)(coll)) {
        return createArrayIterator(coll);
    }

    var iterator = (0, _getIterator2.default)(coll);
    return iterator ? createES2015Iterator(iterator) : createObjectIterator(coll);
}
module.exports = exports.default;

/***/ }),

/***/ 46979:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = once;
function once(fn) {
    function wrapper(...args) {
        if (fn === null) return;
        var callFn = fn;
        fn = null;
        callFn.apply(this, args);
    }
    Object.assign(wrapper, fn);
    return wrapper;
}
module.exports = exports.default;

/***/ }),

/***/ 13362:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = onlyOnce;
function onlyOnce(fn) {
    return function (...args) {
        if (fn === null) throw new Error("Callback was already called.");
        var callFn = fn;
        fn = null;
        callFn.apply(this, args);
    };
}
module.exports = exports.default;

/***/ }),

/***/ 73409:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));

var _isArrayLike = __webpack_require__(95616);

var _isArrayLike2 = _interopRequireDefault(_isArrayLike);

var _wrapAsync = __webpack_require__(28993);

var _wrapAsync2 = _interopRequireDefault(_wrapAsync);

var _awaitify = __webpack_require__(2795);

var _awaitify2 = _interopRequireDefault(_awaitify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = (0, _awaitify2.default)((eachfn, tasks, callback) => {
    var results = (0, _isArrayLike2.default)(tasks) ? [] : {};

    eachfn(tasks, (task, key, taskCb) => {
        (0, _wrapAsync2.default)(task)((err, ...result) => {
            if (result.length < 2) {
                [result] = result;
            }
            results[key] = result;
            taskCb(err);
        });
    }, err => callback(err, results));
}, 3);
module.exports = exports.default;

/***/ }),

/***/ 3111:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.fallback = fallback;
exports.wrap = wrap;
/* istanbul ignore file */

var hasQueueMicrotask = exports.hasQueueMicrotask = typeof queueMicrotask === 'function' && queueMicrotask;
var hasSetImmediate = exports.hasSetImmediate = typeof setImmediate === 'function' && setImmediate;
var hasNextTick = exports.hasNextTick = typeof process === 'object' && typeof process.nextTick === 'function';

function fallback(fn) {
    setTimeout(fn, 0);
}

function wrap(defer) {
    return (fn, ...args) => defer(() => fn(...args));
}

var _defer;

if (hasQueueMicrotask) {
    _defer = queueMicrotask;
} else if (hasSetImmediate) {
    _defer = setImmediate;
} else if (hasNextTick) {
    _defer = process.nextTick;
} else {
    _defer = fallback;
}

exports["default"] = wrap(_defer);

/***/ }),

/***/ 41562:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = _withoutIndex;
function _withoutIndex(iteratee) {
    return (value, index, callback) => iteratee(value, callback);
}
module.exports = exports.default;

/***/ }),

/***/ 28993:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.isAsyncIterable = exports.isAsyncGenerator = exports.isAsync = undefined;

var _asyncify = __webpack_require__(44409);

var _asyncify2 = _interopRequireDefault(_asyncify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isAsync(fn) {
    return fn[Symbol.toStringTag] === 'AsyncFunction';
}

function isAsyncGenerator(fn) {
    return fn[Symbol.toStringTag] === 'AsyncGenerator';
}

function isAsyncIterable(obj) {
    return typeof obj[Symbol.asyncIterator] === 'function';
}

function wrapAsync(asyncFn) {
    if (typeof asyncFn !== 'function') throw new Error('expected a function');
    return isAsync(asyncFn) ? (0, _asyncify2.default)(asyncFn) : asyncFn;
}

exports["default"] = wrapAsync;
exports.isAsync = isAsync;
exports.isAsyncGenerator = isAsyncGenerator;
exports.isAsyncIterable = isAsyncIterable;

/***/ }),

/***/ 48415:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = series;

var _parallel2 = __webpack_require__(73409);

var _parallel3 = _interopRequireDefault(_parallel2);

var _eachOfSeries = __webpack_require__(20667);

var _eachOfSeries2 = _interopRequireDefault(_eachOfSeries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Run the functions in the `tasks` collection in series, each one running once
 * the previous function has completed. If any functions in the series pass an
 * error to its callback, no more functions are run, and `callback` is
 * immediately called with the value of the error. Otherwise, `callback`
 * receives an array of results when `tasks` have completed.
 *
 * It is also possible to use an object instead of an array. Each property will
 * be run as a function, and the results will be passed to the final `callback`
 * as an object instead of an array. This can be a more readable way of handling
 *  results from {@link async.series}.
 *
 * **Note** that while many implementations preserve the order of object
 * properties, the [ECMAScript Language Specification](http://www.ecma-international.org/ecma-262/5.1/#sec-8.6)
 * explicitly states that
 *
 * > The mechanics and order of enumerating the properties is not specified.
 *
 * So if you rely on the order in which your series of functions are executed,
 * and want this to work on all platforms, consider using an array.
 *
 * @name series
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array|Iterable|AsyncIterable|Object} tasks - A collection containing
 * [async functions]{@link AsyncFunction} to run in series.
 * Each function can complete with any number of optional `result` values.
 * @param {Function} [callback] - An optional callback to run once all the
 * functions have completed. This function gets a results array (or object)
 * containing all the result arguments passed to the `task` callbacks. Invoked
 * with (err, result).
 * @return {Promise} a promise, if no callback is passed
 * @example
 *
 * //Using Callbacks
 * async.series([
 *     function(callback) {
 *         setTimeout(function() {
 *             // do some async task
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     function(callback) {
 *         setTimeout(function() {
 *             // then do another async task
 *             callback(null, 'two');
 *         }, 100);
 *     }
 * ], function(err, results) {
 *     console.log(results);
 *     // results is equal to ['one','two']
 * });
 *
 * // an example using objects instead of arrays
 * async.series({
 *     one: function(callback) {
 *         setTimeout(function() {
 *             // do some async task
 *             callback(null, 1);
 *         }, 200);
 *     },
 *     two: function(callback) {
 *         setTimeout(function() {
 *             // then do another async task
 *             callback(null, 2);
 *         }, 100);
 *     }
 * }, function(err, results) {
 *     console.log(results);
 *     // results is equal to: { one: 1, two: 2 }
 * });
 *
 * //Using Promises
 * async.series([
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'two');
 *         }, 100);
 *     }
 * ]).then(results => {
 *     console.log(results);
 *     // results is equal to ['one','two']
 * }).catch(err => {
 *     console.log(err);
 * });
 *
 * // an example using an object instead of an array
 * async.series({
 *     one: function(callback) {
 *         setTimeout(function() {
 *             // do some async task
 *             callback(null, 1);
 *         }, 200);
 *     },
 *     two: function(callback) {
 *         setTimeout(function() {
 *             // then do another async task
 *             callback(null, 2);
 *         }, 100);
 *     }
 * }).then(results => {
 *     console.log(results);
 *     // results is equal to: { one: 1, two: 2 }
 * }).catch(err => {
 *     console.log(err);
 * });
 *
 * //Using async/await
 * async () => {
 *     try {
 *         let results = await async.series([
 *             function(callback) {
 *                 setTimeout(function() {
 *                     // do some async task
 *                     callback(null, 'one');
 *                 }, 200);
 *             },
 *             function(callback) {
 *                 setTimeout(function() {
 *                     // then do another async task
 *                     callback(null, 'two');
 *                 }, 100);
 *             }
 *         ]);
 *         console.log(results);
 *         // results is equal to ['one','two']
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 * // an example using an object instead of an array
 * async () => {
 *     try {
 *         let results = await async.parallel({
 *             one: function(callback) {
 *                 setTimeout(function() {
 *                     // do some async task
 *                     callback(null, 1);
 *                 }, 200);
 *             },
 *            two: function(callback) {
 *                 setTimeout(function() {
 *                     // then do another async task
 *                     callback(null, 2);
 *                 }, 100);
 *            }
 *         });
 *         console.log(results);
 *         // results is equal to: { one: 1, two: 2 }
 *     }
 *     catch (err) {
 *         console.log(err);
 *     }
 * }
 *
 */
function series(tasks, callback) {
    return (0, _parallel3.default)(_eachOfSeries2.default, tasks, callback);
}
module.exports = exports.default;

/***/ }),

/***/ 58363:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = true;

exports.Z = function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = (file.type || '').toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();

      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith('/*')) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
};

/***/ }),

/***/ 79742:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 48764:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(79742)
var ieee754 = __webpack_require__(80645)
var customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    var proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = (function () {
  var alphabet = '0123456789abcdef'
  var table = new Array(256)
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()


/***/ }),

/***/ 94184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 86010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export clsx */
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ __webpack_exports__["Z"] = (clsx);

/***/ }),

/***/ 76489:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(';')
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var index = pair.indexOf('=')

    // skip things that don't look like key=value
    if (index < 0) {
      continue;
    }

    var key = pair.substring(0, index).trim()

    // only assign once
    if (undefined == obj[key]) {
      var val = pair.substring(index + 1, pair.length).trim()

      // quoted values
      if (val[0] === '"') {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 78249:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else {}
}(this, function () {

	/*globals window, global, require*/

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {

	    var crypto;

	    // Native crypto from window (Browser)
	    if (typeof window !== 'undefined' && window.crypto) {
	        crypto = window.crypto;
	    }

	    // Native crypto in web worker (Browser)
	    if (typeof self !== 'undefined' && self.crypto) {
	        crypto = self.crypto;
	    }

	    // Native crypto from worker
	    if (typeof globalThis !== 'undefined' && globalThis.crypto) {
	        crypto = globalThis.crypto;
	    }

	    // Native (experimental IE 11) crypto from window (Browser)
	    if (!crypto && typeof window !== 'undefined' && window.msCrypto) {
	        crypto = window.msCrypto;
	    }

	    // Native crypto from global (NodeJS)
	    if (!crypto && typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.crypto) {
	        crypto = __webpack_require__.g.crypto;
	    }

	    // Native crypto import via require (NodeJS)
	    if (!crypto && "function" === 'function') {
	        try {
	            crypto = __webpack_require__(42480);
	        } catch (err) {}
	    }

	    /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */
	    var cryptoSecureRandomInt = function () {
	        if (crypto) {
	            // Use getRandomValues method (Browser)
	            if (typeof crypto.getRandomValues === 'function') {
	                try {
	                    return crypto.getRandomValues(new Uint32Array(1))[0];
	                } catch (err) {}
	            }

	            // Use randomBytes method (NodeJS)
	            if (typeof crypto.randomBytes === 'function') {
	                try {
	                    return crypto.randomBytes(4).readInt32LE();
	                } catch (err) {}
	            }
	        }

	        throw new Error('Native crypto module could not be used to get secure random number.');
	    };

	    /*
	     * Local polyfill of Object.create

	     */
	    var create = Object.create || (function () {
	        function F() {}

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }());

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var j = 0; j < thatSigBytes; j += 4) {
	                    thisWords[(thisSigBytes + j) >>> 2] = thatWords[j >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            for (var i = 0; i < nBytes; i += 4) {
	                words.push(cryptoSecureRandomInt());
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            var processedWords;

	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),

/***/ 52153:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249));
	}
	else {}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));

/***/ }),

/***/ 24262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getTimezoneOffsetInMilliseconds; }
/* harmony export */ });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/***/ }),

/***/ 13882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ requiredArgs; }
/* harmony export */ });
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/***/ }),

/***/ 93645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ getRoundingMethod; }
/* harmony export */ });
var roundingMap = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function trunc(value) {
    return value < 0 ? Math.ceil(value) : Math.floor(value);
  } // Math.trunc is not supported by IE
};

var defaultRoundingMethod = 'trunc';
function getRoundingMethod(method) {
  return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
}

/***/ }),

/***/ 83946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toInteger; }
/* harmony export */ });
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/***/ }),

/***/ 94533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ differenceInDays; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(24262);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfDay/index.js


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInCalendarDays/index.js



var MILLISECONDS_IN_DAY = 86400000;

/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - (0,getTimezoneOffsetInMilliseconds/* default */.Z)(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - (0,getTimezoneOffsetInMilliseconds/* default */.Z)(startOfDayRight);

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInDays/index.js


 // Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function compareLocalAsc(dateLeft, dateRight) {
  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}

/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full days according to the local timezone
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
//=> 92
 */
function differenceInDays(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  var sign = compareLocalAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight));
  dateLeft.setDate(dateLeft.getDate() - sign * difference);

  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
  var result = sign * (difference - isLastDayNotFull);
  // Prevent negative zero
  return result === 0 ? 0 : result;
}

/***/ }),

/***/ 59910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ differenceInMilliseconds; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */
function differenceInMilliseconds(dateLeft, dateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  return (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dateLeft).getTime() - (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dateRight).getTime();
}

/***/ }),

/***/ 11699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ differenceInSeconds; }
/* harmony export */ });
/* harmony import */ var _differenceInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59910);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _lib_roundingMethods_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93645);



/**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of seconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */
function differenceInSeconds(dateLeft, dateRight, options) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var diff = (0,_differenceInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dateLeft, dateRight) / 1000;
  return (0,_lib_roundingMethods_index_js__WEBPACK_IMPORTED_MODULE_2__/* .getRoundingMethod */ .u)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

/***/ }),

/***/ 46971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ format; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/isValid/index.js + 1 modules
var isValid = __webpack_require__(61436);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(83946);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/addMilliseconds/index.js



/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var timestamp = (0,toDate/* default */.Z)(dirtyDate).getTime();
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return new Date(timestamp + amount);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/subMilliseconds/index.js



/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js


var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js


function startOfUTCISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var weekStartsOn = 1;
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js



function getUTCISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js



function startOfUTCISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/defaultOptions/index.js
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js




function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,requiredArgs/* default */.Z)(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js





function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js





function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,requiredArgs/* default */.Z)(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js




var getUTCWeek_MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / getUTCWeek_MILLISECONDS_IN_WEEK) + 1;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/lightFormatters/index.js

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */
var formatters = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
/* harmony default export */ var lightFormatters = (formatters);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/formatters/index.js







var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters_formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return lightFormatters.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
/* harmony default export */ var format_formatters = (formatters_formatters);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
/* harmony default export */ var format_longFormatters = (longFormatters);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(24262);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};
/* harmony default export */ var _lib_formatDistance = (formatDistance);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var _lib_formatLong = (formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
/* harmony default export */ var _lib_formatRelative = (formatRelative);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var _lib_localize = (localize);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/match/index.js


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var _lib_match = (match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: _lib_formatDistance,
  formatLong: _lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ var en_US = (locale);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/defaultLocale/index.js

/* harmony default export */ var defaultLocale = (en_US);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/format/index.js










 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  (0,requiredArgs/* default */.Z)(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = getDefaultOptions();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale;
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = (0,toDate/* default */.Z)(dirtyDate);
  if (!(0,isValid/* default */.Z)(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = (0,getTimezoneOffsetInMilliseconds/* default */.Z)(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = format_longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = format_formatters[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),

/***/ 61436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ isValid; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isDate/index.js


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return value instanceof Date || (0,esm_typeof/* default */.Z)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isValid/index.js



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = (0,toDate/* default */.Z)(dirtyDate);
  return !isNaN(Number(date));
}

/***/ }),

/***/ 19013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toDate; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71002);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

/***/ }),

/***/ 35035:
/***/ (function(module) {

"use strict";


module.exports = function (data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = { cmp: opts };
    var cycles = (typeof opts.cycles === 'boolean') ? opts.cycles : false;

    var cmp = opts.cmp && (function (f) {
        return function (node) {
            return function (a, b) {
                var aobj = { key: a, value: node[a] };
                var bobj = { key: b, value: node[b] };
                return f(aobj, bobj);
            };
        };
    })(opts.cmp);

    var seen = [];
    return (function stringify (node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') {
            node = node.toJSON();
        }

        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);

        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for (i = 0; i < node.length; i++) {
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }

        if (node === null) return 'null';

        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }

        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for (i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = stringify(node[key]);

            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    })(data);
};


/***/ }),

/***/ 19432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "assign": function() { return /* binding */ assign; },
/* harmony export */   "defaultI18n": function() { return /* binding */ defaultI18n; },
/* harmony export */   "format": function() { return /* binding */ format; },
/* harmony export */   "parse": function() { return /* binding */ parse; },
/* harmony export */   "setGlobalDateI18n": function() { return /* binding */ setGlobalDateI18n; },
/* harmony export */   "setGlobalDateMasks": function() { return /* binding */ setGlobalDateMasks; }
/* harmony export */ });
var token = /d{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|ZZ|Z|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g;
var twoDigitsOptional = "\\d\\d?";
var twoDigits = "\\d\\d";
var threeDigits = "\\d{3}";
var fourDigits = "\\d{4}";
var word = "[^\\s]+";
var literal = /\[([^]*?)\]/gm;
function shorten(arr, sLen) {
    var newArr = [];
    for (var i = 0, len = arr.length; i < len; i++) {
        newArr.push(arr[i].substr(0, sLen));
    }
    return newArr;
}
var monthUpdate = function (arrName) { return function (v, i18n) {
    var lowerCaseArr = i18n[arrName].map(function (v) { return v.toLowerCase(); });
    var index = lowerCaseArr.indexOf(v.toLowerCase());
    if (index > -1) {
        return index;
    }
    return null;
}; };
function assign(origObj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
        var obj = args_1[_a];
        for (var key in obj) {
            // @ts-ignore ex
            origObj[key] = obj[key];
        }
    }
    return origObj;
}
var dayNames = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
var monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var monthNamesShort = shorten(monthNames, 3);
var dayNamesShort = shorten(dayNames, 3);
var defaultI18n = {
    dayNamesShort: dayNamesShort,
    dayNames: dayNames,
    monthNamesShort: monthNamesShort,
    monthNames: monthNames,
    amPm: ["am", "pm"],
    DoFn: function (dayOfMonth) {
        return (dayOfMonth +
            ["th", "st", "nd", "rd"][dayOfMonth % 10 > 3
                ? 0
                : ((dayOfMonth - (dayOfMonth % 10) !== 10 ? 1 : 0) * dayOfMonth) % 10]);
    }
};
var globalI18n = assign({}, defaultI18n);
var setGlobalDateI18n = function (i18n) {
    return (globalI18n = assign(globalI18n, i18n));
};
var regexEscape = function (str) {
    return str.replace(/[|\\{()[^$+*?.-]/g, "\\$&");
};
var pad = function (val, len) {
    if (len === void 0) { len = 2; }
    val = String(val);
    while (val.length < len) {
        val = "0" + val;
    }
    return val;
};
var formatFlags = {
    D: function (dateObj) { return String(dateObj.getDate()); },
    DD: function (dateObj) { return pad(dateObj.getDate()); },
    Do: function (dateObj, i18n) {
        return i18n.DoFn(dateObj.getDate());
    },
    d: function (dateObj) { return String(dateObj.getDay()); },
    dd: function (dateObj) { return pad(dateObj.getDay()); },
    ddd: function (dateObj, i18n) {
        return i18n.dayNamesShort[dateObj.getDay()];
    },
    dddd: function (dateObj, i18n) {
        return i18n.dayNames[dateObj.getDay()];
    },
    M: function (dateObj) { return String(dateObj.getMonth() + 1); },
    MM: function (dateObj) { return pad(dateObj.getMonth() + 1); },
    MMM: function (dateObj, i18n) {
        return i18n.monthNamesShort[dateObj.getMonth()];
    },
    MMMM: function (dateObj, i18n) {
        return i18n.monthNames[dateObj.getMonth()];
    },
    YY: function (dateObj) {
        return pad(String(dateObj.getFullYear()), 4).substr(2);
    },
    YYYY: function (dateObj) { return pad(dateObj.getFullYear(), 4); },
    h: function (dateObj) { return String(dateObj.getHours() % 12 || 12); },
    hh: function (dateObj) { return pad(dateObj.getHours() % 12 || 12); },
    H: function (dateObj) { return String(dateObj.getHours()); },
    HH: function (dateObj) { return pad(dateObj.getHours()); },
    m: function (dateObj) { return String(dateObj.getMinutes()); },
    mm: function (dateObj) { return pad(dateObj.getMinutes()); },
    s: function (dateObj) { return String(dateObj.getSeconds()); },
    ss: function (dateObj) { return pad(dateObj.getSeconds()); },
    S: function (dateObj) {
        return String(Math.round(dateObj.getMilliseconds() / 100));
    },
    SS: function (dateObj) {
        return pad(Math.round(dateObj.getMilliseconds() / 10), 2);
    },
    SSS: function (dateObj) { return pad(dateObj.getMilliseconds(), 3); },
    a: function (dateObj, i18n) {
        return dateObj.getHours() < 12 ? i18n.amPm[0] : i18n.amPm[1];
    },
    A: function (dateObj, i18n) {
        return dateObj.getHours() < 12
            ? i18n.amPm[0].toUpperCase()
            : i18n.amPm[1].toUpperCase();
    },
    ZZ: function (dateObj) {
        var offset = dateObj.getTimezoneOffset();
        return ((offset > 0 ? "-" : "+") +
            pad(Math.floor(Math.abs(offset) / 60) * 100 + (Math.abs(offset) % 60), 4));
    },
    Z: function (dateObj) {
        var offset = dateObj.getTimezoneOffset();
        return ((offset > 0 ? "-" : "+") +
            pad(Math.floor(Math.abs(offset) / 60), 2) +
            ":" +
            pad(Math.abs(offset) % 60, 2));
    }
};
var monthParse = function (v) { return +v - 1; };
var emptyDigits = [null, twoDigitsOptional];
var emptyWord = [null, word];
var amPm = [
    "isPm",
    word,
    function (v, i18n) {
        var val = v.toLowerCase();
        if (val === i18n.amPm[0]) {
            return 0;
        }
        else if (val === i18n.amPm[1]) {
            return 1;
        }
        return null;
    }
];
var timezoneOffset = [
    "timezoneOffset",
    "[^\\s]*?[\\+\\-]\\d\\d:?\\d\\d|[^\\s]*?Z?",
    function (v) {
        var parts = (v + "").match(/([+-]|\d\d)/gi);
        if (parts) {
            var minutes = +parts[1] * 60 + parseInt(parts[2], 10);
            return parts[0] === "+" ? minutes : -minutes;
        }
        return 0;
    }
];
var parseFlags = {
    D: ["day", twoDigitsOptional],
    DD: ["day", twoDigits],
    Do: ["day", twoDigitsOptional + word, function (v) { return parseInt(v, 10); }],
    M: ["month", twoDigitsOptional, monthParse],
    MM: ["month", twoDigits, monthParse],
    YY: [
        "year",
        twoDigits,
        function (v) {
            var now = new Date();
            var cent = +("" + now.getFullYear()).substr(0, 2);
            return +("" + (+v > 68 ? cent - 1 : cent) + v);
        }
    ],
    h: ["hour", twoDigitsOptional, undefined, "isPm"],
    hh: ["hour", twoDigits, undefined, "isPm"],
    H: ["hour", twoDigitsOptional],
    HH: ["hour", twoDigits],
    m: ["minute", twoDigitsOptional],
    mm: ["minute", twoDigits],
    s: ["second", twoDigitsOptional],
    ss: ["second", twoDigits],
    YYYY: ["year", fourDigits],
    S: ["millisecond", "\\d", function (v) { return +v * 100; }],
    SS: ["millisecond", twoDigits, function (v) { return +v * 10; }],
    SSS: ["millisecond", threeDigits],
    d: emptyDigits,
    dd: emptyDigits,
    ddd: emptyWord,
    dddd: emptyWord,
    MMM: ["month", word, monthUpdate("monthNamesShort")],
    MMMM: ["month", word, monthUpdate("monthNames")],
    a: amPm,
    A: amPm,
    ZZ: timezoneOffset,
    Z: timezoneOffset
};
// Some common format strings
var globalMasks = {
    default: "ddd MMM DD YYYY HH:mm:ss",
    shortDate: "M/D/YY",
    mediumDate: "MMM D, YYYY",
    longDate: "MMMM D, YYYY",
    fullDate: "dddd, MMMM D, YYYY",
    isoDate: "YYYY-MM-DD",
    isoDateTime: "YYYY-MM-DDTHH:mm:ssZ",
    shortTime: "HH:mm",
    mediumTime: "HH:mm:ss",
    longTime: "HH:mm:ss.SSS"
};
var setGlobalDateMasks = function (masks) { return assign(globalMasks, masks); };
/***
 * Format a date
 * @method format
 * @param {Date|number} dateObj
 * @param {string} mask Format of the date, i.e. 'mm-dd-yy' or 'shortDate'
 * @returns {string} Formatted date string
 */
var format = function (dateObj, mask, i18n) {
    if (mask === void 0) { mask = globalMasks["default"]; }
    if (i18n === void 0) { i18n = {}; }
    if (typeof dateObj === "number") {
        dateObj = new Date(dateObj);
    }
    if (Object.prototype.toString.call(dateObj) !== "[object Date]" ||
        isNaN(dateObj.getTime())) {
        throw new Error("Invalid Date pass to format");
    }
    mask = globalMasks[mask] || mask;
    var literals = [];
    // Make literals inactive by replacing them with @@@
    mask = mask.replace(literal, function ($0, $1) {
        literals.push($1);
        return "@@@";
    });
    var combinedI18nSettings = assign(assign({}, globalI18n), i18n);
    // Apply formatting rules
    mask = mask.replace(token, function ($0) {
        return formatFlags[$0](dateObj, combinedI18nSettings);
    });
    // Inline literal values back into the formatted value
    return mask.replace(/@@@/g, function () { return literals.shift(); });
};
/**
 * Parse a date string into a Javascript Date object /
 * @method parse
 * @param {string} dateStr Date string
 * @param {string} format Date parse format
 * @param {i18n} I18nSettingsOptional Full or subset of I18N settings
 * @returns {Date|null} Returns Date object. Returns null what date string is invalid or doesn't match format
 */
function parse(dateStr, format, i18n) {
    if (i18n === void 0) { i18n = {}; }
    if (typeof format !== "string") {
        throw new Error("Invalid format in fecha parse");
    }
    // Check to see if the format is actually a mask
    format = globalMasks[format] || format;
    // Avoid regular expression denial of service, fail early for really long strings
    // https://www.owasp.org/index.php/Regular_expression_Denial_of_Service_-_ReDoS
    if (dateStr.length > 1000) {
        return null;
    }
    // Default to the beginning of the year.
    var today = new Date();
    var dateInfo = {
        year: today.getFullYear(),
        month: 0,
        day: 1,
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
        isPm: null,
        timezoneOffset: null
    };
    var parseInfo = [];
    var literals = [];
    // Replace all the literals with @@@. Hopefully a string that won't exist in the format
    var newFormat = format.replace(literal, function ($0, $1) {
        literals.push(regexEscape($1));
        return "@@@";
    });
    var specifiedFields = {};
    var requiredFields = {};
    // Change every token that we find into the correct regex
    newFormat = regexEscape(newFormat).replace(token, function ($0) {
        var info = parseFlags[$0];
        var field = info[0], regex = info[1], requiredField = info[3];
        // Check if the person has specified the same field twice. This will lead to confusing results.
        if (specifiedFields[field]) {
            throw new Error("Invalid format. " + field + " specified twice in format");
        }
        specifiedFields[field] = true;
        // Check if there are any required fields. For instance, 12 hour time requires AM/PM specified
        if (requiredField) {
            requiredFields[requiredField] = true;
        }
        parseInfo.push(info);
        return "(" + regex + ")";
    });
    // Check all the required fields are present
    Object.keys(requiredFields).forEach(function (field) {
        if (!specifiedFields[field]) {
            throw new Error("Invalid format. " + field + " is required in specified format");
        }
    });
    // Add back all the literals after
    newFormat = newFormat.replace(/@@@/g, function () { return literals.shift(); });
    // Check if the date string matches the format. If it doesn't return null
    var matches = dateStr.match(new RegExp(newFormat, "i"));
    if (!matches) {
        return null;
    }
    var combinedI18nSettings = assign(assign({}, globalI18n), i18n);
    // For each match, call the parser function for that date part
    for (var i = 1; i < matches.length; i++) {
        var _a = parseInfo[i - 1], field = _a[0], parser = _a[2];
        var value = parser
            ? parser(matches[i], combinedI18nSettings)
            : +matches[i];
        // If the parser can't make sense of the value, return null
        if (value == null) {
            return null;
        }
        dateInfo[field] = value;
    }
    if (dateInfo.isPm === 1 && dateInfo.hour != null && +dateInfo.hour !== 12) {
        dateInfo.hour = +dateInfo.hour + 12;
    }
    else if (dateInfo.isPm === 0 && +dateInfo.hour === 12) {
        dateInfo.hour = 0;
    }
    var dateTZ;
    if (dateInfo.timezoneOffset == null) {
        dateTZ = new Date(dateInfo.year, dateInfo.month, dateInfo.day, dateInfo.hour, dateInfo.minute, dateInfo.second, dateInfo.millisecond);
        var validateFields = [
            ["month", "getMonth"],
            ["day", "getDate"],
            ["hour", "getHours"],
            ["minute", "getMinutes"],
            ["second", "getSeconds"]
        ];
        for (var i = 0, len = validateFields.length; i < len; i++) {
            // Check to make sure the date field is within the allowed range. Javascript dates allows values
            // outside the allowed range. If the values don't match the value was invalid
            if (specifiedFields[validateFields[i][0]] &&
                dateInfo[validateFields[i][0]] !== dateTZ[validateFields[i][1]]()) {
                return null;
            }
        }
    }
    else {
        dateTZ = new Date(Date.UTC(dateInfo.year, dateInfo.month, dateInfo.day, dateInfo.hour, dateInfo.minute - dateInfo.timezoneOffset, dateInfo.second, dateInfo.millisecond));
        // We can't validate dates in another timezone unfortunately. Do a basic check instead
        if (dateInfo.month > 11 ||
            dateInfo.month < 0 ||
            dateInfo.day > 31 ||
            dateInfo.day < 1 ||
            dateInfo.hour > 23 ||
            dateInfo.hour < 0 ||
            dateInfo.minute > 59 ||
            dateInfo.minute < 0 ||
            dateInfo.second > 59 ||
            dateInfo.second < 0) {
            return null;
        }
    }
    // Don't allow invalid dates
    return dateTZ;
}
var fecha = {
    format: format,
    parse: parse,
    defaultI18n: defaultI18n,
    setGlobalDateI18n: setGlobalDateI18n,
    setGlobalDateMasks: setGlobalDateMasks
};

/* harmony default export */ __webpack_exports__["default"] = (fecha);

//# sourceMappingURL=fecha.js.map


/***/ }),

/***/ 93162:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(a,b){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (b),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else {}})(this,function(){"use strict";function b(a,b){return"undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Deprecated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(a,b,c){var d=new XMLHttpRequest;d.open("GET",a),d.responseType="blob",d.onload=function(){g(d.response,b,c)},d.onerror=function(){console.error("could not download file")},d.send()}function d(a){var b=new XMLHttpRequest;b.open("HEAD",a,!1);try{b.send()}catch(a){}return 200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"))}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b)}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof __webpack_require__.g&&__webpack_require__.g.global===__webpack_require__.g?__webpack_require__.g:void 0,a=f.navigator&&/Macintosh/.test(navigator.userAgent)&&/AppleWebKit/.test(navigator.userAgent)&&!/Safari/.test(navigator.userAgent),g=f.saveAs||("object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype&&!a?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href)},4E4),setTimeout(function(){e(j)},0))}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else{var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i)})}}:function(b,d,e,g){if(g=g||open("","_blank"),g&&(g.document.title=g.document.body.innerText="downloading..."),"string"==typeof b)return c(b,d,e);var h="application/octet-stream"===b.type,i=/constructor/i.test(f.HTMLElement)||f.safari,j=/CriOS\/[\d]+/.test(navigator.userAgent);if((j||h&&i||a)&&"undefined"!=typeof FileReader){var k=new FileReader;k.onloadend=function(){var a=k.result;a=j?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),g?g.location.href=a:location=a,g=null},k.readAsDataURL(b)}else{var l=f.URL||f.webkitURL,m=l.createObjectURL(b);g?g.location=m:location.href=m,g=null,setTimeout(function(){l.revokeObjectURL(m)},4E4)}});f.saveAs=g.saveAs=g, true&&(module.exports=g)});

//# sourceMappingURL=FileSaver.min.js.map

/***/ }),

/***/ 32296:
/***/ (function(module) {

"use strict";


var toString = Object.prototype.toString;

/**
 * Extract names from functions.
 *
 * @param {Function} fn The function who's name we need to extract.
 * @returns {String} The name of the function.
 * @public
 */
module.exports = function name(fn) {
  if ('string' === typeof fn.displayName && fn.constructor.name) {
    return fn.displayName;
  } else if ('string' === typeof fn.name && fn.name) {
    return fn.name;
  }

  //
  // Check to see if the constructor has a name.
  //
  if (
       'object' === typeof fn
    && fn.constructor
    && 'string' === typeof fn.constructor.name
  ) return fn.constructor.name;

  //
  // toString the given function and attempt to parse it out of it, or determine
  // the class.
  //
  var named = fn.toString()
    , type = toString.call(fn).slice(8, -1);

  if ('Function' === type) {
    named = named.substring(named.indexOf('(') + 1, named.indexOf(')'));
  } else {
    named = type;
  }

  return named || 'anonymous';
};


/***/ }),

/***/ 4969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ lib; }
});

// UNUSED EXPORTS: disableExperimentalFragmentVariables, disableFragmentWarnings, enableExperimentalFragmentVariables, gql, resetCaches

;// CONCATENATED MODULE: ./node_modules/graphql-tag/node_modules/tslib/tslib.es6.mjs
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
  function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

/* harmony default export */ var tslib_es6 = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
});

;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/isObjectLike.mjs
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return _typeof(value) == 'object' && value !== null;
}

;// CONCATENATED MODULE: ./node_modules/graphql/polyfills/symbols.mjs
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var SYMBOL_ITERATOR = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')

var SYMBOL_ASYNC_ITERATOR = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')

var SYMBOL_TO_STRING_TAG = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';

;// CONCATENATED MODULE: ./node_modules/graphql/language/location.mjs
/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  var lineRegexp = /\r\n|[\n\r]/g;
  var line = 1;
  var column = position + 1;
  var match;

  while ((match = lineRegexp.exec(source.body)) && match.index < position) {
    line += 1;
    column = position + 1 - (match.index + match[0].length);
  }

  return {
    line: line,
    column: column
  };
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/printLocation.mjs

/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printLocation(location) {
  return printSourceLocation(location.source, getLocation(location.source, location.start));
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printSourceLocation(source, sourceLocation) {
  var firstLineColumnOffset = source.locationOffset.column - 1;
  var body = whitespace(firstLineColumnOffset) + source.body;
  var lineIndex = sourceLocation.line - 1;
  var lineOffset = source.locationOffset.line - 1;
  var lineNum = sourceLocation.line + lineOffset;
  var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  var columnNum = sourceLocation.column + columnOffset;
  var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
  var lines = body.split(/\r\n|[\n\r]/g);
  var locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    var subLineIndex = Math.floor(columnNum / 80);
    var subLineColumnNum = columnNum % 80;
    var subLines = [];

    for (var i = 0; i < locationLine.length; i += 80) {
      subLines.push(locationLine.slice(i, i + 80));
    }

    return locationStr + printPrefixedLines([["".concat(lineNum), subLines[0]]].concat(subLines.slice(1, subLineIndex + 1).map(function (subLine) {
      return ['', subLine];
    }), [[' ', whitespace(subLineColumnNum - 1) + '^'], ['', subLines[subLineIndex + 1]]]));
  }

  return locationStr + printPrefixedLines([// Lines specified like this: ["prefix", "string"],
  ["".concat(lineNum - 1), lines[lineIndex - 1]], ["".concat(lineNum), locationLine], ['', whitespace(columnNum - 1) + '^'], ["".concat(lineNum + 1), lines[lineIndex + 1]]]);
}

function printPrefixedLines(lines) {
  var existingLines = lines.filter(function (_ref) {
    var _ = _ref[0],
        line = _ref[1];
    return line !== undefined;
  });
  var padLen = Math.max.apply(Math, existingLines.map(function (_ref2) {
    var prefix = _ref2[0];
    return prefix.length;
  }));
  return existingLines.map(function (_ref3) {
    var prefix = _ref3[0],
        line = _ref3[1];
    return leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
  }).join('\n');
}

function whitespace(len) {
  return Array(len + 1).join(' ');
}

function leftPad(len, str) {
  return whitespace(len - str.length) + str;
}

;// CONCATENATED MODULE: ./node_modules/graphql/error/GraphQLError.mjs
function GraphQLError_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { GraphQLError_typeof = function _typeof(obj) { return typeof obj; }; } else { GraphQLError_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return GraphQLError_typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (GraphQLError_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }





/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */

var GraphQLError = /*#__PURE__*/function (_Error) {
  _inherits(GraphQLError, _Error);

  var _super = _createSuper(GraphQLError);

  /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */

  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */

  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */

  /**
   * The original error thrown from a field resolver during execution.
   */

  /**
   * Extension fields to add to the formatted error.
   */
  function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
    var _nodeLocations, _nodeLocations2, _nodeLocations3;

    var _this;

    _classCallCheck(this, GraphQLError);

    _this = _super.call(this, message);
    _this.name = 'GraphQLError';
    _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.

    _this.nodes = undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [nodes] : undefined);
    var nodeLocations = [];

    for (var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++) {
      var _this$nodes;

      var _ref4 = _ref3[_i2];
      var loc = _ref4.loc;

      if (loc != null) {
        nodeLocations.push(loc);
      }
    }

    nodeLocations = undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.

    _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
    _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function (loc) {
      return loc.start;
    });
    _this.locations = positions && source ? positions.map(function (pos) {
      return getLocation(source, pos);
    }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function (loc) {
      return getLocation(loc.source, loc.start);
    });
    _this.path = path !== null && path !== void 0 ? path : undefined;
    var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;

    if (extensions == null && isObjectLike(originalExtensions)) {
      _this.extensions = _objectSpread({}, originalExtensions);
    } else {
      _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
    } // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
    // This ensures that the simplest possible GraphQL service adheres to the spec.


    Object.defineProperties(_assertThisInitialized(_this), {
      message: {
        enumerable: true
      },
      locations: {
        enumerable: _this.locations != null
      },
      path: {
        enumerable: _this.path != null
      },
      extensions: {
        enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
      },
      name: {
        enumerable: false
      },
      nodes: {
        enumerable: false
      },
      source: {
        enumerable: false
      },
      positions: {
        enumerable: false
      },
      originalError: {
        enumerable: false
      }
    }); // Include (non-enumerable) stack trace.

    if (originalError !== null && originalError !== void 0 && originalError.stack) {
      Object.defineProperty(_assertThisInitialized(_this), 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true
      });
      return _possibleConstructorReturn(_this);
    } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')


    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), GraphQLError);
    } else {
      Object.defineProperty(_assertThisInitialized(_this), 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true
      });
    }

    return _this;
  }

  _createClass(GraphQLError, [{
    key: "toString",
    value: function toString() {
      return printError(this);
    } // FIXME: workaround to not break chai comparisons, should be remove in v16
    // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet

  }, {
    key: SYMBOL_TO_STRING_TAG,
    get: function get() {
      return 'Object';
    }
  }]);

  return GraphQLError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

function undefinedIfEmpty(array) {
  return array === undefined || array.length === 0 ? undefined : array;
}
/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */


function printError(error) {
  var output = error.message;

  if (error.nodes) {
    for (var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++) {
      var node = _error$nodes2[_i4];

      if (node.loc) {
        output += '\n\n' + printLocation(node.loc);
      }
    }
  } else if (error.source && error.locations) {
    for (var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++) {
      var location = _error$locations2[_i6];
      output += '\n\n' + printSourceLocation(error.source, location);
    }
  }

  return output;
}

;// CONCATENATED MODULE: ./node_modules/graphql/error/syntaxError.mjs

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */

function syntaxError(source, position, description) {
  return new GraphQLError("Syntax Error: ".concat(description), undefined, source, [position]);
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/kinds.mjs
/**
 * The set of allowed kind values for AST nodes.
 */
var Kind = Object.freeze({
  // Name
  NAME: 'Name',
  // Document
  DOCUMENT: 'Document',
  OPERATION_DEFINITION: 'OperationDefinition',
  VARIABLE_DEFINITION: 'VariableDefinition',
  SELECTION_SET: 'SelectionSet',
  FIELD: 'Field',
  ARGUMENT: 'Argument',
  // Fragments
  FRAGMENT_SPREAD: 'FragmentSpread',
  INLINE_FRAGMENT: 'InlineFragment',
  FRAGMENT_DEFINITION: 'FragmentDefinition',
  // Values
  VARIABLE: 'Variable',
  INT: 'IntValue',
  FLOAT: 'FloatValue',
  STRING: 'StringValue',
  BOOLEAN: 'BooleanValue',
  NULL: 'NullValue',
  ENUM: 'EnumValue',
  LIST: 'ListValue',
  OBJECT: 'ObjectValue',
  OBJECT_FIELD: 'ObjectField',
  // Directives
  DIRECTIVE: 'Directive',
  // Types
  NAMED_TYPE: 'NamedType',
  LIST_TYPE: 'ListType',
  NON_NULL_TYPE: 'NonNullType',
  // Type System Definitions
  SCHEMA_DEFINITION: 'SchemaDefinition',
  OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
  // Type Definitions
  SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
  OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
  FIELD_DEFINITION: 'FieldDefinition',
  INPUT_VALUE_DEFINITION: 'InputValueDefinition',
  INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
  UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
  ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
  ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
  INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
  // Directive Definitions
  DIRECTIVE_DEFINITION: 'DirectiveDefinition',
  // Type System Extensions
  SCHEMA_EXTENSION: 'SchemaExtension',
  // Type Extensions
  SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
  OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
  INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
  UNION_TYPE_EXTENSION: 'UnionTypeExtension',
  ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
  INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
});
/**
 * The enum type representing the possible kind values of AST nodes.
 */

// EXTERNAL MODULE: ./node_modules/graphql/language/ast.mjs + 2 modules
var ast = __webpack_require__(29749);
;// CONCATENATED MODULE: ./node_modules/graphql/language/tokenKind.mjs
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var tokenKind_TokenKind = Object.freeze({
  SOF: '<SOF>',
  EOF: '<EOF>',
  BANG: '!',
  DOLLAR: '$',
  AMP: '&',
  PAREN_L: '(',
  PAREN_R: ')',
  SPREAD: '...',
  COLON: ':',
  EQUALS: '=',
  AT: '@',
  BRACKET_L: '[',
  BRACKET_R: ']',
  BRACE_L: '{',
  PIPE: '|',
  BRACE_R: '}',
  NAME: 'Name',
  INT: 'Int',
  FLOAT: 'Float',
  STRING: 'String',
  BLOCK_STRING: 'BlockString',
  COMMENT: 'Comment'
});
/**
 * The enum type representing the token kinds values.
 */

// EXTERNAL MODULE: ./node_modules/graphql/jsutils/inspect.mjs
var inspect = __webpack_require__(25821);
;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/devAssert.mjs
function devAssert(condition, message) {
  var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')

  if (!booleanCondition) {
    throw new Error(message);
  }
}

;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/instanceOf.mjs
function instanceOf_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { instanceOf_typeof = function _typeof(obj) { return typeof obj; }; } else { instanceOf_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return instanceOf_typeof(obj); }


/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */

// See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
/* harmony default export */ var instanceOf = ( true ? // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
// eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
  return value instanceof constructor;
} : // eslint-disable-next-line no-shadow
0);

;// CONCATENATED MODULE: ./node_modules/graphql/language/source.mjs
function source_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function source_createClass(Constructor, protoProps, staticProps) { if (protoProps) source_defineProperties(Constructor.prototype, protoProps); if (staticProps) source_defineProperties(Constructor, staticProps); return Constructor; }






/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */
var Source = /*#__PURE__*/function () {
  function Source(body) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
    var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      line: 1,
      column: 1
    };
    typeof body === 'string' || devAssert(0, "Body must be a string. Received: ".concat((0,inspect/* default */.Z)(body), "."));
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 || devAssert(0, 'line in locationOffset is 1-indexed and must be positive.');
    this.locationOffset.column > 0 || devAssert(0, 'column in locationOffset is 1-indexed and must be positive.');
  } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet


  source_createClass(Source, [{
    key: SYMBOL_TO_STRING_TAG,
    get: function get() {
      return 'Source';
    }
  }]);

  return Source;
}();
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */

// eslint-disable-next-line no-redeclare
function isSource(source) {
  return instanceOf(source, Source);
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/directiveLocation.mjs
/**
 * The set of allowed directive location values.
 */
var DirectiveLocation = Object.freeze({
  // Request Definitions
  QUERY: 'QUERY',
  MUTATION: 'MUTATION',
  SUBSCRIPTION: 'SUBSCRIPTION',
  FIELD: 'FIELD',
  FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
  FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
  INLINE_FRAGMENT: 'INLINE_FRAGMENT',
  VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
  // Type System Definitions
  SCHEMA: 'SCHEMA',
  SCALAR: 'SCALAR',
  OBJECT: 'OBJECT',
  FIELD_DEFINITION: 'FIELD_DEFINITION',
  ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
  INTERFACE: 'INTERFACE',
  UNION: 'UNION',
  ENUM: 'ENUM',
  ENUM_VALUE: 'ENUM_VALUE',
  INPUT_OBJECT: 'INPUT_OBJECT',
  INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
});
/**
 * The enum type representing the directive location values.
 */

// EXTERNAL MODULE: ./node_modules/graphql/language/blockString.mjs
var blockString = __webpack_require__(87392);
;// CONCATENATED MODULE: ./node_modules/graphql/language/lexer.mjs




/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */

var Lexer = /*#__PURE__*/function () {
  /**
   * The previously focused non-ignored token.
   */

  /**
   * The currently focused non-ignored token.
   */

  /**
   * The (1-indexed) line containing the current token.
   */

  /**
   * The character offset at which the current line begins.
   */
  function Lexer(source) {
    var startOfFileToken = new ast/* Token */.WU(tokenKind_TokenKind.SOF, 0, 0, 0, 0, null);
    this.source = source;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */


  var _proto = Lexer.prototype;

  _proto.advance = function advance() {
    this.lastToken = this.token;
    var token = this.token = this.lookahead();
    return token;
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  ;

  _proto.lookahead = function lookahead() {
    var token = this.token;

    if (token.kind !== tokenKind_TokenKind.EOF) {
      do {
        var _token$next;

        // Note: next is only mutable during parsing, so we cast to allow this.
        token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = readToken(this, token);
      } while (token.kind === tokenKind_TokenKind.COMMENT);
    }

    return token;
  };

  return Lexer;
}();
/**
 * @internal
 */

function isPunctuatorTokenKind(kind) {
  return kind === tokenKind_TokenKind.BANG || kind === tokenKind_TokenKind.DOLLAR || kind === tokenKind_TokenKind.AMP || kind === tokenKind_TokenKind.PAREN_L || kind === tokenKind_TokenKind.PAREN_R || kind === tokenKind_TokenKind.SPREAD || kind === tokenKind_TokenKind.COLON || kind === tokenKind_TokenKind.EQUALS || kind === tokenKind_TokenKind.AT || kind === tokenKind_TokenKind.BRACKET_L || kind === tokenKind_TokenKind.BRACKET_R || kind === tokenKind_TokenKind.BRACE_L || kind === tokenKind_TokenKind.PIPE || kind === tokenKind_TokenKind.BRACE_R;
}

function printCharCode(code) {
  return (// NaN/undefined represents access beyond the end of the file.
    isNaN(code) ? tokenKind_TokenKind.EOF : // Trust JSON for ASCII.
    code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : // Otherwise print the escaped form.
    "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"")
  );
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */


function readToken(lexer, prev) {
  var source = lexer.source;
  var body = source.body;
  var bodyLength = body.length;
  var pos = prev.end;

  while (pos < bodyLength) {
    var code = body.charCodeAt(pos);
    var _line = lexer.line;

    var _col = 1 + pos - lexer.lineStart; // SourceCharacter


    switch (code) {
      case 0xfeff: // <BOM>

      case 9: //   \t

      case 32: //  <space>

      case 44:
        //  ,
        ++pos;
        continue;

      case 10:
        //  \n
        ++pos;
        ++lexer.line;
        lexer.lineStart = pos;
        continue;

      case 13:
        //  \r
        if (body.charCodeAt(pos + 1) === 10) {
          pos += 2;
        } else {
          ++pos;
        }

        ++lexer.line;
        lexer.lineStart = pos;
        continue;

      case 33:
        //  !
        return new ast/* Token */.WU(tokenKind_TokenKind.BANG, pos, pos + 1, _line, _col, prev);

      case 35:
        //  #
        return readComment(source, pos, _line, _col, prev);

      case 36:
        //  $
        return new ast/* Token */.WU(tokenKind_TokenKind.DOLLAR, pos, pos + 1, _line, _col, prev);

      case 38:
        //  &
        return new ast/* Token */.WU(tokenKind_TokenKind.AMP, pos, pos + 1, _line, _col, prev);

      case 40:
        //  (
        return new ast/* Token */.WU(tokenKind_TokenKind.PAREN_L, pos, pos + 1, _line, _col, prev);

      case 41:
        //  )
        return new ast/* Token */.WU(tokenKind_TokenKind.PAREN_R, pos, pos + 1, _line, _col, prev);

      case 46:
        //  .
        if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) {
          return new ast/* Token */.WU(tokenKind_TokenKind.SPREAD, pos, pos + 3, _line, _col, prev);
        }

        break;

      case 58:
        //  :
        return new ast/* Token */.WU(tokenKind_TokenKind.COLON, pos, pos + 1, _line, _col, prev);

      case 61:
        //  =
        return new ast/* Token */.WU(tokenKind_TokenKind.EQUALS, pos, pos + 1, _line, _col, prev);

      case 64:
        //  @
        return new ast/* Token */.WU(tokenKind_TokenKind.AT, pos, pos + 1, _line, _col, prev);

      case 91:
        //  [
        return new ast/* Token */.WU(tokenKind_TokenKind.BRACKET_L, pos, pos + 1, _line, _col, prev);

      case 93:
        //  ]
        return new ast/* Token */.WU(tokenKind_TokenKind.BRACKET_R, pos, pos + 1, _line, _col, prev);

      case 123:
        // {
        return new ast/* Token */.WU(tokenKind_TokenKind.BRACE_L, pos, pos + 1, _line, _col, prev);

      case 124:
        // |
        return new ast/* Token */.WU(tokenKind_TokenKind.PIPE, pos, pos + 1, _line, _col, prev);

      case 125:
        // }
        return new ast/* Token */.WU(tokenKind_TokenKind.BRACE_R, pos, pos + 1, _line, _col, prev);

      case 34:
        //  "
        if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) {
          return readBlockString(source, pos, _line, _col, prev, lexer);
        }

        return readString(source, pos, _line, _col, prev);

      case 45: //  -

      case 48: //  0

      case 49: //  1

      case 50: //  2

      case 51: //  3

      case 52: //  4

      case 53: //  5

      case 54: //  6

      case 55: //  7

      case 56: //  8

      case 57:
        //  9
        return readNumber(source, pos, code, _line, _col, prev);

      case 65: //  A

      case 66: //  B

      case 67: //  C

      case 68: //  D

      case 69: //  E

      case 70: //  F

      case 71: //  G

      case 72: //  H

      case 73: //  I

      case 74: //  J

      case 75: //  K

      case 76: //  L

      case 77: //  M

      case 78: //  N

      case 79: //  O

      case 80: //  P

      case 81: //  Q

      case 82: //  R

      case 83: //  S

      case 84: //  T

      case 85: //  U

      case 86: //  V

      case 87: //  W

      case 88: //  X

      case 89: //  Y

      case 90: //  Z

      case 95: //  _

      case 97: //  a

      case 98: //  b

      case 99: //  c

      case 100: // d

      case 101: // e

      case 102: // f

      case 103: // g

      case 104: // h

      case 105: // i

      case 106: // j

      case 107: // k

      case 108: // l

      case 109: // m

      case 110: // n

      case 111: // o

      case 112: // p

      case 113: // q

      case 114: // r

      case 115: // s

      case 116: // t

      case 117: // u

      case 118: // v

      case 119: // w

      case 120: // x

      case 121: // y

      case 122:
        // z
        return readName(source, pos, _line, _col, prev);
    }

    throw syntaxError(source, pos, unexpectedCharacterMessage(code));
  }

  var line = lexer.line;
  var col = 1 + pos - lexer.lineStart;
  return new ast/* Token */.WU(tokenKind_TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */


function unexpectedCharacterMessage(code) {
  if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
    return "Cannot contain the invalid character ".concat(printCharCode(code), ".");
  }

  if (code === 39) {
    // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
  }

  return "Cannot parse the unexpected character ".concat(printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */


function readComment(source, start, line, col, prev) {
  var body = source.body;
  var code;
  var position = start;

  do {
    code = body.charCodeAt(++position);
  } while (!isNaN(code) && ( // SourceCharacter but not LineTerminator
  code > 0x001f || code === 0x0009));

  return new ast/* Token */.WU(tokenKind_TokenKind.COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */


function readNumber(source, start, firstCode, line, col, prev) {
  var body = source.body;
  var code = firstCode;
  var position = start;
  var isFloat = false;

  if (code === 45) {
    // -
    code = body.charCodeAt(++position);
  }

  if (code === 48) {
    // 0
    code = body.charCodeAt(++position);

    if (code >= 48 && code <= 57) {
      throw syntaxError(source, position, "Invalid number, unexpected digit after 0: ".concat(printCharCode(code), "."));
    }
  } else {
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }

  if (code === 46) {
    // .
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }

  if (code === 69 || code === 101) {
    // E e
    isFloat = true;
    code = body.charCodeAt(++position);

    if (code === 43 || code === 45) {
      // + -
      code = body.charCodeAt(++position);
    }

    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or NameStart


  if (code === 46 || isNameStart(code)) {
    throw syntaxError(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
  }

  return new ast/* Token */.WU(isFloat ? tokenKind_TokenKind.FLOAT : tokenKind_TokenKind.INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */


function readDigits(source, start, firstCode) {
  var body = source.body;
  var position = start;
  var code = firstCode;

  if (code >= 48 && code <= 57) {
    // 0 - 9
    do {
      code = body.charCodeAt(++position);
    } while (code >= 48 && code <= 57); // 0 - 9


    return position;
  }

  throw syntaxError(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */


function readString(source, start, line, col, prev) {
  var body = source.body;
  var position = start + 1;
  var chunkStart = position;
  var code = 0;
  var value = '';

  while (position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
  code !== 0x000a && code !== 0x000d) {
    // Closing Quote (")
    if (code === 34) {
      value += body.slice(chunkStart, position);
      return new ast/* Token */.WU(tokenKind_TokenKind.STRING, start, position + 1, line, col, prev, value);
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009) {
      throw syntaxError(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    ++position;

    if (code === 92) {
      // \
      value += body.slice(chunkStart, position - 1);
      code = body.charCodeAt(position);

      switch (code) {
        case 34:
          value += '"';
          break;

        case 47:
          value += '/';
          break;

        case 92:
          value += '\\';
          break;

        case 98:
          value += '\b';
          break;

        case 102:
          value += '\f';
          break;

        case 110:
          value += '\n';
          break;

        case 114:
          value += '\r';
          break;

        case 116:
          value += '\t';
          break;

        case 117:
          {
            // uXXXX
            var charCode = uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));

            if (charCode < 0) {
              var invalidSequence = body.slice(position + 1, position + 5);
              throw syntaxError(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
            }

            value += String.fromCharCode(charCode);
            position += 4;
            break;
          }

        default:
          throw syntaxError(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
      }

      ++position;
      chunkStart = position;
    }
  }

  throw syntaxError(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */


function readBlockString(source, start, line, col, prev, lexer) {
  var body = source.body;
  var position = start + 3;
  var chunkStart = position;
  var code = 0;
  var rawValue = '';

  while (position < body.length && !isNaN(code = body.charCodeAt(position))) {
    // Closing Triple-Quote (""")
    if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
      rawValue += body.slice(chunkStart, position);
      return new ast/* Token */.WU(tokenKind_TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, (0,blockString/* dedentBlockStringValue */.W7)(rawValue));
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
      throw syntaxError(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    if (code === 10) {
      // new line
      ++position;
      ++lexer.line;
      lexer.lineStart = position;
    } else if (code === 13) {
      // carriage return
      if (body.charCodeAt(position + 1) === 10) {
        position += 2;
      } else {
        ++position;
      }

      ++lexer.line;
      lexer.lineStart = position;
    } else if ( // Escape Triple-Quote (\""")
    code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
      rawValue += body.slice(chunkStart, position) + '"""';
      position += 4;
      chunkStart = position;
    } else {
      ++position;
    }
  }

  throw syntaxError(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */


function uniCharCode(a, b, c, d) {
  return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */


function char2hex(a) {
  return a >= 48 && a <= 57 ? a - 48 // 0-9
  : a >= 65 && a <= 70 ? a - 55 // A-F
  : a >= 97 && a <= 102 ? a - 87 // a-f
  : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */


function readName(source, start, line, col, prev) {
  var body = source.body;
  var bodyLength = body.length;
  var position = start + 1;
  var code = 0;

  while (position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
  code >= 48 && code <= 57 || // 0-9
  code >= 65 && code <= 90 || // A-Z
  code >= 97 && code <= 122) // a-z
  ) {
    ++position;
  }

  return new ast/* Token */.WU(tokenKind_TokenKind.NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z


function isNameStart(code) {
  return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/parser.mjs







/**
 * Configuration options to control parser behavior
 */

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  var parser = new Parser(source, options);
  return parser.parseDocument();
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */

function parseValue(source, options) {
  var parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  var value = parser.parseValueLiteral(false);
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */

function parseType(source, options) {
  var parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  var type = parser.parseTypeReference();
  parser.expectToken(TokenKind.EOF);
  return type;
}
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */

var Parser = /*#__PURE__*/function () {
  function Parser(source, options) {
    var sourceObj = isSource(source) ? source : new Source(source);
    this._lexer = new Lexer(sourceObj);
    this._options = options;
  }
  /**
   * Converts a name lex token into a name parse node.
   */


  var _proto = Parser.prototype;

  _proto.parseName = function parseName() {
    var token = this.expectToken(tokenKind_TokenKind.NAME);
    return {
      kind: Kind.NAME,
      value: token.value,
      loc: this.loc(token)
    };
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */
  ;

  _proto.parseDocument = function parseDocument() {
    var start = this._lexer.token;
    return {
      kind: Kind.DOCUMENT,
      definitions: this.many(tokenKind_TokenKind.SOF, this.parseDefinition, tokenKind_TokenKind.EOF),
      loc: this.loc(start)
    };
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */
  ;

  _proto.parseDefinition = function parseDefinition() {
    if (this.peek(tokenKind_TokenKind.NAME)) {
      switch (this._lexer.token.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();

        case 'schema':
        case 'scalar':
        case 'type':
        case 'interface':
        case 'union':
        case 'enum':
        case 'input':
        case 'directive':
          return this.parseTypeSystemDefinition();

        case 'extend':
          return this.parseTypeSystemExtension();
      }
    } else if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } else if (this.peekDescription()) {
      return this.parseTypeSystemDefinition();
    }

    throw this.unexpected();
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  ;

  _proto.parseOperationDefinition = function parseOperationDefinition() {
    var start = this._lexer.token;

    if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return {
        kind: Kind.OPERATION_DEFINITION,
        operation: 'query',
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }

    var operation = this.parseOperationType();
    var name;

    if (this.peek(tokenKind_TokenKind.NAME)) {
      name = this.parseName();
    }

    return {
      kind: Kind.OPERATION_DEFINITION,
      operation: operation,
      name: name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * OperationType : one of query mutation subscription
   */
  ;

  _proto.parseOperationType = function parseOperationType() {
    var operationToken = this.expectToken(tokenKind_TokenKind.NAME);

    switch (operationToken.value) {
      case 'query':
        return 'query';

      case 'mutation':
        return 'mutation';

      case 'subscription':
        return 'subscription';
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  ;

  _proto.parseVariableDefinitions = function parseVariableDefinitions() {
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, this.parseVariableDefinition, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  ;

  _proto.parseVariableDefinition = function parseVariableDefinition() {
    var start = this._lexer.token;
    return {
      kind: Kind.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(tokenKind_TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(tokenKind_TokenKind.EQUALS) ? this.parseValueLiteral(true) : undefined,
      directives: this.parseDirectives(true),
      loc: this.loc(start)
    };
  }
  /**
   * Variable : $ Name
   */
  ;

  _proto.parseVariable = function parseVariable() {
    var start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.DOLLAR);
    return {
      kind: Kind.VARIABLE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  }
  /**
   * SelectionSet : { Selection+ }
   */
  ;

  _proto.parseSelectionSet = function parseSelectionSet() {
    var start = this._lexer.token;
    return {
      kind: Kind.SELECTION_SET,
      selections: this.many(tokenKind_TokenKind.BRACE_L, this.parseSelection, tokenKind_TokenKind.BRACE_R),
      loc: this.loc(start)
    };
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  ;

  _proto.parseSelection = function parseSelection() {
    return this.peek(tokenKind_TokenKind.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  ;

  _proto.parseField = function parseField() {
    var start = this._lexer.token;
    var nameOrAlias = this.parseName();
    var alias;
    var name;

    if (this.expectOptionalToken(tokenKind_TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return {
      kind: Kind.FIELD,
      alias: alias,
      name: name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(tokenKind_TokenKind.BRACE_L) ? this.parseSelectionSet() : undefined,
      loc: this.loc(start)
    };
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  ;

  _proto.parseArguments = function parseArguments(isConst) {
    var item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, item, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  ;

  _proto.parseArgument = function parseArgument() {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return {
      kind: Kind.ARGUMENT,
      name: name,
      value: this.parseValueLiteral(false),
      loc: this.loc(start)
    };
  };

  _proto.parseConstArgument = function parseConstArgument() {
    var start = this._lexer.token;
    return {
      kind: Kind.ARGUMENT,
      name: this.parseName(),
      value: (this.expectToken(tokenKind_TokenKind.COLON), this.parseValueLiteral(true)),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  ;

  _proto.parseFragment = function parseFragment() {
    var start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.SPREAD);
    var hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(tokenKind_TokenKind.NAME)) {
      return {
        kind: Kind.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
        loc: this.loc(start)
      };
    }

    return {
      kind: Kind.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  ;

  _proto.parseFragmentDefinition = function parseFragmentDefinition() {
    var _this$_options;

    var start = this._lexer.token;
    this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) {
      return {
        kind: Kind.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }

    return {
      kind: Kind.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * FragmentName : Name but not `on`
   */
  ;

  _proto.parseFragmentName = function parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  ;

  _proto.parseValueLiteral = function parseValueLiteral(isConst) {
    var token = this._lexer.token;

    switch (token.kind) {
      case tokenKind_TokenKind.BRACKET_L:
        return this.parseList(isConst);

      case tokenKind_TokenKind.BRACE_L:
        return this.parseObject(isConst);

      case tokenKind_TokenKind.INT:
        this._lexer.advance();

        return {
          kind: Kind.INT,
          value: token.value,
          loc: this.loc(token)
        };

      case tokenKind_TokenKind.FLOAT:
        this._lexer.advance();

        return {
          kind: Kind.FLOAT,
          value: token.value,
          loc: this.loc(token)
        };

      case tokenKind_TokenKind.STRING:
      case tokenKind_TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();

      case tokenKind_TokenKind.NAME:
        this._lexer.advance();

        switch (token.value) {
          case 'true':
            return {
              kind: Kind.BOOLEAN,
              value: true,
              loc: this.loc(token)
            };

          case 'false':
            return {
              kind: Kind.BOOLEAN,
              value: false,
              loc: this.loc(token)
            };

          case 'null':
            return {
              kind: Kind.NULL,
              loc: this.loc(token)
            };

          default:
            return {
              kind: Kind.ENUM,
              value: token.value,
              loc: this.loc(token)
            };
        }

      case tokenKind_TokenKind.DOLLAR:
        if (!isConst) {
          return this.parseVariable();
        }

        break;
    }

    throw this.unexpected();
  };

  _proto.parseStringLiteral = function parseStringLiteral() {
    var token = this._lexer.token;

    this._lexer.advance();

    return {
      kind: Kind.STRING,
      value: token.value,
      block: token.kind === tokenKind_TokenKind.BLOCK_STRING,
      loc: this.loc(token)
    };
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  ;

  _proto.parseList = function parseList(isConst) {
    var _this = this;

    var start = this._lexer.token;

    var item = function item() {
      return _this.parseValueLiteral(isConst);
    };

    return {
      kind: Kind.LIST,
      values: this.any(tokenKind_TokenKind.BRACKET_L, item, tokenKind_TokenKind.BRACKET_R),
      loc: this.loc(start)
    };
  }
  /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */
  ;

  _proto.parseObject = function parseObject(isConst) {
    var _this2 = this;

    var start = this._lexer.token;

    var item = function item() {
      return _this2.parseObjectField(isConst);
    };

    return {
      kind: Kind.OBJECT,
      fields: this.any(tokenKind_TokenKind.BRACE_L, item, tokenKind_TokenKind.BRACE_R),
      loc: this.loc(start)
    };
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  ;

  _proto.parseObjectField = function parseObjectField(isConst) {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return {
      kind: Kind.OBJECT_FIELD,
      name: name,
      value: this.parseValueLiteral(isConst),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */
  ;

  _proto.parseDirectives = function parseDirectives(isConst) {
    var directives = [];

    while (this.peek(tokenKind_TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }
  /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */
  ;

  _proto.parseDirective = function parseDirective(isConst) {
    var start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.AT);
    return {
      kind: Kind.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  ;

  _proto.parseTypeReference = function parseTypeReference() {
    var start = this._lexer.token;
    var type;

    if (this.expectOptionalToken(tokenKind_TokenKind.BRACKET_L)) {
      type = this.parseTypeReference();
      this.expectToken(tokenKind_TokenKind.BRACKET_R);
      type = {
        kind: Kind.LIST_TYPE,
        type: type,
        loc: this.loc(start)
      };
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(tokenKind_TokenKind.BANG)) {
      return {
        kind: Kind.NON_NULL_TYPE,
        type: type,
        loc: this.loc(start)
      };
    }

    return type;
  }
  /**
   * NamedType : Name
   */
  ;

  _proto.parseNamedType = function parseNamedType() {
    var start = this._lexer.token;
    return {
      kind: Kind.NAMED_TYPE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Type Definition section.

  /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  ;

  _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
    // Many definitions begin with a description and require a lookahead.
    var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }
    }

    throw this.unexpected(keywordToken);
  };

  _proto.peekDescription = function peekDescription() {
    return this.peek(tokenKind_TokenKind.STRING) || this.peek(tokenKind_TokenKind.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  ;

  _proto.parseDescription = function parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */
  ;

  _proto.parseSchemaDefinition = function parseSchemaDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('schema');
    var directives = this.parseDirectives(true);
    var operationTypes = this.many(tokenKind_TokenKind.BRACE_L, this.parseOperationTypeDefinition, tokenKind_TokenKind.BRACE_R);
    return {
      kind: Kind.SCHEMA_DEFINITION,
      description: description,
      directives: directives,
      operationTypes: operationTypes,
      loc: this.loc(start)
    };
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  ;

  _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
    var start = this._lexer.token;
    var operation = this.parseOperationType();
    this.expectToken(tokenKind_TokenKind.COLON);
    var type = this.parseNamedType();
    return {
      kind: Kind.OPERATION_TYPE_DEFINITION,
      operation: operation,
      type: type,
      loc: this.loc(start)
    };
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  ;

  _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('scalar');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: Kind.SCALAR_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  ;

  _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('type');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: Kind.OBJECT_TYPE_DEFINITION,
      description: description,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  ;

  _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
    var _this$_options2;

    if (!this.expectOptionalKeyword('implements')) {
      return [];
    }

    if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
      var types = []; // Optional leading ampersand

      this.expectOptionalToken(tokenKind_TokenKind.AMP);

      do {
        types.push(this.parseNamedType());
      } while (this.expectOptionalToken(tokenKind_TokenKind.AMP) || this.peek(tokenKind_TokenKind.NAME));

      return types;
    }

    return this.delimitedMany(tokenKind_TokenKind.AMP, this.parseNamedType);
  }
  /**
   * FieldsDefinition : { FieldDefinition+ }
   */
  ;

  _proto.parseFieldsDefinition = function parseFieldsDefinition() {
    var _this$_options3;

    // Legacy support for the SDL?
    if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek(tokenKind_TokenKind.BRACE_L) && this._lexer.lookahead().kind === tokenKind_TokenKind.BRACE_R) {
      this._lexer.advance();

      this._lexer.advance();

      return [];
    }

    return this.optionalMany(tokenKind_TokenKind.BRACE_L, this.parseFieldDefinition, tokenKind_TokenKind.BRACE_R);
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  ;

  _proto.parseFieldDefinition = function parseFieldDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    this.expectToken(tokenKind_TokenKind.COLON);
    var type = this.parseTypeReference();
    var directives = this.parseDirectives(true);
    return {
      kind: Kind.FIELD_DEFINITION,
      description: description,
      name: name,
      arguments: args,
      type: type,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  ;

  _proto.parseArgumentDefs = function parseArgumentDefs() {
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, this.parseInputValueDef, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  ;

  _proto.parseInputValueDef = function parseInputValueDef() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    var type = this.parseTypeReference();
    var defaultValue;

    if (this.expectOptionalToken(tokenKind_TokenKind.EQUALS)) {
      defaultValue = this.parseValueLiteral(true);
    }

    var directives = this.parseDirectives(true);
    return {
      kind: Kind.INPUT_VALUE_DEFINITION,
      description: description,
      name: name,
      type: type,
      defaultValue: defaultValue,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  ;

  _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('interface');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: Kind.INTERFACE_TYPE_DEFINITION,
      description: description,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  ;

  _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('union');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();
    return {
      kind: Kind.UNION_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      types: types,
      loc: this.loc(start)
    };
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  ;

  _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
    return this.expectOptionalToken(tokenKind_TokenKind.EQUALS) ? this.delimitedMany(tokenKind_TokenKind.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  ;

  _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('enum');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();
    return {
      kind: Kind.ENUM_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      values: values,
      loc: this.loc(start)
    };
  }
  /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */
  ;

  _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
    return this.optionalMany(tokenKind_TokenKind.BRACE_L, this.parseEnumValueDefinition, tokenKind_TokenKind.BRACE_R);
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */
  ;

  _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: Kind.ENUM_VALUE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  ;

  _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('input');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();
    return {
      kind: Kind.INPUT_OBJECT_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */
  ;

  _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
    return this.optionalMany(tokenKind_TokenKind.BRACE_L, this.parseInputValueDef, tokenKind_TokenKind.BRACE_R);
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  ;

  _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
    var keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */
  ;

  _proto.parseSchemaExtension = function parseSchemaExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    var directives = this.parseDirectives(true);
    var operationTypes = this.optionalMany(tokenKind_TokenKind.BRACE_L, this.parseOperationTypeDefinition, tokenKind_TokenKind.BRACE_R);

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.SCHEMA_EXTENSION,
      directives: directives,
      operationTypes: operationTypes,
      loc: this.loc(start)
    };
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  ;

  _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    var name = this.parseName();
    var directives = this.parseDirectives(true);

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.SCALAR_TYPE_EXTENSION,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  ;

  _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();

    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.OBJECT_TYPE_EXTENSION,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  ;

  _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();

    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.INTERFACE_TYPE_EXTENSION,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  ;

  _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.UNION_TYPE_EXTENSION,
      name: name,
      directives: directives,
      types: types,
      loc: this.loc(start)
    };
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  ;

  _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.ENUM_TYPE_EXTENSION,
      name: name,
      directives: directives,
      values: values,
      loc: this.loc(start)
    };
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  ;

  _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.INPUT_OBJECT_TYPE_EXTENSION,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */
  ;

  _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(tokenKind_TokenKind.AT);
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    var repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    var locations = this.parseDirectiveLocations();
    return {
      kind: Kind.DIRECTIVE_DEFINITION,
      description: description,
      name: name,
      arguments: args,
      repeatable: repeatable,
      locations: locations,
      loc: this.loc(start)
    };
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  ;

  _proto.parseDirectiveLocations = function parseDirectiveLocations() {
    return this.delimitedMany(tokenKind_TokenKind.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  ;

  _proto.parseDirectiveLocation = function parseDirectiveLocation() {
    var start = this._lexer.token;
    var name = this.parseName();

    if (DirectiveLocation[name.value] !== undefined) {
      return name;
    }

    throw this.unexpected(start);
  } // Core parsing utility functions

  /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */
  ;

  _proto.loc = function loc(startToken) {
    var _this$_options4;

    if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) {
      return new ast/* Location */.Ye(startToken, this._lexer.lastToken, this._lexer.source);
    }
  }
  /**
   * Determines if the next token is of a given kind
   */
  ;

  _proto.peek = function peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  ;

  _proto.expectToken = function expectToken(kind) {
    var token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    throw syntaxError(this._lexer.source, token.start, "Expected ".concat(getTokenKindDesc(kind), ", found ").concat(getTokenDesc(token), "."));
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */
  ;

  _proto.expectOptionalToken = function expectOptionalToken(kind) {
    var token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    return undefined;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  ;

  _proto.expectKeyword = function expectKeyword(value) {
    var token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this._lexer.advance();
    } else {
      throw syntaxError(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat(getTokenDesc(token), "."));
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  ;

  _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
    var token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this._lexer.advance();

      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  ;

  _proto.unexpected = function unexpected(atToken) {
    var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return syntaxError(this._lexer.source, token.start, "Unexpected ".concat(getTokenDesc(token), "."));
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.any = function any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      var nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.many = function many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  ;

  _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    var nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));

    return nodes;
  };

  return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */

function getTokenDesc(token) {
  var value = token.value;
  return getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */


function getTokenKindDesc(kind) {
  return isPunctuatorTokenKind(kind) ? "\"".concat(kind, "\"") : kind;
}

;// CONCATENATED MODULE: ./node_modules/graphql-tag/lib/index.js


var docCache = new Map();
var fragmentSourceMap = new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function cacheKeyFromLoc(loc) {
    return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function (fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if (printFragmentWarnings) {
                    console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
                        + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
                        + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
                }
            }
            else if (!sourceKeySet) {
                fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            }
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        }
        else {
            definitions.push(fragmentDefinition);
        }
    });
    return __assign(__assign({}, ast), { definitions: definitions });
}
function stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function (node) {
        if (node.loc)
            delete node.loc;
        Object.keys(node).forEach(function (key) {
            var value = node[key];
            if (value && typeof value === 'object') {
                workSet.add(value);
            }
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function parseDocument(source) {
    var cacheKey = normalize(source);
    if (!docCache.has(cacheKey)) {
        var parsed = parse(source, {
            experimentalFragmentVariables: experimentalFragmentVariables,
            allowLegacyFragmentVariables: experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') {
            throw new Error('Not a valid GraphQL document.');
        }
        docCache.set(cacheKey, stripLoc(processFragments(parsed)));
    }
    return docCache.get(cacheKey);
}
function gql(literals) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (typeof literals === 'string') {
        literals = [literals];
    }
    var result = literals[0];
    args.forEach(function (arg, i) {
        if (arg && arg.kind === 'Document') {
            result += arg.loc.source.body;
        }
        else {
            result += arg;
        }
        result += literals[i + 1];
    });
    return parseDocument(result);
}
function resetCaches() {
    docCache.clear();
    fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
    printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
    experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
    experimentalFragmentVariables = false;
}
var extras = {
    gql: gql,
    resetCaches: resetCaches,
    disableFragmentWarnings: disableFragmentWarnings,
    enableExperimentalFragmentVariables: enableExperimentalFragmentVariables,
    disableExperimentalFragmentVariables: disableExperimentalFragmentVariables
};
(function (gql_1) {
    gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));
gql["default"] = gql;
/* harmony default export */ var lib = (gql);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(21296);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 96103:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 21296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(96103);
} else {}


/***/ }),

/***/ 80645:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 35717:
/***/ (function(module) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),

/***/ 33827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isBrowser */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

/* harmony default export */ __webpack_exports__["Z"] = (isBrowser);


/***/ }),

/***/ 24970:
/***/ (function(module) {

"use strict";


const isStream = stream =>
	stream !== null &&
	typeof stream === 'object' &&
	typeof stream.pipe === 'function';

isStream.writable = stream =>
	isStream(stream) &&
	stream.writable !== false &&
	typeof stream._write === 'function' &&
	typeof stream._writableState === 'object';

isStream.readable = stream =>
	isStream(stream) &&
	stream.readable !== false &&
	typeof stream._read === 'function' &&
	typeof stream._readableState === 'object';

isStream.duplex = stream =>
	isStream.writable(stream) &&
	isStream.readable(stream);

isStream.transform = stream =>
	isStream.duplex(stream) &&
	typeof stream._transform === 'function';

module.exports = isStream;


/***/ }),

/***/ 16345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ jss_plugin_camel_case_esm; }
});

;// CONCATENATED MODULE: ./node_modules/hyphenate-style-name/index.js
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ var hyphenate_style_name = (hyphenateStyleName);

;// CONCATENATED MODULE: ./node_modules/jss-plugin-camel-case/dist/jss-plugin-camel-case.esm.js


/**
 * Convert camel cased property names to dash separated.
 */

function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    var key = prop.indexOf('--') === 0 ? prop : hyphenate_style_name(prop);
    converted[key] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */


function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }

      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    if (prop.indexOf('--') === 0) {
      return value;
    }

    var hyphenatedProp = hyphenate_style_name(prop); // There was no camel case in place

    if (prop === hyphenatedProp) return value;
    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.

    return null;
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ var jss_plugin_camel_case_esm = (camelCase);


/***/ }),

/***/ 83961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var jss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54013);


var px = jss__WEBPACK_IMPORTED_MODULE_0__/* .hasCSSTOMSupport */ .HZ && CSS ? CSS.px : 'px';
var ms = jss__WEBPACK_IMPORTED_MODULE_0__/* .hasCSSTOMSupport */ .HZ && CSS ? CSS.ms : 'ms';
var percent = jss__WEBPACK_IMPORTED_MODULE_0__/* .hasCSSTOMSupport */ .HZ && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */

var defaultUnits = {
  // Animation properties
  'animation-delay': ms,
  'animation-duration': ms,
  // Background properties
  'background-position': px,
  'background-position-x': px,
  'background-position-y': px,
  'background-size': px,
  // Border Properties
  border: px,
  'border-bottom': px,
  'border-bottom-left-radius': px,
  'border-bottom-right-radius': px,
  'border-bottom-width': px,
  'border-left': px,
  'border-left-width': px,
  'border-radius': px,
  'border-right': px,
  'border-right-width': px,
  'border-top': px,
  'border-top-left-radius': px,
  'border-top-right-radius': px,
  'border-top-width': px,
  'border-width': px,
  'border-block': px,
  'border-block-end': px,
  'border-block-end-width': px,
  'border-block-start': px,
  'border-block-start-width': px,
  'border-block-width': px,
  'border-inline': px,
  'border-inline-end': px,
  'border-inline-end-width': px,
  'border-inline-start': px,
  'border-inline-start-width': px,
  'border-inline-width': px,
  'border-start-start-radius': px,
  'border-start-end-radius': px,
  'border-end-start-radius': px,
  'border-end-end-radius': px,
  // Margin properties
  margin: px,
  'margin-bottom': px,
  'margin-left': px,
  'margin-right': px,
  'margin-top': px,
  'margin-block': px,
  'margin-block-end': px,
  'margin-block-start': px,
  'margin-inline': px,
  'margin-inline-end': px,
  'margin-inline-start': px,
  // Padding properties
  padding: px,
  'padding-bottom': px,
  'padding-left': px,
  'padding-right': px,
  'padding-top': px,
  'padding-block': px,
  'padding-block-end': px,
  'padding-block-start': px,
  'padding-inline': px,
  'padding-inline-end': px,
  'padding-inline-start': px,
  // Mask properties
  'mask-position-x': px,
  'mask-position-y': px,
  'mask-size': px,
  // Width and height properties
  height: px,
  width: px,
  'min-height': px,
  'max-height': px,
  'min-width': px,
  'max-width': px,
  // Position properties
  bottom: px,
  left: px,
  top: px,
  right: px,
  inset: px,
  'inset-block': px,
  'inset-block-end': px,
  'inset-block-start': px,
  'inset-inline': px,
  'inset-inline-end': px,
  'inset-inline-start': px,
  // Shadow properties
  'box-shadow': px,
  'text-shadow': px,
  // Column properties
  'column-gap': px,
  'column-rule': px,
  'column-rule-width': px,
  'column-width': px,
  // Font and text properties
  'font-size': px,
  'font-size-delta': px,
  'letter-spacing': px,
  'text-decoration-thickness': px,
  'text-indent': px,
  'text-stroke': px,
  'text-stroke-width': px,
  'word-spacing': px,
  // Motion properties
  motion: px,
  'motion-offset': px,
  // Outline properties
  outline: px,
  'outline-offset': px,
  'outline-width': px,
  // Perspective properties
  perspective: px,
  'perspective-origin-x': percent,
  'perspective-origin-y': percent,
  // Transform properties
  'transform-origin': percent,
  'transform-origin-x': percent,
  'transform-origin-y': percent,
  'transform-origin-z': percent,
  // Transition properties
  'transition-delay': ms,
  'transition-duration': ms,
  // Alignment properties
  'vertical-align': px,
  'flex-basis': px,
  // Some random properties
  'shape-margin': px,
  size: px,
  gap: px,
  // Grid properties
  grid: px,
  'grid-gap': px,
  'row-gap': px,
  'grid-row-gap': px,
  'grid-column-gap': px,
  'grid-template-rows': px,
  'grid-template-columns': px,
  'grid-auto-rows': px,
  'grid-auto-columns': px,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  'box-shadow-x': px,
  'box-shadow-y': px,
  'box-shadow-blur': px,
  'box-shadow-spread': px,
  'font-line-height': px,
  'text-shadow-x': px,
  'text-shadow-y': px,
  'text-shadow-blur': px
};

/**
 * Clones the object and adds a camel cased property version.
 */

function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;

  var replace = function replace(str) {
    return str[1].toUpperCase();
  };

  var newObj = {};

  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }

  return newObj;
}

var units = addCamelCasedVersion(defaultUnits);
/**
 * Recursive deep style passing function
 */

function iterate(prop, value, options) {
  if (value == null) return value;

  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      value[i] = iterate(prop, value[i], options);
    }
  } else if (typeof value === 'object') {
    if (prop === 'fallbacks') {
      for (var innerProp in value) {
        value[innerProp] = iterate(innerProp, value[innerProp], options);
      }
    } else {
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
      }
    } // eslint-disable-next-line no-restricted-globals

  } else if (typeof value === 'number' && isNaN(value) === false) {
    var unit = options[prop] || units[prop]; // Add the unit if available, except for the special case of 0px.

    if (unit && !(value === 0 && unit === px)) {
      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
    }

    return value.toString();
  }

  return value;
}
/**
 * Add unit to numeric values.
 */


function defaultUnit(options) {
  if (options === void 0) {
    options = {};
  }

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (defaultUnit);


/***/ }),

/***/ 5019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var jss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54013);



var at = '@global';
var atPrefix = '@global ';

var GlobalContainerRule =
/*#__PURE__*/
function () {
  function GlobalContainerRule(key, styles, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    this.rules = new jss__WEBPACK_IMPORTED_MODULE_0__/* .RuleList */ .RB((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = GlobalContainerRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (rule) this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Replace rule, run plugins.
   */
  ;

  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return GlobalContainerRule;
}();

var GlobalPrefixedRule =
/*#__PURE__*/
function () {
  function GlobalPrefixedRule(key, style, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    var selector = key.substr(atPrefix.length);
    this.rule = options.jss.createRule(selector, style, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, options, {
      parent: this
    }));
  }

  var _proto2 = GlobalPrefixedRule.prototype;

  _proto2.toString = function toString(options) {
    return this.rule ? this.rule.toString(options) : '';
  };

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';

  for (var i = 0; i < parts.length; i++) {
    scoped += scope + " " + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }

  return scoped;
}

function handleNestedGlobalContainerRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;
  var rules = style ? style[at] : null;
  if (!rules) return;

  for (var name in rules) {
    sheet.addRule(name, rules[name], (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[at];
}

function handlePrefixedGlobalRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
    var selector = addScope(prop.substr(at.length), rule.selector);
    sheet.addRule(selector, style[prop], (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */


function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (!name) return null;

    if (name === at) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;

    if (parent) {
      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
        options.scoped = false;
      }
    }

    if (!options.selector && options.scoped === false) {
      options.selector = name;
    }

    return null;
  }

  function onProcessRule(rule, sheet) {
    if (rule.type !== 'style' || !sheet) return;
    handleNestedGlobalContainerRule(rule, sheet);
    handlePrefixedGlobalRule(rule, sheet);
  }

  return {
    onCreateRule: onCreateRule,
    onProcessRule: onProcessRule
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (jssGlobal);


/***/ }),

/***/ 63057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87462);



var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */

function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container, sheet) {
    return function (match, key) {
      var rule = container.getRule(key) || sheet && sheet.getRule(key);

      if (rule) {
        return rule.selector;
      }

       false ? 0 : void 0;
      return key;
    };
  }

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);
    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.

        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, prevOptions) {
    // Options has been already created, now we only increase index.
    if (prevOptions) return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, prevOptions, {
      index: prevOptions.index + 1
    });
    var nestingLevel = rule.options.nestingLevel;
    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    var options = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.

    });

    delete options.name;
    return options;
  }

  function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style') return style;
    var styleRule = rule;
    var container = styleRule.options.parent;
    var options;
    var replaceRef;

    for (var prop in style) {
      var isNested = prop.indexOf('&') !== -1;
      var isNestedConditional = prop[0] === '@';
      if (!isNested && !isNestedConditional) continue;
      options = getOptions(styleRule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.

        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.

        selector = selector.replace(refRegExp, replaceRef);
        var name = styleRule.key + "-" + prop;

        if ('replaceRule' in container) {
          // for backward compatibility
          container.replaceRule(name, style[prop], (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, options, {
            selector: selector
          }));
        } else {
          container.addRule(name, style[prop], (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, options, {
            selector: selector
          }));
        }
      } else if (isNestedConditional) {
        // Place conditional right after the parent rule to ensure right ordering.
        container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
          selector: styleRule.selector
        });
      }

      delete style[prop];
    }

    return style;
  }

  return {
    onProcessStyle: onProcessStyle
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (jssNested);


/***/ }),

/***/ 26895:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Sort props by length.
 */
function jssPropsSort() {
  var sort = function sort(prop0, prop1) {
    if (prop0.length === prop1.length) {
      return prop0 > prop1 ? 1 : -1;
    }

    return prop0.length - prop1.length;
  };

  return {
    onProcessStyle: function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;
      var newStyle = {};
      var props = Object.keys(style).sort(sort);

      for (var i = 0; i < props.length; i++) {
        newStyle[props[i]] = style[props[i]];
      }

      return newStyle;
    }
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (jssPropsSort);


/***/ }),

/***/ 27202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var jss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54013);



var now = Date.now();
var fnValuesNs = "fnValues" + now;
var fnRuleNs = "fnStyle" + ++now;

var functionPlugin = function functionPlugin() {
  return {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (typeof decl !== 'function') return null;
      var rule = (0,jss__WEBPACK_IMPORTED_MODULE_0__/* .createRule */ .JH)(name, {}, options);
      rule[fnRuleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle(style, rule) {
      // We need to extract function values from the declaration, so that we can keep core unaware of them.
      // We need to do that only once.
      // We don't need to extract functions on each style update, since this can happen only once.
      // We don't support function values inside of function rules.
      if (fnValuesNs in rule || fnRuleNs in rule) return style;
      var fnValues = {};

      for (var prop in style) {
        var value = style[prop];
        if (typeof value !== 'function') continue;
        delete style[prop];
        fnValues[prop] = value;
      }

      rule[fnValuesNs] = fnValues;
      return style;
    },
    onUpdate: function onUpdate(data, rule, sheet, options) {
      var styleRule = rule;
      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
      // will be returned from that function.

      if (fnRule) {
        // Empty object will remove all currently defined props
        // in case function rule returns a falsy value.
        styleRule.style = fnRule(data) || {};

        if (false) { var prop; }
      }

      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.

      if (fnValues) {
        for (var _prop in fnValues) {
          styleRule.prop(_prop, fnValues[_prop](data), options);
        }
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (functionPlugin);


/***/ }),

/***/ 3203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ jss_plugin_vendor_prefixer_esm; }
});

// EXTERNAL MODULE: ./node_modules/is-in-browser/dist/module.js
var dist_module = __webpack_require__(33827);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(74902);
;// CONCATENATED MODULE: ./node_modules/css-vendor/dist/css-vendor.esm.js



// Export javascript style and css style vendor prefixes.
var js = '';
var css = '';
var vendor = '';
var browser = '';
var isTouch = dist_module/* default */.Z && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.

if (dist_module/* default */.Z) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };

  var _document$createEleme = document.createElement('p'),
      style = _document$createEleme.style;

  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  } // Correctly detect the Edge browser.


  if (js === 'Webkit' && 'msHyphens' in style) {
    js = 'ms';
    css = jsCssMap.ms;
    browser = 'edge';
  } // Correctly detect the Safari browser.


  if (js === 'Webkit' && '-apple-trailing-word' in style) {
    vendor = 'apple';
  }
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */


var prefix = {
  js: js,
  css: css,
  vendor: vendor,
  browser: browser,
  isTouch: isTouch
};

/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */

function supportedKeyframes(key) {
  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
  // https://caniuse.com/#search=keyframes

  if (prefix.js === 'ms') return key;
  return "@" + prefix.css + "keyframes" + key.substr(10);
}

// https://caniuse.com/#search=appearance

var appearence = {
  noPrefill: ['appearance'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'appearance') return false;
    if (prefix.js === 'ms') return "-webkit-" + prop;
    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=color-adjust

var colorAdjust = {
  noPrefill: ['color-adjust'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'color-adjust') return false;
    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
    return prop;
  }
};

var regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */


function camelize(str) {
  return str.replace(regExp, toUpper);
}

/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function pascalize(str) {
  return camelize("-" + str);
}

// but we can use a longhand property instead.
// https://caniuse.com/#search=mask

var mask = {
  noPrefill: ['mask'],
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^mask/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var longhand = 'mask-image';

      if (camelize(longhand) in style) {
        return prop;
      }

      if (prefix.js + pascalize(longhand) in style) {
        return prefix.css + prop;
      }
    }

    return prop;
  }
};

// https://caniuse.com/#search=text-orientation

var textOrientation = {
  noPrefill: ['text-orientation'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'text-orientation') return false;

    if (prefix.vendor === 'apple' && !prefix.isTouch) {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=transform

var transform = {
  noPrefill: ['transform'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transform') return false;

    if (options.transform) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=transition

var transition = {
  noPrefill: ['transition'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transition') return false;

    if (options.transition) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=writing-mode

var writingMode = {
  noPrefill: ['writing-mode'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'writing-mode') return false;

    if (prefix.js === 'Webkit' || prefix.js === 'ms' && prefix.browser !== 'edge') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=user-select

var userSelect = {
  noPrefill: ['user-select'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'user-select') return false;

    if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177

var breakPropsOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^break-/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var jsProp = "WebkitColumn" + pascalize(prop);
      return jsProp in style ? prefix.css + "column-" + prop : false;
    }

    if (prefix.js === 'Moz') {
      var _jsProp = "page" + pascalize(prop);

      return _jsProp in style ? "page-" + prop : false;
    }

    return false;
  }
};

// See https://github.com/postcss/autoprefixer/issues/324.

var inlineLogicalOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
    if (prefix.js === 'Moz') return prop;
    var newProp = prop.replace('-inline', '');
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.

var unprefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    return camelize(prop) in style ? prop : false;
  }
};

var prefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.

    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.

    if (prop[0] === '-' && prop[1] === '-') return prop;
    if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.

    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
    return false;
  }
};

// https://caniuse.com/#search=scroll-snap

var scrollSnap = {
  supportedProperty: function supportedProperty(prop) {
    if (prop.substring(0, 11) !== 'scroll-snap') return false;

    if (prefix.js === 'ms') {
      return "" + prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=overscroll-behavior

var overscrollBehavior = {
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'overscroll-behavior') return false;

    if (prefix.js === 'ms') {
      return prefix.css + "scroll-chaining";
    }

    return prop;
  }
};

var propMap = {
  'flex-grow': 'flex-positive',
  'flex-shrink': 'flex-negative',
  'flex-basis': 'flex-preferred-size',
  'justify-content': 'flex-pack',
  order: 'flex-order',
  'align-items': 'flex-align',
  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.

}; // Support old flex spec from 2012.

var flex2012 = {
  supportedProperty: function supportedProperty(prop, style) {
    var newProp = propMap[prop];
    if (!newProp) return false;
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

var propMap$1 = {
  flex: 'box-flex',
  'flex-grow': 'box-flex',
  'flex-direction': ['box-orient', 'box-direction'],
  order: 'box-ordinal-group',
  'align-items': 'box-align',
  'flex-flow': ['box-orient', 'box-direction'],
  'justify-content': 'box-pack'
};
var propKeys = Object.keys(propMap$1);

var prefixCss = function prefixCss(p) {
  return prefix.css + p;
}; // Support old flex spec from 2009.


var flex2009 = {
  supportedProperty: function supportedProperty(prop, style, _ref) {
    var multiple = _ref.multiple;

    if (propKeys.indexOf(prop) > -1) {
      var newProp = propMap$1[prop];

      if (!Array.isArray(newProp)) {
        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
      }

      if (!multiple) return false;

      for (var i = 0; i < newProp.length; i++) {
        if (!(prefix.js + pascalize(newProp[0]) in style)) {
          return false;
        }
      }

      return newProp.map(prefixCss);
    }

    return false;
  }
};

// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'

var plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
var propertyDetectors = plugins.filter(function (p) {
  return p.supportedProperty;
}).map(function (p) {
  return p.supportedProperty;
});
var noPrefill = plugins.filter(function (p) {
  return p.noPrefill;
}).reduce(function (a, p) {
  a.push.apply(a, (0,toConsumableArray/* default */.Z)(p.noPrefill));
  return a;
}, []);

var el;
var cache = {};

if (dist_module/* default */.Z) {
  el = document.createElement('p'); // We test every property on vendor prefix requirement.
  // Once tested, result is cached. It gives us up to 70% perf boost.
  // http://jsperf.com/element-style-object-access-vs-plain-object
  //
  // Prefill cache with known css properties to reduce amount of
  // properties we need to feature test at runtime.
  // http://davidwalsh.name/vendor-prefix

  var computed = window.getComputedStyle(document.documentElement, '');

  for (var key$1 in computed) {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(key$1)) cache[computed[key$1]] = computed[key$1];
  } // Properties that cannot be correctly detected using the
  // cache prefill method.


  noPrefill.forEach(function (x) {
    return delete cache[x];
  });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */


function supportedProperty(prop, options) {
  if (options === void 0) {
    options = {};
  }

  // For server-side rendering.
  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.

  if ( true && cache[prop] != null) {
    return cache[prop];
  } // Check if 'transition' or 'transform' natively supported in browser.


  if (prop === 'transition' || prop === 'transform') {
    options[prop] = prop in el.style;
  } // Find a plugin for current prefix property.


  for (var i = 0; i < propertyDetectors.length; i++) {
    cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.

    if (cache[prop]) break;
  } // Reset styles for current property.
  // Firefox can even throw an error for invalid properties, e.g., "0".


  try {
    el.style[prop] = '';
  } catch (err) {
    return false;
  }

  return cache[prop];
}

var cache$1 = {};
var transitionProperties = {
  transition: 1,
  'transition-property': 1,
  '-webkit-transition': 1,
  '-webkit-transition-property': 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */

function prefixTransitionCallback(match, p1, p2) {
  if (p1 === 'var') return 'var';
  if (p1 === 'all') return 'all';
  if (p2 === 'all') return ', all';
  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
  if (!prefixedValue) return p1 || p2;
  return prefixedValue;
}

if (dist_module/* default */.Z) el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */

function supportedValue(property, value) {
  // For server-side rendering.
  var prefixedValue = value;
  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  // eslint-disable-next-line no-restricted-globals

  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
    return prefixedValue;
  } // Create cache key for current value.


  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.

  if ( true && cache$1[cacheKey] != null) {
    return cache$1[cacheKey];
  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.


  try {
    // Test value as it is.
    el$1.style[property] = prefixedValue;
  } catch (err) {
    // Return false if value not supported.
    cache$1[cacheKey] = false;
    return false;
  } // If 'transition' or 'transition-property' property.


  if (transitionProperties[property]) {
    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
  } else if (el$1.style[property] === '') {
    // Value with a vendor prefix.
    prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.

    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.

    el$1.style[property] = prefixedValue; // Return false if value not supported.

    if (el$1.style[property] === '') {
      cache$1[cacheKey] = false;
      return false;
    }
  } // Reset styles for current property.


  el$1.style[property] = ''; // Write current value to cache.

  cache$1[cacheKey] = prefixedValue;
  return cache$1[cacheKey];
}



// EXTERNAL MODULE: ./node_modules/jss/dist/jss.esm.js
var jss_esm = __webpack_require__(54013);
;// CONCATENATED MODULE: ./node_modules/jss-plugin-vendor-prefixer/dist/jss-plugin-vendor-prefixer.esm.js



/**
 * Add vendor prefix to a property name when needed.
 */

function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      var atRule = rule;
      atRule.at = supportedKeyframes(atRule.at);
    }
  }

  function prefixStyle(style) {
    for (var prop in style) {
      var value = style[prop];

      if (prop === 'fallbacks' && Array.isArray(value)) {
        style[prop] = value.map(prefixStyle);
        continue;
      }

      var changeProp = false;
      var supportedProp = supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;
      var changeValue = false;
      var supportedValue$1 = supportedValue(supportedProp, (0,jss_esm/* toCssValue */.EK)(value));
      if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue$1 || value;
      }
    }

    return style;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    return prefixStyle(style);
  }

  function onChangeValue(value, prop) {
    return supportedValue(prop, (0,jss_esm/* toCssValue */.EK)(value)) || value;
  }

  return {
    onProcessRule: onProcessRule,
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ var jss_plugin_vendor_prefixer_esm = (jssVendorPrefixer);


/***/ }),

/***/ 54013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EK": function() { return /* binding */ toCssValue; },
/* harmony export */   "HZ": function() { return /* binding */ hasCSSTOMSupport; },
/* harmony export */   "JH": function() { return /* binding */ createRule; },
/* harmony export */   "RB": function() { return /* binding */ RuleList; },
/* harmony export */   "Ue": function() { return /* binding */ createJss; },
/* harmony export */   "_$": function() { return /* binding */ getDynamicStyles; },
/* harmony export */   "xE": function() { return /* binding */ SheetsRegistry; }
/* harmony export */ });
/* unused harmony exports SheetsManager, createGenerateId, sheets */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var is_in_browser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33827);
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43144);
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94578);
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97326);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63366);








var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
  if (style == null || typeof style !== 'object') return style;
  if (Array.isArray(style)) return style.map(cloneStyle);
  if (style.constructor !== plainObjectConstrurctor) return style;
  var newStyle = {};

  for (var name in style) {
    newStyle[name] = cloneStyle(style[name]);
  }

  return newStyle;
}

/**
 * Create a rule instance.
 */

function createRule(name, decl, options) {
  if (name === void 0) {
    name = 'unnamed';
  }

  var jss = options.jss;
  var declCopy = cloneStyle(decl);
  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule; // It is an at-rule and it has no instance.

  if (name[0] === '@') {
     false ? 0 : void 0;
  }

  return null;
}

var join = function join(value, by) {
  var result = '';

  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }

  return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */


var toCssValue = function toCssValue(value) {
  if (!Array.isArray(value)) return value;
  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.

  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', '); // Add !important, because it was ignored.


  if (value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
};

function getWhitespaceSymbols(options) {
  if (options && options.format === false) {
    return {
      linebreak: '',
      space: ''
    };
  }

  return {
    linebreak: '\n',
    space: ' '
  };
}

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */

function indentStr(str, indent) {
  var result = '';

  for (var index = 0; index < indent; index++) {
    result += '  ';
  }

  return result + str;
}
/**
 * Converts a Rule to CSS string.
 */


function toCss(selector, style, options) {
  if (options === void 0) {
    options = {};
  }

  var result = '';
  if (!style) return result;
  var _options = options,
      _options$indent = _options.indent,
      indent = _options$indent === void 0 ? 0 : _options$indent;
  var fallbacks = style.fallbacks;

  if (options.format === false) {
    indent = -Infinity;
  }

  var _getWhitespaceSymbols = getWhitespaceSymbols(options),
      linebreak = _getWhitespaceSymbols.linebreak,
      space = _getWhitespaceSymbols.space;

  if (selector) indent++; // Apply fallbacks first.

  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];

        for (var prop in fallback) {
          var value = fallback[prop];

          if (value != null) {
            if (result) result += linebreak;
            result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];

        if (_value != null) {
          if (result) result += linebreak;
          result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];

    if (_value2 != null && _prop2 !== 'fallbacks') {
      if (result) result += linebreak;
      result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
    }
  } // Allow empty style in this case, because properties will be added dynamically.


  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.

  if (!selector) return result;
  indent--;
  if (result) result = "" + linebreak + result + linebreak;
  return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}

var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = (function (str) {
  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
});

var BaseStyleRule =
/*#__PURE__*/
function () {
  function BaseStyleRule(key, style, options) {
    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
        Renderer = options.Renderer;
    this.key = key;
    this.options = options;
    this.style = style;
    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
  }
  /**
   * Get or set a style property.
   */


  var _proto = BaseStyleRule.prototype;

  _proto.prop = function prop(name, value, options) {
    // It's a getter.
    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.

    var force = options ? options.force : false;
    if (!force && this.style[name] === value) return this;
    var newValue = value;

    if (!options || options.process !== false) {
      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
    }

    var isEmpty = newValue == null || newValue === false;
    var isDefined = name in this.style; // Value is empty and wasn't defined before.

    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.

    var remove = isEmpty && isDefined;
    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.

    if (this.renderable && this.renderer) {
      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
      return this;
    }

    var sheet = this.options.sheet;

    if (sheet && sheet.attached) {
       false ? 0 : void 0;
    }

    return this;
  };

  return BaseStyleRule;
}();
var StyleRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(StyleRule, _BaseStyleRule);

  function StyleRule(key, style, options) {
    var _this;

    _this = _BaseStyleRule.call(this, key, style, options) || this;
    var selector = options.selector,
        scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;

    if (selector) {
      _this.selectorText = selector;
    } else if (scoped !== false) {
      _this.id = generateId((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_this)), sheet);
      _this.selectorText = "." + escape(_this.id);
    }

    return _this;
  }
  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  var _proto2 = StyleRule.prototype;

  /**
   * Apply rule to an element inline.
   */
  _proto2.applyTo = function applyTo(renderable) {
    var renderer = this.renderer;

    if (renderer) {
      var json = this.toJSON();

      for (var prop in json) {
        renderer.setProperty(renderable, prop, json[prop]);
      }
    }

    return this;
  }
  /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */
  ;

  _proto2.toJSON = function toJSON() {
    var json = {};

    for (var prop in this.style) {
      var value = this.style[prop];
      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
    }

    return json;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto2.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.selectorText, this.style, opts);
  };

  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(StyleRule, [{
    key: "selector",
    set: function set(selector) {
      if (selector === this.selectorText) return;
      this.selectorText = selector;
      var renderer = this.renderer,
          renderable = this.renderable;
      if (!renderable || !renderer) return;
      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.

      if (!hasChanged) {
        renderer.replaceRule(renderable, this);
      }
    }
    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') {
      return null;
    }

    return new StyleRule(key, style, options);
  }
};

var defaultToStringOptions = {
  indent: 1,
  children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */

var ConditionalRule =
/*#__PURE__*/
function () {
  function ConditionalRule(key, styles, options) {
    this.type = 'conditional';
    this.isProcessed = false;
    this.key = key;
    var atMatch = key.match(atRegExp);
    this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.

    this.query = options.name || "@" + this.at;
    this.options = options;
    this.rules = new RuleList((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, options, {
      parent: this
    }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = ConditionalRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Replace rule, run plugins.
   */
  ;

  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions;
    }

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (options.indent == null) options.indent = defaultToStringOptions.indent;
    if (options.children == null) options.children = defaultToStringOptions.children;

    if (options.children === false) {
      return this.query + " {}";
    }

    var children = this.rules.toString(options);
    return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
  };

  return ConditionalRule;
}();
var keyRegExp = /@container|@media|@supports\s+/;
var pluginConditionalRule = {
  onCreateRule: function onCreateRule(key, styles, options) {
    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
  }
};

var defaultToStringOptions$1 = {
  indent: 1,
  children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */

var KeyframesRule =
/*#__PURE__*/
function () {
  function KeyframesRule(key, frames, options) {
    this.type = 'keyframes';
    this.at = '@keyframes';
    this.isProcessed = false;
    var nameMatch = key.match(nameRegExp);

    if (nameMatch && nameMatch[1]) {
      this.name = nameMatch[1];
    } else {
      this.name = 'noname';
       false ? 0 : void 0;
    }

    this.key = this.type + "-" + this.name;
    this.options = options;
    var scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;
    this.id = scoped === false ? this.name : escape(generateId(this, sheet));
    this.rules = new RuleList((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, options, {
      parent: this
    }));

    for (var name in frames) {
      this.rules.add(name, frames[name], (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, options, {
        parent: this
      }));
    }

    this.rules.process();
  }
  /**
   * Generates a CSS string.
   */


  var _proto = KeyframesRule.prototype;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions$1;
    }

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
    if (options.children == null) options.children = defaultToStringOptions$1.children;

    if (options.children === false) {
      return this.at + " " + this.id + " {}";
    }

    var children = this.rules.toString(options);
    if (children) children = "" + linebreak + children + linebreak;
    return this.at + " " + this.id + " {" + children + "}";
  };

  return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;

var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
  if (typeof val === 'string') {
    return val.replace(refRegExp, function (match, name) {
      if (name in keyframes) {
        return keyframes[name];
      }

       false ? 0 : void 0;
      return match;
    });
  }

  return val;
};
/**
 * Replace the reference for a animation name.
 */


var replaceRef = function replaceRef(style, prop, keyframes) {
  var value = style[prop];
  var refKeyframe = findReferencedKeyframe(value, keyframes);

  if (refKeyframe !== value) {
    style[prop] = refKeyframe;
  }
};

var pluginKeyframesRule = {
  onCreateRule: function onCreateRule(key, frames, options) {
    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style' || !sheet) return style;
    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
    return style;
  },
  onChangeValue: function onChangeValue(val, prop, rule) {
    var sheet = rule.options.sheet;

    if (!sheet) {
      return val;
    }

    switch (prop) {
      case 'animation':
        return findReferencedKeyframe(val, sheet.keyframes);

      case 'animation-name':
        return findReferencedKeyframe(val, sheet.keyframes);

      default:
        return val;
    }
  }
};

var KeyframeRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(KeyframeRule, _BaseStyleRule);

  function KeyframeRule() {
    return _BaseStyleRule.apply(this, arguments) || this;
  }

  var _proto = KeyframeRule.prototype;

  /**
   * Generates a CSS string.
   */
  _proto.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.key, this.style, opts);
  };

  return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (options.parent && options.parent.type === 'keyframes') {
      return new KeyframeRule(key, style, options);
    }

    return null;
  }
};

var FontFaceRule =
/*#__PURE__*/
function () {
  function FontFaceRule(key, style, options) {
    this.type = 'font-face';
    this.at = '@font-face';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = FontFaceRule.prototype;

  _proto.toString = function toString(options) {
    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (Array.isArray(this.style)) {
      var str = '';

      for (var index = 0; index < this.style.length; index++) {
        str += toCss(this.at, this.style[index]);
        if (this.style[index + 1]) str += linebreak;
      }

      return str;
    }

    return toCss(this.at, this.style, options);
  };

  return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
  }
};

var ViewportRule =
/*#__PURE__*/
function () {
  function ViewportRule(key, style, options) {
    this.type = 'viewport';
    this.at = '@viewport';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = ViewportRule.prototype;

  _proto.toString = function toString(options) {
    return toCss(this.key, this.style, options);
  };

  return ViewportRule;
}();
var pluginViewportRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
  }
};

var SimpleRule =
/*#__PURE__*/
function () {
  function SimpleRule(key, value, options) {
    this.type = 'simple';
    this.isProcessed = false;
    this.key = key;
    this.value = value;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  var _proto = SimpleRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.value)) {
      var str = '';

      for (var index = 0; index < this.value.length; index++) {
        str += this.key + " " + this.value[index] + ";";
        if (this.value[index + 1]) str += '\n';
      }

      return str;
    }

    return this.key + " " + this.value + ";";
  };

  return SimpleRule;
}();
var keysMap = {
  '@charset': true,
  '@import': true,
  '@namespace': true
};
var pluginSimpleRule = {
  onCreateRule: function onCreateRule(key, value, options) {
    return key in keysMap ? new SimpleRule(key, value, options) : null;
  }
};

var plugins = [pluginStyleRule, pluginConditionalRule, pluginKeyframesRule, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];

var defaultUpdateOptions = {
  process: true
};
var forceUpdateOptions = {
  force: true,
  process: true
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */

};

var RuleList =
/*#__PURE__*/
function () {
  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.
  // Original styles object.
  // Used to ensure correct rules order.
  function RuleList(options) {
    this.map = {};
    this.raw = {};
    this.index = [];
    this.counter = 0;
    this.options = options;
    this.classes = options.classes;
    this.keyframes = options.keyframes;
  }
  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  var _proto = RuleList.prototype;

  _proto.add = function add(name, decl, ruleOptions) {
    var _this$options = this.options,
        parent = _this$options.parent,
        sheet = _this$options.sheet,
        jss = _this$options.jss,
        Renderer = _this$options.Renderer,
        generateId = _this$options.generateId,
        scoped = _this$options.scoped;

    var options = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
      classes: this.classes,
      parent: parent,
      sheet: sheet,
      jss: jss,
      Renderer: Renderer,
      generateId: generateId,
      scoped: scoped,
      name: name,
      keyframes: this.keyframes,
      selector: undefined
    }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
    // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
    // we need to make the key unique within this RuleList instance scope.


    var key = name;

    if (name in this.raw) {
      key = name + "-d" + this.counter++;
    } // We need to save the original decl before creating the rule
    // because cache plugin needs to use it as a key to return a cached rule.


    this.raw[key] = decl;

    if (key in this.classes) {
      // E.g. rules inside of @media container
      options.selector = "." + escape(this.classes[key]);
    }

    var rule = createRule(key, decl, options);
    if (!rule) return null;
    this.register(rule);
    var index = options.index === undefined ? this.index.length : options.index;
    this.index.splice(index, 0, rule);
    return rule;
  }
  /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */
  ;

  _proto.replace = function replace(name, decl, ruleOptions) {
    var oldRule = this.get(name);
    var oldIndex = this.index.indexOf(oldRule);

    if (oldRule) {
      this.remove(oldRule);
    }

    var options = ruleOptions;
    if (oldIndex !== -1) options = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, ruleOptions, {
      index: oldIndex
    });
    return this.add(name, decl, options);
  }
  /**
   * Get a rule by name or selector.
   */
  ;

  _proto.get = function get(nameOrSelector) {
    return this.map[nameOrSelector];
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.remove = function remove(rule) {
    this.unregister(rule);
    delete this.raw[rule.key];
    this.index.splice(this.index.indexOf(rule), 1);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.index.indexOf(rule);
  }
  /**
   * Run `onProcessRule()` plugins on every rule.
   */
  ;

  _proto.process = function process() {
    var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
    // we end up with very hard-to-track-down side effects.

    this.index.slice(0).forEach(plugins.onProcessRule, plugins);
  }
  /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */
  ;

  _proto.register = function register(rule) {
    this.map[rule.key] = rule;

    if (rule instanceof StyleRule) {
      this.map[rule.selector] = rule;
      if (rule.id) this.classes[rule.key] = rule.id;
    } else if (rule instanceof KeyframesRule && this.keyframes) {
      this.keyframes[rule.name] = rule.id;
    }
  }
  /**
   * Unregister a rule.
   */
  ;

  _proto.unregister = function unregister(rule) {
    delete this.map[rule.key];

    if (rule instanceof StyleRule) {
      delete this.map[rule.selector];
      delete this.classes[rule.key];
    } else if (rule instanceof KeyframesRule) {
      delete this.keyframes[rule.name];
    }
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var name;
    var data;
    var options;

    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
      name = arguments.length <= 0 ? undefined : arguments[0];
      data = arguments.length <= 1 ? undefined : arguments[1];
      options = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      data = arguments.length <= 0 ? undefined : arguments[0];
      options = arguments.length <= 1 ? undefined : arguments[1];
      name = null;
    }

    if (name) {
      this.updateOne(this.get(name), data, options);
    } else {
      for (var index = 0; index < this.index.length; index++) {
        this.updateOne(this.index[index], data, options);
      }
    }
  }
  /**
   * Execute plugins, update rule props.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    if (options === void 0) {
      options = defaultUpdateOptions;
    }

    var _this$options2 = this.options,
        plugins = _this$options2.jss.plugins,
        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.

    if (rule.rules instanceof RuleList) {
      rule.rules.update(data, options);
      return;
    }

    var style = rule.style;
    plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.

    if (options.process && style && style !== rule.style) {
      // We need to run the plugins in case new `style` relies on syntax plugins.
      plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.

      for (var prop in rule.style) {
        var nextValue = rule.style[prop];
        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (nextValue !== prevValue) {
          rule.prop(prop, nextValue, forceUpdateOptions);
        }
      } // Remove props.


      for (var _prop in style) {
        var _nextValue = rule.style[_prop];
        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (_nextValue == null && _nextValue !== _prevValue) {
          rule.prop(_prop, null, forceUpdateOptions);
        }
      }
    }
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    var str = '';
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    for (var index = 0; index < this.index.length; index++) {
      var rule = this.index[index];
      var css = rule.toString(options); // No need to render an empty rule.

      if (!css && !link) continue;
      if (str) str += linebreak;
      str += css;
    }

    return str;
  };

  return RuleList;
}();

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(styles, options) {
    this.attached = false;
    this.deployed = false;
    this.classes = {};
    this.keyframes = {};
    this.options = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    });

    if (options.Renderer) {
      this.renderer = new options.Renderer(this);
    }

    this.rules = new RuleList(this.options);

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Attach renderable to the render tree.
   */


  var _proto = StyleSheet.prototype;

  _proto.attach = function attach() {
    if (this.attached) return this;
    if (this.renderer) this.renderer.attach();
    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.

    if (!this.deployed) this.deploy();
    return this;
  }
  /**
   * Remove renderable from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.attached) return this;
    if (this.renderer) this.renderer.detach();
    this.attached = false;
    return this;
  }
  /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */
  ;

  _proto.addRule = function addRule(name, decl, options) {
    var queue = this.queue; // Plugins can create rules.
    // In order to preserve the right order, we need to queue all `.addRule` calls,
    // which happen after the first `rules.add()` call.

    if (this.attached && !queue) this.queue = [];
    var rule = this.rules.add(name, decl, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);

    if (this.attached) {
      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (queue) queue.push(rule);else {
        this.insertRule(rule);

        if (this.queue) {
          this.queue.forEach(this.insertRule, this);
          this.queue = undefined;
        }
      }
      return rule;
    } // We can't add rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return rule;
  }
  /**
   * Replace a rule in the current stylesheet.
   */
  ;

  _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
    var oldRule = this.rules.get(nameOrSelector);
    if (!oldRule) return this.addRule(nameOrSelector, decl, options);
    var newRule = this.rules.replace(nameOrSelector, decl, options);

    if (newRule) {
      this.options.jss.plugins.onProcessRule(newRule);
    }

    if (this.attached) {
      if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (this.renderer) {
        if (!newRule) {
          this.renderer.deleteRule(oldRule);
        } else if (oldRule.renderable) {
          this.renderer.replaceRule(oldRule.renderable, newRule);
        }
      }

      return newRule;
    } // We can't replace rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return newRule;
  }
  /**
   * Insert rule into the StyleSheet
   */
  ;

  _proto.insertRule = function insertRule(rule) {
    if (this.renderer) {
      this.renderer.insertRule(rule);
    }
  }
  /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */
  ;

  _proto.addRules = function addRules(styles, options) {
    var added = [];

    for (var name in styles) {
      var rule = this.addRule(name, styles[name], options);
      if (rule) added.push(rule);
    }

    return added;
  }
  /**
   * Get a rule by name or selector.
   */
  ;

  _proto.getRule = function getRule(nameOrSelector) {
    return this.rules.get(nameOrSelector);
  }
  /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */
  ;

  _proto.deleteRule = function deleteRule(name) {
    var rule = typeof name === 'object' ? name : this.rules.get(name);

    if (!rule || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !rule.renderable) {
      return false;
    }

    this.rules.remove(rule);

    if (this.attached && rule.renderable && this.renderer) {
      return this.renderer.deleteRule(rule.renderable);
    }

    return true;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Deploy pure CSS string to a renderable.
   */
  ;

  _proto.deploy = function deploy() {
    if (this.renderer) this.renderer.deploy();
    this.deployed = true;
    return this;
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var _this$rules;

    (_this$rules = this.rules).update.apply(_this$rules, arguments);

    return this;
  }
  /**
   * Updates a single rule.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    this.rules.updateOne(rule, data, options);
    return this;
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return StyleSheet;
}();

var PluginsRegistry =
/*#__PURE__*/
function () {
  function PluginsRegistry() {
    this.plugins = {
      internal: [],
      external: []
    };
    this.registry = {};
  }

  var _proto = PluginsRegistry.prototype;

  /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */
  _proto.onCreateRule = function onCreateRule(name, decl, options) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var rule = this.registry.onCreateRule[i](name, decl, options);
      if (rule) return rule;
    }

    return null;
  }
  /**
   * Call `onProcessRule` hooks.
   */
  ;

  _proto.onProcessRule = function onProcessRule(rule) {
    if (rule.isProcessed) return;
    var sheet = rule.options.sheet;

    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
      this.registry.onProcessRule[i](rule, sheet);
    }

    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
    rule.isProcessed = true;
  }
  /**
   * Call `onProcessStyle` hooks.
   */
  ;

  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    }
  }
  /**
   * Call `onProcessSheet` hooks.
   */
  ;

  _proto.onProcessSheet = function onProcessSheet(sheet) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
      this.registry.onProcessSheet[i](sheet);
    }
  }
  /**
   * Call `onUpdate` hooks.
   */
  ;

  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
    for (var i = 0; i < this.registry.onUpdate.length; i++) {
      this.registry.onUpdate[i](data, rule, sheet, options);
    }
  }
  /**
   * Call `onChangeValue` hooks.
   */
  ;

  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
    var processedValue = value;

    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
    }

    return processedValue;
  }
  /**
   * Register a plugin.
   */
  ;

  _proto.use = function use(newPlugin, options) {
    if (options === void 0) {
      options = {
        queue: 'external'
      };
    }

    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.

    if (plugins.indexOf(newPlugin) !== -1) {
      return;
    }

    plugins.push(newPlugin);
    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
      for (var name in plugin) {
        if (name in registry) {
          registry[name].push(plugin[name]);
        } else {
           false ? 0 : void 0;
        }
      }

      return registry;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    });
  };

  return PluginsRegistry;
}();

/**
 * Sheets registry to access all instances in one place.
 */

var SheetsRegistry =
/*#__PURE__*/
function () {
  function SheetsRegistry() {
    this.registry = [];
  }

  var _proto = SheetsRegistry.prototype;

  /**
   * Register a Style Sheet.
   */
  _proto.add = function add(sheet) {
    var registry = this.registry;
    var index = sheet.options.index;
    if (registry.indexOf(sheet) !== -1) return;

    if (registry.length === 0 || index >= this.index) {
      registry.push(sheet);
      return;
    } // Find a position.


    for (var i = 0; i < registry.length; i++) {
      if (registry[i].options.index > index) {
        registry.splice(i, 0, sheet);
        return;
      }
    }
  }
  /**
   * Reset the registry.
   */
  ;

  _proto.reset = function reset() {
    this.registry = [];
  }
  /**
   * Remove a Style Sheet.
   */
  ;

  _proto.remove = function remove(sheet) {
    var index = this.registry.indexOf(sheet);
    this.registry.splice(index, 1);
  }
  /**
   * Convert all attached sheets to a CSS string.
   */
  ;

  _proto.toString = function toString(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        attached = _ref.attached,
        options = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, ["attached"]);

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    var css = '';

    for (var i = 0; i < this.registry.length; i++) {
      var sheet = this.registry[i];

      if (attached != null && sheet.attached !== attached) {
        continue;
      }

      if (css) css += linebreak;
      css += sheet.toString(options);
    }

    return css;
  };

  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(SheetsRegistry, [{
    key: "index",

    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */

var sheets = new SheetsRegistry();

/* eslint-disable */

/**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */
var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();

var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.

var moduleId = globalThis$1[ns]++;

var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

var createGenerateId = function createGenerateId(options) {
  if (options === void 0) {
    options = {};
  }

  var ruleCounter = 0;

  var generateId = function generateId(rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
       false ? 0 : void 0;
    }

    var jssId = '';
    var prefix = '';

    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix = sheet.options.classNamePrefix;
      }

      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }

    if (options.minify) {
      // Using "c" because a number can't be the first char in a class name.
      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
    }

    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
  };

  return generateId;
};

/**
 * Cache the value from the first time a function is called.
 */

var memoize = function memoize(fn) {
  var value;
  return function () {
    if (!value) value = fn();
    return value;
  };
};
/**
 * Get a style property value.
 */


var getPropertyValue = function getPropertyValue(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      return cssRule.attributeStyleMap.get(prop);
    }

    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
};
/**
 * Set a style property.
 */


var setProperty = function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = toCssValue(value);
    } // Support CSSTOM.


    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.set(prop, cssValue);
    } else {
      var indexOfImportantFlag = cssValue ? cssValue.indexOf('!important') : -1;
      var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
      cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? 'important' : '');
    }
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }

  return true;
};
/**
 * Remove a style property.
 */


var removeProperty = function removeProperty(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.delete(prop);
    } else {
      cssRule.style.removeProperty(prop);
    }
  } catch (err) {
     false ? 0 : void 0;
  }
};
/**
 * Set the selector.
 */


var setSelector = function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText; // Return false if setter was not successful.
  // Currently works in chrome only.

  return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */


var getHead = memoize(function () {
  return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */

function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find attached sheet with the highest index.
 */


function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find a comment with "jss" inside.
 */


function findCommentNode(text) {
  var head = getHead();

  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];

    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }

  return null;
}
/**
 * Find a node before which we can insert the sheet.
 */


function findPrevNode(options) {
  var registry = sheets.registry;

  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element
      };
    } // Otherwise insert after the last attached.


    sheet = findHighestSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element.nextSibling
      };
    }
  } // Try to find a comment placeholder if registry is empty.


  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);

    if (comment) {
      return {
        parent: comment.parentNode,
        node: comment.nextSibling
      };
    } // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.


     false ? 0 : void 0;
  }

  return false;
}
/**
 * Insert style element into the DOM.
 */


function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;
  var nextNode = findPrevNode(options);

  if (nextNode !== false && nextNode.parent) {
    nextNode.parent.insertBefore(style, nextNode.node);
    return;
  } // Works with iframes and any node types.


  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    var insertionPointElement = insertionPoint;
    var parentNode = insertionPointElement.parentNode;
    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else  false ? 0 : void 0;
    return;
  }

  getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */


var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var _insertRule = function insertRule(container, rule, index) {
  try {
    if ('insertRule' in container) {
      container.insertRule(rule, index);
    } // Keyframes rule.
    else if ('appendRule' in container) {
        container.appendRule(rule);
      }
  } catch (err) {
     false ? 0 : void 0;
    return false;
  }

  return container.cssRules[index];
};

var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong

  if (index === undefined || index > maxIndex) {
    // eslint-disable-next-line no-param-reassign
    return maxIndex;
  }

  return index;
};

var createStyle = function createStyle() {
  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
  // insert rules after we insert the style tag.
  // It seems to kick-off the source order specificity algorithm.

  el.textContent = '\n';
  return el;
};

var DomRenderer =
/*#__PURE__*/
function () {
  // Will be empty if link: true option is not set, because
  // it is only for use together with insertRule API.
  function DomRenderer(sheet) {
    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.hasInsertedRules = false;
    this.cssRules = [];
    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) sheets.add(sheet);
    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || createStyle();
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }
  /**
   * Insert style element into render tree.
   */


  var _proto = DomRenderer.prototype;

  _proto.attach = function attach() {
    // In the case the element node is external and it is already in the DOM.
    if (this.element.parentNode || !this.sheet) return;
    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
    // most browsers create a new CSSStyleSheet, except of all IEs.

    var deployed = Boolean(this.sheet && this.sheet.deployed);

    if (this.hasInsertedRules && deployed) {
      this.hasInsertedRules = false;
      this.deploy();
    }
  }
  /**
   * Remove style element from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.sheet) return;
    var parentNode = this.element.parentNode;
    if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
    // Though IE will keep them and we need a consistent behavior.

    if (this.sheet.options.link) {
      this.cssRules = [];
      this.element.textContent = '\n';
    }
  }
  /**
   * Inject CSS string into element.
   */
  ;

  _proto.deploy = function deploy() {
    var sheet = this.sheet;
    if (!sheet) return;

    if (sheet.options.link) {
      this.insertRules(sheet.rules);
      return;
    }

    this.element.textContent = "\n" + sheet.toString() + "\n";
  }
  /**
   * Insert RuleList into an element.
   */
  ;

  _proto.insertRules = function insertRules(rules, nativeParent) {
    for (var i = 0; i < rules.index.length; i++) {
      this.insertRule(rules.index[i], i, nativeParent);
    }
  }
  /**
   * Insert a rule into element.
   */
  ;

  _proto.insertRule = function insertRule(rule, index, nativeParent) {
    if (nativeParent === void 0) {
      nativeParent = this.element.sheet;
    }

    if (rule.rules) {
      var parent = rule;
      var latestNativeParent = nativeParent;

      if (rule.type === 'conditional' || rule.type === 'keyframes') {
        var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.


        latestNativeParent = _insertRule(nativeParent, parent.toString({
          children: false
        }), _insertionIndex);

        if (latestNativeParent === false) {
          return false;
        }

        this.refCssRule(rule, _insertionIndex, latestNativeParent);
      }

      this.insertRules(parent.rules, latestNativeParent);
      return latestNativeParent;
    }

    var ruleStr = rule.toString();
    if (!ruleStr) return false;
    var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);

    var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);

    if (nativeRule === false) {
      return false;
    }

    this.hasInsertedRules = true;
    this.refCssRule(rule, insertionIndex, nativeRule);
    return nativeRule;
  };

  _proto.refCssRule = function refCssRule(rule, index, cssRule) {
    rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
    // like rules inside media queries or keyframes

    if (rule.options.parent instanceof StyleSheet) {
      this.cssRules.splice(index, 0, cssRule);
    }
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.deleteRule = function deleteRule(cssRule) {
    var sheet = this.element.sheet;
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return true;
  }
  /**
   * Get index of a CSS Rule.
   */
  ;

  _proto.indexOf = function indexOf(cssRule) {
    return this.cssRules.indexOf(cssRule);
  }
  /**
   * Generate a new CSS rule and replace the existing one.
   */
  ;

  _proto.replaceRule = function replaceRule(cssRule, rule) {
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    this.element.sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return this.insertRule(rule, index);
  }
  /**
   * Get all rules elements.
   */
  ;

  _proto.getRules = function getRules() {
    return this.element.sheet.cssRules;
  };

  return DomRenderer;
}();

var instanceCounter = 0;

var Jss =
/*#__PURE__*/
function () {
  function Jss(options) {
    this.id = instanceCounter++;
    this.version = "10.10.0";
    this.plugins = new PluginsRegistry();
    this.options = {
      id: {
        minify: false
      },
      createGenerateId: createGenerateId,
      Renderer: is_in_browser__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z ? DomRenderer : null,
      plugins: []
    };
    this.generateId = createGenerateId({
      minify: false
    });

    for (var i = 0; i < plugins.length; i++) {
      this.plugins.use(plugins[i], {
        queue: 'internal'
      });
    }

    this.setup(options);
  }
  /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */


  var _proto = Jss.prototype;

  _proto.setup = function setup(options) {
    if (options === void 0) {
      options = {};
    }

    if (options.createGenerateId) {
      this.options.createGenerateId = options.createGenerateId;
    }

    if (options.id) {
      this.options.id = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this.options.id, options.id);
    }

    if (options.createGenerateId || options.id) {
      this.generateId = this.options.createGenerateId(this.options.id);
    }

    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;

    if ('Renderer' in options) {
      this.options.Renderer = options.Renderer;
    } // eslint-disable-next-line prefer-spread


    if (options.plugins) this.use.apply(this, options.plugins);
    return this;
  }
  /**
   * Create a Style Sheet.
   */
  ;

  _proto.createStyleSheet = function createStyleSheet(styles, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        index = _options.index;

    if (typeof index !== 'number') {
      index = sheets.index === 0 ? 0 : sheets.index + 1;
    }

    var sheet = new StyleSheet(styles, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, options, {
      jss: this,
      generateId: options.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: index
    }));
    this.plugins.onProcessSheet(sheet);
    return sheet;
  }
  /**
   * Detach the Style Sheet and remove it from the registry.
   */
  ;

  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
    sheet.detach();
    sheets.remove(sheet);
    return this;
  }
  /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */
  ;

  _proto.createRule = function createRule$1(name, style, options) {
    if (style === void 0) {
      style = {};
    }

    if (options === void 0) {
      options = {};
    }

    // Enable rule without name for inline styles.
    if (typeof name === 'object') {
      return this.createRule(undefined, name, style);
    }

    var ruleOptions = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, options, {
      name: name,
      jss: this,
      Renderer: this.options.Renderer
    });

    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
    if (!ruleOptions.classes) ruleOptions.classes = {};
    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};

    var rule = createRule(name, style, ruleOptions);

    if (rule) this.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */
  ;

  _proto.use = function use() {
    var _this = this;

    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }

    plugins.forEach(function (plugin) {
      _this.plugins.use(plugin);
    });
    return this;
  };

  return Jss;
}();

var createJss = function createJss(options) {
  return new Jss(options);
};

/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */

var SheetsManager =
/*#__PURE__*/
(/* unused pure expression or super */ null && (function () {
  function SheetsManager() {
    this.length = 0;
    this.sheets = new WeakMap();
  }

  var _proto = SheetsManager.prototype;

  _proto.get = function get(key) {
    var entry = this.sheets.get(key);
    return entry && entry.sheet;
  };

  _proto.add = function add(key, sheet) {
    if (this.sheets.has(key)) return;
    this.length++;
    this.sheets.set(key, {
      sheet: sheet,
      refs: 0
    });
  };

  _proto.manage = function manage(key) {
    var entry = this.sheets.get(key);

    if (entry) {
      if (entry.refs === 0) {
        entry.sheet.attach();
      }

      entry.refs++;
      return entry.sheet;
    }

    warning(false, "[JSS] SheetsManager: can't find sheet to manage");
    return undefined;
  };

  _proto.unmanage = function unmanage(key) {
    var entry = this.sheets.get(key);

    if (entry) {
      if (entry.refs > 0) {
        entry.refs--;
        if (entry.refs === 0) entry.sheet.detach();
      }
    } else {
      warning(false, "SheetsManager: can't find sheet to unmanage");
    }
  };

  _createClass(SheetsManager, [{
    key: "size",
    get: function get() {
      return this.length;
    }
  }]);

  return SheetsManager;
}()));

/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/
var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;

/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value;

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);

      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
var index = createJss();

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (index)));



/***/ }),

/***/ 71168:
/***/ (function(module) {

/**
 * The code was extracted from:
 * https://github.com/davidchambers/Base64.js
 */

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function InvalidCharacterError(message) {
  this.message = message;
}

InvalidCharacterError.prototype = new Error();
InvalidCharacterError.prototype.name = 'InvalidCharacterError';

function polyfill (input) {
  var str = String(input).replace(/=+$/, '');
  if (str.length % 4 == 1) {
    throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
  }
  for (
    // initialize result and counters
    var bc = 0, bs, buffer, idx = 0, output = '';
    // get next character
    buffer = str.charAt(idx++);
    // character found in table? initialize bit storage and add its ascii value;
    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
      // and if not first of each 4 characters,
      // convert the first 8 bits to one ascii character
      bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
  ) {
    // try to find character in table (0-63, not found => -1)
    buffer = chars.indexOf(buffer);
  }
  return output;
}


module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || polyfill;


/***/ }),

/***/ 84491:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var atob = __webpack_require__(71168);

function b64DecodeUnicode(str) {
  return decodeURIComponent(atob(str).replace(/(.)/g, function (m, p) {
    var code = p.charCodeAt(0).toString(16).toUpperCase();
    if (code.length < 2) {
      code = '0' + code;
    }
    return '%' + code;
  }));
}

module.exports = function(str) {
  var output = str.replace(/-/g, "+").replace(/_/g, "/");
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += "==";
      break;
    case 3:
      output += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }

  try{
    return b64DecodeUnicode(output);
  } catch (err) {
    return atob(output);
  }
};


/***/ }),

/***/ 46489:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var base64_url_decode = __webpack_require__(84491);

function InvalidTokenError(message) {
  this.message = message;
}

InvalidTokenError.prototype = new Error();
InvalidTokenError.prototype.name = 'InvalidTokenError';

module.exports = function (token,options) {
  if (typeof token !== 'string') {
    throw new InvalidTokenError('Invalid token specified');
  }

  options = options || {};
  var pos = options.header === true ? 0 : 1;
  try {
    return JSON.parse(base64_url_decode(token.split('.')[pos]));
  } catch (e) {
    throw new InvalidTokenError('Invalid token specified: ' + e.message);
  }
};

module.exports.InvalidTokenError = InvalidTokenError;


/***/ }),

/***/ 18552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 1989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(51789),
    hashDelete = __webpack_require__(80401),
    hashGet = __webpack_require__(57667),
    hashHas = __webpack_require__(21327),
    hashSet = __webpack_require__(81866);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 38407:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(27040),
    listCacheDelete = __webpack_require__(14125),
    listCacheGet = __webpack_require__(82117),
    listCacheHas = __webpack_require__(67518),
    listCacheSet = __webpack_require__(54705);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 57071:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 83369:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(24785),
    mapCacheDelete = __webpack_require__(11285),
    mapCacheGet = __webpack_require__(96000),
    mapCacheHas = __webpack_require__(49916),
    mapCacheSet = __webpack_require__(95265);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 53818:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 58525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 88668:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369),
    setCacheAdd = __webpack_require__(90619),
    setCacheHas = __webpack_require__(72385);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 46384:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407),
    stackClear = __webpack_require__(37465),
    stackDelete = __webpack_require__(63779),
    stackGet = __webpack_require__(67599),
    stackHas = __webpack_require__(44758),
    stackSet = __webpack_require__(34309);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 62705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 11149:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 70577:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 96874:
/***/ (function(module) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ 77412:
/***/ (function(module) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ 34963:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 14636:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(22545),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isIndex = __webpack_require__(65776),
    isTypedArray = __webpack_require__(36719);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 29932:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 62488:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 82908:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 34865:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(89465),
    eq = __webpack_require__(77813);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 18470:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(77813);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 44037:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    keys = __webpack_require__(3674);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),

/***/ 63886:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    keysIn = __webpack_require__(81704);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),

/***/ 89465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(38777);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 85990:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    arrayEach = __webpack_require__(77412),
    assignValue = __webpack_require__(34865),
    baseAssign = __webpack_require__(44037),
    baseAssignIn = __webpack_require__(63886),
    cloneBuffer = __webpack_require__(64626),
    copyArray = __webpack_require__(278),
    copySymbols = __webpack_require__(18805),
    copySymbolsIn = __webpack_require__(1911),
    getAllKeys = __webpack_require__(58234),
    getAllKeysIn = __webpack_require__(46904),
    getTag = __webpack_require__(64160),
    initCloneArray = __webpack_require__(43824),
    initCloneByTag = __webpack_require__(29148),
    initCloneObject = __webpack_require__(38517),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isMap = __webpack_require__(56688),
    isObject = __webpack_require__(13218),
    isSet = __webpack_require__(72928),
    keys = __webpack_require__(3674),
    keysIn = __webpack_require__(81704);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),

/***/ 3118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ 89881:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseForOwn = __webpack_require__(47816),
    createBaseEach = __webpack_require__(99291);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ 21078:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    isFlattenable = __webpack_require__(37285);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ 28483:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(25063);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 47816:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFor = __webpack_require__(28483),
    keys = __webpack_require__(3674);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ 97786:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    toKey = __webpack_require__(40327);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 68866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    isArray = __webpack_require__(1469);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 44239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    getRawTag = __webpack_require__(89607),
    objectToString = __webpack_require__(2333);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 13:
/***/ (function(module) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ 9454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 90939:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(2492),
    isObjectLike = __webpack_require__(37005);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 2492:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    equalArrays = __webpack_require__(67114),
    equalByTag = __webpack_require__(18351),
    equalObjects = __webpack_require__(16096),
    getTag = __webpack_require__(64160),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isTypedArray = __webpack_require__(36719);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 25588:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(64160),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),

/***/ 2958:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    baseIsEqual = __webpack_require__(90939);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ 28458:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isMasked = __webpack_require__(15346),
    isObject = __webpack_require__(13218),
    toSource = __webpack_require__(80346);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 29221:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(64160),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),

/***/ 38749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isLength = __webpack_require__(41780),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 67206:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMatches = __webpack_require__(91573),
    baseMatchesProperty = __webpack_require__(16432),
    identity = __webpack_require__(6557),
    isArray = __webpack_require__(1469),
    property = __webpack_require__(39601);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ 280:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(25726),
    nativeKeys = __webpack_require__(86916);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 10313:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218),
    isPrototype = __webpack_require__(25726),
    nativeKeysIn = __webpack_require__(33498);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ 69199:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(89881),
    isArrayLike = __webpack_require__(98612);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ 91573:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(2958),
    getMatchData = __webpack_require__(1499),
    matchesStrictComparable = __webpack_require__(42634);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ 16432:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(90939),
    get = __webpack_require__(27361),
    hasIn = __webpack_require__(79095),
    isKey = __webpack_require__(15403),
    isStrictComparable = __webpack_require__(89162),
    matchesStrictComparable = __webpack_require__(42634),
    toKey = __webpack_require__(40327);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ 82689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29932),
    baseGet = __webpack_require__(97786),
    baseIteratee = __webpack_require__(67206),
    baseMap = __webpack_require__(69199),
    baseSortBy = __webpack_require__(71131),
    baseUnary = __webpack_require__(7518),
    compareMultiple = __webpack_require__(85022),
    identity = __webpack_require__(6557),
    isArray = __webpack_require__(1469);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),

/***/ 40371:
/***/ (function(module) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ 79152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ 5976:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(6557),
    overRest = __webpack_require__(45357),
    setToString = __webpack_require__(30061);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ 56560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var constant = __webpack_require__(75703),
    defineProperty = __webpack_require__(38777),
    identity = __webpack_require__(6557);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ 71131:
/***/ (function(module) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),

/***/ 22545:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 80531:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    arrayMap = __webpack_require__(29932),
    isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 27561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(67990);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 7518:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 74757:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 71811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isKey = __webpack_require__(15403),
    stringToPath = __webpack_require__(55514),
    toString = __webpack_require__(79833);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 74318:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Uint8Array = __webpack_require__(11149);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ 64626:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(55639);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;


/***/ }),

/***/ 57157:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(74318);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),

/***/ 93147:
/***/ (function(module) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),

/***/ 40419:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),

/***/ 77133:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(74318);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ 26393:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(33448);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),

/***/ 85022:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var compareAscending = __webpack_require__(26393);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),

/***/ 278:
/***/ (function(module) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 98363:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(34865),
    baseAssignValue = __webpack_require__(89465);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ 18805:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    getSymbols = __webpack_require__(99551);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),

/***/ 1911:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    getSymbolsIn = __webpack_require__(51442);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),

/***/ 14429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 99291:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(98612);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ 25063:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 38777:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 67114:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(88668),
    arraySome = __webpack_require__(82908),
    cacheHas = __webpack_require__(74757);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 18351:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    Uint8Array = __webpack_require__(11149),
    eq = __webpack_require__(77813),
    equalArrays = __webpack_require__(67114),
    mapToArray = __webpack_require__(68776),
    setToArray = __webpack_require__(21814);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 16096:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(58234);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 31957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 58234:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(68866),
    getSymbols = __webpack_require__(99551),
    keys = __webpack_require__(3674);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 46904:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(68866),
    getSymbolsIn = __webpack_require__(51442),
    keysIn = __webpack_require__(81704);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),

/***/ 45050:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(37019);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 1499:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(89162),
    keys = __webpack_require__(3674);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ 10852:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(28458),
    getValue = __webpack_require__(47801);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 85924:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(5569);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ 89607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 99551:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(34963),
    stubArray = __webpack_require__(70479);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 51442:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    getPrototype = __webpack_require__(85924),
    getSymbols = __webpack_require__(99551),
    stubArray = __webpack_require__(70479);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),

/***/ 64160:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(18552),
    Map = __webpack_require__(57071),
    Promise = __webpack_require__(53818),
    Set = __webpack_require__(58525),
    WeakMap = __webpack_require__(70577),
    baseGetTag = __webpack_require__(44239),
    toSource = __webpack_require__(80346);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 47801:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 222:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isIndex = __webpack_require__(65776),
    isLength = __webpack_require__(41780),
    toKey = __webpack_require__(40327);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 51789:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 80401:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 57667:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 21327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 81866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 43824:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),

/***/ 29148:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(74318),
    cloneDataView = __webpack_require__(57157),
    cloneRegExp = __webpack_require__(93147),
    cloneSymbol = __webpack_require__(40419),
    cloneTypedArray = __webpack_require__(77133);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),

/***/ 38517:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseCreate = __webpack_require__(3118),
    getPrototype = __webpack_require__(85924),
    isPrototype = __webpack_require__(25726);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ 37285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ 65776:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 16612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(77813),
    isArrayLike = __webpack_require__(98612),
    isIndex = __webpack_require__(65776),
    isObject = __webpack_require__(13218);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 15403:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 37019:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 15346:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(14429);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 25726:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 89162:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ 27040:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 14125:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 82117:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 67518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 54705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 24785:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(1989),
    ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 11285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 96000:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 49916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 95265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 68776:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 42634:
/***/ (function(module) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ 24523:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(88306);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 94536:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 86916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(5569);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 33498:
/***/ (function(module) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ 31167:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(31957);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 2333:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 5569:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 45357:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var apply = __webpack_require__(96874);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ 55639:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(31957);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 90619:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 72385:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 21814:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 30061:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSetToString = __webpack_require__(56560),
    shortOut = __webpack_require__(21275);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ 21275:
/***/ (function(module) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ 37465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 63779:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 67599:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 44758:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 34309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071),
    MapCache = __webpack_require__(83369);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 55514:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(24523);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 40327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 80346:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 67990:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 50361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseClone = __webpack_require__(85990);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),

/***/ 75703:
/***/ (function(module) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 23279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218),
    now = __webpack_require__(7771),
    toNumber = __webpack_require__(14841);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 77813:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 27361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 79095:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHasIn = __webpack_require__(13),
    hasPath = __webpack_require__(222);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ 6557:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 35694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(9454),
    isObjectLike = __webpack_require__(37005);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 1469:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 98612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isLength = __webpack_require__(41780);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 44144:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(55639),
    stubFalse = __webpack_require__(95062);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 41609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseKeys = __webpack_require__(280),
    getTag = __webpack_require__(64160),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isArrayLike = __webpack_require__(98612),
    isBuffer = __webpack_require__(44144),
    isPrototype = __webpack_require__(25726),
    isTypedArray = __webpack_require__(36719);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),

/***/ 23560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObject = __webpack_require__(13218);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 41780:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 56688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMap = __webpack_require__(25588),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),

/***/ 13218:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 37005:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 72928:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsSet = __webpack_require__(29221),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),

/***/ 33448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 36719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(38749),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 3674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(14636),
    baseKeys = __webpack_require__(280),
    isArrayLike = __webpack_require__(98612);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 81704:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(14636),
    baseKeysIn = __webpack_require__(10313),
    isArrayLike = __webpack_require__(98612);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ 88306:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 7771:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 75472:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseOrderBy = __webpack_require__(82689),
    isArray = __webpack_require__(1469);

/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */
function orderBy(collection, iteratees, orders, guard) {
  if (collection == null) {
    return [];
  }
  if (!isArray(iteratees)) {
    iteratees = iteratees == null ? [] : [iteratees];
  }
  orders = guard ? undefined : orders;
  if (!isArray(orders)) {
    orders = orders == null ? [] : [orders];
  }
  return baseOrderBy(collection, iteratees, orders);
}

module.exports = orderBy;


/***/ }),

/***/ 39601:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseProperty = __webpack_require__(40371),
    basePropertyDeep = __webpack_require__(79152),
    isKey = __webpack_require__(15403),
    toKey = __webpack_require__(40327);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ 89734:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(21078),
    baseOrderBy = __webpack_require__(82689),
    baseRest = __webpack_require__(5976),
    isIterateeCall = __webpack_require__(16612);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),

/***/ 70479:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 95062:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 23493:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var debounce = __webpack_require__(23279),
    isObject = __webpack_require__(13218);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 14841:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(27561),
    isObject = __webpack_require__(13218),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 79833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(80531);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 36894:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var format = __webpack_require__(58287);

/*
 * function align (info)
 * Returns a new instance of the align Format which adds a `\t`
 * delimiter before the message to properly align it in the same place.
 * It was previously { align: true } in winston < 3.0.0
 */
module.exports = format(function (info) {
  info.message = "\t".concat(info.message);
  return info;
});

/***/ }),

/***/ 6850:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


/*
 * @api public
 * @property {function} format
 * Both the construction method and set of exposed
 * formats.
 */
var format = exports.format = __webpack_require__(58287);

/*
 * @api public
 * @method {function} levels
 * Registers the specified levels with logform.
 */
exports.levels = __webpack_require__(47371);

//
// Setup all transports as eager-loaded exports
// so that they are static for the bundlers.
//
Object.defineProperty(format, 'align', {
  value: __webpack_require__(36894)
});
Object.defineProperty(format, 'cli', {
  value: __webpack_require__(79008)
});
Object.defineProperty(format, 'colorize', {
  value: __webpack_require__(52046)
});
Object.defineProperty(format, 'combine', {
  value: __webpack_require__(21145)
});
Object.defineProperty(format, 'errors', {
  value: __webpack_require__(2657)
});
Object.defineProperty(format, 'json', {
  value: __webpack_require__(93048)
});
Object.defineProperty(format, 'label', {
  value: __webpack_require__(44403)
});
Object.defineProperty(format, 'logstash', {
  value: __webpack_require__(49660)
});
Object.defineProperty(format, 'metadata', {
  value: __webpack_require__(42883)
});
Object.defineProperty(format, 'ms', {
  value: __webpack_require__(33584)
});
Object.defineProperty(format, 'padLevels', {
  value: __webpack_require__(82886)
});
Object.defineProperty(format, 'prettyPrint', {
  value: __webpack_require__(28703)
});
Object.defineProperty(format, 'printf', {
  value: __webpack_require__(82361)
});
Object.defineProperty(format, 'simple', {
  value: __webpack_require__(82167)
});
Object.defineProperty(format, 'splat', {
  value: __webpack_require__(67729)
});
Object.defineProperty(format, 'timestamp', {
  value: __webpack_require__(7271)
});
Object.defineProperty(format, 'uncolorize', {
  value: __webpack_require__(39729)
});

/***/ }),

/***/ 79008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = __webpack_require__(52046),
  Colorizer = _require.Colorizer;
var _require2 = __webpack_require__(82886),
  Padder = _require2.Padder;
var _require3 = __webpack_require__(15396),
  configs = _require3.configs,
  MESSAGE = _require3.MESSAGE;

/**
 * Cli format class that handles initial state for a a separate
 * Colorizer and Padder instance.
 */
var CliFormat = /*#__PURE__*/function () {
  function CliFormat() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, CliFormat);
    if (!opts.levels) {
      opts.levels = configs.cli.levels;
    }
    this.colorizer = new Colorizer(opts);
    this.padder = new Padder(opts);
    this.options = opts;
  }

  /*
   * function transform (info, opts)
   * Attempts to both:
   * 1. Pad the { level }
   * 2. Colorize the { level, message }
   * of the given `logform` info object depending on the `opts`.
   */
  _createClass(CliFormat, [{
    key: "transform",
    value: function transform(info, opts) {
      this.colorizer.transform(this.padder.transform(info, opts), opts);
      info[MESSAGE] = "".concat(info.level, ":").concat(info.message);
      return info;
    }
  }]);
  return CliFormat;
}();
/*
 * function cli (opts)
 * Returns a new instance of the CLI format that turns a log
 * `info` object into the same format previously available
 * in `winston.cli()` in `winston < 3.0.0`.
 */
module.exports = function (opts) {
  return new CliFormat(opts);
};

//
// Attach the CliFormat for registration purposes
//
module.exports.Format = CliFormat;

/***/ }),

/***/ 52046:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var colors = __webpack_require__(33645);
var _require = __webpack_require__(15396),
  LEVEL = _require.LEVEL,
  MESSAGE = _require.MESSAGE;

//
// Fix colors not appearing in non-tty environments
//
colors.enabled = true;

/**
 * @property {RegExp} hasSpace
 * Simple regex to check for presence of spaces.
 */
var hasSpace = /\s+/;

/*
 * Colorizer format. Wraps the `level` and/or `message` properties
 * of the `info` objects with ANSI color codes based on a few options.
 */
var Colorizer = /*#__PURE__*/function () {
  function Colorizer() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Colorizer);
    if (opts.colors) {
      this.addColors(opts.colors);
    }
    this.options = opts;
  }

  /*
   * Adds the colors Object to the set of allColors
   * known by the Colorizer
   *
   * @param {Object} colors Set of color mappings to add.
   */
  _createClass(Colorizer, [{
    key: "addColors",
    value:
    /*
     * Adds the colors Object to the set of allColors
     * known by the Colorizer
     *
     * @param {Object} colors Set of color mappings to add.
     */
    function addColors(clrs) {
      return Colorizer.addColors(clrs);
    }

    /*
     * function colorize (lookup, level, message)
     * Performs multi-step colorization using @colors/colors/safe
     */
  }, {
    key: "colorize",
    value: function colorize(lookup, level, message) {
      if (typeof message === 'undefined') {
        message = level;
      }

      //
      // If the color for the level is just a string
      // then attempt to colorize the message with it.
      //
      if (!Array.isArray(Colorizer.allColors[lookup])) {
        return colors[Colorizer.allColors[lookup]](message);
      }

      //
      // If it is an Array then iterate over that Array, applying
      // the colors function for each item.
      //
      for (var i = 0, len = Colorizer.allColors[lookup].length; i < len; i++) {
        message = colors[Colorizer.allColors[lookup][i]](message);
      }
      return message;
    }

    /*
     * function transform (info, opts)
     * Attempts to colorize the { level, message } of the given
     * `logform` info object.
     */
  }, {
    key: "transform",
    value: function transform(info, opts) {
      if (opts.all && typeof info[MESSAGE] === 'string') {
        info[MESSAGE] = this.colorize(info[LEVEL], info.level, info[MESSAGE]);
      }
      if (opts.level || opts.all || !opts.message) {
        info.level = this.colorize(info[LEVEL], info.level);
      }
      if (opts.all || opts.message) {
        info.message = this.colorize(info[LEVEL], info.level, info.message);
      }
      return info;
    }
  }], [{
    key: "addColors",
    value: function addColors(clrs) {
      var nextColors = Object.keys(clrs).reduce(function (acc, level) {
        acc[level] = hasSpace.test(clrs[level]) ? clrs[level].split(hasSpace) : clrs[level];
        return acc;
      }, {});
      Colorizer.allColors = Object.assign({}, Colorizer.allColors || {}, nextColors);
      return Colorizer.allColors;
    }
  }]);
  return Colorizer;
}();
/*
 * function colorize (info)
 * Returns a new instance of the colorize Format that applies
 * level colors to `info` objects. This was previously exposed
 * as { colorize: true } to transports in `winston < 3.0.0`.
 */
module.exports = function (opts) {
  return new Colorizer(opts);
};

//
// Attach the Colorizer for registration purposes
//
module.exports.Colorizer = module.exports.Format = Colorizer;

/***/ }),

/***/ 21145:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var format = __webpack_require__(58287);

/*
 * function cascade(formats)
 * Returns a function that invokes the `._format` function in-order
 * for the specified set of `formats`. In this manner we say that Formats
 * are "pipe-like", but not a pure pumpify implementation. Since there is no back
 * pressure we can remove all of the "readable" plumbing in Node streams.
 */
function cascade(formats) {
  if (!formats.every(isValidFormat)) {
    return;
  }
  return function (info) {
    var obj = info;
    for (var i = 0; i < formats.length; i++) {
      obj = formats[i].transform(obj, formats[i].options);
      if (!obj) {
        return false;
      }
    }
    return obj;
  };
}

/*
 * function isValidFormat(format)
 * If the format does not define a `transform` function throw an error
 * with more detailed usage.
 */
function isValidFormat(fmt) {
  if (typeof fmt.transform !== 'function') {
    throw new Error(['No transform function found on format. Did you create a format instance?', 'const myFormat = format(formatFn);', 'const instance = myFormat();'].join('\n'));
  }
  return true;
}

/*
 * function combine (info)
 * Returns a new instance of the combine Format which combines the specified
 * formats into a new format. This is similar to a pipe-chain in transform streams.
 * We choose to combine the prototypes this way because there is no back pressure in
 * an in-memory transform chain.
 */
module.exports = function () {
  for (var _len = arguments.length, formats = new Array(_len), _key = 0; _key < _len; _key++) {
    formats[_key] = arguments[_key];
  }
  var combinedFormat = format(cascade(formats));
  var instance = combinedFormat();
  instance.Format = combinedFormat.Format;
  return instance;
};

//
// Export the cascade method for use in cli and other
// combined formats that should not be assumed to be
// singletons.
//
module.exports.cascade = cascade;

/***/ }),

/***/ 2657:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint no-undefined: 0 */


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var format = __webpack_require__(58287);
var _require = __webpack_require__(15396),
  LEVEL = _require.LEVEL,
  MESSAGE = _require.MESSAGE;

/*
 * function errors (info)
 * If the `message` property of the `info` object is an instance of `Error`,
 * replace the `Error` object its own `message` property.
 *
 * Optionally, the Error's `stack` and/or `cause` properties can also be appended to the `info` object.
 */
module.exports = format(function (einfo, _ref) {
  var stack = _ref.stack,
    cause = _ref.cause;
  if (einfo instanceof Error) {
    var _Object$assign;
    var info = Object.assign({}, einfo, (_Object$assign = {
      level: einfo.level
    }, _defineProperty(_Object$assign, LEVEL, einfo[LEVEL] || einfo.level), _defineProperty(_Object$assign, "message", einfo.message), _defineProperty(_Object$assign, MESSAGE, einfo[MESSAGE] || einfo.message), _Object$assign));
    if (stack) info.stack = einfo.stack;
    if (cause) info.cause = einfo.cause;
    return info;
  }
  if (!(einfo.message instanceof Error)) return einfo;

  // Assign all enumerable properties and the
  // message property from the error provided.
  var err = einfo.message;
  Object.assign(einfo, err);
  einfo.message = err.message;
  einfo[MESSAGE] = err.message;

  // Assign the stack and/or cause if requested.
  if (stack) einfo.stack = err.stack;
  if (cause) einfo.cause = err.cause;
  return einfo;
});

/***/ }),

/***/ 58287:
/***/ (function(module) {

"use strict";


/*
 * Displays a helpful message and the source of
 * the format when it is invalid.
 */
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var InvalidFormatError = /*#__PURE__*/function (_Error) {
  _inherits(InvalidFormatError, _Error);
  var _super = _createSuper(InvalidFormatError);
  function InvalidFormatError(formatFn) {
    var _this;
    _classCallCheck(this, InvalidFormatError);
    _this = _super.call(this, "Format functions must be synchronous taking a two arguments: (info, opts)\nFound: ".concat(formatFn.toString().split('\n')[0], "\n"));
    Error.captureStackTrace(_assertThisInitialized(_this), InvalidFormatError);
    return _this;
  }
  return _createClass(InvalidFormatError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
/*
 * function format (formatFn)
 * Returns a create function for the `formatFn`.
 */
module.exports = function (formatFn) {
  if (formatFn.length > 2) {
    throw new InvalidFormatError(formatFn);
  }

  /*
   * function Format (options)
   * Base prototype which calls a `_format`
   * function and pushes the result.
   */
  function Format() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.options = options;
  }
  Format.prototype.transform = formatFn;

  //
  // Create a function which returns new instances of
  // FormatWrap for simple syntax like:
  //
  // require('winston').formats.json();
  //
  function createFormatWrap(opts) {
    return new Format(opts);
  }

  //
  // Expose the FormatWrap through the create function
  // for testability.
  //
  createFormatWrap.Format = Format;
  return createFormatWrap;
};

/***/ }),

/***/ 93048:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var format = __webpack_require__(58287);
var _require = __webpack_require__(15396),
  MESSAGE = _require.MESSAGE;
var stringify = __webpack_require__(87668);

/*
 * function replacer (key, value)
 * Handles proper stringification of Buffer and bigint output.
 */
function replacer(key, value) {
  // safe-stable-stringify does support BigInt, however, it doesn't wrap the value in quotes.
  // Leading to a loss in fidelity if the resulting string is parsed.
  // It would also be a breaking change for logform.
  if (typeof value === 'bigint') return value.toString();
  return value;
}

/*
 * function json (info)
 * Returns a new instance of the JSON format that turns a log `info`
 * object into pure JSON. This was previously exposed as { json: true }
 * to transports in `winston < 3.0.0`.
 */
module.exports = format(function (info, opts) {
  var jsonStringify = stringify.configure(opts);
  info[MESSAGE] = jsonStringify(info, opts.replacer || replacer, opts.space);
  return info;
});

/***/ }),

/***/ 44403:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var format = __webpack_require__(58287);

/*
 * function label (info)
 * Returns a new instance of the label Format which adds the specified
 * `opts.label` before the message. This was previously exposed as
 * { label: 'my label' } to transports in `winston < 3.0.0`.
 */
module.exports = format(function (info, opts) {
  if (opts.message) {
    info.message = "[".concat(opts.label, "] ").concat(info.message);
    return info;
  }
  info.label = opts.label;
  return info;
});

/***/ }),

/***/ 47371:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(52046),
  Colorizer = _require.Colorizer;

/*
 * Simple method to register colors with a simpler require
 * path within the module.
 */
module.exports = function (config) {
  Colorizer.addColors(config.colors || config);
  return config;
};

/***/ }),

/***/ 49660:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var format = __webpack_require__(58287);
var _require = __webpack_require__(15396),
  MESSAGE = _require.MESSAGE;
var jsonStringify = __webpack_require__(87668);

/*
 * function logstash (info)
 * Returns a new instance of the LogStash Format that turns a
 * log `info` object into pure JSON with the appropriate logstash
 * options. This was previously exposed as { logstash: true }
 * to transports in `winston < 3.0.0`.
 */
module.exports = format(function (info) {
  var logstash = {};
  if (info.message) {
    logstash['@message'] = info.message;
    delete info.message;
  }
  if (info.timestamp) {
    logstash['@timestamp'] = info.timestamp;
    delete info.timestamp;
  }
  logstash['@fields'] = info;
  info[MESSAGE] = jsonStringify(logstash);
  return info;
});

/***/ }),

/***/ 42883:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var format = __webpack_require__(58287);
function fillExcept(info, fillExceptKeys, metadataKey) {
  var savedKeys = fillExceptKeys.reduce(function (acc, key) {
    acc[key] = info[key];
    delete info[key];
    return acc;
  }, {});
  var metadata = Object.keys(info).reduce(function (acc, key) {
    acc[key] = info[key];
    delete info[key];
    return acc;
  }, {});
  Object.assign(info, savedKeys, _defineProperty({}, metadataKey, metadata));
  return info;
}
function fillWith(info, fillWithKeys, metadataKey) {
  info[metadataKey] = fillWithKeys.reduce(function (acc, key) {
    acc[key] = info[key];
    delete info[key];
    return acc;
  }, {});
  return info;
}

/**
 * Adds in a "metadata" object to collect extraneous data, similar to the metadata
 * object in winston 2.x.
 */
module.exports = format(function (info) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var metadataKey = 'metadata';
  if (opts.key) {
    metadataKey = opts.key;
  }
  var fillExceptKeys = [];
  if (!opts.fillExcept && !opts.fillWith) {
    fillExceptKeys.push('level');
    fillExceptKeys.push('message');
  }
  if (opts.fillExcept) {
    fillExceptKeys = opts.fillExcept;
  }
  if (fillExceptKeys.length > 0) {
    return fillExcept(info, fillExceptKeys, metadataKey);
  }
  if (opts.fillWith) {
    return fillWith(info, opts.fillWith, metadataKey);
  }
  return info;
});

/***/ }),

/***/ 33584:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _this = void 0;
var format = __webpack_require__(58287);
var ms = __webpack_require__(57824);

/*
 * function ms (info)
 * Returns an `info` with a `ms` property. The `ms` property holds the Value
 * of the time difference between two calls in milliseconds.
 */
module.exports = format(function (info) {
  var curr = +new Date();
  _this.diff = curr - (_this.prevTime || curr);
  _this.prevTime = curr;
  info.ms = "+".concat(ms(_this.diff));
  return info;
});

/***/ }),

/***/ 82886:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint no-unused-vars: 0 */


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = __webpack_require__(15396),
  configs = _require.configs,
  LEVEL = _require.LEVEL,
  MESSAGE = _require.MESSAGE;
var Padder = /*#__PURE__*/function () {
  function Padder() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      levels: configs.npm.levels
    };
    _classCallCheck(this, Padder);
    this.paddings = Padder.paddingForLevels(opts.levels, opts.filler);
    this.options = opts;
  }

  /**
   * Returns the maximum length of keys in the specified `levels` Object.
   * @param  {Object} levels Set of all levels to calculate longest level against.
   * @returns {Number} Maximum length of the longest level string.
   */
  _createClass(Padder, [{
    key: "transform",
    value:
    /**
     * Prepends the padding onto the `message` based on the `LEVEL` of
     * the `info`. This is based on the behavior of `winston@2` which also
     * prepended the level onto the message.
     *
     * See: https://github.com/winstonjs/winston/blob/2.x/lib/winston/logger.js#L198-L201
     *
     * @param  {Info} info Logform info object
     * @param  {Object} opts Options passed along to this instance.
     * @returns {Info} Modified logform info object.
     */
    function transform(info, opts) {
      info.message = "".concat(this.paddings[info[LEVEL]]).concat(info.message);
      if (info[MESSAGE]) {
        info[MESSAGE] = "".concat(this.paddings[info[LEVEL]]).concat(info[MESSAGE]);
      }
      return info;
    }
  }], [{
    key: "getLongestLevel",
    value: function getLongestLevel(levels) {
      var lvls = Object.keys(levels).map(function (level) {
        return level.length;
      });
      return Math.max.apply(Math, _toConsumableArray(lvls));
    }

    /**
     * Returns the padding for the specified `level` assuming that the
     * maximum length of all levels it's associated with is `maxLength`.
     * @param  {String} level Level to calculate padding for.
     * @param  {String} filler Repeatable text to use for padding.
     * @param  {Number} maxLength Length of the longest level
     * @returns {String} Padding string for the `level`
     */
  }, {
    key: "paddingForLevel",
    value: function paddingForLevel(level, filler, maxLength) {
      var targetLen = maxLength + 1 - level.length;
      var rep = Math.floor(targetLen / filler.length);
      var padding = "".concat(filler).concat(filler.repeat(rep));
      return padding.slice(0, targetLen);
    }

    /**
     * Returns an object with the string paddings for the given `levels`
     * using the specified `filler`.
     * @param  {Object} levels Set of all levels to calculate padding for.
     * @param  {String} filler Repeatable text to use for padding.
     * @returns {Object} Mapping of level to desired padding.
     */
  }, {
    key: "paddingForLevels",
    value: function paddingForLevels(levels) {
      var filler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';
      var maxLength = Padder.getLongestLevel(levels);
      return Object.keys(levels).reduce(function (acc, level) {
        acc[level] = Padder.paddingForLevel(level, filler, maxLength);
        return acc;
      }, {});
    }
  }]);
  return Padder;
}();
/*
 * function padLevels (info)
 * Returns a new instance of the padLevels Format which pads
 * levels to be the same length. This was previously exposed as
 * { padLevels: true } to transports in `winston < 3.0.0`.
 */
module.exports = function (opts) {
  return new Padder(opts);
};
module.exports.Padder = module.exports.Format = Padder;

/***/ }),

/***/ 28703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var inspect = (__webpack_require__(79720).inspect);
var format = __webpack_require__(58287);
var _require = __webpack_require__(15396),
  LEVEL = _require.LEVEL,
  MESSAGE = _require.MESSAGE,
  SPLAT = _require.SPLAT;

/*
 * function prettyPrint (info)
 * Returns a new instance of the prettyPrint Format that "prettyPrint"
 * serializes `info` objects. This was previously exposed as
 * { prettyPrint: true } to transports in `winston < 3.0.0`.
 */
module.exports = format(function (info) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  //
  // info[{LEVEL, MESSAGE, SPLAT}] are enumerable here. Since they
  // are internal, we remove them before util.inspect so they
  // are not printed.
  //
  var stripped = Object.assign({}, info);

  // Remark (indexzero): update this technique in April 2019
  // when node@6 is EOL
  delete stripped[LEVEL];
  delete stripped[MESSAGE];
  delete stripped[SPLAT];
  info[MESSAGE] = inspect(stripped, false, opts.depth || null, opts.colorize);
  return info;
});

/***/ }),

/***/ 82361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = __webpack_require__(15396),
  MESSAGE = _require.MESSAGE;
var Printf = /*#__PURE__*/function () {
  function Printf(templateFn) {
    _classCallCheck(this, Printf);
    this.template = templateFn;
  }
  _createClass(Printf, [{
    key: "transform",
    value: function transform(info) {
      info[MESSAGE] = this.template(info);
      return info;
    }
  }]);
  return Printf;
}();
/*
 * function printf (templateFn)
 * Returns a new instance of the printf Format that creates an
 * intermediate prototype to store the template string-based formatter
 * function.
 */
module.exports = function (opts) {
  return new Printf(opts);
};
module.exports.Printf = module.exports.Format = Printf;

/***/ }),

/***/ 82167:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint no-undefined: 0 */


var format = __webpack_require__(58287);
var _require = __webpack_require__(15396),
  MESSAGE = _require.MESSAGE;
var jsonStringify = __webpack_require__(87668);

/*
 * function simple (info)
 * Returns a new instance of the simple format TransformStream
 * which writes a simple representation of logs.
 *
 *    const { level, message, splat, ...rest } = info;
 *
 *    ${level}: ${message}                            if rest is empty
 *    ${level}: ${message} ${JSON.stringify(rest)}    otherwise
 */
module.exports = format(function (info) {
  var stringifiedRest = jsonStringify(Object.assign({}, info, {
    level: undefined,
    message: undefined,
    splat: undefined
  }));
  var padding = info.padding && info.padding[info.level] || '';
  if (stringifiedRest !== '{}') {
    info[MESSAGE] = "".concat(info.level, ":").concat(padding, " ").concat(info.message, " ").concat(stringifiedRest);
  } else {
    info[MESSAGE] = "".concat(info.level, ":").concat(padding, " ").concat(info.message);
  }
  return info;
});

/***/ }),

/***/ 67729:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var util = __webpack_require__(79720);
var _require = __webpack_require__(15396),
  SPLAT = _require.SPLAT;

/**
 * Captures the number of format (i.e. %s strings) in a given string.
 * Based on `util.format`, see Node.js source:
 * https://github.com/nodejs/node/blob/b1c8f15c5f169e021f7c46eb7b219de95fe97603/lib/util.js#L201-L230
 * @type {RegExp}
 */
var formatRegExp = /%[scdjifoO%]/g;

/**
 * Captures the number of escaped % signs in a format string (i.e. %s strings).
 * @type {RegExp}
 */
var escapedPercent = /%%/g;
var Splatter = /*#__PURE__*/function () {
  function Splatter(opts) {
    _classCallCheck(this, Splatter);
    this.options = opts;
  }

  /**
     * Check to see if tokens <= splat.length, assign { splat, meta } into the
     * `info` accordingly, and write to this instance.
     *
     * @param  {Info} info Logform info message.
     * @param  {String[]} tokens Set of string interpolation tokens.
     * @returns {Info} Modified info message
     * @private
     */
  _createClass(Splatter, [{
    key: "_splat",
    value: function _splat(info, tokens) {
      var msg = info.message;
      var splat = info[SPLAT] || info.splat || [];
      var percents = msg.match(escapedPercent);
      var escapes = percents && percents.length || 0;

      // The expected splat is the number of tokens minus the number of escapes
      // e.g.
      // - { expectedSplat: 3 } '%d %s %j'
      // - { expectedSplat: 5 } '[%s] %d%% %d%% %s %j'
      //
      // Any "meta" will be arugments in addition to the expected splat size
      // regardless of type. e.g.
      //
      // logger.log('info', '%d%% %s %j', 100, 'wow', { such: 'js' }, { thisIsMeta: true });
      // would result in splat of four (4), but only three (3) are expected. Therefore:
      //
      // extraSplat = 3 - 4 = -1
      // metas = [100, 'wow', { such: 'js' }, { thisIsMeta: true }].splice(-1, -1 * -1);
      // splat = [100, 'wow', { such: 'js' }]
      var expectedSplat = tokens.length - escapes;
      var extraSplat = expectedSplat - splat.length;
      var metas = extraSplat < 0 ? splat.splice(extraSplat, -1 * extraSplat) : [];

      // Now that { splat } has been separated from any potential { meta }. we
      // can assign this to the `info` object and write it to our format stream.
      // If the additional metas are **NOT** objects or **LACK** enumerable properties
      // you are going to have a bad time.
      var metalen = metas.length;
      if (metalen) {
        for (var i = 0; i < metalen; i++) {
          Object.assign(info, metas[i]);
        }
      }
      info.message = util.format.apply(util, [msg].concat(_toConsumableArray(splat)));
      return info;
    }

    /**
      * Transforms the `info` message by using `util.format` to complete
      * any `info.message` provided it has string interpolation tokens.
      * If no tokens exist then `info` is immutable.
      *
      * @param  {Info} info Logform info message.
      * @param  {Object} opts Options for this instance.
      * @returns {Info} Modified info message
      */
  }, {
    key: "transform",
    value: function transform(info) {
      var msg = info.message;
      var splat = info[SPLAT] || info.splat;

      // No need to process anything if splat is undefined
      if (!splat || !splat.length) {
        return info;
      }

      // Extract tokens, if none available default to empty array to
      // ensure consistancy in expected results
      var tokens = msg && msg.match && msg.match(formatRegExp);

      // This condition will take care of inputs with info[SPLAT]
      // but no tokens present
      if (!tokens && (splat || splat.length)) {
        var metas = splat.length > 1 ? splat.splice(0) : splat;

        // Now that { splat } has been separated from any potential { meta }. we
        // can assign this to the `info` object and write it to our format stream.
        // If the additional metas are **NOT** objects or **LACK** enumerable properties
        // you are going to have a bad time.
        var metalen = metas.length;
        if (metalen) {
          for (var i = 0; i < metalen; i++) {
            Object.assign(info, metas[i]);
          }
        }
        return info;
      }
      if (tokens) {
        return this._splat(info, tokens);
      }
      return info;
    }
  }]);
  return Splatter;
}();
/*
 * function splat (info)
 * Returns a new instance of the splat format TransformStream
 * which performs string interpolation from `info` objects. This was
 * previously exposed implicitly in `winston < 3.0.0`.
 */
module.exports = function (opts) {
  return new Splatter(opts);
};

/***/ }),

/***/ 7271:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var fecha = __webpack_require__(19432);
var format = __webpack_require__(58287);

/*
 * function timestamp (info)
 * Returns a new instance of the timestamp Format which adds a timestamp
 * to the info. It was previously available in winston < 3.0.0 as:
 *
 * - { timestamp: true }             // `new Date.toISOString()`
 * - { timestamp: function:String }  // Value returned by `timestamp()`
 */
module.exports = format(function (info) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (opts.format) {
    info.timestamp = typeof opts.format === 'function' ? opts.format() : fecha.format(new Date(), opts.format);
  }
  if (!info.timestamp) {
    info.timestamp = new Date().toISOString();
  }
  if (opts.alias) {
    info[opts.alias] = info.timestamp;
  }
  return info;
});

/***/ }),

/***/ 39729:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var colors = __webpack_require__(33645);
var format = __webpack_require__(58287);
var _require = __webpack_require__(15396),
  MESSAGE = _require.MESSAGE;

/*
 * function uncolorize (info)
 * Returns a new instance of the uncolorize Format that strips colors
 * from `info` objects. This was previously exposed as { stripColors: true }
 * to transports in `winston < 3.0.0`.
 */
module.exports = format(function (info, opts) {
  if (opts.level !== false) {
    info.level = colors.strip(info.level);
  }
  if (opts.message !== false) {
    info.message = colors.strip(String(info.message));
  }
  if (opts.raw !== false && info[MESSAGE]) {
    info[MESSAGE] = colors.strip(String(info[MESSAGE]));
  }
  return info;
});

/***/ }),

/***/ 79235:
/***/ (function(module) {

"use strict";


/*
 * Displays a helpful message and the source of
 * the format when it is invalid.
 */
class InvalidFormatError extends Error {
  constructor(formatFn) {
    super(`Format functions must be synchronous taking a two arguments: (info, opts)
Found: ${formatFn.toString().split('\n')[0]}\n`);

    Error.captureStackTrace(this, InvalidFormatError);
  }
}

/*
 * function format (formatFn)
 * Returns a create function for the `formatFn`.
 */
module.exports = formatFn => {
  if (formatFn.length > 2) {
    throw new InvalidFormatError(formatFn);
  }

  /*
   * function Format (options)
   * Base prototype which calls a `_format`
   * function and pushes the result.
   */
  function Format(options = {}) {
    this.options = options;
  }

  Format.prototype.transform = formatFn;

  //
  // Create a function which returns new instances of
  // FormatWrap for simple syntax like:
  //
  // require('winston').formats.json();
  //
  function createFormatWrap(opts) {
    return new Format(opts);
  }

  //
  // Expose the FormatWrap through the create function
  // for testability.
  //
  createFormatWrap.Format = Format;
  return createFormatWrap;
};


/***/ }),

/***/ 13922:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const format = __webpack_require__(79235);
const { MESSAGE } = __webpack_require__(15396);
const stringify = __webpack_require__(87668);

/*
 * function replacer (key, value)
 * Handles proper stringification of Buffer and bigint output.
 */
function replacer(key, value) {
  // safe-stable-stringify does support BigInt, however, it doesn't wrap the value in quotes.
  // Leading to a loss in fidelity if the resulting string is parsed.
  // It would also be a breaking change for logform.
  if (typeof value === 'bigint')
    return value.toString();
  return value;
}

/*
 * function json (info)
 * Returns a new instance of the JSON format that turns a log `info`
 * object into pure JSON. This was previously exposed as { json: true }
 * to transports in `winston < 3.0.0`.
 */
module.exports = format((info, opts) => {
  const jsonStringify = stringify.configure(opts);
  info[MESSAGE] = jsonStringify(info, opts.replacer || replacer, opts.space);
  return info;
});


/***/ }),

/***/ 30381:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    0
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            "object" !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = undefined;
                Object(function webpackMissingModule() { var e = new Error("Cannot find module 'undefined'"); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.4';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));


/***/ }),

/***/ 57824:
/***/ (function(module) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'weeks':
    case 'week':
    case 'w':
      return n * w;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }
  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }
  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }
  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }
  return ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}


/***/ }),

/***/ 28858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KV": function() { return /* binding */ createWrapper; },
/* harmony export */   "ju": function() { return /* binding */ HYDRATE; }
/* harmony export */ });
/* unused harmony export STOREKEY */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14416);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


var HYDRATE = '__NEXT_REDUX_WRAPPER_HYDRATE__';
var STOREKEY = '__NEXT_REDUX_WRAPPER_STORE__';
var getIsServer = function () { return typeof window === 'undefined'; };
var getDeserializedState = function (initialState, _a) {
    var deserializeState = (_a === void 0 ? {} : _a).deserializeState;
    return deserializeState ? deserializeState(initialState) : initialState;
};
var getSerializedState = function (state, _a) {
    var serializeState = (_a === void 0 ? {} : _a).serializeState;
    return serializeState ? serializeState(state) : state;
};
var getStoreKey = function (_a) {
    var storeKey = (_a === void 0 ? {} : _a).storeKey;
    return storeKey || STOREKEY;
};
var initStore = function (_a) {
    var makeStore = _a.makeStore, context = _a.context, config = _a.config;
    var storeKey = getStoreKey(config);
    var createStore = function () { return makeStore(context); };
    if (getIsServer()) {
        var c = context;
        var req = void 0;
        if (c.req)
            req = c.req;
        if (c.ctx && c.ctx.req)
            req = c.ctx.req;
        if (req) {
            // ATTENTION! THIS IS INTERNAL, DO NOT ACCESS DIRECTLY ANYWHERE ELSE
            // @see https://github.com/kirill-konshin/next-redux-wrapper/pull/196#issuecomment-611673546
            if (!req.__nextReduxWrapperStore)
                req.__nextReduxWrapperStore = createStore();
            return req.__nextReduxWrapperStore;
        }
        return createStore();
    }
    // Memoize store if client
    if (!(storeKey in window)) {
        window[storeKey] = createStore();
    }
    return window[storeKey];
};
var createWrapper = function (makeStore, config) {
    if (config === void 0) { config = {}; }
    var makeProps = function (_a) {
        var callback = _a.callback, context = _a.context, _b = _a.isApp, isApp = _b === void 0 ? false : _b;
        return __awaiter(void 0, void 0, void 0, function () {
            var store, initialProps, _c, state;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        store = initStore({ context: context, makeStore: makeStore, config: config });
                        if (config.debug)
                            console.log("1. getProps created store with state", store.getState());
                        _c = callback;
                        if (!_c) return [3 /*break*/, 2];
                        return [4 /*yield*/, callback(
                            // merging store into context instead of just passing as another argument because it's impossible to override getInitialProps signature
                            isApp ? __assign(__assign({}, context), { ctx: __assign(__assign({}, context.ctx), { store: store }) }) : __assign(__assign({}, context), { store: store }))];
                    case 1:
                        _c = (_d.sent());
                        _d.label = 2;
                    case 2:
                        initialProps = (_c) ||
                            {};
                        if (config.debug)
                            console.log("3. getProps after dispatches has store state", store.getState());
                        state = store.getState();
                        return [2 /*return*/, {
                                initialProps: initialProps,
                                initialState: getIsServer() ? getSerializedState(state, config) : state,
                            }];
                }
            });
        });
    };
    var getInitialPageProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (context.store) {
                console.warn('No need to wrap pages if _app was wrapped');
                return [2 /*return*/, callback(context)];
            }
            return [2 /*return*/, makeProps({ callback: callback, context: context })];
        });
    }); }; };
    var getInitialAppProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, makeProps({ callback: callback, context: context, isApp: true })];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    }); }); }; }; // this is just to convince TS
    var getStaticProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, props, settings, wrapperProps;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, makeProps({ callback: callback, context: context })];
                case 1:
                    _a = _c.sent(), _b = _a.initialProps, props = _b.props, settings = __rest(_b, ["props"]), wrapperProps = __rest(_a, ["initialProps"]);
                    return [2 /*return*/, __assign(__assign({}, settings), { props: __assign(__assign({}, wrapperProps), props) })];
            }
        });
    }); }; };
    var getServerSideProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getStaticProps(callback)(context)];
                case 1: return [2 /*return*/, _a.sent()]; // just not to repeat myself
            }
        });
    }); }; };
    var withRedux = function (Component) {
        var displayName = "withRedux(" + (Component.displayName || Component.name || 'Component') + ")";
        //TODO Check if pages/_app was wrapped so there's no need to wrap a page itself
        var Wrapper = function (_a, context) {
            var _b;
            var initialState = _a.initialState, initialProps = _a.initialProps, props = __rest(_a, ["initialState", "initialProps"]);
            var isFirstRender = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
            // this happens when App has page with getServerSideProps/getStaticProps
            var initialStateFromGSPorGSSR = (_b = props === null || props === void 0 ? void 0 : props.pageProps) === null || _b === void 0 ? void 0 : _b.initialState;
            if (config.debug)
                console.log('4. WrappedApp created new store with', displayName, {
                    initialState: initialState,
                    initialStateFromGSPorGSSR: initialStateFromGSPorGSSR,
                });
            var store = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(initStore({ makeStore: makeStore, config: config, context: context }));
            var hydrate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
                if (initialState)
                    store.current.dispatch({
                        type: HYDRATE,
                        payload: getDeserializedState(initialState, config),
                    });
                // ATTENTION! This code assumes that Page's getServerSideProps is executed after App.getInitialProps
                // so we dispatch in this order
                if (initialStateFromGSPorGSSR)
                    store.current.dispatch({
                        type: HYDRATE,
                        payload: getDeserializedState(initialStateFromGSPorGSSR, config),
                    });
            }, [initialStateFromGSPorGSSR, initialState]);
            // apply synchronously on first render (both server side and client side)
            if (isFirstRender.current)
                hydrate();
            // apply async in case props have changed, on navigation for example
            (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
                if (isFirstRender.current) {
                    isFirstRender.current = false;
                    return;
                }
                hydrate();
            }, [hydrate]);
            // order is important! Next.js overwrites props from pages/_app with getStaticProps from page
            // @see https://github.com/zeit/next.js/issues/11648
            if (initialProps && initialProps.pageProps)
                props.pageProps = __assign(__assign({}, initialProps.pageProps), props.pageProps);
            var resultProps = props;
            // just some cleanup to prevent passing it as props, we need to clone props to safely delete initialState
            if (initialStateFromGSPorGSSR) {
                resultProps = __assign(__assign({}, props), { pageProps: __assign({}, props.pageProps) });
                delete resultProps.pageProps.initialState;
            }
            return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_redux__WEBPACK_IMPORTED_MODULE_1__/* .Provider */ .zt, { store: store.current },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, __assign({}, initialProps, resultProps))));
        };
        Wrapper.displayName = displayName;
        if ('getInitialProps' in Component)
            Wrapper.getInitialProps = function (context) { return __awaiter(void 0, void 0, void 0, function () {
                var callback;
                return __generator(this, function (_a) {
                    callback = Component.getInitialProps;
                    return [2 /*return*/, (context.ctx ? getInitialAppProps(callback) : getInitialPageProps(callback))(context)];
                });
            }); };
        return Wrapper;
    };
    return {
        getServerSideProps: getServerSideProps,
        getStaticProps: getStaticProps,
        withRedux: withRedux,
    };
};
// Legacy
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (function (makeStore, config) {
    if (config === void 0) { config = {}; }
    console.warn('/!\\ You are using legacy implementaion. Please update your code: use createWrapper() and wrapper.withRedux().');
    return createWrapper(makeStore, config).withRedux;
});
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 52627:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
// Polyfill fetch
__webpack_require__(63144);
var _apolloClient;
function initApollo(clientFn, options) {
    if (!clientFn) {
        throw new Error('[withApollo] the first param is missing and is required to get the ApolloClient');
    }
    if (typeof window === 'undefined') {
        return getClient(clientFn, options);
    }
    if (!_apolloClient) {
        _apolloClient = getClient(clientFn, options);
    }
    return _apolloClient;
}
exports["default"] = initApollo;
function getClient(clientFn, options) {
    if (options === void 0) { options = {}; }
    if (typeof clientFn !== 'function') {
        throw new Error('[withApollo] requires a function that returns an ApolloClient');
    }
    return clientFn(options);
}


/***/ }),

/***/ 84763:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var withApollo_1 = __importDefault(__webpack_require__(39673));
exports.withApollo = withApollo_1.default;
var apollo_1 = __webpack_require__(52627);
exports.initApollo = apollo_1.default;
exports["default"] = withApollo_1.default;


/***/ }),

/***/ 39673:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(67294));
var apollo_1 = __importDefault(__webpack_require__(52627));
// Gets the display name of a JSX component for dev tools
function getDisplayName(Component) {
    return Component.displayName || Component.name || 'Unknown';
}
function withApollo(client, options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    return function (Page, pageOptions) {
        if (pageOptions === void 0) { pageOptions = {}; }
        var getInitialProps = Page.getInitialProps;
        var getDataFromTree = 'getDataFromTree' in pageOptions
            ? pageOptions.getDataFromTree
            : options.getDataFromTree;
        var render = pageOptions.render || options.render;
        var onError = pageOptions.onError || options.onError;
        function WithApollo(_a) {
            var _b;
            var apollo = _a.apollo, apolloState = _a.apolloState, router = _a.router, props = __rest(_a, ["apollo", "apolloState", "router"]);
            var apolloClient = apollo ||
                apollo_1.default(client, {
                    initialState: (_b = apolloState) === null || _b === void 0 ? void 0 : _b.data,
                    router: router
                });
            if (render) {
                return render({
                    Page: Page,
                    props: __assign(__assign({}, props), { apollo: apolloClient })
                });
            }
            return react_1.default.createElement(Page, __assign({}, props, { apollo: apolloClient }));
        }
        WithApollo.displayName = "WithApollo(" + getDisplayName(Page) + ")";
        if (getInitialProps || getDataFromTree) {
            WithApollo.getInitialProps = function (pageCtx) { return __awaiter(_this, void 0, void 0, function () {
                var ctx, router, AppTree, headers, apollo, apolloState, pageProps, props, appTreeProps, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            ctx = 'Component' in pageCtx ? pageCtx.ctx : pageCtx;
                            router = 'Component' in pageCtx ? pageCtx.router : undefined;
                            AppTree = pageCtx.AppTree;
                            headers = ctx.req ? ctx.req.headers : {};
                            apollo = apollo_1.default(client, {
                                ctx: ctx,
                                headers: headers,
                                router: router
                            });
                            apolloState = {};
                            pageProps = {};
                            if (!getInitialProps) return [3 /*break*/, 2];
                            ctx.apolloClient = apollo;
                            return [4 /*yield*/, getInitialProps(pageCtx)];
                        case 1:
                            pageProps = _a.sent();
                            _a.label = 2;
                        case 2:
                            if (!(typeof window === 'undefined')) return [3 /*break*/, 7];
                            if (ctx.res && (ctx.res.headersSent || ctx.res.finished)) {
                                return [2 /*return*/, pageProps];
                            }
                            if (!getDataFromTree) return [3 /*break*/, 7];
                            _a.label = 3;
                        case 3:
                            _a.trys.push([3, 5, , 6]);
                            props = __assign(__assign({}, pageProps), { apolloState: apolloState, apollo: apollo });
                            appTreeProps = 'Component' in pageCtx ? props : { pageProps: props };
                            return [4 /*yield*/, getDataFromTree(react_1.default.createElement(AppTree, __assign({}, appTreeProps)))];
                        case 4:
                            _a.sent();
                            return [3 /*break*/, 6];
                        case 5:
                            error_1 = _a.sent();
                            if (onError) {
                                onError(error_1, ctx);
                            }
                            else {
                                // Prevent Apollo Client GraphQL errors from crashing SSR.
                                if (false) {}
                            }
                            return [3 /*break*/, 6];
                        case 6:
                            apolloState.data = apollo.cache.extract();
                            _a.label = 7;
                        case 7:
                            // To avoid calling initApollo() twice in the server we send the Apollo Client as a prop
                            // to the component, otherwise the component would have to call initApollo() again but this
                            // time without the context, once that happens the following code will make sure we send
                            // the prop as `null` to the browser
                            apollo.toJSON = function () {
                                return null;
                            };
                            return [2 /*return*/, __assign(__assign({}, pageProps), { apolloState: apolloState,
                                    apollo: apollo })];
                    }
                });
            }); };
        }
        return WithApollo;
    };
}
exports["default"] = withApollo;


/***/ }),

/***/ 7544:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(46029)


/***/ }),

/***/ 63144:
/***/ (function(module) {

"use strict";

/* globals self */ var fetch = self.fetch.bind(self);
module.exports = fetch;
module.exports["default"] = module.exports;

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 83454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(77663);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(11901);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 48930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ paymentGatewayVendorConstant; }
/* harmony export */ });
var paymentGatewayVendorConstant = {
    STRIPE: "STRIPE",
    EBIX: "EBIX",
    RAZORPAY: "RAZORPAY",
    LEAP_PAYMENT: "LEAP_PAYMENT",
    RAZOR_PAY_LINK: "RAZOR_PAY_LINK",
    BKASH: "BKASH"
};


/***/ }),

/***/ 64840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ productType; }
/* harmony export */ });
var productType = {
    ielts: "ielts",
    fastTrack: "fast_track",
    selfPrep: "self_prep",
    free: "free"
};


/***/ }),

/***/ 93957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ priceBundleName; },
/* harmony export */   "d": function() { return /* binding */ batchType; }
/* harmony export */ });
var batchType = {
    ONLINE_WORKSHOP: "ONLINE_WORKSHOP",
    PTE_ONLINE_WORKSHOP: "PTE_ONLINE_WORKSHOP",
    DET_ONLINE_WORKSHOP: "DET_ONLINE_WORKSHOP",
    MASTER_CLASS: "MASTER_CLASS",
    SPEAKING_WORKSHOP: "SPEAKING_WORKSHOP",
    SPEAKING_ELITE_WORKSHOP: "SPEAKING_ELITE_WORKSHOP",
    ESSAY_EVALUATION: "ESSAY_EVALUATION",
    DOUBT_WORKSHOP: "DOUBT_WORKSHOP",
    FAST_TRACK_EXTRA_CLASSES: "FAST_TRACK_EXTRA_CLASSES",
    BEGINNER_MASTER_CLASS: "BEGINNER_MASTER_CLASS",
    FOUNDATION_ONLINE_WORKSHOP: "FOUNDATION_ONLINE_WORKSHOP",
    ORIENTATION_WORKSHOP: "IELTS_PLUS_ORIENTATION"
};
var priceBundleName;
(function(priceBundleName) {
    priceBundleName["IELTS_FOUNDATION"] = "IELTS_FOUNDATION";
    priceBundleName["IELTS_PLUS"] = "IELTS_PLUS";
    priceBundleName["IELTS_PLUS_PREMIUM"] = "IELTS_PLUS_PREMIUM";
    priceBundleName["IELTS_PLUS_PREMIUM_2"] = "IELTS_PLUS_PREMIUM_2";
    priceBundleName["IELTS_PLUS_PREMIUM_3"] = "IELTS_PLUS_PREMIUM_3";
    priceBundleName["BOOSTER_PACK"] = "BOOSTER_PACK";
    priceBundleName["IELTS_MOCK_TEST_FEE"] = "IELTS_MOCK_TEST_FEE";
    priceBundleName["IELTS_PLUS_PART_2"] = "IELTS_PLUS_PART_II_V1";
    priceBundleName["IELTS_FREE_MOCKTEST_FEE"] = "IELTS_FREE_MOCKTEST_FEE";
    priceBundleName["IELTS_PAID_MOCKTEST_FEE"] = "IELTS_PAID_MOCKTEST_FEE";
    priceBundleName["IELTS_SELECT"] = "IELTS_SELECT";
    priceBundleName["IELTS_ELITE"] = "IELTS_ELITE";
    priceBundleName["IELTS_SELECT_V2"] = "IELTS_SELECT_V2";
    priceBundleName["IELTS_ELITE_V1"] = "IELTS_ELITE_V1";
    priceBundleName["IELTS_CUSTOM"] = "IELTS_CUSTOM";
    priceBundleName["SELF_PREP_KICKSTART_GENERAL"] = "SELF_PREP_KICKSTART_GENERAL";
    priceBundleName["SELF_PREP_KICKSTART_ACADEMIC"] = "SELF_PREP_KICKSTART_ACADEMIC";
    priceBundleName["SELF_PREP_ULTIMATE_GENERAL"] = "SELF_PREP_ULTIMATE_GENERAL";
    priceBundleName["SELF_PREP_ULTIMATE_ACADEMIC"] = "SELF_PREP_ULTIMATE_ACADEMIC";
    priceBundleName["IELTS_LIY_COURSE"] = "IELTS_LIY_COURSE";
})(priceBundleName || (priceBundleName = {}));


/***/ }),

/***/ 24187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ basicAuthToken; }
/* harmony export */ });
var basicAuthToken = "Basic aWVsdHNfdXNlcjppZWx0c1B3ZDIwMjMjISFATG9jaw==";


/***/ }),

/***/ 18472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ cookiesConstant; }
/* harmony export */ });
/* unused harmony export cookiesTtl */
var cookiesConstant = {
    downloadAppModal: "downloadAppModal",
    IELTS_COURSE_REFFERER: "ieltsCourseReferer",
    USER_COUNTRY: "user_country",
    NEED_HELP_OPENED: "need_help_opened",
    USER_ID: "user_id",
    IP_COUNTRY_KEY: "IP_COUNTRY_KEY"
};
var cookiesTtl = {
    downloadAppModal: 60 * 30
};


/***/ }),

/***/ 88237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cv": function() { return /* binding */ CountryCode; },
/* harmony export */   "O$": function() { return /* binding */ countryOptions; },
/* harmony export */   "TZ": function() { return /* binding */ CountryList; },
/* harmony export */   "hW": function() { return /* binding */ countries; },
/* harmony export */   "qO": function() { return /* binding */ countryData; },
/* harmony export */   "tj": function() { return /* binding */ validatePhoneNumberOnCountry; },
/* harmony export */   "tr": function() { return /* binding */ countryAndCurrencySymbol; },
/* harmony export */   "zn": function() { return /* binding */ countriesAndReferalAmount; }
/* harmony export */ });
/* unused harmony exports countriesAndPhNoLength, CountryCodeMapping, Currency, countryAndCurrency */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




var CountryCode;
(function(CountryCode) {
    CountryCode["INDIA"] = "INDIA";
    CountryCode["BANGLADESH"] = "BANGLADESH";
    CountryCode["UAE"] = "UAE";
    CountryCode["QATAR"] = "QATAR";
    CountryCode["SAUDI"] = "SAUDI";
    CountryCode["KUWAIT"] = "KUWAIT";
    CountryCode["BAHRAIN"] = "BAHRAIN";
    CountryCode["OMAN"] = "OMAN";
    CountryCode["ALGERIA"] = "ALGERIA";
    CountryCode["EGYPT"] = "EGYPT";
    CountryCode["IRAN"] = "IRAN";
    CountryCode["IRAQ"] = "IRAQ";
    CountryCode["ISRAEL"] = "ISRAEL";
    CountryCode["JORDAN"] = "JORDAN";
    CountryCode["LEBANON"] = "LEBANON";
    CountryCode["LIBYA"] = "LIBYA";
    CountryCode["MOROCCO"] = "MOROCCO";
    CountryCode["SYRIA"] = "SYRIA";
    CountryCode["TUNISIA"] = "TUNISIA";
    CountryCode["PALESTINE"] = "PALESTINE";
    CountryCode["YEMEN"] = "YEMEN";
})(CountryCode || (CountryCode = {}));
var INDIA = CountryCode.INDIA, BANGLADESH = CountryCode.BANGLADESH, UAE = CountryCode.UAE, QATAR = CountryCode.QATAR, SAUDI = CountryCode.SAUDI, KUWAIT = CountryCode.KUWAIT, BAHRAIN = CountryCode.BAHRAIN, OMAN = CountryCode.OMAN, ALGERIA = CountryCode.ALGERIA, EGYPT = CountryCode.EGYPT, IRAN = CountryCode.IRAN, IRAQ = CountryCode.IRAQ, ISRAEL = CountryCode.ISRAEL, JORDAN = CountryCode.JORDAN, LEBANON = CountryCode.LEBANON, LIBYA = CountryCode.LIBYA, MOROCCO = CountryCode.MOROCCO, SYRIA = CountryCode.SYRIA, TUNISIA = CountryCode.TUNISIA, PALESTINE = CountryCode.PALESTINE, YEMEN = CountryCode.YEMEN;
var _obj;
var countryData = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, INDIA, {
    code: "91",
    flag: "https://leapassets.s3.ap-south-1.amazonaws.com/workshop/1658603976706-india.png"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BANGLADESH, {
    code: "880",
    flag: "https://leapassets.s3.ap-south-1.amazonaws.com/workshop/1658603952340-bangladesh.png"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, UAE, {
    code: "971",
    flag: "https://leap-public.s3.ap-south-1.amazonaws.com/web/assets/flags/UAE.png"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, QATAR, {
    code: "974",
    flag: "https://leap-public.s3.ap-south-1.amazonaws.com/web/assets/flags/QA.png"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, SAUDI, {
    code: "966",
    flag: "https://leap-public.s3.ap-south-1.amazonaws.com/web/assets/flags/SA.png"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, KUWAIT, {
    code: "965",
    flag: "https://leap-public.s3.ap-south-1.amazonaws.com/web/assets/flags/KW.png"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, OMAN, {
    code: "968",
    flag: "https://leap-public.s3.ap-south-1.amazonaws.com/web/assets/flags/OM.png"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BAHRAIN, {
    code: "973",
    flag: "https://leap-public.s3.ap-south-1.amazonaws.com/web/assets/flags/BH.png"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, ALGERIA, {
    code: "213",
    flag: "https://ik.imagekit.io/onsnhxjshmp/LeapScholar/country_flag/africa_flag/Algeria_roCYuPGcb.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, EGYPT, {
    code: "20",
    flag: "https://ik.imagekit.io/onsnhxjshmp/LeapScholar/country_flag/africa_flag/Egypt_3eyykyjr3.svg"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, IRAN, {
    code: "98",
    flag: "https://ik.imagekit.io/onsnhxjshmp/LeapScholar/country_flag/asia_flag/Iran_48h_Z655b.svg?updatedAt=1699525262737"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, IRAQ, {
    code: "964",
    flag: "https://ik.imagekit.io/onsnhxjshmp/LeapScholar/country_flag/asia_flag/Iraq_NpssNb7PE.svg?updatedAt=1699525267602"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, ISRAEL, {
    code: "972",
    flag: "https://ik.imagekit.io/onsnhxjshmp/LeapScholar/country_flag/asia_flag/Israel_U7sL68D_0.svg?updatedAt=1699525272447"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, JORDAN, {
    code: "962",
    flag: "https://ik.imagekit.io/onsnhxjshmp/LeapScholar/country_flag/asia_flag/Jordan_OEPvB2wQl.svg?updatedAt=1699525266100"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, LEBANON, {
    code: "961",
    flag: "https://ik.imagekit.io/onsnhxjshmp/LeapScholar/country_flag/asia_flag/Lebanon_5XoLErrrX.svg?updatedAt=1699525267444"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, LIBYA, {
    code: "218",
    flag: "https://ik.imagekit.io/onsnhxjshmp/LeapScholar/country_flag/africa_flag/Libya_HxdvU-nDWA.svg?updatedAt=1699525238291"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MOROCCO, {
    code: "212",
    flag: "https://ik.imagekit.io/onsnhxjshmp/LeapScholar/country_flag/africa_flag/Marocco_rMX7GJ1yp.svg?updatedAt=1699525242189"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, SYRIA, {
    code: "963",
    flag: "https://ik.imagekit.io/onsnhxjshmp/LeapScholar/country_flag/asia_flag/Syria_GRpds7uxo_.svg?updatedAt=1699525257097"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, TUNISIA, {
    code: "216",
    flag: "https://ik.imagekit.io/onsnhxjshmp/LeapScholar/country_flag/africa_flag/Tunis_ijCgxwodF.svg?updatedAt=1699525252697"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, PALESTINE, {
    code: "970",
    flag: "https://ik.imagekit.io/onsnhxjshmp/LeapScholar/country_flag/asia_flag/Palestine_Eij7JLyEP.svg?updatedAt=1699525266833"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, YEMEN, {
    code: "967",
    flag: "https://ik.imagekit.io/onsnhxjshmp/LeapScholar/country_flag/asia_flag/Yemen_RBe2dBjK3a.svg?updatedAt=1699525275206"
}), _obj);
var _obj1;
var countriesAndPhNoLength = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, INDIA, 10), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, BANGLADESH, 10), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, SAUDI, 9), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, QATAR, 8), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, KUWAIT, 8), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, BAHRAIN, 8), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, OMAN, 8), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, UAE, 9), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ALGERIA, 9), // @todo - verify valid phone number length below
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, EGYPT, 9), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, IRAN, 9), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, IRAQ, 9), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ISRAEL, 9), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, JORDAN, 9), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, LEBANON, 9), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, LIBYA, 9), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, MOROCCO, 9), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, SYRIA, 9), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, TUNISIA, 9), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, PALESTINE, 9), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, YEMEN, 9), _obj1);
var validatePhoneNumberOnCountry = function(number, country) {
    if (country && (number === null || number === void 0 ? void 0 : number.length) === countriesAndPhNoLength[country]) {
        return true;
    } else {
        if ((number === null || number === void 0 ? void 0 : number.length) !== 10) return false;
    }
    return false;
};
var countries = [
    {
        label: "India",
        value: INDIA
    },
    {
        label: "Bangladesh",
        value: BANGLADESH
    },
    {
        label: "UAE",
        value: UAE
    },
    {
        label: "Bahrain",
        value: BAHRAIN
    },
    {
        label: "Kuwait",
        value: KUWAIT
    },
    {
        label: "Oman",
        value: OMAN
    },
    {
        label: "Qatar",
        value: QATAR
    },
    {
        label: "Saudi Arabia",
        value: SAUDI
    }, 
];
var CountryCodeMapping = Object.keys(countryData).reduce(function(acc, country) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, countryData[country].code, country));
}, {});
var MIDDLE_EAST_COUNTRIES_IN_FORM = [
    CountryCode.INDIA,
    CountryCode.SAUDI,
    CountryCode.QATAR,
    CountryCode.UAE,
    CountryCode.BAHRAIN,
    CountryCode.KUWAIT,
    CountryCode.OMAN, 
];
var countryOptions = Object.keys(countryData).filter(function(item1) {
    return MIDDLE_EAST_COUNTRIES_IN_FORM.find(function(item2) {
        return item2 === item1;
    });
}).map(function(item) {
    return {
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
            className: "flex items-center gap-x-2",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: countryData[item].flag,
                    alt: "".concat(item, " flag"),
                    width: 28,
                    height: 20
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "inline-block font-bold",
                    children: [
                        "+",
                        countryData[item].code
                    ]
                })
            ]
        }, item),
        value: item
    };
});
var Currency;
(function(Currency) {
    Currency["INR"] = "INR";
    Currency["BDT"] = "BDT";
    Currency["SAR"] = "SAR";
    Currency["QAR"] = "QAR";
    Currency["AED"] = "AED";
})(Currency || (Currency = {}));
var _obj2;
//@ts-ignore // only added required countries
var countryAndCurrency = (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, INDIA, Currency.INR), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, SAUDI, Currency.SAR), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, QATAR, Currency.QAR), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, UAE, Currency.AED), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, BAHRAIN, Currency.AED), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, KUWAIT, Currency.AED), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, OMAN, Currency.AED), _obj2);
var _obj3;
//@ts-ignore // only added required countries
var countryAndCurrencySymbol = (_obj3 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, INDIA, "₹"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, BANGLADESH, Currency.BDT), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, SAUDI, Currency.SAR), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, QATAR, Currency.QAR), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, UAE, Currency.AED), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, BAHRAIN, Currency.AED), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, KUWAIT, Currency.AED), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, OMAN, Currency.AED), _obj3);
var _obj4;
//@ts-ignore // only added required countries
var countriesAndReferalAmount = (_obj4 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, INDIA, 1000), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, SAUDI, 50), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, QATAR, 50), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, UAE, 50), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, BAHRAIN, 50), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, KUWAIT, 50), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, OMAN, 50), _obj4);
var CountryList;
(function(CountryList) {
    CountryList["BH"] = "BAHRAIN";
    CountryList["OM"] = "OMAN";
    CountryList["QA"] = "QATAR";
    CountryList["KW"] = "KUWAIT";
    CountryList["IN"] = "INDIA";
    CountryList["BD"] = "BANGLADESH";
    CountryList["AE"] = "UAE";
    CountryList["SA"] = "SAUDI";
})(CountryList || (CountryList = {}));


/***/ }),

/***/ 1692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dy": function() { return /* binding */ userAttributeName; },
/* harmony export */   "f2": function() { return /* binding */ eventCategory; },
/* harmony export */   "oJ": function() { return /* binding */ eventName; },
/* harmony export */   "sx": function() { return /* binding */ WEeventDataAttributeNames; },
/* harmony export */   "uN": function() { return /* binding */ gaEvents; }
/* harmony export */ });
var eventName = {
    NEW_IELTS_LEAD: "New Ielts Lead",
    NEW_PTE_LEAD: "New PTE Lead",
    EXPLORE_COURSES: "Explore Courses",
    SUBSCRIBE_MASTERCLASS: "Subscribe Masterclass",
    JOIN_TELEGRAM_COMMUNITY: "Join Telegram Community",
    SUBSCRIBE_TO_YOUTUBE: "Subscribe to Youtube",
    ADD_PAYMENT_INFO: "Add Payment Info",
    CONFIRM_SEAT: "Confirm Seat",
    DOWNLOAD_COURSE_OUTLINE: "Download Course Outline",
    RESERVE_SEAT: "Reserve Seat",
    ADD_TO_CART: "Add to Cart",
    CLICKED_ON_STUDY_MATERIAL: "Clicked on study material",
    CLICKED_ON_FS_STUDY_MATERIAL: "CLICKED_ON_FS_STUDY_MATERIAL",
    CLICKED_ON_FS_VIDEO: "CLICKED_ON_FS_VIDEO",
    CLICKED_ON_CLASS_RECORDINGS: "Clicked on Class Recordings",
    CLICKED_ON_BOOK_SPEAKING_CLUB: "Clicked on book speaking club",
    CLICKED_ON_BOOK_ESSAY_EVALUATION: "Clicked on book essay Evaluation",
    CLICKED_ON_CHAT_WITH_EDUCATOR: "Clicked on chat with Educator",
    PAID_FOR_IELTS_PLUS: "Paid for Ielts Plus",
    SPEAKING_CLUB_BOOK_ATTEMPTED: "speaking_slot_booking_attempted",
    INITIATE_CHECKOUT: "Initiate Checkout",
    JOIN_WAIT_LIST: "Join wait list",
    MASTERCLASS_REGISTERED: "Masterclass Registered",
    REDIRECT_PAGE_TRACKER: " redirect page tracker",
    JOIN_CLASS: "join class",
    UPCOMING_CLASS_CLICKED: "Upcoming Class Clicked",
    UPLOADED_ESSAY_FOR_EVALUATION: "Uploaded Essay For Evaluation",
    USER_PROFILE_PAGE_WITH_STAGE: "User on Profile Page in Stage",
    LS_PAYMENT_BUTTON_CLICK: "Click on LS payment button",
    LS_PAYMENT_SUCCESS: "LS Payment Success",
    LS_PAYMENT_FAIL_OR_ABANDONED: "LS Payment Fail",
    NEW_LS_LEAD: "New LS Lead",
    GENERAL_COUNSELLING_FORM_VISIBLE: "General counselling form visible",
    SPOT_COUNSELLING_FORM_VISIBLE: "Spot counselling form visible",
    GENERAL_COUNSELLING_FORM_SUBMIT: "General counselling form submit",
    SPOT_COUNSELLING_FORM_SUBMIT: "Spot Counselling form submit",
    GENERAL_COUNSELLING_MEETING_BOOKED: "General counselling meeting booked",
    SPOT_COUNSELLING_MEETING_BOOKED: "Spot Counselling meeting booked",
    FAST_TRACK_CLICK: "Fast_track_Click",
    INITIATE_CHECKOUT_FAST_TRACK: "initiate_checkout_fast_track",
    PAID_FOR_FAST_TRACK: "paid_for_fast_track",
    FS_VIDEO_CLICK_PLAY: "fs_video_click_play",
    CHANGE_USER_DETAIL: "change_user_detail",
    ADDED_TO_CALENDAR: "added_to_calendar",
    TIMER_JOIN_CLASS_CLICKED: "timer_join_class_clicked",
    NPS_SCORE_GIVEN: "nps_score_given",
    REMINDER_SET_MC: "reminder_set_MC",
    SPEAKING_SLOT_BOOKED: "speaking_slot_booked",
    MOCK_TEST_UNLOCKED: "mock_test_unlocked",
    MOCK_START_TEST: "mock_start_test",
    MOCK_TEST_SCORE_RELEASED: "mock_test_score_released",
    MOCK_WRITING_SUBMITTED: "mock_writing_submitted",
    MOCK_WRITING_EVALUATED: "mock_writing_evaluated",
    BATCH_CHANGE: "batch_change",
    VIEWED_CLASS_RECORDING: "viewed_class_recording",
    ONLINE_WORKSHOP_BATCH_ID: "online_workshop_batch_id",
    VALID_PROMO_CODE: "valid_promo_code",
    INVALID_PROMO_CODE: "invalid_promo_code",
    COURSE_LIKED: "course_liked",
    COURSE_DISLIKED: "course_disliked",
    PURCHASE_SPEAKING_SLOTS: "purchase_speaking_slots",
    CLICK_PURCHASE_SPEAKING_SLOTS: "click_purchase_speaking_slots",
    CLICK_ON_RESERVE_FREE_SEAT: "click_on_reserve_free_seat",
    MASTERCLASS_LANDING_PAGE: "masterclass_landing_page",
    CRASHCOURSE_LANDINGPAGE: "crashcourse_landingpage",
    VIDEO_SERIES_CLICK: "video_series_click",
    VIDEO_COMPLETE: "video_complete",
    CANCEL_SPEAKING_SLOT: "cancel_speaking_slot",
    START_LEARNING_FOLD1: "start_learning_fold1",
    START_LEARNING_FAST_TRACK: "start_learning_fast_track",
    START_LEARNING_PLUS: "start_learning_plus",
    START_LEARNING_PREMIUM: "start_learning_premium",
    VIEW_UPCOMING_BATCHES: "view_upcoming_batches",
    CLICKED_SHARE_DETAILS_IELTS_TEST: "clicked_share_details_ielts_test",
    SUBMITTED_IELTS_TEST_DATE: "submitted_ielts_test_date",
    VIDEO_SERIES_PREVIEW_CLICK: "video_series_preview_click",
    VIDEO_PREVIEW_START: "video_preview_start",
    VIDEO_PREVIEW_COMPLETE: "video_preview_complete"
};
var gaEvents = {
    IELTS_ADD_PAYMENT_INFO: "ielts_add_payment_info",
    IELTS_ADD_TO_CART: "ielts_add_to_cart"
};
var eventCategory = {
    IELTS_WEBSITE: "Ielts Website",
    IELTS_PROFILE: "Ielts Profile",
    NEW_IELTS_LEAD: "New Ielts Lead",
    NEW_PTE_LEAD: "New PTE Lead",
    USER_PROFILE_PAGE: "Profile page",
    COUNTRY_LANDING_PAGE: "Country Landing Page",
    LS_PAYMENT: "LS Payment",
    NEW_LEAD: "New Lead",
    COUNSELLING_TYPE: "Counselling type",
    FAST_TRACK: "fast_track",
    NPS_FORM: "nps_form",
    SPEAKING_CLUB: "speaking_club",
    MOCK_TEST: "mock_test",
    STUDY_MATERIAL: "study_material",
    REGISTRATION: "registration",
    PAID_FOR_IELTS_PLUS: "Paid for Ielts pro",
    PAID_FOR_PTE_PRO: "Paid for pte pro",
    PAID_FOR_DET_PRO: "Paid for DET pro",
    IELTS_CRASH_COURSE_WEBSITE: "ielts_crash_course_website"
};
var userAttributeName = {
    WE_EMAIL: "we_email",
    WE_HASHED_EMAIL: "we_hashed_email",
    WE_FIRST_NAME: "we_first_name",
    WE_LAST_NAME: "we_last_name",
    WE_PHONE: "we_phone",
    WE_WHATSAPP_OPT_IN: "we_whatsapp_opt_in"
};
//KEEP ALL THE DATA THAT WE PUSH TO WEBENGAGE HERE , DON'T USE DIRECTLY AS STRING
var WEeventDataAttributeNames = {
    CATEGORY: "category",
    ACTION: "action",
    LABEL: "label",
    USER_STAGE: "user_stage",
    COUNTRY: "country",
    PREFERRED_INTAKE: "preferred_intake",
    PREFERRED_PROGRAM: "preferred_program",
    ADMIT_STATUS: "admit_status",
    HELP_FROM_LS: "help_from_ls",
    PASSPORT_STATUS: "passport_status",
    IELTS_STATUS: "ielts_status",
    HIGHEST_EDUCATION: "highest_education",
    UTM_SOURCE: "utmSource",
    UTM_CAMPAIGN: "utmCampaign",
    MEETING_LINK: "meeting_link",
    MEETING_DATE: "meeting_date",
    MEETING_TIME: "meeting_time",
    USER_NAME: "user_name",
    USER_EMAIL: "user_email",
    PRICE_OFFER: "price_offer",
    PAID: "paid",
    VIDEO_TITLE: "video_title",
    TEACHER_NAME: "teacher_name",
    BATCH_ID: "batchId",
    BOOK_DATE: "book_date",
    WEEKLY_SCHEDULE: "weekly_schedule",
    TELEGRAM_LINK: "TELEGRAM_LINK",
    BATCH_END_DATE: "batch_end_date",
    BATCH_START_DATE: "batch_start_date",
    NPS_RATING: "nps_rating",
    WORKSHOP_TYPE: "workshop_type",
    BATCH_TITLE: "BATCH_TITLE",
    SPEAKING_CLUB_SLOT_BOOKED: "speaking_club_slot_booked",
    SPEAKING_BATCH_ID: "speaking_batch_id",
    IELTS_PLUS_BATCH_ID: "ielts_plus_batch_id",
    MOCK_TEST_SECTION: "mock_test_section",
    MOCK_TEST_ID: "mock_test_id",
    MOCK_TEST_INDEX: "mock_test_index",
    STUDY_MATERIAL_LINK: "study_material_link",
    PROMO_CODE: "promo_code",
    USER_ID: "user_id",
    SERIES_TITLE: "series_title",
    BATCH_START_TIME: "batch_start_time",
    TYPE: "type",
    IELTS_DATE: "ielts_date",
    TEACHER_TELEGRAM_URL: "teacher_telegram_url"
};


/***/ }),

/***/ 56014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XE": function() { return /* binding */ ieltsExamType; },
/* harmony export */   "ow": function() { return /* binding */ batchExamTypeDto; },
/* harmony export */   "p$": function() { return /* binding */ dateUploadFormData; }
/* harmony export */ });
/* unused harmony export OptionalBinaryAnswer */
/* harmony import */ var components_Inputs_DatePicker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3569);
/* harmony import */ var components_Inputs_RadioButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25778);
/* harmony import */ var components_Inputs_SingleUpload__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28069);



var OptionalBinaryAnswer;
(function(OptionalBinaryAnswer) {
    OptionalBinaryAnswer["YES"] = "YES";
    OptionalBinaryAnswer["NO"] = "NO";
    OptionalBinaryAnswer["NOT_SURE"] = "NOT_SURE";
})(OptionalBinaryAnswer || (OptionalBinaryAnswer = {}));
var ieltsExamType;
(function(ieltsExamType) {
    ieltsExamType["ACADEMIC"] = "ACADEMIC";
    ieltsExamType["GENERAL"] = "GENERAL";
    ieltsExamType["OTHER"] = "OTHER";
})(ieltsExamType || (ieltsExamType = {}));
var batchExamTypeDto;
(function(batchExamTypeDto) {
    batchExamTypeDto["ACADEMIC"] = "ACADEMIC";
    batchExamTypeDto["GENERAL"] = "GENERAL";
    batchExamTypeDto["BOTH"] = "BOTH";
})(batchExamTypeDto || (batchExamTypeDto = {}));
var ieltsExamTypeOptions = [
    {
        label: "Academic",
        value: ieltsExamType.ACADEMIC
    },
    {
        label: "General",
        value: ieltsExamType.GENERAL
    }, 
];
var oneToOneCounsellingSession = [
    {
        label: "Yes",
        value: OptionalBinaryAnswer.YES
    },
    {
        label: "No",
        value: OptionalBinaryAnswer.NO
    }, 
];
var dateUploadFormData = [
    {
        heading: "Which IELTS test are you appearing for?",
        name: "ieltsExamType",
        component: components_Inputs_RadioButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
        options: ieltsExamTypeOptions,
        validate: function(v) {
            if (!v) return "Please select the exam date";
        },
        defaultValue: ieltsExamType.ACADEMIC
    },
    {
        heading: "Do you want Free 1-1 Study Abroad Counselling?",
        name: "oneToOneCounsellingSession",
        component: components_Inputs_RadioButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
        options: oneToOneCounsellingSession,
        validate: function(v) {
            if (!v) return "Please select the exam date";
        },
        defaultValue: OptionalBinaryAnswer.YES
    },
    {
        heading: "When is your IELTS exam?",
        name: "examDate",
        placeholder: "DD/MM/YYYY",
        component: components_Inputs_DatePicker__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
        validate: function(v) {
            if (!v) return "Please select the exam date";
        },
        customDatePickerCss: "border-[#BDBDBD] placeholder:text-[#BDBDBD] placeholder:opacity-50 w-full cursor-pointer",
        showDatePickerIcon: true
    },
    {
        heading: "Upload your IELTS booking proof",
        name: "IELTS_TEST_DETAILS",
        label: "PNG or PDF",
        component: components_Inputs_SingleUpload__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
        fileType: ".pdf, .jpeg, .jpg, .png, application/pdf, image/jpeg, image/png",
        validate: function(v) {
            if (!v) return "Please upload document";
        }
    }, 
];


/***/ }),

/***/ 73113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V2": function() { return /* binding */ IeltsDemoStages; },
/* harmony export */   "XN": function() { return /* binding */ allowedTimeRangeArray; },
/* harmony export */   "dn": function() { return /* binding */ DemoFormAbVariants; },
/* harmony export */   "uw": function() { return /* binding */ defaultTimeRangeArray; },
/* harmony export */   "wr": function() { return /* binding */ CalendarView; }
/* harmony export */ });
/* unused harmony exports noSlotsModalConten, congratsConfetticoData, getZoomCardData, AbVariants, DisqualifiedUserRedirectVariants, QeFormFlow, IeltsAppVariants, ieltsAppCardData, IELTS_APP_LINK */
/* harmony import */ var page_routes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12615);
/* harmony import */ var scripts_segment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83697);
/* harmony import */ var utils_events_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42477);



var CalendarView;
(function(CalendarView) {
    CalendarView["LOADING"] = "LOADING";
    CalendarView["LIVE_VIEW"] = "LIVE_VIEW";
    CalendarView["FULL_CALENDAR_VIEW"] = "FULL_CALENDAR_VIEW";
})(CalendarView || (CalendarView = {}));
var defaultTimeRangeArray = [
    {
        startHour: 10,
        endHour: 14,
        disabled: false
    },
    {
        startHour: 14,
        endHour: 19,
        disabled: false
    },
    {
        startHour: 19,
        endHour: 23,
        disabled: false
    }, 
];
var allowedTimeRangeArray = [
    {
        startHour: 0,
        endHour: 14
    },
    {
        startHour: 14,
        endHour: 19
    },
    {
        startHour: 19,
        endHour: 24
    }, 
];
var noSlotsModalConten = {
    title: "Thank you for signing up with LeapScholar!",
    subtitle: "All MasterClass slots are currently booked. We will let you know once the slots become available",
    ctaAction: function() {
        (0,scripts_segment__WEBPACK_IMPORTED_MODULE_1__.trackIeltsClick)(utils_events_utils__WEBPACK_IMPORTED_MODULE_2__.ieltsPageName.NO_DEMO_SLOTS, {
            contentName: "Go to dashboard"
        });
        window.open(page_routes__WEBPACK_IMPORTED_MODULE_0__/* .navRoutes.IELTS_STUDENT_DASHBOARD */ .CZ.IELTS_STUDENT_DASHBOARD, "_self");
    },
    description: "Meanwhile, you can try out our FREE mock tests!",
    imageURL: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/profile/retry-modal.svg"),
    ctaText: "Go to Dashboard"
};
var IeltsDemoStages;
(function(IeltsDemoStages) {
    IeltsDemoStages[IeltsDemoStages["TEACHER_MODAL"] = 0] = "TEACHER_MODAL";
    IeltsDemoStages[IeltsDemoStages["FORM_STAGE"] = 1] = "FORM_STAGE";
    IeltsDemoStages[IeltsDemoStages["TECAHER_SCREEN"] = 2] = "TECAHER_SCREEN";
    IeltsDemoStages[IeltsDemoStages["REQUEST_EVAL"] = 3] = "REQUEST_EVAL";
})(IeltsDemoStages || (IeltsDemoStages = {}));
var congratsConfetticoData = {
    image: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/congrats_confetti.svg"),
    heading: "Your IELTS Masterclass is Booked"
};
var getZoomCardData = function(downloadLink) {
    return {
        image: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/zoom_image.png"),
        heading: "Install Zoom App",
        subHeading: "MasterClass would be on Zoom",
        isAutoDownload: true,
        manualDownload: {
            downloadCta: "Download Zoom",
            downloadCtaClick: function() {
                trackClick(ieltsPageName.DEMO_CONFIRMATION_SCREEN, {
                    contentName: "Download Zoom"
                });
                window.open(downloadLink, "_self");
            }
        },
        autoDownload: {
            redirectText: "Redirecting to Play Store in",
            redirectTimeInSec: 5,
            downloadCta: "Download Zoom",
            downloadCtaClick: function() {
                trackClick("Demo Confirm Exp 2", {
                    contentName: "Download Zoom"
                });
                window.open(downloadLink, "_self");
            }
        }
    };
};
var AbVariants;
(function(AbVariants) {
    AbVariants[AbVariants["ORIGINAL"] = 0] = "ORIGINAL";
    AbVariants[AbVariants["MANUAL_DOWNLOAD"] = 1] = "MANUAL_DOWNLOAD";
    AbVariants[AbVariants["AUTO_DOWNLOAD"] = 2] = "AUTO_DOWNLOAD";
})(AbVariants || (AbVariants = {}));
var DemoFormAbVariants;
(function(DemoFormAbVariants) {
    DemoFormAbVariants[DemoFormAbVariants["ORIGINAL"] = 0] = "ORIGINAL";
    DemoFormAbVariants[DemoFormAbVariants["FORM_1_CALENDAR_FORM_2"] = 1] = "FORM_1_CALENDAR_FORM_2";
})(DemoFormAbVariants || (DemoFormAbVariants = {}));
var DisqualifiedUserRedirectVariants;
(function(DisqualifiedUserRedirectVariants) {
    DisqualifiedUserRedirectVariants[DisqualifiedUserRedirectVariants["TO_MASTER_CLASS"] = 0] = "TO_MASTER_CLASS";
    DisqualifiedUserRedirectVariants[DisqualifiedUserRedirectVariants["TO_DISQUAILIFED_CALENDER"] = 1] = "TO_DISQUAILIFED_CALENDER";
})(DisqualifiedUserRedirectVariants || (DisqualifiedUserRedirectVariants = {}));
var QeFormFlow;
(function(QeFormFlow) {
    QeFormFlow[QeFormFlow["OLD_FORM"] = 0] = "OLD_FORM";
    QeFormFlow[QeFormFlow["NEW_FORM"] = 1] = "NEW_FORM";
})(QeFormFlow || (QeFormFlow = {}));
var IeltsAppVariants;
(function(IeltsAppVariants) {
    IeltsAppVariants["ZOOM_DOWNLOAD"] = "0";
    IeltsAppVariants["IELTS_APP"] = "1";
    IeltsAppVariants["IELTS_APP_SCRATCH_CARD"] = "2";
})(IeltsAppVariants || (IeltsAppVariants = {}));
var ieltsAppCardData = {
    image: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/ielts_app.png"),
    heading: "Your classes would happen on our IELTS App",
    subHeading: "Download IELTS App to unlock:",
    rewardPointers: [
        {
            img: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/green_accept_icon.svg"),
            text: "Free Speaking Practice Sessions"
        },
        {
            img: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/green_accept_icon.svg"),
            text: "IELTS Band Predictor Test"
        },
        {
            img: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/green_accept_icon.svg"),
            text: "Exclusive Free Masterclasses"
        }, 
    ]
};
var IELTS_APP_LINK = "https://leapielts.app.link/open/";


/***/ }),

/***/ 33447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fd": function() { return /* binding */ mockTestCategory; },
/* harmony export */   "sX": function() { return /* binding */ MOCK_TEST_TYPE; },
/* harmony export */   "zN": function() { return /* binding */ speakingEvaluationBannerData; }
/* harmony export */ });
/* unused harmony export MOCK_TEST_CAMPAIGN_QUERY */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var MOCK_TEST_CAMPAIGN_QUERY = "free_mock_test";
var MOCK_TEST_TYPE = "mock_test_type";
var mockTestCategory = {
    event_mock_test: "event_mock_test",
    masterclass_mock_test: "masterclass_mock_test"
};
var speakingEvaluationBannerData = {
    title: "Full Length Speaking Evaluation",
    subTitle: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: "text-[#686868]",
        children: [
            "If you have Speaking evaluation as part of your bundle, ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
            "please access it through Dashboard"
        ]
    }),
    ctaText: "Go to Dashboard",
    bgImg: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts-profile/dashboard/batch_card/speaking_bg.png"),
    desktopBgImg: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts-profile/dashboard/batch_card/speaking_desktop.webp")
};


/***/ }),

/***/ 53667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CB": function() { return /* binding */ fastTrackNpsQuestion; },
/* harmony export */   "Rf": function() { return /* binding */ getQuestionType; },
/* harmony export */   "U": function() { return /* binding */ NpsUserType; },
/* harmony export */   "gx": function() { return /* binding */ npsColorDefinition; },
/* harmony export */   "wP": function() { return /* binding */ ieltsNpsQuestion; },
/* harmony export */   "wv": function() { return /* binding */ NpsRatingArray; },
/* harmony export */   "x6": function() { return /* binding */ getNpsUserType; }
/* harmony export */ });
/* unused harmony exports npsQuestions, ratingColors */
var npsQuestions = {
    firstQuestion: {
        id: "Q1",
        question: "Sorry about that, What can we do better?",
        image: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/nps/sad_emoji.png")
    },
    secondQuestion: {
        id: "Q2",
        question: "Thank you! What can we improve to delight you further?",
        image: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/nps/happy_emoji.png")
    },
    thirdQuestion: {
        id: "Q3",
        question: "We are glad! What do you like about LeapScholar?",
        image: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/nps/delight_emoji.png")
    }
};
var NpsUserType;
(function(NpsUserType) {
    NpsUserType["PROMOTERS"] = "PROMOTERS";
    NpsUserType["PASSIVE"] = "PASSIVE";
    NpsUserType["DETRACTORS"] = "DETRACTORS";
})(NpsUserType || (NpsUserType = {}));
var ratingColors = {
    backgroundColor: [
        "#FF7675",
        "#FF7675",
        "#F99377",
        "#F69F6B",
        "#F3AB5F",
        "#F0B952",
        "#E0C176",
        "#D1D7B9",
        "#96C7C6",
        "#73B0B1", 
    ],
    borderColor: [
        "#FD4B6D",
        "#FC5B55",
        "#F7724D",
        "#F88037",
        "#FD8D17",
        "#E4990E",
        "#DAAE42",
        "#BCC792",
        "#79B2B1",
        "#388E8E", 
    ]
};
var getNpsUserType = function(rating) {
    if (rating <= 6) return NpsUserType.DETRACTORS;
    if (rating <= 8) return NpsUserType.PASSIVE;
    return NpsUserType.PROMOTERS;
};
var npsColorDefinition = function(rating) {
    var npsUserType = getNpsUserType(rating);
    switch(npsUserType){
        case NpsUserType.DETRACTORS:
            return "#FF7675";
        case NpsUserType.PASSIVE:
            return "#FABE2C";
        case NpsUserType.PROMOTERS:
        default:
            return "#73CE36";
    }
};
var NpsRatingArray = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var fastTrackNpsQuestion = "How likely are you to recommend LeapScholar’s FastTrack course to your friends who are preparing for IELTS?";
var ieltsNpsQuestion = "How likely are you to recommend LeapScholar's IELTS courses to your friends who are preparing for IELTS?";
var getQuestionType = function(rating, questionObject) {
    return Object.keys(questionObject).find(function(questionType) {
        return questionObject[questionType].applicableRatings.includes(rating);
    }) || null;
};


/***/ }),

/***/ 64461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ab": function() { return /* binding */ tofuDisqMcDataMweb; },
/* harmony export */   "B1": function() { return /* binding */ mcBannerDataWeb; },
/* harmony export */   "BN": function() { return /* binding */ mcBannerDataMweb; },
/* harmony export */   "qk": function() { return /* binding */ IeltsAppValueProps; },
/* harmony export */   "rk": function() { return /* binding */ valuePropsData; },
/* harmony export */   "vY": function() { return /* binding */ tofuDisqMcData; }
/* harmony export */ });
/* unused harmony exports MasterclassValuePropsData, ieltsPlusValuePropsData, ieltsPremiumValuePropsData, ieltsFoundationValuePropsData, ieltsPlusPropsData, plusBannerValuePropsData, premiumBannerValuePropsData, ietlsPlusFilterData, ieltsPlusFilterData, viewAllFilterType, ieltsViewAllTabsData */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_common_LineBreak__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81964);


var valuePropsData = [
    {
        id: 1,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/value_props/ielts/live.svg"),
        altText: "Live Classes",
        titleText: "Daily",
        text: "Live Classes",
        isDynamicText: false,
        type: "duration"
    },
    {
        id: 2,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/value_props/ielts/check.svg"),
        altText: "Mock test",
        text: "Mock Tests",
        isDynamicText: true,
        type: "tests"
    },
    {
        id: 3,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/value_props/ielts/note.svg"),
        altText: "Evaluation",
        text: "Writing Evaluation",
        isDynamicText: true,
        type: "writing"
    },
    {
        id: 4,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/value_props/ielts/chat.svg"),
        altText: "Speaking",
        text: "Speaking Evaluation",
        isDynamicText: true,
        type: "speaking"
    },
    {
        id: 5,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/value_props/ielts/idea.svg"),
        altText: "Material",
        text: "Study Materials",
        isDynamicText: false,
        type: "material"
    },
    {
        id: 6,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/value_props/ielts/certificate.svg"),
        altText: "Certificate",
        text: "Completion Certificate",
        isDynamicText: false,
        type: "certificate"
    },
    {
        id: 7,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/value_props/ielts/abc.svg"),
        altText: "Daily Grammar classes",
        text: "Daily Grammar classes",
        isDynamicText: false,
        type: "daily_grammar_classes"
    },
    {
        id: 8,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/value_props/ielts/video.svg"),
        altText: "Class recordings",
        text: "Class recordings",
        isDynamicText: false,
        type: "Class recordings"
    }, 
];
var MasterclassValuePropsData = [
    {
        id: 1,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/ielts/live_classes.png"),
        altText: "Live Classes",
        text: "Live Classes",
        isDynamicText: false,
        type: "duration"
    },
    {
        id: 2,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/ielts/mock_test.svg"),
        altText: "Mock test",
        text: "Mock Tests",
        isDynamicText: false,
        type: "tests"
    },
    {
        id: 3,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/ielts/writing_evaluation.svg"),
        altText: "Evaluation",
        text: "Writing Evaluation",
        isDynamicText: false,
        type: "writing"
    },
    {
        id: 4,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/ielts/speaking_evaluation.svg"),
        altText: "Speaking",
        text: "Speaking Evaluation",
        isDynamicText: false,
        type: "speaking"
    },
    {
        id: 5,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/ielts/study_material.svg"),
        altText: "Material",
        text: "Study Materials",
        isDynamicText: false,
        type: "material"
    },
    {
        id: 6,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/ielts/certificate.svg"),
        altText: "Certificate",
        text: "Completion Certificate",
        isDynamicText: false,
        type: "certificate"
    }, 
];
var ieltsPlusValuePropsData = [
    {
        id: 1,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/value_props/live.svg"),
        altText: "20+ hours",
        titleText: "Daily",
        text: "Live Classes",
        isDynamicText: false,
        type: "duration"
    },
    {
        id: 2,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/value_props/check_list.svg"),
        titleText: "Five",
        altText: "Mock test",
        text: "Mock Tests",
        isDynamicText: false,
        type: "tests"
    },
    {
        id: 3,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/value_props/write.svg"),
        titleText: "Three",
        altText: "Evaluation",
        text: "Writing Evaluation",
        isDynamicText: false,
        type: "writing"
    },
    {
        id: 4,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/value_props/text.svg"),
        titleText: "Three",
        altText: "Speaking",
        text: "Speaking Evaluation",
        isDynamicText: false,
        type: "speaking"
    }, 
];
var ieltsPremiumValuePropsData = [
    {
        id: 1,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/masterclass-type/tick-icon.svg"),
        altText: "Small Batches",
        titleText: "Small Batches",
        text: "",
        isDynamicText: false,
        type: "duration"
    },
    {
        id: 2,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/masterclass-type/tick-icon.svg"),
        titleText: "Exclusive Content",
        altText: "Exclusive Content",
        text: "",
        isDynamicText: false,
        type: "tests"
    },
    {
        id: 3,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/masterclass-type/tick-icon.svg"),
        titleText: "Exclusive",
        altText: "Evaluation",
        text: "Mock Tests",
        isDynamicText: false,
        type: "writing"
    },
    {
        id: 4,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/masterclass-type/tick-icon.svg"),
        titleText: "Extra Questions",
        altText: "Speaking",
        text: "for Practice",
        isDynamicText: false,
        type: "speaking"
    }, 
];
var ieltsFoundationValuePropsData = [
    {
        id: 1,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/masterclass-type/tick-icon.svg"),
        altText: "Designed",
        titleText: "Designed For",
        text: "IELTS Beginners",
        isDynamicText: false
    },
    {
        id: 2,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/masterclass-type/tick-icon.svg"),
        altText: "Skill-Building",
        titleText: "Skill-Building",
        text: "Course",
        isDynamicText: false
    },
    {
        id: 3,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/masterclass-type/tick-icon.svg"),
        titleText: "Upskill self to learn IELTS",
        altText: "Speaking",
        text: "syllabus after 2 weeks",
        isDynamicText: false
    },
    {
        id: 4,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/masterclass-type/tick-icon.svg"),
        titleText: "Specially Curated",
        altText: "Evaluation",
        text: "Practice Tests",
        isDynamicText: false
    }, 
];
var ieltsPlusPropsData = [
    {
        id: 1,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/masterclass-type/tick-icon.svg"),
        altText: "Daily",
        titleText: "Daily",
        text: "Live Classes",
        isDynamicText: false
    },
    {
        id: 2,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/masterclass-type/tick-icon.svg"),
        altText: "Skill-Building",
        titleText: "Free Speaking",
        text: "Evaluation",
        isDynamicText: false
    },
    {
        id: 3,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/masterclass-type/tick-icon.svg"),
        titleText: "Study",
        altText: "Study",
        text: "materials",
        isDynamicText: false
    },
    {
        id: 4,
        icon: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/masterclass-type/tick-icon.svg"),
        titleText: "Mock",
        altText: "Mock",
        text: "Tests",
        isDynamicText: false
    }, 
];
var plusBannerValuePropsData = [
    {
        imgUrl: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/value_props/ielts/view_all/plus1.svg"),
        boldText: "LIVE",
        defaultText: "classes with experts"
    },
    {
        imgUrl: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/value_props/ielts/view_all/plus2.svg"),
        boldText: "Lifetime",
        defaultText: "access to recordings"
    },
    {
        imgUrl: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/value_props/ielts/view_all/plus3.svg"),
        boldText: "Mock tests",
        defaultText: "and study materials"
    }, 
];
var premiumBannerValuePropsData = [
    {
        imgUrl: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/value_props/ielts/view_all/premium1.svg"),
        defaultText: "Personalised Attention"
    },
    {
        imgUrl: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/value_props/ielts/view_all/premium2.svg"),
        defaultText: "Speaking & Writing evaluations"
    },
    {
        imgUrl: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/ielts/value_props/ielts/view_all/premium3.svg"),
        defaultText: "Reading & Writing mock tests"
    }, 
];
var ietlsPlusFilterData;
(function(ietlsPlusFilterData) {
    ietlsPlusFilterData[ietlsPlusFilterData["START_SOON"] = -1] = "START_SOON";
    ietlsPlusFilterData[ietlsPlusFilterData["ALL"] = -1] = "ALL";
    ietlsPlusFilterData[ietlsPlusFilterData["IELTS_PLUS_PART_2"] = -2] = "IELTS_PLUS_PART_2";
})(ietlsPlusFilterData || (ietlsPlusFilterData = {}));
var ieltsPlusFilterData = [
    {
        id: ietlsPlusFilterData.START_SOON,
        text: "Starts soon"
    },
    {
        id: 2,
        text: "All"
    },
    {
        id: 3,
        text: "Evening"
    },
    {
        id: 4,
        text: "Morning"
    },
    {
        id: 5,
        text: "Afternoon"
    }, 
];
var viewAllFilterType;
(function(viewAllFilterType) {
    viewAllFilterType["ALL"] = "All_weeks";
    viewAllFilterType["IELTS_PLUS_PART_2"] = "IELTSPlusPart2";
})(viewAllFilterType || (viewAllFilterType = {}));
var ieltsViewAllTabsData = [
    {
        id: 1,
        text: "IELTS Elite",
        active: true
    },
    {
        id: 2,
        text: "IELTS Select",
        active: true
    }, 
];
var IeltsAppValueProps = [
    "Exclusive Live Masterclasses",
    "IELTS Band Predictor Tests",
    "Free Speaking Practice on App", 
];
var tofuDisqMcData = {
    title: "We have unlocked a free  IELTS Masterclass for you. What you get:",
    points: [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "font-bold",
                    children: "Exclusive IELTS"
                }),
                " session where you learn about tips and tricks to get",
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "font-bold",
                    children: "8+ band for FREE"
                })
            ]
        }, "1"),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            children: [
                "Finding the perfect ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "font-bold",
                    children: "preparation method "
                }),
                "for you with our ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "font-bold",
                    children: " band predictor"
                }),
                " and diagnostic tests"
            ]
        }, "2"),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            children: [
                "Live interaction with",
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "font-bold",
                    children: "India's top IELTS Trainers "
                }),
                " and mentors to get your doubts cleared"
            ]
        }, "3"), 
    ]
};
var tofuDisqMcDataMweb = {
    title: "Unlocked : Free IELTS Masterclass",
    points: [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            children: "Get your doubts cleared about IELTS"
        }, "1"),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            children: [
                "Finding the perfect ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "font-bold",
                    children: "preparation "
                }),
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_LineBreak__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    device: "mobile"
                }),
                " method for you"
            ]
        }, "2"),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "font-bold",
                    children: " Live interaction "
                }),
                "with IELTS ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_LineBreak__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    device: "mobile"
                }),
                " Trainers"
            ]
        }, "3"), 
    ]
};
var mcBannerDataWeb = {
    title: "IELTS Masterclass",
    points: tofuDisqMcData.points
};
var mcBannerDataMweb = {
    title: "IELTS Masterclass",
    points: [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "font-bold",
                    children: "Free exclusive "
                }),
                " IELTS session"
            ]
        }, "1"),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "font-bold",
                    children: " Live interaction "
                }),
                "with IELTS Trainers"
            ]
        }, "2"),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            children: [
                "Get your doubts cleared and ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_LineBreak__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    device: "mobile"
                }),
                " learn",
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "font-bold",
                    children: " tips & tricks"
                })
            ]
        }, "3"), 
    ]
};


/***/ }),

/***/ 91738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YZ": function() { return /* binding */ applicationStatus; },
/* harmony export */   "xH": function() { return /* binding */ counsellingStageRank; }
/* harmony export */ });
/* unused harmony exports stageMapper, applicationPostSubMissionStatus, applicationFilingStatus */
var stageMapper = {
    LS_USER_ACQUIRED: "user_acquried",
    LS_LEAD_CAPTURED: "user_acquried",
    LS_LEAD_CLOSED_AFTER_SALES_CALL: "user_acquried",
    LS_COUNSELING_CALL_CANCELLED: "user_acquried",
    LS_DEAD_LEAD: "user_acquried",
    LS_WEBINAR_CANCELLED: "user_acquried",
    LS_COUNSELING_CALL_MISSED: "user_acquried",
    LS_COUNSELING_CALL_NO_SHOW: "user_acquried",
    LS_COUNSELING_CALL_SCHEDULED: "call_scheduled",
    LS_WEBINAR_SCHEDULED: "call_scheduled",
    LS_COUNSELING_CALL_DONE: "call_done",
    LS_WEBINAR_ATTENDED: "call_done",
    LS_LEAD_CLOSED_AFTER_COUNSELLOR_CALL: "call_done",
    LS_PAYMENT_DONE: "payment_done",
    LS_WEBINAR_PAYMENT_DONE: "payment_done",
    LS_COLLEGE_SHORTLISTED: "payment_done",
    LS_COLLEGE_FINALIZED: "college_finalized",
    LS_APPLICATION_PROCESS_STARTED: "college_finalized",
    LS_APPLICATION_IN_PROCESS: "college_finalized",
    LS_APPLICATION_PROCESS_ON_HOLD: "college_finalized",
    LS_DOCUMENTS_UPLOADED: "college_finalized",
    LS_APPLICATION_SUBMITTED_TO_AGGREGATOR: "college_finalized",
    LS_APPLICATION_REJECTED_BY_AGGREGATOR: "college_finalized",
    LS_APPLICATION_SUBMITTED_TO_INSTITUTE: "college_finalized",
    LS_APPLICATION_ON_HOLD_BY_INSTITUTE: "college_finalized",
    LS_APPLICATION_ON_HOLD_BY_AGGREGATOR: "college_finalized",
    LS_CONDITIONAL_ADMIT_RECEIVED: "college_finalized",
    LS_UNCONDITIONAL_ADMIT_RECEIVED: "college_finalized",
    LS_ADMIT_REJECTED_BY_INSTITUTE: "college_finalized",
    LS_ADMIT_DECLINED: "college_finalized",
    LS_ADMIT_ACCEPTED: "college_finalized",
    LS_OFFER_REVOKED_BY_UNIVERSITY: "college_finalized",
    LS_DEPOSIT_PAID: "college_finalized",
    LS_TUITION_FEE_PAID: "college_finalized",
    LS_VISA_WIP: "college_finalized",
    LS_VISA_APPLIED: "college_finalized",
    LS_VISA_REJECTED: "college_finalized",
    LS_VISA_GRANTED: "college_finalized"
};
// Stage less than 7 : LS_Lead_Captured --- given by Vijay Dhingra sd-2049 PRD
// Stage 7 : LS_Webinar_Scheduled
// Stage between 8 to 9: LS_Webinar_Attended
// Stage above 9 : no change
var counsellingStageRank = {
    LS_USER_ACQUIRED: 1,
    LS_LEAD_CAPTURED: 2,
    LS_DEAD_LEAD: 2,
    LS_LEAD_CLOSED_AFTER_SALES_CALL: 3,
    LS_COUNSELING_CALL_CANCELLED: 4,
    LS_WEBINAR_CANCELLED: 4.1,
    LS_COUNSELING_CALL_NO_SHOW: 5,
    LS_COUNSELING_CALL_MISSED: 6,
    LS_COUNSELING_CALL_SCHEDULED: 7,
    LS_WEBINAR_SCHEDULED: 7,
    LS_COUNSELING_CALL_DONE: 8,
    LS_WEBINAR_ATTENDED: 8,
    LS_LEAD_CLOSED_AFTER_COUNSELLOR_CALL: 9,
    LS_PAYMENT_DONE: 10,
    LS_WEBINAR_PAYMENT_DONE: 10,
    LS_COLLEGE_SHORTLISTED: 11,
    LS_COLLEGE_FINALIZED: 12,
    LS_APPLICATION_PROCESS_STARTED: 12.1,
    LS_APPLICATION_IN_PROCESS: 12.2,
    LS_APPLICATION_PROCESS_ON_HOLD: 12.3,
    LS_DOCUMENTS_UPLOADED: 13,
    LS_APPLICATION_SUBMITTED_TO_AGGREGATOR: 14,
    LS_APPLICATION_REJECTED_BY_AGGREGATOR: 15,
    LS_APPLICATION_SUBMITTED_TO_INSTITUTE: 16,
    LS_APPLICATION_ON_HOLD_BY_INSTITUTE: 17,
    LS_APPLICATION_ON_HOLD_BY_AGGREGATOR: 18,
    LS_CONDITIONAL_ADMIT_RECEIVED: 19,
    LS_UNCONDITIONAL_ADMIT_RECEIVED: 20,
    LS_ADMIT_REJECTED_BY_INSTITUTE: 21,
    LS_ADMIT_DECLINED: 22,
    LS_ADMIT_ACCEPTED: 23,
    LS_OFFER_REVOKED_BY_UNIVERSITY: 23.1,
    LS_DEPOSIT_PAID: 24,
    LS_TUITION_FEE_PAID: 25,
    LS_LEAD_DROP_OFF: 30,
    // all visa state
    LS_VISA_WIP: 26,
    LS_VISA_APPLIED: 27,
    LS_VISA_REJECTED: 28,
    LS_VISA_GRANTED: 29,
    LS_VISA_PROCESS_ON_HOLD: 30,
    LS_VISA_FILING_STARTED: 31,
    LS_VISA_DROPPED: 32,
    //new live flow states
    LS_COUNSELLING_CALL_SCHEDULED_NONLIVE: 2.1,
    LS_COUNSELLING_CALL_SCHEDULED_LIVE: 2.2,
    LS_DUMMY_SCHEDULED_LIVE: 2.7,
    LS_USER_DROP_LIVE: 2.3,
    LS_USER_DROP_NON_LIVE: 2.4,
    LS_LEAD_QUALIFIED: 2.5,
    LS_WELCOME_CALL_DONE: 2.6
};
/* aplication status and its sub-stages ----- START */ var applicationStatus = {
    INITIAL_SHORTLIST: "INITIAL_SHORTLIST",
    ARCHIVED: "ARCHIVED",
    APPLICATION_DROPPED: "APPLICATION_DROPPED",
    RECOMMENDATION_GIVEN: "RECOMMENDATION_GIVEN",
    SEND_FILING_REQUEST: "SEND_FILING_REQUEST",
    PROCESS_ON_HOLD_DUE_TO_MISSING_DOCUMENTS: "PROCESS_ON_HOLD_DUE_TO_MISSING_DOCUMENTS",
    FILING_IN_PROCESS: "FILING_IN_PROCESS",
    APPLICATION_ON_HOLD: "APPLICATION_ON_HOLD",
    SUBMITTED_TO_AGGREGATOR: "SUBMITTED_TO_AGGREGATOR",
    ON_HOLD_BY_AGGREGATOR: "ON_HOLD_BY_AGGREGATOR",
    CASE_CLOSED_BY_AGGREGATOR: "CASE_CLOSED_BY_AGGREGATOR",
    PROGRAM_CLOSED: "PROGRAM_CLOSED",
    SUBMITTED_TO_INSTITUTE: "SUBMITTED_TO_INSTITUTE",
    ON_HOLD_BY_INSTITUTE: "ON_HOLD_BY_INSTITUTE",
    UNCONDITIONAL_ADMIT_RECEIVED: "UNCONDITIONAL_ADMIT_RECEIVED",
    CONDITIONAL_ADMIT_RECEIVED: "CONDITIONAL_ADMIT_RECEIVED",
    ADMIT_REJECTED: "ADMIT_REJECTED",
    APPLICATION_DEFERRED: "APPLICATION_DEFERRED",
    ADMIT_ACCEPTED: "ADMIT_ACCEPTED",
    ADMIT_DECLINED: "ADMIT_DECLINED",
    DEPOSIT_PAID: "DEPOSIT_PAID",
    TUITION_FEE_PAID: "TUITION_FEE_PAID"
};
var applicationPostSubMissionStatus = {
    UNDER_REVIEW: "UNDER_REVIEW",
    ADDITIONAL_DOCUMENTS_REQUIRED: "ADDITIONAL_DOCUMENTS_REQUIRED",
    ON_HOLD_OTHER_REASONS: "ON_HOLD_OTHER_REASONS",
    PAYMENT_PENDING: "PAYMENT_PENDING",
    SUBMITTED_TO_INSTITUTION: "SUBMITTED_TO_INSTITUTION",
    CASE_CLOSED_BY_AGGREGATOR: "CASE_CLOSED_BY_AGGREGATOR",
    PROGRAM_CLOSED: "PROGRAM_CLOSED"
};
var applicationFilingStatus = {
    IN_PROGRESS: "IN_PROGRESS",
    DOCS_PENDING: "DOCS_PENDING",
    ON_HOLD: "ON_HOLD",
    DROPPED: "DROPPED",
    COUNSELLOR_TO_REVIEW: "COUNSELLOR_TO_REVIEW",
    PAYMENT_PENDING: "PAYMENT_PENDING",
    SUBMITTED: "SUBMITTED",
    RECEIVED: "RECEIVED"
} /* aplication status and its sub-stages ----- END */ ;


/***/ }),

/***/ 4162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Aw": function() { return /* binding */ BundleIds; },
/* harmony export */   "uG": function() { return /* binding */ PaymentType; }
/* harmony export */ });
/* unused harmony exports PaymentGatewayVendor, Status */
var Currency;
(function(Currency) {
    Currency[Currency["USD"] = 0] = "USD";
    Currency[Currency["INR"] = 1] = "INR";
    Currency[Currency["EUR"] = 2] = "EUR";
    Currency[Currency["GBP"] = 3] = "GBP";
    Currency[Currency["AUD"] = 4] = "AUD";
    Currency[Currency["BDT"] = 5] = "BDT";
})(Currency || (Currency = {}));
var PaymentGatewayVendor;
(function(PaymentGatewayVendor) {
    PaymentGatewayVendor[PaymentGatewayVendor["STRIPE"] = 0] = "STRIPE";
    PaymentGatewayVendor[PaymentGatewayVendor["EBIX"] = 1] = "EBIX";
    PaymentGatewayVendor[PaymentGatewayVendor["RAZORPAY"] = 2] = "RAZORPAY";
    PaymentGatewayVendor[PaymentGatewayVendor["LEAP_PAYMENT"] = 3] = "LEAP_PAYMENT";
    PaymentGatewayVendor[PaymentGatewayVendor["RAZOR_PAY_LINK"] = 4] = "RAZOR_PAY_LINK";
    PaymentGatewayVendor[PaymentGatewayVendor["BKASH"] = 5] = "BKASH";
})(PaymentGatewayVendor || (PaymentGatewayVendor = {}));
var PaymentPlatform;
(function(PaymentPlatform) {
    PaymentPlatform[PaymentPlatform["WEB"] = 0] = "WEB";
    PaymentPlatform[PaymentPlatform["ANDROID"] = 1] = "ANDROID";
    PaymentPlatform[PaymentPlatform["DEFAULT"] = 2] = "DEFAULT";
})(PaymentPlatform || (PaymentPlatform = {}));
var PaymentType;
(function(PaymentType) {
    PaymentType["COUNSELLING_FEE"] = "COUNSELLING_FEE";
    PaymentType["IELTS_FEE"] = "IELTS_FEE";
    PaymentType["FAST_TRACK_FEE"] = "FAST_TRACK_FEE";
    PaymentType["IELTS_PREMIUM_FEE"] = "IELTS_PREMIUM_FEE";
    PaymentType["IELTS_PREMIUM_2_FEE"] = "IELTS_PREMIUM_2_FEE";
    PaymentType["IELTS_PREMIUM_3_FEE"] = "IELTS_PREMIUM_3_FEE";
    PaymentType["SPEAKING_CLUB_FEE"] = "SPEAKING_CLUB_FEE";
    PaymentType["SPEAKING_CLUB_SINGLE_CREDIT_FEE"] = "SPEAKING_CLUB_SINGLE_CREDIT_FEE";
    PaymentType["IELTS_FOUNDATION_FEE"] = "IELTS_FOUNDATION_FEE";
    PaymentType["REWARD_BOOSTER_FEE"] = "REWARD_BOOSTER_FEE";
    PaymentType["TCY_MOCK_TEST_FEE"] = "TCY_MOCK_TEST_FEE";
    PaymentType["AI_EVALUATION"] = "AI_EVALUATION";
    PaymentType["IELTS_PLUS_PART_2_FEE"] = "IELTS_PART_II_FEE";
    PaymentType["IELTS_SELECT_FEE"] = "IELTS_SELECT_FEE";
    PaymentType["IELTS_ELITE_FEE"] = "IELTS_ELITE_FEE";
    PaymentType["IELTS_CUSTOM_FEE"] = "IELTS_CUSTOM_FEE";
    PaymentType["GENERIC_PAYMENT"] = "GENERIC_PAYMENT";
})(PaymentType || (PaymentType = {}));
var Status;
(function(Status) {
    Status[Status["CREATED"] = 0] = "CREATED";
    Status[Status["SUCCESS"] = 1] = "SUCCESS";
    Status[Status["FAILED"] = 2] = "FAILED";
    Status[Status["REFUNDED"] = 3] = "REFUNDED";
})(Status || (Status = {}));
var BundleIds;
(function(BundleIds) {
    BundleIds["TCY_MOCK_TEST"] = "TCY_MOCK_TEST";
    BundleIds["IELTS_AI_EVAL_IELTS8"] = "IELTS_AI_EVAL_IELTS8";
})(BundleIds || (BundleIds = {}));


/***/ }),

/***/ 50115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ QuestionTypeDto; },
/* harmony export */   "s": function() { return /* binding */ QuizStatus; }
/* harmony export */ });
var QuestionTypeDto;
(function(QuestionTypeDto) {
    QuestionTypeDto["SINGLE_CHECK"] = "SINGLE_CHOICE";
    QuestionTypeDto["MULTI_CHECK"] = "MULTIPLE_CHOICE";
})(QuestionTypeDto || (QuestionTypeDto = {}));
var QuizStatus;
(function(QuizStatus) {
    QuizStatus["ATTEMPTED"] = "ATTEMPTED";
    QuizStatus["FINISHED"] = "FINISHED";
    QuizStatus["NOT_ATTEMPTED"] = "NOT_ATTEMPTED";
})(QuizStatus || (QuizStatus = {}));


/***/ }),

/***/ 46510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qo": function() { return /* binding */ RewardsApi; },
/* harmony export */   "nD": function() { return /* binding */ DateUploadScreens; },
/* harmony export */   "wX": function() { return /* binding */ IeltsTestStatus; }
/* harmony export */ });
var IeltsTestStatus;
(function(IeltsTestStatus) {
    IeltsTestStatus["NOT_SUBMITTED"] = "NOT_SUBMITTED";
    IeltsTestStatus["SUBMITTED"] = "SUBMITTED";
    IeltsTestStatus["APPROVED"] = "APPROVED";
    IeltsTestStatus["REJECTED"] = "REJECTED";
})(IeltsTestStatus || (IeltsTestStatus = {}));
var DateUploadScreens;
(function(DateUploadScreens) {
    DateUploadScreens["LOCKED_REWARDS"] = "LOCKED_REWARDS";
    DateUploadScreens["LOGIN_FORM"] = "LOGIN_FORM";
    DateUploadScreens["UNLOCKED_REWARDS"] = "UNLOCKED_REWARDS";
})(DateUploadScreens || (DateUploadScreens = {}));
var RewardsApi;
(function(RewardsApi) {
    RewardsApi["PRE"] = "pre";
    RewardsApi["POST"] = "post";
})(RewardsApi || (RewardsApi = {}));


/***/ }),

/***/ 32707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Oy": function() { return /* binding */ ExamFormats; },
/* harmony export */   "Qi": function() { return /* binding */ ModalTypes; },
/* harmony export */   "WG": function() { return /* binding */ ExamCategories; },
/* harmony export */   "qb": function() { return /* binding */ Status; }
/* harmony export */ });
/* unused harmony exports CreditType, SpeakingSlotStatus, ExamFormatTypeDto, ExamFormatDto, ExamDto, StatusDto */
var CreditType;
(function(CreditType) {
    CreditType["SECTIONAL_TEST"] = "SECTIONAL_TEST";
    CreditType["SPEAKING_PRACTICE"] = "SPEAKING_PRACTICE";
    CreditType["IELTS_REPLICA_TEST"] = "IELTS_REPLICA_TEST";
})(CreditType || (CreditType = {}));
var SpeakingSlotStatus;
(function(SpeakingSlotStatus) {
    SpeakingSlotStatus["SCHEDULED"] = "SCHEDULED";
    SpeakingSlotStatus["LIVE"] = "LIVE";
})(SpeakingSlotStatus || (SpeakingSlotStatus = {}));
var ExamFormatTypeDto;
(function(ExamFormatTypeDto) {
    ExamFormatTypeDto["SECTIONAL"] = "SECTIONAL";
    ExamFormatTypeDto["FULL_LENGTH"] = "FULL_LENGTH";
    ExamFormatTypeDto["SECTIONAL_TIME_BOUND"] = "SECTIONAL_TIME_BOUND";
    ExamFormatTypeDto["DIAGNOSTIC"] = "DIAGNOSTIC";
    ExamFormatTypeDto["MINI_BPT"] = "MINI_BPT";
})(ExamFormatTypeDto || (ExamFormatTypeDto = {}));
var ModalTypes;
(function(ModalTypes) {
    ModalTypes["INITIAL"] = "";
    ModalTypes["MOCKTEST_MODAL"] = "MOCKTEST_MODAL";
    ModalTypes["REGISTRATION_MODAL"] = "REGISTRATION_MODAL";
    ModalTypes["PREFERANCE_MODAL"] = "PREFERANCE_MODAL";
})(ModalTypes || (ModalTypes = {}));
var ExamFormatDto = {
    "Sectional Test": "Sectional Test",
    "Full Length Test": "Full Length Test",
    "Diagnostic Test": "Diagnostic Test"
};
var ExamFormats;
(function(ExamFormats) {
    ExamFormats["SECTIONAL"] = "Sectional Test";
    ExamFormats["FULL_LENGTH"] = "Full Length Test";
    ExamFormats["DAIGNOSTIC"] = "Diagnostic Test";
})(ExamFormats || (ExamFormats = {}));
var Status;
(function(Status) {
    Status["LOCKED"] = "LOCKED";
    Status["UNLOCKED"] = "UNLOCKED";
})(Status || (Status = {}));
var ExamDto;
(function(ExamDto) {
    ExamDto["SAT"] = "SAT";
    ExamDto["IELTS"] = "IELTS";
})(ExamDto || (ExamDto = {}));
var StatusDto;
(function(StatusDto) {
    StatusDto["ACTIVE"] = "ACTIVE";
    StatusDto["DISABLED"] = "DISABLED";
})(StatusDto || (StatusDto = {}));
var ExamCategories;
(function(ExamCategories) {
    ExamCategories["READING"] = "READING";
    ExamCategories["LISTENING"] = "LISTENING";
    ExamCategories["WRITING"] = "WRITING";
    ExamCategories["AI_SPEAKING_MOCKTEST"] = "AI_SPEAKING_MOCKTEST";
})(ExamCategories || (ExamCategories = {}));


/***/ }),

/***/ 22308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Bq": function() { return /* binding */ apoloClient; },
  "ZP": function() { return /* binding */ apollo; }
});

// UNUSED EXPORTS: createApolloClient

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/graphql/jsutils/inspect.mjs
var inspect = __webpack_require__(25821);
// EXTERNAL MODULE: ./node_modules/graphql/language/ast.mjs + 2 modules
var ast = __webpack_require__(29749);
;// CONCATENATED MODULE: ./node_modules/graphql/language/visitor.mjs


/**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */

var QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: ['name', // Note: fragment variable definitions are experimental and may be changed
  // or removed in the future.
  'variableDefinitions', 'typeCondition', 'directives', 'selectionSet'],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['description', 'directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: ['description', 'name', 'type', 'defaultValue', 'directives'],
  InterfaceTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields']
};
var BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */

function visitor_visit(root, visitor) {
  var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QueryDocumentKeys;

  /* eslint-disable no-undef-init */
  var stack = undefined;
  var inArray = Array.isArray(root);
  var keys = [root];
  var index = -1;
  var edits = [];
  var node = undefined;
  var key = undefined;
  var parent = undefined;
  var path = [];
  var ancestors = [];
  var newRoot = root;
  /* eslint-enable no-undef-init */

  do {
    index++;
    var isLeaving = index === keys.length;
    var isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
        } else {
          var clone = {};

          for (var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++) {
            var k = _Object$keys2[_i2];
            clone[k] = node[k];
          }

          node = clone;
        }

        var editOffset = 0;

        for (var ii = 0; ii < edits.length; ii++) {
          var editKey = edits[ii][0];
          var editValue = edits[ii][1];

          if (inArray) {
            editKey -= editOffset;
          }

          if (inArray && editValue === null) {
            node.splice(editKey, 1);
            editOffset++;
          } else {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else {
      key = parent ? inArray ? index : keys[index] : undefined;
      node = parent ? parent[key] : newRoot;

      if (node === null || node === undefined) {
        continue;
      }

      if (parent) {
        path.push(key);
      }
    }

    var result = void 0;

    if (!Array.isArray(node)) {
      if (!(0,ast/* isNode */.UG)(node)) {
        throw new Error("Invalid AST Node: ".concat((0,inspect/* default */.Z)(node), "."));
      }

      var visitFn = getVisitFn(visitor, node.kind, isLeaving);

      if (visitFn) {
        result = visitFn.call(visitor, node, key, parent, path, ancestors);

        if (result === BREAK) {
          break;
        }

        if (result === false) {
          if (!isLeaving) {
            path.pop();
            continue;
          }
        } else if (result !== undefined) {
          edits.push([key, result]);

          if (!isLeaving) {
            if ((0,ast/* isNode */.UG)(result)) {
              node = result;
            } else {
              path.pop();
              continue;
            }
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      var _visitorKeys$node$kin;

      stack = {
        inArray: inArray,
        index: index,
        keys: keys,
        edits: edits,
        prev: stack
      };
      inArray = Array.isArray(node);
      keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    newRoot = edits[edits.length - 1][1];
  }

  return newRoot;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */

function visitInParallel(visitors) {
  var skipping = new Array(visitors.length);
  return {
    enter: function enter(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (skipping[i] == null) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          false);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      }
    },
    leave: function leave(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (skipping[i] == null) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          true);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          }
        } else if (skipping[i] === node) {
          skipping[i] = null;
        }
      }
    }
  };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */

function getVisitFn(visitor, kind, isLeaving) {
  var kindVisitor = visitor[kind];

  if (kindVisitor) {
    if (!isLeaving && typeof kindVisitor === 'function') {
      // { Kind() {} }
      return kindVisitor;
    }

    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;

    if (typeof kindSpecificVisitor === 'function') {
      // { Kind: { enter() {}, leave() {} } }
      return kindSpecificVisitor;
    }
  } else {
    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;

    if (specificVisitor) {
      if (typeof specificVisitor === 'function') {
        // { enter() {}, leave() {} }
        return specificVisitor;
      }

      var specificKindVisitor = specificVisitor[kind];

      if (typeof specificKindVisitor === 'function') {
        // { enter: { Kind() {} }, leave: { Kind() {} } }
        return specificKindVisitor;
      }
    }
  }
}

// EXTERNAL MODULE: ./node_modules/ts-invariant/lib/invariant.esm.js
var invariant_esm = __webpack_require__(47591);
// EXTERNAL MODULE: ./node_modules/fast-json-stable-stringify/index.js
var fast_json_stable_stringify = __webpack_require__(35035);
var fast_json_stable_stringify_default = /*#__PURE__*/__webpack_require__.n(fast_json_stable_stringify);
;// CONCATENATED MODULE: ./node_modules/@wry/equality/lib/equality.esm.js
var _a = Object.prototype, equality_esm_toString = _a.toString, equality_esm_hasOwnProperty = _a.hasOwnProperty;
var previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */
function equal(a, b) {
    try {
        return check(a, b);
    }
    finally {
        previousComparisons.clear();
    }
}
function check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) {
        return true;
    }
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = equality_esm_toString.call(a);
    var bTag = equality_esm_toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) {
        return false;
    }
    switch (aTag) {
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length)
                return false;
        // Fall through to object case...
        case '[object Object]': {
            if (previouslyCompared(a, b))
                return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length)
                return false;
            // Now make sure they have the same keys.
            for (var k = 0; k < keyCount; ++k) {
                if (!equality_esm_hasOwnProperty.call(b, aKeys[k])) {
                    return false;
                }
            }
            // Finally, check deep equality of all child properties.
            for (var k = 0; k < keyCount; ++k) {
                var key = aKeys[k];
                if (!check(a[key], b[key])) {
                    return false;
                }
            }
            return true;
        }
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a)
                return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]': {
            if (a.size !== b.size)
                return false;
            if (previouslyCompared(a, b))
                return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while (true) {
                var info = aIterator.next();
                if (info.done)
                    break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) {
                    return false;
                }
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !check(aValue, b.get(aKey))) {
                    return false;
                }
            }
            return true;
        }
    }
    // Otherwise the values are not equal.
    return false;
}
function previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b))
            return true;
    }
    else {
        previousComparisons.set(a, bSet = new Set);
    }
    bSet.add(b);
    return false;
}

/* harmony default export */ var equality_esm = ((/* unused pure expression or super */ null && (equal)));

//# sourceMappingURL=equality.esm.js.map

;// CONCATENATED MODULE: ./node_modules/apollo-utilities/lib/bundle.esm.js
/* provided dependency */ var process = __webpack_require__(83454);






function isScalarValue(value) {
    return ['StringValue', 'BooleanValue', 'EnumValue'].indexOf(value.kind) > -1;
}
function isNumberValue(value) {
    return ['IntValue', 'FloatValue'].indexOf(value.kind) > -1;
}
function isStringValue(value) {
    return value.kind === 'StringValue';
}
function isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function isIntValue(value) {
    return value.kind === 'IntValue';
}
function isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function isVariable(value) {
    return value.kind === 'Variable';
}
function isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function isListValue(value) {
    return value.kind === 'ListValue';
}
function isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function isNullValue(value) {
    return value.kind === 'NullValue';
}
function valueToObjectRepresentation(argObj, name, value, variables) {
    if (isIntValue(value) || isFloatValue(value)) {
        argObj[name.value] = Number(value.value);
    }
    else if (isBooleanValue(value) || isStringValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function (obj) {
            return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    }
    else if (isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    }
    else if (isListValue(value)) {
        argObj[name.value] = value.values.map(function (listValue) {
            var nestedArgArrayObj = {};
            valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
        });
    }
    else if (isEnumValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isNullValue(value)) {
        argObj[name.value] = null;
    }
    else {
        throw  true ? new invariant_esm/* InvariantError */.ej(17) : 0;
    }
}
function storeKeyNameFromField(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function (directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) {
                directive.arguments.forEach(function (_a) {
                    var name = _a.name, value = _a.value;
                    return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
                });
            }
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj, name, value, variables);
        });
    }
    return getStoreKeyName(field.name.value, argObj, directivesObj);
}
var KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export',
];
function getStoreKeyName(fieldName, args, directives) {
    if (directives &&
        directives['connection'] &&
        directives['connection']['key']) {
        if (directives['connection']['filter'] &&
            directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter']
                ? directives['connection']['filter']
                : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function (key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        }
        else {
            return directives['connection']['key'];
        }
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = fast_json_stable_stringify_default()(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) {
        Object.keys(directives).forEach(function (key) {
            if (KNOWN_DIRECTIVES.indexOf(key) !== -1)
                return;
            if (directives[key] && Object.keys(directives[key]).length) {
                completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
            }
            else {
                completeFieldName += "@" + key;
            }
        });
    }
    return completeFieldName;
}
function argumentsObjectFromField(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function resultKeyNameFromField(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function isField(selection) {
    return selection.kind === 'Field';
}
function isInlineFragment(selection) {
    return selection.kind === 'InlineFragment';
}
function bundle_esm_isIdValue(idObject) {
    return idObject &&
        idObject.type === 'id' &&
        typeof idObject.generated === 'boolean';
}
function toIdValue(idConfig, generated) {
    if (generated === void 0) { generated = false; }
    return (0,tslib_es6/* __assign */.pi)({ type: 'id', generated: generated }, (typeof idConfig === 'string'
        ? { id: idConfig, typename: undefined }
        : idConfig));
}
function isJsonValue(jsonObject) {
    return (jsonObject != null &&
        typeof jsonObject === 'object' &&
        jsonObject.type === 'json');
}
function defaultValueFromVariable(node) {
    throw  true ? new InvariantError(18) : 0;
}
function valueFromNode(node, onVariable) {
    if (onVariable === void 0) { onVariable = defaultValueFromVariable; }
    switch (node.kind) {
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function (v) { return valueFromNode(v, onVariable); });
        case 'ObjectValue': {
            var value = {};
            for (var _i = 0, _a = node.fields; _i < _a.length; _i++) {
                var field = _a[_i];
                value[field.name.value] = valueFromNode(field.value, onVariable);
            }
            return value;
        }
        default:
            return node.value;
    }
}

function getDirectiveInfoFromField(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function (directive) {
            directiveObj_1[directive.name.value] = argumentsObjectFromField(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function shouldInclude(selection, variables) {
    if (variables === void 0) { variables = {}; }
    return getInclusionDirectives(selection.directives).every(function (_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
             true ? (0,invariant_esm/* invariant */.kG)(evaledValue !== void 0, 13) : 0;
        }
        else {
            evaledValue = ifArgument.value.value;
        }
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function getDirectiveNames(doc) {
    var names = [];
    visitor_visit(doc, {
        Directive: function (node) {
            names.push(node.name.value);
        },
    });
    return names;
}
function hasDirectives(names, doc) {
    return getDirectiveNames(doc).some(function (name) { return names.indexOf(name) > -1; });
}
function hasClientExports(document) {
    return (document &&
        hasDirectives(['client'], document) &&
        hasDirectives(['export'], document));
}
function isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function getInclusionDirectives(directives) {
    return directives ? directives.filter(isInclusionDirective).map(function (directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
         true ? (0,invariant_esm/* invariant */.kG)(directiveArguments && directiveArguments.length === 1, 14) : 0;
        var ifArgument = directiveArguments[0];
         true ? (0,invariant_esm/* invariant */.kG)(ifArgument.name && ifArgument.name.value === 'if', 15) : 0;
        var ifValue = ifArgument.value;
         true ? (0,invariant_esm/* invariant */.kG)(ifValue &&
            (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16) : 0;
        return { directive: directive, ifArgument: ifArgument };
    }) : [];
}

function getFragmentQueryDocument(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function (definition) {
        if (definition.kind === 'OperationDefinition') {
            throw  true ? new invariant_esm/* InvariantError */.ej(11) : 0;
        }
        if (definition.kind === 'FragmentDefinition') {
            fragments.push(definition);
        }
    });
    if (typeof actualFragmentName === 'undefined') {
         true ? (0,invariant_esm/* invariant */.kG)(fragments.length === 1, 12) : 0;
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, document), { definitions: (0,tslib_es6/* __spreadArrays */.pr)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName,
                            },
                        },
                    ],
                },
            }
        ], document.definitions) });
    return query;
}

function bundle_esm_assign(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    sources.forEach(function (source) {
        if (typeof source === 'undefined' || source === null) {
            return;
        }
        Object.keys(source).forEach(function (key) {
            target[key] = source[key];
        });
    });
    return target;
}

function getMutationDefinition(doc) {
    checkDocument(doc);
    var mutationDef = doc.definitions.filter(function (definition) {
        return definition.kind === 'OperationDefinition' &&
            definition.operation === 'mutation';
    })[0];
     true ? invariant(mutationDef, 1) : 0;
    return mutationDef;
}
function checkDocument(doc) {
     true ? (0,invariant_esm/* invariant */.kG)(doc && doc.kind === 'Document', 2) : 0;
    var operations = doc.definitions
        .filter(function (d) { return d.kind !== 'FragmentDefinition'; })
        .map(function (definition) {
        if (definition.kind !== 'OperationDefinition') {
            throw  true ? new invariant_esm/* InvariantError */.ej(3) : 0;
        }
        return definition;
    });
     true ? (0,invariant_esm/* invariant */.kG)(operations.length <= 1, 4) : 0;
    return doc;
}
function getOperationDefinition(doc) {
    checkDocument(doc);
    return doc.definitions.filter(function (definition) { return definition.kind === 'OperationDefinition'; })[0];
}
function getOperationDefinitionOrDie(document) {
    var def = getOperationDefinition(document);
     true ? invariant(def, 5) : 0;
    return def;
}
function getOperationName(doc) {
    return (doc.definitions
        .filter(function (definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    })
        .map(function (x) { return x.name.value; })[0] || null);
}
function getFragmentDefinitions(doc) {
    return doc.definitions.filter(function (definition) { return definition.kind === 'FragmentDefinition'; });
}
function getQueryDefinition(doc) {
    var queryDef = getOperationDefinition(doc);
     true ? (0,invariant_esm/* invariant */.kG)(queryDef && queryDef.operation === 'query', 6) : 0;
    return queryDef;
}
function getFragmentDefinition(doc) {
     true ? (0,invariant_esm/* invariant */.kG)(doc.kind === 'Document', 7) : 0;
     true ? (0,invariant_esm/* invariant */.kG)(doc.definitions.length <= 1, 8) : 0;
    var fragmentDef = doc.definitions[0];
     true ? (0,invariant_esm/* invariant */.kG)(fragmentDef.kind === 'FragmentDefinition', 9) : 0;
    return fragmentDef;
}
function getMainDefinition(queryDoc) {
    checkDocument(queryDoc);
    var fragmentDefinition;
    for (var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++) {
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' ||
                operation === 'mutation' ||
                operation === 'subscription') {
                return definition;
            }
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) {
            fragmentDefinition = definition;
        }
    }
    if (fragmentDefinition) {
        return fragmentDefinition;
    }
    throw  true ? new invariant_esm/* InvariantError */.ej(10) : 0;
}
function createFragmentMap(fragments) {
    if (fragments === void 0) { fragments = []; }
    var symTable = {};
    fragments.forEach(function (fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function getDefaultValues(definition) {
    if (definition &&
        definition.variableDefinitions &&
        definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions
            .filter(function (_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        })
            .map(function (_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            valueToObjectRepresentation(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return bundle_esm_assign.apply(void 0, (0,tslib_es6/* __spreadArrays */.pr)([{}], defaultValues));
    }
    return {};
}
function variablesInOperation(operation) {
    var names = new Set();
    if (operation.variableDefinitions) {
        for (var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++) {
            var definition = _a[_i];
            names.add(definition.variable.name.value);
        }
    }
    return names;
}

function filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function (elem, i) {
        if (test.call(this, elem, i, array)) {
            array[target++] = elem;
        }
    }, context);
    array.length = target;
    return array;
}

var TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename',
    },
};
function isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function (selection) {
        return selection.kind === 'FragmentSpread' &&
            isEmpty(fragments[selection.name.value], fragments);
    });
}
function nullIfDocIsEmpty(doc) {
    return isEmpty(getOperationDefinition(doc) || getFragmentDefinition(doc), createFragmentMap(getFragmentDefinitions(doc)))
        ? null
        : doc;
}
function getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function (dir) {
            return (dir.name && dir.name === directive.name.value) ||
                (dir.test && dir.test(directive));
        });
    };
}
function removeDirectivesFromDocument(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = nullIfDocIsEmpty(visitor_visit(doc, {
        Variable: {
            enter: function (node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') {
                    variablesInUse[node.name.value] = true;
                }
            },
        },
        Field: {
            enter: function (node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function (directive) { return directive.remove; });
                    if (shouldRemoveField &&
                        node.directives &&
                        node.directives.some(getDirectiveMatcher(directives))) {
                        if (node.arguments) {
                            node.arguments.forEach(function (arg) {
                                if (arg.value.kind === 'Variable') {
                                    variablesToRemove.push({
                                        name: arg.value.name.value,
                                    });
                                }
                            });
                        }
                        if (node.selectionSet) {
                            getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function (frag) {
                                fragmentSpreadsToRemove.push({
                                    name: frag.name.value,
                                });
                            });
                        }
                        return null;
                    }
                }
            },
        },
        FragmentSpread: {
            enter: function (node) {
                fragmentSpreadsInUse[node.name.value] = true;
            },
        },
        Directive: {
            enter: function (node) {
                if (getDirectiveMatcher(directives)(node)) {
                    return null;
                }
            },
        },
    }));
    if (modifiedDoc &&
        filterInPlace(variablesToRemove, function (v) { return !variablesInUse[v.name]; }).length) {
        modifiedDoc = removeArgumentsFromDocument(variablesToRemove, modifiedDoc);
    }
    if (modifiedDoc &&
        filterInPlace(fragmentSpreadsToRemove, function (fs) { return !fragmentSpreadsInUse[fs.name]; })
            .length) {
        modifiedDoc = removeFragmentSpreadFromDocument(fragmentSpreadsToRemove, modifiedDoc);
    }
    return modifiedDoc;
}
function addTypenameToDocument(doc) {
    return visitor_visit(checkDocument(doc), {
        SelectionSet: {
            enter: function (node, _key, parent) {
                if (parent &&
                    parent.kind === 'OperationDefinition') {
                    return;
                }
                var selections = node.selections;
                if (!selections) {
                    return;
                }
                var skip = selections.some(function (selection) {
                    return (isField(selection) &&
                        (selection.name.value === '__typename' ||
                            selection.name.value.lastIndexOf('__', 0) === 0));
                });
                if (skip) {
                    return;
                }
                var field = parent;
                if (isField(field) &&
                    field.directives &&
                    field.directives.some(function (d) { return d.name.value === 'export'; })) {
                    return;
                }
                return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, node), { selections: (0,tslib_es6/* __spreadArrays */.pr)(selections, [TYPENAME_FIELD]) });
            },
        },
    });
}
var connectionRemoveConfig = {
    test: function (directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) {
            if (!directive.arguments ||
                !directive.arguments.some(function (arg) { return arg.name.value === 'key'; })) {
                 true || 0;
            }
        }
        return willRemove;
    },
};
function removeConnectionDirectiveFromDocument(doc) {
    return removeDirectivesFromDocument([connectionRemoveConfig], checkDocument(doc));
}
function hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    return (selectionSet &&
        selectionSet.selections &&
        selectionSet.selections.some(function (selection) {
            return hasDirectivesInSelection(directives, selection, nestedCheck);
        }));
}
function hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    if (!isField(selection)) {
        return true;
    }
    if (!selection.directives) {
        return false;
    }
    return (selection.directives.some(getDirectiveMatcher(directives)) ||
        (nestedCheck &&
            hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck)));
}
function getDirectivesFromDocument(directives, doc) {
    checkDocument(doc);
    var parentPath;
    return nullIfDocIsEmpty(visit(doc, {
        SelectionSet: {
            enter: function (node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath ||
                    currentPath === parentPath ||
                    !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function (selection) { return hasDirectivesInSelection(directives, selection); });
                        if (hasDirectivesInSelectionSet(directives, node, false)) {
                            parentPath = currentPath;
                        }
                        return __assign(__assign({}, node), { selections: selectionsWithDirectives });
                    }
                    else {
                        return null;
                    }
                }
            },
        },
    }));
}
function getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function (aConfig) {
            return argument.value &&
                argument.value.kind === 'Variable' &&
                argument.value.name &&
                (aConfig.name === argument.value.name.value ||
                    (aConfig.test && aConfig.test(argument)));
        });
    };
}
function removeArgumentsFromDocument(config, doc) {
    var argMatcher = getArgumentMatcher(config);
    return nullIfDocIsEmpty(visitor_visit(doc, {
        OperationDefinition: {
            enter: function (node) {
                return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, node), { variableDefinitions: node.variableDefinitions.filter(function (varDef) {
                        return !config.some(function (arg) { return arg.name === varDef.variable.name.value; });
                    }) });
            },
        },
        Field: {
            enter: function (node) {
                var shouldRemoveField = config.some(function (argConfig) { return argConfig.remove; });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function (arg) {
                        if (argMatcher(arg)) {
                            argMatchCount_1 += 1;
                        }
                    });
                    if (argMatchCount_1 === 1) {
                        return null;
                    }
                }
            },
        },
        Argument: {
            enter: function (node) {
                if (argMatcher(node)) {
                    return null;
                }
            },
        },
    }));
}
function removeFragmentSpreadFromDocument(config, doc) {
    function enter(node) {
        if (config.some(function (def) { return def.name === node.name.value; })) {
            return null;
        }
    }
    return nullIfDocIsEmpty(visitor_visit(doc, {
        FragmentSpread: { enter: enter },
        FragmentDefinition: { enter: enter },
    }));
}
function getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function (selection) {
        if ((isField(selection) || isInlineFragment(selection)) &&
            selection.selectionSet) {
            getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function (frag) { return allFragments.push(frag); });
        }
        else if (selection.kind === 'FragmentSpread') {
            allFragments.push(selection);
        }
    });
    return allFragments;
}
function buildQueryFromSelectionSet(document) {
    var definition = getMainDefinition(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') {
        return document;
    }
    var modifiedDoc = visitor_visit(document, {
        OperationDefinition: {
            enter: function (node) {
                return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, node), { operation: 'query' });
            },
        },
    });
    return modifiedDoc;
}
function removeClientSetsFromDocument(document) {
    checkDocument(document);
    var modifiedDoc = removeDirectivesFromDocument([
        {
            test: function (directive) { return directive.name.value === 'client'; },
            remove: true,
        },
    ], document);
    if (modifiedDoc) {
        modifiedDoc = visitor_visit(modifiedDoc, {
            FragmentDefinition: {
                enter: function (node) {
                    if (node.selectionSet) {
                        var isTypenameOnly = node.selectionSet.selections.every(function (selection) {
                            return isField(selection) && selection.name.value === '__typename';
                        });
                        if (isTypenameOnly) {
                            return null;
                        }
                    }
                },
            },
        });
    }
    return modifiedDoc;
}

var canUseWeakMap = typeof WeakMap === 'function' && !(typeof navigator === 'object' &&
    navigator.product === 'ReactNative');

var bundle_esm_toString = Object.prototype.toString;
function cloneDeep(value) {
    return cloneDeepHelper(value, new Map());
}
function cloneDeepHelper(val, seen) {
    switch (bundle_esm_toString.call(val)) {
        case "[object Array]": {
            if (seen.has(val))
                return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function (child, i) {
                copy_1[i] = cloneDeepHelper(child, seen);
            });
            return copy_1;
        }
        case "[object Object]": {
            if (seen.has(val))
                return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function (key) {
                copy_2[key] = cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        }
        default:
            return val;
    }
}

function getEnv() {
    if (typeof process !== 'undefined' && "production") {
        return "production";
    }
    return 'development';
}
function isEnv(env) {
    return getEnv() === env;
}
function isProduction() {
    return isEnv('production') === true;
}
function isDevelopment() {
    return isEnv('development') === true;
}
function isTest() {
    return isEnv('test') === true;
}

function tryFunctionOrLogError(f) {
    try {
        return f();
    }
    catch (e) {
        if (console.error) {
            console.error(e);
        }
    }
}
function graphQLResultHasError(result) {
    return result.errors && result.errors.length;
}

function deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function (prop) {
        if (o[prop] !== null &&
            (typeof o[prop] === 'object' || typeof o[prop] === 'function') &&
            !Object.isFrozen(o[prop])) {
            deepFreeze(o[prop]);
        }
    });
    return o;
}
function maybeDeepFreeze(obj) {
    if (isDevelopment() || isTest()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) {
            return deepFreeze(obj);
        }
    }
    return obj;
}

var bundle_esm_hasOwnProperty = Object.prototype.hasOwnProperty;
function mergeDeep() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    return mergeDeepArray(sources);
}
function mergeDeepArray(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = shallowCopyForMerge(target, pastCopies);
        for (var i = 1; i < count; ++i) {
            target = mergeHelper(target, sources[i], pastCopies);
        }
    }
    return target;
}
function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function mergeHelper(target, source, pastCopies) {
    if (isObject(source) && isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) {
            target = shallowCopyForMerge(target, pastCopies);
        }
        Object.keys(source).forEach(function (sourceKey) {
            var sourceValue = source[sourceKey];
            if (bundle_esm_hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) {
                    target[sourceKey] = mergeHelper(shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
                }
            }
            else {
                target[sourceKey] = sourceValue;
            }
        });
        return target;
    }
    return source;
}
function shallowCopyForMerge(value, pastCopies) {
    if (value !== null &&
        typeof value === 'object' &&
        pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) {
            value = value.slice(0);
        }
        else {
            value = (0,tslib_es6/* __assign */.pi)({ __proto__: Object.getPrototypeOf(value) }, value);
        }
        pastCopies.push(value);
    }
    return value;
}

var haveWarned = Object.create({});
function warnOnceInDevelopment(msg, type) {
    if (type === void 0) { type = 'warn'; }
    if (!isProduction() && !haveWarned[msg]) {
        if (!isTest()) {
            haveWarned[msg] = true;
        }
        if (type === 'error') {
            console.error(msg);
        }
        else {
            console.warn(msg);
        }
    }
}

function stripSymbols(data) {
    return JSON.parse(JSON.stringify(data));
}


//# sourceMappingURL=bundle.esm.js.map

;// CONCATENATED MODULE: ./node_modules/apollo-cache/lib/bundle.esm.js


function queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery',
        },
        selectionSet: selectionSetFromObj(obj),
    };
    var out = {
        kind: 'Document',
        definitions: [op],
    };
    return out;
}
function fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType',
            },
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery',
        },
        selectionSet: selectionSetFromObj(obj),
    };
    var out = {
        kind: 'Document',
        definitions: [frag],
    };
    return out;
}
function selectionSetFromObj(obj) {
    if (typeof obj === 'number' ||
        typeof obj === 'boolean' ||
        typeof obj === 'string' ||
        typeof obj === 'undefined' ||
        obj === null) {
        return null;
    }
    if (Array.isArray(obj)) {
        return selectionSetFromObj(obj[0]);
    }
    var selections = [];
    Object.keys(obj).forEach(function (key) {
        var nestedSelSet = selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key,
            },
            selectionSet: nestedSelSet || undefined,
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections,
    };
    return selectionSet;
}
var justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename',
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null,
                    },
                ],
            },
        },
    ],
};

var ApolloCache = (function () {
    function ApolloCache() {
    }
    ApolloCache.prototype.transformDocument = function (document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function (document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic,
        });
    };
    ApolloCache.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.read({
            query: getFragmentQueryDocument(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic,
        });
    };
    ApolloCache.prototype.writeQuery = function (options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables,
        });
    };
    ApolloCache.prototype.writeFragment = function (options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: getFragmentQueryDocument(options.fragment, options.fragmentName),
        });
    };
    ApolloCache.prototype.writeData = function (_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: justTypenameQuery,
                });
            }
            catch (e) {
            }
            var __typename = (typenameResult && typenameResult.__typename) || '__ClientData';
            var dataToWrite = Object.assign({ __typename: __typename }, data);
            this.writeFragment({
                id: id,
                fragment: fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite,
            });
        }
        else {
            this.writeQuery({ query: queryFromPojo(data), data: data });
        }
    };
    return ApolloCache;
}());

var Cache;
(function (Cache) {
})(Cache || (Cache = {}));


//# sourceMappingURL=bundle.esm.js.map

;// CONCATENATED MODULE: ./node_modules/@wry/context/lib/context.esm.js
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var MISSING_VALUE = {};
var idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var makeSlotClass = function () { return /** @class */ (function () {
    function Slot() {
        // If you have a Slot object, you can find out its slot.id, but you cannot
        // guess the slot.id of a Slot you don't have access to, thanks to the
        // randomized suffix.
        this.id = [
            "slot",
            idCounter++,
            Date.now(),
            Math.random().toString(36).slice(2),
        ].join(":");
    }
    Slot.prototype.hasValue = function () {
        for (var context_1 = currentContext; context_1; context_1 = context_1.parent) {
            // We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === MISSING_VALUE)
                    break;
                if (context_1 !== currentContext) {
                    // Cache the value in currentContext.slots so the next lookup will
                    // be faster. This caching is safe because the tree of contexts and
                    // the values of the slots are logically immutable.
                    currentContext.slots[this.id] = value;
                }
                return true;
            }
        }
        if (currentContext) {
            // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            currentContext.slots[this.id] = MISSING_VALUE;
        }
        return false;
    };
    Slot.prototype.getValue = function () {
        if (this.hasValue()) {
            return currentContext.slots[this.id];
        }
    };
    Slot.prototype.withValue = function (value, callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        var _a;
        var slots = (_a = {
                __proto__: null
            },
            _a[this.id] = value,
            _a);
        var parent = currentContext;
        currentContext = { parent: parent, slots: slots };
        try {
            // Function.prototype.apply allows the arguments array argument to be
            // omitted or undefined, so args! is fine here.
            return callback.apply(thisArg, args);
        }
        finally {
            currentContext = parent;
        }
    };
    // Capture the current context and wrap a callback function so that it
    // reestablishes the captured context when called.
    Slot.bind = function (callback) {
        var context = currentContext;
        return function () {
            var saved = currentContext;
            try {
                currentContext = context;
                return callback.apply(this, arguments);
            }
            finally {
                currentContext = saved;
            }
        };
    };
    // Immediately run a callback function without any captured context.
    Slot.noContext = function (callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        if (currentContext) {
            var saved = currentContext;
            try {
                currentContext = null;
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            }
            finally {
                currentContext = saved;
            }
        }
        else {
            return callback.apply(thisArg, args);
        }
    };
    return Slot;
}()); };
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var globalKey = "@wry/context:Slot";
var host = Array;
var Slot = host[globalKey] || function () {
    var Slot = makeSlotClass();
    try {
        Object.defineProperty(host, globalKey, {
            value: host[globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false,
        });
    }
    finally {
        return Slot;
    }
}();

var bind = Slot.bind, noContext = Slot.noContext;
function setTimeoutWithContext(callback, delay) {
    return setTimeout(bind(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function asyncFromGen(genFn) {
    return function () {
        var gen = genFn.apply(this, arguments);
        var boundNext = bind(gen.next);
        var boundThrow = bind(gen.throw);
        return new Promise(function (resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                }
                catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if (isPromiseLike(result.value)) {
                    result.value.then(next, result.done ? reject : invokeThrow);
                }
                else {
                    next(result.value);
                }
            }
            var invokeNext = function (value) { return invoke(boundNext, value); };
            var invokeThrow = function (error) { return invoke(boundThrow, error); };
            invokeNext();
        });
    };
}
function isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var wrappedFibers = (/* unused pure expression or super */ null && ([]));
function wrapYieldingFiberMethods(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if (wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function (obj, method) {
            var fn = obj[method];
            obj[method] = function () {
                return noContext(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        wrappedFibers.push(Fiber);
    }
    return Fiber;
}


//# sourceMappingURL=context.esm.js.map

;// CONCATENATED MODULE: ./node_modules/optimism/lib/bundle.esm.js



function defaultDispose() { }
var bundle_esm_Cache = /** @class */ (function () {
    function Cache(max, dispose) {
        if (max === void 0) { max = Infinity; }
        if (dispose === void 0) { dispose = defaultDispose; }
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function (key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function (key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function (key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) {
                newer.older = older;
            }
            if (older) {
                older.newer = newer;
            }
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) {
                this.oldest = newer;
            }
        }
        return entry;
    };
    Cache.prototype.set = function (key, value) {
        var entry = this.getEntry(key);
        if (entry) {
            return entry.value = value;
        }
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) {
            this.newest.newer = entry;
        }
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function () {
        while (this.oldest && this.map.size > this.max) {
            this.delete(this.oldest.key);
        }
    };
    Cache.prototype.delete = function (key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) {
                this.newest = entry.older;
            }
            if (entry === this.oldest) {
                this.oldest = entry.newer;
            }
            if (entry.newer) {
                entry.newer.older = entry.older;
            }
            if (entry.older) {
                entry.older.newer = entry.newer;
            }
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}());

var parentEntrySlot = new Slot();

var reusableEmptyArray = [];
var emptySetPool = [];
var POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function assert(condition, optionalMessage) {
    if (!condition) {
        throw new Error(optionalMessage || "assertion failure");
    }
}
function valueIs(a, b) {
    var len = a.length;
    return (
    // Unknown values are not equal to each other.
    len > 0 &&
        // Both values must be ordinary (or both exceptional) to be equal.
        len === b.length &&
        // The underlying value or exception must be the same.
        a[len - 1] === b[len - 1]);
}
function valueGet(value) {
    switch (value.length) {
        case 0: throw new Error("unknown value");
        case 1: return value[0];
        case 2: throw value[1];
    }
}
function valueCopy(value) {
    return value.slice(0);
}
var Entry = /** @class */ (function () {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function () {
        assert(!this.recomputing, "already recomputing");
        if (!rememberParent(this) && maybeReportOrphan(this)) {
            // The recipient of the entry.reportOrphan callback decided to dispose
            // of this orphan entry by calling entry.dispose(), so we don't need to
            // (and should not) proceed with the recomputation.
            return void 0;
        }
        return mightBeDirty(this)
            ? reallyRecompute(this)
            : valueGet(this.value);
    };
    Entry.prototype.setDirty = function () {
        if (this.dirty)
            return;
        this.dirty = true;
        this.value.length = 0;
        reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function () {
        var _this = this;
        forgetChildren(this).forEach(maybeReportOrphan);
        maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function (parent) {
            parent.setDirty();
            forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}());
function rememberParent(child) {
    var parent = parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) {
            parent.childValues.set(child, []);
        }
        if (mightBeDirty(child)) {
            reportDirtyChild(parent, child);
        }
        else {
            reportCleanChild(parent, child);
        }
        return parent;
    }
}
function reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    parentEntrySlot.withValue(entry, recomputeNewValue, [entry]);
    if (maybeSubscribe(entry)) {
        // If we successfully recomputed entry.value and did not fail to
        // (re)subscribe, then this Entry is no longer explicitly dirty.
        setClean(entry);
    }
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach(maybeReportOrphan);
    return valueGet(entry.value);
}
function recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    }
    catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function setClean(entry) {
    entry.dirty = false;
    if (mightBeDirty(entry)) {
        // This Entry may still have dirty children, in which case we can't
        // let our parents know we're clean just yet.
        return;
    }
    reportClean(entry);
}
function reportDirty(child) {
    child.parents.forEach(function (parent) { return reportDirtyChild(parent, child); });
}
function reportClean(child) {
    child.parents.forEach(function (parent) { return reportCleanChild(parent, child); });
}
// Let a parent Entry know that one of its children may be dirty.
function reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    assert(parent.childValues.has(child));
    assert(mightBeDirty(child));
    if (!parent.dirtyChildren) {
        parent.dirtyChildren = emptySetPool.pop() || new Set;
    }
    else if (parent.dirtyChildren.has(child)) {
        // If we already know this child is dirty, then we must have already
        // informed our own parents that we are dirty, so we can terminate
        // the recursion early.
        return;
    }
    parent.dirtyChildren.add(child);
    reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    assert(parent.childValues.has(child));
    assert(!mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) {
        parent.childValues.set(child, valueCopy(child.value));
    }
    else if (!valueIs(childValue, child.value)) {
        parent.setDirty();
    }
    removeDirtyChild(parent, child);
    if (mightBeDirty(parent)) {
        return;
    }
    reportClean(parent);
}
function removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if (emptySetPool.length < POOL_TARGET_SIZE) {
                emptySetPool.push(dc);
            }
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function maybeReportOrphan(entry) {
    return entry.parents.size === 0 &&
        typeof entry.reportOrphan === "function" &&
        entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function forgetChildren(parent) {
    var children = reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function (_value, child) {
            forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    assert(parent.dirtyChildren === null);
    return children;
}
function forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    removeDirtyChild(parent, child);
}
function maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") {
        try {
            maybeUnsubscribe(entry); // Prevent double subscriptions.
            entry.unsubscribe = entry.subscribe.apply(null, entry.args);
        }
        catch (e) {
            // If this Entry has a subscribe function and it threw an exception
            // (or an unsubscribe function it previously returned now throws),
            // return false to indicate that we were not able to subscribe (or
            // unsubscribe), and this Entry should remain dirty.
            entry.setDirty();
            return false;
        }
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}

// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var KeyTrie = /** @class */ (function () {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function () {
        var array = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            array[_i] = arguments[_i];
        }
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function (array) {
        var node = this;
        array.forEach(function (key) { return node = node.getChildTrie(key); });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function (key) {
        var map = this.weakness && isObjRef(key)
            ? this.weak || (this.weak = new WeakMap())
            : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child)
            map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}());
function isObjRef(value) {
    switch (typeof value) {
        case "object":
            if (value === null)
                break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}

// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var keyTrie = new KeyTrie(typeof WeakMap === "function");
function defaultMakeCacheKey() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return keyTrie.lookupArray(args);
}
var caches = new Set();
function wrap(originalFunction, options) {
    if (options === void 0) { options = Object.create(null); }
    var cache = new bundle_esm_Cache(options.max || Math.pow(2, 16), function (entry) { return entry.dispose(); });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || defaultMakeCacheKey;
    function optimistic() {
        if (disposable && !parentEntrySlot.hasValue()) {
            // If there's no current parent computation, and this wrapped
            // function is disposable (meaning we don't care about entry.value,
            // just dependency tracking), then we can short-cut everything else
            // in this function, because entry.recompute() is going to recycle
            // the entry object without recomputing anything, anyway.
            return void 0;
        }
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) {
            return originalFunction.apply(null, arguments);
        }
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) {
            entry.args = args;
        }
        else {
            entry = new Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) {
                entry.reportOrphan = function () { return cache.delete(key); };
            }
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!parentEntrySlot.hasValue()) {
            caches.forEach(function (cache) { return cache.clean(); });
            caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function () {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) {
            child.setDirty();
        }
    };
    return optimistic;
}


//# sourceMappingURL=bundle.esm.js.map

;// CONCATENATED MODULE: ./node_modules/apollo-cache-inmemory/lib/bundle.esm.js






var bundle_esm_haveWarned = false;
function shouldWarn() {
    var answer = !bundle_esm_haveWarned;
    if (!isTest()) {
        bundle_esm_haveWarned = true;
    }
    return answer;
}
var HeuristicFragmentMatcher = (function () {
    function HeuristicFragmentMatcher() {
    }
    HeuristicFragmentMatcher.prototype.ensureReady = function () {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function () {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function (idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) {
            return isRootQuery;
        }
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            if (shouldWarn()) {
                 true || 0;
                 true || 0;
                 true || 0;
            }
            return 'heuristic';
        }
        if (__typename === typeCondition) {
            return true;
        }
        if (shouldWarn()) {
             true || 0;
        }
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}());
var IntrospectionFragmentMatcher = (function () {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        }
        else {
            this.isReady = false;
        }
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function (idValue, typeCondition, context) {
         true ? (0,invariant_esm/* invariant */.kG)(this.isReady, 1) : 0;
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) {
            return isRootQuery;
        }
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
         true ? (0,invariant_esm/* invariant */.kG)(__typename, 2) : 0;
        if (__typename === typeCondition) {
            return true;
        }
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename &&
            implementingTypes &&
            implementingTypes.indexOf(__typename) > -1) {
            return true;
        }
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function (introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function (type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') {
                typeMap[type.name] = type.possibleTypes.map(function (implementingType) { return implementingType.name; });
            }
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}());

var hasOwn = Object.prototype.hasOwnProperty;
var DepTrackingCache = (function () {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) { data = Object.create(null); }
        this.data = data;
        this.depend = wrap(function (dataId) { return _this.data[dataId]; }, {
            disposable: true,
            makeCacheKey: function (dataId) {
                return dataId;
            },
        });
    }
    DepTrackingCache.prototype.toObject = function () {
        return this.data;
    };
    DepTrackingCache.prototype.get = function (dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function (dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function (dataId) {
        if (hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function () {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function (newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function (dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function (dataId) {
                if (!hasOwn.call(newData, dataId)) {
                    _this.delete(dataId);
                }
            });
        }
        else {
            Object.keys(this.data).forEach(function (dataId) {
                _this.delete(dataId);
            });
        }
    };
    return DepTrackingCache;
}());
function defaultNormalizedCacheFactory(seed) {
    return new DepTrackingCache(seed);
}

var StoreReader = (function () {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new KeyTrie(canUseWeakMap) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = wrap(function (options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function (_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof DepTrackingCache) {
                    return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
                }
            }
        });
        this.executeSelectionSet = wrap(function (options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function (_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof DepTrackingCache) {
                    return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
                }
            }
        });
        this.executeSubSelectedArray = wrap(function (options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function (_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof DepTrackingCache) {
                    return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
                }
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function (options) {
        return this.diffQueryAgainstStore((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { returnPartialData: false })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function (_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = getQueryDefinition(query);
        variables = bundle_esm_assign({}, getDefaultValues(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: (config && config.cacheRedirects) || {},
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query',
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction,
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) {
            execResult.missing.forEach(function (info) {
                if (info.tolerable)
                    return;
                throw  true ? new invariant_esm/* InvariantError */.ej(8) : 0;
            });
        }
        if (previousResult) {
            if (equal(previousResult, execResult.result)) {
                execResult.result = previousResult;
            }
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields,
        };
    };
    StoreReader.prototype.executeStoreQuery = function (_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? defaultFragmentMatcher : _b;
        var mainDefinition = getMainDefinition(query);
        var fragments = getFragmentDefinitions(query);
        var fragmentMap = createFragmentMap(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher,
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext,
        });
    };
    StoreReader.prototype.executeSelectionSet = function (_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = { result: null };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = (object && object.__typename) ||
            (rootValue.id === 'ROOT_QUERY' && 'Query') ||
            void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function (selection) {
            var _a;
            if (!shouldInclude(selection, variables)) {
                return;
            }
            if (isField(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') {
                    objectsToMerge.push((_a = {},
                        _a[resultKeyNameFromField(selection)] = fieldResult,
                        _a));
                }
            }
            else {
                var fragment = void 0;
                if (isInlineFragment(selection)) {
                    fragment = selection;
                }
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) {
                        throw  true ? new invariant_esm/* InvariantError */.ej(9) : 0;
                    }
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition ||
                    execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext,
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) {
                        fragmentExecResult = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, fragmentExecResult), { missing: fragmentExecResult.missing.map(function (info) {
                                return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, info), { tolerable: true });
                            }) });
                    }
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = mergeDeepArray(objectsToMerge);
        if (this.freezeResults && "production" !== 'production') {}
        return finalResult;
    };
    StoreReader.prototype.executeField = function (object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = argumentsObjectFromField(field, variables);
        var info = {
            resultKey: resultKeyNameFromField(field),
            directives: getDirectiveInfoFromField(field, variables),
        };
        var readStoreResult = readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) {
            return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
                field: field,
                array: readStoreResult.result,
                execContext: execContext,
            }));
        }
        if (!field.selectionSet) {
            assertSelectionSetForIdValue(field, readStoreResult.result);
            if (this.freezeResults && "production" !== 'production') {}
            return readStoreResult;
        }
        if (readStoreResult.result == null) {
            return readStoreResult;
        }
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext,
        }));
    };
    StoreReader.prototype.combineExecResults = function () {
        var execResults = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            execResults[_i] = arguments[_i];
        }
        var missing;
        execResults.forEach(function (execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing,
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function (_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function (item) {
            if (item === null) {
                return null;
            }
            if (Array.isArray(item)) {
                return handleMissing(_this.executeSubSelectedArray({
                    field: field,
                    array: item,
                    execContext: execContext,
                }));
            }
            if (field.selectionSet) {
                return handleMissing(_this.executeSelectionSet({
                    selectionSet: field.selectionSet,
                    rootValue: item,
                    execContext: execContext,
                }));
            }
            assertSelectionSetForIdValue(field, item);
            return item;
        });
        if (this.freezeResults && "production" !== 'production') {}
        return { result: array, missing: missing };
    };
    return StoreReader;
}());
function assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && bundle_esm_isIdValue(value)) {
        throw  true ? new invariant_esm/* InvariantError */.ej(10) : 0;
    }
}
function defaultFragmentMatcher() {
    return true;
}
function assertIdValue(idValue) {
     true ? invariant(isIdValue(idValue), 11) : 0;
}
function readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) {
        storeKeyName = getStoreKeyName(storeKeyName, args, directives);
    }
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' &&
            context.cacheRedirects &&
            typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) {
                    fieldValue = resolver(object, args, {
                        getCacheKey: function (storeObj) {
                            var id = context.dataIdFromObject(storeObj);
                            return id && toIdValue({
                                id: id,
                                typename: storeObj.__typename,
                            });
                        },
                    });
                }
            }
        }
    }
    if (typeof fieldValue === 'undefined') {
        return {
            result: fieldValue,
            missing: [{
                    object: object,
                    fieldName: storeKeyName,
                    tolerable: false,
                }],
        };
    }
    if (isJsonValue(fieldValue)) {
        fieldValue = fieldValue.json;
    }
    return {
        result: fieldValue,
    };
}

var ObjectCache = (function () {
    function ObjectCache(data) {
        if (data === void 0) { data = Object.create(null); }
        this.data = data;
    }
    ObjectCache.prototype.toObject = function () {
        return this.data;
    };
    ObjectCache.prototype.get = function (dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function (dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function (dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function () {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function (newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}());
function defaultNormalizedCacheFactory$1(seed) {
    return new ObjectCache(seed);
}

var WriteError = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error));
function enhanceErrorWithDocument(error, document) {
    var enhancedError = new WriteError("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var StoreWriter = (function () {
    function StoreWriter() {
    }
    StoreWriter.prototype.writeQueryToStore = function (_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction,
        });
    };
    StoreWriter.prototype.writeResultToStore = function (_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = getOperationDefinition(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: bundle_esm_assign({}, getDefaultValues(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: createFragmentMap(getFragmentDefinitions(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction,
                },
            });
        }
        catch (e) {
            throw enhanceErrorWithDocument(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function (_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function (selection) {
            var _a;
            if (!shouldInclude(selection, variables)) {
                return;
            }
            if (isField(selection)) {
                var resultFieldKey = resultKeyNameFromField(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') {
                    _this.writeFieldToStore({
                        dataId: dataId,
                        value: value,
                        field: selection,
                        context: context,
                    });
                }
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function (directive) { return directive.name && directive.name.value === 'defer'; });
                        isClient = selection.directives.some(function (directive) { return directive.name && directive.name.value === 'client'; });
                    }
                    if (!isDefered && !isClient && context.fragmentMatcherFunction) {
                         true || 0;
                    }
                }
            }
            else {
                var fragment = void 0;
                if (isInlineFragment(selection)) {
                    fragment = selection;
                }
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                     true ? (0,invariant_esm/* invariant */.kG)(fragment, 3) : 0;
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = toIdValue({ id: id, typename: undefined });
                    var fakeContext = {
                        store: new ObjectCache((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {},
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    if (!isProduction() && match === 'heuristic') {
                         true || 0;
                    }
                    matches = !!match;
                }
                if (matches) {
                    _this.writeSelectionSetToStore({
                        result: result,
                        selectionSet: fragment.selectionSet,
                        dataId: dataId,
                        context: context,
                    });
                }
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function (_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = storeKeyNameFromField(field, variables);
        if (!field.selectionSet || value === null) {
            storeValue =
                value != null && typeof value === 'object'
                    ?
                        { type: 'json', json: value }
                    :
                        value;
        }
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        }
        else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!isGeneratedId(valueDataId)) {
                valueDataId = '$' + valueDataId;
            }
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                 true ? (0,invariant_esm/* invariant */.kG)(!semanticId || !isGeneratedId(semanticId), 4) : 0;
                if (semanticId ||
                    (typeof semanticId === 'number' && semanticId === 0)) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!isDataProcessed(valueDataId, field, context.processedData)) {
                this.writeSelectionSetToStore({
                    dataId: valueDataId,
                    result: value,
                    selectionSet: field.selectionSet,
                    context: context,
                });
            }
            var typename = value.__typename;
            storeValue = toIdValue({ id: valueDataId, typename: typename }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && bundle_esm_isIdValue(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                 true ? (0,invariant_esm/* invariant */.kG)(!generated || escapedId.generated || typenameChanged, 5) : 0;
                 true ? (0,invariant_esm/* invariant */.kG)(!hadTypename || hasTypename, 6) : 0;
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) {
                            store.delete(escapedId.id);
                        }
                    }
                    else {
                        mergeWithGenerated(escapedId.id, storeValue.id, store);
                    }
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !equal(storeValue, storeObject[storeFieldName])) {
            store.set(dataId, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
        }
    };
    StoreWriter.prototype.processArrayValue = function (value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function (item, index) {
            if (item === null) {
                return null;
            }
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) {
                return _this.processArrayValue(item, itemDataId, selectionSet, context);
            }
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!isDataProcessed(itemDataId, selectionSet, context.processedData)) {
                _this.writeSelectionSetToStore({
                    dataId: itemDataId,
                    result: item,
                    selectionSet: selectionSet,
                    context: context,
                });
            }
            return toIdValue({ id: itemDataId, typename: item.__typename }, generated);
        });
    };
    return StoreWriter;
}());
function isGeneratedId(id) {
    return id[0] === '$';
}
function mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) {
        return false;
    }
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function (key) {
        var value = generated[key];
        var realValue = real[key];
        if (bundle_esm_isIdValue(value) &&
            isGeneratedId(value.id) &&
            bundle_esm_isIdValue(realValue) &&
            !equal(value, realValue) &&
            mergeWithGenerated(value.id, realValue.id, cache)) {
            madeChanges = true;
        }
    });
    cache.delete(generatedKey);
    var newRealValue = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, generated), real);
    if (equal(newRealValue, real)) {
        return madeChanges;
    }
    cache.set(realKey, newRealValue);
    return true;
}
function isDataProcessed(dataId, field, processedData) {
    if (!processedData) {
        return false;
    }
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) {
            return true;
        }
        else {
            processedData[dataId].push(field);
        }
    }
    else {
        processedData[dataId] = [field];
    }
    return false;
}

var defaultConfig = {
    fragmentMatcher: new HeuristicFragmentMatcher(),
    dataIdFromObject: defaultDataIdFromObject,
    addTypename: true,
    resultCaching: true,
    freezeResults: false,
};
function defaultDataIdFromObject(result) {
    if (result.__typename) {
        if (result.id !== undefined) {
            return result.__typename + ":" + result.id;
        }
        if (result._id !== undefined) {
            return result.__typename + ":" + result._id;
        }
    }
    return null;
}
var hasOwn$1 = Object.prototype.hasOwnProperty;
var OptimisticCacheLayer = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function () {
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function (dataId) {
        return hasOwn$1.call(this.data, dataId)
            ? this.data[dataId]
            : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}(ObjectCache));
var InMemoryCache = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new KeyTrie(canUseWeakMap);
        _this.silenceBroadcast = false;
        _this.config = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, defaultConfig), config);
        if (_this.config.customResolvers) {
             true || 0;
            _this.config.cacheRedirects = _this.config.customResolvers;
        }
        if (_this.config.cacheResolvers) {
             true || 0;
            _this.config.cacheRedirects = _this.config.cacheResolvers;
        }
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching
            ? new DepTrackingCache()
            : new ObjectCache();
        _this.optimisticData = _this.data;
        _this.storeWriter = new StoreWriter();
        _this.storeReader = new StoreReader({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults,
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = wrap(function (c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function (c) {
                if (c.optimistic) {
                    return;
                }
                if (c.previousResult) {
                    return;
                }
                if (cache.data instanceof DepTrackingCache) {
                    return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
                }
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function (data) {
        if (data)
            this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function (optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function (options) {
        if (typeof options.rootId === 'string' &&
            typeof this.data.get(options.rootId) === 'undefined') {
            return null;
        }
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config,
        }) || null;
    };
    InMemoryCache.prototype.write = function (write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction,
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function (query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config,
        });
    };
    InMemoryCache.prototype.watch = function (watch) {
        var _this = this;
        this.watches.add(watch);
        return function () {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function (query) {
        throw  true ? new invariant_esm/* InvariantError */.ej(7) : 0;
    };
    InMemoryCache.prototype.reset = function () {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function (idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while (layer instanceof OptimisticCacheLayer) {
            if (layer.optimisticId === idToRemove) {
                ++removedCount;
            }
            else {
                toReapply.push(layer);
            }
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while (toReapply.length > 0) {
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function (transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') {
            this.data = this.optimisticData = new OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        }
        try {
            transaction(this);
        }
        finally {
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function (transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function (document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = addTypenameToDocument(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function () {
        var _this = this;
        if (!this.silenceBroadcast) {
            this.watches.forEach(function (c) { return _this.maybeBroadcastWatch(c); });
        }
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function (c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic,
        }));
    };
    return InMemoryCache;
}(ApolloCache));


//# sourceMappingURL=bundle.esm.js.map

// EXTERNAL MODULE: ./node_modules/zen-observable/index.js
var zen_observable = __webpack_require__(49329);
var zen_observable_default = /*#__PURE__*/__webpack_require__.n(zen_observable);
;// CONCATENATED MODULE: ./node_modules/zen-observable-ts/lib/bundle.esm.js


var bundle_esm_Observable = (zen_observable_default());

/* harmony default export */ var bundle_esm = (bundle_esm_Observable);

//# sourceMappingURL=bundle.esm.js.map

;// CONCATENATED MODULE: ./node_modules/apollo-link/lib/bundle.esm.js







function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context',
    ];
    for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) {
            throw  true ? new invariant_esm/* InvariantError */.ej(2) : 0;
        }
    }
    return operation;
}
var LinkError = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error));
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function (resolve, reject) {
        observable.subscribe({
            next: function (data) {
                if (completed) {
                     true || 0;
                }
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject,
        });
    });
}
var makePromise = (/* unused pure expression or super */ null && (toPromise));
function fromPromise(promise) {
    return new Observable(function (observer) {
        promise
            .then(function (value) {
            observer.next(value);
            observer.complete();
        })
            .catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new bundle_esm(function (observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query,
    };
    if (!transformedOperation.operationName) {
        transformedOperation.operationName =
            typeof transformedOperation.query !== 'string'
                ? getOperationName(transformedOperation.query)
                : '';
    }
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = (0,tslib_es6/* __assign */.pi)({}, starting);
    var setContext = function (next) {
        if (typeof next === 'function') {
            context = (0,tslib_es6/* __assign */.pi)({}, context, next(context));
        }
        else {
            context = (0,tslib_es6/* __assign */.pi)({}, context, next);
        }
    };
    var getContext = function () { return ((0,tslib_es6/* __assign */.pi)({}, context)); };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext,
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext,
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function () { return getKey(operation); },
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([operationName, query, variables]);
}

function passthrough(op, forward) {
    return forward ? forward(op) : bundle_esm.of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function () { return bundle_esm.of(); });
}
function from(links) {
    if (links.length === 0)
        return empty();
    return links.map(toLink).reduce(function (x, y) { return x.concat(y); });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) {
        return new ApolloLink(function (operation) {
            return test(operation)
                ? leftLink.request(operation) || bundle_esm.of()
                : rightLink.request(operation) || bundle_esm.of();
        });
    }
    else {
        return new ApolloLink(function (operation, forward) {
            return test(operation)
                ? leftLink.request(operation, forward) || bundle_esm.of()
                : rightLink.request(operation, forward) || bundle_esm.of();
        });
    }
}
var concat = function (first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) {
         true || 0;
        return firstLink;
    }
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) {
        return new ApolloLink(function (operation) {
            return firstLink.request(operation, function (op) { return nextLink.request(op) || bundle_esm.of(); }) || bundle_esm.of();
        });
    }
    else {
        return new ApolloLink(function (operation, forward) {
            return (firstLink.request(operation, function (op) {
                return nextLink.request(op, forward) || bundle_esm.of();
            }) || bundle_esm.of());
        });
    }
};
var ApolloLink = (function () {
    function ApolloLink(request) {
        if (request)
            this.request = request;
    }
    ApolloLink.prototype.split = function (test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function (next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function (operation, forward) {
        throw  true ? new invariant_esm/* InvariantError */.ej(1) : 0;
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}());
function execute(link, operation) {
    return (link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || bundle_esm.of());
}


//# sourceMappingURL=bundle.esm.js.map

// EXTERNAL MODULE: ./node_modules/symbol-observable/es/index.js + 1 modules
var es = __webpack_require__(98123);
;// CONCATENATED MODULE: ./node_modules/apollo-client/bundle.esm.js







var NetworkStatus;
(function (NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})(NetworkStatus || (NetworkStatus = {}));
function isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}

var apollo_client_bundle_esm_Observable = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[es/* default */.Z] = function () {
        return this;
    };
    Observable.prototype['@@observable'] = function () {
        return this;
    };
    return Observable;
}(bundle_esm));

function isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}

function isApolloError(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var generateErrorMessage = function (err) {
    var message = '';
    if (isNonEmptyArray(err.graphQLErrors)) {
        err.graphQLErrors.forEach(function (graphQLError) {
            var errorMessage = graphQLError
                ? graphQLError.message
                : 'Error message not found.';
            message += "GraphQL error: " + errorMessage + "\n";
        });
    }
    if (err.networkError) {
        message += 'Network error: ' + err.networkError.message + '\n';
    }
    message = message.replace(/\n$/, '');
    return message;
};
var ApolloError = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) {
            _this.message = generateErrorMessage(_this);
        }
        else {
            _this.message = errorMessage;
        }
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error));

var FetchType;
(function (FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})(FetchType || (FetchType = {}));

var hasError = function (storeValue, policy) {
    if (policy === void 0) { policy = 'none'; }
    return storeValue && (storeValue.networkError ||
        (policy === 'none' && isNonEmptyArray(storeValue.graphQLErrors)));
};
var ObservableQuery = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function (observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = getOperationDefinition(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var observer = {
                next: function (result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) {
                        _this.queryManager.removeQuery(_this.queryId);
                    }
                    setTimeout(function () {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject,
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function () {
        var result = this.getCurrentResult();
        if (result.data === undefined) {
            result.data = {};
        }
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function () {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: NetworkStatus.error,
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' ||
            fetchPolicy === 'no-cache';
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if (hasError(queryStoreValue, this.options.errorPolicy)) {
                return {
                    data: void 0,
                    loading: false,
                    networkStatus: networkStatus,
                    error: new ApolloError({
                        graphQLErrors: queryStoreValue.graphQLErrors,
                        networkError: queryStoreValue.networkError,
                    }),
                };
            }
            if (queryStoreValue.variables) {
                this.options.variables = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus,
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') {
                result.errors = queryStoreValue.graphQLErrors;
            }
        }
        else {
            var loading = isNetworkFetchPolicy ||
                (partial && fetchPolicy !== 'cache-only');
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? NetworkStatus.loading : NetworkStatus.ready,
            };
        }
        if (!partial) {
            this.updateLastResult((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), { stale: false }));
        }
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), { partial: partial });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function (newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot &&
            newResult &&
            snapshot.networkStatus === newResult.networkStatus &&
            snapshot.stale === newResult.stale &&
            equal(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function () {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function () {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function () {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function () {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function (variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') {
            return Promise.reject( true ? new invariant_esm/* InvariantError */.ej(1) : 0);
        }
        if (fetchPolicy !== 'no-cache' &&
            fetchPolicy !== 'cache-and-network') {
            fetchPolicy = 'network-only';
        }
        if (!equal(this.variables, variables)) {
            this.variables = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.variables), variables);
        }
        if (!equal(this.options.variables, this.variables)) {
            this.options.variables = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.options.variables), this.variables);
        }
        return this.queryManager.fetchQuery(this.queryId, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.options), { fetchPolicy: fetchPolicy }), FetchType.refetch);
    };
    ObservableQuery.prototype.fetchMore = function (fetchMoreOptions) {
        var _this = this;
         true ? (0,invariant_esm/* invariant */.kG)(fetchMoreOptions.updateQuery, 2) : 0;
        var combinedOptions = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (fetchMoreOptions.query ? fetchMoreOptions : (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.options), fetchMoreOptions), { variables: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.variables), fetchMoreOptions.variables) }))), { fetchPolicy: 'network-only' });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager
            .fetchQuery(qid, combinedOptions, FetchType.normal, this.queryId)
            .then(function (fetchMoreResult) {
            _this.updateQuery(function (previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables,
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function (error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function (options) {
        var _this = this;
        var subscription = this.queryManager
            .startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
        })
            .subscribe({
            next: function (subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) {
                    _this.updateQuery(function (previous, _a) {
                        var variables = _a.variables;
                        return updateQuery(previous, {
                            subscriptionData: subscriptionData,
                            variables: variables,
                        });
                    });
                }
            },
            error: function (err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                 true || 0;
            },
        });
        this.subscriptions.add(subscription);
        return function () {
            if (_this.subscriptions.delete(subscription)) {
                subscription.unsubscribe();
            }
        };
    };
    ObservableQuery.prototype.setOptions = function (opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.options), opts);
        if (opts.pollInterval) {
            this.startPolling(opts.pollInterval);
        }
        else if (opts.pollInterval === 0) {
            this.stopPolling();
        }
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' ||
            oldFetchPolicy === 'standby' ||
            fetchPolicy === 'network-only'), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function (variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) { tryFetch = false; }
        if (fetchResults === void 0) { fetchResults = true; }
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && equal(variables, this.variables)) {
            return this.observers.size && fetchResults
                ? this.result()
                : Promise.resolve();
        }
        this.variables = this.options.variables = variables;
        if (!this.observers.size) {
            return Promise.resolve();
        }
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function (mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = tryFunctionOrLogError(function () {
            return mapFn(previousResult, { variables: variables });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function () {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function (pollInterval) {
        assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function (newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults
            ? newResult
            : cloneDeep(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function (observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) {
                subObserver.error = defaultSubscriptionObserverErrorCallback;
            }
        }
        catch (_a) { }
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult)
            observer.next(this.lastResult);
        if (observer.error && this.lastError)
            observer.error(this.lastError);
        if (first) {
            this.setUpQuery();
        }
        return function () {
            if (_this.observers.delete(observer) && !_this.observers.size) {
                _this.tearDownQuery();
            }
        };
    };
    ObservableQuery.prototype.setUpQuery = function () {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) {
            queryManager.addObservableQuery(queryId, this);
        }
        if (this.options.pollInterval) {
            assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function (error) {
            _this.updateLastResult((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, _this.lastResult), { errors: error.graphQLErrors, networkStatus: NetworkStatus.error, loading: false }));
            iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function (result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) {
                        queryManager.getLocalState().addExportedVariables(query_1, variables).then(function (variables) {
                            var previousVariables = _this.variables;
                            _this.variables = _this.options.variables = variables;
                            if (!result.loading &&
                                previousResult_1 &&
                                fetchPolicy_1 !== 'cache-only' &&
                                queryManager.transform(query_1).serverQuery &&
                                !equal(previousVariables, variables)) {
                                _this.refetch();
                            }
                            else {
                                iterateObserversSafely(_this.observers, 'next', result);
                            }
                        });
                    }
                    else {
                        iterateObserversSafely(_this.observers, 'next', result);
                    }
                }
            },
            error: onError,
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function () {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}(apollo_client_bundle_esm_Observable));
function defaultSubscriptionObserverErrorCallback(error) {
     true || 0;
}
function iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function (obs) { return obs[method] && observersWithMethod.push(obs); });
    observersWithMethod.forEach(function (obs) { return obs[method](argument); });
}
function assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
     true ? (0,invariant_esm/* invariant */.kG)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3) : 0;
}

var MutationStore = (function () {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function () {
        return this.store;
    };
    MutationStore.prototype.get = function (mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function (mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null,
        };
    };
    MutationStore.prototype.markMutationError = function (mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function (mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function () {
        this.store = {};
    };
    return MutationStore;
}());

var QueryStore = (function () {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function () {
        return this.store;
    };
    QueryStore.prototype.get = function (queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function (query) {
        var previousQuery = this.store[query.queryId];
         true ? (0,invariant_esm/* invariant */.kG)(!previousQuery ||
            previousQuery.document === query.document ||
            equal(previousQuery.document, query.document), 19) : 0;
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables &&
            previousQuery &&
            previousQuery.networkStatus !== NetworkStatus.loading) {
            if (!equal(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) {
            networkStatus = NetworkStatus.setVariables;
        }
        else if (query.isPoll) {
            networkStatus = NetworkStatus.poll;
        }
        else if (query.isRefetch) {
            networkStatus = NetworkStatus.refetch;
        }
        else {
            networkStatus = NetworkStatus.loading;
        }
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) {
            graphQLErrors = previousQuery.graphQLErrors;
        }
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata,
        };
        if (typeof query.fetchMoreForQueryId === 'string' &&
            this.store[query.fetchMoreForQueryId]) {
            this.store[query.fetchMoreForQueryId].networkStatus =
                NetworkStatus.fetchMore;
        }
    };
    QueryStore.prototype.markQueryResult = function (queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId])
            return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = NetworkStatus.ready;
        if (typeof fetchMoreForQueryId === 'string' &&
            this.store[fetchMoreForQueryId]) {
            this.store[fetchMoreForQueryId].networkStatus = NetworkStatus.ready;
        }
    };
    QueryStore.prototype.markQueryError = function (queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId])
            return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = NetworkStatus.error;
        if (typeof fetchMoreForQueryId === 'string') {
            this.markQueryResultClient(fetchMoreForQueryId, true);
        }
    };
    QueryStore.prototype.markQueryResultClient = function (queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) {
                storeValue.networkStatus = NetworkStatus.ready;
            }
        }
    };
    QueryStore.prototype.stopQuery = function (queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function (observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function (queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) {
                _this.stopQuery(queryId);
            }
            else {
                _this.store[queryId].networkStatus = NetworkStatus.loading;
            }
        });
    };
    return QueryStore;
}());

function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

var LocalState = (function () {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) {
            this.client = client;
        }
        if (resolvers) {
            this.addResolvers(resolvers);
        }
        if (fragmentMatcher) {
            this.setFragmentMatcher(fragmentMatcher);
        }
    }
    LocalState.prototype.addResolvers = function (resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) {
            resolvers.forEach(function (resolverGroup) {
                _this.resolvers = mergeDeep(_this.resolvers, resolverGroup);
            });
        }
        else {
            this.resolvers = mergeDeep(this.resolvers, resolvers);
        }
    };
    LocalState.prototype.setResolvers = function (resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function () {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function (_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            return (0,tslib_es6/* __generator */.Jh)(this, function (_c) {
                if (document) {
                    return [2, this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function (localResult) { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, remoteResult), { data: localResult.result })); })];
                }
                return [2, remoteResult];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function (fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function () {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function (document) {
        if (hasDirectives(['client'], document)) {
            if (this.resolvers) {
                return document;
            }
             true || 0;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function (document) {
        return this.resolvers ? removeClientSetsFromDocument(document) : document;
    };
    LocalState.prototype.prepareContext = function (context) {
        if (context === void 0) { context = {}; }
        var cache = this.cache;
        var newContext = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { cache: cache, getCacheKey: function (obj) {
                if (cache.config) {
                    return cache.config.dataIdFromObject(obj);
                }
                else {
                     true ? (0,invariant_esm/* invariant */.kG)(false, 6) : 0;
                }
            } });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function (document, variables, context) {
        if (variables === void 0) { variables = {}; }
        if (context === void 0) { context = {}; }
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                if (document) {
                    return [2, this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function (data) { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, variables), data.exportedVariables)); })];
                }
                return [2, (0,tslib_es6/* __assign */.pi)({}, variables)];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function (document) {
        var forceResolvers = false;
        visitor_visit(document, {
            Directive: {
                enter: function (node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function (arg) {
                            return arg.name.value === 'always' &&
                                arg.value.kind === 'BooleanValue' &&
                                arg.value.value === true;
                        });
                        if (forceResolvers) {
                            return BREAK;
                        }
                    }
                },
            },
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function (document, variables) {
        return this.cache.diff({
            query: buildQueryFromSelectionSet(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false,
        }).result;
    };
    LocalState.prototype.resolveDocument = function (document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) { context = {}; }
        if (variables === void 0) { variables = {}; }
        if (fragmentMatcher === void 0) { fragmentMatcher = function () { return true; }; }
        if (onlyRunForcedResolvers === void 0) { onlyRunForcedResolvers = false; }
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_b) {
                mainDefinition = getMainDefinition(document);
                fragments = getFragmentDefinitions(document);
                fragmentMap = createFragmentMap(fragments);
                definitionOperation = mainDefinition
                    .operation;
                defaultOperationType = definitionOperation
                    ? capitalizeFirstLetter(definitionOperation)
                    : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { cache: cache,
                        client: client }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers,
                };
                return [2, this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function (result) { return ({
                        result: result,
                        exportedVariables: execContext.exportedVariables,
                    }); })];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function (selectionSet, rootValue, execContext) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [rootValue];
                execute = function (selection) { return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function () {
                    var fragment, typeCondition;
                    return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                        if (!shouldInclude(selection, variables)) {
                            return [2];
                        }
                        if (isField(selection)) {
                            return [2, this.resolveField(selection, rootValue, execContext).then(function (fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') {
                                        resultsToMerge.push((_a = {},
                                            _a[resultKeyNameFromField(selection)] = fieldResult,
                                            _a));
                                    }
                                })];
                        }
                        if (isInlineFragment(selection)) {
                            fragment = selection;
                        }
                        else {
                            fragment = fragmentMap[selection.name.value];
                             true ? (0,invariant_esm/* invariant */.kG)(fragment, 7) : 0;
                        }
                        if (fragment && fragment.typeCondition) {
                            typeCondition = fragment.typeCondition.name.value;
                            if (execContext.fragmentMatcher(rootValue, typeCondition, context)) {
                                return [2, this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function (fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })];
                            }
                        }
                        return [2];
                    });
                }); };
                return [2, Promise.all(selectionSet.selections.map(execute)).then(function () {
                        return mergeDeepArray(resultsToMerge);
                    })];
            });
        });
    };
    LocalState.prototype.resolveField = function (field, rootValue, execContext) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = resultKeyNameFromField(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers ||
                    this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) {
                            resultPromise = Promise.resolve(resolve(rootValue, argumentsObjectFromField(field, variables), execContext.context, { field: field, fragmentMap: execContext.fragmentMap }));
                        }
                    }
                }
                return [2, resultPromise.then(function (result) {
                        if (result === void 0) { result = defaultResult; }
                        if (field.directives) {
                            field.directives.forEach(function (directive) {
                                if (directive.name.value === 'export' && directive.arguments) {
                                    directive.arguments.forEach(function (arg) {
                                        if (arg.name.value === 'as' && arg.value.kind === 'StringValue') {
                                            execContext.exportedVariables[arg.value.value] = result;
                                        }
                                    });
                                }
                            });
                        }
                        if (!field.selectionSet) {
                            return result;
                        }
                        if (result == null) {
                            return result;
                        }
                        if (Array.isArray(result)) {
                            return _this.resolveSubSelectedArray(field, result, execContext);
                        }
                        if (field.selectionSet) {
                            return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                        }
                    })];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function (field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function (item) {
            if (item === null) {
                return null;
            }
            if (Array.isArray(item)) {
                return _this.resolveSubSelectedArray(field, item, execContext);
            }
            if (field.selectionSet) {
                return _this.resolveSelectionSet(field.selectionSet, item, execContext);
            }
        }));
    };
    return LocalState;
}());

function multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new apollo_client_bundle_esm_Observable(function (observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function (value) {
                observers.forEach(function (obs) { return obs.next && obs.next(value); });
            },
            error: function (error) {
                observers.forEach(function (obs) { return obs.error && obs.error(error); });
            },
            complete: function () {
                observers.forEach(function (obs) { return obs.complete && obs.complete(); });
            },
        });
        return function () {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function asyncMap(observable, mapFn) {
    return new apollo_client_bundle_esm_Observable(function (observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function (value) {
                ++activeNextCount;
                new Promise(function (resolve) {
                    resolve(mapFn(value));
                }).then(function (result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function (e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function (e) {
                error && error.call(observer, e);
            },
            complete: function () {
                completed = true;
                if (!activeNextCount) {
                    complete && complete.call(observer);
                }
            },
        };
        var sub = observable.subscribe(handler);
        return function () { return sub.unsubscribe(); };
    });
}

var apollo_client_bundle_esm_hasOwnProperty = Object.prototype.hasOwnProperty;
var QueryManager = (function () {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function () { return undefined; } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new MutationStore();
        this.queryStore = new QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new (canUseWeakMap ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new LocalState({ cache: store.getCache() });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function () {
        var _this = this;
        this.queries.forEach(function (_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function (reject) {
            reject( true ? new invariant_esm/* InvariantError */.ej(8) : 0);
        });
    };
    QueryManager.prototype.mutate = function (_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_f) {
                switch (_f.label) {
                    case 0:
                         true ? (0,invariant_esm/* invariant */.kG)(mutation, 9) : 0;
                         true ? (0,invariant_esm/* invariant */.kG)(!fetchPolicy || fetchPolicy === 'no-cache', 10) : 0;
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function () { return ({ document: mutation }); });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [3, 2];
                        return [4, this.localState.addExportedVariables(mutation, variables, context)];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function () {
                            var ret = {};
                            if (updateQueriesByName) {
                                _this.queries.forEach(function (_a, queryId) {
                                    var observableQuery = _a.observableQuery;
                                    if (observableQuery) {
                                        var queryName = observableQuery.queryName;
                                        if (queryName &&
                                            apollo_client_bundle_esm_hasOwnProperty.call(updateQueriesByName, queryName)) {
                                            ret[queryId] = {
                                                updater: updateQueriesByName[queryName],
                                                query: _this.queryStore.get(queryId),
                                            };
                                        }
                                    }
                                });
                            }
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse,
                        });
                        this.broadcastQueries();
                        self = this;
                        return [2, new Promise(function (resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { optimisticResponse: optimisticResponse }), variables, false).subscribe({
                                    next: function (result) {
                                        if (graphQLResultHasError(result) && errorPolicy === 'none') {
                                            error = new ApolloError({
                                                graphQLErrors: result.errors,
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') {
                                            self.dataStore.markMutationResult({
                                                mutationId: mutationId,
                                                result: result,
                                                document: mutation,
                                                variables: variables,
                                                updateQueries: generateUpdateQueriesInfo(),
                                                update: updateWithProxyFn,
                                            });
                                        }
                                        storeResult = result;
                                    },
                                    error: function (err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse,
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function () { return ({ document: null }); });
                                        reject(new ApolloError({
                                            networkError: err,
                                        }));
                                    },
                                    complete: function () {
                                        if (error) {
                                            self.mutationStore.markMutationError(mutationId, error);
                                        }
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse,
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') {
                                            refetchQueries = refetchQueries(storeResult);
                                        }
                                        var refetchQueryPromises = [];
                                        if (isNonEmptyArray(refetchQueries)) {
                                            refetchQueries.forEach(function (refetchQuery) {
                                                if (typeof refetchQuery === 'string') {
                                                    self.queries.forEach(function (_a) {
                                                        var observableQuery = _a.observableQuery;
                                                        if (observableQuery &&
                                                            observableQuery.queryName === refetchQuery) {
                                                            refetchQueryPromises.push(observableQuery.refetch());
                                                        }
                                                    });
                                                }
                                                else {
                                                    var queryOptions = {
                                                        query: refetchQuery.query,
                                                        variables: refetchQuery.variables,
                                                        fetchPolicy: 'network-only',
                                                    };
                                                    if (refetchQuery.context) {
                                                        queryOptions.context = refetchQuery.context;
                                                    }
                                                    refetchQueryPromises.push(self.query(queryOptions));
                                                }
                                            });
                                        }
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function () {
                                            self.setQuery(mutationId, function () { return ({ document: null }); });
                                            if (errorPolicy === 'ignore' &&
                                                storeResult &&
                                                graphQLResultHasError(storeResult)) {
                                                delete storeResult.errors;
                                            }
                                            resolve(storeResult);
                                        });
                                    },
                                });
                            })];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function (queryId, options, fetchType, fetchMoreForQueryId) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [3, 2];
                        return [4, this.localState.addExportedVariables(query, variables, context)];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { variables: variables });
                        isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false,
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if (hasDirectives(['live'], query))
                            shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== 'no-cache'
                            ? this.updateQueryWatch(queryId, query, options)
                            : undefined;
                        this.setQuery(queryId, function () { return ({
                            document: query,
                            lastRequestId: requestId,
                            invalidated: true,
                            cancel: cancel,
                        }); });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === FetchType.poll,
                            isRefetch: fetchType === FetchType.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId,
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId,
                            }).catch(function (error) {
                                if (isApolloError(error)) {
                                    throw error;
                                }
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new ApolloError({ networkError: error });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') {
                                return [2, networkResult];
                            }
                            networkResult.catch(function () { });
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) {
                            return [2, this.localState.runResolvers({
                                    document: query,
                                    remoteResult: { data: storeResult },
                                    context: context,
                                    variables: variables,
                                    onlyRunForcedResolvers: true,
                                }).then(function (result) {
                                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                    _this.broadcastQueries();
                                    return result;
                                })];
                        }
                        this.broadcastQueries();
                        return [2, { data: storeResult }];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function (queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === 'no-cache') {
            this.setQuery(queryId, function () { return ({
                newData: { result: result.data, complete: true },
            }); });
        }
        else {
            this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
        }
    };
    QueryManager.prototype.queryListenerForObserver = function (queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) {
                try {
                    observer[method](argument);
                }
                catch (e) {
                     true || 0;
                }
            }
            else if (method === 'error') {
                 true || 0;
            }
        }
        return function (queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue)
                return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery
                ? observableQuery.options.fetchPolicy
                : options.fetchPolicy;
            if (fetchPolicy === 'standby')
                return;
            var loading = isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult &&
                lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData ||
                (!newData && queryStoreValue.previousVariables) ||
                (networkStatusChanged && options.notifyOnNetworkStatusChange) ||
                fetchPolicy === 'cache-only' ||
                fetchPolicy === 'cache-and-network';
            if (loading && !shouldNotifyIfLoading) {
                return;
            }
            var hasGraphQLErrors = isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery
                && observableQuery.options.errorPolicy
                || options.errorPolicy
                || 'none';
            if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) {
                return invoke('error', new ApolloError({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError,
                }));
            }
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') {
                        _this.setQuery(queryId, function () { return ({ newData: null }); });
                    }
                    data = newData.result;
                    isMissing = !newData.complete;
                }
                else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== 'none' &&
                        (lastError && lastError.graphQLErrors) !==
                            queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    }
                    else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables ||
                                queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true,
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData ||
                    fetchPolicy === 'cache-only');
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale,
                };
                if (errorPolicy === 'all' && hasGraphQLErrors) {
                    resultFromStore.errors = queryStoreValue.graphQLErrors;
                }
                invoke('next', resultFromStore);
            }
            catch (networkError) {
                invoke('error', new ApolloError({ networkError: networkError }));
            }
        };
    };
    QueryManager.prototype.transform = function (document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = removeConnectionDirectiveFromDocument(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: hasClientExports(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: getDefaultValues(getOperationDefinition(transformed)),
            };
            var add = function (doc) {
                if (doc && !transformCache.has(doc)) {
                    transformCache.set(doc, cacheEntry_1);
                }
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function (document, variables) {
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function (options, shouldSubscribe) {
        if (shouldSubscribe === void 0) { shouldSubscribe = true; }
         true ? (0,invariant_esm/* invariant */.kG)(options.fetchPolicy !== 'standby', 11) : 0;
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') {
            options.notifyOnNetworkStatusChange = false;
        }
        var transformedOptions = (0,tslib_es6/* __assign */.pi)({}, options);
        return new ObservableQuery({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe,
        });
    };
    QueryManager.prototype.query = function (options) {
        var _this = this;
         true ? (0,invariant_esm/* invariant */.kG)(options.query, 12) : 0;
         true ? (0,invariant_esm/* invariant */.kG)(options.query.kind === 'Document', 13) : 0;
         true ? (0,invariant_esm/* invariant */.kG)(!options.returnPartialData, 14) : 0;
         true ? (0,invariant_esm/* invariant */.kG)(!options.pollInterval, 15) : 0;
        return new Promise(function (resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery
                .result()
                .then(resolve, reject)
                .then(function () {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function () {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function (queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function (queryId, listener) {
        this.setQuery(queryId, function (_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return { invalidated: false };
        });
    };
    QueryManager.prototype.updateQueryWatch = function (queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel)
            cancel();
        var previousResult = function () {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) {
                    previousResult = lastResult.data;
                }
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function (newData) {
                _this.setQuery(queryId, function () { return ({ invalidated: true, newData: newData }); });
            },
        });
    };
    QueryManager.prototype.addObservableQuery = function (queryId, observableQuery) {
        this.setQuery(queryId, function () { return ({ observableQuery: observableQuery }); });
    };
    QueryManager.prototype.removeObservableQuery = function (queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function () { return ({ observableQuery: null }); });
        if (cancel)
            cancel();
    };
    QueryManager.prototype.clearStore = function () {
        this.fetchQueryRejectFns.forEach(function (reject) {
            reject( true ? new invariant_esm/* InvariantError */.ej(16) : 0);
        });
        var resetIds = [];
        this.queries.forEach(function (_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery)
                resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function () {
        var _this = this;
        return this.clearStore().then(function () {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function (includeStandby) {
        var _this = this;
        if (includeStandby === void 0) { includeStandby = false; }
        var observableQueryPromises = [];
        this.queries.forEach(function (_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' &&
                    (includeStandby || fetchPolicy !== 'standby')) {
                    observableQueryPromises.push(observableQuery.refetch());
                }
                _this.setQuery(queryId, function () { return ({ newData: null }); });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function (queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function (queryId, options, listener) {
         true || 0;
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options)
            .catch(function () { return undefined; });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function (_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function (variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function (result) {
                if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if (graphQLResultHasError(result)) {
                    throw new ApolloError({
                        graphQLErrors: result.errors,
                    });
                }
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new apollo_client_bundle_esm_Observable(function (observer) {
                var sub = null;
                observablePromise_1.then(function (observable) { return sub = observable.subscribe(observer); }, observer.error);
                return function () { return sub && sub.unsubscribe(); };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function (queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function (queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function (x) { return x.unsubscribe(); });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function (observableQuery, optimistic) {
        if (optimistic === void 0) { optimistic = true; }
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) {
            return { data: newData.result, partial: false };
        }
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') {
            return { data: undefined, partial: false };
        }
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic,
        }), result = _b.result, complete = _b.complete;
        return {
            data: (complete || returnPartialData) ? result : void 0,
            partial: !complete,
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function (queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
             true ? (0,invariant_esm/* invariant */.kG)(foundObserveableQuery, 17) : 0;
            observableQuery = foundObserveableQuery;
        }
        else {
            observableQuery = queryIdOrObservable;
        }
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query,
        };
    };
    QueryManager.prototype.broadcastQueries = function () {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function (info, id) {
            if (info.invalidated) {
                info.listeners.forEach(function (listener) {
                    if (listener) {
                        listener(_this.queryStore.get(id), info.newData);
                    }
                });
            }
        });
    };
    QueryManager.prototype.getLocalState = function () {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function (query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) { deduplication = this.queryDeduplication; }
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: getOperationName(serverQuery) || void 0,
                context: this.prepareContext((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { forceFetch: !deduplication })),
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = multiplex(execute(link, operation)));
                    var cleanup = function () {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size)
                            inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup,
                    });
                }
            }
            else {
                observable = multiplex(execute(link, operation));
            }
        }
        else {
            observable = apollo_client_bundle_esm_Observable.of({ data: {} });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) {
            observable = asyncMap(observable, function (result) {
                return _this.localState.runResolvers({
                    document: clientQuery,
                    remoteResult: result,
                    context: context,
                    variables: variables,
                });
            });
        }
        return observable;
    };
    QueryManager.prototype.fetchRequest = function (_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function (resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function () {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function (_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function (result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === 'none' && isNonEmptyArray(result.errors)) {
                    return reject(new ApolloError({
                        graphQLErrors: result.errors,
                    }));
                }
                if (errorPolicy === 'all') {
                    errorsFromStore = result.errors;
                }
                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') {
                    resultFromStore = result.data;
                }
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true,
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) {
                        resultFromStore = result_1;
                    }
                }
            }).subscribe({
                error: function (error) {
                    cleanup();
                    reject(error);
                },
                complete: function () {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: NetworkStatus.ready,
                        stale: false,
                    });
                },
            });
            _this.setQuery(queryId, function (_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function (queryId) {
        return (this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set(),
        });
    };
    QueryManager.prototype.setQuery = function (queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function (queryId, invalidated) {
        if (invalidated === void 0) { invalidated = true; }
        if (queryId) {
            this.setQuery(queryId, function () { return ({ invalidated: invalidated }); });
        }
    };
    QueryManager.prototype.prepareContext = function (context) {
        if (context === void 0) { context = {}; }
        var newContext = this.localState.prepareContext(context);
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, newContext), { clientAwareness: this.clientAwareness });
    };
    QueryManager.prototype.checkInFlight = function (queryId) {
        var query = this.queryStore.get(queryId);
        return (query &&
            query.networkStatus !== NetworkStatus.ready &&
            query.networkStatus !== NetworkStatus.error);
    };
    QueryManager.prototype.startPollingQuery = function (options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
         true ? (0,invariant_esm/* invariant */.kG)(pollInterval, 18) : 0;
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) {
                this.pollingInfoByQueryId.set(queryId, (info = {}));
            }
            info.interval = pollInterval;
            info.options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { fetchPolicy: 'network-only' });
            var maybeFetch_1 = function () {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) {
                        poll_1();
                    }
                    else {
                        _this.fetchQuery(queryId, info.options, FetchType.poll).then(poll_1, poll_1);
                    }
                }
            };
            var poll_1 = function () {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) {
                this.addQueryListener(queryId, listener);
            }
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function (queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}());

var DataStore = (function () {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function () {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function (result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) { ignoreErrors = false; }
        var writeWithErrors = !graphQLResultHasError(result);
        if (ignoreErrors && graphQLResultHasError(result) && result.data) {
            writeWithErrors = true;
        }
        if (!fetchMoreForQueryId && writeWithErrors) {
            this.cache.write({
                result: result.data,
                dataId: 'ROOT_QUERY',
                query: document,
                variables: variables,
            });
        }
    };
    DataStore.prototype.markSubscriptionResult = function (result, document, variables) {
        if (!graphQLResultHasError(result)) {
            this.cache.write({
                result: result.data,
                dataId: 'ROOT_SUBSCRIPTION',
                query: document,
                variables: variables,
            });
        }
    };
    DataStore.prototype.markMutationInit = function (mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') {
                optimistic_1 = mutation.optimisticResponse(mutation.variables);
            }
            else {
                optimistic_1 = mutation.optimisticResponse;
            }
            this.cache.recordOptimisticTransaction(function (c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: { data: optimistic_1 },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update,
                    });
                }
                finally {
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function (mutation) {
        var _this = this;
        if (!graphQLResultHasError(mutation.result)) {
            var cacheWrites_1 = [{
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables,
                }];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) {
                Object.keys(updateQueries_1).forEach(function (id) {
                    var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                    var _b = _this.cache.diff({
                        query: query.document,
                        variables: query.variables,
                        returnPartialData: true,
                        optimistic: false,
                    }), currentQueryResult = _b.result, complete = _b.complete;
                    if (complete) {
                        var nextQueryResult = tryFunctionOrLogError(function () {
                            return updater(currentQueryResult, {
                                mutationResult: mutation.result,
                                queryName: getOperationName(query.document) || undefined,
                                queryVariables: query.variables,
                            });
                        });
                        if (nextQueryResult) {
                            cacheWrites_1.push({
                                result: nextQueryResult,
                                dataId: 'ROOT_QUERY',
                                query: query.document,
                                variables: query.variables,
                            });
                        }
                    }
                });
            }
            this.cache.performTransaction(function (c) {
                cacheWrites_1.forEach(function (write) { return c.write(write); });
                var update = mutation.update;
                if (update) {
                    tryFunctionOrLogError(function () { return update(c, mutation.result); });
                }
            });
        }
    };
    DataStore.prototype.markMutationComplete = function (_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) {
            this.cache.removeOptimistic(mutationId);
        }
    };
    DataStore.prototype.markUpdateQueryResult = function (document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document,
        });
    };
    DataStore.prototype.reset = function () {
        return this.cache.reset();
    };
    return DataStore;
}());

var version = "2.6.10";

var hasSuggestedDevtools = false;
var ApolloClient = (function () {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) {
            link = ApolloLink.empty();
        }
        if (!link || !cache) {
            throw  true ? new invariant_esm/* InvariantError */.ej(4) : 0;
        }
        this.link = link;
        this.cache = cache;
        this.store = new DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) {
            setTimeout(function () { return (_this.disableNetworkFetches = false); }, ssrForceFetchDelay);
        }
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools =  false &&
            0;
        if (typeof connectToDevTools === 'undefined'
            ? defaultConnectToDevTools
            : connectToDevTools && typeof window !== 'undefined') {
            window.__APOLLO_CLIENT__ = this;
        }
        if (!hasSuggestedDevtools && "production" !== 'production') {}
        this.version = version;
        this.localState = new LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher,
        });
        this.queryManager = new QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion,
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function () {
                if (_this.devToolsHookCb) {
                    _this.devToolsHookCb({
                        action: {},
                        state: {
                            queries: _this.queryManager.queryStore.getStore(),
                            mutations: _this.queryManager.mutationStore.getStore(),
                        },
                        dataWithOptimisticResults: _this.cache.extract(true),
                    });
                }
            },
        });
    }
    ApolloClient.prototype.stop = function () {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function (options) {
        if (this.defaultOptions.watchQuery) {
            options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.defaultOptions.watchQuery), options);
        }
        if (this.disableNetworkFetches &&
            (options.fetchPolicy === 'network-only' ||
                options.fetchPolicy === 'cache-and-network')) {
            options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function (options) {
        if (this.defaultOptions.query) {
            options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.defaultOptions.query), options);
        }
         true ? (0,invariant_esm/* invariant */.kG)(options.fetchPolicy !== 'cache-and-network', 5) : 0;
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') {
            options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function (options) {
        if (this.defaultOptions.mutate) {
            options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.defaultOptions.mutate), options);
        }
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function (options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function (options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function (options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function (options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function (cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function (payload) {
        return execute(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function () {
         true || 0;
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () { return _this.queryManager.clearStore(); })
            .then(function () { return Promise.all(_this.resetStoreCallbacks.map(function (fn) { return fn(); })); })
            .then(function () { return _this.reFetchObservableQueries(); });
    };
    ApolloClient.prototype.clearStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () { return _this.queryManager.clearStore(); })
            .then(function () { return Promise.all(_this.clearStoreCallbacks.map(function (fn) { return fn(); })); });
    };
    ApolloClient.prototype.onResetStore = function (cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function () {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    ApolloClient.prototype.onClearStore = function (cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function () {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function (includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function (optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function (serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function (resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function (resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function () {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function (fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}());

/* harmony default export */ var apollo_client_bundle_esm = ((/* unused pure expression or super */ null && (ApolloClient)));

//# sourceMappingURL=bundle.esm.js.map

// EXTERNAL MODULE: ./node_modules/graphql/language/blockString.mjs
var blockString = __webpack_require__(87392);
;// CONCATENATED MODULE: ./node_modules/graphql/language/printer.mjs


/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */

function print(ast) {
  return visitor_visit(ast, {
    leave: printDocASTReducer
  });
}
var MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future

var printDocASTReducer = {
  Name: function Name(node) {
    return node.value;
  },
  Variable: function Variable(node) {
    return '$' + node.name;
  },
  // Document
  Document: function Document(node) {
    return join(node.definitions, '\n\n') + '\n';
  },
  OperationDefinition: function OperationDefinition(node) {
    var op = node.operation;
    var name = node.name;
    var varDefs = printer_wrap('(', join(node.variableDefinitions, ', '), ')');
    var directives = join(node.directives, ' ');
    var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
    // the query short form.

    return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], ' ');
  },
  VariableDefinition: function VariableDefinition(_ref) {
    var variable = _ref.variable,
        type = _ref.type,
        defaultValue = _ref.defaultValue,
        directives = _ref.directives;
    return variable + ': ' + type + printer_wrap(' = ', defaultValue) + printer_wrap(' ', join(directives, ' '));
  },
  SelectionSet: function SelectionSet(_ref2) {
    var selections = _ref2.selections;
    return block(selections);
  },
  Field: function Field(_ref3) {
    var alias = _ref3.alias,
        name = _ref3.name,
        args = _ref3.arguments,
        directives = _ref3.directives,
        selectionSet = _ref3.selectionSet;
    var prefix = printer_wrap('', alias, ': ') + name;
    var argsLine = prefix + printer_wrap('(', join(args, ', '), ')');

    if (argsLine.length > MAX_LINE_LENGTH) {
      argsLine = prefix + printer_wrap('(\n', indent(join(args, '\n')), '\n)');
    }

    return join([argsLine, join(directives, ' '), selectionSet], ' ');
  },
  Argument: function Argument(_ref4) {
    var name = _ref4.name,
        value = _ref4.value;
    return name + ': ' + value;
  },
  // Fragments
  FragmentSpread: function FragmentSpread(_ref5) {
    var name = _ref5.name,
        directives = _ref5.directives;
    return '...' + name + printer_wrap(' ', join(directives, ' '));
  },
  InlineFragment: function InlineFragment(_ref6) {
    var typeCondition = _ref6.typeCondition,
        directives = _ref6.directives,
        selectionSet = _ref6.selectionSet;
    return join(['...', printer_wrap('on ', typeCondition), join(directives, ' '), selectionSet], ' ');
  },
  FragmentDefinition: function FragmentDefinition(_ref7) {
    var name = _ref7.name,
        typeCondition = _ref7.typeCondition,
        variableDefinitions = _ref7.variableDefinitions,
        directives = _ref7.directives,
        selectionSet = _ref7.selectionSet;
    return (// Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(name).concat(printer_wrap('(', join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat(printer_wrap('', join(directives, ' '), ' ')) + selectionSet
    );
  },
  // Value
  IntValue: function IntValue(_ref8) {
    var value = _ref8.value;
    return value;
  },
  FloatValue: function FloatValue(_ref9) {
    var value = _ref9.value;
    return value;
  },
  StringValue: function StringValue(_ref10, key) {
    var value = _ref10.value,
        isBlockString = _ref10.block;
    return isBlockString ? (0,blockString/* printBlockString */.LZ)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
  },
  BooleanValue: function BooleanValue(_ref11) {
    var value = _ref11.value;
    return value ? 'true' : 'false';
  },
  NullValue: function NullValue() {
    return 'null';
  },
  EnumValue: function EnumValue(_ref12) {
    var value = _ref12.value;
    return value;
  },
  ListValue: function ListValue(_ref13) {
    var values = _ref13.values;
    return '[' + join(values, ', ') + ']';
  },
  ObjectValue: function ObjectValue(_ref14) {
    var fields = _ref14.fields;
    return '{' + join(fields, ', ') + '}';
  },
  ObjectField: function ObjectField(_ref15) {
    var name = _ref15.name,
        value = _ref15.value;
    return name + ': ' + value;
  },
  // Directive
  Directive: function Directive(_ref16) {
    var name = _ref16.name,
        args = _ref16.arguments;
    return '@' + name + printer_wrap('(', join(args, ', '), ')');
  },
  // Type
  NamedType: function NamedType(_ref17) {
    var name = _ref17.name;
    return name;
  },
  ListType: function ListType(_ref18) {
    var type = _ref18.type;
    return '[' + type + ']';
  },
  NonNullType: function NonNullType(_ref19) {
    var type = _ref19.type;
    return type + '!';
  },
  // Type System Definitions
  SchemaDefinition: addDescription(function (_ref20) {
    var directives = _ref20.directives,
        operationTypes = _ref20.operationTypes;
    return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
  }),
  OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
    var operation = _ref21.operation,
        type = _ref21.type;
    return operation + ': ' + type;
  },
  ScalarTypeDefinition: addDescription(function (_ref22) {
    var name = _ref22.name,
        directives = _ref22.directives;
    return join(['scalar', name, join(directives, ' ')], ' ');
  }),
  ObjectTypeDefinition: addDescription(function (_ref23) {
    var name = _ref23.name,
        interfaces = _ref23.interfaces,
        directives = _ref23.directives,
        fields = _ref23.fields;
    return join(['type', name, printer_wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),
  FieldDefinition: addDescription(function (_ref24) {
    var name = _ref24.name,
        args = _ref24.arguments,
        type = _ref24.type,
        directives = _ref24.directives;
    return name + (hasMultilineItems(args) ? printer_wrap('(\n', indent(join(args, '\n')), '\n)') : printer_wrap('(', join(args, ', '), ')')) + ': ' + type + printer_wrap(' ', join(directives, ' '));
  }),
  InputValueDefinition: addDescription(function (_ref25) {
    var name = _ref25.name,
        type = _ref25.type,
        defaultValue = _ref25.defaultValue,
        directives = _ref25.directives;
    return join([name + ': ' + type, printer_wrap('= ', defaultValue), join(directives, ' ')], ' ');
  }),
  InterfaceTypeDefinition: addDescription(function (_ref26) {
    var name = _ref26.name,
        interfaces = _ref26.interfaces,
        directives = _ref26.directives,
        fields = _ref26.fields;
    return join(['interface', name, printer_wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),
  UnionTypeDefinition: addDescription(function (_ref27) {
    var name = _ref27.name,
        directives = _ref27.directives,
        types = _ref27.types;
    return join(['union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  }),
  EnumTypeDefinition: addDescription(function (_ref28) {
    var name = _ref28.name,
        directives = _ref28.directives,
        values = _ref28.values;
    return join(['enum', name, join(directives, ' '), block(values)], ' ');
  }),
  EnumValueDefinition: addDescription(function (_ref29) {
    var name = _ref29.name,
        directives = _ref29.directives;
    return join([name, join(directives, ' ')], ' ');
  }),
  InputObjectTypeDefinition: addDescription(function (_ref30) {
    var name = _ref30.name,
        directives = _ref30.directives,
        fields = _ref30.fields;
    return join(['input', name, join(directives, ' '), block(fields)], ' ');
  }),
  DirectiveDefinition: addDescription(function (_ref31) {
    var name = _ref31.name,
        args = _ref31.arguments,
        repeatable = _ref31.repeatable,
        locations = _ref31.locations;
    return 'directive @' + name + (hasMultilineItems(args) ? printer_wrap('(\n', indent(join(args, '\n')), '\n)') : printer_wrap('(', join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + join(locations, ' | ');
  }),
  SchemaExtension: function SchemaExtension(_ref32) {
    var directives = _ref32.directives,
        operationTypes = _ref32.operationTypes;
    return join(['extend schema', join(directives, ' '), block(operationTypes)], ' ');
  },
  ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
    var name = _ref33.name,
        directives = _ref33.directives;
    return join(['extend scalar', name, join(directives, ' ')], ' ');
  },
  ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
    var name = _ref34.name,
        interfaces = _ref34.interfaces,
        directives = _ref34.directives,
        fields = _ref34.fields;
    return join(['extend type', name, printer_wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },
  InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
    var name = _ref35.name,
        interfaces = _ref35.interfaces,
        directives = _ref35.directives,
        fields = _ref35.fields;
    return join(['extend interface', name, printer_wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },
  UnionTypeExtension: function UnionTypeExtension(_ref36) {
    var name = _ref36.name,
        directives = _ref36.directives,
        types = _ref36.types;
    return join(['extend union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  },
  EnumTypeExtension: function EnumTypeExtension(_ref37) {
    var name = _ref37.name,
        directives = _ref37.directives,
        values = _ref37.values;
    return join(['extend enum', name, join(directives, ' '), block(values)], ' ');
  },
  InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
    var name = _ref38.name,
        directives = _ref38.directives,
        fields = _ref38.fields;
    return join(['extend input', name, join(directives, ' '), block(fields)], ' ');
  }
};

function addDescription(cb) {
  return function (node) {
    return join([node.description, cb(node)], '\n');
  };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */


function join(maybeArray) {
  var _maybeArray$filter$jo;

  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function (x) {
    return x;
  }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */


function block(array) {
  return printer_wrap('{\n', indent(join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */


function printer_wrap(start, maybeString) {
  var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}

function indent(str) {
  return printer_wrap('  ', str.replace(/\n/g, '\n  '));
}

function isMultiline(str) {
  return str.indexOf('\n') !== -1;
}

function hasMultilineItems(maybeArray) {
  return maybeArray != null && maybeArray.some(isMultiline);
}

;// CONCATENATED MODULE: ./node_modules/apollo-link-http-common/lib/bundle.esm.js




var defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
};
var defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json',
};
var defaultOptions = {
    method: 'POST',
};
var fallbackHttpConfig = {
    http: defaultHttpOptions,
    headers: defaultHeaders,
    options: defaultOptions,
};
var throwServerError = function (response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var parseAndCheckHttpResponse = function (operations) { return function (response) {
    return (response
        .text()
        .then(function (bodyText) {
        try {
            return JSON.parse(bodyText);
        }
        catch (err) {
            var parseError = err;
            parseError.name = 'ServerParseError';
            parseError.response = response;
            parseError.statusCode = response.status;
            parseError.bodyText = bodyText;
            return Promise.reject(parseError);
        }
    })
        .then(function (result) {
        if (response.status >= 300) {
            throwServerError(response, result, "Response not successful: Received status code " + response.status);
        }
        if (!Array.isArray(result) &&
            !result.hasOwnProperty('data') &&
            !result.hasOwnProperty('errors')) {
            throwServerError(response, result, "Server response was missing for query '" + (Array.isArray(operations)
                ? operations.map(function (op) { return op.operationName; })
                : operations.operationName) + "'.");
        }
        return result;
    }));
}; };
var checkFetcher = function (fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined')
            library = 'node-fetch';
        throw  true ? new invariant_esm/* InvariantError */.ej(1) : 0;
    }
};
var createSignalIfSupported = function () {
    if (typeof AbortController === 'undefined')
        return { controller: false, signal: false };
    var controller = new AbortController();
    var signal = controller.signal;
    return { controller: controller, signal: signal };
};
var selectHttpOptionsAndBody = function (operation, fallbackConfig) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    var options = (0,tslib_es6/* __assign */.pi)({}, fallbackConfig.options, { headers: fallbackConfig.headers, credentials: fallbackConfig.credentials });
    var http = fallbackConfig.http;
    configs.forEach(function (config) {
        options = (0,tslib_es6/* __assign */.pi)({}, options, config.options, { headers: (0,tslib_es6/* __assign */.pi)({}, options.headers, config.headers) });
        if (config.credentials)
            options.credentials = config.credentials;
        http = (0,tslib_es6/* __assign */.pi)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = { operationName: operationName, variables: variables };
    if (http.includeExtensions)
        body.extensions = extensions;
    if (http.includeQuery)
        body.query = print(query);
    return {
        options: options,
        body: body,
    };
};
var serializeFetchParameter = function (p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    }
    catch (e) {
        var parseError =  true ? new invariant_esm/* InvariantError */.ej(2) : 0;
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var selectURI = function (operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) {
        return contextURI;
    }
    else if (typeof fallbackURI === 'function') {
        return fallbackURI(operation);
    }
    else {
        return fallbackURI || '/graphql';
    }
};


//# sourceMappingURL=bundle.esm.js.map

;// CONCATENATED MODULE: ./node_modules/apollo-link-http/lib/bundle.esm.js




var createHttpLink = function (linkOptions) {
    if (linkOptions === void 0) { linkOptions = {}; }
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, requestOptions = (0,tslib_es6/* __rest */._T)(linkOptions, ["uri", "fetch", "includeExtensions", "useGETForQueries"]);
    checkFetcher(fetcher);
    if (!fetcher) {
        fetcher = fetch;
    }
    var linkConfig = {
        http: { includeExtensions: includeExtensions },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers,
    };
    return new ApolloLink(function (operation) {
        var chosenURI = selectURI(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) {
                clientAwarenessHeaders['apollographql-client-name'] = name_1;
            }
            if (version) {
                clientAwarenessHeaders['apollographql-client-version'] = version;
            }
        }
        var contextHeaders = (0,tslib_es6/* __assign */.pi)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders,
        };
        var _b = selectHttpOptionsAndBody(operation, fallbackHttpConfig, linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = createSignalIfSupported(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller)
                options.signal = signal;
        }
        var definitionIsMutation = function (d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries &&
            !operation.query.definitions.some(definitionIsMutation)) {
            options.method = 'GET';
        }
        if (options.method === 'GET') {
            var _d = rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) {
                return fromError(parseError);
            }
            chosenURI = newURI;
        }
        else {
            try {
                options.body = serializeFetchParameter(body, 'Payload');
            }
            catch (parseError) {
                return fromError(parseError);
            }
        }
        return new bundle_esm(function (observer) {
            fetcher(chosenURI, options)
                .then(function (response) {
                operation.setContext({ response: response });
                return response;
            })
                .then(parseAndCheckHttpResponse(operation))
                .then(function (result) {
                observer.next(result);
                observer.complete();
                return result;
            })
                .catch(function (err) {
                if (err.name === 'AbortError')
                    return;
                if (err.result && err.result.errors && err.result.data) {
                    observer.next(err.result);
                }
                observer.error(err);
            });
            return function () {
                if (controller)
                    controller.abort();
            };
        });
    });
};
function rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function (key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) {
        addQueryParam('query', body.query);
    }
    if (body.operationName) {
        addQueryParam('operationName', body.operationName);
    }
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = serializeFetchParameter(body.variables, 'Variables map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = serializeFetchParameter(body.extensions, 'Extensions map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return { newURI: newURI };
}
var HttpLink = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, createHttpLink(opts).request) || this;
    }
    return HttpLink;
}(ApolloLink));


//# sourceMappingURL=bundle.esm.js.map

// EXTERNAL MODULE: ./node_modules/next/dist/build/polyfills/fetch/index.js
var polyfills_fetch = __webpack_require__(63144);
var fetch_default = /*#__PURE__*/__webpack_require__.n(polyfills_fetch);
// EXTERNAL MODULE: ./node_modules/next-with-apollo/lib/index.js
var lib = __webpack_require__(84763);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./apollo/apollo.ts





var GRAPHQL_URL = "https://cms.leapscholar.com" || 0;
var apollo_link = createHttpLink({
    fetch: (fetch_default()),
    uri: GRAPHQL_URL + "/graphql?_limit=100&verified=false"
});
/* harmony default export */ var apollo = (lib_default()(function(param) {
    var initialState = param.initialState;
    return new ApolloClient({
        link: apollo_link,
        cache: new InMemoryCache()//  rehydrate the cache using the initial data passed from the server:
        .restore(initialState || {})
    });
}));
function createApolloClient(initialState) {
    var ssrMode = "object" === "undefined";
    return new ApolloClient({
        ssrMode: ssrMode,
        link: apollo_link,
        cache: new InMemoryCache().restore(initialState),
        defaultOptions: getDefaultOptions(ssrMode)
    });
}
var getDefaultOptions = function(isSsr) {
    return {
        watchQuery: {
            fetchPolicy: isSsr ? "no-cache" : "cache-and-network",
            errorPolicy: "ignore"
        },
        query: {
            fetchPolicy: isSsr ? "no-cache" : "network-only",
            errorPolicy: "all"
        },
        mutate: {
            errorPolicy: "all"
        }
    };
};
var apoloClient = createApolloClient({
    resultCaching: true,
    addTypename: true
});


/***/ }),

/***/ 93630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "De": function() { return /* binding */ IeltsStatus; },
/* harmony export */   "Wk": function() { return /* binding */ CounselingStage; }
/* harmony export */ });
/* unused harmony exports PreferredCountry, PreferredIntake, PreferredProgram, HighestLevelEducation, TypeOfHelp, PayOfExpenses, QuestionForCounsellor, DocumentsAvailable */
var PreferredCountry;
(function(PreferredCountry) {
    PreferredCountry["Canada"] = "Canada";
    PreferredCountry["USA"] = "USA";
    PreferredCountry["UK"] = "UK";
    PreferredCountry["Germany"] = "Germany";
    PreferredCountry["Australia"] = "Australia";
    PreferredCountry["NewZealand"] = "NewZealand";
    PreferredCountry["Singapore"] = "Singapore";
    PreferredCountry["Netherlands"] = "Netherlands";
    PreferredCountry["China"] = "China";
    PreferredCountry["RestOfEurope"] = "RestOfEurope";
    PreferredCountry["MiddleEasternCountries"] = "MiddleEasternCountries";
    PreferredCountry["OpenToAnyCountry"] = "OpenToAnyCountry";
})(PreferredCountry || (PreferredCountry = {}));
var PreferredIntake;
(function(PreferredIntake) {
    PreferredIntake["JANUARY_2021"] = "JANUARY_2021";
    PreferredIntake["SEPTEMBER_2020"] = "SEPTEMBER_2020";
    PreferredIntake["MAY_2021"] = "MAY_2021";
    PreferredIntake["SEPTEMBER_2021"] = "SEPTEMBER_2021";
    PreferredIntake["OTHER"] = "OTHER";
})(PreferredIntake || (PreferredIntake = {}));
var PreferredProgram;
(function(PreferredProgram) {
    PreferredProgram["POST_GRADUATE_DIPLOMA"] = "POST_GRADUATE_DIPLOMA";
    PreferredProgram["MASTERS"] = "MASTERS";
    PreferredProgram["UNDER_GRADUATION"] = "UNDER_GRADUATION";
    PreferredProgram["MBA"] = "MBA";
    PreferredProgram["NOT_DECIDED"] = "NOT_DECIDED";
})(PreferredProgram || (PreferredProgram = {}));
var IeltsStatus;
(function(IeltsStatus) {
    IeltsStatus["NOT_DECIDED"] = "NOT_DECIDED";
    IeltsStatus["ALREADY_GIVEN"] = "ALREADY_GIVEN";
    IeltsStatus["EXAM_BOOKED"] = "EXAM_BOOKED";
    IeltsStatus["PLANING_TO_BOOK"] = "PLANING_TO_BOOK";
})(IeltsStatus || (IeltsStatus = {}));
var HighestLevelEducation;
(function(HighestLevelEducation) {
    HighestLevelEducation["TENTH"] = "TENTH";
    HighestLevelEducation["TWELFTH"] = "TWELFTH";
    HighestLevelEducation["BTECH_BE_BARCH"] = "BTECH_BE_BARCH";
    HighestLevelEducation["BSC_BA_BCOM_BBA_LLB"] = "BSC_BA_BCOM_BBA_LLB";
    HighestLevelEducation["MTECH"] = "MTECH";
    HighestLevelEducation["MBBS"] = "MBBS";
    HighestLevelEducation["MA_MSC_LLM"] = "MA_MSC_LLM";
    HighestLevelEducation["MD"] = "MD";
})(HighestLevelEducation || (HighestLevelEducation = {}));
var TypeOfHelp;
(function(TypeOfHelp) {
    TypeOfHelp["COUNSELLING_AND_COLLEGE_APPLICATION"] = "COUNSELLING_AND_COLLEGE_APPLICATION";
    TypeOfHelp["SCHOLARSHIP"] = "SCHOLARSHIP";
    TypeOfHelp["VISA_SERVICES"] = "VISA_SERVICES";
    TypeOfHelp["IELTS_CLASSES"] = "IELTS_CLASSES";
    TypeOfHelp["EDUCATIOIN_LOAN"] = "EDUCATIOIN_LOAN";
})(TypeOfHelp || (TypeOfHelp = {}));
var PayOfExpenses;
(function(PayOfExpenses) {
    PayOfExpenses["NO_CONCERN"] = "NO_CONCERN";
    PayOfExpenses["EDUCATION_LOAN"] = "EDUCATION_LOAN";
    PayOfExpenses["FAMILY_HELP"] = "FAMILY_HELP";
    PayOfExpenses["FULL_SCHOLARSHIP"] = "FULL_SCHOLARSHIP";
    PayOfExpenses["NO_MONEY"] = "NO_MONEY";
})(PayOfExpenses || (PayOfExpenses = {}));
(function(HighestLevelEducation) {})(HighestLevelEducation || (HighestLevelEducation = {}));
var CounselingStage;
(function(CounselingStage) {
    CounselingStage["LS_LEAD_CAPTURED"] = "LS_LEAD_CAPTURED";
    CounselingStage["LS_LEAD_CLOSED_AFTER_SALES_CALL"] = "LS_LEAD_CLOSED_AFTER_SALES_CALL";
    CounselingStage["LS_COUNSELING_CALL_SCHEDULED"] = "LS_COUNSELING_CALL_SCHEDULED";
    CounselingStage["LS_COUNSELING_CALL_CANCELLED"] = "LS_COUNSELING_CALL_CANCELLED";
    CounselingStage["LS_COUNSELING_CALL_DONE"] = "LS_COUNSELING_CALL_DONE";
    CounselingStage["LS_COUNSELING_CALL_NO_SHOW"] = "LS_COUNSELING_CALL_NO_SHOW";
    CounselingStage["LS_LEAD_CLOSED_AFTER_COUNSELLOR_CALL"] = "LS_LEAD_CLOSED_AFTER_COUNSELLOR_CALL";
    CounselingStage["LS_PAYMENT_DONE"] = "LS_PAYMENT_DONE";
    CounselingStage["LS_COLLEGE_SHORTLISTED"] = "LS_COLLEGE_SHORTLISTED";
    CounselingStage["LS_COLLEGE_FINALIZED"] = "LS_COLLEGE_FINALIZED";
    CounselingStage["LS_DOCUMENTS_UPLOADED"] = "LS_DOCUMENTS_UPLOADED";
    CounselingStage["LS_APPLICATION_SUBMITTED_TO_AGGREGATOR"] = "LS_APPLICATION_SUBMITTED_TO_AGGREGATOR";
})(CounselingStage || (CounselingStage = {}));
var QuestionForCounsellor;
(function(QuestionForCounsellor) {
    QuestionForCounsellor["COUNTRY_TO_CHOOSE"] = "COUNTRY_TO_CHOOSE";
    QuestionForCounsellor["COURSE_TO_CHOOSE"] = "COURSE_TO_CHOOSE";
    QuestionForCounsellor["BEST_COLLEGE"] = "BEST_COLLEGE";
    QuestionForCounsellor["IMPROVING_PROFILE"] = "IMPROVING_PROFILE";
    QuestionForCounsellor["JOBS_PROSPECTS"] = "JOBS_PROSPECTS";
    QuestionForCounsellor["APPLYING_FOR_SCHOLARSHIP"] = "APPLYING_FOR_SCHOLARSHIP";
    QuestionForCounsellor["SCHOLARSHIP_FROM_LEAP"] = "SCHOLARSHIP_FROM_LEAP";
    QuestionForCounsellor["FINANCING"] = "FINANCING";
})(QuestionForCounsellor || (QuestionForCounsellor = {}));
var DocumentsAvailable;
(function(DocumentsAvailable) {
    DocumentsAvailable["TWELFTH_MARKSHEET"] = "TWELFTH_MARK_SHEET";
    DocumentsAvailable["SMESTER_WISE_MARKSHEET"] = "UG_DMC";
    DocumentsAvailable["GRADUATE_DEGREE"] = "UG_PASSING_CERT";
    DocumentsAvailable["SOP"] = "SOP";
    DocumentsAvailable["LOR"] = "LOR";
    DocumentsAvailable["PASSPORT"] = "PASSPORT_FRONT";
})(DocumentsAvailable || (DocumentsAvailable = {}));


/***/ }),

/***/ 96325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WO": function() { return /* binding */ FETCH_EVENT_DATA; },
/* harmony export */   "Zp": function() { return /* binding */ FETCH_EVENT_IMAGES; }
/* harmony export */ });
/* unused harmony export FETCH_SINGLE_EVENT_DATA */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4969);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query ($slugArray: [String!]) {\n    events(where: { slug: $slugArray }) {\n      name\n      slug\n      description\n      previous_event\n      Agenda {\n        agenda\n        sequence\n      }\n      poster {\n        url\n      }\n      thumbnail {\n        url\n      }\n      event_tags_v2 {\n        tag {\n          Name\n          type\n        }\n        visible\n      }\n      speakers {\n        name\n        image {\n          url\n        }\n        headline\n        comment\n        linkedin\n      }\n      displayEventAsBanner\n      isOfflineEvent\n      locationUrl\n      venueName\n      cityName\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query ($slugArray: [String!]) {\n    events(where: { slug: $slugArray }) {\n      name\n      slug\n      poster {\n        url\n      }\n      thumbnail {\n        url\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query ($slugString: String!) {\n    events(where: { slug: $slugString }) {\n      name\n      slug\n      description\n      previous_event\n      Agenda {\n        agenda\n        sequence\n      }\n      poster {\n        url\n      }\n      thumbnail {\n        url\n      }\n      event_tags_v2 {\n        tag {\n          Name\n          type\n        }\n        visible\n      }\n      speakers {\n        name\n        image {\n          url\n        }\n        headline\n        comment\n        linkedin\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var FETCH_EVENT_DATA = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject());
var FETCH_EVENT_IMAGES = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject1());
var FETCH_SINGLE_EVENT_DATA = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject2());


/***/ }),

/***/ 38170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ communityAction; }
/* harmony export */ });
/* harmony import */ var _CommunityConstants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58588);

var setLoadingTrue = function() {
    return {
        type: _CommunityConstants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].SET_LOADING_TRUE */ .Z.SET_LOADING_TRUE
    };
};
var setLoadingFalse = function() {
    return {
        type: _CommunityConstants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].SET_LOADING_FALSE */ .Z.SET_LOADING_FALSE
    };
};
var fetchUserGetSocialToken = function() {
    return {
        type: _CommunityConstants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_USER_GETSOCIAL_TOKEN */ .Z.FETCH_USER_GETSOCIAL_TOKEN
    };
};
var fetchUserGetSocialTokenSuccess = function(payload) {
    return {
        type: _CommunityConstants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_USER_GETSOCIAL_TOKEN_SUCCESS */ .Z.FETCH_USER_GETSOCIAL_TOKEN_SUCCESS,
        payload: payload
    };
};
var fetchUserGetSocialTokenFail = function(payload) {
    return {
        type: _CommunityConstants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_USER_GETSOCIAL_TOKEN_FAIL */ .Z.FETCH_USER_GETSOCIAL_TOKEN_FAIL,
        payload: payload
    };
};
// states to store getSocial Data
var setGetSocialUserProfile = function(payload) {
    return {
        type: _CommunityConstants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].SET_GETSOCIAL_USER_PROFILE */ .Z.SET_GETSOCIAL_USER_PROFILE,
        payload: payload
    };
};
var setFollowedTopics = function(payload) {
    return {
        type: _CommunityConstants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].SET_FOLLOWED_TOPICS */ .Z.SET_FOLLOWED_TOPICS,
        payload: payload
    };
};
var setAllTopics = function(payload) {
    return {
        type: _CommunityConstants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].SET_ALL_TOPICS */ .Z.SET_ALL_TOPICS,
        payload: payload
    };
};
var setTimelinePosts = function(payload) {
    return {
        type: _CommunityConstants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].SET_TIMELINE_POSTS */ .Z.SET_TIMELINE_POSTS,
        payload: payload
    };
};
var setSearchPostResult = function(payload) {
    return {
        type: _CommunityConstants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].SET_SEARCH_POSTS_RESULT */ .Z.SET_SEARCH_POSTS_RESULT,
        payload: payload
    };
};
var setSuggestedPostsResult = function(payload) {
    return {
        type: _CommunityConstants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].SET_SUGGESTED_POSTS_RESULT */ .Z.SET_SUGGESTED_POSTS_RESULT,
        payload: payload
    };
};
var setSingleFeedViewData = function(payload) {
    return {
        type: _CommunityConstants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].SET_SINGLE_FEED_VIWE_DATA */ .Z.SET_SINGLE_FEED_VIWE_DATA,
        payload: payload
    };
};
var setSelectedTopicForFeed = function(payload) {
    return {
        type: _CommunityConstants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].SET_SELECTED_TOPICS_FOR_FEED */ .Z.SET_SELECTED_TOPICS_FOR_FEED,
        payload: payload
    };
};
var communityAction = {
    setLoadingTrue: setLoadingTrue,
    setLoadingFalse: setLoadingFalse,
    fetchUserGetSocialToken: fetchUserGetSocialToken,
    fetchUserGetSocialTokenSuccess: fetchUserGetSocialTokenSuccess,
    fetchUserGetSocialTokenFail: fetchUserGetSocialTokenFail,
    setGetSocialUserProfile: setGetSocialUserProfile,
    setFollowedTopics: setFollowedTopics,
    setAllTopics: setAllTopics,
    setTimelinePosts: setTimelinePosts,
    setSearchPostResult: setSearchPostResult,
    setSuggestedPostsResult: setSuggestedPostsResult,
    setSingleFeedViewData: setSingleFeedViewData,
    setSelectedTopicForFeed: setSelectedTopicForFeed
};


/***/ }),

/***/ 58588:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    SET_LOADING_TRUE: "SET_LOADING_TRUE",
    SET_LOADING_FALSE: "SET_LOADING_FALSE",
    FETCH_USER_GETSOCIAL_TOKEN: "FETCH_USER_GETSOCIAL_TOKEN",
    FETCH_USER_GETSOCIAL_TOKEN_SUCCESS: "FETCH_USER_GETSOCIAL_TOKEN_SUCCESS",
    FETCH_USER_GETSOCIAL_TOKEN_FAIL: "FETCH_USER_GETSOCIAL_TOKEN_FAIL",
    SET_GETSOCIAL_USER_PROFILE: "SET_GETSOCIAL_USER_PROFILE",
    SET_FOLLOWED_TOPICS: "SET_FOLLOWED_TOPICS",
    SET_ALL_TOPICS: "SET_ALL_TOPICS",
    SET_TIMELINE_POSTS: "SET_TIMELINE_POSTS",
    SET_SEARCH_POSTS_RESULT: "SET_SEARCH_POSTS_RESULT",
    SET_SUGGESTED_POSTS_RESULT: "SET_SUGGESTED_POSTS_RESULT",
    SET_SINGLE_FEED_VIWE_DATA: "SET_SINGLE_FEED_VIWE_DATA",
    SET_SELECTED_TOPICS_FOR_FEED: "SET_SELECTED_TOPICS_FOR_FEED"
});


/***/ }),

/***/ 96050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ documentUploadActionConstants; },
/* harmony export */   "g": function() { return /* binding */ documentUploadActions; }
/* harmony export */ });
var documentUploadActionConstants = {
    FETCH_DOCUMENT_DATA: "FETCH_DOCUMENT_DATA",
    FETCH_DOCUMENT_DATA_SUCCESS: "FETCH_DOCUMENT_DATA_SUCCESS",
    FETCH_DOCUMENT_DATA_ERROR: "FETCH_DOCUMENT_DATA_ERROR",
    UPLOAD_DOCUMENT: "UPLOAD_DOCUMENT",
    UPLOAD_DOCUMENT_SUCCESS: "UPLOAD_DOCUMENT_SUCCESS",
    UPLOAD_DOCUMENT_ERROR: "UPLOAD_DOCUMENT_ERROR",
    DELETE_DOCUMENT: "DELETE_DOCUMENT",
    DELETE_DOCUMENT_SUCCESS: "DELETE_DOCUMENT_SUCCESS",
    DELETE_DOCUMENT_ERROR: "DELETE_DOCUMENT_ERROR",
    DOWNLOAD_DOCUMENT: "DOWNLOAD_DOCUMENT",
    DOWNLOAD_DOCUMENT_SUCCESS: "DOWNLOAD_DOCUMENT_SUCCESS",
    DOWNLOAD_DOCUMENT_ERROR: "DOWNLOAD_DOCUMENT_ERROR",
    VIEW_DOCUMENT: "VIEW_DOCUMENT",
    VIEW_DOCUMENT_SUCCESS: "VIEW_DOCUMENT_SUCCESS",
    VIEW_DOCUMENT_ERROR: "VIEW_DOCUMENT_ERROR",
    ADD_HIGHEST_EDUCATION: "ADD_HIGHEST_EDUCATION",
    ADD_HIGHEST_EDUCATION_SUCCESS: "ADD_HIGHEST_EDUCATION_SUCCESS",
    ADD_HIGHEST_EDUCATION_ERROR: "ADD_HIGHEST_EDUCATION_ERROR",
    ADD_WORK_EX: "ADD_WORK_EX",
    ADD_WORK_EX_SUCCESS: "ADD_WORK_EX_SUCCESS",
    ADD_WORK_EX_ERROR: "ADD_WORK_EX_ERROR",
    ADD_MISC_DOCUMENT: "ADD_MISC_DOCUMENT",
    ADD_MISC_DOCUMENT_SUCCESS: "ADD_MISC_DOCUMENT_SUCCESS",
    ADD_MISC_DOCUMENT_ERROR: "ADD_MISC_DOCUMENT_ERROR",
    FILTER_DOCUMENTS: "FILTER_DOCUMENTS",
    ADD_FILE_LABEL: "ADD_FILE_LABEL",
    ADD_FILE_LABEL_SUCCESS: "ADD_FILE_LABEL_SUCCESS",
    ADD_FILE_LABEL_ERROR: "ADD_FILE_LABEL_ERROR",
    SELECT_ENGLISH_EXAM_TYPE: "SELECT_ENGLISH_EXAM_TYPE",
    SELECT_ENGLISH_EXAM_TYPE_SUCCESS: "SELECT_ENGLISH_EXAM_TYPE_SUCCESS",
    SELECT_ENGLISH_EXAM_TYPE_ERROR: "SELECT_ENGLISH_EXAM_TYPE_ERROR",
    EDIT_TITLE: "EDIT_TITLE",
    EDIT_TITLE_SUCCESS: "EDIT_TITLE_SUCCESS",
    EDIT_TITLE_ERROR: "EDIT_TITLE_ERROR",
    EDIT_MISC_TITLE: "EDIT_MISC_TITLE"
};
var fetchDocumentData = function() {
    return {
        type: documentUploadActionConstants.FETCH_DOCUMENT_DATA
    };
};
var fetchDocumentDataSuccess = function(payload) {
    return {
        type: documentUploadActionConstants.FETCH_DOCUMENT_DATA_SUCCESS,
        payload: payload
    };
};
var fetchDocumentDataError = function(payload) {
    return {
        type: documentUploadActionConstants.FETCH_DOCUMENT_DATA_ERROR,
        payload: payload
    };
};
var uploadDocument = function(payload) {
    return {
        type: documentUploadActionConstants.UPLOAD_DOCUMENT,
        payload: payload
    };
};
var uploadDocumentSuccess = function(payload) {
    return {
        type: documentUploadActionConstants.UPLOAD_DOCUMENT_SUCCESS,
        payload: payload
    };
};
var uploadDocumentError = function(payload) {
    return {
        type: documentUploadActionConstants.UPLOAD_DOCUMENT_ERROR,
        payload: payload
    };
};
var deleteDocument = function(payload) {
    return {
        type: documentUploadActionConstants.DELETE_DOCUMENT,
        payload: payload
    };
};
var deleteDocumentSuccess = function(payload) {
    return {
        type: documentUploadActionConstants.DELETE_DOCUMENT_SUCCESS,
        payload: payload
    };
};
var deleteDocumentError = function(payload) {
    return {
        type: documentUploadActionConstants.DELETE_DOCUMENT_ERROR,
        payload: payload
    };
};
var downloadDocument = function(payload) {
    return {
        type: documentUploadActionConstants.DOWNLOAD_DOCUMENT,
        payload: payload
    };
};
var downloadDocumentSuccess = function(payload) {
    return {
        type: documentUploadActionConstants.DOWNLOAD_DOCUMENT_SUCCESS,
        payload: payload
    };
};
var downloadDocumentError = function(payload) {
    return {
        type: documentUploadActionConstants.DOWNLOAD_DOCUMENT_ERROR,
        payload: payload
    };
};
var viewDocument = function(payload) {
    return {
        type: documentUploadActionConstants.VIEW_DOCUMENT,
        payload: payload
    };
};
var viewDocumentSuccess = function(payload) {
    return {
        type: documentUploadActionConstants.VIEW_DOCUMENT_SUCCESS,
        payload: payload
    };
};
var viewDocumentError = function(payload) {
    return {
        type: documentUploadActionConstants.VIEW_DOCUMENT_ERROR,
        payload: payload
    };
};
var addHighestEducation = function(payload) {
    return {
        type: documentUploadActionConstants.ADD_HIGHEST_EDUCATION,
        payload: payload
    };
};
var addHighestEducationSuccess = function(payload) {
    return {
        type: documentUploadActionConstants.ADD_HIGHEST_EDUCATION_SUCCESS,
        payload: payload
    };
};
var addHighestEducationError = function(payload) {
    return {
        type: documentUploadActionConstants.ADD_HIGHEST_EDUCATION_ERROR,
        payload: payload
    };
};
var addWorkEx = function(payload) {
    return {
        type: documentUploadActionConstants.ADD_WORK_EX,
        payload: payload
    };
};
var addWorkExSuccess = function(payload) {
    return {
        type: documentUploadActionConstants.ADD_WORK_EX_SUCCESS,
        payload: payload
    };
};
var addWorkExError = function(payload) {
    return {
        type: documentUploadActionConstants.ADD_WORK_EX_ERROR,
        payload: payload
    };
};
var addMiscDocument = function(payload) {
    return {
        type: documentUploadActionConstants.ADD_MISC_DOCUMENT,
        payload: payload
    };
};
var addMiscDocumentSuccess = function(payload) {
    return {
        type: documentUploadActionConstants.ADD_MISC_DOCUMENT_SUCCESS,
        payload: payload
    };
};
var addMiscDocumentError = function(payload) {
    return {
        type: documentUploadActionConstants.ADD_MISC_DOCUMENT_ERROR,
        payload: payload
    };
};
var editMiscTitle = function(payload) {
    return {
        type: documentUploadActionConstants.EDIT_MISC_TITLE,
        payload: payload
    };
};
var filterDocuments = function(payload) {
    return {
        type: documentUploadActionConstants.FILTER_DOCUMENTS,
        payload: payload
    };
};
var addFileLabel = function(payload) {
    return {
        type: documentUploadActionConstants.ADD_FILE_LABEL,
        payload: payload
    };
};
var addFileLabelSuccess = function(payload) {
    return {
        type: documentUploadActionConstants.ADD_FILE_LABEL_SUCCESS,
        payload: payload
    };
};
var addFileLabelError = function(payload) {
    return {
        type: documentUploadActionConstants.ADD_FILE_LABEL_ERROR,
        payload: payload
    };
};
var editTitle = function(payload) {
    return {
        type: documentUploadActionConstants.EDIT_TITLE,
        payload: payload
    };
};
var editTitleSuccess = function(payload) {
    return {
        type: documentUploadActionConstants.EDIT_TITLE_SUCCESS,
        payload: payload
    };
};
var editTitleError = function(payload) {
    return {
        type: documentUploadActionConstants.EDIT_TITLE_ERROR,
        payload: payload
    };
};
var selectEnglishExamType = function(payload) {
    return {
        type: documentUploadActionConstants.SELECT_ENGLISH_EXAM_TYPE,
        payload: payload
    };
};
var selectEnglishExamTypeSuccess = function(payload) {
    return {
        type: documentUploadActionConstants.SELECT_ENGLISH_EXAM_TYPE_SUCCESS,
        payload: payload
    };
};
var selectEnglishExamTypeError = function(payload) {
    return {
        type: documentUploadActionConstants.SELECT_ENGLISH_EXAM_TYPE_ERROR,
        payload: payload
    };
};
var documentUploadActions = {
    fetchDocumentData: fetchDocumentData,
    fetchDocumentDataSuccess: fetchDocumentDataSuccess,
    fetchDocumentDataError: fetchDocumentDataError,
    uploadDocument: uploadDocument,
    uploadDocumentSuccess: uploadDocumentSuccess,
    uploadDocumentError: uploadDocumentError,
    deleteDocument: deleteDocument,
    deleteDocumentSuccess: deleteDocumentSuccess,
    deleteDocumentError: deleteDocumentError,
    downloadDocument: downloadDocument,
    downloadDocumentSuccess: downloadDocumentSuccess,
    downloadDocumentError: downloadDocumentError,
    viewDocument: viewDocument,
    viewDocumentSuccess: viewDocumentSuccess,
    viewDocumentError: viewDocumentError,
    addHighestEducation: addHighestEducation,
    addHighestEducationSuccess: addHighestEducationSuccess,
    addHighestEducationError: addHighestEducationError,
    addWorkEx: addWorkEx,
    addWorkExSuccess: addWorkExSuccess,
    addWorkExError: addWorkExError,
    addMiscDocument: addMiscDocument,
    addMiscDocumentSuccess: addMiscDocumentSuccess,
    addMiscDocumentError: addMiscDocumentError,
    filterDocuments: filterDocuments,
    addFileLabel: addFileLabel,
    addFileLabelSuccess: addFileLabelSuccess,
    addFileLabelError: addFileLabelError,
    selectEnglishExamType: selectEnglishExamType,
    selectEnglishExamTypeSuccess: selectEnglishExamTypeSuccess,
    selectEnglishExamTypeError: selectEnglishExamTypeError,
    editTitle: editTitle,
    editTitleSuccess: editTitleSuccess,
    editTitleError: editTitleError,
    editMiscTitle: editMiscTitle
};


/***/ }),

/***/ 98656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ aiEvalutionActions; },
/* harmony export */   "x": function() { return /* binding */ AiEvaluationActionTypes; }
/* harmony export */ });
var AiEvaluationActionTypes = {
    GET_SMART_TEST_PRICE: "GET_SMART_TEST_PRICE",
    GET_SMART_TEST_PRICE_SUCCESS: "GET_SMART_TEST_PRICE_SUCCESS",
    GET_SMART_TESTS_PROGRESS_STATUS: "GET_SMART_TESTS_PROGRESS_STATUS",
    GET_SMART_TESTS_PROGRESS_STATUS_SUCCESS: "GET_SMART_TESTS_PROGRESS_STATUS_SUCCESS"
};
var getAiEvalutionToken = function() {
    var isRedirection = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return {
        type: "GET_AI_EVALUTION_TOKEN",
        payload: isRedirection
    };
};
var getAiEvalutionTokenSuccess = function(payload) {
    return {
        type: "GET_AI_EVALUTION_TOKEN_SUCCESS",
        payload: payload
    };
};
var getAiEvalutionTokenFail = function(message) {
    return {
        type: "GET_AI_EVALUTION_TOKEN_FAIL",
        payload: message
    };
};
var aiEvalutionAlreadyPaid = function() {
    return {
        type: "AI_EVALUTION_ALREADY_PAID"
    };
};
var aiEvalutionAlreadyPaidSuccess = function(payload) {
    return {
        type: "AI_EVALUTION_ALREADY_PAID_SUCCESS",
        payload: payload
    };
};
var aiEvalutionAlreadyPaidFail = function(message) {
    return {
        type: "AI_EVALUTION_ALREADY_PAID_FAIL",
        payload: message
    };
};
var saveForm = function(payload) {
    return {
        type: "AI_EVALUATION_FORM_SUBMIT",
        payload: payload
    };
};
var purchaseType = function(payload) {
    return {
        type: "AI_EVALUATION_PURCHASE_TYPE",
        payload: payload
    };
};
var toggleShowForm = function(payload) {
    return {
        type: "TOGGLE_AI_EVALUATION_SHOW_FORM",
        payload: payload
    };
};
var toggleShowLoader = function(payload) {
    return {
        type: "TOGGLE_AI_EVALUATION_SHOW_LOADER",
        payload: payload
    };
};
var updateError = function(payload) {
    return {
        type: "UPDATE_ERROR",
        payload: payload
    };
};
var openIelts8tab = function(payload) {
    return {
        type: "OPEN_IELTS8_TAB",
        payload: payload
    };
};
var getSmartTestPrice = function() {
    return {
        type: AiEvaluationActionTypes.GET_SMART_TEST_PRICE
    };
};
var getSmartTestPriceSucess = function(payload) {
    return {
        type: AiEvaluationActionTypes.GET_SMART_TEST_PRICE_SUCCESS,
        payload: payload
    };
};
var getSmartTestsProgressStatus = function() {
    return {
        type: AiEvaluationActionTypes.GET_SMART_TESTS_PROGRESS_STATUS
    };
};
var getSmartTestsProgressStatusSuccess = function(payload) {
    return {
        type: AiEvaluationActionTypes.GET_SMART_TESTS_PROGRESS_STATUS_SUCCESS,
        payload: payload
    };
};
var aiEvalutionActions = {
    getAiEvalutionToken: getAiEvalutionToken,
    getAiEvalutionTokenSuccess: getAiEvalutionTokenSuccess,
    getAiEvalutionTokenFail: getAiEvalutionTokenFail,
    aiEvalutionAlreadyPaid: aiEvalutionAlreadyPaid,
    aiEvalutionAlreadyPaidSuccess: aiEvalutionAlreadyPaidSuccess,
    aiEvalutionAlreadyPaidFail: aiEvalutionAlreadyPaidFail,
    purchaseType: purchaseType,
    toggleShowForm: toggleShowForm,
    toggleShowLoader: toggleShowLoader,
    saveForm: saveForm,
    updateError: updateError,
    openIelts8tab: openIelts8tab,
    getSmartTestPrice: getSmartTestPrice,
    getSmartTestPriceSucess: getSmartTestPriceSucess,
    getSmartTestsProgressStatus: getSmartTestsProgressStatus,
    getSmartTestsProgressStatusSuccess: getSmartTestsProgressStatusSuccess
};


/***/ }),

/***/ 4014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dn": function() { return /* binding */ savecallBackFormData; },
/* harmony export */   "K3": function() { return /* binding */ toggleRequestCbForm; },
/* harmony export */   "Lm": function() { return /* binding */ fetchRequestCbSuccess; },
/* harmony export */   "Rn": function() { return /* binding */ fetchRequestCbStatusSuccess; },
/* harmony export */   "Vm": function() { return /* binding */ submitCallBackRequest; },
/* harmony export */   "_t": function() { return /* binding */ fetchRequestCbFailure; },
/* harmony export */   "cG": function() { return /* binding */ toggleRequestCbSucessModal; },
/* harmony export */   "cM": function() { return /* binding */ setIsRequestCbModalOpen; },
/* harmony export */   "nw": function() { return /* binding */ fetchRequestCbStatusFailure; },
/* harmony export */   "vD": function() { return /* binding */ fetchRequestCbRequested; },
/* harmony export */   "wC": function() { return /* binding */ fetchRequestCallBackStatus; },
/* harmony export */   "yC": function() { return /* binding */ setIsFormSubmitted; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27272);



var initialState = {
    isRequestCbFormOpen: false,
    isRequestCbSucessModalOpen: false,
    isLoading: false,
    error: null,
    ctaText: "Submit",
    requestedCallBackBefore: null,
    isRequestCallBackStatusLoading: false,
    callBackFormData: null,
    isRequestCbModalOpen: false,
    isFormSubmitted: false
};
var fetchRequestCbRequested = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("RequestCbPremium/fetchRequestCbRequested");
var fetchRequestCallBackStatus = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("RequestCbPremium/fetchRequestCallBackStatus");
var submitCallBackRequest = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("RequestCbPremium/submitDemoCallBack");
var RequestCbSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "RequestCbPremium",
    initialState: initialState,
    reducers: {
        toggleRequestCbForm: function toggleRequestCbForm(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                isRequestCbFormOpen: action.payload
            });
        },
        toggleRequestCbSucessModal: function toggleRequestCbSucessModal(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                isRequestCbSucessModalOpen: action.payload
            });
        },
        toggleCtaText: function toggleCtaText(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                ctaText: action.payload
            });
        },
        fetchRequestCbSuccess: function fetchRequestCbSuccess(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                isLoading: false,
                ctaText: "Done"
            });
        },
        fetchRequestCbFailure: function fetchRequestCbFailure(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                isLoading: false,
                error: action.payload
            });
        },
        fetchRequestCbStatusSuccess: function fetchRequestCbStatusSuccess(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                isRequestCallBackStatusLoading: false,
                requestedCallBackBefore: action.payload
            });
        },
        fetchRequestCbStatusFailure: function fetchRequestCbStatusFailure(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                isRequestCallBackStatusLoading: false,
                error: action.payload
            });
        },
        savecallBackFormData: function savecallBackFormData(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                callBackFormData: action.payload
            });
        },
        setIsRequestCbModalOpen: function setIsRequestCbModalOpen(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                isRequestCbModalOpen: action.payload
            });
        },
        setIsFormSubmitted: function setIsFormSubmitted(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                isFormSubmitted: action.payload
            });
        }
    }
});
var _actions = RequestCbSlice.actions;
var fetchRequestCbSuccess = _actions.fetchRequestCbSuccess, fetchRequestCbFailure = _actions.fetchRequestCbFailure, toggleRequestCbForm = _actions.toggleRequestCbForm, toggleRequestCbSucessModal = _actions.toggleRequestCbSucessModal, fetchRequestCbStatusSuccess = _actions.fetchRequestCbStatusSuccess, fetchRequestCbStatusFailure = _actions.fetchRequestCbStatusFailure, savecallBackFormData = _actions.savecallBackFormData, setIsRequestCbModalOpen = _actions.setIsRequestCbModalOpen, setIsFormSubmitted = _actions.setIsFormSubmitted;
/* harmony default export */ __webpack_exports__["ZP"] = (RequestCbSlice.reducer);


/***/ }),

/***/ 65489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ batchDetailsActions; },
/* harmony export */   "W": function() { return /* binding */ batchDetailActionTypes; }
/* harmony export */ });
var batchDetailActionTypes = {
    TOGGLE_SHOW_NOT_ABLE_TO_BUY_MODAL: "TOGGLE_SHOW_NOT_ABLE_TO_BUY_MODAL",
    TOOGLE_SHOW_DISQAULIFIED_USERS_MODAL: "TOOGLE_SHOW_DISQAULIFIED_USERS_MODAL",
    FETCH_PRODUCT_BATCH_DETAILS_REQUESTED_CLIENT_SIDE: "FETCH_PRODUCT_BATCH_DETAILS_REQUESTED_CLIENT_SIDE",
    TOGGLE_FAIL_TO_FETCH_BATCH: "TOGGLE_FAIL_TO_FETCH_BATCH"
};
var fetchBatchDetails = function(payload) {
    return {
        type: "FETCH_BATCH_DETAILS_REQUESTED",
        payload: payload
    };
};
var fetchBatchDetailsClientSide = function(payload) {
    return {
        type: "FETCH_BATCH_DETAILS_REQUESTED_CLIENT_SIDE",
        payload: payload
    };
};
var fetchBatchDetailsSuccess = function(payload) {
    return {
        type: "FETCH_BATCH_DETAILS_SUCCESS",
        payload: payload
    };
};
var fetchBatchDetailsFail = function(message) {
    return {
        type: "FETCH_BATCH_DETAILS_FAIL",
        payload: message
    };
};
var fetchBatchTeacherSuccess = function(payload) {
    return {
        type: "FETCH_BATCH_TEACHER_SUCCESS",
        payload: payload
    };
};
var toggleIeltsPlusLoader = function(payload) {
    return {
        type: "TOGGLE_IELTS_PLUS_LOADER",
        payload: payload
    };
};
var toggleIeltsPlusForm = function(payload) {
    return {
        type: "TOGGLE_IELTS_PLUS_FORM",
        payload: payload
    };
};
var togglePromoCode = function(payload) {
    return {
        type: "TOGGLE_PROMO_CODE",
        payload: payload
    };
};
var toggleTriedToBuyBeforeLogin = function(payload) {
    return {
        type: "TOGGLE_TRIED_TO_BUY_BEFORE_LOGIN",
        payload: payload
    };
};
var toogleShowNotAbleToBuyModal = function(payload) {
    return {
        type: batchDetailActionTypes.TOGGLE_SHOW_NOT_ABLE_TO_BUY_MODAL,
        payload: payload
    };
};
var toggleShowDisqaulifiedUsersModal = function(payload) {
    return {
        type: batchDetailActionTypes.TOOGLE_SHOW_DISQAULIFIED_USERS_MODAL,
        payload: payload
    };
};
var fetchProductBatchDetailsClientSide = function(payload) {
    return {
        type: batchDetailActionTypes.FETCH_PRODUCT_BATCH_DETAILS_REQUESTED_CLIENT_SIDE,
        payload: payload
    };
};
var toggleFailToFetchBatchData = function(payload) {
    return {
        type: batchDetailActionTypes.TOGGLE_FAIL_TO_FETCH_BATCH,
        payload: payload
    };
};
var batchDetailsActions = {
    fetchBatchDetails: fetchBatchDetails,
    fetchBatchDetailsSuccess: fetchBatchDetailsSuccess,
    fetchBatchDetailsFail: fetchBatchDetailsFail,
    fetchBatchTeacherSuccess: fetchBatchTeacherSuccess,
    toggleIeltsPlusLoader: toggleIeltsPlusLoader,
    toggleIeltsPlusForm: toggleIeltsPlusForm,
    fetchBatchDetailsClientSide: fetchBatchDetailsClientSide,
    togglePromoCode: togglePromoCode,
    toggleTriedToBuyBeforeLogin: toggleTriedToBuyBeforeLogin,
    toogleShowNotAbleToBuyModal: toogleShowNotAbleToBuyModal,
    toggleShowDisqaulifiedUsersModal: toggleShowDisqaulifiedUsersModal,
    fetchProductBatchDetailsClientSide: fetchProductBatchDetailsClientSide,
    toggleFailToFetchBatchData: toggleFailToFetchBatchData
};


/***/ }),

/***/ 60742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ batchDetailsApi; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var service_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14117);
/* harmony import */ var lib_auth_cookies_new__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89208);
/* harmony import */ var DataMapper_Common_basicAuth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24187);





var fetchBatchDetails = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(batchId, ctx) {
        var headers, config, res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    headers = {
                        Authorization: DataMapper_Common_basicAuth__WEBPACK_IMPORTED_MODULE_4__/* .basicAuthToken */ .y
                    };
                    config = {
                        method: "POST",
                        url: "".concat("https://api.leapscholar.com", "/v2/workshop/").concat(batchId, "/details"),
                        data: {
                            productTypes: null
                        },
                        headers: headers
                    };
                    _ctx.next = 5;
                    return (0,service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(config);
                case 5:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 10:
                    return _ctx.abrupt("return", false);
                case 11:
                    _ctx.next = 16;
                    break;
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }));
    return function fetchBatchDetails(batchId, ctx) {
        return _ref.apply(this, arguments);
    };
}();
var fetchBatchDetailsClientSide = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(batchId) {
        var headers, res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    headers = {
                        "X-API-VERSION": "4"
                    };
                    _ctx.next = 4;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=v2/workshop/".concat(batchId, "/details"), {
                        headers: headers
                    });
                case 4:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 9:
                    return _ctx.abrupt("return", false);
                case 10:
                    _ctx.next = 15;
                    break;
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }));
    return function fetchBatchDetailsClientSide(batchId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchBatchTeacherDetails = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(teacherId, ctx) {
        var accessToken, headers, res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    accessToken = (0,lib_auth_cookies_new__WEBPACK_IMPORTED_MODULE_2__/* .getTokenCookie */ .r_)(ctx);
                    ;
                    if (accessToken) {
                        headers = {
                            Authorization: "Bearer ".concat(accessToken)
                        };
                    }
                    _ctx.next = 6;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("".concat("https://api.leapscholar.com", "/teacher/").concat(teacherId, "/details"), {
                        headers: headers
                    });
                case 6:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 11;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 11:
                    return _ctx.abrupt("return", false);
                case 12:
                    _ctx.next = 17;
                    break;
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                14
            ]
        ]);
    }));
    return function fetchBatchTeacherDetails(teacherId, ctx) {
        return _ref.apply(this, arguments);
    };
}();
var fetchBatchTeacherDetailsClient = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(teacherId) {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=teacher/".concat(teacherId, "/details"));
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    return _ctx.abrupt("return", false);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchBatchTeacherDetailsClient(teacherId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchProductBatchDetailsClientSide = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(payload) {
        var batchId, config, res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    batchId = payload.batchId;
                    config = {
                        method: "POST",
                        url: "/api/scholarOpenRoute?path=v2/workshop/".concat(batchId, "/details"),
                        data: {
                            productTypes: null
                        }
                    };
                    _ctx.next = 5;
                    return (0,service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(config);
                case 5:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 10:
                    return _ctx.abrupt("return", false);
                case 11:
                    _ctx.next = 16;
                    break;
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }));
    return function fetchProductBatchDetailsClientSide(payload) {
        return _ref.apply(this, arguments);
    };
}();
var batchDetailsApi = {
    fetchBatchDetails: fetchBatchDetails,
    fetchBatchTeacherDetails: fetchBatchTeacherDetails,
    fetchBatchDetailsClientSide: fetchBatchDetailsClientSide,
    fetchBatchTeacherDetailsClient: fetchBatchTeacherDetailsClient,
    fetchProductBatchDetailsClientSide: fetchProductBatchDetailsClientSide
};


/***/ }),

/***/ 67443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ facultyActions; }
/* harmony export */ });
var fetchFaculties = function() {
    return {
        type: "FETCH_FACULTIES_REQUESTED"
    };
};
var fetchFacultiesClientSide = function() {
    return {
        type: "FETCH_FACULTIES_REQUESTED_CLIENT"
    };
};
var fetchSuccess = function(payload) {
    return {
        type: "FETCH_FACULTIES_SUCCESS",
        payload: payload
    };
};
var fetchFail = function(message) {
    return {
        type: "FETCH_FACULTIES_FAIL",
        payload: message
    };
};
var facultyActions = {
    fetchFaculties: fetchFaculties,
    fetchSuccess: fetchSuccess,
    fetchFail: fetchFail,
    fetchFacultiesClientSide: fetchFacultiesClientSide
};


/***/ }),

/***/ 73092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "vp": function() { return /* binding */ setBundleDetails; }
/* harmony export */ });
/* unused harmony exports DiscountType, setBundleDetailsError, setBundleDetailsLoading */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27272);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28858);





var PaymentBundlesName = "PaymentBundles";
var DiscountType;
(function(DiscountType) {
    DiscountType["PERCENTAGE"] = "PERCENTAGE";
    DiscountType["FLAT"] = "FLAT";
})(DiscountType || (DiscountType = {}));
var initialState = {
    bundleDetails: null,
    error: null,
    isLoading: false
};
var PaymentBundlesSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createSlice */ .oM)({
    name: PaymentBundlesName,
    initialState: initialState,
    reducers: {
        setBundleDetails: function setBundleDetails(state, action) {
            var description = action.payload.description //convert it to json because it will come as string
            ;
            try {
                if (description) {
                    description = JSON.parse(description.replaceAll("'", '"'));
                }
            } catch (error) {
                console.log(error, "errorInpayment");
            }
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                bundleDetails: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, action.payload), {
                    description: description
                })
            });
        },
        setBundleDetailsLoading: function setBundleDetailsLoading(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                isLoading: action.payload
            });
        },
        setBundleDetailsError: function setBundleDetailsError(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                error: action.payload
            });
        }
    },
    extraReducers: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__/* .HYDRATE */ .ju, function(state, action) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
            bundleDetails: action.payload.PaymentBundles.bundleDetails,
            error: action.payload.PaymentBundles.error,
            isLoading: action.payload.PaymentBundles.isLoading
        });
    })
});
var _actions = PaymentBundlesSlice.actions;
var setBundleDetails = _actions.setBundleDetails, setBundleDetailsError = _actions.setBundleDetailsError, setBundleDetailsLoading = _actions.setBundleDetailsLoading;
/* harmony default export */ __webpack_exports__["ZP"] = (PaymentBundlesSlice.reducer);


/***/ }),

/***/ 25386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GS": function() { return /* binding */ setDate; },
/* harmony export */   "K5": function() { return /* binding */ setTimeRange; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27272);



var filtersSliceName = "Filters";
var initialState = {
    selectedDate: "",
    selectedTimeRange: null
};
var filtersSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: filtersSliceName,
    initialState: initialState,
    reducers: {
        setDate: function setDate(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                selectedDate: action.payload
            });
        },
        setTimeRange: function setTimeRange(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                selectedTimeRange: action.payload
            });
        }
    }
});
var _actions = filtersSlice.actions;
var setDate = _actions.setDate, setTimeRange = _actions.setTimeRange;
/* harmony default export */ __webpack_exports__["ZP"] = (filtersSlice.reducer);


/***/ }),

/***/ 4975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BF": function() { return /* binding */ setAnroidAppMagicLink; },
/* harmony export */   "Fo": function() { return /* binding */ fetchMasterclassData; },
/* harmony export */   "Me": function() { return /* binding */ setCalendarView; },
/* harmony export */   "U5": function() { return /* binding */ setFormData; },
/* harmony export */   "XW": function() { return /* binding */ setRejoinDemoModalData; },
/* harmony export */   "ZS": function() { return /* binding */ bookIeltsSlot; },
/* harmony export */   "_": function() { return /* binding */ fetchAnroidAppMagicLinkSlice; },
/* harmony export */   "cd": function() { return /* binding */ bookDETSlot; },
/* harmony export */   "dT": function() { return /* binding */ fetchRejoinModalData; },
/* harmony export */   "eh": function() { return /* binding */ setSlotsArray; },
/* harmony export */   "jt": function() { return /* binding */ subscribeMasterClass; },
/* harmony export */   "k": function() { return /* binding */ enrollWorkshop; },
/* harmony export */   "lY": function() { return /* binding */ setSelectedSlot; },
/* harmony export */   "oS": function() { return /* binding */ setMasterClassListObj; },
/* harmony export */   "ov": function() { return /* binding */ fetchIeltsSlots; },
/* harmony export */   "q3": function() { return /* binding */ bookPteSlot; },
/* harmony export */   "qT": function() { return /* binding */ setIeltsSlotsDetails; },
/* harmony export */   "sT": function() { return /* binding */ setError; },
/* harmony export */   "tP": function() { return /* binding */ setHasBookedSlot; },
/* harmony export */   "wt": function() { return /* binding */ setIsLoading; },
/* harmony export */   "xe": function() { return /* binding */ setMasterClassBooked; },
/* harmony export */   "yI": function() { return /* binding */ setHasNoSlots; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27272);
/* harmony import */ var DataMapper_IeltsProfile_IeltsDemo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73113);




var IeltsDemoSliceName = "IeltsDemo";
var initialState = {
    calendarView: DataMapper_IeltsProfile_IeltsDemo__WEBPACK_IMPORTED_MODULE_0__/* .CalendarView.LOADING */ .wr.LOADING,
    ieltsSlotsDetails: null,
    slotsArray: [],
    selectedSlot: null,
    error: false,
    hasBookedSlot: false,
    hasNoSlots: false,
    isLoading: true,
    formData: null,
    masterClassListObj: null,
    masterClassBooked: false,
    rejoinDemoModalData: null,
    anroidAppMagicLink: null
};
var ieltsDemoSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createSlice */ .oM)({
    name: IeltsDemoSliceName,
    initialState: initialState,
    reducers: {
        setCalendarView: function setCalendarView(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                calendarView: action.payload
            });
        },
        setIeltsSlotsDetails: function setIeltsSlotsDetails(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                ieltsSlotsDetails: action.payload
            });
        },
        setSlotsArray: function setSlotsArray(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                slotsArray: action.payload
            });
        },
        setSelectedSlot: function setSelectedSlot(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                selectedSlot: action.payload
            });
        },
        setError: function setError(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                error: action.payload
            });
        },
        setHasBookedSlot: function setHasBookedSlot(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                hasBookedSlot: action.payload
            });
        },
        setHasNoSlots: function setHasNoSlots(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                hasNoSlots: action.payload
            });
        },
        setIsLoading: function setIsLoading(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                isLoading: action.payload
            });
        },
        setFormData: function setFormData(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                formData: action.payload
            });
        },
        setMasterClassListObj: function setMasterClassListObj(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                masterClassListObj: action.payload
            });
        },
        setMasterClassBooked: function setMasterClassBooked(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                masterClassBooked: action.payload
            });
        },
        setRejoinDemoModalData: function setRejoinDemoModalData(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                rejoinDemoModalData: action.payload
            });
        },
        setAnroidAppMagicLink: function setAnroidAppMagicLink(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                anroidAppMagicLink: action.payload
            });
        }
    }
});
var fetchIeltsSlots = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createAction */ .PH)("".concat(IeltsDemoSliceName, "/fetchIeltsSlots"));
var fetchMasterclassData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createAction */ .PH)("".concat(IeltsDemoSliceName, "/fetchMasterclassData"));
var bookIeltsSlot = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createAction */ .PH)("".concat(IeltsDemoSliceName, "/bookIeltsSlot"));
var bookPteSlot = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createAction */ .PH)("".concat(IeltsDemoSliceName, "/bookPteSlot"));
var bookDETSlot = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createAction */ .PH)("".concat(IeltsDemoSliceName, "/bookDETSlot"));
var enrollWorkshop = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createAction */ .PH)("".concat(IeltsDemoSliceName, "/enrollWorkshop"));
var subscribeMasterClass = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createAction */ .PH)("".concat(IeltsDemoSliceName, "/subscribeMasterClass"));
var fetchRejoinModalData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createAction */ .PH)("".concat(IeltsDemoSliceName, "/fetchRejoinModalStatus"));
var fetchAnroidAppMagicLinkSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createAction */ .PH)("".concat(IeltsDemoSliceName, "/fetchAnroidAppMagicLinkSlice"));
var _actions = ieltsDemoSlice.actions;
var setCalendarView = _actions.setCalendarView, setIeltsSlotsDetails = _actions.setIeltsSlotsDetails, setSlotsArray = _actions.setSlotsArray, setSelectedSlot = _actions.setSelectedSlot, setError = _actions.setError, setHasBookedSlot = _actions.setHasBookedSlot, setHasNoSlots = _actions.setHasNoSlots, setIsLoading = _actions.setIsLoading, setFormData = _actions.setFormData, setMasterClassListObj = _actions.setMasterClassListObj, setMasterClassBooked = _actions.setMasterClassBooked, setRejoinDemoModalData = _actions.setRejoinDemoModalData, setAnroidAppMagicLink = _actions.setAnroidAppMagicLink;
/* harmony default export */ __webpack_exports__["ZP"] = (ieltsDemoSlice.reducer);


/***/ }),

/***/ 97521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ ieltsEliteApis; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var service_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14117);
/* harmony import */ var utils_browserUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50437);
/* harmony import */ var components_SpotCounselling_Calendar_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82788);






var fetchGetIeltsStage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=ielts-elite/stage");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        success: false,
                        data: null
                    });
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchGetIeltsStage() {
        return _ref.apply(this, arguments);
    };
}();
var fetchPostIeltsEliteNudgeForm = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(formData) {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/scholarRoute?path=ielts-elite/details", formData);
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        success: false,
                        data: null
                    });
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchPostIeltsEliteNudgeForm(formData) {
        return _ref.apply(this, arguments);
    };
}();
var fetchPostDETEliteNudgeForm = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(formData) {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/scholarRoute?path=det-elite/details", formData);
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        success: false,
                        data: null
                    });
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchPostDETEliteNudgeForm(formData) {
        return _ref.apply(this, arguments);
    };
}();
var fetchGetStudentEligibility = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=student/eligibility");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        success: false,
                        data: null
                    });
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchGetStudentEligibility() {
        return _ref.apply(this, arguments);
    };
}();
var fetchPostDetailsIeltsClass = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values) {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/scholarRoute?path=workshop/ielts-class", values);
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        success: false,
                        data: null
                    });
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchPostDetailsIeltsClass(values) {
        return _ref.apply(this, arguments);
    };
}();
var fetchQeFormDataApi = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=ielts-elite/details");
                case 2:
                    return _ctx.abrupt("return", _ctx.sent);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchQeFormDataApi() {
        return _ref.apply(this, arguments);
    };
}();
var ieltsQualificationEngineApi = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(isTofuFlow, source) {
        var headers, res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    headers = {};
                    if (isTofuFlow) {
                        headers = {
                            "x-platform": (0,utils_browserUtils__WEBPACK_IMPORTED_MODULE_2__/* .mobileCheck */ .KU)() ? "TOFU_MWEB" : "TOFU_WEB"
                        };
                    } else {
                        headers = {
                            "x-platform": (0,utils_browserUtils__WEBPACK_IMPORTED_MODULE_2__/* .mobileCheck */ .KU)() ? "MWEB" : "WEB"
                        };
                    }
                    if (source) {
                        headers = {
                            "x-platform": source
                        };
                    }
                    _ctx.prev = 3;
                    _ctx.next = 6;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=ielts-elite/qualification/status", {
                        headers: headers
                    });
                case 6:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](3);
                    return _ctx.abrupt("return", {
                        success: false,
                        message: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                3,
                10
            ]
        ]);
    }));
    return function ieltsQualificationEngineApi(isTofuFlow, source) {
        return _ref.apply(this, arguments);
    };
}();
var fetchIeltsQeStatus = function() {
    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=ielts-elite/qualification/fetch/status");
};
var postExamBookingDataApi = function(examBookedData) {
    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/scholarRoute?path=ielts-elite/exam-details", examBookedData);
};
var fetchLiyStatusApi = function() {
    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=fee/liy/status", {
        headers: {
            "X-API-VERSION": "2"
        }
    });
};
var fetchExamBookedStatusApi = function() {
    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=ielts-elite/exam-details/form-visibility");
};
var lsqTriggerApi = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(lsqSource) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/scholarRoute?path=ielts-elite/dashboard/lsq-event?bookingSource=".concat(lsqSource)));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function lsqTriggerApi(lsqSource) {
        return _ref.apply(this, arguments);
    };
}();
var menaEventApi = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=ielts-elite/meta-event-mena");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        success: false,
                        message: "Error sending MENA event"
                    });
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function menaEventApi() {
        return _ref.apply(this, arguments);
    };
}();
var lsqTriggerGetApi = function() {
    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=ielts-elite/inbound-lsq");
};
var fetchInboundSalesNumberApi = function() {
    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=ielts-elite/inbound-call-number");
};
var fetchPteStatusApi = function() {
    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=fee/pte/status");
};
var fetchPostPteEliteNudgeFormApi = function(formData) {
    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/scholarRoute?path=pte-elite/details", formData);
};
var getPaidUserStatusApi = function() {
    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=ielts-elite/paid-status");
};
var hasUpcomingDemoApi = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(slotType) {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=counselling/has-upcoming-demo/".concat(slotType));
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    return _ctx.abrupt("return", false);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", false);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function hasUpcomingDemoApi(slotType) {
        return _ref.apply(this, arguments);
    };
}();
var fetchDemoStateApi = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(slotType) {
        var _obj, path, res, ref;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    path = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, components_SpotCounselling_Calendar_utils__WEBPACK_IMPORTED_MODULE_3__/* .SlotTypes.PTE_SPOT_COUNSELLING */ .C3.PTE_SPOT_COUNSELLING, "pet-elite/details"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, components_SpotCounselling_Calendar_utils__WEBPACK_IMPORTED_MODULE_3__/* .SlotTypes.DET_SPOT_COUNSELLING */ .C3.DET_SPOT_COUNSELLING, "det-elite/details"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, components_SpotCounselling_Calendar_utils__WEBPACK_IMPORTED_MODULE_3__/* .SlotTypes.IELTS_SPOT_COUNSELLING */ .C3.IELTS_SPOT_COUNSELLING, "ielts-elite/details"), _obj);
                    _ctx.next = 5;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=".concat(path[slotType]));
                case 5:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 11;
                        break;
                    }
                    ;
                    return _ctx.abrupt("return", (ref = res.data) === null || ref === void 0 ? void 0 : ref.data);
                case 11:
                    return _ctx.abrupt("return", false);
                case 12:
                    _ctx.next = 18;
                    break;
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return", false);
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                14
            ]
        ]);
    }));
    return function fetchDemoStateApi(slotType) {
        return _ref.apply(this, arguments);
    };
}();
var ieltsEliteApis = {
    fetchPostIeltsEliteNudgeForm: fetchPostIeltsEliteNudgeForm,
    fetchPostDetailsIeltsClass: fetchPostDetailsIeltsClass,
    fetchGetIeltsStage: fetchGetIeltsStage,
    fetchGetStudentEligibility: fetchGetStudentEligibility,
    fetchQeFormDataApi: fetchQeFormDataApi,
    ieltsQualificationEngineApi: ieltsQualificationEngineApi,
    fetchIeltsQeStatus: fetchIeltsQeStatus,
    postExamBookingDataApi: postExamBookingDataApi,
    fetchLiyStatusApi: fetchLiyStatusApi,
    fetchExamBookedStatusApi: fetchExamBookedStatusApi,
    lsqTriggerApi: lsqTriggerApi,
    menaEventApi: menaEventApi,
    lsqTriggerGetApi: lsqTriggerGetApi,
    fetchInboundSalesNumberApi: fetchInboundSalesNumberApi,
    fetchPteStatusApi: fetchPteStatusApi,
    fetchPostPteEliteNudgeFormApi: fetchPostPteEliteNudgeFormApi,
    getPaidUserStatusApi: getPaidUserStatusApi,
    fetchPostDETEliteNudgeForm: fetchPostDETEliteNudgeForm,
    hasUpcomingDemoApi: hasUpcomingDemoApi,
    fetchDemoStateApi: fetchDemoStateApi
};


/***/ }),

/***/ 48472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$c": function() { return /* binding */ setPaidUserStatus; },
/* harmony export */   "AI": function() { return /* binding */ setInboundSalesNumber; },
/* harmony export */   "CW": function() { return /* binding */ setLiyPaymentStatus; },
/* harmony export */   "Cq": function() { return /* binding */ setStudentEligibilityLoading; },
/* harmony export */   "D$": function() { return /* binding */ runIeltsQualificationEngineAction; },
/* harmony export */   "Dr": function() { return /* binding */ updatePostGetStageAction; },
/* harmony export */   "EB": function() { return /* binding */ setIeltsStageError; },
/* harmony export */   "FZ": function() { return /* binding */ setIeltsStageLoading; },
/* harmony export */   "Fj": function() { return /* binding */ fetchPostDetailsIeltsClass; },
/* harmony export */   "GR": function() { return /* binding */ setUserQeData; },
/* harmony export */   "Ge": function() { return /* binding */ lsqTriggerGetApiSlice; },
/* harmony export */   "Ih": function() { return /* binding */ UserQeData; },
/* harmony export */   "Lp": function() { return /* binding */ postExamBookingDataSlice; },
/* harmony export */   "Lt": function() { return /* binding */ fetchLiyStatusSlice; },
/* harmony export */   "NS": function() { return /* binding */ fetchPostIeltsEliteNudgeForm; },
/* harmony export */   "QW": function() { return /* binding */ IeltsStageType; },
/* harmony export */   "Qt": function() { return /* binding */ setIsQeModalOpen; },
/* harmony export */   "Qv": function() { return /* binding */ fetchPteStatusSlice; },
/* harmony export */   "R$": function() { return /* binding */ fetchExamBookedStatusSlice; },
/* harmony export */   "Rx": function() { return /* binding */ fetchQeFormData; },
/* harmony export */   "Vn": function() { return /* binding */ setPtePaymentStatus; },
/* harmony export */   "WB": function() { return /* binding */ setQeFormData; },
/* harmony export */   "Wv": function() { return /* binding */ fetchGetIeltsStage; },
/* harmony export */   "XS": function() { return /* binding */ updatePostFillIeltsEliteNudgeForm; },
/* harmony export */   "ZJ": function() { return /* binding */ getPaidUserStatusSlice; },
/* harmony export */   "c0": function() { return /* binding */ updatePostGetStudentEligibility; },
/* harmony export */   "cU": function() { return /* binding */ fetchIeltsQeStatusSlice; },
/* harmony export */   "de": function() { return /* binding */ lsqTriggerSlice; },
/* harmony export */   "dk": function() { return /* binding */ updateStudentEligibility; },
/* harmony export */   "eE": function() { return /* binding */ fetchGetStudentEligibility; },
/* harmony export */   "k9": function() { return /* binding */ fetchInboundSalesNumberSlice; },
/* harmony export */   "pk": function() { return /* binding */ setQeLoaders; },
/* harmony export */   "q1": function() { return /* binding */ fetchPostDETEliteNudgeForm; },
/* harmony export */   "qJ": function() { return /* binding */ updatePostFillIeltsQeFormAction; },
/* harmony export */   "qp": function() { return /* binding */ updateIeltsStage; },
/* harmony export */   "sU": function() { return /* binding */ setIsQeFormSubmit; },
/* harmony export */   "vg": function() { return /* binding */ toggleIsIeltsEliteQeFormOpen; },
/* harmony export */   "xU": function() { return /* binding */ setStudentEligibilityError; },
/* harmony export */   "y6": function() { return /* binding */ setIsExamBookedSubmit; },
/* harmony export */   "zW": function() { return /* binding */ setExamBookedStatus; },
/* harmony export */   "zv": function() { return /* binding */ fetchPostPteEliteNudgeFormSlice; }
/* harmony export */ });
/* unused harmony exports ieltsEliteStateName, fetchPostIeltsQeform, setShowCongratsText */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27272);



var ieltsEliteStateName = "IeltsElite";
var IeltsStageType;
(function(IeltsStageType) {
    IeltsStageType["IELTS_DEMO_BOOKED"] = "IELTS_DEMO_BOOKED";
    IeltsStageType["IELTS_DEMO_ATTENDED"] = "IELTS_DEMO_ATTENDED";
    IeltsStageType["LS_USER_ACQUIRED"] = "LS_USER_ACQUIRED";
    IeltsStageType["IELTS_USER_ACQUIRED"] = "IELTS_USER_ACQUIRED";
    IeltsStageType["IELTS_PAID_USER"] = "IELTS_PAID_USER";
    IeltsStageType["IELTS_DEMO_MISSED"] = "IELTS_DEMO_MISSED";
    IeltsStageType["IELTS_LIY_PAID_USER"] = "IELTS_LIY_PAID_USER";
    IeltsStageType["IELTS_LIY_DEMO_BOOKED"] = "IELTS_LIY_DEMO_BOOKED";
    IeltsStageType["IELTS_LIY_DEMO_ATTENDED"] = "IELTS_LIY_DEMO_ATTENDED";
    IeltsStageType["IELTS_LIY_DEMO_MISSED"] = "IELTS_LIY_DEMO_MISSED";
    IeltsStageType["SAT_PAID_USER"] = "SAT_PAID_USER";
})(IeltsStageType || (IeltsStageType = {}));
var UserQeData;
(function(UserQeData) {
    UserQeData["TYPE1"] = "TYPE1";
    UserQeData["TYPE2"] = "TYPE2";
    UserQeData["DEFAULT"] = "DEFAULT";
})(UserQeData || (UserQeData = {}));
var initialState = {
    isIeltsStageLoading: false,
    ieltsStageError: null,
    isStudentEligibilityLoading: false,
    isStudentEligibilityError: null,
    error: null,
    isIeltsEliteQeFormOpen: false,
    ieltsStage: null,
    studentEligibility: null,
    showCongratsText: false,
    postGetStageAction: null,
    postGetEligibilityAction: null,
    postFillIeltsQeFormAction: null,
    postFillIeltsEliteNudgeForm: null,
    isQeModalOpen: false,
    isQeFormSubmit: false,
    qeFormData: null,
    userQeData: null,
    isExamBookedSubmit: false,
    liyPaymentStatus: null,
    examBookedStatus: null,
    inboundSalesNumber: null,
    ptePaymentStatus: null,
    paidUserStatus: false,
    qeLoaders: false
};
var fetchGetIeltsStage = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("".concat(ieltsEliteStateName, "/fetchGetIeltsStage"));
var fetchGetStudentEligibility = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("".concat(ieltsEliteStateName, "/fetchGetStudentEligibility"));
var fetchPostIeltsEliteNudgeForm = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("".concat(ieltsEliteStateName, "/fetchPostIeltsEliteNudgeForm"));
var fetchPostDETEliteNudgeForm = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("".concat(ieltsEliteStateName, "/fetchPostDETEliteNudgeForm"));
var fetchPostIeltsQeform = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("".concat(ieltsEliteStateName, "/fetchPostIeltsQeform"));
var fetchPostDetailsIeltsClass = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("".concat(ieltsEliteStateName, "/fetchPostDetailsIeltsClass"));
//accepting a callback which will be called after this get api is called
var fetchQeFormData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("".concat(ieltsEliteStateName, "/fetchQeFormData"));
var runIeltsQualificationEngineAction = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("".concat(ieltsEliteStateName, "/runIeltsQualificationEngine"));
var fetchIeltsQeStatusSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("".concat(ieltsEliteStateName, "/fetchIeltsQeStatusSlice"));
var postExamBookingDataSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("".concat(ieltsEliteStateName, "/postExamBookingDataSlice"));
var fetchLiyStatusSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("".concat(ieltsEliteStateName, "/fetchLiyStatusSlice"));
var fetchExamBookedStatusSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("".concat(ieltsEliteStateName, "/fetchExamBookedStatusSlice"));
var lsqTriggerSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("".concat(ieltsEliteStateName, "/lsqTriggerSlice"));
var lsqTriggerGetApiSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("".concat(ieltsEliteStateName, "/lsqTriggerGetApiSlice"));
var fetchInboundSalesNumberSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("".concat(ieltsEliteStateName, "/fetchInboundSalesNumberSlice"));
var fetchPteStatusSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("".concat(ieltsEliteStateName, "/fetchPteStatusSlice"));
var fetchPostPteEliteNudgeFormSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("".concat(ieltsEliteStateName, "/fetchPostPteEliteNudgeFormSlice"));
var getPaidUserStatusSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("".concat(ieltsEliteStateName, "/getPaidUserStatusslice"));
var ieltsEliteSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: ieltsEliteStateName,
    initialState: initialState,
    reducers: {
        toggleIsIeltsEliteQeFormOpen: function toggleIsIeltsEliteQeFormOpen(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                isIeltsEliteQeFormOpen: action.payload
            });
        },
        updateIeltsStage: function updateIeltsStage(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                ieltsStage: action.payload
            });
        },
        updateStudentEligibility: function updateStudentEligibility(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                studentEligibility: action.payload
            });
        },
        setIeltsStageLoading: function setIeltsStageLoading(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                ieltsStageLoading: action.payload
            });
        },
        setIeltsStageError: function setIeltsStageError(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                ieltsStageError: action.payload
            });
        },
        setStudentEligibilityLoading: function setStudentEligibilityLoading(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                isStudentEligibilityLoading: action.payload
            });
        },
        setStudentEligibilityError: function setStudentEligibilityError(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                isStudentEligibilityError: action.payload
            });
        },
        setShowCongratsText: function setShowCongratsText(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                showCongratsText: action.payload
            });
        },
        updatePostGetStageAction: function updatePostGetStageAction(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                postGetStageAction: action.payload
            });
        },
        updatePostGetStudentEligibility: function updatePostGetStudentEligibility(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                postGetEligibilityAction: action.payload
            });
        },
        updatePostFillIeltsQeFormAction: function updatePostFillIeltsQeFormAction(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                postFillIeltsQeFormAction: action.payload
            });
        },
        updatePostFillIeltsEliteNudgeForm: function updatePostFillIeltsEliteNudgeForm(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                postFillIeltsEliteNudgeForm: action.payload
            });
        },
        setIsQeModalOpen: function setIsQeModalOpen(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                isQeModalOpen: action.payload
            });
        },
        setIsQeFormSubmit: function setIsQeFormSubmit(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                isQeFormSubmit: action.payload
            });
        },
        setQeFormData: function setQeFormData(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                qeFormData: action.payload
            });
        },
        setUserQeData: function setUserQeData(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                userQeData: action.payload
            });
        },
        setIsExamBookedSubmit: function setIsExamBookedSubmit(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                isExamBookedSubmit: action.payload
            });
        },
        setLiyPaymentStatus: function setLiyPaymentStatus(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                liyPaymentStatus: action.payload
            });
        },
        setExamBookedStatus: function setExamBookedStatus(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                examBookedStatus: action.payload
            });
        },
        setInboundSalesNumber: function setInboundSalesNumber(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                inboundSalesNumber: action.payload
            });
        },
        setPtePaymentStatus: function setPtePaymentStatus(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                ptePaymentStatus: action.payload
            });
        },
        setPaidUserStatus: function setPaidUserStatus(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                paidUserStatus: action.payload
            });
        },
        setQeLoaders: function setQeLoaders(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                qeLoaders: action.payload
            });
        }
    }
});
var _actions = ieltsEliteSlice.actions;
var toggleIsIeltsEliteQeFormOpen = _actions.toggleIsIeltsEliteQeFormOpen, updateIeltsStage = _actions.updateIeltsStage, updateStudentEligibility = _actions.updateStudentEligibility, setIeltsStageLoading = _actions.setIeltsStageLoading, setIeltsStageError = _actions.setIeltsStageError, setStudentEligibilityLoading = _actions.setStudentEligibilityLoading, setStudentEligibilityError = _actions.setStudentEligibilityError, setShowCongratsText = _actions.setShowCongratsText, updatePostGetStageAction = _actions.updatePostGetStageAction, updatePostGetStudentEligibility = _actions.updatePostGetStudentEligibility, updatePostFillIeltsQeFormAction = _actions.updatePostFillIeltsQeFormAction, updatePostFillIeltsEliteNudgeForm = _actions.updatePostFillIeltsEliteNudgeForm, setIsQeModalOpen = _actions.setIsQeModalOpen, setIsQeFormSubmit = _actions.setIsQeFormSubmit, setQeFormData = _actions.setQeFormData, setUserQeData = _actions.setUserQeData, setIsExamBookedSubmit = _actions.setIsExamBookedSubmit, setLiyPaymentStatus = _actions.setLiyPaymentStatus, setExamBookedStatus = _actions.setExamBookedStatus, setInboundSalesNumber = _actions.setInboundSalesNumber, setPtePaymentStatus = _actions.setPtePaymentStatus, setPaidUserStatus = _actions.setPaidUserStatus, setQeLoaders = _actions.setQeLoaders;
/* harmony default export */ __webpack_exports__["ZP"] = (ieltsEliteSlice.reducer);


/***/ }),

/***/ 6179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ masterclassTypeActions; },
/* harmony export */   "L": function() { return /* binding */ actionConstant; }
/* harmony export */ });
var actionConstant = {
    REQUEST_BEGINNER_MASTERCLASS_TYPE_DATA: "REQUEST_BEGINNER_MASTERCLASS_TYPE_DATA",
    SUCCESS_BEGINNER_MASTERCLASS_TYPE_DATA: "SUCCESS_BEGINNER_MASTERCLASS_TYPE_DATA",
    REQUEST_CLASSIC_MASTERCLASS_TYPE_DATA: "REQUEST_CLASSIC_MASTERCLASS_TYPE_DATA",
    SUCCESS_CLASSIC_MASTERCLASS_TYPE_DATA: "SUCCESS_CLASSIC_MASTERCLASS_TYPE_DATA",
    UPDATE_ERROR: "UPDATE_ERROR",
    FETCH_MASTERCLASS_ATTEND_STATUS: "FETCH_MASTERCLASS_ATTEND_STATUS",
    SET_MASTERCLASS_ATTEND_STATUS: "SET_MASTERCLASS_ATTEND_STATUS"
};
var requestBeginnerMasterClassData = function(payload) {
    return {
        type: actionConstant.REQUEST_BEGINNER_MASTERCLASS_TYPE_DATA,
        payload: payload
    };
};
var successBeginnerMasterClassData = function(payload) {
    return {
        type: actionConstant.SUCCESS_BEGINNER_MASTERCLASS_TYPE_DATA,
        payload: payload
    };
};
var requestClassicMasterClassData = function(payload) {
    return {
        type: actionConstant.REQUEST_CLASSIC_MASTERCLASS_TYPE_DATA,
        payload: payload
    };
};
var successClassicMasterClassData = function(payload) {
    return {
        type: actionConstant.SUCCESS_CLASSIC_MASTERCLASS_TYPE_DATA,
        payload: payload
    };
};
var updateError = function(payload) {
    return {
        type: actionConstant.UPDATE_ERROR,
        payload: payload
    };
};
var fetchMasterclassAttendStatusAction = function() {
    return {
        type: actionConstant.FETCH_MASTERCLASS_ATTEND_STATUS
    };
};
var setMasterclassAttendStatusAction = function(payload) {
    return {
        type: actionConstant.SET_MASTERCLASS_ATTEND_STATUS,
        payload: payload
    };
};
var masterclassTypeActions = {
    requestBeginnerMasterClassData: requestBeginnerMasterClassData,
    successBeginnerMasterClassData: successBeginnerMasterClassData,
    requestClassicMasterClassData: requestClassicMasterClassData,
    successClassicMasterClassData: successClassicMasterClassData,
    updateError: updateError,
    fetchMasterclassAttendStatusAction: fetchMasterclassAttendStatusAction,
    setMasterclassAttendStatusAction: setMasterclassAttendStatusAction
};


/***/ }),

/***/ 56515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ promoCodeActions; }
/* harmony export */ });
var fetchPromoCodeValidation = function(payload) {
    return {
        type: "FETCH_PROMO_CODE_VALIDATION",
        payload: payload
    };
};
var fetchPromoCodeValidationSuccess = function(payload) {
    return {
        type: "FETCH_PROMO_CODE_VALIDATION_SUCCESS",
        payload: payload
    };
};
var fetchPromoCodeValidationFail = function(message) {
    return {
        type: "FETCH_PROMO_CODE_VALIDATION_FAIL",
        payload: message
    };
};
var updatePromoCodeApplied = function(payload) {
    return {
        type: "UPDATE_PROMO_CODE_APPLIED",
        payload: payload
    };
};
var removePromoCode = function() {
    return {
        type: "REMOVE_PROMO_CODE"
    };
};
var togglePromoCodeForm = function(payload) {
    return {
        type: "TOGGLE_PROMO_CODE_FORM",
        payload: payload
    };
};
var togglePromoCodeApplicationLoading = function(payload) {
    return {
        type: "TOGGLE_PROMO_CODE_APPLICATION_LOADING",
        payload: payload
    };
};
var fetchPromoCodes = function(payload) {
    return {
        type: "FETCH_PROMO_CODES",
        payload: payload
    };
};
var changeIsValidCode = function(payload) {
    return {
        type: "CHANGE_IS_VALID_CODE",
        payload: payload
    };
};
var fetchPromoCodesSuccess = function(payload) {
    return {
        type: "FETCH_PROMO_CODES_SUCCESS",
        payload: payload
    };
};
var fetchPromoCodesFail = function(message) {
    return {
        type: "FETCH_PROMO_CODES_FAIL",
        payload: message
    };
};
var promoCodeActions = {
    fetchPromoCodeValidation: fetchPromoCodeValidation,
    fetchPromoCodeValidationSuccess: fetchPromoCodeValidationSuccess,
    fetchPromoCodeValidationFail: fetchPromoCodeValidationFail,
    updatePromoCodeApplied: updatePromoCodeApplied,
    removePromoCode: removePromoCode,
    togglePromoCodeForm: togglePromoCodeForm,
    togglePromoCodeApplicationLoading: togglePromoCodeApplicationLoading,
    fetchPromoCodes: fetchPromoCodes,
    fetchPromoCodesSuccess: fetchPromoCodesSuccess,
    fetchPromoCodesFail: fetchPromoCodesFail,
    changeIsValidCode: changeIsValidCode
};


/***/ }),

/***/ 14729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E4": function() { return /* binding */ setReferalError; },
/* harmony export */   "ty": function() { return /* binding */ postReferalData; },
/* harmony export */   "vm": function() { return /* binding */ ieltsReferalStateName; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27272);



var ieltsReferalStateName = "ieltsReferal";
var initialState = {
    error: ""
};
var postReferalData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("".concat(ieltsReferalStateName, "/postReferalData"));
var IeltsReferalSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: ieltsReferalStateName,
    initialState: initialState,
    reducers: {
        setReferalError: function setReferalError(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                error: action.payload
            });
        }
    }
});
var setReferalError = IeltsReferalSlice.actions.setReferalError;
/* harmony default export */ __webpack_exports__["ZP"] = (IeltsReferalSlice.reducer);


/***/ }),

/***/ 46809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ reviewActions; }
/* harmony export */ });
var fetchReviews = function() {
    return {
        type: "FETCH_IELTS_REVIEWS"
    };
};
var fetchReviewsSuccess = function(payload) {
    return {
        type: "FETCH_IELTS_REVIEWS_SUCCESS",
        payload: payload
    };
};
var updateError = function(message) {
    return {
        type: "UPDATE_IELTS_REVIEWS_ERROR",
        payload: message
    };
};
var reviewActions = {
    fetchReviews: fetchReviews,
    fetchReviewsSuccess: fetchReviewsSuccess,
    updateError: updateError
};


/***/ }),

/***/ 73289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ selfPrepAction; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27272);



var reducerName = "selfPrep";
var initialState = {
    selfPrepPrice: null
};
var selfPrepSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: reducerName,
    initialState: initialState,
    reducers: {
        setSelfPrepPrice: function setSelfPrepPrice(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                selfPrepPrice: action.payload
            });
        }
    }
});
var selfPrepAction = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, selfPrepSlice.actions);
/* harmony default export */ __webpack_exports__["Z"] = (selfPrepSlice.reducer);


/***/ }),

/***/ 50501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ actionConstant; },
/* harmony export */   "i": function() { return /* binding */ semPageAction; }
/* harmony export */ });
var actionConstant = {
    SEM_PAGE_DETAIL_REQUEST: "SEM_PAGE_DETAIL_REQUEST",
    SEM_PAGE_DETAIL_SUCCESS: "SEM_PAGE_DETAIL_SUCCESS",
    UPDATE_ERROR: "UPDATE_ERROR",
    SEM_SAVE_FORM_REQUEST: "SEM_SAVE_FORM_REQUEST",
    SEM_SAVE_FORM_SUCCESS: "SEM_SAVE_FORM_SUCCESS",
    TOGGEL_MODAL: "TOGGEL_MODAL"
};
var semPageDetailRequest = function() {
    return {
        type: actionConstant.SEM_PAGE_DETAIL_REQUEST
    };
};
var semPageDetailSuccess = function(payload) {
    return {
        type: actionConstant.SEM_PAGE_DETAIL_SUCCESS,
        payload: payload
    };
};
var updateError = function(payload) {
    return {
        type: actionConstant.UPDATE_ERROR,
        payload: payload
    };
};
var semSaveFormRequest = function(payload, path) {
    return {
        type: actionConstant.SEM_SAVE_FORM_REQUEST,
        payload: payload,
        path: path
    };
};
var semSaveFormSuccess = function() {
    return {
        type: actionConstant.SEM_SAVE_FORM_SUCCESS
    };
};
var toggelModal = function(payload) {
    return {
        type: actionConstant.TOGGEL_MODAL,
        payload: payload
    };
};
var semPageAction = {
    semPageDetailRequest: semPageDetailRequest,
    semPageDetailSuccess: semPageDetailSuccess,
    updateError: updateError,
    semSaveFormRequest: semSaveFormRequest,
    semSaveFormSuccess: semSaveFormSuccess,
    toggelModal: toggelModal
};


/***/ }),

/***/ 70941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ac": function() { return /* binding */ BatchType; },
/* harmony export */   "Ir": function() { return /* binding */ BatchesFilters; },
/* harmony export */   "kv": function() { return /* binding */ ProductType; },
/* harmony export */   "mX": function() { return /* binding */ SeatStatusEnum; },
/* harmony export */   "u4": function() { return /* binding */ BatchesTypeDto; }
/* harmony export */ });
var BatchesTypeDto;
(function(BatchesTypeDto) {
    BatchesTypeDto["PRIME"] = "PRIME";
    BatchesTypeDto["PLUS"] = "PLUS";
    BatchesTypeDto["FOCUS"] = "FOCUS";
})(BatchesTypeDto || (BatchesTypeDto = {}));
var SeatStatusEnum;
(function(SeatStatusEnum) {
    SeatStatusEnum["AVAILABLE"] = "AVAILABLE";
    SeatStatusEnum["FAST_FILLING"] = "FAST_FILLING";
    SeatStatusEnum["ALMOST_FILLED"] = "ALMOST_FILLED";
    SeatStatusEnum["FILLED"] = "FILLED";
})(SeatStatusEnum || (SeatStatusEnum = {}));
var BatchesFilters;
(function(BatchesFilters) {
    BatchesFilters["ALL_BATCHES"] = "All Batches";
    BatchesFilters["WEEK_DAY_BATCHES"] = "Weekday Batches";
    BatchesFilters["WEEKEND_BATCHES"] = "Weekend Batches";
    BatchesFilters["EVENING_BATCHES_ONLY"] = "Evening Batches Only";
    BatchesFilters["STARTING_IN_2_DAYS"] = "Starting within 2 days";
    BatchesFilters["BAND_ASSURANCE"] = "Band Assurance";
})(BatchesFilters || (BatchesFilters = {}));
var ProductType;
(function(ProductType) {
    ProductType["BAND_ASSURANCE"] = "BAND_ASSURANCE";
})(ProductType || (ProductType = {}));
var BatchType;
(function(BatchType) {
    BatchType["IELTS"] = "IELTS";
    BatchType["PTE"] = "PTE";
    BatchType["DET"] = "DET";
})(BatchType || (BatchType = {}));


/***/ }),

/***/ 4726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ upcomingIeltsBatchesAction; },
/* harmony export */   "h": function() { return /* binding */ UpcomingType; }
/* harmony export */ });
var UpcomingType = {
    UPCOMING_IELTS_FETCH_REQUESTED: "UPCOMING_IELTS_FETCH_REQUESTED",
    UPCOMING_IELTS_FETCH_SUCCESS: "UPCOMING_IELTS_FETCH_SUCCESS",
    UPCOMING_IELTS_FETCH_FAIL: "UPCOMING_IELTS_FETCH_FAIL",
    UPCOMING_IELTS_FETCH_CLIENT_REQUESTED: "UPCOMING_IELTS_FETCH_CLIENT_REQUESTED",
    IELTS_FOUNDATION_BATCH_FETCH_REQUESTED: "IELTS_FOUNDATION_BATCH_FETCH_REQUESTED",
    IELTS_FOUNDATION_BATCH_FETCH_SUCCESS: "IELTS_FOUNDATION_BATCH_FETCH_SUCCESS",
    IELTS_PLUS_BATCH_FETCH_SUCCESS: "IELTS_PLUS_BATCH_FETCH_SUCCESS",
    IELTS_PREMIUM_BATCH_FETCH_SUCCESS: "IELTS_PREMIUM_BATCH_FETCH_SUCCESS",
    NUDGE_FETCH_SUCCESS: "NUDGE_FETCH_SUCCESS",
    TOGGLE_UPCOMING_IELTS_BATCHES_MODAL: "TOGGLE_UPCOMING_IELTS_BATCHES_MODAL",
    FETCH_GET_UPCOMING_BATCH_TIME_AND_PRICE: "FETCH_GET_UPCOMING_BATCH_TIME_AND_PRICE",
    FETCH_GET_UPCOMING_BATCH_TIME_AND_PRICE_SUCCESS: "FETCH_GET_UPCOMING_BATCH_TIME_AND_PRICE_SUCCESS",
    FETCH_IELTS_BATCHES: "FETCH_IELTS_BATCHES",
    FETCH_PTE_BATCHES: "FETCH_PTE_BATCHES",
    FETCH_DET_BATCHES: "FETCH_DET_BATCHES",
    SET_ALL_IELTS_BATCHES: "SET_ALL_IELTS_BATCHES",
    FETCH_BATCHES_BANNER: "FETCH_BATCHES_BANNER",
    SET_BATCHES_BANNER_DATA: "SET_BATCHES_BANNER_DATA",
    TOGGLE_OFFER_MODAL: "TOGGLE_OFFER_MODAL"
};
var fetchUpcomingIeltsBatch = function(payload) {
    return {
        type: UpcomingType.UPCOMING_IELTS_FETCH_REQUESTED,
        payload: payload
    };
};
var fetchUpcomingIeltsBatchClient = function() {
    return {
        type: UpcomingType.UPCOMING_IELTS_FETCH_CLIENT_REQUESTED
    };
};
var fetchIeltsFoundationBatchRequest = function() {
    return {
        type: UpcomingType.IELTS_FOUNDATION_BATCH_FETCH_REQUESTED
    };
};
var fetchIeltsFoundationBatchSuccess = function(payload) {
    return {
        type: UpcomingType.IELTS_FOUNDATION_BATCH_FETCH_SUCCESS,
        payload: payload
    };
};
var fetchIeltsPlusBatchSuccess = function(payload) {
    return {
        type: UpcomingType.IELTS_PLUS_BATCH_FETCH_SUCCESS,
        payload: payload
    };
};
var fetchUpcomingIeltsSuccess = function(payload) {
    return {
        type: UpcomingType.UPCOMING_IELTS_FETCH_SUCCESS,
        payload: payload
    };
};
var fetchNudgeSuccess = function(payload) {
    return {
        type: UpcomingType.NUDGE_FETCH_SUCCESS,
        payload: payload
    };
};
var fetchUpcomingIeltsFail = function(message) {
    return {
        type: UpcomingType.UPCOMING_IELTS_FETCH_FAIL,
        payload: message
    };
};
var toggleUpcomigIeltsBatchModal = function(payload) {
    return {
        type: UpcomingType.TOGGLE_UPCOMING_IELTS_BATCHES_MODAL,
        payload: payload
    };
};
var fetchUpcomingBatchPriceAndTime = function() {
    return {
        type: UpcomingType.FETCH_GET_UPCOMING_BATCH_TIME_AND_PRICE
    };
};
var fetchUpcomingBatchPriceAndTimeSuccess = function(payload) {
    return {
        type: UpcomingType.FETCH_GET_UPCOMING_BATCH_TIME_AND_PRICE_SUCCESS,
        payload: payload
    };
};
var fetchIeltsBatches = function(payload) {
    return {
        type: UpcomingType.FETCH_IELTS_BATCHES,
        payload: payload
    };
};
var fetchPteBatches = function(payload) {
    return {
        type: UpcomingType.FETCH_PTE_BATCHES,
        payload: payload
    };
};
var fetchDETBatches = function(payload) {
    return {
        type: UpcomingType.FETCH_DET_BATCHES,
        payload: payload
    };
};
var setAllIeltsBatches = function(payload) {
    return {
        type: UpcomingType.SET_ALL_IELTS_BATCHES,
        payload: payload
    };
};
var fetchBannerData = function() {
    return {
        type: UpcomingType.FETCH_BATCHES_BANNER
    };
};
var setBannerData = function(payload) {
    return {
        type: UpcomingType.SET_BATCHES_BANNER_DATA,
        payload: payload
    };
};
var toggleOfferModal = function(payload) {
    return {
        type: UpcomingType.TOGGLE_OFFER_MODAL,
        payload: payload
    };
};
var upcomingIeltsBatchesAction = {
    fetchUpcomingIeltsBatch: fetchUpcomingIeltsBatch,
    fetchUpcomingIeltsSuccess: fetchUpcomingIeltsSuccess,
    fetchUpcomingIeltsFail: fetchUpcomingIeltsFail,
    fetchUpcomingIeltsBatchClient: fetchUpcomingIeltsBatchClient,
    fetchNudgeSuccess: fetchNudgeSuccess,
    fetchIeltsFoundationBatchRequest: fetchIeltsFoundationBatchRequest,
    fetchIeltsFoundationBatchSuccess: fetchIeltsFoundationBatchSuccess,
    fetchIeltsPlusBatchSuccess: fetchIeltsPlusBatchSuccess,
    toggleUpcomigIeltsBatchModal: toggleUpcomigIeltsBatchModal,
    fetchUpcomingBatchPriceAndTimeSuccess: fetchUpcomingBatchPriceAndTimeSuccess,
    fetchUpcomingBatchPriceAndTime: fetchUpcomingBatchPriceAndTime,
    fetchIeltsBatches: fetchIeltsBatches,
    setAllIeltsBatches: setAllIeltsBatches,
    fetchBannerData: fetchBannerData,
    setBannerData: setBannerData,
    toggleOfferModal: toggleOfferModal,
    fetchPteBatches: fetchPteBatches,
    fetchDETBatches: fetchDETBatches
};


/***/ }),

/***/ 93306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KM": function() { return /* binding */ PrimaryButton; },
/* harmony export */   "O3": function() { return /* binding */ DangerButton; },
/* harmony export */   "Sn": function() { return /* binding */ StyledButton; },
/* harmony export */   "Sq": function() { return /* binding */ StyledButtonWithArrow; },
/* harmony export */   "kq": function() { return /* binding */ SecondaryButton; },
/* harmony export */   "se": function() { return /* binding */ SecondaryButtonWithIcon; }
/* harmony export */ });
/* unused harmony exports TertiaryButton, QuaternaryButton, ImageButton, FloatingButton, StyledButtonWithIcon */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);


var PrimaryButton = function(param) {
    var px = param.px, ctaText = param.ctaText, onClick = param.onClick, disabled = param.disabled, className = param.className, py = param.py;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        onClick: function(e) {
            if (!disabled) {
                onClick(e);
            }
        },
        className: "font-bold text-center rounded cursor-pointer ".concat(px ? px : "px-6", " ").concat(disabled ? "text-lightgray-600 bg-gray-1050 cursor-not-allowed" : "bg-primary text-white border-primary border", " ").concat(className ? className : "", " py-[14px] leading-[20px] shadow-[0px_3px_10px_-2px_rgba(28,34,51,0.12)] "),
        children: ctaText
    });
};
var DangerButton = function(param) {
    var px = param.px, ctaText = param.ctaText, onClick = param.onClick, disabled = param.disabled, className = param.className, py = param.py;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        onClick: onClick,
        className: "font-bold text-center shadow-11 ".concat(py ? py : "py-3", " rounded cursor-pointer ").concat(px ? px : "px-6", " ").concat(disabled ? "text-lightgray-600 bg-gray-1050 cursor-not-allowed" : "bg-red-400 text-white border-red-400 border", " ").concat(className ? className : ""),
        children: ctaText
    });
};
var SecondaryButton = function(param) {
    var px = param.px, py = param.py, ctaText = param.ctaText, onClick = param.onClick, className = param.className, disabled = param.disabled;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        onClick: onClick,
        className: "bg-white text-primary font-bold text-sm md:text-base text-center border border-primary rounded cursor-pointer ".concat(py ? py : "py-3", " ").concat(px ? px : "px-6", " ").concat(disabled ? "opacity-50" : "", " ").concat(className ? className : ""),
        children: ctaText
    });
};
var SecondaryButtonWithIcon = function(param) {
    var px = param.px, py = param.py, ctaText = param.ctaText, onClick = param.onClick, className = param.className, iconDimension = param.iconDimension, iconSrc = param.iconSrc, disabled = param.disabled;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        onClick: onClick,
        className: "bg-white text-primary border font-bold text-sm md:text-base text-center border-primary rounded cursor-pointer ".concat(py ? py : "py-3", " ").concat(px ? px : "px-6", " ").concat(disabled ? "opacity-50" : "", " ").concat(className ? className : ""),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex items-center justify-center",
            children: [
                ctaText,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "ml-1 flex items-center",
                    children: iconSrc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                        src: iconSrc,
                        width: iconDimension !== null && iconDimension !== void 0 ? iconDimension : 16,
                        height: iconDimension !== null && iconDimension !== void 0 ? iconDimension : 16,
                        alt: "single_tick"
                    })
                })
            ]
        })
    });
};
var TertiaryButton = function(param) {
    var px = param.px, ctaText = param.ctaText, href = param.href, onClick = param.onClick;
    return /*#__PURE__*/ _jsx("a", {
        onClick: onClick,
        target: "_blank",
        rel: "noopener noreferrer",
        href: href,
        className: "bg-primary text-white font-bold text-sm md:text-base text-center py-3 border border-primary rounded cursor-pointer ".concat(px ? px : "px-6"),
        children: ctaText
    });
};
var QuaternaryButton = function(param) {
    var px = param.px, ctaText = param.ctaText, href = param.href;
    return /*#__PURE__*/ _jsx("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        href: href,
        className: "bg-white text-primary font-bold text-sm md:text-base text-center py-3 border border-primary rounded cursor-pointer ".concat(px ? px : "px-6"),
        children: ctaText
    });
};
var ImageButton = function(param) {
    var image = param.image, _size = param.size, size = _size === void 0 ? "m" : _size, ctaText = param.ctaText, ctaAction = param.ctaAction, customCss = param.customCss;
    var imageSize = function() {
        switch(size){
            case "x":
                return "w-4";
            case "m":
                return "w-6";
            case "l":
                return "w-8";
        }
    };
    return /*#__PURE__*/ _jsx("button", {
        className: "my-2 md:my-4 w-full",
        onClick: ctaAction,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex justify-center items-center ".concat(customCss || "text-primary font-bold"),
            children: [
                image && /*#__PURE__*/ _jsx("img", {
                    src: image,
                    className: imageSize()
                }),
                /*#__PURE__*/ _jsx("span", {
                    className: "pl-2",
                    children: ctaText
                })
            ]
        })
    });
};
var FloatingButton = function(param) {
    var isVisible = param.isVisible, ctaAction = param.ctaAction, ctaText = param.ctaText, img = param.img, _positionX = param.positionX, positionX = _positionX === void 0 ? "right" : _positionX, _positionY = param.positionY, positionY = _positionY === void 0 ? "bottom" : _positionY, buttonCss = param.buttonCss, customCss = param.customCss, _zIndex = param.zIndex, zIndex = _zIndex === void 0 ? 2000 : _zIndex;
    var getPositionY = function() {
        if (positionY == "top") {
            return "top-0";
        } else {
            return "bottom-0";
        }
    };
    var getPositionX = function() {
        if (positionX === "left") {
            return "left-0";
        } else {
            return "right-0";
        }
    };
    if (isVisible) {
        return /*#__PURE__*/ _jsx("div", {
            className: [
                "fixed",
                getPositionX(),
                getPositionY(),
                "my-2 md:my-2", 
            ].join(" "),
            style: {
                zIndex: zIndex
            },
            children: /*#__PURE__*/ _jsx("div", {
                className: customCss,
                children: /*#__PURE__*/ _jsx("button", {
                    className: "my-2 w-full",
                    onClick: ctaAction,
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "flex justify-center items-center ".concat(buttonCss || "text-primary font-bold"),
                        children: [
                            img && /*#__PURE__*/ _jsx("img", {
                                src: img,
                                className: ""
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "pl-2",
                                children: ctaText
                            })
                        ]
                    })
                })
            })
        });
    } else {
        return null;
    }
};
var StyledButton = function(param) {
    var ctaText = param.ctaText, onClick = param.onClick, className = param.className, disabled = param.disabled, bRadius = param.bRadius, py = param.py, isCounNudge = param.isCounNudge;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        onClick: !disabled ? onClick : function() {},
        style: {
            background: disabled ? "#CDCDCD" : !isCounNudge ? "transparent linear-gradient(166deg, #E2A531 0%, #E26D30 100%) 0% 0% no-repeat padding-box" : "",
            boxShadow: "0px 1px 5px #9C27B01F",
            borderRadius: bRadius !== null && bRadius !== void 0 ? bRadius : "3px",
            opacity: 1
        },
        className: "px-3 ".concat(py !== null && py !== void 0 ? py : "py-1", " text-white font-bold text-sm md:text-base text-center  rounded cursor-pointer  ").concat(disabled ? "text-[#8E8E8E]" : "", " ").concat(className ? className : ""),
        disabled: disabled,
        children: ctaText
    });
};
var StyledButtonWithArrow = function(param) {
    var ctaText = param.ctaText, onClick = param.onClick, className = param.className, disabled = param.disabled, bRadius = param.bRadius, iconDimension = param.iconDimension, py = param.py;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        onClick: !disabled ? onClick : function() {},
        style: {
            background: "transparent linear-gradient(166deg, #E2A531 0%, #E26D30 100%) 0% 0% no-repeat padding-box",
            boxShadow: "0px 1px 5px #9C27B01F",
            borderRadius: bRadius !== null && bRadius !== void 0 ? bRadius : "3px",
            opacity: 1
        },
        className: "px-3 ".concat(py !== null && py !== void 0 ? py : "py-1", " text-white font-bold text-sm md:text-base text-center  rounded cursor-pointer  ").concat(disabled ? "opacity-50" : "", " ").concat(className ? className : ""),
        disabled: disabled,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex items-center",
            children: [
                ctaText,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "ml-1 flex items-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                        src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/arrow_right_long.svg"),
                        width: iconDimension !== null && iconDimension !== void 0 ? iconDimension : 16,
                        height: iconDimension !== null && iconDimension !== void 0 ? iconDimension : 16,
                        alt: "single_tick"
                    })
                })
            ]
        })
    });
};
var StyledButtonWithIcon = function(param) {
    var ctaText = param.ctaText, onClick = param.onClick, image = param.image, className = param.className, disabled = param.disabled, bRadius = param.bRadius, iconDimension = param.iconDimension, py = param.py;
    return /*#__PURE__*/ _jsx("button", {
        onClick: !disabled ? onClick : function() {},
        style: {
            background: disabled ? "grey" : "transparent linear-gradient(166deg, #E2A531 0%, #E26D30 100%) 0% 0% no-repeat padding-box",
            boxShadow: "0px 1px 5px #9C27B01F",
            borderRadius: bRadius !== null && bRadius !== void 0 ? bRadius : "3px",
            opacity: 1
        },
        className: "px-3 ".concat(py !== null && py !== void 0 ? py : "py-1", " text-white font-bold text-sm md:text-base text-center  rounded cursor-pointer  ").concat(disabled ? "opacity-50" : "", " ").concat(className ? className : ""),
        disabled: disabled,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex items-center",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "mr-1 flex items-center",
                    children: /*#__PURE__*/ _jsx(Image, {
                        src: image !== null && image !== void 0 ? image : "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/arrow_right_long.svg"),
                        width: iconDimension !== null && iconDimension !== void 0 ? iconDimension : 16,
                        height: iconDimension !== null && iconDimension !== void 0 ? iconDimension : 16,
                        alt: "single_tick"
                    })
                }),
                ctaText
            ]
        })
    });
};


/***/ }),

/***/ 3569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66089);
/* harmony import */ var next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_datepicker__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9198);
/* harmony import */ var react_datepicker__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_datepicker__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_datepicker_dist_react_datepicker_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18698);
/* harmony import */ var react_datepicker_dist_react_datepicker_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_datepicker_dist_react_datepicker_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61436);






var DatePickerComponent = function(param) {
    var input = param.input, placeholder = param.placeholder, meta = param.meta, customDatePickerCss = param.customDatePickerCss, _showDatePickerIcon = param.showDatePickerIcon, showDatePickerIcon = _showDatePickerIcon === void 0 ? false : _showDatePickerIcon;
    var datePickerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var hasError = meta && meta.touched && meta.error;
    var toggleCalendar = function() {
        if (datePickerRef && datePickerRef.current) {
            datePickerRef.current.setOpen(true);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
            [
                "3e949ab0ac7a5830",
                [
                    hasError ? "#FF695B" : "#d1d5db"
                ]
            ]
        ]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                onClick: toggleCalendar,
                className: next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                    [
                        "3e949ab0ac7a5830",
                        [
                            hasError ? "#FF695B" : "#d1d5db"
                        ]
                    ]
                ]) + " " + "flex justify-between date_container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_datepicker__WEBPACK_IMPORTED_MODULE_4___default()), {
                        locale: "en",
                        ref: datePickerRef,
                        placeholderText: placeholder,
                        className: customDatePickerCss,
                        dateFormat: "dd-MM-yyyy",
                        selected: input.value,
                        disabledKeyboardNavigation: true,
                        onChange: function(date) {
                            if ((0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(date)) {
                                input.onChange(new Date(date));
                            } else {
                                input.onChange(null);
                            }
                        },
                        onBlur: input.onBlur,
                        onFocus: input.onFocus
                    }),
                    showDatePickerIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/blue_calendar.svg"),
                        alt: "calendar",
                        style: {
                            cursor: "pointer"
                        },
                        className: next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                            [
                                "3e949ab0ac7a5830",
                                [
                                    hasError ? "#FF695B" : "#d1d5db"
                                ]
                            ]
                        ])
                    })
                ]
            }),
            hasError && !meta.active && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                    [
                        "3e949ab0ac7a5830",
                        [
                            hasError ? "#FF695B" : "#d1d5db"
                        ]
                    ]
                ]) + " " + "mt-1 text-xs text-red-600",
                children: meta.error
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "3e949ab0ac7a5830",
                dynamic: [
                    hasError ? "#FF695B" : "#d1d5db"
                ],
                children: ".date_container.__jsx-style-dynamic-selector{border:solid 1px ".concat(hasError ? "#FF695B" : "#d1d5db", ";-webkit-border-radius:6px;-moz-border-radius:6px;border-radius:6px;padding:12px;color:#616161;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;background-color:#fff}date_container.__jsx-style-dynamic-selector:focus{-webkit-box-shadow:0px 2px 4px rgba(130,136,148,.16),0px 0px 1px rgba(130,136,148,.16);-moz-box-shadow:0px 2px 4px rgba(130,136,148,.16),0px 0px 1px rgba(130,136,148,.16);box-shadow:0px 2px 4px rgba(130,136,148,.16),0px 0px 1px rgba(130,136,148,.16);border-color:#443eff}input.__jsx-style-dynamic-selector::-webkit-input-placeholder{color:#616161;opacity:1}input.__jsx-style-dynamic-selector:-moz-placeholder{color:#616161;opacity:1}input.__jsx-style-dynamic-selector::-moz-placeholder{color:#616161;opacity:1}input.__jsx-style-dynamic-selector:-ms-input-placeholder{color:#616161;opacity:1}input.__jsx-style-dynamic-selector::-ms-input-placeholder{color:#616161;opacity:1}input.__jsx-style-dynamic-selector::placeholder{color:#616161;opacity:1}")
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DatePickerComponent);


/***/ }),

/***/ 9710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_dropzone__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21582);





var Dropzone = function(param) {
    var onChange = param.onChange, onError = param.onError, enabled = param.enabled, children = param.children, essayEvaluationDrop = param.essayEvaluationDrop, _multipleUpload = param.multipleUpload, multipleUpload = _multipleUpload === void 0 ? true : _multipleUpload, fileType = param.fileType;
    var onDrop = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(acceptedFiles) {
        console.log("acceptedFiles = ", acceptedFiles);
        var file = acceptedFiles[0];
        if (!file) {
            onError({
                name: "InvalidFileException",
                message: essayEvaluationDrop ? "Invalid file format. Only jpg, png, pdf or doc are allowed" : "Invalid file format. Only jpg, png or pdf are allowed"
            });
            return;
        }
        if (file.size > 20000000) {
            onError({
                name: "FileSizeException",
                message: "File size should be less than 20mb"
            });
            return;
        }
        onChange(file);
    }, []);
    var ref = (0,react_dropzone__WEBPACK_IMPORTED_MODULE_2__/* .useDropzone */ .u)({
        onDrop: onDrop,
        accept: essayEvaluationDrop ? "application/pdf, image/jpeg application/docx, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, image/png, .jpg" : fileType ? ".".concat(fileType) : "text/csv, .csv, .xlsx, .png, .jpg, .docx, .doc, .pdf, application/pdf, image/jpeg, image/png",
        multiple: multipleUpload
    }), getRootProps = ref.getRootProps, getInputProps = ref.getInputProps, isDragActive = ref.isDragActive;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, getRootProps()), {
            children: [
                enabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, getInputProps())),
                children(isDragActive)
            ]
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Dropzone);


/***/ }),

/***/ 25778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var RadioButton = function(param) {
    var options = param.options, input = param.input, meta = param.meta, containerCss = param.containerCss, inActiveCss = param.inActiveCss, activeCss = param.activeCss;
    var hasError = meta && meta.touched && meta.error;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat(containerCss !== null && containerCss !== void 0 ? containerCss : "flex justify-between gap-4"),
                children: options.map(function(option) {
                    var label = option.label, icon = option.icon, value = option.value, subLabel = option.subLabel;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                        type: "button",
                        onFocus: function() {
                            if (input) {
                                input.onFocus();
                            }
                        },
                        onBlur: function() {
                            if (input) {
                                input.onBlur();
                            }
                        },
                        onClick: function() {
                            if (input) {
                                input.onChange(value);
                            }
                        },
                        className: "w-full border py-4 ".concat(input && input.value === value ? activeCss !== null && activeCss !== void 0 ? activeCss : "border-[#736EFF] text-[#443EFF] bg-[#E3E2FF]" : inActiveCss !== null && inActiveCss !== void 0 ? inActiveCss : "border-[#DBDBDB] text-[#686868]", " rounded-[8px]"),
                        children: [
                            icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                className: "w-9 h-6 pb-1",
                                src: icon
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: label
                            }),
                            subLabel && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "mt-2 text-xs",
                                children: subLabel
                            })
                        ]
                    }, "option-".concat(value));
                })
            }),
            hasError && !meta.active && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "w-full mt-2 text-xs text-red-600",
                children: meta.error
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RadioButton);


/***/ }),

/***/ 28069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var components_common_Spinner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70231);
/* harmony import */ var service_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14117);
/* harmony import */ var components_Inputs_Dropzone__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9710);
/* harmony import */ var public_static_scss_FileUpload_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87990);
/* harmony import */ var public_static_scss_FileUpload_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(public_static_scss_FileUpload_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var utils_string_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44827);
/* harmony import */ var scripts_segment__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83697);
/* harmony import */ var utils_events_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42477);













var SingleUpload = function(param) {
    var input = param.input, meta = param.meta, label = param.label, fileType = param.fileType;
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), error = ref2[0], setError = ref2[1];
    var ctaZeroFilesText = "Select file";
    var ctaUploadedFilesText = "Replace file";
    var ctaText = (input === null || input === void 0 ? void 0 : input.value) ? ctaUploadedFilesText : ctaZeroFilesText;
    var _fileUrl = input === null || input === void 0 ? void 0 : (ref = input.value) === null || ref === void 0 ? void 0 : ref.url;
    var generatedFileName = (0,utils_string_utils__WEBPACK_IMPORTED_MODULE_8__/* .getFilename */ .vt)(_fileUrl || "");
    var getFileCategory = function() {
        if ((input === null || input === void 0 ? void 0 : input.name) == "CONSOLIDATED_PASSPORT") {
            return "Passport";
        } else if ((input === null || input === void 0 ? void 0 : input.name) == "WORK_EX" || (input === null || input === void 0 ? void 0 : input.name) == "COUNSELING_OTHER" || (input === null || input === void 0 ? void 0 : input.name) == "RESUME") {
            return "Other Documents";
        } else {
            return "Educational Documents";
        }
    };
    var getFileName = function() {
        if ((input === null || input === void 0 ? void 0 : input.name) == "TENTH_MARK_SHEET" || (input === null || input === void 0 ? void 0 : input.name) == "TWELFTH_MARK_SHEET" || (input === null || input === void 0 ? void 0 : input.name) == "COUNSELING_OTHER") {
            return label;
        } else if (input === null || input === void 0 ? void 0 : input.name.includes("SEM_MARK_SHEET")) {
            return "Semester ".concat(parseInt(label), " Marksheet");
        } else if ((input === null || input === void 0 ? void 0 : input.name) == "CONSOLIDATED_PASSPORT") {
            return "Passport";
        } else if ((input === null || input === void 0 ? void 0 : input.name) == "UG_CONSOLIDATED_MARK_SHEET") {
            return "Consolidated UG Marksheet";
        } else if ((input === null || input === void 0 ? void 0 : input.name) == "PG_CONSOLIDATED_MARK_SHEET") {
            return "Consolidate PG Marksheet";
        } else if ((input === null || input === void 0 ? void 0 : input.name) == "IELTS_SCORE_CARD") {
            return "IELTS Score Card";
        }
    };
    var handleUpload = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(file) {
            var formData, res, trackPayload;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        formData = new FormData();
                        formData.append("file", file);
                        _ctx.next = 5;
                        return service_api__WEBPACK_IMPORTED_MODULE_4__/* ["default"].post */ .Z.post("/api/upload?name=".concat(input.name), formData, {
                            headers: {
                                "Content-Type": "multipart/form-data"
                            }
                        });
                    case 5:
                        res = _ctx.sent;
                        if (!res.data.success) {
                            _ctx.next = 10;
                            break;
                        }
                        trackPayload = {
                            fileType: (file === null || file === void 0 ? void 0 : file.type) || "NA",
                            fileCategory: getFileCategory() || "NA",
                            fileName: getFileName() || "NA"
                        };
                        (0,scripts_segment__WEBPACK_IMPORTED_MODULE_6__.trackFileUpload)(utils_events_utils__WEBPACK_IMPORTED_MODULE_7__.pageName.Application_Document_Page, trackPayload);
                        return _ctx.abrupt("return", res.data.data);
                    case 10:
                        _ctx.next = 15;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        console.log(_ctx.t0);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function handleUpload(file) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleError = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(error) {
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setError(error.message);
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleError(error) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChange = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(file) {
            var fileObject, url;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setError(null);
                        setLoading(true);
                        input.onFocus();
                        fileObject = {
                            name: file.name,
                            size: file.size
                        };
                        _ctx.next = 6;
                        return handleUpload(file);
                    case 6:
                        url = _ctx.sent;
                        setLoading(false);
                        input.onChange((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, input.value, fileObject), {
                            url: url
                        }));
                        input.onBlur();
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleChange(file) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Inputs_Dropzone__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                enabled: true,
                onChange: handleChange,
                onError: handleError,
                fileType: fileType,
                children: function(isDragActive) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "rounded-6 border border-lightgray-950 p-3 cursor-pointer w-full bg-white border-dashed ".concat(isDragActive && "bg-gray-300", " ").concat(meta.touched && meta.error || error ? "border-red-600" : "border-gray-400"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "flex justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "".concat((public_static_scss_FileUpload_module_scss__WEBPACK_IMPORTED_MODULE_12___default().fileUploadLabel), " text-normal text-yellow-400 mt-1 max-w-180 md:max-w-300 flex ").concat(input.value && "text-green-200 ".concat((public_static_scss_FileUpload_module_scss__WEBPACK_IMPORTED_MODULE_12___default().active)) || true, " ").concat(loading && "text-green-200 ".concat((public_static_scss_FileUpload_module_scss__WEBPACK_IMPORTED_MODULE_12___default().loading)), " ").concat((meta.touched && meta.error || error) && "text-red-600 ".concat((public_static_scss_FileUpload_module_scss__WEBPACK_IMPORTED_MODULE_12___default().error))),
                                    children: [
                                        loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: (public_static_scss_FileUpload_module_scss__WEBPACK_IMPORTED_MODULE_12___default().spinnerHolder),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Spinner__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                size: "small"
                                            })
                                        }),
                                        label
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: (public_static_scss_FileUpload_module_scss__WEBPACK_IMPORTED_MODULE_12___default().uploadRightSection),
                                    children: [
                                        generatedFileName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: (public_static_scss_FileUpload_module_scss__WEBPACK_IMPORTED_MODULE_12___default().filename),
                                            children: generatedFileName
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: (public_static_scss_FileUpload_module_scss__WEBPACK_IMPORTED_MODULE_12___default().fileUploadCta),
                                            children: ctaText
                                        })
                                    ]
                                })
                            ]
                        })
                    });
                }
            }),
            meta.touched && meta.error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                className: "text-xs text-red-600",
                children: meta.error
            }),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                className: "text-xs text-red-600",
                children: error
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SingleUpload);


/***/ }),

/***/ 11281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HI": function() { return /* binding */ getWeeklyScheduleOfBatch; },
/* harmony export */   "gB": function() { return /* binding */ isPlusBatch; },
/* harmony export */   "yF": function() { return /* binding */ getThreeDatesWhichHasBatches; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93957);


var isPlusBatch = function(batchData) {
    return batchData.pricingBundleName === DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .priceBundleName.IELTS_PLUS */ .F.IELTS_PLUS;
};
var getThreeDatesWhichHasBatches = function(batches) {
    var datesWithBatchesObject = batches.reduce(function(prevObject, batchData) {
        var startDate = new Date(batchData.startDate).toLocaleDateString();
        if (startDate in prevObject) {
            prevObject[startDate].push(batchData);
        } else prevObject[startDate] = [
            batchData
        ];
        return prevObject;
    }, {});
    var threeDates = [];
    var currentDate = {
        dateObj: new Date(),
        dateNow: Date.now()
    };
    var i = 0;
    while(threeDates.length <= 3 && i < 1000){
        if (datesWithBatchesObject[currentDate.dateObj.toLocaleDateString()] && datesWithBatchesObject[currentDate.dateObj.toLocaleDateString()].length > 0) {
            threeDates.push({
                dateString: currentDate.dateObj.toLocaleDateString(),
                dateObject: currentDate.dateObj
            });
        }
        currentDate.dateObj = new Date(currentDate.dateNow + 24 * 60 * 60 * 1000);
        currentDate.dateNow = currentDate.dateNow + 24 * 60 * 60 * 1000;
        i++;
    }
    return {
        datesWithBatchesObject: datesWithBatchesObject,
        threeDates: threeDates
    };
};
var getWeeklyScheduleOfBatch = function(batchData) {
    var ref;
    var daysWithNumbers = {
        Sunday: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6
    };
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((batchData === null || batchData === void 0 ? void 0 : (ref = batchData.weeklySchedule) === null || ref === void 0 ? void 0 : ref.split("-")) || [], 2), firstDayInWeeklySchedule = ref1[0], lastDayInWeeklySchedule = ref1[1];
    firstDayInWeeklySchedule = daysWithNumbers[firstDayInWeeklySchedule];
    lastDayInWeeklySchedule = daysWithNumbers[lastDayInWeeklySchedule];
    var schedule = [];
    for(var key in daysWithNumbers){
        if (daysWithNumbers[key] >= firstDayInWeeklySchedule && daysWithNumbers[key] <= lastDayInWeeklySchedule) {
            schedule.push(key);
        }
    }
    return schedule;
};


/***/ }),

/***/ 69117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CV": function() { return /* binding */ getStudentTestimonialsForCountryPage; },
/* harmony export */   "EY": function() { return /* binding */ getEventsOnServerSide; },
/* harmony export */   "KU": function() { return /* binding */ getI2CEligibilityForMeet; },
/* harmony export */   "Nt": function() { return /* binding */ getI2CBlogsFromCMS; },
/* harmony export */   "P5": function() { return /* binding */ getFormJsonByFormId; },
/* harmony export */   "SM": function() { return /* binding */ getI2CSlidersFromCMS; },
/* harmony export */   "ZG": function() { return /* binding */ getI2CMainBannerFromCMS; },
/* harmony export */   "ZY": function() { return /* binding */ checkIfMefuUser; },
/* harmony export */   "e0": function() { return /* binding */ checkIfIeltsApp; },
/* harmony export */   "k4": function() { return /* binding */ getI2CMOfferingsFromCMS; },
/* harmony export */   "n0": function() { return /* binding */ getSingleEventOnServerSide; },
/* harmony export */   "o9": function() { return /* binding */ getCountryEventsData; },
/* harmony export */   "oO": function() { return /* binding */ getFormJsonByFormIdCms; },
/* harmony export */   "wy": function() { return /* binding */ getI2CSlotsForMeet; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var service_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14117);
/* harmony import */ var lib_auth_cookies_new__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89208);
/* harmony import */ var utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51119);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6154);







var checkIfPrivateEvent = function(tags) {
    var tagNames = tags.map(function(item) {
        var ref;
        return item === null || item === void 0 ? void 0 : (ref = item.tag) === null || ref === void 0 ? void 0 : ref.Name;
    });
    return tagNames.includes("PRIVATE_EVENT");
};
var getEventsOnServerSide = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(isServer) {
        var url, upcomingEvents, finalData, ref, ref1, eventsSlug, apiEventsData, slugObj, newSlugArray, queryParam, eventsStaticData, eventStaticDataArray, i, j, ref2, ref3, data;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    url = "";
                    if (isServer) {
                        url = "".concat("https://api.leapscholar.com", "/event/upcoming/30");
                    } else {
                        url = "/api/scholarRoute?path=event/upcoming/30";
                    }
                    _ctx.next = 4;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(url);
                case 4:
                    upcomingEvents = _ctx.sent;
                    finalData = [];
                    if (!upcomingEvents.data.success) {
                        _ctx.next = 24;
                        break;
                    }
                    ;
                    if (!(upcomingEvents === null || upcomingEvents === void 0 ? void 0 : (ref = upcomingEvents.data) === null || ref === void 0 ? void 0 : ref.data)) {
                        _ctx.next = 24;
                        break;
                    }
                    ;
                    eventsSlug = [];
                    apiEventsData = [];
                    upcomingEvents === null || upcomingEvents === void 0 ? void 0 : (ref1 = upcomingEvents.data) === null || ref1 === void 0 ? void 0 : ref1.data.forEach(function(elem) {
                        if (elem.slots) {
                            elem.slots.forEach(function(data) {
                                if (data.slug) {
                                    eventsSlug.push(data.slug);
                                    apiEventsData.push(data);
                                }
                            });
                        }
                    });
                    slugObj = {};
                    eventsSlug.forEach(function(elen) {
                        if (!slugObj[elen]) {
                            slugObj[elen] = 1;
                        }
                    });
                    newSlugArray = Object.keys(slugObj);
                    if (!(newSlugArray.length === 0)) {
                        _ctx.next = 18;
                        break;
                    }
                    throw Error("No events present");
                case 18:
                    queryParam = newSlugArray.reduce(function(acc, curr, index) {
                        acc += "slug_in=".concat(curr).concat(newSlugArray.length - 1 === index ? "" : "&");
                        return acc;
                    }, "?");
                    _ctx.next = 21;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("".concat("https://cms.leapscholar.com", "/events").concat(queryParam));
                case 21:
                    eventsStaticData = _ctx.sent;
                    eventStaticDataArray = eventsStaticData === null || eventsStaticData === void 0 ? void 0 : eventsStaticData.data;
                    if ((apiEventsData === null || apiEventsData === void 0 ? void 0 : apiEventsData.length) > 0 && eventStaticDataArray.length > 0) {
                        for(i = 0; i < apiEventsData.length; i++){
                            for(j = 0; j < eventStaticDataArray.length; j++){
                                ;
                                if (((ref2 = eventStaticDataArray[j]) === null || ref2 === void 0 ? void 0 : ref2.slug) == ((ref3 = apiEventsData[i]) === null || ref3 === void 0 ? void 0 : ref3.slug)) {
                                    data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, eventStaticDataArray[j], apiEventsData[i]);
                                    finalData.push(data);
                                }
                            }
                        }
                    }
                case 24:
                    finalData = finalData.filter(function(event) {
                        return !checkIfPrivateEvent(event === null || event === void 0 ? void 0 : event.event_tags_v2);
                    });
                    return _ctx.abrupt("return", finalData);
                case 26:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getEventsOnServerSide(isServer) {
        return _ref.apply(this, arguments);
    };
}();
var getCountryEventsData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(country, isServer) {
        var eventsData, sortedDetails, sortedData, filteredCountryEvents;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getEventsOnServerSide(isServer);
                case 3:
                    eventsData = _ctx.sent;
                    sortedDetails = function() {
                        return eventsData.sort(function(a, b) {
                            return new Date(a.date) - new Date(b.date);
                        });
                    };
                    sortedData = sortedDetails();
                    filteredCountryEvents = sortedData.filter(function(item) {
                        var eventTags = item.event_tags_v2;
                        for(var i = 0; i < eventTags.length; i++){
                            var ref, ref1;
                            if (((ref = eventTags[i].tag) === null || ref === void 0 ? void 0 : ref.type) === "country" && ((ref1 = eventTags[i].tag) === null || ref1 === void 0 ? void 0 : ref1.Name) === country) {
                                return true;
                            }
                        }
                        return false;
                    });
                    if (!(filteredCountryEvents.length >= 3)) {
                        _ctx.next = 11;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        events: filteredCountryEvents.slice(0, 3)
                    });
                case 11:
                    return _ctx.abrupt("return", {
                        events: filteredCountryEvents
                    });
                case 12:
                    _ctx.next = 17;
                    break;
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        events: []
                    });
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                14
            ]
        ]);
    }));
    return function getCountryEventsData(country, isServer) {
        return _ref.apply(this, arguments);
    };
}();
var getStudentTestimonialsForCountryPage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(country) {
        var ref, reviews, finalData;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("".concat("https://cms.leapscholar.com", "/reviews?platform_eq=SCHOLAR&type_eq=Testimonial&country_null=false&country_eq=").concat(country));
                case 3:
                    ref = _ctx.sent;
                    reviews = ref.data;
                    finalData = reviews.map(function(el) {
                        var ref;
                        var studentInfo = "";
                        if (el.Name) {
                            var ref1;
                            studentInfo = (ref1 = el.Name) === null || ref1 === void 0 ? void 0 : ref1.split(",");
                        }
                        return {
                            rating: el.rating,
                            name: studentInfo[0] || "",
                            image: (ref = el.user_image) === null || ref === void 0 ? void 0 : ref.url,
                            college: studentInfo[1] || "",
                            reviews: el.review
                        };
                    }).filter(function(el) {
                        if (!!(el.name && el.reviews)) return true;
                        return false;
                    });
                    if (!(finalData.length > 4)) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        reviews: finalData.slice(0, 4)
                    });
                case 10:
                    return _ctx.abrupt("return", {
                        reviews: finalData
                    });
                case 11:
                    _ctx.next = 16;
                    break;
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        reviews: []
                    });
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }));
    return function getStudentTestimonialsForCountryPage(country) {
        return _ref.apply(this, arguments);
    };
}();
var getSingleEventOnServerSide = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(eventId, isServer) {
        var url, eventData, ref, apiData, ref1, CMS_URL, res2, cmsData, eventData1;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    url = "";
                    if (isServer) {
                        url = "".concat("https://api.leapscholar.com", "/event/details/").concat(eventId);
                    } else {
                        url = "/api/scholarRoute?path=event/details/".concat(eventId);
                    }
                    _ctx.next = 4;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(url);
                case 4:
                    eventData = _ctx.sent;
                    if (!eventData.data.success) {
                        _ctx.next = 18;
                        break;
                    }
                    ;
                    apiData = eventData === null || eventData === void 0 ? void 0 : (ref = eventData.data) === null || ref === void 0 ? void 0 : ref.data;
                    if (!apiData) {
                        _ctx.next = 18;
                        break;
                    }
                    ;
                    CMS_URL = "https://cms.leapscholar.com" || 0;
                    _ctx.next = 13;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(CMS_URL + "/events?slug=".concat(apiData === null || apiData === void 0 ? void 0 : apiData.slug));
                case 13:
                    res2 = _ctx.sent;
                    cmsData = (ref1 = res2.data) === null || ref1 === void 0 ? void 0 : ref1[0];
                    if (!cmsData) {
                        _ctx.next = 18;
                        break;
                    }
                    eventData1 = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, apiData, cmsData);
                    return _ctx.abrupt("return", eventData1);
                case 18:
                    return _ctx.abrupt("return", {});
                case 19:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSingleEventOnServerSide(eventId, isServer) {
        return _ref.apply(this, arguments);
    };
}();
var getI2CBlogsFromCMS = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, blogs;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("".concat("https://cms.leapscholar.com", "/banners?type=i2c_blog"));
                case 3:
                    ref = _ctx.sent;
                    blogs = ref.data;
                    return _ctx.abrupt("return", blogs);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        blogs: []
                    });
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function getI2CBlogsFromCMS() {
        return _ref.apply(this, arguments);
    };
}();
var getI2CSlidersFromCMS = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, sliders;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("".concat("https://cms.leapscholar.com", "/banners?type=i2c_sliders"));
                case 3:
                    ref = _ctx.sent;
                    sliders = ref.data;
                    return _ctx.abrupt("return", sliders);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        blogs: []
                    });
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function getI2CSlidersFromCMS() {
        return _ref.apply(this, arguments);
    };
}();
var getI2CSlotsForMeet = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(ctx, isServer) {
        var accessToken, url, data;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    accessToken = (0,lib_auth_cookies_new__WEBPACK_IMPORTED_MODULE_2__/* .getTokenCookie */ .r_)(ctx);
                    _ctx.prev = 1;
                    url = "";
                    if (isServer) {
                        url = "".concat("https://api.leapscholar.com", "/counselling/slots/live/30");
                    } else {
                        url = "/api/scholarRoute?path=counselling/slots/live/30";
                    }
                    _ctx.next = 6;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(url, {
                        headers: {
                            Authorization: "Bearer ".concat(accessToken)
                        }
                    });
                case 6:
                    data = _ctx.sent.data;
                    if (!(data === null || data === void 0 ? void 0 : data.success)) {
                        _ctx.next = 11;
                        break;
                    }
                    return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : data.data);
                case 11:
                    return _ctx.abrupt("return", {});
                case 12:
                    _ctx.next = 17;
                    break;
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](1);
                    return _ctx.abrupt("return", {
                        slots: {}
                    });
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                14
            ]
        ]);
    }));
    return function getI2CSlotsForMeet(ctx, isServer) {
        return _ref.apply(this, arguments);
    };
}();
var getI2CEligibilityForMeet = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(ctx, isServer) {
        var accessToken, url, data;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    accessToken = (0,lib_auth_cookies_new__WEBPACK_IMPORTED_MODULE_2__/* .getTokenCookie */ .r_)(ctx);
                    _ctx.prev = 1;
                    url = "";
                    if (isServer) {
                        url = "".concat("https://api.leapscholar.com", "/student/eligibility");
                    } else {
                        url = "/api/scholarRoute?path=student/eligibility";
                    }
                    _ctx.next = 6;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(url, {
                        headers: {
                            Authorization: "Bearer ".concat(accessToken)
                        }
                    });
                case 6:
                    data = _ctx.sent.data;
                    if (!(data === null || data === void 0 ? void 0 : data.success)) {
                        _ctx.next = 11;
                        break;
                    }
                    return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : data.data);
                case 11:
                    return _ctx.abrupt("return", null);
                case 12:
                    _ctx.next = 17;
                    break;
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](1);
                    return _ctx.abrupt("return", {
                        eligibility: null
                    });
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                14
            ]
        ]);
    }));
    return function getI2CEligibilityForMeet(ctx, isServer) {
        return _ref.apply(this, arguments);
    };
}();
var getI2CMainBannerFromCMS = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, mainBanner;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("".concat("https://cms.leapscholar.com", "/banners?type=i2c_main"));
                case 3:
                    ref = _ctx.sent;
                    mainBanner = ref.data;
                    return _ctx.abrupt("return", mainBanner);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        mainBanner: []
                    });
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function getI2CMainBannerFromCMS() {
        return _ref.apply(this, arguments);
    };
}();
var getI2CMOfferingsFromCMS = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, offerings;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("".concat("https://cms.leapscholar.com", "/banners?type=offerings"));
                case 3:
                    ref = _ctx.sent;
                    offerings = ref.data;
                    return _ctx.abrupt("return", offerings);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        offerings: []
                    });
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function getI2CMOfferingsFromCMS() {
        return _ref.apply(this, arguments);
    };
}();
var checkIfIeltsApp = function() {
    var platformCookie = (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_3__/* .getCookie */ .ej)(null, "platform");
    return platformCookie === "mweb";
};
var checkIfMefuUser = function() {
    var mefuCookie = (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_3__/* .getCookie */ .ej)(null, "mefu_user");
    if (!mefuCookie) return null;
    console.log(mefuCookie);
    return mefuCookie == "true" ? "true" : "false";
};
var getFormJsonByFormId = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(formId, isServer) {
        var url, ref, ref1, res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    url = "";
                    if (isServer) {
                        url = "".concat("https://api.leapscholar.com", "/internal-profile/dynamic/tofu/form/").concat(formId);
                    } else {
                        url = "/api/scholarRoute?path=internal-profile/dynamic/tofu/form/".concat(formId);
                    }
                    _ctx.prev = 2;
                    ;
                    _ctx.next = 6;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(url);
                case 6:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", {
                        data: res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.formJson
                    });
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](2);
                    return _ctx.abrupt("return", {
                        data: {}
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                10
            ]
        ]);
    }));
    return function getFormJsonByFormId(formId, isServer) {
        return _ref.apply(this, arguments);
    };
}();
var getFormJsonByFormIdCms = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var url, res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    url = "".concat("https://cms.leapscholar.com", "/partial-form-data");
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return axios__WEBPACK_IMPORTED_MODULE_6__/* ["default"].get */ .Z.get(url);
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](1);
                    return _ctx.abrupt("return", {
                        data: {
                            formJson: {},
                            cta: "Check Admit Eligibility",
                            headingLineOne: "Craft Your",
                            headingLineTwo: "Study Abroad Journey"
                        }
                    });
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                8
            ]
        ]);
    }));
    return function getFormJsonByFormIdCms() {
        return _ref.apply(this, arguments);
    };
}();



/***/ }),

/***/ 85456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ loginApis; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./service/api.ts + 1 modules
var api = __webpack_require__(14117);
// EXTERNAL MODULE: ./utils/cookie-utiils.ts
var cookie_utiils = __webpack_require__(51119);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./utils/utm_utils.ts
var utm_utils = __webpack_require__(86147);
;// CONCATENATED MODULE: ./utils/helperFunctionUtils.ts





var captureAndSaveUtmWhileLoginIn = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var pathName, getDefaultUtmValues, urlParams, utmParamsMap, utmData, defaultUtmValues;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    pathName = window.location.pathname || "";
                    getDefaultUtmValues = function() {
                        try {
                            var previousPageUrl = document.referrer || "";
                            if (previousPageUrl === null || previousPageUrl === void 0 ? void 0 : previousPageUrl.includes("".concat("https://leapscholar.com", "/blog"))) {
                                return {
                                    utmMedium: "Blogs",
                                    utmSource: (previousPageUrl === null || previousPageUrl === void 0 ? void 0 : previousPageUrl.includes("ielts")) ? "IELTS_SEO" : "Counselling_SEO",
                                    utmCampaign: (previousPageUrl === null || previousPageUrl === void 0 ? void 0 : previousPageUrl.includes("ielts")) ? "IELTS_Blog" : "Counselling_Blog",
                                    utmTerm: previousPageUrl
                                };
                            }
                            if (pathName === "/") {
                                return {
                                    utmMedium: "Homepage",
                                    utmSource: "Direct",
                                    utmCampaign: "Direct",
                                    utmTerm: "".concat("https://leapscholar.com").concat(pathName)
                                };
                            }
                            if (previousPageUrl === null || previousPageUrl === void 0 ? void 0 : previousPageUrl.includes("".concat("https://leapscholar.com", "/exams"))) {
                                var utmCampaign = "General_Pages";
                                var pageTypes = {
                                    "/ielts/practice-test/speaking": "Speaking_Pages",
                                    "/ielts/practice-test/reading": "Reading_Pages",
                                    "/ielts/practice-test/writing": "Writing_Pages",
                                    "/ielts/practice-test/listening": "Listening_Pages",
                                    "/exams/gre": "Gre",
                                    "/exams/toefl": "Toefl",
                                    "/exams/pte": "Pte",
                                    "/exams/gmat": "Gmat",
                                    "/exams/duolingo": "Duolingo",
                                    "/exams/sat": "Sat"
                                };
                                Object.entries(pageTypes).forEach(function(param) {
                                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), path = _param[0], campaign = _param[1];
                                    if (previousPageUrl.includes(path)) {
                                        utmCampaign = campaign;
                                    }
                                });
                                var isExamPage = [
                                    "/exams/toefl",
                                    "/exams/gre",
                                    "/exams/pte",
                                    "/exams/gmat",
                                    "/exams/duolingo",
                                    "/exams/sat", 
                                ];
                                var matchesPattern = isExamPage.some(function(pattern) {
                                    return previousPageUrl.includes("".concat("https://leapscholar.com").concat(pattern));
                                });
                                return {
                                    utmCampaign: utmCampaign,
                                    utmSource: matchesPattern ? "Other_Exams_SEO" : "IELTS_SEO",
                                    utmMedium: "Pillar_Pages",
                                    utmTerm: previousPageUrl
                                };
                            }
                            return {};
                        } catch (err) {
                            console.error(err);
                            return {};
                        }
                    };
                    try {
                        urlParams = new URLSearchParams(window.location.search);
                        utmParamsMap = {
                            utm_source: "utmSource",
                            utm_medium: "utmMedium",
                            utm_campaign: "utmCampaign",
                            utm_term: "utmTerm"
                        };
                        utmData = {};
                        Object.keys(utmParamsMap).forEach(function(param) {
                            var value = urlParams.get(param);
                            if (value !== null) {
                                utmData[utmParamsMap[param]] = value;
                            }
                        });
                        defaultUtmValues = getDefaultUtmValues();
                        Object.entries(defaultUtmValues).forEach(function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                            if (!utmData[key]) utmData[key] = value;
                        });
                        if (Object.keys(utmData).length > 0) {
                            (0,utm_utils/* saveUtmData */.G)({}, (0,_object_spread/* default */.Z)({}, utmData));
                        }
                    } catch (err) {
                        console.error(err);
                    }
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function captureAndSaveUtmWhileLoginIn() {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./components/Login/LoginApis.ts





var generateOtp = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(countryCode, country, phone, whatsAppConsent) {
        var appName, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    appName = "leap_scholar";
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return api/* default.post */.Z.post("/api/auth?path=otp/generate/".concat(appName, "/%2B").concat(countryCode).concat(phone, "/&nocache=").concat(new Date().getTime(), "&isWebRequest=", true, "&whatsappConsent=").concat(whatsAppConsent), null, {
                        params: {
                            country_code: country
                        }
                    });
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](1);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return", _ctx.t0);
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                8
            ]
        ]);
    }));
    return function generateOtp(countryCode, country, phone, whatsAppConsent) {
        return _ref.apply(this, arguments);
    };
}();
var validateOtp = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(corelationId, otp, whatsAppConsent, country) {
        var appName, ref, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    appName = "leap_scholar";
                    _ctx.prev = 1;
                    ;
                    _ctx.next = 5;
                    return api/* default.post */.Z.post("/api/auth?path=otp/validate/".concat(appName, "/").concat(corelationId, "/").concat(otp, "/").concat(whatsAppConsent, "&nocache=").concat(new Date().getTime(), "&isWebRequest=", true), null, {
                        params: {
                            country_code: country
                        }
                    });
                case 5:
                    res = _ctx.sent;
                    if (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success) {
                        localStorage.setItem("userDataCollectedByChatBot", "true");
                    }
                    return _ctx.abrupt("return", res.data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](1);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return", _ctx.t0);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                10
            ]
        ]);
    }));
    return function validateOtp(corelationId, otp, whatsAppConsent, country) {
        return _ref.apply(this, arguments);
    };
}();
var resendOtp = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(country, corelationId, whatsAppConsent) {
        var appName, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    appName = "leap_scholar";
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return api/* default.post */.Z.post("/api/auth?path=otp/resend/".concat(appName, "/").concat(corelationId, "&nocache=").concat(new Date().getTime(), "&isWebRequest=", true, "&whatsappConsent=").concat(whatsAppConsent), null, {
                        params: {
                            country_code: country
                        }
                    });
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](1);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return", _ctx.t0);
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                8
            ]
        ]);
    }));
    return function resendOtp(country, corelationId, whatsAppConsent) {
        return _ref.apply(this, arguments);
    };
}();
var registerUser = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(flowType) {
        var payload, ref, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    payload = {};
                    if (flowType) {
                        payload = {
                            flowType: flowType
                        };
                    }
                    _ctx.prev = 2;
                    ;
                    _ctx.next = 6;
                    return captureAndSaveUtmWhileLoginIn();
                case 6:
                    _ctx.next = 8;
                    return api/* default.post */.Z.post("/api/register", payload);
                case 8:
                    res = _ctx.sent;
                    if ((ref = res.data) === null || ref === void 0 ? void 0 : ref.success) (0,cookie_utiils/* deleteCookie */.kT)(null, "referrer_id");
                    return _ctx.abrupt("return", res.data);
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](2);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return", _ctx.t0);
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                13
            ]
        ]);
    }));
    return function registerUser(flowType) {
        return _ref.apply(this, arguments);
    };
}();
var verifyTruecaller = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(requestId, whatsAppSubscription) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/auth?path=truecaller/verify", {
                        requestId: requestId,
                        whatsAppSubscription: whatsAppSubscription
                    });
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return", _ctx.t0);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function verifyTruecaller(requestId, whatsAppSubscription) {
        return _ref.apply(this, arguments);
    };
}();
var initTruecallerLogin = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(requestId) {
        var app, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    app = "leap_scholar";
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return api/* default.post */.Z.post("/api/auth?path=truecaller/initTruecaller", {
                        requestId: requestId,
                        app: app
                    });
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](1);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return", _ctx.t0);
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                8
            ]
        ]);
    }));
    return function initTruecallerLogin(requestId) {
        return _ref.apply(this, arguments);
    };
}();
var ivrCallRequest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(country, corelationId, whatsAppConsent) {
        var appName, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    appName = "leap_scholar";
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return api/* default.post */.Z.post("/api/auth?path=otp/ivr/".concat(appName, "/").concat(corelationId, "&nocache=").concat(new Date().getTime(), "&isWebRequest=", true, "&whatsappConsent=").concat(whatsAppConsent), null, {
                        params: {
                            country_code: country
                        }
                    });
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](1);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return", _ctx.t0);
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                8
            ]
        ]);
    }));
    return function ivrCallRequest(country, corelationId, whatsAppConsent) {
        return _ref.apply(this, arguments);
    };
}();
var loginApis = {
    generateOtp: generateOtp,
    validateOtp: validateOtp,
    registerUser: registerUser,
    resendOtp: resendOtp,
    initTruecallerLogin: initTruecallerLogin,
    verifyTruecaller: verifyTruecaller,
    ivrCallRequest: ivrCallRequest
};


/***/ }),

/***/ 32847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ components_Login; },
  "PD": function() { return /* binding */ getLoginPageTitle; },
  "Wg": function() { return /* binding */ getTrackingId; }
});

// UNUSED EXPORTS: webFlowType

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./DataMapper/CountryCode.tsx
var CountryCode = __webpack_require__(88237);
// EXTERNAL MODULE: ./DataMapper/EventTracker/EventData.ts
var EventData = __webpack_require__(1692);
// EXTERNAL MODULE: ./components/Login/LoginApis.ts + 1 modules
var LoginApis = __webpack_require__(85456);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Backdrop/Backdrop.js
var Backdrop = __webpack_require__(32692);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Fade/Fade.js
var Fade = __webpack_require__(73637);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Modal/Modal.js + 3 modules
var Modal = __webpack_require__(5566);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(98456);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/throttle.js
var throttle = __webpack_require__(23493);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
;// CONCATENATED MODULE: ./components/Login/OtpOnCall.tsx



var OtpOnCall = function(param) {
    var onClick = param.onClick, ivrMsg = param.ivrMsg, setIvrMsg = param.setIvrMsg;
    var ref = (0,react.useState)(15), timer = ref[0], setTimer = ref[1];
    var ref1 = (0,react.useState)(1), attempts = ref1[0], setAttempts = ref1[1];
    (0,react.useEffect)(function() {
        if (shouldEnableButton(attempts) && ivrMsg.type === "success") {
            setTimer(15);
            setAttempts(attempts + 1);
        }
    }, [
        ivrMsg
    ]);
    (0,react.useEffect)(function() {
        return function() {
            setAttempts(1);
            setIvrMsg({
                type: "default",
                message: ""
            });
        };
    }, []);
    (0,react.useEffect)(function() {
        if (ivrMsg.type === "success" || ivrMsg.type === "default") {
            var timerRef = setInterval(function() {
                setTimer(function(prevState) {
                    if (prevState <= 0) {
                        clearInterval(timerRef);
                        return 0;
                    }
                    return prevState - 1;
                });
            }, 1000);
            return function() {
                return clearInterval(timerRef);
            };
        }
    }, [
        ivrMsg
    ]);
    var buttonClick = throttle_default()(onClick, 500, {
        leading: true
    });
    var getVerb = function() {
        return ivrMsg.type === "default" || ivrMsg.type === "error" ? "Get" : "Resend";
    };
    var shouldEnableButton = function(attempts) {
        return attempts < 2;
    };
    if (timer !== 0 && shouldEnableButton(attempts)) return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "text-primary cursor-pointer",
        children: [
            getVerb(),
            " OTP on Call in: ",
            timer,
            " sec"
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full flex-col items-center",
        children: [
            shouldEnableButton(attempts) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: function() {
                    buttonClick();
                },
                className: "text-[#443EFF] font-semibold cursor-pointer ml-1 flex items-center",
                children: [
                    getVerb(),
                    " OTP on Call",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        width: "16",
                        height: "16",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        className: "ml-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M5 12H19M19 12L13 6M19 12L13 18",
                            stroke: "#443EFF",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    })
                ]
            }),
            ivrMsg.message && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(ivrMsg.type == "success" ? "text-[16px] font-semibold lfc-text-success-500" : "text-[16px] lfc-text-error-500", " px-2"),
                children: ivrMsg.message
            })
        ]
    });
};
/* harmony default export */ var Login_OtpOnCall = (OtpOnCall);

// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./components/Login/EnterOtpView.tsx







var EnterOtp = function(param) {
    var otp = param.otp, phone = param.phone, otpText = param.otpText, otpErrMsg = param.otpErrMsg, otpSuccessMsg = param.otpSuccessMsg, country = param.country, changeView = param.changeView, submitOtp = param.submitOtp, resendOtp = param.resendOtp, handleChange = param.handleChange, ivrCallRequest = param.ivrCallRequest, ivrMsg = param.ivrMsg, setIvrMsg = param.setIvrMsg;
    var ref, ref1;
    var ref2 = (0,react.useState)(30), resendOtpCount = ref2[0], setResendOtpCount = ref2[1];
    var resendOtpCountRef = (0,react.useRef)(resendOtpCount);
    var ref3 = (0,react.useState)(false), submitLock = ref3[0], setSubmitLock = ref3[1];
    var otpWaiting = ((ref = otp === null || otp === void 0 ? void 0 : otp.filter(function(n) {
        return n;
    })) === null || ref === void 0 ? void 0 : ref.length) === 6 && !otpErrMsg && !otpSuccessMsg;
    var otpDivRef = (0,react.useRef)(null);
    var timeoutRef = (0,react.useRef)(null);
    var handleInputFocus = function() {
        if (lib/* isMobile */.tq && otpDivRef.current) {
            // Store the timeout ID in the ref so we can clear it later
            timeoutRef.current = setTimeout(function() {
                var ref;
                (ref = otpDivRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            }, 300);
        }
    };
    (0,react.useEffect)(function() {
        return function() {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    (0,react.useEffect)(function() {
        var otpInterval = setInterval(function() {
            if (resendOtpCountRef.current < 1) {
                clearInterval(otpInterval);
            } else {
                resendOtpCountRef.current -= 1;
                setResendOtpCount(resendOtpCountRef.current);
            }
        }, 1000);
        return function() {
            clearInterval(otpInterval);
        };
    }, []);
    var getOtpMsg = function() {
        if (resendOtpCount) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-center w-full mb-4 mt-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-[#1C2233]",
                        children: "Didn't get OTP?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "text-[#656E7F] ml-1",
                        children: [
                            " ",
                            "Resend OTP in",
                            " ",
                            resendOtpCount < 10 ? "00:0".concat(resendOtpCount) : "00:".concat(resendOtpCount)
                        ]
                    })
                ]
            });
        } else if (otpSuccessMsg) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "font-semibold lfc-text-success-500 mt-8 mb-4",
                children: otpSuccessMsg
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-center w-full mt-8 mb-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-[#1C2233]",
                        children: "Didn't get OTP?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        onClick: resendOtp,
                        className: "text-[#443EFF] font-semibold cursor-pointer ml-1 flex items-center",
                        children: "Resend OTP"
                    })
                ]
            });
        }
    };
    var otpRef = (0,react.useRef)([]);
    (0,react.useEffect)(function() {
        otpRef.current[0].focus();
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        if (((ref = otp === null || otp === void 0 ? void 0 : otp.filter(function(n) {
            return n;
        })) === null || ref === void 0 ? void 0 : ref.length) === 6) {
            submitAndUnsetLock();
        }
    }, [
        otp
    ]);
    var handleOTP = function(event, index) {
        var newOTP = (0,_to_consumable_array/* default */.Z)(otp);
        var value = event.target.value;
        if (!isNaN(value) && value.length <= 6 - index) {
            if (value.length === 1) {
                newOTP[index] = value;
                if (index < 5) {
                    otpRef.current[index + 1].focus();
                }
            } else if (value.length > 1 && value.length <= 6) {
                var offset = index;
                while(offset < index + value.length){
                    newOTP[offset] = value[offset - index];
                    if (offset + 1 <= 5) {
                        otpRef.current[offset + 1].focus();
                    }
                    offset += 1;
                }
            }
            handleChange(newOTP);
        }
    };
    var submitAndUnsetLock = function() {
        if (!submitLock) {
            setSubmitLock(true);
            submitOtp().finally(function() {
                setSubmitLock(false);
            });
        }
    };
    var handleDelete = function(event, index) {
        var ref;
        if (event.keyCode === 8) {
            var newOTP = (0,_to_consumable_array/* default */.Z)(otp);
            newOTP[index] = "";
            handleChange(newOTP);
            if (index > 0) {
                otpRef.current[index - 1].focus();
            }
        }
        if (event.key === "Enter" && ((ref = otp === null || otp === void 0 ? void 0 : otp.filter(function(n) {
            return n;
        })) === null || ref === void 0 ? void 0 : ref.length) === 6 && !submitLock) {
            submitAndUnsetLock();
        }
    };
    var checkOTPBoxColor = function() {
        var ref, ref1;
        if (((ref = otp === null || otp === void 0 ? void 0 : otp.filter(function(n) {
            return n;
        })) === null || ref === void 0 ? void 0 : ref.length) === 6 && otpErrMsg.length > 0) return "border-[#FF695B]";
        else if (((ref1 = otp === null || otp === void 0 ? void 0 : otp.filter(function(n) {
            return n;
        })) === null || ref1 === void 0 ? void 0 : ref1.length) === 6 && otpSuccessMsg.length > 0) return "border-[#4AAC64]";
        else return "border-[#C6CBD2]";
    };
    (0,react.useEffect)(function() {
        var ref;
        if (((ref = otp === null || otp === void 0 ? void 0 : otp.filter(function(n) {
            return n;
        })) === null || ref === void 0 ? void 0 : ref.length) === 6 && otpErrMsg) {
            otpRef.current.forEach(function(input) {
                if (input) input.blur();
            });
        }
    }, [
        otpErrMsg,
        otp
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-[#757575] leading-5 pb-4 -mt-5 flex justify-between w-full",
                    style: {
                        marginBottom: "16px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-lg text-[#1C2233]",
                            children: [
                                "OTP sent to",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "font-bold",
                                    children: [
                                        "+",
                                        CountryCode/* countryData */.qO[country].code,
                                        " ",
                                        phone
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: "text-[#443EFF] cursor-pointer border-none bg-transparent flex items-center gap-0.5 px-1",
                            onClick: function() {
                                return changeView("phone");
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/edit_pencil.svg",
                                    alt: "edit",
                                    width: 20,
                                    height: 20
                                }),
                                "Edit"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center items-center gap-3 md:gap-4",
                ref: otpDivRef,
                children: (0,_to_consumable_array/* default */.Z)(Array(6)).map(function(_i, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        className: "text-base w-[2.8rem] h-12 text-center rounded-lg border border-solid ".concat(checkOTPBoxColor(), " text-[#333] bg-white outline-none p-[14px_10px] focus:border-[#574EDD] focus:shadow-[0_0_0_1px_rgba(87,78,221,0.1)] md:text-lg"),
                        type: "number",
                        placeholder: "",
                        value: otp[index],
                        onChange: function(e) {
                            return handleOTP(e, index);
                        },
                        ref: function(el) {
                            return otpRef.current[index] = el;
                        },
                        onKeyDown: function(event) {
                            var isDigit = /^[0-9]$/.test(event.key);
                            var allowedKeys = [
                                "Backspace",
                                "ArrowLeft",
                                "ArrowRight",
                                "Tab",
                                "Delete", 
                            ];
                            if (!isDigit && !allowedKeys.includes(event.key)) {
                                event.preventDefault();
                            }
                            handleDelete(event, index);
                        },
                        onFocus: handleInputFocus
                    }, index);
                })
            }),
            otpErrMsg && ((ref1 = otp === null || otp === void 0 ? void 0 : otp.filter(function(n) {
                return n;
            })) === null || ref1 === void 0 ? void 0 : ref1.length) === 6 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-sm leading-[18px] pt-3 w-full text-[#FF695B] text-center",
                children: otpErrMsg
            }),
            otpWaiting && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-[#686868] text-sm mt-4 flex items-center justify-center gap-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-4 h-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                            size: 16
                        })
                    }),
                    "Please wait"
                ]
            }),
            getOtpMsg(),
            country === CountryCode/* CountryCode.INDIA */.Cv.INDIA && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pt-2 pb-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Login_OtpOnCall, {
                    onClick: ivrCallRequest,
                    ivrMsg: ivrMsg,
                    setIvrMsg: setIvrMsg
                })
            })
        ]
    });
};
/* harmony default export */ var EnterOtpView = (EnterOtp);

// EXTERNAL MODULE: ./scripts/segment.ts + 1 modules
var segment = __webpack_require__(83697);
// EXTERNAL MODULE: ./utils/events-utils.js
var events_utils = __webpack_require__(42477);
// EXTERNAL MODULE: ./components/Inputs/Button.tsx
var Button = __webpack_require__(93306);
;// CONCATENATED MODULE: ./components/Login/CountryCodeSelector.tsx



var CountryCodeSelector = function(param) {
    var country = param.country, changeCountry = param.changeCountry;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var dropdownRef = (0,react.useRef)(null);
    // Close dropdown when clicking outside
    (0,react.useEffect)(function() {
        var handleClickOutside = function(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center w-full",
        ref: dropdownRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center w-full cursor-pointer",
                onClick: function() {
                    return setIsOpen(!isOpen);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: CountryCode/* countryData */.qO[country].flag,
                        width: 28,
                        height: 20,
                        alt: country,
                        className: "rounded-[3px] mr-2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "text-[16px]",
                        children: [
                            "+",
                            CountryCode/* countryData */.qO[country].code
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        width: "10",
                        height: "6",
                        viewBox: "0 0 10 6",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        className: "ml-2 transition-transform duration-200 ".concat(isOpen ? "rotate-180" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M1 1L5 5L9 1",
                            stroke: "black",
                            strokeWidth: "1",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-[110%] left-0 w-full max-h-[200px] overflow-y-scroll z-[9999999] bg-white shadow-lg rounded-[8px] border border-[#C6CBD2] border-solid",
                children: CountryCode/* countries.map */.hW.map(function(option) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center justify-between px-3 py-3 cursor-pointer ".concat(option.value === country ? "bg-[#ececec]" : "hover:bg-[#f8f8f8]"),
                        onClick: function() {
                            changeCountry(option.value);
                            setIsOpen(false);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: CountryCode/* countryData */.qO[option.value].flag,
                                        width: 28,
                                        height: 20,
                                        alt: option.label,
                                        className: "rounded-[3px]"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pl-2 text-base",
                                        children: option.label
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "text-base",
                                children: [
                                    "+",
                                    CountryCode/* countryData */.qO[option.value].code
                                ]
                            })
                        ]
                    }, option.value);
                })
            })
        ]
    });
};
/* harmony default export */ var Login_CountryCodeSelector = (CountryCodeSelector);

;// CONCATENATED MODULE: ./components/Login/EnterPhoneView.tsx








var EnterMobile = function(param) {
    var phone = param.phone, phoneText = param.phoneText, phoneErrMsg = param.phoneErrMsg, showTruecaller = param.showTruecaller, phoneInfoMsg = param.phoneInfoMsg, country = param.country, canChangeCountryCode = param.canChangeCountryCode, handleChange = param.handleChange, generateOtp = param.generateOtp, truecallerLoginManager = param.truecallerLoginManager, changeCountry = param.changeCountry, isLoading = param.isLoading, isGeneratingOtp = param.isGeneratingOtp;
    var hadSentEvent = (0,react.useRef)(false);
    var phoneRef = (0,react.useRef)(null);
    var timeoutRef = (0,react.useRef)(null);
    var handleInputFocus = function() {
        if (lib/* isMobile */.tq && phoneRef.current) {
            timeoutRef.current = setTimeout(function() {
                var ref;
                (ref = phoneRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
            }, 300);
        }
    };
    var handlePhoneChange = function(e) {
        handleChange(e);
    };
    var preventNumberInputScroll = function(e) {
        e.currentTarget.blur();
    };
    (0,react.useEffect)(function() {
        return function() {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-6 md:mb-[40px] w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative flex items-center w-full rounded-[8px] border border-solid ".concat((0,CountryCode/* validatePhoneNumberOnCountry */.tj)(phone, country) ? "border-[rgba(74,172,100,1)]" : "border-[#dbdbdb]", " bg-white transition-[border-color] duration-200 ease h-[48px] p-[12px_16px] text-[#1c2233] focus-within:border-[#6555db] focus-within:border-[1px] focus-within:shadow-[0_0_0_2px_rgba(90,77,194,0.1)]"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "md:text-lg text-base ".concat(canChangeCountryCode ? "border-r border-[#dbdbdb] pr-3 mr-3" : "pl-4 pr-2 border-r border-gray-300"),
                        children: canChangeCountryCode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Login_CountryCodeSelector, {
                            country: country,
                            changeCountry: changeCountry
                        }) : "+91"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        ref: phoneRef,
                        className: "text-[16px] py-[14px] pr-[16px] bg-transparent text-[#1c1c1c] font-[400] caret-[#443eff] flex-1 h-full transition-all duration-200 ease placeholder:text-[#686868] placeholder:opacity-70 placeholder:transition-opacity placeholder:duration-200 focus:placeholder:opacity-50 md:text-[16px] md:leading-[1.5rem] border-0 ".concat(canChangeCountryCode ? "w-[60%] md:w-[66.666667%]" : ""),
                        type: "number",
                        inputMode: "numeric",
                        value: phone,
                        onChange: handlePhoneChange,
                        placeholder: "Mobile Number",
                        onFocus: handleInputFocus,
                        onKeyDown: function(e) {
                            // Prevent 'e' and 'E' characters
                            if (e.key === "e" || e.key === "E") {
                                e.preventDefault();
                            }
                            if (e.key === "Enter") {
                                generateOtp();
                            } else {
                                if (!hadSentEvent.current) {
                                    (0,segment.trackClick)(events_utils.pageName.Login_Modal, {
                                        widgetName: "Login Modal",
                                        widgetFormat: "Modal",
                                        contentName: "Input Number",
                                        contentFormat: "Button"
                                    });
                                    hadSentEvent.current = true;
                                }
                            }
                        },
                        onWheel: preventNumberInputScroll,
                        autoFocus: !lib/* isMobile */.tq
                    })
                ]
            }),
            !phoneErrMsg && phoneInfoMsg && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-[0.875rem] leading-[1.25rem] text-center pt-[0.5rem] w-full text-[rgba(68,62,255,1)]",
                children: phoneInfoMsg
            }),
            phoneErrMsg && !(0,CountryCode/* validatePhoneNumberOnCountry */.tj)(phone, country) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-[0.875rem] leading-[1.25rem] text-center pt-[0.5rem] w-full text-[rgba(255,105,91,1)]",
                children: phoneErrMsg
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* PrimaryButton */.KM, {
                py: "pt-[14px] pb-[14px] md:py-3",
                disabled: !(0,CountryCode/* validatePhoneNumberOnCountry */.tj)(phone, country) || isLoading || isGeneratingOtp,
                className: "mt-4 mb-4 w-full rounded-[12px] shadow-[0px_3px_10px_-2px_rgba(28,34,51,0.12)] !important",
                ctaText: phoneText,
                onClick: generateOtp
            }),
            lib/* isMobile */.tq && showTruecaller && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full text-[#888] font-[400] text-center text-[16px] my-[4px] relative flex items-center justify-center before:content-[''] before:flex-1 before:h-[1px] before:bg-[#e0e0e0] before:mx-[15px] after:content-[''] after:flex-1 after:h-[1px] after:bg-[#e0e0e0] after:mx-[15px]",
                        children: "or"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "flex items-center justify-center font-bold text-base w-full py-3 px-4 rounded-lg border border-[#0086FE] text-[#0086FE] bg-white cursor-pointer transition-all duration-200 mt-4 shadow-sm hover:bg-[rgba(59,130,246,0.05)] md:mt-5 md:mb-5",
                        onClick: truecallerLoginManager,
                        children: [
                            "Continue with",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/assets/truecaller-logo.svg",
                                alt: "truecaller",
                                width: 79,
                                height: 25
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var EnterPhoneView = (EnterMobile);

;// CONCATENATED MODULE: ./components/Login/LoginPopup.tsx









var LoginModal = function(param) {
    var isModalOpen = param.isModalOpen, title = param.title, imageUrl = param.imageUrl, canClose = param.canClose, activeView = param.activeView, phone = param.phone, otp = param.otp, phoneText = param.phoneText, otpText = param.otpText, phoneErrMsg = param.phoneErrMsg, otpErrMsg = param.otpErrMsg, otpSuccessMsg = param.otpSuccessMsg, showTruecaller = param.showTruecaller, showLoader = param.showLoader, phoneInfoMsg = param.phoneInfoMsg, canChangeCountryCode = param.canChangeCountryCode, country = param.country, handleClose = param.handleClose, handlePhoneChange = param.handlePhoneChange, handleOtpChange = param.handleOtpChange, handleViewChange = param.handleViewChange, generateOtp = param.generateOtp, validateOtp = param.validateOtp, resendOtp = param.resendOtp, truecallerLoginManager = param.truecallerLoginManager, changeCountry = param.changeCountry, ivrCallRequest = param.ivrCallRequest, ivrMsg = param.ivrMsg, setIvrMsg = param.setIvrMsg, isGeneratingOtp = param.isGeneratingOtp;
    (0,react.useEffect)(function() {
        (0,segment.trackPage)(events_utils.pageName.Login_Modal);
    }, []);
    // const wrapperRef = useRef(null);
    // useEffect(() => {
    //   function handleClickOutside(event: any) {
    //     /*@ts-ignore*/
    //     if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
    //       handleClose();
    //       console.log('clicked')
    //     }
    //   }
    //   document.addEventListener("mousedown", handleClickOutside);
    //   return () => {
    //     document.removeEventListener("mousedown", handleClickOutside);
    //   };
    // }, [wrapperRef]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        // ref={wrapperRef}
        className: "flex justify-center items-end md:items-center md:px-4",
        "aria-labelledby": "transition-modal-title",
        "aria-describedby": "transition-modal-description",
        open: isModalOpen,
        onClose: handleClose,
        closeAfterTransition: true,
        BackdropComponent: Backdrop/* default */.Z,
        BackdropProps: {
            timeout: 800
        },
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
        children: !showLoader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
            in: isModalOpen,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative w-full flex items-center justify-center md:mx-auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bg-white w-120 py-6 md:py-6 shadow-10 rounded-t-2xl md:rounded-20",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex ".concat(activeView !== "phone" ? canClose ? "justify-between" : "justify-center md:pt-4" : "justify-end", " items-center w-full md:px-8 pb-4 md:pb-0 px-6"),
                            onClick: function() {
                                if (canClose) handleClose();
                            },
                            children: [
                                activeView !== "phone" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "w-[24px] h-[28px] md:w-[42px] md:h-[50px]",
                                    src: "/assets/icons/leap_logo.svg",
                                    alt: "leap"
                                }),
                                canClose && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "cursor-pointer",
                                    src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/auth/close_icon.svg"),
                                    alt: "close"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center px-4 md:px-16 w-full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col items-center w-full mb-[36px] md:mb-[32px] md:mt-[".concat(activeView !== "phone" && !canClose ? "32px" : "64px", "]"),
                                    children: [
                                        activeView === "phone" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: "w-[42px] h-[50px] md:w-[68px] md:h-[80px]",
                                            src: "/assets/icons/leap_logo.svg",
                                            alt: "leap"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[24px] md:text-[32px] font-bold text-center mt-2 md:mt-3",
                                            children: activeView === "phone" ? "Login" : "Verify your number"
                                        })
                                    ]
                                }),
                                activeView === "phone" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EnterPhoneView, {
                                    phone: phone,
                                    phoneText: phoneText,
                                    phoneErrMsg: phoneErrMsg,
                                    handleChange: handlePhoneChange,
                                    changeView: handleViewChange,
                                    generateOtp: generateOtp,
                                    truecallerLoginManager: truecallerLoginManager,
                                    showTruecaller: showTruecaller,
                                    phoneInfoMsg: phoneInfoMsg,
                                    canChangeCountryCode: canChangeCountryCode,
                                    country: country,
                                    changeCountry: changeCountry,
                                    isLoading: showLoader,
                                    isGeneratingOtp: isGeneratingOtp
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EnterOtpView, {
                                    otp: otp,
                                    phone: phone,
                                    otpText: otpText,
                                    otpErrMsg: otpErrMsg,
                                    otpSuccessMsg: otpSuccessMsg,
                                    handleChange: handleOtpChange,
                                    changeView: handleViewChange,
                                    submitOtp: validateOtp,
                                    resendOtp: resendOtp,
                                    country: country,
                                    ivrCallRequest: ivrCallRequest,
                                    ivrMsg: ivrMsg,
                                    setIvrMsg: setIvrMsg
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-[#A6ADB8] text-sm text-center leading-5 md:leading-6 break-normal",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "By submitting this form, you consent to our",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "text-[#a6adb8] underline hover:text-[#443eff]",
                                                href: "https://leapscholar.com/terms",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: "Terms of service"
                                            }),
                                            " ",
                                            "and",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "text-[#a6adb8] underline hover:text-[#443eff]",
                                                href: "https://leapscholar.com/privacy",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: "Privacy policy"
                                            }),
                                            " ",
                                            "and to be contacted by us via Call/Email/WhatsApp/SMS"
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "h-64 flex flex-col justify-center items-center",
            style: {
                width: "100%",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/circle_loader.gif"),
                alt: "Loading...",
                className: "w-16 md:w-20"
            })
        })
    });
};
/* harmony default export */ var LoginPopup = (LoginModal);

// EXTERNAL MODULE: ./components/Login/utils.ts + 4 modules
var utils = __webpack_require__(26411);
// EXTERNAL MODULE: ./components/SpotCounselling/redux/SpotCounsellingActions.ts
var SpotCounsellingActions = __webpack_require__(10585);
// EXTERNAL MODULE: ./components/TofuOnbordingForms/SpotCounsellingProgressiveForm/IeltsToCounselling/IeltsToCounsellingApi.ts
var IeltsToCounsellingApi = __webpack_require__(78779);
// EXTERNAL MODULE: ./components/decorator/redux/AuthActions.ts
var AuthActions = __webpack_require__(86982);
// EXTERNAL MODULE: ./ga.ts
var ga = __webpack_require__(83138);
// EXTERNAL MODULE: ./lib/DateUtils/dateLib/format.ts + 1 modules
var format = __webpack_require__(45172);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./page_routes/index.ts
var page_routes = __webpack_require__(12615);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./utils/cookie-utiils.ts
var cookie_utiils = __webpack_require__(51119);
// EXTERNAL MODULE: ./utils/event_utils.ts
var event_utils = __webpack_require__(59042);
// EXTERNAL MODULE: ./utils/utm_utils.ts
var utm_utils = __webpack_require__(86147);
;// CONCATENATED MODULE: ./utils/autoReadSMS.ts


function autoReadSMS(cb) {
    return _autoReadSMS.apply(this, arguments);
};
function _autoReadSMS() {
    _autoReadSMS = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(cb) {
        var signal, otpCredential;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    signal = new AbortController();
                    setTimeout(function() {
                        return signal.abort();
                    }, 60 * 1000);
                    _ctx.prev = 2;
                    if (!( true && "OTPCredential" in window)) {
                        _ctx.next = 18;
                        break;
                    }
                    if (!(typeof navigator != "undefined" && navigator.credentials)) {
                        _ctx.next = 15;
                        break;
                    }
                    _ctx.next = 7;
                    return navigator.credentials.get({
                        otp: {
                            transport: [
                                "sms"
                            ]
                        },
                        signal: signal.signal
                    });
                case 7:
                    otpCredential = _ctx.sent;
                    if (!(otpCredential && otpCredential.code)) {
                        _ctx.next = 12;
                        break;
                    }
                    return _ctx.abrupt("return", cb({
                        code: otpCredential.code,
                        error: "",
                        meta: otpCredential
                    }));
                case 12:
                    return _ctx.abrupt("return", cb({
                        code: "",
                        error: "otpCredential error" + JSON.stringify(otpCredential)
                    }));
                case 13:
                    _ctx.next = 16;
                    break;
                case 15:
                    return _ctx.abrupt("return", cb({
                        code: "",
                        error: "navigator credentials not found"
                    }));
                case 16:
                    _ctx.next = 19;
                    break;
                case 18:
                    return _ctx.abrupt("return", cb({
                        code: "",
                        error: "OTPCredential not found"
                    }));
                case 19:
                    _ctx.next = 25;
                    break;
                case 21:
                    _ctx.prev = 21;
                    _ctx.t0 = _ctx["catch"](2);
                    cb({
                        code: "",
                        error: "Error reading OTP: " + _ctx.t0.toString()
                    });
                    console.log("Error reading OTP:", _ctx.t0);
                case 25:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                21
            ]
        ]);
    }));
    return _autoReadSMS.apply(this, arguments);
}

// EXTERNAL MODULE: ./hooks/login/useLocation.ts
var useLocation = __webpack_require__(28531);
;// CONCATENATED MODULE: ./components/Login/index.tsx

























var MAX_AGE = 60 * 60 * 24 * 365;
var webFlowType = {
    WEB_FLOW_MASTERCLASS: "webflow_masterclass",
    WEB_FLOW_FASTTRACK: "webflow_fasttrack"
};
var getTrackingId = function(url_string, key) {
    try {
        var url = new URL(window.location.origin + url_string);
        return url.searchParams.get(key);
    } catch (_) {
        return;
    }
};
var getLoginPageTitle = function(url, trackingId) {
    var callbackUrl = url.split("?")[0];
    if (callbackUrl && (callbackUrl === page_routes/* navRoutes.FAST_TRACK_FORM */.CZ.FAST_TRACK_FORM || callbackUrl.startsWith(page_routes/* navRoutes.FAST_TRACK_VIDEO */.CZ.FAST_TRACK_VIDEO))) {
        if (trackingId === webFlowType.WEB_FLOW_FASTTRACK) {
            return "Register for Fast Track";
        }
        return "Login for IELTS Fast Track";
    } else if (trackingId === webFlowType.WEB_FLOW_MASTERCLASS) {
        return "Register for Masterclass";
    } else if (url.includes("product?bundleName=IELTS_LIY_COURSE")) {
        return "Login to proceed";
    } else return "Login";
};
var Login = function(param) {
    var isModalOpen = param.isModalOpen, title = param.title, callback = param.callback, canClose = param.canClose, preFilledPhone = param.preFilledPhone, flowType = param.flowType, saveToken = param.saveToken, canChangeCountryCode = param.canChangeCountryCode, handleClose = param.handleClose, resetPreFilledPhone = param.resetPreFilledPhone, country = param.country, setCountry = param.setCountry, ctaText = param.ctaText, imageUrl = param.imageUrl;
    var userCountry = (0,useLocation/* default */.Z)().userCountry;
    var ref = (0,react.useState)(""), phone = ref[0], setPhone = ref[1];
    var ref1 = (0,react.useState)([
        "",
        "",
        "",
        "",
        "",
        ""
    ]), otp = ref1[0], setOtp = ref1[1];
    var ref2 = (0,react.useState)("phone"), activeView = ref2[0], setActiveView = ref2[1];
    var ref3 = (0,react.useState)(""), correlationId = ref3[0], setCorrelationId = ref3[1];
    var whatsAppSubscription = true;
    var ref4 = (0,react.useState)("Get OTP"), phoneText = ref4[0], setPhoneText = ref4[1];
    var ref5 = (0,react.useState)(""), phoneErrMsg = ref5[0], setPhoneErrMsg = ref5[1];
    var ref6 = (0,react.useState)("Proceed"), otpText = ref6[0], setOtpText = ref6[1];
    var ref7 = (0,react.useState)(""), otpErrMsg = ref7[0], setOtpErrMsg = ref7[1];
    var ref8 = (0,react.useState)({
        type: "default",
        message: ""
    }), ivrMsg = ref8[0], setIvrMsg = ref8[1];
    var ref9 = (0,react.useState)(""), phoneInfoMsg = ref9[0], setPhoneInfoMsg = ref9[1];
    var ref10 = (0,react.useState)(""), otpSuccessMsg = ref10[0], setOtpSuccessMsg = ref10[1];
    var ref11 = (0,react.useState)(false), showLoader = ref11[0], setShowLoader = ref11[1];
    var ref12 = (0,react.useState)(true), showTruecaller = ref12[0], setShowTruecaller = ref12[1];
    var phoneNumberWithoutZeros = (0,utils/* removeLeadingZeros */.Qo)(phone);
    var ref13 = (0,react.useState)(false), isGeneratingOtp = ref13[0], setIsGeneratingOtp = ref13[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var samesite = router.query.samesite;
    var path = router.pathname;
    var utmDetails = (0,utm_utils/* getUtmData */.M)(null);
    var callbackUrl = router.query.callbackUrl;
    var variant = getTrackingId(callbackUrl, "variant");
    var eventParam = (0,react.useMemo)(function() {
        if (callbackUrl) {
            var trackinId = getTrackingId(callbackUrl, "tracking_id");
            if (trackinId === webFlowType.WEB_FLOW_MASTERCLASS) {
                return {
                    category: trackinId,
                    label: "IELTS - MasterClass Landing Page"
                };
            } else if (trackinId === webFlowType.WEB_FLOW_FASTTRACK) {
                return {
                    category: trackinId,
                    label: "IELTS Fast Track"
                };
            } else return null;
        }
        return null;
    }, [
        callbackUrl
    ]);
    var handleGaEvent = function(payload) {
        var userProps = {
            lead_stage: payload.leadStage,
            user_id: payload.userId,
            subscribed_to_whatsapp: payload.subscribedToWhatsapp,
            login_type: payload.authType
        };
        var eventProps = {
            page_name: payload.pageName,
            auth_type: payload.authType,
            subscribed_to_whatsapp: payload.subscribedToWhatsapp,
            login_type: payload.authType
        };
        (0,ga.sendCustomGaEvent)("Log In Successful", eventProps, userProps);
    };
    var autoUpdateOtp = function(autoOtp) {
        var code = autoOtp.code;
        if (code && code.length == 6) {
            var optList = code.split("");
            return setOtp(optList);
        }
    };
    var generateOtp = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var res, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsGeneratingOtp(true);
                        (0,segment.trackClick)(events_utils.pageName.Login_Modal, {
                            widgetName: "Login Modal",
                            widgetFormat: "Modal",
                            contentName: "Get OTP",
                            contentFormat: "Button",
                            phone: phone
                        });
                        if ((0,CountryCode/* validatePhoneNumberOnCountry */.tj)(phoneNumberWithoutZeros, country)) {
                            _ctx.next = 8;
                            break;
                        }
                        setIsGeneratingOtp(false);
                        setPhoneErrMsg("Please enter a valid phone number");
                        return _ctx.abrupt("return");
                    case 8:
                        setPhoneErrMsg("");
                        setPhoneText("Please wait");
                        _ctx.prev = 10;
                        _ctx.next = 13;
                        return LoginApis/* loginApis.generateOtp */.Z.generateOtp(CountryCode/* countryData */.qO[country].code, country, phoneNumberWithoutZeros, whatsAppSubscription);
                    case 13:
                        res = _ctx.sent;
                        if (res.success) {
                            setCorrelationId(res.data);
                            setActiveView("otp");
                            autoReadSMS(autoUpdateOtp);
                            if (eventParam) {
                                (0,ga.logEvent)(eventParam.category, "Get OTP", eventParam.label);
                            }
                        } else {
                            ;
                            (0,segment.trackEventAsync)(event_utils/* segmentEvents.OTP_ERROR */.Fh.OTP_ERROR, {
                                phoneNumber: phoneNumberWithoutZeros,
                                errorCode: (res === null || res === void 0 ? void 0 : (ref = res.response) === null || ref === void 0 ? void 0 : ref.status) || 200,
                                errorMessage: res === null || res === void 0 ? void 0 : res.message,
                                currentPage: router.pathname,
                                refererUrl: document === null || document === void 0 ? void 0 : document.referrer,
                                loginStep: utils/* LOGIN_STEPS.GENERATE_OTP */.i0.GENERATE_OTP
                            });
                            setPhoneErrMsg(res.message);
                        }
                        _ctx.next = 20;
                        break;
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](10);
                        setPhoneErrMsg("Something went wrong. Please try after sometime");
                    case 20:
                        _ctx.prev = 20;
                        setIsGeneratingOtp(false);
                        setPhoneText(ctaText || "Get OTP");
                        return _ctx.finish(20);
                    case 24:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    10,
                    17,
                    20,
                    24
                ]
            ]);
        }));
        return function generateOtp() {
            return _ref.apply(this, arguments);
        };
    }();
    var validateOtp = function() {
        return new Promise(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(resolve) {
                var res, ref;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            (0,segment.trackClick)(events_utils.pageName.Login_Modal, {
                                widgetName: "Login Modal",
                                widgetFormat: "Modal",
                                contentName: "Submit OTP",
                                contentFormat: "Button",
                                phone: phoneNumberWithoutZeros
                            });
                            setOtpErrMsg("");
                            setOtpText("Please wait");
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return LoginApis/* loginApis.validateOtp */.Z.validateOtp(correlationId, otp.join(""), whatsAppSubscription, country);
                        case 6:
                            res = _ctx.sent;
                            if (!res.success) {
                                _ctx.next = 13;
                                break;
                            }
                            _ctx.next = 10;
                            return storeToken(res.data, setOtpErrMsg);
                        case 10:
                            if (eventParam) {
                                (0,ga.logEvent)(eventParam.category, "Submit OTP", eventParam.label);
                            }
                            _ctx.next = 14;
                            break;
                        case 13:
                            {
                                ;
                                (0,segment.trackEventAsync)(event_utils/* segmentEvents.OTP_ERROR */.Fh.OTP_ERROR, {
                                    phoneNumber: phoneNumberWithoutZeros,
                                    errorCode: (res === null || res === void 0 ? void 0 : (ref = res.response) === null || ref === void 0 ? void 0 : ref.status) || 200,
                                    errorMessage: res === null || res === void 0 ? void 0 : res.message,
                                    currentPage: router.pathname,
                                    refererUrl: document === null || document === void 0 ? void 0 : document.referrer,
                                    loginStep: utils/* LOGIN_STEPS.SUBMIT_OTP */.i0.SUBMIT_OTP
                                });
                                setOtpErrMsg(res.message);
                            }
                        case 14:
                            _ctx.next = 21;
                            break;
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](3);
                            console.log(_ctx.t0.message, "err?");
                            (0,cookie_utiils/* deleteCookie */.kT)(null, "token");
                            setOtpErrMsg("OTP is invalid");
                        case 21:
                            _ctx.prev = 21;
                            setOtpText("Proceed");
                            resolve();
                            return _ctx.finish(21);
                        case 25:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        16,
                        21,
                        25
                    ]
                ]);
            }));
            return function(resolve) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    var storeToken = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(token, cbError) {
            var registerRes, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, trackPayload, webFlowData, data, ref10, reSavedata, ref11;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        (0,cookie_utiils/* saveCookie */.YB)(null, "token", token, MAX_AGE, samesite);
                        _ctx.next = 4;
                        return LoginApis/* loginApis.registerUser */.Z.registerUser(flowType);
                    case 4:
                        registerRes = _ctx.sent;
                        if (!registerRes.success) {
                            _ctx.next = 40;
                            break;
                        }
                        ;
                        trackPayload = (0,_object_spread/* default */.Z)({
                            pageName: path || "NA",
                            authType: (registerRes === null || registerRes === void 0 ? void 0 : (ref = registerRes.data) === null || ref === void 0 ? void 0 : ref.newUser) ? "Sign Up" : "Sign In",
                            leadStage: (registerRes === null || registerRes === void 0 ? void 0 : (ref1 = registerRes.data) === null || ref1 === void 0 ? void 0 : ref1.stage) || "",
                            flowType: flowType,
                            userId: (registerRes === null || registerRes === void 0 ? void 0 : (ref2 = registerRes.data) === null || ref2 === void 0 ? void 0 : ref2.userId) || "",
                            subscribedToWhatsapp: whatsAppSubscription,
                            phone: phoneNumberWithoutZeros || "NA",
                            country: country || "NA"
                        }, (0,utils/* getPixelData */.WE)());
                        (0,cookie_utiils/* saveCookie */.YB)(null, "user_id", (registerRes === null || registerRes === void 0 ? void 0 : (ref3 = registerRes.data) === null || ref3 === void 0 ? void 0 : ref3.userId) || "");
                        saveToken(token);
                        (0,ga.logEvent)("login success", "login success", "");
                        webFlowData = localStorage.getItem("webFlowData");
                        if (!(registerRes === null || registerRes === void 0 ? void 0 : (ref4 = registerRes.data) === null || ref4 === void 0 ? void 0 : ref4.newUser)) {
                            _ctx.next = 16;
                            break;
                        }
                        _ctx.next = 15;
                        return (0,ga.fireTagEvent)("complete registration");
                    case 15:
                        (0,ga.logEvent)(EventData/* eventCategory.NEW_IELTS_LEAD */.f2.NEW_IELTS_LEAD, router.asPath, "");
                    case 16:
                        dispatch(SpotCounsellingActions/* spotCounsellingActions.fetchStage */.F.fetchStage());
                        _ctx.next = 19;
                        return (0,IeltsToCounsellingApi/* getUserData */.is)();
                    case 19:
                        data = _ctx.sent;
                        _ctx.next = 22;
                        return (0,segment.trackSignup)("Log In Successful", trackPayload);
                    case 22:
                        if (!(callbackUrl === null || callbackUrl === void 0 ? void 0 : callbackUrl.includes("drive"))) {
                            _ctx.next = 25;
                            break;
                        }
                        _ctx.next = 25;
                        return (0,segment.trackSignup)("Log In Successful Exp1", (0,_object_spread/* default */.Z)({}, trackPayload, (0,utils/* getPixelData */.WE)()));
                    case 25:
                        handleGaEvent(trackPayload);
                        if (!((registerRes === null || registerRes === void 0 ? void 0 : (ref5 = registerRes.data) === null || ref5 === void 0 ? void 0 : ref5.newUser) && (data === null || data === void 0 ? void 0 : (ref6 = data.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : ref7.preferredCountry))) {
                            _ctx.next = 29;
                            break;
                        }
                        _ctx.next = 29;
                        return (0,segment.trackSignup)("Log In Successful ".concat(data === null || data === void 0 ? void 0 : (ref8 = data.data) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.data) === null || ref9 === void 0 ? void 0 : ref9.preferredCountry), trackPayload);
                    case 29:
                        if (!(webFlowData && variant)) {
                            _ctx.next = 37;
                            break;
                        }
                        ;
                        _ctx.next = 33;
                        return (0,IeltsToCounsellingApi/* saveUserData */.gt)(JSON.parse(webFlowData));
                    case 33:
                        reSavedata = _ctx.sent;
                        if (reSavedata === null || reSavedata === void 0 ? void 0 : (ref10 = reSavedata.data) === null || ref10 === void 0 ? void 0 : ref10.success) {
                            localStorage.removeItem("webFlowData");
                            (0,segment.trackEvent)("Force redirect webFlow failed", webFlowData);
                            router.push(page_routes/* navRoutes.MEETING_FINDER */.CZ.MEETING_FINDER);
                        }
                        _ctx.next = 38;
                        break;
                    case 37:
                        {
                            setTimeout(function() {
                                var ref;
                                callback(registerRes === null || registerRes === void 0 ? void 0 : (ref = registerRes.data) === null || ref === void 0 ? void 0 : ref.newUser);
                                handleClose();
                            }, 1);
                        }
                    case 38:
                        _ctx.next = 41;
                        break;
                    case 40:
                        {
                            ;
                            (0,segment.trackEventAsync)(event_utils/* segmentEvents.OTP_ERROR */.Fh.OTP_ERROR, {
                                phoneNumber: phoneNumberWithoutZeros,
                                errorCode: (registerRes === null || registerRes === void 0 ? void 0 : (ref11 = registerRes.response) === null || ref11 === void 0 ? void 0 : ref11.status) || 200,
                                errorMessage: registerRes === null || registerRes === void 0 ? void 0 : registerRes.message,
                                currentPage: router.pathname,
                                refererUrl: document === null || document === void 0 ? void 0 : document.referrer,
                                loginStep: utils/* LOGIN_STEPS.REGISTER_USER */.i0.REGISTER_USER
                            });
                            (0,cookie_utiils/* deleteCookie */.kT)(null, "token");
                            cbError(registerRes.message);
                        }
                    case 41:
                        _ctx.next = 46;
                        break;
                    case 43:
                        _ctx.prev = 43;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error("Error in storeToken: ", _ctx.t0);
                    case 46:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    43
                ]
            ]);
        }));
        return function storeToken(token, cbError) {
            return _ref.apply(this, arguments);
        };
    }();
    var resendOtp = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var res, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        (0,segment.trackClick)(events_utils.pageName.Login_Modal, {
                            widgetName: "Login Modal",
                            widgetFormat: "Modal",
                            contentName: "Resend OTP",
                            contentFormat: "Button",
                            phone: phoneNumberWithoutZeros
                        });
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return LoginApis/* loginApis.resendOtp */.Z.resendOtp(country, correlationId, whatsAppSubscription);
                    case 4:
                        res = _ctx.sent;
                        if (res.success) {
                            setOtpSuccessMsg("OTP resent successfully");
                            if (eventParam) {
                                (0,ga.logEvent)(eventParam.category, "Resend OTP", eventParam.label);
                            }
                        } else {
                            ;
                            (0,segment.trackEventAsync)(event_utils/* segmentEvents.OTP_ERROR */.Fh.OTP_ERROR, {
                                phoneNumber: phoneNumberWithoutZeros,
                                errorCode: (res === null || res === void 0 ? void 0 : (ref = res.response) === null || ref === void 0 ? void 0 : ref.status) || 200,
                                errorMessage: res === null || res === void 0 ? void 0 : res.message,
                                currentPage: router.pathname,
                                refererUrl: document === null || document === void 0 ? void 0 : document.referrer,
                                loginStep: utils/* LOGIN_STEPS.RESEND_OTP */.i0.RESEND_OTP
                            });
                            setOtpErrMsg(res.message);
                        }
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](1);
                        setOtpErrMsg("Something went wrong. Please try after sometime");
                    case 11:
                        _ctx.prev = 11;
                        setTimeout(function() {
                            setOtpSuccessMsg("");
                        }, 5000);
                        return _ctx.finish(11);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    8,
                    11,
                    14
                ]
            ]);
        }));
        return function resendOtp() {
            return _ref.apply(this, arguments);
        };
    }();
    var ivrCallRequest = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return LoginApis/* loginApis.ivrCallRequest */.Z.ivrCallRequest(country, correlationId, whatsAppSubscription);
                    case 3:
                        res = _ctx.sent;
                        if (res === null || res === void 0 ? void 0 : res.success) {
                            setIvrMsg({
                                type: "success",
                                message: "OTP call on the way"
                            });
                        } else {
                            setIvrMsg({
                                message: "Failed to sent OTP, please try after sometime",
                                type: "error"
                            });
                        }
                        _ctx.next = 11;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        console.log(_ctx.t0);
                        setIvrMsg({
                            message: "Failed to sent OTP, please try after sometime",
                            type: "error"
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function ivrCallRequest() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (preFilledPhone) {
            setPhone(preFilledPhone);
        }
    }, [
        preFilledPhone
    ]);
    (0,react.useEffect)(function() {
        if (phoneNumberWithoutZeros && preFilledPhone) {
            generateOtp();
            resetPreFilledPhone();
        }
    }, [
        phoneNumberWithoutZeros
    ]);
    var truecallerDeepLink = function(requestId) {
        window.location.href = "truecallersdk://truesdk/web_verify?requestNonce=".concat(requestId, "&partnerKey=").concat("l5btsc5e38b7e21d64208a91c7702fc8fc8a3", "&partnerName=").concat("Leap Scholar", "&title=").concat(title, "&&skipOption=Skip");
    };
    var truecallerRejectHandler = function(error) {
        setShowLoader(false);
        setShowTruecaller(false);
        setPhoneInfoMsg(error);
    };
    var truecallerErrorHandler = function(error) {
        setPhoneErrMsg(error);
        setShowLoader(false);
        setShowTruecaller(false);
    };
    var truecallerAcceptHandler = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(token) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return storeToken(token, truecallerErrorHandler);
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function truecallerAcceptHandler(token) {
            return _ref.apply(this, arguments);
        };
    }();
    var truecallerDeepLinkActive = function(requestId) {
        return new Promise(function(resolve, reject) {
            var requestAttempt = 0;
            var requestInterval = setInterval((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var res, ref;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return LoginApis/* loginApis.verifyTruecaller */.Z.verifyTruecaller(requestId, whatsAppSubscription);
                        case 2:
                            res = _ctx.sent;
                            requestAttempt += 1;
                            if (res === null || res === void 0 ? void 0 : res.success) {
                                if (res.data) {
                                    clearInterval(requestInterval);
                                    resolve(res.data);
                                }
                            } else {
                                ;
                                (0,segment.trackEventAsync)(event_utils/* segmentEvents.OTP_ERROR */.Fh.OTP_ERROR, {
                                    phoneNumber: phoneNumberWithoutZeros,
                                    errorCode: (res === null || res === void 0 ? void 0 : (ref = res.response) === null || ref === void 0 ? void 0 : ref.status) || 200,
                                    errorMessage: res === null || res === void 0 ? void 0 : res.message,
                                    currentPage: router.pathname,
                                    refererUrl: document === null || document === void 0 ? void 0 : document.referrer,
                                    loginStep: utils/* LOGIN_STEPS.VERFY_LOGIN_WITH_TC */.i0.VERFY_LOGIN_WITH_TC
                                });
                            }
                            if (requestAttempt > 5 || !(res === null || res === void 0 ? void 0 : res.success)) {
                                clearInterval(requestInterval);
                                reject("Oops ! Truecaller verification failed. You can login with OTP");
                            }
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            })), 3000);
        });
    };
    var trueCallerCheckout = function(requestId) {
        return new Promise(function(resolve, reject) {
            setTimeout((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (document.hasFocus()) {
                                reject("Looks like you don’t have Truecaller installed. You can login with OTP");
                            } else {
                                resolve(requestId);
                            }
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            })), 600);
        });
    };
    var truecallerLoginManager = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var requestId, res, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        (0,segment.trackClick)(events_utils.pageName.Login_Modal, {
                            widgetName: "Login Modal",
                            widgetFormat: "Modal",
                            contentName: "Login with Truecaller",
                            contentFormat: "Button"
                        });
                        setShowLoader(true);
                        requestId = (0,format/* generateUniqueValue */.UO)();
                        if (!requestId) {
                            _ctx.next = 11;
                            break;
                        }
                        _ctx.next = 6;
                        return LoginApis/* loginApis.initTruecallerLogin */.Z.initTruecallerLogin(requestId);
                    case 6:
                        res = _ctx.sent;
                        if (!(res === null || res === void 0 ? void 0 : res.success)) {
                            ;
                            (0,segment.trackEventAsync)(event_utils/* segmentEvents.OTP_ERROR */.Fh.OTP_ERROR, {
                                phoneNumber: phoneNumberWithoutZeros,
                                errorCode: (res === null || res === void 0 ? void 0 : (ref = res.response) === null || ref === void 0 ? void 0 : ref.status) || 200,
                                errorMessage: res === null || res === void 0 ? void 0 : res.message,
                                currentPage: router.pathname,
                                refererUrl: document === null || document === void 0 ? void 0 : document.referrer,
                                loginStep: utils/* LOGIN_STEPS.LOGIN_WITH_TC */.i0.LOGIN_WITH_TC
                            });
                        }
                        truecallerDeepLink(requestId);
                        _ctx.next = 11;
                        return trueCallerCheckout(requestId).then(truecallerDeepLinkActive).then(truecallerAcceptHandler).catch(truecallerRejectHandler);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function truecallerLoginManager() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginPopup, {
        phone: phone,
        handlePhoneChange: function(e) {
            setPhone(e.target.value);
        },
        activeView: activeView,
        handleViewChange: function(view) {
            return setActiveView(view);
        },
        isModalOpen: isModalOpen,
        handleClose: handleClose,
        generateOtp: generateOtp,
        whatsAppSubscription: whatsAppSubscription,
        otp: otp,
        handleOtpChange: function(val) {
            return setOtp(val);
        },
        validateOtp: validateOtp,
        canClose: canClose,
        title: title,
        imageUrl: imageUrl,
        resendOtp: resendOtp,
        phoneText: ctaText || phoneText,
        phoneErrMsg: phoneErrMsg,
        otpText: otpText,
        otpErrMsg: otpErrMsg,
        otpSuccessMsg: otpSuccessMsg,
        truecallerLoginManager: truecallerLoginManager,
        showTruecaller: showTruecaller,
        showLoader: showLoader,
        phoneInfoMsg: phoneInfoMsg,
        canChangeCountryCode: canChangeCountryCode,
        country: country,
        changeCountry: function(country) {
            return setCountry(country);
        },
        ivrCallRequest: ivrCallRequest,
        ivrMsg: ivrMsg,
        setIvrMsg: setIvrMsg,
        isGeneratingOtp: isGeneratingOtp
    });
};
var mapDispatchToProps = function(dispatch) {
    return {
        saveToken: function(payload) {
            dispatch(AuthActions/* authActions.saveAuth */.Y.saveAuth(payload));
        }
    };
};
/* harmony default export */ var components_Login = ((0,es/* connect */.$j)(null, mapDispatchToProps)(Login));


/***/ }),

/***/ 26411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i0": function() { return /* binding */ LOGIN_STEPS; },
  "WE": function() { return /* binding */ getPixelData; },
  "Qo": function() { return /* binding */ removeLeadingZeros; },
  "tD": function() { return /* binding */ validateAndRedirectForIeltsForm; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./service/api.ts + 1 modules
var api = __webpack_require__(14117);
// EXTERNAL MODULE: ./utils/cookie-utiils.ts
var cookie_utiils = __webpack_require__(51119);
// EXTERNAL MODULE: ./utils/utm_utils.ts
var utm_utils = __webpack_require__(86147);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/native.js
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ var esm_browser_native = ({
  randomUUID
});
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = ((/* unused pure expression or super */ null && (stringify)));
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v4.js




function v4(options, buf, offset) {
  if (esm_browser_native.randomUUID && !buf && !options) {
    return esm_browser_native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);
;// CONCATENATED MODULE: ./components/Login/utils.ts








var LOGIN_STEPS;
(function(LOGIN_STEPS) {
    LOGIN_STEPS["GENERATE_OTP"] = "GENERATE_OTP";
    LOGIN_STEPS["SUBMIT_OTP"] = "SUBMIT_OTP";
    LOGIN_STEPS["RESEND_OTP"] = "RESEND_OTP";
    LOGIN_STEPS["LOGIN_WITH_TC"] = "LOGIN_WITH_TC";
    LOGIN_STEPS["VERFY_LOGIN_WITH_TC"] = "VERFY_LOGIN_WITH_TC";
    LOGIN_STEPS["REGISTER_USER"] = "REGISTER_USER";
})(LOGIN_STEPS || (LOGIN_STEPS = {}));
function removeLeadingZeros(phoneNumber) {
    // Use a regular expression to match and remove leading zeros
    return phoneNumber.replace(/^0+/, "");
}
var validateAndRedirectForIeltsForm = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(callbackUrl, isDownloadPage) {
        var openUrl, decodedUrl, res, ref, success, data, message, requiredFields, isFormNotFilled, redirectUrl;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    openUrl = function(url) {
                        return window.open(url, "_self");
                    };
                    decodedUrl = decodeURIComponent(callbackUrl);
                    if (!(isDownloadPage || (decodedUrl === null || decodedUrl === void 0 ? void 0 : decodedUrl.includes("mock-tests/band-predictor-test")))) {
                        _ctx.next = 21;
                        break;
                    }
                    _ctx.prev = 3;
                    _ctx.next = 6;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=ielts-elite/details");
                case 6:
                    res = _ctx.sent;
                    ref = (res === null || res === void 0 ? void 0 : res.data) || {}, success = ref.success, data = ref.data, message = ref.message;
                    if (!success) {
                        _ctx.next = 12;
                        break;
                    }
                    {
                        requiredFields = [
                            "ieltsExamType",
                            "whenIelts",
                            "whatCareerStage",
                            "name"
                        ];
                        isFormNotFilled = !data || requiredFields.some(function(field) {
                            return !data[field];
                        });
                        redirectUrl = isFormNotFilled ? isDownloadPage ? "/ielts-seo-form/ielts_seo_blog_download?url=".concat(encodeURIComponent(callbackUrl)) : "/ielts-seo-form/ielts_seo_bpt?callbackUrl=".concat(encodeURIComponent(callbackUrl)) : callbackUrl || "";
                        openUrl(redirectUrl);
                    }
                    _ctx.next = 13;
                    break;
                case 12:
                    throw new Error(message);
                case 13:
                    _ctx.next = 19;
                    break;
                case 15:
                    _ctx.prev = 15;
                    _ctx.t0 = _ctx["catch"](3);
                    console.error((_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message) || "Something went wrong. Please try after sometime");
                    openUrl(callbackUrl || "");
                case 19:
                    _ctx.next = 22;
                    break;
                case 21:
                    {
                        openUrl(callbackUrl || "");
                    }
                case 22:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                3,
                15
            ]
        ]);
    }));
    return function validateAndRedirectForIeltsForm(callbackUrl, isDownloadPage) {
        return _ref.apply(this, arguments);
    };
}();
var getPixelData = function() {
    var data = getUtmDataa();
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
        fbc: formatFbClid(data.fbclid, data._fbc)
    });
};
var getUtmDataa = function() {
    var urlParams = new URLSearchParams(window.location.search);
    var utmData = (0,utm_utils/* getUtmData */.M)({});
    return {
        utmSource: urlParams.get("utm_source") || (utmData === null || utmData === void 0 ? void 0 : utmData.utmSource),
        utmCampaign: urlParams.get("utm_campaign") || (utmData === null || utmData === void 0 ? void 0 : utmData.utmCampaign),
        adName: urlParams.get("ad_name") || (utmData === null || utmData === void 0 ? void 0 : utmData.adName),
        utmMedium: urlParams.get("utm_medium") || (utmData === null || utmData === void 0 ? void 0 : utmData.utmMedium),
        utmTerm: urlParams.get("utm_term") || (utmData === null || utmData === void 0 ? void 0 : utmData.utmTerm),
        event_time: new Date().getTime(),
        campaignType: urlParams.get("campaign_type") || (utmData === null || utmData === void 0 ? void 0 : utmData.campaignType),
        adId: urlParams.get("ad_id") || (utmData === null || utmData === void 0 ? void 0 : utmData.adId),
        fbclid: urlParams.get("fbclid") || (utmData === null || utmData === void 0 ? void 0 : utmData.fbclid),
        _fbc: (0,cookie_utiils/* getCookie */.ej)({}, "_fbc") || (utmData === null || utmData === void 0 ? void 0 : utmData._fbc),
        _fbp: (0,cookie_utiils/* getCookie */.ej)({}, "_fbp") || (utmData === null || utmData === void 0 ? void 0 : utmData._fbp),
        gclid: urlParams.get("gclid") || (utmData === null || utmData === void 0 ? void 0 : utmData.gclid),
        action_source: "website",
        event_id: esm_browser_v4(),
        event_source_url: window.location.href
    };
};
var formatFbClid = function(fbclid, fbc) {
    if (fbc !== null) {
        if (!isFbcCorrectFormat(fbc)) {
            console.log("isFbcCorrectFormat false");
            return null;
        }
        return fbc;
    }
    if (fbclid === null) return null;
    var version = "fb";
    var subdomainIndex = "1";
    var creationTime = Date.now();
    var formattedFbclid = "".concat(version, ".").concat(subdomainIndex, ".").concat(creationTime, ".").concat(fbclid);
    return formattedFbclid;
};
var isFbcCorrectFormat = function(fbc) {
    var substringArrays = fbc === null || fbc === void 0 ? void 0 : fbc.split(".");
    return (substringArrays === null || substringArrays === void 0 ? void 0 : substringArrays.length) === 4 && substringArrays[3] !== "" && substringArrays[3] !== " ";
};


/***/ }),

/***/ 43674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ withLogin; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var page_routes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12615);
/* harmony import */ var components_Login__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32847);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14416);
/* harmony import */ var lib_auth_token__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72714);
/* harmony import */ var DataMapper_Profile_StageMapper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91738);
/* harmony import */ var DataMapper_CountryCode__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88237);











var withLogin = function(Component) {
    return function(props) {
        var counsellingStage = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function(state) {
            var ref;
            return state === null || state === void 0 ? void 0 : (ref = state.counselling) === null || ref === void 0 ? void 0 : ref.counsellingStage;
        });
        var authValue = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function(state) {
            var ref, ref1;
            return state === null || state === void 0 ? void 0 : (ref = state.auth) === null || ref === void 0 ? void 0 : (ref1 = ref.auth) === null || ref1 === void 0 ? void 0 : ref1.token;
        });
        var authToken = new lib_auth_token__WEBPACK_IMPORTED_MODULE_6__/* .AuthToken */ .H(authValue);
        var isLoggedIn = authToken && authToken.isValid;
        // ====
        var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
        var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showLoginView = ref[0], setShowLoginView = ref[1];
        var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(function() {
            return void 0;
        }), callback = ref1[0], setCallback = ref1[1];
        var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("Take the first step, to fulfill your study abroad dreams"), title = ref2[0], setTitle = ref2[1];
        var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("Get OTP"), ctaText = ref3[0], setCtaText = ref3[1];
        var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), canClose = ref4[0], setCanClose = ref4[1];
        var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), preFilledPhone = ref5[0], setPrefilledPhone = ref5[1];
        var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), flowType = ref6[0], setFlowType = ref6[1];
        var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), canChangeCountryCode = ref7[0], setCanChangeCountryCode = ref7[1];
        var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(DataMapper_CountryCode__WEBPACK_IMPORTED_MODULE_8__/* .CountryCode.INDIA */ .Cv.INDIA), country = ref8[0], setCountry = ref8[1];
        var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), imageUrl = ref9[0], setImageUrl = ref9[1];
        var initLogin = function() {
            var title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Sign Up To Get Free Counselling", canClose = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, phone = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", flowType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "counselling", callback = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : function(isNewUser) {
                if (isNewUser) {
                    router.push("/spot-counselling");
                } else {
                    router.push(page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.POSTLOGIN_COUNSELLING */ .CZ.POSTLOGIN_COUNSELLING);
                }
            }, countryCode = arguments.length > 5 ? arguments[5] : void 0, ctaText = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "Get OTP", image = arguments.length > 7 ? arguments[7] : void 0;
            setCtaText(ctaText);
            setShowLoginView(true);
            setTitle(title);
            setCanClose(canClose);
            setPrefilledPhone(phone);
            setFlowType(flowType);
            setCallback(function() {
                return callback;
            });
            flowType === "ielts" && setCanChangeCountryCode(true);
            if (countryCode) {
                setCanChangeCountryCode(true);
                setCountry(countryCode);
            }
            if (image) {
                setImageUrl(image);
            }
        };
        var handleSpotCounsellingFlow = function() {
            if (isLoggedIn) {
                // check counselling stage and depending on stage we route user to different urls
                if (counsellingStage && DataMapper_Profile_StageMapper__WEBPACK_IMPORTED_MODULE_7__/* .counsellingStageRank */ .xH[counsellingStage] <= DataMapper_Profile_StageMapper__WEBPACK_IMPORTED_MODULE_7__/* .counsellingStageRank.LS_LEAD_CAPTURED */ .xH.LS_LEAD_CAPTURED) {
                    router.push(page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.SPOT_COUNSELLING */ .CZ.SPOT_COUNSELLING);
                } else {
                    router.push(page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.POSTLOGIN_COUNSELLING */ .CZ.POSTLOGIN_COUNSELLING);
                }
            } else {
                initLogin();
            }
        };
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props), {
                    initLogin: initLogin,
                    handleSpotCounsellingFlow: handleSpotCounsellingFlow
                })),
                showLoginView && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Login__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                    title: "Login",
                    canClose: canClose,
                    handleClose: function() {
                        return setShowLoginView(false);
                    },
                    callback: callback,
                    isModalOpen: showLoginView,
                    preFilledPhone: preFilledPhone,
                    flowType: flowType,
                    resetPreFilledPhone: function() {
                        return setPrefilledPhone("");
                    },
                    canChangeCountryCode: true,
                    country: country,
                    setCountry: setCountry,
                    ctaText: "Continue",
                    imageUrl: imageUrl
                })
            ]
        });
    };
};


/***/ }),

/***/ 48310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ meetCounsellerActions; }
/* harmony export */ });
var fetchExpertsData = function() {
    return {
        type: "FETCH_EXPERTS_DATA"
    };
};
var fetchExpertsSuccess = function(payload) {
    return {
        type: "FETCH_EXPERTS_DATA_SUCCESS",
        payload: payload
    };
};
var fetchExpertsFail = function(message) {
    return {
        type: "FETCH_EXPERTS_DATA_FAIL",
        payload: message
    };
};
var fetchMeetCounsellerSlot = function() {
    return {
        type: "FETCH_MEET_COUNSELLER_SLOT"
    };
};
var fetchMeetCounsellerSlotSuccess = function(payload) {
    return {
        type: "FETCH_MEET_COUNSELLER_SLOT_SUCCESS",
        payload: payload
    };
};
var fetchMeetCounsellerSlotFail = function(message) {
    return {
        type: "FETCH_MEET_COUNSELLER_SLOT_FAIL",
        payload: message
    };
};
var fetchTypedMeetCounsellerSlot = function(payload) {
    return {
        type: "FETCH_TYPED_MEET_COUNSELLER_SLOT",
        payload: payload
    };
};
var fetchTypedMeetCounsellerSlotSuccess = function(payload) {
    return {
        type: "FETCH_TYPED_MEET_COUNSELLER_SLOT_SUCCESS",
        payload: payload
    };
};
var fetchTypedMeetCounsellerSlotFail = function(message) {
    return {
        type: "FETCH_TYPED_MEET_COUNSELLER_SLOT_FAIL",
        payload: message
    };
};
var confirmMeetCounsellerSlot = function(payload) {
    return {
        type: "CONFIRM_MEET_COUNSELLER_SLOT",
        payload: payload
    };
};
var confirmMeetCounsellerSlotSuccess = function(payload) {
    return {
        type: "CONFIRM_MEET_COUNSELLER_SLOT_SUCCESS",
        payload: payload
    };
};
var confirmMeetCounsellerSlotFail = function(message) {
    return {
        type: "CONFIRM_MEET_COUNSELLER_SLOT_FAIL",
        payload: message
    };
};
var confirmRescheduleSlot = function(payload) {
    return {
        type: "CONFIRM_RESCHEDULE_SLOT",
        payload: payload
    };
};
var confirmRescheduleSlotSuccess = function(payload) {
    return {
        type: "CONFIRM_RESCHEDULE_SLOT_SUCCESS",
        payload: payload
    };
};
var confirmRescheduleSlotFail = function(message) {
    return {
        type: "CONFIRM_RESCHEDULE_SLOT_FAIL",
        payload: message
    };
};
var fetchMeetProfile = function() {
    return {
        type: "FETCH_MEET_PROFILE"
    };
};
var fetchMeetProfileSuccess = function(payload) {
    return {
        type: "FETCH_MEET_PROFILE_SUCCESS",
        payload: payload
    };
};
var fetchMeetProfileFail = function(message) {
    return {
        type: "FETCH_MEET_PROFILE_FAIL",
        payload: message
    };
};
var submitMeetProfile = function(payload) {
    return {
        type: "SUBMIT_MEET_PROFILE",
        payload: payload
    };
};
var submitMeetProfileSuccess = function(payload) {
    return {
        type: "SUBMIT_MEET_PROFILE_SUCCESS",
        payload: payload
    };
};
var submitMeetProfileFail = function(message) {
    return {
        type: "SUBMIT_MEET_PROFILE_FAIL",
        payload: message
    };
};
var fetchVisaCounsellerSlotFail = function(message) {
    return {
        type: "FETCH_VISA_COUNSELLER_SLOT_FAIL",
        payload: message
    };
};
var fetchVisaCounsellerSlot = function(payload) {
    return {
        type: "FETCH_VISA_COUNSELLER_SLOT",
        payload: payload
    };
};
var fetchVisaCounsellerSlotSuccess = function(payload) {
    return {
        type: "FETCH_VISA_COUNSELLER_SLOT_SUCCESS",
        payload: payload
    };
};
var meetCounsellerActions = {
    fetchExpertsData: fetchExpertsData,
    fetchExpertsSuccess: fetchExpertsSuccess,
    fetchExpertsFail: fetchExpertsFail,
    fetchMeetCounsellerSlot: fetchMeetCounsellerSlot,
    fetchMeetCounsellerSlotSuccess: fetchMeetCounsellerSlotSuccess,
    fetchMeetCounsellerSlotFail: fetchMeetCounsellerSlotFail,
    confirmMeetCounsellerSlot: confirmMeetCounsellerSlot,
    confirmMeetCounsellerSlotSuccess: confirmMeetCounsellerSlotSuccess,
    confirmMeetCounsellerSlotFail: confirmMeetCounsellerSlotFail,
    confirmRescheduleSlot: confirmRescheduleSlot,
    confirmRescheduleSlotSuccess: confirmRescheduleSlotSuccess,
    confirmRescheduleSlotFail: confirmRescheduleSlotFail,
    fetchMeetProfile: fetchMeetProfile,
    fetchMeetProfileSuccess: fetchMeetProfileSuccess,
    fetchMeetProfileFail: fetchMeetProfileFail,
    submitMeetProfile: submitMeetProfile,
    submitMeetProfileSuccess: submitMeetProfileSuccess,
    submitMeetProfileFail: submitMeetProfileFail,
    fetchTypedMeetCounsellerSlot: fetchTypedMeetCounsellerSlot,
    fetchTypedMeetCounsellerSlotSuccess: fetchTypedMeetCounsellerSlotSuccess,
    fetchTypedMeetCounsellerSlotFail: fetchTypedMeetCounsellerSlotFail,
    fetchVisaCounsellerSlot: fetchVisaCounsellerSlot,
    fetchVisaCounsellerSlotFail: fetchVisaCounsellerSlotFail,
    fetchVisaCounsellerSlotSuccess: fetchVisaCounsellerSlotSuccess
};


/***/ }),

/***/ 16902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ chatActions; },
/* harmony export */   "Y": function() { return /* binding */ chatActionsConstants; }
/* harmony export */ });
var chatActionsConstants = {
    QUERY_RAISE_API: "QUERY_RAISE_API",
    QUERY_RAISE_API_SUCCESS: "QUERY_RAISE_API_SUCCESS",
    QUERY_RAISE_API_ERROR: "QUERY_RAISE_API_ERROR",
    RESET_QUERY_STATE: "RESET_QUERY_STATE"
};
var queryRiseApi = function(payload) {
    return {
        type: chatActionsConstants.QUERY_RAISE_API,
        payload: payload
    };
};
var resetQuery = function() {
    return {
        type: chatActionsConstants.RESET_QUERY_STATE
    };
};
var chatActions = {
    queryRiseApi: queryRiseApi,
    resetQuery: resetQuery
};


/***/ }),

/***/ 4421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ onboardingActions; },
/* harmony export */   "j": function() { return /* binding */ onboardingActionConstants; }
/* harmony export */ });
var onboardingActionConstants = {
    ADD_COUNTRY: "ADD_COUNTRY",
    DELETE_COUNTRY: "DELETE_COUNTRY",
    SET_EDIT_MODE: "SET_EDIT_MODE",
    HANDLE_STEP: "HANDLE_STEP",
    SET_COMPLETE: "SET_COMPLETE",
    TOGGLE_SKIP_MODAL: "TOGGLE_SKIP_MODAL",
    CHECK_FORM: "CHECK_FORM",
    HANDLE_TAB_SELECT: "HANDLE_TAB_SELECT",
    SET_FIRST_STEP_DATA: "SET_FIRST_STEP_DATA",
    SAVE_FIRST_STEP: "SAVE_FIRST_STEP",
    SET_CURRENT_PROGRESS: "SET_CURRENT_PROGRESS",
    SET_COUNTRY_FORM_DATA: "SET_COUNTRY_FORM_DATA",
    SET_FORM_VALIDATION: "SET_FORM_VALIDATION",
    SHOW_FIRST_STEP_ERROR: "SHOW_FIRST_STEP_ERROR",
    SUBMIT_FIRST_STEP: "SUBMIT_FIRST_STEP",
    SUBMIT_FIRST_STEP_SUCCESS: "SUBMIT_FIRST_STEP_SUCCESS",
    SUBMIT_FIRST_STEP_ERROR: "SUBMIT_FIRST_STEP_ERROR",
    FETCH_INITIAL_DATA: "FETCH_INITIAL_DATA",
    FETCH_INITIAL_DATA_SUCCESS: "FETCH_INITIAL_DATA_SUCCESS",
    FETCH_INITIAL_DATA_ERROR: "FETCH_INITIAL_DATA_ERROR",
    SET_HIGHEST_EDUCATION: "SET_HIGHEST_EDUCATION",
    VALIDATE_EDUCATION_FORM: "VALIDATE_EDUCATION_FORM",
    CHECK_EDUCATION_FORM: "CHECK_EDUCATION_FORM",
    SET_EDUCATION_FORM_DATA: "SET_EDUCATION_FORM_DATA",
    SUBMIT_EDUCATION_DETAILS: "SUBMIT_EDUCATION_DETAILS",
    SUBMIT_EDUCATION_DETAILS_SUCCESS: "SUBMIT_EDUCATION_DETAILS_SUCCESS",
    SUBMIT_EDUCATION_DETAILS_ERROR: "SUBMIT_EDUCATION_DETAILS_ERROR",
    SUBMIT_PREPARATION_STAGE: "SUBMIT_PREPARATION_STAGE",
    SUBMIT_PREPARATION_STAGE_SUCCESS: "SUBMIT_PREPARATION_STAGE_SUCCESS",
    SUBMIT_PREPARATION_STAGE_ERROR: "SUBMIT_PREPARATION_STAGE_ERROR",
    CHECK_EXAM_FORM: "CHECK_EXAM_FORM",
    TOGGLE_SUCCESS_MODAL: "TOGGLE_SUCCESS_MODAL",
    SUBMIT_EXAM_FORM_DATA: "SUBMIT_EXAM_FORM_DATA",
    SUBMIT_EXAM_FORM_DATA_SUCCESS: "SUBMIT_EXAM_FORM_DATA_SUCCESS",
    SUBMIT_EXAM_FORM_DATA_ERROR: "SUBMIT_EXAM_FORM_DATA_ERROR",
    SET_PREPARATION_STAGE: "SET_PREPARATION_STAGE",
    SUBMIT_COLLEGE_FORMS: "SUBMIT_COLLEGE_FORMS",
    SUBMIT_COLLEGE_FORMS_SUCCESS: "SUBMIT_COLLEGE_FORMS_SUCCESS",
    SUBMIT_COLLEGE_FORMS_ERROR: "SUBMIT_COLLEGE_FORMS_ERROR",
    FETCH_CITY_FROM_COUNTRY: "FETCH_CITY_FROM_COUNTRY",
    FETCH_CITY_FROM_COUNTRY_SUCCESS: "FETCH_CITY_FROM_COUNTRY_SUCCESS",
    FETCH_CITY_FROM_COUNTRY_ERROR: "FETCH_CITY_FROM_COUNTRY_ERROR",
    FETCH_PREFERRED_PROGRAMS: "FETCH_PREFERRED_PROGRAMS",
    FETCH_PREFERRED_PROGRAMS_SUCCESS: "FETCH_PREFERRED_PROGRAMS_SUCCESS",
    FETCH_PREFERRED_PROGRAMS_ERROR: "FETCH_PREFERRED_PROGRAMS_ERROR",
    GET_PREFERRED_LOCATION_LISTS: "GET_PREFERRED_LOCATION_LISTS",
    GET_PREFERRED_LOCATION_LISTS_SUCCESS: "GET_PREFERRED_LOCATION_LISTS_SUCCESS",
    GET_PREFERRED_LOCATION_LISTS_ERROR: "GET_PREFERRED_LOCATION_LISTS_ERROR",
    DELETE_COUNTRY_FROM_FORM_DATA: "DELETE_COUNTRY_FROM_FORM_DATA",
    DELETE_COUNTRY_FROM_FORM_DATA_SUCCESS: "DELETE_COUNTRY_FROM_FORM_DATA_SUCCESS",
    DELETE_COUNTRY_FROM_FORM_DATA_ERROR: "DELETE_COUNTRY_FROM_FORM_DATA_ERROR",
    SET_SUBMITTING_COUNTRY_FORM: "SET_SUBMITTING_COUNTRY_FORM",
    GET_PREFERRED_COUNTRY_ID_LISTS_SUCCESS: "GET_PREFERRED_COUNTRY_ID_LISTS_SUCCESS",
    GET_PREFERRED_COUNTRY_ID_LISTS: "GET_PREFERRED_COUNTRY_ID_LISTS",
    GET_PREFERRED_COUNTRY_ID_LISTS_ERROR: "GET_PREFERRED_COUNTRY_ID_LISTS_ERROR",
    GET_PREFERRED_PROGRAM_COURSE_LISTS_SUCCESS: "GET_PREFERRED_PROGRAM_COURSE_LISTS_SUCCESS",
    GET_PREFERRED_PROGRAM_COURSE_LISTS: "GET_PREFERRED_PROGRAM_COURSE_LISTS",
    GET_PREFERRED_PROGRAM_COURSE_LISTS_ERROR: "GET_PREFERRED_PROGRAM_COURSE_LISTS_ERROR",
    HANDLE_NEXT_CLICKED: "HANDLE_NEXT_CLICKED",
    IELTS_REQUIRED: "IELTS_REQUIRED",
    IELTS_STATUS: "IELTS_STATUS"
};
var addCountry = function(payload) {
    return {
        type: onboardingActionConstants.ADD_COUNTRY,
        payload: payload
    };
};
var deleteCountry = function(payload) {
    return {
        type: onboardingActionConstants.DELETE_COUNTRY,
        payload: payload
    };
};
var setEditMode = function(payload) {
    return {
        type: onboardingActionConstants.SET_EDIT_MODE,
        payload: payload
    };
};
var handleStep = function(payload) {
    return {
        type: onboardingActionConstants.HANDLE_STEP,
        payload: payload
    };
};
var setComplete = function(payload) {
    return {
        type: onboardingActionConstants.SET_COMPLETE,
        payload: payload
    };
};
var toggleSkipModal = function(payload) {
    return {
        type: onboardingActionConstants.TOGGLE_SKIP_MODAL,
        payload: payload
    };
};
var checkForm = function(payload) {
    return {
        type: onboardingActionConstants.CHECK_FORM,
        payload: payload
    };
};
var handleTabSelect = function(payload) {
    return {
        type: onboardingActionConstants.HANDLE_TAB_SELECT,
        payload: payload
    };
};
var setFirstStepData = function(payload) {
    return {
        type: onboardingActionConstants.SET_FIRST_STEP_DATA,
        payload: payload
    };
};
var saveFirstStep = function() {
    return {
        type: onboardingActionConstants.SAVE_FIRST_STEP
    };
};
var setCurrentProgress = function(payload) {
    return {
        type: onboardingActionConstants.SET_CURRENT_PROGRESS,
        payload: payload
    };
};
var setCountryFormData = function(payload) {
    return {
        type: onboardingActionConstants.SET_COUNTRY_FORM_DATA,
        payload: payload
    };
};
var setFormValidation = function(payload) {
    return {
        type: onboardingActionConstants.SET_FORM_VALIDATION,
        payload: payload
    };
};
var showFirstStepError = function(payload) {
    return {
        type: onboardingActionConstants.SHOW_FIRST_STEP_ERROR,
        payload: payload
    };
};
var handleNext = function(payload) {
    return {
        type: onboardingActionConstants.HANDLE_NEXT_CLICKED,
        payload: payload
    };
};
var submitFirstStep = function(payload) {
    return {
        type: onboardingActionConstants.SUBMIT_FIRST_STEP,
        payload: payload
    };
};
var setPreparationStage = function(payload) {
    return {
        type: onboardingActionConstants.SET_PREPARATION_STAGE,
        payload: payload
    };
};
var submitFirstStepSuccess = function(payload) {
    return {
        type: onboardingActionConstants.SUBMIT_FIRST_STEP_SUCCESS,
        payload: payload
    };
};
var submitFirstStepError = function(payload) {
    return {
        type: onboardingActionConstants.SUBMIT_FIRST_STEP_ERROR,
        payload: payload
    };
};
var fetchInitialData = function() {
    return {
        type: onboardingActionConstants.FETCH_INITIAL_DATA
    };
};
var fetchInitialDataSuccess = function(payload) {
    return {
        type: onboardingActionConstants.FETCH_INITIAL_DATA_SUCCESS,
        payload: payload
    };
};
var fetchInitialDataError = function(payload) {
    return {
        type: onboardingActionConstants.FETCH_INITIAL_DATA_ERROR,
        payload: payload
    };
};
var setHighestEducation = function(payload) {
    return {
        type: onboardingActionConstants.SET_HIGHEST_EDUCATION,
        payload: payload
    };
};
var validateEducationForm = function(payload) {
    return {
        type: onboardingActionConstants.VALIDATE_EDUCATION_FORM,
        payload: payload
    };
};
var checkEducationForm = function(payload) {
    return {
        type: onboardingActionConstants.CHECK_EDUCATION_FORM,
        payload: payload
    };
};
var setEducationFormData = function(payload) {
    return {
        type: onboardingActionConstants.SET_EDUCATION_FORM_DATA,
        payload: payload
    };
};
var submitEducationDetails = function(payload) {
    return {
        type: onboardingActionConstants.SUBMIT_EDUCATION_DETAILS,
        payload: payload
    };
};
var submitEducationDetailsSuccess = function(payload) {
    return {
        type: onboardingActionConstants.SUBMIT_EDUCATION_DETAILS_SUCCESS,
        payload: payload
    };
};
var submitEducationDetailsError = function(payload) {
    return {
        type: onboardingActionConstants.SUBMIT_EDUCATION_DETAILS_ERROR,
        payload: payload
    };
};
var submitCollegeForms = function(payload) {
    return {
        type: onboardingActionConstants.SUBMIT_COLLEGE_FORMS,
        payload: payload
    };
};
var submitCollegeFormsSuccess = function(payload) {
    return {
        type: onboardingActionConstants.SUBMIT_COLLEGE_FORMS_SUCCESS,
        payload: payload
    };
};
var submitCollegeFormsError = function(payload) {
    return {
        type: onboardingActionConstants.SUBMIT_COLLEGE_FORMS_ERROR,
        payload: payload
    };
};
var submitPreparationStage = function(payload) {
    return {
        type: onboardingActionConstants.SUBMIT_PREPARATION_STAGE,
        payload: payload
    };
};
var submitPreparationStageSuccess = function(payload) {
    return {
        type: onboardingActionConstants.SUBMIT_PREPARATION_STAGE_SUCCESS,
        payload: payload
    };
};
var submitPreparationStageError = function(payload) {
    return {
        type: onboardingActionConstants.SUBMIT_PREPARATION_STAGE_ERROR,
        payload: payload
    };
};
var checkExamForm = function(payload) {
    return {
        type: onboardingActionConstants.CHECK_EXAM_FORM,
        payload: payload
    };
};
var toggleSuccessModal = function(payload) {
    return {
        type: onboardingActionConstants.TOGGLE_SUCCESS_MODAL,
        payload: payload
    };
};
var submitExamFormData = function(payload) {
    return {
        type: onboardingActionConstants.SUBMIT_EXAM_FORM_DATA,
        payload: payload
    };
};
var submitExamFormDataSuccess = function(payload) {
    return {
        type: onboardingActionConstants.SUBMIT_EXAM_FORM_DATA_SUCCESS,
        payload: payload
    };
};
var submitExamFormDataError = function(payload) {
    return {
        type: onboardingActionConstants.SUBMIT_EXAM_FORM_DATA_ERROR,
        payload: payload
    };
};
var fetchCityFromCountry = function(payload) {
    return {
        type: onboardingActionConstants.FETCH_CITY_FROM_COUNTRY,
        payload: payload
    };
};
var fetchCityFromCountrySuccess = function(payload) {
    return {
        type: onboardingActionConstants.FETCH_CITY_FROM_COUNTRY_SUCCESS,
        payload: payload
    };
};
var fetchCityFromCountryError = function(payload) {
    return {
        type: onboardingActionConstants.FETCH_CITY_FROM_COUNTRY_ERROR,
        payload: payload
    };
};
var fetchPreferredPrograms = function(payload) {
    return {
        type: onboardingActionConstants.FETCH_PREFERRED_PROGRAMS,
        payload: payload
    };
};
var fetchPreferredProgramsSuccess = function(payload) {
    return {
        type: onboardingActionConstants.FETCH_PREFERRED_PROGRAMS_SUCCESS,
        payload: payload
    };
};
var fetchPreferredProgramsError = function(payload) {
    return {
        type: onboardingActionConstants.FETCH_PREFERRED_PROGRAMS_ERROR,
        payload: payload
    };
};
var getPreferredLocationLists = function(payload) {
    return {
        type: onboardingActionConstants.GET_PREFERRED_LOCATION_LISTS,
        payload: payload
    };
};
var getPreferredLocationListsSuccess = function(payload) {
    return {
        type: onboardingActionConstants.GET_PREFERRED_LOCATION_LISTS_SUCCESS,
        payload: payload
    };
};
var getPreferredLocationListsError = function(payload) {
    return {
        type: onboardingActionConstants.GET_PREFERRED_LOCATION_LISTS_ERROR,
        payload: payload
    };
};
var getPreferredProgramCourseLists = function(payload) {
    return {
        type: onboardingActionConstants.GET_PREFERRED_PROGRAM_COURSE_LISTS,
        payload: payload
    };
};
var getPreferredProgramCourseListsSuccess = function(payload) {
    return {
        type: onboardingActionConstants.GET_PREFERRED_PROGRAM_COURSE_LISTS_SUCCESS,
        payload: payload
    };
};
var getPreferredProgramCourseListsError = function(payload) {
    return {
        type: onboardingActionConstants.GET_PREFERRED_PROGRAM_COURSE_LISTS_ERROR,
        payload: payload
    };
};
var getPreferredCountryIdLists = function(payload) {
    return {
        type: onboardingActionConstants.GET_PREFERRED_COUNTRY_ID_LISTS,
        payload: payload
    };
};
var getPreferredCountryIdListsSuccess = function(payload) {
    return {
        type: onboardingActionConstants.GET_PREFERRED_COUNTRY_ID_LISTS_SUCCESS,
        payload: payload
    };
};
var getPreferredCountryIdListsError = function(payload) {
    return {
        type: onboardingActionConstants.GET_PREFERRED_COUNTRY_ID_LISTS_ERROR,
        payload: payload
    };
};
var deleteCountryFromFormData = function(payload) {
    return {
        type: onboardingActionConstants.DELETE_COUNTRY_FROM_FORM_DATA,
        payload: payload
    };
};
var deleteCountryFromFormDataSuccess = function(payload) {
    return {
        type: onboardingActionConstants.DELETE_COUNTRY_FROM_FORM_DATA_SUCCESS,
        payload: payload
    };
};
var deleteCountryFromFormDataError = function(payload) {
    return {
        type: onboardingActionConstants.DELETE_COUNTRY_FROM_FORM_DATA_ERROR,
        payload: payload
    };
};
var setSubmittingCountryForm = function(payload) {
    return {
        type: onboardingActionConstants.SET_SUBMITTING_COUNTRY_FORM,
        payload: payload
    };
};
var setIeltsRequired = function(payload) {
    return {
        type: onboardingActionConstants.IELTS_REQUIRED,
        payload: payload
    };
};
var setIeltsStatus = function(payload) {
    return {
        type: onboardingActionConstants.IELTS_STATUS,
        payload: payload
    };
};
var onboardingActions = {
    addCountry: addCountry,
    deleteCountry: deleteCountry,
    setEditMode: setEditMode,
    handleStep: handleStep,
    setComplete: setComplete,
    toggleSkipModal: toggleSkipModal,
    checkForm: checkForm,
    handleTabSelect: handleTabSelect,
    setFirstStepData: setFirstStepData,
    saveFirstStep: saveFirstStep,
    setCurrentProgress: setCurrentProgress,
    setCountryFormData: setCountryFormData,
    setFormValidation: setFormValidation,
    showFirstStepError: showFirstStepError,
    submitFirstStep: submitFirstStep,
    submitFirstStepSuccess: submitFirstStepSuccess,
    submitFirstStepError: submitFirstStepError,
    submitPreparationStage: submitPreparationStage,
    submitPreparationStageSuccess: submitPreparationStageSuccess,
    submitPreparationStageError: submitPreparationStageError,
    fetchInitialData: fetchInitialData,
    fetchInitialDataSuccess: fetchInitialDataSuccess,
    fetchInitialDataError: fetchInitialDataError,
    setHighestEducation: setHighestEducation,
    validateEducationForm: validateEducationForm,
    checkEducationForm: checkEducationForm,
    setEducationFormData: setEducationFormData,
    submitEducationDetails: submitEducationDetails,
    submitEducationDetailsSuccess: submitEducationDetailsSuccess,
    submitEducationDetailsError: submitEducationDetailsError,
    checkExamForm: checkExamForm,
    toggleSuccessModal: toggleSuccessModal,
    submitExamFormData: submitExamFormData,
    submitExamFormDataSuccess: submitExamFormDataSuccess,
    submitExamFormDataError: submitExamFormDataError,
    setPreparationStage: setPreparationStage,
    submitCollegeFormsError: submitCollegeFormsError,
    submitCollegeForms: submitCollegeForms,
    submitCollegeFormsSuccess: submitCollegeFormsSuccess,
    fetchCityFromCountry: fetchCityFromCountry,
    fetchCityFromCountrySuccess: fetchCityFromCountrySuccess,
    fetchCityFromCountryError: fetchCityFromCountryError,
    fetchPreferredPrograms: fetchPreferredPrograms,
    fetchPreferredProgramsSuccess: fetchPreferredProgramsSuccess,
    fetchPreferredProgramsError: fetchPreferredProgramsError,
    deleteCountryFromFormData: deleteCountryFromFormData,
    deleteCountryFromFormDataSuccess: deleteCountryFromFormDataSuccess,
    deleteCountryFromFormDataError: deleteCountryFromFormDataError,
    setSubmittingCountryForm: setSubmittingCountryForm,
    getPreferredLocationLists: getPreferredLocationLists,
    getPreferredLocationListsSuccess: getPreferredLocationListsSuccess,
    getPreferredLocationListsError: getPreferredLocationListsError,
    getPreferredProgramCourseLists: getPreferredProgramCourseLists,
    getPreferredProgramCourseListsSuccess: getPreferredProgramCourseListsSuccess,
    getPreferredProgramCourseListsError: getPreferredProgramCourseListsError,
    getPreferredCountryIdLists: getPreferredCountryIdLists,
    getPreferredCountryIdListsSuccess: getPreferredCountryIdListsSuccess,
    getPreferredCountryIdListsError: getPreferredCountryIdListsError,
    handleNext: handleNext,
    setIeltsRequired: setIeltsRequired,
    setIeltsStatus: setIeltsStatus
};


/***/ }),

/***/ 66377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ onboardingApi; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var service_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14117);



var submitFirstStepRequest = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/scholarRoute?path=student/info/preparation-stage/".concat(data, "?step=1"));
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 8:
                    return _ctx.abrupt("return", false);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function submitFirstStepRequest(data) {
        return _ref.apply(this, arguments);
    };
}();
var fetchInitialDataRequest = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=student/info/onboard-info/v2");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res);
                case 8:
                    return _ctx.abrupt("return", false);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchInitialDataRequest() {
        return _ref.apply(this, arguments);
    };
}();
var submitEducationDetailsRequest = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/scholarRoute?path=student/info/education-details?step=3", data);
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 8:
                    return _ctx.abrupt("return", false);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function submitEducationDetailsRequest(data) {
        return _ref.apply(this, arguments);
    };
}();
var deleteCountryFromFormData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/scholarRoute?path=student/info/country-details/delete/".concat(id));
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function deleteCountryFromFormData(id) {
        return _ref.apply(this, arguments);
    };
}();
var submitCollegeFormsRequest = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/scholarRoute?path=student/info/country-details/update/v2?step=2", data);
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 8:
                    return _ctx.abrupt("return", false);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function submitCollegeFormsRequest(data) {
        return _ref.apply(this, arguments);
    };
}();
var submitExamFormRequest = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/scholarRoute?path=student/info/misc-details?step=4", data);
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 8:
                    return _ctx.abrupt("return", false);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function submitExamFormRequest(data) {
        return _ref.apply(this, arguments);
    };
}();
var fetchPreferredPrograms = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/seoRoute?path=course/substream/listAll");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 8:
                    return _ctx.abrupt("return", false);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchPreferredPrograms() {
        return _ref.apply(this, arguments);
    };
}();
var getPreferredLocationLists = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        var ref, res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/seoRoute?path=cities/suggestions", data);
                case 4:
                    res = _ctx.sent;
                    if (!(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", res);
                case 9:
                    return _ctx.abrupt("return", false);
                case 10:
                    _ctx.next = 15;
                    break;
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }));
    return function getPreferredLocationLists(data) {
        return _ref.apply(this, arguments);
    };
}();
var getPreferredProgramCourseLists = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        var ref, res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/seoRoute?path=course/substream/suggestions", data);
                case 4:
                    res = _ctx.sent;
                    if (!(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", res);
                case 9:
                    return _ctx.abrupt("return", false);
                case 10:
                    _ctx.next = 15;
                    break;
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }));
    return function getPreferredProgramCourseLists(data) {
        return _ref.apply(this, arguments);
    };
}();
var getPreferredCountryIdLists = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/seoRoute?path=country/listAll");
                case 4:
                    res = _ctx.sent;
                    if (!(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", res);
                case 9:
                    return _ctx.abrupt("return", false);
                case 10:
                    _ctx.next = 15;
                    break;
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }));
    return function getPreferredCountryIdLists() {
        return _ref.apply(this, arguments);
    };
}();
var fetchCityListFromCountry = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(country) {
        var getCountry, res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    getCountry = function() {
                        var c = "";
                        if (country == "USA") {
                            c = "United States";
                        } else if (country == "UK") {
                            c = "United Kingdom";
                        } else {
                            c = country;
                        }
                        return c;
                    };
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=value-object/countries/".concat(getCountry(), "/cities"));
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](1);
                    throw new Error("Something went wrong. Please refresh the page");
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                8
            ]
        ]);
    }));
    return function fetchCityListFromCountry(country) {
        return _ref.apply(this, arguments);
    };
}();
var getAllCountryData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/seoRoute?path=country/listAll");
                case 4:
                    res = _ctx.sent;
                    if (!(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 9:
                    return _ctx.abrupt("return", false);
                case 10:
                    _ctx.next = 15;
                    break;
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }));
    return function getAllCountryData() {
        return _ref.apply(this, arguments);
    };
}();
var onboardingApi = {
    submitFirstStepRequest: submitFirstStepRequest,
    fetchInitialDataRequest: fetchInitialDataRequest,
    submitEducationDetailsRequest: submitEducationDetailsRequest,
    submitExamFormRequest: submitExamFormRequest,
    submitCollegeFormsRequest: submitCollegeFormsRequest,
    fetchCityListFromCountry: fetchCityListFromCountry,
    deleteCountryFromFormData: deleteCountryFromFormData,
    fetchPreferredPrograms: fetchPreferredPrograms,
    getPreferredLocationLists: getPreferredLocationLists,
    getPreferredCountryIdLists: getPreferredCountryIdLists,
    getPreferredProgramCourseLists: getPreferredProgramCourseLists,
    getAllCountryData: getAllCountryData
};


/***/ }),

/***/ 90813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ paymentApi; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var service_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14117);



var fetchUserDetailsForPayment = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=student/pre/webinar/payment");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error(_ctx.t0 || "Something went wrong. Please refresh the page");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchUserDetailsForPayment() {
        return _ref.apply(this, arguments);
    };
}();
var fetchPaymentData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(payload) {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/scholarRoute?path=student/pre/webinar/payment/update", payload);
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error(_ctx.t0 || "Something went wrong. Please refresh the page");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchPaymentData(payload) {
        return _ref.apply(this, arguments);
    };
}();
var validatePromoCode = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(promo) {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/scholarOpenRoute?path=promocode/apply/".concat(promo), {
                        bundleId: 0
                    });
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error(_ctx.t0 || "Something went wrong. Please refresh the page");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function validatePromoCode(promo) {
        return _ref.apply(this, arguments);
    };
}();
// const initilizePayment = async () => {
//   try {
//     const res = await api.get(
//       `/api/scholarRoute?path=profile/post/visa-counsellor`
//     );
//     if (res.data.success) {
//       return res.data.data;
//     } else {
//       throw new Error(res.data.message);
//     }
//   } catch (err: any) {
//     throw new Error(err || "Something went wrong. Please refresh the page");
//   }
// };
var fetchPaymentDetails = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(payload) {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=payment/info/".concat(payload));
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        success: false,
                        message: "Something went wrong"
                    });
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchPaymentDetails(payload) {
        return _ref.apply(this, arguments);
    };
}();
var paymentApi = {
    fetchPaymentDetails: fetchPaymentDetails,
    fetchPaymentData: fetchPaymentData,
    validatePromoCode: validatePromoCode,
    //initilizePayment,
    fetchUserDetailsForPayment: fetchUserDetailsForPayment
};


/***/ }),

/***/ 27839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$8": function() { return /* binding */ fetchGetWordOfTheDay; },
/* harmony export */   "JO": function() { return /* binding */ setWordOfTheDayError; },
/* harmony export */   "KW": function() { return /* binding */ setWordLikeCount; },
/* harmony export */   "ln": function() { return /* binding */ setWordOfTheDayLoading; },
/* harmony export */   "qf": function() { return /* binding */ setWordOfTheDayData; },
/* harmony export */   "rB": function() { return /* binding */ fetchPostWordLike; },
/* harmony export */   "vI": function() { return /* binding */ setUserLikeStatus; }
/* harmony export */ });
/* unused harmony export wordOfTheDayStateName */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27272);



var wordOfTheDayStateName = "WordOfTheDay";
var initialState = {
    isLoading: false,
    error: "",
    wordOfTheDayResponse: null,
    wordLikeCount: null,
    userLikeStatus: null
};
var fetchGetWordOfTheDay = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("".concat(wordOfTheDayStateName, "/fetchWordOfTheDay"));
var fetchPostWordLike = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("".concat(wordOfTheDayStateName, "/fetchPostWordLike"));
var WordOfTheDaySlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: wordOfTheDayStateName,
    initialState: initialState,
    reducers: {
        setWordOfTheDayLoading: function setWordOfTheDayLoading(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                isLoading: action.payload
            });
        },
        setWordOfTheDayError: function setWordOfTheDayError(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                error: action.payload
            });
        },
        setWordOfTheDayData: function setWordOfTheDayData(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                wordOfTheDayResponse: action.payload
            });
        },
        setWordLikeCount: function setWordLikeCount(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                wordLikeCount: action.payload
            });
        },
        setUserLikeStatus: function setUserLikeStatus(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                userLikeStatus: action.payload
            });
        }
    }
});
var _actions = WordOfTheDaySlice.actions;
var setWordOfTheDayError = _actions.setWordOfTheDayError, setWordOfTheDayLoading = _actions.setWordOfTheDayLoading, setWordOfTheDayData = _actions.setWordOfTheDayData, setWordLikeCount = _actions.setWordLikeCount, setUserLikeStatus = _actions.setUserLikeStatus;
/* harmony default export */ __webpack_exports__["ZP"] = (WordOfTheDaySlice.reducer);


/***/ }),

/***/ 52828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DX": function() { return /* binding */ setUpdateVideoCompletionError; },
/* harmony export */   "Uk": function() { return /* binding */ fetchPracticeTabData; },
/* harmony export */   "b2": function() { return /* binding */ fetchUpdateVideoCompletionAction; },
/* harmony export */   "lg": function() { return /* binding */ setPractiseError; },
/* harmony export */   "wC": function() { return /* binding */ setUpdateVideoCompletionLoading; },
/* harmony export */   "wP": function() { return /* binding */ setPractiseData; }
/* harmony export */ });
/* unused harmony exports ModuleType, setPractiseLoading, setUpdateVideoCompletionSuccess */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27272);



var ModuleType;
(function(ModuleType) {
    ModuleType["header"] = "header";
    ModuleType["video"] = "video";
})(ModuleType || (ModuleType = {}));
var initialState = {
    isLoading: false,
    error: "",
    moduleData: null,
    videoUpdateCompletionLoading: false,
    videoUpdateCompletionError: false
};
var fetchPracticeTabData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("practiseTab/fetchAndroidData");
var fetchUpdateVideoCompletionAction = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("practiseTab/fetchUpdateVideoCompletionAction");
var practiseAppSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "practiseTab",
    initialState: initialState,
    reducers: {
        setPractiseLoading: function setPractiseLoading(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                isLoading: action.payload
            });
        },
        setPractiseError: function setPractiseError(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                error: action.payload
            });
        },
        setPractiseData: function setPractiseData(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                moduleData: action.payload
            });
        },
        setUpdateVideoCompletionLoading: function setUpdateVideoCompletionLoading(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                videoUpdateCompletionLoading: action.payload
            });
        },
        setUpdateVideoCompletionError: function setUpdateVideoCompletionError(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                videoUpdateCompletionError: action.payload
            });
        },
        setUpdateVideoCompletionSuccess: function setUpdateVideoCompletionSuccess(state) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state);
        }
    }
});
var _actions = practiseAppSlice.actions;
var setPractiseError = _actions.setPractiseError, setPractiseLoading = _actions.setPractiseLoading, setPractiseData = _actions.setPractiseData, setUpdateVideoCompletionLoading = _actions.setUpdateVideoCompletionLoading, setUpdateVideoCompletionError = _actions.setUpdateVideoCompletionError, setUpdateVideoCompletionSuccess = _actions.setUpdateVideoCompletionSuccess;
/* harmony default export */ __webpack_exports__["ZP"] = (practiseAppSlice.reducer);


/***/ }),

/***/ 92485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ counsellingFormActionsTypes; },
/* harmony export */   "W": function() { return /* binding */ counsellingFormActions; }
/* harmony export */ });
var counsellingFormActionsTypes = {
    UPDATE_POST_FETCH_ELIGIBILITY_ACTION: "UPDATE_POST_FETCH_ELIGIBILITY_ACTION"
};
var fetchProfileData = function() {
    return {
        type: "PROFILE_FETCH_REQUESTED"
    };
};
var fetchProfileSuccess = function(payload) {
    return {
        type: "PROFILE_FETCH_SUCCESS",
        payload: payload
    };
};
var fetchProfileFail = function(message) {
    return {
        type: "PROFILE_FETCH_FAIL",
        payload: message
    };
};
var saveProfile = function(payload) {
    return {
        type: "SAVE_PROFILE_REQUESTED",
        payload: payload
    };
};
var saveProfileSuccess = function(payload) {
    return {
        type: "SAVE_PROFILE_SUCCESS",
        payload: payload
    };
};
var saveProfileFail = function(message) {
    return {
        type: "SAVE_PROFILE_FAIL",
        payload: message
    };
};
var fetchEligibility = function() {
    return {
        type: "ELIGIBILITY_FETCH_REQUESTED"
    };
};
var fetchEligibilitySuccess = function(payload) {
    return {
        type: "ELIGIBILITY_FETCH_SUCCESS",
        payload: payload
    };
};
/** while dispatching this action you should give it a callback.In that callback u can get the
 eligibility data you can use that data. this callback function will be called after fetching
the eligibility
 */ var updatePostFetchEligibilityAction = function(payload) {
    return {
        type: counsellingFormActionsTypes.UPDATE_POST_FETCH_ELIGIBILITY_ACTION,
        payload: payload
    };
};
var fetchEligibilityFail = function(message) {
    return {
        type: "ELIGIBILITY_FETCH_FAIL",
        payload: message
    };
};
var updateSaveCta = function(payload) {
    return {
        type: "UPDATE_SAVE_CTA_STATUS",
        payload: payload
    };
};
var fetchIeltsNudgeData = function() {
    return {
        type: "FETCH_IELTS_NUDGE_DATA"
    };
};
var fetchIeltsNudgeDataSuccess = function(payload) {
    return {
        type: "FETCH_IELTS_NUDGE_DATA_SUCCESS",
        payload: payload
    };
};
var fetchIeltsNudgeDataFail = function(payload) {
    return {
        type: "FETCH_IELTS_NUDGE_DATA_SUCCESS",
        payload: payload
    };
};
var saveIeltsNudgeData = function(payload) {
    return {
        type: "SAVE_IELTS_NUDGE_DATA",
        payload: payload
    };
};
var saveIeltsNudgeDataSuccess = function(payload) {
    return {
        type: "SAVE_IELTS_NUDGE_DATA_SUCCESS",
        payload: payload
    };
};
var saveIeltsNudegeDataFail = function(message) {
    return {
        type: "SAVE_IELTS_NUDGE_DATA_FAIL",
        payload: message
    };
};
var counsellingFormActions = {
    fetchProfileData: fetchProfileData,
    fetchProfileSuccess: fetchProfileSuccess,
    fetchProfileFail: fetchProfileFail,
    saveProfile: saveProfile,
    saveProfileSuccess: saveProfileSuccess,
    saveProfileFail: saveProfileFail,
    fetchEligibility: fetchEligibility,
    fetchEligibilitySuccess: fetchEligibilitySuccess,
    fetchEligibilityFail: fetchEligibilityFail,
    updateSaveCta: updateSaveCta,
    fetchIeltsNudgeData: fetchIeltsNudgeData,
    fetchIeltsNudgeDataSuccess: fetchIeltsNudgeDataSuccess,
    fetchIeltsNudgeDataFail: fetchIeltsNudgeDataFail,
    saveIeltsNudgeDataSuccess: saveIeltsNudgeDataSuccess,
    saveIeltsNudegeDataFail: saveIeltsNudegeDataFail,
    saveIeltsNudgeData: saveIeltsNudgeData,
    updatePostFetchEligibilityAction: updatePostFetchEligibilityAction
};


/***/ }),

/***/ 23433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ financialCounsellingActions; }
/* harmony export */ });
var fetchFinancialCounsellingData = function() {
    return {
        type: "FINANCIAL_COUNSELLING_FETCH_REQUESTED"
    };
};
var fetchSuccess = function(payload) {
    return {
        type: "FINANCIAL_COUNSELLING_FETCH_SUCCEEDED",
        payload: payload
    };
};
var fetchFail = function(message) {
    return {
        type: "FINANCIAL_COUNSELLING_FETCH_FAILED",
        payload: message
    };
};
var updateJoinStatus = function(payload) {
    return {
        type: "UPDATE_JOIN_STATUS",
        payload: payload
    };
};
var updateCanAttendStatus = function(payload) {
    return {
        type: "UPDATE_CAN_ATTEND_STATUS",
        payload: payload
    };
};
var fetchFinancialCounsellingPageData = function() {
    return {
        type: "FINANCIAL_COUNSELLING_PAGE_FETCH_REQUESTED"
    };
};
var fetchFinancialCounsellingPageDataSuccess = function(payload) {
    return {
        type: "FINANCIAL_COUNSELLING_PAGE_FETCH_SUCCEEDED",
        payload: payload
    };
};
var fetchFinancialCounsellingPageDataFail = function(message) {
    return {
        type: "FINANCIAL_COUNSELLING_PAGE_FETCH_FAILED",
        message: message
    };
};
var financialCounsellingActions = {
    fetchFinancialCounsellingData: fetchFinancialCounsellingData,
    fetchSuccess: fetchSuccess,
    fetchFail: fetchFail,
    updateJoinStatus: updateJoinStatus,
    updateCanAttendStatus: updateCanAttendStatus,
    fetchFinancialCounsellingPageData: fetchFinancialCounsellingPageData,
    fetchFinancialCounsellingPageDataSuccess: fetchFinancialCounsellingPageDataSuccess,
    fetchFinancialCounsellingPageDataFail: fetchFinancialCounsellingPageDataFail
};


/***/ }),

/***/ 63152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ counsellingActions; }
/* harmony export */ });
var fetchCounsellingStage = function() {
    return {
        type: "COUNSELLING_STAGE_FETCH_REQUESTED"
    };
};
var fetchCounsellingStageSuccess = function(payload) {
    return {
        type: "COUNSELLING_STAGE_FETCH_SUCCESS",
        payload: payload
    };
};
var fetchCounsellingStageFail = function(message) {
    return {
        type: "COUNSELLING_STAGE_FETCH_FAIL",
        payload: message
    };
};
var fetchPostPaymentData = function() {
    return {
        type: "POST_PAYMENT_DATA_FETCH_REQUESTED"
    };
};
var fetchPostPaymentDataSuccess = function(payload) {
    return {
        type: "POST_PAYMENT_DATA_FETCH_SUCCESS",
        payload: payload
    };
};
var fetchPostPaymentDataFail = function(message) {
    return {
        type: "POST_PAYMENT_DATA_FETCH_FAIL",
        payload: message
    };
};
var fetchScholarshipBookmarks = function() {
    return {
        type: "FECTH_BOOKMARK_DATA_FETCH_REQUESTED"
    };
};
var fetchScholarshipBookmarksSuccess = function(payload) {
    return {
        type: "FETCH_BOOKMARK_DATA_FETCH_SUCCESS",
        payload: payload
    };
};
var fetchScholarshipBookmarksFail = function(message) {
    return {
        type: "FETCH_BOOMARK_FETCH_FAIL",
        payload: message
    };
};
var counsellingActions = {
    fetchCounsellingStage: fetchCounsellingStage,
    fetchCounsellingStageFail: fetchCounsellingStageFail,
    fetchCounsellingStageSuccess: fetchCounsellingStageSuccess,
    fetchPostPaymentData: fetchPostPaymentData,
    fetchPostPaymentDataSuccess: fetchPostPaymentDataSuccess,
    fetchPostPaymentDataFail: fetchPostPaymentDataFail,
    fetchScholarshipBookmarks: fetchScholarshipBookmarks,
    fetchScholarshipBookmarksSuccess: fetchScholarshipBookmarksSuccess,
    fetchScholarshipBookmarksFail: fetchScholarshipBookmarksFail
};


/***/ }),

/***/ 3561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ documentDetailsActions; }
/* harmony export */ });
/* harmony import */ var _constants_document_details_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87393);

var fetchDocumentDetailsData = function() {
    return {
        type: _constants_document_details_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_DOCUMENT_DETAILS_DATA */ .Z.FETCH_DOCUMENT_DETAILS_DATA
    };
};
var fetchDocumentDetailsDataSuccess = function(payload) {
    return {
        type: _constants_document_details_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_DOCUMENT_DETAILS_DATA_SUCCESS */ .Z.FETCH_DOCUMENT_DETAILS_DATA_SUCCESS,
        payload: payload
    };
};
var fetchDocumentDetailsDataError = function(message) {
    return {
        type: _constants_document_details_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_DOCUMENT_DETAILS_DATA_ERROR */ .Z.FETCH_DOCUMENT_DETAILS_DATA_ERROR,
        payload: message
    };
};
var documentDetailsActions = {
    fetchDocumentDetailsData: fetchDocumentDetailsData,
    fetchDocumentDetailsDataSuccess: fetchDocumentDetailsDataSuccess,
    fetchDocumentDetailsDataError: fetchDocumentDetailsDataError
};


/***/ }),

/***/ 89961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ noticeBoardActions; }
/* harmony export */ });
/* harmony import */ var _constants_notice_board_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5303);

var fetchNoticeBoardData = function() {
    return {
        type: _constants_notice_board_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_NOTICE_BOARD_DATA */ .Z.FETCH_NOTICE_BOARD_DATA
    };
};
var fetchNoticeBoardDataSuccess = function(payload) {
    return {
        type: _constants_notice_board_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_NOTICE_BOARD_DATA_SUCCESS */ .Z.FETCH_NOTICE_BOARD_DATA_SUCCESS,
        payload: payload
    };
};
var fetchNoticeBoardDataError = function(message) {
    return {
        type: _constants_notice_board_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_NOTICE_BOARD_DATA_ERROR */ .Z.FETCH_NOTICE_BOARD_DATA_ERROR,
        payload: message
    };
};
var noticeBoardActions = {
    fetchNoticeBoardData: fetchNoticeBoardData,
    fetchNoticeBoardDataSuccess: fetchNoticeBoardDataSuccess,
    fetchNoticeBoardDataError: fetchNoticeBoardDataError
};


/***/ }),

/***/ 79281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ overviewActions; }
/* harmony export */ });
/* harmony import */ var _constants_overview_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5570);

var fetchOverviewData = function() {
    return {
        type: _constants_overview_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_OVERVIEW_DATA */ .Z.FETCH_OVERVIEW_DATA
    };
};
var fetchOverviewDataSuccess = function(payload) {
    return {
        type: _constants_overview_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_OVERVIEW_DATA_SUCCESS */ .Z.FETCH_OVERVIEW_DATA_SUCCESS,
        payload: payload
    };
};
var fetchOverviewDataError = function(message) {
    return {
        type: _constants_overview_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_OVERVIEW_DATA_ERROR */ .Z.FETCH_OVERVIEW_DATA_ERROR,
        payload: message
    };
};
var toggleBookCounsellorModal = function(payload) {
    return {
        type: _constants_overview_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].TOGGLE_BOOK_COUNSELLING_MODAL */ .Z.TOGGLE_BOOK_COUNSELLING_MODAL,
        payload: payload
    };
};
var toggleSpeakToCounsellorModal = function(payload) {
    return {
        type: _constants_overview_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].TOGGLE_SPEAK_TO_COUNSELLOR_MODAL */ .Z.TOGGLE_SPEAK_TO_COUNSELLOR_MODAL,
        payload: payload
    };
};
var toggleGetLsPlusModal = function(payload) {
    return {
        type: _constants_overview_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].TOGGLE_GET_LS_PLUS_MODAL */ .Z.TOGGLE_GET_LS_PLUS_MODAL,
        payload: payload
    };
};
var fetchCounsellingFeeData = function() {
    return {
        type: _constants_overview_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_COUNSELLING_FEE_DATA */ .Z.FETCH_COUNSELLING_FEE_DATA
    };
};
var fetchCounsellingFeeDataSuccess = function(payload) {
    return {
        type: _constants_overview_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_COUNSELLING_FEE_DATA_SUCCESS */ .Z.FETCH_COUNSELLING_FEE_DATA_SUCCESS,
        payload: payload
    };
};
var fetchCounsellingFeeDataError = function(message) {
    return {
        type: _constants_overview_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_COUNSELLING_FEE_DATA_ERROR */ .Z.FETCH_COUNSELLING_FEE_DATA_ERROR,
        payload: message
    };
};
var fetchPostPaymentData = function() {
    return {
        type: _constants_overview_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_POST_PAYMENT_DATA */ .Z.FETCH_POST_PAYMENT_DATA
    };
};
var fetchPostPaymentDataSuccess = function(payload) {
    return {
        type: _constants_overview_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_POST_PAYMENT_DATA_SUCCESS */ .Z.FETCH_POST_PAYMENT_DATA_SUCCESS,
        payload: payload
    };
};
var fetchPostPaymentDataError = function(message) {
    return {
        type: _constants_overview_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_POST_PAYMENT_DATA_ERROR */ .Z.FETCH_POST_PAYMENT_DATA_ERROR,
        payload: message
    };
};
var fetchOffer = function() {
    return {
        type: _constants_overview_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_OFFER */ .Z.FETCH_OFFER
    };
};
var fetchOfferSuccess = function(payload) {
    return {
        type: _constants_overview_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_OFFER_SUCCESS */ .Z.FETCH_OFFER_SUCCESS,
        payload: payload
    };
};
var fetchOfferError = function(message) {
    return {
        type: _constants_overview_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_OFFER_ERROR */ .Z.FETCH_OFFER_ERROR,
        payload: message
    };
};
var toggleAllTaskView = function(isOpen) {
    return {
        type: _constants_overview_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].TOGGLE_ALL_TASK_VIEW */ .Z.TOGGLE_ALL_TASK_VIEW,
        payload: isOpen
    };
};
var fetchPlaylist = function() {
    return {
        type: _constants_overview_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_PLAYLIST */ .Z.FETCH_PLAYLIST
    };
};
var fetchPlayListSuccess = function(payload) {
    return {
        type: _constants_overview_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_PLAYLIST_SUCCESS */ .Z.FETCH_PLAYLIST_SUCCESS,
        payload: payload
    };
};
var fetchPlayListFail = function(payload) {
    return {
        type: _constants_overview_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_PLAYLIST_FAIL */ .Z.FETCH_PLAYLIST_FAIL,
        payload: payload
    };
};
var overviewActions = {
    fetchOverviewData: fetchOverviewData,
    fetchOverviewDataSuccess: fetchOverviewDataSuccess,
    fetchOverviewDataError: fetchOverviewDataError,
    toggleBookCounsellorModal: toggleBookCounsellorModal,
    toggleSpeakToCounsellorModal: toggleSpeakToCounsellorModal,
    toggleGetLsPlusModal: toggleGetLsPlusModal,
    fetchCounsellingFeeData: fetchCounsellingFeeData,
    fetchCounsellingFeeDataSuccess: fetchCounsellingFeeDataSuccess,
    fetchCounsellingFeeDataError: fetchCounsellingFeeDataError,
    fetchPostPaymentData: fetchPostPaymentData,
    fetchPostPaymentDataSuccess: fetchPostPaymentDataSuccess,
    fetchPostPaymentDataError: fetchPostPaymentDataError,
    fetchOffer: fetchOffer,
    fetchOfferSuccess: fetchOfferSuccess,
    fetchOfferError: fetchOfferError,
    toggleAllTaskView: toggleAllTaskView,
    fetchPlaylist: fetchPlaylist,
    fetchPlayListSuccess: fetchPlayListSuccess,
    fetchPlayListFail: fetchPlayListFail
};


/***/ }),

/***/ 73309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ upcomingAppointmentsActions; }
/* harmony export */ });
/* harmony import */ var _constants_upcoming_appointments_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93787);

var fetchUpcomingAppointmentsData = function() {
    return {
        type: _constants_upcoming_appointments_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_UPCOMING_APPOINTMENTS_DATA */ .Z.FETCH_UPCOMING_APPOINTMENTS_DATA
    };
};
var fetchUpcomingAppointmentsDataSuccess = function(payload) {
    return {
        type: _constants_upcoming_appointments_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_UPCOMING_APPOINTMENTS_DATA_SUCCESS */ .Z.FETCH_UPCOMING_APPOINTMENTS_DATA_SUCCESS,
        payload: payload
    };
};
var fetchUpcomingAppointmentsDataError = function(message) {
    return {
        type: _constants_upcoming_appointments_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_UPCOMING_APPOINTMENTS_DATA_ERROR */ .Z.FETCH_UPCOMING_APPOINTMENTS_DATA_ERROR,
        payload: message
    };
};
var upcomingAppointmentsActions = {
    fetchUpcomingAppointmentsData: fetchUpcomingAppointmentsData,
    fetchUpcomingAppointmentsDataSuccess: fetchUpcomingAppointmentsDataSuccess,
    fetchUpcomingAppointmentsDataError: fetchUpcomingAppointmentsDataError
};


/***/ }),

/***/ 74386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ visaAssistanceActions; }
/* harmony export */ });
/* harmony import */ var _constants_visa_assistance_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82382);

var fetchVisaAssistanceData = function() {
    return {
        type: _constants_visa_assistance_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_VISA_ASSISTANCE_DATA */ .Z.FETCH_VISA_ASSISTANCE_DATA
    };
};
var ffetchVisaAssistanceDataSuccess = function(payload) {
    return {
        type: _constants_visa_assistance_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_VISA_ASSISTANCE_DATA_SUCCESS */ .Z.FETCH_VISA_ASSISTANCE_DATA_SUCCESS,
        payload: payload
    };
};
var fetchVisaAssistanceDataError = function(message) {
    return {
        type: _constants_visa_assistance_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_VISA_ASSISTANCE_DATA_ERROR */ .Z.FETCH_VISA_ASSISTANCE_DATA_ERROR,
        payload: message
    };
};
var visaAssistanceActions = {
    fetchVisaAssistanceData: fetchVisaAssistanceData,
    ffetchVisaAssistanceDataSuccess: ffetchVisaAssistanceDataSuccess,
    fetchVisaAssistanceDataError: fetchVisaAssistanceDataError
};


/***/ }),

/***/ 7241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ overviewApi; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./service/api.ts + 1 modules
var api = __webpack_require__(14117);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 15 modules
var lib = __webpack_require__(4969);
;// CONCATENATED MODULE: ./apollo/queries/playList.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query {\n    plAyLists {\n      name\n      play_list {\n        caption\n        youtube_link\n        description\n        thumbnail {\n          url\n        }\n        ctaText\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var FETCH_PLAYLIST = (0,lib/* default */.ZP)(_templateObject());
/* harmony default export */ var playList = (FETCH_PLAYLIST);

// EXTERNAL MODULE: ./apollo/apollo.ts + 13 modules
var apollo = __webpack_require__(22308);
;// CONCATENATED MODULE: ./components/Profile/CounsellingProfile/redux/apis/overview-apis.ts





var fetchOverviewRequest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=profile/post/task");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchOverviewRequest() {
        return _ref.apply(this, arguments);
    };
}();
var fetchCounsellingFeeRequest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=student/counselling/fee");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchCounsellingFeeRequest() {
        return _ref.apply(this, arguments);
    };
}();
var fetchPostPaymentDataRequest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=student/post-payment");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 6;
                        break;
                    }
                    return _ctx.abrupt("return", res);
                case 6:
                    _ctx.next = 11;
                    break;
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function fetchPostPaymentDataRequest() {
        return _ref.apply(this, arguments);
    };
}();
var fetchOfferRequest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=student/offer");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 6;
                        break;
                    }
                    return _ctx.abrupt("return", res);
                case 6:
                    _ctx.next = 11;
                    break;
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function fetchOfferRequest() {
        return _ref.apply(this, arguments);
    };
}();
var fetchPlaylist = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return apollo/* apoloClient.query */.Bq.query({
                        query: playList,
                        variables: []
                    });
                case 3:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchPlaylist() {
        return _ref.apply(this, arguments);
    };
}();
var overviewApi = {
    fetchOverviewRequest: fetchOverviewRequest,
    fetchCounsellingFeeRequest: fetchCounsellingFeeRequest,
    fetchPostPaymentDataRequest: fetchPostPaymentDataRequest,
    fetchOfferRequest: fetchOfferRequest,
    fetchPlaylist: fetchPlaylist
};


/***/ }),

/***/ 87393:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    FETCH_DOCUMENT_DETAILS_DATA: "FETCH_DOCUMENT_DETAILS_DATA",
    FETCH_DOCUMENT_DETAILS_DATA_SUCCESS: "FETCH_DOCUMENT_DETAILS_DATA_SUCCESS",
    FETCH_DOCUMENT_DETAILS_DATA_ERROR: "FETCH_DOCUMENT_DETAILS_DATA_ERROR"
});


/***/ }),

/***/ 44211:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    SHOW_APPLICATION_VIEW: "SHOW_APPLICATION_VIEW",
    HIDE_APPLICATION_VIEW: "HIDE_APPLICATION_VIEW"
});


/***/ }),

/***/ 5303:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    FETCH_NOTICE_BOARD_DATA: "FETCH_NOTICE_BOARD_DATA",
    FETCH_NOTICE_BOARD_DATA_SUCCESS: "FETCH_NOTICE_BOARD_DATA_SUCCESS",
    FETCH_NOTICE_BOARD_DATA_ERROR: "FETCH_NOTICE_BOARD_DATA_ERROR"
});


/***/ }),

/***/ 5570:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    FETCH_OVERVIEW_DATA: "FETCH_OVERVIEW_DATA",
    FETCH_OVERVIEW_DATA_SUCCESS: "FETCH_OVERVIEW_DATA_SUCCESS",
    FETCH_OVERVIEW_DATA_ERROR: "FETCH_OVERVIEW_DATA_ERROR",
    TOGGLE_BOOK_COUNSELLING_MODAL: "TOGGLE_BOOK_COUNSELLING_MODAL",
    TOGGLE_SPEAK_TO_COUNSELLOR_MODAL: "TOGGLE_SPEAK_TO_COUNSELLOR_MODAL",
    TOGGLE_GET_LS_PLUS_MODAL: "TOGGLE_GET_LS_PLUS_MODAL",
    FETCH_COUNSELLING_FEE_DATA: "FETCH_COUNSELLING_FEE_DATA",
    FETCH_COUNSELLING_FEE_DATA_SUCCESS: "FETCH_COUNSELLING_FEE_DATA_SUCCESS",
    FETCH_COUNSELLING_FEE_DATA_ERROR: "FETCH_COUNSELLING_FEE_DATA_ERROR",
    FETCH_POST_PAYMENT_DATA: "FETCH_POST_PAYMENT_DATA",
    FETCH_POST_PAYMENT_DATA_SUCCESS: "FETCH_POST_PAYMENT_DATA_SUCCESS",
    FETCH_POST_PAYMENT_DATA_ERROR: "FETCH_POST_PAYMENT_DATA_ERROR",
    FETCH_OFFER: "FETCH_OFFER",
    FETCH_OFFER_SUCCESS: "FETCH_OFFER_SUCCESS",
    FETCH_OFFER_ERROR: "FETCH_OFFER_ERROR",
    TOGGLE_ALL_TASK_VIEW: "TOGGLE_ALL_TASK_VIEW",
    FETCH_PLAYLIST: "FETCH_PLAYLIST",
    FETCH_PLAYLIST_SUCCESS: "FETCH_PLAYLIST_SUCCESS",
    FETCH_PLAYLIST_FAIL: "FETCH_PLAYLIST_FAIL"
});


/***/ }),

/***/ 93787:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    FETCH_UPCOMING_APPOINTMENTS_DATA: "FETCH_UPCOMING_APPOINTMENTS_DATA",
    FETCH_UPCOMING_APPOINTMENTS_DATA_SUCCESS: "FETCH_UPCOMING_APPOINTMENTS_DATA_SUCCESS",
    FETCH_UPCOMING_APPOINTMENTS_DATA_ERROR: "FETCH_UPCOMING_APPOINTMENTS_DATA_ERROR"
});


/***/ }),

/***/ 82382:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    FETCH_VISA_ASSISTANCE_DATA: "FETCH_VISA_ASSISTANCE_DATA",
    FETCH_VISA_ASSISTANCE_DATA_SUCCESS: "FETCH_VISA_ASSISTANCE_DATA_SUCCESS",
    FETCH_VISA_ASSISTANCE_DATA_ERROR: "FETCH_VISA_ASSISTANCE_DATA_ERROR"
});


/***/ }),

/***/ 48943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ fastTrackFormActionType; },
/* harmony export */   "g": function() { return /* binding */ fastTrackActions; }
/* harmony export */ });
var fastTrackFormActionType = {
    SAVE_FAST_TRACK_FORM: "SAVE_FAST_TRACK_FORM",
    ENROLL_TO_FAST_TRACK_FORM: "ENROLL_TO_FAST_TRACK_FORM",
    TOGGLE_FAST_TRACK_MODAL: "TOGGLE_FAST_TRACK_MODAL",
    FAST_TRACK_FORM_ERROR: "FAST_TRACK_FORM_ERROR",
    TOGGLE_FAST_TRACK_FORM_CTA_TEXT: "TOGGLE_FAST_TRACK_FORM_CTA_TEXT"
};
var saveForm = function(payload) {
    return {
        type: fastTrackFormActionType.SAVE_FAST_TRACK_FORM,
        payload: payload
    };
};
var toggleCtaText = function(payload) {
    return {
        type: fastTrackFormActionType.TOGGLE_FAST_TRACK_FORM_CTA_TEXT,
        payload: payload
    };
};
var toggleFastTrackFormModal = function(payload) {
    return {
        type: fastTrackFormActionType.TOGGLE_FAST_TRACK_MODAL,
        payload: payload
    };
};
var enrollToFastTrack = function(payload) {
    return {
        type: fastTrackFormActionType.ENROLL_TO_FAST_TRACK_FORM,
        payload: payload
    };
};
var updateError = function(message) {
    return {
        type: fastTrackFormActionType.FAST_TRACK_FORM_ERROR,
        payload: message
    };
};
var toggleFastTrackLoader = function(payload) {
    return {
        type: "TOGGLE_FAST_TRACK_LOADER",
        payload: payload
    };
};
var toggleFastTrackForm = function(payload) {
    return {
        type: "TOGGLE_FAST_TRACK_FORM",
        payload: payload
    };
};
var fastTrackActions = {
    saveForm: saveForm,
    toggleCtaText: toggleCtaText,
    toggleFastTrackFormModal: toggleFastTrackFormModal,
    enrollToFastTrack: enrollToFastTrack,
    updateError: updateError,
    toggleFastTrackLoader: toggleFastTrackLoader,
    toggleFastTrackForm: toggleFastTrackForm
};


/***/ }),

/***/ 16503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ fastTrackVideoAction; },
/* harmony export */   "x": function() { return /* binding */ fastTrackActionVideoType; }
/* harmony export */ });
var fastTrackActionVideoType = {
    FETCH_FAST_TRACK_VIDEO_REQ: "FETCH_FAST_TRACK_VIDEO_REQ",
    FETCH_FAST_TRACK_VIDEO_SUCCESS: "FETCH_FAST_TRACK_VIDEO_SUCCESS",
    FETCH_FAST_TRACK_VIDEO_FAIL: "FETCH_FAST_TRACK_VIDEO_FAIL",
    FAST_TRACK_WATCH_VIDEO: "FAST_TRACK_WATCH_VIDEO",
    FAST_TRACK_WATCH_VIDEO_SUCCESS: "FAST_TRACK_WATCH_VIDEO_SUCCESS",
    FAST_TRACK_WATCH_VIDEO_FAIL: "FAST_TRACK_WATCH_VIDEO_FAIL",
    FAST_TRACK_REDIRECT: "FAST_TRACK_REDIRECT",
    FAST_TRACK_MODAL: "FAST_TRACK_MODAL",
    VIDEO_PREVIEW_END_MODAL: "VIDEO_PREVIEW_END_MODAL",
    UPDATE_NEXT_VIDEO_TO_PLAY_AFTER_PAYMENT: "UPDATE_NEXT_VIDEO_TO_PLAY_AFTER_PAYMENT"
};
var watchedVideo = function(payload) {
    return {
        type: fastTrackActionVideoType.FAST_TRACK_WATCH_VIDEO,
        payload: payload
    };
};
var watchedVideoSuccess = function(payload) {
    return {
        type: fastTrackActionVideoType.FAST_TRACK_WATCH_VIDEO_SUCCESS,
        payload: payload
    };
};
var watchedVideoFail = function(payload) {
    return {
        type: fastTrackActionVideoType.FAST_TRACK_WATCH_VIDEO_FAIL,
        payload: payload
    };
};
var fetchFastTrackVideoReq = function(payload) {
    return {
        type: fastTrackActionVideoType.FETCH_FAST_TRACK_VIDEO_REQ,
        payload: payload
    };
};
var fetchFastTrackVideoSuccess = function(payload) {
    return {
        type: fastTrackActionVideoType.FETCH_FAST_TRACK_VIDEO_SUCCESS,
        payload: payload
    };
};
var fetchFastTrackVideoFail = function(payload) {
    return {
        type: fastTrackActionVideoType.FETCH_FAST_TRACK_VIDEO_FAIL,
        payload: payload
    };
};
var toggleFastTrackModal = function(payload) {
    return {
        type: fastTrackActionVideoType.FAST_TRACK_MODAL,
        payload: payload
    };
};
var toggleVideoPreviewEndModal = function(payload) {
    return {
        type: fastTrackActionVideoType.VIDEO_PREVIEW_END_MODAL,
        payload: payload
    };
};
var updateNextVideoToPlayAfterPayment = function(payload) {
    return {
        type: fastTrackActionVideoType.UPDATE_NEXT_VIDEO_TO_PLAY_AFTER_PAYMENT,
        payload: payload
    };
};
var fastTrackVideoAction = {
    fetchFastTrackVideoReq: fetchFastTrackVideoReq,
    fetchFastTrackVideoSuccess: fetchFastTrackVideoSuccess,
    fetchFastTrackVideoFail: fetchFastTrackVideoFail,
    watchedVideo: watchedVideo,
    watchedVideoSuccess: watchedVideoSuccess,
    watchedVideoFail: watchedVideoFail,
    toggleFastTrackModal: toggleFastTrackModal,
    toggleVideoPreviewEndModal: toggleVideoPreviewEndModal,
    updateNextVideoToPlayAfterPayment: updateNextVideoToPlayAfterPayment
};


/***/ }),

/***/ 4069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ ieltsAttendanceActions; }
/* harmony export */ });
var updateError = function(message) {
    return {
        type: "IELTS_ATTENDANCE_ERROR",
        payload: message
    };
};
var updateSelectedBatch = function(payload) {
    return {
        type: "UPDATE_SELECTED_BATCH",
        payload: payload
    };
};
var addToCalendar = function(payload) {
    return {
        type: "ADD_IELTS_CLASS_TO_CALENDAR",
        payload: payload
    };
};
var updateAddedToCalendar = function(payload) {
    return {
        type: "UPDATE_ADDED_TO_CALENDAR",
        payload: payload
    };
};
var ieltsAttendanceActions = {
    updateError: updateError,
    updateSelectedBatch: updateSelectedBatch,
    addToCalendar: addToCalendar,
    updateAddedToCalendar: updateAddedToCalendar
};


/***/ }),

/***/ 97909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ certificateAction; },
/* harmony export */   "y": function() { return /* binding */ certificateActionType; }
/* harmony export */ });
var certificateActionType = {
    FETCH_CERTIFICATE_REQ: "FETCH_CERTIFICATE_REQ",
    FETCH_CERTIFICATE_SUCCESS: "FETCH_CERTIFICATE_SUCCESS",
    FETCH_CERTIFICATE_FAIL: "FETCH_CERTIFICATE_FAIL",
    CLEAR_ERROR_MESSAGE: "CLEAR_ERROR_MESSAGE"
};
var fetchCertificateReq = function(payload) {
    return {
        type: certificateActionType.FETCH_CERTIFICATE_REQ,
        payload: payload
    };
};
var fetchCertificateSuccess = function(payload) {
    return {
        type: certificateActionType.FETCH_CERTIFICATE_SUCCESS,
        payload: payload
    };
};
var fetchCertificateFail = function(payload) {
    return {
        type: certificateActionType.FETCH_CERTIFICATE_FAIL,
        payload: payload
    };
};
var clearErrorMessage = function() {
    return {
        type: certificateActionType.CLEAR_ERROR_MESSAGE
    };
};
var certificateAction = {
    fetchCertificateFail: fetchCertificateFail,
    fetchCertificateSuccess: fetchCertificateSuccess,
    fetchCertificateReq: fetchCertificateReq,
    clearErrorMessage: clearErrorMessage
};


/***/ }),

/***/ 3676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ classRecordingsActions; }
/* harmony export */ });
var fetchRecordings = function(payload) {
    return {
        type: "RECORDINGS_FETCH_REQUESTED",
        payload: payload
    };
};
var setRecordingsLoading = function(payload) {
    return {
        type: "SET_RECORDINGS_LOADING",
        payload: payload
    };
};
var fetchRecordingsSuccess = function(payload) {
    return {
        type: "RECORDINGS_FETCH_SUCCESS",
        payload: payload
    };
};
var fetchRecordingsFail = function(payload) {
    return {
        type: "RECORDINGS_FETCH_FAIL",
        payload: payload
    };
};
var fetchVideo = function(payload) {
    return {
        type: "VIDEO_FETCH_REQUESTED",
        payload: payload
    };
};
var fetchVideoSuccess = function(payload) {
    return {
        type: "VIDEO_FETCH_SUCCESS",
        payload: payload
    };
};
var fetchVideoFail = function(payload) {
    return {
        type: "VIDEO_FETCH_FAIL",
        payload: payload
    };
};
var updateRecordings = function(payload) {
    return {
        type: "UPDATE_RECORDINGS",
        payload: payload
    };
};
var fetchSelfPrepRecordings = function() {
    return {
        type: "SELF_PREP_RECORDINGS_FETCH_REQUESTED"
    };
};
var fetchGrammarRecordings = function() {
    return {
        type: "GRAMMAR_RECORDINGS_FETCH_REQUESTED"
    };
};
var updateSelfPrepRecordings = function(payload) {
    return {
        type: "SELF_PREP_UPDATE_RECORDINGS",
        payload: payload
    };
};
var classRecordingsActions = {
    fetchRecordings: fetchRecordings,
    fetchRecordingsSuccess: fetchRecordingsSuccess,
    fetchRecordingsFail: fetchRecordingsFail,
    fetchVideo: fetchVideo,
    fetchVideoSuccess: fetchVideoSuccess,
    fetchVideoFail: fetchVideoFail,
    updateRecordings: updateRecordings,
    fetchSelfPrepRecordings: fetchSelfPrepRecordings,
    updateSelfPrepRecordings: updateSelfPrepRecordings,
    fetchGrammarRecordings: fetchGrammarRecordings,
    setRecordingsLoading: setRecordingsLoading
};


/***/ }),

/***/ 86075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ essayAction; },
/* harmony export */   "N": function() { return /* binding */ essayType; }
/* harmony export */ });
var essayType = {
    ESSAY_FETCH_REQ: "ESSAY_FETCH_REQ",
    ESSAY_FETCH_SUCCESS: "ESSAY_FETCH_ACCEPT",
    ESSAY_FETCH_FAIL: "ESSAY_FETCH_FAIL",
    UPLOAD_ESSAY_REQ: "UPLOAD_ESSAY_REQ",
    UPLOAD_ESSAY_SUCCESS: "UPLOAD_ESSAY_SUCCESS",
    UPLOAD_ESSAY_FAIL: "UPLOAD_ESSAY_FAIL",
    CLEAR_ERROR_MSG: "CLEAR_ERROR_MSG",
    REPLACE_ESSAY_REQ: "REPLACE_ESSAY_REQ",
    REPLACE_ESSAY_SUCCESS: "REPLACE_ESSAY_SUCCESS",
    REPLACE_ESSAY_FAIL: "REPLACE_ESSAY_FAIL"
};
var fetchEssayReq = function(payload) {
    return {
        type: essayType.ESSAY_FETCH_REQ,
        payload: payload
    };
};
var fetchEssaySuccess = function(payload) {
    return {
        type: essayType.ESSAY_FETCH_SUCCESS,
        payload: payload
    };
};
var fetchEssayFail = function(payload) {
    return {
        type: essayType.ESSAY_FETCH_FAIL,
        payload: payload
    };
};
var uploadEssayReq = function(payload) {
    return {
        type: essayType.UPLOAD_ESSAY_REQ,
        payload: payload
    };
};
var uploadEssaySuccess = function(payload) {
    return {
        type: essayType.UPLOAD_ESSAY_SUCCESS,
        payload: payload
    };
};
var uploadEssayFail = function(payload) {
    return {
        type: essayType.UPLOAD_ESSAY_FAIL,
        payload: payload
    };
};
var replaceEssayReq = function(payload) {
    return {
        type: essayType.REPLACE_ESSAY_REQ,
        payload: payload
    };
};
var replaceEssaySuccess = function(payload) {
    return {
        type: essayType.REPLACE_ESSAY_SUCCESS,
        payload: payload
    };
};
var replaceEssayFail = function(payload) {
    return {
        type: essayType.REPLACE_ESSAY_FAIL,
        payload: payload
    };
};
var clearErrorMessage = function() {
    return {
        type: essayType.CLEAR_ERROR_MSG
    };
};
var essayAction = {
    fetchEssayReq: fetchEssayReq,
    fetchEssaySuccess: fetchEssaySuccess,
    fetchEssayFail: fetchEssayFail,
    uploadEssayReq: uploadEssayReq,
    uploadEssaySuccess: uploadEssaySuccess,
    uploadEssayFail: uploadEssayFail,
    clearErrorMessage: clearErrorMessage,
    replaceEssayReq: replaceEssayReq,
    replaceEssaySuccess: replaceEssaySuccess,
    replaceEssayFail: replaceEssayFail
};


/***/ }),

/***/ 82715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ extraClassActions; },
/* harmony export */   "r": function() { return /* binding */ ExtraClassType; }
/* harmony export */ });
var ExtraClassType = {
    NOTIFY_USER_FOR_EXTRA_CLASS: "NOTIFY_USER_FOR_EXTRA_CLASS",
    NOTIFY_USER_POST_ACTION: "NOTIFY_USER_POST_ACTION",
    NOTIFY_USER_FOR_EXTRA_CLASS_SUCCESS: "NOTIFY_USER_FOR_EXTRA_CLASS_SUCCESS",
    NOTIFY_ORIENTATION_CLASS_SUCCESS: "NOTIFY_ORIENTATION_CLASS_SUCCESS",
    NOTIFY_USER_FOR_EXTRA_CLASS_FAIL: "NOTIFY_USER_FOR_EXTRA_CLASS_FAIL",
    TOGGLE_HAS_JOINED_MODAL: "TOGGLE_HAS_JOINED_MODAL",
    FETCH_ENROLLED_EXTRA_CLASS_REQ: "FETCH_ENROLLED_EXTRA_CLASS_REQ",
    FETCH_ENROLLED_EXTRA_CLASS_SUCCESS: "FETCH_ENROLLED_EXTRA_CLASS_SUCCESS",
    FETCH_ENROLLED_EXTRA_CLASS_FAIL: "FETCH_ENROLLED_EXTRA_CLASS_FAIL"
};
var notifyUserForExtraClassReq = function(payload) {
    return {
        type: ExtraClassType.NOTIFY_USER_FOR_EXTRA_CLASS,
        payload: payload
    };
};
var notifyUserForExtraClassSuccess = function(payload) {
    return {
        type: ExtraClassType.NOTIFY_USER_FOR_EXTRA_CLASS_SUCCESS,
        payload: payload
    };
};
var notifyUserForExtraClassFail = function(payload) {
    return {
        type: ExtraClassType.NOTIFY_USER_FOR_EXTRA_CLASS_FAIL,
        payload: payload
    };
};
var toggleHasJoinedModal = function(payload) {
    return {
        type: ExtraClassType.TOGGLE_HAS_JOINED_MODAL,
        payload: payload
    };
};
var toggleHasJoinedOrientation = function(payload) {
    return {
        type: ExtraClassType.NOTIFY_ORIENTATION_CLASS_SUCCESS,
        payload: payload
    };
};
var fetchEnrolledExtraClass = function() {
    return {
        type: ExtraClassType.FETCH_ENROLLED_EXTRA_CLASS_REQ
    };
};
var fetchEnrolledExtraClassSuccess = function(payload) {
    return {
        type: ExtraClassType.FETCH_ENROLLED_EXTRA_CLASS_SUCCESS,
        payload: payload
    };
};
var fetchEnrolledExtraClassFail = function(payload) {
    return {
        type: ExtraClassType.FETCH_ENROLLED_EXTRA_CLASS_FAIL,
        payload: payload
    };
};
var notifyUserPostAction = function(payload) {
    return {
        type: ExtraClassType.NOTIFY_USER_POST_ACTION,
        payload: payload
    };
};
var extraClassActions = {
    notifyUserForExtraClassReq: notifyUserForExtraClassReq,
    notifyUserForExtraClassSuccess: notifyUserForExtraClassSuccess,
    notifyUserForExtraClassFail: notifyUserForExtraClassFail,
    toggleHasJoinedModal: toggleHasJoinedModal,
    fetchEnrolledExtraClass: fetchEnrolledExtraClass,
    fetchEnrolledExtraClassSuccess: fetchEnrolledExtraClassSuccess,
    fetchEnrolledExtraClassFail: fetchEnrolledExtraClassFail,
    notifyUserPostAction: notifyUserPostAction,
    toggleHasJoinedOrientation: toggleHasJoinedOrientation
};


/***/ }),

/***/ 72823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ fastTrackActionType; },
/* harmony export */   "v": function() { return /* binding */ fastTrackAction; }
/* harmony export */ });
var fastTrackActionType = {
    FETCH_FAST_TRACK_STATUS_REQ: "FETCH_FAST_TRACK_REQ",
    FETCH_FAST_TRACK_STATUS_SUCCESS: "FETCH_FAST_TRACK_SUCCESS",
    FETCH_FAST_TRACK_STATUS_FAIL: "FETCH_FAST_TRACK_FAIL",
    FETCH_FAST_TRACK_CARD_REQ: "FETCH_FAST_TRACK_CARD_REQ",
    FETCH_FAST_TRACK_CARD_SUCCESS: "FETCH_FAST_TRACK_CARD_SUCCESS",
    FETCH_FAST_TRACK_CARD_FAIL: "FETCH_FAST_TRACK_CARD_FAIL",
    FETCH_FAST_TRACK_VIDEO_CATEGORY: "FETCH_FAST_TRACK_VIDEO_CATEGORY"
};
var fetchFastTrackReq = function() {
    return {
        type: fastTrackActionType.FETCH_FAST_TRACK_STATUS_REQ
    };
};
var fetchFastTrackSuccess = function(payload) {
    return {
        type: fastTrackActionType.FETCH_FAST_TRACK_STATUS_SUCCESS,
        payload: payload
    };
};
var fetchFastTrackFail = function(payload) {
    return {
        type: fastTrackActionType.FETCH_FAST_TRACK_STATUS_FAIL,
        payload: payload
    };
};
var fetchFastTrackCardReq = function() {
    return {
        type: fastTrackActionType.FETCH_FAST_TRACK_CARD_REQ
    };
};
var fetchFastTrackCardSuccess = function(payload) {
    return {
        type: fastTrackActionType.FETCH_FAST_TRACK_CARD_SUCCESS,
        payload: payload
    };
};
var fetchFastTrackCardFail = function(payload) {
    return {
        type: fastTrackActionType.FETCH_FAST_TRACK_CARD_FAIL,
        payload: payload
    };
};
var fetchFastTrackCategoryList = function() {
    return {
        type: fastTrackActionType.FETCH_FAST_TRACK_VIDEO_CATEGORY
    };
};
var fastTrackAction = {
    fetchFastTrackFail: fetchFastTrackFail,
    fetchFastTrackReq: fetchFastTrackReq,
    fetchFastTrackSuccess: fetchFastTrackSuccess,
    fetchFastTrackCardReq: fetchFastTrackCardReq,
    fetchFastTrackCardSuccess: fetchFastTrackCardSuccess,
    fetchFastTrackCardFail: fetchFastTrackCardFail,
    fetchFastTrackCategoryList: fetchFastTrackCategoryList
};


/***/ }),

/***/ 57251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H8": function() { return /* binding */ fetchSetReminderFailure; },
/* harmony export */   "X8": function() { return /* binding */ fetchSetReminderSuccess; },
/* harmony export */   "a1": function() { return /* binding */ fetchSetReminderRequest; },
/* harmony export */   "pA": function() { return /* binding */ fetchSetReminder; }
/* harmony export */ });
/* unused harmony export setNotificationSuccess */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27272);



var initialState = {
    isApiLoading: false,
    error: null,
    notifySuccess: false
};
var schedulePageSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "batchSchedule",
    initialState: initialState,
    reducers: {
        fetchSetReminderRequest: function fetchSetReminderRequest(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                isApiLoading: true
            });
        },
        fetchSetReminderSuccess: function fetchSetReminderSuccess(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                isApiLoading: false
            });
        },
        fetchSetReminderFailure: function fetchSetReminderFailure(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                isApiLoading: false,
                error: "something went wrong"
            });
        },
        setNotificationSuccess: function setNotificationSuccess(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                notifySuccess: action.payload
            });
        }
    }
});
var fetchSetReminder = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("batchSchedule/fetchSetReminder");
var _actions = schedulePageSlice.actions;
var fetchSetReminderRequest = _actions.fetchSetReminderRequest, fetchSetReminderSuccess = _actions.fetchSetReminderSuccess, fetchSetReminderFailure = _actions.fetchSetReminderFailure, setNotificationSuccess = _actions.setNotificationSuccess;
/* harmony default export */ __webpack_exports__["ZP"] = (schedulePageSlice.reducer);


/***/ }),

/***/ 41356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ ieltsPlusActions; },
/* harmony export */   "Q": function() { return /* binding */ IeltsPlusActionsTypes; }
/* harmony export */ });
var IeltsPlusActionsTypes = {
    CHECK_IELTS_BATCHES_ENROLLMENT: "CHECK_IELTS_BATCHES_ENROLLMENT"
};
var fetchIeltsData = function() {
    return {
        type: "IELTS_FETCH_REQUESTED"
    };
};
var fetchSuccess = function(payload) {
    return {
        type: "IElTS_FETCH_SUCCEEDED",
        payload: payload
    };
};
var fetchFail = function(message) {
    return {
        type: "IELTS_FETCH_FAILED",
        payload: message
    };
};
var updateModalText = function(payload) {
    return {
        type: "UPDATE_MODAL_TEXT",
        payload: payload
    };
};
var toggleConfirmModal = function(payload) {
    return {
        type: "TOGGLE_CONFIRM_MODAL",
        payload: payload
    };
};
var enrollToIeltsPlus = function(batchId) {
    return {
        type: "ENROLL_TO_IELTS_PLUS",
        payload: batchId
    };
};
var enrollSuccess = function(payload) {
    return {
        type: "ENROLL_SUCCESS",
        payload: payload
    };
};
var enrollFail = function(message) {
    return {
        type: "ENROLL_FAILED",
        payload: message
    };
};
var fetchObjects = function(batchId) {
    return {
        type: "FETCH_OBJECTS_REQUESTED",
        payload: batchId
    };
};
var fetchObjectsSuccess = function(payload) {
    return {
        type: "FETCH_OBJECTS_SUCCESS",
        payload: payload
    };
};
var fetchObjectsFail = function(message) {
    return {
        type: "FETCH_OBJECTS_FAIL",
        payload: message
    };
};
var toggleRegisterModal = function(payload) {
    return {
        type: "TOGGLE_REGISTER_MODAL",
        payload: payload
    };
};
var toggleJoinModal = function(payload) {
    return {
        type: "TOGGLE_JOIN_MODAL",
        payload: payload
    };
};
var fetchEnrolledBatches = function() {
    return {
        type: "FETCH_ENROLLED_BATCHES_REQUESTED"
    };
};
var fetchEnrolledBatchesSuccess = function(payload) {
    return {
        type: "FETCH_ENROLLED_BATCHES_SUCCESS",
        payload: payload
    };
};
var updateError = function(message) {
    return {
        type: "UPDATE_IELTS_PLUS_ERROR_MESSAGE",
        payload: message
    };
};
var updateActiveBatchId = function(payload) {
    return {
        type: "UPDATE_ACTIVE_BATCH_ID",
        payload: payload
    };
};
var updateAddToCalendar = function(payload) {
    return {
        type: "UPDATE_ADD_TO_CALENDAR_STATUS",
        payload: payload
    };
};
var addCompletedIeltsClasses = function(payload) {
    return {
        type: "ADD_COMPLETED_IELTS_CLASSES",
        payload: payload
    };
};
var addUpcomingIeltsClasses = function(payload) {
    return {
        type: "ADD_UPCOMING_IELTS_CLASSES",
        payload: payload
    };
};
var addAllIeltsClasses = function(payload) {
    return {
        type: "ADD_ALL_IELTS_CLASSES",
        payload: payload
    };
};
var toggleLoadingEnrolledClasses = function(payload) {
    return {
        type: "TOGGLE_LOADING_ENROLLED_CLASSES",
        payload: payload
    };
};
var checkIeltsEnrollment = function(payload) {
    return {
        type: "CHECK_IETLS_ENROLLMENT",
        payload: payload
    };
};
var checkFoundationEnrollment = function(payload) {
    return {
        type: "CHECK_FOUNDATION_ENROLLMENT",
        payload: payload
    };
};
var checkPlusEnrollment = function(payload) {
    return {
        type: "CHECK_PLUS_ENROLLMENT",
        payload: payload
    };
};
var checkPremiumEnrollment = function(payload) {
    return {
        type: "CHECK_PREMIUM_ENROLLMENT",
        payload: payload
    };
};
var checkIeltsBatchesEnrollment = function(payload) {
    return {
        type: IeltsPlusActionsTypes.CHECK_IELTS_BATCHES_ENROLLMENT,
        payload: payload
    };
};
var fetchRewardList = function(payload) {
    return {
        type: "FETCH_REWARD_LIST_REQUESTED",
        payload: payload
    };
};
var fetchRewardListSuccess = function(payload) {
    return {
        type: "FETCH_REWARD_LIST_SUCCESS",
        payload: payload
    };
};
var toggleRewardModal = function(payload) {
    return {
        type: "TOGGLE_REWARD_MODAL",
        payload: payload
    };
};
var getClickedRewardDay = function(payload) {
    return {
        type: "GET_CLICKED_REWARD_DAY",
        payload: payload
    };
};
var ieltsPlusActions = {
    fetchIeltsData: fetchIeltsData,
    fetchSuccess: fetchSuccess,
    fetchFail: fetchFail,
    updateModalText: updateModalText,
    toggleConfirmModal: toggleConfirmModal,
    enrollToIeltsPlus: enrollToIeltsPlus,
    enrollSuccess: enrollSuccess,
    enrollFail: enrollFail,
    fetchObjects: fetchObjects,
    fetchObjectsSuccess: fetchObjectsSuccess,
    fetchObjectsFail: fetchObjectsFail,
    toggleRegisterModal: toggleRegisterModal,
    toggleJoinModal: toggleJoinModal,
    fetchEnrolledBatches: fetchEnrolledBatches,
    fetchEnrolledBatchesSuccess: fetchEnrolledBatchesSuccess,
    updateError: updateError,
    updateActiveBatchId: updateActiveBatchId,
    updateAddToCalendar: updateAddToCalendar,
    addCompletedIeltsClasses: addCompletedIeltsClasses,
    addUpcomingIeltsClasses: addUpcomingIeltsClasses,
    toggleLoadingEnrolledClasses: toggleLoadingEnrolledClasses,
    checkIeltsEnrollment: checkIeltsEnrollment,
    checkFoundationEnrollment: checkFoundationEnrollment,
    checkPlusEnrollment: checkPlusEnrollment,
    checkIeltsBatchesEnrollment: checkIeltsBatchesEnrollment,
    fetchRewardList: fetchRewardList,
    fetchRewardListSuccess: fetchRewardListSuccess,
    toggleRewardModal: toggleRewardModal,
    getClickedRewardDay: getClickedRewardDay,
    checkPremiumEnrollment: checkPremiumEnrollment,
    addAllIeltsClasses: addAllIeltsClasses
};


/***/ }),

/***/ 43302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ ieltsTestActions; }
/* harmony export */ });
var toggleIeltsTestForm = function(payload) {
    return {
        type: "TOGGLE_IELTS_TEST_FORM",
        payload: payload
    };
};
var fetchIeltsTestSubmission = function() {
    return {
        type: "FETCH_IELTS_TEST_SUBMISSION_REQUESTED"
    };
};
var updateIeltsTestSubmissionStatus = function(payload) {
    return {
        type: "UPDATE_IELTS_TEST_SUBMISSION_STATUS",
        payload: payload
    };
};
var saveIeltsSubmissionDetails = function(payload) {
    return {
        type: "SAVE_IELTS_TEST_SUBMISSION_DETAILS",
        payload: payload
    };
};
var toggleShowIeltsSubmissionSection = function(payload) {
    return {
        type: "TOGGLE_SHOW_IELTS_TEST_SUBMISSION_SECTION",
        payload: payload
    };
};
var updateSubmissionTime = function(payload) {
    return {
        type: "UPDATE_SUBMISSION_TIME",
        payload: payload
    };
};
var toggleShowSubmittedDocsModal = function(payload) {
    return {
        type: "TOGGLE_SHOW_SUBMITTED_DOCS_MODAL",
        payload: payload
    };
};
var setScreen = function(payload) {
    return {
        type: "SET_SCREEN",
        payload: payload
    };
};
var fetchRewards = function(payload) {
    return {
        type: "FETCH_REWARDS",
        payload: payload
    };
};
var setRewards = function(payload) {
    return {
        type: "SET_REWARDS",
        payload: payload
    };
};
var fetchUserStatus = function() {
    return {
        type: "FETCH_USER_STATUS"
    };
};
var setUserStatus = function(payload) {
    return {
        type: "SET_USER_STATUS",
        payload: payload
    };
};
var fetchIeltsTestBannerStatusReq = function() {
    return {
        type: "FETCH_IELTS_TEST_BANNER_STATUS"
    };
};
var setIeltsTestBannerStatusSuccess = function(payload) {
    return {
        type: "FETCH_IELTS_TEST_BANNER_STATUS_SUCCESS",
        payload: payload
    };
};
var ieltsTestActions = {
    toggleIeltsTestForm: toggleIeltsTestForm,
    fetchIeltsTestSubmission: fetchIeltsTestSubmission,
    updateIeltsTestSubmissionStatus: updateIeltsTestSubmissionStatus,
    saveIeltsSubmissionDetails: saveIeltsSubmissionDetails,
    toggleShowIeltsSubmissionSection: toggleShowIeltsSubmissionSection,
    updateSubmissionTime: updateSubmissionTime,
    toggleShowSubmittedDocsModal: toggleShowSubmittedDocsModal,
    setScreen: setScreen,
    fetchRewards: fetchRewards,
    setRewards: setRewards,
    fetchUserStatus: fetchUserStatus,
    setUserStatus: setUserStatus,
    fetchIeltsTestBannerStatusReq: fetchIeltsTestBannerStatusReq,
    setIeltsTestBannerStatusSuccess: setIeltsTestBannerStatusSuccess
};


/***/ }),

/***/ 21491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ joinMasterClassType; },
/* harmony export */   "u": function() { return /* binding */ joinMasterClassActions; }
/* harmony export */ });
var joinMasterClassType = {
    FETCH_REGISTERED_MEETING_DATA: "FETCH_REGISTERED_MEETING_DATA",
    FETCH_REGISTERED_MEETING_DATA_SUCCESS: "FETCH_REGISTERED_MEETING_DATA_SUCCESS",
    FETCH_REGISTERED_MEETING_DATA_FAIL: "FETCH_REGISTERED_MEETING_DATA_FAIL",
    CHANGE_MEETING_STATUS: "CHANGE_MEETING_STATUS",
    FETCH_IELTS_DEMO_DATA: "FETCH_IELTS_DEMO_DATA",
    SET_IELTS_DEMO_DATA: "SET_IELTS_DEMO_DATA"
};
var fetchRegisteredMeetingData = function(payload) {
    return {
        type: joinMasterClassType.FETCH_REGISTERED_MEETING_DATA,
        payload: payload
    };
};
var fetchRegisteredMeetingDataSuccess = function(payload) {
    return {
        type: joinMasterClassType.FETCH_REGISTERED_MEETING_DATA_SUCCESS,
        payload: payload
    };
};
var fetchRegisteredMeetingDatafail = function(payload) {
    return {
        type: joinMasterClassType.FETCH_REGISTERED_MEETING_DATA_FAIL,
        payload: payload
    };
};
var changeMeetingStatus = function(payload) {
    return {
        type: joinMasterClassType.CHANGE_MEETING_STATUS,
        payload: payload
    };
};
var fetchIeltsDemoData = function(payload) {
    return {
        type: joinMasterClassType.FETCH_IELTS_DEMO_DATA,
        payload: payload
    };
};
var setIeltsDemoData = function(payload) {
    return {
        type: joinMasterClassType.SET_IELTS_DEMO_DATA,
        payload: payload
    };
};
var joinMasterClassActions = {
    fetchRegisteredMeetingData: fetchRegisteredMeetingData,
    fetchRegisteredMeetingDataSuccess: fetchRegisteredMeetingDataSuccess,
    fetchRegisteredMeetingDatafail: fetchRegisteredMeetingDatafail,
    changeMeetingStatus: changeMeetingStatus,
    fetchIeltsDemoData: fetchIeltsDemoData,
    setIeltsDemoData: setIeltsDemoData
};


/***/ }),

/***/ 40441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ masterclassReplaysActionType; },
/* harmony export */   "u": function() { return /* binding */ masterclassReplaysActions; }
/* harmony export */ });
var masterclassReplaysActionType = {
    FETCH_MASTERCLASS_REPLAYS: "FETCH_MASTERCLASS_REPLAYS",
    FETCH_MASTERCLASS_REPLAYS_SUCCESS: "FETCH_MASTERCLASS_REPLAYS_SUCCESS",
    UPDATE_ERROR: "UPDATE_ERROR",
    TOGGLE_SUBSCRIPTION_MODAL: "TOGGLE_SUBSCRIPTION_MODAL",
    RESUME_VIDEO_AFTER_SUBSCRIBE: "RESUME_VIDEO_AFTER_SUBSCRIBE"
};
var fetchMasterclassReplays = function() {
    return {
        type: masterclassReplaysActionType.FETCH_MASTERCLASS_REPLAYS
    };
};
var fetchMasterclassReplaysSuccess = function(payload) {
    return {
        type: masterclassReplaysActionType.FETCH_MASTERCLASS_REPLAYS_SUCCESS,
        payload: payload
    };
};
var updateError = function(payload) {
    return {
        type: masterclassReplaysActionType.UPDATE_ERROR,
        payload: payload
    };
};
var toggleSubscriptionModal = function(payload) {
    return {
        type: masterclassReplaysActionType.TOGGLE_SUBSCRIPTION_MODAL,
        payload: payload
    };
};
var resumeVideoAfterSubscribe = function(payload) {
    return {
        type: masterclassReplaysActionType.RESUME_VIDEO_AFTER_SUBSCRIBE,
        payload: payload
    };
};
var masterclassReplaysActions = {
    fetchMasterclassReplays: fetchMasterclassReplays,
    fetchMasterclassReplaysSuccess: fetchMasterclassReplaysSuccess,
    toggleSubscriptionModal: toggleSubscriptionModal,
    resumeVideoAfterSubscribe: resumeVideoAfterSubscribe,
    updateError: updateError
};


/***/ }),

/***/ 5721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ masterclassActions; }
/* harmony export */ });
var fetchMasterclassSubscriptionStatus = function() {
    var callback = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {};
    return {
        type: "FETCH_MASTERCLASS_SUBSCRIPTION_REQUESTED",
        callback: callback
    };
};
var fetchMasterclassSubscriptionStatusSuccess = function(payload) {
    return {
        type: "FETCH_MASTERCLASS_SUBSCRIPTION_STATUS_SUCCESS",
        payload: payload
    };
};
var updateError = function(message) {
    return {
        type: "UPDATE_MASTERCLASS_ERROR",
        payload: message
    };
};
var fetchMasterclassData = function() {
    return {
        type: "FETCH_MASTERCLASS_DATA_REQUESTED"
    };
};
var fetchMasterclassDataSuccess = function(payload) {
    return {
        type: "FETCH_MASTERCLASS_DATA_SUCCESS",
        payload: payload
    };
};
var enrollForMasterclassRequested = function() {
    return {
        type: "ENROLL_FOR_MASTERCLASS_REQUESTED"
    };
};
var updateUnsubscribedCtaText = function(payload) {
    return {
        type: "UPDATE_UNSUBSCRIBED_MASTERCLASS_CTA_TEXT",
        payload: payload
    };
};
var toggleConfirmationModal = function(payload) {
    return {
        type: "MASTERCLASS_CONFIRMATION_MODAL",
        payload: payload
    };
};
var toggleMasterclassEnrollModal = function(payload) {
    return {
        type: "TOGGLE_MASTERCLASS_ENROLL_MODAL",
        payload: payload
    };
};
var setMasterclassSubscriptionStatus = function(payload) {
    return {
        type: "SET_MASTERCLASS_SUBSCRIPTION_STATUS",
        payload: payload
    };
};
var subscribeToMasterClass = function(payload) {
    return {
        type: "SUBSCRIBE_TO_MASTERCLASSES",
        payload: payload
    };
};
var fetchBeginnerMasterclass = function() {
    return {
        type: "FETCH_BEGINNER_MASTERCLASS"
    };
};
var fetchBeginnerMasterclassDataSuccess = function(payload) {
    return {
        type: "FETCH_BEGINNER_MASTERCLASS_DATA_SUCCESS",
        payload: payload
    };
};
var fetchFreeIeltsCourseStatus = function() {
    return {
        type: "FETCH_FREE_IELTS_COURSE_STATE"
    };
};
var fetchFreeIeltsCourseSuccess = function(payload) {
    return {
        type: "FETCH_FREE_IELTS_COURSE_STATUS_SUCCESS",
        payload: payload
    };
};
var fetchMasterclassRecommendation = function() {
    return {
        type: "FETCH_MASTERCLASS_RECOMMENDATION"
    };
};
var fetchMasterclassRecommendationSuccess = function(payload) {
    return {
        type: "FETCH_MASTERCLASS_RECOMMENDATION_SUCCESS",
        payload: payload
    };
};
var masterclassActions = {
    fetchMasterclassSubscriptionStatus: fetchMasterclassSubscriptionStatus,
    fetchMasterclassSubscriptionStatusSuccess: fetchMasterclassSubscriptionStatusSuccess,
    updateError: updateError,
    fetchMasterclassData: fetchMasterclassData,
    fetchMasterclassDataSuccess: fetchMasterclassDataSuccess,
    enrollForMasterclassRequested: enrollForMasterclassRequested,
    updateUnsubscribedCtaText: updateUnsubscribedCtaText,
    toggleMasterclassEnrollModal: toggleMasterclassEnrollModal,
    toggleConfirmationModal: toggleConfirmationModal,
    setMasterclassSubscriptionStatus: setMasterclassSubscriptionStatus,
    fetchBeginnerMasterclass: fetchBeginnerMasterclass,
    fetchBeginnerMasterclassDataSuccess: fetchBeginnerMasterclassDataSuccess,
    fetchFreeIeltsCourseStatus: fetchFreeIeltsCourseStatus,
    fetchFreeIeltsCourseSuccess: fetchFreeIeltsCourseSuccess,
    fetchMasterclassRecommendation: fetchMasterclassRecommendation,
    fetchMasterclassRecommendationSuccess: fetchMasterclassRecommendationSuccess,
    subscribeToMasterClass: subscribeToMasterClass
};


/***/ }),

/***/ 27412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bp": function() { return /* binding */ setReserveSeatErrorMessage; },
/* harmony export */   "Cg": function() { return /* binding */ fetchTcyMockTestBannerDetailsAction; },
/* harmony export */   "E1": function() { return /* binding */ setTycBannerData; },
/* harmony export */   "Fc": function() { return /* binding */ setAutoLoginUrl; },
/* harmony export */   "Fg": function() { return /* binding */ setMockTestPrice; },
/* harmony export */   "GQ": function() { return /* binding */ setReserveSeat; },
/* harmony export */   "IC": function() { return /* binding */ setTcyMocktestStatus; },
/* harmony export */   "Jp": function() { return /* binding */ fetchMockTestStatus; },
/* harmony export */   "OX": function() { return /* binding */ setReserveSeatLoading; },
/* harmony export */   "q_": function() { return /* binding */ setCtaText; },
/* harmony export */   "tZ": function() { return /* binding */ fetchMockTestAutoLogin; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27272);



var initialState = {
    status: null,
    isLoading: false,
    error: "",
    reservedTheSeat: null,
    mockTestPrice: null,
    ctaText: "Buy Now",
    autoLoginUrl: null,
    tcyMocktestStatus: null,
    tcyBannerDetails: null
};
var MockTestPrice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "mockTestPrice",
    initialState: initialState,
    reducers: {
        setReserveSeat: function setReserveSeat(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                reservedTheSeat: action.payload
            });
        },
        setReserveSeatErrorMessage: function setReserveSeatErrorMessage(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                error: action.payload
            });
        },
        setReserveSeatLoading: function setReserveSeatLoading(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                isLoading: action.payload
            });
        },
        setMockTestPrice: function setMockTestPrice(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                mockTestPrice: action.payload
            });
        },
        setCtaText: function setCtaText(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                ctaText: action.payload
            });
        },
        setAutoLoginUrl: function setAutoLoginUrl(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                autoLoginUrl: action.payload
            });
        },
        setTcyMocktestStatus: function setTcyMocktestStatus(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                tcyMocktestStatus: action.payload
            });
        },
        setTycBannerData: function setTycBannerData(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                tcyBannerDetails: action.payload
            });
        }
    }
});
var fetchMockTestAutoLogin = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("mockTestPrice/fetchMockTestAutoLogin");
var fetchMockTestStatus = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("mockTestPrice/fetchMockTestStatus");
var fetchTcyMockTestBannerDetailsAction = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("mockTestPrice/fetchTcyMockTestBannerDetails");
var _actions = MockTestPrice.actions;
var setReserveSeat = _actions.setReserveSeat, setReserveSeatErrorMessage = _actions.setReserveSeatErrorMessage, setReserveSeatLoading = _actions.setReserveSeatLoading, setCtaText = _actions.setCtaText, setMockTestPrice = _actions.setMockTestPrice, setAutoLoginUrl = _actions.setAutoLoginUrl, setTcyMocktestStatus = _actions.setTcyMocktestStatus, setTycBannerData = _actions.setTycBannerData;
/* harmony default export */ __webpack_exports__["ZP"] = (MockTestPrice.reducer);


/***/ }),

/***/ 22192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ mockTestActions; }
/* harmony export */ });
var fetchMockTest = function(payload) {
    return {
        type: "FETCH_MOCK_TEST_REQUESTED",
        payload: payload
    };
};
var fetchMockTestSuccess = function(payload) {
    return {
        type: "FETCH_MOCK_TEST_SUCCESS",
        payload: payload
    };
};
var updateError = function(message) {
    return {
        type: "UPDATE_MOCK_TEST_ERROR",
        payload: message
    };
};
var updateView = function(payload) {
    return {
        type: "UPDATE_MOCK_TEST_VIEW",
        payload: payload
    };
};
var updateActiveSection = function(payload) {
    return {
        type: "UPDATE_MOCK_TEST_ACTIVE_SECTION",
        payload: payload
    };
};
var updateActiveTestIndex = function(payload) {
    return {
        type: "UPDATE_ACTIVE_MOCK_TEST_INDEX",
        payload: payload
    };
};
var fetchEssayStatus = function(payload) {
    return {
        type: "FETCH_ESSAY_STATUS_REQUESTED",
        payload: payload
    };
};
var uploadWritingMockTest = function(payload) {
    return {
        type: "UPLOAD_WRITING_MOCK_TEST",
        payload: payload
    };
};
var toggleUploadMockTestStatus = function(payload) {
    return {
        type: "TOGGLE_UPLOAD_MOCK_TEST_STATUS",
        payload: payload
    };
};
var updateActiveMockTestId = function(payload) {
    return {
        type: "UPDATE_ACTIVE_MOCK_TEST_ID",
        payload: payload
    };
};
var fetchEssayList = function() {
    return {
        type: "FETCH_ESSAY_LIST_REQUESTED"
    };
};
var fetchEssayListSuccess = function(payload) {
    return {
        type: "FETCH_ESSAY_LIST_SUCCESS",
        payload: payload
    };
};
var replaceWritingMockTest = function(payload) {
    return {
        type: "REPLACE_WRITING_MOCK_TEST",
        payload: payload
    };
};
var fetchSampleMockTest = function() {
    return {
        type: "FETCH_SAMPLE_MOCK_TEST_REQUESTED"
    };
};
var mockTestActions = {
    fetchMockTest: fetchMockTest,
    fetchMockTestSuccess: fetchMockTestSuccess,
    updateError: updateError,
    updateView: updateView,
    updateActiveSection: updateActiveSection,
    updateActiveTestIndex: updateActiveTestIndex,
    fetchEssayStatus: fetchEssayStatus,
    uploadWritingMockTest: uploadWritingMockTest,
    toggleUploadMockTestStatus: toggleUploadMockTestStatus,
    updateActiveMockTestId: updateActiveMockTestId,
    fetchEssayList: fetchEssayList,
    fetchEssayListSuccess: fetchEssayListSuccess,
    replaceWritingMockTest: replaceWritingMockTest,
    fetchSampleMockTest: fetchSampleMockTest
};


/***/ }),

/***/ 92272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ myClassAction; },
/* harmony export */   "j": function() { return /* binding */ myClassActionType; }
/* harmony export */ });
var myClassActionType = {
    IELTS_FETCH_REQUESTED: "IELTS_FETCH_REQUESTED",
    IElTS_FETCH_SUCCEEDED: "IElTS_FETCH_SUCCEEDED",
    IELTS_FETCH_FAILED: "IELTS_FETCH_FAILED",
    UPDATE_MODAL_TEXT: "UPDATE_MODAL_TEXT",
    TOGGLE_CONFIRM_MODAL: "TOGGLE_CONFIRM_MODAL",
    ENROLL_TO_IELTS_PLUS: "ENROLL_TO_IELTS_PLUS",
    ENROLL_TO_IELTS_PLUS_SUCCESS: "ENROLL_TO_IELTS_PLUS_SUCCESS",
    ENROLL_TO_IELTS_PLUS_FAILED: "ENROLL_TO_IELTS_PLUS_FAILED",
    ENROLL_TO_MASTER_CLASS: "ENROLL_TO_MASTER_CLASS",
    ENROLL_TO_MASTER_CLASS_SUCCESS: "ENROLL_TO_MASTER_CLASS_SUCCESS",
    ENROLL_TO_MASTER_CLASS_FAIL: "ENROLL_TO_MASTER_CLASS_FAIL",
    MASTER_FETCH_REQUESTED: "MASTER_FETCH_REQUESTED",
    MASTER_FETCH_SUCCESS: "MASTER_FETCH_SUCCESS",
    MASTER_FETCH_FAIL: "MASTER_FETCH_FAIL",
    UPCOMING_CLASS_FETCH_REQUESTED: "UPCOMING_CLASS_FETCH_REQUESTED",
    UPCOMING_CLASS_FETCH_SUCCESS: "UPCOMING_CLASS_FETCH_SUCCESS",
    UPCOMING_CLASS_FETCH_FAIL: "UPCOMING_CLASS_FETCH_FAIL",
    SET_IELTS_MODAL: "SET_IELTS_MODAL",
    SET_MASTER_CLASS_MODAL: "SET_MASTER_CLASS_MODAL",
    NOTIFY_USER_FOR_MASTERCLASS: "NOTIFY_USER_FOR_MASTERCLASS",
    FETCH_MASTERCLASS_SUBSCRIPTION_STATUS: "FETCH_MASTERCLASS_SUBSCRIPTION_STATUS"
};
var fetchIeltsData = function() {
    return {
        type: myClassActionType.IELTS_FETCH_REQUESTED
    };
};
var fetchSuccess = function(payload) {
    return {
        type: myClassActionType.IElTS_FETCH_SUCCEEDED,
        payload: payload
    };
};
var fetchFail = function(message) {
    return {
        type: myClassActionType.IELTS_FETCH_FAILED,
        payload: message
    };
};
var updateModalText = function(payload) {
    return {
        type: myClassActionType.UPDATE_MODAL_TEXT,
        payload: payload
    };
};
var toggleConfirmModal = function(payload) {
    return {
        type: myClassActionType.TOGGLE_CONFIRM_MODAL,
        payload: payload
    };
};
var enrollToIeltsPlus = function(batchId) {
    return {
        type: myClassActionType.ENROLL_TO_IELTS_PLUS,
        payload: batchId
    };
};
var enrollIeltsSuccess = function(payload) {
    return {
        type: myClassActionType.ENROLL_TO_IELTS_PLUS_SUCCESS,
        payload: payload
    };
};
var enrollIeltsFail = function(message) {
    return {
        type: myClassActionType.ENROLL_TO_IELTS_PLUS_FAILED,
        payload: message
    };
};
// Master class Actions
var fetchMasterclassSubscriptionStatus = function() {
    return {
        type: myClassActionType.FETCH_MASTERCLASS_SUBSCRIPTION_STATUS
    };
};
var fetchMasterclassSubscriptionStatusSuccess = function(payload) {
    return {
        type: "FETCH_MASTERCLASS_SUBSCRIPTION_STATUS_SUCCESS",
        payload: payload
    };
};
var fetchMasterclassSubscriptionStatusFail = function(message) {
    return {
        type: "FETCH_MASTERCLASS_SUBSCRIPTION_STATUS_FAIL",
        payload: message
    };
};
var fetchMasterClassData = function() {
    return {
        type: myClassActionType.MASTER_FETCH_REQUESTED
    };
};
var fetchMasterClassSuccess = function(payload) {
    return {
        type: myClassActionType.MASTER_FETCH_SUCCESS,
        payload: payload
    };
};
var fetchMasterClassFail = function(message) {
    return {
        type: myClassActionType.MASTER_FETCH_FAIL,
        payload: message
    };
};
var enrollToMasterClass = function() {
    return {
        type: myClassActionType.ENROLL_TO_MASTER_CLASS
    };
};
var enrollToMasterClassSuccess = function(payload) {
    return {
        type: myClassActionType.ENROLL_TO_MASTER_CLASS_SUCCESS,
        payload: payload
    };
};
var enrollToMasterClassFail = function(message) {
    return {
        type: myClassActionType.ENROLL_TO_MASTER_CLASS_FAIL,
        payload: message
    };
};
var notifyUser = function(batchId) {
    return {
        type: myClassActionType.NOTIFY_USER_FOR_MASTERCLASS,
        payload: batchId
    };
};
// upcoming classes
var fetchUpcomingClassData = function() {
    return {
        type: myClassActionType.UPCOMING_CLASS_FETCH_REQUESTED
    };
};
var fetchUpcomingClassSuccess = function(payload) {
    return {
        type: myClassActionType.UPCOMING_CLASS_FETCH_SUCCESS,
        payload: payload
    };
};
var fetchUpcomingClassFail = function(message) {
    return {
        type: myClassActionType.UPCOMING_CLASS_FETCH_FAIL,
        payload: message
    };
};
var setIeltsModal = function(modalStatus) {
    return {
        type: myClassActionType.SET_IELTS_MODAL,
        payload: modalStatus
    };
};
var setMasterClassModal = function(modalStatus) {
    return {
        type: myClassActionType.SET_MASTER_CLASS_MODAL,
        payload: modalStatus
    };
};
var myClassAction = {
    fetchIeltsData: fetchIeltsData,
    fetchSuccess: fetchSuccess,
    fetchFail: fetchFail,
    updateModalText: updateModalText,
    toggleConfirmModal: toggleConfirmModal,
    enrollToIeltsPlus: enrollToIeltsPlus,
    enrollIeltsSuccess: enrollIeltsSuccess,
    enrollIeltsFail: enrollIeltsFail,
    fetchMasterclassSubscriptionStatus: fetchMasterclassSubscriptionStatus,
    fetchMasterclassSubscriptionStatusSuccess: fetchMasterclassSubscriptionStatusSuccess,
    fetchMasterclassSubscriptionStatusFail: fetchMasterclassSubscriptionStatusFail,
    fetchMasterClassData: fetchMasterClassData,
    fetchMasterClassSuccess: fetchMasterClassSuccess,
    fetchMasterClassFail: fetchMasterClassFail,
    fetchUpcomingClassData: fetchUpcomingClassData,
    fetchUpcomingClassSuccess: fetchUpcomingClassSuccess,
    fetchUpcomingClassFail: fetchUpcomingClassFail,
    setIeltsModal: setIeltsModal,
    enrollToMasterClass: enrollToMasterClass,
    enrollToMasterClassSuccess: enrollToMasterClassSuccess,
    enrollToMasterClassFail: enrollToMasterClassFail,
    setMasterClassModal: setMasterClassModal,
    notifyUser: notifyUser
};


/***/ }),

/***/ 66362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ noticeBoardActions; }
/* harmony export */ });
var fetchAllNotices = function() {
    return {
        type: "ALL_NOTICE_FETCH_REQUESTED"
    };
};
var fetchNoticeSuccess = function(payload) {
    return {
        type: "ALL_NOTICE_FETCH_SUCCESS",
        payload: payload
    };
};
var fetchNoticeFail = function(payload) {
    return {
        type: "ALL_NOTICE_FETCH_FAIL",
        payload: payload
    };
};
var noticeBoardActions = {
    fetchAllNotices: fetchAllNotices,
    fetchNoticeSuccess: fetchNoticeSuccess,
    fetchNoticeFail: fetchNoticeFail
};


/***/ }),

/***/ 43712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ npsActions; }
/* harmony export */ });
var fetchNpsStatus = function() {
    return {
        type: "FETCH_NPS_STATUS"
    };
};
var fetchFastTrackNpsStatus = function() {
    return {
        type: "FETCH_FAST_TRACK_NPS_STATUS"
    };
};
var fetchNpsStatusSuccess = function(payload) {
    return {
        type: "FETCH_NPS_STATUS_SUCCESS",
        payload: payload
    };
};
var updateNpsStatus = function(payload) {
    return {
        type: "UPDATE_NPS_STATUS",
        payload: payload
    };
};
var updateError = function(message) {
    return {
        type: "UPDATE_ERROR_MESSAGE",
        payload: message
    };
};
var submitRatings = function(payload) {
    return {
        type: "SUBMIT_NPS_RATINGS",
        payload: payload
    };
};
var submitForm = function(payload) {
    return {
        type: "SUBMIT_NPS_FORM",
        payload: payload
    };
};
var updateQuestion = function(payload) {
    return {
        type: "UPDATE_NPS_QUESTION",
        payload: payload
    };
};
var updateNpsId = function(payload) {
    return {
        type: "UPDATE_NPS_ID",
        payload: payload
    };
};
var updateQuestionType = function(payload) {
    return {
        type: "UPDATE_QUESTION_TYPE",
        payload: payload
    };
};
var updateQuestionTitle = function(payload) {
    return {
        type: "UPDATE_QUESTION_TITLE",
        payload: payload
    };
};
var updateSubmitRating = function(payload) {
    return {
        type: "UPDATE_SUBMIT_RATING",
        payload: payload
    };
};
var npsActions = {
    fetchNpsStatus: fetchNpsStatus,
    fetchNpsStatusSuccess: fetchNpsStatusSuccess,
    updateNpsStatus: updateNpsStatus,
    updateError: updateError,
    submitRatings: submitRatings,
    submitForm: submitForm,
    updateQuestion: updateQuestion,
    updateNpsId: updateNpsId,
    updateQuestionType: updateQuestionType,
    updateQuestionTitle: updateQuestionTitle,
    fetchFastTrackNpsStatus: fetchFastTrackNpsStatus,
    updateSubmitRating: updateSubmitRating
};


/***/ }),

/***/ 67461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "lY": function() { return /* binding */ setOrientationSelectedBatch; }
/* harmony export */ });
/* unused harmony exports orientationFormSubmitReq, setIsLoading, setError */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27272);



var initialState = {
    isLoading: false,
    formSubmit: false,
    error: "",
    selectedBatch: null
};
var orientationFormSubmitReq = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("orientation/formSubmit");
var orientationSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "orientation",
    initialState: initialState,
    reducers: {
        setIsLoading: function setIsLoading(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                isLoading: action.payload
            });
        },
        setError: function setError(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                error: action.payload
            });
        },
        setOrientationSelectedBatch: function setOrientationSelectedBatch(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                selectedBatch: action.payload
            });
        }
    }
});
var _actions = orientationSlice.actions;
var setIsLoading = _actions.setIsLoading, setError = _actions.setError, setOrientationSelectedBatch = _actions.setOrientationSelectedBatch;
/* harmony default export */ __webpack_exports__["ZP"] = (orientationSlice.reducer);


/***/ }),

/***/ 66096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ quizActions; }
/* harmony export */ });
/* harmony import */ var components_Profile_IeltsProfile_QuizSection_redux_QuizType__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16433);

var fetchQuizListReq = function(batchId) {
    return {
        type: components_Profile_IeltsProfile_QuizSection_redux_QuizType__WEBPACK_IMPORTED_MODULE_0__/* .QuizType.FETCH_QUIZ_LIST */ .p.FETCH_QUIZ_LIST,
        payload: batchId
    };
};
var fetchQuizListSuccess = function(payload) {
    return {
        type: components_Profile_IeltsProfile_QuizSection_redux_QuizType__WEBPACK_IMPORTED_MODULE_0__/* .QuizType.FETCH_QUIZ_LIST_SUCCESS */ .p.FETCH_QUIZ_LIST_SUCCESS,
        payload: payload
    };
};
var updateCompleteQuizList = function(payload) {
    return {
        type: components_Profile_IeltsProfile_QuizSection_redux_QuizType__WEBPACK_IMPORTED_MODULE_0__/* .QuizType.UPDATE_COMPLETE_QUIZ_LIST */ .p.UPDATE_COMPLETE_QUIZ_LIST,
        payload: payload
    };
};
var updateNewQuizList = function(payload) {
    return {
        type: components_Profile_IeltsProfile_QuizSection_redux_QuizType__WEBPACK_IMPORTED_MODULE_0__/* .QuizType.UPDATE_NEW_QUIZ_LIST */ .p.UPDATE_NEW_QUIZ_LIST,
        payload: payload
    };
};
var fetchQuizQuestionReq = function(payload) {
    var isRetake = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, quizBundleId = arguments.length > 2 ? arguments[2] : void 0, batchId = arguments.length > 3 ? arguments[3] : void 0, callback = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : function() {};
    return {
        type: components_Profile_IeltsProfile_QuizSection_redux_QuizType__WEBPACK_IMPORTED_MODULE_0__/* .QuizType.FETCH_QUIZ_QUESTION */ .p.FETCH_QUIZ_QUESTION,
        payload: payload,
        isRetake: isRetake,
        quizBundleId: quizBundleId,
        batchId: batchId,
        callback: callback
    };
};
var fetchQuizQuestionSuccess = function(payload) {
    return {
        type: components_Profile_IeltsProfile_QuizSection_redux_QuizType__WEBPACK_IMPORTED_MODULE_0__/* .QuizType.FETCH_QUIZ_QUESTION_SUCCESS */ .p.FETCH_QUIZ_QUESTION_SUCCESS,
        payload: payload
    };
};
var updateQuizStatus = function(payload) {
    return {
        type: components_Profile_IeltsProfile_QuizSection_redux_QuizType__WEBPACK_IMPORTED_MODULE_0__/* .QuizType.UPDATE_QUIZ_STATUS */ .p.UPDATE_QUIZ_STATUS,
        payload: payload
    };
};
var updateQuizSubmittedAns = function(payload) {
    return {
        type: components_Profile_IeltsProfile_QuizSection_redux_QuizType__WEBPACK_IMPORTED_MODULE_0__/* .QuizType.UPDATE_SUBMITTED_ANS */ .p.UPDATE_SUBMITTED_ANS,
        payload: payload
    };
};
var updateError = function(payload) {
    return {
        type: components_Profile_IeltsProfile_QuizSection_redux_QuizType__WEBPACK_IMPORTED_MODULE_0__/* .QuizType.UPDATE_ERROR */ .p.UPDATE_ERROR,
        payload: payload
    };
};
var startQuizTest = function(payload, quizBundleId, batchId) {
    return {
        type: components_Profile_IeltsProfile_QuizSection_redux_QuizType__WEBPACK_IMPORTED_MODULE_0__/* .QuizType.START_QUIZ_TEST */ .p.START_QUIZ_TEST,
        payload: payload,
        quizBundleId: quizBundleId,
        batchId: batchId
    };
};
var updateAttemptId = function(payload) {
    return {
        type: components_Profile_IeltsProfile_QuizSection_redux_QuizType__WEBPACK_IMPORTED_MODULE_0__/* .QuizType.UPDATE_QUIZ_ATTEMPT_ID */ .p.UPDATE_QUIZ_ATTEMPT_ID,
        payload: payload
    };
};
var submitQuestion = function(payload) {
    return {
        type: components_Profile_IeltsProfile_QuizSection_redux_QuizType__WEBPACK_IMPORTED_MODULE_0__/* .QuizType.SUBMIT_QUESTION_ANS */ .p.SUBMIT_QUESTION_ANS,
        payload: payload
    };
};
var updateSubmitModal = function(payload) {
    return {
        type: components_Profile_IeltsProfile_QuizSection_redux_QuizType__WEBPACK_IMPORTED_MODULE_0__/* .QuizType.UPDATE_SUBMIT_MODAL */ .p.UPDATE_SUBMIT_MODAL,
        payload: payload
    };
};
var updateExitModal = function(payload) {
    return {
        type: components_Profile_IeltsProfile_QuizSection_redux_QuizType__WEBPACK_IMPORTED_MODULE_0__/* .QuizType.UPDATE_EXIT_MODAL */ .p.UPDATE_EXIT_MODAL,
        payload: payload
    };
};
var updateQuizTestDate = function(payload) {
    return {
        type: components_Profile_IeltsProfile_QuizSection_redux_QuizType__WEBPACK_IMPORTED_MODULE_0__/* .QuizType.QUIZ_UPDATE_START_TEST_DATE */ .p.QUIZ_UPDATE_START_TEST_DATE,
        payload: payload
    };
};
var updateQuizEndTestDate = function(payload) {
    return {
        type: components_Profile_IeltsProfile_QuizSection_redux_QuizType__WEBPACK_IMPORTED_MODULE_0__/* .QuizType.QUIZ_UPDATE_END_TEST_DATE */ .p.QUIZ_UPDATE_END_TEST_DATE,
        payload: payload
    };
};
var endQuizTest = function(payload) {
    return {
        type: components_Profile_IeltsProfile_QuizSection_redux_QuizType__WEBPACK_IMPORTED_MODULE_0__/* .QuizType.END_QUIZ_TEST */ .p.END_QUIZ_TEST,
        payload: payload
    };
};
var updateQuizSubmitSuccessfully = function(payload) {
    return {
        type: components_Profile_IeltsProfile_QuizSection_redux_QuizType__WEBPACK_IMPORTED_MODULE_0__/* .QuizType.SUBMIT_SUCCESSFULLY_ACTION */ .p.SUBMIT_SUCCESSFULLY_ACTION,
        payload: payload
    };
};
var updateQuizTitle = function(payload) {
    return {
        type: components_Profile_IeltsProfile_QuizSection_redux_QuizType__WEBPACK_IMPORTED_MODULE_0__/* .QuizType.UPDATE_QUIZ_TITLE */ .p.UPDATE_QUIZ_TITLE,
        payload: payload
    };
};
var fetchQuizModalType = function(payload) {
    return {
        type: components_Profile_IeltsProfile_QuizSection_redux_QuizType__WEBPACK_IMPORTED_MODULE_0__/* .QuizType.FETCH_QUIZ_MODAL_TYPE */ .p.FETCH_QUIZ_MODAL_TYPE,
        payload: payload
    };
};
var fetchQuizModalTypeSuccess = function(payload) {
    return {
        type: components_Profile_IeltsProfile_QuizSection_redux_QuizType__WEBPACK_IMPORTED_MODULE_0__/* .QuizType.FETCH_QUIZ_MODAL_TYPE_SUCCESS */ .p.FETCH_QUIZ_MODAL_TYPE_SUCCESS,
        payload: payload
    };
};
var fetchQuizBundleListReq = function(payload) {
    var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
    return {
        type: components_Profile_IeltsProfile_QuizSection_redux_QuizType__WEBPACK_IMPORTED_MODULE_0__/* .QuizType.FETCH_QUIZ_BUNDLE_TYPE_REQUESTED */ .p.FETCH_QUIZ_BUNDLE_TYPE_REQUESTED,
        payload: payload,
        callback: callback
    };
};
var fetchQuizBundleListSuccess = function(payload) {
    return {
        type: components_Profile_IeltsProfile_QuizSection_redux_QuizType__WEBPACK_IMPORTED_MODULE_0__/* .QuizType.FETCH_QUIZ_BUNDLE_TYPE_SUCCESS */ .p.FETCH_QUIZ_BUNDLE_TYPE_SUCCESS,
        payload: payload
    };
};
var quizActions = {
    fetchQuizListReq: fetchQuizListReq,
    fetchQuizListSuccess: fetchQuizListSuccess,
    updateError: updateError,
    updateCompleteQuizList: updateCompleteQuizList,
    fetchQuizQuestionReq: fetchQuizQuestionReq,
    fetchQuizQuestionSuccess: fetchQuizQuestionSuccess,
    updateNewQuizList: updateNewQuizList,
    updateQuizSubmittedAns: updateQuizSubmittedAns,
    updateQuizStatus: updateQuizStatus,
    startQuizTest: startQuizTest,
    updateAttemptId: updateAttemptId,
    submitQuestion: submitQuestion,
    updateSubmitModal: updateSubmitModal,
    updateExitModal: updateExitModal,
    endQuizTest: endQuizTest,
    updateQuizTestDate: updateQuizTestDate,
    updateQuizSubmitSuccessfully: updateQuizSubmitSuccessfully,
    updateQuizEndTestDate: updateQuizEndTestDate,
    updateQuizTitle: updateQuizTitle,
    fetchQuizModalType: fetchQuizModalType,
    fetchQuizModalTypeSuccess: fetchQuizModalTypeSuccess,
    fetchQuizBundleListReq: fetchQuizBundleListReq,
    fetchQuizBundleListSuccess: fetchQuizBundleListSuccess
};


/***/ }),

/***/ 16433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ QuizType; }
/* harmony export */ });
var QuizType;
(function(QuizType) {
    QuizType["FETCH_QUIZ_LIST"] = "FETCH_QUIZ_LIST";
    QuizType["FETCH_QUIZ_LIST_SUCCESS"] = "FETCH_QUIZ_LIST_SUCCESS";
    QuizType["UPDATE_NEW_QUIZ_LIST"] = "UPDATE_NEW_QUIZ_LIST";
    QuizType["UPDATE_COMPLETE_QUIZ_LIST"] = "UPDATE_COMPLETE_QUIZ_LIST";
    QuizType["FETCH_QUIZ_QUESTION"] = "FETCH_QUIZ_QUESTION";
    QuizType["FETCH_QUIZ_QUESTION_SUCCESS"] = "FETCH_QUIZ_QUESTION_SUCCESS";
    QuizType["UPDATE_ERROR"] = "UPDATE_ERROR";
    QuizType["UPDATE_ACTIVE_QUIZ_ID"] = "UPDATE_ACTIVE_QUIZ_ID";
    QuizType["UPDATE_QUIZ_STATUS"] = "UPDATE_QUIZ_STATUS";
    QuizType["UPDATE_QUIZ_ATTEMPT_ID"] = "UPDATE_QUIZ_ATTEMPT_ID";
    QuizType["UPDATE_SUBMITTED_ANS"] = "UPDATE_SUBMITTED_ANS";
    QuizType["START_QUIZ_TEST"] = "START_QUIZ_TEST";
    QuizType["END_QUIZ_TEST"] = "END_QUIZ_TEST";
    QuizType["SUBMIT_QUESTION_ANS"] = "SUBMIT_QUESTION_ANS";
    QuizType["UPDATE_SUBMIT_MODAL"] = "UPDATE_SUBMIT_MODAL";
    QuizType["UPDATE_EXIT_MODAL"] = "UPDATE_EXIT_MODAL";
    QuizType["QUIZ_UPDATE_START_TEST_DATE"] = "QUIZ_UPDATE_START_TEST_DATE";
    QuizType["QUIZ_UPDATE_END_TEST_DATE"] = "QUIZ_UPDATE_END_TEST_DATE";
    QuizType["SUBMIT_SUCCESSFULLY_ACTION"] = "SUBMIT_SUCCESSFULLY_ACTION";
    QuizType["UPDATE_QUIZ_TITLE"] = "UPDATE_QUIZ_TITLE";
    QuizType["FETCH_QUIZ_MODAL_TYPE"] = "FETCH_QUIZ_MODAL_TYPE";
    QuizType["FETCH_QUIZ_MODAL_TYPE_SUCCESS"] = "FETCH_QUIZ_MODAL_TYPE_SUCCESS";
    QuizType["FETCH_QUIZ_BUNDLE_TYPE_REQUESTED"] = "FETCH_QUIZ_BUNDLE_TYPE_REQUESTED";
    QuizType["FETCH_QUIZ_BUNDLE_TYPE_SUCCESS"] = "FETCH_QUIZ_BUNDLE_TYPE_SUCCESS";
})(QuizType || (QuizType = {}));


/***/ }),

/***/ 49410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ speakingClubType; },
/* harmony export */   "u": function() { return /* binding */ speakingClubActions; }
/* harmony export */ });
var speakingClubType = {
    SPEAKING_CLUB_SLOT_SUCCESS: "SPEAKING_CLUB_SLOT_SUCCESS",
    SPEAKING_CLUB_SLOT_FETCH_FAIL: "SPEAKING_CLUB_SLOT_FETCH_FAIL",
    SPEAKING_CLUB_SLOT_FETCH_REQUESTED: "SPEAKING_CLUB_SLOT_FETCH_REQUESTED",
    SPEAKING_WORKSHOP_POST_REQUESTED: "SPEAKING_WORKSHOP_POST_REQUESTED",
    SPEAKING_WORKSHOP_POST_SUCCESS: "SPEAKING_WORKSHOP_POST_SUCCESS",
    SPEAKING_WORKSHOP_POST_FAIL: "SPEAKING_WORKSHOP_POST_FAIL",
    UPCOMING_SPEAKING_CLUB_REQUEST: "UPCOMING_SPEAKING_CLUB_REQUEST",
    UPCOMING_SPEAKING_CLUB_SUCCESS: "UPCOMING_SPEAKING_CLUB_SUCCESS",
    UPCOMING_SPEAKING_CLUB_FAIL: "UPCOMING_SPEAKING_CLUB_FAIL",
    UPDATE_MODAL_TEXT: "UPDATE_MODAL_TEXT",
    CLOSE_MODAL: "CLOSE_MODAL",
    SET_MODAL_TEXT: "SET_MODAL_TEXT,",
    FETCH_SPEAKING_CLUB_CREDITS: "FETCH_SPEAKING_CLUB_CREDITS",
    FETCH_SPEAKING_CLUB_CREDITS_SUCCESS: "FETCH_SPEAKING_CLUB_CREDITS_SUCCESS",
    FETCH_SPEAKING_CLUB_CREDITS_FAIL: "FETCH_SPEAKING_CLUB_CREDITS_FAIL",
    FETCH_SPEAKING_BUNDLE_PRICE_REQ: "FETCH_SPEAKING_CLUB_BUNDLE_PRICE_REQ",
    FETCH_SPEAKING_BUNDLE_PRICE_SUCCESS: "FETCH_SPEAKING_BUNDLE_PRICE_SUCCESS",
    FETCH_SPEAKING_BUNDLE_PRICE_FAIL: "FETCH_SPEAKING_BUNDLE_PRICE_FAIL",
    TOOGLE_SPEAKING_CLUB_RESCHEDULE_MODAL: "TOOGLE_SPEAKING_CLUB_RESCHEDULE_MODAL",
    TOGGLE_SPEAKING_CLUB_CANCELLED_MODAL: "TOGGLE_SPEAKING_CLUB_CANCELLED_MODAL",
    CANCEL_SPEAKING_CLUB_BATCH: "CANCEL_SPEAKING_CLUB_BATCH",
    UPDATE_SPEAKING_CLUB_ERROR: "UPDATE_SPEAKING_CLUB_ERROR",
    RESCHEDULE_SPEAKING_CLUB_BATCH: "RESCHEDULE_SPEAKING_CLUB_BATCH",
    TOGGLE_SPEAKING_CLUB_IS_RESCHEDULING: "TOGGLE_SPEAKING_CLUB_IS_RESCHEDULING",
    GET_FLSE_VISIBILITY_ACTION: "GET_FLSE_VISIBILITY_ACTION",
    SET_FLSE_VISIBILITY_ACTION: "SET_FLSE_VISIBILITY_ACTION"
};
var fetchSpeakingClubSlotData = function() {
    return {
        type: speakingClubType.SPEAKING_CLUB_SLOT_FETCH_REQUESTED
    };
};
var fetchSpeakingClubSlotSuccess = function(payload) {
    return {
        type: speakingClubType.SPEAKING_CLUB_SLOT_SUCCESS,
        payload: payload
    };
};
var fetchSpeakingClubSlotFail = function(message) {
    return {
        type: speakingClubType.SPEAKING_CLUB_SLOT_FETCH_FAIL,
        payload: message
    };
};
var postSpeakingWorkShop = function(payload) {
    return {
        type: speakingClubType.SPEAKING_WORKSHOP_POST_REQUESTED,
        payload: payload
    };
};
var postSpeakingWorkShopSuccess = function(payload) {
    return {
        type: speakingClubType.SPEAKING_WORKSHOP_POST_SUCCESS,
        payload: payload
    };
};
var postSpeakingWorkShopFail = function(payload) {
    return {
        type: speakingClubType.SPEAKING_WORKSHOP_POST_FAIL,
        payload: payload
    };
};
// upcoming speaking classes action
var fetchUpcomingSpeakingClubData = function() {
    return {
        type: speakingClubType.UPCOMING_SPEAKING_CLUB_REQUEST
    };
};
var fetchUpcomingSpeakingClubSuccess = function(payload) {
    return {
        type: speakingClubType.UPCOMING_SPEAKING_CLUB_SUCCESS,
        payload: payload
    };
};
var fetchUpcomingSpeakingClubFail = function(message) {
    return {
        type: speakingClubType.UPCOMING_SPEAKING_CLUB_FAIL,
        payload: message
    };
};
// modal actions
var closeModal = function() {
    return {
        type: speakingClubType.CLOSE_MODAL
    };
};
var setModalText = function(message) {
    return {
        type: speakingClubType.SET_MODAL_TEXT,
        payload: message
    };
};
var fetchSpeakingClubCredits = function() {
    return {
        type: speakingClubType.FETCH_SPEAKING_CLUB_CREDITS
    };
};
var fetchSpeakingClubCreditsSuccess = function(payload) {
    return {
        type: speakingClubType.FETCH_SPEAKING_CLUB_CREDITS_SUCCESS,
        payload: payload
    };
};
var fetchSpeakingClubCreditsFail = function(message) {
    return {
        type: speakingClubType.FETCH_SPEAKING_CLUB_CREDITS_FAIL,
        payload: message
    };
};
var fetchSpeakingPriceBundleReq = function() {
    return {
        type: speakingClubType.FETCH_SPEAKING_BUNDLE_PRICE_REQ
    };
};
var fetchSpeakingPriceBundleSuccess = function(payload) {
    return {
        type: speakingClubType.FETCH_SPEAKING_BUNDLE_PRICE_SUCCESS,
        payload: payload
    };
};
var fetchSpeakingPriceBundleFail = function(payload) {
    return {
        type: speakingClubType.FETCH_SPEAKING_BUNDLE_PRICE_FAIL,
        payload: payload
    };
};
var toogleSpeakingClubRescheduleModal = function(payload) {
    return {
        type: speakingClubType.TOOGLE_SPEAKING_CLUB_RESCHEDULE_MODAL,
        payload: payload
    };
};
var toggleSpeakingClubCancelledModal = function(payload) {
    return {
        type: speakingClubType.TOGGLE_SPEAKING_CLUB_CANCELLED_MODAL,
        payload: payload
    };
};
var cancelSpeakingClubSlot = function(payload) {
    return {
        type: speakingClubType.CANCEL_SPEAKING_CLUB_BATCH,
        payload: payload
    };
};
var updateError = function(payload) {
    return {
        type: speakingClubType.UPDATE_SPEAKING_CLUB_ERROR,
        payload: payload
    };
};
var rescheduleSlot = function(payload) {
    return {
        type: speakingClubType.RESCHEDULE_SPEAKING_CLUB_BATCH,
        payload: payload
    };
};
var toggleIsRescheduling = function(payload) {
    return {
        type: speakingClubType.TOGGLE_SPEAKING_CLUB_IS_RESCHEDULING,
        payload: payload
    };
};
var getFlseVisibility = function() {
    return {
        type: speakingClubType.GET_FLSE_VISIBILITY_ACTION
    };
};
var setFlseVisibility = function(payload) {
    return {
        type: speakingClubType.SET_FLSE_VISIBILITY_ACTION,
        payload: payload
    };
};
var speakingClubActions = {
    fetchSpeakingClubSlotData: fetchSpeakingClubSlotData,
    fetchSpeakingClubSlotSuccess: fetchSpeakingClubSlotSuccess,
    fetchSpeakingClubSlotFail: fetchSpeakingClubSlotFail,
    postSpeakingWorkShop: postSpeakingWorkShop,
    postSpeakingWorkShopSuccess: postSpeakingWorkShopSuccess,
    postSpeakingWorkShopFail: postSpeakingWorkShopFail,
    fetchUpcomingSpeakingClubData: fetchUpcomingSpeakingClubData,
    fetchUpcomingSpeakingClubSuccess: fetchUpcomingSpeakingClubSuccess,
    fetchUpcomingSpeakingClubFail: fetchUpcomingSpeakingClubFail,
    closeModal: closeModal,
    setModalText: setModalText,
    fetchSpeakingClubCredits: fetchSpeakingClubCredits,
    fetchSpeakingClubCreditsSuccess: fetchSpeakingClubCreditsSuccess,
    fetchSpeakingClubCreditsFail: fetchSpeakingClubCreditsFail,
    fetchSpeakingPriceBundleReq: fetchSpeakingPriceBundleReq,
    fetchSpeakingPriceBundleSuccess: fetchSpeakingPriceBundleSuccess,
    fetchSpeakingPriceBundleFail: fetchSpeakingPriceBundleFail,
    toogleSpeakingClubRescheduleModal: toogleSpeakingClubRescheduleModal,
    toggleSpeakingClubCancelledModal: toggleSpeakingClubCancelledModal,
    cancelSpeakingClubSlot: cancelSpeakingClubSlot,
    updateError: updateError,
    rescheduleSlot: rescheduleSlot,
    toggleIsRescheduling: toggleIsRescheduling,
    getFlseVisibility: getFlseVisibility,
    setFlseVisibility: setFlseVisibility
};


/***/ }),

/***/ 80190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ storiesActions; }
/* harmony export */ });
var fetchStories = function() {
    return {
        type: "FETCH_STORIES"
    };
};
var fetchStoriesSuccess = function(payload) {
    return {
        type: "FETCH_STORIES_SUCCESS",
        payload: payload
    };
};
var updateCategory = function(payload) {
    return {
        type: "UPDATE_ACTIVE_CATEGORY",
        payload: payload
    };
};
var updateStory = function(payload) {
    return {
        type: "UPDATE_ACTIVE_STORY",
        payload: payload
    };
};
var toggleShowStory = function(payload) {
    return {
        type: "TOGGLE_SHOW_STORY",
        payload: payload
    };
};
var updateStorySeen = function(payload) {
    return {
        type: "UPDATE_STORY_SEEN",
        payload: payload
    };
};
var storiesActions = {
    fetchStories: fetchStories,
    fetchStoriesSuccess: fetchStoriesSuccess,
    updateCategory: updateCategory,
    updateStory: updateStory,
    toggleShowStory: toggleShowStory,
    updateStorySeen: updateStorySeen
};


/***/ }),

/***/ 49257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ studyMaterialActions; }
/* harmony export */ });
var fetchFastTrackStudyMaterial = function() {
    return {
        type: "FAST_TRACK_STUDY_MATERIAL_FETCH_REQUESTED"
    };
};
var fetchStudyMaterial = function(payload) {
    return {
        type: "STUDY_MATERIAL_FETCH_REQUESTED",
        payload: payload
    };
};
var fetchStudyMaterialSuccess = function(payload) {
    return {
        type: "STUDY_MATERIAL_FETCH_SUCCESS",
        payload: payload
    };
};
var fetchStudyMaterialFail = function(payload) {
    return {
        type: "STUDY_MATERIAL_FETCH_FAIL",
        payload: payload
    };
};
var studyMaterialActions = {
    fetchStudyMaterial: fetchStudyMaterial,
    fetchStudyMaterialSuccess: fetchStudyMaterialSuccess,
    fetchStudyMaterialFail: fetchStudyMaterialFail,
    fetchFastTrackStudyMaterial: fetchFastTrackStudyMaterial
};


/***/ }),

/***/ 68515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ TestPrepApi; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var service_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14117);



var fetchMockTestList = function(examType) {
    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=test-prep/dashboard/".concat(examType), {
        headers: {
            "X-API-VERSION": "7"
        }
    });
};
var fetchMockTest = function(examId) {
    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=test-prep/card/".concat(examId));
};
var fetchModalDataCms = function() {
    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("".concat("https://cms.leapscholar.com", "/mocktest-modals?status_eq=ACTIVE"));
};
var fetchMocktestPrice = function() {
    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=fee/mock-test/status");
};
var fetchGetDaignosticTests = function() {
    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=test-prep/diagnostic-test/result");
};
var fetchMockTestResult = function(mockTestId) {
    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=test-prep/exam/".concat(mockTestId, "/ieltsScoreCard"), {
        headers: {
            "X-API-VERSION": 3
        }
    });
};
var fetchMockTestResultV4 = function(mockTestId) {
    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=test-prep/exam/".concat(mockTestId, "/ieltsScoreCard"), {
        headers: {
            "X-API-VERSION": 4
        }
    });
};
var fetchSelfPrepBaughtStatus = function() {
    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=fee/self-prep/status");
};
var fetchMockTestsCredits = function() {
    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=mocktest/credit-slot/details");
};
var postWritingExamPreferenceApi = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(payload) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/scholarRoute?path=test-prep/exam/".concat(payload.examId, "/preference"), payload));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postWritingExamPreferenceApi(payload) {
        return _ref.apply(this, arguments);
    };
}();
var fetchLiyMocktestDashboard = function() {
    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=test-prep/liy/dashboard");
};
var TestPrepApi = {
    fetchMockTestList: fetchMockTestList,
    fetchMockTest: fetchMockTest,
    fetchModalDataCms: fetchModalDataCms,
    fetchMocktestPrice: fetchMocktestPrice,
    fetchGetDaignosticTests: fetchGetDaignosticTests,
    fetchMockTestResult: fetchMockTestResult,
    fetchSelfPrepBaughtStatus: fetchSelfPrepBaughtStatus,
    fetchMockTestsCredits: fetchMockTestsCredits,
    postWritingExamPreferenceApi: postWritingExamPreferenceApi,
    fetchLiyMocktestDashboard: fetchLiyMocktestDashboard,
    fetchMockTestResultV4: fetchMockTestResultV4
};


/***/ }),

/***/ 57980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$U": function() { return /* binding */ setShowModal; },
/* harmony export */   "AH": function() { return /* binding */ fetchLiyMocktestDashboard; },
/* harmony export */   "DB": function() { return /* binding */ setInitiatePayment; },
/* harmony export */   "Gk": function() { return /* binding */ setExamResult; },
/* harmony export */   "Gl": function() { return /* binding */ setDaignosticTests; },
/* harmony export */   "H": function() { return /* binding */ setMocktestModalData; },
/* harmony export */   "IQ": function() { return /* binding */ setMockTestIsLoading; },
/* harmony export */   "VD": function() { return /* binding */ setSelfPrepBaughtData; },
/* harmony export */   "W7": function() { return /* binding */ postWritingExamPreference; },
/* harmony export */   "Xu": function() { return /* binding */ setLiyMocktestDashboard; },
/* harmony export */   "_y": function() { return /* binding */ setSubmittedExamPref; },
/* harmony export */   "au": function() { return /* binding */ fetchMockTestModal; },
/* harmony export */   "br": function() { return /* binding */ fetchMockTestPrice; },
/* harmony export */   "dO": function() { return /* binding */ setMockTest; },
/* harmony export */   "go": function() { return /* binding */ fetchGetDaignosticTests; },
/* harmony export */   "h2": function() { return /* binding */ fetchMocktestResult; },
/* harmony export */   "iR": function() { return /* binding */ fetchMockTestsCredits; },
/* harmony export */   "kh": function() { return /* binding */ saveForm; },
/* harmony export */   "lf": function() { return /* binding */ setPracticeTests; },
/* harmony export */   "m5": function() { return /* binding */ fetchMockTest; },
/* harmony export */   "oK": function() { return /* binding */ setShowFLSEFeedback; },
/* harmony export */   "qc": function() { return /* binding */ fetchMockTestList; },
/* harmony export */   "qg": function() { return /* binding */ fetchFLSEFeedbackData; },
/* harmony export */   "rI": function() { return /* binding */ setMockTestList; },
/* harmony export */   "u5": function() { return /* binding */ setMockTestError; },
/* harmony export */   "wl": function() { return /* binding */ setUnlockPrice; },
/* harmony export */   "xs": function() { return /* binding */ setDaignosticTestsError; },
/* harmony export */   "xw": function() { return /* binding */ fetchSelfPrepBaughtStatusAction; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var Interfaces_reducerTypes_TestPrepSchema__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32707);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27272);




var initialState = {
    isLoading: false,
    errorMessage: "",
    MockTestData: null,
    examData: [],
    showModal: Interfaces_reducerTypes_TestPrepSchema__WEBPACK_IMPORTED_MODULE_0__/* .ModalTypes.INITIAL */ .Qi.INITIAL,
    mocktestModalData: null,
    initiatePayment: false,
    unlockPriceObj: null,
    daignosticTests: null,
    daignosticTestsError: null,
    singleMockTest: null,
    examResult: null,
    selfPrepBaughtData: null,
    practiceTests: null,
    submittedExamPref: false,
    showFLSEFeedback: false,
    liyMocktestDashboard: null
};
var TestPrepSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createSlice */ .oM)({
    name: "mockTest",
    initialState: initialState,
    reducers: {
        setMockTestIsLoading: function setMockTestIsLoading(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                isLoading: action.payload
            });
        },
        setMockTestError: function setMockTestError(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                errorMessage: action.payload
            });
        },
        setMockTestList: function setMockTestList(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                examData: action.payload
            });
        },
        setMockTest: function setMockTest(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                singleMockTest: action.payload
            });
        },
        setShowModal: function setShowModal(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                showModal: action.payload
            });
        },
        setMocktestModalData: function setMocktestModalData(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                mocktestModalData: action.payload
            });
        },
        setInitiatePayment: function setInitiatePayment(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                initiatePayment: action.payload
            });
        },
        setUnlockPrice: function setUnlockPrice(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                unlockPriceObj: action.payload
            });
        },
        setDaignosticTests: function setDaignosticTests(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                daignosticTests: action.payload
            });
        },
        setDaignosticTestsError: function setDaignosticTestsError(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                daignosticTestsError: action.payload
            });
        },
        setExamResult: function setExamResult(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                examResult: action.payload
            });
        },
        setSelfPrepBaughtData: function setSelfPrepBaughtData(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                selfPrepBaughtData: action.payload
            });
        },
        setPracticeTests: function setPracticeTests(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                practiceTests: action.payload
            });
        },
        setSubmittedExamPref: function setSubmittedExamPref(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                submittedExamPref: action.payload
            });
        },
        setShowFLSEFeedback: function setShowFLSEFeedback(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                showFLSEFeedback: action.payload
            });
        },
        setLiyMocktestDashboard: function setLiyMocktestDashboard(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                liyMocktestDashboard: action.payload
            });
        }
    }
});
var fetchMockTestList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createAction */ .PH)("mockTest/fetchMockTestList");
var fetchMockTest = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createAction */ .PH)("mockTest/fetchMockTest");
var fetchMockTestModal = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createAction */ .PH)("mockTest/fetchMockTestModal");
var fetchMockTestPrice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createAction */ .PH)("mockTest/fetchMockTestModalPrice");
var fetchGetDaignosticTests = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createAction */ .PH)("mockTest/fetchGetDaignosticTests");
var fetchMocktestResult = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createAction */ .PH)("mockTest/fetchMocktestResult");
var saveForm = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createAction */ .PH)("mockTest/saveForm");
var fetchSelfPrepBaughtStatusAction = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createAction */ .PH)("mockTest/fetchSelfPrepBaughtStatusAction");
var fetchMockTestsCredits = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createAction */ .PH)("mockTest/fetchMockTestsCredits");
var fetchFLSEFeedbackData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createAction */ .PH)("mockTest/fetchFLSEFeedbackData");
var postWritingExamPreference = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createAction */ .PH)("mockTest/postWritingExamPreference");
var fetchLiyMocktestDashboard = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createAction */ .PH)("mockTest/fetchLiyMocktestDashboard");
var _actions = TestPrepSlice.actions;
var setMockTestIsLoading = _actions.setMockTestIsLoading, setMockTestError = _actions.setMockTestError, setMockTestList = _actions.setMockTestList, setMockTest = _actions.setMockTest, setShowModal = _actions.setShowModal, setMocktestModalData = _actions.setMocktestModalData, setInitiatePayment = _actions.setInitiatePayment, setUnlockPrice = _actions.setUnlockPrice, setDaignosticTests = _actions.setDaignosticTests, setDaignosticTestsError = _actions.setDaignosticTestsError, setExamResult = _actions.setExamResult, setSelfPrepBaughtData = _actions.setSelfPrepBaughtData, setPracticeTests = _actions.setPracticeTests, setSubmittedExamPref = _actions.setSubmittedExamPref, setShowFLSEFeedback = _actions.setShowFLSEFeedback, setLiyMocktestDashboard = _actions.setLiyMocktestDashboard;
/* harmony default export */ __webpack_exports__["ZP"] = (TestPrepSlice.reducer);


/***/ }),

/***/ 51055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ upcomingClassActions; },
/* harmony export */   "r": function() { return /* binding */ upcomingType; }
/* harmony export */ });
var upcomingType = {
    UPCOMING_CLASS_FETCH_REQUESTED: "UPCOMING_CLASS_FETCH_REQUESTED",
    LIVE_CLASS_FETCH_REQUESTED: "LIVE_CLASS_FETCH_REQUESTED",
    LIVE_MASTERCLASS_FETCH_REQUESTED: "LIVE_MASTERCLASS_FETCH_REQUESTED",
    UPCOMING_CLASS_FETCH_SUCCESS: "UPCOMING_CLASS_FETCH_SUCCESS",
    UPCOMING_CLASS_FETCH_FAIL: "UPCOMING_CLASS_FETCH_FAIL",
    LIVE_CLASS_FETCH_SUCCESS: "LIVE_CLASS_FETCH_SUCCESS",
    UPCOMING_EXTRA_CLASS_FETCH_SUCCESS: "UPCOMING_EXTRA_CLASS_FETCH_SUCCESS",
    SET_LIVE_MASTERCLASS: "SET_UPCOMING_MASTERCLASS",
    SET_LIVE_IELTS: "SET_UPCOMING_IELTS",
    FETCH_VOICE_ROOM_DATA: "FETCH_VOICE_ROOM_DATA",
    FETCH_VOICE_ROOM_SUCCESS: "FETCH_VOICE_ROOM_SUCCESS",
    SET_IS_LOADING: "SET_IS_LOADING",
    SET_ORIENTATION_CLASS: "SET_ORIENTATION_CLASS",
    SET_ORIENTATION_ENROLMENT: "SET_ORIENTATION_ENROLMENT",
    FETCH_ENHANCE_ENROLLMENT: "FETCH_ENHANCE_ENROLLMENT",
    GET_LIVE_CLASS_MEETING_LINK: "GET_LIVE_CLASS_MEETING_LINK"
};
var fetchUpcomingClassData = function() {
    return {
        type: upcomingType.UPCOMING_CLASS_FETCH_REQUESTED
    };
};
var fetchUpcomingClassSuccess = function(payload) {
    return {
        type: upcomingType.UPCOMING_CLASS_FETCH_SUCCESS,
        payload: payload
    };
};
var fetchUpcomingClassFail = function(message) {
    return {
        type: upcomingType.UPCOMING_CLASS_FETCH_FAIL,
        payload: message
    };
};
var fetchLiveClassSuccess = function(payload) {
    return {
        type: upcomingType.LIVE_CLASS_FETCH_SUCCESS,
        payload: payload
    };
};
var fetchUpcomingextraClassSuccess = function(payload) {
    return {
        type: upcomingType.UPCOMING_EXTRA_CLASS_FETCH_SUCCESS,
        payload: payload
    };
};
var setUpcomingMasterclass = function(payload) {
    return {
        type: upcomingType.SET_LIVE_MASTERCLASS,
        payload: payload
    };
};
var setUpcomingIelts = function(payload) {
    return {
        type: upcomingType.SET_LIVE_IELTS,
        payload: payload
    };
};
var setOrientationClass = function(payload) {
    return {
        type: upcomingType.SET_ORIENTATION_CLASS,
        payload: payload
    };
};
var fetchLiveClassData = function() {
    return {
        type: upcomingType.LIVE_CLASS_FETCH_REQUESTED
    };
};
var fetchLiveMasterClassData = function(payload) {
    return {
        type: upcomingType.LIVE_MASTERCLASS_FETCH_REQUESTED,
        payload: payload
    };
};
var fetchVoiceRoomData = function() {
    return {
        type: upcomingType.FETCH_VOICE_ROOM_DATA
    };
};
var fetchVoiceRoomSuccess = function(payload) {
    return {
        type: upcomingType.FETCH_VOICE_ROOM_SUCCESS,
        payload: payload
    };
};
var setLoading = function(payload) {
    return {
        type: upcomingType.SET_IS_LOADING,
        payload: payload
    };
};
var setOrientationEnrollment = function(payload) {
    return {
        type: upcomingType.SET_ORIENTATION_ENROLMENT,
        payload: payload
    };
};
var fetchEnhanceEnrollment = function() {
    return {
        type: upcomingType.FETCH_ENHANCE_ENROLLMENT
    };
};
var upcomingClassActions = {
    fetchUpcomingClassData: fetchUpcomingClassData,
    fetchUpcomingClassSuccess: fetchUpcomingClassSuccess,
    fetchUpcomingClassFail: fetchUpcomingClassFail,
    fetchLiveClassSuccess: fetchLiveClassSuccess,
    fetchUpcomingextraClassSuccess: fetchUpcomingextraClassSuccess,
    setUpcomingMasterclass: setUpcomingMasterclass,
    setUpcomingIelts: setUpcomingIelts,
    fetchLiveClassData: fetchLiveClassData,
    fetchLiveMasterClassData: fetchLiveMasterClassData,
    fetchVoiceRoomData: fetchVoiceRoomData,
    fetchVoiceRoomSuccess: fetchVoiceRoomSuccess,
    setLoading: setLoading,
    setOrientationClass: setOrientationClass,
    setOrientationEnrollment: setOrientationEnrollment,
    fetchEnhanceEnrollment: fetchEnhanceEnrollment
};


/***/ }),

/***/ 55007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ ieltsRegistrationFormActions; }
/* harmony export */ });
var saveForm = function(payload) {
    return {
        type: "SAVE_IELTS_FORM",
        payload: payload
    };
};
var toggleCtaText = function(payload) {
    return {
        type: "TOGGLE_IELTS_FORM_CTA_TEXT",
        payload: payload
    };
};
var toggleIeltsFormModal = function(payload) {
    return {
        type: "TOGGLE_IELTS_FORM_MODAL",
        payload: payload
    };
};
var enrollToIeltsPlus = function(payload) {
    return {
        type: "ENROLL_TO_IELTS_PLUS_FORM",
        payload: payload
    };
};
var updateError = function(message) {
    return {
        type: "IELTS_FORM_ERROR",
        payload: message
    };
};
//ub
var setIeltsPlusPaymentSuccess = function(payload) {
    return {
        type: "IELTS_PLUS_PAYMENT_SUCCESS",
        payload: payload
    };
};
var toggleFreeTrailEligibility = function(payload) {
    return {
        type: "TOGGLE_FREE_TRAIL_ELIGIBILITY",
        payload: payload
    };
};
var toggleInitPayment = function(payload) {
    return {
        type: "TOGGLE_IELTS_INIT_PAYMENT",
        payload: payload
    };
};
var ieltsRegistrationFormActions = {
    saveForm: saveForm,
    toggleCtaText: toggleCtaText,
    toggleIeltsFormModal: toggleIeltsFormModal,
    enrollToIeltsPlus: enrollToIeltsPlus,
    updateError: updateError,
    //ub
    setIeltsPlusPaymentSuccess: setIeltsPlusPaymentSuccess,
    toggleFreeTrailEligibility: toggleFreeTrailEligibility,
    toggleInitPayment: toggleInitPayment
};


/***/ }),

/***/ 94073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ ieltsRegistrationFormApi; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var service_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14117);



var saveForm = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values) {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/scholarRoute?path=workshop/ielts-class", values);
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function saveForm(values) {
        return _ref.apply(this, arguments);
    };
}();
var enrollToIeltsPlus = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(batchId) {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/scholarRoute?path=student/workshop/1/".concat(batchId, "/enroll"));
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please try after sometime");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function enrollToIeltsPlus(batchId) {
        return _ref.apply(this, arguments);
    };
}();
var updateUserExamType = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(ieltsExamType) {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/scholarRoute?path=ielts-elite/examtype/".concat(ieltsExamType));
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log("Something went wrong");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function updateUserExamType(ieltsExamType) {
        return _ref.apply(this, arguments);
    };
}();
var ieltsRegistrationFormApi = {
    saveForm: saveForm,
    enrollToIeltsPlus: enrollToIeltsPlus,
    updateUserExamType: updateUserExamType
};


/***/ }),

/***/ 34208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ intermediateScreenActions; }
/* harmony export */ });
var toggleView = function(payload) {
    return {
        type: "TOGGLE_INTERMEDIATE_SCREEN_VIEW",
        payload: payload
    };
};
var updateUserInfo = function(payload) {
    return {
        type: "UPDATE_USER_INFO_REQUESTED",
        payload: payload
    };
};
var intermediateScreenActions = {
    toggleView: toggleView,
    updateUserInfo: updateUserInfo
};


/***/ }),

/***/ 42133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ masterclassRegistrationActions; }
/* harmony export */ });
var saveForm = function(payload) {
    return {
        type: "MASTERCLASS_FORM_SUBMIT",
        payload: payload
    };
};
//ub
var saveFormSuccess = function(payload) {
    return {
        type: "MASTERCLASS_FORM_SUBMIT_SUCCESS",
        payload: payload
    };
};
var saveFormValues = function(payload) {
    return {
        type: "SAVE_MASTERCLASS_FORM_VALUES",
        payload: payload
    };
};
var toggleCtaText = function(payload) {
    return {
        type: "TOGGLE_MASTERCLASS_FORM_CTA_TEXT",
        payload: payload
    };
};
var toggleMasterclassFormModal = function(payload) {
    return {
        type: "TOGGLE_MASTERCLASS_FORM_MODAL",
        payload: payload
    };
};
var enrollToMasterclass = function(payload) {
    return {
        type: "ENROLL_TO_MASTERCLASS_FORM",
        payload: payload
    };
};
var updateError = function(message) {
    return {
        type: "MASTERCLASS_FORM_ERROR",
        payload: message
    };
};
var toggleShowForm = function(payload) {
    return {
        type: "TOGGLE_MASTERCLASS_SHOW_FORM",
        payload: payload
    };
};
var toggleShowLoader = function(payload) {
    return {
        type: "TOGGLE_MASTERCLASS_SHOW_LOADER",
        payload: payload
    };
};
var postFormAction = function(payload) {
    return {
        type: "POST_FORM_ACTION",
        payload: payload
    };
};
var toggleIsLoading = function(payload) {
    return {
        type: "TOGGLE_MC_LOADING_STATUS",
        payload: payload
    };
};
var toggleShouldRedirectToI2cTimeline = function(payload) {
    return {
        type: "TOGGLE_I2C_REDIRECT_STATUS",
        payload: payload
    };
};
var masterclassRegistrationActions = {
    saveForm: saveForm,
    saveFormSuccess: saveFormSuccess,
    toggleCtaText: toggleCtaText,
    toggleMasterclassFormModal: toggleMasterclassFormModal,
    enrollToMasterclass: enrollToMasterclass,
    updateError: updateError,
    toggleShowForm: toggleShowForm,
    toggleShowLoader: toggleShowLoader,
    postFormAction: postFormAction,
    saveFormValues: saveFormValues,
    toggleIsLoading: toggleIsLoading,
    toggleShouldRedirectToI2cTimeline: toggleShouldRedirectToI2cTimeline
};


/***/ }),

/***/ 94063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ referAndEarnActions; }
/* harmony export */ });
var fetchUserInfo = function() {
    return {
        type: "USER_DETAILS_FETCH_REQUESTED"
    };
};
var fetchSuccess = function(payload) {
    return {
        type: "USER_DETAILS_FETCH_SUCCESS",
        payload: payload
    };
};
var fetchFail = function(message) {
    return {
        type: "USER_DETAILS_FETCH_FAIL",
        payload: message
    };
};
var referAndEarnActions = {
    fetchUserInfo: fetchUserInfo,
    fetchSuccess: fetchSuccess,
    fetchFail: fetchFail
};


/***/ }),

/***/ 68884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ registrationFormAction; }
/* harmony export */ });
var fetchInitialFormValuesRequested = function() {
    return {
        type: "FETCH_INITIAL_FORM_VALUES_REQUESTED"
    };
};
var fetchInitialFormValuesSuccess = function(payload) {
    return {
        type: "FETCH_INITIAL_FORM_VALUES_SUCCESS",
        payload: payload
    };
};
var updateError = function(message) {
    return {
        type: "UPDATE_IELTS_REGISTRATION_FORM_ERROR",
        paylaod: message
    };
};
var registrationFormAction = {
    fetchInitialFormValuesRequested: fetchInitialFormValuesRequested,
    fetchInitialFormValuesSuccess: fetchInitialFormValuesSuccess,
    updateError: updateError
};


/***/ }),

/***/ 24268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ registrationFormApi; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var service_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14117);



var fetchInitialFormValues = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=workshop/master-class");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchInitialFormValues() {
        return _ref.apply(this, arguments);
    };
}();
var registrationFormApi = {
    fetchInitialFormValues: fetchInitialFormValues
};


/***/ }),

/***/ 31007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ ieltsScreenControllerActions; }
/* harmony export */ });
var setIeltsView = function(payload) {
    return {
        type: "SET_IELTS_SCREEN",
        payload: payload
    };
};
var setIeltsScreenLoading = function(payload) {
    return {
        type: "IELTS_SCREEN_LOADING",
        payload: payload
    };
};
var fetchUserStates = function() {
    return {
        type: "FETCH_USER_STATES"
    };
};
var setUserStates = function(payload) {
    return {
        type: "SET_USER_STATES",
        payload: payload
    };
};
var fetchDemoDetails = function(payload) {
    return {
        type: "FETCH_DEMO_DETAILS",
        payload: payload
    };
};
var setDemoDetails = function(payload) {
    return {
        type: "SET_DEMO_DETAILS",
        payload: payload
    };
};
var fetchUserIeltsDetailsReq = function() {
    return {
        type: "FETCH_USER_IELTS_DETAILS_REQUEST"
    };
};
var fetchUserIeltsDetailsSuccess = function(payload) {
    return {
        type: "FETCH_USER_IELTS_DETAILS_SUCCESS",
        payload: payload
    };
};
var fetchUserI2CEligibility = function() {
    return {
        type: "FETCH_USER_I2C_ELIGIBILITY_REQUEST"
    };
};
var fetchUserI2CEligibilitySuccess = function(payload) {
    return {
        type: "FETCH_USER_I2C_ELIGIBILITY_SUCCESS",
        payload: payload
    };
};
var fetchUserPaymentInfo = function(payload) {
    return {
        type: "FETCH_USER_PAYMENT_INFO",
        payload: payload
    };
};
var fetchUserPaymentInfoSuccess = function(payload) {
    return {
        type: "FETCH_USER_PAYMENT_INFO_SUCCESS",
        payload: payload
    };
};
var fetchIeltsEliteState = function() {
    return {
        type: "FETCH_USER_IELTS_ELITE_STAGE"
    };
};
var fetchIeltsEliteStateSuccess = function(payload) {
    return {
        type: "FETCH_USER_IELTS_ELITE_STAGE_SUCCESS",
        payload: payload
    };
};
var ieltsScreenControllerActions = {
    setIeltsView: setIeltsView,
    setIeltsScreenLoading: setIeltsScreenLoading,
    fetchUserStates: fetchUserStates,
    setUserStates: setUserStates,
    fetchDemoDetails: fetchDemoDetails,
    setDemoDetails: setDemoDetails,
    fetchUserIeltsDetailsReq: fetchUserIeltsDetailsReq,
    fetchUserIeltsDetailsSuccess: fetchUserIeltsDetailsSuccess,
    fetchUserPaymentInfo: fetchUserPaymentInfo,
    fetchUserPaymentInfoSuccess: fetchUserPaymentInfoSuccess,
    fetchIeltsEliteState: fetchIeltsEliteState,
    fetchIeltsEliteStateSuccess: fetchIeltsEliteStateSuccess,
    fetchUserI2CEligibility: fetchUserI2CEligibility,
    fetchUserI2CEligibilitySuccess: fetchUserI2CEligibilitySuccess
};


/***/ }),

/***/ 78575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ ieltsScreenApi; }
/* harmony export */ });
/* harmony import */ var service_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14117);

var fetchIeltsUserStates = function() {
    return service_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/ielts/studentDashboard");
};
var fetchDemoDetails = function(counsellingType) {
    return service_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/scholarRoute?path=counselling/slots/".concat(counsellingType, "/booked"), {
        headers: {
            "X-API-VERSION": "2"
        }
    });
};
var fetchIeltsUserDetails = function() {
    return service_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/scholarRoute?path=ielts-elite/onboarding-details");
};
var fetchIeltsPaymentInfo = function(batchId) {
    return service_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/scholarRoute?path=payment/details/".concat(batchId));
};
var fetchIeltsEliteState = function() {
    return service_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/scholarRoute?path=ielts-elite/stage");
};
var fetchI2CEligibility = function() {
    return service_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/scholarRoute?path=student/eligibility/i2c");
};
var ieltsScreenApi = {
    fetchIeltsUserStates: fetchIeltsUserStates,
    fetchDemoDetails: fetchDemoDetails,
    fetchIeltsUserDetails: fetchIeltsUserDetails,
    fetchIeltsPaymentInfo: fetchIeltsPaymentInfo,
    fetchIeltsEliteState: fetchIeltsEliteState,
    fetchI2CEligibility: fetchI2CEligibility
};


/***/ }),

/***/ 86853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$y": function() { return /* binding */ setWhatsappTipsData; },
/* harmony export */   "Dr": function() { return /* binding */ fetchWhatsappTipsDataAction; },
/* harmony export */   "QF": function() { return /* binding */ setWhatsappTipsStatus; },
/* harmony export */   "QH": function() { return /* binding */ fetchScratchCardStatusAction; },
/* harmony export */   "Qm": function() { return /* binding */ setScratchSubscriptionData; },
/* harmony export */   "TP": function() { return /* binding */ setIsScratchModalOpen; },
/* harmony export */   "TS": function() { return /* binding */ setScratchCardStatus; },
/* harmony export */   "_b": function() { return /* binding */ updateTipsTricksStatusAction; },
/* harmony export */   "iJ": function() { return /* binding */ updateScratchCardStatusAction; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27272);



var DemoRewardsSliceName = "DemoRewards";
var initialState = {
    isScratchModalOpen: false,
    scratchSubscriptionData: null,
    whatsappTipsData: null,
    whatsappTipsStatus: false,
    scratchCardStatus: false
};
var DemoRewardsSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: DemoRewardsSliceName,
    initialState: initialState,
    reducers: {
        setIsScratchModalOpen: function setIsScratchModalOpen(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                isScratchModalOpen: action.payload
            });
        },
        setScratchSubscriptionData: function setScratchSubscriptionData(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                scratchSubscriptionData: action.payload
            });
        },
        setWhatsappTipsData: function setWhatsappTipsData(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                whatsappTipsData: action.payload
            });
        },
        setWhatsappTipsStatus: function setWhatsappTipsStatus(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                whatsappTipsStatus: action.payload
            });
        },
        setScratchCardStatus: function setScratchCardStatus(state, action) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                scratchCardStatus: action.payload
            });
        }
    }
});
var fetchScratchCardStatusAction = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("".concat(DemoRewardsSliceName, "/fetchScratchCardStatus"));
var fetchWhatsappTipsDataAction = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("".concat(DemoRewardsSliceName, "/fetchWhatsappTipsData"));
var updateScratchCardStatusAction = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("".concat(DemoRewardsSliceName, "/updateScratchCardStatus"));
var updateTipsTricksStatusAction = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createAction */ .PH)("".concat(DemoRewardsSliceName, "/updateTipsTricksStatus"));
var _actions = DemoRewardsSlice.actions;
var setIsScratchModalOpen = _actions.setIsScratchModalOpen, setScratchSubscriptionData = _actions.setScratchSubscriptionData, setWhatsappTipsData = _actions.setWhatsappTipsData, setWhatsappTipsStatus = _actions.setWhatsappTipsStatus, setScratchCardStatus = _actions.setScratchCardStatus;
/* harmony default export */ __webpack_exports__["ZP"] = (DemoRewardsSlice.reducer);


/***/ }),

/***/ 67985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ updateProfileActions; },
/* harmony export */   "U": function() { return /* binding */ actionConstants; }
/* harmony export */ });
var actionConstants = {
    //academic details form
    FETCH_ACADEMIC_DATA: "FETCH_ACADEMIC_DATA",
    FETCH_ACADEMIC_DATA_SUCCESS: "FETCH_ACADEMIC_DATA_SUCCESS",
    FETCH_ACADEMIC_DATA_FAIL: "FETCH_ACADEMIC_DATA_FAIL",
    SAVE_ACADEMIC_DATA: "SAVE_ACADEMIC_DATA",
    SAVE_ACADEMIC_DATA_SUCCESS: "SAVE_ACADEMIC_DATA_SUCCESS",
    SAVE_ACADEMIC_DATA_FAIL: "SAVE_ACADEMIC_DATA_FAIL",
    //emergency contact details form
    FETCH_EMERGENCY_CONTACT_DATA: "FETCH_EMERGENCY_CONTACT_DATA",
    FETCH_EMERGENCY_CONTACT_DATA_SUCCESS: "FETCH_EMERGENCY_CONTACT_DATA_SUCCESS",
    FETCH_EMERGENCY_CONTACT_DATA_FAIL: "FETCH_EMERGENCY_CONTACT_DATA_FAIL",
    SAVE_EMERGENCY_CONTACT_DATA: "SAVE_EMERGENCY_CONTACT_DATA",
    SAVE_EMERGENCY_CONTACT_DATA_SUCCESS: "SAVE_EMERGENCY_CONTACT_DATA_SUCCESS",
    SAVE_EMERGENCY_CONTACT_DATA_FAIL: "SAVE_EMERGENCY_CONTACT_DATA_FAIL",
    //state & city actions
    GET_STATE_LIST: "GET_STATE_LIST",
    GET_STATE_LIST_SUCCESS: "GET_STATE_LIST_SUCCESS",
    GET_STATE_LIST_FAIL: "GET_STATE_LIST_FAIL",
    GET_CITY_LIST: "GET_CITY_LIST",
    GET_CITY_LIST_SUCCESS: "GET_CITY_LIST_SUCCESS",
    GET_CITY_LIST_FAIL: "GET_CITY_LIST_FAIL",
    //exam score details
    FETCH_EXAM_SCORE_DATA: "FETCH_EXAM_SCORE_DATA",
    FETCH_EXAM_SCORE_DATA_SUCCESS: "FETCH_EXAM_SCORE_DATA_SUCCESS",
    FETCH_EXAM_SCORE_DATA_FAIL: "FETCH_EXAM_SCORE_DATA_FAIL",
    SAVE_EXAM_SCORE: "SAVE_EXAM_SCORE",
    SAVE_EXAM_SCORE_SUCCESS: "SAVE_EXAM_SCORE_SUCCESS",
    SAVE_EXAM_SCORE_FAIL: "SAVE_EXAM_SCORE_FAIL",
    //work experience details
    FETCH_WORK_EXP_DATA: "FETCH_WORK_EXP_DATA",
    FETCH_WORK_EXP_DATA_SUCCESS: "FETCH_WORK_EXP_DATA_SUCCESS",
    FETCH_WORK_EXP_DATA_FAIL: "FETCH_WORK_EXP_DATA_FAIL",
    SAVE_WORK_EXP: "SAVE_WORK_EXP",
    SAVE_WORK_EXP_SUCCESS: "SAVE_WORK_EXP_SUCCESS",
    SAVE_WORK_EXP_FAIL: "SAVE_WORK_EXP_FAIL",
    DELETE_WORK_EXP: "DELETE_WORK_EXP",
    DELETE_WORK_EXP_SUCCESS: "DELETE_WORK_EXP_SUCCESS",
    DELETE_WORK_EXP_FAIL: "DELETE_WORK_EXP_FAIL",
    RESET_ERROR: "RESET_ERROR"
};
var fetchPersonalData = function() {
    return {
        type: "FETCH_PERSONAL_DATA"
    };
};
var fetchPersonalDataSuccess = function(payload) {
    return {
        type: "FETCH_PERSONAL_DATA_SUCCESS",
        payload: payload
    };
};
var fetchPersonalDataFail = function(message) {
    return {
        type: "FETCH_PERSONAL_DATA_FAIL",
        payload: message
    };
};
var savePersonalData = function(payload) {
    return {
        type: "SAVE_PERSONAL_DATA",
        payload: payload
    };
};
var savePersonalDataSuccess = function(payload) {
    return {
        type: "SAVE_PERSONAL_DATA_SUCCESS",
        payload: payload
    };
};
var savePersonalDataFail = function(message) {
    return {
        type: "SAVE_PERSONAL_DATA_FAIL",
        payload: message
    };
};
/*----------- Academic details - start ---------- */ var fetchAcademicDetails = function() {
    return {
        type: actionConstants.FETCH_ACADEMIC_DATA
    };
};
var fetchAcademicDetailsSuccess = function(payload) {
    return {
        type: actionConstants.FETCH_ACADEMIC_DATA_SUCCESS,
        payload: payload
    };
};
var fetchAcademicDetailsFail = function(message) {
    return {
        type: actionConstants.FETCH_ACADEMIC_DATA_FAIL,
        payload: message
    };
};
var saveAcademicDetails = function(payload) {
    return {
        type: actionConstants.SAVE_ACADEMIC_DATA,
        payload: payload
    };
};
var saveAcademicDetailsSuccess = function(payload) {
    return {
        type: actionConstants.SAVE_ACADEMIC_DATA_SUCCESS,
        payload: payload
    };
};
var saveAcademicDetailsFail = function(message) {
    return {
        type: actionConstants.SAVE_ACADEMIC_DATA_FAIL,
        payload: message
    };
};
/*----------- Academic details - start ---------- */ /*----------- Emergency contact details - start ---------- */ var fetchEmergencyContactDetails = function() {
    return {
        type: actionConstants.FETCH_EMERGENCY_CONTACT_DATA
    };
};
var fetchEmergencyContactDetailsSuccess = function(payload) {
    return {
        type: actionConstants.FETCH_EMERGENCY_CONTACT_DATA_SUCCESS,
        payload: payload
    };
};
var fetchEmergencyContactDetailsFail = function(message) {
    return {
        type: actionConstants.FETCH_EMERGENCY_CONTACT_DATA_FAIL,
        payload: message
    };
};
var saveEmergencyContactDetails = function(payload) {
    return {
        type: actionConstants.SAVE_EMERGENCY_CONTACT_DATA,
        payload: payload
    };
};
var saveEmergencyContactDetailsSuccess = function(payload) {
    return {
        type: actionConstants.SAVE_EMERGENCY_CONTACT_DATA_SUCCESS,
        payload: payload
    };
};
var saveEmergencyContactDetailsFail = function(message) {
    return {
        type: actionConstants.SAVE_EMERGENCY_CONTACT_DATA_FAIL,
        payload: message
    };
};
/*----------- Emergency contact details - start ---------- */ /*----------- State,Cities - start ---------- */ var getStateList = function(payload) {
    return {
        type: actionConstants.GET_STATE_LIST,
        payload: payload
    };
};
var getStateListSuccess = function(payload) {
    return {
        type: actionConstants.GET_STATE_LIST_SUCCESS,
        payload: payload
    };
};
var getStateListFail = function(message) {
    return {
        type: actionConstants.GET_STATE_LIST_FAIL,
        payload: message
    };
};
var getCityList = function(payload) {
    return {
        type: actionConstants.GET_CITY_LIST,
        payload: payload
    };
};
var getCityListSuccess = function(payload) {
    return {
        type: actionConstants.GET_CITY_LIST_SUCCESS,
        payload: payload
    };
};
var getCityListFail = function(message) {
    return {
        type: actionConstants.GET_CITY_LIST_FAIL,
        payload: message
    };
};
/*----------- State,Cities - start ---------- */ /*----------- Exam score details - start ---------- */ var fetchExamScoreDetails = function() {
    return {
        type: actionConstants.FETCH_EXAM_SCORE_DATA
    };
};
var fetchExamScoreDetailsSuccess = function(payload) {
    return {
        type: actionConstants.FETCH_EXAM_SCORE_DATA_SUCCESS,
        payload: payload
    };
};
var fetchExamScoreDetailsFail = function(message) {
    return {
        type: actionConstants.FETCH_EXAM_SCORE_DATA_FAIL,
        payload: message
    };
};
var saveExamScoreDetails = function(payload) {
    return {
        type: actionConstants.SAVE_EXAM_SCORE,
        payload: payload
    };
};
var saveExamScoreDetailsSuccess = function(payload) {
    return {
        type: actionConstants.SAVE_EXAM_SCORE_SUCCESS,
        payload: payload
    };
};
var saveExamScoreDetailsFail = function(message) {
    return {
        type: actionConstants.SAVE_EXAM_SCORE_FAIL,
        payload: message
    };
};
/*----------- Exam score details - end ---------- */ /*----------- Work Experience details - start ---------- */ var fetchWorkExpDetails = function() {
    return {
        type: actionConstants.FETCH_WORK_EXP_DATA
    };
};
var fetchWorkExpDetailsSuccess = function(payload) {
    return {
        type: actionConstants.FETCH_WORK_EXP_DATA_SUCCESS,
        payload: payload
    };
};
var fetchWorkExpDetailsFail = function(message) {
    return {
        type: actionConstants.FETCH_WORK_EXP_DATA_FAIL,
        payload: message
    };
};
var saveWorkExpDetails = function(payload) {
    return {
        type: actionConstants.SAVE_WORK_EXP,
        payload: payload
    };
};
var saveWorkExpDetailsSuccess = function(payload) {
    return {
        type: actionConstants.SAVE_WORK_EXP_SUCCESS,
        payload: payload
    };
};
var saveWorkExpDetailsFail = function(message) {
    return {
        type: actionConstants.SAVE_WORK_EXP_FAIL,
        payload: message
    };
};
var deleteWorkExp = function(payload) {
    return {
        type: actionConstants.DELETE_WORK_EXP,
        payload: payload
    };
};
var deleteWorkExpSuccess = function(payload) {
    return {
        type: actionConstants.DELETE_WORK_EXP_SUCCESS,
        payload: payload
    };
};
var deleteWorkExpFail = function(message) {
    return {
        type: actionConstants.DELETE_WORK_EXP_FAIL,
        payload: message
    };
};
/*----------- Work Experience details - end ---------- */ var fetchAddressData = function() {
    return {
        type: "FETCH_ADDRESS_DATA"
    };
};
var fetchAddressDataSuccess = function(payload) {
    return {
        type: "FETCH_ADDRESS_DATA_SUCCESS",
        payload: payload
    };
};
var fetchAddressDataFail = function(message) {
    return {
        type: "FETCH_ADDRESS_DATA_FAIL",
        payload: message
    };
};
var saveAddressData = function(payload) {
    return {
        type: "SAVE_ADDRESS_DATA",
        payload: payload
    };
};
var saveAddressDataSuccess = function(payload) {
    return {
        type: "SAVE_ADDRESS_DATA_SUCCESS",
        payload: payload
    };
};
var saveAddressDataFail = function(message) {
    return {
        type: "SAVE_ADDRESS_DATA_FAIL",
        payload: message
    };
};
var fetchPassportData = function() {
    return {
        type: "FETCH_PASSPORT_DATA"
    };
};
var fetchPassportDataSuccess = function(payload) {
    return {
        type: "FETCH_PASSPORT_DATA_SUCCESS",
        payload: payload
    };
};
var fetchPassportDataFail = function(message) {
    return {
        type: "FETCH_PASSPORT_DATA_FAIL",
        payload: message
    };
};
var savePassportData = function(payload) {
    return {
        type: "SAVE_PASSPORT_DATA",
        payload: payload
    };
};
var savePassportDataSuccess = function(payload) {
    return {
        type: "SAVE_PASSPORT_DATA_SUCCESS",
        payload: payload
    };
};
var savePassportDataFail = function(message) {
    return {
        type: "SAVE_PASSPORT_DATA_FAIL",
        payload: message
    };
};
var fetchBackgroundData = function() {
    return {
        type: "FETCH_BACKGROUND_DATA"
    };
};
var fetchBackgroundDataSuccess = function(payload) {
    return {
        type: "FETCH_BACKGROUND_DATA_SUCCESS",
        payload: payload
    };
};
var fetchBackgroundDataFail = function(message) {
    return {
        type: "FETCH_BACKGROUND_DATA_FAIL",
        payload: message
    };
};
var saveBackgroundData = function(payload) {
    return {
        type: "SAVE_BACKGROUND_DATA",
        payload: payload
    };
};
var saveBackgroundDataSuccess = function(payload) {
    return {
        type: "SAVE_BACKGROUND_DATA_SUCCESS",
        payload: payload
    };
};
var saveBackgroundDataFail = function(message) {
    return {
        type: "SAVE_BACKGROUND_DATA_FAIL",
        payload: message
    };
};
var getCountryList = function() {
    return {
        type: "GET_COUNTRY_LIST"
    };
};
var getCountryListSuccess = function(payload) {
    return {
        type: "GET_COUNTRY_LIST_SUCCESS",
        payload: payload
    };
};
var getCountryListFail = function(message) {
    return {
        type: "GET_COUNTRY_LIST_FAIL",
        payload: message
    };
};
var getLanguageList = function() {
    return {
        type: "GET_LANGUAGE_LIST"
    };
};
var getLanguageListSuccess = function(payload) {
    return {
        type: "GET_LANGUAGE_LIST_SUCCESS",
        payload: payload
    };
};
var getLanguageListFail = function(message) {
    return {
        type: "GET_LANGUAGE_LIST_FAIL",
        payload: message
    };
};
//education details
var fetchEducationData = function() {
    return {
        type: "FETCH_EDUCATION_DATA"
    };
};
var fetchEducationDataSuccess = function(payload) {
    return {
        type: "FETCH_EDUCATION_DATA_SUCCESS",
        payload: payload
    };
};
var fetchEducationDataFail = function(message) {
    return {
        type: "FETCH_EDUCATION_DATA_FAIL",
        payload: message
    };
};
var saveEducationData = function(payload) {
    return {
        type: "SAVE_EDUCATION_DATA",
        payload: payload
    };
};
var saveEducationDataSuccess = function(payload) {
    return {
        type: "SAVE_EDUCATION_DATA_SUCCESS",
        payload: payload
    };
};
var saveEducationDataFail = function(message) {
    return {
        type: "SAVE_EDUCATION_DATA_FAIL",
        payload: message
    };
};
//referee form
var fetchRefereeData = function() {
    return {
        type: "FETCH_REFEREE_DATA"
    };
};
var fetchRefereeDataSuccess = function(payload) {
    return {
        type: "FETCH_REFEREE_DATA_SUCCESS",
        payload: payload
    };
};
var fetchRefereeDataFail = function(message) {
    return {
        type: "FETCH_REFEREE_DATA_FAIL",
        payload: message
    };
};
var saveRefereeData = function(payload) {
    return {
        type: "SAVE_REFEREE_DATA",
        payload: payload
    };
};
var saveRefereeDataSuccess = function(payload) {
    return {
        type: "SAVE_REFEREE_DATA_SUCCESS",
        payload: payload
    };
};
var saveRefereeDataFail = function(message) {
    return {
        type: "SAVE_REFEREE_DATA_FAIL",
        payload: message
    };
};
var resetFetchError = function() {
    return {
        type: "RESET_FETCH_ERROR"
    };
};
var resetSaveError = function() {
    return {
        type: "RESET_SAVE_ERROR"
    };
};
var resetError = function() {
    return {
        type: "RESET_ERROR"
    };
};
var updateProfileActions = {
    fetchPersonalData: fetchPersonalData,
    fetchPersonalDataSuccess: fetchPersonalDataSuccess,
    fetchPersonalDataFail: fetchPersonalDataFail,
    savePersonalData: savePersonalData,
    savePersonalDataSuccess: savePersonalDataSuccess,
    savePersonalDataFail: savePersonalDataFail,
    fetchAddressData: fetchAddressData,
    fetchAddressDataSuccess: fetchAddressDataSuccess,
    fetchAddressDataFail: fetchAddressDataFail,
    saveAddressData: saveAddressData,
    saveAddressDataSuccess: saveAddressDataSuccess,
    saveAddressDataFail: saveAddressDataFail,
    fetchPassportData: fetchPassportData,
    fetchPassportDataSuccess: fetchPassportDataSuccess,
    fetchPassportDataFail: fetchPassportDataFail,
    savePassportData: savePassportData,
    savePassportDataSuccess: savePassportDataSuccess,
    savePassportDataFail: savePassportDataFail,
    fetchBackgroundData: fetchBackgroundData,
    fetchBackgroundDataSuccess: fetchBackgroundDataSuccess,
    fetchBackgroundDataFail: fetchBackgroundDataFail,
    saveBackgroundData: saveBackgroundData,
    saveBackgroundDataSuccess: saveBackgroundDataSuccess,
    saveBackgroundDataFail: saveBackgroundDataFail,
    getCountryList: getCountryList,
    getCountryListSuccess: getCountryListSuccess,
    getCountryListFail: getCountryListFail,
    getLanguageList: getLanguageList,
    getLanguageListSuccess: getLanguageListSuccess,
    getLanguageListFail: getLanguageListFail,
    fetchAcademicDetails: fetchAcademicDetails,
    fetchAcademicDetailsSuccess: fetchAcademicDetailsSuccess,
    fetchAcademicDetailsFail: fetchAcademicDetailsFail,
    saveAcademicDetails: saveAcademicDetails,
    saveAcademicDetailsSuccess: saveAcademicDetailsSuccess,
    saveAcademicDetailsFail: saveAcademicDetailsFail,
    fetchEmergencyContactDetails: fetchEmergencyContactDetails,
    fetchEmergencyContactDetailsSuccess: fetchEmergencyContactDetailsSuccess,
    fetchEmergencyContactDetailsFail: fetchEmergencyContactDetailsFail,
    saveEmergencyContactDetails: saveEmergencyContactDetails,
    saveEmergencyContactDetailsSuccess: saveEmergencyContactDetailsSuccess,
    saveEmergencyContactDetailsFail: saveEmergencyContactDetailsFail,
    getStateList: getStateList,
    getStateListSuccess: getStateListSuccess,
    getStateListFail: getStateListFail,
    getCityList: getCityList,
    getCityListSuccess: getCityListSuccess,
    getCityListFail: getCityListFail,
    fetchExamScoreDetails: fetchExamScoreDetails,
    fetchExamScoreDetailsSuccess: fetchExamScoreDetailsSuccess,
    fetchExamScoreDetailsFail: fetchExamScoreDetailsFail,
    saveExamScoreDetails: saveExamScoreDetails,
    saveExamScoreDetailsSuccess: saveExamScoreDetailsSuccess,
    saveExamScoreDetailsFail: saveExamScoreDetailsFail,
    fetchEducationData: fetchEducationData,
    fetchEducationDataSuccess: fetchEducationDataSuccess,
    fetchEducationDataFail: fetchEducationDataFail,
    saveEducationData: saveEducationData,
    saveEducationDataSuccess: saveEducationDataSuccess,
    saveEducationDataFail: saveEducationDataFail,
    fetchRefereeData: fetchRefereeData,
    fetchRefereeDataSuccess: fetchRefereeDataSuccess,
    fetchRefereeDataFail: fetchRefereeDataFail,
    saveRefereeData: saveRefereeData,
    saveRefereeDataSuccess: saveRefereeDataSuccess,
    saveRefereeDataFail: saveRefereeDataFail,
    fetchWorkExpDetails: fetchWorkExpDetails,
    fetchWorkExpDetailsSuccess: fetchWorkExpDetailsSuccess,
    fetchWorkExpDetailsFail: fetchWorkExpDetailsFail,
    saveWorkExpDetails: saveWorkExpDetails,
    saveWorkExpDetailsSuccess: saveWorkExpDetailsSuccess,
    saveWorkExpDetailsFail: saveWorkExpDetailsFail,
    deleteWorkExp: deleteWorkExp,
    deleteWorkExpSuccess: deleteWorkExpSuccess,
    deleteWorkExpFail: deleteWorkExpFail,
    resetFetchError: resetFetchError,
    resetSaveError: resetSaveError,
    resetError: resetError
};


/***/ }),

/***/ 22767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DS": function() { return /* binding */ confirmRescheduleSlot; },
/* harmony export */   "Ds": function() { return /* binding */ confirmPDETEliteDemoSlot; },
/* harmony export */   "EQ": function() { return /* binding */ fetchSpotCounsellingSlot; },
/* harmony export */   "FE": function() { return /* binding */ confirmSpotCounsellingSlot; },
/* harmony export */   "c5": function() { return /* binding */ confirmIeltsEliteDemoSlot; },
/* harmony export */   "nD": function() { return /* binding */ fetchOptimizeEligibilityJourney; },
/* harmony export */   "nJ": function() { return /* binding */ getInfoForLiveUser; },
/* harmony export */   "sG": function() { return /* binding */ confirmPteEliteDemoSlot; },
/* harmony export */   "yU": function() { return /* binding */ getRegisteredMeetingLink; }
/* harmony export */ });
/* unused harmony exports fetchIeltsEliteDemoSlots, unAuthenticatedFetchIeltsEliteDemoSlot, fetchGetBookedIeltsEliteDemoSlots, postInfoForLiveUser, postLiveButtonClicked */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var service_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14117);
/* harmony import */ var components_SpotCounselling_Calendar_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82788);
/* harmony import */ var utils_events_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42477);
/* harmony import */ var utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51119);
/* harmony import */ var utils_utm_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86147);







var fetchSpotCounsellingSlot = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(setIsLoading, isLoaderNeeded) {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=counselling/slots/live/30");
                case 3:
                    res = _ctx.sent;
                    if (isLoaderNeeded) setIsLoading(false);
                    return _ctx.abrupt("return", res);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log("Something went wrong. Please refresh the page");
                    throw new Error("Something went wrong. Please refresh the page");
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function fetchSpotCounsellingSlot(setIsLoading, isLoaderNeeded) {
        return _ref.apply(this, arguments);
    };
}();
var confirmRescheduleSlot = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(payload) {
        var ref, batchId, utmData, meetingId, data, res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    batchId = payload.batchId, utmData = payload.utmData, meetingId = payload.meetingId;
                    data = {
                        utm_campaign: utmData.utm_campaign || "",
                        utm_source: utmData.utm_source || "",
                        utm_term: utmData.utm_term || "",
                        gclid: (utmData === null || utmData === void 0 ? void 0 : utmData.gclid) || "",
                        adName: (utmData === null || utmData === void 0 ? void 0 : utmData.adName) || "",
                        utm_medium: utmData.utm_medium || "",
                        campaign_type: utmData.campaign_type || "",
                        form_id: ((ref = utmData.formId) === null || ref === void 0 ? void 0 : ref.length) ? utmData.formId : null,
                        ad_id: utmData.ad_id || ""
                    };
                    _ctx.prev = 3;
                    _ctx.next = 6;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/scholarRoute?path=counselling/register/".concat(batchId, "&reschedule=true&meetingId=").concat(meetingId), data);
                case 6:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : res.data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](3);
                    console.log("Something went wrong. Please refresh the page");
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                3,
                10
            ]
        ]);
    }));
    return function confirmRescheduleSlot(payload) {
        return _ref.apply(this, arguments);
    };
}();
var confirmSpotCounsellingSlot = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(payload) {
        var batchId, utmData, res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    batchId = payload.batchId, utmData = payload.utmData;
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/scholarRoute?path=counselling/register/".concat(batchId), utmData);
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : res.data);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](1);
                    console.log("Something went wrong. Please refresh the page");
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                8
            ]
        ]);
    }));
    return function confirmSpotCounsellingSlot(payload) {
        return _ref.apply(this, arguments);
    };
}();
var getRegisteredMeetingLink = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(batch_id) {
        var res, ref, ref1;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=counselling/details/".concat(batch_id));
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    {
                        ;
                        window.open(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.meetingLink, "_blank");
                    }
                    _ctx.next = 9;
                    break;
                case 8:
                    throw new Error(res.data.message);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0 || "Something went wrong. Please refresh the page");
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function getRegisteredMeetingLink(batch_id) {
        return _ref.apply(this, arguments);
    };
}();
// Ielts Elite Demo Api's
var fetchIeltsEliteDemoSlots = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(setIsLoading, isLoaderNeeded) {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=counselling/slots/".concat(components_SpotCounselling_Calendar_utils__WEBPACK_IMPORTED_MODULE_2__/* .SlotTypes.IELTS_SPOT_COUNSELLING */ .C3.IELTS_SPOT_COUNSELLING, "/live/30"));
                case 3:
                    res = _ctx.sent;
                    if (isLoaderNeeded) setIsLoading(false);
                    return _ctx.abrupt("return", res);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function fetchIeltsEliteDemoSlots(setIsLoading, isLoaderNeeded) {
        return _ref.apply(this, arguments);
    };
}();
var confirmIeltsEliteDemoSlot = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(payload, isReschedule) {
        var batchId, config, res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    batchId = payload.batchId;
                    _ctx.prev = 1;
                    config = {
                        method: "POST",
                        url: "/api/scholarRoute?path=counselling/register/".concat(batchId, "&slotType=").concat(components_SpotCounselling_Calendar_utils__WEBPACK_IMPORTED_MODULE_2__/* .SlotTypes.IELTS_SPOT_COUNSELLING */ .C3.IELTS_SPOT_COUNSELLING, "&reschedule=").concat(isReschedule),
                        headers: {
                            "X-IELTS-PLATFORM": (0,utils_events_utils__WEBPACK_IMPORTED_MODULE_3__.getPlatformV2)(),
                            "X-API-VERSION": "2"
                        },
                        data: payload
                    };
                    _ctx.next = 5;
                    return (0,service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(config);
                case 5:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 10:
                    return _ctx.abrupt("return", res.data.message);
                case 11:
                    _ctx.next = 16;
                    break;
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](1);
                    return _ctx.abrupt("return", {
                        data: null,
                        message: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message
                    });
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                13
            ]
        ]);
    }));
    return function confirmIeltsEliteDemoSlot(payload, isReschedule) {
        return _ref.apply(this, arguments);
    };
}();
var confirmPteEliteDemoSlot = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(payload, isReschedule) {
        var batchId, config, res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    batchId = payload.batchId;
                    _ctx.prev = 1;
                    config = {
                        method: "POST",
                        url: "/api/scholarRoute?path=counselling/register/".concat(batchId, "&slotType=").concat(components_SpotCounselling_Calendar_utils__WEBPACK_IMPORTED_MODULE_2__/* .SlotTypes.PTE_SPOT_COUNSELLING */ .C3.PTE_SPOT_COUNSELLING, "&reschedule=").concat(isReschedule),
                        headers: {
                            "X-IELTS-PLATFORM": (0,utils_events_utils__WEBPACK_IMPORTED_MODULE_3__.getPlatformV2)(),
                            "X-API-VERSION": "2"
                        },
                        data: payload
                    };
                    _ctx.next = 5;
                    return (0,service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(config);
                case 5:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 10:
                    return _ctx.abrupt("return", res.data.message);
                case 11:
                    _ctx.next = 16;
                    break;
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](1);
                    return _ctx.abrupt("return", {
                        data: null,
                        message: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message
                    });
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                13
            ]
        ]);
    }));
    return function confirmPteEliteDemoSlot(payload, isReschedule) {
        return _ref.apply(this, arguments);
    };
}();
var confirmPDETEliteDemoSlot = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(payload, isReschedule) {
        var batchId, config, res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    batchId = payload.batchId;
                    _ctx.prev = 1;
                    config = {
                        method: "POST",
                        url: "/api/scholarRoute?path=counselling/register/".concat(batchId, "&slotType=").concat(components_SpotCounselling_Calendar_utils__WEBPACK_IMPORTED_MODULE_2__/* .SlotTypes.DET_SPOT_COUNSELLING */ .C3.DET_SPOT_COUNSELLING, "&reschedule=").concat(isReschedule),
                        headers: {
                            "X-IELTS-PLATFORM": (0,utils_events_utils__WEBPACK_IMPORTED_MODULE_3__.getPlatformV2)(),
                            "X-API-VERSION": "2"
                        },
                        data: payload
                    };
                    _ctx.next = 5;
                    return (0,service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(config);
                case 5:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 10:
                    return _ctx.abrupt("return", res.data.message);
                case 11:
                    _ctx.next = 16;
                    break;
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](1);
                    return _ctx.abrupt("return", {
                        data: null,
                        message: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message
                    });
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                13
            ]
        ]);
    }));
    return function confirmPDETEliteDemoSlot(payload, isReschedule) {
        return _ref.apply(this, arguments);
    };
}();
var unAuthenticatedFetchIeltsEliteDemoSlot = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(tempToken) {
        var res, ref;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/scholarRoute?path=counselling/slots/".concat(components_SpotCounselling_Calendar_utils__WEBPACK_IMPORTED_MODULE_2__/* .SlotTypes.IELTS_SPOT_COUNSELLING */ .C3.IELTS_SPOT_COUNSELLING, "/live/30"), {
                        sessionToken: tempToken
                    });
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    ;
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.message);
                case 10:
                    _ctx.next = 16;
                    break;
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }));
    return function unAuthenticatedFetchIeltsEliteDemoSlot(tempToken) {
        return _ref.apply(this, arguments);
    };
}();
var fetchGetBookedIeltsEliteDemoSlots = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=counselling/slots/".concat(components_SpotCounselling_Calendar_utils__WEBPACK_IMPORTED_MODULE_2__/* .SlotTypes.IELTS_SPOT_COUNSELLING */ .C3.IELTS_SPOT_COUNSELLING, "/booked"));
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchGetBookedIeltsEliteDemoSlots() {
        return _ref.apply(this, arguments);
    };
}();
var getInfoForLiveUser = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, res, ref1;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return (0,service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("/api/scholarRoute?path=lead/liveVOBooking/get");
                case 4:
                    res = _ctx.sent;
                    if (!(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                        _ctx.next = 10;
                        break;
                    }
                    ;
                    return _ctx.abrupt("return", {
                        success: true,
                        data: res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.data
                    });
                case 10:
                    return _ctx.abrupt("return", {
                        success: false,
                        data: {}
                    });
                case 11:
                    _ctx.next = 17;
                    break;
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return", {
                        success: false,
                        data: {}
                    });
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }));
    return function getInfoForLiveUser() {
        return _ref.apply(this, arguments);
    };
}();
var postInfoForLiveUser = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(payType) {
        var ref, res, ref1;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/scholarRoute?path=lead/liveVOBooking/post", {
                        payType: payType
                    });
                case 4:
                    res = _ctx.sent;
                    if (!(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                        _ctx.next = 10;
                        break;
                    }
                    ;
                    return _ctx.abrupt("return", {
                        success: true,
                        data: res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.data
                    });
                case 10:
                    return _ctx.abrupt("return", {
                        success: false,
                        data: null
                    });
                case 11:
                    _ctx.next = 17;
                    break;
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return", {
                        success: false,
                        data: null
                    });
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }));
    return function postInfoForLiveUser(payType) {
        return _ref.apply(this, arguments);
    };
}();
var postLiveButtonClicked = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, res, ref1;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/scholarRoute?path=lead/liveVOBooking/clicked", {
                        isClicked: true
                    });
                case 4:
                    res = _ctx.sent;
                    if (!(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                        _ctx.next = 10;
                        break;
                    }
                    ;
                    return _ctx.abrupt("return", {
                        success: true,
                        data: res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.data
                    });
                case 10:
                    return _ctx.abrupt("return", {
                        success: false,
                        data: null
                    });
                case 11:
                    _ctx.next = 17;
                    break;
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return", {
                        success: false,
                        data: null
                    });
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }));
    return function postLiveButtonClicked() {
        return _ref.apply(this, arguments);
    };
}();
var fetchOptimizeEligibilityJourney = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var utmDetails, refererUrl, referrer, ref, ref1, data, ref2, _targetCampaign, targetCampaign, targetCampaignList, isReferrer, ref3, keys, isEligible;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    utmDetails = (0,utils_utm_utils__WEBPACK_IMPORTED_MODULE_5__/* .getUtmData */ .M)(null);
                    refererUrl = (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_4__/* .getCookie */ .ej)({}, "refererUrl");
                    referrer = refererUrl || (document === null || document === void 0 ? void 0 : document.referrer) || "";
                    _ctx.prev = 3;
                    ;
                    _ctx.next = 7;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("".concat("https://cms.leapscholar.com", "/constants?key=OptimizeEligibilityJourney"));
                case 7:
                    data = _ctx.sent.data;
                    ref2 = ((ref = data[0]) === null || ref === void 0 ? void 0 : ref.jsonValue) || {}, _targetCampaign = ref2.targetCampaign, targetCampaign = _targetCampaign === void 0 ? {} : _targetCampaign;
                    targetCampaignList = Object.keys(targetCampaign);
                    isReferrer = false;
                    ;
                    keys = Object.keys((ref3 = (ref1 = data[0]) === null || ref1 === void 0 ? void 0 : ref1.jsonValue) !== null && ref3 !== void 0 ? ref3 : {});
                    isEligible = keys.some(function(key) {
                        var ref;
                        var valueArray = (ref = data[0]) === null || ref === void 0 ? void 0 : ref.jsonValue[key];
                        if (key === "referrer" && (valueArray === null || valueArray === void 0 ? void 0 : valueArray.includes(referrer))) {
                            isReferrer = true;
                        }
                        var utmValue = utmDetails[key];
                        return utmValue && (valueArray === null || valueArray === void 0 ? void 0 : valueArray.length) && (valueArray === null || valueArray === void 0 ? void 0 : valueArray.some(function(ele) {
                            if (targetCampaignList === null || targetCampaignList === void 0 ? void 0 : targetCampaignList.includes(ele)) {
                                var ref;
                                var utmCampaign = utmDetails.utmCampaign;
                                return ((ref = targetCampaign[ele]) === null || ref === void 0 ? void 0 : ref.includes(utmCampaign)) && ele === (utmValue === null || utmValue === void 0 ? void 0 : utmValue.toLowerCase());
                            }
                            return ele === (utmValue === null || utmValue === void 0 ? void 0 : utmValue.toLowerCase());
                        }));
                    });
                    return _ctx.abrupt("return", isEligible && isReferrer);
                case 17:
                    _ctx.prev = 17;
                    _ctx.t0 = _ctx["catch"](3);
                    console.error(_ctx.t0);
                    return _ctx.abrupt("return", false);
                case 21:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                3,
                17
            ]
        ]);
    }));
    return function fetchOptimizeEligibilityJourney() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 82788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C3": function() { return /* binding */ SlotTypes; },
/* harmony export */   "Ol": function() { return /* binding */ getDashboardRoute; },
/* harmony export */   "uy": function() { return /* binding */ getExamType; }
/* harmony export */ });
/* harmony import */ var page_routes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12615);

var SlotTypes;
(function(SlotTypes) {
    SlotTypes["IELTS_SPOT_COUNSELLING"] = "IELTS_SPOT_COUNSELLING";
    SlotTypes["PTE_SPOT_COUNSELLING"] = "PTE_SPOT_COUNSELLING";
    SlotTypes["DET_SPOT_COUNSELLING"] = "DET_SPOT_COUNSELLING";
})(SlotTypes || (SlotTypes = {}));
var getDashboardRoute = function(event) {
    switch(event){
        case SlotTypes.IELTS_SPOT_COUNSELLING:
            return page_routes__WEBPACK_IMPORTED_MODULE_0__/* .navRoutes.IELTS_STUDENT_DASHBOARD */ .CZ.IELTS_STUDENT_DASHBOARD;
        case SlotTypes.PTE_SPOT_COUNSELLING:
            return page_routes__WEBPACK_IMPORTED_MODULE_0__/* .navRoutes.PTE_DASBOARD */ .CZ.PTE_DASBOARD;
        case SlotTypes.DET_SPOT_COUNSELLING:
            return page_routes__WEBPACK_IMPORTED_MODULE_0__/* .navRoutes.DET_DASHBOARD */ .CZ.DET_DASHBOARD;
    }
};
var getExamType = function(event) {
    switch(event){
        case SlotTypes.IELTS_SPOT_COUNSELLING:
            return "IELTS";
        case SlotTypes.PTE_SPOT_COUNSELLING:
            return "PTE";
        case SlotTypes.DET_SPOT_COUNSELLING:
            return "DET";
    }
};


/***/ }),

/***/ 10585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ spotCounsellingActions; }
/* harmony export */ });
var fetchExpertsData = function() {
    return {
        type: "FETCH_EXPERTS_DATA"
    };
};
var fetchExpertsSuccess = function(payload) {
    return {
        type: "FETCH_EXPERTS_DATA_SUCCESS",
        payload: payload
    };
};
var fetchExpertsFail = function(message) {
    return {
        type: "FETCH_EXPERTS_DATA_FAIL",
        payload: message
    };
};
var fetchStage = function() {
    return {
        type: "FETCH_STAGE"
    };
};
var fetchStageSuccess = function(payload) {
    return {
        type: "FETCH_STAGE_SUCCESS",
        payload: payload
    };
};
var fetchStageFail = function(message) {
    return {
        type: "FETCH_STAGE_FAIL",
        payload: message
    };
};
var fetchAppNudgeEligibility = function() {
    return {
        type: "FETCH_APP_NUDGE_ELIGIBILITY"
    };
};
var fetchAppNudgeEligibilitySuccess = function(payload) {
    return {
        type: "FETCH_APP_NUDGE_ELIGIBILITY_SUCCESS",
        payload: payload
    };
};
var fetchAppNudgeData = function(payload) {
    return {
        type: "FETCH_APP_NUDGE_DATA",
        payload: payload
    };
};
var fetchAppNudgeEligibilityFail = function(message) {
    return {
        type: "FETCH_APP_NUDGE_ELIGIBILITY_FAIL",
        payload: message
    };
};
var fetchSpotCounsellingSlot = function() {
    return {
        type: "FETCH_SPOT_COUNSELLING_SLOT"
    };
};
var fetchSpotCounsellingSlotSuccess = function(payload) {
    return {
        type: "FETCH_SPOT_COUNSELLING_SLOT_SUCCESS",
        payload: payload
    };
};
var fetchSpotCounsellingSlotFail = function(message) {
    return {
        type: "FETCH_SPOT_COUNSELLING_SLOT_FAIL",
        payload: message
    };
};
var confirmSpotCounsellingSlot = function(payload) {
    return {
        type: "CONFIRM_SPOT_COUNSELLING_SLOT",
        payload: payload
    };
};
var confirmSpotCounsellingSlotSuccess = function(payload) {
    return {
        type: "CONFIRM_SPOT_COUNSELLING_SLOT_SUCCESS",
        payload: payload
    };
};
var confirmSpotCounsellingSlotFail = function(message) {
    return {
        type: "CONFIRM_SPOT_COUNSELLING_SLOT_FAIL",
        payload: message
    };
};
var confirmRescheduleSlot = function(payload) {
    return {
        type: "CONFIRM_SPOT_RESCHEDULE_SLOT",
        payload: payload
    };
};
var confirmRescheduleSlotSuccess = function(payload) {
    return {
        type: "CONFIRM_SPOT_RESCHEDULE_SLOT_SUCCESS",
        payload: payload
    };
};
var confirmRescheduleSlotFail = function(message) {
    return {
        type: "CONFIRM_SPOT_RESCHEDULE_SLOT_FAIL",
        payload: message
    };
};
var fetchSpotProfile = function() {
    return {
        type: "FETCH_SPOT_PROFILE"
    };
};
var fetchSpotProfileSuccess = function(payload) {
    return {
        type: "FETCH_SPOT_PROFILE_SUCCESS",
        payload: payload
    };
};
var fetchSpotProfileFail = function(message) {
    return {
        type: "FETCH_SPOT_PROFILE_FAIL",
        payload: message
    };
};
var submitSpotProfile = function(payload) {
    return {
        type: "SUBMIT_SPOT_PROFILE",
        payload: payload
    };
};
var submitSpotProfileSuccess = function(payload) {
    return {
        type: "SUBMIT_SPOT_PROFILE_SUCCESS",
        payload: payload
    };
};
var submitSpotProfileFail = function(message) {
    return {
        type: "SUBMIT_SPOT_PROFILE_FAIL",
        payload: message
    };
};
var fetchGoalPlanData = function() {
    return {
        type: "FETCH_GOAL_PLAN_DATA"
    };
};
var fetchUpcomingEvents = function() {
    return {
        type: "FETCH_UPCOMING_EVENTS"
    };
};
var fetchUpcomingEventsSuccess = function(payload) {
    return {
        type: "FETCH_UPCOMING_EVENTS_SUCCESS",
        payload: payload
    };
};
var fetchEligibility = function() {
    return {
        type: "ELIGIBILITY_FETCH_REQUESTED"
    };
};
var fetchEligibilitySuccess = function(payload) {
    return {
        type: "ELIGIBILITY_FETCH_SUCCESS",
        payload: payload
    };
};
var fetchReQualificationCheck = function() {
    return {
        type: "REQUALIFICATION_ELIGIBLITY_FETCH_REQUESTED"
    };
};
var fetchReQualificationCheckSuccess = function(payload) {
    return {
        type: "REQUALIFICATION_ELIGIBLITY_FETCH_SUCCESS",
        payload: payload
    };
};
var fetchProfileLayout = function() {
    return {
        type: "FETCH_PROFILE_LAYOUT"
    };
};
var fetchProfileLayoutSuccess = function(payload) {
    return {
        type: "FETCH_PROFILE_LAYOUT_SUCCESS",
        payload: payload
    };
};
var fetchProfileLayoutFail = function(payload) {
    return {
        type: "FETCH_PROFILE_LAYOUT_FAIL",
        payload: payload
    };
};
var fetchEligibilityFail = function(message) {
    return {
        type: "ELIGIBILITY_FETCH_FAIL",
        payload: message
    };
};
var fetchReQualificationCheckFail = function(message) {
    return {
        type: "REQUALIFICATION_ELIGIBLITY_FETCH_FAIL",
        payload: message
    };
};
var fetchUpcomingEventsFail = function(payload) {
    return {
        type: "FETCH_UPCOMING_EVENTS_FAIL",
        payload: payload
    };
};
var fetchGoalPlanDataSuccess = function(payload) {
    return {
        type: "FETCH_GOAL_PLAN_DATA_SUCCESS",
        payload: payload
    };
};
var fetchGoalPlanDataFail = function(message) {
    return {
        type: "FETCH_GOAL_PLAN_DATA_FAIL",
        payload: message
    };
};
var toggleAppMOdal = function(payload) {
    return {
        type: "TOGGLE_MODAL_APP",
        payload: payload
    };
};
var spotCounsellingActions = {
    toggleAppMOdal: toggleAppMOdal,
    fetchExpertsData: fetchExpertsData,
    fetchExpertsSuccess: fetchExpertsSuccess,
    fetchExpertsFail: fetchExpertsFail,
    fetchStage: fetchStage,
    fetchStageSuccess: fetchStageSuccess,
    fetchStageFail: fetchStageFail,
    fetchSpotCounsellingSlot: fetchSpotCounsellingSlot,
    fetchSpotCounsellingSlotSuccess: fetchSpotCounsellingSlotSuccess,
    fetchSpotCounsellingSlotFail: fetchSpotCounsellingSlotFail,
    confirmSpotCounsellingSlot: confirmSpotCounsellingSlot,
    confirmSpotCounsellingSlotSuccess: confirmSpotCounsellingSlotSuccess,
    confirmSpotCounsellingSlotFail: confirmSpotCounsellingSlotFail,
    confirmRescheduleSlot: confirmRescheduleSlot,
    confirmRescheduleSlotSuccess: confirmRescheduleSlotSuccess,
    confirmRescheduleSlotFail: confirmRescheduleSlotFail,
    fetchSpotProfile: fetchSpotProfile,
    fetchSpotProfileSuccess: fetchSpotProfileSuccess,
    fetchSpotProfileFail: fetchSpotProfileFail,
    submitSpotProfile: submitSpotProfile,
    submitSpotProfileSuccess: submitSpotProfileSuccess,
    submitSpotProfileFail: submitSpotProfileFail,
    fetchGoalPlanData: fetchGoalPlanData,
    fetchGoalPlanDataSuccess: fetchGoalPlanDataSuccess,
    fetchGoalPlanDataFail: fetchGoalPlanDataFail,
    fetchUpcomingEvents: fetchUpcomingEvents,
    fetchUpcomingEventsSuccess: fetchUpcomingEventsSuccess,
    fetchUpcomingEventsFail: fetchUpcomingEventsFail,
    fetchEligibility: fetchEligibility,
    fetchEligibilitySuccess: fetchEligibilitySuccess,
    fetchEligibilityFail: fetchEligibilityFail,
    fetchProfileLayout: fetchProfileLayout,
    fetchProfileLayoutSuccess: fetchProfileLayoutSuccess,
    fetchProfileLayoutFail: fetchProfileLayoutFail,
    fetchReQualificationCheck: fetchReQualificationCheck,
    fetchReQualificationCheckSuccess: fetchReQualificationCheckSuccess,
    fetchReQualificationCheckFail: fetchReQualificationCheckFail,
    fetchAppNudgeEligibility: fetchAppNudgeEligibility,
    fetchAppNudgeEligibilitySuccess: fetchAppNudgeEligibilitySuccess,
    fetchAppNudgeEligibilityFail: fetchAppNudgeEligibilityFail,
    fetchAppNudgeData: fetchAppNudgeData
};


/***/ }),

/***/ 40163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ng": function() { return /* binding */ fetchPreferredCountry; },
/* harmony export */   "Vp": function() { return /* binding */ getAbVariant; },
/* harmony export */   "nr": function() { return /* binding */ spotCounsellingApi; }
/* harmony export */ });
/* unused harmony exports saveData, checkEligibilty, submitSpotProfile */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(828);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var apollo_apollo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22308);
/* harmony import */ var apollo_queries_events__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96325);
/* harmony import */ var service_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14117);
/* harmony import */ var hooks_events_useUpcomingEventsData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61693);
/* harmony import */ var lib_auth_cookies_new__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89208);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var redux_store__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71640);
/* harmony import */ var utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51119);












var fetchUpcommingEventsData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, state, preferredCountry, bookedEvents, studentStage, upcomingEventsRes, ref1, res, bookedList, ref2, ref3, ref4, ref5, apiEventData, eventsSlug, slugObj, newSlugArray, res2, cmsEventsData, finalData, i, j, ref6, ref7, data, toShow;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    state = redux_store__WEBPACK_IMPORTED_MODULE_7__/* .store.getState */ .h.getState();
                    preferredCountry = "";
                    ;
                    if (!(0,lib_auth_cookies_new__WEBPACK_IMPORTED_MODULE_5__/* .getTokenCookie */ .r_)()) {
                        _ctx.next = 12;
                        break;
                    }
                    _ctx.next = 8;
                    return fetchPreferredCountry();
                case 8:
                    preferredCountry = _ctx.sent;
                    _ctx.next = 11;
                    return service_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("/api/scholarRoute?path=event/registered");
                case 11:
                    bookedEvents = _ctx.sent;
                case 12:
                    studentStage = state.spotCounselling.stage;
                    upcomingEventsRes = service_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("/api/scholarRoute?path=event/upcoming/30");
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z;
                    _ctx.next = 17;
                    return Promise.all([
                        upcomingEventsRes
                    ]);
                case 17:
                    _ctx.t1 = _ctx.sent;
                    ref1 = (0, _ctx.t0)(_ctx.t1, 1);
                    res = ref1[0];
                    bookedList = [];
                    if (bookedEvents === null || bookedEvents === void 0 ? void 0 : (ref = bookedEvents.data) === null || ref === void 0 ? void 0 : ref.success) {
                        ;
                        bookedList = bookedEvents === null || bookedEvents === void 0 ? void 0 : (ref2 = bookedEvents.data) === null || ref2 === void 0 ? void 0 : ref2.data;
                    }
                    if (!res.data.success) {
                        _ctx.next = 52;
                        break;
                    }
                    ;
                    if (!(res === null || res === void 0 ? void 0 : (ref3 = res.data) === null || ref3 === void 0 ? void 0 : ref3.data)) {
                        _ctx.next = 49;
                        break;
                    }
                    ;
                    apiEventData = [];
                    eventsSlug = [];
                    res === null || res === void 0 ? void 0 : (ref4 = res.data) === null || ref4 === void 0 ? void 0 : ref4.data.forEach(function(elem) {
                        if (elem.slots) {
                            elem.slots.forEach(function(data) {
                                if (data.slug) {
                                    eventsSlug.push(data.slug);
                                    apiEventData.push(data);
                                }
                            });
                        }
                    });
                    slugObj = {};
                    eventsSlug.forEach(function(elen) {
                        if (!slugObj[elen]) {
                            slugObj[elen] = 1;
                        }
                    });
                    newSlugArray = Object.keys(slugObj);
                    if (!(newSlugArray.length === 0)) {
                        _ctx.next = 34;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 34:
                    _ctx.next = 36;
                    return apollo_apollo__WEBPACK_IMPORTED_MODULE_1__/* .apoloClient.query */ .Bq.query({
                        query: apollo_queries_events__WEBPACK_IMPORTED_MODULE_2__/* .FETCH_EVENT_DATA */ .WO,
                        variables: {
                            slugArray: newSlugArray
                        }
                    });
                case 36:
                    res2 = _ctx.sent;
                    cmsEventsData = res2 === null || res2 === void 0 ? void 0 : (ref5 = res2.data) === null || ref5 === void 0 ? void 0 : ref5.events;
                    if (!(apiEventData && cmsEventsData)) {
                        _ctx.next = 46;
                        break;
                    }
                    finalData = [];
                    for(i = 0; i < apiEventData.length; i++){
                        for(j = 0; j < cmsEventsData.length; j++){
                            ;
                            if (((ref6 = cmsEventsData[j]) === null || ref6 === void 0 ? void 0 : ref6.slug) == ((ref7 = apiEventData[i]) === null || ref7 === void 0 ? void 0 : ref7.slug)) {
                                data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, cmsEventsData[j], apiEventData[i]);
                                finalData.push(data);
                            }
                        }
                    }
                    toShow = [];
                    if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6___default()(studentStage)) {
                        finalData.map(function(event) {
                            var check = (0,hooks_events_useUpcomingEventsData__WEBPACK_IMPORTED_MODULE_4__/* .checkEventsToShow */ .Xo)(event.batchId, event.event_tags_v2, studentStage, preferredCountry !== null && preferredCountry !== void 0 ? preferredCountry : "", bookedList);
                            if (check) {
                                toShow.push(event);
                            }
                        });
                    } else {
                        finalData.map(function(event) {
                            var check = (0,hooks_events_useUpcomingEventsData__WEBPACK_IMPORTED_MODULE_4__/* .checkTofuVisibility */ .lZ)(event.batchId, event.event_tags_v2, bookedList);
                            if (check) {
                                toShow.push(event);
                            }
                        });
                    }
                    return _ctx.abrupt("return", {
                        upcomingEvents: toShow,
                        bookedEvents: bookedList
                    });
                case 46:
                    return _ctx.abrupt("return", {
                        error: "Failed to get upcoming events",
                        data: {
                            bookedEvents: bookedList,
                            upcomingEvents: []
                        }
                    });
                case 47:
                    _ctx.next = 50;
                    break;
                case 49:
                    return _ctx.abrupt("return", {
                        error: "failed",
                        data: null
                    });
                case 50:
                    _ctx.next = 53;
                    break;
                case 52:
                    return _ctx.abrupt("return", {
                        bookedEvents: bookedList,
                        upcomingEvents: []
                    });
                case 53:
                    _ctx.next = 58;
                    break;
                case 55:
                    _ctx.prev = 55;
                    _ctx.t2 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        bookedEvents: [],
                        upcomingEvents: []
                    });
                case 58:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                55
            ]
        ]);
    }));
    return function fetchUpcommingEventsData() {
        return _ref.apply(this, arguments);
    };
}();
var getExpertData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("/api/scholarRoute?path=v2/workshop/MASTER_CLASS/0/12");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function getExpertData() {
        return _ref.apply(this, arguments);
    };
}();
var getProfileLayout = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("/api/scholarRoute?path=student/profile-layout");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function getProfileLayout() {
        return _ref.apply(this, arguments);
    };
}();
var saveData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values) {
        var ref, res, ref1;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    ;
                    _ctx.prev = 2;
                    _ctx.next = 5;
                    return service_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post("/api/scholarRoute?path=lead/country-form-spot", values);
                case 5:
                    res = _ctx.sent;
                    _ctx.next = 11;
                    break;
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](2);
                    throw new Error("Something went wrong. Please try after sometime");
                case 11:
                    if (!(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                        _ctx.next = 15;
                        break;
                    }
                    return _ctx.abrupt("return", true);
                case 15:
                    ;
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.message);
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                8
            ]
        ]);
    }));
    return function saveData(values) {
        return _ref.apply(this, arguments);
    };
}();
var getAbVariant = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(experiment) {
        var userId, payload, res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    userId = (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_8__/* .getCookie */ .ej)(null, "user_id");
                    payload = {
                        guid: userId === null || userId === void 0 ? void 0 : userId.toString(),
                        preUserId: userId
                    };
                    _ctx.next = 5;
                    return service_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post("/api/abExperiments?path=getAb/".concat(experiment), payload);
                case 5:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : res.data);
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                9
            ]
        ]);
    }));
    return function getAbVariant(experiment) {
        return _ref.apply(this, arguments);
    };
}();
var checkEligibilty = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("/api/scholarRoute?path=student/eligibility");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 8:
                    return _ctx.abrupt("return", res.data.message);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", _ctx.t0.message);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function checkEligibilty() {
        return _ref.apply(this, arguments);
    };
}();
var checkReQualificationEligibility = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("/api/scholarRoute?path=student/eligibility/requalification");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 8:
                    return _ctx.abrupt("return", res.data.message);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", _ctx.t0.message);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function checkReQualificationEligibility() {
        return _ref.apply(this, arguments);
    };
}();
var getStage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("/api/scholarRoute?path=student/stage");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 8:
                    return _ctx.abrupt("return", res.data.message);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", _ctx.t0.message || "Something went wrong");
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function getStage() {
        return _ref.apply(this, arguments);
    };
}();
var getAppNudgeEligibility = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("/api/scholarRoute?path=student/eligibility/app/nudge");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 8:
                    return _ctx.abrupt("return", res.data.message);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", _ctx.t0.message || "Something went wrong");
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function getAppNudgeEligibility() {
        return _ref.apply(this, arguments);
    };
}();
var getAppNudgeData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return service_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("".concat("https://cms.leapscholar.com", "/idle-user-app-nudges"));
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", (ref = res.data) === null || ref === void 0 ? void 0 : ref[0]);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {});
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function getAppNudgeData() {
        return _ref.apply(this, arguments);
    };
}();
var getStageCustom = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("/api/scholarRoute?path=student/stage");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 8:
                    return _ctx.abrupt("return", "LS_LEAD_CAPTURED");
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", "LS_LEAD_CAPTURED");
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function getStageCustom() {
        return _ref.apply(this, arguments);
    };
}();
var activateLead = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(lead) {
        var ref, res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return service_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("/api/scholarRoute?path=user/reviveUser/".concat(lead));
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", false);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function activateLead(lead) {
        return _ref.apply(this, arguments);
    };
}();
var reviveUserEligibility = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(lead) {
        var ref, res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return service_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("/api/scholarRoute?path=user/reviveUser/eligibility/".concat(lead));
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.data);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", false);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function reviveUserEligibility(lead) {
        return _ref.apply(this, arguments);
    };
}();
var getGoalPlanData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("/api/scholarRoute?path=lead/goalPlan/pre-users");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 8:
                    return _ctx.abrupt("return", res.data.message);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", _ctx.t0.message || "Something went wrong");
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function getGoalPlanData() {
        return _ref.apply(this, arguments);
    };
}();
var fetchSpotCounsellingSlot = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res, ref;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("/api/scholarRoute?path=counselling/slots/live/30");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    ;
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.message);
                case 10:
                    _ctx.next = 16;
                    break;
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }));
    return function fetchSpotCounsellingSlot() {
        return _ref.apply(this, arguments);
    };
}();
var confirmSpotCounsellingSlot = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(payload) {
        var ref, ref1, ref2, batchId, data, res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    batchId = payload.batchId;
                    data = {
                        utm_campaign: payload.utmData.utm_campaign || "",
                        utm_source: payload.utmData.utm_source || "",
                        utm_term: payload.utmData.utm_term || "",
                        utm_medium: payload.utmData.utm_medium || "",
                        gclid: ((ref = payload.utmData) === null || ref === void 0 ? void 0 : ref.gclid) || "",
                        adName: ((ref1 = payload.utmData) === null || ref1 === void 0 ? void 0 : ref1.adName) || "",
                        campaign_type: payload.utmData.campaign_type || "",
                        form_id: ((ref2 = payload.utmData.formId) === null || ref2 === void 0 ? void 0 : ref2.length) ? payload.utmData.formId : null,
                        ad_id: payload.utmData.ad_id || "",
                        referer: payload.utmData.referer || ""
                    };
                    _ctx.prev = 3;
                    _ctx.next = 6;
                    return service_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post("/api/scholarRoute?path=counselling/register/".concat(batchId), data);
                case 6:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 11;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 11:
                    return _ctx.abrupt("return", res.data.message);
                case 12:
                    _ctx.next = 18;
                    break;
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](3);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return", _ctx.t0.message);
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                3,
                14
            ]
        ]);
    }));
    return function confirmSpotCounsellingSlot(payload) {
        return _ref.apply(this, arguments);
    };
}();
var confirmRescheduleSlot = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(payload) {
        var ref, batchId, utmData, meetingId, data, res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    batchId = payload.batchId, utmData = payload.utmData, meetingId = payload.meetingId;
                    data = {
                        utm_campaign: utmData.utm_campaign || "",
                        utm_source: utmData.utm_source || "",
                        utm_term: utmData.utm_term || "",
                        utm_medium: utmData.utm_medium || "",
                        gclid: (utmData === null || utmData === void 0 ? void 0 : utmData.gclid) || "",
                        adName: (utmData === null || utmData === void 0 ? void 0 : utmData.adName) || "",
                        campaign_type: utmData.campaign_type || "",
                        form_id: ((ref = utmData.formId) === null || ref === void 0 ? void 0 : ref.length) ? utmData.formId : null,
                        ad_id: utmData.ad_id || ""
                    };
                    _ctx.prev = 3;
                    _ctx.next = 6;
                    return service_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post("/api/scholarRoute?path=counselling/register/".concat(batchId, "&reschedule=true&meetingId=").concat(meetingId), data);
                case 6:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 11;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 11:
                    return _ctx.abrupt("return", res.data.message);
                case 12:
                    _ctx.next = 18;
                    break;
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](3);
                    console.log(_ctx.t0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                3,
                14
            ]
        ]);
    }));
    return function confirmRescheduleSlot(payload) {
        return _ref.apply(this, arguments);
    };
}();
var fetchSpotProfile = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, res, ref1;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return service_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("/api/scholarRoute?path=student/spot-profile");
                case 4:
                    res = _ctx.sent;
                    if (!(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 9:
                    ;
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.message);
                case 11:
                    _ctx.next = 17;
                    break;
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }));
    return function fetchSpotProfile() {
        return _ref.apply(this, arguments);
    };
}();
var fetchPreferredCountry = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res, ref;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("/api/scholarRoute?path=student/preferred-country");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 9;
                        break;
                    }
                    ;
                    return _ctx.abrupt("return", (ref = res.data) === null || ref === void 0 ? void 0 : ref.data);
                case 9:
                    return _ctx.abrupt("return", null);
                case 10:
                    _ctx.next = 16;
                    break;
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return", null);
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }));
    return function fetchPreferredCountry() {
        return _ref.apply(this, arguments);
    };
}();
var submitSpotProfile = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values) {
        var ref, res, ref1;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return service_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post("/api/scholarRoute?path=student/spot-profile", values);
                case 4:
                    res = _ctx.sent;
                    if (!(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", res);
                case 9:
                    ;
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.message);
                case 11:
                    _ctx.next = 16;
                    break;
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please try after sometime");
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }));
    return function submitSpotProfile(values) {
        return _ref.apply(this, arguments);
    };
}();
var spotCounsellingApi = {
    getExpertData: getExpertData,
    checkEligibilty: checkEligibilty,
    saveData: saveData,
    getStage: getStage,
    fetchSpotCounsellingSlot: fetchSpotCounsellingSlot,
    confirmSpotCounsellingSlot: confirmSpotCounsellingSlot,
    confirmRescheduleSlot: confirmRescheduleSlot,
    fetchSpotProfile: fetchSpotProfile,
    fetchPreferredCountry: fetchPreferredCountry,
    submitSpotProfile: submitSpotProfile,
    getGoalPlanData: getGoalPlanData,
    fetchUpcommingEventsData: fetchUpcommingEventsData,
    getProfileLayout: getProfileLayout,
    getStageCustom: getStageCustom,
    checkReQualificationEligibility: checkReQualificationEligibility,
    activateLead: activateLead,
    reviveUserEligibility: reviveUserEligibility,
    getAppNudgeEligibility: getAppNudgeEligibility,
    getAppNudgeData: getAppNudgeData,
    getAbVariant: getAbVariant
};


/***/ }),

/***/ 78779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sw": function() { return /* binding */ fetchSlot; },
/* harmony export */   "gt": function() { return /* binding */ saveUserData; },
/* harmony export */   "is": function() { return /* binding */ getUserData; },
/* harmony export */   "j6": function() { return /* binding */ IeltsToCounsellingEligibility; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var service_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14117);
/* harmony import */ var components_LSRevamp_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69117);
/* harmony import */ var page_routes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12615);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(72132);
/* harmony import */ var scripts_segment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83697);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62408);










var IeltsToCounsellingEligibility = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values) {
        var formId, ref, res, ref1, ref2, ref3, userData, ref4, ref5, ref6, ref7, ref8, ref9, ieltsStatus, phone, email, preferredCountry, passportStatus, slotType, trackPayload, _args = arguments;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    formId = _args.length > 1 && _args[1] !== void 0 ? _args[1] : "I2C_form";
                    (0,scripts_segment__WEBPACK_IMPORTED_MODULE_4__.trackForm)("Form Submitted", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, values), {
                        formId: formId
                    }));
                    _ctx.prev = 2;
                    ;
                    _ctx.next = 6;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=student/eligibility");
                case 6:
                    res = _ctx.sent;
                    if (!(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                        _ctx.next = 29;
                        break;
                    }
                    ;
                    _ctx.next = 11;
                    return getUserData();
                case 11:
                    userData = _ctx.sent;
                    if (!(userData === null || userData === void 0 ? void 0 : (ref1 = userData.data) === null || ref1 === void 0 ? void 0 : ref1.success)) {
                        _ctx.next = 25;
                        break;
                    }
                    ;
                    ref9 = (userData === null || userData === void 0 ? void 0 : (ref4 = userData.data) === null || ref4 === void 0 ? void 0 : ref4.data) || {}, ieltsStatus = ref9.ieltsStatus, phone = ref9.phone, email = ref9.email, preferredCountry = ref9.preferredCountry, passportStatus = ref9.passportStatus;
                    slotType = res === null || res === void 0 ? void 0 : (ref5 = res.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.data) === null || ref6 === void 0 ? void 0 : ref6.slotType;
                    trackPayload = {
                        eventCategory: res.data.data.reason === "SPOT_APPROVED" ? "Spot_Counselling" : "regular_counselling",
                        productCategory: (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .getProductCategory */ .dB)(slotType) || "",
                        slotAvailable: "",
                        qualificationType: [
                            "NO_PROBLEM",
                            "SPOT_APPROVED"
                        ].includes(res.data.data.reason) ? "Qualified" : "Not qualified",
                        ieltsStatus: ieltsStatus || "NA",
                        formId: formId,
                        email: email || "NA",
                        phone: phone || "NA"
                    };
                    _ctx.next = 19;
                    return (0,scripts_segment__WEBPACK_IMPORTED_MODULE_4__.trackProductFormAsync)("Qualified for Product", trackPayload);
                case 19:
                    if (!((res === null || res === void 0 ? void 0 : (ref7 = res.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.data) === null || ref8 === void 0 ? void 0 : ref8.reason) === "SPOT_APPROVED" && slotType !== 3)) {
                        _ctx.next = 23;
                        break;
                    }
                    if (passportStatus === "PENDING" && preferredCountry === "USA") {
                        _ctx.next = 23;
                        break;
                    }
                    _ctx.next = 23;
                    return (0,scripts_segment__WEBPACK_IMPORTED_MODULE_4__.trackProductFormAsync)("Qualified for Product ".concat(preferredCountry), trackPayload);
                case 23:
                    _ctx.next = 26;
                    break;
                case 25:
                    {
                        console.error("Something went wrong");
                    }
                case 26:
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : (ref2 = res.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.slotType);
                case 29:
                    throw new Error("Something went wrong");
                case 30:
                    _ctx.next = 35;
                    break;
                case 32:
                    _ctx.prev = 32;
                    _ctx.t0 = _ctx["catch"](2);
                    console.error(_ctx.t0);
                case 35:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                32
            ]
        ]);
    }));
    return function IeltsToCounsellingEligibility(values) {
        return _ref.apply(this, arguments);
    };
}();
var fetchSlot = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(setSlotType, setIsLoading, router, timer, getSchedule) {
        var isIeltsApp, ref, res, ref1, ref2, ref3, userData, ref4, ref5, ieltsStatus, phone, email, trackPayload;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    isIeltsApp = (0,components_LSRevamp_utils__WEBPACK_IMPORTED_MODULE_2__/* .checkIfIeltsApp */ .e0)();
                    _ctx.prev = 1;
                    ;
                    _ctx.next = 5;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=student/eligibility");
                case 5:
                    res = _ctx.sent;
                    if (!(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                        _ctx.next = 17;
                        break;
                    }
                    ;
                    getSchedule();
                    _ctx.next = 11;
                    return getUserData();
                case 11:
                    userData = _ctx.sent;
                    if (userData === null || userData === void 0 ? void 0 : (ref1 = userData.data) === null || ref1 === void 0 ? void 0 : ref1.success) {
                        ;
                        ref5 = userData === null || userData === void 0 ? void 0 : (ref4 = userData.data) === null || ref4 === void 0 ? void 0 : ref4.data, ieltsStatus = ref5.ieltsStatus, phone = ref5.phone, email = ref5.email;
                        trackPayload = {
                            eventCategory: res.data.data.reason === "SPOT_APPROVED" ? "Spot_Counselling" : "regular_counselling",
                            productCategory: (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .getProductCategory */ .dB)(res.data.data.slotType) || "",
                            slotAvailable: "",
                            qualificationType: [
                                "NO_PROBLEM",
                                "SPOT_APPROVED"
                            ].includes(res.data.data.reason) ? "Qualified" : "Not qualified",
                            ieltsStatus: ieltsStatus || "NA",
                            formId: isIeltsApp ? "I2C_app" : "I2C_form",
                            email: email || "NA",
                            phone: phone || "NA"
                        };
                        (0,scripts_segment__WEBPACK_IMPORTED_MODULE_4__.trackProduct)("Qualified for Product", trackPayload);
                    }
                    setSlotType(res === null || res === void 0 ? void 0 : (ref2 = res.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.slotType);
                    setIsLoading(false);
                    _ctx.next = 18;
                    break;
                case 17:
                    {
                        setIsLoading(false);
                        react_toastify__WEBPACK_IMPORTED_MODULE_9__/* .toast.error */ .Am.error("Something went wrong");
                        timer.current = setTimeout(function() {
                            router.push({
                                pathname: page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.PROFILE */ .CZ.PROFILE
                            });
                        }, 2000);
                    }
                case 18:
                    _ctx.next = 25;
                    break;
                case 20:
                    _ctx.prev = 20;
                    _ctx.t0 = _ctx["catch"](1);
                    setIsLoading(false);
                    react_toastify__WEBPACK_IMPORTED_MODULE_9__/* .toast.error */ .Am.error("Something went wrong");
                    timer.current = setTimeout(function() {
                        router.push({
                            pathname: page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.PROFILE */ .CZ.PROFILE
                        });
                    }, 2000);
                case 25:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                20
            ]
        ]);
    }));
    return function fetchSlot(setSlotType, setIsLoading, router, timer, getSchedule) {
        return _ref.apply(this, arguments);
    };
}();
var getUserData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var userdata;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=student/counselling-details");
                case 3:
                    userdata = _ctx.sent;
                    return _ctx.abrupt("return", userdata);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function getUserData() {
        return _ref.apply(this, arguments);
    };
}();
var saveUserData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(payload) {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/scholarRoute?path=student/spot-counseling/apply", payload);
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function saveUserData(payload) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 29999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ tofuObordingActions; }
/* harmony export */ });
var fetchSpotCounsellingFromData = function() {
    return {
        type: "FETCH_SPOT_FORM_DATA"
    };
};
var fetchSpotCounsellingFromDataSuccess = function(payload) {
    return {
        type: "FETCH_SPOT_FORM_DATA_SUCCESS",
        payload: payload
    };
};
var fetchSpotCounsellingFromDataFail = function(message) {
    return {
        type: "FETCH_SPOT_FORM_DATA_FAIL",
        payload: message
    };
};
var tofuObordingActions = {
    fetchSpotCounsellingFromData: fetchSpotCounsellingFromData,
    fetchSpotCounsellingFromDataSuccess: fetchSpotCounsellingFromDataSuccess,
    fetchSpotCounsellingFromDataFail: fetchSpotCounsellingFromDataFail
};


/***/ }),

/***/ 64880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ tofuOnbordingApis; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var service_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14117);



var fetchSpotCounsellingFromData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=student/spot-counseling");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 8:
                    throw new Error(res.data.message);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", _ctx.t0.message || "Something went wrong");
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchSpotCounsellingFromData() {
        return _ref.apply(this, arguments);
    };
}();
var tofuOnbordingApis = {
    fetchSpotCounsellingFromData: fetchSpotCounsellingFromData
};


/***/ }),

/***/ 62408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BX": function() { return /* binding */ nameExtraSpacetriming; },
/* harmony export */   "D$": function() { return /* binding */ setLocalStorageItem; },
/* harmony export */   "Eg": function() { return /* binding */ getBanner; },
/* harmony export */   "II": function() { return /* binding */ semFormBackNextDecision; },
/* harmony export */   "KB": function() { return /* binding */ getDependentQuestionFieldName; },
/* harmony export */   "Pl": function() { return /* binding */ validateHowToHelpVal; },
/* harmony export */   "XT": function() { return /* binding */ formProgressBarUseStyles; },
/* harmony export */   "Yc": function() { return /* binding */ returnCountry; },
/* harmony export */   "dB": function() { return /* binding */ getProductCategory; },
/* harmony export */   "dW": function() { return /* binding */ getLeadCohort; },
/* harmony export */   "e2": function() { return /* binding */ indexCal; },
/* harmony export */   "hi": function() { return /* binding */ autonextDecision; },
/* harmony export */   "i_": function() { return /* binding */ getfirstQuestionToDisplay; },
/* harmony export */   "kK": function() { return /* binding */ getParsedJson; },
/* harmony export */   "le": function() { return /* binding */ getLocalStorageItem; },
/* harmony export */   "nK": function() { return /* binding */ isObjectEmpty; },
/* harmony export */   "nZ": function() { return /* binding */ V8LeadCaptureStepsPage; },
/* harmony export */   "qg": function() { return /* binding */ nameValidator; },
/* harmony export */   "qm": function() { return /* binding */ forceAutonextDecision; },
/* harmony export */   "sV": function() { return /* binding */ geturlToRedirect; },
/* harmony export */   "tZ": function() { return /* binding */ LeadCaptureStepsPage; },
/* harmony export */   "uR": function() { return /* binding */ validateHowToHelpValSem; }
/* harmony export */ });
/* unused harmony exports SpotLeadCaptureStepsPage, V8IntakeMapper, viewRewardClick, autoNextLogicSpotCouncellingForm, spotProfileDataMapper, downloadAppToShowStages */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29815);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _material_ui_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11719);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72132);
/* harmony import */ var scripts_segment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83697);
/* harmony import */ var service_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14117);
/* harmony import */ var utils_events_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42477);








var formProgressBarUseStyles = (0,_material_ui_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    root: {
        width: "100%",
        "& .MuiLinearProgress-colorPrimary": {
            backgroundColor: "transparent",
            height: "12px"
        },
        "& .MuiLinearProgress-barColorPrimary": {
            backgroundColor: "#7FBF7D",
            height: "12px"
        }
    },
    rootNew: {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "& .MuiLinearProgress-colorPrimary": {
            backgroundColor: "#E5E7EB",
            borderRadius: "6px",
            height: "8px",
            width: "100%"
        },
        "& .MuiLinearProgress-barColorPrimary": {
            backgroundColor: "#443EFF",
            borderRadius: "6px",
            height: "8px"
        }
    }
});
var getProductCategory = function(slotType) {
    if (slotType) {
        if (slotType === 1) {
            return "Slot 1";
        }
        if (slotType === 2) {
            return "Slot 2";
        }
        if (slotType === 7) {
            return "Slot 7";
        }
        if (slotType === 29) {
            return "Slot 29";
        }
        if (slotType === 31) {
            return "Slot 31";
        }
        return "Slot 3";
    } else {
        return "regular_counselling";
    }
};
var returnCountry = function(country) {
    switch(country){
        case "UK":
            return "UK";
        case "CANADA":
            return "Canada";
        case "USA":
            return "USA";
        case "AUSTRALIA":
            return "Australia";
        case "IRELAND":
            return "Ireland";
        default:
            return "Other";
    }
};
var SpotLeadCaptureStepsPage = {
    1: "Prog_Form_P1",
    2: "Prog_Form_P2",
    3: "Prog_Form_P3",
    4: "Prog_Form_P4",
    5: "Prog_Form_P5",
    6: "SEM v5 - CTA Page"
};
var LeadCaptureStepsPage = {
    preferredRequirement: "Prog_Form_P1",
    preferredProgram: "Prog_Form_P2",
    preferredIntake: "Prog_Form_P3",
    ieltsStatus: "Prog_Form_P4",
    highestLevelEducation: "Prog_Form_P5",
    highestEducationPassoutYear: "Prog_Form_P6",
    grades: "Prog_Form_P7",
    name: "SEM v5 - CTA Page",
    admitStatus: "Prog_Form_P9",
    ielts_toefl_score: "Prog_Form_P10",
    howLeapHelp: "Prog_Form_P11",
    ieltsBookConf: "Prog_Form_P12"
};
var V8LeadCaptureStepsPage = {
    home: "SEM v8 - Home Screen",
    help: "SEM v8 - First Question Screen",
    preferredIntake: "SEM v8 - Second Question",
    ieltsStatus: "SEM v8 - Third Question",
    highestLevelEducation: "SEM v8 - Fourth Question",
    highestEducationPassoutYear: "SEM v8 - Fifth Question",
    grades: "SEM v8 - Sixth Question",
    preferredProgram: "SEM v8 - Seventh Question",
    admitStatus: "SEM v8 - Eigth Question",
    ielts_toefl_score: "SEM v8 - Ninth Question",
    howLeapHelp: "SEM v8 - Tenth Question",
    ieltsBookConf: "SEM v8 - Elevnth Question",
    name: "SEM v8 - CTA Page"
};
var V8IntakeMapper = {
    JAN_2023: "January 2023",
    SEP_2023: "September 2023"
};
var geturlToRedirect = function() {
    return "https://leapscholar.com";
};
//ielts reward banner tracking
var viewRewardClick = function(ieltsUserCategory) {
    trackIeltsClick(ieltsPageName.COUNSELLING_PAGE, {
        pageName: "Counselling Page",
        widgetName: "Congratulations Modal",
        widgetFormat: "Card",
        contentName: "See all Rewards",
        eventCategory: ieltsUserCategory
    });
};
//autoNextLogicSpotCouncellingForm
var autoNextLogicSpotCouncellingForm = function(currentFormStep, setCurrentFormStep, changedValues) {
    if (currentFormStep === 1 && (changedValues === null || changedValues === void 0 ? void 0 : changedValues.preferredCountry)) {
        setCurrentFormStep(currentFormStep + 1);
    }
    if (currentFormStep === 2 && (changedValues === null || changedValues === void 0 ? void 0 : changedValues.preferredIntake) && (changedValues === null || changedValues === void 0 ? void 0 : changedValues.preferredProgram)) {
        setCurrentFormStep(currentFormStep + 1);
    }
    if (currentFormStep === 3 && (changedValues === null || changedValues === void 0 ? void 0 : changedValues.highestLevelEducation) && (changedValues === null || changedValues === void 0 ? void 0 : changedValues.highestEducationPassoutYear)) {
        setCurrentFormStep(currentFormStep + 1);
    }
};
//name validator
var nameValidator = function(name) {
    if (!name.trim()) {
        return false;
    }
    return /^[A-Za-z\s]+$/.test(name);
};
//extra space trimming from name
var nameExtraSpacetriming = function(name) {
    var ref;
    //replacing extra space between name if any
    return (ref = name === null || name === void 0 ? void 0 : name.replace(/\s+/g, " ")) === null || ref === void 0 ? void 0 : ref.trim();
};
//Spot Profile data mapper
var spotProfileDataMapper = {
    TENTH: "10th Standard",
    TWELFTH: "12th Standard",
    BACHELORS: "Bachelor’s Degree",
    MASTERS: "Master’s Degree",
    EXAM_BOOKED: "Scheduled",
    ALREADY_GIVEN: "Already given",
    NOT_DECIDED: "Not decided",
    PLANING_TO_BOOK: "Planning to Give"
};
var validateHowToHelpVal = function(v, limit) {
    if (v) {
        if (v.length > limit) {
            v.splice(-1, 1);
            react_toastify__WEBPACK_IMPORTED_MODULE_5__/* .toast.warn */ .Am.warn("Maximum ".concat(limit, " selections allowed"));
        } else {}
    }
    if (!(v === null || v === void 0 ? void 0 : v.length)) return "Please select atleast one option";
};
var validateHowToHelpValSem = function(v, limit) {
    if (v) {
        if (v.length > limit) {
            v.splice(-1, 1);
            return "Maximum ".concat(limit, " selections allowed");
        } else {}
    }
    if (!(v === null || v === void 0 ? void 0 : v.length)) return "Please select atleast one option";
};
var isObjectEmpty = function(obj) {
    try {
        var ref;
        return ((ref = Object.keys(obj)) === null || ref === void 0 ? void 0 : ref.length) === 0;
    } catch (err) {
        console.error(err);
        return true;
    }
};
var getDependentQuestionFieldName = function(formJson, questionId) {
    for(var i = 0; i < (formJson === null || formJson === void 0 ? void 0 : formJson.fields.length); i++){
        if ((formJson === null || formJson === void 0 ? void 0 : formJson.fields[i].question_id) === questionId) {
            return formJson === null || formJson === void 0 ? void 0 : formJson.fields[i].semFieldValue;
        }
    }
    return "df";
};
var indexCal = function(formJson, currentFormStep) {
    var ref;
    var modifiedFormStepQuestionDistribution = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(formJson === null || formJson === void 0 ? void 0 : (ref = formJson.page_distribution) === null || ref === void 0 ? void 0 : ref.slice(0, currentFormStep - 1));
    var sumTillCurrentIndex = modifiedFormStepQuestionDistribution === null || modifiedFormStepQuestionDistribution === void 0 ? void 0 : modifiedFormStepQuestionDistribution.reduce(function(partialSum, a) {
        return partialSum + a;
    }, 0);
    var startIndex = currentFormStep > 1 ? sumTillCurrentIndex : 0;
    var endIndex = startIndex + (formJson === null || formJson === void 0 ? void 0 : formJson.page_distribution[currentFormStep - 1]);
    return [
        startIndex,
        endIndex
    ];
};
var getfirstQuestionToDisplay = function(json) {
    var ref;
    var fieldObject = json === null || json === void 0 ? void 0 : (ref = json.fields) === null || ref === void 0 ? void 0 : ref.find(function(field) {
        return (field === null || field === void 0 ? void 0 : field.question_id) === 1;
    });
    return fieldObject === null || fieldObject === void 0 ? void 0 : fieldObject.semFieldValue;
};
var autonextDecision = function(dublicateFormValues, formJson, currentFormStep, setCurrentFormStep, isClickingBack) {
    var isNormalAutoNextRequired = true;
    var startInd = indexCal(formJson, currentFormStep)[0];
    var endIndex = indexCal(formJson, currentFormStep)[1];
    for(var i = startInd; i < endIndex; i++){
        var ref, ref1;
        if (!(((ref = formJson === null || formJson === void 0 ? void 0 : formJson.fields[i]) === null || ref === void 0 ? void 0 : ref.type) === "numberInput" || ((ref1 = formJson === null || formJson === void 0 ? void 0 : formJson.fields[i]) === null || ref1 === void 0 ? void 0 : ref1.type) == "textInput")) {
            var ref2;
            if (dublicateFormValues[(ref2 = formJson === null || formJson === void 0 ? void 0 : formJson.fields[i]) === null || ref2 === void 0 ? void 0 : ref2.semFieldValue]) {
                continue;
            } else {
                isNormalAutoNextRequired = false;
            }
        } else {
            isNormalAutoNextRequired = false;
            return;
        }
    }
    if (isNormalAutoNextRequired && !isClickingBack) {
        setCurrentFormStep(currentFormStep + 1);
    }
};
var forceAutonextDecision = function(formJson, currentFormStep, formValues, setCurrentFormStep, isClickingBack) {
    var isForceAutoNextRequired = false;
    var startInd = indexCal(formJson, currentFormStep)[0];
    var endIndex = indexCal(formJson, currentFormStep)[1];
    for(var i = startInd; i < endIndex; i++){
        var ref;
        if ((ref = formJson === null || formJson === void 0 ? void 0 : formJson.fields[i]) === null || ref === void 0 ? void 0 : ref.default_visibility) {
            return;
        } else {
            var ref1, ref2;
            var selectedField = (ref1 = formJson === null || formJson === void 0 ? void 0 : formJson.fields[i]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.visibility_dependency) === null || ref2 === void 0 ? void 0 : ref2.dependencies;
            var isThisFieldVisible = true;
            for(var j = 0; j < (selectedField === null || selectedField === void 0 ? void 0 : selectedField.length); j++){
                var ref3, ref4, ref5, ref6;
                var questionId = (ref3 = selectedField[j]) === null || ref3 === void 0 ? void 0 : ref3.question_id;
                if (((ref4 = selectedField[j]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.value) === null || ref5 === void 0 ? void 0 : ref5.includes(formValues[getDependentQuestionFieldName(formJson, questionId)])) || ((ref6 = selectedField[j]) === null || ref6 === void 0 ? void 0 : ref6.value.length) == 0) {
                    continue;
                } else {
                    isThisFieldVisible = false;
                }
            }
            if (!isThisFieldVisible) {
                isForceAutoNextRequired = true;
            } else {
                return;
            }
        }
    }
    if (isForceAutoNextRequired && !isClickingBack) {
        setCurrentFormStep(currentFormStep + 1);
    } else if (isForceAutoNextRequired && isClickingBack) {
        setCurrentFormStep(function(prev) {
            return prev - 1;
        });
    }
};
var semFormBackNextDecision = function(formJson, values, currentQuestion, direction) {
    var _loop = function(i) {
        var ref;
        if (currentQuestion === ((ref = formJson === null || formJson === void 0 ? void 0 : formJson.fields[i]) === null || ref === void 0 ? void 0 : ref.semFieldValue)) {
            var ref1, ref2;
            if ((ref1 = formJson === null || formJson === void 0 ? void 0 : formJson.fields[i]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.visibility_dependency) === null || ref2 === void 0 ? void 0 : ref2.hasDependentQuestion) {
                if (direction === "next") {
                    var _loop = function(j) {
                        var ref, ref1, ref2, ref3;
                        var element = (ref = formJson === null || formJson === void 0 ? void 0 : formJson.fields[i]) === null || ref === void 0 ? void 0 : (ref1 = ref.visibility_dependency) === null || ref1 === void 0 ? void 0 : ref1.nextQuestionRequirment[j];
                        var hasAllValueIncluded = true;
                        element === null || element === void 0 ? void 0 : (ref2 = element.prevQuestion) === null || ref2 === void 0 ? void 0 : ref2.forEach(function(ques) {
                            if (!(element === null || element === void 0 ? void 0 : element.value.includes(values[ques]))) {
                                hasAllValueIncluded = false;
                            }
                        });
                        if (hasAllValueIncluded || (element === null || element === void 0 ? void 0 : (ref3 = element.value) === null || ref3 === void 0 ? void 0 : ref3.length) === 0) {
                            nextQuestionHolder = element === null || element === void 0 ? void 0 : element.nextQuestion;
                            return "break";
                        }
                    };
                    var ref3, ref4, ref5;
                    for(var j = 0; j < ((ref3 = formJson === null || formJson === void 0 ? void 0 : formJson.fields[i]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.visibility_dependency) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.nextQuestionRequirment) === null || ref5 === void 0 ? void 0 : ref5.length); j++){
                        var _ret = _loop(j);
                        if (_ret === "break") break;
                    }
                } else {
                    var _loop1 = function(j1) {
                        var ref, ref1, ref2, ref3;
                        var element = (ref = formJson === null || formJson === void 0 ? void 0 : formJson.fields[i]) === null || ref === void 0 ? void 0 : (ref1 = ref.visibility_dependency) === null || ref1 === void 0 ? void 0 : ref1.prevQuestionRequirment[j1];
                        var hasAllValueIncluded = true;
                        element === null || element === void 0 ? void 0 : (ref2 = element.question) === null || ref2 === void 0 ? void 0 : ref2.forEach(function(ques) {
                            var ref;
                            if (!(element === null || element === void 0 ? void 0 : (ref = element.value) === null || ref === void 0 ? void 0 : ref.includes(values[ques]))) {
                                hasAllValueIncluded = false;
                            }
                        });
                        if ((element === null || element === void 0 ? void 0 : element.question) === "help") {
                            nextQuestionHolder = "help";
                        } else if (hasAllValueIncluded || (element === null || element === void 0 ? void 0 : (ref3 = element.value) === null || ref3 === void 0 ? void 0 : ref3.length) === 0) {
                            nextQuestionHolder = element === null || element === void 0 ? void 0 : element.prevQuestion;
                            return "break";
                        }
                    };
                    var ref6, ref7, ref8;
                    for(var j1 = 0; j1 < ((ref6 = formJson === null || formJson === void 0 ? void 0 : formJson.fields[i]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.visibility_dependency) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.prevQuestionRequirment) === null || ref8 === void 0 ? void 0 : ref8.length); j1++){
                        var _ret1 = _loop1(j1);
                        if (_ret1 === "break") break;
                    }
                }
            }
        }
    };
    var ref;
    var nextQuestionHolder = "";
    for(var i = 0; i < (formJson === null || formJson === void 0 ? void 0 : (ref = formJson.fields) === null || ref === void 0 ? void 0 : ref.length); i++)_loop(i);
    return nextQuestionHolder;
};
var getLeadCohort = function(leadDetails, slotId) {
    // for cohort 4
    if ((slotId == 1 || slotId == 2) && ((leadDetails === null || leadDetails === void 0 ? void 0 : leadDetails.ieltsStatus) === "NOT_DECIDED" || (leadDetails === null || leadDetails === void 0 ? void 0 : leadDetails.ieltsStatus) === "PLANING_TO_BOOK") && ((leadDetails === null || leadDetails === void 0 ? void 0 : leadDetails.passportStatus) === "PENDING" || (leadDetails === null || leadDetails === void 0 ? void 0 : leadDetails.workingDegreeStatus) == false || (leadDetails === null || leadDetails === void 0 ? void 0 : leadDetails.workingMarksheetStatus) == false)) {
        return "COHORT_4";
    }
};
var getParsedJson = function(data) {
    try {
        return JSON.parse(data);
    } catch (err) {
        return {};
    }
};
var getBanner = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(howLeapHelp) {
        var ref, response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return service_api__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("https://cms.leapscholar.com" + "/webflow-form-submits?howLeapHelp=".concat(howLeapHelp));
                case 4:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref[0]);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", null);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function getBanner(howLeapHelp) {
        return _ref.apply(this, arguments);
    };
}();
var getLocalStorageItem = function(key) {
    try {
        return localStorage.getItem(key);
    } catch (err) {
        console.error(err);
        return null;
    }
};
var setLocalStorageItem = function(key, value) {
    try {
        localStorage.setItem(key, value);
    } catch (err) {
        console.error(err);
    }
};
var downloadAppToShowStages = (/* unused pure expression or super */ null && ([
    "LS_WEBINAR_SCHEDULED",
    "LS_WEBINAR_ATTENDED", 
]));


/***/ }),

/***/ 76270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ setIsGetSupportModalOpen; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27272);

var getSupportSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "getSupport",
    initialState: {
        isGetSupportModalOpen: false
    },
    reducers: {
        setIsGetSupportModalOpen: function(state, action) {
            state.isGetSupportModalOpen = action.payload;
        }
    }
});
var setIsGetSupportModalOpen = getSupportSlice.actions.setIsGetSupportModalOpen;
/* harmony default export */ __webpack_exports__["Z"] = (getSupportSlice.reducer);


/***/ }),

/***/ 61562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./DataMapper/Profile/StageMapper.tsx
var StageMapper = __webpack_require__(91738);
// EXTERNAL MODULE: ./components/Profile/ReferAndEarn/redux/ReferAndEarnActions.ts
var ReferAndEarnActions = __webpack_require__(94063);
;// CONCATENATED MODULE: ./uiKit/components/Alert/src/InfoAlert.tsx

var InfoAlert = function(param) {
    var type = param.type, icon = param.icon, text = param.text, isOpen = param.isOpen;
    var getColorOfText = function() {
        switch(type){
            case "success":
                return "text-white bg-green-300";
            case "danger":
                return "text-white bg-red-960";
        }
    };
    if (isOpen) return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: [
            "w-full flex items-center p-2 md:px-4 md:py-2",
            getColorOfText(), 
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: icon,
                width: 25,
                height: 25
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "font-bold text-font14 pl-4",
                children: text
            })
        ]
    });
    else return null;
};

;// CONCATENATED MODULE: ./uiKit/components/Alert/src/index.ts


;// CONCATENATED MODULE: ./uiKit/components/Alert/index.ts


// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./hooks/useOnlineStatus.tsx

function getOnlineStatus() {
    return typeof navigator !== "undefined" && typeof navigator.onLine === "boolean" ? navigator.onLine : true;
}
function useOnlineStatus() {
    var ref = (0,react.useState)(getOnlineStatus()), onlineStatus = ref[0], setOnlineStatus = ref[1];
    var goOnline = function() {
        return setOnlineStatus(true);
    };
    var goOffline = function() {
        return setOnlineStatus(false);
    };
    (0,react.useEffect)(function() {
        window.addEventListener("online", goOnline);
        window.addEventListener("offline", goOffline);
        return function() {
            window.removeEventListener("online", goOnline);
            window.removeEventListener("offline", goOffline);
        };
    }, []);
    return onlineStatus;
}

;// CONCATENATED MODULE: ./components/common/InternetCheckAlertBox.tsx



var InternetCheckAlertBox = function() {
    var isOnline = useOnlineStatus();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoAlert, {
        type: "danger",
        icon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAABHNCSVQICAgIfAhkiAAAAjFJREFUWEfNmP1RwkAQxUkFWgJUIFRg6MAOhAqECowVaAeGDuzAWIFYgdiBVhDfw5AJyX3s3uYPb4bJGPbe/rJ32ceZTf7ZyCw8dV3fYP4tPnmjU+G6y7LsJVU3GQgwz0i68iQuAbVOgUoCAswGyR4jCbeAetJCqYEAc4kkn/jwGhrf+HIGKF7FIwWIT30nzPAAoEIYewxTAaE606Y6mhys0kE6QQtUQphvlWbwrVtJJ4iBUJ0coq9S4V7cAlB7yVwNEGEI5Rpvzc1rz/cVgJajAUWqs0YyLuUEcVwa9ifXWCKuikGJKoRE7xCau8SQ5EwDsbUn6R6hCzNQ5KknCiCytNX0gUUrBCA2walXQF4hShwQPgtVKQgEmAKT74MCOiBKBZulF0hqEcolI1DQUkJA0epQPQEoWCUnkMYiEoEI5bQUH1CJCSKLMAA5LWUAhOqw37DviIYBiPoDS3EBhSxiAGkEGlhKv8vmyKgyUCMQH/DMUvpAXosYqTG6ZM6q1ALFLCKwoaTmGtqTrUYXKGgRkR1+OvbwWJQyWks5AkksIiWLcs7xlJJJLSIivmu+F/Uuj9afpYxQnfYtMf7MJeeWQOo3q/uEI7z2Xbk9gXy/8KRboPUkjQd62whEuHYX0uyOuAPuFc19XqcGrS9WqISAZTMa8g+m7ghEM62MVRoD6gci81MfWuEPntktS2eBIsyGx6lup+bacw+wYlcWdcXcD8TyRFsAhntR988GRaLk0F8Ph/r+6c8wkQAAAABJRU5ErkJggg==",
        text: "Please check your internet connection.",
        isOpen: !isOnline
    });
};
/* harmony default export */ var common_InternetCheckAlertBox = (InternetCheckAlertBox);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./utils/country_utils.ts
var country_utils = __webpack_require__(20581);
;// CONCATENATED MODULE: ./hooks/useIsomorphicEffect.ts

var useIsomorphicEffect = function() {
    return  true ? react.useLayoutEffect : 0;
};
/* harmony default export */ var hooks_useIsomorphicEffect = (useIsomorphicEffect);

// EXTERNAL MODULE: ./hooks/login/useLocation.ts
var useLocation = __webpack_require__(28531);
// EXTERNAL MODULE: ./apollo/model/profile/profile.ts
var profile = __webpack_require__(93630);
// EXTERNAL MODULE: ./node_modules/next/dist/shared/lib/styled-jsx.js
var styled_jsx = __webpack_require__(66089);
var styled_jsx_default = /*#__PURE__*/__webpack_require__.n(styled_jsx);
// EXTERNAL MODULE: ./components/common/withWindowDimensions.tsx
var withWindowDimensions = __webpack_require__(5588);
// EXTERNAL MODULE: ./components/Login/withLogin.tsx
var withLogin = __webpack_require__(43674);
// EXTERNAL MODULE: ./hooks/useDevice.ts
var useDevice = __webpack_require__(84367);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./page_routes/index.ts
var page_routes = __webpack_require__(12615);
// EXTERNAL MODULE: ./scripts/segment.ts + 1 modules
var segment = __webpack_require__(83697);
// EXTERNAL MODULE: ./utils/events-utils.js
var events_utils = __webpack_require__(42477);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./service/api.ts + 1 modules
var api = __webpack_require__(14117);
;// CONCATENATED MODULE: ./components/common/FooterLinks.tsx





var FooterLinks = function() {
    var ref = (0,react.useState)(), footerLink = ref[0], setFooterLink = ref[1];
    var ref1 = (0,react.useState)(null), openId = ref1[0], setOpenId = ref1[1];
    var handleToggle = function(idx) {
        setOpenId(function(prev) {
            return prev !== idx ? idx : null;
        });
        try {
            var footerLinkDetails = document.getElementById("footer-link-details");
            if (footerLinkDetails) {
                var detailsElements = footerLinkDetails.querySelectorAll("details");
                detailsElements.forEach(function(details) {
                    details.addEventListener("click", function() {
                        detailsElements.forEach(function(otherDetails) {
                            if (otherDetails !== details) {
                                otherDetails.removeAttribute("open");
                            }
                        });
                    });
                });
            }
        } catch (e) {
            console.error(e);
        }
    };
    var fetchFooterLinks = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var cmsServer, apiUrl, res, ref, responseData, result;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        cmsServer = "https://cf-cms.leapscholar.com";
                        apiUrl = "".concat(cmsServer, "/footer-links?_limit=-1");
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return api/* default.get */.Z.get(apiUrl);
                    case 5:
                        res = _ctx.sent;
                        if (res === null || res === void 0 ? void 0 : res.data) {
                            ;
                            responseData = (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.length) && (res === null || res === void 0 ? void 0 : res.data) || [];
                            result = [];
                            responseData === null || responseData === void 0 ? void 0 : responseData.forEach(function(_, index) {
                                if (index % 4 === 0) {
                                    result.push(responseData.slice(index, index + 4));
                                }
                            });
                            setFooterLink(result);
                        }
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](2);
                        console.error(_ctx.t0);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    9
                ]
            ]);
        }));
        return function fetchFooterLinks() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        fetchFooterLinks();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "footer-link-details",
        className: "flex flex-col gap-6",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: footerLink === null || footerLink === void 0 ? void 0 : footerLink.map(function(sectionItem, idx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: "md:grid grid-cols-4 flex flex-col gap-6",
                            children: sectionItem === null || sectionItem === void 0 ? void 0 : sectionItem.map(function(footerLinkItem) {
                                var ref;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("details", {
                                    className: "group",
                                    onClick: function() {
                                        return handleToggle(footerLinkItem === null || footerLinkItem === void 0 ? void 0 : footerLinkItem.id);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("summary", {
                                            className: "flex cursor-pointer justify-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                    className: "font-bold text-[14px] leading-[21px]",
                                                    children: footerLinkItem === null || footerLinkItem === void 0 ? void 0 : footerLinkItem.heading
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                    className: "flex-shrink-0 ml-1.5 w-5 h-5 transition duration-300 group-open:-rotate-180",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    fill: "none",
                                                    viewBox: "0 0 24 24",
                                                    stroke: "currentColor",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        "stroke-linecap": "round",
                                                        "stroke-linejoin": "round",
                                                        "stroke-width": "2",
                                                        d: "M19 9l-7 7-7-7"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "md:hidden",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                    className: "text-[#CBCAD5] font-bold text-[14px] leading-[21px] mt-6 md:mt-4 mb-3 md:mb-1",
                                                    children: footerLinkItem === null || footerLinkItem === void 0 ? void 0 : footerLinkItem.heading
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    children: footerLinkItem === null || footerLinkItem === void 0 ? void 0 : (ref = footerLinkItem.footerLinkList) === null || ref === void 0 ? void 0 : ref.map(function(linkItem, index) {
                                                        var ref;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                            className: "text-[14px] leading-[21px] font-medium md:font-normal cursor-pointer ".concat((footerLinkItem === null || footerLinkItem === void 0 ? void 0 : (ref = footerLinkItem.footerLinkList) === null || ref === void 0 ? void 0 : ref.length) !== index + 1 ? "mb-3" : "mb-0"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "".concat(linkItem === null || linkItem === void 0 ? void 0 : linkItem.link),
                                                                children: linkItem === null || linkItem === void 0 ? void 0 : linkItem.text
                                                            })
                                                        });
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, "footer-link-".concat(idx));
                            })
                        }),
                        openId !== null && (sectionItem === null || sectionItem === void 0 ? void 0 : sectionItem.some(function(e) {
                            return (e === null || e === void 0 ? void 0 : e.id) === openId;
                        })) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "md:block hidden",
                            children: sectionItem === null || sectionItem === void 0 ? void 0 : sectionItem.map(function(item) {
                                var ref;
                                if ((item === null || item === void 0 ? void 0 : item.id) !== openId) {
                                    return null;
                                }
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                            className: "text-[#CBCAD5] font-bold text-[14px] leading-[21px] my-1",
                                            children: item === null || item === void 0 ? void 0 : item.heading
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            className: "grid grid-cols-4 gap-3",
                                            children: item === null || item === void 0 ? void 0 : (ref = item.footerLinkList) === null || ref === void 0 ? void 0 : ref.map(function(linkItem, index) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                    className: "text-[14px] leading-[21px] md:font-normal",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        target: "_self",
                                                        href: "".concat(linkItem === null || linkItem === void 0 ? void 0 : linkItem.link),
                                                        className: "cursor-pointer",
                                                        children: linkItem === null || linkItem === void 0 ? void 0 : linkItem.text
                                                    })
                                                }, "footer-link-sec-".concat(index));
                                            })
                                        })
                                    ]
                                });
                            })
                        })
                    ]
                });
            })
        })
    });
};
/* harmony default export */ var common_FooterLinks = (FooterLinks);

;// CONCATENATED MODULE: ./components/common/FooterHtmlSiteMap.tsx

var FooterHtmlSiteMap = function() {
    var alphabet = Array.from({
        length: 26
    }, function(_, i) {
        var ref;
        return (ref = String.fromCharCode(97 + i)) === null || ref === void 0 ? void 0 : ref.toLowerCase();
    });
    alphabet.push("others");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "max-w-[1180px] md:m-auto mt-[40px] md:mt-[40px] flex flex-col md:flex-row justify-around md:gap-[80px] border-t-[0.5px] border-t-[#686868] py-4 my-6 text-[14px] leading-[21px] font-bold",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-4 md:mb-0",
                children: "Universities"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-wrap gap-[12px] md:gap-0 justify-evenly w-full",
                children: alphabet === null || alphabet === void 0 ? void 0 : alphabet.map(function(word, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "".concat("https://leapscholar.com" || 0, "/html-sitemap/abroad-university-list/").concat(word),
                                target: "_self",
                                children: word === null || word === void 0 ? void 0 : word.toLocaleUpperCase()
                            }, "footer-".concat(idx)),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                style: {
                                    borderRight: (word === null || word === void 0 ? void 0 : word.length) === 1 ? "1px solid white !important" : ""
                                }
                            })
                        ]
                    });
                })
            })
        ]
    });
};
/* harmony default export */ var common_FooterHtmlSiteMap = (FooterHtmlSiteMap);

// EXTERNAL MODULE: ./lib/auth_token.ts
var auth_token = __webpack_require__(72714);
;// CONCATENATED MODULE: ./components/common/Footer.tsx
















var links = {
    countries: [
        {
            country: "USA",
            link: "/usa"
        },
        {
            country: "UK",
            link: "/uk"
        },
        {
            country: "Canada",
            link: "/canada"
        },
        {
            country: "Australia",
            link: "/australia"
        },
        {
            country: "Ireland",
            link: "/ireland"
        },
        {
            country: "Germany",
            link: "/germany"
        }, 
    ],
    topUniversities: [
        {
            text: "Top Universities in USA",
            link: "/usa/universities-colleges-list"
        },
        {
            text: "Top Universities in UK",
            link: "/uk/universities-colleges-list"
        },
        {
            text: "Top Universities in Canada",
            link: "/canada/universities-colleges-list"
        },
        {
            text: "Top Universities in Australia",
            link: "/australia/universities-colleges-list"
        },
        {
            text: "Top Universities in Ireland",
            link: "/ireland/universities-colleges-list"
        }, 
    ],
    offerings: [
        {
            text: "Free IELTS Masterclass",
            path: "/ielts-free-online-coaching"
        },
        {
            text: "Talk to a counsellor",
            path: "/counsellors"
        },
        {
            text: "Twinning Programs",
            link: "https://advantage.leapscholar.com"
        },
        {
            text: "Cost Calculator",
            path: "/cost-calculator"
        },
        {
            text: "Blog",
            link: "https://leapscholar.com/blog/"
        },
        {
            text: "Study Abroad Knowledge Center",
            link: "https://leapscholar.com/blog/study-abroad-knowledge-center-sitemap/"
        },
        {
            text: "Events",
            path: "/events"
        }, 
    ],
    testimonials: [
        {
            path: "/testimonials/ielts",
            contentName: "IELTS"
        },
        {
            path: "/testimonials/scholar",
            contentName: "Counselling"
        }, 
    ],
    company: [
        {
            text: "About Us",
            path: "/about-us"
        },
        {
            text: "Careers",
            link: "https://careers.leapfinance.com"
        },
        {
            text: "Leap in the news!",
            link: "https://press.leapscholar.com"
        }, 
    ],
    products: [
        {
            text: "LeapFinance",
            link: "https://leapfinance.com"
        },
        {
            text: "LeapAdvantage",
            link: "https://advantage.leapscholar.com"
        },
        {
            text: "IELTS Prep by LeapScholar",
            link: "/exams/ielts/preparation-online"
        }, 
    ],
    socialMedia: [
        {
            icon: "https://leapassets.s3.ap-south-1.amazonaws.com/youtube.svg",
            link: "https://www.youtube.com/c/leapscholar",
            contentName: "Youtube"
        },
        {
            icon: "https://leapassets.s3.ap-south-1.amazonaws.com/twitter.svg",
            link: "https://twitter.com/leapscholar",
            contentName: "Twitter"
        },
        {
            icon: "https://leapassets.s3.ap-south-1.amazonaws.com/linkedin.svg",
            link: "https://www.linkedin.com/company/leap-global-education/",
            contentName: "Linkedin"
        },
        {
            icon: "https://leapassets.s3.ap-south-1.amazonaws.com/instagram.svg",
            link: "https://www.instagram.com/leapscholar",
            contentName: "Instagram"
        },
        {
            icon: "https://leapassets.s3.ap-south-1.amazonaws.com/facebook.svg",
            link: "https://www.facebook.com/leapscholar",
            contentName: "Facebook"
        },
        {
            icon: "https://leapassets.s3.ap-south-1.amazonaws.com/telegram-icon.svg",
            link: "https://t.me/leap_abroad",
            contentName: "Telegram"
        }, 
    ],
    partners: [
        {
            link: "https://yocket.com",
            contentName: "Yocket study abroad"
        },
        {
            link: "https://geebeeworld.com",
            contentName: "GEEBEE"
        }, 
    ],
    exams: [
        {
            text: "IELTS",
            link: "https://leapscholar.com/exams/ielts?flow=footer"
        },
        {
            text: "TOEFL",
            link: "https://leapscholar.com/exams/toefl?flow=footer"
        },
        {
            text: "SAT",
            link: "https://leapscholar.com/exams/sat?flow=footer"
        },
        {
            text: "PTE",
            link: "https://leapscholar.com/exams/pte?flow=footer"
        },
        {
            text: "GRE",
            link: "https://leapscholar.com/exams/gre?flow=footer"
        },
        {
            text: "GMAT",
            link: "https://leapscholar.com/exams/gmat?flow=footer"
        }, 
    ]
};
var getWidget = function(contentName, widgetName) {
    return {
        contentName: contentName,
        widgetName: widgetName,
        widgetFormat: "Banner",
        contentFormat: "Button"
    };
};
var Divider = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "h-100 bg-gray-780 w-full my-6"
    });
};
var ContactSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-1 text-lightgray-250 break-words mt-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "font-bold text-normal",
                children: "Contact us"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                className: "text-font14 text-lightgray-1650 flex gap-1 mt-1",
                href: "tel:08047184844",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "self-start",
                        src: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/footer-call.svg",
                        alt: "call"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: " Call us on:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "+91 080-47184844"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "(Between 10 am to 7 pm)"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                className: "text-font14 text-lightgray-1650 flex gap-1 items-center",
                href: "mailto:contact@leapscholar.com",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/footer-mail.svg",
                        alt: "call"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: " Mail us on:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "contact@leapscholar.com"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var osSpecificLink = {
    Android: {
        image: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/google-play.svg",
        link: "https://play.google.com/store/apps/details?id=com.leapscholar.app"
    },
    iOS: {
        image: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/app-store.svg",
        link: "https://apps.apple.com/in/app/counselling-by-leapscholar/id1618752229"
    }
};
var AppLink = function(param) {
    var image = param.image, link = param.link;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        href: link,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: image,
            alt: "download"
        })
    });
};
var Footer = function() {
    var ref = (0,useDevice/* default */.Z)(), isMobile = ref.isMobile, isTablet = ref.isTablet;
    var authValue = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref1;
        return state === null || state === void 0 ? void 0 : (ref = state.auth) === null || ref === void 0 ? void 0 : (ref1 = ref.auth) === null || ref1 === void 0 ? void 0 : ref1.token;
    });
    var authToken = new auth_token/* AuthToken */.H(authValue);
    var isLoggedIn = authToken && authToken.isValid;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                className: "jsx-6c18a0bf384ea743" + " " + "bg-blue-100 ".concat(isLoggedIn ? "" : "pb-[200px] md:pb-0", " text-white ").concat(isMobile ? "py-5 px-[22px]" : "p-[36px]"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-6c18a0bf384ea743" + " " + ((!isMobile && !isTablet ? "wrapper" : "") || ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "jsx-6c18a0bf384ea743" + " " + "flex flex-col gap-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "jsx-6c18a0bf384ea743" + " " + "flex items-center gap-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/company_logo/new-footer-logo.svg"),
                                            alt: "logo",
                                            style: {
                                                width: "200px"
                                            },
                                            className: "jsx-6c18a0bf384ea743" + " " + "logo"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "jsx-6c18a0bf384ea743" + " " + "flex flex-col gap-1 text-lightgray-250",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "jsx-6c18a0bf384ea743" + " " + "flex gap-2 mt-2",
                                            children: links.socialMedia.map(function(element, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    onClick: function() {
                                                        return (0,segment.trackClick)(events_utils.pageName.LeapScholarHomePage, getWidget(element.contentName, "Footer"));
                                                    },
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    href: element.link,
                                                    className: "jsx-6c18a0bf384ea743",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: element.icon,
                                                        alt: "social-icon",
                                                        width: 30,
                                                        height: 30
                                                    })
                                                }, index);
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "jsx-6c18a0bf384ea743" + " " + "flex flex-col gap-6 mt-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "jsx-6c18a0bf384ea743",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "jsx-6c18a0bf384ea743" + " " + "font-bold text-normal mb-3",
                                                        children: "Download Study Abroad App"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "jsx-6c18a0bf384ea743" + " " + "flex gap-4",
                                                        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: lib/* osName */.BF === "Android" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink, {
                                                                image: osSpecificLink.Android.image,
                                                                link: osSpecificLink.Android.link
                                                            }) : lib/* osName */.BF === "iOS" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink, {
                                                                image: osSpecificLink.iOS.image,
                                                                link: osSpecificLink.iOS.link
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink, {
                                                                        image: osSpecificLink.Android.image,
                                                                        link: osSpecificLink.Android.link
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink, {
                                                                        image: osSpecificLink.iOS.image,
                                                                        link: osSpecificLink.iOS.link
                                                                    })
                                                                ]
                                                            })
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink, {
                                                                    image: osSpecificLink.Android.image,
                                                                    link: osSpecificLink.Android.link
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink, {
                                                                    image: osSpecificLink.iOS.image,
                                                                    link: osSpecificLink.iOS.link
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "jsx-6c18a0bf384ea743",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "jsx-6c18a0bf384ea743" + " " + "font-bold text-normal mb-3",
                                                        children: "Download IELTS Prep App"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink, {
                                                        image: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/google-play.svg",
                                                        link: "https://leapielts.app.link/open"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactSection, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "jsx-6c18a0bf384ea743" + " " + "flex-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "jsx-6c18a0bf384ea743" + " " + "md:hidden",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_FooterLinks, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "jsx-6c18a0bf384ea743" + " " + "grid ".concat(!isMobile ? "md:grid-cols-4" : "grid-cols-2 gap-5 mt-8"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "jsx-6c18a0bf384ea743" + " " + "flex flex-col gap-1 text-lightgray-250",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "jsx-6c18a0bf384ea743" + " " + "font-bold text-normal",
                                                        children: "Countries"
                                                    }),
                                                    links.countries.map(function(element, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "".concat(element.link),
                                                            onClick: function() {
                                                                (0,segment.trackClick)(events_utils.pageName.LeapScholarHomePage, getWidget(element.country, "Footer - Countries List"));
                                                            },
                                                            className: "jsx-6c18a0bf384ea743" + " " + "text-font14 text-lightgray-1650",
                                                            children: element.country
                                                        }, index);
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "jsx-6c18a0bf384ea743" + " " + "flex flex-col text-lightgray-250 mt-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "jsx-6c18a0bf384ea743" + " " + "font-bold text-normal",
                                                                children: "Top Universities"
                                                            }),
                                                            links.topUniversities.map(function(element, index) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "".concat(element.link),
                                                                    className: "jsx-6c18a0bf384ea743" + " " + "text-font14 text-lightgray-1650",
                                                                    children: element.text
                                                                }, index);
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "jsx-6c18a0bf384ea743" + " " + "flex flex-col gap-1 text-lightgray-250",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "jsx-6c18a0bf384ea743" + " " + "font-bold text-normal",
                                                        children: "Company"
                                                    }),
                                                    links.company.map(function(element, index) {
                                                        return element.link ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            onClick: function() {
                                                                (0,segment.trackClick)(events_utils.pageName.LeapScholarHomePage, getWidget(element.text, "Footer - Company"));
                                                            },
                                                            target: "_blank",
                                                            rel: "noopener noreferrer",
                                                            href: element.link,
                                                            className: "jsx-6c18a0bf384ea743" + " " + "text-font14 text-lightgray-1650",
                                                            children: element.text
                                                        }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "".concat(element.path),
                                                            prefetch: false,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                onClick: function() {
                                                                    (0,segment.trackClick)(events_utils.pageName.LeapScholarHomePage, getWidget(element.text, "Footer - Company"));
                                                                },
                                                                className: "jsx-6c18a0bf384ea743" + " " + "text-font14 text-lightgray-1650",
                                                                children: element.text
                                                            })
                                                        }, index);
                                                    }),
                                                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "jsx-6c18a0bf384ea743" + " " + "flex flex-col text-lightgray-250 mt-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "jsx-6c18a0bf384ea743" + " " + "font-bold text-normal",
                                                                children: "Our Partners"
                                                            }),
                                                            links.partners.map(function(element, index) {
                                                                return element.link ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    onClick: function() {
                                                                        (0,segment.trackClick)(events_utils.pageName.LeapScholarHomePage, getWidget(element.contentName, "Footer - Partner"));
                                                                    },
                                                                    target: "_blank",
                                                                    rel: "noopener noreferrer",
                                                                    href: element.link,
                                                                    className: "jsx-6c18a0bf384ea743" + " " + "text-font14 text-lightgray-1650",
                                                                    children: element.contentName
                                                                }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: "".concat(element.link),
                                                                    prefetch: false,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        onClick: function() {
                                                                            (0,segment.trackClick)(events_utils.pageName.LeapScholarHomePage, getWidget(element.contentName, "Footer - Partner"));
                                                                        },
                                                                        className: "jsx-6c18a0bf384ea743" + " " + "text-font14 text-lightgray-1650",
                                                                        children: element.contentName
                                                                    })
                                                                }, index);
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "jsx-6c18a0bf384ea743" + " " + "flex flex-col gap-1 text-lightgray-250",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "jsx-6c18a0bf384ea743" + " " + "font-bold text-normal",
                                                        children: "Our Offerings"
                                                    }),
                                                    links.offerings.map(function(element, index) {
                                                        return element.link ? element.link === "/" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            onClick: function() {
                                                                (0,segment.trackClick)(events_utils.pageName.LeapScholarHomePage, getWidget(element.text, "Footer - Our Offerings"));
                                                            },
                                                            href: "/",
                                                            className: "jsx-6c18a0bf384ea743" + " " + "text-font14 text-lightgray-1650",
                                                            children: element.text
                                                        }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            onClick: function() {
                                                                (0,segment.trackClick)(events_utils.pageName.LeapScholarHomePage, getWidget(element.text, "Footer - Our Offerings"));
                                                            },
                                                            target: "_blank",
                                                            rel: "noopener noreferrer",
                                                            href: element.link,
                                                            className: "jsx-6c18a0bf384ea743" + " " + "text-font14 text-lightgray-1650 w-[85%]",
                                                            children: element.text
                                                        }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "".concat(element.path),
                                                            prefetch: false,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                onClick: function() {
                                                                    (0,segment.trackClick)(events_utils.pageName.LeapScholarHomePage, getWidget(element.text, "Footer - Our Offerings"));
                                                                },
                                                                className: "jsx-6c18a0bf384ea743" + " " + "text-font14 text-lightgray-1650",
                                                                children: element.text
                                                            })
                                                        }, index);
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "jsx-6c18a0bf384ea743" + " " + "flex flex-col text-gray-13 mt-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "jsx-6c18a0bf384ea743" + " " + "font-bold text-[15px]",
                                                                children: "Testimonials"
                                                            }),
                                                            links.testimonials.map(function(element, index) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: "".concat(element.path),
                                                                    prefetch: false,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        onClick: function() {
                                                                            (0,segment.trackClick)(events_utils.pageName.LeapScholarHomePage, getWidget(element.contentName, "Footer - Testimonials"));
                                                                        },
                                                                        className: "jsx-6c18a0bf384ea743" + " " + "text-font14 text-lightgray-1650",
                                                                        children: element.contentName
                                                                    })
                                                                }, index);
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "jsx-6c18a0bf384ea743" + " " + "flex flex-col gap-1 text-lightgray-250",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "jsx-6c18a0bf384ea743" + " " + "font-bold text-normal",
                                                        children: "Our Products"
                                                    }),
                                                    links.products.map(function(element, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            onClick: function() {
                                                                (0,segment.trackClick)(events_utils.pageName.LeapScholarHomePage, getWidget(element.text, "Footer - Our Products"));
                                                            },
                                                            rel: "noopener noreferrer",
                                                            target: element.text === "IELTS by Leap" ? "_self" : "_blank",
                                                            href: element.link,
                                                            className: "jsx-6c18a0bf384ea743" + " " + "text-font14 text-lightgray-1650",
                                                            children: element.text
                                                        }, index);
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "jsx-6c18a0bf384ea743" + " " + "flex flex-col gap-1 text-lightgray-250 mt-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "jsx-6c18a0bf384ea743" + " " + "font-bold text-normal",
                                                                children: "Exam Information"
                                                            }),
                                                            links.exams.map(function(element, index) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    onClick: function() {
                                                                        (0,segment.trackClick)(events_utils.pageName.LeapScholarHomePage, getWidget(element.text, "Footer - Exam Information"));
                                                                    },
                                                                    rel: "noopener noreferrer",
                                                                    target: element.text === "IELTS by Leap" ? "_self" : "_blank",
                                                                    href: element.link,
                                                                    className: "jsx-6c18a0bf384ea743" + " " + "text-font14 text-lightgray-1650",
                                                                    children: element.text
                                                                }, index);
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "jsx-6c18a0bf384ea743",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "jsx-6c18a0bf384ea743" + " " + ((!isMobile ? "grid md:grid-cols-4" : "") || ""),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "jsx-6c18a0bf384ea743" + " " + "flex flex-col gap-1 text-lightgray-250 break-words",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "jsx-6c18a0bf384ea743" + " " + "font-bold text-normal",
                                                            children: "HQ- Bangalore \xa0(India)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "jsx-6c18a0bf384ea743" + " " + "text-font13 text-lightgray-1650 ".concat(!isMobile && "max-w-[148px]"),
                                                            children: "163/A, 9th Main Rd, Sector 6, HSR Layout, Bengaluru, Karnataka 560102"
                                                        })
                                                    ]
                                                }),
                                                isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}) : null,
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "jsx-6c18a0bf384ea743" + " " + "flex flex-col gap-1 text-lightgray-250 break-words",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "jsx-6c18a0bf384ea743" + " " + "font-bold text-normal",
                                                            children: "Branch Office \xa0(Bangalore)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "jsx-6c18a0bf384ea743" + " " + "text-font13 text-lightgray-1650 ".concat(!isMobile && "max-w-[148px]"),
                                                            children: [
                                                                "No 144, 3rd floor, Shubharam Complex, Mahatma Gandhi Rd, near Metro Station Trinity, above HDFC Bank, Craig Park Layout, Ashok Nagar, Bengaluru, Karnataka 560001,",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                                                    className: "jsx-6c18a0bf384ea743"
                                                                }),
                                                                " Contact Number: +919663730932"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}) : null,
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "jsx-6c18a0bf384ea743" + " " + "flex flex-col gap-1 text-lightgray-250 break-words",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "jsx-6c18a0bf384ea743" + " " + "font-bold text-normal",
                                                            children: "Singapore \xa0(International)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "jsx-6c18a0bf384ea743" + " " + "text-font13 text-lightgray-1650 ".concat(!isMobile && "max-w-[148px]"),
                                                            children: "11 Collyer Quay #17-00 The Arcade, 049317, Singapore"
                                                        })
                                                    ]
                                                }),
                                                isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}) : null,
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "jsx-6c18a0bf384ea743" + " " + "flex flex-col gap-1 text-lightgray-250 break-words",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "jsx-6c18a0bf384ea743" + " " + "font-bold text-normal",
                                                            children: "UAE \xa0(International)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "jsx-6c18a0bf384ea743" + " " + "text-font13 text-lightgray-1650 ".concat(!isMobile && "max-w-[148px]"),
                                                            children: [
                                                                "Office 1106, Arenco Tower, Sheikh Zayed Road, ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                                                    className: "jsx-6c18a0bf384ea743"
                                                                }),
                                                                " Media City Dubai - 3087, UAE ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                                                    className: "jsx-6c18a0bf384ea743"
                                                                }),
                                                                " Contact Number: +971 501501220"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}) : null,
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "jsx-6c18a0bf384ea743" + " " + "flex flex-col gap-1 text-lightgray-250 md:hidden break-words",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "jsx-6c18a0bf384ea743" + " " + "font-bold text-normal",
                                                            children: "Our Partners"
                                                        }),
                                                        links.partners.map(function(element, index) {
                                                            return element.link ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                onClick: function() {
                                                                    (0,segment.trackClick)(events_utils.pageName.LeapScholarHomePage, getWidget(element.contentName, "Footer - Partner"));
                                                                },
                                                                target: "_blank",
                                                                rel: "noopener noreferrer",
                                                                href: element.link,
                                                                className: "jsx-6c18a0bf384ea743" + " " + "text-font14 text-lightgray-1650",
                                                                children: element.contentName
                                                            }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "".concat(element.link),
                                                                prefetch: false,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    onClick: function() {
                                                                        (0,segment.trackClick)(events_utils.pageName.LeapScholarHomePage, getWidget(element.contentName, "Footer - Partner"));
                                                                    },
                                                                    className: "jsx-6c18a0bf384ea743" + " " + "text-font14 text-lightgray-1650",
                                                                    children: element.contentName
                                                                })
                                                            }, index);
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "jsx-6c18a0bf384ea743" + " " + "flex flex-col gap-1 text-lightgray-250 pt-4 md:pt-0 break-words",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/privacy",
                                                            prefetch: false,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "jsx-6c18a0bf384ea743" + " " + "text-sm text-lightgray-1650 inline-block",
                                                                children: "Privacy Policy"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: page_routes/* navRoutes.TERM_AND_CONDITION */.CZ.TERM_AND_CONDITION,
                                                            prefetch: false,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "jsx-6c18a0bf384ea743" + " " + "text-sm text-lightgray-1650 inline-block",
                                                                children: "Terms and Conditions"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: page_routes/* navRoutes.REFUND_POLICY */.CZ.REFUND_POLICY,
                                                            prefetch: false,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "jsx-6c18a0bf384ea743" + " " + "text-sm text-lightgray-1650 inline-block",
                                                                children: "Refund policy"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_FooterHtmlSiteMap, {})
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "6c18a0bf384ea743",
                children: ".logo.jsx-6c18a0bf384ea743{-webkit-filter:brightness(0)invert(1);filter:brightness(0)invert(1);margin-left:-4px;height:50px}.wrapper.jsx-6c18a0bf384ea743{max-width:1120px;margin:auto;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;gap:80px}"
            })
        ]
    });
};
/* harmony default export */ var common_Footer = ((0,withWindowDimensions/* default */.Z)((0,withLogin/* withLogin */.U)(Footer)));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./utils/navbarUtilsLs.tsx
var loggedOutNav = {
    navData: [
        {
            title: "Study Abroad",
            icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/study-abroad.svg",
            subMenu: [
                {
                    text: "Study in USA",
                    link: "/usa"
                },
                {
                    text: "Study in UK",
                    link: "/uk"
                },
                {
                    text: "Study in Canada",
                    link: "/canada"
                },
                {
                    text: "Study in Australia",
                    link: "/australia"
                },
                {
                    text: "Study in Ireland",
                    link: "/ireland"
                },
                {
                    text: "Study in Germany",
                    link: "/germany"
                },
                {
                    text: "Our Counsellors",
                    link: "/counsellors"
                },
                {
                    text: "Master's Programs",
                    link: "https://advantage.leapscholar.com/",
                    isTargetBlank: true
                },
                {
                    text: "Undergraduate Programs",
                    link: "https://advantage.leapscholar.com/for-undergrad",
                    isTargetBlank: true
                }, 
            ]
        },
        {
            title: "IELTS",
            icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/ielts.svg",
            subMenu: [
                {
                    text: "IELTS Courses",
                    link: "/test-prep/dashboard"
                },
                {
                    text: "IELTS Booking Details",
                    breadcrumb: "Booking",
                    nestedSubmenu: [
                        {
                            text: "IELTS Dates",
                            link: "/exams/ielts/dates"
                        },
                        {
                            text: "IELTS Fees",
                            link: "/exams/ielts/fees"
                        },
                        {
                            text: "IELTS Centres",
                            link: "/exams/ielts/centre"
                        },
                        {
                            text: "IELTS Registration",
                            link: "/exams/ielts/registration"
                        },
                        {
                            text: "IELTS Slot Booking",
                            link: "/exams/ielts/slot-booking"
                        }, 
                    ]
                },
                {
                    text: "IELTS Module Details",
                    breadcrumb: "Module",
                    nestedSubmenu: [
                        {
                            text: "IELTS Module Overview",
                            link: "/exams/ielts/modules"
                        },
                        {
                            text: "Speaking Details",
                            link: "/exams/ielts/modules/speaking-overview"
                        },
                        {
                            text: "Listening Details",
                            link: "/exams/ielts/modules/listening-overview"
                        },
                        {
                            text: "Writing Details",
                            link: "/exams/ielts/modules/writing-overview"
                        },
                        {
                            text: "Reading Details",
                            link: "/exams/ielts/modules/reading-overview"
                        }, 
                    ]
                },
                {
                    text: "IELTS Practice Test",
                    link: "/exams/ielts/practice-test"
                },
                {
                    text: "IELTS Exam Overview",
                    link: "/exams/ielts"
                },
                {
                    text: "Free IELTS Masterclass",
                    link: "/ielts-free-online-coaching"
                },
                {
                    text: "Important IELTS Articles",
                    link: "/blog/category/ielts-preparation/",
                    isTargetBlank: true
                }, 
            ]
        },
        {
            title: "Events",
            link: "/events",
            icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/event.svg"
        },
        {
            title: "Blogs",
            link: "/blog/",
            icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/library_books.svg"
        },
        {
            title: "About",
            link: "/about-us",
            icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/about.svg"
        }, 
    ],
    mobileNavData: [
        {
            title: "Study Abroad",
            icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/study-abroad.svg",
            subMenu: [
                {
                    text: "Study in USA",
                    link: "/usa"
                },
                {
                    text: "Study in UK",
                    link: "/uk"
                },
                {
                    text: "Study in Canada",
                    link: "/canada"
                },
                {
                    text: "Study in Australia",
                    link: "/australia"
                },
                {
                    text: "Study in Ireland",
                    link: "/ireland"
                },
                {
                    text: "Study in Germany",
                    link: "/germany"
                },
                {
                    text: "Our Counsellors",
                    link: "/counsellors"
                },
                {
                    text: "Master's Programs",
                    link: "https://advantage.leapscholar.com/"
                },
                {
                    text: "Undergraduate Programs",
                    link: "https://advantage.leapscholar.com/for-undergrad"
                }, 
            ]
        },
        {
            title: "IELTS",
            icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/ielts.svg",
            subMenu: [
                {
                    text: "IELTS Courses",
                    link: "/test-prep/dashboard"
                },
                {
                    text: "IELTS Booking Details",
                    breadcrumb: "Booking",
                    nestedSubmenu: [
                        {
                            text: "IELTS Dates",
                            link: "/exams/ielts/dates"
                        },
                        {
                            text: "IELTS Fees",
                            link: "/exams/ielts/fees"
                        },
                        {
                            text: "IELTS Centres",
                            link: "/exams/ielts/centre"
                        },
                        {
                            text: "IELTS Registration",
                            link: "/exams/ielts/registration"
                        },
                        {
                            text: "IELTS Slot Booking",
                            link: "/exams/ielts/slot-booking"
                        }, 
                    ]
                },
                {
                    text: "IELTS Module Details",
                    breadcrumb: "Module",
                    nestedSubmenu: [
                        {
                            text: "IELTS Module Overview",
                            link: "/exams/ielts/modules"
                        },
                        {
                            text: "Speaking Details",
                            link: "/exams/ielts/modules/speaking-overview"
                        },
                        {
                            text: "Listening Details",
                            link: "/exams/ielts/modules/listening-overview"
                        },
                        {
                            text: "Writing Details",
                            link: "/exams/ielts/modules/writing-overview"
                        },
                        {
                            text: "Reading Details",
                            link: "/exams/ielts/modules/reading-overview"
                        }, 
                    ]
                },
                {
                    text: "IELTS Practice Test",
                    link: "/exams/ielts/practice-test"
                },
                {
                    text: "IELTS Exam Overview",
                    link: "/exams/ielts"
                },
                {
                    text: "Free IELTS Masterclass",
                    link: "/ielts-free-online-coaching"
                },
                {
                    text: "Important IELTS Articles",
                    link: "/blog/category/ielts-preparation/",
                    isTargetBlank: true
                }, 
            ]
        },
        {
            title: "Events",
            link: "/events",
            icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/event.svg"
        },
        {
            title: "Blogs",
            link: "/blog/",
            icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/library_books.svg"
        },
        {
            title: "About",
            link: "/about-us",
            icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/about.svg"
        },
        {
            title: "(080) 47184844",
            link: "tel:+918047184844",
            icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/call.svg"
        },
        {
            title: "contact@leapscholar.com",
            link: "mailto:contact@leapscholar.com",
            icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/email.svg"
        }, 
    ]
};
var loggedInNav = {
    navData: [
        {
            title: "Counselling",
            icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/study-abroad.svg",
            link: "/profile"
        },
        {
            title: "IELTS Prep",
            icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/ielts.svg",
            link: "/test-prep/dashboard"
        }, 
    ],
    buttons: [
        {
            title: "Download App",
            buttonType: "PRIMARY",
            buttonSubMenu: [
                {
                    text: "Counselling App",
                    link: "https://play.google.com/store/apps/details?id=com.leapscholar.app",
                    isTargetBlank: true
                },
                {
                    text: "IELTS Prep App",
                    link: "https://leapielts.app.link/open",
                    isTargetBlank: true
                }, 
            ],
            icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/download-app.svg"
        },
        {
            title: "My Account",
            buttonType: "SECONDARY",
            buttonSubMenu: [
                {
                    text: "Get Support",
                    isTargetBlank: false,
                    contactInfo: [
                        {
                            title: "(080) 47184844",
                            link: "tel:+918047184844",
                            icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/call.svg"
                        },
                        {
                            title: "contact@leapscholar.com",
                            link: "mailto:contact@leapscholar.com",
                            icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/email.svg"
                        }, 
                    ]
                },
                {
                    text: "Profile",
                    link: "/profile"
                },
                {
                    text: "Log Out",
                    link: "/api/logout"
                }, 
            ],
            icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/account.svg"
        }, 
    ],
    mobileNavData: [
        {
            title: "Download App",
            icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/download-app.svg",
            subMenu: [
                {
                    text: "Counselling App",
                    link: "https://play.google.com/store/apps/details?id=com.leapscholar.app",
                    isTargetBlank: true
                },
                {
                    text: "IELTS Prep App",
                    link: "https://leapielts.app.link/open",
                    isTargetBlank: true
                }, 
            ]
        },
        {
            title: "My Account",
            icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/account.svg",
            subMenu: [
                {
                    text: "Profile",
                    link: "/profile"
                },
                {
                    text: "Log Out",
                    link: "/api/logout"
                }, 
            ]
        },
        {
            title: "(080) 47184844",
            link: "tel:+918047184844",
            icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/call.svg"
        },
        {
            title: "contact@leapscholar.com",
            link: "mailto:contact@leapscholar.com",
            icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/email.svg"
        }, 
    ]
};

;// CONCATENATED MODULE: ./node_modules/@leapfinance/frontend-commons/components/LsTofu/Constants/withWindowDimensions.js
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
/* eslint-disable react/display-name */ 

var withWindowDimensions_withWindowDimensions = function withWindowDimensions(WrappedComponent) {
    return function(props) {
        var _a = __read((0,react.useState)({
            width: 380,
            height: 640
        }), 2), windowDimensions = _a[0], setWindowDimensions = _a[1];
        (0,react.useEffect)(function() {
            var handleResize = function handleResize() {
                setWindowDimensions({
                    width: window.innerWidth,
                    height: window.innerHeight
                });
            };
            handleResize();
            window.addEventListener("resize", handleResize);
            return function() {
                window.removeEventListener("resize", handleResize);
            };
        }, []);
        return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(WrappedComponent, __assign({}, props, {
            windowWidth: windowDimensions.width,
            windowHeight: windowDimensions.height,
            isMobileSized: windowDimensions.width < 700,
            isTabSized: windowDimensions.width < 1000 && windowDimensions.width > 700
        })));
    };
};
/* harmony default export */ var Constants_withWindowDimensions = (withWindowDimensions_withWindowDimensions); //# sourceMappingURL=withWindowDimensions.js.map

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}
;// CONCATENATED MODULE: ./node_modules/@leapfinance/frontend-commons/components/LeapScholar/Navbar/NewHeader/Components/LoginModule.js

var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return _instanceof(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
};

var LoginModule = function LoginModule(_a) {
    var loginFunction = _a.loginFunction;
    var handleLogin = function handleLogin() {
        return __awaiter(void 0, void 0, void 0, function() {
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!loginFunction) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            loginFunction()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        window.location.href = "/login";
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return /*#__PURE__*/ react.createElement("button", {
        className: "lfc-w-full md:lfc-max-w-[101px] lfc-px-6 lfc-py-3 md:lfc-py-2 lfc-rounded-full lfc-bg-[#4A47FF] lfc-text-white lfc-font-semibold lfc-whitespace-nowrap",
        onClick: function onClick() {
            void handleLogin();
        }
    }, "Sign in");
};
/* harmony default export */ var Components_LoginModule = (LoginModule); //# sourceMappingURL=LoginModule.js.map

;// CONCATENATED MODULE: ./node_modules/@leapfinance/frontend-commons/components/LeapScholar/Navbar/NewHeader/constant.js
var firstLevelNavList = [
    {
        name: "Study Abroad",
        uniqueId: "countries",
        type: "modal",
        icon: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/earth_icon_Kvo-hR5QA.svg"
    },
    {
        name: "Exams",
        uniqueId: "exams",
        type: "modal",
        icon: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/file_validation_icon_R6S_UIDVT1.svg"
    },
    {
        name: "Resources",
        uniqueId: "resources",
        type: "modal",
        icon: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/book_icon_SlaW0XlAq8.svg"
    },
    {
        name: "Blogs",
        uniqueId: "blogs",
        type: "link",
        link: "/blog/",
        icon: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/license_icon_G1BdqCUonK.svg"
    },
    {
        name: "Leap Digest",
        uniqueId: "leap_digest",
        type: "link",
        link: "/digest",
        icon: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/newspaper_icon_4ZuR_rpoky.svg"
    },
    {
        name: "Events",
        uniqueId: "events",
        type: "link",
        link: "/events",
        icon: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/calendar_icon_FAVAl9rYlm.svg"
    },
    {
        name: "About Us",
        uniqueId: "about_us",
        type: "link",
        link: "/about-us",
        icon: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/information_icon_6pQIrJ35LR.svg"
    }
];
var countryNavData = {
    usa: {
        uniqueId: "usa",
        tabName: "USA",
        topHeading: "Study in USA",
        topHeadingLink: "/usa",
        subNavs: [
            {
                heading: "Top Cities in USA",
                navLinks: [
                    {
                        name: "Universities in Oxford",
                        link: "/usa/universities-colleges-list/oxford-ohio-ohio-in-usa"
                    },
                    {
                        name: "Universities in Cambridge",
                        link: "/usa/universities-colleges-list/cambridge-massachusetts-massachusetts-in-usa"
                    },
                    {
                        name: "Universities in Columbia",
                        link: "/usa/universities-colleges-list/columbia-south-carolina-south-carolina-in-usa"
                    },
                    {
                        name: "Universities in Boston",
                        link: "/usa/universities-colleges-list/boston-massachusetts-in-usa"
                    },
                    {
                        name: "Universities in Princeton",
                        link: "/usa/universities-colleges-list/princeton-new-jersey-in-usa"
                    }
                ]
            },
            {
                heading: "Top Courses in USA",
                navLinks: [
                    {
                        name: "Masters in USA",
                        link: "/usa/universities-colleges-list/masters-in-usa"
                    },
                    {
                        name: "Masters in computer science in USA",
                        link: "/usa/universities-colleges-list/masters-in-computer-science-in-usa"
                    },
                    {
                        name: "Masters in data science in USA",
                        link: "/usa/universities-colleges-list/masters-in-data-science-in-usa"
                    }
                ]
            },
            {
                heading: "Top Universities in USA",
                navLinks: [
                    {
                        name: "Harvard University",
                        link: "/usa/university-details/harvard-university"
                    },
                    {
                        name: "Stanford University",
                        link: "/usa/university-details/stanford-university"
                    },
                    {
                        name: "Northeastern University",
                        link: "/usa/university-details/northeastern-university"
                    },
                    {
                        name: "Columbia University",
                        link: "/usa/university-details/columbia-university"
                    },
                    {
                        name: "Yale University",
                        link: "/usa/university-details/yale-university"
                    }
                ]
            }
        ]
    },
    uk: {
        uniqueId: "uk",
        tabName: "UK",
        topHeading: "Study in UK",
        topHeadingLink: "/uk",
        subNavs: [
            {
                heading: "Top Cities in UK",
                navLinks: [
                    {
                        name: "Universities in Bangor",
                        link: "/uk/universities-colleges-list/bangor-uk-in-uk"
                    },
                    {
                        name: "Universities in Oxford",
                        link: "/uk/universities-colleges-list/oxford-mississippi-in-uk"
                    },
                    {
                        name: "Universities in Cambridge",
                        link: "/uk/universities-colleges-list/cambridge-massachusetts-in-uk"
                    },
                    {
                        name: "Universities in Coventry",
                        link: "/uk/universities-colleges-list/coventry-in-uk"
                    },
                    {
                        name: "Universities in Edinburgh",
                        link: "/uk/universities-colleges-list/edinburgh-in-uk"
                    }
                ]
            },
            {
                heading: "Top Courses in UK",
                navLinks: [
                    {
                        name: "Masters in UK",
                        link: "/uk/universities-colleges-list/masters-in-uk"
                    },
                    {
                        name: "Masters in Computer Science in UK",
                        link: "/uk/universities-colleges-list/masters-in-computer-science-in-uk"
                    },
                    {
                        name: "Masters in Physiotherapy in UK",
                        link: "/uk/universities-colleges-list/masters-in-physiotherapy-in-uk"
                    }
                ]
            },
            {
                heading: "Top Universities in UK",
                navLinks: [
                    {
                        name: "University of Oxford",
                        link: "/uk/university-details/university-of-oxford"
                    },
                    {
                        name: "University of Cambridge",
                        link: "/uk/university-details/university-of-cambridge"
                    },
                    {
                        name: "Coventry University",
                        link: "/uk/university-details/coventry-university"
                    },
                    {
                        name: "University of Leeds",
                        link: "/uk/university-details/university-of-leeds"
                    },
                    {
                        name: "University of East London",
                        link: "/uk/university-details/university-of-east-london"
                    }
                ]
            }
        ]
    },
    canada: {
        uniqueId: "canada",
        tabName: "Canada",
        topHeading: "Study in Canada",
        topHeadingLink: "/canada",
        subNavs: [
            {
                heading: "Top Cities in Canada",
                navLinks: [
                    {
                        name: "Universities in Toronto",
                        link: "/canada/universities-colleges-list/toronto-ontario-in-canada"
                    },
                    {
                        name: "Universities in Canada",
                        link: "/canada/universities-colleges-list"
                    },
                    {
                        name: "Universities in Alberta",
                        link: "/canada/universities-colleges-list/edmonton-alberta-in-canada"
                    },
                    {
                        name: "Universities in Kingston",
                        link: "/canada/universities-colleges-list/kingston-in-canada"
                    },
                    {
                        name: "Universities in London",
                        link: "/canada/universities-colleges-list/london-canada-in-canada"
                    }
                ]
            },
            {
                heading: "Top Courses in Canada",
                navLinks: [
                    {
                        name: "Masters in Canada",
                        link: "/canada/universities-colleges-list/masters-in-canada"
                    },
                    {
                        name: "PhD in Canada",
                        link: "/canada/universities-colleges-list/phd-in-canada"
                    },
                    {
                        name: "Masters in Computer Science in Canada",
                        link: "/canada/universities-colleges-list/masters-in-computer-science-in-canada"
                    }
                ]
            },
            {
                heading: "Top Universities in UK",
                navLinks: [
                    {
                        name: "Conestoga College",
                        link: "/canada/university-details/conestoga-college"
                    },
                    {
                        name: "University of Toronto",
                        link: "/canada/university-details/university-of-toronto"
                    },
                    {
                        name: "Lambton College",
                        link: "/canada/university-details/lambton-college"
                    },
                    {
                        name: "Humber College",
                        link: "/canada/university-details/humber-college-north"
                    },
                    {
                        name: "Centennial College",
                        link: "/canada/university-details/centennial-college"
                    }
                ]
            }
        ]
    },
    ireland: {
        uniqueId: "ireland",
        tabName: "Ireland",
        topHeading: "Study in Ireland",
        topHeadingLink: "/ireland",
        subNavs: [
            {
                heading: "Top Cities in Ireland",
                navLinks: [
                    {
                        name: "Universities in Dublin",
                        link: "/ireland/universities-colleges-list/dublin-leinster-in-ireland"
                    },
                    {
                        name: "Universities in Galway",
                        link: "/ireland/universities-colleges-list/galway-connaught-in-ireland"
                    },
                    {
                        name: "Universities in Waterford",
                        link: "/ireland/universities-colleges-list/waterford-ulster-in-ireland"
                    },
                    {
                        name: "Universities in Limerick",
                        link: "/ireland/universities-colleges-list/limerick-in-ireland"
                    },
                    {
                        name: "Universities in Cork",
                        link: "/ireland/universities-colleges-list/cork-ulster-in-ireland"
                    }
                ]
            },
            {
                heading: "Top Courses in Ireland",
                navLinks: [
                    {
                        name: "Masters in Ireland",
                        link: "/ireland/universities-colleges-list/masters-in-ireland"
                    },
                    {
                        name: "PhD in Ireland",
                        link: "/ireland/universities-colleges-list/phd-in-ireland"
                    },
                    {
                        name: "Masters in Data Science in Ireland",
                        link: "/ireland/universities-colleges-list/masters-in-data-science-in-ireland"
                    }
                ]
            },
            {
                heading: "Top Universities in Ireland",
                navLinks: [
                    {
                        name: "Trinity College",
                        link: "/ireland/university-details/trinity-college-dublin-the-university-of-dublin"
                    },
                    {
                        name: "Institute of Technology - Carlow",
                        link: "/ireland/university-details/institute-of-technology-carlow"
                    },
                    {
                        name: "Dublin City University",
                        link: "/ireland/university-details/dublin-city-university"
                    },
                    {
                        name: "University College Dublin",
                        link: "/ireland/university-details/university-college-dublin"
                    },
                    {
                        name: "University of Limerick",
                        link: "/ireland/university-details/university-of-limerick"
                    }
                ]
            }
        ]
    },
    australia: {
        uniqueId: "australia",
        tabName: "Australia",
        topHeading: "Study in Australia",
        topHeadingLink: "/australia",
        subNavs: [
            {
                heading: "Top Cities in Australia",
                navLinks: [
                    {
                        name: "Universities in Melbourne",
                        link: "/australia/universities-colleges-list/melbourne-aus-victoria-in-australia"
                    },
                    {
                        name: "Universities in Wollongong",
                        link: "/australia/universities-colleges-list/wollongong-new-south-wales-aus-in-australia"
                    },
                    {
                        name: "Universities in Canberra",
                        link: "/australia/universities-colleges-list/canberra-australian-capital-territory-in-australia"
                    },
                    {
                        name: "Universities in Adelaide",
                        link: "/australia/universities-colleges-list/adelaide-south-australia-in-australia"
                    }
                ]
            },
            {
                heading: "Top Courses in Australia",
                navLinks: [
                    {
                        name: "Masters in Australia",
                        link: "/australia/universities-colleges-list/masters-in-australia"
                    },
                    {
                        name: "Masters in Business Analytics in Australia",
                        link: "/australia/universities-colleges-list/masters-in-business-analytics-in-australia"
                    },
                    {
                        name: "Masters in Public Health in Australia",
                        link: "/australia/universities-colleges-list/masters-in-public-health-in-australia"
                    }
                ]
            },
            {
                heading: "Top Universities in Australia",
                navLinks: [
                    {
                        name: "Deakin University",
                        link: "/australia/university-details/deakin-university"
                    },
                    {
                        name: "Monash University",
                        link: "/australia/university-details/monash-university"
                    },
                    {
                        name: "RMIT University",
                        link: "/australia/university-details/rmit-university"
                    },
                    {
                        name: "Carnegie Mellon University",
                        link: "/australia/university-details/carnegie-mellon-university-australia"
                    },
                    {
                        name: "The University of Queensland",
                        link: "/australia/university-details/university-of-queensland"
                    }
                ]
            }
        ]
    },
    germany: {
        uniqueId: "germany",
        tabName: "Germany",
        topHeading: "Study in Germany",
        topHeadingLink: "/germany",
        subNavs: null
    },
    france: {
        uniqueId: "france",
        tabName: "France",
        topHeading: "Study in France",
        topHeadingLink: "/france",
        subNavs: null
    },
    "new-zealand": {
        uniqueId: "new-zealand",
        tabName: "New Zealand",
        topHeading: "Study in New Zealand",
        topHeadingLink: "/new-zealand",
        subNavs: null
    },
    italy: {
        uniqueId: "italy",
        tabName: "Italy",
        topHeading: "Study in Italy",
        topHeadingLink: "/italy",
        subNavs: null
    }
};
var examNavData = {
    ielts: {
        uniqueId: "ielts",
        tabName: "IELTS",
        topHeading: "Free IELTS masterclass",
        topHeadingLink: "/exams/ielts/preparation-online",
        subNavs: [
            {
                heading: "Exam details",
                navLinks: [
                    {
                        name: "IELTS Overview",
                        link: "/exams/ielts/"
                    },
                    {
                        name: "IELTS Syllabus",
                        link: "/exams/ielts/syllabus-and-pattern"
                    },
                    {
                        name: "IELTS Types",
                        link: "/exams/ielts/types"
                    },
                    {
                        name: "IELTS Exam Fees",
                        link: "/exams/ielts/fees"
                    },
                    {
                        name: "IELTS Eligibility",
                        link: "/exams/ielts/eligibility"
                    },
                    {
                        name: "IELTS Dates",
                        link: "/exams/ielts/dates"
                    },
                    {
                        name: "IELTS Registration",
                        link: "/exams/ielts/registration"
                    },
                    {
                        name: "IELTS Coaching Centres",
                        link: "/exams/ielts/centre"
                    },
                    {
                        name: "IELTS Results",
                        link: "/exams/ielts/results"
                    },
                    {
                        name: "IELTS Slot Booking",
                        link: "/exams/ielts/slot-booking"
                    }
                ]
            },
            {
                heading: "Practice",
                navLinks: [
                    {
                        name: "Test",
                        link: "/exams/ielts/practice-test",
                        icon: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/speed_icon_xUV6R9Ivu.svg"
                    },
                    {
                        name: "Speaking",
                        link: "/exams/ielts/practice-test/speaking",
                        icon: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/chat_icon_QlTt4yG6WW.svg"
                    },
                    {
                        name: "Writing",
                        link: "/exams/ielts/practice-test/writing",
                        icon: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/note_icon_LBq7a_bks.svg"
                    },
                    {
                        name: "Reading",
                        link: "/exams/ielts/practice-test/reading",
                        icon: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/book_icon_1_wnYXOu1ElV.svg"
                    },
                    {
                        name: "Listening",
                        link: "/exams/ielts/practice-test/listening",
                        icon: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/headphone_icon_g243t3cUQ4.svg"
                    }
                ]
            }
        ]
    },
    duolingo: {
        uniqueId: "duolingo",
        tabName: "Duolingo",
        topHeading: null,
        topHeadingLink: null,
        subNavs: [
            {
                heading: "Exam Details",
                navLinks: [
                    {
                        name: "Duolingo Overview",
                        link: "/exams/duolingo"
                    },
                    {
                        name: "Duolingo Syllabus",
                        link: "/exams/duolingo/pattern-and-syllabus"
                    },
                    {
                        name: "Duolingo Exam Fees",
                        link: "/exams/duolingo/fees"
                    },
                    {
                        name: "Duolingo Preparation",
                        link: "/exams/duolingo/how-to-prepare-for-duolingo-english-test"
                    },
                    {
                        name: "Duolingo Sample Questions",
                        link: "/exams/duolingo/sample-questions-and-answers"
                    }
                ]
            },
            {
                heading: "Duolingo Accepted Countries",
                navLinks: [
                    {
                        name: "Australia",
                        link: "/blog/duolingo-accepted-universities-in-australia/"
                    },
                    {
                        name: "Canada",
                        link: "/blog/duolingo-accepted-universities-in-canada/"
                    },
                    {
                        name: "Germany",
                        link: "/blog/duolingo-accepted-universities-in-germany/"
                    },
                    {
                        name: "Ireland",
                        link: "/blog/duolingo-accepted-universities-in-ireland/"
                    },
                    {
                        name: "UK",
                        link: "/blog/duolingo-accepted-universities-in-uk/"
                    }
                ]
            }
        ]
    },
    sat: {
        uniqueId: "sat",
        tabName: "SAT",
        topHeading: null,
        topHeadingLink: null,
        subNavs: [
            {
                heading: "Exam details",
                navLinks: [
                    {
                        name: "SAT Overview",
                        link: "/exams/sat"
                    },
                    {
                        name: "SAT Syllabus",
                        link: "/exams/sat/syllabus"
                    },
                    {
                        name: "SAT Exam Fees",
                        link: "/exams/sat/fees"
                    },
                    {
                        name: "SAT Eligibility",
                        link: "/exams/sat/eligibility"
                    },
                    {
                        name: "SAT Dates",
                        link: "/exams/sat/dates"
                    },
                    {
                        name: "SAT Registration",
                        link: "/exams/sat/registration"
                    },
                    {
                        name: "SAT Centres",
                        link: "/exams/sat/centre"
                    },
                    {
                        name: "SAT Results",
                        link: "/exams/sat/results"
                    },
                    {
                        name: "SAT Preparation",
                        link: "/exams/sat/preparation"
                    },
                    {
                        name: "SAT Practice Test",
                        link: "/exams/sat/practice-test"
                    },
                    {
                        name: "SAT Blogs",
                        link: "/blog/category/sat/"
                    }
                ]
            }
        ]
    },
    pte: {
        uniqueId: "pte",
        tabName: "PTE",
        topHeading: null,
        topHeadingLink: null,
        subNavs: [
            {
                heading: "Exam details",
                navLinks: [
                    {
                        name: "PTE Overview",
                        link: "/exams/pte"
                    },
                    {
                        name: "PTE Syllabus",
                        link: "/exams/pte/syllabus"
                    },
                    {
                        name: "PTE Exam Fees",
                        link: "/exams/pte/fees"
                    },
                    {
                        name: "PTE Dates",
                        link: "/exams/pte/dates"
                    },
                    {
                        name: "PTE Registration",
                        link: "/exams/pte/registration"
                    },
                    {
                        name: "PTE Centres",
                        link: "/exams/pte/centre"
                    },
                    {
                        name: "PTE Results",
                        link: "/exams/pte/results"
                    },
                    {
                        name: "PTE Slot Booking",
                        link: "/exams/pte/slot-booking"
                    },
                    {
                        name: "PTE Preparation",
                        link: "/exams/pte/preparation"
                    }
                ]
            },
            {
                heading: "Practice",
                navLinks: [
                    {
                        name: "PTE Test",
                        link: "/exams/pte/practice-test",
                        icon: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/speed_icon_xUV6R9Ivu.svg"
                    },
                    {
                        name: "Listening",
                        link: "/exams/pte/practice-test/listening",
                        icon: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/headphone_icon_g243t3cUQ4.svg"
                    },
                    {
                        name: "Reading",
                        link: "/exams/pte/practice-test/reading",
                        icon: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/book_icon_1_wnYXOu1ElV.svg"
                    },
                    {
                        name: "Speaking & Writing",
                        link: "/exams/pte/practice-test/speaking-writing",
                        icon: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/note_icon_LBq7a_bks.svg"
                    }
                ]
            }
        ]
    },
    toefl: {
        uniqueId: "toefl",
        tabName: "TOEFL",
        topHeading: null,
        topHeadingLink: null,
        subNavs: [
            {
                heading: "Exam details",
                navLinks: [
                    {
                        name: "TOEFL Overview",
                        link: "/exams/toefl"
                    },
                    {
                        name: "TOEFL Syllabus",
                        link: "/exams/toefl/syllabus"
                    },
                    {
                        name: "TOEFL Fees",
                        link: "/exams/toefl/fees"
                    },
                    {
                        name: "TOEFL Dates",
                        link: "/exams/toefl/dates"
                    },
                    {
                        name: "TOEFL Registration",
                        link: "/exams/toefl/registration"
                    },
                    {
                        name: "TOEFL Results",
                        link: "/exams/toefl/results"
                    },
                    {
                        name: "TOEFL Preparation",
                        link: "/exams/toefl/preparation"
                    }
                ]
            },
            {
                heading: "Practice",
                navLinks: [
                    {
                        name: "TOEFL Test",
                        link: "/exams/toefl/practice-test",
                        icon: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/speed_icon_xUV6R9Ivu.svg"
                    },
                    {
                        name: "Speaking",
                        link: "/exams/toefl/practice-test/speaking",
                        icon: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/chat_icon_QlTt4yG6WW.svg"
                    },
                    {
                        name: "Writing",
                        link: "/exams/toefl/practice-test/writing",
                        icon: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/note_icon_LBq7a_bks.svg"
                    },
                    {
                        name: "Reading",
                        link: "/exams/toefl/practice-test/reading",
                        icon: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/book_icon_1_wnYXOu1ElV.svg"
                    },
                    {
                        name: "Listening",
                        link: "/exams/toefl/practice-test/listening",
                        icon: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/headphone_icon_g243t3cUQ4.svg"
                    }
                ]
            }
        ]
    },
    gre: {
        uniqueId: "gre",
        tabName: "GRE",
        topHeading: null,
        topHeadingLink: null,
        subNavs: [
            {
                heading: "Exam details",
                navLinks: [
                    {
                        name: "GRE Overview",
                        link: "/exams/gre"
                    },
                    {
                        name: "GRE Syllabus",
                        link: "/exams/gre/syllabus"
                    },
                    {
                        name: "GRE Exam Fees",
                        link: "/exams/gre/fees"
                    },
                    {
                        name: "GRE Dates",
                        link: "/exams/gre/dates"
                    },
                    {
                        name: "GRE Registration",
                        link: "/exams/gre/registration"
                    },
                    {
                        name: "GRE Results",
                        link: "/exams/gre/results"
                    },
                    {
                        name: "GRE Slot Booking",
                        link: "/exams/gre/slot-booking"
                    },
                    {
                        name: "GRE Preparation",
                        link: "/exams/gre/preparation"
                    },
                    {
                        name: "GRE Practice test",
                        link: "/exams/gre/practice-test"
                    }
                ]
            }
        ]
    },
    gmat: {
        uniqueId: "gmat",
        tabName: "GMAT",
        topHeading: null,
        topHeadingLink: null,
        subNavs: [
            {
                heading: "Exam details",
                navLinks: [
                    {
                        name: "GMAT Overview",
                        link: "/exams/gmat"
                    },
                    {
                        name: "GMAT Syllabus",
                        link: "/exams/gmat/syllabus"
                    },
                    {
                        name: "GMAT Exam Fees",
                        link: "/exams/gmat/fees"
                    },
                    {
                        name: "GMAT Dates",
                        link: "/exams/gmat/dates"
                    },
                    {
                        name: "GMAT Registration",
                        link: "/exams/gmat/registration"
                    },
                    {
                        name: "GMAT Results",
                        link: "/exams/gmat/results"
                    },
                    {
                        name: "GMAT Preparation",
                        link: "/exams/gmat/preparation"
                    },
                    {
                        name: "GMAT Sample papers",
                        link: "/exams/gmat/sample-paper"
                    }
                ]
            }
        ]
    }
};
var resourcesNavData = {
    uniqueId: "resources",
    tabName: "Resources",
    topHeading: null,
    topHeadingLink: null,
    subNavs: [
        {
            heading: "Books",
            navLinks: [
                {
                    name: "IELTS Books",
                    link: "/exams/ielts/books"
                },
                {
                    name: "SAT Books",
                    link: "/exams/sat/books"
                },
                {
                    name: "PTE Books",
                    link: "/exams/pte/books"
                },
                {
                    name: "TOEFL Books",
                    link: "/exams/toefl/books"
                },
                {
                    name: "GRE Books",
                    link: "/exams/gre/books"
                },
                {
                    name: "GMAT Books",
                    link: "/exams/gmat/books"
                }
            ]
        },
        {
            heading: "LOR",
            navLinks: [
                {
                    name: "LOR Blog",
                    link: "/blog/letter-of-recommendation/"
                },
                {
                    name: "LOR for Masters",
                    link: "/blog/lor-letter-of-recommendation-for-masters-sample-format/"
                },
                {
                    name: "LOR for PhD",
                    link: "/blog/letter-of-recommendation-for-phd-sample-examples-and-pdf/"
                }
            ]
        },
        {
            heading: "SOP",
            navLinks: [
                {
                    name: "SOP Blog",
                    link: "/blog/sop-meaning-and-format/"
                },
                {
                    name: "SOP for Masters",
                    link: "/blog/sop-statement-of-purpose-for-masters-samples/"
                },
                {
                    name: "SOP for MBA",
                    link: "/blog/statement-of-purpose-for-mba-with-sample/"
                },
                {
                    name: "SOP for PhD",
                    link: "/blog/sop-statement-of-purpose-for-phd-and-sample/"
                }
            ]
        },
        {
            heading: "Other",
            navLinks: [
                {
                    name: "Counsellors",
                    link: "/counsellors"
                }
            ]
        }
    ]
}; //# sourceMappingURL=constant.js.map

;// CONCATENATED MODULE: ./node_modules/@leapfinance/frontend-commons/components/LeapScholar/Navbar/NewHeader/Desktop/MainNavButton.js

var MainNavButton = function MainNavButton(_a) {
    var firstLevelNavList = _a.firstLevelNavList, activeModal = _a.activeModal, handleModalVisibility = _a.handleModalVisibility;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, firstLevelNavList === null || firstLevelNavList === void 0 ? void 0 : firstLevelNavList.map(function(item) {
        if ((item === null || item === void 0 ? void 0 : item.type) === "modal") {
            return /*#__PURE__*/ react.createElement("div", {
                key: item === null || item === void 0 ? void 0 : item.uniqueId,
                className: "lfc-h-full lfc-flex lfc-items-center lfc-relative lfc-group",
                onMouseEnter: function onMouseEnter() {
                    handleModalVisibility("enter", item === null || item === void 0 ? void 0 : item.uniqueId);
                },
                onMouseLeave: function onMouseLeave() {
                    handleModalVisibility("leave", item === null || item === void 0 ? void 0 : item.uniqueId);
                }
            }, /*#__PURE__*/ react.createElement("p", {
                className: "lfc-relative lfc-px-1 lfc-flex lfc-items-center  lfc-font-medium lfc-cursor-pointer group-hover:lfc-text-[#4A47FF] lfc-whitespace-nowrap ".concat(activeModal === (item === null || item === void 0 ? void 0 : item.uniqueId) ? "lfc-text-[#4A47FF]" : "lfc-text-[#2E2C57]")
            }, item === null || item === void 0 ? void 0 : item.name, /*#__PURE__*/ react.createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "currentColor",
                className: "lfc-w-6 lfc-h-6"
            }, /*#__PURE__*/ react.createElement("path", {
                d: "M12.001 16.174C11.8677 16.174 11.7427 16.1532 11.626 16.1115C11.5094 16.0699 11.401 15.999 11.301 15.899L6.70103 11.299C6.51769 11.1157 6.42603 10.8824 6.42603 10.599C6.42603 10.3157 6.51769 10.0824 6.70103 9.89902C6.88436 9.71569 7.11769 9.62402 7.40103 9.62402C7.68436 9.62402 7.91769 9.71569 8.10103 9.89902L12.001 13.799L15.901 9.89902C16.0844 9.71569 16.3177 9.62402 16.601 9.62402C16.8844 9.62402 17.1177 9.71569 17.301 9.89902C17.4844 10.0824 17.576 10.3157 17.576 10.599C17.576 10.8824 17.4844 11.1157 17.301 11.299L12.701 15.899C12.601 15.999 12.4927 16.0699 12.376 16.1115C12.2594 16.1532 12.1344 16.174 12.001 16.174Z"
            }))), /*#__PURE__*/ react.createElement("div", {
                className: "lfc-absolute lfc-bg-[#4A47FF] lfc-w-full lfc-h-[4px] lfc-bottom-0 lfc-left-0 lfc-right-0 lfc-rounded-t-md group-hover:lfc-block ".concat(activeModal === (item === null || item === void 0 ? void 0 : item.uniqueId) ? "lfc-block" : "lfc-hidden")
            }));
        } else {
            return /*#__PURE__*/ react.createElement("a", {
                key: item === null || item === void 0 ? void 0 : item.uniqueId,
                className: "lfc-text-[#2E2C57] lfc-font-medium lfc-cursor-pointer hover:lfc-text-[#4A47FF] lfc-whitespace-nowrap",
                href: item === null || item === void 0 ? void 0 : item.link
            }, item === null || item === void 0 ? void 0 : item.name);
        }
    }));
};
/* harmony default export */ var Desktop_MainNavButton = (MainNavButton); //# sourceMappingURL=MainNavButton.js.map

;// CONCATENATED MODULE: ./node_modules/@leapfinance/frontend-commons/components/LeapScholar/Navbar/NewHeader/Components/NavListComponent.js

var NavListComponent = function NavListComponent(_a) {
    var _b, _c;
    var thirdLevelNavData = _a.thirdLevelNavData, customStyle = _a.customStyle;
    return /*#__PURE__*/ react.createElement("div", {
        className: customStyle || ""
    }, /*#__PURE__*/ react.createElement("p", {
        className: "lfc-mb-6 lfc-font-semibold md:lfc-px-4 lfc-text-[#2E2C57] lfc-cursor-default"
    }, thirdLevelNavData === null || thirdLevelNavData === void 0 ? void 0 : thirdLevelNavData.heading.toUpperCase()), /*#__PURE__*/ react.createElement("hr", {
        className: "!lfc-bg-[#E2E2E8] !lfc-border-[#E2E2E8] lfc-mb-2 md:lfc-mb-3 md:lfc-mx-4"
    }), /*#__PURE__*/ react.createElement("nav", null, /*#__PURE__*/ react.createElement("ul", {
        className: "lfc-list-none ".concat(((_b = thirdLevelNavData === null || thirdLevelNavData === void 0 ? void 0 : thirdLevelNavData.navLinks) === null || _b === void 0 ? void 0 : _b.length) > 5 ? "md:lfc-grid md:lfc-grid-cols-2 md:lfc-grid-rows-5" : "", " ")
    }, (_c = thirdLevelNavData === null || thirdLevelNavData === void 0 ? void 0 : thirdLevelNavData.navLinks) === null || _c === void 0 ? void 0 : _c.map(function(elem, index) {
        return /*#__PURE__*/ react.createElement("li", {
            key: "".concat(elem === null || elem === void 0 ? void 0 : elem.name, "_").concat(index),
            className: "lfc-py-4 md:lfc-py-3 md:lfc-px-4 lfc-list-none lfc-ml-0"
        }, /*#__PURE__*/ react.createElement("a", {
            className: "lfc-text-[#2E2C57] lfc-flex lfc-gap-3 lfc-items-center hover:lfc-underline",
            href: (elem === null || elem === void 0 ? void 0 : elem.link) || ""
        }, (elem === null || elem === void 0 ? void 0 : elem.icon) && /*#__PURE__*/ react.createElement("img", {
            width: 16,
            height: 16,
            src: elem === null || elem === void 0 ? void 0 : elem.icon,
            alt: elem.name
        }), elem === null || elem === void 0 ? void 0 : elem.name));
    }))));
};
/* harmony default export */ var Components_NavListComponent = (NavListComponent); //# sourceMappingURL=NavListComponent.js.map

;// CONCATENATED MODULE: ./node_modules/@leapfinance/frontend-commons/components/LeapScholar/Navbar/NewHeader/Desktop/SubMenuModal.js
var SubMenuModal_read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};


var SubMenuModal = function SubMenuModal(_a) {
    var _b, _c, _d, _e;
    var modalKey = _a.modalKey, isModalOpen = _a.isModalOpen, handleModalVisibility = _a.handleModalVisibility, secondLevelNavData = _a.secondLevelNavData;
    var _f = SubMenuModal_read((0,react.useState)((_b = secondLevelNavData[Object.keys(secondLevelNavData)[0]]) === null || _b === void 0 ? void 0 : _b.uniqueId), 2), activeTab = _f[0], setActiveTab = _f[1];
    var isOnlyOneTab = ((_c = Object.keys(secondLevelNavData)) === null || _c === void 0 ? void 0 : _c.length) === 1;
    return /*#__PURE__*/ react.createElement("div", {
        onMouseEnter: function onMouseEnter() {
            handleModalVisibility("enter", modalKey);
        },
        onMouseLeave: function onMouseLeave() {
            handleModalVisibility("leave", modalKey);
        },
        className: "lfc-fixed lfc-z-[900] lfc-top-[60px] lfc-left-[10%] lfc-right-[10%] lfc-bg-white lfc-shadow-[0px_4px_6px_-2px_#10182808,0px_12px_16px_-4px_#10182814] lfc-rounded-b-2xl ".concat(isModalOpen ? "lfc-block" : "lfc-hidden")
    }, /*#__PURE__*/ react.createElement("div", {
        className: "lfc-w-full lfc-flex"
    }, !isOnlyOneTab && /*#__PURE__*/ react.createElement("div", {
        className: "lfc-min-w-[15%] lfc-max-w-[15%] lfc-border-r !lfc-border-[#EEEEF2] lfc-pb-4"
    }, (_d = Object.keys(secondLevelNavData)) === null || _d === void 0 ? void 0 : _d.map(function(elem) {
        var _$_a, _b, _c;
        return /*#__PURE__*/ react.createElement("button", {
            key: (_$_a = secondLevelNavData === null || secondLevelNavData === void 0 ? void 0 : secondLevelNavData[elem]) === null || _$_a === void 0 ? void 0 : _$_a.uniqueId,
            className: "country-button lfc-w-full lfc-flex lfc-items-center lfc-justify-between lfc-py-4 lfc-pl-8 lfc-pr-4  ".concat(activeTab === ((_b = secondLevelNavData === null || secondLevelNavData === void 0 ? void 0 : secondLevelNavData[elem]) === null || _b === void 0 ? void 0 : _b.uniqueId) ? "lfc-bg-[#4A47FF] lfc-text-white" : "hover:lfc-bg-[#F5F5F7]"),
            onClick: function onClick() {
                var _$_a;
                setActiveTab((_$_a = secondLevelNavData === null || secondLevelNavData === void 0 ? void 0 : secondLevelNavData[elem]) === null || _$_a === void 0 ? void 0 : _$_a.uniqueId);
            }
        }, /*#__PURE__*/ react.createElement("p", {
            className: "lfc-text-start lfc-flex-grow lfc-font-medium"
        }, (_c = secondLevelNavData[elem]) === null || _c === void 0 ? void 0 : _c.tabName), /*#__PURE__*/ react.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            viewBox: "0 0 16 16"
        }, /*#__PURE__*/ react.createElement("path", {
            id: "Vector",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.7931 7.85072C10.9737 8.03134 10.9737 8.32413 10.7931 8.50474L6.07785 13.22C5.89724 13.4006 5.60445 13.4006 5.42383 13.22L5.20578 13.002C5.02516 12.8214 5.02516 12.5285 5.20578 12.3479L9.37599 8.17773L5.20578 4.00752C5.02516 3.8269 5.02516 3.53411 5.20578 3.35349L5.42383 3.13544C5.60445 2.95482 5.89723 2.95482 6.07785 3.13544L10.7931 7.85072Z",
            fill: "#A5A4B6"
        })));
    })), /*#__PURE__*/ react.createElement("div", {
        className: "lfc-flex-grow lfc-min-w-[".concat(isOnlyOneTab ? "100%" : "85%", "] lfc-max-w-[").concat(isOnlyOneTab ? "100%" : "85%", "] lfc-p-8")
    }, (_e = Object.keys(secondLevelNavData)) === null || _e === void 0 ? void 0 : _e.map(function(elem, index) {
        var _$_a, _b, _c, _d, _e, _f, _g, _h, _j;
        return /*#__PURE__*/ react.createElement("div", {
            key: "".concat((_$_a = secondLevelNavData === null || secondLevelNavData === void 0 ? void 0 : secondLevelNavData[elem]) === null || _$_a === void 0 ? void 0 : _$_a.uniqueId, "_").concat(index),
            className: "lfc-w-full ".concat(activeTab === ((_b = secondLevelNavData === null || secondLevelNavData === void 0 ? void 0 : secondLevelNavData[elem]) === null || _b === void 0 ? void 0 : _b.uniqueId) ? "lfc-block" : "lfc-hidden")
        }, ((_c = secondLevelNavData === null || secondLevelNavData === void 0 ? void 0 : secondLevelNavData[elem]) === null || _c === void 0 ? void 0 : _c.topHeading) && /*#__PURE__*/ react.createElement("a", {
            href: ((_d = secondLevelNavData[elem]) === null || _d === void 0 ? void 0 : _d.topHeadingLink) || "",
            className: "lfc-text-2xl hover:lfc-underline lfc-flex lfc-gap-1 lfc-items-center lfc-text-[#2E2C57] lfc-px-4 lfc-mb-8"
        }, (_e = secondLevelNavData === null || secondLevelNavData === void 0 ? void 0 : secondLevelNavData[elem]) === null || _e === void 0 ? void 0 : _e.topHeading, /*#__PURE__*/ react.createElement("img", {
            src: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/arrow_forward_icon_dURtMdw-9v.svg",
            alt: "forward link",
            width: 24,
            height: 24
        })), /*#__PURE__*/ react.createElement("div", {
            className: "w-full lfc-grid lfc-grid-cols-".concat(((_g = (_f = secondLevelNavData === null || secondLevelNavData === void 0 ? void 0 : secondLevelNavData[elem]) === null || _f === void 0 ? void 0 : _f.subNavs) === null || _g === void 0 ? void 0 : _g.length) || 1, " lfc-gap-5")
        }, (_j = (_h = secondLevelNavData === null || secondLevelNavData === void 0 ? void 0 : secondLevelNavData[elem]) === null || _h === void 0 ? void 0 : _h.subNavs) === null || _j === void 0 ? void 0 : _j.map(function(elem, index) {
            return /*#__PURE__*/ react.createElement(Components_NavListComponent, {
                key: "".concat(elem === null || elem === void 0 ? void 0 : elem.uniqueId, "_").concat(index),
                thirdLevelNavData: elem
            });
        })));
    }))));
};
/* harmony default export */ var Desktop_SubMenuModal = (SubMenuModal); //# sourceMappingURL=SubMenuModal.js.map

;// CONCATENATED MODULE: ./node_modules/@leapfinance/frontend-commons/components/LeapScholar/Navbar/NewHeader/Desktop/index.js
var Desktop_read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};





var DesktopNavbar = function DesktopNavbar(_a) {
    var _b = _a.isFixedHeader, isFixedHeader = _b === void 0 ? true : _b, webHeaderWidth = _a.webHeaderWidth, loginFunction = _a.loginFunction;
    var _c = Desktop_read((0,react.useState)(null), 2), activeModal = _c[0], setActiveModal = _c[1];
    var timer = (0,react.useRef)(null);
    var handleModalVisibility = function handleModalVisibility(userAction, key) {
        if (timer.current) {
            clearTimeout(timer.current);
        }
        if (userAction === "enter") {
            if (activeModal !== key) {
                setActiveModal(key);
            }
        }
        if (userAction === "leave") {
            timer.current = setTimeout(function() {
                setActiveModal(null);
            }, 50);
        }
    };
    return /*#__PURE__*/ react.createElement("div", {
        id: "desktop_logged_out_navbar",
        className: "lfc-w-full lfc-h-desktopHeaderHeight lfc-overflow-hidden"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "".concat(isFixedHeader ? "lfc-fixed lfc-z-[800] lfc-top-0 lfc-left-0 lfc-right-0" : "", " lfc-bg-white lfc-border-b !lfc-border-[#E2E2E8] lfc-h-[60px] lfc-overflow-hidden")
    }, /*#__PURE__*/ react.createElement("div", {
        className: "lfc-w-full lfc-h-full lfc-m-auto lfc-flex lfc-justify-between lfc-items-center lfc-px-8 ".concat(webHeaderWidth ? "lfc-max-w-[".concat(webHeaderWidth, "px]") : "lfc-max-w-[1264px]")
    }, /*#__PURE__*/ react.createElement("div", {
        className: "lfc-flex lfc-h-8"
    }, /*#__PURE__*/ react.createElement("a", {
        href: "/"
    }, /*#__PURE__*/ react.createElement("img", {
        id: "leap_scholar_logo",
        src: "https://ik.imagekit.io/onsnhxjshmp/LeapScholar/new-header-logo_7i5sVUf9VF.svg",
        height: 32,
        width: 165,
        alt: "leap scholar logo",
        className: "lfc-cursor-pointer lfc-min-w-[165px] lfc-h-[32px]",
        loading: "eager"
    }))), /*#__PURE__*/ react.createElement("div", {
        className: "lfc-flex lfc-items-center lfc-h-full lfc-gap-6"
    }, /*#__PURE__*/ react.createElement(Desktop_MainNavButton, {
        firstLevelNavList: firstLevelNavList,
        activeModal: activeModal,
        handleModalVisibility: handleModalVisibility
    }), /*#__PURE__*/ react.createElement("div", {
        className: "lfc-min-w-[101px]"
    }, /*#__PURE__*/ react.createElement(Components_LoginModule, {
        loginFunction: loginFunction
    }))))), /*#__PURE__*/ react.createElement(Desktop_SubMenuModal, {
        modalKey: "countries",
        isModalOpen: activeModal === "countries",
        handleModalVisibility: handleModalVisibility,
        secondLevelNavData: countryNavData
    }), /*#__PURE__*/ react.createElement(Desktop_SubMenuModal, {
        modalKey: "exams",
        isModalOpen: activeModal === "exams",
        handleModalVisibility: handleModalVisibility,
        secondLevelNavData: examNavData
    }), /*#__PURE__*/ react.createElement(Desktop_SubMenuModal, {
        modalKey: "resources",
        isModalOpen: activeModal === "resources",
        handleModalVisibility: handleModalVisibility,
        secondLevelNavData: {
            resources: resourcesNavData
        }
    }));
};
/* harmony default export */ var Desktop = (DesktopNavbar); //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@leapfinance/frontend-commons/components/LeapScholar/Navbar/NewHeader/Mobile/MainNavButton.js
var MainNavButton_read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};



var MainNavButton_MainNavButton = function MainNavButton(_a) {
    var firstLevelNavList = _a.firstLevelNavList, setSelectedKey = _a.setSelectedKey;
    var _b = MainNavButton_read((0,react.useState)(null), 2), selectedDropdownKey = _b[0], setSelectedDropdownKey = _b[1];
    return /*#__PURE__*/ react.createElement("div", {
        className: "lfc-flex-grow lfc-overflow-y-scroll"
    }, firstLevelNavList === null || firstLevelNavList === void 0 ? void 0 : firstLevelNavList.map(function(elem) {
        var _$_a, _b, _c;
        return (elem === null || elem === void 0 ? void 0 : elem.type) === "modal" ? /*#__PURE__*/ react.createElement("div", {
            key: elem === null || elem === void 0 ? void 0 : elem.uniqueId,
            className: "lfc-group lfc-border-b lfc-border-[#E2E2E8] lfc-bg-white lfc-overflow-hidden",
            onClick: function onClick() {
                selectedDropdownKey === (elem === null || elem === void 0 ? void 0 : elem.uniqueId) ? setSelectedDropdownKey(null) : setSelectedDropdownKey(elem === null || elem === void 0 ? void 0 : elem.uniqueId);
            }
        }, /*#__PURE__*/ react.createElement("summary", {
            className: "lfc-px-4 lfc-py-5 lfc-flex lfc-items-center lfc-justify-between lfc-cursor-pointer"
        }, /*#__PURE__*/ react.createElement("div", {
            className: "lfc-flex lfc-items-center lfc-gap-3"
        }, /*#__PURE__*/ react.createElement("img", {
            src: elem === null || elem === void 0 ? void 0 : elem.icon,
            alt: elem.name
        }), /*#__PURE__*/ react.createElement("p", {
            className: "lfc-text-[#2E2C57] lfc-font-medium"
        }, elem.name)), /*#__PURE__*/ react.createElement("img", {
            src: "https://ik.imagekit.io/onsnhxjshmp/SEO_project/pillar-pages/down-arrow_SaPGQ1mcmn.svg",
            alt: "arrow",
            className: "lfc-transition lfc-duration-300 ".concat(selectedDropdownKey === (elem === null || elem === void 0 ? void 0 : elem.uniqueId) ? "lfc-rotate-180" : ""),
            height: "20",
            width: "20",
            loading: "lazy"
        })), /*#__PURE__*/ react.createElement("div", {
            className: "lfc-px-4 lfc-pb-4 ".concat(selectedDropdownKey === (elem === null || elem === void 0 ? void 0 : elem.uniqueId) ? "lfc-block" : "lfc-hidden")
        }, (elem === null || elem === void 0 ? void 0 : elem.uniqueId) === "countries" && ((_$_a = Object.keys(countryNavData)) === null || _$_a === void 0 ? void 0 : _$_a.map(function(elem, index) {
            var _$_a, _b;
            return /*#__PURE__*/ react.createElement("button", {
                key: "".concat((_$_a = countryNavData[elem]) === null || _$_a === void 0 ? void 0 : _$_a.uniqueId, "_").concat(index),
                onClick: function onClick() {
                    var _$_a;
                    setSelectedKey((_$_a = countryNavData[elem]) === null || _$_a === void 0 ? void 0 : _$_a.uniqueId);
                },
                className: "lfc-sub-menu-open-btn lfc-w-full lfc-py-4 lfc-flex lfc-items-center lfc-justify-between lfc-text-[#2E2C57] lfc-font-medium"
            }, (_b = countryNavData[elem]) === null || _b === void 0 ? void 0 : _b.tabName, /*#__PURE__*/ react.createElement("img", {
                src: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/right_arrow_icon_1p36w8dhw.svg",
                alt: "arrow",
                height: "20",
                width: "20",
                loading: "lazy"
            }));
        })), (elem === null || elem === void 0 ? void 0 : elem.uniqueId) === "exams" && ((_b = Object.keys(examNavData)) === null || _b === void 0 ? void 0 : _b.map(function(elem, index) {
            var _$_a, _b;
            return /*#__PURE__*/ react.createElement("button", {
                key: "".concat((_$_a = examNavData[elem]) === null || _$_a === void 0 ? void 0 : _$_a.uniqueId, "_").concat(index),
                onClick: function onClick() {
                    var _$_a;
                    setSelectedKey((_$_a = examNavData[elem]) === null || _$_a === void 0 ? void 0 : _$_a.uniqueId);
                },
                className: "lfc-sub-menu-open-btn lfc-w-full lfc-py-4 lfc-flex lfc-items-center lfc-justify-between lfc-text-[#2E2C57] lfc-font-medium"
            }, (_b = examNavData[elem]) === null || _b === void 0 ? void 0 : _b.tabName, /*#__PURE__*/ react.createElement("img", {
                src: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/right_arrow_icon_1p36w8dhw.svg",
                alt: "arrow",
                height: "20",
                width: "20",
                loading: "lazy"
            }));
        })), (elem === null || elem === void 0 ? void 0 : elem.uniqueId) === "resources" && /*#__PURE__*/ react.createElement("div", {
            className: "lfc-flex lfc-flex-col lfc-gap-8 lfc-pt-4"
        }, (_c = resourcesNavData === null || resourcesNavData === void 0 ? void 0 : resourcesNavData.subNavs) === null || _c === void 0 ? void 0 : _c.map(function(elem, index) {
            return /*#__PURE__*/ react.createElement(Components_NavListComponent, {
                key: "".concat(elem === null || elem === void 0 ? void 0 : elem.uniqueId, "_").concat(index),
                thirdLevelNavData: elem
            });
        })))) : /*#__PURE__*/ react.createElement("a", {
            key: elem === null || elem === void 0 ? void 0 : elem.uniqueId,
            className: "lfc-px-4 lfc-py-5 lfc-border-b lfc-border-[#E2E2E8] lfc-flex lfc-items-center lfc-gap-3 lfc-text-[#2E2C57] lfc-font-medium",
            href: elem === null || elem === void 0 ? void 0 : elem.link
        }, /*#__PURE__*/ react.createElement("img", {
            src: elem === null || elem === void 0 ? void 0 : elem.icon,
            alt: elem === null || elem === void 0 ? void 0 : elem.name
        }), elem === null || elem === void 0 ? void 0 : elem.name);
    }));
};
/* harmony default export */ var Mobile_MainNavButton = (MainNavButton_MainNavButton); //# sourceMappingURL=MainNavButton.js.map

;// CONCATENATED MODULE: ./node_modules/@leapfinance/frontend-commons/components/LeapScholar/Navbar/NewHeader/Mobile/SubNavModal.js


var SubNavModal = function SubNavModal(_a) {
    var _b;
    var isSubModalOpen = _a.isSubModalOpen, currentKey = _a.currentKey, secondLevelNavData = _a.secondLevelNavData, setSelectedKey = _a.setSelectedKey;
    return /*#__PURE__*/ react.createElement("div", {
        className: "lfc-fixed lfc-z-[900] lfc-top-[60px] lfc-left-0 lfc-right-0 lfc-bottom-0 lfc-bg-white ".concat(!isSubModalOpen ? "lfc-hidden" : "lfc-block")
    }, /*#__PURE__*/ react.createElement("div", {
        className: "lfc-w-full lfc-h-full lfc-flex lfc-flex-col"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "lfc-px-4 lfc-py-3 lfc-border-b lfc-border-[#E2E2E8]"
    }, /*#__PURE__*/ react.createElement("button", {
        className: "lfc-sub_menu_back_button lfc-flex lfc-gap-1 lfc-items-center",
        onClick: function onClick() {
            setSelectedKey(null);
        }
    }, /*#__PURE__*/ react.createElement("img", {
        src: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/left_icon_Iu0eU2-GZ.svg",
        alt: "arrow",
        height: "20",
        width: "20",
        loading: "lazy"
    }), /*#__PURE__*/ react.createElement("p", {
        className: "text-[#2E2C57] font-medium"
    }, "Back"))), /*#__PURE__*/ react.createElement("div", {
        className: "lfc-flex-grow lfc-py-5 lfc-px-4 lfc-overflow-scroll"
    }, (secondLevelNavData === null || secondLevelNavData === void 0 ? void 0 : secondLevelNavData.topHeadingLink) && /*#__PURE__*/ react.createElement("div", {
        className: "lfc-py-3 lfc-mb-10"
    }, /*#__PURE__*/ react.createElement("a", {
        className: "lfc-text-2xl lfc-text-[#2E2C57] lfc-font-medium lfc-flex lfc-gap-1 lfc-items-center",
        href: secondLevelNavData === null || secondLevelNavData === void 0 ? void 0 : secondLevelNavData.topHeadingLink
    }, secondLevelNavData === null || secondLevelNavData === void 0 ? void 0 : secondLevelNavData.topHeading, /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ react.createElement("g", {
        id: "arrow_forward"
    }, /*#__PURE__*/ react.createElement("mask", {
        id: "mask0_10_6412",
        style: {
            maskType: "alpha"
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "24",
        height: "24"
    }, /*#__PURE__*/ react.createElement("rect", {
        id: "Bounding box",
        width: "24",
        height: "24",
        fill: "#D9D9D9"
    })), /*#__PURE__*/ react.createElement("g", {
        mask: "url(#mask0_10_6412)"
    }, /*#__PURE__*/ react.createElement("path", {
        id: "arrow_forward_2",
        d: "M16.1757 12.9991H5.00073C4.7174 12.9991 4.4799 12.9033 4.28823 12.7116C4.09657 12.52 4.00073 12.2825 4.00073 11.9991C4.00073 11.7158 4.09657 11.4783 4.28823 11.2866C4.4799 11.095 4.7174 10.9991 5.00073 10.9991H16.1757L11.2757 6.09913C11.0757 5.89913 10.9799 5.6658 10.9882 5.39913C10.9966 5.13247 11.1007 4.89913 11.3007 4.69913C11.5007 4.5158 11.7341 4.41997 12.0007 4.41163C12.2674 4.4033 12.5007 4.49913 12.7007 4.69913L19.3007 11.2991C19.4007 11.3991 19.4716 11.5075 19.5132 11.6241C19.5549 11.7408 19.5757 11.8658 19.5757 11.9991C19.5757 12.1325 19.5549 12.2575 19.5132 12.3741C19.4716 12.4908 19.4007 12.5991 19.3007 12.6991L12.7007 19.2991C12.5174 19.4825 12.2882 19.5741 12.0132 19.5741C11.7382 19.5741 11.5007 19.4825 11.3007 19.2991C11.1007 19.0991 11.0007 18.8616 11.0007 18.5866C11.0007 18.3116 11.1007 18.0741 11.3007 17.8741L16.1757 12.9991Z",
        fill: "#2E2C57"
    })))))), /*#__PURE__*/ react.createElement("div", {
        className: "lfc-flex lfc-flex-col lfc-gap-8"
    }, (_b = secondLevelNavData === null || secondLevelNavData === void 0 ? void 0 : secondLevelNavData.subNavs) === null || _b === void 0 ? void 0 : _b.map(function(elem, index) {
        return /*#__PURE__*/ react.createElement(Components_NavListComponent, {
            key: "".concat(elem === null || elem === void 0 ? void 0 : elem.heading, "_").concat(index),
            thirdLevelNavData: elem
        });
    })))));
};
/* harmony default export */ var Mobile_SubNavModal = (SubNavModal); //# sourceMappingURL=SubNavModal.js.map

;// CONCATENATED MODULE: ./node_modules/@leapfinance/frontend-commons/components/LeapScholar/Navbar/NewHeader/Mobile/MainNavModal.js
var MainNavModal_read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};





var MainNavModal = function MainNavModal(_a) {
    var _b, _c;
    var isModalOpen = _a.isModalOpen, loginFunction = _a.loginFunction;
    var _d = MainNavModal_read((0,react.useState)(null), 2), selectedKey = _d[0], setSelectedKey = _d[1];
    return /*#__PURE__*/ react.createElement("div", {
        className: "!lfc-bg-white lfc-fixed lfc-z-[900] lfc-top-[60px] lfc-left-0 lfc-right-0 lfc-bottom-0 lfc-flex lfc-flex-col lfc-w-full ".concat(isModalOpen ? "lfc-block lfc-overflow-y-scroll" : "lfc-hidden")
    }, /*#__PURE__*/ react.createElement(Mobile_MainNavButton, {
        firstLevelNavList: firstLevelNavList,
        setSelectedKey: setSelectedKey
    }), /*#__PURE__*/ react.createElement("div", {
        className: "lfc-px-4 lfc-py-5"
    }, /*#__PURE__*/ react.createElement(Components_LoginModule, {
        loginFunction: loginFunction
    })), (_b = Object.keys(countryNavData)) === null || _b === void 0 ? void 0 : _b.map(function(elem, index) {
        var _$_a, _b, _c;
        return /*#__PURE__*/ react.createElement(Mobile_SubNavModal, {
            isSubModalOpen: selectedKey === ((_$_a = countryNavData[elem]) === null || _$_a === void 0 ? void 0 : _$_a.uniqueId),
            key: "".concat((_b = countryNavData[elem]) === null || _b === void 0 ? void 0 : _b.uniqueId, "_").concat(index),
            currentKey: "".concat((_c = countryNavData[elem]) === null || _c === void 0 ? void 0 : _c.uniqueId),
            secondLevelNavData: countryNavData[elem],
            setSelectedKey: setSelectedKey
        });
    }), (_c = Object.keys(examNavData)) === null || _c === void 0 ? void 0 : _c.map(function(elem, index) {
        var _$_a, _b, _c;
        return /*#__PURE__*/ react.createElement(Mobile_SubNavModal, {
            isSubModalOpen: selectedKey === ((_$_a = examNavData[elem]) === null || _$_a === void 0 ? void 0 : _$_a.uniqueId),
            key: "".concat((_b = examNavData[elem]) === null || _b === void 0 ? void 0 : _b.uniqueId, "_").concat(index),
            currentKey: "".concat((_c = examNavData[elem]) === null || _c === void 0 ? void 0 : _c.uniqueId),
            secondLevelNavData: examNavData[elem],
            setSelectedKey: setSelectedKey
        });
    }));
};
/* harmony default export */ var Mobile_MainNavModal = (MainNavModal); //# sourceMappingURL=MainNavModal.js.map

;// CONCATENATED MODULE: ./node_modules/@leapfinance/frontend-commons/components/LeapScholar/Navbar/NewHeader/Mobile/index.js
var Mobile_read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};


var MobileNavbar = function MobileNavbar(_a) {
    var _b = _a.isFixedHeader, isFixedHeader = _b === void 0 ? true : _b, loginFunction = _a.loginFunction;
    var _c = Mobile_read((0,react.useState)(false), 2), isMainNavModalOpen = _c[0], setIsMainNavModalOpen = _c[1];
    (0,react.useEffect)(function() {
        var _$_a;
        if ((_$_a = document === null || document === void 0 ? void 0 : document.body) === null || _$_a === void 0 ? void 0 : _$_a.style) {
            if (isMainNavModalOpen) {
                document.body.style.overflow = "hidden";
            } else {
                document.body.style.overflow = "auto";
            }
        }
    }, [
        isMainNavModalOpen
    ]);
    return /*#__PURE__*/ react.createElement("div", {
        id: "mobile_logged_out_navbar",
        className: "lfc-h-mobileHeaderHeight lfc-w-full"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "".concat(isFixedHeader ? "lfc-fixed lfc-z-[900] lfc-top-0 lfc-left-0 lfc-right-0" : "", " lfc-bg-white lfc-border-b !lfc-border-[#E2E2E8] lfc-h-[60px] lfc-w-full")
    }, /*#__PURE__*/ react.createElement("div", {
        className: "lfc-w-full lfc-h-[60px] lfc-flex lfc-gap-4 lfc-justify-between lfc-items-center"
    }, /*#__PURE__*/ react.createElement("a", {
        href: "/",
        className: "lfc-pl-4"
    }, /*#__PURE__*/ react.createElement("img", {
        id: "leap_scholar_logo",
        src: "https://ik.imagekit.io/onsnhxjshmp/LeapScholar/new-header-logo_7i5sVUf9VF.svg",
        height: 24,
        width: 124,
        alt: "leap scholar logo",
        className: "lfc-cursor-pointer lfc-w-[124px] lfc-h-[24px]",
        loading: "eager"
    })), /*#__PURE__*/ react.createElement("button", {
        id: "main_nav_button",
        className: "lfc-flex lfc-items-center lfc-p-4 lfc-cursor-pointer lfc-h-full lfc-w-[56px]",
        onClick: function onClick() {
            setIsMainNavModalOpen(!isMainNavModalOpen);
        }
    }, !isMainNavModalOpen ? /*#__PURE__*/ react.createElement("img", {
        id: "menu_icon_open",
        src: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/menu_icon_-qgZm0jLGe.svg",
        alt: "menu icon",
        width: 24,
        height: 24
    }) : /*#__PURE__*/ react.createElement("img", {
        id: "menu_icon_close",
        src: "https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/close_icon_rbXLrXbzg.svg",
        alt: "menu icon",
        width: 24,
        height: 24
    })))), /*#__PURE__*/ react.createElement(Mobile_MainNavModal, {
        isModalOpen: isMainNavModalOpen,
        loginFunction: loginFunction
    }));
};
/* harmony default export */ var Mobile = (MobileNavbar); //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@leapfinance/frontend-commons/utils/imagekitBasePath.js
var imageBasePath = "https://ik.imagekit.io/onsnhxjshmp"; //# sourceMappingURL=imagekitBasePath.js.map

;// CONCATENATED MODULE: ./node_modules/@leapfinance/frontend-commons/components/LeapScholar/Navbar/NavItems/NestedMenu.js

var NestedMenu_awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return _instanceof(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var NestedMenu_generator = undefined && undefined.__generator || function(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
};

var NestedMenu = function NestedMenu(_a) {
    var nestedSubmenu = _a.nestedSubmenu, handleSegmentEvents = _a.handleSegmentEvents;
    var handleNavClick = function handleNavClick(text, link, isTargetBlank, handleClick) {
        return NestedMenu_awaiter(void 0, void 0, void 0, function() {
            return NestedMenu_generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!handleClick) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            handleClick()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!handleSegmentEvents) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            handleSegmentEvents(text)
                        ];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        window.open(link, isTargetBlank ? "_blank" : "_self");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return /*#__PURE__*/ react.createElement("div", {
        className: "lfc-absolute lfc-right-[-216px] lfc-top-[-10px] lfc-bg-white lfc-min-w-[216px] lfc-py-3 lfc-shadow-md lfc-rounded-lg"
    }, nestedSubmenu.map(function(_a, index) {
        var link = _a.link, text = _a.text, isTargetBlank = _a.isTargetBlank, handleClick = _a.handleClick;
        return /*#__PURE__*/ react.createElement("button", {
            key: index,
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            onClick: function onClick() {
                return NestedMenu_awaiter(void 0, void 0, void 0, function() {
                    return NestedMenu_generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                return [
                                    4 /*yield*/ ,
                                    handleNavClick(text, link, isTargetBlank, handleClick)
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            },
            className: "lfc-flex lfc-flex-col lfc-gap-2 lfc-px-4 lfc-py-3 hover:lfc-bg-[#443EFF] lfc-text-black hover:lfc-text-white lfc-transition lfc-w-full"
        }, /*#__PURE__*/ react.createElement("p", {
            className: "lfc-text-sm "
        }, text));
    }));
};
/* harmony default export */ var NavItems_NestedMenu = (NestedMenu); //# sourceMappingURL=NestedMenu.js.map

;// CONCATENATED MODULE: ./node_modules/@leapfinance/frontend-commons/components/LeapScholar/Navbar/NavItems/SubMenu.js

var SubMenu_awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return _instanceof(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var SubMenu_generator = undefined && undefined.__generator || function(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
};
var SubMenu_read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};



var SubMenu = function SubMenu(_a) {
    var menu = _a.menu, isLastMenuItem = _a.isLastMenuItem, handleSegmentEvents = _a.handleSegmentEvents;
    var _b = SubMenu_read((0,react.useState)(""), 2), nestedMenuText = _b[0], setNestedMenuText = _b[1];
    var handleNavClick = function handleNavClick(text, link, isTargetBlank, handleClick) {
        return SubMenu_awaiter(void 0, void 0, void 0, function() {
            return SubMenu_generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!handleClick) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            handleClick()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!handleSegmentEvents) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            handleSegmentEvents(text)
                        ];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        window.open(link, isTargetBlank ? "_blank" : "_self");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return /*#__PURE__*/ react.createElement("div", {
        className: "lfc-absolute lfc-top-[50px] ".concat(isLastMenuItem ? "lfc-right-0" : "lfc-left-[-4px]", " lfc-bg-white lfc-min-w-[216px] lfc-py-3 lfc-shadow-md lfc-rounded-b-lg")
    }, /*#__PURE__*/ react.createElement("div", {
        className: "lfc-flex lfc-flex-col lfc-gap-2"
    }, menu.map(function(_a, index) {
        var nestedSubmenu = _a.nestedSubmenu, text = _a.text, link = _a.link, isTargetBlank = _a.isTargetBlank, contactInfo = _a.contactInfo, handleClick = _a.handleClick;
        return /*#__PURE__*/ react.createElement("div", {
            key: index
        }, nestedSubmenu ? /*#__PURE__*/ react.createElement("div", {
            onMouseOver: function onMouseOver() {
                setNestedMenuText(text);
            },
            className: "lfc-px-4 lfc-py-3 hover:lfc-bg-[#443EFF] hover:lfc-text-white lfc-transition lfc-relative lfc-w-full"
        }, /*#__PURE__*/ react.createElement("div", {
            className: "lfc-flex lfc-items-center lfc-justify-between lfc-gap-4"
        }, /*#__PURE__*/ react.createElement("p", {
            className: "lfc-text-sm"
        }, text), /*#__PURE__*/ react.createElement((image_default()), {
            className: "lfc-brightness-0 lfc--rotate-90",
            src: "https://ik.imagekit.io/onsnhxjshmp/SEO_project/pillar-pages/arrow-down-nav_RgHK4gTT3.svg",
            height: 20,
            width: 20,
            alt: "Open"
        })), nestedMenuText === text && /*#__PURE__*/ react.createElement(NavItems_NestedMenu, {
            nestedSubmenu: nestedSubmenu,
            isLastMenuItem: false,
            handleSegmentEvents: handleSegmentEvents
        })) : /*#__PURE__*/ react.createElement("div", {
            className: "lfc-flex lfc-flex-col lfc-gap-2"
        }, /*#__PURE__*/ react.createElement("button", {
            className: "lfc-text-sm lfc-px-4 lfc-py-3 hover:lfc-bg-[#443EFF] hover:lfc-text-white lfc-transition lfc-w-full lfc-text-left",
            onMouseOver: function onMouseOver() {
                setNestedMenuText(text);
            },
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            onClick: function onClick() {
                return SubMenu_awaiter(void 0, void 0, void 0, function() {
                    return SubMenu_generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                return [
                                    4 /*yield*/ ,
                                    handleNavClick(text, link, isTargetBlank, handleClick)
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }
        }, text), contactInfo ? /*#__PURE__*/ react.createElement(react.Fragment, null, contactInfo === null || contactInfo === void 0 ? void 0 : contactInfo.map(function(_a, index) {
            var icon = _a.icon, link = _a.link, title = _a.title, handleClick = _a.handleClick;
            return /*#__PURE__*/ react.createElement("div", {
                className: "lfc-flex lfc-items-center lfc-gap-1 lfc-text-sm lfc-ml-5 lfc-mb-2",
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                onClick: function onClick() {
                    return SubMenu_awaiter(void 0, void 0, void 0, function() {
                        return SubMenu_generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    if (!handleClick) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        handleClick()
                                    ];
                                case 1:
                                    _a.sent();
                                    _a.label = 2;
                                case 2:
                                    if (!handleSegmentEvents) return [
                                        3 /*break*/ ,
                                        4
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        handleSegmentEvents(title)
                                    ];
                                case 3:
                                    _a.sent();
                                    _a.label = 4;
                                case 4:
                                    window.open(link, isTargetBlank ? "_blank" : "_self");
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                },
                key: index
            }, /*#__PURE__*/ react.createElement((image_default()), {
                src: icon,
                height: 16,
                width: 16,
                alt: "Study abroad"
            }), title);
        })) : /*#__PURE__*/ react.createElement(react.Fragment, null)));
    })));
};
/* harmony default export */ var NavItems_SubMenu = (SubMenu); //# sourceMappingURL=SubMenu.js.map

;// CONCATENATED MODULE: ./node_modules/@leapfinance/frontend-commons/components/LeapScholar/Navbar/NavButtons/Button.js

var Button_awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return _instanceof(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var Button_generator = undefined && undefined.__generator || function(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
};
var Button_read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};



var Button = function Button(_a) {
    var buttonData = _a.buttonData, isLastMenuItem = _a.isLastMenuItem, handleSegmentEvents = _a.handleSegmentEvents;
    var buttonType = buttonData.buttonType, handleClick = buttonData.handleClick, title = buttonData.title, buttonSubMenu = buttonData.buttonSubMenu;
    var ref = (0,react.useRef)();
    var _b = Button_read((0,react.useState)(""), 2), subText = _b[0], setSubText = _b[1];
    (0,react.useEffect)(function() {
        var checkIfClickedOutside = function checkIfClickedOutside(e) {
            var _$_a;
            if ((_$_a = ref.current) === null || _$_a === void 0 ? void 0 : _$_a.contains(e.target)) {
                return;
            }
            setSubText("");
        };
        document.addEventListener("click", checkIfClickedOutside);
        return function() {
            document.removeEventListener("click", checkIfClickedOutside);
        };
    }, []);
    var handleNavClick = function handleNavClick(title, handleClick) {
        return Button_awaiter(void 0, void 0, void 0, function() {
            return Button_generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        setSubText(function(prev) {
                            return prev === title ? "" : title;
                        });
                        if (!handleClick) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            handleClick()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!!buttonSubMenu) return [
                            3 /*break*/ ,
                            4
                        ];
                        if (!handleSegmentEvents) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            handleSegmentEvents(title)
                        ];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return /*#__PURE__*/ react.createElement("div", {
        className: "lfc-relative lfc-flex lfc-justify-center lfc-py-[10px] lfc-px-3 lfc-w-full md:lfc-w-fit lfc-border lfc-border-[#443EFF] lfc-rounded lfc-cursor-pointer ".concat(buttonType === "PRIMARY" ? "lfc-bg-[#443EFF]" : "lfc-bg-white"),
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onClick: function onClick() {
            return Button_awaiter(void 0, void 0, void 0, function() {
                return Button_generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                handleNavClick(title, handleClick)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        },
        ref: ref
    }, /*#__PURE__*/ react.createElement("div", {
        className: "lfc-flex lfc-gap-2 lfc-items-center lfc-justify-between"
    }, title === "My Account" ? /*#__PURE__*/ react.createElement((image_default()), {
        src: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/account.svg",
        height: 20,
        width: 20,
        alt: "Account"
    }) : /*#__PURE__*/ react.createElement("p", {
        className: "lfc-text-sm lfc-font-semibold lfc-rounded ".concat(buttonType === "PRIMARY" ? "lfc-text-white " : "lfc-text-[#443EFF]")
    }, title), buttonSubMenu && /*#__PURE__*/ react.createElement((image_default()), {
        className: "".concat(subText === title && "rotate-180 transition-all"),
        src: buttonType === "PRIMARY" ? "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/dropdown-arrow-white.svg" : "https://ik.imagekit.io/onsnhxjshmp/SEO_project/pillar-pages/arrow-down-nav_RgHK4gTT3.svg",
        height: 20,
        width: 20,
        alt: "Open"
    })), subText === title && buttonSubMenu && /*#__PURE__*/ react.createElement(NavItems_SubMenu, {
        menu: buttonSubMenu,
        isLastMenuItem: isLastMenuItem,
        handleSegmentEvents: handleSegmentEvents
    }));
};
/* harmony default export */ var NavButtons_Button = (Button); //# sourceMappingURL=Button.js.map

;// CONCATENATED MODULE: ./node_modules/@leapfinance/frontend-commons/components/LeapScholar/Navbar/NavButtons/index.js


var NavButtons = function NavButtons(_a) {
    var navButtons = _a.navButtons, handleSegmentEvents = _a.handleSegmentEvents;
    return /*#__PURE__*/ react.createElement("div", {
        className: "lfc-flex lfc-items-center lfc-gap-4"
    }, navButtons.map(function(buttonData, index) {
        return /*#__PURE__*/ react.createElement(NavButtons_Button, {
            buttonData: buttonData,
            isLastMenuItem: (navButtons === null || navButtons === void 0 ? void 0 : navButtons.length) - 1 === index,
            key: index,
            handleSegmentEvents: handleSegmentEvents
        });
    }));
};
/* harmony default export */ var Navbar_NavButtons = (NavButtons); //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@leapfinance/frontend-commons/components/LeapScholar/Navbar/NavItems/index.js

var NavItems_awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return _instanceof(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var NavItems_generator = undefined && undefined.__generator || function(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
};
var NavItems_read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};



var NavItems = function NavItems(_a) {
    var navItem = _a.navItem, isLastMenuItem = _a.isLastMenuItem, handleSegmentEvents = _a.handleSegmentEvents, selectedTitle = _a.selectedTitle, isLoggedIn = _a.isLoggedIn;
    var subMenu = navItem.subMenu, link = navItem.link, title = navItem.title, handleClick = navItem.handleClick;
    var _b = NavItems_read((0,react.useState)(""), 2), subMenuText = _b[0], setSubMenuText = _b[1];
    var ref = (0,react.useRef)();
    var isSelected = title === selectedTitle && isLoggedIn;
    (0,react.useEffect)(function() {
        var checkIfClickedOutside = function checkIfClickedOutside(e) {
            var _$_a;
            if ((_$_a = ref.current) === null || _$_a === void 0 ? void 0 : _$_a.contains(e.target)) {
                return;
            }
            setSubMenuText("");
        };
        document.addEventListener("click", checkIfClickedOutside);
        return function() {
            document.removeEventListener("click", checkIfClickedOutside);
        };
    }, []);
    var handleNavClick = function handleNavClick(text, link, isTargetBlank, handleClick) {
        return NavItems_awaiter(void 0, void 0, void 0, function() {
            return NavItems_generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!handleClick) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            handleClick()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!handleSegmentEvents) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            handleSegmentEvents(text)
                        ];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        window.open(link, isTargetBlank ? "_blank" : "_self");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return /*#__PURE__*/ react.createElement("div", {
        onClick: function onClick() {
            setSubMenuText(function(prev) {
                return prev === title ? "" : title;
            });
        },
        ref: ref,
        className: "lfc-relative"
    }, subMenu ? /*#__PURE__*/ react.createElement("div", {
        className: "lfc-flex lfc-items-center lfc-gap-1 lfc-cursor-pointer lfc-relative"
    }, /*#__PURE__*/ react.createElement("p", {
        className: "lfc-font-bold lfc-text-[#443EFF] lfc-leading-6"
    }, title), /*#__PURE__*/ react.createElement((image_default()), {
        className: "".concat(subMenuText === title ? "lfc-rotate-180" : "lfc-rotate-0", " lfc-transition-all"),
        src: "https://ik.imagekit.io/onsnhxjshmp/SEO_project/pillar-pages/arrow-down-nav_RgHK4gTT3.svg",
        height: 20,
        width: 20,
        alt: "Open"
    }), subMenuText === title && /*#__PURE__*/ react.createElement(NavItems_SubMenu, {
        menu: subMenu,
        isLastMenuItem: isLastMenuItem,
        handleSegmentEvents: handleSegmentEvents
    })) : /*#__PURE__*/ react.createElement("button", {
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onClick: function onClick() {
            return NavItems_awaiter(void 0, void 0, void 0, function() {
                return NavItems_generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                handleNavClick(title, link, false, handleClick)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        },
        className: "lfc-leading-6 lfc-cursor-pointer lfc-font-bold lfc-relative ".concat(isLoggedIn ? "lfc-text-lg" : "", " ").concat(isSelected ? "lfc-text-[#443EFF]" : "")
    }, title, isSelected && /*#__PURE__*/ react.createElement("div", {
        className: "lfc-h-1 lfc-w-full lfc-bg-[#443EFF] lfc-absolute lfc-mt-5 md:lfc-mt-[22px]"
    })));
};
/* harmony default export */ var Navbar_NavItems = (NavItems); //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@leapfinance/frontend-commons/components/LeapScholar/Navbar/DesktopNavbar.js

var DesktopNavbar_awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return _instanceof(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var DesktopNavbar_generator = undefined && undefined.__generator || function(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
};




var DesktopNavbar_DesktopNavbar = function DesktopNavbar(_a) {
    var buttons = _a.buttons, isLoggedIn = _a.isLoggedIn, navData = _a.navData, handleSegmentEvents = _a.handleSegmentEvents, logoLink = _a.logoLink, selectedTitle = _a.selectedTitle;
    return /*#__PURE__*/ react.createElement("div", {
        id: "desktop_logged_in_navbar",
        className: "!lfc-h-[73px] !md:lfc-h-[75px] lfc-w-full"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "lfc-fixed lfc-z-[9000] !lfc-h-[73px] !md:lfc-h-[75px] lfc-left-0 lfc-right-0 lfc-top-0"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "lfc-bg-white lfc-border-b lfc-border-[#DBDBDB] lfc-shadow-[0px_4px_8px_0px_rgba(67,54,149,0.08)] lfc-p-4"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "lfc-max-w-[1200px] lfc-m-auto"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "lfc-flex lfc-justify-between lfc-items-center lfc-h-full ".concat(isLoggedIn ? "lfc-gap-6" : "lfc-gap-3")
    }, /*#__PURE__*/ react.createElement("div", {
        className: "lfc-flex lfc-min-h-[31px] lfc-min-w-[191px]"
    }, /*#__PURE__*/ react.createElement("img", {
        src: "".concat(imageBasePath, "/LeapScholar/new-header-logo_7i5sVUf9VF.svg"),
        height: 31,
        width: 197,
        alt: "leap-scholar-logo",
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onClick: function onClick() {
            return DesktopNavbar_awaiter(void 0, void 0, void 0, function() {
                return DesktopNavbar_generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!handleSegmentEvents) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                handleSegmentEvents("LS Logo")
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            window.open(logoLink, "_self");
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        },
        className: "lfc-cursor-pointer"
    })), /*#__PURE__*/ react.createElement("div", {
        className: "lfc-flex ".concat(isLoggedIn ? "lfc-justify-between" : "lfc-justify-end", " lfc-items-center lfc-gap-6 lfc-w-full")
    }, /*#__PURE__*/ react.createElement("div", {
        className: "lfc-flex lfc-items-center lfc-gap-6"
    }, navData.map(function(navItem, index) {
        return /*#__PURE__*/ react.createElement(Navbar_NavItems, {
            navItem: navItem,
            key: index,
            isLastMenuItem: (navData === null || navData === void 0 ? void 0 : navData.length) - 1 === index,
            isLoggedIn: isLoggedIn,
            handleSegmentEvents: handleSegmentEvents,
            selectedTitle: selectedTitle
        });
    })), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(Navbar_NavButtons, {
        navButtons: buttons,
        handleSegmentEvents: handleSegmentEvents
    }))))))));
};
/* harmony default export */ var Navbar_DesktopNavbar = (DesktopNavbar_DesktopNavbar); //# sourceMappingURL=DesktopNavbar.js.map

;// CONCATENATED MODULE: ./node_modules/@leapfinance/frontend-commons/components/LeapScholar/Navbar/MobNavItems/NestedNavMenuMob.js

var NestedNavMenuMob_awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return _instanceof(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var NestedNavMenuMob_generator = undefined && undefined.__generator || function(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
};


var NestedNavMenuMob = function NestedNavMenuMob(_a) {
    var nestedSubmenuArray = _a.nestedSubmenuArray, breadcrumb = _a.breadcrumb, setIsNestedMenuOpen = _a.setIsNestedMenuOpen, handleSegmentEvents = _a.handleSegmentEvents;
    var handleNavClick = function handleNavClick(text, link, isTargetBlank, handleClick) {
        return NestedNavMenuMob_awaiter(void 0, void 0, void 0, function() {
            return NestedNavMenuMob_generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!handleClick) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            handleClick()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!handleSegmentEvents) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            handleSegmentEvents(text)
                        ];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        window.open(link, isTargetBlank ? "_blank" : "_self");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return /*#__PURE__*/ react.createElement("div", {
        className: "lfc-w-full lfc-h-full lfc-fixed lfc-top-[65px] lfc-left-0 lfc-bg-[#E2E6FA] lfc-p-4 lfc-z-[900]"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "lfc-flex lfc-items-center lfc-gap-2 lfc-leading-5 lfc-text-sm lfc-font-semibold"
    }, /*#__PURE__*/ react.createElement("button", {
        onClick: function onClick() {
            setIsNestedMenuOpen(false);
        }
    }, /*#__PURE__*/ react.createElement((image_default()), {
        className: "lfc--rotate-[135deg] lfc-brightness-0",
        src: "https://ik.imagekit.io/onsnhxjshmp/SEO_project/pillar-pages/arrow-up-right_LFouZ5Mw8r.svg",
        height: 20,
        width: 20,
        alt: "Back"
    })), /*#__PURE__*/ react.createElement("p", {
        className: "lfc-text-[#77768E] lfc-text-sm lfc-font-medium"
    }, "IELTS Exam"), /*#__PURE__*/ react.createElement("span", null, "/"), /*#__PURE__*/ react.createElement("p", null, breadcrumb)), /*#__PURE__*/ react.createElement("div", {
        className: "lfc-mt-4 lfc-border lfc-border-[#E2E2E8] lfc-rounded-lg lfc-shadow-[0px_2px_4px_0px_rgba(16,24,40,0.12)] lfc-overflow-hidden"
    }, nestedSubmenuArray.map(function(_a, index) {
        var link = _a.link, text = _a.text, isTargetBlank = _a.isTargetBlank, handleClick = _a.handleClick;
        return /*#__PURE__*/ react.createElement("button", {
            key: index,
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            onClick: function onClick() {
                return NestedNavMenuMob_awaiter(void 0, void 0, void 0, function() {
                    return NestedNavMenuMob_generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                return [
                                    4 /*yield*/ ,
                                    handleNavClick(text, link, isTargetBlank, handleClick)
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            },
            className: "lfc-px-4 lfc-py-3 lfc-bg-white lfc-flex lfc-w-full lfc-items-center lfc-justify-between lfc-gap-2 lfc-border-b lfc-border-[#E2E2E8]"
        }, /*#__PURE__*/ react.createElement("p", null, text));
    })));
};
/* harmony default export */ var MobNavItems_NestedNavMenuMob = (NestedNavMenuMob); //# sourceMappingURL=NestedNavMenuMob.js.map

;// CONCATENATED MODULE: ./node_modules/@leapfinance/frontend-commons/components/LeapScholar/Navbar/MobNavItems/index.js

var MobNavItems_assign = undefined && undefined.__assign || function() {
    MobNavItems_assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return MobNavItems_assign.apply(this, arguments);
};
var MobNavItems_awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return _instanceof(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var MobNavItems_generator = undefined && undefined.__generator || function(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
};
var MobNavItems_read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};



var MobNavItems = function MobNavItems(_a) {
    var navItem = _a.navItem, handleSegmentEvents = _a.handleSegmentEvents;
    var subMenu = navItem.subMenu, link = navItem.link, title = navItem.title, icon = navItem.icon, handleClick = navItem.handleClick;
    var _b = MobNavItems_read((0,react.useState)(false), 2), isSubmenuOpen = _b[0], setIsSubmenuOpen = _b[1];
    var _c = MobNavItems_read((0,react.useState)(false), 2), isNestedMenuOpen = _c[0], setIsNestedMenuOpen = _c[1];
    var _d = MobNavItems_read((0,react.useState)(), 2), nestedmenuItems = _d[0], setNestedmenuItems = _d[1];
    var handleOpenSubmenu = function handleOpenSubmenu() {
        if (subMenu) setIsSubmenuOpen(function(prev) {
            return !prev;
        });
        else window.open(link, "_self");
    };
    var handleNestedMenuOpen = function handleNestedMenuOpen(isNestedMenu) {
        if (isNestedMenu) setIsNestedMenuOpen(function(prev) {
            return !prev;
        });
    };
    var handleNavClick = function handleNavClick(title, handleClick) {
        return MobNavItems_awaiter(void 0, void 0, void 0, function() {
            return MobNavItems_generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!subMenu) return [
                            3 /*break*/ ,
                            4
                        ];
                        if (!handleClick) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            handleClick()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!handleSegmentEvents) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            handleSegmentEvents(title)
                        ];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        handleOpenSubmenu();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return /*#__PURE__*/ react.createElement("div", {
        className: "lfc-flex lfc-flex-col lfc-p-4 lfc-border-b lfc-border-[#E2E2E8] ".concat(isSubmenuOpen ? "lfc-bg-[#E2E6FA] lfc-pb-6" : "lfc-bg-white")
    }, /*#__PURE__*/ react.createElement("button", {
        className: "lfc-flex lfc-items-center lfc-justify-between lfc-gap-2",
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onClick: function onClick() {
            return MobNavItems_awaiter(void 0, void 0, void 0, function() {
                return MobNavItems_generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                handleNavClick(title, handleClick)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }
    }, /*#__PURE__*/ react.createElement("div", {
        className: "lfc-flex lfc-items-center lfc-gap-2"
    }, /*#__PURE__*/ react.createElement((image_default()), {
        src: icon,
        height: 24,
        width: 24,
        alt: title,
        className: "lfc-brightness-0"
    }), /*#__PURE__*/ react.createElement("p", {
        className: "lfc-text-[#202020] lfc-font-semibold"
    }, title)), subMenu && /*#__PURE__*/ react.createElement((image_default()), {
        className: "lfc-brightness-0 ".concat(isSubmenuOpen && "lfc-rotate-180 lfc-transition-all"),
        src: "https://ik.imagekit.io/onsnhxjshmp/SEO_project/pillar-pages/arrow-down-nav_RgHK4gTT3.svg",
        height: 20,
        width: 20,
        alt: "Open"
    })), isSubmenuOpen && /*#__PURE__*/ react.createElement("div", {
        className: "lfc-mt-4 lfc-border lfc-border-[#E2E2E8] lfc-rounded-lg lfc-shadow-[0px_2px_4px_0px_rgba(16,24,40,0.12)] lfc-overflow-hidden"
    }, subMenu === null || subMenu === void 0 ? void 0 : subMenu.map(function(_a, index) {
        var text = _a.text, nestedSubmenu = _a.nestedSubmenu, breadcrumb = _a.breadcrumb, isTargetBlank = _a.isTargetBlank, link = _a.link, handleClick = _a.handleClick;
        return /*#__PURE__*/ react.createElement("button", {
            key: index,
            className: "lfc-px-4 lfc-py-3 lfc-bg-white lfc-flex lfc-items-center lfc-justify-between lfc-gap-2 lfc-border-b lfc-border-[#E2E2E8] lfc-w-full",
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            onClick: function onClick() {
                return MobNavItems_awaiter(void 0, void 0, void 0, function() {
                    return MobNavItems_generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!nestedSubmenu) return [
                                    3 /*break*/ ,
                                    1
                                ];
                                setNestedmenuItems({
                                    nestedSubmenuArray: nestedSubmenu,
                                    breadcrumb: breadcrumb
                                });
                                handleNestedMenuOpen(!!nestedSubmenu);
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 1:
                                if (!handleClick) return [
                                    3 /*break*/ ,
                                    3
                                ];
                                return [
                                    4 /*yield*/ ,
                                    handleClick()
                                ];
                            case 2:
                                _a.sent();
                                _a.label = 3;
                            case 3:
                                if (!handleSegmentEvents) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                return [
                                    4 /*yield*/ ,
                                    handleSegmentEvents(text)
                                ];
                            case 4:
                                _a.sent();
                                _a.label = 5;
                            case 5:
                                window.open(link, isTargetBlank ? "_blank" : "_self");
                                _a.label = 6;
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }
        }, /*#__PURE__*/ react.createElement("p", null, text), nestedSubmenu && /*#__PURE__*/ react.createElement((image_default()), {
            className: "lfc-brightness-0 lfc--rotate-90",
            src: "https://ik.imagekit.io/onsnhxjshmp/SEO_project/pillar-pages/arrow-down-nav_RgHK4gTT3.svg",
            height: 20,
            width: 20,
            alt: "Open"
        }));
    })), isNestedMenuOpen && (nestedmenuItems === null || nestedmenuItems === void 0 ? void 0 : nestedmenuItems.nestedSubmenuArray) && /*#__PURE__*/ react.createElement(MobNavItems_NestedNavMenuMob, MobNavItems_assign({}, nestedmenuItems, {
        setIsNestedMenuOpen: setIsNestedMenuOpen,
        handleSegmentEvents: handleSegmentEvents
    })));
};
/* harmony default export */ var Navbar_MobNavItems = (MobNavItems); //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@leapfinance/frontend-commons/components/LeapScholar/Navbar/MobNavbar.js

var MobNavbar_awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return _instanceof(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var MobNavbar_generator = undefined && undefined.__generator || function(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
};
var MobNavbar_read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};






var MobNavbar = function MobNavbar(_a) {
    var buttons = _a.buttons, isLoggedIn = _a.isLoggedIn, mobileNavData = _a.mobileNavData, navData = _a.navData, handleSegmentEvents = _a.handleSegmentEvents, logoLink = _a.logoLink, selectedTitle = _a.selectedTitle;
    var _b = MobNavbar_read((0,react.useState)(false), 2), isMenuOpen = _b[0], setMenuVisiblity = _b[1];
    var _c = MobNavbar_read((0,react.useState)(false), 2), isOpenLogo = _c[0], setIsOpenLogo = _c[1];
    (0,react.useEffect)(function() {
        if (isMenuOpen || !isLoggedIn) setIsOpenLogo(true);
        else setIsOpenLogo(false);
    }, [
        isMenuOpen,
        isLoggedIn
    ]);
    return /*#__PURE__*/ react.createElement("div", {
        id: "mobile_logged_in_navbar",
        className: "lfc-w-screen lfc-h-mobileHeaderHeight"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "lfc-w-full lfc-fixed lfc-z-[9000] !lfc-h-mobileHeaderHeight lfc-left-0 lfc-right-0 lfc-top-0"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "lfc-w-screen lfc-h-full lfc-bg-white lfc-border-b lfc-border-[#DBDBDB] lfc-shadow-[0px_4px_8px_0px_rgba(67,54,149,0.08)] lfc-flex lfc-gap-4 lfc-justify-between lfc-items-center lfc-py-4"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "lfc-w-full lfc-flex lfc-gap-2 lfc-items-center lfc-pl-4"
    }, isOpenLogo ? /*#__PURE__*/ react.createElement((image_default()), {
        src: "".concat(imageBasePath, "/LeapScholar/leap_logo_Psi6P4qMo.svg"),
        height: 24,
        width: 124,
        alt: "leap-scholar-logo",
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onClick: function onClick() {
            return MobNavbar_awaiter(void 0, void 0, void 0, function() {
                return MobNavbar_generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!handleSegmentEvents) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                handleSegmentEvents("LS Logo")
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            window.open(logoLink, "_self");
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }
    }) : /*#__PURE__*/ react.createElement((image_default()), {
        src: "".concat(imageBasePath, "/LeapScholar/leap_logo_eGTnLF_EvK.svg"),
        height: 24,
        width: 24,
        alt: "leap-scholar-logo",
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onClick: function onClick() {
            return MobNavbar_awaiter(void 0, void 0, void 0, function() {
                return MobNavbar_generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!handleSegmentEvents) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                handleSegmentEvents("LS Logo")
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            window.open(logoLink, "_self");
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }
    }), isLoggedIn && !isMenuOpen && /*#__PURE__*/ react.createElement("div", {
        className: "lfc-flex lfc-items-center lfc-gap-4"
    }, navData.map(function(navItem, index) {
        return /*#__PURE__*/ react.createElement(Navbar_NavItems, {
            navItem: navItem,
            key: index,
            isLastMenuItem: (navData === null || navData === void 0 ? void 0 : navData.length) - 1 === index,
            isLoggedIn: isLoggedIn,
            selectedTitle: selectedTitle,
            handleSegmentEvents: handleSegmentEvents
        });
    }))), /*#__PURE__*/ react.createElement("div", {
        className: "lfc-pr-4 lfc-w-10 lfc-flex lfc-items-center lfc-justify-center"
    }, /*#__PURE__*/ react.createElement((image_default()), {
        src: isMenuOpen ? "".concat(imageBasePath, "/close-btn.svg") : "".concat(imageBasePath, "/hamburger.svg"),
        height: 24,
        width: 24,
        alt: "hamburger-menu",
        className: "lfc-w-6 lfc-h-6",
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onClick: function onClick() {
            return MobNavbar_awaiter(void 0, void 0, void 0, function() {
                return MobNavbar_generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            setMenuVisiblity(function(prev) {
                                return !prev;
                            });
                            if (!handleSegmentEvents) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                handleSegmentEvents("Header Hamburger")
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }
    }))), isMenuOpen && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement("div", {
        className: "lfc-w-full lfc-h-full lfc-fixed lfc-top-[58px] lfc-pb-[155px] lfc-left-0 lfc-bg-white lfc-overflow-y-scroll"
    }, mobileNavData === null || mobileNavData === void 0 ? void 0 : mobileNavData.map(function(navItem, index) {
        return /*#__PURE__*/ react.createElement(Navbar_MobNavItems, {
            navItem: navItem,
            isLoggedIn: isLoggedIn,
            key: index,
            handleSegmentEvents: handleSegmentEvents
        });
    })), !isLoggedIn && /*#__PURE__*/ react.createElement("div", {
        className: "lfc-fixed lfc-bg-white lfc-left-0 lfc-bottom-0 lfc-w-full lfc-px-4 lfc-py-5 lfc-border lfc-border-[#CBCAD5] lfc-shadow-[0px_0px_4px_-2px_rgba(16,24,40,0.06),0px_-2px_8px_-2px_rgba(16,24,40,0.10)]"
    }, /*#__PURE__*/ react.createElement(Navbar_NavButtons, {
        navButtons: buttons,
        handleSegmentEvents: handleSegmentEvents
    })))));
};
/* harmony default export */ var Navbar_MobNavbar = (MobNavbar); //# sourceMappingURL=MobNavbar.js.map

;// CONCATENATED MODULE: ./node_modules/@leapfinance/frontend-commons/components/LeapScholar/Navbar/index.js
var Navbar_read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};






var Navbar = function Navbar(_a) {
    var _b, _c;
    var buttons = _a.buttons, isLoggedIn = _a.isLoggedIn, navData = _a.navData, isMobileSized = _a.isMobileSized, mobileNavData = _a.mobileNavData, handleSegmentEvents = _a.handleSegmentEvents, logoLink = _a.logoLink, selectedTitle = _a.selectedTitle, isFixedHeader = _a.isFixedHeader, webHeaderWidth = _a.webHeaderWidth, isTabSized = _a.isTabSized;
    var _d = Navbar_read((0,react.useState)(isLoggedIn), 2), isLoggedInLocal = _d[0], setIsLoggedInLocal = _d[1];
    (0,react.useEffect)(function() {
        setIsLoggedInLocal(isLoggedIn);
    }, [
        isLoggedIn
    ]);
    if (isLoggedInLocal) {
        if (isMobileSized || isTabSized) {
            return /*#__PURE__*/ react.createElement(Navbar_MobNavbar, {
                isLoggedIn: isLoggedInLocal,
                navData: navData,
                buttons: buttons,
                mobileNavData: mobileNavData,
                handleSegmentEvents: handleSegmentEvents,
                logoLink: logoLink,
                selectedTitle: selectedTitle
            });
        } else {
            return /*#__PURE__*/ react.createElement(Navbar_DesktopNavbar, {
                isLoggedIn: isLoggedInLocal,
                navData: navData,
                buttons: buttons,
                mobileNavData: mobileNavData,
                handleSegmentEvents: handleSegmentEvents,
                logoLink: logoLink,
                selectedTitle: selectedTitle
            });
        }
    }
    if (!isLoggedInLocal) {
        if (isMobileSized || isTabSized) {
            return /*#__PURE__*/ react.createElement(Mobile, {
                isFixedHeader: isFixedHeader,
                loginFunction: (_b = buttons[0]) === null || _b === void 0 ? void 0 : _b.handleClick
            });
        } else {
            return /*#__PURE__*/ react.createElement(Desktop, {
                isFixedHeader: isFixedHeader,
                webHeaderWidth: webHeaderWidth,
                loginFunction: (_c = buttons[0]) === null || _c === void 0 ? void 0 : _c.handleClick
            });
        }
    }
    return null;
};
/* harmony default export */ var LeapScholar_Navbar = (Constants_withWindowDimensions(Navbar)); //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./lib/auth-cookies-new.js
var auth_cookies_new = __webpack_require__(89208);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/navbarUtils.ts
var navbarUtils = __webpack_require__(79998);
;// CONCATENATED MODULE: ./components/common/NavbarWrapper.tsx















var NavbarWrapper = function(param) {
    var initLogin = param.initLogin;
    var token = (0,auth_cookies_new/* getTokenCookie */.r_)();
    var auth = new auth_token/* AuthToken */.H(token);
    var isLoggedIn = auth === null || auth === void 0 ? void 0 : auth.isValid;
    var router = (0,next_router.useRouter)();
    var handleSegmentEvents = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(title) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,segment.trackEventAsync)("Click", {
                            contentFormat: "Button",
                            widgetName: "Website Header",
                            contentName: title,
                            pageName: "NA"
                        });
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSegmentEvents(title) {
            return _ref.apply(this, arguments);
        };
    }();
    var getNavData = function() {
        if (isLoggedIn) return loggedInNav;
        else return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, loggedOutNav), {
            buttons: [
                {
                    title: "Sign in",
                    buttonType: "SECONDARY",
                    handleClick: function() {
                        return initLogin("Enter your mobile number to continue", true, "", (0,navbarUtils/* isIeltsFlow */.s)(router.pathname) ? "ielts" : "NA", function() {});
                    }
                },
                {
                    title: "Sign Up",
                    buttonType: "PRIMARY",
                    handleClick: function() {
                        return initLogin("Enter your mobile number to continue", true, "", (0,navbarUtils/* isIeltsFlow */.s)(router.pathname) ? "ielts" : "NA", function() {});
                    }
                }, 
            ]
        });
    };
    var getSelectedTitle = function() {
        if (router.pathname.includes("/profile/counselling")) return "Counselling";
        if (router.pathname.includes("/test-prep/dashboard")) return "IELTS Prep";
        return "";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LeapScholar_Navbar, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getNavData()), {
        isLoggedIn: isLoggedIn,
        isLoggedOut: !isLoggedIn,
        logoLink: page_routes/* navRoutes.HOMEPAGE */.CZ.HOMEPAGE,
        handleSegmentEvents: handleSegmentEvents,
        selectedTitle: getSelectedTitle()
    }));
};
/* harmony default export */ var common_NavbarWrapper = ((0,withLogin/* withLogin */.U)(NavbarWrapper));

;// CONCATENATED MODULE: ./components/common/Layout.tsx











var NeedHelpV1 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4889), __webpack_require__.e(2538), __webpack_require__.e(8445)]).then(__webpack_require__.bind(__webpack_require__, 57961));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57961)
            ];
        }
    }
});
var MenaLogoutNavbar = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6775).then(__webpack_require__.bind(__webpack_require__, 76775));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76775)
            ];
        }
    }
});


var Layout = function(param) {
    var auth = param.auth, children = param.children, _isHeaderHidden = param.isHeaderHidden, isHeaderHidden = _isHeaderHidden === void 0 ? false : _isHeaderHidden, _isFooterHidden = param.isFooterHidden, isFooterHidden = _isFooterHidden === void 0 ? false : _isFooterHidden, counsellingStage = param.counsellingStage, fetchUserInfoData = param.fetchUserInfoData, userInfo = param.userInfo, _shouldShowBackButton = param.shouldShowBackButton, shouldShowBackButton = _shouldShowBackButton === void 0 ? false : _shouldShowBackButton, _customNavbar = param.customNavbar, customNavbar = _customNavbar === void 0 ? null : _customNavbar;
    var ref = (0,react.useState)(false), showNeedHelpModal = ref[0], setShowNeedHelpModal = ref[1];
    var ref1 = (0,react.useState)(!isFooterHidden), footerVisiblity = ref1[0], setFooterVisiblity = ref1[1];
    var ref2 = (0,react.useState)(!isHeaderHidden), headerVisibility = ref2[0], setHeaderVisibility = ref2[1];
    var ref3 = (0,react.useState)(false), isMeUser = ref3[0], setIsMeUser = ref3[1];
    var userCountry = (0,useLocation/* default */.Z)().userCountry;
    var loggedIn = auth === null || auth === void 0 ? void 0 : auth.isValid;
    var isPaymentDoneUser = counsellingStage ? StageMapper/* counsellingStageRank */.xH[counsellingStage] >= StageMapper/* counsellingStageRank */.xH[profile/* CounselingStage.LS_PAYMENT_DONE */.Wk.LS_PAYMENT_DONE] : false;
    var isomorphicEffect = hooks_useIsomorphicEffect();
    isomorphicEffect(function() {
        if ((0,country_utils/* checkIfMENAUser */.D7)(userCountry)) {
            setIsMeUser(true);
        }
    }, [
        userCountry
    ]);
    (0,react.useEffect)(function() {
        if (showNeedHelpModal) {
            fetchUserInfoData();
        }
    }, [
        showNeedHelpModal
    ]);
    (0,react.useEffect)(function() {
        try {
            var urlSearchParams = new URLSearchParams(window.location.search);
            if (urlSearchParams.get("isFooterHidden") === "true") {
                setFooterVisiblity(false);
            }
            if (urlSearchParams.get("isHeaderHidden") === "true") {
                setHeaderVisibility(false);
            }
        } catch (error) {}
    }, []);
    var checkHistory = function() {
        if (window) {
            var history = window.history;
            if (history.length > 2) window.history.back();
        }
    };
    var isFooterVisible = function() {
        if (isMeUser) return false;
        return !loggedIn || StageMapper/* counsellingStageRank */.xH[counsellingStage] < 10;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            headerVisibility && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    isMeUser ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MenaLogoutNavbar, {}) : customNavbar ? customNavbar : /*#__PURE__*/ (0,jsx_runtime.jsx)(common_NavbarWrapper, {}),
                    showNeedHelpModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(NeedHelpV1, {
                        setShowNeedHelp: setShowNeedHelpModal,
                        userInfo: userInfo
                    })
                ]
            }),
            shouldShowBackButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/chat/back_button_dark.svg"),
                alt: "back",
                className: "mt-4 ml-4",
                onClick: function() {
                    checkHistory();
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_InternetCheckAlertBox, {}),
            children,
            !isFooterVisible() || !footerVisiblity ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Footer, {})
        ]
    });
};
var mapStateToProps = function(state) {
    return {
        auth: state.auth.auth,
        counsellingStage: state.spotCounselling.stage,
        userInfo: state.referAndEarn.userInfo
    };
};
var mapDispatchToProps = function(dispatch) {
    return {
        fetchUserInfoData: function() {
            dispatch(ReferAndEarnActions/* referAndEarnActions.fetchUserInfo */.F.fetchUserInfo());
        }
    };
};
/* harmony default export */ var common_Layout = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(Layout));


/***/ }),

/***/ 81964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var LineBreak = function(param) {
    var device = param.device;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
        className: device === "mobile" ? "md:hidden" : device === "desktop" ? "hidden md:block" : ""
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LineBreak);


/***/ }),

/***/ 70231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66089);
/* harmony import */ var next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1__);
// # Speed in Seconds (spinner rotating speed)
// # Spinner Size in em units relative to the font size of the parent element.
// # borderSize in em units relative to the font size of the parent element.
// # borderColor color background for border.


var Spinner = function(param) {
    var _speed = param.speed, speed = _speed === void 0 ? 0.8 : _speed, _size = param.size, size = _size === void 0 ? 2.5 : _size, _borderSize = param.borderSize, borderSize = _borderSize === void 0 ? 0.1 : _borderSize, _borderColor = param.borderColor, borderColor = _borderColor === void 0 ? "#ffffff" : _borderColor, _color = param.color, color = _color === void 0 ? "#00b0aa" : _color;
    var sizeMapper = {
        small: 1.1,
        medium: 2.5,
        large: 5,
        extraLarge: 10
    };
    var _size1;
    var sizeValue = (_size1 = sizeMapper[size]) !== null && _size1 !== void 0 ? _size1 : size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
            [
                "e631ae18377d75c",
                [
                    sizeValue,
                    sizeValue,
                    borderSize,
                    borderColor,
                    color
                ]
            ]
        ]) + " " + "loadingspinner rounded-full animate-spin pointer-events-none",
        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default()), {
            id: "e631ae18377d75c",
            dynamic: [
                sizeValue,
                sizeValue,
                borderSize,
                borderColor,
                color
            ],
            children: ".loadingspinner.__jsx-style-dynamic-selector{width:".concat(sizeValue, "em;height:").concat(sizeValue, "em;border:").concat(borderSize, "em solid transparent;border-color:").concat(borderColor, ";border-top-color:").concat(color, "}")
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Spinner);


/***/ }),

/***/ 5588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




var withWindowDimensions = function(WrappedComponent) {
    return function(props) {
        var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
            width: 380,
            height: 640
        }), windowDimensions = ref[0], setWindowDimensions = ref[1];
        (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
            var handleResize = function handleResize() {
                setWindowDimensions({
                    width: window.innerWidth,
                    height: window.innerHeight
                });
            };
            handleResize();
            window.addEventListener("resize", handleResize);
            return function() {
                return window.removeEventListener("resize", handleResize);
            };
        }, []);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
            windowWidth: windowDimensions.width,
            windowHeight: windowDimensions.height,
            isMobileSized: windowDimensions.width < 700,
            isTabSized: windowDimensions.width < 1000 && windowDimensions.width > 700
        }));
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (withWindowDimensions);


/***/ }),

/***/ 86982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ authActions; }
/* harmony export */ });
var saveAuth = function(payload) {
    return {
        type: "SAVE_AUTH",
        payload: payload
    };
};
var authActions = {
    saveAuth: saveAuth
};


/***/ }),

/***/ 44305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ eventTracker; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ga__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83138);
/* harmony import */ var webEngage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84977);




var eventTracker = function(eventType, eventData) {
    var shouldFireGA = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    return new Promise(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(resolve) {
            var category, action, label;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        category = eventData.category, action = eventData.action, label = eventData.label;
                        if (shouldFireGA) {
                            (0,ga__WEBPACK_IMPORTED_MODULE_1__.logEvent)(category, action, label);
                        }
                        (0,webEngage__WEBPACK_IMPORTED_MODULE_3__/* .webEngageGetForever */ .wr)().then(function() {
                            (0,webEngage__WEBPACK_IMPORTED_MODULE_3__/* .webEventTracker */ .PK)(eventType, eventData);
                            resolve(true);
                        }).catch(function() {
                            resolve(false);
                        });
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(resolve) {
            return _ref.apply(this, arguments);
        };
    }());
};


/***/ }),

/***/ 83138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fireCountryTagEvent": function() { return /* binding */ fireCountryTagEvent; },
/* harmony export */   "fireOptimizeEvent": function() { return /* binding */ fireOptimizeEvent; },
/* harmony export */   "fireTagEvent": function() { return /* binding */ fireTagEvent; },
/* harmony export */   "logEvent": function() { return /* binding */ logEvent; },
/* harmony export */   "logPageView": function() { return /* binding */ logPageView; },
/* harmony export */   "sendCustomGaEvent": function() { return /* binding */ sendCustomGaEvent; },
/* harmony export */   "sendCustomGaEventWithoutProperties": function() { return /* binding */ sendCustomGaEventWithoutProperties; },
/* harmony export */   "sendPageViewGAEvent": function() { return /* binding */ sendPageViewGAEvent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_utm_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86147);





var logPageView = function(path) {
    var page = path || window.location.pathname;
    gtag("event", "page_view", {
        page: page
    });
};
var logEvent = function(category, action, label) {
    if ( true && typeof window.gtag === "function") {
        gtag("event", action, {
            category: category,
            action: action,
            label: label
        });
    }
};
var sendPageViewGAEvent = function(eventProps, userProps) {
    var utmDetails = (0,utils_utm_utils__WEBPACK_IMPORTED_MODULE_1__/* .getUtmData */ .M)(null);
    var url = window.location.href;
    var isMobile = window.innerWidth < 768;
    var allEventDetails = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, eventProps, utmDetails), {
        page_url: url,
        platform: isMobile ? "MWEB" : "WEB"
    });
    if ( true && typeof window.gtag === "function") {
        if (userProps) {
            gtag("set", "user_properties", userProps);
        }
        gtag("event", "page_view", allEventDetails);
    }
};
function sendCustomGaEvent(eventName, eventProps, userProps) {
    return new Promise(function(resolve, reject) {
        var utmDetails = (0,utils_utm_utils__WEBPACK_IMPORTED_MODULE_1__/* .getUtmData */ .M)(null);
        var url = window.location.href;
        var isMobile = window.innerWidth < 768;
        var allEventDetails = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, eventProps, utmDetails), {
            page_url: url,
            platform: isMobile ? "MWEB" : "WEB"
        });
        if ( true && typeof window.gtag === "function") {
            if (userProps) {
                gtag("set", "user_properties", userProps);
            }
            gtag("event", eventName, allEventDetails);
            resolve() // Resolve the Promise when the event is sent.
            ;
        } else {
            reject(new Error("Google Analytics not available."));
        }
    });
}
var sendCustomGaEventWithoutProperties = function(eventName) {
    return new Promise(function(resolve, reject) {
        var isMobile = window.innerWidth < 768;
        if ( true && typeof window.gtag === "function") {
            gtag("event", eventName, {
                platform: isMobile ? "MWEB" : "WEB"
            });
            resolve() // Resolve the Promise when the event is sent.
            ;
        } else {
            reject(new Error("Google Analytics not available."));
        }
    });
};
var fireTagEvent = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(eventName, eventData) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!window.dataLayer) {
                        _ctx.next = 3;
                        break;
                    }
                    _ctx.next = 3;
                    return window.dataLayer.push({
                        event: eventName,
                        eventData: eventData
                    });
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fireTagEvent(eventName, eventData) {
        return _ref.apply(this, arguments);
    };
}();
var fireCountryTagEvent = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(eventName, country) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!window.dataLayer) {
                        _ctx.next = 3;
                        break;
                    }
                    _ctx.next = 3;
                    return window.dataLayer.push({
                        event: eventName,
                        country: country
                    });
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fireCountryTagEvent(eventName, country) {
        return _ref.apply(this, arguments);
    };
}();
var fireOptimizeEvent = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!window.dataLayer) {
                        _ctx.next = 3;
                        break;
                    }
                    _ctx.next = 3;
                    return window.dataLayer.push({
                        event: "optimize.activate"
                    });
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fireOptimizeEvent() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 61693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xo": function() { return /* binding */ checkEventsToShow; },
/* harmony export */   "ZP": function() { return /* binding */ useUpcomingEventsData; },
/* harmony export */   "lZ": function() { return /* binding */ checkTofuVisibility; }
/* harmony export */ });
/* unused harmony export checkIfPrivateEvent */
/* harmony import */ var components_SpotCounselling_redux_SpotCounsellingActions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10585);
/* harmony import */ var DataMapper_Profile_StageMapper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91738);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14416);




var nonVisibleTags = [
    "counselling_stage",
    "ielts_stage"
];
var checkIfPrivateEvent = function(eventId, tags, bookedList) {
    var tagNames = tags.map(function(item) {
        var ref;
        return item === null || item === void 0 ? void 0 : (ref = item.tag) === null || ref === void 0 ? void 0 : ref.Name;
    });
    if (tagNames.includes("PRIVATE_EVENT")) {
        var filtererdEvents = bookedList === null || bookedList === void 0 ? void 0 : bookedList.some(function(event) {
            return (event === null || event === void 0 ? void 0 : event.id) === eventId;
        });
        if (filtererdEvents) return false;
        return true;
    } else return false;
};
var checkEventsToShow = function(eventId, tags, stage, preferredCountry, bookedList) {
    var counsellingStages = tags.filter(function(item) {
        var ref;
        return nonVisibleTags.includes(item === null || item === void 0 ? void 0 : (ref = item.tag) === null || ref === void 0 ? void 0 : ref.type);
    }).map(function(item) {
        var ref;
        return item === null || item === void 0 ? void 0 : (ref = item.tag) === null || ref === void 0 ? void 0 : ref.Name;
    });
    var countries = tags.filter(function(item) {
        var ref;
        return (item === null || item === void 0 ? void 0 : (ref = item.tag) === null || ref === void 0 ? void 0 : ref.type) === "country";
    }).map(function(item) {
        var ref;
        return item === null || item === void 0 ? void 0 : (ref = item.tag) === null || ref === void 0 ? void 0 : ref.Name;
    });
    var isPrivateEvent = checkIfPrivateEvent(eventId, tags, bookedList);
    if (isPrivateEvent) return false;
    if (location.pathname === "/profile/counselling" && DataMapper_Profile_StageMapper__WEBPACK_IMPORTED_MODULE_1__/* .counsellingStageRank */ .xH[stage] >= 10) {
        return countries.includes(preferredCountry) && counsellingStages.includes(stage) || counsellingStages.includes("OPEN_TO_ALL");
    } else {
        return stage && (tags === null || tags === void 0 ? void 0 : tags.length) > 0 ? counsellingStages.includes(stage) || counsellingStages.includes("OPEN_TO_ALL") : true;
    }
};
var checkTofuVisibility = function(eventId, tags, bookedList) {
    var counsellingStages = tags.filter(function(item) {
        var ref;
        return nonVisibleTags.includes(item === null || item === void 0 ? void 0 : (ref = item.tag) === null || ref === void 0 ? void 0 : ref.type);
    }).map(function(item) {
        var ref;
        return item === null || item === void 0 ? void 0 : (ref = item.tag) === null || ref === void 0 ? void 0 : ref.Name;
    });
    var success = counsellingStages.includes("OPEN_TO_ALL");
    var isPrivateEvent = checkIfPrivateEvent(eventId, tags, bookedList);
    if (isPrivateEvent) return false;
    return success;
};
function useUpcomingEventsData() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var upcomingEventData = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return state.spotCounselling.eventsData;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        dispatch(components_SpotCounselling_redux_SpotCounsellingActions__WEBPACK_IMPORTED_MODULE_0__/* .spotCounsellingActions.fetchUpcomingEvents */ .F.fetchUpcomingEvents());
    }, []);
    return {
        upcommingEventsData: upcomingEventData.upcomingEvents,
        bookedEvents: upcomingEventData.bookedEvents
    };
};


/***/ }),

/***/ 28531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51119);
/* harmony import */ var DataMapper_Common_cookiesConstant__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18472);
/* harmony import */ var utils_country_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20581);
/* harmony import */ var lib_auth_cookies_new__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89208);
/* harmony import */ var lib_auth_token__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72714);








var useLocation = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_2__/* .getCookie */ .ej)(null, DataMapper_Common_cookiesConstant__WEBPACK_IMPORTED_MODULE_3__/* .cookiesConstant.IP_COUNTRY_KEY */ .k.IP_COUNTRY_KEY) || null), ipCountry = ref[0], setIpCountry = ref[1];
    var token = (0,lib_auth_cookies_new__WEBPACK_IMPORTED_MODULE_5__/* .getTokenCookie */ .r_)();
    var auth = new lib_auth_token__WEBPACK_IMPORTED_MODULE_6__/* .AuthToken */ .H(token);
    var getUserCountryDetails = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var country;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,utils_country_utils__WEBPACK_IMPORTED_MODULE_4__/* .getUserCountry */ .gv)(auth);
                    case 2:
                        country = _ctx.sent;
                        setIpCountry(country);
                        (0,utils_country_utils__WEBPACK_IMPORTED_MODULE_4__/* .setCountryInCookies */ .EI)(country);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getUserCountryDetails() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (auth) {
            getUserCountryDetails();
        }
    }, [
        auth === null || auth === void 0 ? void 0 : auth.isValid
    ]);
    return {
        userCountry: ipCountry
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useLocation);


/***/ }),

/***/ 84367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var utils_browserUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50437);




/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {
    var handleResize = function handleResize() {
        getDeviceInfoByWidth();
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        isIos: false,
        isAndroid: false,
        isMobile: false,
        isTablet: false,
        isLoading: true
    }), deviceInfo = ref[0], setDeviceInfo = ref[1];
    var getDeviceInfoByWidth = function() {
        var payload = {
            isMobile: false,
            isTablet: false
        };
        if (true) {
            if (window.innerWidth <= 700) {
                payload.isMobile = true;
            } else if (window.innerWidth > 700 && window.innerWidth < 1000) {
                payload.isTablet = true;
            }
            setDeviceInfo(function(prevState) {
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, prevState, payload);
            });
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var userAgent = window.navigator.userAgent || navigator.vendor || window.opera;
        var isTablet = window.matchMedia && window.matchMedia("(min-device-width: 768px) and (max-device-width: 1024px)").matches;
        if (/android/i.test(userAgent)) {
            setDeviceInfo(function(config) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, config), {
                    isAndroid: true
                });
            });
        }
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            setDeviceInfo(function(config) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, config), {
                    isIos: true
                });
            });
            if (/iPad/.test(userAgent)) {
                setDeviceInfo(function(config) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, config), {
                        isTablet: isTablet
                    });
                });
            }
        }
        if ((0,utils_browserUtils__WEBPACK_IMPORTED_MODULE_1__/* .mobileCheck */ .KU)()) {
            setDeviceInfo(function(config) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, config), {
                    isMobile: true,
                    isLoading: false
                });
            });
            if (isTablet) {
                setDeviceInfo(function(config) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, config), {
                        isTablet: isTablet
                    });
                });
            }
        }
        setDeviceInfo(function(config) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, config), {
                isLoading: false
            });
        });
        window.addEventListener("resize", handleResize);
        handleResize();
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []);
    return deviceInfo;
};


/***/ }),

/***/ 45172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ format; },
  "UO": function() { return /* binding */ generateUniqueValue; }
});

// UNUSED EXPORTS: replaceDate, replaceDay, replaceMonth, replaceTime, replaceYear

;// CONCATENATED MODULE: ./lib/DateUtils/utils/dateUtils.ts
var monthNameList = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December", 
];
var weekdaysList = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday", 
];

;// CONCATENATED MODULE: ./lib/DateUtils/dateLib/format.ts

function withSpaceString(str) {
    return "".concat(str);
}
function appendZeroInSingleDigit(number) {
    return number.toString().length > 1 ? number : "0" + number.toString();
}
var generateUniqueValue = function() {
    try {
        var timestamp = Date.now();
        var randomNumber = Math.floor(Math.random() * 1000000);
        var uniqueValue = "".concat(timestamp, "-").concat(randomNumber);
        return uniqueValue;
    } catch (err) {
        console.error(err);
    }
};
function replaceDate(date, formatString) {
    /*
   * Date format
   * dd for cardinal date
   * Do for ordinal date
   */ var cardinalDate = date.getDate();
    var ordinalDate = function() {
        if (cardinalDate == 1) return cardinalDate + "st";
        if (cardinalDate == 2) return cardinalDate + "nd";
        if (cardinalDate == 3) return cardinalDate + "rd";
        return cardinalDate + "th";
    };
    return formatString.toString().replace(/\b(dd|DD)\b/g, String(cardinalDate)).replace(/\bDo\b/g, ordinalDate());
}
function replaceDay(date, formatString) {
    /*
   * Date format
   * dd for cardinal date
   * Do for ordinal date
   */ var getDay = date.getDay();
    var dayName = weekdaysList[getDay];
    var shortWeekName = dayName.slice(0, 3);
    return formatString.toString().replace(/\b(ddd)\b/g, String(shortWeekName)).replace(/\bdddd\b/g, String(dayName));
}
function replaceMonth(date, formatString) {
    /*
   * MM-> month number 1-12
   * MMM -> month in short Form e.d Jan, Feb
   * MMMM-> month name full form
   */ var monthNumber = new Date(date).getMonth() + 1;
    var monthName = monthNameList[monthNumber - 1];
    var monthShortName = monthName.slice(0, 3);
    return formatString.toString().replace(/\bMMMM\b/g, withSpaceString(monthName)).replace(/\bMMM\b/g, withSpaceString(monthShortName)).replace(/\bMM\b/g, withSpaceString(monthNumber));
}
function replaceYear(date, formatString) {
    /*
   * YYYY -> year full form
   *  YY -> last two digit of year
   */ var thisYear = new Date(date).getFullYear().toString();
    var shortYear = thisYear.slice(2);
    return formatString.toString().replace(/\bYYYY\b/g, withSpaceString(thisYear)).replace(/\bYY\b/g, withSpaceString(shortYear));
}
function replaceTime(date, formatString) {
    /*
   * HH -> 24hrs format
   * hh -> 12 hrs format
   */ var currentTime = new Date(date);
    var varHour = currentTime.getHours();
    var clockHour = function() {
        if (varHour == 0) return {
            hour: "12",
            abbr: "am"
        };
        if (varHour < 12) return {
            hour: appendZeroInSingleDigit(varHour),
            abbr: "am"
        };
        return {
            hour: appendZeroInSingleDigit(varHour - 12),
            abbr: "pm"
        };
    };
    var varMin = appendZeroInSingleDigit(currentTime.getMinutes());
    var varSec = appendZeroInSingleDigit(currentTime.getSeconds());
    return formatString.toString().replace(/\bHH\b/g, withSpaceString(varHour)).replace(/\bhh\b/g, withSpaceString(clockHour().hour)).replace(/\bmm\b/g, withSpaceString(varMin)).replace(/\bss\b/g, withSpaceString(varSec)).replace(/\ba\b/g, withSpaceString(clockHour().abbr)).replace(/\bA\b/g, withSpaceString(clockHour().abbr).toUpperCase());
}
function format(date, formatString) {
    var dateString = replaceDay(date, formatString);
    dateString = replaceDate(date, dateString);
    dateString = replaceMonth(date, dateString);
    dateString = replaceYear(date, dateString);
    dateString = replaceTime(date, dateString);
    return dateString;
};


/***/ }),

/***/ 96563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ initBkashPayment; }
/* harmony export */ });
var initBkashPayment = function(orderId) {
    window.open(orderId, "_self");
};


/***/ }),

/***/ 5288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dz": function() { return /* binding */ getMockTestFee; },
/* harmony export */   "Py": function() { return /* binding */ getFastTrackFee; },
/* harmony export */   "eG": function() { return /* binding */ getCounsellingFee; }
/* harmony export */ });
/* unused harmony exports getIeltsFee, getSpeakingClubFee */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lib_Razorpay_razorpay__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54418);
/* harmony import */ var lib_Razorpay_paymentGateWay__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7293);
/* harmony import */ var Interfaces_common_PaymentSchema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4162);
/* harmony import */ var DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93957);






var getCounsellingFee = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var paymentInfo, _p;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    paymentInfo = {
                        paymentType: "COUNSELLING_FEE",
                        formDescription: "Get LeapScholar Plus access"
                    };
                    _ctx.next = 3;
                    return (0,lib_Razorpay_razorpay__WEBPACK_IMPORTED_MODULE_1__/* .initRazorpayPaymentRequest */ .WK)(paymentInfo);
                case 3:
                    _p = _ctx.sent;
                    console.log("razorpay module result = ", _p);
                    if (!(_p != undefined)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", _p);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getCounsellingFee() {
        return _ref.apply(this, arguments);
    };
}();
var getIeltsFee = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(paymentType) {
        var newPaymentType, paymentInfo, _p;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    if (paymentType === "IELTS_PLUS_PREMIUM") {
                        newPaymentType = Interfaces_common_PaymentSchema__WEBPACK_IMPORTED_MODULE_3__/* .PaymentType.IELTS_PREMIUM_FEE */ .uG.IELTS_PREMIUM_FEE;
                    } else if (paymentType === DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_4__/* .priceBundleName.IELTS_PLUS_PREMIUM_2 */ .F.IELTS_PLUS_PREMIUM_2) {
                        newPaymentType = Interfaces_common_PaymentSchema__WEBPACK_IMPORTED_MODULE_3__/* .PaymentType.IELTS_PREMIUM_2_FEE */ .uG.IELTS_PREMIUM_2_FEE;
                    } else if (paymentType === DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_4__/* .priceBundleName.IELTS_PLUS_PREMIUM_3 */ .F.IELTS_PLUS_PREMIUM_3) {
                        newPaymentType = Interfaces_common_PaymentSchema__WEBPACK_IMPORTED_MODULE_3__/* .PaymentType.IELTS_PREMIUM_3_FEE */ .uG.IELTS_PREMIUM_3_FEE;
                    } else if (paymentType === DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_4__/* .priceBundleName.IELTS_PLUS_PART_2 */ .F.IELTS_PLUS_PART_2) {
                        newPaymentType = Interfaces_common_PaymentSchema__WEBPACK_IMPORTED_MODULE_3__/* .PaymentType.IELTS_PLUS_PART_2_FEE */ .uG.IELTS_PLUS_PART_2_FEE;
                    } else {
                        newPaymentType = "IELTS_FEE";
                    }
                    paymentInfo = {
                        paymentType: newPaymentType,
                        formDescription: "Get IELTS Plus access",
                        amount: 99
                    };
                    _ctx.next = 5;
                    return (0,lib_Razorpay_paymentGateWay__WEBPACK_IMPORTED_MODULE_2__/* .initDefaultPaymentGateway */ .Q)(paymentInfo);
                case 5:
                    _p = _ctx.sent;
                    console.log("razorpay module result = ", _p);
                    if (!(_p != undefined)) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", _p);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getIeltsFee(paymentType) {
        return _ref.apply(this, arguments);
    };
}();
var getFastTrackFee = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(amount, currency) {
        var paymentInfo, _p;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    paymentInfo = {
                        paymentType: "FAST_TRACK_FEE",
                        formDescription: "Get Fast Track access",
                        currency: currency,
                        amount: amount
                    };
                    _ctx.next = 3;
                    return (0,lib_Razorpay_paymentGateWay__WEBPACK_IMPORTED_MODULE_2__/* .initDefaultPaymentGateway */ .Q)(paymentInfo);
                case 3:
                    _p = _ctx.sent;
                    console.log("razorpay module result = ", _p);
                    if (!(_p != undefined)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", _p);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getFastTrackFee(amount, currency) {
        return _ref.apply(this, arguments);
    };
}();
var getSpeakingClubFee = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(amount, currency) {
        var paymentInfo, speakingClubPayment;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    paymentInfo = {
                        paymentType: "SPEAKING_CLUB_FEE",
                        formDescription: "Get Speaking Club slots access",
                        currency: currency,
                        amount: amount
                    };
                    _ctx.next = 3;
                    return (0,lib_Razorpay_paymentGateWay__WEBPACK_IMPORTED_MODULE_2__/* .initDefaultPaymentGateway */ .Q)(paymentInfo);
                case 3:
                    speakingClubPayment = _ctx.sent;
                    if (!(speakingClubPayment != undefined)) {
                        _ctx.next = 6;
                        break;
                    }
                    return _ctx.abrupt("return", speakingClubPayment);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSpeakingClubFee(amount, currency) {
        return _ref.apply(this, arguments);
    };
}();
var getMockTestFee = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(amount, currency, promoCode) {
        var paymentInfo, mockTestsPayment;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    paymentInfo = {
                        paymentType: Interfaces_common_PaymentSchema__WEBPACK_IMPORTED_MODULE_3__/* .PaymentType.TCY_MOCK_TEST_FEE */ .uG.TCY_MOCK_TEST_FEE,
                        formDescription: "Get Mock Tests slots access",
                        currency: currency,
                        amount: amount
                    };
                    if (promoCode) {
                        paymentInfo["promoCode"] = promoCode;
                    }
                    _ctx.next = 4;
                    return (0,lib_Razorpay_paymentGateWay__WEBPACK_IMPORTED_MODULE_2__/* .initDefaultPaymentGateway */ .Q)(paymentInfo);
                case 4:
                    mockTestsPayment = _ctx.sent;
                    if (!(mockTestsPayment != undefined)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", mockTestsPayment);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getMockTestFee(amount, currency, promoCode) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 7293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ initPaymentGateway; },
/* harmony export */   "Q": function() { return /* binding */ initDefaultPaymentGateway; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var service_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14117);
/* harmony import */ var lib_Razorpay_bkashPayment__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96563);
/* harmony import */ var lib_Razorpay_razorpay__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54418);
/* harmony import */ var razorpayScript__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12718);
/* harmony import */ var DataMapper_Common_Payment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48930);








var initPaymentGateway = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(requestBody, paymentInfo, batchId) {
        var paymentType, formDescription, res, _data, success, data, ref, orderId, paymentGatewayVendor, amount;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    (0,razorpayScript__WEBPACK_IMPORTED_MODULE_5__/* .initRazorpayScript */ .G)();
                    paymentType = paymentInfo.paymentType, formDescription = paymentInfo.formDescription;
                    requestBody.paymentType = paymentType;
                    requestBody.batchId = batchId;
                    _ctx.next = 7;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/scholarRoute?path=payment/createOrder", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, requestBody), {
                        headers: {
                            "X-API-VERSION": "3"
                        }
                    });
                case 7:
                    res = _ctx.sent;
                    _data = res.data, success = _data.success, data = _data.data;
                    if (!success) {
                        _ctx.next = 21;
                        break;
                    }
                    ref = data || {}, orderId = ref.orderId, paymentGatewayVendor = ref.paymentGatewayVendor, amount = ref.amount;
                    if (!(amount == 0)) {
                        _ctx.next = 13;
                        break;
                    }
                    return _ctx.abrupt("return", true);
                case 13:
                    _ctx.t0 = paymentGatewayVendor;
                    _ctx.next = _ctx.t0 === DataMapper_Common_Payment__WEBPACK_IMPORTED_MODULE_3__/* .paymentGatewayVendorConstant.BKASH */ .V.BKASH ? 16 : _ctx.t0 === DataMapper_Common_Payment__WEBPACK_IMPORTED_MODULE_3__/* .paymentGatewayVendorConstant.RAZORPAY */ .V.RAZORPAY ? 18 : 18;
                    break;
                case 16:
                    (0,lib_Razorpay_bkashPayment__WEBPACK_IMPORTED_MODULE_7__/* .initBkashPayment */ .p)(orderId);
                    return _ctx.abrupt("return", undefined);
                case 18:
                    _ctx.next = 20;
                    return (0,lib_Razorpay_razorpay__WEBPACK_IMPORTED_MODULE_2__/* .initPaymentRequestV2 */ .Z$)(requestBody, data, formDescription);
                case 20:
                    return _ctx.abrupt("return", _ctx.sent);
                case 21:
                    return _ctx.abrupt("return", false);
                case 24:
                    _ctx.prev = 24;
                    _ctx.t1 = _ctx["catch"](0);
                    console.log(_ctx.t1);
                case 27:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                24
            ]
        ]);
    }));
    return function initPaymentGateway(requestBody, paymentInfo, batchId) {
        return _ref.apply(this, arguments);
    };
}();
var initDefaultPaymentGateway = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(paymentInfo) {
        var res, _data, success, data, ref, orderId, paymentGatewayVendor, amount;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    (0,razorpayScript__WEBPACK_IMPORTED_MODULE_5__/* .initRazorpayScript */ .G)();
                    _ctx.next = 4;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/scholarRoute?path=payment/createOrder", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, paymentInfo), {
                        headers: {
                            "X-API-VERSION": "3"
                        }
                    });
                case 4:
                    res = _ctx.sent;
                    _data = res.data, success = _data.success, data = _data.data;
                    if (!success) {
                        _ctx.next = 18;
                        break;
                    }
                    ref = data || {}, orderId = ref.orderId, paymentGatewayVendor = ref.paymentGatewayVendor, amount = ref.amount;
                    if (!(amount == 0)) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", true);
                case 10:
                    _ctx.t0 = paymentGatewayVendor;
                    _ctx.next = _ctx.t0 === DataMapper_Common_Payment__WEBPACK_IMPORTED_MODULE_3__/* .paymentGatewayVendorConstant.BKASH */ .V.BKASH ? 13 : _ctx.t0 === DataMapper_Common_Payment__WEBPACK_IMPORTED_MODULE_3__/* .paymentGatewayVendorConstant.RAZORPAY */ .V.RAZORPAY ? 15 : 15;
                    break;
                case 13:
                    (0,lib_Razorpay_bkashPayment__WEBPACK_IMPORTED_MODULE_7__/* .initBkashPayment */ .p)(orderId);
                    return _ctx.abrupt("return", undefined);
                case 15:
                    _ctx.next = 17;
                    return (0,lib_Razorpay_razorpay__WEBPACK_IMPORTED_MODULE_2__/* .initRazorpayPaymentRequestV2 */ .cO)(paymentInfo, data);
                case 17:
                    return _ctx.abrupt("return", _ctx.sent);
                case 18:
                    return _ctx.abrupt("return", false);
                case 21:
                    _ctx.prev = 21;
                    _ctx.t1 = _ctx["catch"](0);
                    console.log(_ctx.t1);
                case 24:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                21
            ]
        ]);
    }));
    return function initDefaultPaymentGateway(paymentInfo) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 54418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HU": function() { return /* binding */ initRazorpayPaymentGenericBundle; },
/* harmony export */   "LT": function() { return /* binding */ initPaymentRequestForCounselling; },
/* harmony export */   "WK": function() { return /* binding */ initRazorpayPaymentRequest; },
/* harmony export */   "Z$": function() { return /* binding */ initPaymentRequestV2; },
/* harmony export */   "cO": function() { return /* binding */ initRazorpayPaymentRequestV2; }
/* harmony export */ });
/* unused harmony export initPaymentRequest */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var service_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14117);
/* harmony import */ var razorpayScript__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12718);





//configure standard checkout form - only form view configurations here
var configurePaymentCheckoutForm = function(formDescription) {
    var currency = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "INR";
    var options = {
        key: "rzp_live_IO8SEeH1XAev8Y",
        currency: currency,
        name: "LeapScholar",
        description: formDescription || "",
        image: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/header/leap-logo.svg")
    };
    return options;
};
var initRazorpayPaymentRequest = function(props) {
    (0,razorpayScript__WEBPACK_IMPORTED_MODULE_2__/* .initRazorpayScript */ .G)();
    return new Promise(function(res) {
        var paymentType = props.paymentType, formDescription = props.formDescription, currency = props.currency;
        var options = configurePaymentCheckoutForm(formDescription, currency);
        service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/scholarRoute?path=payment/createOrder", {
            paymentType: paymentType
        }).then(function(_o) {
            var _data = _o.data, data = _data.data, success = _data.success;
            var ref = data || {}, orderId = ref.orderId, correlationId = ref.correlationId, payer = ref.payer, alreadyPaid = ref.alreadyPaid;
            var ref1 = payer || {}, name = ref1.name, email = ref1.email, phone = ref1.phone;
            if (!success) res(false);
            else {
                if (!alreadyPaid && orderId) {
                    //@ts-ignore
                    options["order_id"] = orderId;
                    //@ts-ignore
                    // options["amount"] = 999; // not needed as cominf from backend
                    //@ts-ignore
                    options["prefill"] = {
                        name: name || "",
                        email: email || "",
                        contact: phone || ""
                    };
                    // debugger;
                    //@ts-ignore
                    options["handler"] = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                        var _t, data;
                        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    _ctx.next = 2;
                                    return (0,service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("/api/scholarRoute?path=payment/confirm/".concat(correlationId));
                                case 2:
                                    _t = _ctx.sent;
                                    data = _t.data.data;
                                    if (data) {
                                        res(data);
                                    }
                                case 5:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee);
                    }));
                    //@ts-ignore
                    options["modal"] = {
                        // triggers only when modal is closed explicitly
                        ondismiss: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                            var _t, data;
                            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        _ctx.next = 2;
                                        return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=payment/confirm/".concat(correlationId));
                                    case 2:
                                        _t = _ctx.sent;
                                        data = _t.data.data;
                                        res(data);
                                    case 5:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }))
                    };
                    //@ts-ignore
                    var razorpay = new Razorpay(options) // call razorpay sdk
                    ;
                    razorpay.open();
                    //to capture failed payments
                    razorpay.on("payment.error", (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                        var _t, data;
                        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    _ctx.next = 2;
                                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=payment/confirm/".concat(correlationId));
                                case 2:
                                    _t = _ctx.sent;
                                    data = _t.data.data;
                                    res(data);
                                case 5:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee);
                    })));
                } else {
                    res(true);
                }
            }
        }).catch(function(err) {
            console.log(err);
            res(false);
        });
    });
};
var initPaymentRequest = function(requestBody, paymentInfo, batchId) {
    initRazorpayScript();
    return new Promise(function(resolve) {
        var paymentType = paymentInfo.paymentType, formDescription = paymentInfo.formDescription;
        var options = configurePaymentCheckoutForm(formDescription, requestBody === null || requestBody === void 0 ? void 0 : requestBody.currency);
        requestBody.paymentType = paymentType;
        requestBody.batchId = batchId;
        api.post("/api/scholarRoute?path=v2/payment/createOrder", _object_spread({}, requestBody)).then(function(res) {
            var _data = res.data, success = _data.success, data = _data.data;
            if (success) {
                var ref = data || {}, orderId = ref.orderId, correlationId = ref.correlationId, payer = ref.payer, alreadyPaid = ref.alreadyPaid;
                var ref1 = payer || {}, name = ref1.name, email = ref1.email, phone = ref1.phone;
                if (!alreadyPaid && orderId) {
                    options["order_id"] = orderId;
                    options["prefill"] = {
                        name: name || "",
                        email: email || "",
                        contact: phone || ""
                    };
                    options["handler"] = _async_to_generator(regeneratorRuntime.mark(function _callee() {
                        var paymentSuccessRes, data;
                        return regeneratorRuntime.wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    _ctx.next = 2;
                                    return api("/api/scholarRoute?path=payment/confirm/".concat(correlationId));
                                case 2:
                                    paymentSuccessRes = _ctx.sent;
                                    data = paymentSuccessRes.data.data;
                                    if (data) {
                                        resolve(data);
                                    }
                                case 5:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee);
                    }));
                    options["modal"] = {
                        ondismiss: _async_to_generator(regeneratorRuntime.mark(function _callee() {
                            var paymentFailRes, data;
                            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        _ctx.next = 2;
                                        return api.get("/api/scholarRoute?path=payment/confirm/".concat(correlationId));
                                    case 2:
                                        paymentFailRes = _ctx.sent;
                                        data = paymentFailRes.data.data;
                                        resolve(data);
                                    case 5:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }))
                    };
                    //@ts-ignore
                    var razorpay = new Razorpay(options);
                    razorpay.open();
                    razorpay.on("payment.error", _async_to_generator(regeneratorRuntime.mark(function _callee() {
                        var modalCloseRes, data;
                        return regeneratorRuntime.wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    _ctx.next = 2;
                                    return api.get("/api/scholarRoute?path=payment/confirm/".concat(correlationId));
                                case 2:
                                    modalCloseRes = _ctx.sent;
                                    data = modalCloseRes.data.data;
                                    resolve(data);
                                case 5:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee);
                    })));
                } else {
                    resolve(true);
                }
            }
        }).catch(function(err) {
            console.log(err);
            resolve(false);
        });
    });
};
var initPaymentRequestForCounselling = function(paymentInfo, requestBody) {
    (0,razorpayScript__WEBPACK_IMPORTED_MODULE_2__/* .initRazorpayScript */ .G)();
    return new Promise(function(resolve) {
        var options = configurePaymentCheckoutForm(paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.formDescription, paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.currency);
        service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/api/scholarRoute?path=v2/payment/createOrder", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, requestBody)).then(function(res) {
            var _data = res.data, success = _data.success, data = _data.data;
            if (success) {
                var ref = data || {}, orderId = ref.orderId, correlationId = ref.correlationId, payer = ref.payer, alreadyPaid = ref.alreadyPaid;
                var ref1 = payer || {}, name = ref1.name, email = ref1.email, phone = ref1.phone;
                if (!alreadyPaid && orderId) {
                    options["order_id"] = orderId;
                    options["prefill"] = {
                        name: name || "",
                        email: email || "",
                        contact: phone || ""
                    };
                    options["handler"] = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                        var paymentSuccessRes, data;
                        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    _ctx.next = 2;
                                    return (0,service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("/api/scholarRoute?path=payment/confirm/".concat(correlationId));
                                case 2:
                                    paymentSuccessRes = _ctx.sent;
                                    data = paymentSuccessRes.data.data;
                                    if (data) {
                                        resolve(data);
                                    }
                                case 5:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee);
                    }));
                    options["modal"] = {
                        ondismiss: function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(reason) {
                                var paymentFailRes;
                                return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _ctx.next = 2;
                                            return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=payment/confirm/".concat(correlationId));
                                        case 2:
                                            paymentFailRes = _ctx.sent;
                                            if (!reason) {
                                                resolve(false);
                                            }
                                        case 4:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(reason) {
                                return _ref.apply(this, arguments);
                            };
                        }()
                    };
                    //@ts-ignore
                    var razorpay = new window.Razorpay(options);
                    razorpay.open();
                    razorpay.on("payment.error", (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                        var modalCloseRes;
                        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    _ctx.next = 2;
                                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=payment/confirm/".concat(correlationId));
                                case 2:
                                    modalCloseRes = _ctx.sent;
                                case 3:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee);
                    })));
                } else {
                    resolve(true);
                }
            }
        }).catch(function(err) {
            console.log(err);
            resolve(false);
        });
    });
};
var initPaymentRequestV2 = function(requestBody, data, formDescription) {
    return new Promise(function(resolve) {
        var options = configurePaymentCheckoutForm(formDescription, requestBody === null || requestBody === void 0 ? void 0 : requestBody.currency);
        var ref = data || {}, orderId = ref.orderId, correlationId = ref.correlationId, payer = ref.payer, alreadyPaid = ref.alreadyPaid;
        var ref1 = payer || {}, name = ref1.name, email = ref1.email, phone = ref1.phone;
        if (!alreadyPaid && orderId) {
            options["order_id"] = orderId;
            options["prefill"] = {
                name: name || "",
                email: email || "",
                contact: phone || ""
            };
            options["handler"] = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var paymentSuccessRes, _$data;
                return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return (0,service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("/api/scholarRoute?path=payment/confirm/".concat(correlationId));
                        case 2:
                            paymentSuccessRes = _ctx.sent;
                            _$data = paymentSuccessRes.data.data;
                            if (_$data) {
                                resolve(_$data);
                            }
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            options["modal"] = {
                ondismiss: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var paymentFailRes, _$data;
                    return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=payment/confirm/".concat(correlationId));
                            case 2:
                                paymentFailRes = _ctx.sent;
                                _$data = paymentFailRes.data.data;
                                resolve(_$data);
                            case 5:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))
            };
            //@ts-ignore
            var razorpay = new Razorpay(options);
            razorpay.open();
            razorpay.on("payment.error", (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var modalCloseRes, _$data;
                return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=payment/confirm/".concat(correlationId));
                        case 2:
                            modalCloseRes = _ctx.sent;
                            _$data = modalCloseRes.data.data;
                            resolve(_$data);
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            })));
        } else {
            resolve(true);
        }
    });
};
var initRazorpayPaymentRequestV2 = function(props, data) {
    return new Promise(function(res) {
        var formDescription = props.formDescription, currency = props.currency;
        var options = configurePaymentCheckoutForm(formDescription, currency);
        var ref = data || {}, orderId = ref.orderId, correlationId = ref.correlationId, payer = ref.payer, alreadyPaid = ref.alreadyPaid;
        var ref1 = payer || {}, name = ref1.name, email = ref1.email, phone = ref1.phone;
        if (!alreadyPaid && orderId) {
            //@ts-ignore
            options["order_id"] = orderId;
            //@ts-ignore
            // options["amount"] = 999; // not needed as cominf from backend
            //@ts-ignore
            options["prefill"] = {
                name: name || "",
                email: email || "",
                contact: phone || ""
            };
            // debugger;
            //@ts-ignore
            options["handler"] = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var _t, _$data;
                return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return (0,service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("/api/scholarRoute?path=payment/confirm/".concat(correlationId));
                        case 2:
                            _t = _ctx.sent;
                            _$data = _t.data.data;
                            if (_$data) {
                                res(_$data);
                            }
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            //@ts-ignore
            options["modal"] = {
                // triggers only when modal is closed explicitly
                ondismiss: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var _t, _$data;
                    return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=payment/confirm/".concat(correlationId));
                            case 2:
                                _t = _ctx.sent;
                                _$data = _t.data.data;
                                res(_$data);
                            case 5:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))
            };
            //@ts-ignore
            var razorpay = new Razorpay(options) // call razorpay sdk
            ;
            razorpay.open();
            //to capture failed payments
            razorpay.on("payment.error", (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var _t, _$data;
                return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=payment/confirm/".concat(correlationId));
                        case 2:
                            _t = _ctx.sent;
                            _$data = _t.data.data;
                            res(_$data);
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            })));
        } else {
            res(true);
        }
    });
};
var initRazorpayPaymentGenericBundle = function(props, data, toggleLoader) {
    return new Promise(function(res) {
        var formDescription = props.formDescription, currency = props.currency;
        var options = configurePaymentCheckoutForm(formDescription, currency);
        var ref = data || {}, orderId = ref.orderId, correlationId = ref.correlationId, payer = ref.payer, alreadyPaid = ref.alreadyPaid;
        var ref1 = payer || {}, name = ref1.name, email = ref1.email, phone = ref1.phone;
        if (!alreadyPaid && orderId) {
            //@ts-ignore
            options["order_id"] = orderId;
            //@ts-ignore
            // options["amount"] = 999; // not needed as cominf from backend
            //@ts-ignore
            options["prefill"] = {
                name: name || "",
                email: email || "",
                contact: phone || ""
            };
            // debugger;
            //@ts-ignore
            options["handler"] = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var _t, _$data;
                return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            toggleLoader && toggleLoader(true);
                            _ctx.next = 3;
                            return (0,service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("/api/scholarRoute?path=payment/confirm/".concat(correlationId, "/bundle/").concat(props.bundleName));
                        case 3:
                            _t = _ctx.sent;
                            _$data = _t.data.data;
                            toggleLoader && toggleLoader(false);
                            if (_$data) {
                                res(_$data);
                            }
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            //@ts-ignore
            options["modal"] = {
                // triggers only when modal is closed explicitly
                ondismiss: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var _t, _$data;
                    return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=payment/confirm/".concat(correlationId, "/bundle/").concat(props.bundleName));
                            case 2:
                                _t = _ctx.sent;
                                _$data = _t.data.data;
                                res(_$data);
                            case 5:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))
            };
            //@ts-ignore
            var razorpay = new Razorpay(options) // call razorpay sdk
            ;
            razorpay.open();
            //to capture failed payments
            razorpay.on("payment.error", (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var _t, _$data;
                return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=payment/confirm/".concat(correlationId, "/bundle/").concat(props.bundleName));
                        case 2:
                            _t = _ctx.sent;
                            _$data = _t.data.data;
                            res(_$data);
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            })));
        } else {
            res(true);
        }
    });
};


/***/ }),

/***/ 89208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bm": function() { return /* binding */ setTokenCookie; },
/* harmony export */   "r_": function() { return /* binding */ getTokenCookie; }
/* harmony export */ });
/* unused harmony export removeTokenCookie */
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62286);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(nookies__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51119);
/* harmony import */ var _DataMapper_Common_cookiesConstant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18472);



var TOKEN_NAME = "token";
var MAX_AGE = 60 * 60 * 24 * 365 // 365 days
;
var USER_ID = "user_id";
var ANALYTICS_USER_ID = "ajs_user_id";
var SESSION_TOKEN = "sessiontoken";
function setTokenCookie(ctx, token) {
    (0,nookies__WEBPACK_IMPORTED_MODULE_0__.setCookie)(ctx, TOKEN_NAME, token, {
        maxAge: MAX_AGE,
        expires: new Date(Date.now() + MAX_AGE * 1000),
        httpOnly: false,
        secure: "production" === "production",
        path: "/",
        sameSite: "lax"
    });
}
function removeTokenCookie(ctx) {
    destroyCookie(ctx, TOKEN_NAME, {
        maxAge: -1,
        path: "/"
    });
    destroyCookie(ctx, USER_ID, {
        maxAge: -1,
        path: "/"
    });
    deleteCookie(ctx, "platform");
    deleteCookie(ctx, "mefu_user");
    destroyCookie(ctx, ANALYTICS_USER_ID, {
        maxAge: -1,
        path: "/"
    });
    destroyCookie(ctx, SESSION_TOKEN, {
        maxAge: -1,
        path: "/"
    });
    destroyCookie(ctx, cookiesConstant.IP_COUNTRY_KEY);
}
function getTokenCookie(ctx) {
    var cookies = (0,nookies__WEBPACK_IMPORTED_MODULE_0__.parseCookies)(ctx);
    return cookies.token;
}


/***/ }),

/***/ 72714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ AuthToken; }
/* harmony export */ });
/* unused harmony export TOKEN_STORAGE_KEY */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52951);
/* harmony import */ var jwt_decode__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46489);
/* harmony import */ var jwt_decode__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jwt_decode__WEBPACK_IMPORTED_MODULE_0__);



var TOKEN_STORAGE_KEY = "leapscholar.authToken";
var AuthToken = /*#__PURE__*/ function() {
    "use strict";
    function AuthToken(token) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, AuthToken);
        this.token = token;
        // we are going to default to an expired decodedToken
        this.decodedToken = {
            email: "",
            exp: 0
        };
        // then try and decode the jwt using jwt-decode
        try {
            if (token) this.decodedToken = jwt_decode__WEBPACK_IMPORTED_MODULE_0___default()(token);
        } catch (e) {}
    }
    var _proto = AuthToken.prototype;
    _proto.getData = function getData() {
        return "Abhijeet Gairola";
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(AuthToken, [
        {
            key: "authorizationString",
            get: function get() {
                return "Bearer ".concat(this.token);
            }
        },
        {
            key: "expiresAt",
            get: function get() {
                return new Date(this.decodedToken.exp * 1000);
            }
        },
        {
            key: "isExpired",
            get: function get() {
                return new Date() > this.expiresAt;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return !this.isExpired;
            }
        },
        {
            key: "userCountry",
            get: function get() {
                var ref;
                return !this.isExpired && ((ref = this.decodedToken.user_id) === null || ref === void 0 ? void 0 : ref.country) || null;
            }
        }
    ]);
    return AuthToken;
}();


/***/ }),

/***/ 46442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ getUserInfo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var service_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14117);



var getUserInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=student/basic");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    return _ctx.abrupt("return", undefined);
                case 9:
                    _ctx.next = 15;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return", undefined);
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function getUserInfo() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 64342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BE": function() { return /* binding */ sortJSONWithThreeParameter; },
/* harmony export */   "xR": function() { return /* binding */ sortJSON; }
/* harmony export */ });
/* unused harmony export sortJSONWithTwoParameter */
function sortJSON(arr, key, asc) {
    return arr.sort(function(a, b) {
        var x = a[key];
        var y = b[key];
        if (asc) {
            return x < y ? -1 : x > y ? 1 : 0;
        } else {
            return x > y ? -1 : x < y ? 1 : 0;
        }
    });
}
function sortJSONWithTwoParameter(arr, key1, key2, asc) {
    return arr.sort(function(a, b) {
        var x = a[key1];
        var y = b[key1];
        var m = a[key2];
        var n = b[key2];
        if (asc) {
            return x < y ? -1 : x > y ? 1 : m < n ? -1 : m > n ? 1 : 0;
        } else {
            return x > y ? -1 : x < y ? 1 : m > n ? -1 : m < n ? 1 : 0;
        }
    });
}
function sortJSONWithThreeParameter(arr, key1, key2, key3, asc) {
    return arr.sort(function(a, b) {
        var x = a[key1];
        var y = b[key1];
        var m = a[key2];
        var n = b[key2];
        var l = a[key3];
        var k = b[key3];
        if (asc) {
            return x < y ? -1 : x > y ? 1 : m < n ? -1 : m > n ? 1 : l < k ? -1 : l > k ? 1 : 0;
        } else {
            return x > y ? -1 : x < y ? 1 : m > n ? -1 : m < n ? 1 : l > k ? -1 : l < k ? 1 : 0;
        }
    });
}


/***/ }),

/***/ 71210:
/***/ (function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ""));
function getDomainLocale(path, locale, locales, domainLocales) {
    if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
        return false;
    }
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 28045:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _defineProperty = (__webpack_require__(79361)/* ["default"] */ .Z);
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
var _toConsumableArray = (__webpack_require__(53929)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = Image;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(67294));
var _head = _interop_require_default(__webpack_require__(5443));
var _imageConfig = __webpack_require__(99309);
var _useIntersection = __webpack_require__(57190);
var _imageConfigContext = __webpack_require__(59977);
var _utils = __webpack_require__(63794);
var _normalizeTrailingSlash = __webpack_require__(82392);
function Image(_param) {
    var src = _param.src, sizes = _param.sizes, _unoptimized = _param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _priority = _param.priority, priority = _priority === void 0 ? false : _priority, loading = _param.loading, _lazyRoot = _param.lazyRoot, lazyRoot = _lazyRoot === void 0 ? null : _lazyRoot, lazyBoundary = _param.lazyBoundary, className = _param.className, quality = _param.quality, width = _param.width, height = _param.height, style = _param.style, objectFit = _param.objectFit, objectPosition = _param.objectPosition, onLoadingComplete = _param.onLoadingComplete, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "empty" : _placeholder, blurDataURL = _param.blurDataURL, all = _object_without_properties_loose(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "lazyRoot",
        "lazyBoundary",
        "className",
        "quality",
        "width",
        "height",
        "style",
        "objectFit",
        "objectPosition",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL"
    ]);
    var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    var config = (0, _react).useMemo(function() {
        var c = configEnv || configContext || _imageConfig.imageConfigDefault;
        var allSizes = _toConsumableArray(c.deviceSizes).concat(_toConsumableArray(c.imageSizes)).sort(function(a, b) {
            return a - b;
        });
        var deviceSizes = c.deviceSizes.sort(function(a, b) {
            return a - b;
        });
        return _extends({}, c, {
            allSizes: allSizes,
            deviceSizes: deviceSizes
        });
    }, [
        configContext
    ]);
    var rest = all;
    var layout = sizes ? "responsive" : "intrinsic";
    if ("layout" in rest) {
        // Override default layout if the user specified one:
        if (rest.layout) layout = rest.layout;
        // Remove property so it's not spread on <img>:
        delete rest.layout;
    }
    var loader = defaultImageLoader;
    if ("loader" in rest) {
        if (rest.loader) {
            var customImageLoader = rest.loader;
            var _tmp;
            _tmp = function(obj) {
                var _ = obj.config, opts = _object_without_properties_loose(obj, [
                    "config"
                ]);
                // The config object is internal only so we must
                // not pass it to the user-defined loader()
                return customImageLoader(opts);
            }, loader = _tmp, _tmp;
        }
        // Remove property so it's not spread on <img>
        delete rest.loader;
    }
    var staticSrc = "";
    if (isStaticImport(src)) {
        var staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!layout || layout !== "fill") {
            height = height || staticImageData.height;
            width = width || staticImageData.width;
            if (!staticImageData.height || !staticImageData.width) {
                throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    var isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if ( true && loadedImageURLs.has(src)) {
        isLazy = false;
    }
    if (experimentalUnoptimized) {
        unoptimized = true;
    }
    var ref = _slicedToArray((0, _react).useState(false), 2), blurComplete = ref[0], setBlurComplete = ref[1];
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootRef: lazyRoot,
        rootMargin: lazyBoundary || "200px",
        disabled: !isLazy
    }), 3), setIntersection = ref1[0], isIntersected = ref1[1], resetIntersected = ref1[2];
    var isVisible = !isLazy || isIntersected;
    var wrapperStyle = {
        boxSizing: "border-box",
        display: "block",
        overflow: "hidden",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var sizerStyle = {
        boxSizing: "border-box",
        display: "block",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var hasSizer = false;
    var sizerSvgUrl;
    var layoutStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        boxSizing: "border-box",
        padding: 0,
        border: "none",
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        minWidth: "100%",
        maxWidth: "100%",
        minHeight: "100%",
        maxHeight: "100%",
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    var widthInt = getInt(width);
    var heightInt = getInt(height);
    var qualityInt = getInt(quality);
    if (false) { var overwrittenStyles, url, urlStr, VALID_BLUR_EXT; }
    var imgStyle = Object.assign({}, style, layoutStyle);
    var blurStyle = placeholder === "blur" && !blurComplete ? {
        backgroundSize: objectFit || "cover",
        backgroundPosition: objectPosition || "0% 0%",
        filter: "blur(20px)",
        backgroundImage: 'url("'.concat(blurDataURL, '")')
    } : {};
    if (layout === "fill") {
        // <Image src="i.png" layout="fill" />
        wrapperStyle.display = "block";
        wrapperStyle.position = "absolute";
        wrapperStyle.top = 0;
        wrapperStyle.left = 0;
        wrapperStyle.bottom = 0;
        wrapperStyle.right = 0;
    } else if (typeof widthInt !== "undefined" && typeof heightInt !== "undefined") {
        // <Image src="i.png" width="100" height="100" />
        var quotient = heightInt / widthInt;
        var paddingTop = isNaN(quotient) ? "100%" : "".concat(quotient * 100, "%");
        if (layout === "responsive") {
            // <Image src="i.png" width="100" height="100" layout="responsive" />
            wrapperStyle.display = "block";
            wrapperStyle.position = "relative";
            hasSizer = true;
            sizerStyle.paddingTop = paddingTop;
        } else if (layout === "intrinsic") {
            // <Image src="i.png" width="100" height="100" layout="intrinsic" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.maxWidth = "100%";
            hasSizer = true;
            sizerStyle.maxWidth = "100%";
            sizerSvgUrl = "data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27".concat(widthInt, "%27%20height=%27").concat(heightInt, "%27/%3e");
        } else if (layout === "fixed") {
            // <Image src="i.png" width="100" height="100" layout="fixed" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.width = widthInt;
            wrapperStyle.height = heightInt;
        }
    } else {
        // <Image src="i.png" />
        if (false) {}
    }
    var imgAttributes = {
        src: emptyDataURL,
        srcSet: undefined,
        sizes: undefined
    };
    if (isVisible) {
        imgAttributes = generateImgAttrs({
            config: config,
            src: src,
            unoptimized: unoptimized,
            layout: layout,
            width: widthInt,
            quality: qualityInt,
            sizes: sizes,
            loader: loader
        });
    }
    var srcString = src;
    if (false) { var fullUrl; }
    var imageSrcSetPropName = "imagesrcset";
    var imageSizesPropName = "imagesizes";
    if (false) {}
    var _obj;
    var linkProps = (_obj = {}, // Note: imagesrcset and imagesizes are not in the link element type with react 17.
    _defineProperty(_obj, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_obj, imageSizesPropName, imgAttributes.sizes), _obj);
    var useLayoutEffect =  false ? 0 : _react.default.useLayoutEffect;
    var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    var previousImageSrc = (0, _react).useRef(src);
    (0, _react).useEffect(function() {
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    useLayoutEffect(function() {
        if (previousImageSrc.current !== src) {
            resetIntersected();
            previousImageSrc.current = src;
        }
    }, [
        resetIntersected,
        src
    ]);
    var imgElementArgs = _extends({
        isLazy: isLazy,
        imgAttributes: imgAttributes,
        heightInt: heightInt,
        widthInt: widthInt,
        qualityInt: qualityInt,
        layout: layout,
        className: className,
        imgStyle: imgStyle,
        blurStyle: blurStyle,
        loading: loading,
        config: config,
        unoptimized: unoptimized,
        placeholder: placeholder,
        loader: loader,
        srcString: srcString,
        onLoadingCompleteRef: onLoadingCompleteRef,
        setBlurComplete: setBlurComplete,
        setIntersection: setIntersection,
        isVisible: isVisible,
        noscriptSizes: sizes
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("span", {
        style: wrapperStyle
    }, hasSizer ? /*#__PURE__*/ _react.default.createElement("span", {
        style: sizerStyle
    }, sizerSvgUrl ? /*#__PURE__*/ _react.default.createElement("img", {
        style: {
            display: "block",
            maxWidth: "100%",
            width: "initial",
            height: "initial",
            background: "none",
            opacity: 1,
            border: 0,
            margin: 0,
            padding: 0
        },
        alt: "",
        "aria-hidden": true,
        src: sizerSvgUrl
    }) : null) : null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs))), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
var ref = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","dangerouslyAllowSVG":false} || {}, _experimentalRemotePatterns = ref.experimentalRemotePatterns, experimentalRemotePatterns = _experimentalRemotePatterns === void 0 ? [] : _experimentalRemotePatterns, experimentalUnoptimized = ref.experimentalUnoptimized;
var configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","dangerouslyAllowSVG":false};
var loadedImageURLs = new Set();
var allImgs = new Map();
var perfObserver;
var emptyDataURL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
if (false) {}
var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
var loaders = new Map([
    [
        "default",
        defaultLoader
    ],
    [
        "imgix",
        imgixLoader
    ],
    [
        "cloudinary",
        cloudinaryLoader
    ],
    [
        "akamai",
        akamaiLoader
    ],
    [
        "custom",
        customLoader
    ], 
]);
var VALID_LAYOUT_VALUES = (/* unused pure expression or super */ null && ([
    "fill",
    "fixed",
    "intrinsic",
    "responsive",
    undefined, 
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, layout, sizes) {
    var deviceSizes = param.deviceSizes, allSizes = param.allSizes;
    if (sizes && (layout === "fill" || layout === "responsive")) {
        // Find all the "vw" percent sizes used in the sizes prop
        var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        var percentSizes = [];
        for(var match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            var _Math;
            var smallestRatio = (_Math = Math).min.apply(_Math, _toConsumableArray(percentSizes)) * 0.01;
            return {
                widths: allSizes.filter(function(s) {
                    return s >= deviceSizes[0] * smallestRatio;
                }),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number" || layout === "fill" || layout === "responsive") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    var widths = _toConsumableArray(new Set(// > are actually 3x in the green color, but only 1.5x in the red and
    // > blue colors. Showing a 3x resolution image in the app vs a 2x
    // > resolution image will be visually the same, though the 3x image
    // > takes significantly more data. Even true 3x resolution screens are
    // > wasteful as the human eye cannot see that level of detail without
    // > something like a magnifying glass.
    // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
    [
        width,
        width * 2 /*, width * 3*/ 
    ].map(function(w) {
        return allSizes.find(function(p) {
            return p >= w;
        }) || allSizes[allSizes.length - 1];
    })));
    return {
        widths: widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    var config = param.config, src = param.src, unoptimized = param.unoptimized, layout = param.layout, width = param.width, quality = param.quality, sizes = param.sizes, loader = param.loader;
    if (unoptimized) {
        return {
            src: src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    var ref = getWidths(config, width, layout, sizes), widths = ref.widths, kind = ref.kind;
    var last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map(function(w, i) {
            return "".concat(loader({
                config: config,
                src: src,
                quality: quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind);
        }).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config: config,
            src: src,
            quality: quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number") {
        return x;
    }
    if (typeof x === "string") {
        return parseInt(x, 10);
    }
    return undefined;
}
function defaultImageLoader(loaderProps) {
    var ref;
    var loaderKey = ((ref = loaderProps.config) == null ? void 0 : ref.loader) || "default";
    var load = loaders.get(loaderKey);
    if (load) {
        return load(loaderProps);
    }
    throw new Error('Unknown "loader" found in "next.config.js". Expected: '.concat(_imageConfig.VALID_LOADERS.join(", "), ". Received: ").concat(loaderKey));
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, layout, placeholder, onLoadingCompleteRef, setBlurComplete) {
    if (!img || img.src === emptyDataURL || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    var p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(function() {}).then(function() {
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        loadedImageURLs.add(src);
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
            var naturalWidth = img.naturalWidth, naturalHeight = img.naturalHeight;
            // Pass back read-only primitive values but not the
            // underlying DOM element because it could be misused.
            onLoadingCompleteRef.current({
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight
            });
        }
        if (false) { var parent, ref; }
    });
}
var ImageElement = function(_param) {
    var imgAttributes = _param.imgAttributes, heightInt = _param.heightInt, widthInt = _param.widthInt, qualityInt = _param.qualityInt, layout = _param.layout, className = _param.className, imgStyle = _param.imgStyle, blurStyle = _param.blurStyle, isLazy = _param.isLazy, placeholder = _param.placeholder, loading = _param.loading, srcString = _param.srcString, config = _param.config, unoptimized = _param.unoptimized, loader = _param.loader, onLoadingCompleteRef = _param.onLoadingCompleteRef, setBlurComplete = _param.setBlurComplete, setIntersection = _param.setIntersection, onLoad = _param.onLoad, onError = _param.onError, isVisible = _param.isVisible, noscriptSizes = _param.noscriptSizes, rest = _object_without_properties_loose(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "layout",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setIntersection",
        "onLoad",
        "onError",
        "isVisible",
        "noscriptSizes"
    ]);
    loading = isLazy ? "lazy" : loading;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        decoding: "async",
        "data-nimg": layout,
        className: className,
        style: _extends({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback(function(img) {
            if (false) {}
            setIntersection(img);
            if (img == null ? void 0 : img.complete) {
                handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            }
        }, [
            setIntersection,
            srcString,
            layout,
            placeholder,
            onLoadingCompleteRef,
            setBlurComplete, 
        ]),
        onLoad: function(event) {
            var img = event.currentTarget;
            handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            if (onLoad) {
                onLoad(event);
            }
        },
        onError: function(event) {
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })), (isLazy || placeholder === "blur") && /*#__PURE__*/ _react.default.createElement("noscript", null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, generateImgAttrs({
        config: config,
        src: srcString,
        unoptimized: unoptimized,
        layout: layout,
        width: widthInt,
        quality: qualityInt,
        sizes: noscriptSizes,
        loader: loader
    }), {
        decoding: "async",
        "data-nimg": layout,
        style: imgStyle,
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading
    }))));
};
function normalizeSrc(src) {
    return src[0] === "/" ? src.slice(1) : src;
}
function imgixLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://static.imgix.net/daisy.png?auto=format&fit=max&w=300
    var url = new URL("".concat(config.path).concat(normalizeSrc(src)));
    var params = url.searchParams;
    params.set("auto", params.get("auto") || "format");
    params.set("fit", params.get("fit") || "max");
    params.set("w", params.get("w") || width.toString());
    if (quality) {
        params.set("q", quality.toString());
    }
    return url.href;
}
function akamaiLoader(param) {
    var config = param.config, src = param.src, width = param.width;
    return "".concat(config.path).concat(normalizeSrc(src), "?imwidth=").concat(width);
}
function cloudinaryLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
    var params = [
        "f_auto",
        "c_limit",
        "w_" + width,
        "q_" + (quality || "auto")
    ];
    var paramsString = params.join(",") + "/";
    return "".concat(config.path).concat(paramsString).concat(normalizeSrc(src));
}
function customLoader(param) {
    var src = param.src;
    throw new Error('Image with src "'.concat(src, '" is missing "loader" prop.') + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
}
function defaultLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    if (false) { var hasMatch, parsedSrc, missingValues; }
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat((0, _normalizeTrailingSlash).normalizePathTrailingSlash(config.path), "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 48418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
var _typeOf = (__webpack_require__(45753)["default"]);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _router = __webpack_require__(76273);
var _addLocale = __webpack_require__(22725);
var _routerContext = __webpack_require__(63462);
var _appRouterContext = __webpack_require__(21018);
var _useIntersection = __webpack_require__(57190);
var _getDomainLocale = __webpack_require__(71210);
var _addBasePath = __webpack_require__(98684);
// @ts-ignore useTransition exist
var hasUseTransition = typeof _react.default.useTransition !== "undefined";
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    router.prefetch(href, as, options).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, soft, shallow, scroll, locale, startTransition) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    var navigate = function() {
        // If the router is an AppRouterInstance, then it'll have `softPush` and
        // `softReplace`.
        if ("softPush" in router && "softReplace" in router) {
            // If we're doing a soft navigation, use the soft variants of
            // replace/push.
            var method = soft ? replace ? "softReplace" : "softPush" : replace ? "replace" : "push";
            router[method](href);
        } else {
            router[replace ? "replace" : "push"](href, as, {
                shallow: shallow,
                locale: locale,
                scroll: scroll
            });
        }
    };
    if (startTransition) {
        startTransition(navigate);
    } else {
        navigate();
    }
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, soft = props.soft, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onTouchStart = props.onTouchStart, _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "soft",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var ref = _slicedToArray(hasUseTransition ? // @ts-ignore useTransition exists
    // eslint-disable-next-line react-hooks/rules-of-hooks
    _react.default.useTransition() : [], 2), /* isPending */ startTransition = ref[1];
    var router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    var ref1 = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref1.href, as = ref1.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref2 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref2[0], isVisible = ref2[1], resetVisible = ref2[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, soft, shallow, scroll, locale, appRouter ? startTransition : undefined);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            if ((0, _router).isLocalURL(href)) {
                prefetch(router, href, as, {
                    priority: true
                });
            }
        },
        onTouchStart: function(e) {
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            if ((0, _router).isLocalURL(href)) {
                prefetch(router, href, as, {
                    priority: true
                });
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 57190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(67294);
var _requestIdleCallback = __webpack_require__(9311);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var unobserve = (0, _react).useRef();
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (unobserve.current) {
                unobserve.current();
                unobserve.current = undefined;
            }
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                unobserve.current = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
            }
            return function() {
                unobserve.current == null ? void 0 : unobserve.current();
                unobserve.current = undefined;
            };
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 46029:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
var _classCallCheck = (__webpack_require__(79658)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(7222)/* ["default"] */ .Z);
var _inherits = (__webpack_require__(97788)/* ["default"] */ .Z);
var _interopRequireDefault = (__webpack_require__(92648)/* ["default"] */ .Z);
var _createSuper = (__webpack_require__(37735)/* ["default"] */ .Z);
var _runtimeJs = /*#__PURE__*/ _interopRequireDefault(__webpack_require__(34051));
__webpack_unused_export__ = ({
    value: true
});
__webpack_unused_export__ = ({
    enumerable: true,
    get: function get() {
        return _utils.AppInitialProps;
    }
});
__webpack_unused_export__ = ({
    enumerable: true,
    get: function get() {
        return _utils.NextWebVitalsMetric;
    }
});
exports["default"] = void 0;
var _async_to_generator = (__webpack_require__(60932)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _utils = __webpack_require__(63794);
function appGetInitialProps(_) {
    return _appGetInitialProps.apply(this, arguments);
}
function _appGetInitialProps() {
    _appGetInitialProps = /**
 * `App` component is used for initialize of pages. It allows for overwriting and full control of the `page` initialization.
 * This allows for keeping state between navigation, custom error handling, injecting additional data.
 */ _async_to_generator(_runtimeJs.default.mark(function _callee(param) {
        var Component, ctx, pageProps;
        return _runtimeJs.default.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    Component = param.Component, ctx = param.ctx;
                    _ctx.next = 3;
                    return (0, _utils).loadGetInitialProps(Component, ctx);
                case 3:
                    pageProps = _ctx.sent;
                    return _ctx.abrupt("return", {
                        pageProps: pageProps
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _appGetInitialProps.apply(this, arguments);
}
var _Component;
var App = /*#__PURE__*/ function(_superClass) {
    _inherits(App, _superClass);
    var _super = _createSuper(App);
    function App() {
        _classCallCheck(this, App);
        return _super.apply(this, arguments);
    }
    _createClass(App, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, Component = _props.Component, pageProps = _props.pageProps;
                return /*#__PURE__*/ _react.default.createElement(Component, Object.assign({}, pageProps));
            }
        }
    ]);
    return App;
}(_Component = _react.default.Component);
App.origGetInitialProps = appGetInitialProps;
App.getInitialProps = appGetInitialProps;
exports["default"] = App; //# sourceMappingURL=_app.js.map


/***/ }),

/***/ 21018:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
var LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
var GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 90638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(96856)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadable = _interop_require_default(__webpack_require__(14302));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 16319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(79658)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(7222)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadableContext = __webpack_require__(16319);
var useSyncExternalStore = ( false ? 0 : __webpack_require__(61688)).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 66089:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(65988); //# sourceMappingURL=styled-jsx.js.map


/***/ }),

/***/ 12615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$S": function() { return /* binding */ handleDynamicQueryStrings; },
/* harmony export */   "CZ": function() { return /* binding */ navRoutes; },
/* harmony export */   "O5": function() { return /* binding */ ieltsContactInfo; },
/* harmony export */   "QB": function() { return /* binding */ menaAccountLink; },
/* harmony export */   "ZK": function() { return /* binding */ ieltsContactInfo2; },
/* harmony export */   "_2": function() { return /* binding */ ieltsFlowPages; },
/* harmony export */   "jb": function() { return /* binding */ menaLoggInStickyLinks; },
/* harmony export */   "lC": function() { return /* binding */ singleLinks; },
/* harmony export */   "ns": function() { return /* binding */ contactInfo; },
/* harmony export */   "ow": function() { return /* binding */ navbarLinks; },
/* harmony export */   "wi": function() { return /* binding */ loggenInStickyLinks; }
/* harmony export */ });
/* unused harmony exports getProfileIeltsPlus, USAPageRoutes */
/* harmony import */ var DataMapper_IeltsProfile_MockTest__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33447);
/* harmony import */ var utils_url_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54728);


var navRoutes = {
    HOMEPAGE: "/",
    WC_FORM: "/profile-information",
    SKU_WC_FORM: "/flow/onboarding-info",
    VN_DASHBOARD: "/profile/dashboard",
    HOMEPAGECOPY: "/home",
    WEBFLOW_PROGRESSIVE_FORM: "/webflow_progressive_form",
    ABOUT_US: "/about-us",
    PRIVACY_PAGE: "/privacy",
    TERM_AND_CONDITION: "/terms",
    REFUND_POLICY: "/refund-policy",
    MENTORS: "/mentors",
    COUNSELLORS: "/counsellors",
    SCHOLARSHIP: "/scholarship-finder",
    SCHOALRSHIP_APPLICATION: "/scholarship-finder",
    SCHOALRSHIP_FAQ: "/scholarship-finder",
    FIND_UNIVERSITY: "/college-list",
    USA_MENTORS: "/connect-with-mentors",
    USA_MENTOR_VIDEOS: "/mentor-videos",
    USA_MENTOR_VIDEOS_VIDEO: "/mentor-videos/[video]",
    COUNTRY_COLLEGE: "/[country]/[college]",
    COUNTRY_COLLEGE_ALLCOURSES: "/[country]/[college]/all-courses",
    COUNTRY_COLLEGE_COURSE: "/[country]/[college]/[course]",
    IELTS_PAGE: "/ielts-free-online-coaching",
    NEW_MASTERCLASS_LANDING_PAGE: "/ielts-masterclass",
    IELTS_CRASH_COURSE: "/ielts-preparation-online/crash_course",
    IELTS_FREE_CRASH_COURSE: "/ielts-preparation-online/free_crash_course",
    IELTS_AI_EVALUTION: "/ielts-preparation-online/smartTests",
    IELTS_ALL_BATCHES: "/ielts-preparation-online/crash_course/all_batches",
    IELTS_BATCHES_PAGE: "/ielts-preparation-online/crash_course/ielts_batches",
    IELTS_FOUNDATION_BATCH: "/ielts-preparation-online/crash_course/all_batches?batch=foundation",
    IELTS_PLUS_BATCH: "/ielts-preparation-online/crash_course/all_batches?batch=plus",
    IELTS_PREMIUM_BATCH: "/ielts-preparation-online/crash_course/all_batches?batch=premium",
    IELTS_JOIN_WAITLIST: "/ielts-preparation-online/crash_course/join_waitlist",
    IELTS_BATCH_DETAILS: "/ielts-preparation-online/crash_course/[location]/[batchId]",
    PROFILE: "/profile",
    PROFILE_MASTERCLASS: "/profile?flowType=ielts&section=ieltsMasterclass",
    EVENTS: "/events",
    EVENTS_DETAILS: "/events/[eventId]",
    BOOK_IELTS_DEMO_FLOW: "/ielts-preparation-online/ielts-elite-demo/user-details-form",
    BOOK_IELTS_DEMO_FORM_MENA: "/ielts-preparation-online/user-details-form?form_version=2",
    RESCHEDULE_IELTS_DEMO: "/ielts-preparation-online/ielts-elite-demo",
    PTE_ALL_BATCH: "/pte/all_batches",
    DET_ALL_BATCH: "/det-prep-online/all_batches",
    // Login Based URLs
    LOGIN_IELTS: "/api/login?callbackUrl=".concat(encodeURIComponent("/profile?flowType=ielts&section=ieltsPlus")),
    LOGIN_IELTS_MASTERCLASS: "/api/login?callbackUrl=".concat(encodeURIComponent("/profile?flowType=ielts&section=ieltsMasterclass")),
    LOGIN_IELTS_PRO: "/api/login?callbackUrl=".concat(encodeURIComponent("/profile?flowType=ielts")),
    LOGIN_COUNSELLING: "/api/login?callbackUrl=".concat(encodeURIComponent("/profile?flowType=counselling")),
    LOGIN_PROFILE: "/api/login?callbackUrl=".concat(encodeURIComponent("/profile/user_acquried")),
    POSTLOGIN_COUNSELLING: "/profile",
    POSTLOGIN_IETLS_MASTERCLASS: "/profile/ielts_plus/overview?flowType=ielts",
    POSTLOGIN_IELTS_PRO: "/profile/ielts_plus/overview?flowType=ielts",
    REDIRECTION_IELTS_COMMUNITY: "/api/login?callbackUrl=".concat(encodeURIComponent("/profile/join_ielts_community?redirect=/ielts-free-online-coaching&community=https://t.me/LeapScholar_IELTS_prep")),
    USER_ACQUIRED: "/profile/counselling/user_acquried",
    LEAD_CAPTURE: "/profile/counselling/lead_capture",
    CALL_SCHEDULED: "/profile/counselling/call_scheduled",
    CALL_DONE: "/profile/counselling/call_done",
    PAYMENT_DONE: "/profile/counselling/payment_done",
    REDIRECTION_COMMUNITY: "/api/login?callbackUrl=".concat(encodeURIComponent("/profile/join_ielts_community?redirect=/&community=https://t.me/joinchat/TvPaO3upIMaYMHJd")),
    APPLY_FOR_SCHOLARSHIP: "/profile/apply-for-scholarship",
    IELTS_REGISTRATION_FORM: "/profile/ielts_pro_registration",
    MASTERCLASS_REGISTRATION_FORM: "/profile/masterclass_registration",
    SINGLE_DOCUMENT_UPLOAD_FORM: "/profile/single_document_upload",
    IELTS_STUDENT_DASHBOARD: "/test-prep/dashboard",
    MEA_IELTS_STUDENT_DASHBOARD: "/profile/ielts-dashboard",
    IELTS_PLUS: "/profile/ielts_plus/[screen]",
    IELTS_NOTICE_BOARD: "/profile/ielts_plus/notice_board",
    IELTS_CLASS_RECORDINGS: "/test-prep/dashboard/video-course",
    IELTS_STUDY_MATERIAL: "/test-prep/dashboard/study-material",
    IELTS_SPEAKING_CLUB: "/profile/ielts_plus/speaking_club",
    IELTS_CLASS_LIST: "/profile/ielts_plus/class_list",
    IELTS_MOCK_TEST: "/profile/ielts_plus/mock_test",
    IELTS_TEST_PREP_MOCK_TEST: "/profile/ielts/mocktest",
    IELTS_CERTIFICATES: "/profile/ielts_plus/certificate",
    PROFILE_SCHOLARSHIP: "/profile/scholarship",
    REGISTER_FOR_FINANCIAL_COUNSELLING: "/profile/register_for_financial_counselling",
    REGISTER_FOR_IELTS: "/profile/register_for_ielts",
    IELTS_ESSAY_EVALUATION: "/profile/ielts_plus/essay_evaluation",
    CAREERS_PAGE: "https://leapfinance.freshteam.com/jobs",
    IELTS_TO_COUNSELLING_NUDGE: "/counselling-nudge",
    LOGIN_IELTS_VIA_NAV: "/api/login?callbackUrl=".concat(encodeURIComponent("/profile?flowType=ielts&type=navbar")),
    LOGIN_COUNSELLING_VIA_NAV: "/api/login?callbackUrl=".concat(encodeURIComponent("/profile?flowType=counselling&type=navbar")),
    MEETING_FINDER: "/meeting-finder",
    LIVE_CALENDAR_FINDER: "/live-calendar-finder",
    CRACK_IELTS_FAST_TRACK: "https://crackielts.leapscholar.com/ls-ielts-fasttrack",
    FAST_TRACK_LANDING_PAGE: "/ielts-preparation-online/fast_track",
    FAST_TRACK_VIDEO: "/profile/fast_track_video",
    FAST_TRACK_FORM: "/profile/fast_track_registration",
    FAST_TRACK: "/profile/ielts_plus/fast_track",
    PLUS_UPCOMING_CLASS: "/profile/ielts_plus/plus_class",
    PLUS_COMPLETE_CLASS: "/profile/ielts_plus/plus_complete",
    PTE_DASBOARD: "/test-prep/pte-exam/dashboard",
    DET_DASHBOARD: "/test-prep/det-exam/dashboard",
    //new paths for counselling flow - start
    HOME: "/profile/counselling",
    COUNSELLING_OVERVIEW: "/profile/counselling/overview",
    COUNSELLING_MY_UNIVERSITIES: "/profile/counselling/my_universities",
    COUNSELLING_DOCUMENT_DETAILS: "/profile/counselling/document_details",
    COUNSELLING_NOTICE_BOARD: "/profile/counselling/notice_board",
    COUNSELLING_UPCOMING_APPOINTMENTS: "/profile/counselling/upcoming_appointments",
    COUNSELLING_FINANCIAL_ASSISTANCE: "/profile/counselling/financial_assistance",
    COUNSELLING_VISA_ASSISTANCE: "/profile/counselling/visa_assistance",
    USER_BOOKMARKS_SCREEN: "/profile/counselling/bookmarks",
    //new path for counselling floe - end
    TELEGRAM_FAST_TRACK: "https://t.me/joinchat/P6eGFG2AHWdmNWFl",
    OFFER_DETAILS: "/profile/counselling/offer",
    MASTERCLASS_MOCK_TEST: "/profile/ielts_plus/mock_test?".concat(DataMapper_IeltsProfile_MockTest__WEBPACK_IMPORTED_MODULE_0__/* .MOCK_TEST_TYPE */ .sX, "=").concat(DataMapper_IeltsProfile_MockTest__WEBPACK_IMPORTED_MODULE_0__/* .mockTestCategory.masterclass_mock_test */ .Fd.masterclass_mock_test),
    MOCK_TEST_PRODUCT: "https://pages.razorpay.com/ielts-mock-tests",
    CHAT: "/profile/chat",
    INITIAL_SHORTLIST: "/profile/counselling/initial-shortlist",
    IELTS_REWARDS: "/profile/ielts/rewards",
    MASTERCLASS_LIST: "/profile/ielts_plus/masterclass_list",
    PROFILE_NAV: "/profile?type=navbar",
    REPLAYS_VIDEO_LIST: "/profile/replays",
    EXTRA_CLASS_LIST: "/profile/ielts_plus/extraclass_list",
    IELTS_QUIZ: "/profile/ielts_quiz",
    IELTS_COMPLETE_QUIZ: "/profile/ielts_quiz?section=complete",
    BOOK_IELTS_TEST: "/profile/counselling/book_ielts_exam",
    MASTERCLASS_TYPE: "/ielts-preparation-online/masterclass",
    BEGINNER_MASTERCLASS: "/ielts-preparation-online/masterclass?type=beginner",
    CLASSIC_MASTERCLASS: "/ielts-preparation-online/masterclass?type=classic",
    ALL_PLUS_EXCLUSIVE: "/ielts-preparation-online/masterclass?type=PLUS_EXCLUSIVE",
    COUNSELLING_APP: "https://play.google.com/store/apps/details?id=com.leapscholar.app",
    IELTS_APP: "https://leapielts.app.link/open",
    JOIN_CLASS: "/profile/join/",
    IELTS_TEST: "/profile/ielts_test",
    SEO_PILLER_PAGE: "/exams/ielts",
    // TOFU Landing Pages
    USA_HOMEPAGE: "/usa",
    CANADA_HOMEPAGE: "/canada",
    AUSTRALIA_HOMEPAGE: "/australia",
    UK_HOMEPAGE: "/uk",
    IRELAND_HOMEPAGE: "/ireland",
    GERMANY_HOMEPAGE: "/germany",
    TOFU_VN_EXPERIMENT: "/spot-counselling/experiment-redirect",
    //Spot Counselling
    SPOT_COUNSELLING: "/spot-counselling",
    SPOT_COUNSELLING_CALENDER: "/spot-counselling/calender",
    SPOT_COUNSELLING_PAYMENT: "/spot-counselling/payment",
    SPOT_COUNSELLING_PAYMENT_CONFIRMATION: "/spot-counselling/payment-confirmation",
    //autoLS pages
    NEW_LIVEPAGE_AUTOLS: "/get-live-counselling",
    SC_PROFILE: "/profile/counselling/sc_profile",
    SPOT_COUNSELLING_ONBOARD: "/spot-counselling/onboard",
    AUTOLS_CONFIRMATION_PAGE: "/spot-counselling/autols-confirmation",
    MOCK_TEST_LANDING_PAGE: "/profile/ielts_plus/ielts_mock_test",
    IELTS_BATCHCLASS_SCHEDULE_PAGE: "/profile/ielts_plus/ielts_batch_schedule",
    PRACTISE_TAB: "/android_app/module",
    ANDROID_MOCK_TEST: "/profile/ielts_plus/app_mock?mock_test_type=event_mock_test",
    ANDROID_MOCK_TEST2: "https://leapielts.app.link/open/ielts_mock_test",
    ANDROID_VOICE_ROOMS: "https://leapielts.app.link/open/voiceroom",
    ANDROID_JOIN_BATCH_CLASS: "https://leapielts.app.link/open/join_class",
    ANDROID_IELTS_APP: "https://leapielts.app.link/open/",
    IOS_ZOOM_APP: "https://apps.apple.com/in/app/zoom-one-platform-to-connect/id546505307?utm_source=website&utm_medium=iOS&utm_campaign=dashboard",
    IELTS_MOCK_TEST_PAGE: (0,utils_url_utils__WEBPACK_IMPORTED_MODULE_1__/* .getIeltsMockTestUrl */ .xC)("exam/IELTS"),
    IELTS__COUNSELLING_TAB: "/ielts-counselling-webview",
    PROFILE_COMMUNITY: "/profile/community",
    PROFILE_COMMUNITY_FEED: "/profile/community/feed",
    PROFILE_COMMUNITY_CREATE: "/profile/community/create_post",
    PROFILE_COMMUNITY_TOPICS: "/profile/community/all_topics",
    PROFILE_COMMUNITY_SEARCH: "/profile/community/search",
    PROFILE_COMMUNITY_PROFILE: "/profile/community/community_profile",
    PROFILE_COMMUNITY_TOPIC: "/profile/community/topic",
    PROFILE_COMMUNITY_POST_VIEW: "/profile/community/view",
    VIEW_ALL_IELTS_BATCHES: "/profile/ielts_plus/view_all",
    FREE_RESOURCE: "/profile/ielts_plus/free_resource",
    EXPIRED_CLASS: "/profile/ielts_plus/expired_class",
    IELTS_INTERMEDIATE_SCREEN: "/profile/ielts/",
    IELTS_ELITE_SLOTS_SCREEN: "/ielts-preparation-online/ielts-elite-demo",
    SPEAKING_EVALUATION: "/profile/speaking_evaluation",
    IELTS_COURSE_LIST_PAGE: "/ielts-preparation-online/courses",
    IELTS_DEMO_REWARDS_PAGE: "/profile/ielts/demo-rewards",
    ANDROID_DASHBOARD: "https://leapielts.app.link",
    ANDROID_MASTERCLASS: "https://leapielts.app.link/open/masterclass",
    IELTS_ONBOARDING_SCREEN: "/profile/onboarding",
    PTE_ONBOARDING_SCREEN: "/profile/pte-onboarding",
    DET_ONBOARDING_SCREEN: "/profile/det-onboarding",
    ANDROID_MOCKTEST: "https://leapielts.app.link/open/tabmocktests",
    IELTS_SELECT_INSTRUCTION_PDF: "https://ls.leapscholar.com/selectbatchusermanual",
    IELTS_ELITE_INSTRUCTION_PDF: "https://ls.leapscholar.com/Elitebatchusermanual",
    //Bofu Pages
    ONBOARDING_PAGE: "/onboarding",
    VO_CALENDAR_PAGE: "/profile/counselling/vo-calendar",
    UPDATE_PROFILE: "/profile/update-profile",
    DOCUMENTS_UPLOAD: "/profile/documents_upload",
    VISA_DOCUMENTS_UPLOAD: "/profile/visa-documents-upload",
    BOFU_APP_DOWNLOAD: "/AppDownload",
    IELTS_EXPIRED_CLASS_LIST: "/profile/ielts_plus/expired_class_list",
    IELTS_DEMO_FLOW_FOR_DISQUALIFIED_USERS: "/ielts-preparation-online/ielts-elite-demo/unlock",
    REDIRECT_PAGE: "/redirectPageV2",
    ME_USER_LOGOUT: "/api/ielts-dashboard/dashboard_logout",
    IELTS_LIY_MOCK_TEST: "/profile/ielts/liy-mocktest",
    COUSNELLOR_ASSIGNED_PAGE: "/profile/counselling/counsellor-assignment",
    redirectingPage: "/redirecting-page",
    SELF_PREP: "/profile/ielts/self-prep",
    LIY_LANDING_PAGE_WEBFLOW: "https://ielts.leapscholar.com/ielts-learn-it-yourself-launch",
    IELTS_INDIA_REFERAL_T_AND_C: "https://ls.leapscholar.com/referraltnc",
    IELTS_MENA_REFERAL_T_AND_C: "https://ls.leapscholar.com/refmenaielts",
    SAT_MENA_REFERAL_T_AND_C: "https://ls.leapscholar.com/sat-referral-terms-and-conditions-uae",
    SAT_SAUDI_REFERRAL_LINK: "https://ls.leapscholar.com/Sat-referral-terms-and-conditions",
    FLSE_FEEDBACK: "/test-prep/dashboard/flse/feedback",
    IELTS_MOCKTEST: "/test-prep/dashboard/ielts-mocktest",
    IELTS_REFERRAL: "/ielts-referral",
    PRACTICE_MODULE: "/test-prep/dashboard/practice",
    IELTS_DEMO_DQL_PAGE: "/ielts-preparation-online/ielts-elite-demo/demo-thank-you",
    IELTS_DEMO_QL_PAGE: "/ielts-preparation-online/ielts-elite-demo/demo-slots-booking",
    SAT_REFERRAL: "/sat-referral",
    SAT_COUNSELLOR_WHATSAAP: "https://wa.me/971501469115?text=I%27m%20interested%20in%20your%20SAT%20Bootcamp%20",
    IELTS_APP_MENA: "https://leapielts.app.link/mena-app-download"
};
var handleDynamicQueryStrings = function(dynamicParam) {
    var bundleName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "IELTS_PLUS";
    return "/api/login?callbackUrl=".concat(encodeURIComponent("/profile?flowType=ielts&section=ieltsPlus&".concat(dynamicParam, "&bundle=").concat(bundleName)));
};
var getProfileIeltsPlus = function(batchId) {
    var bundleName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "IELTS_PLUS";
    return "/profile?flowType=ielts&section=ieltsPlus&batch=".concat(batchId, "&bundle=").concat(bundleName);
};
//****** all usa page routes - start *****//
var USA_HOMEPAGE = navRoutes.USA_HOMEPAGE, FIND_UNIVERSITY = navRoutes.FIND_UNIVERSITY, USA_MENTORS = navRoutes.USA_MENTORS, USA_MENTOR_VIDEOS = navRoutes.USA_MENTOR_VIDEOS, USA_MENTOR_VIDEOS_VIDEO = navRoutes.USA_MENTOR_VIDEOS_VIDEO, COUNTRY_COLLEGE = navRoutes.COUNTRY_COLLEGE, COUNTRY_COLLEGE_ALLCOURSES = navRoutes.COUNTRY_COLLEGE_ALLCOURSES, COUNTRY_COLLEGE_COURSE = navRoutes.COUNTRY_COLLEGE_COURSE;
var USAPageRoutes = [
    USA_HOMEPAGE,
    FIND_UNIVERSITY,
    USA_MENTORS,
    USA_MENTOR_VIDEOS,
    USA_MENTOR_VIDEOS_VIDEO,
    COUNTRY_COLLEGE,
    COUNTRY_COLLEGE_ALLCOURSES,
    COUNTRY_COLLEGE_COURSE, 
];
//****** all usa page routes - end *****//
var navbarLinks = {
    "Study Abroad": {
        text: "Study Abroad",
        links: [
            {
                text: "Study in USA",
                link: "/usa",
                isTargetBlank: false
            },
            {
                text: "Study in UK",
                link: "/uk",
                isTargetBlank: false
            },
            {
                text: "Study in Canada",
                link: "/canada",
                isTargetBlank: false
            },
            {
                text: "Study in Australia",
                link: "/australia",
                isTargetBlank: false
            },
            {
                text: "Study in Ireland",
                link: "/ireland",
                isTargetBlank: false
            },
            {
                text: "Study in Germany",
                link: "/germany",
                isTargetBlank: false
            },
            {
                text: "Our Counsellors",
                link: "/counsellors",
                isTargetBlank: false
            },
            {
                text: "Master’s Programs",
                link: "https://advantage.leapscholar.com/",
                isTargetBlank: true
            },
            {
                text: "Undergraduate Programs",
                link: "https://advantage.leapscholar.com/for-undergrad",
                isTargetBlank: true
            }, 
        ],
        icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/study-abroad.svg"
    },
    IELTS: {
        text: "IELTS",
        links: [
            {
                text: "IELTS Booking Details",
                link: null,
                breadcrumb: "Booking",
                nestedSubmenu: [
                    {
                        text: "IELTS Dates",
                        link: "/exams/ielts/dates"
                    },
                    {
                        text: "IELTS Fees",
                        link: "/exams/ielts/fees"
                    },
                    {
                        text: "IELTS Centres",
                        link: "/exams/ielts/centre"
                    },
                    {
                        text: "IELTS Registration",
                        link: "/exams/ielts/registration"
                    },
                    {
                        text: "IELTS Slot Booking",
                        link: "/exams/ielts/slot-booking"
                    }, 
                ]
            },
            {
                text: "IELTS Module Details",
                link: null,
                breadcrumb: "Module",
                nestedSubmenu: [
                    {
                        text: "IELTS Module Overview",
                        link: "/exams/ielts/modules"
                    },
                    {
                        text: "Speaking Details",
                        link: "/exams/ielts/modules/speaking-overview"
                    },
                    {
                        text: "Listening Details",
                        link: "/exams/ielts/modules/listening-overview"
                    },
                    {
                        text: "Writing Details",
                        link: "/exams/ielts/modules/writing-overview"
                    },
                    {
                        text: "Reading Details",
                        link: "/exams/ielts/modules/reading-overview"
                    }, 
                ]
            },
            {
                text: "IELTS Practice Test",
                link: "/exams/ielts/practice-test"
            },
            {
                text: "IELTS Exam Overview",
                link: "/exams/ielts"
            },
            {
                text: "Paid IELTS Courses",
                link: "/exams/ielts/preparation-online",
                hideInLoggedInState: true
            },
            {
                text: "Free IELTS Masterclass",
                link: "/ielts-free-online-coaching",
                hideInLoggedInState: true
            },
            {
                text: "Important IELTS Articles",
                link: "/blog/category/ielts-preparation/",
                isTargetBlank: true
            }, 
        ],
        icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/ielts.svg"
    },
    "Download App": {
        text: "Download App",
        links: [
            {
                text: "Counselling App",
                link: "https://play.google.com/store/apps/details?id=com.leapscholar.app",
                isTargetBlank: true
            },
            {
                text: "IELTS Prep App",
                link: "https://leapielts.app.link/open",
                isTargetBlank: true
            }, 
        ],
        icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/download-app.svg"
    },
    Account: {
        text: "Account",
        links: [
            {
                text: "Profile",
                link: "/profile?type=navbar",
                isTargetBlank: false
            },
            {
                text: "Log Out",
                link: "/api/logout",
                isTargetBlank: false
            }, 
        ],
        icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/account.svg"
    }
};
var menaAccountLink = {
    Account: {
        icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/account.svg",
        text: "Account",
        links: [
            {
                text: "Profile",
                link: navRoutes.IELTS_STUDENT_DASHBOARD,
                isTargetBlank: false
            },
            {
                text: "Log Out",
                link: "/api/logout",
                isTargetBlank: false
            }, 
        ]
    }
};
var contactInfo = [
    {
        text: "(080) 47184844",
        link: "tel:+918047184844",
        icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/call.svg",
        contentName: "Phone"
    },
    {
        text: "contact@leapscholar.com",
        link: "mailto:contact@leapscholar.com",
        icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/email.svg",
        contentName: "Email"
    }, 
];
var singleLinks = [
    {
        text: "Events",
        link: "/events",
        icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/event.svg"
    },
    {
        text: "Blogs",
        link: "/blog/",
        icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/library_books.svg"
    },
    {
        text: "About",
        link: "/about-us",
        icon: "https://leapassets.s3.ap-south-1.amazonaws.com/navbar/about.svg"
    }, 
];
var loggenInStickyLinks = [
    {
        text: "Counselling Dashboard",
        link: "/profile"
    },
    {
        text: "IELTS Prep Dashboard",
        link: "/test-prep/dashboard/"
    }, 
];
var menaLoggInStickyLinks = [
    {
        text: "IELTS Prep Dashboard",
        link: "/test-prep/dashboard/"
    }, 
];
var ieltsContactInfo = {
    phone: {
        text: "080-47184844",
        link: "tel:+918047184844"
    },
    email: {
        text: "ielts.support@leapscholar.com",
        link: "mailto:ielts.support@leapscholar.com"
    }
};
var ieltsContactInfo2 = {
    text: " +91-08047184844",
    link: "tel:+91-08047184844"
};
var ieltsFlowPages = [
    /^\/mock-tests\/band-predictor-test\/[a-zA-Z0-9-]+$/,
    /^\/profile\/fast_track_registration$/,
    /\/ielts-referral/, 
];


/***/ }),

/***/ 91635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var scripts_segment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83697);




var FourOhFour = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        (0,scripts_segment__WEBPACK_IMPORTED_MODULE_3__.trackPage)("404 Page not found" + router.asPath);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex items-center justify-center w-full h-[90vh] m-auto bg-white",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col text-gray-700 lg:flex-row m-auto",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "order-1 max-w-md px-2 text-sm md:text-base lg:px-0 md:mt-[4rem]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
                            className: "mb-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-4xl font-bold leading-none text-gray-400 select-none lg:text-6xl",
                                    children: "404."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "text-xl font-light leading-normal lg:text-3xl md:text-3xl",
                                    children: "Looks like you're lost"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "max-w-sm mb-[32px] leading-5 md:leading-7",
                            children: "We can't find the page you're looking for. You can find plenty of other things on our homepage."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "/",
                            className: "p-4 text-base font-medium leading-5 text-white rounded shadow bg-primary",
                            children: "Back to Homepage"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "max-w-lg",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FourOhFour);


/***/ }),

/***/ 11901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/ts-invariant/lib/invariant.esm.js
var invariant_esm = __webpack_require__(47591);
;// CONCATENATED MODULE: ./node_modules/@apollo/react-common/lib/react-common.esm.js



var apolloContext;
function getApolloContext() {
    if (!apolloContext) {
        apolloContext = react.createContext({});
    }
    return apolloContext;
}
function resetApolloContext() {
    apolloContext = React.createContext({});
}

var ApolloProvider = function (_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = getApolloContext();
    return react.createElement(ApolloContext.Consumer, null, function (context) {
        if (context === void 0) { context = {}; }
        if (client && context.client !== client) {
            context = Object.assign({}, context, { client: client });
        }
         true ? (0,invariant_esm/* invariant */.kG)(context.client, 5) : 0;
        return (react.createElement(ApolloContext.Provider, { value: context }, children));
    });
};

var ApolloConsumer = function (props) {
    var ApolloContext = getApolloContext();
    return React.createElement(ApolloContext.Consumer, null, function (context) {
         true ? invariant(context && context.client, 6) : 0;
        return props.children(context.client);
    });
};

var DocumentType;
(function (DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})(DocumentType || (DocumentType = {}));
var cache = new Map();
function operationName(type) {
    var name;
    switch (type) {
        case DocumentType.Query:
            name = 'Query';
            break;
        case DocumentType.Mutation:
            name = 'Mutation';
            break;
        case DocumentType.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function parser(document) {
    var cached = cache.get(document);
    if (cached)
        return cached;
    var variables, type, name;
     true ? invariant(!!document && !!document.kind, 1) : 0;
    var fragments = document.definitions.filter(function (x) { return x.kind === 'FragmentDefinition'; });
    var queries = document.definitions.filter(function (x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function (x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function (x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
     true ? invariant(!fragments.length ||
        (queries.length || mutations.length || subscriptions.length), 2) : 0;
     true ? invariant(queries.length + mutations.length + subscriptions.length <= 1, 3) : 0;
    type = queries.length ? DocumentType.Query : DocumentType.Mutation;
    if (!queries.length && !mutations.length)
        type = DocumentType.Subscription;
    var definitions = queries.length
        ? queries
        : mutations.length
            ? mutations
            : subscriptions;
     true ? invariant(definitions.length === 1, 4) : 0;
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') {
        name = definition.name.value;
    }
    else {
        name = 'data';
    }
    var payload = { name: name, type: type, variables: variables };
    cache.set(document, payload);
    return payload;
}


//# sourceMappingURL=react-common.esm.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/buildPolyfills/_optionalChain.js
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */
function _optionalChain(ops) {
  let lastAccessLHS = undefined;
  let value = ops[0];
  let i = 1;
  while (i < ops.length) {
    const op = ops[i] ;
    const fn = ops[i + 1] ;
    i += 2;
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
      return;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => (value ).call(lastAccessLHS, ...args));
      lastAccessLHS = undefined;
    }
  }
  return value;
}

// Sucrase version
// function _optionalChain(ops) {
//   let lastAccessLHS = undefined;
//   let value = ops[0];
//   let i = 1;
//   while (i < ops.length) {
//     const op = ops[i];
//     const fn = ops[i + 1];
//     i += 2;
//     if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
//       return undefined;
//     }
//     if (op === 'access' || op === 'optionalAccess') {
//       lastAccessLHS = value;
//       value = fn(value);
//     } else if (op === 'call' || op === 'optionalCall') {
//       value = fn((...args) => value.call(lastAccessLHS, ...args));
//       lastAccessLHS = undefined;
//     }
//   }
//   return value;
// }


//# sourceMappingURL=_optionalChain.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js
var esm_hub = __webpack_require__(95659);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/utils/hasTracingEnabled.js


// Treeshakable guard to remove all code related to tracing

/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */
function hasTracingEnabled(
  maybeOptions,
) {
  if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) {
    return false;
  }

  const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
  const options = maybeOptions || (client && client.getOptions());
  return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}


//# sourceMappingURL=hasTracingEnabled.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/path.js
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://github.com/calvinmetcalf/rollup-plugin-node-builtins/blob/63ab8aacd013767445ca299e468d9a60a95328d7/src/es6/path.js
//
// Copyright Joyent, Inc.and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

/** JSDoc */
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  let up = 0;
  for (let i = parts.length - 1; i >= 0; i--) {
    const last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
const splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
/** JSDoc */
function splitPath(filename) {
  const parts = splitPathRe.exec(filename);
  return parts ? parts.slice(1) : [];
}

// path.resolve([from ...], to)
// posix version
/** JSDoc */
function resolve(...args) {
  let resolvedPath = '';
  let resolvedAbsolute = false;

  for (let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    const path = i >= 0 ? args[i] : '/';

    // Skip empty entries
    if (!path) {
      continue;
    }

    resolvedPath = `${path}/${resolvedPath}`;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(
    resolvedPath.split('/').filter(p => !!p),
    !resolvedAbsolute,
  ).join('/');

  return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}

/** JSDoc */
function trim(arr) {
  let start = 0;
  for (; start < arr.length; start++) {
    if (arr[start] !== '') {
      break;
    }
  }

  let end = arr.length - 1;
  for (; end >= 0; end--) {
    if (arr[end] !== '') {
      break;
    }
  }

  if (start > end) {
    return [];
  }
  return arr.slice(start, end - start + 1);
}

// path.relative(from, to)
// posix version
/** JSDoc */
function relative(from, to) {
  /* eslint-disable no-param-reassign */
  from = resolve(from).slice(1);
  to = resolve(to).slice(1);
  /* eslint-enable no-param-reassign */

  const fromParts = trim(from.split('/'));
  const toParts = trim(to.split('/'));

  const length = Math.min(fromParts.length, toParts.length);
  let samePartsLength = length;
  for (let i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  let outputParts = [];
  for (let i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
}

// path.normalize(path)
// posix version
/** JSDoc */
function normalizePath(path) {
  const isPathAbsolute = isAbsolute(path);
  const trailingSlash = path.slice(-1) === '/';

  // Normalize the path
  let normalizedPath = normalizeArray(
    path.split('/').filter(p => !!p),
    !isPathAbsolute,
  ).join('/');

  if (!normalizedPath && !isPathAbsolute) {
    normalizedPath = '.';
  }
  if (normalizedPath && trailingSlash) {
    normalizedPath += '/';
  }

  return (isPathAbsolute ? '/' : '') + normalizedPath;
}

// posix version
/** JSDoc */
function isAbsolute(path) {
  return path.charAt(0) === '/';
}

// posix version
/** JSDoc */
function join(...args) {
  return normalizePath(args.join('/'));
}

/** JSDoc */
function dirname(path) {
  const result = splitPath(path);
  const root = result[0];
  let dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.slice(0, dir.length - 1);
  }

  return root + dir;
}

/** JSDoc */
function basename(path, ext) {
  let f = splitPath(path)[2];
  if (ext && f.slice(ext.length * -1) === ext) {
    f = f.slice(0, f.length - ext.length);
  }
  return f;
}


//# sourceMappingURL=path.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/integrations/esm/rewriteframes.js


/** Rewrite event frames paths */
class RewriteFrames  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'RewriteFrames';}

  /**
   * @inheritDoc
   */
   __init() {this.name = RewriteFrames.id;}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
    __init2() {this._prefix = 'app:///';}

  /**
   * @inheritDoc
   */
   constructor(options = {}) {RewriteFrames.prototype.__init.call(this);RewriteFrames.prototype.__init2.call(this);RewriteFrames.prototype.__init3.call(this);
    if (options.root) {
      this._root = options.root;
    }
    if (options.prefix) {
      this._prefix = options.prefix;
    }
    if (options.iteratee) {
      this._iteratee = options.iteratee;
    }
  }

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    addGlobalEventProcessor(event => {
      const self = getCurrentHub().getIntegration(RewriteFrames);
      if (self) {
        return self.process(event);
      }
      return event;
    });
  }

  /** JSDoc */
   process(originalEvent) {
    let processedEvent = originalEvent;

    if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) {
      processedEvent = this._processExceptionsEvent(processedEvent);
    }

    return processedEvent;
  }

  /**
   * @inheritDoc
   */
    __init3() {this._iteratee = (frame) => {
    if (!frame.filename) {
      return frame;
    }
    // Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`
    const isWindowsFrame =
      /^[a-zA-Z]:\\/.test(frame.filename) ||
      // or the presence of a backslash without a forward slash (which are not allowed on Windows)
      (frame.filename.includes('\\') && !frame.filename.includes('/'));
    // Check if the frame filename begins with `/`
    const startsWithSlash = /^\//.test(frame.filename);
    if (isWindowsFrame || startsWithSlash) {
      const filename = isWindowsFrame
        ? frame.filename
            .replace(/^[a-zA-Z]:/, '') // remove Windows-style prefix
            .replace(/\\/g, '/') // replace all `\\` instances with `/`
        : frame.filename;
      const base = this._root ? relative(this._root, filename) : basename(filename);
      frame.filename = `${this._prefix}${base}`;
    }
    return frame;
  };}

  /** JSDoc */
   _processExceptionsEvent(event) {
    try {
      return {
        ...event,
        exception: {
          ...event.exception,
          // The check for this is performed inside `process` call itself, safe to skip here
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          values: event.exception.values.map(value => ({
            ...value,
            ...(value.stacktrace && { stacktrace: this._processStacktrace(value.stacktrace) }),
          })),
        },
      };
    } catch (_oO) {
      return event;
    }
  }

  /** JSDoc */
   _processStacktrace(stacktrace) {
    return {
      ...stacktrace,
      frames: stacktrace && stacktrace.frames && stacktrace.frames.map(f => this._iteratee(f)),
    };
  }
} RewriteFrames.__initStatic();


//# sourceMappingURL=rewriteframes.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/version.js
var version = __webpack_require__(40105);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/sdk.js + 30 modules
var sdk = __webpack_require__(64210);
;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/sdk.js


/**
 * Inits the React SDK
 */
function init(options) {
  options._metadata = options._metadata || {};
  options._metadata.sdk = options._metadata.sdk || {
    name: 'sentry.javascript.react',
    packages: [
      {
        name: 'npm:@sentry/react',
        version: version/* SDK_VERSION */.J,
      },
    ],
    version: version/* SDK_VERSION */.J,
  };
  (0,sdk/* init */.S1)(options);
}


//# sourceMappingURL=sdk.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(21170);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(62844);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(20535);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/span.js


/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */
class SpanRecorder {
   __init() {this.spans = [];}

   constructor(maxlen = 1000) {SpanRecorder.prototype.__init.call(this);
    this._maxlen = maxlen;
  }

  /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */
   add(span) {
    if (this.spans.length > this._maxlen) {
      span.spanRecorder = undefined;
    } else {
      this.spans.push(span);
    }
  }
}

/**
 * Span contains all data about a span
 */
class Span  {
  /**
   * @inheritDoc
   */
   __init2() {this.traceId = (0,misc/* uuid4 */.DM)();}

  /**
   * @inheritDoc
   */
   __init3() {this.spanId = (0,misc/* uuid4 */.DM)().substring(16);}

  /**
   * @inheritDoc
   */

  /**
   * Internal keeper of the status
   */

  /**
   * @inheritDoc
   */

  /**
   * Timestamp in seconds when the span was created.
   */
   __init4() {this.startTimestamp = (0,time/* timestampInSeconds */.ph)();}

  /**
   * Timestamp in seconds when the span ended.
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   __init5() {this.tags = {};}

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   __init6() {this.data = {};}

  /**
   * List of spans that were finalized
   */

  /**
   * @inheritDoc
   */

  /**
   * The instrumenter that created this span.
   */
   __init7() {this.instrumenter = 'sentry';}

  /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(spanContext) {Span.prototype.__init2.call(this);Span.prototype.__init3.call(this);Span.prototype.__init4.call(this);Span.prototype.__init5.call(this);Span.prototype.__init6.call(this);Span.prototype.__init7.call(this);
    if (!spanContext) {
      return this;
    }
    if (spanContext.traceId) {
      this.traceId = spanContext.traceId;
    }
    if (spanContext.spanId) {
      this.spanId = spanContext.spanId;
    }
    if (spanContext.parentSpanId) {
      this.parentSpanId = spanContext.parentSpanId;
    }
    // We want to include booleans as well here
    if ('sampled' in spanContext) {
      this.sampled = spanContext.sampled;
    }
    if (spanContext.op) {
      this.op = spanContext.op;
    }
    if (spanContext.description) {
      this.description = spanContext.description;
    }
    if (spanContext.data) {
      this.data = spanContext.data;
    }
    if (spanContext.tags) {
      this.tags = spanContext.tags;
    }
    if (spanContext.status) {
      this.status = spanContext.status;
    }
    if (spanContext.startTimestamp) {
      this.startTimestamp = spanContext.startTimestamp;
    }
    if (spanContext.endTimestamp) {
      this.endTimestamp = spanContext.endTimestamp;
    }
    if (spanContext.instrumenter) {
      this.instrumenter = spanContext.instrumenter;
    }
  }

  /**
   * @inheritDoc
   */
   startChild(
    spanContext,
  ) {
    const childSpan = new Span({
      ...spanContext,
      parentSpanId: this.spanId,
      sampled: this.sampled,
      traceId: this.traceId,
    });

    childSpan.spanRecorder = this.spanRecorder;
    if (childSpan.spanRecorder) {
      childSpan.spanRecorder.add(childSpan);
    }

    childSpan.transaction = this.transaction;

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && childSpan.transaction) {
      const opStr = (spanContext && spanContext.op) || '< unknown op >';
      const nameStr = childSpan.transaction.name || '< unknown name >';
      const idStr = childSpan.transaction.spanId;

      const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
      childSpan.transaction.metadata.spanMetadata[childSpan.spanId] = { logMessage };
      logger/* logger.log */.kg.log(logMessage);
    }

    return childSpan;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this.tags = { ...this.tags, [key]: value };
    return this;
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   setData(key, value) {
    this.data = { ...this.data, [key]: value };
    return this;
  }

  /**
   * @inheritDoc
   */
   setStatus(value) {
    this.status = value;
    return this;
  }

  /**
   * @inheritDoc
   */
   setHttpStatus(httpStatus) {
    this.setTag('http.status_code', String(httpStatus));
    const spanStatus = spanStatusfromHttpCode(httpStatus);
    if (spanStatus !== 'unknown_error') {
      this.setStatus(spanStatus);
    }
    return this;
  }

  /**
   * @inheritDoc
   */
   isSuccess() {
    return this.status === 'ok';
  }

  /**
   * @inheritDoc
   */
   finish(endTimestamp) {
    if (
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      // Don't call this for transactions
      this.transaction &&
      this.transaction.spanId !== this.spanId
    ) {
      const { logMessage } = this.transaction.metadata.spanMetadata[this.spanId];
      if (logMessage) {
        logger/* logger.log */.kg.log((logMessage ).replace('Starting', 'Finishing'));
      }
    }

    this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,time/* timestampInSeconds */.ph)();
  }

  /**
   * @inheritDoc
   */
   toTraceparent() {
    let sampledString = '';
    if (this.sampled !== undefined) {
      sampledString = this.sampled ? '-1' : '-0';
    }
    return `${this.traceId}-${this.spanId}${sampledString}`;
  }

  /**
   * @inheritDoc
   */
   toContext() {
    return (0,object/* dropUndefinedKeys */.Jr)({
      data: this.data,
      description: this.description,
      endTimestamp: this.endTimestamp,
      op: this.op,
      parentSpanId: this.parentSpanId,
      sampled: this.sampled,
      spanId: this.spanId,
      startTimestamp: this.startTimestamp,
      status: this.status,
      tags: this.tags,
      traceId: this.traceId,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(spanContext) {
    this.data = spanContext.data || {};
    this.description = spanContext.description;
    this.endTimestamp = spanContext.endTimestamp;
    this.op = spanContext.op;
    this.parentSpanId = spanContext.parentSpanId;
    this.sampled = spanContext.sampled;
    this.spanId = spanContext.spanId || this.spanId;
    this.startTimestamp = spanContext.startTimestamp || this.startTimestamp;
    this.status = spanContext.status;
    this.tags = spanContext.tags || {};
    this.traceId = spanContext.traceId || this.traceId;

    return this;
  }

  /**
   * @inheritDoc
   */
   getTraceContext() {
    return (0,object/* dropUndefinedKeys */.Jr)({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      trace_id: this.traceId,
    });
  }

  /**
   * @inheritDoc
   */
   toJSON()

 {
    return (0,object/* dropUndefinedKeys */.Jr)({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      start_timestamp: this.startTimestamp,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      timestamp: this.endTimestamp,
      trace_id: this.traceId,
    });
  }
}

/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */
function spanStatusfromHttpCode(httpStatus) {
  if (httpStatus < 400 && httpStatus >= 100) {
    return 'ok';
  }

  if (httpStatus >= 400 && httpStatus < 500) {
    switch (httpStatus) {
      case 401:
        return 'unauthenticated';
      case 403:
        return 'permission_denied';
      case 404:
        return 'not_found';
      case 409:
        return 'already_exists';
      case 413:
        return 'failed_precondition';
      case 429:
        return 'resource_exhausted';
      default:
        return 'invalid_argument';
    }
  }

  if (httpStatus >= 500 && httpStatus < 600) {
    switch (httpStatus) {
      case 501:
        return 'unimplemented';
      case 503:
        return 'unavailable';
      case 504:
        return 'deadline_exceeded';
      default:
        return 'internal_error';
    }
  }

  return 'unknown_error';
}


//# sourceMappingURL=span.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/constants.js
var constants = __webpack_require__(51131);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/transaction.js





/** JSDoc */
class Transaction extends Span  {

  /**
   * The reference to the current hub.
   */

   __init() {this._measurements = {};}

   __init2() {this._contexts = {};}

   __init3() {this._frozenDynamicSamplingContext = undefined;}

  /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(transactionContext, hub) {
    super(transactionContext);Transaction.prototype.__init.call(this);Transaction.prototype.__init2.call(this);Transaction.prototype.__init3.call(this);
    this._hub = hub || (0,esm_hub/* getCurrentHub */.Gd)();

    this._name = transactionContext.name || '';

    this.metadata = {
      source: 'custom',
      ...transactionContext.metadata,
      spanMetadata: {},
    };

    this._trimEnd = transactionContext.trimEnd;

    // this is because transactions are also spans, and spans have a transaction pointer
    this.transaction = this;

    // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
    // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
    const incomingDynamicSamplingContext = this.metadata.dynamicSamplingContext;
    if (incomingDynamicSamplingContext) {
      // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
      this._frozenDynamicSamplingContext = { ...incomingDynamicSamplingContext };
    }
  }

  /** Getter for `name` property */
   get name() {
    return this._name;
  }

  /** Setter for `name` property, which also sets `source` as custom */
   set name(newName) {
    this.setName(newName);
  }

  /**
   * JSDoc
   */
   setName(name, source = 'custom') {
    this._name = name;
    this.metadata.source = source;
  }

  /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */
   initSpanRecorder(maxlen = 1000) {
    if (!this.spanRecorder) {
      this.spanRecorder = new SpanRecorder(maxlen);
    }
    this.spanRecorder.add(this);
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }
  }

  /**
   * @inheritDoc
   */
   setMeasurement(name, value, unit = '') {
    this._measurements[name] = { value, unit };
  }

  /**
   * @inheritDoc
   */
   setMetadata(newMetadata) {
    this.metadata = { ...this.metadata, ...newMetadata };
  }

  /**
   * @inheritDoc
   */
   finish(endTimestamp) {
    // This transaction is already finished, so we should not flush it again.
    if (this.endTimestamp !== undefined) {
      return undefined;
    }

    if (!this.name) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
      this.name = '<unlabeled transaction>';
    }

    // just sets the end timestamp
    super.finish(endTimestamp);

    const client = this._hub.getClient();
    if (client && client.emit) {
      client.emit('finishTransaction', this);
    }

    if (this.sampled !== true) {
      // At this point if `sampled !== true` we want to discard the transaction.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');

      if (client) {
        client.recordDroppedEvent('sample_rate', 'transaction');
      }

      return undefined;
    }

    const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(s => s !== this && s.endTimestamp) : [];

    if (this._trimEnd && finishedSpans.length > 0) {
      this.endTimestamp = finishedSpans.reduce((prev, current) => {
        if (prev.endTimestamp && current.endTimestamp) {
          return prev.endTimestamp > current.endTimestamp ? prev : current;
        }
        return prev;
      }).endTimestamp;
    }

    const metadata = this.metadata;

    const transaction = {
      contexts: {
        ...this._contexts,
        // We don't want to override trace context
        trace: this.getTraceContext(),
      },
      spans: finishedSpans,
      start_timestamp: this.startTimestamp,
      tags: this.tags,
      timestamp: this.endTimestamp,
      transaction: this.name,
      type: 'transaction',
      sdkProcessingMetadata: {
        ...metadata,
        dynamicSamplingContext: this.getDynamicSamplingContext(),
      },
      ...(metadata.source && {
        transaction_info: {
          source: metadata.source,
        },
      }),
    };

    const hasMeasurements = Object.keys(this._measurements).length > 0;

    if (hasMeasurements) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.log */.kg.log(
          '[Measurements] Adding measurements to transaction',
          JSON.stringify(this._measurements, undefined, 2),
        );
      transaction.measurements = this._measurements;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] Finishing ${this.op} transaction: ${this.name}.`);

    return this._hub.captureEvent(transaction);
  }

  /**
   * @inheritDoc
   */
   toContext() {
    const spanContext = super.toContext();

    return (0,object/* dropUndefinedKeys */.Jr)({
      ...spanContext,
      name: this.name,
      trimEnd: this._trimEnd,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(transactionContext) {
    super.updateWithContext(transactionContext);

    this.name = transactionContext.name || '';

    this._trimEnd = transactionContext.trimEnd;

    return this;
  }

  /**
   * @inheritdoc
   *
   * @experimental
   */
   getDynamicSamplingContext() {
    if (this._frozenDynamicSamplingContext) {
      return this._frozenDynamicSamplingContext;
    }

    const hub = this._hub || (0,esm_hub/* getCurrentHub */.Gd)();
    const client = hub && hub.getClient();

    if (!client) return {};

    const { environment, release } = client.getOptions() || {};
    const { publicKey: public_key } = client.getDsn() || {};

    const maybeSampleRate = this.metadata.sampleRate;
    const sample_rate = maybeSampleRate !== undefined ? maybeSampleRate.toString() : undefined;

    const { segment: user_segment } = hub.getScope().getUser() || {};

    const source = this.metadata.source;

    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const transaction = source && source !== 'url' ? this.name : undefined;

    const dsc = (0,object/* dropUndefinedKeys */.Jr)({
      environment: environment || constants/* DEFAULT_ENVIRONMENT */.J,
      release,
      transaction,
      user_segment,
      public_key,
      trace_id: this.traceId,
      sample_rate,
    });

    // Uncomment if we want to make DSC immutable
    // this._frozenDynamicSamplingContext = dsc;

    client.emit && client.emit('createDsc', dsc);

    return dsc;
  }

  /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */
   setHub(hub) {
    this._hub = hub;
  }
}


//# sourceMappingURL=transaction.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/idletransaction.js




const TRACING_DEFAULTS = {
  idleTimeout: 1000,
  finalTimeout: 30000,
  heartbeatInterval: 5000,
};

const FINISH_REASON_TAG = 'finishReason';

const IDLE_TRANSACTION_FINISH_REASONS = [
  'heartbeatFailed',
  'idleTimeout',
  'documentHidden',
  'finalTimeout',
  'externalFinish',
  'cancelled',
];

/**
 * @inheritDoc
 */
class IdleTransactionSpanRecorder extends SpanRecorder {
   constructor(
      _pushActivity,
      _popActivity,
     transactionSpanId,
    maxlen,
  ) {
    super(maxlen);this._pushActivity = _pushActivity;this._popActivity = _popActivity;this.transactionSpanId = transactionSpanId;  }

  /**
   * @inheritDoc
   */
   add(span) {
    // We should make sure we do not push and pop activities for
    // the transaction that this span recorder belongs to.
    if (span.spanId !== this.transactionSpanId) {
      // We patch span.finish() to pop an activity after setting an endTimestamp.
      span.finish = (endTimestamp) => {
        span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,time/* timestampInSeconds */.ph)();
        this._popActivity(span.spanId);
      };

      // We should only push new activities if the span does not have an end timestamp.
      if (span.endTimestamp === undefined) {
        this._pushActivity(span.spanId);
      }
    }

    super.add(span);
  }
}

/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */
class IdleTransaction extends Transaction {
  // Activities store a list of active spans
   __init() {this.activities = {};}

  // Track state of activities in previous heartbeat

  // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
   __init2() {this._heartbeatCounter = 0;}

  // We should not use heartbeat if we finished a transaction
   __init3() {this._finished = false;}

  // Idle timeout was canceled and we should finish the transaction with the last span end.
   __init4() {this._idleTimeoutCanceledPermanently = false;}

    __init5() {this._beforeFinishCallbacks = [];}

  /**
   * Timer that tracks Transaction idleTimeout
   */

   __init6() {this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[4];}

   constructor(
    transactionContext,
      _idleHub,
    /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */
      _idleTimeout = TRACING_DEFAULTS.idleTimeout,
    /**
     * The final value in ms that a transaction cannot exceed
     */
      _finalTimeout = TRACING_DEFAULTS.finalTimeout,
      _heartbeatInterval = TRACING_DEFAULTS.heartbeatInterval,
    // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
      _onScope = false,
  ) {
    super(transactionContext, _idleHub);this._idleHub = _idleHub;this._idleTimeout = _idleTimeout;this._finalTimeout = _finalTimeout;this._heartbeatInterval = _heartbeatInterval;this._onScope = _onScope;IdleTransaction.prototype.__init.call(this);IdleTransaction.prototype.__init2.call(this);IdleTransaction.prototype.__init3.call(this);IdleTransaction.prototype.__init4.call(this);IdleTransaction.prototype.__init5.call(this);IdleTransaction.prototype.__init6.call(this);
    if (_onScope) {
      // We set the transaction here on the scope so error events pick up the trace
      // context and attach it to the error.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`Setting idle transaction on scope. Span ID: ${this.spanId}`);
      _idleHub.configureScope(scope => scope.setSpan(this));
    }

    this._restartIdleTimeout();
    setTimeout(() => {
      if (!this._finished) {
        this.setStatus('deadline_exceeded');
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[3];
        this.finish();
      }
    }, this._finalTimeout);
  }

  /** {@inheritDoc} */
   finish(endTimestamp = (0,time/* timestampInSeconds */.ph)()) {
    this._finished = true;
    this.activities = {};

    if (this.op === 'ui.action.click') {
      this.setTag(FINISH_REASON_TAG, this._finishReason);
    }

    if (this.spanRecorder) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.log */.kg.log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);

      for (const callback of this._beforeFinishCallbacks) {
        callback(this, endTimestamp);
      }

      this.spanRecorder.spans = this.spanRecorder.spans.filter((span) => {
        // If we are dealing with the transaction itself, we just return it
        if (span.spanId === this.spanId) {
          return true;
        }

        // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
        if (!span.endTimestamp) {
          span.endTimestamp = endTimestamp;
          span.setStatus('cancelled');
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
            logger/* logger.log */.kg.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
        }

        const keepSpan = span.startTimestamp < endTimestamp;
        if (!keepSpan) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
            logger/* logger.log */.kg.log(
              '[Tracing] discarding Span since it happened after Transaction was finished',
              JSON.stringify(span, undefined, 2),
            );
        }
        return keepSpan;
      });

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Tracing] flushing IdleTransaction');
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Tracing] No active IdleTransaction');
    }

    // if `this._onScope` is `true`, the transaction put itself on the scope when it started
    if (this._onScope) {
      const scope = this._idleHub.getScope();
      if (scope.getTransaction() === this) {
        scope.setSpan(undefined);
      }
    }

    return super.finish(endTimestamp);
  }

  /**
   * Register a callback function that gets excecuted before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */
   registerBeforeFinishCallback(callback) {
    this._beforeFinishCallbacks.push(callback);
  }

  /**
   * @inheritDoc
   */
   initSpanRecorder(maxlen) {
    if (!this.spanRecorder) {
      const pushActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._pushActivity(id);
      };
      const popActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._popActivity(id);
      };

      this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanId, maxlen);

      // Start heartbeat so that transactions do not run forever.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('Starting heartbeat');
      this._pingHeartbeat();
    }
    this.spanRecorder.add(this);
  }

  /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */
   cancelIdleTimeout(
    endTimestamp,
    {
      restartOnChildSpanChange,
    }

 = {
      restartOnChildSpanChange: true,
    },
  ) {
    this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
    if (this._idleTimeoutID) {
      clearTimeout(this._idleTimeoutID);
      this._idleTimeoutID = undefined;

      if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[5];
        this.finish(endTimestamp);
      }
    }
  }

  /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */
   setFinishReason(reason) {
    this._finishReason = reason;
  }

  /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */
   _restartIdleTimeout(endTimestamp) {
    this.cancelIdleTimeout();
    this._idleTimeoutID = setTimeout(() => {
      if (!this._finished && Object.keys(this.activities).length === 0) {
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[1];
        this.finish(endTimestamp);
      }
    }, this._idleTimeout);
  }

  /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */
   _pushActivity(spanId) {
    this.cancelIdleTimeout(undefined, { restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently });
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] pushActivity: ${spanId}`);
    this.activities[spanId] = true;
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
  }

  /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */
   _popActivity(spanId) {
    if (this.activities[spanId]) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] popActivity ${spanId}`);
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this.activities[spanId];
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
    }

    if (Object.keys(this.activities).length === 0) {
      const endTimestamp = (0,time/* timestampInSeconds */.ph)();
      if (this._idleTimeoutCanceledPermanently) {
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[5];
        this.finish(endTimestamp);
      } else {
        // We need to add the timeout here to have the real endtimestamp of the transaction
        // Remember timestampInSeconds is in seconds, timeout is in ms
        this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
      }
    }
  }

  /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */
   _beat() {
    // We should not be running heartbeat if the idle transaction is finished.
    if (this._finished) {
      return;
    }

    const heartbeatString = Object.keys(this.activities).join('');

    if (heartbeatString === this._prevHeartbeatString) {
      this._heartbeatCounter++;
    } else {
      this._heartbeatCounter = 1;
    }

    this._prevHeartbeatString = heartbeatString;

    if (this._heartbeatCounter >= 3) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Tracing] Transaction finished because of no change for 3 heart beats');
      this.setStatus('deadline_exceeded');
      this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[0];
      this.finish();
    } else {
      this._pingHeartbeat();
    }
  }

  /**
   * Pings the heartbeat
   */
   _pingHeartbeat() {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
    setTimeout(() => {
      this._beat();
    }, this._heartbeatInterval);
  }
}


//# sourceMappingURL=idletransaction.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument.js + 1 modules
var instrument = __webpack_require__(35648);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/utils.js



/** Grabs active transaction off scope, if any */
function getActiveTransaction(maybeHub) {
  const hub = maybeHub || (0,esm_hub/* getCurrentHub */.Gd)();
  const scope = hub.getScope();
  return scope.getTransaction() ;
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/errors.js



let errorsInstrumented = false;

/**
 * Configures global error listeners
 */
function registerErrorInstrumentation() {
  if (errorsInstrumented) {
    return;
  }

  errorsInstrumented = true;
  (0,instrument/* addInstrumentationHandler */.oq)('error', errorCallback);
  (0,instrument/* addInstrumentationHandler */.oq)('unhandledrejection', errorCallback);
}

/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */
function errorCallback() {
  const activeTransaction = getActiveTransaction();
  if (activeTransaction) {
    const status = 'internal_error';
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] Transaction: ${status} -> Global error occured`);
    activeTransaction.setStatus(status);
  }
}

// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
errorCallback.tag = 'sentry_tracingErrorCallback';


//# sourceMappingURL=errors.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/hubextensions.js







/** Returns all trace headers that are currently on the top scope. */
function traceHeaders() {
  const scope = this.getScope();
  const span = scope.getSpan();

  return span
    ? {
        'sentry-trace': span.toTraceparent(),
      }
    : {};
}

/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param transaction: The transaction needing a sampling decision
 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */
function sample(
  transaction,
  options,
  samplingContext,
) {
  // nothing to do if tracing is not enabled
  if (!hasTracingEnabled(options)) {
    transaction.sampled = false;
    return transaction;
  }

  // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
  if (transaction.sampled !== undefined) {
    transaction.setMetadata({
      sampleRate: Number(transaction.sampled),
    });
    return transaction;
  }

  // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
  // work; prefer the hook if so
  let sampleRate;
  if (typeof options.tracesSampler === 'function') {
    sampleRate = options.tracesSampler(samplingContext);
    transaction.setMetadata({
      sampleRate: Number(sampleRate),
    });
  } else if (samplingContext.parentSampled !== undefined) {
    sampleRate = samplingContext.parentSampled;
  } else if (typeof options.tracesSampleRate !== 'undefined') {
    sampleRate = options.tracesSampleRate;
    transaction.setMetadata({
      sampleRate: Number(sampleRate),
    });
  } else {
    // When `enableTracing === true`, we use a sample rate of 100%
    sampleRate = 1;
    transaction.setMetadata({
      sampleRate,
    });
  }

  // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
  // only valid values are booleans or numbers between 0 and 1.)
  if (!isValidSampleRate(sampleRate)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('[Tracing] Discarding transaction because of invalid sample rate.');
    transaction.sampled = false;
    return transaction;
  }

  // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
  if (!sampleRate) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because ${
          typeof options.tracesSampler === 'function'
            ? 'tracesSampler returned 0 or false'
            : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'
        }`,
      );
    transaction.sampled = false;
    return transaction;
  }

  // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
  // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
  transaction.sampled = Math.random() < (sampleRate );

  // if we're not going to keep it, we're done
  if (!transaction.sampled) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
          sampleRate,
        )})`,
      );
    return transaction;
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] starting ${transaction.op} transaction - ${transaction.name}`);
  return transaction;
}

/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */
function isValidSampleRate(rate) {
  // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if ((0,is/* isNaN */.i2)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(
        `[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
          rate,
        )} of type ${JSON.stringify(typeof rate)}.`,
      );
    return false;
  }

  // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
  if (rate < 0 || rate > 1) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
    return false;
  }
  return true;
}

/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */
function _startTransaction(

  transactionContext,
  customSamplingContext,
) {
  const client = this.getClient();
  const options = (client && client.getOptions()) || {};

  const configInstrumenter = options.instrumenter || 'sentry';
  const transactionInstrumenter = transactionContext.instrumenter || 'sentry';

  if (configInstrumenter !== transactionInstrumenter) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.error */.kg.error(
        `A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`,
      );

    transactionContext.sampled = false;
  }

  let transaction = new Transaction(transactionContext, this);
  transaction = sample(transaction, options, {
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    ...customSamplingContext,
  });
  if (transaction.sampled) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  if (client && client.emit) {
    client.emit('startTransaction', transaction);
  }
  return transaction;
}

/**
 * Create new idle transaction.
 */
function startIdleTransaction(
  hub,
  transactionContext,
  idleTimeout,
  finalTimeout,
  onScope,
  customSamplingContext,
  heartbeatInterval,
) {
  const client = hub.getClient();
  const options = (client && client.getOptions()) || {};

  let transaction = new IdleTransaction(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope);
  transaction = sample(transaction, options, {
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    ...customSamplingContext,
  });
  if (transaction.sampled) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  if (client && client.emit) {
    client.emit('startTransaction', transaction);
  }
  return transaction;
}

/**
 * Adds tracing extensions to the global hub.
 */
function addTracingExtensions() {
  const carrier = (0,esm_hub/* getMainCarrier */.cu)();
  if (!carrier.__SENTRY__) {
    return;
  }
  carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
  if (!carrier.__SENTRY__.extensions.startTransaction) {
    carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
  }
  if (!carrier.__SENTRY__.extensions.traceHeaders) {
    carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
  }

  registerErrorInstrumentation();
}


//# sourceMappingURL=hubextensions.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/tracing.js
const TRACEPARENT_REGEXP = new RegExp(
  '^[ \\t]*' + // whitespace
    '([0-9a-f]{32})?' + // trace_id
    '-?([0-9a-f]{16})?' + // span_id
    '-?([01])?' + // sampled
    '[ \\t]*$', // whitespace
);

/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */
function extractTraceparentData(traceparent) {
  const matches = traceparent.match(TRACEPARENT_REGEXP);

  if (!traceparent || !matches) {
    // empty string or no matches is invalid traceparent data
    return undefined;
  }

  let parentSampled;
  if (matches[3] === '1') {
    parentSampled = true;
  } else if (matches[3] === '0') {
    parentSampled = false;
  }

  return {
    traceId: matches[1],
    parentSampled,
    parentSpanId: matches[2],
  };
}


//# sourceMappingURL=tracing.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/baggage.js



const BAGGAGE_HEADER_NAME = 'baggage';

const SENTRY_BAGGAGE_KEY_PREFIX = 'sentry-';

const SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;

/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */
const MAX_BAGGAGE_STRING_LENGTH = 8192;

/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */
function baggageHeaderToDynamicSamplingContext(
  // Very liberal definition of what any incoming header might look like
  baggageHeader,
) {
  if (!(0,is/* isString */.HD)(baggageHeader) && !Array.isArray(baggageHeader)) {
    return undefined;
  }

  // Intermediary object to store baggage key value pairs of incoming baggage headers on.
  // It is later used to read Sentry-DSC-values from.
  let baggageObject = {};

  if (Array.isArray(baggageHeader)) {
    // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr) => {
      const currBaggageObject = baggageHeaderToObject(curr);
      return {
        ...acc,
        ...currBaggageObject,
      };
    }, {});
  } else {
    // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
    // this is how we choose to handle it)
    if (!baggageHeader) {
      return undefined;
    }

    baggageObject = baggageHeaderToObject(baggageHeader);
  }

  // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
  const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value]) => {
    if (key.match(SENTRY_BAGGAGE_KEY_PREFIX_REGEX)) {
      const nonPrefixedKey = key.slice(SENTRY_BAGGAGE_KEY_PREFIX.length);
      acc[nonPrefixedKey] = value;
    }
    return acc;
  }, {});

  // Only return a dynamic sampling context object if there are keys in it.
  // A keyless object means there were no sentry values on the header, which means that there is no DSC.
  if (Object.keys(dynamicSamplingContext).length > 0) {
    return dynamicSamplingContext ;
  } else {
    return undefined;
  }
}

/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */
function dynamicSamplingContextToSentryBaggageHeader(
  // this also takes undefined for convenience and bundle size in other places
  dynamicSamplingContext,
) {
  // Prefix all DSC keys with "sentry-" and put them into a new object
  const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce(
    (acc, [dscKey, dscValue]) => {
      if (dscValue) {
        acc[`${SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
      }
      return acc;
    },
    {},
  );

  return objectToBaggageHeader(sentryPrefixedDSC);
}

/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */
function baggageHeaderToObject(baggageHeader) {
  return baggageHeader
    .split(',')
    .map(baggageEntry => baggageEntry.split('=').map(keyOrValue => decodeURIComponent(keyOrValue.trim())))
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});
}

/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */
function objectToBaggageHeader(object) {
  if (Object.keys(object).length === 0) {
    // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
  }

  return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex) => {
    const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
    const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
    if (newBaggageHeader.length > MAX_BAGGAGE_STRING_LENGTH) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.warn */.kg.warn(
          `Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`,
        );
      return baggageHeader;
    } else {
      return newBaggageHeader;
    }
  }, '');
}


//# sourceMappingURL=baggage.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(58464);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(71235);
;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/types.js


const WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;


//# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/backgroundtab.js




/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */
function registerBackgroundTabDetection() {
  if (WINDOW && WINDOW.document) {
    WINDOW.document.addEventListener('visibilitychange', () => {
      const activeTransaction = getActiveTransaction() ;
      if (WINDOW.document.hidden && activeTransaction) {
        const statusType = 'cancelled';

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          logger/* logger.log */.kg.log(
            `[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${activeTransaction.op}`,
          );
        // We should not set status if it is already set, this prevent important statuses like
        // error or data loss from being overwritten on transaction.
        if (!activeTransaction.status) {
          activeTransaction.setStatus(statusType);
        }
        activeTransaction.setTag('visibilitychange', 'document.hidden');
        activeTransaction.finish();
      }
    });
  } else {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn('[Tracing] Could not set up background tab detection due to lack of global document');
  }
}


//# sourceMappingURL=backgroundtab.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/bindReporter.js
const bindReporter = (
  callback,
  metric,
  reportAllChanges,
) => {
  let prevValue;
  let delta;
  return (forceReport) => {
    if (metric.value >= 0) {
      if (forceReport || reportAllChanges) {
        delta = metric.value - (prevValue || 0);

        // Report the metric if there's a non-zero delta or if no previous
        // value exists (which can happen in the case of the document becoming
        // hidden when the metric value is 0).
        // See: https://github.com/GoogleChrome/web-vitals/issues/14
        if (delta || prevValue === undefined) {
          prevValue = metric.value;
          metric.delta = delta;
          callback(metric);
        }
      }
    }
  };
};


//# sourceMappingURL=bindReporter.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/generateUniqueID.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */
const generateUniqueID = () => {
  return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};


//# sourceMappingURL=generateUniqueID.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getNavigationEntry.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getNavigationEntryFromPerformanceTiming = () => {
  // eslint-disable-next-line deprecation/deprecation
  const timing = WINDOW.performance.timing;
  // eslint-disable-next-line deprecation/deprecation
  const type = WINDOW.performance.navigation.type;

  const navigationEntry = {
    entryType: 'navigation',
    startTime: 0,
    type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate',
  };

  for (const key in timing) {
    if (key !== 'navigationStart' && key !== 'toJSON') {
      navigationEntry[key] = Math.max((timing[key ] ) - timing.navigationStart, 0);
    }
  }
  return navigationEntry ;
};

const getNavigationEntry = () => {
  if (WINDOW.__WEB_VITALS_POLYFILL__) {
    return (
      WINDOW.performance &&
      ((performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) ||
        getNavigationEntryFromPerformanceTiming())
    );
  } else {
    return WINDOW.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  }
};


//# sourceMappingURL=getNavigationEntry.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getActivationStart.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getActivationStart = () => {
  const navEntry = getNavigationEntry();
  return (navEntry && navEntry.activationStart) || 0;
};


//# sourceMappingURL=getActivationStart.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/initMetric.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const initMetric = (name, value) => {
  const navEntry = getNavigationEntry();
  let navigationType = 'navigate';

  if (navEntry) {
    if (WINDOW.document.prerendering || getActivationStart() > 0) {
      navigationType = 'prerender';
    } else {
      navigationType = navEntry.type.replace(/_/g, '-') ;
    }
  }

  return {
    name,
    value: typeof value === 'undefined' ? -1 : value,
    rating: 'good', // Will be updated if the value changes.
    delta: 0,
    entries: [],
    id: generateUniqueID(),
    navigationType,
  };
};


//# sourceMappingURL=initMetric.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/observe.js
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */
const observe = (
  type,
  callback,
  opts,
) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(type)) {
      const po = new PerformanceObserver(list => {
        callback(list.getEntries() );
      });
      po.observe(
        Object.assign(
          {
            type,
            buffered: true,
          },
          opts || {},
        ) ,
      );
      return po;
    }
  } catch (e) {
    // Do nothing.
  }
  return;
};


//# sourceMappingURL=observe.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/onHidden.js


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const onHidden = (cb, once) => {
  const onHiddenOrPageHide = (event) => {
    if (event.type === 'pagehide' || WINDOW.document.visibilityState === 'hidden') {
      cb(event);
      if (once) {
        removeEventListener('visibilitychange', onHiddenOrPageHide, true);
        removeEventListener('pagehide', onHiddenOrPageHide, true);
      }
    }
  };
  addEventListener('visibilitychange', onHiddenOrPageHide, true);
  // Some browsers have buggy implementations of visibilitychange,
  // so we use pagehide in addition, just to be safe.
  addEventListener('pagehide', onHiddenOrPageHide, true);
};


//# sourceMappingURL=onHidden.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getCLS.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */
const onCLS = (onReport) => {
  const metric = initMetric('CLS', 0);
  let report;

  let sessionValue = 0;
  let sessionEntries = [];

  // const handleEntries = (entries: Metric['entries']) => {
  const handleEntries = (entries) => {
    entries.forEach(entry => {
      // Only count layout shifts without recent user input.
      if (!entry.hadRecentInput) {
        const firstSessionEntry = sessionEntries[0];
        const lastSessionEntry = sessionEntries[sessionEntries.length - 1];

        // If the entry occurred less than 1 second after the previous entry and
        // less than 5 seconds after the first entry in the session, include the
        // entry in the current session. Otherwise, start a new session.
        if (
          sessionValue &&
          sessionEntries.length !== 0 &&
          entry.startTime - lastSessionEntry.startTime < 1000 &&
          entry.startTime - firstSessionEntry.startTime < 5000
        ) {
          sessionValue += entry.value;
          sessionEntries.push(entry);
        } else {
          sessionValue = entry.value;
          sessionEntries = [entry];
        }

        // If the current session value is larger than the current CLS value,
        // update CLS and the entries contributing to it.
        if (sessionValue > metric.value) {
          metric.value = sessionValue;
          metric.entries = sessionEntries;
          if (report) {
            report();
          }
        }
      }
    });
  };

  const po = observe('layout-shift', handleEntries);
  if (po) {
    report = bindReporter(onReport, metric);

    const stopListening = () => {
      handleEntries(po.takeRecords() );
      report(true);
    };

    onHidden(stopListening);

    return stopListening;
  }

  return;
};


//# sourceMappingURL=getCLS.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getVisibilityWatcher.js



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

let firstHiddenTime = -1;

const initHiddenTime = () => {
  // If the document is hidden and not prerendering, assume it was always
  // hidden and the page was loaded in the background.
  return WINDOW.document.visibilityState === 'hidden' && !WINDOW.document.prerendering ? 0 : Infinity;
};

const trackChanges = () => {
  // Update the time if/when the document becomes hidden.
  onHidden(({ timeStamp }) => {
    firstHiddenTime = timeStamp;
  }, true);
};

const getVisibilityWatcher = (

) => {
  if (firstHiddenTime < 0) {
    // If the document is hidden when this code runs, assume it was hidden
    // since navigation start. This isn't a perfect heuristic, but it's the
    // best we can do until an API is available to support querying past
    // visibilityState.
    firstHiddenTime = initHiddenTime();
    trackChanges();
  }
  return {
    get firstHiddenTime() {
      return firstHiddenTime;
    },
  };
};


//# sourceMappingURL=getVisibilityWatcher.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getFID.js






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */
const onFID = (onReport) => {
  const visibilityWatcher = getVisibilityWatcher();
  const metric = initMetric('FID');
  // eslint-disable-next-line prefer-const
  let report;

  const handleEntry = (entry) => {
    // Only report if the page wasn't hidden prior to the first input.
    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
      metric.value = entry.processingStart - entry.startTime;
      metric.entries.push(entry);
      report(true);
    }
  };

  const handleEntries = (entries) => {
    (entries ).forEach(handleEntry);
  };

  const po = observe('first-input', handleEntries);
  report = bindReporter(onReport, metric);

  if (po) {
    onHidden(() => {
      handleEntries(po.takeRecords() );
      po.disconnect();
    }, true);
  }
};


//# sourceMappingURL=getFID.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getLCP.js







/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const reportedMetricIDs = {};

/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */
const onLCP = (onReport) => {
  const visibilityWatcher = getVisibilityWatcher();
  const metric = initMetric('LCP');
  let report;

  const handleEntries = (entries) => {
    const lastEntry = entries[entries.length - 1] ;
    if (lastEntry) {
      // The startTime attribute returns the value of the renderTime if it is
      // not 0, and the value of the loadTime otherwise. The activationStart
      // reference is used because LCP should be relative to page activation
      // rather than navigation start if the page was prerendered.
      const value = Math.max(lastEntry.startTime - getActivationStart(), 0);

      // Only report if the page wasn't hidden prior to LCP.
      if (value < visibilityWatcher.firstHiddenTime) {
        metric.value = value;
        metric.entries = [lastEntry];
        report();
      }
    }
  };

  const po = observe('largest-contentful-paint', handleEntries);

  if (po) {
    report = bindReporter(onReport, metric);

    const stopListening = () => {
      if (!reportedMetricIDs[metric.id]) {
        handleEntries(po.takeRecords() );
        po.disconnect();
        reportedMetricIDs[metric.id] = true;
        report(true);
      }
    };

    // Stop listening after input. Note: while scrolling is an input that
    // stop LCP observation, it's unreliable since it can be programmatically
    // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
    ['keydown', 'click'].forEach(type => {
      addEventListener(type, stopListening, { once: true, capture: true });
    });

    onHidden(stopListening, true);

    return stopListening;
  }

  return;
};


//# sourceMappingURL=getLCP.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/metrics/utils.js
/**
 * Checks if a given value is a valid measurement value.
 */
function isMeasurementValue(value) {
  return typeof value === 'number' && isFinite(value);
}

/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */
function _startChild(transaction, { startTimestamp, ...ctx }) {
  if (startTimestamp && transaction.startTimestamp > startTimestamp) {
    transaction.startTimestamp = startTimestamp;
  }

  return transaction.startChild({
    startTimestamp,
    ...ctx,
  });
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/metrics/index.js










/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */
function msToSec(time) {
  return time / 1000;
}

function getBrowserPerformanceAPI() {
  return WINDOW && WINDOW.addEventListener && WINDOW.performance;
}

let _performanceCursor = 0;

let _measurements = {};
let _lcpEntry;
let _clsEntry;

/**
 * Start tracking web vitals
 *
 * @returns A function that forces web vitals collection
 */
function startTrackingWebVitals() {
  const performance = getBrowserPerformanceAPI();
  if (performance && time/* browserPerformanceTimeOrigin */.Z1) {
    if (performance.mark) {
      WINDOW.performance.mark('sentry-tracing-init');
    }
    _trackFID();
    const clsCallback = _trackCLS();
    const lcpCallback = _trackLCP();

    return () => {
      if (clsCallback) {
        clsCallback();
      }
      if (lcpCallback) {
        lcpCallback();
      }
    };
  }

  return () => undefined;
}

/**
 * Start tracking long tasks.
 */
function startTrackingLongTasks() {
  const entryHandler = (entries) => {
    for (const entry of entries) {
      const transaction = getActiveTransaction() ;
      if (!transaction) {
        return;
      }
      const startTime = msToSec((time/* browserPerformanceTimeOrigin */.Z1 ) + entry.startTime);
      const duration = msToSec(entry.duration);

      transaction.startChild({
        description: 'Main UI thread blocked',
        op: 'ui.long-task',
        startTimestamp: startTime,
        endTimestamp: startTime + duration,
      });
    }
  };

  observe('longtask', entryHandler);
}

/**
 * Start tracking interaction events.
 */
function startTrackingInteractions() {
  const entryHandler = (entries) => {
    for (const entry of entries) {
      const transaction = getActiveTransaction() ;
      if (!transaction) {
        return;
      }

      if (entry.name === 'click') {
        const startTime = msToSec((time/* browserPerformanceTimeOrigin */.Z1 ) + entry.startTime);
        const duration = msToSec(entry.duration);

        transaction.startChild({
          description: (0,browser/* htmlTreeAsString */.Rt)(entry.target),
          op: `ui.interaction.${entry.name}`,
          startTimestamp: startTime,
          endTimestamp: startTime + duration,
        });
      }
    }
  };

  observe('event', entryHandler, { durationThreshold: 0 });
}

/** Starts tracking the Cumulative Layout Shift on the current page. */
function _trackCLS() {
  // See:
  // https://web.dev/evolving-cls/
  // https://web.dev/cls-web-tooling/
  return onCLS(metric => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding CLS');
    _measurements['cls'] = { value: metric.value, unit: '' };
    _clsEntry = entry ;
  });
}

/** Starts tracking the Largest Contentful Paint on the current page. */
function _trackLCP() {
  return onLCP(metric => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding LCP');
    _measurements['lcp'] = { value: metric.value, unit: 'millisecond' };
    _lcpEntry = entry ;
  });
}

/** Starts tracking the First Input Delay on the current page. */
function _trackFID() {
  onFID(metric => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    const timeOrigin = msToSec(time/* browserPerformanceTimeOrigin */.Z1 );
    const startTime = msToSec(entry.startTime);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding FID');
    _measurements['fid'] = { value: metric.value, unit: 'millisecond' };
    _measurements['mark.fid'] = { value: timeOrigin + startTime, unit: 'second' };
  });
}

/** Add performance related spans to a transaction */
function addPerformanceEntries(transaction) {
  const performance = getBrowserPerformanceAPI();
  if (!performance || !WINDOW.performance.getEntries || !time/* browserPerformanceTimeOrigin */.Z1) {
    // Gatekeeper if performance API not available
    return;
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Tracing] Adding & adjusting spans using Performance API');
  const timeOrigin = msToSec(time/* browserPerformanceTimeOrigin */.Z1);

  const performanceEntries = performance.getEntries();

  let responseStartTimestamp;
  let requestStartTimestamp;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  performanceEntries.slice(_performanceCursor).forEach((entry) => {
    const startTime = msToSec(entry.startTime);
    const duration = msToSec(entry.duration);

    if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) {
      return;
    }

    switch (entry.entryType) {
      case 'navigation': {
        _addNavigationSpans(transaction, entry, timeOrigin);
        responseStartTimestamp = timeOrigin + msToSec(entry.responseStart);
        requestStartTimestamp = timeOrigin + msToSec(entry.requestStart);
        break;
      }
      case 'mark':
      case 'paint':
      case 'measure': {
        _addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);

        // capture web vitals
        const firstHidden = getVisibilityWatcher();
        // Only report if the page wasn't hidden prior to the web vital.
        const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;

        if (entry.name === 'first-paint' && shouldRecord) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding FP');
          _measurements['fp'] = { value: entry.startTime, unit: 'millisecond' };
        }
        if (entry.name === 'first-contentful-paint' && shouldRecord) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding FCP');
          _measurements['fcp'] = { value: entry.startTime, unit: 'millisecond' };
        }
        break;
      }
      case 'resource': {
        const resourceName = (entry.name ).replace(WINDOW.location.origin, '');
        _addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin);
        break;
      }
      // Ignore other entry types.
    }
  });

  _performanceCursor = Math.max(performanceEntries.length - 1, 0);

  _trackNavigator(transaction);

  // Measurements are only available for pageload transactions
  if (transaction.op === 'pageload') {
    // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
    // start of the response in milliseconds
    if (typeof responseStartTimestamp === 'number') {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding TTFB');
      _measurements['ttfb'] = {
        value: (responseStartTimestamp - transaction.startTimestamp) * 1000,
        unit: 'millisecond',
      };

      if (typeof requestStartTimestamp === 'number' && requestStartTimestamp <= responseStartTimestamp) {
        // Capture the time spent making the request and receiving the first byte of the response.
        // This is the time between the start of the request and the start of the response in milliseconds.
        _measurements['ttfb.requestTime'] = {
          value: (responseStartTimestamp - requestStartTimestamp) * 1000,
          unit: 'millisecond',
        };
      }
    }

    ['fcp', 'fp', 'lcp'].forEach(name => {
      if (!_measurements[name] || timeOrigin >= transaction.startTimestamp) {
        return;
      }
      // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
      // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
      // to be adjusted to be relative to transaction.startTimestamp.
      const oldValue = _measurements[name].value;
      const measurementTimestamp = timeOrigin + msToSec(oldValue);

      // normalizedValue should be in milliseconds
      const normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
      const delta = normalizedValue - oldValue;

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.log */.kg.log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
      _measurements[name].value = normalizedValue;
    });

    const fidMark = _measurements['mark.fid'];
    if (fidMark && _measurements['fid']) {
      // create span for FID
      _startChild(transaction, {
        description: 'first input delay',
        endTimestamp: fidMark.value + msToSec(_measurements['fid'].value),
        op: 'ui.action',
        startTimestamp: fidMark.value,
      });

      // Delete mark.fid as we don't want it to be part of final payload
      delete _measurements['mark.fid'];
    }

    // If FCP is not recorded we should not record the cls value
    // according to the new definition of CLS.
    if (!('fcp' in _measurements)) {
      delete _measurements.cls;
    }

    Object.keys(_measurements).forEach(measurementName => {
      transaction.setMeasurement(
        measurementName,
        _measurements[measurementName].value,
        _measurements[measurementName].unit,
      );
    });

    _tagMetricInfo(transaction);
  }

  _lcpEntry = undefined;
  _clsEntry = undefined;
  _measurements = {};
}

/** Create measure related spans */
function _addMeasureSpans(
  transaction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry,
  startTime,
  duration,
  timeOrigin,
) {
  const measureStartTimestamp = timeOrigin + startTime;
  const measureEndTimestamp = measureStartTimestamp + duration;

  _startChild(transaction, {
    description: entry.name ,
    endTimestamp: measureEndTimestamp,
    op: entry.entryType ,
    startTimestamp: measureStartTimestamp,
  });

  return measureStartTimestamp;
}

/** Instrument navigation entries */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addNavigationSpans(transaction, entry, timeOrigin) {
  ['unloadEvent', 'redirect', 'domContentLoadedEvent', 'loadEvent', 'connect'].forEach(event => {
    _addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
  });
  _addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
  _addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
  _addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
  _addRequest(transaction, entry, timeOrigin);
}

/** Create performance navigation related spans */
function _addPerformanceNavigationTiming(
  transaction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry,
  event,
  timeOrigin,
  description,
  eventEnd,
) {
  const end = eventEnd ? (entry[eventEnd] ) : (entry[`${event}End`] );
  const start = entry[`${event}Start`] ;
  if (!start || !end) {
    return;
  }
  _startChild(transaction, {
    op: 'browser',
    description: description || event,
    startTimestamp: timeOrigin + msToSec(start),
    endTimestamp: timeOrigin + msToSec(end),
  });
}

/** Create request and response related spans */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addRequest(transaction, entry, timeOrigin) {
  _startChild(transaction, {
    op: 'browser',
    description: 'request',
    startTimestamp: timeOrigin + msToSec(entry.requestStart ),
    endTimestamp: timeOrigin + msToSec(entry.responseEnd ),
  });

  _startChild(transaction, {
    op: 'browser',
    description: 'response',
    startTimestamp: timeOrigin + msToSec(entry.responseStart ),
    endTimestamp: timeOrigin + msToSec(entry.responseEnd ),
  });
}

/** Create resource-related spans */
function _addResourceSpans(
  transaction,
  entry,
  resourceName,
  startTime,
  duration,
  timeOrigin,
) {
  // we already instrument based on fetch and xhr, so we don't need to
  // duplicate spans here.
  if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const data = {};
  if ('transferSize' in entry) {
    data['http.response_transfer_size'] = entry.transferSize;
  }
  if ('encodedBodySize' in entry) {
    data['http.response_content_length'] = entry.encodedBodySize;
  }
  if ('decodedBodySize' in entry) {
    data['http.decoded_response_content_length'] = entry.decodedBodySize;
  }
  if ('renderBlockingStatus' in entry) {
    data['resource.render_blocking_status'] = entry.renderBlockingStatus;
  }

  const startTimestamp = timeOrigin + startTime;
  const endTimestamp = startTimestamp + duration;

  _startChild(transaction, {
    description: resourceName,
    endTimestamp,
    op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
    startTimestamp,
    data,
  });
}

/**
 * Capture the information of the user agent.
 */
function _trackNavigator(transaction) {
  const navigator = WINDOW.navigator ;
  if (!navigator) {
    return;
  }

  // track network connectivity
  const connection = navigator.connection;
  if (connection) {
    if (connection.effectiveType) {
      transaction.setTag('effectiveConnectionType', connection.effectiveType);
    }

    if (connection.type) {
      transaction.setTag('connectionType', connection.type);
    }

    if (isMeasurementValue(connection.rtt)) {
      _measurements['connection.rtt'] = { value: connection.rtt, unit: 'millisecond' };
    }
  }

  if (isMeasurementValue(navigator.deviceMemory)) {
    transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
  }

  if (isMeasurementValue(navigator.hardwareConcurrency)) {
    transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
  }
}

/** Add LCP / CLS data to transaction to allow debugging */
function _tagMetricInfo(transaction) {
  if (_lcpEntry) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding LCP Data');

    // Capture Properties of the LCP element that contributes to the LCP.

    if (_lcpEntry.element) {
      transaction.setTag('lcp.element', (0,browser/* htmlTreeAsString */.Rt)(_lcpEntry.element));
    }

    if (_lcpEntry.id) {
      transaction.setTag('lcp.id', _lcpEntry.id);
    }

    if (_lcpEntry.url) {
      // Trim URL to the first 200 characters.
      transaction.setTag('lcp.url', _lcpEntry.url.trim().slice(0, 200));
    }

    transaction.setTag('lcp.size', _lcpEntry.size);
  }

  // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
  if (_clsEntry && _clsEntry.sources) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding CLS Data');
    _clsEntry.sources.forEach((source, index) =>
      transaction.setTag(`cls.source.${index + 1}`, (0,browser/* htmlTreeAsString */.Rt)(source.node)),
    );
  }
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(57321);
;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/request.js



/* eslint-disable max-lines */

const DEFAULT_TRACE_PROPAGATION_TARGETS = ['localhost', /^\/(?!\/)/];

/** Options for Request Instrumentation */

const defaultRequestInstrumentationOptions = {
  traceFetch: true,
  traceXHR: true,
  // TODO (v8): Remove this property
  tracingOrigins: DEFAULT_TRACE_PROPAGATION_TARGETS,
  tracePropagationTargets: DEFAULT_TRACE_PROPAGATION_TARGETS,
};

/** Registers span creators for xhr and fetch requests  */
function instrumentOutgoingRequests(_options) {
  // eslint-disable-next-line deprecation/deprecation
  const { traceFetch, traceXHR, tracePropagationTargets, tracingOrigins, shouldCreateSpanForRequest } = {
    traceFetch: defaultRequestInstrumentationOptions.traceFetch,
    traceXHR: defaultRequestInstrumentationOptions.traceXHR,
    ..._options,
  };

  const shouldCreateSpan =
    typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_) => true;

  // TODO(v8) Remove tracingOrigins here
  // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
  // and we don't want to break the API. We can remove it in v8.
  const shouldAttachHeadersWithTargets = (url) =>
    shouldAttachHeaders(url, tracePropagationTargets || tracingOrigins);

  const spans = {};

  if (traceFetch) {
    (0,instrument/* addInstrumentationHandler */.oq)('fetch', (handlerData) => {
      fetchCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
    });
  }

  if (traceXHR) {
    (0,instrument/* addInstrumentationHandler */.oq)('xhr', (handlerData) => {
      xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
    });
  }
}

/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */
function shouldAttachHeaders(url, tracePropagationTargets) {
  return (0,string/* stringMatchesSomePattern */.U0)(url, tracePropagationTargets || DEFAULT_TRACE_PROPAGATION_TARGETS);
}

/**
 * Create and track fetch request spans
 */
function fetchCallback(
  handlerData,
  shouldCreateSpan,
  shouldAttachHeaders,
  spans,
) {
  if (!hasTracingEnabled() || !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) {
    return;
  }

  if (handlerData.endTimestamp) {
    const spanId = handlerData.fetchData.__span;
    if (!spanId) return;

    const span = spans[spanId];
    if (span) {
      if (handlerData.response) {
        // TODO (kmclb) remove this once types PR goes through
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        span.setHttpStatus(handlerData.response.status);

        const contentLength =
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          handlerData.response && handlerData.response.headers && handlerData.response.headers.get('content-length');

        const contentLengthNum = parseInt(contentLength);
        if (contentLengthNum > 0) {
          span.setData('http.response_content_length', contentLengthNum);
        }
      } else if (handlerData.error) {
        span.setStatus('internal_error');
      }
      span.finish();

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return;
  }

  const currentScope = (0,esm_hub/* getCurrentHub */.Gd)().getScope();
  const currentSpan = currentScope && currentScope.getSpan();
  const activeTransaction = currentSpan && currentSpan.transaction;

  if (currentSpan && activeTransaction) {
    const { method, url } = handlerData.fetchData;
    const span = currentSpan.startChild({
      data: {
        url,
        type: 'fetch',
        'http.method': method,
      },
      description: `${method} ${url}`,
      op: 'http.client',
    });

    handlerData.fetchData.__span = span.spanId;
    spans[span.spanId] = span;

    const request = handlerData.args[0];

    // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
    handlerData.args[1] = handlerData.args[1] || {};

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const options = handlerData.args[1];

    if (shouldAttachHeaders(handlerData.fetchData.url)) {
      options.headers = addTracingHeadersToFetchRequest(
        request,
        activeTransaction.getDynamicSamplingContext(),
        span,
        options,
      );
    }
  }
}

/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */
function addTracingHeadersToFetchRequest(
  request, // unknown is actually type Request but we can't export DOM types from this package,
  dynamicSamplingContext,
  span,
  options

,
) {
  const sentryBaggageHeader = dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext);
  const sentryTraceHeader = span.toTraceparent();

  const headers =
    typeof Request !== 'undefined' && (0,is/* isInstanceOf */.V9)(request, Request) ? (request ).headers : options.headers;

  if (!headers) {
    return { 'sentry-trace': sentryTraceHeader, baggage: sentryBaggageHeader };
  } else if (typeof Headers !== 'undefined' && (0,is/* isInstanceOf */.V9)(headers, Headers)) {
    const newHeaders = new Headers(headers );

    newHeaders.append('sentry-trace', sentryTraceHeader);

    if (sentryBaggageHeader) {
      // If the same header is appended multiple times the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.append(BAGGAGE_HEADER_NAME, sentryBaggageHeader);
    }

    return newHeaders ;
  } else if (Array.isArray(headers)) {
    const newHeaders = [...headers, ['sentry-trace', sentryTraceHeader]];

    if (sentryBaggageHeader) {
      // If there are multiple entries with the same key, the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.push([BAGGAGE_HEADER_NAME, sentryBaggageHeader]);
    }

    return newHeaders ;
  } else {
    const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
    const newBaggageHeaders = [];

    if (Array.isArray(existingBaggageHeader)) {
      newBaggageHeaders.push(...existingBaggageHeader);
    } else if (existingBaggageHeader) {
      newBaggageHeaders.push(existingBaggageHeader);
    }

    if (sentryBaggageHeader) {
      newBaggageHeaders.push(sentryBaggageHeader);
    }

    return {
      ...(headers ),
      'sentry-trace': sentryTraceHeader,
      baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined,
    };
  }
}

/**
 * Create and track xhr request spans
 */
function xhrCallback(
  handlerData,
  shouldCreateSpan,
  shouldAttachHeaders,
  spans,
) {
  const xhr = handlerData.xhr;
  const sentryXhrData = xhr && xhr[instrument/* SENTRY_XHR_DATA_KEY */.xU];

  if (
    !hasTracingEnabled() ||
    (xhr && xhr.__sentry_own_request__) ||
    !(xhr && sentryXhrData && shouldCreateSpan(sentryXhrData.url))
  ) {
    return;
  }

  // check first if the request has finished and is tracked by an existing span which should now end
  if (handlerData.endTimestamp) {
    const spanId = xhr.__sentry_xhr_span_id__;
    if (!spanId) return;

    const span = spans[spanId];
    if (span) {
      span.setHttpStatus(sentryXhrData.status_code);
      span.finish();

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return;
  }

  const currentScope = (0,esm_hub/* getCurrentHub */.Gd)().getScope();
  const currentSpan = currentScope && currentScope.getSpan();
  const activeTransaction = currentSpan && currentSpan.transaction;

  if (currentSpan && activeTransaction) {
    const span = currentSpan.startChild({
      data: {
        ...sentryXhrData.data,
        type: 'xhr',
        'http.method': sentryXhrData.method,
        url: sentryXhrData.url,
      },
      description: `${sentryXhrData.method} ${sentryXhrData.url}`,
      op: 'http.client',
    });

    xhr.__sentry_xhr_span_id__ = span.spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;

    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url)) {
      try {
        xhr.setRequestHeader('sentry-trace', span.toTraceparent());

        const dynamicSamplingContext = activeTransaction.getDynamicSamplingContext();
        const sentryBaggageHeader = dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext);

        if (sentryBaggageHeader) {
          // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
          // We can therefore simply set a baggage header without checking what was there before
          // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
          xhr.setRequestHeader(BAGGAGE_HEADER_NAME, sentryBaggageHeader);
        }
      } catch (_) {
        // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
      }
    }
  }
}


//# sourceMappingURL=request.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/router.js



/**
 * Default function implementing pageload and navigation transactions
 */
function instrumentRoutingWithDefaults(
  customStartTransaction,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  if (!WINDOW || !WINDOW.location) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('Could not initialize routing instrumentation due to invalid location');
    return;
  }

  let startingUrl = WINDOW.location.href;

  let activeTransaction;
  if (startTransactionOnPageLoad) {
    activeTransaction = customStartTransaction({
      name: WINDOW.location.pathname,
      // pageload should always start at timeOrigin (and needs to be in s, not ms)
      startTimestamp: time/* browserPerformanceTimeOrigin */.Z1 ? time/* browserPerformanceTimeOrigin */.Z1 / 1000 : undefined,
      op: 'pageload',
      metadata: { source: 'url' },
    });
  }

  if (startTransactionOnLocationChange) {
    (0,instrument/* addInstrumentationHandler */.oq)('history', ({ to, from }) => {
      /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */
      if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
        startingUrl = undefined;
        return;
      }

      if (from !== to) {
        startingUrl = undefined;
        if (activeTransaction) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
          // If there's an open transaction on the scope, we need to finish it before creating an new one.
          activeTransaction.finish();
        }
        activeTransaction = customStartTransaction({
          name: WINDOW.location.pathname,
          op: 'navigation',
          metadata: { source: 'url' },
        });
      }
    });
  }
}


//# sourceMappingURL=router.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/browsertracing.js








const BROWSER_TRACING_INTEGRATION_ID = 'BrowserTracing';

/** Options for Browser Tracing integration */

const DEFAULT_BROWSER_TRACING_OPTIONS = {
  ...TRACING_DEFAULTS,
  markBackgroundTransactions: true,
  routingInstrumentation: instrumentRoutingWithDefaults,
  startTransactionOnLocationChange: true,
  startTransactionOnPageLoad: true,
  enableLongTask: true,
  _experiments: {},
  ...defaultRequestInstrumentationOptions,
};

/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */
class BrowserTracing  {
  // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
  // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
  // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
  // integrations.

  /** Browser Tracing integration options */

  /**
   * @inheritDoc
   */
   __init() {this.name = BROWSER_TRACING_INTEGRATION_ID;}

   constructor(_options) {BrowserTracing.prototype.__init.call(this);
    addTracingExtensions();

    this.options = {
      ...DEFAULT_BROWSER_TRACING_OPTIONS,
      ..._options,
    };

    // Special case: enableLongTask can be set in _experiments
    // TODO (v8): Remove this in v8
    if (this.options._experiments.enableLongTask !== undefined) {
      this.options.enableLongTask = this.options._experiments.enableLongTask;
    }

    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) {
      // eslint-disable-next-line deprecation/deprecation
      this.options.tracePropagationTargets = _options.tracingOrigins;
    }

    this._collectWebVitals = startTrackingWebVitals();
    if (this.options.enableLongTask) {
      startTrackingLongTasks();
    }
    if (this.options._experiments.enableInteractions) {
      startTrackingInteractions();
    }
  }

  /**
   * @inheritDoc
   */
   setupOnce(_, getCurrentHub) {
    this._getCurrentHub = getCurrentHub;

    const {
      routingInstrumentation: instrumentRouting,
      startTransactionOnLocationChange,
      startTransactionOnPageLoad,
      markBackgroundTransactions,
      traceFetch,
      traceXHR,
      tracePropagationTargets,
      shouldCreateSpanForRequest,
      _experiments,
    } = this.options;

    instrumentRouting(
      (context) => {
        const transaction = this._createRouteTransaction(context);

        this.options._experiments.onStartRouteTransaction &&
          this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);

        return transaction;
      },
      startTransactionOnPageLoad,
      startTransactionOnLocationChange,
    );

    if (markBackgroundTransactions) {
      registerBackgroundTabDetection();
    }

    if (_experiments.enableInteractions) {
      this._registerInteractionListener();
    }

    instrumentOutgoingRequests({
      traceFetch,
      traceXHR,
      tracePropagationTargets,
      shouldCreateSpanForRequest,
    });
  }

  /** Create routing idle transaction. */
   _createRouteTransaction(context) {
    if (!this._getCurrentHub) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
      return undefined;
    }

    const { beforeNavigate, idleTimeout, finalTimeout, heartbeatInterval } = this.options;

    const isPageloadTransaction = context.op === 'pageload';

    const sentryTraceMetaTagValue = isPageloadTransaction ? getMetaContent('sentry-trace') : null;
    const baggageMetaTagValue = isPageloadTransaction ? getMetaContent('baggage') : null;

    const traceParentData = sentryTraceMetaTagValue ? extractTraceparentData(sentryTraceMetaTagValue) : undefined;
    const dynamicSamplingContext = baggageMetaTagValue
      ? baggageHeaderToDynamicSamplingContext(baggageMetaTagValue)
      : undefined;

    const expandedContext = {
      ...context,
      ...traceParentData,
      metadata: {
        ...context.metadata,
        dynamicSamplingContext: traceParentData && !dynamicSamplingContext ? {} : dynamicSamplingContext,
      },
      trimEnd: true,
    };

    const modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;

    // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
    // from being sent to Sentry).
    const finalContext = modifiedContext === undefined ? { ...expandedContext, sampled: false } : modifiedContext;

    // If `beforeNavigate` set a custom name, record that fact
    finalContext.metadata =
      finalContext.name !== expandedContext.name
        ? { ...finalContext.metadata, source: 'custom' }
        : finalContext.metadata;

    this._latestRouteName = finalContext.name;
    this._latestRouteSource = finalContext.metadata && finalContext.metadata.source;

    if (finalContext.sampled === false) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.log */.kg.log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] Starting ${finalContext.op} transaction on scope`);

    const hub = this._getCurrentHub();
    const { location } = WINDOW;

    const idleTransaction = startIdleTransaction(
      hub,
      finalContext,
      idleTimeout,
      finalTimeout,
      true,
      { location }, // for use in the tracesSampler
      heartbeatInterval,
    );
    idleTransaction.registerBeforeFinishCallback(transaction => {
      this._collectWebVitals();
      addPerformanceEntries(transaction);
    });

    return idleTransaction ;
  }

  /** Start listener for interaction transactions */
   _registerInteractionListener() {
    let inflightInteractionTransaction;
    const registerInteractionTransaction = () => {
      const { idleTimeout, finalTimeout, heartbeatInterval } = this.options;
      const op = 'ui.action.click';

      const currentTransaction = getActiveTransaction();
      if (currentTransaction && currentTransaction.op && ['navigation', 'pageload'].includes(currentTransaction.op)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          logger/* logger.warn */.kg.warn(
            `[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`,
          );
        return undefined;
      }

      if (inflightInteractionTransaction) {
        inflightInteractionTransaction.setFinishReason('interactionInterrupted');
        inflightInteractionTransaction.finish();
        inflightInteractionTransaction = undefined;
      }

      if (!this._getCurrentHub) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
        return undefined;
      }

      if (!this._latestRouteName) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
        return undefined;
      }

      const hub = this._getCurrentHub();
      const { location } = WINDOW;

      const context = {
        name: this._latestRouteName,
        op,
        trimEnd: true,
        metadata: {
          source: this._latestRouteSource || 'url',
        },
      };

      inflightInteractionTransaction = startIdleTransaction(
        hub,
        context,
        idleTimeout,
        finalTimeout,
        true,
        { location }, // for use in the tracesSampler
        heartbeatInterval,
      );
    };

    ['click'].forEach(type => {
      addEventListener(type, registerInteractionTransaction, { once: false, capture: true });
    });
  }
}

/** Returns the value of a meta tag */
function getMetaContent(metaName) {
  // Can't specify generic to `getDomElement` because tracing can be used
  // in a variety of environments, have to disable `no-unsafe-member-access`
  // as a result.
  const metaTag = (0,browser/* getDomElement */.qT)(`meta[name=${metaName}]`);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return metaTag ? metaTag.getAttribute('content') : null;
}


//# sourceMappingURL=browsertracing.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/userIntegrations.js
/**
 * Recursively traverses an object to update an existing nested key.
 * Note: The provided key path must include existing properties,
 * the function will not create objects while traversing.
 *
 * @param obj An object to update
 * @param value The value to update the nested key with
 * @param keyPath The path to the key to update ex. fizz.buzz.foo
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setNestedKey(obj, keyPath, value) {
  // Ex. foo.bar.zoop will extract foo and bar.zoop
  const match = keyPath.match(/([a-z_]+)\.(.*)/i);
  // The match will be null when there's no more recursing to do, i.e., when we've reached the right level of the object
  if (match === null) {
    obj[keyPath] = value;
  } else {
    // `match[1]` is the initial segment of the path, and `match[2]` is the remainder of the path
    const innerObj = obj[match[1]];
    setNestedKey(innerObj, match[2], value);
  }
}

/**
 * Enforces inclusion of a given integration with specified options in an integration array originally determined by the
 * user, by either including the given default instance or by patching an existing user instance with the given options.
 *
 * Ideally this would happen when integrations are set up, but there isn't currently a mechanism there for merging
 * options from a default integration instance with those from a user-provided instance of the same integration, only
 * for allowing the user to override a default instance entirely. (TODO: Fix that.)
 *
 * @param defaultIntegrationInstance An instance of the integration with the correct options already set
 * @param userIntegrations Integrations defined by the user.
 * @param forcedOptions Options with which to patch an existing user-derived instance on the integration.
 * @returns A final integrations array.
 */
function addOrUpdateIntegration(
  defaultIntegrationInstance,
  userIntegrations,
  forcedOptions = {},
) {
  return (
    Array.isArray(userIntegrations)
      ? addOrUpdateIntegrationInArray(defaultIntegrationInstance, userIntegrations, forcedOptions)
      : addOrUpdateIntegrationInFunction(
          defaultIntegrationInstance,
          // Somehow TS can't figure out that not being an array makes this necessarily a function
          userIntegrations ,
          forcedOptions,
        )
  ) ;
}

function addOrUpdateIntegrationInArray(
  defaultIntegrationInstance,
  userIntegrations,
  forcedOptions,
) {
  const userInstance = userIntegrations.find(integration => integration.name === defaultIntegrationInstance.name);

  if (userInstance) {
    for (const [keyPath, value] of Object.entries(forcedOptions)) {
      setNestedKey(userInstance, keyPath, value);
    }

    return userIntegrations;
  }

  return [...userIntegrations, defaultIntegrationInstance];
}

function addOrUpdateIntegrationInFunction(
  defaultIntegrationInstance,
  userIntegrationsFunc,
  forcedOptions,
) {
  const wrapper = defaultIntegrations => {
    const userFinalIntegrations = userIntegrationsFunc(defaultIntegrations);

    // There are instances where we want the user to be able to prevent an integration from appearing at all, which they
    // would do by providing a function which filters out the integration in question. If that's happened in one of
    // those cases, don't add our default back in.
    if (defaultIntegrationInstance.allowExclusionByUser) {
      const userFinalInstance = userFinalIntegrations.find(
        integration => integration.name === defaultIntegrationInstance.name,
      );
      if (!userFinalInstance) {
        return userFinalIntegrations;
      }
    }

    return addOrUpdateIntegrationInArray(defaultIntegrationInstance, userFinalIntegrations, forcedOptions);
  };

  return wrapper;
}


//# sourceMappingURL=userIntegrations.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/getVercelEnv.js
/* provided dependency */ var process = __webpack_require__(83454);
/**
 * Returns an environment setting value determined by Vercel's `VERCEL_ENV` environment variable.
 *
 * @param isClient Flag to indicate whether to use the `NEXT_PUBLIC_` prefixed version of the environment variable.
 */
function getVercelEnv(isClient) {
  const vercelEnvVar = isClient ? process.env.NEXT_PUBLIC_VERCEL_ENV : process.env.VERCEL_ENV;
  return vercelEnvVar ? `vercel-${vercelEnvVar}` : undefined;
}


//# sourceMappingURL=getVercelEnv.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/metadata.js


const PACKAGE_NAME_PREFIX = 'npm:@sentry/';

/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 * @param options sdk options object that gets mutated
 * @param names list of package names
 */
function buildMetadata(options, names) {
  options._metadata = options._metadata || {};
  options._metadata.sdk =
    options._metadata.sdk ||
    ({
      name: 'sentry.javascript.nextjs',
      packages: names.map(name => ({
        name: `${PACKAGE_NAME_PREFIX}${name}`,
        version: version/* SDK_VERSION */.J,
      })),
      version: version/* SDK_VERSION */.J,
    } );
}


//# sourceMappingURL=metadata.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/helpers.js
var helpers = __webpack_require__(86891);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/url.js
var url = __webpack_require__(26956);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/performance.js





const globalObject = helpers/* WINDOW */.m9

;

/**
 * Every Next.js page (static and dynamic ones) comes with a script tag with the id "__NEXT_DATA__". This script tag
 * contains a JSON object with data that was either generated at build time for static pages (`getStaticProps`), or at
 * runtime with data fetchers like `getServerSideProps.`.
 *
 * We can use this information to:
 * - Always get the parameterized route we're in when loading a page.
 * - Send trace information (trace-id, baggage) from the server to the client.
 *
 * This function extracts this information.
 */
function extractNextDataTagInformation() {
  let nextData;
  // Let's be on the safe side and actually check first if there is really a __NEXT_DATA__ script tag on the page.
  // Theoretically this should always be the case though.
  const nextDataTag = globalObject.document.getElementById('__NEXT_DATA__');
  if (nextDataTag && nextDataTag.innerHTML) {
    try {
      nextData = JSON.parse(nextDataTag.innerHTML);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('Could not extract __NEXT_DATA__');
    }
  }

  if (!nextData) {
    return {};
  }

  const nextDataTagInfo = {};

  const { page, query, props } = nextData;

  // `nextData.page` always contains the parameterized route - except for when an error occurs in a data fetching
  // function, then it is "/_error", but that isn't a problem since users know which route threw by looking at the
  // parent transaction
  // TODO: Actually this is a problem (even though it is not that big), because the DSC and the transaction payload will contain
  // a different transaction name. Maybe we can fix this. Idea: Also send transaction name via pageProps when available.
  nextDataTagInfo.route = page;
  nextDataTagInfo.params = query;

  if (props && props.pageProps) {
    if (props.pageProps._sentryBaggage) {
      nextDataTagInfo.baggage = props.pageProps._sentryBaggage;
    }

    if (props.pageProps._sentryTraceData) {
      nextDataTagInfo.traceParentData = extractTraceparentData(props.pageProps._sentryTraceData);
    }
  }

  return nextDataTagInfo;
}

const DEFAULT_TAGS = {
  'routing.instrumentation': 'next-router',
} ;

// We keep track of the active transaction so we can finish it when we start a navigation transaction.
let activeTransaction = undefined;

// We keep track of the previous location name so we can set the `from` field on navigation transactions.
// This is either a route or a pathname.
let prevLocationName = undefined;

const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();

/**
 * Creates routing instrumention for Next Router. Only supported for
 * client side routing. Works for Next >= 10.
 *
 * Leverages the SingletonRouter from the `next/router` to
 * generate pageload/navigation transactions and parameterize
 * transaction names.
 */
function nextRouterInstrumentation(
  startTransactionCb,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  const { route, traceParentData, baggage, params } = extractNextDataTagInformation();
  prevLocationName = route || globalObject.location.pathname;

  if (startTransactionOnPageLoad) {
    const source = route ? 'route' : 'url';
    const dynamicSamplingContext = baggageHeaderToDynamicSamplingContext(baggage);

    activeTransaction = startTransactionCb({
      name: prevLocationName,
      op: 'pageload',
      tags: DEFAULT_TAGS,
      ...(params && client && client.getOptions().sendDefaultPii && { data: params }),
      ...traceParentData,
      metadata: {
        source,
        dynamicSamplingContext: traceParentData && !dynamicSamplingContext ? {} : dynamicSamplingContext,
      },
    });
  }

  if (startTransactionOnLocationChange) {
    router_default().events.on('routeChangeStart', (navigationTarget) => {
      const matchedRoute = getNextRouteFromPathname((0,url/* stripUrlQueryAndFragment */.rt)(navigationTarget));

      let transactionName;
      let transactionSource;

      if (matchedRoute) {
        transactionName = matchedRoute;
        transactionSource = 'route';
      } else {
        transactionName = navigationTarget;
        transactionSource = 'url';
      }

      const tags = {
        ...DEFAULT_TAGS,
        from: prevLocationName,
      };

      prevLocationName = transactionName;

      if (activeTransaction) {
        activeTransaction.finish();
      }

      const navigationTransaction = startTransactionCb({
        name: transactionName,
        op: 'navigation',
        tags,
        metadata: { source: transactionSource },
      });

      if (navigationTransaction) {
        // In addition to the navigation transaction we're also starting a span to mark Next.js's `routeChangeStart`
        // and `routeChangeComplete` events.
        // We don't want to finish the navigation transaction on `routeChangeComplete`, since users might want to attach
        // spans to that transaction even after `routeChangeComplete` is fired (eg. HTTP requests in some useEffect
        // hooks). Instead, we'll simply let the navigation transaction finish itself (it's an `IdleTransaction`).
        const nextRouteChangeSpan = navigationTransaction.startChild({
          op: 'ui.nextjs.route-change',
          description: 'Next.js Route Change',
        });

        const finishRouteChangeSpan = () => {
          nextRouteChangeSpan.finish();
          router_default().events.off('routeChangeComplete', finishRouteChangeSpan);
        };

        router_default().events.on('routeChangeComplete', finishRouteChangeSpan);
      }
    });
  }
}

function getNextRouteFromPathname(pathname) {
  const pageRoutes = (globalObject.__BUILD_MANIFEST || {}).sortedPages;

  // Page route should in 99.999% of the cases be defined by now but just to be sure we make a check here
  if (!pageRoutes) {
    return;
  }

  return pageRoutes.find(route => {
    const routeRegExp = convertNextRouteToRegExp(route);
    return pathname.match(routeRegExp);
  });
}

/**
 * Converts a Next.js style route to a regular expression that matches on pathnames (no query params or URL fragments).
 *
 * In general this involves replacing any instances of square brackets in a route with a wildcard:
 * e.g. "/users/[id]/info" becomes /\/users\/([^/]+?)\/info/
 *
 * Some additional edgecases need to be considered:
 * - All routes have an optional slash at the end, meaning users can navigate to "/users/[id]/info" or
 *   "/users/[id]/info/" - both will be resolved to "/users/[id]/info".
 * - Non-optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[...params]").
 * - Optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[[...params]]").
 *
 * @param route A Next.js style route as it is found in `global.__BUILD_MANIFEST.sortedPages`
 */
function convertNextRouteToRegExp(route) {
  // We can assume a route is at least "/".
  const routeParts = route.split('/');

  let optionalCatchallWildcardRegex = '';
  if (routeParts[routeParts.length - 1].match(/^\[\[\.\.\..+\]\]$/)) {
    // If last route part has pattern "[[...xyz]]" we pop the latest route part to get rid of the required trailing
    // slash that would come before it if we didn't pop it.
    routeParts.pop();
    optionalCatchallWildcardRegex = '(?:/(.+?))?';
  }

  const rejoinedRouteParts = routeParts
    .map(
      routePart =>
        routePart
          .replace(/^\[\.\.\..+\]$/, '(.+?)') // Replace catch all wildcard with regex wildcard
          .replace(/^\[.*\]$/, '([^/]+?)'), // Replace route wildcards with lazy regex wildcards
    )
    .join('/');

  return new RegExp(
    `^${rejoinedRouteParts}${optionalCatchallWildcardRegex}(?:/)?$`, // optional slash at the end
  );
}


//# sourceMappingURL=performance.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/dsn.js
var dsn = __webpack_require__(30292);
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/tunnelRoute.js


const globalWithInjectedValues = __webpack_require__.g

;

/**
 * Applies the `tunnel` option to the Next.js SDK options based on `withSentryConfig`'s `tunnelRoute` option.
 */
function applyTunnelRouteOption(options) {
  const tunnelRouteOption = globalWithInjectedValues.__sentryRewritesTunnelPath__;
  if (tunnelRouteOption && options.dsn) {
    const dsnComponents = (0,dsn/* dsnFromString */.U4)(options.dsn);
    if (!dsnComponents) {
      return;
    }
    const sentrySaasDsnMatch = dsnComponents.host.match(/^o(\d+)\.ingest\.sentry\.io$/);
    if (sentrySaasDsnMatch) {
      const orgId = sentrySaasDsnMatch[1];
      const tunnelPath = `${tunnelRouteOption}?o=${orgId}&p=${dsnComponents.projectId}`;
      options.tunnel = tunnelPath;
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.info */.kg.info(`Tunneling events to "${tunnelPath}"`);
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('Provided DSN is not a Sentry SaaS DSN. Will not tunnel events.');
    }
  }
}


//# sourceMappingURL=tunnelRoute.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/index.js





















// Treeshakable guard to remove all code related to tracing

const client_globalWithInjectedValues = __webpack_require__.g

;

/** Inits the Sentry NextJS SDK on the browser with the React SDK. */
function client_init(options) {
  applyTunnelRouteOption(options);
  buildMetadata(options, ['nextjs', 'react']);

  options.environment = options.environment || getVercelEnv(true) || "production";

  addClientIntegrations(options);

  init(options);

  (0,esm_exports/* configureScope */.e)(scope => {
    scope.setTag('runtime', 'browser');
    const filterTransactions = event =>
      event.type === 'transaction' && event.transaction === '/404' ? null : event;
    filterTransactions.id = 'NextClient404Filter';
    scope.addEventProcessor(filterTransactions);

    if (false) {}
  });
}

function addClientIntegrations(options) {
  let integrations = options.integrations || [];

  // This value is injected at build time, based on the output directory specified in the build config. Though a default
  // is set there, we set it here as well, just in case something has gone wrong with the injection.
  const assetPrefixPath = client_globalWithInjectedValues.__rewriteFramesAssetPrefixPath__ || '';

  const defaultRewriteFramesIntegration = new RewriteFrames({
    // Turn `<origin>/<path>/_next/static/...` into `app:///_next/static/...`
    iteratee: frame => {
      try {
        const { origin } = new URL(frame.filename );
        frame.filename = _optionalChain([frame, 'access', _ => _.filename, 'optionalAccess', _2 => _2.replace, 'call', _3 => _3(origin, 'app://'), 'access', _4 => _4.replace, 'call', _5 => _5(assetPrefixPath, '')]);
      } catch (err) {
        // Filename wasn't a properly formed URL, so there's nothing we can do
      }

      // We need to URI-decode the filename because Next.js has wildcard routes like "/users/[id].js" which show up as "/users/%5id%5.js" in Error stacktraces.
      // The corresponding sources that Next.js generates have proper brackets so we also need proper brackets in the frame so that source map resolving works.
      if (frame.filename && frame.filename.startsWith('app:///_next')) {
        frame.filename = decodeURI(frame.filename);
      }

      if (
        frame.filename &&
        frame.filename.match(
          /^app:\/\/\/_next\/static\/chunks\/(main-|main-app-|polyfills-|webpack-|framework-|framework\.)[0-9a-f]+\.js$/,
        )
      ) {
        // We don't care about these frames. It's Next.js internal code.
        frame.in_app = false;
      }

      return frame;
    },
  });
  integrations = addOrUpdateIntegration(defaultRewriteFramesIntegration, integrations);

  // This evaluates to true unless __SENTRY_TRACING__ is text-replaced with "false", in which case everything inside
  // will get treeshaken away
  if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
    if (hasTracingEnabled(options)) {
      const defaultBrowserTracingIntegration = new BrowserTracing({
        // eslint-disable-next-line deprecation/deprecation
        tracingOrigins: [...defaultRequestInstrumentationOptions.tracingOrigins, /^(api\/)/],
        routingInstrumentation: nextRouterInstrumentation,
      });

      integrations = addOrUpdateIntegration(defaultBrowserTracingIntegration, integrations, {
        'options.routingInstrumentation': nextRouterInstrumentation,
      });
    }
  }

  options.integrations = integrations;
}

/**
 * Just a passthrough in case this is imported from the client.
 */
function withSentryConfig(exportedUserNextConfig) {
  return exportedUserNextConfig;
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./apollo/apollo.ts + 13 modules
var apollo = __webpack_require__(22308);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./components/GoogleAnalytics.tsx



var TRACKING_ID = "G-WYK02Y98MM";
var GoogleAnalytics = function(param) {
    var userId = param.userId;
    if (!TRACKING_ID) {
        return null;
    }
    var gtagConfig = "'".concat(TRACKING_ID, "', {");
    if (userId) {
        gtagConfig += "'user_id': '".concat(userId, "',");
    }
    gtagConfig += "}";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                strategy: "afterInteractive",
                src: "https://www.googletagmanager.com/gtag/js?id=".concat(TRACKING_ID)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                strategy: "afterInteractive",
                id: "gtag-init",
                dangerouslySetInnerHTML: {
                    __html: "\n            window.dataLayer = window.dataLayer || [];\n            function gtag(){dataLayer.push(arguments);}\n            gtag('js', new Date());\n            gtag('config', ".concat(gtagConfig, ");\n          ")
                }
            })
        ]
    });
};
/* harmony default export */ var components_GoogleAnalytics = (/*#__PURE__*/(0,react.memo)(GoogleAnalytics));

// EXTERNAL MODULE: ./components/SpotCounselling/redux/SpotCounsellingActions.ts
var SpotCounsellingActions = __webpack_require__(10585);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./scripts/segment.ts + 1 modules
var segment = __webpack_require__(83697);
// EXTERNAL MODULE: ./uiKit/utils/withWindowDimensions.tsx
var withWindowDimensions = __webpack_require__(96683);
;// CONCATENATED MODULE: ./components/common/InactiveUserModal.tsx








var InactiveUserModal = function(param) {
    var handleCloseModal = param.handleCloseModal, isMobileSized = param.isMobileSized;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = (0,react.useState)(null), modalContent = ref7[0], setModalContent = ref7[1];
    var ref8 = (0,react.useState)(false), shouldShowModal = ref8[0], setShouldShowModal = ref8[1];
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        var fetchModalContent = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var response, data, ref, ref1, ref2, ref3, ref4, paths, matchedPaths, isPathMatched, matchedPathDetail, shouldPathExactMatch, isExactPathMatched;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return fetch("".concat("https://cms.leapscholar.com", "/modals?type=inactive_user_modal"));
                        case 3:
                            response = _ctx.sent;
                            _ctx.next = 6;
                            return response.json();
                        case 6:
                            data = _ctx.sent;
                            if (data === null || data === void 0 ? void 0 : data.length) {
                                ;
                                setModalContent((ref = data[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.modalContent) === null || ref1 === void 0 ? void 0 : ref1[0]);
                                paths = (ref2 = data[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.modalContent) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.paths;
                                if (paths.length) {
                                    matchedPaths = paths === null || paths === void 0 ? void 0 : paths.filter(function(path) {
                                        return router.asPath.includes(path === null || path === void 0 ? void 0 : path.path);
                                    });
                                    isPathMatched = matchedPaths === null || matchedPaths === void 0 ? void 0 : matchedPaths.length;
                                    matchedPathDetail = matchedPaths === null || matchedPaths === void 0 ? void 0 : matchedPaths[0];
                                    shouldPathExactMatch = matchedPathDetail === null || matchedPathDetail === void 0 ? void 0 : matchedPathDetail.exactmatch;
                                    if (shouldPathExactMatch) {
                                        isExactPathMatched = router.pathname === (matchedPathDetail === null || matchedPathDetail === void 0 ? void 0 : matchedPathDetail.path);
                                        if (isExactPathMatched) {
                                            (0,segment.trackPage)(matchedPathDetail === null || matchedPathDetail === void 0 ? void 0 : matchedPathDetail.name);
                                            setShouldShowModal(true);
                                        }
                                    } else if (isPathMatched) {
                                        (0,segment.trackPage)(matchedPathDetail === null || matchedPathDetail === void 0 ? void 0 : matchedPathDetail.name);
                                        setShouldShowModal(true);
                                    }
                                }
                            }
                            _ctx.next = 13;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            console.error("Error fetching modal content:", _ctx.t0);
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }));
            return function fetchModalContent() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchModalContent();
    }, []);
    if (!shouldShowModal) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fixed inset-0 z-50 overflow-auto bg-[#000000] bg-opacity-60 flex md:w-full p-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative md:p-8 p-6 bg-white w-full max-w-md m-auto flex-col flex rounded-lg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-end absolute top-[0.5rem] right-[0.5rem]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/closeIcon.svg"),
                        className: "cursor-pointer",
                        alt: "closeIcon",
                        onClick: handleCloseModal
                    })
                }),
                ((modalContent === null || modalContent === void 0 ? void 0 : modalContent.desktopImage) || (modalContent === null || modalContent === void 0 ? void 0 : modalContent.mobileImage)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: isMobileSized ? modalContent === null || modalContent === void 0 ? void 0 : (ref = modalContent.mobileImage) === null || ref === void 0 ? void 0 : ref.url : modalContent === null || modalContent === void 0 ? void 0 : (ref1 = modalContent.desktopImage) === null || ref1 === void 0 ? void 0 : ref1.url,
                        width: isMobileSized ? 320 : 400,
                        height: isMobileSized ? 200 : 220,
                        alt: "modal_desktop_image"
                    })
                }),
                (modalContent === null || modalContent === void 0 ? void 0 : (ref2 = modalContent.title) === null || ref2 === void 0 ? void 0 : ref2.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-[20px] font-[700] leading-[28px] text-center pt-4 text-[#332EBF]",
                    children: modalContent === null || modalContent === void 0 ? void 0 : modalContent.title
                }) : null,
                (modalContent === null || modalContent === void 0 ? void 0 : (ref3 = modalContent.subtitle) === null || ref3 === void 0 ? void 0 : ref3.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "md:text-[18px] text-[14px] font-[400] leading-[32px] md:pt-2 text-center text-[#332EBF]",
                    children: modalContent === null || modalContent === void 0 ? void 0 : modalContent.subtitle
                }) : null,
                (modalContent === null || modalContent === void 0 ? void 0 : (ref4 = modalContent.description) === null || ref4 === void 0 ? void 0 : ref4.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "md:text-[16px] text-[700] leading-[28px] md:pt-2 text-center",
                    dangerouslySetInnerHTML: {
                        __html: modalContent === null || modalContent === void 0 ? void 0 : modalContent.description
                    }
                }) : null,
                (modalContent === null || modalContent === void 0 ? void 0 : (ref5 = modalContent.bulletPoints) === null || ref5 === void 0 ? void 0 : ref5.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "justify-around flex md:flex-row flex-col pt-4",
                    children: modalContent === null || modalContent === void 0 ? void 0 : (ref6 = modalContent.bulletPoints) === null || ref6 === void 0 ? void 0 : ref6.map(function(item, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-start align-baseline",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/masterclass-type/tick-icon.svg"),
                                    alt: "tick",
                                    width: 20,
                                    height: 20,
                                    className: "mr-2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "md:text-[14px]",
                                    children: item === null || item === void 0 ? void 0 : item.Value
                                })
                            ]
                        }, index);
                    })
                }) : null,
                (modalContent === null || modalContent === void 0 ? void 0 : modalContent.ctaText) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex cursor-pointer justify-center w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: modalContent.ctaUrl,
                        className: "mt-4 bg-primary text-white font-bold py-2 px-4 w-full text-center rounded",
                        onClick: handleCloseModal,
                        children: modalContent === null || modalContent === void 0 ? void 0 : modalContent.ctaText
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var common_InactiveUserModal = ((0,withWindowDimensions/* default */.Z)(InactiveUserModal));

// EXTERNAL MODULE: ./components/common/Layout.tsx + 34 modules
var Layout = __webpack_require__(61562);
// EXTERNAL MODULE: ./components/decorator/redux/AuthActions.ts
var AuthActions = __webpack_require__(86982);
// EXTERNAL MODULE: ./ga.ts
var ga = __webpack_require__(83138);
// EXTERNAL MODULE: ./lib/auth-cookies-new.js
var auth_cookies_new = __webpack_require__(89208);
// EXTERNAL MODULE: ./lib/auth_token.ts
var auth_token = __webpack_require__(72714);
// EXTERNAL MODULE: ./node_modules/next/app.js
var app = __webpack_require__(7544);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/redux-saga/dist/redux-saga-core-npm-proxy.esm.js + 2 modules
var redux_saga_core_npm_proxy_esm = __webpack_require__(11201);
// EXTERNAL MODULE: ./redux/store.ts + 184 modules
var store = __webpack_require__(71640);
// EXTERNAL MODULE: ./utils/cookie-utiils.ts
var cookie_utiils = __webpack_require__(51119);
// EXTERNAL MODULE: ./utils/utm_utils.ts
var utm_utils = __webpack_require__(86147);
// EXTERNAL MODULE: ./pages/404.js
var _404 = __webpack_require__(91635);
// EXTERNAL MODULE: ./winston/winston.config.ts
var winston_config = __webpack_require__(82734);
// EXTERNAL MODULE: ./components/UserDashboard/GetSupport/getSupportSlice.ts
var getSupportSlice = __webpack_require__(76270);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@leapfinance/frontend-commons/tailwind-compiled.css
var tailwind_compiled = __webpack_require__(45565);
// EXTERNAL MODULE: ./public/static/scss/GlobalStyleSheet.scss
var GlobalStyleSheet = __webpack_require__(97282);
// EXTERNAL MODULE: ./public/static/scss/GlobalVendor.css
var GlobalVendor = __webpack_require__(5999);
;// CONCATENATED MODULE: ./pages/_app.tsx

































var GetSupportModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4889), __webpack_require__.e(3619)]).then(__webpack_require__.bind(__webpack_require__, 80252));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80252)
            ];
        }
    }
});
var CANONICAL_DOMAIN = "https://leapscholar.com";
if (true) {
    if ((0,winston_config/* getUserId */.n)(null)) {
        esm_exports/* setUser */.av({
            username: (0,winston_config/* getUserId */.n)(null)
        });
    }
    client_init({
        enabled: "production" === "production",
        dsn: "https://13b2a1dc3a8a43c094398b460821973e@o505542.ingest.sentry.io/5594076",
        sampleRate: 1.0,
        autoSessionTracking: true
    });
}
var savePromocode = function(context, query) {
    var promocode = query && query.promocode;
    if (!!promocode) (0,cookie_utiils/* saveCookie */.YB)(context, "promocode", promocode);
};
var captureAndSaveUtm = function(context, query) {
    var utmSource = query && query.utm_source;
    var utmCampaign = query && query.utm_campaign;
    var utmTerm = query && query.utm_term;
    var utmMedium = query && query.utm_medium;
    var campaignType = query && query.campaign_type;
    var adId = query && query.ad_id;
    var trackingId = query && query.tracking_id;
    var gclid = query && query.gclid;
    var fbclid = query && query.fbclid;
    var adName = query && query.ad_name;
    (0,utm_utils/* saveUtmData */.G)(context, {
        gclid: gclid,
        adName: adName,
        utmSource: utmSource,
        utmCampaign: utmCampaign,
        utmMedium: utmMedium,
        utmTerm: utmTerm,
        adId: adId,
        fbclid: fbclid,
        campaignType: campaignType,
        trackingId: trackingId
    });
};
var ScholarApp = function(param) {
    var Component = param.Component, pageProps = param.pageProps, apollo = param.apollo, err = param.err;
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    pageProps.auth = new auth_token/* AuthToken */.H(pageProps.auth.token);
    var isGetSupportModalOpen = (0,es/* useSelector */.v9)(function(state) {
        return state.getSupportSlice.isGetSupportModalOpen;
    });
    var ref3 = (0,react.useState)(false), showModal = ref3[0], setShowModal = ref3[1];
    var handleCloseModal = function() {
        setShowModal(false);
        sessionStorage.setItem("modalShown", "true");
    };
    (0,react.useEffect)(function() {
        if (router.isReady) {
            var ref;
            if ((ref = pageProps.auth) === null || ref === void 0 ? void 0 : ref.isValid) {
                dispatch(SpotCounsellingActions/* spotCounsellingActions.fetchStage */.F.fetchStage());
                dispatch(SpotCounsellingActions/* spotCounsellingActions.fetchAppNudgeEligibility */.F.fetchAppNudgeEligibility());
            }
            (0,ga.logPageView)(router.asPath);
        }
        var onRouteChangeComplete = function() {
            if ((0,auth_cookies_new/* getTokenCookie */.r_)(null)) {
                dispatch(SpotCounsellingActions/* spotCounsellingActions.fetchStage */.F.fetchStage());
                dispatch(SpotCounsellingActions/* spotCounsellingActions.fetchAppNudgeEligibility */.F.fetchAppNudgeEligibility());
            }
        };
        router.events.on("routeChangeComplete", onRouteChangeComplete);
        return function() {
            router.events.off("routeChangeComplete", onRouteChangeComplete);
        };
    }, []);
    (0,react.useEffect)(function() {
        var ref, ref1;
        var _pathSliceLength = Math.min.apply(Math, [
            router_default().asPath.indexOf("?") > 0 ? router_default().asPath.indexOf("?") : (router_default()).asPath.length,
            router_default().asPath.indexOf("#") > 0 ? router_default().asPath.indexOf("#") : (router_default()).asPath.length, 
        ]);
        var canonicalURL = CANONICAL_DOMAIN + router_default().asPath.substring(0, _pathSliceLength);
        var link = document.createElement("link");
        link.rel = "canonical";
        link.href = canonicalURL;
        document.head.appendChild(link);
        if ([
            "blog",
            "university",
            "universities"
        ].includes(document === null || document === void 0 ? void 0 : (ref = document.referrer) === null || ref === void 0 ? void 0 : ref.split("/")[3])) {
            (0,utm_utils/* saveUtmData */.G)({}, {
                referer: document === null || document === void 0 ? void 0 : document.referrer
            });
        }
        var refererUrl = (0,cookie_utiils/* getCookie */.ej)({}, "refererUrl");
        var decodedCallbackUrl = decodeURIComponent(window.location.href);
        var referrer = decodedCallbackUrl.split("referrer=")[1];
        var referrerInCookie = (0,cookie_utiils/* getCookie */.ej)({}, "referrer_id");
        if (!(refererUrl === null || refererUrl === void 0 ? void 0 : refererUrl.length) && (document === null || document === void 0 ? void 0 : document.referrer)) {
            (0,cookie_utiils/* saveUtmCookie */.AV)({}, "refererUrl", document === null || document === void 0 ? void 0 : document.referrer);
        }
        if ((!referrerInCookie || referrerInCookie === "undefined") && !(pageProps === null || pageProps === void 0 ? void 0 : (ref1 = pageProps.auth) === null || ref1 === void 0 ? void 0 : ref1.token)) {
            var ref2;
            (0,cookie_utiils/* saveUtmCookie */.AV)({}, "referrer_id", referrer || ((router_default()) === null || (router_default()) === void 0 ? void 0 : (ref2 = (router_default()).query) === null || ref2 === void 0 ? void 0 : ref2.referrer));
        }
        var inactivityTimer;
        var time = "30000" || 0;
        var resetTimer = function() {
            clearTimeout(inactivityTimer);
            inactivityTimer = setTimeout(function() {
                if (!sessionStorage.getItem("modalShown")) {
                    setShowModal(true);
                }
            }, parseInt(time));
        };
        var handleClick = function() {
            resetTimer();
            if (window.parent !== window) {
                window.parent.postMessage({
                    eventType: "click"
                }, "*");
            }
            sessionStorage.setItem("modalShown", "true");
        };
        document.addEventListener("click", handleClick);
        resetTimer();
        return function() {
            clearTimeout(inactivityTimer);
            document.removeEventListener("click", handleClick);
        };
    }, []);
    var isDev = "production" === "development";
    if (pageProps === null || pageProps === void 0 ? void 0 : pageProps.error) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(_404["default"], {})
        });
    }
    var userId = (0,cookie_utiils/* getCookie */.ej)(null, "user_id");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isDev && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "leap-tracker-clarity",
                strategy: "afterInteractive",
                dangerouslySetInnerHTML: {
                    __html: '\n    (function(c,l,a,r,i,t,y){\n      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};\n      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;\n      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);\n      console.log("in clarity", '.concat(userId, ')\n      clarity("set", "preUserId", "').concat(userId, '");\n    })(window, document, "clarity", "script", \'').concat("bbvlrvwtbs", "');\n  ")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "leap-tracker-gtm",
                strategy: "afterInteractive",
                dangerouslySetInnerHTML: {
                    __html: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n                    })(window,document,'script','dataLayer','".concat("GTM-T86SG35", "');")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "vwoCode",
                strategy: "afterInteractive",
                dangerouslySetInnerHTML: {
                    __html: "window._vwo_code=window._vwo_code || (function() {\n            var account_id=".concat("612479", ",\n            version = 1.5,\n            settings_tolerance=2000,\n            library_tolerance=2500,\n            use_existing_jquery=false,\n            is_spa=1,\n            hide_element='body',\n            hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important',\n            /* DO NOT EDIT BELOW THIS LINE */\n            f=false,w=window,d=document,vwoCodeEl=d.querySelector('#vwoCode'),code={use_existing_jquery:function(){return use_existing_jquery},library_tolerance:function(){return library_tolerance},hide_element_style:function(){return'{'+hide_element_style+'}'},finish:function(){if(!f){f=true;var e=d.getElementById('_vis_opt_path_hides');if(e)e.parentNode.removeChild(e)}},finished:function(){return f},load:function(e){var t=d.createElement('script');t.fetchPriority='high';t.src=e;t.type='text/javascript';t.onerror=function(){_vwo_code.finish()};d.getElementsByTagName('head')[0].appendChild(t)},getVersion:function(){return version},getMatchedCookies:function(e){var t=[];if(document.cookie){t=document.cookie.match(e)||[]}return t},getCombinationCookie:function(){var e=code.getMatchedCookies(/(?:^|;)s?(_vis_opt_exp_d+_combi=[^;$]*)/gi);e=e.map(function(e){try{var t=decodeURIComponent(e);if(!/_vis_opt_exp_d+_combi=(?:d+,?)+s*$/.test(t)){return''}return t}catch(e){return''}});var i=[];e.forEach(function(e){var t=e.match(/([d,]+)/g);t&&i.push(t.join('-'))});return i.join('|')},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;w.settings_timer=setTimeout(function(){_vwo_code.finish()},settings_tolerance);var e=d.currentScript,t=d.createElement('style'),i=e&&!e.async?hide_element?hide_element+'{'+hide_element_style+'}':'':code.lA=1,n=d.getElementsByTagName('head')[0];t.setAttribute('id','_vis_opt_path_hides');vwoCodeEl&&t.setAttribute('nonce',vwoCodeEl.nonce);t.setAttribute('type','text/css');if(t.styleSheet)t.styleSheet.cssText=i;else t.appendChild(d.createTextNode(i));n.appendChild(t);var o=this.getCombinationCookie();this.load('https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&f='+ +is_spa+'&vn='+version+(o?'&c='+o:''));return settings_timer}};w._vwo_settings_timer = code.init();return code;}());")
                },
                async: true
            }),
            isGetSupportModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(GetSupportModal, {
                isModalOpen: isGetSupportModalOpen,
                handleClose: function() {
                    return dispatch((0,getSupportSlice/* setIsGetSupportModalOpen */.j)(false));
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_GoogleAnalytics, {
                userId: pageProps === null || pageProps === void 0 ? void 0 : (ref = pageProps.auth) === null || ref === void 0 ? void 0 : (ref1 = ref.decodedToken) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.user_id) === null || ref2 === void 0 ? void 0 : ref2.user_id
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ApolloProvider, {
                client: apollo,
                children: [
                    showModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(common_InactiveUserModal, {
                        handleCloseModal: handleCloseModal
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageProps), {
                        err: err
                    }))
                ]
            })
        ]
    });
};
ScholarApp.getInitialProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(appContext) {
        var ref, ref1, appProps, token, auth;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    captureAndSaveUtm(appContext.ctx, appContext.ctx.query);
                    savePromocode(appContext.ctx, appContext.ctx.query);
                    _ctx.next = 5;
                    return app["default"].getInitialProps(appContext);
                case 5:
                    appProps = _ctx.sent;
                    if (((ref = appProps.pageProps) === null || ref === void 0 ? void 0 : (ref1 = ref.error) === null || ref1 === void 0 ? void 0 : ref1.statusCode) && appContext.ctx.res) {
                        appContext.ctx.res.statusCode = appProps.pageProps.error.statusCode;
                    }
                    if (!(appContext.ctx.req && appContext.Component.getInitialProps)) {
                        _ctx.next = 11;
                        break;
                    }
                    appContext.ctx.store.dispatch(redux_saga_core_npm_proxy_esm/* END */.uR);
                    _ctx.next = 11;
                    return appContext.ctx.store.sagaTask.toPromise();
                case 11:
                    token = (0,auth_cookies_new/* getTokenCookie */.r_)(appContext.ctx);
                    auth = new auth_token/* AuthToken */.H(token);
                    appContext.ctx.store.dispatch(AuthActions/* authActions.saveAuth */.Y.saveAuth(auth === null || auth === void 0 ? void 0 : auth.token));
                    appProps.pageProps.auth = auth;
                    return _ctx.abrupt("return", (0,_object_spread/* default */.Z)({
                        query: appContext.ctx.query
                    }, appProps));
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(appContext) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var _app = (store/* wrapper.withRedux */.YS.withRedux((0,apollo/* default */.ZP)(ScholarApp)));


/***/ }),

/***/ 12718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ initRazorpayScript; }
/* harmony export */ });
function initRazorpayScript() {
    var razorpayScript = document.getElementById("_razorpay_script_tag");
    if (razorpayScript) return;
    var script = document.createElement("script");
    script.id = "_razorpay_script_tag";
    script.type = "text/javascript";
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    var head = document.head;
    head.insertBefore(script, head.firstElementChild);
}


/***/ }),

/***/ 71640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ store; },
  "YS": function() { return /* binding */ wrapper; }
});

// UNUSED EXPORTS: makeStore

// EXTERNAL MODULE: ./node_modules/next-redux-wrapper/es6/index.js
var es6 = __webpack_require__(28858);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js + 1 modules
var redux = __webpack_require__(45217);
// EXTERNAL MODULE: ./node_modules/redux-devtools-extension/index.js
var redux_devtools_extension = __webpack_require__(28500);
// EXTERNAL MODULE: ./node_modules/redux-saga/dist/redux-saga-core-npm-proxy.esm.js + 2 modules
var redux_saga_core_npm_proxy_esm = __webpack_require__(11201);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
;// CONCATENATED MODULE: ./utils/ielts_batch_sort_utils.ts



var calcPercentage = function(value, total) {
    return value / total * 100;
};
var sortBatches = function(batches) {
    var batchList = cloneDeep_default()(batches);
    batchList.sort(function(a, b) {
        return a.meetingStartTime > b.meetingStartTime ? 1 : -1;
    });
    var fullBatches = batchList.filter(function(batch) {
        var numberOfSeats = batch.numberOfSeats, seatBooked = batch.seatBooked;
        var seatsRemaining = numberOfSeats - seatBooked;
        return seatsRemaining <= 0;
    });
    var fastFillingBatches = batchList.filter(function(batch) {
        var numberOfSeats = batch.numberOfSeats, seatBooked = batch.seatBooked;
        var seatsRemaining = numberOfSeats - seatBooked;
        var percentageSeatRemaining = calcPercentage(seatsRemaining, numberOfSeats);
        return percentageSeatRemaining <= 50 && percentageSeatRemaining > 0;
    });
    var normalBatches = batchList.filter(function(batch) {
        var numberOfSeats = batch.numberOfSeats, seatBooked = batch.seatBooked;
        var allSeatsBooked = numberOfSeats - seatBooked <= 0;
        var fastFillingBatch = calcPercentage(numberOfSeats - seatBooked, numberOfSeats) <= 50 && calcPercentage(numberOfSeats - seatBooked, numberOfSeats) > 0;
        return !allSeatsBooked && !fastFillingBatch;
    });
    var newBatchList = (0,_to_consumable_array/* default */.Z)(orderBy_default()(fastFillingBatches, [
        "startTime"
    ], "asc")).concat((0,_to_consumable_array/* default */.Z)(orderBy_default()(normalBatches, [
        "startTime"
    ], "asc")), (0,_to_consumable_array/* default */.Z)(orderBy_default()(fullBatches, [
        "startTime"
    ], "asc")));
    return newBatchList;
};
var filterUpcomingBatchesFromEnrolledBatches = function(enrollIeltsBatches, upcomingIeltsBatchesData) {
    return upcomingIeltsBatchesData.filter(function(value) {
        return !enrollIeltsBatches.find(function(batch) {
            return batch.batchId == value.batchId;
        });
    });
};

// EXTERNAL MODULE: ./components/Profile/IeltsProfile/IeltsPlus/redux/IeltsPlusActions.ts
var IeltsPlusActions = __webpack_require__(41356);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/IeltsPlus/redux/IeltsPlusReducer.ts





var initialState = {
    ieltsData: null,
    loading: true,
    showHasJoinedModal: false,
    showConfirmModal: false,
    errorMessage: "",
    modalText: {
        batchId: 1,
        calendarText: "",
        clockText: ""
    },
    batchId: "",
    objects: {
        vidoes: 0,
        materials: 0,
        lastUpdatedVideo: 0,
        lastUpdatedMaterial: 0
    },
    showRegisterModal: false,
    enrolledBatches: [],
    activeBatchId: null,
    completedClasses: [],
    upcomingClasses: [],
    loadingEnrolledClasses: true,
    isEnrolled: null,
    isEnrolledForFoundation: null,
    isEnrolledForPlus: null,
    isEnrolledForPremium: null,
    isEnrolledForBatches: {
        isEnrolledForPlus: null,
        isEnrolledForPremium: null,
        isEnrolledForElite: null,
        isEnrolledForSelect: null
    },
    rewardList: null,
    isRewardModalOpen: false,
    getClickedRewardDay: "",
    allIeltsBatches: []
};
var reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    var changeAddToCalendarStatus = function(batchId) {
        var activeBatchIndex = state.upcomingClasses.findIndex(function(batch) {
            return batch.batchId === batchId;
        });
        var newEnrolledBatches = cloneDeep_default()(state.upcomingClasses);
        newEnrolledBatches[activeBatchIndex].addedToCalendar = true;
        return newEnrolledBatches;
    };
    switch(action.type){
        case "IElTS_FETCH_SUCCEEDED":
            var newBatchList = sortBatches(action.payload.workshop);
            var newPayload = cloneDeep_default()(action.payload);
            newPayload.workshop = newBatchList;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                ieltsData: newPayload,
                loading: false,
                batchId: newPayload.isEnrolled && newPayload.workshop[0].batchId
            });
        case "IELTS_FETCH_FAILED":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                errorMessage: action.message
            });
        case "ENROLL_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showHasJoinedModal: action.payload
            });
        case "TOGGLE_JOIN_MODAL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showHasJoinedModal: action.payload
            });
        case "ENROLL_FAILED":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                errorMessage: action.message
            });
        case "UPDATE_MODAL_TEXT":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                modalText: action.payload
            });
        case "TOGGLE_CONFIRM_MODAL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showConfirmModal: action.payload
            });
        case "FETCH_OBJECTS_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                objects: action.payload
            });
        case "FETCH_OBJECTS_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        case "TOGGLE_REGISTER_MODAL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showRegisterModal: action.payload
            });
        case "FETCH_ENROLLED_BATCHES_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                enrolledBatches: action.payload
            });
        case "UPDATE_ACTIVE_BATCH_ID":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                activeBatchId: action.payload
            });
        case "UPDATE_ADD_TO_CALENDAR_STATUS":
            var newEnrolledBatches = changeAddToCalendarStatus(action.payload);
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                upcomingClasses: newEnrolledBatches
            });
        case "ADD_COMPLETED_IELTS_CLASSES":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                completedClasses: action.payload
            });
        case "ADD_UPCOMING_IELTS_CLASSES":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                upcomingClasses: action.payload
            });
        case "TOGGLE_LOADING_ENROLLED_CLASSES":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loadingEnrolledClasses: false
            });
        case "CHECK_IETLS_ENROLLMENT":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isEnrolled: action.payload
            });
        case "CHECK_FOUNDATION_ENROLLMENT":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isEnrolledForFoundation: action.payload
            });
        case "CHECK_PLUS_ENROLLMENT":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isEnrolledForPlus: action.payload
            });
        case "CHECK_PREMIUM_ENROLLMENT":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isEnrolledForPremium: action.payload
            });
        case IeltsPlusActions/* IeltsPlusActionsTypes.CHECK_IELTS_BATCHES_ENROLLMENT */.Q.CHECK_IELTS_BATCHES_ENROLLMENT:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isEnrolledForBatches: action.payload
            });
        case "FETCH_REWARD_LIST_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                rewardList: action.payload
            });
        case "TOGGLE_REWARD_MODAL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isRewardModalOpen: action.payload
            });
        case "GET_CLICKED_REWARD_DAY":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                getClickedRewardDay: action.payload
            });
        case "ADD_ALL_IELTS_CLASSES":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                allIeltsBatches: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var IeltsPlusReducer = (reducer);

;// CONCATENATED MODULE: ./components/Profile/CounsellingProfile/FinancialCounselling/redux/FinancialCounsellingReducer.ts


var FinancialCounsellingReducer_initialState = {
    financialCounsellingData: null,
    financialCounsellingPageData: null,
    canAttend: false,
    isJoined: false,
    error: "",
    loading: true
};
var FinancialCounsellingReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : FinancialCounsellingReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "FINANCIAL_COUNSELLING_FETCH_SUCCEEDED":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                financialCounsellingData: action.payload,
                loading: false
            });
        case "FINANCIAL_COUNSELLING_FETCH_FAILED":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.message
            });
        case "UPDATE_JOIN_STATUS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isJoined: action.payload
            });
        case "UPDATE_CAN_ATTEND_STATUS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                canAttend: action.payload
            });
        // new api
        case "FINANCIAL_COUNSELLING_PAGE_FETCH_REQUESTED":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: true
            });
        case "FINANCIAL_COUNSELLING_PAGE_FETCH_SUCCEEDED":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                financialCounsellingPageData: action.payload,
                loading: false
            });
        case "FINANCIAL_COUNSELLING_PAGE_FETCH_FAILED":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                error: action.message
            });
        default:
            return state;
    }
};
/* harmony default export */ var FinancialCounsellingReducer = (FinancialCounsellingReducer_reducer);

// EXTERNAL MODULE: ./components/Profile/CounsellingFormExperiment/redux/CounsellingFormActions.tsx
var CounsellingFormActions = __webpack_require__(92485);
;// CONCATENATED MODULE: ./components/Profile/CounsellingFormExperiment/redux/CounsellingFormReducer.ts



var CounsellingFormReducer_initialState = {
    profileData: {},
    loading: true,
    error: "",
    eligibility: {},
    saving: false,
    ieltsNudgeData: {},
    ieltsNudgeError: null,
    postFetchEligibilityAction: null
};
// create your reducer
var CounsellingFormReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : CounsellingFormReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "PROFILE_FETCH_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                profileData: action.payload,
                loading: false
            });
        case "PROFILE_FETCH_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                error: action.payload
            });
        case "SAVE_PROFILE_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                profileData: action.payload
            });
        case "SAVE_PROFILE_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        case "ELIGIBILITY_FETCH_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                eligibility: action.payload,
                saving: false
            });
        case "ELIGIBILITY_FETCH_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                saving: false
            });
        case "UPDATE_SAVE_CTA_STATUS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: action.payload
            });
        case "FETCH_IELTS_NUDGE_DATA_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                ieltsNudgeData: action.payload,
                loading: false,
                ieltsNudgeError: null,
                saving: false
            });
        case "FETCH_IELTS_NUDGE_DATA_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                ieltsNudgeError: action.payload,
                saving: false
            });
        case "SAVE_IELTS_NUDGE_DATA_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                // ieltsNudgeData: action.payload,
                ieltsNudgeError: null
            });
        case "SAVE_IELTS_NUDGE_DATA_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                ieltsNudgeError: action.payload
            });
        case CounsellingFormActions/* counsellingFormActionsTypes.UPDATE_POST_FETCH_ELIGIBILITY_ACTION */.G.UPDATE_POST_FETCH_ELIGIBILITY_ACTION:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                postFetchEligibilityAction: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var CounsellingFormReducer = (CounsellingFormReducer_reducer);

// EXTERNAL MODULE: ./components/Profile/IeltsProfile/SpeakingClub/redux/SpeakingClubActions.ts
var SpeakingClubActions = __webpack_require__(49410);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/SpeakingClub/redux/SpeakingClubReducer.ts



var SpeakingClubReducer_initialState = {
    SpeakingClubSlotAvailableDate: [],
    bookingDate: "",
    error: "",
    loading: false,
    showHasJoinedSpeakingClubModal: false,
    upcomingSpeakingClass: null,
    modalText: "",
    credits: {
        totalCredits: 0,
        creditsLeft: 0
    },
    speakingClubPriceBundle: null,
    showRescheduleModal: false,
    showCancelldModal: false,
    isRescheduling: false,
    showFlse: false
};
var TOOGLE_SPEAKING_CLUB_RESCHEDULE_MODAL = SpeakingClubActions/* speakingClubType.TOOGLE_SPEAKING_CLUB_RESCHEDULE_MODAL */.s.TOOGLE_SPEAKING_CLUB_RESCHEDULE_MODAL, TOGGLE_SPEAKING_CLUB_CANCELLED_MODAL = SpeakingClubActions/* speakingClubType.TOGGLE_SPEAKING_CLUB_CANCELLED_MODAL */.s.TOGGLE_SPEAKING_CLUB_CANCELLED_MODAL, TOGGLE_SPEAKING_CLUB_IS_RESCHEDULING = SpeakingClubActions/* speakingClubType.TOGGLE_SPEAKING_CLUB_IS_RESCHEDULING */.s.TOGGLE_SPEAKING_CLUB_IS_RESCHEDULING, UPDATE_SPEAKING_CLUB_ERROR = SpeakingClubActions/* speakingClubType.UPDATE_SPEAKING_CLUB_ERROR */.s.UPDATE_SPEAKING_CLUB_ERROR;
var SpeakingClubReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : SpeakingClubReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case SpeakingClubActions/* speakingClubType.SPEAKING_CLUB_SLOT_SUCCESS */.s.SPEAKING_CLUB_SLOT_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                SpeakingClubSlotAvailableDate: action.payload,
                loading: false
            });
        case SpeakingClubActions/* speakingClubType.SPEAKING_CLUB_SLOT_FETCH_FAIL */.s.SPEAKING_CLUB_SLOT_FETCH_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                loading: false
            });
        case SpeakingClubActions/* speakingClubType.SPEAKING_WORKSHOP_POST_REQUESTED */.s.SPEAKING_WORKSHOP_POST_REQUESTED:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: true
            });
        case SpeakingClubActions/* speakingClubType.SPEAKING_WORKSHOP_POST_SUCCESS */.s.SPEAKING_WORKSHOP_POST_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showHasJoinedSpeakingClubModal: action.payload,
                loading: false
            });
        case SpeakingClubActions/* speakingClubType.SPEAKING_WORKSHOP_POST_FAIL */.s.SPEAKING_WORKSHOP_POST_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                loading: false
            });
        case SpeakingClubActions/* speakingClubType.UPCOMING_SPEAKING_CLUB_SUCCESS */.s.UPCOMING_SPEAKING_CLUB_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                upcomingSpeakingClass: action.payload
            });
        case SpeakingClubActions/* speakingClubType.UPCOMING_SPEAKING_CLUB_FAIL */.s.UPCOMING_SPEAKING_CLUB_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                loading: false
            });
        case SpeakingClubActions/* speakingClubType.CLOSE_MODAL */.s.CLOSE_MODAL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showHasJoinedSpeakingClubModal: false
            });
        case SpeakingClubActions/* speakingClubType.SET_MODAL_TEXT */.s.SET_MODAL_TEXT:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                modalText: action.payload
            });
        case SpeakingClubActions/* speakingClubType.FETCH_SPEAKING_CLUB_CREDITS_SUCCESS */.s.FETCH_SPEAKING_CLUB_CREDITS_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                credits: action.payload
            });
        case SpeakingClubActions/* speakingClubType.FETCH_SPEAKING_CLUB_CREDITS_FAIL */.s.FETCH_SPEAKING_CLUB_CREDITS_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        case SpeakingClubActions/* speakingClubType.FETCH_SPEAKING_BUNDLE_PRICE_SUCCESS */.s.FETCH_SPEAKING_BUNDLE_PRICE_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                speakingClubPriceBundle: action.payload
            });
        case SpeakingClubActions/* speakingClubType.FETCH_SPEAKING_BUNDLE_PRICE_FAIL */.s.FETCH_SPEAKING_BUNDLE_PRICE_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        case TOOGLE_SPEAKING_CLUB_RESCHEDULE_MODAL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showRescheduleModal: action.payload
            });
        case TOGGLE_SPEAKING_CLUB_CANCELLED_MODAL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showCancelldModal: action.payload
            });
        case TOGGLE_SPEAKING_CLUB_IS_RESCHEDULING:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isRescheduling: action.payload
            });
        case UPDATE_SPEAKING_CLUB_ERROR:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        case SpeakingClubActions/* speakingClubType.SET_FLSE_VISIBILITY_ACTION */.s.SET_FLSE_VISIBILITY_ACTION:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showFlse: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var SpeakingClubReducer = (SpeakingClubReducer_reducer);

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/ClassRecordings/redux/ClassRecordingsReducer.ts


var ClassRecordingsReducer_initialState = {
    recordingData: null,
    error: "",
    isRecordingsLoading: true
};
var ClassRecordingsReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ClassRecordingsReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "RECORDINGS_FETCH_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                recordingData: action.payload
            });
        case "RECORDINGS_FETCH_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        case "UPDATE_RECORDINGS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                recordingData: action.payload
            });
        case "VIDEO_FETCH_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                recordingData: action.payload
            });
        case "VIDEO_FETCH_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        case "SET_RECORDINGS_LOADING":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isRecordingsLoading: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var ClassRecordingsReducer = (ClassRecordingsReducer_reducer);

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/NoticeBoard/redux/NoticeBoardReducer.ts


var NoticeBoardReducer_initialState = {
    allNotices: null,
    error: ""
};
// create your reducer
var NoticeBoardReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : NoticeBoardReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "ALL_NOTICE_FETCH_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                allNotices: action.payload
            });
        case "ALL_NOTICE_FETCH_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var NoticeBoardReducer = (NoticeBoardReducer_reducer);

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/StudyMaterial/redux/StudyMaterialReducer.ts


var StudyMaterialReducer_initialState = {
    studyMaterialData: null,
    error: ""
};
// create your reducer
var StudyMaterialReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : StudyMaterialReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "STUDY_MATERIAL_FETCH_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                studyMaterialData: action.payload
            });
        case "STUDY_MATERIAL_FETCH_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var StudyMaterialReducer = (StudyMaterialReducer_reducer);

// EXTERNAL MODULE: ./components/Profile/IeltsProfile/MyClasses/redux/MyClassActions.ts
var MyClassActions = __webpack_require__(92272);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/MyClasses/redux/MyClassReducer.ts



var MyClassReducer_initialState = {
    ieltsData: null,
    masterClassData: [],
    loading: true,
    showHasJoinedModal: false,
    showHasJoinedMasterClassModal: false,
    showConfirmModal: false,
    errorMessage: "",
    modalText: {
        batchId: 1,
        calendarText: "",
        clockText: ""
    },
    upcomingClass: {},
    masterclassSubscriptionStatus: null,
    fetchingMasterclassSubscriptionStatus: true
};
// create your reducer
var MyClassReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : MyClassReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case MyClassActions/* myClassActionType.ENROLL_TO_IELTS_PLUS_SUCCESS */.j.ENROLL_TO_IELTS_PLUS_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showHasJoinedModal: action.payload
            });
        case MyClassActions/* myClassActionType.ENROLL_TO_IELTS_PLUS_FAILED */.j.ENROLL_TO_IELTS_PLUS_FAILED:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                errorMessage: action.message
            });
        case MyClassActions/* myClassActionType.UPDATE_MODAL_TEXT */.j.UPDATE_MODAL_TEXT:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                modalText: action.payload
            });
        case MyClassActions/* myClassActionType.TOGGLE_CONFIRM_MODAL */.j.TOGGLE_CONFIRM_MODAL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showConfirmModal: action.payload
            });
        case MyClassActions/* myClassActionType.MASTER_FETCH_SUCCESS */.j.MASTER_FETCH_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                masterClassData: action.payload
            });
        case MyClassActions/* myClassActionType.MASTER_FETCH_FAIL */.j.MASTER_FETCH_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                errorMessage: action.message
            });
        case MyClassActions/* myClassActionType.SET_IELTS_MODAL */.j.SET_IELTS_MODAL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showHasJoinedModal: action.payload
            });
        case MyClassActions/* myClassActionType.SET_MASTER_CLASS_MODAL */.j.SET_MASTER_CLASS_MODAL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showHasJoinedMasterClassModal: action.payload
            });
        case MyClassActions/* myClassActionType.ENROLL_TO_MASTER_CLASS_SUCCESS */.j.ENROLL_TO_MASTER_CLASS_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showHasJoinedMasterClassModal: action.payload
            });
        case "FETCH_MASTERCLASS_SUBSCRIPTION_STATUS_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                masterclassSubscriptionStatus: action.payload,
                fetchingMasterclassSubscriptionStatus: false
            });
        case "FETCH_MASTERCLASS_SUBSCRIPTION_STATUS_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                fetchingMasterclassSubscriptionStatus: false
            });
        default:
            return state;
    }
};
/* harmony default export */ var MyClassReducer = (MyClassReducer_reducer);

// EXTERNAL MODULE: ./components/Profile/IeltsProfile/UpcomingClass/redux/UpcomingClassActions.ts
var UpcomingClassActions = __webpack_require__(51055);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/UpcomingClass/redux/upcomingReducer.ts



var upcomingReducer_initialState = {
    loading: true,
    errorMessage: "",
    upcomingClass: null,
    liveClass: [],
    upcomingExtraClass: [],
    liveIeltClasses: [],
    liveMasterclasses: [],
    voiceRoom: [],
    isLiveLoading: false,
    orientationClass: [],
    enrollOrientationClass: []
};
// create your reducer
var upcomingReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : upcomingReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case UpcomingClassActions/* upcomingType.UPCOMING_CLASS_FETCH_SUCCESS */.r.UPCOMING_CLASS_FETCH_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                upcomingClass: action.payload,
                loading: false
            });
        case UpcomingClassActions/* upcomingType.UPCOMING_CLASS_FETCH_FAIL */.r.UPCOMING_CLASS_FETCH_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                errorMessage: action.message,
                loading: false
            });
        case UpcomingClassActions/* upcomingType.LIVE_CLASS_FETCH_SUCCESS */.r.LIVE_CLASS_FETCH_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                liveClass: action.payload
            });
        case UpcomingClassActions/* upcomingType.UPCOMING_EXTRA_CLASS_FETCH_SUCCESS */.r.UPCOMING_EXTRA_CLASS_FETCH_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                upcomingExtraClass: action.payload
            });
        case UpcomingClassActions/* upcomingType.SET_LIVE_IELTS */.r.SET_LIVE_IELTS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                liveIeltClasses: action.payload
            });
        case UpcomingClassActions/* upcomingType.SET_LIVE_MASTERCLASS */.r.SET_LIVE_MASTERCLASS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                liveMasterclasses: action.payload
            });
        case UpcomingClassActions/* upcomingType.FETCH_VOICE_ROOM_SUCCESS */.r.FETCH_VOICE_ROOM_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                voiceRoom: action.payload
            });
        case UpcomingClassActions/* upcomingType.SET_IS_LOADING */.r.SET_IS_LOADING:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLiveLoading: action.payload
            });
        case UpcomingClassActions/* upcomingType.SET_ORIENTATION_CLASS */.r.SET_ORIENTATION_CLASS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                orientationClass: action.payload
            });
        case UpcomingClassActions/* upcomingType.SET_ORIENTATION_ENROLMENT */.r.SET_ORIENTATION_ENROLMENT:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                enrollOrientationClass: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var upcomingReducer = (upcomingReducer_reducer);

;// CONCATENATED MODULE: ./components/Profile/ReferAndEarn/redux/ReferAndEarnReducer.ts


var ReferAndEarnReducer_initialState = {
    userInfo: {
        email: "",
        firstname: "",
        lastname: "",
        phone: "",
        name: ""
    },
    referralData: [],
    error: ""
};
// create your reducer
var ReferAndEarnReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ReferAndEarnReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "USER_DETAILS_FETCH_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                userInfo: action.payload
            });
        case "USER_DETAILS_FETCH_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        case "USER_REFERRALS_FETCH_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                referralData: action.payload
            });
        case "USER_REFERRALS_FETCH_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        case "POST_REFERRAL_CODE_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        case "REGISTER_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var ReferAndEarnReducer = (ReferAndEarnReducer_reducer);

;// CONCATENATED MODULE: ./components/Profile/CounsellingProfile/redux/CounsellingReducer.ts


var CounsellingReducer_initialState = {
    error: "",
    postPaymentData: null,
    isLoading: true,
    scholarshipBookmarkData: []
};
var CounsellingReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : CounsellingReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "COUNSELLING_STAGE_FETCH_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                counsellingStage: action.payload,
                isLoading: false
            });
        case "COUNSELLING_STAGE_FETCH_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                isLoading: false
            });
        case "POST_PAYMENT_DATA_FETCH_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                postPaymentData: action.payload
            });
        case "POST_PAYMENT_DATA_FETCH_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        case "FETCH_BOOKMARK_DATA_FETCH_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                scholarshipBookmarkData: action.payload,
                isLoading: false
            });
        case "FETCH_BOOMARK_FETCH_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                isLoading: false
            });
        default:
            return state;
    }
};
/* harmony default export */ var CounsellingReducer = (CounsellingReducer_reducer);

// EXTERNAL MODULE: ./components/Profile/IeltsProfile/EssayEvaluation/redux/EssayActions.ts
var EssayActions = __webpack_require__(86075);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/EssayEvaluation/redux/EssayReducer.ts



var EssayReducer_initialState = {
    essayData: null,
    loading: true,
    uploadSuccess: false,
    errorMessage: ""
};
var EssayReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : EssayReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case EssayActions/* essayType.ESSAY_FETCH_REQ */.N.ESSAY_FETCH_REQ:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: true
            });
        case EssayActions/* essayType.ESSAY_FETCH_SUCCESS */.N.ESSAY_FETCH_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                essayData: action.payload
            });
        case EssayActions/* essayType.ESSAY_FETCH_FAIL */.N.ESSAY_FETCH_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                errorMessage: action.payload
            });
        case EssayActions/* essayType.UPLOAD_ESSAY_REQ */.N.UPLOAD_ESSAY_REQ:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: true
            });
        case EssayActions/* essayType.UPLOAD_ESSAY_SUCCESS */.N.UPLOAD_ESSAY_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                essayData: action.payload
            });
        case EssayActions/* essayType.UPLOAD_ESSAY_FAIL */.N.UPLOAD_ESSAY_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                errorMessage: action.payload
            });
        case EssayActions/* essayType.REPLACE_ESSAY_REQ */.N.REPLACE_ESSAY_REQ:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: true
            });
        case EssayActions/* essayType.REPLACE_ESSAY_SUCCESS */.N.REPLACE_ESSAY_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                essayData: action.payload
            });
        case EssayActions/* essayType.REPLACE_ESSAY_FAIL */.N.REPLACE_ESSAY_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                errorMessage: action.payload
            });
        case EssayActions/* essayType.CLEAR_ERROR_MSG */.N.CLEAR_ERROR_MSG:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                errorMessage: ""
            });
        default:
            return state;
    }
};
/* harmony default export */ var EssayReducer = (EssayReducer_reducer);

;// CONCATENATED MODULE: ./components/Ielts/Faculty/redux/FacultyReducer.ts




var FacultyReducer_initialState = {
    facultyData: [],
    error: ""
};
var FacultyReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : FacultyReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case es6/* HYDRATE */.ju:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                facultyData: action.payload.ieltsFaculty.facultyData
            });
        case "FETCH_FACULTIES_SUCCESS":
            var visibleOnHomePage = action.payload.filter(function(data) {
                return data.visibleOnHomePage;
            });
            var dataInreqFormat = visibleOnHomePage.reduce(function(a, c) {
                var newObj = cloneDeep_default()(c);
                newObj.headerText = "".concat(newObj.yearsOfExperience, "+ years of experience");
                newObj.bodyText = newObj.description;
                newObj.footerText = newObj.shortDescription;
                newObj.image = newObj.mobileImage;
                a.push(newObj);
                return a;
            }, []);
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                facultyData: dataInreqFormat
            });
        case "FETCH_FACULTIES_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var FacultyReducer = (FacultyReducer_reducer);

// EXTERNAL MODULE: ./components/Ielts/BatchDetails/redux/BatchDetailsAction.ts
var BatchDetailsAction = __webpack_require__(65489);
;// CONCATENATED MODULE: ./components/Ielts/BatchDetails/redux/BatchDetailsReducer.ts




var BatchDetailsReducer_initialState = {
    batchData: {},
    teacherData: {},
    error: "",
    showLoader: false,
    showForm: false,
    showPromo: false,
    triedToBuyBeforeLogin: null,
    showNotAbleToBuyModal: false,
    showDisqaulifiedUsersModal: false,
    failToFetchBatchData: false
};
var BatchDetailsReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : BatchDetailsReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case es6/* HYDRATE */.ju:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                batchData: action.payload.batchDetails.batchData,
                teacherData: action.payload.batchDetails.teacherData,
                error: action.payload.batchDetails.error
            });
        case "FETCH_BATCH_DETAILS_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                batchData: action.payload
            });
        case "FETCH_BATCH_DETAILS_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        case "FETCH_BATCH_TEACHER_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                teacherData: action.payload
            });
        case "FETCH_BATCH_TEACHER_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        case "TOGGLE_IELTS_PLUS_LOADER":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showLoader: action.payload
            });
        case "TOGGLE_IELTS_PLUS_FORM":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showForm: action.payload
            });
        case "TOGGLE_PROMO_CODE":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showPromo: action.payload
            });
        case "TOGGLE_TRIED_TO_BUY_BEFORE_LOGIN":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                triedToBuyBeforeLogin: action.payload
            });
        case BatchDetailsAction/* batchDetailActionTypes.TOGGLE_SHOW_NOT_ABLE_TO_BUY_MODAL */.W.TOGGLE_SHOW_NOT_ABLE_TO_BUY_MODAL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showNotAbleToBuyModal: action.payload
            });
        case BatchDetailsAction/* batchDetailActionTypes.TOOGLE_SHOW_DISQAULIFIED_USERS_MODAL */.W.TOOGLE_SHOW_DISQAULIFIED_USERS_MODAL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showDisqaulifiedUsersModal: action.payload
            });
        case BatchDetailsAction/* batchDetailActionTypes.TOGGLE_FAIL_TO_FETCH_BATCH */.W.TOGGLE_FAIL_TO_FETCH_BATCH:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                failToFetchBatchData: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var BatchDetailsReducer = (BatchDetailsReducer_reducer);

// EXTERNAL MODULE: ./components/Ielts/UpcomingIeltsBatches/redux/UpcomingIeltsActions.ts
var UpcomingIeltsActions = __webpack_require__(4726);
// EXTERNAL MODULE: ./utils/ielts_batch_utils.ts
var ielts_batch_utils = __webpack_require__(5438);
;// CONCATENATED MODULE: ./components/Ielts/UpcomingIeltsBatches/redux/UpcomingIeltsReducer.ts






var UpcomingIeltsReducer_initialState = {
    upcomingIeltsBatchesData: [],
    foundationBatch: [],
    premiumBatchData: [],
    plusBatchData: [],
    ieltsSelectBatches: [],
    ieltsEliteBatches: [],
    loading: false,
    errorMessage: "",
    nudgeOffer: {},
    isUpcomingIeltsBatchModalOpen: false,
    nextBatchPriceAndTiming: null,
    allIeltsBatches: null,
    batchesBannerData: null,
    isOfferModalOpen: false
};
var UpcomingIeltsReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : UpcomingIeltsReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case es6/* HYDRATE */.ju:
            var upcomingIeltsBatchesData = action.payload.upcomingIeltsBatches.upcomingIeltsBatchesData;
            var filteredPremiumBatchData = upcomingIeltsBatchesData.filter(function(data) {
                return (0,ielts_batch_utils/* isPremiumBatch */.xX)(data);
            });
            var ieltsSelectBatches = upcomingIeltsBatchesData;
            var ieltsEliteBatches = upcomingIeltsBatchesData;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                upcomingIeltsBatchesData: action.payload.upcomingIeltsBatches.upcomingIeltsBatchesData,
                nudgeOffer: action.payload.upcomingIeltsBatches.nudgeOffer,
                premiumBatchData: filteredPremiumBatchData,
                ieltsSelectBatches: ieltsSelectBatches,
                ieltsEliteBatches: ieltsEliteBatches
            });
        case UpcomingIeltsActions/* UpcomingType.UPCOMING_IELTS_FETCH_REQUESTED */.h.UPCOMING_IELTS_FETCH_REQUESTED:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: true
            });
        case UpcomingIeltsActions/* UpcomingType.UPCOMING_IELTS_FETCH_SUCCESS */.h.UPCOMING_IELTS_FETCH_SUCCESS:
            var newBatchList = sortBatches(action.payload);
            var premiumBatchData = newBatchList.filter(function(item) {
                return (0,ielts_batch_utils/* isPremiumBatch */.xX)(item);
            });
            var selectBatch = newBatchList;
            var eliteBatch = newBatchList;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                upcomingIeltsBatchesData: newBatchList,
                premiumBatchData: premiumBatchData,
                ieltsSelectBatches: selectBatch,
                ieltsEliteBatches: eliteBatch
            });
        case UpcomingIeltsActions/* UpcomingType.IELTS_FOUNDATION_BATCH_FETCH_REQUESTED */.h.IELTS_FOUNDATION_BATCH_FETCH_REQUESTED:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: true
            });
        case UpcomingIeltsActions/* UpcomingType.IELTS_FOUNDATION_BATCH_FETCH_SUCCESS */.h.IELTS_FOUNDATION_BATCH_FETCH_SUCCESS:
            var newFoundationBatchList = sortBatches(action.payload);
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                foundationBatch: newFoundationBatchList
            });
        case UpcomingIeltsActions/* UpcomingType.IELTS_PREMIUM_BATCH_FETCH_SUCCESS */.h.IELTS_PREMIUM_BATCH_FETCH_SUCCESS:
            var newPremiumBatchList = sortBatches(action.payload);
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                premiumBatchData: newPremiumBatchList
            });
        case UpcomingIeltsActions/* UpcomingType.IELTS_PLUS_BATCH_FETCH_SUCCESS */.h.IELTS_PLUS_BATCH_FETCH_SUCCESS:
            var newPlusList = sortBatches(action.payload);
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                plusBatchData: newPlusList
            });
        case UpcomingIeltsActions/* UpcomingType.NUDGE_FETCH_SUCCESS */.h.NUDGE_FETCH_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                nudgeOffer: action.payload
            });
        case UpcomingIeltsActions/* UpcomingType.UPCOMING_IELTS_FETCH_FAIL */.h.UPCOMING_IELTS_FETCH_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                errorMessage: action.payload
            });
        case UpcomingIeltsActions/* UpcomingType.TOGGLE_UPCOMING_IELTS_BATCHES_MODAL */.h.TOGGLE_UPCOMING_IELTS_BATCHES_MODAL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isUpcomingIeltsBatchModalOpen: action.payload
            });
        case UpcomingIeltsActions/* UpcomingType.FETCH_GET_UPCOMING_BATCH_TIME_AND_PRICE_SUCCESS */.h.FETCH_GET_UPCOMING_BATCH_TIME_AND_PRICE_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                nextBatchPriceAndTiming: action.payload
            });
        case UpcomingIeltsActions/* UpcomingType.SET_ALL_IELTS_BATCHES */.h.SET_ALL_IELTS_BATCHES:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                allIeltsBatches: action.payload
            });
        case UpcomingIeltsActions/* UpcomingType.SET_BATCHES_BANNER_DATA */.h.SET_BATCHES_BANNER_DATA:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                batchesBannerData: action.payload
            });
        case UpcomingIeltsActions/* UpcomingType.TOGGLE_OFFER_MODAL */.h.TOGGLE_OFFER_MODAL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isOfferModalOpen: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var UpcomingIeltsReducer = (UpcomingIeltsReducer_reducer);

// EXTERNAL MODULE: ./components/Profile/UpdateProfileFormsNew/redux/UpdateProfileActions.tsx
var UpdateProfileActions = __webpack_require__(67985);
;// CONCATENATED MODULE: ./components/Profile/UpdateProfileFormsNew/redux/UpdateProfileReducer.tsx



var UpdateProfileReducer_initialState = {
    // all form data state
    personalData: {},
    addressData: {},
    passportData: {},
    backgroundData: {},
    academicData: {},
    emergencyContactData: {},
    examScoreData: {},
    educationData: [],
    refereeData: [],
    workExpData: [],
    // all option data state
    countryList: [],
    languageList: [],
    cityList: [],
    stateList: [],
    // process states
    loading: false,
    fetchError: {},
    saveError: {}
};
// create your reducer
var UpdateProfileReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : UpdateProfileReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    // console.log("reducer action --->", action,state);
    switch(action.type){
        // ---FETCH_PERSONAL_DATA START--- verified
        case "FETCH_PERSONAL_DATA":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: true
            });
        case "FETCH_PERSONAL_DATA_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                personalData: action.payload,
                loading: false
            });
        case "FETCH_PERSONAL_DATA_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                fetchError: {
                    personalData: true
                }
            });
        // ---FETCH_PERSONAL_DATA END---
        // ---SAVE_PERSONAL_DATA START--- verified
        case "SAVE_PERSONAL_DATA":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: true
            });
        case "SAVE_PERSONAL_DATA_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: false,
                saveError: {
                    personalData: false
                }
            });
        case "SAVE_PERSONAL_DATA_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saveError: {
                    personalData: true
                },
                saving: false
            });
        // ---SAVE_PERSONAL_DATA END---
        // ---FETCH_ADDRESS_DATA START--- verified
        case "FETCH_ADDRESS_DATA":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: true
            });
        case "FETCH_ADDRESS_DATA_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                addressData: action.payload,
                loading: false
            });
        case "FETCH_ADDRESS_DATA_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                fetchError: {
                    addressData: true
                }
            });
        // ---FETCH_ADDRESS_DATA END---
        // ---SAVE_ADDRESS_DATA START--- verified
        case "SAVE_ADDRESS_DATA":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: true
            });
        case "SAVE_ADDRESS_DATA_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: false,
                saveError: {
                    addressData: false
                }
            });
        case "SAVE_ADDRESS_DATA_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: false,
                saveError: {
                    addressData: true
                }
            });
        // ---SAVE_ADDRESS_DATA END---
        // ---FETCH_PASSPORT_DATA START--- verified
        case "FETCH_PASSPORT_DATA":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: true
            });
        case "FETCH_PASSPORT_DATA_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                passportData: action.payload,
                loading: false
            });
        case "FETCH_PASSPORT_DATA_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                fetchError: {
                    passportData: true
                }
            });
        // ---FETCH_PASSPORT_DATA END---
        // ---SAVE_PASSPORT_DATA START---  verified
        case "SAVE_PASSPORT_DATA ":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: true
            });
        case "SAVE_PASSPORT_DATA_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: false,
                saveError: {
                    passportData: false
                }
            });
        case "SAVE_PASSPORT_DATA_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: false,
                saveError: {
                    passportData: true
                }
            });
        // ---SAVE_PASSPORT_DATA END---
        // ---FETCH_BACKGROUND_DATA START--- verified
        case "FETCH_BACKGROUND_DATA ":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: true
            });
        case "FETCH_BACKGROUND_DATA_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                backgroundData: action.payload,
                loading: false
            });
        case "FETCH_BACKGROUND_DATA_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                fetchError: {
                    backgroundData: true
                }
            });
        // ---FETCH_BACKGROUND_DATA END---
        // ---SAVE_BACKGROUND_DATA START---  verified
        case "SAVE_BACKGROUND_DATA ":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: true
            });
        case "SAVE_BACKGROUND_DATA_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: false,
                saveError: {
                    backgroundData: false
                }
            });
        case "SAVE_BACKGROUND_DATA_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: false,
                saveError: {
                    backgroundData: true
                }
            });
        // ---SAVE_BACKGROUND_DATA END---
        // ---GET_COUNTRY_LIST START---
        case "GET_COUNTRY_LIST ":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: true
            });
        case "GET_COUNTRY_LIST_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                countryList: action.payload,
                loading: false
            });
        case "GET_COUNTRY_LIST_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                fetchError: {
                    countryData: true
                },
                loading: false
            });
        // ---GET_COUNTRY_LIST END---
        // ---GET_LANGUAGE_LIST START---
        case "GET_LANGUAGE_LIST ":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: true
            });
        case "GET_LANGUAGE_LIST_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                languageList: action.payload,
                loading: false
            });
        case "GET_LANGUAGE_LIST_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                fetchError: {
                    languageData: true
                },
                loading: false
            });
        // ---GET_LANGUAGE_LIST END---
        // ---FETCH_ACADEMIC_DATA START---
        case UpdateProfileActions/* actionConstants.FETCH_ACADEMIC_DATA */.U.FETCH_ACADEMIC_DATA:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: true
            });
        case UpdateProfileActions/* actionConstants.FETCH_ACADEMIC_DATA_SUCCESS */.U.FETCH_ACADEMIC_DATA_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                academicData: action.payload
            });
        case UpdateProfileActions/* actionConstants.FETCH_ACADEMIC_DATA_FAIL */.U.FETCH_ACADEMIC_DATA_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                fetchError: {
                    academicData: true
                }
            });
        // ---FETCH_ACADEMIC_DATA END---
        // ---SAVE_ACADEMIC_DATA START---
        case UpdateProfileActions/* actionConstants.SAVE_ACADEMIC_DATA */.U.SAVE_ACADEMIC_DATA:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: true
            });
        case UpdateProfileActions/* actionConstants.SAVE_ACADEMIC_DATA_SUCCESS */.U.SAVE_ACADEMIC_DATA_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: false,
                saveError: {
                    academicData: false
                }
            });
        case UpdateProfileActions/* actionConstants.SAVE_ACADEMIC_DATA_FAIL */.U.SAVE_ACADEMIC_DATA_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: false,
                saveError: {
                    academicData: true
                }
            });
        // ---SAVE_ACADEMIC_DATA END---
        // ---SAVE_ACADEMIC_DATA START---
        case UpdateProfileActions/* actionConstants.FETCH_EMERGENCY_CONTACT_DATA */.U.FETCH_EMERGENCY_CONTACT_DATA:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: true
            });
        case UpdateProfileActions/* actionConstants.FETCH_EMERGENCY_CONTACT_DATA_SUCCESS */.U.FETCH_EMERGENCY_CONTACT_DATA_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                emergencyContactData: action.payload
            });
        case UpdateProfileActions/* actionConstants.FETCH_EMERGENCY_CONTACT_DATA_FAIL */.U.FETCH_EMERGENCY_CONTACT_DATA_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                fetchError: {
                    emergencyContactData: true
                }
            });
        // ---SAVE_ACADEMIC_DATA END---
        // ---FETCH_EMERGENCY_CONTACT_DATA START---
        case UpdateProfileActions/* actionConstants.SAVE_EMERGENCY_CONTACT_DATA */.U.SAVE_EMERGENCY_CONTACT_DATA:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: true
            });
        case UpdateProfileActions/* actionConstants.SAVE_EMERGENCY_CONTACT_DATA_SUCCESS */.U.SAVE_EMERGENCY_CONTACT_DATA_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: false,
                saveError: {
                    emergencyContactData: false
                }
            });
        case UpdateProfileActions/* actionConstants.SAVE_EMERGENCY_CONTACT_DATA_FAIL */.U.SAVE_EMERGENCY_CONTACT_DATA_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: false,
                saveError: {
                    emergencyContactData: true
                }
            });
        // ---FETCH_EMERGENCY_CONTACT_DATA END---
        // ---GET_STATE_LIST START---
        case UpdateProfileActions/* actionConstants.GET_STATE_LIST */.U.GET_STATE_LIST:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: true
            });
        case UpdateProfileActions/* actionConstants.GET_STATE_LIST_SUCCESS */.U.GET_STATE_LIST_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                stateList: action.payload,
                loading: false
            });
        case UpdateProfileActions/* actionConstants.GET_STATE_LIST_FAIL */.U.GET_STATE_LIST_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                fetchError: {
                    stateData: true
                }
            });
        // ---GET_STATE_LIST END---
        // ---GET_CITY_LIST START---
        case UpdateProfileActions/* actionConstants.GET_CITY_LIST */.U.GET_CITY_LIST:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: true
            });
        case UpdateProfileActions/* actionConstants.GET_CITY_LIST_SUCCESS */.U.GET_CITY_LIST_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                cityList: action.payload,
                loading: false
            });
        case UpdateProfileActions/* actionConstants.GET_CITY_LIST_FAIL */.U.GET_CITY_LIST_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                fetchError: {
                    cityData: true
                }
            });
        // ---GET_CITY_LIST END---
        // ---FETCH_EXAM_SCORE_DATA START---
        case UpdateProfileActions/* actionConstants.FETCH_EXAM_SCORE_DATA */.U.FETCH_EXAM_SCORE_DATA:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: true
            });
        case UpdateProfileActions/* actionConstants.FETCH_EXAM_SCORE_DATA_SUCCESS */.U.FETCH_EXAM_SCORE_DATA_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                examScoreData: action.payload,
                loading: false
            });
        case UpdateProfileActions/* actionConstants.FETCH_EXAM_SCORE_DATA_FAIL */.U.FETCH_EXAM_SCORE_DATA_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                fetchError: {
                    examScoreData: true
                }
            });
        // ---FETCH_EXAM_SCORE_DATA END---
        // ---SAVE_EXAM_SCORE START---
        case UpdateProfileActions/* actionConstants.SAVE_EXAM_SCORE */.U.SAVE_EXAM_SCORE:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: true
            });
        case UpdateProfileActions/* actionConstants.SAVE_EXAM_SCORE_SUCCESS */.U.SAVE_EXAM_SCORE_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: false,
                saveError: {
                    examScoreData: false
                }
            });
        case UpdateProfileActions/* actionConstants.SAVE_EXAM_SCORE_FAIL */.U.SAVE_EXAM_SCORE_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: false,
                saveError: {
                    examScoreData: true
                }
            });
        // ---SAVE_EXAM_SCORE END---
        // ---FETCH_EDUCATION_DATA START---
        case "FETCH_EDUCATION_DATA":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: true
            });
        case "FETCH_EDUCATION_DATA_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                educationData: action.payload,
                loading: false
            });
        case "FETCH_EDUCATION_DATA_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                fetchError: {
                    educationData: true
                }
            });
        // ---FETCH_EDUCATION_DATA END---
        // ---SAVE_EDUCATION_DATA START---
        case "SAVE_EDUCATION_DATA":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: true
            });
        case "SAVE_EDUCATION_DATA_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: false,
                saveError: {
                    educationData: false
                }
            });
        case "SAVE_EDUCATION_DATA_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: false,
                saveError: {
                    educationData: false
                }
            });
        // ---SAVE_EDUCATION_DATA END---
        // ---FETCH_REFEREE_DATA START---
        case "FETCH_REFEREE_DATA":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false
            });
        case "FETCH_REFEREE_DATA_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                refereeData: action.payload,
                loading: false
            });
        case "FETCH_REFEREE_DATA_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                fetchError: {
                    refereeData: true
                }
            });
        // ---FETCH_REFEREE_DATA END---
        // ---SAVE_REFEREE_DATA START---
        case "SAVE_REFEREE_DATA":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: true
            });
        case "SAVE_REFEREE_DATA_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: false,
                saveError: {
                    refereeData: false
                }
            });
        case "SAVE_REFEREE_DATA_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: false,
                saveError: {
                    refereeData: true
                }
            });
        // ---SAVE_REFEREE_DATA END---
        // ---FETCH_WORK_EXP_DATA START---
        case UpdateProfileActions/* actionConstants.FETCH_WORK_EXP_DATA */.U.FETCH_WORK_EXP_DATA:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: true
            });
        case UpdateProfileActions/* actionConstants.FETCH_WORK_EXP_DATA_SUCCESS */.U.FETCH_WORK_EXP_DATA_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                workExpData: action.payload
            });
        case UpdateProfileActions/* actionConstants.FETCH_WORK_EXP_DATA_FAIL */.U.FETCH_WORK_EXP_DATA_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                fetchError: {
                    workExpData: true
                }
            });
        // ---FETCH_WORK_EXP_DATA END---
        // ---SAVE_WORK_EXP START---
        case UpdateProfileActions/* actionConstants.SAVE_WORK_EXP */.U.SAVE_WORK_EXP:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: true
            });
        case UpdateProfileActions/* actionConstants.SAVE_WORK_EXP_SUCCESS */.U.SAVE_WORK_EXP_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: false,
                saveError: {
                    workExpData: false
                }
            });
        case UpdateProfileActions/* actionConstants.SAVE_WORK_EXP_FAIL */.U.SAVE_WORK_EXP_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saving: false,
                saveError: {
                    workExpData: true
                }
            });
        // ---SAVE_WORK_EXP END---
        // ---FETCH_BACKGROUND_DATA START---
        // case actionConstants.DELETE_WORK_EXP_SUCCESS:
        //   return {
        //     ...state,
        //     deleting: false,
        //   };
        // case actionConstants.DELETE_WORK_EXP_FAIL:
        //   return {
        //     ...state,
        //     deleteError: action.payload,
        //     deleting: false,
        //   };
        // ---FETCH_BACKGROUND_DATA END---
        case "RESET_FETCH_ERROR":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                fetchError: ""
            });
        case "RESET_SAVE_ERROR":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saveError: ""
            });
        case "RESET_ERROR":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saveError: {},
                fetchError: {}
            });
        default:
            return state;
    }
};
/* harmony default export */ var UpdateProfileReducer = (UpdateProfileReducer_reducer);

;// CONCATENATED MODULE: ./components/Profile/IeltsRegistrationForm/redux/IeltsRegistrationFormReducer.ts


var IeltsRegistrationFormReducer_initialState = {
    ctaText: "Done",
    isModalOpen: false,
    error: "",
    ieltsPaymentSuccess: false,
    ieltsFreeTrailEligiblity: null,
    initPayment: false
};
// create your reducer
var IeltsRegistrationFormReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : IeltsRegistrationFormReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "TOGGLE_IELTS_FORM_CTA_TEXT":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                ctaText: action.payload
            });
        case "TOGGLE_IELTS_FORM_MODAL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isModalOpen: action.payload
            });
        case "IELTS_FORM_ERROR":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        //ub
        case "IELTS_PLUS_PAYMENT_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                ieltsPaymentSuccess: action.payload
            });
        case "TOGGLE_FREE_TRAIL_ELIGIBILITY":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                ieltsFreeTrailEligiblity: action.payload
            });
        case "TOGGLE_IELTS_INIT_PAYMENT":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                initPayment: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var IeltsRegistrationFormReducer = (IeltsRegistrationFormReducer_reducer);

;// CONCATENATED MODULE: ./components/Profile/MasterclassRegistrationForm/redux/MasterclassRegistrationFormReducer.ts


var MasterclassRegistrationFormReducer_initialState = {
    ctaText: "Done",
    isModalOpen: false,
    error: "",
    showForm: false,
    showLoader: false,
    //ub
    saveFormSuccess: false,
    postFormAction: null,
    formValues: {},
    isLoading: false,
    shouldRedirectI2cTimeline: false
};
// create your reducer
var MasterclassRegistrationFormReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : MasterclassRegistrationFormReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "TOGGLE_MASTERCLASS_FORM_CTA_TEXT":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                ctaText: action.payload
            });
        case "TOGGLE_MASTERCLASS_FORM_MODAL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isModalOpen: action.payload
            });
        case "MASTERCLASS_FORM_ERROR":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        case "TOGGLE_MASTERCLASS_SHOW_FORM":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showForm: action.payload
            });
        case "TOGGLE_MASTERCLASS_SHOW_LOADER":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showLoader: action.payload
            });
        //ub
        case "MASTERCLASS_FORM_SUBMIT_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                saveFormSuccess: action.payload
            });
        case "POST_FORM_ACTION":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                postFormAction: action.payload
            });
        case "SAVE_MASTERCLASS_FORM_VALUES":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                formValues: action.payload
            });
        case "TOGGLE_MC_LOADING_STATUS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLoading: action.payload
            });
        case "TOGGLE_I2C_REDIRECT_STATUS":
            {
                console.log("sadasd", action.payload);
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    shouldRedirectI2cTimeline: action.payload
                });
            }
        default:
            return state;
    }
};
/* harmony default export */ var MasterclassRegistrationFormReducer = (MasterclassRegistrationFormReducer_reducer);

;// CONCATENATED MODULE: ./components/Profile/IeltsAttendanceScreen/redux/IeltsAttendanceReducer.ts


var IeltsAttendanceReducer_initialState = {
    error: "",
    selectedBatch: {},
    addedToCalendar: false
};
var IeltsAttendanceReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : IeltsAttendanceReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "IELTS_ATTENDANCE_ERROR":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        case "UPDATE_SELECTED_BATCH":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                selectedBatch: action.payload
            });
        case "UPDATE_ADDED_TO_CALENDAR":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                addedToCalendar: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var IeltsAttendanceReducer = (IeltsAttendanceReducer_reducer);

// EXTERNAL MODULE: ./components/Profile/IeltsProfile/ExtraClass/redux/ExtraClassActions.ts
var ExtraClassActions = __webpack_require__(82715);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/ExtraClass/redux/ExtraClassReducer.ts



var ExtraClassReducer_initialState = {
    loading: false,
    showHasJoinedModal: false,
    errorMessage: "",
    enrolledExtraClass: null,
    postAction: null,
    plusExclusive: [],
    showHasJoinedOrientation: false
};
var ExtraClassReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ExtraClassReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case ExtraClassActions/* ExtraClassType.NOTIFY_USER_FOR_EXTRA_CLASS */.r.NOTIFY_USER_FOR_EXTRA_CLASS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: true
            });
        case ExtraClassActions/* ExtraClassType.NOTIFY_USER_FOR_EXTRA_CLASS_SUCCESS */.r.NOTIFY_USER_FOR_EXTRA_CLASS_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                showHasJoinedModal: action.payload
            });
        case ExtraClassActions/* ExtraClassType.NOTIFY_USER_FOR_EXTRA_CLASS_FAIL */.r.NOTIFY_USER_FOR_EXTRA_CLASS_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                errorMessage: action.payload
            });
        case ExtraClassActions/* ExtraClassType.TOGGLE_HAS_JOINED_MODAL */.r.TOGGLE_HAS_JOINED_MODAL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showHasJoinedModal: action.payload
            });
        case ExtraClassActions/* ExtraClassType.FETCH_ENROLLED_EXTRA_CLASS_REQ */.r.FETCH_ENROLLED_EXTRA_CLASS_REQ:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: true
            });
        case ExtraClassActions/* ExtraClassType.FETCH_ENROLLED_EXTRA_CLASS_SUCCESS */.r.FETCH_ENROLLED_EXTRA_CLASS_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                enrolledExtraClass: action.payload
            });
        case ExtraClassActions/* ExtraClassType.FETCH_ENROLLED_EXTRA_CLASS_FAIL */.r.FETCH_ENROLLED_EXTRA_CLASS_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                errorMessage: action.payload
            });
        case ExtraClassActions/* ExtraClassType.NOTIFY_ORIENTATION_CLASS_SUCCESS */.r.NOTIFY_ORIENTATION_CLASS_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                showHasJoinedOrientation: action.payload
            });
        case ExtraClassActions/* ExtraClassType.NOTIFY_USER_POST_ACTION */.r.NOTIFY_USER_POST_ACTION:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                postAction: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var ExtraClassReducer = (ExtraClassReducer_reducer);

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/Nps/redux/NpsReducer.ts


var NpsReducer_initialState = {
    showNps: false,
    npsData: null,
    error: "",
    currentQuestion: null,
    npsId: "",
    questionType: "rating",
    questionTitle: "",
    submitRating: null
};
var NpsReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : NpsReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "FETCH_NPS_STATUS_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                npsData: action.payload
            });
        case "UPDATE_ERROR_MESSAGE":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        case "UPDATE_NPS_QUESTION":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                currentQuestion: action.payload
            });
        case "UPDATE_NPS_STATUS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showNps: action.payload
            });
        case "UPDATE_NPS_ID":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                npsId: action.payload
            });
        case "UPDATE_QUESTION_TYPE":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                questionType: action.payload
            });
        case "UPDATE_QUESTION_TITLE":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                questionTitle: action.payload
            });
        case "UPDATE_SUBMIT_RATING":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                submitRating: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var NpsReducer = (NpsReducer_reducer);

;// CONCATENATED MODULE: ./components/SpotCounselling/redux/SpotCounsellingReducer.ts


var SpotCounsellingReducer_initialState = {
    isLoading: false,
    expertsData: [],
    error: null,
    stage: null,
    goalPlanData: {},
    slots: [],
    isEnrolled: false,
    isLoadingSlots: false,
    spotProfileData: null,
    isSubmittedSpotProfile: false,
    isLiveSlotAvailable: null,
    liveSlot: null,
    eligibility: {},
    eventsData: {
        upcomingEvents: [],
        bookedEvents: []
    },
    profileLayout: {},
    requalificationEligibility: {},
    isAppNudgeRequired: false,
    appNudgeData: {},
    isModalOpen: false,
    courseSelected: "",
    cardId: ""
};
// create your reducer
var SpotCounsellingReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : SpotCounsellingReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "FETCH_PROFILE_LAYOUT":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLoading: true
            });
        case "FETCH_PROFILE_LAYOUT_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                profileLayout: action.payload,
                isLoading: false
            });
        case "FETCH_PROFILE_LAYOUT_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLoading: false
            });
        case "ELIGIBILITY_FETCH_REQUESTED":
            return (0,_object_spread/* default */.Z)({}, state);
        case "ELIGIBILITY_FETCH_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                eligibility: action.payload,
                saving: false
            });
        case "REQUALIFICATION_ELIGIBLITY_FETCH_REQUESTED":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLoading: true
            });
        case "REQUALIFICATION_ELIGIBLITY_FETCH_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                requalificationEligibility: action.payload,
                isLoading: false
            });
        case "REQUALIFICATION_ELIGIBLITY_FETCH_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                isLoading: false
            });
        case "ELIGIBILITY_FETCH_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                saving: false
            });
        case "FETCH_UPCOMING_EVENTS":
            return (0,_object_spread/* default */.Z)({}, state);
        case "FETCH_UPCOMING_EVENTS_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                eventsData: action.payload
            });
        case "FETCH_UPCOMING_EVENTS_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        case "FETCH_EXPERTS_DATA":
            return (0,_object_spread/* default */.Z)({}, state);
        case "FETCH_EXPERTS_DATA_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                expertsData: action.payload
            });
        case "FETCH_EXPERTS_DATA_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                expertsData: []
            });
        case "FETCH_STAGE":
            return (0,_object_spread/* default */.Z)({}, state);
        case "FETCH_STAGE_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                stage: action.payload
            });
        case "FETCH_STAGE_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                stage: null
            });
        case "FETCH_APP_NUDGE_ELIGIBILITY":
            return (0,_object_spread/* default */.Z)({}, state);
        case "FETCH_APP_NUDGE_DATA":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                appNudgeData: (0,_object_spread/* default */.Z)({}, action.payload)
            });
        case "FETCH_APP_NUDGE_ELIGIBILITY_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isAppNudgeRequired: action.payload
            });
        case "FETCH_APP_NUDGE_ELIGIBILITY_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        case "FETCH_GOAL_PLAN_DATA":
            return (0,_object_spread/* default */.Z)({}, state);
        case "FETCH_GOAL_PLAN_DATA_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                goalPlanData: action.payload,
                error: null
            });
        case "FETCH_GOAL_PLAN_DATA_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                goalPlanData: null
            });
        case "FETCH_SPOT_COUNSELLING_SLOT":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                slots: [],
                isLoadingSlots: true
            });
        case "UNAUTHENTICATED_FETCH_SPOT_COUNSELLING_SLOT":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                slots: [],
                isLoadingSlots: true
            });
        case "FETCH_SPOT_COUNSELLING_SLOT_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                slots: action.payload.spotCounselingCalendarResponses,
                isLoadingSlots: false,
                isLiveSlotAvailable: action.payload.liveSlotAvailable,
                liveSlot: action.payload.liveSlot
            });
        case "FETCH_SPOT_COUNSELLING_SLOT_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                slots: [],
                isLoadingSlots: false,
                liveSlot: null,
                isLiveSlotAvailable: false
            });
        case "CONFIRM_SPOT_COUNSELLING_SLOT_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isEnrolled: action.payload.data
            });
        case "CONFIRM_SPOT_COUNSELLING_SLOT_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isEnrolled: false,
                error: action.payload
            });
        case "CONFIRM_SPOT_COUNSELLING_SLOT":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: null,
                isEnrolled: false
            });
        case "UNAUTHENTICATED_CONFIRM_SPOT_COUNSELLING_SLOT":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: null,
                isEnrolled: false
            });
        case "CONFIRM_SPOT_RESCHEDULE_SLOT_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isEnrolled: action.payload.data
            });
        case "TOGGLE_MODAL_APP":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isModalOpen: action.payload.isOpen,
                courseSelected: action.payload.courseSelected,
                cardId: action.payload.cardClicked
            });
        case "CONFIRM_SPOT_RESCHEDULE_SLOT_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isEnrolled: false,
                error: action.payload
            });
        case "CONFIRM_SPOT_RESCHEDULE_SLOT":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: null,
                isEnrolled: false
            });
        case "FETCH_SPOT_PROFILE":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLoading: true
            });
        case "FETCH_SPOT_PROFILE_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                spotProfileData: action.payload,
                isLoading: false
            });
        case "FETCH_SPOT_PROFILE_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                spotProfileData: null,
                isLoading: false
            });
        case "SUBMIT_SPOT_PROFILE":
            return (0,_object_spread/* default */.Z)({}, state);
        case "SUBMIT_SPOT_PROFILE_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isSubmittedSpotProfile: action.payload
            });
        case "SUBMIT_SPOT_PROFILE_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var SpotCounsellingReducer = (SpotCounsellingReducer_reducer);

;// CONCATENATED MODULE: ./components/SpotCounselling/Calender/redux/calenderReducer.ts



var calenderReducer_initialState = {
    isModalOpen: false,
    isSlotStarted: false,
    selectedSlot: {},
    isLiveViewOn: false,
    slotOptions: [],
    isLoading: false,
    selectedDate: "",
    isJoinLiveClicked: false
};
// create your reducer
var calenderReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : calenderReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "TOGGLE_MODAL_OPEN":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isModalOpen: action.payload
            });
        case "TOGGLE_IS_SLOT_STARTED":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isSlotStarted: action.payload
            });
        case "SETTING_SELECTED_SLOT":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                selectedSlot: (0,_object_spread/* default */.Z)({}, action.payload)
            });
        case "TOGGLE_LIVEVIEW_ON":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLiveViewOn: action.payload
            });
        case "TOGGLE_IS_LOADING":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLoading: action.payload
            });
        case "SET_SLOT_OPTIONS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                slotOptions: (0,_to_consumable_array/* default */.Z)(action.payload)
            });
        case "SET_SELECTED_DATE":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                selectedDate: action.payload
            });
        case "TOGGLE_JOIN_LIVE_BUTTON":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isJoinLiveClicked: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var calenderReducer = (calenderReducer_reducer);

;// CONCATENATED MODULE: ./components/Ielts/PromoCode/redux/PromoCodeReducer.ts


var PromoCodeReducer_initialState = {
    promoCodeApplied: false,
    promoCode: "",
    promoMsg: "",
    priceAfterDiscount: null,
    isValidCode: null,
    discount: null,
    showPromoCodeForm: false,
    isPromoCodeApplicationLoading: false,
    promoCodes: []
};
var promoCodeReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : PromoCodeReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    var getPromoMsg = function(offerPrice, discount) {
        if (offerPrice === 0) {
            return "This product is already free of cost for you!";
        } else {
            return "Congrats! You have unlocked ".concat(discount, "% off");
        }
    };
    switch(action.type){
        case "FETCH_PROMO_CODE_VALIDATION_SUCCESS":
            var price = action.payload.offerPrice - action.payload.data.discount / 100 * action.payload.offerPrice;
            var msg = getPromoMsg(action.payload.offerPrice, action.payload.data.discount);
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                promoCodeApplied: true,
                priceAfterDiscount: Math.floor(price),
                promoMsg: msg,
                isValidCode: true,
                discount: action.payload.data.discount
            });
        case "FETCH_PROMO_CODE_VALIDATION_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                promoMsg: action.payload,
                isValidCode: false
            });
        case "UPDATE_PROMO_CODE_APPLIED":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                promoCodeApplied: action.payload
            });
        case "REMOVE_PROMO_CODE":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                promoCodeApplied: false,
                promoMsg: "",
                isValidCode: null,
                priceAfterDiscount: null,
                promoCode: ""
            });
        case "FETCH_PROMO_CODE_VALIDATION":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                promoCode: action.payload.promoCode
            });
        case "TOGGLE_PROMO_CODE_FORM":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showPromoCodeForm: action.payload
            });
        case "TOGGLE_PROMO_CODE_APPLICATION_LOADING":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isPromoCodeApplicationLoading: action.payload
            });
        case "FETCH_PROMO_CODES_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                promoCodes: action.payload
            });
        case "CHANGE_IS_VALID_CODE":
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    isValidCode: action.payload
                });
            }
        default:
            return state;
    }
};
/* harmony default export */ var PromoCodeReducer = (promoCodeReducer);

// EXTERNAL MODULE: ./lib/auth_token.ts
var auth_token = __webpack_require__(72714);
;// CONCATENATED MODULE: ./components/decorator/redux/AuthReducer.ts




var AuthReducer_initialState = {
    auth: undefined
};
// create your reducer
var AuthReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : AuthReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case es6/* HYDRATE */.ju:
            var ref, ref1;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                auth: new auth_token/* AuthToken */.H((ref = action.payload.auth) === null || ref === void 0 ? void 0 : (ref1 = ref.auth) === null || ref1 === void 0 ? void 0 : ref1.token)
            });
        case "SAVE_AUTH":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                auth: new auth_token/* AuthToken */.H(action.payload)
            });
        default:
            return state;
    }
};
/* harmony default export */ var AuthReducer = (AuthReducer_reducer);

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/MockTest/redux/MockTestReducer.ts




var MockTestReducer_initialState = {
    mockTestData: null,
    error: "",
    view: "mockCards",
    activeSection: null,
    activeMockTestIndex: null,
    essayUploaded: false,
    showMockTest: true,
    activeMockTestId: null
};
var getColor = function(status, completedSubmission, type) {
    if (status === "LOCKED") {
        if (type === "circle") {
            return "bg-skin-200";
        } else {
            return "bg-skin-100";
        }
    } else if (completedSubmission) {
        if (type === "circle") {
            return "bg-green-1100";
        } else {
            return "bg-green-1000";
        }
    } else {
        if (type === "circle") {
            return "bg-green-500";
        } else {
            return "bg-blue-1100";
        }
    }
};
var mockTestReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : MockTestReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "FETCH_MOCK_TEST_SUCCESS":
            var newMockTestData = cloneDeep_default()(action.payload);
            newMockTestData === null || newMockTestData === void 0 ? void 0 : newMockTestData.mockTests.forEach(function(mock) {
                mock.completedSubmission = mock.sections.length - mock.sections.filter(function(section) {
                    return section.submission;
                }).length === 0 ? true : false;
                mock.title = "Mock Test ".concat(mock.mockTestIndex);
                mock.subText = mock.mockTestStatus === "LOCKED" ? "Your tutor will unlock the test soon" : "Your test has been unlocked. Attempt now!";
                mock.sectionsRemaining = mock.sections.length - mock.sections.filter(function(section) {
                    return section.submission;
                }).length;
                mock.statusText = mock.mockTestStatus === "LOCKED" ? "Locked" : mock.sectionsRemaining > 1 ? "Sections Remaining" : "Section Remaining";
                mock.backgroundColor = getColor(mock.mockTestStatus, mock.completedSubmission, "background");
                mock.circleColor = getColor(mock.mockTestStatus, mock.completedSubmission, "circle");
            });
            newMockTestData === null || newMockTestData === void 0 ? void 0 : newMockTestData.mockTests.sort(function(a, b) {
                return a.mockTestIndex > b.mockTestIndex ? 1 : -1;
            });
            var completedMockTest = [];
            var lockedMockTest = [];
            var ongoingMockTest = [];
            var len = newMockTestData === null || newMockTestData === void 0 ? void 0 : newMockTestData.mockTests.length;
            for(var i = 0; i < len; i++){
                if (newMockTestData.mockTests[i].completedSubmission) {
                    completedMockTest.push(newMockTestData.mockTests[i]);
                } else if (newMockTestData.mockTests[i].mockTestStatus === "LOCKED") {
                    lockedMockTest.push(newMockTestData.mockTests[i]);
                } else {
                    ongoingMockTest.push(newMockTestData.mockTests[i]);
                }
            }
            var newMockList = (0,_to_consumable_array/* default */.Z)(ongoingMockTest).concat((0,_to_consumable_array/* default */.Z)(lockedMockTest), (0,_to_consumable_array/* default */.Z)(completedMockTest));
            newMockTestData.mockTests = newMockList;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                mockTestData: newMockTestData
            });
        case "UPDATE_MOCK_TEST_ERROR":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        case "UPDATE_MOCK_TEST_VIEW":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                view: action.payload
            });
        case "UPDATE_MOCK_TEST_ACTIVE_SECTION":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                activeSection: action.payload
            });
        case "UPDATE_ACTIVE_MOCK_TEST_INDEX":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                activeMockTestIndex: action.payload
            });
        case "TOGGLE_UPLOAD_MOCK_TEST_STATUS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                essayUploaded: action.payload
            });
        case "UPDATE_ACTIVE_MOCK_TEST_ID":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                activeMockTestId: action.payload
            });
        case "FETCH_ESSAY_LIST_SUCCESS":
            var hideMockTest = action.payload.length > 0;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showMockTest: !hideMockTest
            });
        default:
            return state;
    }
};
/* harmony default export */ var MockTestReducer = (mockTestReducer);

// EXTERNAL MODULE: ./components/Profile/FastTrackRegistrationForm/redux/FastTrackFormActions.ts
var FastTrackFormActions = __webpack_require__(48943);
;// CONCATENATED MODULE: ./components/Profile/FastTrackRegistrationForm/redux/FastTrackFormReducer.ts



var FastTrackFormReducer_initialState = {
    ctaText: "Next",
    isModalOpen: false,
    error: "",
    showFastTrackLoader: false,
    showFastTrackForm: false
};
var FastTrackFormReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : FastTrackFormReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case FastTrackFormActions/* fastTrackFormActionType.TOGGLE_FAST_TRACK_FORM_CTA_TEXT */.I.TOGGLE_FAST_TRACK_FORM_CTA_TEXT:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                ctaText: action.payload
            });
        case FastTrackFormActions/* fastTrackFormActionType.TOGGLE_FAST_TRACK_MODAL */.I.TOGGLE_FAST_TRACK_MODAL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isModalOpen: action.payload
            });
        case FastTrackFormActions/* fastTrackFormActionType.FAST_TRACK_FORM_ERROR */.I.FAST_TRACK_FORM_ERROR:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        case "TOGGLE_FAST_TRACK_LOADER":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showFastTrackLoader: action.payload
            });
        case "TOGGLE_FAST_TRACK_FORM":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showFastTrackForm: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var FastTrackFormReducer = (FastTrackFormReducer_reducer);

// EXTERNAL MODULE: ./components/Profile/IeltsProfile/FastTrack/redux/FastTrackAction.ts
var FastTrackAction = __webpack_require__(72823);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/FastTrack/redux/FastTrackReducer.ts



var FastTrackReducer_initialState = {
    fastTrackStatus: null,
    fastTrackCard: [],
    loading: false,
    error: ""
};
var FastTrackReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : FastTrackReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case FastTrackAction/* fastTrackActionType.FETCH_FAST_TRACK_STATUS_REQ */.X.FETCH_FAST_TRACK_STATUS_REQ:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: true
            });
        case FastTrackAction/* fastTrackActionType.FETCH_FAST_TRACK_STATUS_SUCCESS */.X.FETCH_FAST_TRACK_STATUS_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                fastTrackStatus: action.payload
            });
        case FastTrackAction/* fastTrackActionType.FETCH_FAST_TRACK_STATUS_FAIL */.X.FETCH_FAST_TRACK_STATUS_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                error: action.payload
            });
        case FastTrackAction/* fastTrackActionType.FETCH_FAST_TRACK_CARD_REQ */.X.FETCH_FAST_TRACK_CARD_REQ:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: true
            });
        case FastTrackAction/* fastTrackActionType.FETCH_FAST_TRACK_CARD_SUCCESS */.X.FETCH_FAST_TRACK_CARD_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                fastTrackCard: action.payload
            });
        case FastTrackAction/* fastTrackActionType.FETCH_FAST_TRACK_CARD_FAIL */.X.FETCH_FAST_TRACK_CARD_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                error: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var FastTrackReducer = (FastTrackReducer_reducer);

// EXTERNAL MODULE: ./components/Profile/FastTrackVideo/redux/FastTrackVideoAction.ts
var FastTrackVideoAction = __webpack_require__(16503);
;// CONCATENATED MODULE: ./components/Profile/FastTrackVideo/redux/FastTrackVideoReducer.ts



var FastTrackVideoReducer_initialState = {
    fastTrackVideoSeries: null,
    loading: false,
    error: "",
    redirect: false,
    modal: false,
    videoPreviewEndModal: false,
    nextVideoToPlayAfterPayment: null
};
var FastTrackVideoReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : FastTrackVideoReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case FastTrackVideoAction/* fastTrackActionVideoType.FETCH_FAST_TRACK_VIDEO_REQ */.x.FETCH_FAST_TRACK_VIDEO_REQ:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: true
            });
        case FastTrackVideoAction/* fastTrackActionVideoType.FETCH_FAST_TRACK_VIDEO_SUCCESS */.x.FETCH_FAST_TRACK_VIDEO_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                fastTrackVideoSeries: action.payload
            });
        case FastTrackVideoAction/* fastTrackActionVideoType.FETCH_FAST_TRACK_VIDEO_FAIL */.x.FETCH_FAST_TRACK_VIDEO_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                error: action.payload
            });
        case FastTrackVideoAction/* fastTrackActionVideoType.FAST_TRACK_WATCH_VIDEO_SUCCESS */.x.FAST_TRACK_WATCH_VIDEO_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                redirect: true
            });
        case FastTrackVideoAction/* fastTrackActionVideoType.FAST_TRACK_WATCH_VIDEO_FAIL */.x.FAST_TRACK_WATCH_VIDEO_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        case FastTrackVideoAction/* fastTrackActionVideoType.FAST_TRACK_MODAL */.x.FAST_TRACK_MODAL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                modal: action.payload
            });
        case FastTrackVideoAction/* fastTrackActionVideoType.VIDEO_PREVIEW_END_MODAL */.x.VIDEO_PREVIEW_END_MODAL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                videoPreviewEndModal: action.payload
            });
        case FastTrackVideoAction/* fastTrackActionVideoType.UPDATE_NEXT_VIDEO_TO_PLAY_AFTER_PAYMENT */.x.UPDATE_NEXT_VIDEO_TO_PLAY_AFTER_PAYMENT:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                nextVideoToPlayAfterPayment: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var FastTrackVideoReducer = (FastTrackVideoReducer_reducer);

;// CONCATENATED MODULE: ./components/Profile/IntermediateScreen/redux/IntermediateScreenReducer.ts


var IntermediateScreenReducer_initialState = {
    showUpdateUserModal: false,
    showUpdateUserView: false
};
var intermediateScreenReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : IntermediateScreenReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "TOGGLE_INTERMEDIATE_SCREEN_VIEW":
            if (window.innerWidth > 767) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    showUpdateUserModal: action.payload
                });
            } else {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    showUpdateUserView: action.payload
                });
            }
        default:
            return state;
    }
};
/* harmony default export */ var IntermediateScreenReducer = (intermediateScreenReducer);

// EXTERNAL MODULE: ./components/Profile/CounsellingProfile/redux/constants/overview-constants.ts
var overview_constants = __webpack_require__(5570);
;// CONCATENATED MODULE: ./components/Profile/CounsellingProfile/redux/reducers/overview-reducers.ts



var overview_reducers_initialState = {
    isLoading: false,
    isPaidCounselling: true,
    isPaidIelts: false,
    overviewData: {},
    error: "",
    isError: false,
    isOpenBookCounsellingModal: false,
    isOpenSpeakToCounsellorModal: false,
    isOpenGetLsPlusModal: false,
    isCallScheduled: false,
    counsellingFeeData: {},
    postPaymentData: {},
    offerData: null,
    isAllTaskOpen: false,
    isOnboardingDone: false,
    onboardStepsCompleted: 0,
    playList: {
        data: []
    }
};
var overview_reducers_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : overview_reducers_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case overview_constants/* default.FETCH_OVERVIEW_DATA */.Z.FETCH_OVERVIEW_DATA:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLoading: true,
                isError: false
            });
        case overview_constants/* default.FETCH_OVERVIEW_DATA_SUCCESS */.Z.FETCH_OVERVIEW_DATA_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                overviewData: action.payload,
                isLoading: false,
                isError: false
            });
        case overview_constants/* default.FETCH_OVERVIEW_DATA_ERROR */.Z.FETCH_OVERVIEW_DATA_ERROR:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                isLoading: false,
                isError: true
            });
        case overview_constants/* default.TOGGLE_BOOK_COUNSELLING_MODAL */.Z.TOGGLE_BOOK_COUNSELLING_MODAL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isOpenBookCounsellingModal: action.payload
            });
        case overview_constants/* default.TOGGLE_SPEAK_TO_COUNSELLOR_MODAL */.Z.TOGGLE_SPEAK_TO_COUNSELLOR_MODAL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isOpenSpeakToCounsellorModal: action.payload
            });
        case overview_constants/* default.TOGGLE_GET_LS_PLUS_MODAL */.Z.TOGGLE_GET_LS_PLUS_MODAL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isOpenGetLsPlusModal: action.payload
            });
        case overview_constants/* default.FETCH_COUNSELLING_FEE_DATA */.Z.FETCH_COUNSELLING_FEE_DATA:
            return (0,_object_spread/* default */.Z)({}, state);
        case overview_constants/* default.FETCH_COUNSELLING_FEE_DATA_SUCCESS */.Z.FETCH_COUNSELLING_FEE_DATA_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                counsellingFeeData: action.payload.data
            });
        case overview_constants/* default.FETCH_COUNSELLING_FEE_DATA_ERROR */.Z.FETCH_COUNSELLING_FEE_DATA_ERROR:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                counsellingFeeData: {},
                error: action.payload
            });
        case overview_constants/* default.FETCH_POST_PAYMENT_DATA_SUCCESS */.Z.FETCH_POST_PAYMENT_DATA_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                postPaymentData: action.payload
            });
        case overview_constants/* default.FETCH_OFFER_SUCCESS */.Z.FETCH_OFFER_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                offerData: action.payload
            });
        case overview_constants/* default.FETCH_OFFER_ERROR */.Z.FETCH_OFFER_ERROR:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                offerData: null
            });
        case overview_constants/* default.TOGGLE_ALL_TASK_VIEW */.Z.TOGGLE_ALL_TASK_VIEW:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isAllTaskOpen: action.payload
            });
        case overview_constants/* default.FETCH_PLAYLIST */.Z.FETCH_PLAYLIST:
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    playList: (0,_object_spread/* default */.Z)({}, state.playList)
                });
            }
        case overview_constants/* default.FETCH_PLAYLIST_SUCCESS */.Z.FETCH_PLAYLIST_SUCCESS:
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    playList: {
                        data: action.payload
                    }
                });
            }
        case overview_constants/* default.FETCH_PLAYLIST_FAIL */.Z.FETCH_PLAYLIST_FAIL:
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    playList: (0,_object_spread/* default */.Z)({}, state.playList)
                });
            }
        default:
            return state;
    }
};
/* harmony default export */ var overview_reducers = (overview_reducers_reducer);

// EXTERNAL MODULE: ./components/Profile/CounsellingProfile/redux/constants/notice-board-constants.ts
var notice_board_constants = __webpack_require__(5303);
;// CONCATENATED MODULE: ./components/Profile/CounsellingProfile/redux/reducers/notice-board-reducers.ts



var notice_board_reducers_initialState = {
    noticeBoardData: [],
    error: "",
    isLoading: false,
    isError: false
};
var notice_board_reducers_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : notice_board_reducers_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case notice_board_constants/* default.FETCH_NOTICE_BOARD_DATA */.Z.FETCH_NOTICE_BOARD_DATA:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLoading: true,
                isError: false
            });
        case notice_board_constants/* default.FETCH_NOTICE_BOARD_DATA_SUCCESS */.Z.FETCH_NOTICE_BOARD_DATA_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                noticeBoardData: action.payload,
                isLoading: false,
                isError: false
            });
        case notice_board_constants/* default.FETCH_NOTICE_BOARD_DATA_ERROR */.Z.FETCH_NOTICE_BOARD_DATA_ERROR:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                isLoading: false,
                isError: true
            });
        default:
            return state;
    }
};
/* harmony default export */ var notice_board_reducers = (notice_board_reducers_reducer);

// EXTERNAL MODULE: ./components/Profile/CounsellingProfile/redux/constants/upcoming-appointments-constants.ts
var upcoming_appointments_constants = __webpack_require__(93787);
;// CONCATENATED MODULE: ./components/Profile/CounsellingProfile/redux/reducers/upcoming-appointments-reducers.ts



var upcoming_appointments_reducers_initialState = {
    upcomingAppointmentData: [],
    error: "",
    isLoading: false,
    isError: false
};
var upcoming_appointments_reducers_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : upcoming_appointments_reducers_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case upcoming_appointments_constants/* default.FETCH_UPCOMING_APPOINTMENTS_DATA */.Z.FETCH_UPCOMING_APPOINTMENTS_DATA:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLoading: true,
                isError: false
            });
        case upcoming_appointments_constants/* default.FETCH_UPCOMING_APPOINTMENTS_DATA_SUCCESS */.Z.FETCH_UPCOMING_APPOINTMENTS_DATA_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                upcomingAppointmentData: action.payload,
                isLoading: false,
                isError: false
            });
        case upcoming_appointments_constants/* default.FETCH_UPCOMING_APPOINTMENTS_DATA_ERROR */.Z.FETCH_UPCOMING_APPOINTMENTS_DATA_ERROR:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                isLoading: false,
                isError: true
            });
        default:
            return state;
    }
};
/* harmony default export */ var upcoming_appointments_reducers = (upcoming_appointments_reducers_reducer);

// EXTERNAL MODULE: ./components/Profile/CounsellingProfile/redux/constants/document-details-constants.ts
var document_details_constants = __webpack_require__(87393);
;// CONCATENATED MODULE: ./components/Profile/CounsellingProfile/redux/reducers/document-details-reducers.ts



var document_details_reducers_initialState = {
    documentDetailsData: {},
    error: "",
    isLoading: false,
    isError: false
};
var document_details_reducers_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document_details_reducers_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case document_details_constants/* default.FETCH_DOCUMENT_DETAILS_DATA */.Z.FETCH_DOCUMENT_DETAILS_DATA:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLoading: true,
                isError: false
            });
        case document_details_constants/* default.FETCH_DOCUMENT_DETAILS_DATA_SUCCESS */.Z.FETCH_DOCUMENT_DETAILS_DATA_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                documentDetailsData: action.payload,
                isLoading: false,
                isError: false
            });
        case document_details_constants/* default.FETCH_DOCUMENT_DETAILS_DATA_ERROR */.Z.FETCH_DOCUMENT_DETAILS_DATA_ERROR:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                isLoading: false,
                isError: true
            });
        default:
            return state;
    }
};
/* harmony default export */ var document_details_reducers = (document_details_reducers_reducer);

// EXTERNAL MODULE: ./components/Profile/CounsellingProfile/redux/constants/visa-assistance-constants.ts
var visa_assistance_constants = __webpack_require__(82382);
;// CONCATENATED MODULE: ./components/Profile/CounsellingProfile/redux/reducers/visa-assistance-reducers.ts



var visa_assistance_reducers_initialState = {
    visaAssistanceData: {},
    error: "",
    isLoading: false,
    isError: false
};
var visa_assistance_reducers_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : visa_assistance_reducers_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case visa_assistance_constants/* default.FETCH_VISA_ASSISTANCE_DATA */.Z.FETCH_VISA_ASSISTANCE_DATA:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLoading: true,
                isError: false
            });
        case visa_assistance_constants/* default.FETCH_VISA_ASSISTANCE_DATA_SUCCESS */.Z.FETCH_VISA_ASSISTANCE_DATA_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                visaAssistanceData: action.payload,
                isLoading: false,
                isError: false
            });
        case visa_assistance_constants/* default.FETCH_VISA_ASSISTANCE_DATA_ERROR */.Z.FETCH_VISA_ASSISTANCE_DATA_ERROR:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                isLoading: false,
                isError: true
            });
        default:
            return state;
    }
};
/* harmony default export */ var visa_assistance_reducers = (visa_assistance_reducers_reducer);

;// CONCATENATED MODULE: ./components/Profile/RegistrationForm/redux/RegistrationFormReducer.ts


var RegistrationFormReducer_initialState = {
    initialFormValues: {},
    error: ""
};
var RegistrationFormReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : RegistrationFormReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "FETCH_INITIAL_FORM_VALUES_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                initialFormValues: action.payload
            });
        case "UPDATE_IELTS_REGISTRATION_FORM_ERROR":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var RegistrationFormReducer = (RegistrationFormReducer_reducer);

// EXTERNAL MODULE: ./components/Profile/CounsellingProfile/redux/constants/my-universities-constants.ts
var my_universities_constants = __webpack_require__(44211);
;// CONCATENATED MODULE: ./components/Profile/CounsellingProfile/redux/reducers/my-universities-reducers.ts



var my_universities_reducers_initialState = {
    isOpenApplicationDetailsView: false,
    selectedCollegeDetails: null
};
var my_universities_reducers_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : my_universities_reducers_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case my_universities_constants/* default.SHOW_APPLICATION_VIEW */.Z.SHOW_APPLICATION_VIEW:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isOpenApplicationDetailsView: true,
                selectedCollegeDetails: action.payload
            });
        case my_universities_constants/* default.HIDE_APPLICATION_VIEW */.Z.HIDE_APPLICATION_VIEW:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isOpenApplicationDetailsView: false
            });
        default:
            return state;
    }
};
/* harmony default export */ var my_universities_reducers = (my_universities_reducers_reducer);

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/Masterclass/redux/MasterclassReducer.ts


var MasterclassReducer_initialState = {
    subscriptionStatus: null,
    error: "",
    masterclassData: [],
    unsubscribedCtaText: "Subscribe For Free Masterclass",
    showEnrolledForm: false,
    showConfirmModal: false,
    beginnerMasterClass: [],
    userSubscriptionType: null,
    masterclassRecommendation: null
};
var masterclassReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : MasterclassReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "FETCH_MASTERCLASS_SUBSCRIPTION_STATUS_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                subscriptionStatus: action.payload
            });
        case "FETCH_MASTERCLASS_DATA_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                masterclassData: action.payload
            });
        case "FETCH_BEGINNER_MASTERCLASS_DATA_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                beginnerMasterClass: action.payload
            });
        case "UPDATE_UNSUBSCRIBED_MASTERCLASS_CTA_TEXT":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                unsubscribedCtaText: action.payload
            });
        case "TOGGLE_MASTERCLASS_ENROLL_MODAL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showEnrolledForm: action.payload
            });
        case "MASTERCLASS_CONFIRMATION_MODAL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showConfirmModal: action.payload
            });
        case "SET_MASTERCLASS_SUBSCRIPTION_STATUS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                subscriptionStatus: action.payload
            });
        case "FETCH_FREE_IELTS_COURSE_STATUS_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                userSubscriptionType: action.payload
            });
        case "FETCH_MASTERCLASS_RECOMMENDATION_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                masterclassRecommendation: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var MasterclassReducer = (masterclassReducer);

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/IeltsTest/redux/IeltsTestReducer.ts


var IeltsTestReducer_initialState = {
    showTestForm: false,
    status: "",
    showIeltsSubmissionSection: false,
    submissionTime: "",
    showSubmittedDocsModal: false,
    screen: "",
    rewardsArray: null,
    userStatus: false,
    showIeltsTestBanner: false
};
var IeltsTestReducer_mockTestReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : IeltsTestReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "TOGGLE_IELTS_TEST_FORM":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showTestForm: action.payload
            });
        case "UPDATE_IELTS_TEST_SUBMISSION_STATUS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                status: action.payload
            });
        case "TOGGLE_SHOW_IELTS_TEST_SUBMISSION_SECTION":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showIeltsSubmissionSection: action.payload
            });
        case "UPDATE_SUBMISSION_TIME":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                submissionTime: action.payload
            });
        case "TOGGLE_SHOW_SUBMITTED_DOCS_MODAL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showSubmittedDocsModal: action.payload
            });
        case "SET_SCREEN":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                screen: action.payload
            });
        case "SET_REWARDS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                rewardsArray: action.payload
            });
        case "SET_USER_STATUS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                userStatus: action.payload
            });
        case "FETCH_IELTS_TEST_BANNER_STATUS_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showIeltsTestBanner: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var IeltsTestReducer = (IeltsTestReducer_mockTestReducer);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./components/Onboarding/redux/OnboardingActions.ts
var OnboardingActions = __webpack_require__(4421);
;// CONCATENATED MODULE: ./components/Onboarding/redux/OnboardingReducer.ts






var OnboardingReducer_initialState = {
    currentTab: "",
    addedCountries: [],
    removedCountries: [],
    initialCountry: "Canada",
    isEditMode: false,
    activeStep: null,
    completedSteps: [],
    isOpenSkipModal: false,
    percentCompletionList: [
        "5",
        "10",
        "50",
        "80",
        "100"
    ],
    progressCompleted: [],
    preparationStage: "",
    currentProgress: Number(0),
    countryFormData: [],
    isCheckingForm: false,
    isFormValidated: false,
    firstStepError: false,
    initialData: {},
    educationDetailsFormData: {
        highestLevelEducation: "",
        educationDetails: []
    },
    preferredLocations: [],
    examDetails: {},
    isValidatedEducation: null,
    isCheckingEduForm: false,
    deletedCountryId: Number(-1),
    isCheckingExamForm: false,
    isValidatedExamForm: null,
    isOpenSuccessModal: false,
    citiesData: [],
    isSubmittingCountryForm: false,
    stepsCompleted: 0,
    preferredProgramCourses: [],
    preferredCountryIds: [],
    initialPreferredCourses: [],
    initialPreferredLocations: [],
    isNextClicked: false,
    isIeltsRequired: false,
    isIeltsNotInitiated: false
};
var OnboardingReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : OnboardingReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case OnboardingActions/* onboardingActionConstants.ADD_COUNTRY */.j.ADD_COUNTRY:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                addedCountries: (0,_to_consumable_array/* default */.Z)(state.addedCountries).concat([
                    action.payload
                ]),
                currentTab: action.payload
            });
        case OnboardingActions/* onboardingActionConstants.DELETE_COUNTRY */.j.DELETE_COUNTRY:
            var updatedCountries = (0,_to_consumable_array/* default */.Z)(state.countryFormData.filter(function(c) {
                return c.country !== action.payload;
            }));
            var availableCountries = (0,_to_consumable_array/* default */.Z)(state.addedCountries.filter(function(c) {
                return c != action.payload;
            }));
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                countryFormData: (0,_to_consumable_array/* default */.Z)(updatedCountries),
                addedCountries: (0,_to_consumable_array/* default */.Z)(state.addedCountries.filter(function(c) {
                    return c != action.payload;
                })),
                removedCountries: (0,_to_consumable_array/* default */.Z)(state.removedCountries).concat([
                    action.payload
                ]),
                currentTab: availableCountries[availableCountries.length - 1]
            });
        case OnboardingActions/* onboardingActionConstants.SET_EDIT_MODE */.j.SET_EDIT_MODE:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isEditMode: action.payload
            });
        case OnboardingActions/* onboardingActionConstants.HANDLE_STEP */.j.HANDLE_STEP:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                activeStep: action.payload
            });
        case OnboardingActions/* onboardingActionConstants.SET_COMPLETE */.j.SET_COMPLETE:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                completedSteps: (0,_to_consumable_array/* default */.Z)(state.completedSteps).concat([
                    action.payload
                ])
            });
        case OnboardingActions/* onboardingActionConstants.TOGGLE_SKIP_MODAL */.j.TOGGLE_SKIP_MODAL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isOpenSkipModal: !state.isOpenSkipModal
            });
        case OnboardingActions/* onboardingActionConstants.CHECK_FORM */.j.CHECK_FORM:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isCheckingForm: action.payload
            });
        case OnboardingActions/* onboardingActionConstants.HANDLE_TAB_SELECT */.j.HANDLE_TAB_SELECT:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                currentTab: action.payload
            });
        case OnboardingActions/* onboardingActionConstants.SET_FIRST_STEP_DATA */.j.SET_FIRST_STEP_DATA:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                preparationStage: action.payload
            });
        case OnboardingActions/* onboardingActionConstants.SET_PREPARATION_STAGE */.j.SET_PREPARATION_STAGE:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                preparationStage: action.payload
            });
        case OnboardingActions/* onboardingActionConstants.SET_CURRENT_PROGRESS */.j.SET_CURRENT_PROGRESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                currentProgress: state.stepsCompleted > action.payload ? state.stepsCompleted : action.payload
            });
        case OnboardingActions/* onboardingActionConstants.SET_COUNTRY_FORM_DATA */.j.SET_COUNTRY_FORM_DATA:
            var ref, ref1, ref2;
            var index = (ref = state.countryFormData) === null || ref === void 0 ? void 0 : ref.findIndex(function(item) {
                return item.country == (action === null || action === void 0 ? void 0 : action.payload.country);
            });
            var newArray = (0,_to_consumable_array/* default */.Z)(state.countryFormData);
            if (index >= 0) {
                newArray[index] = action.payload;
            } else {
                newArray.push(action.payload);
            }
            for(var i = 0; i < (newArray === null || newArray === void 0 ? void 0 : newArray.length); i++){
                var ref3, ref4, ref5, ref6, ref7, ref8, ref9;
                newArray[i].preferredCourses = (ref3 = action.payload) === null || ref3 === void 0 ? void 0 : ref3.preferredCourses;
                newArray[i].preferredLocations = (ref4 = action.payload) === null || ref4 === void 0 ? void 0 : ref4.preferredLocations;
                newArray[i].budget = (ref5 = action.payload) === null || ref5 === void 0 ? void 0 : ref5.budget;
                newArray[i].courseDuration = (ref6 = action.payload) === null || ref6 === void 0 ? void 0 : ref6.courseDuration;
                newArray[i].noLocationPreference = (ref7 = action.payload) === null || ref7 === void 0 ? void 0 : ref7.noLocationPreference;
                newArray[i].preferredIntake = (ref8 = action.payload) === null || ref8 === void 0 ? void 0 : ref8.preferredIntake;
                newArray[i].preferredProgram = (ref9 = action.payload) === null || ref9 === void 0 ? void 0 : ref9.preferredProgram;
            }
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                countryFormData: (0,_to_consumable_array/* default */.Z)(newArray),
                initialPreferredCourses: (ref1 = action.payload) === null || ref1 === void 0 ? void 0 : ref1.preferredCourses,
                initialPreferredLocations: (ref2 = action.payload) === null || ref2 === void 0 ? void 0 : ref2.preferredLocations
            });
        case OnboardingActions/* onboardingActionConstants.SET_FORM_VALIDATION */.j.SET_FORM_VALIDATION:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isFormValidated: action.payload
            });
        case OnboardingActions/* onboardingActionConstants.HANDLE_NEXT_CLICKED */.j.HANDLE_NEXT_CLICKED:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isNextClicked: action.payload
            });
        case OnboardingActions/* onboardingActionConstants.SHOW_FIRST_STEP_ERROR */.j.SHOW_FIRST_STEP_ERROR:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                firstStepError: action.payload
            });
        case OnboardingActions/* onboardingActionConstants.FETCH_INITIAL_DATA_SUCCESS */.j.FETCH_INITIAL_DATA_SUCCESS:
            var ref10, ref11, ref12;
            var countriesData = (ref10 = cloneDeep_default()(action.payload.countriesInterestedIn)) === null || ref10 === void 0 ? void 0 : ref10.reduce(function(a, c) {
                a["preferredProgram"] = cloneDeep_default()(c.preferredProgram);
                a["preferredIntake"] = cloneDeep_default()(c.preferredIntake);
                a["budget"] = cloneDeep_default()(c.budget);
                a["countryId"] = cloneDeep_default()(c.countryId);
                a["courseDuration"] = cloneDeep_default()(c.courseDuration);
                a["preferredLocations"] = cloneDeep_default()(c.preferredLocations);
                a["preferredCourses"] = cloneDeep_default()(c.preferredCourses);
                return a;
            }, {});
            var countryData = [];
            var countries = [];
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                initialData: action.payload,
                educationDetailsFormData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.educationDetailsFormData), {
                    educationDetails: action.payload.educationDetails,
                    highestLevelEducation: action.payload.highestLevelEducation
                }),
                examDetails: action.payload.examDetails,
                preparationStage: action.payload.preparationStage,
                countryFormData: countryData,
                initialPreferredCourses: (ref11 = countryData[0]) === null || ref11 === void 0 ? void 0 : ref11.preferredCourses,
                initialPreferredLocations: (ref12 = countryData[0]) === null || ref12 === void 0 ? void 0 : ref12.preferredLocations,
                addedCountries: countries,
                countryDetails: countriesData,
                currentTab: countries[0],
                examData: {
                    gapYears: action.payload.gapYears,
                    passportStatus: action.payload.passportStatus,
                    totalWorkExperience: action.payload.totalWorkExperience,
                    proofOfEmploymentHistory: action.payload.proofOfEmploymentHistory
                },
                stepsCompleted: action.payload.stepsCompleted
            });
        case OnboardingActions/* onboardingActionConstants.SET_HIGHEST_EDUCATION */.j.SET_HIGHEST_EDUCATION:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                educationDetailsFormData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.educationDetailsFormData), {
                    highestLevelEducation: action.payload.status
                })
            });
        case OnboardingActions/* onboardingActionConstants.VALIDATE_EDUCATION_FORM */.j.VALIDATE_EDUCATION_FORM:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isValidatedEducation: action.payload
            });
        case OnboardingActions/* onboardingActionConstants.CHECK_EDUCATION_FORM */.j.CHECK_EDUCATION_FORM:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isCheckingEduForm: action.payload
            });
        case OnboardingActions/* onboardingActionConstants.GET_PREFERRED_PROGRAM_COURSE_LISTS_SUCCESS */.j.GET_PREFERRED_PROGRAM_COURSE_LISTS_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                preferredProgramCourses: action.payload
            });
        case OnboardingActions/* onboardingActionConstants.GET_PREFERRED_LOCATION_LISTS_SUCCESS */.j.GET_PREFERRED_LOCATION_LISTS_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                preferredLocations: action.payload
            });
        case OnboardingActions/* onboardingActionConstants.GET_PREFERRED_COUNTRY_ID_LISTS_SUCCESS */.j.GET_PREFERRED_COUNTRY_ID_LISTS_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                preferredCountryIds: action.payload
            });
        case OnboardingActions/* onboardingActionConstants.SET_EDUCATION_FORM_DATA */.j.SET_EDUCATION_FORM_DATA:
            if (action.payload.length == 2) {
                var ref13, ref14;
                var _payload = (0,_sliced_to_array/* default */.Z)(action.payload, 2), a = _payload[0], b = _payload[1];
                var ref15;
                var UpdatedEducationDetails = (0,_to_consumable_array/* default */.Z)((ref15 = (ref13 = state.educationDetailsFormData) === null || ref13 === void 0 ? void 0 : ref13.educationDetails) !== null && ref15 !== void 0 ? ref15 : []);
                UpdatedEducationDetails = (ref14 = state.educationDetailsFormData) === null || ref14 === void 0 ? void 0 : ref14.educationDetails.map(function(item) {
                    return item.educationLevel == (a === null || a === void 0 ? void 0 : a.educationLevel) ? a : item;
                });
                UpdatedEducationDetails = UpdatedEducationDetails.map(function(item) {
                    return item.educationLevel == (b === null || b === void 0 ? void 0 : b.educationLevel) ? b : item;
                });
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    educationDetailsFormData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.educationDetailsFormData), {
                        educationDetails: UpdatedEducationDetails
                    })
                });
            } else if (action.payload.educationLevel == "TWELFTH") {
                var ref16, ref17;
                var ref18;
                var UpdatedEducationDetails1 = (0,_to_consumable_array/* default */.Z)((ref18 = (ref16 = state.educationDetailsFormData) === null || ref16 === void 0 ? void 0 : ref16.educationDetails) !== null && ref18 !== void 0 ? ref18 : []);
                UpdatedEducationDetails1 = (ref17 = state.educationDetailsFormData) === null || ref17 === void 0 ? void 0 : ref17.educationDetails.map(function(item) {
                    var ref;
                    return item.educationLevel == ((ref = action.payload) === null || ref === void 0 ? void 0 : ref.educationLevel) ? action.payload : item;
                });
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    educationDetailsFormData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.educationDetailsFormData), {
                        educationDetails: UpdatedEducationDetails1
                    })
                });
            } else {
                var ref19;
                var ref20;
                var UpdatedEducationDetails2 = (0,_to_consumable_array/* default */.Z)((ref20 = (ref19 = state.educationDetailsFormData) === null || ref19 === void 0 ? void 0 : ref19.educationDetails) !== null && ref20 !== void 0 ? ref20 : []);
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    educationDetailsFormData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.educationDetailsFormData), {
                        educationDetails: UpdatedEducationDetails2
                    })
                });
            }
        case OnboardingActions/* onboardingActionConstants.SUBMIT_EDUCATION_DETAILS_SUCCESS */.j.SUBMIT_EDUCATION_DETAILS_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isCheckingEduForm: action.payload
            });
        case OnboardingActions/* onboardingActionConstants.SUBMIT_COLLEGE_FORMS_SUCCESS */.j.SUBMIT_COLLEGE_FORMS_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isSubmittingCountryForm: false
            });
        case OnboardingActions/* onboardingActionConstants.SUBMIT_PREPARATION_STAGE_SUCCESS */.j.SUBMIT_PREPARATION_STAGE_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                preparationStage: action.payload
            });
        case OnboardingActions/* onboardingActionConstants.CHECK_EXAM_FORM */.j.CHECK_EXAM_FORM:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isCheckingExamForm: action.payload
            });
        case OnboardingActions/* onboardingActionConstants.TOGGLE_SUCCESS_MODAL */.j.TOGGLE_SUCCESS_MODAL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isOpenSuccessModal: !state.isOpenSuccessModal
            });
        case OnboardingActions/* onboardingActionConstants.FETCH_CITY_FROM_COUNTRY_SUCCESS */.j.FETCH_CITY_FROM_COUNTRY_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                citiesData: action.payload
            });
        case OnboardingActions/* onboardingActionConstants.FETCH_CITY_FROM_COUNTRY_ERROR */.j.FETCH_CITY_FROM_COUNTRY_ERROR:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                citiesData: []
            });
        case OnboardingActions/* onboardingActionConstants.DELETE_COUNTRY_FROM_FORM_DATA_SUCCESS */.j.DELETE_COUNTRY_FROM_FORM_DATA_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                deletedCountryId: action.payload
            });
        case OnboardingActions/* onboardingActionConstants.DELETE_COUNTRY_FROM_FORM_DATA_ERROR */.j.DELETE_COUNTRY_FROM_FORM_DATA_ERROR:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                deletedCountryId: state.deletedCountryId
            });
        case OnboardingActions/* onboardingActionConstants.SET_SUBMITTING_COUNTRY_FORM */.j.SET_SUBMITTING_COUNTRY_FORM:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isSubmittingCountryForm: action.payload
            });
        case OnboardingActions/* onboardingActionConstants.IELTS_REQUIRED */.j.IELTS_REQUIRED:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isIeltsRequired: action.payload
            });
        case OnboardingActions/* onboardingActionConstants.IELTS_STATUS */.j.IELTS_STATUS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isIeltsNotInitiated: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var OnboardingReducer = (OnboardingReducer_reducer);

// EXTERNAL MODULE: ./components/Profile/IeltsProfile/Certificates/redux/CertificateAction.ts
var CertificateAction = __webpack_require__(97909);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/Certificates/redux/CertificateReducer.ts



var CertificateReducer_initialState = {
    certificateData: null,
    error: ""
};
var CertificateReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : CertificateReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case CertificateAction/* certificateActionType.FETCH_CERTIFICATE_SUCCESS */.y.FETCH_CERTIFICATE_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                certificateData: action.payload
            });
        case CertificateAction/* certificateActionType.FETCH_CERTIFICATE_FAIL */.y.FETCH_CERTIFICATE_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        case CertificateAction/* certificateActionType.CLEAR_ERROR_MESSAGE */.y.CLEAR_ERROR_MESSAGE:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: ""
            });
        default:
            return state;
    }
};
/* harmony default export */ var CertificateReducer = (CertificateReducer_reducer);

// EXTERNAL MODULE: ./components/DocumentsUpload/redux/DocumentUploadActions.ts
var DocumentUploadActions = __webpack_require__(96050);
;// CONCATENATED MODULE: ./components/DocumentsUpload/redux/DocumentUploadReducer.ts




var DocumentUploadReducer_initialState = {
    highestEducation: null,
    initialData: {},
    viewUrl: "",
    highestEducationData: {},
    uploadRes: null,
    isDeleted: false,
    filterStatus: "ALL_DOCUMENTS",
    englishExamType: ""
};
var DocumentUploadReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : DocumentUploadReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case DocumentUploadActions/* documentUploadActionConstants.FETCH_DOCUMENT_DATA */.N.FETCH_DOCUMENT_DATA:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                data: action.payload
            });
        case DocumentUploadActions/* documentUploadActionConstants.FETCH_DOCUMENT_DATA_SUCCESS */.N.FETCH_DOCUMENT_DATA_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                data: action.payload,
                initialData: action.payload
            });
        case DocumentUploadActions/* documentUploadActionConstants.VIEW_DOCUMENT_SUCCESS */.N.VIEW_DOCUMENT_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                viewUrl: action.payload
            });
        case DocumentUploadActions/* documentUploadActionConstants.ADD_HIGHEST_EDUCATION_SUCCESS */.N.ADD_HIGHEST_EDUCATION_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                initialData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.initialData), {
                    educationDocuments: action.payload
                })
            });
        case DocumentUploadActions/* documentUploadActionConstants.UPLOAD_DOCUMENT_SUCCESS */.N.UPLOAD_DOCUMENT_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                uploadRes: action.payload
            });
        case DocumentUploadActions/* documentUploadActionConstants.FILTER_DOCUMENTS */.N.FILTER_DOCUMENTS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                filterStatus: action.payload
            });
        case DocumentUploadActions/* documentUploadActionConstants.DELETE_DOCUMENT_SUCCESS */.N.DELETE_DOCUMENT_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isDeleted: action.payload
            });
        case DocumentUploadActions/* documentUploadActionConstants.DELETE_DOCUMENT */.N.DELETE_DOCUMENT:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isDeleted: false
            });
        case DocumentUploadActions/* documentUploadActionConstants.ADD_MISC_DOCUMENT_SUCCESS */.N.ADD_MISC_DOCUMENT_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                initialData: action.payload
            });
        case DocumentUploadActions/* documentUploadActionConstants.ADD_FILE_LABEL */.N.ADD_FILE_LABEL:
            var ref;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                initialData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.initialData), {
                    //@ts-ignore
                    miscellaneousDocuments: (state === null || state === void 0 ? void 0 : (ref = state.initialData) === null || ref === void 0 ? void 0 : ref.miscellaneousDocuments) ? (0,_to_consumable_array/* default */.Z)(state.initialData.miscellaneousDocuments).concat([
                        action.payload
                    ]) : [
                        action.payload
                    ]
                })
            });
        case DocumentUploadActions/* documentUploadActionConstants.EDIT_TITLE */.N.EDIT_TITLE:
            var newArray = (0,_object_spread/* default */.Z)({}, state.initialData);
            var splitData = Object.entries(newArray);
            var filData = splitData.filter(function(item) {
                if (item[0] === "miscellaneousDocuments") {
                    return item;
                }
            });
            var UpdatedData = (0,_to_consumable_array/* default */.Z)(filData[0][1]).concat([
                action.payload
            ]);
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                initialData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.initialData), {
                    miscellaneousDocuments: UpdatedData
                })
            });
        case DocumentUploadActions/* documentUploadActionConstants.SELECT_ENGLISH_EXAM_TYPE_SUCCESS */.N.SELECT_ENGLISH_EXAM_TYPE_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                initialData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.initialData), {
                    englishProficiencyExamDocuments: action.payload
                })
            });
        case DocumentUploadActions/* documentUploadActionConstants.EDIT_MISC_TITLE */.N.EDIT_MISC_TITLE:
            var savedData = (0,_object_spread/* default */.Z)({}, action.payload);
            var newArray2 = (0,_object_spread/* default */.Z)({}, state.initialData);
            var splitData2 = Object.entries(newArray2);
            var filData2 = splitData2.filter(function(item) {
                if (item[0] === "miscellaneousDocuments") {
                    return item;
                }
            });
            var b = filData2[0][1];
            var UpdatedData2 = b.map(function(item) {
                return item.fileLabel == (savedData === null || savedData === void 0 ? void 0 : savedData.toBeEditedTitle) ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                    fileLabel: savedData === null || savedData === void 0 ? void 0 : savedData.updatedTitle
                }) : item;
            });
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                initialData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.initialData), {
                    miscellaneousDocuments: UpdatedData2
                })
            });
        default:
            return state;
    }
};
/* harmony default export */ var DocumentUploadReducer = (DocumentUploadReducer_reducer);

;// CONCATENATED MODULE: ./components/Ielts/Reviews/redux/ReviewsReducer.ts



var ReviewsReducer_initialState = {
    testimonialData: [],
    videoReviews: [],
    interviewData: []
};
var reviewReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ReviewsReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case es6/* HYDRATE */.ju:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                testimonialData: action.payload.review.testimonialData,
                videoReviews: action.payload.review.videoReviews,
                interviewData: action.payload.review.interviewData
            });
        case "FETCH_IELTS_REVIEWS_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                testimonialData: action.payload["Testimonial"] || [],
                videoReviews: action.payload["Video"] || [],
                interviewData: action.payload["Interview"] || []
            });
        default:
            return state;
    }
};
/* harmony default export */ var ReviewsReducer = (reviewReducer);

;// CONCATENATED MODULE: ./components/MeetCounsellerVirtualOffice/redux/MeetCounsellerReducer.ts


var MeetCounsellerReducer_initialState = {
    expertsData: [],
    error: null,
    stage: null,
    slots: [],
    isEnrolled: false,
    isLoadingSlots: false,
    meetProfileData: null,
    isSubmittedMeetProfile: false,
    isLiveSlotAvailable: null,
    liveSlot: null,
    typedSlots: [],
    visaCounsellorSlot: []
};
var MeetCounsellerReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : MeetCounsellerReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "FETCH_EXPERTS_DATA":
            return (0,_object_spread/* default */.Z)({}, state);
        case "FETCH_EXPERTS_DATA_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                expertsData: action.payload
            });
        case "FETCH_EXPERTS_DATA_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                expertsData: []
            });
        case "FETCH_STAGE":
            return (0,_object_spread/* default */.Z)({}, state);
        case "FETCH_STAGE_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                stage: action.payload
            });
        case "FETCH_STAGE_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                stage: null
            });
        case "FETCH_MEET_COUNSELLER_SLOT":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                slots: [],
                isLoadingSlots: true
            });
        case "FETCH_MEET_COUNSELLER_SLOT_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                slots: action.payload.calendarResponses,
                isLoadingSlots: false,
                isLiveSlotAvailable: action.payload.liveSlotAvailable,
                liveSlot: action.payload.liveSlot
            });
        case "FETCH_MEET_COUNSELLER_SLOT_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                slots: [],
                isLoadingSlots: false,
                liveSlot: null,
                isLiveSlotAvailable: false
            });
        case "FETCH_TYPED_MEET_COUNSELLER_SLOT":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                typedSlots: [],
                isLoadingSlots: true
            });
        case "FETCH_TYPED_MEET_COUNSELLER_SLOT_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                typedSlots: action.payload.calendarResponses,
                isLoadingSlots: false,
                isLiveSlotAvailable: action.payload.liveSlotAvailable,
                liveSlot: action.payload.liveSlot
            });
        case "FETCH_TYPED_MEET_COUNSELLER_SLOT_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                typedSlots: [],
                isLoadingSlots: false,
                liveSlot: null,
                isLiveSlotAvailable: false
            });
        case "FETCH_VISA_COUNSELLER_SLOT":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                visaCounsellorSlot: [],
                isLoadingSlots: true
            });
        case "FETCH_VISA_COUNSELLER_SLOT_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                visaCounsellorSlot: action.payload.calendarResponses,
                isLoadingSlots: false,
                isLiveSlotAvailable: action.payload.liveSlotAvailable,
                liveSlot: action.payload.liveSlot
            });
        case "FETCH_VISA_COUNSELLER_SLOT_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                visaCounsellorSlot: [],
                isLoadingSlots: false,
                liveSlot: null,
                isLiveSlotAvailable: false
            });
        case "CONFIRM_MEET_COUNSELLER_SLOT_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isEnrolled: true
            });
        case "CONFIRM_MEET_COUNSELLER_SLOT_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isEnrolled: false,
                error: action.payload
            });
        case "CONFIRM_MEET_COUNSELLER_SLOT":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: null,
                isEnrolled: false
            });
        case "CONFIRM_RESCHEDULE_SLOT_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isEnrolled: action.payload
            });
        case "CONFIRM_RESCHEDULE_SLOT_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isEnrolled: false,
                error: action.payload
            });
        case "CONFIRM_RESCHEDULE_SLOT":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: null,
                isEnrolled: false
            });
        case "FETCH_MEET_PROFILE":
            return (0,_object_spread/* default */.Z)({}, state);
        case "FETCH_MEET_PROFILE_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                meetProfileData: action.payload
            });
        case "FETCH_MEET_PROFILE_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                meetProfileData: null
            });
        case "SUBMIT_MEET_PROFILE":
            return (0,_object_spread/* default */.Z)({}, state);
        case "SUBMIT_MEET_PROFILE_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isSubmittedMeetProfile: action.payload
            });
        case "SUBMIT_MEET_PROFILE_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var MeetCounsellerReducer = (MeetCounsellerReducer_reducer);

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/Stories/redux/StoriesReducer.ts


var StoriesReducer_initialState = {
    stories: [],
    activeCategory: null,
    activeStory: null,
    showStory: false
};
var StoriesReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : StoriesReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "FETCH_STORIES_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                stories: action.payload
            });
        case "UPDATE_ACTIVE_CATEGORY":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                activeCategory: action.payload
            });
        case "UPDATE_ACTIVE_STORY":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                activeStory: action.payload
            });
        case "TOGGLE_SHOW_STORY":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showStory: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var StoriesReducer = (StoriesReducer_reducer);

;// CONCATENATED MODULE: ./components/Profile/StudentDashbord/IeltsScreenController/redux/IeltsScreenControllerReducer.ts


var IeltsScreenControllerReducer_initialState = {
    activeTab: null,
    isLoading: false,
    userStates: null,
    demoDetails: null,
    userIeltsDetails: null,
    userPaymentInfo: null,
    ieltsStage: undefined,
    i2cEligibile: null
};
var ieltsScreenControllerReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : IeltsScreenControllerReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "SET_IELTS_SCREEN":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                activeTab: action.payload
            });
        case "SET_USER_STATES":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                userStates: action.payload
            });
        case "SET_DEMO_DETAILS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                demoDetails: action.payload
            });
        case "FETCH_USER_IELTS_DETAILS_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                userIeltsDetails: action.payload
            });
        case "FETCH_USER_PAYMENT_INFO_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                userPaymentInfo: action.payload
            });
        case "FETCH_USER_IELTS_ELITE_STAGE_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                ieltsStage: action.payload
            });
        case "FETCH_USER_I2C_ELIGIBILITY_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                i2cEligibile: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var IeltsScreenControllerReducer = (ieltsScreenControllerReducer);

// EXTERNAL MODULE: ./components/Ielts/BatchDetails/RequestCallBackForm/redux/RequestCallBackFormSlice.ts
var RequestCallBackFormSlice = __webpack_require__(4014);
// EXTERNAL MODULE: ./components/Ielts/AiEvaluation/redux/AiEvalutionAction.ts
var AiEvalutionAction = __webpack_require__(98656);
;// CONCATENATED MODULE: ./components/Ielts/AiEvaluation/redux/AiEvalutionReducer.ts



var AiEvalutionReducer_initialState = {
    error: "",
    isAlreadyPaid: null,
    showForm: false,
    showLoader: false,
    purchaseType: null,
    smartTestsPrice: null,
    smartTestsProgressStatus: null
};
var AiEvalutionReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : AiEvalutionReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "GET_AI_EVALUTION_TOKEN":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showLoader: true
            });
        case "GET_AI_EVALUTION_TOKEN_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showLoader: false
            });
        case "GET_AI_EVALUTION_TOKEN_FAil":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                showLoader: false
            });
        case "AI_EVALUTION_ALREADY_PAID_SUCCESS":
            var ref;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isAlreadyPaid: (ref = action.payload) === null || ref === void 0 ? void 0 : ref.alreadyPaid
            });
        case "AI_EVALUTION_ALREADY_PAID_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        case "AI_EVALUATION_PURCHASE_TYPE":
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    purchaseType: action.payload
                });
            }
        case "TOGGLE_AI_EVALUATION_SHOW_FORM":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showForm: action.payload
            });
        case "TOGGLE_AI_EVALUATION_SHOW_LOADER":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showLoader: action.payload
            });
        case "UPDATE_ERROR":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        case AiEvalutionAction/* AiEvaluationActionTypes.GET_SMART_TEST_PRICE_SUCCESS */.x.GET_SMART_TEST_PRICE_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                smartTestsPrice: action.payload
            });
        case AiEvalutionAction/* AiEvaluationActionTypes.GET_SMART_TESTS_PROGRESS_STATUS_SUCCESS */.x.GET_SMART_TESTS_PROGRESS_STATUS_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                smartTestsProgressStatus: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var AiEvalutionReducer = (AiEvalutionReducer_reducer);

// EXTERNAL MODULE: ./components/Profile/IeltsProfile/Masterclass/MasterclassReplays/redux/MasterclassReplaysActions.ts
var MasterclassReplaysActions = __webpack_require__(40441);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/Masterclass/MasterclassReplays/redux/MasterclassReplaysReducer.ts



var MasterclassReplaysReducer_initialState = {
    replaysData: null,
    showModal: false,
    error: "",
    resumeVideo: null
};
var masterclassReplaysReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : MasterclassReplaysReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case MasterclassReplaysActions/* masterclassReplaysActionType.FETCH_MASTERCLASS_REPLAYS */.q.FETCH_MASTERCLASS_REPLAYS:
            return (0,_object_spread/* default */.Z)({}, state);
        case MasterclassReplaysActions/* masterclassReplaysActionType.FETCH_MASTERCLASS_REPLAYS_SUCCESS */.q.FETCH_MASTERCLASS_REPLAYS_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                replaysData: action.payload
            });
        case MasterclassReplaysActions/* masterclassReplaysActionType.TOGGLE_SUBSCRIPTION_MODAL */.q.TOGGLE_SUBSCRIPTION_MODAL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showModal: action.payload
            });
        case MasterclassReplaysActions/* masterclassReplaysActionType.RESUME_VIDEO_AFTER_SUBSCRIBE */.q.RESUME_VIDEO_AFTER_SUBSCRIBE:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                resumeVideo: action.payload
            });
        case MasterclassReplaysActions/* masterclassReplaysActionType.UPDATE_ERROR */.q.UPDATE_ERROR:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var MasterclassReplaysReducer = (masterclassReplaysReducer);

// EXTERNAL MODULE: ./components/Ielts/SemLanding/redux/SemLandingAction.ts
var SemLandingAction = __webpack_require__(50501);
;// CONCATENATED MODULE: ./components/Ielts/SemLanding/redux/SemLandingReducer.ts



var SemLandingReducer_initialState = {
    semPageDetails: null,
    error: "",
    loader: true,
    isModalOpen: false
};
var SemLandingReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : SemLandingReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case SemLandingAction/* actionConstant.SEM_PAGE_DETAIL_REQUEST */.L.SEM_PAGE_DETAIL_REQUEST:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loader: true
            });
        case SemLandingAction/* actionConstant.SEM_PAGE_DETAIL_SUCCESS */.L.SEM_PAGE_DETAIL_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loader: false,
                semPageDetails: action.payload
            });
        case SemLandingAction/* actionConstant.UPDATE_ERROR */.L.UPDATE_ERROR:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        case SemLandingAction/* actionConstant.TOGGEL_MODAL */.L.TOGGEL_MODAL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isModalOpen: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var SemLandingReducer = (SemLandingReducer_reducer);

// EXTERNAL MODULE: ./components/Profile/IeltsProfile/QuizSection/redux/QuizType.ts
var QuizType = __webpack_require__(16433);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/QuizSection/redux/QuizReducer.ts



var QuizReducer_initialState = {
    error: "",
    isLoading: false,
    quizList: [],
    activeQuestionId: null,
    activeQuizId: null,
    completeQuizList: [],
    newQuizList: [],
    ieltsQuizQuestionList: [],
    quizStatus: null,
    submittedQuestionsList: [],
    attemptId: null,
    isSubmitModalOpen: false,
    isExitModalOpen: false,
    submitSuccessfully: false,
    quizStartTime: null,
    quizEndTime: null,
    quizTitle: "",
    quizModalType: null,
    QuizBundleList: null
};
var QuizReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : QuizReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case QuizType/* QuizType.FETCH_QUIZ_LIST */.p.FETCH_QUIZ_LIST:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLoading: true
            });
        case QuizType/* QuizType.FETCH_QUIZ_LIST_SUCCESS */.p.FETCH_QUIZ_LIST_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLoading: false,
                quizList: action.payload
            });
        case QuizType/* QuizType.UPDATE_ERROR */.p.UPDATE_ERROR:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLoading: false,
                error: action.payload
            });
        case QuizType/* QuizType.UPDATE_COMPLETE_QUIZ_LIST */.p.UPDATE_COMPLETE_QUIZ_LIST:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                completeQuizList: action.payload
            });
        case QuizType/* QuizType.UPDATE_NEW_QUIZ_LIST */.p.UPDATE_NEW_QUIZ_LIST:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                newQuizList: action.payload
            });
        case QuizType/* QuizType.FETCH_QUIZ_QUESTION_SUCCESS */.p.FETCH_QUIZ_QUESTION_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                ieltsQuizQuestionList: action.payload
            });
        case QuizType/* QuizType.UPDATE_ACTIVE_QUIZ_ID */.p.UPDATE_ACTIVE_QUIZ_ID:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                activeQuizId: action.payload
            });
        case QuizType/* QuizType.UPDATE_QUIZ_STATUS */.p.UPDATE_QUIZ_STATUS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                quizStatus: action.payload
            });
        case QuizType/* QuizType.UPDATE_SUBMITTED_ANS */.p.UPDATE_SUBMITTED_ANS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                submittedQuestionsList: action.payload
            });
        case QuizType/* QuizType.UPDATE_QUIZ_ATTEMPT_ID */.p.UPDATE_QUIZ_ATTEMPT_ID:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                attemptId: action.payload
            });
        case QuizType/* QuizType.UPDATE_SUBMIT_MODAL */.p.UPDATE_SUBMIT_MODAL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isSubmitModalOpen: action.payload
            });
        case QuizType/* QuizType.UPDATE_EXIT_MODAL */.p.UPDATE_EXIT_MODAL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isExitModalOpen: action.payload
            });
        case QuizType/* QuizType.QUIZ_UPDATE_START_TEST_DATE */.p.QUIZ_UPDATE_START_TEST_DATE:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                quizStartTime: action.payload
            });
        case QuizType/* QuizType.SUBMIT_SUCCESSFULLY_ACTION */.p.SUBMIT_SUCCESSFULLY_ACTION:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                submitSuccessfully: action.payload
            });
        case QuizType/* QuizType.QUIZ_UPDATE_END_TEST_DATE */.p.QUIZ_UPDATE_END_TEST_DATE:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                quizEndTime: action.payload
            });
        case QuizType/* QuizType.UPDATE_QUIZ_TITLE */.p.UPDATE_QUIZ_TITLE:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                quizTitle: action.payload
            });
        case QuizType/* QuizType.FETCH_QUIZ_MODAL_TYPE_SUCCESS */.p.FETCH_QUIZ_MODAL_TYPE_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                quizModalType: action.payload
            });
        case QuizType/* QuizType.FETCH_QUIZ_BUNDLE_TYPE_SUCCESS */.p.FETCH_QUIZ_BUNDLE_TYPE_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                QuizBundleList: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var QuizReducer = (QuizReducer_reducer);

// EXTERNAL MODULE: ./components/Ielts/IeltsMasterclassType/redux/MasterClassTypeAction.tsx
var MasterClassTypeAction = __webpack_require__(6179);
;// CONCATENATED MODULE: ./components/Ielts/IeltsMasterclassType/redux/MasterClassTypeReducer.tsx



var MasterClassTypeReducer_initialState = {
    beginnerMasterClass: null,
    classicMasterClass: null,
    error: "",
    showLoader: false,
    hasAttendedMasterClass: false
};
var MasterClassTypeReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : MasterClassTypeReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case MasterClassTypeAction/* actionConstant.REQUEST_BEGINNER_MASTERCLASS_TYPE_DATA */.L.REQUEST_BEGINNER_MASTERCLASS_TYPE_DATA:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showLoader: true
            });
        case MasterClassTypeAction/* actionConstant.SUCCESS_BEGINNER_MASTERCLASS_TYPE_DATA */.L.SUCCESS_BEGINNER_MASTERCLASS_TYPE_DATA:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                beginnerMasterClass: action.payload,
                showLoader: false
            });
        case MasterClassTypeAction/* actionConstant.REQUEST_CLASSIC_MASTERCLASS_TYPE_DATA */.L.REQUEST_CLASSIC_MASTERCLASS_TYPE_DATA:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showLoader: true
            });
        case MasterClassTypeAction/* actionConstant.SUCCESS_CLASSIC_MASTERCLASS_TYPE_DATA */.L.SUCCESS_CLASSIC_MASTERCLASS_TYPE_DATA:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                classicMasterClass: action.payload,
                showLoader: false
            });
        case MasterClassTypeAction/* actionConstant.SET_MASTERCLASS_ATTEND_STATUS */.L.SET_MASTERCLASS_ATTEND_STATUS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                hasAttendedMasterClass: action.payload,
                showLoader: false
            });
        case MasterClassTypeAction/* actionConstant.UPDATE_ERROR */.L.UPDATE_ERROR:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var MasterClassTypeReducer = (MasterClassTypeReducer_reducer);

// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(27272);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/FoundationClass/redux/FoundationSlice.ts



var FoundationSlice_initialState = {
    isEnrolledInFoundation: null,
    foundationClass: [],
    myFoundationClass: []
};
var foundationSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "foundationClass",
    initialState: FoundationSlice_initialState,
    reducers: {
        setIsEnrolledInFoundation: function setIsEnrolledInFoundation(state, action) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isEnrolledInFoundation: action.payload
            });
        },
        setFoundationClass: function setFoundationClass(state, action) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                foundationClass: action.payload
            });
        },
        setMyFoundationClass: function setMyFoundationClass(state, action) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                myFoundationClass: action.payload
            });
        }
    }
});
var _actions = foundationSlice.actions;
var setFoundationClass = _actions.setFoundationClass, setIsEnrolledInFoundation = _actions.setIsEnrolledInFoundation, setMyFoundationClass = _actions.setMyFoundationClass;
/* harmony default export */ var FoundationSlice = (foundationSlice.reducer);

// EXTERNAL MODULE: ./components/Profile/IeltsProfile/JoinMasterClass/redux/joinMasterClassActions.ts
var joinMasterClassActions = __webpack_require__(21491);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/JoinMasterClass/redux/joinMasterClassReducer.ts



var joinMasterClassReducer_initialState = {
    startDate: "",
    endDate: "",
    meetingUrl: "",
    meetingStatus: "loading",
    title: "",
    workshopType: null,
    batchDay: null,
    slotType: null
};
var joinMasterClassReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : joinMasterClassReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case joinMasterClassActions/* joinMasterClassType.FETCH_REGISTERED_MEETING_DATA_SUCCESS */.t.FETCH_REGISTERED_MEETING_DATA_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                startDate: action.payload.startDate,
                endDate: action.payload.endDate,
                meetingUrl: action.payload.meetingUrl,
                title: action.payload.title,
                workshopType: action.payload.workshopType,
                batchDay: action.payload.batchDay
            });
        case joinMasterClassActions/* joinMasterClassType.SET_IELTS_DEMO_DATA */.t.SET_IELTS_DEMO_DATA:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                startDate: action.payload.startDate,
                endDate: action.payload.endDate,
                meetingUrl: action.payload.meetingUrl
            });
        case joinMasterClassActions/* joinMasterClassType.FETCH_REGISTERED_MEETING_DATA_FAIL */.t.FETCH_REGISTERED_MEETING_DATA_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                meetingStatus: action.payload
            });
        case joinMasterClassActions/* joinMasterClassType.CHANGE_MEETING_STATUS */.t.CHANGE_MEETING_STATUS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                meetingStatus: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var redux_joinMasterClassReducer = (joinMasterClassReducer);

// EXTERNAL MODULE: ./components/Profile/IeltsProfile/MockTest/MockTestLandingPage/redux/MockTestPriceSlice.ts
var MockTestPriceSlice = __webpack_require__(27412);
// EXTERNAL MODULE: ./components/Profile/IeltsProfile/IeltsPlus/SchedulePage/redux/schedulePageSlice.ts
var schedulePageSlice = __webpack_require__(57251);
// EXTERNAL MODULE: ./components/NeedHelpV1/redux/NeedHelpActions.ts
var NeedHelpActions = __webpack_require__(16902);
;// CONCATENATED MODULE: ./components/NeedHelpV1/redux/NeedHelpReducer.ts



var NeedHelpReducer_initialState = {
    responseSuccess: false,
    responseError: false,
    responseLoading: false
};
var NeedHelpReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : NeedHelpReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case NeedHelpActions/* chatActionsConstants.QUERY_RAISE_API */.Y.QUERY_RAISE_API:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                responseLoading: true,
                responseSuccess: false,
                responseError: false
            });
        case NeedHelpActions/* chatActionsConstants.QUERY_RAISE_API_SUCCESS */.Y.QUERY_RAISE_API_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                responseError: false,
                responseLoading: false,
                responseSuccess: true
            });
        case NeedHelpActions/* chatActionsConstants.QUERY_RAISE_API_ERROR */.Y.QUERY_RAISE_API_ERROR:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                responseError: true,
                responseLoading: false,
                responseSuccess: false
            });
        case NeedHelpActions/* chatActionsConstants.RESET_QUERY_STATE */.Y.RESET_QUERY_STATE:
            return NeedHelpReducer_initialState;
        default:
            return state;
    }
};
/* harmony default export */ var NeedHelpReducer = (NeedHelpReducer_reducer);

// EXTERNAL MODULE: ./components/Ielts/SelfPrepPrePayment/redux/selfPrepSlice.ts
var selfPrepSlice = __webpack_require__(73289);
;// CONCATENATED MODULE: ./components/TofuOnbordingForms/redux/Reducer.ts


var Reducer_initialState = {
    initialData: {},
    isLoading: false,
    isError: false,
    error: ""
};
var Reducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Reducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "FETCH_SPOT_FORM_DATA":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLoading: true,
                isError: false
            });
        case "FETCH_SPOT_FORM_DATA_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                initialData: action.payload,
                isLoading: false,
                isError: false
            });
        case "FETCH_SPOT_FORM_DATA_FAIL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLoading: false,
                isError: true,
                error: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var Reducer = (Reducer_reducer);

;// CONCATENATED MODULE: ./components/Payment/redux/PaymentReduxConstants.ts
/* harmony default export */ var PaymentReduxConstants = ({
    FETCH_USER_DATA_FOR_PAYMENT: "FETCH_USER_DATA_FOR_PAYMENT",
    FETCH_USER_DATA_FOR_PAYMENT_SUCCESS: "FETCH_USER_DATA_FOR_PAYMENT_SUCCESS",
    FETCH_USER_DATA_FOR_PAYMENT_ERROR: "FETCH_USER_DATA_FOR_PAYMENT_ERROR",
    FETCH_PAYMENT_DATA: "FETCH_PAYMENT_DATA",
    FETCH_PAYMENT_DATA_SUCCESS: "FETCH_PAYMENT_DATA_SUCCESS",
    FETCH_PAYMENT_DATA_ERROR: "FETCH_PAYMENT_DATA_ERROR",
    VALIDATE_PROMO_CODE: "VALIDATE_PROMO_CODE",
    VALIDATE_PROMO_CODE_SUCCESS: "VALIDATE_PROMO_CODE_SUCCESS",
    VALIDATE_PROMO_CODE_ERROR: "VALIDATE_PROMO_CODE_ERROR",
    // APPLY_PROMO_CODE:"APPLY_PROMO_CODE",
    INITIALIZE_PAYMENT: "INITIALIZE_PAYMENT",
    INITIALIZE_PAYMENT_SUCCESS: "INITIALIZE_PAYMENT_SUCCESS",
    INITIALIZE_PAYMENT_ERROR: "INITIALIZE_PAYMENT_ERROR"
});

;// CONCATENATED MODULE: ./components/Payment/redux/PaymentReducer.ts



var PaymentReducer_initialState = {
    userDetails: null,
    paymentDetails: null,
    promoDetails: null,
    error: "",
    isLoading: false,
    isError: false
};
var PaymentReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : PaymentReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case PaymentReduxConstants.FETCH_USER_DATA_FOR_PAYMENT:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLoading: true,
                isError: false
            });
        case PaymentReduxConstants.FETCH_USER_DATA_FOR_PAYMENT_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                userDetails: action.payload,
                isLoading: false,
                isError: false
            });
        case PaymentReduxConstants.FETCH_USER_DATA_FOR_PAYMENT_ERROR:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                isLoading: false,
                isError: true
            });
        case PaymentReduxConstants.FETCH_PAYMENT_DATA:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLoading: true,
                isError: false
            });
        case PaymentReduxConstants.FETCH_PAYMENT_DATA_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                paymentDetails: action.payload,
                isLoading: false,
                isError: false
            });
        case PaymentReduxConstants.FETCH_PAYMENT_DATA_ERROR:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                isLoading: false,
                isError: true
            });
        case PaymentReduxConstants.VALIDATE_PROMO_CODE:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLoading: true,
                isError: false
            });
        case PaymentReduxConstants.VALIDATE_PROMO_CODE_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                promoDetails: action.payload,
                isLoading: false,
                isError: false
            });
        case PaymentReduxConstants.VALIDATE_PROMO_CODE_ERROR:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                isLoading: false,
                isError: true
            });
        // case PaymentConstants.APPLY_PROMO_CODE:
        //   return {
        //     ...state,
        //     isLoading: true,
        //     isError: false,
        //     paymentDetails: {
        //       ...state.paymentDetails,
        //       offer: Math.floor(
        //         state.paymentDetails.offer -
        //           (state.promoDetails.discount / 100) * state.paymentDetails.offer
        //       ),
        //     },
        //   };
        case PaymentReduxConstants.INITIALIZE_PAYMENT:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLoading: true,
                isError: false
            });
        case PaymentReduxConstants.INITIALIZE_PAYMENT_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLoading: false,
                isError: false
            });
        case PaymentReduxConstants.INITIALIZE_PAYMENT_ERROR:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.payload,
                isLoading: false,
                isError: true
            });
        default:
            return state;
    }
};
/* harmony default export */ var PaymentReducer = (PaymentReducer_reducer);

// EXTERNAL MODULE: ./components/Profile/IeltsProfile/Orientation/redux/OrientationSlice.ts
var OrientationSlice = __webpack_require__(67461);
// EXTERNAL MODULE: ./components/Profile/AndroidApp/redux/PractiseAppSlice.ts
var PractiseAppSlice = __webpack_require__(52828);
// EXTERNAL MODULE: ./components/Profile/AndroidApp/PractiseTab/WordOfTheDay/redux/WordOfTheDaySlice.tsx
var WordOfTheDaySlice = __webpack_require__(27839);
// EXTERNAL MODULE: ./components/CounsellingCommunity/redux/CommunityConstants.ts
var CommunityConstants = __webpack_require__(58588);
;// CONCATENATED MODULE: ./components/CounsellingCommunity/redux/CommunityReducer.ts



var CommunityReducer_initialState = {
    isLoading: false,
    userDetailsWithToken: null,
    userGetSocialProfile: null,
    followedTopics: null,
    allTopics: null,
    timelinePosts: null,
    singleFeedData: null,
    searchPostsResults: null,
    suggestedPostsResults: null,
    isError: false,
    selectedTopicForFeed: null
};
var CommunityReducer_reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : CommunityReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case CommunityConstants/* default.SET_LOADING_TRUE */.Z.SET_LOADING_TRUE:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLoading: true
            });
        case CommunityConstants/* default.SET_LOADING_FALSE */.Z.SET_LOADING_FALSE:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLoading: false
            });
        case CommunityConstants/* default.FETCH_USER_GETSOCIAL_TOKEN */.Z.FETCH_USER_GETSOCIAL_TOKEN:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLoading: true
            });
        case CommunityConstants/* default.FETCH_USER_GETSOCIAL_TOKEN_SUCCESS */.Z.FETCH_USER_GETSOCIAL_TOKEN_SUCCESS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLoading: false,
                userDetailsWithToken: action.payload
            });
        case CommunityConstants/* default.FETCH_USER_GETSOCIAL_TOKEN_FAIL */.Z.FETCH_USER_GETSOCIAL_TOKEN_FAIL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isLoading: false
            });
        case CommunityConstants/* default.SET_GETSOCIAL_USER_PROFILE */.Z.SET_GETSOCIAL_USER_PROFILE:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                userGetSocialProfile: action.payload
            });
        case CommunityConstants/* default.SET_FOLLOWED_TOPICS */.Z.SET_FOLLOWED_TOPICS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                followedTopics: action.payload
            });
        case CommunityConstants/* default.SET_ALL_TOPICS */.Z.SET_ALL_TOPICS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                allTopics: action.payload
            });
        case CommunityConstants/* default.SET_TIMELINE_POSTS */.Z.SET_TIMELINE_POSTS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                timelinePosts: action.payload
            });
        case CommunityConstants/* default.SET_SINGLE_FEED_VIWE_DATA */.Z.SET_SINGLE_FEED_VIWE_DATA:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                singleFeedData: action.payload
            });
        case CommunityConstants/* default.SET_SEARCH_POSTS_RESULT */.Z.SET_SEARCH_POSTS_RESULT:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                searchPostsResults: action.payload
            });
        case CommunityConstants/* default.SET_SELECTED_TOPICS_FOR_FEED */.Z.SET_SELECTED_TOPICS_FOR_FEED:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                selectedTopicForFeed: action.payload
            });
        default:
            return state;
    }
};
/* harmony default export */ var CommunityReducer = (CommunityReducer_reducer);

// EXTERNAL MODULE: ./components/Profile/IeltsProfile/TestPrep/redux/TestPrepSlice.ts
var TestPrepSlice = __webpack_require__(57980);
// EXTERNAL MODULE: ./components/Ielts/IeltsEliteDemo/redux/IeltsEliteSlice.ts
var IeltsEliteSlice = __webpack_require__(48472);
// EXTERNAL MODULE: ./components/Ielts/IeltsDemo/DemoCalendar/Filters/redux/FiltersSlice.ts
var FiltersSlice = __webpack_require__(25386);
// EXTERNAL MODULE: ./components/Ielts/IeltsDemo/redux/IeltsDemoSlice.ts
var IeltsDemoSlice = __webpack_require__(4975);
// EXTERNAL MODULE: ./components/Ielts/GenericBundles/redux/PaymentBundleSlices.ts
var PaymentBundleSlices = __webpack_require__(73092);
// EXTERNAL MODULE: ./components/Profile/StudentDashbord/IeltsSection/IeltsDemoRewards/redux/DemoRewardsSlice.ts
var DemoRewardsSlice = __webpack_require__(86853);
// EXTERNAL MODULE: ./components/Ielts/Referal/redux/IeltsReferalSlice.ts
var IeltsReferalSlice = __webpack_require__(14729);
// EXTERNAL MODULE: ./components/UserDashboard/GetSupport/getSupportSlice.ts
var getSupportSlice = __webpack_require__(76270);
;// CONCATENATED MODULE: ./redux/rootReducer.ts




























































// ToFu





// ls community









var _obj;
var rootReducer = (0,redux/* combineReducers */.UY)((_obj = {
    ieltsPlus: IeltsPlusReducer,
    financialCounselling: FinancialCounsellingReducer,
    speakingClub: SpeakingClubReducer,
    classRecordings: ClassRecordingsReducer,
    noticeBoard: NoticeBoardReducer,
    studyMaterial: StudyMaterialReducer,
    myClass: MyClassReducer,
    upcomingClass: upcomingReducer,
    referAndEarn: ReferAndEarnReducer,
    counselling: CounsellingReducer,
    counsellingForm: CounsellingFormReducer,
    essayEvaluation: EssayReducer,
    ieltsFaculty: FacultyReducer,
    batchDetails: BatchDetailsReducer,
    upcomingIeltsBatches: UpcomingIeltsReducer,
    updateProfile: UpdateProfileReducer,
    ieltsRegistrationForm: IeltsRegistrationFormReducer,
    masterclassRegistrationForm: MasterclassRegistrationFormReducer,
    ieltsAttendance: IeltsAttendanceReducer,
    extraClass: ExtraClassReducer,
    ieltsNps: NpsReducer,
    spotCounselling: SpotCounsellingReducer,
    calender: calenderReducer,
    promoCode: PromoCodeReducer,
    overviewReducer: overview_reducers,
    counsellingNoticeBoardReducer: notice_board_reducers,
    upcomingAppointments: upcoming_appointments_reducers,
    documentDetails: document_details_reducers,
    visaAssistance: visa_assistance_reducers,
    auth: AuthReducer,
    mockTest: MockTestReducer,
    fastTrackRegistrationForm: FastTrackFormReducer,
    fastTrack: FastTrackReducer,
    fastTrackVideo: FastTrackVideoReducer,
    intermediateScreen: IntermediateScreenReducer,
    registrationForms: RegistrationFormReducer,
    myUniversities: my_universities_reducers,
    masterclass: MasterclassReducer,
    ieltsTest: IeltsTestReducer,
    onboardingReducer: OnboardingReducer,
    ieltsCertificate: CertificateReducer,
    documentUpload: DocumentUploadReducer,
    review: ReviewsReducer,
    meetCounseller: MeetCounsellerReducer,
    stories: StoriesReducer,
    ieltsScreenController: IeltsScreenControllerReducer,
    aiEvalution: AiEvalutionReducer,
    masterClassReplays: MasterclassReplaysReducer,
    lsPayment: PaymentReducer,
    ieltsQuiz: QuizReducer,
    semDetails: SemLandingReducer,
    masterClassType: MasterClassTypeReducer,
    foundationClass: FoundationSlice,
    joinMasterClass: redux_joinMasterClassReducer,
    RequestCbPremium: RequestCallBackFormSlice/* default */.ZP,
    tofuOnbording: Reducer,
    mockTestPrice: MockTestPriceSlice/* default */.ZP,
    lsCommunity: CommunityReducer,
    batchShedule: schedulePageSlice/* default */.ZP,
    orientation: OrientationSlice/* default */.ZP,
    practiseTab: PractiseAppSlice/* default */.ZP,
    NeedHelp: NeedHelpReducer,
    WordOfTheDay: WordOfTheDaySlice/* default */.ZP,
    TestPrep: TestPrepSlice/* default */.ZP,
    IeltsElite: IeltsEliteSlice/* default */.ZP,
    Filters: FiltersSlice/* default */.ZP,
    IeltsDemo: IeltsDemoSlice/* default */.ZP,
    PaymentBundles: PaymentBundleSlices/* default */.ZP,
    DemoRewards: DemoRewardsSlice/* default */.ZP,
    selfPrep: selfPrepSlice/* default */.Z
}, (0,_define_property/* default */.Z)(_obj, IeltsReferalSlice/* ieltsReferalStateName */.vm, IeltsReferalSlice/* default */.ZP), (0,_define_property/* default */.Z)(_obj, "getSupportSlice", getSupportSlice/* default */.Z), _obj));

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@redux-saga/is/dist/redux-saga-is.esm.js
var redux_saga_is_esm = __webpack_require__(52847);
// EXTERNAL MODULE: ./node_modules/@redux-saga/core/dist/io-c3792963.js + 1 modules
var io_c3792963 = __webpack_require__(83959);
;// CONCATENATED MODULE: ./node_modules/@redux-saga/core/dist/redux-saga-effects.esm.js







var done = function done(value) {
  return {
    done: true,
    value: value
  };
};

var qEnd = {};
function safeName(patternOrChannel) {
  if ((0,redux_saga_is_esm/* channel */.CE)(patternOrChannel)) {
    return 'channel';
  }

  if ((0,redux_saga_is_esm/* stringableFunc */.eR)(patternOrChannel)) {
    return String(patternOrChannel);
  }

  if ((0,redux_saga_is_esm/* func */.Yl)(patternOrChannel)) {
    return patternOrChannel.name;
  }

  return String(patternOrChannel);
}
function fsmIterator(fsm, startState, name) {
  var stateUpdater,
      errorState,
      effect,
      nextState = startState;

  function next(arg, error) {
    if (nextState === qEnd) {
      return done(arg);
    }

    if (error && !errorState) {
      nextState = qEnd;
      throw error;
    } else {
      stateUpdater && stateUpdater(arg);
      var currentState = error ? fsm[errorState](error) : fsm[nextState]();
      nextState = currentState.nextState;
      effect = currentState.effect;
      stateUpdater = currentState.stateUpdater;
      errorState = currentState.errorState;
      return nextState === qEnd ? done(arg) : effect;
    }
  }

  return (0,io_c3792963.q)(next, function (error) {
    return next(null, error);
  }, name);
}

function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = {
    done: false,
    value: take(patternOrChannel)
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: fork.apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var action,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yTake,
        stateUpdater: setAction
      };
    },
    q2: function q2() {
      return {
        nextState: 'q1',
        effect: yFork(action)
      };
    }
  }, 'q1', "takeEvery(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = {
    done: false,
    value: (0,io_c3792963.K)(patternOrChannel)
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: io_c3792963.L.apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var yCancel = function yCancel(task) {
    return {
      done: false,
      value: (0,io_c3792963.M)(task)
    };
  };

  var task, action;

  var setTask = function setTask(t) {
    return task = t;
  };

  var setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yTake,
        stateUpdater: setAction
      };
    },
    q2: function q2() {
      return task ? {
        nextState: 'q3',
        effect: yCancel(task)
      } : {
        nextState: 'q1',
        effect: yFork(action),
        stateUpdater: setTask
      };
    },
    q3: function q3() {
      return {
        nextState: 'q1',
        effect: yFork(action),
        stateUpdater: setTask
      };
    }
  }, 'q1', "takeLatest(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

function takeLeading(patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = {
    done: false,
    value: take(patternOrChannel)
  };

  var yCall = function yCall(ac) {
    return {
      done: false,
      value: call.apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var action;

  var setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yTake,
        stateUpdater: setAction
      };
    },
    q2: function q2() {
      return {
        nextState: 'q1',
        effect: yCall(action)
      };
    }
  }, 'q1', "takeLeading(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

function throttle(delayLength, patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action, channel$1;

  var yTake = function yTake() {
    return {
      done: false,
      value: take(channel$1)
    };
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: fork.apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var yDelay = {
    done: false,
    value: delay(delayLength)
  };

  var setAction = function setAction(ac) {
    return action = ac;
  };

  var setChannel = function setChannel(ch) {
    return channel$1 = ch;
  };

  var needsChannel = !channel(patternOrChannel);

  if (!needsChannel) {
    setChannel(patternOrChannel);
  }

  return fsmIterator({
    q1: function q1() {
      var yActionChannel = {
        done: false,
        value: actionChannel(patternOrChannel, sliding(1))
      };
      return {
        nextState: 'q2',
        effect: yActionChannel,
        stateUpdater: setChannel
      };
    },
    q2: function q2() {
      return {
        nextState: 'q3',
        effect: yTake(),
        stateUpdater: setAction
      };
    },
    q3: function q3() {
      return {
        nextState: 'q4',
        effect: yFork(action)
      };
    },
    q4: function q4() {
      return {
        nextState: 'q2',
        effect: yDelay
      };
    }
  }, needsChannel ? 'q1' : 'q2', "throttle(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

function retry(maxTries, delayLength, fn) {
  var counter = maxTries;

  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var yCall = {
    done: false,
    value: call.apply(void 0, [fn].concat(args))
  };
  var yDelay = {
    done: false,
    value: delay(delayLength)
  };
  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yCall,
        errorState: 'q10'
      };
    },
    q2: function q2() {
      return {
        nextState: qEnd
      };
    },
    q10: function q10(error) {
      counter -= 1;

      if (counter <= 0) {
        throw error;
      }

      return {
        nextState: 'q1',
        effect: yDelay
      };
    }
  }, 'q1', "retry(" + fn.name + ")");
}

function debounceHelper(delayLength, patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action, raceOutput;
  var yTake = {
    done: false,
    value: take(patternOrChannel)
  };
  var yRace = {
    done: false,
    value: race({
      action: take(patternOrChannel),
      debounce: delay(delayLength)
    })
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: fork.apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var yNoop = function yNoop(value) {
    return {
      done: false,
      value: value
    };
  };

  var setAction = function setAction(ac) {
    return action = ac;
  };

  var setRaceOutput = function setRaceOutput(ro) {
    return raceOutput = ro;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yTake,
        stateUpdater: setAction
      };
    },
    q2: function q2() {
      return {
        nextState: 'q3',
        effect: yRace,
        stateUpdater: setRaceOutput
      };
    },
    q3: function q3() {
      return raceOutput.debounce ? {
        nextState: 'q1',
        effect: yFork(action)
      } : {
        nextState: 'q2',
        effect: yNoop(raceOutput.action),
        stateUpdater: setAction
      };
    }
  }, 'q1', "debounce(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

var validateTakeEffect = function validateTakeEffect(fn, patternOrChannel, worker) {
  check(patternOrChannel, notUndef, fn.name + " requires a pattern or channel");
  check(worker, notUndef, fn.name + " requires a saga parameter");
};

function takeEvery$1(patternOrChannel, worker) {
  if (false) {}

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return fork.apply(void 0, [takeEvery, patternOrChannel, worker].concat(args));
}
function takeLatest$1(patternOrChannel, worker) {
  if (false) {}

  for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  return io_c3792963.L.apply(void 0, [takeLatest, patternOrChannel, worker].concat(args));
}
function takeLeading$1(patternOrChannel, worker) {
  if (false) {}

  for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    args[_key3 - 2] = arguments[_key3];
  }

  return fork.apply(void 0, [takeLeading, patternOrChannel, worker].concat(args));
}
function throttle$1(ms, patternOrChannel, worker) {
  if (false) {}

  for (var _len4 = arguments.length, args = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
    args[_key4 - 3] = arguments[_key4];
  }

  return fork.apply(void 0, [throttle, ms, patternOrChannel, worker].concat(args));
}
function retry$1(maxTries, delayLength, worker) {
  for (var _len5 = arguments.length, args = new Array(_len5 > 3 ? _len5 - 3 : 0), _key5 = 3; _key5 < _len5; _key5++) {
    args[_key5 - 3] = arguments[_key5];
  }

  return call.apply(void 0, [retry, maxTries, delayLength, worker].concat(args));
}
function debounce(delayLength, pattern, worker) {
  for (var _len6 = arguments.length, args = new Array(_len6 > 3 ? _len6 - 3 : 0), _key6 = 3; _key6 < _len6; _key6++) {
    args[_key6 - 3] = arguments[_key6];
  }

  return fork.apply(void 0, [debounceHelper, delayLength, pattern, worker].concat(args));
}



;// CONCATENATED MODULE: ./node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./service/api.ts + 1 modules
var api = __webpack_require__(14117);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/IeltsPlus/redux/IeltsPlusApi.ts



var fetchIeltsPlusData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=student/ielts/fee/v2");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    throw new Error(res.data.message);
                case 9:
                    _ctx.next = 15;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    throw new Error("Something went wrong. Please try after sometime");
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchIeltsPlusData() {
        return _ref.apply(this, arguments);
    };
}();
var enrollStudentToIeltsPlus = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(batchId) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=student/workshop/1/".concat(batchId, "/enroll"));
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", true);
                case 8:
                    throw new Error(res.data.message);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please try after sometime");
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function enrollStudentToIeltsPlus(batchId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchObjects = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(batchId) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=workshop/objects/".concat(batchId));
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please try after sometime");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchObjects(batchId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchEnrolledBatches = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var headers, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    headers = {
                        "X-API-VERSION": "4"
                    };
                    _ctx.next = 4;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=student/enrolled/batches", {
                        headers: headers
                    });
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function fetchEnrolledBatches() {
        return _ref.apply(this, arguments);
    };
}();
var fetchRewardList = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(batchId) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=reward/list/".concat(batchId));
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please try after sometime");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchRewardList(batchId) {
        return _ref.apply(this, arguments);
    };
}();
var ieltsPlusApi = {
    fetchIeltsPlusData: fetchIeltsPlusData,
    enrollStudentToIeltsPlus: enrollStudentToIeltsPlus,
    fetchObjects: fetchObjects,
    fetchEnrolledBatches: fetchEnrolledBatches,
    fetchRewardList: fetchRewardList
};

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./utils/batches.ts
var batches = __webpack_require__(67834);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/IeltsPlus/redux/IeltsPlusSaga.ts


var _marked = runtime_default().mark(ieltsSaga);
var _marked1 = runtime_default().mark(IeltsPlusSaga_fetchRewardList);
var _marked2 = runtime_default().mark(IeltsPlusSaga_fetchEnrolledBatches);
var _marked3 = runtime_default().mark(IeltsPlusSaga_fetchObjects);
var _marked4 = runtime_default().mark(enrollToIeltsPlus);
var _marked5 = runtime_default().mark(fetchData);






var getCompletedBatches = function(data) {
    var completedBatches = data.filter(function(batch) {
        return moment_default()(batch.endTime).isBefore();
    });
    return completedBatches;
};
var getUpcomingBatches = function(data) {
    var upcomingBatches = data.filter(function(batch) {
        return moment_default()(batch.endTime).isAfter();
    });
    return upcomingBatches;
};
function fetchData() {
    var ieltsData;
    return runtime_default().wrap(function fetchData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(ieltsPlusApi.fetchIeltsPlusData);
            case 3:
                ieltsData = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)(IeltsPlusActions/* ieltsPlusActions.fetchSuccess */.P.fetchSuccess(ieltsData));
            case 6:
                _ctx.next = 13;
                break;
            case 8:
                _ctx.prev = 8;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 13;
                return (0,io_c3792963.Y)(IeltsPlusActions/* ieltsPlusActions.fetchFail */.P.fetchFail(_ctx.t0.message));
            case 13:
            case "end":
                return _ctx.stop();
        }
    }, _marked5, null, [
        [
            0,
            8
        ]
    ]);
}
function enrollToIeltsPlus(action) {
    var res;
    return runtime_default().wrap(function enrollToIeltsPlus$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(ieltsPlusApi.enrollStudentToIeltsPlus, action.payload);
            case 3:
                res = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)(IeltsPlusActions/* ieltsPlusActions.enrollSuccess */.P.enrollSuccess(res));
            case 6:
                _ctx.next = 13;
                break;
            case 8:
                _ctx.prev = 8;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 13;
                return (0,io_c3792963.Y)(IeltsPlusActions/* ieltsPlusActions.enrollFail */.P.enrollFail(_ctx.t0.message));
            case 13:
            case "end":
                return _ctx.stop();
        }
    }, _marked4, null, [
        [
            0,
            8
        ]
    ]);
}
function IeltsPlusSaga_fetchObjects(action) {
    var res;
    return runtime_default().wrap(function fetchObjects$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(ieltsPlusApi.fetchObjects, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(IeltsPlusActions/* ieltsPlusActions.fetchObjectsSuccess */.P.fetchObjectsSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(IeltsPlusActions/* ieltsPlusActions.fetchObjectsFail */.P.fetchObjectsFail(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(IeltsPlusActions/* ieltsPlusActions.fetchObjectsFail */.P.fetchObjectsFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, _marked3, null, [
        [
            0,
            13
        ]
    ]);
}
function IeltsPlusSaga_fetchEnrolledBatches() {
    var res, enrolledBatches, completedBatches, upcomingBatches, batchList, ref, plusEnrollment, foundationEnrolment, premiumEnrolment, selectBatchEnrollment, eliteBatchEnrollment;
    return runtime_default().wrap(function fetchEnrolledBatches$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(ieltsPlusApi.fetchEnrolledBatches);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 30;
                    break;
                }
                enrolledBatches = cloneDeep_default()(res.data.enrolledBatches);
                completedBatches = getCompletedBatches(enrolledBatches);
                upcomingBatches = getUpcomingBatches(enrolledBatches);
                _ctx.next = 10;
                return (0,io_c3792963.Y)(IeltsPlusActions/* ieltsPlusActions.addCompletedIeltsClasses */.P.addCompletedIeltsClasses(completedBatches));
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)(IeltsPlusActions/* ieltsPlusActions.addUpcomingIeltsClasses */.P.addUpcomingIeltsClasses(upcomingBatches));
            case 12:
                _ctx.next = 14;
                return (0,io_c3792963.Y)(IeltsPlusActions/* ieltsPlusActions.addAllIeltsClasses */.P.addAllIeltsClasses((0,_to_consumable_array/* default */.Z)(upcomingBatches).concat((0,_to_consumable_array/* default */.Z)(completedBatches))));
            case 14:
                _ctx.next = 16;
                return (0,io_c3792963.Y)(IeltsPlusActions/* ieltsPlusActions.fetchEnrolledBatchesSuccess */.P.fetchEnrolledBatchesSuccess(enrolledBatches));
            case 16:
                batchList = (0,_to_consumable_array/* default */.Z)(upcomingBatches).concat((0,_to_consumable_array/* default */.Z)(completedBatches));
                ref = batchList.reduce(batches/* reduceOnlineWorkshopEnrollment */.aj, {
                    plusEnrollment: 0,
                    foundationEnrolment: 0,
                    premiumEnrolment: 0,
                    selectBatchEnrollment: 0,
                    eliteBatchEnrollment: 0
                }), plusEnrollment = ref.plusEnrollment, foundationEnrolment = ref.foundationEnrolment, premiumEnrolment = ref.premiumEnrolment, selectBatchEnrollment = ref.selectBatchEnrollment, eliteBatchEnrollment = ref.eliteBatchEnrollment;
                _ctx.next = 20;
                return (0,io_c3792963.Y)(IeltsPlusActions/* ieltsPlusActions.checkIeltsEnrollment */.P.checkIeltsEnrollment(enrolledBatches.length > 0));
            case 20:
                _ctx.next = 22;
                return (0,io_c3792963.Y)(IeltsPlusActions/* ieltsPlusActions.checkFoundationEnrollment */.P.checkFoundationEnrollment(foundationEnrolment > 0));
            case 22:
                _ctx.next = 24;
                return (0,io_c3792963.Y)(IeltsPlusActions/* ieltsPlusActions.checkPlusEnrollment */.P.checkPlusEnrollment(plusEnrollment > 0 || premiumEnrolment > 0));
            case 24:
                _ctx.next = 26;
                return (0,io_c3792963.Y)(IeltsPlusActions/* ieltsPlusActions.checkPremiumEnrollment */.P.checkPremiumEnrollment(premiumEnrolment > 0));
            case 26:
                _ctx.next = 28;
                return (0,io_c3792963.Y)(IeltsPlusActions/* ieltsPlusActions.checkIeltsBatchesEnrollment */.P.checkIeltsBatchesEnrollment({
                    isEnrolledForElite: eliteBatchEnrollment > 0,
                    isEnrolledForSelect: selectBatchEnrollment > 0,
                    isEnrolledForPlus: plusEnrollment > 0,
                    isEnrolledForPremium: premiumEnrolment > 0
                }));
            case 28:
                _ctx.next = 32;
                break;
            case 30:
                _ctx.next = 32;
                return (0,io_c3792963.Y)(IeltsPlusActions/* ieltsPlusActions.updateError */.P.updateError(res.message));
            case 32:
                _ctx.next = 39;
                break;
            case 34:
                _ctx.prev = 34;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 39;
                return (0,io_c3792963.Y)(IeltsPlusActions/* ieltsPlusActions.updateError */.P.updateError("Something went wrong. Please try after sometime"));
            case 39:
                _ctx.prev = 39;
                _ctx.next = 42;
                return (0,io_c3792963.Y)(IeltsPlusActions/* ieltsPlusActions.toggleLoadingEnrolledClasses */.P.toggleLoadingEnrolledClasses(false));
            case 42:
                return _ctx.finish(39);
            case 43:
            case "end":
                return _ctx.stop();
        }
    }, _marked2, null, [
        [
            0,
            34,
            39,
            43
        ]
    ]);
}
function IeltsPlusSaga_fetchRewardList(action) {
    var ref, res, sortdata;
    return runtime_default().wrap(function fetchRewardList$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                ;
                _ctx.next = 4;
                return (0,io_c3792963.N)(ieltsPlusApi.fetchRewardList, action.payload);
            case 4:
                res = _ctx.sent;
                sortdata = (ref = res.data) === null || ref === void 0 ? void 0 : ref.sort(function(a, b) {
                    return a.reward.nthDay > b.reward.nthDay ? 1 : -1;
                });
                _ctx.next = 8;
                return (0,io_c3792963.Y)(IeltsPlusActions/* ieltsPlusActions.fetchRewardListSuccess */.P.fetchRewardListSuccess(sortdata));
            case 8:
                _ctx.next = 15;
                break;
            case 10:
                _ctx.prev = 10;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 15;
                return (0,io_c3792963.Y)(IeltsPlusActions/* ieltsPlusActions.enrollFail */.P.enrollFail(_ctx.t0.message));
            case 15:
            case "end":
                return _ctx.stop();
        }
    }, _marked1, null, [
        [
            0,
            10
        ]
    ]);
}
function ieltsSaga() {
    return runtime_default().wrap(function ieltsSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("IELTS_FETCH_REQUESTED", fetchData);
            case 2:
                _ctx.next = 4;
                return takeLatest$1("ENROLL_TO_IELTS_PLUS", enrollToIeltsPlus);
            case 4:
                _ctx.next = 6;
                return takeLatest$1("FETCH_OBJECTS_REQUESTED", IeltsPlusSaga_fetchObjects);
            case 6:
                _ctx.next = 8;
                return takeLatest$1("FETCH_ENROLLED_BATCHES_REQUESTED", IeltsPlusSaga_fetchEnrolledBatches);
            case 8:
                _ctx.next = 10;
                return takeLatest$1("FETCH_REWARD_LIST_REQUESTED", IeltsPlusSaga_fetchRewardList);
            case 10:
            case "end":
                return _ctx.stop();
        }
    }, _marked);
}
/* harmony default export */ var IeltsPlusSaga = (ieltsSaga);

;// CONCATENATED MODULE: ./components/Profile/CounsellingProfile/FinancialCounselling/redux/FinancialCounsellingApi.ts



var fetchFinancialCounsellingData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=financial_counselling/upcoming_webinar");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    throw new Error(res.data.message);
                case 9:
                    _ctx.next = 15;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchFinancialCounsellingData() {
        return _ref.apply(this, arguments);
    };
}();
var fetchFinancialCounsellingPageData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=profile/post/financial-event");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res);
                case 8:
                    throw new Error(res.data.message);
                case 9:
                    _ctx.next = 15;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchFinancialCounsellingPageData() {
        return _ref.apply(this, arguments);
    };
}();
var financialCounsellingApi = {
    fetchFinancialCounsellingData: fetchFinancialCounsellingData,
    fetchFinancialCounsellingPageData: fetchFinancialCounsellingPageData
};

// EXTERNAL MODULE: ./components/Profile/CounsellingProfile/FinancialCounselling/redux/FinancialCounsellingActions.ts
var FinancialCounsellingActions = __webpack_require__(23433);
;// CONCATENATED MODULE: ./components/Profile/CounsellingProfile/FinancialCounselling/redux/FinancialCounsellingSaga.ts

var FinancialCounsellingSaga_marked = runtime_default().mark(financialCounsellingSaga);
var FinancialCounsellingSaga_marked1 = runtime_default().mark(fetchPageData);
var FinancialCounsellingSaga_marked2 = runtime_default().mark(FinancialCounsellingSaga_fetchData);



function FinancialCounsellingSaga_fetchData() {
    var financialCounsellingData;
    return runtime_default().wrap(function fetchData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(financialCounsellingApi.fetchFinancialCounsellingData);
            case 3:
                financialCounsellingData = _ctx.sent;
                if (!financialCounsellingData.isJoined) {
                    _ctx.next = 7;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(FinancialCounsellingActions/* financialCounsellingActions.updateJoinStatus */.P.updateJoinStatus(financialCounsellingData.isJoined));
            case 7:
                _ctx.next = 9;
                return (0,io_c3792963.Y)(FinancialCounsellingActions/* financialCounsellingActions.fetchSuccess */.P.fetchSuccess(financialCounsellingData));
            case 9:
                _ctx.next = 15;
                break;
            case 11:
                _ctx.prev = 11;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 15;
                return (0,io_c3792963.Y)(FinancialCounsellingActions/* financialCounsellingActions.fetchFail */.P.fetchFail(_ctx.t0.message));
            case 15:
            case "end":
                return _ctx.stop();
        }
    }, FinancialCounsellingSaga_marked2, null, [
        [
            0,
            11
        ]
    ]);
}
function fetchPageData() {
    var res;
    return runtime_default().wrap(function fetchPageData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(financialCounsellingApi.fetchFinancialCounsellingPageData);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(FinancialCounsellingActions/* financialCounsellingActions.fetchFinancialCounsellingPageDataSuccess */.P.fetchFinancialCounsellingPageDataSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(FinancialCounsellingActions/* financialCounsellingActions.fetchFinancialCounsellingPageDataFail */.P.fetchFinancialCounsellingPageDataFail(res.data.message));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(FinancialCounsellingActions/* financialCounsellingActions.fetchFinancialCounsellingPageDataFail */.P.fetchFinancialCounsellingPageDataFail(_ctx.t0.message));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, FinancialCounsellingSaga_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function financialCounsellingSaga() {
    return runtime_default().wrap(function financialCounsellingSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("FINANCIAL_COUNSELLING_FETCH_REQUESTED", FinancialCounsellingSaga_fetchData);
            case 2:
                _ctx.next = 4;
                return takeLatest$1("FINANCIAL_COUNSELLING_PAGE_FETCH_REQUESTED", fetchPageData);
            case 4:
            case "end":
                return _ctx.stop();
        }
    }, FinancialCounsellingSaga_marked);
}
/* harmony default export */ var FinancialCounsellingSaga = (financialCounsellingSaga);

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/SpeakingClub/redux/SpeakingClubApi.ts



var fetchSlotAvailableDateData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=v2/workshop/speaking-club/30/300");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    throw new Error(res.data.message);
                case 9:
                    _ctx.next = 15;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchSlotAvailableDateData() {
        return _ref.apply(this, arguments);
    };
}();
var postSpeakingWorkShop = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(batchId) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=workshop/enroll/".concat(batchId, "/SPEAKING_WORKSHOP"));
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        success: true,
                        payload: true
                    });
                case 8:
                    return _ctx.abrupt("return", {
                        success: false,
                        payload: res.data.message
                    });
                case 9:
                    _ctx.next = 15;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function postSpeakingWorkShop(batchId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchUpcomingSpeakingClasses = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=v2/workshop/enroll/my/SPEAKING_ELITE_WORKSHOP");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    throw new Error(res.data.message);
                case 9:
                    _ctx.next = 15;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchUpcomingSpeakingClasses() {
        return _ref.apply(this, arguments);
    };
}();
var fetchSpeakingClubCredits = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=workshop/enroll/credits/SPEAKING_WORKSHOP");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchSpeakingClubCredits() {
        return _ref.apply(this, arguments);
    };
}();
var fetchSpeakingClubPriceBundle = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=student/speaking-club/fee");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        success: true,
                        data: res.data.data
                    });
                case 8:
                    return _ctx.abrupt("return", {
                        success: false,
                        data: res.data.message
                    });
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        success: false,
                        data: "Something went wrong"
                    });
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchSpeakingClubPriceBundle() {
        return _ref.apply(this, arguments);
    };
}();
var cancelSlot = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(batchId) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.put */.Z.put("/api/scholarRoute?path=workshop/enroll/user/".concat(batchId, "/SPEAKING_WORKSHOP"));
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function cancelSlot(batchId) {
        return _ref.apply(this, arguments);
    };
}();
var rescheduleSlot = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
        var batchId, previousBatchId, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    batchId = payload.batchId, previousBatchId = payload.previousBatchId;
                    _ctx.next = 4;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=workshop/enroll/reschedule/".concat(batchId, "/").concat(previousBatchId, "/SPEAKING_WORKSHOP"));
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function rescheduleSlot(payload) {
        return _ref.apply(this, arguments);
    };
}();
var getUserFeedbackApi = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref, res, ref1;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=workshop/feedback/flse");
                case 4:
                    res = _ctx.sent;
                    if (!(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                        _ctx.next = 8;
                        break;
                    }
                    ;
                    return _ctx.abrupt("return", (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.data);
                case 8:
                    return _ctx.abrupt("return", false);
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", false);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function getUserFeedbackApi() {
        return _ref.apply(this, arguments);
    };
}();
var getFlseVisibilityApi = function() {
    return api/* default.get */.Z.get("/api/scholarRoute?path=flse/is-flse-visible");
};
var speakingClubApi = {
    fetchSlotAvailableDateData: fetchSlotAvailableDateData,
    postSpeakingWorkShop: postSpeakingWorkShop,
    fetchUpcomingSpeakingClasses: fetchUpcomingSpeakingClasses,
    fetchSpeakingClubCredits: fetchSpeakingClubCredits,
    fetchSpeakingClubPriceBundle: fetchSpeakingClubPriceBundle,
    cancelSlot: cancelSlot,
    rescheduleSlot: rescheduleSlot,
    getUserFeedbackApi: getUserFeedbackApi,
    getFlseVisibilityApi: getFlseVisibilityApi
};

// EXTERNAL MODULE: ./DataMapper/EventTracker/EventData.ts
var EventData = __webpack_require__(1692);
// EXTERNAL MODULE: ./eventTracker.ts
var eventTracker = __webpack_require__(44305);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/SpeakingClub/redux/SpeakingClubSaga.ts


var SpeakingClubSaga_marked = runtime_default().mark(speakingClubSaga);
var SpeakingClubSaga_marked1 = runtime_default().mark(getFlseVisibilitySaga);
var SpeakingClubSaga_marked2 = runtime_default().mark(rescheduleSpeakingClubBatch);
var SpeakingClubSaga_marked3 = runtime_default().mark(cancelSpeakingClubBatch);
var SpeakingClubSaga_marked4 = runtime_default().mark(fetchSpeakingPriceBundle);
var SpeakingClubSaga_marked5 = runtime_default().mark(SpeakingClubSaga_fetchSpeakingClubCredits);
var _marked6 = runtime_default().mark(enrollSpeakingClub);
var _marked7 = runtime_default().mark(fetchUpcomingSpeakingClubData);
var _marked8 = runtime_default().mark(SpeakingClubSaga_fetchData);






var CANCEL_SPEAKING_CLUB_BATCH = SpeakingClubActions/* speakingClubType.CANCEL_SPEAKING_CLUB_BATCH */.s.CANCEL_SPEAKING_CLUB_BATCH, RESCHEDULE_SPEAKING_CLUB_BATCH = SpeakingClubActions/* speakingClubType.RESCHEDULE_SPEAKING_CLUB_BATCH */.s.RESCHEDULE_SPEAKING_CLUB_BATCH, SPEAKING_CLUB_SLOT_FETCH_REQUESTED = SpeakingClubActions/* speakingClubType.SPEAKING_CLUB_SLOT_FETCH_REQUESTED */.s.SPEAKING_CLUB_SLOT_FETCH_REQUESTED, SPEAKING_WORKSHOP_POST_REQUESTED = SpeakingClubActions/* speakingClubType.SPEAKING_WORKSHOP_POST_REQUESTED */.s.SPEAKING_WORKSHOP_POST_REQUESTED, UPCOMING_SPEAKING_CLUB_REQUEST = SpeakingClubActions/* speakingClubType.UPCOMING_SPEAKING_CLUB_REQUEST */.s.UPCOMING_SPEAKING_CLUB_REQUEST, FETCH_SPEAKING_CLUB_CREDITS = SpeakingClubActions/* speakingClubType.FETCH_SPEAKING_CLUB_CREDITS */.s.FETCH_SPEAKING_CLUB_CREDITS, FETCH_SPEAKING_BUNDLE_PRICE_REQ = SpeakingClubActions/* speakingClubType.FETCH_SPEAKING_BUNDLE_PRICE_REQ */.s.FETCH_SPEAKING_BUNDLE_PRICE_REQ, GET_FLSE_VISIBILITY_ACTION = SpeakingClubActions/* speakingClubType.GET_FLSE_VISIBILITY_ACTION */.s.GET_FLSE_VISIBILITY_ACTION;
var SpeakingClubSaga_cancelSlot = speakingClubApi.cancelSlot, SpeakingClubSaga_rescheduleSlot = speakingClubApi.rescheduleSlot;
function SpeakingClubSaga_fetchData() {
    var speakingClubDate;
    return runtime_default().wrap(function fetchData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(speakingClubApi.fetchSlotAvailableDateData);
            case 3:
                speakingClubDate = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)(SpeakingClubActions/* speakingClubActions.fetchSpeakingClubSlotSuccess */.u.fetchSpeakingClubSlotSuccess(speakingClubDate));
            case 6:
                _ctx.next = 12;
                break;
            case 8:
                _ctx.prev = 8;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 12;
                return (0,io_c3792963.Y)(SpeakingClubActions/* speakingClubActions.fetchSpeakingClubSlotFail */.u.fetchSpeakingClubSlotFail(_ctx.t0.message));
            case 12:
            case "end":
                return _ctx.stop();
        }
    }, _marked8, null, [
        [
            0,
            8
        ]
    ]);
}
function fetchUpcomingSpeakingClubData() {
    var speakingClubDate;
    return runtime_default().wrap(function fetchUpcomingSpeakingClubData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(speakingClubApi.fetchUpcomingSpeakingClasses);
            case 3:
                speakingClubDate = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)(SpeakingClubActions/* speakingClubActions.fetchUpcomingSpeakingClubSuccess */.u.fetchUpcomingSpeakingClubSuccess(speakingClubDate));
            case 6:
                _ctx.next = 12;
                break;
            case 8:
                _ctx.prev = 8;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 12;
                return (0,io_c3792963.Y)(SpeakingClubActions/* speakingClubActions.fetchUpcomingSpeakingClubFail */.u.fetchUpcomingSpeakingClubFail(_ctx.t0.message));
            case 12:
            case "end":
                return _ctx.stop();
        }
    }, _marked7, null, [
        [
            0,
            8
        ]
    ]);
}
function enrollSpeakingClub(action) {
    var res;
    return runtime_default().wrap(function enrollSpeakingClub$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(speakingClubApi.postSpeakingWorkShop, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(SpeakingClubActions/* speakingClubActions.postSpeakingWorkShopSuccess */.u.postSpeakingWorkShopSuccess(res.payload));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(SpeakingClubActions/* speakingClubActions.postSpeakingWorkShopFail */.u.postSpeakingWorkShopFail(res.payload));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(SpeakingClubActions/* speakingClubActions.postSpeakingWorkShopFail */.u.postSpeakingWorkShopFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, _marked6, null, [
        [
            0,
            13
        ]
    ]);
}
function SpeakingClubSaga_fetchSpeakingClubCredits() {
    var res;
    return runtime_default().wrap(function fetchSpeakingClubCredits$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(speakingClubApi.fetchSpeakingClubCredits);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(SpeakingClubActions/* speakingClubActions.fetchSpeakingClubCreditsSuccess */.u.fetchSpeakingClubCreditsSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(SpeakingClubActions/* speakingClubActions.fetchSpeakingClubCreditsFail */.u.fetchSpeakingClubCreditsFail(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(SpeakingClubActions/* speakingClubActions.fetchSpeakingClubCreditsFail */.u.fetchSpeakingClubCreditsFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, SpeakingClubSaga_marked5, null, [
        [
            0,
            13
        ]
    ]);
}
function fetchSpeakingPriceBundle() {
    var res;
    return runtime_default().wrap(function fetchSpeakingPriceBundle$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(speakingClubApi.fetchSpeakingClubPriceBundle);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(SpeakingClubActions/* speakingClubActions.fetchSpeakingPriceBundleSuccess */.u.fetchSpeakingPriceBundleSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(SpeakingClubActions/* speakingClubActions.fetchSpeakingPriceBundleFail */.u.fetchSpeakingPriceBundleFail(res.data));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(SpeakingClubActions/* speakingClubActions.fetchSpeakingPriceBundleFail */.u.fetchSpeakingPriceBundleFail("Something went wrong!"));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, SpeakingClubSaga_marked4, null, [
        [
            0,
            13
        ]
    ]);
}
function cancelSpeakingClubBatch(action) {
    var res, ref, ref1, _obj;
    return runtime_default().wrap(function cancelSpeakingClubBatch$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(SpeakingClubSaga_cancelSlot, action.payload.batchId);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 19;
                    break;
                }
                ;
                _ctx.next = 8;
                return (0,io_c3792963.Y)(SpeakingClubActions/* speakingClubActions.toggleSpeakingClubCancelledModal */.u.toggleSpeakingClubCancelledModal(true));
            case 8:
                _ctx.next = 10;
                return (0,io_c3792963.Y)(SpeakingClubActions/* speakingClubActions.toogleSpeakingClubRescheduleModal */.u.toogleSpeakingClubRescheduleModal(false));
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)(SpeakingClubActions/* speakingClubActions.toggleIsRescheduling */.u.toggleIsRescheduling(false));
            case 12:
                _ctx.next = 14;
                return (0,io_c3792963.Y)(SpeakingClubActions/* speakingClubActions.fetchUpcomingSpeakingClubSuccess */.u.fetchUpcomingSpeakingClubSuccess(null));
            case 14:
                ;
                _ctx.next = 17;
                return (0,io_c3792963.N)(eventTracker/* eventTracker */.x, EventData/* eventName.CANCEL_SPEAKING_SLOT */.oJ.CANCEL_SPEAKING_SLOT, (_obj = {}, (0,_define_property/* default */.Z)(_obj, EventData/* WEeventDataAttributeNames.CATEGORY */.sx.CATEGORY, ""), (0,_define_property/* default */.Z)(_obj, EventData/* WEeventDataAttributeNames.ACTION */.sx.ACTION, ""), (0,_define_property/* default */.Z)(_obj, EventData/* WEeventDataAttributeNames.LABEL */.sx.LABEL, ""), (0,_define_property/* default */.Z)(_obj, EventData/* WEeventDataAttributeNames.BATCH_START_DATE */.sx.BATCH_START_DATE, moment_default()(action.payload.startDate).format("DD MMM YYYY")), (0,_define_property/* default */.Z)(_obj, EventData/* WEeventDataAttributeNames.BATCH_START_TIME */.sx.BATCH_START_TIME, action.payload.startTime), (0,_define_property/* default */.Z)(_obj, EventData/* WEeventDataAttributeNames.BATCH_ID */.sx.BATCH_ID, (ref = action.payload.batchData) === null || ref === void 0 ? void 0 : ref.id), (0,_define_property/* default */.Z)(_obj, EventData/* WEeventDataAttributeNames.TEACHER_NAME */.sx.TEACHER_NAME, (ref1 = action.payload.teacherData) === null || ref1 === void 0 ? void 0 : ref1.name), _obj), false);
            case 17:
                _ctx.next = 21;
                break;
            case 19:
                _ctx.next = 21;
                return (0,io_c3792963.Y)(SpeakingClubActions/* speakingClubActions.updateError */.u.updateError(res.message));
            case 21:
                _ctx.next = 27;
                break;
            case 23:
                _ctx.prev = 23;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 27;
                return (0,io_c3792963.Y)(SpeakingClubActions/* speakingClubActions.updateError */.u.updateError("Something went wrong!"));
            case 27:
            case "end":
                return _ctx.stop();
        }
    }, SpeakingClubSaga_marked3, null, [
        [
            0,
            23
        ]
    ]);
}
function rescheduleSpeakingClubBatch(action) {
    var res;
    return runtime_default().wrap(function rescheduleSpeakingClubBatch$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(SpeakingClubSaga_rescheduleSlot, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 11;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(SpeakingClubActions/* speakingClubActions.postSpeakingWorkShopSuccess */.u.postSpeakingWorkShopSuccess(true));
            case 7:
                _ctx.next = 9;
                return (0,io_c3792963.Y)(SpeakingClubActions/* speakingClubActions.toogleSpeakingClubRescheduleModal */.u.toogleSpeakingClubRescheduleModal(false));
            case 9:
                _ctx.next = 13;
                break;
            case 11:
                _ctx.next = 13;
                return (0,io_c3792963.Y)(SpeakingClubActions/* speakingClubActions.updateError */.u.updateError(res.message));
            case 13:
                _ctx.next = 19;
                break;
            case 15:
                _ctx.prev = 15;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 19;
                return (0,io_c3792963.Y)(SpeakingClubActions/* speakingClubActions.updateError */.u.updateError("Something went wrong!"));
            case 19:
            case "end":
                return _ctx.stop();
        }
    }, SpeakingClubSaga_marked2, null, [
        [
            0,
            15
        ]
    ]);
}
function getFlseVisibilitySaga() {
    var res;
    return runtime_default().wrap(function getFlseVisibilitySaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(speakingClubApi.getFlseVisibilityApi);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(SpeakingClubActions/* speakingClubActions.setFlseVisibility */.u.setFlseVisibility(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(SpeakingClubActions/* speakingClubActions.setFlseVisibility */.u.setFlseVisibility(false));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(SpeakingClubActions/* speakingClubActions.updateError */.u.updateError("Something went wrong!"));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, SpeakingClubSaga_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function speakingClubSaga() {
    return runtime_default().wrap(function speakingClubSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(SPEAKING_CLUB_SLOT_FETCH_REQUESTED, SpeakingClubSaga_fetchData);
            case 2:
                _ctx.next = 4;
                return takeLatest$1(SPEAKING_WORKSHOP_POST_REQUESTED, enrollSpeakingClub);
            case 4:
                _ctx.next = 6;
                return takeLatest$1(UPCOMING_SPEAKING_CLUB_REQUEST, fetchUpcomingSpeakingClubData);
            case 6:
                _ctx.next = 8;
                return takeLatest$1(FETCH_SPEAKING_CLUB_CREDITS, SpeakingClubSaga_fetchSpeakingClubCredits);
            case 8:
                _ctx.next = 10;
                return takeLatest$1(FETCH_SPEAKING_BUNDLE_PRICE_REQ, fetchSpeakingPriceBundle);
            case 10:
                _ctx.next = 12;
                return takeLatest$1(CANCEL_SPEAKING_CLUB_BATCH, cancelSpeakingClubBatch);
            case 12:
                _ctx.next = 14;
                return takeLatest$1(RESCHEDULE_SPEAKING_CLUB_BATCH, rescheduleSpeakingClubBatch);
            case 14:
                _ctx.next = 16;
                return takeLatest$1(GET_FLSE_VISIBILITY_ACTION, getFlseVisibilitySaga);
            case 16:
            case "end":
                return _ctx.stop();
        }
    }, SpeakingClubSaga_marked);
}
/* harmony default export */ var SpeakingClubSaga = (speakingClubSaga);

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/ClassRecordings/redux/ClassRecordingsApi.ts



var fetchRecordings = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(batchId) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=video/batch/".concat(batchId), {
                        headers: {
                            "X-API-VERSION": "4"
                        }
                    });
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    throw new Error(res.data.message);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please try after sometime");
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchRecordings(batchId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchVideo = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=video/batch/".concat(payload.batchId, "/").concat(payload.videoId), {
                        headers: {
                            "X-API-VERSION": "4"
                        }
                    });
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    throw new Error(res.data.message);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please try after sometime");
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchVideo(payload) {
        return _ref.apply(this, arguments);
    };
}();
var fetchSelfPrepRecordings = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=video/test-prep", {
                        headers: {
                            "X-API-VERSION": "2"
                        }
                    });
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    throw new Error(res.data.message);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please try after sometime");
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchSelfPrepRecordings() {
        return _ref.apply(this, arguments);
    };
}();
var fetchGrammarRecordings = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=video/grammar-class", {});
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    throw new Error(res.data.message);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please try after sometime");
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchGrammarRecordings() {
        return _ref.apply(this, arguments);
    };
}();
var classRecordingsApi = {
    fetchRecordings: fetchRecordings,
    fetchVideo: fetchVideo,
    fetchSelfPrepRecordings: fetchSelfPrepRecordings,
    fetchGrammarRecordings: fetchGrammarRecordings
};

// EXTERNAL MODULE: ./components/Profile/IeltsProfile/ClassRecordings/redux/ClassRecordingsActions.ts
var ClassRecordingsActions = __webpack_require__(3676);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/ClassRecordings/classRecordingUtil.ts



var getClassRecordingPayload = function(playList) {
    if (playList && playList.length > 0) {
        var mainVideo = playList[0];
        if (!playList) {
            playList = [];
        }
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mainVideo), {
            playList: (0,_to_consumable_array/* default */.Z)(playList)
        });
    }
    return null;
};

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/ClassRecordings/redux/ClassRecordingsSaga.ts




var ClassRecordingsSaga_marked = runtime_default().mark(recordingsSaga);
var ClassRecordingsSaga_marked1 = runtime_default().mark(fetchSelfPrepVideoSaga);
var ClassRecordingsSaga_marked2 = runtime_default().mark(fetchGrammarDataSaga);
var ClassRecordingsSaga_marked3 = runtime_default().mark(fetchSelfPrepDataSaga);
var ClassRecordingsSaga_marked4 = runtime_default().mark(ClassRecordingsSaga_fetchVideo);
var ClassRecordingsSaga_marked5 = runtime_default().mark(ClassRecordingsSaga_fetchData);




function ClassRecordingsSaga_fetchData(action) {
    var res, modifiedRes;
    return runtime_default().wrap(function fetchData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.Y)(ClassRecordingsActions/* classRecordingsActions.setRecordingsLoading */.M.setRecordingsLoading(true));
            case 3:
                _ctx.next = 5;
                return (0,io_c3792963.N)(classRecordingsApi.fetchRecordings, action.payload);
            case 5:
                res = _ctx.sent;
                modifiedRes = null;
                if (res) {
                    if (!res.playList) {
                        res.playList = [];
                    }
                    modifiedRes = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, res), {
                        playList: [
                            {
                                id: res.id,
                                title: res.title,
                                url: res.url,
                                imageUrl: res.imageUrl,
                                createdAt: res.createdAt,
                                batchClassTopic: res === null || res === void 0 ? void 0 : res.batchClassTopic
                            }, 
                        ].concat((0,_to_consumable_array/* default */.Z)(res.playList))
                    });
                }
                _ctx.next = 10;
                return (0,io_c3792963.Y)(ClassRecordingsActions/* classRecordingsActions.fetchRecordingsSuccess */.M.fetchRecordingsSuccess(modifiedRes));
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)(ClassRecordingsActions/* classRecordingsActions.setRecordingsLoading */.M.setRecordingsLoading(false));
            case 12:
                _ctx.next = 21;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 19;
                return (0,io_c3792963.Y)(ClassRecordingsActions/* classRecordingsActions.fetchRecordingsFail */.M.fetchRecordingsFail(_ctx.t0.message));
            case 19:
                _ctx.next = 21;
                return (0,io_c3792963.Y)(ClassRecordingsActions/* classRecordingsActions.setRecordingsLoading */.M.setRecordingsLoading(false));
            case 21:
            case "end":
                return _ctx.stop();
        }
    }, ClassRecordingsSaga_marked5, null, [
        [
            0,
            14
        ]
    ]);
}
function ClassRecordingsSaga_fetchVideo(action) {
    var res, modifiedRes;
    return runtime_default().wrap(function fetchVideo$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(classRecordingsApi.fetchVideo, action.payload);
            case 3:
                res = _ctx.sent;
                modifiedRes = null;
                if (res) {
                    if (!res.playList) {
                        res.playList = [];
                    }
                    modifiedRes = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, res), {
                        playList: [
                            {
                                id: res.id,
                                title: res.title,
                                url: res.url,
                                imageUrl: res.imageUrl,
                                createdAt: res.createdAt,
                                batchClassTopic: res === null || res === void 0 ? void 0 : res.batchClassTopic
                            }, 
                        ].concat((0,_to_consumable_array/* default */.Z)(res.playList))
                    });
                }
                _ctx.next = 8;
                return (0,io_c3792963.Y)(ClassRecordingsActions/* classRecordingsActions.fetchVideoSuccess */.M.fetchVideoSuccess(modifiedRes));
            case 8:
                _ctx.next = 15;
                break;
            case 10:
                _ctx.prev = 10;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 15;
                return (0,io_c3792963.Y)(ClassRecordingsActions/* classRecordingsActions.fetchVideoFail */.M.fetchVideoFail(_ctx.t0.message));
            case 15:
            case "end":
                return _ctx.stop();
        }
    }, ClassRecordingsSaga_marked4, null, [
        [
            0,
            10
        ]
    ]);
}
function fetchSelfPrepDataSaga(action) {
    var res;
    return runtime_default().wrap(function fetchSelfPrepDataSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.Y)(ClassRecordingsActions/* classRecordingsActions.setRecordingsLoading */.M.setRecordingsLoading(true));
            case 3:
                _ctx.next = 5;
                return (0,io_c3792963.N)(classRecordingsApi.fetchSelfPrepRecordings);
            case 5:
                res = _ctx.sent;
                _ctx.next = 8;
                return (0,io_c3792963.Y)(ClassRecordingsActions/* classRecordingsActions.fetchRecordingsSuccess */.M.fetchRecordingsSuccess(getClassRecordingPayload((res === null || res === void 0 ? void 0 : res.playList) || null)));
            case 8:
                _ctx.next = 10;
                return (0,io_c3792963.Y)(ClassRecordingsActions/* classRecordingsActions.setRecordingsLoading */.M.setRecordingsLoading(false));
            case 10:
                _ctx.next = 19;
                break;
            case 12:
                _ctx.prev = 12;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(ClassRecordingsActions/* classRecordingsActions.setRecordingsLoading */.M.setRecordingsLoading(false));
            case 17:
                _ctx.next = 19;
                return (0,io_c3792963.Y)(ClassRecordingsActions/* classRecordingsActions.fetchRecordingsFail */.M.fetchRecordingsFail(_ctx.t0.message));
            case 19:
            case "end":
                return _ctx.stop();
        }
    }, ClassRecordingsSaga_marked3, null, [
        [
            0,
            12
        ]
    ]);
}
function fetchGrammarDataSaga(action) {
    var res;
    return runtime_default().wrap(function fetchGrammarDataSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.Y)(ClassRecordingsActions/* classRecordingsActions.setRecordingsLoading */.M.setRecordingsLoading(true));
            case 3:
                _ctx.next = 5;
                return (0,io_c3792963.N)(classRecordingsApi.fetchGrammarRecordings);
            case 5:
                res = _ctx.sent;
                _ctx.next = 8;
                return (0,io_c3792963.Y)(ClassRecordingsActions/* classRecordingsActions.fetchRecordingsSuccess */.M.fetchRecordingsSuccess(getClassRecordingPayload((res === null || res === void 0 ? void 0 : res.playList) || null)));
            case 8:
                _ctx.next = 15;
                break;
            case 10:
                _ctx.prev = 10;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 15;
                return (0,io_c3792963.Y)(ClassRecordingsActions/* classRecordingsActions.fetchRecordingsFail */.M.fetchRecordingsFail(_ctx.t0.message));
            case 15:
                _ctx.prev = 15;
                _ctx.next = 18;
                return (0,io_c3792963.Y)(ClassRecordingsActions/* classRecordingsActions.setRecordingsLoading */.M.setRecordingsLoading(false));
            case 18:
                return _ctx.finish(15);
            case 19:
            case "end":
                return _ctx.stop();
        }
    }, ClassRecordingsSaga_marked2, null, [
        [
            0,
            10,
            15,
            19
        ]
    ]);
}
function fetchSelfPrepVideoSaga(action) {
    var classRecordings, modifiedRes, currentRecording;
    return runtime_default().wrap(function fetchSelfPrepVideoSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.Y)(ClassRecordingsActions/* classRecordingsActions.setRecordingsLoading */.M.setRecordingsLoading(true));
            case 3:
                _ctx.next = 5;
                return (0,io_c3792963.a3)(function(state) {
                    return state.classRecordings.recordingData;
                });
            case 5:
                classRecordings = _ctx.sent;
                modifiedRes = null;
                currentRecording = classRecordings.playList.find(function(recording) {
                    return recording.id == action.payload;
                });
                if (classRecordings && currentRecording) {
                    if (!classRecordings.playList) {
                        classRecordings.playList = [];
                    }
                    modifiedRes = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentRecording), {
                        playList: classRecordings.playList
                    });
                }
                _ctx.next = 11;
                return (0,io_c3792963.Y)(ClassRecordingsActions/* classRecordingsActions.fetchVideoSuccess */.M.fetchVideoSuccess(modifiedRes));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(ClassRecordingsActions/* classRecordingsActions.fetchVideoFail */.M.fetchVideoFail(_ctx.t0.message));
            case 18:
                _ctx.prev = 18;
                _ctx.next = 21;
                return (0,io_c3792963.Y)(ClassRecordingsActions/* classRecordingsActions.setRecordingsLoading */.M.setRecordingsLoading(false));
            case 21:
                return _ctx.finish(18);
            case 22:
            case "end":
                return _ctx.stop();
        }
    }, ClassRecordingsSaga_marked1, null, [
        [
            0,
            13,
            18,
            22
        ]
    ]);
}
function recordingsSaga() {
    return runtime_default().wrap(function recordingsSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("RECORDINGS_FETCH_REQUESTED", ClassRecordingsSaga_fetchData);
            case 2:
                _ctx.next = 4;
                return takeLatest$1("VIDEO_FETCH_REQUESTED", ClassRecordingsSaga_fetchVideo);
            case 4:
                _ctx.next = 6;
                return takeLatest$1("SELF_PREP_RECORDINGS_FETCH_REQUESTED", fetchSelfPrepDataSaga);
            case 6:
                _ctx.next = 8;
                return takeLatest$1("GRAMMAR_RECORDINGS_FETCH_REQUESTED", fetchGrammarDataSaga);
            case 8:
                _ctx.next = 10;
                return takeLatest$1("SELF_PREP_UPDATE_RECORDINGS", fetchSelfPrepVideoSaga);
            case 10:
            case "end":
                return _ctx.stop();
        }
    }, ClassRecordingsSaga_marked);
}
/* harmony default export */ var ClassRecordingsSaga = (recordingsSaga);

// EXTERNAL MODULE: ./components/Profile/IeltsProfile/NoticeBoard/redux/NoticeBoardActions.ts
var NoticeBoardActions = __webpack_require__(66362);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/NoticeBoard/redux/NoticeBoardApi.ts



var fetchNotices = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=workshop/notice-board/notice");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    throw new Error(res.data.message);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please try after sometime");
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchNotices() {
        return _ref.apply(this, arguments);
    };
}();
var noticeBoardApi = {
    fetchNotices: fetchNotices
};

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/NoticeBoard/redux/NoticeBoardSaga.ts

var NoticeBoardSaga_marked = runtime_default().mark(noticeBoardSaga);
var NoticeBoardSaga_marked1 = runtime_default().mark(fetchAllNotices);



function fetchAllNotices() {
    var res;
    return runtime_default().wrap(function fetchAllNotices$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(noticeBoardApi.fetchNotices);
            case 3:
                res = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)(NoticeBoardActions/* noticeBoardActions.fetchNoticeSuccess */.N.fetchNoticeSuccess(res));
            case 6:
                _ctx.next = 14;
                break;
            case 8:
                _ctx.prev = 8;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 13;
                return (0,io_c3792963.Y)(NoticeBoardActions/* noticeBoardActions.fetchNoticeFail */.N.fetchNoticeFail(_ctx.t0.message));
            case 13:
                throw new Error(_ctx.t0.message);
            case 14:
            case "end":
                return _ctx.stop();
        }
    }, NoticeBoardSaga_marked1, null, [
        [
            0,
            8
        ]
    ]);
}
function noticeBoardSaga() {
    return runtime_default().wrap(function noticeBoardSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("ALL_NOTICE_FETCH_REQUESTED", fetchAllNotices);
            case 2:
            case "end":
                return _ctx.stop();
        }
    }, NoticeBoardSaga_marked);
}
/* harmony default export */ var NoticeBoardSaga = (noticeBoardSaga);

// EXTERNAL MODULE: ./components/Profile/IeltsProfile/StudyMaterial/redux/StudyMaterialActions.ts
var StudyMaterialActions = __webpack_require__(49257);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/StudyMaterial/redux/StudyMaterialApi.ts



var fetchStudyMaterial = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(batchId) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=workshop/study-material/section/".concat(batchId));
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    throw new Error(res.data.message);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please contact the teach team");
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchStudyMaterial(batchId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchFastTrackStudyMaterial = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=workshop/study-material/global-sections");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    throw new Error(res.data.message);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please contact the teach team");
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchFastTrackStudyMaterial() {
        return _ref.apply(this, arguments);
    };
}();
var studyMaterialApi = {
    fetchStudyMaterial: fetchStudyMaterial,
    fetchFastTrackStudyMaterial: fetchFastTrackStudyMaterial
};

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/StudyMaterial/redux/StudyMaterialSaga.ts

var StudyMaterialSaga_marked = runtime_default().mark(studyMaterialSaga);
var StudyMaterialSaga_marked1 = runtime_default().mark(StudyMaterialSaga_fetchFastTrackStudyMaterial);
var StudyMaterialSaga_marked2 = runtime_default().mark(StudyMaterialSaga_fetchStudyMaterial);



function StudyMaterialSaga_fetchStudyMaterial(action) {
    var res;
    return runtime_default().wrap(function fetchStudyMaterial$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(studyMaterialApi.fetchStudyMaterial, action.payload);
            case 3:
                res = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)(StudyMaterialActions/* studyMaterialActions.fetchStudyMaterialSuccess */.g.fetchStudyMaterialSuccess(res));
            case 6:
                _ctx.next = 13;
                break;
            case 8:
                _ctx.prev = 8;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 13;
                return (0,io_c3792963.Y)(StudyMaterialActions/* studyMaterialActions.fetchStudyMaterialFail */.g.fetchStudyMaterialFail(_ctx.t0.message));
            case 13:
            case "end":
                return _ctx.stop();
        }
    }, StudyMaterialSaga_marked2, null, [
        [
            0,
            8
        ]
    ]);
}
function StudyMaterialSaga_fetchFastTrackStudyMaterial() {
    var res;
    return runtime_default().wrap(function fetchFastTrackStudyMaterial$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(studyMaterialApi.fetchFastTrackStudyMaterial);
            case 3:
                res = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)(StudyMaterialActions/* studyMaterialActions.fetchStudyMaterialSuccess */.g.fetchStudyMaterialSuccess(res));
            case 6:
                _ctx.next = 13;
                break;
            case 8:
                _ctx.prev = 8;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 13;
                return (0,io_c3792963.Y)(StudyMaterialActions/* studyMaterialActions.fetchStudyMaterialFail */.g.fetchStudyMaterialFail(_ctx.t0.message));
            case 13:
            case "end":
                return _ctx.stop();
        }
    }, StudyMaterialSaga_marked1, null, [
        [
            0,
            8
        ]
    ]);
}
function studyMaterialSaga() {
    return runtime_default().wrap(function studyMaterialSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("STUDY_MATERIAL_FETCH_REQUESTED", StudyMaterialSaga_fetchStudyMaterial);
            case 2:
                _ctx.next = 4;
                return takeLatest$1("FAST_TRACK_STUDY_MATERIAL_FETCH_REQUESTED", StudyMaterialSaga_fetchFastTrackStudyMaterial);
            case 4:
            case "end":
                return _ctx.stop();
        }
    }, StudyMaterialSaga_marked);
}
/* harmony default export */ var StudyMaterialSaga = (studyMaterialSaga);

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/MyClasses/redux/MyClassApi.ts



var MyClassApi_enrollStudentToIeltsPlus = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(batchId) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=student/workshop/1/".concat(batchId, "/enroll"));
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", true);
                case 8:
                    throw new Error(res.data.message);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please try after sometime");
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function enrollStudentToIeltsPlus(batchId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchMasterClassData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=v2/workshop/MASTER_CLASS/0/12");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    throw new Error(res.data.message);
                case 9:
                    _ctx.next = 15;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    throw new Error("Something went wrong. Please try after sometime");
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchMasterClassData() {
        return _ref.apply(this, arguments);
    };
}();
var enrollStudentToMasterClass = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=workshop/master-class/subscribe");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", true);
                case 8:
                    throw new Error(res.data.message);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please try after sometime");
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function enrollStudentToMasterClass() {
        return _ref.apply(this, arguments);
    };
}();
var notifyUser = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(batchId) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=workshop/enroll/".concat(batchId, "/MASTER_CLASS"));
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please try after sometime");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function notifyUser(batchId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchMasterclassSubscriptionStatus = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=workshop/master-class-subscription-status");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please try after sometime");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchMasterclassSubscriptionStatus() {
        return _ref.apply(this, arguments);
    };
}();
var myClassApi = {
    enrollStudentToIeltsPlus: MyClassApi_enrollStudentToIeltsPlus,
    fetchMasterClassData: fetchMasterClassData,
    enrollStudentToMasterClass: enrollStudentToMasterClass,
    notifyUser: notifyUser,
    fetchMasterclassSubscriptionStatus: fetchMasterclassSubscriptionStatus
};

// EXTERNAL MODULE: ./components/Profile/MasterclassRegistrationForm/redux/MasterclassRegistrationFormAction.ts
var MasterclassRegistrationFormAction = __webpack_require__(42133);
// EXTERNAL MODULE: ./components/Profile/IeltsProfile/Masterclass/redux/MasterclassActions.ts
var MasterclassActions = __webpack_require__(5721);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/MyClasses/redux/MyClassSaga.ts
/* eslint-disable @typescript-eslint/no-unused-vars */ 
var MyClassSaga_marked = runtime_default().mark(myClassSaga);
var MyClassSaga_marked1 = runtime_default().mark(MyClassSaga_fetchMasterclassSubscriptionStatus);
var MyClassSaga_marked2 = runtime_default().mark(MyClassSaga_notifyUser);
var MyClassSaga_marked3 = runtime_default().mark(enrollToMasterClass);






function enrollToMasterClass(action) {
    var res;
    return runtime_default().wrap(function enrollToMasterClass$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(myClassApi.enrollStudentToMasterClass);
            case 3:
                res = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)(MyClassActions/* myClassAction.enrollToMasterClassSuccess */.e.enrollToMasterClassSuccess(res));
            case 6:
                _ctx.next = 8;
                return (0,io_c3792963.Y)(MasterclassRegistrationFormAction/* masterclassRegistrationActions.toggleShowForm */.Z.toggleShowForm(false));
            case 8:
                _ctx.next = 10;
                return (0,io_c3792963.Y)(MasterclassRegistrationFormAction/* masterclassRegistrationActions.toggleMasterclassFormModal */.Z.toggleMasterclassFormModal(true));
            case 10:
                _ctx.next = 17;
                break;
            case 12:
                _ctx.prev = 12;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(MyClassActions/* myClassAction.enrollToMasterClassFail */.e.enrollToMasterClassFail(_ctx.t0.message));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, MyClassSaga_marked3, null, [
        [
            0,
            12
        ]
    ]);
}
function MyClassSaga_notifyUser(action) {
    var res;
    return runtime_default().wrap(function notifyUser$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(myClassApi.notifyUser, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 13;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.fetchMasterclassData */.u.fetchMasterclassData());
            case 7:
                _ctx.next = 9;
                return (0,io_c3792963.Y)(UpcomingClassActions/* upcomingClassActions.fetchUpcomingClassData */.n.fetchUpcomingClassData());
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.toggleConfirmationModal */.u.toggleConfirmationModal(true));
            case 11:
                _ctx.next = 14;
                break;
            case 13:
                {
                    console.log(res.message);
                }
            case 14:
                _ctx.next = 19;
                break;
            case 16:
                _ctx.prev = 16;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
            case 19:
            case "end":
                return _ctx.stop();
        }
    }, MyClassSaga_marked2, null, [
        [
            0,
            16
        ]
    ]);
}
function MyClassSaga_fetchMasterclassSubscriptionStatus() {
    var res;
    return runtime_default().wrap(function fetchMasterclassSubscriptionStatus$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(myClassApi.fetchMasterclassSubscriptionStatus);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(MyClassActions/* myClassAction.fetchMasterclassSubscriptionStatusSuccess */.e.fetchMasterclassSubscriptionStatusSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(MyClassActions/* myClassAction.fetchMasterclassSubscriptionStatusFail */.e.fetchMasterclassSubscriptionStatusFail(res.message));
            case 11:
                _ctx.next = 16;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
            case 16:
            case "end":
                return _ctx.stop();
        }
    }, MyClassSaga_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function myClassSaga() {
    return runtime_default().wrap(function myClassSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(MyClassActions/* myClassActionType.NOTIFY_USER_FOR_MASTERCLASS */.j.NOTIFY_USER_FOR_MASTERCLASS, MyClassSaga_notifyUser);
            case 2:
            case "end":
                return _ctx.stop();
        }
    }, MyClassSaga_marked);
// yield takeLatest("FETCH_MASTERCLASS_SUBSCRIPTION_STATUS", fetchMasterclassSubscriptionStatus);
}
/* harmony default export */ var MyClassSaga = (myClassSaga);

// EXTERNAL MODULE: ./DataMapper/Common/WorkshopData.ts
var WorkshopData = __webpack_require__(93957);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/UpcomingClass/redux/upcomingApi.ts




var fetchUpcomingClass = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=workshop/enroll/upcoming", {
                        headers: {
                            "X-API-VERSION": "3"
                        }
                    });
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    throw new Error(res.data.message);
                case 9:
                    _ctx.next = 15;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    throw new Error("Something went wrong. Please try after sometime");
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchUpcomingClass() {
        return _ref.apply(this, arguments);
    };
}();
var enhanceUpcomingClass = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=api/workshop/upcoming", {
                        enrollmentStatus: true,
                        workshops: [
                            WorkshopData/* batchType.ORIENTATION_WORKSHOP */.d.ORIENTATION_WORKSHOP
                        ]
                    });
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    throw new Error(res.data.message);
                case 9:
                    _ctx.next = 15;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    throw new Error("Something went wrong. Please try after sometime");
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function enhanceUpcomingClass() {
        return _ref.apply(this, arguments);
    };
}();
var fetchLiveClass = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=workshop/enroll/live");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    throw new Error(res.data.message);
                case 9:
                    _ctx.next = 15;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    throw new Error("Something went wrong. Please try after sometime");
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchLiveClass() {
        return _ref.apply(this, arguments);
    };
}();
var enhanceLiveClass = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(includeNextClass) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=api/workshop/live", {
                        workshops: [
                            WorkshopData/* batchType.MASTER_CLASS */.d.MASTER_CLASS,
                            WorkshopData/* batchType.ONLINE_WORKSHOP */.d.ONLINE_WORKSHOP
                        ],
                        getBeforeLiveInMin: includeNextClass || 0
                    });
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    throw new Error(res.data.message);
                case 9:
                    _ctx.next = 15;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    throw new Error("Something went wrong. Please try after sometime");
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function enhanceLiveClass(includeNextClass) {
        return _ref.apply(this, arguments);
    };
}();
var enhanceEnrolmentClass = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=api/enrollment/enroll", {
                        workshops: [
                            WorkshopData/* batchType.ORIENTATION_WORKSHOP */.d.ORIENTATION_WORKSHOP
                        ]
                    });
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    throw new Error(res.data.message);
                case 9:
                    _ctx.next = 15;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    throw new Error("Something went wrong. Please try after sometime");
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function enhanceEnrolmentClass() {
        return _ref.apply(this, arguments);
    };
}();
var fetchVoiceRoomApi = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=voicerooms/live_now");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 8:
                    throw new Error(res.data.message);
                case 9:
                    _ctx.next = 15;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    throw new Error("Something went wrong. Please try after sometime");
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchVoiceRoomApi() {
        return _ref.apply(this, arguments);
    };
}();
var upcomingApi = {
    fetchUpcomingClass: fetchUpcomingClass,
    fetchLiveClass: fetchLiveClass,
    enhanceLiveClass: enhanceLiveClass,
    enhanceUpcomingClass: enhanceUpcomingClass,
    fetchVoiceRoomApi: fetchVoiceRoomApi,
    enhanceEnrolmentClass: enhanceEnrolmentClass
};

// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(89734);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/UpcomingClass/redux/upcomingSaga.ts


var upcomingSaga_marked = runtime_default().mark(upcomingSaga);
var upcomingSaga_marked1 = runtime_default().mark(fetchOrientationClass);
var upcomingSaga_marked2 = runtime_default().mark(fetchVoiceRoomSaga);
var upcomingSaga_marked3 = runtime_default().mark(fetchLiveMasterclass);
var upcomingSaga_marked4 = runtime_default().mark(liveMasterclassSection);
var upcomingSaga_marked5 = runtime_default().mark(liveIeltsSection);
var upcomingSaga_marked6 = runtime_default().mark(upcomingExtraClass);
var upcomingSaga_marked7 = runtime_default().mark(liveClassSuccess);
var upcomingSaga_marked8 = runtime_default().mark(fetchUpcomingClassData);







function fetchUpcomingClassData() {
    var res, data;
    return runtime_default().wrap(function fetchUpcomingClassData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963._)([
                    (0,io_c3792963.N)(upcomingApi.fetchUpcomingClass),
                    (0,io_c3792963.N)(upcomingApi.enhanceUpcomingClass), 
                ]);
            case 3:
                res = _ctx.sent;
                data = (0,_object_spread/* default */.Z)({}, res[0], res[1]);
                _ctx.next = 7;
                return (0,io_c3792963.N)(upcomingExtraClass, data);
            case 7:
                _ctx.next = 9;
                return (0,io_c3792963.N)(fetchOrientationClass, data);
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(UpcomingClassActions/* upcomingClassActions.fetchUpcomingClassSuccess */.n.fetchUpcomingClassSuccess(res));
            case 11:
                _ctx.next = 13;
                return (0,io_c3792963.N)(liveClassSuccess);
            case 13:
                _ctx.next = 20;
                break;
            case 15:
                _ctx.prev = 15;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 20;
                return (0,io_c3792963.Y)(UpcomingClassActions/* upcomingClassActions.fetchUpcomingClassFail */.n.fetchUpcomingClassFail(_ctx.t0.message));
            case 20:
            case "end":
                return _ctx.stop();
        }
    }, upcomingSaga_marked8, null, [
        [
            0,
            15
        ]
    ]);
}
function liveClassSuccess() {
    var res, result;
    return runtime_default().wrap(function liveClassSuccess$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.Y)(UpcomingClassActions/* upcomingClassActions.setLoading */.n.setLoading(true));
            case 3:
                _ctx.next = 5;
                return (0,io_c3792963._)([
                    (0,io_c3792963.N)(upcomingApi.fetchLiveClass),
                    (0,io_c3792963.N)(upcomingApi.enhanceLiveClass), 
                ]);
            case 5:
                res = _ctx.sent;
                result = (0,_object_spread/* default */.Z)({}, res[0], res[1]);
                _ctx.next = 9;
                return (0,io_c3792963.N)(liveIeltsSection, result);
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.N)(liveMasterclassSection, result);
            case 11:
                _ctx.next = 13;
                return (0,io_c3792963.Y)(UpcomingClassActions/* upcomingClassActions.setLoading */.n.setLoading(false));
            case 13:
                _ctx.next = 22;
                break;
            case 15:
                _ctx.prev = 15;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 20;
                return (0,io_c3792963.Y)(UpcomingClassActions/* upcomingClassActions.setLoading */.n.setLoading(false));
            case 20:
                _ctx.next = 22;
                return (0,io_c3792963.Y)(UpcomingClassActions/* upcomingClassActions.fetchUpcomingClassFail */.n.fetchUpcomingClassFail(_ctx.t0.message));
            case 22:
            case "end":
                return _ctx.stop();
        }
    }, upcomingSaga_marked7, null, [
        [
            0,
            15
        ]
    ]);
}
function upcomingExtraClass(data) {
    var priorityList, filterUpcomingExtraClass, result;
    return runtime_default().wrap(function upcomingExtraClass$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                priorityList = [
                    "SPEAKING_WORKSHOP",
                    "DOUBT_WORKSHOP"
                ];
                filterUpcomingExtraClass = function(data) {
                    return data.workshopType != WorkshopData/* batchType.ONLINE_WORKSHOP */.d.ONLINE_WORKSHOP && data.workshopType != WorkshopData/* batchType.ORIENTATION_WORKSHOP */.d.ORIENTATION_WORKSHOP;
                };
                result = sortBy_default()((0,batches/* repackUpcomingClass */.I6)(data, filterUpcomingExtraClass, priorityList).filter(function(data) {
                    return data;
                }), function(value) {
                    return new Date(value.meetingStartTime);
                }).filter(function(data) {
                    return moment_default()(data.meetingStartTime) > moment_default()();
                });
                _ctx.next = 6;
                return (0,io_c3792963.Y)(UpcomingClassActions/* upcomingClassActions.fetchUpcomingextraClassSuccess */.n.fetchUpcomingextraClassSuccess(result));
            case 6:
                _ctx.next = 13;
                break;
            case 8:
                _ctx.prev = 8;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 13;
                return (0,io_c3792963.Y)(UpcomingClassActions/* upcomingClassActions.fetchUpcomingClassFail */.n.fetchUpcomingClassFail(_ctx.t0.message));
            case 13:
            case "end":
                return _ctx.stop();
        }
    }, upcomingSaga_marked6, null, [
        [
            0,
            8
        ]
    ]);
}
function liveIeltsSection(data) {
    var priorityList, result;
    return runtime_default().wrap(function liveIeltsSection$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                priorityList = [
                    WorkshopData/* batchType.ONLINE_WORKSHOP */.d.ONLINE_WORKSHOP,
                    WorkshopData/* batchType.SPEAKING_WORKSHOP */.d.SPEAKING_WORKSHOP,
                    WorkshopData/* batchType.MASTER_CLASS */.d.MASTER_CLASS,
                    WorkshopData/* batchType.DOUBT_WORKSHOP */.d.DOUBT_WORKSHOP,
                    WorkshopData/* batchType.FAST_TRACK_EXTRA_CLASSES */.d.FAST_TRACK_EXTRA_CLASSES, 
                ];
                result = (0,batches/* repackUpcomingClass */.I6)(data, null, priorityList).filter(function(data) {
                    return data;
                });
                _ctx.next = 5;
                return (0,io_c3792963.Y)(UpcomingClassActions/* upcomingClassActions.setUpcomingIelts */.n.setUpcomingIelts(result));
            case 5:
                _ctx.next = 12;
                break;
            case 7:
                _ctx.prev = 7;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 12;
                return (0,io_c3792963.Y)(UpcomingClassActions/* upcomingClassActions.fetchUpcomingClassFail */.n.fetchUpcomingClassFail(_ctx.t0.message));
            case 12:
            case "end":
                return _ctx.stop();
        }
    }, upcomingSaga_marked5, null, [
        [
            0,
            7
        ]
    ]);
}
function liveMasterclassSection(data) {
    var priorityList, result;
    return runtime_default().wrap(function liveMasterclassSection$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                priorityList = [
                    "BEGINNER_MASTER_CLASS",
                    "MASTER_CLASS"
                ];
                result = (0,batches/* repackUpcomingClass */.I6)(data, null, priorityList).filter(function(data) {
                    return data;
                });
                _ctx.next = 5;
                return (0,io_c3792963.Y)(UpcomingClassActions/* upcomingClassActions.setUpcomingMasterclass */.n.setUpcomingMasterclass(result));
            case 5:
                _ctx.next = 12;
                break;
            case 7:
                _ctx.prev = 7;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 12;
                return (0,io_c3792963.Y)(UpcomingClassActions/* upcomingClassActions.fetchUpcomingClassFail */.n.fetchUpcomingClassFail(_ctx.t0.message));
            case 12:
            case "end":
                return _ctx.stop();
        }
    }, upcomingSaga_marked4, null, [
        [
            0,
            7
        ]
    ]);
}
function fetchLiveMasterclass(action) {
    var res;
    return runtime_default().wrap(function fetchLiveMasterclass$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return (0,io_c3792963.N)(upcomingApi.enhanceLiveClass, action.payload);
            case 2:
                res = _ctx.sent;
                if (!res) {
                    _ctx.next = 6;
                    break;
                }
                _ctx.next = 6;
                return (0,io_c3792963.N)(liveMasterclassSection, res);
            case 6:
            case "end":
                return _ctx.stop();
        }
    }, upcomingSaga_marked3);
}
function fetchVoiceRoomSaga() {
    var res;
    return runtime_default().wrap(function fetchVoiceRoomSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(upcomingApi.fetchVoiceRoomApi);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(UpcomingClassActions/* upcomingClassActions.fetchVoiceRoomSuccess */.n.fetchVoiceRoomSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(UpcomingClassActions/* upcomingClassActions.fetchUpcomingClassFail */.n.fetchUpcomingClassFail("Something Went Wrong!"));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(UpcomingClassActions/* upcomingClassActions.fetchUpcomingClassFail */.n.fetchUpcomingClassFail("Something Went Wrong!"));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, upcomingSaga_marked2, null, [
        [
            0,
            13
        ]
    ]);
}
function fetchOrientationClass(data) {
    var filterUpcomingExtraClass, result, enrolOrientationClass;
    return runtime_default().wrap(function fetchOrientationClass$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                filterUpcomingExtraClass = function(data) {
                    return data.workshopType == WorkshopData/* batchType.ORIENTATION_WORKSHOP */.d.ORIENTATION_WORKSHOP;
                };
                result = sortBy_default()((0,batches/* repackUpcomingClass */.I6)(data, filterUpcomingExtraClass).filter(function(data) {
                    return data;
                }), function(value) {
                    return new Date(value.meetingStartTime);
                });
                enrolOrientationClass = result.filter(function(data) {
                    return data.isEnrolled;
                });
                _ctx.next = 6;
                return (0,io_c3792963.Y)(UpcomingClassActions/* upcomingClassActions.setOrientationClass */.n.setOrientationClass(result));
            case 6:
                _ctx.next = 8;
                return (0,io_c3792963.Y)(UpcomingClassActions/* upcomingClassActions.setOrientationEnrollment */.n.setOrientationEnrollment(enrolOrientationClass));
            case 8:
                _ctx.next = 15;
                break;
            case 10:
                _ctx.prev = 10;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 15;
                return (0,io_c3792963.Y)(UpcomingClassActions/* upcomingClassActions.fetchUpcomingClassFail */.n.fetchUpcomingClassFail("Something Went Wrong!"));
            case 15:
            case "end":
                return _ctx.stop();
        }
    }, upcomingSaga_marked1, null, [
        [
            0,
            10
        ]
    ]);
}
function upcomingSaga() {
    return runtime_default().wrap(function upcomingSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(UpcomingClassActions/* upcomingType.UPCOMING_CLASS_FETCH_REQUESTED */.r.UPCOMING_CLASS_FETCH_REQUESTED, fetchUpcomingClassData);
            case 2:
                _ctx.next = 4;
                return takeLatest$1(UpcomingClassActions/* upcomingType.LIVE_CLASS_FETCH_REQUESTED */.r.LIVE_CLASS_FETCH_REQUESTED, liveClassSuccess);
            case 4:
                _ctx.next = 6;
                return takeLatest$1(UpcomingClassActions/* upcomingType.LIVE_MASTERCLASS_FETCH_REQUESTED */.r.LIVE_MASTERCLASS_FETCH_REQUESTED, fetchLiveMasterclass);
            case 6:
                _ctx.next = 8;
                return takeLatest$1(UpcomingClassActions/* upcomingType.FETCH_VOICE_ROOM_DATA */.r.FETCH_VOICE_ROOM_DATA, fetchVoiceRoomSaga);
            case 8:
            case "end":
                return _ctx.stop();
        }
    }, upcomingSaga_marked);
}
/* harmony default export */ var redux_upcomingSaga = (upcomingSaga);

// EXTERNAL MODULE: ./components/Profile/ReferAndEarn/redux/ReferAndEarnActions.ts
var ReferAndEarnActions = __webpack_require__(94063);
;// CONCATENATED MODULE: ./components/Profile/ReferAndEarn/redux/ReferAndEarnApi.ts



var fetchUserDetails = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=student/basic");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    throw new Error(res.data.message);
                case 9:
                    _ctx.next = 15;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    throw new Error("Something went wrong. Please try after some time");
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchUserDetails() {
        return _ref.apply(this, arguments);
    };
}();
var fetchDETUserDetails = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=det-elite/details");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    console.log("Error in fetching user details");
                    return _ctx.abrupt("return", null);
                case 10:
                    _ctx.next = 16;
                    break;
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return", null);
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }));
    return function fetchDETUserDetails() {
        return _ref.apply(this, arguments);
    };
}();
var referAndEarnApi = {
    fetchUserDetails: fetchUserDetails,
    fetchDETUserDetails: fetchDETUserDetails
};

;// CONCATENATED MODULE: ./components/Profile/ReferAndEarn/redux/ReferAndEarnSaga.ts

var ReferAndEarnSaga_marked = runtime_default().mark(referAndEarnSaga);
var ReferAndEarnSaga_marked1 = runtime_default().mark(ReferAndEarnSaga_fetchData);



function ReferAndEarnSaga_fetchData() {
    var userDetails;
    return runtime_default().wrap(function fetchData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(referAndEarnApi.fetchUserDetails);
            case 3:
                userDetails = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)(ReferAndEarnActions/* referAndEarnActions.fetchSuccess */.F.fetchSuccess(userDetails));
            case 6:
                _ctx.next = 13;
                break;
            case 8:
                _ctx.prev = 8;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 13;
                return (0,io_c3792963.Y)(ReferAndEarnActions/* referAndEarnActions.fetchFail */.F.fetchFail(_ctx.t0.message));
            case 13:
            case "end":
                return _ctx.stop();
        }
    }, ReferAndEarnSaga_marked1, null, [
        [
            0,
            8
        ]
    ]);
}
function referAndEarnSaga() {
    return runtime_default().wrap(function referAndEarnSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("USER_DETAILS_FETCH_REQUESTED", ReferAndEarnSaga_fetchData);
            case 2:
            case "end":
                return _ctx.stop();
        }
    }, ReferAndEarnSaga_marked);
}
/* harmony default export */ var ReferAndEarnSaga = (referAndEarnSaga);

// EXTERNAL MODULE: ./components/Profile/CounsellingProfile/redux/CounsellingActions.ts
var CounsellingActions = __webpack_require__(63152);
;// CONCATENATED MODULE: ./components/Profile/CounsellingProfile/redux/CounsellingApis.ts



var fetchPostPaymentData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=student/post-payment");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchPostPaymentData() {
        return _ref.apply(this, arguments);
    };
}();
var fetchBookmarksData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=scholarship-finder/get-bookmarks", {
                        bookmarkType: "SCHOLARSHIP"
                    });
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchBookmarksData() {
        return _ref.apply(this, arguments);
    };
}();
var counsellingApi = {
    fetchPostPaymentData: fetchPostPaymentData,
    fetchBookmarksData: fetchBookmarksData
};

;// CONCATENATED MODULE: ./components/Profile/CounsellingProfile/redux/CounsellingSaga.ts

var CounsellingSaga_marked = runtime_default().mark(counsellingSaga);
var CounsellingSaga_marked1 = runtime_default().mark(fetchBookmarkData);
var CounsellingSaga_marked2 = runtime_default().mark(CounsellingSaga_fetchPostPaymentData);



function CounsellingSaga_fetchPostPaymentData() {
    var res;
    return runtime_default().wrap(function fetchPostPaymentData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(counsellingApi.fetchPostPaymentData);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(CounsellingActions/* counsellingActions.fetchPostPaymentDataSuccess */.P.fetchPostPaymentDataSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(CounsellingActions/* counsellingActions.fetchPostPaymentDataFail */.P.fetchPostPaymentDataFail(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(CounsellingActions/* counsellingActions.fetchCounsellingStageFail */.P.fetchCounsellingStageFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, CounsellingSaga_marked2, null, [
        [
            0,
            13
        ]
    ]);
}
function fetchBookmarkData() {
    var res;
    return runtime_default().wrap(function fetchBookmarkData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(counsellingApi.fetchBookmarksData);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(CounsellingActions/* counsellingActions.fetchScholarshipBookmarksSuccess */.P.fetchScholarshipBookmarksSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(CounsellingActions/* counsellingActions.fetchScholarshipBookmarksFail */.P.fetchScholarshipBookmarksFail(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(CounsellingActions/* counsellingActions.fetchScholarshipBookmarksFail */.P.fetchScholarshipBookmarksFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, CounsellingSaga_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function counsellingSaga() {
    return runtime_default().wrap(function counsellingSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("POST_PAYMENT_DATA_FETCH_REQUESTED", CounsellingSaga_fetchPostPaymentData);
            case 2:
                _ctx.next = 4;
                return takeLatest$1("FECTH_BOOKMARK_DATA_FETCH_REQUESTED", fetchBookmarkData);
            case 4:
            case "end":
                return _ctx.stop();
        }
    }, CounsellingSaga_marked);
}
/* harmony default export */ var CounsellingSaga = (counsellingSaga);

;// CONCATENATED MODULE: ./components/Profile/CounsellingFormExperiment/redux/CounsellingFormApis.ts



var fetchProfileData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=student/profile");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchProfileData() {
        return _ref.apply(this, arguments);
    };
}();
var saveProfile = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=student/profile", values);
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function saveProfile(values) {
        return _ref.apply(this, arguments);
    };
}();
var checkEligibilty = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=student/eligibility/ielts");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function checkEligibilty() {
        return _ref.apply(this, arguments);
    };
}();
var fetchIeltsNudgeData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=student/ielts-nudge");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchIeltsNudgeData() {
        return _ref.apply(this, arguments);
    };
}();
var saveIeltsNudgeData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=student/ielts-nudge", values);
                case 3:
                    res = _ctx.sent;
                    console.log("res from api", res.data.data);
                    return _ctx.abrupt("return", res);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function saveIeltsNudgeData(values) {
        return _ref.apply(this, arguments);
    };
}();
var counsellingFormApis = {
    fetchProfileData: fetchProfileData,
    saveProfile: saveProfile,
    checkEligibilty: checkEligibilty,
    fetchIeltsNudgeData: fetchIeltsNudgeData,
    saveIeltsNudgeData: saveIeltsNudgeData
};

// EXTERNAL MODULE: ./utils/common_utils.ts
var common_utils = __webpack_require__(92177);
;// CONCATENATED MODULE: ./components/Profile/CounsellingFormExperiment/redux/CounsellingFormSaga.ts

var CounsellingFormSaga_marked = runtime_default().mark(counsellingFormSaga);
var CounsellingFormSaga_marked1 = runtime_default().mark(CounsellingFormSaga_saveIeltsNudgeData);
var CounsellingFormSaga_marked2 = runtime_default().mark(CounsellingFormSaga_fetchIeltsNudgeData);
var CounsellingFormSaga_marked3 = runtime_default().mark(fetchEligibility);
var CounsellingFormSaga_marked4 = runtime_default().mark(CounsellingFormSaga_saveProfile);
var CounsellingFormSaga_marked5 = runtime_default().mark(fetchProfile);




function fetchProfile() {
    var res;
    return runtime_default().wrap(function fetchProfile$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(counsellingFormApis.fetchProfileData);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(CounsellingFormActions/* counsellingFormActions.fetchProfileSuccess */.W.fetchProfileSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(CounsellingFormActions/* counsellingFormActions.fetchProfileFail */.W.fetchProfileFail(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(CounsellingFormActions/* counsellingFormActions.fetchProfileFail */.W.fetchProfileFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, CounsellingFormSaga_marked5, null, [
        [
            0,
            13
        ]
    ]);
}
function CounsellingFormSaga_saveProfile(action) {
    var res;
    return runtime_default().wrap(function saveProfile$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.Y)(CounsellingFormActions/* counsellingFormActions.updateSaveCta */.W.updateSaveCta(true));
            case 3:
                _ctx.next = 5;
                return (0,io_c3792963.N)(counsellingFormApis.saveProfile, action.payload);
            case 5:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 15;
                    break;
                }
                _ctx.next = 9;
                return (0,io_c3792963.Y)(CounsellingFormActions/* counsellingFormActions.saveProfileSuccess */.W.saveProfileSuccess(res.data.data));
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(CounsellingFormActions/* counsellingFormActions.fetchEligibility */.W.fetchEligibility());
            case 11:
                _ctx.next = 13;
                return (0,io_c3792963.Y)(CounsellingFormActions/* counsellingFormActions.updateSaveCta */.W.updateSaveCta(false));
            case 13:
                _ctx.next = 19;
                break;
            case 15:
                _ctx.next = 17;
                return (0,io_c3792963.Y)(CounsellingFormActions/* counsellingFormActions.updateSaveCta */.W.updateSaveCta(false));
            case 17:
                _ctx.next = 19;
                return (0,io_c3792963.Y)(CounsellingFormActions/* counsellingFormActions.saveProfileFail */.W.saveProfileFail(res.data.message));
            case 19:
                _ctx.next = 28;
                break;
            case 21:
                _ctx.prev = 21;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 26;
                return (0,io_c3792963.Y)(CounsellingFormActions/* counsellingFormActions.updateSaveCta */.W.updateSaveCta(false));
            case 26:
                _ctx.next = 28;
                return (0,io_c3792963.Y)(CounsellingFormActions/* counsellingFormActions.fetchProfileFail */.W.fetchProfileFail(_ctx.t0.message));
            case 28:
            case "end":
                return _ctx.stop();
        }
    }, CounsellingFormSaga_marked4, null, [
        [
            0,
            21
        ]
    ]);
}
function fetchEligibility() {
    var res, callBackAfterFetchingEligibility;
    return runtime_default().wrap(function fetchEligibility$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(counsellingFormApis.checkEligibilty);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 13;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(CounsellingFormActions/* counsellingFormActions.fetchEligibilitySuccess */.W.fetchEligibilitySuccess(res.data.data));
            case 7:
                _ctx.next = 9;
                return (0,io_c3792963.a3)(function(state) {
                    return state.counsellingForm.postFetchEligibilityAction;
                });
            case 9:
                callBackAfterFetchingEligibility = _ctx.sent;
                if ((0,common_utils/* isFunction */.mf)(callBackAfterFetchingEligibility)) {
                    callBackAfterFetchingEligibility(res.data.data);
                }
                _ctx.next = 15;
                break;
            case 13:
                _ctx.next = 15;
                return (0,io_c3792963.Y)(CounsellingFormActions/* counsellingFormActions.fetchEligibilityFail */.W.fetchEligibilityFail(res.data.message));
            case 15:
                _ctx.next = 22;
                break;
            case 17:
                _ctx.prev = 17;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 22;
                return (0,io_c3792963.Y)(CounsellingFormActions/* counsellingFormActions.fetchEligibilityFail */.W.fetchEligibilityFail(_ctx.t0.message));
            case 22:
            case "end":
                return _ctx.stop();
        }
    }, CounsellingFormSaga_marked3, null, [
        [
            0,
            17
        ]
    ]);
}
function CounsellingFormSaga_fetchIeltsNudgeData() {
    var res;
    return runtime_default().wrap(function fetchIeltsNudgeData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(counsellingFormApis.fetchIeltsNudgeData);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(CounsellingFormActions/* counsellingFormActions.fetchIeltsNudgeDataSuccess */.W.fetchIeltsNudgeDataSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(CounsellingFormActions/* counsellingFormActions.fetchIeltsNudgeDataFail */.W.fetchIeltsNudgeDataFail(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(CounsellingFormActions/* counsellingFormActions.fetchIeltsNudgeDataFail */.W.fetchIeltsNudgeDataFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, CounsellingFormSaga_marked2, null, [
        [
            0,
            13
        ]
    ]);
}
function CounsellingFormSaga_saveIeltsNudgeData(action) {
    var res;
    return runtime_default().wrap(function saveIeltsNudgeData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(counsellingFormApis.saveIeltsNudgeData, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 11;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(CounsellingFormActions/* counsellingFormActions.saveIeltsNudgeDataSuccess */.W.saveIeltsNudgeDataSuccess(res.data.data));
            case 7:
                _ctx.next = 9;
                return (0,io_c3792963.Y)(CounsellingFormActions/* counsellingFormActions.fetchEligibility */.W.fetchEligibility());
            case 9:
                _ctx.next = 15;
                break;
            case 11:
                _ctx.next = 13;
                return (0,io_c3792963.Y)(CounsellingFormActions/* counsellingFormActions.updateSaveCta */.W.updateSaveCta(false));
            case 13:
                _ctx.next = 15;
                return (0,io_c3792963.Y)(CounsellingFormActions/* counsellingFormActions.saveProfileFail */.W.saveProfileFail(res.data.message));
            case 15:
                _ctx.next = 22;
                break;
            case 17:
                _ctx.prev = 17;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 22;
                return (0,io_c3792963.Y)(CounsellingFormActions/* counsellingFormActions.saveIeltsNudegeDataFail */.W.saveIeltsNudegeDataFail(_ctx.t0.message));
            case 22:
            case "end":
                return _ctx.stop();
        }
    }, CounsellingFormSaga_marked1, null, [
        [
            0,
            17
        ]
    ]);
}
function counsellingFormSaga() {
    return runtime_default().wrap(function counsellingFormSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("PROFILE_FETCH_REQUESTED", fetchProfile);
            case 2:
                _ctx.next = 4;
                return takeLatest$1("SAVE_PROFILE_REQUESTED", CounsellingFormSaga_saveProfile);
            case 4:
                _ctx.next = 6;
                return takeLatest$1("ELIGIBILITY_FETCH_REQUESTED", fetchEligibility);
            case 6:
                _ctx.next = 8;
                return takeLatest$1("FETCH_IELTS_NUDGE_DATA", CounsellingFormSaga_fetchIeltsNudgeData);
            case 8:
                _ctx.next = 10;
                return takeLatest$1("SAVE_IELTS_NUDGE_DATA", CounsellingFormSaga_saveIeltsNudgeData);
            case 10:
            case "end":
                return _ctx.stop();
        }
    }, CounsellingFormSaga_marked);
}
/* harmony default export */ var CounsellingFormSaga = (counsellingFormSaga);

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/EssayEvaluation/redux/EssayApi.ts



var uploadEssayApi = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
        var batchId, file, formData, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    batchId = payload.batchId, file = payload.file;
                    formData = new FormData();
                    formData.append("file", file);
                    _ctx.next = 6;
                    return api/* default.post */.Z.post("/api/uploadFile?name=workshop/essay/upload/".concat(batchId), formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    });
                case 6:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 11;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        success: true,
                        payload: res.data.data
                    });
                case 11:
                    return _ctx.abrupt("return", {
                        success: false,
                        payload: res.data.message
                    });
                case 12:
                    _ctx.next = 17;
                    break;
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        success: false,
                        payload: "res.data.message"
                    });
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                14
            ]
        ]);
    }));
    return function uploadEssayApi(payload) {
        return _ref.apply(this, arguments);
    };
}();
var replaceEssayApi = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
        var batchId, file, essayId, formData, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    batchId = payload.batchId, file = payload.file, essayId = payload.essayId;
                    formData = new FormData();
                    formData.append("file", file);
                    _ctx.next = 6;
                    return api/* default.post */.Z.post("/api/uploadFile?name=workshop/essay/upload/".concat(batchId, "/").concat(essayId), formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    });
                case 6:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 11;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        success: true,
                        payload: res.data.data
                    });
                case 11:
                    return _ctx.abrupt("return", {
                        success: false,
                        payload: res.data.message
                    });
                case 12:
                    _ctx.next = 17;
                    break;
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please try after sometime");
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                14
            ]
        ]);
    }));
    return function replaceEssayApi(payload) {
        return _ref.apply(this, arguments);
    };
}();
var fetchEssayApi = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(batchId) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=workshop/essay/".concat(batchId, "\n      "));
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        success: true,
                        payload: res.data.data
                    });
                case 8:
                    return _ctx.abrupt("return", {
                        success: false,
                        payload: res.data.message
                    });
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please try after sometime");
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchEssayApi(batchId) {
        return _ref.apply(this, arguments);
    };
}();
var essayApi = {
    uploadEssayApi: uploadEssayApi,
    fetchEssayApi: fetchEssayApi,
    replaceEssayApi: replaceEssayApi
};

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/EssayEvaluation/redux/EssaySaga.ts

var EssaySaga_marked = runtime_default().mark(essaySaga);
var EssaySaga_marked1 = runtime_default().mark(fetchEssaySaga);
var EssaySaga_marked2 = runtime_default().mark(replaceEssaySaga);
var EssaySaga_marked3 = runtime_default().mark(uploadEssaySaga);



function uploadEssaySaga(action) {
    var res;
    return runtime_default().wrap(function uploadEssaySaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(essayApi.uploadEssayApi, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(EssayActions/* essayAction.uploadEssaySuccess */.I.uploadEssaySuccess(res.payload));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(EssayActions/* essayAction.uploadEssayFail */.I.uploadEssayFail(res.payload));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(EssayActions/* essayAction.uploadEssayFail */.I.uploadEssayFail(_ctx.t0.message));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, EssaySaga_marked3, null, [
        [
            0,
            13
        ]
    ]);
}
function replaceEssaySaga(action) {
    var res;
    return runtime_default().wrap(function replaceEssaySaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(essayApi.replaceEssayApi, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(EssayActions/* essayAction.replaceEssaySuccess */.I.replaceEssaySuccess(res.payload));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(EssayActions/* essayAction.replaceEssayFail */.I.replaceEssayFail(res.payload));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(EssayActions/* essayAction.replaceEssayFail */.I.replaceEssayFail(_ctx.t0.message));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, EssaySaga_marked2, null, [
        [
            0,
            13
        ]
    ]);
}
function fetchEssaySaga(action) {
    var res;
    return runtime_default().wrap(function fetchEssaySaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(essayApi.fetchEssayApi, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(EssayActions/* essayAction.fetchEssaySuccess */.I.fetchEssaySuccess(res.payload));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(EssayActions/* essayAction.fetchEssayFail */.I.fetchEssayFail(res.payload));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(EssayActions/* essayAction.fetchEssayFail */.I.fetchEssayFail(_ctx.t0.message));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, EssaySaga_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function essaySaga() {
    return runtime_default().wrap(function essaySaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(EssayActions/* essayType.UPLOAD_ESSAY_REQ */.N.UPLOAD_ESSAY_REQ, uploadEssaySaga);
            case 2:
                _ctx.next = 4;
                return takeLatest$1(EssayActions/* essayType.ESSAY_FETCH_REQ */.N.ESSAY_FETCH_REQ, fetchEssaySaga);
            case 4:
                _ctx.next = 6;
                return takeLatest$1(EssayActions/* essayType.REPLACE_ESSAY_REQ */.N.REPLACE_ESSAY_REQ, replaceEssaySaga);
            case 6:
            case "end":
                return _ctx.stop();
        }
    }, EssaySaga_marked);
}
/* harmony default export */ var EssaySaga = (essaySaga);

// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js
var react_toastify_esm = __webpack_require__(72132);
;// CONCATENATED MODULE: ./components/Ielts/Faculty/redux/FacultyApi.ts




var fetchFaculties = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res, ref;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("".concat("https://api.leapscholar.com", "/teacher"));
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    ;
                    return _ctx.abrupt("return", (ref = res.data) === null || ref === void 0 ? void 0 : ref.message);
                case 10:
                    _ctx.next = 16;
                    break;
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    react_toastify_esm/* toast.error */.Am.error("Something went wrong. Please try after sometime");
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }));
    return function fetchFaculties() {
        return _ref.apply(this, arguments);
    };
}();
var fetchFacultiesClientSide = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=teacher");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    {
                        react_toastify_esm/* toast.error */.Am.error(res.data.message);
                    }
                case 9:
                    _ctx.next = 15;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    react_toastify_esm/* toast.error */.Am.error("Something went wrong. Please try after sometime");
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchFacultiesClientSide() {
        return _ref.apply(this, arguments);
    };
}();
var facultyApis = {
    fetchFaculties: fetchFaculties,
    fetchFacultiesClientSide: fetchFacultiesClientSide
};

// EXTERNAL MODULE: ./components/Ielts/Faculty/redux/FacultyActions.ts
var FacultyActions = __webpack_require__(67443);
;// CONCATENATED MODULE: ./components/Ielts/Faculty/redux/FacultySaga.ts

var FacultySaga_marked = runtime_default().mark(facultiesSaga);
var FacultySaga_marked1 = runtime_default().mark(fetchDataClientSide);
var FacultySaga_marked2 = runtime_default().mark(FacultySaga_fetchData);



function FacultySaga_fetchData() {
    var res;
    return runtime_default().wrap(function fetchData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(facultyApis.fetchFaculties);
            case 3:
                res = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)(FacultyActions/* facultyActions.fetchSuccess */.$.fetchSuccess(res));
            case 6:
                _ctx.next = 13;
                break;
            case 8:
                _ctx.prev = 8;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 13;
                return (0,io_c3792963.Y)(FacultyActions/* facultyActions.fetchFail */.$.fetchFail(_ctx.t0.message));
            case 13:
            case "end":
                return _ctx.stop();
        }
    }, FacultySaga_marked2, null, [
        [
            0,
            8
        ]
    ]);
}
function fetchDataClientSide() {
    var res;
    return runtime_default().wrap(function fetchDataClientSide$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(facultyApis.fetchFacultiesClientSide);
            case 3:
                res = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)(FacultyActions/* facultyActions.fetchSuccess */.$.fetchSuccess(res));
            case 6:
                _ctx.next = 13;
                break;
            case 8:
                _ctx.prev = 8;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 13;
                return (0,io_c3792963.Y)(FacultyActions/* facultyActions.fetchFail */.$.fetchFail(_ctx.t0.message));
            case 13:
            case "end":
                return _ctx.stop();
        }
    }, FacultySaga_marked1, null, [
        [
            0,
            8
        ]
    ]);
}
function facultiesSaga() {
    return runtime_default().wrap(function facultiesSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("FETCH_FACULTIES_REQUESTED", FacultySaga_fetchData);
            case 2:
                _ctx.next = 4;
                return takeLatest$1("FETCH_FACULTIES_REQUESTED_CLIENT", fetchDataClientSide);
            case 4:
            case "end":
                return _ctx.stop();
        }
    }, FacultySaga_marked);
}
/* harmony default export */ var FacultySaga = (facultiesSaga);

// EXTERNAL MODULE: ./components/Ielts/BatchDetails/redux/BatchDetailsApi.ts
var BatchDetailsApi = __webpack_require__(60742);
;// CONCATENATED MODULE: ./components/Ielts/BatchDetails/redux/BatchDetailsSaga.ts

var BatchDetailsSaga_marked = runtime_default().mark(BatchDetailsSaga_facultiesSaga);
var BatchDetailsSaga_marked1 = runtime_default().mark(fetchProductBatchhDataClientSide);
var BatchDetailsSaga_marked2 = runtime_default().mark(BatchDetailsSaga_fetchDataClientSide);
var BatchDetailsSaga_marked3 = runtime_default().mark(BatchDetailsSaga_fetchData);



function BatchDetailsSaga_fetchData(action) {
    var res, teacherResponse;
    return runtime_default().wrap(function fetchData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(BatchDetailsApi/* batchDetailsApi.fetchBatchDetails */.h.fetchBatchDetails, action.payload.batchId, action.payload.ctx);
            case 3:
                res = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)(BatchDetailsAction/* batchDetailsActions.fetchBatchDetailsSuccess */.P.fetchBatchDetailsSuccess(res));
            case 6:
                _ctx.next = 8;
                return (0,io_c3792963.N)(BatchDetailsApi/* batchDetailsApi.fetchBatchTeacherDetails */.h.fetchBatchTeacherDetails, res.primaryTeacherId, action.payload.ctx);
            case 8:
                teacherResponse = _ctx.sent;
                _ctx.next = 11;
                return (0,io_c3792963.Y)(BatchDetailsAction/* batchDetailsActions.fetchBatchTeacherSuccess */.P.fetchBatchTeacherSuccess(teacherResponse));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(BatchDetailsAction/* batchDetailsActions.fetchBatchDetailsFail */.P.fetchBatchDetailsFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, BatchDetailsSaga_marked3, null, [
        [
            0,
            13
        ]
    ]);
}
function BatchDetailsSaga_fetchDataClientSide(action) {
    var res, teacherResponse;
    return runtime_default().wrap(function fetchDataClientSide$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(BatchDetailsApi/* batchDetailsApi.fetchBatchDetailsClientSide */.h.fetchBatchDetailsClientSide, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res) {
                    _ctx.next = 15;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(BatchDetailsAction/* batchDetailsActions.fetchBatchDetailsSuccess */.P.fetchBatchDetailsSuccess(res));
            case 7:
                _ctx.next = 9;
                return (0,io_c3792963.N)(BatchDetailsApi/* batchDetailsApi.fetchBatchTeacherDetailsClient */.h.fetchBatchTeacherDetailsClient, res.primaryTeacherId);
            case 9:
                teacherResponse = _ctx.sent;
                if (!teacherResponse) {
                    _ctx.next = 13;
                    break;
                }
                _ctx.next = 13;
                return (0,io_c3792963.Y)(BatchDetailsAction/* batchDetailsActions.fetchBatchTeacherSuccess */.P.fetchBatchTeacherSuccess(teacherResponse));
            case 13:
                _ctx.next = 17;
                break;
            case 15:
                _ctx.next = 17;
                return (0,io_c3792963.Y)(BatchDetailsAction/* batchDetailsActions.toggleFailToFetchBatchData */.P.toggleFailToFetchBatchData(true));
            case 17:
                _ctx.next = 26;
                break;
            case 19:
                _ctx.prev = 19;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 24;
                return (0,io_c3792963.Y)(BatchDetailsAction/* batchDetailsActions.toggleFailToFetchBatchData */.P.toggleFailToFetchBatchData(true));
            case 24:
                _ctx.next = 26;
                return (0,io_c3792963.Y)(BatchDetailsAction/* batchDetailsActions.fetchBatchDetailsFail */.P.fetchBatchDetailsFail(_ctx.t0.message));
            case 26:
            case "end":
                return _ctx.stop();
        }
    }, BatchDetailsSaga_marked2, null, [
        [
            0,
            19
        ]
    ]);
}
function fetchProductBatchhDataClientSide(action) {
    var res, teacherResponse;
    return runtime_default().wrap(function fetchProductBatchhDataClientSide$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(BatchDetailsApi/* batchDetailsApi.fetchProductBatchDetailsClientSide */.h.fetchProductBatchDetailsClientSide, action.payload);
            case 3:
                res = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)(BatchDetailsAction/* batchDetailsActions.fetchBatchDetailsSuccess */.P.fetchBatchDetailsSuccess(res));
            case 6:
                _ctx.next = 8;
                return (0,io_c3792963.N)(BatchDetailsApi/* batchDetailsApi.fetchBatchTeacherDetailsClient */.h.fetchBatchTeacherDetailsClient, res.primaryTeacherId);
            case 8:
                teacherResponse = _ctx.sent;
                _ctx.next = 11;
                return (0,io_c3792963.Y)(BatchDetailsAction/* batchDetailsActions.fetchBatchTeacherSuccess */.P.fetchBatchTeacherSuccess(teacherResponse));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(BatchDetailsAction/* batchDetailsActions.fetchBatchDetailsFail */.P.fetchBatchDetailsFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, BatchDetailsSaga_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function BatchDetailsSaga_facultiesSaga() {
    return runtime_default().wrap(function facultiesSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("FETCH_BATCH_DETAILS_REQUESTED", BatchDetailsSaga_fetchData);
            case 2:
                _ctx.next = 4;
                return takeLatest$1(BatchDetailsAction/* batchDetailActionTypes.FETCH_PRODUCT_BATCH_DETAILS_REQUESTED_CLIENT_SIDE */.W.FETCH_PRODUCT_BATCH_DETAILS_REQUESTED_CLIENT_SIDE, fetchProductBatchhDataClientSide);
            case 4:
                _ctx.next = 6;
                return takeLatest$1("FETCH_BATCH_DETAILS_REQUESTED_CLIENT_SIDE", BatchDetailsSaga_fetchDataClientSide);
            case 6:
            case "end":
                return _ctx.stop();
        }
    }, BatchDetailsSaga_marked);
}
/* harmony default export */ var BatchDetailsSaga = (BatchDetailsSaga_facultiesSaga);

// EXTERNAL MODULE: ./lib/auth-cookies-new.js
var auth_cookies_new = __webpack_require__(89208);
;// CONCATENATED MODULE: ./components/Ielts/UpcomingIeltsBatches/redux/UpcomingIeltsApi.ts




var fetchUpcomingIeltsPlusClass = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(ctx) {
        var accessToken, headers, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    accessToken = (0,auth_cookies_new/* getTokenCookie */.r_)(ctx);
                    headers = {};
                    if (accessToken) {
                        headers = {
                            Authorization: "Bearer ".concat(accessToken)
                        };
                    }
                    headers["X-API-VERSION"] = "5";
                    _ctx.next = 7;
                    return api/* default.get */.Z.get("".concat("https://api.leapscholar.com", "/v2/workshop/ielts-class/home"), {
                        headers: headers
                    });
                case 7:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 12;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        success: true,
                        data: res.data.data
                    });
                case 12:
                    console.log("fetchUpcomingIeltsPlusClass response failure", res.data.message) //logs for debugging in prod
                    ;
                    return _ctx.abrupt("return", {
                        success: false,
                        data: res.data.message
                    });
                case 14:
                    _ctx.next = 20;
                    break;
                case 16:
                    _ctx.prev = 16;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return", {
                        success: false,
                        data: "Something went wrong. Please try after sometime"
                    });
                case 20:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                16
            ]
        ]);
    }));
    return function fetchUpcomingIeltsPlusClass(ctx) {
        return _ref.apply(this, arguments);
    };
}();
var fetchUpcomingIeltsPlusClassClientSide = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var headers, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    headers = {
                        "X-API-VERSION": "5"
                    };
                    _ctx.next = 4;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=v2/workshop/ielts-class/home", {
                        headers: headers
                    });
                case 4:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        success: true,
                        data: res.data.data
                    });
                case 9:
                    return _ctx.abrupt("return", {
                        success: false,
                        data: res.data.message
                    });
                case 10:
                    _ctx.next = 16;
                    break;
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return", {
                        success: false,
                        data: "Something went wrong. Please try after sometime"
                    });
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }));
    return function fetchUpcomingIeltsPlusClassClientSide() {
        return _ref.apply(this, arguments);
    };
}();
var fetchUpcomingBatchPriceAndTime = function() {
    return api/* default.get */.Z.get("/api/ielts/avataran_upcoming_batches");
};
var fetchIeltsBatches = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", api/* default.get */.Z.get("/api/ielts/ieltsBatchesList"));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchIeltsBatches() {
        return _ref.apply(this, arguments);
    };
}();
var fetchPteBatches = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", api/* default.get */.Z.get("/api/ielts/pteBatchesList"));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchPteBatches() {
        return _ref.apply(this, arguments);
    };
}();
var fetchDETBatches = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", api/* default.get */.Z.get("/api/ielts/detBatchesList"));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchDETBatches() {
        return _ref.apply(this, arguments);
    };
}();
var fetchIeltsBanner = function() {
    return api/* default.get */.Z.get("/api/ielts/ieltsBatchesBanner");
};
var upcomingIeltsPlusBatchesApi = {
    fetchUpcomingIeltsPlusClass: fetchUpcomingIeltsPlusClass,
    fetchUpcomingIeltsPlusClassClientSide: fetchUpcomingIeltsPlusClassClientSide,
    fetchUpcomingBatchPriceAndTime: fetchUpcomingBatchPriceAndTime,
    fetchIeltsBatches: fetchIeltsBatches,
    fetchIeltsBanner: fetchIeltsBanner,
    fetchPteBatches: fetchPteBatches,
    fetchDETBatches: fetchDETBatches
};

;// CONCATENATED MODULE: ./components/Ielts/UpcomingIeltsBatches/redux/UpcomingIeltsSaga.ts

var UpcomingIeltsSaga_marked = runtime_default().mark(upcomingIeltsSaga);
var UpcomingIeltsSaga_marked1 = runtime_default().mark(fetchBatchesBanner);
var UpcomingIeltsSaga_marked2 = runtime_default().mark(UpcomingIeltsSaga_fetchDETBatches);
var UpcomingIeltsSaga_marked3 = runtime_default().mark(UpcomingIeltsSaga_fetchPteBatches);
var UpcomingIeltsSaga_marked4 = runtime_default().mark(UpcomingIeltsSaga_fetchIeltsBatches);
var UpcomingIeltsSaga_marked5 = runtime_default().mark(fetchUpcomingBatchPriceAndTimingSaga);
var UpcomingIeltsSaga_marked6 = runtime_default().mark(fetchDataClient);
var UpcomingIeltsSaga_marked7 = runtime_default().mark(UpcomingIeltsSaga_fetchData);





function UpcomingIeltsSaga_fetchData(action) {
    var res;
    return runtime_default().wrap(function fetchData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return (0,io_c3792963.N)(upcomingIeltsPlusBatchesApi.fetchUpcomingIeltsPlusClass, action.payload);
            case 2:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 10;
                    break;
                }
                _ctx.next = 6;
                return (0,io_c3792963.Y)(UpcomingIeltsActions/* upcomingIeltsBatchesAction.fetchUpcomingIeltsSuccess */.f.fetchUpcomingIeltsSuccess(res.data.workshopBatches));
            case 6:
                _ctx.next = 8;
                return (0,io_c3792963.Y)(UpcomingIeltsActions/* upcomingIeltsBatchesAction.fetchNudgeSuccess */.f.fetchNudgeSuccess(res.data.nudgeOffer));
            case 8:
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)(UpcomingIeltsActions/* upcomingIeltsBatchesAction.fetchUpcomingIeltsFail */.f.fetchUpcomingIeltsFail(res.data));
            case 12:
            case "end":
                return _ctx.stop();
        }
    }, UpcomingIeltsSaga_marked7);
}
function fetchDataClient() {
    var res, ieltsPlusBatch, foundationBatch, plusBatch;
    return runtime_default().wrap(function fetchDataClient$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return (0,io_c3792963.N)(upcomingIeltsPlusBatchesApi.fetchUpcomingIeltsPlusClassClientSide);
            case 2:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 15;
                    break;
                }
                ieltsPlusBatch = res.data.workshopBatches.filter(function(data) {
                    return data.pricingBundleName != WorkshopData/* priceBundleName.IELTS_FOUNDATION */.F.IELTS_FOUNDATION;
                });
                _ctx.next = 7;
                return (0,io_c3792963.Y)(UpcomingIeltsActions/* upcomingIeltsBatchesAction.fetchUpcomingIeltsSuccess */.f.fetchUpcomingIeltsSuccess(ieltsPlusBatch));
            case 7:
                foundationBatch = res.data.workshopBatches.filter(function(data) {
                    return data.pricingBundleName == WorkshopData/* priceBundleName.IELTS_FOUNDATION */.F.IELTS_FOUNDATION;
                });
                _ctx.next = 10;
                return (0,io_c3792963.Y)(UpcomingIeltsActions/* upcomingIeltsBatchesAction.fetchIeltsFoundationBatchSuccess */.f.fetchIeltsFoundationBatchSuccess(foundationBatch));
            case 10:
                plusBatch = res.data.workshopBatches.filter(function(data) {
                    return data.pricingBundleName == WorkshopData/* priceBundleName.IELTS_PLUS */.F.IELTS_PLUS;
                });
                _ctx.next = 13;
                return (0,io_c3792963.Y)(UpcomingIeltsActions/* upcomingIeltsBatchesAction.fetchIeltsPlusBatchSuccess */.f.fetchIeltsPlusBatchSuccess(plusBatch));
            case 13:
                _ctx.next = 17;
                break;
            case 15:
                _ctx.next = 17;
                return (0,io_c3792963.Y)(UpcomingIeltsActions/* upcomingIeltsBatchesAction.fetchUpcomingIeltsFail */.f.fetchUpcomingIeltsFail(res.data));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, UpcomingIeltsSaga_marked6);
}
function fetchUpcomingBatchPriceAndTimingSaga() {
    var res;
    return runtime_default().wrap(function fetchUpcomingBatchPriceAndTimingSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(upcomingIeltsPlusBatchesApi.fetchUpcomingBatchPriceAndTime);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(UpcomingIeltsActions/* upcomingIeltsBatchesAction.fetchUpcomingBatchPriceAndTimeSuccess */.f.fetchUpcomingBatchPriceAndTimeSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(UpcomingIeltsActions/* upcomingIeltsBatchesAction.fetchUpcomingIeltsFail */.f.fetchUpcomingIeltsFail(res.data.message));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(UpcomingIeltsActions/* upcomingIeltsBatchesAction.fetchUpcomingIeltsFail */.f.fetchUpcomingIeltsFail("Something went wrong"));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, UpcomingIeltsSaga_marked5, null, [
        [
            0,
            13
        ]
    ]);
}
function UpcomingIeltsSaga_fetchIeltsBatches(action) {
    var res;
    return runtime_default().wrap(function fetchIeltsBatches$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(upcomingIeltsPlusBatchesApi.fetchIeltsBatches);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 10;
                    break;
                }
                if ((0,common_utils/* isFunction */.mf)(action.payload)) {
                    action.payload(res.data.data);
                }
                _ctx.next = 8;
                return (0,io_c3792963.Y)(UpcomingIeltsActions/* upcomingIeltsBatchesAction.setAllIeltsBatches */.f.setAllIeltsBatches(res.data.data));
            case 8:
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)(UpcomingIeltsActions/* upcomingIeltsBatchesAction.setAllIeltsBatches */.f.setAllIeltsBatches(null));
            case 12:
                _ctx.next = 18;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(UpcomingIeltsActions/* upcomingIeltsBatchesAction.setAllIeltsBatches */.f.setAllIeltsBatches(null));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, UpcomingIeltsSaga_marked4, null, [
        [
            0,
            14
        ]
    ]);
}
function UpcomingIeltsSaga_fetchPteBatches(action) {
    var res;
    return runtime_default().wrap(function fetchPteBatches$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(upcomingIeltsPlusBatchesApi.fetchPteBatches);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 10;
                    break;
                }
                if ((0,common_utils/* isFunction */.mf)(action.payload)) {
                    action.payload(res.data.data);
                }
                _ctx.next = 8;
                return (0,io_c3792963.Y)(UpcomingIeltsActions/* upcomingIeltsBatchesAction.setAllIeltsBatches */.f.setAllIeltsBatches(res.data.data));
            case 8:
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)(UpcomingIeltsActions/* upcomingIeltsBatchesAction.setAllIeltsBatches */.f.setAllIeltsBatches(null));
            case 12:
                _ctx.next = 18;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(UpcomingIeltsActions/* upcomingIeltsBatchesAction.setAllIeltsBatches */.f.setAllIeltsBatches(null));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, UpcomingIeltsSaga_marked3, null, [
        [
            0,
            14
        ]
    ]);
}
function UpcomingIeltsSaga_fetchDETBatches(action) {
    var res;
    return runtime_default().wrap(function fetchDETBatches$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(upcomingIeltsPlusBatchesApi.fetchDETBatches);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 10;
                    break;
                }
                if ((0,common_utils/* isFunction */.mf)(action.payload)) {
                    action.payload(res.data.data);
                }
                _ctx.next = 8;
                return (0,io_c3792963.Y)(UpcomingIeltsActions/* upcomingIeltsBatchesAction.setAllIeltsBatches */.f.setAllIeltsBatches(res.data.data));
            case 8:
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)(UpcomingIeltsActions/* upcomingIeltsBatchesAction.setAllIeltsBatches */.f.setAllIeltsBatches(null));
            case 12:
                _ctx.next = 18;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(UpcomingIeltsActions/* upcomingIeltsBatchesAction.setAllIeltsBatches */.f.setAllIeltsBatches(null));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, UpcomingIeltsSaga_marked2, null, [
        [
            0,
            14
        ]
    ]);
}
function fetchBatchesBanner() {
    var res;
    return runtime_default().wrap(function fetchBatchesBanner$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(upcomingIeltsPlusBatchesApi.fetchIeltsBanner);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(UpcomingIeltsActions/* upcomingIeltsBatchesAction.setBannerData */.f.setBannerData(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(UpcomingIeltsActions/* upcomingIeltsBatchesAction.setBannerData */.f.setBannerData(null));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(UpcomingIeltsActions/* upcomingIeltsBatchesAction.setBannerData */.f.setBannerData(null));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, UpcomingIeltsSaga_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function upcomingIeltsSaga() {
    return runtime_default().wrap(function upcomingIeltsSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(UpcomingIeltsActions/* UpcomingType.UPCOMING_IELTS_FETCH_REQUESTED */.h.UPCOMING_IELTS_FETCH_REQUESTED, UpcomingIeltsSaga_fetchData);
            case 2:
                _ctx.next = 4;
                return takeLatest$1(UpcomingIeltsActions/* UpcomingType.UPCOMING_IELTS_FETCH_CLIENT_REQUESTED */.h.UPCOMING_IELTS_FETCH_CLIENT_REQUESTED, fetchDataClient);
            case 4:
                _ctx.next = 6;
                return takeLatest$1(UpcomingIeltsActions/* UpcomingType.FETCH_GET_UPCOMING_BATCH_TIME_AND_PRICE */.h.FETCH_GET_UPCOMING_BATCH_TIME_AND_PRICE, fetchUpcomingBatchPriceAndTimingSaga);
            case 6:
                _ctx.next = 8;
                return takeLatest$1(UpcomingIeltsActions/* UpcomingType.FETCH_IELTS_BATCHES */.h.FETCH_IELTS_BATCHES, UpcomingIeltsSaga_fetchIeltsBatches);
            case 8:
                _ctx.next = 10;
                return takeLatest$1(UpcomingIeltsActions/* UpcomingType.FETCH_PTE_BATCHES */.h.FETCH_PTE_BATCHES, UpcomingIeltsSaga_fetchPteBatches);
            case 10:
                _ctx.next = 12;
                return takeLatest$1(UpcomingIeltsActions/* UpcomingType.FETCH_DET_BATCHES */.h.FETCH_DET_BATCHES, UpcomingIeltsSaga_fetchDETBatches);
            case 12:
                _ctx.next = 14;
                return takeLatest$1(UpcomingIeltsActions/* UpcomingType.FETCH_BATCHES_BANNER */.h.FETCH_BATCHES_BANNER, fetchBatchesBanner);
            case 14:
            case "end":
                return _ctx.stop();
        }
    }, UpcomingIeltsSaga_marked);
}
/* harmony default export */ var UpcomingIeltsSaga = (upcomingIeltsSaga);

;// CONCATENATED MODULE: ./components/Profile/UpdateProfileFormsNew/redux/UpdateProfileApis.tsx



var fetchPersonalData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=student/info/personal-info");
                case 3:
                    res = _ctx.sent;
                    console.log("res", res);
                    return _ctx.abrupt("return", res);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function fetchPersonalData() {
        return _ref.apply(this, arguments);
    };
}();
var savePersonalData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=student/info/personal-info", values);
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function savePersonalData(values) {
        return _ref.apply(this, arguments);
    };
}();
var fetchAddressData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=student/info/address");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchAddressData() {
        return _ref.apply(this, arguments);
    };
}();
var saveAddressData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=student/info/address", values);
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function saveAddressData(values) {
        return _ref.apply(this, arguments);
    };
}();
var fetchPassportData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=student/info/passport");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchPassportData() {
        return _ref.apply(this, arguments);
    };
}();
var savePassportData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=student/info/passport", values);
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function savePassportData(values) {
        return _ref.apply(this, arguments);
    };
}();
var fetchBackgroundData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=student/info/background-info");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchBackgroundData() {
        return _ref.apply(this, arguments);
    };
}();
var saveBackgroundData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=student/info/background-info", values);
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function saveBackgroundData(values) {
        return _ref.apply(this, arguments);
    };
}();
var getCountryList = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=value-object/countries");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function getCountryList() {
        return _ref.apply(this, arguments);
    };
}();
var getLanguageList = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=value-object/languages");
                case 3:
                    res = _ctx.sent;
                    console.log("language", res);
                    return _ctx.abrupt("return", res);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function getLanguageList() {
        return _ref.apply(this, arguments);
    };
}();
/*----------- Academic details - start ---------- */ var fetchAcademicData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=student/info/academic-info");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchAcademicData() {
        return _ref.apply(this, arguments);
    };
}();
var saveAcademicData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    console.log("POST /info/academic-info body --->", values);
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=student/info/academic-info", values);
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](1);
                    throw new Error("Something went wrong. Please refresh the page");
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                8
            ]
        ]);
    }));
    return function saveAcademicData(values) {
        return _ref.apply(this, arguments);
    };
}();
var fetchEducationData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=student/info/education");
                case 3:
                    res = _ctx.sent;
                    console.log("res", res.data);
                    return _ctx.abrupt("return", res);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function fetchEducationData() {
        return _ref.apply(this, arguments);
    };
}();
var saveEducationData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=student/info/education", values);
                case 3:
                    res = _ctx.sent;
                    console.log("save education", res.data);
                    return _ctx.abrupt("return", res);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function saveEducationData(values) {
        return _ref.apply(this, arguments);
    };
}();
/*----------- Academic details - end ---------- */ /*----------- Emergency contact details - start ---------- */ var fetchEmergencyContactData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    console.log("GET /info/emergency Request");
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=student/info/emergency");
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](1);
                    throw new Error("Something went wrong. Please refresh the page");
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                8
            ]
        ]);
    }));
    return function fetchEmergencyContactData() {
        return _ref.apply(this, arguments);
    };
}();
var saveEmergencyContactData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    console.log("POST /info/emergency body --->", values);
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=student/info/emergency", values);
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](1);
                    throw new Error("Something went wrong. Please refresh the page");
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                8
            ]
        ]);
    }));
    return function saveEmergencyContactData(values) {
        return _ref.apply(this, arguments);
    };
}();
/*----------- Emergency contact details  - end ---------- */ /*----------- Exam score details  - end ---------- */ var fetchExamScore = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    console.log("GET info/exams Request");
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=student/info/exams");
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](1);
                    throw new Error("Something went wrong. Please refresh the page");
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                8
            ]
        ]);
    }));
    return function fetchExamScore() {
        return _ref.apply(this, arguments);
    };
}();
var saveExamScore = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    console.log("POST info/exams body --->", values);
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=student/info/exams", values);
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](1);
                    throw new Error("Something went wrong. Please refresh the page");
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                8
            ]
        ]);
    }));
    return function saveExamScore(values) {
        return _ref.apply(this, arguments);
    };
}();
/*----------- Exam score details  - end ---------- */ /*----------- Work Experience details  - start ---------- */ var fetchWorkExp = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    console.log("GET info/work-ex Request");
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=student/info/work-ex");
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](1);
                    throw new Error("Something went wrong. Please refresh the page");
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                8
            ]
        ]);
    }));
    return function fetchWorkExp() {
        return _ref.apply(this, arguments);
    };
}();
var saveWorkExp = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    console.log("POST info/exams body --->", values);
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=student/info/work-ex", values);
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](1);
                    throw new Error("Something went wrong. Please refresh the page");
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                8
            ]
        ]);
    }));
    return function saveWorkExp(values) {
        return _ref.apply(this, arguments);
    };
}();
var deleteWorkExp = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    console.log("POST info/exams body --->", values);
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=student/info/work-ex", values);
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](1);
                    throw new Error("Something went wrong. Please refresh the page");
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                8
            ]
        ]);
    }));
    return function deleteWorkExp(values) {
        return _ref.apply(this, arguments);
    };
}();
/*----------- Work Experience details  - end ---------- */ /*----------- State, City apis - start ---------- */ var fetchStateList = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(country) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    console.log("GET value-object/countries/".concat(country, "/state --->"));
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=value-object/countries/".concat(country, "/state"));
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](1);
                    throw new Error("Something went wrong. Please refresh the page");
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                8
            ]
        ]);
    }));
    return function fetchStateList(country) {
        return _ref.apply(this, arguments);
    };
}();
var fetchCityList = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
        var ref, _country, country, _state, state, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = data || {}, _country = ref.country, country = _country === void 0 ? "" : _country, _state = ref.state, state = _state === void 0 ? "" : _state;
                    console.log("GET value-object/countries/".concat(country, "/state/").concat(state, "/city ---->"));
                    _ctx.prev = 2;
                    _ctx.next = 5;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=value-object/countries/".concat(country, "/state/").concat(state, "/city"));
                case 5:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](2);
                    throw new Error("Something went wrong. Please refresh the page");
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                9
            ]
        ]);
    }));
    return function fetchCityList(data) {
        return _ref.apply(this, arguments);
    };
}();
/*----------- State, City apis - end ---------- */ //referee form
var fetchRefereeData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=student/info/referee");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchRefereeData() {
        return _ref.apply(this, arguments);
    };
}();
var saveRefereeData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=student/info/referee", values);
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function saveRefereeData(values) {
        return _ref.apply(this, arguments);
    };
}();
var updateProfileApis = {
    fetchPersonalData: fetchPersonalData,
    savePersonalData: savePersonalData,
    getCountryList: getCountryList,
    getLanguageList: getLanguageList,
    fetchAddressData: fetchAddressData,
    saveAddressData: saveAddressData,
    fetchPassportData: fetchPassportData,
    savePassportData: savePassportData,
    fetchBackgroundData: fetchBackgroundData,
    saveBackgroundData: saveBackgroundData,
    //ub - start
    fetchAcademicData: fetchAcademicData,
    saveAcademicData: saveAcademicData,
    fetchEmergencyContactData: fetchEmergencyContactData,
    saveEmergencyContactData: saveEmergencyContactData,
    fetchStateList: fetchStateList,
    fetchCityList: fetchCityList,
    fetchExamScore: fetchExamScore,
    saveExamScore: saveExamScore,
    //ub -end
    fetchEducationData: fetchEducationData,
    saveEducationData: saveEducationData,
    //referee details
    fetchRefereeData: fetchRefereeData,
    saveRefereeData: saveRefereeData,
    //ub- start
    fetchWorkExp: fetchWorkExp,
    saveWorkExp: saveWorkExp,
    deleteWorkExp: deleteWorkExp
};

// EXTERNAL MODULE: ./utils/common-utils.js
var utils_common_utils = __webpack_require__(1576);
;// CONCATENATED MODULE: ./components/Profile/UpdateProfileFormsNew/redux/UpdateProfileSaga.tsx

var UpdateProfileSaga_marked = runtime_default().mark(updateProfileSaga);
var UpdateProfileSaga_marked1 = runtime_default().mark(getCityList);
var UpdateProfileSaga_marked2 = runtime_default().mark(getStateList);
var UpdateProfileSaga_marked3 = runtime_default().mark(UpdateProfileSaga_getLanguageList);
var UpdateProfileSaga_marked4 = runtime_default().mark(UpdateProfileSaga_getCountryList);
var UpdateProfileSaga_marked5 = runtime_default().mark(deletwWorkExpDetails);
var UpdateProfileSaga_marked6 = runtime_default().mark(saveWorkExpDetails);
var UpdateProfileSaga_marked7 = runtime_default().mark(fetchWorkExpDetails);
var UpdateProfileSaga_marked8 = runtime_default().mark(UpdateProfileSaga_saveRefereeData);
var _marked9 = runtime_default().mark(UpdateProfileSaga_fetchRefereeData);
var _marked10 = runtime_default().mark(UpdateProfileSaga_saveEducationData);
var _marked11 = runtime_default().mark(UpdateProfileSaga_fetchEducationData);
var _marked12 = runtime_default().mark(saveExamScores);
var _marked13 = runtime_default().mark(fetchExamScores);
var _marked14 = runtime_default().mark(saveEmergencyContact);
var _marked15 = runtime_default().mark(fetchEmergencyContact);
var _marked16 = runtime_default().mark(saveAcademicDetails);
var _marked17 = runtime_default().mark(fetchAcademicDetails);
var _marked18 = runtime_default().mark(UpdateProfileSaga_saveBackgroundData);
var _marked19 = runtime_default().mark(UpdateProfileSaga_fetchBackgroundData);
var _marked20 = runtime_default().mark(UpdateProfileSaga_savePassportData);
var _marked21 = runtime_default().mark(UpdateProfileSaga_fetchPassportData);
var _marked22 = runtime_default().mark(UpdateProfileSaga_saveAddressData);
var _marked23 = runtime_default().mark(UpdateProfileSaga_fetchAddressData);
var _marked24 = runtime_default().mark(UpdateProfileSaga_savePersonalData);
var _marked25 = runtime_default().mark(UpdateProfileSaga_fetchPersonalData);





function UpdateProfileSaga_fetchPersonalData() {
    var res;
    return runtime_default().wrap(function fetchPersonalData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(updateProfileApis.fetchPersonalData);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchPersonalDataSuccess */.Q.fetchPersonalDataSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchPersonalDataFail */.Q.fetchPersonalDataFail(res.data.message));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchPersonalDataFail */.Q.fetchPersonalDataFail(_ctx.t0.message));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, _marked25, null, [
        [
            0,
            13
        ]
    ]);
}
function UpdateProfileSaga_savePersonalData(action) {
    var res;
    return runtime_default().wrap(function savePersonalData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(updateProfileApis.savePersonalData, action.payload);
            case 3:
                res = _ctx.sent;
                console.log("lion", res.data);
                if (!res.data.success) {
                    _ctx.next = 10;
                    break;
                }
                _ctx.next = 8;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.savePersonalDataSuccess */.Q.savePersonalDataSuccess(res.data.data));
            case 8:
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.savePersonalDataFail */.Q.savePersonalDataFail(res.data.message));
            case 12:
                _ctx.next = 19;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 19;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.savePersonalDataFail */.Q.savePersonalDataFail(_ctx.t0.message));
            case 19:
            case "end":
                return _ctx.stop();
        }
    }, _marked24, null, [
        [
            0,
            14
        ]
    ]);
}
function UpdateProfileSaga_fetchAddressData() {
    var res;
    return runtime_default().wrap(function fetchAddressData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(updateProfileApis.fetchAddressData);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchAddressDataSuccess */.Q.fetchAddressDataSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchAddressDataFail */.Q.fetchAddressDataFail(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchAddressDataFail */.Q.fetchAddressDataFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, _marked23, null, [
        [
            0,
            13
        ]
    ]);
}
function UpdateProfileSaga_saveAddressData(action) {
    var res;
    return runtime_default().wrap(function saveAddressData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(updateProfileApis.saveAddressData, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.saveAddressDataSuccess */.Q.saveAddressDataSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.saveAddressDataFail */.Q.saveAddressDataFail(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.saveAddressDataFail */.Q.saveAddressDataFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, _marked22, null, [
        [
            0,
            13
        ]
    ]);
}
function UpdateProfileSaga_fetchPassportData() {
    var res;
    return runtime_default().wrap(function fetchPassportData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(updateProfileApis.fetchPassportData);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchPassportDataSuccess */.Q.fetchPassportDataSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchPassportDataFail */.Q.fetchPassportDataFail(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchPassportDataFail */.Q.fetchPassportDataFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, _marked21, null, [
        [
            0,
            13
        ]
    ]);
}
function UpdateProfileSaga_savePassportData(action) {
    var res;
    return runtime_default().wrap(function savePassportData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(updateProfileApis.savePassportData, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.savePassportDataSuccess */.Q.savePassportDataSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.savePassportDataFail */.Q.savePassportDataFail(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.savePassportDataFail */.Q.savePassportDataFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, _marked20, null, [
        [
            0,
            13
        ]
    ]);
}
function UpdateProfileSaga_fetchBackgroundData() {
    var res;
    return runtime_default().wrap(function fetchBackgroundData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(updateProfileApis.fetchBackgroundData);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchBackgroundDataSuccess */.Q.fetchBackgroundDataSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchBackgroundDataFail */.Q.fetchBackgroundDataFail(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchBackgroundDataFail */.Q.fetchBackgroundDataFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, _marked19, null, [
        [
            0,
            13
        ]
    ]);
}
function UpdateProfileSaga_saveBackgroundData(action) {
    var res;
    return runtime_default().wrap(function saveBackgroundData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(updateProfileApis.saveBackgroundData, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.saveBackgroundDataSuccess */.Q.saveBackgroundDataSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.saveBackgroundDataFail */.Q.saveBackgroundDataFail(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.saveBackgroundDataFail */.Q.saveBackgroundDataFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, _marked18, null, [
        [
            0,
            13
        ]
    ]);
}
/********* Academic details - START ********/ function fetchAcademicDetails() {
    var res;
    return runtime_default().wrap(function fetchAcademicDetails$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(updateProfileApis.fetchAcademicData);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchAcademicDetailsSuccess */.Q.fetchAcademicDetailsSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchAcademicDetailsFail */.Q.fetchAcademicDetailsFail(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchAcademicDetailsFail */.Q.fetchAcademicDetailsFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, _marked17, null, [
        [
            0,
            13
        ]
    ]);
}
function saveAcademicDetails(action) {
    var res;
    return runtime_default().wrap(function saveAcademicDetails$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(updateProfileApis.saveAcademicData, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.saveAcademicDetailsSuccess */.Q.saveAcademicDetailsSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.saveAcademicDetailsFail */.Q.saveAcademicDetailsFail(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.saveAcademicDetailsFail */.Q.saveAcademicDetailsFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, _marked16, null, [
        [
            0,
            13
        ]
    ]);
}
/********* Academic details - END ********/ /********* Emergency contact details - START ********/ function fetchEmergencyContact() {
    var res;
    return runtime_default().wrap(function fetchEmergencyContact$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(updateProfileApis.fetchEmergencyContactData);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchEmergencyContactDetailsSuccess */.Q.fetchEmergencyContactDetailsSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchEmergencyContactDetailsFail */.Q.fetchEmergencyContactDetailsFail(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchEmergencyContactDetailsFail */.Q.fetchEmergencyContactDetailsFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, _marked15, null, [
        [
            0,
            13
        ]
    ]);
}
function saveEmergencyContact(action) {
    var res;
    return runtime_default().wrap(function saveEmergencyContact$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(updateProfileApis.saveEmergencyContactData, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.saveEmergencyContactDetailsSuccess */.Q.saveEmergencyContactDetailsSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.saveEmergencyContactDetailsFail */.Q.saveEmergencyContactDetailsFail(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.saveEmergencyContactDetailsFail */.Q.saveEmergencyContactDetailsFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, _marked14, null, [
        [
            0,
            13
        ]
    ]);
}
/********* Emergency contact details - END ********/ /********* Exam Score details - START ********/ function fetchExamScores() {
    var res;
    return runtime_default().wrap(function fetchExamScores$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(updateProfileApis.fetchExamScore);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchExamScoreDetailsSuccess */.Q.fetchExamScoreDetailsSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchExamScoreDetailsFail */.Q.fetchExamScoreDetailsFail(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchExamScoreDetailsFail */.Q.fetchExamScoreDetailsFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, _marked13, null, [
        [
            0,
            13
        ]
    ]);
}
function saveExamScores(action) {
    var res;
    return runtime_default().wrap(function saveExamScores$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(updateProfileApis.saveExamScore, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.saveExamScoreDetailsSuccess */.Q.saveExamScoreDetailsSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.saveExamScoreDetailsFail */.Q.saveExamScoreDetailsFail(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.saveExamScoreDetailsFail */.Q.saveExamScoreDetailsFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, _marked12, null, [
        [
            0,
            13
        ]
    ]);
}
/********* Exam Score details - END ********/ function UpdateProfileSaga_fetchEducationData() {
    var res;
    return runtime_default().wrap(function fetchEducationData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(updateProfileApis.fetchEducationData);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 10;
                    break;
                }
                console.log("yash", res.data);
                _ctx.next = 8;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchEducationDataSuccess */.Q.fetchEducationDataSuccess(res.data.data));
            case 8:
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchEducationDataFail */.Q.fetchEducationDataFail(res.data.message));
            case 12:
                _ctx.next = 19;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 19;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchEducationDataFail */.Q.fetchEducationDataFail(_ctx.t0.message));
            case 19:
            case "end":
                return _ctx.stop();
        }
    }, _marked11, null, [
        [
            0,
            14
        ]
    ]);
}
function UpdateProfileSaga_saveEducationData(action) {
    var res;
    return runtime_default().wrap(function saveEducationData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(updateProfileApis.saveEducationData, action.payload);
            case 3:
                res = _ctx.sent;
                console.log("lion", res.data);
                if (!res.data.success) {
                    _ctx.next = 10;
                    break;
                }
                _ctx.next = 8;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.saveEducationDataSuccess */.Q.saveEducationDataSuccess(res.data.data));
            case 8:
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.saveEducationDataFail */.Q.saveEducationDataFail(res.data.message));
            case 12:
                _ctx.next = 19;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 19;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.saveEducationDataFail */.Q.saveEducationDataFail(_ctx.t0.message));
            case 19:
            case "end":
                return _ctx.stop();
        }
    }, _marked10, null, [
        [
            0,
            14
        ]
    ]);
}
function UpdateProfileSaga_fetchRefereeData() {
    var res, formattedReferee;
    return runtime_default().wrap(function fetchRefereeData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(updateProfileApis.fetchRefereeData);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 11;
                    break;
                }
                console.log("yash", res.data);
                formattedReferee = {
                    refereeOne: res.data.data[0],
                    refereeTwo: res.data.data[1],
                    refereeThree: res.data.data[2]
                };
                _ctx.next = 9;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchRefereeDataSuccess */.Q.fetchRefereeDataSuccess(formattedReferee));
            case 9:
                _ctx.next = 13;
                break;
            case 11:
                _ctx.next = 13;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchRefereeDataFail */.Q.fetchRefereeDataFail(res.data.message));
            case 13:
                _ctx.next = 20;
                break;
            case 15:
                _ctx.prev = 15;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 20;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchRefereeDataFail */.Q.fetchRefereeDataFail(_ctx.t0.message));
            case 20:
            case "end":
                return _ctx.stop();
        }
    }, _marked9, null, [
        [
            0,
            15
        ]
    ]);
}
function UpdateProfileSaga_saveRefereeData(action) {
    var _payload, refereeOne, refereeTwo, refereeThree, obj, res;
    return runtime_default().wrap(function saveRefereeData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _payload = action.payload, refereeOne = _payload.refereeOne, refereeTwo = _payload.refereeTwo, refereeThree = _payload.refereeThree;
                obj = [
                    refereeOne,
                    refereeTwo,
                    refereeThree
                ];
                _ctx.prev = 2;
                _ctx.next = 5;
                return (0,io_c3792963.N)(updateProfileApis.saveRefereeData, obj);
            case 5:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 11;
                    break;
                }
                _ctx.next = 9;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.saveRefereeDataSuccess */.Q.saveRefereeDataSuccess(res.data.data));
            case 9:
                _ctx.next = 13;
                break;
            case 11:
                _ctx.next = 13;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.saveRefereeDataFail */.Q.saveRefereeDataFail(res.data.message));
            case 13:
                _ctx.next = 20;
                break;
            case 15:
                _ctx.prev = 15;
                _ctx.t0 = _ctx["catch"](2);
                console.log(_ctx.t0);
                _ctx.next = 20;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.saveRefereeDataFail */.Q.saveRefereeDataFail(_ctx.t0.message));
            case 20:
            case "end":
                return _ctx.stop();
        }
    }, UpdateProfileSaga_marked8, null, [
        [
            2,
            15
        ]
    ]);
}
/********* Work Experience - START ********/ function fetchWorkExpDetails() {
    var res;
    return runtime_default().wrap(function fetchWorkExpDetails$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(updateProfileApis.fetchWorkExp);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchWorkExpDetailsSuccess */.Q.fetchWorkExpDetailsSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchWorkExpDetailsFail */.Q.fetchWorkExpDetailsFail(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.fetchWorkExpDetailsFail */.Q.fetchWorkExpDetailsFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, UpdateProfileSaga_marked7, null, [
        [
            0,
            13
        ]
    ]);
}
function saveWorkExpDetails(action) {
    var res;
    return runtime_default().wrap(function saveWorkExpDetails$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(updateProfileApis.saveWorkExp, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.saveWorkExpDetailsSuccess */.Q.saveWorkExpDetailsSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.saveWorkExpDetailsFail */.Q.saveWorkExpDetailsFail(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.saveWorkExpDetailsFail */.Q.saveWorkExpDetailsFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, UpdateProfileSaga_marked6, null, [
        [
            0,
            13
        ]
    ]);
}
function deletwWorkExpDetails(action) {
    var res;
    return runtime_default().wrap(function deletwWorkExpDetails$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(updateProfileApis.deleteWorkExp, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.deleteWorkExpSuccess */.Q.deleteWorkExpSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.deleteWorkExpFail */.Q.deleteWorkExpFail(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.deleteWorkExpFail */.Q.deleteWorkExpFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, UpdateProfileSaga_marked5, null, [
        [
            0,
            13
        ]
    ]);
}
/********* Work Experience - END ********/ function UpdateProfileSaga_getCountryList() {
    var res, list;
    return runtime_default().wrap(function getCountryList$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(updateProfileApis.getCountryList);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 10;
                    break;
                }
                list = (0,utils_common_utils/* createOptionsObject */.mK)(res.data.data);
                _ctx.next = 8;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.getCountryListSuccess */.Q.getCountryListSuccess(list));
            case 8:
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.getCountryListFail */.Q.getCountryListFail(res.data.message));
            case 12:
                _ctx.next = 19;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 19;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.getCountryListFail */.Q.getCountryListFail(_ctx.t0.message));
            case 19:
            case "end":
                return _ctx.stop();
        }
    }, UpdateProfileSaga_marked4, null, [
        [
            0,
            14
        ]
    ]);
}
function UpdateProfileSaga_getLanguageList() {
    var res, list;
    return runtime_default().wrap(function getLanguageList$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(updateProfileApis.getLanguageList);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 10;
                    break;
                }
                list = (0,utils_common_utils/* createOptionsObject */.mK)(res.data.data);
                _ctx.next = 8;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.getLanguageListSuccess */.Q.getLanguageListSuccess(list));
            case 8:
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.getLanguageListFail */.Q.getLanguageListFail(res.data.message));
            case 12:
                _ctx.next = 19;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 19;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.getLanguageListFail */.Q.getLanguageListFail(_ctx.t0.message));
            case 19:
            case "end":
                return _ctx.stop();
        }
    }, UpdateProfileSaga_marked3, null, [
        [
            0,
            14
        ]
    ]);
}
function getStateList(action) {
    var res, states;
    return runtime_default().wrap(function getStateList$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(updateProfileApis.fetchStateList, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 10;
                    break;
                }
                states = (0,utils_common_utils/* createOptionsObject */.mK)(res.data.data);
                _ctx.next = 8;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.getStateListSuccess */.Q.getStateListSuccess(states));
            case 8:
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.getStateListFail */.Q.getStateListFail(res.data.message));
            case 12:
                _ctx.next = 19;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 19;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.getStateListFail */.Q.getStateListFail(_ctx.t0.message));
            case 19:
            case "end":
                return _ctx.stop();
        }
    }, UpdateProfileSaga_marked2, null, [
        [
            0,
            14
        ]
    ]);
}
function getCityList(action) {
    var res, cities;
    return runtime_default().wrap(function getCityList$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(updateProfileApis.fetchCityList, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 10;
                    break;
                }
                cities = (0,utils_common_utils/* createOptionsObject */.mK)(res.data.data);
                _ctx.next = 8;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.getCityListSuccess */.Q.getCityListSuccess(cities));
            case 8:
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.getCityListFail */.Q.getCityListFail(res.data.message));
            case 12:
                _ctx.next = 19;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 19;
                return (0,io_c3792963.Y)(UpdateProfileActions/* updateProfileActions.getCityListFail */.Q.getCityListFail(_ctx.t0.message));
            case 19:
            case "end":
                return _ctx.stop();
        }
    }, UpdateProfileSaga_marked1, null, [
        [
            0,
            14
        ]
    ]);
}
function updateProfileSaga() {
    return runtime_default().wrap(function updateProfileSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("FETCH_PERSONAL_DATA", UpdateProfileSaga_fetchPersonalData);
            case 2:
                _ctx.next = 4;
                return takeLatest$1("SAVE_PERSONAL_DATA", UpdateProfileSaga_savePersonalData);
            case 4:
                _ctx.next = 6;
                return takeLatest$1("FETCH_ADDRESS_DATA", UpdateProfileSaga_fetchAddressData);
            case 6:
                _ctx.next = 8;
                return takeLatest$1("SAVE_ADDRESS_DATA", UpdateProfileSaga_saveAddressData);
            case 8:
                _ctx.next = 10;
                return takeLatest$1("FETCH_PASSPORT_DATA", UpdateProfileSaga_fetchPassportData);
            case 10:
                _ctx.next = 12;
                return takeLatest$1("SAVE_PASSPORT_DATA", UpdateProfileSaga_savePassportData);
            case 12:
                _ctx.next = 14;
                return takeLatest$1("FETCH_BACKGROUND_DATA", UpdateProfileSaga_fetchBackgroundData);
            case 14:
                _ctx.next = 16;
                return takeLatest$1("SAVE_BACKGROUND_DATA", UpdateProfileSaga_saveBackgroundData);
            case 16:
                _ctx.next = 18;
                return takeLatest$1("FETCH_EDUCATION_DATA", UpdateProfileSaga_fetchEducationData);
            case 18:
                _ctx.next = 20;
                return takeLatest$1("SAVE_EDUCATION_DATA", UpdateProfileSaga_saveEducationData);
            case 20:
                _ctx.next = 22;
                return takeLatest$1("FETCH_REFEREE_DATA", UpdateProfileSaga_fetchRefereeData);
            case 22:
                _ctx.next = 24;
                return takeLatest$1("SAVE_REFEREE_DATA", UpdateProfileSaga_saveRefereeData);
            case 24:
                _ctx.next = 26;
                return takeLatest$1("GET_COUNTRY_LIST", UpdateProfileSaga_getCountryList);
            case 26:
                _ctx.next = 28;
                return takeLatest$1("GET_LANGUAGE_LIST", UpdateProfileSaga_getLanguageList);
            case 28:
                _ctx.next = 30;
                return takeLatest$1(UpdateProfileActions/* actionConstants.FETCH_ACADEMIC_DATA */.U.FETCH_ACADEMIC_DATA, fetchAcademicDetails);
            case 30:
                _ctx.next = 32;
                return takeLatest$1(UpdateProfileActions/* actionConstants.SAVE_ACADEMIC_DATA */.U.SAVE_ACADEMIC_DATA, saveAcademicDetails);
            case 32:
                _ctx.next = 34;
                return takeLatest$1(UpdateProfileActions/* actionConstants.FETCH_EMERGENCY_CONTACT_DATA */.U.FETCH_EMERGENCY_CONTACT_DATA, fetchEmergencyContact);
            case 34:
                _ctx.next = 36;
                return takeLatest$1(UpdateProfileActions/* actionConstants.SAVE_EMERGENCY_CONTACT_DATA */.U.SAVE_EMERGENCY_CONTACT_DATA, saveEmergencyContact);
            case 36:
                _ctx.next = 38;
                return takeLatest$1(UpdateProfileActions/* actionConstants.GET_STATE_LIST */.U.GET_STATE_LIST, getStateList);
            case 38:
                _ctx.next = 40;
                return takeLatest$1(UpdateProfileActions/* actionConstants.GET_CITY_LIST */.U.GET_CITY_LIST, getCityList);
            case 40:
                _ctx.next = 42;
                return takeLatest$1(UpdateProfileActions/* actionConstants.FETCH_EXAM_SCORE_DATA */.U.FETCH_EXAM_SCORE_DATA, fetchExamScores);
            case 42:
                _ctx.next = 44;
                return takeLatest$1(UpdateProfileActions/* actionConstants.SAVE_EXAM_SCORE */.U.SAVE_EXAM_SCORE, saveExamScores);
            case 44:
                _ctx.next = 46;
                return takeLatest$1(UpdateProfileActions/* actionConstants.FETCH_WORK_EXP_DATA */.U.FETCH_WORK_EXP_DATA, fetchWorkExpDetails);
            case 46:
                _ctx.next = 48;
                return takeLatest$1(UpdateProfileActions/* actionConstants.SAVE_WORK_EXP */.U.SAVE_WORK_EXP, saveWorkExpDetails);
            case 48:
                _ctx.next = 50;
                return takeLatest$1(UpdateProfileActions/* actionConstants.DELETE_WORK_EXP */.U.DELETE_WORK_EXP, deletwWorkExpDetails);
            case 50:
            case "end":
                return _ctx.stop();
        }
    }, UpdateProfileSaga_marked);
//ub -end
}
/* harmony default export */ var UpdateProfileSaga = (updateProfileSaga);

// EXTERNAL MODULE: ./components/Profile/IeltsRegistrationForm/redux/IeltsRegistrationFormActions.ts
var IeltsRegistrationFormActions = __webpack_require__(55007);
// EXTERNAL MODULE: ./components/Profile/IeltsRegistrationForm/redux/IeltsRegistrationFormApi.ts
var IeltsRegistrationFormApi = __webpack_require__(94073);
// EXTERNAL MODULE: ./components/TofuOnbordingForms/SpotCounsellingProgressiveForm/IeltsToCounselling/IeltsToCounsellingApi.ts
var IeltsToCounsellingApi = __webpack_require__(78779);
// EXTERNAL MODULE: ./ga.ts
var ga = __webpack_require__(83138);
;// CONCATENATED MODULE: ./components/Profile/IeltsRegistrationForm/redux/IeltsRegistrationFormSaga.ts



var IeltsRegistrationFormSaga_marked = runtime_default().mark(IeltsRegistrationFormSaga_ieltsSaga);
var IeltsRegistrationFormSaga_marked1 = runtime_default().mark(IeltsRegistrationFormSaga_enrollToIeltsPlus);
var IeltsRegistrationFormSaga_marked2 = runtime_default().mark(saveData);









function saveData(action) {
    var freeTrailEligibility, res;
    return runtime_default().wrap(function saveData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return (0,io_c3792963.a3)(function(state) {
                    return state.ieltsRegistrationForm.ieltsFreeTrailEligiblity;
                });
            case 2:
                freeTrailEligibility = _ctx.sent;
                if (freeTrailEligibility) {
                    (0,ga.logEvent)("Ielts free trial", "start free trial", "start free trial cta");
                }
                _ctx.prev = 4;
                _ctx.next = 7;
                return (0,io_c3792963.Y)(IeltsRegistrationFormActions/* ieltsRegistrationFormActions.toggleCtaText */.z.toggleCtaText("Saving"));
            case 7:
                _ctx.next = 9;
                return (0,io_c3792963.N)(IeltsRegistrationFormApi/* ieltsRegistrationFormApi.saveForm */.R.saveForm, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, action.payload.values), {
                    formId: "I2C_form"
                }));
            case 9:
                res = _ctx.sent;
                _ctx.next = 12;
                return (0,io_c3792963.N)(eventTracker/* eventTracker */.x, EventData/* eventName.INITIATE_CHECKOUT */.oJ.INITIATE_CHECKOUT, {
                    category: "Ielts",
                    action: EventData/* eventName.INITIATE_CHECKOUT */.oJ.INITIATE_CHECKOUT,
                    label: "",
                    batchId: parseInt(action.payload.batchId, 10)
                });
            case 12:
                _ctx.next = 14;
                return (0,io_c3792963.N)(ga.fireTagEvent, "ielts_initiate_checkout");
            case 14:
                if (!res.success) {
                    _ctx.next = 27;
                    break;
                }
                _ctx.next = 17;
                return (0,io_c3792963.Y)(CounsellingFormActions/* counsellingFormActions.updatePostFetchEligibilityAction */.W.updatePostFetchEligibilityAction(function(eligibilityData) {
                    (0,IeltsToCounsellingApi/* IeltsToCounsellingEligibility */.j6)(eligibilityData);
                }));
            case 17:
                _ctx.next = 19;
                return (0,io_c3792963.Y)(CounsellingFormActions/* counsellingFormActions.fetchEligibility */.W.fetchEligibility());
            case 19:
                _ctx.next = 21;
                return (0,io_c3792963.Y)(BatchDetailsAction/* batchDetailsActions.toggleIeltsPlusForm */.P.toggleIeltsPlusForm(false));
            case 21:
                _ctx.next = 23;
                return (0,io_c3792963.Y)(IeltsRegistrationFormActions/* ieltsRegistrationFormActions.toggleCtaText */.z.toggleCtaText("Next"));
            case 23:
                _ctx.next = 25;
                return (0,io_c3792963.Y)(IeltsRegistrationFormActions/* ieltsRegistrationFormActions.toggleInitPayment */.z.toggleInitPayment(true));
            case 25:
                _ctx.next = 29;
                break;
            case 27:
                _ctx.next = 29;
                return (0,io_c3792963.Y)(IeltsRegistrationFormActions/* ieltsRegistrationFormActions.updateError */.z.updateError(res.message));
            case 29:
                _ctx.next = 36;
                break;
            case 31:
                _ctx.prev = 31;
                _ctx.t0 = _ctx["catch"](4);
                _ctx.next = 35;
                return (0,io_c3792963.Y)(IeltsRegistrationFormActions/* ieltsRegistrationFormActions.updateError */.z.updateError("Something went wrong. Please try after sometime."));
            case 35:
                console.error(_ctx.t0);
            case 36:
                _ctx.prev = 36;
                _ctx.next = 39;
                return (0,io_c3792963.Y)(IeltsRegistrationFormActions/* ieltsRegistrationFormActions.toggleCtaText */.z.toggleCtaText("Next"));
            case 39:
                return _ctx.finish(36);
            case 40:
            case "end":
                return _ctx.stop();
        }
    }, IeltsRegistrationFormSaga_marked2, null, [
        [
            4,
            31,
            36,
            40
        ]
    ]);
}
function IeltsRegistrationFormSaga_enrollToIeltsPlus(action) {
    var res;
    return runtime_default().wrap(function enrollToIeltsPlus$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.Y)(IeltsRegistrationFormActions/* ieltsRegistrationFormActions.toggleCtaText */.z.toggleCtaText("Saving"));
            case 3:
                _ctx.next = 5;
                return (0,io_c3792963.N)(IeltsRegistrationFormApi/* ieltsRegistrationFormApi.enrollToIeltsPlus */.R.enrollToIeltsPlus, action.payload);
            case 5:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 13;
                    break;
                }
                _ctx.next = 9;
                return (0,io_c3792963.Y)(IeltsRegistrationFormActions/* ieltsRegistrationFormActions.toggleCtaText */.z.toggleCtaText("Submit"));
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(IeltsRegistrationFormActions/* ieltsRegistrationFormActions.toggleIeltsFormModal */.z.toggleIeltsFormModal(true));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.next = 15;
                return (0,io_c3792963.Y)(IeltsRegistrationFormActions/* ieltsRegistrationFormActions.updateError */.z.updateError(res.message));
            case 15:
                _ctx.next = 17;
                return (0,io_c3792963.Y)(IeltsRegistrationFormActions/* ieltsRegistrationFormActions.toggleCtaText */.z.toggleCtaText("Submit"));
            case 17:
                _ctx.next = 24;
                break;
            case 19:
                _ctx.prev = 19;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 23;
                return (0,io_c3792963.Y)(IeltsRegistrationFormActions/* ieltsRegistrationFormActions.updateError */.z.updateError("Something went wrong. Please try after sometime."));
            case 23:
                console.error(_ctx.t0);
            case 24:
            case "end":
                return _ctx.stop();
        }
    }, IeltsRegistrationFormSaga_marked1, null, [
        [
            0,
            19
        ]
    ]);
}
function IeltsRegistrationFormSaga_ieltsSaga() {
    return runtime_default().wrap(function ieltsSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("SAVE_IELTS_FORM", saveData);
            case 2:
                _ctx.next = 4;
                return takeLatest$1("ENROLL_TO_IELTS_PLUS_FORM", IeltsRegistrationFormSaga_enrollToIeltsPlus);
            case 4:
            case "end":
                return _ctx.stop();
        }
    }, IeltsRegistrationFormSaga_marked);
}
/* harmony default export */ var IeltsRegistrationFormSaga = (IeltsRegistrationFormSaga_ieltsSaga);

;// CONCATENATED MODULE: ./components/Profile/MasterclassRegistrationForm/redux/MasterclassRegistrationFormApi.ts



var saveForm = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=workshop/master-class", values, {
                        headers: {
                            "X-API-VERSION": "2"
                        }
                    });
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function saveForm(values) {
        return _ref.apply(this, arguments);
    };
}();
var masterclassRegistrationFormApi = {
    saveForm: saveForm
};

// EXTERNAL MODULE: ./node_modules/crypto-js/sha256.js
var sha256 = __webpack_require__(52153);
var sha256_default = /*#__PURE__*/__webpack_require__.n(sha256);
// EXTERNAL MODULE: ./lib/getUserInfo.ts
var getUserInfo = __webpack_require__(46442);
// EXTERNAL MODULE: ./components/Profile/RegistrationForm/redux/RegistrationFormApi.ts
var RegistrationFormApi = __webpack_require__(24268);
// EXTERNAL MODULE: ./DataMapper/IeltsDateUploadData.tsx
var IeltsDateUploadData = __webpack_require__(56014);
// EXTERNAL MODULE: ./components/SpotCounselling/redux/SpotCounsellingApi.ts
var SpotCounsellingApi = __webpack_require__(40163);
;// CONCATENATED MODULE: ./components/Profile/MasterclassRegistrationForm/redux/MasterclassRegistrationFormSaga.ts

var MasterclassRegistrationFormSaga_marked = runtime_default().mark(masterclassSaga);
var MasterclassRegistrationFormSaga_marked1 = runtime_default().mark(resetFormAction);
var MasterclassRegistrationFormSaga_marked2 = runtime_default().mark(MasterclassRegistrationFormSaga_saveData);














var getMasterclassRegistration = function(state) {
    return state.masterclassRegistrationForm;
};
function MasterclassRegistrationFormSaga_saveData(action) {
    var res, ref, slotType, masterClassDataRes, variant, shouldRedirectTOI2cTimeline, userData, masterclassRegistrationStore;
    return runtime_default().wrap(function saveData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.Y)(MasterclassRegistrationFormAction/* masterclassRegistrationActions.toggleIsLoading */.Z.toggleIsLoading(true));
            case 3:
                _ctx.next = 5;
                return (0,io_c3792963.Y)(MasterclassRegistrationFormAction/* masterclassRegistrationActions.toggleCtaText */.Z.toggleCtaText("Saving"));
            case 5:
                _ctx.next = 7;
                return (0,io_c3792963.N)(masterclassRegistrationFormApi.saveForm, action.payload);
            case 7:
                res = _ctx.sent;
                _ctx.next = 10;
                return (0,io_c3792963.Y)(MasterclassRegistrationFormAction/* masterclassRegistrationActions.saveFormValues */.Z.saveFormValues(action.payload));
            case 10:
                if (!res.success) {
                    _ctx.next = 56;
                    break;
                }
                ;
                _ctx.next = 14;
                return (0,io_c3792963.N)(IeltsToCounsellingApi/* IeltsToCounsellingEligibility */.j6, action.payload, "masterclass_form");
            case 14:
                slotType = _ctx.sent;
                _ctx.next = 17;
                return (0,io_c3792963.N)(RegistrationFormApi/* registrationFormApi.fetchInitialFormValues */.U.fetchInitialFormValues);
            case 17:
                masterClassDataRes = _ctx.sent;
                _ctx.next = 20;
                return (0,io_c3792963.N)(SpotCounsellingApi/* spotCounsellingApi.getAbVariant */.nr.getAbVariant, "i2cTimeLineExp");
            case 20:
                variant = _ctx.sent;
                shouldRedirectTOI2cTimeline = [
                    1,
                    2,
                    7
                ].includes(slotType) && (masterClassDataRes === null || masterClassDataRes === void 0 ? void 0 : masterClassDataRes.success) && (masterClassDataRes === null || masterClassDataRes === void 0 ? void 0 : (ref = masterClassDataRes.data) === null || ref === void 0 ? void 0 : ref.ieltsExamType) !== IeltsDateUploadData/* ieltsExamType.GENERAL */.XE.GENERAL && (variant === null || variant === void 0 ? void 0 : variant.success) && (variant === null || variant === void 0 ? void 0 : variant.data) === 2;
                (0,common_utils/* localStorageSetItem */.A6)("shouldShowI2cTimeLine", shouldRedirectTOI2cTimeline);
                _ctx.next = 25;
                return (0,io_c3792963.N)(getUserInfo/* getUserInfo */.b);
            case 25:
                userData = _ctx.sent;
                (0,eventTracker/* eventTracker */.x)(EventData/* eventName.MASTERCLASS_REGISTERED */.oJ.MASTERCLASS_REGISTERED, {
                    category: EventData/* eventName.MASTERCLASS_REGISTERED */.oJ.MASTERCLASS_REGISTERED,
                    action: window.location.pathname,
                    label: ""
                });
                _ctx.next = 29;
                return (0,io_c3792963.N)(ga.fireTagEvent, "masterclass_registered", {
                    hashed_email: sha256_default()(action.payload.email).toString(),
                    user_email: action.payload.email,
                    hashed_phone: sha256_default()((userData === null || userData === void 0 ? void 0 : userData.phone) || "").toString()
                });
            case 29:
                _ctx.next = 31;
                return (0,io_c3792963.Y)(MasterclassRegistrationFormAction/* masterclassRegistrationActions.toggleCtaText */.Z.toggleCtaText("Next"));
            case 31:
                _ctx.next = 33;
                return (0,io_c3792963.Y)(MasterclassRegistrationFormAction/* masterclassRegistrationActions.toggleShowForm */.Z.toggleShowForm(false));
            case 33:
                if (shouldRedirectTOI2cTimeline) {
                    _ctx.next = 36;
                    break;
                }
                _ctx.next = 36;
                return (0,io_c3792963.Y)(MasterclassRegistrationFormAction/* masterclassRegistrationActions.saveFormSuccess */.Z.saveFormSuccess(true)) // here
                ;
            case 36:
                _ctx.next = 38;
                return (0,io_c3792963.a3)(getMasterclassRegistration);
            case 38:
                masterclassRegistrationStore = _ctx.sent;
                if (!(masterclassRegistrationStore.postFormAction && typeof masterclassRegistrationStore.postFormAction == "function")) {
                    _ctx.next = 43;
                    break;
                }
                {
                    masterclassRegistrationStore.postFormAction();
                }
                _ctx.next = 45;
                break;
            case 43:
                _ctx.next = 45;
                return (0,io_c3792963.Y)(MasterclassRegistrationFormAction/* masterclassRegistrationActions.toggleMasterclassFormModal */.Z.toggleMasterclassFormModal(true));
            case 45:
                _ctx.next = 47;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.setMasterclassSubscriptionStatus */.u.setMasterclassSubscriptionStatus(true));
            case 47:
                _ctx.next = 49;
                return (0,io_c3792963.Y)(MasterclassRegistrationFormAction/* masterclassRegistrationActions.postFormAction */.Z.postFormAction(null));
            case 49:
                _ctx.next = 51;
                return (0,io_c3792963.Y)(MasterclassRegistrationFormAction/* masterclassRegistrationActions.toggleIsLoading */.Z.toggleIsLoading(false));
            case 51:
                if (!shouldRedirectTOI2cTimeline) {
                    _ctx.next = 54;
                    break;
                }
                _ctx.next = 54;
                return (0,io_c3792963.Y)(MasterclassRegistrationFormAction/* masterclassRegistrationActions.toggleShouldRedirectToI2cTimeline */.Z.toggleShouldRedirectToI2cTimeline(true));
            case 54:
                _ctx.next = 64;
                break;
            case 56:
                _ctx.next = 58;
                return (0,io_c3792963.Y)(MasterclassRegistrationFormAction/* masterclassRegistrationActions.postFormAction */.Z.postFormAction(null));
            case 58:
                _ctx.next = 60;
                return (0,io_c3792963.Y)(MasterclassRegistrationFormAction/* masterclassRegistrationActions.updateError */.Z.updateError("Something went wrong. Please try after sometime."));
            case 60:
                _ctx.next = 62;
                return (0,io_c3792963.Y)(MasterclassRegistrationFormAction/* masterclassRegistrationActions.saveFormSuccess */.Z.saveFormSuccess(false));
            case 62:
                _ctx.next = 64;
                return (0,io_c3792963.Y)(MasterclassRegistrationFormAction/* masterclassRegistrationActions.toggleIsLoading */.Z.toggleIsLoading(false));
            case 64:
                _ctx.next = 79;
                break;
            case 66:
                _ctx.prev = 66;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 70;
                return (0,io_c3792963.Y)(MasterclassRegistrationFormAction/* masterclassRegistrationActions.toggleCtaText */.Z.toggleCtaText("Next"));
            case 70:
                _ctx.next = 72;
                return (0,io_c3792963.Y)(MasterclassRegistrationFormAction/* masterclassRegistrationActions.postFormAction */.Z.postFormAction(null));
            case 72:
                _ctx.next = 74;
                return (0,io_c3792963.Y)(MasterclassRegistrationFormAction/* masterclassRegistrationActions.updateError */.Z.updateError("Something went wrong. Please try after sometime."));
            case 74:
                _ctx.next = 76;
                return (0,io_c3792963.Y)(MasterclassRegistrationFormAction/* masterclassRegistrationActions.saveFormSuccess */.Z.saveFormSuccess(false));
            case 76:
                _ctx.next = 78;
                return (0,io_c3792963.Y)(MasterclassRegistrationFormAction/* masterclassRegistrationActions.toggleIsLoading */.Z.toggleIsLoading(false));
            case 78:
                console.error(_ctx.t0);
            case 79:
            case "end":
                return _ctx.stop();
        }
    }, MasterclassRegistrationFormSaga_marked2, null, [
        [
            0,
            66
        ]
    ]);
}
function resetFormAction(action) {
    return runtime_default().wrap(function resetFormAction$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                if (!(action.payload == false)) {
                    _ctx.next = 3;
                    break;
                }
                _ctx.next = 3;
                return (0,io_c3792963.Y)(MasterclassRegistrationFormAction/* masterclassRegistrationActions.postFormAction */.Z.postFormAction(null));
            case 3:
            case "end":
                return _ctx.stop();
        }
    }, MasterclassRegistrationFormSaga_marked1);
}
function masterclassSaga() {
    return runtime_default().wrap(function masterclassSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("MASTERCLASS_FORM_SUBMIT", MasterclassRegistrationFormSaga_saveData);
            case 2:
                _ctx.next = 4;
                return takeLatest$1("TOGGLE_MASTERCLASS_FORM_MODAL", resetFormAction);
            case 4:
            case "end":
                return _ctx.stop();
        }
    }, MasterclassRegistrationFormSaga_marked);
}
/* harmony default export */ var MasterclassRegistrationFormSaga = (masterclassSaga);

;// CONCATENATED MODULE: ./utils/google_calendar.ts

var createCalendarEventObj = function(batchData) {
    var selectedBatch = batchData.selectedBatch, name = batchData.name;
    var startTime = getTimeInCorrectFormat(selectedBatch.startDate, selectedBatch.startTime);
    var endTime = getTimeInCorrectFormat(selectedBatch.startDate, selectedBatch.endTime);
    var recurrence = getRecurrence(selectedBatch);
    return {
        summary: "LeapScholar IELTS Plus class",
        location: "https://bit.ly/3bV70u7",
        description: "\n      Hello ".concat(name, ",\n        You can join your class here: https://bit.ly/3bV70u7 \n        Go to your batch details page by clicking the blue arrow and click enter class.\n        To join these classes, you have to sign in to your Zoom account. \n        Steps to follow when you join before the session:\n\n        Step 1: Download Zoom App\n        Step 2: Click on the link\n        Step 3: Click on Sign In\n        Step 4: SIGN IN WITH GOOGLE\n        Step 5: Enter your gmail ID and password\n        Step 6: Connect with Internet Audio\n        \n        If you face any issues, please refer to these images for steps to follow: http://bit.ly/3r5iaRs \n        Also, do join your batch Telegram group here: ").concat(selectedBatch.groupChatLink, "."),
        start: {
            dateTime: startTime,
            timeZone: "Asia/Kolkata"
        },
        end: {
            dateTime: endTime,
            timeZone: "Asia/Kolkata"
        },
        recurrence: recurrence,
        reminders: {
            useDefault: false,
            overrides: [
                {
                    method: "popup",
                    minutes: 10
                }
            ]
        },
        attendees: []
    };
};
var getTimeInCorrectFormat = function(date, time) {
    return "".concat(date === null || date === void 0 ? void 0 : date.split("T")[0], "T").concat(time === null || time === void 0 ? void 0 : time.split("T")[1]);
};
var weekList = [
    "MO",
    "TU",
    "WE",
    "TH",
    "FR",
    "SA",
    "SU"
];
var getRecurrence = function(batch) {
    var ref;
    var weeklySchedule = (ref = batch.weeklySchedule) === null || ref === void 0 ? void 0 : ref.split("-").map(function(str) {
        return str.replace(/\s/g, "");
    });
    var arr = [];
    weekList.forEach(function(day) {
        if (weekList.indexOf(day) >= weekList.indexOf(weeklySchedule[0].substring(0, 2).toUpperCase()) && weekList.indexOf(day) <= weekList.indexOf(weeklySchedule[1].substring(0, 2).toUpperCase())) {
            arr.push(day);
        }
    });
    var newDate = moment_default()(batch.endDate).add(1, "days").toISOString();
    return [
        "RRULE:FREQ=DAILY;UNTIL=".concat(newDate.split("T")[0].split("-").join(""), ";INTERVAL=1;BYDAY=").concat(arr.join(",")), 
    ];
};

;// CONCATENATED MODULE: ./components/Profile/IeltsAttendanceScreen/redux/IeltsAttendanceApi.ts



var DISCOVERY_DOCS = [
    "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest", 
];
var SCOPES = "https://www.googleapis.com/auth/calendar.events";
var addToCalendar = function(batchData) {
    return new Promise(function(res, rej) {
        try {
            var gapi = window.gapi;
            gapi.load("client:auth2", function() {
                gapi.client.init({
                    apiKey: "AIzaSyDw_QSnnBltUgFU-c-J0jb0vzVaLZukAKw",
                    clientId: "662230608867-r40higcigr2fjobg62qm6tmkiov8cep6.apps.googleusercontent.com",
                    discoveryDocs: DISCOVERY_DOCS,
                    scope: SCOPES
                });
                gapi.client.load("calendar", "v3", function() {
                    return console.log("Gapi Loaded");
                });
                var eventObj = createCalendarEventObj(batchData);
                if (gapi.auth2.getAuthInstance().isSignedIn.get()) {
                    gapi.auth2.getAuthInstance().then((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                        var request;
                        return runtime_default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    request = gapi.client.calendar.events.insert({
                                        calendarId: "primary",
                                        resource: eventObj
                                    });
                                    _ctx.next = 3;
                                    return request.execute(function(event) {
                                        if (event.error) {
                                            rej(false);
                                        } else {
                                            res(true);
                                        }
                                    });
                                case 3:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee);
                    }))).catch(function() {
                        rej(false);
                    });
                } else {
                    gapi.auth2.getAuthInstance().signIn().then(function() {
                        var request = gapi.client.calendar.events.insert({
                            calendarId: "primary",
                            resource: eventObj
                        });
                        request.execute(function(event) {
                            if (event.error) {
                                rej(false);
                            } else {
                                res(true);
                            }
                        });
                    }).catch(function() {
                        rej(false);
                    });
                }
            });
        } catch (err) {
            rej(false);
            console.log(err);
        }
    });
};
var ieltsAttendanceApi = {
    addToCalendar: addToCalendar
};

// EXTERNAL MODULE: ./components/Profile/IeltsAttendanceScreen/redux/IeltsAttendanceActions.ts
var IeltsAttendanceActions = __webpack_require__(4069);
;// CONCATENATED MODULE: ./components/Profile/IeltsAttendanceScreen/redux/IeltsAttendanceSaga.ts


var IeltsAttendanceSaga_marked = runtime_default().mark(IeltsAttendanceSaga_ieltsSaga);
var IeltsAttendanceSaga_marked1 = runtime_default().mark(IeltsAttendanceSaga_addToCalendar);







function IeltsAttendanceSaga_addToCalendar(action) {
    var res, ieltsData, _obj;
    return runtime_default().wrap(function addToCalendar$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(ieltsAttendanceApi.addToCalendar, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res) {
                    _ctx.next = 16;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.N)(ieltsPlusApi.fetchIeltsPlusData);
            case 7:
                ieltsData = _ctx.sent;
                if (!(ieltsData.workshop.length > 0)) {
                    _ctx.next = 12;
                    break;
                }
                ;
                _ctx.next = 12;
                return (0,io_c3792963.N)(eventTracker/* eventTracker */.x, EventData/* eventName.ADDED_TO_CALENDAR */.oJ.ADDED_TO_CALENDAR, (_obj = {}, (0,_define_property/* default */.Z)(_obj, EventData/* WEeventDataAttributeNames.CATEGORY */.sx.CATEGORY, EventData/* eventCategory.REGISTRATION */.f2.REGISTRATION), (0,_define_property/* default */.Z)(_obj, EventData/* WEeventDataAttributeNames.ACTION */.sx.ACTION, EventData/* eventName.ADDED_TO_CALENDAR */.oJ.ADDED_TO_CALENDAR), (0,_define_property/* default */.Z)(_obj, EventData/* WEeventDataAttributeNames.LABEL */.sx.LABEL, ""), (0,_define_property/* default */.Z)(_obj, EventData/* WEeventDataAttributeNames.BATCH_ID */.sx.BATCH_ID, ieltsData.workshop[0].batchId), (0,_define_property/* default */.Z)(_obj, EventData/* WEeventDataAttributeNames.BATCH_START_DATE */.sx.BATCH_START_DATE, new Date((ieltsData === null || ieltsData === void 0 ? void 0 : ieltsData.workshop[0].meetingStartTime) || "")), (0,_define_property/* default */.Z)(_obj, EventData/* WEeventDataAttributeNames.BATCH_END_DATE */.sx.BATCH_END_DATE, new Date((ieltsData === null || ieltsData === void 0 ? void 0 : ieltsData.workshop[0].meetingEndTime) || "")), (0,_define_property/* default */.Z)(_obj, EventData/* WEeventDataAttributeNames.TEACHER_NAME */.sx.TEACHER_NAME, ieltsData.workshop[0].name), _obj));
            case 12:
                _ctx.next = 14;
                return (0,io_c3792963.Y)(IeltsAttendanceActions/* ieltsAttendanceActions.updateAddedToCalendar */.I.updateAddedToCalendar(true));
            case 14:
                _ctx.next = 16;
                return (0,io_c3792963.Y)(IeltsPlusActions/* ieltsPlusActions.updateAddToCalendar */.P.updateAddToCalendar(action.payload.selectedBatch.batchId));
            case 16:
                _ctx.next = 22;
                break;
            case 18:
                _ctx.prev = 18;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 22;
                return (0,io_c3792963.Y)(IeltsAttendanceActions/* ieltsAttendanceActions.updateError */.I.updateError("Something went wrong. Please try after sometime"));
            case 22:
            case "end":
                return _ctx.stop();
        }
    }, IeltsAttendanceSaga_marked1, null, [
        [
            0,
            18
        ]
    ]);
}
function IeltsAttendanceSaga_ieltsSaga() {
    return runtime_default().wrap(function ieltsSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("ADD_IELTS_CLASS_TO_CALENDAR", IeltsAttendanceSaga_addToCalendar);
            case 2:
            case "end":
                return _ctx.stop();
        }
    }, IeltsAttendanceSaga_marked);
}
/* harmony default export */ var IeltsAttendanceSaga = (IeltsAttendanceSaga_ieltsSaga);

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/ExtraClass/redux/ExtraClassApi.ts




var ExtraClassApi_notifyUser = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    if (!(payload.workshopType == WorkshopData/* batchType.ORIENTATION_WORKSHOP */.d.ORIENTATION_WORKSHOP)) {
                        _ctx.next = 8;
                        break;
                    }
                    _ctx.next = 5;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=api/enrollment/enroll", {
                        batchId: payload.batchId,
                        workshopType: payload.workshopType
                    });
                case 5:
                    res = _ctx.sent;
                    _ctx.next = 11;
                    break;
                case 8:
                    _ctx.next = 10;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=workshop/enroll/".concat(payload.batchId, "/").concat(payload.workshopType));
                case 10:
                    res = _ctx.sent;
                case 11:
                    if (!res.data.success) {
                        _ctx.next = 15;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        success: true,
                        data: res.data.data
                    });
                case 15:
                    return _ctx.abrupt("return", {
                        success: false,
                        data: res.data.message
                    });
                case 16:
                    _ctx.next = 21;
                    break;
                case 18:
                    _ctx.prev = 18;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        success: false,
                        data: "Something went wrong"
                    });
                case 21:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                18
            ]
        ]);
    }));
    return function notifyUser(payload) {
        return _ref.apply(this, arguments);
    };
}();
var fetchEnrolledExtraClass = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=workshop/enroll/my/all_extra_classes");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        success: true,
                        data: res.data.data
                    });
                case 8:
                    return _ctx.abrupt("return", {
                        success: false,
                        data: res.data.message
                    });
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        success: false,
                        data: "Something went wrong"
                    });
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchEnrolledExtraClass() {
        return _ref.apply(this, arguments);
    };
}();
var extraClassApi = {
    notifyUser: ExtraClassApi_notifyUser,
    fetchEnrolledExtraClass: fetchEnrolledExtraClass
};

// EXTERNAL MODULE: ./page_routes/index.ts
var page_routes = __webpack_require__(12615);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/ExtraClass/redux/ExtraClassSaga.ts



var ExtraClassSaga_marked = runtime_default().mark(ExtraClassSaga_noticeBoardSaga);
var ExtraClassSaga_marked1 = runtime_default().mark(ExtraClassSaga_fetchEnrolledExtraClass);
var ExtraClassSaga_marked2 = runtime_default().mark(notifyUserForExtraClass);







var getUpcomingClass = function(state) {
    return state.upcomingClass.upcomingExtraClass;
};
var getPostAction = function(state) {
    return state.extraClass.postAction;
};
function notifyUserForExtraClass(action) {
    var res, upcomingExtraClass, postAction;
    return runtime_default().wrap(function notifyUserForExtraClass$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(extraClassApi.notifyUser, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 30;
                    break;
                }
                if (!(action.payload.workshopType === WorkshopData/* batchType.ORIENTATION_WORKSHOP */.d.ORIENTATION_WORKSHOP)) {
                    _ctx.next = 10;
                    break;
                }
                _ctx.next = 8;
                return (0,io_c3792963.Y)(ExtraClassActions/* extraClassActions.toggleHasJoinedOrientation */.n.toggleHasJoinedOrientation(true));
            case 8:
                _ctx.next = 28;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.a3)(getUpcomingClass);
            case 12:
                upcomingExtraClass = _ctx.sent;
                _ctx.next = 15;
                return (0,io_c3792963.Y)(UpcomingClassActions/* upcomingClassActions.fetchUpcomingextraClassSuccess */.n.fetchUpcomingextraClassSuccess(upcomingExtraClass.map(function(data) {
                    return data.batchId == action.payload.batchId ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                        isEnrolled: true
                    }) : data;
                })));
            case 15:
                _ctx.next = 17;
                return (0,io_c3792963.a3)(getPostAction);
            case 17:
                postAction = _ctx.sent;
                if (!postAction) {
                    _ctx.next = 22;
                    break;
                }
                {
                    postAction();
                }
                _ctx.next = 24;
                break;
            case 22:
                _ctx.next = 24;
                return (0,io_c3792963.Y)(ExtraClassActions/* extraClassActions.notifyUserForExtraClassSuccess */.n.notifyUserForExtraClassSuccess(res.data));
            case 24:
                _ctx.next = 26;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.fetchMasterclassData */.u.fetchMasterclassData());
            case 26:
                _ctx.next = 28;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.fetchBeginnerMasterclass */.u.fetchBeginnerMasterclass());
            case 28:
                _ctx.next = 33;
                break;
            case 30:
                _ctx.next = 32;
                return (0,io_c3792963.Y)(ExtraClassActions/* extraClassActions.notifyUserForExtraClassFail */.n.notifyUserForExtraClassFail(res.data));
            case 32:
                window.open("".concat(page_routes/* navRoutes.IELTS_STUDENT_DASHBOARD */.CZ.IELTS_STUDENT_DASHBOARD), "_self");
            case 33:
                _ctx.next = 41;
                break;
            case 35:
                _ctx.prev = 35;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 40;
                return (0,io_c3792963.Y)(ExtraClassActions/* extraClassActions.notifyUserForExtraClassFail */.n.notifyUserForExtraClassFail(_ctx.t0.message));
            case 40:
                throw new Error(_ctx.t0.message);
            case 41:
            case "end":
                return _ctx.stop();
        }
    }, ExtraClassSaga_marked2, null, [
        [
            0,
            35
        ]
    ]);
}
function ExtraClassSaga_fetchEnrolledExtraClass() {
    var res;
    return runtime_default().wrap(function fetchEnrolledExtraClass$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(extraClassApi.fetchEnrolledExtraClass);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(ExtraClassActions/* extraClassActions.fetchEnrolledExtraClassSuccess */.n.fetchEnrolledExtraClassSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(ExtraClassActions/* extraClassActions.fetchEnrolledExtraClassFail */.n.fetchEnrolledExtraClassFail(res.data));
            case 11:
                _ctx.next = 19;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(ExtraClassActions/* extraClassActions.fetchEnrolledExtraClassFail */.n.fetchEnrolledExtraClassFail(_ctx.t0.message));
            case 18:
                throw new Error(_ctx.t0.message);
            case 19:
            case "end":
                return _ctx.stop();
        }
    }, ExtraClassSaga_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function ExtraClassSaga_noticeBoardSaga() {
    return runtime_default().wrap(function noticeBoardSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(ExtraClassActions/* ExtraClassType.NOTIFY_USER_FOR_EXTRA_CLASS */.r.NOTIFY_USER_FOR_EXTRA_CLASS, notifyUserForExtraClass);
            case 2:
                _ctx.next = 4;
                return takeLatest$1(ExtraClassActions/* ExtraClassType.FETCH_ENROLLED_EXTRA_CLASS_REQ */.r.FETCH_ENROLLED_EXTRA_CLASS_REQ, ExtraClassSaga_fetchEnrolledExtraClass);
            case 4:
            case "end":
                return _ctx.stop();
        }
    }, ExtraClassSaga_marked);
}
/* harmony default export */ var ExtraClassSaga = (ExtraClassSaga_noticeBoardSaga);

// EXTERNAL MODULE: ./components/Profile/IeltsProfile/Nps/redux/NpsActions.ts
var NpsActions = __webpack_require__(43712);
// EXTERNAL MODULE: ./utils/events-utils.js
var events_utils = __webpack_require__(42477);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/Nps/redux/NpsApis.ts




var fetchNpsStatus = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=nps/eligible", {
                        headers: {
                            "X-API-VERSION": 2
                        }
                    });
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchNpsStatus() {
        return _ref.apply(this, arguments);
    };
}();
var fetchFastTrackNpsStatus = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=nps/eligible/fast_track");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchFastTrackNpsStatus() {
        return _ref.apply(this, arguments);
    };
}();
var submitRatings = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
        var pathName, body, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    pathName = "";
                    if (data.pathName) {
                        pathName = "".concat(window.location.pathname, "/").concat(data.pathName);
                    }
                    _ctx.prev = 2;
                    body = {
                        rating: data.ratings,
                        originatingUrl: pathName || window.location.pathname,
                        isSkipped: (data === null || data === void 0 ? void 0 : data.isSkipped) || false
                    };
                    _ctx.next = 6;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=nps/rating", body, {
                        headers: {
                            "X-API-VERSION": 2,
                            "X-PLATFORM": (0,events_utils.getPlatformV2)()
                        }
                    });
                case 6:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](2);
                    console.log(_ctx.t0);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                10
            ]
        ]);
    }));
    return function submitRatings(data) {
        return _ref.apply(this, arguments);
    };
}();
var submitForm = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=nps/supporting_answer", values, {
                        headers: {
                            "X-API-VERSION": 2,
                            "X-PLATFORM": (0,events_utils.getPlatformV2)()
                        }
                    });
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function submitForm(values) {
        return _ref.apply(this, arguments);
    };
}();
var npsApis = {
    fetchNpsStatus: fetchNpsStatus,
    submitRatings: submitRatings,
    submitForm: submitForm,
    fetchFastTrackNpsStatus: fetchFastTrackNpsStatus
};

// EXTERNAL MODULE: ./DataMapper/IeltsProfile/npsData.ts
var IeltsProfile_npsData = __webpack_require__(53667);
// EXTERNAL MODULE: ./scripts/segment.ts + 1 modules
var segment = __webpack_require__(83697);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/Nps/redux/NpsSaga.ts



var NpsSaga_marked = runtime_default().mark(npsSaga);
var NpsSaga_marked1 = runtime_default().mark(NpsSaga_submitForm);
var NpsSaga_marked2 = runtime_default().mark(NpsSaga_submitRatings);
var NpsSaga_marked3 = runtime_default().mark(NpsSaga_fetchFastTrackNpsStatus);
var NpsSaga_marked4 = runtime_default().mark(NpsSaga_fetchNpsStatus);






function NpsSaga_fetchNpsStatus() {
    var res, ref, npsData, questionType;
    return runtime_default().wrap(function fetchNpsStatus$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(npsApis.fetchNpsStatus);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 24;
                    break;
                }
                ;
                npsData = res.data;
                _ctx.next = 9;
                return (0,io_c3792963.Y)(NpsActions/* npsActions.fetchNpsStatusSuccess */._.fetchNpsStatusSuccess(res.data));
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(NpsActions/* npsActions.updateNpsStatus */._.updateNpsStatus(((ref = res.data) === null || ref === void 0 ? void 0 : ref.isEligible) || false));
            case 11:
                if (!(npsData && npsData.rating && npsData.rating > 0)) {
                    _ctx.next = 22;
                    break;
                }
                _ctx.next = 14;
                return (0,io_c3792963.Y)(NpsActions/* npsActions.updateSubmitRating */._.updateSubmitRating(npsData.rating));
            case 14:
                questionType = (0,IeltsProfile_npsData/* getQuestionType */.Rf)(npsData.rating, npsData.questions);
                if (!questionType) {
                    _ctx.next = 18;
                    break;
                }
                _ctx.next = 18;
                return (0,io_c3792963.Y)(NpsActions/* npsActions.updateQuestion */._.updateQuestion((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, npsData.questions[questionType]), {
                    id: questionType
                })));
            case 18:
                _ctx.next = 20;
                return (0,io_c3792963.Y)(NpsActions/* npsActions.updateNpsId */._.updateNpsId("".concat(npsData === null || npsData === void 0 ? void 0 : npsData.npsId)));
            case 20:
                _ctx.next = 22;
                return (0,io_c3792963.Y)(NpsActions/* npsActions.updateQuestionType */._.updateQuestionType("suggestionForm"));
            case 22:
                _ctx.next = 26;
                break;
            case 24:
                _ctx.next = 26;
                return (0,io_c3792963.Y)(NpsActions/* npsActions.updateError */._.updateError(res.message));
            case 26:
                _ctx.next = 32;
                break;
            case 28:
                _ctx.prev = 28;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 32;
                return (0,io_c3792963.Y)(NpsActions/* npsActions.updateError */._.updateError("Something went wrong. Please try after sometime"));
            case 32:
            case "end":
                return _ctx.stop();
        }
    }, NpsSaga_marked4, null, [
        [
            0,
            28
        ]
    ]);
}
function NpsSaga_fetchFastTrackNpsStatus() {
    var res;
    return runtime_default().wrap(function fetchFastTrackNpsStatus$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(npsApis.fetchFastTrackNpsStatus);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(NpsActions/* npsActions.fetchNpsStatusSuccess */._.fetchNpsStatusSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(NpsActions/* npsActions.updateError */._.updateError(res.message));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(NpsActions/* npsActions.updateError */._.updateError("Something went wrong. Please try after sometime"));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, NpsSaga_marked3, null, [
        [
            0,
            13
        ]
    ]);
}
function NpsSaga_submitRatings(action) {
    var res, ref, pageName, npsData, questionType;
    return runtime_default().wrap(function submitRatings$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return (0,io_c3792963.Y)(NpsActions/* npsActions.updateQuestionType */._.updateQuestionType("loading"));
            case 2:
                _ctx.prev = 2;
                _ctx.next = 5;
                return (0,io_c3792963.N)(npsApis.submitRatings, action.payload);
            case 5:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 32;
                    break;
                }
                ;
                pageName = "";
                if (action.payload.pathName) {
                    if (action.payload.pathName == "ielts?section=plus") {
                        pageName = events_utils.ieltsPageName.IELTS_PLUS;
                    } else if (action.payload.pathName == "ielts?section=fastTrack") {
                        pageName = events_utils.ieltsPageName.IELTS_FAST_TRACK;
                    }
                }
                (0,segment.trackIeltsForm)("Form Filled", {
                    pageName: pageName || events_utils.ieltsPageName.IELTS_My_Classes,
                    widgetName: "NPS",
                    widgetFormat: "Form",
                    contentName: "NPS Question",
                    contentFormat: "Rating Scale",
                    rating: action.payload.ratings
                });
                if (!((ref = action.payload) === null || ref === void 0 ? void 0 : ref.isSkipped)) {
                    _ctx.next = 16;
                    break;
                }
                _ctx.next = 14;
                return (0,io_c3792963.Y)(NpsActions/* npsActions.updateNpsStatus */._.updateNpsStatus(false));
            case 14:
                _ctx.next = 30;
                break;
            case 16:
                _ctx.next = 18;
                return (0,io_c3792963.Y)(NpsActions/* npsActions.updateSubmitRating */._.updateSubmitRating(action.payload.ratings));
            case 18:
                _ctx.next = 20;
                return (0,io_c3792963.a3)(function(state) {
                    return state.ieltsNps.npsData;
                });
            case 20:
                npsData = _ctx.sent;
                if (!npsData) {
                    _ctx.next = 26;
                    break;
                }
                questionType = (0,IeltsProfile_npsData/* getQuestionType */.Rf)(action.payload.ratings, npsData.questions);
                if (!questionType) {
                    _ctx.next = 26;
                    break;
                }
                _ctx.next = 26;
                return (0,io_c3792963.Y)(NpsActions/* npsActions.updateQuestion */._.updateQuestion((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, npsData.questions[questionType]), {
                    id: questionType
                })));
            case 26:
                _ctx.next = 28;
                return (0,io_c3792963.Y)(NpsActions/* npsActions.updateNpsId */._.updateNpsId(res.data));
            case 28:
                _ctx.next = 30;
                return (0,io_c3792963.Y)(NpsActions/* npsActions.updateQuestionType */._.updateQuestionType("suggestionForm"));
            case 30:
                _ctx.next = 36;
                break;
            case 32:
                _ctx.next = 34;
                return (0,io_c3792963.Y)(NpsActions/* npsActions.updateQuestionType */._.updateQuestionType("rating"));
            case 34:
                _ctx.next = 36;
                return (0,io_c3792963.Y)(NpsActions/* npsActions.updateError */._.updateError(res.message));
            case 36:
                _ctx.next = 44;
                break;
            case 38:
                _ctx.prev = 38;
                _ctx.t0 = _ctx["catch"](2);
                _ctx.next = 42;
                return (0,io_c3792963.Y)(NpsActions/* npsActions.updateQuestionType */._.updateQuestionType("rating"));
            case 42:
                _ctx.next = 44;
                return (0,io_c3792963.Y)(NpsActions/* npsActions.updateError */._.updateError("Something went wrong. Please try after sometime"));
            case 44:
            case "end":
                return _ctx.stop();
        }
    }, NpsSaga_marked2, null, [
        [
            2,
            38
        ]
    ]);
}
function NpsSaga_submitForm(action) {
    var res, ref;
    return runtime_default().wrap(function submitForm$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return (0,io_c3792963.Y)(NpsActions/* npsActions.updateQuestionType */._.updateQuestionType("loading"));
            case 2:
                _ctx.prev = 2;
                _ctx.next = 5;
                return (0,io_c3792963.N)(npsApis.submitForm, action.payload);
            case 5:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 17;
                    break;
                }
                ;
                if (!((ref = action.payload) === null || ref === void 0 ? void 0 : ref.isSkipped)) {
                    _ctx.next = 13;
                    break;
                }
                _ctx.next = 11;
                return (0,io_c3792963.Y)(NpsActions/* npsActions.updateNpsStatus */._.updateNpsStatus(false));
            case 11:
                _ctx.next = 15;
                break;
            case 13:
                _ctx.next = 15;
                return (0,io_c3792963.Y)(NpsActions/* npsActions.updateQuestionType */._.updateQuestionType("thankYou"));
            case 15:
                _ctx.next = 21;
                break;
            case 17:
                _ctx.next = 19;
                return (0,io_c3792963.Y)(NpsActions/* npsActions.updateQuestionType */._.updateQuestionType("suggestionForm"));
            case 19:
                _ctx.next = 21;
                return (0,io_c3792963.Y)(NpsActions/* npsActions.updateError */._.updateError(res.message));
            case 21:
                _ctx.next = 29;
                break;
            case 23:
                _ctx.prev = 23;
                _ctx.t0 = _ctx["catch"](2);
                _ctx.next = 27;
                return (0,io_c3792963.Y)(NpsActions/* npsActions.updateQuestionType */._.updateQuestionType("suggestionForm"));
            case 27:
                _ctx.next = 29;
                return (0,io_c3792963.Y)(NpsActions/* npsActions.updateError */._.updateError("Something went wrong. Please try after sometime"));
            case 29:
            case "end":
                return _ctx.stop();
        }
    }, NpsSaga_marked1, null, [
        [
            2,
            23
        ]
    ]);
}
function npsSaga() {
    return runtime_default().wrap(function npsSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("FETCH_NPS_STATUS", NpsSaga_fetchNpsStatus);
            case 2:
                _ctx.next = 4;
                return takeLatest$1("SUBMIT_NPS_RATINGS", NpsSaga_submitRatings);
            case 4:
                _ctx.next = 6;
                return takeLatest$1("SUBMIT_NPS_FORM", NpsSaga_submitForm);
            case 6:
                _ctx.next = 8;
                return takeLatest$1("FETCH_FAST_TRACK_NPS_STATUS", NpsSaga_fetchFastTrackNpsStatus);
            case 8:
            case "end":
                return _ctx.stop();
        }
    }, NpsSaga_marked);
}
/* harmony default export */ var NpsSaga = (npsSaga);

// EXTERNAL MODULE: ./components/SpotCounselling/redux/SpotCounsellingActions.ts
var SpotCounsellingActions = __webpack_require__(10585);
;// CONCATENATED MODULE: ./components/SpotCounselling/redux/SpotCounsellingSaga.ts

var SpotCounsellingSaga_marked = runtime_default().mark(spotCounsellingSaga);
var SpotCounsellingSaga_marked1 = runtime_default().mark(fetchProfileLayout);
var SpotCounsellingSaga_marked2 = runtime_default().mark(fetchReQualificationEligibilitySaga);
var SpotCounsellingSaga_marked3 = runtime_default().mark(fetchEligibilitySaga);
var SpotCounsellingSaga_marked4 = runtime_default().mark(submitSpotProfile);
var SpotCounsellingSaga_marked5 = runtime_default().mark(fetchUpcomingEvents);
var SpotCounsellingSaga_marked6 = runtime_default().mark(fetchSpotProfile);
var SpotCounsellingSaga_marked7 = runtime_default().mark(confirmRescheduleSlot);
var SpotCounsellingSaga_marked8 = runtime_default().mark(confirmSpotCounsellingSlot);
var SpotCounsellingSaga_marked9 = runtime_default().mark(fetchSpotCounsellingSlot);
var SpotCounsellingSaga_marked10 = runtime_default().mark(getGoalPlanData);
var SpotCounsellingSaga_marked11 = runtime_default().mark(getAppNudgeEligibility);
var SpotCounsellingSaga_marked12 = runtime_default().mark(getStage);
var SpotCounsellingSaga_marked13 = runtime_default().mark(getExpertsData);



function getExpertsData() {
    var res;
    return runtime_default().wrap(function getExpertsData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(SpotCounsellingApi/* spotCounsellingApi.getExpertData */.nr.getExpertData);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchExpertsSuccess */.F.fetchExpertsSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchExpertsFail */.F.fetchExpertsFail(res.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchExpertsFail */.F.fetchExpertsFail("Something went wrong. Please try after sometime."));
            case 17:
                console.error(_ctx.t0);
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, SpotCounsellingSaga_marked13, null, [
        [
            0,
            13
        ]
    ]);
}
function getStage() {
    var res;
    return runtime_default().wrap(function getStage$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(SpotCounsellingApi/* spotCounsellingApi.getStage */.nr.getStage);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchStageSuccess */.F.fetchStageSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchStageFail */.F.fetchStageFail(res.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchExpertsFail */.F.fetchExpertsFail("Something went wrong. Please try after sometime."));
            case 17:
                console.error(_ctx.t0);
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, SpotCounsellingSaga_marked12, null, [
        [
            0,
            13
        ]
    ]);
}
function getAppNudgeEligibility() {
    var res, appData;
    return runtime_default().wrap(function getAppNudgeEligibility$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(SpotCounsellingApi/* spotCounsellingApi.getAppNudgeEligibility */.nr.getAppNudgeEligibility);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 14;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchAppNudgeEligibilitySuccess */.F.fetchAppNudgeEligibilitySuccess(res.data));
            case 7:
                _ctx.next = 9;
                return (0,io_c3792963.N)(SpotCounsellingApi/* spotCounsellingApi.getAppNudgeData */.nr.getAppNudgeData);
            case 9:
                appData = _ctx.sent;
                _ctx.next = 12;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchAppNudgeData */.F.fetchAppNudgeData(appData));
            case 12:
                _ctx.next = 16;
                break;
            case 14:
                _ctx.next = 16;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchAppNudgeEligibilityFail */.F.fetchAppNudgeEligibilityFail(res.message));
            case 16:
                _ctx.next = 22;
                break;
            case 18:
                _ctx.prev = 18;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 22;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchExpertsFail */.F.fetchExpertsFail("Something went wrong. Please try after sometime."));
            case 22:
            case "end":
                return _ctx.stop();
        }
    }, SpotCounsellingSaga_marked11, null, [
        [
            0,
            18
        ]
    ]);
}
function getGoalPlanData() {
    var res;
    return runtime_default().wrap(function getGoalPlanData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(SpotCounsellingApi/* spotCounsellingApi.getGoalPlanData */.nr.getGoalPlanData);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchGoalPlanDataSuccess */.F.fetchGoalPlanDataSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchGoalPlanDataFail */.F.fetchGoalPlanDataFail(res.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchGoalPlanDataFail */.F.fetchGoalPlanDataFail("Something went wrong. Please try after sometime."));
            case 17:
                console.error(_ctx.t0);
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, SpotCounsellingSaga_marked10, null, [
        [
            0,
            13
        ]
    ]);
}
function fetchSpotCounsellingSlot() {
    var slots;
    return runtime_default().wrap(function fetchSpotCounsellingSlot$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(SpotCounsellingApi/* spotCounsellingApi.fetchSpotCounsellingSlot */.nr.fetchSpotCounsellingSlot);
            case 3:
                slots = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchSpotCounsellingSlotSuccess */.F.fetchSpotCounsellingSlotSuccess(slots));
            case 6:
                _ctx.next = 12;
                break;
            case 8:
                _ctx.prev = 8;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 12;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchSpotCounsellingSlotFail */.F.fetchSpotCounsellingSlotFail(_ctx.t0.message));
            case 12:
            case "end":
                return _ctx.stop();
        }
    }, SpotCounsellingSaga_marked9, null, [
        [
            0,
            8
        ]
    ]);
}
function confirmSpotCounsellingSlot(action) {
    var res;
    return runtime_default().wrap(function confirmSpotCounsellingSlot$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(SpotCounsellingApi/* spotCounsellingApi.confirmSpotCounsellingSlot */.nr.confirmSpotCounsellingSlot, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.confirmSpotCounsellingSlotSuccess */.F.confirmSpotCounsellingSlotSuccess(res));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.confirmSpotCounsellingSlotFail */.F.confirmSpotCounsellingSlotFail(res));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.confirmSpotCounsellingSlotFail */.F.confirmSpotCounsellingSlotFail(_ctx.t0.message));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, SpotCounsellingSaga_marked8, null, [
        [
            0,
            13
        ]
    ]);
}
function confirmRescheduleSlot(action) {
    var res;
    return runtime_default().wrap(function confirmRescheduleSlot$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(SpotCounsellingApi/* spotCounsellingApi.confirmRescheduleSlot */.nr.confirmRescheduleSlot, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.confirmRescheduleSlotSuccess */.F.confirmRescheduleSlotSuccess(res));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.confirmRescheduleSlotFail */.F.confirmRescheduleSlotFail(res));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.confirmRescheduleSlotFail */.F.confirmRescheduleSlotFail(_ctx.t0.message));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, SpotCounsellingSaga_marked7, null, [
        [
            0,
            13
        ]
    ]);
}
function fetchSpotProfile() {
    var res;
    return runtime_default().wrap(function fetchSpotProfile$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(SpotCounsellingApi/* spotCounsellingApi.fetchSpotProfile */.nr.fetchSpotProfile);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchSpotProfileSuccess */.F.fetchSpotProfileSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchSpotProfileFail */.F.fetchSpotProfileFail(res.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchSpotProfileFail */.F.fetchSpotProfileFail("Something went wrong. Please try after sometime."));
            case 17:
                console.error(_ctx.t0);
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, SpotCounsellingSaga_marked6, null, [
        [
            0,
            13
        ]
    ]);
}
function fetchUpcomingEvents() {
    var res;
    return runtime_default().wrap(function fetchUpcomingEvents$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(SpotCounsellingApi/* spotCounsellingApi.fetchUpcommingEventsData */.nr.fetchUpcommingEventsData);
            case 3:
                res = _ctx.sent;
                if (!res) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchUpcomingEventsSuccess */.F.fetchUpcomingEventsSuccess(res));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchUpcomingEventsFail */.F.fetchUpcomingEventsFail("Something went wrong"));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchUpcomingEventsFail */.F.fetchUpcomingEventsFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, SpotCounsellingSaga_marked5, null, [
        [
            0,
            13
        ]
    ]);
}
function submitSpotProfile(action) {
    var ref, res;
    return runtime_default().wrap(function submitSpotProfile$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                ;
                _ctx.next = 4;
                return (0,io_c3792963.N)(SpotCounsellingApi/* spotCounsellingApi.submitSpotProfile */.nr.submitSpotProfile, action.payload);
            case 4:
                res = _ctx.sent;
                if (!(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                    _ctx.next = 10;
                    break;
                }
                _ctx.next = 8;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.submitSpotProfileSuccess */.F.submitSpotProfileSuccess(res.data.data));
            case 8:
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.submitSpotProfileFail */.F.submitSpotProfileFail(res));
            case 12:
                _ctx.next = 18;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.submitSpotProfileFail */.F.submitSpotProfileFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, SpotCounsellingSaga_marked4, null, [
        [
            0,
            14
        ]
    ]);
}
function fetchEligibilitySaga() {
    var ref, res;
    return runtime_default().wrap(function fetchEligibilitySaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                ;
                _ctx.next = 4;
                return (0,io_c3792963.N)(SpotCounsellingApi/* spotCounsellingApi.checkEligibilty */.nr.checkEligibilty);
            case 4:
                res = _ctx.sent;
                if (!((ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                    _ctx.next = 10;
                    break;
                }
                _ctx.next = 8;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchEligibilitySuccess */.F.fetchEligibilitySuccess(res.data.data));
            case 8:
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchEligibilityFail */.F.fetchEligibilityFail(res));
            case 12:
                _ctx.next = 19;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 19;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchEligibilityFail */.F.fetchEligibilityFail(_ctx.t0.message));
            case 19:
            case "end":
                return _ctx.stop();
        }
    }, SpotCounsellingSaga_marked3, null, [
        [
            0,
            14
        ]
    ]);
}
function fetchReQualificationEligibilitySaga() {
    var res;
    return runtime_default().wrap(function fetchReQualificationEligibilitySaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(SpotCounsellingApi/* spotCounsellingApi.checkReQualificationEligibility */.nr.checkReQualificationEligibility);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchReQualificationCheckSuccess */.F.fetchReQualificationCheckSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchReQualificationCheckFail */.F.fetchReQualificationCheckFail(res));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchReQualificationCheckFail */.F.fetchReQualificationCheckFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, SpotCounsellingSaga_marked2, null, [
        [
            0,
            13
        ]
    ]);
}
function fetchProfileLayout() {
    var res;
    return runtime_default().wrap(function fetchProfileLayout$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(SpotCounsellingApi/* spotCounsellingApi.getProfileLayout */.nr.getProfileLayout);
            case 3:
                res = _ctx.sent;
                if (!(res === null || res === void 0 ? void 0 : res.success)) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchProfileLayoutSuccess */.F.fetchProfileLayoutSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(SpotCounsellingActions/* spotCounsellingActions.fetchProfileLayoutFail */.F.fetchProfileLayoutFail(""));
            case 11:
                _ctx.next = 16;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0.message);
            case 16:
            case "end":
                return _ctx.stop();
        }
    }, SpotCounsellingSaga_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function spotCounsellingSaga() {
    return runtime_default().wrap(function spotCounsellingSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("ELIGIBILITY_FETCH_REQUESTED", fetchEligibilitySaga);
            case 2:
                _ctx.next = 4;
                return takeLatest$1("FETCH_UPCOMING_EVENTS", fetchUpcomingEvents);
            case 4:
                _ctx.next = 6;
                return takeLatest$1("FETCH_EXPERTS_DATA", getExpertsData);
            case 6:
                _ctx.next = 8;
                return takeLatest$1("FETCH_STAGE", getStage);
            case 8:
                _ctx.next = 10;
                return takeLatest$1("FETCH_SPOT_COUNSELLING_SLOT", fetchSpotCounsellingSlot);
            case 10:
                _ctx.next = 12;
                return takeLatest$1("CONFIRM_SPOT_COUNSELLING_SLOT", confirmSpotCounsellingSlot);
            case 12:
                _ctx.next = 14;
                return takeLatest$1("CONFIRM_SPOT_RESCHEDULE_SLOT", confirmRescheduleSlot);
            case 14:
                _ctx.next = 16;
                return takeLatest$1("FETCH_SPOT_PROFILE", fetchSpotProfile);
            case 16:
                _ctx.next = 18;
                return takeLatest$1("SUBMIT_SPOT_PROFILE", submitSpotProfile);
            case 18:
                _ctx.next = 20;
                return takeLatest$1("FETCH_GOAL_PLAN_DATA", getGoalPlanData);
            case 20:
                _ctx.next = 22;
                return takeLatest$1("FETCH_PROFILE_LAYOUT", fetchProfileLayout);
            case 22:
                _ctx.next = 24;
                return takeLatest$1("REQUALIFICATION_ELIGIBLITY_FETCH_REQUESTED", fetchReQualificationEligibilitySaga);
            case 24:
                _ctx.next = 26;
                return takeLatest$1("FETCH_APP_NUDGE_ELIGIBILITY", getAppNudgeEligibility);
            case 26:
            case "end":
                return _ctx.stop();
        }
    }, SpotCounsellingSaga_marked);
}
/* harmony default export */ var SpotCounsellingSaga = (spotCounsellingSaga);

// EXTERNAL MODULE: ./components/Ielts/PromoCode/redux/PromoCodeActions.ts
var PromoCodeActions = __webpack_require__(56515);
// EXTERNAL MODULE: ./components/Ielts/UpcomingIeltsBatches/ViewAllBatches/DataMapper/interface.ts
var DataMapper_interface = __webpack_require__(70941);
;// CONCATENATED MODULE: ./components/Ielts/PromoCode/redux/PromoCodeApi.ts




var fetchPromoCodeValidation = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarOpenRoute?path=promocode/apply/".concat(payload.promoCode), {
                        bundleId: payload.bundleId
                    });
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchPromoCodeValidation(payload) {
        return _ref.apply(this, arguments);
    };
}();
var fetchPromoCodes = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(batchType) {
        var promoCodeType, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    promoCodeType = batchType === DataMapper_interface/* BatchType.DET */.Ac.DET ? "det-elite" : "pte-elite";
                    _ctx.next = 4;
                    return api/* default.get */.Z.get("/api/scholarOpenRoute?path=".concat(promoCodeType, "/promocodes"));
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function fetchPromoCodes(batchType) {
        return _ref.apply(this, arguments);
    };
}();
var promoCodeApi = {
    fetchPromoCodeValidation: fetchPromoCodeValidation,
    fetchPromoCodes: fetchPromoCodes
};

;// CONCATENATED MODULE: ./components/Ielts/PromoCode/redux/PromoCodeSaga.ts



var PromoCodeSaga_marked = runtime_default().mark(promoCodeSaga);
var PromoCodeSaga_marked1 = runtime_default().mark(PromoCodeSaga_fetchPromoCodes);
var PromoCodeSaga_marked2 = runtime_default().mark(PromoCodeSaga_fetchPromoCodeValidation);







function PromoCodeSaga_fetchPromoCodeValidation(action) {
    var batchData, clickEvent, res, payload, price, VALID_PROMO_CODE, ref, ref1, INVALID_PROMO_CODE, ref2, ref3;
    return runtime_default().wrap(function fetchPromoCodeValidation$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                batchData = action.payload.batchData;
                _ctx.next = 3;
                return (0,io_c3792963.Y)(PromoCodeActions/* promoCodeActions.togglePromoCodeApplicationLoading */.r.togglePromoCodeApplicationLoading(true));
            case 3:
                clickEvent = function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(price) {
                        return runtime_default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    if (batchData) (0,segment.trackIeltsClick)(events_utils.ieltsPageName.IELTS_COURSE_DESCRIPTION_PAGE, {
                                        widgetName: "Promo Code",
                                        widgetFormat: "Field",
                                        contentName: "Apply",
                                        contentFormat: "Button",
                                        eventId: batchData === null || batchData === void 0 ? void 0 : batchData.id,
                                        eventCategory: (0,events_utils.getBatchType)(batchData),
                                        offerPrice: price
                                    });
                                case 1:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee);
                    }));
                    return function clickEvent(price) {
                        return _ref.apply(this, arguments);
                    };
                }();
                _ctx.prev = 4;
                _ctx.next = 7;
                return (0,io_c3792963.N)(promoCodeApi.fetchPromoCodeValidation, action.payload);
            case 7:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 20;
                    break;
                }
                payload = {
                    data: res.data,
                    offerPrice: action.payload.offerPrice
                };
                _ctx.next = 12;
                return (0,io_c3792963.Y)(PromoCodeActions/* promoCodeActions.fetchPromoCodeValidationSuccess */.r.fetchPromoCodeValidationSuccess(payload));
            case 12:
                price = payload.offerPrice - payload.data.discount / 100 * payload.offerPrice;
                _ctx.next = 15;
                return (0,io_c3792963.N)(clickEvent, price);
            case 15:
                VALID_PROMO_CODE = EventData/* eventName.VALID_PROMO_CODE */.oJ.VALID_PROMO_CODE;
                _ctx.next = 18;
                return (0,io_c3792963.N)(eventTracker/* eventTracker */.x, VALID_PROMO_CODE, (0,_define_property/* default */.Z)({
                    CATEGORY: "",
                    ACTION: "",
                    LABEL: ""
                }, EventData/* WEeventDataAttributeNames.PROMO_CODE */.sx.PROMO_CODE, action.payload.promoCode), false);
            case 18:
                _ctx.next = 28;
                break;
            case 20:
                ;
                INVALID_PROMO_CODE = EventData/* eventName.INVALID_PROMO_CODE */.oJ.INVALID_PROMO_CODE;
                _ctx.next = 24;
                return (0,io_c3792963.Y)(PromoCodeActions/* promoCodeActions.fetchPromoCodeValidationFail */.r.fetchPromoCodeValidationFail(res.message || "Invalid code. Try the code LEAPIELTS to get 10% off"));
            case 24:
                _ctx.next = 26;
                return (0,io_c3792963.N)(eventTracker/* eventTracker */.x, INVALID_PROMO_CODE, (0,_define_property/* default */.Z)({
                    CATEGORY: "",
                    ACTION: "",
                    LABEL: ""
                }, EventData/* WEeventDataAttributeNames.PROMO_CODE */.sx.PROMO_CODE, action.payload.promoCode), false);
            case 26:
                _ctx.next = 28;
                return (0,io_c3792963.N)(clickEvent, (batchData === null || batchData === void 0 ? void 0 : (ref = batchData.nudgeOffer) === null || ref === void 0 ? void 0 : ref.show) ? batchData === null || batchData === void 0 ? void 0 : (ref1 = batchData.nudgeOffer) === null || ref1 === void 0 ? void 0 : ref1.discountedOfferPrice : batchData === null || batchData === void 0 ? void 0 : batchData.offerPrice);
            case 28:
                _ctx.next = 30;
                return (0,io_c3792963.Y)(PromoCodeActions/* promoCodeActions.togglePromoCodeApplicationLoading */.r.togglePromoCodeApplicationLoading(false));
            case 30:
                _ctx.next = 41;
                break;
            case 32:
                _ctx.prev = 32;
                _ctx.t0 = _ctx["catch"](4);
                ;
                _ctx.next = 37;
                return (0,io_c3792963.Y)(PromoCodeActions/* promoCodeActions.fetchPromoCodeValidationFail */.r.fetchPromoCodeValidationFail("Something went wrong. Please try after sometime"));
            case 37:
                _ctx.next = 39;
                return (0,io_c3792963.N)(clickEvent, (batchData === null || batchData === void 0 ? void 0 : (ref2 = batchData.nudgeOffer) === null || ref2 === void 0 ? void 0 : ref2.show) ? batchData === null || batchData === void 0 ? void 0 : (ref3 = batchData.nudgeOffer) === null || ref3 === void 0 ? void 0 : ref3.discountedOfferPrice : batchData === null || batchData === void 0 ? void 0 : batchData.offerPrice);
            case 39:
                _ctx.next = 41;
                return (0,io_c3792963.Y)(PromoCodeActions/* promoCodeActions.togglePromoCodeApplicationLoading */.r.togglePromoCodeApplicationLoading(false));
            case 41:
            case "end":
                return _ctx.stop();
        }
    }, PromoCodeSaga_marked2, null, [
        [
            4,
            32
        ]
    ]);
}
function PromoCodeSaga_fetchPromoCodes(action) {
    var res;
    return runtime_default().wrap(function fetchPromoCodes$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(promoCodeApi.fetchPromoCodes, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(PromoCodeActions/* promoCodeActions.fetchPromoCodesSuccess */.r.fetchPromoCodesSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(PromoCodeActions/* promoCodeActions.fetchPromoCodesFail */.r.fetchPromoCodesFail(res.message));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(PromoCodeActions/* promoCodeActions.fetchPromoCodesFail */.r.fetchPromoCodesFail(_ctx.t0.message));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, PromoCodeSaga_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function promoCodeSaga() {
    return runtime_default().wrap(function promoCodeSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("FETCH_PROMO_CODE_VALIDATION", PromoCodeSaga_fetchPromoCodeValidation);
            case 2:
                _ctx.next = 4;
                return takeLatest$1("FETCH_PROMO_CODES", PromoCodeSaga_fetchPromoCodes);
            case 4:
            case "end":
                return _ctx.stop();
        }
    }, PromoCodeSaga_marked);
}
/* harmony default export */ var PromoCodeSaga = (promoCodeSaga);

// EXTERNAL MODULE: ./components/Profile/IeltsProfile/MockTest/redux/MockTestActions.ts
var MockTestActions = __webpack_require__(22192);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/MockTest/redux/MockTestApi.ts



var fetchMockTest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(batchId) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=mocktest/".concat(batchId));
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchMockTest(batchId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchFreeMockTest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=mocktest/event");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchFreeMockTest() {
        return _ref.apply(this, arguments);
    };
}();
var fetchSampleMockTest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=mocktest/freeMockTest");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchSampleMockTest() {
        return _ref.apply(this, arguments);
    };
}();
var fetchEssayStatus = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(essayId) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=workshop/essay/".concat(essayId, "/details"));
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchEssayStatus(essayId) {
        return _ref.apply(this, arguments);
    };
}();
var uploadWritingMockTest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
        var file, activeBatchId, activeMockTestIndex, formData, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    file = payload.file, activeBatchId = payload.activeBatchId, activeMockTestIndex = payload.activeMockTestIndex;
                    _ctx.prev = 1;
                    formData = new FormData();
                    formData.append("file", file);
                    _ctx.next = 6;
                    return api/* default.post */.Z.post("/api/uploadFile?name=workshop/essay/upload/".concat(activeBatchId, "/mocktest/").concat(activeMockTestIndex), formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    });
                case 6:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](1);
                    return _ctx.abrupt("return", {
                        success: false,
                        payload: "res.data.message"
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                10
            ]
        ]);
    }));
    return function uploadWritingMockTest(payload) {
        return _ref.apply(this, arguments);
    };
}();
var fetchEssayList = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=mocktest/independent/essays");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchEssayList() {
        return _ref.apply(this, arguments);
    };
}();
var mockTestApi = {
    fetchMockTest: fetchMockTest,
    fetchEssayStatus: fetchEssayStatus,
    uploadWritingMockTest: uploadWritingMockTest,
    fetchEssayList: fetchEssayList,
    fetchFreeMockTest: fetchFreeMockTest,
    fetchSampleMockTest: fetchSampleMockTest
};

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/MockTest/redux/MockTestSaga.ts

var MockTestSaga_marked = runtime_default().mark(mockTestSaga);
var MockTestSaga_marked1 = runtime_default().mark(MockTestSaga_fetchEssayList);
var MockTestSaga_marked2 = runtime_default().mark(MockTestSaga_uploadWritingMockTest);
var MockTestSaga_marked3 = runtime_default().mark(MockTestSaga_fetchEssayStatus);
var MockTestSaga_marked4 = runtime_default().mark(MockTestSaga_fetchFreeMockTest);
var MockTestSaga_marked5 = runtime_default().mark(MockTestSaga_fetchMockTest);



function MockTestSaga_fetchMockTest(action) {
    var res;
    return runtime_default().wrap(function fetchMockTest$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                res = null;
                if (!action.payload) {
                    _ctx.next = 8;
                    break;
                }
                _ctx.next = 5;
                return (0,io_c3792963.N)(mockTestApi.fetchMockTest, action.payload);
            case 5:
                res = _ctx.sent;
                _ctx.next = 11;
                break;
            case 8:
                _ctx.next = 10;
                return (0,io_c3792963.N)(mockTestApi.fetchFreeMockTest);
            case 10:
                res = _ctx.sent;
            case 11:
                if (!res.success) {
                    _ctx.next = 16;
                    break;
                }
                _ctx.next = 14;
                return (0,io_c3792963.Y)(MockTestActions/* mockTestActions.fetchMockTestSuccess */.A.fetchMockTestSuccess(res.data));
            case 14:
                _ctx.next = 18;
                break;
            case 16:
                _ctx.next = 18;
                return (0,io_c3792963.Y)(MockTestActions/* mockTestActions.updateError */.A.updateError(res.message));
            case 18:
                _ctx.next = 24;
                break;
            case 20:
                _ctx.prev = 20;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 24;
                return (0,io_c3792963.Y)(MockTestActions/* mockTestActions.updateError */.A.updateError("Something went wrong. Please try after sometime"));
            case 24:
            case "end":
                return _ctx.stop();
        }
    }, MockTestSaga_marked5, null, [
        [
            0,
            20
        ]
    ]);
}
function MockTestSaga_fetchFreeMockTest() {
    var res;
    return runtime_default().wrap(function fetchFreeMockTest$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(mockTestApi.fetchSampleMockTest);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(MockTestActions/* mockTestActions.fetchMockTestSuccess */.A.fetchMockTestSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(MockTestActions/* mockTestActions.updateError */.A.updateError(res.message));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(MockTestActions/* mockTestActions.updateError */.A.updateError("Something went wrong. Please try after sometime"));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, MockTestSaga_marked4, null, [
        [
            0,
            13
        ]
    ]);
}
function MockTestSaga_fetchEssayStatus(action) {
    var res;
    return runtime_default().wrap(function fetchEssayStatus$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(mockTestApi.fetchEssayStatus, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 8;
                    break;
                }
                {}
                _ctx.next = 10;
                break;
            case 8:
                _ctx.next = 10;
                return (0,io_c3792963.Y)(MockTestActions/* mockTestActions.updateError */.A.updateError(res.message));
            case 10:
                _ctx.next = 16;
                break;
            case 12:
                _ctx.prev = 12;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 16;
                return (0,io_c3792963.Y)(MockTestActions/* mockTestActions.updateError */.A.updateError("Something went wrong. Please try after sometime"));
            case 16:
            case "end":
                return _ctx.stop();
        }
    }, MockTestSaga_marked3, null, [
        [
            0,
            12
        ]
    ]);
}
function MockTestSaga_uploadWritingMockTest(action) {
    var res;
    return runtime_default().wrap(function uploadWritingMockTest$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(mockTestApi.uploadWritingMockTest, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(MockTestActions/* mockTestActions.toggleUploadMockTestStatus */.A.toggleUploadMockTestStatus(true));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(MockTestActions/* mockTestActions.updateError */.A.updateError(res.message));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(MockTestActions/* mockTestActions.updateError */.A.updateError("Something went wrong. Please try after sometime"));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, MockTestSaga_marked2, null, [
        [
            0,
            13
        ]
    ]);
}
function MockTestSaga_fetchEssayList() {
    var res;
    return runtime_default().wrap(function fetchEssayList$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(mockTestApi.fetchEssayList);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(MockTestActions/* mockTestActions.fetchEssayListSuccess */.A.fetchEssayListSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(MockTestActions/* mockTestActions.updateError */.A.updateError(res.message));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(MockTestActions/* mockTestActions.updateError */.A.updateError("Something went wrong. Please try after sometime"));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, MockTestSaga_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function mockTestSaga() {
    return runtime_default().wrap(function mockTestSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("FETCH_MOCK_TEST_REQUESTED", MockTestSaga_fetchMockTest);
            case 2:
                _ctx.next = 4;
                return takeLatest$1("FETCH_ESSAY_STATUS_REQUESTED", MockTestSaga_fetchEssayStatus);
            case 4:
                _ctx.next = 6;
                return takeLatest$1("UPLOAD_WRITING_MOCK_TEST", MockTestSaga_uploadWritingMockTest);
            case 6:
                _ctx.next = 8;
                return takeLatest$1("FETCH_ESSAY_LIST_REQUESTED", MockTestSaga_fetchEssayList);
            case 8:
                _ctx.next = 10;
                return takeLatest$1("FETCH_SAMPLE_MOCK_TEST_REQUESTED", MockTestSaga_fetchFreeMockTest);
            case 10:
            case "end":
                return _ctx.stop();
        }
    }, MockTestSaga_marked);
}
/* harmony default export */ var MockTestSaga = (mockTestSaga);

// EXTERNAL MODULE: ./lib/Razorpay/getCounsellingFee.ts
var getCounsellingFee = __webpack_require__(5288);
;// CONCATENATED MODULE: ./components/Profile/FastTrackRegistrationForm/redux/FastTrackFormApi.ts



var FastTrackFormApi_saveForm = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=workshop/ielts-class", values);
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function saveForm(values) {
        return _ref.apply(this, arguments);
    };
}();
var enrollToFastTrack = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(batchId) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=student/workshop/1/".concat(batchId, "/enroll"));
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please try after sometime");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function enrollToFastTrack(batchId) {
        return _ref.apply(this, arguments);
    };
}();
var fastTrackRegistrationFormApi = {
    saveForm: FastTrackFormApi_saveForm,
    enrollToFastTrack: enrollToFastTrack
};

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/FastTrack/redux/FatTrackApi.ts



var fetchFastTrackApi = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=fee/fasttrack/status");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        success: true,
                        data: res.data.data
                    });
                case 8:
                    return _ctx.abrupt("return", {
                        success: false,
                        data: res.data.message
                    });
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        success: false,
                        data: "Something went wrong"
                    });
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchFastTrackApi() {
        return _ref.apply(this, arguments);
    };
}();
var fetchFastTrackCardDetail = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=fasttrack/video/cards");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        success: true,
                        data: res.data.data
                    });
                case 8:
                    return _ctx.abrupt("return", {
                        success: false,
                        data: res.data.message
                    });
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        success: false,
                        data: "Something went wrong"
                    });
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchFastTrackCardDetail() {
        return _ref.apply(this, arguments);
    };
}();
var fetchFastTrackCategoryList = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=fasttrack/video/category/list");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        success: true,
                        data: res.data.data
                    });
                case 8:
                    return _ctx.abrupt("return", {
                        success: false,
                        data: res.data.message
                    });
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        success: false,
                        data: "Something went wrong"
                    });
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchFastTrackCategoryList() {
        return _ref.apply(this, arguments);
    };
}();
var fastTrackApi = {
    fetchFastTrackApi: fetchFastTrackApi,
    fetchFastTrackCardDetail: fetchFastTrackCardDetail,
    fetchFastTrackCategoryList: fetchFastTrackCategoryList
};

;// CONCATENATED MODULE: ./components/Profile/FastTrackRegistrationForm/redux/FastTrackFormSaga.ts



var FastTrackFormSaga_marked = runtime_default().mark(fastTrackSaga);
var FastTrackFormSaga_marked1 = runtime_default().mark(FastTrackFormSaga_enrollToFastTrack);
var FastTrackFormSaga_marked2 = runtime_default().mark(FastTrackFormSaga_saveData);








function FastTrackFormSaga_saveData(action) {
    var res, fastTrackStatus, paymentReceived;
    return runtime_default().wrap(function saveData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.Y)(FastTrackFormActions/* fastTrackActions.toggleCtaText */.g.toggleCtaText("Saving"));
            case 3:
                _ctx.next = 5;
                return (0,io_c3792963.N)(ga.fireTagEvent, "fast_track_initiate_checkout");
            case 5:
                _ctx.next = 7;
                return (0,io_c3792963.N)(fastTrackRegistrationFormApi.saveForm, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, action.payload.values), {
                    formId: "I2C_form"
                }));
            case 7:
                res = _ctx.sent;
                _ctx.next = 10;
                return (0,io_c3792963.N)(fastTrackApi.fetchFastTrackApi);
            case 10:
                fastTrackStatus = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 28;
                    break;
                }
                _ctx.next = 14;
                return (0,io_c3792963.Y)(FastTrackFormActions/* fastTrackActions.toggleFastTrackForm */.g.toggleFastTrackForm(false));
            case 14:
                (0,IeltsToCounsellingApi/* IeltsToCounsellingEligibility */.j6)(action.payload.values);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(FastTrackFormActions/* fastTrackActions.toggleCtaText */.g.toggleCtaText("Next"));
            case 17:
                _ctx.next = 19;
                return (0,io_c3792963.N)(getCounsellingFee/* getFastTrackFee */.Py, fastTrackStatus.data.offerPrice);
            case 19:
                paymentReceived = _ctx.sent;
                if (!paymentReceived) {
                    _ctx.next = 26;
                    break;
                }
                (0,ga.logEvent)(EventData/* eventCategory.FAST_TRACK */.f2.FAST_TRACK, EventData/* eventName.PAID_FOR_FAST_TRACK */.oJ.PAID_FOR_FAST_TRACK, "");
                _ctx.next = 24;
                return (0,io_c3792963.N)(ga.fireTagEvent, "fast_track_paid", {
                    value: "249",
                    currency: (fastTrackStatus === null || fastTrackStatus === void 0 ? void 0 : fastTrackStatus.currency) || "INR",
                    content_id: "fastrack",
                    content_type: "FastTrack"
                });
            case 24:
                _ctx.next = 26;
                return (0,io_c3792963.Y)(FastTrackFormActions/* fastTrackActions.toggleFastTrackFormModal */.g.toggleFastTrackFormModal(true));
            case 26:
                _ctx.next = 30;
                break;
            case 28:
                _ctx.next = 30;
                return (0,io_c3792963.Y)(FastTrackFormActions/* fastTrackActions.updateError */.g.updateError(res.message));
            case 30:
                _ctx.next = 37;
                break;
            case 32:
                _ctx.prev = 32;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 36;
                return (0,io_c3792963.Y)(FastTrackFormActions/* fastTrackActions.updateError */.g.updateError("Something went wrong. Please try after sometime."));
            case 36:
                console.error(_ctx.t0);
            case 37:
            case "end":
                return _ctx.stop();
        }
    }, FastTrackFormSaga_marked2, null, [
        [
            0,
            32
        ]
    ]);
}
function FastTrackFormSaga_enrollToFastTrack(action) {
    var res;
    return runtime_default().wrap(function enrollToFastTrack$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.Y)(FastTrackFormActions/* fastTrackActions.toggleCtaText */.g.toggleCtaText("Saving"));
            case 3:
                _ctx.next = 5;
                return (0,io_c3792963.N)(fastTrackRegistrationFormApi.enrollToFastTrack, action.payload);
            case 5:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 13;
                    break;
                }
                _ctx.next = 9;
                return (0,io_c3792963.Y)(FastTrackFormActions/* fastTrackActions.toggleCtaText */.g.toggleCtaText("Next"));
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(FastTrackFormActions/* fastTrackActions.toggleFastTrackFormModal */.g.toggleFastTrackFormModal(true));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.next = 15;
                return (0,io_c3792963.Y)(FastTrackFormActions/* fastTrackActions.updateError */.g.updateError(res.message));
            case 15:
                _ctx.next = 17;
                return (0,io_c3792963.Y)(FastTrackFormActions/* fastTrackActions.toggleCtaText */.g.toggleCtaText("Next"));
            case 17:
                _ctx.next = 24;
                break;
            case 19:
                _ctx.prev = 19;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 23;
                return (0,io_c3792963.Y)(FastTrackFormActions/* fastTrackActions.updateError */.g.updateError("Something went wrong. Please try after sometime."));
            case 23:
                console.error(_ctx.t0);
            case 24:
            case "end":
                return _ctx.stop();
        }
    }, FastTrackFormSaga_marked1, null, [
        [
            0,
            19
        ]
    ]);
}
function fastTrackSaga() {
    return runtime_default().wrap(function fastTrackSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(FastTrackFormActions/* fastTrackFormActionType.SAVE_FAST_TRACK_FORM */.I.SAVE_FAST_TRACK_FORM, FastTrackFormSaga_saveData);
            case 2:
                _ctx.next = 4;
                return takeLatest$1(FastTrackFormActions/* fastTrackFormActionType.ENROLL_TO_FAST_TRACK_FORM */.I.ENROLL_TO_FAST_TRACK_FORM, FastTrackFormSaga_enrollToFastTrack);
            case 4:
            case "end":
                return _ctx.stop();
        }
    }, FastTrackFormSaga_marked);
}
/* harmony default export */ var FastTrackFormSaga = (fastTrackSaga);

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/FastTrack/redux/FastTrackSaga.ts

var FastTrackSaga_marked = runtime_default().mark(FastTrackSaga_fastTrackSaga);
var FastTrackSaga_marked1 = runtime_default().mark(fetchCategoryList);
var FastTrackSaga_marked2 = runtime_default().mark(fetchFastTrackCard);
var FastTrackSaga_marked3 = runtime_default().mark(fetchFastTrackStatus);



function fetchFastTrackStatus() {
    var res;
    return runtime_default().wrap(function fetchFastTrackStatus$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(fastTrackApi.fetchFastTrackApi);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(FastTrackAction/* fastTrackAction.fetchFastTrackSuccess */.v.fetchFastTrackSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(FastTrackAction/* fastTrackAction.fetchFastTrackFail */.v.fetchFastTrackFail(res.data));
            case 11:
                _ctx.next = 19;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(FastTrackAction/* fastTrackAction.fetchFastTrackFail */.v.fetchFastTrackFail("Something went wrong"));
            case 18:
                throw new Error(_ctx.t0.message);
            case 19:
            case "end":
                return _ctx.stop();
        }
    }, FastTrackSaga_marked3, null, [
        [
            0,
            13
        ]
    ]);
}
function fetchFastTrackCard() {
    var res;
    return runtime_default().wrap(function fetchFastTrackCard$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(fastTrackApi.fetchFastTrackCardDetail);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(FastTrackAction/* fastTrackAction.fetchFastTrackCardSuccess */.v.fetchFastTrackCardSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(FastTrackAction/* fastTrackAction.fetchFastTrackCardFail */.v.fetchFastTrackCardFail(res.data));
            case 11:
                _ctx.next = 19;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(FastTrackAction/* fastTrackAction.fetchFastTrackCardFail */.v.fetchFastTrackCardFail("Something went wrong"));
            case 18:
                throw new Error(_ctx.t0.message);
            case 19:
            case "end":
                return _ctx.stop();
        }
    }, FastTrackSaga_marked2, null, [
        [
            0,
            13
        ]
    ]);
}
function fetchCategoryList() {
    var res;
    return runtime_default().wrap(function fetchCategoryList$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(fastTrackApi.fetchFastTrackCategoryList);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(FastTrackAction/* fastTrackAction.fetchFastTrackCardSuccess */.v.fetchFastTrackCardSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(FastTrackAction/* fastTrackAction.fetchFastTrackCardFail */.v.fetchFastTrackCardFail(res.data));
            case 11:
                _ctx.next = 19;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(FastTrackAction/* fastTrackAction.fetchFastTrackCardFail */.v.fetchFastTrackCardFail("Something went wrong"));
            case 18:
                throw new Error(_ctx.t0.message);
            case 19:
            case "end":
                return _ctx.stop();
        }
    }, FastTrackSaga_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function FastTrackSaga_fastTrackSaga() {
    return runtime_default().wrap(function fastTrackSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(FastTrackAction/* fastTrackActionType.FETCH_FAST_TRACK_STATUS_REQ */.X.FETCH_FAST_TRACK_STATUS_REQ, fetchFastTrackStatus);
            case 2:
                _ctx.next = 4;
                return takeLatest$1(FastTrackAction/* fastTrackActionType.FETCH_FAST_TRACK_CARD_REQ */.X.FETCH_FAST_TRACK_CARD_REQ, fetchFastTrackCard);
            case 4:
                _ctx.next = 6;
                return takeLatest$1(FastTrackAction/* fastTrackActionType.FETCH_FAST_TRACK_VIDEO_CATEGORY */.X.FETCH_FAST_TRACK_VIDEO_CATEGORY, fetchCategoryList);
            case 6:
            case "end":
                return _ctx.stop();
        }
    }, FastTrackSaga_marked);
}
/* harmony default export */ var FastTrackSaga = (FastTrackSaga_fastTrackSaga);

;// CONCATENATED MODULE: ./components/Profile/FastTrackVideo/redux/FastTrackVideoApi.ts



var fetchFastTrackVideoApi = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(videoCategoryName) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=fasttrack/video/v2/category/".concat(videoCategoryName));
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        success: true,
                        data: res.data.data
                    });
                case 8:
                    return _ctx.abrupt("return", {
                        success: false,
                        data: res.data.message
                    });
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        success: false,
                        data: "Something went wrong"
                    });
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchFastTrackVideoApi(videoCategoryName) {
        return _ref.apply(this, arguments);
    };
}();
var fetchFastTrackMarkVideoWatched = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(videoId) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=fasttrack/video/watched/".concat(videoId));
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        success: true,
                        data: res.data.data
                    });
                case 8:
                    return _ctx.abrupt("return", {
                        success: false,
                        data: res.data.message
                    });
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        success: false,
                        data: "Something went wrong"
                    });
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchFastTrackMarkVideoWatched(videoId) {
        return _ref.apply(this, arguments);
    };
}();
var fastTrackVideoApi = {
    fetchFastTrackVideoApi: fetchFastTrackVideoApi,
    fetchFastTrackMarkVideoWatched: fetchFastTrackMarkVideoWatched
};

;// CONCATENATED MODULE: ./components/Profile/FastTrackVideo/redux/FastTrackVideoSaga.ts

var FastTrackVideoSaga_marked = runtime_default().mark(fastTrackVideoSaga);
var FastTrackVideoSaga_marked1 = runtime_default().mark(fetchFastTrackVideoMarkedWatch);
var FastTrackVideoSaga_marked2 = runtime_default().mark(fetchFastTrackVideoStatus);



function fetchFastTrackVideoStatus(action) {
    var res;
    return runtime_default().wrap(function fetchFastTrackVideoStatus$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(fastTrackVideoApi.fetchFastTrackVideoApi, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(FastTrackVideoAction/* fastTrackVideoAction.fetchFastTrackVideoSuccess */.F.fetchFastTrackVideoSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(FastTrackVideoAction/* fastTrackVideoAction.fetchFastTrackVideoFail */.F.fetchFastTrackVideoFail(res.data));
            case 11:
                _ctx.next = 19;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(FastTrackVideoAction/* fastTrackVideoAction.fetchFastTrackVideoFail */.F.fetchFastTrackVideoFail("Something went wrong"));
            case 18:
                throw new Error(_ctx.t0.message);
            case 19:
            case "end":
                return _ctx.stop();
        }
    }, FastTrackVideoSaga_marked2, null, [
        [
            0,
            13
        ]
    ]);
}
function fetchFastTrackVideoMarkedWatch(action) {
    var res;
    return runtime_default().wrap(function fetchFastTrackVideoMarkedWatch$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(fastTrackVideoApi.fetchFastTrackMarkVideoWatched, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(FastTrackVideoAction/* fastTrackVideoAction.watchedVideoSuccess */.F.watchedVideoSuccess(true));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(FastTrackVideoAction/* fastTrackVideoAction.watchedVideoFail */.F.watchedVideoFail(res.data));
            case 11:
                _ctx.next = 19;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(FastTrackVideoAction/* fastTrackVideoAction.watchedVideoFail */.F.watchedVideoFail("Something went wrong"));
            case 18:
                throw new Error(_ctx.t0.message);
            case 19:
            case "end":
                return _ctx.stop();
        }
    }, FastTrackVideoSaga_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function fastTrackVideoSaga() {
    return runtime_default().wrap(function fastTrackVideoSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(FastTrackVideoAction/* fastTrackActionVideoType.FETCH_FAST_TRACK_VIDEO_REQ */.x.FETCH_FAST_TRACK_VIDEO_REQ, fetchFastTrackVideoStatus);
            case 2:
                _ctx.next = 4;
                return takeLatest$1(FastTrackVideoAction/* fastTrackActionVideoType.FAST_TRACK_WATCH_VIDEO */.x.FAST_TRACK_WATCH_VIDEO, fetchFastTrackVideoMarkedWatch);
            case 4:
            case "end":
                return _ctx.stop();
        }
    }, FastTrackVideoSaga_marked);
}
/* harmony default export */ var FastTrackVideoSaga = (fastTrackVideoSaga);

;// CONCATENATED MODULE: ./components/Profile/IntermediateScreen/redux/IntermediateScreenApi.ts



var updateUserInfo = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
        var newValues, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    newValues = {
                        name: values.name,
                        email: values.email
                    };
                    _ctx.next = 4;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=user/profile/update", newValues);
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function updateUserInfo(values) {
        return _ref.apply(this, arguments);
    };
}();
var intermediateScreenApi = {
    updateUserInfo: updateUserInfo
};

// EXTERNAL MODULE: ./components/Profile/IntermediateScreen/redux/IntermediateScreenActions.ts
var IntermediateScreenActions = __webpack_require__(34208);
// EXTERNAL MODULE: ./webEngage.js
var webEngage = __webpack_require__(84977);
// EXTERNAL MODULE: ./components/Profile/CounsellingProfile/redux/actions/overview-actions.ts
var overview_actions = __webpack_require__(79281);
;// CONCATENATED MODULE: ./components/Profile/IntermediateScreen/redux/IntermediateScreenSaga.ts


var IntermediateScreenSaga_marked = runtime_default().mark(intermediateScreenSaga);
var IntermediateScreenSaga_marked1 = runtime_default().mark(IntermediateScreenSaga_updateUserInfo);








function IntermediateScreenSaga_updateUserInfo(action) {
    var res, _obj, WE_FIRST_NAME, WE_EMAIL;
    return runtime_default().wrap(function updateUserInfo$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(intermediateScreenApi.updateUserInfo, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 16;
                    break;
                }
                ;
                (0,eventTracker/* eventTracker */.x)(EventData/* eventName.CHANGE_USER_DETAIL */.oJ.CHANGE_USER_DETAIL, (_obj = {}, (0,_define_property/* default */.Z)(_obj, EventData/* WEeventDataAttributeNames.USER_NAME */.sx.USER_NAME, action.payload.name), (0,_define_property/* default */.Z)(_obj, EventData/* WEeventDataAttributeNames.USER_EMAIL */.sx.USER_EMAIL, action.payload.email), _obj));
                WE_FIRST_NAME = EventData/* userAttributeName.WE_FIRST_NAME */.Dy.WE_FIRST_NAME, WE_EMAIL = EventData/* userAttributeName.WE_EMAIL */.Dy.WE_EMAIL;
                (0,webEngage/* webUserTracker */.j8)(WE_FIRST_NAME, action.payload.name);
                (0,webEngage/* webUserTracker */.j8)(WE_EMAIL, action.payload.email);
                _ctx.next = 12;
                return (0,io_c3792963.Y)(ReferAndEarnActions/* referAndEarnActions.fetchUserInfo */.F.fetchUserInfo());
            case 12:
                _ctx.next = 14;
                return (0,io_c3792963.Y)(overview_actions/* overviewActions.fetchOverviewData */.B.fetchOverviewData());
            case 14:
                _ctx.next = 16;
                return (0,io_c3792963.Y)(IntermediateScreenActions/* intermediateScreenActions.toggleView */.G.toggleView(false));
            case 16:
                _ctx.next = 21;
                break;
            case 18:
                _ctx.prev = 18;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
            case 21:
            case "end":
                return _ctx.stop();
        }
    }, IntermediateScreenSaga_marked1, null, [
        [
            0,
            18
        ]
    ]);
}
function intermediateScreenSaga() {
    return runtime_default().wrap(function intermediateScreenSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("UPDATE_USER_INFO_REQUESTED", IntermediateScreenSaga_updateUserInfo);
            case 2:
            case "end":
                return _ctx.stop();
        }
    }, IntermediateScreenSaga_marked);
}
/* harmony default export */ var IntermediateScreenSaga = (intermediateScreenSaga);

// EXTERNAL MODULE: ./components/Profile/CounsellingProfile/redux/apis/overview-apis.ts + 1 modules
var overview_apis = __webpack_require__(7241);
;// CONCATENATED MODULE: ./components/Profile/CounsellingProfile/redux/sagas/overview-sagas.ts

var overview_sagas_marked = runtime_default().mark(overviewSaga);
var overview_sagas_marked1 = runtime_default().mark(playList);
var overview_sagas_marked2 = runtime_default().mark(fetchOffer);
var overview_sagas_marked3 = runtime_default().mark(overview_sagas_fetchPostPaymentData);
var overview_sagas_marked4 = runtime_default().mark(fetchCounsellingFee);
var overview_sagas_marked5 = runtime_default().mark(fetchOverview);




function fetchOverview() {
    var res, events, eventsData, data;
    return runtime_default().wrap(function fetchOverview$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(overview_apis/* overviewApi.fetchOverviewRequest */.P.fetchOverviewRequest);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 13;
                    break;
                }
                events = res.data.data.events;
                eventsData = [];
                events && events.length > 0 && events.map(function(e, i) {
                    var event = {
                        id: i,
                        title: e.profile.name,
                        subtitle: e.profile.shortDescription,
                        image: e.profile.mobileImage,
                        meetingDate: e.startTime
                    };
                    eventsData.push(event);
                });
                data = res.data.data;
                _ctx.next = 11;
                return (0,io_c3792963.Y)(overview_actions/* overviewActions.fetchOverviewDataSuccess */.B.fetchOverviewDataSuccess({
                    eventsData: eventsData,
                    data: data
                }));
            case 11:
                _ctx.next = 15;
                break;
            case 13:
                _ctx.next = 15;
                return (0,io_c3792963.Y)(overview_actions/* overviewActions.fetchOverviewDataError */.B.fetchOverviewDataError(res.data.message));
            case 15:
                _ctx.next = 22;
                break;
            case 17:
                _ctx.prev = 17;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 22;
                return (0,io_c3792963.Y)(overview_actions/* overviewActions.fetchOverviewDataError */.B.fetchOverviewDataError(_ctx.t0.message));
            case 22:
            case "end":
                return _ctx.stop();
        }
    }, overview_sagas_marked5, null, [
        [
            0,
            17
        ]
    ]);
}
function fetchCounsellingFee() {
    var res;
    return runtime_default().wrap(function fetchCounsellingFee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(overview_apis/* overviewApi.fetchCounsellingFeeRequest */.P.fetchCounsellingFeeRequest);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(overview_actions/* overviewActions.fetchCounsellingFeeDataSuccess */.B.fetchCounsellingFeeDataSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(overview_actions/* overviewActions.fetchCounsellingFeeDataError */.B.fetchCounsellingFeeDataError(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(overview_actions/* overviewActions.fetchCounsellingFeeDataError */.B.fetchCounsellingFeeDataError(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, overview_sagas_marked4, null, [
        [
            0,
            13
        ]
    ]);
}
function overview_sagas_fetchPostPaymentData() {
    var res;
    return runtime_default().wrap(function fetchPostPaymentData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(overview_apis/* overviewApi.fetchPostPaymentDataRequest */.P.fetchPostPaymentDataRequest);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(overview_actions/* overviewActions.fetchPostPaymentDataSuccess */.B.fetchPostPaymentDataSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(overview_actions/* overviewActions.fetchPostPaymentDataError */.B.fetchPostPaymentDataError(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(overview_actions/* overviewActions.fetchPostPaymentDataError */.B.fetchPostPaymentDataError(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, overview_sagas_marked3, null, [
        [
            0,
            13
        ]
    ]);
}
function fetchOffer() {
    var res;
    return runtime_default().wrap(function fetchOffer$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(overview_apis/* overviewApi.fetchOfferRequest */.P.fetchOfferRequest);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(overview_actions/* overviewActions.fetchOfferSuccess */.B.fetchOfferSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(overview_actions/* overviewActions.fetchOfferError */.B.fetchOfferError(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(overview_actions/* overviewActions.fetchOfferError */.B.fetchOfferError(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, overview_sagas_marked2, null, [
        [
            0,
            13
        ]
    ]);
}
function playList() {
    var ref, res, playListData;
    return runtime_default().wrap(function playList$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                ;
                _ctx.next = 4;
                return (0,io_c3792963.N)(overview_apis/* overviewApi.fetchPlaylist */.P.fetchPlaylist);
            case 4:
                res = _ctx.sent;
                playListData = (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.plAyLists) || [];
                _ctx.next = 8;
                return (0,io_c3792963.Y)(overview_actions/* overviewActions.fetchPlayListSuccess */.B.fetchPlayListSuccess(playListData));
            case 8:
                _ctx.next = 14;
                break;
            case 10:
                _ctx.prev = 10;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 14;
                return (0,io_c3792963.Y)(overview_actions/* overviewActions.fetchPlayListFail */.B.fetchPlayListFail("Something went wrong. Please try after sometime"));
            case 14:
            case "end":
                return _ctx.stop();
        }
    }, overview_sagas_marked1, null, [
        [
            0,
            10
        ]
    ]);
}
function overviewSaga() {
    return runtime_default().wrap(function overviewSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(overview_constants/* default.FETCH_OVERVIEW_DATA */.Z.FETCH_OVERVIEW_DATA, fetchOverview);
            case 2:
                _ctx.next = 4;
                return takeLatest$1(overview_constants/* default.FETCH_COUNSELLING_FEE_DATA */.Z.FETCH_COUNSELLING_FEE_DATA, fetchCounsellingFee);
            case 4:
                _ctx.next = 6;
                return takeLatest$1(overview_constants/* default.FETCH_POST_PAYMENT_DATA */.Z.FETCH_POST_PAYMENT_DATA, overview_sagas_fetchPostPaymentData);
            case 6:
                _ctx.next = 8;
                return takeLatest$1(overview_constants/* default.FETCH_OFFER */.Z.FETCH_OFFER, fetchOffer);
            case 8:
                _ctx.next = 10;
                return takeLatest$1(overview_constants/* default.FETCH_PLAYLIST */.Z.FETCH_PLAYLIST, playList);
            case 10:
            case "end":
                return _ctx.stop();
        }
    }, overview_sagas_marked);
}
/* harmony default export */ var overview_sagas = (overviewSaga);

// EXTERNAL MODULE: ./components/Profile/CounsellingProfile/redux/actions/notice-board-actions.ts
var notice_board_actions = __webpack_require__(89961);
;// CONCATENATED MODULE: ./components/Profile/CounsellingProfile/redux/apis/notice-board-apis.ts



var fetchNoticeRequest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=profile/post/notice");
                case 3:
                    res = _ctx.sent;
                    console.log("notice response", res.data);
                    return _ctx.abrupt("return", res);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function fetchNoticeRequest() {
        return _ref.apply(this, arguments);
    };
}();
var noticeApi = {
    fetchNoticeRequest: fetchNoticeRequest
};

;// CONCATENATED MODULE: ./components/Profile/CounsellingProfile/redux/sagas/notice-board-sagas.ts

var notice_board_sagas_marked = runtime_default().mark(notice_board_sagas_noticeBoardSaga);
var notice_board_sagas_marked1 = runtime_default().mark(fetchNoticeBoard);




function fetchNoticeBoard() {
    var res;
    return runtime_default().wrap(function fetchNoticeBoard$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(noticeApi.fetchNoticeRequest);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(notice_board_actions/* noticeBoardActions.fetchNoticeBoardDataSuccess */.N.fetchNoticeBoardDataSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(notice_board_actions/* noticeBoardActions.fetchNoticeBoardDataError */.N.fetchNoticeBoardDataError(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(notice_board_actions/* noticeBoardActions.fetchNoticeBoardDataError */.N.fetchNoticeBoardDataError(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, notice_board_sagas_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function notice_board_sagas_noticeBoardSaga() {
    return runtime_default().wrap(function noticeBoardSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(notice_board_constants/* default.FETCH_NOTICE_BOARD_DATA */.Z.FETCH_NOTICE_BOARD_DATA, fetchNoticeBoard);
            case 2:
            case "end":
                return _ctx.stop();
        }
    }, notice_board_sagas_marked);
}
/* harmony default export */ var notice_board_sagas = (notice_board_sagas_noticeBoardSaga);

// EXTERNAL MODULE: ./components/Profile/CounsellingProfile/redux/actions/upcoming-appointments-actions.ts
var upcoming_appointments_actions = __webpack_require__(73309);
;// CONCATENATED MODULE: ./components/Profile/CounsellingProfile/redux/apis/upcoming-appointments-apis.ts



var fetchUpcomingAppointmentsRequest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=profile/post/events");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchUpcomingAppointmentsRequest() {
        return _ref.apply(this, arguments);
    };
}();
var upcomingAppointmentsApi = {
    fetchUpcomingAppointmentsRequest: fetchUpcomingAppointmentsRequest
};

;// CONCATENATED MODULE: ./components/Profile/CounsellingProfile/redux/sagas/upcoming-appointments-sagas.ts

var upcoming_appointments_sagas_marked = runtime_default().mark(upcomingAppointmentsSaga);
var upcoming_appointments_sagas_marked1 = runtime_default().mark(fetchUpcomingApointments);




function fetchUpcomingApointments() {
    var res;
    return runtime_default().wrap(function fetchUpcomingApointments$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(upcomingAppointmentsApi.fetchUpcomingAppointmentsRequest);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(upcoming_appointments_actions/* upcomingAppointmentsActions.fetchUpcomingAppointmentsDataSuccess */.E.fetchUpcomingAppointmentsDataSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(upcoming_appointments_actions/* upcomingAppointmentsActions.fetchUpcomingAppointmentsDataError */.E.fetchUpcomingAppointmentsDataError(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(upcoming_appointments_actions/* upcomingAppointmentsActions.fetchUpcomingAppointmentsDataError */.E.fetchUpcomingAppointmentsDataError(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, upcoming_appointments_sagas_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function upcomingAppointmentsSaga() {
    return runtime_default().wrap(function upcomingAppointmentsSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(upcoming_appointments_constants/* default.FETCH_UPCOMING_APPOINTMENTS_DATA */.Z.FETCH_UPCOMING_APPOINTMENTS_DATA, fetchUpcomingApointments);
            case 2:
            case "end":
                return _ctx.stop();
        }
    }, upcoming_appointments_sagas_marked);
}
/* harmony default export */ var upcoming_appointments_sagas = (upcomingAppointmentsSaga);

// EXTERNAL MODULE: ./components/Profile/CounsellingProfile/redux/actions/document-details-actions.ts
var document_details_actions = __webpack_require__(3561);
;// CONCATENATED MODULE: ./components/Profile/CounsellingProfile/redux/apis/document-details-apis.ts



var fetchDocumentDetailsRequest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=profile/post/doc");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchDocumentDetailsRequest() {
        return _ref.apply(this, arguments);
    };
}();
var documentDetailsApi = {
    fetchDocumentDetailsRequest: fetchDocumentDetailsRequest
};

;// CONCATENATED MODULE: ./components/Profile/CounsellingProfile/redux/sagas/document-details-sagas.ts

var document_details_sagas_marked = runtime_default().mark(documentsDetailsSaga);
var document_details_sagas_marked1 = runtime_default().mark(fetchDocumentsDetailsData);




function fetchDocumentsDetailsData() {
    var res;
    return runtime_default().wrap(function fetchDocumentsDetailsData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(documentDetailsApi.fetchDocumentDetailsRequest);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(document_details_actions/* documentDetailsActions.fetchDocumentDetailsDataSuccess */.C.fetchDocumentDetailsDataSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(document_details_actions/* documentDetailsActions.fetchDocumentDetailsDataError */.C.fetchDocumentDetailsDataError(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(document_details_actions/* documentDetailsActions.fetchDocumentDetailsDataError */.C.fetchDocumentDetailsDataError(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, document_details_sagas_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function documentsDetailsSaga() {
    return runtime_default().wrap(function documentsDetailsSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(document_details_constants/* default.FETCH_DOCUMENT_DETAILS_DATA */.Z.FETCH_DOCUMENT_DETAILS_DATA, fetchDocumentsDetailsData);
            case 2:
            case "end":
                return _ctx.stop();
        }
    }, document_details_sagas_marked);
}
/* harmony default export */ var document_details_sagas = (documentsDetailsSaga);

// EXTERNAL MODULE: ./components/Profile/CounsellingProfile/redux/actions/visa-assistance-action.ts
var visa_assistance_action = __webpack_require__(74386);
;// CONCATENATED MODULE: ./components/Profile/CounsellingProfile/redux/apis/visa-assistance-apis.ts



var fetchVisaAssistanceDataRequest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=profile/post/visa-counsellor");
                case 3:
                    res = _ctx.sent;
                    console.log("response for visa", res.data);
                    return _ctx.abrupt("return", res);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function fetchVisaAssistanceDataRequest() {
        return _ref.apply(this, arguments);
    };
}();
var visaAssistanceApi = {
    fetchVisaAssistanceDataRequest: fetchVisaAssistanceDataRequest
};

;// CONCATENATED MODULE: ./components/Profile/CounsellingProfile/redux/sagas/visa-assistance-sagas.ts

var visa_assistance_sagas_marked = runtime_default().mark(visaAssistanceSaga);
var visa_assistance_sagas_marked1 = runtime_default().mark(fetchVisaAssistanceData);




function fetchVisaAssistanceData() {
    var res;
    return runtime_default().wrap(function fetchVisaAssistanceData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(visaAssistanceApi.fetchVisaAssistanceDataRequest);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(visa_assistance_action/* visaAssistanceActions.ffetchVisaAssistanceDataSuccess */.I.ffetchVisaAssistanceDataSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(visa_assistance_action/* visaAssistanceActions.fetchVisaAssistanceDataError */.I.fetchVisaAssistanceDataError(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(visa_assistance_action/* visaAssistanceActions.fetchVisaAssistanceDataError */.I.fetchVisaAssistanceDataError(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, visa_assistance_sagas_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function visaAssistanceSaga() {
    return runtime_default().wrap(function visaAssistanceSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(visa_assistance_constants/* default.FETCH_VISA_ASSISTANCE_DATA */.Z.FETCH_VISA_ASSISTANCE_DATA, fetchVisaAssistanceData);
            case 2:
            case "end":
                return _ctx.stop();
        }
    }, visa_assistance_sagas_marked);
}
/* harmony default export */ var visa_assistance_sagas = (visaAssistanceSaga);

// EXTERNAL MODULE: ./components/Profile/RegistrationForm/redux/RegistrationFormActions.ts
var RegistrationFormActions = __webpack_require__(68884);
;// CONCATENATED MODULE: ./components/Profile/RegistrationForm/redux/RegistrationFormSaga.ts

var RegistrationFormSaga_marked = runtime_default().mark(registrationFormSaga);
var RegistrationFormSaga_marked1 = runtime_default().mark(fetchInitialFormValues);



function fetchInitialFormValues() {
    var res;
    return runtime_default().wrap(function fetchInitialFormValues$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(RegistrationFormApi/* registrationFormApi.fetchInitialFormValues */.U.fetchInitialFormValues);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(RegistrationFormActions/* registrationFormAction.fetchInitialFormValuesSuccess */.y.fetchInitialFormValuesSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(RegistrationFormActions/* registrationFormAction.updateError */.y.updateError(res.message));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(RegistrationFormActions/* registrationFormAction.updateError */.y.updateError("Something went wrong. Please try after sometime"));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, RegistrationFormSaga_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function registrationFormSaga() {
    return runtime_default().wrap(function registrationFormSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("FETCH_INITIAL_FORM_VALUES_REQUESTED", fetchInitialFormValues);
            case 2:
            case "end":
                return _ctx.stop();
        }
    }, RegistrationFormSaga_marked);
}
/* harmony default export */ var RegistrationFormSaga = (registrationFormSaga);

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/Masterclass/redux/MasterclassApis.ts




var MasterclassApis_fetchMasterclassSubscriptionStatus = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=workshop/master-class-subscription-status");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchMasterclassSubscriptionStatus() {
        return _ref.apply(this, arguments);
    };
}();
var fetchMasterclassData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=workshop/MASTER_CLASS/0/20/v3");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchMasterclassData() {
        return _ref.apply(this, arguments);
    };
}();
var fetchBeginnerMasterclassData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=workshop/".concat(WorkshopData/* batchType.BEGINNER_MASTER_CLASS */.d.BEGINNER_MASTER_CLASS, "/0/12/v3"));
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchBeginnerMasterclassData() {
        return _ref.apply(this, arguments);
    };
}();
var enrollForMasterclass = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=workshop/master-class/subscribe");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function enrollForMasterclass() {
        return _ref.apply(this, arguments);
    };
}();
var fetchMasterclassSubscriptionState = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=v2/workshop/ieltsFreeCourse/status");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchMasterclassSubscriptionState() {
        return _ref.apply(this, arguments);
    };
}();
var fetchMasterclassRecommendation = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=workshop/recommended/master-class");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchMasterclassRecommendation() {
        return _ref.apply(this, arguments);
    };
}();
var subscribeToMasterClass = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=workshop/master-class/subscribe");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        success: false,
                        message: "Something went wrong please try later after some time. server is down now we are working on it"
                    });
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function subscribeToMasterClass() {
        return _ref.apply(this, arguments);
    };
}();
var masterclassApis = {
    fetchMasterclassSubscriptionStatus: MasterclassApis_fetchMasterclassSubscriptionStatus,
    fetchMasterclassData: fetchMasterclassData,
    enrollForMasterclass: enrollForMasterclass,
    fetchBeginnerMasterclassData: fetchBeginnerMasterclassData,
    fetchMasterclassSubscriptionState: fetchMasterclassSubscriptionState,
    fetchMasterclassRecommendation: fetchMasterclassRecommendation,
    subscribeToMasterClass: subscribeToMasterClass
};

// EXTERNAL MODULE: ./lib/sortingJson.ts
var sortingJson = __webpack_require__(64342);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/Masterclass/redux/MasterclassSaga.ts

var MasterclassSaga_marked = runtime_default().mark(MasterclassSaga_masterclassSaga);
var MasterclassSaga_marked1 = runtime_default().mark(fetchMasterclassRecommendationSaga);
var MasterclassSaga_marked2 = runtime_default().mark(subscribeToMasterClassSaga);
var MasterclassSaga_marked3 = runtime_default().mark(MasterclassSaga_fetchMasterclassSubscriptionState);
var MasterclassSaga_marked4 = runtime_default().mark(MasterclassSaga_fetchBeginnerMasterclassData);
var MasterclassSaga_marked5 = runtime_default().mark(enrollForMasterclassRequested);
var MasterclassSaga_marked6 = runtime_default().mark(MasterclassSaga_fetchMasterclassData);
var MasterclassSaga_marked7 = runtime_default().mark(MasterclassSaga_fetchMasterclassSubscriptionStatus);







function MasterclassSaga_fetchMasterclassSubscriptionStatus(action) {
    var res;
    return runtime_default().wrap(function fetchMasterclassSubscriptionStatus$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(masterclassApis.fetchMasterclassSubscriptionStatus);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 10;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.fetchMasterclassSubscriptionStatusSuccess */.u.fetchMasterclassSubscriptionStatusSuccess(res.data));
            case 7:
                action.callback(res.data);
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.updateError */.u.updateError(res.message));
            case 12:
                _ctx.next = 18;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.updateError */.u.updateError("Something went wrong. Please try after sometime"));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, MasterclassSaga_marked7, null, [
        [
            0,
            14
        ]
    ]);
}
function MasterclassSaga_fetchMasterclassData() {
    var res, masterclassData;
    return runtime_default().wrap(function fetchMasterclassData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(masterclassApis.fetchMasterclassData);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 10;
                    break;
                }
                masterclassData = res.data.filter(function(data) {
                    return moment_default()(data.meetingStartTime) > moment_default()();
                });
                _ctx.next = 8;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.fetchMasterclassDataSuccess */.u.fetchMasterclassDataSuccess((0,sortingJson/* sortJSON */.xR)(masterclassData, "meetingStartTime", true)));
            case 8:
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.updateError */.u.updateError(res.message));
            case 12:
                _ctx.next = 18;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.updateError */.u.updateError("Something went wrong. Please try after sometime"));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, MasterclassSaga_marked6, null, [
        [
            0,
            14
        ]
    ]);
}
function enrollForMasterclassRequested() {
    var res;
    return runtime_default().wrap(function enrollForMasterclassRequested$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.updateUnsubscribedCtaText */.u.updateUnsubscribedCtaText("Please wait"));
            case 2:
                _ctx.prev = 2;
                _ctx.next = 5;
                return (0,io_c3792963.N)(masterclassApis.enrollForMasterclass);
            case 5:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 17;
                    break;
                }
                _ctx.next = 9;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.setMasterclassSubscriptionStatus */.u.setMasterclassSubscriptionStatus(null));
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.toggleMasterclassEnrollModal */.u.toggleMasterclassEnrollModal(true));
            case 11:
                _ctx.next = 13;
                return (0,io_c3792963.Y)(MasterclassRegistrationFormAction/* masterclassRegistrationActions.toggleMasterclassFormModal */.Z.toggleMasterclassFormModal(true));
            case 13:
                _ctx.next = 15;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.fetchMasterclassSubscriptionStatus */.u.fetchMasterclassSubscriptionStatus());
            case 15:
                _ctx.next = 19;
                break;
            case 17:
                _ctx.next = 19;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.updateError */.u.updateError(res.message));
            case 19:
                _ctx.next = 25;
                break;
            case 21:
                _ctx.prev = 21;
                _ctx.t0 = _ctx["catch"](2);
                _ctx.next = 25;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.updateError */.u.updateError("Something went wrong. Please try after sometime"));
            case 25:
                _ctx.prev = 25;
                _ctx.next = 28;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.updateUnsubscribedCtaText */.u.updateUnsubscribedCtaText("Subscribe For Free Masterclass"));
            case 28:
                return _ctx.finish(25);
            case 29:
            case "end":
                return _ctx.stop();
        }
    }, MasterclassSaga_marked5, null, [
        [
            2,
            21,
            25,
            29
        ]
    ]);
}
function MasterclassSaga_fetchBeginnerMasterclassData() {
    var res, masterclassData;
    return runtime_default().wrap(function fetchBeginnerMasterclassData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(masterclassApis.fetchBeginnerMasterclassData);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 10;
                    break;
                }
                masterclassData = res.data.filter(function(data) {
                    return moment_default()(data.meetingStartTime) > moment_default()();
                });
                _ctx.next = 8;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.fetchBeginnerMasterclassDataSuccess */.u.fetchBeginnerMasterclassDataSuccess((0,sortingJson/* sortJSON */.xR)(masterclassData, "meetingStartTime", true)));
            case 8:
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.updateError */.u.updateError(res.message));
            case 12:
                _ctx.next = 18;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.updateError */.u.updateError("Something went wrong. Please try after sometime"));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, MasterclassSaga_marked4, null, [
        [
            0,
            14
        ]
    ]);
}
function MasterclassSaga_fetchMasterclassSubscriptionState() {
    var res;
    return runtime_default().wrap(function fetchMasterclassSubscriptionState$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(masterclassApis.fetchMasterclassSubscriptionState);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.fetchFreeIeltsCourseSuccess */.u.fetchFreeIeltsCourseSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.updateError */.u.updateError(res.message));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.updateError */.u.updateError("Something went wrong. Please try after sometime"));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, MasterclassSaga_marked3, null, [
        [
            0,
            13
        ]
    ]);
}
function subscribeToMasterClassSaga(action) {
    var res;
    return runtime_default().wrap(function subscribeToMasterClassSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(masterclassApis.subscribeToMasterClass);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 10;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.setMasterclassSubscriptionStatus */.u.setMasterclassSubscriptionStatus(true));
            case 7:
                if ((0,common_utils/* isFunction */.mf)(action.payload)) {
                    action.payload(true);
                }
                _ctx.next = 13;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.updateError */.u.updateError(res.message));
            case 12:
                if ((0,common_utils/* isFunction */.mf)(action.payload)) {
                    action.payload(false);
                }
            case 13:
                _ctx.next = 20;
                break;
            case 15:
                _ctx.prev = 15;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 19;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.updateError */.u.updateError("Something went wrong. Please try after sometime"));
            case 19:
                if ((0,common_utils/* isFunction */.mf)(action.payload)) {
                    action.payload(false);
                }
            case 20:
            case "end":
                return _ctx.stop();
        }
    }, MasterclassSaga_marked2, null, [
        [
            0,
            15
        ]
    ]);
}
function fetchMasterclassRecommendationSaga() {
    var res;
    return runtime_default().wrap(function fetchMasterclassRecommendationSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(masterclassApis.fetchMasterclassRecommendation);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.fetchMasterclassRecommendationSuccess */.u.fetchMasterclassRecommendationSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.updateError */.u.updateError(res.message));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.updateError */.u.updateError("Something went wrong. Please try after sometime"));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, MasterclassSaga_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function MasterclassSaga_masterclassSaga() {
    return runtime_default().wrap(function masterclassSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("FETCH_MASTERCLASS_SUBSCRIPTION_REQUESTED", MasterclassSaga_fetchMasterclassSubscriptionStatus);
            case 2:
                _ctx.next = 4;
                return takeLatest$1("FETCH_FREE_IELTS_COURSE_STATE", MasterclassSaga_fetchMasterclassSubscriptionState);
            case 4:
                _ctx.next = 6;
                return takeLatest$1("FETCH_MASTERCLASS_DATA_REQUESTED", MasterclassSaga_fetchMasterclassData);
            case 6:
                _ctx.next = 8;
                return takeLatest$1("FETCH_BEGINNER_MASTERCLASS", MasterclassSaga_fetchBeginnerMasterclassData);
            case 8:
                _ctx.next = 10;
                return takeLatest$1("ENROLL_FOR_MASTERCLASS_REQUESTED", enrollForMasterclassRequested);
            case 10:
                _ctx.next = 12;
                return takeLatest$1("FETCH_MASTERCLASS_RECOMMENDATION", fetchMasterclassRecommendationSaga);
            case 12:
                _ctx.next = 14;
                return takeLatest$1("SUBSCRIBE_TO_MASTERCLASSES", subscribeToMasterClassSaga);
            case 14:
            case "end":
                return _ctx.stop();
        }
    }, MasterclassSaga_marked);
}
/* harmony default export */ var MasterclassSaga = (MasterclassSaga_masterclassSaga);

// EXTERNAL MODULE: ./components/Profile/IeltsProfile/IeltsTest/redux/IeltsTestActions.ts
var IeltsTestActions = __webpack_require__(43302);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/IeltsTest/redux/IeltsTestApis.ts



var fetchIeltsTestSubmissionStatus = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=basket/status");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchIeltsTestSubmissionStatus() {
        return _ref.apply(this, arguments);
    };
}();
var submitIeltsTestDetails = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
        var ref, ref1, values, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    values = {
                        testDateReceiptUrl: payload["IELTS_TEST_DETAILS"].url,
                        testDate: payload.examDate,
                        ieltsExamType: (ref = payload === null || payload === void 0 ? void 0 : payload.ieltsExamType) !== null && ref !== void 0 ? ref : null,
                        oneToOneCounsellingSession: (ref1 = payload === null || payload === void 0 ? void 0 : payload.oneToOneCounsellingSession) !== null && ref1 !== void 0 ? ref1 : null
                    };
                    _ctx.next = 5;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=artifact/save/ielts_test_details_basket", values);
                case 5:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                9
            ]
        ]);
    }));
    return function submitIeltsTestDetails(payload) {
        return _ref.apply(this, arguments);
    };
}();
var fetchIeltsDateRewards = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(stage) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=basket/rewards/".concat(stage));
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchIeltsDateRewards(stage) {
        return _ref.apply(this, arguments);
    };
}();
var fetchIeltsDateUserStatus = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=basket/user-status");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchIeltsDateUserStatus() {
        return _ref.apply(this, arguments);
    };
}();
var fetchIeltsTestBannerStatusApi = function() {
    return api/* default.get */.Z.get("/api/scholarRoute?path=metadata/ielts");
};
var ieltsTestApis = {
    fetchIeltsTestSubmissionStatus: fetchIeltsTestSubmissionStatus,
    submitIeltsTestDetails: submitIeltsTestDetails,
    fetchIeltsDateRewards: fetchIeltsDateRewards,
    fetchIeltsDateUserStatus: fetchIeltsDateUserStatus,
    fetchIeltsTestBannerStatusApi: fetchIeltsTestBannerStatusApi
};

// EXTERNAL MODULE: ./Interfaces/reducerTypes/IeltsTestSchema.ts
var IeltsTestSchema = __webpack_require__(46510);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/IeltsTest/redux/IeltsTestSaga.ts

var IeltsTestSaga_marked = runtime_default().mark(ieltsTestSaga);
var IeltsTestSaga_marked1 = runtime_default().mark(fetchIeltsTestBannerStatus);
var IeltsTestSaga_marked2 = runtime_default().mark(IeltsTestSaga_fetchIeltsDateUserStatus);
var IeltsTestSaga_marked3 = runtime_default().mark(IeltsTestSaga_fetchIeltsDateRewards);
var IeltsTestSaga_marked4 = runtime_default().mark(saveIeltsTestSubmissionDetails);
var IeltsTestSaga_marked5 = runtime_default().mark(fetchIeltsTestSubmission);




function fetchIeltsTestSubmission() {
    var res, submissionStatus;
    return runtime_default().wrap(function fetchIeltsTestSubmission$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(ieltsTestApis.fetchIeltsTestSubmissionStatus);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 10;
                    break;
                }
                submissionStatus = res.data;
                _ctx.next = 8;
                return (0,io_c3792963.Y)(IeltsTestActions/* ieltsTestActions.updateIeltsTestSubmissionStatus */.J.updateIeltsTestSubmissionStatus(submissionStatus));
            case 8:
                _ctx.next = 11;
                break;
            case 10:
                {
                    console.log(res.message);
                }
            case 11:
                _ctx.next = 16;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.log("something went wonrg");
            case 16:
            case "end":
                return _ctx.stop();
        }
    }, IeltsTestSaga_marked5, null, [
        [
            0,
            13
        ]
    ]);
}
function saveIeltsTestSubmissionDetails(action) {
    var res;
    return runtime_default().wrap(function saveIeltsTestSubmissionDetails$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(ieltsTestApis.submitIeltsTestDetails, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 13;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(IeltsTestActions/* ieltsTestActions.toggleShowSubmittedDocsModal */.J.toggleShowSubmittedDocsModal(true));
            case 7:
                _ctx.next = 9;
                return (0,io_c3792963.Y)(IeltsTestActions/* ieltsTestActions.toggleIeltsTestForm */.J.toggleIeltsTestForm(false));
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(IeltsTestActions/* ieltsTestActions.updateIeltsTestSubmissionStatus */.J.updateIeltsTestSubmissionStatus(IeltsTestSchema/* IeltsTestStatus.SUBMITTED */.wX.SUBMITTED));
            case 11:
                _ctx.next = 14;
                break;
            case 13:
                {
                    console.log(res.message);
                }
            case 14:
                _ctx.next = 19;
                break;
            case 16:
                _ctx.prev = 16;
                _ctx.t0 = _ctx["catch"](0);
                console.log("something went wrong");
            case 19:
            case "end":
                return _ctx.stop();
        }
    }, IeltsTestSaga_marked4, null, [
        [
            0,
            16
        ]
    ]);
}
function IeltsTestSaga_fetchIeltsDateRewards(action) {
    var res;
    return runtime_default().wrap(function fetchIeltsDateRewards$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(ieltsTestApis.fetchIeltsDateRewards, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(IeltsTestActions/* ieltsTestActions.setRewards */.J.setRewards(res.data));
            case 7:
                _ctx.next = 10;
                break;
            case 9:
                {
                    console.log(res.message);
                }
            case 10:
                _ctx.next = 15;
                break;
            case 12:
                _ctx.prev = 12;
                _ctx.t0 = _ctx["catch"](0);
                console.log("something went wrong");
            case 15:
            case "end":
                return _ctx.stop();
        }
    }, IeltsTestSaga_marked3, null, [
        [
            0,
            12
        ]
    ]);
}
function IeltsTestSaga_fetchIeltsDateUserStatus() {
    var res;
    return runtime_default().wrap(function fetchIeltsDateUserStatus$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(ieltsTestApis.fetchIeltsDateUserStatus);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(IeltsTestActions/* ieltsTestActions.setUserStatus */.J.setUserStatus(res.data));
            case 7:
                _ctx.next = 10;
                break;
            case 9:
                {
                    console.log(res.message);
                }
            case 10:
                _ctx.next = 15;
                break;
            case 12:
                _ctx.prev = 12;
                _ctx.t0 = _ctx["catch"](0);
                console.log("something went wrong");
            case 15:
            case "end":
                return _ctx.stop();
        }
    }, IeltsTestSaga_marked2, null, [
        [
            0,
            12
        ]
    ]);
}
function fetchIeltsTestBannerStatus() {
    var res, bannerStatus;
    return runtime_default().wrap(function fetchIeltsTestBannerStatus$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(ieltsTestApis.fetchIeltsTestBannerStatusApi);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 10;
                    break;
                }
                bannerStatus = res.data.data;
                _ctx.next = 8;
                return (0,io_c3792963.Y)(IeltsTestActions/* ieltsTestActions.setIeltsTestBannerStatusSuccess */.J.setIeltsTestBannerStatusSuccess(bannerStatus.showIeltsUploadBanner));
            case 8:
                _ctx.next = 11;
                break;
            case 10:
                {
                    console.log(res.message);
                }
            case 11:
                _ctx.next = 16;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.log("something went wrong");
            case 16:
            case "end":
                return _ctx.stop();
        }
    }, IeltsTestSaga_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function ieltsTestSaga() {
    return runtime_default().wrap(function ieltsTestSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("FETCH_IELTS_TEST_SUBMISSION_REQUESTED", fetchIeltsTestSubmission);
            case 2:
                _ctx.next = 4;
                return takeLatest$1("SAVE_IELTS_TEST_SUBMISSION_DETAILS", saveIeltsTestSubmissionDetails);
            case 4:
                _ctx.next = 6;
                return takeLatest$1("FETCH_REWARDS", IeltsTestSaga_fetchIeltsDateRewards);
            case 6:
                _ctx.next = 8;
                return takeLatest$1("FETCH_USER_STATUS", IeltsTestSaga_fetchIeltsDateUserStatus);
            case 8:
                _ctx.next = 10;
                return takeLatest$1("FETCH_IELTS_TEST_BANNER_STATUS", fetchIeltsTestBannerStatus);
            case 10:
            case "end":
                return _ctx.stop();
        }
    }, IeltsTestSaga_marked);
}
/* harmony default export */ var IeltsTestSaga = (ieltsTestSaga);

// EXTERNAL MODULE: ./components/Onboarding/redux/OnboardingApis.ts
var OnboardingApis = __webpack_require__(66377);
;// CONCATENATED MODULE: ./components/Onboarding/redux/OnboardingSaga.ts

var OnboardingSaga_marked = runtime_default().mark(onboardingSaga);
var OnboardingSaga_marked1 = runtime_default().mark(deleteCountryFromCountryFormData);
var OnboardingSaga_marked2 = runtime_default().mark(getPreferredCountryIdLists);
var OnboardingSaga_marked3 = runtime_default().mark(getPreferredProgramCourseLists);
var OnboardingSaga_marked4 = runtime_default().mark(getPreferredLocationLists);
var OnboardingSaga_marked5 = runtime_default().mark(fetchPreferredProgramsList);
var OnboardingSaga_marked6 = runtime_default().mark(fetchCitiesFromCountry);
var OnboardingSaga_marked7 = runtime_default().mark(submitCollegeForms);
var OnboardingSaga_marked8 = runtime_default().mark(submitExamFormData);
var OnboardingSaga_marked9 = runtime_default().mark(submitEducationDetails);
var OnboardingSaga_marked10 = runtime_default().mark(fetchInitialData);
var OnboardingSaga_marked11 = runtime_default().mark(submitFirstStep);




function submitFirstStep(action) {
    var getStep, activeStep, res;
    return runtime_default().wrap(function submitFirstStep$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                getStep = function(state) {
                    return state.onboardingReducer.activeStep;
                };
                _ctx.next = 3;
                return (0,io_c3792963.a3)(getStep);
            case 3:
                activeStep = _ctx.sent;
                _ctx.prev = 4;
                _ctx.next = 7;
                return (0,io_c3792963.N)(OnboardingApis/* onboardingApi.submitFirstStepRequest */.G.submitFirstStepRequest, action.payload);
            case 7:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 19;
                    break;
                }
                _ctx.next = 11;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.submitFirstStepSuccess */.E.submitFirstStepSuccess(res.data));
            case 11:
                _ctx.next = 13;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.setComplete */.E.setComplete(activeStep));
            case 13:
                _ctx.next = 15;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.handleStep */.E.handleStep(activeStep + 1));
            case 15:
                _ctx.next = 17;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.setCurrentProgress */.E.setCurrentProgress(10));
            case 17:
                _ctx.next = 21;
                break;
            case 19:
                _ctx.next = 21;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.submitFirstStepError */.E.submitFirstStepError(res.message));
            case 21:
                _ctx.next = 28;
                break;
            case 23:
                _ctx.prev = 23;
                _ctx.t0 = _ctx["catch"](4);
                _ctx.next = 27;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.submitFirstStepError */.E.submitFirstStepError("Something went wrong. Please try after sometime."));
            case 27:
                console.error(_ctx.t0);
            case 28:
            case "end":
                return _ctx.stop();
        }
    }, OnboardingSaga_marked11, null, [
        [
            4,
            23
        ]
    ]);
}
function fetchInitialData() {
    var getProgressArray, progressArray, res, ref, ref1, ref2, ref3, i, ref4, ref5, ref6, ref7, ref8, ref9;
    return runtime_default().wrap(function fetchInitialData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                getProgressArray = function(state) {
                    return state.onboardingReducer.percentCompletionList;
                };
                _ctx.next = 3;
                return (0,io_c3792963.a3)(getProgressArray);
            case 3:
                progressArray = _ctx.sent;
                _ctx.prev = 4;
                _ctx.next = 7;
                return (0,io_c3792963.N)(OnboardingApis/* onboardingApi.fetchInitialDataRequest */.G.fetchInitialDataRequest);
            case 7:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 33;
                    break;
                }
                ;
                _ctx.next = 12;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.fetchInitialDataSuccess */.E.fetchInitialDataSuccess(res.data.data));
            case 12:
                _ctx.next = 14;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.setCurrentProgress */.E.setCurrentProgress(Number(progressArray[res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.stepsCompleted]) || Number(5)));
            case 14:
                ;
                if (!((res === null || res === void 0 ? void 0 : (ref2 = res.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.stepsCompleted) > 0)) {
                    _ctx.next = 28;
                    break;
                }
                ;
                i = 0;
            case 18:
                if (!(i <= (res === null || res === void 0 ? void 0 : (ref4 = res.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.stepsCompleted))) {
                    _ctx.next = 24;
                    break;
                }
                _ctx.next = 21;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.setComplete */.E.setComplete(i));
            case 21:
                i++;
                _ctx.next = 18;
                break;
            case 24:
                _ctx.next = 26;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.handleStep */.E.handleStep((res === null || res === void 0 ? void 0 : (ref6 = res.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : ref7.stepsCompleted) || 0));
            case 26:
                _ctx.next = 31;
                break;
            case 28:
                ;
                _ctx.next = 31;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.handleStep */.E.handleStep((res === null || res === void 0 ? void 0 : (ref8 = res.data) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.data) === null || ref9 === void 0 ? void 0 : ref9.stepsCompleted) || 0));
            case 31:
                _ctx.next = 35;
                break;
            case 33:
                _ctx.next = 35;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.fetchInitialDataError */.E.fetchInitialDataError(res.message));
            case 35:
                _ctx.next = 42;
                break;
            case 37:
                _ctx.prev = 37;
                _ctx.t0 = _ctx["catch"](4);
                _ctx.next = 41;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.fetchInitialDataError */.E.fetchInitialDataError("Something went wrong. Please try after sometime."));
            case 41:
                console.error(_ctx.t0);
            case 42:
            case "end":
                return _ctx.stop();
        }
    }, OnboardingSaga_marked10, null, [
        [
            4,
            37
        ]
    ]);
}
function submitEducationDetails(action) {
    var getStep, activeStep, res;
    return runtime_default().wrap(function submitEducationDetails$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                getStep = function(state) {
                    return state.onboardingReducer.activeStep;
                };
                _ctx.next = 3;
                return (0,io_c3792963.a3)(getStep);
            case 3:
                activeStep = _ctx.sent;
                _ctx.prev = 4;
                _ctx.next = 7;
                return (0,io_c3792963.N)(OnboardingApis/* onboardingApi.submitEducationDetailsRequest */.G.submitEducationDetailsRequest, action.payload);
            case 7:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 19;
                    break;
                }
                _ctx.next = 11;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.submitEducationDetailsSuccess */.E.submitEducationDetailsSuccess(res.data));
            case 11:
                _ctx.next = 13;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.handleStep */.E.handleStep(activeStep + 1));
            case 13:
                _ctx.next = 15;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.setComplete */.E.setComplete(activeStep));
            case 15:
                _ctx.next = 17;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.setCurrentProgress */.E.setCurrentProgress(80));
            case 17:
                _ctx.next = 21;
                break;
            case 19:
                _ctx.next = 21;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.submitEducationDetailsError */.E.submitEducationDetailsError(res.message));
            case 21:
                _ctx.next = 28;
                break;
            case 23:
                _ctx.prev = 23;
                _ctx.t0 = _ctx["catch"](4);
                _ctx.next = 27;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.submitEducationDetailsError */.E.submitEducationDetailsError("Something went wrong. Please try after sometime."));
            case 27:
                console.error(_ctx.t0);
            case 28:
            case "end":
                return _ctx.stop();
        }
    }, OnboardingSaga_marked9, null, [
        [
            4,
            23
        ]
    ]);
}
function submitExamFormData(action) {
    var getStep, activeStep, res, getAddedCountries, addedCountries, getIeltsNotInitiatedStatus, isIeltsNotInitiated, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    return runtime_default().wrap(function submitExamFormData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                getStep = function(state) {
                    return state.onboardingReducer.activeStep;
                };
                _ctx.next = 3;
                return (0,io_c3792963.a3)(getStep);
            case 3:
                activeStep = _ctx.sent;
                _ctx.prev = 4;
                _ctx.next = 7;
                return (0,io_c3792963.N)(OnboardingApis/* onboardingApi.submitExamFormRequest */.G.submitExamFormRequest, action.payload);
            case 7:
                res = _ctx.sent;
                getAddedCountries = function(state) {
                    return state.onboardingReducer.addedCountries;
                };
                _ctx.next = 11;
                return (0,io_c3792963.a3)(getAddedCountries);
            case 11:
                addedCountries = _ctx.sent;
                getIeltsNotInitiatedStatus = function(state) {
                    return state.onboardingReducer.isIeltsNotInitiated;
                };
                _ctx.next = 15;
                return (0,io_c3792963.a3)(getIeltsNotInitiatedStatus);
            case 15:
                isIeltsNotInitiated = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 44;
                    break;
                }
                ;
                _ctx.next = 20;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.submitExamFormDataSuccess */.E.submitExamFormDataSuccess(res.data));
            case 20:
                _ctx.next = 22;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.setCurrentProgress */.E.setCurrentProgress(100));
            case 22:
                if (!((addedCountries === null || addedCountries === void 0 ? void 0 : addedCountries.length) === 1 && (addedCountries === null || addedCountries === void 0 ? void 0 : addedCountries.includes("UK")) || ((ref = action.payload) === null || ref === void 0 ? void 0 : (ref1 = ref.examDetails) === null || ref1 === void 0 ? void 0 : ref1.examType) === "IELTS" && ((ref2 = action.payload) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.examDetails) === null || ref3 === void 0 ? void 0 : ref3.examStatus) !== "NOT_DECIDED" && ((ref4 = action.payload) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.examDetails) === null || ref5 === void 0 ? void 0 : ref5.examStatus) !== "PLANING_TO_BOOK")) {
                    _ctx.next = 31;
                    break;
                }
                _ctx.next = 25;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.handleStep */.E.handleStep(activeStep + 1));
            case 25:
                _ctx.next = 27;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.setComplete */.E.setComplete(activeStep));
            case 27:
                _ctx.next = 29;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.toggleSuccessModal */.E.toggleSuccessModal(true));
            case 29:
                _ctx.next = 42;
                break;
            case 31:
                if (!(((ref6 = action.payload) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.examDetails) === null || ref7 === void 0 ? void 0 : ref7.examType) === "IELTS" && isIeltsNotInitiated)) {
                    _ctx.next = 36;
                    break;
                }
                _ctx.next = 34;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.setIeltsRequired */.E.setIeltsRequired(true));
            case 34:
                _ctx.next = 42;
                break;
            case 36:
                _ctx.next = 38;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.handleStep */.E.handleStep(activeStep + 1));
            case 38:
                _ctx.next = 40;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.setComplete */.E.setComplete(activeStep));
            case 40:
                _ctx.next = 42;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.toggleSuccessModal */.E.toggleSuccessModal(true));
            case 42:
                _ctx.next = 46;
                break;
            case 44:
                _ctx.next = 46;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.submitExamFormDataError */.E.submitExamFormDataError(res.message));
            case 46:
                _ctx.next = 53;
                break;
            case 48:
                _ctx.prev = 48;
                _ctx.t0 = _ctx["catch"](4);
                _ctx.next = 52;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.submitEducationDetailsError */.E.submitEducationDetailsError("Something went wrong. Please try after sometime."));
            case 52:
                console.error(_ctx.t0);
            case 53:
            case "end":
                return _ctx.stop();
        }
    }, OnboardingSaga_marked8, null, [
        [
            4,
            48
        ]
    ]);
}
function submitCollegeForms() {
    var getStep, activeStep, getCountryFormData, countryFormData, res;
    return runtime_default().wrap(function submitCollegeForms$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                getStep = function(state) {
                    return state.onboardingReducer.activeStep;
                };
                _ctx.next = 3;
                return (0,io_c3792963.a3)(getStep);
            case 3:
                activeStep = _ctx.sent;
                getCountryFormData = function(state) {
                    return state.onboardingReducer.countryFormData;
                };
                _ctx.next = 7;
                return (0,io_c3792963.a3)(getCountryFormData);
            case 7:
                countryFormData = _ctx.sent;
                _ctx.prev = 8;
                _ctx.next = 11;
                return (0,io_c3792963.N)(OnboardingApis/* onboardingApi.submitCollegeFormsRequest */.G.submitCollegeFormsRequest, countryFormData);
            case 11:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 23;
                    break;
                }
                _ctx.next = 15;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.submitCollegeFormsSuccess */.E.submitCollegeFormsSuccess(res.data));
            case 15:
                _ctx.next = 17;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.handleStep */.E.handleStep(activeStep + 1));
            case 17:
                _ctx.next = 19;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.setComplete */.E.setComplete(activeStep));
            case 19:
                _ctx.next = 21;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.setCurrentProgress */.E.setCurrentProgress(50));
            case 21:
                _ctx.next = 25;
                break;
            case 23:
                _ctx.next = 25;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.submitCollegeFormsError */.E.submitCollegeFormsError(res.message));
            case 25:
                _ctx.next = 32;
                break;
            case 27:
                _ctx.prev = 27;
                _ctx.t0 = _ctx["catch"](8);
                _ctx.next = 31;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.submitCollegeFormsError */.E.submitCollegeFormsError("Something went wrong. Please try after sometime."));
            case 31:
                console.error(_ctx.t0);
            case 32:
            case "end":
                return _ctx.stop();
        }
    }, OnboardingSaga_marked7, null, [
        [
            8,
            27
        ]
    ]);
}
function fetchCitiesFromCountry(action) {
    var res, cities;
    return runtime_default().wrap(function fetchCitiesFromCountry$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(OnboardingApis/* onboardingApi.fetchCityListFromCountry */.G.fetchCityListFromCountry, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 10;
                    break;
                }
                cities = (0,utils_common_utils/* createOptionsObject */.mK)(res.data.data);
                _ctx.next = 8;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.fetchCityFromCountrySuccess */.E.fetchCityFromCountrySuccess(cities));
            case 8:
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.fetchCityFromCountryError */.E.fetchCityFromCountryError(res.data.message));
            case 12:
                _ctx.next = 18;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.fetchCityFromCountryError */.E.fetchCityFromCountryError(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, OnboardingSaga_marked6, null, [
        [
            0,
            14
        ]
    ]);
}
function fetchPreferredProgramsList() {
    var res;
    return runtime_default().wrap(function fetchPreferredProgramsList$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(OnboardingApis/* onboardingApi.fetchPreferredPrograms */.G.fetchPreferredPrograms);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.fetchPreferredProgramsSuccess */.E.fetchPreferredProgramsSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.fetchPreferredProgramsError */.E.fetchPreferredProgramsError(res.data.message));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.fetchPreferredProgramsError */.E.fetchPreferredProgramsError(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, OnboardingSaga_marked5, null, [
        [
            0,
            13
        ]
    ]);
}
function getPreferredLocationLists(action) {
    var ref, res;
    return runtime_default().wrap(function getPreferredLocationLists$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                ;
                _ctx.next = 4;
                return (0,io_c3792963.N)(OnboardingApis/* onboardingApi.getPreferredLocationLists */.G.getPreferredLocationLists, action.payload);
            case 4:
                res = _ctx.sent;
                if (!(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                    _ctx.next = 10;
                    break;
                }
                _ctx.next = 8;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.getPreferredLocationListsSuccess */.E.getPreferredLocationListsSuccess(res));
            case 8:
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.getPreferredLocationListsError */.E.getPreferredLocationListsError(res.data.message));
            case 12:
                _ctx.next = 18;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.getPreferredLocationListsError */.E.getPreferredLocationListsError(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, OnboardingSaga_marked4, null, [
        [
            0,
            14
        ]
    ]);
}
function getPreferredProgramCourseLists(action) {
    var ref, res;
    return runtime_default().wrap(function getPreferredProgramCourseLists$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                ;
                _ctx.next = 4;
                return (0,io_c3792963.N)(OnboardingApis/* onboardingApi.getPreferredProgramCourseLists */.G.getPreferredProgramCourseLists, action.payload);
            case 4:
                res = _ctx.sent;
                if (!(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                    _ctx.next = 10;
                    break;
                }
                _ctx.next = 8;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.getPreferredProgramCourseListsSuccess */.E.getPreferredProgramCourseListsSuccess(res));
            case 8:
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.getPreferredProgramCourseListsError */.E.getPreferredProgramCourseListsError(res.data.message));
            case 12:
                _ctx.next = 18;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.getPreferredProgramCourseListsError */.E.getPreferredProgramCourseListsError(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, OnboardingSaga_marked3, null, [
        [
            0,
            14
        ]
    ]);
}
function getPreferredCountryIdLists(action) {
    var ref, res;
    return runtime_default().wrap(function getPreferredCountryIdLists$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                ;
                _ctx.next = 4;
                return (0,io_c3792963.N)(OnboardingApis/* onboardingApi.getPreferredCountryIdLists */.G.getPreferredCountryIdLists);
            case 4:
                res = _ctx.sent;
                if (!(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                    _ctx.next = 10;
                    break;
                }
                _ctx.next = 8;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.getPreferredCountryIdListsSuccess */.E.getPreferredCountryIdListsSuccess([
                    res,
                    action.payload, 
                ]));
            case 8:
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.getPreferredCountryIdListsError */.E.getPreferredCountryIdListsError(res.data.message));
            case 12:
                _ctx.next = 18;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.getPreferredCountryIdListsError */.E.getPreferredCountryIdListsError(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, OnboardingSaga_marked2, null, [
        [
            0,
            14
        ]
    ]);
}
function deleteCountryFromCountryFormData(action) {
    var res;
    return runtime_default().wrap(function deleteCountryFromCountryFormData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(OnboardingApis/* onboardingApi.deleteCountryFromFormData */.G.deleteCountryFromFormData, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.deleteCountryFromFormDataSuccess */.E.deleteCountryFromFormDataSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.deleteCountryFromFormDataError */.E.deleteCountryFromFormDataError(res.data.message));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(OnboardingActions/* onboardingActions.deleteCountryFromFormDataError */.E.deleteCountryFromFormDataError(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, OnboardingSaga_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function onboardingSaga() {
    return runtime_default().wrap(function onboardingSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("SUBMIT_FIRST_STEP", submitFirstStep);
            case 2:
                _ctx.next = 4;
                return takeLatest$1("FETCH_INITIAL_DATA", fetchInitialData);
            case 4:
                _ctx.next = 6;
                return takeLatest$1("SUBMIT_EDUCATION_DETAILS", submitEducationDetails);
            case 6:
                _ctx.next = 8;
                return takeLatest$1("SUBMIT_EXAM_FORM_DATA", submitExamFormData);
            case 8:
                _ctx.next = 10;
                return takeLatest$1("SUBMIT_COLLEGE_FORMS", submitCollegeForms);
            case 10:
                _ctx.next = 12;
                return takeLatest$1("FETCH_CITY_FROM_COUNTRY", fetchCitiesFromCountry);
            case 12:
                _ctx.next = 14;
                return takeLatest$1("DELETE_COUNTRY_FROM_FORM_DATA", deleteCountryFromCountryFormData);
            case 14:
                _ctx.next = 16;
                return takeLatest$1("FETCH_PREFERRED_PROGRAMS", fetchPreferredProgramsList);
            case 16:
                _ctx.next = 18;
                return takeLatest$1("GET_PREFERRED_LOCATION_LISTS", getPreferredLocationLists);
            case 18:
                _ctx.next = 20;
                return takeLatest$1("GET_PREFERRED_COUNTRY_ID_LISTS", getPreferredCountryIdLists);
            case 20:
                _ctx.next = 22;
                return takeLatest$1("GET_PREFERRED_PROGRAM_COURSE_LISTS", getPreferredProgramCourseLists);
            case 22:
            case "end":
                return _ctx.stop();
        }
    }, OnboardingSaga_marked);
}
/* harmony default export */ var OnboardingSaga = (onboardingSaga);

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/Certificates/redux/CertificateApi.ts



var fetchCertificateData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=v2/workshop/enroll/certificate/".concat(payload));
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        success: true,
                        data: res.data.data
                    });
                case 8:
                    return _ctx.abrupt("return", {
                        success: false,
                        data: res.data.message
                    });
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        success: false,
                        data: "Something went wrong"
                    });
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchCertificateData(payload) {
        return _ref.apply(this, arguments);
    };
}();
var certificateApi = {
    fetchCertificateData: fetchCertificateData
};

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/Certificates/redux/CertificateSaga.ts

var CertificateSaga_marked = runtime_default().mark(certificateSaga);
var CertificateSaga_marked1 = runtime_default().mark(fetchCertificateSaga);



function fetchCertificateSaga(action) {
    var res;
    return runtime_default().wrap(function fetchCertificateSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(certificateApi.fetchCertificateData, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(CertificateAction/* certificateAction.fetchCertificateSuccess */.K.fetchCertificateSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(CertificateAction/* certificateAction.fetchCertificateFail */.K.fetchCertificateFail(res.data));
            case 11:
                _ctx.next = 19;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(CertificateAction/* certificateAction.fetchCertificateFail */.K.fetchCertificateFail(_ctx.t0.message));
            case 18:
                throw new Error(_ctx.t0.message);
            case 19:
            case "end":
                return _ctx.stop();
        }
    }, CertificateSaga_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function certificateSaga() {
    return runtime_default().wrap(function certificateSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(CertificateAction/* certificateActionType.FETCH_CERTIFICATE_REQ */.y.FETCH_CERTIFICATE_REQ, fetchCertificateSaga);
            case 2:
            case "end":
                return _ctx.stop();
        }
    }, CertificateSaga_marked);
}
/* harmony default export */ var CertificateSaga = (certificateSaga);

// EXTERNAL MODULE: ./node_modules/file-saver/dist/FileSaver.min.js
var FileSaver_min = __webpack_require__(93162);
;// CONCATENATED MODULE: ./components/DocumentsUpload/redux/DocumentUploadApis.ts
// import api, { ApiRequestConfig } from "service/api"




var fetchDocumentDataRequest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=student/counseling/document/categories");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    return _ctx.abrupt("return", false);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchDocumentDataRequest() {
        return _ref.apply(this, arguments);
    };
}();
var uploadDocumentRequest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
        var file, d, idStatus, formData, url, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    file = data.file, d = data.d;
                    idStatus = d.hasOwnProperty("id");
                    if (idStatus == false) {
                        d.id = 0;
                    }
                    _ctx.prev = 3;
                    _ctx.prev = 4;
                    formData = new FormData();
                    formData.append("file", file);
                    url = "";
                    if (d.key === "WORK_EX") {
                        url = "/api/upload?path=student/doc/WORK_EX/".concat(d.id, "/").concat(d.workExId);
                    } else if (d.key === "COUNSELING_OTHER") {
                        url = "/api/upload?path=student/doc/COUNSELING_OTHER/".concat(d.id, "/").concat(d.fileLabel);
                    } else {
                        url = "/api/upload?path=student/doc/".concat(d.key, "/").concat(d.id, "/document");
                    }
                    _ctx.next = 11;
                    return api/* default.post */.Z.post(url, formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    });
                case 11:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data.data);
                case 15:
                    _ctx.prev = 15;
                    _ctx.t0 = _ctx["catch"](4);
                    console.log(_ctx.t0);
                case 18:
                    _ctx.next = 23;
                    break;
                case 20:
                    _ctx.prev = 20;
                    _ctx.t1 = _ctx["catch"](3);
                    console.log(_ctx.t1);
                case 23:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                3,
                20
            ],
            [
                4,
                15
            ]
        ]);
    }));
    return function uploadDocumentRequest(data) {
        return _ref.apply(this, arguments);
    };
}();
var deleteDocumentRequest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
        var d, key, id, url, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    d = data.d;
                    key = d.key, id = d.id;
                    ;
                    if (key == "WORK_EX") {
                        url = "/api/scholarRoute?path=student/deleteWorkExDocument/".concat(id, "/").concat((d === null || d === void 0 ? void 0 : d.workExId) || 0);
                    } else {
                        url = "/api/scholarRoute?path=student/deleteDocument/".concat(key, "/").concat(id);
                    }
                    _ctx.prev = 4;
                    _ctx.next = 7;
                    return api/* default.delete */.Z["delete"](url);
                case 7:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 12;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.success);
                case 12:
                    return _ctx.abrupt("return", false);
                case 13:
                    _ctx.next = 18;
                    break;
                case 15:
                    _ctx.prev = 15;
                    _ctx.t0 = _ctx["catch"](4);
                    console.log(_ctx.t0);
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                4,
                15
            ]
        ]);
    }));
    return function deleteDocumentRequest(data) {
        return _ref.apply(this, arguments);
    };
}();
var downloadDocumentRequest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(docId) {
        var downloadUrl, config, res, fileName;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    downloadUrl = "artifact/student/download/".concat(docId);
                    _ctx.prev = 1;
                    config = {
                        method: "GET",
                        url: "/api/download?path=".concat(downloadUrl),
                        responseType: "blob"
                    };
                    _ctx.next = 5;
                    return (0,api/* default */.Z)(config);
                case 5:
                    res = _ctx.sent;
                    if (res && res.data && res.data.size > 0) {
                        fileName = res.headers["content-disposition"].split("filename=")[1];
                        (0,FileSaver_min.saveAs)(res.data, fileName);
                    }
                    _ctx.next = 12;
                    break;
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](1);
                    throw new Error("Something went wrong. Please contact the tech team");
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                9
            ]
        ]);
    }));
    return function downloadDocumentRequest(docId) {
        return _ref.apply(this, arguments);
    };
}();
var viewDocumentRequest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(docId) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=student/viewdoc/".concat(docId));
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    return _ctx.abrupt("return", false);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function viewDocumentRequest(docId) {
        return _ref.apply(this, arguments);
    };
}();
var addHighestEducationRequest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=student/highestEducation", data);
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    return _ctx.abrupt("return", false);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function addHighestEducationRequest(data) {
        return _ref.apply(this, arguments);
    };
}();
var editTitleRequest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(datas) {
        var data, fileLabelId, modalType, workId, url, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    data = datas.data, fileLabelId = datas.fileLabelId, modalType = datas.modalType, workId = datas.workId;
                    ;
                    if (modalType == "COUNSELING_OTHER") {
                        url = "/api/scholarRoute?path=student/addFileLabel/".concat(fileLabelId || 0);
                    } else if (modalType == "WORK_EX") {
                        url = "/api/scholarRoute?path=student/workExperience/".concat(workId);
                    }
                    _ctx.prev = 3;
                    _ctx.next = 6;
                    return api/* default.post */.Z.post(url, data);
                case 6:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 11;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 11:
                    return _ctx.abrupt("return", false);
                case 12:
                    _ctx.next = 17;
                    break;
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](3);
                    console.log(_ctx.t0);
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                3,
                14
            ]
        ]);
    }));
    return function editTitleRequest(datas) {
        return _ref.apply(this, arguments);
    };
}();
var addWorkExRequest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=student/workExperience/0", data);
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    return _ctx.abrupt("return", false);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function addWorkExRequest(data) {
        return _ref.apply(this, arguments);
    };
}();
var addMiscDocumentRequest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=student/workExperience", data);
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    return _ctx.abrupt("return", false);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function addMiscDocumentRequest(data) {
        return _ref.apply(this, arguments);
    };
}();
var selectEnglishExamRequest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(examType) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=student/englishExam/".concat(examType));
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    return _ctx.abrupt("return", false);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function selectEnglishExamRequest(examType) {
        return _ref.apply(this, arguments);
    };
}();
var documentUploadApi = {
    fetchDocumentDataRequest: fetchDocumentDataRequest,
    uploadDocumentRequest: uploadDocumentRequest,
    deleteDocumentRequest: deleteDocumentRequest,
    downloadDocumentRequest: downloadDocumentRequest,
    viewDocumentRequest: viewDocumentRequest,
    addHighestEducationRequest: addHighestEducationRequest,
    addWorkExRequest: addWorkExRequest,
    addMiscDocumentRequest: addMiscDocumentRequest,
    selectEnglishExamRequest: selectEnglishExamRequest,
    editTitleRequest: editTitleRequest
};

;// CONCATENATED MODULE: ./components/DocumentsUpload/redux/DocumentUploadSaga.ts

var DocumentUploadSaga_marked = runtime_default().mark(documentsUploadSaga);
var DocumentUploadSaga_marked1 = runtime_default().mark(selectEnglishExamType);
var DocumentUploadSaga_marked2 = runtime_default().mark(addMiscDocument);
var DocumentUploadSaga_marked3 = runtime_default().mark(editTitle);
var DocumentUploadSaga_marked4 = runtime_default().mark(addWorkEx);
var DocumentUploadSaga_marked5 = runtime_default().mark(highestEducation);
var DocumentUploadSaga_marked6 = runtime_default().mark(viewDocument);
var DocumentUploadSaga_marked7 = runtime_default().mark(downloaDocument);
var DocumentUploadSaga_marked8 = runtime_default().mark(deleteDocument);
var DocumentUploadSaga_marked9 = runtime_default().mark(uploadDocument);
var DocumentUploadSaga_marked10 = runtime_default().mark(fetchDocumentData);



function fetchDocumentData() {
    var res;
    return runtime_default().wrap(function fetchDocumentData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(documentUploadApi.fetchDocumentDataRequest);
            case 3:
                res = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)(DocumentUploadActions/* documentUploadActions.fetchDocumentDataSuccess */.g.fetchDocumentDataSuccess(res));
            case 6:
                _ctx.next = 13;
                break;
            case 8:
                _ctx.prev = 8;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 13;
                return (0,io_c3792963.Y)(DocumentUploadActions/* documentUploadActions.fetchDocumentDataError */.g.fetchDocumentDataError(_ctx.t0.message));
            case 13:
            case "end":
                return _ctx.stop();
        }
    }, DocumentUploadSaga_marked10, null, [
        [
            0,
            8
        ]
    ]);
}
function uploadDocument(action) {
    var res;
    return runtime_default().wrap(function uploadDocument$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(documentUploadApi.uploadDocumentRequest, action.payload);
            case 3:
                res = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)(DocumentUploadActions/* documentUploadActions.uploadDocumentSuccess */.g.uploadDocumentSuccess(res));
            case 6:
                _ctx.next = 8;
                return (0,io_c3792963.Y)(DocumentUploadActions/* documentUploadActions.fetchDocumentData */.g.fetchDocumentData());
            case 8:
                _ctx.next = 15;
                break;
            case 10:
                _ctx.prev = 10;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 15;
                return (0,io_c3792963.Y)(DocumentUploadActions/* documentUploadActions.uploadDocumentError */.g.uploadDocumentError(_ctx.t0.message));
            case 15:
            case "end":
                return _ctx.stop();
        }
    }, DocumentUploadSaga_marked9, null, [
        [
            0,
            10
        ]
    ]);
}
function deleteDocument(action) {
    var res;
    return runtime_default().wrap(function deleteDocument$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(documentUploadApi.deleteDocumentRequest, action.payload);
            case 3:
                res = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)(DocumentUploadActions/* documentUploadActions.deleteDocumentSuccess */.g.deleteDocumentSuccess(res));
            case 6:
                _ctx.next = 8;
                return (0,io_c3792963.Y)(DocumentUploadActions/* documentUploadActions.fetchDocumentData */.g.fetchDocumentData());
            case 8:
                _ctx.next = 15;
                break;
            case 10:
                _ctx.prev = 10;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 15;
                return (0,io_c3792963.Y)(DocumentUploadActions/* documentUploadActions.deleteDocumentError */.g.deleteDocumentError(_ctx.t0.message));
            case 15:
            case "end":
                return _ctx.stop();
        }
    }, DocumentUploadSaga_marked8, null, [
        [
            0,
            10
        ]
    ]);
}
function downloaDocument(action) {
    var res;
    return runtime_default().wrap(function downloaDocument$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(documentUploadApi.downloadDocumentRequest, action.payload);
            case 3:
                res = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)(DocumentUploadActions/* documentUploadActions.downloadDocumentSuccess */.g.downloadDocumentSuccess(res));
            case 6:
                _ctx.next = 13;
                break;
            case 8:
                _ctx.prev = 8;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 13;
                return (0,io_c3792963.Y)(DocumentUploadActions/* documentUploadActions.downloadDocumentError */.g.downloadDocumentError(_ctx.t0.message));
            case 13:
            case "end":
                return _ctx.stop();
        }
    }, DocumentUploadSaga_marked7, null, [
        [
            0,
            8
        ]
    ]);
}
function viewDocument(action) {
    var res;
    return runtime_default().wrap(function viewDocument$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(documentUploadApi.viewDocumentRequest, action.payload);
            case 3:
                res = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)(DocumentUploadActions/* documentUploadActions.viewDocumentSuccess */.g.viewDocumentSuccess(res));
            case 6:
                _ctx.next = 13;
                break;
            case 8:
                _ctx.prev = 8;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 13;
                return (0,io_c3792963.Y)(DocumentUploadActions/* documentUploadActions.viewDocumentError */.g.viewDocumentError(_ctx.t0.message));
            case 13:
            case "end":
                return _ctx.stop();
        }
    }, DocumentUploadSaga_marked6, null, [
        [
            0,
            8
        ]
    ]);
}
function highestEducation(action) {
    var res;
    return runtime_default().wrap(function highestEducation$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(documentUploadApi.addHighestEducationRequest, action.payload);
            case 3:
                res = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)(DocumentUploadActions/* documentUploadActions.addHighestEducationSuccess */.g.addHighestEducationSuccess(res));
            case 6:
                _ctx.next = 8;
                return (0,io_c3792963.Y)(DocumentUploadActions/* documentUploadActions.fetchDocumentData */.g.fetchDocumentData());
            case 8:
                _ctx.next = 15;
                break;
            case 10:
                _ctx.prev = 10;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 15;
                return (0,io_c3792963.Y)(DocumentUploadActions/* documentUploadActions.addHighestEducationError */.g.addHighestEducationError(_ctx.t0.message));
            case 15:
            case "end":
                return _ctx.stop();
        }
    }, DocumentUploadSaga_marked5, null, [
        [
            0,
            10
        ]
    ]);
}
function addWorkEx(action) {
    var res;
    return runtime_default().wrap(function addWorkEx$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(documentUploadApi.addWorkExRequest, action.payload);
            case 3:
                res = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)(DocumentUploadActions/* documentUploadActions.addWorkExSuccess */.g.addWorkExSuccess(res));
            case 6:
                _ctx.next = 8;
                return (0,io_c3792963.Y)(DocumentUploadActions/* documentUploadActions.fetchDocumentData */.g.fetchDocumentData());
            case 8:
                _ctx.next = 15;
                break;
            case 10:
                _ctx.prev = 10;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 15;
                return (0,io_c3792963.Y)(DocumentUploadActions/* documentUploadActions.addWorkExError */.g.addWorkExError(_ctx.t0.message));
            case 15:
            case "end":
                return _ctx.stop();
        }
    }, DocumentUploadSaga_marked4, null, [
        [
            0,
            10
        ]
    ]);
}
function editTitle(action) {
    var res;
    return runtime_default().wrap(function editTitle$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(documentUploadApi.editTitleRequest, action.payload);
            case 3:
                res = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)(DocumentUploadActions/* documentUploadActions.editTitleSuccess */.g.editTitleSuccess(res));
            case 6:
                _ctx.next = 8;
                return (0,io_c3792963.Y)(DocumentUploadActions/* documentUploadActions.fetchDocumentData */.g.fetchDocumentData());
            case 8:
                _ctx.next = 15;
                break;
            case 10:
                _ctx.prev = 10;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 15;
                return (0,io_c3792963.Y)(DocumentUploadActions/* documentUploadActions.editTitleError */.g.editTitleError(_ctx.t0.message));
            case 15:
            case "end":
                return _ctx.stop();
        }
    }, DocumentUploadSaga_marked3, null, [
        [
            0,
            10
        ]
    ]);
}
function addMiscDocument() {
    var getStep;
    return runtime_default().wrap(function addMiscDocument$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                getStep = function(state) {
                    return state.documentUpload.initialData;
                };
                _ctx.next = 3;
                return (0,io_c3792963.a3)(getStep);
            case 3:
            case "end":
                return _ctx.stop();
        }
    }, DocumentUploadSaga_marked2);
// try {
//   const res = yield call(
//     documentUploadApi.addFileLabelRequest,
//     action.payload
//   );
//   yield put(documentUploadActions.addFileLabelSuccess(res));
//   yield put(documentUploadActions.fetchDocumentData());
// } catch (e:any) {
//   console.error(e);
//   yield put(documentUploadActions.addFileLabelError(e.message));
// }
}
function selectEnglishExamType(action) {
    var res;
    return runtime_default().wrap(function selectEnglishExamType$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(documentUploadApi.selectEnglishExamRequest, action.payload);
            case 3:
                res = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)(DocumentUploadActions/* documentUploadActions.selectEnglishExamTypeSuccess */.g.selectEnglishExamTypeSuccess(res));
            case 6:
                _ctx.next = 13;
                break;
            case 8:
                _ctx.prev = 8;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 13;
                return (0,io_c3792963.Y)(DocumentUploadActions/* documentUploadActions.selectEnglishExamTypeError */.g.selectEnglishExamTypeError(_ctx.t0.message));
            case 13:
            case "end":
                return _ctx.stop();
        }
    }, DocumentUploadSaga_marked1, null, [
        [
            0,
            8
        ]
    ]);
}
function documentsUploadSaga() {
    return runtime_default().wrap(function documentsUploadSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(DocumentUploadActions/* documentUploadActionConstants.FETCH_DOCUMENT_DATA */.N.FETCH_DOCUMENT_DATA, fetchDocumentData);
            case 2:
                _ctx.next = 4;
                return takeLatest$1(DocumentUploadActions/* documentUploadActionConstants.UPLOAD_DOCUMENT */.N.UPLOAD_DOCUMENT, uploadDocument);
            case 4:
                _ctx.next = 6;
                return takeLatest$1(DocumentUploadActions/* documentUploadActionConstants.DELETE_DOCUMENT */.N.DELETE_DOCUMENT, deleteDocument);
            case 6:
                _ctx.next = 8;
                return takeLatest$1(DocumentUploadActions/* documentUploadActionConstants.DOWNLOAD_DOCUMENT */.N.DOWNLOAD_DOCUMENT, downloaDocument);
            case 8:
                _ctx.next = 10;
                return takeLatest$1(DocumentUploadActions/* documentUploadActionConstants.VIEW_DOCUMENT */.N.VIEW_DOCUMENT, viewDocument);
            case 10:
                _ctx.next = 12;
                return takeLatest$1(DocumentUploadActions/* documentUploadActionConstants.ADD_HIGHEST_EDUCATION */.N.ADD_HIGHEST_EDUCATION, highestEducation);
            case 12:
                _ctx.next = 14;
                return takeLatest$1(DocumentUploadActions/* documentUploadActionConstants.ADD_WORK_EX */.N.ADD_WORK_EX, addWorkEx);
            case 14:
                _ctx.next = 16;
                return takeLatest$1(DocumentUploadActions/* documentUploadActionConstants.EDIT_TITLE */.N.EDIT_TITLE, editTitle);
            case 16:
                _ctx.next = 18;
                return takeLatest$1(DocumentUploadActions/* documentUploadActionConstants.ADD_MISC_DOCUMENT */.N.ADD_MISC_DOCUMENT, addMiscDocument);
            case 18:
                _ctx.next = 20;
                return takeLatest$1(DocumentUploadActions/* documentUploadActionConstants.SELECT_ENGLISH_EXAM_TYPE */.N.SELECT_ENGLISH_EXAM_TYPE, selectEnglishExamType);
            case 20:
            case "end":
                return _ctx.stop();
        }
    }, DocumentUploadSaga_marked);
}
/* harmony default export */ var DocumentUploadSaga = (documentsUploadSaga);

// EXTERNAL MODULE: ./components/Ielts/Reviews/redux/ReviewsActions.ts
var ReviewsActions = __webpack_require__(46809);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 15 modules
var lib = __webpack_require__(4969);
;// CONCATENATED MODULE: ./apollo/queries/reviews.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  query {\n    reviews(where: { platform: "IELTS" }) {\n      id\n      Name\n      platform\n      review\n      score\n      youtube\n      thumbnail {\n        url\n      }\n      user_image {\n        url\n      }\n      social_platform {\n        link\n        platform\n      }\n      type\n    }\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var FETCH_IELTS_REVIEWS = (0,lib/* default */.ZP)(_templateObject());
/* harmony default export */ var reviews = (FETCH_IELTS_REVIEWS);

// EXTERNAL MODULE: ./apollo/apollo.ts + 13 modules
var apollo = __webpack_require__(22308);
;// CONCATENATED MODULE: ./components/Ielts/Reviews/redux/ReviewsApis.ts




var fetchReviews = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return apollo/* apoloClient.query */.Bq.query({
                        query: reviews,
                        variables: []
                    });
                case 3:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchReviews() {
        return _ref.apply(this, arguments);
    };
}();
var reviewApis = {
    fetchReviews: fetchReviews
};

;// CONCATENATED MODULE: ./components/Ielts/Reviews/redux/ReviewsSaga.ts

var ReviewsSaga_marked = runtime_default().mark(reviewsSaga);
var ReviewsSaga_marked1 = runtime_default().mark(ReviewsSaga_fetchReviews);



function ReviewsSaga_fetchReviews() {
    var ref, ref1, res, reviewsObj;
    return runtime_default().wrap(function fetchReviews$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                ;
                _ctx.next = 4;
                return (0,io_c3792963.N)(reviewApis.fetchReviews);
            case 4:
                res = _ctx.sent;
                reviewsObj = (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.reviews) === null || ref1 === void 0 ? void 0 : ref1.reduce(function(a, c) {
                    if (a[c.type] && a[c.type].length > 0) {
                        a[c.type].push(c);
                    } else {
                        a[c.type] = [];
                        a[c.type].push(c);
                    }
                    return a;
                }, {});
                _ctx.next = 8;
                return (0,io_c3792963.Y)(ReviewsActions/* reviewActions.fetchReviewsSuccess */.Z.fetchReviewsSuccess(reviewsObj));
            case 8:
                _ctx.next = 15;
                break;
            case 10:
                _ctx.prev = 10;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 14;
                return (0,io_c3792963.Y)(ReviewsActions/* reviewActions.updateError */.Z.updateError("Something went wrong. Please try after sometime"));
            case 14:
                console.log(_ctx.t0);
            case 15:
            case "end":
                return _ctx.stop();
        }
    }, ReviewsSaga_marked1, null, [
        [
            0,
            10
        ]
    ]);
}
function reviewsSaga() {
    return runtime_default().wrap(function reviewsSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("FETCH_IELTS_REVIEWS", ReviewsSaga_fetchReviews);
            case 2:
            case "end":
                return _ctx.stop();
        }
    }, ReviewsSaga_marked);
}
/* harmony default export */ var ReviewsSaga = (reviewsSaga);

// EXTERNAL MODULE: ./components/MeetCounsellerVirtualOffice/redux/MeetCounsellerActions.ts
var MeetCounsellerActions = __webpack_require__(48310);
;// CONCATENATED MODULE: ./components/MeetCounsellerVirtualOffice/redux/MeetCounsellerApi.ts



var getExpertData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=v2/workshop/MASTER_CLASS/0/12");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function getExpertData() {
        return _ref.apply(this, arguments);
    };
}();
var MeetCounsellerApi_saveData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
        var ref, res, ref1;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    ;
                    _ctx.prev = 2;
                    _ctx.next = 5;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=lead/country-form-spot", values);
                case 5:
                    res = _ctx.sent;
                    _ctx.next = 11;
                    break;
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](2);
                    throw new Error("Something went wrong. Please try after sometime");
                case 11:
                    if (!(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                        _ctx.next = 15;
                        break;
                    }
                    return _ctx.abrupt("return", true);
                case 15:
                    ;
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.message);
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                8
            ]
        ]);
    }));
    return function saveData(values) {
        return _ref.apply(this, arguments);
    };
}();
var fetchMeetCounsellerSlot = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res, ref;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=scholar-calendar/slots/live/".concat(4));
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    ;
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.message);
                case 10:
                    _ctx.next = 16;
                    break;
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }));
    return function fetchMeetCounsellerSlot() {
        return _ref.apply(this, arguments);
    };
}();
var fetchTypedMeetCounsellerSlot = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
        var res, ref;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=scholar-calendar/slots/live/".concat(4, "/").concat(payload === null || payload === void 0 ? void 0 : payload.leadId, "/").concat(payload === null || payload === void 0 ? void 0 : payload.meetType));
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    ;
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.message);
                case 10:
                    _ctx.next = 15;
                    break;
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }));
    return function fetchTypedMeetCounsellerSlot(payload) {
        return _ref.apply(this, arguments);
    };
}();
var confirmMeetCounsellerSlot = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
        var data, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    data = {
                        minute: payload.minute || "",
                        date: payload.date || "",
                        duration: payload.duration,
                        utmTerm: payload.utmTerm || "",
                        utmCampaign: payload.utmCampaign || "",
                        utmSource: (payload === null || payload === void 0 ? void 0 : payload.reschedule) ? "Rescheduled" : payload.utmSource || "",
                        label: payload.label || ""
                    };
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=scholar-calendar/create/meeting/".concat((payload === null || payload === void 0 ? void 0 : payload.meetingType) || "OFFICE_HOUR"), data);
                case 4:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", true);
                case 9:
                    return _ctx.abrupt("return", false);
                case 10:
                    _ctx.next = 16;
                    break;
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](1);
                    console.log(_ctx.t0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                12
            ]
        ]);
    }));
    return function confirmMeetCounsellerSlot(payload) {
        return _ref.apply(this, arguments);
    };
}();
var MeetCounsellerApi_confirmRescheduleSlot = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
        var ref, minute, utmData, meetingId, data, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    minute = payload.minute, utmData = payload.utmData, meetingId = payload.meetingId;
                    data = {
                        utm_campaign: utmData.utm_campaign || "",
                        utm_source: utmData.utm_source || "",
                        utm_term: utmData.utm_term || "",
                        utm_medium: utmData.utm_medium || "",
                        campaign_type: utmData.campaign_type || "",
                        gclid: (utmData === null || utmData === void 0 ? void 0 : utmData.gclid) || "",
                        adName: (utmData === null || utmData === void 0 ? void 0 : utmData.adName) || "",
                        form_id: ((ref = utmData.formId) === null || ref === void 0 ? void 0 : ref.length) ? utmData.formId : null,
                        ad_id: utmData.ad_id || ""
                    };
                    _ctx.prev = 3;
                    _ctx.next = 6;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=counselling/register/".concat(minute, "&reschedule=true&meetingId=").concat(meetingId), data);
                case 6:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 11;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 11:
                    return _ctx.abrupt("return", res.data.message);
                case 12:
                    _ctx.next = 18;
                    break;
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](3);
                    console.log(_ctx.t0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                3,
                14
            ]
        ]);
    }));
    return function confirmRescheduleSlot(payload) {
        return _ref.apply(this, arguments);
    };
}();
var fetchMeetProfile = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref, res, ref1;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=student/spot-profile");
                case 4:
                    res = _ctx.sent;
                    if (!(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 9:
                    ;
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.message);
                case 11:
                    _ctx.next = 17;
                    break;
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }));
    return function fetchMeetProfile() {
        return _ref.apply(this, arguments);
    };
}();
var submitMeetProfile = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
        var ref, res, ref1;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=student/spot-profile", values);
                case 4:
                    res = _ctx.sent;
                    if (!(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", res);
                case 9:
                    ;
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.message);
                case 11:
                    _ctx.next = 16;
                    break;
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please try after sometime");
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }));
    return function submitMeetProfile(values) {
        return _ref.apply(this, arguments);
    };
}();
var fetchVisaCounsellerSlot = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(leadId) {
        var res, ref;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=scholar-calendar/slots/live/".concat(4, "/").concat(leadId, "/VISA_COUNSELLING"));
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    ;
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.message);
                case 10:
                    _ctx.next = 15;
                    break;
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }));
    return function fetchVisaCounsellerSlot(leadId) {
        return _ref.apply(this, arguments);
    };
}();
var meetCounsellerApi = {
    getExpertData: getExpertData,
    saveData: MeetCounsellerApi_saveData,
    fetchMeetCounsellerSlot: fetchMeetCounsellerSlot,
    confirmMeetCounsellerSlot: confirmMeetCounsellerSlot,
    confirmRescheduleSlot: MeetCounsellerApi_confirmRescheduleSlot,
    fetchMeetProfile: fetchMeetProfile,
    submitMeetProfile: submitMeetProfile,
    fetchTypedMeetCounsellerSlot: fetchTypedMeetCounsellerSlot,
    fetchVisaCounsellerSlot: fetchVisaCounsellerSlot
};

;// CONCATENATED MODULE: ./components/MeetCounsellerVirtualOffice/redux/MeetCounsellerSaga.ts

var MeetCounsellerSaga_marked = runtime_default().mark(meetCounsellerSaga);
var MeetCounsellerSaga_marked1 = runtime_default().mark(MeetCounsellerSaga_submitMeetProfile);
var MeetCounsellerSaga_marked2 = runtime_default().mark(MeetCounsellerSaga_fetchMeetProfile);
var MeetCounsellerSaga_marked3 = runtime_default().mark(MeetCounsellerSaga_confirmRescheduleSlot);
var MeetCounsellerSaga_marked4 = runtime_default().mark(MeetCounsellerSaga_confirmMeetCounsellerSlot);
var MeetCounsellerSaga_marked5 = runtime_default().mark(MeetCounsellerSaga_fetchVisaCounsellerSlot);
var MeetCounsellerSaga_marked6 = runtime_default().mark(MeetCounsellerSaga_fetchTypedMeetCounsellerSlot);
var MeetCounsellerSaga_marked7 = runtime_default().mark(MeetCounsellerSaga_fetchMeetCounsellerSlot);
var MeetCounsellerSaga_marked8 = runtime_default().mark(MeetCounsellerSaga_getExpertsData);



function MeetCounsellerSaga_getExpertsData() {
    var res;
    return runtime_default().wrap(function getExpertsData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(meetCounsellerApi.getExpertData);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(MeetCounsellerActions/* meetCounsellerActions.fetchExpertsSuccess */.m.fetchExpertsSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(MeetCounsellerActions/* meetCounsellerActions.fetchExpertsFail */.m.fetchExpertsFail(res.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(MeetCounsellerActions/* meetCounsellerActions.fetchExpertsFail */.m.fetchExpertsFail("Something went wrong. Please try after sometime."));
            case 17:
                console.error(_ctx.t0);
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, MeetCounsellerSaga_marked8, null, [
        [
            0,
            13
        ]
    ]);
}
function MeetCounsellerSaga_fetchMeetCounsellerSlot() {
    var slots;
    return runtime_default().wrap(function fetchMeetCounsellerSlot$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(meetCounsellerApi.fetchMeetCounsellerSlot);
            case 3:
                slots = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)(MeetCounsellerActions/* meetCounsellerActions.fetchMeetCounsellerSlotSuccess */.m.fetchMeetCounsellerSlotSuccess(slots));
            case 6:
                _ctx.next = 12;
                break;
            case 8:
                _ctx.prev = 8;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 12;
                return (0,io_c3792963.Y)(MeetCounsellerActions/* meetCounsellerActions.fetchMeetCounsellerSlotFail */.m.fetchMeetCounsellerSlotFail(_ctx.t0.message));
            case 12:
            case "end":
                return _ctx.stop();
        }
    }, MeetCounsellerSaga_marked7, null, [
        [
            0,
            8
        ]
    ]);
}
function MeetCounsellerSaga_fetchTypedMeetCounsellerSlot(action) {
    var slots;
    return runtime_default().wrap(function fetchTypedMeetCounsellerSlot$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(meetCounsellerApi.fetchTypedMeetCounsellerSlot, action.payload);
            case 3:
                slots = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)(MeetCounsellerActions/* meetCounsellerActions.fetchTypedMeetCounsellerSlotSuccess */.m.fetchTypedMeetCounsellerSlotSuccess(slots));
            case 6:
                _ctx.next = 12;
                break;
            case 8:
                _ctx.prev = 8;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 12;
                return (0,io_c3792963.Y)(MeetCounsellerActions/* meetCounsellerActions.fetchMeetCounsellerSlotFail */.m.fetchMeetCounsellerSlotFail(_ctx.t0.message));
            case 12:
            case "end":
                return _ctx.stop();
        }
    }, MeetCounsellerSaga_marked6, null, [
        [
            0,
            8
        ]
    ]);
}
function MeetCounsellerSaga_fetchVisaCounsellerSlot(action) {
    var slots;
    return runtime_default().wrap(function fetchVisaCounsellerSlot$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(meetCounsellerApi.fetchVisaCounsellerSlot, action.payload);
            case 3:
                slots = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)(MeetCounsellerActions/* meetCounsellerActions.fetchVisaCounsellerSlotSuccess */.m.fetchVisaCounsellerSlotSuccess(slots));
            case 6:
                _ctx.next = 12;
                break;
            case 8:
                _ctx.prev = 8;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 12;
                return (0,io_c3792963.Y)(MeetCounsellerActions/* meetCounsellerActions.fetchVisaCounsellerSlotFail */.m.fetchVisaCounsellerSlotFail(_ctx.t0.message));
            case 12:
            case "end":
                return _ctx.stop();
        }
    }, MeetCounsellerSaga_marked5, null, [
        [
            0,
            8
        ]
    ]);
}
function MeetCounsellerSaga_confirmMeetCounsellerSlot(action) {
    var res;
    return runtime_default().wrap(function confirmMeetCounsellerSlot$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(meetCounsellerApi.confirmMeetCounsellerSlot, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res) {
                    _ctx.next = 10;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(MeetCounsellerActions/* meetCounsellerActions.confirmMeetCounsellerSlotSuccess */.m.confirmMeetCounsellerSlotSuccess(res));
            case 7:
                return _ctx.abrupt("return", true);
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)(MeetCounsellerActions/* meetCounsellerActions.confirmMeetCounsellerSlotFail */.m.confirmMeetCounsellerSlotFail(res));
            case 12:
                _ctx.next = 18;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(MeetCounsellerActions/* meetCounsellerActions.confirmMeetCounsellerSlotFail */.m.confirmMeetCounsellerSlotFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, MeetCounsellerSaga_marked4, null, [
        [
            0,
            14
        ]
    ]);
}
function MeetCounsellerSaga_confirmRescheduleSlot(action) {
    var res;
    return runtime_default().wrap(function confirmRescheduleSlot$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(meetCounsellerApi.confirmRescheduleSlot, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(MeetCounsellerActions/* meetCounsellerActions.confirmRescheduleSlotSuccess */.m.confirmRescheduleSlotSuccess(res));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(MeetCounsellerActions/* meetCounsellerActions.confirmRescheduleSlotFail */.m.confirmRescheduleSlotFail(res));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(MeetCounsellerActions/* meetCounsellerActions.confirmRescheduleSlotFail */.m.confirmRescheduleSlotFail(_ctx.t0.message));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, MeetCounsellerSaga_marked3, null, [
        [
            0,
            13
        ]
    ]);
}
function MeetCounsellerSaga_fetchMeetProfile() {
    var res;
    return runtime_default().wrap(function fetchMeetProfile$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(meetCounsellerApi.fetchMeetProfile);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(MeetCounsellerActions/* meetCounsellerActions.fetchMeetProfileSuccess */.m.fetchMeetProfileSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(MeetCounsellerActions/* meetCounsellerActions.fetchMeetProfileFail */.m.fetchMeetProfileFail(res.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(MeetCounsellerActions/* meetCounsellerActions.fetchMeetProfileFail */.m.fetchMeetProfileFail("Something went wrong. Please try after sometime."));
            case 17:
                console.error(_ctx.t0);
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, MeetCounsellerSaga_marked2, null, [
        [
            0,
            13
        ]
    ]);
}
function MeetCounsellerSaga_submitMeetProfile(action) {
    var ref, res;
    return runtime_default().wrap(function submitMeetProfile$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                ;
                _ctx.next = 4;
                return (0,io_c3792963.N)(meetCounsellerApi.submitMeetProfile, action.payload);
            case 4:
                res = _ctx.sent;
                if (!(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                    _ctx.next = 10;
                    break;
                }
                _ctx.next = 8;
                return (0,io_c3792963.Y)(MeetCounsellerActions/* meetCounsellerActions.submitMeetProfileSuccess */.m.submitMeetProfileSuccess(res.data.data));
            case 8:
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)(MeetCounsellerActions/* meetCounsellerActions.submitMeetProfileFail */.m.submitMeetProfileFail(res));
            case 12:
                _ctx.next = 18;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(MeetCounsellerActions/* meetCounsellerActions.submitMeetProfileFail */.m.submitMeetProfileFail(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, MeetCounsellerSaga_marked1, null, [
        [
            0,
            14
        ]
    ]);
}
function meetCounsellerSaga() {
    return runtime_default().wrap(function meetCounsellerSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("FETCH_EXPERTS_DATA", MeetCounsellerSaga_getExpertsData);
            case 2:
                _ctx.next = 4;
                return takeLatest$1("FETCH_MEET_COUNSELLER_SLOT", MeetCounsellerSaga_fetchMeetCounsellerSlot);
            case 4:
                _ctx.next = 6;
                return takeLatest$1("CONFIRM_MEET_COUNSELLER_SLOT", MeetCounsellerSaga_confirmMeetCounsellerSlot);
            case 6:
                _ctx.next = 8;
                return takeLatest$1("CONFIRM_RESCHEDULE_SLOT", MeetCounsellerSaga_confirmRescheduleSlot);
            case 8:
                _ctx.next = 10;
                return takeLatest$1("FETCH_MEET_PROFILE", MeetCounsellerSaga_fetchMeetProfile);
            case 10:
                _ctx.next = 12;
                return takeLatest$1("SUBMIT_MEET_PROFILE", MeetCounsellerSaga_submitMeetProfile);
            case 12:
                _ctx.next = 14;
                return takeLatest$1("FETCH_TYPED_MEET_COUNSELLER_SLOT", MeetCounsellerSaga_fetchTypedMeetCounsellerSlot);
            case 14:
                _ctx.next = 16;
                return takeLatest$1("FETCH_VISA_COUNSELLER_SLOT", MeetCounsellerSaga_fetchVisaCounsellerSlot);
            case 16:
            case "end":
                return _ctx.stop();
        }
    }, MeetCounsellerSaga_marked);
}
/* harmony default export */ var MeetCounsellerSaga = (meetCounsellerSaga);

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/Stories/redux/StoriesApis.ts

var requestStories = function() {
    return api/* default.get */.Z.get("/api/scholarRoute?path=stories/get", {
        headers: {
            "X-API-VERSION": "3"
        }
    });
};
var requestUpdateStoryStatus = function(storyId) {
    return api/* default.post */.Z.post("/api/scholarRoute?path=stories/update/story/SEEN/".concat(storyId));
};
var storiesApis = {
    requestStories: requestStories,
    requestUpdateStoryStatus: requestUpdateStoryStatus
};

// EXTERNAL MODULE: ./components/Profile/IeltsProfile/Stories/redux/StoriesActions.ts
var StoriesActions = __webpack_require__(80190);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/Stories/redux/StoriesSaga.ts

var StoriesSaga_marked = runtime_default().mark(storiesSaga);
var StoriesSaga_marked1 = runtime_default().mark(handleUpdateStoryStatus);
var StoriesSaga_marked2 = runtime_default().mark(handleFetchStories);




function handleFetchStories() {
    var res, newRes, i, temp;
    return runtime_default().wrap(function handleFetchStories$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(storiesApis.requestStories);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 11;
                    break;
                }
                newRes = cloneDeep_default()(res.data.data);
                newRes = newRes.filter(function(data) {
                    return data.listOfImages && Array.isArray(data.listOfImages) && data.listOfImages.length > 0;
                });
                for(i = 0; i < newRes.length; i += 1){
                    temp = newRes[i].listOfImages.filter(function(img) {
                        return img.userStatus === "NOT_SEEN";
                    });
                    if (temp.length > 0) {
                        newRes[i].userstatus = "NOT_SEEN";
                    }
                    newRes[i].listOfImages.sort(function(a, b) {
                        return a.userStatus === b.userStatus ? 0 : a.userStatus === "NOT_SEEN" ? -1 : 1;
                    });
                }
                newRes = newRes.sort(function(a, b) {
                    return a.userstatus === b.userstatus ? 0 : a.userstatus === "NOT_SEEN" ? -1 : 1;
                });
                _ctx.next = 11;
                return (0,io_c3792963.Y)(StoriesActions/* storiesActions.fetchStoriesSuccess */._.fetchStoriesSuccess(newRes));
            case 11:
                _ctx.next = 16;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
            case 16:
            case "end":
                return _ctx.stop();
        }
    }, StoriesSaga_marked2, null, [
        [
            0,
            13
        ]
    ]);
}
function handleUpdateStoryStatus(action) {
    var res;
    return runtime_default().wrap(function handleUpdateStoryStatus$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(storiesApis.requestUpdateStoryStatus, action.payload);
            case 3:
                res = _ctx.sent;
                if (res.data.success) {}
                _ctx.next = 10;
                break;
            case 7:
                _ctx.prev = 7;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
            case 10:
            case "end":
                return _ctx.stop();
        }
    }, StoriesSaga_marked1, null, [
        [
            0,
            7
        ]
    ]);
}
function storiesSaga() {
    return runtime_default().wrap(function storiesSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("FETCH_STORIES", handleFetchStories);
            case 2:
                _ctx.next = 4;
                return takeLatest$1("UPDATE_STORY_SEEN", handleUpdateStoryStatus);
            case 4:
            case "end":
                return _ctx.stop();
        }
    }, StoriesSaga_marked);
}
/* harmony default export */ var StoriesSaga = (storiesSaga);

// EXTERNAL MODULE: ./lib/Razorpay/paymentGateWay.ts
var paymentGateWay = __webpack_require__(7293);
// EXTERNAL MODULE: ./utils/promoCodeUtils.ts
var promoCodeUtils = __webpack_require__(26489);
;// CONCATENATED MODULE: ./components/Ielts/AiEvaluation/redux/AiEvalutionApi.ts



var fetchAiEvalutionToken = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=aievaluation/ielts8/token");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    return _ctx.abrupt("return", false);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchAiEvalutionToken() {
        return _ref.apply(this, arguments);
    };
}();
var aiEvalutionAlreadyPaid = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=aievaluation/ielts8/fee/alreadyPaid");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    return _ctx.abrupt("return", false);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function aiEvalutionAlreadyPaid() {
        return _ref.apply(this, arguments);
    };
}();
var AiEvalutionApi_saveForm = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=workshop/ielts-class", values);
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function saveForm(values) {
        return _ref.apply(this, arguments);
    };
}();
var fetchGetSmartTestFee = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=fee/smart-test/status");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 8:
                    return _ctx.abrupt("return", false);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchGetSmartTestFee() {
        return _ref.apply(this, arguments);
    };
}();
var fetchGetSmartTestProgressStatus = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=aievaluation/ielts8/free/status");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 8:
                    return _ctx.abrupt("return", false);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", false);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchGetSmartTestProgressStatus() {
        return _ref.apply(this, arguments);
    };
}();
var aiEvalutionApi = {
    fetchAiEvalutionToken: fetchAiEvalutionToken,
    aiEvalutionAlreadyPaid: aiEvalutionAlreadyPaid,
    saveForm: AiEvalutionApi_saveForm,
    fetchGetSmartTestFee: fetchGetSmartTestFee,
    fetchGetSmartTestProgressStatus: fetchGetSmartTestProgressStatus
};

;// CONCATENATED MODULE: ./components/Ielts/AiEvaluation/redux/AiEvalutionSaga.ts



var AiEvalutionSaga_marked = runtime_default().mark(aiEvalutionSaga);
var AiEvalutionSaga_marked1 = runtime_default().mark(fetchGetSmartTestProgressStatusSaga);
var AiEvalutionSaga_marked2 = runtime_default().mark(fetchGetSmartTestFeeSaga);
var AiEvalutionSaga_marked3 = runtime_default().mark(openIelts8tab);
var AiEvalutionSaga_marked4 = runtime_default().mark(AiEvalutionSaga_saveData);
var AiEvalutionSaga_marked5 = runtime_default().mark(AiEvalutionSaga_aiEvalutionAlreadyPaid);
var AiEvalutionSaga_marked6 = runtime_default().mark(AiEvalutionSaga_fetchAiEvalutionToken);







function AiEvalutionSaga_fetchAiEvalutionToken() {
    var res;
    return runtime_default().wrap(function fetchAiEvalutionToken$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(aiEvalutionApi.fetchAiEvalutionToken);
            case 3:
                res = _ctx.sent;
                if (!res) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(AiEvalutionAction/* aiEvalutionActions.getAiEvalutionTokenSuccess */.Z.getAiEvalutionTokenSuccess(res));
            case 7:
                _ctx.next = 9;
                return (0,io_c3792963.Y)(AiEvalutionAction/* aiEvalutionActions.openIelts8tab */.Z.openIelts8tab(res));
            case 9:
                _ctx.next = 16;
                break;
            case 11:
                _ctx.prev = 11;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 16;
                return (0,io_c3792963.Y)(AiEvalutionAction/* aiEvalutionActions.updateError */.Z.updateError("Something went wrong. Please try after sometime"));
            case 16:
            case "end":
                return _ctx.stop();
        }
    }, AiEvalutionSaga_marked6, null, [
        [
            0,
            11
        ]
    ]);
}
function AiEvalutionSaga_aiEvalutionAlreadyPaid() {
    var res;
    return runtime_default().wrap(function aiEvalutionAlreadyPaid$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(aiEvalutionApi.aiEvalutionAlreadyPaid);
            case 3:
                res = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)(AiEvalutionAction/* aiEvalutionActions.aiEvalutionAlreadyPaidSuccess */.Z.aiEvalutionAlreadyPaidSuccess(res));
            case 6:
                _ctx.next = 13;
                break;
            case 8:
                _ctx.prev = 8;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 13;
                return (0,io_c3792963.Y)(AiEvalutionAction/* aiEvalutionActions.updateError */.Z.updateError("Something went wrong. Please try after sometime"));
            case 13:
            case "end":
                return _ctx.stop();
        }
    }, AiEvalutionSaga_marked5, null, [
        [
            0,
            8
        ]
    ]);
}
function AiEvalutionSaga_saveData(action) {
    var res, type, promoCode, smartTestsPrice, paymentInfo, paymentReceived;
    return runtime_default().wrap(function saveData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(aiEvalutionApi.saveForm, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, action.payload), {
                    formId: "I2C_form"
                }));
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 34;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.a3)(function(state) {
                    return state.aiEvalution.purchaseType;
                });
            case 7:
                type = _ctx.sent;
                _ctx.next = 10;
                return (0,io_c3792963.a3)(function(state) {
                    return state.promoCode;
                });
            case 10:
                promoCode = _ctx.sent;
                _ctx.next = 13;
                return (0,io_c3792963.a3)(function(state) {
                    return state.aiEvalution.smartTestsPrice;
                });
            case 13:
                smartTestsPrice = _ctx.sent;
                (0,IeltsToCounsellingApi/* IeltsToCounsellingEligibility */.j6)(action.payload.values);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(AiEvalutionAction/* aiEvalutionActions.toggleShowForm */.Z.toggleShowForm(false));
            case 17:
                if (!(type === "paid")) {
                    _ctx.next = 32;
                    break;
                }
                paymentInfo = {
                    paymentType: "AI_EVALUATION",
                    formDescription: "Automated IELTS Assessments",
                    amount: typeof promoCode.priceAfterDiscount == "number" ? promoCode.priceAfterDiscount : smartTestsPrice || 299
                };
                if (promoCode.isValidCode) {
                    paymentInfo["promoCode"] = {
                        name: promoCode.promoCode.trim(),
                        discount: promoCode.discount
                    };
                }
                _ctx.next = 22;
                return (0,paymentGateWay/* initDefaultPaymentGateway */.Q)(paymentInfo);
            case 22:
                paymentReceived = _ctx.sent;
                if (!paymentReceived) {
                    _ctx.next = 30;
                    break;
                }
                (0,promoCodeUtils/* removePromoCode */.$)();
                _ctx.next = 27;
                return (0,io_c3792963.N)(ga.fireTagEvent, "SmartTests_paid", {
                    value: "299",
                    currency: "INR",
                    content_id: "smartTests",
                    content_type: "smartTests"
                });
            case 27:
                (0,ga.logEvent)("SmartTests", "Paid for SmartTests", " ");
                _ctx.next = 30;
                return (0,io_c3792963.Y)(AiEvalutionAction/* aiEvalutionActions.getAiEvalutionToken */.Z.getAiEvalutionToken(true));
            case 30:
                _ctx.next = 34;
                break;
            case 32:
                _ctx.next = 34;
                return (0,io_c3792963.Y)(AiEvalutionAction/* aiEvalutionActions.getAiEvalutionToken */.Z.getAiEvalutionToken());
            case 34:
                _ctx.next = 41;
                break;
            case 36:
                _ctx.prev = 36;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 41;
                return (0,io_c3792963.Y)(AiEvalutionAction/* aiEvalutionActions.updateError */.Z.updateError("Something went wrong. Please try after sometime"));
            case 41:
            case "end":
                return _ctx.stop();
        }
    }, AiEvalutionSaga_marked4, null, [
        [
            0,
            36
        ]
    ]);
}
function openIelts8tab(action) {
    return runtime_default().wrap(function openIelts8tab$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                window.open("".concat("https://smarttests.leapscholar.com", "?token=").concat(action.payload), "_self");
                _ctx.next = 9;
                break;
            case 4:
                _ctx.prev = 4;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 9;
                return (0,io_c3792963.Y)(AiEvalutionAction/* aiEvalutionActions.updateError */.Z.updateError("Something went wrong. Please try after sometime"));
            case 9:
            case "end":
                return _ctx.stop();
        }
    }, AiEvalutionSaga_marked3, null, [
        [
            0,
            4
        ]
    ]);
}
function fetchGetSmartTestFeeSaga() {
    var res, ref;
    return runtime_default().wrap(function fetchGetSmartTestFeeSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(aiEvalutionApi.fetchGetSmartTestFee);
            case 3:
                res = _ctx.sent;
                if (!res.data) {
                    _ctx.next = 8;
                    break;
                }
                ;
                _ctx.next = 8;
                return (0,io_c3792963.Y)(AiEvalutionAction/* aiEvalutionActions.getSmartTestPriceSucess */.Z.getSmartTestPriceSucess((ref = res.data) === null || ref === void 0 ? void 0 : ref.offerPrice));
            case 8:
                _ctx.next = 12;
                break;
            case 10:
                _ctx.prev = 10;
                _ctx.t0 = _ctx["catch"](0);
            case 12:
            case "end":
                return _ctx.stop();
        }
    }, AiEvalutionSaga_marked2, null, [
        [
            0,
            10
        ]
    ]);
}
function fetchGetSmartTestProgressStatusSaga() {
    var res;
    return runtime_default().wrap(function fetchGetSmartTestProgressStatusSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(aiEvalutionApi.fetchGetSmartTestProgressStatus);
            case 3:
                res = _ctx.sent;
                if (!(res === null || res === void 0 ? void 0 : res.data)) {
                    _ctx.next = 7;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(AiEvalutionAction/* aiEvalutionActions.getSmartTestsProgressStatusSuccess */.Z.getSmartTestsProgressStatusSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.prev = 9;
                _ctx.t0 = _ctx["catch"](0);
            case 11:
            case "end":
                return _ctx.stop();
        }
    }, AiEvalutionSaga_marked1, null, [
        [
            0,
            9
        ]
    ]);
}
function aiEvalutionSaga() {
    return runtime_default().wrap(function aiEvalutionSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("GET_AI_EVALUTION_TOKEN", AiEvalutionSaga_fetchAiEvalutionToken);
            case 2:
                _ctx.next = 4;
                return takeLatest$1("AI_EVALUTION_ALREADY_PAID", AiEvalutionSaga_aiEvalutionAlreadyPaid);
            case 4:
                _ctx.next = 6;
                return takeLatest$1("AI_EVALUATION_FORM_SUBMIT", AiEvalutionSaga_saveData);
            case 6:
                _ctx.next = 8;
                return takeLatest$1("OPEN_IELTS8_TAB", openIelts8tab);
            case 8:
                _ctx.next = 10;
                return takeLatest$1(AiEvalutionAction/* AiEvaluationActionTypes.GET_SMART_TEST_PRICE */.x.GET_SMART_TEST_PRICE, fetchGetSmartTestFeeSaga);
            case 10:
                _ctx.next = 12;
                return takeLatest$1(AiEvalutionAction/* AiEvaluationActionTypes.GET_SMART_TESTS_PROGRESS_STATUS */.x.GET_SMART_TESTS_PROGRESS_STATUS, fetchGetSmartTestProgressStatusSaga);
            case 12:
            case "end":
                return _ctx.stop();
        }
    }, AiEvalutionSaga_marked);
}
/* harmony default export */ var AiEvalutionSaga = (aiEvalutionSaga);

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/Masterclass/MasterclassReplays/redux/MasterclassReplaysApis.ts



var fetchMasterclassReplays = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=video/youtubeRecording");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchMasterclassReplays() {
        return _ref.apply(this, arguments);
    };
}();
var masterclassReplaysApis = {
    fetchMasterclassReplays: fetchMasterclassReplays
};

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/Masterclass/MasterclassReplays/redux/MasterclassReplaysSaga.ts



var MasterclassReplaysSaga_marked = runtime_default().mark(masterclassReplaysSaga);
var MasterclassReplaysSaga_marked1 = runtime_default().mark(MasterclassReplaysSaga_fetchMasterclassReplays);




function MasterclassReplaysSaga_fetchMasterclassReplays() {
    var res, ref, result;
    return runtime_default().wrap(function fetchMasterclassReplays$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(masterclassReplaysApis.fetchMasterclassReplays);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 11;
                    break;
                }
                ;
                result = (ref = res.data) === null || ref === void 0 ? void 0 : ref.map(function(video, i) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, video), {
                        id: i + 1
                    });
                });
                _ctx.next = 9;
                return (0,io_c3792963.Y)(MasterclassReplaysActions/* masterclassReplaysActions.fetchMasterclassReplaysSuccess */.u.fetchMasterclassReplaysSuccess(result || []));
            case 9:
                _ctx.next = 13;
                break;
            case 11:
                _ctx.next = 13;
                return (0,io_c3792963.Y)(MasterclassReplaysActions/* masterclassReplaysActions.updateError */.u.updateError(res.message));
            case 13:
                _ctx.next = 19;
                break;
            case 15:
                _ctx.prev = 15;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 19;
                return (0,io_c3792963.Y)(MasterclassReplaysActions/* masterclassReplaysActions.updateError */.u.updateError("Something went wrong. Please try after sometime"));
            case 19:
            case "end":
                return _ctx.stop();
        }
    }, MasterclassReplaysSaga_marked1, null, [
        [
            0,
            15
        ]
    ]);
}
function masterclassReplaysSaga() {
    return runtime_default().wrap(function masterclassReplaysSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(MasterclassReplaysActions/* masterclassReplaysActionType.FETCH_MASTERCLASS_REPLAYS */.q.FETCH_MASTERCLASS_REPLAYS, MasterclassReplaysSaga_fetchMasterclassReplays);
            case 2:
            case "end":
                return _ctx.stop();
        }
    }, MasterclassReplaysSaga_marked);
}
/* harmony default export */ var MasterclassReplaysSaga = (masterclassReplaysSaga);

;// CONCATENATED MODULE: ./components/Payment/redux/PaymentActions.ts

var fetchUserDataForPayment = function() {
    return {
        type: PaymentReduxConstants.FETCH_USER_DATA_FOR_PAYMENT
    };
};
var fetchUserDataForPaymentSuccess = function(payload) {
    return {
        type: PaymentReduxConstants.FETCH_USER_DATA_FOR_PAYMENT_SUCCESS,
        payload: payload
    };
};
var fetchUserDataForPaymentError = function(message) {
    return {
        type: PaymentReduxConstants.FETCH_USER_DATA_FOR_PAYMENT_ERROR,
        payload: message
    };
};
var fetchPaymentData = function(payload) {
    return {
        type: PaymentReduxConstants.FETCH_PAYMENT_DATA,
        payload: payload
    };
};
var fetchPaymentDataSuccess = function(payload) {
    return {
        type: PaymentReduxConstants.FETCH_PAYMENT_DATA_SUCCESS,
        payload: payload
    };
};
var fetchPaymentDataError = function(message) {
    return {
        type: PaymentReduxConstants.FETCH_PAYMENT_DATA_ERROR,
        payload: message
    };
};
var validatePromoCode = function(payload) {
    return {
        type: PaymentReduxConstants.VALIDATE_PROMO_CODE,
        payload: payload
    };
};
var validatePromoCodeSuccess = function(payload) {
    return {
        type: PaymentReduxConstants.VALIDATE_PROMO_CODE_SUCCESS,
        payload: payload
    };
};
var validatePromoCodeError = function(message) {
    return {
        type: PaymentReduxConstants.VALIDATE_PROMO_CODE_ERROR,
        payload: message
    };
};
var initilizePayment = function(payload) {
    return {
        type: PaymentReduxConstants.INITIALIZE_PAYMENT,
        payload: payload
    };
};
var initilizePaymentSuccess = function(payload) {
    return {
        type: PaymentReduxConstants.INITIALIZE_PAYMENT_SUCCESS,
        payload: payload
    };
};
var initilizePaymentError = function(message) {
    return {
        type: PaymentReduxConstants.INITIALIZE_PAYMENT_ERROR,
        payload: message
    };
};
// const applyPromoCode = (payload?:any) => ({
//   type: PaymentConstants.APPLY_PROMO_CODE,
//   payload,
// });
var paymentActions = {
    fetchUserDataForPayment: fetchUserDataForPayment,
    fetchUserDataForPaymentSuccess: fetchUserDataForPaymentSuccess,
    fetchUserDataForPaymentError: fetchUserDataForPaymentError,
    fetchPaymentData: fetchPaymentData,
    fetchPaymentDataSuccess: fetchPaymentDataSuccess,
    fetchPaymentDataError: fetchPaymentDataError,
    validatePromoCode: validatePromoCode,
    validatePromoCodeSuccess: validatePromoCodeSuccess,
    validatePromoCodeError: validatePromoCodeError,
    // applyPromoCode,
    initilizePayment: initilizePayment,
    initilizePaymentSuccess: initilizePaymentSuccess,
    initilizePaymentError: initilizePaymentError
};

// EXTERNAL MODULE: ./components/Payment/redux/PaymentApis.ts
var PaymentApis = __webpack_require__(90813);
;// CONCATENATED MODULE: ./components/Payment/redux/PaymentSaga.ts



var PaymentSaga_marked = runtime_default().mark(paymentSaga);
var PaymentSaga_marked1 = runtime_default().mark(PaymentSaga_fetchPaymentData);
var PaymentSaga_marked2 = runtime_default().mark(PaymentSaga_fetchUserDataForPayment);




function PaymentSaga_fetchUserDataForPayment() {
    var res;
    return runtime_default().wrap(function fetchUserDataForPayment$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(PaymentApis/* paymentApi.fetchUserDetailsForPayment */.Y.fetchUserDetailsForPayment);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(paymentActions.fetchUserDataForPaymentSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(paymentActions.fetchUserDataForPaymentError(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(paymentActions.fetchUserDataForPaymentError(_ctx.t0.message));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, PaymentSaga_marked2, null, [
        [
            0,
            13
        ]
    ]);
}
function PaymentSaga_fetchPaymentData(action) {
    var res, _data, offer, alreadypaid, mrp, paymentCategory, res2, newOffer;
    return runtime_default().wrap(function fetchPaymentData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                console.log("saga", action);
                _ctx.prev = 1;
                _ctx.next = 4;
                return (0,io_c3792963.N)(PaymentApis/* paymentApi.fetchPaymentData */.Y.fetchPaymentData, action.payload.paymentData);
            case 4:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 38;
                    break;
                }
                if (!res.data.data) {
                    _ctx.next = 36;
                    break;
                }
                _data = res.data.data, offer = _data.offer, alreadypaid = _data.alreadypaid, mrp = _data.mrp, paymentCategory = _data.paymentCategory;
                if (!(!alreadypaid && offer !== 0 && paymentCategory === "PGD_999")) {
                    _ctx.next = 34;
                    break;
                }
                if (!action.payload.promoCode) {
                    _ctx.next = 30;
                    break;
                }
                _ctx.next = 12;
                return (0,io_c3792963.N)(PaymentApis/* paymentApi.validatePromoCode */.Y.validatePromoCode, action.payload.promoCode);
            case 12:
                res2 = _ctx.sent;
                if (!res2.data.success) {
                    _ctx.next = 26;
                    break;
                }
                _ctx.next = 16;
                return (0,io_c3792963.Y)(paymentActions.validatePromoCodeSuccess(res2.data.data));
            case 16:
                if (!(mrp === 999)) {
                    _ctx.next = 22;
                    break;
                }
                newOffer = Math.floor(offer - res2.data.data.discount / 100 * offer);
                _ctx.next = 20;
                return (0,io_c3792963.Y)(paymentActions.fetchPaymentDataSuccess((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, res.data.data), {
                    offer: newOffer
                })));
            case 20:
                _ctx.next = 24;
                break;
            case 22:
                _ctx.next = 24;
                return (0,io_c3792963.Y)(paymentActions.fetchPaymentDataSuccess(res.data.data));
            case 24:
                _ctx.next = 28;
                break;
            case 26:
                _ctx.next = 28;
                return (0,io_c3792963.Y)(paymentActions.fetchPaymentDataSuccess(res.data.data));
            case 28:
                _ctx.next = 32;
                break;
            case 30:
                _ctx.next = 32;
                return (0,io_c3792963.Y)(paymentActions.fetchPaymentDataSuccess(res.data.data));
            case 32:
                _ctx.next = 36;
                break;
            case 34:
                _ctx.next = 36;
                return (0,io_c3792963.Y)(paymentActions.fetchPaymentDataSuccess(res.data.data));
            case 36:
                _ctx.next = 40;
                break;
            case 38:
                _ctx.next = 40;
                return (0,io_c3792963.Y)(paymentActions.fetchPaymentDataError(res.data.message));
            case 40:
                _ctx.next = 47;
                break;
            case 42:
                _ctx.prev = 42;
                _ctx.t0 = _ctx["catch"](1);
                console.error(_ctx.t0);
                _ctx.next = 47;
                return (0,io_c3792963.Y)(paymentActions.fetchPaymentDataError(_ctx.t0.message));
            case 47:
            case "end":
                return _ctx.stop();
        }
    }, PaymentSaga_marked1, null, [
        [
            1,
            42
        ]
    ]);
}
// function* validatePromoCode(action: AnyAction): Generator<any, any, any> {
//   try {
//     const res = yield call(paymentApi.validatePromoCode, action.payload);
//     if (res.data.success) {
//       yield put(paymentActions.validatePromoCodeSuccess(res.data.data));
//     } else {
//       yield put(paymentActions.validatePromoCodeError(res.data.message));
//     }
//   } catch (e: any) {
//     console.error(e);
//     yield put(paymentActions.validatePromoCodeError(e.message));
//   }
// }
// function* initilizePayment(action: AnyAction): Generator<any, any, any> {
//   try {
//     const res = yield call(paymentApi. , action.payload);
//     if (res.data.success) {
//       yield put(paymentActions.initilizePaymentSuccess(res.data.data));
//     } else {
//       yield put(paymentActions.initilizePaymentError(res.data.message));
//     }
//   } catch (e:any) {
//     console.error(e);
//     yield put(paymentActions.initilizePaymentError(e.message));
//   }
// }
function paymentSaga() {
    return runtime_default().wrap(function paymentSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(PaymentReduxConstants.FETCH_USER_DATA_FOR_PAYMENT, PaymentSaga_fetchUserDataForPayment);
            case 2:
                _ctx.next = 4;
                return takeLatest$1(PaymentReduxConstants.FETCH_PAYMENT_DATA, PaymentSaga_fetchPaymentData);
            case 4:
            case "end":
                return _ctx.stop();
        }
    }, PaymentSaga_marked);
//yield takeLatest(PaymentConstants.VALIDATE_PROMO_CODE, validatePromoCode);
// yield takeLatest(
//   PaymentConstants.INITIALIZE_PAYMENT,
//   initilizePayment
// );
}
/* harmony default export */ var PaymentSaga = (paymentSaga);

// EXTERNAL MODULE: ./components/Profile/IeltsProfile/QuizSection/redux/QuizActions.ts
var QuizActions = __webpack_require__(66096);
;// CONCATENATED MODULE: ./apollo/queries/ielts_quiz.ts

function ielts_quiz_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ($slugArray: [String]) {\n    ieltsQuizs(where: { id: $slugArray }) {\n      id\n      Title\n      Icon {\n        url\n      }\n      question {\n        ielts_question {\n          id\n          QuestionDescription\n          Instruction\n          ExplanationOfAnswers\n          Marks\n          NegativeMarking\n          QuestionType\n          Option {\n            id\n            option_description\n            is_correct\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    ielts_quiz_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ($slugId: String) {\n    ieltsQuizs(where: { id: $slugId }) {\n      id\n      Title\n      question {\n        ielts_question {\n          id\n          QuestionDescription\n          Instruction\n          ExplanationOfAnswers\n          Marks\n          NegativeMarking\n          QuestionType\n          Option {\n            id\n            option_description\n            is_correct\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var FETCH_IELTS_QUIZ = (0,lib/* default */.ZP)(ielts_quiz_templateObject());
var FETCH_QUIZ_DETAILS = (0,lib/* default */.ZP)(_templateObject1());

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/QuizSection/redux/QuizApis.ts






var fetchQuizList = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(batchId) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=api/workshop/".concat(batchId, "/quiz-bundle/summary"));
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchQuizList(batchId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchIeltsQuizListCms = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(querySlug) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return apollo/* apoloClient.query */.Bq.query({
                        query: FETCH_IELTS_QUIZ,
                        variables: {
                            slugArray: querySlug
                        }
                    });
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchIeltsQuizListCms(querySlug) {
        return _ref.apply(this, arguments);
    };
}();
// const quizUserStatusReq = async (id: string) => {
//   try {
//     const res = await api.get(
//       `/api/scholarRoute?path=quiz/userQuizInfo/${id}`
//     );
//     return res.data;
//   } catch (err: any) {
//     console.log(err);
//   }
// };
var quizUserStatusReq = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(id, quizBundleId, batchId) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=quiz-bundle/result/".concat(batchId, "/").concat(quizBundleId, "/").concat(id));
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function quizUserStatusReq(id, quizBundleId, batchId) {
        return _ref.apply(this, arguments);
    };
}();
var quizEndAttemptReq = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=quiz/end", (0,_object_spread/* default */.Z)({
                        endTime: new Date()
                    }, payload));
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function quizEndAttemptReq(payload) {
        return _ref.apply(this, arguments);
    };
}();
var rewardQuizEndAttemptReq = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
        var headers, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    headers = {
                        "X-API-VERSION": "1"
                    };
                    _ctx.next = 4;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=quiz-bundle/quiz/end", (0,_object_spread/* default */.Z)({
                        endTime: new Date()
                    }, payload), {
                        headers: headers
                    });
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function rewardQuizEndAttemptReq(payload) {
        return _ref.apply(this, arguments);
    };
}();
var fetchQuizDetailCms = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(id) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return apollo/* apoloClient.query */.Bq.query({
                        query: FETCH_QUIZ_DETAILS,
                        variables: {
                            slugId: id
                        }
                    });
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchQuizDetailCms(id) {
        return _ref.apply(this, arguments);
    };
}();
var quizStartAttemptReq = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(id) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=quiz/".concat(id, "/start"));
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function quizStartAttemptReq(id) {
        return _ref.apply(this, arguments);
    };
}();
var rewardQuizStartAttemptReq = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(id, quizBundleId, batchId) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=quiz-bundle/".concat(batchId, "/").concat(quizBundleId, "/").concat(id, "/start"));
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function rewardQuizStartAttemptReq(id, quizBundleId, batchId) {
        return _ref.apply(this, arguments);
    };
}();
var quizQueAnsSubmit = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=quiz/submission", (0,_object_spread/* default */.Z)({}, payload));
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function quizQueAnsSubmit(payload) {
        return _ref.apply(this, arguments);
    };
}();
var rewardQuizQueAnsSubmit = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=quiz-bundle/quiz/submit", (0,_object_spread/* default */.Z)({}, payload));
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function rewardQuizQueAnsSubmit(payload) {
        return _ref.apply(this, arguments);
    };
}();
var fetchQuizModalType = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(quizId) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=quiz/courseRecomendation/".concat(quizId));
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchQuizModalType(quizId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchBundleQuizList = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
        var headers, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    headers = {
                        "X-API-VERSION": "1"
                    };
                    _ctx.next = 4;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=api/workshop/".concat(payload.batchId, "/quiz-bundle/").concat(payload.priority), {
                        headers: headers
                    });
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function fetchBundleQuizList(payload) {
        return _ref.apply(this, arguments);
    };
}();
var quizApis = {
    fetchQuizList: fetchQuizList,
    fetchIeltsQuizListCms: fetchIeltsQuizListCms,
    fetchQuizDetailCms: fetchQuizDetailCms,
    quizStartAttemptReq: quizStartAttemptReq,
    quizEndAttemptReq: quizEndAttemptReq,
    quizUserStatusReq: quizUserStatusReq,
    quizQueAnsSubmit: quizQueAnsSubmit,
    fetchQuizModalType: fetchQuizModalType,
    fetchBundleQuizList: fetchBundleQuizList,
    rewardQuizEndAttemptReq: rewardQuizEndAttemptReq,
    rewardQuizQueAnsSubmit: rewardQuizQueAnsSubmit,
    rewardQuizStartAttemptReq: rewardQuizStartAttemptReq
};

// EXTERNAL MODULE: ./Interfaces/reducerTypes/IeltsPlusQuizSchema.ts
var IeltsPlusQuizSchema = __webpack_require__(50115);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/QuizSection/redux/QuizSaga.ts



var QuizSaga_marked = runtime_default().mark(quizSaga);
var QuizSaga_marked1 = runtime_default().mark(QuizSaga_fetchBundleQuizList);
var QuizSaga_marked2 = runtime_default().mark(QuizSaga_fetchQuizModalType);
var QuizSaga_marked3 = runtime_default().mark(postAnsSubmit);
var QuizSaga_marked4 = runtime_default().mark(postEndQuiz);
var QuizSaga_marked5 = runtime_default().mark(postStartQuiz);
var QuizSaga_marked6 = runtime_default().mark(fetchQuizQuestion);
var QuizSaga_marked7 = runtime_default().mark(QuizSaga_fetchQuizList);





function QuizSaga_fetchQuizList(action) {
    var res, cmsData, quizListData, newQuizList, completeQuizList;
    return runtime_default().wrap(function fetchQuizList$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(quizApis.fetchQuizList, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 19;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.N)(quizApis.fetchIeltsQuizListCms, res.data.filter(function(quizItem) {
                    return quizItem;
                }).map(function(quizItems) {
                    return quizItems.quizId;
                }));
            case 7:
                cmsData = _ctx.sent;
                quizListData = res.data.filter(function(quizItems) {
                    var ref;
                    return (ref = cmsData.ieltsQuizs) === null || ref === void 0 ? void 0 : ref.find(function(quizData) {
                        return quizData.id == quizItems.quizId;
                    });
                }).map(function(quizItems) {
                    var ref;
                    var quizCmsData = (ref = cmsData.ieltsQuizs) === null || ref === void 0 ? void 0 : ref.find(function(quizData) {
                        return quizData.id == quizItems.quizId;
                    });
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, quizItems, quizCmsData), {
                        title: quizCmsData === null || quizCmsData === void 0 ? void 0 : quizCmsData.Title,
                        icon: quizCmsData.Icon.url
                    });
                });
                _ctx.next = 11;
                return (0,io_c3792963.Y)(QuizActions/* quizActions.fetchQuizListSuccess */.J.fetchQuizListSuccess(quizListData));
            case 11:
                newQuizList = quizListData.filter(function(quizItems) {
                    return quizItems.status != IeltsPlusQuizSchema/* QuizStatus.FINISHED */.s.FINISHED;
                });
                completeQuizList = quizListData.filter(function(quizItems) {
                    return quizItems.status == IeltsPlusQuizSchema/* QuizStatus.FINISHED */.s.FINISHED;
                });
                _ctx.next = 15;
                return (0,io_c3792963.Y)(QuizActions/* quizActions.updateNewQuizList */.J.updateNewQuizList(newQuizList));
            case 15:
                _ctx.next = 17;
                return (0,io_c3792963.Y)(QuizActions/* quizActions.updateCompleteQuizList */.J.updateCompleteQuizList(completeQuizList));
            case 17:
                _ctx.next = 21;
                break;
            case 19:
                _ctx.next = 21;
                return (0,io_c3792963.Y)(QuizActions/* quizActions.updateError */.J.updateError(res.message));
            case 21:
                _ctx.next = 28;
                break;
            case 23:
                _ctx.prev = 23;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 28;
                return (0,io_c3792963.Y)(QuizActions/* quizActions.updateError */.J.updateError("Something went wrong. Please try after sometime"));
            case 28:
            case "end":
                return _ctx.stop();
        }
    }, QuizSaga_marked7, null, [
        [
            0,
            23
        ]
    ]);
}
function fetchQuizQuestion(action) {
    var res, ref, ref1, latestAttempt, cmsQuizQuestionData, quizQuestionData;
    return runtime_default().wrap(function fetchQuizQuestion$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(quizApis.quizUserStatusReq, action.payload, action.quizBundleId, action.batchId);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 37;
                    break;
                }
                ;
                latestAttempt = res.data.length > 0 && res.data.reduce(function(acc, cur) {
                    if (!acc || cur.attemptId > acc.attemptId) return cur;
                    return acc;
                }, null);
                if (action.isRetake) {
                    latestAttempt = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, latestAttempt), {
                        status: IeltsPlusQuizSchema/* QuizStatus.NOT_ATTEMPTED */.s.NOT_ATTEMPTED
                    });
                }
                _ctx.next = 10;
                return (0,io_c3792963.N)(quizApis.fetchQuizDetailCms, action.payload);
            case 10:
                cmsQuizQuestionData = _ctx.sent;
                quizQuestionData = (ref = cmsQuizQuestionData === null || cmsQuizQuestionData === void 0 ? void 0 : cmsQuizQuestionData.ieltsQuizs[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.question) === null || ref1 === void 0 ? void 0 : ref1.filter(function(data) {
                    return data["ielts_question"];
                }).map(function(data) {
                    var ieltsQuestion = data["ielts_question"];
                    return {
                        id: ieltsQuestion.id,
                        questionType: ieltsQuestion.QuestionType,
                        explanationOfAnswers: ieltsQuestion.ExplanationOfAnswers,
                        optionList: ieltsQuestion.Option,
                        questionTitle: ieltsQuestion.QuestionDescription
                    };
                });
                _ctx.next = 14;
                return (0,io_c3792963.Y)(QuizActions/* quizActions.updateQuizTitle */.J.updateQuizTitle(cmsQuizQuestionData === null || cmsQuizQuestionData === void 0 ? void 0 : cmsQuizQuestionData.ieltsQuizs[0]["Title"]));
            case 14:
                if (!(latestAttempt.status == IeltsPlusQuizSchema/* QuizStatus.NOT_ATTEMPTED */.s.NOT_ATTEMPTED || action.isRetake)) {
                    _ctx.next = 19;
                    break;
                }
                _ctx.next = 17;
                return (0,io_c3792963.Y)(QuizActions/* quizActions.startQuizTest */.J.startQuizTest(action.payload, action.quizBundleId, action.batchId));
            case 17:
                _ctx.next = 23;
                break;
            case 19:
                _ctx.next = 21;
                return (0,io_c3792963.Y)(QuizActions/* quizActions.updateQuizStatus */.J.updateQuizStatus(latestAttempt.status));
            case 21:
                _ctx.next = 23;
                return (0,io_c3792963.Y)(QuizActions/* quizActions.updateAttemptId */.J.updateAttemptId(latestAttempt.attemptId));
            case 23:
                if (!latestAttempt.startTime) {
                    _ctx.next = 26;
                    break;
                }
                _ctx.next = 26;
                return (0,io_c3792963.Y)(QuizActions/* quizActions.updateQuizTestDate */.J.updateQuizTestDate(latestAttempt.startTime));
            case 26:
                if (!latestAttempt.endTime) {
                    _ctx.next = 29;
                    break;
                }
                _ctx.next = 29;
                return (0,io_c3792963.Y)(QuizActions/* quizActions.updateQuizEndTestDate */.J.updateQuizEndTestDate(latestAttempt.endTime));
            case 29:
                if (!(latestAttempt && latestAttempt.submittedQuestionsList && latestAttempt.status != IeltsPlusQuizSchema/* QuizStatus.NOT_ATTEMPTED */.s.NOT_ATTEMPTED)) {
                    _ctx.next = 32;
                    break;
                }
                _ctx.next = 32;
                return (0,io_c3792963.Y)(QuizActions/* quizActions.updateQuizSubmittedAns */.J.updateQuizSubmittedAns(latestAttempt.submittedQuestionsList));
            case 32:
                action.callback && action.callback();
                _ctx.next = 35;
                return (0,io_c3792963.Y)(QuizActions/* quizActions.updateQuizStatus */.J.updateQuizStatus(latestAttempt.status));
            case 35:
                _ctx.next = 37;
                return (0,io_c3792963.Y)(QuizActions/* quizActions.fetchQuizQuestionSuccess */.J.fetchQuizQuestionSuccess(quizQuestionData));
            case 37:
                _ctx.next = 44;
                break;
            case 39:
                _ctx.prev = 39;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 44;
                return (0,io_c3792963.Y)(QuizActions/* quizActions.updateError */.J.updateError("Something went wrong. Please try after sometime"));
            case 44:
            case "end":
                return _ctx.stop();
        }
    }, QuizSaga_marked6, null, [
        [
            0,
            39
        ]
    ]);
}
function postStartQuiz(action) {
    var res;
    return runtime_default().wrap(function postStartQuiz$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                ;
                if (!(action.quizBundleId && action.batchId)) {
                    _ctx.next = 8;
                    break;
                }
                _ctx.next = 5;
                return (0,io_c3792963.N)(quizApis.rewardQuizStartAttemptReq, action.payload, action.quizBundleId, action.batchId);
            case 5:
                res = _ctx.sent;
                _ctx.next = 11;
                break;
            case 8:
                _ctx.next = 10;
                return (0,io_c3792963.N)(quizApis.quizStartAttemptReq, action.payload);
            case 10:
                res = _ctx.sent;
            case 11:
                if (!res.success) {
                    _ctx.next = 16;
                    break;
                }
                _ctx.next = 14;
                return (0,io_c3792963.Y)(QuizActions/* quizActions.updateQuizStatus */.J.updateQuizStatus(IeltsPlusQuizSchema/* QuizStatus.ATTEMPTED */.s.ATTEMPTED));
            case 14:
                _ctx.next = 16;
                return (0,io_c3792963.Y)(QuizActions/* quizActions.updateAttemptId */.J.updateAttemptId(res.data));
            case 16:
                _ctx.next = 22;
                break;
            case 18:
                _ctx.prev = 18;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 22;
                return (0,io_c3792963.Y)(QuizActions/* quizActions.updateError */.J.updateError("Something went wrong. Please try after sometime"));
            case 22:
            case "end":
                return _ctx.stop();
        }
    }, QuizSaga_marked5, null, [
        [
            0,
            18
        ]
    ]);
}
function postEndQuiz(action) {
    var res;
    return runtime_default().wrap(function postEndQuiz$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                ;
                if (!action.payload.batchId) {
                    _ctx.next = 8;
                    break;
                }
                _ctx.next = 5;
                return (0,io_c3792963.N)(quizApis.rewardQuizEndAttemptReq, action.payload);
            case 5:
                res = _ctx.sent;
                _ctx.next = 11;
                break;
            case 8:
                _ctx.next = 10;
                return (0,io_c3792963.N)(quizApis.quizEndAttemptReq, action.payload);
            case 10:
                res = _ctx.sent;
            case 11:
                if (!res.success) {
                    _ctx.next = 16;
                    break;
                }
                _ctx.next = 14;
                return (0,io_c3792963.Y)(QuizActions/* quizActions.updateQuizStatus */.J.updateQuizStatus(IeltsPlusQuizSchema/* QuizStatus.FINISHED */.s.FINISHED));
            case 14:
                _ctx.next = 16;
                return (0,io_c3792963.Y)(QuizActions/* quizActions.updateQuizSubmitSuccessfully */.J.updateQuizSubmitSuccessfully(true));
            case 16:
                _ctx.next = 22;
                break;
            case 18:
                _ctx.prev = 18;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 22;
                return (0,io_c3792963.Y)(QuizActions/* quizActions.updateError */.J.updateError("Something went wrong. Please try after sometime"));
            case 22:
            case "end":
                return _ctx.stop();
        }
    }, QuizSaga_marked4, null, [
        [
            0,
            18
        ]
    ]);
}
function postAnsSubmit(action) {
    return runtime_default().wrap(function postAnsSubmit$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                if (!action.payload.quizBundleId) {
                    _ctx.next = 6;
                    break;
                }
                _ctx.next = 4;
                return (0,io_c3792963.N)(quizApis.rewardQuizQueAnsSubmit, action.payload);
            case 4:
                _ctx.next = 8;
                break;
            case 6:
                _ctx.next = 8;
                return (0,io_c3792963.N)(quizApis.quizQueAnsSubmit, action.payload);
            case 8:
                _ctx.next = 14;
                break;
            case 10:
                _ctx.prev = 10;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 14;
                return (0,io_c3792963.Y)(QuizActions/* quizActions.updateError */.J.updateError("Something went wrong. Please try after sometime"));
            case 14:
            case "end":
                return _ctx.stop();
        }
    }, QuizSaga_marked3, null, [
        [
            0,
            10
        ]
    ]);
}
function QuizSaga_fetchQuizModalType(action) {
    var res;
    return runtime_default().wrap(function fetchQuizModalType$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(quizApis.fetchQuizModalType, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(QuizActions/* quizActions.fetchQuizModalTypeSuccess */.J.fetchQuizModalTypeSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(QuizActions/* quizActions.updateError */.J.updateError("Something went wrong. Please try after sometime"));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(QuizActions/* quizActions.updateError */.J.updateError("Something went wrong. Please try after sometime"));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, QuizSaga_marked2, null, [
        [
            0,
            13
        ]
    ]);
}
function QuizSaga_fetchBundleQuizList(action) {
    var res;
    return runtime_default().wrap(function fetchBundleQuizList$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(quizApis.fetchBundleQuizList, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 10;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(QuizActions/* quizActions.fetchQuizBundleListSuccess */.J.fetchQuizBundleListSuccess(res.data));
            case 7:
                action.callback && action.callback(res.data);
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)(QuizActions/* quizActions.updateError */.J.updateError(res.message));
            case 12:
                _ctx.next = 19;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
                _ctx.next = 19;
                return (0,io_c3792963.Y)(QuizActions/* quizActions.updateError */.J.updateError("Something went wrong. Please try after sometime"));
            case 19:
            case "end":
                return _ctx.stop();
        }
    }, QuizSaga_marked1, null, [
        [
            0,
            14
        ]
    ]);
}
function quizSaga() {
    return runtime_default().wrap(function quizSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(QuizType/* QuizType.FETCH_QUIZ_LIST */.p.FETCH_QUIZ_LIST, QuizSaga_fetchQuizList);
            case 2:
                _ctx.next = 4;
                return takeLatest$1(QuizType/* QuizType.FETCH_QUIZ_QUESTION */.p.FETCH_QUIZ_QUESTION, fetchQuizQuestion);
            case 4:
                _ctx.next = 6;
                return takeLatest$1(QuizType/* QuizType.START_QUIZ_TEST */.p.START_QUIZ_TEST, postStartQuiz);
            case 6:
                _ctx.next = 8;
                return takeLatest$1(QuizType/* QuizType.SUBMIT_QUESTION_ANS */.p.SUBMIT_QUESTION_ANS, postAnsSubmit);
            case 8:
                _ctx.next = 10;
                return takeLatest$1(QuizType/* QuizType.END_QUIZ_TEST */.p.END_QUIZ_TEST, postEndQuiz);
            case 10:
                _ctx.next = 12;
                return takeLatest$1(QuizType/* QuizType.FETCH_QUIZ_MODAL_TYPE */.p.FETCH_QUIZ_MODAL_TYPE, QuizSaga_fetchQuizModalType);
            case 12:
                _ctx.next = 14;
                return takeLatest$1(QuizType/* QuizType.FETCH_QUIZ_BUNDLE_TYPE_REQUESTED */.p.FETCH_QUIZ_BUNDLE_TYPE_REQUESTED, QuizSaga_fetchBundleQuizList);
            case 14:
            case "end":
                return _ctx.stop();
        }
    }, QuizSaga_marked);
}
/* harmony default export */ var QuizSaga = (quizSaga);

;// CONCATENATED MODULE: ./apollo/queries/semPageDetail.ts

function semPageDetail_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query {\n    semPages {\n        target_intent\n        template_type\n        landing_page_name\n        landing_page_link\n        headline\n        sub_heading\n        bullet_points\n    }\n  }\n"
    ]);
    semPageDetail_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var FETCH_SEM_PAGE_QUERY = (0,lib/* default */.ZP)(semPageDetail_templateObject());
/* harmony default export */ var semPageDetail = (FETCH_SEM_PAGE_QUERY);

;// CONCATENATED MODULE: ./components/Ielts/SemLanding/redux/SemLandingApi.ts





var fetchSemPageDetails = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return apollo/* apoloClient.query */.Bq.query({
                        query: semPageDetail
                    });
                case 3:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchSemPageDetails() {
        return _ref.apply(this, arguments);
    };
}();
var saveSemForm = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=preferences/semlead", values);
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function saveSemForm(values) {
        return _ref.apply(this, arguments);
    };
}();
var semPageApi = {
    fetchSemPageDetails: fetchSemPageDetails,
    saveSemForm: saveSemForm
};

;// CONCATENATED MODULE: ./components/Ielts/SemLanding/redux/SemLandingSaga.ts



var SemLandingSaga_marked = runtime_default().mark(semPageSaga);
var SemLandingSaga_marked1 = runtime_default().mark(saveSemDataHandler);
var SemLandingSaga_marked2 = runtime_default().mark(semDetailsHandler);







function semDetailsHandler() {
    var ref, res, semDetails;
    return runtime_default().wrap(function semDetailsHandler$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                ;
                _ctx.next = 4;
                return (0,io_c3792963.N)(semPageApi.fetchSemPageDetails);
            case 4:
                res = _ctx.sent;
                semDetails = res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.semPages.map(function(data) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                        bullet_points: JSON.parse(data.bullet_points)
                    });
                });
                _ctx.next = 8;
                return (0,io_c3792963.Y)(SemLandingAction/* semPageAction.semPageDetailSuccess */.i.semPageDetailSuccess(semDetails));
            case 8:
                _ctx.next = 14;
                break;
            case 10:
                _ctx.prev = 10;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 14;
                return (0,io_c3792963.Y)(SemLandingAction/* semPageAction.updateError */.i.updateError("Something went wrong. Please try after sometime"));
            case 14:
            case "end":
                return _ctx.stop();
        }
    }, SemLandingSaga_marked2, null, [
        [
            0,
            10
        ]
    ]);
}
function saveSemDataHandler(action) {
    var res, ref;
    return runtime_default().wrap(function saveSemDataHandler$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(semPageApi.saveSemForm, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 24;
                    break;
                }
                ;
                _ctx.next = 8;
                return (0,io_c3792963.Y)(SemLandingAction/* semPageAction.semSaveFormSuccess */.i.semSaveFormSuccess());
            case 8:
                if (!(res.data !== "ALREADY_REGISTERED")) {
                    _ctx.next = 14;
                    break;
                }
                (0,segment.trackIeltsForm)("Form Filled SEM", {
                    formType: "Masterclass SEM",
                    pageName: action.path
                });
                _ctx.next = 12;
                return (0,io_c3792963.Y)(SemLandingAction/* semPageAction.toggelModal */.i.toggelModal(true));
            case 12:
                _ctx.next = 21;
                break;
            case 14:
                _ctx.prev = 14;
                window.open(page_routes/* navRoutes.POSTLOGIN_COUNSELLING */.CZ.POSTLOGIN_COUNSELLING, "_self");
                _ctx.next = 21;
                break;
            case 18:
                _ctx.prev = 18;
                _ctx.t0 = _ctx["catch"](14);
                return _ctx.abrupt("return");
            case 21:
                _ctx.next = 23;
                return (0,io_c3792963.N)(ga.fireTagEvent, "masterclass_registered", {
                    hashed_email: sha256_default()(action.payload.emailId).toString(),
                    user_email: action.payload.emailId,
                    hashed_phone: sha256_default()(((ref = action.payload) === null || ref === void 0 ? void 0 : ref.phoneNumber) || "").toString()
                });
            case 23:
                (0,ga.logEvent)("MasterClass Registered", "NA", "NA");
            case 24:
                _ctx.next = 31;
                break;
            case 26:
                _ctx.prev = 26;
                _ctx.t1 = _ctx["catch"](0);
                console.error(_ctx.t1);
                _ctx.next = 31;
                return (0,io_c3792963.Y)(SemLandingAction/* semPageAction.updateError */.i.updateError("Something went wrong. Please try after sometime"));
            case 31:
            case "end":
                return _ctx.stop();
        }
    }, SemLandingSaga_marked1, null, [
        [
            0,
            26
        ],
        [
            14,
            18
        ]
    ]);
}
function semPageSaga() {
    return runtime_default().wrap(function semPageSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(SemLandingAction/* actionConstant.SEM_PAGE_DETAIL_REQUEST */.L.SEM_PAGE_DETAIL_REQUEST, semDetailsHandler);
            case 2:
                _ctx.next = 4;
                return takeLatest$1(SemLandingAction/* actionConstant.SEM_SAVE_FORM_REQUEST */.L.SEM_SAVE_FORM_REQUEST, saveSemDataHandler);
            case 4:
            case "end":
                return _ctx.stop();
        }
    }, SemLandingSaga_marked);
}
/* harmony default export */ var SemLandingSaga = (semPageSaga);

;// CONCATENATED MODULE: ./components/Ielts/IeltsMasterclassType/redux/MasterClassTypeApi.tsx



// Before Login
var getBeginnerMasterClassData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=v2/workshop/BEGINNER_MASTER_CLASS/0/12");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function getBeginnerMasterClassData() {
        return _ref.apply(this, arguments);
    };
}();
// Before Login
var getClassicMasterClassData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=v2/workshop/MASTER_CLASS/0/20");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function getClassicMasterClassData() {
        return _ref.apply(this, arguments);
    };
}();
var fetchtMasterclassAttendStatus = function() {
    return api/* default.get */.Z.get("/api/scholarRoute?path=ielts-elite/mc/status");
};
var masterclassTypeApi = {
    getBeginnerMasterClassData: getBeginnerMasterClassData,
    getClassicMasterClassData: getClassicMasterClassData,
    fetchtMasterclassAttendStatus: fetchtMasterclassAttendStatus
};

;// CONCATENATED MODULE: ./components/Ielts/IeltsMasterclassType/redux/MasterClassTypeSaga.tsx

var MasterClassTypeSaga_marked = runtime_default().mark(masterclassTypeSaga);
var MasterClassTypeSaga_marked1 = runtime_default().mark(getMasterclassAttendStatusSaga);
var MasterClassTypeSaga_marked2 = runtime_default().mark(getClassicMasterClassDataHandler);
var MasterClassTypeSaga_marked3 = runtime_default().mark(getBeginnerMasterClassDataHandler);






function getBeginnerMasterClassDataHandler(action) {
    var isLogin, res, masterclassData;
    return runtime_default().wrap(function getBeginnerMasterClassDataHandler$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                isLogin = action.payload;
                if (!isLogin) {
                    _ctx.next = 8;
                    break;
                }
                _ctx.next = 5;
                return (0,io_c3792963.N)(masterclassApis.fetchBeginnerMasterclassData);
            case 5:
                _ctx.t0 = _ctx.sent;
                _ctx.next = 11;
                break;
            case 8:
                _ctx.next = 10;
                return (0,io_c3792963.N)(masterclassTypeApi.getBeginnerMasterClassData);
            case 10:
                _ctx.t0 = _ctx.sent;
            case 11:
                res = _ctx.t0;
                if (!res.success) {
                    _ctx.next = 18;
                    break;
                }
                masterclassData = res.data.filter(function(data) {
                    return moment_default()(data.meetingStartTime) > moment_default()();
                });
                _ctx.next = 16;
                return (0,io_c3792963.Y)(MasterClassTypeAction/* masterclassTypeActions.successBeginnerMasterClassData */.G.successBeginnerMasterClassData((0,sortingJson/* sortJSON */.xR)(masterclassData, "meetingStartTime", true)));
            case 16:
                _ctx.next = 20;
                break;
            case 18:
                _ctx.next = 20;
                return (0,io_c3792963.Y)(MasterClassTypeAction/* masterclassTypeActions.updateError */.G.updateError(res.message));
            case 20:
                _ctx.next = 27;
                break;
            case 22:
                _ctx.prev = 22;
                _ctx.t1 = _ctx["catch"](0);
                console.error(_ctx.t1);
                _ctx.next = 27;
                return (0,io_c3792963.Y)(MasterClassTypeAction/* masterclassTypeActions.updateError */.G.updateError("Something went wrong. Please try after sometime"));
            case 27:
            case "end":
                return _ctx.stop();
        }
    }, MasterClassTypeSaga_marked3, null, [
        [
            0,
            22
        ]
    ]);
}
function getClassicMasterClassDataHandler(action) {
    var isLogin, res, masterclassData;
    return runtime_default().wrap(function getClassicMasterClassDataHandler$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                isLogin = action.payload;
                if (!isLogin) {
                    _ctx.next = 8;
                    break;
                }
                _ctx.next = 5;
                return (0,io_c3792963.N)(masterclassApis.fetchMasterclassData);
            case 5:
                _ctx.t0 = _ctx.sent;
                _ctx.next = 11;
                break;
            case 8:
                _ctx.next = 10;
                return (0,io_c3792963.N)(masterclassTypeApi.getClassicMasterClassData);
            case 10:
                _ctx.t0 = _ctx.sent;
            case 11:
                res = _ctx.t0;
                if (!res.success) {
                    _ctx.next = 18;
                    break;
                }
                masterclassData = res.data.filter(function(data) {
                    return moment_default()(data.meetingStartTime) > moment_default()();
                });
                _ctx.next = 16;
                return (0,io_c3792963.Y)(MasterClassTypeAction/* masterclassTypeActions.successClassicMasterClassData */.G.successClassicMasterClassData((0,sortingJson/* sortJSON */.xR)(masterclassData, "meetingStartTime", true)));
            case 16:
                _ctx.next = 20;
                break;
            case 18:
                _ctx.next = 20;
                return (0,io_c3792963.Y)(MasterClassTypeAction/* masterclassTypeActions.updateError */.G.updateError(res.message));
            case 20:
                _ctx.next = 27;
                break;
            case 22:
                _ctx.prev = 22;
                _ctx.t1 = _ctx["catch"](0);
                console.error(_ctx.t1);
                _ctx.next = 27;
                return (0,io_c3792963.Y)(MasterClassTypeAction/* masterclassTypeActions.updateError */.G.updateError("Something went wrong. Please try after sometime"));
            case 27:
            case "end":
                return _ctx.stop();
        }
    }, MasterClassTypeSaga_marked2, null, [
        [
            0,
            22
        ]
    ]);
}
function getMasterclassAttendStatusSaga() {
    var res;
    return runtime_default().wrap(function getMasterclassAttendStatusSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(masterclassTypeApi.fetchtMasterclassAttendStatus);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(MasterClassTypeAction/* masterclassTypeActions.setMasterclassAttendStatusAction */.G.setMasterclassAttendStatusAction(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(MasterClassTypeAction/* masterclassTypeActions.updateError */.G.updateError(res.data.message));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(MasterClassTypeAction/* masterclassTypeActions.updateError */.G.updateError("Something went wrong. Please try after sometime"));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, MasterClassTypeSaga_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function masterclassTypeSaga() {
    return runtime_default().wrap(function masterclassTypeSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(MasterClassTypeAction/* actionConstant.REQUEST_BEGINNER_MASTERCLASS_TYPE_DATA */.L.REQUEST_BEGINNER_MASTERCLASS_TYPE_DATA, getBeginnerMasterClassDataHandler);
            case 2:
                _ctx.next = 4;
                return takeLatest$1(MasterClassTypeAction/* actionConstant.REQUEST_CLASSIC_MASTERCLASS_TYPE_DATA */.L.REQUEST_CLASSIC_MASTERCLASS_TYPE_DATA, getClassicMasterClassDataHandler);
            case 4:
                _ctx.next = 6;
                return takeLatest$1(MasterClassTypeAction/* actionConstant.FETCH_MASTERCLASS_ATTEND_STATUS */.L.FETCH_MASTERCLASS_ATTEND_STATUS, getMasterclassAttendStatusSaga);
            case 6:
            case "end":
                return _ctx.stop();
        }
    }, MasterClassTypeSaga_marked);
}
/* harmony default export */ var MasterClassTypeSaga = (masterclassTypeSaga);

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/JoinMasterClass/redux/joinMasterClassApi.ts



var fetchRegisteredMeetingData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(batchId) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=workshop/attendance/".concat(batchId));
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0 || "Something went wrong. Please refresh the page");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchRegisteredMeetingData(batchId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchIeltsDemoData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(batchId) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=ielts-counselling/attendance/".concat(batchId));
                case 2:
                    return _ctx.abrupt("return", _ctx.sent);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchIeltsDemoData(batchId) {
        return _ref.apply(this, arguments);
    };
}();
var joinMasterClassApi = {
    fetchRegisteredMeetingData: fetchRegisteredMeetingData,
    fetchIeltsDemoData: fetchIeltsDemoData
};

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/JoinMasterClass/redux/joinMasterClassSaga.ts

var joinMasterClassSaga_marked = runtime_default().mark(joinMasterClassSaga);
var joinMasterClassSaga_marked1 = runtime_default().mark(joinMasterClassSaga_fetchIeltsDemoData);
var joinMasterClassSaga_marked2 = runtime_default().mark(joinMasterClassSaga_fetchRegisteredMeetingData);



function joinMasterClassSaga_fetchRegisteredMeetingData(action) {
    var ref, res, ref1, ref2, ref3, ref4;
    return runtime_default().wrap(function fetchRegisteredMeetingData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                ;
                _ctx.next = 4;
                return (0,io_c3792963.N)(joinMasterClassApi.fetchRegisteredMeetingData, action.payload);
            case 4:
                res = _ctx.sent;
                if (!(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                    _ctx.next = 11;
                    break;
                }
                ;
                _ctx.next = 9;
                return (0,io_c3792963.Y)(joinMasterClassActions/* joinMasterClassActions.fetchRegisteredMeetingDataSuccess */.u.fetchRegisteredMeetingDataSuccess(res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.data));
            case 9:
                _ctx.next = 24;
                break;
            case 11:
                ;
                if (!((res === null || res === void 0 ? void 0 : (ref2 = res.data) === null || ref2 === void 0 ? void 0 : ref2.message) === "Not enrolled for master class" || (res === null || res === void 0 ? void 0 : (ref3 = res.data) === null || ref3 === void 0 ? void 0 : ref3.message) === "Not enrolled for this class")) {
                    _ctx.next = 17;
                    break;
                }
                _ctx.next = 15;
                return (0,io_c3792963.Y)(joinMasterClassActions/* joinMasterClassActions.fetchRegisteredMeetingDatafail */.u.fetchRegisteredMeetingDatafail("notEnrolled"));
            case 15:
                _ctx.next = 24;
                break;
            case 17:
                if (!((res === null || res === void 0 ? void 0 : (ref4 = res.data) === null || ref4 === void 0 ? void 0 : ref4.message) === "unable to get response at this moment")) {
                    _ctx.next = 22;
                    break;
                }
                _ctx.next = 20;
                return (0,io_c3792963.Y)(joinMasterClassActions/* joinMasterClassActions.fetchRegisteredMeetingDatafail */.u.fetchRegisteredMeetingDatafail("error"));
            case 20:
                _ctx.next = 24;
                break;
            case 22:
                _ctx.next = 24;
                return (0,io_c3792963.Y)(joinMasterClassActions/* joinMasterClassActions.fetchRegisteredMeetingDatafail */.u.fetchRegisteredMeetingDatafail("ended"));
            case 24:
                _ctx.next = 30;
                break;
            case 26:
                _ctx.prev = 26;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 30;
                return (0,io_c3792963.Y)(joinMasterClassActions/* joinMasterClassActions.fetchRegisteredMeetingDatafail */.u.fetchRegisteredMeetingDatafail("error"));
            case 30:
            case "end":
                return _ctx.stop();
        }
    }, joinMasterClassSaga_marked2, null, [
        [
            0,
            26
        ]
    ]);
}
function joinMasterClassSaga_fetchIeltsDemoData(action) {
    var ref, res, ref1, ref2, ref3, ref4;
    return runtime_default().wrap(function fetchIeltsDemoData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                ;
                _ctx.next = 4;
                return (0,io_c3792963.N)(joinMasterClassApi.fetchIeltsDemoData, action.payload);
            case 4:
                res = _ctx.sent;
                if (!(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                    _ctx.next = 11;
                    break;
                }
                ;
                _ctx.next = 9;
                return (0,io_c3792963.Y)(joinMasterClassActions/* joinMasterClassActions.setIeltsDemoData */.u.setIeltsDemoData(res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.data));
            case 9:
                _ctx.next = 24;
                break;
            case 11:
                ;
                if (!((res === null || res === void 0 ? void 0 : (ref2 = res.data) === null || ref2 === void 0 ? void 0 : ref2.message) === "Not enrolled for master class" || (res === null || res === void 0 ? void 0 : (ref3 = res.data) === null || ref3 === void 0 ? void 0 : ref3.message) === "Not enrolled for this class")) {
                    _ctx.next = 17;
                    break;
                }
                _ctx.next = 15;
                return (0,io_c3792963.Y)(joinMasterClassActions/* joinMasterClassActions.fetchRegisteredMeetingDatafail */.u.fetchRegisteredMeetingDatafail("notEnrolled"));
            case 15:
                _ctx.next = 24;
                break;
            case 17:
                if (!((res === null || res === void 0 ? void 0 : (ref4 = res.data) === null || ref4 === void 0 ? void 0 : ref4.message) === "unable to get response at this moment")) {
                    _ctx.next = 22;
                    break;
                }
                _ctx.next = 20;
                return (0,io_c3792963.Y)(joinMasterClassActions/* joinMasterClassActions.fetchRegisteredMeetingDatafail */.u.fetchRegisteredMeetingDatafail("error"));
            case 20:
                _ctx.next = 24;
                break;
            case 22:
                _ctx.next = 24;
                return (0,io_c3792963.Y)(joinMasterClassActions/* joinMasterClassActions.fetchRegisteredMeetingDatafail */.u.fetchRegisteredMeetingDatafail("ended"));
            case 24:
                _ctx.next = 30;
                break;
            case 26:
                _ctx.prev = 26;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 30;
                return (0,io_c3792963.Y)(joinMasterClassActions/* joinMasterClassActions.fetchRegisteredMeetingDatafail */.u.fetchRegisteredMeetingDatafail("error"));
            case 30:
            case "end":
                return _ctx.stop();
        }
    }, joinMasterClassSaga_marked1, null, [
        [
            0,
            26
        ]
    ]);
}
function joinMasterClassSaga() {
    return runtime_default().wrap(function joinMasterClassSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(joinMasterClassActions/* joinMasterClassType.FETCH_REGISTERED_MEETING_DATA */.t.FETCH_REGISTERED_MEETING_DATA, joinMasterClassSaga_fetchRegisteredMeetingData);
            case 2:
                _ctx.next = 4;
                return takeLatest$1(joinMasterClassActions/* joinMasterClassType.FETCH_IELTS_DEMO_DATA */.t.FETCH_IELTS_DEMO_DATA, joinMasterClassSaga_fetchIeltsDemoData);
            case 4:
            case "end":
                return _ctx.stop();
        }
    }, joinMasterClassSaga_marked);
}
/* harmony default export */ var redux_joinMasterClassSaga = (joinMasterClassSaga);

;// CONCATENATED MODULE: ./components/Ielts/BatchDetails/RequestCallBackForm/redux/RequestcallbackApi.ts




var fetchRequestCallBack = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(formData) {
        var path, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    path = "v2/workshop/callbackDetails";
                    _ctx.next = 4;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=".concat(path), formData);
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    react_toastify_esm/* toast */.Am === null || react_toastify_esm/* toast */.Am === void 0 ? void 0 : react_toastify_esm/* toast.error */.Am.error("Something went wrong. Please try after sometime");
                    return _ctx.abrupt("return", "something went wrong");
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function fetchRequestCallBack(formData) {
        return _ref.apply(this, arguments);
    };
}();
var fetchRequestCallBackStatus = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(userCategory) {
        var path, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    path = "v2/workshop/callback-request/".concat(userCategory, "/status");
                    _ctx.next = 4;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=".concat(path));
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", "something went wrong");
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function fetchRequestCallBackStatus(userCategory) {
        return _ref.apply(this, arguments);
    };
}();
var submitRequestCallback = function(callbackData) {
    return api/* default.post */.Z.post("/api/scholarRoute?path=v2/workshop/callbackDetails", callbackData, {
        headers: {
            "X-API-VERSION": "2"
        }
    });
};
var RequestCallBackApi = {
    fetchRequestCallBack: fetchRequestCallBack,
    fetchRequestCallBackStatus: fetchRequestCallBackStatus,
    submitRequestCallback: submitRequestCallback
};
/* harmony default export */ var RequestcallbackApi = (RequestCallBackApi);

;// CONCATENATED MODULE: ./components/Ielts/BatchDetails/RequestCallBackForm/redux/RequestCallBackFormSaga.ts

var RequestCallBackFormSaga_marked = runtime_default().mark(RequestCbSaga);
var RequestCallBackFormSaga_marked1 = runtime_default().mark(submitCallBackRequestSaga);
var RequestCallBackFormSaga_marked2 = runtime_default().mark(fetchRequestCbStatusSaga);
var RequestCallBackFormSaga_marked3 = runtime_default().mark(fetchRequestCbSaga);



function fetchRequestCbSaga(action) {
    var res;
    return runtime_default().wrap(function fetchRequestCbSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(RequestcallbackApi.fetchRequestCallBack, action.payload);
            case 3:
                res = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)((0,RequestCallBackFormSlice/* savecallBackFormData */.Dn)(action.payload));
            case 6:
                if (!res.success) {
                    _ctx.next = 15;
                    break;
                }
                _ctx.next = 9;
                return (0,io_c3792963.Y)((0,RequestCallBackFormSlice/* fetchRequestCbSuccess */.Lm)());
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)((0,RequestCallBackFormSlice/* toggleRequestCbForm */.K3)(false));
            case 11:
                _ctx.next = 13;
                return (0,io_c3792963.Y)((0,RequestCallBackFormSlice/* toggleRequestCbSucessModal */.cG)(true));
            case 13:
                _ctx.next = 17;
                break;
            case 15:
                _ctx.next = 17;
                return (0,io_c3792963.Y)((0,RequestCallBackFormSlice/* fetchRequestCbFailure */._t)(res.message));
            case 17:
                _ctx.next = 23;
                break;
            case 19:
                _ctx.prev = 19;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 23;
                return (0,io_c3792963.Y)((0,RequestCallBackFormSlice/* fetchRequestCbFailure */._t)("Something went wrong. Please try after sometime"));
            case 23:
            case "end":
                return _ctx.stop();
        }
    }, RequestCallBackFormSaga_marked3, null, [
        [
            0,
            19
        ]
    ]);
}
function fetchRequestCbStatusSaga(action) {
    var res;
    return runtime_default().wrap(function fetchRequestCbStatusSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(RequestcallbackApi.fetchRequestCallBackStatus, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 14;
                    break;
                }
                if (!res.data) {
                    _ctx.next = 10;
                    break;
                }
                _ctx.next = 8;
                return (0,io_c3792963.Y)((0,RequestCallBackFormSlice/* fetchRequestCbStatusSuccess */.Rn)(true));
            case 8:
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)((0,RequestCallBackFormSlice/* fetchRequestCbStatusSuccess */.Rn)(false));
            case 12:
                _ctx.next = 16;
                break;
            case 14:
                _ctx.next = 16;
                return (0,io_c3792963.Y)((0,RequestCallBackFormSlice/* fetchRequestCbStatusFailure */.nw)("Something went wrong. Please try after sometime"));
            case 16:
                _ctx.next = 22;
                break;
            case 18:
                _ctx.prev = 18;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 22;
                return (0,io_c3792963.Y)((0,RequestCallBackFormSlice/* fetchRequestCbStatusFailure */.nw)("Something went wrong. Please try after sometime"));
            case 22:
            case "end":
                return _ctx.stop();
        }
    }, RequestCallBackFormSaga_marked2, null, [
        [
            0,
            18
        ]
    ]);
}
function submitCallBackRequestSaga(action) {
    var res;
    return runtime_default().wrap(function submitCallBackRequestSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(RequestcallbackApi.submitRequestCallback, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)((0,RequestCallBackFormSlice/* setIsFormSubmitted */.yC)(true));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)((0,RequestCallBackFormSlice/* setIsFormSubmitted */.yC)(false));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)((0,RequestCallBackFormSlice/* setIsFormSubmitted */.yC)(false));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, RequestCallBackFormSaga_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function RequestCbSaga() {
    return runtime_default().wrap(function RequestCbSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(RequestCallBackFormSlice/* fetchRequestCbRequested */.vD, fetchRequestCbSaga);
            case 2:
                _ctx.next = 4;
                return takeLatest$1(RequestCallBackFormSlice/* fetchRequestCallBackStatus */.wC, fetchRequestCbStatusSaga);
            case 4:
                _ctx.next = 6;
                return takeLatest$1(RequestCallBackFormSlice/* submitCallBackRequest */.Vm, submitCallBackRequestSaga);
            case 6:
            case "end":
                return _ctx.stop();
        }
    }, RequestCallBackFormSaga_marked);
}
/* harmony default export */ var RequestCallBackFormSaga = (RequestCbSaga);

// EXTERNAL MODULE: ./components/TofuOnbordingForms/redux/Actions.ts
var Actions = __webpack_require__(29999);
// EXTERNAL MODULE: ./components/TofuOnbordingForms/redux/Api.ts
var Api = __webpack_require__(64880);
;// CONCATENATED MODULE: ./components/TofuOnbordingForms/redux/Saga.ts

var Saga_marked = runtime_default().mark(tofuOnbordingSaga);
var Saga_marked1 = runtime_default().mark(fetchSpotCounsellingFromData);



function fetchSpotCounsellingFromData() {
    var res;
    return runtime_default().wrap(function fetchSpotCounsellingFromData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(Api/* tofuOnbordingApis.fetchSpotCounsellingFromData */.I.fetchSpotCounsellingFromData);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(Actions/* tofuObordingActions.fetchSpotCounsellingFromDataSuccess */.a.fetchSpotCounsellingFromDataSuccess(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(Actions/* tofuObordingActions.fetchSpotCounsellingFromDataFail */.a.fetchSpotCounsellingFromDataFail(res));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(Actions/* tofuObordingActions.fetchSpotCounsellingFromDataFail */.a.fetchSpotCounsellingFromDataFail(_ctx.t0.message));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, Saga_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function tofuOnbordingSaga() {
    return runtime_default().wrap(function tofuOnbordingSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("FETCH_SPOT_FORM_DATA", fetchSpotCounsellingFromData);
            case 2:
            case "end":
                return _ctx.stop();
        }
    }, Saga_marked);
}
/* harmony default export */ var Saga = (tofuOnbordingSaga);

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/MockTest/MockTestLandingPage/redux/MockTestPriceApi.ts



function fetchMockTestAutoLogin() {
    return _fetchMockTestAutoLogin.apply(this, arguments);
}
function _fetchMockTestAutoLogin() {
    _fetchMockTestAutoLogin = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=mocktest/tcy/autologin", {
                        headers: {
                            "X-API-VERSION": "1"
                        }
                    });
                case 4:
                    res = _ctx.sent;
                    if (!((ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        success: true,
                        data: res.data.data
                    });
                case 9:
                    return _ctx.abrupt("return", {
                        success: false,
                        data: res.data.message
                    });
                case 10:
                    _ctx.next = 15;
                    break;
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        success: false,
                        data: "Something Went Wrong"
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }));
    return _fetchMockTestAutoLogin.apply(this, arguments);
}
function getMockTestStatus() {
    return _getMockTestStatus.apply(this, arguments);
}
function _getMockTestStatus() {
    _getMockTestStatus = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=fee/cb-mocktest/status", {
                        headers: {
                            "X-API-VERSION": "1"
                        }
                    });
                case 4:
                    res = _ctx.sent;
                    if (!((ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        success: true,
                        data: res.data.data
                    });
                case 9:
                    return _ctx.abrupt("return", {
                        status: false,
                        data: res.data.message
                    });
                case 10:
                    _ctx.next = 15;
                    break;
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        success: false,
                        data: "Something Went Wrong"
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }));
    return _getMockTestStatus.apply(this, arguments);
}
function getTcyBannerStatus() {
    return _getTcyBannerStatus.apply(this, arguments);
}
function _getTcyBannerStatus() {
    _getTcyBannerStatus = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=mocktest/tcy/autologin", {
                        headers: {
                            "X-API-VERSION": "1"
                        }
                    });
                case 4:
                    res = _ctx.sent;
                    if (!((ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        success: true,
                        data: res.data.data
                    });
                case 9:
                    return _ctx.abrupt("return", {
                        status: false,
                        data: res.data.message
                    });
                case 10:
                    _ctx.next = 15;
                    break;
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        success: false,
                        data: "Something Went Wrong"
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }));
    return _getTcyBannerStatus.apply(this, arguments);
}
var MockTestPriceApi = {
    fetchMockTestAutoLogin: fetchMockTestAutoLogin,
    getMockTestStatus: getMockTestStatus,
    getTcyBannerStatus: getTcyBannerStatus
};

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/MockTest/MockTestLandingPage/redux/MockTestPriceSaga.ts

var MockTestPriceSaga_marked = runtime_default().mark(MockTestPriceSaga);
var MockTestPriceSaga_marked1 = runtime_default().mark(getTycBannerDataSaga);
var MockTestPriceSaga_marked2 = runtime_default().mark(getMockTestStatusSaga);
var MockTestPriceSaga_marked3 = runtime_default().mark(fetchMockTestAutoLoginSaga);




function fetchMockTestAutoLoginSaga() {
    var res, ref, ref1, ref2;
    return runtime_default().wrap(function fetchMockTestAutoLoginSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(MockTestPriceApi.fetchMockTestAutoLogin);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 8;
                    break;
                }
                {
                    ;
                    (0,MockTestPriceSlice/* setAutoLoginUrl */.Fc)((ref = res.data) === null || ref === void 0 ? void 0 : ref.autologinUrl);
                    ((ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.autologinUrl) ? window.open((ref2 = res.data) === null || ref2 === void 0 ? void 0 : ref2.autologinUrl) : react_toastify_esm/* toast.error */.Am.error("Something went wrong. Please try after some time");
                }
                _ctx.next = 10;
                break;
            case 8:
                _ctx.next = 10;
                return (0,io_c3792963.Y)((0,MockTestPriceSlice/* setReserveSeatErrorMessage */.Bp)("something went wrong"));
            case 10:
                _ctx.next = 16;
                break;
            case 12:
                _ctx.prev = 12;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 16;
                return (0,io_c3792963.Y)((0,MockTestPriceSlice/* setReserveSeatErrorMessage */.Bp)("something went wrong"));
            case 16:
            case "end":
                return _ctx.stop();
        }
    }, MockTestPriceSaga_marked3, null, [
        [
            0,
            12
        ]
    ]);
}
function getMockTestStatusSaga() {
    var res, ref, ref1, ref2;
    return runtime_default().wrap(function getMockTestStatusSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.Y)((0,MockTestPriceSlice/* setCtaText */.q_)("Loading"));
            case 3:
                _ctx.next = 5;
                return (0,io_c3792963.Y)((0,MockTestPriceSlice/* setReserveSeatLoading */.OX)(true));
            case 5:
                _ctx.next = 7;
                return (0,io_c3792963.N)(MockTestPriceApi.getMockTestStatus);
            case 7:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 30;
                    break;
                }
                ;
                _ctx.next = 12;
                return (0,io_c3792963.Y)((0,MockTestPriceSlice/* setReserveSeatLoading */.OX)(false));
            case 12:
                _ctx.next = 14;
                return (0,io_c3792963.Y)((0,MockTestPriceSlice/* setTcyMocktestStatus */.IC)(res.data));
            case 14:
                if (!((ref = res.data) === null || ref === void 0 ? void 0 : ref.alreadyPaid)) {
                    _ctx.next = 21;
                    break;
                }
                _ctx.next = 17;
                return (0,io_c3792963.Y)((0,MockTestPriceSlice/* setCtaText */.q_)("Go to Test"));
            case 17:
                _ctx.next = 19;
                return (0,io_c3792963.Y)((0,MockTestPriceSlice/* setReserveSeat */.GQ)(true));
            case 19:
                _ctx.next = 28;
                break;
            case 21:
                ;
                _ctx.next = 24;
                return (0,io_c3792963.Y)((0,MockTestPriceSlice/* setCtaText */.q_)("Buy Now ₹ ".concat((ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.offerPrice, "/-")));
            case 24:
                _ctx.next = 26;
                return (0,io_c3792963.Y)((0,MockTestPriceSlice/* setMockTestPrice */.Fg)((ref2 = res.data) === null || ref2 === void 0 ? void 0 : ref2.offerPrice));
            case 26:
                _ctx.next = 28;
                return (0,io_c3792963.Y)((0,MockTestPriceSlice/* setReserveSeat */.GQ)(false));
            case 28:
                _ctx.next = 34;
                break;
            case 30:
                _ctx.next = 32;
                return (0,io_c3792963.Y)((0,MockTestPriceSlice/* setCtaText */.q_)("Buy Now"));
            case 32:
                _ctx.next = 34;
                return (0,io_c3792963.Y)((0,MockTestPriceSlice/* setReserveSeatLoading */.OX)(false));
            case 34:
                _ctx.next = 44;
                break;
            case 36:
                _ctx.prev = 36;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 40;
                return (0,io_c3792963.Y)((0,MockTestPriceSlice/* setCtaText */.q_)("Buy Now"));
            case 40:
                _ctx.next = 42;
                return (0,io_c3792963.Y)((0,MockTestPriceSlice/* setReserveSeatLoading */.OX)(false));
            case 42:
                _ctx.next = 44;
                return (0,io_c3792963.Y)((0,MockTestPriceSlice/* setReserveSeatErrorMessage */.Bp)("something went wrong"));
            case 44:
            case "end":
                return _ctx.stop();
        }
    }, MockTestPriceSaga_marked2, null, [
        [
            0,
            36
        ]
    ]);
}
function getTycBannerDataSaga() {
    var res;
    return runtime_default().wrap(function getTycBannerDataSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.Y)((0,MockTestPriceSlice/* setReserveSeatLoading */.OX)(true));
            case 3:
                _ctx.next = 5;
                return (0,io_c3792963.N)(MockTestPriceApi.getTcyBannerStatus);
            case 5:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 11;
                    break;
                }
                _ctx.next = 9;
                return (0,io_c3792963.Y)((0,MockTestPriceSlice/* setTycBannerData */.E1)(res.data));
            case 9:
                _ctx.next = 13;
                break;
            case 11:
                _ctx.next = 13;
                return (0,io_c3792963.Y)((0,MockTestPriceSlice/* setReserveSeatErrorMessage */.Bp)(res.data));
            case 13:
                _ctx.next = 19;
                break;
            case 15:
                _ctx.prev = 15;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 19;
                return (0,io_c3792963.Y)((0,MockTestPriceSlice/* setReserveSeatErrorMessage */.Bp)("something went wrong"));
            case 19:
                _ctx.prev = 19;
                _ctx.next = 22;
                return (0,io_c3792963.Y)((0,MockTestPriceSlice/* setReserveSeatLoading */.OX)(false));
            case 22:
                return _ctx.finish(19);
            case 23:
            case "end":
                return _ctx.stop();
        }
    }, MockTestPriceSaga_marked1, null, [
        [
            0,
            15,
            19,
            23
        ]
    ]);
}
function MockTestPriceSaga() {
    return runtime_default().wrap(function MockTestPriceSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(MockTestPriceSlice/* fetchMockTestAutoLogin */.tZ, fetchMockTestAutoLoginSaga);
            case 2:
                _ctx.next = 4;
                return takeLatest$1(MockTestPriceSlice/* fetchMockTestStatus */.Jp, getMockTestStatusSaga);
            case 4:
                _ctx.next = 6;
                return takeLatest$1(MockTestPriceSlice/* fetchTcyMockTestBannerDetailsAction */.Cg, getTycBannerDataSaga);
            case 6:
            case "end":
                return _ctx.stop();
        }
    }, MockTestPriceSaga_marked);
}
/* harmony default export */ var redux_MockTestPriceSaga = (MockTestPriceSaga);

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/IeltsPlus/SchedulePage/redux/schedulePageApi.ts




var fetchSetReminderApi = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var batchId, day, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    batchId = param.batchId, day = param.day;
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=v2/workshop/reminder/batchClass", {
                        batchId: batchId,
                        day: day
                    });
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](1);
                    react_toastify_esm/* toast.error */.Am.error("Something went wrong. Please try after sometime");
                    return _ctx.abrupt("return", {
                        success: false,
                        message: "something went wrong"
                    });
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                8
            ]
        ]);
    }));
    return function fetchSetReminderApi(_) {
        return _ref.apply(this, arguments);
    };
}();
var schedulePageApis = {
    fetchSetReminderApi: fetchSetReminderApi
};

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/IeltsPlus/SchedulePage/redux/schedulePageSaga.ts

var schedulePageSaga_marked = runtime_default().mark(SchedulePageSaga);
var schedulePageSaga_marked1 = runtime_default().mark(fetchsetReminderSaga);




function fetchsetReminderSaga(action) {
    var res;
    return runtime_default().wrap(function fetchsetReminderSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return (0,io_c3792963.Y)((0,schedulePageSlice/* fetchSetReminderRequest */.a1)());
            case 2:
                _ctx.prev = 2;
                _ctx.next = 5;
                return (0,io_c3792963.N)(schedulePageApis.fetchSetReminderApi, action.payload);
            case 5:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 11;
                    break;
                }
                _ctx.next = 9;
                return (0,io_c3792963.Y)((0,schedulePageSlice/* fetchSetReminderSuccess */.X8)());
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(IeltsPlusActions/* ieltsPlusActions.fetchEnrolledBatches */.P.fetchEnrolledBatches());
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](2);
                _ctx.next = 17;
                return (0,io_c3792963.Y)((0,schedulePageSlice/* fetchSetReminderFailure */.H8)());
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, schedulePageSaga_marked1, null, [
        [
            2,
            13
        ]
    ]);
}
function SchedulePageSaga() {
    return runtime_default().wrap(function SchedulePageSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(schedulePageSlice/* fetchSetReminder */.pA, fetchsetReminderSaga);
            case 2:
            case "end":
                return _ctx.stop();
        }
    }, schedulePageSaga_marked);
}
/* harmony default export */ var schedulePageSaga = (SchedulePageSaga);

// EXTERNAL MODULE: ./components/CounsellingCommunity/redux/CommunityAction.ts
var CommunityAction = __webpack_require__(38170);
;// CONCATENATED MODULE: ./components/CounsellingCommunity/redux/CommunityApis.ts



var fetchUserDataAndToken = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=community/generate/token");
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    return _ctx.abrupt("return", false);
                case 9:
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchUserDataAndToken() {
        return _ref.apply(this, arguments);
    };
}();
var communityApi = {
    fetchUserDataAndToken: fetchUserDataAndToken
};

;// CONCATENATED MODULE: ./components/CounsellingCommunity/redux/CommunitySaga.ts

var CommunitySaga_marked = runtime_default().mark(CommunitySaga);
var CommunitySaga_marked1 = runtime_default().mark(getUserDateAndToken);




function getUserDateAndToken() {
    var res;
    return runtime_default().wrap(function getUserDateAndToken$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(communityApi.fetchUserDataAndToken);
            case 3:
                res = _ctx.sent;
                if (!res) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(CommunityAction/* communityAction.fetchUserGetSocialTokenSuccess */.N.fetchUserGetSocialTokenSuccess(res));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(CommunityAction/* communityAction.fetchUserGetSocialTokenFail */.N.fetchUserGetSocialTokenFail("Something went wrong. redirecting you to profile page"));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)(CommunityAction/* communityAction.fetchUserGetSocialTokenFail */.N.fetchUserGetSocialTokenFail("Something went wrong. redirecting you to profile page"));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, CommunitySaga_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function CommunitySaga() {
    return runtime_default().wrap(function CommunitySaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(CommunityConstants/* default.FETCH_USER_GETSOCIAL_TOKEN */.Z.FETCH_USER_GETSOCIAL_TOKEN, getUserDateAndToken);
            case 2:
            case "end":
                return _ctx.stop();
        }
    }, CommunitySaga_marked);
}
/* harmony default export */ var redux_CommunitySaga = (CommunitySaga);

;// CONCATENATED MODULE: ./components/Profile/AndroidApp/redux/PractiseApi.tsx



var fetchPracticeTabApi = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.get */.Z.get("/api/scholarRoute?path=practise/view");
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log("err", _ctx.t0);
                    return _ctx.abrupt("return", null);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchPracticeTabApi() {
        return _ref.apply(this, arguments);
    };
}();
var fetchUpdateVideoCompletion = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(videoId) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api/* default.put */.Z.put("/api/scholarRoute?path=practise/user/watched/video/".concat(videoId));
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0, "error");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchUpdateVideoCompletion(videoId) {
        return _ref.apply(this, arguments);
    };
}();
var androidApis = {
    fetchPracticeTabApi: fetchPracticeTabApi,
    fetchUpdateVideoCompletion: fetchUpdateVideoCompletion
};

;// CONCATENATED MODULE: ./components/Profile/AndroidApp/redux/PractiseAppSaga.tsx

var PractiseAppSaga_marked = runtime_default().mark(fetchUpdateVideoCompletionSaga);
var PractiseAppSaga_marked1 = runtime_default().mark(fetchPracticeTabSaga);



function fetchPracticeTabSaga() {
    var res;
    return runtime_default().wrap(function fetchPracticeTabSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(androidApis.fetchPracticeTabApi);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)((0,PractiseAppSlice/* setPractiseData */.wP)(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)((0,PractiseAppSlice/* setPractiseError */.lg)("failed"));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)((0,PractiseAppSlice/* setPractiseError */.lg)("Something went wrong!"));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, PractiseAppSaga_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function fetchUpdateVideoCompletionSaga(action) {
    var res;
    return runtime_default().wrap(function fetchUpdateVideoCompletionSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                (0,PractiseAppSlice/* setUpdateVideoCompletionLoading */.wC)(true);
                _ctx.next = 4;
                return (0,io_c3792963.N)(androidApis.fetchUpdateVideoCompletion, action.payload);
            case 4:
                res = _ctx.sent;
                if (res.success) {
                    (0,PractiseAppSlice/* setUpdateVideoCompletionLoading */.wC)(false);
                // setUpdateVideoCompletionSuccess(true);
                } else {
                    (0,PractiseAppSlice/* setUpdateVideoCompletionError */.DX)("Something went wrong please try again later");
                    (0,PractiseAppSlice/* setUpdateVideoCompletionLoading */.wC)(false);
                }
                _ctx.next = 12;
                break;
            case 8:
                _ctx.prev = 8;
                _ctx.t0 = _ctx["catch"](0);
                (0,PractiseAppSlice/* setUpdateVideoCompletionError */.DX)("Something went wrong please try again later");
                (0,PractiseAppSlice/* setUpdateVideoCompletionLoading */.wC)(false);
            case 12:
            case "end":
                return _ctx.stop();
        }
    }, PractiseAppSaga_marked, null, [
        [
            0,
            8
        ]
    ]);
}
function practiseAppSaga() {
    return runtime_default().wrap(function practiseAppSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(PractiseAppSlice/* fetchPracticeTabData */.Uk, fetchPracticeTabSaga);
            case 2:
                _ctx.next = 4;
                return takeLatest$1(PractiseAppSlice/* fetchUpdateVideoCompletionAction */.b2, fetchUpdateVideoCompletionSaga);
            case 4:
            case "end":
                return _ctx.stop();
        }
    }, practiseAppSaga);
};

;// CONCATENATED MODULE: ./components/NeedHelpV1/redux/NeedHelpApis.ts



var zohoRecord = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
        var ref, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return api/* default.post */.Z.post("/api/scholarRoute?path=user/zoho-record", data);
                case 4:
                    res = _ctx.sent;
                    if (!(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        success: true,
                        payload: res.data.data
                    });
                case 7:
                    return _ctx.abrupt("return", {
                        success: false,
                        payload: res.data.message
                    });
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error("Something went wrong. Please refresh the page");
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }));
    return function zohoRecord(data) {
        return _ref.apply(this, arguments);
    };
}();
var NeedHelpApis = {
    zohoRecord: zohoRecord
};

;// CONCATENATED MODULE: ./components/NeedHelpV1/redux/NeedHelpSaga.ts

var NeedHelpSaga_marked = runtime_default().mark(NeedHelpSaga);
var NeedHelpSaga_marked1 = runtime_default().mark(NeedHelpSaga_zohoRecord);



function NeedHelpSaga_zohoRecord(action) {
    var res;
    return runtime_default().wrap(function zohoRecord$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(NeedHelpApis.zohoRecord, action.payload);
            case 3:
                res = _ctx.sent;
                if (!(res === null || res === void 0 ? void 0 : res.success)) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)({
                    type: NeedHelpActions/* chatActionsConstants.QUERY_RAISE_API_SUCCESS */.Y.QUERY_RAISE_API_SUCCESS
                });
            case 7:
                _ctx.next = 10;
                break;
            case 9:
                throw Error("Something Went Wrong While Raising Query!!");
            case 10:
                _ctx.next = 16;
                break;
            case 12:
                _ctx.prev = 12;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 16;
                return (0,io_c3792963.Y)({
                    type: NeedHelpActions/* chatActionsConstants.QUERY_RAISE_API_ERROR */.Y.QUERY_RAISE_API_ERROR
                });
            case 16:
            case "end":
                return _ctx.stop();
        }
    }, NeedHelpSaga_marked1, null, [
        [
            0,
            12
        ]
    ]);
}
function NeedHelpSaga() {
    return runtime_default().wrap(function NeedHelpSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(NeedHelpActions/* chatActionsConstants.QUERY_RAISE_API */.Y.QUERY_RAISE_API, NeedHelpSaga_zohoRecord);
            case 2:
            case "end":
                return _ctx.stop();
        }
    }, NeedHelpSaga_marked);
}
/* harmony default export */ var redux_NeedHelpSaga = (NeedHelpSaga);

;// CONCATENATED MODULE: ./components/Profile/AndroidApp/PractiseTab/WordOfTheDay/redux/WordOfTheDayApi.tsx



var fetchGetWordOfTheDay = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var path, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    path = "/api/scholarRoute?path=wotd/get/word_of_the_day";
                    _ctx.next = 4;
                    return api/* default.get */.Z.get(path);
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        success: false,
                        data: null
                    });
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function fetchGetWordOfTheDay() {
        return _ref.apply(this, arguments);
    };
}();
var fetchPostLike = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(wordOfTheDayId) {
        var path, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    path = "/api/scholarRoute?path=wotd/update/like/".concat(wordOfTheDayId);
                    _ctx.next = 4;
                    return api/* default.post */.Z.post(path);
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        success: false,
                        data: null
                    });
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function fetchPostLike(wordOfTheDayId) {
        return _ref.apply(this, arguments);
    };
}();
var wordOfTheDayApis = {
    fetchGetWordOfTheDay: fetchGetWordOfTheDay,
    fetchPostLike: fetchPostLike
};

;// CONCATENATED MODULE: ./components/Profile/AndroidApp/PractiseTab/WordOfTheDay/redux/WordOfTheDaySaga.tsx

var WordOfTheDaySaga_marked = runtime_default().mark(fetchPostLikeSaga);
var WordOfTheDaySaga_marked1 = runtime_default().mark(fetchGetWordOfTheDaySaga);



function fetchGetWordOfTheDaySaga() {
    var res, ref, ref1, ref2, ref3;
    return runtime_default().wrap(function fetchGetWordOfTheDaySaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return (0,io_c3792963.Y)((0,WordOfTheDaySlice/* setWordOfTheDayLoading */.ln)(true));
            case 2:
                _ctx.prev = 2;
                _ctx.next = 5;
                return (0,io_c3792963.N)(wordOfTheDayApis.fetchGetWordOfTheDay);
            case 5:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 22;
                    break;
                }
                ;
                _ctx.next = 10;
                return (0,io_c3792963.Y)((0,WordOfTheDaySlice/* setWordOfTheDayData */.qf)(res.data));
            case 10:
                if (!(((ref = res.data) === null || ref === void 0 ? void 0 : ref.totalLikes) !== undefined)) {
                    _ctx.next = 14;
                    break;
                }
                ;
                _ctx.next = 14;
                return (0,io_c3792963.Y)((0,WordOfTheDaySlice/* setWordLikeCount */.KW)((ref2 = res.data) === null || ref2 === void 0 ? void 0 : ref2.totalLikes));
            case 14:
                if (!((ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.userLikeStatus)) {
                    _ctx.next = 18;
                    break;
                }
                ;
                _ctx.next = 18;
                return (0,io_c3792963.Y)((0,WordOfTheDaySlice/* setUserLikeStatus */.vI)((ref3 = res.data) === null || ref3 === void 0 ? void 0 : ref3.userLikeStatus));
            case 18:
                _ctx.next = 20;
                return (0,io_c3792963.Y)((0,WordOfTheDaySlice/* setWordOfTheDayLoading */.ln)(false));
            case 20:
                _ctx.next = 24;
                break;
            case 22:
                _ctx.next = 24;
                return (0,io_c3792963.Y)((0,WordOfTheDaySlice/* setWordOfTheDayError */.JO)("Something went wrong Please try after some time"));
            case 24:
                _ctx.next = 32;
                break;
            case 26:
                _ctx.prev = 26;
                _ctx.t0 = _ctx["catch"](2);
                _ctx.next = 30;
                return (0,io_c3792963.Y)((0,WordOfTheDaySlice/* setWordOfTheDayLoading */.ln)(false));
            case 30:
                _ctx.next = 32;
                return (0,io_c3792963.Y)((0,WordOfTheDaySlice/* setWordOfTheDayError */.JO)("Something went wrong Please try after some time"));
            case 32:
            case "end":
                return _ctx.stop();
        }
    }, WordOfTheDaySaga_marked1, null, [
        [
            2,
            26
        ]
    ]);
}
function fetchPostLikeSaga(action) {
    var res, wordOfTheDaystate;
    return runtime_default().wrap(function fetchPostLikeSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(wordOfTheDayApis.fetchPostLike, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 12;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)((0,WordOfTheDaySlice/* setUserLikeStatus */.vI)(true));
            case 7:
                _ctx.next = 9;
                return (0,io_c3792963.a3)(function(state) {
                    return state.WordOfTheDay;
                });
            case 9:
                wordOfTheDaystate = _ctx.sent;
                _ctx.next = 12;
                return (0,io_c3792963.Y)((0,WordOfTheDaySlice/* setWordLikeCount */.KW)(wordOfTheDaystate.wordLikeCount + 1));
            case 12:
                _ctx.next = 16;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
            case 16:
            case "end":
                return _ctx.stop();
        }
    }, WordOfTheDaySaga_marked, null, [
        [
            0,
            14
        ]
    ]);
}
function wordOfTheDaySaga() {
    return runtime_default().wrap(function wordOfTheDaySaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(WordOfTheDaySlice/* fetchGetWordOfTheDay */.$8, fetchGetWordOfTheDaySaga);
            case 2:
                _ctx.next = 4;
                return takeLatest$1(WordOfTheDaySlice/* fetchPostWordLike */.rB, fetchPostLikeSaga);
            case 4:
            case "end":
                return _ctx.stop();
        }
    }, wordOfTheDaySaga);
};

// EXTERNAL MODULE: ./components/Profile/IeltsProfile/TestPrep/redux/TestPrepApi.ts
var TestPrepApi = __webpack_require__(68515);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/TestPrep/redux/TestPrepSaga.ts

var TestPrepSaga_marked = runtime_default().mark(testPrepSaga);
var TestPrepSaga_marked1 = runtime_default().mark(fetchLiyMocktestDashboardSaga);
var TestPrepSaga_marked2 = runtime_default().mark(fetchFLSEFeedbackSaga);
var TestPrepSaga_marked3 = runtime_default().mark(postWritingExamPreferenceSaga);
var TestPrepSaga_marked4 = runtime_default().mark(fetchPracticeTestsSaga);
var TestPrepSaga_marked5 = runtime_default().mark(fetchSelfPrepBaughtStatusSaga);
var TestPrepSaga_marked6 = runtime_default().mark(fetchMocktestResultSaga);
var TestPrepSaga_marked7 = runtime_default().mark(fetchGetDaignosticTestsSaga);
var TestPrepSaga_marked8 = runtime_default().mark(saveIeltsForm);
var TestPrepSaga_marked9 = runtime_default().mark(fetchMockTestPriceSaga);
var TestPrepSaga_marked10 = runtime_default().mark(fetchMockTestModalSaga);
var TestPrepSaga_marked11 = runtime_default().mark(fetchMockTestSaga);
var TestPrepSaga_marked12 = runtime_default().mark(fetchMockTestListSaga);





function fetchMockTestListSaga(action) {
    var res;
    return runtime_default().wrap(function fetchMockTestListSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTestIsLoading */.IQ)(true));
            case 3:
                _ctx.next = 5;
                return (0,io_c3792963.N)(TestPrepApi/* TestPrepApi.fetchMockTestList */.F.fetchMockTestList, action.payload);
            case 5:
                res = _ctx.sent;
                _ctx.next = 8;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTestIsLoading */.IQ)(false));
            case 8:
                if (!res.data.success) {
                    _ctx.next = 13;
                    break;
                }
                _ctx.next = 11;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTestList */.rI)(res.data.data));
            case 11:
                _ctx.next = 15;
                break;
            case 13:
                _ctx.next = 15;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTestError */.u5)("something went wrong"));
            case 15:
                _ctx.next = 23;
                break;
            case 17:
                _ctx.prev = 17;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 21;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTestIsLoading */.IQ)(false));
            case 21:
                _ctx.next = 23;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTestError */.u5)("something went wrong"));
            case 23:
            case "end":
                return _ctx.stop();
        }
    }, TestPrepSaga_marked12, null, [
        [
            0,
            17
        ]
    ]);
}
function fetchMockTestSaga(action) {
    var res;
    return runtime_default().wrap(function fetchMockTestSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTestIsLoading */.IQ)(true));
            case 3:
                _ctx.next = 5;
                return (0,io_c3792963.N)(TestPrepApi/* TestPrepApi.fetchMockTest */.F.fetchMockTest, action.payload);
            case 5:
                res = _ctx.sent;
                _ctx.next = 8;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTestIsLoading */.IQ)(false));
            case 8:
                if (!(res.data.success && res.data.data)) {
                    _ctx.next = 13;
                    break;
                }
                _ctx.next = 11;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTest */.dO)(res.data.data));
            case 11:
                _ctx.next = 15;
                break;
            case 13:
                _ctx.next = 15;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTestError */.u5)("something went wrong while fetching  mock test data please try after some time"));
            case 15:
                _ctx.next = 17;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTestIsLoading */.IQ)(false));
            case 17:
                _ctx.next = 25;
                break;
            case 19:
                _ctx.prev = 19;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 23;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTestIsLoading */.IQ)(false));
            case 23:
                _ctx.next = 25;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTestError */.u5)("something went wrong while fetching  mock test data please try after some time"));
            case 25:
            case "end":
                return _ctx.stop();
        }
    }, TestPrepSaga_marked11, null, [
        [
            0,
            19
        ]
    ]);
}
function fetchMockTestModalSaga() {
    var ref, res;
    return runtime_default().wrap(function fetchMockTestModalSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                ;
                _ctx.next = 4;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTestIsLoading */.IQ)(true));
            case 4:
                _ctx.next = 6;
                return (0,io_c3792963.N)(TestPrepApi/* TestPrepApi.fetchModalDataCms */.F.fetchModalDataCms);
            case 6:
                res = _ctx.sent;
                _ctx.next = 9;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTestIsLoading */.IQ)(false));
            case 9:
                if (!((res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.length) > 0)) {
                    _ctx.next = 14;
                    break;
                }
                _ctx.next = 12;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMocktestModalData */.H)(res === null || res === void 0 ? void 0 : res.data[0]));
            case 12:
                _ctx.next = 16;
                break;
            case 14:
                _ctx.next = 16;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTestError */.u5)("something went wrong"));
            case 16:
                _ctx.next = 24;
                break;
            case 18:
                _ctx.prev = 18;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 22;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTestIsLoading */.IQ)(false));
            case 22:
                _ctx.next = 24;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTestError */.u5)("something went wrong"));
            case 24:
            case "end":
                return _ctx.stop();
        }
    }, TestPrepSaga_marked10, null, [
        [
            0,
            18
        ]
    ]);
}
function fetchMockTestPriceSaga() {
    var ref, res, ref1;
    return runtime_default().wrap(function fetchMockTestPriceSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                ;
                _ctx.next = 4;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTestIsLoading */.IQ)(true));
            case 4:
                _ctx.next = 6;
                return (0,io_c3792963.N)(TestPrepApi/* TestPrepApi.fetchMocktestPrice */.F.fetchMocktestPrice);
            case 6:
                res = _ctx.sent;
                _ctx.next = 9;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTestIsLoading */.IQ)(false));
            case 9:
                if (!(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                    _ctx.next = 15;
                    break;
                }
                ;
                _ctx.next = 13;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setUnlockPrice */.wl)(res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.data));
            case 13:
                _ctx.next = 17;
                break;
            case 15:
                _ctx.next = 17;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTestError */.u5)("something went wrong"));
            case 17:
                _ctx.next = 25;
                break;
            case 19:
                _ctx.prev = 19;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 23;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTestIsLoading */.IQ)(false));
            case 23:
                _ctx.next = 25;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTestError */.u5)("something went wrong"));
            case 25:
            case "end":
                return _ctx.stop();
        }
    }, TestPrepSaga_marked9, null, [
        [
            0,
            19
        ]
    ]);
}
function saveIeltsForm(action) {
    var res;
    return runtime_default().wrap(function saveIeltsForm$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(IeltsRegistrationFormApi/* ieltsRegistrationFormApi.saveForm */.R.saveForm, action.payload);
            case 3:
                res = _ctx.sent;
                if (!(res === null || res === void 0 ? void 0 : res.success)) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setInitiatePayment */.DB)(true));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTestError */.u5)("something went wrong"));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTestError */.u5)("something went wrong"));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, TestPrepSaga_marked8, null, [
        [
            0,
            13
        ]
    ]);
}
function fetchGetDaignosticTestsSaga() {
    var ref, res, ref1;
    return runtime_default().wrap(function fetchGetDaignosticTestsSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                ;
                _ctx.next = 4;
                return (0,io_c3792963.N)(TestPrepApi/* TestPrepApi.fetchGetDaignosticTests */.F.fetchGetDaignosticTests);
            case 4:
                res = _ctx.sent;
                if (!((ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                    _ctx.next = 11;
                    break;
                }
                ;
                _ctx.next = 9;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setDaignosticTests */.Gl)((ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.data));
            case 9:
                _ctx.next = 13;
                break;
            case 11:
                _ctx.next = 13;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setDaignosticTestsError */.xs)(true));
            case 13:
                _ctx.next = 19;
                break;
            case 15:
                _ctx.prev = 15;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 19;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setDaignosticTestsError */.xs)(true));
            case 19:
            case "end":
                return _ctx.stop();
        }
    }, TestPrepSaga_marked7, null, [
        [
            0,
            15
        ]
    ]);
}
function fetchMocktestResultSaga(action) {
    var ref, res;
    return runtime_default().wrap(function fetchMocktestResultSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                ;
                _ctx.next = 4;
                return (0,io_c3792963.N)(TestPrepApi/* TestPrepApi.fetchMockTestResult */.F.fetchMockTestResult, action.payload);
            case 4:
                res = _ctx.sent;
                if (!((ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                    _ctx.next = 10;
                    break;
                }
                _ctx.next = 8;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setExamResult */.Gk)(res.data.data));
            case 8:
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setExamResult */.Gk)(null));
            case 12:
                _ctx.next = 18;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setExamResult */.Gk)(null));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, TestPrepSaga_marked6, null, [
        [
            0,
            14
        ]
    ]);
}
function fetchSelfPrepBaughtStatusSaga() {
    var ref, res;
    return runtime_default().wrap(function fetchSelfPrepBaughtStatusSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                ;
                _ctx.next = 4;
                return (0,io_c3792963.N)(TestPrepApi/* TestPrepApi.fetchSelfPrepBaughtStatus */.F.fetchSelfPrepBaughtStatus);
            case 4:
                res = _ctx.sent;
                if (!((ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                    _ctx.next = 10;
                    break;
                }
                _ctx.next = 8;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setSelfPrepBaughtData */.VD)(res.data.data));
            case 8:
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setSelfPrepBaughtData */.VD)(null));
            case 12:
                _ctx.next = 18;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setSelfPrepBaughtData */.VD)(null));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, TestPrepSaga_marked5, null, [
        [
            0,
            14
        ]
    ]);
}
function fetchPracticeTestsSaga() {
    var ref, res;
    return runtime_default().wrap(function fetchPracticeTestsSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                ;
                _ctx.next = 4;
                return (0,io_c3792963.N)(TestPrepApi/* TestPrepApi.fetchMockTestsCredits */.F.fetchMockTestsCredits);
            case 4:
                res = _ctx.sent;
                if (!(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                    _ctx.next = 10;
                    break;
                }
                _ctx.next = 8;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setPracticeTests */.lf)(res.data.data));
            case 8:
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTestError */.u5)("something went wrong"));
            case 12:
                _ctx.next = 18;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTestError */.u5)("something went wrong"));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, TestPrepSaga_marked4, null, [
        [
            0,
            14
        ]
    ]);
}
function postWritingExamPreferenceSaga(action) {
    var ref, res;
    return runtime_default().wrap(function postWritingExamPreferenceSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                ;
                _ctx.next = 4;
                return (0,io_c3792963.N)(TestPrepApi/* TestPrepApi.postWritingExamPreferenceApi */.F.postWritingExamPreferenceApi, action.payload);
            case 4:
                res = _ctx.sent;
                if (!((ref = res.data) === null || ref === void 0 ? void 0 : ref.success)) {
                    _ctx.next = 10;
                    break;
                }
                _ctx.next = 8;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setSubmittedExamPref */._y)(res.data.success));
            case 8:
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setSubmittedExamPref */._y)(false));
            case 12:
                _ctx.next = 18;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setSubmittedExamPref */._y)(false));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, TestPrepSaga_marked3, null, [
        [
            0,
            14
        ]
    ]);
}
function fetchFLSEFeedbackSaga() {
    var res;
    return runtime_default().wrap(function fetchFLSEFeedbackSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(speakingClubApi.getUserFeedbackApi);
            case 3:
                res = _ctx.sent;
                if (!res) {
                    _ctx.next = 10;
                    break;
                }
                if (!(res.length > 0)) {
                    _ctx.next = 8;
                    break;
                }
                _ctx.next = 8;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setShowFLSEFeedback */.oK)(true));
            case 8:
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTestError */.u5)("something went wrong"));
            case 12:
                _ctx.next = 18;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setMockTestError */.u5)("something went wrong"));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, TestPrepSaga_marked2, null, [
        [
            0,
            14
        ]
    ]);
}
function fetchLiyMocktestDashboardSaga() {
    var res;
    return runtime_default().wrap(function fetchLiyMocktestDashboardSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(TestPrepApi/* TestPrepApi.fetchLiyMocktestDashboard */.F.fetchLiyMocktestDashboard);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setLiyMocktestDashboard */.Xu)(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setLiyMocktestDashboard */.Xu)(null));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)((0,TestPrepSlice/* setLiyMocktestDashboard */.Xu)(null));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, TestPrepSaga_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function testPrepSaga() {
    return runtime_default().wrap(function testPrepSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(TestPrepSlice/* fetchMockTestList */.qc, fetchMockTestListSaga);
            case 2:
                _ctx.next = 4;
                return takeLatest$1(TestPrepSlice/* fetchMockTest */.m5, fetchMockTestSaga);
            case 4:
                _ctx.next = 6;
                return takeLatest$1(TestPrepSlice/* fetchMockTestModal */.au, fetchMockTestModalSaga);
            case 6:
                _ctx.next = 8;
                return takeLatest$1(TestPrepSlice/* fetchMockTestPrice */.br, fetchMockTestPriceSaga);
            case 8:
                _ctx.next = 10;
                return takeLatest$1(TestPrepSlice/* saveForm */.kh, saveIeltsForm);
            case 10:
                _ctx.next = 12;
                return takeLatest$1(TestPrepSlice/* fetchGetDaignosticTests */.go, fetchGetDaignosticTestsSaga);
            case 12:
                _ctx.next = 14;
                return takeLatest$1(TestPrepSlice/* fetchMocktestResult */.h2, fetchMocktestResultSaga);
            case 14:
                _ctx.next = 16;
                return takeLatest$1(TestPrepSlice/* fetchSelfPrepBaughtStatusAction */.xw, fetchSelfPrepBaughtStatusSaga);
            case 16:
                _ctx.next = 18;
                return takeLatest$1(TestPrepSlice/* fetchMockTestsCredits */.iR, fetchPracticeTestsSaga);
            case 18:
                _ctx.next = 20;
                return takeLatest$1(TestPrepSlice/* postWritingExamPreference */.W7, postWritingExamPreferenceSaga);
            case 20:
                _ctx.next = 22;
                return takeLatest$1(TestPrepSlice/* fetchFLSEFeedbackData */.qg, fetchFLSEFeedbackSaga);
            case 22:
                _ctx.next = 24;
                return takeLatest$1(TestPrepSlice/* fetchLiyMocktestDashboard */.AH, fetchLiyMocktestDashboardSaga);
            case 24:
            case "end":
                return _ctx.stop();
        }
    }, TestPrepSaga_marked);
}
/* harmony default export */ var TestPrepSaga = (testPrepSaga);

// EXTERNAL MODULE: ./components/Ielts/IeltsEliteDemo/redux/IeltsEliteApi.ts
var IeltsEliteApi = __webpack_require__(97521);
;// CONCATENATED MODULE: ./components/Ielts/IeltsEliteDemo/redux/IeltsEliteSaga.ts

var IeltsEliteSaga_marked = runtime_default().mark(getPaidUserStatusSaga);
var IeltsEliteSaga_marked1 = runtime_default().mark(fetchPostPteEliteNudgeFormSaga);
var IeltsEliteSaga_marked2 = runtime_default().mark(fetchPteStatusSaga);
var IeltsEliteSaga_marked3 = runtime_default().mark(fetchInboundSalesNumberSaga);
var IeltsEliteSaga_marked4 = runtime_default().mark(lsqTriggerGetApiSaga);
var IeltsEliteSaga_marked5 = runtime_default().mark(lsqTriggerSaga);
var IeltsEliteSaga_marked6 = runtime_default().mark(fetchExamBookedStatusSaga);
var IeltsEliteSaga_marked7 = runtime_default().mark(fetchLiyStatusSaga);
var IeltsEliteSaga_marked8 = runtime_default().mark(postExamBookingDataSaga);
var IeltsEliteSaga_marked9 = runtime_default().mark(fetchIeltsQeStatusSaga);
var IeltsEliteSaga_marked10 = runtime_default().mark(runIeltsQESaga);
var IeltsEliteSaga_marked11 = runtime_default().mark(fetchQeFormDatasaga);
var IeltsEliteSaga_marked12 = runtime_default().mark(fetchPostDetailsIeltsClassSaga);
var IeltsEliteSaga_marked13 = runtime_default().mark(fetchPostDETEliteNudgeFormSaga);
var IeltsEliteSaga_marked14 = runtime_default().mark(fetchPostIeltsEliteNudgeFormSaga);
var IeltsEliteSaga_marked15 = runtime_default().mark(fetchGetStudentEligibilitySaga);
var IeltsEliteSaga_marked16 = runtime_default().mark(fetchGetIeltsStageSaga);





function fetchGetIeltsStageSaga() {
    var postGetStageAction, res, userStage;
    return runtime_default().wrap(function fetchGetIeltsStageSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setIeltsStageLoading */.FZ)(true));
            case 2:
                _ctx.next = 4;
                return (0,io_c3792963.a3)(function(state) {
                    return state.IeltsElite.postGetStageAction;
                });
            case 4:
                postGetStageAction = _ctx.sent;
                _ctx.prev = 5;
                _ctx.next = 8;
                return (0,io_c3792963.N)(IeltsEliteApi/* ieltsEliteApis.fetchGetIeltsStage */.i.fetchGetIeltsStage);
            case 8:
                res = _ctx.sent;
                userStage = res.data.userStage;
                _ctx.next = 12;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setIeltsStageLoading */.FZ)(false));
            case 12:
                if (!res.success) {
                    _ctx.next = 17;
                    break;
                }
                _ctx.next = 15;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* updateIeltsStage */.qp)(userStage));
            case 15:
                _ctx.next = 19;
                break;
            case 17:
                _ctx.next = 19;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setIeltsStageError */.EB)(res.data));
            case 19:
                if ((0,common_utils/* isFunction */.mf)(postGetStageAction)) {
                    postGetStageAction(userStage);
                }
                _ctx.next = 29;
                break;
            case 22:
                _ctx.prev = 22;
                _ctx.t0 = _ctx["catch"](5);
                if ((0,common_utils/* isFunction */.mf)(postGetStageAction)) {
                    postGetStageAction(null);
                }
                _ctx.next = 27;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setIeltsStageLoading */.FZ)(false));
            case 27:
                _ctx.next = 29;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setIeltsStageError */.EB)("Something went wrong Please try after some time"));
            case 29:
            case "end":
                return _ctx.stop();
        }
    }, IeltsEliteSaga_marked16, null, [
        [
            5,
            22
        ]
    ]);
}
function fetchGetStudentEligibilitySaga() {
    var postGetEligibilityAction, res;
    return runtime_default().wrap(function fetchGetStudentEligibilitySaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setStudentEligibilityLoading */.Cq)(true));
            case 2:
                _ctx.next = 4;
                return (0,io_c3792963.a3)(function(state) {
                    return state.IeltsElite.postGetEligibilityAction;
                });
            case 4:
                postGetEligibilityAction = _ctx.sent;
                _ctx.prev = 5;
                _ctx.next = 8;
                return (0,io_c3792963.N)(IeltsEliteApi/* ieltsEliteApis.fetchGetStudentEligibility */.i.fetchGetStudentEligibility);
            case 8:
                res = _ctx.sent;
                _ctx.next = 11;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setStudentEligibilityLoading */.Cq)(false));
            case 11:
                if (!res.success) {
                    _ctx.next = 16;
                    break;
                }
                _ctx.next = 14;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* updateStudentEligibility */.dk)(res.data));
            case 14:
                _ctx.next = 18;
                break;
            case 16:
                _ctx.next = 18;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setStudentEligibilityError */.xU)(res.data));
            case 18:
                if ((0,common_utils/* isFunction */.mf)(postGetEligibilityAction)) {
                    postGetEligibilityAction(res.data);
                }
                _ctx.next = 28;
                break;
            case 21:
                _ctx.prev = 21;
                _ctx.t0 = _ctx["catch"](5);
                _ctx.next = 25;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setStudentEligibilityLoading */.Cq)(false));
            case 25:
                _ctx.next = 27;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setStudentEligibilityError */.xU)("Something went wrong Please try after some time"));
            case 27:
                if ((0,common_utils/* isFunction */.mf)(postGetEligibilityAction)) {
                    postGetEligibilityAction(null);
                }
            case 28:
            case "end":
                return _ctx.stop();
        }
    }, IeltsEliteSaga_marked15, null, [
        [
            5,
            21
        ]
    ]);
}
function fetchPostIeltsEliteNudgeFormSaga(action) {
    var res, postFillIeltsEliteNudgeForm, qeResponse;
    return runtime_default().wrap(function fetchPostIeltsEliteNudgeFormSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setQeLoaders */.pk)(true));
            case 3:
                _ctx.next = 5;
                return (0,io_c3792963.N)(IeltsEliteApi/* ieltsEliteApis.fetchPostIeltsEliteNudgeForm */.i.fetchPostIeltsEliteNudgeForm, action.payload);
            case 5:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 22;
                    break;
                }
                _ctx.next = 9;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setIsQeFormSubmit */.sU)(true));
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.a3)(function(state) {
                    return state.IeltsElite.postFillIeltsEliteNudgeForm;
                });
            case 11:
                postFillIeltsEliteNudgeForm = _ctx.sent;
                if ((0,common_utils/* isFunction */.mf)(postFillIeltsEliteNudgeForm)) {
                    postFillIeltsEliteNudgeForm(action.payload);
                }
                _ctx.next = 15;
                return (0,io_c3792963.N)(IeltsEliteApi/* ieltsEliteApis.ieltsQualificationEngineApi */.i.ieltsQualificationEngineApi, false, action.payload.source);
            case 15:
                qeResponse = _ctx.sent;
                if (!qeResponse.success) {
                    _ctx.next = 20;
                    break;
                }
                if (!(0,common_utils/* isFunction */.mf)(action.payload.qeEngineCallBack)) {
                    _ctx.next = 20;
                    break;
                }
                _ctx.next = 20;
                return action.payload.qeEngineCallBack(qeResponse.data);
            case 20:
                _ctx.next = 24;
                break;
            case 22:
                _ctx.next = 24;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setIsQeFormSubmit */.sU)(false));
            case 24:
                _ctx.next = 30;
                break;
            case 26:
                _ctx.prev = 26;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 30;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setIsQeFormSubmit */.sU)(false));
            case 30:
                _ctx.prev = 30;
                _ctx.next = 33;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setQeLoaders */.pk)(false));
            case 33:
                return _ctx.finish(30);
            case 34:
            case "end":
                return _ctx.stop();
        }
    }, IeltsEliteSaga_marked14, null, [
        [
            0,
            26,
            30,
            34
        ]
    ]);
}
function fetchPostDETEliteNudgeFormSaga(action) {
    var res, postFillIeltsEliteNudgeForm;
    return runtime_default().wrap(function fetchPostDETEliteNudgeFormSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(IeltsEliteApi/* ieltsEliteApis.fetchPostDETEliteNudgeForm */.i.fetchPostDETEliteNudgeForm, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 13;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setIsQeFormSubmit */.sU)(true));
            case 7:
                _ctx.next = 9;
                return (0,io_c3792963.a3)(function(state) {
                    return state.IeltsElite.postFillIeltsEliteNudgeForm;
                });
            case 9:
                postFillIeltsEliteNudgeForm = _ctx.sent;
                if ((0,common_utils/* isFunction */.mf)(postFillIeltsEliteNudgeForm)) {
                    postFillIeltsEliteNudgeForm(action.payload);
                }
                _ctx.next = 15;
                break;
            case 13:
                _ctx.next = 15;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setIsQeFormSubmit */.sU)(false));
            case 15:
                _ctx.next = 21;
                break;
            case 17:
                _ctx.prev = 17;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 21;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setIsQeFormSubmit */.sU)(false));
            case 21:
            case "end":
                return _ctx.stop();
        }
    }, IeltsEliteSaga_marked13, null, [
        [
            0,
            17
        ]
    ]);
}
function fetchPostDetailsIeltsClassSaga(action) {
    var postFillIeltsQeFormAction;
    return runtime_default().wrap(function fetchPostDetailsIeltsClassSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return (0,io_c3792963.a3)(function(state) {
                    return state.IeltsElite.postFillIeltsQeFormAction;
                });
            case 2:
                postFillIeltsQeFormAction = _ctx.sent;
                _ctx.prev = 3;
                _ctx.next = 6;
                return (0,io_c3792963.N)(IeltsEliteApi/* ieltsEliteApis.fetchPostDetailsIeltsClass */.i.fetchPostDetailsIeltsClass, action.payload);
            case 6:
                _ctx.next = 10;
                break;
            case 8:
                _ctx.prev = 8;
                _ctx.t0 = _ctx["catch"](3);
            case 10:
                if ((0,common_utils/* isFunction */.mf)(postFillIeltsQeFormAction)) {
                    postFillIeltsQeFormAction(action.payload);
                }
            case 11:
            case "end":
                return _ctx.stop();
        }
    }, IeltsEliteSaga_marked12, null, [
        [
            3,
            8
        ]
    ]);
}
function fetchQeFormDatasaga(action) {
    var res;
    return runtime_default().wrap(function fetchQeFormDatasaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(IeltsEliteApi/* ieltsEliteApis.fetchQeFormDataApi */.i.fetchQeFormDataApi);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 10;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setQeFormData */.WB)(res.data.data));
            case 7:
                if ((0,common_utils/* isFunction */.mf)(action.payload)) {
                    action.payload(res.data.data);
                }
                _ctx.next = 13;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setQeFormData */.WB)(null));
            case 12:
                if ((0,common_utils/* isFunction */.mf)(action.payload)) {
                    action.payload(null);
                }
            case 13:
                _ctx.next = 20;
                break;
            case 15:
                _ctx.prev = 15;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 19;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setQeFormData */.WB)(null));
            case 19:
                if ((0,common_utils/* isFunction */.mf)(action.payload)) {
                    action.payload(null);
                }
            case 20:
            case "end":
                return _ctx.stop();
        }
    }, IeltsEliteSaga_marked11, null, [
        [
            0,
            15
        ]
    ]);
}
function runIeltsQESaga(action) {
    var res;
    return runtime_default().wrap(function runIeltsQESaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setQeLoaders */.pk)(true));
            case 3:
                _ctx.next = 5;
                return (0,io_c3792963.N)(IeltsEliteApi/* ieltsEliteApis.ieltsQualificationEngineApi */.i.ieltsQualificationEngineApi, action.payload);
            case 5:
                res = _ctx.sent;
                _ctx.next = 8;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setUserQeData */.GR)(res === null || res === void 0 ? void 0 : res.data));
            case 8:
                _ctx.next = 13;
                break;
            case 10:
                _ctx.prev = 10;
                _ctx.t0 = _ctx["catch"](0);
                console.log("err", _ctx.t0);
            case 13:
                _ctx.prev = 13;
                _ctx.next = 16;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setQeLoaders */.pk)(false));
            case 16:
                return _ctx.finish(13);
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, IeltsEliteSaga_marked10, null, [
        [
            0,
            10,
            13,
            17
        ]
    ]);
}
function fetchIeltsQeStatusSaga() {
    var res;
    return runtime_default().wrap(function fetchIeltsQeStatusSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(IeltsEliteApi/* ieltsEliteApis.fetchIeltsQeStatus */.i.fetchIeltsQeStatus);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setUserQeData */.GR)(res === null || res === void 0 ? void 0 : res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setUserQeData */.GR)(null));
            case 11:
                _ctx.next = 16;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.log("err", _ctx.t0);
            case 16:
            case "end":
                return _ctx.stop();
        }
    }, IeltsEliteSaga_marked9, null, [
        [
            0,
            13
        ]
    ]);
}
function postExamBookingDataSaga(action) {
    var res;
    return runtime_default().wrap(function postExamBookingDataSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(IeltsEliteApi/* ieltsEliteApis.postExamBookingDataApi */.i.postExamBookingDataApi, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 11;
                    break;
                }
                _ctx.next = 7;
                return (0,segment.trackEventAsync)("Form Submitted", {
                    formId: "Exam Booking Form",
                    examStatus: action.payload.examBooked,
                    assistanceStatus: action.payload.examBookingAssistance
                });
            case 7:
                _ctx.next = 9;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setIsExamBookedSubmit */.y6)(true));
            case 9:
                _ctx.next = 13;
                break;
            case 11:
                _ctx.next = 13;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setIsExamBookedSubmit */.y6)(false));
            case 13:
                _ctx.next = 20;
                break;
            case 15:
                _ctx.prev = 15;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 19;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setIsExamBookedSubmit */.y6)(false));
            case 19:
                console.log("err", _ctx.t0);
            case 20:
            case "end":
                return _ctx.stop();
        }
    }, IeltsEliteSaga_marked8, null, [
        [
            0,
            15
        ]
    ]);
}
function fetchLiyStatusSaga() {
    var res;
    return runtime_default().wrap(function fetchLiyStatusSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(IeltsEliteApi/* ieltsEliteApis.fetchLiyStatusApi */.i.fetchLiyStatusApi);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setLiyPaymentStatus */.CW)(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setLiyPaymentStatus */.CW)(null));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setLiyPaymentStatus */.CW)(null));
            case 17:
                console.log("err", _ctx.t0);
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, IeltsEliteSaga_marked7, null, [
        [
            0,
            13
        ]
    ]);
}
function fetchExamBookedStatusSaga() {
    var res;
    return runtime_default().wrap(function fetchExamBookedStatusSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(IeltsEliteApi/* ieltsEliteApis.fetchExamBookedStatusApi */.i.fetchExamBookedStatusApi);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setExamBookedStatus */.zW)(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setExamBookedStatus */.zW)(null));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setExamBookedStatus */.zW)(null));
            case 17:
                console.log("err", _ctx.t0);
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, IeltsEliteSaga_marked6, null, [
        [
            0,
            13
        ]
    ]);
}
function lsqTriggerSaga(action) {
    return runtime_default().wrap(function lsqTriggerSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(IeltsEliteApi/* ieltsEliteApis.lsqTriggerApi */.i.lsqTriggerApi, action.payload);
            case 3:
                _ctx.next = 8;
                break;
            case 5:
                _ctx.prev = 5;
                _ctx.t0 = _ctx["catch"](0);
                console.log("err", _ctx.t0);
            case 8:
            case "end":
                return _ctx.stop();
        }
    }, IeltsEliteSaga_marked5, null, [
        [
            0,
            5
        ]
    ]);
}
function lsqTriggerGetApiSaga() {
    return runtime_default().wrap(function lsqTriggerGetApiSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(IeltsEliteApi/* ieltsEliteApis.lsqTriggerGetApi */.i.lsqTriggerGetApi);
            case 3:
                _ctx.next = 8;
                break;
            case 5:
                _ctx.prev = 5;
                _ctx.t0 = _ctx["catch"](0);
                console.log("err", _ctx.t0);
            case 8:
            case "end":
                return _ctx.stop();
        }
    }, IeltsEliteSaga_marked4, null, [
        [
            0,
            5
        ]
    ]);
}
function fetchInboundSalesNumberSaga() {
    var res;
    return runtime_default().wrap(function fetchInboundSalesNumberSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(IeltsEliteApi/* ieltsEliteApis.fetchInboundSalesNumberApi */.i.fetchInboundSalesNumberApi);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setInboundSalesNumber */.AI)(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setInboundSalesNumber */.AI)(null));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setInboundSalesNumber */.AI)(null));
            case 17:
                console.log("err", _ctx.t0);
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, IeltsEliteSaga_marked3, null, [
        [
            0,
            13
        ]
    ]);
}
function fetchPteStatusSaga() {
    var res;
    return runtime_default().wrap(function fetchPteStatusSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(IeltsEliteApi/* ieltsEliteApis.fetchPteStatusApi */.i.fetchPteStatusApi);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setPtePaymentStatus */.Vn)(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setPtePaymentStatus */.Vn)(null));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setPtePaymentStatus */.Vn)(null));
            case 17:
                console.log("err", _ctx.t0);
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, IeltsEliteSaga_marked2, null, [
        [
            0,
            13
        ]
    ]);
}
function fetchPostPteEliteNudgeFormSaga(action) {
    return runtime_default().wrap(function fetchPostPteEliteNudgeFormSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(IeltsEliteApi/* ieltsEliteApis.fetchPostPteEliteNudgeFormApi */.i.fetchPostPteEliteNudgeFormApi, action.payload);
            case 3:
                _ctx.next = 8;
                break;
            case 5:
                _ctx.prev = 5;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0);
            case 8:
            case "end":
                return _ctx.stop();
        }
    }, IeltsEliteSaga_marked1, null, [
        [
            0,
            5
        ]
    ]);
}
function getPaidUserStatusSaga() {
    var res;
    return runtime_default().wrap(function getPaidUserStatusSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(IeltsEliteApi/* ieltsEliteApis.getPaidUserStatusApi */.i.getPaidUserStatusApi);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setPaidUserStatus */.$c)(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setPaidUserStatus */.$c)(false));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)((0,IeltsEliteSlice/* setPaidUserStatus */.$c)(false));
            case 17:
                console.log("err", _ctx.t0);
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, IeltsEliteSaga_marked, null, [
        [
            0,
            13
        ]
    ]);
}
function ieltsEliteSaga() {
    return runtime_default().wrap(function ieltsEliteSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(IeltsEliteSlice/* fetchGetIeltsStage */.Wv, fetchGetIeltsStageSaga);
            case 2:
                _ctx.next = 4;
                return takeLatest$1(IeltsEliteSlice/* fetchPostIeltsEliteNudgeForm */.NS, fetchPostIeltsEliteNudgeFormSaga);
            case 4:
                _ctx.next = 6;
                return takeLatest$1(IeltsEliteSlice/* fetchPostDETEliteNudgeForm */.q1, fetchPostDETEliteNudgeFormSaga);
            case 6:
                _ctx.next = 8;
                return takeLatest$1(IeltsEliteSlice/* fetchGetStudentEligibility */.eE, fetchGetStudentEligibilitySaga);
            case 8:
                _ctx.next = 10;
                return takeLatest$1(IeltsEliteSlice/* fetchPostDetailsIeltsClass */.Fj, fetchPostDetailsIeltsClassSaga);
            case 10:
                _ctx.next = 12;
                return takeLatest$1(IeltsEliteSlice/* fetchQeFormData */.Rx, fetchQeFormDatasaga);
            case 12:
                _ctx.next = 14;
                return takeLatest$1(IeltsEliteSlice/* runIeltsQualificationEngineAction */.D$, runIeltsQESaga);
            case 14:
                _ctx.next = 16;
                return takeLatest$1(IeltsEliteSlice/* fetchIeltsQeStatusSlice */.cU, fetchIeltsQeStatusSaga);
            case 16:
                _ctx.next = 18;
                return takeLatest$1(IeltsEliteSlice/* postExamBookingDataSlice */.Lp, postExamBookingDataSaga);
            case 18:
                _ctx.next = 20;
                return takeLatest$1(IeltsEliteSlice/* fetchLiyStatusSlice */.Lt, fetchLiyStatusSaga);
            case 20:
                _ctx.next = 22;
                return takeLatest$1(IeltsEliteSlice/* fetchExamBookedStatusSlice */.R$, fetchExamBookedStatusSaga);
            case 22:
                _ctx.next = 24;
                return takeLatest$1(IeltsEliteSlice/* lsqTriggerSlice */.de, lsqTriggerSaga);
            case 24:
                _ctx.next = 26;
                return takeLatest$1(IeltsEliteSlice/* lsqTriggerGetApiSlice */.Ge, lsqTriggerGetApiSaga);
            case 26:
                _ctx.next = 28;
                return takeLatest$1(IeltsEliteSlice/* fetchInboundSalesNumberSlice */.k9, fetchInboundSalesNumberSaga);
            case 28:
                _ctx.next = 30;
                return takeLatest$1(IeltsEliteSlice/* fetchPteStatusSlice */.Qv, fetchPteStatusSaga);
            case 30:
                _ctx.next = 32;
                return takeLatest$1(IeltsEliteSlice/* fetchPostPteEliteNudgeFormSlice */.zv, fetchPostPteEliteNudgeFormSaga);
            case 32:
                _ctx.next = 34;
                return takeLatest$1(IeltsEliteSlice/* getPaidUserStatusSlice */.ZJ, getPaidUserStatusSaga);
            case 34:
            case "end":
                return _ctx.stop();
        }
    }, ieltsEliteSaga);
};

// EXTERNAL MODULE: ./components/Profile/StudentDashbord/IeltsScreenController/redux/ieltsSceenApi.ts
var ieltsSceenApi = __webpack_require__(78575);
// EXTERNAL MODULE: ./components/Profile/StudentDashbord/IeltsScreenController/redux/IeltsScreenControllerActions.ts
var IeltsScreenControllerActions = __webpack_require__(31007);
;// CONCATENATED MODULE: ./components/Profile/StudentDashbord/IeltsScreenController/redux/ieltsScreenSaga.ts

var ieltsScreenSaga_marked = runtime_default().mark(ieltsScreenSaga);
var ieltsScreenSaga_marked1 = runtime_default().mark(fetchI2CEligibilitySaga);
var ieltsScreenSaga_marked2 = runtime_default().mark(fetchIeltsStageSaga);
var ieltsScreenSaga_marked3 = runtime_default().mark(fetchUserPaymentInfoSaga);
var ieltsScreenSaga_marked4 = runtime_default().mark(fetchUserIeltsDetailsSaga);
var ieltsScreenSaga_marked5 = runtime_default().mark(fetchDemoBookingDetails);
var ieltsScreenSaga_marked6 = runtime_default().mark(fetchIeltsUserStates);



function fetchIeltsUserStates() {
    var res;
    return runtime_default().wrap(function fetchIeltsUserStates$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(ieltsSceenApi/* ieltsScreenApi.fetchIeltsUserStates */.k.fetchIeltsUserStates);
            case 3:
                res = _ctx.sent;
                if (!(res === null || res === void 0 ? void 0 : res.data)) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(IeltsScreenControllerActions/* ieltsScreenControllerActions.setUserStates */.K.setUserStates(res.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)(IeltsScreenControllerActions/* ieltsScreenControllerActions.setUserStates */.K.setUserStates(null));
            case 11:
                _ctx.next = 18;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 18;
                return (0,io_c3792963.Y)(IeltsScreenControllerActions/* ieltsScreenControllerActions.setUserStates */.K.setUserStates(null));
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, ieltsScreenSaga_marked6, null, [
        [
            0,
            13
        ]
    ]);
}
function fetchDemoBookingDetails(action) {
    var res, ref;
    return runtime_default().wrap(function fetchDemoBookingDetails$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(ieltsSceenApi/* ieltsScreenApi.fetchDemoDetails */.k.fetchDemoDetails, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 10;
                    break;
                }
                ;
                _ctx.next = 8;
                return (0,io_c3792963.Y)(IeltsScreenControllerActions/* ieltsScreenControllerActions.setDemoDetails */.K.setDemoDetails((ref = res.data.data[0]) !== null && ref !== void 0 ? ref : null));
            case 8:
                _ctx.next = 12;
                break;
            case 10:
                _ctx.next = 12;
                return (0,io_c3792963.Y)(IeltsScreenControllerActions/* ieltsScreenControllerActions.setDemoDetails */.K.setDemoDetails(null));
            case 12:
                _ctx.next = 19;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
                _ctx.next = 19;
                return (0,io_c3792963.Y)(IeltsScreenControllerActions/* ieltsScreenControllerActions.setDemoDetails */.K.setDemoDetails(null));
            case 19:
            case "end":
                return _ctx.stop();
        }
    }, ieltsScreenSaga_marked5, null, [
        [
            0,
            14
        ]
    ]);
}
function fetchUserIeltsDetailsSaga() {
    var res;
    return runtime_default().wrap(function fetchUserIeltsDetailsSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(ieltsSceenApi/* ieltsScreenApi.fetchIeltsUserDetails */.k.fetchIeltsUserDetails);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 7;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(IeltsScreenControllerActions/* ieltsScreenControllerActions.fetchUserIeltsDetailsSuccess */.K.fetchUserIeltsDetailsSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.prev = 9;
                _ctx.t0 = _ctx["catch"](0);
            case 11:
            case "end":
                return _ctx.stop();
        }
    }, ieltsScreenSaga_marked4, null, [
        [
            0,
            9
        ]
    ]);
}
function fetchUserPaymentInfoSaga(action) {
    var res;
    return runtime_default().wrap(function fetchUserPaymentInfoSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(ieltsSceenApi/* ieltsScreenApi.fetchIeltsPaymentInfo */.k.fetchIeltsPaymentInfo, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 7;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(IeltsScreenControllerActions/* ieltsScreenControllerActions.fetchUserPaymentInfoSuccess */.K.fetchUserPaymentInfoSuccess(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.prev = 9;
                _ctx.t0 = _ctx["catch"](0);
            case 11:
            case "end":
                return _ctx.stop();
        }
    }, ieltsScreenSaga_marked3, null, [
        [
            0,
            9
        ]
    ]);
}
function fetchIeltsStageSaga() {
    var res;
    return runtime_default().wrap(function fetchIeltsStageSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(ieltsSceenApi/* ieltsScreenApi.fetchIeltsEliteState */.k.fetchIeltsEliteState);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 7;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(IeltsScreenControllerActions/* ieltsScreenControllerActions.fetchIeltsEliteStateSuccess */.K.fetchIeltsEliteStateSuccess(res.data.data.userStage));
            case 7:
                _ctx.next = 12;
                break;
            case 9:
                _ctx.prev = 9;
                _ctx.t0 = _ctx["catch"](0);
                console.log("err", _ctx.t0);
            case 12:
            case "end":
                return _ctx.stop();
        }
    }, ieltsScreenSaga_marked2, null, [
        [
            0,
            9
        ]
    ]);
}
function fetchI2CEligibilitySaga() {
    var res;
    return runtime_default().wrap(function fetchI2CEligibilitySaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(ieltsSceenApi/* ieltsScreenApi.fetchI2CEligibility */.k.fetchI2CEligibility);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 7;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)(IeltsScreenControllerActions/* ieltsScreenControllerActions.fetchUserI2CEligibilitySuccess */.K.fetchUserI2CEligibilitySuccess(res.data.data));
            case 7:
                _ctx.next = 12;
                break;
            case 9:
                _ctx.prev = 9;
                _ctx.t0 = _ctx["catch"](0);
                console.log("err", _ctx.t0);
            case 12:
            case "end":
                return _ctx.stop();
        }
    }, ieltsScreenSaga_marked1, null, [
        [
            0,
            9
        ]
    ]);
}
function ieltsScreenSaga() {
    return runtime_default().wrap(function ieltsScreenSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1("FETCH_USER_STATES", fetchIeltsUserStates);
            case 2:
                _ctx.next = 4;
                return takeLatest$1("FETCH_DEMO_DETAILS", fetchDemoBookingDetails);
            case 4:
                _ctx.next = 6;
                return takeLatest$1("FETCH_USER_IELTS_DETAILS_REQUEST", fetchUserIeltsDetailsSaga);
            case 6:
                _ctx.next = 8;
                return takeLatest$1("FETCH_USER_PAYMENT_INFO", fetchUserPaymentInfoSaga);
            case 8:
                _ctx.next = 10;
                return takeLatest$1("FETCH_USER_IELTS_ELITE_STAGE", fetchIeltsStageSaga);
            case 10:
                _ctx.next = 12;
                return takeLatest$1("FETCH_USER_I2C_ELIGIBILITY_REQUEST", fetchI2CEligibilitySaga);
            case 12:
            case "end":
                return _ctx.stop();
        }
    }, ieltsScreenSaga_marked);
}
/* harmony default export */ var redux_ieltsScreenSaga = (ieltsScreenSaga);

// EXTERNAL MODULE: ./components/SpotCounselling/Calendar/utils.ts
var utils = __webpack_require__(82788);
;// CONCATENATED MODULE: ./components/Ielts/IeltsDemo/redux/IeltsDemoApi.ts


var fetchIeltsEliteDemoSlots = function(days) {
    return api/* default.get */.Z.get("/api/scholarRoute?path=counselling/slots/".concat(utils/* SlotTypes.IELTS_SPOT_COUNSELLING */.C3.IELTS_SPOT_COUNSELLING, "/live/").concat(days), {
        headers: {
            "X-API-VERSION": 3
        }
    });
};
var fetchMasterclassDataApi = function(masterclassLimit) {
    return api/* default.get */.Z.get("/api/ielts/masterclassSlotStructure", {
        headers: {
            starting_limit: masterclassLimit.start,
            ending_limit: masterclassLimit.end,
            data_limit: masterclassLimit.dataLimit
        }
    });
};
var enrollWorkshop = function(workshop) {
    return api/* default.post */.Z.post("/api/scholarRoute?path=workshop/enroll/".concat(workshop.batchId, "/").concat(workshop.workshopType));
};
var subscribeMasterClassApi = function() {
    return api/* default.post */.Z.post("/api/scholarRoute?path=workshop/master-class/subscribe");
};
var fetchRejoinModalStatus = function() {
    return api/* default.get */.Z.get("/api/scholarRoute?path=ielts-elite/eligible/rejoin");
};
var fetchAnroidAppMagicLink = function() {
    return api/* default.get */.Z.get("/api/scholarRoute?path=ielts-elite/magic-link");
};
var IeltsDemoApi = {
    fetchIeltsEliteDemoSlots: fetchIeltsEliteDemoSlots,
    fetchMasterclassDataApi: fetchMasterclassDataApi,
    enrollWorkshop: enrollWorkshop,
    subscribeMasterClassApi: subscribeMasterClassApi,
    fetchRejoinModalStatus: fetchRejoinModalStatus,
    fetchAnroidAppMagicLink: fetchAnroidAppMagicLink
};

// EXTERNAL MODULE: ./components/SpotCounselling/Calendar/service.ts
var service = __webpack_require__(22767);
;// CONCATENATED MODULE: ./components/Ielts/IeltsDemo/redux/IeltsDemoSaga.ts


var IeltsDemoSaga_marked = runtime_default().mark(ieltsDemoSaga);
var IeltsDemoSaga_marked1 = runtime_default().mark(fetchAnroidAppMagicLinkSaga);
var IeltsDemoSaga_marked2 = runtime_default().mark(fetchRejoinModalDataSaga);
var IeltsDemoSaga_marked3 = runtime_default().mark(subscribeMasterClassSaga);
var IeltsDemoSaga_marked4 = runtime_default().mark(enrollWorkshopSaga);
var IeltsDemoSaga_marked5 = runtime_default().mark(fetchMasterclassDataSaga);
var IeltsDemoSaga_marked6 = runtime_default().mark(bookDETSlotSaga);
var IeltsDemoSaga_marked7 = runtime_default().mark(bookPteSlotSaga);
var IeltsDemoSaga_marked8 = runtime_default().mark(bookIeltsSlotSaga);
var IeltsDemoSaga_marked9 = runtime_default().mark(fetchIeltsDemoSlots);









function fetchIeltsDemoSlots(action) {
    var res;
    return runtime_default().wrap(function fetchIeltsDemoSlots$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(IeltsDemoApi.fetchIeltsEliteDemoSlots, action.payload);
            case 3:
                res = _ctx.sent;
                _ctx.next = 6;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setIsLoading */.wt)(false));
            case 6:
                if (!res.data.success) {
                    _ctx.next = 11;
                    break;
                }
                _ctx.next = 9;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setIeltsSlotsDetails */.qT)(res.data.data));
            case 9:
                _ctx.next = 15;
                break;
            case 11:
                _ctx.next = 13;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setError */.sT)(true));
            case 13:
                _ctx.next = 15;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setIeltsSlotsDetails */.qT)(null));
            case 15:
                _ctx.next = 25;
                break;
            case 17:
                _ctx.prev = 17;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 21;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setIsLoading */.wt)(false));
            case 21:
                _ctx.next = 23;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setError */.sT)(true));
            case 23:
                _ctx.next = 25;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setIeltsSlotsDetails */.qT)(null));
            case 25:
            case "end":
                return _ctx.stop();
        }
    }, IeltsDemoSaga_marked9, null, [
        [
            0,
            17
        ]
    ]);
}
function bookIeltsSlotSaga(Action) {
    var res;
    return runtime_default().wrap(function bookIeltsSlotSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(service/* confirmIeltsEliteDemoSlot */.c5, Action.payload.payload, Action.payload.isReschedule);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 17;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.N)(segment.trackUserDevice);
            case 7:
                _ctx.next = 9;
                return (0,segment.trackEventAsync)("Event Booked", (0,_object_spread/* default */.Z)({}, Action.payload.segmentPayload));
            case 9:
                if (!(0,common_utils/* isFunction */.mf)(Action.payload.postBookingCallBack)) {
                    _ctx.next = 13;
                    break;
                }
                {
                    Action.payload.postBookingCallBack();
                }
                _ctx.next = 15;
                break;
            case 13:
                _ctx.next = 15;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setHasBookedSlot */.tP)(res.data));
            case 15:
                _ctx.next = 21;
                break;
            case 17:
                _ctx.next = 19;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setError */.sT)(true));
            case 19:
                _ctx.next = 21;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setHasBookedSlot */.tP)(false));
            case 21:
                _ctx.next = 29;
                break;
            case 23:
                _ctx.prev = 23;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 27;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setError */.sT)(true));
            case 27:
                _ctx.next = 29;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setHasBookedSlot */.tP)(false));
            case 29:
            case "end":
                return _ctx.stop();
        }
    }, IeltsDemoSaga_marked8, null, [
        [
            0,
            23
        ]
    ]);
}
function bookPteSlotSaga(Action) {
    var res;
    return runtime_default().wrap(function bookPteSlotSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(service/* confirmPteEliteDemoSlot */.sG, Action.payload.payload, Action.payload.isReschedule);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 17;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.N)(segment.trackUserDevice);
            case 7:
                _ctx.next = 9;
                return (0,segment.trackEventAsync)("Event Booked", (0,_object_spread/* default */.Z)({}, Action.payload.segmentPayload));
            case 9:
                if (!(0,common_utils/* isFunction */.mf)(Action.payload.postBookingCallBack)) {
                    _ctx.next = 13;
                    break;
                }
                {
                    Action.payload.postBookingCallBack();
                }
                _ctx.next = 15;
                break;
            case 13:
                _ctx.next = 15;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setHasBookedSlot */.tP)(res.data));
            case 15:
                _ctx.next = 21;
                break;
            case 17:
                _ctx.next = 19;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setError */.sT)(true));
            case 19:
                _ctx.next = 21;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setHasBookedSlot */.tP)(false));
            case 21:
                _ctx.next = 29;
                break;
            case 23:
                _ctx.prev = 23;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 27;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setError */.sT)(true));
            case 27:
                _ctx.next = 29;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setHasBookedSlot */.tP)(false));
            case 29:
            case "end":
                return _ctx.stop();
        }
    }, IeltsDemoSaga_marked7, null, [
        [
            0,
            23
        ]
    ]);
}
function bookDETSlotSaga(Action) {
    var res;
    return runtime_default().wrap(function bookDETSlotSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(service/* confirmPDETEliteDemoSlot */.Ds, Action.payload.payload, Action.payload.isReschedule);
            case 3:
                res = _ctx.sent;
                if (!res.success) {
                    _ctx.next = 19;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.N)(segment.trackUserDevice);
            case 7:
                _ctx.next = 9;
                return (0,segment.trackEventAsync)("Event Booked", (0,_object_spread/* default */.Z)({}, Action.payload.segmentPayload));
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.N)(ga.fireTagEvent, "det_demo_booked");
            case 11:
                if (!(0,common_utils/* isFunction */.mf)(Action.payload.postBookingCallBack)) {
                    _ctx.next = 15;
                    break;
                }
                {
                    Action.payload.postBookingCallBack();
                }
                _ctx.next = 17;
                break;
            case 15:
                _ctx.next = 17;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setHasBookedSlot */.tP)(res.data));
            case 17:
                _ctx.next = 23;
                break;
            case 19:
                _ctx.next = 21;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setError */.sT)(true));
            case 21:
                _ctx.next = 23;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setHasBookedSlot */.tP)(false));
            case 23:
                _ctx.next = 31;
                break;
            case 25:
                _ctx.prev = 25;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 29;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setError */.sT)(true));
            case 29:
                _ctx.next = 31;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setHasBookedSlot */.tP)(false));
            case 31:
            case "end":
                return _ctx.stop();
        }
    }, IeltsDemoSaga_marked6, null, [
        [
            0,
            25
        ]
    ]);
}
function fetchMasterclassDataSaga(action) {
    var res;
    return runtime_default().wrap(function fetchMasterclassDataSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(IeltsDemoApi.fetchMasterclassDataApi, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setMasterClassListObj */.oS)(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setError */.sT)(true));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setError */.sT)(true));
            case 17:
                _ctx.prev = 17;
                _ctx.next = 20;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setIsLoading */.wt)(false));
            case 20:
                return _ctx.finish(17);
            case 21:
            case "end":
                return _ctx.stop();
        }
    }, IeltsDemoSaga_marked5, null, [
        [
            0,
            13,
            17,
            21
        ]
    ]);
}
function enrollWorkshopSaga(action) {
    var res;
    return runtime_default().wrap(function enrollWorkshopSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(IeltsDemoApi.enrollWorkshop, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setMasterClassBooked */.xe)(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setError */.sT)(true));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setError */.sT)(true));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, IeltsDemoSaga_marked4, null, [
        [
            0,
            13
        ]
    ]);
}
function subscribeMasterClassSaga(action) {
    var res;
    return runtime_default().wrap(function subscribeMasterClassSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(IeltsDemoApi.subscribeMasterClassApi);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 13;
                    break;
                }
                if (!res.data.data) {
                    _ctx.next = 11;
                    break;
                }
                _ctx.next = 8;
                return (0,io_c3792963.Y)(MasterclassActions/* masterclassActions.fetchMasterclassSubscriptionStatusSuccess */.u.fetchMasterclassSubscriptionStatusSuccess(res.data.data));
            case 8:
                if (!(0,common_utils/* isFunction */.mf)(action.payload)) {
                    _ctx.next = 11;
                    break;
                }
                _ctx.next = 11;
                return action.payload();
            case 11:
                _ctx.next = 15;
                break;
            case 13:
                _ctx.next = 15;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setError */.sT)(true));
            case 15:
                _ctx.next = 21;
                break;
            case 17:
                _ctx.prev = 17;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 21;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setError */.sT)(true));
            case 21:
            case "end":
                return _ctx.stop();
        }
    }, IeltsDemoSaga_marked3, null, [
        [
            0,
            17
        ]
    ]);
}
function fetchRejoinModalDataSaga() {
    var res;
    return runtime_default().wrap(function fetchRejoinModalDataSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(IeltsDemoApi.fetchRejoinModalStatus);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setRejoinDemoModalData */.XW)(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setRejoinDemoModalData */.XW)(null));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setRejoinDemoModalData */.XW)(null));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, IeltsDemoSaga_marked2, null, [
        [
            0,
            13
        ]
    ]);
}
function fetchAnroidAppMagicLinkSaga() {
    var res;
    return runtime_default().wrap(function fetchAnroidAppMagicLinkSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(IeltsDemoApi.fetchAnroidAppMagicLink);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setAnroidAppMagicLink */.BF)(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setAnroidAppMagicLink */.BF)(null));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)((0,IeltsDemoSlice/* setAnroidAppMagicLink */.BF)(null));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, IeltsDemoSaga_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function ieltsDemoSaga() {
    return runtime_default().wrap(function ieltsDemoSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(IeltsDemoSlice/* fetchIeltsSlots */.ov, fetchIeltsDemoSlots);
            case 2:
                _ctx.next = 4;
                return takeLatest$1(IeltsDemoSlice/* bookIeltsSlot */.ZS, bookIeltsSlotSaga);
            case 4:
                _ctx.next = 6;
                return takeLatest$1(IeltsDemoSlice/* bookPteSlot */.q3, bookPteSlotSaga);
            case 6:
                _ctx.next = 8;
                return takeLatest$1(IeltsDemoSlice/* bookDETSlot */.cd, bookDETSlotSaga);
            case 8:
                _ctx.next = 10;
                return takeLatest$1(IeltsDemoSlice/* fetchMasterclassData */.Fo, fetchMasterclassDataSaga);
            case 10:
                _ctx.next = 12;
                return takeLatest$1(IeltsDemoSlice/* enrollWorkshop */.k, enrollWorkshopSaga);
            case 12:
                _ctx.next = 14;
                return takeLatest$1(IeltsDemoSlice/* subscribeMasterClass */.jt, subscribeMasterClassSaga);
            case 14:
                _ctx.next = 16;
                return takeLatest$1(IeltsDemoSlice/* fetchRejoinModalData */.dT, fetchRejoinModalDataSaga);
            case 16:
                _ctx.next = 18;
                return takeLatest$1(IeltsDemoSlice/* fetchAnroidAppMagicLinkSlice */._, fetchAnroidAppMagicLinkSaga);
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, IeltsDemoSaga_marked);
}
/* harmony default export */ var IeltsDemoSaga = (ieltsDemoSaga);

;// CONCATENATED MODULE: ./components/Profile/StudentDashbord/IeltsSection/IeltsDemoRewards/redux/DemoRewardsApi.ts

var fetchScratchCardStatus = function(subscriptionType) {
    return api/* default.get */.Z.get("/api/scholarRoute?path=subscription/details/".concat(subscriptionType));
};
var updateScratchCardStatus = function() {
    return api/* default.post */.Z.post("/api/scholarRoute?path=subscription/scratch-card");
};
var updateTipsTricksStatus = function() {
    return api/* default.post */.Z.post("/api/scholarRoute?path=subscription/tips-tricks");
};
var DemoRewardsApi = {
    fetchScratchCardStatus: fetchScratchCardStatus,
    updateScratchCardStatus: updateScratchCardStatus,
    updateTipsTricksStatus: updateTipsTricksStatus
};

;// CONCATENATED MODULE: ./components/Profile/StudentDashbord/IeltsSection/IeltsDemoRewards/redux/DemoRewardSaga.ts

var DemoRewardSaga_marked = runtime_default().mark(DemoRewardsSaga);
var DemoRewardSaga_marked1 = runtime_default().mark(DemoRewardSaga_updateTipsTricksStatus);
var DemoRewardSaga_marked2 = runtime_default().mark(DemoRewardSaga_updateScratchCardStatus);
var DemoRewardSaga_marked3 = runtime_default().mark(fetchWhatsappTipsData);
var DemoRewardSaga_marked4 = runtime_default().mark(DemoRewardSaga_fetchScratchCardStatus);



function DemoRewardSaga_fetchScratchCardStatus(action) {
    var res;
    return runtime_default().wrap(function fetchScratchCardStatus$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(DemoRewardsApi.fetchScratchCardStatus, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)((0,DemoRewardsSlice/* setScratchSubscriptionData */.Qm)(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)((0,DemoRewardsSlice/* setScratchSubscriptionData */.Qm)(null));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)((0,DemoRewardsSlice/* setScratchSubscriptionData */.Qm)(null));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, DemoRewardSaga_marked4, null, [
        [
            0,
            13
        ]
    ]);
}
function fetchWhatsappTipsData(action) {
    var res;
    return runtime_default().wrap(function fetchWhatsappTipsData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(DemoRewardsApi.fetchScratchCardStatus, action.payload);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)((0,DemoRewardsSlice/* setWhatsappTipsData */.$y)(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)((0,DemoRewardsSlice/* setWhatsappTipsData */.$y)(null));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)((0,DemoRewardsSlice/* setWhatsappTipsData */.$y)(null));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, DemoRewardSaga_marked3, null, [
        [
            0,
            13
        ]
    ]);
}
function DemoRewardSaga_updateScratchCardStatus() {
    var res;
    return runtime_default().wrap(function updateScratchCardStatus$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(DemoRewardsApi.updateScratchCardStatus);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)((0,DemoRewardsSlice/* setScratchCardStatus */.TS)(res.data.data));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)((0,DemoRewardsSlice/* setScratchCardStatus */.TS)(false));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)((0,DemoRewardsSlice/* setScratchCardStatus */.TS)(false));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, DemoRewardSaga_marked2, null, [
        [
            0,
            13
        ]
    ]);
}
function DemoRewardSaga_updateTipsTricksStatus(action) {
    var res;
    return runtime_default().wrap(function updateTipsTricksStatus$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(DemoRewardsApi.updateTipsTricksStatus);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 9;
                    break;
                }
                _ctx.next = 7;
                return (0,io_c3792963.Y)((0,DemoRewardsSlice/* setWhatsappTipsStatus */.QF)(!action.payload));
            case 7:
                _ctx.next = 11;
                break;
            case 9:
                _ctx.next = 11;
                return (0,io_c3792963.Y)((0,DemoRewardsSlice/* setWhatsappTipsStatus */.QF)(false));
            case 11:
                _ctx.next = 17;
                break;
            case 13:
                _ctx.prev = 13;
                _ctx.t0 = _ctx["catch"](0);
                _ctx.next = 17;
                return (0,io_c3792963.Y)((0,DemoRewardsSlice/* setWhatsappTipsStatus */.QF)(false));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, DemoRewardSaga_marked1, null, [
        [
            0,
            13
        ]
    ]);
}
function DemoRewardsSaga() {
    return runtime_default().wrap(function DemoRewardsSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(DemoRewardsSlice/* fetchScratchCardStatusAction */.QH, DemoRewardSaga_fetchScratchCardStatus);
            case 2:
                _ctx.next = 4;
                return takeLatest$1(DemoRewardsSlice/* fetchWhatsappTipsDataAction */.Dr, fetchWhatsappTipsData);
            case 4:
                _ctx.next = 6;
                return takeLatest$1(DemoRewardsSlice/* updateScratchCardStatusAction */.iJ, DemoRewardSaga_updateScratchCardStatus);
            case 6:
                _ctx.next = 8;
                return takeLatest$1(DemoRewardsSlice/* updateTipsTricksStatusAction */._b, DemoRewardSaga_updateTipsTricksStatus);
            case 8:
            case "end":
                return _ctx.stop();
        }
    }, DemoRewardSaga_marked);
}
/* harmony default export */ var DemoRewardSaga = (DemoRewardsSaga);

;// CONCATENATED MODULE: ./components/Ielts/Referal/redux/ReferalApi.ts

var postReferalDetails = function(refData) {
    return api/* default.post */.Z.post("/api/scholarRoute?path=ielts-elite/refer".concat(refData.leadSource ? "?leadSource=".concat(refData.leadSource) : ""), refData);
};
var referalApis = {
    postReferalDetails: postReferalDetails
};

;// CONCATENATED MODULE: ./components/Ielts/Referal/redux/ReferalSaga.ts

var ReferalSaga_marked = runtime_default().mark(postReferalDetailsSaga);




function postReferalDetailsSaga(action) {
    var res, _message;
    return runtime_default().wrap(function postReferalDetailsSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,io_c3792963.N)(referalApis.postReferalDetails, action.payload.data);
            case 3:
                res = _ctx.sent;
                if (!res.data.success) {
                    _ctx.next = 8;
                    break;
                }
                {
                    if ((0,common_utils/* isFunction */.mf)(action.payload.callBack)) {
                        action.payload.callBack();
                    }
                }
                _ctx.next = 10;
                break;
            case 8:
                ;
                throw Error((_message = res.data.message) !== null && _message !== void 0 ? _message : "");
            case 10:
                _ctx.next = 17;
                break;
            case 12:
                _ctx.prev = 12;
                _ctx.t0 = _ctx["catch"](0);
                console.log(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message, "ksgkhjgsihygsiy");
                _ctx.next = 17;
                return (0,io_c3792963.Y)((0,IeltsReferalSlice/* setReferalError */.E4)(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message));
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, ReferalSaga_marked, null, [
        [
            0,
            12
        ]
    ]);
}
function referalSaga() {
    return runtime_default().wrap(function referalSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeLatest$1(IeltsReferalSlice/* postReferalData */.ty, postReferalDetailsSaga);
            case 2:
            case "end":
                return _ctx.stop();
        }
    }, referalSaga);
};

;// CONCATENATED MODULE: ./redux/rootSaga.ts

var rootSaga_marked = runtime_default().mark(rootSaga);



















































//tofu



// ls commumity










function rootSaga() {
    return runtime_default().wrap(function rootSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return (0,io_c3792963._)([
                    IeltsPlusSaga(),
                    FinancialCounsellingSaga(),
                    SpeakingClubSaga(),
                    ClassRecordingsSaga(),
                    NoticeBoardSaga(),
                    StudyMaterialSaga(),
                    MyClassSaga(),
                    redux_upcomingSaga(),
                    ReferAndEarnSaga(),
                    CounsellingSaga(),
                    CounsellingFormSaga(),
                    EssaySaga(),
                    FacultySaga(),
                    BatchDetailsSaga(),
                    UpcomingIeltsSaga(),
                    UpdateProfileSaga(),
                    IeltsRegistrationFormSaga(),
                    MasterclassRegistrationFormSaga(),
                    IeltsAttendanceSaga(),
                    ExtraClassSaga(),
                    NpsSaga(),
                    SpotCounsellingSaga(),
                    PromoCodeSaga(),
                    overview_sagas(),
                    notice_board_sagas(),
                    upcoming_appointments_sagas(),
                    document_details_sagas(),
                    visa_assistance_sagas(),
                    MockTestSaga(),
                    FastTrackFormSaga(),
                    FastTrackSaga(),
                    FastTrackVideoSaga(),
                    IntermediateScreenSaga(),
                    RegistrationFormSaga(),
                    MasterclassSaga(),
                    IeltsTestSaga(),
                    OnboardingSaga(),
                    CertificateSaga(),
                    DocumentUploadSaga(),
                    ReviewsSaga(),
                    MeetCounsellerSaga(),
                    StoriesSaga(),
                    AiEvalutionSaga(),
                    MasterclassReplaysSaga(),
                    PaymentSaga(),
                    QuizSaga(),
                    SemLandingSaga(),
                    MasterClassTypeSaga(),
                    redux_joinMasterClassSaga(),
                    RequestCallBackFormSaga(),
                    Saga(),
                    redux_MockTestPriceSaga(),
                    schedulePageSaga(),
                    redux_CommunitySaga(),
                    practiseAppSaga(),
                    redux_NeedHelpSaga(),
                    wordOfTheDaySaga(),
                    TestPrepSaga(),
                    ieltsEliteSaga(),
                    redux_ieltsScreenSaga(),
                    IeltsDemoSaga(),
                    DemoRewardSaga(),
                    referalSaga(), 
                ]);
            case 2:
            case "end":
                return _ctx.stop();
        }
    }, rootSaga_marked);
}
/* harmony default export */ var redux_rootSaga = (rootSaga);

;// CONCATENATED MODULE: ./redux/store.ts






var sagaMiddleware = (0,redux_saga_core_npm_proxy_esm/* default */.ZP)();
var makeStore = function() {
    // 1: Create the middleware
    // 2: Add an extra parameter for applying middleware:
    var store = (0,redux/* createStore */.MT)(rootReducer, (0,redux_devtools_extension/* composeWithDevTools */.Uo)((0,redux/* applyMiddleware */.md)(sagaMiddleware)));
    store.sagaTask = sagaMiddleware.run(redux_rootSaga);
    // 4: now return the store:
    return store;
};
var store = (0,redux/* createStore */.MT)(rootReducer, (0,redux_devtools_extension/* composeWithDevTools */.Uo)((0,redux/* applyMiddleware */.md)(sagaMiddleware)));
// export an assembled wrapper
var wrapper = (0,es6/* createWrapper */.KV)(makeStore, {
    debug: false
});


/***/ }),

/***/ 83697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "segmentReset": function() { return /* binding */ segmentReset; },
  "slotShown": function() { return /* binding */ slotShown; },
  "trackCalendarMeetingEvent": function() { return /* binding */ trackCalendarMeetingEvent; },
  "trackClick": function() { return /* binding */ trackClick; },
  "trackEvent": function() { return /* binding */ trackEvent; },
  "trackEventAsync": function() { return /* binding */ trackEventAsync; },
  "trackEventsClick": function() { return /* binding */ trackEventsClick; },
  "trackFileUpload": function() { return /* binding */ trackFileUpload; },
  "trackForm": function() { return /* binding */ trackForm; },
  "trackIdentity": function() { return /* binding */ trackIdentity; },
  "trackIdentityV2": function() { return /* binding */ trackIdentityV2; },
  "trackIeltsClick": function() { return /* binding */ trackIeltsClick; },
  "trackIeltsError": function() { return /* binding */ trackIeltsError; },
  "trackIeltsEvent": function() { return /* binding */ trackIeltsEvent; },
  "trackIeltsEventAttend": function() { return /* binding */ trackIeltsEventAttend; },
  "trackIeltsForm": function() { return /* binding */ trackIeltsForm; },
  "trackIeltsFormAsync": function() { return /* binding */ trackIeltsFormAsync; },
  "trackIeltsPayment": function() { return /* binding */ trackIeltsPayment; },
  "trackOnboardingProduct": function() { return /* binding */ trackOnboardingProduct; },
  "trackPage": function() { return /* binding */ trackPage; },
  "trackPageExit": function() { return /* binding */ trackPageExit; },
  "trackPageV2": function() { return /* binding */ trackPageV2; },
  "trackPageViewWithContent": function() { return /* binding */ trackPageViewWithContent; },
  "trackPayment": function() { return /* binding */ trackPayment; },
  "trackProduct": function() { return /* binding */ trackProduct; },
  "trackProductFormAsync": function() { return /* binding */ trackProductFormAsync; },
  "trackReferral": function() { return /* binding */ trackReferral; },
  "trackSignup": function() { return /* binding */ trackSignup; },
  "trackUserDevice": function() { return /* binding */ trackUserDevice; },
  "trackVideo": function() { return /* binding */ trackVideo; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./components/LSRevamp/utils.ts
var utils = __webpack_require__(69117);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./tz-cities-to-countries.json
var tz_cities_to_countries_namespaceObject = JSON.parse('{"Andorra":"Andorra","Calcutta":"India","Dubai":"United Arab Emirates","Kabul":"Afghanistan","Tirane":"Albania","Yerevan":"Armenia","Casey":"Antarctica","Davis":"Antarctica","Mawson":"Antarctica","Palmer":"Antarctica","Rothera":"Antarctica","Troll":"Antarctica","Vostok":"Antarctica","Buenos_Aires":"Argentina","Cordoba":"Argentina","Salta":"Argentina","Jujuy":"Argentina","Tucuman":"Argentina","Catamarca":"Argentina","La_Rioja":"Argentina","San_Juan":"Argentina","Mendoza":"Argentina","San_Luis":"Argentina","Rio_Gallegos":"Argentina","Ushuaia":"Argentina","Pago_Pago":"Samoa (American)","Vienna":"Austria","Lord_Howe":"Australia","Macquarie":"Australia","Hobart":"Australia","Melbourne":"Australia","Sydney":"Australia","Broken_Hill":"Australia","Brisbane":"Australia","Lindeman":"Australia","Adelaide":"Australia","Darwin":"Australia","Perth":"Australia","Eucla":"Australia","Baku":"Azerbaijan","Barbados":"Barbados","Dhaka":"Bangladesh","Brussels":"Belgium","Sofia":"Bulgaria","Bermuda":"Bermuda","Brunei":"Brunei","La_Paz":"Bolivia","Noronha":"Brazil","Belem":"Brazil","Fortaleza":"Brazil","Recife":"Brazil","Araguaina":"Brazil","Maceio":"Brazil","Bahia":"Brazil","Sao_Paulo":"Brazil","Campo_Grande":"Brazil","Cuiaba":"Brazil","Santarem":"Brazil","Porto_Velho":"Brazil","Boa_Vista":"Brazil","Manaus":"Brazil","Eirunepe":"Brazil","Rio_Branco":"Brazil","Thimphu":"Bhutan","Minsk":"Belarus","Belize":"Belize","St_Johns":"Canada","Halifax":"Canada","Glace_Bay":"Canada","Moncton":"Canada","Goose_Bay":"Canada","Toronto":"Canada","Nipigon":"Canada","Thunder_Bay":"Canada","Iqaluit":"Canada","Pangnirtung":"Canada","Winnipeg":"Canada","Rainy_River":"Canada","Resolute":"Canada","Rankin_Inlet":"Canada","Regina":"Canada","Swift_Current":"Canada","Edmonton":"Canada","Cambridge_Bay":"Canada","Yellowknife":"Canada","Inuvik":"Canada","Dawson_Creek":"Canada","Fort_Nelson":"Canada","Whitehorse":"Canada","Dawson":"Canada","Vancouver":"Canada","Cocos":"Cocos (Keeling) Islands","Zurich":"Switzerland","Abidjan":"Côte d\'Ivoire","Rarotonga":"Cook Islands","Santiago":"Chile","Punta_Arenas":"Chile","Easter":"Chile","Shanghai":"China","Urumqi":"China","Bogota":"Colombia","Costa_Rica":"Costa Rica","Havana":"Cuba","Cape_Verde":"Cape Verde","Christmas":"Christmas Island","Nicosia":"Cyprus","Famagusta":"Cyprus","Prague":"Czech Republic","Berlin":"Germany","Copenhagen":"Denmark","Santo_Domingo":"Dominican Republic","Algiers":"Algeria","Guayaquil":"Ecuador","Galapagos":"Ecuador","Tallinn":"Estonia","Cairo":"Egypt","El_Aaiun":"Western Sahara","Madrid":"Spain","Ceuta":"Spain","Canary":"Spain","Helsinki":"Finland","Fiji":"Fiji","Stanley":"Falkland Islands","Chuuk":"Micronesia","Pohnpei":"Micronesia","Kosrae":"Micronesia","Faroe":"Faroe Islands","Paris":"France","London":"Britain (UK)","Tbilisi":"Georgia","Cayenne":"French Guiana","Gibraltar":"Gibraltar","Nuuk":"Greenland","Danmarkshavn":"Greenland","Scoresbysund":"Greenland","Thule":"Greenland","Athens":"Greece","South_Georgia":"South Georgia & the South Sandwich Islands","Guatemala":"Guatemala","Guam":"Guam","Bissau":"Guinea-Bissau","Guyana":"Guyana","Hong_Kong":"Hong Kong","Tegucigalpa":"Honduras","Port-au-Prince":"Haiti","Budapest":"Hungary","Jakarta":"Indonesia","Pontianak":"Indonesia","Makassar":"Indonesia","Jayapura":"Indonesia","Dublin":"Ireland","Jerusalem":"Israel","Kolkata":"India","Chagos":"British Indian Ocean Territory","Baghdad":"Iraq","Tehran":"Iran","Reykjavik":"Iceland","Rome":"Italy","Jamaica":"Jamaica","Amman":"Jordan","Tokyo":"Japan","Nairobi":"Kenya","Bishkek":"Kyrgyzstan","Tarawa":"Kiribati","Kanton":"Kiribati","Kiritimati":"Kiribati","Pyongyang":"Korea (North)","Seoul":"Korea (South)","Almaty":"Kazakhstan","Qyzylorda":"Kazakhstan","Qostanay":"Kazakhstan","Aqtobe":"Kazakhstan","Aqtau":"Kazakhstan","Atyrau":"Kazakhstan","Oral":"Kazakhstan","Beirut":"Lebanon","Colombo":"Sri Lanka","Monrovia":"Liberia","Vilnius":"Lithuania","Luxembourg":"Luxembourg","Riga":"Latvia","Tripoli":"Libya","Casablanca":"Morocco","Monaco":"Monaco","Chisinau":"Moldova","Majuro":"Marshall Islands","Kwajalein":"Marshall Islands","Yangon":"Myanmar (Burma)","Ulaanbaatar":"Mongolia","Hovd":"Mongolia","Choibalsan":"Mongolia","Macau":"Macau","Martinique":"Martinique","Malta":"Malta","Mauritius":"Mauritius","Maldives":"Maldives","Mexico_City":"Mexico","Cancun":"Mexico","Merida":"Mexico","Monterrey":"Mexico","Matamoros":"Mexico","Mazatlan":"Mexico","Chihuahua":"Mexico","Ojinaga":"Mexico","Hermosillo":"Mexico","Tijuana":"Mexico","Bahia_Banderas":"Mexico","Kuala_Lumpur":"Malaysia","Kuching":"Malaysia","Maputo":"Mozambique","Windhoek":"Namibia","Noumea":"New Caledonia","Norfolk":"Norfolk Island","Lagos":"Nigeria","Managua":"Nicaragua","Amsterdam":"Netherlands","Oslo":"Norway","Kathmandu":"Nepal","Nauru":"Nauru","Niue":"Niue","Auckland":"New Zealand","Chatham":"New Zealand","Panama":"Panama","Lima":"Peru","Tahiti":"French Polynesia","Marquesas":"French Polynesia","Gambier":"French Polynesia","Port_Moresby":"Papua New Guinea","Bougainville":"Papua New Guinea","Manila":"Philippines","Karachi":"Pakistan","Warsaw":"Poland","Miquelon":"St Pierre & Miquelon","Pitcairn":"Pitcairn","Puerto_Rico":"Puerto Rico","Gaza":"Palestine","Hebron":"Palestine","Lisbon":"Portugal","Madeira":"Portugal","Azores":"Portugal","Palau":"Palau","Asuncion":"Paraguay","Qatar":"Qatar","Reunion":"Réunion","Bucharest":"Romania","Belgrade":"Serbia","Kaliningrad":"Russia","Moscow":"Russia","Simferopol":"Russia","Kirov":"Russia","Volgograd":"Russia","Astrakhan":"Russia","Saratov":"Russia","Ulyanovsk":"Russia","Samara":"Russia","Yekaterinburg":"Russia","Omsk":"Russia","Novosibirsk":"Russia","Barnaul":"Russia","Tomsk":"Russia","Novokuznetsk":"Russia","Krasnoyarsk":"Russia","Irkutsk":"Russia","Chita":"Russia","Yakutsk":"Russia","Khandyga":"Russia","Vladivostok":"Russia","Ust-Nera":"Russia","Magadan":"Russia","Sakhalin":"Russia","Srednekolymsk":"Russia","Kamchatka":"Russia","Anadyr":"Russia","Riyadh":"Saudi Arabia","Guadalcanal":"Solomon Islands","Mahe":"Seychelles","Khartoum":"Sudan","Stockholm":"Sweden","Singapore":"Singapore","Paramaribo":"Suriname","Juba":"South Sudan","Sao_Tome":"Sao Tome & Principe","El_Salvador":"El Salvador","Damascus":"Syria","Grand_Turk":"Turks & Caicos Is","Ndjamena":"Chad","Kerguelen":"French Southern & Antarctic Lands","Bangkok":"Thailand","Dushanbe":"Tajikistan","Fakaofo":"Tokelau","Dili":"East Timor","Ashgabat":"Turkmenistan","Tunis":"Tunisia","Tongatapu":"Tonga","Istanbul":"Turkey","Funafuti":"Tuvalu","Taipei":"Taiwan","Kiev":"Ukraine","Uzhgorod":"Ukraine","Zaporozhye":"Ukraine","Wake":"US minor outlying islands","New_York":"United States","Detroit":"United States","Louisville":"United States","Monticello":"United States","Indianapolis":"United States","Vincennes":"United States","Winamac":"United States","Marengo":"United States","Petersburg":"United States","Vevay":"United States","Chicago":"United States","Tell_City":"United States","Knox":"United States","Menominee":"United States","Center":"United States","New_Salem":"United States","Beulah":"United States","Denver":"United States","Boise":"United States","Phoenix":"United States","Los_Angeles":"United States","Anchorage":"United States","Juneau":"United States","Sitka":"United States","Metlakatla":"United States","Yakutat":"United States","Nome":"United States","Adak":"United States","Honolulu":"United States","Montevideo":"Uruguay","Samarkand":"Uzbekistan","Tashkent":"Uzbekistan","Caracas":"Venezuela","Ho_Chi_Minh":"Vietnam","Efate":"Vanuatu","Wallis":"Wallis & Futuna","Apia":"Samoa (western)","Johannesburg":"South Africa","Antigua":"Antigua & Barbuda","Anguilla":"Anguilla","Luanda":"Angola","McMurdo":"Antarctica","DumontDUrville":"Antarctica","Syowa":"Antarctica","Aruba":"Aruba","Mariehamn":"Åland Islands","Sarajevo":"Bosnia & Herzegovina","Ouagadougou":"Burkina Faso","Bahrain":"Bahrain","Bujumbura":"Burundi","Porto-Novo":"Benin","St_Barthelemy":"St Barthelemy","Kralendijk":"Caribbean NL","Nassau":"Bahamas","Gaborone":"Botswana","Blanc-Sablon":"Canada","Atikokan":"Canada","Creston":"Canada","Kinshasa":"Congo (Dem. Rep.)","Lubumbashi":"Congo (Dem. Rep.)","Bangui":"Central African Rep.","Brazzaville":"Congo (Rep.)","Douala":"Cameroon","Curacao":"Curaçao","Busingen":"Germany","Djibouti":"Djibouti","Dominica":"Dominica","Asmara":"Eritrea","Addis_Ababa":"Ethiopia","Libreville":"Gabon","Grenada":"Grenada","Guernsey":"Guernsey","Accra":"Ghana","Banjul":"Gambia","Conakry":"Guinea","Guadeloupe":"Guadeloupe","Malabo":"Equatorial Guinea","Zagreb":"Croatia","Isle_of_Man":"Isle of Man","Jersey":"Jersey","Phnom_Penh":"Cambodia","Comoro":"Comoros","St_Kitts":"St Kitts & Nevis","Kuwait":"Kuwait","Cayman":"Cayman Islands","Vientiane":"Laos","St_Lucia":"St Lucia","Vaduz":"Liechtenstein","Maseru":"Lesotho","Podgorica":"Montenegro","Marigot":"St Martin (French)","Antananarivo":"Madagascar","Skopje":"North Macedonia","Bamako":"Mali","Saipan":"Northern Mariana Islands","Nouakchott":"Mauritania","Montserrat":"Montserrat","Blantyre":"Malawi","Niamey":"Niger","Muscat":"Oman","Kigali":"Rwanda","St_Helena":"St Helena","Ljubljana":"Slovenia","Longyearbyen":"Svalbard & Jan Mayen","Bratislava":"Slovakia","Freetown":"Sierra Leone","San_Marino":"San Marino","Dakar":"Senegal","Mogadishu":"Somalia","Lower_Princes":"St Maarten (Dutch)","Mbabane":"Eswatini (Swaziland)","Lome":"Togo","Port_of_Spain":"Trinidad & Tobago","Dar_es_Salaam":"Tanzania","Kampala":"Uganda","Midway":"US minor outlying islands","Vatican":"Vatican City","St_Vincent":"St Vincent","Tortola":"Virgin Islands (UK)","St_Thomas":"Virgin Islands (US)","Aden":"Yemen","Mayotte":"Mayotte","Lusaka":"Zambia","Harare":"Zimbabwe"}');
// EXTERNAL MODULE: ./utils/browserUtils.ts
var browserUtils = __webpack_require__(50437);
// EXTERNAL MODULE: ./utils/cookie-utiils.ts
var cookie_utiils = __webpack_require__(51119);
// EXTERNAL MODULE: ./utils/events-utils.js
var events_utils = __webpack_require__(42477);
// EXTERNAL MODULE: ./utils/utm_utils.ts
var utm_utils = __webpack_require__(86147);
;// CONCATENATED MODULE: ./scripts/segment.ts











var timestamp = "NA";
var utmDetails = (0,utm_utils/* getUtmData */.M)(null);
var userId = (0,cookie_utiils/* getCookie */.ej)(null, "user_id");
var userCountry;
var gaClientId = (0,cookie_utiils/* getCookie */.ej)(null, "_ga");
if (Intl) {
    var userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var tzArr = userTimeZone.split("/");
    var userCity = tzArr[tzArr.length - 1];
    userCountry = tz_cities_to_countries_namespaceObject[userCity];
}
var trackPage = function(name, properties) {
    var eventName = "Page Viewed";
    var isMefuUser = (0,utils/* checkIfMefuUser */.ZY)();
    var props = (0,_object_spread/* default */.Z)({
        pageName: name || "NA",
        pageUrl: window.location.href || "NA",
        utmCampaign: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmCampaign) || "NA",
        gclid: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.gclid) || "NA",
        adName: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adName) || "NA",
        utmSource: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmSource) || "NA",
        utmTerm: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmTerm) || "NA",
        adId: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adId) || "NA",
        platform: lib/* isMobile */.tq ? "Mweb" : "WEB",
        timestamp: timestamp,
        ShownSlots: JSON.stringify(properties === null || properties === void 0 ? void 0 : properties.slots) || "NA",
        referrer: (document === null || document === void 0 ? void 0 : document.referrer) || "NA",
        screenHeight: window === null || window === void 0 ? void 0 : window.screen.height,
        screenWidth: window === null || window === void 0 ? void 0 : window.screen.width,
        OS: lib/* osName */.BF,
        stage: (properties === null || properties === void 0 ? void 0 : properties.stage) || "NA",
        eventId: (properties === null || properties === void 0 ? void 0 : properties.eventId) || "NA",
        country: userCountry || "N/A",
        payType: (properties === null || properties === void 0 ? void 0 : properties.payType) || "NA",
        userId: (properties === null || properties === void 0 ? void 0 : properties.userId) || "N/A",
        gaClientId: gaClientId || "NA",
        leadSource: (properties === null || properties === void 0 ? void 0 : properties.leadSource) || "NA",
        flowType: (properties === null || properties === void 0 ? void 0 : properties.flowType) || "NA"
    }, properties);
    var userPayload = (0,_object_spread/* default */.Z)({
        isMefuUser: isMefuUser !== null && isMefuUser !== void 0 ? isMefuUser : "N/A"
    }, properties === null || properties === void 0 ? void 0 : properties.slotInfo);
    if (window.analytics) {
        window.analytics.track(eventName, props);
        window.analytics.identify(properties === null || properties === void 0 ? void 0 : properties.userId, userPayload);
    }
};
var trackPageExit = function(name, properties) {
    var eventName = "Page Exit";
    var props = {
        pageName: name || "NA",
        pageUrl: window.location.href || "NA",
        utmCampaign: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmCampaign) || "NA",
        utmSource: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmSource) || "NA",
        gclid: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.gclid) || "NA",
        adName: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adName) || "NA",
        utmTerm: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmTerm) || "NA",
        adId: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adId) || "NA",
        platform: lib/* isMobile */.tq ? "Mweb" : "WEB",
        timestamp: timestamp,
        referrer: (document === null || document === void 0 ? void 0 : document.referrer) || "NA",
        screenHeight: window === null || window === void 0 ? void 0 : window.screen.height,
        screenWidth: window === null || window === void 0 ? void 0 : window.screen.width,
        OS: lib/* osName */.BF,
        eventId: (properties === null || properties === void 0 ? void 0 : properties.eventId) || "NA",
        gaClientId: gaClientId || "NA"
    };
    if (window.analytics) {
        window.analytics.track(eventName, props);
    }
};
var trackPageV2 = function(name, properties) {
    var eventName = "Page Viewed";
    var props = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        pageName: name || "NA",
        pageUrl: window.location.href || "NA",
        utmCampaign: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmCampaign) || "NA",
        utmSource: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmSource) || "NA",
        utmTerm: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmTerm) || "NA",
        gclid: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.gclid) || "NA",
        adName: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adName) || "NA",
        adId: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adId) || "NA",
        utmMedium: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmMedium) || "NA",
        platform: lib/* isMobile */.tq ? "Mweb" : "WEB",
        timestamp: timestamp,
        referrer: (document === null || document === void 0 ? void 0 : document.referrer) || "NA",
        screenHeight: window === null || window === void 0 ? void 0 : window.screen.height,
        screenWidth: window === null || window === void 0 ? void 0 : window.screen.width,
        OS: lib/* osName */.BF,
        eventId: (properties === null || properties === void 0 ? void 0 : properties.eventId) || "NA",
        Platform: (0,events_utils.getPlatform)(),
        country: userCountry || "N/A"
    }, properties), {
        gaClientId: gaClientId || "NA"
    });
    if (window.analytics) {
        window.analytics.track(eventName, props);
    }
};
var trackPageViewWithContent = function(name, props) {
    var eventName = "Page Viewed";
    var data = {
        pageName: name || "NA",
        pageUrl: window.location.href || "NA",
        contentName: (props === null || props === void 0 ? void 0 : props.contentName) || "NA",
        contentFormat: props.contentFormat || "NA",
        utmCampaign: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmCampaign) || "NA",
        gclid: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.gclid) || "NA",
        adName: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adName) || "NA",
        utmSource: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmSource) || "NA",
        utmTerm: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmTerm) || "NA",
        adId: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adId) || "NA",
        platform: lib/* isMobile */.tq ? "Mweb" : "WEB",
        timestamp: timestamp,
        screenHeight: window === null || window === void 0 ? void 0 : window.screen.height,
        screenWidth: window === null || window === void 0 ? void 0 : window.screen.width,
        OS: lib/* osName */.BF,
        modalName: props === null || props === void 0 ? void 0 : props.modalName,
        applicationStage: props === null || props === void 0 ? void 0 : props.applicationStage,
        Platform: (0,events_utils.getPlatform)(),
        screenType: props.screenType || "NA",
        gaClientId: gaClientId || "NA"
    };
    var userPayload = {
        pageName: window.location.href || "NA",
        utmCampaign: props.utmCampaign || "NA",
        gclid: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.gclid) || "NA",
        adName: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adName) || "NA",
        utmSource: (props === null || props === void 0 ? void 0 : props.utmSource) || "NA",
        utmTerm: (props === null || props === void 0 ? void 0 : props.utmTerm) || "NA",
        adId: (props === null || props === void 0 ? void 0 : props.adId) || "NA",
        flowType: props.flowType || "NA",
        subscribedToWhatsapp: true,
        userId: (props === null || props === void 0 ? void 0 : props.userId) || "NA",
        phone: (props === null || props === void 0 ? void 0 : props.phone) ? props === null || props === void 0 ? void 0 : props.phone : undefined,
        timestamp: timestamp,
        country: (props === null || props === void 0 ? void 0 : props.country) || userCountry || "NA"
    };
    if (window.analytics) {
        window.analytics.track(eventName, data);
        window.analytics.identify(props === null || props === void 0 ? void 0 : props.userId, userPayload);
    }
};
var trackClick = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(name, props, eventType) {
        var eventName, isMefuUser, data, userPayload;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    eventName = eventType !== null && eventType !== void 0 ? eventType : "Click";
                    isMefuUser = (0,utils/* checkIfMefuUser */.ZY)();
                    data = (0,_object_spread/* default */.Z)({
                        pageName: name || "NA",
                        widgetFormat: props.widgetFormat || "NA",
                        widgetName: props.widgetName || "NA",
                        contentName: props.contentName || "NA",
                        contentFormat: props.contentFormat || "NA",
                        utmCampaign: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmCampaign) || "NA",
                        utmSource: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmSource) || "NA",
                        utmTerm: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmTerm) || "NA",
                        adId: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adId) || "NA",
                        gclid: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.gclid) || "NA",
                        adName: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adName) || "NA",
                        timestamp: timestamp || "NA",
                        from: (props === null || props === void 0 ? void 0 : props.from) || "NA",
                        selectedSlot: (props === null || props === void 0 ? void 0 : props.selectedSlot) || "NA",
                        phone: (props === null || props === void 0 ? void 0 : props.phone) || "NA",
                        cardNumber: (props === null || props === void 0 ? void 0 : props.cardNumber) || "NA",
                        platform: lib/* isMobile */.tq ? "Mweb" : "WEB",
                        sectionName: (props === null || props === void 0 ? void 0 : props.sectionName) || "NA",
                        eventCategory: (props === null || props === void 0 ? void 0 : props.eventCategory) || "NA",
                        screenHeight: window === null || window === void 0 ? void 0 : window.screen.height,
                        screenWidth: window === null || window === void 0 ? void 0 : window.screen.width,
                        OS: lib/* osName */.BF,
                        applicationStage: props === null || props === void 0 ? void 0 : props.applicationStage,
                        howLeapHelp: (props === null || props === void 0 ? void 0 : props.howLeapHelp) || "NA",
                        passportStatus: (props === null || props === void 0 ? void 0 : props.passportStatus) || "NA",
                        counsellorRecommendationId: (props === null || props === void 0 ? void 0 : props.counsellorRecommendationId) || "NA",
                        payType: (props === null || props === void 0 ? void 0 : props.payType) || "NA",
                        error: (props === null || props === void 0 ? void 0 : props.error) || "NA",
                        rating: props === null || props === void 0 ? void 0 : props.rating,
                        reason: props === null || props === void 0 ? void 0 : props.reason,
                        collegeName: (props === null || props === void 0 ? void 0 : props.collegeName) || "NA",
                        gaClientId: gaClientId || "NA",
                        preferencesMatchCount: (props === null || props === void 0 ? void 0 : props.preferencesMatchCount) || "NA",
                        pageUrl: window.location.href || "NA",
                        utmMedium: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmMedium) || "NA",
                        pageCategory: (props === null || props === void 0 ? void 0 : props.pageCategory) || "NA",
                        stage: (props === null || props === void 0 ? void 0 : props.stage) || "NA",
                        Platform: (0,events_utils.getPlatform)()
                    }, props);
                    userPayload = {
                        isMefuUser: isMefuUser !== null && isMefuUser !== void 0 ? isMefuUser : "N/A"
                    };
                    if (!window.analytics) {
                        _ctx.next = 9;
                        break;
                    }
                    _ctx.next = 7;
                    return window.analytics.track(eventName, data);
                case 7:
                    _ctx.next = 9;
                    return window.analytics.identify(props.userId, userPayload);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function trackClick(name, props, eventType) {
        return _ref.apply(this, arguments);
    };
}();
var trackIdentity = function(eventName, props) {
    if (window.analytics) {
        window.analytics.identify(eventName, props);
    }
};
var trackIdentityV2 = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(eventName, props) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!window.analytics) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", fallBackAnalytics(new Promise(function(resolve) {
                        window.analytics.identify(eventName, props, {}, function() {
                            resolve(true);
                        });
                    })));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function trackIdentityV2(eventName, props) {
        return _ref.apply(this, arguments);
    };
}();
var trackEvent = function(eventName, props) {
    if (window.analytics) {
        window.analytics.track(eventName, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            gaClientId: gaClientId || "NA"
        }));
    }
};
var trackIeltsEvent = function(eventName, props) {
    props = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        utmCampaign: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmCampaign) || "NA",
        utmSource: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmSource) || "NA",
        utmTerm: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmTerm) || "NA",
        adId: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adId) || "NA",
        gclid: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.gclid) || "NA",
        adName: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adName) || "NA",
        referrer: (document === null || document === void 0 ? void 0 : document.referrer) || "NA",
        Platform: (0,events_utils.getPlatform)(),
        gaClientId: gaClientId || "NA"
    });
    if (window.analytics) {
        window.analytics.track(eventName, props);
    }
};
var trackPayment = function(eventName, props) {
    if (window.analytics) {
        window.analytics.track(eventName, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            gaClientId: gaClientId || "NA"
        }));
    }
};
var trackSignup = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(eventName, props) {
        var eventPayload, userPayload;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!window.analytics) {
                        _ctx.next = 7;
                        break;
                    }
                    eventPayload = (0,_object_spread/* default */.Z)({
                        pageName: window.location.href || "NA",
                        authType: props.authType || "NA",
                        utmCampaign: props.utmCampaign || "NA",
                        utmSource: (props === null || props === void 0 ? void 0 : props.utmSource) || "NA",
                        utmTerm: (props === null || props === void 0 ? void 0 : props.utmTerm) || "NA",
                        gclid: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.gclid) || "NA",
                        adName: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adName) || "NA",
                        adId: (props === null || props === void 0 ? void 0 : props.adId) || "NA",
                        flowType: props.flowType || "NA",
                        subscribedToWhatsapp: true,
                        timestamp: timestamp,
                        country: (props === null || props === void 0 ? void 0 : props.country) || "NA",
                        Platform: (0,events_utils.getPlatform)(),
                        gaClientId: gaClientId || "NA"
                    }, props);
                    userPayload = (0,_object_spread/* default */.Z)({
                        pageName: window.location.href || "NA",
                        utmCampaign: props.utmCampaign || "NA",
                        utmSource: (props === null || props === void 0 ? void 0 : props.utmSource) || "NA",
                        utmTerm: (props === null || props === void 0 ? void 0 : props.utmTerm) || "NA",
                        gclid: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.gclid) || "NA",
                        adName: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adName) || "NA",
                        adId: (props === null || props === void 0 ? void 0 : props.adId) || "NA",
                        flowType: props.flowType || "NA",
                        subscribedToWhatsapp: true,
                        userId: (props === null || props === void 0 ? void 0 : props.userId) || "NA",
                        phone: (props === null || props === void 0 ? void 0 : props.phone) ? props === null || props === void 0 ? void 0 : props.phone : undefined,
                        timestamp: timestamp,
                        country: (props === null || props === void 0 ? void 0 : props.country) || "NA"
                    }, props);
                    _ctx.next = 5;
                    return window.analytics.identify(props.userId, userPayload);
                case 5:
                    _ctx.next = 7;
                    return window.analytics.track(eventName, eventPayload);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function trackSignup(eventName, props) {
        return _ref.apply(this, arguments);
    };
}();
var trackForm = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(eventName, props) {
        var ref, ref1, ref2, eventPayload, userPayload;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (window.analytics) {
                        ;
                        eventPayload = (0,_object_spread/* default */.Z)({
                            formType: (props === null || props === void 0 ? void 0 : props.formType) || "NA",
                            formId: (props === null || props === void 0 ? void 0 : props.formId) || "NA",
                            utmCampaign: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmCampaign) || "NA",
                            utmSource: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmSource) || "NA",
                            utmTerm: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmTerm) || "NA",
                            adId: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adId) || "NA",
                            gclid: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.gclid) || "NA",
                            adName: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adName) || "NA",
                            timestamp: timestamp,
                            phone: (props === null || props === void 0 ? void 0 : props.phone) || "NA",
                            name: (props === null || props === void 0 ? void 0 : props.name) || "NA",
                            Platform: (0,events_utils.getPlatform)(),
                            howLeapHelp: (props === null || props === void 0 ? void 0 : props.howLeapHelp) || "NA",
                            pageUrl: (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href) || "NA",
                            gaClientId: gaClientId || "NA"
                        }, props);
                        userPayload = (0,_object_spread/* default */.Z)({
                            admitStatus: (props === null || props === void 0 ? void 0 : (ref1 = props.admitDetails) === null || ref1 === void 0 ? void 0 : ref1.admitStatus) || (props === null || props === void 0 ? void 0 : props.admitStatus) || "NA",
                            college: (props === null || props === void 0 ? void 0 : props.college) || "NA",
                            consultant: (props === null || props === void 0 ? void 0 : props.consultant) || "NA",
                            helpForAdmit: (props === null || props === void 0 ? void 0 : props.helpForAdmit) || "NA",
                            email: (props === null || props === void 0 ? void 0 : props.email) ? props === null || props === void 0 ? void 0 : props.email : undefined,
                            gradeMetric: (props === null || props === void 0 ? void 0 : props.gradeMetric) || "NA",
                            grades: (props === null || props === void 0 ? void 0 : props.grades) || "NA",
                            highestLevelEducation: (props === null || props === void 0 ? void 0 : props.highestLevelEducation) || "NA",
                            ieltsStatus: (props === null || props === void 0 ? void 0 : props.ieltsStatus) || "NA",
                            journeyStatus: (props === null || props === void 0 ? void 0 : props.journeyStatus) || "NA",
                            payOfExpenses: (props === null || props === void 0 ? void 0 : props.payOfExpenses) || "NA",
                            preferredCountry: (props === null || props === void 0 ? void 0 : props.preferredCountry) || "NA",
                            preferredIntake: (props === null || props === void 0 ? void 0 : props.preferredIntake) || "NA",
                            preferredProgram: (props === null || props === void 0 ? void 0 : props.preferredProgram) || "NA",
                            timestamp: timestamp,
                            ieltsType: (props === null || props === void 0 ? void 0 : props.ieltsType) || "NA",
                            ieltsPurpose: (props === null || props === void 0 ? void 0 : props.ieltsPurpose) || "NA",
                            ieltsMonth: (props === null || props === void 0 ? void 0 : props.ieltsMonth) || "NA",
                            ieltsYear: (props === null || props === void 0 ? void 0 : props.ieltsYear) || "NA",
                            phone: (props === null || props === void 0 ? void 0 : props.phone) ? props === null || props === void 0 ? void 0 : props.phone : undefined,
                            name: (props === null || props === void 0 ? void 0 : props.name) ? props === null || props === void 0 ? void 0 : props.name : undefined,
                            howLeapHelp: (props === null || props === void 0 ? void 0 : props.howLeapHelp) || "NA",
                            pageUrl: (window === null || window === void 0 ? void 0 : (ref2 = window.location) === null || ref2 === void 0 ? void 0 : ref2.href) || "NA"
                        }, props);
                        window.analytics.identify(userId, userPayload);
                        window.analytics.track(eventName, eventPayload);
                    }
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function trackForm(eventName, props) {
        return _ref.apply(this, arguments);
    };
}();
var trackReferral = function(eventName, props, userId) {
    if (window.analytics) {
        var eventPayload = {
            formId: (props === null || props === void 0 ? void 0 : props.formId) || "NA",
            createdAt: new Date(),
            referrerName: (props === null || props === void 0 ? void 0 : props.referrerName) || "NA",
            referrerPhone: (props === null || props === void 0 ? void 0 : props.referrerPhone) || "NA",
            referrerUserId: (props === null || props === void 0 ? void 0 : props.referrerUserId) || "NA",
            refereeName: (props === null || props === void 0 ? void 0 : props.refereeName) || "NA",
            refereePhone: (props === null || props === void 0 ? void 0 : props.refereePhone) || "NA",
            refereeUserId: (props === null || props === void 0 ? void 0 : props.refereeUserId) || "NA",
            gaClientId: gaClientId || "NA"
        };
        window.analytics.track(eventName, eventPayload, {
            userId: userId
        });
        window.analytics.identify(userId, {});
    }
};
var trackProduct = function(eventName, props) {
    if (window.analytics) {
        var eventPayload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            timestamp: timestamp,
            gaClientId: gaClientId || "NA"
        });
        var userPayload = {
            eventCategory: (props === null || props === void 0 ? void 0 : props.eventCategory) || "NA",
            productCategory: (props === null || props === void 0 ? void 0 : props.productCategory) || "NA",
            cohorts: (props === null || props === void 0 ? void 0 : props.cohorts) || "NA"
        };
        window.analytics.identify(userId, userPayload);
        window.analytics.track(eventName, eventPayload);
    }
};
var trackProductFormAsync = function(eventName, props) {
    return new Promise(function(resolve) {
        if (window.analytics) {
            var eventPayload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                timestamp: timestamp,
                gaClientId: gaClientId || "NA"
            });
            var userPayload = {
                eventCategory: (props === null || props === void 0 ? void 0 : props.eventCategory) || "NA",
                productCategory: (props === null || props === void 0 ? void 0 : props.productCategory) || "NA",
                cohorts: (props === null || props === void 0 ? void 0 : props.cohorts) || "NA"
            };
            window.analytics.identify(userId, userPayload);
            window.analytics.track(eventName, eventPayload);
            resolve(true);
        }
    });
};
var trackOnboardingProduct = function(eventName, props) {
    if (window.analytics) {
        var eventPayload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            timestamp: timestamp,
            gaClientId: gaClientId || "NA"
        });
        var userPayload = {};
        window.analytics.identify(userId, userPayload);
        window.analytics.track(eventName, eventPayload);
    }
};
var segmentReset = function() {
    if (window.analytics) {
        window.analytics.reset();
    }
};
var trackIeltsClick = function(name, props) {
    var eventName = "Click";
    //  // add a new field in the array below which is passed in a set
    var eventFields = [
        "pageName",
        "pageNumber",
        "pageContent",
        "widgetFormat",
        "widgetName",
        "contentName",
        "contentFormat",
        "utmCampaign",
        "utmSource",
        "utmTerm",
        "adId",
        "timestamp",
        "eventId",
        "eventID2",
        "QuizScore",
        "eventCategory",
        "teacher",
        "startDate",
        "endDate",
        "title",
        "startTime",
        "endTime",
        "eventLink",
        "referrer",
        "sectionName",
        "filterName",
        "offerPrice",
        "Rewardstatus",
        "RewardDay",
        "RewardName",
        "Status",
        "contentPage",
        "product",
        "buttonName",
        "type",
        "EducatorName",
        "platform",
        "pageUrl",
        "bundleTitle",
        "bundleType",
        "counsellingStage",
        "course",
        "pageType",
        "recordingType",
        "filters",
        "leadSource",
        "flowType",
        "abVariant",
        "flow", 
    ];
    var eventData = eventFields.reduce(function(accumulator, currentValue) {
        if (props[currentValue] || typeof props[currentValue] === "number") {
            accumulator[currentValue] = props[currentValue];
        }
        return accumulator;
    }, {});
    var defaultFields = {
        pageName: name || "NA",
        referrer: (document === null || document === void 0 ? void 0 : document.referrer) || "NA",
        utmCampaign: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmCampaign) || "NA",
        utmSource: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmSource) || "NA",
        utmTerm: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmTerm) || "NA",
        adId: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adId) || "NA",
        gclid: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.gclid) || "NA",
        adName: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adName) || "NA",
        timestamp: timestamp || "NA",
        screenHeight: window === null || window === void 0 ? void 0 : window.screen.height,
        screenWidth: window === null || window === void 0 ? void 0 : window.screen.width,
        OS: lib/* osName */.BF,
        Platform: (0,events_utils.getPlatform)(),
        pageUrl: window.location.href
    };
    eventData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, eventData, defaultFields), {
        gaClientId: gaClientId || "NA"
    });
    if (window.analytics) {
        window.analytics.track(eventName, eventData);
    }
};
var trackEventsClick = function(name, props) {
    var ref;
    var eventName = "Click";
    var data = {
        pageName: name || "NA",
        widgetFormat: (props === null || props === void 0 ? void 0 : props.widgetFormat) || "NA",
        widgetName: (props === null || props === void 0 ? void 0 : props.widgetName) || "NA",
        contentName: (props === null || props === void 0 ? void 0 : props.contentName) || "NA",
        contentFormat: (props === null || props === void 0 ? void 0 : props.contentFormat) || "NA",
        utmCampaign: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmCampaign) || "NA",
        utmSource: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmSource) || "NA",
        utmTerm: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmTerm) || "NA",
        adId: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adId) || "NA",
        gclid: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.gclid) || "NA",
        adName: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adName) || "NA",
        timestamp: timestamp || "NA",
        eventId: "".concat((props === null || props === void 0 ? void 0 : props.eventId) || "NA"),
        eventTags: (props === null || props === void 0 ? void 0 : props.tags) || "NA",
        eventCTA: (props === null || props === void 0 ? void 0 : props.cta) || "NA",
        referrer: (document === null || document === void 0 ? void 0 : document.referrer) || "NA",
        currentPage: (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.pathname) || "NA",
        screenHeight: window === null || window === void 0 ? void 0 : window.screen.height,
        screenWidth: window === null || window === void 0 ? void 0 : window.screen.width,
        OS: lib/* osName */.BF,
        Platform: (0,events_utils.getPlatform)(),
        gaClientId: gaClientId || "NA"
    };
    if (window.analytics) {
        window.analytics.track(eventName, data);
    }
};
var trackIeltsEventAttend = function(props) {
    var eventName = "Event Attended";
    var data = {
        eventId: "".concat((props === null || props === void 0 ? void 0 : props.eventId) || "NA"),
        eventCategory: (props === null || props === void 0 ? void 0 : props.eventCategory) || "NA",
        teacher: (props === null || props === void 0 ? void 0 : props.teacher) || "NA",
        meetingDate: (props === null || props === void 0 ? void 0 : props.meetingDate) || "NA",
        title: (props === null || props === void 0 ? void 0 : props.title) || "NA",
        meetingTime: (props === null || props === void 0 ? void 0 : props.meetingTime) || "NA",
        eventLink: (props === null || props === void 0 ? void 0 : props.eventLink) || "NA",
        batchDay: (props === null || props === void 0 ? void 0 : props.batchDay) || "NA",
        Platform: (0,events_utils.getPlatform)(),
        gaClientId: gaClientId || "NA"
    };
    if (window.analytics) {
        window.analytics.track(eventName, data);
    }
};
var trackIeltsForm = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(eventName, props) {
        var email, eventPayload, userPayload;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    email = undefined;
                    if (props.email) email = props.email;
                    else if (props.emailId) email = props.emailId;
                    if (window.analytics) {
                        eventPayload = {
                            formType: (props === null || props === void 0 ? void 0 : props.formType) || "NA",
                            eventId: "".concat((props === null || props === void 0 ? void 0 : props.eventId) || "NA"),
                            pageName: (props === null || props === void 0 ? void 0 : props.pageName) || "NA",
                            widgetFormat: (props === null || props === void 0 ? void 0 : props.widgetFormat) || "NA",
                            widgetName: (props === null || props === void 0 ? void 0 : props.widgetName) || "NA",
                            contentName: (props === null || props === void 0 ? void 0 : props.contentName) || "NA",
                            contentFormat: (props === null || props === void 0 ? void 0 : props.contentFormat) || "NA",
                            utmCampaign: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmCampaign) || "NA",
                            utmSource: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmSource) || "NA",
                            utmTerm: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmTerm) || "NA",
                            adId: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adId) || "NA",
                            gclid: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.gclid) || "NA",
                            adName: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adName) || "NA",
                            rating: "".concat(props.rating || "NA"),
                            timestamp: timestamp,
                            referrer: (document === null || document === void 0 ? void 0 : document.referrer) || "NA",
                            Platform: (0,events_utils.getPlatform)(),
                            gaClientId: gaClientId || "NA"
                        };
                        userPayload = {
                            college: (props === null || props === void 0 ? void 0 : props.college) || "NA",
                            email: email,
                            highestLevelEducation: (props === null || props === void 0 ? void 0 : props.highestLevelEducation) || "NA",
                            ieltsStatus: (props === null || props === void 0 ? void 0 : props.ieltsStatus) || "NA",
                            journeyStatus: (props === null || props === void 0 ? void 0 : props.journeyStatus) || "NA",
                            payOfExpenses: (props === null || props === void 0 ? void 0 : props.payOfExpenses) || "NA",
                            preferredCountry: (props === null || props === void 0 ? void 0 : props.preferredCountry) || "NA",
                            preferredIntake: (props === null || props === void 0 ? void 0 : props.preferredIntake) || "NA",
                            preferredProgram: (props === null || props === void 0 ? void 0 : props.preferredProgram) || "NA",
                            timestamp: timestamp,
                            currentEnglishLevel: (props === null || props === void 0 ? void 0 : props.currentEnglishLevel) || "NA",
                            ieltsExamMonth: (props === null || props === void 0 ? void 0 : props.ieltsExamMonth) || "NA",
                            prefferedTimeSlot: (props === null || props === void 0 ? void 0 : props.prefferedTimeSlot) || "NA"
                        };
                        window.analytics.identify(userId, userPayload);
                        window.analytics.track(eventName, eventPayload);
                    }
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function trackIeltsForm(eventName, props) {
        return _ref.apply(this, arguments);
    };
}();
var trackIeltsFormAsync = function(eventName, props) {
    return new Promise(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(resolve) {
            var email, eventPayload, userPayload;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        email = undefined;
                        if (props.email) email = props.email;
                        else if (props.emailId) email = props.emailId;
                        eventPayload = (0,_object_spread/* default */.Z)({
                            formType: (props === null || props === void 0 ? void 0 : props.formType) || "NA",
                            eventId: "".concat((props === null || props === void 0 ? void 0 : props.eventId) || "NA"),
                            pageName: (props === null || props === void 0 ? void 0 : props.pageName) || "NA",
                            widgetFormat: (props === null || props === void 0 ? void 0 : props.widgetFormat) || "NA",
                            widgetName: (props === null || props === void 0 ? void 0 : props.widgetName) || "NA",
                            contentName: (props === null || props === void 0 ? void 0 : props.contentName) || "NA",
                            contentFormat: (props === null || props === void 0 ? void 0 : props.contentFormat) || "NA",
                            utmCampaign: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmCampaign) || "NA",
                            utmSource: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmSource) || "NA",
                            utmTerm: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmTerm) || "NA",
                            gclid: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.gclid) || "NA",
                            adName: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adName) || "NA",
                            adId: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adId) || "NA",
                            rating: "".concat(props.rating || "NA"),
                            timestamp: timestamp,
                            referrer: (document === null || document === void 0 ? void 0 : document.referrer) || "NA",
                            Platform: (0,events_utils.getPlatform)(),
                            formId: props.formId || "NA",
                            leadSource: props.leadSource || "NA",
                            gaClientId: gaClientId || "NA"
                        }, props);
                        userPayload = {
                            college: (props === null || props === void 0 ? void 0 : props.college) || "NA",
                            email: email,
                            highestLevelEducation: (props === null || props === void 0 ? void 0 : props.highestLevelEducation) || "NA",
                            ieltsStatus: (props === null || props === void 0 ? void 0 : props.ieltsStatus) || "NA",
                            journeyStatus: (props === null || props === void 0 ? void 0 : props.journeyStatus) || "NA",
                            payOfExpenses: (props === null || props === void 0 ? void 0 : props.payOfExpenses) || "NA",
                            preferredCountry: (props === null || props === void 0 ? void 0 : props.preferredCountry) || "NA",
                            preferredIntake: (props === null || props === void 0 ? void 0 : props.preferredIntake) || "NA",
                            preferredProgram: (props === null || props === void 0 ? void 0 : props.preferredProgram) || "NA",
                            timestamp: timestamp,
                            currentEnglishLevel: (props === null || props === void 0 ? void 0 : props.currentEnglishLevel) || "NA",
                            ieltsExamMonth: (props === null || props === void 0 ? void 0 : props.ieltsExamMonth) || "NA",
                            prefferedTimeSlot: (props === null || props === void 0 ? void 0 : props.prefferedTimeSlot) || "NA",
                            name: (props === null || props === void 0 ? void 0 : props.name) ? props === null || props === void 0 ? void 0 : props.name : undefined,
                            ieltsExamType: (props === null || props === void 0 ? void 0 : props.ieltsExamType) || "NA",
                            whatCareerStage: (props === null || props === void 0 ? void 0 : props.whatCareerStage) || "NA",
                            whenIelts: (props === null || props === void 0 ? void 0 : props.whenIelts) || "NA",
                            phone: (props === null || props === void 0 ? void 0 : props.phone) ? props === null || props === void 0 ? void 0 : props.phone : undefined
                        };
                        if (!window.analytics) {
                            _ctx.next = 8;
                            break;
                        }
                        _ctx.next = 7;
                        return Promise.all([
                            trackIdentityV2(userId, userPayload),
                            trackEventAsync(eventName, eventPayload), 
                        ]);
                    case 7:
                        resolve(true);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(resolve) {
            return _ref.apply(this, arguments);
        };
    }());
};
var trackIeltsPayment = function(props) {
    if (window.analytics) {
        window.analytics.track("Payment Successful", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            utm_campaign: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmCampaign) || "NA",
            utm_Source: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmSource) || "NA",
            utm_term: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmTerm) || "NA",
            gclid: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.gclid) || "NA",
            adName: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adName) || "NA",
            ad_id: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adId) || "NA",
            timestamp: timestamp,
            referrer: (document === null || document === void 0 ? void 0 : document.referrer) || "NA",
            Platform: (0,events_utils.getPlatform)(),
            gaClientId: gaClientId || "NA"
        }));
    }
};
var trackIeltsError = function(props) {
    var eventName = "Error";
    var data = {
        eventId: "".concat((props === null || props === void 0 ? void 0 : props.eventId) || "NA"),
        eventCategory: (props === null || props === void 0 ? void 0 : props.eventCategory) || "NA",
        meetingDate: (props === null || props === void 0 ? void 0 : props.meetingDate) || "NA",
        title: (props === null || props === void 0 ? void 0 : props.title) || "NA",
        teacher: (props === null || props === void 0 ? void 0 : props.teacher) || "NA",
        meetingTime: (props === null || props === void 0 ? void 0 : props.meetingTime) || "NA",
        eventLink: (props === null || props === void 0 ? void 0 : props.eventLink) || "NA",
        errorCategory: (props === null || props === void 0 ? void 0 : props.errorCategory) || "NA",
        errorMessage: (props === null || props === void 0 ? void 0 : props.errorMessage) || "NA",
        Platform: (0,events_utils.getPlatform)(),
        gaClientId: gaClientId || "NA"
    };
    if (window.analytics) {
        window.analytics.track(eventName, data);
    }
};
var trackFileUpload = function(name, props) {
    var eventName = "Document Uploaded";
    var data = {
        pageName: name || "NA",
        fileType: (props === null || props === void 0 ? void 0 : props.fileType) || "NA",
        fileCategory: (props === null || props === void 0 ? void 0 : props.fileCategory) || "NA",
        fileName: (props === null || props === void 0 ? void 0 : props.fileName) || "NA",
        uploadSource: (props === null || props === void 0 ? void 0 : props.uploadSource) || "NA",
        utmCampaign: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmCampaign) || "NA",
        utmSource: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmSource) || "NA",
        utmTerm: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmTerm) || "NA",
        adId: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adId) || "NA",
        gclid: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.gclid) || "NA",
        adName: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adName) || "NA",
        referrer: (document === null || document === void 0 ? void 0 : document.referrer) || "NA",
        gaClientId: gaClientId || "NA"
    };
    if (window.analytics) {
        window.analytics.track(eventName, data);
    }
};
var trackVideo = function(props) {
    var eventName = "Watch Video";
    var data = {
        videoName: props.videoName || "NA",
        videoId: props.videoId || "NA",
        videoUrl: props.videoUrl || "NA",
        watchDuration: props.watchDuration || "NA",
        utmCampaign: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmCampaign) || "NA",
        gclid: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.gclid) || "NA",
        adName: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adName) || "NA",
        utmSource: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmSource) || "NA",
        utmTerm: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmTerm) || "NA",
        adId: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adId) || "NA",
        timestamp: timestamp || "NA",
        gaClientId: gaClientId || "NA"
    };
    if (window.analytics) {
        window.analytics.track(eventName, data);
    }
};
var trackCalendarMeetingEvent = function(name, props) {
    var eventName = props.eventName || "";
    var data = {
        EventCategory: "Office Hour",
        EventID: "NA",
        Counsellor: props.CounsellorName,
        Speaker: "NA",
        Host: "NA",
        EventDate: props.date,
        EventTime: props.time,
        utmCampaign: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmCampaign) || "NA",
        gclid: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.gclid) || "NA",
        adName: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adName) || "NA",
        utmSource: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmSource) || "NA",
        utmTerm: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmTerm) || "NA",
        adId: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adId) || "NA",
        gaClientId: gaClientId || "NA"
    };
    if (window.analytics) {
        window.analytics.track(eventName, data);
    }
};
var trackEventAsync = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(name, props) {
        var eventName;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    eventName = name || "";
                    if (!window.analytics) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return", fallBackAnalytics(new Promise(function(resolve) {
                        window.analytics.track(eventName, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                            utmCampaign: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmCampaign) || "NA",
                            utmSource: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmSource) || "NA",
                            utmTerm: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmTerm) || "NA",
                            gclid: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.gclid) || "NA",
                            adName: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adName) || "NA",
                            utmMedium: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmMedium) || "NA",
                            adId: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adId) || "NA",
                            Platform: (0,events_utils.getPlatform)(),
                            platform: (0,events_utils.getPlatform)(),
                            gaClientId: gaClientId || "NA"
                        }), {}, function() {
                            resolve(true);
                        });
                    })));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function trackEventAsync(name, props) {
        return _ref.apply(this, arguments);
    };
}();
var slotShown = function(properties) {
    var eventName = "Slots Shown";
    var props = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        pageName: "Slots Shown",
        pageUrl: window.location.href || "NA",
        utmCampaign: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmCampaign) || "NA",
        utmSource: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmSource) || "NA",
        utmTerm: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmTerm) || "NA",
        adId: (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adId) || "NA",
        platform: lib/* isMobile */.tq ? "Mweb" : "WEB",
        timestamp: timestamp,
        shownSlots: (properties === null || properties === void 0 ? void 0 : properties.slots) || "NA",
        slotCount: (properties === null || properties === void 0 ? void 0 : properties.slotCount) || "NA",
        referrer: (document === null || document === void 0 ? void 0 : document.referrer) || "NA",
        screenHeight: window === null || window === void 0 ? void 0 : window.screen.height,
        screenWidth: window === null || window === void 0 ? void 0 : window.screen.width,
        OS: lib/* osName */.BF,
        eventId: (properties === null || properties === void 0 ? void 0 : properties.eventId) || "NA",
        country: userCountry || "N/A"
    }, properties), {
        gaClientId: gaClientId || "NA"
    });
    if (window.analytics) {
        window.analytics.track(eventName, props);
        window.analytics.identify(properties === null || properties === void 0 ? void 0 : properties.userId, {});
    }
};
var trackUserDevice = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    if (!window.analytics) {
                        _ctx.next = 4;
                        break;
                    }
                    _ctx.next = 4;
                    return (0,browserUtils/* getUserDeviceName */.vM)().then(function(deviceName) {
                        return deviceName && new Promise(function(resolve) {
                            window.analytics.identify(userId, {
                                deviceModel: deviceName
                            }, {}, function() {
                                resolve(true);
                            });
                        });
                    });
                case 4:
                    _ctx.next = 9;
                    break;
                case 6:
                    _ctx.prev = 6;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log("err", _ctx.t0);
                case 9:
                    return _ctx.abrupt("return");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                6
            ]
        ]);
    }));
    return function trackUserDevice() {
        return _ref.apply(this, arguments);
    };
}();
var fallBackAnalytics = function(cb) {
    return new Promise(function(resolve) {
        var timer = setTimeout(function() {
            resolve(true);
            clearTimeout(timer);
        }, 900);
        cb.then(function() {
            resolve(true);
            clearTimeout(timer);
        });
    });
};


/***/ }),

/***/ 14117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ service_api; }
});

// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(6154);
;// CONCATENATED MODULE: ./utils/networkUtils.ts
var buildAuthUrl = function(auth_page, callbackPath, utmSource, utmCampaign, utmTerm, gclid, adName) {
    var finalUrl = "/".concat(auth_page, "?redirected=true&callbackUrl=").concat(encodeURIComponent(callbackPath || ""));
    if (utmSource) finalUrl += "&utm_source=".concat(utmSource);
    if (utmCampaign) finalUrl += "&utm_campaign=".concat(utmCampaign);
    if (utmTerm) finalUrl += "&utm_term=".concat(utmTerm);
    if (gclid) finalUrl += "&gclid=".concat(gclid);
    if (adName) finalUrl += "&ad_name=".concat(adName);
    return finalUrl;
};
var getRedirectLoginPath = function() {
    if (true) {
        var callbackUrl = window.location.pathname + window.location.search + window.location.hash;
        var auth_page = null;
        var url = new URL("https://test.com" + callbackUrl);
        auth_page = url.searchParams.get("auth_page");
        var utmSource = url.searchParams.get("utm_source") || undefined;
        var utmCampaign = url.searchParams.get("utm_campaign") || undefined;
        var gclid = url.searchParams.get("gclid") || undefined;
        var adName = url.searchParams.get("ad_name") || undefined;
        var utmTerm = url.searchParams.get("utm_term") || undefined;
        var pageName = auth_page && auth_page !== "" ? auth_page : "login";
        return buildAuthUrl(pageName, callbackUrl, utmSource, utmCampaign, utmTerm, gclid, adName);
    }
    return "/";
};

;// CONCATENATED MODULE: ./service/api.ts


// Add a request interceptor
var api = axios/* default.create */.Z.create();
api.interceptors.response.use(function(response) {
    return response;
}, function(error) {
    var ref, ref1;
    if ((((ref = error.response) === null || ref === void 0 ? void 0 : ref.status) === 403 || ((ref1 = error.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 401) && "object" !== "undefined") {
        api.get("/api/logout").then(function(res) {
            var loginRedirect = getRedirectLoginPath();
            window.open(loginRedirect, "_self");
        }).catch(function(err) {
            return Promise.reject(err);
        });
    } else return Promise.reject(error);
});
/* harmony default export */ var service_api = (api);


/***/ }),

/***/ 96683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ withWindowDimensions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76166);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85518);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23279);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_3__);









function withWindowDimensions(WrappedComponent) {
    return /*#__PURE__*/ function(Component) {
        "use strict";
        (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_class, Component);
        var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_class);
        function _class() {
            (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, _class);
            var _this;
            _this = _super.apply(this, arguments);
            _this.state = {
                width: 0,
                height: 0
            };
            _this.updateWindowDimensions = function() {
                _this.setState({
                    width: window.innerWidth,
                    height: window.innerHeight
                });
            };
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this.updateWindowDimensions();
            window.addEventListener("resize", lodash_debounce__WEBPACK_IMPORTED_MODULE_3___default()(this.updateWindowDimensions, 800));
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            window.removeEventListener("resize", lodash_debounce__WEBPACK_IMPORTED_MODULE_3___default()(this.updateWindowDimensions, 800));
        };
        _proto.render = function render() {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, this.props), {
                windowWidth: this.state.width,
                windowHeight: this.state.height,
                isMobileSized: react_device_detect__WEBPACK_IMPORTED_MODULE_2__/* .isMobile */ .tq
            }));
        };
        return _class;
    }(react__WEBPACK_IMPORTED_MODULE_1__.Component);
};


/***/ }),

/***/ 67834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gp": function() { return /* binding */ getPriceBundleName; },
/* harmony export */   "Gz": function() { return /* binding */ getLectureDateText; },
/* harmony export */   "I6": function() { return /* binding */ repackUpcomingClass; },
/* harmony export */   "IK": function() { return /* binding */ getNextClassDate; },
/* harmony export */   "IT": function() { return /* binding */ hideScheduleClassList; },
/* harmony export */   "Q0": function() { return /* binding */ getLectureNumber; },
/* harmony export */   "aj": function() { return /* binding */ reduceOnlineWorkshopEnrollment; },
/* harmony export */   "cJ": function() { return /* binding */ getLectureTime; },
/* harmony export */   "eq": function() { return /* binding */ getLectureDetails; },
/* harmony export */   "f4": function() { return /* binding */ classIsLive; },
/* harmony export */   "r6": function() { return /* binding */ getDateBundler; },
/* harmony export */   "zy": function() { return /* binding */ getLectureDateObject; }
/* harmony export */ });
/* unused harmony exports filterLiveClass, excludeTimeFromDate, getFilteredBatchesMap, getDateText */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29815);
/* harmony import */ var DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93957);
/* harmony import */ var DataMapper_IeltsSection_valueProps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64461);
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46971);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var utils_ielts_batch_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5438);
/* harmony import */ var utils_timeUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10459);
/* eslint-disable prefer-spread */ 








var filterLiveClass = function(data) {
    return moment(data.meetingStartTime) <= moment() && moment(data.meetingEndTime) > moment();
};
var repackUpcomingClass = function(data, cb, filterPriorityList) {
    if (!cb) {
        if (!filterPriorityList) {
            return [].concat.apply([], Object.values(data));
        } else {
            return [].concat.apply([], filterPriorityList.map(function(workshop) {
                return data[workshop];
            }));
        }
    }
    if (filterPriorityList) return [].concat.apply([], filterPriorityList.map(function(workshop) {
        return data[workshop];
    })).filter(function(data) {
        return cb ? cb(data) : true;
    });
    else return [].concat.apply([], Object.values(data)).filter(function(data) {
        return cb ? cb(data) : true;
    });
};
var reduceOnlineWorkshopEnrollment = function(result, data) {
    if (data.pricingBundleName === DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .priceBundleName.IELTS_FOUNDATION */ .F.IELTS_FOUNDATION) return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, result), {
        foundationEnrolment: result.foundationEnrolment + 1
    });
    else if (data.pricingBundleName === DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .priceBundleName.IELTS_PLUS */ .F.IELTS_PLUS) return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, result), {
        plusEnrollment: result.plusEnrollment + 1
    });
    else if (data.pricingBundleName === DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .priceBundleName.IELTS_PLUS_PREMIUM */ .F.IELTS_PLUS_PREMIUM || data.pricingBundleName === DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .priceBundleName.IELTS_PLUS_PREMIUM_2 */ .F.IELTS_PLUS_PREMIUM_2) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, result), {
            premiumEnrolment: result.premiumEnrolment + 1
        });
    } else {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, result), {
            selectBatchEnrollment: result.selectBatchEnrollment + 1,
            eliteBatchEnrollment: result.eliteBatchEnrollment + 1
        });
    }
};
var getPriceBundleName = function(priceBundle) {
    var removeIelts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (priceBundle == DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .priceBundleName.IELTS_FOUNDATION */ .F.IELTS_FOUNDATION) {
        if (removeIelts) return "Foundation";
        return "IELTS Foundation";
    }
    if ((0,utils_ielts_batch_utils__WEBPACK_IMPORTED_MODULE_3__/* .isPremiumBundleCheck */ .O9)(priceBundle)) {
        if (removeIelts) return "Premium";
        return "IELTS Premium";
    }
    if (removeIelts) return "Plus";
    return "IELTS Plus";
};
var excludeTimeFromDate = function(date) {
    var newDate = new Date();
    newDate.setDate(date.getDate());
    newDate.setMonth(date.getMonth());
    newDate.setFullYear(date.getFullYear());
    return newDate.toString();
};
var getDateBundler = function(classData) {
    var dateBundler = {};
    classData.forEach(function(value) {
        var classDate = excludeTimeFromDate(new Date(value.meetingStartTime));
        if (dateBundler[classDate]) {
            dateBundler[classDate] = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(dateBundler[classDate]).concat([
                value
            ]);
        } else {
            dateBundler[classDate] = [
                value
            ];
        }
    });
    return dateBundler;
};
var classIsLive = function(startTime, endTime) {
    return moment__WEBPACK_IMPORTED_MODULE_2___default()() >= moment__WEBPACK_IMPORTED_MODULE_2___default()(startTime) && moment__WEBPACK_IMPORTED_MODULE_2___default()() <= moment__WEBPACK_IMPORTED_MODULE_2___default()(endTime);
};
var getFilteredBatchesMap = function(upcomingIeltsBatchesData) {
    var includeIeltsPlusPart2Batches = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var BatchesToBeShown = [];
    BatchesToBeShown = upcomingIeltsBatchesData.filter(function(item) {
        return isPremiumBatch(item);
    });
    var weeksFilters = BatchesToBeShown.reduce(function(acc, curr) {
        var weeksDurationNumber = diffWeeks(curr.startTime, curr.endTime);
        if (Array.isArray(acc[weeksDurationNumber])) {
            acc[weeksDurationNumber].push(curr);
        } else {
            acc[weeksDurationNumber] = [
                curr
            ];
        }
        return acc;
    }, {});
    var typesToBeShown = Object.keys(weeksFilters).map(function(item) {
        return {
            id: parseInt(item),
            text: "".concat(item, " ").concat(parseInt(item) === 1 ? "week" : "weeks")
        };
    });
    typesToBeShown.unshift({
        id: ietlsPlusFilterData.ALL,
        text: "All"
    });
    weeksFilters[ietlsPlusFilterData.ALL] = BatchesToBeShown;
    return {
        filteredBatchesMap: weeksFilters,
        typesToBeShown: typesToBeShown
    };
};
var getDateText = function(startDate) {
    if (startDate) {
        var batchStartDateString = new Date(startDate).toDateString();
        var tommorowDateString = new Date(new Date().setDate(new Date().getDate() + 1)).toDateString();
        if (batchStartDateString === new Date().toDateString()) {
            return "Today";
        } else if (batchStartDateString === tommorowDateString) {
            return "Tommorow";
        }
        return format(new Date(startDate), "do MMMM");
    }
    return "";
};
var getNextClassDate = function(batchDate) {
    var batchClassData = batchDate.batchClassResponseDto;
    try {
        if (batchClassData) {
            var ref;
            var dayToShow = batchClassData.dayTobeShown;
            var mapOfBatches = batchClassData.mapOfDayToBatchClassTopicDto;
            if (!mapOfBatches) return batchDate.startDate;
            if (dayToShow) return mapOfBatches && mapOfBatches[dayToShow].date;
            return ((ref = Object.values(mapOfBatches).find(function(data) {
                return new Date() < new Date(data.date);
            })) === null || ref === void 0 ? void 0 : ref.date) || batchDate.startDate;
        }
    } catch (e) {
        console.log(e);
    }
    return batchDate.startDate;
};
var getLectureDetails = function(batchDate, excludeNextClass) {
    if (batchDate.batchClassResponseDto) {
        var totalClass = Object.keys(batchDate.batchClassResponseDto.mapOfDayToBatchClassTopicDto || {}).length;
        return {
            current: batchDate.batchClassResponseDto.dayTobeShown || 0,
            total: totalClass,
            str: "".concat(excludeNextClass ? batchDate.batchClassResponseDto.completedClasses : batchDate.batchClassResponseDto.dayTobeShown, "/").concat(totalClass)
        };
    } else return {
        current: 0,
        total: 0,
        str: "0/0"
    };
};
var getLectureDateText = function(batchData) {
    var day = (0,utils_timeUtils__WEBPACK_IMPORTED_MODULE_4__/* .getNextClassTiming */ .b5)(getNextClassDate(batchData));
    return "".concat(day && "".concat(day, ", ")).concat((0,date_fns_format__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(new Date(getNextClassDate(batchData)), "dd LLL"));
};
var getLectureDateObject = function(batchData) {
    var nextLectureDate = getNextClassDate(batchData);
    var day = (0,utils_timeUtils__WEBPACK_IMPORTED_MODULE_4__/* .getNextClassTiming */ .b5)(nextLectureDate);
    return {
        relativeDate: day,
        date: new Date(nextLectureDate)
    };
};
function getLectureNumber(batchDate, excludeNextClass) {
    return "Lecture ".concat(getLectureDetails(batchDate, excludeNextClass).str);
}
function getLectureTime(batchData) {
    return "".concat((0,date_fns_format__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(new Date(batchData.startTime), "hh:mm a"), "-").concat((0,date_fns_format__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(new Date(batchData.endTime), "hh:mm a"));
}
var hideScheduleClassList = function(batchData) {
    var ref;
    var classSchedule = ((ref = batchData.batchClassResponseDto) === null || ref === void 0 ? void 0 : ref.mapOfDayToBatchClassTopicDto) || null;
    if (classSchedule) {
        return !!Object.keys(classSchedule).map(function(value) {
            return classSchedule[value];
        }).find(function(value) {
            return !value.topic;
        });
    } else {
        return true;
    }
};


/***/ }),

/***/ 50437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KU": function() { return /* binding */ mobileCheck; },
/* harmony export */   "lS": function() { return /* binding */ checkUserAgentIsMobile; },
/* harmony export */   "vM": function() { return /* binding */ getUserDeviceName; }
/* harmony export */ });
/* unused harmony exports getUserOsName, removeNonAsciiChars */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);


var mobileCheck = function mobileCheck() {
    var check = false;
    if (window) {
        (function(a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
    }
    return check;
};
var checkUserAgentIsMobile = function(userAgent) {
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgent.substr(0, 4));
};
var getUserDeviceName = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", new Promise(function(resolve) {
                        if (false) {}
                        try {
                            window.navigator.userAgentData.getHighEntropyValues([
                                "model"
                            ]).then(function(ua) {
                                var model = ua["model"];
                                resolve(model);
                            });
                        } catch (e) {
                            resolve("");
                        }
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getUserDeviceName() {
        return _ref.apply(this, arguments);
    };
}();
var getUserOsName = function(reqUserAgent) {
    try {
        if (reqUserAgent || "object" != "undefined") {
            var userAgent = (reqUserAgent || window.navigator.userAgent || navigator.vendor || window.opera || "").toLowerCase();
            if (/android/i.test(userAgent)) {
                return "android";
            }
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                return "ios";
            }
            if (true) {
                return "macintosh";
            }
        }
    } catch (e) {
        console.log("err", e);
    }
    return "window";
};
var removeNonAsciiChars = function(value) {
    try {
        return value === null || value === void 0 ? void 0 : value.replace(/[^\x00-\x7F]/g, "");
    } catch (error) {
        return "";
    }
};


/***/ }),

/***/ 1576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DU": function() { return /* binding */ getPercentage; },
/* harmony export */   "a": function() { return /* binding */ getFilteredData; },
/* harmony export */   "mK": function() { return /* binding */ createOptionsObject; }
/* harmony export */ });
/* unused harmony export getYearRange */
/* harmony import */ var lodash_isArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1469);
/* harmony import */ var lodash_isArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isArray__WEBPACK_IMPORTED_MODULE_0__);

var createOptionsObject = function(arr) {
    if (arr.length) {
        var optionObject = [];
        arr.forEach(function(e) {
            optionObject.push({
                value: e,
                label: e
            });
        });
        return optionObject;
    }
};
var getFilteredData = function(status, data) {
    var updatedData = {};
    if (lodash_isArray__WEBPACK_IMPORTED_MODULE_0___default()(data)) {
        if (status === "PENDING") {
            updatedData = {
                uploaded: [],
                pending: data && data.filter(function(k) {
                    return k.documentStatus === "PENDING";
                }),
                rejected: [],
                accepted: []
            };
        } else if (status === "UPLOADED") {
            updatedData = {
                uploaded: data && data.filter(function(k) {
                    return k.documentStatus === "UPLOADED";
                }),
                pending: [],
                rejected: [],
                accepted: []
            };
        } else if (status === "VERIFIED") {
            updatedData = {
                uploaded: [],
                pending: [],
                rejected: [],
                accepted: data && data.filter(function(k) {
                    return k.documentStatus === "ACCEPTED";
                })
            };
        } else if (status === "REJECTED") {
            updatedData = {
                uploaded: [],
                pending: [],
                rejected: data && data.filter(function(k) {
                    return k.documentStatus === "REJECTED";
                }),
                accepted: []
            };
        } else {
            updatedData = {
                uploaded: data && data.filter(function(k) {
                    return k.documentStatus === "UPLOADED";
                }),
                pending: data && data.filter(function(k) {
                    return k.documentStatus === "PENDING";
                }),
                rejected: data && data.filter(function(k) {
                    return k.documentStatus === "REJECTED";
                }),
                accepted: data && data.filter(function(k) {
                    return k.documentStatus === "ACCEPTED";
                })
            };
        }
        return updatedData;
    }
};
var getPercentage = function(number, total) {
    return Math.floor(number / total * 100);
};
var getYearRange = function() {
    var backYearsRange = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10;
    var currentYear = new Date().getFullYear();
    var yearRange = [];
    var range = function(start, stop, step) {
        return Array.from({
            length: (stop - start) / step + 1
        }, function(_, i) {
            yearRange.push({
                label: (start + i * step).toString(),
                value: start + i * step
            });
        });
    };
    range(currentYear + 1, currentYear - backYearsRange, -1);
    return yearRange;
};


/***/ }),

/***/ 92177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A6": function() { return /* binding */ localStorageSetItem; },
/* harmony export */   "BX": function() { return /* binding */ getQueryParamStringFromObject; },
/* harmony export */   "GQ": function() { return /* binding */ localStorageGetItem; },
/* harmony export */   "JP": function() { return /* binding */ getFixedRandomNumberPerHour; },
/* harmony export */   "Zm": function() { return /* binding */ redirectOutFromIframe; },
/* harmony export */   "aS": function() { return /* binding */ truncateString; },
/* harmony export */   "mf": function() { return /* binding */ isFunction; },
/* harmony export */   "xT": function() { return /* binding */ getRandomNumber; }
/* harmony export */ });
/* unused harmony exports checkIfWeAreInFrame, getNumberFromEnd, joinStringWithHyphen, isReferrerSemLeapScholar */
/* harmony import */ var _utm_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86147);

var isFunction = function(data) {
    if (typeof data === "function") return true;
    return false;
};
var localStorageSetItem = function(key, value) {
    try {
        localStorage.setItem(key, JSON.stringify(value));
        return true;
    } catch (error) {
        return false;
    }
};
var localStorageGetItem = function(key) {
    try {
        var itemWeGet = localStorage.getItem(key);
        if (itemWeGet !== null) {
            return JSON.parse(itemWeGet);
        }
        return null;
    } catch (error) {
        return null;
    }
};
var getQueryParamStringFromObject = function(object) {
    var ref;
    var valuesString = Object.keys(object).map(function(key) {
        var ref;
        return ((ref = object[key]) === null || ref === void 0 ? void 0 : ref.length) > 0 ? "".concat(key, "=").concat(object[key]) : "";
    });
    valuesString = (ref = valuesString === null || valuesString === void 0 ? void 0 : valuesString.filter(function(n) {
        return n;
    })) === null || ref === void 0 ? void 0 : ref.join("&");
    valuesString = valuesString.length > 0 ? "&".concat(valuesString) : "";
    return valuesString;
};
var redirectOutFromIframe = function(url) {
    try {
        if (window && window.top) {
            window.top.location.href = url;
        }
    } catch (err) {
        console.log(err);
    }
};
var checkIfWeAreInFrame = function() {
    try {
        if (window) {
            if (window.parent.location === window.location) {
                return false;
            } else {
                return true;
            }
        }
        return false;
    } catch (error) {
        return false;
    }
};
function getFixedRandomNumberPerHour(startingNumber, endingNumber, salt) {
    var randomNumber = salt || 5144;
    var currentHour = new Date().getHours();
    var diff = endingNumber - startingNumber;
    return Math.floor(randomNumber * currentHour % diff) + startingNumber;
}
function getNumberFromEnd(str) {
    if (!str) return null;
    var regex = /(\d+)$/;
    var matches = regex.exec(str);
    if (matches && matches.length > 1) {
        return parseInt(matches[1]);
    } else {
        return null;
    }
}
var joinStringWithHyphen = function(string) {
    if (!string) return null;
    string = string.replace(/[^a-zA-Z0-9\s]/g, "").toLowerCase();
    string = string.replace(/\s+/g, "-");
    return string;
};
var truncateString = function(str, len) {
    if (str && str !== "-" && (str === null || str === void 0 ? void 0 : str.length) > len) {
        if (len <= 3) {
            return str.slice(0, len - 3) + "...";
        } else {
            return str.slice(0, len) + "...";
        }
    } else {
        return str;
    }
};
var isReferrerSemLeapScholar = function() {
    try {
        var ref, ref1;
        var utmDetails = getUtmData(null);
        var isGoogleUTMSource = (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmSource) ? (ref1 = utmDetails === null || utmDetails === void 0 ? void 0 : (ref = utmDetails.utmSource) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === null || ref1 === void 0 ? void 0 : ref1.includes("google_search") : false;
        return isGoogleUTMSource;
    } catch (error) {
        console.error(error);
        return false;
    }
};
var getRandomNumber = function(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
};


/***/ }),

/***/ 51119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$S": function() { return /* binding */ COOKIES_CONSTANT; },
/* harmony export */   "AV": function() { return /* binding */ saveUtmCookie; },
/* harmony export */   "YB": function() { return /* binding */ saveCookie; },
/* harmony export */   "ej": function() { return /* binding */ getCookie; },
/* harmony export */   "kT": function() { return /* binding */ deleteCookie; }
/* harmony export */ });
/* unused harmony export YEAR */
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62286);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(nookies__WEBPACK_IMPORTED_MODULE_0__);

var MAX_AGE = 60 * 60 * 24 * 30 // 30 days
;
var YEAR = (/* unused pure expression or super */ null && (60 * 60 * 24 * 356)) // 365 days
;
function saveCookie(ctx, key, value, ttl, sameSite) {
    (0,nookies__WEBPACK_IMPORTED_MODULE_0__.setCookie)(ctx, key, value, {
        maxAge: ttl || MAX_AGE,
        expires: ttl ? new Date(Date.now() + ttl * 1000) : new Date(Date.now() + MAX_AGE * 1000),
        httpOnly: false,
        secure:  true || 0,
        path: "/",
        sameSite: sameSite !== null && sameSite !== void 0 ? sameSite : "lax"
    });
}
function saveUtmCookie(ctx, key, value, ttl) {
    (0,nookies__WEBPACK_IMPORTED_MODULE_0__.setCookie)(ctx, key, value, {
        maxAge: ttl || MAX_AGE,
        expires: ttl ? new Date(Date.now() + ttl * 1000) : new Date(Date.now() + MAX_AGE * 1000),
        httpOnly: false,
        secure: true,
        path: "/",
        sameSite: "none"
    });
}
function deleteCookie(ctx, key) {
    (0,nookies__WEBPACK_IMPORTED_MODULE_0__.destroyCookie)(ctx, key, {
        maxAge: -1,
        path: "/"
    });
}
function getCookie(ctx, key) {
    var cookies = (0,nookies__WEBPACK_IMPORTED_MODULE_0__.parseCookies)(ctx);
    return cookies[key];
}
var COOKIES_CONSTANT = {
    TOKEN_NAME: "token",
    USER_ID: "user_id",
    ANALYTICS_USER_ID: "ajs_user_id",
    SESSION_TOKEN: "sessiontoken",
    USER_COUNTRY: "user_country",
    IP_COUNTRY_KEY: "IP_COUNTRY_KEY",
    LIY_EXAM_FORM: "LIY_EXAM_FORM"
};


/***/ }),

/***/ 20581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D7": function() { return /* binding */ checkIfMENAUser; },
/* harmony export */   "EI": function() { return /* binding */ setCountryInCookies; },
/* harmony export */   "Lu": function() { return /* binding */ ME_USERS_ALLOWED_PATHS; },
/* harmony export */   "fe": function() { return /* binding */ getDemoFormUrl; },
/* harmony export */   "gv": function() { return /* binding */ getUserCountry; },
/* harmony export */   "rZ": function() { return /* binding */ getCountry; }
/* harmony export */ });
/* unused harmony exports checkIfItsServer, checkForCountriesAndRedirect, MIDDLE_EAST_COUNTRIES, getCountryFromCookies, getStringFromQueryParams */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var DataMapper_Common_cookiesConstant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18472);
/* harmony import */ var DataMapper_CountryCode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88237);
/* harmony import */ var page_routes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12615);
/* harmony import */ var utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51119);
/* harmony import */ var service_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14117);
/* harmony import */ var DataMapper_Common_basicAuth__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24187);








var getCountry = function() {
    try {
        if (!checkIfItsServer()) {
            return localStorage.getItem("currentSelectedCountry");
        }
    } catch (error) {}
    return null;
};
var checkIfItsServer = function() {
    return "object" === "undefined";
};
var checkForCountriesAndRedirect = function(param) {
    var country = param.country, countriesNotAllowed = param.countriesNotAllowed, ctx = param.ctx, redirectUrl = param.redirectUrl, allowedPaths = param.allowedPaths, currentPath = param.currentPath;
    if (allowedPaths.find(function(item) {
        return item === currentPath;
    })) {
        return;
    }
    if (countriesNotAllowed.find(function(item) {
        return item === country;
    })) {
        if (ctx) {
            var ref, ref1;
            (ref = ctx.res) === null || ref === void 0 ? void 0 : ref.writeHead(302, {
                Location: redirectUrl
            });
            (ref1 = ctx.res) === null || ref1 === void 0 ? void 0 : ref1.end();
        } else {
            window.open(redirectUrl, "_self");
        }
    }
};
var checkIfMENAUser = function(userCountry) {
    var country = userCountry;
    if (!country && !checkIfItsServer()) {
        country = (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_4__/* .getCookie */ .ej)(null, DataMapper_Common_cookiesConstant__WEBPACK_IMPORTED_MODULE_1__/* .cookiesConstant.USER_COUNTRY */ .k.USER_COUNTRY);
    }
    if (country) {
        if (MIDDLE_EAST_COUNTRIES.find(function(item) {
            return item === country;
        })) return true;
    }
    return false;
};
var MIDDLE_EAST_COUNTRIES = [
    DataMapper_CountryCode__WEBPACK_IMPORTED_MODULE_2__/* .CountryCode.BAHRAIN */ .Cv.BAHRAIN,
    DataMapper_CountryCode__WEBPACK_IMPORTED_MODULE_2__/* .CountryCode.KUWAIT */ .Cv.KUWAIT,
    DataMapper_CountryCode__WEBPACK_IMPORTED_MODULE_2__/* .CountryCode.OMAN */ .Cv.OMAN,
    DataMapper_CountryCode__WEBPACK_IMPORTED_MODULE_2__/* .CountryCode.QATAR */ .Cv.QATAR,
    DataMapper_CountryCode__WEBPACK_IMPORTED_MODULE_2__/* .CountryCode.SAUDI */ .Cv.SAUDI,
    DataMapper_CountryCode__WEBPACK_IMPORTED_MODULE_2__/* .CountryCode.UAE */ .Cv.UAE,
    DataMapper_CountryCode__WEBPACK_IMPORTED_MODULE_2__/* .CountryCode.ALGERIA */ .Cv.ALGERIA,
    DataMapper_CountryCode__WEBPACK_IMPORTED_MODULE_2__/* .CountryCode.EGYPT */ .Cv.EGYPT,
    DataMapper_CountryCode__WEBPACK_IMPORTED_MODULE_2__/* .CountryCode.IRAN */ .Cv.IRAN,
    DataMapper_CountryCode__WEBPACK_IMPORTED_MODULE_2__/* .CountryCode.IRAQ */ .Cv.IRAQ,
    DataMapper_CountryCode__WEBPACK_IMPORTED_MODULE_2__/* .CountryCode.ISRAEL */ .Cv.ISRAEL,
    DataMapper_CountryCode__WEBPACK_IMPORTED_MODULE_2__/* .CountryCode.JORDAN */ .Cv.JORDAN,
    DataMapper_CountryCode__WEBPACK_IMPORTED_MODULE_2__/* .CountryCode.LEBANON */ .Cv.LEBANON,
    DataMapper_CountryCode__WEBPACK_IMPORTED_MODULE_2__/* .CountryCode.LIBYA */ .Cv.LIBYA,
    DataMapper_CountryCode__WEBPACK_IMPORTED_MODULE_2__/* .CountryCode.MOROCCO */ .Cv.MOROCCO,
    DataMapper_CountryCode__WEBPACK_IMPORTED_MODULE_2__/* .CountryCode.SYRIA */ .Cv.SYRIA,
    DataMapper_CountryCode__WEBPACK_IMPORTED_MODULE_2__/* .CountryCode.TUNISIA */ .Cv.TUNISIA,
    DataMapper_CountryCode__WEBPACK_IMPORTED_MODULE_2__/* .CountryCode.PALESTINE */ .Cv.PALESTINE, 
];
var ME_USERS_ALLOWED_PATHS = [
    page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.IELTS_PLUS */ .CZ.IELTS_PLUS,
    "".concat(page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.IELTS_INTERMEDIATE_SCREEN */ .CZ.IELTS_INTERMEDIATE_SCREEN, "[batchId]"),
    page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.IELTS_ALL_BATCHES */ .CZ.IELTS_ALL_BATCHES,
    page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.IELTS_BATCH_DETAILS */ .CZ.IELTS_BATCH_DETAILS,
    page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.BOOK_IELTS_DEMO_FLOW */ .CZ.BOOK_IELTS_DEMO_FLOW,
    page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.RESCHEDULE_IELTS_DEMO */ .CZ.RESCHEDULE_IELTS_DEMO,
    page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.IELTS_STUDENT_DASHBOARD */ .CZ.IELTS_STUDENT_DASHBOARD,
    page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.IELTS_STUDY_MATERIAL */ .CZ.IELTS_STUDY_MATERIAL,
    page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.IELTS_CLASS_RECORDINGS */ .CZ.IELTS_CLASS_RECORDINGS,
    page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.SELF_PREP */ .CZ.SELF_PREP, 
];
var getCountryFromCookies = function() {
    return (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_4__/* .getCookie */ .ej)(null, DataMapper_Common_cookiesConstant__WEBPACK_IMPORTED_MODULE_1__/* .cookiesConstant.IP_COUNTRY_KEY */ .k.IP_COUNTRY_KEY) || null;
};
var setCountryInCookies = function(countryName) {
    (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_4__/* .deleteCookie */ .kT)(null, DataMapper_Common_cookiesConstant__WEBPACK_IMPORTED_MODULE_1__/* .cookiesConstant.IP_COUNTRY_KEY */ .k.IP_COUNTRY_KEY);
    (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_4__/* .saveCookie */ .YB)(null, DataMapper_Common_cookiesConstant__WEBPACK_IMPORTED_MODULE_1__/* .cookiesConstant.IP_COUNTRY_KEY */ .k.IP_COUNTRY_KEY, countryName, 30 * 60);
};
var getCountryUserInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var userInfoRes, userInfo;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_5__/* ["default"].get */ .Z.get("api/scholarOpenRoute?path=user/location", {
                        headers: {
                            Authorization: DataMapper_Common_basicAuth__WEBPACK_IMPORTED_MODULE_7__/* .basicAuthToken */ .y
                        }
                    });
                case 3:
                    userInfoRes = _ctx.sent;
                    if (!userInfoRes.data.data) {
                        _ctx.next = 9;
                        break;
                    }
                    userInfo = userInfoRes.data.data;
                    return _ctx.abrupt("return", DataMapper_CountryCode__WEBPACK_IMPORTED_MODULE_2__/* .CountryList */ .TZ[userInfo.country] || DataMapper_CountryCode__WEBPACK_IMPORTED_MODULE_2__/* .CountryCode.INDIA */ .Cv.INDIA);
                case 9:
                    return _ctx.abrupt("return", DataMapper_CountryCode__WEBPACK_IMPORTED_MODULE_2__/* .CountryCode.INDIA */ .Cv.INDIA);
                case 10:
                    _ctx.next = 15;
                    break;
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", DataMapper_CountryCode__WEBPACK_IMPORTED_MODULE_2__/* .CountryCode.INDIA */ .Cv.INDIA);
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }));
    return function getCountryUserInfo() {
        return _ref.apply(this, arguments);
    };
}();
var getUserCountry = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(auth) {
        var saveCountry, ipCountry;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    saveCountry = getCountryFromCookies();
                    if (!((auth === null || auth === void 0 ? void 0 : auth.isValid) && auth.userCountry)) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", auth.userCountry);
                case 5:
                    if (!saveCountry) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", saveCountry);
                case 9:
                    _ctx.next = 11;
                    return getCountryUserInfo();
                case 11:
                    ipCountry = _ctx.sent;
                    return _ctx.abrupt("return", ipCountry || DataMapper_CountryCode__WEBPACK_IMPORTED_MODULE_2__/* .CountryCode.INDIA */ .Cv.INDIA);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getUserCountry(auth) {
        return _ref.apply(this, arguments);
    };
}();
var getDemoFormUrl = function(params, userCountry) {
    if (checkIfMENAUser(userCountry)) {
        return "".concat(page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.BOOK_IELTS_DEMO_FORM_MENA */ .CZ.BOOK_IELTS_DEMO_FORM_MENA, "&").concat(getStringFromQueryParams(params));
    } else {
        return "".concat(page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.BOOK_IELTS_DEMO_FLOW */ .CZ.BOOK_IELTS_DEMO_FLOW, "?").concat(getStringFromQueryParams(params));
    }
};
var getStringFromQueryParams = function(params) {
    return Object.keys(params).reduce(function(acc, curr, index) {
        return "".concat(acc).concat(index > 0 ? "&" : "").concat(curr, "=").concat(params[curr]);
    }, "");
};


/***/ }),

/***/ 59042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fh": function() { return /* binding */ segmentEvents; },
/* harmony export */   "NJ": function() { return /* binding */ getTags; },
/* harmony export */   "dk": function() { return /* binding */ handleFormSubmissionGaEventForm; },
/* harmony export */   "eD": function() { return /* binding */ handleQualifiedForProductGaEvent; }
/* harmony export */ });
/* harmony import */ var ga__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83138);
var nonVisibleTags = [
    "counselling_stage",
    "ielts_stage"
];

var getTags = function(tags) {
    var arr = [];
    arr = tags.filter(function(item) {
        var ref;
        return item.visible && !nonVisibleTags.includes((ref = item.tag) === null || ref === void 0 ? void 0 : ref.type);
    }).map(function(item) {
        var ref;
        return (ref = item.tag) === null || ref === void 0 ? void 0 : ref.Name;
    });
    return arr;
};
var segmentEvents = {
    OTP_ERROR: "OTP Error"
};
var handleFormSubmissionGaEventForm = function(userPayload, eventPayload) {
    var userProps = {
        preferred_country: userPayload.preferredCountry,
        preferred_intake: userPayload.preferredIntake,
        preferred_program: userPayload.preferredProgram,
        budget: userPayload.budget,
        admit_status: userPayload.admitStatus,
        highest_level_education: userPayload.highestLevelEducation,
        grades: userPayload.grades,
        grade_metric: userPayload.gradeMetric,
        ielts_status: userPayload.ieltsStatus,
        ielts_score: userPayload.ieltsScore,
        toefl_score: userPayload.toeflScore,
        pay_of_expenses: userPayload.payOfExpenses,
        highest_education_passout_year: userPayload.highestEducationPassoutYear,
        ielts_user_type: userPayload.ieltsUserType,
        how_leap_help: userPayload.howLeapHelp,
        passport_status: userPayload.passportStatus,
        lead_stage: userPayload.stage
    };
    var eventProps = {
        form_type: eventPayload.formType,
        form_id: eventPayload.formId
    };
    (0,ga__WEBPACK_IMPORTED_MODULE_0__.sendCustomGaEvent)("Form Filled", eventProps, userProps);
};
var handleQualifiedForProductGaEvent = function(userPayload, eventPayload) {
    var userProps = {
        lead_stage: userPayload.leadStage
    };
    var eventProps = {
        event_category: eventPayload.eventCategory,
        product_category: eventPayload.productCategory,
        qualification_type: eventPayload.qualificationType,
        reason_for_disqualification: eventPayload.reasonForDisqualification
    };
    (0,ga__WEBPACK_IMPORTED_MODULE_0__.sendCustomGaEvent)("Qualified for Product", eventProps, userProps);
};


/***/ }),

/***/ 42477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LeadCaptureStepsPage": function() { return /* binding */ LeadCaptureStepsPage; },
/* harmony export */   "getBatchTagName": function() { return /* binding */ getBatchTagName; },
/* harmony export */   "getBatchTagSkin": function() { return /* binding */ getBatchTagSkin; },
/* harmony export */   "getBatchType": function() { return /* binding */ getBatchType; },
/* harmony export */   "getIeltsPageName": function() { return /* binding */ getIeltsPageName; },
/* harmony export */   "getMasterClassType": function() { return /* binding */ getMasterClassType; },
/* harmony export */   "getPageName": function() { return /* binding */ getPageName; },
/* harmony export */   "getPlatform": function() { return /* binding */ getPlatform; },
/* harmony export */   "getPlatformV2": function() { return /* binding */ getPlatformV2; },
/* harmony export */   "ieltsPageName": function() { return /* binding */ ieltsPageName; },
/* harmony export */   "onboardingStepsPage": function() { return /* binding */ onboardingStepsPage; },
/* harmony export */   "pageName": function() { return /* binding */ pageName; },
/* harmony export */   "platforms": function() { return /* binding */ platforms; }
/* harmony export */ });
/* harmony import */ var DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93957);
/* harmony import */ var components_LSRevamp_ieltsPage_FreeIeltsCourse_FreeCrashCourseUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11281);
/* harmony import */ var components_LSRevamp_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69117);
/* harmony import */ var page_routes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12615);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85518);
/* harmony import */ var utils_browserUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50437);
/* harmony import */ var _ielts_batch_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5438);







var pageName = {
    Login_Modal: "Login Modal",
    Event_Join_Page: "Event Joining Page",
    Neutral_Landing_Page: "Neutral Landing Page",
    UK_Landing_Page: "UK Landing Page",
    Canada_Landing_Page: "Canada Landing Page",
    Australia_Landing_Page: "Australia Landing Page",
    USA_Landing_Page: "USA Landing Page",
    Ireland_Landing_Page: "Ireland Landing Page",
    Leapscholar_Overview_Page: (0,components_LSRevamp_utils__WEBPACK_IMPORTED_MODULE_2__/* .checkIfMefuUser */ .ZY)() === "true" ? "Leapscholar Overview Page - MeFu" : "Leapscholar Overview Page",
    My_Universities: "My Universities",
    Document_Details: "Document Details",
    Notice_Board: "Notice Board",
    Upcoming_Appointments: "Upcoming Appointments",
    Financial_Assistance: "Financial Assistance",
    Visa_Assistance: "Visa Assistance",
    Webinar_Landing_Page: "Webinar Landing Page",
    Profile_Routing_Page: "Profile Routing Page",
    Calendar_Booking_Page: "Calendar Booking Page",
    Calendar_Booking_Page_Join_Live_View: "Calendar Booking Page Join Live View",
    Calendar_Booking_Page_Join_Live_View_V2: "Calendar Booking Page Join Live View V2",
    Pre_Session_Page: "Pre-session Page",
    Form_Landing_page: "Form Landing Page",
    SEM_EXP_Page: "SEM Revamped Exp",
    Profile_Form_Page: "Profile Form Page",
    Application_Profile_Page: "Application Profile Page",
    Application_Document_Page: "Application Document Page",
    IELTS_To_Counselling_Form_Page: "IELTS To Counselling Form_Page",
    IELTS_To_Counselling_Form_Page_Exp1: "IELTS To Counselling Form_Page_question",
    Counselling_Chat_Page: "Counselling Chat Page",
    BOFU_User_Dashboard: "BOFU User Dashboard",
    BOFU_Slot_Page: "BOFU slot page",
    Event_Landing_Page: "Event Landing Page",
    Event_Specific_Page: "Event Specific Page",
    Leapscholar_Chat: "Leapscholar Chat",
    IELTS_Smart_Test_Landing_Page: "IELTS SmartTests Landing Page",
    IELTS_SmartTests: "IELTS SmartTests",
    SC_Profile_Form_Page: "SC Profile Form Page",
    REPLAYS_PAGE: "IELTS Replays",
    Join_Redirect_Page: "Join Redirect Page",
    Counsellor_Chat_Page: "Counsellor Chat page",
    RM_Chat_Page: "RM Chat page",
    Chat_Main_Page: "Chat main page",
    Direct_Live_Join_Page: "Direct Live Join Page",
    Scholarship_Landing_Page: "Scholarship Landing Page",
    Unresolved_reason: "Unresolved Reason",
    Resolution_feedback: "Resolution Feedback",
    Resolution_rating: "Resolution rating",
    Onboard: "onboard",
    IELTS_GIVING_IELTS_SOON: "IELTS - Giving IELTS Soon",
    IELTS_BOOKING_SUBMISSION: "IELTS - IELTS Booking Submission",
    LeapScholarHomePage: "LeapScholar Home Page",
    CounsellorPage: "Counsellor Page",
    AboutUsLandingPage: "About Us Landing Page",
    ProfileI2CApp: "Profile Page I2C",
    CalendarI2CApp: "Calendar Page I2C",
    IeltsCounsellingTab: "Counselling_tab",
    userBookmarksScreen: "Profile Bookmarks",
    AutoLsConfirmationPage: "AutoLs Success Page",
    PaymentConfirmationPage: "Payment Success Page",
    VoCalendarPage: "User Led VO Booking Page",
    VoCalendarNoSlotsPage: "User Led VO Booking No Slot Page",
    VoCalendarBookingSuccessPage: "VO Booking Success Page",
    VoCalendarBookingFailPage: "VO Booking Booking Fail Page",
    VoWelcomeCallPage: "Vo Welcome Call Page",
    BofuAppDownloadNudgePage: "App Download payment done",
    tofuAppDownloadNudgePage: "App download post tofu booking",
    appDownloadSlider: "App download slider",
    appDownloadCard: "App download card",
    DisqualifiedNoSeatModal: "Disqualified No Seat Modal",
    CannotJoinModal: "Can't join Modal",
    npsForm: "ToFu NPS Form",
    i2cCardViewed: "i2C card viewed",
    COUNSELLOR_ASSIGNMENT_DONE_PAGE: "Counsellor Assignment Done Page",
    COUNSELLOR_ASSIGNMENT_NOT_DONE_PAGE: "Counsellor Assignment Not Done Page",
    ISFeedBackForm: "IS feedback form",
    thankYouScreen: "Thank You Message Page",
    accountDeleteRequest: "Account Delete Request",
    reassignmentPage: "Reassignment Page"
};
var getPageName = function() {
    if (true) {
        var ref;
        var path = (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.pathname) || "";
        if (path === page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.UK_HOMEPAGE */ .CZ.UK_HOMEPAGE) {
            return pageName.UK_Landing_Page;
        } else if (path === page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.USA_HOMEPAGE */ .CZ.USA_HOMEPAGE) {
            return pageName.USA_Landing_Page;
        } else if (path === page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.CANADA_HOMEPAGE */ .CZ.CANADA_HOMEPAGE) {
            return pageName.Canada_Landing_Page;
        } else if (path === page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.IRELAND_HOMEPAGE */ .CZ.IRELAND_HOMEPAGE) {
            return pageName.Ireland_Landing_Page;
        } else if (page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.AUSTRALIA_HOMEPAGE */ .CZ.AUSTRALIA_HOMEPAGE) {
            return pageName.Australia_Landing_Page;
        } else if (page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.Form_Landing_page */ .CZ.Form_Landing_page) {
            return pageName.Form_Landing_page;
        } else {
            return pageName.Neutral_Landing_Page;
        }
    }
};
var ieltsPageName = {
    IELTS_COURSE_LANDING_PAGE: "IELTS - Course Landing Page",
    PTE_BATCH_DETAIL_PAGE: "PTE - Course Detail Page",
    IELTS_FREE_CRASH_COURSE_LANDING_PAGE: "IELTS -Free Trial Landing Page",
    IELTS_MASTERCLASS_LANDING_PAGE: "IELTS - MasterClass Landing Page",
    IELTS_COURSE_DESCRIPTION_PAGE: "IELTS - Course Description Page",
    PTE_COURSE_DESCRIPTION_PAGE: "PTE LIVE Payment Page",
    DET_COURSE_DESCRIPTION_PAGE: "PET LIVE Payment Page",
    IELTS_FREE_TRAIL_COURSE_DESCRIPTION_PAGE: "IELTS - Free Trial Course Description Page",
    IELTS_OVERVIEW: "IELTS - Overview",
    IELTS_My_Classes: "IELTS - My Classes",
    IELTS_SPEAKING_CLUB_SLOTS_BOOKING: "IELTS - Speaking Club Slots Booking",
    IELTS_COURSE_PAGE: "IELTS - Dashboard",
    IELTS_SPEAKING_CLUB_PAGE: "IELTS - Speaking Club Page",
    IELTS_FAST_TRACK: "IELTS Fast Track",
    IELTS_FAST_TRACK_VIDEO_PLAYER: "IELTS Fast Track Video Player",
    IELTS_STUDY_MATERIAL_PAGE: "IELTS - Study Material Page",
    IELTS_RECORDINGS_PAGE: "IELTS - Recordings Page",
    IELTS_MOCK_TEST_PAGE: "IELTS - Mock Test Page",
    IELTS_WRITING_TEST_PAGE: "IELTS - Writing Test Page",
    IELTS_MASTERCLASS_PROFILE_PAGE: "IELTS - Overview",
    IELTS_PLUS: "IELTS Courses Profile Page",
    IELTS_MASTERCLASS_LANDING_PAGE_TEST1: "IELTS - MasterClass Landing Page Test1",
    IELTS_FAST_TRACK_STUDY_MATERIAL_PAGE: "IELTS Fast Track - Study Material Page",
    IELTS_SELF_PREP_STUDY_MATERIAL_PAGE: "IELTS Self Prep - Study Material Page",
    MASTERCLASS_PROFILE_PAGE: "IELTS MasterClass Profile Page",
    IELTS_PROFILE_PAGE: "IELTS Plus",
    FAST_TRACK_PROFILE_PAGE: "IELTS Fast Track",
    IELTS_NEW_QUIZ_PAGE: "IELTS New Quiz page",
    IELTS_COMPLETED_QUIZ_PAGE: "IELTS Completed Quiz page",
    IELTS_QUIZ_RESULTS_PAGE: "IELTS Quiz Results page",
    IELTS_ADDITIONAL_COURSE_PAGE: "IELTS Additional Course page",
    IELTS_FOUNDATION_LANDING_PAGE_VIEW_ALL: "IELTS Foundation Landing Page",
    IELTS_PLUS_LANDING_PAGE_VIEW_ALL: "IELTS Plus Landing Page",
    IELTS_BEGINNER_MASTERCLASS_LANDING_PAGE_VIEW_ALL: " IELTS - Beginner MasterClass Landing Page",
    IELTS_CLASSIC_MASTERCLASS_LANDING_PAGE_VIEW_ALL: " IELTS - Classic MasterClass Landing Page",
    IELTS_COURSES_PROFILE_PAGE: "IELTS Courses Profile Page",
    IELTS_NEW_LANDING_PAGE: "IELTS New Landing Page",
    COUNSELLING_PAGE: "Counselling Page",
    SEM_EXP_Page: "SEM Revamped Exp",
    CRASH_COURSE_REWARDS_PAGE: "Crash Course - Rewards Page",
    CRASH_COURSE_QUIZ_PAGE: "Crash Course - Quiz Page",
    CRASH_COURSE_TAKE_QUIZ_NOW: "Crash Course - Take Quiz now",
    NEW_REWARDS_PAGE: "New Rewards Page",
    NEW_REWARDS_POP_UP: "New Rewards - Pop up",
    MOCK_TEST_LANDING_PAGE: "Crash Course - Mock Test Page",
    NEW_TCY_ONLINE_PAGE: "New TCYonline page",
    CLASS_SCHEDULE_PAGE: "Class Schedule Page",
    IELTS_PLUS_CHALLENGING_PAGE: "IELTSPlus Challenge Landing Page",
    IELTS_CALLBACK_PAGE: "IELTS - IELTS Booking Callback",
    IELTS_APP_PRACTICE_TAB: "IELTS App - Practice Tab",
    IELTS_PLUS_START_BATCH_LANDING_PAGE: "Ielts Plus Start Batch Landing Page",
    IELTS_TO_COUNSELLING_PAGE: "IELTS To Counselling Form_Page",
    PTE_TO_COUNSELLING_PAGE: "PTE To Counselling Form_Page",
    DET_TO_COUNSELLING_PAGE: "DET To Counselling Form_Page",
    IELTS_PLUS_EXPIRY_MODAL: "IELTS Plus Expiry Modal",
    IELTS_PLUS_LANDING_PAGE: "IELTS Plus Landing Page",
    IELTS_BATCH_CARD_PAGE: "IELTS Batch Card page",
    IELTS_PLUS_CONFIRMATION_MODAL: "IELTS Plus Confirmation Modal",
    IELTS_ELITE_INPAGE_FORM_1: "Elite LP Form 1",
    IELTS_ELITE_INPAGE_FORM_2: "Elite LP Form 2",
    DEMO_PROG_FORM: "Demo Prog Form",
    IELTS_ELITE_LP_FORM: "Elite LP Form",
    IELTS_ELITE_DEMO_BOOKING_PAGE: "Elite Demo Booking Form",
    D2C_FORM: "D2C Form",
    MOCK_FORM: "mock_form",
    IELTS_ALL_BATCHES_VIEW_ALL_PAGE: "IELTS All Batches Page",
    MOCK_TEST_DASHBOARD: "Mock Test Dashboard",
    KNOW_MORE_MOCK_TEST_DASHBOARD: "Know more from Mock Test Dashboard",
    DEMO_CALENDAR_THREE_SLOTS: "Demo Calendar Three Slots",
    DEMO_CALENDAR_ALL_SLOTS: "Demo Calendar All Slots",
    PTE_DEMO_CALENDAR_ALL_SLOTS: "PTE Demo Calendar All Slots",
    DET_DEMO_CALENDAR_ALL_SLOTS: "DET Demo Calendar All Slots",
    DEMO_CONFIRMATION_SCREEN: "Demo Confirmation Screen",
    PTE_DEMO_CONFIRMATION_SCREEN: "PTE Demo Confirmation Screen",
    DET_DEMO_CONFIRMATION_SCREEN: "DET Demo Confirmation Screen",
    IELTS_TOOLKIT_PAGE: "IELTS Toolkit Page",
    IELTS_TOOLKIT_UNLOCKED_CARD: "IELTS Toolkit Unlocked Card",
    IELTS_TOOLKIT_LOCKED_CARD: "IELTS Toolkit Locked Card",
    NO_DEMO_SLOTS: "No demo slots",
    PTE_NO_DEMO_SLOTS: "PTE No demo slots",
    DET_NO_DEMO_SLOTS: "DET No demo slots",
    BPT_REDIRECT_PAGE: "BPT Redirect Page",
    GENERIC_BUNDLE_PAYMENT_PAGE: "Generic Bundle Payment Page",
    RECORDED_DEMO_SCREEN: "Recorded Demo Screen",
    IELTS_PAYMENT_DETAILS: "Payment details",
    IELTS_PREPARATION_ONLINE: "Ielts Preparation Online",
    SELF_PREP_LP: "Self-Prep LP",
    IELTS_COURSE_LISTING_PAGE: "IELTS Course Listing Page",
    EXPIRED_BATCH: "expired batch",
    LIVE_DEMO_CALENDAR: "Live Demo Calendar",
    PTE_LIVE_DEMO_CALENDAR: "PTE Live Demo Calendar",
    DET_LIVE_DEMO_CALENDAR: "DET Live Demo Calendar",
    APP_INSTALL_NUDGE: "App Install Nudge",
    IELTS_DEMO_AS_MC: "Ielts Demo As MC",
    DEMO_MC_FORM_1: "Demo MC Form 1",
    DEMO_MC_FORM_2: "Demo MC Form 2",
    CLASSIC_MASTERCLASS: "Classic MasterClass",
    MC_LIVE_SOON: "MC Live Soon",
    IELTS_DEMO_CALENDAR_TOFU_FLOW: "Demo Calendar Three Slots Tofu Flow",
    IELTS_DEMO_CALENDAR_LIVE_TOFU_FLOW: "Live Demo Calendar Tofu Flow",
    DEMO_IELTS_BOOKING_LOADER: "Demo Booking Loader",
    NO_IELTS_SLOTS_FOR_DISQUALIFIED_USERS: "No Booking Modal T2I",
    IELTS_FORM_POST_BOOKING: "Ielts Form Post Booking",
    DEMO_CALENDAR_ALL_SLOTS_TOFU_FLOW: "Demo Calendar All Slots Tofu Flow",
    T2I_NO_SEAT_MODAL: "T2I No Seat Modal",
    MC_REMINDER_MODAL: "MC Reminder Modal",
    TOFDU_DISQ_ONBOARDING_PAGE: "TOFU Disqualified Onboarding Page",
    IELTS_JOIN_CLASS: "IELTS Join Class",
    MASTERCLASS_CALENDAR: "Masterclass Calendar",
    DEMO_REBOOKING: "Demo Rebooking",
    IELTS_BAP_BATCHES_PAGE: "IELTS BAP Batches Page",
    PAID_USER_DASHBOARD: "Paid User Dashboard",
    VIDEO_COURSE: "Video Course",
    IELTS_VIDEO_COURSE: "IELTS Course",
    GRAMMAR_VIDEO_COURSE: "Grammar Course",
    LIY_PAYMENT_PAGE: "LIY Payment Page",
    DET_PAYMENT_PAGE: "DET Payment Page",
    LIY_PAYMENT_PAGE_2: "LIY Payment Page 2",
    LIY_PAYMENT_PAGE_MENA: "LIY Payment Page-MENA",
    LIY_PAYMENT_PAGE_MENA2: "LIY Payment Page-MENA2",
    CHANGE_EXAM_TYPE: "Change Exam Type",
    LIY_REDIRECTION: "LIY Redirection",
    IELTS_INDIA_REFERAL_PAGE: "IELTS India Referral Page",
    IELTS_BATCH_FILTERS: "IELTS Batch Filters",
    EXAM_BOOKING_FORM_START: "Exam Booking Form - Start",
    EXAM_BOOKING_FORM_DATE: "Exam Booking Form - Date",
    EXAM_BOOKING_FORM_ASSISTANCE: "Exam Booking Form - Assistance",
    EXAM_BOOKING_FORM_COUNSELLING: "Exam Booking Form - Counselling",
    LIY_DASHBOARD_V3: "LIY-Dashboard-V3",
    THANQ_PAGE_MENA: "Thank You Page MENA",
    THANQ_PAGE_IELTS: "Thank You Page IELTS",
    THANQ_PAGE_SAT: "Thank You Page SAT",
    LIY_MENA_EVAL_BOOKING: "LIY MENA Evaluation Booking",
    DEMO_EVAL_BOOKING: "IELTS DEMO Evaluation Booking",
    PTE_EVAL_BOOKING: "PTE Evaluation Booking",
    DET_EVAL_BOOKING: "DET Evaluation Booking",
    PTE_PAYMENT_PAGE: "PTE Payment Page",
    PTE_ALL_BATCHES_VIEW_ALL_PAGE: "PTE All Batches Page",
    DET_ALL_BATCHES_VIEW_ALL_PAGE: "DET All Batches Page",
    DET_VOUCHER_SUCCESS: "DET Voucher Success",
    SAT_PARENT_FORM: "SAT Parent Form",
    LIY_PAYMENT_PAGE_GROWTH: "LIY Payment Page-Growth"
};
var getIeltsPageName = function() {
    if (true) {
        var ref;
        var path = (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.pathname) || "";
        switch(path){
            case page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.IELTS_STUDENT_DASHBOARD */ .CZ.IELTS_STUDENT_DASHBOARD:
                return ieltsPageName.IELTS_COURSE_PAGE;
            case page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.IELTS_SPEAKING_CLUB */ .CZ.IELTS_SPEAKING_CLUB:
                return ieltsPageName.IELTS_SPEAKING_CLUB_PAGE;
            case page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.IELTS_PAGE */ .CZ.IELTS_PAGE:
                return ieltsPageName.IELTS_MASTERCLASS_LANDING_PAGE;
            case page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.NEW_MASTERCLASS_LANDING_PAGE */ .CZ.NEW_MASTERCLASS_LANDING_PAGE:
                return ieltsPageName.IELTS_NEW_LANDING_PAGE;
            case page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.IELTS_STUDY_MATERIAL */ .CZ.IELTS_STUDY_MATERIAL:
                return ieltsPageName.IELTS_STUDY_MATERIAL_PAGE;
            case page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.PRACTISE_TAB */ .CZ.PRACTISE_TAB:
                return ieltsPageName.IELTS_APP_PRACTICE_TAB;
            case page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.FREE_RESOURCE */ .CZ.FREE_RESOURCE:
                return ieltsPageName.IELTS_BATCH_CARD_PAGE;
            case page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.MASTERCLASS_TYPE */ .CZ.MASTERCLASS_TYPE:
                return ieltsPageName.MASTERCLASS_PROFILE_PAGE;
            case page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.IELTS_TEST_PREP_MOCK_TEST */ .CZ.IELTS_TEST_PREP_MOCK_TEST:
                return ieltsPageName.MOCK_TEST_DASHBOARD;
            case page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.IELTS_ONBOARDING_SCREEN */ .CZ.IELTS_ONBOARDING_SCREEN:
                return ieltsPageName.IELTS_PAYMENT_DETAILS;
            case page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.IELTS_EXPIRED_CLASS_LIST */ .CZ.IELTS_EXPIRED_CLASS_LIST:
            case page_routes__WEBPACK_IMPORTED_MODULE_3__/* .navRoutes.EXPIRED_CLASS */ .CZ.EXPIRED_CLASS:
                return ieltsPageName.EXPIRED_BATCH;
            default:
                return "";
        }
    }
};
var getBatchType = function(batchData) {
    if (batchData === null || batchData === void 0 ? void 0 : batchData.workshopType) {
        switch(batchData === null || batchData === void 0 ? void 0 : batchData.workshopType){
            case DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .batchType.ONLINE_WORKSHOP */ .d.ONLINE_WORKSHOP:
                if (batchData.pricingBundleName === DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .priceBundleName.IELTS_PLUS_PREMIUM */ .F.IELTS_PLUS_PREMIUM) {
                    return "IELTS Premium";
                } else if (batchData.pricingBundleName === DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .priceBundleName.IELTS_PLUS_PREMIUM_2 */ .F.IELTS_PLUS_PREMIUM_2) {
                    return "IELTS Premium 2";
                } else if (batchData.pricingBundleName === "IELTS_FOUNDATION") {
                    return "IELTS Foundation";
                } else {
                    return "IELTS Plus";
                }
            case DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .batchType.DOUBT_WORKSHOP */ .d.DOUBT_WORKSHOP:
                return "IELTS ExtraClass";
            case DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .batchType.FAST_TRACK_EXTRA_CLASSES */ .d.FAST_TRACK_EXTRA_CLASSES:
                return "IELTS Fast Track ExtraClass";
            case DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .batchType.SPEAKING_WORKSHOP */ .d.SPEAKING_WORKSHOP:
            case DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .batchType.SPEAKING_ELITE_WORKSHOP */ .d.SPEAKING_ELITE_WORKSHOP:
                return "IELTS Speaking Club";
            case DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .batchType.MASTER_CLASS */ .d.MASTER_CLASS:
                return "IELTS Classic MasterClass";
            case DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .batchType.BEGINNER_MASTER_CLASS */ .d.BEGINNER_MASTER_CLASS:
                return "IELTS Beginner MasterClass";
            case DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .batchType.ORIENTATION_WORKSHOP */ .d.ORIENTATION_WORKSHOP:
                return "Orientation Class";
            case DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .batchType.PTE_ONLINE_WORKSHOP */ .d.PTE_ONLINE_WORKSHOP:
                return "PTE Online Workshop";
            case DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .batchType.DET_ONLINE_WORKSHOP */ .d.DET_ONLINE_WORKSHOP:
                return "DET Online Workshop";
        }
    } else if (batchData === null || batchData === void 0 ? void 0 : batchData.pricingBundleName) {
        if (batchData.pricingBundleName === DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .priceBundleName.IELTS_PLUS_PREMIUM */ .F.IELTS_PLUS_PREMIUM) {
            return "IELTS Premium";
        } else if (batchData.pricingBundleName === DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .priceBundleName.IELTS_PLUS_PREMIUM_2 */ .F.IELTS_PLUS_PREMIUM_2) {
            return "IELTS Premium 2";
        } else if (batchData.pricingBundleName === "IELTS_FOUNDATION") {
            return "IELTS Foundation";
        } else {
            return "IELTS Plus";
        }
    } else return "";
};
var getMasterClassType = function(batchData) {
    if ((batchData === null || batchData === void 0 ? void 0 : batchData.workshopType) === DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .batchType.BEGINNER_MASTER_CLASS */ .d.BEGINNER_MASTER_CLASS) {
        return "Beginner MasterClass";
    } else if ((batchData === null || batchData === void 0 ? void 0 : batchData.workshopType) === DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .batchType.MASTER_CLASS */ .d.MASTER_CLASS) {
        return "Classic MasterClass";
    }
    return "";
};
var onboardingStepsPage = {
    STEP_ONE: "Onboarding step1",
    STEP_TWO: "Onboarding step2",
    STEP_THREE: "Onboarding step3",
    STEP_FOUR: "Onboarding step4"
};
var LeadCaptureStepsPage = {
    STEP_ONE: "Prog_Form_P1",
    STEP_TWO: "Prog_Form_P2",
    STEP_THREE: "Prog_Form_P3",
    STEP_FOUR: "Prog_Form_P4",
    STEP_FIVE: "Prog_Form_P5",
    STEP_SIX: "Prog_Form_P6",
    STEP_SEVEN: "Prog_Form_P7",
    STEP_EIGHT: "Prog_Form_P8",
    STEP_NINE: "Prog_Form_P9"
};
var getBatchTagName = function(batchData) {
    if (batchData.workshopType) {
        switch(batchData === null || batchData === void 0 ? void 0 : batchData.workshopType){
            case DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .batchType.ONLINE_WORKSHOP */ .d.ONLINE_WORKSHOP:
                if (batchData.pricingBundleName === DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .priceBundleName.IELTS_FOUNDATION */ .F.IELTS_FOUNDATION) {
                    return "Foundation";
                } else if ((0,components_LSRevamp_ieltsPage_FreeIeltsCourse_FreeCrashCourseUtils__WEBPACK_IMPORTED_MODULE_1__/* .isPlusBatch */ .gB)(batchData)) {
                    return "IELTS Plus";
                } else return "IELTS Premium";
            case DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .batchType.DOUBT_WORKSHOP */ .d.DOUBT_WORKSHOP:
                return "IELTS ExtraClass";
            case DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .batchType.FAST_TRACK_EXTRA_CLASSES */ .d.FAST_TRACK_EXTRA_CLASSES:
                return "IELTS Fast Track ExtraClass";
            case DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .batchType.SPEAKING_WORKSHOP */ .d.SPEAKING_WORKSHOP:
                return "IELTS Speaking Club";
            case DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .batchType.MASTER_CLASS */ .d.MASTER_CLASS:
                return "Classic";
            case DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .batchType.BEGINNER_MASTER_CLASS */ .d.BEGINNER_MASTER_CLASS:
                return "Beginner";
        }
    } else if (batchData === null || batchData === void 0 ? void 0 : batchData.pricingBundleName) {
        if ((0,_ielts_batch_utils__WEBPACK_IMPORTED_MODULE_6__/* .isPremiumBatch */ .xX)(batchData)) {
            return "IELTS Premium";
        } else {
            return "IELTS Plus";
        }
    } else return "";
};
var getBatchTagSkin = function(batchData) {
    if (batchData.workshopType) {
        switch(batchData === null || batchData === void 0 ? void 0 : batchData.workshopType){
            case DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .batchType.ONLINE_WORKSHOP */ .d.ONLINE_WORKSHOP:
                if (batchData.pricingBundleName === DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .priceBundleName.IELTS_FOUNDATION */ .F.IELTS_FOUNDATION) {
                    return "primary";
                }
                if ((0,_ielts_batch_utils__WEBPACK_IMPORTED_MODULE_6__/* .isPremiumBatch */ .xX)(batchData)) {
                    return "success";
                } else {
                    return "orange";
                }
            case DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .batchType.DOUBT_WORKSHOP */ .d.DOUBT_WORKSHOP:
                return "warning";
            case DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .batchType.FAST_TRACK_EXTRA_CLASSES */ .d.FAST_TRACK_EXTRA_CLASSES:
                return "success";
            case DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .batchType.SPEAKING_WORKSHOP */ .d.SPEAKING_WORKSHOP:
                return "success";
            case DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .batchType.MASTER_CLASS */ .d.MASTER_CLASS:
                return "warning";
            case DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .batchType.BEGINNER_MASTER_CLASS */ .d.BEGINNER_MASTER_CLASS:
                return "success";
        }
    } else if (batchData === null || batchData === void 0 ? void 0 : batchData.pricingBundleName) {
        if (batchData.pricingBundleName === DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_0__/* .priceBundleName.IELTS_PLUS */ .F.IELTS_PLUS) {
            return "warning";
        } else {
            return "primary";
        }
    }
    return "primary";
};
var platforms = {
    android: "ANDROID",
    web: "WEB",
    mweb: "MWEB"
};
var getPlatform = function() {
    var params = new URL(document.location).searchParams;
    var platform = params.get("platform");
    if (platform == "app") return platforms.android;
    else if (react_device_detect__WEBPACK_IMPORTED_MODULE_4__/* .isMobile */ .tq) return platforms.mweb;
    else return platforms.web;
};
var getPlatformV2 = function() {
    var params = new URL(document.location).searchParams;
    var platform = params.get("platform");
    if (platform == "app") return platforms.android;
    if ((0,utils_browserUtils__WEBPACK_IMPORTED_MODULE_5__/* .mobileCheck */ .KU)()) return platforms.mweb;
    return platforms.web;
};


/***/ }),

/***/ 5438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$R": function() { return /* binding */ getLatestUpcomingClass; },
/* harmony export */   "D3": function() { return /* binding */ eligibleForNewFlow; },
/* harmony export */   "D4": function() { return /* binding */ getPriceBundleNameFromPaymentType; },
/* harmony export */   "J6": function() { return /* binding */ diffeDays; },
/* harmony export */   "O9": function() { return /* binding */ isPremiumBundleCheck; },
/* harmony export */   "OT": function() { return /* binding */ IsDemoBooked; },
/* harmony export */   "UH": function() { return /* binding */ getIeltsFlowType; },
/* harmony export */   "ZJ": function() { return /* binding */ shortenWeeklySchedule; },
/* harmony export */   "Zr": function() { return /* binding */ showDaignoisticTests; },
/* harmony export */   "bX": function() { return /* binding */ diffWeeks; },
/* harmony export */   "eB": function() { return /* binding */ eligibleForNewFlowByPrice; },
/* harmony export */   "uG": function() { return /* binding */ selectOtherCountryIfGermanyIsThere; },
/* harmony export */   "wj": function() { return /* binding */ dayDifference; },
/* harmony export */   "xT": function() { return /* binding */ removeNullValueFromArray; },
/* harmony export */   "xX": function() { return /* binding */ isPremiumBatch; }
/* harmony export */ });
/* unused harmony exports getBatchSlots, getStartingHour, getStartingDate, getBatchErrorMessage, isIeltsEliteBundleAvataran, getEliteAndSelectBatches, getLatestLiveClass */
/* harmony import */ var components_Ielts_IeltsEliteDemo_redux_IeltsEliteSlice__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48472);
/* harmony import */ var DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93957);
/* harmony import */ var Interfaces_common_PaymentSchema__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4162);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_ielts_date_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66316);
/* harmony import */ var date_fns_isValid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61436);
/* harmony import */ var DataMapper_Common_ProductType__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64840);










var getBatchSlots = function(startHours) {
    if (startHours < 12) {
        return "Morning Batch";
    } else if (startHours < 18) {
        return "Afternoon Batch";
    } else {
        return "Evening Batch";
    }
};
var shortenWeeklySchedule = function(weekday) {
    // expected monday-friday
    // output mon-fri
    var weekArray = weekday.split("-");
    if (weekArray.length !== 2) return weekday;
    return "".concat(weekArray[0].slice(0, 3), "-").concat(weekArray[1].slice(0, 3));
};
var diffWeeks = function(startDate, endDate) {
    var dt1 = new Date(startDate);
    var dt2 = new Date(endDate);
    var diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60 * 60 * 24 * 7;
    return Math.abs(Math.round(diff));
};
var getStartingHour = function(startDate) {
    return Number(moment(startDate).format("HH"));
};
var diffeDays = function(startDate, hours, minutes) {
    var startHours = hours < 10 ? "".concat(0).concat(hours) : "".concat(hours);
    var startMinutes = minutes < 10 ? "".concat(0).concat(minutes) : "".concat(minutes);
    var DateString = startDate + "T" + startHours + ":" + startMinutes + ":" + "00";
    return getDayWithoutWeekend(DateString);
};
var getDayWithoutWeekend = function(startDate) {
    var ONE_DAY = 1000 * 60 * 60 * 24;
    var variableDate = Date.parse(startDate);
    var currentDate = Date.parse(new Date().toString());
    var totalDate = 0;
    while(variableDate <= currentDate){
        var currentDayNumber = new Date(variableDate).getDay();
        if (currentDayNumber !== 0 && currentDayNumber !== 6) {
            totalDate += 1;
        }
        variableDate += ONE_DAY;
    }
    return totalDate;
};
var dayDifference = function(startDate) {
    return getDayWithoutWeekend(startDate);
};
var getStartingDate = function(startDate) {
    return Number(moment(startDate).format("DD"));
};
var isPremiumBatch = function(batchData) {
    return isPremiumBundleCheck(batchData === null || batchData === void 0 ? void 0 : batchData.pricingBundleName);
};
var isPremiumBundleCheck = function(pricingBundleName) {
    return !(pricingBundleName === null || pricingBundleName === void 0 ? void 0 : pricingBundleName.includes("PLUS"));
};
var showDaignoisticTests = function(isEnrolledForBatches) {
    if (isEnrolledForBatches.isEnrolledForElite === null && isEnrolledForBatches.isEnrolledForSelect === null && isEnrolledForBatches.isEnrolledForPlus === null && isEnrolledForBatches.isEnrolledForPremium === null) {
        return true //this means api is not called yet and everything is in it default state
        ;
    }
    if (isEnrolledForBatches.isEnrolledForElite === true || isEnrolledForBatches.isEnrolledForSelect === true || isEnrolledForBatches.isEnrolledForPlus === true || isEnrolledForBatches.isEnrolledForPremium === true) {
        return false //this means user is enrolled in any of the batch
        ;
    }
    return true //this means everything is false user is not enrolled in any batch
    ;
};
var getPriceBundleNameFromPaymentType = function(paymentType) {
    switch(paymentType){
        case Interfaces_common_PaymentSchema__WEBPACK_IMPORTED_MODULE_2__/* .PaymentType.IELTS_FOUNDATION_FEE */ .uG.IELTS_FOUNDATION_FEE:
            return DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_1__/* .priceBundleName.IELTS_FOUNDATION */ .F.IELTS_FOUNDATION;
        case Interfaces_common_PaymentSchema__WEBPACK_IMPORTED_MODULE_2__/* .PaymentType.IELTS_PREMIUM_FEE */ .uG.IELTS_PREMIUM_FEE:
            return DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_1__/* .priceBundleName.IELTS_PLUS_PREMIUM */ .F.IELTS_PLUS_PREMIUM;
        case Interfaces_common_PaymentSchema__WEBPACK_IMPORTED_MODULE_2__/* .PaymentType.IELTS_PREMIUM_2_FEE */ .uG.IELTS_PREMIUM_2_FEE:
            return DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_1__/* .priceBundleName.IELTS_PLUS_PREMIUM_2 */ .F.IELTS_PLUS_PREMIUM_2;
        case Interfaces_common_PaymentSchema__WEBPACK_IMPORTED_MODULE_2__/* .PaymentType.IELTS_PREMIUM_3_FEE */ .uG.IELTS_PREMIUM_3_FEE:
            return DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_1__/* .priceBundleName.IELTS_PLUS_PREMIUM_3 */ .F.IELTS_PLUS_PREMIUM_3;
        case Interfaces_common_PaymentSchema__WEBPACK_IMPORTED_MODULE_2__/* .PaymentType.REWARD_BOOSTER_FEE */ .uG.REWARD_BOOSTER_FEE:
            return DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_1__/* .priceBundleName.BOOSTER_PACK */ .F.BOOSTER_PACK;
        case Interfaces_common_PaymentSchema__WEBPACK_IMPORTED_MODULE_2__/* .PaymentType.IELTS_PLUS_PART_2_FEE */ .uG.IELTS_PLUS_PART_2_FEE:
            return DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_1__/* .priceBundleName.IELTS_PLUS_PART_2 */ .F.IELTS_PLUS_PART_2;
        case Interfaces_common_PaymentSchema__WEBPACK_IMPORTED_MODULE_2__/* .PaymentType.IELTS_FEE */ .uG.IELTS_FEE:
        default:
            return DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_1__/* .priceBundleName.IELTS_PLUS */ .F.IELTS_PLUS;
    }
};
var isBatchFull = function(bookedSeat, numberOfSeat) {
    return numberOfSeat <= bookedSeat;
};
var classAlreadyStarted = function(classStartDate) {
    return classStartDate < new Date();
};
var getBatchErrorMessage = function(batchDetails) {
    if (isBatchFull(batchDetails.seatBooked, batchDetails.numberOfSeats)) return "Sorry you cannot enrol in this batch as all seats are booked.";
    if (classAlreadyStarted(getFullDate(batchDetails.startDate, batchDetails.startHour, batchDetails.startMinute))) return "Sorry, You cannot enrol in this batch as it has already started.";
    return "";
};
var removeNullValueFromArray = function(arr) {
    return arr === null || arr === void 0 ? void 0 : arr.filter(function(data) {
        return data;
    });
};
var selectOtherCountryIfGermanyIsThere = function(arr) {
    if (arr && arr.length > 1 && arr.includes("Other")) {
        var index = arr.indexOf("Other");
        arr.splice(index, 1);
        return arr;
    } else return arr;
};
var IsDemoBooked = function(ieltsStage) {
    return ieltsStage === components_Ielts_IeltsEliteDemo_redux_IeltsEliteSlice__WEBPACK_IMPORTED_MODULE_0__/* .IeltsStageType.IELTS_DEMO_BOOKED */ .QW.IELTS_DEMO_BOOKED || ieltsStage === components_Ielts_IeltsEliteDemo_redux_IeltsEliteSlice__WEBPACK_IMPORTED_MODULE_0__/* .IeltsStageType.IELTS_DEMO_ATTENDED */ .QW.IELTS_DEMO_ATTENDED;
};
var isIeltsEliteBundleAvataran = function(pricingBundleName) {
    return pricingBundleName.toUpperCase().includes("ELITE");
};
var getEliteAndSelectBatches = function(batches) {
    return batches.reduce(function(acc, batch) {
        if (isIeltsEliteBundleAvataran(batch.pricingBundleName || "")) {
            return _object_spread_props(_object_spread({}, acc), {
                eliteBatch: _to_consumable_array(acc.eliteBatch).concat([
                    batch
                ])
            });
        } else {
            return _object_spread_props(_object_spread({}, acc), {
                selectBatch: _to_consumable_array(acc.selectBatch).concat([
                    batch
                ])
            });
        }
    }, {
        eliteBatch: [],
        selectBatch: []
    });
};
var addISTLabelToTime = function(dateString) {
    var istLabelString = dateString + ".000+05:30";
    return (0,date_fns_isValid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(new Date(istLabelString)) ? istLabelString : dateString;
};
var getLatestUpcomingClass = function(batches) {
    try {
        if (batches.length < 1) return null;
        var nextUpcomingClass = null;
        batches.forEach(function(batch) {
            if (new Date(addISTLabelToTime(batch.startTime)) > new Date() && (!nextUpcomingClass || new Date(addISTLabelToTime(batch.startTime)) < new Date(addISTLabelToTime(nextUpcomingClass === null || nextUpcomingClass === void 0 ? void 0 : nextUpcomingClass.startTime)))) {
                nextUpcomingClass = batch;
            }
        });
        return nextUpcomingClass;
    } catch (e) {
        return null;
    }
};
var eligibleForNewFlow = function(bundleName) {
    return bundleName != DataMapper_Common_WorkshopData__WEBPACK_IMPORTED_MODULE_1__/* .priceBundleName.IELTS_CUSTOM */ .F.IELTS_CUSTOM;
};
var eligibleForNewFlowByPrice = function(price) {
    return price > 6800;
};
var getIeltsFlowType = function(enrolment, selfPrepDetails, isEnrolledInLiveClasses) {
    if (enrolment.length > 0) {
        var latestBatch = getLatestUpcomingClass(enrolment);
        if (latestBatch) {
            return {
                flowType: DataMapper_Common_ProductType__WEBPACK_IMPORTED_MODULE_5__/* .productType.ielts */ .$.ielts,
                activeBatchId: latestBatch.batchId
            };
        }
        return {
            flowType: DataMapper_Common_ProductType__WEBPACK_IMPORTED_MODULE_5__/* .productType.ielts */ .$.ielts,
            activeBatchId: enrolment[0].batchId
        };
    } else if (selfPrepDetails && selfPrepDetails.alreadyPaid) {
        return {
            flowType: DataMapper_Common_ProductType__WEBPACK_IMPORTED_MODULE_5__/* .productType.selfPrep */ .$.selfPrep,
            activeBatchId: null
        };
    } else if (isEnrolledInLiveClasses == false && selfPrepDetails && !selfPrepDetails.alreadyPaid) {
        return {
            flowType: DataMapper_Common_ProductType__WEBPACK_IMPORTED_MODULE_5__/* .productType.free */ .$.free,
            activeBatchId: null
        };
    }
    return null;
};
var getLatestLiveClass = function(batches) {
    try {
        if (batches.length < 1) return null;
        var nextUpcomingClass = null;
        batches.forEach(function(batch) {
            if (new Date(addISTLabelToTime(batch.startTime)) > new Date() || new Date(addISTLabelToTime(batch.startTime)) < new Date() && new Date(addISTLabelToTime(batch.endTime)) > new Date() && (!nextUpcomingClass || new Date(addISTLabelToTime(batch.startTime)) < new Date(addISTLabelToTime(nextUpcomingClass === null || nextUpcomingClass === void 0 ? void 0 : nextUpcomingClass.startTime)))) {
                nextUpcomingClass = batch;
            }
        });
        return nextUpcomingClass;
    } catch (e) {
        return null;
    }
};


/***/ }),

/***/ 66316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nj": function() { return /* binding */ getDayDiff; },
/* harmony export */   "OT": function() { return /* binding */ getHourFormat; },
/* harmony export */   "Xg": function() { return /* binding */ timeDiffInMin; },
/* harmony export */   "Xz": function() { return /* binding */ addDaysToDate; },
/* harmony export */   "gb": function() { return /* binding */ formatTimeInHours; },
/* harmony export */   "mh": function() { return /* binding */ getDateFormat; },
/* harmony export */   "mr": function() { return /* binding */ formatTime; },
/* harmony export */   "rk": function() { return /* binding */ parseDateStringToObj; },
/* harmony export */   "sy": function() { return /* binding */ formatTimeIn12Hours; },
/* harmony export */   "vz": function() { return /* binding */ getExactTime; },
/* harmony export */   "wf": function() { return /* binding */ getDay; },
/* harmony export */   "xL": function() { return /* binding */ checkIfDateIsTodayOrTommorow; }
/* harmony export */ });
/* unused harmony exports formatDate, getDayDiffInNumber, getTimeDiffWithHoursAndMinutes, isThereAClassToday, getFullDate, isClassOngoingNow, isClassStarted */
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var date_fns_isValid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61436);



var formatDate = function(date) {
    return new Intl.DateTimeFormat("en-GB", {
        weekday: "short",
        day: "numeric",
        month: "short",
        year: "numeric"
    }).format(new Date(date));
};
var formatTime = function(startHour, startMinute, endHour, endMinute) {
    var startSuffix = startHour >= 12 ? "PM" : "AM";
    var endSuffix = endHour >= 12 ? "PM" : "AM";
    var newStartHour = startHour > 12 ? startHour - 12 : startHour;
    var newEndHour = endHour > 12 ? endHour - 12 : endHour;
    var newStartMinute = startMinute;
    var newEndMinute = endMinute;
    var stringStartMinute = String(newStartMinute);
    var stringEndMinute = String(newEndMinute);
    if (stringStartMinute.length === 1) {
        newStartMinute = "0".concat(stringStartMinute);
    }
    if (stringEndMinute.length === 1) {
        newEndMinute = "0".concat(stringEndMinute);
    }
    return "".concat(newStartHour, ":").concat(newStartMinute).concat(startSuffix, " - ").concat(newEndHour, ":").concat(newEndMinute).concat(endSuffix);
};
var timeDiffInMin = function(startTime, endTime) {
    var start = moment__WEBPACK_IMPORTED_MODULE_0___default()(startTime);
    var end = moment__WEBPACK_IMPORTED_MODULE_0___default()(endTime);
    return moment__WEBPACK_IMPORTED_MODULE_0___default().duration(end.diff(start)).asMinutes();
};
var getDayDiff = function(time) {
    var timeDff = moment__WEBPACK_IMPORTED_MODULE_0___default()(time).startOf("day").diff(moment__WEBPACK_IMPORTED_MODULE_0___default()(Date.now()).startOf("day"), "days");
    if (timeDff < -1) return "".concat(Math.abs(timeDff), " days ago");
    if (timeDff < 0) return "Yesterday";
    if (timeDff == 0) return "Today";
    if (timeDff == 1) return "Tomorrow";
    else return "".concat(timeDff, " days");
};
var getDayDiffInNumber = function(date1, date2) {
    var daysDifference = moment(date1).startOf("day").diff(moment(date2).startOf("day"), "days");
    return daysDifference;
};
var formatTimeIn12Hours = function(hour, minute) {
    var suffix = hour >= 12 ? "pm" : "am";
    var newHour = hour > 12 ? hour - 12 : hour;
    if (hour === 0) newHour = 12;
    var newMinute = minute;
    var stringMinute = String(newMinute);
    if ((stringMinute === null || stringMinute === void 0 ? void 0 : stringMinute.length) === 1) {
        newMinute = "0".concat(stringMinute);
    } else {
        newMinute = stringMinute;
    }
    return {
        suffix: suffix,
        newHour: newHour,
        newMinute: newMinute
    };
};
var getTimeDiffWithHoursAndMinutes = function(firstTime, secondTime) {
    return {
        hours: firstTime.hours - secondTime.hours,
        minutes: firstTime.minutes - secondTime.minutes
    };
};
var isThereAClassToday = function(batchData) {
    var ref;
    var daysWithNumbers = {
        Sunday: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6
    };
    var todayDay = new Date().getDay();
    var ref1 = _sliced_to_array((batchData === null || batchData === void 0 ? void 0 : (ref = batchData.weeklySchedule) === null || ref === void 0 ? void 0 : ref.split("-")) || [], 2), firstDayInWeeklySchedule = ref1[0], lastDayInWeeklySchedule = ref1[1];
    firstDayInWeeklySchedule = daysWithNumbers[firstDayInWeeklySchedule];
    lastDayInWeeklySchedule = daysWithNumbers[lastDayInWeeklySchedule];
    if (todayDay >= parseInt(firstDayInWeeklySchedule) && todayDay <= parseInt(lastDayInWeeklySchedule)) {
        return true;
    }
    return false;
};
var getFullDate = function(date, hour, min) {
    var currentDate = new Date(date);
    currentDate.setHours(hour);
    currentDate.setMinutes(min);
    return currentDate;
};
var getExactTime = function(date, hour, min) {
    return new Date(new Date(date).setHours(hour, min));
};
var formatTimeInHours = function(seconds) {
    var hours = Math.floor(seconds / 3600);
    var minutes = Math.floor(seconds % 3600 / 60);
    var remainingSeconds = seconds % 60;
    var formattedHours = String(hours).padStart(2, "0");
    var formattedMinutes = String(minutes).padStart(2, "0");
    var formattedSeconds = String(remainingSeconds).padStart(2, "0");
    return {
        hours: formattedHours,
        minutes: formattedMinutes,
        seconds: formattedSeconds
    };
};
var isClassOngoingNow = function(batchData) {
    var startTimeInUnix = getFullDate(new Date().toDateString(), batchData === null || batchData === void 0 ? void 0 : batchData.startHour, batchData === null || batchData === void 0 ? void 0 : batchData.startMinute);
    var endTimeInUnix = getFullDate(new Date().toDateString(), batchData === null || batchData === void 0 ? void 0 : batchData.endHour, batchData === null || batchData === void 0 ? void 0 : batchData.endMinute);
    var currentTime = new Date();
    return startTimeInUnix <= currentTime && currentTime <= endTimeInUnix;
};
var isClassStarted = function(batchData) {
    var startTimeInUnix = getFullDate(new Date().toDateString(), batchData === null || batchData === void 0 ? void 0 : batchData.startHour, batchData === null || batchData === void 0 ? void 0 : batchData.startMinute);
    var currentTime = new Date();
    if (startTimeInUnix >= currentTime) {
        return false;
    }
    return true;
};
var checkIfDateIsTodayOrTommorow = function(date) {
    var tommorowDateString = new Date(new Date().setDate(new Date().getDate() + 1)).toDateString();
    var todayDateString = new Date().toDateString();
    var givenDateString = new Date(date).toDateString();
    if (givenDateString == todayDateString || givenDateString === tommorowDateString) {
        return true;
    }
    return false;
};
var addDaysToDate = function(date, days) {
    var newDate = new Date(date);
    return new Date(newDate.setDate(newDate.getDate() + days));
};
var getDay = function(date, showTodayString) {
    var weekday = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday", 
    ];
    var currentDate = new Date().toLocaleDateString();
    var dateString = new Date(date);
    var TODAY = "Today";
    if (currentDate === dateString.toLocaleDateString() && showTodayString) return TODAY;
    else return weekday[new Date(date).getDay()];
};
var getDateFormat = function(date) {
    return new Date(date).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short"
    });
};
var getHourFormat = function(hour) {
    var suffix = hour >= 12 ? "PM" : "AM";
    var newHour = hour > 12 ? hour - 12 : hour;
    if (hour === 0) newHour = 12;
    return "".concat(newHour, " ").concat(suffix);
};
var parseDateStringToObj = function(date) {
    if (date && (0,date_fns_isValid__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(new Date(date))) {
        return new Date(date);
    }
    return undefined;
};


/***/ }),

/***/ 79998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ isIeltsFlow; }
/* harmony export */ });
/* harmony import */ var utils_country_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20581);

var isIeltsFlow = function(pathName) {
    return utils_country_utils__WEBPACK_IMPORTED_MODULE_0__/* .ME_USERS_ALLOWED_PATHS.includes */ .Lu.includes(pathName);
};


/***/ }),

/***/ 26489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ removePromoCode; }
/* harmony export */ });
/* harmony import */ var utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51119);

var removePromoCode = function() {
    (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .deleteCookie */ .kT)(null, "promocode");
};


/***/ }),

/***/ 44827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rr": function() { return /* binding */ pluralizeText; },
/* harmony export */   "fm": function() { return /* binding */ capitalizeFirstLetter; },
/* harmony export */   "vt": function() { return /* binding */ getFilename; }
/* harmony export */ });
var capitalizeFirstLetter = function(word) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};
var getFilename = function(_fileUrl) {
    var _lastIndexUrlSeparator = _fileUrl === null || _fileUrl === void 0 ? void 0 : _fileUrl.lastIndexOf("/");
    return _lastIndexUrlSeparator && (_fileUrl === null || _fileUrl === void 0 ? void 0 : _fileUrl.substring(_lastIndexUrlSeparator + 1));
};
var pluralizeText = function(text, suffix, count) {
    if (count > 1) return text + suffix;
    return text;
};


/***/ }),

/***/ 10459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nz": function() { return /* binding */ formatDateForSpeakingClasses; },
/* harmony export */   "b5": function() { return /* binding */ getNextClassTiming; },
/* harmony export */   "du": function() { return /* binding */ secondsConverter; },
/* harmony export */   "vZ": function() { return /* binding */ getTimeLeftForMeetingInSeconds; }
/* harmony export */ });
/* unused harmony exports appendZeroForTiming, getClassTimingInWork */
/* harmony import */ var date_fns_differenceInSeconds__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11699);
/* harmony import */ var date_fns_differenceInDays__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94533);
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46971);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61436);
/* harmony import */ var utils_ielts_date_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66316);





function secondsConverter(seconds) {
    var day = Math.floor(seconds / (24 * 3600));
    var h = Math.floor(seconds % (24 * 3600) / 3600);
    var m = Math.floor(seconds % 3600 / 60);
    var s = Math.floor(seconds % 3600 % 60);
    return {
        sec: s,
        min: m,
        hour: h,
        day: day
    };
}
function appendZeroForTiming(digit) {
    if ("".concat(digit).length == 1) return "0".concat(digit);
    return digit;
}
var getTimeLeftForMeetingInSeconds = function(meetingStartTime, startHour, startMinute) {
    var timeDiff = (0,date_fns_differenceInSeconds__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,utils_ielts_date_utils__WEBPACK_IMPORTED_MODULE_0__/* .getExactTime */ .vz)(meetingStartTime, startHour, startMinute), new Date());
    return timeDiff > 0 ? timeDiff : 0;
};
function getClassTimingInWork(ms) {
    var seconds = Math.floor(ms / 1000);
    var date = secondsConverter(seconds);
    if (date.day) {
        if (date.day > 1) return "".concat(date.day, " Days");
        return "Tomorrow";
    } else {
        return "Today";
    }
}
function getNextClassTiming(date) {
    var todayDay = new Date(new Date().toDateString()) //excluding the time because we need date only
    ;
    var classDay = new Date(date);
    var dayDiff = (0,date_fns_differenceInDays__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(classDay, todayDay);
    if (dayDiff < 0) return "";
    if (todayDay.getDate() == classDay.getDate()) return "Today";
    if (dayDiff == 1 || dayDiff == 0) return "Tomorrow";
    else return "".concat((0,date_fns_differenceInDays__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(classDay, todayDay), " Days");
}
function formatDateForSpeakingClasses(date) {
    if (!(0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(date)) return null;
    var formattedDate = (0,date_fns_format__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(date, "do MMM, EEEE");
    var formattedTime = (0,date_fns_format__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(date, "h:mm a");
    return {
        date: formattedDate,
        time: formattedTime
    };
}


/***/ }),

/***/ 54728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B8": function() { return /* binding */ getRedirectUrl; },
/* harmony export */   "x3": function() { return /* binding */ checkIeltsRoute; },
/* harmony export */   "xC": function() { return /* binding */ getIeltsMockTestUrl; }
/* harmony export */ });
/* unused harmony exports getFlowType, youtubeParser */
/* harmony import */ var utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51119);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85518);
/* harmony import */ var page_routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12615);



var getFlowType = function(url) {
    var queryStrings = url.split("?")[1];
    if (queryStrings) {
        var flowType = queryStrings.split("&")[0];
        if (flowType) {
            return flowType.split("=")[1];
        } else {
            return undefined;
        }
    } else {
        return undefined;
    }
};
var checkIeltsRoute = function() {
    if (window.location.pathname.match("/ielts-preparation-online")) {
        return true;
    } else {
        return false;
    }
};
function youtubeParser(url) {
    try {
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        var match = url.match(regExp);
        return match && match[7].length == 11 ? match[7] : "";
    } catch (e) {
        return "";
    }
}
var getIeltsMockTestUrl = function(reqUrl) {
    var mockTestBasePath = "https://test-prep.leapscholar.com";
    var token = (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(null, "token");
    var userId = (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(null, "user_id");
    var source = react_device_detect__WEBPACK_IMPORTED_MODULE_1__/* .isMobile */ .tq ? "Mweb" : "WEB";
    return "".concat(mockTestBasePath, "/redirectPageV2?token=").concat(token, "&userId=").concat(userId, "&requrl=").concat(reqUrl, "&source=").concat(source);
};
var getRedirectUrl = function(data) {
    var redirectPage = page_routes__WEBPACK_IMPORTED_MODULE_2__/* .navRoutes.REDIRECT_PAGE */ .CZ.REDIRECT_PAGE + "?";
    if (data.reqUrl) {
        redirectPage += "requrl=".concat(data.reqUrl);
    }
    if (data.token) {
        redirectPage += "&token=".concat(data.token);
    }
    if (data.source) {
        redirectPage += "&source=".concat(data.source);
    }
    if (data.userId) {
        redirectPage += "&userId=".concat(data.userId);
    }
    if (data.stage) {
        redirectPage += "&stage=".concat(data.stage);
    }
    return redirectPage;
};


/***/ }),

/***/ 86147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ saveUtmData; },
/* harmony export */   "M": function() { return /* binding */ getUtmData; }
/* harmony export */ });
/* harmony import */ var utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51119);

function getUtmData(ctx) {
    var utmSource, utmCampaign, campaignType, adId, trackingId, utmMedium, referer, gclid, adName, fbclid, _fbc, _fbp;
    if ((0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(ctx, "utmSource")) {
        utmSource = (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(ctx, "utmSource");
    }
    if ((0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(ctx, "utmCampaign")) {
        utmCampaign = (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(ctx, "utmCampaign");
    }
    if ((0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(ctx, "utmMedium")) {
        utmMedium = (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(ctx, "utmMedium");
    }
    var utmTerm = (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(ctx, "utmTerm");
    if ((0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(ctx, "campaignType")) {
        campaignType = (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(ctx, "campaignType");
    }
    if ((0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(ctx, "adId")) {
        adId = (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(ctx, "adId");
    }
    if ((0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(ctx, "fbclid")) {
        fbclid = (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(ctx, "fbclid");
    }
    if ((0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(ctx, "trackingId")) {
        trackingId = (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(ctx, "trackingId");
    }
    if ((0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(ctx, "referer")) {
        referer = (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(ctx, "referer");
    }
    if ((0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(ctx, "gclid")) {
        gclid = (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(ctx, "gclid");
    }
    if ((0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(ctx, "adName")) {
        adName = (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(ctx, "adName");
    }
    if ((0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(ctx, "_fbc")) {
        _fbc = (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(ctx, "_fbc");
    }
    if ((0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(ctx, "_fbp")) {
        _fbp = (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(ctx, "_fbp");
    }
    return {
        utmSource: utmSource,
        utmCampaign: utmCampaign,
        utmTerm: utmTerm,
        campaignType: campaignType,
        adId: adId,
        trackingId: trackingId,
        utmMedium: utmMedium,
        referer: referer,
        fbclid: fbclid,
        gclid: gclid,
        adName: adName,
        _fbc: _fbc,
        _fbp: _fbp
    };
}
function saveUtmData(ctx, utmData) {
    if (utmData.utmSource) {
        (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .saveUtmCookie */ .AV)(ctx, "utmSource", utmData.utmSource, 60 * 60 * 24);
    }
    if (utmData.utmCampaign) {
        (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .saveUtmCookie */ .AV)(ctx, "utmCampaign", utmData.utmCampaign, 60 * 60 * 24);
    }
    if (utmData.utmMedium) {
        (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .saveUtmCookie */ .AV)(ctx, "utmMedium", utmData.utmMedium, 60 * 60 * 24);
    }
    if (utmData.utmTerm) {
        (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .saveUtmCookie */ .AV)(ctx, "utmTerm", utmData.utmTerm, 60 * 60 * 24);
    }
    if (utmData.campaignType) {
        (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .saveUtmCookie */ .AV)(ctx, "campaignType", utmData.campaignType, 60 * 60 * 24);
    }
    if (utmData.adId) {
        (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .saveUtmCookie */ .AV)(ctx, "adId", utmData.adId, 60 * 60 * 24);
    }
    if (utmData.fbclid) {
        (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .saveUtmCookie */ .AV)(ctx, "fbclid", utmData.fbclid, 60 * 60 * 24);
    }
    if (utmData.trackingId) {
        (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .saveUtmCookie */ .AV)(ctx, "trackingId", utmData.trackingId);
    }
    if (utmData.referer) {
        (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .saveUtmCookie */ .AV)(ctx, "referer", utmData.referer);
    }
    if (utmData.gclid) {
        (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .saveUtmCookie */ .AV)(ctx, "gclid", utmData.gclid);
    }
    if (utmData.adName) {
        (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .saveUtmCookie */ .AV)(ctx, "adName", utmData.adName);
    }
}


/***/ }),

/***/ 84977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gr": function() { return /* binding */ webUserLogOut; },
/* harmony export */   "PK": function() { return /* binding */ webEventTracker; },
/* harmony export */   "j8": function() { return /* binding */ webUserTracker; },
/* harmony export */   "wr": function() { return /* binding */ webEngageGetForever; }
/* harmony export */ });
/* unused harmony exports initWebEngage, webInitialization, webUserLogin */
var initWebEngage = function() {
    var webEngageScript = document.getElementById("_webengage_script_tag");
    if (webEngageScript) return;
    var script = document.createElement("script");
    script.id = "_webengage_script_tag";
    script.type = "text/javascript";
    script.innerHTML = 'var webengage;\n  !(function (w, e, b, n, g) {\n    function o(e, t) {\n      e[t[t.length - 1]] = function () {\n        r.__queue.push([t.join("."), arguments]);\n      };\n    }\n    var i,\n      s,\n      r = w[b],\n      z = " ",\n      l = "init options track screen onReady".split(z),\n      a = "feedback survey notification".split(z),\n      c = "options render clear abort".split(z),\n      p = "Open Close Submit Complete View Click".split(z),\n      u = "identify login logout setAttribute".split(z);\n    if (!r || !r.__v) {\n      for (\n        w[b] = r = { __queue: [], __v: "6.0", user: {} }, i = 0;\n        i < l.length;\n        i++\n      )\n        o(r, [l[i]]);\n      for (i = 0; i < a.length; i++) {\n        for (r[a[i]] = {}, s = 0; s < c.length; s++) o(r[a[i]], [a[i], c[s]]);\n        for (s = 0; s < p.length; s++) o(r[a[i]], [a[i], "on" + p[s]]);\n      }\n      for (i = 0; i < u.length; i++) o(r.user, ["user", u[i]]);\n      setTimeout(function () {\n        var f = e.createElement("script"),\n          d = e.getElementById("_webengage_script_tag");\n        (f.type = "text/javascript"),\n          (f.async = !0),\n          (f.src =\n            ("https:" == e.location.protocol\n              ? "https://ssl.widgets.webengage.com"\n              : "http://cdn.widgets.webengage.com") +\n            "/js/webengage-min-v-6.0.js"),\n          d.parentNode.insertBefore(f, d);\n      });\n    }\n  })(window, document, "webengage");\n  window.webengage=webengage;\n  ';
    document.body.appendChild(script);
};
var webInitialization = function(webId) {
    if (window && "object" === "object" && window.webengage) {
        window.webengage.init(webId);
    }
};
var webEventTracker = function(eventType, eventData) {
    if (window && "object" === "object" && window.webengage) {
        window.webengage.track(eventType, eventData);
    }
};
var webUserTracker = function(userAttribute, userData) {
    if (window && "object" === "object" && window.webengage) {
        window.webengage.user.setAttribute(userAttribute, userData);
    }
};
var webUserLogin = function(userId) {
    if (window && "object" === "object" && window.webengage) {
        window.webengage.user.login(userId);
    }
};
var webUserLogOut = function() {
    if (window && "object" === "object" && window.webengage) {
        window.webengage.user.logout();
    }
};
var webEngageGetForever = function() {
    return new Promise(function(resolve, reject) {
        try {
            var ref;
            var webEngageState = (ref = window.webengage) === null || ref === void 0 ? void 0 : ref.state;
            var countDown = 10;
            var webCounter = setInterval(function() {
                if ((webEngageState === null || webEngageState === void 0 ? void 0 : webEngageState.getForever()) || countDown < 0) {
                    clearInterval(webCounter);
                    if (webEngageState === null || webEngageState === void 0 ? void 0 : webEngageState.getForever()) {
                        resolve(webEngageState.getForever());
                    } else {
                        reject(false);
                    }
                } else {
                    var ref;
                    webEngageState = (ref = window.webengage) === null || ref === void 0 ? void 0 : ref.state;
                    countDown -= 1;
                }
            }, 200);
        } catch (err) {
            reject(false);
        }
    });
};


/***/ }),

/***/ 82734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ logger; },
/* harmony export */   "n": function() { return /* binding */ getUserId; }
/* harmony export */ });
/* harmony import */ var utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51119);
/* provided dependency */ var process = __webpack_require__(83454);

var winston = __webpack_require__(15832);
var _format = winston.format, combine = _format.combine, timestamp = _format.timestamp, printf = _format.printf, colorize = _format.colorize, align = _format.align;
var _LOG_LEVEL;
var logger = winston.createLogger({
    level: (_LOG_LEVEL = process.env.LOG_LEVEL) !== null && _LOG_LEVEL !== void 0 ? _LOG_LEVEL : "info",
    format: combine(colorize({
        all: true
    }), timestamp({
        format: "YYYY-MM-DD hh:mm:ss.SSS"
    }), align(), printf(function(info) {
        return "[".concat(info.timestamp, "] logLevel = ").concat(info.level, " | ").concat(info.message);
    })),
    transports: [
        new winston.transports.Console()
    ]
});
var getUserId = function(ctx) {
    return (0,utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(ctx, utils_cookie_utiils__WEBPACK_IMPORTED_MODULE_0__/* .COOKIES_CONSTANT.USER_ID */ .$S.USER_ID);
};


/***/ }),

/***/ 27596:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var process = __webpack_require__(83454);
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
(function(){var e={997:function(e){e.exports=function(e,r,n){if(e.filter)return e.filter(r,n);if(void 0===e||null===e)throw new TypeError;if("function"!=typeof r)throw new TypeError;var o=[];for(var i=0;i<e.length;i++){if(!t.call(e,i))continue;var a=e[i];if(r.call(n,a,i,e))o.push(a)}return o};var t=Object.prototype.hasOwnProperty},468:function(e,t,r){"use strict";function _typeof(e){if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(e){return typeof e}}else{_typeof=function _typeof(e){return e&&typeof Symbol==="function"&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e}}return _typeof(e)}function _classCallCheck(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function")}}var n=r(977),o=n.codes,i=o.ERR_AMBIGUOUS_ARGUMENT,a=o.ERR_INVALID_ARG_TYPE,c=o.ERR_INVALID_ARG_VALUE,u=o.ERR_INVALID_RETURN_VALUE,f=o.ERR_MISSING_ARGS;var s=r(971);var l=r(467),p=l.inspect;var y=r(467).types,g=y.isPromise,v=y.isRegExp;var d=Object.assign?Object.assign:r(203).assign;var b=Object.is?Object.is:r(113);var h=new Map;var m;var S;var E;var O;var A;function lazyLoadComparison(){var e=r(97);m=e.isDeepEqual;S=e.isDeepStrictEqual}var w=/[\x00-\x08\x0b\x0c\x0e-\x1f]/g;var j=null&&0;var _=function escapeFn(e){return j[e.charCodeAt(0)]};var P=false;var x=e.exports=ok;var k={};function innerFail(e){if(e.message instanceof Error)throw e.message;throw new s(e)}function fail(e,t,r,n,o){var i=arguments.length;var a;if(i===0){a="Failed"}else if(i===1){r=e;e=undefined}else{if(P===false){P=true;var c=process.emitWarning?process.emitWarning:console.warn.bind(console);c("assert.fail() with more than one argument is deprecated. "+"Please use assert.strictEqual() instead or only pass a message.","DeprecationWarning","DEP0094")}if(i===2)n="!="}if(r instanceof Error)throw r;var u={actual:e,expected:t,operator:n===undefined?"fail":n,stackStartFn:o||fail};if(r!==undefined){u.message=r}var f=new s(u);if(a){f.message=a;f.generatedMessage=true}throw f}x.fail=fail;x.AssertionError=s;function innerOk(e,t,r,n){if(!r){var o=false;if(t===0){o=true;n="No value argument passed to `assert.ok()`"}else if(n instanceof Error){throw n}var i=new s({actual:r,expected:true,message:n,operator:"==",stackStartFn:e});i.generatedMessage=o;throw i}}function ok(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++){t[r]=arguments[r]}innerOk.apply(void 0,[ok,t.length].concat(t))}x.ok=ok;x.equal=function equal(e,t,r){if(arguments.length<2){throw new f("actual","expected")}if(e!=t){innerFail({actual:e,expected:t,message:r,operator:"==",stackStartFn:equal})}};x.notEqual=function notEqual(e,t,r){if(arguments.length<2){throw new f("actual","expected")}if(e==t){innerFail({actual:e,expected:t,message:r,operator:"!=",stackStartFn:notEqual})}};x.deepEqual=function deepEqual(e,t,r){if(arguments.length<2){throw new f("actual","expected")}if(m===undefined)lazyLoadComparison();if(!m(e,t)){innerFail({actual:e,expected:t,message:r,operator:"deepEqual",stackStartFn:deepEqual})}};x.notDeepEqual=function notDeepEqual(e,t,r){if(arguments.length<2){throw new f("actual","expected")}if(m===undefined)lazyLoadComparison();if(m(e,t)){innerFail({actual:e,expected:t,message:r,operator:"notDeepEqual",stackStartFn:notDeepEqual})}};x.deepStrictEqual=function deepStrictEqual(e,t,r){if(arguments.length<2){throw new f("actual","expected")}if(m===undefined)lazyLoadComparison();if(!S(e,t)){innerFail({actual:e,expected:t,message:r,operator:"deepStrictEqual",stackStartFn:deepStrictEqual})}};x.notDeepStrictEqual=notDeepStrictEqual;function notDeepStrictEqual(e,t,r){if(arguments.length<2){throw new f("actual","expected")}if(m===undefined)lazyLoadComparison();if(S(e,t)){innerFail({actual:e,expected:t,message:r,operator:"notDeepStrictEqual",stackStartFn:notDeepStrictEqual})}}x.strictEqual=function strictEqual(e,t,r){if(arguments.length<2){throw new f("actual","expected")}if(!b(e,t)){innerFail({actual:e,expected:t,message:r,operator:"strictEqual",stackStartFn:strictEqual})}};x.notStrictEqual=function notStrictEqual(e,t,r){if(arguments.length<2){throw new f("actual","expected")}if(b(e,t)){innerFail({actual:e,expected:t,message:r,operator:"notStrictEqual",stackStartFn:notStrictEqual})}};var T=function Comparison(e,t,r){var n=this;_classCallCheck(this,Comparison);t.forEach((function(t){if(t in e){if(r!==undefined&&typeof r[t]==="string"&&v(e[t])&&e[t].test(r[t])){n[t]=r[t]}else{n[t]=e[t]}}}))};function compareExceptionKey(e,t,r,n,o,i){if(!(r in e)||!S(e[r],t[r])){if(!n){var a=new T(e,o);var c=new T(t,o,e);var u=new s({actual:a,expected:c,operator:"deepStrictEqual",stackStartFn:i});u.actual=e;u.expected=t;u.operator=i.name;throw u}innerFail({actual:e,expected:t,message:n,operator:i.name,stackStartFn:i})}}function expectedException(e,t,r,n){if(typeof t!=="function"){if(v(t))return t.test(e);if(arguments.length===2){throw new a("expected",["Function","RegExp"],t)}if(_typeof(e)!=="object"||e===null){var o=new s({actual:e,expected:t,message:r,operator:"deepStrictEqual",stackStartFn:n});o.operator=n.name;throw o}var i=Object.keys(t);if(t instanceof Error){i.push("name","message")}else if(i.length===0){throw new c("error",t,"may not be an empty object")}if(m===undefined)lazyLoadComparison();i.forEach((function(o){if(typeof e[o]==="string"&&v(t[o])&&t[o].test(e[o])){return}compareExceptionKey(e,t,o,r,i,n)}));return true}if(t.prototype!==undefined&&e instanceof t){return true}if(Error.isPrototypeOf(t)){return false}return t.call({},e)===true}function getActual(e){if(typeof e!=="function"){throw new a("fn","Function",e)}try{e()}catch(e){return e}return k}function checkIsPromise(e){return g(e)||e!==null&&_typeof(e)==="object"&&typeof e.then==="function"&&typeof e.catch==="function"}function waitForActual(e){return Promise.resolve().then((function(){var t;if(typeof e==="function"){t=e();if(!checkIsPromise(t)){throw new u("instance of Promise","promiseFn",t)}}else if(checkIsPromise(e)){t=e}else{throw new a("promiseFn",["Function","Promise"],e)}return Promise.resolve().then((function(){return t})).then((function(){return k})).catch((function(e){return e}))}))}function expectsError(e,t,r,n){if(typeof r==="string"){if(arguments.length===4){throw new a("error",["Object","Error","Function","RegExp"],r)}if(_typeof(t)==="object"&&t!==null){if(t.message===r){throw new i("error/message",'The error message "'.concat(t.message,'" is identical to the message.'))}}else if(t===r){throw new i("error/message",'The error "'.concat(t,'" is identical to the message.'))}n=r;r=undefined}else if(r!=null&&_typeof(r)!=="object"&&typeof r!=="function"){throw new a("error",["Object","Error","Function","RegExp"],r)}if(t===k){var o="";if(r&&r.name){o+=" (".concat(r.name,")")}o+=n?": ".concat(n):".";var c=e.name==="rejects"?"rejection":"exception";innerFail({actual:undefined,expected:r,operator:e.name,message:"Missing expected ".concat(c).concat(o),stackStartFn:e})}if(r&&!expectedException(t,r,n,e)){throw t}}function expectsNoError(e,t,r,n){if(t===k)return;if(typeof r==="string"){n=r;r=undefined}if(!r||expectedException(t,r)){var o=n?": ".concat(n):".";var i=e.name==="doesNotReject"?"rejection":"exception";innerFail({actual:t,expected:r,operator:e.name,message:"Got unwanted ".concat(i).concat(o,"\n")+'Actual message: "'.concat(t&&t.message,'"'),stackStartFn:e})}throw t}x.throws=function throws(e){for(var t=arguments.length,r=new Array(t>1?t-1:0),n=1;n<t;n++){r[n-1]=arguments[n]}expectsError.apply(void 0,[throws,getActual(e)].concat(r))};x.rejects=function rejects(e){for(var t=arguments.length,r=new Array(t>1?t-1:0),n=1;n<t;n++){r[n-1]=arguments[n]}return waitForActual(e).then((function(e){return expectsError.apply(void 0,[rejects,e].concat(r))}))};x.doesNotThrow=function doesNotThrow(e){for(var t=arguments.length,r=new Array(t>1?t-1:0),n=1;n<t;n++){r[n-1]=arguments[n]}expectsNoError.apply(void 0,[doesNotThrow,getActual(e)].concat(r))};x.doesNotReject=function doesNotReject(e){for(var t=arguments.length,r=new Array(t>1?t-1:0),n=1;n<t;n++){r[n-1]=arguments[n]}return waitForActual(e).then((function(e){return expectsNoError.apply(void 0,[doesNotReject,e].concat(r))}))};x.ifError=function ifError(e){if(e!==null&&e!==undefined){var t="ifError got unwanted exception: ";if(_typeof(e)==="object"&&typeof e.message==="string"){if(e.message.length===0&&e.constructor){t+=e.constructor.name}else{t+=e.message}}else{t+=p(e)}var r=new s({actual:e,expected:null,operator:"ifError",message:t,stackStartFn:ifError});var n=e.stack;if(typeof n==="string"){var o=n.split("\n");o.shift();var i=r.stack.split("\n");for(var a=0;a<o.length;a++){var c=i.indexOf(o[a]);if(c!==-1){i=i.slice(0,c);break}}r.stack="".concat(i.join("\n"),"\n").concat(o.join("\n"))}throw r}};function strict(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++){t[r]=arguments[r]}innerOk.apply(void 0,[strict,t.length].concat(t))}x.strict=d(strict,x,{equal:x.strictEqual,deepEqual:x.deepStrictEqual,notEqual:x.notStrictEqual,notDeepEqual:x.notDeepStrictEqual});x.strict.strict=x.strict},971:function(e,t,r){"use strict";function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};var n=Object.keys(r);if(typeof Object.getOwnPropertySymbols==="function"){n=n.concat(Object.getOwnPropertySymbols(r).filter((function(e){return Object.getOwnPropertyDescriptor(r,e).enumerable})))}n.forEach((function(t){_defineProperty(e,t,r[t])}))}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}function _classCallCheck(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function")}}function _defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||false;n.configurable=true;if("value"in n)n.writable=true;Object.defineProperty(e,n.key,n)}}function _createClass(e,t,r){if(t)_defineProperties(e.prototype,t);if(r)_defineProperties(e,r);return e}function _possibleConstructorReturn(e,t){if(t&&(_typeof(t)==="object"||typeof t==="function")){return t}return _assertThisInitialized(e)}function _assertThisInitialized(e){if(e===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}return e}function _inherits(e,t){if(typeof t!=="function"&&t!==null){throw new TypeError("Super expression must either be null or a function")}e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:true,configurable:true}});if(t)_setPrototypeOf(e,t)}function _wrapNativeSuper(e){var t=typeof Map==="function"?new Map:undefined;_wrapNativeSuper=function _wrapNativeSuper(e){if(e===null||!_isNativeFunction(e))return e;if(typeof e!=="function"){throw new TypeError("Super expression must either be null or a function")}if(typeof t!=="undefined"){if(t.has(e))return t.get(e);t.set(e,Wrapper)}function Wrapper(){return _construct(e,arguments,_getPrototypeOf(this).constructor)}Wrapper.prototype=Object.create(e.prototype,{constructor:{value:Wrapper,enumerable:false,writable:true,configurable:true}});return _setPrototypeOf(Wrapper,e)};return _wrapNativeSuper(e)}function isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Date.prototype.toString.call(Reflect.construct(Date,[],(function(){})));return true}catch(e){return false}}function _construct(e,t,r){if(isNativeReflectConstruct()){_construct=Reflect.construct}else{_construct=function _construct(e,t,r){var n=[null];n.push.apply(n,t);var o=Function.bind.apply(e,n);var i=new o;if(r)_setPrototypeOf(i,r.prototype);return i}}return _construct.apply(null,arguments)}function _isNativeFunction(e){return Function.toString.call(e).indexOf("[native code]")!==-1}function _setPrototypeOf(e,t){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(e,t){e.__proto__=t;return e};return _setPrototypeOf(e,t)}function _getPrototypeOf(e){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(e){return e.__proto__||Object.getPrototypeOf(e)};return _getPrototypeOf(e)}function _typeof(e){if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(e){return typeof e}}else{_typeof=function _typeof(e){return e&&typeof Symbol==="function"&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e}}return _typeof(e)}var n=r(467),o=n.inspect;var i=r(977),a=i.codes.ERR_INVALID_ARG_TYPE;function endsWith(e,t,r){if(r===undefined||r>e.length){r=e.length}return e.substring(r-t.length,r)===t}function repeat(e,t){t=Math.floor(t);if(e.length==0||t==0)return"";var r=e.length*t;t=Math.floor(Math.log(t)/Math.log(2));while(t){e+=e;t--}e+=e.substring(0,r-e.length);return e}var c="";var u="";var f="";var s="";var l={deepStrictEqual:"Expected values to be strictly deep-equal:",strictEqual:"Expected values to be strictly equal:",strictEqualObject:'Expected "actual" to be reference-equal to "expected":',deepEqual:"Expected values to be loosely deep-equal:",equal:"Expected values to be loosely equal:",notDeepStrictEqual:'Expected "actual" not to be strictly deep-equal to:',notStrictEqual:'Expected "actual" to be strictly unequal to:',notStrictEqualObject:'Expected "actual" not to be reference-equal to "expected":',notDeepEqual:'Expected "actual" not to be loosely deep-equal to:',notEqual:'Expected "actual" to be loosely unequal to:',notIdentical:"Values identical but not reference-equal:"};var p=10;function copyError(e){var t=Object.keys(e);var r=Object.create(Object.getPrototypeOf(e));t.forEach((function(t){r[t]=e[t]}));Object.defineProperty(r,"message",{value:e.message});return r}function inspectValue(e){return o(e,{compact:false,customInspect:false,depth:1e3,maxArrayLength:Infinity,showHidden:false,breakLength:Infinity,showProxy:false,sorted:true,getters:true})}function createErrDiff(e,t,r){var n="";var o="";var i=0;var a="";var y=false;var g=inspectValue(e);var v=g.split("\n");var d=inspectValue(t).split("\n");var b=0;var h="";if(r==="strictEqual"&&_typeof(e)==="object"&&_typeof(t)==="object"&&e!==null&&t!==null){r="strictEqualObject"}if(v.length===1&&d.length===1&&v[0]!==d[0]){var m=v[0].length+d[0].length;if(m<=p){if((_typeof(e)!=="object"||e===null)&&(_typeof(t)!=="object"||t===null)&&(e!==0||t!==0)){return"".concat(l[r],"\n\n")+"".concat(v[0]," !== ").concat(d[0],"\n")}}else if(r!=="strictEqualObject"){var S=process.stderr&&process.stderr.isTTY?process.stderr.columns:80;if(m<S){while(v[0][b]===d[0][b]){b++}if(b>2){h="\n  ".concat(repeat(" ",b),"^");b=0}}}}var E=v[v.length-1];var O=d[d.length-1];while(E===O){if(b++<2){a="\n  ".concat(E).concat(a)}else{n=E}v.pop();d.pop();if(v.length===0||d.length===0)break;E=v[v.length-1];O=d[d.length-1]}var A=Math.max(v.length,d.length);if(A===0){var w=g.split("\n");if(w.length>30){w[26]="".concat(c,"...").concat(s);while(w.length>27){w.pop()}}return"".concat(l.notIdentical,"\n\n").concat(w.join("\n"),"\n")}if(b>3){a="\n".concat(c,"...").concat(s).concat(a);y=true}if(n!==""){a="\n  ".concat(n).concat(a);n=""}var j=0;var _=l[r]+"\n".concat(u,"+ actual").concat(s," ").concat(f,"- expected").concat(s);var P=" ".concat(c,"...").concat(s," Lines skipped");for(b=0;b<A;b++){var x=b-i;if(v.length<b+1){if(x>1&&b>2){if(x>4){o+="\n".concat(c,"...").concat(s);y=true}else if(x>3){o+="\n  ".concat(d[b-2]);j++}o+="\n  ".concat(d[b-1]);j++}i=b;n+="\n".concat(f,"-").concat(s," ").concat(d[b]);j++}else if(d.length<b+1){if(x>1&&b>2){if(x>4){o+="\n".concat(c,"...").concat(s);y=true}else if(x>3){o+="\n  ".concat(v[b-2]);j++}o+="\n  ".concat(v[b-1]);j++}i=b;o+="\n".concat(u,"+").concat(s," ").concat(v[b]);j++}else{var k=d[b];var T=v[b];var I=T!==k&&(!endsWith(T,",")||T.slice(0,-1)!==k);if(I&&endsWith(k,",")&&k.slice(0,-1)===T){I=false;T+=","}if(I){if(x>1&&b>2){if(x>4){o+="\n".concat(c,"...").concat(s);y=true}else if(x>3){o+="\n  ".concat(v[b-2]);j++}o+="\n  ".concat(v[b-1]);j++}i=b;o+="\n".concat(u,"+").concat(s," ").concat(T);n+="\n".concat(f,"-").concat(s," ").concat(k);j+=2}else{o+=n;n="";if(x===1||b===0){o+="\n  ".concat(T);j++}}}if(j>20&&b<A-2){return"".concat(_).concat(P,"\n").concat(o,"\n").concat(c,"...").concat(s).concat(n,"\n")+"".concat(c,"...").concat(s)}}return"".concat(_).concat(y?P:"","\n").concat(o).concat(n).concat(a).concat(h)}var y=function(e){_inherits(AssertionError,e);function AssertionError(e){var t;_classCallCheck(this,AssertionError);if(_typeof(e)!=="object"||e===null){throw new a("options","Object",e)}var r=e.message,n=e.operator,o=e.stackStartFn;var i=e.actual,p=e.expected;var y=Error.stackTraceLimit;Error.stackTraceLimit=0;if(r!=null){t=_possibleConstructorReturn(this,_getPrototypeOf(AssertionError).call(this,String(r)))}else{if(process.stderr&&process.stderr.isTTY){if(process.stderr&&process.stderr.getColorDepth&&process.stderr.getColorDepth()!==1){c="[34m";u="[32m";s="[39m";f="[31m"}else{c="";u="";s="";f=""}}if(_typeof(i)==="object"&&i!==null&&_typeof(p)==="object"&&p!==null&&"stack"in i&&i instanceof Error&&"stack"in p&&p instanceof Error){i=copyError(i);p=copyError(p)}if(n==="deepStrictEqual"||n==="strictEqual"){t=_possibleConstructorReturn(this,_getPrototypeOf(AssertionError).call(this,createErrDiff(i,p,n)))}else if(n==="notDeepStrictEqual"||n==="notStrictEqual"){var g=l[n];var v=inspectValue(i).split("\n");if(n==="notStrictEqual"&&_typeof(i)==="object"&&i!==null){g=l.notStrictEqualObject}if(v.length>30){v[26]="".concat(c,"...").concat(s);while(v.length>27){v.pop()}}if(v.length===1){t=_possibleConstructorReturn(this,_getPrototypeOf(AssertionError).call(this,"".concat(g," ").concat(v[0])))}else{t=_possibleConstructorReturn(this,_getPrototypeOf(AssertionError).call(this,"".concat(g,"\n\n").concat(v.join("\n"),"\n")))}}else{var d=inspectValue(i);var b="";var h=l[n];if(n==="notDeepEqual"||n==="notEqual"){d="".concat(l[n],"\n\n").concat(d);if(d.length>1024){d="".concat(d.slice(0,1021),"...")}}else{b="".concat(inspectValue(p));if(d.length>512){d="".concat(d.slice(0,509),"...")}if(b.length>512){b="".concat(b.slice(0,509),"...")}if(n==="deepEqual"||n==="equal"){d="".concat(h,"\n\n").concat(d,"\n\nshould equal\n\n")}else{b=" ".concat(n," ").concat(b)}}t=_possibleConstructorReturn(this,_getPrototypeOf(AssertionError).call(this,"".concat(d).concat(b)))}}Error.stackTraceLimit=y;t.generatedMessage=!r;Object.defineProperty(_assertThisInitialized(t),"name",{value:"AssertionError [ERR_ASSERTION]",enumerable:false,writable:true,configurable:true});t.code="ERR_ASSERTION";t.actual=i;t.expected=p;t.operator=n;if(Error.captureStackTrace){Error.captureStackTrace(_assertThisInitialized(t),o)}t.stack;t.name="AssertionError";return _possibleConstructorReturn(t)}_createClass(AssertionError,[{key:"toString",value:function toString(){return"".concat(this.name," [").concat(this.code,"]: ").concat(this.message)}},{key:o.custom,value:function value(e,t){return o(this,_objectSpread({},t,{customInspect:false,depth:0}))}}]);return AssertionError}(_wrapNativeSuper(Error));e.exports=y},977:function(e,t,r){"use strict";function _typeof(e){if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(e){return typeof e}}else{_typeof=function _typeof(e){return e&&typeof Symbol==="function"&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e}}return _typeof(e)}function _classCallCheck(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function")}}function _possibleConstructorReturn(e,t){if(t&&(_typeof(t)==="object"||typeof t==="function")){return t}return _assertThisInitialized(e)}function _assertThisInitialized(e){if(e===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}return e}function _getPrototypeOf(e){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(e){return e.__proto__||Object.getPrototypeOf(e)};return _getPrototypeOf(e)}function _inherits(e,t){if(typeof t!=="function"&&t!==null){throw new TypeError("Super expression must either be null or a function")}e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:true,configurable:true}});if(t)_setPrototypeOf(e,t)}function _setPrototypeOf(e,t){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(e,t){e.__proto__=t;return e};return _setPrototypeOf(e,t)}var n={};var o;var i;function createErrorType(e,t,r){if(!r){r=Error}function getMessage(e,r,n){if(typeof t==="string"){return t}else{return t(e,r,n)}}var o=function(t){_inherits(NodeError,t);function NodeError(t,r,n){var o;_classCallCheck(this,NodeError);o=_possibleConstructorReturn(this,_getPrototypeOf(NodeError).call(this,getMessage(t,r,n)));o.code=e;return o}return NodeError}(r);n[e]=o}function oneOf(e,t){if(Array.isArray(e)){var r=e.length;e=e.map((function(e){return String(e)}));if(r>2){return"one of ".concat(t," ").concat(e.slice(0,r-1).join(", "),", or ")+e[r-1]}else if(r===2){return"one of ".concat(t," ").concat(e[0]," or ").concat(e[1])}else{return"of ".concat(t," ").concat(e[0])}}else{return"of ".concat(t," ").concat(String(e))}}function startsWith(e,t,r){return e.substr(!r||r<0?0:+r,t.length)===t}function endsWith(e,t,r){if(r===undefined||r>e.length){r=e.length}return e.substring(r-t.length,r)===t}function includes(e,t,r){if(typeof r!=="number"){r=0}if(r+t.length>e.length){return false}else{return e.indexOf(t,r)!==-1}}createErrorType("ERR_AMBIGUOUS_ARGUMENT",'The "%s" argument is ambiguous. %s',TypeError);createErrorType("ERR_INVALID_ARG_TYPE",(function(e,t,n){if(o===undefined)o=r(468);o(typeof e==="string","'name' must be a string");var i;if(typeof t==="string"&&startsWith(t,"not ")){i="must not be";t=t.replace(/^not /,"")}else{i="must be"}var a;if(endsWith(e," argument")){a="The ".concat(e," ").concat(i," ").concat(oneOf(t,"type"))}else{var c=includes(e,".")?"property":"argument";a='The "'.concat(e,'" ').concat(c," ").concat(i," ").concat(oneOf(t,"type"))}a+=". Received type ".concat(_typeof(n));return a}),TypeError);createErrorType("ERR_INVALID_ARG_VALUE",(function(e,t){var n=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"is invalid";if(i===undefined)i=r(467);var o=i.inspect(t);if(o.length>128){o="".concat(o.slice(0,128),"...")}return"The argument '".concat(e,"' ").concat(n,". Received ").concat(o)}),TypeError,RangeError);createErrorType("ERR_INVALID_RETURN_VALUE",(function(e,t,r){var n;if(r&&r.constructor&&r.constructor.name){n="instance of ".concat(r.constructor.name)}else{n="type ".concat(_typeof(r))}return"Expected ".concat(e,' to be returned from the "').concat(t,'"')+" function but got ".concat(n,".")}),TypeError);createErrorType("ERR_MISSING_ARGS",(function(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++){t[n]=arguments[n]}if(o===undefined)o=r(468);o(t.length>0,"At least one arg needs to be specified");var i="The ";var a=t.length;t=t.map((function(e){return'"'.concat(e,'"')}));switch(a){case 1:i+="".concat(t[0]," argument");break;case 2:i+="".concat(t[0]," and ").concat(t[1]," arguments");break;default:i+=t.slice(0,a-1).join(", ");i+=", and ".concat(t[a-1]," arguments");break}return"".concat(i," must be specified")}),TypeError);e.exports.codes=n},97:function(e,t,r){"use strict";function _slicedToArray(e,t){return _arrayWithHoles(e)||_iterableToArrayLimit(e,t)||_nonIterableRest()}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}function _iterableToArrayLimit(e,t){var r=[];var n=true;var o=false;var i=undefined;try{for(var a=e[Symbol.iterator](),c;!(n=(c=a.next()).done);n=true){r.push(c.value);if(t&&r.length===t)break}}catch(e){o=true;i=e}finally{try{if(!n&&a["return"]!=null)a["return"]()}finally{if(o)throw i}}return r}function _arrayWithHoles(e){if(Array.isArray(e))return e}function _typeof(e){if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(e){return typeof e}}else{_typeof=function _typeof(e){return e&&typeof Symbol==="function"&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e}}return _typeof(e)}var n=/a/g.flags!==undefined;var o=function arrayFromSet(e){var t=[];e.forEach((function(e){return t.push(e)}));return t};var i=function arrayFromMap(e){var t=[];e.forEach((function(e,r){return t.push([r,e])}));return t};var a=Object.is?Object.is:r(113);var c=Object.getOwnPropertySymbols?Object.getOwnPropertySymbols:function(){return[]};var u=Number.isNaN?Number.isNaN:r(252);function uncurryThis(e){return e.call.bind(e)}var f=uncurryThis(Object.prototype.hasOwnProperty);var s=uncurryThis(Object.prototype.propertyIsEnumerable);var l=uncurryThis(Object.prototype.toString);var p=r(467).types,y=p.isAnyArrayBuffer,g=p.isArrayBufferView,v=p.isDate,d=p.isMap,b=p.isRegExp,h=p.isSet,m=p.isNativeError,S=p.isBoxedPrimitive,E=p.isNumberObject,O=p.isStringObject,A=p.isBooleanObject,w=p.isBigIntObject,j=p.isSymbolObject,_=p.isFloat32Array,P=p.isFloat64Array;function isNonIndex(e){if(e.length===0||e.length>10)return true;for(var t=0;t<e.length;t++){var r=e.charCodeAt(t);if(r<48||r>57)return true}return e.length===10&&e>=Math.pow(2,32)}function getOwnNonIndexProperties(e){return Object.keys(e).filter(isNonIndex).concat(c(e).filter(Object.prototype.propertyIsEnumerable.bind(e)))}
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */function compare(e,t){if(e===t){return 0}var r=e.length;var n=t.length;for(var o=0,i=Math.min(r,n);o<i;++o){if(e[o]!==t[o]){r=e[o];n=t[o];break}}if(r<n){return-1}if(n<r){return 1}return 0}var x=undefined;var k=true;var T=false;var I=0;var N=1;var F=2;var R=3;function areSimilarRegExps(e,t){return n?e.source===t.source&&e.flags===t.flags:RegExp.prototype.toString.call(e)===RegExp.prototype.toString.call(t)}function areSimilarFloatArrays(e,t){if(e.byteLength!==t.byteLength){return false}for(var r=0;r<e.byteLength;r++){if(e[r]!==t[r]){return false}}return true}function areSimilarTypedArrays(e,t){if(e.byteLength!==t.byteLength){return false}return compare(new Uint8Array(e.buffer,e.byteOffset,e.byteLength),new Uint8Array(t.buffer,t.byteOffset,t.byteLength))===0}function areEqualArrayBuffers(e,t){return e.byteLength===t.byteLength&&compare(new Uint8Array(e),new Uint8Array(t))===0}function isEqualBoxedPrimitive(e,t){if(E(e)){return E(t)&&a(Number.prototype.valueOf.call(e),Number.prototype.valueOf.call(t))}if(O(e)){return O(t)&&String.prototype.valueOf.call(e)===String.prototype.valueOf.call(t)}if(A(e)){return A(t)&&Boolean.prototype.valueOf.call(e)===Boolean.prototype.valueOf.call(t)}if(w(e)){return w(t)&&BigInt.prototype.valueOf.call(e)===BigInt.prototype.valueOf.call(t)}return j(t)&&Symbol.prototype.valueOf.call(e)===Symbol.prototype.valueOf.call(t)}function innerDeepEqual(e,t,r,n){if(e===t){if(e!==0)return true;return r?a(e,t):true}if(r){if(_typeof(e)!=="object"){return typeof e==="number"&&u(e)&&u(t)}if(_typeof(t)!=="object"||e===null||t===null){return false}if(Object.getPrototypeOf(e)!==Object.getPrototypeOf(t)){return false}}else{if(e===null||_typeof(e)!=="object"){if(t===null||_typeof(t)!=="object"){return e==t}return false}if(t===null||_typeof(t)!=="object"){return false}}var o=l(e);var i=l(t);if(o!==i){return false}if(Array.isArray(e)){if(e.length!==t.length){return false}var c=getOwnNonIndexProperties(e,x);var f=getOwnNonIndexProperties(t,x);if(c.length!==f.length){return false}return keyCheck(e,t,r,n,N,c)}if(o==="[object Object]"){if(!d(e)&&d(t)||!h(e)&&h(t)){return false}}if(v(e)){if(!v(t)||Date.prototype.getTime.call(e)!==Date.prototype.getTime.call(t)){return false}}else if(b(e)){if(!b(t)||!areSimilarRegExps(e,t)){return false}}else if(m(e)||e instanceof Error){if(e.message!==t.message||e.name!==t.name){return false}}else if(g(e)){if(!r&&(_(e)||P(e))){if(!areSimilarFloatArrays(e,t)){return false}}else if(!areSimilarTypedArrays(e,t)){return false}var s=getOwnNonIndexProperties(e,x);var p=getOwnNonIndexProperties(t,x);if(s.length!==p.length){return false}return keyCheck(e,t,r,n,I,s)}else if(h(e)){if(!h(t)||e.size!==t.size){return false}return keyCheck(e,t,r,n,F)}else if(d(e)){if(!d(t)||e.size!==t.size){return false}return keyCheck(e,t,r,n,R)}else if(y(e)){if(!areEqualArrayBuffers(e,t)){return false}}else if(S(e)&&!isEqualBoxedPrimitive(e,t)){return false}return keyCheck(e,t,r,n,I)}function getEnumerables(e,t){return t.filter((function(t){return s(e,t)}))}function keyCheck(e,t,r,n,o,i){if(arguments.length===5){i=Object.keys(e);var a=Object.keys(t);if(i.length!==a.length){return false}}var u=0;for(;u<i.length;u++){if(!f(t,i[u])){return false}}if(r&&arguments.length===5){var l=c(e);if(l.length!==0){var p=0;for(u=0;u<l.length;u++){var y=l[u];if(s(e,y)){if(!s(t,y)){return false}i.push(y);p++}else if(s(t,y)){return false}}var g=c(t);if(l.length!==g.length&&getEnumerables(t,g).length!==p){return false}}else{var v=c(t);if(v.length!==0&&getEnumerables(t,v).length!==0){return false}}}if(i.length===0&&(o===I||o===N&&e.length===0||e.size===0)){return true}if(n===undefined){n={val1:new Map,val2:new Map,position:0}}else{var d=n.val1.get(e);if(d!==undefined){var b=n.val2.get(t);if(b!==undefined){return d===b}}n.position++}n.val1.set(e,n.position);n.val2.set(t,n.position);var h=objEquiv(e,t,r,i,n,o);n.val1.delete(e);n.val2.delete(t);return h}function setHasEqualElement(e,t,r,n){var i=o(e);for(var a=0;a<i.length;a++){var c=i[a];if(innerDeepEqual(t,c,r,n)){e.delete(c);return true}}return false}function findLooseMatchingPrimitives(e){switch(_typeof(e)){case"undefined":return null;case"object":return undefined;case"symbol":return false;case"string":e=+e;case"number":if(u(e)){return false}}return true}function setMightHaveLoosePrim(e,t,r){var n=findLooseMatchingPrimitives(r);if(n!=null)return n;return t.has(n)&&!e.has(n)}function mapMightHaveLoosePrim(e,t,r,n,o){var i=findLooseMatchingPrimitives(r);if(i!=null){return i}var a=t.get(i);if(a===undefined&&!t.has(i)||!innerDeepEqual(n,a,false,o)){return false}return!e.has(i)&&innerDeepEqual(n,a,false,o)}function setEquiv(e,t,r,n){var i=null;var a=o(e);for(var c=0;c<a.length;c++){var u=a[c];if(_typeof(u)==="object"&&u!==null){if(i===null){i=new Set}i.add(u)}else if(!t.has(u)){if(r)return false;if(!setMightHaveLoosePrim(e,t,u)){return false}if(i===null){i=new Set}i.add(u)}}if(i!==null){var f=o(t);for(var s=0;s<f.length;s++){var l=f[s];if(_typeof(l)==="object"&&l!==null){if(!setHasEqualElement(i,l,r,n))return false}else if(!r&&!e.has(l)&&!setHasEqualElement(i,l,r,n)){return false}}return i.size===0}return true}function mapHasEqualEntry(e,t,r,n,i,a){var c=o(e);for(var u=0;u<c.length;u++){var f=c[u];if(innerDeepEqual(r,f,i,a)&&innerDeepEqual(n,t.get(f),i,a)){e.delete(f);return true}}return false}function mapEquiv(e,t,r,n){var o=null;var a=i(e);for(var c=0;c<a.length;c++){var u=_slicedToArray(a[c],2),f=u[0],s=u[1];if(_typeof(f)==="object"&&f!==null){if(o===null){o=new Set}o.add(f)}else{var l=t.get(f);if(l===undefined&&!t.has(f)||!innerDeepEqual(s,l,r,n)){if(r)return false;if(!mapMightHaveLoosePrim(e,t,f,s,n))return false;if(o===null){o=new Set}o.add(f)}}}if(o!==null){var p=i(t);for(var y=0;y<p.length;y++){var g=_slicedToArray(p[y],2),f=g[0],v=g[1];if(_typeof(f)==="object"&&f!==null){if(!mapHasEqualEntry(o,e,f,v,r,n))return false}else if(!r&&(!e.has(f)||!innerDeepEqual(e.get(f),v,false,n))&&!mapHasEqualEntry(o,e,f,v,false,n)){return false}}return o.size===0}return true}function objEquiv(e,t,r,n,o,i){var a=0;if(i===F){if(!setEquiv(e,t,r,o)){return false}}else if(i===R){if(!mapEquiv(e,t,r,o)){return false}}else if(i===N){for(;a<e.length;a++){if(f(e,a)){if(!f(t,a)||!innerDeepEqual(e[a],t[a],r,o)){return false}}else if(f(t,a)){return false}else{var c=Object.keys(e);for(;a<c.length;a++){var u=c[a];if(!f(t,u)||!innerDeepEqual(e[u],t[u],r,o)){return false}}if(c.length!==Object.keys(t).length){return false}return true}}}for(a=0;a<n.length;a++){var s=n[a];if(!innerDeepEqual(e[s],t[s],r,o)){return false}}return true}function isDeepEqual(e,t){return innerDeepEqual(e,t,T)}function isDeepStrictEqual(e,t){return innerDeepEqual(e,t,k)}e.exports={isDeepEqual:isDeepEqual,isDeepStrictEqual:isDeepStrictEqual}},171:function(e,t,r){"use strict";var n=r(627);var o=r(302);var i=o(n("String.prototype.indexOf"));e.exports=function callBoundIntrinsic(e,t){var r=n(e,!!t);if(typeof r==="function"&&i(e,".prototype.")>-1){return o(r)}return r}},302:function(e,t,r){"use strict";var n=r(194);var o=r(627);var i=o("%Function.prototype.apply%");var a=o("%Function.prototype.call%");var c=o("%Reflect.apply%",true)||n.call(a,i);var u=o("%Object.getOwnPropertyDescriptor%",true);var f=o("%Object.defineProperty%",true);var s=o("%Math.max%");if(f){try{f({},"a",{value:1})}catch(e){f=null}}e.exports=function callBind(e){var t=c(n,a,arguments);if(u&&f){var r=u(t,"length");if(r.configurable){f(t,"length",{value:1+s(0,e.length-(arguments.length-1))})}}return t};var l=function applyBind(){return c(n,i,arguments)};if(f){f(e.exports,"apply",{value:l})}else{e.exports.apply=l}},217:function(e,t,r){"use strict";var n=r(705);var o=typeof Symbol==="function"&&typeof Symbol("foo")==="symbol";var i=Object.prototype.toString;var a=Array.prototype.concat;var c=Object.defineProperty;var isFunction=function(e){return typeof e==="function"&&i.call(e)==="[object Function]"};var arePropertyDescriptorsSupported=function(){var e={};try{c(e,"x",{enumerable:false,value:e});for(var t in e){return false}return e.x===e}catch(e){return false}};var u=c&&arePropertyDescriptorsSupported();var defineProperty=function(e,t,r,n){if(t in e&&(!isFunction(n)||!n())){return}if(u){c(e,t,{configurable:true,enumerable:false,value:r,writable:true})}else{e[t]=r}};var defineProperties=function(e,t){var r=arguments.length>2?arguments[2]:{};var i=n(t);if(o){i=a.call(i,Object.getOwnPropertySymbols(t))}for(var c=0;c<i.length;c+=1){defineProperty(e,i[c],t[i[c]],r[i[c]])}};defineProperties.supportsDescriptors=!!u;e.exports=defineProperties},203:function(e){"use strict";function assign(e,t){if(e===undefined||e===null){throw new TypeError("Cannot convert first argument to object")}var r=Object(e);for(var n=1;n<arguments.length;n++){var o=arguments[n];if(o===undefined||o===null){continue}var i=Object.keys(Object(o));for(var a=0,c=i.length;a<c;a++){var u=i[a];var f=Object.getOwnPropertyDescriptor(o,u);if(f!==undefined&&f.enumerable){r[u]=o[u]}}}return r}function polyfill(){if(!Object.assign){Object.defineProperty(Object,"assign",{enumerable:false,configurable:true,writable:true,value:assign})}}e.exports={assign:assign,polyfill:polyfill}},981:function(e){var t=Object.prototype.hasOwnProperty;var r=Object.prototype.toString;e.exports=function forEach(e,n,o){if(r.call(n)!=="[object Function]"){throw new TypeError("iterator must be a function")}var i=e.length;if(i===+i){for(var a=0;a<i;a++){n.call(o,e[a],a,e)}}else{for(var c in e){if(t.call(e,c)){n.call(o,e[c],c,e)}}}}},861:function(e){"use strict";var t="Function.prototype.bind called on incompatible ";var r=Array.prototype.slice;var n=Object.prototype.toString;var o="[object Function]";e.exports=function bind(e){var i=this;if(typeof i!=="function"||n.call(i)!==o){throw new TypeError(t+i)}var a=r.call(arguments,1);var c;var binder=function(){if(this instanceof c){var t=i.apply(this,a.concat(r.call(arguments)));if(Object(t)===t){return t}return this}else{return i.apply(e,a.concat(r.call(arguments)))}};var u=Math.max(0,i.length-a.length);var f=[];for(var s=0;s<u;s++){f.push("$"+s)}c=Function("binder","return function ("+f.join(",")+"){ return binder.apply(this,arguments); }")(binder);if(i.prototype){var l=function Empty(){};l.prototype=i.prototype;c.prototype=new l;l.prototype=null}return c}},194:function(e,t,r){"use strict";var n=r(861);e.exports=Function.prototype.bind||n},627:function(e,t,r){"use strict";var n;var o=SyntaxError;var i=Function;var a=TypeError;var getEvalledConstructor=function(e){try{return i('"use strict"; return ('+e+").constructor;")()}catch(e){}};var c=Object.getOwnPropertyDescriptor;if(c){try{c({},"")}catch(e){c=null}}var throwTypeError=function(){throw new a};var u=c?function(){try{arguments.callee;return throwTypeError}catch(e){try{return c(arguments,"callee").get}catch(e){return throwTypeError}}}():throwTypeError;var f=r(567)();var s=Object.getPrototypeOf||function(e){return e.__proto__};var l={};var p=typeof Uint8Array==="undefined"?n:s(Uint8Array);var y={"%AggregateError%":typeof AggregateError==="undefined"?n:AggregateError,"%Array%":Array,"%ArrayBuffer%":typeof ArrayBuffer==="undefined"?n:ArrayBuffer,"%ArrayIteratorPrototype%":f?s([][Symbol.iterator]()):n,"%AsyncFromSyncIteratorPrototype%":n,"%AsyncFunction%":l,"%AsyncGenerator%":l,"%AsyncGeneratorFunction%":l,"%AsyncIteratorPrototype%":l,"%Atomics%":typeof Atomics==="undefined"?n:Atomics,"%BigInt%":typeof BigInt==="undefined"?n:BigInt,"%Boolean%":Boolean,"%DataView%":typeof DataView==="undefined"?n:DataView,"%Date%":Date,"%decodeURI%":decodeURI,"%decodeURIComponent%":decodeURIComponent,"%encodeURI%":encodeURI,"%encodeURIComponent%":encodeURIComponent,"%Error%":Error,"%eval%":eval,"%EvalError%":EvalError,"%Float32Array%":typeof Float32Array==="undefined"?n:Float32Array,"%Float64Array%":typeof Float64Array==="undefined"?n:Float64Array,"%FinalizationRegistry%":typeof FinalizationRegistry==="undefined"?n:FinalizationRegistry,"%Function%":i,"%GeneratorFunction%":l,"%Int8Array%":typeof Int8Array==="undefined"?n:Int8Array,"%Int16Array%":typeof Int16Array==="undefined"?n:Int16Array,"%Int32Array%":typeof Int32Array==="undefined"?n:Int32Array,"%isFinite%":isFinite,"%isNaN%":isNaN,"%IteratorPrototype%":f?s(s([][Symbol.iterator]())):n,"%JSON%":typeof JSON==="object"?JSON:n,"%Map%":typeof Map==="undefined"?n:Map,"%MapIteratorPrototype%":typeof Map==="undefined"||!f?n:s((new Map)[Symbol.iterator]()),"%Math%":Math,"%Number%":Number,"%Object%":Object,"%parseFloat%":parseFloat,"%parseInt%":parseInt,"%Promise%":typeof Promise==="undefined"?n:Promise,"%Proxy%":typeof Proxy==="undefined"?n:Proxy,"%RangeError%":RangeError,"%ReferenceError%":ReferenceError,"%Reflect%":typeof Reflect==="undefined"?n:Reflect,"%RegExp%":RegExp,"%Set%":typeof Set==="undefined"?n:Set,"%SetIteratorPrototype%":typeof Set==="undefined"||!f?n:s((new Set)[Symbol.iterator]()),"%SharedArrayBuffer%":typeof SharedArrayBuffer==="undefined"?n:SharedArrayBuffer,"%String%":String,"%StringIteratorPrototype%":f?s(""[Symbol.iterator]()):n,"%Symbol%":f?Symbol:n,"%SyntaxError%":o,"%ThrowTypeError%":u,"%TypedArray%":p,"%TypeError%":a,"%Uint8Array%":typeof Uint8Array==="undefined"?n:Uint8Array,"%Uint8ClampedArray%":typeof Uint8ClampedArray==="undefined"?n:Uint8ClampedArray,"%Uint16Array%":typeof Uint16Array==="undefined"?n:Uint16Array,"%Uint32Array%":typeof Uint32Array==="undefined"?n:Uint32Array,"%URIError%":URIError,"%WeakMap%":typeof WeakMap==="undefined"?n:WeakMap,"%WeakRef%":typeof WeakRef==="undefined"?n:WeakRef,"%WeakSet%":typeof WeakSet==="undefined"?n:WeakSet};var g=function doEval(e){var t;if(e==="%AsyncFunction%"){t=getEvalledConstructor("async function () {}")}else if(e==="%GeneratorFunction%"){t=getEvalledConstructor("function* () {}")}else if(e==="%AsyncGeneratorFunction%"){t=getEvalledConstructor("async function* () {}")}else if(e==="%AsyncGenerator%"){var r=doEval("%AsyncGeneratorFunction%");if(r){t=r.prototype}}else if(e==="%AsyncIteratorPrototype%"){var n=doEval("%AsyncGenerator%");if(n){t=s(n.prototype)}}y[e]=t;return t};var v={"%ArrayBufferPrototype%":["ArrayBuffer","prototype"],"%ArrayPrototype%":["Array","prototype"],"%ArrayProto_entries%":["Array","prototype","entries"],"%ArrayProto_forEach%":["Array","prototype","forEach"],"%ArrayProto_keys%":["Array","prototype","keys"],"%ArrayProto_values%":["Array","prototype","values"],"%AsyncFunctionPrototype%":["AsyncFunction","prototype"],"%AsyncGenerator%":["AsyncGeneratorFunction","prototype"],"%AsyncGeneratorPrototype%":["AsyncGeneratorFunction","prototype","prototype"],"%BooleanPrototype%":["Boolean","prototype"],"%DataViewPrototype%":["DataView","prototype"],"%DatePrototype%":["Date","prototype"],"%ErrorPrototype%":["Error","prototype"],"%EvalErrorPrototype%":["EvalError","prototype"],"%Float32ArrayPrototype%":["Float32Array","prototype"],"%Float64ArrayPrototype%":["Float64Array","prototype"],"%FunctionPrototype%":["Function","prototype"],"%Generator%":["GeneratorFunction","prototype"],"%GeneratorPrototype%":["GeneratorFunction","prototype","prototype"],"%Int8ArrayPrototype%":["Int8Array","prototype"],"%Int16ArrayPrototype%":["Int16Array","prototype"],"%Int32ArrayPrototype%":["Int32Array","prototype"],"%JSONParse%":["JSON","parse"],"%JSONStringify%":["JSON","stringify"],"%MapPrototype%":["Map","prototype"],"%NumberPrototype%":["Number","prototype"],"%ObjectPrototype%":["Object","prototype"],"%ObjProto_toString%":["Object","prototype","toString"],"%ObjProto_valueOf%":["Object","prototype","valueOf"],"%PromisePrototype%":["Promise","prototype"],"%PromiseProto_then%":["Promise","prototype","then"],"%Promise_all%":["Promise","all"],"%Promise_reject%":["Promise","reject"],"%Promise_resolve%":["Promise","resolve"],"%RangeErrorPrototype%":["RangeError","prototype"],"%ReferenceErrorPrototype%":["ReferenceError","prototype"],"%RegExpPrototype%":["RegExp","prototype"],"%SetPrototype%":["Set","prototype"],"%SharedArrayBufferPrototype%":["SharedArrayBuffer","prototype"],"%StringPrototype%":["String","prototype"],"%SymbolPrototype%":["Symbol","prototype"],"%SyntaxErrorPrototype%":["SyntaxError","prototype"],"%TypedArrayPrototype%":["TypedArray","prototype"],"%TypeErrorPrototype%":["TypeError","prototype"],"%Uint8ArrayPrototype%":["Uint8Array","prototype"],"%Uint8ClampedArrayPrototype%":["Uint8ClampedArray","prototype"],"%Uint16ArrayPrototype%":["Uint16Array","prototype"],"%Uint32ArrayPrototype%":["Uint32Array","prototype"],"%URIErrorPrototype%":["URIError","prototype"],"%WeakMapPrototype%":["WeakMap","prototype"],"%WeakSetPrototype%":["WeakSet","prototype"]};var d=r(194);var b=r(646);var h=d.call(Function.call,Array.prototype.concat);var m=d.call(Function.apply,Array.prototype.splice);var S=d.call(Function.call,String.prototype.replace);var E=d.call(Function.call,String.prototype.slice);var O=/[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;var A=/\\(\\)?/g;var w=function stringToPath(e){var t=E(e,0,1);var r=E(e,-1);if(t==="%"&&r!=="%"){throw new o("invalid intrinsic syntax, expected closing `%`")}else if(r==="%"&&t!=="%"){throw new o("invalid intrinsic syntax, expected opening `%`")}var n=[];S(e,O,(function(e,t,r,o){n[n.length]=r?S(o,A,"$1"):t||e}));return n};var j=function getBaseIntrinsic(e,t){var r=e;var n;if(b(v,r)){n=v[r];r="%"+n[0]+"%"}if(b(y,r)){var i=y[r];if(i===l){i=g(r)}if(typeof i==="undefined"&&!t){throw new a("intrinsic "+e+" exists, but is not available. Please file an issue!")}return{alias:n,name:r,value:i}}throw new o("intrinsic "+e+" does not exist!")};e.exports=function GetIntrinsic(e,t){if(typeof e!=="string"||e.length===0){throw new a("intrinsic name must be a non-empty string")}if(arguments.length>1&&typeof t!=="boolean"){throw new a('"allowMissing" argument must be a boolean')}var r=w(e);var i=r.length>0?r[0]:"";var u=j("%"+i+"%",t);var f=u.name;var s=u.value;var l=false;var p=u.alias;if(p){i=p[0];m(r,h([0,1],p))}for(var g=1,v=true;g<r.length;g+=1){var d=r[g];var S=E(d,0,1);var O=E(d,-1);if((S==='"'||S==="'"||S==="`"||(O==='"'||O==="'"||O==="`"))&&S!==O){throw new o("property names with quotes must have matching quotes")}if(d==="constructor"||!v){l=true}i+="."+d;f="%"+i+"%";if(b(y,f)){s=y[f]}else if(s!=null){if(!(d in s)){if(!t){throw new a("base intrinsic for "+e+" exists, but the property is not available.")}return void n}if(c&&g+1>=r.length){var A=c(s,d);v=!!A;if(v&&"get"in A&&!("originalValue"in A.get)){s=A.get}else{s=s[d]}}else{v=b(s,d);s=s[d]}if(v&&!l){y[f]=s}}}return s}},567:function(e,t,r){"use strict";var n=typeof Symbol!=="undefined"&&Symbol;var o=r(186);e.exports=function hasNativeSymbols(){if(typeof n!=="function"){return false}if(typeof Symbol!=="function"){return false}if(typeof n("foo")!=="symbol"){return false}if(typeof Symbol("bar")!=="symbol"){return false}return o()}},186:function(e){"use strict";e.exports=function hasSymbols(){if(typeof Symbol!=="function"||typeof Object.getOwnPropertySymbols!=="function"){return false}if(typeof Symbol.iterator==="symbol"){return true}var e={};var t=Symbol("test");var r=Object(t);if(typeof t==="string"){return false}if(Object.prototype.toString.call(t)!=="[object Symbol]"){return false}if(Object.prototype.toString.call(r)!=="[object Symbol]"){return false}var n=42;e[t]=n;for(t in e){return false}if(typeof Object.keys==="function"&&Object.keys(e).length!==0){return false}if(typeof Object.getOwnPropertyNames==="function"&&Object.getOwnPropertyNames(e).length!==0){return false}var o=Object.getOwnPropertySymbols(e);if(o.length!==1||o[0]!==t){return false}if(!Object.prototype.propertyIsEnumerable.call(e,t)){return false}if(typeof Object.getOwnPropertyDescriptor==="function"){var i=Object.getOwnPropertyDescriptor(e,t);if(i.value!==n||i.enumerable!==true){return false}}return true}},646:function(e,t,r){"use strict";var n=r(194);e.exports=n.call(Function.call,Object.prototype.hasOwnProperty)},140:function(e){if(typeof Object.create==="function"){e.exports=function inherits(e,t){if(t){e.super_=t;e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:false,writable:true,configurable:true}})}}}else{e.exports=function inherits(e,t){if(t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}}}},749:function(e){"use strict";var t=typeof Symbol==="function"&&typeof Symbol.toStringTag==="symbol";var r=Object.prototype.toString;var n=function isArguments(e){if(t&&e&&typeof e==="object"&&Symbol.toStringTag in e){return false}return r.call(e)==="[object Arguments]"};var o=function isArguments(e){if(n(e)){return true}return e!==null&&typeof e==="object"&&typeof e.length==="number"&&e.length>=0&&r.call(e)!=="[object Array]"&&r.call(e.callee)==="[object Function]"};var i=function(){return n(arguments)}();n.isLegacyArguments=o;e.exports=i?n:o},611:function(e){"use strict";var t=Object.prototype.toString;var r=Function.prototype.toString;var n=/^\s*(?:function)?\*/;var o=typeof Symbol==="function"&&typeof Symbol.toStringTag==="symbol";var i=Object.getPrototypeOf;var getGeneratorFunc=function(){if(!o){return false}try{return Function("return function*() {}")()}catch(e){}};var a=getGeneratorFunc();var c=a?i(a):{};e.exports=function isGeneratorFunction(e){if(typeof e!=="function"){return false}if(n.test(r.call(e))){return true}if(!o){var a=t.call(e);return a==="[object GeneratorFunction]"}return i(e)===c}},562:function(e){"use strict";e.exports=function isNaN(e){return e!==e}},252:function(e,t,r){"use strict";var n=r(302);var o=r(217);var i=r(562);var a=r(917);var c=r(828);var u=n(a(),Number);o(u,{getPolyfill:a,implementation:i,shim:c});e.exports=u},917:function(e,t,r){"use strict";var n=r(562);e.exports=function getPolyfill(){if(Number.isNaN&&Number.isNaN(NaN)&&!Number.isNaN("a")){return Number.isNaN}return n}},828:function(e,t,r){"use strict";var n=r(217);var o=r(917);e.exports=function shimNumberIsNaN(){var e=o();n(Number,{isNaN:e},{isNaN:function testIsNaN(){return Number.isNaN!==e}});return e}},387:function(e,t,r){"use strict";var n=r(981);var o=r(382);var i=r(171);var a=i("Object.prototype.toString");var c=r(567)();var u=c&&typeof Symbol.toStringTag==="symbol";var f=o();var s=i("Array.prototype.indexOf",true)||function indexOf(e,t){for(var r=0;r<e.length;r+=1){if(e[r]===t){return r}}return-1};var l=i("String.prototype.slice");var p={};var y=r(30);var g=Object.getPrototypeOf;if(u&&y&&g){n(f,(function(e){var t=new __webpack_require__.g[e];if(!(Symbol.toStringTag in t)){throw new EvalError("this engine has support for Symbol.toStringTag, but "+e+" does not have the property! Please report this.")}var r=g(t);var n=y(r,Symbol.toStringTag);if(!n){var o=g(r);n=y(o,Symbol.toStringTag)}p[e]=n.get}))}var v=function tryAllTypedArrays(e){var t=false;n(p,(function(r,n){if(!t){try{t=r.call(e)===n}catch(e){}}}));return t};e.exports=function isTypedArray(e){if(!e||typeof e!=="object"){return false}if(!u){var t=l(a(e),8,-1);return s(f,t)>-1}if(!y){return false}return v(e)}},113:function(e){"use strict";var numberIsNaN=function(e){return e!==e};e.exports=function is(e,t){if(e===0&&t===0){return 1/e===1/t}if(e===t){return true}if(numberIsNaN(e)&&numberIsNaN(t)){return true}return false}},237:function(e,t,r){"use strict";var n;if(!Object.keys){var o=Object.prototype.hasOwnProperty;var i=Object.prototype.toString;var a=r(857);var c=Object.prototype.propertyIsEnumerable;var u=!c.call({toString:null},"toString");var f=c.call((function(){}),"prototype");var s=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"];var equalsConstructorPrototype=function(e){var t=e.constructor;return t&&t.prototype===e};var l={$applicationCache:true,$console:true,$external:true,$frame:true,$frameElement:true,$frames:true,$innerHeight:true,$innerWidth:true,$onmozfullscreenchange:true,$onmozfullscreenerror:true,$outerHeight:true,$outerWidth:true,$pageXOffset:true,$pageYOffset:true,$parent:true,$scrollLeft:true,$scrollTop:true,$scrollX:true,$scrollY:true,$self:true,$webkitIndexedDB:true,$webkitStorageInfo:true,$window:true};var p=function(){if(typeof window==="undefined"){return false}for(var e in window){try{if(!l["$"+e]&&o.call(window,e)&&window[e]!==null&&typeof window[e]==="object"){try{equalsConstructorPrototype(window[e])}catch(e){return true}}}catch(e){return true}}return false}();var equalsConstructorPrototypeIfNotBuggy=function(e){if(typeof window==="undefined"||!p){return equalsConstructorPrototype(e)}try{return equalsConstructorPrototype(e)}catch(e){return false}};n=function keys(e){var t=e!==null&&typeof e==="object";var r=i.call(e)==="[object Function]";var n=a(e);var c=t&&i.call(e)==="[object String]";var l=[];if(!t&&!r&&!n){throw new TypeError("Object.keys called on a non-object")}var p=f&&r;if(c&&e.length>0&&!o.call(e,0)){for(var y=0;y<e.length;++y){l.push(String(y))}}if(n&&e.length>0){for(var g=0;g<e.length;++g){l.push(String(g))}}else{for(var v in e){if(!(p&&v==="prototype")&&o.call(e,v)){l.push(String(v))}}}if(u){var d=equalsConstructorPrototypeIfNotBuggy(e);for(var b=0;b<s.length;++b){if(!(d&&s[b]==="constructor")&&o.call(e,s[b])){l.push(s[b])}}}return l}}e.exports=n},705:function(e,t,r){"use strict";var n=Array.prototype.slice;var o=r(857);var i=Object.keys;var a=i?function keys(e){return i(e)}:r(237);var c=Object.keys;a.shim=function shimObjectKeys(){if(Object.keys){var e=function(){var e=Object.keys(arguments);return e&&e.length===arguments.length}(1,2);if(!e){Object.keys=function keys(e){if(o(e)){return c(n.call(e))}return c(e)}}}else{Object.keys=a}return Object.keys||a};e.exports=a},857:function(e){"use strict";var t=Object.prototype.toString;e.exports=function isArguments(e){var r=t.call(e);var n=r==="[object Arguments]";if(!n){n=r!=="[object Array]"&&e!==null&&typeof e==="object"&&typeof e.length==="number"&&e.length>=0&&t.call(e.callee)==="[object Function]"}return n}},913:function(e){e.exports=function isBuffer(e){return e instanceof Buffer}},989:function(e,t,r){"use strict";var n=r(749);var o=r(611);var i=r(728);var a=r(387);function uncurryThis(e){return e.call.bind(e)}var c=typeof BigInt!=="undefined";var u=typeof Symbol!=="undefined";var f=uncurryThis(Object.prototype.toString);var s=uncurryThis(Number.prototype.valueOf);var l=uncurryThis(String.prototype.valueOf);var p=uncurryThis(Boolean.prototype.valueOf);if(c){var y=uncurryThis(BigInt.prototype.valueOf)}if(u){var g=uncurryThis(Symbol.prototype.valueOf)}function checkBoxedPrimitive(e,t){if(typeof e!=="object"){return false}try{t(e);return true}catch(e){return false}}t.isArgumentsObject=n;t.isGeneratorFunction=o;t.isTypedArray=a;function isPromise(e){return typeof Promise!=="undefined"&&e instanceof Promise||e!==null&&typeof e==="object"&&typeof e.then==="function"&&typeof e.catch==="function"}t.isPromise=isPromise;function isArrayBufferView(e){if(typeof ArrayBuffer!=="undefined"&&ArrayBuffer.isView){return ArrayBuffer.isView(e)}return a(e)||isDataView(e)}t.isArrayBufferView=isArrayBufferView;function isUint8Array(e){return i(e)==="Uint8Array"}t.isUint8Array=isUint8Array;function isUint8ClampedArray(e){return i(e)==="Uint8ClampedArray"}t.isUint8ClampedArray=isUint8ClampedArray;function isUint16Array(e){return i(e)==="Uint16Array"}t.isUint16Array=isUint16Array;function isUint32Array(e){return i(e)==="Uint32Array"}t.isUint32Array=isUint32Array;function isInt8Array(e){return i(e)==="Int8Array"}t.isInt8Array=isInt8Array;function isInt16Array(e){return i(e)==="Int16Array"}t.isInt16Array=isInt16Array;function isInt32Array(e){return i(e)==="Int32Array"}t.isInt32Array=isInt32Array;function isFloat32Array(e){return i(e)==="Float32Array"}t.isFloat32Array=isFloat32Array;function isFloat64Array(e){return i(e)==="Float64Array"}t.isFloat64Array=isFloat64Array;function isBigInt64Array(e){return i(e)==="BigInt64Array"}t.isBigInt64Array=isBigInt64Array;function isBigUint64Array(e){return i(e)==="BigUint64Array"}t.isBigUint64Array=isBigUint64Array;function isMapToString(e){return f(e)==="[object Map]"}isMapToString.working=typeof Map!=="undefined"&&isMapToString(new Map);function isMap(e){if(typeof Map==="undefined"){return false}return isMapToString.working?isMapToString(e):e instanceof Map}t.isMap=isMap;function isSetToString(e){return f(e)==="[object Set]"}isSetToString.working=typeof Set!=="undefined"&&isSetToString(new Set);function isSet(e){if(typeof Set==="undefined"){return false}return isSetToString.working?isSetToString(e):e instanceof Set}t.isSet=isSet;function isWeakMapToString(e){return f(e)==="[object WeakMap]"}isWeakMapToString.working=typeof WeakMap!=="undefined"&&isWeakMapToString(new WeakMap);function isWeakMap(e){if(typeof WeakMap==="undefined"){return false}return isWeakMapToString.working?isWeakMapToString(e):e instanceof WeakMap}t.isWeakMap=isWeakMap;function isWeakSetToString(e){return f(e)==="[object WeakSet]"}isWeakSetToString.working=typeof WeakSet!=="undefined"&&isWeakSetToString(new WeakSet);function isWeakSet(e){return isWeakSetToString(e)}t.isWeakSet=isWeakSet;function isArrayBufferToString(e){return f(e)==="[object ArrayBuffer]"}isArrayBufferToString.working=typeof ArrayBuffer!=="undefined"&&isArrayBufferToString(new ArrayBuffer);function isArrayBuffer(e){if(typeof ArrayBuffer==="undefined"){return false}return isArrayBufferToString.working?isArrayBufferToString(e):e instanceof ArrayBuffer}t.isArrayBuffer=isArrayBuffer;function isDataViewToString(e){return f(e)==="[object DataView]"}isDataViewToString.working=typeof ArrayBuffer!=="undefined"&&typeof DataView!=="undefined"&&isDataViewToString(new DataView(new ArrayBuffer(1),0,1));function isDataView(e){if(typeof DataView==="undefined"){return false}return isDataViewToString.working?isDataViewToString(e):e instanceof DataView}t.isDataView=isDataView;var v=typeof SharedArrayBuffer!=="undefined"?SharedArrayBuffer:undefined;function isSharedArrayBufferToString(e){return f(e)==="[object SharedArrayBuffer]"}function isSharedArrayBuffer(e){if(typeof v==="undefined"){return false}if(typeof isSharedArrayBufferToString.working==="undefined"){isSharedArrayBufferToString.working=isSharedArrayBufferToString(new v)}return isSharedArrayBufferToString.working?isSharedArrayBufferToString(e):e instanceof v}t.isSharedArrayBuffer=isSharedArrayBuffer;function isAsyncFunction(e){return f(e)==="[object AsyncFunction]"}t.isAsyncFunction=isAsyncFunction;function isMapIterator(e){return f(e)==="[object Map Iterator]"}t.isMapIterator=isMapIterator;function isSetIterator(e){return f(e)==="[object Set Iterator]"}t.isSetIterator=isSetIterator;function isGeneratorObject(e){return f(e)==="[object Generator]"}t.isGeneratorObject=isGeneratorObject;function isWebAssemblyCompiledModule(e){return f(e)==="[object WebAssembly.Module]"}t.isWebAssemblyCompiledModule=isWebAssemblyCompiledModule;function isNumberObject(e){return checkBoxedPrimitive(e,s)}t.isNumberObject=isNumberObject;function isStringObject(e){return checkBoxedPrimitive(e,l)}t.isStringObject=isStringObject;function isBooleanObject(e){return checkBoxedPrimitive(e,p)}t.isBooleanObject=isBooleanObject;function isBigIntObject(e){return c&&checkBoxedPrimitive(e,y)}t.isBigIntObject=isBigIntObject;function isSymbolObject(e){return u&&checkBoxedPrimitive(e,g)}t.isSymbolObject=isSymbolObject;function isBoxedPrimitive(e){return isNumberObject(e)||isStringObject(e)||isBooleanObject(e)||isBigIntObject(e)||isSymbolObject(e)}t.isBoxedPrimitive=isBoxedPrimitive;function isAnyArrayBuffer(e){return typeof Uint8Array!=="undefined"&&(isArrayBuffer(e)||isSharedArrayBuffer(e))}t.isAnyArrayBuffer=isAnyArrayBuffer;["isProxy","isExternal","isModuleNamespaceObject"].forEach((function(e){Object.defineProperty(t,e,{enumerable:false,value:function(){throw new Error(e+" is not supported in userland")}})}))},467:function(e,t,r){var n=Object.getOwnPropertyDescriptors||function getOwnPropertyDescriptors(e){var t=Object.keys(e);var r={};for(var n=0;n<t.length;n++){r[t[n]]=Object.getOwnPropertyDescriptor(e,t[n])}return r};var o=/%[sdj%]/g;t.format=function(e){if(!isString(e)){var t=[];for(var r=0;r<arguments.length;r++){t.push(inspect(arguments[r]))}return t.join(" ")}var r=1;var n=arguments;var i=n.length;var a=String(e).replace(o,(function(e){if(e==="%%")return"%";if(r>=i)return e;switch(e){case"%s":return String(n[r++]);case"%d":return Number(n[r++]);case"%j":try{return JSON.stringify(n[r++])}catch(e){return"[Circular]"}default:return e}}));for(var c=n[r];r<i;c=n[++r]){if(isNull(c)||!isObject(c)){a+=" "+c}else{a+=" "+inspect(c)}}return a};t.deprecate=function(e,r){if(typeof process!=="undefined"&&process.noDeprecation===true){return e}if(typeof process==="undefined"){return function(){return t.deprecate(e,r).apply(this,arguments)}}var n=false;function deprecated(){if(!n){if(process.throwDeprecation){throw new Error(r)}else if(process.traceDeprecation){console.trace(r)}else{console.error(r)}n=true}return e.apply(this,arguments)}return deprecated};var i={};var a=/^$/;if(process.env.NODE_DEBUG){var c=process.env.NODE_DEBUG;c=c.replace(/[|\\{}()[\]^$+?.]/g,"\\$&").replace(/\*/g,".*").replace(/,/g,"$|^").toUpperCase();a=new RegExp("^"+c+"$","i")}t.debuglog=function(e){e=e.toUpperCase();if(!i[e]){if(a.test(e)){var r=process.pid;i[e]=function(){var n=t.format.apply(t,arguments);console.error("%s %d: %s",e,r,n)}}else{i[e]=function(){}}}return i[e]};function inspect(e,r){var n={seen:[],stylize:stylizeNoColor};if(arguments.length>=3)n.depth=arguments[2];if(arguments.length>=4)n.colors=arguments[3];if(isBoolean(r)){n.showHidden=r}else if(r){t._extend(n,r)}if(isUndefined(n.showHidden))n.showHidden=false;if(isUndefined(n.depth))n.depth=2;if(isUndefined(n.colors))n.colors=false;if(isUndefined(n.customInspect))n.customInspect=true;if(n.colors)n.stylize=stylizeWithColor;return formatValue(n,e,n.depth)}t.inspect=inspect;inspect.colors={bold:[1,22],italic:[3,23],underline:[4,24],inverse:[7,27],white:[37,39],grey:[90,39],black:[30,39],blue:[34,39],cyan:[36,39],green:[32,39],magenta:[35,39],red:[31,39],yellow:[33,39]};inspect.styles={special:"cyan",number:"yellow",boolean:"yellow",undefined:"grey",null:"bold",string:"green",date:"magenta",regexp:"red"};function stylizeWithColor(e,t){var r=inspect.styles[t];if(r){return"["+inspect.colors[r][0]+"m"+e+"["+inspect.colors[r][1]+"m"}else{return e}}function stylizeNoColor(e,t){return e}function arrayToHash(e){var t={};e.forEach((function(e,r){t[e]=true}));return t}function formatValue(e,r,n){if(e.customInspect&&r&&isFunction(r.inspect)&&r.inspect!==t.inspect&&!(r.constructor&&r.constructor.prototype===r)){var o=r.inspect(n,e);if(!isString(o)){o=formatValue(e,o,n)}return o}var i=formatPrimitive(e,r);if(i){return i}var a=Object.keys(r);var c=arrayToHash(a);if(e.showHidden){a=Object.getOwnPropertyNames(r)}if(isError(r)&&(a.indexOf("message")>=0||a.indexOf("description")>=0)){return formatError(r)}if(a.length===0){if(isFunction(r)){var u=r.name?": "+r.name:"";return e.stylize("[Function"+u+"]","special")}if(isRegExp(r)){return e.stylize(RegExp.prototype.toString.call(r),"regexp")}if(isDate(r)){return e.stylize(Date.prototype.toString.call(r),"date")}if(isError(r)){return formatError(r)}}var f="",s=false,l=["{","}"];if(isArray(r)){s=true;l=["[","]"]}if(isFunction(r)){var p=r.name?": "+r.name:"";f=" [Function"+p+"]"}if(isRegExp(r)){f=" "+RegExp.prototype.toString.call(r)}if(isDate(r)){f=" "+Date.prototype.toUTCString.call(r)}if(isError(r)){f=" "+formatError(r)}if(a.length===0&&(!s||r.length==0)){return l[0]+f+l[1]}if(n<0){if(isRegExp(r)){return e.stylize(RegExp.prototype.toString.call(r),"regexp")}else{return e.stylize("[Object]","special")}}e.seen.push(r);var y;if(s){y=formatArray(e,r,n,c,a)}else{y=a.map((function(t){return formatProperty(e,r,n,c,t,s)}))}e.seen.pop();return reduceToSingleString(y,f,l)}function formatPrimitive(e,t){if(isUndefined(t))return e.stylize("undefined","undefined");if(isString(t)){var r="'"+JSON.stringify(t).replace(/^"|"$/g,"").replace(/'/g,"\\'").replace(/\\"/g,'"')+"'";return e.stylize(r,"string")}if(isNumber(t))return e.stylize(""+t,"number");if(isBoolean(t))return e.stylize(""+t,"boolean");if(isNull(t))return e.stylize("null","null")}function formatError(e){return"["+Error.prototype.toString.call(e)+"]"}function formatArray(e,t,r,n,o){var i=[];for(var a=0,c=t.length;a<c;++a){if(hasOwnProperty(t,String(a))){i.push(formatProperty(e,t,r,n,String(a),true))}else{i.push("")}}o.forEach((function(o){if(!o.match(/^\d+$/)){i.push(formatProperty(e,t,r,n,o,true))}}));return i}function formatProperty(e,t,r,n,o,i){var a,c,u;u=Object.getOwnPropertyDescriptor(t,o)||{value:t[o]};if(u.get){if(u.set){c=e.stylize("[Getter/Setter]","special")}else{c=e.stylize("[Getter]","special")}}else{if(u.set){c=e.stylize("[Setter]","special")}}if(!hasOwnProperty(n,o)){a="["+o+"]"}if(!c){if(e.seen.indexOf(u.value)<0){if(isNull(r)){c=formatValue(e,u.value,null)}else{c=formatValue(e,u.value,r-1)}if(c.indexOf("\n")>-1){if(i){c=c.split("\n").map((function(e){return"  "+e})).join("\n").substr(2)}else{c="\n"+c.split("\n").map((function(e){return"   "+e})).join("\n")}}}else{c=e.stylize("[Circular]","special")}}if(isUndefined(a)){if(i&&o.match(/^\d+$/)){return c}a=JSON.stringify(""+o);if(a.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)){a=a.substr(1,a.length-2);a=e.stylize(a,"name")}else{a=a.replace(/'/g,"\\'").replace(/\\"/g,'"').replace(/(^"|"$)/g,"'");a=e.stylize(a,"string")}}return a+": "+c}function reduceToSingleString(e,t,r){var n=0;var o=e.reduce((function(e,t){n++;if(t.indexOf("\n")>=0)n++;return e+t.replace(/\u001b\[\d\d?m/g,"").length+1}),0);if(o>60){return r[0]+(t===""?"":t+"\n ")+" "+e.join(",\n  ")+" "+r[1]}return r[0]+t+" "+e.join(", ")+" "+r[1]}t.types=r(989);function isArray(e){return Array.isArray(e)}t.isArray=isArray;function isBoolean(e){return typeof e==="boolean"}t.isBoolean=isBoolean;function isNull(e){return e===null}t.isNull=isNull;function isNullOrUndefined(e){return e==null}t.isNullOrUndefined=isNullOrUndefined;function isNumber(e){return typeof e==="number"}t.isNumber=isNumber;function isString(e){return typeof e==="string"}t.isString=isString;function isSymbol(e){return typeof e==="symbol"}t.isSymbol=isSymbol;function isUndefined(e){return e===void 0}t.isUndefined=isUndefined;function isRegExp(e){return isObject(e)&&objectToString(e)==="[object RegExp]"}t.isRegExp=isRegExp;t.types.isRegExp=isRegExp;function isObject(e){return typeof e==="object"&&e!==null}t.isObject=isObject;function isDate(e){return isObject(e)&&objectToString(e)==="[object Date]"}t.isDate=isDate;t.types.isDate=isDate;function isError(e){return isObject(e)&&(objectToString(e)==="[object Error]"||e instanceof Error)}t.isError=isError;t.types.isNativeError=isError;function isFunction(e){return typeof e==="function"}t.isFunction=isFunction;function isPrimitive(e){return e===null||typeof e==="boolean"||typeof e==="number"||typeof e==="string"||typeof e==="symbol"||typeof e==="undefined"}t.isPrimitive=isPrimitive;t.isBuffer=r(913);function objectToString(e){return Object.prototype.toString.call(e)}function pad(e){return e<10?"0"+e.toString(10):e.toString(10)}var u=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];function timestamp(){var e=new Date;var t=[pad(e.getHours()),pad(e.getMinutes()),pad(e.getSeconds())].join(":");return[e.getDate(),u[e.getMonth()],t].join(" ")}t.log=function(){console.log("%s - %s",timestamp(),t.format.apply(t,arguments))};t.inherits=r(140);t._extend=function(e,t){if(!t||!isObject(t))return e;var r=Object.keys(t);var n=r.length;while(n--){e[r[n]]=t[r[n]]}return e};function hasOwnProperty(e,t){return Object.prototype.hasOwnProperty.call(e,t)}var f=typeof Symbol!=="undefined"?Symbol("util.promisify.custom"):undefined;t.promisify=function promisify(e){if(typeof e!=="function")throw new TypeError('The "original" argument must be of type Function');if(f&&e[f]){var t=e[f];if(typeof t!=="function"){throw new TypeError('The "util.promisify.custom" argument must be of type Function')}Object.defineProperty(t,f,{value:t,enumerable:false,writable:false,configurable:true});return t}function t(){var t,r;var n=new Promise((function(e,n){t=e;r=n}));var o=[];for(var i=0;i<arguments.length;i++){o.push(arguments[i])}o.push((function(e,n){if(e){r(e)}else{t(n)}}));try{e.apply(this,o)}catch(e){r(e)}return n}Object.setPrototypeOf(t,Object.getPrototypeOf(e));if(f)Object.defineProperty(t,f,{value:t,enumerable:false,writable:false,configurable:true});return Object.defineProperties(t,n(e))};t.promisify.custom=f;function callbackifyOnRejected(e,t){if(!e){var r=new Error("Promise was rejected with a falsy value");r.reason=e;e=r}return t(e)}function callbackify(e){if(typeof e!=="function"){throw new TypeError('The "original" argument must be of type Function')}function callbackified(){var t=[];for(var r=0;r<arguments.length;r++){t.push(arguments[r])}var n=t.pop();if(typeof n!=="function"){throw new TypeError("The last argument must be of type Function")}var o=this;var cb=function(){return n.apply(o,arguments)};e.apply(this,t).then((function(e){process.nextTick(cb.bind(null,null,e))}),(function(e){process.nextTick(callbackifyOnRejected.bind(null,e,cb))}))}Object.setPrototypeOf(callbackified,Object.getPrototypeOf(e));Object.defineProperties(callbackified,n(e));return callbackified}t.callbackify=callbackify},728:function(e,t,r){"use strict";var n=r(981);var o=r(382);var i=r(171);var a=i("Object.prototype.toString");var c=r(567)();var u=c&&typeof Symbol.toStringTag==="symbol";var f=o();var s=i("String.prototype.slice");var l={};var p=r(30);var y=Object.getPrototypeOf;if(u&&p&&y){n(f,(function(e){if(typeof __webpack_require__.g[e]==="function"){var t=new __webpack_require__.g[e];if(!(Symbol.toStringTag in t)){throw new EvalError("this engine has support for Symbol.toStringTag, but "+e+" does not have the property! Please report this.")}var r=y(t);var n=p(r,Symbol.toStringTag);if(!n){var o=y(r);n=p(o,Symbol.toStringTag)}l[e]=n.get}}))}var g=function tryAllTypedArrays(e){var t=false;n(l,(function(r,n){if(!t){try{var o=r.call(e);if(o===n){t=o}}catch(e){}}}));return t};var v=r(387);e.exports=function whichTypedArray(e){if(!v(e)){return false}if(!u){return s(a(e),8,-1)}return g(e)}},382:function(e,t,r){"use strict";var n=r(997);e.exports=function availableTypedArrays(){return n(["BigInt64Array","BigUint64Array","Float32Array","Float64Array","Int16Array","Int32Array","Int8Array","Uint16Array","Uint32Array","Uint8Array","Uint8ClampedArray"],(function(e){return typeof __webpack_require__.g[e]==="function"}))}},30:function(e,t,r){"use strict";var n=r(627);var o=n("%Object.getOwnPropertyDescriptor%",true);if(o){try{o([],"length")}catch(e){o=null}}e.exports=o}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var o=t[r]={exports:{}};var i=true;try{e[r](o,o.exports,__nccwpck_require__);i=false}finally{if(i)delete t[r]}return o.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(468);module.exports=r})();

/***/ }),

/***/ 47715:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
/* provided dependency */ var process = __webpack_require__(83454);
(function(){"use strict";var e={116:function(e,t,i){var a=i(491);var r=i(838);var n=i(362);var s=i(528);var l=i(400);for(var f in l){t[f]=l[f]}t.NONE=0;t.DEFLATE=1;t.INFLATE=2;t.GZIP=3;t.GUNZIP=4;t.DEFLATERAW=5;t.INFLATERAW=6;t.UNZIP=7;var o=31;var h=139;function Zlib(e){if(typeof e!=="number"||e<t.DEFLATE||e>t.UNZIP){throw new TypeError("Bad argument")}this.dictionary=null;this.err=0;this.flush=0;this.init_done=false;this.level=0;this.memLevel=0;this.mode=e;this.strategy=0;this.windowBits=0;this.write_in_progress=false;this.pending_close=false;this.gzip_id_bytes_read=0}Zlib.prototype.close=function(){if(this.write_in_progress){this.pending_close=true;return}this.pending_close=false;a(this.init_done,"close before init");a(this.mode<=t.UNZIP);if(this.mode===t.DEFLATE||this.mode===t.GZIP||this.mode===t.DEFLATERAW){n.deflateEnd(this.strm)}else if(this.mode===t.INFLATE||this.mode===t.GUNZIP||this.mode===t.INFLATERAW||this.mode===t.UNZIP){s.inflateEnd(this.strm)}this.mode=t.NONE;this.dictionary=null};Zlib.prototype.write=function(e,t,i,a,r,n,s){return this._write(true,e,t,i,a,r,n,s)};Zlib.prototype.writeSync=function(e,t,i,a,r,n,s){return this._write(false,e,t,i,a,r,n,s)};Zlib.prototype._write=function(e,i,r,n,s,l,f,o){a.equal(arguments.length,8);a(this.init_done,"write before init");a(this.mode!==t.NONE,"already finalized");a.equal(false,this.write_in_progress,"write already in progress");a.equal(false,this.pending_close,"close is pending");this.write_in_progress=true;a.equal(false,i===undefined,"must provide flush value");this.write_in_progress=true;if(i!==t.Z_NO_FLUSH&&i!==t.Z_PARTIAL_FLUSH&&i!==t.Z_SYNC_FLUSH&&i!==t.Z_FULL_FLUSH&&i!==t.Z_FINISH&&i!==t.Z_BLOCK){throw new Error("Invalid flush value")}if(r==null){r=Buffer.alloc(0);s=0;n=0}this.strm.avail_in=s;this.strm.input=r;this.strm.next_in=n;this.strm.avail_out=o;this.strm.output=l;this.strm.next_out=f;this.flush=i;if(!e){this._process();if(this._checkError()){return this._afterSync()}return}var h=this;process.nextTick((function(){h._process();h._after()}));return this};Zlib.prototype._afterSync=function(){var e=this.strm.avail_out;var t=this.strm.avail_in;this.write_in_progress=false;return[t,e]};Zlib.prototype._process=function(){var e=null;switch(this.mode){case t.DEFLATE:case t.GZIP:case t.DEFLATERAW:this.err=n.deflate(this.strm,this.flush);break;case t.UNZIP:if(this.strm.avail_in>0){e=this.strm.next_in}switch(this.gzip_id_bytes_read){case 0:if(e===null){break}if(this.strm.input[e]===o){this.gzip_id_bytes_read=1;e++;if(this.strm.avail_in===1){break}}else{this.mode=t.INFLATE;break}case 1:if(e===null){break}if(this.strm.input[e]===h){this.gzip_id_bytes_read=2;this.mode=t.GUNZIP}else{this.mode=t.INFLATE}break;default:throw new Error("invalid number of gzip magic number bytes read")}case t.INFLATE:case t.GUNZIP:case t.INFLATERAW:this.err=s.inflate(this.strm,this.flush);if(this.err===t.Z_NEED_DICT&&this.dictionary){this.err=s.inflateSetDictionary(this.strm,this.dictionary);if(this.err===t.Z_OK){this.err=s.inflate(this.strm,this.flush)}else if(this.err===t.Z_DATA_ERROR){this.err=t.Z_NEED_DICT}}while(this.strm.avail_in>0&&this.mode===t.GUNZIP&&this.err===t.Z_STREAM_END&&this.strm.next_in[0]!==0){this.reset();this.err=s.inflate(this.strm,this.flush)}break;default:throw new Error("Unknown mode "+this.mode)}};Zlib.prototype._checkError=function(){switch(this.err){case t.Z_OK:case t.Z_BUF_ERROR:if(this.strm.avail_out!==0&&this.flush===t.Z_FINISH){this._error("unexpected end of file");return false}break;case t.Z_STREAM_END:break;case t.Z_NEED_DICT:if(this.dictionary==null){this._error("Missing dictionary")}else{this._error("Bad dictionary")}return false;default:this._error("Zlib error");return false}return true};Zlib.prototype._after=function(){if(!this._checkError()){return}var e=this.strm.avail_out;var t=this.strm.avail_in;this.write_in_progress=false;this.callback(t,e);if(this.pending_close){this.close()}};Zlib.prototype._error=function(e){if(this.strm.msg){e=this.strm.msg}this.onerror(e,this.err);this.write_in_progress=false;if(this.pending_close){this.close()}};Zlib.prototype.init=function(e,i,r,n,s){a(arguments.length===4||arguments.length===5,"init(windowBits, level, memLevel, strategy, [dictionary])");a(e>=8&&e<=15,"invalid windowBits");a(i>=-1&&i<=9,"invalid compression level");a(r>=1&&r<=9,"invalid memlevel");a(n===t.Z_FILTERED||n===t.Z_HUFFMAN_ONLY||n===t.Z_RLE||n===t.Z_FIXED||n===t.Z_DEFAULT_STRATEGY,"invalid strategy");this._init(i,e,r,n,s);this._setDictionary()};Zlib.prototype.params=function(){throw new Error("deflateParams Not supported")};Zlib.prototype.reset=function(){this._reset();this._setDictionary()};Zlib.prototype._init=function(e,i,a,l,f){this.level=e;this.windowBits=i;this.memLevel=a;this.strategy=l;this.flush=t.Z_NO_FLUSH;this.err=t.Z_OK;if(this.mode===t.GZIP||this.mode===t.GUNZIP){this.windowBits+=16}if(this.mode===t.UNZIP){this.windowBits+=32}if(this.mode===t.DEFLATERAW||this.mode===t.INFLATERAW){this.windowBits=-1*this.windowBits}this.strm=new r;switch(this.mode){case t.DEFLATE:case t.GZIP:case t.DEFLATERAW:this.err=n.deflateInit2(this.strm,this.level,t.Z_DEFLATED,this.windowBits,this.memLevel,this.strategy);break;case t.INFLATE:case t.GUNZIP:case t.INFLATERAW:case t.UNZIP:this.err=s.inflateInit2(this.strm,this.windowBits);break;default:throw new Error("Unknown mode "+this.mode)}if(this.err!==t.Z_OK){this._error("Init error")}this.dictionary=f;this.write_in_progress=false;this.init_done=true};Zlib.prototype._setDictionary=function(){if(this.dictionary==null){return}this.err=t.Z_OK;switch(this.mode){case t.DEFLATE:case t.DEFLATERAW:this.err=n.deflateSetDictionary(this.strm,this.dictionary);break;default:break}if(this.err!==t.Z_OK){this._error("Failed to set dictionary")}};Zlib.prototype._reset=function(){this.err=t.Z_OK;switch(this.mode){case t.DEFLATE:case t.DEFLATERAW:case t.GZIP:this.err=n.deflateReset(this.strm);break;case t.INFLATE:case t.INFLATERAW:case t.GUNZIP:this.err=s.inflateReset(this.strm);break;default:break}if(this.err!==t.Z_OK){this._error("Failed to reset stream")}};t.Zlib=Zlib},979:function(e,t,i){var a=i(300).Buffer;var r=i(781).Transform;var n=i(116);var s=i(837);var l=i(491).ok;var f=i(300).kMaxLength;var o="Cannot create final Buffer. It would be larger "+"than 0x"+f.toString(16)+" bytes";n.Z_MIN_WINDOWBITS=8;n.Z_MAX_WINDOWBITS=15;n.Z_DEFAULT_WINDOWBITS=15;n.Z_MIN_CHUNK=64;n.Z_MAX_CHUNK=Infinity;n.Z_DEFAULT_CHUNK=16*1024;n.Z_MIN_MEMLEVEL=1;n.Z_MAX_MEMLEVEL=9;n.Z_DEFAULT_MEMLEVEL=8;n.Z_MIN_LEVEL=-1;n.Z_MAX_LEVEL=9;n.Z_DEFAULT_LEVEL=n.Z_DEFAULT_COMPRESSION;var h=Object.keys(n);for(var _=0;_<h.length;_++){var d=h[_];if(d.match(/^Z/)){Object.defineProperty(t,d,{enumerable:true,value:n[d],writable:false})}}var u={Z_OK:n.Z_OK,Z_STREAM_END:n.Z_STREAM_END,Z_NEED_DICT:n.Z_NEED_DICT,Z_ERRNO:n.Z_ERRNO,Z_STREAM_ERROR:n.Z_STREAM_ERROR,Z_DATA_ERROR:n.Z_DATA_ERROR,Z_MEM_ERROR:n.Z_MEM_ERROR,Z_BUF_ERROR:n.Z_BUF_ERROR,Z_VERSION_ERROR:n.Z_VERSION_ERROR};var c=Object.keys(u);for(var v=0;v<c.length;v++){var b=c[v];u[u[b]]=b}Object.defineProperty(t,"codes",{enumerable:true,value:Object.freeze(u),writable:false});t.Deflate=Deflate;t.Inflate=Inflate;t.Gzip=Gzip;t.Gunzip=Gunzip;t.DeflateRaw=DeflateRaw;t.InflateRaw=InflateRaw;t.Unzip=Unzip;t.createDeflate=function(e){return new Deflate(e)};t.createInflate=function(e){return new Inflate(e)};t.createDeflateRaw=function(e){return new DeflateRaw(e)};t.createInflateRaw=function(e){return new InflateRaw(e)};t.createGzip=function(e){return new Gzip(e)};t.createGunzip=function(e){return new Gunzip(e)};t.createUnzip=function(e){return new Unzip(e)};t.deflate=function(e,t,i){if(typeof t==="function"){i=t;t={}}return zlibBuffer(new Deflate(t),e,i)};t.deflateSync=function(e,t){return zlibBufferSync(new Deflate(t),e)};t.gzip=function(e,t,i){if(typeof t==="function"){i=t;t={}}return zlibBuffer(new Gzip(t),e,i)};t.gzipSync=function(e,t){return zlibBufferSync(new Gzip(t),e)};t.deflateRaw=function(e,t,i){if(typeof t==="function"){i=t;t={}}return zlibBuffer(new DeflateRaw(t),e,i)};t.deflateRawSync=function(e,t){return zlibBufferSync(new DeflateRaw(t),e)};t.unzip=function(e,t,i){if(typeof t==="function"){i=t;t={}}return zlibBuffer(new Unzip(t),e,i)};t.unzipSync=function(e,t){return zlibBufferSync(new Unzip(t),e)};t.inflate=function(e,t,i){if(typeof t==="function"){i=t;t={}}return zlibBuffer(new Inflate(t),e,i)};t.inflateSync=function(e,t){return zlibBufferSync(new Inflate(t),e)};t.gunzip=function(e,t,i){if(typeof t==="function"){i=t;t={}}return zlibBuffer(new Gunzip(t),e,i)};t.gunzipSync=function(e,t){return zlibBufferSync(new Gunzip(t),e)};t.inflateRaw=function(e,t,i){if(typeof t==="function"){i=t;t={}}return zlibBuffer(new InflateRaw(t),e,i)};t.inflateRawSync=function(e,t){return zlibBufferSync(new InflateRaw(t),e)};function zlibBuffer(e,t,i){var r=[];var n=0;e.on("error",onError);e.on("end",onEnd);e.end(t);flow();function flow(){var t;while(null!==(t=e.read())){r.push(t);n+=t.length}e.once("readable",flow)}function onError(t){e.removeListener("end",onEnd);e.removeListener("readable",flow);i(t)}function onEnd(){var t;var s=null;if(n>=f){s=new RangeError(o)}else{t=a.concat(r,n)}r=[];e.close();i(s,t)}}function zlibBufferSync(e,t){if(typeof t==="string")t=a.from(t);if(!a.isBuffer(t))throw new TypeError("Not a string or buffer");var i=e._finishFlushFlag;return e._processChunk(t,i)}function Deflate(e){if(!(this instanceof Deflate))return new Deflate(e);Zlib.call(this,e,n.DEFLATE)}function Inflate(e){if(!(this instanceof Inflate))return new Inflate(e);Zlib.call(this,e,n.INFLATE)}function Gzip(e){if(!(this instanceof Gzip))return new Gzip(e);Zlib.call(this,e,n.GZIP)}function Gunzip(e){if(!(this instanceof Gunzip))return new Gunzip(e);Zlib.call(this,e,n.GUNZIP)}function DeflateRaw(e){if(!(this instanceof DeflateRaw))return new DeflateRaw(e);Zlib.call(this,e,n.DEFLATERAW)}function InflateRaw(e){if(!(this instanceof InflateRaw))return new InflateRaw(e);Zlib.call(this,e,n.INFLATERAW)}function Unzip(e){if(!(this instanceof Unzip))return new Unzip(e);Zlib.call(this,e,n.UNZIP)}function isValidFlushFlag(e){return e===n.Z_NO_FLUSH||e===n.Z_PARTIAL_FLUSH||e===n.Z_SYNC_FLUSH||e===n.Z_FULL_FLUSH||e===n.Z_FINISH||e===n.Z_BLOCK}function Zlib(e,i){var s=this;this._opts=e=e||{};this._chunkSize=e.chunkSize||t.Z_DEFAULT_CHUNK;r.call(this,e);if(e.flush&&!isValidFlushFlag(e.flush)){throw new Error("Invalid flush flag: "+e.flush)}if(e.finishFlush&&!isValidFlushFlag(e.finishFlush)){throw new Error("Invalid flush flag: "+e.finishFlush)}this._flushFlag=e.flush||n.Z_NO_FLUSH;this._finishFlushFlag=typeof e.finishFlush!=="undefined"?e.finishFlush:n.Z_FINISH;if(e.chunkSize){if(e.chunkSize<t.Z_MIN_CHUNK||e.chunkSize>t.Z_MAX_CHUNK){throw new Error("Invalid chunk size: "+e.chunkSize)}}if(e.windowBits){if(e.windowBits<t.Z_MIN_WINDOWBITS||e.windowBits>t.Z_MAX_WINDOWBITS){throw new Error("Invalid windowBits: "+e.windowBits)}}if(e.level){if(e.level<t.Z_MIN_LEVEL||e.level>t.Z_MAX_LEVEL){throw new Error("Invalid compression level: "+e.level)}}if(e.memLevel){if(e.memLevel<t.Z_MIN_MEMLEVEL||e.memLevel>t.Z_MAX_MEMLEVEL){throw new Error("Invalid memLevel: "+e.memLevel)}}if(e.strategy){if(e.strategy!=t.Z_FILTERED&&e.strategy!=t.Z_HUFFMAN_ONLY&&e.strategy!=t.Z_RLE&&e.strategy!=t.Z_FIXED&&e.strategy!=t.Z_DEFAULT_STRATEGY){throw new Error("Invalid strategy: "+e.strategy)}}if(e.dictionary){if(!a.isBuffer(e.dictionary)){throw new Error("Invalid dictionary: it should be a Buffer instance")}}this._handle=new n.Zlib(i);var l=this;this._hadError=false;this._handle.onerror=function(e,i){_close(l);l._hadError=true;var a=new Error(e);a.errno=i;a.code=t.codes[i];l.emit("error",a)};var f=t.Z_DEFAULT_COMPRESSION;if(typeof e.level==="number")f=e.level;var o=t.Z_DEFAULT_STRATEGY;if(typeof e.strategy==="number")o=e.strategy;this._handle.init(e.windowBits||t.Z_DEFAULT_WINDOWBITS,f,e.memLevel||t.Z_DEFAULT_MEMLEVEL,o,e.dictionary);this._buffer=a.allocUnsafe(this._chunkSize);this._offset=0;this._level=f;this._strategy=o;this.once("end",this.close);Object.defineProperty(this,"_closed",{get:function(){return!s._handle},configurable:true,enumerable:true})}s.inherits(Zlib,r);Zlib.prototype.params=function(e,i,a){if(e<t.Z_MIN_LEVEL||e>t.Z_MAX_LEVEL){throw new RangeError("Invalid compression level: "+e)}if(i!=t.Z_FILTERED&&i!=t.Z_HUFFMAN_ONLY&&i!=t.Z_RLE&&i!=t.Z_FIXED&&i!=t.Z_DEFAULT_STRATEGY){throw new TypeError("Invalid strategy: "+i)}if(this._level!==e||this._strategy!==i){var r=this;this.flush(n.Z_SYNC_FLUSH,(function(){l(r._handle,"zlib binding closed");r._handle.params(e,i);if(!r._hadError){r._level=e;r._strategy=i;if(a)a()}}))}else{process.nextTick(a)}};Zlib.prototype.reset=function(){l(this._handle,"zlib binding closed");return this._handle.reset()};Zlib.prototype._flush=function(e){this._transform(a.alloc(0),"",e)};Zlib.prototype.flush=function(e,t){var i=this;var r=this._writableState;if(typeof e==="function"||e===undefined&&!t){t=e;e=n.Z_FULL_FLUSH}if(r.ended){if(t)process.nextTick(t)}else if(r.ending){if(t)this.once("end",t)}else if(r.needDrain){if(t){this.once("drain",(function(){return i.flush(e,t)}))}}else{this._flushFlag=e;this.write(a.alloc(0),"",t)}};Zlib.prototype.close=function(e){_close(this,e);process.nextTick(emitCloseNT,this)};function _close(e,t){if(t)process.nextTick(t);if(!e._handle)return;e._handle.close();e._handle=null}function emitCloseNT(e){e.emit("close")}Zlib.prototype._transform=function(e,t,i){var r;var s=this._writableState;var l=s.ending||s.ended;var f=l&&(!e||s.length===e.length);if(e!==null&&!a.isBuffer(e))return i(new Error("invalid input"));if(!this._handle)return i(new Error("zlib binding closed"));if(f)r=this._finishFlushFlag;else{r=this._flushFlag;if(e.length>=s.length){this._flushFlag=this._opts.flush||n.Z_NO_FLUSH}}this._processChunk(e,r,i)};Zlib.prototype._processChunk=function(e,t,i){var r=e&&e.length;var n=this._chunkSize-this._offset;var s=0;var h=this;var _=typeof i==="function";if(!_){var d=[];var u=0;var c;this.on("error",(function(e){c=e}));l(this._handle,"zlib binding closed");do{var v=this._handle.writeSync(t,e,s,r,this._buffer,this._offset,n)}while(!this._hadError&&callback(v[0],v[1]));if(this._hadError){throw c}if(u>=f){_close(this);throw new RangeError(o)}var b=a.concat(d,u);_close(this);return b}l(this._handle,"zlib binding closed");var w=this._handle.write(t,e,s,r,this._buffer,this._offset,n);w.buffer=e;w.callback=callback;function callback(f,o){if(this){this.buffer=null;this.callback=null}if(h._hadError)return;var c=n-o;l(c>=0,"have should not go down");if(c>0){var v=h._buffer.slice(h._offset,h._offset+c);h._offset+=c;if(_){h.push(v)}else{d.push(v);u+=v.length}}if(o===0||h._offset>=h._chunkSize){n=h._chunkSize;h._offset=0;h._buffer=a.allocUnsafe(h._chunkSize)}if(o===0){s+=r-f;r=f;if(!_)return true;var b=h._handle.write(t,e,s,r,h._buffer,h._offset,h._chunkSize);b.callback=callback;b.buffer=e;return}if(!_)return false;i()}};s.inherits(Deflate,Zlib);s.inherits(Inflate,Zlib);s.inherits(Gzip,Zlib);s.inherits(Gunzip,Zlib);s.inherits(DeflateRaw,Zlib);s.inherits(InflateRaw,Zlib);s.inherits(Unzip,Zlib)},859:function(e,t){var i=typeof Uint8Array!=="undefined"&&typeof Uint16Array!=="undefined"&&typeof Int32Array!=="undefined";function _has(e,t){return Object.prototype.hasOwnProperty.call(e,t)}t.assign=function(e){var t=Array.prototype.slice.call(arguments,1);while(t.length){var i=t.shift();if(!i){continue}if(typeof i!=="object"){throw new TypeError(i+"must be non-object")}for(var a in i){if(_has(i,a)){e[a]=i[a]}}}return e};t.shrinkBuf=function(e,t){if(e.length===t){return e}if(e.subarray){return e.subarray(0,t)}e.length=t;return e};var a={arraySet:function(e,t,i,a,r){if(t.subarray&&e.subarray){e.set(t.subarray(i,i+a),r);return}for(var n=0;n<a;n++){e[r+n]=t[i+n]}},flattenChunks:function(e){var t,i,a,r,n,s;a=0;for(t=0,i=e.length;t<i;t++){a+=e[t].length}s=new Uint8Array(a);r=0;for(t=0,i=e.length;t<i;t++){n=e[t];s.set(n,r);r+=n.length}return s}};var r={arraySet:function(e,t,i,a,r){for(var n=0;n<a;n++){e[r+n]=t[i+n]}},flattenChunks:function(e){return[].concat.apply([],e)}};t.setTyped=function(e){if(e){t.Buf8=Uint8Array;t.Buf16=Uint16Array;t.Buf32=Int32Array;t.assign(t,a)}else{t.Buf8=Array;t.Buf16=Array;t.Buf32=Array;t.assign(t,r)}};t.setTyped(i)},417:function(e){function adler32(e,t,i,a){var r=e&65535|0,n=e>>>16&65535|0,s=0;while(i!==0){s=i>2e3?2e3:i;i-=s;do{r=r+t[a++]|0;n=n+r|0}while(--s);r%=65521;n%=65521}return r|n<<16|0}e.exports=adler32},400:function(e){e.exports={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8}},625:function(e){function makeTable(){var e,t=[];for(var i=0;i<256;i++){e=i;for(var a=0;a<8;a++){e=e&1?3988292384^e>>>1:e>>>1}t[i]=e}return t}var t=makeTable();function crc32(e,i,a,r){var n=t,s=r+a;e^=-1;for(var l=r;l<s;l++){e=e>>>8^n[(e^i[l])&255]}return e^-1}e.exports=crc32},362:function(e,t,i){var a=i(859);var r=i(40);var n=i(417);var s=i(625);var l=i(277);var f=0;var o=1;var h=3;var _=4;var d=5;var u=0;var c=1;var v=-2;var b=-3;var w=-5;var p=-1;var g=1;var m=2;var k=3;var y=4;var E=0;var z=2;var Z=8;var x=9;var I=15;var R=8;var S=29;var L=256;var A=L+1+S;var T=30;var F=19;var N=2*A+1;var D=15;var B=3;var U=258;var O=U+B+1;var M=32;var C=42;var G=69;var H=73;var P=91;var K=103;var W=113;var V=666;var q=1;var X=2;var Y=3;var j=4;var J=3;function err(e,t){e.msg=l[t];return t}function rank(e){return(e<<1)-(e>4?9:0)}function zero(e){var t=e.length;while(--t>=0){e[t]=0}}function flush_pending(e){var t=e.state;var i=t.pending;if(i>e.avail_out){i=e.avail_out}if(i===0){return}a.arraySet(e.output,t.pending_buf,t.pending_out,i,e.next_out);e.next_out+=i;t.pending_out+=i;e.total_out+=i;e.avail_out-=i;t.pending-=i;if(t.pending===0){t.pending_out=0}}function flush_block_only(e,t){r._tr_flush_block(e,e.block_start>=0?e.block_start:-1,e.strstart-e.block_start,t);e.block_start=e.strstart;flush_pending(e.strm)}function put_byte(e,t){e.pending_buf[e.pending++]=t}function putShortMSB(e,t){e.pending_buf[e.pending++]=t>>>8&255;e.pending_buf[e.pending++]=t&255}function read_buf(e,t,i,r){var l=e.avail_in;if(l>r){l=r}if(l===0){return 0}e.avail_in-=l;a.arraySet(t,e.input,e.next_in,l,i);if(e.state.wrap===1){e.adler=n(e.adler,t,l,i)}else if(e.state.wrap===2){e.adler=s(e.adler,t,l,i)}e.next_in+=l;e.total_in+=l;return l}function longest_match(e,t){var i=e.max_chain_length;var a=e.strstart;var r;var n;var s=e.prev_length;var l=e.nice_match;var f=e.strstart>e.w_size-O?e.strstart-(e.w_size-O):0;var o=e.window;var h=e.w_mask;var _=e.prev;var d=e.strstart+U;var u=o[a+s-1];var c=o[a+s];if(e.prev_length>=e.good_match){i>>=2}if(l>e.lookahead){l=e.lookahead}do{r=t;if(o[r+s]!==c||o[r+s-1]!==u||o[r]!==o[a]||o[++r]!==o[a+1]){continue}a+=2;r++;do{}while(o[++a]===o[++r]&&o[++a]===o[++r]&&o[++a]===o[++r]&&o[++a]===o[++r]&&o[++a]===o[++r]&&o[++a]===o[++r]&&o[++a]===o[++r]&&o[++a]===o[++r]&&a<d);n=U-(d-a);a=d-U;if(n>s){e.match_start=t;s=n;if(n>=l){break}u=o[a+s-1];c=o[a+s]}}while((t=_[t&h])>f&&--i!==0);if(s<=e.lookahead){return s}return e.lookahead}function fill_window(e){var t=e.w_size;var i,r,n,s,l;do{s=e.window_size-e.lookahead-e.strstart;if(e.strstart>=t+(t-O)){a.arraySet(e.window,e.window,t,t,0);e.match_start-=t;e.strstart-=t;e.block_start-=t;r=e.hash_size;i=r;do{n=e.head[--i];e.head[i]=n>=t?n-t:0}while(--r);r=t;i=r;do{n=e.prev[--i];e.prev[i]=n>=t?n-t:0}while(--r);s+=t}if(e.strm.avail_in===0){break}r=read_buf(e.strm,e.window,e.strstart+e.lookahead,s);e.lookahead+=r;if(e.lookahead+e.insert>=B){l=e.strstart-e.insert;e.ins_h=e.window[l];e.ins_h=(e.ins_h<<e.hash_shift^e.window[l+1])&e.hash_mask;while(e.insert){e.ins_h=(e.ins_h<<e.hash_shift^e.window[l+B-1])&e.hash_mask;e.prev[l&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=l;l++;e.insert--;if(e.lookahead+e.insert<B){break}}}}while(e.lookahead<O&&e.strm.avail_in!==0)}function deflate_stored(e,t){var i=65535;if(i>e.pending_buf_size-5){i=e.pending_buf_size-5}for(;;){if(e.lookahead<=1){fill_window(e);if(e.lookahead===0&&t===f){return q}if(e.lookahead===0){break}}e.strstart+=e.lookahead;e.lookahead=0;var a=e.block_start+i;if(e.strstart===0||e.strstart>=a){e.lookahead=e.strstart-a;e.strstart=a;flush_block_only(e,false);if(e.strm.avail_out===0){return q}}if(e.strstart-e.block_start>=e.w_size-O){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}}e.insert=0;if(t===_){flush_block_only(e,true);if(e.strm.avail_out===0){return Y}return j}if(e.strstart>e.block_start){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}return q}function deflate_fast(e,t){var i;var a;for(;;){if(e.lookahead<O){fill_window(e);if(e.lookahead<O&&t===f){return q}if(e.lookahead===0){break}}i=0;if(e.lookahead>=B){e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+B-1])&e.hash_mask;i=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=e.strstart}if(i!==0&&e.strstart-i<=e.w_size-O){e.match_length=longest_match(e,i)}if(e.match_length>=B){a=r._tr_tally(e,e.strstart-e.match_start,e.match_length-B);e.lookahead-=e.match_length;if(e.match_length<=e.max_lazy_match&&e.lookahead>=B){e.match_length--;do{e.strstart++;e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+B-1])&e.hash_mask;i=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=e.strstart}while(--e.match_length!==0);e.strstart++}else{e.strstart+=e.match_length;e.match_length=0;e.ins_h=e.window[e.strstart];e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+1])&e.hash_mask}}else{a=r._tr_tally(e,0,e.window[e.strstart]);e.lookahead--;e.strstart++}if(a){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}}e.insert=e.strstart<B-1?e.strstart:B-1;if(t===_){flush_block_only(e,true);if(e.strm.avail_out===0){return Y}return j}if(e.last_lit){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}return X}function deflate_slow(e,t){var i;var a;var n;for(;;){if(e.lookahead<O){fill_window(e);if(e.lookahead<O&&t===f){return q}if(e.lookahead===0){break}}i=0;if(e.lookahead>=B){e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+B-1])&e.hash_mask;i=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=e.strstart}e.prev_length=e.match_length;e.prev_match=e.match_start;e.match_length=B-1;if(i!==0&&e.prev_length<e.max_lazy_match&&e.strstart-i<=e.w_size-O){e.match_length=longest_match(e,i);if(e.match_length<=5&&(e.strategy===g||e.match_length===B&&e.strstart-e.match_start>4096)){e.match_length=B-1}}if(e.prev_length>=B&&e.match_length<=e.prev_length){n=e.strstart+e.lookahead-B;a=r._tr_tally(e,e.strstart-1-e.prev_match,e.prev_length-B);e.lookahead-=e.prev_length-1;e.prev_length-=2;do{if(++e.strstart<=n){e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+B-1])&e.hash_mask;i=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=e.strstart}}while(--e.prev_length!==0);e.match_available=0;e.match_length=B-1;e.strstart++;if(a){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}}else if(e.match_available){a=r._tr_tally(e,0,e.window[e.strstart-1]);if(a){flush_block_only(e,false)}e.strstart++;e.lookahead--;if(e.strm.avail_out===0){return q}}else{e.match_available=1;e.strstart++;e.lookahead--}}if(e.match_available){a=r._tr_tally(e,0,e.window[e.strstart-1]);e.match_available=0}e.insert=e.strstart<B-1?e.strstart:B-1;if(t===_){flush_block_only(e,true);if(e.strm.avail_out===0){return Y}return j}if(e.last_lit){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}return X}function deflate_rle(e,t){var i;var a;var n,s;var l=e.window;for(;;){if(e.lookahead<=U){fill_window(e);if(e.lookahead<=U&&t===f){return q}if(e.lookahead===0){break}}e.match_length=0;if(e.lookahead>=B&&e.strstart>0){n=e.strstart-1;a=l[n];if(a===l[++n]&&a===l[++n]&&a===l[++n]){s=e.strstart+U;do{}while(a===l[++n]&&a===l[++n]&&a===l[++n]&&a===l[++n]&&a===l[++n]&&a===l[++n]&&a===l[++n]&&a===l[++n]&&n<s);e.match_length=U-(s-n);if(e.match_length>e.lookahead){e.match_length=e.lookahead}}}if(e.match_length>=B){i=r._tr_tally(e,1,e.match_length-B);e.lookahead-=e.match_length;e.strstart+=e.match_length;e.match_length=0}else{i=r._tr_tally(e,0,e.window[e.strstart]);e.lookahead--;e.strstart++}if(i){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}}e.insert=0;if(t===_){flush_block_only(e,true);if(e.strm.avail_out===0){return Y}return j}if(e.last_lit){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}return X}function deflate_huff(e,t){var i;for(;;){if(e.lookahead===0){fill_window(e);if(e.lookahead===0){if(t===f){return q}break}}e.match_length=0;i=r._tr_tally(e,0,e.window[e.strstart]);e.lookahead--;e.strstart++;if(i){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}}e.insert=0;if(t===_){flush_block_only(e,true);if(e.strm.avail_out===0){return Y}return j}if(e.last_lit){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}return X}function Config(e,t,i,a,r){this.good_length=e;this.max_lazy=t;this.nice_length=i;this.max_chain=a;this.func=r}var Q;Q=[new Config(0,0,0,0,deflate_stored),new Config(4,4,8,4,deflate_fast),new Config(4,5,16,8,deflate_fast),new Config(4,6,32,32,deflate_fast),new Config(4,4,16,16,deflate_slow),new Config(8,16,32,32,deflate_slow),new Config(8,16,128,128,deflate_slow),new Config(8,32,128,256,deflate_slow),new Config(32,128,258,1024,deflate_slow),new Config(32,258,258,4096,deflate_slow)];function lm_init(e){e.window_size=2*e.w_size;zero(e.head);e.max_lazy_match=Q[e.level].max_lazy;e.good_match=Q[e.level].good_length;e.nice_match=Q[e.level].nice_length;e.max_chain_length=Q[e.level].max_chain;e.strstart=0;e.block_start=0;e.lookahead=0;e.insert=0;e.match_length=e.prev_length=B-1;e.match_available=0;e.ins_h=0}function DeflateState(){this.strm=null;this.status=0;this.pending_buf=null;this.pending_buf_size=0;this.pending_out=0;this.pending=0;this.wrap=0;this.gzhead=null;this.gzindex=0;this.method=Z;this.last_flush=-1;this.w_size=0;this.w_bits=0;this.w_mask=0;this.window=null;this.window_size=0;this.prev=null;this.head=null;this.ins_h=0;this.hash_size=0;this.hash_bits=0;this.hash_mask=0;this.hash_shift=0;this.block_start=0;this.match_length=0;this.prev_match=0;this.match_available=0;this.strstart=0;this.match_start=0;this.lookahead=0;this.prev_length=0;this.max_chain_length=0;this.max_lazy_match=0;this.level=0;this.strategy=0;this.good_match=0;this.nice_match=0;this.dyn_ltree=new a.Buf16(N*2);this.dyn_dtree=new a.Buf16((2*T+1)*2);this.bl_tree=new a.Buf16((2*F+1)*2);zero(this.dyn_ltree);zero(this.dyn_dtree);zero(this.bl_tree);this.l_desc=null;this.d_desc=null;this.bl_desc=null;this.bl_count=new a.Buf16(D+1);this.heap=new a.Buf16(2*A+1);zero(this.heap);this.heap_len=0;this.heap_max=0;this.depth=new a.Buf16(2*A+1);zero(this.depth);this.l_buf=0;this.lit_bufsize=0;this.last_lit=0;this.d_buf=0;this.opt_len=0;this.static_len=0;this.matches=0;this.insert=0;this.bi_buf=0;this.bi_valid=0}function deflateResetKeep(e){var t;if(!e||!e.state){return err(e,v)}e.total_in=e.total_out=0;e.data_type=z;t=e.state;t.pending=0;t.pending_out=0;if(t.wrap<0){t.wrap=-t.wrap}t.status=t.wrap?C:W;e.adler=t.wrap===2?0:1;t.last_flush=f;r._tr_init(t);return u}function deflateReset(e){var t=deflateResetKeep(e);if(t===u){lm_init(e.state)}return t}function deflateSetHeader(e,t){if(!e||!e.state){return v}if(e.state.wrap!==2){return v}e.state.gzhead=t;return u}function deflateInit2(e,t,i,r,n,s){if(!e){return v}var l=1;if(t===p){t=6}if(r<0){l=0;r=-r}else if(r>15){l=2;r-=16}if(n<1||n>x||i!==Z||r<8||r>15||t<0||t>9||s<0||s>y){return err(e,v)}if(r===8){r=9}var f=new DeflateState;e.state=f;f.strm=e;f.wrap=l;f.gzhead=null;f.w_bits=r;f.w_size=1<<f.w_bits;f.w_mask=f.w_size-1;f.hash_bits=n+7;f.hash_size=1<<f.hash_bits;f.hash_mask=f.hash_size-1;f.hash_shift=~~((f.hash_bits+B-1)/B);f.window=new a.Buf8(f.w_size*2);f.head=new a.Buf16(f.hash_size);f.prev=new a.Buf16(f.w_size);f.lit_bufsize=1<<n+6;f.pending_buf_size=f.lit_bufsize*4;f.pending_buf=new a.Buf8(f.pending_buf_size);f.d_buf=1*f.lit_bufsize;f.l_buf=(1+2)*f.lit_bufsize;f.level=t;f.strategy=s;f.method=i;return deflateReset(e)}function deflateInit(e,t){return deflateInit2(e,t,Z,I,R,E)}function deflate(e,t){var i,a;var n,l;if(!e||!e.state||t>d||t<0){return e?err(e,v):v}a=e.state;if(!e.output||!e.input&&e.avail_in!==0||a.status===V&&t!==_){return err(e,e.avail_out===0?w:v)}a.strm=e;i=a.last_flush;a.last_flush=t;if(a.status===C){if(a.wrap===2){e.adler=0;put_byte(a,31);put_byte(a,139);put_byte(a,8);if(!a.gzhead){put_byte(a,0);put_byte(a,0);put_byte(a,0);put_byte(a,0);put_byte(a,0);put_byte(a,a.level===9?2:a.strategy>=m||a.level<2?4:0);put_byte(a,J);a.status=W}else{put_byte(a,(a.gzhead.text?1:0)+(a.gzhead.hcrc?2:0)+(!a.gzhead.extra?0:4)+(!a.gzhead.name?0:8)+(!a.gzhead.comment?0:16));put_byte(a,a.gzhead.time&255);put_byte(a,a.gzhead.time>>8&255);put_byte(a,a.gzhead.time>>16&255);put_byte(a,a.gzhead.time>>24&255);put_byte(a,a.level===9?2:a.strategy>=m||a.level<2?4:0);put_byte(a,a.gzhead.os&255);if(a.gzhead.extra&&a.gzhead.extra.length){put_byte(a,a.gzhead.extra.length&255);put_byte(a,a.gzhead.extra.length>>8&255)}if(a.gzhead.hcrc){e.adler=s(e.adler,a.pending_buf,a.pending,0)}a.gzindex=0;a.status=G}}else{var b=Z+(a.w_bits-8<<4)<<8;var p=-1;if(a.strategy>=m||a.level<2){p=0}else if(a.level<6){p=1}else if(a.level===6){p=2}else{p=3}b|=p<<6;if(a.strstart!==0){b|=M}b+=31-b%31;a.status=W;putShortMSB(a,b);if(a.strstart!==0){putShortMSB(a,e.adler>>>16);putShortMSB(a,e.adler&65535)}e.adler=1}}if(a.status===G){if(a.gzhead.extra){n=a.pending;while(a.gzindex<(a.gzhead.extra.length&65535)){if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>n){e.adler=s(e.adler,a.pending_buf,a.pending-n,n)}flush_pending(e);n=a.pending;if(a.pending===a.pending_buf_size){break}}put_byte(a,a.gzhead.extra[a.gzindex]&255);a.gzindex++}if(a.gzhead.hcrc&&a.pending>n){e.adler=s(e.adler,a.pending_buf,a.pending-n,n)}if(a.gzindex===a.gzhead.extra.length){a.gzindex=0;a.status=H}}else{a.status=H}}if(a.status===H){if(a.gzhead.name){n=a.pending;do{if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>n){e.adler=s(e.adler,a.pending_buf,a.pending-n,n)}flush_pending(e);n=a.pending;if(a.pending===a.pending_buf_size){l=1;break}}if(a.gzindex<a.gzhead.name.length){l=a.gzhead.name.charCodeAt(a.gzindex++)&255}else{l=0}put_byte(a,l)}while(l!==0);if(a.gzhead.hcrc&&a.pending>n){e.adler=s(e.adler,a.pending_buf,a.pending-n,n)}if(l===0){a.gzindex=0;a.status=P}}else{a.status=P}}if(a.status===P){if(a.gzhead.comment){n=a.pending;do{if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>n){e.adler=s(e.adler,a.pending_buf,a.pending-n,n)}flush_pending(e);n=a.pending;if(a.pending===a.pending_buf_size){l=1;break}}if(a.gzindex<a.gzhead.comment.length){l=a.gzhead.comment.charCodeAt(a.gzindex++)&255}else{l=0}put_byte(a,l)}while(l!==0);if(a.gzhead.hcrc&&a.pending>n){e.adler=s(e.adler,a.pending_buf,a.pending-n,n)}if(l===0){a.status=K}}else{a.status=K}}if(a.status===K){if(a.gzhead.hcrc){if(a.pending+2>a.pending_buf_size){flush_pending(e)}if(a.pending+2<=a.pending_buf_size){put_byte(a,e.adler&255);put_byte(a,e.adler>>8&255);e.adler=0;a.status=W}}else{a.status=W}}if(a.pending!==0){flush_pending(e);if(e.avail_out===0){a.last_flush=-1;return u}}else if(e.avail_in===0&&rank(t)<=rank(i)&&t!==_){return err(e,w)}if(a.status===V&&e.avail_in!==0){return err(e,w)}if(e.avail_in!==0||a.lookahead!==0||t!==f&&a.status!==V){var g=a.strategy===m?deflate_huff(a,t):a.strategy===k?deflate_rle(a,t):Q[a.level].func(a,t);if(g===Y||g===j){a.status=V}if(g===q||g===Y){if(e.avail_out===0){a.last_flush=-1}return u}if(g===X){if(t===o){r._tr_align(a)}else if(t!==d){r._tr_stored_block(a,0,0,false);if(t===h){zero(a.head);if(a.lookahead===0){a.strstart=0;a.block_start=0;a.insert=0}}}flush_pending(e);if(e.avail_out===0){a.last_flush=-1;return u}}}if(t!==_){return u}if(a.wrap<=0){return c}if(a.wrap===2){put_byte(a,e.adler&255);put_byte(a,e.adler>>8&255);put_byte(a,e.adler>>16&255);put_byte(a,e.adler>>24&255);put_byte(a,e.total_in&255);put_byte(a,e.total_in>>8&255);put_byte(a,e.total_in>>16&255);put_byte(a,e.total_in>>24&255)}else{putShortMSB(a,e.adler>>>16);putShortMSB(a,e.adler&65535)}flush_pending(e);if(a.wrap>0){a.wrap=-a.wrap}return a.pending!==0?u:c}function deflateEnd(e){var t;if(!e||!e.state){return v}t=e.state.status;if(t!==C&&t!==G&&t!==H&&t!==P&&t!==K&&t!==W&&t!==V){return err(e,v)}e.state=null;return t===W?err(e,b):u}function deflateSetDictionary(e,t){var i=t.length;var r;var s,l;var f;var o;var h;var _;var d;if(!e||!e.state){return v}r=e.state;f=r.wrap;if(f===2||f===1&&r.status!==C||r.lookahead){return v}if(f===1){e.adler=n(e.adler,t,i,0)}r.wrap=0;if(i>=r.w_size){if(f===0){zero(r.head);r.strstart=0;r.block_start=0;r.insert=0}d=new a.Buf8(r.w_size);a.arraySet(d,t,i-r.w_size,r.w_size,0);t=d;i=r.w_size}o=e.avail_in;h=e.next_in;_=e.input;e.avail_in=i;e.next_in=0;e.input=t;fill_window(r);while(r.lookahead>=B){s=r.strstart;l=r.lookahead-(B-1);do{r.ins_h=(r.ins_h<<r.hash_shift^r.window[s+B-1])&r.hash_mask;r.prev[s&r.w_mask]=r.head[r.ins_h];r.head[r.ins_h]=s;s++}while(--l);r.strstart=s;r.lookahead=B-1;fill_window(r)}r.strstart+=r.lookahead;r.block_start=r.strstart;r.insert=r.lookahead;r.lookahead=0;r.match_length=r.prev_length=B-1;r.match_available=0;e.next_in=h;e.input=_;e.avail_in=o;r.wrap=f;return u}t.deflateInit=deflateInit;t.deflateInit2=deflateInit2;t.deflateReset=deflateReset;t.deflateResetKeep=deflateResetKeep;t.deflateSetHeader=deflateSetHeader;t.deflate=deflate;t.deflateEnd=deflateEnd;t.deflateSetDictionary=deflateSetDictionary;t.deflateInfo="pako deflate (from Nodeca project)"},663:function(e){var t=30;var i=12;e.exports=function inflate_fast(e,a){var r;var n;var s;var l;var f;var o;var h;var _;var d;var u;var c;var v;var b;var w;var p;var g;var m;var k;var y;var E;var z;var Z;var x;var I,R;r=e.state;n=e.next_in;I=e.input;s=n+(e.avail_in-5);l=e.next_out;R=e.output;f=l-(a-e.avail_out);o=l+(e.avail_out-257);h=r.dmax;_=r.wsize;d=r.whave;u=r.wnext;c=r.window;v=r.hold;b=r.bits;w=r.lencode;p=r.distcode;g=(1<<r.lenbits)-1;m=(1<<r.distbits)-1;e:do{if(b<15){v+=I[n++]<<b;b+=8;v+=I[n++]<<b;b+=8}k=w[v&g];t:for(;;){y=k>>>24;v>>>=y;b-=y;y=k>>>16&255;if(y===0){R[l++]=k&65535}else if(y&16){E=k&65535;y&=15;if(y){if(b<y){v+=I[n++]<<b;b+=8}E+=v&(1<<y)-1;v>>>=y;b-=y}if(b<15){v+=I[n++]<<b;b+=8;v+=I[n++]<<b;b+=8}k=p[v&m];i:for(;;){y=k>>>24;v>>>=y;b-=y;y=k>>>16&255;if(y&16){z=k&65535;y&=15;if(b<y){v+=I[n++]<<b;b+=8;if(b<y){v+=I[n++]<<b;b+=8}}z+=v&(1<<y)-1;if(z>h){e.msg="invalid distance too far back";r.mode=t;break e}v>>>=y;b-=y;y=l-f;if(z>y){y=z-y;if(y>d){if(r.sane){e.msg="invalid distance too far back";r.mode=t;break e}}Z=0;x=c;if(u===0){Z+=_-y;if(y<E){E-=y;do{R[l++]=c[Z++]}while(--y);Z=l-z;x=R}}else if(u<y){Z+=_+u-y;y-=u;if(y<E){E-=y;do{R[l++]=c[Z++]}while(--y);Z=0;if(u<E){y=u;E-=y;do{R[l++]=c[Z++]}while(--y);Z=l-z;x=R}}}else{Z+=u-y;if(y<E){E-=y;do{R[l++]=c[Z++]}while(--y);Z=l-z;x=R}}while(E>2){R[l++]=x[Z++];R[l++]=x[Z++];R[l++]=x[Z++];E-=3}if(E){R[l++]=x[Z++];if(E>1){R[l++]=x[Z++]}}}else{Z=l-z;do{R[l++]=R[Z++];R[l++]=R[Z++];R[l++]=R[Z++];E-=3}while(E>2);if(E){R[l++]=R[Z++];if(E>1){R[l++]=R[Z++]}}}}else if((y&64)===0){k=p[(k&65535)+(v&(1<<y)-1)];continue i}else{e.msg="invalid distance code";r.mode=t;break e}break}}else if((y&64)===0){k=w[(k&65535)+(v&(1<<y)-1)];continue t}else if(y&32){r.mode=i;break e}else{e.msg="invalid literal/length code";r.mode=t;break e}break}}while(n<s&&l<o);E=b>>3;n-=E;b-=E<<3;v&=(1<<b)-1;e.next_in=n;e.next_out=l;e.avail_in=n<s?5+(s-n):5-(n-s);e.avail_out=l<o?257+(o-l):257-(l-o);r.hold=v;r.bits=b;return}},528:function(e,t,i){var a=i(859);var r=i(417);var n=i(625);var s=i(663);var l=i(753);var f=0;var o=1;var h=2;var _=4;var d=5;var u=6;var c=0;var v=1;var b=2;var w=-2;var p=-3;var g=-4;var m=-5;var k=8;var y=1;var E=2;var z=3;var Z=4;var x=5;var I=6;var R=7;var S=8;var L=9;var A=10;var T=11;var F=12;var N=13;var D=14;var B=15;var U=16;var O=17;var M=18;var C=19;var G=20;var H=21;var P=22;var K=23;var W=24;var V=25;var q=26;var X=27;var Y=28;var j=29;var J=30;var Q=31;var $=32;var ee=852;var te=592;var ie=15;var ae=ie;function zswap32(e){return(e>>>24&255)+(e>>>8&65280)+((e&65280)<<8)+((e&255)<<24)}function InflateState(){this.mode=0;this.last=false;this.wrap=0;this.havedict=false;this.flags=0;this.dmax=0;this.check=0;this.total=0;this.head=null;this.wbits=0;this.wsize=0;this.whave=0;this.wnext=0;this.window=null;this.hold=0;this.bits=0;this.length=0;this.offset=0;this.extra=0;this.lencode=null;this.distcode=null;this.lenbits=0;this.distbits=0;this.ncode=0;this.nlen=0;this.ndist=0;this.have=0;this.next=null;this.lens=new a.Buf16(320);this.work=new a.Buf16(288);this.lendyn=null;this.distdyn=null;this.sane=0;this.back=0;this.was=0}function inflateResetKeep(e){var t;if(!e||!e.state){return w}t=e.state;e.total_in=e.total_out=t.total=0;e.msg="";if(t.wrap){e.adler=t.wrap&1}t.mode=y;t.last=0;t.havedict=0;t.dmax=32768;t.head=null;t.hold=0;t.bits=0;t.lencode=t.lendyn=new a.Buf32(ee);t.distcode=t.distdyn=new a.Buf32(te);t.sane=1;t.back=-1;return c}function inflateReset(e){var t;if(!e||!e.state){return w}t=e.state;t.wsize=0;t.whave=0;t.wnext=0;return inflateResetKeep(e)}function inflateReset2(e,t){var i;var a;if(!e||!e.state){return w}a=e.state;if(t<0){i=0;t=-t}else{i=(t>>4)+1;if(t<48){t&=15}}if(t&&(t<8||t>15)){return w}if(a.window!==null&&a.wbits!==t){a.window=null}a.wrap=i;a.wbits=t;return inflateReset(e)}function inflateInit2(e,t){var i;var a;if(!e){return w}a=new InflateState;e.state=a;a.window=null;i=inflateReset2(e,t);if(i!==c){e.state=null}return i}function inflateInit(e){return inflateInit2(e,ae)}var re=true;var ne,se;function fixedtables(e){if(re){var t;ne=new a.Buf32(512);se=new a.Buf32(32);t=0;while(t<144){e.lens[t++]=8}while(t<256){e.lens[t++]=9}while(t<280){e.lens[t++]=7}while(t<288){e.lens[t++]=8}l(o,e.lens,0,288,ne,0,e.work,{bits:9});t=0;while(t<32){e.lens[t++]=5}l(h,e.lens,0,32,se,0,e.work,{bits:5});re=false}e.lencode=ne;e.lenbits=9;e.distcode=se;e.distbits=5}function updatewindow(e,t,i,r){var n;var s=e.state;if(s.window===null){s.wsize=1<<s.wbits;s.wnext=0;s.whave=0;s.window=new a.Buf8(s.wsize)}if(r>=s.wsize){a.arraySet(s.window,t,i-s.wsize,s.wsize,0);s.wnext=0;s.whave=s.wsize}else{n=s.wsize-s.wnext;if(n>r){n=r}a.arraySet(s.window,t,i-r,n,s.wnext);r-=n;if(r){a.arraySet(s.window,t,i-r,r,0);s.wnext=r;s.whave=s.wsize}else{s.wnext+=n;if(s.wnext===s.wsize){s.wnext=0}if(s.whave<s.wsize){s.whave+=n}}}return 0}function inflate(e,t){var i;var ee,te;var ie;var ae;var re,ne;var se;var le;var fe,oe;var he;var _e;var de;var ue=0;var ce,ve,be;var we,pe,ge;var me;var ke;var ye=new a.Buf8(4);var Ee;var ze;var Ze=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];if(!e||!e.state||!e.output||!e.input&&e.avail_in!==0){return w}i=e.state;if(i.mode===F){i.mode=N}ae=e.next_out;te=e.output;ne=e.avail_out;ie=e.next_in;ee=e.input;re=e.avail_in;se=i.hold;le=i.bits;fe=re;oe=ne;ke=c;e:for(;;){switch(i.mode){case y:if(i.wrap===0){i.mode=N;break}while(le<16){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if(i.wrap&2&&se===35615){i.check=0;ye[0]=se&255;ye[1]=se>>>8&255;i.check=n(i.check,ye,2,0);se=0;le=0;i.mode=E;break}i.flags=0;if(i.head){i.head.done=false}if(!(i.wrap&1)||(((se&255)<<8)+(se>>8))%31){e.msg="incorrect header check";i.mode=J;break}if((se&15)!==k){e.msg="unknown compression method";i.mode=J;break}se>>>=4;le-=4;me=(se&15)+8;if(i.wbits===0){i.wbits=me}else if(me>i.wbits){e.msg="invalid window size";i.mode=J;break}i.dmax=1<<me;e.adler=i.check=1;i.mode=se&512?A:F;se=0;le=0;break;case E:while(le<16){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}i.flags=se;if((i.flags&255)!==k){e.msg="unknown compression method";i.mode=J;break}if(i.flags&57344){e.msg="unknown header flags set";i.mode=J;break}if(i.head){i.head.text=se>>8&1}if(i.flags&512){ye[0]=se&255;ye[1]=se>>>8&255;i.check=n(i.check,ye,2,0)}se=0;le=0;i.mode=z;case z:while(le<32){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if(i.head){i.head.time=se}if(i.flags&512){ye[0]=se&255;ye[1]=se>>>8&255;ye[2]=se>>>16&255;ye[3]=se>>>24&255;i.check=n(i.check,ye,4,0)}se=0;le=0;i.mode=Z;case Z:while(le<16){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if(i.head){i.head.xflags=se&255;i.head.os=se>>8}if(i.flags&512){ye[0]=se&255;ye[1]=se>>>8&255;i.check=n(i.check,ye,2,0)}se=0;le=0;i.mode=x;case x:if(i.flags&1024){while(le<16){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}i.length=se;if(i.head){i.head.extra_len=se}if(i.flags&512){ye[0]=se&255;ye[1]=se>>>8&255;i.check=n(i.check,ye,2,0)}se=0;le=0}else if(i.head){i.head.extra=null}i.mode=I;case I:if(i.flags&1024){he=i.length;if(he>re){he=re}if(he){if(i.head){me=i.head.extra_len-i.length;if(!i.head.extra){i.head.extra=new Array(i.head.extra_len)}a.arraySet(i.head.extra,ee,ie,he,me)}if(i.flags&512){i.check=n(i.check,ee,he,ie)}re-=he;ie+=he;i.length-=he}if(i.length){break e}}i.length=0;i.mode=R;case R:if(i.flags&2048){if(re===0){break e}he=0;do{me=ee[ie+he++];if(i.head&&me&&i.length<65536){i.head.name+=String.fromCharCode(me)}}while(me&&he<re);if(i.flags&512){i.check=n(i.check,ee,he,ie)}re-=he;ie+=he;if(me){break e}}else if(i.head){i.head.name=null}i.length=0;i.mode=S;case S:if(i.flags&4096){if(re===0){break e}he=0;do{me=ee[ie+he++];if(i.head&&me&&i.length<65536){i.head.comment+=String.fromCharCode(me)}}while(me&&he<re);if(i.flags&512){i.check=n(i.check,ee,he,ie)}re-=he;ie+=he;if(me){break e}}else if(i.head){i.head.comment=null}i.mode=L;case L:if(i.flags&512){while(le<16){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if(se!==(i.check&65535)){e.msg="header crc mismatch";i.mode=J;break}se=0;le=0}if(i.head){i.head.hcrc=i.flags>>9&1;i.head.done=true}e.adler=i.check=0;i.mode=F;break;case A:while(le<32){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}e.adler=i.check=zswap32(se);se=0;le=0;i.mode=T;case T:if(i.havedict===0){e.next_out=ae;e.avail_out=ne;e.next_in=ie;e.avail_in=re;i.hold=se;i.bits=le;return b}e.adler=i.check=1;i.mode=F;case F:if(t===d||t===u){break e}case N:if(i.last){se>>>=le&7;le-=le&7;i.mode=X;break}while(le<3){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}i.last=se&1;se>>>=1;le-=1;switch(se&3){case 0:i.mode=D;break;case 1:fixedtables(i);i.mode=G;if(t===u){se>>>=2;le-=2;break e}break;case 2:i.mode=O;break;case 3:e.msg="invalid block type";i.mode=J}se>>>=2;le-=2;break;case D:se>>>=le&7;le-=le&7;while(le<32){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if((se&65535)!==(se>>>16^65535)){e.msg="invalid stored block lengths";i.mode=J;break}i.length=se&65535;se=0;le=0;i.mode=B;if(t===u){break e}case B:i.mode=U;case U:he=i.length;if(he){if(he>re){he=re}if(he>ne){he=ne}if(he===0){break e}a.arraySet(te,ee,ie,he,ae);re-=he;ie+=he;ne-=he;ae+=he;i.length-=he;break}i.mode=F;break;case O:while(le<14){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}i.nlen=(se&31)+257;se>>>=5;le-=5;i.ndist=(se&31)+1;se>>>=5;le-=5;i.ncode=(se&15)+4;se>>>=4;le-=4;if(i.nlen>286||i.ndist>30){e.msg="too many length or distance symbols";i.mode=J;break}i.have=0;i.mode=M;case M:while(i.have<i.ncode){while(le<3){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}i.lens[Ze[i.have++]]=se&7;se>>>=3;le-=3}while(i.have<19){i.lens[Ze[i.have++]]=0}i.lencode=i.lendyn;i.lenbits=7;Ee={bits:i.lenbits};ke=l(f,i.lens,0,19,i.lencode,0,i.work,Ee);i.lenbits=Ee.bits;if(ke){e.msg="invalid code lengths set";i.mode=J;break}i.have=0;i.mode=C;case C:while(i.have<i.nlen+i.ndist){for(;;){ue=i.lencode[se&(1<<i.lenbits)-1];ce=ue>>>24;ve=ue>>>16&255;be=ue&65535;if(ce<=le){break}if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if(be<16){se>>>=ce;le-=ce;i.lens[i.have++]=be}else{if(be===16){ze=ce+2;while(le<ze){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}se>>>=ce;le-=ce;if(i.have===0){e.msg="invalid bit length repeat";i.mode=J;break}me=i.lens[i.have-1];he=3+(se&3);se>>>=2;le-=2}else if(be===17){ze=ce+3;while(le<ze){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}se>>>=ce;le-=ce;me=0;he=3+(se&7);se>>>=3;le-=3}else{ze=ce+7;while(le<ze){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}se>>>=ce;le-=ce;me=0;he=11+(se&127);se>>>=7;le-=7}if(i.have+he>i.nlen+i.ndist){e.msg="invalid bit length repeat";i.mode=J;break}while(he--){i.lens[i.have++]=me}}}if(i.mode===J){break}if(i.lens[256]===0){e.msg="invalid code -- missing end-of-block";i.mode=J;break}i.lenbits=9;Ee={bits:i.lenbits};ke=l(o,i.lens,0,i.nlen,i.lencode,0,i.work,Ee);i.lenbits=Ee.bits;if(ke){e.msg="invalid literal/lengths set";i.mode=J;break}i.distbits=6;i.distcode=i.distdyn;Ee={bits:i.distbits};ke=l(h,i.lens,i.nlen,i.ndist,i.distcode,0,i.work,Ee);i.distbits=Ee.bits;if(ke){e.msg="invalid distances set";i.mode=J;break}i.mode=G;if(t===u){break e}case G:i.mode=H;case H:if(re>=6&&ne>=258){e.next_out=ae;e.avail_out=ne;e.next_in=ie;e.avail_in=re;i.hold=se;i.bits=le;s(e,oe);ae=e.next_out;te=e.output;ne=e.avail_out;ie=e.next_in;ee=e.input;re=e.avail_in;se=i.hold;le=i.bits;if(i.mode===F){i.back=-1}break}i.back=0;for(;;){ue=i.lencode[se&(1<<i.lenbits)-1];ce=ue>>>24;ve=ue>>>16&255;be=ue&65535;if(ce<=le){break}if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if(ve&&(ve&240)===0){we=ce;pe=ve;ge=be;for(;;){ue=i.lencode[ge+((se&(1<<we+pe)-1)>>we)];ce=ue>>>24;ve=ue>>>16&255;be=ue&65535;if(we+ce<=le){break}if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}se>>>=we;le-=we;i.back+=we}se>>>=ce;le-=ce;i.back+=ce;i.length=be;if(ve===0){i.mode=q;break}if(ve&32){i.back=-1;i.mode=F;break}if(ve&64){e.msg="invalid literal/length code";i.mode=J;break}i.extra=ve&15;i.mode=P;case P:if(i.extra){ze=i.extra;while(le<ze){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}i.length+=se&(1<<i.extra)-1;se>>>=i.extra;le-=i.extra;i.back+=i.extra}i.was=i.length;i.mode=K;case K:for(;;){ue=i.distcode[se&(1<<i.distbits)-1];ce=ue>>>24;ve=ue>>>16&255;be=ue&65535;if(ce<=le){break}if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if((ve&240)===0){we=ce;pe=ve;ge=be;for(;;){ue=i.distcode[ge+((se&(1<<we+pe)-1)>>we)];ce=ue>>>24;ve=ue>>>16&255;be=ue&65535;if(we+ce<=le){break}if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}se>>>=we;le-=we;i.back+=we}se>>>=ce;le-=ce;i.back+=ce;if(ve&64){e.msg="invalid distance code";i.mode=J;break}i.offset=be;i.extra=ve&15;i.mode=W;case W:if(i.extra){ze=i.extra;while(le<ze){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}i.offset+=se&(1<<i.extra)-1;se>>>=i.extra;le-=i.extra;i.back+=i.extra}if(i.offset>i.dmax){e.msg="invalid distance too far back";i.mode=J;break}i.mode=V;case V:if(ne===0){break e}he=oe-ne;if(i.offset>he){he=i.offset-he;if(he>i.whave){if(i.sane){e.msg="invalid distance too far back";i.mode=J;break}}if(he>i.wnext){he-=i.wnext;_e=i.wsize-he}else{_e=i.wnext-he}if(he>i.length){he=i.length}de=i.window}else{de=te;_e=ae-i.offset;he=i.length}if(he>ne){he=ne}ne-=he;i.length-=he;do{te[ae++]=de[_e++]}while(--he);if(i.length===0){i.mode=H}break;case q:if(ne===0){break e}te[ae++]=i.length;ne--;i.mode=H;break;case X:if(i.wrap){while(le<32){if(re===0){break e}re--;se|=ee[ie++]<<le;le+=8}oe-=ne;e.total_out+=oe;i.total+=oe;if(oe){e.adler=i.check=i.flags?n(i.check,te,oe,ae-oe):r(i.check,te,oe,ae-oe)}oe=ne;if((i.flags?se:zswap32(se))!==i.check){e.msg="incorrect data check";i.mode=J;break}se=0;le=0}i.mode=Y;case Y:if(i.wrap&&i.flags){while(le<32){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if(se!==(i.total&4294967295)){e.msg="incorrect length check";i.mode=J;break}se=0;le=0}i.mode=j;case j:ke=v;break e;case J:ke=p;break e;case Q:return g;case $:default:return w}}e.next_out=ae;e.avail_out=ne;e.next_in=ie;e.avail_in=re;i.hold=se;i.bits=le;if(i.wsize||oe!==e.avail_out&&i.mode<J&&(i.mode<X||t!==_)){if(updatewindow(e,e.output,e.next_out,oe-e.avail_out)){i.mode=Q;return g}}fe-=e.avail_in;oe-=e.avail_out;e.total_in+=fe;e.total_out+=oe;i.total+=oe;if(i.wrap&&oe){e.adler=i.check=i.flags?n(i.check,te,oe,e.next_out-oe):r(i.check,te,oe,e.next_out-oe)}e.data_type=i.bits+(i.last?64:0)+(i.mode===F?128:0)+(i.mode===G||i.mode===B?256:0);if((fe===0&&oe===0||t===_)&&ke===c){ke=m}return ke}function inflateEnd(e){if(!e||!e.state){return w}var t=e.state;if(t.window){t.window=null}e.state=null;return c}function inflateGetHeader(e,t){var i;if(!e||!e.state){return w}i=e.state;if((i.wrap&2)===0){return w}i.head=t;t.done=false;return c}function inflateSetDictionary(e,t){var i=t.length;var a;var n;var s;if(!e||!e.state){return w}a=e.state;if(a.wrap!==0&&a.mode!==T){return w}if(a.mode===T){n=1;n=r(n,t,i,0);if(n!==a.check){return p}}s=updatewindow(e,t,i,i);if(s){a.mode=Q;return g}a.havedict=1;return c}t.inflateReset=inflateReset;t.inflateReset2=inflateReset2;t.inflateResetKeep=inflateResetKeep;t.inflateInit=inflateInit;t.inflateInit2=inflateInit2;t.inflate=inflate;t.inflateEnd=inflateEnd;t.inflateGetHeader=inflateGetHeader;t.inflateSetDictionary=inflateSetDictionary;t.inflateInfo="pako inflate (from Nodeca project)"},753:function(e,t,i){var a=i(859);var r=15;var n=852;var s=592;var l=0;var f=1;var o=2;var h=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0];var _=[16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78];var d=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0];var u=[16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64];e.exports=function inflate_table(e,t,i,c,v,b,w,p){var g=p.bits;var m=0;var k=0;var y=0,E=0;var z=0;var Z=0;var x=0;var I=0;var R=0;var S=0;var L;var A;var T;var F;var N;var D=null;var B=0;var U;var O=new a.Buf16(r+1);var M=new a.Buf16(r+1);var C=null;var G=0;var H,P,K;for(m=0;m<=r;m++){O[m]=0}for(k=0;k<c;k++){O[t[i+k]]++}z=g;for(E=r;E>=1;E--){if(O[E]!==0){break}}if(z>E){z=E}if(E===0){v[b++]=1<<24|64<<16|0;v[b++]=1<<24|64<<16|0;p.bits=1;return 0}for(y=1;y<E;y++){if(O[y]!==0){break}}if(z<y){z=y}I=1;for(m=1;m<=r;m++){I<<=1;I-=O[m];if(I<0){return-1}}if(I>0&&(e===l||E!==1)){return-1}M[1]=0;for(m=1;m<r;m++){M[m+1]=M[m]+O[m]}for(k=0;k<c;k++){if(t[i+k]!==0){w[M[t[i+k]]++]=k}}if(e===l){D=C=w;U=19}else if(e===f){D=h;B-=257;C=_;G-=257;U=256}else{D=d;C=u;U=-1}S=0;k=0;m=y;N=b;Z=z;x=0;T=-1;R=1<<z;F=R-1;if(e===f&&R>n||e===o&&R>s){return 1}for(;;){H=m-x;if(w[k]<U){P=0;K=w[k]}else if(w[k]>U){P=C[G+w[k]];K=D[B+w[k]]}else{P=32+64;K=0}L=1<<m-x;A=1<<Z;y=A;do{A-=L;v[N+(S>>x)+A]=H<<24|P<<16|K|0}while(A!==0);L=1<<m-1;while(S&L){L>>=1}if(L!==0){S&=L-1;S+=L}else{S=0}k++;if(--O[m]===0){if(m===E){break}m=t[i+w[k]]}if(m>z&&(S&F)!==T){if(x===0){x=z}N+=y;Z=m-x;I=1<<Z;while(Z+x<E){I-=O[Z+x];if(I<=0){break}Z++;I<<=1}R+=1<<Z;if(e===f&&R>n||e===o&&R>s){return 1}T=S&F;v[T]=z<<24|Z<<16|N-b|0}}if(S!==0){v[N+S]=m-x<<24|64<<16|0}p.bits=z;return 0}},277:function(e){e.exports={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"}},40:function(e,t,i){var a=i(859);var r=4;var n=0;var s=1;var l=2;function zero(e){var t=e.length;while(--t>=0){e[t]=0}}var f=0;var o=1;var h=2;var _=3;var d=258;var u=29;var c=256;var v=c+1+u;var b=30;var w=19;var p=2*v+1;var g=15;var m=16;var k=7;var y=256;var E=16;var z=17;var Z=18;var x=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];var I=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];var R=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];var S=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];var L=512;var A=new Array((v+2)*2);zero(A);var T=new Array(b*2);zero(T);var F=new Array(L);zero(F);var N=new Array(d-_+1);zero(N);var D=new Array(u);zero(D);var B=new Array(b);zero(B);function StaticTreeDesc(e,t,i,a,r){this.static_tree=e;this.extra_bits=t;this.extra_base=i;this.elems=a;this.max_length=r;this.has_stree=e&&e.length}var U;var O;var M;function TreeDesc(e,t){this.dyn_tree=e;this.max_code=0;this.stat_desc=t}function d_code(e){return e<256?F[e]:F[256+(e>>>7)]}function put_short(e,t){e.pending_buf[e.pending++]=t&255;e.pending_buf[e.pending++]=t>>>8&255}function send_bits(e,t,i){if(e.bi_valid>m-i){e.bi_buf|=t<<e.bi_valid&65535;put_short(e,e.bi_buf);e.bi_buf=t>>m-e.bi_valid;e.bi_valid+=i-m}else{e.bi_buf|=t<<e.bi_valid&65535;e.bi_valid+=i}}function send_code(e,t,i){send_bits(e,i[t*2],i[t*2+1])}function bi_reverse(e,t){var i=0;do{i|=e&1;e>>>=1;i<<=1}while(--t>0);return i>>>1}function bi_flush(e){if(e.bi_valid===16){put_short(e,e.bi_buf);e.bi_buf=0;e.bi_valid=0}else if(e.bi_valid>=8){e.pending_buf[e.pending++]=e.bi_buf&255;e.bi_buf>>=8;e.bi_valid-=8}}function gen_bitlen(e,t){var i=t.dyn_tree;var a=t.max_code;var r=t.stat_desc.static_tree;var n=t.stat_desc.has_stree;var s=t.stat_desc.extra_bits;var l=t.stat_desc.extra_base;var f=t.stat_desc.max_length;var o;var h,_;var d;var u;var c;var v=0;for(d=0;d<=g;d++){e.bl_count[d]=0}i[e.heap[e.heap_max]*2+1]=0;for(o=e.heap_max+1;o<p;o++){h=e.heap[o];d=i[i[h*2+1]*2+1]+1;if(d>f){d=f;v++}i[h*2+1]=d;if(h>a){continue}e.bl_count[d]++;u=0;if(h>=l){u=s[h-l]}c=i[h*2];e.opt_len+=c*(d+u);if(n){e.static_len+=c*(r[h*2+1]+u)}}if(v===0){return}do{d=f-1;while(e.bl_count[d]===0){d--}e.bl_count[d]--;e.bl_count[d+1]+=2;e.bl_count[f]--;v-=2}while(v>0);for(d=f;d!==0;d--){h=e.bl_count[d];while(h!==0){_=e.heap[--o];if(_>a){continue}if(i[_*2+1]!==d){e.opt_len+=(d-i[_*2+1])*i[_*2];i[_*2+1]=d}h--}}}function gen_codes(e,t,i){var a=new Array(g+1);var r=0;var n;var s;for(n=1;n<=g;n++){a[n]=r=r+i[n-1]<<1}for(s=0;s<=t;s++){var l=e[s*2+1];if(l===0){continue}e[s*2]=bi_reverse(a[l]++,l)}}function tr_static_init(){var e;var t;var i;var a;var r;var n=new Array(g+1);i=0;for(a=0;a<u-1;a++){D[a]=i;for(e=0;e<1<<x[a];e++){N[i++]=a}}N[i-1]=a;r=0;for(a=0;a<16;a++){B[a]=r;for(e=0;e<1<<I[a];e++){F[r++]=a}}r>>=7;for(;a<b;a++){B[a]=r<<7;for(e=0;e<1<<I[a]-7;e++){F[256+r++]=a}}for(t=0;t<=g;t++){n[t]=0}e=0;while(e<=143){A[e*2+1]=8;e++;n[8]++}while(e<=255){A[e*2+1]=9;e++;n[9]++}while(e<=279){A[e*2+1]=7;e++;n[7]++}while(e<=287){A[e*2+1]=8;e++;n[8]++}gen_codes(A,v+1,n);for(e=0;e<b;e++){T[e*2+1]=5;T[e*2]=bi_reverse(e,5)}U=new StaticTreeDesc(A,x,c+1,v,g);O=new StaticTreeDesc(T,I,0,b,g);M=new StaticTreeDesc(new Array(0),R,0,w,k)}function init_block(e){var t;for(t=0;t<v;t++){e.dyn_ltree[t*2]=0}for(t=0;t<b;t++){e.dyn_dtree[t*2]=0}for(t=0;t<w;t++){e.bl_tree[t*2]=0}e.dyn_ltree[y*2]=1;e.opt_len=e.static_len=0;e.last_lit=e.matches=0}function bi_windup(e){if(e.bi_valid>8){put_short(e,e.bi_buf)}else if(e.bi_valid>0){e.pending_buf[e.pending++]=e.bi_buf}e.bi_buf=0;e.bi_valid=0}function copy_block(e,t,i,r){bi_windup(e);if(r){put_short(e,i);put_short(e,~i)}a.arraySet(e.pending_buf,e.window,t,i,e.pending);e.pending+=i}function smaller(e,t,i,a){var r=t*2;var n=i*2;return e[r]<e[n]||e[r]===e[n]&&a[t]<=a[i]}function pqdownheap(e,t,i){var a=e.heap[i];var r=i<<1;while(r<=e.heap_len){if(r<e.heap_len&&smaller(t,e.heap[r+1],e.heap[r],e.depth)){r++}if(smaller(t,a,e.heap[r],e.depth)){break}e.heap[i]=e.heap[r];i=r;r<<=1}e.heap[i]=a}function compress_block(e,t,i){var a;var r;var n=0;var s;var l;if(e.last_lit!==0){do{a=e.pending_buf[e.d_buf+n*2]<<8|e.pending_buf[e.d_buf+n*2+1];r=e.pending_buf[e.l_buf+n];n++;if(a===0){send_code(e,r,t)}else{s=N[r];send_code(e,s+c+1,t);l=x[s];if(l!==0){r-=D[s];send_bits(e,r,l)}a--;s=d_code(a);send_code(e,s,i);l=I[s];if(l!==0){a-=B[s];send_bits(e,a,l)}}}while(n<e.last_lit)}send_code(e,y,t)}function build_tree(e,t){var i=t.dyn_tree;var a=t.stat_desc.static_tree;var r=t.stat_desc.has_stree;var n=t.stat_desc.elems;var s,l;var f=-1;var o;e.heap_len=0;e.heap_max=p;for(s=0;s<n;s++){if(i[s*2]!==0){e.heap[++e.heap_len]=f=s;e.depth[s]=0}else{i[s*2+1]=0}}while(e.heap_len<2){o=e.heap[++e.heap_len]=f<2?++f:0;i[o*2]=1;e.depth[o]=0;e.opt_len--;if(r){e.static_len-=a[o*2+1]}}t.max_code=f;for(s=e.heap_len>>1;s>=1;s--){pqdownheap(e,i,s)}o=n;do{s=e.heap[1];e.heap[1]=e.heap[e.heap_len--];pqdownheap(e,i,1);l=e.heap[1];e.heap[--e.heap_max]=s;e.heap[--e.heap_max]=l;i[o*2]=i[s*2]+i[l*2];e.depth[o]=(e.depth[s]>=e.depth[l]?e.depth[s]:e.depth[l])+1;i[s*2+1]=i[l*2+1]=o;e.heap[1]=o++;pqdownheap(e,i,1)}while(e.heap_len>=2);e.heap[--e.heap_max]=e.heap[1];gen_bitlen(e,t);gen_codes(i,f,e.bl_count)}function scan_tree(e,t,i){var a;var r=-1;var n;var s=t[0*2+1];var l=0;var f=7;var o=4;if(s===0){f=138;o=3}t[(i+1)*2+1]=65535;for(a=0;a<=i;a++){n=s;s=t[(a+1)*2+1];if(++l<f&&n===s){continue}else if(l<o){e.bl_tree[n*2]+=l}else if(n!==0){if(n!==r){e.bl_tree[n*2]++}e.bl_tree[E*2]++}else if(l<=10){e.bl_tree[z*2]++}else{e.bl_tree[Z*2]++}l=0;r=n;if(s===0){f=138;o=3}else if(n===s){f=6;o=3}else{f=7;o=4}}}function send_tree(e,t,i){var a;var r=-1;var n;var s=t[0*2+1];var l=0;var f=7;var o=4;if(s===0){f=138;o=3}for(a=0;a<=i;a++){n=s;s=t[(a+1)*2+1];if(++l<f&&n===s){continue}else if(l<o){do{send_code(e,n,e.bl_tree)}while(--l!==0)}else if(n!==0){if(n!==r){send_code(e,n,e.bl_tree);l--}send_code(e,E,e.bl_tree);send_bits(e,l-3,2)}else if(l<=10){send_code(e,z,e.bl_tree);send_bits(e,l-3,3)}else{send_code(e,Z,e.bl_tree);send_bits(e,l-11,7)}l=0;r=n;if(s===0){f=138;o=3}else if(n===s){f=6;o=3}else{f=7;o=4}}}function build_bl_tree(e){var t;scan_tree(e,e.dyn_ltree,e.l_desc.max_code);scan_tree(e,e.dyn_dtree,e.d_desc.max_code);build_tree(e,e.bl_desc);for(t=w-1;t>=3;t--){if(e.bl_tree[S[t]*2+1]!==0){break}}e.opt_len+=3*(t+1)+5+5+4;return t}function send_all_trees(e,t,i,a){var r;send_bits(e,t-257,5);send_bits(e,i-1,5);send_bits(e,a-4,4);for(r=0;r<a;r++){send_bits(e,e.bl_tree[S[r]*2+1],3)}send_tree(e,e.dyn_ltree,t-1);send_tree(e,e.dyn_dtree,i-1)}function detect_data_type(e){var t=4093624447;var i;for(i=0;i<=31;i++,t>>>=1){if(t&1&&e.dyn_ltree[i*2]!==0){return n}}if(e.dyn_ltree[9*2]!==0||e.dyn_ltree[10*2]!==0||e.dyn_ltree[13*2]!==0){return s}for(i=32;i<c;i++){if(e.dyn_ltree[i*2]!==0){return s}}return n}var C=false;function _tr_init(e){if(!C){tr_static_init();C=true}e.l_desc=new TreeDesc(e.dyn_ltree,U);e.d_desc=new TreeDesc(e.dyn_dtree,O);e.bl_desc=new TreeDesc(e.bl_tree,M);e.bi_buf=0;e.bi_valid=0;init_block(e)}function _tr_stored_block(e,t,i,a){send_bits(e,(f<<1)+(a?1:0),3);copy_block(e,t,i,true)}function _tr_align(e){send_bits(e,o<<1,3);send_code(e,y,A);bi_flush(e)}function _tr_flush_block(e,t,i,a){var n,s;var f=0;if(e.level>0){if(e.strm.data_type===l){e.strm.data_type=detect_data_type(e)}build_tree(e,e.l_desc);build_tree(e,e.d_desc);f=build_bl_tree(e);n=e.opt_len+3+7>>>3;s=e.static_len+3+7>>>3;if(s<=n){n=s}}else{n=s=i+5}if(i+4<=n&&t!==-1){_tr_stored_block(e,t,i,a)}else if(e.strategy===r||s===n){send_bits(e,(o<<1)+(a?1:0),3);compress_block(e,A,T)}else{send_bits(e,(h<<1)+(a?1:0),3);send_all_trees(e,e.l_desc.max_code+1,e.d_desc.max_code+1,f+1);compress_block(e,e.dyn_ltree,e.dyn_dtree)}init_block(e);if(a){bi_windup(e)}}function _tr_tally(e,t,i){e.pending_buf[e.d_buf+e.last_lit*2]=t>>>8&255;e.pending_buf[e.d_buf+e.last_lit*2+1]=t&255;e.pending_buf[e.l_buf+e.last_lit]=i&255;e.last_lit++;if(t===0){e.dyn_ltree[i*2]++}else{e.matches++;t--;e.dyn_ltree[(N[i]+c+1)*2]++;e.dyn_dtree[d_code(t)*2]++}return e.last_lit===e.lit_bufsize-1}t._tr_init=_tr_init;t._tr_stored_block=_tr_stored_block;t._tr_flush_block=_tr_flush_block;t._tr_tally=_tr_tally;t._tr_align=_tr_align},838:function(e){function ZStream(){this.input=null;this.next_in=0;this.avail_in=0;this.total_in=0;this.output=null;this.next_out=0;this.avail_out=0;this.total_out=0;this.msg="";this.state=null;this.data_type=2;this.adler=0}e.exports=ZStream},491:function(e){e.exports=__webpack_require__(27596)},300:function(e){e.exports=__webpack_require__(48764)},781:function(e){e.exports=__webpack_require__(79681)},837:function(e){e.exports=__webpack_require__(79720)}};var t={};function __nccwpck_require__(i){var a=t[i];if(a!==undefined){return a.exports}var r=t[i]={exports:{}};var n=true;try{e[i](r,r.exports,__nccwpck_require__);n=false}finally{if(n)delete t[i]}return r.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var i=__nccwpck_require__(979);module.exports=i})();

/***/ }),

/***/ 25293:
/***/ (function(module) {

var __dirname = "/";
(function(){"use strict";var e={699:function(e){var t=typeof Reflect==="object"?Reflect:null;var n=t&&typeof t.apply==="function"?t.apply:function ReflectApply(e,t,n){return Function.prototype.apply.call(e,t,n)};var r;if(t&&typeof t.ownKeys==="function"){r=t.ownKeys}else if(Object.getOwnPropertySymbols){r=function ReflectOwnKeys(e){return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e))}}else{r=function ReflectOwnKeys(e){return Object.getOwnPropertyNames(e)}}function ProcessEmitWarning(e){if(console&&console.warn)console.warn(e)}var i=Number.isNaN||function NumberIsNaN(e){return e!==e};function EventEmitter(){EventEmitter.init.call(this)}e.exports=EventEmitter;e.exports.once=once;EventEmitter.EventEmitter=EventEmitter;EventEmitter.prototype._events=undefined;EventEmitter.prototype._eventsCount=0;EventEmitter.prototype._maxListeners=undefined;var s=10;function checkListener(e){if(typeof e!=="function"){throw new TypeError('The "listener" argument must be of type Function. Received type '+typeof e)}}Object.defineProperty(EventEmitter,"defaultMaxListeners",{enumerable:true,get:function(){return s},set:function(e){if(typeof e!=="number"||e<0||i(e)){throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received '+e+".")}s=e}});EventEmitter.init=function(){if(this._events===undefined||this._events===Object.getPrototypeOf(this)._events){this._events=Object.create(null);this._eventsCount=0}this._maxListeners=this._maxListeners||undefined};EventEmitter.prototype.setMaxListeners=function setMaxListeners(e){if(typeof e!=="number"||e<0||i(e)){throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received '+e+".")}this._maxListeners=e;return this};function _getMaxListeners(e){if(e._maxListeners===undefined)return EventEmitter.defaultMaxListeners;return e._maxListeners}EventEmitter.prototype.getMaxListeners=function getMaxListeners(){return _getMaxListeners(this)};EventEmitter.prototype.emit=function emit(e){var t=[];for(var r=1;r<arguments.length;r++)t.push(arguments[r]);var i=e==="error";var s=this._events;if(s!==undefined)i=i&&s.error===undefined;else if(!i)return false;if(i){var o;if(t.length>0)o=t[0];if(o instanceof Error){throw o}var f=new Error("Unhandled error."+(o?" ("+o.message+")":""));f.context=o;throw f}var u=s[e];if(u===undefined)return false;if(typeof u==="function"){n(u,this,t)}else{var a=u.length;var c=arrayClone(u,a);for(var r=0;r<a;++r)n(c[r],this,t)}return true};function _addListener(e,t,n,r){var i;var s;var o;checkListener(n);s=e._events;if(s===undefined){s=e._events=Object.create(null);e._eventsCount=0}else{if(s.newListener!==undefined){e.emit("newListener",t,n.listener?n.listener:n);s=e._events}o=s[t]}if(o===undefined){o=s[t]=n;++e._eventsCount}else{if(typeof o==="function"){o=s[t]=r?[n,o]:[o,n]}else if(r){o.unshift(n)}else{o.push(n)}i=_getMaxListeners(e);if(i>0&&o.length>i&&!o.warned){o.warned=true;var f=new Error("Possible EventEmitter memory leak detected. "+o.length+" "+String(t)+" listeners "+"added. Use emitter.setMaxListeners() to "+"increase limit");f.name="MaxListenersExceededWarning";f.emitter=e;f.type=t;f.count=o.length;ProcessEmitWarning(f)}}return e}EventEmitter.prototype.addListener=function addListener(e,t){return _addListener(this,e,t,false)};EventEmitter.prototype.on=EventEmitter.prototype.addListener;EventEmitter.prototype.prependListener=function prependListener(e,t){return _addListener(this,e,t,true)};function onceWrapper(){if(!this.fired){this.target.removeListener(this.type,this.wrapFn);this.fired=true;if(arguments.length===0)return this.listener.call(this.target);return this.listener.apply(this.target,arguments)}}function _onceWrap(e,t,n){var r={fired:false,wrapFn:undefined,target:e,type:t,listener:n};var i=onceWrapper.bind(r);i.listener=n;r.wrapFn=i;return i}EventEmitter.prototype.once=function once(e,t){checkListener(t);this.on(e,_onceWrap(this,e,t));return this};EventEmitter.prototype.prependOnceListener=function prependOnceListener(e,t){checkListener(t);this.prependListener(e,_onceWrap(this,e,t));return this};EventEmitter.prototype.removeListener=function removeListener(e,t){var n,r,i,s,o;checkListener(t);r=this._events;if(r===undefined)return this;n=r[e];if(n===undefined)return this;if(n===t||n.listener===t){if(--this._eventsCount===0)this._events=Object.create(null);else{delete r[e];if(r.removeListener)this.emit("removeListener",e,n.listener||t)}}else if(typeof n!=="function"){i=-1;for(s=n.length-1;s>=0;s--){if(n[s]===t||n[s].listener===t){o=n[s].listener;i=s;break}}if(i<0)return this;if(i===0)n.shift();else{spliceOne(n,i)}if(n.length===1)r[e]=n[0];if(r.removeListener!==undefined)this.emit("removeListener",e,o||t)}return this};EventEmitter.prototype.off=EventEmitter.prototype.removeListener;EventEmitter.prototype.removeAllListeners=function removeAllListeners(e){var t,n,r;n=this._events;if(n===undefined)return this;if(n.removeListener===undefined){if(arguments.length===0){this._events=Object.create(null);this._eventsCount=0}else if(n[e]!==undefined){if(--this._eventsCount===0)this._events=Object.create(null);else delete n[e]}return this}if(arguments.length===0){var i=Object.keys(n);var s;for(r=0;r<i.length;++r){s=i[r];if(s==="removeListener")continue;this.removeAllListeners(s)}this.removeAllListeners("removeListener");this._events=Object.create(null);this._eventsCount=0;return this}t=n[e];if(typeof t==="function"){this.removeListener(e,t)}else if(t!==undefined){for(r=t.length-1;r>=0;r--){this.removeListener(e,t[r])}}return this};function _listeners(e,t,n){var r=e._events;if(r===undefined)return[];var i=r[t];if(i===undefined)return[];if(typeof i==="function")return n?[i.listener||i]:[i];return n?unwrapListeners(i):arrayClone(i,i.length)}EventEmitter.prototype.listeners=function listeners(e){return _listeners(this,e,true)};EventEmitter.prototype.rawListeners=function rawListeners(e){return _listeners(this,e,false)};EventEmitter.listenerCount=function(e,t){if(typeof e.listenerCount==="function"){return e.listenerCount(t)}else{return listenerCount.call(e,t)}};EventEmitter.prototype.listenerCount=listenerCount;function listenerCount(e){var t=this._events;if(t!==undefined){var n=t[e];if(typeof n==="function"){return 1}else if(n!==undefined){return n.length}}return 0}EventEmitter.prototype.eventNames=function eventNames(){return this._eventsCount>0?r(this._events):[]};function arrayClone(e,t){var n=new Array(t);for(var r=0;r<t;++r)n[r]=e[r];return n}function spliceOne(e,t){for(;t+1<e.length;t++)e[t]=e[t+1];e.pop()}function unwrapListeners(e){var t=new Array(e.length);for(var n=0;n<t.length;++n){t[n]=e[n].listener||e[n]}return t}function once(e,t){return new Promise((function(n,r){function errorListener(n){e.removeListener(t,resolver);r(n)}function resolver(){if(typeof e.removeListener==="function"){e.removeListener("error",errorListener)}n([].slice.call(arguments))}eventTargetAgnosticAddListener(e,t,resolver,{once:true});if(t!=="error"){addErrorHandlerIfEventEmitter(e,errorListener,{once:true})}}))}function addErrorHandlerIfEventEmitter(e,t,n){if(typeof e.on==="function"){eventTargetAgnosticAddListener(e,"error",t,n)}}function eventTargetAgnosticAddListener(e,t,n,r){if(typeof e.on==="function"){if(r.once){e.once(t,n)}else{e.on(t,n)}}else if(typeof e.addEventListener==="function"){e.addEventListener(t,(function wrapListener(i){if(r.once){e.removeEventListener(t,wrapListener)}n(i)}))}else{throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type '+typeof e)}}}};var t={};function __nccwpck_require__(n){var r=t[n];if(r!==undefined){return r.exports}var i=t[n]={exports:{}};var s=true;try{e[n](i,i.exports,__nccwpck_require__);s=false}finally{if(s)delete t[n]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var n=__nccwpck_require__(699);module.exports=n})();

/***/ }),

/***/ 78428:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
(function(){var r={962:function(r,e,t){var o=t(685);var a=t(310);var i=r.exports;for(var n in o){if(o.hasOwnProperty(n))i[n]=o[n]}i.request=function(r,e){r=validateParams(r);return o.request.call(this,r,e)};i.get=function(r,e){r=validateParams(r);return o.get.call(this,r,e)};function validateParams(r){if(typeof r==="string"){r=a.parse(r)}if(!r.protocol){r.protocol="https:"}if(r.protocol!=="https:"){throw new Error('Protocol "'+r.protocol+'" not supported. Expected "https:"')}return r}},685:function(r){"use strict";r.exports=__webpack_require__(22321)},310:function(r){"use strict";r.exports=__webpack_require__(11987)}};var e={};function __nccwpck_require__(t){var o=e[t];if(o!==undefined){return o.exports}var a=e[t]={exports:{}};var i=true;try{r[t](a,a.exports,__nccwpck_require__);i=false}finally{if(i)delete e[t]}return a.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(962);module.exports=t})();

/***/ }),

/***/ 87990:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fileUploadLabel":"FileUpload_fileUploadLabel__F6eAz","active":"FileUpload_active__B5hxv","error":"FileUpload_error__lIsai","loading":"FileUpload_loading__uPtrT","spinnerHolder":"FileUpload_spinnerHolder__vM7f6","fileUploadCta":"FileUpload_fileUploadCta__lst8a","filename":"FileUpload_filename__lEx8E"};

/***/ }),

/***/ 45565:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 18698:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 5999:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 97282:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 11987:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
(function(){var e={477:function(e){"use strict";e.exports=__webpack_require__(97334)}};var t={};function __nccwpck_require__(o){var a=t[o];if(a!==undefined){return a.exports}var s=t[o]={exports:{}};var n=true;try{e[o](s,s.exports,__nccwpck_require__);n=false}finally{if(n)delete t[o]}return s.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var o={};!function(){var e=o;var t,a=(t=__nccwpck_require__(477))&&"object"==typeof t&&"default"in t?t.default:t,s=/https?|ftp|gopher|file/;function r(e){"string"==typeof e&&(e=d(e));var t=function(e,t,o){var a=e.auth,s=e.hostname,n=e.protocol||"",p=e.pathname||"",c=e.hash||"",i=e.query||"",u=!1;a=a?encodeURIComponent(a).replace(/%3A/i,":")+"@":"",e.host?u=a+e.host:s&&(u=a+(~s.indexOf(":")?"["+s+"]":s),e.port&&(u+=":"+e.port)),i&&"object"==typeof i&&(i=t.encode(i));var f=e.search||i&&"?"+i||"";return n&&":"!==n.substr(-1)&&(n+=":"),e.slashes||(!n||o.test(n))&&!1!==u?(u="//"+(u||""),p&&"/"!==p[0]&&(p="/"+p)):u||(u=""),c&&"#"!==c[0]&&(c="#"+c),f&&"?"!==f[0]&&(f="?"+f),{protocol:n,host:u,pathname:p=p.replace(/[?#]/g,encodeURIComponent),search:f=f.replace("#","%23"),hash:c}}(e,a,s);return""+t.protocol+t.host+t.pathname+t.search+t.hash}var n="http://",p="w.w",c=n+p,i=/^([a-z0-9.+-]*:\/\/\/)([a-z0-9.+-]:\/*)?/i,u=/https?|ftp|gopher|file/;function h(e,t){var o="string"==typeof e?d(e):e;e="object"==typeof e?r(e):e;var a=d(t),s="";o.protocol&&!o.slashes&&(s=o.protocol,e=e.replace(o.protocol,""),s+="/"===t[0]||"/"===e[0]?"/":""),s&&a.protocol&&(s="",a.slashes||(s=a.protocol,t=t.replace(a.protocol,"")));var p=e.match(i);p&&!a.protocol&&(e=e.substr((s=p[1]+(p[2]||"")).length),/^\/\/[^/]/.test(t)&&(s=s.slice(0,-1)));var f=new URL(e,c+"/"),m=new URL(t,f).toString().replace(c,""),v=a.protocol||o.protocol;return v+=o.slashes||a.slashes?"//":"",!s&&v?m=m.replace(n,v):s&&(m=m.replace(n,"")),u.test(m)||~t.indexOf(".")||"/"===e.slice(-1)||"/"===t.slice(-1)||"/"!==m.slice(-1)||(m=m.slice(0,-1)),s&&(m=s+("/"===m[0]?m.substr(1):m)),m}function l(){}l.prototype.parse=d,l.prototype.format=r,l.prototype.resolve=h,l.prototype.resolveObject=h;var f=/^https?|ftp|gopher|file/,m=/^(.*?)([#?].*)/,v=/^([a-z0-9.+-]*:)(\/{0,3})(.*)/i,_=/^([a-z0-9.+-]*:)?\/\/\/*/i,b=/^([a-z0-9.+-]*:)(\/{0,2})\[(.*)\]$/i;function d(e,t,o){if(void 0===t&&(t=!1),void 0===o&&(o=!1),e&&"object"==typeof e&&e instanceof l)return e;var s=(e=e.trim()).match(m);e=s?s[1].replace(/\\/g,"/")+s[2]:e.replace(/\\/g,"/"),b.test(e)&&"/"!==e.slice(-1)&&(e+="/");var n=!/(^javascript)/.test(e)&&e.match(v),i=_.test(e),u="";n&&(f.test(n[1])||(u=n[1].toLowerCase(),e=""+n[2]+n[3]),n[2]||(i=!1,f.test(n[1])?(u=n[1],e=""+n[3]):e="//"+n[3]),3!==n[2].length&&1!==n[2].length||(u=n[1],e="/"+n[3]));var g,y=(s?s[1]:e).match(/^https?:\/\/[^/]+(:[0-9]+)(?=\/|$)/),w=y&&y[1],C=new l,U="",j="";try{g=new URL(e)}catch(t){U=t,u||o||!/^\/\//.test(e)||/^\/\/.+[@.]/.test(e)||(j="/",e=e.substr(1));try{g=new URL(e,c)}catch(e){return C.protocol=u,C.href=u,C}}C.slashes=i&&!j,C.host=g.host===p?"":g.host,C.hostname=g.hostname===p?"":g.hostname.replace(/(\[|\])/g,""),C.protocol=U?u||null:g.protocol,C.search=g.search.replace(/\\/g,"%5C"),C.hash=g.hash.replace(/\\/g,"%5C");var x=e.split("#");!C.search&&~x[0].indexOf("?")&&(C.search="?"),C.hash||""!==x[1]||(C.hash="#"),C.query=t?a.decode(g.search.substr(1)):C.search.substr(1),C.pathname=j+(n?function(e){return e.replace(/['^|`]/g,(function(e){return"%"+e.charCodeAt().toString(16).toUpperCase()})).replace(/((?:%[0-9A-F]{2})+)/g,(function(e,t){try{return decodeURIComponent(t).split("").map((function(e){var t=e.charCodeAt();return t>256||/^[a-z0-9]$/i.test(e)?e:"%"+t.toString(16).toUpperCase()})).join("")}catch(e){return t}}))}(g.pathname):g.pathname),"about:"===C.protocol&&"blank"===C.pathname&&(C.protocol="",C.pathname=""),U&&"/"!==e[0]&&(C.pathname=C.pathname.substr(1)),u&&!f.test(u)&&"/"!==e.slice(-1)&&"/"===C.pathname&&(C.pathname=""),C.path=C.pathname+C.search,C.auth=[g.username,g.password].map(decodeURIComponent).filter(Boolean).join(":"),C.port=g.port,w&&!C.host.endsWith(w)&&(C.host+=w,C.port=w.slice(1)),C.href=j?""+C.pathname+C.search+C.hash:r(C);var q=/^(file)/.test(C.href)?["host","hostname"]:[];return Object.keys(C).forEach((function(e){~q.indexOf(e)||(C[e]=C[e]||null)})),C}e.parse=d,e.format=r,e.resolve=h,e.resolveObject=function(e,t){return d(h(e,t))},e.Url=l}();module.exports=o})();

/***/ }),

/***/ 73461:
/***/ (function(module) {

var __dirname = "/";
(function(){if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var n={};!function(){var e=n;e.endianness=function(){return"LE"};e.hostname=function(){if(typeof location!=="undefined"){return location.hostname}else return""};e.loadavg=function(){return[]};e.uptime=function(){return 0};e.freemem=function(){return Number.MAX_VALUE};e.totalmem=function(){return Number.MAX_VALUE};e.cpus=function(){return[]};e.type=function(){return"Browser"};e.release=function(){if(typeof navigator!=="undefined"){return navigator.appVersion}return""};e.networkInterfaces=e.getNetworkInterfaces=function(){return{}};e.arch=function(){return"javascript"};e.platform=function(){return"browser"};e.tmpdir=e.tmpDir=function(){return"/tmp"};e.EOL="\n";e.homedir=function(){return"/"}}();module.exports=n})();

/***/ }),

/***/ 1864:
/***/ (function(module) {

var __dirname = "/";
(function(){"use strict";var e={113:function(e){function assertPath(e){if(typeof e!=="string"){throw new TypeError("Path must be a string. Received "+JSON.stringify(e))}}function normalizeStringPosix(e,r){var t="";var i=0;var n=-1;var a=0;var f;for(var l=0;l<=e.length;++l){if(l<e.length)f=e.charCodeAt(l);else if(f===47)break;else f=47;if(f===47){if(n===l-1||a===1){}else if(n!==l-1&&a===2){if(t.length<2||i!==2||t.charCodeAt(t.length-1)!==46||t.charCodeAt(t.length-2)!==46){if(t.length>2){var s=t.lastIndexOf("/");if(s!==t.length-1){if(s===-1){t="";i=0}else{t=t.slice(0,s);i=t.length-1-t.lastIndexOf("/")}n=l;a=0;continue}}else if(t.length===2||t.length===1){t="";i=0;n=l;a=0;continue}}if(r){if(t.length>0)t+="/..";else t="..";i=2}}else{if(t.length>0)t+="/"+e.slice(n+1,l);else t=e.slice(n+1,l);i=l-n-1}n=l;a=0}else if(f===46&&a!==-1){++a}else{a=-1}}return t}function _format(e,r){var t=r.dir||r.root;var i=r.base||(r.name||"")+(r.ext||"");if(!t){return i}if(t===r.root){return t+i}return t+e+i}var r={resolve:function resolve(){var e="";var r=false;var t;for(var i=arguments.length-1;i>=-1&&!r;i--){var n;if(i>=0)n=arguments[i];else{if(t===undefined)t="";n=t}assertPath(n);if(n.length===0){continue}e=n+"/"+e;r=n.charCodeAt(0)===47}e=normalizeStringPosix(e,!r);if(r){if(e.length>0)return"/"+e;else return"/"}else if(e.length>0){return e}else{return"."}},normalize:function normalize(e){assertPath(e);if(e.length===0)return".";var r=e.charCodeAt(0)===47;var t=e.charCodeAt(e.length-1)===47;e=normalizeStringPosix(e,!r);if(e.length===0&&!r)e=".";if(e.length>0&&t)e+="/";if(r)return"/"+e;return e},isAbsolute:function isAbsolute(e){assertPath(e);return e.length>0&&e.charCodeAt(0)===47},join:function join(){if(arguments.length===0)return".";var e;for(var t=0;t<arguments.length;++t){var i=arguments[t];assertPath(i);if(i.length>0){if(e===undefined)e=i;else e+="/"+i}}if(e===undefined)return".";return r.normalize(e)},relative:function relative(e,t){assertPath(e);assertPath(t);if(e===t)return"";e=r.resolve(e);t=r.resolve(t);if(e===t)return"";var i=1;for(;i<e.length;++i){if(e.charCodeAt(i)!==47)break}var n=e.length;var a=n-i;var f=1;for(;f<t.length;++f){if(t.charCodeAt(f)!==47)break}var l=t.length;var s=l-f;var o=a<s?a:s;var u=-1;var h=0;for(;h<=o;++h){if(h===o){if(s>o){if(t.charCodeAt(f+h)===47){return t.slice(f+h+1)}else if(h===0){return t.slice(f+h)}}else if(a>o){if(e.charCodeAt(i+h)===47){u=h}else if(h===0){u=0}}break}var c=e.charCodeAt(i+h);var v=t.charCodeAt(f+h);if(c!==v)break;else if(c===47)u=h}var g="";for(h=i+u+1;h<=n;++h){if(h===n||e.charCodeAt(h)===47){if(g.length===0)g+="..";else g+="/.."}}if(g.length>0)return g+t.slice(f+u);else{f+=u;if(t.charCodeAt(f)===47)++f;return t.slice(f)}},_makeLong:function _makeLong(e){return e},dirname:function dirname(e){assertPath(e);if(e.length===0)return".";var r=e.charCodeAt(0);var t=r===47;var i=-1;var n=true;for(var a=e.length-1;a>=1;--a){r=e.charCodeAt(a);if(r===47){if(!n){i=a;break}}else{n=false}}if(i===-1)return t?"/":".";if(t&&i===1)return"//";return e.slice(0,i)},basename:function basename(e,r){if(r!==undefined&&typeof r!=="string")throw new TypeError('"ext" argument must be a string');assertPath(e);var t=0;var i=-1;var n=true;var a;if(r!==undefined&&r.length>0&&r.length<=e.length){if(r.length===e.length&&r===e)return"";var f=r.length-1;var l=-1;for(a=e.length-1;a>=0;--a){var s=e.charCodeAt(a);if(s===47){if(!n){t=a+1;break}}else{if(l===-1){n=false;l=a+1}if(f>=0){if(s===r.charCodeAt(f)){if(--f===-1){i=a}}else{f=-1;i=l}}}}if(t===i)i=l;else if(i===-1)i=e.length;return e.slice(t,i)}else{for(a=e.length-1;a>=0;--a){if(e.charCodeAt(a)===47){if(!n){t=a+1;break}}else if(i===-1){n=false;i=a+1}}if(i===-1)return"";return e.slice(t,i)}},extname:function extname(e){assertPath(e);var r=-1;var t=0;var i=-1;var n=true;var a=0;for(var f=e.length-1;f>=0;--f){var l=e.charCodeAt(f);if(l===47){if(!n){t=f+1;break}continue}if(i===-1){n=false;i=f+1}if(l===46){if(r===-1)r=f;else if(a!==1)a=1}else if(r!==-1){a=-1}}if(r===-1||i===-1||a===0||a===1&&r===i-1&&r===t+1){return""}return e.slice(r,i)},format:function format(e){if(e===null||typeof e!=="object"){throw new TypeError('The "pathObject" argument must be of type Object. Received type '+typeof e)}return _format("/",e)},parse:function parse(e){assertPath(e);var r={root:"",dir:"",base:"",ext:"",name:""};if(e.length===0)return r;var t=e.charCodeAt(0);var i=t===47;var n;if(i){r.root="/";n=1}else{n=0}var a=-1;var f=0;var l=-1;var s=true;var o=e.length-1;var u=0;for(;o>=n;--o){t=e.charCodeAt(o);if(t===47){if(!s){f=o+1;break}continue}if(l===-1){s=false;l=o+1}if(t===46){if(a===-1)a=o;else if(u!==1)u=1}else if(a!==-1){u=-1}}if(a===-1||l===-1||u===0||u===1&&a===l-1&&a===f+1){if(l!==-1){if(f===0&&i)r.base=r.name=e.slice(1,l);else r.base=r.name=e.slice(f,l)}}else{if(f===0&&i){r.name=e.slice(1,a);r.base=e.slice(1,l)}else{r.name=e.slice(f,a);r.base=e.slice(f,l)}r.ext=e.slice(a,l)}if(f>0)r.dir=e.slice(0,f-1);else if(i)r.dir="/";return r},sep:"/",delimiter:":",win32:null,posix:null};r.posix=r;e.exports=r}};var r={};function __nccwpck_require__(t){var i=r[t];if(i!==undefined){return i.exports}var n=r[t]={exports:{}};var a=true;try{e[t](n,n.exports,__nccwpck_require__);a=false}finally{if(a)delete r[t]}return n.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(113);module.exports=t})();

/***/ }),

/***/ 77663:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={308:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(308);module.exports=r})();

/***/ }),

/***/ 97334:
/***/ (function(module) {

var __dirname = "/";
(function(){"use strict";var e={721:function(e){function hasOwnProperty(e,r){return Object.prototype.hasOwnProperty.call(e,r)}e.exports=function(e,n,t,o){n=n||"&";t=t||"=";var a={};if(typeof e!=="string"||e.length===0){return a}var i=/\+/g;e=e.split(n);var u=1e3;if(o&&typeof o.maxKeys==="number"){u=o.maxKeys}var c=e.length;if(u>0&&c>u){c=u}for(var p=0;p<c;++p){var f=e[p].replace(i,"%20"),s=f.indexOf(t),_,l,y,d;if(s>=0){_=f.substr(0,s);l=f.substr(s+1)}else{_=f;l=""}y=decodeURIComponent(_);d=decodeURIComponent(l);if(!hasOwnProperty(a,y)){a[y]=d}else if(r(a[y])){a[y].push(d)}else{a[y]=[a[y],d]}}return a};var r=Array.isArray||function(e){return Object.prototype.toString.call(e)==="[object Array]"}},850:function(e){var stringifyPrimitive=function(e){switch(typeof e){case"string":return e;case"boolean":return e?"true":"false";case"number":return isFinite(e)?e:"";default:return""}};e.exports=function(e,t,o,a){t=t||"&";o=o||"=";if(e===null){e=undefined}if(typeof e==="object"){return map(n(e),(function(n){var a=encodeURIComponent(stringifyPrimitive(n))+o;if(r(e[n])){return map(e[n],(function(e){return a+encodeURIComponent(stringifyPrimitive(e))})).join(t)}else{return a+encodeURIComponent(stringifyPrimitive(e[n]))}})).join(t)}if(!a)return"";return encodeURIComponent(stringifyPrimitive(a))+o+encodeURIComponent(stringifyPrimitive(e))};var r=Array.isArray||function(e){return Object.prototype.toString.call(e)==="[object Array]"};function map(e,r){if(e.map)return e.map(r);var n=[];for(var t=0;t<e.length;t++){n.push(r(e[t],t))}return n}var n=Object.keys||function(e){var r=[];for(var n in e){if(Object.prototype.hasOwnProperty.call(e,n))r.push(n)}return r}}};var r={};function __nccwpck_require__(n){var t=r[n];if(t!==undefined){return t.exports}var o=r[n]={exports:{}};var a=true;try{e[n](o,o.exports,__nccwpck_require__);a=false}finally{if(a)delete r[n]}return o.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var n={};!function(){var e=n;e.decode=e.parse=__nccwpck_require__(721);e.encode=e.stringify=__nccwpck_require__(850)}();module.exports=n})();

/***/ }),

/***/ 79681:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var process = __webpack_require__(83454);
(function(){var e={140:function(e){if(typeof Object.create==="function"){e.exports=function inherits(e,t){if(t){e.super_=t;e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:false,writable:true,configurable:true}})}}}else{e.exports=function inherits(e,t){if(t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}}}},349:function(e){"use strict";const t={};function createErrorType(e,r,n){if(!n){n=Error}function getMessage(e,t,n){if(typeof r==="string"){return r}else{return r(e,t,n)}}class NodeError extends n{constructor(e,t,r){super(getMessage(e,t,r))}}NodeError.prototype.name=n.name;NodeError.prototype.code=e;t[e]=NodeError}function oneOf(e,t){if(Array.isArray(e)){const r=e.length;e=e.map((e=>String(e)));if(r>2){return`one of ${t} ${e.slice(0,r-1).join(", ")}, or `+e[r-1]}else if(r===2){return`one of ${t} ${e[0]} or ${e[1]}`}else{return`of ${t} ${e[0]}`}}else{return`of ${t} ${String(e)}`}}function startsWith(e,t,r){return e.substr(!r||r<0?0:+r,t.length)===t}function endsWith(e,t,r){if(r===undefined||r>e.length){r=e.length}return e.substring(r-t.length,r)===t}function includes(e,t,r){if(typeof r!=="number"){r=0}if(r+t.length>e.length){return false}else{return e.indexOf(t,r)!==-1}}createErrorType("ERR_INVALID_OPT_VALUE",(function(e,t){return'The value "'+t+'" is invalid for option "'+e+'"'}),TypeError);createErrorType("ERR_INVALID_ARG_TYPE",(function(e,t,r){let n;if(typeof t==="string"&&startsWith(t,"not ")){n="must not be";t=t.replace(/^not /,"")}else{n="must be"}let i;if(endsWith(e," argument")){i=`The ${e} ${n} ${oneOf(t,"type")}`}else{const r=includes(e,".")?"property":"argument";i=`The "${e}" ${r} ${n} ${oneOf(t,"type")}`}i+=`. Received type ${typeof r}`;return i}),TypeError);createErrorType("ERR_STREAM_PUSH_AFTER_EOF","stream.push() after EOF");createErrorType("ERR_METHOD_NOT_IMPLEMENTED",(function(e){return"The "+e+" method is not implemented"}));createErrorType("ERR_STREAM_PREMATURE_CLOSE","Premature close");createErrorType("ERR_STREAM_DESTROYED",(function(e){return"Cannot call "+e+" after a stream was destroyed"}));createErrorType("ERR_MULTIPLE_CALLBACK","Callback called multiple times");createErrorType("ERR_STREAM_CANNOT_PIPE","Cannot pipe, not readable");createErrorType("ERR_STREAM_WRITE_AFTER_END","write after end");createErrorType("ERR_STREAM_NULL_VALUES","May not write null values to stream",TypeError);createErrorType("ERR_UNKNOWN_ENCODING",(function(e){return"Unknown encoding: "+e}),TypeError);createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT","stream.unshift() after end event");e.exports.q=t},716:function(e,t,r){"use strict";var n=Object.keys||function(e){var t=[];for(var r in e){t.push(r)}return t};e.exports=Duplex;var i=r(787);var a=r(513);r(140)(Duplex,i);{var o=n(a.prototype);for(var s=0;s<o.length;s++){var f=o[s];if(!Duplex.prototype[f])Duplex.prototype[f]=a.prototype[f]}}function Duplex(e){if(!(this instanceof Duplex))return new Duplex(e);i.call(this,e);a.call(this,e);this.allowHalfOpen=true;if(e){if(e.readable===false)this.readable=false;if(e.writable===false)this.writable=false;if(e.allowHalfOpen===false){this.allowHalfOpen=false;this.once("end",onend)}}}Object.defineProperty(Duplex.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});Object.defineProperty(Duplex.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});Object.defineProperty(Duplex.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function onend(){if(this._writableState.ended)return;process.nextTick(onEndNT,this)}function onEndNT(e){e.end()}Object.defineProperty(Duplex.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined||this._writableState===undefined){return false}return this._readableState.destroyed&&this._writableState.destroyed},set:function set(e){if(this._readableState===undefined||this._writableState===undefined){return}this._readableState.destroyed=e;this._writableState.destroyed=e}})},788:function(e,t,r){"use strict";e.exports=PassThrough;var n=r(551);r(140)(PassThrough,n);function PassThrough(e){if(!(this instanceof PassThrough))return new PassThrough(e);n.call(this,e)}PassThrough.prototype._transform=function(e,t,r){r(null,e)}},787:function(e,t,r){"use strict";e.exports=Readable;var n;Readable.ReadableState=ReadableState;var i=r(361).EventEmitter;var a=function EElistenerCount(e,t){return e.listeners(t).length};var o=r(455);var s=r(300).Buffer;var f=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return s.from(e)}function _isUint8Array(e){return s.isBuffer(e)||e instanceof f}var l=r(837);var u;if(l&&l.debuglog){u=l.debuglog("stream")}else{u=function debug(){}}var d=r(41);var c=r(289);var h=r(483),p=h.getHighWaterMark;var b=r(349).q,g=b.ERR_INVALID_ARG_TYPE,y=b.ERR_STREAM_PUSH_AFTER_EOF,_=b.ERR_METHOD_NOT_IMPLEMENTED,v=b.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;var w;var m;var S;r(140)(Readable,o);var R=c.errorOrDestroy;var E=["error","close","destroy","pause","resume"];function prependListener(e,t,r){if(typeof e.prependListener==="function")return e.prependListener(t,r);if(!e._events||!e._events[t])e.on(t,r);else if(Array.isArray(e._events[t]))e._events[t].unshift(r);else e._events[t]=[r,e._events[t]]}function ReadableState(e,t,i){n=n||r(716);e=e||{};if(typeof i!=="boolean")i=t instanceof n;this.objectMode=!!e.objectMode;if(i)this.objectMode=this.objectMode||!!e.readableObjectMode;this.highWaterMark=p(this,e,"readableHighWaterMark",i);this.buffer=new d;this.length=0;this.pipes=null;this.pipesCount=0;this.flowing=null;this.ended=false;this.endEmitted=false;this.reading=false;this.sync=true;this.needReadable=false;this.emittedReadable=false;this.readableListening=false;this.resumeScheduled=false;this.paused=true;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.destroyed=false;this.defaultEncoding=e.defaultEncoding||"utf8";this.awaitDrain=0;this.readingMore=false;this.decoder=null;this.encoding=null;if(e.encoding){if(!w)w=r(862).s;this.decoder=new w(e.encoding);this.encoding=e.encoding}}function Readable(e){n=n||r(716);if(!(this instanceof Readable))return new Readable(e);var t=this instanceof n;this._readableState=new ReadableState(e,this,t);this.readable=true;if(e){if(typeof e.read==="function")this._read=e.read;if(typeof e.destroy==="function")this._destroy=e.destroy}o.call(this)}Object.defineProperty(Readable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined){return false}return this._readableState.destroyed},set:function set(e){if(!this._readableState){return}this._readableState.destroyed=e}});Readable.prototype.destroy=c.destroy;Readable.prototype._undestroy=c.undestroy;Readable.prototype._destroy=function(e,t){t(e)};Readable.prototype.push=function(e,t){var r=this._readableState;var n;if(!r.objectMode){if(typeof e==="string"){t=t||r.defaultEncoding;if(t!==r.encoding){e=s.from(e,t);t=""}n=true}}else{n=true}return readableAddChunk(this,e,t,false,n)};Readable.prototype.unshift=function(e){return readableAddChunk(this,e,null,true,false)};function readableAddChunk(e,t,r,n,i){u("readableAddChunk",t);var a=e._readableState;if(t===null){a.reading=false;onEofChunk(e,a)}else{var o;if(!i)o=chunkInvalid(a,t);if(o){R(e,o)}else if(a.objectMode||t&&t.length>0){if(typeof t!=="string"&&!a.objectMode&&Object.getPrototypeOf(t)!==s.prototype){t=_uint8ArrayToBuffer(t)}if(n){if(a.endEmitted)R(e,new v);else addChunk(e,a,t,true)}else if(a.ended){R(e,new y)}else if(a.destroyed){return false}else{a.reading=false;if(a.decoder&&!r){t=a.decoder.write(t);if(a.objectMode||t.length!==0)addChunk(e,a,t,false);else maybeReadMore(e,a)}else{addChunk(e,a,t,false)}}}else if(!n){a.reading=false;maybeReadMore(e,a)}}return!a.ended&&(a.length<a.highWaterMark||a.length===0)}function addChunk(e,t,r,n){if(t.flowing&&t.length===0&&!t.sync){t.awaitDrain=0;e.emit("data",r)}else{t.length+=t.objectMode?1:r.length;if(n)t.buffer.unshift(r);else t.buffer.push(r);if(t.needReadable)emitReadable(e)}maybeReadMore(e,t)}function chunkInvalid(e,t){var r;if(!_isUint8Array(t)&&typeof t!=="string"&&t!==undefined&&!e.objectMode){r=new g("chunk",["string","Buffer","Uint8Array"],t)}return r}Readable.prototype.isPaused=function(){return this._readableState.flowing===false};Readable.prototype.setEncoding=function(e){if(!w)w=r(862).s;var t=new w(e);this._readableState.decoder=t;this._readableState.encoding=this._readableState.decoder.encoding;var n=this._readableState.buffer.head;var i="";while(n!==null){i+=t.write(n.data);n=n.next}this._readableState.buffer.clear();if(i!=="")this._readableState.buffer.push(i);this._readableState.length=i.length;return this};var T=1073741824;function computeNewHighWaterMark(e){if(e>=T){e=T}else{e--;e|=e>>>1;e|=e>>>2;e|=e>>>4;e|=e>>>8;e|=e>>>16;e++}return e}function howMuchToRead(e,t){if(e<=0||t.length===0&&t.ended)return 0;if(t.objectMode)return 1;if(e!==e){if(t.flowing&&t.length)return t.buffer.head.data.length;else return t.length}if(e>t.highWaterMark)t.highWaterMark=computeNewHighWaterMark(e);if(e<=t.length)return e;if(!t.ended){t.needReadable=true;return 0}return t.length}Readable.prototype.read=function(e){u("read",e);e=parseInt(e,10);var t=this._readableState;var r=e;if(e!==0)t.emittedReadable=false;if(e===0&&t.needReadable&&((t.highWaterMark!==0?t.length>=t.highWaterMark:t.length>0)||t.ended)){u("read: emitReadable",t.length,t.ended);if(t.length===0&&t.ended)endReadable(this);else emitReadable(this);return null}e=howMuchToRead(e,t);if(e===0&&t.ended){if(t.length===0)endReadable(this);return null}var n=t.needReadable;u("need readable",n);if(t.length===0||t.length-e<t.highWaterMark){n=true;u("length less than watermark",n)}if(t.ended||t.reading){n=false;u("reading or ended",n)}else if(n){u("do read");t.reading=true;t.sync=true;if(t.length===0)t.needReadable=true;this._read(t.highWaterMark);t.sync=false;if(!t.reading)e=howMuchToRead(r,t)}var i;if(e>0)i=fromList(e,t);else i=null;if(i===null){t.needReadable=t.length<=t.highWaterMark;e=0}else{t.length-=e;t.awaitDrain=0}if(t.length===0){if(!t.ended)t.needReadable=true;if(r!==e&&t.ended)endReadable(this)}if(i!==null)this.emit("data",i);return i};function onEofChunk(e,t){u("onEofChunk");if(t.ended)return;if(t.decoder){var r=t.decoder.end();if(r&&r.length){t.buffer.push(r);t.length+=t.objectMode?1:r.length}}t.ended=true;if(t.sync){emitReadable(e)}else{t.needReadable=false;if(!t.emittedReadable){t.emittedReadable=true;emitReadable_(e)}}}function emitReadable(e){var t=e._readableState;u("emitReadable",t.needReadable,t.emittedReadable);t.needReadable=false;if(!t.emittedReadable){u("emitReadable",t.flowing);t.emittedReadable=true;process.nextTick(emitReadable_,e)}}function emitReadable_(e){var t=e._readableState;u("emitReadable_",t.destroyed,t.length,t.ended);if(!t.destroyed&&(t.length||t.ended)){e.emit("readable");t.emittedReadable=false}t.needReadable=!t.flowing&&!t.ended&&t.length<=t.highWaterMark;flow(e)}function maybeReadMore(e,t){if(!t.readingMore){t.readingMore=true;process.nextTick(maybeReadMore_,e,t)}}function maybeReadMore_(e,t){while(!t.reading&&!t.ended&&(t.length<t.highWaterMark||t.flowing&&t.length===0)){var r=t.length;u("maybeReadMore read 0");e.read(0);if(r===t.length)break}t.readingMore=false}Readable.prototype._read=function(e){R(this,new _("_read()"))};Readable.prototype.pipe=function(e,t){var r=this;var n=this._readableState;switch(n.pipesCount){case 0:n.pipes=e;break;case 1:n.pipes=[n.pipes,e];break;default:n.pipes.push(e);break}n.pipesCount+=1;u("pipe count=%d opts=%j",n.pipesCount,t);var i=(!t||t.end!==false)&&e!==process.stdout&&e!==process.stderr;var o=i?onend:unpipe;if(n.endEmitted)process.nextTick(o);else r.once("end",o);e.on("unpipe",onunpipe);function onunpipe(e,t){u("onunpipe");if(e===r){if(t&&t.hasUnpiped===false){t.hasUnpiped=true;cleanup()}}}function onend(){u("onend");e.end()}var s=pipeOnDrain(r);e.on("drain",s);var f=false;function cleanup(){u("cleanup");e.removeListener("close",onclose);e.removeListener("finish",onfinish);e.removeListener("drain",s);e.removeListener("error",onerror);e.removeListener("unpipe",onunpipe);r.removeListener("end",onend);r.removeListener("end",unpipe);r.removeListener("data",ondata);f=true;if(n.awaitDrain&&(!e._writableState||e._writableState.needDrain))s()}r.on("data",ondata);function ondata(t){u("ondata");var i=e.write(t);u("dest.write",i);if(i===false){if((n.pipesCount===1&&n.pipes===e||n.pipesCount>1&&indexOf(n.pipes,e)!==-1)&&!f){u("false write response, pause",n.awaitDrain);n.awaitDrain++}r.pause()}}function onerror(t){u("onerror",t);unpipe();e.removeListener("error",onerror);if(a(e,"error")===0)R(e,t)}prependListener(e,"error",onerror);function onclose(){e.removeListener("finish",onfinish);unpipe()}e.once("close",onclose);function onfinish(){u("onfinish");e.removeListener("close",onclose);unpipe()}e.once("finish",onfinish);function unpipe(){u("unpipe");r.unpipe(e)}e.emit("pipe",r);if(!n.flowing){u("pipe resume");r.resume()}return e};function pipeOnDrain(e){return function pipeOnDrainFunctionResult(){var t=e._readableState;u("pipeOnDrain",t.awaitDrain);if(t.awaitDrain)t.awaitDrain--;if(t.awaitDrain===0&&a(e,"data")){t.flowing=true;flow(e)}}}Readable.prototype.unpipe=function(e){var t=this._readableState;var r={hasUnpiped:false};if(t.pipesCount===0)return this;if(t.pipesCount===1){if(e&&e!==t.pipes)return this;if(!e)e=t.pipes;t.pipes=null;t.pipesCount=0;t.flowing=false;if(e)e.emit("unpipe",this,r);return this}if(!e){var n=t.pipes;var i=t.pipesCount;t.pipes=null;t.pipesCount=0;t.flowing=false;for(var a=0;a<i;a++){n[a].emit("unpipe",this,{hasUnpiped:false})}return this}var o=indexOf(t.pipes,e);if(o===-1)return this;t.pipes.splice(o,1);t.pipesCount-=1;if(t.pipesCount===1)t.pipes=t.pipes[0];e.emit("unpipe",this,r);return this};Readable.prototype.on=function(e,t){var r=o.prototype.on.call(this,e,t);var n=this._readableState;if(e==="data"){n.readableListening=this.listenerCount("readable")>0;if(n.flowing!==false)this.resume()}else if(e==="readable"){if(!n.endEmitted&&!n.readableListening){n.readableListening=n.needReadable=true;n.flowing=false;n.emittedReadable=false;u("on readable",n.length,n.reading);if(n.length){emitReadable(this)}else if(!n.reading){process.nextTick(nReadingNextTick,this)}}}return r};Readable.prototype.addListener=Readable.prototype.on;Readable.prototype.removeListener=function(e,t){var r=o.prototype.removeListener.call(this,e,t);if(e==="readable"){process.nextTick(updateReadableListening,this)}return r};Readable.prototype.removeAllListeners=function(e){var t=o.prototype.removeAllListeners.apply(this,arguments);if(e==="readable"||e===undefined){process.nextTick(updateReadableListening,this)}return t};function updateReadableListening(e){var t=e._readableState;t.readableListening=e.listenerCount("readable")>0;if(t.resumeScheduled&&!t.paused){t.flowing=true}else if(e.listenerCount("data")>0){e.resume()}}function nReadingNextTick(e){u("readable nexttick read 0");e.read(0)}Readable.prototype.resume=function(){var e=this._readableState;if(!e.flowing){u("resume");e.flowing=!e.readableListening;resume(this,e)}e.paused=false;return this};function resume(e,t){if(!t.resumeScheduled){t.resumeScheduled=true;process.nextTick(resume_,e,t)}}function resume_(e,t){u("resume",t.reading);if(!t.reading){e.read(0)}t.resumeScheduled=false;e.emit("resume");flow(e);if(t.flowing&&!t.reading)e.read(0)}Readable.prototype.pause=function(){u("call pause flowing=%j",this._readableState.flowing);if(this._readableState.flowing!==false){u("pause");this._readableState.flowing=false;this.emit("pause")}this._readableState.paused=true;return this};function flow(e){var t=e._readableState;u("flow",t.flowing);while(t.flowing&&e.read()!==null){}}Readable.prototype.wrap=function(e){var t=this;var r=this._readableState;var n=false;e.on("end",(function(){u("wrapped end");if(r.decoder&&!r.ended){var e=r.decoder.end();if(e&&e.length)t.push(e)}t.push(null)}));e.on("data",(function(i){u("wrapped data");if(r.decoder)i=r.decoder.write(i);if(r.objectMode&&(i===null||i===undefined))return;else if(!r.objectMode&&(!i||!i.length))return;var a=t.push(i);if(!a){n=true;e.pause()}}));for(var i in e){if(this[i]===undefined&&typeof e[i]==="function"){this[i]=function methodWrap(t){return function methodWrapReturnFunction(){return e[t].apply(e,arguments)}}(i)}}for(var a=0;a<E.length;a++){e.on(E[a],this.emit.bind(this,E[a]))}this._read=function(t){u("wrapped _read",t);if(n){n=false;e.resume()}};return this};if(typeof Symbol==="function"){Readable.prototype[Symbol.asyncIterator]=function(){if(m===undefined){m=r(224)}return m(this)}}Object.defineProperty(Readable.prototype,"readableHighWaterMark",{enumerable:false,get:function get(){return this._readableState.highWaterMark}});Object.defineProperty(Readable.prototype,"readableBuffer",{enumerable:false,get:function get(){return this._readableState&&this._readableState.buffer}});Object.defineProperty(Readable.prototype,"readableFlowing",{enumerable:false,get:function get(){return this._readableState.flowing},set:function set(e){if(this._readableState){this._readableState.flowing=e}}});Readable._fromList=fromList;Object.defineProperty(Readable.prototype,"readableLength",{enumerable:false,get:function get(){return this._readableState.length}});function fromList(e,t){if(t.length===0)return null;var r;if(t.objectMode)r=t.buffer.shift();else if(!e||e>=t.length){if(t.decoder)r=t.buffer.join("");else if(t.buffer.length===1)r=t.buffer.first();else r=t.buffer.concat(t.length);t.buffer.clear()}else{r=t.buffer.consume(e,t.decoder)}return r}function endReadable(e){var t=e._readableState;u("endReadable",t.endEmitted);if(!t.endEmitted){t.ended=true;process.nextTick(endReadableNT,t,e)}}function endReadableNT(e,t){u("endReadableNT",e.endEmitted,e.length);if(!e.endEmitted&&e.length===0){e.endEmitted=true;t.readable=false;t.emit("end");if(e.autoDestroy){var r=t._writableState;if(!r||r.autoDestroy&&r.finished){t.destroy()}}}}if(typeof Symbol==="function"){Readable.from=function(e,t){if(S===undefined){S=r(720)}return S(Readable,e,t)}}function indexOf(e,t){for(var r=0,n=e.length;r<n;r++){if(e[r]===t)return r}return-1}},551:function(e,t,r){"use strict";e.exports=Transform;var n=r(349).q,i=n.ERR_METHOD_NOT_IMPLEMENTED,a=n.ERR_MULTIPLE_CALLBACK,o=n.ERR_TRANSFORM_ALREADY_TRANSFORMING,s=n.ERR_TRANSFORM_WITH_LENGTH_0;var f=r(716);r(140)(Transform,f);function afterTransform(e,t){var r=this._transformState;r.transforming=false;var n=r.writecb;if(n===null){return this.emit("error",new a)}r.writechunk=null;r.writecb=null;if(t!=null)this.push(t);n(e);var i=this._readableState;i.reading=false;if(i.needReadable||i.length<i.highWaterMark){this._read(i.highWaterMark)}}function Transform(e){if(!(this instanceof Transform))return new Transform(e);f.call(this,e);this._transformState={afterTransform:afterTransform.bind(this),needTransform:false,transforming:false,writecb:null,writechunk:null,writeencoding:null};this._readableState.needReadable=true;this._readableState.sync=false;if(e){if(typeof e.transform==="function")this._transform=e.transform;if(typeof e.flush==="function")this._flush=e.flush}this.on("prefinish",prefinish)}function prefinish(){var e=this;if(typeof this._flush==="function"&&!this._readableState.destroyed){this._flush((function(t,r){done(e,t,r)}))}else{done(this,null,null)}}Transform.prototype.push=function(e,t){this._transformState.needTransform=false;return f.prototype.push.call(this,e,t)};Transform.prototype._transform=function(e,t,r){r(new i("_transform()"))};Transform.prototype._write=function(e,t,r){var n=this._transformState;n.writecb=r;n.writechunk=e;n.writeencoding=t;if(!n.transforming){var i=this._readableState;if(n.needTransform||i.needReadable||i.length<i.highWaterMark)this._read(i.highWaterMark)}};Transform.prototype._read=function(e){var t=this._transformState;if(t.writechunk!==null&&!t.transforming){t.transforming=true;this._transform(t.writechunk,t.writeencoding,t.afterTransform)}else{t.needTransform=true}};Transform.prototype._destroy=function(e,t){f.prototype._destroy.call(this,e,(function(e){t(e)}))};function done(e,t,r){if(t)return e.emit("error",t);if(r!=null)e.push(r);if(e._writableState.length)throw new s;if(e._transformState.transforming)throw new o;return e.push(null)}},513:function(e,t,r){"use strict";e.exports=Writable;function WriteReq(e,t,r){this.chunk=e;this.encoding=t;this.callback=r;this.next=null}function CorkedRequest(e){var t=this;this.next=null;this.entry=null;this.finish=function(){onCorkedFinish(t,e)}}var n;Writable.WritableState=WritableState;var i={deprecate:r(777)};var a=r(455);var o=r(300).Buffer;var s=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return o.from(e)}function _isUint8Array(e){return o.isBuffer(e)||e instanceof s}var f=r(289);var l=r(483),u=l.getHighWaterMark;var d=r(349).q,c=d.ERR_INVALID_ARG_TYPE,h=d.ERR_METHOD_NOT_IMPLEMENTED,p=d.ERR_MULTIPLE_CALLBACK,b=d.ERR_STREAM_CANNOT_PIPE,g=d.ERR_STREAM_DESTROYED,y=d.ERR_STREAM_NULL_VALUES,_=d.ERR_STREAM_WRITE_AFTER_END,v=d.ERR_UNKNOWN_ENCODING;var w=f.errorOrDestroy;r(140)(Writable,a);function nop(){}function WritableState(e,t,i){n=n||r(716);e=e||{};if(typeof i!=="boolean")i=t instanceof n;this.objectMode=!!e.objectMode;if(i)this.objectMode=this.objectMode||!!e.writableObjectMode;this.highWaterMark=u(this,e,"writableHighWaterMark",i);this.finalCalled=false;this.needDrain=false;this.ending=false;this.ended=false;this.finished=false;this.destroyed=false;var a=e.decodeStrings===false;this.decodeStrings=!a;this.defaultEncoding=e.defaultEncoding||"utf8";this.length=0;this.writing=false;this.corked=0;this.sync=true;this.bufferProcessing=false;this.onwrite=function(e){onwrite(t,e)};this.writecb=null;this.writelen=0;this.bufferedRequest=null;this.lastBufferedRequest=null;this.pendingcb=0;this.prefinished=false;this.errorEmitted=false;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.bufferedRequestCount=0;this.corkedRequestsFree=new CorkedRequest(this)}WritableState.prototype.getBuffer=function getBuffer(){var e=this.bufferedRequest;var t=[];while(e){t.push(e);e=e.next}return t};(function(){try{Object.defineProperty(WritableState.prototype,"buffer",{get:i.deprecate((function writableStateBufferGetter(){return this.getBuffer()}),"_writableState.buffer is deprecated. Use _writableState.getBuffer "+"instead.","DEP0003")})}catch(e){}})();var m;if(typeof Symbol==="function"&&Symbol.hasInstance&&typeof Function.prototype[Symbol.hasInstance]==="function"){m=Function.prototype[Symbol.hasInstance];Object.defineProperty(Writable,Symbol.hasInstance,{value:function value(e){if(m.call(this,e))return true;if(this!==Writable)return false;return e&&e._writableState instanceof WritableState}})}else{m=function realHasInstance(e){return e instanceof this}}function Writable(e){n=n||r(716);var t=this instanceof n;if(!t&&!m.call(Writable,this))return new Writable(e);this._writableState=new WritableState(e,this,t);this.writable=true;if(e){if(typeof e.write==="function")this._write=e.write;if(typeof e.writev==="function")this._writev=e.writev;if(typeof e.destroy==="function")this._destroy=e.destroy;if(typeof e.final==="function")this._final=e.final}a.call(this)}Writable.prototype.pipe=function(){w(this,new b)};function writeAfterEnd(e,t){var r=new _;w(e,r);process.nextTick(t,r)}function validChunk(e,t,r,n){var i;if(r===null){i=new y}else if(typeof r!=="string"&&!t.objectMode){i=new c("chunk",["string","Buffer"],r)}if(i){w(e,i);process.nextTick(n,i);return false}return true}Writable.prototype.write=function(e,t,r){var n=this._writableState;var i=false;var a=!n.objectMode&&_isUint8Array(e);if(a&&!o.isBuffer(e)){e=_uint8ArrayToBuffer(e)}if(typeof t==="function"){r=t;t=null}if(a)t="buffer";else if(!t)t=n.defaultEncoding;if(typeof r!=="function")r=nop;if(n.ending)writeAfterEnd(this,r);else if(a||validChunk(this,n,e,r)){n.pendingcb++;i=writeOrBuffer(this,n,a,e,t,r)}return i};Writable.prototype.cork=function(){this._writableState.corked++};Writable.prototype.uncork=function(){var e=this._writableState;if(e.corked){e.corked--;if(!e.writing&&!e.corked&&!e.bufferProcessing&&e.bufferedRequest)clearBuffer(this,e)}};Writable.prototype.setDefaultEncoding=function setDefaultEncoding(e){if(typeof e==="string")e=e.toLowerCase();if(!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((e+"").toLowerCase())>-1))throw new v(e);this._writableState.defaultEncoding=e;return this};Object.defineProperty(Writable.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});function decodeChunk(e,t,r){if(!e.objectMode&&e.decodeStrings!==false&&typeof t==="string"){t=o.from(t,r)}return t}Object.defineProperty(Writable.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});function writeOrBuffer(e,t,r,n,i,a){if(!r){var o=decodeChunk(t,n,i);if(n!==o){r=true;i="buffer";n=o}}var s=t.objectMode?1:n.length;t.length+=s;var f=t.length<t.highWaterMark;if(!f)t.needDrain=true;if(t.writing||t.corked){var l=t.lastBufferedRequest;t.lastBufferedRequest={chunk:n,encoding:i,isBuf:r,callback:a,next:null};if(l){l.next=t.lastBufferedRequest}else{t.bufferedRequest=t.lastBufferedRequest}t.bufferedRequestCount+=1}else{doWrite(e,t,false,s,n,i,a)}return f}function doWrite(e,t,r,n,i,a,o){t.writelen=n;t.writecb=o;t.writing=true;t.sync=true;if(t.destroyed)t.onwrite(new g("write"));else if(r)e._writev(i,t.onwrite);else e._write(i,a,t.onwrite);t.sync=false}function onwriteError(e,t,r,n,i){--t.pendingcb;if(r){process.nextTick(i,n);process.nextTick(finishMaybe,e,t);e._writableState.errorEmitted=true;w(e,n)}else{i(n);e._writableState.errorEmitted=true;w(e,n);finishMaybe(e,t)}}function onwriteStateUpdate(e){e.writing=false;e.writecb=null;e.length-=e.writelen;e.writelen=0}function onwrite(e,t){var r=e._writableState;var n=r.sync;var i=r.writecb;if(typeof i!=="function")throw new p;onwriteStateUpdate(r);if(t)onwriteError(e,r,n,t,i);else{var a=needFinish(r)||e.destroyed;if(!a&&!r.corked&&!r.bufferProcessing&&r.bufferedRequest){clearBuffer(e,r)}if(n){process.nextTick(afterWrite,e,r,a,i)}else{afterWrite(e,r,a,i)}}}function afterWrite(e,t,r,n){if(!r)onwriteDrain(e,t);t.pendingcb--;n();finishMaybe(e,t)}function onwriteDrain(e,t){if(t.length===0&&t.needDrain){t.needDrain=false;e.emit("drain")}}function clearBuffer(e,t){t.bufferProcessing=true;var r=t.bufferedRequest;if(e._writev&&r&&r.next){var n=t.bufferedRequestCount;var i=new Array(n);var a=t.corkedRequestsFree;a.entry=r;var o=0;var s=true;while(r){i[o]=r;if(!r.isBuf)s=false;r=r.next;o+=1}i.allBuffers=s;doWrite(e,t,true,t.length,i,"",a.finish);t.pendingcb++;t.lastBufferedRequest=null;if(a.next){t.corkedRequestsFree=a.next;a.next=null}else{t.corkedRequestsFree=new CorkedRequest(t)}t.bufferedRequestCount=0}else{while(r){var f=r.chunk;var l=r.encoding;var u=r.callback;var d=t.objectMode?1:f.length;doWrite(e,t,false,d,f,l,u);r=r.next;t.bufferedRequestCount--;if(t.writing){break}}if(r===null)t.lastBufferedRequest=null}t.bufferedRequest=r;t.bufferProcessing=false}Writable.prototype._write=function(e,t,r){r(new h("_write()"))};Writable.prototype._writev=null;Writable.prototype.end=function(e,t,r){var n=this._writableState;if(typeof e==="function"){r=e;e=null;t=null}else if(typeof t==="function"){r=t;t=null}if(e!==null&&e!==undefined)this.write(e,t);if(n.corked){n.corked=1;this.uncork()}if(!n.ending)endWritable(this,n,r);return this};Object.defineProperty(Writable.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function needFinish(e){return e.ending&&e.length===0&&e.bufferedRequest===null&&!e.finished&&!e.writing}function callFinal(e,t){e._final((function(r){t.pendingcb--;if(r){w(e,r)}t.prefinished=true;e.emit("prefinish");finishMaybe(e,t)}))}function prefinish(e,t){if(!t.prefinished&&!t.finalCalled){if(typeof e._final==="function"&&!t.destroyed){t.pendingcb++;t.finalCalled=true;process.nextTick(callFinal,e,t)}else{t.prefinished=true;e.emit("prefinish")}}}function finishMaybe(e,t){var r=needFinish(t);if(r){prefinish(e,t);if(t.pendingcb===0){t.finished=true;e.emit("finish");if(t.autoDestroy){var n=e._readableState;if(!n||n.autoDestroy&&n.endEmitted){e.destroy()}}}}return r}function endWritable(e,t,r){t.ending=true;finishMaybe(e,t);if(r){if(t.finished)process.nextTick(r);else e.once("finish",r)}t.ended=true;e.writable=false}function onCorkedFinish(e,t,r){var n=e.entry;e.entry=null;while(n){var i=n.callback;t.pendingcb--;i(r);n=n.next}t.corkedRequestsFree.next=e}Object.defineProperty(Writable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._writableState===undefined){return false}return this._writableState.destroyed},set:function set(e){if(!this._writableState){return}this._writableState.destroyed=e}});Writable.prototype.destroy=f.destroy;Writable.prototype._undestroy=f.undestroy;Writable.prototype._destroy=function(e,t){t(e)}},224:function(e,t,r){"use strict";var n;function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var i=r(7);var a=Symbol("lastResolve");var o=Symbol("lastReject");var s=Symbol("error");var f=Symbol("ended");var l=Symbol("lastPromise");var u=Symbol("handlePromise");var d=Symbol("stream");function createIterResult(e,t){return{value:e,done:t}}function readAndResolve(e){var t=e[a];if(t!==null){var r=e[d].read();if(r!==null){e[l]=null;e[a]=null;e[o]=null;t(createIterResult(r,false))}}}function onReadable(e){process.nextTick(readAndResolve,e)}function wrapForNext(e,t){return function(r,n){e.then((function(){if(t[f]){r(createIterResult(undefined,true));return}t[u](r,n)}),n)}}var c=Object.getPrototypeOf((function(){}));var h=Object.setPrototypeOf((n={get stream(){return this[d]},next:function next(){var e=this;var t=this[s];if(t!==null){return Promise.reject(t)}if(this[f]){return Promise.resolve(createIterResult(undefined,true))}if(this[d].destroyed){return new Promise((function(t,r){process.nextTick((function(){if(e[s]){r(e[s])}else{t(createIterResult(undefined,true))}}))}))}var r=this[l];var n;if(r){n=new Promise(wrapForNext(r,this))}else{var i=this[d].read();if(i!==null){return Promise.resolve(createIterResult(i,false))}n=new Promise(this[u])}this[l]=n;return n}},_defineProperty(n,Symbol.asyncIterator,(function(){return this})),_defineProperty(n,"return",(function _return(){var e=this;return new Promise((function(t,r){e[d].destroy(null,(function(e){if(e){r(e);return}t(createIterResult(undefined,true))}))}))})),n),c);var p=function createReadableStreamAsyncIterator(e){var t;var r=Object.create(h,(t={},_defineProperty(t,d,{value:e,writable:true}),_defineProperty(t,a,{value:null,writable:true}),_defineProperty(t,o,{value:null,writable:true}),_defineProperty(t,s,{value:null,writable:true}),_defineProperty(t,f,{value:e._readableState.endEmitted,writable:true}),_defineProperty(t,u,{value:function value(e,t){var n=r[d].read();if(n){r[l]=null;r[a]=null;r[o]=null;e(createIterResult(n,false))}else{r[a]=e;r[o]=t}},writable:true}),t));r[l]=null;i(e,(function(e){if(e&&e.code!=="ERR_STREAM_PREMATURE_CLOSE"){var t=r[o];if(t!==null){r[l]=null;r[a]=null;r[o]=null;t(e)}r[s]=e;return}var n=r[a];if(n!==null){r[l]=null;r[a]=null;r[o]=null;n(createIterResult(undefined,true))}r[f]=true}));e.on("readable",onReadable.bind(null,r));return r};e.exports=p},41:function(e,t,r){"use strict";function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);if(t)n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,n)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}function _classCallCheck(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function")}}function _defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||false;n.configurable=true;if("value"in n)n.writable=true;Object.defineProperty(e,n.key,n)}}function _createClass(e,t,r){if(t)_defineProperties(e.prototype,t);if(r)_defineProperties(e,r);return e}var n=r(300),i=n.Buffer;var a=r(837),o=a.inspect;var s=o&&o.custom||"inspect";function copyBuffer(e,t,r){i.prototype.copy.call(e,t,r)}e.exports=function(){function BufferList(){_classCallCheck(this,BufferList);this.head=null;this.tail=null;this.length=0}_createClass(BufferList,[{key:"push",value:function push(e){var t={data:e,next:null};if(this.length>0)this.tail.next=t;else this.head=t;this.tail=t;++this.length}},{key:"unshift",value:function unshift(e){var t={data:e,next:this.head};if(this.length===0)this.tail=t;this.head=t;++this.length}},{key:"shift",value:function shift(){if(this.length===0)return;var e=this.head.data;if(this.length===1)this.head=this.tail=null;else this.head=this.head.next;--this.length;return e}},{key:"clear",value:function clear(){this.head=this.tail=null;this.length=0}},{key:"join",value:function join(e){if(this.length===0)return"";var t=this.head;var r=""+t.data;while(t=t.next){r+=e+t.data}return r}},{key:"concat",value:function concat(e){if(this.length===0)return i.alloc(0);var t=i.allocUnsafe(e>>>0);var r=this.head;var n=0;while(r){copyBuffer(r.data,t,n);n+=r.data.length;r=r.next}return t}},{key:"consume",value:function consume(e,t){var r;if(e<this.head.data.length){r=this.head.data.slice(0,e);this.head.data=this.head.data.slice(e)}else if(e===this.head.data.length){r=this.shift()}else{r=t?this._getString(e):this._getBuffer(e)}return r}},{key:"first",value:function first(){return this.head.data}},{key:"_getString",value:function _getString(e){var t=this.head;var r=1;var n=t.data;e-=n.length;while(t=t.next){var i=t.data;var a=e>i.length?i.length:e;if(a===i.length)n+=i;else n+=i.slice(0,e);e-=a;if(e===0){if(a===i.length){++r;if(t.next)this.head=t.next;else this.head=this.tail=null}else{this.head=t;t.data=i.slice(a)}break}++r}this.length-=r;return n}},{key:"_getBuffer",value:function _getBuffer(e){var t=i.allocUnsafe(e);var r=this.head;var n=1;r.data.copy(t);e-=r.data.length;while(r=r.next){var a=r.data;var o=e>a.length?a.length:e;a.copy(t,t.length-e,0,o);e-=o;if(e===0){if(o===a.length){++n;if(r.next)this.head=r.next;else this.head=this.tail=null}else{this.head=r;r.data=a.slice(o)}break}++n}this.length-=n;return t}},{key:s,value:function value(e,t){return o(this,_objectSpread({},t,{depth:0,customInspect:false}))}}]);return BufferList}()},289:function(e){"use strict";function destroy(e,t){var r=this;var n=this._readableState&&this._readableState.destroyed;var i=this._writableState&&this._writableState.destroyed;if(n||i){if(t){t(e)}else if(e){if(!this._writableState){process.nextTick(emitErrorNT,this,e)}else if(!this._writableState.errorEmitted){this._writableState.errorEmitted=true;process.nextTick(emitErrorNT,this,e)}}return this}if(this._readableState){this._readableState.destroyed=true}if(this._writableState){this._writableState.destroyed=true}this._destroy(e||null,(function(e){if(!t&&e){if(!r._writableState){process.nextTick(emitErrorAndCloseNT,r,e)}else if(!r._writableState.errorEmitted){r._writableState.errorEmitted=true;process.nextTick(emitErrorAndCloseNT,r,e)}else{process.nextTick(emitCloseNT,r)}}else if(t){process.nextTick(emitCloseNT,r);t(e)}else{process.nextTick(emitCloseNT,r)}}));return this}function emitErrorAndCloseNT(e,t){emitErrorNT(e,t);emitCloseNT(e)}function emitCloseNT(e){if(e._writableState&&!e._writableState.emitClose)return;if(e._readableState&&!e._readableState.emitClose)return;e.emit("close")}function undestroy(){if(this._readableState){this._readableState.destroyed=false;this._readableState.reading=false;this._readableState.ended=false;this._readableState.endEmitted=false}if(this._writableState){this._writableState.destroyed=false;this._writableState.ended=false;this._writableState.ending=false;this._writableState.finalCalled=false;this._writableState.prefinished=false;this._writableState.finished=false;this._writableState.errorEmitted=false}}function emitErrorNT(e,t){e.emit("error",t)}function errorOrDestroy(e,t){var r=e._readableState;var n=e._writableState;if(r&&r.autoDestroy||n&&n.autoDestroy)e.destroy(t);else e.emit("error",t)}e.exports={destroy:destroy,undestroy:undestroy,errorOrDestroy:errorOrDestroy}},7:function(e,t,r){"use strict";var n=r(349).q.ERR_STREAM_PREMATURE_CLOSE;function once(e){var t=false;return function(){if(t)return;t=true;for(var r=arguments.length,n=new Array(r),i=0;i<r;i++){n[i]=arguments[i]}e.apply(this,n)}}function noop(){}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function eos(e,t,r){if(typeof t==="function")return eos(e,null,t);if(!t)t={};r=once(r||noop);var i=t.readable||t.readable!==false&&e.readable;var a=t.writable||t.writable!==false&&e.writable;var o=function onlegacyfinish(){if(!e.writable)f()};var s=e._writableState&&e._writableState.finished;var f=function onfinish(){a=false;s=true;if(!i)r.call(e)};var l=e._readableState&&e._readableState.endEmitted;var u=function onend(){i=false;l=true;if(!a)r.call(e)};var d=function onerror(t){r.call(e,t)};var c=function onclose(){var t;if(i&&!l){if(!e._readableState||!e._readableState.ended)t=new n;return r.call(e,t)}if(a&&!s){if(!e._writableState||!e._writableState.ended)t=new n;return r.call(e,t)}};var h=function onrequest(){e.req.on("finish",f)};if(isRequest(e)){e.on("complete",f);e.on("abort",c);if(e.req)h();else e.on("request",h)}else if(a&&!e._writableState){e.on("end",o);e.on("close",o)}e.on("end",u);e.on("finish",f);if(t.error!==false)e.on("error",d);e.on("close",c);return function(){e.removeListener("complete",f);e.removeListener("abort",c);e.removeListener("request",h);if(e.req)e.req.removeListener("finish",f);e.removeListener("end",o);e.removeListener("close",o);e.removeListener("finish",f);e.removeListener("end",u);e.removeListener("error",d);e.removeListener("close",c)}}e.exports=eos},720:function(e,t,r){"use strict";function asyncGeneratorStep(e,t,r,n,i,a,o){try{var s=e[a](o);var f=s.value}catch(e){r(e);return}if(s.done){t(f)}else{Promise.resolve(f).then(n,i)}}function _asyncToGenerator(e){return function(){var t=this,r=arguments;return new Promise((function(n,i){var a=e.apply(t,r);function _next(e){asyncGeneratorStep(a,n,i,_next,_throw,"next",e)}function _throw(e){asyncGeneratorStep(a,n,i,_next,_throw,"throw",e)}_next(undefined)}))}}function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);if(t)n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,n)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var n=r(349).q.ERR_INVALID_ARG_TYPE;function from(e,t,r){var i;if(t&&typeof t.next==="function"){i=t}else if(t&&t[Symbol.asyncIterator])i=t[Symbol.asyncIterator]();else if(t&&t[Symbol.iterator])i=t[Symbol.iterator]();else throw new n("iterable",["Iterable"],t);var a=new e(_objectSpread({objectMode:true},r));var o=false;a._read=function(){if(!o){o=true;next()}};function next(){return _next2.apply(this,arguments)}function _next2(){_next2=_asyncToGenerator((function*(){try{var e=yield i.next(),t=e.value,r=e.done;if(r){a.push(null)}else if(a.push(yield t)){next()}else{o=false}}catch(e){a.destroy(e)}}));return _next2.apply(this,arguments)}return a}e.exports=from},522:function(e,t,r){"use strict";var n;function once(e){var t=false;return function(){if(t)return;t=true;e.apply(void 0,arguments)}}var i=r(349).q,a=i.ERR_MISSING_ARGS,o=i.ERR_STREAM_DESTROYED;function noop(e){if(e)throw e}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function destroyer(e,t,i,a){a=once(a);var s=false;e.on("close",(function(){s=true}));if(n===undefined)n=r(7);n(e,{readable:t,writable:i},(function(e){if(e)return a(e);s=true;a()}));var f=false;return function(t){if(s)return;if(f)return;f=true;if(isRequest(e))return e.abort();if(typeof e.destroy==="function")return e.destroy();a(t||new o("pipe"))}}function call(e){e()}function pipe(e,t){return e.pipe(t)}function popCallback(e){if(!e.length)return noop;if(typeof e[e.length-1]!=="function")return noop;return e.pop()}function pipeline(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++){t[r]=arguments[r]}var n=popCallback(t);if(Array.isArray(t[0]))t=t[0];if(t.length<2){throw new a("streams")}var i;var o=t.map((function(e,r){var a=r<t.length-1;var s=r>0;return destroyer(e,a,s,(function(e){if(!i)i=e;if(e)o.forEach(call);if(a)return;o.forEach(call);n(i)}))}));return t.reduce(pipe)}e.exports=pipeline},483:function(e,t,r){"use strict";var n=r(349).q.ERR_INVALID_OPT_VALUE;function highWaterMarkFrom(e,t,r){return e.highWaterMark!=null?e.highWaterMark:t?e[r]:null}function getHighWaterMark(e,t,r,i){var a=highWaterMarkFrom(t,i,r);if(a!=null){if(!(isFinite(a)&&Math.floor(a)===a)||a<0){var o=i?r:"highWaterMark";throw new n(o,a)}return Math.floor(a)}return e.objectMode?16:16*1024}e.exports={getHighWaterMark:getHighWaterMark}},455:function(e,t,r){e.exports=r(781)},207:function(e,t,r){var n=r(300);var i=n.Buffer;function copyProps(e,t){for(var r in e){t[r]=e[r]}}if(i.from&&i.alloc&&i.allocUnsafe&&i.allocUnsafeSlow){e.exports=n}else{copyProps(n,t);t.Buffer=SafeBuffer}function SafeBuffer(e,t,r){return i(e,t,r)}SafeBuffer.prototype=Object.create(i.prototype);copyProps(i,SafeBuffer);SafeBuffer.from=function(e,t,r){if(typeof e==="number"){throw new TypeError("Argument must not be a number")}return i(e,t,r)};SafeBuffer.alloc=function(e,t,r){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}var n=i(e);if(t!==undefined){if(typeof r==="string"){n.fill(t,r)}else{n.fill(t)}}else{n.fill(0)}return n};SafeBuffer.allocUnsafe=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return i(e)};SafeBuffer.allocUnsafeSlow=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return n.SlowBuffer(e)}},552:function(e,t,r){e.exports=Stream;var n=r(361).EventEmitter;var i=r(140);i(Stream,n);Stream.Readable=r(787);Stream.Writable=r(513);Stream.Duplex=r(716);Stream.Transform=r(551);Stream.PassThrough=r(788);Stream.finished=r(7);Stream.pipeline=r(522);Stream.Stream=Stream;function Stream(){n.call(this)}Stream.prototype.pipe=function(e,t){var r=this;function ondata(t){if(e.writable){if(false===e.write(t)&&r.pause){r.pause()}}}r.on("data",ondata);function ondrain(){if(r.readable&&r.resume){r.resume()}}e.on("drain",ondrain);if(!e._isStdio&&(!t||t.end!==false)){r.on("end",onend);r.on("close",onclose)}var i=false;function onend(){if(i)return;i=true;e.end()}function onclose(){if(i)return;i=true;if(typeof e.destroy==="function")e.destroy()}function onerror(e){cleanup();if(n.listenerCount(this,"error")===0){throw e}}r.on("error",onerror);e.on("error",onerror);function cleanup(){r.removeListener("data",ondata);e.removeListener("drain",ondrain);r.removeListener("end",onend);r.removeListener("close",onclose);r.removeListener("error",onerror);e.removeListener("error",onerror);r.removeListener("end",cleanup);r.removeListener("close",cleanup);e.removeListener("close",cleanup)}r.on("end",cleanup);r.on("close",cleanup);e.on("close",cleanup);e.emit("pipe",r);return e}},862:function(e,t,r){"use strict";var n=r(207).Buffer;var i=n.isEncoding||function(e){e=""+e;switch(e&&e.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return true;default:return false}};function _normalizeEncoding(e){if(!e)return"utf8";var t;while(true){switch(e){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return e;default:if(t)return;e=(""+e).toLowerCase();t=true}}}function normalizeEncoding(e){var t=_normalizeEncoding(e);if(typeof t!=="string"&&(n.isEncoding===i||!i(e)))throw new Error("Unknown encoding: "+e);return t||e}t.s=StringDecoder;function StringDecoder(e){this.encoding=normalizeEncoding(e);var t;switch(this.encoding){case"utf16le":this.text=utf16Text;this.end=utf16End;t=4;break;case"utf8":this.fillLast=utf8FillLast;t=4;break;case"base64":this.text=base64Text;this.end=base64End;t=3;break;default:this.write=simpleWrite;this.end=simpleEnd;return}this.lastNeed=0;this.lastTotal=0;this.lastChar=n.allocUnsafe(t)}StringDecoder.prototype.write=function(e){if(e.length===0)return"";var t;var r;if(this.lastNeed){t=this.fillLast(e);if(t===undefined)return"";r=this.lastNeed;this.lastNeed=0}else{r=0}if(r<e.length)return t?t+this.text(e,r):this.text(e,r);return t||""};StringDecoder.prototype.end=utf8End;StringDecoder.prototype.text=utf8Text;StringDecoder.prototype.fillLast=function(e){if(this.lastNeed<=e.length){e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,e.length);this.lastNeed-=e.length};function utf8CheckByte(e){if(e<=127)return 0;else if(e>>5===6)return 2;else if(e>>4===14)return 3;else if(e>>3===30)return 4;return e>>6===2?-1:-2}function utf8CheckIncomplete(e,t,r){var n=t.length-1;if(n<r)return 0;var i=utf8CheckByte(t[n]);if(i>=0){if(i>0)e.lastNeed=i-1;return i}if(--n<r||i===-2)return 0;i=utf8CheckByte(t[n]);if(i>=0){if(i>0)e.lastNeed=i-2;return i}if(--n<r||i===-2)return 0;i=utf8CheckByte(t[n]);if(i>=0){if(i>0){if(i===2)i=0;else e.lastNeed=i-3}return i}return 0}function utf8CheckExtraBytes(e,t,r){if((t[0]&192)!==128){e.lastNeed=0;return"�"}if(e.lastNeed>1&&t.length>1){if((t[1]&192)!==128){e.lastNeed=1;return"�"}if(e.lastNeed>2&&t.length>2){if((t[2]&192)!==128){e.lastNeed=2;return"�"}}}}function utf8FillLast(e){var t=this.lastTotal-this.lastNeed;var r=utf8CheckExtraBytes(this,e,t);if(r!==undefined)return r;if(this.lastNeed<=e.length){e.copy(this.lastChar,t,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,t,0,e.length);this.lastNeed-=e.length}function utf8Text(e,t){var r=utf8CheckIncomplete(this,e,t);if(!this.lastNeed)return e.toString("utf8",t);this.lastTotal=r;var n=e.length-(r-this.lastNeed);e.copy(this.lastChar,0,n);return e.toString("utf8",t,n)}function utf8End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+"�";return t}function utf16Text(e,t){if((e.length-t)%2===0){var r=e.toString("utf16le",t);if(r){var n=r.charCodeAt(r.length-1);if(n>=55296&&n<=56319){this.lastNeed=2;this.lastTotal=4;this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1];return r.slice(0,-1)}}return r}this.lastNeed=1;this.lastTotal=2;this.lastChar[0]=e[e.length-1];return e.toString("utf16le",t,e.length-1)}function utf16End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed){var r=this.lastTotal-this.lastNeed;return t+this.lastChar.toString("utf16le",0,r)}return t}function base64Text(e,t){var r=(e.length-t)%3;if(r===0)return e.toString("base64",t);this.lastNeed=3-r;this.lastTotal=3;if(r===1){this.lastChar[0]=e[e.length-1]}else{this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1]}return e.toString("base64",t,e.length-r)}function base64End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+this.lastChar.toString("base64",0,3-this.lastNeed);return t}function simpleWrite(e){return e.toString(this.encoding)}function simpleEnd(e){return e&&e.length?this.write(e):""}},777:function(e){e.exports=deprecate;function deprecate(e,t){if(config("noDeprecation")){return e}var r=false;function deprecated(){if(!r){if(config("throwDeprecation")){throw new Error(t)}else if(config("traceDeprecation")){console.trace(t)}else{console.warn(t)}r=true}return e.apply(this,arguments)}return deprecated}function config(e){try{if(!__webpack_require__.g.localStorage)return false}catch(e){return false}var t=__webpack_require__.g.localStorage[e];if(null==t)return false;return String(t).toLowerCase()==="true"}},300:function(e){"use strict";e.exports=__webpack_require__(48764)},361:function(e){"use strict";e.exports=__webpack_require__(25293)},781:function(e){"use strict";e.exports=(__webpack_require__(25293).EventEmitter)},837:function(e){"use strict";e.exports=__webpack_require__(79720)}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var a=true;try{e[r](i,i.exports,__nccwpck_require__);a=false}finally{if(a)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(552);module.exports=r})();

/***/ }),

/***/ 22321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var process = __webpack_require__(83454);
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
(function(){var e={699:function(e){e.exports={100:"Continue",101:"Switching Protocols",102:"Processing",200:"OK",201:"Created",202:"Accepted",203:"Non-Authoritative Information",204:"No Content",205:"Reset Content",206:"Partial Content",207:"Multi-Status",208:"Already Reported",226:"IM Used",300:"Multiple Choices",301:"Moved Permanently",302:"Found",303:"See Other",304:"Not Modified",305:"Use Proxy",307:"Temporary Redirect",308:"Permanent Redirect",400:"Bad Request",401:"Unauthorized",402:"Payment Required",403:"Forbidden",404:"Not Found",405:"Method Not Allowed",406:"Not Acceptable",407:"Proxy Authentication Required",408:"Request Timeout",409:"Conflict",410:"Gone",411:"Length Required",412:"Precondition Failed",413:"Payload Too Large",414:"URI Too Long",415:"Unsupported Media Type",416:"Range Not Satisfiable",417:"Expectation Failed",418:"I'm a teapot",421:"Misdirected Request",422:"Unprocessable Entity",423:"Locked",424:"Failed Dependency",425:"Unordered Collection",426:"Upgrade Required",428:"Precondition Required",429:"Too Many Requests",431:"Request Header Fields Too Large",451:"Unavailable For Legal Reasons",500:"Internal Server Error",501:"Not Implemented",502:"Bad Gateway",503:"Service Unavailable",504:"Gateway Timeout",505:"HTTP Version Not Supported",506:"Variant Also Negotiates",507:"Insufficient Storage",508:"Loop Detected",509:"Bandwidth Limit Exceeded",510:"Not Extended",511:"Network Authentication Required"}},140:function(e){if(typeof Object.create==="function"){e.exports=function inherits(e,t){if(t){e.super_=t;e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:false,writable:true,configurable:true}})}}}else{e.exports=function inherits(e,t){if(t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}}}},349:function(e){"use strict";const t={};function createErrorType(e,r,n){if(!n){n=Error}function getMessage(e,t,n){if(typeof r==="string"){return r}else{return r(e,t,n)}}class NodeError extends n{constructor(e,t,r){super(getMessage(e,t,r))}}NodeError.prototype.name=n.name;NodeError.prototype.code=e;t[e]=NodeError}function oneOf(e,t){if(Array.isArray(e)){const r=e.length;e=e.map((e=>String(e)));if(r>2){return`one of ${t} ${e.slice(0,r-1).join(", ")}, or `+e[r-1]}else if(r===2){return`one of ${t} ${e[0]} or ${e[1]}`}else{return`of ${t} ${e[0]}`}}else{return`of ${t} ${String(e)}`}}function startsWith(e,t,r){return e.substr(!r||r<0?0:+r,t.length)===t}function endsWith(e,t,r){if(r===undefined||r>e.length){r=e.length}return e.substring(r-t.length,r)===t}function includes(e,t,r){if(typeof r!=="number"){r=0}if(r+t.length>e.length){return false}else{return e.indexOf(t,r)!==-1}}createErrorType("ERR_INVALID_OPT_VALUE",(function(e,t){return'The value "'+t+'" is invalid for option "'+e+'"'}),TypeError);createErrorType("ERR_INVALID_ARG_TYPE",(function(e,t,r){let n;if(typeof t==="string"&&startsWith(t,"not ")){n="must not be";t=t.replace(/^not /,"")}else{n="must be"}let i;if(endsWith(e," argument")){i=`The ${e} ${n} ${oneOf(t,"type")}`}else{const r=includes(e,".")?"property":"argument";i=`The "${e}" ${r} ${n} ${oneOf(t,"type")}`}i+=`. Received type ${typeof r}`;return i}),TypeError);createErrorType("ERR_STREAM_PUSH_AFTER_EOF","stream.push() after EOF");createErrorType("ERR_METHOD_NOT_IMPLEMENTED",(function(e){return"The "+e+" method is not implemented"}));createErrorType("ERR_STREAM_PREMATURE_CLOSE","Premature close");createErrorType("ERR_STREAM_DESTROYED",(function(e){return"Cannot call "+e+" after a stream was destroyed"}));createErrorType("ERR_MULTIPLE_CALLBACK","Callback called multiple times");createErrorType("ERR_STREAM_CANNOT_PIPE","Cannot pipe, not readable");createErrorType("ERR_STREAM_WRITE_AFTER_END","write after end");createErrorType("ERR_STREAM_NULL_VALUES","May not write null values to stream",TypeError);createErrorType("ERR_UNKNOWN_ENCODING",(function(e){return"Unknown encoding: "+e}),TypeError);createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT","stream.unshift() after end event");e.exports.q=t},716:function(e,t,r){"use strict";var n=Object.keys||function(e){var t=[];for(var r in e){t.push(r)}return t};e.exports=Duplex;var i=r(787);var a=r(513);r(140)(Duplex,i);{var o=n(a.prototype);for(var s=0;s<o.length;s++){var f=o[s];if(!Duplex.prototype[f])Duplex.prototype[f]=a.prototype[f]}}function Duplex(e){if(!(this instanceof Duplex))return new Duplex(e);i.call(this,e);a.call(this,e);this.allowHalfOpen=true;if(e){if(e.readable===false)this.readable=false;if(e.writable===false)this.writable=false;if(e.allowHalfOpen===false){this.allowHalfOpen=false;this.once("end",onend)}}}Object.defineProperty(Duplex.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});Object.defineProperty(Duplex.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});Object.defineProperty(Duplex.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function onend(){if(this._writableState.ended)return;process.nextTick(onEndNT,this)}function onEndNT(e){e.end()}Object.defineProperty(Duplex.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined||this._writableState===undefined){return false}return this._readableState.destroyed&&this._writableState.destroyed},set:function set(e){if(this._readableState===undefined||this._writableState===undefined){return}this._readableState.destroyed=e;this._writableState.destroyed=e}})},788:function(e,t,r){"use strict";e.exports=PassThrough;var n=r(551);r(140)(PassThrough,n);function PassThrough(e){if(!(this instanceof PassThrough))return new PassThrough(e);n.call(this,e)}PassThrough.prototype._transform=function(e,t,r){r(null,e)}},787:function(e,t,r){"use strict";e.exports=Readable;var n;Readable.ReadableState=ReadableState;var i=r(361).EventEmitter;var a=function EElistenerCount(e,t){return e.listeners(t).length};var o=r(455);var s=r(300).Buffer;var f=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return s.from(e)}function _isUint8Array(e){return s.isBuffer(e)||e instanceof f}var l=r(837);var u;if(l&&l.debuglog){u=l.debuglog("stream")}else{u=function debug(){}}var d=r(41);var c=r(289);var h=r(483),p=h.getHighWaterMark;var b=r(349).q,y=b.ERR_INVALID_ARG_TYPE,g=b.ERR_STREAM_PUSH_AFTER_EOF,_=b.ERR_METHOD_NOT_IMPLEMENTED,v=b.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;var m;var w;var R;r(140)(Readable,o);var S=c.errorOrDestroy;var E=["error","close","destroy","pause","resume"];function prependListener(e,t,r){if(typeof e.prependListener==="function")return e.prependListener(t,r);if(!e._events||!e._events[t])e.on(t,r);else if(Array.isArray(e._events[t]))e._events[t].unshift(r);else e._events[t]=[r,e._events[t]]}function ReadableState(e,t,i){n=n||r(716);e=e||{};if(typeof i!=="boolean")i=t instanceof n;this.objectMode=!!e.objectMode;if(i)this.objectMode=this.objectMode||!!e.readableObjectMode;this.highWaterMark=p(this,e,"readableHighWaterMark",i);this.buffer=new d;this.length=0;this.pipes=null;this.pipesCount=0;this.flowing=null;this.ended=false;this.endEmitted=false;this.reading=false;this.sync=true;this.needReadable=false;this.emittedReadable=false;this.readableListening=false;this.resumeScheduled=false;this.paused=true;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.destroyed=false;this.defaultEncoding=e.defaultEncoding||"utf8";this.awaitDrain=0;this.readingMore=false;this.decoder=null;this.encoding=null;if(e.encoding){if(!m)m=r(862).s;this.decoder=new m(e.encoding);this.encoding=e.encoding}}function Readable(e){n=n||r(716);if(!(this instanceof Readable))return new Readable(e);var t=this instanceof n;this._readableState=new ReadableState(e,this,t);this.readable=true;if(e){if(typeof e.read==="function")this._read=e.read;if(typeof e.destroy==="function")this._destroy=e.destroy}o.call(this)}Object.defineProperty(Readable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined){return false}return this._readableState.destroyed},set:function set(e){if(!this._readableState){return}this._readableState.destroyed=e}});Readable.prototype.destroy=c.destroy;Readable.prototype._undestroy=c.undestroy;Readable.prototype._destroy=function(e,t){t(e)};Readable.prototype.push=function(e,t){var r=this._readableState;var n;if(!r.objectMode){if(typeof e==="string"){t=t||r.defaultEncoding;if(t!==r.encoding){e=s.from(e,t);t=""}n=true}}else{n=true}return readableAddChunk(this,e,t,false,n)};Readable.prototype.unshift=function(e){return readableAddChunk(this,e,null,true,false)};function readableAddChunk(e,t,r,n,i){u("readableAddChunk",t);var a=e._readableState;if(t===null){a.reading=false;onEofChunk(e,a)}else{var o;if(!i)o=chunkInvalid(a,t);if(o){S(e,o)}else if(a.objectMode||t&&t.length>0){if(typeof t!=="string"&&!a.objectMode&&Object.getPrototypeOf(t)!==s.prototype){t=_uint8ArrayToBuffer(t)}if(n){if(a.endEmitted)S(e,new v);else addChunk(e,a,t,true)}else if(a.ended){S(e,new g)}else if(a.destroyed){return false}else{a.reading=false;if(a.decoder&&!r){t=a.decoder.write(t);if(a.objectMode||t.length!==0)addChunk(e,a,t,false);else maybeReadMore(e,a)}else{addChunk(e,a,t,false)}}}else if(!n){a.reading=false;maybeReadMore(e,a)}}return!a.ended&&(a.length<a.highWaterMark||a.length===0)}function addChunk(e,t,r,n){if(t.flowing&&t.length===0&&!t.sync){t.awaitDrain=0;e.emit("data",r)}else{t.length+=t.objectMode?1:r.length;if(n)t.buffer.unshift(r);else t.buffer.push(r);if(t.needReadable)emitReadable(e)}maybeReadMore(e,t)}function chunkInvalid(e,t){var r;if(!_isUint8Array(t)&&typeof t!=="string"&&t!==undefined&&!e.objectMode){r=new y("chunk",["string","Buffer","Uint8Array"],t)}return r}Readable.prototype.isPaused=function(){return this._readableState.flowing===false};Readable.prototype.setEncoding=function(e){if(!m)m=r(862).s;var t=new m(e);this._readableState.decoder=t;this._readableState.encoding=this._readableState.decoder.encoding;var n=this._readableState.buffer.head;var i="";while(n!==null){i+=t.write(n.data);n=n.next}this._readableState.buffer.clear();if(i!=="")this._readableState.buffer.push(i);this._readableState.length=i.length;return this};var T=1073741824;function computeNewHighWaterMark(e){if(e>=T){e=T}else{e--;e|=e>>>1;e|=e>>>2;e|=e>>>4;e|=e>>>8;e|=e>>>16;e++}return e}function howMuchToRead(e,t){if(e<=0||t.length===0&&t.ended)return 0;if(t.objectMode)return 1;if(e!==e){if(t.flowing&&t.length)return t.buffer.head.data.length;else return t.length}if(e>t.highWaterMark)t.highWaterMark=computeNewHighWaterMark(e);if(e<=t.length)return e;if(!t.ended){t.needReadable=true;return 0}return t.length}Readable.prototype.read=function(e){u("read",e);e=parseInt(e,10);var t=this._readableState;var r=e;if(e!==0)t.emittedReadable=false;if(e===0&&t.needReadable&&((t.highWaterMark!==0?t.length>=t.highWaterMark:t.length>0)||t.ended)){u("read: emitReadable",t.length,t.ended);if(t.length===0&&t.ended)endReadable(this);else emitReadable(this);return null}e=howMuchToRead(e,t);if(e===0&&t.ended){if(t.length===0)endReadable(this);return null}var n=t.needReadable;u("need readable",n);if(t.length===0||t.length-e<t.highWaterMark){n=true;u("length less than watermark",n)}if(t.ended||t.reading){n=false;u("reading or ended",n)}else if(n){u("do read");t.reading=true;t.sync=true;if(t.length===0)t.needReadable=true;this._read(t.highWaterMark);t.sync=false;if(!t.reading)e=howMuchToRead(r,t)}var i;if(e>0)i=fromList(e,t);else i=null;if(i===null){t.needReadable=t.length<=t.highWaterMark;e=0}else{t.length-=e;t.awaitDrain=0}if(t.length===0){if(!t.ended)t.needReadable=true;if(r!==e&&t.ended)endReadable(this)}if(i!==null)this.emit("data",i);return i};function onEofChunk(e,t){u("onEofChunk");if(t.ended)return;if(t.decoder){var r=t.decoder.end();if(r&&r.length){t.buffer.push(r);t.length+=t.objectMode?1:r.length}}t.ended=true;if(t.sync){emitReadable(e)}else{t.needReadable=false;if(!t.emittedReadable){t.emittedReadable=true;emitReadable_(e)}}}function emitReadable(e){var t=e._readableState;u("emitReadable",t.needReadable,t.emittedReadable);t.needReadable=false;if(!t.emittedReadable){u("emitReadable",t.flowing);t.emittedReadable=true;process.nextTick(emitReadable_,e)}}function emitReadable_(e){var t=e._readableState;u("emitReadable_",t.destroyed,t.length,t.ended);if(!t.destroyed&&(t.length||t.ended)){e.emit("readable");t.emittedReadable=false}t.needReadable=!t.flowing&&!t.ended&&t.length<=t.highWaterMark;flow(e)}function maybeReadMore(e,t){if(!t.readingMore){t.readingMore=true;process.nextTick(maybeReadMore_,e,t)}}function maybeReadMore_(e,t){while(!t.reading&&!t.ended&&(t.length<t.highWaterMark||t.flowing&&t.length===0)){var r=t.length;u("maybeReadMore read 0");e.read(0);if(r===t.length)break}t.readingMore=false}Readable.prototype._read=function(e){S(this,new _("_read()"))};Readable.prototype.pipe=function(e,t){var r=this;var n=this._readableState;switch(n.pipesCount){case 0:n.pipes=e;break;case 1:n.pipes=[n.pipes,e];break;default:n.pipes.push(e);break}n.pipesCount+=1;u("pipe count=%d opts=%j",n.pipesCount,t);var i=(!t||t.end!==false)&&e!==process.stdout&&e!==process.stderr;var o=i?onend:unpipe;if(n.endEmitted)process.nextTick(o);else r.once("end",o);e.on("unpipe",onunpipe);function onunpipe(e,t){u("onunpipe");if(e===r){if(t&&t.hasUnpiped===false){t.hasUnpiped=true;cleanup()}}}function onend(){u("onend");e.end()}var s=pipeOnDrain(r);e.on("drain",s);var f=false;function cleanup(){u("cleanup");e.removeListener("close",onclose);e.removeListener("finish",onfinish);e.removeListener("drain",s);e.removeListener("error",onerror);e.removeListener("unpipe",onunpipe);r.removeListener("end",onend);r.removeListener("end",unpipe);r.removeListener("data",ondata);f=true;if(n.awaitDrain&&(!e._writableState||e._writableState.needDrain))s()}r.on("data",ondata);function ondata(t){u("ondata");var i=e.write(t);u("dest.write",i);if(i===false){if((n.pipesCount===1&&n.pipes===e||n.pipesCount>1&&indexOf(n.pipes,e)!==-1)&&!f){u("false write response, pause",n.awaitDrain);n.awaitDrain++}r.pause()}}function onerror(t){u("onerror",t);unpipe();e.removeListener("error",onerror);if(a(e,"error")===0)S(e,t)}prependListener(e,"error",onerror);function onclose(){e.removeListener("finish",onfinish);unpipe()}e.once("close",onclose);function onfinish(){u("onfinish");e.removeListener("close",onclose);unpipe()}e.once("finish",onfinish);function unpipe(){u("unpipe");r.unpipe(e)}e.emit("pipe",r);if(!n.flowing){u("pipe resume");r.resume()}return e};function pipeOnDrain(e){return function pipeOnDrainFunctionResult(){var t=e._readableState;u("pipeOnDrain",t.awaitDrain);if(t.awaitDrain)t.awaitDrain--;if(t.awaitDrain===0&&a(e,"data")){t.flowing=true;flow(e)}}}Readable.prototype.unpipe=function(e){var t=this._readableState;var r={hasUnpiped:false};if(t.pipesCount===0)return this;if(t.pipesCount===1){if(e&&e!==t.pipes)return this;if(!e)e=t.pipes;t.pipes=null;t.pipesCount=0;t.flowing=false;if(e)e.emit("unpipe",this,r);return this}if(!e){var n=t.pipes;var i=t.pipesCount;t.pipes=null;t.pipesCount=0;t.flowing=false;for(var a=0;a<i;a++){n[a].emit("unpipe",this,{hasUnpiped:false})}return this}var o=indexOf(t.pipes,e);if(o===-1)return this;t.pipes.splice(o,1);t.pipesCount-=1;if(t.pipesCount===1)t.pipes=t.pipes[0];e.emit("unpipe",this,r);return this};Readable.prototype.on=function(e,t){var r=o.prototype.on.call(this,e,t);var n=this._readableState;if(e==="data"){n.readableListening=this.listenerCount("readable")>0;if(n.flowing!==false)this.resume()}else if(e==="readable"){if(!n.endEmitted&&!n.readableListening){n.readableListening=n.needReadable=true;n.flowing=false;n.emittedReadable=false;u("on readable",n.length,n.reading);if(n.length){emitReadable(this)}else if(!n.reading){process.nextTick(nReadingNextTick,this)}}}return r};Readable.prototype.addListener=Readable.prototype.on;Readable.prototype.removeListener=function(e,t){var r=o.prototype.removeListener.call(this,e,t);if(e==="readable"){process.nextTick(updateReadableListening,this)}return r};Readable.prototype.removeAllListeners=function(e){var t=o.prototype.removeAllListeners.apply(this,arguments);if(e==="readable"||e===undefined){process.nextTick(updateReadableListening,this)}return t};function updateReadableListening(e){var t=e._readableState;t.readableListening=e.listenerCount("readable")>0;if(t.resumeScheduled&&!t.paused){t.flowing=true}else if(e.listenerCount("data")>0){e.resume()}}function nReadingNextTick(e){u("readable nexttick read 0");e.read(0)}Readable.prototype.resume=function(){var e=this._readableState;if(!e.flowing){u("resume");e.flowing=!e.readableListening;resume(this,e)}e.paused=false;return this};function resume(e,t){if(!t.resumeScheduled){t.resumeScheduled=true;process.nextTick(resume_,e,t)}}function resume_(e,t){u("resume",t.reading);if(!t.reading){e.read(0)}t.resumeScheduled=false;e.emit("resume");flow(e);if(t.flowing&&!t.reading)e.read(0)}Readable.prototype.pause=function(){u("call pause flowing=%j",this._readableState.flowing);if(this._readableState.flowing!==false){u("pause");this._readableState.flowing=false;this.emit("pause")}this._readableState.paused=true;return this};function flow(e){var t=e._readableState;u("flow",t.flowing);while(t.flowing&&e.read()!==null){}}Readable.prototype.wrap=function(e){var t=this;var r=this._readableState;var n=false;e.on("end",(function(){u("wrapped end");if(r.decoder&&!r.ended){var e=r.decoder.end();if(e&&e.length)t.push(e)}t.push(null)}));e.on("data",(function(i){u("wrapped data");if(r.decoder)i=r.decoder.write(i);if(r.objectMode&&(i===null||i===undefined))return;else if(!r.objectMode&&(!i||!i.length))return;var a=t.push(i);if(!a){n=true;e.pause()}}));for(var i in e){if(this[i]===undefined&&typeof e[i]==="function"){this[i]=function methodWrap(t){return function methodWrapReturnFunction(){return e[t].apply(e,arguments)}}(i)}}for(var a=0;a<E.length;a++){e.on(E[a],this.emit.bind(this,E[a]))}this._read=function(t){u("wrapped _read",t);if(n){n=false;e.resume()}};return this};if(typeof Symbol==="function"){Readable.prototype[Symbol.asyncIterator]=function(){if(w===undefined){w=r(224)}return w(this)}}Object.defineProperty(Readable.prototype,"readableHighWaterMark",{enumerable:false,get:function get(){return this._readableState.highWaterMark}});Object.defineProperty(Readable.prototype,"readableBuffer",{enumerable:false,get:function get(){return this._readableState&&this._readableState.buffer}});Object.defineProperty(Readable.prototype,"readableFlowing",{enumerable:false,get:function get(){return this._readableState.flowing},set:function set(e){if(this._readableState){this._readableState.flowing=e}}});Readable._fromList=fromList;Object.defineProperty(Readable.prototype,"readableLength",{enumerable:false,get:function get(){return this._readableState.length}});function fromList(e,t){if(t.length===0)return null;var r;if(t.objectMode)r=t.buffer.shift();else if(!e||e>=t.length){if(t.decoder)r=t.buffer.join("");else if(t.buffer.length===1)r=t.buffer.first();else r=t.buffer.concat(t.length);t.buffer.clear()}else{r=t.buffer.consume(e,t.decoder)}return r}function endReadable(e){var t=e._readableState;u("endReadable",t.endEmitted);if(!t.endEmitted){t.ended=true;process.nextTick(endReadableNT,t,e)}}function endReadableNT(e,t){u("endReadableNT",e.endEmitted,e.length);if(!e.endEmitted&&e.length===0){e.endEmitted=true;t.readable=false;t.emit("end");if(e.autoDestroy){var r=t._writableState;if(!r||r.autoDestroy&&r.finished){t.destroy()}}}}if(typeof Symbol==="function"){Readable.from=function(e,t){if(R===undefined){R=r(720)}return R(Readable,e,t)}}function indexOf(e,t){for(var r=0,n=e.length;r<n;r++){if(e[r]===t)return r}return-1}},551:function(e,t,r){"use strict";e.exports=Transform;var n=r(349).q,i=n.ERR_METHOD_NOT_IMPLEMENTED,a=n.ERR_MULTIPLE_CALLBACK,o=n.ERR_TRANSFORM_ALREADY_TRANSFORMING,s=n.ERR_TRANSFORM_WITH_LENGTH_0;var f=r(716);r(140)(Transform,f);function afterTransform(e,t){var r=this._transformState;r.transforming=false;var n=r.writecb;if(n===null){return this.emit("error",new a)}r.writechunk=null;r.writecb=null;if(t!=null)this.push(t);n(e);var i=this._readableState;i.reading=false;if(i.needReadable||i.length<i.highWaterMark){this._read(i.highWaterMark)}}function Transform(e){if(!(this instanceof Transform))return new Transform(e);f.call(this,e);this._transformState={afterTransform:afterTransform.bind(this),needTransform:false,transforming:false,writecb:null,writechunk:null,writeencoding:null};this._readableState.needReadable=true;this._readableState.sync=false;if(e){if(typeof e.transform==="function")this._transform=e.transform;if(typeof e.flush==="function")this._flush=e.flush}this.on("prefinish",prefinish)}function prefinish(){var e=this;if(typeof this._flush==="function"&&!this._readableState.destroyed){this._flush((function(t,r){done(e,t,r)}))}else{done(this,null,null)}}Transform.prototype.push=function(e,t){this._transformState.needTransform=false;return f.prototype.push.call(this,e,t)};Transform.prototype._transform=function(e,t,r){r(new i("_transform()"))};Transform.prototype._write=function(e,t,r){var n=this._transformState;n.writecb=r;n.writechunk=e;n.writeencoding=t;if(!n.transforming){var i=this._readableState;if(n.needTransform||i.needReadable||i.length<i.highWaterMark)this._read(i.highWaterMark)}};Transform.prototype._read=function(e){var t=this._transformState;if(t.writechunk!==null&&!t.transforming){t.transforming=true;this._transform(t.writechunk,t.writeencoding,t.afterTransform)}else{t.needTransform=true}};Transform.prototype._destroy=function(e,t){f.prototype._destroy.call(this,e,(function(e){t(e)}))};function done(e,t,r){if(t)return e.emit("error",t);if(r!=null)e.push(r);if(e._writableState.length)throw new s;if(e._transformState.transforming)throw new o;return e.push(null)}},513:function(e,t,r){"use strict";e.exports=Writable;function WriteReq(e,t,r){this.chunk=e;this.encoding=t;this.callback=r;this.next=null}function CorkedRequest(e){var t=this;this.next=null;this.entry=null;this.finish=function(){onCorkedFinish(t,e)}}var n;Writable.WritableState=WritableState;var i={deprecate:r(777)};var a=r(455);var o=r(300).Buffer;var s=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return o.from(e)}function _isUint8Array(e){return o.isBuffer(e)||e instanceof s}var f=r(289);var l=r(483),u=l.getHighWaterMark;var d=r(349).q,c=d.ERR_INVALID_ARG_TYPE,h=d.ERR_METHOD_NOT_IMPLEMENTED,p=d.ERR_MULTIPLE_CALLBACK,b=d.ERR_STREAM_CANNOT_PIPE,y=d.ERR_STREAM_DESTROYED,g=d.ERR_STREAM_NULL_VALUES,_=d.ERR_STREAM_WRITE_AFTER_END,v=d.ERR_UNKNOWN_ENCODING;var m=f.errorOrDestroy;r(140)(Writable,a);function nop(){}function WritableState(e,t,i){n=n||r(716);e=e||{};if(typeof i!=="boolean")i=t instanceof n;this.objectMode=!!e.objectMode;if(i)this.objectMode=this.objectMode||!!e.writableObjectMode;this.highWaterMark=u(this,e,"writableHighWaterMark",i);this.finalCalled=false;this.needDrain=false;this.ending=false;this.ended=false;this.finished=false;this.destroyed=false;var a=e.decodeStrings===false;this.decodeStrings=!a;this.defaultEncoding=e.defaultEncoding||"utf8";this.length=0;this.writing=false;this.corked=0;this.sync=true;this.bufferProcessing=false;this.onwrite=function(e){onwrite(t,e)};this.writecb=null;this.writelen=0;this.bufferedRequest=null;this.lastBufferedRequest=null;this.pendingcb=0;this.prefinished=false;this.errorEmitted=false;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.bufferedRequestCount=0;this.corkedRequestsFree=new CorkedRequest(this)}WritableState.prototype.getBuffer=function getBuffer(){var e=this.bufferedRequest;var t=[];while(e){t.push(e);e=e.next}return t};(function(){try{Object.defineProperty(WritableState.prototype,"buffer",{get:i.deprecate((function writableStateBufferGetter(){return this.getBuffer()}),"_writableState.buffer is deprecated. Use _writableState.getBuffer "+"instead.","DEP0003")})}catch(e){}})();var w;if(typeof Symbol==="function"&&Symbol.hasInstance&&typeof Function.prototype[Symbol.hasInstance]==="function"){w=Function.prototype[Symbol.hasInstance];Object.defineProperty(Writable,Symbol.hasInstance,{value:function value(e){if(w.call(this,e))return true;if(this!==Writable)return false;return e&&e._writableState instanceof WritableState}})}else{w=function realHasInstance(e){return e instanceof this}}function Writable(e){n=n||r(716);var t=this instanceof n;if(!t&&!w.call(Writable,this))return new Writable(e);this._writableState=new WritableState(e,this,t);this.writable=true;if(e){if(typeof e.write==="function")this._write=e.write;if(typeof e.writev==="function")this._writev=e.writev;if(typeof e.destroy==="function")this._destroy=e.destroy;if(typeof e.final==="function")this._final=e.final}a.call(this)}Writable.prototype.pipe=function(){m(this,new b)};function writeAfterEnd(e,t){var r=new _;m(e,r);process.nextTick(t,r)}function validChunk(e,t,r,n){var i;if(r===null){i=new g}else if(typeof r!=="string"&&!t.objectMode){i=new c("chunk",["string","Buffer"],r)}if(i){m(e,i);process.nextTick(n,i);return false}return true}Writable.prototype.write=function(e,t,r){var n=this._writableState;var i=false;var a=!n.objectMode&&_isUint8Array(e);if(a&&!o.isBuffer(e)){e=_uint8ArrayToBuffer(e)}if(typeof t==="function"){r=t;t=null}if(a)t="buffer";else if(!t)t=n.defaultEncoding;if(typeof r!=="function")r=nop;if(n.ending)writeAfterEnd(this,r);else if(a||validChunk(this,n,e,r)){n.pendingcb++;i=writeOrBuffer(this,n,a,e,t,r)}return i};Writable.prototype.cork=function(){this._writableState.corked++};Writable.prototype.uncork=function(){var e=this._writableState;if(e.corked){e.corked--;if(!e.writing&&!e.corked&&!e.bufferProcessing&&e.bufferedRequest)clearBuffer(this,e)}};Writable.prototype.setDefaultEncoding=function setDefaultEncoding(e){if(typeof e==="string")e=e.toLowerCase();if(!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((e+"").toLowerCase())>-1))throw new v(e);this._writableState.defaultEncoding=e;return this};Object.defineProperty(Writable.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});function decodeChunk(e,t,r){if(!e.objectMode&&e.decodeStrings!==false&&typeof t==="string"){t=o.from(t,r)}return t}Object.defineProperty(Writable.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});function writeOrBuffer(e,t,r,n,i,a){if(!r){var o=decodeChunk(t,n,i);if(n!==o){r=true;i="buffer";n=o}}var s=t.objectMode?1:n.length;t.length+=s;var f=t.length<t.highWaterMark;if(!f)t.needDrain=true;if(t.writing||t.corked){var l=t.lastBufferedRequest;t.lastBufferedRequest={chunk:n,encoding:i,isBuf:r,callback:a,next:null};if(l){l.next=t.lastBufferedRequest}else{t.bufferedRequest=t.lastBufferedRequest}t.bufferedRequestCount+=1}else{doWrite(e,t,false,s,n,i,a)}return f}function doWrite(e,t,r,n,i,a,o){t.writelen=n;t.writecb=o;t.writing=true;t.sync=true;if(t.destroyed)t.onwrite(new y("write"));else if(r)e._writev(i,t.onwrite);else e._write(i,a,t.onwrite);t.sync=false}function onwriteError(e,t,r,n,i){--t.pendingcb;if(r){process.nextTick(i,n);process.nextTick(finishMaybe,e,t);e._writableState.errorEmitted=true;m(e,n)}else{i(n);e._writableState.errorEmitted=true;m(e,n);finishMaybe(e,t)}}function onwriteStateUpdate(e){e.writing=false;e.writecb=null;e.length-=e.writelen;e.writelen=0}function onwrite(e,t){var r=e._writableState;var n=r.sync;var i=r.writecb;if(typeof i!=="function")throw new p;onwriteStateUpdate(r);if(t)onwriteError(e,r,n,t,i);else{var a=needFinish(r)||e.destroyed;if(!a&&!r.corked&&!r.bufferProcessing&&r.bufferedRequest){clearBuffer(e,r)}if(n){process.nextTick(afterWrite,e,r,a,i)}else{afterWrite(e,r,a,i)}}}function afterWrite(e,t,r,n){if(!r)onwriteDrain(e,t);t.pendingcb--;n();finishMaybe(e,t)}function onwriteDrain(e,t){if(t.length===0&&t.needDrain){t.needDrain=false;e.emit("drain")}}function clearBuffer(e,t){t.bufferProcessing=true;var r=t.bufferedRequest;if(e._writev&&r&&r.next){var n=t.bufferedRequestCount;var i=new Array(n);var a=t.corkedRequestsFree;a.entry=r;var o=0;var s=true;while(r){i[o]=r;if(!r.isBuf)s=false;r=r.next;o+=1}i.allBuffers=s;doWrite(e,t,true,t.length,i,"",a.finish);t.pendingcb++;t.lastBufferedRequest=null;if(a.next){t.corkedRequestsFree=a.next;a.next=null}else{t.corkedRequestsFree=new CorkedRequest(t)}t.bufferedRequestCount=0}else{while(r){var f=r.chunk;var l=r.encoding;var u=r.callback;var d=t.objectMode?1:f.length;doWrite(e,t,false,d,f,l,u);r=r.next;t.bufferedRequestCount--;if(t.writing){break}}if(r===null)t.lastBufferedRequest=null}t.bufferedRequest=r;t.bufferProcessing=false}Writable.prototype._write=function(e,t,r){r(new h("_write()"))};Writable.prototype._writev=null;Writable.prototype.end=function(e,t,r){var n=this._writableState;if(typeof e==="function"){r=e;e=null;t=null}else if(typeof t==="function"){r=t;t=null}if(e!==null&&e!==undefined)this.write(e,t);if(n.corked){n.corked=1;this.uncork()}if(!n.ending)endWritable(this,n,r);return this};Object.defineProperty(Writable.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function needFinish(e){return e.ending&&e.length===0&&e.bufferedRequest===null&&!e.finished&&!e.writing}function callFinal(e,t){e._final((function(r){t.pendingcb--;if(r){m(e,r)}t.prefinished=true;e.emit("prefinish");finishMaybe(e,t)}))}function prefinish(e,t){if(!t.prefinished&&!t.finalCalled){if(typeof e._final==="function"&&!t.destroyed){t.pendingcb++;t.finalCalled=true;process.nextTick(callFinal,e,t)}else{t.prefinished=true;e.emit("prefinish")}}}function finishMaybe(e,t){var r=needFinish(t);if(r){prefinish(e,t);if(t.pendingcb===0){t.finished=true;e.emit("finish");if(t.autoDestroy){var n=e._readableState;if(!n||n.autoDestroy&&n.endEmitted){e.destroy()}}}}return r}function endWritable(e,t,r){t.ending=true;finishMaybe(e,t);if(r){if(t.finished)process.nextTick(r);else e.once("finish",r)}t.ended=true;e.writable=false}function onCorkedFinish(e,t,r){var n=e.entry;e.entry=null;while(n){var i=n.callback;t.pendingcb--;i(r);n=n.next}t.corkedRequestsFree.next=e}Object.defineProperty(Writable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._writableState===undefined){return false}return this._writableState.destroyed},set:function set(e){if(!this._writableState){return}this._writableState.destroyed=e}});Writable.prototype.destroy=f.destroy;Writable.prototype._undestroy=f.undestroy;Writable.prototype._destroy=function(e,t){t(e)}},224:function(e,t,r){"use strict";var n;function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var i=r(7);var a=Symbol("lastResolve");var o=Symbol("lastReject");var s=Symbol("error");var f=Symbol("ended");var l=Symbol("lastPromise");var u=Symbol("handlePromise");var d=Symbol("stream");function createIterResult(e,t){return{value:e,done:t}}function readAndResolve(e){var t=e[a];if(t!==null){var r=e[d].read();if(r!==null){e[l]=null;e[a]=null;e[o]=null;t(createIterResult(r,false))}}}function onReadable(e){process.nextTick(readAndResolve,e)}function wrapForNext(e,t){return function(r,n){e.then((function(){if(t[f]){r(createIterResult(undefined,true));return}t[u](r,n)}),n)}}var c=Object.getPrototypeOf((function(){}));var h=Object.setPrototypeOf((n={get stream(){return this[d]},next:function next(){var e=this;var t=this[s];if(t!==null){return Promise.reject(t)}if(this[f]){return Promise.resolve(createIterResult(undefined,true))}if(this[d].destroyed){return new Promise((function(t,r){process.nextTick((function(){if(e[s]){r(e[s])}else{t(createIterResult(undefined,true))}}))}))}var r=this[l];var n;if(r){n=new Promise(wrapForNext(r,this))}else{var i=this[d].read();if(i!==null){return Promise.resolve(createIterResult(i,false))}n=new Promise(this[u])}this[l]=n;return n}},_defineProperty(n,Symbol.asyncIterator,(function(){return this})),_defineProperty(n,"return",(function _return(){var e=this;return new Promise((function(t,r){e[d].destroy(null,(function(e){if(e){r(e);return}t(createIterResult(undefined,true))}))}))})),n),c);var p=function createReadableStreamAsyncIterator(e){var t;var r=Object.create(h,(t={},_defineProperty(t,d,{value:e,writable:true}),_defineProperty(t,a,{value:null,writable:true}),_defineProperty(t,o,{value:null,writable:true}),_defineProperty(t,s,{value:null,writable:true}),_defineProperty(t,f,{value:e._readableState.endEmitted,writable:true}),_defineProperty(t,u,{value:function value(e,t){var n=r[d].read();if(n){r[l]=null;r[a]=null;r[o]=null;e(createIterResult(n,false))}else{r[a]=e;r[o]=t}},writable:true}),t));r[l]=null;i(e,(function(e){if(e&&e.code!=="ERR_STREAM_PREMATURE_CLOSE"){var t=r[o];if(t!==null){r[l]=null;r[a]=null;r[o]=null;t(e)}r[s]=e;return}var n=r[a];if(n!==null){r[l]=null;r[a]=null;r[o]=null;n(createIterResult(undefined,true))}r[f]=true}));e.on("readable",onReadable.bind(null,r));return r};e.exports=p},41:function(e,t,r){"use strict";function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);if(t)n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,n)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}function _classCallCheck(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function")}}function _defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||false;n.configurable=true;if("value"in n)n.writable=true;Object.defineProperty(e,n.key,n)}}function _createClass(e,t,r){if(t)_defineProperties(e.prototype,t);if(r)_defineProperties(e,r);return e}var n=r(300),i=n.Buffer;var a=r(837),o=a.inspect;var s=o&&o.custom||"inspect";function copyBuffer(e,t,r){i.prototype.copy.call(e,t,r)}e.exports=function(){function BufferList(){_classCallCheck(this,BufferList);this.head=null;this.tail=null;this.length=0}_createClass(BufferList,[{key:"push",value:function push(e){var t={data:e,next:null};if(this.length>0)this.tail.next=t;else this.head=t;this.tail=t;++this.length}},{key:"unshift",value:function unshift(e){var t={data:e,next:this.head};if(this.length===0)this.tail=t;this.head=t;++this.length}},{key:"shift",value:function shift(){if(this.length===0)return;var e=this.head.data;if(this.length===1)this.head=this.tail=null;else this.head=this.head.next;--this.length;return e}},{key:"clear",value:function clear(){this.head=this.tail=null;this.length=0}},{key:"join",value:function join(e){if(this.length===0)return"";var t=this.head;var r=""+t.data;while(t=t.next){r+=e+t.data}return r}},{key:"concat",value:function concat(e){if(this.length===0)return i.alloc(0);var t=i.allocUnsafe(e>>>0);var r=this.head;var n=0;while(r){copyBuffer(r.data,t,n);n+=r.data.length;r=r.next}return t}},{key:"consume",value:function consume(e,t){var r;if(e<this.head.data.length){r=this.head.data.slice(0,e);this.head.data=this.head.data.slice(e)}else if(e===this.head.data.length){r=this.shift()}else{r=t?this._getString(e):this._getBuffer(e)}return r}},{key:"first",value:function first(){return this.head.data}},{key:"_getString",value:function _getString(e){var t=this.head;var r=1;var n=t.data;e-=n.length;while(t=t.next){var i=t.data;var a=e>i.length?i.length:e;if(a===i.length)n+=i;else n+=i.slice(0,e);e-=a;if(e===0){if(a===i.length){++r;if(t.next)this.head=t.next;else this.head=this.tail=null}else{this.head=t;t.data=i.slice(a)}break}++r}this.length-=r;return n}},{key:"_getBuffer",value:function _getBuffer(e){var t=i.allocUnsafe(e);var r=this.head;var n=1;r.data.copy(t);e-=r.data.length;while(r=r.next){var a=r.data;var o=e>a.length?a.length:e;a.copy(t,t.length-e,0,o);e-=o;if(e===0){if(o===a.length){++n;if(r.next)this.head=r.next;else this.head=this.tail=null}else{this.head=r;r.data=a.slice(o)}break}++n}this.length-=n;return t}},{key:s,value:function value(e,t){return o(this,_objectSpread({},t,{depth:0,customInspect:false}))}}]);return BufferList}()},289:function(e){"use strict";function destroy(e,t){var r=this;var n=this._readableState&&this._readableState.destroyed;var i=this._writableState&&this._writableState.destroyed;if(n||i){if(t){t(e)}else if(e){if(!this._writableState){process.nextTick(emitErrorNT,this,e)}else if(!this._writableState.errorEmitted){this._writableState.errorEmitted=true;process.nextTick(emitErrorNT,this,e)}}return this}if(this._readableState){this._readableState.destroyed=true}if(this._writableState){this._writableState.destroyed=true}this._destroy(e||null,(function(e){if(!t&&e){if(!r._writableState){process.nextTick(emitErrorAndCloseNT,r,e)}else if(!r._writableState.errorEmitted){r._writableState.errorEmitted=true;process.nextTick(emitErrorAndCloseNT,r,e)}else{process.nextTick(emitCloseNT,r)}}else if(t){process.nextTick(emitCloseNT,r);t(e)}else{process.nextTick(emitCloseNT,r)}}));return this}function emitErrorAndCloseNT(e,t){emitErrorNT(e,t);emitCloseNT(e)}function emitCloseNT(e){if(e._writableState&&!e._writableState.emitClose)return;if(e._readableState&&!e._readableState.emitClose)return;e.emit("close")}function undestroy(){if(this._readableState){this._readableState.destroyed=false;this._readableState.reading=false;this._readableState.ended=false;this._readableState.endEmitted=false}if(this._writableState){this._writableState.destroyed=false;this._writableState.ended=false;this._writableState.ending=false;this._writableState.finalCalled=false;this._writableState.prefinished=false;this._writableState.finished=false;this._writableState.errorEmitted=false}}function emitErrorNT(e,t){e.emit("error",t)}function errorOrDestroy(e,t){var r=e._readableState;var n=e._writableState;if(r&&r.autoDestroy||n&&n.autoDestroy)e.destroy(t);else e.emit("error",t)}e.exports={destroy:destroy,undestroy:undestroy,errorOrDestroy:errorOrDestroy}},7:function(e,t,r){"use strict";var n=r(349).q.ERR_STREAM_PREMATURE_CLOSE;function once(e){var t=false;return function(){if(t)return;t=true;for(var r=arguments.length,n=new Array(r),i=0;i<r;i++){n[i]=arguments[i]}e.apply(this,n)}}function noop(){}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function eos(e,t,r){if(typeof t==="function")return eos(e,null,t);if(!t)t={};r=once(r||noop);var i=t.readable||t.readable!==false&&e.readable;var a=t.writable||t.writable!==false&&e.writable;var o=function onlegacyfinish(){if(!e.writable)f()};var s=e._writableState&&e._writableState.finished;var f=function onfinish(){a=false;s=true;if(!i)r.call(e)};var l=e._readableState&&e._readableState.endEmitted;var u=function onend(){i=false;l=true;if(!a)r.call(e)};var d=function onerror(t){r.call(e,t)};var c=function onclose(){var t;if(i&&!l){if(!e._readableState||!e._readableState.ended)t=new n;return r.call(e,t)}if(a&&!s){if(!e._writableState||!e._writableState.ended)t=new n;return r.call(e,t)}};var h=function onrequest(){e.req.on("finish",f)};if(isRequest(e)){e.on("complete",f);e.on("abort",c);if(e.req)h();else e.on("request",h)}else if(a&&!e._writableState){e.on("end",o);e.on("close",o)}e.on("end",u);e.on("finish",f);if(t.error!==false)e.on("error",d);e.on("close",c);return function(){e.removeListener("complete",f);e.removeListener("abort",c);e.removeListener("request",h);if(e.req)e.req.removeListener("finish",f);e.removeListener("end",o);e.removeListener("close",o);e.removeListener("finish",f);e.removeListener("end",u);e.removeListener("error",d);e.removeListener("close",c)}}e.exports=eos},720:function(e,t,r){"use strict";function asyncGeneratorStep(e,t,r,n,i,a,o){try{var s=e[a](o);var f=s.value}catch(e){r(e);return}if(s.done){t(f)}else{Promise.resolve(f).then(n,i)}}function _asyncToGenerator(e){return function(){var t=this,r=arguments;return new Promise((function(n,i){var a=e.apply(t,r);function _next(e){asyncGeneratorStep(a,n,i,_next,_throw,"next",e)}function _throw(e){asyncGeneratorStep(a,n,i,_next,_throw,"throw",e)}_next(undefined)}))}}function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);if(t)n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,n)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var n=r(349).q.ERR_INVALID_ARG_TYPE;function from(e,t,r){var i;if(t&&typeof t.next==="function"){i=t}else if(t&&t[Symbol.asyncIterator])i=t[Symbol.asyncIterator]();else if(t&&t[Symbol.iterator])i=t[Symbol.iterator]();else throw new n("iterable",["Iterable"],t);var a=new e(_objectSpread({objectMode:true},r));var o=false;a._read=function(){if(!o){o=true;next()}};function next(){return _next2.apply(this,arguments)}function _next2(){_next2=_asyncToGenerator((function*(){try{var e=yield i.next(),t=e.value,r=e.done;if(r){a.push(null)}else if(a.push(yield t)){next()}else{o=false}}catch(e){a.destroy(e)}}));return _next2.apply(this,arguments)}return a}e.exports=from},522:function(e,t,r){"use strict";var n;function once(e){var t=false;return function(){if(t)return;t=true;e.apply(void 0,arguments)}}var i=r(349).q,a=i.ERR_MISSING_ARGS,o=i.ERR_STREAM_DESTROYED;function noop(e){if(e)throw e}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function destroyer(e,t,i,a){a=once(a);var s=false;e.on("close",(function(){s=true}));if(n===undefined)n=r(7);n(e,{readable:t,writable:i},(function(e){if(e)return a(e);s=true;a()}));var f=false;return function(t){if(s)return;if(f)return;f=true;if(isRequest(e))return e.abort();if(typeof e.destroy==="function")return e.destroy();a(t||new o("pipe"))}}function call(e){e()}function pipe(e,t){return e.pipe(t)}function popCallback(e){if(!e.length)return noop;if(typeof e[e.length-1]!=="function")return noop;return e.pop()}function pipeline(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++){t[r]=arguments[r]}var n=popCallback(t);if(Array.isArray(t[0]))t=t[0];if(t.length<2){throw new a("streams")}var i;var o=t.map((function(e,r){var a=r<t.length-1;var s=r>0;return destroyer(e,a,s,(function(e){if(!i)i=e;if(e)o.forEach(call);if(a)return;o.forEach(call);n(i)}))}));return t.reduce(pipe)}e.exports=pipeline},483:function(e,t,r){"use strict";var n=r(349).q.ERR_INVALID_OPT_VALUE;function highWaterMarkFrom(e,t,r){return e.highWaterMark!=null?e.highWaterMark:t?e[r]:null}function getHighWaterMark(e,t,r,i){var a=highWaterMarkFrom(t,i,r);if(a!=null){if(!(isFinite(a)&&Math.floor(a)===a)||a<0){var o=i?r:"highWaterMark";throw new n(o,a)}return Math.floor(a)}return e.objectMode?16:16*1024}e.exports={getHighWaterMark:getHighWaterMark}},455:function(e,t,r){e.exports=r(781)},381:function(e,t,r){var n=r(781);if(process.env.READABLE_STREAM==="disable"&&n){e.exports=n.Readable;Object.assign(e.exports,n);e.exports.Stream=n}else{t=e.exports=r(787);t.Stream=n||t;t.Readable=t;t.Writable=r(513);t.Duplex=r(716);t.Transform=r(551);t.PassThrough=r(788);t.finished=r(7);t.pipeline=r(522)}},207:function(e,t,r){var n=r(300);var i=n.Buffer;function copyProps(e,t){for(var r in e){t[r]=e[r]}}if(i.from&&i.alloc&&i.allocUnsafe&&i.allocUnsafeSlow){e.exports=n}else{copyProps(n,t);t.Buffer=SafeBuffer}function SafeBuffer(e,t,r){return i(e,t,r)}SafeBuffer.prototype=Object.create(i.prototype);copyProps(i,SafeBuffer);SafeBuffer.from=function(e,t,r){if(typeof e==="number"){throw new TypeError("Argument must not be a number")}return i(e,t,r)};SafeBuffer.alloc=function(e,t,r){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}var n=i(e);if(t!==undefined){if(typeof r==="string"){n.fill(t,r)}else{n.fill(t)}}else{n.fill(0)}return n};SafeBuffer.allocUnsafe=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return i(e)};SafeBuffer.allocUnsafeSlow=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return n.SlowBuffer(e)}},333:function(e,t,r){var n=r(66);var i=r(418);var a=r(90);var o=r(699);var s=r(310);var f=t;f.request=function(e,t){if(typeof e==="string")e=s.parse(e);else e=a(e);var r=__webpack_require__.g.location.protocol.search(/^https?:$/)===-1?"http:":"";var i=e.protocol||r;var o=e.hostname||e.host;var f=e.port;var l=e.path||"/";if(o&&o.indexOf(":")!==-1)o="["+o+"]";e.url=(o?i+"//"+o:"")+(f?":"+f:"")+l;e.method=(e.method||"GET").toUpperCase();e.headers=e.headers||{};var u=new n(e);if(t)u.on("response",t);return u};f.get=function get(e,t){var r=f.request(e,t);r.end();return r};f.ClientRequest=n;f.IncomingMessage=i.IncomingMessage;f.Agent=function(){};f.Agent.defaultMaxSockets=4;f.globalAgent=new f.Agent;f.STATUS_CODES=o;f.METHODS=["CHECKOUT","CONNECT","COPY","DELETE","GET","HEAD","LOCK","M-SEARCH","MERGE","MKACTIVITY","MKCOL","MOVE","NOTIFY","OPTIONS","PATCH","POST","PROPFIND","PROPPATCH","PURGE","PUT","REPORT","SEARCH","SUBSCRIBE","TRACE","UNLOCK","UNSUBSCRIBE"]},762:function(e,t){t.fetch=isFunction(__webpack_require__.g.fetch)&&isFunction(__webpack_require__.g.ReadableStream);t.writableStream=isFunction(__webpack_require__.g.WritableStream);t.abortController=isFunction(__webpack_require__.g.AbortController);var r;function getXHR(){if(r!==undefined)return r;if(__webpack_require__.g.XMLHttpRequest){r=new __webpack_require__.g.XMLHttpRequest;try{r.open("GET",__webpack_require__.g.XDomainRequest?"/":"https://example.com")}catch(e){r=null}}else{r=null}return r}function checkTypeSupport(e){var t=getXHR();if(!t)return false;try{t.responseType=e;return t.responseType===e}catch(e){}return false}t.arraybuffer=t.fetch||checkTypeSupport("arraybuffer");t.msstream=!t.fetch&&checkTypeSupport("ms-stream");t.mozchunkedarraybuffer=!t.fetch&&checkTypeSupport("moz-chunked-arraybuffer");t.overrideMimeType=t.fetch||(getXHR()?isFunction(getXHR().overrideMimeType):false);function isFunction(e){return typeof e==="function"}r=null},66:function(e,t,r){var n=r(762);var i=r(140);var a=r(418);var o=r(381);var s=a.IncomingMessage;var f=a.readyStates;function decideMode(e,t){if(n.fetch&&t){return"fetch"}else if(n.mozchunkedarraybuffer){return"moz-chunked-arraybuffer"}else if(n.msstream){return"ms-stream"}else if(n.arraybuffer&&e){return"arraybuffer"}else{return"text"}}var l=e.exports=function(e){var t=this;o.Writable.call(t);t._opts=e;t._body=[];t._headers={};if(e.auth)t.setHeader("Authorization","Basic "+Buffer.from(e.auth).toString("base64"));Object.keys(e.headers).forEach((function(r){t.setHeader(r,e.headers[r])}));var r;var i=true;if(e.mode==="disable-fetch"||"requestTimeout"in e&&!n.abortController){i=false;r=true}else if(e.mode==="prefer-streaming"){r=false}else if(e.mode==="allow-wrong-content-type"){r=!n.overrideMimeType}else if(!e.mode||e.mode==="default"||e.mode==="prefer-fast"){r=true}else{throw new Error("Invalid value for opts.mode")}t._mode=decideMode(r,i);t._fetchTimer=null;t.on("finish",(function(){t._onFinish()}))};i(l,o.Writable);l.prototype.setHeader=function(e,t){var r=this;var n=e.toLowerCase();if(u.indexOf(n)!==-1)return;r._headers[n]={name:e,value:t}};l.prototype.getHeader=function(e){var t=this._headers[e.toLowerCase()];if(t)return t.value;return null};l.prototype.removeHeader=function(e){var t=this;delete t._headers[e.toLowerCase()]};l.prototype._onFinish=function(){var e=this;if(e._destroyed)return;var t=e._opts;var r=e._headers;var i=null;if(t.method!=="GET"&&t.method!=="HEAD"){i=new Blob(e._body,{type:(r["content-type"]||{}).value||""})}var a=[];Object.keys(r).forEach((function(e){var t=r[e].name;var n=r[e].value;if(Array.isArray(n)){n.forEach((function(e){a.push([t,e])}))}else{a.push([t,n])}}));if(e._mode==="fetch"){var o=null;if(n.abortController){var s=new AbortController;o=s.signal;e._fetchAbortController=s;if("requestTimeout"in t&&t.requestTimeout!==0){e._fetchTimer=__webpack_require__.g.setTimeout((function(){e.emit("requestTimeout");if(e._fetchAbortController)e._fetchAbortController.abort()}),t.requestTimeout)}}__webpack_require__.g.fetch(e._opts.url,{method:e._opts.method,headers:a,body:i||undefined,mode:"cors",credentials:t.withCredentials?"include":"same-origin",signal:o}).then((function(t){e._fetchResponse=t;e._connect()}),(function(t){__webpack_require__.g.clearTimeout(e._fetchTimer);if(!e._destroyed)e.emit("error",t)}))}else{var l=e._xhr=new __webpack_require__.g.XMLHttpRequest;try{l.open(e._opts.method,e._opts.url,true)}catch(t){process.nextTick((function(){e.emit("error",t)}));return}if("responseType"in l)l.responseType=e._mode;if("withCredentials"in l)l.withCredentials=!!t.withCredentials;if(e._mode==="text"&&"overrideMimeType"in l)l.overrideMimeType("text/plain; charset=x-user-defined");if("requestTimeout"in t){l.timeout=t.requestTimeout;l.ontimeout=function(){e.emit("requestTimeout")}}a.forEach((function(e){l.setRequestHeader(e[0],e[1])}));e._response=null;l.onreadystatechange=function(){switch(l.readyState){case f.LOADING:case f.DONE:e._onXHRProgress();break}};if(e._mode==="moz-chunked-arraybuffer"){l.onprogress=function(){e._onXHRProgress()}}l.onerror=function(){if(e._destroyed)return;e.emit("error",new Error("XHR error"))};try{l.send(i)}catch(t){process.nextTick((function(){e.emit("error",t)}));return}}};function statusValid(e){try{var t=e.status;return t!==null&&t!==0}catch(e){return false}}l.prototype._onXHRProgress=function(){var e=this;if(!statusValid(e._xhr)||e._destroyed)return;if(!e._response)e._connect();e._response._onXHRProgress()};l.prototype._connect=function(){var e=this;if(e._destroyed)return;e._response=new s(e._xhr,e._fetchResponse,e._mode,e._fetchTimer);e._response.on("error",(function(t){e.emit("error",t)}));e.emit("response",e._response)};l.prototype._write=function(e,t,r){var n=this;n._body.push(e);r()};l.prototype.abort=l.prototype.destroy=function(){var e=this;e._destroyed=true;__webpack_require__.g.clearTimeout(e._fetchTimer);if(e._response)e._response._destroyed=true;if(e._xhr)e._xhr.abort();else if(e._fetchAbortController)e._fetchAbortController.abort()};l.prototype.end=function(e,t,r){var n=this;if(typeof e==="function"){r=e;e=undefined}o.Writable.prototype.end.call(n,e,t,r)};l.prototype.flushHeaders=function(){};l.prototype.setTimeout=function(){};l.prototype.setNoDelay=function(){};l.prototype.setSocketKeepAlive=function(){};var u=["accept-charset","accept-encoding","access-control-request-headers","access-control-request-method","connection","content-length","cookie","cookie2","date","dnt","expect","host","keep-alive","origin","referer","te","trailer","transfer-encoding","upgrade","via"]},418:function(e,t,r){var n=r(762);var i=r(140);var a=r(381);var o=t.readyStates={UNSENT:0,OPENED:1,HEADERS_RECEIVED:2,LOADING:3,DONE:4};var s=t.IncomingMessage=function(e,t,r,i){var o=this;a.Readable.call(o);o._mode=r;o.headers={};o.rawHeaders=[];o.trailers={};o.rawTrailers=[];o.on("end",(function(){process.nextTick((function(){o.emit("close")}))}));if(r==="fetch"){o._fetchResponse=t;o.url=t.url;o.statusCode=t.status;o.statusMessage=t.statusText;t.headers.forEach((function(e,t){o.headers[t.toLowerCase()]=e;o.rawHeaders.push(t,e)}));if(n.writableStream){var s=new WritableStream({write:function(e){return new Promise((function(t,r){if(o._destroyed){r()}else if(o.push(Buffer.from(e))){t()}else{o._resumeFetch=t}}))},close:function(){__webpack_require__.g.clearTimeout(i);if(!o._destroyed)o.push(null)},abort:function(e){if(!o._destroyed)o.emit("error",e)}});try{t.body.pipeTo(s).catch((function(e){__webpack_require__.g.clearTimeout(i);if(!o._destroyed)o.emit("error",e)}));return}catch(e){}}var f=t.body.getReader();function read(){f.read().then((function(e){if(o._destroyed)return;if(e.done){__webpack_require__.g.clearTimeout(i);o.push(null);return}o.push(Buffer.from(e.value));read()})).catch((function(e){__webpack_require__.g.clearTimeout(i);if(!o._destroyed)o.emit("error",e)}))}read()}else{o._xhr=e;o._pos=0;o.url=e.responseURL;o.statusCode=e.status;o.statusMessage=e.statusText;var l=e.getAllResponseHeaders().split(/\r?\n/);l.forEach((function(e){var t=e.match(/^([^:]+):\s*(.*)/);if(t){var r=t[1].toLowerCase();if(r==="set-cookie"){if(o.headers[r]===undefined){o.headers[r]=[]}o.headers[r].push(t[2])}else if(o.headers[r]!==undefined){o.headers[r]+=", "+t[2]}else{o.headers[r]=t[2]}o.rawHeaders.push(t[1],t[2])}}));o._charset="x-user-defined";if(!n.overrideMimeType){var u=o.rawHeaders["mime-type"];if(u){var d=u.match(/;\s*charset=([^;])(;|$)/);if(d){o._charset=d[1].toLowerCase()}}if(!o._charset)o._charset="utf-8"}}};i(s,a.Readable);s.prototype._read=function(){var e=this;var t=e._resumeFetch;if(t){e._resumeFetch=null;t()}};s.prototype._onXHRProgress=function(){var e=this;var t=e._xhr;var r=null;switch(e._mode){case"text":r=t.responseText;if(r.length>e._pos){var n=r.substr(e._pos);if(e._charset==="x-user-defined"){var i=Buffer.alloc(n.length);for(var a=0;a<n.length;a++)i[a]=n.charCodeAt(a)&255;e.push(i)}else{e.push(n,e._charset)}e._pos=r.length}break;case"arraybuffer":if(t.readyState!==o.DONE||!t.response)break;r=t.response;e.push(Buffer.from(new Uint8Array(r)));break;case"moz-chunked-arraybuffer":r=t.response;if(t.readyState!==o.LOADING||!r)break;e.push(Buffer.from(new Uint8Array(r)));break;case"ms-stream":r=t.response;if(t.readyState!==o.LOADING)break;var s=new __webpack_require__.g.MSStreamReader;s.onprogress=function(){if(s.result.byteLength>e._pos){e.push(Buffer.from(new Uint8Array(s.result.slice(e._pos))));e._pos=s.result.byteLength}};s.onload=function(){e.push(null)};s.readAsArrayBuffer(r);break}if(e._xhr.readyState===o.DONE&&e._mode!=="ms-stream"){e.push(null)}}},862:function(e,t,r){"use strict";var n=r(207).Buffer;var i=n.isEncoding||function(e){e=""+e;switch(e&&e.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return true;default:return false}};function _normalizeEncoding(e){if(!e)return"utf8";var t;while(true){switch(e){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return e;default:if(t)return;e=(""+e).toLowerCase();t=true}}}function normalizeEncoding(e){var t=_normalizeEncoding(e);if(typeof t!=="string"&&(n.isEncoding===i||!i(e)))throw new Error("Unknown encoding: "+e);return t||e}t.s=StringDecoder;function StringDecoder(e){this.encoding=normalizeEncoding(e);var t;switch(this.encoding){case"utf16le":this.text=utf16Text;this.end=utf16End;t=4;break;case"utf8":this.fillLast=utf8FillLast;t=4;break;case"base64":this.text=base64Text;this.end=base64End;t=3;break;default:this.write=simpleWrite;this.end=simpleEnd;return}this.lastNeed=0;this.lastTotal=0;this.lastChar=n.allocUnsafe(t)}StringDecoder.prototype.write=function(e){if(e.length===0)return"";var t;var r;if(this.lastNeed){t=this.fillLast(e);if(t===undefined)return"";r=this.lastNeed;this.lastNeed=0}else{r=0}if(r<e.length)return t?t+this.text(e,r):this.text(e,r);return t||""};StringDecoder.prototype.end=utf8End;StringDecoder.prototype.text=utf8Text;StringDecoder.prototype.fillLast=function(e){if(this.lastNeed<=e.length){e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,e.length);this.lastNeed-=e.length};function utf8CheckByte(e){if(e<=127)return 0;else if(e>>5===6)return 2;else if(e>>4===14)return 3;else if(e>>3===30)return 4;return e>>6===2?-1:-2}function utf8CheckIncomplete(e,t,r){var n=t.length-1;if(n<r)return 0;var i=utf8CheckByte(t[n]);if(i>=0){if(i>0)e.lastNeed=i-1;return i}if(--n<r||i===-2)return 0;i=utf8CheckByte(t[n]);if(i>=0){if(i>0)e.lastNeed=i-2;return i}if(--n<r||i===-2)return 0;i=utf8CheckByte(t[n]);if(i>=0){if(i>0){if(i===2)i=0;else e.lastNeed=i-3}return i}return 0}function utf8CheckExtraBytes(e,t,r){if((t[0]&192)!==128){e.lastNeed=0;return"�"}if(e.lastNeed>1&&t.length>1){if((t[1]&192)!==128){e.lastNeed=1;return"�"}if(e.lastNeed>2&&t.length>2){if((t[2]&192)!==128){e.lastNeed=2;return"�"}}}}function utf8FillLast(e){var t=this.lastTotal-this.lastNeed;var r=utf8CheckExtraBytes(this,e,t);if(r!==undefined)return r;if(this.lastNeed<=e.length){e.copy(this.lastChar,t,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,t,0,e.length);this.lastNeed-=e.length}function utf8Text(e,t){var r=utf8CheckIncomplete(this,e,t);if(!this.lastNeed)return e.toString("utf8",t);this.lastTotal=r;var n=e.length-(r-this.lastNeed);e.copy(this.lastChar,0,n);return e.toString("utf8",t,n)}function utf8End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+"�";return t}function utf16Text(e,t){if((e.length-t)%2===0){var r=e.toString("utf16le",t);if(r){var n=r.charCodeAt(r.length-1);if(n>=55296&&n<=56319){this.lastNeed=2;this.lastTotal=4;this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1];return r.slice(0,-1)}}return r}this.lastNeed=1;this.lastTotal=2;this.lastChar[0]=e[e.length-1];return e.toString("utf16le",t,e.length-1)}function utf16End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed){var r=this.lastTotal-this.lastNeed;return t+this.lastChar.toString("utf16le",0,r)}return t}function base64Text(e,t){var r=(e.length-t)%3;if(r===0)return e.toString("base64",t);this.lastNeed=3-r;this.lastTotal=3;if(r===1){this.lastChar[0]=e[e.length-1]}else{this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1]}return e.toString("base64",t,e.length-r)}function base64End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+this.lastChar.toString("base64",0,3-this.lastNeed);return t}function simpleWrite(e){return e.toString(this.encoding)}function simpleEnd(e){return e&&e.length?this.write(e):""}},777:function(e){e.exports=deprecate;function deprecate(e,t){if(config("noDeprecation")){return e}var r=false;function deprecated(){if(!r){if(config("throwDeprecation")){throw new Error(t)}else if(config("traceDeprecation")){console.trace(t)}else{console.warn(t)}r=true}return e.apply(this,arguments)}return deprecated}function config(e){try{if(!__webpack_require__.g.localStorage)return false}catch(e){return false}var t=__webpack_require__.g.localStorage[e];if(null==t)return false;return String(t).toLowerCase()==="true"}},90:function(e){e.exports=extend;var t=Object.prototype.hasOwnProperty;function extend(){var e={};for(var r=0;r<arguments.length;r++){var n=arguments[r];for(var i in n){if(t.call(n,i)){e[i]=n[i]}}}return e}},300:function(e){"use strict";e.exports=__webpack_require__(48764)},361:function(e){"use strict";e.exports=__webpack_require__(25293)},781:function(e){"use strict";e.exports=__webpack_require__(79681)},310:function(e){"use strict";e.exports=__webpack_require__(11987)},837:function(e){"use strict";e.exports=__webpack_require__(79720)}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var a=true;try{e[r](i,i.exports,__nccwpck_require__);a=false}finally{if(a)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(333);module.exports=r})();

/***/ }),

/***/ 79720:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
/* provided dependency */ var process = __webpack_require__(83454);
(function(){var r={997:function(r){r.exports=function(r,t,n){if(r.filter)return r.filter(t,n);if(void 0===r||null===r)throw new TypeError;if("function"!=typeof t)throw new TypeError;var o=[];for(var i=0;i<r.length;i++){if(!e.call(r,i))continue;var a=r[i];if(t.call(n,a,i,r))o.push(a)}return o};var e=Object.prototype.hasOwnProperty},171:function(r,e,t){"use strict";var n=t(627);var o=t(302);var i=o(n("String.prototype.indexOf"));r.exports=function callBoundIntrinsic(r,e){var t=n(r,!!e);if(typeof t==="function"&&i(r,".prototype.")>-1){return o(t)}return t}},302:function(r,e,t){"use strict";var n=t(194);var o=t(627);var i=o("%Function.prototype.apply%");var a=o("%Function.prototype.call%");var f=o("%Reflect.apply%",true)||n.call(a,i);var u=o("%Object.getOwnPropertyDescriptor%",true);var s=o("%Object.defineProperty%",true);var c=o("%Math.max%");if(s){try{s({},"a",{value:1})}catch(r){s=null}}r.exports=function callBind(r){var e=f(n,a,arguments);if(u&&s){var t=u(e,"length");if(t.configurable){s(e,"length",{value:1+c(0,r.length-(arguments.length-1))})}}return e};var y=function applyBind(){return f(n,i,arguments)};if(s){s(r.exports,"apply",{value:y})}else{r.exports.apply=y}},981:function(r){var e=Object.prototype.hasOwnProperty;var t=Object.prototype.toString;r.exports=function forEach(r,n,o){if(t.call(n)!=="[object Function]"){throw new TypeError("iterator must be a function")}var i=r.length;if(i===+i){for(var a=0;a<i;a++){n.call(o,r[a],a,r)}}else{for(var f in r){if(e.call(r,f)){n.call(o,r[f],f,r)}}}}},861:function(r){"use strict";var e="Function.prototype.bind called on incompatible ";var t=Array.prototype.slice;var n=Object.prototype.toString;var o="[object Function]";r.exports=function bind(r){var i=this;if(typeof i!=="function"||n.call(i)!==o){throw new TypeError(e+i)}var a=t.call(arguments,1);var f;var binder=function(){if(this instanceof f){var e=i.apply(this,a.concat(t.call(arguments)));if(Object(e)===e){return e}return this}else{return i.apply(r,a.concat(t.call(arguments)))}};var u=Math.max(0,i.length-a.length);var s=[];for(var c=0;c<u;c++){s.push("$"+c)}f=Function("binder","return function ("+s.join(",")+"){ return binder.apply(this,arguments); }")(binder);if(i.prototype){var y=function Empty(){};y.prototype=i.prototype;f.prototype=new y;y.prototype=null}return f}},194:function(r,e,t){"use strict";var n=t(861);r.exports=Function.prototype.bind||n},627:function(r,e,t){"use strict";var n;var o=SyntaxError;var i=Function;var a=TypeError;var getEvalledConstructor=function(r){try{return i('"use strict"; return ('+r+").constructor;")()}catch(r){}};var f=Object.getOwnPropertyDescriptor;if(f){try{f({},"")}catch(r){f=null}}var throwTypeError=function(){throw new a};var u=f?function(){try{arguments.callee;return throwTypeError}catch(r){try{return f(arguments,"callee").get}catch(r){return throwTypeError}}}():throwTypeError;var s=t(567)();var c=Object.getPrototypeOf||function(r){return r.__proto__};var y={};var p=typeof Uint8Array==="undefined"?n:c(Uint8Array);var l={"%AggregateError%":typeof AggregateError==="undefined"?n:AggregateError,"%Array%":Array,"%ArrayBuffer%":typeof ArrayBuffer==="undefined"?n:ArrayBuffer,"%ArrayIteratorPrototype%":s?c([][Symbol.iterator]()):n,"%AsyncFromSyncIteratorPrototype%":n,"%AsyncFunction%":y,"%AsyncGenerator%":y,"%AsyncGeneratorFunction%":y,"%AsyncIteratorPrototype%":y,"%Atomics%":typeof Atomics==="undefined"?n:Atomics,"%BigInt%":typeof BigInt==="undefined"?n:BigInt,"%Boolean%":Boolean,"%DataView%":typeof DataView==="undefined"?n:DataView,"%Date%":Date,"%decodeURI%":decodeURI,"%decodeURIComponent%":decodeURIComponent,"%encodeURI%":encodeURI,"%encodeURIComponent%":encodeURIComponent,"%Error%":Error,"%eval%":eval,"%EvalError%":EvalError,"%Float32Array%":typeof Float32Array==="undefined"?n:Float32Array,"%Float64Array%":typeof Float64Array==="undefined"?n:Float64Array,"%FinalizationRegistry%":typeof FinalizationRegistry==="undefined"?n:FinalizationRegistry,"%Function%":i,"%GeneratorFunction%":y,"%Int8Array%":typeof Int8Array==="undefined"?n:Int8Array,"%Int16Array%":typeof Int16Array==="undefined"?n:Int16Array,"%Int32Array%":typeof Int32Array==="undefined"?n:Int32Array,"%isFinite%":isFinite,"%isNaN%":isNaN,"%IteratorPrototype%":s?c(c([][Symbol.iterator]())):n,"%JSON%":typeof JSON==="object"?JSON:n,"%Map%":typeof Map==="undefined"?n:Map,"%MapIteratorPrototype%":typeof Map==="undefined"||!s?n:c((new Map)[Symbol.iterator]()),"%Math%":Math,"%Number%":Number,"%Object%":Object,"%parseFloat%":parseFloat,"%parseInt%":parseInt,"%Promise%":typeof Promise==="undefined"?n:Promise,"%Proxy%":typeof Proxy==="undefined"?n:Proxy,"%RangeError%":RangeError,"%ReferenceError%":ReferenceError,"%Reflect%":typeof Reflect==="undefined"?n:Reflect,"%RegExp%":RegExp,"%Set%":typeof Set==="undefined"?n:Set,"%SetIteratorPrototype%":typeof Set==="undefined"||!s?n:c((new Set)[Symbol.iterator]()),"%SharedArrayBuffer%":typeof SharedArrayBuffer==="undefined"?n:SharedArrayBuffer,"%String%":String,"%StringIteratorPrototype%":s?c(""[Symbol.iterator]()):n,"%Symbol%":s?Symbol:n,"%SyntaxError%":o,"%ThrowTypeError%":u,"%TypedArray%":p,"%TypeError%":a,"%Uint8Array%":typeof Uint8Array==="undefined"?n:Uint8Array,"%Uint8ClampedArray%":typeof Uint8ClampedArray==="undefined"?n:Uint8ClampedArray,"%Uint16Array%":typeof Uint16Array==="undefined"?n:Uint16Array,"%Uint32Array%":typeof Uint32Array==="undefined"?n:Uint32Array,"%URIError%":URIError,"%WeakMap%":typeof WeakMap==="undefined"?n:WeakMap,"%WeakRef%":typeof WeakRef==="undefined"?n:WeakRef,"%WeakSet%":typeof WeakSet==="undefined"?n:WeakSet};var g=function doEval(r){var e;if(r==="%AsyncFunction%"){e=getEvalledConstructor("async function () {}")}else if(r==="%GeneratorFunction%"){e=getEvalledConstructor("function* () {}")}else if(r==="%AsyncGeneratorFunction%"){e=getEvalledConstructor("async function* () {}")}else if(r==="%AsyncGenerator%"){var t=doEval("%AsyncGeneratorFunction%");if(t){e=t.prototype}}else if(r==="%AsyncIteratorPrototype%"){var n=doEval("%AsyncGenerator%");if(n){e=c(n.prototype)}}l[r]=e;return e};var d={"%ArrayBufferPrototype%":["ArrayBuffer","prototype"],"%ArrayPrototype%":["Array","prototype"],"%ArrayProto_entries%":["Array","prototype","entries"],"%ArrayProto_forEach%":["Array","prototype","forEach"],"%ArrayProto_keys%":["Array","prototype","keys"],"%ArrayProto_values%":["Array","prototype","values"],"%AsyncFunctionPrototype%":["AsyncFunction","prototype"],"%AsyncGenerator%":["AsyncGeneratorFunction","prototype"],"%AsyncGeneratorPrototype%":["AsyncGeneratorFunction","prototype","prototype"],"%BooleanPrototype%":["Boolean","prototype"],"%DataViewPrototype%":["DataView","prototype"],"%DatePrototype%":["Date","prototype"],"%ErrorPrototype%":["Error","prototype"],"%EvalErrorPrototype%":["EvalError","prototype"],"%Float32ArrayPrototype%":["Float32Array","prototype"],"%Float64ArrayPrototype%":["Float64Array","prototype"],"%FunctionPrototype%":["Function","prototype"],"%Generator%":["GeneratorFunction","prototype"],"%GeneratorPrototype%":["GeneratorFunction","prototype","prototype"],"%Int8ArrayPrototype%":["Int8Array","prototype"],"%Int16ArrayPrototype%":["Int16Array","prototype"],"%Int32ArrayPrototype%":["Int32Array","prototype"],"%JSONParse%":["JSON","parse"],"%JSONStringify%":["JSON","stringify"],"%MapPrototype%":["Map","prototype"],"%NumberPrototype%":["Number","prototype"],"%ObjectPrototype%":["Object","prototype"],"%ObjProto_toString%":["Object","prototype","toString"],"%ObjProto_valueOf%":["Object","prototype","valueOf"],"%PromisePrototype%":["Promise","prototype"],"%PromiseProto_then%":["Promise","prototype","then"],"%Promise_all%":["Promise","all"],"%Promise_reject%":["Promise","reject"],"%Promise_resolve%":["Promise","resolve"],"%RangeErrorPrototype%":["RangeError","prototype"],"%ReferenceErrorPrototype%":["ReferenceError","prototype"],"%RegExpPrototype%":["RegExp","prototype"],"%SetPrototype%":["Set","prototype"],"%SharedArrayBufferPrototype%":["SharedArrayBuffer","prototype"],"%StringPrototype%":["String","prototype"],"%SymbolPrototype%":["Symbol","prototype"],"%SyntaxErrorPrototype%":["SyntaxError","prototype"],"%TypedArrayPrototype%":["TypedArray","prototype"],"%TypeErrorPrototype%":["TypeError","prototype"],"%Uint8ArrayPrototype%":["Uint8Array","prototype"],"%Uint8ClampedArrayPrototype%":["Uint8ClampedArray","prototype"],"%Uint16ArrayPrototype%":["Uint16Array","prototype"],"%Uint32ArrayPrototype%":["Uint32Array","prototype"],"%URIErrorPrototype%":["URIError","prototype"],"%WeakMapPrototype%":["WeakMap","prototype"],"%WeakSetPrototype%":["WeakSet","prototype"]};var v=t(194);var b=t(646);var A=v.call(Function.call,Array.prototype.concat);var m=v.call(Function.apply,Array.prototype.splice);var S=v.call(Function.call,String.prototype.replace);var h=v.call(Function.call,String.prototype.slice);var O=/[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;var w=/\\(\\)?/g;var j=function stringToPath(r){var e=h(r,0,1);var t=h(r,-1);if(e==="%"&&t!=="%"){throw new o("invalid intrinsic syntax, expected closing `%`")}else if(t==="%"&&e!=="%"){throw new o("invalid intrinsic syntax, expected opening `%`")}var n=[];S(r,O,(function(r,e,t,o){n[n.length]=t?S(o,w,"$1"):e||r}));return n};var P=function getBaseIntrinsic(r,e){var t=r;var n;if(b(d,t)){n=d[t];t="%"+n[0]+"%"}if(b(l,t)){var i=l[t];if(i===y){i=g(t)}if(typeof i==="undefined"&&!e){throw new a("intrinsic "+r+" exists, but is not available. Please file an issue!")}return{alias:n,name:t,value:i}}throw new o("intrinsic "+r+" does not exist!")};r.exports=function GetIntrinsic(r,e){if(typeof r!=="string"||r.length===0){throw new a("intrinsic name must be a non-empty string")}if(arguments.length>1&&typeof e!=="boolean"){throw new a('"allowMissing" argument must be a boolean')}var t=j(r);var i=t.length>0?t[0]:"";var u=P("%"+i+"%",e);var s=u.name;var c=u.value;var y=false;var p=u.alias;if(p){i=p[0];m(t,A([0,1],p))}for(var g=1,d=true;g<t.length;g+=1){var v=t[g];var S=h(v,0,1);var O=h(v,-1);if((S==='"'||S==="'"||S==="`"||(O==='"'||O==="'"||O==="`"))&&S!==O){throw new o("property names with quotes must have matching quotes")}if(v==="constructor"||!d){y=true}i+="."+v;s="%"+i+"%";if(b(l,s)){c=l[s]}else if(c!=null){if(!(v in c)){if(!e){throw new a("base intrinsic for "+r+" exists, but the property is not available.")}return void n}if(f&&g+1>=t.length){var w=f(c,v);d=!!w;if(d&&"get"in w&&!("originalValue"in w.get)){c=w.get}else{c=c[v]}}else{d=b(c,v);c=c[v]}if(d&&!y){l[s]=c}}}return c}},567:function(r,e,t){"use strict";var n=typeof Symbol!=="undefined"&&Symbol;var o=t(186);r.exports=function hasNativeSymbols(){if(typeof n!=="function"){return false}if(typeof Symbol!=="function"){return false}if(typeof n("foo")!=="symbol"){return false}if(typeof Symbol("bar")!=="symbol"){return false}return o()}},186:function(r){"use strict";r.exports=function hasSymbols(){if(typeof Symbol!=="function"||typeof Object.getOwnPropertySymbols!=="function"){return false}if(typeof Symbol.iterator==="symbol"){return true}var r={};var e=Symbol("test");var t=Object(e);if(typeof e==="string"){return false}if(Object.prototype.toString.call(e)!=="[object Symbol]"){return false}if(Object.prototype.toString.call(t)!=="[object Symbol]"){return false}var n=42;r[e]=n;for(e in r){return false}if(typeof Object.keys==="function"&&Object.keys(r).length!==0){return false}if(typeof Object.getOwnPropertyNames==="function"&&Object.getOwnPropertyNames(r).length!==0){return false}var o=Object.getOwnPropertySymbols(r);if(o.length!==1||o[0]!==e){return false}if(!Object.prototype.propertyIsEnumerable.call(r,e)){return false}if(typeof Object.getOwnPropertyDescriptor==="function"){var i=Object.getOwnPropertyDescriptor(r,e);if(i.value!==n||i.enumerable!==true){return false}}return true}},646:function(r,e,t){"use strict";var n=t(194);r.exports=n.call(Function.call,Object.prototype.hasOwnProperty)},140:function(r){if(typeof Object.create==="function"){r.exports=function inherits(r,e){if(e){r.super_=e;r.prototype=Object.create(e.prototype,{constructor:{value:r,enumerable:false,writable:true,configurable:true}})}}}else{r.exports=function inherits(r,e){if(e){r.super_=e;var TempCtor=function(){};TempCtor.prototype=e.prototype;r.prototype=new TempCtor;r.prototype.constructor=r}}}},749:function(r){"use strict";var e=typeof Symbol==="function"&&typeof Symbol.toStringTag==="symbol";var t=Object.prototype.toString;var n=function isArguments(r){if(e&&r&&typeof r==="object"&&Symbol.toStringTag in r){return false}return t.call(r)==="[object Arguments]"};var o=function isArguments(r){if(n(r)){return true}return r!==null&&typeof r==="object"&&typeof r.length==="number"&&r.length>=0&&t.call(r)!=="[object Array]"&&t.call(r.callee)==="[object Function]"};var i=function(){return n(arguments)}();n.isLegacyArguments=o;r.exports=i?n:o},611:function(r){"use strict";var e=Object.prototype.toString;var t=Function.prototype.toString;var n=/^\s*(?:function)?\*/;var o=typeof Symbol==="function"&&typeof Symbol.toStringTag==="symbol";var i=Object.getPrototypeOf;var getGeneratorFunc=function(){if(!o){return false}try{return Function("return function*() {}")()}catch(r){}};var a=getGeneratorFunc();var f=a?i(a):{};r.exports=function isGeneratorFunction(r){if(typeof r!=="function"){return false}if(n.test(t.call(r))){return true}if(!o){var a=e.call(r);return a==="[object GeneratorFunction]"}return i(r)===f}},387:function(r,e,t){"use strict";var n=t(981);var o=t(382);var i=t(171);var a=i("Object.prototype.toString");var f=t(567)();var u=f&&typeof Symbol.toStringTag==="symbol";var s=o();var c=i("Array.prototype.indexOf",true)||function indexOf(r,e){for(var t=0;t<r.length;t+=1){if(r[t]===e){return t}}return-1};var y=i("String.prototype.slice");var p={};var l=t(30);var g=Object.getPrototypeOf;if(u&&l&&g){n(s,(function(r){var e=new __webpack_require__.g[r];if(!(Symbol.toStringTag in e)){throw new EvalError("this engine has support for Symbol.toStringTag, but "+r+" does not have the property! Please report this.")}var t=g(e);var n=l(t,Symbol.toStringTag);if(!n){var o=g(t);n=l(o,Symbol.toStringTag)}p[r]=n.get}))}var d=function tryAllTypedArrays(r){var e=false;n(p,(function(t,n){if(!e){try{e=t.call(r)===n}catch(r){}}}));return e};r.exports=function isTypedArray(r){if(!r||typeof r!=="object"){return false}if(!u){var e=y(a(r),8,-1);return c(s,e)>-1}if(!l){return false}return d(r)}},913:function(r){r.exports=function isBuffer(r){return r instanceof Buffer}},989:function(r,e,t){"use strict";var n=t(749);var o=t(611);var i=t(728);var a=t(387);function uncurryThis(r){return r.call.bind(r)}var f=typeof BigInt!=="undefined";var u=typeof Symbol!=="undefined";var s=uncurryThis(Object.prototype.toString);var c=uncurryThis(Number.prototype.valueOf);var y=uncurryThis(String.prototype.valueOf);var p=uncurryThis(Boolean.prototype.valueOf);if(f){var l=uncurryThis(BigInt.prototype.valueOf)}if(u){var g=uncurryThis(Symbol.prototype.valueOf)}function checkBoxedPrimitive(r,e){if(typeof r!=="object"){return false}try{e(r);return true}catch(r){return false}}e.isArgumentsObject=n;e.isGeneratorFunction=o;e.isTypedArray=a;function isPromise(r){return typeof Promise!=="undefined"&&r instanceof Promise||r!==null&&typeof r==="object"&&typeof r.then==="function"&&typeof r.catch==="function"}e.isPromise=isPromise;function isArrayBufferView(r){if(typeof ArrayBuffer!=="undefined"&&ArrayBuffer.isView){return ArrayBuffer.isView(r)}return a(r)||isDataView(r)}e.isArrayBufferView=isArrayBufferView;function isUint8Array(r){return i(r)==="Uint8Array"}e.isUint8Array=isUint8Array;function isUint8ClampedArray(r){return i(r)==="Uint8ClampedArray"}e.isUint8ClampedArray=isUint8ClampedArray;function isUint16Array(r){return i(r)==="Uint16Array"}e.isUint16Array=isUint16Array;function isUint32Array(r){return i(r)==="Uint32Array"}e.isUint32Array=isUint32Array;function isInt8Array(r){return i(r)==="Int8Array"}e.isInt8Array=isInt8Array;function isInt16Array(r){return i(r)==="Int16Array"}e.isInt16Array=isInt16Array;function isInt32Array(r){return i(r)==="Int32Array"}e.isInt32Array=isInt32Array;function isFloat32Array(r){return i(r)==="Float32Array"}e.isFloat32Array=isFloat32Array;function isFloat64Array(r){return i(r)==="Float64Array"}e.isFloat64Array=isFloat64Array;function isBigInt64Array(r){return i(r)==="BigInt64Array"}e.isBigInt64Array=isBigInt64Array;function isBigUint64Array(r){return i(r)==="BigUint64Array"}e.isBigUint64Array=isBigUint64Array;function isMapToString(r){return s(r)==="[object Map]"}isMapToString.working=typeof Map!=="undefined"&&isMapToString(new Map);function isMap(r){if(typeof Map==="undefined"){return false}return isMapToString.working?isMapToString(r):r instanceof Map}e.isMap=isMap;function isSetToString(r){return s(r)==="[object Set]"}isSetToString.working=typeof Set!=="undefined"&&isSetToString(new Set);function isSet(r){if(typeof Set==="undefined"){return false}return isSetToString.working?isSetToString(r):r instanceof Set}e.isSet=isSet;function isWeakMapToString(r){return s(r)==="[object WeakMap]"}isWeakMapToString.working=typeof WeakMap!=="undefined"&&isWeakMapToString(new WeakMap);function isWeakMap(r){if(typeof WeakMap==="undefined"){return false}return isWeakMapToString.working?isWeakMapToString(r):r instanceof WeakMap}e.isWeakMap=isWeakMap;function isWeakSetToString(r){return s(r)==="[object WeakSet]"}isWeakSetToString.working=typeof WeakSet!=="undefined"&&isWeakSetToString(new WeakSet);function isWeakSet(r){return isWeakSetToString(r)}e.isWeakSet=isWeakSet;function isArrayBufferToString(r){return s(r)==="[object ArrayBuffer]"}isArrayBufferToString.working=typeof ArrayBuffer!=="undefined"&&isArrayBufferToString(new ArrayBuffer);function isArrayBuffer(r){if(typeof ArrayBuffer==="undefined"){return false}return isArrayBufferToString.working?isArrayBufferToString(r):r instanceof ArrayBuffer}e.isArrayBuffer=isArrayBuffer;function isDataViewToString(r){return s(r)==="[object DataView]"}isDataViewToString.working=typeof ArrayBuffer!=="undefined"&&typeof DataView!=="undefined"&&isDataViewToString(new DataView(new ArrayBuffer(1),0,1));function isDataView(r){if(typeof DataView==="undefined"){return false}return isDataViewToString.working?isDataViewToString(r):r instanceof DataView}e.isDataView=isDataView;var d=typeof SharedArrayBuffer!=="undefined"?SharedArrayBuffer:undefined;function isSharedArrayBufferToString(r){return s(r)==="[object SharedArrayBuffer]"}function isSharedArrayBuffer(r){if(typeof d==="undefined"){return false}if(typeof isSharedArrayBufferToString.working==="undefined"){isSharedArrayBufferToString.working=isSharedArrayBufferToString(new d)}return isSharedArrayBufferToString.working?isSharedArrayBufferToString(r):r instanceof d}e.isSharedArrayBuffer=isSharedArrayBuffer;function isAsyncFunction(r){return s(r)==="[object AsyncFunction]"}e.isAsyncFunction=isAsyncFunction;function isMapIterator(r){return s(r)==="[object Map Iterator]"}e.isMapIterator=isMapIterator;function isSetIterator(r){return s(r)==="[object Set Iterator]"}e.isSetIterator=isSetIterator;function isGeneratorObject(r){return s(r)==="[object Generator]"}e.isGeneratorObject=isGeneratorObject;function isWebAssemblyCompiledModule(r){return s(r)==="[object WebAssembly.Module]"}e.isWebAssemblyCompiledModule=isWebAssemblyCompiledModule;function isNumberObject(r){return checkBoxedPrimitive(r,c)}e.isNumberObject=isNumberObject;function isStringObject(r){return checkBoxedPrimitive(r,y)}e.isStringObject=isStringObject;function isBooleanObject(r){return checkBoxedPrimitive(r,p)}e.isBooleanObject=isBooleanObject;function isBigIntObject(r){return f&&checkBoxedPrimitive(r,l)}e.isBigIntObject=isBigIntObject;function isSymbolObject(r){return u&&checkBoxedPrimitive(r,g)}e.isSymbolObject=isSymbolObject;function isBoxedPrimitive(r){return isNumberObject(r)||isStringObject(r)||isBooleanObject(r)||isBigIntObject(r)||isSymbolObject(r)}e.isBoxedPrimitive=isBoxedPrimitive;function isAnyArrayBuffer(r){return typeof Uint8Array!=="undefined"&&(isArrayBuffer(r)||isSharedArrayBuffer(r))}e.isAnyArrayBuffer=isAnyArrayBuffer;["isProxy","isExternal","isModuleNamespaceObject"].forEach((function(r){Object.defineProperty(e,r,{enumerable:false,value:function(){throw new Error(r+" is not supported in userland")}})}))},467:function(r,e,t){var n=Object.getOwnPropertyDescriptors||function getOwnPropertyDescriptors(r){var e=Object.keys(r);var t={};for(var n=0;n<e.length;n++){t[e[n]]=Object.getOwnPropertyDescriptor(r,e[n])}return t};var o=/%[sdj%]/g;e.format=function(r){if(!isString(r)){var e=[];for(var t=0;t<arguments.length;t++){e.push(inspect(arguments[t]))}return e.join(" ")}var t=1;var n=arguments;var i=n.length;var a=String(r).replace(o,(function(r){if(r==="%%")return"%";if(t>=i)return r;switch(r){case"%s":return String(n[t++]);case"%d":return Number(n[t++]);case"%j":try{return JSON.stringify(n[t++])}catch(r){return"[Circular]"}default:return r}}));for(var f=n[t];t<i;f=n[++t]){if(isNull(f)||!isObject(f)){a+=" "+f}else{a+=" "+inspect(f)}}return a};e.deprecate=function(r,t){if(typeof process!=="undefined"&&process.noDeprecation===true){return r}if(typeof process==="undefined"){return function(){return e.deprecate(r,t).apply(this,arguments)}}var n=false;function deprecated(){if(!n){if(process.throwDeprecation){throw new Error(t)}else if(process.traceDeprecation){console.trace(t)}else{console.error(t)}n=true}return r.apply(this,arguments)}return deprecated};var i={};var a=/^$/;if(process.env.NODE_DEBUG){var f=process.env.NODE_DEBUG;f=f.replace(/[|\\{}()[\]^$+?.]/g,"\\$&").replace(/\*/g,".*").replace(/,/g,"$|^").toUpperCase();a=new RegExp("^"+f+"$","i")}e.debuglog=function(r){r=r.toUpperCase();if(!i[r]){if(a.test(r)){var t=process.pid;i[r]=function(){var n=e.format.apply(e,arguments);console.error("%s %d: %s",r,t,n)}}else{i[r]=function(){}}}return i[r]};function inspect(r,t){var n={seen:[],stylize:stylizeNoColor};if(arguments.length>=3)n.depth=arguments[2];if(arguments.length>=4)n.colors=arguments[3];if(isBoolean(t)){n.showHidden=t}else if(t){e._extend(n,t)}if(isUndefined(n.showHidden))n.showHidden=false;if(isUndefined(n.depth))n.depth=2;if(isUndefined(n.colors))n.colors=false;if(isUndefined(n.customInspect))n.customInspect=true;if(n.colors)n.stylize=stylizeWithColor;return formatValue(n,r,n.depth)}e.inspect=inspect;inspect.colors={bold:[1,22],italic:[3,23],underline:[4,24],inverse:[7,27],white:[37,39],grey:[90,39],black:[30,39],blue:[34,39],cyan:[36,39],green:[32,39],magenta:[35,39],red:[31,39],yellow:[33,39]};inspect.styles={special:"cyan",number:"yellow",boolean:"yellow",undefined:"grey",null:"bold",string:"green",date:"magenta",regexp:"red"};function stylizeWithColor(r,e){var t=inspect.styles[e];if(t){return"["+inspect.colors[t][0]+"m"+r+"["+inspect.colors[t][1]+"m"}else{return r}}function stylizeNoColor(r,e){return r}function arrayToHash(r){var e={};r.forEach((function(r,t){e[r]=true}));return e}function formatValue(r,t,n){if(r.customInspect&&t&&isFunction(t.inspect)&&t.inspect!==e.inspect&&!(t.constructor&&t.constructor.prototype===t)){var o=t.inspect(n,r);if(!isString(o)){o=formatValue(r,o,n)}return o}var i=formatPrimitive(r,t);if(i){return i}var a=Object.keys(t);var f=arrayToHash(a);if(r.showHidden){a=Object.getOwnPropertyNames(t)}if(isError(t)&&(a.indexOf("message")>=0||a.indexOf("description")>=0)){return formatError(t)}if(a.length===0){if(isFunction(t)){var u=t.name?": "+t.name:"";return r.stylize("[Function"+u+"]","special")}if(isRegExp(t)){return r.stylize(RegExp.prototype.toString.call(t),"regexp")}if(isDate(t)){return r.stylize(Date.prototype.toString.call(t),"date")}if(isError(t)){return formatError(t)}}var s="",c=false,y=["{","}"];if(isArray(t)){c=true;y=["[","]"]}if(isFunction(t)){var p=t.name?": "+t.name:"";s=" [Function"+p+"]"}if(isRegExp(t)){s=" "+RegExp.prototype.toString.call(t)}if(isDate(t)){s=" "+Date.prototype.toUTCString.call(t)}if(isError(t)){s=" "+formatError(t)}if(a.length===0&&(!c||t.length==0)){return y[0]+s+y[1]}if(n<0){if(isRegExp(t)){return r.stylize(RegExp.prototype.toString.call(t),"regexp")}else{return r.stylize("[Object]","special")}}r.seen.push(t);var l;if(c){l=formatArray(r,t,n,f,a)}else{l=a.map((function(e){return formatProperty(r,t,n,f,e,c)}))}r.seen.pop();return reduceToSingleString(l,s,y)}function formatPrimitive(r,e){if(isUndefined(e))return r.stylize("undefined","undefined");if(isString(e)){var t="'"+JSON.stringify(e).replace(/^"|"$/g,"").replace(/'/g,"\\'").replace(/\\"/g,'"')+"'";return r.stylize(t,"string")}if(isNumber(e))return r.stylize(""+e,"number");if(isBoolean(e))return r.stylize(""+e,"boolean");if(isNull(e))return r.stylize("null","null")}function formatError(r){return"["+Error.prototype.toString.call(r)+"]"}function formatArray(r,e,t,n,o){var i=[];for(var a=0,f=e.length;a<f;++a){if(hasOwnProperty(e,String(a))){i.push(formatProperty(r,e,t,n,String(a),true))}else{i.push("")}}o.forEach((function(o){if(!o.match(/^\d+$/)){i.push(formatProperty(r,e,t,n,o,true))}}));return i}function formatProperty(r,e,t,n,o,i){var a,f,u;u=Object.getOwnPropertyDescriptor(e,o)||{value:e[o]};if(u.get){if(u.set){f=r.stylize("[Getter/Setter]","special")}else{f=r.stylize("[Getter]","special")}}else{if(u.set){f=r.stylize("[Setter]","special")}}if(!hasOwnProperty(n,o)){a="["+o+"]"}if(!f){if(r.seen.indexOf(u.value)<0){if(isNull(t)){f=formatValue(r,u.value,null)}else{f=formatValue(r,u.value,t-1)}if(f.indexOf("\n")>-1){if(i){f=f.split("\n").map((function(r){return"  "+r})).join("\n").substr(2)}else{f="\n"+f.split("\n").map((function(r){return"   "+r})).join("\n")}}}else{f=r.stylize("[Circular]","special")}}if(isUndefined(a)){if(i&&o.match(/^\d+$/)){return f}a=JSON.stringify(""+o);if(a.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)){a=a.substr(1,a.length-2);a=r.stylize(a,"name")}else{a=a.replace(/'/g,"\\'").replace(/\\"/g,'"').replace(/(^"|"$)/g,"'");a=r.stylize(a,"string")}}return a+": "+f}function reduceToSingleString(r,e,t){var n=0;var o=r.reduce((function(r,e){n++;if(e.indexOf("\n")>=0)n++;return r+e.replace(/\u001b\[\d\d?m/g,"").length+1}),0);if(o>60){return t[0]+(e===""?"":e+"\n ")+" "+r.join(",\n  ")+" "+t[1]}return t[0]+e+" "+r.join(", ")+" "+t[1]}e.types=t(989);function isArray(r){return Array.isArray(r)}e.isArray=isArray;function isBoolean(r){return typeof r==="boolean"}e.isBoolean=isBoolean;function isNull(r){return r===null}e.isNull=isNull;function isNullOrUndefined(r){return r==null}e.isNullOrUndefined=isNullOrUndefined;function isNumber(r){return typeof r==="number"}e.isNumber=isNumber;function isString(r){return typeof r==="string"}e.isString=isString;function isSymbol(r){return typeof r==="symbol"}e.isSymbol=isSymbol;function isUndefined(r){return r===void 0}e.isUndefined=isUndefined;function isRegExp(r){return isObject(r)&&objectToString(r)==="[object RegExp]"}e.isRegExp=isRegExp;e.types.isRegExp=isRegExp;function isObject(r){return typeof r==="object"&&r!==null}e.isObject=isObject;function isDate(r){return isObject(r)&&objectToString(r)==="[object Date]"}e.isDate=isDate;e.types.isDate=isDate;function isError(r){return isObject(r)&&(objectToString(r)==="[object Error]"||r instanceof Error)}e.isError=isError;e.types.isNativeError=isError;function isFunction(r){return typeof r==="function"}e.isFunction=isFunction;function isPrimitive(r){return r===null||typeof r==="boolean"||typeof r==="number"||typeof r==="string"||typeof r==="symbol"||typeof r==="undefined"}e.isPrimitive=isPrimitive;e.isBuffer=t(913);function objectToString(r){return Object.prototype.toString.call(r)}function pad(r){return r<10?"0"+r.toString(10):r.toString(10)}var u=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];function timestamp(){var r=new Date;var e=[pad(r.getHours()),pad(r.getMinutes()),pad(r.getSeconds())].join(":");return[r.getDate(),u[r.getMonth()],e].join(" ")}e.log=function(){console.log("%s - %s",timestamp(),e.format.apply(e,arguments))};e.inherits=t(140);e._extend=function(r,e){if(!e||!isObject(e))return r;var t=Object.keys(e);var n=t.length;while(n--){r[t[n]]=e[t[n]]}return r};function hasOwnProperty(r,e){return Object.prototype.hasOwnProperty.call(r,e)}var s=typeof Symbol!=="undefined"?Symbol("util.promisify.custom"):undefined;e.promisify=function promisify(r){if(typeof r!=="function")throw new TypeError('The "original" argument must be of type Function');if(s&&r[s]){var e=r[s];if(typeof e!=="function"){throw new TypeError('The "util.promisify.custom" argument must be of type Function')}Object.defineProperty(e,s,{value:e,enumerable:false,writable:false,configurable:true});return e}function e(){var e,t;var n=new Promise((function(r,n){e=r;t=n}));var o=[];for(var i=0;i<arguments.length;i++){o.push(arguments[i])}o.push((function(r,n){if(r){t(r)}else{e(n)}}));try{r.apply(this,o)}catch(r){t(r)}return n}Object.setPrototypeOf(e,Object.getPrototypeOf(r));if(s)Object.defineProperty(e,s,{value:e,enumerable:false,writable:false,configurable:true});return Object.defineProperties(e,n(r))};e.promisify.custom=s;function callbackifyOnRejected(r,e){if(!r){var t=new Error("Promise was rejected with a falsy value");t.reason=r;r=t}return e(r)}function callbackify(r){if(typeof r!=="function"){throw new TypeError('The "original" argument must be of type Function')}function callbackified(){var e=[];for(var t=0;t<arguments.length;t++){e.push(arguments[t])}var n=e.pop();if(typeof n!=="function"){throw new TypeError("The last argument must be of type Function")}var o=this;var cb=function(){return n.apply(o,arguments)};r.apply(this,e).then((function(r){process.nextTick(cb.bind(null,null,r))}),(function(r){process.nextTick(callbackifyOnRejected.bind(null,r,cb))}))}Object.setPrototypeOf(callbackified,Object.getPrototypeOf(r));Object.defineProperties(callbackified,n(r));return callbackified}e.callbackify=callbackify},728:function(r,e,t){"use strict";var n=t(981);var o=t(382);var i=t(171);var a=i("Object.prototype.toString");var f=t(567)();var u=f&&typeof Symbol.toStringTag==="symbol";var s=o();var c=i("String.prototype.slice");var y={};var p=t(30);var l=Object.getPrototypeOf;if(u&&p&&l){n(s,(function(r){if(typeof __webpack_require__.g[r]==="function"){var e=new __webpack_require__.g[r];if(!(Symbol.toStringTag in e)){throw new EvalError("this engine has support for Symbol.toStringTag, but "+r+" does not have the property! Please report this.")}var t=l(e);var n=p(t,Symbol.toStringTag);if(!n){var o=l(t);n=p(o,Symbol.toStringTag)}y[r]=n.get}}))}var g=function tryAllTypedArrays(r){var e=false;n(y,(function(t,n){if(!e){try{var o=t.call(r);if(o===n){e=o}}catch(r){}}}));return e};var d=t(387);r.exports=function whichTypedArray(r){if(!d(r)){return false}if(!u){return c(a(r),8,-1)}return g(r)}},382:function(r,e,t){"use strict";var n=t(997);r.exports=function availableTypedArrays(){return n(["BigInt64Array","BigUint64Array","Float32Array","Float64Array","Int16Array","Int32Array","Int8Array","Uint16Array","Uint32Array","Uint8Array","Uint8ClampedArray"],(function(r){return typeof __webpack_require__.g[r]==="function"}))}},30:function(r,e,t){"use strict";var n=t(627);var o=n("%Object.getOwnPropertyDescriptor%",true);if(o){try{o([],"length")}catch(r){o=null}}r.exports=o}};var e={};function __nccwpck_require__(t){var n=e[t];if(n!==undefined){return n.exports}var o=e[t]={exports:{}};var i=true;try{r[t](o,o.exports,__nccwpck_require__);i=false}finally{if(i)delete e[t]}return o.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(467);module.exports=t})();

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90638)


/***/ }),

/***/ 25675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(28045)


/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(48418)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90387)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(20699)


/***/ }),

/***/ 62286:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.destroyCookie = exports.setCookie = exports.parseCookies = void 0;
var cookie = __webpack_require__(76489);
var setCookieParser = __webpack_require__(69328);
var utils_1 = __webpack_require__(51022);
/**
 * Parses cookies.
 *
 * @param ctx NextJS page or API context, express context, null or undefined.
 * @param options Options that we pass down to `cookie` library.
 */
function parseCookies(ctx, options) {
    var _a, _b;
    if ((_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx.req) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b.cookie) {
        return cookie.parse(ctx.req.headers.cookie, options);
    }
    if (utils_1.isBrowser()) {
        return cookie.parse(document.cookie, options);
    }
    return {};
}
exports.parseCookies = parseCookies;
/**
 * Sets a cookie.
 *
 * @param ctx NextJS page or API context, express context, null or undefined.
 * @param name The name of your cookie.
 * @param value The value of your cookie.
 * @param options Options that we pass down to `cookie` library.
 */
function setCookie(ctx, name, value, options) {
    var _a, _b;
    if (options === void 0) { options = {}; }
    // SSR
    if (((_a = ctx === null || ctx === void 0 ? void 0 : ctx.res) === null || _a === void 0 ? void 0 : _a.getHeader) && ctx.res.setHeader) {
        // Check if response has finished and warn about it.
        if ((_b = ctx === null || ctx === void 0 ? void 0 : ctx.res) === null || _b === void 0 ? void 0 : _b.finished) {
            console.warn("Not setting \"" + name + "\" cookie. Response has finished.");
            console.warn("You should set cookie before res.send()");
            return {};
        }
        /**
         * Load existing cookies from the header and parse them.
         */
        var cookies = ctx.res.getHeader('Set-Cookie') || [];
        if (typeof cookies === 'string')
            cookies = [cookies];
        if (typeof cookies === 'number')
            cookies = [];
        /**
         * Parse cookies but ignore values - we've already encoded
         * them in the previous call.
         */
        var parsedCookies = setCookieParser.parse(cookies, {
            decodeValues: false,
        });
        /**
         * We create the new cookie and make sure that none of
         * the existing cookies match it.
         */
        var newCookie_1 = utils_1.createCookie(name, value, options);
        var cookiesToSet_1 = [];
        parsedCookies.forEach(function (parsedCookie) {
            if (!utils_1.areCookiesEqual(parsedCookie, newCookie_1)) {
                /**
                 * We serialize the cookie back to the original format
                 * if it isn't the same as the new one.
                 */
                var serializedCookie = cookie.serialize(parsedCookie.name, parsedCookie.value, __assign({ 
                    // we prevent reencoding by default, but you might override it
                    encode: function (val) { return val; } }, parsedCookie));
                cookiesToSet_1.push(serializedCookie);
            }
        });
        cookiesToSet_1.push(cookie.serialize(name, value, options));
        // Update the header.
        ctx.res.setHeader('Set-Cookie', cookiesToSet_1);
    }
    // Browser
    if (utils_1.isBrowser()) {
        if (options && options.httpOnly) {
            throw new Error('Can not set a httpOnly cookie in the browser.');
        }
        document.cookie = cookie.serialize(name, value, options);
    }
    return {};
}
exports.setCookie = setCookie;
/**
 * Destroys a cookie with a particular name.
 *
 * @param ctx NextJS page or API context, express context, null or undefined.
 * @param name Cookie name.
 * @param options Options that we pass down to `cookie` library.
 */
function destroyCookie(ctx, name, options) {
    /**
     * We forward the request destroy to setCookie function
     * as it is the same function with modified maxAge value.
     */
    return setCookie(ctx, name, '', __assign(__assign({}, (options || {})), { maxAge: -1 }));
}
exports.destroyCookie = destroyCookie;
/* Utility Exports */
exports["default"] = {
    set: setCookie,
    get: parseCookies,
    destroy: destroyCookie,
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 51022:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.areCookiesEqual = exports.hasSameProperties = exports.createCookie = exports.isBrowser = void 0;
/**
 * Tells whether we are in a browser or server.
 */
function isBrowser() {
    return typeof window !== 'undefined';
}
exports.isBrowser = isBrowser;
/**
 * Create an instance of the Cookie interface
 */
function createCookie(name, value, options) {
    var sameSite = options.sameSite;
    if (sameSite === true) {
        sameSite = 'strict';
    }
    if (sameSite === undefined || sameSite === false) {
        sameSite = 'lax';
    }
    var cookieToSet = __assign(__assign({}, options), { sameSite: sameSite });
    delete cookieToSet.encode;
    return __assign({ name: name, value: value }, cookieToSet);
}
exports.createCookie = createCookie;
/**
 * Tells whether given objects have the same properties.
 */
function hasSameProperties(a, b) {
    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b);
    if (aProps.length !== bProps.length) {
        return false;
    }
    for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];
        if (a[propName] !== b[propName]) {
            return false;
        }
    }
    return true;
}
exports.hasSameProperties = hasSameProperties;
/**
 * Compare the cookie and return true if the cookies have equivalent
 * options and the cookies would be overwritten in the browser storage.
 *
 * @param a first Cookie for comparison
 * @param b second Cookie for comparison
 */
function areCookiesEqual(a, b) {
    var sameSiteSame = a.sameSite === b.sameSite;
    if (typeof a.sameSite === 'string' && typeof b.sameSite === 'string') {
        sameSiteSame = a.sameSite.toLowerCase() === b.sameSite.toLowerCase();
    }
    return (hasSameProperties(__assign(__assign({}, a), { sameSite: undefined }), __assign(__assign({}, b), { sameSite: undefined })) && sameSiteSame);
}
exports.areCookiesEqual = areCookiesEqual;
/* Functions */
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 33138:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var name = __webpack_require__(32296);

/**
 * Wrap callbacks to prevent double execution.
 *
 * @param {Function} fn Function that should only be called once.
 * @returns {Function} A wrapped callback which prevents multiple executions.
 * @public
 */
module.exports = function one(fn) {
  var called = 0
    , value;

  /**
   * The function that prevents double execution.
   *
   * @private
   */
  function onetime() {
    if (called) return value;

    called = 1;
    value = fn.apply(this, arguments);
    fn = null;

    return value;
  }

  //
  // To make debugging more easy we want to use the name of the supplied
  // function. So when you look at the functions that are assigned to event
  // listeners you don't see a load of `onetime` functions but actually the
  // names of the functions that this module will call.
  //
  // NOTE: We cannot override the `name` property, as that is `readOnly`
  // property, so displayName will have to do.
  //
  onetime.displayName = name(fn);
  return onetime;
};


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 9198:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

!function(e,t){ true?t(exports,__webpack_require__(67294),__webpack_require__(45697),__webpack_require__(94184),__webpack_require__(63398),__webpack_require__(5307),__webpack_require__(269),__webpack_require__(53802),__webpack_require__(78015),__webpack_require__(6716),__webpack_require__(23567),__webpack_require__(3580),__webpack_require__(3128),__webpack_require__(38882),__webpack_require__(20885),__webpack_require__(58083),__webpack_require__(11265),__webpack_require__(43313),__webpack_require__(18976),__webpack_require__(86111),__webpack_require__(2583),__webpack_require__(36529),__webpack_require__(99829),__webpack_require__(1981),__webpack_require__(2169),__webpack_require__(97231),__webpack_require__(46911),__webpack_require__(7530),__webpack_require__(27373),__webpack_require__(64932),__webpack_require__(54174),__webpack_require__(96884),__webpack_require__(22771),__webpack_require__(6520),__webpack_require__(41999),__webpack_require__(93812),__webpack_require__(35343),__webpack_require__(23532),__webpack_require__(88494),__webpack_require__(49227),__webpack_require__(57095),__webpack_require__(18941),__webpack_require__(64998),__webpack_require__(1742),__webpack_require__(2764),__webpack_require__(66767),__webpack_require__(62368),__webpack_require__(90631),__webpack_require__(43745),__webpack_require__(25331),__webpack_require__(19089),__webpack_require__(59856),__webpack_require__(38906),__webpack_require__(44814),__webpack_require__(97900),__webpack_require__(25340),__webpack_require__(7187),__webpack_require__(44013),__webpack_require__(53915),__webpack_require__(29681),__webpack_require__(58949),__webpack_require__(73935),__webpack_require__(38862),__webpack_require__(19229)):0}(this,(function(e,t,r,n,a,o,s,i,p,c,l,d,u,h,f,m,y,g,D,v,k,w,b,S,M,C,_,Y,E,P,N,O,x,I,T,R,L,F,A,W,Q,q,K,B,H,j,V,U,$,z,G,J,X,Z,ee,te,re,ne,ae,oe,se,ie,pe,ce){"use strict";function le(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var de=le(t),ue=le(n),he=le(se),fe=le(ie);function me(e,t,r){return t=Ye(t),function(e,t){if(t&&("object"==typeof t||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return Pe(e)}(e,ye()?Reflect.construct(t,r||[],Ye(e).constructor):t.apply(e,r))}function ye(){try{var e=!Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){})))}catch(e){}return(ye=function(){return!!e})()}function ge(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function De(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?ge(Object(r),!0).forEach((function(t){Me(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):ge(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function ve(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var r=e[Symbol.toPrimitive];if(void 0!==r){var n=r.call(e,t||"default");if("object"!=typeof n)return n;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:String(t)}function ke(e){return ke="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},ke(e)}function we(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function be(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,ve(n.key),n)}}function Se(e,t,r){return t&&be(e.prototype,t),r&&be(e,r),Object.defineProperty(e,"prototype",{writable:!1}),e}function Me(e,t,r){return(t=ve(t))in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function Ce(){return Ce=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},Ce.apply(this,arguments)}function _e(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&Ee(e,t)}function Ye(e){return Ye=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)},Ye(e)}function Ee(e,t){return Ee=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e},Ee(e,t)}function Pe(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function Ne(e){return function(e){if(Array.isArray(e))return Oe(e)}(e)||function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}(e)||function(e,t){if(!e)return;if("string"==typeof e)return Oe(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);"Object"===r&&e.constructor&&(r=e.constructor.name);if("Map"===r||"Set"===r)return Array.from(e);if("Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))return Oe(e,t)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function Oe(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}var xe=12,Ie=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;function Te(e){var t=e?"string"==typeof e||e instanceof String?oe.parseISO(e):ne.toDate(e):new Date;return Re(t)?t:null}function Re(e,t){return t=t||new Date("1/1/1000"),o.isValid(e)&&!te.isBefore(e,t)}function Le(e,t,r){if("en"===r)return s.format(e,t,{useAdditionalWeekYearTokens:!0,useAdditionalDayOfYearTokens:!0});var n=Je(r);return r&&!n&&console.warn('A locale object was not found for the provided string ["'.concat(r,'"].')),!n&&Ge()&&Je(Ge())&&(n=Je(Ge())),s.format(e,t,{locale:n||null,useAdditionalWeekYearTokens:!0,useAdditionalDayOfYearTokens:!0})}function Fe(e,t){var r=t.dateFormat,n=t.locale;return e&&Le(e,Array.isArray(r)?r[0]:r,n)||""}function Ae(e,t){var r=t.hour,n=void 0===r?0:r,a=t.minute,o=void 0===a?0:a,s=t.second,i=void 0===s?0:s;return O.setHours(N.setMinutes(P.setSeconds(e,i),o),n)}function We(e,t,r){var n=Je(t||Ge());return q.startOfWeek(e,{locale:n,weekStartsOn:r})}function Qe(e){return K.startOfMonth(e)}function qe(e){return H.startOfYear(e)}function Ke(e){return B.startOfQuarter(e)}function Be(){return Q.startOfDay(Te())}function He(e,t){return e&&t?X.isSameYear(e,t):!e&&!t}function je(e,t){return e&&t?J.isSameMonth(e,t):!e&&!t}function Ve(e,t){return e&&t?Z.isSameQuarter(e,t):!e&&!t}function Ue(e,t){return e&&t?G.isSameDay(e,t):!e&&!t}function $e(e,t){return e&&t?z.isEqual(e,t):!e&&!t}function ze(e,t,r){var n,a=Q.startOfDay(t),o=j.endOfDay(r);try{n=re.isWithinInterval(e,{start:a,end:o})}catch(e){n=!1}return n}function Ge(){return("undefined"!=typeof window?window:globalThis).__localeId__}function Je(e){if("string"==typeof e){var t="undefined"!=typeof window?window:globalThis;return t.__localeData__?t.__localeData__[e]:null}return e}function Xe(e,t){return Le(x.setMonth(Te(),e),"LLLL",t)}function Ze(e,t){return Le(x.setMonth(Te(),e),"LLL",t)}function et(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,a=t.excludeDates,o=t.excludeDateIntervals,s=t.includeDates,i=t.includeDateIntervals,p=t.filterDate;return pt(e,{minDate:r,maxDate:n})||a&&a.some((function(t){return Ue(e,t.date?t.date:t)}))||o&&o.some((function(t){var r=t.start,n=t.end;return re.isWithinInterval(e,{start:r,end:n})}))||s&&!s.some((function(t){return Ue(e,t)}))||i&&!i.some((function(t){var r=t.start,n=t.end;return re.isWithinInterval(e,{start:r,end:n})}))||p&&!p(Te(e))||!1}function tt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeDates,n=t.excludeDateIntervals;return n&&n.length>0?n.some((function(t){var r=t.start,n=t.end;return re.isWithinInterval(e,{start:r,end:n})})):r&&r.some((function(t){return Ue(e,t.date?t.date:t)}))||!1}function rt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,a=t.excludeDates,o=t.includeDates,s=t.filterDate;return pt(e,{minDate:K.startOfMonth(r),maxDate:U.endOfMonth(n)})||a&&a.some((function(t){return je(e,t)}))||o&&!o.some((function(t){return je(e,t)}))||s&&!s(Te(e))||!1}function nt(e,t,r,n){var a=Y.getYear(e),o=C.getMonth(e),s=Y.getYear(t),i=C.getMonth(t),p=Y.getYear(n);return a===s&&a===p?o<=r&&r<=i:a<s?p===a&&o<=r||p===s&&i>=r||p<s&&p>a:void 0}function at(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,a=t.excludeDates,o=t.includeDates,s=t.filterDate;return pt(e,{minDate:r,maxDate:n})||a&&a.some((function(t){return Ve(e,t)}))||o&&!o.some((function(t){return Ve(e,t)}))||s&&!s(Te(e))||!1}function ot(e,t,r){if(!o.isValid(t)||!o.isValid(r))return!1;var n=Y.getYear(t),a=Y.getYear(r);return n<=e&&a>=e}function st(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,a=t.excludeDates,o=t.includeDates,s=t.filterDate,i=new Date(e,0,1);return pt(i,{minDate:H.startOfYear(r),maxDate:$.endOfYear(n)})||a&&a.some((function(e){return He(i,e)}))||o&&!o.some((function(e){return He(i,e)}))||s&&!s(Te(i))||!1}function it(e,t,r,n){var a=Y.getYear(e),o=_.getQuarter(e),s=Y.getYear(t),i=_.getQuarter(t),p=Y.getYear(n);return a===s&&a===p?o<=r&&r<=i:a<s?p===a&&o<=r||p===s&&i>=r||p<s&&p>a:void 0}function pt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate;return r&&F.differenceInCalendarDays(e,r)<0||n&&F.differenceInCalendarDays(e,n)>0}function ct(e,t){return t.some((function(t){return w.getHours(t)===w.getHours(e)&&k.getMinutes(t)===k.getMinutes(e)}))}function lt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeTimes,n=t.includeTimes,a=t.filterTime;return r&&ct(e,r)||n&&!ct(e,n)||a&&!a(e)||!1}function dt(e,t){var r=t.minTime,n=t.maxTime;if(!r||!n)throw new Error("Both minTime and maxTime props required");var a,o=Te(),s=O.setHours(N.setMinutes(o,k.getMinutes(e)),w.getHours(e)),i=O.setHours(N.setMinutes(o,k.getMinutes(r)),w.getHours(r)),p=O.setHours(N.setMinutes(o,k.getMinutes(n)),w.getHours(n));try{a=!re.isWithinInterval(s,{start:i,end:p})}catch(e){a=!1}return a}function ut(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.includeDates,a=y.subMonths(e,1);return r&&A.differenceInCalendarMonths(r,a)>0||n&&n.every((function(e){return A.differenceInCalendarMonths(e,a)>0}))||!1}function ht(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.includeDates,a=d.addMonths(e,1);return r&&A.differenceInCalendarMonths(a,r)>0||n&&n.every((function(e){return A.differenceInCalendarMonths(a,e)>0}))||!1}function ft(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.includeDates,a=D.subYears(e,1);return r&&W.differenceInCalendarYears(r,a)>0||n&&n.every((function(e){return W.differenceInCalendarYears(e,a)>0}))||!1}function mt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.includeDates,a=h.addYears(e,1);return r&&W.differenceInCalendarYears(a,r)>0||n&&n.every((function(e){return W.differenceInCalendarYears(a,e)>0}))||!1}function yt(e){var t=e.minDate,r=e.includeDates;if(r&&t){var n=r.filter((function(e){return F.differenceInCalendarDays(e,t)>=0}));return R.min(n)}return r?R.min(r):t}function gt(e){var t=e.maxDate,r=e.includeDates;if(r&&t){var n=r.filter((function(e){return F.differenceInCalendarDays(e,t)<=0}));return L.max(n)}return r?L.max(r):t}function Dt(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--highlighted",r=new Map,n=0,o=e.length;n<o;n++){var s=e[n];if(a.isDate(s)){var i=Le(s,"MM.dd.yyyy"),p=r.get(i)||[];p.includes(t)||(p.push(t),r.set(i,p))}else if("object"===ke(s)){var c=Object.keys(s),l=c[0],d=s[c[0]];if("string"==typeof l&&d.constructor===Array)for(var u=0,h=d.length;u<h;u++){var f=Le(d[u],"MM.dd.yyyy"),m=r.get(f)||[];m.includes(l)||(m.push(l),r.set(f,m))}}}return r}function vt(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--holidays",r=new Map;return e.forEach((function(e){var n=e.date,o=e.holidayName;if(a.isDate(n)){var s=Le(n,"MM.dd.yyyy"),i=r.get(s)||{};if(!("className"in i)||i.className!==t||(p=i.holidayNames,c=[o],p.length!==c.length||!p.every((function(e,t){return e===c[t]})))){var p,c;i.className=t;var l=i.holidayNames;i.holidayNames=l?[].concat(Ne(l),[o]):[o],r.set(s,i)}}})),r}function kt(e,t,r,n,a){for(var o=a.length,s=[],c=0;c<o;c++){var l=i.addMinutes(p.addHours(e,w.getHours(a[c])),k.getMinutes(a[c])),d=i.addMinutes(e,(r+1)*n);ee.isAfter(l,t)&&te.isBefore(l,d)&&s.push(a[c])}return s}function wt(e){return e<10?"0".concat(e):"".concat(e)}function bt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:xe,r=Math.ceil(Y.getYear(e)/t)*t;return{startPeriod:r-(t-1),endPeriod:r}}function St(e){var t=e.getSeconds(),r=e.getMilliseconds();return ne.toDate(e.getTime()-1e3*t-r)}function Mt(e){if(!a.isDate(e))throw new Error("Invalid date");var t=new Date(e);return t.setHours(0,0,0,0),t}function Ct(e,t){if(!a.isDate(e)||!a.isDate(t))throw new Error("Invalid date received");var r=Mt(e),n=Mt(t);return te.isBefore(r,n)}function _t(e,t,r,n){for(var a=[],o=0;o<2*t+1;o++){var s=e+t-o,i=!0;r&&(i=Y.getYear(r)<=s),n&&i&&(i=Y.getYear(n)>=s),i&&a.push(s)}return a}var Yt=function(e){function r(e){var n;we(this,r),Me(Pe(n=me(this,r,[e])),"renderOptions",(function(){var e=n.props.year,t=n.state.yearsList.map((function(t){return de.default.createElement("div",{className:e===t?"react-datepicker__year-option react-datepicker__year-option--selected_year":"react-datepicker__year-option",key:t,onClick:n.onChange.bind(Pe(n),t),"aria-selected":e===t?"true":void 0},e===t?de.default.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",t)})),r=n.props.minDate?Y.getYear(n.props.minDate):null,a=n.props.maxDate?Y.getYear(n.props.maxDate):null;return a&&n.state.yearsList.find((function(e){return e===a}))||t.unshift(de.default.createElement("div",{className:"react-datepicker__year-option",key:"upcoming",onClick:n.incrementYears},de.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),r&&n.state.yearsList.find((function(e){return e===r}))||t.push(de.default.createElement("div",{className:"react-datepicker__year-option",key:"previous",onClick:n.decrementYears},de.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),t})),Me(Pe(n),"onChange",(function(e){n.props.onChange(e)})),Me(Pe(n),"handleClickOutside",(function(){n.props.onCancel()})),Me(Pe(n),"shiftYears",(function(e){var t=n.state.yearsList.map((function(t){return t+e}));n.setState({yearsList:t})})),Me(Pe(n),"incrementYears",(function(){return n.shiftYears(1)})),Me(Pe(n),"decrementYears",(function(){return n.shiftYears(-1)}));var a=e.yearDropdownItemNumber,o=e.scrollableYearDropdown,s=a||(o?10:5);return n.state={yearsList:_t(n.props.year,s,n.props.minDate,n.props.maxDate)},n.dropdownRef=t.createRef(),n}return _e(r,e),Se(r,[{key:"componentDidMount",value:function(){var e=this.dropdownRef.current;if(e){var t=e.children?Array.from(e.children):null,r=t?t.find((function(e){return e.ariaSelected})):null;e.scrollTop=r?r.offsetTop+(r.clientHeight-e.clientHeight)/2:(e.scrollHeight-e.clientHeight)/2}}},{key:"render",value:function(){var e=ue.default({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return de.default.createElement("div",{className:e,ref:this.dropdownRef},this.renderOptions())}}]),r}(de.default.Component),Et=he.default(Yt),Pt=function(e){function t(){var e;we(this,t);for(var r=arguments.length,n=new Array(r),a=0;a<r;a++)n[a]=arguments[a];return Me(Pe(e=me(this,t,[].concat(n))),"state",{dropdownVisible:!1}),Me(Pe(e),"renderSelectOptions",(function(){for(var t=e.props.minDate?Y.getYear(e.props.minDate):1900,r=e.props.maxDate?Y.getYear(e.props.maxDate):2100,n=[],a=t;a<=r;a++)n.push(de.default.createElement("option",{key:a,value:a},a));return n})),Me(Pe(e),"onSelectChange",(function(t){e.onChange(t.target.value)})),Me(Pe(e),"renderSelectMode",(function(){return de.default.createElement("select",{value:e.props.year,className:"react-datepicker__year-select",onChange:e.onSelectChange},e.renderSelectOptions())})),Me(Pe(e),"renderReadView",(function(t){return de.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:function(t){return e.toggleDropdown(t)}},de.default.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),de.default.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},e.props.year))})),Me(Pe(e),"renderDropdown",(function(){return de.default.createElement(Et,{key:"dropdown",year:e.props.year,onChange:e.onChange,onCancel:e.toggleDropdown,minDate:e.props.minDate,maxDate:e.props.maxDate,scrollableYearDropdown:e.props.scrollableYearDropdown,yearDropdownItemNumber:e.props.yearDropdownItemNumber})})),Me(Pe(e),"renderScrollMode",(function(){var t=e.state.dropdownVisible,r=[e.renderReadView(!t)];return t&&r.unshift(e.renderDropdown()),r})),Me(Pe(e),"onChange",(function(t){e.toggleDropdown(),t!==e.props.year&&e.props.onChange(t)})),Me(Pe(e),"toggleDropdown",(function(t){e.setState({dropdownVisible:!e.state.dropdownVisible},(function(){e.props.adjustDateOnChange&&e.handleYearChange(e.props.date,t)}))})),Me(Pe(e),"handleYearChange",(function(t,r){e.onSelect(t,r),e.setOpen()})),Me(Pe(e),"onSelect",(function(t,r){e.props.onSelect&&e.props.onSelect(t,r)})),Me(Pe(e),"setOpen",(function(){e.props.setOpen&&e.props.setOpen(!0)})),e}return _e(t,e),Se(t,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return de.default.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),t}(de.default.Component),Nt=function(e){function t(){var e;we(this,t);for(var r=arguments.length,n=new Array(r),a=0;a<r;a++)n[a]=arguments[a];return Me(Pe(e=me(this,t,[].concat(n))),"isSelectedMonth",(function(t){return e.props.month===t})),Me(Pe(e),"renderOptions",(function(){return e.props.monthNames.map((function(t,r){return de.default.createElement("div",{className:e.isSelectedMonth(r)?"react-datepicker__month-option react-datepicker__month-option--selected_month":"react-datepicker__month-option",key:t,onClick:e.onChange.bind(Pe(e),r),"aria-selected":e.isSelectedMonth(r)?"true":void 0},e.isSelectedMonth(r)?de.default.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",t)}))})),Me(Pe(e),"onChange",(function(t){return e.props.onChange(t)})),Me(Pe(e),"handleClickOutside",(function(){return e.props.onCancel()})),e}return _e(t,e),Se(t,[{key:"render",value:function(){return de.default.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}}]),t}(de.default.Component),Ot=he.default(Nt),xt=function(e){function t(){var e;we(this,t);for(var r=arguments.length,n=new Array(r),a=0;a<r;a++)n[a]=arguments[a];return Me(Pe(e=me(this,t,[].concat(n))),"state",{dropdownVisible:!1}),Me(Pe(e),"renderSelectOptions",(function(e){return e.map((function(e,t){return de.default.createElement("option",{key:t,value:t},e)}))})),Me(Pe(e),"renderSelectMode",(function(t){return de.default.createElement("select",{value:e.props.month,className:"react-datepicker__month-select",onChange:function(t){return e.onChange(t.target.value)}},e.renderSelectOptions(t))})),Me(Pe(e),"renderReadView",(function(t,r){return de.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:e.toggleDropdown},de.default.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}),de.default.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},r[e.props.month]))})),Me(Pe(e),"renderDropdown",(function(t){return de.default.createElement(Ot,{key:"dropdown",month:e.props.month,monthNames:t,onChange:e.onChange,onCancel:e.toggleDropdown})})),Me(Pe(e),"renderScrollMode",(function(t){var r=e.state.dropdownVisible,n=[e.renderReadView(!r,t)];return r&&n.unshift(e.renderDropdown(t)),n})),Me(Pe(e),"onChange",(function(t){e.toggleDropdown(),t!==e.props.month&&e.props.onChange(t)})),Me(Pe(e),"toggleDropdown",(function(){return e.setState({dropdownVisible:!e.state.dropdownVisible})})),e}return _e(t,e),Se(t,[{key:"render",value:function(){var e,t=this,r=[0,1,2,3,4,5,6,7,8,9,10,11].map(this.props.useShortMonthInDropdown?function(e){return Ze(e,t.props.locale)}:function(e){return Xe(e,t.props.locale)});switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode(r);break;case"select":e=this.renderSelectMode(r)}return de.default.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),t}(de.default.Component);function It(e,t){for(var r=[],n=Qe(e),a=Qe(t);!ee.isAfter(n,a);)r.push(Te(n)),n=d.addMonths(n,1);return r}var Tt=function(e){function t(e){var r;return we(this,t),Me(Pe(r=me(this,t,[e])),"renderOptions",(function(){return r.state.monthYearsList.map((function(e){var t=E.getTime(e),n=He(r.props.date,e)&&je(r.props.date,e);return de.default.createElement("div",{className:n?"react-datepicker__month-year-option--selected_month-year":"react-datepicker__month-year-option",key:t,onClick:r.onChange.bind(Pe(r),t),"aria-selected":n?"true":void 0},n?de.default.createElement("span",{className:"react-datepicker__month-year-option--selected"},"✓"):"",Le(e,r.props.dateFormat,r.props.locale))}))})),Me(Pe(r),"onChange",(function(e){return r.props.onChange(e)})),Me(Pe(r),"handleClickOutside",(function(){r.props.onCancel()})),r.state={monthYearsList:It(r.props.minDate,r.props.maxDate)},r}return _e(t,e),Se(t,[{key:"render",value:function(){var e=ue.default({"react-datepicker__month-year-dropdown":!0,"react-datepicker__month-year-dropdown--scrollable":this.props.scrollableMonthYearDropdown});return de.default.createElement("div",{className:e},this.renderOptions())}}]),t}(de.default.Component),Rt=he.default(Tt),Lt=function(e){function t(){var e;we(this,t);for(var r=arguments.length,n=new Array(r),a=0;a<r;a++)n[a]=arguments[a];return Me(Pe(e=me(this,t,[].concat(n))),"state",{dropdownVisible:!1}),Me(Pe(e),"renderSelectOptions",(function(){for(var t=Qe(e.props.minDate),r=Qe(e.props.maxDate),n=[];!ee.isAfter(t,r);){var a=E.getTime(t);n.push(de.default.createElement("option",{key:a,value:a},Le(t,e.props.dateFormat,e.props.locale))),t=d.addMonths(t,1)}return n})),Me(Pe(e),"onSelectChange",(function(t){e.onChange(t.target.value)})),Me(Pe(e),"renderSelectMode",(function(){return de.default.createElement("select",{value:E.getTime(Qe(e.props.date)),className:"react-datepicker__month-year-select",onChange:e.onSelectChange},e.renderSelectOptions())})),Me(Pe(e),"renderReadView",(function(t){var r=Le(e.props.date,e.props.dateFormat,e.props.locale);return de.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__month-year-read-view",onClick:function(t){return e.toggleDropdown(t)}},de.default.createElement("span",{className:"react-datepicker__month-year-read-view--down-arrow"}),de.default.createElement("span",{className:"react-datepicker__month-year-read-view--selected-month-year"},r))})),Me(Pe(e),"renderDropdown",(function(){return de.default.createElement(Rt,{key:"dropdown",date:e.props.date,dateFormat:e.props.dateFormat,onChange:e.onChange,onCancel:e.toggleDropdown,minDate:e.props.minDate,maxDate:e.props.maxDate,scrollableMonthYearDropdown:e.props.scrollableMonthYearDropdown,locale:e.props.locale})})),Me(Pe(e),"renderScrollMode",(function(){var t=e.state.dropdownVisible,r=[e.renderReadView(!t)];return t&&r.unshift(e.renderDropdown()),r})),Me(Pe(e),"onChange",(function(t){e.toggleDropdown();var r=Te(parseInt(t));He(e.props.date,r)&&je(e.props.date,r)||e.props.onChange(r)})),Me(Pe(e),"toggleDropdown",(function(){return e.setState({dropdownVisible:!e.state.dropdownVisible})})),e}return _e(t,e),Se(t,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return de.default.createElement("div",{className:"react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),t}(de.default.Component),Ft=function(e){function t(){var e;we(this,t);for(var r=arguments.length,n=new Array(r),a=0;a<r;a++)n[a]=arguments[a];return Me(Pe(e=me(this,t,[].concat(n))),"dayEl",de.default.createRef()),Me(Pe(e),"handleClick",(function(t){!e.isDisabled()&&e.props.onClick&&e.props.onClick(t)})),Me(Pe(e),"handleMouseEnter",(function(t){!e.isDisabled()&&e.props.onMouseEnter&&e.props.onMouseEnter(t)})),Me(Pe(e),"handleOnKeyDown",(function(t){" "===t.key&&(t.preventDefault(),t.key="Enter"),e.props.handleOnKeyDown(t)})),Me(Pe(e),"isSameDay",(function(t){return Ue(e.props.day,t)})),Me(Pe(e),"isKeyboardSelected",(function(){return!e.props.disabledKeyboardNavigation&&!(e.isSameDay(e.props.selected)||e.isSameWeek(e.props.selected))&&(e.isSameDay(e.props.preSelection)||e.isSameWeek(e.props.preSelection))})),Me(Pe(e),"isDisabled",(function(){return et(e.props.day,e.props)})),Me(Pe(e),"isExcluded",(function(){return tt(e.props.day,e.props)})),Me(Pe(e),"isStartOfWeek",(function(){return Ue(e.props.day,We(e.props.day,e.props.locale,e.props.calendarStartDay))})),Me(Pe(e),"isSameWeek",(function(t){return e.props.showWeekPicker&&Ue(t,We(e.props.day,e.props.locale,e.props.calendarStartDay))})),Me(Pe(e),"getHighLightedClass",(function(){var t=e.props,r=t.day,n=t.highlightDates;if(!n)return!1;var a=Le(r,"MM.dd.yyyy");return n.get(a)})),Me(Pe(e),"getHolidaysClass",(function(){var t=e.props,r=t.day,n=t.holidays;if(!n)return!1;var a=Le(r,"MM.dd.yyyy");return n.has(a)?[n.get(a).className]:void 0})),Me(Pe(e),"isInRange",(function(){var t=e.props,r=t.day,n=t.startDate,a=t.endDate;return!(!n||!a)&&ze(r,n,a)})),Me(Pe(e),"isInSelectingRange",(function(){var t,r=e.props,n=r.day,a=r.selectsStart,o=r.selectsEnd,s=r.selectsRange,i=r.selectsDisabledDaysInRange,p=r.startDate,c=r.endDate,l=null!==(t=e.props.selectingDate)&&void 0!==t?t:e.props.preSelection;return!(!(a||o||s)||!l||!i&&e.isDisabled())&&(a&&c&&(te.isBefore(l,c)||$e(l,c))?ze(n,l,c):(o&&p&&(ee.isAfter(l,p)||$e(l,p))||!(!s||!p||c||!ee.isAfter(l,p)&&!$e(l,p)))&&ze(n,p,l))})),Me(Pe(e),"isSelectingRangeStart",(function(){var t;if(!e.isInSelectingRange())return!1;var r=e.props,n=r.day,a=r.startDate,o=r.selectsStart,s=null!==(t=e.props.selectingDate)&&void 0!==t?t:e.props.preSelection;return Ue(n,o?s:a)})),Me(Pe(e),"isSelectingRangeEnd",(function(){var t;if(!e.isInSelectingRange())return!1;var r=e.props,n=r.day,a=r.endDate,o=r.selectsEnd,s=r.selectsRange,i=null!==(t=e.props.selectingDate)&&void 0!==t?t:e.props.preSelection;return Ue(n,o||s?i:a)})),Me(Pe(e),"isRangeStart",(function(){var t=e.props,r=t.day,n=t.startDate,a=t.endDate;return!(!n||!a)&&Ue(n,r)})),Me(Pe(e),"isRangeEnd",(function(){var t=e.props,r=t.day,n=t.startDate,a=t.endDate;return!(!n||!a)&&Ue(a,r)})),Me(Pe(e),"isWeekend",(function(){var t=b.getDay(e.props.day);return 0===t||6===t})),Me(Pe(e),"isAfterMonth",(function(){return void 0!==e.props.month&&(e.props.month+1)%12===C.getMonth(e.props.day)})),Me(Pe(e),"isBeforeMonth",(function(){return void 0!==e.props.month&&(C.getMonth(e.props.day)+1)%12===e.props.month})),Me(Pe(e),"isCurrentDay",(function(){return e.isSameDay(Te())})),Me(Pe(e),"isSelected",(function(){return e.isSameDay(e.props.selected)||e.isSameWeek(e.props.selected)})),Me(Pe(e),"getClassNames",(function(t){var r,n=e.props.dayClassName?e.props.dayClassName(t):void 0;return ue.default("react-datepicker__day",n,"react-datepicker__day--"+Le(e.props.day,"ddd",r),{"react-datepicker__day--disabled":e.isDisabled(),"react-datepicker__day--excluded":e.isExcluded(),"react-datepicker__day--selected":e.isSelected(),"react-datepicker__day--keyboard-selected":e.isKeyboardSelected(),"react-datepicker__day--range-start":e.isRangeStart(),"react-datepicker__day--range-end":e.isRangeEnd(),"react-datepicker__day--in-range":e.isInRange(),"react-datepicker__day--in-selecting-range":e.isInSelectingRange(),"react-datepicker__day--selecting-range-start":e.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":e.isSelectingRangeEnd(),"react-datepicker__day--today":e.isCurrentDay(),"react-datepicker__day--weekend":e.isWeekend(),"react-datepicker__day--outside-month":e.isAfterMonth()||e.isBeforeMonth()},e.getHighLightedClass("react-datepicker__day--highlighted"),e.getHolidaysClass())})),Me(Pe(e),"getAriaLabel",(function(){var t=e.props,r=t.day,n=t.ariaLabelPrefixWhenEnabled,a=void 0===n?"Choose":n,o=t.ariaLabelPrefixWhenDisabled,s=void 0===o?"Not available":o,i=e.isDisabled()||e.isExcluded()?s:a;return"".concat(i," ").concat(Le(r,"PPPP",e.props.locale))})),Me(Pe(e),"getTitle",(function(){var t=e.props,r=t.day,n=t.holidays,a=void 0===n?new Map:n,o=t.excludeDates,s=Le(r,"MM.dd.yyyy"),i=[];return a.has(s)&&i.push.apply(i,Ne(a.get(s).holidayNames)),e.isExcluded()&&i.push(null==o?void 0:o.filter((function(e){return Ue(e.date?e.date:e,r)})).map((function(e){return e.message}))),i.join(", ")})),Me(Pe(e),"getTabIndex",(function(t,r){var n=t||e.props.selected,a=r||e.props.preSelection;return(!e.props.showWeekPicker||!e.props.showWeekNumber&&e.isStartOfWeek())&&(e.isKeyboardSelected()||e.isSameDay(n)&&Ue(a,n))?0:-1})),Me(Pe(e),"handleFocusDay",(function(){var t,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=!1;0===e.getTabIndex()&&!r.isInputFocused&&e.isSameDay(e.props.preSelection)&&(document.activeElement&&document.activeElement!==document.body||(n=!0),e.props.inline&&!e.props.shouldFocusDayInline&&(n=!1),e.props.containerRef&&e.props.containerRef.current&&e.props.containerRef.current.contains(document.activeElement)&&document.activeElement.classList.contains("react-datepicker__day")&&(n=!0),e.props.monthShowsDuplicateDaysEnd&&e.isAfterMonth()&&(n=!1),e.props.monthShowsDuplicateDaysStart&&e.isBeforeMonth()&&(n=!1)),n&&(null===(t=e.dayEl.current)||void 0===t||t.focus({preventScroll:!0}))})),Me(Pe(e),"renderDayContents",(function(){return e.props.monthShowsDuplicateDaysEnd&&e.isAfterMonth()||e.props.monthShowsDuplicateDaysStart&&e.isBeforeMonth()?null:e.props.renderDayContents?e.props.renderDayContents(S.getDate(e.props.day),e.props.day):S.getDate(e.props.day)})),Me(Pe(e),"render",(function(){return de.default.createElement("div",{ref:e.dayEl,className:e.getClassNames(e.props.day),onKeyDown:e.handleOnKeyDown,onClick:e.handleClick,onMouseEnter:e.handleMouseEnter,tabIndex:e.getTabIndex(),"aria-label":e.getAriaLabel(),role:"option",title:e.getTitle(),"aria-disabled":e.isDisabled(),"aria-current":e.isCurrentDay()?"date":void 0,"aria-selected":e.isSelected()||e.isInRange()},e.renderDayContents(),""!==e.getTitle()&&de.default.createElement("span",{className:"overlay"},e.getTitle()))})),e}return _e(t,e),Se(t,[{key:"componentDidMount",value:function(){this.handleFocusDay()}},{key:"componentDidUpdate",value:function(e){this.handleFocusDay(e)}}]),t}(de.default.Component),At=function(e){function t(){var e;we(this,t);for(var r=arguments.length,n=new Array(r),a=0;a<r;a++)n[a]=arguments[a];return Me(Pe(e=me(this,t,[].concat(n))),"weekNumberEl",de.default.createRef()),Me(Pe(e),"handleClick",(function(t){e.props.onClick&&e.props.onClick(t)})),Me(Pe(e),"handleOnKeyDown",(function(t){" "===t.key&&(t.preventDefault(),t.key="Enter"),e.props.handleOnKeyDown(t)})),Me(Pe(e),"isKeyboardSelected",(function(){return!e.props.disabledKeyboardNavigation&&!Ue(e.props.date,e.props.selected)&&Ue(e.props.date,e.props.preSelection)})),Me(Pe(e),"getTabIndex",(function(){return e.props.showWeekPicker&&e.props.showWeekNumber&&(e.isKeyboardSelected()||Ue(e.props.date,e.props.selected)&&Ue(e.props.preSelection,e.props.selected))?0:-1})),Me(Pe(e),"handleFocusWeekNumber",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=!1;0===e.getTabIndex()&&!t.isInputFocused&&Ue(e.props.date,e.props.preSelection)&&(document.activeElement&&document.activeElement!==document.body||(r=!0),e.props.inline&&!e.props.shouldFocusDayInline&&(r=!1),e.props.containerRef&&e.props.containerRef.current&&e.props.containerRef.current.contains(document.activeElement)&&document.activeElement&&document.activeElement.classList.contains("react-datepicker__week-number")&&(r=!0)),r&&e.weekNumberEl.current&&e.weekNumberEl.current.focus({preventScroll:!0})})),e}return _e(t,e),Se(t,[{key:"componentDidMount",value:function(){this.handleFocusWeekNumber()}},{key:"componentDidUpdate",value:function(e){this.handleFocusWeekNumber(e)}},{key:"render",value:function(){var e=this.props,t=e.weekNumber,r=e.ariaLabelPrefix,n=void 0===r?"week ":r,a={"react-datepicker__week-number":!0,"react-datepicker__week-number--clickable":!!e.onClick,"react-datepicker__week-number--selected":Ue(this.props.date,this.props.selected),"react-datepicker__week-number--keyboard-selected":this.isKeyboardSelected()};return de.default.createElement("div",{ref:this.weekNumberEl,className:ue.default(a),"aria-label":"".concat(n," ").concat(this.props.weekNumber),onClick:this.handleClick,onKeyDown:this.handleOnKeyDown,tabIndex:this.getTabIndex()},t)}}],[{key:"defaultProps",get:function(){return{ariaLabelPrefix:"week "}}}]),t}(de.default.Component),Wt=function(e){function t(){var e;we(this,t);for(var r=arguments.length,n=new Array(r),a=0;a<r;a++)n[a]=arguments[a];return Me(Pe(e=me(this,t,[].concat(n))),"handleDayClick",(function(t,r){e.props.onDayClick&&e.props.onDayClick(t,r)})),Me(Pe(e),"handleDayMouseEnter",(function(t){e.props.onDayMouseEnter&&e.props.onDayMouseEnter(t)})),Me(Pe(e),"handleWeekClick",(function(t,r,n){if("function"==typeof e.props.onWeekSelect&&e.props.onWeekSelect(t,r,n),e.props.showWeekPicker){var a=We(t,e.props.locale,e.props.calendarStartDay);e.handleDayClick(a,n)}e.props.shouldCloseOnSelect&&e.props.setOpen(!1)})),Me(Pe(e),"formatWeekNumber",(function(t){return e.props.formatWeekNumber?e.props.formatWeekNumber(t):function(e,t){var r=t&&Je(t)||Ge()&&Je(Ge());return M.getISOWeek(e,r?{locale:r}:null)}(t)})),Me(Pe(e),"renderDays",(function(){var t=We(e.props.day,e.props.locale,e.props.calendarStartDay),r=[],n=e.formatWeekNumber(t);if(e.props.showWeekNumber){var a=e.props.onWeekSelect||e.props.showWeekPicker?e.handleWeekClick.bind(Pe(e),t,n):void 0;r.push(de.default.createElement(At,{key:"W",weekNumber:n,date:t,onClick:a,selected:e.props.selected,preSelection:e.props.preSelection,ariaLabelPrefix:e.props.ariaLabelPrefix,showWeekPicker:e.props.showWeekPicker,showWeekNumber:e.props.showWeekNumber,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef}))}return r.concat([0,1,2,3,4,5,6].map((function(r){var n=c.addDays(t,r);return de.default.createElement(Ft,{ariaLabelPrefixWhenEnabled:e.props.chooseDayAriaLabelPrefix,ariaLabelPrefixWhenDisabled:e.props.disabledDayAriaLabelPrefix,key:n.valueOf(),day:n,month:e.props.month,onClick:e.handleDayClick.bind(Pe(e),n),onMouseEnter:e.handleDayMouseEnter.bind(Pe(e),n),minDate:e.props.minDate,maxDate:e.props.maxDate,excludeDates:e.props.excludeDates,excludeDateIntervals:e.props.excludeDateIntervals,includeDates:e.props.includeDates,includeDateIntervals:e.props.includeDateIntervals,highlightDates:e.props.highlightDates,holidays:e.props.holidays,selectingDate:e.props.selectingDate,filterDate:e.props.filterDate,preSelection:e.props.preSelection,selected:e.props.selected,selectsStart:e.props.selectsStart,selectsEnd:e.props.selectsEnd,selectsRange:e.props.selectsRange,showWeekPicker:e.props.showWeekPicker,showWeekNumber:e.props.showWeekNumber,selectsDisabledDaysInRange:e.props.selectsDisabledDaysInRange,startDate:e.props.startDate,endDate:e.props.endDate,dayClassName:e.props.dayClassName,renderDayContents:e.props.renderDayContents,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef,inline:e.props.inline,shouldFocusDayInline:e.props.shouldFocusDayInline,monthShowsDuplicateDaysEnd:e.props.monthShowsDuplicateDaysEnd,monthShowsDuplicateDaysStart:e.props.monthShowsDuplicateDaysStart,locale:e.props.locale})})))})),Me(Pe(e),"startOfWeek",(function(){return We(e.props.day,e.props.locale,e.props.calendarStartDay)})),Me(Pe(e),"isKeyboardSelected",(function(){return!e.props.disabledKeyboardNavigation&&!Ue(e.startOfWeek(),e.props.selected)&&Ue(e.startOfWeek(),e.props.preSelection)})),e}return _e(t,e),Se(t,[{key:"render",value:function(){var e={"react-datepicker__week":!0,"react-datepicker__week--selected":Ue(this.startOfWeek(),this.props.selected),"react-datepicker__week--keyboard-selected":this.isKeyboardSelected()};return de.default.createElement("div",{className:ue.default(e)},this.renderDays())}}],[{key:"defaultProps",get:function(){return{shouldCloseOnSelect:!0}}}]),t}(de.default.Component),Qt="two_columns",qt="three_columns",Kt="four_columns",Bt=Me(Me(Me({},Qt,{grid:[[0,1],[2,3],[4,5],[6,7],[8,9],[10,11]],verticalNavigationOffset:2}),qt,{grid:[[0,1,2],[3,4,5],[6,7,8],[9,10,11]],verticalNavigationOffset:3}),Kt,{grid:[[0,1,2,3],[4,5,6,7],[8,9,10,11]],verticalNavigationOffset:4});function Ht(e,t){return e?Kt:t?Qt:qt}var jt=function(e){function t(){var e;we(this,t);for(var r=arguments.length,n=new Array(r),a=0;a<r;a++)n[a]=arguments[a];return Me(Pe(e=me(this,t,[].concat(n))),"MONTH_REFS",Ne(Array(12)).map((function(){return de.default.createRef()}))),Me(Pe(e),"QUARTER_REFS",Ne(Array(4)).map((function(){return de.default.createRef()}))),Me(Pe(e),"isDisabled",(function(t){return et(t,e.props)})),Me(Pe(e),"isExcluded",(function(t){return tt(t,e.props)})),Me(Pe(e),"handleDayClick",(function(t,r){e.props.onDayClick&&e.props.onDayClick(t,r,e.props.orderInDisplay)})),Me(Pe(e),"handleDayMouseEnter",(function(t){e.props.onDayMouseEnter&&e.props.onDayMouseEnter(t)})),Me(Pe(e),"handleMouseLeave",(function(){e.props.onMouseLeave&&e.props.onMouseLeave()})),Me(Pe(e),"isRangeStartMonth",(function(t){var r=e.props,n=r.day,a=r.startDate,o=r.endDate;return!(!a||!o)&&je(x.setMonth(n,t),a)})),Me(Pe(e),"isRangeStartQuarter",(function(t){var r=e.props,n=r.day,a=r.startDate,o=r.endDate;return!(!a||!o)&&Ve(I.setQuarter(n,t),a)})),Me(Pe(e),"isRangeEndMonth",(function(t){var r=e.props,n=r.day,a=r.startDate,o=r.endDate;return!(!a||!o)&&je(x.setMonth(n,t),o)})),Me(Pe(e),"isRangeEndQuarter",(function(t){var r=e.props,n=r.day,a=r.startDate,o=r.endDate;return!(!a||!o)&&Ve(I.setQuarter(n,t),o)})),Me(Pe(e),"isInSelectingRangeMonth",(function(t){var r,n=e.props,a=n.day,o=n.selectsStart,s=n.selectsEnd,i=n.selectsRange,p=n.startDate,c=n.endDate,l=null!==(r=e.props.selectingDate)&&void 0!==r?r:e.props.preSelection;return!(!(o||s||i)||!l)&&(o&&c?nt(l,c,t,a):(s&&p||!(!i||!p||c))&&nt(p,l,t,a))})),Me(Pe(e),"isSelectingMonthRangeStart",(function(t){var r;if(!e.isInSelectingRangeMonth(t))return!1;var n=e.props,a=n.day,o=n.startDate,s=n.selectsStart,i=x.setMonth(a,t),p=null!==(r=e.props.selectingDate)&&void 0!==r?r:e.props.preSelection;return je(i,s?p:o)})),Me(Pe(e),"isSelectingMonthRangeEnd",(function(t){var r;if(!e.isInSelectingRangeMonth(t))return!1;var n=e.props,a=n.day,o=n.endDate,s=n.selectsEnd,i=n.selectsRange,p=x.setMonth(a,t),c=null!==(r=e.props.selectingDate)&&void 0!==r?r:e.props.preSelection;return je(p,s||i?c:o)})),Me(Pe(e),"isInSelectingRangeQuarter",(function(t){var r,n=e.props,a=n.day,o=n.selectsStart,s=n.selectsEnd,i=n.selectsRange,p=n.startDate,c=n.endDate,l=null!==(r=e.props.selectingDate)&&void 0!==r?r:e.props.preSelection;return!(!(o||s||i)||!l)&&(o&&c?it(l,c,t,a):(s&&p||!(!i||!p||c))&&it(p,l,t,a))})),Me(Pe(e),"isWeekInMonth",(function(t){var r=e.props.day,n=c.addDays(t,6);return je(t,r)||je(n,r)})),Me(Pe(e),"isCurrentMonth",(function(e,t){return Y.getYear(e)===Y.getYear(Te())&&t===C.getMonth(Te())})),Me(Pe(e),"isCurrentQuarter",(function(e,t){return Y.getYear(e)===Y.getYear(Te())&&t===_.getQuarter(Te())})),Me(Pe(e),"isSelectedMonth",(function(e,t,r){return C.getMonth(r)===t&&Y.getYear(e)===Y.getYear(r)})),Me(Pe(e),"isSelectedQuarter",(function(e,t,r){return _.getQuarter(e)===t&&Y.getYear(e)===Y.getYear(r)})),Me(Pe(e),"renderWeeks",(function(){for(var t=[],r=e.props.fixedHeight,n=0,a=!1,o=We(Qe(e.props.day),e.props.locale,e.props.calendarStartDay);t.push(de.default.createElement(Wt,{ariaLabelPrefix:e.props.weekAriaLabelPrefix,chooseDayAriaLabelPrefix:e.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:e.props.disabledDayAriaLabelPrefix,key:n,day:o,month:C.getMonth(e.props.day),onDayClick:e.handleDayClick,onDayMouseEnter:e.handleDayMouseEnter,onWeekSelect:e.props.onWeekSelect,formatWeekNumber:e.props.formatWeekNumber,locale:e.props.locale,minDate:e.props.minDate,maxDate:e.props.maxDate,excludeDates:e.props.excludeDates,excludeDateIntervals:e.props.excludeDateIntervals,includeDates:e.props.includeDates,includeDateIntervals:e.props.includeDateIntervals,inline:e.props.inline,shouldFocusDayInline:e.props.shouldFocusDayInline,highlightDates:e.props.highlightDates,holidays:e.props.holidays,selectingDate:e.props.selectingDate,filterDate:e.props.filterDate,preSelection:e.props.preSelection,selected:e.props.selected,selectsStart:e.props.selectsStart,selectsEnd:e.props.selectsEnd,selectsRange:e.props.selectsRange,selectsDisabledDaysInRange:e.props.selectsDisabledDaysInRange,showWeekNumber:e.props.showWeekNumbers,showWeekPicker:e.props.showWeekPicker,startDate:e.props.startDate,endDate:e.props.endDate,dayClassName:e.props.dayClassName,setOpen:e.props.setOpen,shouldCloseOnSelect:e.props.shouldCloseOnSelect,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,renderDayContents:e.props.renderDayContents,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef,calendarStartDay:e.props.calendarStartDay,monthShowsDuplicateDaysEnd:e.props.monthShowsDuplicateDaysEnd,monthShowsDuplicateDaysStart:e.props.monthShowsDuplicateDaysStart})),!a;){n++,o=l.addWeeks(o,1);var s=r&&n>=6,i=!r&&!e.isWeekInMonth(o);if(s||i){if(!e.props.peekNextMonth)break;a=!0}}return t})),Me(Pe(e),"onMonthClick",(function(t,r){e.handleDayClick(Qe(x.setMonth(e.props.day,r)),t)})),Me(Pe(e),"onMonthMouseEnter",(function(t){e.handleDayMouseEnter(Qe(x.setMonth(e.props.day,t)))})),Me(Pe(e),"handleMonthNavigation",(function(t,r){e.isDisabled(r)||e.isExcluded(r)||(e.props.setPreSelection(r),e.MONTH_REFS[t].current&&e.MONTH_REFS[t].current.focus())})),Me(Pe(e),"onMonthKeyDown",(function(t,r){var n=e.props,a=n.selected,o=n.preSelection,s=n.disabledKeyboardNavigation,i=n.showTwoColumnMonthYearPicker,p=n.showFourColumnMonthYearPicker,c=n.setPreSelection,l=t.key;if("Tab"!==l&&t.preventDefault(),!s){var u=Ht(p,i),h=Bt[u].verticalNavigationOffset,f=Bt[u].grid;switch(l){case"Enter":e.onMonthClick(t,r),c(a);break;case"ArrowRight":e.handleMonthNavigation(11===r?0:r+1,d.addMonths(o,1));break;case"ArrowLeft":e.handleMonthNavigation(0===r?11:r-1,y.subMonths(o,1));break;case"ArrowUp":e.handleMonthNavigation(f[0].includes(r)?r+12-h:r-h,y.subMonths(o,h));break;case"ArrowDown":e.handleMonthNavigation(f[f.length-1].includes(r)?r-12+h:r+h,d.addMonths(o,h))}}})),Me(Pe(e),"onQuarterClick",(function(t,r){e.handleDayClick(Ke(I.setQuarter(e.props.day,r)),t)})),Me(Pe(e),"onQuarterMouseEnter",(function(t){e.handleDayMouseEnter(Ke(I.setQuarter(e.props.day,t)))})),Me(Pe(e),"handleQuarterNavigation",(function(t,r){e.isDisabled(r)||e.isExcluded(r)||(e.props.setPreSelection(r),e.QUARTER_REFS[t-1].current&&e.QUARTER_REFS[t-1].current.focus())})),Me(Pe(e),"onQuarterKeyDown",(function(t,r){var n=t.key;if(!e.props.disabledKeyboardNavigation)switch(n){case"Enter":e.onQuarterClick(t,r),e.props.setPreSelection(e.props.selected);break;case"ArrowRight":e.handleQuarterNavigation(4===r?1:r+1,u.addQuarters(e.props.preSelection,1));break;case"ArrowLeft":e.handleQuarterNavigation(1===r?4:r-1,g.subQuarters(e.props.preSelection,1))}})),Me(Pe(e),"getMonthClassNames",(function(t){var r=e.props,n=r.day,a=r.startDate,o=r.endDate,s=r.selected,i=r.minDate,p=r.maxDate,c=r.preSelection,l=r.monthClassName,d=r.excludeDates,u=r.includeDates,h=l?l(x.setMonth(n,t)):void 0,f=x.setMonth(n,t);return ue.default("react-datepicker__month-text","react-datepicker__month-".concat(t),h,{"react-datepicker__month-text--disabled":(i||p||d||u)&&rt(f,e.props),"react-datepicker__month-text--selected":e.isSelectedMonth(n,t,s),"react-datepicker__month-text--keyboard-selected":!e.props.disabledKeyboardNavigation&&C.getMonth(c)===t,"react-datepicker__month-text--in-selecting-range":e.isInSelectingRangeMonth(t),"react-datepicker__month-text--in-range":nt(a,o,t,n),"react-datepicker__month-text--range-start":e.isRangeStartMonth(t),"react-datepicker__month-text--range-end":e.isRangeEndMonth(t),"react-datepicker__month-text--selecting-range-start":e.isSelectingMonthRangeStart(t),"react-datepicker__month-text--selecting-range-end":e.isSelectingMonthRangeEnd(t),"react-datepicker__month-text--today":e.isCurrentMonth(n,t)})})),Me(Pe(e),"getTabIndex",(function(t){var r=C.getMonth(e.props.preSelection);return e.props.disabledKeyboardNavigation||t!==r?"-1":"0"})),Me(Pe(e),"getQuarterTabIndex",(function(t){var r=_.getQuarter(e.props.preSelection);return e.props.disabledKeyboardNavigation||t!==r?"-1":"0"})),Me(Pe(e),"getAriaLabel",(function(t){var r=e.props,n=r.chooseDayAriaLabelPrefix,a=void 0===n?"Choose":n,o=r.disabledDayAriaLabelPrefix,s=void 0===o?"Not available":o,i=r.day,p=x.setMonth(i,t),c=e.isDisabled(p)||e.isExcluded(p)?s:a;return"".concat(c," ").concat(Le(p,"MMMM yyyy"))})),Me(Pe(e),"getQuarterClassNames",(function(t){var r=e.props,n=r.day,a=r.startDate,o=r.endDate,s=r.selected,i=r.minDate,p=r.maxDate,c=r.preSelection,l=r.disabledKeyboardNavigation;return ue.default("react-datepicker__quarter-text","react-datepicker__quarter-".concat(t),{"react-datepicker__quarter-text--disabled":(i||p)&&at(I.setQuarter(n,t),e.props),"react-datepicker__quarter-text--selected":e.isSelectedQuarter(n,t,s),"react-datepicker__quarter-text--keyboard-selected":!l&&_.getQuarter(c)===t,"react-datepicker__quarter-text--in-selecting-range":e.isInSelectingRangeQuarter(t),"react-datepicker__quarter-text--in-range":it(a,o,t,n),"react-datepicker__quarter-text--range-start":e.isRangeStartQuarter(t),"react-datepicker__quarter-text--range-end":e.isRangeEndQuarter(t)})})),Me(Pe(e),"getMonthContent",(function(t){var r=e.props,n=r.showFullMonthYearPicker,a=r.renderMonthContent,o=r.locale,s=r.day,i=Ze(t,o),p=Xe(t,o);return a?a(t,i,p,s):n?p:i})),Me(Pe(e),"getQuarterContent",(function(t){var r=e.props,n=r.renderQuarterContent,a=function(e,t){return Le(I.setQuarter(Te(),e),"QQQ",t)}(t,r.locale);return n?n(t,a):a})),Me(Pe(e),"renderMonths",(function(){var t=e.props,r=t.showTwoColumnMonthYearPicker,n=t.showFourColumnMonthYearPicker,a=t.day,o=t.selected;return Bt[Ht(n,r)].grid.map((function(t,r){return de.default.createElement("div",{className:"react-datepicker__month-wrapper",key:r},t.map((function(t,r){return de.default.createElement("div",{ref:e.MONTH_REFS[t],key:r,onClick:function(r){e.onMonthClick(r,t)},onKeyDown:function(r){e.onMonthKeyDown(r,t)},onMouseEnter:function(){return e.onMonthMouseEnter(t)},tabIndex:e.getTabIndex(t),className:e.getMonthClassNames(t),role:"option","aria-label":e.getAriaLabel(t),"aria-current":e.isCurrentMonth(a,t)?"date":void 0,"aria-selected":e.isSelectedMonth(a,t,o)},e.getMonthContent(t))})))}))})),Me(Pe(e),"renderQuarters",(function(){var t=e.props,r=t.day,n=t.selected;return de.default.createElement("div",{className:"react-datepicker__quarter-wrapper"},[1,2,3,4].map((function(t,a){return de.default.createElement("div",{key:a,ref:e.QUARTER_REFS[a],role:"option",onClick:function(r){e.onQuarterClick(r,t)},onKeyDown:function(r){e.onQuarterKeyDown(r,t)},onMouseEnter:function(){return e.onQuarterMouseEnter(t)},className:e.getQuarterClassNames(t),"aria-selected":e.isSelectedQuarter(r,t,n),tabIndex:e.getQuarterTabIndex(t),"aria-current":e.isCurrentQuarter(r,t)?"date":void 0},e.getQuarterContent(t))})))})),Me(Pe(e),"getClassNames",(function(){var t=e.props,r=t.selectingDate,n=t.selectsStart,a=t.selectsEnd,o=t.showMonthYearPicker,s=t.showQuarterYearPicker,i=t.showWeekPicker;return ue.default("react-datepicker__month",{"react-datepicker__month--selecting-range":r&&(n||a)},{"react-datepicker__monthPicker":o},{"react-datepicker__quarterPicker":s},{"react-datepicker__weekPicker":i})})),e}return _e(t,e),Se(t,[{key:"render",value:function(){var e=this.props,t=e.showMonthYearPicker,r=e.showQuarterYearPicker,n=e.day,a=e.ariaLabelPrefix,o=void 0===a?"month ":a;return de.default.createElement("div",{className:this.getClassNames(),onMouseLeave:this.handleMouseLeave,"aria-label":"".concat(o," ").concat(Le(n,"yyyy-MM")),role:"listbox"},t?this.renderMonths():r?this.renderQuarters():this.renderWeeks())}}]),t}(de.default.Component),Vt=function(e){function t(){var e;we(this,t);for(var r=arguments.length,n=new Array(r),a=0;a<r;a++)n[a]=arguments[a];return Me(Pe(e=me(this,t,[].concat(n))),"state",{height:null}),Me(Pe(e),"scrollToTheSelectedTime",(function(){requestAnimationFrame((function(){e.list&&(e.list.scrollTop=e.centerLi&&t.calcCenterPosition(e.props.monthRef?e.props.monthRef.clientHeight-e.header.clientHeight:e.list.clientHeight,e.centerLi))}))})),Me(Pe(e),"handleClick",(function(t){(e.props.minTime||e.props.maxTime)&&dt(t,e.props)||(e.props.excludeTimes||e.props.includeTimes||e.props.filterTime)&&lt(t,e.props)||e.props.onChange(t)})),Me(Pe(e),"isSelectedTime",(function(t){return e.props.selected&&(r=e.props.selected,n=t,St(r).getTime()===St(n).getTime());var r,n})),Me(Pe(e),"isDisabledTime",(function(t){return(e.props.minTime||e.props.maxTime)&&dt(t,e.props)||(e.props.excludeTimes||e.props.includeTimes||e.props.filterTime)&&lt(t,e.props)})),Me(Pe(e),"liClasses",(function(t){var r=["react-datepicker__time-list-item",e.props.timeClassName?e.props.timeClassName(t):void 0];return e.isSelectedTime(t)&&r.push("react-datepicker__time-list-item--selected"),e.isDisabledTime(t)&&r.push("react-datepicker__time-list-item--disabled"),e.props.injectTimes&&(60*w.getHours(t)+k.getMinutes(t))%e.props.intervals!=0&&r.push("react-datepicker__time-list-item--injected"),r.join(" ")})),Me(Pe(e),"handleOnKeyDown",(function(t,r){" "===t.key&&(t.preventDefault(),t.key="Enter"),"ArrowUp"!==t.key&&"ArrowLeft"!==t.key||!t.target.previousSibling||(t.preventDefault(),t.target.previousSibling.focus()),"ArrowDown"!==t.key&&"ArrowRight"!==t.key||!t.target.nextSibling||(t.preventDefault(),t.target.nextSibling.focus()),"Enter"===t.key&&e.handleClick(r),e.props.handleOnKeyDown(t)})),Me(Pe(e),"renderTimes",(function(){for(var t,r=[],n=e.props.format?e.props.format:"p",a=e.props.intervals,o=e.props.selected||e.props.openToDate||Te(),s=(t=o,Q.startOfDay(t)),p=e.props.injectTimes&&e.props.injectTimes.sort((function(e,t){return e-t})),c=60*function(e){var t=new Date(e.getFullYear(),e.getMonth(),e.getDate()),r=new Date(e.getFullYear(),e.getMonth(),e.getDate(),24);return Math.round((+r-+t)/36e5)}(o),l=c/a,d=0;d<l;d++){var u=i.addMinutes(s,d*a);if(r.push(u),p){var h=kt(s,u,d,a,p);r=r.concat(h)}}var f=r.reduce((function(e,t){return t.getTime()<=o.getTime()?t:e}),r[0]);return r.map((function(t,r){return de.default.createElement("li",{key:r,onClick:e.handleClick.bind(Pe(e),t),className:e.liClasses(t),ref:function(r){t===f&&(e.centerLi=r)},onKeyDown:function(r){e.handleOnKeyDown(r,t)},tabIndex:t===f?0:-1,role:"option","aria-selected":e.isSelectedTime(t)?"true":void 0,"aria-disabled":e.isDisabledTime(t)?"true":void 0},Le(t,n,e.props.locale))}))})),e}return _e(t,e),Se(t,[{key:"componentDidMount",value:function(){this.scrollToTheSelectedTime(),this.props.monthRef&&this.header&&this.setState({height:this.props.monthRef.clientHeight-this.header.clientHeight})}},{key:"render",value:function(){var e=this,t=this.state.height;return de.default.createElement("div",{className:"react-datepicker__time-container ".concat(this.props.todayButton?"react-datepicker__time-container--with-today-button":"")},de.default.createElement("div",{className:"react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly?"react-datepicker__header--time--only":""),ref:function(t){e.header=t}},de.default.createElement("div",{className:"react-datepicker-time__header"},this.props.timeCaption)),de.default.createElement("div",{className:"react-datepicker__time"},de.default.createElement("div",{className:"react-datepicker__time-box"},de.default.createElement("ul",{className:"react-datepicker__time-list",ref:function(t){e.list=t},style:t?{height:t}:{},role:"listbox","aria-label":this.props.timeCaption},this.renderTimes()))))}}],[{key:"defaultProps",get:function(){return{intervals:30,onTimeChange:function(){},todayButton:null,timeCaption:"Time"}}}]),t}(de.default.Component);Me(Vt,"calcCenterPosition",(function(e,t){return t.offsetTop-(e/2-t.clientHeight/2)}));var Ut=function(e){function t(e){var r;return we(this,t),Me(Pe(r=me(this,t,[e])),"YEAR_REFS",Ne(Array(r.props.yearItemNumber)).map((function(){return de.default.createRef()}))),Me(Pe(r),"isDisabled",(function(e){return et(e,r.props)})),Me(Pe(r),"isExcluded",(function(e){return tt(e,r.props)})),Me(Pe(r),"selectingDate",(function(){var e;return null!==(e=r.props.selectingDate)&&void 0!==e?e:r.props.preSelection})),Me(Pe(r),"updateFocusOnPaginate",(function(e){var t=function(){this.YEAR_REFS[e].current.focus()}.bind(Pe(r));window.requestAnimationFrame(t)})),Me(Pe(r),"handleYearClick",(function(e,t){r.props.onDayClick&&r.props.onDayClick(e,t)})),Me(Pe(r),"handleYearNavigation",(function(e,t){var n=r.props,a=n.date,o=n.yearItemNumber,s=bt(a,o).startPeriod;r.isDisabled(t)||r.isExcluded(t)||(r.props.setPreSelection(t),e-s==-1?r.updateFocusOnPaginate(o-1):e-s===o?r.updateFocusOnPaginate(0):r.YEAR_REFS[e-s].current.focus())})),Me(Pe(r),"isSameDay",(function(e,t){return Ue(e,t)})),Me(Pe(r),"isCurrentYear",(function(e){return e===Y.getYear(Te())})),Me(Pe(r),"isRangeStart",(function(e){return r.props.startDate&&r.props.endDate&&He(T.setYear(Te(),e),r.props.startDate)})),Me(Pe(r),"isRangeEnd",(function(e){return r.props.startDate&&r.props.endDate&&He(T.setYear(Te(),e),r.props.endDate)})),Me(Pe(r),"isInRange",(function(e){return ot(e,r.props.startDate,r.props.endDate)})),Me(Pe(r),"isInSelectingRange",(function(e){var t=r.props,n=t.selectsStart,a=t.selectsEnd,o=t.selectsRange,s=t.startDate,i=t.endDate;return!(!(n||a||o)||!r.selectingDate())&&(n&&i?ot(e,r.selectingDate(),i):(a&&s||!(!o||!s||i))&&ot(e,s,r.selectingDate()))})),Me(Pe(r),"isSelectingRangeStart",(function(e){if(!r.isInSelectingRange(e))return!1;var t=r.props,n=t.startDate,a=t.selectsStart,o=T.setYear(Te(),e);return He(o,a?r.selectingDate():n)})),Me(Pe(r),"isSelectingRangeEnd",(function(e){if(!r.isInSelectingRange(e))return!1;var t=r.props,n=t.endDate,a=t.selectsEnd,o=t.selectsRange,s=T.setYear(Te(),e);return He(s,a||o?r.selectingDate():n)})),Me(Pe(r),"isKeyboardSelected",(function(e){var t=qe(T.setYear(r.props.date,e));return!r.props.disabledKeyboardNavigation&&!r.props.inline&&!Ue(t,qe(r.props.selected))&&Ue(t,qe(r.props.preSelection))})),Me(Pe(r),"onYearClick",(function(e,t){var n=r.props.date;r.handleYearClick(qe(T.setYear(n,t)),e)})),Me(Pe(r),"onYearKeyDown",(function(e,t){var n=e.key;if(!r.props.disabledKeyboardNavigation)switch(n){case"Enter":r.onYearClick(e,t),r.props.setPreSelection(r.props.selected);break;case"ArrowRight":r.handleYearNavigation(t+1,h.addYears(r.props.preSelection,1));break;case"ArrowLeft":r.handleYearNavigation(t-1,D.subYears(r.props.preSelection,1))}})),Me(Pe(r),"getYearClassNames",(function(e){var t=r.props,n=t.minDate,a=t.maxDate,o=t.selected,s=t.excludeDates,i=t.includeDates,p=t.filterDate;return ue.default("react-datepicker__year-text",{"react-datepicker__year-text--selected":e===Y.getYear(o),"react-datepicker__year-text--disabled":(n||a||s||i||p)&&st(e,r.props),"react-datepicker__year-text--keyboard-selected":r.isKeyboardSelected(e),"react-datepicker__year-text--range-start":r.isRangeStart(e),"react-datepicker__year-text--range-end":r.isRangeEnd(e),"react-datepicker__year-text--in-range":r.isInRange(e),"react-datepicker__year-text--in-selecting-range":r.isInSelectingRange(e),"react-datepicker__year-text--selecting-range-start":r.isSelectingRangeStart(e),"react-datepicker__year-text--selecting-range-end":r.isSelectingRangeEnd(e),"react-datepicker__year-text--today":r.isCurrentYear(e)})})),Me(Pe(r),"getYearTabIndex",(function(e){return r.props.disabledKeyboardNavigation?"-1":e===Y.getYear(r.props.preSelection)?"0":"-1"})),Me(Pe(r),"getYearContainerClassNames",(function(){var e=r.props,t=e.selectingDate,n=e.selectsStart,a=e.selectsEnd,o=e.selectsRange;return ue.default("react-datepicker__year",{"react-datepicker__year--selecting-range":t&&(n||a||o)})})),Me(Pe(r),"getYearContent",(function(e){return r.props.renderYearContent?r.props.renderYearContent(e):e})),r}return _e(t,e),Se(t,[{key:"render",value:function(){for(var e=this,t=[],r=this.props,n=r.date,a=r.yearItemNumber,o=r.onYearMouseEnter,s=r.onYearMouseLeave,i=bt(n,a),p=i.startPeriod,c=i.endPeriod,l=function(r){t.push(de.default.createElement("div",{ref:e.YEAR_REFS[r-p],onClick:function(t){e.onYearClick(t,r)},onKeyDown:function(t){e.onYearKeyDown(t,r)},tabIndex:e.getYearTabIndex(r),className:e.getYearClassNames(r),onMouseEnter:function(e){return o(e,r)},onMouseLeave:function(e){return s(e,r)},key:r,"aria-current":e.isCurrentYear(r)?"date":void 0},e.getYearContent(r)))},d=p;d<=c;d++)l(d);return de.default.createElement("div",{className:this.getYearContainerClassNames()},de.default.createElement("div",{className:"react-datepicker__year-wrapper",onMouseLeave:this.props.clearSelectingDate},t))}}]),t}(de.default.Component),$t=function(e){function t(e){var r;return we(this,t),Me(Pe(r=me(this,t,[e])),"onTimeChange",(function(e){r.setState({time:e});var t=r.props.date,n=t instanceof Date&&!isNaN(t)?t:new Date;n.setHours(e.split(":")[0]),n.setMinutes(e.split(":")[1]),r.props.onChange(n)})),Me(Pe(r),"renderTimeInput",(function(){var e=r.state.time,t=r.props,n=t.date,a=t.timeString,o=t.customTimeInput;return o?de.default.cloneElement(o,{date:n,value:e,onChange:r.onTimeChange}):de.default.createElement("input",{type:"time",className:"react-datepicker-time__input",placeholder:"Time",name:"time-input",required:!0,value:e,onChange:function(e){r.onTimeChange(e.target.value||a)}})})),r.state={time:r.props.timeString},r}return _e(t,e),Se(t,[{key:"render",value:function(){return de.default.createElement("div",{className:"react-datepicker__input-time-container"},de.default.createElement("div",{className:"react-datepicker-time__caption"},this.props.timeInputLabel),de.default.createElement("div",{className:"react-datepicker-time__input-container"},de.default.createElement("div",{className:"react-datepicker-time__input"},this.renderTimeInput())))}}],[{key:"getDerivedStateFromProps",value:function(e,t){return e.timeString!==t.time?{time:e.timeString}:null}}]),t}(de.default.Component);function zt(e){var t=e.className,r=e.children;return de.default.createElement("div",{className:t},r)}var Gt=["react-datepicker__year-select","react-datepicker__month-select","react-datepicker__month-year-select"],Jt=function(e){function t(e){var r;return we(this,t),Me(Pe(r=me(this,t,[e])),"handleClickOutside",(function(e){r.props.onClickOutside(e)})),Me(Pe(r),"setClickOutsideRef",(function(){return r.containerRef.current})),Me(Pe(r),"handleDropdownFocus",(function(e){(function(){var e=((arguments.length>0&&void 0!==arguments[0]?arguments[0]:{}).className||"").split(/\s+/);return Gt.some((function(t){return e.indexOf(t)>=0}))})(e.target)&&r.props.onDropdownFocus()})),Me(Pe(r),"getDateInView",(function(){var e=r.props,t=e.preSelection,n=e.selected,a=e.openToDate,o=yt(r.props),s=gt(r.props),i=Te(),p=a||n||t;return p||(o&&te.isBefore(i,o)?o:s&&ee.isAfter(i,s)?s:i)})),Me(Pe(r),"increaseMonth",(function(){r.setState((function(e){var t=e.date;return{date:d.addMonths(t,1)}}),(function(){return r.handleMonthChange(r.state.date)}))})),Me(Pe(r),"decreaseMonth",(function(){r.setState((function(e){var t=e.date;return{date:y.subMonths(t,1)}}),(function(){return r.handleMonthChange(r.state.date)}))})),Me(Pe(r),"handleDayClick",(function(e,t,n){r.props.onSelect(e,t,n),r.props.setPreSelection&&r.props.setPreSelection(e)})),Me(Pe(r),"handleDayMouseEnter",(function(e){r.setState({selectingDate:e}),r.props.onDayMouseEnter&&r.props.onDayMouseEnter(e)})),Me(Pe(r),"handleMonthMouseLeave",(function(){r.setState({selectingDate:null}),r.props.onMonthMouseLeave&&r.props.onMonthMouseLeave()})),Me(Pe(r),"handleYearMouseEnter",(function(e,t){r.setState({selectingDate:T.setYear(Te(),t)}),r.props.onYearMouseEnter&&r.props.onYearMouseEnter(e,t)})),Me(Pe(r),"handleYearMouseLeave",(function(e,t){r.props.onYearMouseLeave&&r.props.onYearMouseLeave(e,t)})),Me(Pe(r),"handleYearChange",(function(e){r.props.onYearChange&&(r.props.onYearChange(e),r.setState({isRenderAriaLiveMessage:!0})),r.props.adjustDateOnChange&&(r.props.onSelect&&r.props.onSelect(e),r.props.setOpen&&r.props.setOpen(!0)),r.props.setPreSelection&&r.props.setPreSelection(e)})),Me(Pe(r),"handleMonthChange",(function(e){r.handleCustomMonthChange(e),r.props.adjustDateOnChange&&(r.props.onSelect&&r.props.onSelect(e),r.props.setOpen&&r.props.setOpen(!0)),r.props.setPreSelection&&r.props.setPreSelection(e)})),Me(Pe(r),"handleCustomMonthChange",(function(e){r.props.onMonthChange&&(r.props.onMonthChange(e),r.setState({isRenderAriaLiveMessage:!0}))})),Me(Pe(r),"handleMonthYearChange",(function(e){r.handleYearChange(e),r.handleMonthChange(e)})),Me(Pe(r),"changeYear",(function(e){r.setState((function(t){var r=t.date;return{date:T.setYear(r,e)}}),(function(){return r.handleYearChange(r.state.date)}))})),Me(Pe(r),"changeMonth",(function(e){r.setState((function(t){var r=t.date;return{date:x.setMonth(r,e)}}),(function(){return r.handleMonthChange(r.state.date)}))})),Me(Pe(r),"changeMonthYear",(function(e){r.setState((function(t){var r=t.date;return{date:T.setYear(x.setMonth(r,C.getMonth(e)),Y.getYear(e))}}),(function(){return r.handleMonthYearChange(r.state.date)}))})),Me(Pe(r),"header",(function(){var e=We(arguments.length>0&&void 0!==arguments[0]?arguments[0]:r.state.date,r.props.locale,r.props.calendarStartDay),t=[];return r.props.showWeekNumbers&&t.push(de.default.createElement("div",{key:"W",className:"react-datepicker__day-name"},r.props.weekLabel||"#")),t.concat([0,1,2,3,4,5,6].map((function(t){var n=c.addDays(e,t),a=r.formatWeekday(n,r.props.locale),o=r.props.weekDayClassName?r.props.weekDayClassName(n):void 0;return de.default.createElement("div",{key:t,className:ue.default("react-datepicker__day-name",o)},a)})))})),Me(Pe(r),"formatWeekday",(function(e,t){return r.props.formatWeekDay?function(e,t,r){return t(Le(e,"EEEE",r))}(e,r.props.formatWeekDay,t):r.props.useWeekdaysShort?function(e,t){return Le(e,"EEE",t)}(e,t):function(e,t){return Le(e,"EEEEEE",t)}(e,t)})),Me(Pe(r),"decreaseYear",(function(){r.setState((function(e){var t=e.date;return{date:D.subYears(t,r.props.showYearPicker?r.props.yearItemNumber:1)}}),(function(){return r.handleYearChange(r.state.date)}))})),Me(Pe(r),"clearSelectingDate",(function(){r.setState({selectingDate:null})})),Me(Pe(r),"renderPreviousButton",(function(){if(!r.props.renderCustomHeader){var e;switch(!0){case r.props.showMonthYearPicker:e=ft(r.state.date,r.props);break;case r.props.showYearPicker:e=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.yearItemNumber,a=void 0===n?xe:n,o=bt(qe(D.subYears(e,a)),a).endPeriod,s=r&&Y.getYear(r);return s&&s>o||!1}(r.state.date,r.props);break;default:e=ut(r.state.date,r.props)}if((r.props.forceShowMonthNavigation||r.props.showDisabledMonthNavigation||!e)&&!r.props.showTimeSelectOnly){var t=["react-datepicker__navigation","react-datepicker__navigation--previous"],n=r.decreaseMonth;(r.props.showMonthYearPicker||r.props.showQuarterYearPicker||r.props.showYearPicker)&&(n=r.decreaseYear),e&&r.props.showDisabledMonthNavigation&&(t.push("react-datepicker__navigation--previous--disabled"),n=null);var a=r.props.showMonthYearPicker||r.props.showQuarterYearPicker||r.props.showYearPicker,o=r.props,s=o.previousMonthButtonLabel,i=o.previousYearButtonLabel,p=r.props,c=p.previousMonthAriaLabel,l=void 0===c?"string"==typeof s?s:"Previous Month":c,d=p.previousYearAriaLabel,u=void 0===d?"string"==typeof i?i:"Previous Year":d;return de.default.createElement("button",{type:"button",className:t.join(" "),onClick:n,onKeyDown:r.props.handleOnKeyDown,"aria-label":a?u:l},de.default.createElement("span",{className:["react-datepicker__navigation-icon","react-datepicker__navigation-icon--previous"].join(" ")},a?r.props.previousYearButtonLabel:r.props.previousMonthButtonLabel))}}})),Me(Pe(r),"increaseYear",(function(){r.setState((function(e){var t=e.date;return{date:h.addYears(t,r.props.showYearPicker?r.props.yearItemNumber:1)}}),(function(){return r.handleYearChange(r.state.date)}))})),Me(Pe(r),"renderNextButton",(function(){if(!r.props.renderCustomHeader){var e;switch(!0){case r.props.showMonthYearPicker:e=mt(r.state.date,r.props);break;case r.props.showYearPicker:e=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.yearItemNumber,a=void 0===n?xe:n,o=bt(h.addYears(e,a),a).startPeriod,s=r&&Y.getYear(r);return s&&s<o||!1}(r.state.date,r.props);break;default:e=ht(r.state.date,r.props)}if((r.props.forceShowMonthNavigation||r.props.showDisabledMonthNavigation||!e)&&!r.props.showTimeSelectOnly){var t=["react-datepicker__navigation","react-datepicker__navigation--next"];r.props.showTimeSelect&&t.push("react-datepicker__navigation--next--with-time"),r.props.todayButton&&t.push("react-datepicker__navigation--next--with-today-button");var n=r.increaseMonth;(r.props.showMonthYearPicker||r.props.showQuarterYearPicker||r.props.showYearPicker)&&(n=r.increaseYear),e&&r.props.showDisabledMonthNavigation&&(t.push("react-datepicker__navigation--next--disabled"),n=null);var a=r.props.showMonthYearPicker||r.props.showQuarterYearPicker||r.props.showYearPicker,o=r.props,s=o.nextMonthButtonLabel,i=o.nextYearButtonLabel,p=r.props,c=p.nextMonthAriaLabel,l=void 0===c?"string"==typeof s?s:"Next Month":c,d=p.nextYearAriaLabel,u=void 0===d?"string"==typeof i?i:"Next Year":d;return de.default.createElement("button",{type:"button",className:t.join(" "),onClick:n,onKeyDown:r.props.handleOnKeyDown,"aria-label":a?u:l},de.default.createElement("span",{className:["react-datepicker__navigation-icon","react-datepicker__navigation-icon--next"].join(" ")},a?r.props.nextYearButtonLabel:r.props.nextMonthButtonLabel))}}})),Me(Pe(r),"renderCurrentMonth",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:r.state.date,t=["react-datepicker__current-month"];return r.props.showYearDropdown&&t.push("react-datepicker__current-month--hasYearDropdown"),r.props.showMonthDropdown&&t.push("react-datepicker__current-month--hasMonthDropdown"),r.props.showMonthYearDropdown&&t.push("react-datepicker__current-month--hasMonthYearDropdown"),de.default.createElement("div",{className:t.join(" ")},Le(e,r.props.dateFormat,r.props.locale))})),Me(Pe(r),"renderYearDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(r.props.showYearDropdown&&!e)return de.default.createElement(Pt,{adjustDateOnChange:r.props.adjustDateOnChange,date:r.state.date,onSelect:r.props.onSelect,setOpen:r.props.setOpen,dropdownMode:r.props.dropdownMode,onChange:r.changeYear,minDate:r.props.minDate,maxDate:r.props.maxDate,year:Y.getYear(r.state.date),scrollableYearDropdown:r.props.scrollableYearDropdown,yearDropdownItemNumber:r.props.yearDropdownItemNumber})})),Me(Pe(r),"renderMonthDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(r.props.showMonthDropdown&&!e)return de.default.createElement(xt,{dropdownMode:r.props.dropdownMode,locale:r.props.locale,onChange:r.changeMonth,month:C.getMonth(r.state.date),useShortMonthInDropdown:r.props.useShortMonthInDropdown})})),Me(Pe(r),"renderMonthYearDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(r.props.showMonthYearDropdown&&!e)return de.default.createElement(Lt,{dropdownMode:r.props.dropdownMode,locale:r.props.locale,dateFormat:r.props.dateFormat,onChange:r.changeMonthYear,minDate:r.props.minDate,maxDate:r.props.maxDate,date:r.state.date,scrollableMonthYearDropdown:r.props.scrollableMonthYearDropdown})})),Me(Pe(r),"handleTodayButtonClick",(function(e){r.props.onSelect(Be(),e),r.props.setPreSelection&&r.props.setPreSelection(Be())})),Me(Pe(r),"renderTodayButton",(function(){if(r.props.todayButton&&!r.props.showTimeSelectOnly)return de.default.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return r.handleTodayButtonClick(e)}},r.props.todayButton)})),Me(Pe(r),"renderDefaultHeader",(function(e){var t=e.monthDate,n=e.i;return de.default.createElement("div",{className:"react-datepicker__header ".concat(r.props.showTimeSelect?"react-datepicker__header--has-time-select":"")},r.renderCurrentMonth(t),de.default.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(r.props.dropdownMode),onFocus:r.handleDropdownFocus},r.renderMonthDropdown(0!==n),r.renderMonthYearDropdown(0!==n),r.renderYearDropdown(0!==n)),de.default.createElement("div",{className:"react-datepicker__day-names"},r.header(t)))})),Me(Pe(r),"renderCustomHeader",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.monthDate,n=e.i;if(r.props.showTimeSelect&&!r.state.monthContainer||r.props.showTimeSelectOnly)return null;var a=ut(r.state.date,r.props),o=ht(r.state.date,r.props),s=ft(r.state.date,r.props),i=mt(r.state.date,r.props),p=!r.props.showMonthYearPicker&&!r.props.showQuarterYearPicker&&!r.props.showYearPicker;return de.default.createElement("div",{className:"react-datepicker__header react-datepicker__header--custom",onFocus:r.props.onDropdownFocus},r.props.renderCustomHeader(De(De({},r.state),{},{customHeaderCount:n,monthDate:t,changeMonth:r.changeMonth,changeYear:r.changeYear,decreaseMonth:r.decreaseMonth,increaseMonth:r.increaseMonth,decreaseYear:r.decreaseYear,increaseYear:r.increaseYear,prevMonthButtonDisabled:a,nextMonthButtonDisabled:o,prevYearButtonDisabled:s,nextYearButtonDisabled:i})),p&&de.default.createElement("div",{className:"react-datepicker__day-names"},r.header(t)))})),Me(Pe(r),"renderYearHeader",(function(){var e=r.state.date,t=r.props,n=t.showYearPicker,a=bt(e,t.yearItemNumber),o=a.startPeriod,s=a.endPeriod;return de.default.createElement("div",{className:"react-datepicker__header react-datepicker-year-header"},n?"".concat(o," - ").concat(s):Y.getYear(e))})),Me(Pe(r),"renderHeader",(function(e){switch(!0){case void 0!==r.props.renderCustomHeader:return r.renderCustomHeader(e);case r.props.showMonthYearPicker||r.props.showQuarterYearPicker||r.props.showYearPicker:return r.renderYearHeader(e);default:return r.renderDefaultHeader(e)}})),Me(Pe(r),"renderMonths",(function(){var e;if(!r.props.showTimeSelectOnly&&!r.props.showYearPicker){for(var t=[],n=r.props.showPreviousMonths?r.props.monthsShown-1:0,a=y.subMonths(r.state.date,n),o=null!==(e=r.props.monthSelectedIn)&&void 0!==e?e:n,s=0;s<r.props.monthsShown;++s){var i=s-o+n,p=d.addMonths(a,i),c="month-".concat(s),l=s<r.props.monthsShown-1,u=s>0;t.push(de.default.createElement("div",{key:c,ref:function(e){r.monthContainer=e},className:"react-datepicker__month-container"},r.renderHeader({monthDate:p,i:s}),de.default.createElement(jt,{chooseDayAriaLabelPrefix:r.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:r.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:r.props.weekAriaLabelPrefix,ariaLabelPrefix:r.props.monthAriaLabelPrefix,onChange:r.changeMonthYear,day:p,dayClassName:r.props.dayClassName,calendarStartDay:r.props.calendarStartDay,monthClassName:r.props.monthClassName,onDayClick:r.handleDayClick,handleOnKeyDown:r.props.handleOnDayKeyDown,onDayMouseEnter:r.handleDayMouseEnter,onMouseLeave:r.handleMonthMouseLeave,onWeekSelect:r.props.onWeekSelect,orderInDisplay:s,formatWeekNumber:r.props.formatWeekNumber,locale:r.props.locale,minDate:r.props.minDate,maxDate:r.props.maxDate,excludeDates:r.props.excludeDates,excludeDateIntervals:r.props.excludeDateIntervals,highlightDates:r.props.highlightDates,holidays:r.props.holidays,selectingDate:r.state.selectingDate,includeDates:r.props.includeDates,includeDateIntervals:r.props.includeDateIntervals,inline:r.props.inline,shouldFocusDayInline:r.props.shouldFocusDayInline,fixedHeight:r.props.fixedHeight,filterDate:r.props.filterDate,preSelection:r.props.preSelection,setPreSelection:r.props.setPreSelection,selected:r.props.selected,selectsStart:r.props.selectsStart,selectsEnd:r.props.selectsEnd,selectsRange:r.props.selectsRange,selectsDisabledDaysInRange:r.props.selectsDisabledDaysInRange,showWeekNumbers:r.props.showWeekNumbers,startDate:r.props.startDate,endDate:r.props.endDate,peekNextMonth:r.props.peekNextMonth,setOpen:r.props.setOpen,shouldCloseOnSelect:r.props.shouldCloseOnSelect,renderDayContents:r.props.renderDayContents,renderMonthContent:r.props.renderMonthContent,renderQuarterContent:r.props.renderQuarterContent,renderYearContent:r.props.renderYearContent,disabledKeyboardNavigation:r.props.disabledKeyboardNavigation,showMonthYearPicker:r.props.showMonthYearPicker,showFullMonthYearPicker:r.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:r.props.showTwoColumnMonthYearPicker,showFourColumnMonthYearPicker:r.props.showFourColumnMonthYearPicker,showYearPicker:r.props.showYearPicker,showQuarterYearPicker:r.props.showQuarterYearPicker,showWeekPicker:r.props.showWeekPicker,isInputFocused:r.props.isInputFocused,containerRef:r.containerRef,monthShowsDuplicateDaysEnd:l,monthShowsDuplicateDaysStart:u})))}return t}})),Me(Pe(r),"renderYears",(function(){if(!r.props.showTimeSelectOnly)return r.props.showYearPicker?de.default.createElement("div",{className:"react-datepicker__year--container"},r.renderHeader(),de.default.createElement(Ut,Ce({onDayClick:r.handleDayClick,selectingDate:r.state.selectingDate,clearSelectingDate:r.clearSelectingDate,date:r.state.date},r.props,{onYearMouseEnter:r.handleYearMouseEnter,onYearMouseLeave:r.handleYearMouseLeave}))):void 0})),Me(Pe(r),"renderTimeSection",(function(){if(r.props.showTimeSelect&&(r.state.monthContainer||r.props.showTimeSelectOnly))return de.default.createElement(Vt,{selected:r.props.selected,openToDate:r.props.openToDate,onChange:r.props.onTimeChange,timeClassName:r.props.timeClassName,format:r.props.timeFormat,includeTimes:r.props.includeTimes,intervals:r.props.timeIntervals,minTime:r.props.minTime,maxTime:r.props.maxTime,excludeTimes:r.props.excludeTimes,filterTime:r.props.filterTime,timeCaption:r.props.timeCaption,todayButton:r.props.todayButton,showMonthDropdown:r.props.showMonthDropdown,showMonthYearDropdown:r.props.showMonthYearDropdown,showYearDropdown:r.props.showYearDropdown,withPortal:r.props.withPortal,monthRef:r.state.monthContainer,injectTimes:r.props.injectTimes,locale:r.props.locale,handleOnKeyDown:r.props.handleOnKeyDown,showTimeSelectOnly:r.props.showTimeSelectOnly})})),Me(Pe(r),"renderInputTimeSection",(function(){var e=new Date(r.props.selected),t=Re(e)&&Boolean(r.props.selected)?"".concat(wt(e.getHours()),":").concat(wt(e.getMinutes())):"";if(r.props.showTimeInput)return de.default.createElement($t,{date:e,timeString:t,timeInputLabel:r.props.timeInputLabel,onChange:r.props.onTimeChange,customTimeInput:r.props.customTimeInput})})),Me(Pe(r),"renderAriaLiveRegion",(function(){var e,t=bt(r.state.date,r.props.yearItemNumber),n=t.startPeriod,a=t.endPeriod;return e=r.props.showYearPicker?"".concat(n," - ").concat(a):r.props.showMonthYearPicker||r.props.showQuarterYearPicker?Y.getYear(r.state.date):"".concat(Xe(C.getMonth(r.state.date),r.props.locale)," ").concat(Y.getYear(r.state.date)),de.default.createElement("span",{role:"alert","aria-live":"polite",className:"react-datepicker__aria-live"},r.state.isRenderAriaLiveMessage&&e)})),Me(Pe(r),"renderChildren",(function(){if(r.props.children)return de.default.createElement("div",{className:"react-datepicker__children-container"},r.props.children)})),r.containerRef=de.default.createRef(),r.state={date:r.getDateInView(),selectingDate:null,monthContainer:null,isRenderAriaLiveMessage:!1},r}return _e(t,e),Se(t,[{key:"componentDidMount",value:function(){var e=this;this.props.showTimeSelect&&(this.assignMonthContainer=void e.setState({monthContainer:e.monthContainer}))}},{key:"componentDidUpdate",value:function(e){var t=this;if(!this.props.preSelection||Ue(this.props.preSelection,e.preSelection)&&this.props.monthSelectedIn===e.monthSelectedIn)this.props.openToDate&&!Ue(this.props.openToDate,e.openToDate)&&this.setState({date:this.props.openToDate});else{var r=!je(this.state.date,this.props.preSelection);this.setState({date:this.props.preSelection},(function(){return r&&t.handleCustomMonthChange(t.state.date)}))}}},{key:"render",value:function(){var e=this.props.container||zt;return de.default.createElement("div",{style:{display:"contents"},ref:this.containerRef},de.default.createElement(e,{className:ue.default("react-datepicker",this.props.className,{"react-datepicker--time-only":this.props.showTimeSelectOnly})},this.renderAriaLiveRegion(),this.renderPreviousButton(),this.renderNextButton(),this.renderMonths(),this.renderYears(),this.renderTodayButton(),this.renderTimeSection(),this.renderInputTimeSection(),this.renderChildren()))}}],[{key:"defaultProps",get:function(){return{onDropdownFocus:function(){},monthsShown:1,forceShowMonthNavigation:!1,timeCaption:"Time",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",customTimeInput:null,yearItemNumber:xe}}}]),t}(de.default.Component),Xt=function(e){var t=e.icon,r=e.className,n=void 0===r?"":r,a=e.onClick,o="react-datepicker__calendar-icon";return de.default.isValidElement(t)?de.default.cloneElement(t,{className:"".concat(t.props.className||""," ").concat(o," ").concat(n),onClick:function(e){"function"==typeof t.props.onClick&&t.props.onClick(e),"function"==typeof a&&a(e)}}):"string"==typeof t?de.default.createElement("i",{className:"".concat(o," ").concat(t," ").concat(n),"aria-hidden":"true",onClick:a}):de.default.createElement("svg",{className:"".concat(o," ").concat(n),xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 448 512",onClick:a},de.default.createElement("path",{d:"M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"}))},Zt=function(e){function t(e){var r;return we(this,t),(r=me(this,t,[e])).el=document.createElement("div"),r}return _e(t,e),Se(t,[{key:"componentDidMount",value:function(){this.portalRoot=(this.props.portalHost||document).getElementById(this.props.portalId),this.portalRoot||(this.portalRoot=document.createElement("div"),this.portalRoot.setAttribute("id",this.props.portalId),(this.props.portalHost||document.body).appendChild(this.portalRoot)),this.portalRoot.appendChild(this.el)}},{key:"componentWillUnmount",value:function(){this.portalRoot.removeChild(this.el)}},{key:"render",value:function(){return fe.default.createPortal(this.props.children,this.el)}}]),t}(de.default.Component),er=function(e){return!e.disabled&&-1!==e.tabIndex},tr=function(e){function t(e){var r;return we(this,t),Me(Pe(r=me(this,t,[e])),"getTabChildren",(function(){return Array.prototype.slice.call(r.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"),1,-1).filter(er)})),Me(Pe(r),"handleFocusStart",(function(){var e=r.getTabChildren();e&&e.length>1&&e[e.length-1].focus()})),Me(Pe(r),"handleFocusEnd",(function(){var e=r.getTabChildren();e&&e.length>1&&e[0].focus()})),r.tabLoopRef=de.default.createRef(),r}return _e(t,e),Se(t,[{key:"render",value:function(){return this.props.enableTabLoop?de.default.createElement("div",{className:"react-datepicker__tab-loop",ref:this.tabLoopRef},de.default.createElement("div",{className:"react-datepicker__tab-loop__start",tabIndex:"0",onFocus:this.handleFocusStart}),this.props.children,de.default.createElement("div",{className:"react-datepicker__tab-loop__end",tabIndex:"0",onFocus:this.handleFocusEnd})):this.props.children}}],[{key:"defaultProps",get:function(){return{enableTabLoop:!0}}}]),t}(de.default.Component);var rr,nr=function(e){function t(){return we(this,t),me(this,t,arguments)}return _e(t,e),Se(t,[{key:"render",value:function(){var e,t=this.props,r=t.className,n=t.wrapperClassName,a=t.hidePopper,o=t.popperComponent,s=t.targetComponent,i=t.enableTabLoop,p=t.popperOnKeyDown,c=t.portalId,l=t.portalHost,d=t.popperProps,u=t.showArrow;if(!a){var h=ue.default("react-datepicker-popper",r);e=de.default.createElement(tr,{enableTabLoop:i},de.default.createElement("div",{ref:d.refs.setFloating,style:d.floatingStyles,className:h,"data-placement":d.placement,onKeyDown:p},o,u&&de.default.createElement(pe.FloatingArrow,{ref:d.arrowRef,context:d.context,fill:"currentColor",strokeWidth:1,height:8,width:16,style:{transform:"translateY(-1px)"},className:"react-datepicker__triangle"})))}this.props.popperContainer&&(e=de.default.createElement(this.props.popperContainer,{},e)),c&&!a&&(e=de.default.createElement(Zt,{portalId:c,portalHost:l},e));var f=ue.default("react-datepicker-wrapper",n);return de.default.createElement(de.default.Fragment,null,de.default.createElement("div",{ref:d.refs.setReference,className:f},s),e)}}],[{key:"defaultProps",get:function(){return{hidePopper:!0}}}]),t}(de.default.Component),ar=(rr=nr,function(e){var t=De(De({},e),{},{popperModifiers:e.popperModifiers||[],popperProps:e.popperProps||{},hidePopper:"boolean"!=typeof e.hidePopper||e.hidePopper}),r=de.default.useRef(),n=pe.useFloating(De({open:!t.hidePopper,whileElementsMounted:pe.autoUpdate,placement:t.popperPlacement,middleware:[pe.flip({padding:15}),pe.offset(10),pe.arrow({element:r})].concat(Ne(t.popperModifiers))},t.popperProps));return de.default.createElement(rr,Ce({},t,{popperProps:De(De({},n),{},{arrowRef:r})}))}),or="react-datepicker-ignore-onclickoutside",sr=he.default(Jt);var ir="Date input not valid.",pr=function(e){function t(e){var r;return we(this,t),Me(Pe(r=me(this,t,[e])),"getPreSelection",(function(){return r.props.openToDate?r.props.openToDate:r.props.selectsEnd&&r.props.startDate?r.props.startDate:r.props.selectsStart&&r.props.endDate?r.props.endDate:Te()})),Me(Pe(r),"modifyHolidays",(function(){var e;return null===(e=r.props.holidays)||void 0===e?void 0:e.reduce((function(e,t){var r=new Date(t.date);return o.isValid(r)?[].concat(Ne(e),[De(De({},t),{},{date:r})]):e}),[])})),Me(Pe(r),"calcInitialState",(function(){var e,t=r.getPreSelection(),n=yt(r.props),a=gt(r.props),o=n&&te.isBefore(t,Q.startOfDay(n))?n:a&&ee.isAfter(t,j.endOfDay(a))?a:t;return{open:r.props.startOpen||!1,preventFocus:!1,preSelection:null!==(e=r.props.selectsRange?r.props.startDate:r.props.selected)&&void 0!==e?e:o,highlightDates:Dt(r.props.highlightDates),focused:!1,shouldFocusDayInline:!1,isRenderAriaLiveMessage:!1}})),Me(Pe(r),"clearPreventFocusTimeout",(function(){r.preventFocusTimeout&&clearTimeout(r.preventFocusTimeout)})),Me(Pe(r),"setFocus",(function(){r.input&&r.input.focus&&r.input.focus({preventScroll:!0})})),Me(Pe(r),"setBlur",(function(){r.input&&r.input.blur&&r.input.blur(),r.cancelFocusInput()})),Me(Pe(r),"setOpen",(function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];r.setState({open:e,preSelection:e&&r.state.open?r.state.preSelection:r.calcInitialState().preSelection,lastPreSelectChange:lr},(function(){e||r.setState((function(e){return{focused:!!t&&e.focused}}),(function(){!t&&r.setBlur(),r.setState({inputValue:null})}))}))})),Me(Pe(r),"inputOk",(function(){return a.isDate(r.state.preSelection)})),Me(Pe(r),"isCalendarOpen",(function(){return void 0===r.props.open?r.state.open&&!r.props.disabled&&!r.props.readOnly:r.props.open})),Me(Pe(r),"handleFocus",(function(e){r.state.preventFocus||(r.props.onFocus(e),r.props.preventOpenOnFocus||r.props.readOnly||r.setOpen(!0)),r.setState({focused:!0})})),Me(Pe(r),"sendFocusBackToInput",(function(){r.preventFocusTimeout&&r.clearPreventFocusTimeout(),r.setState({preventFocus:!0},(function(){r.preventFocusTimeout=setTimeout((function(){r.setFocus(),r.setState({preventFocus:!1})}))}))})),Me(Pe(r),"cancelFocusInput",(function(){clearTimeout(r.inputFocusTimeout),r.inputFocusTimeout=null})),Me(Pe(r),"deferFocusInput",(function(){r.cancelFocusInput(),r.inputFocusTimeout=setTimeout((function(){return r.setFocus()}),1)})),Me(Pe(r),"handleDropdownFocus",(function(){r.cancelFocusInput()})),Me(Pe(r),"handleBlur",(function(e){(!r.state.open||r.props.withPortal||r.props.showTimeInput)&&r.props.onBlur(e),r.setState({focused:!1})})),Me(Pe(r),"handleCalendarClickOutside",(function(e){r.props.inline||r.setOpen(!1),r.props.onClickOutside(e),r.props.withPortal&&e.preventDefault()})),Me(Pe(r),"handleChange",(function(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];var a=t[0];if(!r.props.onChangeRaw||(r.props.onChangeRaw.apply(Pe(r),t),"function"==typeof a.isDefaultPrevented&&!a.isDefaultPrevented())){r.setState({inputValue:a.target.value,lastPreSelectChange:cr});var o,i,p,c,l,d,u,h,f=(o=a.target.value,i=r.props.dateFormat,p=r.props.locale,c=r.props.strictParsing,l=r.props.minDate,d=null,u=Je(p)||Je(Ge()),h=!0,Array.isArray(i)?(i.forEach((function(e){var t=ae.parse(o,e,new Date,{locale:u,useAdditionalWeekYearTokens:!0,useAdditionalDayOfYearTokens:!0});c&&(h=Re(t,l)&&o===Le(t,e,p)),Re(t,l)&&h&&(d=t)})),d):(d=ae.parse(o,i,new Date,{locale:u,useAdditionalWeekYearTokens:!0,useAdditionalDayOfYearTokens:!0}),c?h=Re(d)&&o===Le(d,i,p):Re(d)||(i=i.match(Ie).map((function(e){var t=e[0];if("p"===t||"P"===t){var r=s.longFormatters[t];return u?r(e,u.formatLong):t}return e})).join(""),o.length>0&&(d=ae.parse(o,i.slice(0,o.length),new Date,{useAdditionalWeekYearTokens:!0,useAdditionalDayOfYearTokens:!0})),Re(d)||(d=new Date(o))),Re(d)&&h?d:null));r.props.showTimeSelectOnly&&r.props.selected&&f&&!Ue(f,r.props.selected)&&(f=ce.set(r.props.selected,{hours:w.getHours(f),minutes:k.getMinutes(f),seconds:v.getSeconds(f)})),!f&&a.target.value||(r.props.showWeekPicker&&(f=We(f,r.props.locale,r.props.calendarStartDay)),r.setSelected(f,a,!0))}})),Me(Pe(r),"handleSelect",(function(e,t,n){if(r.props.shouldCloseOnSelect&&!r.props.showTimeSelect&&r.sendFocusBackToInput(),r.props.onChangeRaw&&r.props.onChangeRaw(t),r.props.showWeekPicker&&(e=We(e,r.props.locale,r.props.calendarStartDay)),r.setSelected(e,t,!1,n),r.props.showDateSelect&&r.setState({isRenderAriaLiveMessage:!0}),!r.props.shouldCloseOnSelect||r.props.showTimeSelect)r.setPreSelection(e);else if(!r.props.inline){r.props.selectsRange||r.setOpen(!1);var a=r.props,o=a.startDate,s=a.endDate;!o||s||Ct(e,o)||r.setOpen(!1)}})),Me(Pe(r),"setSelected",(function(e,t,n,a){var o=e;if(r.props.showYearPicker){if(null!==o&&st(Y.getYear(o),r.props))return}else if(r.props.showMonthYearPicker){if(null!==o&&rt(o,r.props))return}else if(null!==o&&et(o,r.props))return;var s=r.props,i=s.onChange,p=s.selectsRange,c=s.startDate,l=s.endDate;if(!$e(r.props.selected,o)||r.props.allowSameDay||p)if(null!==o&&(!r.props.selected||n&&(r.props.showTimeSelect||r.props.showTimeSelectOnly||r.props.showTimeInput)||(o=Ae(o,{hour:w.getHours(r.props.selected),minute:k.getMinutes(r.props.selected),second:v.getSeconds(r.props.selected)})),r.props.inline||r.setState({preSelection:o}),r.props.focusSelectedMonth||r.setState({monthSelectedIn:a})),p){var d=c&&!l,u=c&&l;!c&&!l?i([o,null],t):d&&(Ct(o,c)?i([o,null],t):i([c,o],t)),u&&i([o,null],t)}else i(o,t);n||(r.props.onSelect(o,t),r.setState({inputValue:null}))})),Me(Pe(r),"setPreSelection",(function(e){var t=void 0!==r.props.minDate,n=void 0!==r.props.maxDate,a=!0;if(e){r.props.showWeekPicker&&(e=We(e,r.props.locale,r.props.calendarStartDay));var o=Q.startOfDay(e);if(t&&n)a=ze(e,r.props.minDate,r.props.maxDate);else if(t){var s=Q.startOfDay(r.props.minDate);a=ee.isAfter(e,s)||$e(o,s)}else if(n){var i=j.endOfDay(r.props.maxDate);a=te.isBefore(e,i)||$e(o,i)}}a&&r.setState({preSelection:e})})),Me(Pe(r),"toggleCalendar",(function(){r.setOpen(!r.state.open)})),Me(Pe(r),"handleTimeChange",(function(e){var t=r.props.selected?r.props.selected:r.getPreSelection(),n=r.props.selected?e:Ae(t,{hour:w.getHours(e),minute:k.getMinutes(e)});r.setState({preSelection:n}),r.props.onChange(n),r.props.shouldCloseOnSelect&&(r.sendFocusBackToInput(),r.setOpen(!1)),r.props.showTimeInput&&r.setOpen(!0),(r.props.showTimeSelectOnly||r.props.showTimeSelect)&&r.setState({isRenderAriaLiveMessage:!0}),r.setState({inputValue:null})})),Me(Pe(r),"onInputClick",(function(){r.props.disabled||r.props.readOnly||r.setOpen(!0),r.props.onInputClick()})),Me(Pe(r),"onInputKeyDown",(function(e){r.props.onKeyDown(e);var t=e.key;if(r.state.open||r.props.inline||r.props.preventOpenOnFocus){if(r.state.open){if("ArrowDown"===t||"ArrowUp"===t){e.preventDefault();var n=r.props.showWeekPicker&&r.props.showWeekNumbers?'.react-datepicker__week-number[tabindex="0"]':'.react-datepicker__day[tabindex="0"]',a=r.calendar.componentNode&&r.calendar.componentNode.querySelector(n);return void(a&&a.focus({preventScroll:!0}))}var o=Te(r.state.preSelection);"Enter"===t?(e.preventDefault(),r.inputOk()&&r.state.lastPreSelectChange===lr?(r.handleSelect(o,e),!r.props.shouldCloseOnSelect&&r.setPreSelection(o)):r.setOpen(!1)):"Escape"===t?(e.preventDefault(),r.sendFocusBackToInput(),r.setOpen(!1)):"Tab"===t&&r.setOpen(!1),r.inputOk()||r.props.onInputError({code:1,msg:ir})}}else"ArrowDown"!==t&&"ArrowUp"!==t&&"Enter"!==t||r.onInputClick()})),Me(Pe(r),"onPortalKeyDown",(function(e){"Escape"===e.key&&(e.preventDefault(),r.setState({preventFocus:!0},(function(){r.setOpen(!1),setTimeout((function(){r.setFocus(),r.setState({preventFocus:!1})}))})))})),Me(Pe(r),"onDayKeyDown",(function(e){r.props.onKeyDown(e);var t,n=e.key,a=e.shiftKey,o=Te(r.state.preSelection);if("Enter"===n)e.preventDefault(),r.handleSelect(o,e),!r.props.shouldCloseOnSelect&&r.setPreSelection(o);else if("Escape"===n)e.preventDefault(),r.setOpen(!1),r.inputOk()||r.props.onInputError({code:1,msg:ir});else if(!r.props.disabledKeyboardNavigation){var s;switch(n){case"ArrowLeft":s=r.props.showWeekPicker?m.subWeeks(o,1):f.subDays(o,1);break;case"ArrowRight":s=r.props.showWeekPicker?l.addWeeks(o,1):c.addDays(o,1);break;case"ArrowUp":s=m.subWeeks(o,1);break;case"ArrowDown":s=l.addWeeks(o,1);break;case"PageUp":s=a?D.subYears(o,1):y.subMonths(o,1);break;case"PageDown":s=a?h.addYears(o,1):d.addMonths(o,1);break;case"Home":s=We(o,r.props.locale,r.props.calendarStartDay);break;case"End":t=o,s=V.endOfWeek(t);break;default:s=null}if(!s)return void(r.props.onInputError&&r.props.onInputError({code:1,msg:ir}));if(e.preventDefault(),r.setState({lastPreSelectChange:lr}),r.props.adjustDateOnChange&&r.setSelected(s),r.setPreSelection(s),r.props.inline){var i=C.getMonth(o),p=C.getMonth(s),u=Y.getYear(o),g=Y.getYear(s);i!==p||u!==g?r.setState({shouldFocusDayInline:!0}):r.setState({shouldFocusDayInline:!1})}}})),Me(Pe(r),"onPopperKeyDown",(function(e){"Escape"===e.key&&(e.preventDefault(),r.sendFocusBackToInput())})),Me(Pe(r),"onClearClick",(function(e){e&&e.preventDefault&&e.preventDefault(),r.sendFocusBackToInput(),r.props.selectsRange?r.props.onChange([null,null],e):r.props.onChange(null,e),r.setState({inputValue:null})})),Me(Pe(r),"clear",(function(){r.onClearClick()})),Me(Pe(r),"onScroll",(function(e){"boolean"==typeof r.props.closeOnScroll&&r.props.closeOnScroll?e.target!==document&&e.target!==document.documentElement&&e.target!==document.body||r.setOpen(!1):"function"==typeof r.props.closeOnScroll&&r.props.closeOnScroll(e)&&r.setOpen(!1)})),Me(Pe(r),"renderCalendar",(function(){return r.props.inline||r.isCalendarOpen()?de.default.createElement(sr,{ref:function(e){r.calendar=e},locale:r.props.locale,calendarStartDay:r.props.calendarStartDay,chooseDayAriaLabelPrefix:r.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:r.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:r.props.weekAriaLabelPrefix,monthAriaLabelPrefix:r.props.monthAriaLabelPrefix,adjustDateOnChange:r.props.adjustDateOnChange,setOpen:r.setOpen,shouldCloseOnSelect:r.props.shouldCloseOnSelect,dateFormat:r.props.dateFormatCalendar,useWeekdaysShort:r.props.useWeekdaysShort,formatWeekDay:r.props.formatWeekDay,dropdownMode:r.props.dropdownMode,selected:r.props.selected,preSelection:r.state.preSelection,onSelect:r.handleSelect,onWeekSelect:r.props.onWeekSelect,openToDate:r.props.openToDate,minDate:r.props.minDate,maxDate:r.props.maxDate,selectsStart:r.props.selectsStart,selectsEnd:r.props.selectsEnd,selectsRange:r.props.selectsRange,startDate:r.props.startDate,endDate:r.props.endDate,excludeDates:r.props.excludeDates,excludeDateIntervals:r.props.excludeDateIntervals,filterDate:r.props.filterDate,onClickOutside:r.handleCalendarClickOutside,formatWeekNumber:r.props.formatWeekNumber,highlightDates:r.state.highlightDates,holidays:vt(r.modifyHolidays()),includeDates:r.props.includeDates,includeDateIntervals:r.props.includeDateIntervals,includeTimes:r.props.includeTimes,injectTimes:r.props.injectTimes,inline:r.props.inline,shouldFocusDayInline:r.state.shouldFocusDayInline,peekNextMonth:r.props.peekNextMonth,showMonthDropdown:r.props.showMonthDropdown,showPreviousMonths:r.props.showPreviousMonths,useShortMonthInDropdown:r.props.useShortMonthInDropdown,showMonthYearDropdown:r.props.showMonthYearDropdown,showWeekNumbers:r.props.showWeekNumbers,showYearDropdown:r.props.showYearDropdown,withPortal:r.props.withPortal,forceShowMonthNavigation:r.props.forceShowMonthNavigation,showDisabledMonthNavigation:r.props.showDisabledMonthNavigation,scrollableYearDropdown:r.props.scrollableYearDropdown,scrollableMonthYearDropdown:r.props.scrollableMonthYearDropdown,todayButton:r.props.todayButton,weekLabel:r.props.weekLabel,outsideClickIgnoreClass:or,fixedHeight:r.props.fixedHeight,monthsShown:r.props.monthsShown,monthSelectedIn:r.state.monthSelectedIn,onDropdownFocus:r.handleDropdownFocus,onMonthChange:r.props.onMonthChange,onYearChange:r.props.onYearChange,dayClassName:r.props.dayClassName,weekDayClassName:r.props.weekDayClassName,monthClassName:r.props.monthClassName,timeClassName:r.props.timeClassName,showDateSelect:r.props.showDateSelect,showTimeSelect:r.props.showTimeSelect,showTimeSelectOnly:r.props.showTimeSelectOnly,onTimeChange:r.handleTimeChange,timeFormat:r.props.timeFormat,timeIntervals:r.props.timeIntervals,minTime:r.props.minTime,maxTime:r.props.maxTime,excludeTimes:r.props.excludeTimes,filterTime:r.props.filterTime,timeCaption:r.props.timeCaption,className:r.props.calendarClassName,container:r.props.calendarContainer,yearItemNumber:r.props.yearItemNumber,yearDropdownItemNumber:r.props.yearDropdownItemNumber,previousMonthAriaLabel:r.props.previousMonthAriaLabel,previousMonthButtonLabel:r.props.previousMonthButtonLabel,nextMonthAriaLabel:r.props.nextMonthAriaLabel,nextMonthButtonLabel:r.props.nextMonthButtonLabel,previousYearAriaLabel:r.props.previousYearAriaLabel,previousYearButtonLabel:r.props.previousYearButtonLabel,nextYearAriaLabel:r.props.nextYearAriaLabel,nextYearButtonLabel:r.props.nextYearButtonLabel,timeInputLabel:r.props.timeInputLabel,disabledKeyboardNavigation:r.props.disabledKeyboardNavigation,renderCustomHeader:r.props.renderCustomHeader,popperProps:r.props.popperProps,renderDayContents:r.props.renderDayContents,renderMonthContent:r.props.renderMonthContent,renderQuarterContent:r.props.renderQuarterContent,renderYearContent:r.props.renderYearContent,onDayMouseEnter:r.props.onDayMouseEnter,onMonthMouseLeave:r.props.onMonthMouseLeave,onYearMouseEnter:r.props.onYearMouseEnter,onYearMouseLeave:r.props.onYearMouseLeave,selectsDisabledDaysInRange:r.props.selectsDisabledDaysInRange,showTimeInput:r.props.showTimeInput,showMonthYearPicker:r.props.showMonthYearPicker,showFullMonthYearPicker:r.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:r.props.showTwoColumnMonthYearPicker,showFourColumnMonthYearPicker:r.props.showFourColumnMonthYearPicker,showYearPicker:r.props.showYearPicker,showQuarterYearPicker:r.props.showQuarterYearPicker,showWeekPicker:r.props.showWeekPicker,excludeScrollbar:r.props.excludeScrollbar,handleOnKeyDown:r.props.onKeyDown,handleOnDayKeyDown:r.onDayKeyDown,isInputFocused:r.state.focused,customTimeInput:r.props.customTimeInput,setPreSelection:r.setPreSelection},r.props.children):null})),Me(Pe(r),"renderAriaLiveRegion",(function(){var e,t=r.props,n=t.dateFormat,a=t.locale,o=r.props.showTimeInput||r.props.showTimeSelect?"PPPPp":"PPPP";return e=r.props.selectsRange?"Selected start date: ".concat(Fe(r.props.startDate,{dateFormat:o,locale:a}),". ").concat(r.props.endDate?"End date: "+Fe(r.props.endDate,{dateFormat:o,locale:a}):""):r.props.showTimeSelectOnly?"Selected time: ".concat(Fe(r.props.selected,{dateFormat:n,locale:a})):r.props.showYearPicker?"Selected year: ".concat(Fe(r.props.selected,{dateFormat:"yyyy",locale:a})):r.props.showMonthYearPicker?"Selected month: ".concat(Fe(r.props.selected,{dateFormat:"MMMM yyyy",locale:a})):r.props.showQuarterYearPicker?"Selected quarter: ".concat(Fe(r.props.selected,{dateFormat:"yyyy, QQQ",locale:a})):"Selected date: ".concat(Fe(r.props.selected,{dateFormat:o,locale:a})),de.default.createElement("span",{role:"alert","aria-live":"polite",className:"react-datepicker__aria-live"},e)})),Me(Pe(r),"renderDateInput",(function(){var e,t=ue.default(r.props.className,Me({},or,r.state.open)),n=r.props.customInput||de.default.createElement("input",{type:"text"}),a=r.props.customInputRef||"ref",o="string"==typeof r.props.value?r.props.value:"string"==typeof r.state.inputValue?r.state.inputValue:r.props.selectsRange?function(e,t,r){if(!e)return"";var n=Fe(e,r),a=t?Fe(t,r):"";return"".concat(n," - ").concat(a)}(r.props.startDate,r.props.endDate,r.props):Fe(r.props.selected,r.props);return de.default.cloneElement(n,(Me(Me(Me(Me(Me(Me(Me(Me(Me(Me(e={},a,(function(e){r.input=e})),"value",o),"onBlur",r.handleBlur),"onChange",r.handleChange),"onClick",r.onInputClick),"onFocus",r.handleFocus),"onKeyDown",r.onInputKeyDown),"id",r.props.id),"name",r.props.name),"form",r.props.form),Me(Me(Me(Me(Me(Me(Me(Me(Me(Me(e,"autoFocus",r.props.autoFocus),"placeholder",r.props.placeholderText),"disabled",r.props.disabled),"autoComplete",r.props.autoComplete),"className",ue.default(n.props.className,t)),"title",r.props.title),"readOnly",r.props.readOnly),"required",r.props.required),"tabIndex",r.props.tabIndex),"aria-describedby",r.props.ariaDescribedBy),Me(Me(Me(e,"aria-invalid",r.props.ariaInvalid),"aria-labelledby",r.props.ariaLabelledBy),"aria-required",r.props.ariaRequired)))})),Me(Pe(r),"renderClearButton",(function(){var e=r.props,t=e.isClearable,n=e.disabled,a=e.selected,o=e.startDate,s=e.endDate,i=e.clearButtonTitle,p=e.clearButtonClassName,c=void 0===p?"":p,l=e.ariaLabelClose,d=void 0===l?"Close":l;return!t||null==a&&null==o&&null==s?null:de.default.createElement("button",{type:"button",className:ue.default("react-datepicker__close-icon",c,{"react-datepicker__close-icon--disabled":n}),disabled:n,"aria-label":d,onClick:r.onClearClick,title:i,tabIndex:-1})})),r.state=r.calcInitialState(),r.preventFocusTimeout=null,r}return _e(t,e),Se(t,[{key:"componentDidMount",value:function(){window.addEventListener("scroll",this.onScroll,!0)}},{key:"componentDidUpdate",value:function(e,t){var r,n;e.inline&&(r=e.selected,n=this.props.selected,r&&n?C.getMonth(r)!==C.getMonth(n)||Y.getYear(r)!==Y.getYear(n):r!==n)&&this.setPreSelection(this.props.selected),void 0!==this.state.monthSelectedIn&&e.monthsShown!==this.props.monthsShown&&this.setState({monthSelectedIn:0}),e.highlightDates!==this.props.highlightDates&&this.setState({highlightDates:Dt(this.props.highlightDates)}),t.focused||$e(e.selected,this.props.selected)||this.setState({inputValue:null}),t.open!==this.state.open&&(!1===t.open&&!0===this.state.open&&this.props.onCalendarOpen(),!0===t.open&&!1===this.state.open&&this.props.onCalendarClose())}},{key:"componentWillUnmount",value:function(){this.clearPreventFocusTimeout(),window.removeEventListener("scroll",this.onScroll,!0)}},{key:"renderInputContainer",value:function(){var e=this.props,t=e.showIcon,r=e.icon,n=e.calendarIconClassname,a=e.toggleCalendarOnIconClick,o=this.state.open;return de.default.createElement("div",{className:"react-datepicker__input-container".concat(t?" react-datepicker__view-calendar-icon":"")},t&&de.default.createElement(Xt,Ce({icon:r,className:"".concat(n," ").concat(o&&"react-datepicker-ignore-onclickoutside")},a?{onClick:this.toggleCalendar}:null)),this.state.isRenderAriaLiveMessage&&this.renderAriaLiveRegion(),this.renderDateInput(),this.renderClearButton())}},{key:"render",value:function(){var e=this.renderCalendar();if(this.props.inline)return e;if(this.props.withPortal){var t=this.state.open?de.default.createElement(tr,{enableTabLoop:this.props.enableTabLoop},de.default.createElement("div",{className:"react-datepicker__portal",tabIndex:-1,onKeyDown:this.onPortalKeyDown},e)):null;return this.state.open&&this.props.portalId&&(t=de.default.createElement(Zt,{portalId:this.props.portalId,portalHost:this.props.portalHost},t)),de.default.createElement("div",null,this.renderInputContainer(),t)}return de.default.createElement(ar,{className:this.props.popperClassName,wrapperClassName:this.props.wrapperClassName,hidePopper:!this.isCalendarOpen(),portalId:this.props.portalId,portalHost:this.props.portalHost,popperModifiers:this.props.popperModifiers,targetComponent:this.renderInputContainer(),popperContainer:this.props.popperContainer,popperComponent:e,popperPlacement:this.props.popperPlacement,popperProps:this.props.popperProps,popperOnKeyDown:this.onPopperKeyDown,enableTabLoop:this.props.enableTabLoop,showArrow:this.props.showPopperArrow})}}],[{key:"defaultProps",get:function(){return{allowSameDay:!1,dateFormat:"MM/dd/yyyy",dateFormatCalendar:"LLLL yyyy",onChange:function(){},disabled:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onKeyDown:function(){},onInputClick:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},onCalendarOpen:function(){},onCalendarClose:function(){},preventOpenOnFocus:!1,onYearChange:function(){},onInputError:function(){},monthsShown:1,readOnly:!1,withPortal:!1,selectsDisabledDaysInRange:!1,shouldCloseOnSelect:!0,showTimeSelect:!1,showTimeInput:!1,showPreviousMonths:!1,showMonthYearPicker:!1,showFullMonthYearPicker:!1,showTwoColumnMonthYearPicker:!1,showFourColumnMonthYearPicker:!1,showYearPicker:!1,showQuarterYearPicker:!1,showWeekPicker:!1,strictParsing:!1,timeIntervals:30,timeCaption:"Time",previousMonthAriaLabel:"Previous Month",previousMonthButtonLabel:"Previous Month",nextMonthAriaLabel:"Next Month",nextMonthButtonLabel:"Next Month",previousYearAriaLabel:"Previous Year",previousYearButtonLabel:"Previous Year",nextYearAriaLabel:"Next Year",nextYearButtonLabel:"Next Year",timeInputLabel:"Time",enableTabLoop:!0,yearItemNumber:xe,focusSelectedMonth:!1,showPopperArrow:!0,excludeScrollbar:!0,customTimeInput:null,calendarStartDay:void 0,toggleCalendarOnIconClick:!1}}}]),t}(de.default.Component),cr="input",lr="navigate";e.CalendarContainer=zt,e.default=pr,e.getDefaultLocale=Ge,e.registerLocale=function(e,t){var r="undefined"!=typeof window?window:globalThis;r.__localeData__||(r.__localeData__={}),r.__localeData__[e]=t},e.setDefaultLocale=function(e){("undefined"!=typeof window?window:globalThis).__localeId__=e},Object.defineProperty(e,"__esModule",{value:!0})}));


/***/ }),

/***/ 81491:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.addLeadingZeros = addLeadingZeros;
function addLeadingZeros(number, targetLength) {
  const sign = number < 0 ? "-" : "";
  const output = Math.abs(number).toString().padStart(targetLength, "0");
  return sign + output;
}


/***/ }),

/***/ 89445:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "defaultLocale", ({
  enumerable: true,
  get: function () {
    return _index.enUS;
  },
}));
var _index = __webpack_require__(86177);


/***/ }),

/***/ 67845:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.getDefaultOptions = getDefaultOptions;
exports.setDefaultOptions = setDefaultOptions;

let defaultOptions = {};

function getDefaultOptions() {
  return defaultOptions;
}

function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}


/***/ }),

/***/ 74088:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.formatters = void 0;
var _index = __webpack_require__(52394);
var _index2 = __webpack_require__(2169);
var _index3 = __webpack_require__(74551);
var _index4 = __webpack_require__(68483);
var _index5 = __webpack_require__(3570);

var _index6 = __webpack_require__(81491);
var _index7 = __webpack_require__(63393);

const dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night",
};

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

const formatters = (exports.formatters = {
  // Era
  G: function (date, token, localize) {
    const era = date.getFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return localize.era(era, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return localize.era(era, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return localize.era(era, { width: "wide" });
    }
  },

  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === "yo") {
      const signedYear = date.getFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      const year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, { unit: "year" });
    }

    return _index7.lightFormatters.y(date, token);
  },

  // Local week-numbering year
  Y: function (date, token, localize, options) {
    const signedWeekYear = (0, _index5.getWeekYear)(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === "YY") {
      const twoDigitYear = weekYear % 100;
      return (0, _index6.addLeadingZeros)(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === "Yo") {
      return localize.ordinalNumber(weekYear, { unit: "year" });
    }

    // Padding
    return (0, _index6.addLeadingZeros)(weekYear, token.length);
  },

  // ISO week-numbering year
  R: function (date, token) {
    const isoWeekYear = (0, _index3.getISOWeekYear)(date);

    // Padding
    return (0, _index6.addLeadingZeros)(isoWeekYear, token.length);
  },

  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    const year = date.getFullYear();
    return (0, _index6.addLeadingZeros)(year, token.length);
  },

  // Quarter
  Q: function (date, token, localize) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "Q":
        return String(quarter);
      // 01, 02, 03, 04
      case "QQ":
        return (0, _index6.addLeadingZeros)(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return localize.ordinalNumber(quarter, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return localize.quarter(quarter, {
          width: "abbreviated",
          context: "formatting",
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return localize.quarter(quarter, {
          width: "narrow",
          context: "formatting",
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return localize.quarter(quarter, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Stand-alone quarter
  q: function (date, token, localize) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "q":
        return String(quarter);
      // 01, 02, 03, 04
      case "qq":
        return (0, _index6.addLeadingZeros)(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return localize.ordinalNumber(quarter, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return localize.quarter(quarter, {
          width: "abbreviated",
          context: "standalone",
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return localize.quarter(quarter, {
          width: "narrow",
          context: "standalone",
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return localize.quarter(quarter, {
          width: "wide",
          context: "standalone",
        });
    }
  },

  // Month
  M: function (date, token, localize) {
    const month = date.getMonth();
    switch (token) {
      case "M":
      case "MM":
        return _index7.lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return localize.ordinalNumber(month + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return localize.month(month, {
          width: "abbreviated",
          context: "formatting",
        });
      // J, F, ..., D
      case "MMMMM":
        return localize.month(month, {
          width: "narrow",
          context: "formatting",
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return localize.month(month, { width: "wide", context: "formatting" });
    }
  },

  // Stand-alone month
  L: function (date, token, localize) {
    const month = date.getMonth();
    switch (token) {
      // 1, 2, ..., 12
      case "L":
        return String(month + 1);
      // 01, 02, ..., 12
      case "LL":
        return (0, _index6.addLeadingZeros)(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return localize.ordinalNumber(month + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return localize.month(month, {
          width: "abbreviated",
          context: "standalone",
        });
      // J, F, ..., D
      case "LLLLL":
        return localize.month(month, {
          width: "narrow",
          context: "standalone",
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return localize.month(month, { width: "wide", context: "standalone" });
    }
  },

  // Local week of year
  w: function (date, token, localize, options) {
    const week = (0, _index4.getWeek)(date, options);

    if (token === "wo") {
      return localize.ordinalNumber(week, { unit: "week" });
    }

    return (0, _index6.addLeadingZeros)(week, token.length);
  },

  // ISO week of year
  I: function (date, token, localize) {
    const isoWeek = (0, _index2.getISOWeek)(date);

    if (token === "Io") {
      return localize.ordinalNumber(isoWeek, { unit: "week" });
    }

    return (0, _index6.addLeadingZeros)(isoWeek, token.length);
  },

  // Day of the month
  d: function (date, token, localize) {
    if (token === "do") {
      return localize.ordinalNumber(date.getDate(), { unit: "date" });
    }

    return _index7.lightFormatters.d(date, token);
  },

  // Day of year
  D: function (date, token, localize) {
    const dayOfYear = (0, _index.getDayOfYear)(date);

    if (token === "Do") {
      return localize.ordinalNumber(dayOfYear, { unit: "dayOfYear" });
    }

    return (0, _index6.addLeadingZeros)(dayOfYear, token.length);
  },

  // Day of week
  E: function (date, token, localize) {
    const dayOfWeek = date.getDay();
    switch (token) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "EEEEE":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "EEEEEE":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "EEEE":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Local day of week
  e: function (date, token, localize, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(localDayOfWeek);
      // Padded numerical value
      case "ee":
        return (0, _index6.addLeadingZeros)(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return localize.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "eee":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "eeeee":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "eeeeee":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "eeee":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case "c":
        return String(localDayOfWeek);
      // Padded numerical value
      case "cc":
        return (0, _index6.addLeadingZeros)(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return localize.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "ccc":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone",
        });
      // T
      case "ccccc":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "standalone",
        });
      // Tu
      case "cccccc":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "standalone",
        });
      // Tuesday
      case "cccc":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "standalone",
        });
    }
  },

  // ISO day of week
  i: function (date, token, localize) {
    const dayOfWeek = date.getDay();
    const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case "i":
        return String(isoDayOfWeek);
      // 02
      case "ii":
        return (0, _index6.addLeadingZeros)(isoDayOfWeek, token.length);
      // 2nd
      case "io":
        return localize.ordinalNumber(isoDayOfWeek, { unit: "day" });
      // Tue
      case "iii":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "iiiii":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "iiiiii":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "iiii":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // AM or PM
  a: function (date, token, localize) {
    const hours = date.getHours();
    const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";

    switch (token) {
      case "a":
      case "aa":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "aaa":
        return localize
          .dayPeriod(dayPeriodEnumValue, {
            width: "abbreviated",
            context: "formatting",
          })
          .toLowerCase();
      case "aaaaa":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "aaaa":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }

    switch (token) {
      case "b":
      case "bb":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "bbb":
        return localize
          .dayPeriod(dayPeriodEnumValue, {
            width: "abbreviated",
            context: "formatting",
          })
          .toLowerCase();
      case "bbbbb":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "bbbb":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "BBBBB":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "BBBB":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === "ho") {
      let hours = date.getHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return _index7.lightFormatters.h(date, token);
  },

  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === "Ho") {
      return localize.ordinalNumber(date.getHours(), { unit: "hour" });
    }

    return _index7.lightFormatters.H(date, token);
  },

  // Hour [0-11]
  K: function (date, token, localize) {
    const hours = date.getHours() % 12;

    if (token === "Ko") {
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return (0, _index6.addLeadingZeros)(hours, token.length);
  },

  // Hour [1-24]
  k: function (date, token, localize) {
    let hours = date.getHours();
    if (hours === 0) hours = 24;

    if (token === "ko") {
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return (0, _index6.addLeadingZeros)(hours, token.length);
  },

  // Minute
  m: function (date, token, localize) {
    if (token === "mo") {
      return localize.ordinalNumber(date.getMinutes(), { unit: "minute" });
    }

    return _index7.lightFormatters.m(date, token);
  },

  // Second
  s: function (date, token, localize) {
    if (token === "so") {
      return localize.ordinalNumber(date.getSeconds(), { unit: "second" });
    }

    return _index7.lightFormatters.s(date, token);
  },

  // Fraction of second
  S: function (date, token) {
    return _index7.lightFormatters.S(date, token);
  },

  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return "Z";
    }

    switch (token) {
      // Hours and optional minutes
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX": // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX": // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx": // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx": // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (GMT)
  O: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (specific non-location)
  z: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },

  // Seconds timestamp
  t: function (date, token, _localize) {
    const timestamp = Math.trunc(date.getTime() / 1000);
    return (0, _index6.addLeadingZeros)(timestamp, token.length);
  },

  // Milliseconds timestamp
  T: function (date, token, _localize) {
    const timestamp = date.getTime();
    return (0, _index6.addLeadingZeros)(timestamp, token.length);
  },
});

function formatTimezoneShort(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = Math.trunc(absOffset / 60);
  const minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  return (
    sign + String(hours) + delimiter + (0, _index6.addLeadingZeros)(minutes, 2)
  );
}

function formatTimezoneWithOptionalMinutes(offset, delimiter) {
  if (offset % 60 === 0) {
    const sign = offset > 0 ? "-" : "+";
    return sign + (0, _index6.addLeadingZeros)(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, delimiter);
}

function formatTimezone(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = (0, _index6.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
  const minutes = (0, _index6.addLeadingZeros)(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}


/***/ }),

/***/ 63393:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.lightFormatters = void 0;
var _index = __webpack_require__(81491);

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

const lightFormatters = (exports.lightFormatters = {
  // Year
  y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    const signedYear = date.getFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    const year = signedYear > 0 ? signedYear : 1 - signedYear;
    return (0, _index.addLeadingZeros)(
      token === "yy" ? year % 100 : year,
      token.length,
    );
  },

  // Month
  M(date, token) {
    const month = date.getMonth();
    return token === "M"
      ? String(month + 1)
      : (0, _index.addLeadingZeros)(month + 1, 2);
  },

  // Day of the month
  d(date, token) {
    return (0, _index.addLeadingZeros)(date.getDate(), token.length);
  },

  // AM or PM
  a(date, token) {
    const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";

    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },

  // Hour [1-12]
  h(date, token) {
    return (0, _index.addLeadingZeros)(
      date.getHours() % 12 || 12,
      token.length,
    );
  },

  // Hour [0-23]
  H(date, token) {
    return (0, _index.addLeadingZeros)(date.getHours(), token.length);
  },

  // Minute
  m(date, token) {
    return (0, _index.addLeadingZeros)(date.getMinutes(), token.length);
  },

  // Second
  s(date, token) {
    return (0, _index.addLeadingZeros)(date.getSeconds(), token.length);
  },

  // Fraction of second
  S(date, token) {
    const numberOfDigits = token.length;
    const milliseconds = date.getMilliseconds();
    const fractionalSeconds = Math.trunc(
      milliseconds * Math.pow(10, numberOfDigits - 3),
    );
    return (0, _index.addLeadingZeros)(fractionalSeconds, token.length);
  },
});


/***/ }),

/***/ 77837:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.longFormatters = void 0;

const dateLongFormatter = (pattern, formatLong) => {
  switch (pattern) {
    case "P":
      return formatLong.date({ width: "short" });
    case "PP":
      return formatLong.date({ width: "medium" });
    case "PPP":
      return formatLong.date({ width: "long" });
    case "PPPP":
    default:
      return formatLong.date({ width: "full" });
  }
};

const timeLongFormatter = (pattern, formatLong) => {
  switch (pattern) {
    case "p":
      return formatLong.time({ width: "short" });
    case "pp":
      return formatLong.time({ width: "medium" });
    case "ppp":
      return formatLong.time({ width: "long" });
    case "pppp":
    default:
      return formatLong.time({ width: "full" });
  }
};

const dateTimeLongFormatter = (pattern, formatLong) => {
  const matchResult = pattern.match(/(P+)(p+)?/) || [];
  const datePattern = matchResult[1];
  const timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  let dateTimeFormat;

  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong.dateTime({ width: "short" });
      break;
    case "PP":
      dateTimeFormat = formatLong.dateTime({ width: "medium" });
      break;
    case "PPP":
      dateTimeFormat = formatLong.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong.dateTime({ width: "full" });
      break;
  }

  return dateTimeFormat
    .replace("{{date}}", dateLongFormatter(datePattern, formatLong))
    .replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};

const longFormatters = (exports.longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter,
});


/***/ }),

/***/ 8568:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getTimezoneOffsetInMilliseconds = getTimezoneOffsetInMilliseconds;
var _index = __webpack_require__(44013);

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  const _date = (0, _index.toDate)(date);
  const utcDate = new Date(
    Date.UTC(
      _date.getFullYear(),
      _date.getMonth(),
      _date.getDate(),
      _date.getHours(),
      _date.getMinutes(),
      _date.getSeconds(),
      _date.getMilliseconds(),
    ),
  );
  utcDate.setUTCFullYear(_date.getFullYear());
  return +date - +utcDate;
}


/***/ }),

/***/ 58958:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
exports.isProtectedWeekYearToken = isProtectedWeekYearToken;
exports.warnOrThrowProtectedError = warnOrThrowProtectedError;
const dayOfYearTokenRE = /^D+$/;
const weekYearTokenRE = /^Y+$/;

const throwTokens = ["D", "DD", "YY", "YYYY"];

function isProtectedDayOfYearToken(token) {
  return dayOfYearTokenRE.test(token);
}

function isProtectedWeekYearToken(token) {
  return weekYearTokenRE.test(token);
}

function warnOrThrowProtectedError(token, format, input) {
  const _message = message(token, format, input);
  console.warn(_message);
  if (throwTokens.includes(token)) throw new RangeError(_message);
}

function message(token, format, input) {
  const subject = token[0] === "Y" ? "years" : "days of the month";
  return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}


/***/ }),

/***/ 6716:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.addDays = addDays;
var _index = __webpack_require__(44013);
var _index2 = __webpack_require__(78197);

/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(date, amount) {
  const _date = (0, _index.toDate)(date);
  if (isNaN(amount)) return (0, _index2.constructFrom)(date, NaN);
  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
  }
  _date.setDate(_date.getDate() + amount);
  return _date;
}


/***/ }),

/***/ 78015:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.addHours = addHours;
var _index = __webpack_require__(34878);
var _index2 = __webpack_require__(50615);

/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be added.
 *
 * @returns The new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */
function addHours(date, amount) {
  return (0, _index.addMilliseconds)(date, amount * _index2.millisecondsInHour);
}


/***/ }),

/***/ 34878:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.addMilliseconds = addMilliseconds;
var _index = __webpack_require__(44013);
var _index2 = __webpack_require__(78197);

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be added.
 *
 * @returns The new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(date, amount) {
  const timestamp = +(0, _index.toDate)(date);
  return (0, _index2.constructFrom)(date, timestamp + amount);
}


/***/ }),

/***/ 53802:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.addMinutes = addMinutes;
var _index = __webpack_require__(34878);
var _index2 = __webpack_require__(50615);

/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be added.
 *
 * @returns The new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */
function addMinutes(date, amount) {
  return (0, _index.addMilliseconds)(
    date,
    amount * _index2.millisecondsInMinute,
  );
}


/***/ }),

/***/ 3580:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.addMonths = addMonths;
var _index = __webpack_require__(44013);
var _index2 = __webpack_require__(78197);

/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */
function addMonths(date, amount) {
  const _date = (0, _index.toDate)(date);
  if (isNaN(amount)) return (0, _index2.constructFrom)(date, NaN);
  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
  }
  const dayOfMonth = _date.getDate();

  // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.
  const endOfDesiredMonth = (0, _index2.constructFrom)(date, _date.getTime());
  endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
  const daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    _date.setFullYear(
      endOfDesiredMonth.getFullYear(),
      endOfDesiredMonth.getMonth(),
      dayOfMonth,
    );
    return _date;
  }
}


/***/ }),

/***/ 3128:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.addQuarters = addQuarters;
var _index = __webpack_require__(3580);

/**
 * @name addQuarters
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be added.
 *
 * @returns The new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * const result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */
function addQuarters(date, amount) {
  const months = amount * 3;
  return (0, _index.addMonths)(date, months);
}


/***/ }),

/***/ 23567:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.addWeeks = addWeeks;
var _index = __webpack_require__(6716);

/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be added.
 *
 * @returns The new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks(date, amount) {
  const days = amount * 7;
  return (0, _index.addDays)(date, days);
}


/***/ }),

/***/ 38882:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.addYears = addYears;
var _index = __webpack_require__(3580);

/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be added.
 *
 * @returns The new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears(date, amount) {
  return (0, _index.addMonths)(date, amount * 12);
}


/***/ }),

/***/ 50615:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.secondsInYear =
  exports.secondsInWeek =
  exports.secondsInQuarter =
  exports.secondsInMonth =
  exports.secondsInMinute =
  exports.secondsInHour =
  exports.secondsInDay =
  exports.quartersInYear =
  exports.monthsInYear =
  exports.monthsInQuarter =
  exports.minutesInYear =
  exports.minutesInMonth =
  exports.minutesInHour =
  exports.minutesInDay =
  exports.minTime =
  exports.millisecondsInWeek =
  exports.millisecondsInSecond =
  exports.millisecondsInMinute =
  exports.millisecondsInHour =
  exports.millisecondsInDay =
  exports.maxTime =
  exports.daysInYear =
  exports.daysInWeek =
    void 0; /**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */

/**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */
const daysInWeek = (exports.daysInWeek = 7);

/**
 * @constant
 * @name daysInYear
 * @summary Days in 1 year.
 *
 * @description
 * How many days in a year.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 */
const daysInYear = (exports.daysInYear = 365.2425);

/**
 * @constant
 * @name maxTime
 * @summary Maximum allowed time.
 *
 * @example
 * import { maxTime } from "date-fns/constants";
 *
 * const isValid = 8640000000000001 <= maxTime;
 * //=> false
 *
 * new Date(8640000000000001);
 * //=> Invalid Date
 */
const maxTime = (exports.maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000);

/**
 * @constant
 * @name minTime
 * @summary Minimum allowed time.
 *
 * @example
 * import { minTime } from "date-fns/constants";
 *
 * const isValid = -8640000000000001 >= minTime;
 * //=> false
 *
 * new Date(-8640000000000001)
 * //=> Invalid Date
 */
const minTime = (exports.minTime = -maxTime);

/**
 * @constant
 * @name millisecondsInWeek
 * @summary Milliseconds in 1 week.
 */
const millisecondsInWeek = (exports.millisecondsInWeek = 604800000);

/**
 * @constant
 * @name millisecondsInDay
 * @summary Milliseconds in 1 day.
 */
const millisecondsInDay = (exports.millisecondsInDay = 86400000);

/**
 * @constant
 * @name millisecondsInMinute
 * @summary Milliseconds in 1 minute
 */
const millisecondsInMinute = (exports.millisecondsInMinute = 60000);

/**
 * @constant
 * @name millisecondsInHour
 * @summary Milliseconds in 1 hour
 */
const millisecondsInHour = (exports.millisecondsInHour = 3600000);

/**
 * @constant
 * @name millisecondsInSecond
 * @summary Milliseconds in 1 second
 */
const millisecondsInSecond = (exports.millisecondsInSecond = 1000);

/**
 * @constant
 * @name minutesInYear
 * @summary Minutes in 1 year.
 */
const minutesInYear = (exports.minutesInYear = 525600);

/**
 * @constant
 * @name minutesInMonth
 * @summary Minutes in 1 month.
 */
const minutesInMonth = (exports.minutesInMonth = 43200);

/**
 * @constant
 * @name minutesInDay
 * @summary Minutes in 1 day.
 */
const minutesInDay = (exports.minutesInDay = 1440);

/**
 * @constant
 * @name minutesInHour
 * @summary Minutes in 1 hour.
 */
const minutesInHour = (exports.minutesInHour = 60);

/**
 * @constant
 * @name monthsInQuarter
 * @summary Months in 1 quarter.
 */
const monthsInQuarter = (exports.monthsInQuarter = 3);

/**
 * @constant
 * @name monthsInYear
 * @summary Months in 1 year.
 */
const monthsInYear = (exports.monthsInYear = 12);

/**
 * @constant
 * @name quartersInYear
 * @summary Quarters in 1 year
 */
const quartersInYear = (exports.quartersInYear = 4);

/**
 * @constant
 * @name secondsInHour
 * @summary Seconds in 1 hour.
 */
const secondsInHour = (exports.secondsInHour = 3600);

/**
 * @constant
 * @name secondsInMinute
 * @summary Seconds in 1 minute.
 */
const secondsInMinute = (exports.secondsInMinute = 60);

/**
 * @constant
 * @name secondsInDay
 * @summary Seconds in 1 day.
 */
const secondsInDay = (exports.secondsInDay = secondsInHour * 24);

/**
 * @constant
 * @name secondsInWeek
 * @summary Seconds in 1 week.
 */
const secondsInWeek = (exports.secondsInWeek = secondsInDay * 7);

/**
 * @constant
 * @name secondsInYear
 * @summary Seconds in 1 year.
 */
const secondsInYear = (exports.secondsInYear = secondsInDay * daysInYear);

/**
 * @constant
 * @name secondsInMonth
 * @summary Seconds in 1 month
 */
const secondsInMonth = (exports.secondsInMonth = secondsInYear / 12);

/**
 * @constant
 * @name secondsInQuarter
 * @summary Seconds in 1 quarter.
 */
const secondsInQuarter = (exports.secondsInQuarter = secondsInMonth * 3);


/***/ }),

/***/ 78197:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.constructFrom = constructFrom;

/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */
function constructFrom(date, value) {
  if (date instanceof Date) {
    return new date.constructor(value);
  } else {
    return new Date(value);
  }
}


/***/ }),

/***/ 23532:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.differenceInCalendarDays = differenceInCalendarDays;
var _index = __webpack_require__(50615);
var _index2 = __webpack_require__(57095);
var _index3 = __webpack_require__(8568);

/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */
function differenceInCalendarDays(dateLeft, dateRight) {
  const startOfDayLeft = (0, _index2.startOfDay)(dateLeft);
  const startOfDayRight = (0, _index2.startOfDay)(dateRight);

  const timestampLeft =
    +startOfDayLeft -
    (0, _index3.getTimezoneOffsetInMilliseconds)(startOfDayLeft);
  const timestampRight =
    +startOfDayRight -
    (0, _index3.getTimezoneOffsetInMilliseconds)(startOfDayRight);

  // Round the number of days to the nearest integer because the number of
  // milliseconds in a day is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(
    (timestampLeft - timestampRight) / _index.millisecondsInDay,
  );
}


/***/ }),

/***/ 88494:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.differenceInCalendarMonths = differenceInCalendarMonths;
var _index = __webpack_require__(44013);

/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths(dateLeft, dateRight) {
  const _dateLeft = (0, _index.toDate)(dateLeft);
  const _dateRight = (0, _index.toDate)(dateRight);

  const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
  const monthDiff = _dateLeft.getMonth() - _dateRight.getMonth();

  return yearDiff * 12 + monthDiff;
}


/***/ }),

/***/ 49227:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.differenceInCalendarYears = differenceInCalendarYears;
var _index = __webpack_require__(44013);

/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInCalendarYears(dateLeft, dateRight) {
  const _dateLeft = (0, _index.toDate)(dateLeft);
  const _dateRight = (0, _index.toDate)(dateRight);

  return _dateLeft.getFullYear() - _dateRight.getFullYear();
}


/***/ }),

/***/ 66767:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.endOfDay = endOfDay;
var _index = __webpack_require__(44013);

/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */
function endOfDay(date) {
  const _date = (0, _index.toDate)(date);
  _date.setHours(23, 59, 59, 999);
  return _date;
}


/***/ }),

/***/ 90631:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.endOfMonth = endOfMonth;
var _index = __webpack_require__(44013);

/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth(date) {
  const _date = (0, _index.toDate)(date);
  const month = _date.getMonth();
  _date.setFullYear(_date.getFullYear(), month + 1, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}


/***/ }),

/***/ 62368:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.endOfWeek = endOfWeek;
var _index = __webpack_require__(44013);

var _index2 = __webpack_require__(67845);

/**
 * The {@link endOfWeek} function options.
 */

/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek(date, options) {
  const defaultOptions = (0, _index2.getDefaultOptions)();
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const _date = (0, _index.toDate)(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);

  _date.setDate(_date.getDate() + diff);
  _date.setHours(23, 59, 59, 999);
  return _date;
}


/***/ }),

/***/ 43745:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.endOfYear = endOfYear;
var _index = __webpack_require__(44013);

/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */
function endOfYear(date) {
  const _date = (0, _index.toDate)(date);
  const year = _date.getFullYear();
  _date.setFullYear(year + 1, 0, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}


/***/ }),

/***/ 269:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.format = exports.formatDate = format;
Object.defineProperty(exports, "formatters", ({
  enumerable: true,
  get: function () {
    return _index3.formatters;
  },
}));
Object.defineProperty(exports, "longFormatters", ({
  enumerable: true,
  get: function () {
    return _index4.longFormatters;
  },
}));
var _index = __webpack_require__(89445);
var _index2 = __webpack_require__(67845);
var _index3 = __webpack_require__(74088);
var _index4 = __webpack_require__(77837);
var _index5 = __webpack_require__(58958);

var _index6 = __webpack_require__(5307);
var _index7 = __webpack_require__(44013);

// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874

// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const formattingTokensRegExp =
  /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;

const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * The {@link format} function options.
 */

/**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */
function format(date, formatStr, options) {
  const defaultOptions = (0, _index2.getDefaultOptions)();
  const locale =
    options?.locale ?? defaultOptions.locale ?? _index.defaultLocale;

  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const originalDate = (0, _index7.toDate)(date);

  if (!(0, _index6.isValid)(originalDate)) {
    throw new RangeError("Invalid time value");
  }

  let parts = formatStr
    .match(longFormattingTokensRegExp)
    .map((substring) => {
      const firstCharacter = substring[0];
      if (firstCharacter === "p" || firstCharacter === "P") {
        const longFormatter = _index4.longFormatters[firstCharacter];
        return longFormatter(substring, locale.formatLong);
      }
      return substring;
    })
    .join("")
    .match(formattingTokensRegExp)
    .map((substring) => {
      // Replace two single quote characters with one single quote character
      if (substring === "''") {
        return { isToken: false, value: "'" };
      }

      const firstCharacter = substring[0];
      if (firstCharacter === "'") {
        return { isToken: false, value: cleanEscapedString(substring) };
      }

      if (_index3.formatters[firstCharacter]) {
        return { isToken: true, value: substring };
      }

      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" +
            firstCharacter +
            "`",
        );
      }

      return { isToken: false, value: substring };
    });

  // invoke localize preprocessor (only for french locales at the moment)
  if (locale.localize.preprocessor) {
    parts = locale.localize.preprocessor(originalDate, parts);
  }

  const formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale,
  };

  return parts
    .map((part) => {
      if (!part.isToken) return part.value;

      const token = part.value;

      if (
        (!options?.useAdditionalWeekYearTokens &&
          (0, _index5.isProtectedWeekYearToken)(token)) ||
        (!options?.useAdditionalDayOfYearTokens &&
          (0, _index5.isProtectedDayOfYearToken)(token))
      ) {
        (0, _index5.warnOrThrowProtectedError)(token, formatStr, String(date));
      }

      const formatter = _index3.formatters[token[0]];
      return formatter(originalDate, token, locale.localize, formatterOptions);
    })
    .join("");
}

function cleanEscapedString(input) {
  const matched = input.match(escapedStringRegExp);

  if (!matched) {
    return input;
  }

  return matched[1].replace(doubleQuoteRegExp, "'");
}


/***/ }),

/***/ 1981:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getDate = getDate;
var _index = __webpack_require__(44013);

/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */
function getDate(date) {
  const _date = (0, _index.toDate)(date);
  const dayOfMonth = _date.getDate();
  return dayOfMonth;
}


/***/ }),

/***/ 99829:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getDay = getDay;
var _index = __webpack_require__(44013);

/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of week, 0 represents Sunday
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */
function getDay(date) {
  const _date = (0, _index.toDate)(date);
  const day = _date.getDay();
  return day;
}


/***/ }),

/***/ 52394:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getDayOfYear = getDayOfYear;
var _index = __webpack_require__(23532);
var _index2 = __webpack_require__(2764);
var _index3 = __webpack_require__(44013);

/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear(date) {
  const _date = (0, _index3.toDate)(date);
  const diff = (0, _index.differenceInCalendarDays)(
    _date,
    (0, _index2.startOfYear)(_date),
  );
  const dayOfYear = diff + 1;
  return dayOfYear;
}


/***/ }),

/***/ 7260:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getDaysInMonth = getDaysInMonth;
var _index = __webpack_require__(44013);
var _index2 = __webpack_require__(78197);

/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth(date) {
  const _date = (0, _index.toDate)(date);
  const year = _date.getFullYear();
  const monthIndex = _date.getMonth();
  const lastDayOfMonth = (0, _index2.constructFrom)(date, 0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}


/***/ }),

/***/ 5445:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getDefaultOptions = getDefaultOptions;

var _index = __webpack_require__(67845);

/**
 * @name getDefaultOptions
 * @category Common Helpers
 * @summary Get default options.
 * @pure false
 *
 * @description
 * Returns an object that contains defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * You can change these with [setDefaultOptions](https://date-fns.org/docs/setDefaultOptions).
 *
 * @returns The default options
 *
 * @example
 * const result = getDefaultOptions()
 * //=> {}
 *
 * @example
 * setDefaultOptions({ weekStarsOn: 1, firstWeekContainsDate: 4 })
 * const result = getDefaultOptions()
 * //=> { weekStarsOn: 1, firstWeekContainsDate: 4 }
 */
function getDefaultOptions() {
  return Object.assign({}, (0, _index.getDefaultOptions)());
}


/***/ }),

/***/ 36529:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getHours = getHours;
var _index = __webpack_require__(44013);

/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */
function getHours(date) {
  const _date = (0, _index.toDate)(date);
  const hours = _date.getHours();
  return hours;
}


/***/ }),

/***/ 30:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getISODay = getISODay;
var _index = __webpack_require__(44013);

/**
 * @name getISODay
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * const result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */
function getISODay(date) {
  const _date = (0, _index.toDate)(date);
  let day = _date.getDay();

  if (day === 0) {
    day = 7;
  }

  return day;
}


/***/ }),

/***/ 2169:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getISOWeek = getISOWeek;
var _index = __webpack_require__(50615);
var _index2 = __webpack_require__(84822);
var _index3 = __webpack_require__(34734);
var _index4 = __webpack_require__(44013);

/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek(date) {
  const _date = (0, _index4.toDate)(date);
  const diff =
    +(0, _index2.startOfISOWeek)(_date) -
    +(0, _index3.startOfISOWeekYear)(_date);

  // Round the number of weeks to the nearest integer because the number of
  // milliseconds in a week is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(diff / _index.millisecondsInWeek) + 1;
}


/***/ }),

/***/ 74551:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getISOWeekYear = getISOWeekYear;
var _index = __webpack_require__(78197);
var _index2 = __webpack_require__(84822);
var _index3 = __webpack_require__(44013);

/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOWeekYear(date) {
  const _date = (0, _index3.toDate)(date);
  const year = _date.getFullYear();

  const fourthOfJanuaryOfNextYear = (0, _index.constructFrom)(date, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = (0, _index2.startOfISOWeek)(
    fourthOfJanuaryOfNextYear,
  );

  const fourthOfJanuaryOfThisYear = (0, _index.constructFrom)(date, 0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = (0, _index2.startOfISOWeek)(
    fourthOfJanuaryOfThisYear,
  );

  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}


/***/ }),

/***/ 2583:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getMinutes = getMinutes;
var _index = __webpack_require__(44013);

/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */
function getMinutes(date) {
  const _date = (0, _index.toDate)(date);
  const minutes = _date.getMinutes();
  return minutes;
}


/***/ }),

/***/ 97231:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getMonth = getMonth;
var _index = __webpack_require__(44013);

/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The month
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */
function getMonth(date) {
  const _date = (0, _index.toDate)(date);
  const month = _date.getMonth();
  return month;
}


/***/ }),

/***/ 46911:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getQuarter = getQuarter;
var _index = __webpack_require__(44013);

/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */
function getQuarter(date) {
  const _date = (0, _index.toDate)(date);
  const quarter = Math.trunc(_date.getMonth() / 3) + 1;
  return quarter;
}


/***/ }),

/***/ 86111:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getSeconds = getSeconds;
var _index = __webpack_require__(44013);

/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */
function getSeconds(date) {
  const _date = (0, _index.toDate)(date);
  const seconds = _date.getSeconds();
  return seconds;
}


/***/ }),

/***/ 27373:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getTime = getTime;
var _index = __webpack_require__(44013);

/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */
function getTime(date) {
  const _date = (0, _index.toDate)(date);
  const timestamp = _date.getTime();
  return timestamp;
}


/***/ }),

/***/ 68483:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getWeek = getWeek;
var _index = __webpack_require__(50615);
var _index2 = __webpack_require__(18941);
var _index3 = __webpack_require__(85696);
var _index4 = __webpack_require__(44013);

/**
 * The {@link getWeek} function options.
 */

/**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */

function getWeek(date, options) {
  const _date = (0, _index4.toDate)(date);
  const diff =
    +(0, _index2.startOfWeek)(_date, options) -
    +(0, _index3.startOfWeekYear)(_date, options);

  // Round the number of weeks to the nearest integer because the number of
  // milliseconds in a week is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(diff / _index.millisecondsInWeek) + 1;
}


/***/ }),

/***/ 3570:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getWeekYear = getWeekYear;
var _index = __webpack_require__(78197);
var _index2 = __webpack_require__(18941);
var _index3 = __webpack_require__(44013);

var _index4 = __webpack_require__(67845);

/**
 * The {@link getWeekYear} function options.
 */

/**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */
function getWeekYear(date, options) {
  const _date = (0, _index3.toDate)(date);
  const year = _date.getFullYear();

  const defaultOptions = (0, _index4.getDefaultOptions)();
  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const firstWeekOfNextYear = (0, _index.constructFrom)(date, 0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = (0, _index2.startOfWeek)(
    firstWeekOfNextYear,
    options,
  );

  const firstWeekOfThisYear = (0, _index.constructFrom)(date, 0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = (0, _index2.startOfWeek)(
    firstWeekOfThisYear,
    options,
  );

  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}


/***/ }),

/***/ 7530:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.getYear = getYear;
var _index = __webpack_require__(44013);

/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */
function getYear(date) {
  return (0, _index.toDate)(date).getFullYear();
}


/***/ }),

/***/ 97900:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isAfter = isAfter;
var _index = __webpack_require__(44013);

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be after the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter(date, dateToCompare) {
  const _date = (0, _index.toDate)(date);
  const _dateToCompare = (0, _index.toDate)(dateToCompare);
  return _date.getTime() > _dateToCompare.getTime();
}


/***/ }),

/***/ 25340:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isBefore = isBefore;
var _index = __webpack_require__(44013);

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore(date, dateToCompare) {
  const _date = (0, _index.toDate)(date);
  const _dateToCompare = (0, _index.toDate)(dateToCompare);
  return +_date < +_dateToCompare;
}


/***/ }),

/***/ 63398:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.isDate = isDate; /**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  return (
    value instanceof Date ||
    (typeof value === "object" &&
      Object.prototype.toString.call(value) === "[object Date]")
  );
}


/***/ }),

/***/ 25331:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isEqual = isEqual;
var _index = __webpack_require__(44013);

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual(leftDate, rightDate) {
  const _dateLeft = (0, _index.toDate)(leftDate);
  const _dateRight = (0, _index.toDate)(rightDate);
  return +_dateLeft === +_dateRight;
}


/***/ }),

/***/ 19089:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isSameDay = isSameDay;
var _index = __webpack_require__(57095);

/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same day (and year and month)
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */
function isSameDay(dateLeft, dateRight) {
  const dateLeftStartOfDay = (0, _index.startOfDay)(dateLeft);
  const dateRightStartOfDay = (0, _index.startOfDay)(dateRight);

  return +dateLeftStartOfDay === +dateRightStartOfDay;
}


/***/ }),

/***/ 59856:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isSameMonth = isSameMonth;
var _index = __webpack_require__(44013);

/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same month (and year)
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */
function isSameMonth(dateLeft, dateRight) {
  const _dateLeft = (0, _index.toDate)(dateLeft);
  const _dateRight = (0, _index.toDate)(dateRight);
  return (
    _dateLeft.getFullYear() === _dateRight.getFullYear() &&
    _dateLeft.getMonth() === _dateRight.getMonth()
  );
}


/***/ }),

/***/ 44814:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isSameQuarter = isSameQuarter;
var _index = __webpack_require__(1742);

/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same quarter (and year)
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */
function isSameQuarter(dateLeft, dateRight) {
  const dateLeftStartOfQuarter = (0, _index.startOfQuarter)(dateLeft);
  const dateRightStartOfQuarter = (0, _index.startOfQuarter)(dateRight);

  return +dateLeftStartOfQuarter === +dateRightStartOfQuarter;
}


/***/ }),

/***/ 38906:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isSameYear = isSameYear;
var _index = __webpack_require__(44013);

/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */
function isSameYear(dateLeft, dateRight) {
  const _dateLeft = (0, _index.toDate)(dateLeft);
  const _dateRight = (0, _index.toDate)(dateRight);
  return _dateLeft.getFullYear() === _dateRight.getFullYear();
}


/***/ }),

/***/ 5307:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isValid = isValid;
var _index = __webpack_require__(63398);
var _index2 = __webpack_require__(44013);

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(date) {
  if (!(0, _index.isDate)(date) && typeof date !== "number") {
    return false;
  }
  const _date = (0, _index2.toDate)(date);
  return !isNaN(Number(_date));
}


/***/ }),

/***/ 7187:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.isWithinInterval = isWithinInterval;
var _index = __webpack_require__(44013);

/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param interval - The interval to check
 *
 * @returns The date is within the interval
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date })
 * // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end })
 * // => true
 */
function isWithinInterval(date, interval) {
  const time = +(0, _index.toDate)(date);
  const [startTime, endTime] = [
    +(0, _index.toDate)(interval.start),
    +(0, _index.toDate)(interval.end),
  ].sort((a, b) => a - b);

  return time >= startTime && time <= endTime;
}


/***/ }),

/***/ 56124:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.buildFormatLongFn = buildFormatLongFn;

function buildFormatLongFn(args) {
  return (options = {}) => {
    // TODO: Remove String()
    const width = options.width ? String(options.width) : args.defaultWidth;
    const format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}


/***/ }),

/***/ 65412:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.buildLocalizeFn = buildLocalizeFn; /* eslint-disable no-unused-vars */

/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */

/**
 * The map of localized values for each width.
 */

/**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */

/**
 * Converts the unit value to the tuple of values.
 */

/**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */

/**
 * The tuple of localized quarter values. The first element represents Q1.
 */

/**
 * The tuple of localized day values. The first element represents Sunday.
 */

/**
 * The tuple of localized month values. The first element represents January.
 */

function buildLocalizeFn(args) {
  return (value, options) => {
    const context = options?.context ? String(options.context) : "standalone";

    let valuesArray;
    if (context === "formatting" && args.formattingValues) {
      const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      const width = options?.width ? String(options.width) : defaultWidth;

      valuesArray =
        args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      const defaultWidth = args.defaultWidth;
      const width = options?.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[width] || args.values[defaultWidth];
    }
    const index = args.argumentCallback ? args.argumentCallback(value) : value;

    // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}


/***/ }),

/***/ 78678:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.buildMatchFn = buildMatchFn;

function buildMatchFn(args) {
  return (string, options = {}) => {
    const width = options.width;

    const matchPattern =
      (width && args.matchPatterns[width]) ||
      args.matchPatterns[args.defaultMatchWidth];
    const matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }
    const matchedString = matchResult[0];

    const parsePatterns =
      (width && args.parsePatterns[width]) ||
      args.parsePatterns[args.defaultParseWidth];

    const key = Array.isArray(parsePatterns)
      ? findIndex(parsePatterns, (pattern) => pattern.test(matchedString))
      : // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        findKey(parsePatterns, (pattern) => pattern.test(matchedString));

    let value;

    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback
      ? // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        options.valueCallback(value)
      : value;

    const rest = string.slice(matchedString.length);

    return { value, rest };
  };
}

function findKey(object, predicate) {
  for (const key in object) {
    if (
      Object.prototype.hasOwnProperty.call(object, key) &&
      predicate(object[key])
    ) {
      return key;
    }
  }
  return undefined;
}

function findIndex(array, predicate) {
  for (let key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}


/***/ }),

/***/ 88555:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.buildMatchPatternFn = buildMatchPatternFn;

function buildMatchPatternFn(args) {
  return (string, options = {}) => {
    const matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    const matchedString = matchResult[0];

    const parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    let value = args.valueCallback
      ? args.valueCallback(parseResult[0])
      : parseResult[0];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    value = options.valueCallback ? options.valueCallback(value) : value;

    const rest = string.slice(matchedString.length);

    return { value, rest };
  };
}


/***/ }),

/***/ 86177:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.enUS = void 0;
var _index = __webpack_require__(87949);
var _index2 = __webpack_require__(11217);
var _index3 = __webpack_require__(17811);
var _index4 = __webpack_require__(1636);
var _index5 = __webpack_require__(59911);

/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */
const enUS = (exports.enUS = {
  code: "en-US",
  formatDistance: _index.formatDistance,
  formatLong: _index2.formatLong,
  formatRelative: _index3.formatRelative,
  localize: _index4.localize,
  match: _index5.match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
});


/***/ }),

/***/ 87949:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.formatDistance = void 0;

const formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds",
  },

  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds",
  },

  halfAMinute: "half a minute",

  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes",
  },

  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes",
  },

  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours",
  },

  xHours: {
    one: "1 hour",
    other: "{{count}} hours",
  },

  xDays: {
    one: "1 day",
    other: "{{count}} days",
  },

  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks",
  },

  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks",
  },

  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months",
  },

  xMonths: {
    one: "1 month",
    other: "{{count}} months",
  },

  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years",
  },

  xYears: {
    one: "1 year",
    other: "{{count}} years",
  },

  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years",
  },

  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years",
  },
};

const formatDistance = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }

  return result;
};
exports.formatDistance = formatDistance;


/***/ }),

/***/ 11217:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.formatLong = void 0;
var _index = __webpack_require__(56124);

const dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy",
};

const timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

const dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

const formatLong = (exports.formatLong = {
  date: (0, _index.buildFormatLongFn)({
    formats: dateFormats,
    defaultWidth: "full",
  }),

  time: (0, _index.buildFormatLongFn)({
    formats: timeFormats,
    defaultWidth: "full",
  }),

  dateTime: (0, _index.buildFormatLongFn)({
    formats: dateTimeFormats,
    defaultWidth: "full",
  }),
});


/***/ }),

/***/ 17811:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.formatRelative = void 0;

const formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P",
};

const formatRelative = (token, _date, _baseDate, _options) =>
  formatRelativeLocale[token];
exports.formatRelative = formatRelative;


/***/ }),

/***/ 1636:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.localize = void 0;
var _index = __webpack_require__(65412);

const eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"],
};

const quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"],
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],

  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
};

const dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ],
};

const dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
};

const formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
};

const ordinalNumber = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};

const localize = (exports.localize = {
  ordinalNumber,

  era: (0, _index.buildLocalizeFn)({
    values: eraValues,
    defaultWidth: "wide",
  }),

  quarter: (0, _index.buildLocalizeFn)({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index.buildLocalizeFn)({
    values: monthValues,
    defaultWidth: "wide",
  }),

  day: (0, _index.buildLocalizeFn)({
    values: dayValues,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index.buildLocalizeFn)({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide",
  }),
});


/***/ }),

/***/ 59911:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.match = void 0;

var _index = __webpack_require__(78678);
var _index2 = __webpack_require__(88555);

const matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern = /\d+/i;

const matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i,
};
const parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i],
};

const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i,
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i,
};
const parseMonthPatterns = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i,
};
const parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i],
};

const matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i,
};
const parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i,
  },
};

const match = (exports.match = {
  ordinalNumber: (0, _index2.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index.buildMatchFn)({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index.buildMatchFn)({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index.buildMatchFn)({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any",
  }),

  day: (0, _index.buildMatchFn)({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any",
  }),
});


/***/ }),

/***/ 35343:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.max = max;
var _index = __webpack_require__(44013);

/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */
function max(dates) {
  let result;
  dates.forEach(function (dirtyDate) {
    const currentDate = (0, _index.toDate)(dirtyDate);

    if (
      result === undefined ||
      result < currentDate ||
      isNaN(Number(currentDate))
    ) {
      result = currentDate;
    }
  });

  return result || new Date(NaN);
}


/***/ }),

/***/ 93812:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.min = min;
var _index = __webpack_require__(44013);

/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */
function min(dates) {
  let result;

  dates.forEach((dirtyDate) => {
    const date = (0, _index.toDate)(dirtyDate);
    if (!result || result > date || isNaN(+date)) {
      result = date;
    }
  });

  return result || new Date(NaN);
}


/***/ }),

/***/ 53915:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "longFormatters", ({
  enumerable: true,
  get: function () {
    return _index5.longFormatters;
  },
}));
exports.parse = parse;
Object.defineProperty(exports, "parsers", ({
  enumerable: true,
  get: function () {
    return _index7.parsers;
  },
}));
var _index = __webpack_require__(78197);
var _index2 = __webpack_require__(5445);
var _index3 = __webpack_require__(86177);
var _index4 = __webpack_require__(44013);

var _index5 = __webpack_require__(77837);
var _index6 = __webpack_require__(58958);

var _index7 = __webpack_require__(78561);

var _Setter = __webpack_require__(12189);

// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874

/**
 * The {@link parse} function options.
 */

// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const formattingTokensRegExp =
  /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;

const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;

const notWhitespaceRegExp = /\S/;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The string to parse
 * @param formatStr - The string of tokens
 * @param referenceDate - defines values missing from the parsed dateString
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns The parsed date
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */
function parse(dateStr, formatStr, referenceDate, options) {
  const defaultOptions = (0, _index2.getDefaultOptions)();
  const locale = options?.locale ?? defaultOptions.locale ?? _index3.enUS;

  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  if (formatStr === "") {
    if (dateStr === "") {
      return (0, _index4.toDate)(referenceDate);
    } else {
      return (0, _index.constructFrom)(referenceDate, NaN);
    }
  }

  const subFnOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale,
  };

  // If timezone isn't specified, it will be set to the system timezone
  const setters = [new _Setter.DateToSystemTimezoneSetter()];

  const tokens = formatStr
    .match(longFormattingTokensRegExp)
    .map((substring) => {
      const firstCharacter = substring[0];
      if (firstCharacter in _index5.longFormatters) {
        const longFormatter = _index5.longFormatters[firstCharacter];
        return longFormatter(substring, locale.formatLong);
      }
      return substring;
    })
    .join("")
    .match(formattingTokensRegExp);

  const usedTokens = [];

  for (let token of tokens) {
    if (
      !options?.useAdditionalWeekYearTokens &&
      (0, _index6.isProtectedWeekYearToken)(token)
    ) {
      (0, _index6.warnOrThrowProtectedError)(token, formatStr, dateStr);
    }
    if (
      !options?.useAdditionalDayOfYearTokens &&
      (0, _index6.isProtectedDayOfYearToken)(token)
    ) {
      (0, _index6.warnOrThrowProtectedError)(token, formatStr, dateStr);
    }

    const firstCharacter = token[0];
    const parser = _index7.parsers[firstCharacter];
    if (parser) {
      const { incompatibleTokens } = parser;
      if (Array.isArray(incompatibleTokens)) {
        const incompatibleToken = usedTokens.find(
          (usedToken) =>
            incompatibleTokens.includes(usedToken.token) ||
            usedToken.token === firstCharacter,
        );
        if (incompatibleToken) {
          throw new RangeError(
            `The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`,
          );
        }
      } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) {
        throw new RangeError(
          `The format string mustn't contain \`${token}\` and any other token at the same time`,
        );
      }

      usedTokens.push({ token: firstCharacter, fullToken: token });

      const parseResult = parser.run(
        dateStr,
        token,
        locale.match,
        subFnOptions,
      );

      if (!parseResult) {
        return (0, _index.constructFrom)(referenceDate, NaN);
      }

      setters.push(parseResult.setter);

      dateStr = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" +
            firstCharacter +
            "`",
        );
      }

      // Replace two single quote characters with one single quote character
      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString(token);
      }

      // Cut token from string, or, if string doesn't match the token, return Invalid Date
      if (dateStr.indexOf(token) === 0) {
        dateStr = dateStr.slice(token.length);
      } else {
        return (0, _index.constructFrom)(referenceDate, NaN);
      }
    }
  }

  // Check if the remaining input contains something other than whitespace
  if (dateStr.length > 0 && notWhitespaceRegExp.test(dateStr)) {
    return (0, _index.constructFrom)(referenceDate, NaN);
  }

  const uniquePrioritySetters = setters
    .map((setter) => setter.priority)
    .sort((a, b) => b - a)
    .filter((priority, index, array) => array.indexOf(priority) === index)
    .map((priority) =>
      setters
        .filter((setter) => setter.priority === priority)
        .sort((a, b) => b.subPriority - a.subPriority),
    )
    .map((setterArray) => setterArray[0]);

  let date = (0, _index4.toDate)(referenceDate);

  if (isNaN(date.getTime())) {
    return (0, _index.constructFrom)(referenceDate, NaN);
  }

  const flags = {};
  for (const setter of uniquePrioritySetters) {
    if (!setter.validate(date, subFnOptions)) {
      return (0, _index.constructFrom)(referenceDate, NaN);
    }

    const result = setter.set(date, flags, subFnOptions);
    // Result is tuple (date, flags)
    if (Array.isArray(result)) {
      date = result[0];
      Object.assign(flags, result[1]);
      // Result is date
    } else {
      date = result;
    }
  }

  return (0, _index.constructFrom)(referenceDate, date);
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}


/***/ }),

/***/ 22427:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.Parser = void 0;
var _Setter = __webpack_require__(12189);

class Parser {
  run(dateString, token, match, options) {
    const result = this.parse(dateString, token, match, options);
    if (!result) {
      return null;
    }

    return {
      setter: new _Setter.ValueSetter(
        result.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority,
      ),
      rest: result.rest,
    };
  }

  validate(_utcDate, _value, _options) {
    return true;
  }
}
exports.Parser = Parser;


/***/ }),

/***/ 12189:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.ValueSetter =
  exports.Setter =
  exports.DateToSystemTimezoneSetter =
    void 0;
var _index = __webpack_require__(35298);
var _index2 = __webpack_require__(78197);

const TIMEZONE_UNIT_PRIORITY = 10;

class Setter {
  subPriority = 0;

  validate(_utcDate, _options) {
    return true;
  }
}
exports.Setter = Setter;

class ValueSetter extends Setter {
  constructor(
    value,

    validateValue,

    setValue,

    priority,
    subPriority,
  ) {
    super();
    this.value = value;
    this.validateValue = validateValue;
    this.setValue = setValue;
    this.priority = priority;
    if (subPriority) {
      this.subPriority = subPriority;
    }
  }

  validate(date, options) {
    return this.validateValue(date, this.value, options);
  }

  set(date, flags, options) {
    return this.setValue(date, flags, this.value, options);
  }
}
exports.ValueSetter = ValueSetter;

class DateToSystemTimezoneSetter extends Setter {
  priority = TIMEZONE_UNIT_PRIORITY;
  subPriority = -1;
  set(date, flags) {
    if (flags.timestampIsSet) return date;
    return (0, _index2.constructFrom)(date, (0, _index.transpose)(date, Date));
  }
}
exports.DateToSystemTimezoneSetter = DateToSystemTimezoneSetter;


/***/ }),

/***/ 34320:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.timezonePatterns = exports.numericPatterns = void 0;
const numericPatterns = (exports.numericPatterns = {
  month: /^(1[0-2]|0?\d)/, // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/, // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/, // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/, // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/, // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/, // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/, // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/, // 0 to 12
  minute: /^[0-5]?\d/, // 0 to 59
  second: /^[0-5]?\d/, // 0 to 59

  singleDigit: /^\d/, // 0 to 9
  twoDigits: /^\d{1,2}/, // 0 to 99
  threeDigits: /^\d{1,3}/, // 0 to 999
  fourDigits: /^\d{1,4}/, // 0 to 9999

  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/, // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/, // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/, // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/, // 0 to 9999, -0 to -9999
});

const timezonePatterns = (exports.timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/,
});


/***/ }),

/***/ 78561:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.parsers = void 0;
var _EraParser = __webpack_require__(71759);
var _YearParser = __webpack_require__(39656);
var _LocalWeekYearParser = __webpack_require__(45749);
var _ISOWeekYearParser = __webpack_require__(106);
var _ExtendedYearParser = __webpack_require__(31654);
var _QuarterParser = __webpack_require__(39534);
var _StandAloneQuarterParser = __webpack_require__(97670);
var _MonthParser = __webpack_require__(65354);
var _StandAloneMonthParser = __webpack_require__(66874);
var _LocalWeekParser = __webpack_require__(35975);
var _ISOWeekParser = __webpack_require__(3481);
var _DateParser = __webpack_require__(69044);
var _DayOfYearParser = __webpack_require__(13083);
var _DayParser = __webpack_require__(84306);
var _LocalDayParser = __webpack_require__(13569);
var _StandAloneLocalDayParser = __webpack_require__(68228);
var _ISODayParser = __webpack_require__(22638);
var _AMPMParser = __webpack_require__(20914);
var _AMPMMidnightParser = __webpack_require__(38915);
var _DayPeriodParser = __webpack_require__(41212);
var _Hour1to12Parser = __webpack_require__(2742);
var _Hour0to23Parser = __webpack_require__(90812);
var _Hour0To11Parser = __webpack_require__(39850);
var _Hour1To24Parser = __webpack_require__(49689);
var _MinuteParser = __webpack_require__(72842);
var _SecondParser = __webpack_require__(99913);
var _FractionOfSecondParser = __webpack_require__(97453);
var _ISOTimezoneWithZParser = __webpack_require__(16933);
var _ISOTimezoneParser = __webpack_require__(21820);
var _TimestampSecondsParser = __webpack_require__(36650);
var _TimestampMillisecondsParser = __webpack_require__(92097);

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- It's ok, we want any here
const parsers = (exports.parsers = {
  G: new _EraParser.EraParser(),
  y: new _YearParser.YearParser(),
  Y: new _LocalWeekYearParser.LocalWeekYearParser(),
  R: new _ISOWeekYearParser.ISOWeekYearParser(),
  u: new _ExtendedYearParser.ExtendedYearParser(),
  Q: new _QuarterParser.QuarterParser(),
  q: new _StandAloneQuarterParser.StandAloneQuarterParser(),
  M: new _MonthParser.MonthParser(),
  L: new _StandAloneMonthParser.StandAloneMonthParser(),
  w: new _LocalWeekParser.LocalWeekParser(),
  I: new _ISOWeekParser.ISOWeekParser(),
  d: new _DateParser.DateParser(),
  D: new _DayOfYearParser.DayOfYearParser(),
  E: new _DayParser.DayParser(),
  e: new _LocalDayParser.LocalDayParser(),
  c: new _StandAloneLocalDayParser.StandAloneLocalDayParser(),
  i: new _ISODayParser.ISODayParser(),
  a: new _AMPMParser.AMPMParser(),
  b: new _AMPMMidnightParser.AMPMMidnightParser(),
  B: new _DayPeriodParser.DayPeriodParser(),
  h: new _Hour1to12Parser.Hour1to12Parser(),
  H: new _Hour0to23Parser.Hour0to23Parser(),
  K: new _Hour0To11Parser.Hour0To11Parser(),
  k: new _Hour1To24Parser.Hour1To24Parser(),
  m: new _MinuteParser.MinuteParser(),
  s: new _SecondParser.SecondParser(),
  S: new _FractionOfSecondParser.FractionOfSecondParser(),
  X: new _ISOTimezoneWithZParser.ISOTimezoneWithZParser(),
  x: new _ISOTimezoneParser.ISOTimezoneParser(),
  t: new _TimestampSecondsParser.TimestampSecondsParser(),
  T: new _TimestampMillisecondsParser.TimestampMillisecondsParser(),
});


/***/ }),

/***/ 38915:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.AMPMMidnightParser = void 0;
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

class AMPMMidnightParser extends _Parser.Parser {
  priority = 80;

  parse(dateString, token, match) {
    switch (token) {
      case "b":
      case "bb":
      case "bbb":
        return (
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );

      case "bbbbb":
        return match.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting",
        });
      case "bbbb":
      default:
        return (
          match.dayPeriod(dateString, {
            width: "wide",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );
    }
  }

  set(date, _flags, value) {
    date.setHours((0, _utils.dayPeriodEnumToHours)(value), 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["a", "B", "H", "k", "t", "T"];
}
exports.AMPMMidnightParser = AMPMMidnightParser;


/***/ }),

/***/ 20914:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.AMPMParser = void 0;
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

class AMPMParser extends _Parser.Parser {
  priority = 80;

  parse(dateString, token, match) {
    switch (token) {
      case "a":
      case "aa":
      case "aaa":
        return (
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );

      case "aaaaa":
        return match.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting",
        });
      case "aaaa":
      default:
        return (
          match.dayPeriod(dateString, {
            width: "wide",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );
    }
  }

  set(date, _flags, value) {
    date.setHours((0, _utils.dayPeriodEnumToHours)(value), 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["b", "B", "H", "k", "t", "T"];
}
exports.AMPMParser = AMPMParser;


/***/ }),

/***/ 69044:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.DateParser = void 0;
var _constants = __webpack_require__(34320);
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

const DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const DAYS_IN_MONTH_LEAP_YEAR = [
  31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31,
];

// Day of the month
class DateParser extends _Parser.Parser {
  priority = 90;
  subPriority = 1;

  parse(dateString, token, match) {
    switch (token) {
      case "d":
        return (0, _utils.parseNumericPattern)(
          _constants.numericPatterns.date,
          dateString,
        );
      case "do":
        return match.ordinalNumber(dateString, { unit: "date" });
      default:
        return (0, _utils.parseNDigits)(token.length, dateString);
    }
  }

  validate(date, value) {
    const year = date.getFullYear();
    const isLeapYear = (0, _utils.isLeapYearIndex)(year);
    const month = date.getMonth();
    if (isLeapYear) {
      return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
    } else {
      return value >= 1 && value <= DAYS_IN_MONTH[month];
    }
  }

  set(date, _flags, value) {
    date.setDate(value);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];
}
exports.DateParser = DateParser;


/***/ }),

/***/ 13083:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.DayOfYearParser = void 0;
var _constants = __webpack_require__(34320);
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

class DayOfYearParser extends _Parser.Parser {
  priority = 90;

  subpriority = 1;

  parse(dateString, token, match) {
    switch (token) {
      case "D":
      case "DD":
        return (0, _utils.parseNumericPattern)(
          _constants.numericPatterns.dayOfYear,
          dateString,
        );
      case "Do":
        return match.ordinalNumber(dateString, { unit: "date" });
      default:
        return (0, _utils.parseNDigits)(token.length, dateString);
    }
  }

  validate(date, value) {
    const year = date.getFullYear();
    const isLeapYear = (0, _utils.isLeapYearIndex)(year);
    if (isLeapYear) {
      return value >= 1 && value <= 366;
    } else {
      return value >= 1 && value <= 365;
    }
  }

  set(date, _flags, value) {
    date.setMonth(0, value);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "E",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];
}
exports.DayOfYearParser = DayOfYearParser;


/***/ }),

/***/ 84306:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.DayParser = void 0;
var _index = __webpack_require__(37576);
var _Parser = __webpack_require__(22427);

// Day of week
class DayParser extends _Parser.Parser {
  priority = 90;

  parse(dateString, token, match) {
    switch (token) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return (
          match.day(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );

      // T
      case "EEEEE":
        return match.day(dateString, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "EEEEEE":
        return (
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );

      // Tuesday
      case "EEEE":
      default:
        return (
          match.day(dateString, { width: "wide", context: "formatting" }) ||
          match.day(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 6;
  }

  set(date, _flags, value, options) {
    date = (0, _index.setDay)(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["D", "i", "e", "c", "t", "T"];
}
exports.DayParser = DayParser;


/***/ }),

/***/ 41212:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.DayPeriodParser = void 0;
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

// in the morning, in the afternoon, in the evening, at night
class DayPeriodParser extends _Parser.Parser {
  priority = 80;

  parse(dateString, token, match) {
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return (
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );

      case "BBBBB":
        return match.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting",
        });
      case "BBBB":
      default:
        return (
          match.dayPeriod(dateString, {
            width: "wide",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );
    }
  }

  set(date, _flags, value) {
    date.setHours((0, _utils.dayPeriodEnumToHours)(value), 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["a", "b", "t", "T"];
}
exports.DayPeriodParser = DayPeriodParser;


/***/ }),

/***/ 71759:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.EraParser = void 0;

var _Parser = __webpack_require__(22427);

class EraParser extends _Parser.Parser {
  priority = 140;

  parse(dateString, token, match) {
    switch (token) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return (
          match.era(dateString, { width: "abbreviated" }) ||
          match.era(dateString, { width: "narrow" })
        );

      // A, B
      case "GGGGG":
        return match.era(dateString, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return (
          match.era(dateString, { width: "wide" }) ||
          match.era(dateString, { width: "abbreviated" }) ||
          match.era(dateString, { width: "narrow" })
        );
    }
  }

  set(date, flags, value) {
    flags.era = value;
    date.setFullYear(value, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["R", "u", "t", "T"];
}
exports.EraParser = EraParser;


/***/ }),

/***/ 31654:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.ExtendedYearParser = void 0;
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

class ExtendedYearParser extends _Parser.Parser {
  priority = 130;

  parse(dateString, token) {
    if (token === "u") {
      return (0, _utils.parseNDigitsSigned)(4, dateString);
    }

    return (0, _utils.parseNDigitsSigned)(token.length, dateString);
  }

  set(date, _flags, value) {
    date.setFullYear(value, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"];
}
exports.ExtendedYearParser = ExtendedYearParser;


/***/ }),

/***/ 97453:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.FractionOfSecondParser = void 0;
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

class FractionOfSecondParser extends _Parser.Parser {
  priority = 30;

  parse(dateString, token) {
    const valueCallback = (value) =>
      Math.trunc(value * Math.pow(10, -token.length + 3));
    return (0, _utils.mapValue)(
      (0, _utils.parseNDigits)(token.length, dateString),
      valueCallback,
    );
  }

  set(date, _flags, value) {
    date.setMilliseconds(value);
    return date;
  }

  incompatibleTokens = ["t", "T"];
}
exports.FractionOfSecondParser = FractionOfSecondParser;


/***/ }),

/***/ 39850:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.Hour0To11Parser = void 0;
var _constants = __webpack_require__(34320);
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

class Hour0To11Parser extends _Parser.Parser {
  priority = 70;

  parse(dateString, token, match) {
    switch (token) {
      case "K":
        return (0, _utils.parseNumericPattern)(
          _constants.numericPatterns.hour11h,
          dateString,
        );
      case "Ko":
        return match.ordinalNumber(dateString, { unit: "hour" });
      default:
        return (0, _utils.parseNDigits)(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 11;
  }

  set(date, _flags, value) {
    const isPM = date.getHours() >= 12;
    if (isPM && value < 12) {
      date.setHours(value + 12, 0, 0, 0);
    } else {
      date.setHours(value, 0, 0, 0);
    }
    return date;
  }

  incompatibleTokens = ["h", "H", "k", "t", "T"];
}
exports.Hour0To11Parser = Hour0To11Parser;


/***/ }),

/***/ 90812:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.Hour0to23Parser = void 0;
var _constants = __webpack_require__(34320);
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

class Hour0to23Parser extends _Parser.Parser {
  priority = 70;

  parse(dateString, token, match) {
    switch (token) {
      case "H":
        return (0, _utils.parseNumericPattern)(
          _constants.numericPatterns.hour23h,
          dateString,
        );
      case "Ho":
        return match.ordinalNumber(dateString, { unit: "hour" });
      default:
        return (0, _utils.parseNDigits)(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 23;
  }

  set(date, _flags, value) {
    date.setHours(value, 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["a", "b", "h", "K", "k", "t", "T"];
}
exports.Hour0to23Parser = Hour0to23Parser;


/***/ }),

/***/ 49689:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.Hour1To24Parser = void 0;
var _constants = __webpack_require__(34320);
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

class Hour1To24Parser extends _Parser.Parser {
  priority = 70;

  parse(dateString, token, match) {
    switch (token) {
      case "k":
        return (0, _utils.parseNumericPattern)(
          _constants.numericPatterns.hour24h,
          dateString,
        );
      case "ko":
        return match.ordinalNumber(dateString, { unit: "hour" });
      default:
        return (0, _utils.parseNDigits)(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 24;
  }

  set(date, _flags, value) {
    const hours = value <= 24 ? value % 24 : value;
    date.setHours(hours, 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["a", "b", "h", "H", "K", "t", "T"];
}
exports.Hour1To24Parser = Hour1To24Parser;


/***/ }),

/***/ 2742:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.Hour1to12Parser = void 0;
var _constants = __webpack_require__(34320);
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

class Hour1to12Parser extends _Parser.Parser {
  priority = 70;

  parse(dateString, token, match) {
    switch (token) {
      case "h":
        return (0, _utils.parseNumericPattern)(
          _constants.numericPatterns.hour12h,
          dateString,
        );
      case "ho":
        return match.ordinalNumber(dateString, { unit: "hour" });
      default:
        return (0, _utils.parseNDigits)(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 12;
  }

  set(date, _flags, value) {
    const isPM = date.getHours() >= 12;
    if (isPM && value < 12) {
      date.setHours(value + 12, 0, 0, 0);
    } else if (!isPM && value === 12) {
      date.setHours(0, 0, 0, 0);
    } else {
      date.setHours(value, 0, 0, 0);
    }
    return date;
  }

  incompatibleTokens = ["H", "K", "k", "t", "T"];
}
exports.Hour1to12Parser = Hour1to12Parser;


/***/ }),

/***/ 22638:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.ISODayParser = void 0;
var _index = __webpack_require__(40493);
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

// ISO day of week
class ISODayParser extends _Parser.Parser {
  priority = 90;

  parse(dateString, token, match) {
    const valueCallback = (value) => {
      if (value === 0) {
        return 7;
      }
      return value;
    };

    switch (token) {
      // 2
      case "i":
      case "ii": // 02
        return (0, _utils.parseNDigits)(token.length, dateString);
      // 2nd
      case "io":
        return match.ordinalNumber(dateString, { unit: "day" });
      // Tue
      case "iii":
        return (0, _utils.mapValue)(
          match.day(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
            match.day(dateString, {
              width: "short",
              context: "formatting",
            }) ||
            match.day(dateString, {
              width: "narrow",
              context: "formatting",
            }),
          valueCallback,
        );
      // T
      case "iiiii":
        return (0, _utils.mapValue)(
          match.day(dateString, {
            width: "narrow",
            context: "formatting",
          }),
          valueCallback,
        );
      // Tu
      case "iiiiii":
        return (0, _utils.mapValue)(
          match.day(dateString, {
            width: "short",
            context: "formatting",
          }) ||
            match.day(dateString, {
              width: "narrow",
              context: "formatting",
            }),
          valueCallback,
        );
      // Tuesday
      case "iiii":
      default:
        return (0, _utils.mapValue)(
          match.day(dateString, {
            width: "wide",
            context: "formatting",
          }) ||
            match.day(dateString, {
              width: "abbreviated",
              context: "formatting",
            }) ||
            match.day(dateString, {
              width: "short",
              context: "formatting",
            }) ||
            match.day(dateString, {
              width: "narrow",
              context: "formatting",
            }),
          valueCallback,
        );
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 7;
  }

  set(date, _flags, value) {
    date = (0, _index.setISODay)(date, value);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "E",
    "e",
    "c",
    "t",
    "T",
  ];
}
exports.ISODayParser = ISODayParser;


/***/ }),

/***/ 21820:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.ISOTimezoneParser = void 0;
var _index = __webpack_require__(78197);
var _index2 = __webpack_require__(8568);
var _constants = __webpack_require__(34320);
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

// Timezone (ISO-8601)
class ISOTimezoneParser extends _Parser.Parser {
  priority = 10;

  parse(dateString, token) {
    switch (token) {
      case "x":
        return (0, _utils.parseTimezonePattern)(
          _constants.timezonePatterns.basicOptionalMinutes,
          dateString,
        );
      case "xx":
        return (0, _utils.parseTimezonePattern)(
          _constants.timezonePatterns.basic,
          dateString,
        );
      case "xxxx":
        return (0, _utils.parseTimezonePattern)(
          _constants.timezonePatterns.basicOptionalSeconds,
          dateString,
        );
      case "xxxxx":
        return (0, _utils.parseTimezonePattern)(
          _constants.timezonePatterns.extendedOptionalSeconds,
          dateString,
        );
      case "xxx":
      default:
        return (0, _utils.parseTimezonePattern)(
          _constants.timezonePatterns.extended,
          dateString,
        );
    }
  }

  set(date, flags, value) {
    if (flags.timestampIsSet) return date;
    return (0, _index.constructFrom)(
      date,
      date.getTime() -
        (0, _index2.getTimezoneOffsetInMilliseconds)(date) -
        value,
    );
  }

  incompatibleTokens = ["t", "T", "X"];
}
exports.ISOTimezoneParser = ISOTimezoneParser;


/***/ }),

/***/ 16933:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.ISOTimezoneWithZParser = void 0;
var _index = __webpack_require__(78197);
var _index2 = __webpack_require__(8568);
var _constants = __webpack_require__(34320);
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

// Timezone (ISO-8601. +00:00 is `'Z'`)
class ISOTimezoneWithZParser extends _Parser.Parser {
  priority = 10;

  parse(dateString, token) {
    switch (token) {
      case "X":
        return (0, _utils.parseTimezonePattern)(
          _constants.timezonePatterns.basicOptionalMinutes,
          dateString,
        );
      case "XX":
        return (0, _utils.parseTimezonePattern)(
          _constants.timezonePatterns.basic,
          dateString,
        );
      case "XXXX":
        return (0, _utils.parseTimezonePattern)(
          _constants.timezonePatterns.basicOptionalSeconds,
          dateString,
        );
      case "XXXXX":
        return (0, _utils.parseTimezonePattern)(
          _constants.timezonePatterns.extendedOptionalSeconds,
          dateString,
        );
      case "XXX":
      default:
        return (0, _utils.parseTimezonePattern)(
          _constants.timezonePatterns.extended,
          dateString,
        );
    }
  }

  set(date, flags, value) {
    if (flags.timestampIsSet) return date;
    return (0, _index.constructFrom)(
      date,
      date.getTime() -
        (0, _index2.getTimezoneOffsetInMilliseconds)(date) -
        value,
    );
  }

  incompatibleTokens = ["t", "T", "x"];
}
exports.ISOTimezoneWithZParser = ISOTimezoneWithZParser;


/***/ }),

/***/ 3481:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.ISOWeekParser = void 0;
var _index = __webpack_require__(28322);
var _index2 = __webpack_require__(84822);
var _constants = __webpack_require__(34320);
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

// ISO week of year
class ISOWeekParser extends _Parser.Parser {
  priority = 100;

  parse(dateString, token, match) {
    switch (token) {
      case "I":
        return (0, _utils.parseNumericPattern)(
          _constants.numericPatterns.week,
          dateString,
        );
      case "Io":
        return match.ordinalNumber(dateString, { unit: "week" });
      default:
        return (0, _utils.parseNDigits)(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 53;
  }

  set(date, _flags, value) {
    return (0, _index2.startOfISOWeek)((0, _index.setISOWeek)(date, value));
  }

  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T",
  ];
}
exports.ISOWeekParser = ISOWeekParser;


/***/ }),

/***/ 106:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.ISOWeekYearParser = void 0;
var _index = __webpack_require__(84822);
var _index2 = __webpack_require__(78197);
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

// ISO week-numbering year
class ISOWeekYearParser extends _Parser.Parser {
  priority = 130;

  parse(dateString, token) {
    if (token === "R") {
      return (0, _utils.parseNDigitsSigned)(4, dateString);
    }

    return (0, _utils.parseNDigitsSigned)(token.length, dateString);
  }

  set(date, _flags, value) {
    const firstWeekOfYear = (0, _index2.constructFrom)(date, 0);
    firstWeekOfYear.setFullYear(value, 0, 4);
    firstWeekOfYear.setHours(0, 0, 0, 0);
    return (0, _index.startOfISOWeek)(firstWeekOfYear);
  }

  incompatibleTokens = [
    "G",
    "y",
    "Y",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T",
  ];
}
exports.ISOWeekYearParser = ISOWeekYearParser;


/***/ }),

/***/ 13569:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.LocalDayParser = void 0;
var _index = __webpack_require__(37576);
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

// Local day of week
class LocalDayParser extends _Parser.Parser {
  priority = 90;
  parse(dateString, token, match, options) {
    const valueCallback = (value) => {
      // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
      const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
      return ((value + options.weekStartsOn + 6) % 7) + wholeWeekDays;
    };

    switch (token) {
      // 3
      case "e":
      case "ee": // 03
        return (0, _utils.mapValue)(
          (0, _utils.parseNDigits)(token.length, dateString),
          valueCallback,
        );
      // 3rd
      case "eo":
        return (0, _utils.mapValue)(
          match.ordinalNumber(dateString, {
            unit: "day",
          }),
          valueCallback,
        );
      // Tue
      case "eee":
        return (
          match.day(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );

      // T
      case "eeeee":
        return match.day(dateString, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "eeeeee":
        return (
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );

      // Tuesday
      case "eeee":
      default:
        return (
          match.day(dateString, { width: "wide", context: "formatting" }) ||
          match.day(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 6;
  }

  set(date, _flags, value, options) {
    date = (0, _index.setDay)(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "c",
    "t",
    "T",
  ];
}
exports.LocalDayParser = LocalDayParser;


/***/ }),

/***/ 35975:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.LocalWeekParser = void 0;
var _index = __webpack_require__(40749);
var _index2 = __webpack_require__(18941);
var _constants = __webpack_require__(34320);
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

// Local week of year
class LocalWeekParser extends _Parser.Parser {
  priority = 100;

  parse(dateString, token, match) {
    switch (token) {
      case "w":
        return (0, _utils.parseNumericPattern)(
          _constants.numericPatterns.week,
          dateString,
        );
      case "wo":
        return match.ordinalNumber(dateString, { unit: "week" });
      default:
        return (0, _utils.parseNDigits)(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 53;
  }

  set(date, _flags, value, options) {
    return (0, _index2.startOfWeek)(
      (0, _index.setWeek)(date, value, options),
      options,
    );
  }

  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T",
  ];
}
exports.LocalWeekParser = LocalWeekParser;


/***/ }),

/***/ 45749:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.LocalWeekYearParser = void 0;
var _index = __webpack_require__(3570);

var _index2 = __webpack_require__(18941);
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

// Local week-numbering year
class LocalWeekYearParser extends _Parser.Parser {
  priority = 130;

  parse(dateString, token, match) {
    const valueCallback = (year) => ({
      year,
      isTwoDigitYear: token === "YY",
    });

    switch (token) {
      case "Y":
        return (0, _utils.mapValue)(
          (0, _utils.parseNDigits)(4, dateString),
          valueCallback,
        );
      case "Yo":
        return (0, _utils.mapValue)(
          match.ordinalNumber(dateString, {
            unit: "year",
          }),
          valueCallback,
        );
      default:
        return (0, _utils.mapValue)(
          (0, _utils.parseNDigits)(token.length, dateString),
          valueCallback,
        );
    }
  }

  validate(_date, value) {
    return value.isTwoDigitYear || value.year > 0;
  }

  set(date, flags, value, options) {
    const currentYear = (0, _index.getWeekYear)(date, options);

    if (value.isTwoDigitYear) {
      const normalizedTwoDigitYear = (0, _utils.normalizeTwoDigitYear)(
        value.year,
        currentYear,
      );
      date.setFullYear(
        normalizedTwoDigitYear,
        0,
        options.firstWeekContainsDate,
      );
      date.setHours(0, 0, 0, 0);
      return (0, _index2.startOfWeek)(date, options);
    }

    const year =
      !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
    date.setFullYear(year, 0, options.firstWeekContainsDate);
    date.setHours(0, 0, 0, 0);
    return (0, _index2.startOfWeek)(date, options);
  }

  incompatibleTokens = [
    "y",
    "R",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T",
  ];
}
exports.LocalWeekYearParser = LocalWeekYearParser;


/***/ }),

/***/ 72842:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.MinuteParser = void 0;
var _constants = __webpack_require__(34320);
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

class MinuteParser extends _Parser.Parser {
  priority = 60;

  parse(dateString, token, match) {
    switch (token) {
      case "m":
        return (0, _utils.parseNumericPattern)(
          _constants.numericPatterns.minute,
          dateString,
        );
      case "mo":
        return match.ordinalNumber(dateString, { unit: "minute" });
      default:
        return (0, _utils.parseNDigits)(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 59;
  }

  set(date, _flags, value) {
    date.setMinutes(value, 0, 0);
    return date;
  }

  incompatibleTokens = ["t", "T"];
}
exports.MinuteParser = MinuteParser;


/***/ }),

/***/ 65354:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.MonthParser = void 0;
var _constants = __webpack_require__(34320);
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

class MonthParser extends _Parser.Parser {
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "L",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];

  priority = 110;

  parse(dateString, token, match) {
    const valueCallback = (value) => value - 1;

    switch (token) {
      // 1, 2, ..., 12
      case "M":
        return (0, _utils.mapValue)(
          (0, _utils.parseNumericPattern)(
            _constants.numericPatterns.month,
            dateString,
          ),
          valueCallback,
        );
      // 01, 02, ..., 12
      case "MM":
        return (0, _utils.mapValue)(
          (0, _utils.parseNDigits)(2, dateString),
          valueCallback,
        );
      // 1st, 2nd, ..., 12th
      case "Mo":
        return (0, _utils.mapValue)(
          match.ordinalNumber(dateString, {
            unit: "month",
          }),
          valueCallback,
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return (
          match.month(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.month(dateString, { width: "narrow", context: "formatting" })
        );

      // J, F, ..., D
      case "MMMMM":
        return match.month(dateString, {
          width: "narrow",
          context: "formatting",
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return (
          match.month(dateString, { width: "wide", context: "formatting" }) ||
          match.month(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.month(dateString, { width: "narrow", context: "formatting" })
        );
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 11;
  }

  set(date, _flags, value) {
    date.setMonth(value, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
exports.MonthParser = MonthParser;


/***/ }),

/***/ 39534:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.QuarterParser = void 0;
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

class QuarterParser extends _Parser.Parser {
  priority = 120;

  parse(dateString, token, match) {
    switch (token) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ": // 01, 02, 03, 04
        return (0, _utils.parseNDigits)(token.length, dateString);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return match.ordinalNumber(dateString, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return (
          match.quarter(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.quarter(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );

      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return match.quarter(dateString, {
          width: "narrow",
          context: "formatting",
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return (
          match.quarter(dateString, {
            width: "wide",
            context: "formatting",
          }) ||
          match.quarter(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.quarter(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 4;
  }

  set(date, _flags, value) {
    date.setMonth((value - 1) * 3, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];
}
exports.QuarterParser = QuarterParser;


/***/ }),

/***/ 99913:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.SecondParser = void 0;
var _constants = __webpack_require__(34320);
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

class SecondParser extends _Parser.Parser {
  priority = 50;

  parse(dateString, token, match) {
    switch (token) {
      case "s":
        return (0, _utils.parseNumericPattern)(
          _constants.numericPatterns.second,
          dateString,
        );
      case "so":
        return match.ordinalNumber(dateString, { unit: "second" });
      default:
        return (0, _utils.parseNDigits)(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 59;
  }

  set(date, _flags, value) {
    date.setSeconds(value, 0);
    return date;
  }

  incompatibleTokens = ["t", "T"];
}
exports.SecondParser = SecondParser;


/***/ }),

/***/ 68228:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.StandAloneLocalDayParser = void 0;
var _index = __webpack_require__(37576);
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

// Stand-alone local day of week
class StandAloneLocalDayParser extends _Parser.Parser {
  priority = 90;

  parse(dateString, token, match, options) {
    const valueCallback = (value) => {
      // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
      const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
      return ((value + options.weekStartsOn + 6) % 7) + wholeWeekDays;
    };

    switch (token) {
      // 3
      case "c":
      case "cc": // 03
        return (0, _utils.mapValue)(
          (0, _utils.parseNDigits)(token.length, dateString),
          valueCallback,
        );
      // 3rd
      case "co":
        return (0, _utils.mapValue)(
          match.ordinalNumber(dateString, {
            unit: "day",
          }),
          valueCallback,
        );
      // Tue
      case "ccc":
        return (
          match.day(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.day(dateString, { width: "short", context: "standalone" }) ||
          match.day(dateString, { width: "narrow", context: "standalone" })
        );

      // T
      case "ccccc":
        return match.day(dateString, {
          width: "narrow",
          context: "standalone",
        });
      // Tu
      case "cccccc":
        return (
          match.day(dateString, { width: "short", context: "standalone" }) ||
          match.day(dateString, { width: "narrow", context: "standalone" })
        );

      // Tuesday
      case "cccc":
      default:
        return (
          match.day(dateString, { width: "wide", context: "standalone" }) ||
          match.day(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.day(dateString, { width: "short", context: "standalone" }) ||
          match.day(dateString, { width: "narrow", context: "standalone" })
        );
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 6;
  }

  set(date, _flags, value, options) {
    date = (0, _index.setDay)(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "e",
    "t",
    "T",
  ];
}
exports.StandAloneLocalDayParser = StandAloneLocalDayParser;


/***/ }),

/***/ 66874:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.StandAloneMonthParser = void 0;
var _constants = __webpack_require__(34320);
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

class StandAloneMonthParser extends _Parser.Parser {
  priority = 110;

  parse(dateString, token, match) {
    const valueCallback = (value) => value - 1;

    switch (token) {
      // 1, 2, ..., 12
      case "L":
        return (0, _utils.mapValue)(
          (0, _utils.parseNumericPattern)(
            _constants.numericPatterns.month,
            dateString,
          ),
          valueCallback,
        );
      // 01, 02, ..., 12
      case "LL":
        return (0, _utils.mapValue)(
          (0, _utils.parseNDigits)(2, dateString),
          valueCallback,
        );
      // 1st, 2nd, ..., 12th
      case "Lo":
        return (0, _utils.mapValue)(
          match.ordinalNumber(dateString, {
            unit: "month",
          }),
          valueCallback,
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return (
          match.month(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.month(dateString, { width: "narrow", context: "standalone" })
        );

      // J, F, ..., D
      case "LLLLL":
        return match.month(dateString, {
          width: "narrow",
          context: "standalone",
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return (
          match.month(dateString, { width: "wide", context: "standalone" }) ||
          match.month(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.month(dateString, { width: "narrow", context: "standalone" })
        );
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 11;
  }

  set(date, _flags, value) {
    date.setMonth(value, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];
}
exports.StandAloneMonthParser = StandAloneMonthParser;


/***/ }),

/***/ 97670:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.StandAloneQuarterParser = void 0;
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

class StandAloneQuarterParser extends _Parser.Parser {
  priority = 120;

  parse(dateString, token, match) {
    switch (token) {
      // 1, 2, 3, 4
      case "q":
      case "qq": // 01, 02, 03, 04
        return (0, _utils.parseNDigits)(token.length, dateString);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return match.ordinalNumber(dateString, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return (
          match.quarter(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.quarter(dateString, {
            width: "narrow",
            context: "standalone",
          })
        );

      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return match.quarter(dateString, {
          width: "narrow",
          context: "standalone",
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return (
          match.quarter(dateString, {
            width: "wide",
            context: "standalone",
          }) ||
          match.quarter(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.quarter(dateString, {
            width: "narrow",
            context: "standalone",
          })
        );
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 4;
  }

  set(date, _flags, value) {
    date.setMonth((value - 1) * 3, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "Y",
    "R",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];
}
exports.StandAloneQuarterParser = StandAloneQuarterParser;


/***/ }),

/***/ 92097:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.TimestampMillisecondsParser = void 0;
var _index = __webpack_require__(78197);
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

class TimestampMillisecondsParser extends _Parser.Parser {
  priority = 20;

  parse(dateString) {
    return (0, _utils.parseAnyDigitsSigned)(dateString);
  }

  set(date, _flags, value) {
    return [(0, _index.constructFrom)(date, value), { timestampIsSet: true }];
  }

  incompatibleTokens = "*";
}
exports.TimestampMillisecondsParser = TimestampMillisecondsParser;


/***/ }),

/***/ 36650:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.TimestampSecondsParser = void 0;
var _index = __webpack_require__(78197);
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

class TimestampSecondsParser extends _Parser.Parser {
  priority = 40;

  parse(dateString) {
    return (0, _utils.parseAnyDigitsSigned)(dateString);
  }

  set(date, _flags, value) {
    return [
      (0, _index.constructFrom)(date, value * 1000),
      { timestampIsSet: true },
    ];
  }

  incompatibleTokens = "*";
}
exports.TimestampSecondsParser = TimestampSecondsParser;


/***/ }),

/***/ 39656:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.YearParser = void 0;
var _Parser = __webpack_require__(22427);

var _utils = __webpack_require__(40287);

// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
class YearParser extends _Parser.Parser {
  priority = 130;
  incompatibleTokens = ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"];

  parse(dateString, token, match) {
    const valueCallback = (year) => ({
      year,
      isTwoDigitYear: token === "yy",
    });

    switch (token) {
      case "y":
        return (0, _utils.mapValue)(
          (0, _utils.parseNDigits)(4, dateString),
          valueCallback,
        );
      case "yo":
        return (0, _utils.mapValue)(
          match.ordinalNumber(dateString, {
            unit: "year",
          }),
          valueCallback,
        );
      default:
        return (0, _utils.mapValue)(
          (0, _utils.parseNDigits)(token.length, dateString),
          valueCallback,
        );
    }
  }

  validate(_date, value) {
    return value.isTwoDigitYear || value.year > 0;
  }

  set(date, flags, value) {
    const currentYear = date.getFullYear();

    if (value.isTwoDigitYear) {
      const normalizedTwoDigitYear = (0, _utils.normalizeTwoDigitYear)(
        value.year,
        currentYear,
      );
      date.setFullYear(normalizedTwoDigitYear, 0, 1);
      date.setHours(0, 0, 0, 0);
      return date;
    }

    const year =
      !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
    date.setFullYear(year, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
exports.YearParser = YearParser;


/***/ }),

/***/ 40287:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.dayPeriodEnumToHours = dayPeriodEnumToHours;
exports.isLeapYearIndex = isLeapYearIndex;
exports.mapValue = mapValue;
exports.normalizeTwoDigitYear = normalizeTwoDigitYear;
exports.parseAnyDigitsSigned = parseAnyDigitsSigned;
exports.parseNDigits = parseNDigits;
exports.parseNDigitsSigned = parseNDigitsSigned;
exports.parseNumericPattern = parseNumericPattern;
exports.parseTimezonePattern = parseTimezonePattern;
var _index = __webpack_require__(50615);

var _constants = __webpack_require__(34320);

function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }

  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest,
  };
}

function parseNumericPattern(pattern, dateString) {
  const matchResult = dateString.match(pattern);

  if (!matchResult) {
    return null;
  }

  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length),
  };
}

function parseTimezonePattern(pattern, dateString) {
  const matchResult = dateString.match(pattern);

  if (!matchResult) {
    return null;
  }

  // Input is 'Z'
  if (matchResult[0] === "Z") {
    return {
      value: 0,
      rest: dateString.slice(1),
    };
  }

  const sign = matchResult[1] === "+" ? 1 : -1;
  const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;

  return {
    value:
      sign *
      (hours * _index.millisecondsInHour +
        minutes * _index.millisecondsInMinute +
        seconds * _index.millisecondsInSecond),
    rest: dateString.slice(matchResult[0].length),
  };
}

function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(
    _constants.numericPatterns.anyDigitsSigned,
    dateString,
  );
}

function parseNDigits(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(
        _constants.numericPatterns.singleDigit,
        dateString,
      );
    case 2:
      return parseNumericPattern(
        _constants.numericPatterns.twoDigits,
        dateString,
      );
    case 3:
      return parseNumericPattern(
        _constants.numericPatterns.threeDigits,
        dateString,
      );
    case 4:
      return parseNumericPattern(
        _constants.numericPatterns.fourDigits,
        dateString,
      );
    default:
      return parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
  }
}

function parseNDigitsSigned(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(
        _constants.numericPatterns.singleDigitSigned,
        dateString,
      );
    case 2:
      return parseNumericPattern(
        _constants.numericPatterns.twoDigitsSigned,
        dateString,
      );
    case 3:
      return parseNumericPattern(
        _constants.numericPatterns.threeDigitsSigned,
        dateString,
      );
    case 4:
      return parseNumericPattern(
        _constants.numericPatterns.fourDigitsSigned,
        dateString,
      );
    default:
      return parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
  }
}

function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}

function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  const isCommonEra = currentYear > 0;
  // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC
  const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;

  let result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    const rangeEnd = absCurrentYear + 50;
    const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
    const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result;
}

function isLeapYearIndex(year) {
  return year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0);
}


/***/ }),

/***/ 29681:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.parseISO = parseISO;
var _index = __webpack_require__(50615);

/**
 * The {@link parseISO} function options.
 */

/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 * @param options - An object with options
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */
function parseISO(argument, options) {
  const additionalDigits = options?.additionalDigits ?? 2;
  const dateStrings = splitDateString(argument);

  let date;
  if (dateStrings.date) {
    const parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }

  const timestamp = date.getTime();
  let time = 0;
  let offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);
    if (isNaN(time)) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);
    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    const dirtyDate = new Date(timestamp + time);
    // JS parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.
    const result = new Date(0);
    result.setFullYear(
      dirtyDate.getUTCFullYear(),
      dirtyDate.getUTCMonth(),
      dirtyDate.getUTCDate(),
    );
    result.setHours(
      dirtyDate.getUTCHours(),
      dirtyDate.getUTCMinutes(),
      dirtyDate.getUTCSeconds(),
      dirtyDate.getUTCMilliseconds(),
    );
    return result;
  }

  return new Date(timestamp + time + offset);
}

const patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/,
};

const dateRegex =
  /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const timeRegex =
  /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;

function splitDateString(dateString) {
  const dateStrings = {};
  const array = dateString.split(patterns.dateTimeDelimiter);
  let timeString;

  // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].
  if (array.length > 2) {
    return dateStrings;
  }

  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(
        dateStrings.date.length,
        dateString.length,
      );
    }
  }

  if (timeString) {
    const token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], "");
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  const regex = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" +
      (4 + additionalDigits) +
      "})|(\\d{2}|[+-]\\d{" +
      (2 + additionalDigits) +
      "})$)",
  );

  const captures = dateString.match(regex);
  // Invalid ISO-formatted year
  if (!captures) return { year: NaN, restDateString: "" };

  const year = captures[1] ? parseInt(captures[1]) : null;
  const century = captures[2] ? parseInt(captures[2]) : null;

  // either year or century is null, not both
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length),
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);

  const captures = dateString.match(dateRegex);
  // Invalid ISO-formatted string
  if (!captures) return new Date(NaN);

  const isWeekDate = !!captures[4];
  const dayOfYear = parseDateUnit(captures[1]);
  const month = parseDateUnit(captures[2]) - 1;
  const day = parseDateUnit(captures[3]);
  const week = parseDateUnit(captures[4]);
  const dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    const date = new Date(0);
    if (
      !validateDate(year, month, day) ||
      !validateDayOfYearDate(year, dayOfYear)
    ) {
      return new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  const captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  const hours = parseTimeUnit(captures[1]);
  const minutes = parseTimeUnit(captures[2]);
  const seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return (
    hours * _index.millisecondsInHour +
    minutes * _index.millisecondsInMinute +
    seconds * 1000
  );
}

function parseTimeUnit(value) {
  return (value && parseFloat(value.replace(",", "."))) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === "Z") return 0;

  const captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;

  const sign = captures[1] === "+" ? -1 : 1;
  const hours = parseInt(captures[2]);
  const minutes = (captures[3] && parseInt(captures[3])) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return (
    sign *
    (hours * _index.millisecondsInHour + minutes * _index.millisecondsInMinute)
  );
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  const date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  const fourthOfJanuaryDay = date.getUTCDay() || 7;
  const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// Validation functions

// February is null to handle the leap year (using ||)
const daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0);
}

function validateDate(year, month, date) {
  return (
    month >= 0 &&
    month <= 11 &&
    date >= 1 &&
    date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28))
  );
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return (
    seconds >= 0 &&
    seconds < 60 &&
    minutes >= 0 &&
    minutes < 60 &&
    hours >= 0 &&
    hours < 25
  );
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}


/***/ }),

/***/ 19229:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.set = set;
var _index = __webpack_require__(78197);
var _index2 = __webpack_require__(22771);
var _index3 = __webpack_require__(44013);

/**
 * @name set
 * @category Common Helpers
 * @summary Set date values to a given date.
 *
 * @description
 * Set date values to a given date.
 *
 * Sets time values to date from object `values`.
 * A value is not set if it is undefined or null or doesn't exist in `values`.
 *
 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
 * to use native `Date#setX` methods. If you use this function, you may not want to include the
 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param values - The date values to be set
 *
 * @returns The new date with options set
 *
 * @example
 * // Transform 1 September 2014 into 20 October 2015 in a single line:
 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
 * //=> Tue Oct 20 2015 00:00:00
 *
 * @example
 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
 * //=> Mon Sep 01 2014 12:23:45
 */

function set(date, values) {
  let _date = (0, _index3.toDate)(date);

  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
  if (isNaN(+_date)) {
    return (0, _index.constructFrom)(date, NaN);
  }

  if (values.year != null) {
    _date.setFullYear(values.year);
  }

  if (values.month != null) {
    _date = (0, _index2.setMonth)(_date, values.month);
  }

  if (values.date != null) {
    _date.setDate(values.date);
  }

  if (values.hours != null) {
    _date.setHours(values.hours);
  }

  if (values.minutes != null) {
    _date.setMinutes(values.minutes);
  }

  if (values.seconds != null) {
    _date.setSeconds(values.seconds);
  }

  if (values.milliseconds != null) {
    _date.setMilliseconds(values.milliseconds);
  }

  return _date;
}


/***/ }),

/***/ 37576:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.setDay = setDay;
var _index = __webpack_require__(6716);
var _index2 = __webpack_require__(44013);

var _index3 = __webpack_require__(67845);

/**
 * The {@link setDay} function options.
 */

/**
 * @name setDay
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the week of the new date
 * @param options - An object with options.
 *
 * @returns The new date with the day of the week set
 *
 * @example
 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
 * const result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Set week day to Sunday, with a weekStartsOn of Monday:
 * const result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */
function setDay(date, day, options) {
  const defaultOptions = (0, _index3.getDefaultOptions)();
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const _date = (0, _index2.toDate)(date);
  const currentDay = _date.getDay();

  const remainder = day % 7;
  const dayIndex = (remainder + 7) % 7;

  const delta = 7 - weekStartsOn;
  const diff =
    day < 0 || day > 6
      ? day - ((currentDay + delta) % 7)
      : ((dayIndex + delta) % 7) - ((currentDay + delta) % 7);
  return (0, _index.addDays)(_date, diff);
}


/***/ }),

/***/ 96884:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.setHours = setHours;
var _index = __webpack_require__(44013);

/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param hours - The hours of the new date
 *
 * @returns The new date with the hours set
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */
function setHours(date, hours) {
  const _date = (0, _index.toDate)(date);
  _date.setHours(hours);
  return _date;
}


/***/ }),

/***/ 40493:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.setISODay = setISODay;
var _index = __webpack_require__(6716);
var _index2 = __webpack_require__(30);
var _index3 = __webpack_require__(44013);

/**
 * @name setISODay
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the ISO week of the new date
 *
 * @returns The new date with the day of the ISO week set
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * const result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */
function setISODay(date, day) {
  const _date = (0, _index3.toDate)(date);
  const currentDay = (0, _index2.getISODay)(_date);
  const diff = day - currentDay;
  return (0, _index.addDays)(_date, diff);
}


/***/ }),

/***/ 28322:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.setISOWeek = setISOWeek;
var _index = __webpack_require__(2169);
var _index2 = __webpack_require__(44013);

/**
 * @name setISOWeek
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The ISO week of the new date
 *
 * @returns The new date with the ISO week set
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * const result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */
function setISOWeek(date, week) {
  const _date = (0, _index2.toDate)(date);
  const diff = (0, _index.getISOWeek)(_date) - week;
  _date.setDate(_date.getDate() - diff * 7);
  return _date;
}


/***/ }),

/***/ 54174:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.setMinutes = setMinutes;
var _index = __webpack_require__(44013);

/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param minutes - The minutes of the new date
 *
 * @returns The new date with the minutes set
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */
function setMinutes(date, minutes) {
  const _date = (0, _index.toDate)(date);
  _date.setMinutes(minutes);
  return _date;
}


/***/ }),

/***/ 22771:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.setMonth = setMonth;
var _index = __webpack_require__(78197);
var _index2 = __webpack_require__(7260);
var _index3 = __webpack_require__(44013);

/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param month - The month of the new date
 *
 * @returns The new date with the month set
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth(date, month) {
  const _date = (0, _index3.toDate)(date);
  const year = _date.getFullYear();
  const day = _date.getDate();

  const dateWithDesiredMonth = (0, _index.constructFrom)(date, 0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  const daysInMonth = (0, _index2.getDaysInMonth)(dateWithDesiredMonth);
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  _date.setMonth(month, Math.min(day, daysInMonth));
  return _date;
}


/***/ }),

/***/ 6520:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.setQuarter = setQuarter;
var _index = __webpack_require__(22771);
var _index2 = __webpack_require__(44013);

/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param quarter - The quarter of the new date
 *
 * @returns The new date with the quarter set
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */
function setQuarter(date, quarter) {
  const _date = (0, _index2.toDate)(date);
  const oldQuarter = Math.trunc(_date.getMonth() / 3) + 1;
  const diff = quarter - oldQuarter;
  return (0, _index.setMonth)(_date, _date.getMonth() + diff * 3);
}


/***/ }),

/***/ 64932:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.setSeconds = setSeconds;
var _index = __webpack_require__(44013);

/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param seconds - The seconds of the new date
 *
 * @returns The new date with the seconds set
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */
function setSeconds(date, seconds) {
  const _date = (0, _index.toDate)(date);
  _date.setSeconds(seconds);
  return _date;
}


/***/ }),

/***/ 40749:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.setWeek = setWeek;
var _index = __webpack_require__(68483);
var _index2 = __webpack_require__(44013);

/**
 * The {@link setWeek} function options.
 */

/**
 * @name setWeek
 * @category Week Helpers
 * @summary Set the local week to the given date.
 *
 * @description
 * Set the local week to the given date, saving the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The week of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week set
 *
 * @example
 * // Set the 1st week to 2 January 2005 with default options:
 * const result = setWeek(new Date(2005, 0, 2), 1)
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // Set the 1st week to 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January:
 * const result = setWeek(new Date(2005, 0, 2), 1, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sun Jan 4 2004 00:00:00
 */
function setWeek(date, week, options) {
  const _date = (0, _index2.toDate)(date);
  const diff = (0, _index.getWeek)(_date, options) - week;
  _date.setDate(_date.getDate() - diff * 7);
  return _date;
}


/***/ }),

/***/ 41999:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.setYear = setYear;
var _index = __webpack_require__(78197);
var _index2 = __webpack_require__(44013);

/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param year - The year of the new date
 *
 * @returns The new date with the year set
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear(date, year) {
  const _date = (0, _index2.toDate)(date);

  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
  if (isNaN(+_date)) {
    return (0, _index.constructFrom)(date, NaN);
  }

  _date.setFullYear(year);
  return _date;
}


/***/ }),

/***/ 57095:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.startOfDay = startOfDay;
var _index = __webpack_require__(44013);

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(date) {
  const _date = (0, _index.toDate)(date);
  _date.setHours(0, 0, 0, 0);
  return _date;
}


/***/ }),

/***/ 84822:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.startOfISOWeek = startOfISOWeek;
var _index = __webpack_require__(18941);

/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek(date) {
  return (0, _index.startOfWeek)(date, { weekStartsOn: 1 });
}


/***/ }),

/***/ 34734:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.startOfISOWeekYear = startOfISOWeekYear;
var _index = __webpack_require__(74551);
var _index2 = __webpack_require__(84822);
var _index3 = __webpack_require__(78197);

/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOWeekYear(date) {
  const year = (0, _index.getISOWeekYear)(date);
  const fourthOfJanuary = (0, _index3.constructFrom)(date, 0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  return (0, _index2.startOfISOWeek)(fourthOfJanuary);
}


/***/ }),

/***/ 64998:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.startOfMonth = startOfMonth;
var _index = __webpack_require__(44013);

/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth(date) {
  const _date = (0, _index.toDate)(date);
  _date.setDate(1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}


/***/ }),

/***/ 1742:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.startOfQuarter = startOfQuarter;
var _index = __webpack_require__(44013);

/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */
function startOfQuarter(date) {
  const _date = (0, _index.toDate)(date);
  const currentMonth = _date.getMonth();
  const month = currentMonth - (currentMonth % 3);
  _date.setMonth(month, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}


/***/ }),

/***/ 18941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.startOfWeek = startOfWeek;
var _index = __webpack_require__(44013);

var _index2 = __webpack_require__(67845);

/**
 * The {@link startOfWeek} function options.
 */

/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek(date, options) {
  const defaultOptions = (0, _index2.getDefaultOptions)();
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const _date = (0, _index.toDate)(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;

  _date.setDate(_date.getDate() - diff);
  _date.setHours(0, 0, 0, 0);
  return _date;
}


/***/ }),

/***/ 85696:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.startOfWeekYear = startOfWeekYear;
var _index = __webpack_require__(78197);
var _index2 = __webpack_require__(3570);
var _index3 = __webpack_require__(18941);

var _index4 = __webpack_require__(67845);

/**
 * The {@link startOfWeekYear} function options.
 */

/**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfWeekYear(date, options) {
  const defaultOptions = (0, _index4.getDefaultOptions)();
  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const year = (0, _index2.getWeekYear)(date, options);
  const firstWeek = (0, _index.constructFrom)(date, 0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  const _date = (0, _index3.startOfWeek)(firstWeek, options);
  return _date;
}


/***/ }),

/***/ 2764:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.startOfYear = startOfYear;
var _index = __webpack_require__(44013);
var _index2 = __webpack_require__(78197);

/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear(date) {
  const cleanDate = (0, _index.toDate)(date);
  const _date = (0, _index2.constructFrom)(date, 0);
  _date.setFullYear(cleanDate.getFullYear(), 0, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}


/***/ }),

/***/ 20885:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.subDays = subDays;
var _index = __webpack_require__(6716);

/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be subtracted.
 *
 * @returns The new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays(date, amount) {
  return (0, _index.addDays)(date, -amount);
}


/***/ }),

/***/ 11265:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.subMonths = subMonths;
var _index = __webpack_require__(3580);

/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be subtracted.
 *
 * @returns The new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths(date, amount) {
  return (0, _index.addMonths)(date, -amount);
}


/***/ }),

/***/ 43313:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.subQuarters = subQuarters;
var _index = __webpack_require__(3128);

/**
 * @name subQuarters
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be subtracted.
 *
 * @returns The new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * const result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */
function subQuarters(date, amount) {
  return (0, _index.addQuarters)(date, -amount);
}


/***/ }),

/***/ 58083:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.subWeeks = subWeeks;
var _index = __webpack_require__(23567);

/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be subtracted.
 *
 * @returns The new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */
function subWeeks(date, amount) {
  return (0, _index.addWeeks)(date, -amount);
}


/***/ }),

/***/ 18976:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.subYears = subYears;
var _index = __webpack_require__(38882);

/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be subtracted.
 *
 * @returns The new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */
function subYears(date, amount) {
  return (0, _index.addYears)(date, -amount);
}


/***/ }),

/***/ 44013:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.toDate = toDate;

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  const argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (
    argument instanceof Date ||
    (typeof argument === "object" && argStr === "[object Date]")
  ) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
  } else if (
    typeof argument === "number" ||
    argStr === "[object Number]" ||
    typeof argument === "string" ||
    argStr === "[object String]"
  ) {
    // TODO: Can we get rid of as?
    return new Date(argument);
  } else {
    // TODO: Can we get rid of as?
    return new Date(NaN);
  }
}


/***/ }),

/***/ 35298:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.transpose = transpose;
var _index = __webpack_require__(78197);

/**
 * @name transpose
 * @category Generic Helpers
 * @summary Transpose the date to the given constructor.
 *
 * @description
 * The function transposes the date to the given constructor. It helps you
 * to transpose the date in the system time zone to say `UTCDate` or any other
 * date extension.
 *
 * @typeParam DateInputType - The input `Date` type derived from the passed argument.
 * @typeParam DateOutputType - The output `Date` type derived from the passed constructor.
 *
 * @param fromDate - The date to use values from
 * @param constructor - The date constructor to use
 *
 * @returns Date transposed to the given constructor
 *
 * @example
 * // Create July 10, 2022 00:00 in locale time zone
 * const date = new Date(2022, 6, 10)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0800 (Singapore Standard Time)'
 *
 * @example
 * // Transpose the date to July 10, 2022 00:00 in UTC
 * transpose(date, UTCDate)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0000 (Coordinated Universal Time)'
 */
function transpose(fromDate, constructor) {
  const date =
    constructor instanceof Date
      ? (0, _index.constructFrom)(constructor, 0)
      : new constructor(0);
  date.setFullYear(
    fromDate.getFullYear(),
    fromDate.getMonth(),
    fromDate.getDate(),
  );
  date.setHours(
    fromDate.getHours(),
    fromDate.getMinutes(),
    fromDate.getSeconds(),
    fromDate.getMilliseconds(),
  );
  return date;
}


/***/ }),

/***/ 85518:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(67294);
var React__default = _interopDefault(React);

var UAParser = __webpack_require__(23451);

var ClientUAInstance = new UAParser();
var browser = ClientUAInstance.getBrowser();
var cpu = ClientUAInstance.getCPU();
var device = ClientUAInstance.getDevice();
var engine = ClientUAInstance.getEngine();
var os = ClientUAInstance.getOS();
var ua = ClientUAInstance.getUA();
var setUa = function setUa(userAgentString) {
  return ClientUAInstance.setUA(userAgentString);
};
var parseUserAgent = function parseUserAgent(userAgent) {
  if (!userAgent) {
    console.error('No userAgent string was provided');
    return;
  }

  var UserAgentInstance = new UAParser(userAgent);
  return {
    UA: UserAgentInstance,
    browser: UserAgentInstance.getBrowser(),
    cpu: UserAgentInstance.getCPU(),
    device: UserAgentInstance.getDevice(),
    engine: UserAgentInstance.getEngine(),
    os: UserAgentInstance.getOS(),
    ua: UserAgentInstance.getUA(),
    setUserAgent: function setUserAgent(userAgentString) {
      return UserAgentInstance.setUA(userAgentString);
    }
  };
};

var UAHelper = /*#__PURE__*/Object.freeze({
  ClientUAInstance: ClientUAInstance,
  browser: browser,
  cpu: cpu,
  device: device,
  engine: engine,
  os: os,
  ua: ua,
  setUa: setUa,
  parseUserAgent: parseUserAgent
});

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var DeviceTypes = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  SmartTv: 'smarttv',
  Console: 'console',
  Wearable: 'wearable',
  Embedded: 'embedded',
  Browser: undefined
};
var BrowserTypes = {
  Chrome: 'Chrome',
  Firefox: 'Firefox',
  Opera: 'Opera',
  Yandex: 'Yandex',
  Safari: 'Safari',
  InternetExplorer: 'Internet Explorer',
  Edge: 'Edge',
  Chromium: 'Chromium',
  Ie: 'IE',
  MobileSafari: 'Mobile Safari',
  EdgeChromium: 'Edge Chromium',
  MIUI: 'MIUI Browser',
  SamsungBrowser: 'Samsung Browser'
};
var OsTypes = {
  IOS: 'iOS',
  Android: 'Android',
  WindowsPhone: 'Windows Phone',
  Windows: 'Windows',
  MAC_OS: 'Mac OS'
};
var InitialDeviceTypes = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};

var checkDeviceType = function checkDeviceType(type) {
  switch (type) {
    case DeviceTypes.Mobile:
      return {
        isMobile: true
      };

    case DeviceTypes.Tablet:
      return {
        isTablet: true
      };

    case DeviceTypes.SmartTv:
      return {
        isSmartTV: true
      };

    case DeviceTypes.Console:
      return {
        isConsole: true
      };

    case DeviceTypes.Wearable:
      return {
        isWearable: true
      };

    case DeviceTypes.Browser:
      return {
        isBrowser: true
      };

    case DeviceTypes.Embedded:
      return {
        isEmbedded: true
      };

    default:
      return InitialDeviceTypes;
  }
};
var setUserAgent = function setUserAgent(userAgent) {
  return setUa(userAgent);
};
var setDefaults = function setDefaults(p) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
  return p ? p : d;
};
var getNavigatorInstance = function getNavigatorInstance() {
  if (typeof window !== 'undefined') {
    if (window.navigator || navigator) {
      return window.navigator || navigator;
    }
  }

  return false;
};
var isIOS13Check = function isIOS13Check(type) {
  var nav = getNavigatorInstance();
  return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};

var browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: setDefaults(browser.major),
    browserFullVersion: setDefaults(browser.version),
    browserName: setDefaults(browser.name),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var mobilePayload = function mobilePayload(type, device, os, ua) {
  return _objectSpread2({}, type, {
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    os: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    ua: setDefaults(ua)
  });
};
var smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
  return {
    isEmbedded: isEmbedded,
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};

function deviceDetect(userAgent) {
  var _ref = userAgent ? parseUserAgent(userAgent) : UAHelper,
      device = _ref.device,
      browser = _ref.browser,
      engine = _ref.engine,
      os = _ref.os,
      ua = _ref.ua;

  var type = checkDeviceType(device.type);
  var isBrowser = type.isBrowser,
      isMobile = type.isMobile,
      isTablet = type.isTablet,
      isSmartTV = type.isSmartTV,
      isConsole = type.isConsole,
      isWearable = type.isWearable,
      isEmbedded = type.isEmbedded;

  if (isBrowser) {
    return browserPayload(isBrowser, browser, engine, os, ua);
  }

  if (isSmartTV) {
    return smartTvPayload(isSmartTV, engine, os, ua);
  }

  if (isConsole) {
    return consolePayload(isConsole, engine, os, ua);
  }

  if (isMobile) {
    return mobilePayload(type, device, os, ua);
  }

  if (isTablet) {
    return mobilePayload(type, device, os, ua);
  }

  if (isWearable) {
    return wearablePayload(isWearable, engine, os, ua);
  }

  if (isEmbedded) {
    return embeddedPayload(isEmbedded, device, engine, os, ua);
  }
}

var isMobileType = function isMobileType(_ref) {
  var type = _ref.type;
  return type === DeviceTypes.Mobile;
};
var isTabletType = function isTabletType(_ref2) {
  var type = _ref2.type;
  return type === DeviceTypes.Tablet;
};
var isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
  var type = _ref3.type;
  return type === DeviceTypes.Mobile || type === DeviceTypes.Tablet;
};
var isSmartTVType = function isSmartTVType(_ref4) {
  var type = _ref4.type;
  return type === DeviceTypes.SmartTv;
};
var isBrowserType = function isBrowserType(_ref5) {
  var type = _ref5.type;
  return type === DeviceTypes.Browser;
};
var isWearableType = function isWearableType(_ref6) {
  var type = _ref6.type;
  return type === DeviceTypes.Wearable;
};
var isConsoleType = function isConsoleType(_ref7) {
  var type = _ref7.type;
  return type === DeviceTypes.Console;
};
var isEmbeddedType = function isEmbeddedType(_ref8) {
  var type = _ref8.type;
  return type === DeviceTypes.Embedded;
};
var getMobileVendor = function getMobileVendor(_ref9) {
  var vendor = _ref9.vendor;
  return setDefaults(vendor);
};
var getMobileModel = function getMobileModel(_ref10) {
  var model = _ref10.model;
  return setDefaults(model);
};
var getDeviceType = function getDeviceType(_ref11) {
  var type = _ref11.type;
  return setDefaults(type, 'browser');
}; // os types

var isAndroidType = function isAndroidType(_ref12) {
  var name = _ref12.name;
  return name === OsTypes.Android;
};
var isWindowsType = function isWindowsType(_ref13) {
  var name = _ref13.name;
  return name === OsTypes.Windows;
};
var isMacOsType = function isMacOsType(_ref14) {
  var name = _ref14.name;
  return name === OsTypes.MAC_OS;
};
var isWinPhoneType = function isWinPhoneType(_ref15) {
  var name = _ref15.name;
  return name === OsTypes.WindowsPhone;
};
var isIOSType = function isIOSType(_ref16) {
  var name = _ref16.name;
  return name === OsTypes.IOS;
};
var getOsVersion = function getOsVersion(_ref17) {
  var version = _ref17.version;
  return setDefaults(version);
};
var getOsName = function getOsName(_ref18) {
  var name = _ref18.name;
  return setDefaults(name);
}; // browser types

var isChromeType = function isChromeType(_ref19) {
  var name = _ref19.name;
  return name === BrowserTypes.Chrome;
};
var isFirefoxType = function isFirefoxType(_ref20) {
  var name = _ref20.name;
  return name === BrowserTypes.Firefox;
};
var isChromiumType = function isChromiumType(_ref21) {
  var name = _ref21.name;
  return name === BrowserTypes.Chromium;
};
var isEdgeType = function isEdgeType(_ref22) {
  var name = _ref22.name;
  return name === BrowserTypes.Edge;
};
var isYandexType = function isYandexType(_ref23) {
  var name = _ref23.name;
  return name === BrowserTypes.Yandex;
};
var isSafariType = function isSafariType(_ref24) {
  var name = _ref24.name;
  return name === BrowserTypes.Safari || name === BrowserTypes.MobileSafari;
};
var isMobileSafariType = function isMobileSafariType(_ref25) {
  var name = _ref25.name;
  return name === BrowserTypes.MobileSafari;
};
var isOperaType = function isOperaType(_ref26) {
  var name = _ref26.name;
  return name === BrowserTypes.Opera;
};
var isIEType = function isIEType(_ref27) {
  var name = _ref27.name;
  return name === BrowserTypes.InternetExplorer || name === BrowserTypes.Ie;
};
var isMIUIType = function isMIUIType(_ref28) {
  var name = _ref28.name;
  return name === BrowserTypes.MIUI;
};
var isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
  var name = _ref29.name;
  return name === BrowserTypes.SamsungBrowser;
};
var getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
  var version = _ref30.version;
  return setDefaults(version);
};
var getBrowserVersion = function getBrowserVersion(_ref31) {
  var major = _ref31.major;
  return setDefaults(major);
};
var getBrowserName = function getBrowserName(_ref32) {
  var name = _ref32.name;
  return setDefaults(name);
}; // engine types

var getEngineName = function getEngineName(_ref33) {
  var name = _ref33.name;
  return setDefaults(name);
};
var getEngineVersion = function getEngineVersion(_ref34) {
  var version = _ref34.version;
  return setDefaults(version);
};
var isElectronType = function isElectronType() {
  var nav = getNavigatorInstance();
  var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
  return typeof ua === 'string' ? /electron/.test(ua) : false;
};
var isEdgeChromiumType = function isEdgeChromiumType(ua) {
  return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};
var getIOS13 = function getIOS13() {
  var nav = getNavigatorInstance();
  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};
var getIPad13 = function getIPad13() {
  return isIOS13Check('iPad');
};
var getIphone13 = function getIphone13() {
  return isIOS13Check('iPhone');
};
var getIPod13 = function getIPod13() {
  return isIOS13Check('iPod');
};
var getUseragent = function getUseragent(userAg) {
  return setDefaults(userAg);
};

function buildSelectorsObject(options) {
  var _ref = options ? options : UAHelper,
      device = _ref.device,
      browser = _ref.browser,
      os = _ref.os,
      engine = _ref.engine,
      ua = _ref.ua;

  return {
    isSmartTV: isSmartTVType(device),
    isConsole: isConsoleType(device),
    isWearable: isWearableType(device),
    isEmbedded: isEmbeddedType(device),
    isMobileSafari: isMobileSafariType(browser) || getIPad13(),
    isChromium: isChromiumType(browser),
    isMobile: isMobileAndTabletType(device) || getIPad13(),
    isMobileOnly: isMobileType(device),
    isTablet: isTabletType(device) || getIPad13(),
    isBrowser: isBrowserType(device),
    isDesktop: isBrowserType(device),
    isAndroid: isAndroidType(os),
    isWinPhone: isWinPhoneType(os),
    isIOS: isIOSType(os) || getIPad13(),
    isChrome: isChromeType(browser),
    isFirefox: isFirefoxType(browser),
    isSafari: isSafariType(browser),
    isOpera: isOperaType(browser),
    isIE: isIEType(browser),
    osVersion: getOsVersion(os),
    osName: getOsName(os),
    fullBrowserVersion: getBrowserFullVersion(browser),
    browserVersion: getBrowserVersion(browser),
    browserName: getBrowserName(browser),
    mobileVendor: getMobileVendor(device),
    mobileModel: getMobileModel(device),
    engineName: getEngineName(engine),
    engineVersion: getEngineVersion(engine),
    getUA: getUseragent(ua),
    isEdge: isEdgeType(browser) || isEdgeChromiumType(ua),
    isYandex: isYandexType(browser),
    deviceType: getDeviceType(device),
    isIOS13: getIOS13(),
    isIPad13: getIPad13(),
    isIPhone13: getIphone13(),
    isIPod13: getIPod13(),
    isElectron: isElectronType(),
    isEdgeChromium: isEdgeChromiumType(ua),
    isLegacyEdge: isEdgeType(browser) && !isEdgeChromiumType(ua),
    isWindows: isWindowsType(os),
    isMacOs: isMacOsType(os),
    isMIUI: isMIUIType(browser),
    isSamsungBrowser: isSamsungBrowserType(browser)
  };
}

var isSmartTV = isSmartTVType(device);
var isConsole = isConsoleType(device);
var isWearable = isWearableType(device);
var isEmbedded = isEmbeddedType(device);
var isMobileSafari = isMobileSafariType(browser) || getIPad13();
var isChromium = isChromiumType(browser);
var isMobile = isMobileAndTabletType(device) || getIPad13();
var isMobileOnly = isMobileType(device);
var isTablet = isTabletType(device) || getIPad13();
var isBrowser = isBrowserType(device);
var isDesktop = isBrowserType(device);
var isAndroid = isAndroidType(os);
var isWinPhone = isWinPhoneType(os);
var isIOS = isIOSType(os) || getIPad13();
var isChrome = isChromeType(browser);
var isFirefox = isFirefoxType(browser);
var isSafari = isSafariType(browser);
var isOpera = isOperaType(browser);
var isIE = isIEType(browser);
var osVersion = getOsVersion(os);
var osName = getOsName(os);
var fullBrowserVersion = getBrowserFullVersion(browser);
var browserVersion = getBrowserVersion(browser);
var browserName = getBrowserName(browser);
var mobileVendor = getMobileVendor(device);
var mobileModel = getMobileModel(device);
var engineName = getEngineName(engine);
var engineVersion = getEngineVersion(engine);
var getUA = getUseragent(ua);
var isEdge = isEdgeType(browser) || isEdgeChromiumType(ua);
var isYandex = isYandexType(browser);
var deviceType = getDeviceType(device);
var isIOS13 = getIOS13();
var isIPad13 = getIPad13();
var isIPhone13 = getIphone13();
var isIPod13 = getIPod13();
var isElectron = isElectronType();
var isEdgeChromium = isEdgeChromiumType(ua);
var isLegacyEdge = isEdgeType(browser) && !isEdgeChromiumType(ua);
var isWindows = isWindowsType(os);
var isMacOs = isMacOsType(os);
var isMIUI = isMIUIType(browser);
var isSamsungBrowser = isSamsungBrowserType(browser);
var getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
  if (!userAgent || typeof userAgent !== 'string') {
    console.error('No valid user agent string was provided');
    return;
  }

  var _UAHelper$parseUserAg = parseUserAgent(userAgent),
      device = _UAHelper$parseUserAg.device,
      browser = _UAHelper$parseUserAg.browser,
      os = _UAHelper$parseUserAg.os,
      engine = _UAHelper$parseUserAg.engine,
      ua = _UAHelper$parseUserAg.ua;

  return buildSelectorsObject({
    device: device,
    browser: browser,
    os: os,
    engine: engine,
    ua: ua
  });
};

var AndroidView = function AndroidView(_ref) {
  var renderWithFragment = _ref.renderWithFragment,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["renderWithFragment", "children"]);

  return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var BrowserView = function BrowserView(_ref2) {
  var renderWithFragment = _ref2.renderWithFragment,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["renderWithFragment", "children"]);

  return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var IEView = function IEView(_ref3) {
  var renderWithFragment = _ref3.renderWithFragment,
      children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["renderWithFragment", "children"]);

  return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var IOSView = function IOSView(_ref4) {
  var renderWithFragment = _ref4.renderWithFragment,
      children = _ref4.children,
      props = _objectWithoutProperties(_ref4, ["renderWithFragment", "children"]);

  return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var MobileView = function MobileView(_ref5) {
  var renderWithFragment = _ref5.renderWithFragment,
      children = _ref5.children,
      props = _objectWithoutProperties(_ref5, ["renderWithFragment", "children"]);

  return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var TabletView = function TabletView(_ref6) {
  var renderWithFragment = _ref6.renderWithFragment,
      children = _ref6.children,
      props = _objectWithoutProperties(_ref6, ["renderWithFragment", "children"]);

  return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var WinPhoneView = function WinPhoneView(_ref7) {
  var renderWithFragment = _ref7.renderWithFragment,
      children = _ref7.children,
      props = _objectWithoutProperties(_ref7, ["renderWithFragment", "children"]);

  return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var MobileOnlyView = function MobileOnlyView(_ref8) {
  var renderWithFragment = _ref8.renderWithFragment,
      children = _ref8.children,
      viewClassName = _ref8.viewClassName,
      style = _ref8.style,
      props = _objectWithoutProperties(_ref8, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var SmartTVView = function SmartTVView(_ref9) {
  var renderWithFragment = _ref9.renderWithFragment,
      children = _ref9.children,
      props = _objectWithoutProperties(_ref9, ["renderWithFragment", "children"]);

  return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var ConsoleView = function ConsoleView(_ref10) {
  var renderWithFragment = _ref10.renderWithFragment,
      children = _ref10.children,
      props = _objectWithoutProperties(_ref10, ["renderWithFragment", "children"]);

  return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var WearableView = function WearableView(_ref11) {
  var renderWithFragment = _ref11.renderWithFragment,
      children = _ref11.children,
      props = _objectWithoutProperties(_ref11, ["renderWithFragment", "children"]);

  return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var CustomView = function CustomView(_ref12) {
  var renderWithFragment = _ref12.renderWithFragment,
      children = _ref12.children,
      viewClassName = _ref12.viewClassName,
      style = _ref12.style,
      condition = _ref12.condition,
      props = _objectWithoutProperties(_ref12, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);

  return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};

function withOrientationChange(WrappedComponent) {
  return /*#__PURE__*/function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
      _this.isEventListenerAdded = false;
      _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
      _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
      _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
      _this.state = {
        isLandscape: false,
        isPortrait: false
      };
      return _this;
    }

    _createClass(_class, [{
      key: "handleOrientationChange",
      value: function handleOrientationChange() {
        if (!this.isEventListenerAdded) {
          this.isEventListenerAdded = true;
        }

        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        this.setState({
          isPortrait: orientation === 0,
          isLandscape: orientation === 90
        });
      }
    }, {
      key: "onOrientationChange",
      value: function onOrientationChange() {
        this.handleOrientationChange();
      }
    }, {
      key: "onPageLoad",
      value: function onPageLoad() {
        this.handleOrientationChange();
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
          if (!this.isEventListenerAdded) {
            this.handleOrientationChange();
            window.addEventListener("load", this.onPageLoad, false);
          } else {
            window.removeEventListener("load", this.onPageLoad, false);
          }

          window.addEventListener("resize", this.onOrientationChange, false);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.removeEventListener("resize", this.onOrientationChange, false);
      }
    }, {
      key: "render",
      value: function render() {
        return React__default.createElement(WrappedComponent, _extends({}, this.props, {
          isLandscape: this.state.isLandscape,
          isPortrait: this.state.isPortrait
        }));
      }
    }]);

    return _class;
  }(React__default.Component);
}

function useMobileOrientation() {
  var _useState = React.useState(function () {
    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
    return {
      isPortrait: orientation === 0,
      isLandscape: orientation === 90,
      orientation: orientation === 0 ? 'portrait' : 'landscape'
    };
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var handleOrientationChange = React.useCallback(function () {
    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
    var next = {
      isPortrait: orientation === 0,
      isLandscape: orientation === 90,
      orientation: orientation === 0 ? 'portrait' : 'landscape'
    };
    state.orientation !== next.orientation && setState(next);
  }, [state.orientation]);
  React.useEffect(function () {
    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
      handleOrientationChange();
      window.addEventListener("load", handleOrientationChange, false);
      window.addEventListener("resize", handleOrientationChange, false);
    }

    return function () {
      window.removeEventListener("resize", handleOrientationChange, false);
      window.removeEventListener("load", handleOrientationChange, false);
    };
  }, [handleOrientationChange]);
  return state;
}

function useDeviceData(userAgent) {
  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
  return parseUserAgent(hookUserAgent);
}

function useDeviceSelectors(userAgent) {
  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
  var deviceData = useDeviceData(hookUserAgent);
  var selectors = buildSelectorsObject(deviceData);
  return [selectors, deviceData];
}

__webpack_unused_export__ = AndroidView;
__webpack_unused_export__ = BrowserTypes;
__webpack_unused_export__ = BrowserView;
__webpack_unused_export__ = ConsoleView;
__webpack_unused_export__ = CustomView;
__webpack_unused_export__ = IEView;
__webpack_unused_export__ = IOSView;
__webpack_unused_export__ = MobileOnlyView;
__webpack_unused_export__ = MobileView;
__webpack_unused_export__ = OsTypes;
__webpack_unused_export__ = SmartTVView;
__webpack_unused_export__ = TabletView;
__webpack_unused_export__ = WearableView;
__webpack_unused_export__ = WinPhoneView;
__webpack_unused_export__ = browserName;
__webpack_unused_export__ = browserVersion;
__webpack_unused_export__ = deviceDetect;
__webpack_unused_export__ = deviceType;
__webpack_unused_export__ = engineName;
__webpack_unused_export__ = engineVersion;
__webpack_unused_export__ = fullBrowserVersion;
__webpack_unused_export__ = getSelectorsByUserAgent;
__webpack_unused_export__ = getUA;
__webpack_unused_export__ = isAndroid;
__webpack_unused_export__ = isBrowser;
__webpack_unused_export__ = isChrome;
__webpack_unused_export__ = isChromium;
__webpack_unused_export__ = isConsole;
__webpack_unused_export__ = isDesktop;
__webpack_unused_export__ = isEdge;
__webpack_unused_export__ = isEdgeChromium;
__webpack_unused_export__ = isElectron;
__webpack_unused_export__ = isEmbedded;
__webpack_unused_export__ = isFirefox;
__webpack_unused_export__ = isIE;
exports.gn = isIOS;
__webpack_unused_export__ = isIOS13;
__webpack_unused_export__ = isIPad13;
__webpack_unused_export__ = isIPhone13;
__webpack_unused_export__ = isIPod13;
__webpack_unused_export__ = isLegacyEdge;
__webpack_unused_export__ = isMIUI;
__webpack_unused_export__ = isMacOs;
exports.tq = isMobile;
exports.UA = isMobileOnly;
__webpack_unused_export__ = isMobileSafari;
__webpack_unused_export__ = isOpera;
__webpack_unused_export__ = isSafari;
__webpack_unused_export__ = isSamsungBrowser;
__webpack_unused_export__ = isSmartTV;
__webpack_unused_export__ = isTablet;
__webpack_unused_export__ = isWearable;
__webpack_unused_export__ = isWinPhone;
__webpack_unused_export__ = isWindows;
__webpack_unused_export__ = isYandex;
__webpack_unused_export__ = mobileModel;
__webpack_unused_export__ = mobileVendor;
exports.BF = osName;
__webpack_unused_export__ = osVersion;
__webpack_unused_export__ = parseUserAgent;
__webpack_unused_export__ = setUserAgent;
__webpack_unused_export__ = useDeviceData;
__webpack_unused_export__ = useDeviceSelectors;
__webpack_unused_export__ = useMobileOrientation;
__webpack_unused_export__ = withOrientationChange;


/***/ }),

/***/ 21582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ useDropzone; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/file-selector/node_modules/tslib/tslib.es6.mjs
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
  function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

/* harmony default export */ var tslib_es6 = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
});

;// CONCATENATED MODULE: ./node_modules/file-selector/dist/es5/file.js
var COMMON_MIME_TYPES = new Map([
    ['avi', 'video/avi'],
    ['gif', 'image/gif'],
    ['ico', 'image/x-icon'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['mkv', 'video/x-matroska'],
    ['mov', 'video/quicktime'],
    ['mp4', 'video/mp4'],
    ['pdf', 'application/pdf'],
    ['png', 'image/png'],
    ['zip', 'application/zip'],
    ['doc', 'application/msword'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string'
                ? path
                // If <input webkitdirectory> is set,
                // the File will have a {webkitRelativePath} property
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
                : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                    ? webkitRelativePath
                    : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.')
            .pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}
//# sourceMappingURL=file.js.map
;// CONCATENATED MODULE: ./node_modules/file-selector/dist/es5/file-selector.js


var FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 * @param evt
 */
function fromEvent(evt) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, isDragEvt(evt) && evt.dataTransfer
                    ? getDataTransferFiles(evt.dataTransfer, evt.type)
                    : getInputFiles(evt)];
        });
    });
}
function isDragEvt(value) {
    return !!value.dataTransfer;
}
function getInputFiles(evt) {
    var files = isInput(evt.target)
        ? evt.target.files
            ? fromList(evt.target.files)
            : []
        : [];
    return files.map(function (file) { return toFileWithPath(file); });
}
function isInput(value) {
    return value !== null;
}
function getDataTransferFiles(dt, type) {
    return __awaiter(this, void 0, void 0, function () {
        var items, files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!dt.items) return [3 /*break*/, 2];
                    items = fromList(dt.items)
                        .filter(function (item) { return item.kind === 'file'; });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') {
                        return [2 /*return*/, items];
                    }
                    return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, noIgnoredFiles(flatten(files))];
                case 2: return [2 /*return*/, noIgnoredFiles(fromList(dt.files)
                        .map(function (file) { return toFileWithPath(file); }))];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    var files = [];
    // tslint:disable: prefer-for-of
    for (var i = 0; i < items.length; i++) {
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item);
}
function flatten(items) {
    return items.reduce(function (acc, files) { return __spread(acc, (Array.isArray(files) ? flatten(files) : [files])); }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) {
        return Promise.reject(item + " is not a File");
    }
    var fwp = toFileWithPath(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function (resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function (batch) { return __awaiter(_this, void 0, void 0, function () {
                var files, err_1, items;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!batch.length) return [3 /*break*/, 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, Promise.all(entries)];
                        case 2:
                            files = _a.sent();
                            resolve(files);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            reject(err_1);
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            items = Promise.all(batch.map(fromEntry));
                            entries.push(items);
                            // Continue reading
                            readEntries();
                            _a.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); }, function (err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    entry.file(function (file) {
                        var fwp = toFileWithPath(file, entry.fullPath);
                        resolve(fwp);
                    }, function (err) {
                        reject(err);
                    });
                })];
        });
    });
}
//# sourceMappingURL=file-selector.js.map
;// CONCATENATED MODULE: ./node_modules/file-selector/dist/es5/index.js

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/attr-accept/dist/es/index.js
var es = __webpack_require__(58363);
;// CONCATENATED MODULE: ./node_modules/react-dropzone/dist/es/utils/index.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

 // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted

function fileAccepted(file, accept) {
  return file.type === 'application/x-moz-file' || (0,es/* default */.Z)(file, accept);
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) return file.size >= minSize && file.size <= maxSize;else if (isDefined(minSize)) return file.size >= minSize;else if (isDefined(maxSize)) return file.size <= maxSize;
  }

  return true;
}

function isDefined(value) {
  return value !== undefined && value !== null;
}

function allFilesAccepted(_ref) {
  var files = _ref.files,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      multiple = _ref.multiple;

  if (!multiple && files.length > 1) {
    return false;
  }

  return files.every(function (file) {
    return fileAccepted(file, accept) && fileMatchSize(file, minSize, maxSize);
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === 'function') {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== 'undefined') {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === 'Files' || type === 'application/x-moz-file';
  });
}
function isKindFile(item) {
  return _typeof(item) === 'object' && item !== null && item.kind === 'file';
} // allow the entire document to be a drag target

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}
;// CONCATENATED MODULE: ./node_modules/react-dropzone/dist/es/index.js
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint prefer-template: 0 */




/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone = (0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties(_ref, ["children"]);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties(_useDropzone, ["open"]);

  (0,react.useImperativeHandle)(ref, function () {
    return {
      open: open
    };
  }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return react.createElement(react.Fragment, null, children(_objectSpread({}, props, {
    open: open
  })));
});
Dropzone.displayName = 'Dropzone';
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.draggedFiles Files in active drag
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {File[]} params.rejectedFiles Rejected files
   */
  children: (prop_types_default()).func,

  /**
   * Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: prop_types_default().oneOfType([(prop_types_default()).string, prop_types_default().arrayOf((prop_types_default()).string)]),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: (prop_types_default()).bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: (prop_types_default()).bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: (prop_types_default()).bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: (prop_types_default()).bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: (prop_types_default()).bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: (prop_types_default()).bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: (prop_types_default()).number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: (prop_types_default()).number,

  /**
   * Enable/disable the dropzone
   */
  disabled: (prop_types_default()).bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: (prop_types_default()).func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: (prop_types_default()).func,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: (prop_types_default()).func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: (prop_types_default()).func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: (prop_types_default()).func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are droppped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {File[]} rejectedFiles
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: (prop_types_default()).func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: (prop_types_default()).func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {object[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: (prop_types_default()).func
};
/* harmony default export */ var dist_es = ((/* unused pure expression or super */ null && (Dropzone)));
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {File[]} rejectedFiles List of rejected files
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state and some helper functions.
 *
 * @typedef {object} DropzoneState
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} draggedFiles Files in active drag
 * @property {File[]} acceptedFiles Accepted files
 * @property {File[]} rejectedFiles Rejected files
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  draggedFiles: [],
  acceptedFiles: [],
  rejectedFiles: []
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {string|string[]} [props.accept] Set accepted file types.
 * See https://github.com/okonet/attr-accept for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all.
 * See: https://github.com/react-dropzone/react-dropzone/issues/276
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
 * If `multiple` is set to false and additional files are droppped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 *
 * @returns {DropzoneState}
 */

function useDropzone() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      accept = _ref2.accept,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$getFilesFromEve = _ref2.getFilesFromEvent,
      getFilesFromEvent = _ref2$getFilesFromEve === void 0 ? fromEvent : _ref2$getFilesFromEve,
      _ref2$maxSize = _ref2.maxSize,
      maxSize = _ref2$maxSize === void 0 ? Infinity : _ref2$maxSize,
      _ref2$minSize = _ref2.minSize,
      minSize = _ref2$minSize === void 0 ? 0 : _ref2$minSize,
      _ref2$multiple = _ref2.multiple,
      multiple = _ref2$multiple === void 0 ? true : _ref2$multiple,
      onDragEnter = _ref2.onDragEnter,
      onDragLeave = _ref2.onDragLeave,
      onDragOver = _ref2.onDragOver,
      onDrop = _ref2.onDrop,
      onDropAccepted = _ref2.onDropAccepted,
      onDropRejected = _ref2.onDropRejected,
      onFileDialogCancel = _ref2.onFileDialogCancel,
      _ref2$preventDropOnDo = _ref2.preventDropOnDocument,
      preventDropOnDocument = _ref2$preventDropOnDo === void 0 ? true : _ref2$preventDropOnDo,
      _ref2$noClick = _ref2.noClick,
      noClick = _ref2$noClick === void 0 ? false : _ref2$noClick,
      _ref2$noKeyboard = _ref2.noKeyboard,
      noKeyboard = _ref2$noKeyboard === void 0 ? false : _ref2$noKeyboard,
      _ref2$noDrag = _ref2.noDrag,
      noDrag = _ref2$noDrag === void 0 ? false : _ref2$noDrag,
      _ref2$noDragEventsBub = _ref2.noDragEventsBubbling,
      noDragEventsBubbling = _ref2$noDragEventsBub === void 0 ? false : _ref2$noDragEventsBub;

  var rootRef = (0,react.useRef)(null);
  var inputRef = (0,react.useRef)(null);

  var _useReducer = (0,react.useReducer)(reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive,
      draggedFiles = state.draggedFiles; // Fn for opening the file dialog programmatically

  var openFileDialog = (0,react.useCallback)(function () {
    if (inputRef.current) {
      dispatch({
        type: 'openDialog'
      });
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch]); // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: 'closeDialog'
            });

            if (typeof onFileDialogCancel === 'function') {
              onFileDialogCancel();
            }
          }
        }
      }, 300);
    }
  };

  (0,react.useEffect)(function () {
    window.addEventListener('focus', onWindowFocus, false);
    return function () {
      window.removeEventListener('focus', onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancel]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = (0,react.useCallback)(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, inputRef]); // Update focus state for the dropzone

  var onFocusCb = (0,react.useCallback)(function () {
    dispatch({
      type: 'focus'
    });
  }, []);
  var onBlurCb = (0,react.useCallback)(function () {
    dispatch({
      type: 'blur'
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = (0,react.useCallback)(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [inputRef, noClick]);
  var dragTargetsRef = (0,react.useRef)([]);

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    dragTargetsRef.current = [];
  };

  (0,react.useEffect)(function () {
    if (preventDropOnDocument) {
      document.addEventListener('dragover', onDocumentDragOver, false);
      document.addEventListener('drop', onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener('dragover', onDocumentDragOver);
        document.removeEventListener('drop', onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]);
  var onDragEnterCb = (0,react.useCallback)(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event); // Count the dropzone and any children that are entered.

    if (dragTargetsRef.current.indexOf(event.target) === -1) {
      dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [event.target]);
    }

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (draggedFiles) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        dispatch({
          draggedFiles: draggedFiles,
          isDragActive: true,
          type: 'setDraggedFiles'
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      });
    }
  }, [getFilesFromEvent, onDragEnter, noDragEventsBubbling]);
  var onDragOverCb = (0,react.useCallback)(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);

    if (event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = 'copy';
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (isEvtWithFiles(event) && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = (0,react.useCallback)(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = dragTargetsRef.current.filter(function (target) {
      return target !== event.target && rootRef.current && rootRef.current.contains(target);
    });
    dragTargetsRef.current = targets;

    if (targets.length > 0) {
      return;
    }

    dispatch({
      isDragActive: false,
      type: 'setDraggedFiles',
      draggedFiles: []
    });

    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var onDropCb = (0,react.useCallback)(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        var acceptedFiles = [];
        var rejectedFiles = [];
        files.forEach(function (file) {
          if (fileAccepted(file, accept) && fileMatchSize(file, minSize, maxSize)) {
            acceptedFiles.push(file);
          } else {
            rejectedFiles.push(file);
          }
        });

        if (!multiple && acceptedFiles.length > 1) {
          rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(0))); // Reject everything and empty accepted files
        }

        dispatch({
          acceptedFiles: acceptedFiles,
          rejectedFiles: rejectedFiles,
          type: 'setFiles'
        });

        if (onDrop) {
          onDrop(acceptedFiles, rejectedFiles, event);
        }

        if (rejectedFiles.length > 0 && onDropRejected) {
          onDropRejected(rejectedFiles, event);
        }

        if (acceptedFiles.length > 0 && onDropAccepted) {
          onDropAccepted(acceptedFiles, event);
        }
      });
    }

    dispatch({
      type: 'reset'
    });
  }, [multiple, accept, minSize, maxSize, getFilesFromEvent, onDrop, onDropAccepted, onDropRejected, noDragEventsBubbling]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = (0,react.useMemo)(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
          onKeyDown = _ref3.onKeyDown,
          onFocus = _ref3.onFocus,
          onBlur = _ref3.onBlur,
          onClick = _ref3.onClick,
          onDragEnter = _ref3.onDragEnter,
          onDragOver = _ref3.onDragOver,
          onDragLeave = _ref3.onDragLeave,
          onDrop = _ref3.onDrop,
          rest = _objectWithoutProperties(_ref3, ["refKey", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"]);

      return _objectSpread(_defineProperty({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb))
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}, {}, rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = (0,react.useCallback)(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = (0,react.useMemo)(function () {
    return function () {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$refKey = _ref4.refKey,
          refKey = _ref4$refKey === void 0 ? 'ref' : _ref4$refKey,
          onChange = _ref4.onChange,
          onClick = _ref4.onClick,
          rest = _objectWithoutProperties(_ref4, ["refKey", "onChange", "onClick"]);

      var inputProps = _defineProperty({
        accept: accept,
        multiple: multiple,
        type: 'file',
        style: {
          display: 'none'
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        autoComplete: 'off',
        tabIndex: -1
      }, refKey, inputRef);

      return _objectSpread({}, inputProps, {}, rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  var fileCount = draggedFiles.length;
  var isDragAccept = fileCount > 0 && allFilesAccepted({
    files: draggedFiles,
    accept: accept,
    minSize: minSize,
    maxSize: maxSize,
    multiple: multiple
  });
  var isDragReject = fileCount > 0 && !isDragAccept;
  return _objectSpread({}, state, {
    isDragAccept: isDragAccept,
    isDragReject: isDragReject,
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case 'focus':
      return _objectSpread({}, state, {
        isFocused: true
      });

    case 'blur':
      return _objectSpread({}, state, {
        isFocused: false
      });

    case 'openDialog':
      return _objectSpread({}, state, {
        isFileDialogActive: true
      });

    case 'closeDialog':
      return _objectSpread({}, state, {
        isFileDialogActive: false
      });

    case 'setDraggedFiles':
      /* eslint no-case-declarations: 0 */
      var isDragActive = action.isDragActive,
          draggedFiles = action.draggedFiles;
      return _objectSpread({}, state, {
        draggedFiles: draggedFiles,
        isDragActive: isDragActive
      });

    case 'setFiles':
      return _objectSpread({}, state, {
        acceptedFiles: action.acceptedFiles,
        rejectedFiles: action.rejectedFiles
      });

    case 'reset':
      return _objectSpread({}, state, {
        isFileDialogActive: false,
        isDragActive: false,
        draggedFiles: [],
        acceptedFiles: [],
        rejectedFiles: []
      });

    default:
      return state;
  }
}

/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;__webpack_unused_export__=h;__webpack_unused_export__=z;__webpack_unused_export__=A;exports.ForwardRef=B;__webpack_unused_export__=C;__webpack_unused_export__=D;exports.Memo=E;__webpack_unused_export__=F;__webpack_unused_export__=G;__webpack_unused_export__=H;
__webpack_unused_export__=I;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};exports.isContextConsumer=function(a){return y(a)===h};__webpack_unused_export__=function(a){return y(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return y(a)===k};__webpack_unused_export__=function(a){return y(a)===d};__webpack_unused_export__=function(a){return y(a)===p};__webpack_unused_export__=function(a){return y(a)===n};
__webpack_unused_export__=function(a){return y(a)===c};__webpack_unused_export__=function(a){return y(a)===f};__webpack_unused_export__=function(a){return y(a)===e};__webpack_unused_export__=function(a){return y(a)===l};exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
exports.typeOf=y;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(69921);
} else {}


/***/ }),

/***/ 58949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IGNORE_CLASS_NAME": function() { return /* binding */ IGNORE_CLASS_NAME; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.
  // Also cover shadowRoot node by checking current.host


  while (current.parentNode || current.host) {
    // Only check normal node without shadowRoot
    if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode || current.host;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = {};
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions.passive = !instance.props.preventDefault;
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode)(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    }
    /**
     * Remove all document's event listeners for this component
     */
    ;

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    }
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */
    ;

    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _this$props = this.props;
          _this$props.excludeScrollbar;
          var props = _objectWithoutPropertiesLoose(_this$props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(WrappedComponent, props);
    };

    return onClickOutside;
  }(react__WEBPACK_IMPORTED_MODULE_0__.Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}/* harmony default export */ __webpack_exports__["default"] = (onClickOutsideHOC);

/***/ }),

/***/ 14416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zt": function() { return /* reexport */ components_Provider; },
  "$j": function() { return /* reexport */ connect; },
  "I0": function() { return /* reexport */ useDispatch; },
  "v9": function() { return /* reexport */ useSelector; },
  "oR": function() { return /* reexport */ useStore_useStore; }
});

// UNUSED EXPORTS: ReactReduxContext, batch, connectAdvanced, createDispatchHook, createSelectorHook, createStoreHook, shallowEqual

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Context.js

var ReactReduxContext = /*#__PURE__*/react.createContext(null);

if (false) {}

/* harmony default export */ var Context = ((/* unused pure expression or super */ null && (ReactReduxContext)));
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/batch.js
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/Subscription.js
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

function createListenerCollection() {
  var batch = getBatch();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var nullListeners = {
  notify: function notify() {},
  get: function get() {
    return [];
  }
};
function createSubscription(store, parentSub) {
  var unsubscribe;
  var listeners = nullListeners;

  function addNestedSub(listener) {
    trySubscribe();
    return listeners.subscribe(listener);
  }

  function notifyNestedSubs() {
    listeners.notify();
  }

  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }

  function isSubscribed() {
    return Boolean(unsubscribe);
  }

  function trySubscribe() {
    if (!unsubscribe) {
      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }

  function tryUnsubscribe() {
    if (unsubscribe) {
      unsubscribe();
      unsubscribe = undefined;
      listeners.clear();
      listeners = nullListeners;
    }
  }

  var subscription = {
    addNestedSub: addNestedSub,
    notifyNestedSubs: notifyNestedSubs,
    handleChangeWrapper: handleChangeWrapper,
    isSubscribed: isSubscribed,
    trySubscribe: trySubscribe,
    tryUnsubscribe: tryUnsubscribe,
    getListeners: function getListeners() {
      return listeners;
    }
  };
  return subscription;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/useIsomorphicLayoutEffect.js
 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? react.useLayoutEffect : react.useEffect;
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Provider.js






function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = (0,react.useMemo)(function () {
    var subscription = createSubscription(store);
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = (0,react.useMemo)(function () {
    return store.getState();
  }, [store]);
  useIsomorphicLayoutEffect(function () {
    var subscription = contextValue.subscription;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || ReactReduxContext;
  return /*#__PURE__*/react.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

if (false) {}

/* harmony default export */ var components_Provider = (Provider);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(59864);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/connectAdvanced.js


var _excluded = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"],
    _excluded2 = ["reactReduxForwardedRef"];





 // Define some constant arrays just to avoid re-creating these

var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  useIsomorphicLayoutEffect(function () {
    return effectFunc.apply(void 0, effectArgs);
  }, dependencies);
}

function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  lastChildProps.current = actualChildProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
}

function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

  var didUnsubscribe = false;
  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  var checkForUpdates = function checkForUpdates() {
    if (didUnsubscribe) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    }

    var latestStoreState = store.getState();
    var newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

      forceComponentUpdateDispatch({
        type: 'STORE_UPDATED',
        payload: {
          error: error
        }
      });
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  var unsubscribeWrapper = function unsubscribeWrapper() {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? ReactReduxContext : _ref2$context,
      connectOptions = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, _excluded);

  if (false) { var customStoreWarningMessage; }

  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (false) {}

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = (0,esm_extends/* default */.Z)({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? react.useMemo : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = (0,react.useMemo)(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var reactReduxForwardedRef = props.reactReduxForwardedRef,
            wrapperProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded2);

        return [props.context, reactReduxForwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          reactReduxForwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = (0,react.useMemo)(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && (0,react_is.isContextConsumer)( /*#__PURE__*/react.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = (0,react.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (false) {} // Based on the previous check, one of these must be true


      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = (0,react.useMemo)(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = (0,react.useMemo)(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var subscription = createSubscription(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.
        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = (0,react.useMemo)(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return (0,esm_extends/* default */.Z)({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = (0,react.useReducer)(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = (0,react.useRef)();
      var lastWrapperProps = (0,react.useRef)(wrapperProps);
      var childPropsFromStoreUpdate = (0,react.useRef)();
      var renderIsScheduled = (0,react.useRef)(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = (0,react.useMemo)(function () {
        return /*#__PURE__*/react.createElement(WrappedComponent, (0,esm_extends/* default */.Z)({}, actualChildProps, {
          ref: reactReduxForwardedRef
        }));
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = (0,react.useMemo)(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return /*#__PURE__*/react.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? react.memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = ConnectFunction.displayName = displayName;

    if (forwardRef) {
      var forwarded = react.forwardRef(function forwardConnectRef(props, ref) {
        return /*#__PURE__*/react.createElement(Connect, (0,esm_extends/* default */.Z)({}, props, {
          reactReduxForwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoist_non_react_statics_cjs_default()(forwarded, WrappedComponent);
    }

    return hoist_non_react_statics_cjs_default()(Connect, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/shallowEqual.js
function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/bindActionCreators.js
function bindActionCreators(actionCreators, dispatch) {
  var boundActionCreators = {};

  var _loop = function _loop(key) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = function () {
        return dispatch(actionCreator.apply(void 0, arguments));
      };
    }
  };

  for (var key in actionCreators) {
    _loop(key);
  }

  return boundActionCreators;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/wrapMapToProps.js

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) {}
      return props;
    };

    return proxy;
  };
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapDispatchToProps.js


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return bindActionCreators(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ var mapDispatchToProps = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapStateToProps.js

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ var mapStateToProps = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mergeProps.js


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return (0,esm_extends/* default */.Z)({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) {}
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ var mergeProps = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/selectorFactory.js

var selectorFactory_excluded = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];

function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, selectorFactory_excluded);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {}

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/connect.js


var connect_excluded = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];






/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? mapStateToProps : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? mapDispatchToProps : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? mergeProps : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? finalPropsSelectorFactory : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? shallowEqual : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? shallowEqual : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? shallowEqual : _ref3$areMergedPropsE,
        extraOptions = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref3, connect_excluded);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, (0,esm_extends/* default */.Z)({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ var connect = (/*#__PURE__*/createConnect());
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useReduxContext.js


/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

function useReduxContext_useReduxContext() {
  var contextValue = (0,react.useContext)(ReactReduxContext);

  if (false) {}

  return contextValue;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useStore.js



/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useReduxContext = context === ReactReduxContext ? useReduxContext_useReduxContext : function () {
    return (0,react.useContext)(context);
  };
  return function useStore() {
    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store;

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

var useStore_useStore = /*#__PURE__*/createStoreHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useDispatch.js


/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useStore = context === ReactReduxContext ? useStore_useStore : createStoreHook(context);
  return function useDispatch() {
    var store = useStore();
    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

var useDispatch = /*#__PURE__*/createDispatchHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useSelector.js






var refEquality = function refEquality(a, b) {
  return a === b;
};

function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
  var _useReducer = (0,react.useReducer)(function (s) {
    return s + 1;
  }, 0),
      forceRender = _useReducer[1];

  var subscription = (0,react.useMemo)(function () {
    return createSubscription(store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = (0,react.useRef)();
  var latestSelector = (0,react.useRef)();
  var latestStoreState = (0,react.useRef)();
  var latestSelectedState = (0,react.useRef)();
  var storeState = store.getState();
  var selectedState;

  try {
    if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
      var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references

      if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) {
        selectedState = newSelectedState;
      } else {
        selectedState = latestSelectedState.current;
      }
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    if (latestSubscriptionCallbackError.current) {
      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
    }

    throw err;
  }

  useIsomorphicLayoutEffect(function () {
    latestSelector.current = selector;
    latestStoreState.current = storeState;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  useIsomorphicLayoutEffect(function () {
    function checkForUpdates() {
      try {
        var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed

        if (newStoreState === latestStoreState.current) {
          return;
        }

        var _newSelectedState = latestSelector.current(newStoreState);

        if (equalityFn(_newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = _newSelectedState;
        latestStoreState.current = newStoreState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender();
    }

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useReduxContext = context === ReactReduxContext ? useReduxContext_useReduxContext : function () {
    return (0,react.useContext)(context);
  };
  return function useSelector(selector, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }

    if (false) {}

    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store,
        contextSub = _useReduxContext.subscription;

    var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
    (0,react.useDebugValue)(selectedState);
    return selectedState;
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

var useSelector = /*#__PURE__*/createSelectorHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/exports.js









// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/reactBatchedUpdates.js
/* eslint-disable import/no-unresolved */

;// CONCATENATED MODULE: ./node_modules/react-redux/es/index.js


 // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)

setBatch(react_dom.unstable_batchedUpdates);


/***/ }),

/***/ 72132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Am": function() { return /* binding */ toast; },
/* harmony export */   "Ix": function() { return /* binding */ ToastContainer; }
/* harmony export */ });
/* unused harmony exports Bounce, Flip, Slide, Zoom, collapseToast, cssTransition, useToast, useToastContainer */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98885);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);






function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function isNum(v) {
  return typeof v === 'number' && !isNaN(v);
}
function isBool(v) {
  return typeof v === 'boolean';
}
function isStr(v) {
  return typeof v === 'string';
}
function isFn(v) {
  return typeof v === 'function';
}
function parseClassName(v) {
  return isStr(v) || isFn(v) ? v : null;
}
function objectValues(obj) {
  return Object.keys(obj).map(function (key) {
    return obj[key];
  });
}
function hasToastId(toastId) {
  return toastId === 0 || toastId;
}
function getAutoCloseDelay(toastAutoClose, containerAutoClose) {
  return toastAutoClose === false || isNum(toastAutoClose) && toastAutoClose > 0 ? toastAutoClose : containerAutoClose;
}
var canUseDom = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function canBeRendered(content) {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(content) || isStr(content) || isFn(content) || isNum(content);
}

var POSITION = {
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  TOP_CENTER: 'top-center',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_CENTER: 'bottom-center'
};
var TYPE = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  DEFAULT: 'default',
  DARK: 'dark'
};

/**
 * Used to collapse toast after exit animation
 */
function collapseToast(node, done, duration
/* COLLAPSE_DURATION */
) {
  if (duration === void 0) {
    duration = 300;
  }

  var height = node.scrollHeight;
  var style = node.style;
  requestAnimationFrame(function () {
    style.minHeight = 'initial';
    style.height = height + 'px';
    style.transition = "all " + duration + "ms";
    requestAnimationFrame(function () {
      style.height = '0';
      style.padding = '0';
      style.margin = '0';
      setTimeout(function () {
        return done();
      }, duration);
    });
  });
}

function cssTransition(_ref) {
  var enter = _ref.enter,
      exit = _ref.exit,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 750 : _ref$duration,
      _ref$appendPosition = _ref.appendPosition,
      appendPosition = _ref$appendPosition === void 0 ? false : _ref$appendPosition,
      _ref$collapse = _ref.collapse,
      collapse = _ref$collapse === void 0 ? true : _ref$collapse,
      _ref$collapseDuration = _ref.collapseDuration,
      collapseDuration = _ref$collapseDuration === void 0 ? 300 : _ref$collapseDuration;
  var enterDuration, exitDuration;

  if (Array.isArray(duration) && duration.length === 2) {
    enterDuration = duration[0];
    exitDuration = duration[1];
  } else {
    enterDuration = exitDuration = duration;
  }

  return function ToastTransition(_ref2) {
    var children = _ref2.children,
        position = _ref2.position,
        preventExitTransition = _ref2.preventExitTransition,
        done = _ref2.done,
        props = _objectWithoutPropertiesLoose(_ref2, ["children", "position", "preventExitTransition", "done"]);

    var enterClassName = appendPosition ? enter + "--" + position : enter;
    var exitClassName = appendPosition ? exit + "--" + position : exit;

    var onEnter = function onEnter() {
      var node = props.nodeRef.current;

      if (node) {
        node.classList.add(enterClassName);
        node.style.animationFillMode = 'forwards';
        node.style.animationDuration = enterDuration + "ms";
      }
    };

    var onEntered = function onEntered() {
      var node = props.nodeRef.current;

      if (node) {
        node.classList.remove(enterClassName);
        node.style.removeProperty('animationFillMode');
        node.style.removeProperty('animationDuration');
      }
    };

    var onExited = function onExited() {
      var node = props.nodeRef.current;

      if (node) {
        node.removeEventListener('animationend', onExited);
        collapse ? collapseToast(node, done, collapseDuration) : done();
      }
    };

    var onExit = function onExit() {
      var node = props.nodeRef.current;

      if (node) {
        node.classList.add(exitClassName);
        node.style.animationFillMode = 'forwards';
        node.style.animationDuration = exitDuration + "ms";
        node.addEventListener('animationend', onExited);
      }
    };

    return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(react_transition_group__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, Object.assign({}, props, {
      timeout: preventExitTransition ? collapse ? collapseDuration : 50
      /* DEBOUNCE_DURATION */
      : {
        enter: enterDuration,
        exit: collapse ? exitDuration + collapseDuration : exitDuration + 50
        /* DEBOUNCE_DURATION */

      },
      onEnter: onEnter,
      onEntered: onEntered,
      onExit: preventExitTransition ? onExited : onExit,
      unmountOnExit: true
    }), children);
  };
}

var eventManager = {
  list: /*#__PURE__*/new Map(),
  emitQueue: /*#__PURE__*/new Map(),
  on: function on(event, callback) {
    this.list.has(event) || this.list.set(event, []);
    this.list.get(event).push(callback);
    return this;
  },
  off: function off(event, callback) {
    if (callback) {
      var cb = this.list.get(event).filter(function (cb) {
        return cb !== callback;
      });
      this.list.set(event, cb);
      return this;
    }

    this.list["delete"](event);
    return this;
  },
  cancelEmit: function cancelEmit(event) {
    var timers = this.emitQueue.get(event);

    if (timers) {
      timers.forEach(function (timer) {
        return clearTimeout(timer);
      });
      this.emitQueue["delete"](event);
    }

    return this;
  },

  /**
   * Enqueue the event at the end of the call stack
   * Doing so let the user call toast as follow:
   * toast('1')
   * toast('2')
   * toast('3')
   * Without setTimemout the code above will not work
   */
  emit: function emit(event) {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    this.list.has(event) && this.list.get(event).forEach(function (callback) {
      var timer = setTimeout(function () {
        // @ts-ignore
        callback.apply(void 0, args);
      }, 0);
      _this.emitQueue.has(event) || _this.emitQueue.set(event, []);

      _this.emitQueue.get(event).push(timer);
    });
  }
};

/**
 * `useKeeper` is a helper around `useRef`.
 *
 * You don't need to access the `.current`property to get the value
 * If refresh is set to true. The ref will be updated every render
 */

function useKeeper(arg, refresh) {
  if (refresh === void 0) {
    refresh = false;
  }

  var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(arg);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (refresh) ref.current = arg;
  });
  return ref.current;
}

function reducer(state, action) {
  switch (action.type) {
    case 'ADD':
      return [].concat(state, [action.toastId]).filter(function (id) {
        return id !== action.staleId;
      });

    case 'REMOVE':
      return hasToastId(action.toastId) ? state.filter(function (id) {
        return id !== action.toastId;
      }) : [];
  }
}

function useToastContainer(props) {
  var _useReducer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(function (x) {
    return x + 1;
  }, 0),
      forceUpdate = _useReducer[1];

  var _useReducer2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(reducer, []),
      toast = _useReducer2[0],
      dispatch = _useReducer2[1];

  var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var toastCount = useKeeper(0);
  var queue = useKeeper([]);
  var collection = useKeeper({});
  var instance = useKeeper({
    toastKey: 1,
    displayedToast: 0,
    props: props,
    containerId: null,
    isToastActive: isToastActive,
    getToast: function getToast(id) {
      return collection[id] || null;
    }
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    instance.containerId = props.containerId;
    eventManager.cancelEmit(3
    /* WillUnmount */
    ).on(0
    /* Show */
    , buildToast).on(1
    /* Clear */
    , function (toastId) {
      return containerRef.current && removeToast(toastId);
    }).on(5
    /* ClearWaitingQueue */
    , clearWaitingQueue).emit(2
    /* DidMount */
    , instance);
    return function () {
      return eventManager.emit(3
      /* WillUnmount */
      , instance);
    };
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    instance.isToastActive = isToastActive;
    instance.displayedToast = toast.length;
    eventManager.emit(4
    /* Change */
    , toast.length, props.containerId);
  }, [toast]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    instance.props = props;
  });

  function isToastActive(id) {
    return toast.indexOf(id) !== -1;
  }

  function clearWaitingQueue(_ref) {
    var containerId = _ref.containerId;
    var _instance$props = instance.props,
        limit = _instance$props.limit,
        enableMultiContainer = _instance$props.enableMultiContainer;

    if (limit && (!containerId || instance.containerId === containerId && enableMultiContainer)) {
      toastCount -= queue.length;
      queue = [];
    }
  }

  function removeToast(toastId) {
    var queueLen = queue.length;
    toastCount = hasToastId(toastId) ? toastCount - 1 : toastCount - instance.displayedToast;
    if (toastCount < 0) toastCount = 0;

    if (queueLen > 0) {
      var freeSlot = hasToastId(toastId) ? 1 : instance.props.limit;

      if (queueLen === 1 || freeSlot === 1) {
        instance.displayedToast++;
        dequeueToast();
      } else {
        var toDequeue = freeSlot > queueLen ? queueLen : freeSlot;
        instance.displayedToast = toDequeue;

        for (var i = 0; i < toDequeue; i++) {
          dequeueToast();
        }
      }
    }

    dispatch({
      type: 'REMOVE',
      toastId: toastId
    });
  }

  function dequeueToast() {
    var _queue$shift = queue.shift(),
        toastContent = _queue$shift.toastContent,
        toastProps = _queue$shift.toastProps,
        staleId = _queue$shift.staleId; // ensure that exit transition has been completed, hence the timeout


    setTimeout(function () {
      appendToast(toastContent, toastProps, staleId);
    }, 500);
  }
  /**
   * check if a container is attached to the dom
   * check for multi-container, build only if associated
   * check for duplicate toastId if no update
   */


  function isNotValid(_ref2) {
    var containerId = _ref2.containerId,
        toastId = _ref2.toastId,
        updateId = _ref2.updateId;
    return !containerRef.current || instance.props.enableMultiContainer && containerId !== instance.props.containerId || instance.isToastActive(toastId) && updateId == null ? true : false;
  } // this function and all the function called inside needs to rely on ref(`useKeeper`)


  function buildToast(content, _ref3) {
    var delay = _ref3.delay,
        staleId = _ref3.staleId,
        options = _objectWithoutPropertiesLoose(_ref3, ["delay", "staleId"]);

    if (!canBeRendered(content) || isNotValid(options)) return;
    var toastId = options.toastId,
        updateId = options.updateId;
    var props = instance.props,
        isToastActive = instance.isToastActive;

    var closeToast = function closeToast() {
      return removeToast(toastId);
    };

    var isNotAnUpdate = !isToastActive(toastId);
    if (isNotAnUpdate) toastCount++;
    var toastProps = {
      toastId: toastId,
      updateId: updateId,
      key: options.key || instance.toastKey++,
      type: options.type,
      closeToast: closeToast,
      closeButton: options.closeButton,
      rtl: props.rtl,
      position: options.position || props.position,
      transition: options.transition || props.transition,
      className: parseClassName(options.className || props.toastClassName),
      bodyClassName: parseClassName(options.bodyClassName || props.bodyClassName),
      style: options.style || props.toastStyle,
      bodyStyle: options.bodyStyle || props.bodyStyle,
      onClick: options.onClick || props.onClick,
      pauseOnHover: isBool(options.pauseOnHover) ? options.pauseOnHover : props.pauseOnHover,
      pauseOnFocusLoss: isBool(options.pauseOnFocusLoss) ? options.pauseOnFocusLoss : props.pauseOnFocusLoss,
      draggable: isBool(options.draggable) ? options.draggable : props.draggable,
      draggablePercent: isNum(options.draggablePercent) ? options.draggablePercent : props.draggablePercent,
      closeOnClick: isBool(options.closeOnClick) ? options.closeOnClick : props.closeOnClick,
      progressClassName: parseClassName(options.progressClassName || props.progressClassName),
      progressStyle: options.progressStyle || props.progressStyle,
      autoClose: getAutoCloseDelay(options.autoClose, props.autoClose),
      hideProgressBar: isBool(options.hideProgressBar) ? options.hideProgressBar : props.hideProgressBar,
      progress: options.progress,
      role: isStr(options.role) ? options.role : props.role,
      deleteToast: function deleteToast() {
        removeFromCollection(toastId);
      }
    };
    if (isFn(options.onOpen)) toastProps.onOpen = options.onOpen;
    if (isFn(options.onClose)) toastProps.onClose = options.onClose;
    var closeButton = props.closeButton;

    if (options.closeButton === false || canBeRendered(options.closeButton)) {
      closeButton = options.closeButton;
    } else if (options.closeButton === true) {
      closeButton = canBeRendered(props.closeButton) ? props.closeButton : true;
    }

    toastProps.closeButton = closeButton;
    var toastContent = content;

    if ((0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(content) && !isStr(content.type)) {
      toastContent = (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(content, {
        closeToast: closeToast,
        toastProps: toastProps
      });
    } else if (isFn(content)) {
      toastContent = content({
        closeToast: closeToast,
        toastProps: toastProps
      });
    } // not handling limit + delay by design. Waiting for user feedback first


    if (props.limit && props.limit > 0 && toastCount > props.limit && isNotAnUpdate) {
      queue.push({
        toastContent: toastContent,
        toastProps: toastProps,
        staleId: staleId
      });
    } else if (isNum(delay) && delay > 0) {
      setTimeout(function () {
        appendToast(toastContent, toastProps, staleId);
      }, delay);
    } else {
      appendToast(toastContent, toastProps, staleId);
    }
  }

  function appendToast(content, toastProps, staleId) {
    var toastId = toastProps.toastId;
    collection[toastId] = {
      content: content,
      props: toastProps
    };
    dispatch({
      type: 'ADD',
      toastId: toastId,
      staleId: staleId
    });
  }

  function removeFromCollection(toastId) {
    delete collection[toastId];
    forceUpdate();
  }

  function getToastToRender(cb) {
    var toastToRender = {};
    var toastList = props.newestOnTop ? Object.keys(collection).reverse() : Object.keys(collection);

    for (var i = 0; i < toastList.length; i++) {
      var _toast = collection[toastList[i]];
      var position = _toast.props.position;
      toastToRender[position] || (toastToRender[position] = []);
      toastToRender[position].push(_toast);
    }

    return Object.keys(toastToRender).map(function (p) {
      return cb(p, toastToRender[p]);
    });
  }

  return {
    getToastToRender: getToastToRender,
    collection: collection,
    containerRef: containerRef,
    isToastActive: isToastActive
  };
}

function getX(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientX : e.clientX;
}

function getY(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientY : e.clientY;
}

function useToast(props) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true),
      isRunning = _useState[0],
      setIsRunning = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      preventExitTransition = _useState2[0],
      setPreventExitTransition = _useState2[1];

  var toastRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var drag = useKeeper({
    start: 0,
    x: 0,
    y: 0,
    deltaX: 0,
    removalDistance: 0,
    canCloseOnClick: true,
    canDrag: false,
    boundingRect: null
  });
  var syncProps = useKeeper(props, true);
  var autoClose = props.autoClose,
      pauseOnHover = props.pauseOnHover,
      closeToast = props.closeToast,
      onClick = props.onClick,
      closeOnClick = props.closeOnClick;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (isFn(props.onOpen)) props.onOpen((0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(props.children) && props.children.props);
    return function () {
      if (isFn(syncProps.onClose)) syncProps.onClose((0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(syncProps.children) && syncProps.children.props);
    };
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    props.draggable && bindDragEvents();
    return function () {
      props.draggable && unbindDragEvents();
    };
  }, [props.draggable]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    props.pauseOnFocusLoss && bindFocusEvents();
    return function () {
      props.pauseOnFocusLoss && unbindFocusEvents();
    };
  }, [props.pauseOnFocusLoss]);

  function onDragStart(e) {
    var toast = toastRef.current;
    drag.canCloseOnClick = true;
    drag.canDrag = true;
    drag.boundingRect = toast.getBoundingClientRect();
    toast.style.transition = '';
    drag.start = drag.x = getX(e.nativeEvent);
    drag.removalDistance = toast.offsetWidth * (props.draggablePercent / 100);
  }

  function onDragTransitionEnd() {
    if (drag.boundingRect) {
      var _drag$boundingRect = drag.boundingRect,
          top = _drag$boundingRect.top,
          bottom = _drag$boundingRect.bottom,
          left = _drag$boundingRect.left,
          right = _drag$boundingRect.right;

      if (props.pauseOnHover && drag.x >= left && drag.x <= right && drag.y >= top && drag.y <= bottom) {
        pauseToast();
      } else {
        playToast();
      }
    }
  }

  function playToast() {
    setIsRunning(true);
  }

  function pauseToast() {
    setIsRunning(false);
  }

  function bindFocusEvents() {
    window.addEventListener('focus', playToast);
    window.addEventListener('blur', pauseToast);
  }

  function unbindFocusEvents() {
    window.removeEventListener('focus', playToast);
    window.removeEventListener('blur', pauseToast);
  }

  function bindDragEvents() {
    document.addEventListener('mousemove', onDragMove);
    document.addEventListener('mouseup', onDragEnd);
    document.addEventListener('touchmove', onDragMove);
    document.addEventListener('touchend', onDragEnd);
  }

  function unbindDragEvents() {
    document.removeEventListener('mousemove', onDragMove);
    document.removeEventListener('mouseup', onDragEnd);
    document.removeEventListener('touchmove', onDragMove);
    document.removeEventListener('touchend', onDragEnd);
  }

  function onDragMove(e) {
    e.preventDefault();
    var toast = toastRef.current;

    if (drag.canDrag) {
      if (isRunning) pauseToast();
      drag.x = getX(e);
      drag.deltaX = drag.x - drag.start;
      drag.y = getY(e); // prevent false positif during a toast click

      if (drag.start !== drag.x) drag.canCloseOnClick = false;
      toast.style.transform = "translateX(" + drag.deltaX + "px)";
      toast.style.opacity = "" + (1 - Math.abs(drag.deltaX / drag.removalDistance));
    }
  }

  function onDragEnd() {
    var toast = toastRef.current;

    if (drag.canDrag) {
      drag.canDrag = false;

      if (Math.abs(drag.deltaX) > drag.removalDistance) {
        setPreventExitTransition(true);
        props.closeToast();
        return;
      }

      toast.style.transition = 'transform 0.2s, opacity 0.2s';
      toast.style.transform = 'translateX(0)';
      toast.style.opacity = '1';
    }
  }

  var eventHandlers = {
    onMouseDown: onDragStart,
    onTouchStart: onDragStart,
    onMouseUp: onDragTransitionEnd,
    onTouchEnd: onDragTransitionEnd
  };

  if (autoClose && pauseOnHover) {
    eventHandlers.onMouseEnter = pauseToast;
    eventHandlers.onMouseLeave = playToast;
  } // prevent toast from closing when user drags the toast


  if (closeOnClick) {
    eventHandlers.onClick = function (e) {
      onClick && onClick(e);
      drag.canCloseOnClick && closeToast();
    };
  }

  return {
    playToast: playToast,
    pauseToast: pauseToast,
    isRunning: isRunning,
    preventExitTransition: preventExitTransition,
    toastRef: toastRef,
    eventHandlers: eventHandlers
  };
}

function CloseButton(_ref) {
  var closeToast = _ref.closeToast,
      type = _ref.type,
      _ref$ariaLabel = _ref.ariaLabel,
      ariaLabel = _ref$ariaLabel === void 0 ? 'close' : _ref$ariaLabel;
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("button", {
    className: "Toastify"
    /* CSS_NAMESPACE */
    + "__close-button " + "Toastify"
    /* CSS_NAMESPACE */
    + "__close-button--" + type,
    type: "button",
    onClick: function onClick(e) {
      e.stopPropagation();
      closeToast(e);
    },
    "aria-label": ariaLabel
  }, (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 14 16"
  }, (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    fillRule: "evenodd",
    d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
  })));
}

function ProgressBar(_ref) {
  var _ref2, _animationEvent;

  var delay = _ref.delay,
      isRunning = _ref.isRunning,
      closeToast = _ref.closeToast,
      type = _ref.type,
      hide = _ref.hide,
      className = _ref.className,
      userStyle = _ref.style,
      controlledProgress = _ref.controlledProgress,
      progress = _ref.progress,
      rtl = _ref.rtl,
      isIn = _ref.isIn;

  var style = _extends({}, userStyle, {
    animationDuration: delay + "ms",
    animationPlayState: isRunning ? 'running' : 'paused',
    opacity: hide ? 0 : 1
  });

  if (controlledProgress) style.transform = "scaleX(" + progress + ")";
  var defaultClassArr = ["Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar", controlledProgress ? "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--controlled" : "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--animated", "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--" + type, (_ref2 = {}, _ref2["Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--rtl"] = rtl, _ref2)];
  var classNames = isFn(className) ? className({
    rtl: rtl,
    type: type,
    defaultClassName: clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"].apply */ .Z.apply(void 0, defaultClassArr)
  }) : clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"].apply */ .Z.apply(void 0, [].concat(defaultClassArr, [className])); // 🧐 controlledProgress is derived from progress
  // so if controlledProgress is set
  // it means that this is also the case for progress

  var animationEvent = (_animationEvent = {}, _animationEvent[controlledProgress && progress >= 1 ? 'onTransitionEnd' : 'onAnimationEnd'] = controlledProgress && progress < 1 ? null : function () {
    isIn && closeToast();
  }, _animationEvent);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("div", Object.assign({
    className: classNames,
    style: style
  }, animationEvent));
}
ProgressBar.defaultProps = {
  type: TYPE.DEFAULT,
  hide: false
};

var Toast = function Toast(props) {
  var _ref;

  var _useToast = useToast(props),
      isRunning = _useToast.isRunning,
      preventExitTransition = _useToast.preventExitTransition,
      toastRef = _useToast.toastRef,
      eventHandlers = _useToast.eventHandlers;

  var closeButton = props.closeButton,
      children = props.children,
      autoClose = props.autoClose,
      onClick = props.onClick,
      type = props.type,
      hideProgressBar = props.hideProgressBar,
      closeToast = props.closeToast,
      Transition = props.transition,
      position = props.position,
      className = props.className,
      style = props.style,
      bodyClassName = props.bodyClassName,
      bodyStyle = props.bodyStyle,
      progressClassName = props.progressClassName,
      progressStyle = props.progressStyle,
      updateId = props.updateId,
      role = props.role,
      progress = props.progress,
      rtl = props.rtl,
      toastId = props.toastId,
      deleteToast = props.deleteToast;
  var defaultClassArr = ["Toastify"
  /* CSS_NAMESPACE */
  + "__toast", "Toastify"
  /* CSS_NAMESPACE */
  + "__toast--" + type, (_ref = {}, _ref["Toastify"
  /* CSS_NAMESPACE */
  + "__toast--rtl"] = rtl, _ref)];
  var cssClasses = isFn(className) ? className({
    rtl: rtl,
    position: position,
    type: type,
    defaultClassName: clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"].apply */ .Z.apply(void 0, defaultClassArr)
  }) : clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"].apply */ .Z.apply(void 0, [].concat(defaultClassArr, [className]));
  var controlledProgress = !!progress;

  function renderCloseButton(closeButton) {
    if (!closeButton) return;
    var props = {
      closeToast: closeToast,
      type: type
    };
    if (isFn(closeButton)) return closeButton(props);
    if ((0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(closeButton)) return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(closeButton, props);
  }

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Transition, {
    "in": props["in"],
    appear: true,
    done: deleteToast,
    position: position,
    preventExitTransition: preventExitTransition,
    nodeRef: toastRef
  }, (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("div", Object.assign({
    id: toastId,
    onClick: onClick,
    className: cssClasses || undefined
  }, eventHandlers, {
    style: style,
    ref: toastRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("div", Object.assign({}, props["in"] && {
    role: role
  }, {
    className: isFn(bodyClassName) ? bodyClassName({
      type: type
    }) : (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("Toastify"
    /* CSS_NAMESPACE */
    + "__toast-body", bodyClassName),
    style: bodyStyle
  }), children), renderCloseButton(closeButton), (autoClose || controlledProgress) && (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(ProgressBar, Object.assign({}, updateId && !controlledProgress ? {
    key: "pb-" + updateId
  } : {}, {
    rtl: rtl,
    delay: autoClose,
    isRunning: isRunning,
    isIn: props["in"],
    closeToast: closeToast,
    hide: hideProgressBar,
    type: type,
    style: progressStyle,
    className: progressClassName,
    controlledProgress: controlledProgress,
    progress: progress
  }))));
};

var Bounce = /*#__PURE__*/cssTransition({
  enter: "Toastify"
  /* CSS_NAMESPACE */
  + "__bounce-enter",
  exit: "Toastify"
  /* CSS_NAMESPACE */
  + "__bounce-exit",
  appendPosition: true
});
var Slide = /*#__PURE__*/cssTransition({
  enter: "Toastify"
  /* CSS_NAMESPACE */
  + "__slide-enter",
  exit: "Toastify"
  /* CSS_NAMESPACE */
  + "__slide-exit",
  duration: [450, 750],
  appendPosition: true
});
var Zoom = /*#__PURE__*/cssTransition({
  enter: "Toastify"
  /* CSS_NAMESPACE */
  + "__zoom-enter",
  exit: "Toastify"
  /* CSS_NAMESPACE */
  + "__zoom-exit"
});
var Flip = /*#__PURE__*/cssTransition({
  enter: "Toastify"
  /* CSS_NAMESPACE */
  + "__flip-enter",
  exit: "Toastify"
  /* CSS_NAMESPACE */
  + "__flip-exit"
});

var ToastPositioner = function ToastPositioner(_ref) {
  var children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "className", "style"]);

  // Monkey patch react-transition-group
  // As exit transition is broken with strict mode
  delete rest["in"];
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("div", {
    className: className,
    style: style
  }, react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, function (child) {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, rest);
  }));
};

var ToastContainer = function ToastContainer(props) {
  var _useToastContainer = useToastContainer(props),
      getToastToRender = _useToastContainer.getToastToRender,
      containerRef = _useToastContainer.containerRef,
      isToastActive = _useToastContainer.isToastActive;

  var className = props.className,
      style = props.style,
      rtl = props.rtl,
      containerId = props.containerId;
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("div", {
    ref: containerRef,
    className: "Toastify"
    /* CSS_NAMESPACE */
    ,
    id: containerId
  }, getToastToRender(function (position, toastList) {
    var _cx, _cx2;

    var swag = {
      className: isFn(className) ? className({
        position: position,
        rtl: rtl,
        defaultClassName: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("Toastify"
        /* CSS_NAMESPACE */
        + "__toast-container", "Toastify"
        /* CSS_NAMESPACE */
        + "__toast-container--" + position, (_cx = {}, _cx["Toastify"
        /* CSS_NAMESPACE */
        + "__toast-container--rtl"] = rtl, _cx))
      }) : (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("Toastify"
      /* CSS_NAMESPACE */
      + "__toast-container", "Toastify"
      /* CSS_NAMESPACE */
      + "__toast-container--" + position, (_cx2 = {}, _cx2["Toastify"
      /* CSS_NAMESPACE */
      + "__toast-container--rtl"] = rtl, _cx2), parseClassName(className)),
      style: toastList.length === 0 ? _extends({}, style, {
        pointerEvents: 'none'
      }) : _extends({}, style)
    };
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(ToastPositioner, Object.assign({}, swag, {
      key: "container-" + position
    }), toastList.map(function (_ref) {
      var content = _ref.content,
          toastProps = _ref.props;
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Toast, Object.assign({}, toastProps, {
        "in": isToastActive(toastProps.toastId),
        key: "toast-" + toastProps.key,
        closeButton: toastProps.closeButton === true ? CloseButton : toastProps.closeButton
      }), content);
    }));
  }));
};

if (false) {}

ToastContainer.defaultProps = {
  position: POSITION.TOP_RIGHT,
  transition: Bounce,
  rtl: false,
  autoClose: 5000,
  hideProgressBar: false,
  closeButton: CloseButton,
  pauseOnHover: true,
  pauseOnFocusLoss: true,
  closeOnClick: true,
  newestOnTop: false,
  draggable: true,
  draggablePercent: 80,
  role: 'alert'
};

var containers = /*#__PURE__*/new Map();
var latestInstance;
var containerDomNode;
var containerConfig;
var queue = [];
var lazy = false;
/**
 * Check whether any container is currently mounted in the DOM
 */

function isAnyContainerMounted() {
  return containers.size > 0;
}
/**
 * Get the container by id. Returns the last container declared when no id is given.
 */


function getContainer(containerId) {
  if (!isAnyContainerMounted()) return null;
  return containers.get(!containerId ? latestInstance : containerId);
}
/**
 * Get the toast by id, given it's in the DOM, otherwise returns null
 */


function getToast(toastId, _ref) {
  var containerId = _ref.containerId;
  var container = getContainer(containerId);
  if (!container) return null;
  return container.getToast(toastId);
}
/**
 * Generate a random toastId
 */


function generateToastId() {
  return (Math.random().toString(36) + Date.now().toString(36)).substr(2, 10);
}
/**
 * Generate a toastId or use the one provided
 */


function getToastId(options) {
  if (options && (isStr(options.toastId) || isNum(options.toastId))) {
    return options.toastId;
  }

  return generateToastId();
}
/**
 * If the container is not mounted, the toast is enqueued and
 * the container lazy mounted
 */


function dispatchToast(content, options) {
  if (isAnyContainerMounted()) {
    eventManager.emit(0
    /* Show */
    , content, options);
  } else {
    queue.push({
      content: content,
      options: options
    });

    if (lazy && canUseDom) {
      lazy = false;
      containerDomNode = document.createElement('div');
      document.body.appendChild(containerDomNode);
      (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.render)((0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(ToastContainer, Object.assign({}, containerConfig)), containerDomNode);
    }
  }

  return options.toastId;
}
/**
 * Merge provided options with the defaults settings and generate the toastId
 */


function mergeOptions(type, options) {
  return _extends({}, options, {
    type: options && options.type || type,
    toastId: getToastId(options)
  });
}

var toast = function toast(content, options) {
  return dispatchToast(content, mergeOptions(TYPE.DEFAULT, options));
};

toast.success = function (content, options) {
  return dispatchToast(content, mergeOptions(TYPE.SUCCESS, options));
};

toast.info = function (content, options) {
  return dispatchToast(content, mergeOptions(TYPE.INFO, options));
};

toast.error = function (content, options) {
  return dispatchToast(content, mergeOptions(TYPE.ERROR, options));
};

toast.warning = function (content, options) {
  return dispatchToast(content, mergeOptions(TYPE.WARNING, options));
};

toast.dark = function (content, options) {
  return dispatchToast(content, mergeOptions(TYPE.DARK, options));
};
/**
 * Maybe I should remove warning in favor of warn, I don't know
 */


toast.warn = toast.warning;
/**
 * Remove toast programmaticaly
 */

toast.dismiss = function (id) {
  return isAnyContainerMounted() && eventManager.emit(1
  /* Clear */
  , id);
};
/**
 * Clear waiting queue when limit is used
 */


toast.clearWaitingQueue = function (params) {
  if (params === void 0) {
    params = {};
  }

  return isAnyContainerMounted() && eventManager.emit(5
  /* ClearWaitingQueue */
  , params);
};
/**
 * return true if one container is displaying the toast
 */


toast.isActive = function (id) {
  var isToastActive = false;
  containers.forEach(function (container) {
    if (container.isToastActive && container.isToastActive(id)) {
      isToastActive = true;
    }
  });
  return isToastActive;
};

toast.update = function (toastId, options) {
  if (options === void 0) {
    options = {};
  }

  // if you call toast and toast.update directly nothing will be displayed
  // this is why I defered the update
  setTimeout(function () {
    var toast = getToast(toastId, options);

    if (toast) {
      var oldOptions = toast.props,
          oldContent = toast.content;

      var nextOptions = _extends({}, oldOptions, options, {
        toastId: options.toastId || toastId,
        updateId: generateToastId()
      });

      if (nextOptions.toastId !== toastId) nextOptions.staleId = toastId;
      var content = typeof nextOptions.render !== 'undefined' ? nextOptions.render : oldContent;
      delete nextOptions.render;
      dispatchToast(content, nextOptions);
    }
  }, 0);
};
/**
 * Used for controlled progress bar.
 */


toast.done = function (id) {
  toast.update(id, {
    progress: 1
  });
};
/**
 * Track changes. The callback get the number of toast displayed
 *
 */


toast.onChange = function (callback) {
  if (isFn(callback)) {
    eventManager.on(4
    /* Change */
    , callback);
  }

  return function () {
    isFn(callback) && eventManager.off(4
    /* Change */
    , callback);
  };
};
/**
 * Configure the ToastContainer when lazy mounted
 */


toast.configure = function (config) {
  if (config === void 0) {
    config = {};
  }

  lazy = true;
  containerConfig = config;
};

toast.POSITION = POSITION;
toast.TYPE = TYPE;
/**
 * Wait until the ToastContainer is mounted to dispatch the toast
 * and attach isActive method
 */

eventManager.on(2
/* DidMount */
, function (containerInstance) {
  latestInstance = containerInstance.containerId || containerInstance;
  containers.set(latestInstance, containerInstance);
  queue.forEach(function (item) {
    eventManager.emit(0
    /* Show */
    , item.content, item.options);
  });
  queue = [];
}).on(3
/* WillUnmount */
, function (containerInstance) {
  containers["delete"](containerInstance.containerId || containerInstance);

  if (containers.size === 0) {
    eventManager.off(0
    /* Show */
    ).off(1
    /* Clear */
    ).off(5
    /* ClearWaitingQueue */
    );
  }

  if (canUseDom && containerDomNode) {
    document.body.removeChild(containerDomNode);
  }
});


//# sourceMappingURL=react-toastify.esm.js.map


/***/ }),

/***/ 98885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ esm_Transition; }
});

// UNUSED EXPORTS: ENTERED, ENTERING, EXITED, EXITING, UNMOUNTED

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/config.js
/* harmony default export */ var config = ({
  disabled: false
});
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroupContext.js
var TransitionGroupContext = __webpack_require__(220);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/utils/reflow.js
var reflow = __webpack_require__(59391);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/Transition.js









var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) (0,reflow/* forceReflow */.Q)(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [react_dom.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : react_dom.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      react.createElement(TransitionGroupContext/* default.Provider */.Z.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : react.cloneElement(react.Children.only(children), childProps))
    );
  };

  return Transition;
}(react.Component);

Transition.contextType = TransitionGroupContext/* default */.Z;
Transition.propTypes =  false ? 0 : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ var esm_Transition = (Transition);

/***/ }),

/***/ 220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/* harmony default export */ __webpack_exports__["Z"] = (react__WEBPACK_IMPORTED_MODULE_0__.createContext(null));

/***/ }),

/***/ 59391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ forceReflow; }
/* harmony export */ });
var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};

/***/ }),

/***/ 94281:
/***/ (function(module) {

"use strict";


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var codes = {};

function createErrorType(code, message, Base) {
  if (!Base) {
    Base = Error;
  }

  function getMessage(arg1, arg2, arg3) {
    if (typeof message === 'string') {
      return message;
    } else {
      return message(arg1, arg2, arg3);
    }
  }

  var NodeError =
  /*#__PURE__*/
  function (_Base) {
    _inheritsLoose(NodeError, _Base);

    function NodeError(arg1, arg2, arg3) {
      return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
    }

    return NodeError;
  }(Base);

  NodeError.prototype.name = Base.name;
  NodeError.prototype.code = code;
  codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


function oneOf(expected, thing) {
  if (Array.isArray(expected)) {
    var len = expected.length;
    expected = expected.map(function (i) {
      return String(i);
    });

    if (len > 2) {
      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
    } else if (len === 2) {
      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
    } else {
      return "of ".concat(thing, " ").concat(expected[0]);
    }
  } else {
    return "of ".concat(thing, " ").concat(String(expected));
  }
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


function startsWith(str, search, pos) {
  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }

  return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


function includes(str, search, start) {
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > str.length) {
    return false;
  } else {
    return str.indexOf(search, start) !== -1;
  }
}

createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
  return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
  // determiner: 'must be' or 'must not be'
  var determiner;

  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
    determiner = 'must not be';
    expected = expected.replace(/^not /, '');
  } else {
    determiner = 'must be';
  }

  var msg;

  if (endsWith(name, ' argument')) {
    // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  } else {
    var type = includes(name, '.') ? 'property' : 'argument';
    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  }

  msg += ". Received type ".concat(typeof actual);
  return msg;
}, TypeError);
createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
  return 'The ' + name + ' method is not implemented';
});
createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
createErrorType('ERR_STREAM_DESTROYED', function (name) {
  return 'Cannot call ' + name + ' after a stream was destroyed';
});
createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
  return 'Unknown encoding: ' + arg;
}, TypeError);
createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
module.exports.q = codes;


/***/ }),

/***/ 56753:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
};
/*</replacement>*/

module.exports = Duplex;
var Readable = __webpack_require__(79481);
var Writable = __webpack_require__(64229);
__webpack_require__(35717)(Duplex, Readable);
{
  // Allow the keys array to be GC'ed.
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}
function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);
  Readable.call(this, options);
  Writable.call(this, options);
  this.allowHalfOpen = true;
  if (options) {
    if (options.readable === false) this.readable = false;
    if (options.writable === false) this.writable = false;
    if (options.allowHalfOpen === false) {
      this.allowHalfOpen = false;
      this.once('end', onend);
    }
  }
}
Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});
Object.defineProperty(Duplex.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
Object.defineProperty(Duplex.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});

// the no-half-open enforcer
function onend() {
  // If the writable side ended, then we're ok.
  if (this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  process.nextTick(onEndNT, this);
}
function onEndNT(self) {
  self.end();
}
Object.defineProperty(Duplex.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

/***/ }),

/***/ 82725:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;
var Transform = __webpack_require__(74605);
__webpack_require__(35717)(PassThrough, Transform);
function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);
  Transform.call(this, options);
}
PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),

/***/ 79481:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



module.exports = Readable;

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = (__webpack_require__(25293).EventEmitter);
var EElistenerCount = function EElistenerCount(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(22503);
/*</replacement>*/

var Buffer = (__webpack_require__(48764).Buffer);
var OurUint8Array = (typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*<replacement>*/
var debugUtil = __webpack_require__(94616);
var debug;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function debug() {};
}
/*</replacement>*/

var BufferList = __webpack_require__(57327);
var destroyImpl = __webpack_require__(61195);
var _require = __webpack_require__(82457),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = (__webpack_require__(94281)/* .codes */ .q),
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;

// Lazy loaded to improve the startup performance.
var StringDecoder;
var createReadableStreamAsyncIterator;
var from;
__webpack_require__(35717)(Readable, Stream);
var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}
function ReadableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__(56753);
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;
  this.paused = true;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'end' (and potentially 'finish')
  this.autoDestroy = !!options.autoDestroy;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;
  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = (__webpack_require__(32553).StringDecoder);
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}
function Readable(options) {
  Duplex = Duplex || __webpack_require__(56753);
  if (!(this instanceof Readable)) return new Readable(options);

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the ReadableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  this._readableState = new ReadableState(options, this, isDuplex);

  // legacy
  this.readable = true;
  if (options) {
    if (typeof options.read === 'function') this._read = options.read;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }
  Stream.call(this);
}
Object.defineProperty(Readable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;
  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }
  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  debug('readableAddChunk', chunk);
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      errorOrDestroy(stream, er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }
      if (addToFront) {
        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
      } else if (state.destroyed) {
        return false;
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
      maybeReadMore(stream, state);
    }
  }

  // We can push more data if we are below the highWaterMark.
  // Also, if we have no data yet, we can stand some more bytes.
  // This is to work around cases where hwm=0, such as the repl.
  return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    state.awaitDrain = 0;
    stream.emit('data', chunk);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
  }
  return er;
}
Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = (__webpack_require__(32553).StringDecoder);
  var decoder = new StringDecoder(enc);
  this._readableState.decoder = decoder;
  // If setEncoding(null), decoder.encoding equals utf8
  this._readableState.encoding = this._readableState.decoder.encoding;

  // Iterate over current buffer to convert already stored Buffers:
  var p = this._readableState.buffer.head;
  var content = '';
  while (p !== null) {
    content += decoder.write(p.data);
    p = p.next;
  }
  this._readableState.buffer.clear();
  if (content !== '') this._readableState.buffer.push(content);
  this._readableState.length = content.length;
  return this;
};

// Don't raise the hwm > 1GB
var MAX_HWM = 0x40000000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;
  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }
  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }
  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;
  if (ret === null) {
    state.needReadable = state.length <= state.highWaterMark;
    n = 0;
  } else {
    state.length -= n;
    state.awaitDrain = 0;
  }
  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }
  if (ret !== null) this.emit('data', ret);
  return ret;
};
function onEofChunk(stream, state) {
  debug('onEofChunk');
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;
  if (state.sync) {
    // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
  } else {
    // emit 'readable' now to make sure it gets picked up.
    state.needReadable = false;
    if (!state.emittedReadable) {
      state.emittedReadable = true;
      emitReadable_(stream);
    }
  }
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  debug('emitReadable', state.needReadable, state.emittedReadable);
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    process.nextTick(emitReadable_, stream);
  }
}
function emitReadable_(stream) {
  var state = stream._readableState;
  debug('emitReadable_', state.destroyed, state.length, state.ended);
  if (!state.destroyed && (state.length || state.ended)) {
    stream.emit('readable');
    state.emittedReadable = false;
  }

  // The stream needs another readable event if
  // 1. It is not flowing, as the flow mechanism will take
  //    care of it.
  // 2. It is not ended.
  // 3. It is below the highWaterMark, so we can schedule
  //    another readable later.
  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    process.nextTick(maybeReadMore_, stream, state);
  }
}
function maybeReadMore_(stream, state) {
  // Attempt to read more data if we should.
  //
  // The conditions for reading more data are (one of):
  // - Not enough data buffered (state.length < state.highWaterMark). The loop
  //   is responsible for filling the buffer with enough data if such data
  //   is available. If highWaterMark is 0 and we are not in the flowing mode
  //   we should _not_ attempt to buffer any extra data. We'll get more data
  //   when the stream consumer calls read() instead.
  // - No data in the buffer, and the stream is in flowing mode. In this mode
  //   the loop below is responsible for ensuring read() is called. Failing to
  //   call read here would abort the flow and there's no other mechanism for
  //   continuing the flow if the stream consumer has just subscribed to the
  //   'data' event.
  //
  // In addition to the above conditions to keep reading data, the following
  // conditions prevent the data from being read:
  // - The stream has ended (state.ended).
  // - There is already a pending 'read' operation (state.reading). This is a
  //   case where the the stream has called the implementation defined _read()
  //   method, but they are processing the call asynchronously and have _not_
  //   called push() with new data. In this case we skip performing more
  //   read()s. The execution ends in this method again after the _read() ends
  //   up calling push() with more data.
  while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
    var len = state.length;
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;
  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) process.nextTick(endFn);else src.once('end', endFn);
  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }
  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);
  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);
    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    debug('dest.write', ret);
    if (ret === false) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);
  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }
  return dest;
};
function pipeOnDrain(src) {
  return function pipeOnDrainFunctionResult() {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}
Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = {
    hasUnpiped: false
  };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;
    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    for (var i = 0; i < len; i++) dests[i].emit('unpipe', this, {
      hasUnpiped: false
    });
    return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;
  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];
  dest.emit('unpipe', this, unpipeInfo);
  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);
  var state = this._readableState;
  if (ev === 'data') {
    // update readableListening so that resume() may be a no-op
    // a few lines down. This is needed to support once('readable').
    state.readableListening = this.listenerCount('readable') > 0;

    // Try start flowing on next tick if stream isn't explicitly paused
    if (state.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.flowing = false;
      state.emittedReadable = false;
      debug('on readable', state.length, state.reading);
      if (state.length) {
        emitReadable(this);
      } else if (!state.reading) {
        process.nextTick(nReadingNextTick, this);
      }
    }
  }
  return res;
};
Readable.prototype.addListener = Readable.prototype.on;
Readable.prototype.removeListener = function (ev, fn) {
  var res = Stream.prototype.removeListener.call(this, ev, fn);
  if (ev === 'readable') {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
Readable.prototype.removeAllListeners = function (ev) {
  var res = Stream.prototype.removeAllListeners.apply(this, arguments);
  if (ev === 'readable' || ev === undefined) {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
function updateReadableListening(self) {
  var state = self._readableState;
  state.readableListening = self.listenerCount('readable') > 0;
  if (state.resumeScheduled && !state.paused) {
    // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;

    // crude way to check if we should resume
  } else if (self.listenerCount('data') > 0) {
    self.resume();
  }
}
function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    // we flow only if there is no one listening
    // for readable, but we still have to call
    // resume()
    state.flowing = !state.readableListening;
    resume(this, state);
  }
  state.paused = false;
  return this;
};
function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    process.nextTick(resume_, stream, state);
  }
}
function resume_(stream, state) {
  debug('resume', state.reading);
  if (!state.reading) {
    stream.read(0);
  }
  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (this._readableState.flowing !== false) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  this._readableState.paused = true;
  return this;
};
function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null);
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;
  var state = this._readableState;
  var paused = false;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }
    _this.push(null);
  });
  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };
  return this;
};
if (typeof Symbol === 'function') {
  Readable.prototype[Symbol.asyncIterator] = function () {
    if (createReadableStreamAsyncIterator === undefined) {
      createReadableStreamAsyncIterator = __webpack_require__(45850);
    }
    return createReadableStreamAsyncIterator(this);
  };
}
Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.highWaterMark;
  }
});
Object.defineProperty(Readable.prototype, 'readableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState && this._readableState.buffer;
  }
});
Object.defineProperty(Readable.prototype, 'readableFlowing', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.flowing;
  },
  set: function set(state) {
    if (this._readableState) {
      this._readableState.flowing = state;
    }
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, 'readableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.length;
  }
});

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;
  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.first();else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = state.buffer.consume(n, state.decoder);
  }
  return ret;
}
function endReadable(stream) {
  var state = stream._readableState;
  debug('endReadable', state.endEmitted);
  if (!state.endEmitted) {
    state.ended = true;
    process.nextTick(endReadableNT, state, stream);
  }
}
function endReadableNT(state, stream) {
  debug('endReadableNT', state.endEmitted, state.length);

  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
    if (state.autoDestroy) {
      // In case of duplex streams we need a way to detect
      // if the writable side is ready for autoDestroy as well
      var wState = stream._writableState;
      if (!wState || wState.autoDestroy && wState.finished) {
        stream.destroy();
      }
    }
  }
}
if (typeof Symbol === 'function') {
  Readable.from = function (iterable, opts) {
    if (from === undefined) {
      from = __webpack_require__(15167);
    }
    return from(Readable, iterable, opts);
  };
}
function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}

/***/ }),

/***/ 74605:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;
var _require$codes = (__webpack_require__(94281)/* .codes */ .q),
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING,
  ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
var Duplex = __webpack_require__(56753);
__webpack_require__(35717)(Transform, Duplex);
function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;
  var cb = ts.writecb;
  if (cb === null) {
    return this.emit('error', new ERR_MULTIPLE_CALLBACK());
  }
  ts.writechunk = null;
  ts.writecb = null;
  if (data != null)
    // single equals check for both `null` and `undefined`
    this.push(data);
  cb(er);
  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}
function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);
  Duplex.call(this, options);
  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;
  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;
    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}
function prefinish() {
  var _this = this;
  if (typeof this._flush === 'function' && !this._readableState.destroyed) {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}
Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;
  if (ts.writechunk !== null && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};
Transform.prototype._destroy = function (err, cb) {
  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
  });
};
function done(stream, er, data) {
  if (er) return stream.emit('error', er);
  if (data != null)
    // single equals check for both `null` and `undefined`
    stream.push(data);

  // TODO(BridgeAR): Write a test for these two error cases
  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
  if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
  return stream.push(null);
}

/***/ }),

/***/ 64229:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;
  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(94927)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(22503);
/*</replacement>*/

var Buffer = (__webpack_require__(48764).Buffer);
var OurUint8Array = (typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
var destroyImpl = __webpack_require__(61195);
var _require = __webpack_require__(82457),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = (__webpack_require__(94281)/* .codes */ .q),
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
  ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
  ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
  ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
var errorOrDestroy = destroyImpl.errorOrDestroy;
__webpack_require__(35717)(Writable, Stream);
function nop() {}
function WritableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__(56753);
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream,
  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;
  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'finish' (and potentially 'end')
  this.autoDestroy = !!options.autoDestroy;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};
(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function writableStateBufferGetter() {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function value(object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;
      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function realHasInstance(object) {
    return object instanceof this;
  };
}
function Writable(options) {
  Duplex = Duplex || __webpack_require__(56753);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the WritableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
  this._writableState = new WritableState(options, this, isDuplex);

  // legacy.
  this.writable = true;
  if (options) {
    if (typeof options.write === 'function') this._write = options.write;
    if (typeof options.writev === 'function') this._writev = options.writev;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
    if (typeof options.final === 'function') this._final = options.final;
  }
  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};
function writeAfterEnd(stream, cb) {
  var er = new ERR_STREAM_WRITE_AFTER_END();
  // TODO: defer error events consistently everywhere, not just the cb
  errorOrDestroy(stream, er);
  process.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var er;
  if (chunk === null) {
    er = new ERR_STREAM_NULL_VALUES();
  } else if (typeof chunk !== 'string' && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
  }
  if (er) {
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
    return false;
  }
  return true;
}
Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);
  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }
  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
  if (typeof cb !== 'function') cb = nop;
  if (state.ending) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }
  return ret;
};
Writable.prototype.cork = function () {
  this._writableState.corked++;
};
Writable.prototype.uncork = function () {
  var state = this._writableState;
  if (state.corked) {
    state.corked--;
    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};
Object.defineProperty(Writable.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}
Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;
  state.length += len;
  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;
  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }
  return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));else if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;
  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    process.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    process.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}
function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}
function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;
  if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
  onwriteStateUpdate(state);
  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state) || stream.destroyed;
    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }
    if (sync) {
      process.nextTick(afterWrite, stream, state, finished, cb);
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}
function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;
  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;
    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;
    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;
      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }
    if (entry === null) state.lastBufferedRequest = null;
  }
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}
Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
Writable.prototype._writev = null;
Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;
  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending) endWritable(this, state, cb);
  return this;
};
Object.defineProperty(Writable.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});
function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      errorOrDestroy(stream, err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function' && !state.destroyed) {
      state.pendingcb++;
      state.finalCalled = true;
      process.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}
function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
      if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well
        var rState = stream._readableState;
        if (!rState || rState.autoDestroy && rState.endEmitted) {
          stream.destroy();
        }
      }
    }
  }
  return need;
}
function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) process.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }

  // reuse the free corkReq.
  state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  cb(err);
};

/***/ }),

/***/ 45850:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);


var _Object$setPrototypeO;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var finished = __webpack_require__(8610);
var kLastResolve = Symbol('lastResolve');
var kLastReject = Symbol('lastReject');
var kError = Symbol('error');
var kEnded = Symbol('ended');
var kLastPromise = Symbol('lastPromise');
var kHandlePromise = Symbol('handlePromise');
var kStream = Symbol('stream');
function createIterResult(value, done) {
  return {
    value: value,
    done: done
  };
}
function readAndResolve(iter) {
  var resolve = iter[kLastResolve];
  if (resolve !== null) {
    var data = iter[kStream].read();
    // we defer if data is null
    // we can be expecting either 'end' or
    // 'error'
    if (data !== null) {
      iter[kLastPromise] = null;
      iter[kLastResolve] = null;
      iter[kLastReject] = null;
      resolve(createIterResult(data, false));
    }
  }
}
function onReadable(iter) {
  // we wait for the next tick, because it might
  // emit an error with process.nextTick
  process.nextTick(readAndResolve, iter);
}
function wrapForNext(lastPromise, iter) {
  return function (resolve, reject) {
    lastPromise.then(function () {
      if (iter[kEnded]) {
        resolve(createIterResult(undefined, true));
        return;
      }
      iter[kHandlePromise](resolve, reject);
    }, reject);
  };
}
var AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
  get stream() {
    return this[kStream];
  },
  next: function next() {
    var _this = this;
    // if we have detected an error in the meanwhile
    // reject straight away
    var error = this[kError];
    if (error !== null) {
      return Promise.reject(error);
    }
    if (this[kEnded]) {
      return Promise.resolve(createIterResult(undefined, true));
    }
    if (this[kStream].destroyed) {
      // We need to defer via nextTick because if .destroy(err) is
      // called, the error will be emitted via nextTick, and
      // we cannot guarantee that there is no error lingering around
      // waiting to be emitted.
      return new Promise(function (resolve, reject) {
        process.nextTick(function () {
          if (_this[kError]) {
            reject(_this[kError]);
          } else {
            resolve(createIterResult(undefined, true));
          }
        });
      });
    }

    // if we have multiple next() calls
    // we will wait for the previous Promise to finish
    // this logic is optimized to support for await loops,
    // where next() is only called once at a time
    var lastPromise = this[kLastPromise];
    var promise;
    if (lastPromise) {
      promise = new Promise(wrapForNext(lastPromise, this));
    } else {
      // fast path needed to support multiple this.push()
      // without triggering the next() queue
      var data = this[kStream].read();
      if (data !== null) {
        return Promise.resolve(createIterResult(data, false));
      }
      promise = new Promise(this[kHandlePromise]);
    }
    this[kLastPromise] = promise;
    return promise;
  }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function () {
  return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
  var _this2 = this;
  // destroy(err, cb) is a private API
  // we can guarantee we have that here, because we control the
  // Readable class this is attached to
  return new Promise(function (resolve, reject) {
    _this2[kStream].destroy(null, function (err) {
      if (err) {
        reject(err);
        return;
      }
      resolve(createIterResult(undefined, true));
    });
  });
}), _Object$setPrototypeO), AsyncIteratorPrototype);
var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
  var _Object$create;
  var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
    value: stream,
    writable: true
  }), _defineProperty(_Object$create, kLastResolve, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kLastReject, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kError, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kEnded, {
    value: stream._readableState.endEmitted,
    writable: true
  }), _defineProperty(_Object$create, kHandlePromise, {
    value: function value(resolve, reject) {
      var data = iterator[kStream].read();
      if (data) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        resolve(createIterResult(data, false));
      } else {
        iterator[kLastResolve] = resolve;
        iterator[kLastReject] = reject;
      }
    },
    writable: true
  }), _Object$create));
  iterator[kLastPromise] = null;
  finished(stream, function (err) {
    if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
      var reject = iterator[kLastReject];
      // reject if we are waiting for data in the Promise
      // returned by next() and store the error
      if (reject !== null) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        reject(err);
      }
      iterator[kError] = err;
      return;
    }
    var resolve = iterator[kLastResolve];
    if (resolve !== null) {
      iterator[kLastPromise] = null;
      iterator[kLastResolve] = null;
      iterator[kLastReject] = null;
      resolve(createIterResult(undefined, true));
    }
    iterator[kEnded] = true;
  });
  stream.on('readable', onReadable.bind(null, iterator));
  return iterator;
};
module.exports = createReadableStreamAsyncIterator;

/***/ }),

/***/ 57327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = __webpack_require__(48764),
  Buffer = _require.Buffer;
var _require2 = __webpack_require__(52361),
  inspect = _require2.inspect;
var custom = inspect && inspect.custom || 'inspect';
function copyBuffer(src, target, offset) {
  Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/function () {
  function BufferList() {
    _classCallCheck(this, BufferList);
    this.head = null;
    this.tail = null;
    this.length = 0;
  }
  _createClass(BufferList, [{
    key: "push",
    value: function push(v) {
      var entry = {
        data: v,
        next: null
      };
      if (this.length > 0) this.tail.next = entry;else this.head = entry;
      this.tail = entry;
      ++this.length;
    }
  }, {
    key: "unshift",
    value: function unshift(v) {
      var entry = {
        data: v,
        next: this.head
      };
      if (this.length === 0) this.tail = entry;
      this.head = entry;
      ++this.length;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (this.length === 0) return;
      var ret = this.head.data;
      if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
      --this.length;
      return ret;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = this.tail = null;
      this.length = 0;
    }
  }, {
    key: "join",
    value: function join(s) {
      if (this.length === 0) return '';
      var p = this.head;
      var ret = '' + p.data;
      while (p = p.next) ret += s + p.data;
      return ret;
    }
  }, {
    key: "concat",
    value: function concat(n) {
      if (this.length === 0) return Buffer.alloc(0);
      var ret = Buffer.allocUnsafe(n >>> 0);
      var p = this.head;
      var i = 0;
      while (p) {
        copyBuffer(p.data, ret, i);
        i += p.data.length;
        p = p.next;
      }
      return ret;
    }

    // Consumes a specified amount of bytes or characters from the buffered data.
  }, {
    key: "consume",
    value: function consume(n, hasStrings) {
      var ret;
      if (n < this.head.data.length) {
        // `slice` is the same for buffers and strings.
        ret = this.head.data.slice(0, n);
        this.head.data = this.head.data.slice(n);
      } else if (n === this.head.data.length) {
        // First chunk is a perfect match.
        ret = this.shift();
      } else {
        // Result spans more than one buffer.
        ret = hasStrings ? this._getString(n) : this._getBuffer(n);
      }
      return ret;
    }
  }, {
    key: "first",
    value: function first() {
      return this.head.data;
    }

    // Consumes a specified amount of characters from the buffered data.
  }, {
    key: "_getString",
    value: function _getString(n) {
      var p = this.head;
      var c = 1;
      var ret = p.data;
      n -= ret.length;
      while (p = p.next) {
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
          if (nb === str.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = str.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Consumes a specified amount of bytes from the buffered data.
  }, {
    key: "_getBuffer",
    value: function _getBuffer(n) {
      var ret = Buffer.allocUnsafe(n);
      var p = this.head;
      var c = 1;
      p.data.copy(ret);
      n -= p.data.length;
      while (p = p.next) {
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
          if (nb === buf.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = buf.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Make sure the linked list only shows the minimal necessary information.
  }, {
    key: custom,
    value: function value(_, options) {
      return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
        // Only inspect one level.
        depth: 0,
        // It should not recurse.
        customInspect: false
      }));
    }
  }]);
  return BufferList;
}();

/***/ }),

/***/ 61195:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);


// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;
  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;
  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        process.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        process.nextTick(emitErrorNT, this, err);
      }
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }
  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else {
        process.nextTick(emitCloseNT, _this);
      }
    } else if (cb) {
      process.nextTick(emitCloseNT, _this);
      cb(err);
    } else {
      process.nextTick(emitCloseNT, _this);
    }
  });
  return this;
}
function emitErrorAndCloseNT(self, err) {
  emitErrorNT(self, err);
  emitCloseNT(self);
}
function emitCloseNT(self) {
  if (self._writableState && !self._writableState.emitClose) return;
  if (self._readableState && !self._readableState.emitClose) return;
  self.emit('close');
}
function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }
  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}
function emitErrorNT(self, err) {
  self.emit('error', err);
}
function errorOrDestroy(stream, err) {
  // We have tests that rely on errors being emitted
  // in the same tick, so changing this is semver major.
  // For now when you opt-in to autoDestroy we allow
  // the error to be emitted nextTick. In a future
  // semver major update we should change the default to this.

  var rState = stream._readableState;
  var wState = stream._writableState;
  if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);else stream.emit('error', err);
}
module.exports = {
  destroy: destroy,
  undestroy: undestroy,
  errorOrDestroy: errorOrDestroy
};

/***/ }),

/***/ 8610:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).



var ERR_STREAM_PREMATURE_CLOSE = (__webpack_require__(94281)/* .codes.ERR_STREAM_PREMATURE_CLOSE */ .q.ERR_STREAM_PREMATURE_CLOSE);
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    callback.apply(this, args);
  };
}
function noop() {}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function eos(stream, opts, callback) {
  if (typeof opts === 'function') return eos(stream, null, opts);
  if (!opts) opts = {};
  callback = once(callback || noop);
  var readable = opts.readable || opts.readable !== false && stream.readable;
  var writable = opts.writable || opts.writable !== false && stream.writable;
  var onlegacyfinish = function onlegacyfinish() {
    if (!stream.writable) onfinish();
  };
  var writableEnded = stream._writableState && stream._writableState.finished;
  var onfinish = function onfinish() {
    writable = false;
    writableEnded = true;
    if (!readable) callback.call(stream);
  };
  var readableEnded = stream._readableState && stream._readableState.endEmitted;
  var onend = function onend() {
    readable = false;
    readableEnded = true;
    if (!writable) callback.call(stream);
  };
  var onerror = function onerror(err) {
    callback.call(stream, err);
  };
  var onclose = function onclose() {
    var err;
    if (readable && !readableEnded) {
      if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
    if (writable && !writableEnded) {
      if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
  };
  var onrequest = function onrequest() {
    stream.req.on('finish', onfinish);
  };
  if (isRequest(stream)) {
    stream.on('complete', onfinish);
    stream.on('abort', onclose);
    if (stream.req) onrequest();else stream.on('request', onrequest);
  } else if (writable && !stream._writableState) {
    // legacy streams
    stream.on('end', onlegacyfinish);
    stream.on('close', onlegacyfinish);
  }
  stream.on('end', onend);
  stream.on('finish', onfinish);
  if (opts.error !== false) stream.on('error', onerror);
  stream.on('close', onclose);
  return function () {
    stream.removeListener('complete', onfinish);
    stream.removeListener('abort', onclose);
    stream.removeListener('request', onrequest);
    if (stream.req) stream.req.removeListener('finish', onfinish);
    stream.removeListener('end', onlegacyfinish);
    stream.removeListener('close', onlegacyfinish);
    stream.removeListener('finish', onfinish);
    stream.removeListener('end', onend);
    stream.removeListener('error', onerror);
    stream.removeListener('close', onclose);
  };
}
module.exports = eos;

/***/ }),

/***/ 15167:
/***/ (function(module) {

module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};


/***/ }),

/***/ 59946:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).



var eos;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    callback.apply(void 0, arguments);
  };
}
var _require$codes = (__webpack_require__(94281)/* .codes */ .q),
  ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop(err) {
  // Rethrow the error if it exists to avoid swallowing it
  if (err) throw err;
}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function destroyer(stream, reading, writing, callback) {
  callback = once(callback);
  var closed = false;
  stream.on('close', function () {
    closed = true;
  });
  if (eos === undefined) eos = __webpack_require__(8610);
  eos(stream, {
    readable: reading,
    writable: writing
  }, function (err) {
    if (err) return callback(err);
    closed = true;
    callback();
  });
  var destroyed = false;
  return function (err) {
    if (closed) return;
    if (destroyed) return;
    destroyed = true;

    // request.destroy just do .end - .abort is what we want
    if (isRequest(stream)) return stream.abort();
    if (typeof stream.destroy === 'function') return stream.destroy();
    callback(err || new ERR_STREAM_DESTROYED('pipe'));
  };
}
function call(fn) {
  fn();
}
function pipe(from, to) {
  return from.pipe(to);
}
function popCallback(streams) {
  if (!streams.length) return noop;
  if (typeof streams[streams.length - 1] !== 'function') return noop;
  return streams.pop();
}
function pipeline() {
  for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
    streams[_key] = arguments[_key];
  }
  var callback = popCallback(streams);
  if (Array.isArray(streams[0])) streams = streams[0];
  if (streams.length < 2) {
    throw new ERR_MISSING_ARGS('streams');
  }
  var error;
  var destroys = streams.map(function (stream, i) {
    var reading = i < streams.length - 1;
    var writing = i > 0;
    return destroyer(stream, reading, writing, function (err) {
      if (!error) error = err;
      if (err) destroys.forEach(call);
      if (reading) return;
      destroys.forEach(call);
      callback(error);
    });
  });
  return streams.reduce(pipe);
}
module.exports = pipeline;

/***/ }),

/***/ 82457:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var ERR_INVALID_OPT_VALUE = (__webpack_require__(94281)/* .codes.ERR_INVALID_OPT_VALUE */ .q.ERR_INVALID_OPT_VALUE);
function highWaterMarkFrom(options, isDuplex, duplexKey) {
  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function getHighWaterMark(state, options, duplexKey, isDuplex) {
  var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
  if (hwm != null) {
    if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
      var name = isDuplex ? duplexKey : 'highWaterMark';
      throw new ERR_INVALID_OPT_VALUE(name, hwm);
    }
    return Math.floor(hwm);
  }

  // Default value
  return state.objectMode ? 16 : 16 * 1024;
}
module.exports = {
  getHighWaterMark: getHighWaterMark
};

/***/ }),

/***/ 22503:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(25293).EventEmitter;


/***/ }),

/***/ 88473:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(79481);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(64229);
exports.Duplex = __webpack_require__(56753);
exports.Transform = __webpack_require__(74605);
exports.PassThrough = __webpack_require__(82725);
exports.finished = __webpack_require__(8610);
exports.pipeline = __webpack_require__(59946);


/***/ }),

/***/ 28500:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var compose = (__webpack_require__(45217)/* .compose */ .qC);

__webpack_unused_export__ = true;
exports.Uo =
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : function () {
        if (arguments.length === 0) return undefined;
        if (typeof arguments[0] === 'object') return compose;
        return compose.apply(null, arguments);
      };

__webpack_unused_export__ =
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__
    ? window.__REDUX_DEVTOOLS_EXTENSION__
    : function () {
        return function (noop) {
          return noop;
        };
      };


/***/ }),

/***/ 11201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uR": function() { return /* reexport */ END; },
  "ZP": function() { return /* binding */ redux_saga_core_npm_proxy_esm; }
});

// UNUSED EXPORTS: CANCEL, SAGA_LOCATION, buffers, channel, detach, eventChannel, isEnd, multicastChannel, runSaga, stdChannel

// EXTERNAL MODULE: ./node_modules/@redux-saga/symbols/dist/redux-saga-symbols.esm.js
var redux_saga_symbols_esm = __webpack_require__(12470);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@redux-saga/is/dist/redux-saga-is.esm.js
var redux_saga_is_esm = __webpack_require__(52847);
// EXTERNAL MODULE: ./node_modules/@redux-saga/core/dist/io-c3792963.js + 1 modules
var io_c3792963 = __webpack_require__(83959);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js + 1 modules
var redux = __webpack_require__(45217);
;// CONCATENATED MODULE: ./node_modules/@redux-saga/deferred/dist/redux-saga-deferred.esm.js
function deferred() {
  var def = {};
  def.promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  return def;
}
function arrayOfDeferred(length) {
  var arr = [];

  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }

  return arr;
}

/* harmony default export */ var redux_saga_deferred_esm = (deferred);


;// CONCATENATED MODULE: ./node_modules/@redux-saga/core/dist/redux-saga-core.esm.js











var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/

var semaphore = 0;
/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/

function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release();
  }
}
/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/


function asap(task) {
  queue.push(task);

  if (!semaphore) {
    suspend();
    flush();
  }
}
/**
 * Puts the scheduler in a `suspended` state and executes a task immediately.
 */

function immediately(task) {
  try {
    suspend();
    return task();
  } finally {
    flush();
  }
}
/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/

function suspend() {
  semaphore++;
}
/**
  Puts the scheduler in a `released` state.
**/


function release() {
  semaphore--;
}
/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/


function flush() {
  release();
  var task;

  while (!semaphore && (task = queue.shift()) !== undefined) {
    exec(task);
  }
}

var array = function array(patterns) {
  return function (input) {
    return patterns.some(function (p) {
      return matcher(p)(input);
    });
  };
};
var predicate = function predicate(_predicate) {
  return function (input) {
    return _predicate(input);
  };
};
var string = function string(pattern) {
  return function (input) {
    return input.type === String(pattern);
  };
};
var symbol = function symbol(pattern) {
  return function (input) {
    return input.type === pattern;
  };
};
var wildcard = function wildcard() {
  return io_c3792963.k;
};
function matcher(pattern) {
  // prettier-ignore
  var matcherCreator = pattern === '*' ? wildcard : (0,redux_saga_is_esm/* string */.Z_)(pattern) ? string : (0,redux_saga_is_esm/* array */.IX)(pattern) ? array : (0,redux_saga_is_esm/* stringableFunc */.eR)(pattern) ? string : (0,redux_saga_is_esm/* func */.Yl)(pattern) ? predicate : (0,redux_saga_is_esm/* symbol */.NA)(pattern) ? symbol : null;

  if (matcherCreator === null) {
    throw new Error("invalid pattern: " + pattern);
  }

  return matcherCreator(pattern);
}

var END = {
  type: redux_saga_symbols_esm/* CHANNEL_END_TYPE */.sZ
};
var isEnd = function isEnd(a) {
  return a && a.type === redux_saga_symbols_esm/* CHANNEL_END_TYPE */.sZ;
};
var CLOSED_CHANNEL_WITH_TAKERS = 'Cannot have a closed channel with pending takers';
var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = "Saga or channel was provided with an undefined action\nHints:\n  - check that your Action Creator returns a non-undefined value\n  - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners";
function channel(buffer$1) {
  if (buffer$1 === void 0) {
    buffer$1 = (0,io_c3792963.e)();
  }

  var closed = false;
  var takers = [];

  if (false) {}

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw (0,io_c3792963.i)(CLOSED_CHANNEL_WITH_TAKERS);
    }

    if (takers.length && !buffer$1.isEmpty()) {
      throw (0,io_c3792963.i)('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    if (false) {}

    if (closed) {
      return;
    }

    if (takers.length === 0) {
      return buffer$1.put(input);
    }

    var cb = takers.shift();
    cb(input);
  }

  function take(cb) {
    if (false) {}

    if (closed && buffer$1.isEmpty()) {
      cb(END);
    } else if (!buffer$1.isEmpty()) {
      cb(buffer$1.take());
    } else {
      takers.push(cb);

      cb.cancel = function () {
        (0,io_c3792963.r)(takers, cb);
      };
    }
  }

  function flush(cb) {
    if (false) {}

    if (closed && buffer$1.isEmpty()) {
      cb(END);
      return;
    }

    cb(buffer$1.flush());
  }

  function close() {
    if (false) {}

    if (closed) {
      return;
    }

    closed = true;
    var arr = takers;
    takers = [];

    for (var i = 0, len = arr.length; i < len; i++) {
      var taker = arr[i];
      taker(END);
    }
  }

  return {
    take: take,
    put: put,
    flush: flush,
    close: close
  };
}
function eventChannel(subscribe, buffer) {
  if (buffer === void 0) {
    buffer = none();
  }

  var closed = false;
  var unsubscribe;
  var chan = channel(buffer);

  var close = function close() {
    if (closed) {
      return;
    }

    closed = true;

    if (func(unsubscribe)) {
      unsubscribe();
    }

    chan.close();
  };

  unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      close();
      return;
    }

    chan.put(input);
  });

  if (false) {}

  unsubscribe = once(unsubscribe);

  if (closed) {
    unsubscribe();
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: close
  };
}
function multicastChannel() {
  var _ref;

  var closed = false;
  var currentTakers = [];
  var nextTakers = currentTakers;

  function checkForbiddenStates() {
    if (closed && nextTakers.length) {
      throw (0,io_c3792963.i)(CLOSED_CHANNEL_WITH_TAKERS);
    }
  }

  var ensureCanMutateNextTakers = function ensureCanMutateNextTakers() {
    if (nextTakers !== currentTakers) {
      return;
    }

    nextTakers = currentTakers.slice();
  };

  var close = function close() {
    if (false) {}

    closed = true;
    var takers = currentTakers = nextTakers;
    nextTakers = [];
    takers.forEach(function (taker) {
      taker(END);
    });
  };

  return _ref = {}, _ref[redux_saga_symbols_esm/* MULTICAST */.AS] = true, _ref.put = function put(input) {
    if (false) {}

    if (closed) {
      return;
    }

    if (isEnd(input)) {
      close();
      return;
    }

    var takers = currentTakers = nextTakers;

    for (var i = 0, len = takers.length; i < len; i++) {
      var taker = takers[i];

      if (taker[redux_saga_symbols_esm/* MATCH */.uq](input)) {
        taker.cancel();
        taker(input);
      }
    }
  }, _ref.take = function take(cb, matcher) {
    if (matcher === void 0) {
      matcher = wildcard;
    }

    if (false) {}

    if (closed) {
      cb(END);
      return;
    }

    cb[redux_saga_symbols_esm/* MATCH */.uq] = matcher;
    ensureCanMutateNextTakers();
    nextTakers.push(cb);
    cb.cancel = (0,io_c3792963.o)(function () {
      ensureCanMutateNextTakers();
      (0,io_c3792963.r)(nextTakers, cb);
    });
  }, _ref.close = close, _ref;
}
function stdChannel() {
  var chan = multicastChannel();
  var put = chan.put;

  chan.put = function (input) {
    if (input[redux_saga_symbols_esm/* SAGA_ACTION */.Nm]) {
      put(input);
      return;
    }

    asap(function () {
      put(input);
    });
  };

  return chan;
}

var RUNNING = 0;
var CANCELLED = 1;
var ABORTED = 2;
var DONE = 3;

function resolvePromise(promise, cb) {
  var cancelPromise = promise[redux_saga_symbols_esm/* CANCEL */.n1];

  if ((0,redux_saga_is_esm/* func */.Yl)(cancelPromise)) {
    cb.cancel = cancelPromise;
  }

  promise.then(cb, function (error) {
    cb(error, true);
  });
}

var current = 0;
var nextSagaId = (function () {
  return ++current;
});

var _effectRunnerMap;

function getIteratorMetaInfo(iterator, fn) {
  if (iterator.isSagaIterator) {
    return {
      name: iterator.meta.name
    };
  }

  return (0,io_c3792963.j)(fn);
}

function createTaskIterator(_ref) {
  var context = _ref.context,
      fn = _ref.fn,
      args = _ref.args;

  // catch synchronous failures; see #152 and #441
  try {
    var result = fn.apply(context, args); // i.e. a generator function returns an iterator

    if ((0,redux_saga_is_esm/* iterator */.hZ)(result)) {
      return result;
    }

    var resolved = false;

    var next = function next(arg) {
      if (!resolved) {
        resolved = true; // Only promises returned from fork will be interpreted. See #1573

        return {
          value: result,
          done: !(0,redux_saga_is_esm/* promise */.MC)(result)
        };
      } else {
        return {
          value: arg,
          done: true
        };
      }
    };

    return (0,io_c3792963.q)(next);
  } catch (err) {
    // do not bubble up synchronous failures for detached forks
    // instead create a failed task. See #152 and #441
    return (0,io_c3792963.q)(function () {
      throw err;
    });
  }
}

function runPutEffect(env, _ref2, cb) {
  var channel = _ref2.channel,
      action = _ref2.action,
      resolve = _ref2.resolve;

  /**
   Schedule the put in case another saga is holding a lock.
   The put will be executed atomically. ie nested puts will execute after
   this put has terminated.
   **/
  asap(function () {
    var result;

    try {
      result = (channel ? channel.put : env.dispatch)(action);
    } catch (error) {
      cb(error, true);
      return;
    }

    if (resolve && (0,redux_saga_is_esm/* promise */.MC)(result)) {
      resolvePromise(result, cb);
    } else {
      cb(result);
    }
  }); // Put effects are non cancellables
}

function runTakeEffect(env, _ref3, cb) {
  var _ref3$channel = _ref3.channel,
      channel = _ref3$channel === void 0 ? env.channel : _ref3$channel,
      pattern = _ref3.pattern,
      maybe = _ref3.maybe;

  var takeCb = function takeCb(input) {
    if (input instanceof Error) {
      cb(input, true);
      return;
    }

    if (isEnd(input) && !maybe) {
      cb(redux_saga_symbols_esm/* TERMINATE */.EO);
      return;
    }

    cb(input);
  };

  try {
    channel.take(takeCb, (0,redux_saga_is_esm/* notUndef */.d5)(pattern) ? matcher(pattern) : null);
  } catch (err) {
    cb(err, true);
    return;
  }

  cb.cancel = takeCb.cancel;
}

function runCallEffect(env, _ref4, cb, _ref5) {
  var context = _ref4.context,
      fn = _ref4.fn,
      args = _ref4.args;
  var task = _ref5.task;

  // catch synchronous failures; see #152
  try {
    var result = fn.apply(context, args);

    if ((0,redux_saga_is_esm/* promise */.MC)(result)) {
      resolvePromise(result, cb);
      return;
    }

    if ((0,redux_saga_is_esm/* iterator */.hZ)(result)) {
      // resolve iterator
      proc(env, result, task.context, current, (0,io_c3792963.j)(fn),
      /* isRoot */
      false, cb);
      return;
    }

    cb(result);
  } catch (error) {
    cb(error, true);
  }
}

function runCPSEffect(env, _ref6, cb) {
  var context = _ref6.context,
      fn = _ref6.fn,
      args = _ref6.args;

  // CPS (ie node style functions) can define their own cancellation logic
  // by setting cancel field on the cb
  // catch synchronous failures; see #152
  try {
    var cpsCb = function cpsCb(err, res) {
      if ((0,redux_saga_is_esm/* undef */.sR)(err)) {
        cb(res);
      } else {
        cb(err, true);
      }
    };

    fn.apply(context, args.concat(cpsCb));

    if (cpsCb.cancel) {
      cb.cancel = cpsCb.cancel;
    }
  } catch (error) {
    cb(error, true);
  }
}

function runForkEffect(env, _ref7, cb, _ref8) {
  var context = _ref7.context,
      fn = _ref7.fn,
      args = _ref7.args,
      detached = _ref7.detached;
  var parent = _ref8.task;
  var taskIterator = createTaskIterator({
    context: context,
    fn: fn,
    args: args
  });
  var meta = getIteratorMetaInfo(taskIterator, fn);
  immediately(function () {
    var child = proc(env, taskIterator, parent.context, current, meta, detached, undefined);

    if (detached) {
      cb(child);
    } else {
      if (child.isRunning()) {
        parent.queue.addTask(child);
        cb(child);
      } else if (child.isAborted()) {
        parent.queue.abort(child.error());
      } else {
        cb(child);
      }
    }
  }); // Fork effects are non cancellables
}

function runJoinEffect(env, taskOrTasks, cb, _ref9) {
  var task = _ref9.task;

  var joinSingleTask = function joinSingleTask(taskToJoin, cb) {
    if (taskToJoin.isRunning()) {
      var joiner = {
        task: task,
        cb: cb
      };

      cb.cancel = function () {
        if (taskToJoin.isRunning()) (0,io_c3792963.r)(taskToJoin.joiners, joiner);
      };

      taskToJoin.joiners.push(joiner);
    } else {
      if (taskToJoin.isAborted()) {
        cb(taskToJoin.error(), true);
      } else {
        cb(taskToJoin.result());
      }
    }
  };

  if ((0,redux_saga_is_esm/* array */.IX)(taskOrTasks)) {
    if (taskOrTasks.length === 0) {
      cb([]);
      return;
    }

    var childCallbacks = (0,io_c3792963.l)(taskOrTasks, cb);
    taskOrTasks.forEach(function (t, i) {
      joinSingleTask(t, childCallbacks[i]);
    });
  } else {
    joinSingleTask(taskOrTasks, cb);
  }
}

function cancelSingleTask(taskToCancel) {
  if (taskToCancel.isRunning()) {
    taskToCancel.cancel();
  }
}

function runCancelEffect(env, taskOrTasks, cb, _ref10) {
  var task = _ref10.task;

  if (taskOrTasks === redux_saga_symbols_esm/* SELF_CANCELLATION */.sC) {
    cancelSingleTask(task);
  } else if ((0,redux_saga_is_esm/* array */.IX)(taskOrTasks)) {
    taskOrTasks.forEach(cancelSingleTask);
  } else {
    cancelSingleTask(taskOrTasks);
  }

  cb(); // cancel effects are non cancellables
}

function runAllEffect(env, effects, cb, _ref11) {
  var digestEffect = _ref11.digestEffect;
  var effectId = current;
  var keys = Object.keys(effects);

  if (keys.length === 0) {
    cb((0,redux_saga_is_esm/* array */.IX)(effects) ? [] : {});
    return;
  }

  var childCallbacks = (0,io_c3792963.l)(effects, cb);
  keys.forEach(function (key) {
    digestEffect(effects[key], effectId, childCallbacks[key], key);
  });
}

function runRaceEffect(env, effects, cb, _ref12) {
  var digestEffect = _ref12.digestEffect;
  var effectId = current;
  var keys = Object.keys(effects);
  var response = (0,redux_saga_is_esm/* array */.IX)(effects) ? (0,io_c3792963.m)(keys.length) : {};
  var childCbs = {};
  var completed = false;
  keys.forEach(function (key) {
    var chCbAtKey = function chCbAtKey(res, isErr) {
      if (completed) {
        return;
      }

      if (isErr || (0,io_c3792963.s)(res)) {
        // Race Auto cancellation
        cb.cancel();
        cb(res, isErr);
      } else {
        cb.cancel();
        completed = true;
        response[key] = res;
        cb(response);
      }
    };

    chCbAtKey.cancel = io_c3792963.t;
    childCbs[key] = chCbAtKey;
  });

  cb.cancel = function () {
    // prevents unnecessary cancellation
    if (!completed) {
      completed = true;
      keys.forEach(function (key) {
        return childCbs[key].cancel();
      });
    }
  };

  keys.forEach(function (key) {
    if (completed) {
      return;
    }

    digestEffect(effects[key], effectId, childCbs[key], key);
  });
}

function runSelectEffect(env, _ref13, cb) {
  var selector = _ref13.selector,
      args = _ref13.args;

  try {
    var state = selector.apply(void 0, [env.getState()].concat(args));
    cb(state);
  } catch (error) {
    cb(error, true);
  }
}

function runChannelEffect(env, _ref14, cb) {
  var pattern = _ref14.pattern,
      buffer = _ref14.buffer;
  var chan = channel(buffer);
  var match = matcher(pattern);

  var taker = function taker(action) {
    if (!isEnd(action)) {
      env.channel.take(taker, match);
    }

    chan.put(action);
  };

  var close = chan.close;

  chan.close = function () {
    taker.cancel();
    close();
  };

  env.channel.take(taker, match);
  cb(chan);
}

function runCancelledEffect(env, data, cb, _ref15) {
  var task = _ref15.task;
  cb(task.isCancelled());
}

function runFlushEffect(env, channel, cb) {
  channel.flush(cb);
}

function runGetContextEffect(env, prop, cb, _ref16) {
  var task = _ref16.task;
  cb(task.context[prop]);
}

function runSetContextEffect(env, props, cb, _ref17) {
  var task = _ref17.task;
  (0,io_c3792963.p)(task.context, props);
  cb();
}

var effectRunnerMap = (_effectRunnerMap = {}, _effectRunnerMap[io_c3792963.T] = runTakeEffect, _effectRunnerMap[io_c3792963.P] = runPutEffect, _effectRunnerMap[io_c3792963.A] = runAllEffect, _effectRunnerMap[io_c3792963.R] = runRaceEffect, _effectRunnerMap[io_c3792963.C] = runCallEffect, _effectRunnerMap[io_c3792963.a] = runCPSEffect, _effectRunnerMap[io_c3792963.F] = runForkEffect, _effectRunnerMap[io_c3792963.J] = runJoinEffect, _effectRunnerMap[io_c3792963.b] = runCancelEffect, _effectRunnerMap[io_c3792963.S] = runSelectEffect, _effectRunnerMap[io_c3792963.d] = runChannelEffect, _effectRunnerMap[io_c3792963.f] = runCancelledEffect, _effectRunnerMap[io_c3792963.g] = runFlushEffect, _effectRunnerMap[io_c3792963.G] = runGetContextEffect, _effectRunnerMap[io_c3792963.h] = runSetContextEffect, _effectRunnerMap);

/**
 Used to track a parent task and its forks
 In the fork model, forked tasks are attached by default to their parent
 We model this using the concept of Parent task && main Task
 main task is the main flow of the current Generator, the parent tasks is the
 aggregation of the main tasks + all its forked tasks.
 Thus the whole model represents an execution tree with multiple branches (vs the
 linear execution tree in sequential (non parallel) programming)

 A parent tasks has the following semantics
 - It completes if all its forks either complete or all cancelled
 - If it's cancelled, all forks are cancelled as well
 - It aborts if any uncaught error bubbles up from forks
 - If it completes, the return value is the one returned by the main task
 **/

function forkQueue(mainTask, onAbort, cont) {
  var tasks = [];
  var result;
  var completed = false;
  addTask(mainTask);

  var getTasks = function getTasks() {
    return tasks;
  };

  function abort(err) {
    onAbort();
    cancelAll();
    cont(err, true);
  }

  function addTask(task) {
    tasks.push(task);

    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      (0,io_c3792963.r)(tasks, task);
      task.cont = io_c3792963.t;

      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }

        if (!tasks.length) {
          completed = true;
          cont(result);
        }
      }
    };
  }

  function cancelAll() {
    if (completed) {
      return;
    }

    completed = true;
    tasks.forEach(function (t) {
      t.cont = io_c3792963.t;
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: getTasks
  };
}

// there can be only a single saga error created at any given moment

function formatLocation(fileName, lineNumber) {
  return fileName + "?" + lineNumber;
}

function effectLocationAsString(effect) {
  var location = (0,io_c3792963.v)(effect);

  if (location) {
    var code = location.code,
        fileName = location.fileName,
        lineNumber = location.lineNumber;
    var source = code + "  " + formatLocation(fileName, lineNumber);
    return source;
  }

  return '';
}

function sagaLocationAsString(sagaMeta) {
  var name = sagaMeta.name,
      location = sagaMeta.location;

  if (location) {
    return name + "  " + formatLocation(location.fileName, location.lineNumber);
  }

  return name;
}

function cancelledTasksAsString(sagaStack) {
  var cancelledTasks = (0,io_c3792963.u)(function (i) {
    return i.cancelledTasks;
  }, sagaStack);

  if (!cancelledTasks.length) {
    return '';
  }

  return ['Tasks cancelled due to error:'].concat(cancelledTasks).join('\n');
}

var crashedEffect = null;
var sagaStack = [];
var addSagaFrame = function addSagaFrame(frame) {
  frame.crashedEffect = crashedEffect;
  sagaStack.push(frame);
};
var clear = function clear() {
  crashedEffect = null;
  sagaStack.length = 0;
}; // this sets crashed effect for the soon-to-be-reported saga frame
// this slightly streatches the singleton nature of this module into wrong direction
// as it's even less obvious what's the data flow here, but it is what it is for now

var setCrashedEffect = function setCrashedEffect(effect) {
  crashedEffect = effect;
};
/**
  @returns {string}

  @example
  The above error occurred in task errorInPutSaga {pathToFile}
  when executing effect put({type: 'REDUCER_ACTION_ERROR_IN_PUT'}) {pathToFile}
      created by fetchSaga {pathToFile}
      created by rootSaga {pathToFile}
*/

var redux_saga_core_esm_toString = function toString() {
  var firstSaga = sagaStack[0],
      otherSagas = sagaStack.slice(1);
  var crashedEffectLocation = firstSaga.crashedEffect ? effectLocationAsString(firstSaga.crashedEffect) : null;
  var errorMessage = "The above error occurred in task " + sagaLocationAsString(firstSaga.meta) + (crashedEffectLocation ? " \n when executing effect " + crashedEffectLocation : '');
  return [errorMessage].concat(otherSagas.map(function (s) {
    return "    created by " + sagaLocationAsString(s.meta);
  }), [cancelledTasksAsString(sagaStack)]).join('\n');
};

function newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont) {
  var _task;

  if (cont === void 0) {
    cont = io_c3792963.t;
  }

  var status = RUNNING;
  var taskResult;
  var taskError;
  var deferredEnd = null;
  var cancelledDueToErrorTasks = [];
  var context = Object.create(parentContext);
  var queue = forkQueue(mainTask, function onAbort() {
    cancelledDueToErrorTasks.push.apply(cancelledDueToErrorTasks, queue.getTasks().map(function (t) {
      return t.meta.name;
    }));
  }, end);
  /**
   This may be called by a parent generator to trigger/propagate cancellation
   cancel all pending tasks (including the main task), then end the current task.
    Cancellation propagates down to the whole execution tree held by this Parent task
   It's also propagated to all joiners of this task and their execution tree/joiners
    Cancellation is noop for terminated/Cancelled tasks tasks
   **/

  function cancel() {
    if (status === RUNNING) {
      // Setting status to CANCELLED does not necessarily mean that the task/iterators are stopped
      // effects in the iterator's finally block will still be executed
      status = CANCELLED;
      queue.cancelAll(); // Ending with a TASK_CANCEL will propagate the Cancellation to all joiners

      end(redux_saga_symbols_esm/* TASK_CANCEL */.Wd, false);
    }
  }

  function end(result, isErr) {
    if (!isErr) {
      // The status here may be RUNNING or CANCELLED
      // If the status is CANCELLED, then we do not need to change it here
      if (result === redux_saga_symbols_esm/* TASK_CANCEL */.Wd) {
        status = CANCELLED;
      } else if (status !== CANCELLED) {
        status = DONE;
      }

      taskResult = result;
      deferredEnd && deferredEnd.resolve(result);
    } else {
      status = ABORTED;
      addSagaFrame({
        meta: meta,
        cancelledTasks: cancelledDueToErrorTasks
      });

      if (task.isRoot) {
        var sagaStack = redux_saga_core_esm_toString(); // we've dumped the saga stack to string and are passing it to user's code
        // we know that it won't be needed anymore and we need to clear it

        clear();
        env.onError(result, {
          sagaStack: sagaStack
        });
      }

      taskError = result;
      deferredEnd && deferredEnd.reject(result);
    }

    task.cont(result, isErr);
    task.joiners.forEach(function (joiner) {
      joiner.cb(result, isErr);
    });
    task.joiners = null;
  }

  function setContext(props) {
    if (false) {}

    (0,io_c3792963.p)(context, props);
  }

  function toPromise() {
    if (deferredEnd) {
      return deferredEnd.promise;
    }

    deferredEnd = redux_saga_deferred_esm();

    if (status === ABORTED) {
      deferredEnd.reject(taskError);
    } else if (status !== RUNNING) {
      deferredEnd.resolve(taskResult);
    }

    return deferredEnd.promise;
  }

  var task = (_task = {}, _task[redux_saga_symbols_esm/* TASK */.Cs] = true, _task.id = parentEffectId, _task.meta = meta, _task.isRoot = isRoot, _task.context = context, _task.joiners = [], _task.queue = queue, _task.cancel = cancel, _task.cont = cont, _task.end = end, _task.setContext = setContext, _task.toPromise = toPromise, _task.isRunning = function isRunning() {
    return status === RUNNING;
  }, _task.isCancelled = function isCancelled() {
    return status === CANCELLED || status === RUNNING && mainTask.status === CANCELLED;
  }, _task.isAborted = function isAborted() {
    return status === ABORTED;
  }, _task.result = function result() {
    return taskResult;
  }, _task.error = function error() {
    return taskError;
  }, _task);
  return task;
}

function proc(env, iterator$1, parentContext, parentEffectId, meta, isRoot, cont) {
  if (false) {}

  var finalRunEffect = env.finalizeRunEffect(runEffect);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/

  next.cancel = io_c3792963.t;
  /** Creates a main task to track the main flow */

  var mainTask = {
    meta: meta,
    cancel: cancelMain,
    status: RUNNING
  };
  /**
   Creates a new task descriptor for this generator.
   A task is the aggregation of it's mainTask and all it's forked tasks.
   **/

  var task = newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont);
  var executingContext = {
    task: task,
    digestEffect: digestEffect
  };
  /**
    cancellation of the main task. We'll simply resume the Generator with a TASK_CANCEL
  **/

  function cancelMain() {
    if (mainTask.status === RUNNING) {
      mainTask.status = CANCELLED;
      next(redux_saga_symbols_esm/* TASK_CANCEL */.Wd);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/


  if (cont) {
    cont.cancel = task.cancel;
  } // kicks up the generator


  next(); // then return the task descriptor to the caller

  return task;
  /**
   * This is the generator driver
   * It's a recursive async/continuation function which calls itself
   * until the generator terminates or throws
   * @param {internal commands(TASK_CANCEL | TERMINATE) | any} arg - value, generator will be resumed with.
   * @param {boolean} isErr - the flag shows if effect finished with an error
   *
   * receives either (command | effect result, false) or (any thrown thing, true)
   */

  function next(arg, isErr) {
    try {
      var result;

      if (isErr) {
        result = iterator$1.throw(arg); // user handled the error, we can clear bookkept values

        clear();
      } else if ((0,io_c3792963.y)(arg)) {
        /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.status = CANCELLED;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/

        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/

        result = (0,redux_saga_is_esm/* func */.Yl)(iterator$1.return) ? iterator$1.return(redux_saga_symbols_esm/* TASK_CANCEL */.Wd) : {
          done: true,
          value: redux_saga_symbols_esm/* TASK_CANCEL */.Wd
        };
      } else if ((0,io_c3792963.z)(arg)) {
        // We get TERMINATE flag, i.e. by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = (0,redux_saga_is_esm/* func */.Yl)(iterator$1.return) ? iterator$1.return() : {
          done: true
        };
      } else {
        result = iterator$1.next(arg);
      }

      if (!result.done) {
        digestEffect(result.value, parentEffectId, next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        if (mainTask.status !== CANCELLED) {
          mainTask.status = DONE;
        }

        mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.status === CANCELLED) {
        throw error;
      }

      mainTask.status = ABORTED;
      mainTask.cont(error, true);
    }
  }

  function runEffect(effect, effectId, currCb) {
    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      of completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    if ((0,redux_saga_is_esm/* promise */.MC)(effect)) {
      resolvePromise(effect, currCb);
    } else if ((0,redux_saga_is_esm/* iterator */.hZ)(effect)) {
      // resolve iterator
      proc(env, effect, task.context, effectId, meta,
      /* isRoot */
      false, currCb);
    } else if (effect && effect[redux_saga_symbols_esm.IO]) {
      var effectRunner = effectRunnerMap[effect.type];
      effectRunner(env, effect.payload, currCb, executingContext);
    } else {
      // anything else returned as is
      currCb(effect);
    }
  }

  function digestEffect(effect, parentEffectId, cb, label) {
    if (label === void 0) {
      label = '';
    }

    var effectId = nextSagaId();
    env.sagaMonitor && env.sagaMonitor.effectTriggered({
      effectId: effectId,
      parentEffectId: parentEffectId,
      label: label,
      effect: effect
    });
    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/

    var effectSettled; // Completion callback passed to the appropriate effect runner

    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = io_c3792963.t; // defensive measure

      if (env.sagaMonitor) {
        if (isErr) {
          env.sagaMonitor.effectRejected(effectId, res);
        } else {
          env.sagaMonitor.effectResolved(effectId, res);
        }
      }

      if (isErr) {
        setCrashedEffect(effect);
      }

      cb(res, isErr);
    } // tracks down the current cancel


    currCb.cancel = io_c3792963.t; // setup cancellation logic on the parent cb

    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      currCb.cancel(); // propagates cancel downward

      currCb.cancel = io_c3792963.t; // defensive measure

      env.sagaMonitor && env.sagaMonitor.effectCancelled(effectId);
    };

    finalRunEffect(effect, effectId, currCb);
  }
}

var RUN_SAGA_SIGNATURE = 'runSaga(options, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ": saga argument must be a Generator function!";
function runSaga(_ref, saga) {
  var _ref$channel = _ref.channel,
      channel = _ref$channel === void 0 ? stdChannel() : _ref$channel,
      dispatch = _ref.dispatch,
      getState = _ref.getState,
      _ref$context = _ref.context,
      context = _ref$context === void 0 ? {} : _ref$context,
      sagaMonitor = _ref.sagaMonitor,
      effectMiddlewares = _ref.effectMiddlewares,
      _ref$onError = _ref.onError,
      onError = _ref$onError === void 0 ? io_c3792963.B : _ref$onError;

  if (false) {}

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var iterator$1 = saga.apply(void 0, args);

  if (false) {}

  var effectId = nextSagaId();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.rootSagaStarted = sagaMonitor.rootSagaStarted || io_c3792963.t;
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || io_c3792963.t;
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || io_c3792963.t;
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || io_c3792963.t;
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || io_c3792963.t;
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || io_c3792963.t;
    sagaMonitor.rootSagaStarted({
      effectId: effectId,
      saga: saga,
      args: args
    });
  }

  if (false) { var MIDDLEWARE_TYPE_ERROR; }

  var finalizeRunEffect;

  if (effectMiddlewares) {
    var middleware = redux/* compose.apply */.qC.apply(void 0, effectMiddlewares);

    finalizeRunEffect = function finalizeRunEffect(runEffect) {
      return function (effect, effectId, currCb) {
        var plainRunEffect = function plainRunEffect(eff) {
          return runEffect(eff, effectId, currCb);
        };

        return middleware(plainRunEffect)(effect);
      };
    };
  } else {
    finalizeRunEffect = io_c3792963.E;
  }

  var env = {
    channel: channel,
    dispatch: (0,io_c3792963.D)(dispatch),
    getState: getState,
    sagaMonitor: sagaMonitor,
    onError: onError,
    finalizeRunEffect: finalizeRunEffect
  };
  return immediately(function () {
    var task = proc(env, iterator$1, context, effectId, (0,io_c3792963.j)(saga),
    /* isRoot */
    true, undefined);

    if (sagaMonitor) {
      sagaMonitor.effectResolved(effectId, task);
    }

    return task;
  });
}

function sagaMiddlewareFactory(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$context = _ref.context,
      context = _ref$context === void 0 ? {} : _ref$context,
      _ref$channel = _ref.channel,
      channel = _ref$channel === void 0 ? stdChannel() : _ref$channel,
      sagaMonitor = _ref.sagaMonitor,
      options = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["context", "channel", "sagaMonitor"]);

  var boundRunSaga;

  if (false) {}

  function sagaMiddleware(_ref2) {
    var getState = _ref2.getState,
        dispatch = _ref2.dispatch;
    boundRunSaga = runSaga.bind(null, (0,esm_extends/* default */.Z)({}, options, {
      context: context,
      channel: channel,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor
    }));
    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }

        var result = next(action); // hit reducers

        channel.put(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    if (false) {}

    return boundRunSaga.apply(void 0, arguments);
  };

  sagaMiddleware.setContext = function (props) {
    if (false) {}

    (0,io_c3792963.p)(context, props);
  };

  return sagaMiddleware;
}

/* harmony default export */ var redux_saga_core_esm = (sagaMiddlewareFactory);


;// CONCATENATED MODULE: ./node_modules/redux-saga/dist/redux-saga-core-npm-proxy.esm.js





/* harmony default export */ var redux_saga_core_npm_proxy_esm = (redux_saga_core_esm);


/***/ }),

/***/ 45217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "md": function() { return /* binding */ applyMiddleware; },
  "UY": function() { return /* binding */ combineReducers; },
  "qC": function() { return /* binding */ compose; },
  "MT": function() { return /* binding */ createStore; }
});

// UNUSED EXPORTS: __DO_NOT_USE__ActionTypes, bindActionCreators, legacy_createStore

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
;// CONCATENATED MODULE: ./node_modules/redux/es/redux.js


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (false) {}

  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 0);
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : 0);
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : 0);
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 0);
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 0);
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 0);
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : 0);
    }

    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 0);
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : 0);
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : 0);
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

var legacy_createStore = (/* unused pure expression or super */ null && (createStore));

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : 0);
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : 0);
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {}

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {}

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) { var warningMessage; }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : 0);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : 0);
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 0);
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2(_objectSpread2({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}




/***/ }),

/***/ 89509:
/***/ (function(module, exports, __webpack_require__) {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(48764)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ 87668:
/***/ (function(module, exports) {

"use strict";


const { hasOwnProperty } = Object.prototype

const stringify = configure()

// @ts-expect-error
stringify.configure = configure
// @ts-expect-error
stringify.stringify = stringify

// @ts-expect-error
stringify.default = stringify

// @ts-expect-error used for named export
exports.stringify = stringify
// @ts-expect-error used for named export
exports.configure = configure

module.exports = stringify

// eslint-disable-next-line no-control-regex
const strEscapeSequencesRegExp = /[\u0000-\u001f\u0022\u005c\ud800-\udfff]|[\ud800-\udbff](?![\udc00-\udfff])|(?:[^\ud800-\udbff]|^)[\udc00-\udfff]/

// Escape C0 control characters, double quotes, the backslash and every code
// unit with a numeric value in the inclusive range 0xD800 to 0xDFFF.
function strEscape (str) {
  // Some magic numbers that worked out fine while benchmarking with v8 8.0
  if (str.length < 5000 && !strEscapeSequencesRegExp.test(str)) {
    return `"${str}"`
  }
  return JSON.stringify(str)
}

function insertSort (array) {
  // Insertion sort is very efficient for small input sizes but it has a bad
  // worst case complexity. Thus, use native array sort for bigger values.
  if (array.length > 2e2) {
    return array.sort()
  }
  for (let i = 1; i < array.length; i++) {
    const currentValue = array[i]
    let position = i
    while (position !== 0 && array[position - 1] > currentValue) {
      array[position] = array[position - 1]
      position--
    }
    array[position] = currentValue
  }
  return array
}

const typedArrayPrototypeGetSymbolToStringTag =
  Object.getOwnPropertyDescriptor(
    Object.getPrototypeOf(
      Object.getPrototypeOf(
        new Int8Array()
      )
    ),
    Symbol.toStringTag
  ).get

function isTypedArrayWithEntries (value) {
  return typedArrayPrototypeGetSymbolToStringTag.call(value) !== undefined && value.length !== 0
}

function stringifyTypedArray (array, separator, maximumBreadth) {
  if (array.length < maximumBreadth) {
    maximumBreadth = array.length
  }
  const whitespace = separator === ',' ? '' : ' '
  let res = `"0":${whitespace}${array[0]}`
  for (let i = 1; i < maximumBreadth; i++) {
    res += `${separator}"${i}":${whitespace}${array[i]}`
  }
  return res
}

function getCircularValueOption (options) {
  if (hasOwnProperty.call(options, 'circularValue')) {
    const circularValue = options.circularValue
    if (typeof circularValue === 'string') {
      return `"${circularValue}"`
    }
    if (circularValue == null) {
      return circularValue
    }
    if (circularValue === Error || circularValue === TypeError) {
      return {
        toString () {
          throw new TypeError('Converting circular structure to JSON')
        }
      }
    }
    throw new TypeError('The "circularValue" argument must be of type string or the value null or undefined')
  }
  return '"[Circular]"'
}

function getBooleanOption (options, key) {
  let value
  if (hasOwnProperty.call(options, key)) {
    value = options[key]
    if (typeof value !== 'boolean') {
      throw new TypeError(`The "${key}" argument must be of type boolean`)
    }
  }
  return value === undefined ? true : value
}

function getPositiveIntegerOption (options, key) {
  let value
  if (hasOwnProperty.call(options, key)) {
    value = options[key]
    if (typeof value !== 'number') {
      throw new TypeError(`The "${key}" argument must be of type number`)
    }
    if (!Number.isInteger(value)) {
      throw new TypeError(`The "${key}" argument must be an integer`)
    }
    if (value < 1) {
      throw new RangeError(`The "${key}" argument must be >= 1`)
    }
  }
  return value === undefined ? Infinity : value
}

function getItemCount (number) {
  if (number === 1) {
    return '1 item'
  }
  return `${number} items`
}

function getUniqueReplacerSet (replacerArray) {
  const replacerSet = new Set()
  for (const value of replacerArray) {
    if (typeof value === 'string' || typeof value === 'number') {
      replacerSet.add(String(value))
    }
  }
  return replacerSet
}

function getStrictOption (options) {
  if (hasOwnProperty.call(options, 'strict')) {
    const value = options.strict
    if (typeof value !== 'boolean') {
      throw new TypeError('The "strict" argument must be of type boolean')
    }
    if (value) {
      return (value) => {
        let message = `Object can not safely be stringified. Received type ${typeof value}`
        if (typeof value !== 'function') message += ` (${value.toString()})`
        throw new Error(message)
      }
    }
  }
}

function configure (options) {
  options = { ...options }
  const fail = getStrictOption(options)
  if (fail) {
    if (options.bigint === undefined) {
      options.bigint = false
    }
    if (!('circularValue' in options)) {
      options.circularValue = Error
    }
  }
  const circularValue = getCircularValueOption(options)
  const bigint = getBooleanOption(options, 'bigint')
  const deterministic = getBooleanOption(options, 'deterministic')
  const maximumDepth = getPositiveIntegerOption(options, 'maximumDepth')
  const maximumBreadth = getPositiveIntegerOption(options, 'maximumBreadth')

  function stringifyFnReplacer (key, parent, stack, replacer, spacer, indentation) {
    let value = parent[key]

    if (typeof value === 'object' && value !== null && typeof value.toJSON === 'function') {
      value = value.toJSON(key)
    }
    value = replacer.call(parent, key, value)

    switch (typeof value) {
      case 'string':
        return strEscape(value)
      case 'object': {
        if (value === null) {
          return 'null'
        }
        if (stack.indexOf(value) !== -1) {
          return circularValue
        }

        let res = ''
        let join = ','
        const originalIndentation = indentation

        if (Array.isArray(value)) {
          if (value.length === 0) {
            return '[]'
          }
          if (maximumDepth < stack.length + 1) {
            return '"[Array]"'
          }
          stack.push(value)
          if (spacer !== '') {
            indentation += spacer
            res += `\n${indentation}`
            join = `,\n${indentation}`
          }
          const maximumValuesToStringify = Math.min(value.length, maximumBreadth)
          let i = 0
          for (; i < maximumValuesToStringify - 1; i++) {
            const tmp = stringifyFnReplacer(String(i), value, stack, replacer, spacer, indentation)
            res += tmp !== undefined ? tmp : 'null'
            res += join
          }
          const tmp = stringifyFnReplacer(String(i), value, stack, replacer, spacer, indentation)
          res += tmp !== undefined ? tmp : 'null'
          if (value.length - 1 > maximumBreadth) {
            const removedKeys = value.length - maximumBreadth - 1
            res += `${join}"... ${getItemCount(removedKeys)} not stringified"`
          }
          if (spacer !== '') {
            res += `\n${originalIndentation}`
          }
          stack.pop()
          return `[${res}]`
        }

        let keys = Object.keys(value)
        const keyLength = keys.length
        if (keyLength === 0) {
          return '{}'
        }
        if (maximumDepth < stack.length + 1) {
          return '"[Object]"'
        }
        let whitespace = ''
        let separator = ''
        if (spacer !== '') {
          indentation += spacer
          join = `,\n${indentation}`
          whitespace = ' '
        }
        const maximumPropertiesToStringify = Math.min(keyLength, maximumBreadth)
        if (deterministic && !isTypedArrayWithEntries(value)) {
          keys = insertSort(keys)
        }
        stack.push(value)
        for (let i = 0; i < maximumPropertiesToStringify; i++) {
          const key = keys[i]
          const tmp = stringifyFnReplacer(key, value, stack, replacer, spacer, indentation)
          if (tmp !== undefined) {
            res += `${separator}${strEscape(key)}:${whitespace}${tmp}`
            separator = join
          }
        }
        if (keyLength > maximumBreadth) {
          const removedKeys = keyLength - maximumBreadth
          res += `${separator}"...":${whitespace}"${getItemCount(removedKeys)} not stringified"`
          separator = join
        }
        if (spacer !== '' && separator.length > 1) {
          res = `\n${indentation}${res}\n${originalIndentation}`
        }
        stack.pop()
        return `{${res}}`
      }
      case 'number':
        return isFinite(value) ? String(value) : fail ? fail(value) : 'null'
      case 'boolean':
        return value === true ? 'true' : 'false'
      case 'undefined':
        return undefined
      case 'bigint':
        if (bigint) {
          return String(value)
        }
        // fallthrough
      default:
        return fail ? fail(value) : undefined
    }
  }

  function stringifyArrayReplacer (key, value, stack, replacer, spacer, indentation) {
    if (typeof value === 'object' && value !== null && typeof value.toJSON === 'function') {
      value = value.toJSON(key)
    }

    switch (typeof value) {
      case 'string':
        return strEscape(value)
      case 'object': {
        if (value === null) {
          return 'null'
        }
        if (stack.indexOf(value) !== -1) {
          return circularValue
        }

        const originalIndentation = indentation
        let res = ''
        let join = ','

        if (Array.isArray(value)) {
          if (value.length === 0) {
            return '[]'
          }
          if (maximumDepth < stack.length + 1) {
            return '"[Array]"'
          }
          stack.push(value)
          if (spacer !== '') {
            indentation += spacer
            res += `\n${indentation}`
            join = `,\n${indentation}`
          }
          const maximumValuesToStringify = Math.min(value.length, maximumBreadth)
          let i = 0
          for (; i < maximumValuesToStringify - 1; i++) {
            const tmp = stringifyArrayReplacer(String(i), value[i], stack, replacer, spacer, indentation)
            res += tmp !== undefined ? tmp : 'null'
            res += join
          }
          const tmp = stringifyArrayReplacer(String(i), value[i], stack, replacer, spacer, indentation)
          res += tmp !== undefined ? tmp : 'null'
          if (value.length - 1 > maximumBreadth) {
            const removedKeys = value.length - maximumBreadth - 1
            res += `${join}"... ${getItemCount(removedKeys)} not stringified"`
          }
          if (spacer !== '') {
            res += `\n${originalIndentation}`
          }
          stack.pop()
          return `[${res}]`
        }
        stack.push(value)
        let whitespace = ''
        if (spacer !== '') {
          indentation += spacer
          join = `,\n${indentation}`
          whitespace = ' '
        }
        let separator = ''
        for (const key of replacer) {
          const tmp = stringifyArrayReplacer(key, value[key], stack, replacer, spacer, indentation)
          if (tmp !== undefined) {
            res += `${separator}${strEscape(key)}:${whitespace}${tmp}`
            separator = join
          }
        }
        if (spacer !== '' && separator.length > 1) {
          res = `\n${indentation}${res}\n${originalIndentation}`
        }
        stack.pop()
        return `{${res}}`
      }
      case 'number':
        return isFinite(value) ? String(value) : fail ? fail(value) : 'null'
      case 'boolean':
        return value === true ? 'true' : 'false'
      case 'undefined':
        return undefined
      case 'bigint':
        if (bigint) {
          return String(value)
        }
        // fallthrough
      default:
        return fail ? fail(value) : undefined
    }
  }

  function stringifyIndent (key, value, stack, spacer, indentation) {
    switch (typeof value) {
      case 'string':
        return strEscape(value)
      case 'object': {
        if (value === null) {
          return 'null'
        }
        if (typeof value.toJSON === 'function') {
          value = value.toJSON(key)
          // Prevent calling `toJSON` again.
          if (typeof value !== 'object') {
            return stringifyIndent(key, value, stack, spacer, indentation)
          }
          if (value === null) {
            return 'null'
          }
        }
        if (stack.indexOf(value) !== -1) {
          return circularValue
        }
        const originalIndentation = indentation

        if (Array.isArray(value)) {
          if (value.length === 0) {
            return '[]'
          }
          if (maximumDepth < stack.length + 1) {
            return '"[Array]"'
          }
          stack.push(value)
          indentation += spacer
          let res = `\n${indentation}`
          const join = `,\n${indentation}`
          const maximumValuesToStringify = Math.min(value.length, maximumBreadth)
          let i = 0
          for (; i < maximumValuesToStringify - 1; i++) {
            const tmp = stringifyIndent(String(i), value[i], stack, spacer, indentation)
            res += tmp !== undefined ? tmp : 'null'
            res += join
          }
          const tmp = stringifyIndent(String(i), value[i], stack, spacer, indentation)
          res += tmp !== undefined ? tmp : 'null'
          if (value.length - 1 > maximumBreadth) {
            const removedKeys = value.length - maximumBreadth - 1
            res += `${join}"... ${getItemCount(removedKeys)} not stringified"`
          }
          res += `\n${originalIndentation}`
          stack.pop()
          return `[${res}]`
        }

        let keys = Object.keys(value)
        const keyLength = keys.length
        if (keyLength === 0) {
          return '{}'
        }
        if (maximumDepth < stack.length + 1) {
          return '"[Object]"'
        }
        indentation += spacer
        const join = `,\n${indentation}`
        let res = ''
        let separator = ''
        let maximumPropertiesToStringify = Math.min(keyLength, maximumBreadth)
        if (isTypedArrayWithEntries(value)) {
          res += stringifyTypedArray(value, join, maximumBreadth)
          keys = keys.slice(value.length)
          maximumPropertiesToStringify -= value.length
          separator = join
        }
        if (deterministic) {
          keys = insertSort(keys)
        }
        stack.push(value)
        for (let i = 0; i < maximumPropertiesToStringify; i++) {
          const key = keys[i]
          const tmp = stringifyIndent(key, value[key], stack, spacer, indentation)
          if (tmp !== undefined) {
            res += `${separator}${strEscape(key)}: ${tmp}`
            separator = join
          }
        }
        if (keyLength > maximumBreadth) {
          const removedKeys = keyLength - maximumBreadth
          res += `${separator}"...": "${getItemCount(removedKeys)} not stringified"`
          separator = join
        }
        if (separator !== '') {
          res = `\n${indentation}${res}\n${originalIndentation}`
        }
        stack.pop()
        return `{${res}}`
      }
      case 'number':
        return isFinite(value) ? String(value) : fail ? fail(value) : 'null'
      case 'boolean':
        return value === true ? 'true' : 'false'
      case 'undefined':
        return undefined
      case 'bigint':
        if (bigint) {
          return String(value)
        }
        // fallthrough
      default:
        return fail ? fail(value) : undefined
    }
  }

  function stringifySimple (key, value, stack) {
    switch (typeof value) {
      case 'string':
        return strEscape(value)
      case 'object': {
        if (value === null) {
          return 'null'
        }
        if (typeof value.toJSON === 'function') {
          value = value.toJSON(key)
          // Prevent calling `toJSON` again
          if (typeof value !== 'object') {
            return stringifySimple(key, value, stack)
          }
          if (value === null) {
            return 'null'
          }
        }
        if (stack.indexOf(value) !== -1) {
          return circularValue
        }

        let res = ''

        if (Array.isArray(value)) {
          if (value.length === 0) {
            return '[]'
          }
          if (maximumDepth < stack.length + 1) {
            return '"[Array]"'
          }
          stack.push(value)
          const maximumValuesToStringify = Math.min(value.length, maximumBreadth)
          let i = 0
          for (; i < maximumValuesToStringify - 1; i++) {
            const tmp = stringifySimple(String(i), value[i], stack)
            res += tmp !== undefined ? tmp : 'null'
            res += ','
          }
          const tmp = stringifySimple(String(i), value[i], stack)
          res += tmp !== undefined ? tmp : 'null'
          if (value.length - 1 > maximumBreadth) {
            const removedKeys = value.length - maximumBreadth - 1
            res += `,"... ${getItemCount(removedKeys)} not stringified"`
          }
          stack.pop()
          return `[${res}]`
        }

        let keys = Object.keys(value)
        const keyLength = keys.length
        if (keyLength === 0) {
          return '{}'
        }
        if (maximumDepth < stack.length + 1) {
          return '"[Object]"'
        }
        let separator = ''
        let maximumPropertiesToStringify = Math.min(keyLength, maximumBreadth)
        if (isTypedArrayWithEntries(value)) {
          res += stringifyTypedArray(value, ',', maximumBreadth)
          keys = keys.slice(value.length)
          maximumPropertiesToStringify -= value.length
          separator = ','
        }
        if (deterministic) {
          keys = insertSort(keys)
        }
        stack.push(value)
        for (let i = 0; i < maximumPropertiesToStringify; i++) {
          const key = keys[i]
          const tmp = stringifySimple(key, value[key], stack)
          if (tmp !== undefined) {
            res += `${separator}${strEscape(key)}:${tmp}`
            separator = ','
          }
        }
        if (keyLength > maximumBreadth) {
          const removedKeys = keyLength - maximumBreadth
          res += `${separator}"...":"${getItemCount(removedKeys)} not stringified"`
        }
        stack.pop()
        return `{${res}}`
      }
      case 'number':
        return isFinite(value) ? String(value) : fail ? fail(value) : 'null'
      case 'boolean':
        return value === true ? 'true' : 'false'
      case 'undefined':
        return undefined
      case 'bigint':
        if (bigint) {
          return String(value)
        }
        // fallthrough
      default:
        return fail ? fail(value) : undefined
    }
  }

  function stringify (value, replacer, space) {
    if (arguments.length > 1) {
      let spacer = ''
      if (typeof space === 'number') {
        spacer = ' '.repeat(Math.min(space, 10))
      } else if (typeof space === 'string') {
        spacer = space.slice(0, 10)
      }
      if (replacer != null) {
        if (typeof replacer === 'function') {
          return stringifyFnReplacer('', { '': value }, [], replacer, spacer, '')
        }
        if (Array.isArray(replacer)) {
          return stringifyArrayReplacer('', value, [], getUniqueReplacerSet(replacer), spacer, '')
        }
      }
      if (spacer.length !== 0) {
        return stringifyIndent('', value, [], spacer, '')
      }
    }
    return stringifySimple('', value, [])
  }

  return stringify
}


/***/ }),

/***/ 69328:
/***/ (function(module) {

"use strict";


var defaultParseOptions = {
  decodeValues: true,
  map: false,
  silent: false,
};

function isNonEmptyString(str) {
  return typeof str === "string" && !!str.trim();
}

function parseString(setCookieValue, options) {
  var parts = setCookieValue.split(";").filter(isNonEmptyString);

  var nameValuePairStr = parts.shift();
  var parsed = parseNameValuePair(nameValuePairStr);
  var name = parsed.name;
  var value = parsed.value;

  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  try {
    value = options.decodeValues ? decodeURIComponent(value) : value; // decode cookie value
  } catch (e) {
    console.error(
      "set-cookie-parser encountered an error while decoding a cookie with value '" +
        value +
        "'. Set options.decodeValues to false to disable this feature.",
      e
    );
  }

  var cookie = {
    name: name,
    value: value,
  };

  parts.forEach(function (part) {
    var sides = part.split("=");
    var key = sides.shift().trimLeft().toLowerCase();
    var value = sides.join("=");
    if (key === "expires") {
      cookie.expires = new Date(value);
    } else if (key === "max-age") {
      cookie.maxAge = parseInt(value, 10);
    } else if (key === "secure") {
      cookie.secure = true;
    } else if (key === "httponly") {
      cookie.httpOnly = true;
    } else if (key === "samesite") {
      cookie.sameSite = value;
    } else {
      cookie[key] = value;
    }
  });

  return cookie;
}

function parseNameValuePair(nameValuePairStr) {
  // Parses name-value-pair according to rfc6265bis draft

  var name = "";
  var value = "";
  var nameValueArr = nameValuePairStr.split("=");
  if (nameValueArr.length > 1) {
    name = nameValueArr.shift();
    value = nameValueArr.join("="); // everything after the first =, joined by a "=" if there was more than one part
  } else {
    value = nameValuePairStr;
  }

  return { name: name, value: value };
}

function parse(input, options) {
  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  if (!input) {
    if (!options.map) {
      return [];
    } else {
      return {};
    }
  }

  if (input.headers) {
    if (typeof input.headers.getSetCookie === "function") {
      // for fetch responses - they combine headers of the same type in the headers array,
      // but getSetCookie returns an uncombined array
      input = input.headers.getSetCookie();
    } else if (input.headers["set-cookie"]) {
      // fast-path for node.js (which automatically normalizes header names to lower-case
      input = input.headers["set-cookie"];
    } else {
      // slow-path for other environments - see #25
      var sch =
        input.headers[
          Object.keys(input.headers).find(function (key) {
            return key.toLowerCase() === "set-cookie";
          })
        ];
      // warn if called on a request-like object with a cookie header rather than a set-cookie header - see #34, 36
      if (!sch && input.headers.cookie && !options.silent) {
        console.warn(
          "Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning."
        );
      }
      input = sch;
    }
  }
  if (!Array.isArray(input)) {
    input = [input];
  }

  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  if (!options.map) {
    return input.filter(isNonEmptyString).map(function (str) {
      return parseString(str, options);
    });
  } else {
    var cookies = {};
    return input.filter(isNonEmptyString).reduce(function (cookies, str) {
      var cookie = parseString(str, options);
      cookies[cookie.name] = cookie;
      return cookies;
    }, cookies);
  }
}

/*
  Set-Cookie header field-values are sometimes comma joined in one string. This splits them without choking on commas
  that are within a single set-cookie field-value, such as in the Expires portion.

  This is uncommon, but explicitly allowed - see https://tools.ietf.org/html/rfc2616#section-4.2
  Node.js does this for every header *except* set-cookie - see https://github.com/nodejs/node/blob/d5e363b77ebaf1caf67cd7528224b651c86815c1/lib/_http_incoming.js#L128
  React Native's fetch does this for *every* header, including set-cookie.

  Based on: https://github.com/google/j2objc/commit/16820fdbc8f76ca0c33472810ce0cb03d20efe25
  Credits to: https://github.com/tomball for original and https://github.com/chrusart for JavaScript implementation
*/
function splitCookiesString(cookiesString) {
  if (Array.isArray(cookiesString)) {
    return cookiesString;
  }
  if (typeof cookiesString !== "string") {
    return [];
  }

  var cookiesStrings = [];
  var pos = 0;
  var start;
  var ch;
  var lastComma;
  var nextStart;
  var cookiesSeparatorFound;

  function skipWhitespace() {
    while (pos < cookiesString.length && /\s/.test(cookiesString.charAt(pos))) {
      pos += 1;
    }
    return pos < cookiesString.length;
  }

  function notSpecialChar() {
    ch = cookiesString.charAt(pos);

    return ch !== "=" && ch !== ";" && ch !== ",";
  }

  while (pos < cookiesString.length) {
    start = pos;
    cookiesSeparatorFound = false;

    while (skipWhitespace()) {
      ch = cookiesString.charAt(pos);
      if (ch === ",") {
        // ',' is a cookie separator if we have later first '=', not ';' or ','
        lastComma = pos;
        pos += 1;

        skipWhitespace();
        nextStart = pos;

        while (pos < cookiesString.length && notSpecialChar()) {
          pos += 1;
        }

        // currently special character
        if (pos < cookiesString.length && cookiesString.charAt(pos) === "=") {
          // we found cookies separator
          cookiesSeparatorFound = true;
          // pos is inside the next cookie, so back up and return it.
          pos = nextStart;
          cookiesStrings.push(cookiesString.substring(start, lastComma));
          start = pos;
        } else {
          // in param ',' or param separator ';',
          // we continue from that comma
          pos = lastComma + 1;
        }
      } else {
        pos += 1;
      }
    }

    if (!cookiesSeparatorFound || pos >= cookiesString.length) {
      cookiesStrings.push(cookiesString.substring(start, cookiesString.length));
    }
  }

  return cookiesStrings;
}

module.exports = parse;
module.exports.parse = parse;
module.exports.parseString = parseString;
module.exports.splitCookiesString = splitCookiesString;


/***/ }),

/***/ 77911:
/***/ (function(__unused_webpack_module, exports) {

exports.get = function(belowFn) {
  var oldLimit = Error.stackTraceLimit;
  Error.stackTraceLimit = Infinity;

  var dummyObject = {};

  var v8Handler = Error.prepareStackTrace;
  Error.prepareStackTrace = function(dummyObject, v8StackTrace) {
    return v8StackTrace;
  };
  Error.captureStackTrace(dummyObject, belowFn || exports.get);

  var v8StackTrace = dummyObject.stack;
  Error.prepareStackTrace = v8Handler;
  Error.stackTraceLimit = oldLimit;

  return v8StackTrace;
};

exports.parse = function(err) {
  if (!err.stack) {
    return [];
  }

  var self = this;
  var lines = err.stack.split('\n').slice(1);

  return lines
    .map(function(line) {
      if (line.match(/^\s*[-]{4,}$/)) {
        return self._createParsedCallSite({
          fileName: line,
          lineNumber: null,
          functionName: null,
          typeName: null,
          methodName: null,
          columnNumber: null,
          'native': null,
        });
      }

      var lineMatch = line.match(/at (?:(.+)\s+\()?(?:(.+?):(\d+)(?::(\d+))?|([^)]+))\)?/);
      if (!lineMatch) {
        return;
      }

      var object = null;
      var method = null;
      var functionName = null;
      var typeName = null;
      var methodName = null;
      var isNative = (lineMatch[5] === 'native');

      if (lineMatch[1]) {
        functionName = lineMatch[1];
        var methodStart = functionName.lastIndexOf('.');
        if (functionName[methodStart-1] == '.')
          methodStart--;
        if (methodStart > 0) {
          object = functionName.substr(0, methodStart);
          method = functionName.substr(methodStart + 1);
          var objectEnd = object.indexOf('.Module');
          if (objectEnd > 0) {
            functionName = functionName.substr(objectEnd + 1);
            object = object.substr(0, objectEnd);
          }
        }
        typeName = null;
      }

      if (method) {
        typeName = object;
        methodName = method;
      }

      if (method === '<anonymous>') {
        methodName = null;
        functionName = null;
      }

      var properties = {
        fileName: lineMatch[2] || null,
        lineNumber: parseInt(lineMatch[3], 10) || null,
        functionName: functionName,
        typeName: typeName,
        methodName: methodName,
        columnNumber: parseInt(lineMatch[4], 10) || null,
        'native': isNative,
      };

      return self._createParsedCallSite(properties);
    })
    .filter(function(callSite) {
      return !!callSite;
    });
};

function CallSite(properties) {
  for (var property in properties) {
    this[property] = properties[property];
  }
}

var strProperties = [
  'this',
  'typeName',
  'functionName',
  'methodName',
  'fileName',
  'lineNumber',
  'columnNumber',
  'function',
  'evalOrigin'
];
var boolProperties = [
  'topLevel',
  'eval',
  'native',
  'constructor'
];
strProperties.forEach(function (property) {
  CallSite.prototype[property] = null;
  CallSite.prototype['get' + property[0].toUpperCase() + property.substr(1)] = function () {
    return this[property];
  }
});
boolProperties.forEach(function (property) {
  CallSite.prototype[property] = false;
  CallSite.prototype['is' + property[0].toUpperCase() + property.substr(1)] = function () {
    return this[property];
  }
});

exports._createParsedCallSite = function(properties) {
  return new CallSite(properties);
};


/***/ }),

/***/ 32553:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = (__webpack_require__(89509).Buffer);
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),

/***/ 84207:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var process = __webpack_require__(83454);
/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 583:
/***/ (function(module) {



function hash(str) {
  var hash = 5381,
      i    = str.length;

  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }

  /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */
  return hash >>> 0;
}

module.exports = hash;


/***/ }),

/***/ 590:
/***/ (function(__unused_webpack_module, exports, __nccwpck_require__) {



exports.__esModule = true;
exports.computeId = computeId;
exports.computeSelector = computeSelector;

var _stringHash = _interopRequireDefault(__nccwpck_require__(583));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var sanitize = function sanitize(rule) {
  return rule.replace(/\/style/gi, '\\/style');
};

var cache = {};
/**
 * computeId
 *
 * Compute and memoize a jsx id from a basedId and optionally props.
 */

function computeId(baseId, props) {
  if (!props) {
    return "jsx-" + baseId;
  }

  var propsToString = String(props);
  var key = baseId + propsToString;

  if (!cache[key]) {
    cache[key] = "jsx-" + (0, _stringHash["default"])(baseId + "-" + propsToString);
  }

  return cache[key];
}
/**
 * computeSelector
 *
 * Compute and memoize dynamic selectors.
 */


function computeSelector(id, css) {
  var selectoPlaceholderRegexp = /__jsx-style-dynamic-selector/g; // Sanitize SSR-ed CSS.
  // Client side code doesn't need to be sanitized since we use
  // document.createTextNode (dev) and the CSSOM api sheet.insertRule (prod).

  if (typeof window === 'undefined') {
    css = sanitize(css);
  }

  var idcss = id + css;

  if (!cache[idcss]) {
    cache[idcss] = css.replace(selectoPlaceholderRegexp, id);
  }

  return cache[idcss];
}

/***/ }),

/***/ 503:
/***/ (function(__unused_webpack_module, exports) {



exports.__esModule = true;
exports["default"] = void 0;

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*
Based on Glamor's sheet
https://github.com/threepointone/glamor/blob/667b480d31b3721a905021b26e1290ce92ca2879/src/sheet.js
*/
var isProd = typeof process !== 'undefined' && process.env && "production" === 'production';

var isString = function isString(o) {
  return Object.prototype.toString.call(o) === '[object String]';
};

var StyleSheet = /*#__PURE__*/function () {
  function StyleSheet(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        _ref$name = _ref.name,
        name = _ref$name === void 0 ? 'stylesheet' : _ref$name,
        _ref$optimizeForSpeed = _ref.optimizeForSpeed,
        optimizeForSpeed = _ref$optimizeForSpeed === void 0 ? isProd : _ref$optimizeForSpeed,
        _ref$isBrowser = _ref.isBrowser,
        isBrowser = _ref$isBrowser === void 0 ? typeof window !== 'undefined' : _ref$isBrowser;

    invariant(isString(name), '`name` must be a string');
    this._name = name;
    this._deletedRulePlaceholder = "#" + name + "-deleted-rule____{}";
    invariant(typeof optimizeForSpeed === 'boolean', '`optimizeForSpeed` must be a boolean');
    this._optimizeForSpeed = optimizeForSpeed;
    this._isBrowser = isBrowser;
    this._serverSheet = undefined;
    this._tags = [];
    this._injected = false;
    this._rulesCount = 0;
    var node = this._isBrowser && document.querySelector('meta[property="csp-nonce"]');
    this._nonce = node ? node.getAttribute('content') : null;
  }

  var _proto = StyleSheet.prototype;

  _proto.setOptimizeForSpeed = function setOptimizeForSpeed(bool) {
    invariant(typeof bool === 'boolean', '`setOptimizeForSpeed` accepts a boolean');
    invariant(this._rulesCount === 0, 'optimizeForSpeed cannot be when rules have already been inserted');
    this.flush();
    this._optimizeForSpeed = bool;
    this.inject();
  };

  _proto.isOptimizeForSpeed = function isOptimizeForSpeed() {
    return this._optimizeForSpeed;
  };

  _proto.inject = function inject() {
    var _this = this;

    invariant(!this._injected, 'sheet already injected');
    this._injected = true;

    if (this._isBrowser && this._optimizeForSpeed) {
      this._tags[0] = this.makeStyleTag(this._name);
      this._optimizeForSpeed = 'insertRule' in this.getSheet();

      if (!this._optimizeForSpeed) {
        if (!isProd) {
          console.warn('StyleSheet: optimizeForSpeed mode not supported falling back to standard mode.');
        }

        this.flush();
        this._injected = true;
      }

      return;
    }

    this._serverSheet = {
      cssRules: [],
      insertRule: function insertRule(rule, index) {
        if (typeof index === 'number') {
          _this._serverSheet.cssRules[index] = {
            cssText: rule
          };
        } else {
          _this._serverSheet.cssRules.push({
            cssText: rule
          });
        }

        return index;
      },
      deleteRule: function deleteRule(index) {
        _this._serverSheet.cssRules[index] = null;
      }
    };
  };

  _proto.getSheetForTag = function getSheetForTag(tag) {
    if (tag.sheet) {
      return tag.sheet;
    } // this weirdness brought to you by firefox


    for (var i = 0; i < document.styleSheets.length; i++) {
      if (document.styleSheets[i].ownerNode === tag) {
        return document.styleSheets[i];
      }
    }
  };

  _proto.getSheet = function getSheet() {
    return this.getSheetForTag(this._tags[this._tags.length - 1]);
  };

  _proto.insertRule = function insertRule(rule, index) {
    invariant(isString(rule), '`insertRule` accepts only strings');

    if (!this._isBrowser) {
      if (typeof index !== 'number') {
        index = this._serverSheet.cssRules.length;
      }

      this._serverSheet.insertRule(rule, index);

      return this._rulesCount++;
    }

    if (this._optimizeForSpeed) {
      var sheet = this.getSheet();

      if (typeof index !== 'number') {
        index = sheet.cssRules.length;
      } // this weirdness for perf, and chrome's weird bug
      // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule


      try {
        sheet.insertRule(rule, index);
      } catch (error) {
        if (!isProd) {
          console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
        }

        return -1;
      }
    } else {
      var insertionPoint = this._tags[index];

      this._tags.push(this.makeStyleTag(this._name, rule, insertionPoint));
    }

    return this._rulesCount++;
  };

  _proto.replaceRule = function replaceRule(index, rule) {
    if (this._optimizeForSpeed || !this._isBrowser) {
      var sheet = this._isBrowser ? this.getSheet() : this._serverSheet;

      if (!rule.trim()) {
        rule = this._deletedRulePlaceholder;
      }

      if (!sheet.cssRules[index]) {
        // @TBD Should we throw an error?
        return index;
      }

      sheet.deleteRule(index);

      try {
        sheet.insertRule(rule, index);
      } catch (error) {
        if (!isProd) {
          console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
        } // In order to preserve the indices we insert a deleteRulePlaceholder


        sheet.insertRule(this._deletedRulePlaceholder, index);
      }
    } else {
      var tag = this._tags[index];
      invariant(tag, "old rule at index `" + index + "` not found");
      tag.textContent = rule;
    }

    return index;
  };

  _proto.deleteRule = function deleteRule(index) {
    if (!this._isBrowser) {
      this._serverSheet.deleteRule(index);

      return;
    }

    if (this._optimizeForSpeed) {
      this.replaceRule(index, '');
    } else {
      var tag = this._tags[index];
      invariant(tag, "rule at index `" + index + "` not found");
      tag.parentNode.removeChild(tag);
      this._tags[index] = null;
    }
  };

  _proto.flush = function flush() {
    this._injected = false;
    this._rulesCount = 0;

    if (this._isBrowser) {
      this._tags.forEach(function (tag) {
        return tag && tag.parentNode.removeChild(tag);
      });

      this._tags = [];
    } else {
      // simpler on server
      this._serverSheet.cssRules = [];
    }
  };

  _proto.cssRules = function cssRules() {
    var _this2 = this;

    if (!this._isBrowser) {
      return this._serverSheet.cssRules;
    }

    return this._tags.reduce(function (rules, tag) {
      if (tag) {
        rules = rules.concat(Array.prototype.map.call(_this2.getSheetForTag(tag).cssRules, function (rule) {
          return rule.cssText === _this2._deletedRulePlaceholder ? null : rule;
        }));
      } else {
        rules.push(null);
      }

      return rules;
    }, []);
  };

  _proto.makeStyleTag = function makeStyleTag(name, cssString, relativeToTag) {
    if (cssString) {
      invariant(isString(cssString), 'makeStyleTag accepts only strings as second parameter');
    }

    var tag = document.createElement('style');
    if (this._nonce) tag.setAttribute('nonce', this._nonce);
    tag.type = 'text/css';
    tag.setAttribute("data-" + name, '');

    if (cssString) {
      tag.appendChild(document.createTextNode(cssString));
    }

    var head = document.head || document.getElementsByTagName('head')[0];

    if (relativeToTag) {
      head.insertBefore(tag, relativeToTag);
    } else {
      head.appendChild(tag);
    }

    return tag;
  };

  _createClass(StyleSheet, [{
    key: "length",
    get: function get() {
      return this._rulesCount;
    }
  }]);

  return StyleSheet;
}();

exports["default"] = StyleSheet;

function invariant(condition, message) {
  if (!condition) {
    throw new Error("StyleSheet: " + message + ".");
  }
}

/***/ }),

/***/ 449:
/***/ (function(__unused_webpack_module, exports, __nccwpck_require__) {



exports.__esModule = true;
exports["default"] = JSXStyle;

var _react = _interopRequireDefault(__nccwpck_require__(522));

var _stylesheetRegistry = __nccwpck_require__(147);

var _hash = __nccwpck_require__(590);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Opt-into the new `useInsertionEffect` API in React 18, fallback to `useLayoutEffect`.
// https://github.com/reactwg/react-18/discussions/110
var useInsertionEffect = _react["default"].useInsertionEffect || _react["default"].useLayoutEffect;
var defaultRegistry = typeof window !== 'undefined' ? (0, _stylesheetRegistry.createStyleRegistry)() : undefined;

function JSXStyle(props) {
  var registry = defaultRegistry ? defaultRegistry : (0, _stylesheetRegistry.useStyleRegistry)(); // If `registry` does not exist, we do nothing here.

  if (!registry) {
    return null;
  }

  if (typeof window === 'undefined') {
    registry.add(props);
    return null;
  }

  useInsertionEffect(function () {
    registry.add(props);
    return function () {
      registry.remove(props);
    }; // props.children can be string[], will be striped since id is identical
  }, [props.id, String(props.dynamic)]);
  return null;
}

JSXStyle.dynamic = function (info) {
  return info.map(function (tagInfo) {
    var baseId = tagInfo[0];
    var props = tagInfo[1];
    return (0, _hash.computeId)(baseId, props);
  }).join(' ');
};

/***/ }),

/***/ 147:
/***/ (function(__unused_webpack_module, exports, __nccwpck_require__) {



exports.__esModule = true;
exports.createStyleRegistry = createStyleRegistry;
exports.StyleRegistry = StyleRegistry;
exports.useStyleRegistry = useStyleRegistry;
exports.StyleSheetContext = exports.StyleSheetRegistry = void 0;

var _react = _interopRequireWildcard(__nccwpck_require__(522));

var _stylesheet = _interopRequireDefault(__nccwpck_require__(503));

var _hash = __nccwpck_require__(590);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function mapRulesToStyle(cssRules, options) {
  if (options === void 0) {
    options = {};
  }

  return cssRules.map(function (args) {
    var id = args[0];
    var css = args[1];
    return _react["default"].createElement('style', {
      id: "__" + id,
      // Avoid warnings upon render with a key
      key: "__" + id,
      nonce: options.nonce ? options.nonce : undefined,
      dangerouslySetInnerHTML: {
        __html: css
      }
    });
  });
}

var StyleSheetRegistry = /*#__PURE__*/function () {
  function StyleSheetRegistry(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        _ref$styleSheet = _ref.styleSheet,
        styleSheet = _ref$styleSheet === void 0 ? null : _ref$styleSheet,
        _ref$optimizeForSpeed = _ref.optimizeForSpeed,
        optimizeForSpeed = _ref$optimizeForSpeed === void 0 ? false : _ref$optimizeForSpeed,
        _ref$isBrowser = _ref.isBrowser,
        isBrowser = _ref$isBrowser === void 0 ? typeof window !== 'undefined' : _ref$isBrowser;

    this._sheet = styleSheet || new _stylesheet["default"]({
      name: 'styled-jsx',
      optimizeForSpeed: optimizeForSpeed
    });

    this._sheet.inject();

    if (styleSheet && typeof optimizeForSpeed === 'boolean') {
      this._sheet.setOptimizeForSpeed(optimizeForSpeed);

      this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
    }

    this._isBrowser = isBrowser;
    this._fromServer = undefined;
    this._indices = {};
    this._instancesCounts = {};
  }

  var _proto = StyleSheetRegistry.prototype;

  _proto.add = function add(props) {
    var _this = this;

    if (undefined === this._optimizeForSpeed) {
      this._optimizeForSpeed = Array.isArray(props.children);

      this._sheet.setOptimizeForSpeed(this._optimizeForSpeed);

      this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
    }

    if (this._isBrowser && !this._fromServer) {
      this._fromServer = this.selectFromServer();
      this._instancesCounts = Object.keys(this._fromServer).reduce(function (acc, tagName) {
        acc[tagName] = 0;
        return acc;
      }, {});
    }

    var _this$getIdAndRules = this.getIdAndRules(props),
        styleId = _this$getIdAndRules.styleId,
        rules = _this$getIdAndRules.rules; // Deduping: just increase the instances count.


    if (styleId in this._instancesCounts) {
      this._instancesCounts[styleId] += 1;
      return;
    }

    var indices = rules.map(function (rule) {
      return _this._sheet.insertRule(rule);
    }) // Filter out invalid rules
    .filter(function (index) {
      return index !== -1;
    });
    this._indices[styleId] = indices;
    this._instancesCounts[styleId] = 1;
  };

  _proto.remove = function remove(props) {
    var _this2 = this;

    var _this$getIdAndRules2 = this.getIdAndRules(props),
        styleId = _this$getIdAndRules2.styleId;

    invariant(styleId in this._instancesCounts, "styleId: `" + styleId + "` not found");
    this._instancesCounts[styleId] -= 1;

    if (this._instancesCounts[styleId] < 1) {
      var tagFromServer = this._fromServer && this._fromServer[styleId];

      if (tagFromServer) {
        tagFromServer.parentNode.removeChild(tagFromServer);
        delete this._fromServer[styleId];
      } else {
        this._indices[styleId].forEach(function (index) {
          return _this2._sheet.deleteRule(index);
        });

        delete this._indices[styleId];
      }

      delete this._instancesCounts[styleId];
    }
  };

  _proto.update = function update(props, nextProps) {
    this.add(nextProps);
    this.remove(props);
  };

  _proto.flush = function flush() {
    this._sheet.flush();

    this._sheet.inject();

    this._fromServer = undefined;
    this._indices = {};
    this._instancesCounts = {};
  };

  _proto.cssRules = function cssRules() {
    var _this3 = this;

    var fromServer = this._fromServer ? Object.keys(this._fromServer).map(function (styleId) {
      return [styleId, _this3._fromServer[styleId]];
    }) : [];

    var cssRules = this._sheet.cssRules();

    return fromServer.concat(Object.keys(this._indices).map(function (styleId) {
      return [styleId, _this3._indices[styleId].map(function (index) {
        return cssRules[index].cssText;
      }).join(_this3._optimizeForSpeed ? '' : '\n')];
    }) // filter out empty rules
    .filter(function (rule) {
      return Boolean(rule[1]);
    }));
  };

  _proto.styles = function styles(options) {
    return mapRulesToStyle(this.cssRules(), options);
  };

  _proto.getIdAndRules = function getIdAndRules(props) {
    var css = props.children,
        dynamic = props.dynamic,
        id = props.id;

    if (dynamic) {
      var styleId = (0, _hash.computeId)(id, dynamic);
      return {
        styleId: styleId,
        rules: Array.isArray(css) ? css.map(function (rule) {
          return (0, _hash.computeSelector)(styleId, rule);
        }) : [(0, _hash.computeSelector)(styleId, css)]
      };
    }

    return {
      styleId: (0, _hash.computeId)(id),
      rules: Array.isArray(css) ? css : [css]
    };
  }
  /**
   * selectFromServer
   *
   * Collects style tags from the document with id __jsx-XXX
   */
  ;

  _proto.selectFromServer = function selectFromServer() {
    var elements = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
    return elements.reduce(function (acc, element) {
      var id = element.id.slice(2);
      acc[id] = element;
      return acc;
    }, {});
  };

  return StyleSheetRegistry;
}();

exports.StyleSheetRegistry = StyleSheetRegistry;

function invariant(condition, message) {
  if (!condition) {
    throw new Error("StyleSheetRegistry: " + message + ".");
  }
}

var StyleSheetContext = (0, _react.createContext)(null);
exports.StyleSheetContext = StyleSheetContext;

function createStyleRegistry() {
  return new StyleSheetRegistry();
}

function StyleRegistry(_ref2) {
  var configuredRegistry = _ref2.registry,
      children = _ref2.children;
  var rootRegistry = (0, _react.useContext)(StyleSheetContext);

  var _useState = (0, _react.useState)(function () {
    return rootRegistry || configuredRegistry || createStyleRegistry();
  }),
      registry = _useState[0];

  return _react["default"].createElement(StyleSheetContext.Provider, {
    value: registry
  }, children);
}

function useStyleRegistry() {
  return (0, _react.useContext)(StyleSheetContext);
}

/***/ }),

/***/ 522:
/***/ (function(module) {

module.exports = __webpack_require__(67294);

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __nccwpck_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		var threw = true;
/******/ 		try {
/******/ 			__webpack_modules__[moduleId](module, module.exports, __nccwpck_require__);
/******/ 			threw = false;
/******/ 		} finally {
/******/ 			if(threw) delete __webpack_module_cache__[moduleId];
/******/ 		}
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat */
/******/ 	
/******/ 	if (typeof __nccwpck_require__ !== 'undefined') __nccwpck_require__.ab = __dirname + "/";
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
!function() {
var exports = __webpack_exports__;


exports.__esModule = true;
exports.style = exports.useStyleRegistry = exports.createStyleRegistry = exports.StyleRegistry = void 0;

var _stylesheetRegistry = __nccwpck_require__(147);

exports.StyleRegistry = _stylesheetRegistry.StyleRegistry;
exports.createStyleRegistry = _stylesheetRegistry.createStyleRegistry;
exports.useStyleRegistry = _stylesheetRegistry.useStyleRegistry;

var _style = _interopRequireDefault(__nccwpck_require__(449));

exports.style = _style["default"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
}();
module.exports = __webpack_exports__;
/******/ })()
;

/***/ }),

/***/ 65988:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(84207).style


/***/ }),

/***/ 98123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es; }
});

;// CONCATENATED MODULE: ./node_modules/symbol-observable/es/ponyfill.js
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

;// CONCATENATED MODULE: ./node_modules/symbol-observable/es/index.js
/* module decorator */ module = __webpack_require__.hmd(module);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof __webpack_require__.g !== 'undefined') {
  root = __webpack_require__.g;
} else if (true) {
  root = module;
} else {}

var result = symbolObservablePonyfill(root);
/* harmony default export */ var es = (result);


/***/ }),

/***/ 9273:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/**
 * cli.js: Config that conform to commonly used CLI logging levels.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



/**
 * Default levels for the CLI configuration.
 * @type {Object}
 */
exports.levels = {
  error: 0,
  warn: 1,
  help: 2,
  data: 3,
  info: 4,
  debug: 5,
  prompt: 6,
  verbose: 7,
  input: 8,
  silly: 9
};

/**
 * Default colors for the CLI configuration.
 * @type {Object}
 */
exports.colors = {
  error: 'red',
  warn: 'yellow',
  help: 'cyan',
  data: 'grey',
  info: 'green',
  debug: 'blue',
  prompt: 'grey',
  verbose: 'cyan',
  input: 'grey',
  silly: 'magenta'
};


/***/ }),

/***/ 85243:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * index.js: Default settings for all levels that winston knows about.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



/**
 * Export config set for the CLI.
 * @type {Object}
 */
Object.defineProperty(exports, "cli", ({
  value: __webpack_require__(9273)
}));

/**
 * Export config set for npm.
 * @type {Object}
 */
Object.defineProperty(exports, "npm", ({
  value: __webpack_require__(2459)
}));

/**
 * Export config set for the syslog.
 * @type {Object}
 */
Object.defineProperty(exports, "syslog", ({
  value: __webpack_require__(51945)
}));


/***/ }),

/***/ 2459:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/**
 * npm.js: Config that conform to npm logging levels.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



/**
 * Default levels for the npm configuration.
 * @type {Object}
 */
exports.levels = {
  error: 0,
  warn: 1,
  info: 2,
  http: 3,
  verbose: 4,
  debug: 5,
  silly: 6
};

/**
 * Default levels for the npm configuration.
 * @type {Object}
 */
exports.colors = {
  error: 'red',
  warn: 'yellow',
  info: 'green',
  http: 'green',
  verbose: 'cyan',
  debug: 'blue',
  silly: 'magenta'
};


/***/ }),

/***/ 51945:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/**
 * syslog.js: Config that conform to syslog logging levels.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



/**
 * Default levels for the syslog configuration.
 * @type {Object}
 */
exports.levels = {
  emerg: 0,
  alert: 1,
  crit: 2,
  error: 3,
  warning: 4,
  notice: 5,
  info: 6,
  debug: 7
};

/**
 * Default levels for the syslog configuration.
 * @type {Object}
 */
exports.colors = {
  emerg: 'red',
  alert: 'yellow',
  crit: 'red',
  error: 'red',
  warning: 'red',
  notice: 'yellow',
  info: 'green',
  debug: 'blue'
};


/***/ }),

/***/ 15396:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


/**
 * A shareable symbol constant that can be used
 * as a non-enumerable / semi-hidden level identifier
 * to allow the readable level property to be mutable for
 * operations like colorization
 *
 * @type {Symbol}
 */
Object.defineProperty(exports, "LEVEL", ({
  value: Symbol.for('level')
}));

/**
 * A shareable symbol constant that can be used
 * as a non-enumerable / semi-hidden message identifier
 * to allow the final message property to not have
 * side effects on another.
 *
 * @type {Symbol}
 */
Object.defineProperty(exports, "MESSAGE", ({
  value: Symbol.for('message')
}));

/**
 * A shareable symbol constant that can be used
 * as a non-enumerable / semi-hidden message identifier
 * to allow the extracted splat property be hidden
 *
 * @type {Symbol}
 */
Object.defineProperty(exports, "SPLAT", ({
  value: Symbol.for('splat')
}));

/**
 * A shareable object constant  that can be used
 * as a standard configuration for winston@3.
 *
 * @type {Object}
 */
Object.defineProperty(exports, "configs", ({
  value: __webpack_require__(85243)
}));


/***/ }),

/***/ 47591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ej": function() { return /* binding */ InvariantError; },
/* harmony export */   "kG": function() { return /* binding */ invariant; }
/* harmony export */ });
/* unused harmony export process */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70655);
/* provided dependency */ var process = __webpack_require__(83454);


var genericMessage = "Invariant Violation";
var _a = Object.setPrototypeOf, setPrototypeOf = _a === void 0 ? function (obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : _a;
var InvariantError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) { message = genericMessage; }
        var _this = _super.call(this, typeof message === "number"
            ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)"
            : message) || this;
        _this.framesToPop = 1;
        _this.name = genericMessage;
        setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error));
function invariant(condition, message) {
    if (!condition) {
        throw new InvariantError(message);
    }
}
function wrapConsoleMethod(method) {
    return function () {
        return console[method].apply(console, arguments);
    };
}
(function (invariant) {
    invariant.warn = wrapConsoleMethod("warn");
    invariant.error = wrapConsoleMethod("error");
})(invariant || (invariant = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var processStub = { env: {} };
if (typeof process === "object") {
    processStub = process;
}
else
    try {
        // Using Function to evaluate this assignment in global scope also escapes
        // the strict mode of the current module, thereby allowing the assignment.
        // Inspired by https://github.com/facebook/regenerator/pull/369.
        Function("stub", "process = stub")(processStub);
    }
    catch (atLeastWeTried) {
        // The assignment can fail if a Content Security Policy heavy-handedly
        // forbids Function usage. In those environments, developers should take
        // extra care to replace process.env.NODE_ENV in their production builds,
        // or define an appropriate global.process polyfill.
    }
var invariant$1 = (/* unused pure expression or super */ null && (invariant));

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (invariant$1)));

//# sourceMappingURL=invariant.esm.js.map


/***/ }),

/***/ 70655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jh": function() { return /* binding */ __generator; },
/* harmony export */   "ZT": function() { return /* binding */ __extends; },
/* harmony export */   "_T": function() { return /* binding */ __rest; },
/* harmony export */   "mG": function() { return /* binding */ __awaiter; },
/* harmony export */   "pi": function() { return /* binding */ __assign; },
/* harmony export */   "pr": function() { return /* binding */ __spreadArrays; }
/* harmony export */ });
/* unused harmony exports __decorate, __param, __metadata, __createBinding, __exportStar, __values, __read, __spread, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),

/***/ 23451:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* UAParser.js v1.0.35
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */
(function(window,undefined){"use strict";var LIBVERSION="1.0.35",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded",UA_MAX_LENGTH=350;var AMAZON="Amazon",APPLE="Apple",ASUS="ASUS",BLACKBERRY="BlackBerry",BROWSER="Browser",CHROME="Chrome",EDGE="Edge",FIREFOX="Firefox",GOOGLE="Google",HUAWEI="Huawei",LG="LG",MICROSOFT="Microsoft",MOTOROLA="Motorola",OPERA="Opera",SAMSUNG="Samsung",SHARP="Sharp",SONY="Sony",VIERA="Viera",XIAOMI="Xiaomi",ZEBRA="Zebra",FACEBOOK="Facebook",CHROMIUM_OS="Chromium OS",MAC_OS="Mac OS";var extend=function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i])}else{mergedRegexes[i]=regexes[i]}}return mergedRegexes},enumerize=function(arr){var enums={};for(var i=0;i<arr.length;i++){enums[arr[i].toUpperCase()]=arr[i]}return enums},has=function(str1,str2){return typeof str1===STR_TYPE?lowerize(str2).indexOf(lowerize(str1))!==-1:false},lowerize=function(str){return str.toLowerCase()},majorize=function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,EMPTY).split(".")[0]:undefined},trim=function(str,len){if(typeof str===STR_TYPE){str=str.replace(/^\s\s*/,EMPTY);return typeof len===UNDEF_TYPE?str:str.substring(0,UA_MAX_LENGTH)}};var rgxMapper=function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){if(!regex[j]){break}matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length===2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length===3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length===4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},strMapper=function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(has(map[i],str)){return i===UNKNOWN?undefined:i}}return str};var oldSafariMap={"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"},windowsVersionMap={ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"};var regexes={browser:[[/\b(?:crmo|crios)\/([\w\.]+)/i],[VERSION,[NAME,"Chrome"]],[/edg(?:e|ios|a)?\/([\w\.]+)/i],[VERSION,[NAME,"Edge"]],[/(opera mini)\/([-\w\.]+)/i,/(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,/(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i],[NAME,VERSION],[/opios[\/ ]+([\w\.]+)/i],[VERSION,[NAME,OPERA+" Mini"]],[/\bopr\/([\w\.]+)/i],[VERSION,[NAME,OPERA]],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,/(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,/(ba?idubrowser)[\/ ]?([\w\.]+)/i,/(?:ms|\()(ie) ([\w\.]+)/i,/(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,/(heytap|ovi)browser\/([\d\.]+)/i,/(weibo)__([\d\.]+)/i],[NAME,VERSION],[/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"UC"+BROWSER]],[/microm.+\bqbcore\/([\w\.]+)/i,/\bqbcore\/([\w\.]+).+microm/i],[VERSION,[NAME,"WeChat(Win) Desktop"]],[/micromessenger\/([\w\.]+)/i],[VERSION,[NAME,"WeChat"]],[/konqueror\/([\w\.]+)/i],[VERSION,[NAME,"Konqueror"]],[/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i],[VERSION,[NAME,"IE"]],[/ya(?:search)?browser\/([\w\.]+)/i],[VERSION,[NAME,"Yandex"]],[/(avast|avg)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 Secure "+BROWSER],VERSION],[/\bfocus\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" Focus"]],[/\bopt\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Touch"]],[/coc_coc\w+\/([\w\.]+)/i],[VERSION,[NAME,"Coc Coc"]],[/dolfin\/([\w\.]+)/i],[VERSION,[NAME,"Dolphin"]],[/coast\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Coast"]],[/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI "+BROWSER]],[/fxios\/([-\w\.]+)/i],[VERSION,[NAME,FIREFOX]],[/\bqihu|(qi?ho?o?|360)browser/i],[[NAME,"360 "+BROWSER]],[/(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 "+BROWSER],VERSION],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/(electron)\/([\w\.]+) safari/i,/(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,/m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i],[NAME,VERSION],[/(metasr)[\/ ]?([\w\.]+)/i,/(lbbrowser)/i,/\[(linkedin)app\]/i],[NAME],[/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i],[[NAME,FACEBOOK],VERSION],[/(kakao(?:talk|story))[\/ ]([\w\.]+)/i,/(naver)\(.*?(\d+\.[\w\.]+).*\)/i,/safari (line)\/([\w\.]+)/i,/\b(line)\/([\w\.]+)\/iab/i,/(chromium|instagram)[\/ ]([-\w\.]+)/i],[NAME,VERSION],[/\bgsa\/([\w\.]+) .*safari\//i],[VERSION,[NAME,"GSA"]],[/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i],[VERSION,[NAME,"TikTok"]],[/headlesschrome(?:\/([\w\.]+)| )/i],[VERSION,[NAME,CHROME+" Headless"]],[/ wv\).+(chrome)\/([\w\.]+)/i],[[NAME,CHROME+" WebView"],VERSION],[/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i],[VERSION,[NAME,"Android "+BROWSER]],[/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i],[VERSION,NAME],[/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,strMapper,oldSafariMap]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape\d?)\/([-\w\.]+)/i],[[NAME,"Netscape"],VERSION],[/mobile vr; rv:([\w\.]+)\).+firefox/i],[VERSION,[NAME,FIREFOX+" Reality"]],[/ekiohf.+(flow)\/([\w\.]+)/i,/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,/(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,/(firefox)\/([\w\.]+)/i,/(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,/(links) \(([\w\.]+)/i,/panasonic;(viera)/i],[NAME,VERSION],[/(cobalt)\/([\w\.]+)/i],[NAME,[VERSION,/master.|lts./,""]]],cpu:[[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/\b(aarch64|arm(v?8e?l?|_?64))\b/i],[[ARCHITECTURE,"arm64"]],[/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i],[[ARCHITECTURE,"armhf"]],[/windows (ce|mobile); ppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i],[[ARCHITECTURE,/ower/,EMPTY,lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i],[[ARCHITECTURE,lowerize]]],device:[[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,TABLET]],[/\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,/samsung[- ]([-\w]+)/i,/sec-(sgh\w+)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,MOBILE]],[/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i],[MODEL,[VENDOR,APPLE],[TYPE,MOBILE]],[/\((ipad);[-\w\),; ]+apple/i,/applecoremedia\/[\w\.]+ \((ipad)/i,/\b(ipad)\d\d?,\d\d?[;\]].+ios/i],[MODEL,[VENDOR,APPLE],[TYPE,TABLET]],[/(macintosh);/i],[MODEL,[VENDOR,APPLE]],[/\b(sh-?[altvz]?\d\d[a-ekm]?)/i],[MODEL,[VENDOR,SHARP],[TYPE,MOBILE]],[/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,TABLET]],[/(?:huawei|honor)([-\w ]+)[;\)]/i,/\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,MOBILE]],[/\b(poco[\w ]+)(?: bui|\))/i,/\b; (\w+) build\/hm\1/i,/\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,/\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,/\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,MOBILE]],[/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,TABLET]],[/; (\w+) bui.+ oppo/i,/\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i],[MODEL,[VENDOR,"OPPO"],[TYPE,MOBILE]],[/vivo (\w+)(?: bui|\))/i,/\b(v[12]\d{3}\w?[at])(?: bui|;)/i],[MODEL,[VENDOR,"Vivo"],[TYPE,MOBILE]],[/\b(rmx[12]\d{3})(?: bui|;|\))/i],[MODEL,[VENDOR,"Realme"],[TYPE,MOBILE]],[/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,/\bmot(?:orola)?[- ](\w*)/i,/((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i],[MODEL,[VENDOR,MOTOROLA],[TYPE,MOBILE]],[/\b(mz60\d|xoom[2 ]{0,2}) build\//i],[MODEL,[VENDOR,MOTOROLA],[TYPE,TABLET]],[/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i],[MODEL,[VENDOR,LG],[TYPE,TABLET]],[/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,/\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,/\blg-?([\d\w]+) bui/i],[MODEL,[VENDOR,LG],[TYPE,MOBILE]],[/(ideatab[-\w ]+)/i,/lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/(?:maemo|nokia).*(n900|lumia \d+)/i,/nokia[-_ ]?([-\w\.]*)/i],[[MODEL,/_/g," "],[VENDOR,"Nokia"],[TYPE,MOBILE]],[/(pixel c)\b/i],[MODEL,[VENDOR,GOOGLE],[TYPE,TABLET]],[/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i],[MODEL,[VENDOR,GOOGLE],[TYPE,MOBILE]],[/droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,SONY],[TYPE,MOBILE]],[/sony tablet [ps]/i,/\b(?:sony)?sgp\w+(?: bui|\))/i],[[MODEL,"Xperia Tablet"],[VENDOR,SONY],[TYPE,TABLET]],[/ (kb2005|in20[12]5|be20[12][59])\b/i,/(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/(alexa)webm/i,/(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,/(kf[a-z]+)( bui|\)).+silk\//i],[MODEL,[VENDOR,AMAZON],[TYPE,TABLET]],[/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i],[[MODEL,/(.+)/g,"Fire Phone $1"],[VENDOR,AMAZON],[TYPE,MOBILE]],[/(playbook);[-\w\),; ]+(rim)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/\b((?:bb[a-f]|st[hv])100-\d)/i,/\(bb10; (\w+)/i],[MODEL,[VENDOR,BLACKBERRY],[TYPE,MOBILE]],[/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i],[MODEL,[VENDOR,ASUS],[TYPE,TABLET]],[/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],[MODEL,[VENDOR,ASUS],[TYPE,MOBILE]],[/(nexus 9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,/(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,/(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/droid.+; (m[1-5] note) bui/i,/\bmz-([-\w]{2,})/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,/(hp) ([\w ]+\w)/i,/(asus)-?(\w+)/i,/(microsoft); (lumia[\w ]+)/i,/(lenovo)[-_ ]?([-\w]+)/i,/(jolla)/i,/(oppo) ?([\w ]+) bui/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kobo)\s(ereader|touch)/i,/(archos) (gamepad2?)/i,/(hp).+(touchpad(?!.+tablet)|tablet)/i,/(kindle)\/([\w\.]+)/i,/(nook)[\w ]+build\/(\w+)/i,/(dell) (strea[kpr\d ]*[\dko])/i,/(le[- ]+pan)[- ]+(\w{1,9}) bui/i,/(trinity)[- ]*(t\d{3}) bui/i,/(gigaset)[- ]+(q\w{1,9}) bui/i,/(vodafone) ([\w ]+)(?:\)| bui)/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(surface duo)/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,TABLET]],[/droid [\d\.]+; (fp\du?)(?: b|\))/i],[MODEL,[VENDOR,"Fairphone"],[TYPE,MOBILE]],[/(u304aa)/i],[MODEL,[VENDOR,"AT&T"],[TYPE,MOBILE]],[/\bsie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/\b(rct\w+) b/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/\b(venue[\d ]{2,7}) b/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/\b(q(?:mv|ta)\w+) b/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i],[MODEL,[VENDOR,"Barnes & Noble"],[TYPE,TABLET]],[/\b(tm\d{3}\w+) b/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/\b(k88) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/\b(nx\d{3}j) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,MOBILE]],[/\b(gen\d{3}) b.+49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/\b(zur\d{3}) b/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/\b((zeki)?tb.*\b) b/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/\b([yr]\d{2}) b/i,/\b(dragon[- ]+touch |dt)(\w{5}) b/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/\b(ns-?\w{0,9}) b/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/\b((nxa|next)-?\w{0,9}) b/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/\b(lvtel\-)?(v1[12]) b/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/\b(ph-1) /i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/\b(v(100md|700na|7011|917g).*\b) b/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/\b(trio[-\w\. ]+) b/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/\btu_(1491) b/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/(shield[\w ]+) b/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,TABLET]],[/(sprint) (\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,MICROSOFT],[TYPE,MOBILE]],[/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,TABLET]],[/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,MOBILE]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,SAMSUNG],[TYPE,SMARTTV]],[/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i],[[VENDOR,LG],[TYPE,SMARTTV]],[/(apple) ?tv/i],[VENDOR,[MODEL,APPLE+" TV"],[TYPE,SMARTTV]],[/crkey/i],[[MODEL,CHROME+"cast"],[VENDOR,GOOGLE],[TYPE,SMARTTV]],[/droid.+aft(\w)( bui|\))/i],[MODEL,[VENDOR,AMAZON],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i,/(aquos-tv[\w ]+)\)/i],[MODEL,[VENDOR,SHARP],[TYPE,SMARTTV]],[/(bravia[\w ]+)( bui|\))/i],[MODEL,[VENDOR,SONY],[TYPE,SMARTTV]],[/(mitv-\w{5}) bui/i],[MODEL,[VENDOR,XIAOMI],[TYPE,SMARTTV]],[/Hbbtv.*(technisat) (.*);/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,/hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i],[[VENDOR,trim],[MODEL,trim],[TYPE,SMARTTV]],[/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i],[[TYPE,SMARTTV]],[/(ouya)/i,/(nintendo) ([wids3utch]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/droid.+; (shield) bui/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation [345portablevi]+)/i],[MODEL,[VENDOR,SONY],[TYPE,CONSOLE]],[/\b(xbox(?: one)?(?!; xbox))[\); ]/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,CONSOLE]],[/((pebble))app/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i],[MODEL,[VENDOR,APPLE],[TYPE,WEARABLE]],[/droid.+; (glass) \d/i],[MODEL,[VENDOR,GOOGLE],[TYPE,WEARABLE]],[/droid.+; (wt63?0{2,3})\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,WEARABLE]],[/(quest( 2| pro)?)/i],[MODEL,[VENDOR,FACEBOOK],[TYPE,WEARABLE]],[/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i],[VENDOR,[TYPE,EMBEDDED]],[/(aeobc)\b/i],[MODEL,[VENDOR,AMAZON],[TYPE,EMBEDDED]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i],[MODEL,[TYPE,MOBILE]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i],[MODEL,[TYPE,TABLET]],[/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i],[[TYPE,TABLET]],[/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i],[[TYPE,MOBILE]],[/(android[-\w\. ]{0,9});.+buil/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+ edge\/([\w\.]+)/i],[VERSION,[NAME,EDGE+"HTML"]],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[VERSION,[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,/ekioh(flow)\/([\w\.]+)/i,/(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,/(icab)[\/ ]([23]\.[\d\.]+)/i,/\b(libweb)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9})\b.+(gecko)/i],[VERSION,NAME]],os:[[/microsoft (windows) (vista|xp)/i],[NAME,VERSION],[/(windows) nt 6\.2; (arm)/i,/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,/(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i],[NAME,[VERSION,strMapper,windowsVersionMap]],[/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,strMapper,windowsVersionMap]],[/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,/ios;fbsv\/([\d\.]+)/i,/cfnetwork\/.+darwin/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac os x) ?([\w\. ]*)/i,/(macintosh|mac_powerpc\b)(?!.+haiku)/i],[[NAME,MAC_OS],[VERSION,/_/g,"."]],[/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i],[VERSION,NAME],[/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,/(blackberry)\w*\/([\w\.]*)/i,/(tizen|kaios)[\/ ]([\w\.]+)/i,/\((series40);/i],[NAME,VERSION],[/\(bb(10);/i],[VERSION,[NAME,BLACKBERRY]],[/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i],[VERSION,[NAME,"Symbian"]],[/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" OS"]],[/web0s;.+rt(tv)/i,/\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i],[VERSION,[NAME,"webOS"]],[/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i],[VERSION,[NAME,"watchOS"]],[/crkey\/([\d\.]+)/i],[VERSION,[NAME,CHROME+"cast"]],[/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i],[[NAME,CHROMIUM_OS],VERSION],[/panasonic;(viera)/i,/(netrange)mmh/i,/(nettv)\/(\d+\.[\w\.]+)/i,/(nintendo|playstation) ([wids345portablevuch]+)/i,/(xbox); +xbox ([^\);]+)/i,/\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,/(mint)[\/\(\) ]?(\w*)/i,/(mageia|vectorlinux)[; ]/i,/([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,/(hurd|linux) ?([\w\.]*)/i,/(gnu) ?([\w\.]*)/i,/\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,/(haiku) (\w+)/i],[NAME,VERSION],[/(sunos) ?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,/(aix) ((\d)(?=\.|\)| )[\w\.])*/i,/\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,/(unix) ?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(ua,extensions){if(typeof ua===OBJ_TYPE){extensions=ua;ua=undefined}if(!(this instanceof UAParser)){return new UAParser(ua,extensions).getResult()}var _navigator=typeof window!==UNDEF_TYPE&&window.navigator?window.navigator:undefined;var _ua=ua||(_navigator&&_navigator.userAgent?_navigator.userAgent:EMPTY);var _uach=_navigator&&_navigator.userAgentData?_navigator.userAgentData:undefined;var _rgxmap=extensions?extend(regexes,extensions):regexes;var _isSelfNav=_navigator&&_navigator.userAgent==_ua;this.getBrowser=function(){var _browser={};_browser[NAME]=undefined;_browser[VERSION]=undefined;rgxMapper.call(_browser,_ua,_rgxmap.browser);_browser[MAJOR]=majorize(_browser[VERSION]);if(_isSelfNav&&_navigator&&_navigator.brave&&typeof _navigator.brave.isBrave==FUNC_TYPE){_browser[NAME]="Brave"}return _browser};this.getCPU=function(){var _cpu={};_cpu[ARCHITECTURE]=undefined;rgxMapper.call(_cpu,_ua,_rgxmap.cpu);return _cpu};this.getDevice=function(){var _device={};_device[VENDOR]=undefined;_device[MODEL]=undefined;_device[TYPE]=undefined;rgxMapper.call(_device,_ua,_rgxmap.device);if(_isSelfNav&&!_device[TYPE]&&_uach&&_uach.mobile){_device[TYPE]=MOBILE}if(_isSelfNav&&_device[MODEL]=="Macintosh"&&_navigator&&typeof _navigator.standalone!==UNDEF_TYPE&&_navigator.maxTouchPoints&&_navigator.maxTouchPoints>2){_device[MODEL]="iPad";_device[TYPE]=TABLET}return _device};this.getEngine=function(){var _engine={};_engine[NAME]=undefined;_engine[VERSION]=undefined;rgxMapper.call(_engine,_ua,_rgxmap.engine);return _engine};this.getOS=function(){var _os={};_os[NAME]=undefined;_os[VERSION]=undefined;rgxMapper.call(_os,_ua,_rgxmap.os);if(_isSelfNav&&!_os[NAME]&&_uach&&_uach.platform!="Unknown"){_os[NAME]=_uach.platform.replace(/chrome os/i,CHROMIUM_OS).replace(/macos/i,MAC_OS)}return _os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return _ua};this.setUA=function(ua){_ua=typeof ua===STR_TYPE&&ua.length>UA_MAX_LENGTH?trim(ua,UA_MAX_LENGTH):ua;return this};this.setUA(_ua);return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER=enumerize([NAME,VERSION,MAJOR]);UAParser.CPU=enumerize([ARCHITECTURE]);UAParser.DEVICE=enumerize([MODEL,VENDOR,TYPE,CONSOLE,MOBILE,SMARTTV,TABLET,WEARABLE,EMBEDDED]);UAParser.ENGINE=UAParser.OS=enumerize([NAME,VERSION]);if(typeof exports!==UNDEF_TYPE){if("object"!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if("function"===FUNC_TYPE&&__webpack_require__.amdO){!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return UAParser}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(typeof window!==UNDEF_TYPE){window.UAParser=UAParser}}var $=typeof window!==UNDEF_TYPE&&(window.jQuery||window.Zepto);if($&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(ua){parser.setUA(ua);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

/***/ }),

/***/ 53250:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(67294);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 61688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(53250);
} else {}


/***/ }),

/***/ 94927:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!__webpack_require__.g.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = __webpack_require__.g.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}


/***/ }),

/***/ 94307:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


// Expose modern transport directly as the export

module.exports = __webpack_require__(79428);

// Expose legacy stream
module.exports.LegacyTransportStream = __webpack_require__(15686);

/***/ }),

/***/ 15686:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var util = __webpack_require__(79720);

var _require = __webpack_require__(15396),
    LEVEL = _require.LEVEL;

var TransportStream = __webpack_require__(79428);

/**
 * Constructor function for the LegacyTransportStream. This is an internal
 * wrapper `winston >= 3` uses to wrap older transports implementing
 * log(level, message, meta).
 * @param {Object} options - Options for this TransportStream instance.
 * @param {Transpot} options.transport - winston@2 or older Transport to wrap.
 */

var LegacyTransportStream = module.exports = function LegacyTransportStream() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  TransportStream.call(this, options);
  if (!options.transport || typeof options.transport.log !== 'function') {
    throw new Error('Invalid transport, must be an object with a log method.');
  }

  this.transport = options.transport;
  this.level = this.level || options.transport.level;
  this.handleExceptions = this.handleExceptions || options.transport.handleExceptions;

  // Display our deprecation notice.
  this._deprecated();

  // Properly bubble up errors from the transport to the
  // LegacyTransportStream instance, but only once no matter how many times
  // this transport is shared.
  function transportError(err) {
    this.emit('error', err, this.transport);
  }

  if (!this.transport.__winstonError) {
    this.transport.__winstonError = transportError.bind(this);
    this.transport.on('error', this.transport.__winstonError);
  }
};

/*
 * Inherit from TransportStream using Node.js built-ins
 */
util.inherits(LegacyTransportStream, TransportStream);

/**
 * Writes the info object to our transport instance.
 * @param {mixed} info - TODO: add param description.
 * @param {mixed} enc - TODO: add param description.
 * @param {function} callback - TODO: add param description.
 * @returns {undefined}
 * @private
 */
LegacyTransportStream.prototype._write = function _write(info, enc, callback) {
  if (this.silent || info.exception === true && !this.handleExceptions) {
    return callback(null);
  }

  // Remark: This has to be handled in the base transport now because we
  // cannot conditionally write to our pipe targets as stream.
  if (!this.level || this.levels[this.level] >= this.levels[info[LEVEL]]) {
    this.transport.log(info[LEVEL], info.message, info, this._nop);
  }

  callback(null);
};

/**
 * Writes the batch of info objects (i.e. "object chunks") to our transport
 * instance after performing any necessary filtering.
 * @param {mixed} chunks - TODO: add params description.
 * @param {function} callback - TODO: add params description.
 * @returns {mixed} - TODO: add returns description.
 * @private
 */
LegacyTransportStream.prototype._writev = function _writev(chunks, callback) {
  for (var i = 0; i < chunks.length; i++) {
    if (this._accept(chunks[i])) {
      this.transport.log(chunks[i].chunk[LEVEL], chunks[i].chunk.message, chunks[i].chunk, this._nop);
      chunks[i].callback();
    }
  }

  return callback(null);
};

/**
 * Displays a deprecation notice. Defined as a function so it can be
 * overriden in tests.
 * @returns {undefined}
 */
LegacyTransportStream.prototype._deprecated = function _deprecated() {
  // eslint-disable-next-line no-console
  console.error([this.transport.name + ' is a legacy winston transport. Consider upgrading: ', '- Upgrade docs: https://github.com/winstonjs/winston/blob/master/UPGRADE-3.0.md'].join('\n'));
};

/**
 * Clean up error handling state on the legacy transport associated
 * with this instance.
 * @returns {undefined}
 */
LegacyTransportStream.prototype.close = function close() {
  if (this.transport.close) {
    this.transport.close();
  }

  if (this.transport.__winstonError) {
    this.transport.removeListener('error', this.transport.__winstonError);
    this.transport.__winstonError = null;
  }
};

/***/ }),

/***/ 79428:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var util = __webpack_require__(79720);
var Writable = __webpack_require__(64229);

var _require = __webpack_require__(15396),
    LEVEL = _require.LEVEL;

/**
 * Constructor function for the TransportStream. This is the base prototype
 * that all `winston >= 3` transports should inherit from.
 * @param {Object} options - Options for this TransportStream instance
 * @param {String} options.level - Highest level according to RFC5424.
 * @param {Boolean} options.handleExceptions - If true, info with
 * { exception: true } will be written.
 * @param {Function} options.log - Custom log function for simple Transport
 * creation
 * @param {Function} options.close - Called on "unpipe" from parent.
 */


var TransportStream = module.exports = function TransportStream() {
  var _this = this;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  Writable.call(this, { objectMode: true, highWaterMark: options.highWaterMark });

  this.format = options.format;
  this.level = options.level;
  this.handleExceptions = options.handleExceptions;
  this.handleRejections = options.handleRejections;
  this.silent = options.silent;

  if (options.log) this.log = options.log;
  if (options.logv) this.logv = options.logv;
  if (options.close) this.close = options.close;

  // Get the levels from the source we are piped from.
  this.once('pipe', function (logger) {
    // Remark (indexzero): this bookkeeping can only support multiple
    // Logger parents with the same `levels`. This comes into play in
    // the `winston.Container` code in which `container.add` takes
    // a fully realized set of options with pre-constructed TransportStreams.
    _this.levels = logger.levels;
    _this.parent = logger;
  });

  // If and/or when the transport is removed from this instance
  this.once('unpipe', function (src) {
    // Remark (indexzero): this bookkeeping can only support multiple
    // Logger parents with the same `levels`. This comes into play in
    // the `winston.Container` code in which `container.add` takes
    // a fully realized set of options with pre-constructed TransportStreams.
    if (src === _this.parent) {
      _this.parent = null;
      if (_this.close) {
        _this.close();
      }
    }
  });
};

/*
 * Inherit from Writeable using Node.js built-ins
 */
util.inherits(TransportStream, Writable);

/**
 * Writes the info object to our transport instance.
 * @param {mixed} info - TODO: add param description.
 * @param {mixed} enc - TODO: add param description.
 * @param {function} callback - TODO: add param description.
 * @returns {undefined}
 * @private
 */
TransportStream.prototype._write = function _write(info, enc, callback) {
  if (this.silent || info.exception === true && !this.handleExceptions) {
    return callback(null);
  }

  // Remark: This has to be handled in the base transport now because we
  // cannot conditionally write to our pipe targets as stream. We always
  // prefer any explicit level set on the Transport itself falling back to
  // any level set on the parent.
  var level = this.level || this.parent && this.parent.level;

  if (!level || this.levels[level] >= this.levels[info[LEVEL]]) {
    if (info && !this.format) {
      return this.log(info, callback);
    }

    var errState = void 0;
    var transformed = void 0;

    // We trap(and re-throw) any errors generated by the user-provided format, but also
    // guarantee that the streams callback is invoked so that we can continue flowing.
    try {
      transformed = this.format.transform(Object.assign({}, info), this.format.options);
    } catch (err) {
      errState = err;
    }

    if (errState || !transformed) {
      // eslint-disable-next-line callback-return
      callback();
      if (errState) throw errState;
      return;
    }

    return this.log(transformed, callback);
  }
  this._writableState.sync = false;
  return callback(null);
};

/**
 * Writes the batch of info objects (i.e. "object chunks") to our transport
 * instance after performing any necessary filtering.
 * @param {mixed} chunks - TODO: add params description.
 * @param {function} callback - TODO: add params description.
 * @returns {mixed} - TODO: add returns description.
 * @private
 */
TransportStream.prototype._writev = function _writev(chunks, callback) {
  if (this.logv) {
    var infos = chunks.filter(this._accept, this);
    if (!infos.length) {
      return callback(null);
    }

    // Remark (indexzero): from a performance perspective if Transport
    // implementers do choose to implement logv should we make it their
    // responsibility to invoke their format?
    return this.logv(infos, callback);
  }

  for (var i = 0; i < chunks.length; i++) {
    if (!this._accept(chunks[i])) continue;

    if (chunks[i].chunk && !this.format) {
      this.log(chunks[i].chunk, chunks[i].callback);
      continue;
    }

    var errState = void 0;
    var transformed = void 0;

    // We trap(and re-throw) any errors generated by the user-provided format, but also
    // guarantee that the streams callback is invoked so that we can continue flowing.
    try {
      transformed = this.format.transform(Object.assign({}, chunks[i].chunk), this.format.options);
    } catch (err) {
      errState = err;
    }

    if (errState || !transformed) {
      // eslint-disable-next-line callback-return
      chunks[i].callback();
      if (errState) {
        // eslint-disable-next-line callback-return
        callback(null);
        throw errState;
      }
    } else {
      this.log(transformed, chunks[i].callback);
    }
  }

  return callback(null);
};

/**
 * Predicate function that returns true if the specfied `info` on the
 * WriteReq, `write`, should be passed down into the derived
 * TransportStream's I/O via `.log(info, callback)`.
 * @param {WriteReq} write - winston@3 Node.js WriteReq for the `info` object
 * representing the log message.
 * @returns {Boolean} - Value indicating if the `write` should be accepted &
 * logged.
 */
TransportStream.prototype._accept = function _accept(write) {
  var info = write.chunk;
  if (this.silent) {
    return false;
  }

  // We always prefer any explicit level set on the Transport itself
  // falling back to any level set on the parent.
  var level = this.level || this.parent && this.parent.level;

  // Immediately check the average case: log level filtering.
  if (info.exception === true || !level || this.levels[level] >= this.levels[info[LEVEL]]) {
    // Ensure the info object is valid based on `{ exception }`:
    // 1. { handleExceptions: true }: all `info` objects are valid
    // 2. { exception: false }: accepted by all transports.
    if (this.handleExceptions || info.exception !== true) {
      return true;
    }
  }

  return false;
};

/**
 * _nop is short for "No operation"
 * @returns {Boolean} Intentionally false.
 */
TransportStream.prototype._nop = function _nop() {
  // eslint-disable-next-line no-undefined
  return void undefined;
};

/***/ }),

/***/ 54201:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const util = __webpack_require__(79720);
const { LEVEL } = __webpack_require__(15396);
const TransportStream = __webpack_require__(51746);

/**
 * Constructor function for the LegacyTransportStream. This is an internal
 * wrapper `winston >= 3` uses to wrap older transports implementing
 * log(level, message, meta).
 * @param {Object} options - Options for this TransportStream instance.
 * @param {Transpot} options.transport - winston@2 or older Transport to wrap.
 */

const LegacyTransportStream = module.exports = function LegacyTransportStream(options = {}) {
  TransportStream.call(this, options);
  if (!options.transport || typeof options.transport.log !== 'function') {
    throw new Error('Invalid transport, must be an object with a log method.');
  }

  this.transport = options.transport;
  this.level = this.level || options.transport.level;
  this.handleExceptions = this.handleExceptions || options.transport.handleExceptions;

  // Display our deprecation notice.
  this._deprecated();

  // Properly bubble up errors from the transport to the
  // LegacyTransportStream instance, but only once no matter how many times
  // this transport is shared.
  function transportError(err) {
    this.emit('error', err, this.transport);
  }

  if (!this.transport.__winstonError) {
    this.transport.__winstonError = transportError.bind(this);
    this.transport.on('error', this.transport.__winstonError);
  }
};

/*
 * Inherit from TransportStream using Node.js built-ins
 */
util.inherits(LegacyTransportStream, TransportStream);

/**
 * Writes the info object to our transport instance.
 * @param {mixed} info - TODO: add param description.
 * @param {mixed} enc - TODO: add param description.
 * @param {function} callback - TODO: add param description.
 * @returns {undefined}
 * @private
 */
LegacyTransportStream.prototype._write = function _write(info, enc, callback) {
  if (this.silent || (info.exception === true && !this.handleExceptions)) {
    return callback(null);
  }

  // Remark: This has to be handled in the base transport now because we
  // cannot conditionally write to our pipe targets as stream.
  if (!this.level || this.levels[this.level] >= this.levels[info[LEVEL]]) {
    this.transport.log(info[LEVEL], info.message, info, this._nop);
  }

  callback(null);
};

/**
 * Writes the batch of info objects (i.e. "object chunks") to our transport
 * instance after performing any necessary filtering.
 * @param {mixed} chunks - TODO: add params description.
 * @param {function} callback - TODO: add params description.
 * @returns {mixed} - TODO: add returns description.
 * @private
 */
LegacyTransportStream.prototype._writev = function _writev(chunks, callback) {
  for (let i = 0; i < chunks.length; i++) {
    if (this._accept(chunks[i])) {
      this.transport.log(
        chunks[i].chunk[LEVEL],
        chunks[i].chunk.message,
        chunks[i].chunk,
        this._nop
      );
      chunks[i].callback();
    }
  }

  return callback(null);
};

/**
 * Displays a deprecation notice. Defined as a function so it can be
 * overriden in tests.
 * @returns {undefined}
 */
LegacyTransportStream.prototype._deprecated = function _deprecated() {
  // eslint-disable-next-line no-console
  console.error([
    `${this.transport.name} is a legacy winston transport. Consider upgrading: `,
    '- Upgrade docs: https://github.com/winstonjs/winston/blob/master/UPGRADE-3.0.md'
  ].join('\n'));
};

/**
 * Clean up error handling state on the legacy transport associated
 * with this instance.
 * @returns {undefined}
 */
LegacyTransportStream.prototype.close = function close() {
  if (this.transport.close) {
    this.transport.close();
  }

  if (this.transport.__winstonError) {
    this.transport.removeListener('error', this.transport.__winstonError);
    this.transport.__winstonError = null;
  }
};


/***/ }),

/***/ 51746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const util = __webpack_require__(79720);
const Writable = __webpack_require__(64229);
const { LEVEL } = __webpack_require__(15396);

/**
 * Constructor function for the TransportStream. This is the base prototype
 * that all `winston >= 3` transports should inherit from.
 * @param {Object} options - Options for this TransportStream instance
 * @param {String} options.level - Highest level according to RFC5424.
 * @param {Boolean} options.handleExceptions - If true, info with
 * { exception: true } will be written.
 * @param {Function} options.log - Custom log function for simple Transport
 * creation
 * @param {Function} options.close - Called on "unpipe" from parent.
 */
const TransportStream = module.exports = function TransportStream(options = {}) {
  Writable.call(this, { objectMode: true, highWaterMark: options.highWaterMark });

  this.format = options.format;
  this.level = options.level;
  this.handleExceptions = options.handleExceptions;
  this.handleRejections = options.handleRejections;
  this.silent = options.silent;

  if (options.log) this.log = options.log;
  if (options.logv) this.logv = options.logv;
  if (options.close) this.close = options.close;

  // Get the levels from the source we are piped from.
  this.once('pipe', logger => {
    // Remark (indexzero): this bookkeeping can only support multiple
    // Logger parents with the same `levels`. This comes into play in
    // the `winston.Container` code in which `container.add` takes
    // a fully realized set of options with pre-constructed TransportStreams.
    this.levels = logger.levels;
    this.parent = logger;
  });

  // If and/or when the transport is removed from this instance
  this.once('unpipe', src => {
    // Remark (indexzero): this bookkeeping can only support multiple
    // Logger parents with the same `levels`. This comes into play in
    // the `winston.Container` code in which `container.add` takes
    // a fully realized set of options with pre-constructed TransportStreams.
    if (src === this.parent) {
      this.parent = null;
      if (this.close) {
        this.close();
      }
    }
  });
};

/*
 * Inherit from Writeable using Node.js built-ins
 */
util.inherits(TransportStream, Writable);

/**
 * Writes the info object to our transport instance.
 * @param {mixed} info - TODO: add param description.
 * @param {mixed} enc - TODO: add param description.
 * @param {function} callback - TODO: add param description.
 * @returns {undefined}
 * @private
 */
TransportStream.prototype._write = function _write(info, enc, callback) {
  if (this.silent || (info.exception === true && !this.handleExceptions)) {
    return callback(null);
  }

  // Remark: This has to be handled in the base transport now because we
  // cannot conditionally write to our pipe targets as stream. We always
  // prefer any explicit level set on the Transport itself falling back to
  // any level set on the parent.
  const level = this.level || (this.parent && this.parent.level);

  if (!level || this.levels[level] >= this.levels[info[LEVEL]]) {
    if (info && !this.format) {
      return this.log(info, callback);
    }

    let errState;
    let transformed;

    // We trap(and re-throw) any errors generated by the user-provided format, but also
    // guarantee that the streams callback is invoked so that we can continue flowing.
    try {
      transformed = this.format.transform(Object.assign({}, info), this.format.options);
    } catch (err) {
      errState = err;
    }

    if (errState || !transformed) {
      // eslint-disable-next-line callback-return
      callback();
      if (errState) throw errState;
      return;
    }

    return this.log(transformed, callback);
  }
  this._writableState.sync = false;
  return callback(null);
};

/**
 * Writes the batch of info objects (i.e. "object chunks") to our transport
 * instance after performing any necessary filtering.
 * @param {mixed} chunks - TODO: add params description.
 * @param {function} callback - TODO: add params description.
 * @returns {mixed} - TODO: add returns description.
 * @private
 */
TransportStream.prototype._writev = function _writev(chunks, callback) {
  if (this.logv) {
    const infos = chunks.filter(this._accept, this);
    if (!infos.length) {
      return callback(null);
    }

    // Remark (indexzero): from a performance perspective if Transport
    // implementers do choose to implement logv should we make it their
    // responsibility to invoke their format?
    return this.logv(infos, callback);
  }

  for (let i = 0; i < chunks.length; i++) {
    if (!this._accept(chunks[i])) continue;

    if (chunks[i].chunk && !this.format) {
      this.log(chunks[i].chunk, chunks[i].callback);
      continue;
    }

    let errState;
    let transformed;

    // We trap(and re-throw) any errors generated by the user-provided format, but also
    // guarantee that the streams callback is invoked so that we can continue flowing.
    try {
      transformed = this.format.transform(
        Object.assign({}, chunks[i].chunk),
        this.format.options
      );
    } catch (err) {
      errState = err;
    }

    if (errState || !transformed) {
      // eslint-disable-next-line callback-return
      chunks[i].callback();
      if (errState) {
        // eslint-disable-next-line callback-return
        callback(null);
        throw errState;
      }
    } else {
      this.log(transformed, chunks[i].callback);
    }
  }

  return callback(null);
};

/**
 * Predicate function that returns true if the specfied `info` on the
 * WriteReq, `write`, should be passed down into the derived
 * TransportStream's I/O via `.log(info, callback)`.
 * @param {WriteReq} write - winston@3 Node.js WriteReq for the `info` object
 * representing the log message.
 * @returns {Boolean} - Value indicating if the `write` should be accepted &
 * logged.
 */
TransportStream.prototype._accept = function _accept(write) {
  const info = write.chunk;
  if (this.silent) {
    return false;
  }

  // We always prefer any explicit level set on the Transport itself
  // falling back to any level set on the parent.
  const level = this.level || (this.parent && this.parent.level);

  // Immediately check the average case: log level filtering.
  if (
    info.exception === true ||
    !level ||
    this.levels[level] >= this.levels[info[LEVEL]]
  ) {
    // Ensure the info object is valid based on `{ exception }`:
    // 1. { handleExceptions: true }: all `info` objects are valid
    // 2. { exception: false }: accepted by all transports.
    if (this.handleExceptions || info.exception !== true) {
      return true;
    }
  }

  return false;
};

/**
 * _nop is short for "No operation"
 * @returns {Boolean} Intentionally false.
 */
TransportStream.prototype._nop = function _nop() {
  // eslint-disable-next-line no-undefined
  return void undefined;
};


/***/ }),

/***/ 15832:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * winston.js: Top-level include defining Winston.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



var logform = __webpack_require__(6850);
var _require = __webpack_require__(23221),
  warn = _require.warn;

/**
 * Expose version. Use `require` method for `webpack` support.
 * @type {string}
 */
exports.version = __webpack_require__(12561).version;
/**
 * Include transports defined by default by winston
 * @type {Array}
 */
exports.transports = __webpack_require__(50557);
/**
 * Expose utility methods
 * @type {Object}
 */
exports.config = __webpack_require__(8953);
/**
 * Hoist format-related functionality from logform.
 * @type {Object}
 */
exports.addColors = logform.levels;
/**
 * Hoist format-related functionality from logform.
 * @type {Object}
 */
exports.format = logform.format;
/**
 * Expose core Logging-related prototypes.
 * @type {function}
 */
exports.createLogger = __webpack_require__(53040);
/**
 * Expose core Logging-related prototypes.
 * @type {function}
 */
exports.Logger = __webpack_require__(47803);
/**
 * Expose core Logging-related prototypes.
 * @type {Object}
 */
exports.ExceptionHandler = __webpack_require__(69796);
/**
 * Expose core Logging-related prototypes.
 * @type {Object}
 */
exports.RejectionHandler = __webpack_require__(74841);
/**
 * Expose core Logging-related prototypes.
 * @type {Container}
 */
exports.Container = __webpack_require__(75100);
/**
 * Expose core Logging-related prototypes.
 * @type {Object}
 */
exports.Transport = __webpack_require__(94307);
/**
 * We create and expose a default `Container` to `winston.loggers` so that the
 * programmer may manage multiple `winston.Logger` instances without any
 * additional overhead.
 * @example
 *   // some-file1.js
 *   const logger = require('winston').loggers.get('something');
 *
 *   // some-file2.js
 *   const logger = require('winston').loggers.get('something');
 */
exports.loggers = new exports.Container();

/**
 * We create and expose a 'defaultLogger' so that the programmer may do the
 * following without the need to create an instance of winston.Logger directly:
 * @example
 *   const winston = require('winston');
 *   winston.log('info', 'some message');
 *   winston.error('some error');
 */
var defaultLogger = exports.createLogger();

// Pass through the target methods onto `winston.
Object.keys(exports.config.npm.levels).concat(['log', 'query', 'stream', 'add', 'remove', 'clear', 'profile', 'startTimer', 'handleExceptions', 'unhandleExceptions', 'handleRejections', 'unhandleRejections', 'configure', 'child']).forEach(function (method) {
  return exports[method] = function () {
    return defaultLogger[method].apply(defaultLogger, arguments);
  };
});

/**
 * Define getter / setter for the default logger level which need to be exposed
 * by winston.
 * @type {string}
 */
Object.defineProperty(exports, "level", ({
  get: function get() {
    return defaultLogger.level;
  },
  set: function set(val) {
    defaultLogger.level = val;
  }
}));

/**
 * Define getter for `exceptions` which replaces `handleExceptions` and
 * `unhandleExceptions`.
 * @type {Object}
 */
Object.defineProperty(exports, "exceptions", ({
  get: function get() {
    return defaultLogger.exceptions;
  }
}));

/**
 * Define getters / setters for appropriate properties of the default logger
 * which need to be exposed by winston.
 * @type {Logger}
 */
['exitOnError'].forEach(function (prop) {
  Object.defineProperty(exports, prop, {
    get: function get() {
      return defaultLogger[prop];
    },
    set: function set(val) {
      defaultLogger[prop] = val;
    }
  });
});

/**
 * The default transports and exceptionHandlers for the default winston logger.
 * @type {Object}
 */
Object.defineProperty(exports, "default", ({
  get: function get() {
    return {
      exceptionHandlers: defaultLogger.exceptionHandlers,
      rejectionHandlers: defaultLogger.rejectionHandlers,
      transports: defaultLogger.transports
    };
  }
}));

// Have friendlier breakage notices for properties that were exposed by default
// on winston < 3.0.
warn.deprecated(exports, 'setLevels');
warn.forFunctions(exports, 'useFormat', ['cli']);
warn.forProperties(exports, 'useFormat', ['padLevels', 'stripColors']);
warn.forFunctions(exports, 'deprecated', ['addRewriter', 'addFilter', 'clone', 'extend']);
warn.forProperties(exports, 'deprecated', ['emitErrs', 'levelLength']);

/***/ }),

/***/ 23221:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * common.js: Internal helper and utility functions for winston.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



var _require = __webpack_require__(79720),
  format = _require.format;

/**
 * Set of simple deprecation notices and a way to expose them for a set of
 * properties.
 * @type {Object}
 * @private
 */
exports.warn = {
  deprecated: function deprecated(prop) {
    return function () {
      throw new Error(format('{ %s } was removed in winston@3.0.0.', prop));
    };
  },
  useFormat: function useFormat(prop) {
    return function () {
      throw new Error([format('{ %s } was removed in winston@3.0.0.', prop), 'Use a custom winston.format = winston.format(function) instead.'].join('\n'));
    };
  },
  forFunctions: function forFunctions(obj, type, props) {
    props.forEach(function (prop) {
      obj[prop] = exports.warn[type](prop);
    });
  },
  forProperties: function forProperties(obj, type, props) {
    props.forEach(function (prop) {
      var notice = exports.warn[type](prop);
      Object.defineProperty(obj, prop, {
        get: notice,
        set: notice
      });
    });
  }
};

/***/ }),

/***/ 8953:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * index.js: Default settings for all levels that winston knows about.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



var logform = __webpack_require__(6850);
var _require = __webpack_require__(15396),
  configs = _require.configs;

/**
 * Export config set for the CLI.
 * @type {Object}
 */
exports.cli = logform.levels(configs.cli);

/**
 * Export config set for npm.
 * @type {Object}
 */
exports.npm = logform.levels(configs.npm);

/**
 * Export config set for the syslog.
 * @type {Object}
 */
exports.syslog = logform.levels(configs.syslog);

/**
 * Hoist addColors from logform where it was refactored into in winston@3.
 * @type {Object}
 */
exports.addColors = logform.levels;

/***/ }),

/***/ 75100:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * container.js: Inversion of control container for winston logger instances.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var createLogger = __webpack_require__(53040);

/**
 * Inversion of control container for winston logger instances.
 * @type {Container}
 */
module.exports = /*#__PURE__*/function () {
  /**
   * Constructor function for the Container object responsible for managing a
   * set of `winston.Logger` instances based on string ids.
   * @param {!Object} [options={}] - Default pass-thru options for Loggers.
   */
  function Container() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Container);
    this.loggers = new Map();
    this.options = options;
  }

  /**
   * Retrieves a `winston.Logger` instance for the specified `id`. If an
   * instance does not exist, one is created.
   * @param {!string} id - The id of the Logger to get.
   * @param {?Object} [options] - Options for the Logger instance.
   * @returns {Logger} - A configured Logger instance with a specified id.
   */
  _createClass(Container, [{
    key: "add",
    value: function add(id, options) {
      var _this = this;
      if (!this.loggers.has(id)) {
        // Remark: Simple shallow clone for configuration options in case we pass
        // in instantiated protoypal objects
        options = Object.assign({}, options || this.options);
        var existing = options.transports || this.options.transports;

        // Remark: Make sure if we have an array of transports we slice it to
        // make copies of those references.
        if (existing) {
          options.transports = Array.isArray(existing) ? existing.slice() : [existing];
        } else {
          options.transports = [];
        }
        var logger = createLogger(options);
        logger.on('close', function () {
          return _this._delete(id);
        });
        this.loggers.set(id, logger);
      }
      return this.loggers.get(id);
    }

    /**
     * Retreives a `winston.Logger` instance for the specified `id`. If
     * an instance does not exist, one is created.
     * @param {!string} id - The id of the Logger to get.
     * @param {?Object} [options] - Options for the Logger instance.
     * @returns {Logger} - A configured Logger instance with a specified id.
     */
  }, {
    key: "get",
    value: function get(id, options) {
      return this.add(id, options);
    }

    /**
     * Check if the container has a logger with the id.
     * @param {?string} id - The id of the Logger instance to find.
     * @returns {boolean} - Boolean value indicating if this instance has a
     * logger with the specified `id`.
     */
  }, {
    key: "has",
    value: function has(id) {
      return !!this.loggers.has(id);
    }

    /**
     * Closes a `Logger` instance with the specified `id` if it exists.
     * If no `id` is supplied then all Loggers are closed.
     * @param {?string} id - The id of the Logger instance to close.
     * @returns {undefined}
     */
  }, {
    key: "close",
    value: function close(id) {
      var _this2 = this;
      if (id) {
        return this._removeLogger(id);
      }
      this.loggers.forEach(function (val, key) {
        return _this2._removeLogger(key);
      });
    }

    /**
     * Remove a logger based on the id.
     * @param {!string} id - The id of the logger to remove.
     * @returns {undefined}
     * @private
     */
  }, {
    key: "_removeLogger",
    value: function _removeLogger(id) {
      if (!this.loggers.has(id)) {
        return;
      }
      var logger = this.loggers.get(id);
      logger.close();
      this._delete(id);
    }

    /**
     * Deletes a `Logger` instance with the specified `id`.
     * @param {!string} id - The id of the Logger instance to delete from
     * container.
     * @returns {undefined}
     * @private
     */
  }, {
    key: "_delete",
    value: function _delete(id) {
      this.loggers["delete"](id);
    }
  }]);
  return Container;
}();

/***/ }),

/***/ 53040:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * create-logger.js: Logger factory for winston logger instances.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var _require = __webpack_require__(15396),
  LEVEL = _require.LEVEL;
var config = __webpack_require__(8953);
var Logger = __webpack_require__(47803);
var debug = __webpack_require__(12524)('winston:create-logger');
function isLevelEnabledFunctionName(level) {
  return 'is' + level.charAt(0).toUpperCase() + level.slice(1) + 'Enabled';
}

/**
 * Create a new instance of a winston Logger. Creates a new
 * prototype for each instance.
 * @param {!Object} opts - Options for the created logger.
 * @returns {Logger} - A newly created logger instance.
 */
module.exports = function () {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  //
  // Default levels: npm
  //
  opts.levels = opts.levels || config.npm.levels;

  /**
   * DerivedLogger to attach the logs level methods.
   * @type {DerivedLogger}
   * @extends {Logger}
   */
  var DerivedLogger = /*#__PURE__*/function (_Logger) {
    _inherits(DerivedLogger, _Logger);
    var _super = _createSuper(DerivedLogger);
    /**
     * Create a new class derived logger for which the levels can be attached to
     * the prototype of. This is a V8 optimization that is well know to increase
     * performance of prototype functions.
     * @param {!Object} options - Options for the created logger.
     */
    function DerivedLogger(options) {
      _classCallCheck(this, DerivedLogger);
      return _super.call(this, options);
    }
    return _createClass(DerivedLogger);
  }(Logger);
  var logger = new DerivedLogger(opts);

  //
  // Create the log level methods for the derived logger.
  //
  Object.keys(opts.levels).forEach(function (level) {
    debug('Define prototype method for "%s"', level);
    if (level === 'log') {
      // eslint-disable-next-line no-console
      console.warn('Level "log" not defined: conflicts with the method "log". Use a different level name.');
      return;
    }

    //
    // Define prototype methods for each log level e.g.:
    // logger.log('info', msg) implies these methods are defined:
    // - logger.info(msg)
    // - logger.isInfoEnabled()
    //
    // Remark: to support logger.child this **MUST** be a function
    // so it'll always be called on the instance instead of a fixed
    // place in the prototype chain.
    //
    DerivedLogger.prototype[level] = function () {
      // Prefer any instance scope, but default to "root" logger
      var self = this || logger;

      // Optimize the hot-path which is the single object.
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      if (args.length === 1) {
        var msg = args[0];
        var info = msg && msg.message && msg || {
          message: msg
        };
        info.level = info[LEVEL] = level;
        self._addDefaultMeta(info);
        self.write(info);
        return this || logger;
      }

      // When provided nothing assume the empty string
      if (args.length === 0) {
        self.log(level, '');
        return self;
      }

      // Otherwise build argument list which could potentially conform to
      // either:
      // . v3 API: log(obj)
      // 2. v1/v2 API: log(level, msg, ... [string interpolate], [{metadata}], [callback])
      return self.log.apply(self, [level].concat(args));
    };
    DerivedLogger.prototype[isLevelEnabledFunctionName(level)] = function () {
      return (this || logger).isLevelEnabled(level);
    };
  });
  return logger;
};

/***/ }),

/***/ 69796:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);
/**
 * exception-handler.js: Object for handling uncaughtException events.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var os = __webpack_require__(73461);
var asyncForEach = __webpack_require__(78058);
var debug = __webpack_require__(12524)('winston:exception');
var once = __webpack_require__(33138);
var stackTrace = __webpack_require__(77911);
var ExceptionStream = __webpack_require__(50288);

/**
 * Object for handling uncaughtException events.
 * @type {ExceptionHandler}
 */
module.exports = /*#__PURE__*/function () {
  /**
   * TODO: add contructor description
   * @param {!Logger} logger - TODO: add param description
   */
  function ExceptionHandler(logger) {
    _classCallCheck(this, ExceptionHandler);
    if (!logger) {
      throw new Error('Logger is required to handle exceptions');
    }
    this.logger = logger;
    this.handlers = new Map();
  }

  /**
   * Handles `uncaughtException` events for the current process by adding any
   * handlers passed in.
   * @returns {undefined}
   */
  _createClass(ExceptionHandler, [{
    key: "handle",
    value: function handle() {
      var _this = this;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      args.forEach(function (arg) {
        if (Array.isArray(arg)) {
          return arg.forEach(function (handler) {
            return _this._addHandler(handler);
          });
        }
        _this._addHandler(arg);
      });
      if (!this.catcher) {
        this.catcher = this._uncaughtException.bind(this);
        process.on('uncaughtException', this.catcher);
      }
    }

    /**
     * Removes any handlers to `uncaughtException` events for the current
     * process. This does not modify the state of the `this.handlers` set.
     * @returns {undefined}
     */
  }, {
    key: "unhandle",
    value: function unhandle() {
      var _this2 = this;
      if (this.catcher) {
        process.removeListener('uncaughtException', this.catcher);
        this.catcher = false;
        Array.from(this.handlers.values()).forEach(function (wrapper) {
          return _this2.logger.unpipe(wrapper);
        });
      }
    }

    /**
     * TODO: add method description
     * @param {Error} err - Error to get information about.
     * @returns {mixed} - TODO: add return description.
     */
  }, {
    key: "getAllInfo",
    value: function getAllInfo(err) {
      var message = null;
      if (err) {
        message = typeof err === 'string' ? err : err.message;
      }
      return {
        error: err,
        // TODO (indexzero): how do we configure this?
        level: 'error',
        message: ["uncaughtException: ".concat(message || '(no error message)'), err && err.stack || '  No stack trace'].join('\n'),
        stack: err && err.stack,
        exception: true,
        date: new Date().toString(),
        process: this.getProcessInfo(),
        os: this.getOsInfo(),
        trace: this.getTrace(err)
      };
    }

    /**
     * Gets all relevant process information for the currently running process.
     * @returns {mixed} - TODO: add return description.
     */
  }, {
    key: "getProcessInfo",
    value: function getProcessInfo() {
      return {
        pid: process.pid,
        uid: process.getuid ? process.getuid() : null,
        gid: process.getgid ? process.getgid() : null,
        cwd: process.cwd(),
        execPath: process.execPath,
        version: process.version,
        argv: process.argv,
        memoryUsage: process.memoryUsage()
      };
    }

    /**
     * Gets all relevant OS information for the currently running process.
     * @returns {mixed} - TODO: add return description.
     */
  }, {
    key: "getOsInfo",
    value: function getOsInfo() {
      return {
        loadavg: os.loadavg(),
        uptime: os.uptime()
      };
    }

    /**
     * Gets a stack trace for the specified error.
     * @param {mixed} err - TODO: add param description.
     * @returns {mixed} - TODO: add return description.
     */
  }, {
    key: "getTrace",
    value: function getTrace(err) {
      var trace = err ? stackTrace.parse(err) : stackTrace.get();
      return trace.map(function (site) {
        return {
          column: site.getColumnNumber(),
          file: site.getFileName(),
          "function": site.getFunctionName(),
          line: site.getLineNumber(),
          method: site.getMethodName(),
          "native": site.isNative()
        };
      });
    }

    /**
     * Helper method to add a transport as an exception handler.
     * @param {Transport} handler - The transport to add as an exception handler.
     * @returns {void}
     */
  }, {
    key: "_addHandler",
    value: function _addHandler(handler) {
      if (!this.handlers.has(handler)) {
        handler.handleExceptions = true;
        var wrapper = new ExceptionStream(handler);
        this.handlers.set(handler, wrapper);
        this.logger.pipe(wrapper);
      }
    }

    /**
     * Logs all relevant information around the `err` and exits the current
     * process.
     * @param {Error} err - Error to handle
     * @returns {mixed} - TODO: add return description.
     * @private
     */
  }, {
    key: "_uncaughtException",
    value: function _uncaughtException(err) {
      var info = this.getAllInfo(err);
      var handlers = this._getExceptionHandlers();
      // Calculate if we should exit on this error
      var doExit = typeof this.logger.exitOnError === 'function' ? this.logger.exitOnError(err) : this.logger.exitOnError;
      var timeout;
      if (!handlers.length && doExit) {
        // eslint-disable-next-line no-console
        console.warn('winston: exitOnError cannot be true with no exception handlers.');
        // eslint-disable-next-line no-console
        console.warn('winston: not exiting process.');
        doExit = false;
      }
      function gracefulExit() {
        debug('doExit', doExit);
        debug('process._exiting', process._exiting);
        if (doExit && !process._exiting) {
          // Remark: Currently ignoring any exceptions from transports when
          // catching uncaught exceptions.
          if (timeout) {
            clearTimeout(timeout);
          }
          // eslint-disable-next-line no-process-exit
          process.exit(1);
        }
      }
      if (!handlers || handlers.length === 0) {
        return process.nextTick(gracefulExit);
      }

      // Log to all transports attempting to listen for when they are completed.
      asyncForEach(handlers, function (handler, next) {
        var done = once(next);
        var transport = handler.transport || handler;

        // Debug wrapping so that we can inspect what's going on under the covers.
        function onDone(event) {
          return function () {
            debug(event);
            done();
          };
        }
        transport._ending = true;
        transport.once('finish', onDone('finished'));
        transport.once('error', onDone('error'));
      }, function () {
        return doExit && gracefulExit();
      });
      this.logger.log(info);

      // If exitOnError is true, then only allow the logging of exceptions to
      // take up to `3000ms`.
      if (doExit) {
        timeout = setTimeout(gracefulExit, 3000);
      }
    }

    /**
     * Returns the list of transports and exceptionHandlers for this instance.
     * @returns {Array} - List of transports and exceptionHandlers for this
     * instance.
     * @private
     */
  }, {
    key: "_getExceptionHandlers",
    value: function _getExceptionHandlers() {
      // Remark (indexzero): since `logger.transports` returns all of the pipes
      // from the _readableState of the stream we actually get the join of the
      // explicit handlers and the implicit transports with
      // `handleExceptions: true`
      return this.logger.transports.filter(function (wrap) {
        var transport = wrap.transport || wrap;
        return transport.handleExceptions;
      });
    }
  }]);
  return ExceptionHandler;
}();

/***/ }),

/***/ 50288:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * exception-stream.js: TODO: add file header handler.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var _require = __webpack_require__(88473),
  Writable = _require.Writable;

/**
 * TODO: add class description.
 * @type {ExceptionStream}
 * @extends {Writable}
 */
module.exports = /*#__PURE__*/function (_Writable) {
  _inherits(ExceptionStream, _Writable);
  var _super = _createSuper(ExceptionStream);
  /**
   * Constructor function for the ExceptionStream responsible for wrapping a
   * TransportStream; only allowing writes of `info` objects with
   * `info.exception` set to true.
   * @param {!TransportStream} transport - Stream to filter to exceptions
   */
  function ExceptionStream(transport) {
    var _this;
    _classCallCheck(this, ExceptionStream);
    _this = _super.call(this, {
      objectMode: true
    });
    if (!transport) {
      throw new Error('ExceptionStream requires a TransportStream instance.');
    }

    // Remark (indexzero): we set `handleExceptions` here because it's the
    // predicate checked in ExceptionHandler.prototype.__getExceptionHandlers
    _this.handleExceptions = true;
    _this.transport = transport;
    return _this;
  }

  /**
   * Writes the info object to our transport instance if (and only if) the
   * `exception` property is set on the info.
   * @param {mixed} info - TODO: add param description.
   * @param {mixed} enc - TODO: add param description.
   * @param {mixed} callback - TODO: add param description.
   * @returns {mixed} - TODO: add return description.
   * @private
   */
  _createClass(ExceptionStream, [{
    key: "_write",
    value: function _write(info, enc, callback) {
      if (info.exception) {
        return this.transport.log(info, callback);
      }
      callback();
      return true;
    }
  }]);
  return ExceptionStream;
}(Writable);

/***/ }),

/***/ 47803:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * logger.js: TODO: add file header description.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var _require = __webpack_require__(88473),
  Stream = _require.Stream,
  Transform = _require.Transform;
var asyncForEach = __webpack_require__(78058);
var _require2 = __webpack_require__(15396),
  LEVEL = _require2.LEVEL,
  SPLAT = _require2.SPLAT;
var isStream = __webpack_require__(24970);
var ExceptionHandler = __webpack_require__(69796);
var RejectionHandler = __webpack_require__(74841);
var LegacyTransportStream = __webpack_require__(54201);
var Profiler = __webpack_require__(25140);
var _require3 = __webpack_require__(23221),
  warn = _require3.warn;
var config = __webpack_require__(8953);

/**
 * Captures the number of format (i.e. %s strings) in a given string.
 * Based on `util.format`, see Node.js source:
 * https://github.com/nodejs/node/blob/b1c8f15c5f169e021f7c46eb7b219de95fe97603/lib/util.js#L201-L230
 * @type {RegExp}
 */
var formatRegExp = /%[scdjifoO%]/g;

/**
 * TODO: add class description.
 * @type {Logger}
 * @extends {Transform}
 */
var Logger = /*#__PURE__*/function (_Transform) {
  _inherits(Logger, _Transform);
  var _super = _createSuper(Logger);
  /**
   * Constructor function for the Logger object responsible for persisting log
   * messages and metadata to one or more transports.
   * @param {!Object} options - foo
   */
  function Logger(options) {
    var _this;
    _classCallCheck(this, Logger);
    _this = _super.call(this, {
      objectMode: true
    });
    _this.configure(options);
    return _this;
  }
  _createClass(Logger, [{
    key: "child",
    value: function child(defaultRequestMetadata) {
      var logger = this;
      return Object.create(logger, {
        write: {
          value: function value(info) {
            var infoClone = Object.assign({}, defaultRequestMetadata, info);

            // Object.assign doesn't copy inherited Error
            // properties so we have to do that explicitly
            //
            // Remark (indexzero): we should remove this
            // since the errors format will handle this case.
            //
            if (info instanceof Error) {
              infoClone.stack = info.stack;
              infoClone.message = info.message;
            }
            logger.write(infoClone);
          }
        }
      });
    }

    /**
     * This will wholesale reconfigure this instance by:
     * 1. Resetting all transports. Older transports will be removed implicitly.
     * 2. Set all other options including levels, colors, rewriters, filters,
     *    exceptionHandlers, etc.
     * @param {!Object} options - TODO: add param description.
     * @returns {undefined}
     */
  }, {
    key: "configure",
    value: function configure() {
      var _this2 = this;
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        silent = _ref.silent,
        format = _ref.format,
        defaultMeta = _ref.defaultMeta,
        levels = _ref.levels,
        _ref$level = _ref.level,
        level = _ref$level === void 0 ? 'info' : _ref$level,
        _ref$exitOnError = _ref.exitOnError,
        exitOnError = _ref$exitOnError === void 0 ? true : _ref$exitOnError,
        transports = _ref.transports,
        colors = _ref.colors,
        emitErrs = _ref.emitErrs,
        formatters = _ref.formatters,
        padLevels = _ref.padLevels,
        rewriters = _ref.rewriters,
        stripColors = _ref.stripColors,
        exceptionHandlers = _ref.exceptionHandlers,
        rejectionHandlers = _ref.rejectionHandlers;
      // Reset transports if we already have them
      if (this.transports.length) {
        this.clear();
      }
      this.silent = silent;
      this.format = format || this.format || __webpack_require__(13922)();
      this.defaultMeta = defaultMeta || null;
      // Hoist other options onto this instance.
      this.levels = levels || this.levels || config.npm.levels;
      this.level = level;
      if (this.exceptions) {
        this.exceptions.unhandle();
      }
      if (this.rejections) {
        this.rejections.unhandle();
      }
      this.exceptions = new ExceptionHandler(this);
      this.rejections = new RejectionHandler(this);
      this.profilers = {};
      this.exitOnError = exitOnError;

      // Add all transports we have been provided.
      if (transports) {
        transports = Array.isArray(transports) ? transports : [transports];
        transports.forEach(function (transport) {
          return _this2.add(transport);
        });
      }
      if (colors || emitErrs || formatters || padLevels || rewriters || stripColors) {
        throw new Error(['{ colors, emitErrs, formatters, padLevels, rewriters, stripColors } were removed in winston@3.0.0.', 'Use a custom winston.format(function) instead.', 'See: https://github.com/winstonjs/winston/tree/master/UPGRADE-3.0.md'].join('\n'));
      }
      if (exceptionHandlers) {
        this.exceptions.handle(exceptionHandlers);
      }
      if (rejectionHandlers) {
        this.rejections.handle(rejectionHandlers);
      }
    }
  }, {
    key: "isLevelEnabled",
    value: function isLevelEnabled(level) {
      var _this3 = this;
      var givenLevelValue = getLevelValue(this.levels, level);
      if (givenLevelValue === null) {
        return false;
      }
      var configuredLevelValue = getLevelValue(this.levels, this.level);
      if (configuredLevelValue === null) {
        return false;
      }
      if (!this.transports || this.transports.length === 0) {
        return configuredLevelValue >= givenLevelValue;
      }
      var index = this.transports.findIndex(function (transport) {
        var transportLevelValue = getLevelValue(_this3.levels, transport.level);
        if (transportLevelValue === null) {
          transportLevelValue = configuredLevelValue;
        }
        return transportLevelValue >= givenLevelValue;
      });
      return index !== -1;
    }

    /* eslint-disable valid-jsdoc */
    /**
     * Ensure backwards compatibility with a `log` method
     * @param {mixed} level - Level the log message is written at.
     * @param {mixed} msg - TODO: add param description.
     * @param {mixed} meta - TODO: add param description.
     * @returns {Logger} - TODO: add return description.
     *
     * @example
     *    // Supports the existing API:
     *    logger.log('info', 'Hello world', { custom: true });
     *    logger.log('info', new Error('Yo, it\'s on fire'));
     *
     *    // Requires winston.format.splat()
     *    logger.log('info', '%s %d%%', 'A string', 50, { thisIsMeta: true });
     *
     *    // And the new API with a single JSON literal:
     *    logger.log({ level: 'info', message: 'Hello world', custom: true });
     *    logger.log({ level: 'info', message: new Error('Yo, it\'s on fire') });
     *
     *    // Also requires winston.format.splat()
     *    logger.log({
     *      level: 'info',
     *      message: '%s %d%%',
     *      [SPLAT]: ['A string', 50],
     *      meta: { thisIsMeta: true }
     *    });
     *
     */
    /* eslint-enable valid-jsdoc */
  }, {
    key: "log",
    value: function log(level, msg) {
      var _Object$assign2;
      for (var _len = arguments.length, splat = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        splat[_key - 2] = arguments[_key];
      }
      // eslint-disable-line max-params
      // Optimize for the hotpath of logging JSON literals
      if (arguments.length === 1) {
        // Yo dawg, I heard you like levels ... seriously ...
        // In this context the LHS `level` here is actually the `info` so read
        // this as: info[LEVEL] = info.level;
        level[LEVEL] = level.level;
        this._addDefaultMeta(level);
        this.write(level);
        return this;
      }

      // Slightly less hotpath, but worth optimizing for.
      if (arguments.length === 2) {
        var _msg;
        if (msg && _typeof(msg) === 'object') {
          msg[LEVEL] = msg.level = level;
          this._addDefaultMeta(msg);
          this.write(msg);
          return this;
        }
        msg = (_msg = {}, _defineProperty(_msg, LEVEL, level), _defineProperty(_msg, "level", level), _defineProperty(_msg, "message", msg), _msg);
        this._addDefaultMeta(msg);
        this.write(msg);
        return this;
      }
      var meta = splat[0];
      if (_typeof(meta) === 'object' && meta !== null) {
        // Extract tokens, if none available default to empty array to
        // ensure consistancy in expected results
        var tokens = msg && msg.match && msg.match(formatRegExp);
        if (!tokens) {
          var _Object$assign;
          var info = Object.assign({}, this.defaultMeta, meta, (_Object$assign = {}, _defineProperty(_Object$assign, LEVEL, level), _defineProperty(_Object$assign, SPLAT, splat), _defineProperty(_Object$assign, "level", level), _defineProperty(_Object$assign, "message", msg), _Object$assign));
          if (meta.message) info.message = "".concat(info.message, " ").concat(meta.message);
          if (meta.stack) info.stack = meta.stack;
          this.write(info);
          return this;
        }
      }
      this.write(Object.assign({}, this.defaultMeta, (_Object$assign2 = {}, _defineProperty(_Object$assign2, LEVEL, level), _defineProperty(_Object$assign2, SPLAT, splat), _defineProperty(_Object$assign2, "level", level), _defineProperty(_Object$assign2, "message", msg), _Object$assign2)));
      return this;
    }

    /**
     * Pushes data so that it can be picked up by all of our pipe targets.
     * @param {mixed} info - TODO: add param description.
     * @param {mixed} enc - TODO: add param description.
     * @param {mixed} callback - Continues stream processing.
     * @returns {undefined}
     * @private
     */
  }, {
    key: "_transform",
    value: function _transform(info, enc, callback) {
      if (this.silent) {
        return callback();
      }

      // [LEVEL] is only soft guaranteed to be set here since we are a proper
      // stream. It is likely that `info` came in through `.log(info)` or
      // `.info(info)`. If it is not defined, however, define it.
      // This LEVEL symbol is provided by `triple-beam` and also used in:
      // - logform
      // - winston-transport
      // - abstract-winston-transport
      if (!info[LEVEL]) {
        info[LEVEL] = info.level;
      }

      // Remark: really not sure what to do here, but this has been reported as
      // very confusing by pre winston@2.0.0 users as quite confusing when using
      // custom levels.
      if (!this.levels[info[LEVEL]] && this.levels[info[LEVEL]] !== 0) {
        // eslint-disable-next-line no-console
        console.error('[winston] Unknown logger level: %s', info[LEVEL]);
      }

      // Remark: not sure if we should simply error here.
      if (!this._readableState.pipes) {
        // eslint-disable-next-line no-console
        console.error('[winston] Attempt to write logs with no transports, which can increase memory usage: %j', info);
      }

      // Here we write to the `format` pipe-chain, which on `readable` above will
      // push the formatted `info` Object onto the buffer for this instance. We trap
      // (and re-throw) any errors generated by the user-provided format, but also
      // guarantee that the streams callback is invoked so that we can continue flowing.
      try {
        this.push(this.format.transform(info, this.format.options));
      } finally {
        this._writableState.sync = false;
        // eslint-disable-next-line callback-return
        callback();
      }
    }

    /**
     * Delays the 'finish' event until all transport pipe targets have
     * also emitted 'finish' or are already finished.
     * @param {mixed} callback - Continues stream processing.
     */
  }, {
    key: "_final",
    value: function _final(callback) {
      var transports = this.transports.slice();
      asyncForEach(transports, function (transport, next) {
        if (!transport || transport.finished) return setImmediate(next);
        transport.once('finish', next);
        transport.end();
      }, callback);
    }

    /**
     * Adds the transport to this logger instance by piping to it.
     * @param {mixed} transport - TODO: add param description.
     * @returns {Logger} - TODO: add return description.
     */
  }, {
    key: "add",
    value: function add(transport) {
      // Support backwards compatibility with all existing `winston < 3.x.x`
      // transports which meet one of two criteria:
      // 1. They inherit from winston.Transport in  < 3.x.x which is NOT a stream.
      // 2. They expose a log method which has a length greater than 2 (i.e. more then
      //    just `log(info, callback)`.
      var target = !isStream(transport) || transport.log.length > 2 ? new LegacyTransportStream({
        transport: transport
      }) : transport;
      if (!target._writableState || !target._writableState.objectMode) {
        throw new Error('Transports must WritableStreams in objectMode. Set { objectMode: true }.');
      }

      // Listen for the `error` event and the `warn` event on the new Transport.
      this._onEvent('error', target);
      this._onEvent('warn', target);
      this.pipe(target);
      if (transport.handleExceptions) {
        this.exceptions.handle();
      }
      if (transport.handleRejections) {
        this.rejections.handle();
      }
      return this;
    }

    /**
     * Removes the transport from this logger instance by unpiping from it.
     * @param {mixed} transport - TODO: add param description.
     * @returns {Logger} - TODO: add return description.
     */
  }, {
    key: "remove",
    value: function remove(transport) {
      if (!transport) return this;
      var target = transport;
      if (!isStream(transport) || transport.log.length > 2) {
        target = this.transports.filter(function (match) {
          return match.transport === transport;
        })[0];
      }
      if (target) {
        this.unpipe(target);
      }
      return this;
    }

    /**
     * Removes all transports from this logger instance.
     * @returns {Logger} - TODO: add return description.
     */
  }, {
    key: "clear",
    value: function clear() {
      this.unpipe();
      return this;
    }

    /**
     * Cleans up resources (streams, event listeners) for all transports
     * associated with this instance (if necessary).
     * @returns {Logger} - TODO: add return description.
     */
  }, {
    key: "close",
    value: function close() {
      this.exceptions.unhandle();
      this.rejections.unhandle();
      this.clear();
      this.emit('close');
      return this;
    }

    /**
     * Sets the `target` levels specified on this instance.
     * @param {Object} Target levels to use on this instance.
     */
  }, {
    key: "setLevels",
    value: function setLevels() {
      warn.deprecated('setLevels');
    }

    /**
     * Queries the all transports for this instance with the specified `options`.
     * This will aggregate each transport's results into one object containing
     * a property per transport.
     * @param {Object} options - Query options for this instance.
     * @param {function} callback - Continuation to respond to when complete.
     */
  }, {
    key: "query",
    value: function query(options, callback) {
      if (typeof options === 'function') {
        callback = options;
        options = {};
      }
      options = options || {};
      var results = {};
      var queryObject = Object.assign({}, options.query || {});

      // Helper function to query a single transport
      function queryTransport(transport, next) {
        if (options.query && typeof transport.formatQuery === 'function') {
          options.query = transport.formatQuery(queryObject);
        }
        transport.query(options, function (err, res) {
          if (err) {
            return next(err);
          }
          if (typeof transport.formatResults === 'function') {
            res = transport.formatResults(res, options.format);
          }
          next(null, res);
        });
      }

      // Helper function to accumulate the results from `queryTransport` into
      // the `results`.
      function addResults(transport, next) {
        queryTransport(transport, function (err, result) {
          // queryTransport could potentially invoke the callback multiple times
          // since Transport code can be unpredictable.
          if (next) {
            result = err || result;
            if (result) {
              results[transport.name] = result;
            }

            // eslint-disable-next-line callback-return
            next();
          }
          next = null;
        });
      }

      // Iterate over the transports in parallel setting the appropriate key in
      // the `results`.
      asyncForEach(this.transports.filter(function (transport) {
        return !!transport.query;
      }), addResults, function () {
        return callback(null, results);
      });
    }

    /**
     * Returns a log stream for all transports. Options object is optional.
     * @param{Object} options={} - Stream options for this instance.
     * @returns {Stream} - TODO: add return description.
     */
  }, {
    key: "stream",
    value: function stream() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var out = new Stream();
      var streams = [];
      out._streams = streams;
      out.destroy = function () {
        var i = streams.length;
        while (i--) {
          streams[i].destroy();
        }
      };

      // Create a list of all transports for this instance.
      this.transports.filter(function (transport) {
        return !!transport.stream;
      }).forEach(function (transport) {
        var str = transport.stream(options);
        if (!str) {
          return;
        }
        streams.push(str);
        str.on('log', function (log) {
          log.transport = log.transport || [];
          log.transport.push(transport.name);
          out.emit('log', log);
        });
        str.on('error', function (err) {
          err.transport = err.transport || [];
          err.transport.push(transport.name);
          out.emit('error', err);
        });
      });
      return out;
    }

    /**
     * Returns an object corresponding to a specific timing. When done is called
     * the timer will finish and log the duration. e.g.:
     * @returns {Profile} - TODO: add return description.
     * @example
     *    const timer = winston.startTimer()
     *    setTimeout(() => {
     *      timer.done({
     *        message: 'Logging message'
     *      });
     *    }, 1000);
     */
  }, {
    key: "startTimer",
    value: function startTimer() {
      return new Profiler(this);
    }

    /**
     * Tracks the time inbetween subsequent calls to this method with the same
     * `id` parameter. The second call to this method will log the difference in
     * milliseconds along with the message.
     * @param {string} id Unique id of the profiler
     * @returns {Logger} - TODO: add return description.
     */
  }, {
    key: "profile",
    value: function profile(id) {
      var time = Date.now();
      if (this.profilers[id]) {
        var timeEnd = this.profilers[id];
        delete this.profilers[id];

        // Attempt to be kind to users if they are still using older APIs.
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        if (typeof args[args.length - 2] === 'function') {
          // eslint-disable-next-line no-console
          console.warn('Callback function no longer supported as of winston@3.0.0');
          args.pop();
        }

        // Set the duration property of the metadata
        var info = _typeof(args[args.length - 1]) === 'object' ? args.pop() : {};
        info.level = info.level || 'info';
        info.durationMs = time - timeEnd;
        info.message = info.message || id;
        return this.write(info);
      }
      this.profilers[id] = time;
      return this;
    }

    /**
     * Backwards compatibility to `exceptions.handle` in winston < 3.0.0.
     * @returns {undefined}
     * @deprecated
     */
  }, {
    key: "handleExceptions",
    value: function handleExceptions() {
      var _this$exceptions;
      // eslint-disable-next-line no-console
      console.warn('Deprecated: .handleExceptions() will be removed in winston@4. Use .exceptions.handle()');
      (_this$exceptions = this.exceptions).handle.apply(_this$exceptions, arguments);
    }

    /**
     * Backwards compatibility to `exceptions.handle` in winston < 3.0.0.
     * @returns {undefined}
     * @deprecated
     */
  }, {
    key: "unhandleExceptions",
    value: function unhandleExceptions() {
      var _this$exceptions2;
      // eslint-disable-next-line no-console
      console.warn('Deprecated: .unhandleExceptions() will be removed in winston@4. Use .exceptions.unhandle()');
      (_this$exceptions2 = this.exceptions).unhandle.apply(_this$exceptions2, arguments);
    }

    /**
     * Throw a more meaningful deprecation notice
     * @throws {Error} - TODO: add throws description.
     */
  }, {
    key: "cli",
    value: function cli() {
      throw new Error(['Logger.cli() was removed in winston@3.0.0', 'Use a custom winston.formats.cli() instead.', 'See: https://github.com/winstonjs/winston/tree/master/UPGRADE-3.0.md'].join('\n'));
    }

    /**
     * Bubbles the `event` that occured on the specified `transport` up
     * from this instance.
     * @param {string} event - The event that occured
     * @param {Object} transport - Transport on which the event occured
     * @private
     */
  }, {
    key: "_onEvent",
    value: function _onEvent(event, transport) {
      function transportEvent(err) {
        // https://github.com/winstonjs/winston/issues/1364
        if (event === 'error' && !this.transports.includes(transport)) {
          this.add(transport);
        }
        this.emit(event, err, transport);
      }
      if (!transport['__winston' + event]) {
        transport['__winston' + event] = transportEvent.bind(this);
        transport.on(event, transport['__winston' + event]);
      }
    }
  }, {
    key: "_addDefaultMeta",
    value: function _addDefaultMeta(msg) {
      if (this.defaultMeta) {
        Object.assign(msg, this.defaultMeta);
      }
    }
  }]);
  return Logger;
}(Transform);
function getLevelValue(levels, level) {
  var value = levels[level];
  if (!value && value !== 0) {
    return null;
  }
  return value;
}

/**
 * Represents the current readableState pipe targets for this Logger instance.
 * @type {Array|Object}
 */
Object.defineProperty(Logger.prototype, 'transports', {
  configurable: false,
  enumerable: true,
  get: function get() {
    var pipes = this._readableState.pipes;
    return !Array.isArray(pipes) ? [pipes].filter(Boolean) : pipes;
  }
});
module.exports = Logger;

/***/ }),

/***/ 25140:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * profiler.js: TODO: add file header description.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



/**
 * TODO: add class description.
 * @type {Profiler}
 * @private
 */
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Profiler = /*#__PURE__*/function () {
  /**
   * Constructor function for the Profiler instance used by
   * `Logger.prototype.startTimer`. When done is called the timer will finish
   * and log the duration.
   * @param {!Logger} logger - TODO: add param description.
   * @private
   */
  function Profiler(logger) {
    _classCallCheck(this, Profiler);
    var Logger = __webpack_require__(47803);
    if (_typeof(logger) !== 'object' || Array.isArray(logger) || !(logger instanceof Logger)) {
      throw new Error('Logger is required for profiling');
    } else {
      this.logger = logger;
      this.start = Date.now();
    }
  }

  /**
   * Ends the current timer (i.e. Profiler) instance and logs the `msg` along
   * with the duration since creation.
   * @returns {mixed} - TODO: add return description.
   * @private
   */
  _createClass(Profiler, [{
    key: "done",
    value: function done() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      if (typeof args[args.length - 1] === 'function') {
        // eslint-disable-next-line no-console
        console.warn('Callback function no longer supported as of winston@3.0.0');
        args.pop();
      }
      var info = _typeof(args[args.length - 1]) === 'object' ? args.pop() : {};
      info.level = info.level || 'info';
      info.durationMs = Date.now() - this.start;
      return this.logger.write(info);
    }
  }]);
  return Profiler;
}();
;
module.exports = Profiler;

/***/ }),

/***/ 74841:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);
/**
 * exception-handler.js: Object for handling uncaughtException events.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var os = __webpack_require__(73461);
var asyncForEach = __webpack_require__(78058);
var debug = __webpack_require__(12524)('winston:rejection');
var once = __webpack_require__(33138);
var stackTrace = __webpack_require__(77911);
var ExceptionStream = __webpack_require__(50288);

/**
 * Object for handling unhandledRejection events.
 * @type {RejectionHandler}
 */
module.exports = /*#__PURE__*/function () {
  /**
   * TODO: add contructor description
   * @param {!Logger} logger - TODO: add param description
   */
  function RejectionHandler(logger) {
    _classCallCheck(this, RejectionHandler);
    if (!logger) {
      throw new Error('Logger is required to handle rejections');
    }
    this.logger = logger;
    this.handlers = new Map();
  }

  /**
   * Handles `unhandledRejection` events for the current process by adding any
   * handlers passed in.
   * @returns {undefined}
   */
  _createClass(RejectionHandler, [{
    key: "handle",
    value: function handle() {
      var _this = this;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      args.forEach(function (arg) {
        if (Array.isArray(arg)) {
          return arg.forEach(function (handler) {
            return _this._addHandler(handler);
          });
        }
        _this._addHandler(arg);
      });
      if (!this.catcher) {
        this.catcher = this._unhandledRejection.bind(this);
        process.on('unhandledRejection', this.catcher);
      }
    }

    /**
     * Removes any handlers to `unhandledRejection` events for the current
     * process. This does not modify the state of the `this.handlers` set.
     * @returns {undefined}
     */
  }, {
    key: "unhandle",
    value: function unhandle() {
      var _this2 = this;
      if (this.catcher) {
        process.removeListener('unhandledRejection', this.catcher);
        this.catcher = false;
        Array.from(this.handlers.values()).forEach(function (wrapper) {
          return _this2.logger.unpipe(wrapper);
        });
      }
    }

    /**
     * TODO: add method description
     * @param {Error} err - Error to get information about.
     * @returns {mixed} - TODO: add return description.
     */
  }, {
    key: "getAllInfo",
    value: function getAllInfo(err) {
      var message = null;
      if (err) {
        message = typeof err === 'string' ? err : err.message;
      }
      return {
        error: err,
        // TODO (indexzero): how do we configure this?
        level: 'error',
        message: ["unhandledRejection: ".concat(message || '(no error message)'), err && err.stack || '  No stack trace'].join('\n'),
        stack: err && err.stack,
        exception: true,
        date: new Date().toString(),
        process: this.getProcessInfo(),
        os: this.getOsInfo(),
        trace: this.getTrace(err)
      };
    }

    /**
     * Gets all relevant process information for the currently running process.
     * @returns {mixed} - TODO: add return description.
     */
  }, {
    key: "getProcessInfo",
    value: function getProcessInfo() {
      return {
        pid: process.pid,
        uid: process.getuid ? process.getuid() : null,
        gid: process.getgid ? process.getgid() : null,
        cwd: process.cwd(),
        execPath: process.execPath,
        version: process.version,
        argv: process.argv,
        memoryUsage: process.memoryUsage()
      };
    }

    /**
     * Gets all relevant OS information for the currently running process.
     * @returns {mixed} - TODO: add return description.
     */
  }, {
    key: "getOsInfo",
    value: function getOsInfo() {
      return {
        loadavg: os.loadavg(),
        uptime: os.uptime()
      };
    }

    /**
     * Gets a stack trace for the specified error.
     * @param {mixed} err - TODO: add param description.
     * @returns {mixed} - TODO: add return description.
     */
  }, {
    key: "getTrace",
    value: function getTrace(err) {
      var trace = err ? stackTrace.parse(err) : stackTrace.get();
      return trace.map(function (site) {
        return {
          column: site.getColumnNumber(),
          file: site.getFileName(),
          "function": site.getFunctionName(),
          line: site.getLineNumber(),
          method: site.getMethodName(),
          "native": site.isNative()
        };
      });
    }

    /**
     * Helper method to add a transport as an exception handler.
     * @param {Transport} handler - The transport to add as an exception handler.
     * @returns {void}
     */
  }, {
    key: "_addHandler",
    value: function _addHandler(handler) {
      if (!this.handlers.has(handler)) {
        handler.handleRejections = true;
        var wrapper = new ExceptionStream(handler);
        this.handlers.set(handler, wrapper);
        this.logger.pipe(wrapper);
      }
    }

    /**
     * Logs all relevant information around the `err` and exits the current
     * process.
     * @param {Error} err - Error to handle
     * @returns {mixed} - TODO: add return description.
     * @private
     */
  }, {
    key: "_unhandledRejection",
    value: function _unhandledRejection(err) {
      var info = this.getAllInfo(err);
      var handlers = this._getRejectionHandlers();
      // Calculate if we should exit on this error
      var doExit = typeof this.logger.exitOnError === 'function' ? this.logger.exitOnError(err) : this.logger.exitOnError;
      var timeout;
      if (!handlers.length && doExit) {
        // eslint-disable-next-line no-console
        console.warn('winston: exitOnError cannot be true with no rejection handlers.');
        // eslint-disable-next-line no-console
        console.warn('winston: not exiting process.');
        doExit = false;
      }
      function gracefulExit() {
        debug('doExit', doExit);
        debug('process._exiting', process._exiting);
        if (doExit && !process._exiting) {
          // Remark: Currently ignoring any rejections from transports when
          // catching unhandled rejections.
          if (timeout) {
            clearTimeout(timeout);
          }
          // eslint-disable-next-line no-process-exit
          process.exit(1);
        }
      }
      if (!handlers || handlers.length === 0) {
        return process.nextTick(gracefulExit);
      }

      // Log to all transports attempting to listen for when they are completed.
      asyncForEach(handlers, function (handler, next) {
        var done = once(next);
        var transport = handler.transport || handler;

        // Debug wrapping so that we can inspect what's going on under the covers.
        function onDone(event) {
          return function () {
            debug(event);
            done();
          };
        }
        transport._ending = true;
        transport.once('finish', onDone('finished'));
        transport.once('error', onDone('error'));
      }, function () {
        return doExit && gracefulExit();
      });
      this.logger.log(info);

      // If exitOnError is true, then only allow the logging of exceptions to
      // take up to `3000ms`.
      if (doExit) {
        timeout = setTimeout(gracefulExit, 3000);
      }
    }

    /**
     * Returns the list of transports and exceptionHandlers for this instance.
     * @returns {Array} - List of transports and exceptionHandlers for this
     * instance.
     * @private
     */
  }, {
    key: "_getRejectionHandlers",
    value: function _getRejectionHandlers() {
      // Remark (indexzero): since `logger.transports` returns all of the pipes
      // from the _readableState of the stream we actually get the join of the
      // explicit handlers and the implicit transports with
      // `handleRejections: true`
      return this.logger.transports.filter(function (wrap) {
        var transport = wrap.transport || wrap;
        return transport.handleRejections;
      });
    }
  }]);
  return RejectionHandler;
}();

/***/ }),

/***/ 61860:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
/**
 * tail-file.js: TODO: add file header description.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



var fs = __webpack_require__(62828);
var _require = __webpack_require__(32553),
  StringDecoder = _require.StringDecoder;
var _require2 = __webpack_require__(88473),
  Stream = _require2.Stream;

/**
 * Simple no-op function.
 * @returns {undefined}
 */
function noop() {}

/**
 * TODO: add function description.
 * @param {Object} options - Options for tail.
 * @param {function} iter - Iterator function to execute on every line.
* `tail -f` a file. Options must include file.
 * @returns {mixed} - TODO: add return description.
 */
module.exports = function (options, iter) {
  var buffer = Buffer.alloc(64 * 1024);
  var decode = new StringDecoder('utf8');
  var stream = new Stream();
  var buff = '';
  var pos = 0;
  var row = 0;
  if (options.start === -1) {
    delete options.start;
  }
  stream.readable = true;
  stream.destroy = function () {
    stream.destroyed = true;
    stream.emit('end');
    stream.emit('close');
  };
  fs.open(options.file, 'a+', '0644', function (err, fd) {
    if (err) {
      if (!iter) {
        stream.emit('error', err);
      } else {
        iter(err);
      }
      stream.destroy();
      return;
    }
    (function read() {
      if (stream.destroyed) {
        fs.close(fd, noop);
        return;
      }
      return fs.read(fd, buffer, 0, buffer.length, pos, function (error, bytes) {
        if (error) {
          if (!iter) {
            stream.emit('error', error);
          } else {
            iter(error);
          }
          stream.destroy();
          return;
        }
        if (!bytes) {
          if (buff) {
            // eslint-disable-next-line eqeqeq
            if (options.start == null || row > options.start) {
              if (!iter) {
                stream.emit('line', buff);
              } else {
                iter(null, buff);
              }
            }
            row++;
            buff = '';
          }
          return setTimeout(read, 1000);
        }
        var data = decode.write(buffer.slice(0, bytes));
        if (!iter) {
          stream.emit('data', data);
        }
        data = (buff + data).split(/\n+/);
        var l = data.length - 1;
        var i = 0;
        for (; i < l; i++) {
          // eslint-disable-next-line eqeqeq
          if (options.start == null || row > options.start) {
            if (!iter) {
              stream.emit('line', data[i]);
            } else {
              iter(null, data[i]);
            }
          }
          row++;
        }
        buff = data[l];
        pos += bytes;
        return read();
      });
    })();
  });
  if (!iter) {
    return stream;
  }
  return stream.destroy;
};

/***/ }),

/***/ 93739:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable no-console */
/*
 * console.js: Transport for outputting to the console.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var os = __webpack_require__(73461);
var _require = __webpack_require__(15396),
  LEVEL = _require.LEVEL,
  MESSAGE = _require.MESSAGE;
var TransportStream = __webpack_require__(94307);

/**
 * Transport for outputting to the console.
 * @type {Console}
 * @extends {TransportStream}
 */
module.exports = /*#__PURE__*/function (_TransportStream) {
  _inherits(Console, _TransportStream);
  var _super = _createSuper(Console);
  /**
   * Constructor function for the Console transport object responsible for
   * persisting log messages and metadata to a terminal or TTY.
   * @param {!Object} [options={}] - Options for this instance.
   */
  function Console() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Console);
    _this = _super.call(this, options);

    // Expose the name of this Transport on the prototype
    _this.name = options.name || 'console';
    _this.stderrLevels = _this._stringArrayToSet(options.stderrLevels);
    _this.consoleWarnLevels = _this._stringArrayToSet(options.consoleWarnLevels);
    _this.eol = typeof options.eol === 'string' ? options.eol : os.EOL;
    _this.setMaxListeners(30);
    return _this;
  }

  /**
   * Core logging method exposed to Winston.
   * @param {Object} info - TODO: add param description.
   * @param {Function} callback - TODO: add param description.
   * @returns {undefined}
   */
  _createClass(Console, [{
    key: "log",
    value: function log(info, callback) {
      var _this2 = this;
      setImmediate(function () {
        return _this2.emit('logged', info);
      });

      // Remark: what if there is no raw...?
      if (this.stderrLevels[info[LEVEL]]) {
        if (console._stderr) {
          // Node.js maps `process.stderr` to `console._stderr`.
          console._stderr.write("".concat(info[MESSAGE]).concat(this.eol));
        } else {
          // console.error adds a newline
          console.error(info[MESSAGE]);
        }
        if (callback) {
          callback(); // eslint-disable-line callback-return
        }

        return;
      } else if (this.consoleWarnLevels[info[LEVEL]]) {
        if (console._stderr) {
          // Node.js maps `process.stderr` to `console._stderr`.
          // in Node.js console.warn is an alias for console.error
          console._stderr.write("".concat(info[MESSAGE]).concat(this.eol));
        } else {
          // console.warn adds a newline
          console.warn(info[MESSAGE]);
        }
        if (callback) {
          callback(); // eslint-disable-line callback-return
        }

        return;
      }
      if (console._stdout) {
        // Node.js maps `process.stdout` to `console._stdout`.
        console._stdout.write("".concat(info[MESSAGE]).concat(this.eol));
      } else {
        // console.log adds a newline.
        console.log(info[MESSAGE]);
      }
      if (callback) {
        callback(); // eslint-disable-line callback-return
      }
    }

    /**
     * Returns a Set-like object with strArray's elements as keys (each with the
     * value true).
     * @param {Array} strArray - Array of Set-elements as strings.
     * @param {?string} [errMsg] - Custom error message thrown on invalid input.
     * @returns {Object} - TODO: add return description.
     * @private
     */
  }, {
    key: "_stringArrayToSet",
    value: function _stringArrayToSet(strArray, errMsg) {
      if (!strArray) return {};
      errMsg = errMsg || 'Cannot make set from type other than Array of string elements';
      if (!Array.isArray(strArray)) {
        throw new Error(errMsg);
      }
      return strArray.reduce(function (set, el) {
        if (typeof el !== 'string') {
          throw new Error(errMsg);
        }
        set[el] = true;
        return set;
      }, {});
    }
  }]);
  return Console;
}(TransportStream);

/***/ }),

/***/ 13401:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
/* eslint-disable complexity,max-statements */
/**
 * file.js: Transport for outputting to a local log file.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var fs = __webpack_require__(85811);
var path = __webpack_require__(1864);
var asyncSeries = __webpack_require__(48415);
var zlib = __webpack_require__(47715);
var _require = __webpack_require__(15396),
  MESSAGE = _require.MESSAGE;
var _require2 = __webpack_require__(88473),
  Stream = _require2.Stream,
  PassThrough = _require2.PassThrough;
var TransportStream = __webpack_require__(94307);
var debug = __webpack_require__(12524)('winston:file');
var os = __webpack_require__(73461);
var tailFile = __webpack_require__(61860);

/**
 * Transport for outputting to a local log file.
 * @type {File}
 * @extends {TransportStream}
 */
module.exports = /*#__PURE__*/function (_TransportStream) {
  _inherits(File, _TransportStream);
  var _super = _createSuper(File);
  /**
   * Constructor function for the File transport object responsible for
   * persisting log messages and metadata to one or more files.
   * @param {Object} options - Options for this instance.
   */
  function File() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, File);
    _this = _super.call(this, options);

    // Expose the name of this Transport on the prototype.
    _this.name = options.name || 'file';

    // Helper function which throws an `Error` in the event that any of the
    // rest of the arguments is present in `options`.
    function throwIf(target) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      args.slice(1).forEach(function (name) {
        if (options[name]) {
          throw new Error("Cannot set ".concat(name, " and ").concat(target, " together"));
        }
      });
    }

    // Setup the base stream that always gets piped to to handle buffering.
    _this._stream = new PassThrough();
    _this._stream.setMaxListeners(30);

    // Bind this context for listener methods.
    _this._onError = _this._onError.bind(_assertThisInitialized(_this));
    if (options.filename || options.dirname) {
      throwIf('filename or dirname', 'stream');
      _this._basename = _this.filename = options.filename ? path.basename(options.filename) : 'winston.log';
      _this.dirname = options.dirname || path.dirname(options.filename);
      _this.options = options.options || {
        flags: 'a'
      };
    } else if (options.stream) {
      // eslint-disable-next-line no-console
      console.warn('options.stream will be removed in winston@4. Use winston.transports.Stream');
      throwIf('stream', 'filename', 'maxsize');
      _this._dest = _this._stream.pipe(_this._setupStream(options.stream));
      _this.dirname = path.dirname(_this._dest.path);
      // We need to listen for drain events when write() returns false. This
      // can make node mad at times.
    } else {
      throw new Error('Cannot log to file without filename or stream.');
    }
    _this.maxsize = options.maxsize || null;
    _this.rotationFormat = options.rotationFormat || false;
    _this.zippedArchive = options.zippedArchive || false;
    _this.maxFiles = options.maxFiles || null;
    _this.eol = typeof options.eol === 'string' ? options.eol : os.EOL;
    _this.tailable = options.tailable || false;
    _this.lazy = options.lazy || false;

    // Internal state variables representing the number of files this instance
    // has created and the current size (in bytes) of the current logfile.
    _this._size = 0;
    _this._pendingSize = 0;
    _this._created = 0;
    _this._drain = false;
    _this._opening = false;
    _this._ending = false;
    _this._fileExist = false;
    if (_this.dirname) _this._createLogDirIfNotExist(_this.dirname);
    if (!_this.lazy) _this.open();
    return _this;
  }
  _createClass(File, [{
    key: "finishIfEnding",
    value: function finishIfEnding() {
      var _this2 = this;
      if (this._ending) {
        if (this._opening) {
          this.once('open', function () {
            _this2._stream.once('finish', function () {
              return _this2.emit('finish');
            });
            setImmediate(function () {
              return _this2._stream.end();
            });
          });
        } else {
          this._stream.once('finish', function () {
            return _this2.emit('finish');
          });
          setImmediate(function () {
            return _this2._stream.end();
          });
        }
      }
    }

    /**
     * Core logging method exposed to Winston. Metadata is optional.
     * @param {Object} info - TODO: add param description.
     * @param {Function} callback - TODO: add param description.
     * @returns {undefined}
     */
  }, {
    key: "log",
    value: function log(info) {
      var _this3 = this;
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      // Remark: (jcrugzz) What is necessary about this callback(null, true) now
      // when thinking about 3.x? Should silent be handled in the base
      // TransportStream _write method?
      if (this.silent) {
        callback();
        return true;
      }

      // Output stream buffer is full and has asked us to wait for the drain event
      if (this._drain) {
        this._stream.once('drain', function () {
          _this3._drain = false;
          _this3.log(info, callback);
        });
        return;
      }
      if (this._rotate) {
        this._stream.once('rotate', function () {
          _this3._rotate = false;
          _this3.log(info, callback);
        });
        return;
      }
      if (this.lazy) {
        if (!this._fileExist) {
          if (!this._opening) {
            this.open();
          }
          this.once('open', function () {
            _this3._fileExist = true;
            _this3.log(info, callback);
            return;
          });
          return;
        }
        if (this._needsNewFile(this._pendingSize)) {
          this._dest.once('close', function () {
            if (!_this3._opening) {
              _this3.open();
            }
            _this3.once('open', function () {
              _this3.log(info, callback);
              return;
            });
            return;
          });
          return;
        }
      }

      // Grab the raw string and append the expected EOL.
      var output = "".concat(info[MESSAGE]).concat(this.eol);
      var bytes = Buffer.byteLength(output);

      // After we have written to the PassThrough check to see if we need
      // to rotate to the next file.
      //
      // Remark: This gets called too early and does not depict when data
      // has been actually flushed to disk.
      function logged() {
        var _this4 = this;
        this._size += bytes;
        this._pendingSize -= bytes;
        debug('logged %s %s', this._size, output);
        this.emit('logged', info);

        // Do not attempt to rotate files while rotating
        if (this._rotate) {
          return;
        }

        // Do not attempt to rotate files while opening
        if (this._opening) {
          return;
        }

        // Check to see if we need to end the stream and create a new one.
        if (!this._needsNewFile()) {
          return;
        }
        if (this.lazy) {
          this._endStream(function () {
            _this4.emit('fileclosed');
          });
          return;
        }

        // End the current stream, ensure it flushes and create a new one.
        // This could potentially be optimized to not run a stat call but its
        // the safest way since we are supporting `maxFiles`.
        this._rotate = true;
        this._endStream(function () {
          return _this4._rotateFile();
        });
      }

      // Keep track of the pending bytes being written while files are opening
      // in order to properly rotate the PassThrough this._stream when the file
      // eventually does open.
      this._pendingSize += bytes;
      if (this._opening && !this.rotatedWhileOpening && this._needsNewFile(this._size + this._pendingSize)) {
        this.rotatedWhileOpening = true;
      }
      var written = this._stream.write(output, logged.bind(this));
      if (!written) {
        this._drain = true;
        this._stream.once('drain', function () {
          _this3._drain = false;
          callback();
        });
      } else {
        callback(); // eslint-disable-line callback-return
      }

      debug('written', written, this._drain);
      this.finishIfEnding();
      return written;
    }

    /**
     * Query the transport. Options object is optional.
     * @param {Object} options - Loggly-like query options for this instance.
     * @param {function} callback - Continuation to respond to when complete.
     * TODO: Refactor me.
     */
  }, {
    key: "query",
    value: function query(options, callback) {
      if (typeof options === 'function') {
        callback = options;
        options = {};
      }
      options = normalizeQuery(options);
      var file = path.join(this.dirname, this.filename);
      var buff = '';
      var results = [];
      var row = 0;
      var stream = fs.createReadStream(file, {
        encoding: 'utf8'
      });
      stream.on('error', function (err) {
        if (stream.readable) {
          stream.destroy();
        }
        if (!callback) {
          return;
        }
        return err.code !== 'ENOENT' ? callback(err) : callback(null, results);
      });
      stream.on('data', function (data) {
        data = (buff + data).split(/\n+/);
        var l = data.length - 1;
        var i = 0;
        for (; i < l; i++) {
          if (!options.start || row >= options.start) {
            add(data[i]);
          }
          row++;
        }
        buff = data[l];
      });
      stream.on('close', function () {
        if (buff) {
          add(buff, true);
        }
        if (options.order === 'desc') {
          results = results.reverse();
        }

        // eslint-disable-next-line callback-return
        if (callback) callback(null, results);
      });
      function add(buff, attempt) {
        try {
          var log = JSON.parse(buff);
          if (check(log)) {
            push(log);
          }
        } catch (e) {
          if (!attempt) {
            stream.emit('error', e);
          }
        }
      }
      function push(log) {
        if (options.rows && results.length >= options.rows && options.order !== 'desc') {
          if (stream.readable) {
            stream.destroy();
          }
          return;
        }
        if (options.fields) {
          log = options.fields.reduce(function (obj, key) {
            obj[key] = log[key];
            return obj;
          }, {});
        }
        if (options.order === 'desc') {
          if (results.length >= options.rows) {
            results.shift();
          }
        }
        results.push(log);
      }
      function check(log) {
        if (!log) {
          return;
        }
        if (_typeof(log) !== 'object') {
          return;
        }
        var time = new Date(log.timestamp);
        if (options.from && time < options.from || options.until && time > options.until || options.level && options.level !== log.level) {
          return;
        }
        return true;
      }
      function normalizeQuery(options) {
        options = options || {};

        // limit
        options.rows = options.rows || options.limit || 10;

        // starting row offset
        options.start = options.start || 0;

        // now
        options.until = options.until || new Date();
        if (_typeof(options.until) !== 'object') {
          options.until = new Date(options.until);
        }

        // now - 24
        options.from = options.from || options.until - 24 * 60 * 60 * 1000;
        if (_typeof(options.from) !== 'object') {
          options.from = new Date(options.from);
        }

        // 'asc' or 'desc'
        options.order = options.order || 'desc';
        return options;
      }
    }

    /**
     * Returns a log stream for this transport. Options object is optional.
     * @param {Object} options - Stream options for this instance.
     * @returns {Stream} - TODO: add return description.
     * TODO: Refactor me.
     */
  }, {
    key: "stream",
    value: function stream() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var file = path.join(this.dirname, this.filename);
      var stream = new Stream();
      var tail = {
        file: file,
        start: options.start
      };
      stream.destroy = tailFile(tail, function (err, line) {
        if (err) {
          return stream.emit('error', err);
        }
        try {
          stream.emit('data', line);
          line = JSON.parse(line);
          stream.emit('log', line);
        } catch (e) {
          stream.emit('error', e);
        }
      });
      return stream;
    }

    /**
     * Checks to see the filesize of.
     * @returns {undefined}
     */
  }, {
    key: "open",
    value: function open() {
      var _this5 = this;
      // If we do not have a filename then we were passed a stream and
      // don't need to keep track of size.
      if (!this.filename) return;
      if (this._opening) return;
      this._opening = true;

      // Stat the target file to get the size and create the stream.
      this.stat(function (err, size) {
        if (err) {
          return _this5.emit('error', err);
        }
        debug('stat done: %s { size: %s }', _this5.filename, size);
        _this5._size = size;
        _this5._dest = _this5._createStream(_this5._stream);
        _this5._opening = false;
        _this5.once('open', function () {
          if (_this5._stream.eventNames().includes('rotate')) {
            _this5._stream.emit('rotate');
          } else {
            _this5._rotate = false;
          }
        });
      });
    }

    /**
     * Stat the file and assess information in order to create the proper stream.
     * @param {function} callback - TODO: add param description.
     * @returns {undefined}
     */
  }, {
    key: "stat",
    value: function stat(callback) {
      var _this6 = this;
      var target = this._getFile();
      var fullpath = path.join(this.dirname, target);
      fs.stat(fullpath, function (err, stat) {
        if (err && err.code === 'ENOENT') {
          debug('ENOENT ok', fullpath);
          // Update internally tracked filename with the new target name.
          _this6.filename = target;
          return callback(null, 0);
        }
        if (err) {
          debug("err ".concat(err.code, " ").concat(fullpath));
          return callback(err);
        }
        if (!stat || _this6._needsNewFile(stat.size)) {
          // If `stats.size` is greater than the `maxsize` for this
          // instance then try again.
          return _this6._incFile(function () {
            return _this6.stat(callback);
          });
        }

        // Once we have figured out what the filename is, set it
        // and return the size.
        _this6.filename = target;
        callback(null, stat.size);
      });
    }

    /**
     * Closes the stream associated with this instance.
     * @param {function} cb - TODO: add param description.
     * @returns {undefined}
     */
  }, {
    key: "close",
    value: function close(cb) {
      var _this7 = this;
      if (!this._stream) {
        return;
      }
      this._stream.end(function () {
        if (cb) {
          cb(); // eslint-disable-line callback-return
        }

        _this7.emit('flush');
        _this7.emit('closed');
      });
    }

    /**
     * TODO: add method description.
     * @param {number} size - TODO: add param description.
     * @returns {undefined}
     */
  }, {
    key: "_needsNewFile",
    value: function _needsNewFile(size) {
      size = size || this._size;
      return this.maxsize && size >= this.maxsize;
    }

    /**
     * TODO: add method description.
     * @param {Error} err - TODO: add param description.
     * @returns {undefined}
     */
  }, {
    key: "_onError",
    value: function _onError(err) {
      this.emit('error', err);
    }

    /**
     * TODO: add method description.
     * @param {Stream} stream - TODO: add param description.
     * @returns {mixed} - TODO: add return description.
     */
  }, {
    key: "_setupStream",
    value: function _setupStream(stream) {
      stream.on('error', this._onError);
      return stream;
    }

    /**
     * TODO: add method description.
     * @param {Stream} stream - TODO: add param description.
     * @returns {mixed} - TODO: add return description.
     */
  }, {
    key: "_cleanupStream",
    value: function _cleanupStream(stream) {
      stream.removeListener('error', this._onError);
      stream.destroy();
      return stream;
    }

    /**
     * TODO: add method description.
     */
  }, {
    key: "_rotateFile",
    value: function _rotateFile() {
      var _this8 = this;
      this._incFile(function () {
        return _this8.open();
      });
    }

    /**
     * Unpipe from the stream that has been marked as full and end it so it
     * flushes to disk.
     *
     * @param {function} callback - Callback for when the current file has closed.
     * @private
     */
  }, {
    key: "_endStream",
    value: function _endStream() {
      var _this9 = this;
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      if (this._dest) {
        this._stream.unpipe(this._dest);
        this._dest.end(function () {
          _this9._cleanupStream(_this9._dest);
          callback();
        });
      } else {
        callback(); // eslint-disable-line callback-return
      }
    }

    /**
     * Returns the WritableStream for the active file on this instance. If we
     * should gzip the file then a zlib stream is returned.
     *
     * @param {ReadableStream} source –PassThrough to pipe to the file when open.
     * @returns {WritableStream} Stream that writes to disk for the active file.
     */
  }, {
    key: "_createStream",
    value: function _createStream(source) {
      var _this10 = this;
      var fullpath = path.join(this.dirname, this.filename);
      debug('create stream start', fullpath, this.options);
      var dest = fs.createWriteStream(fullpath, this.options)
      // TODO: What should we do with errors here?
      .on('error', function (err) {
        return debug(err);
      }).on('close', function () {
        return debug('close', dest.path, dest.bytesWritten);
      }).on('open', function () {
        debug('file open ok', fullpath);
        _this10.emit('open', fullpath);
        source.pipe(dest);

        // If rotation occured during the open operation then we immediately
        // start writing to a new PassThrough, begin opening the next file
        // and cleanup the previous source and dest once the source has drained.
        if (_this10.rotatedWhileOpening) {
          _this10._stream = new PassThrough();
          _this10._stream.setMaxListeners(30);
          _this10._rotateFile();
          _this10.rotatedWhileOpening = false;
          _this10._cleanupStream(dest);
          source.end();
        }
      });
      debug('create stream ok', fullpath);
      if (this.zippedArchive) {
        var gzip = zlib.createGzip();
        gzip.pipe(dest);
        return gzip;
      }
      return dest;
    }

    /**
     * TODO: add method description.
     * @param {function} callback - TODO: add param description.
     * @returns {undefined}
     */
  }, {
    key: "_incFile",
    value: function _incFile(callback) {
      debug('_incFile', this.filename);
      var ext = path.extname(this._basename);
      var basename = path.basename(this._basename, ext);
      if (!this.tailable) {
        this._created += 1;
        this._checkMaxFilesIncrementing(ext, basename, callback);
      } else {
        this._checkMaxFilesTailable(ext, basename, callback);
      }
    }

    /**
     * Gets the next filename to use for this instance in the case that log
     * filesizes are being capped.
     * @returns {string} - TODO: add return description.
     * @private
     */
  }, {
    key: "_getFile",
    value: function _getFile() {
      var ext = path.extname(this._basename);
      var basename = path.basename(this._basename, ext);
      var isRotation = this.rotationFormat ? this.rotationFormat() : this._created;

      // Caveat emptor (indexzero): rotationFormat() was broken by design When
      // combined with max files because the set of files to unlink is never
      // stored.
      var target = !this.tailable && this._created ? "".concat(basename).concat(isRotation).concat(ext) : "".concat(basename).concat(ext);
      return this.zippedArchive && !this.tailable ? "".concat(target, ".gz") : target;
    }

    /**
     * Increment the number of files created or checked by this instance.
     * @param {mixed} ext - TODO: add param description.
     * @param {mixed} basename - TODO: add param description.
     * @param {mixed} callback - TODO: add param description.
     * @returns {undefined}
     * @private
     */
  }, {
    key: "_checkMaxFilesIncrementing",
    value: function _checkMaxFilesIncrementing(ext, basename, callback) {
      // Check for maxFiles option and delete file.
      if (!this.maxFiles || this._created < this.maxFiles) {
        return setImmediate(callback);
      }
      var oldest = this._created - this.maxFiles;
      var isOldest = oldest !== 0 ? oldest : '';
      var isZipped = this.zippedArchive ? '.gz' : '';
      var filePath = "".concat(basename).concat(isOldest).concat(ext).concat(isZipped);
      var target = path.join(this.dirname, filePath);
      fs.unlink(target, callback);
    }

    /**
     * Roll files forward based on integer, up to maxFiles. e.g. if base if
     * file.log and it becomes oversized, roll to file1.log, and allow file.log
     * to be re-used. If file is oversized again, roll file1.log to file2.log,
     * roll file.log to file1.log, and so on.
     * @param {mixed} ext - TODO: add param description.
     * @param {mixed} basename - TODO: add param description.
     * @param {mixed} callback - TODO: add param description.
     * @returns {undefined}
     * @private
     */
  }, {
    key: "_checkMaxFilesTailable",
    value: function _checkMaxFilesTailable(ext, basename, callback) {
      var _this12 = this;
      var tasks = [];
      if (!this.maxFiles) {
        return;
      }

      // const isZipped = this.zippedArchive ? '.gz' : '';
      var isZipped = this.zippedArchive ? '.gz' : '';
      for (var x = this.maxFiles - 1; x > 1; x--) {
        tasks.push(function (i, cb) {
          var _this11 = this;
          var fileName = "".concat(basename).concat(i - 1).concat(ext).concat(isZipped);
          var tmppath = path.join(this.dirname, fileName);
          fs.exists(tmppath, function (exists) {
            if (!exists) {
              return cb(null);
            }
            fileName = "".concat(basename).concat(i).concat(ext).concat(isZipped);
            fs.rename(tmppath, path.join(_this11.dirname, fileName), cb);
          });
        }.bind(this, x));
      }
      asyncSeries(tasks, function () {
        fs.rename(path.join(_this12.dirname, "".concat(basename).concat(ext)), path.join(_this12.dirname, "".concat(basename, "1").concat(ext).concat(isZipped)), callback);
      });
    }
  }, {
    key: "_createLogDirIfNotExist",
    value: function _createLogDirIfNotExist(dirPath) {
      /* eslint-disable no-sync */
      if (!fs.existsSync(dirPath)) {
        fs.mkdirSync(dirPath, {
          recursive: true
        });
      }
      /* eslint-enable no-sync */
    }
  }]);
  return File;
}(TransportStream);

/***/ }),

/***/ 85216:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
/**
 * http.js: Transport for outputting to a json-rpcserver.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var http = __webpack_require__(22321);
var https = __webpack_require__(78428);
var _require = __webpack_require__(88473),
  Stream = _require.Stream;
var TransportStream = __webpack_require__(94307);
var jsonStringify = __webpack_require__(87668);

/**
 * Transport for outputting to a json-rpc server.
 * @type {Stream}
 * @extends {TransportStream}
 */
module.exports = /*#__PURE__*/function (_TransportStream) {
  _inherits(Http, _TransportStream);
  var _super = _createSuper(Http);
  /**
   * Constructor function for the Http transport object responsible for
   * persisting log messages and metadata to a terminal or TTY.
   * @param {!Object} [options={}] - Options for this instance.
   */
  // eslint-disable-next-line max-statements
  function Http() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Http);
    _this = _super.call(this, options);
    _this.options = options;
    _this.name = options.name || 'http';
    _this.ssl = !!options.ssl;
    _this.host = options.host || 'localhost';
    _this.port = options.port;
    _this.auth = options.auth;
    _this.path = options.path || '';
    _this.agent = options.agent;
    _this.headers = options.headers || {};
    _this.headers['content-type'] = 'application/json';
    _this.batch = options.batch || false;
    _this.batchInterval = options.batchInterval || 5000;
    _this.batchCount = options.batchCount || 10;
    _this.batchOptions = [];
    _this.batchTimeoutID = -1;
    _this.batchCallback = {};
    if (!_this.port) {
      _this.port = _this.ssl ? 443 : 80;
    }
    return _this;
  }

  /**
   * Core logging method exposed to Winston.
   * @param {Object} info - TODO: add param description.
   * @param {function} callback - TODO: add param description.
   * @returns {undefined}
   */
  _createClass(Http, [{
    key: "log",
    value: function log(info, callback) {
      var _this2 = this;
      this._request(info, null, null, function (err, res) {
        if (res && res.statusCode !== 200) {
          err = new Error("Invalid HTTP Status Code: ".concat(res.statusCode));
        }
        if (err) {
          _this2.emit('warn', err);
        } else {
          _this2.emit('logged', info);
        }
      });

      // Remark: (jcrugzz) Fire and forget here so requests dont cause buffering
      // and block more requests from happening?
      if (callback) {
        setImmediate(callback);
      }
    }

    /**
     * Query the transport. Options object is optional.
     * @param {Object} options -  Loggly-like query options for this instance.
     * @param {function} callback - Continuation to respond to when complete.
     * @returns {undefined}
     */
  }, {
    key: "query",
    value: function query(options, callback) {
      if (typeof options === 'function') {
        callback = options;
        options = {};
      }
      options = {
        method: 'query',
        params: this.normalizeQuery(options)
      };
      var auth = options.params.auth || null;
      delete options.params.auth;
      var path = options.params.path || null;
      delete options.params.path;
      this._request(options, auth, path, function (err, res, body) {
        if (res && res.statusCode !== 200) {
          err = new Error("Invalid HTTP Status Code: ".concat(res.statusCode));
        }
        if (err) {
          return callback(err);
        }
        if (typeof body === 'string') {
          try {
            body = JSON.parse(body);
          } catch (e) {
            return callback(e);
          }
        }
        callback(null, body);
      });
    }

    /**
     * Returns a log stream for this transport. Options object is optional.
     * @param {Object} options - Stream options for this instance.
     * @returns {Stream} - TODO: add return description
     */
  }, {
    key: "stream",
    value: function stream() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var stream = new Stream();
      options = {
        method: 'stream',
        params: options
      };
      var path = options.params.path || null;
      delete options.params.path;
      var auth = options.params.auth || null;
      delete options.params.auth;
      var buff = '';
      var req = this._request(options, auth, path);
      stream.destroy = function () {
        return req.destroy();
      };
      req.on('data', function (data) {
        data = (buff + data).split(/\n+/);
        var l = data.length - 1;
        var i = 0;
        for (; i < l; i++) {
          try {
            stream.emit('log', JSON.parse(data[i]));
          } catch (e) {
            stream.emit('error', e);
          }
        }
        buff = data[l];
      });
      req.on('error', function (err) {
        return stream.emit('error', err);
      });
      return stream;
    }

    /**
     * Make a request to a winstond server or any http server which can
     * handle json-rpc.
     * @param {function} options - Options to sent the request.
     * @param {Object?} auth - authentication options
     * @param {string} path - request path
     * @param {function} callback - Continuation to respond to when complete.
     */
  }, {
    key: "_request",
    value: function _request(options, auth, path, callback) {
      options = options || {};
      auth = auth || this.auth;
      path = path || this.path || '';
      if (this.batch) {
        this._doBatch(options, callback, auth, path);
      } else {
        this._doRequest(options, callback, auth, path);
      }
    }

    /**
     * Send or memorize the options according to batch configuration
     * @param {function} options - Options to sent the request.
     * @param {function} callback - Continuation to respond to when complete.
     * @param {Object?} auth - authentication options
     * @param {string} path - request path
     */
  }, {
    key: "_doBatch",
    value: function _doBatch(options, callback, auth, path) {
      this.batchOptions.push(options);
      if (this.batchOptions.length === 1) {
        // First message stored, it's time to start the timeout!
        var me = this;
        this.batchCallback = callback;
        this.batchTimeoutID = setTimeout(function () {
          // timeout is reached, send all messages to endpoint
          me.batchTimeoutID = -1;
          me._doBatchRequest(me.batchCallback, auth, path);
        }, this.batchInterval);
      }
      if (this.batchOptions.length === this.batchCount) {
        // max batch count is reached, send all messages to endpoint
        this._doBatchRequest(this.batchCallback, auth, path);
      }
    }

    /**
     * Initiate a request with the memorized batch options, stop the batch timeout
     * @param {function} callback - Continuation to respond to when complete.
     * @param {Object?} auth - authentication options
     * @param {string} path - request path
     */
  }, {
    key: "_doBatchRequest",
    value: function _doBatchRequest(callback, auth, path) {
      if (this.batchTimeoutID > 0) {
        clearTimeout(this.batchTimeoutID);
        this.batchTimeoutID = -1;
      }
      var batchOptionsCopy = this.batchOptions.slice();
      this.batchOptions = [];
      this._doRequest(batchOptionsCopy, callback, auth, path);
    }

    /**
     * Make a request to a winstond server or any http server which can
     * handle json-rpc.
     * @param {function} options - Options to sent the request.
     * @param {function} callback - Continuation to respond to when complete.
     * @param {Object?} auth - authentication options
     * @param {string} path - request path
     */
  }, {
    key: "_doRequest",
    value: function _doRequest(options, callback, auth, path) {
      // Prepare options for outgoing HTTP request
      var headers = Object.assign({}, this.headers);
      if (auth && auth.bearer) {
        headers.Authorization = "Bearer ".concat(auth.bearer);
      }
      var req = (this.ssl ? https : http).request(_objectSpread(_objectSpread({}, this.options), {}, {
        method: 'POST',
        host: this.host,
        port: this.port,
        path: "/".concat(path.replace(/^\//, '')),
        headers: headers,
        auth: auth && auth.username && auth.password ? "".concat(auth.username, ":").concat(auth.password) : '',
        agent: this.agent
      }));
      req.on('error', callback);
      req.on('response', function (res) {
        return res.on('end', function () {
          return callback(null, res);
        }).resume();
      });
      req.end(Buffer.from(jsonStringify(options, this.options.replacer), 'utf8'));
    }
  }]);
  return Http;
}(TransportStream);

/***/ }),

/***/ 50557:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * transports.js: Set of all transports Winston knows about.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



/**
 * TODO: add property description.
 * @type {Console}
 */
Object.defineProperty(exports, "Console", ({
  configurable: true,
  enumerable: true,
  get: function get() {
    return __webpack_require__(93739);
  }
}));

/**
 * TODO: add property description.
 * @type {File}
 */
Object.defineProperty(exports, "File", ({
  configurable: true,
  enumerable: true,
  get: function get() {
    return __webpack_require__(13401);
  }
}));

/**
 * TODO: add property description.
 * @type {Http}
 */
Object.defineProperty(exports, "Http", ({
  configurable: true,
  enumerable: true,
  get: function get() {
    return __webpack_require__(85216);
  }
}));

/**
 * TODO: add property description.
 * @type {Stream}
 */
Object.defineProperty(exports, "Stream", ({
  configurable: true,
  enumerable: true,
  get: function get() {
    return __webpack_require__(36780);
  }
}));

/***/ }),

/***/ 36780:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * stream.js: Transport for outputting to any arbitrary stream.
 *
 * (C) 2010 Charlie Robbins
 * MIT LICENCE
 */



function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var isStream = __webpack_require__(24970);
var _require = __webpack_require__(15396),
  MESSAGE = _require.MESSAGE;
var os = __webpack_require__(73461);
var TransportStream = __webpack_require__(94307);

/**
 * Transport for outputting to any arbitrary stream.
 * @type {Stream}
 * @extends {TransportStream}
 */
module.exports = /*#__PURE__*/function (_TransportStream) {
  _inherits(Stream, _TransportStream);
  var _super = _createSuper(Stream);
  /**
   * Constructor function for the Console transport object responsible for
   * persisting log messages and metadata to a terminal or TTY.
   * @param {!Object} [options={}] - Options for this instance.
   */
  function Stream() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Stream);
    _this = _super.call(this, options);
    if (!options.stream || !isStream(options.stream)) {
      throw new Error('options.stream is required.');
    }

    // We need to listen for drain events when write() returns false. This can
    // make node mad at times.
    _this._stream = options.stream;
    _this._stream.setMaxListeners(Infinity);
    _this.isObjectMode = options.stream._writableState.objectMode;
    _this.eol = typeof options.eol === 'string' ? options.eol : os.EOL;
    return _this;
  }

  /**
   * Core logging method exposed to Winston.
   * @param {Object} info - TODO: add param description.
   * @param {Function} callback - TODO: add param description.
   * @returns {undefined}
   */
  _createClass(Stream, [{
    key: "log",
    value: function log(info, callback) {
      var _this2 = this;
      setImmediate(function () {
        return _this2.emit('logged', info);
      });
      if (this.isObjectMode) {
        this._stream.write(info);
        if (callback) {
          callback(); // eslint-disable-line callback-return
        }

        return;
      }
      this._stream.write("".concat(info[MESSAGE]).concat(this.eol));
      if (callback) {
        callback(); // eslint-disable-line callback-return
      }

      return;
    }
  }]);
  return Stream;
}(TransportStream);

/***/ }),

/***/ 49329:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(60516).Observable;


/***/ }),

/***/ 60516:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Observable = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// === Symbol Support ===
var hasSymbols = function () {
  return typeof Symbol === 'function';
};

var hasSymbol = function (name) {
  return hasSymbols() && Boolean(Symbol[name]);
};

var getSymbol = function (name) {
  return hasSymbol(name) ? Symbol[name] : '@@' + name;
};

if (hasSymbols() && !hasSymbol('observable')) {
  Symbol.observable = Symbol('observable');
}

var SymbolIterator = getSymbol('iterator');
var SymbolObservable = getSymbol('observable');
var SymbolSpecies = getSymbol('species'); // === Abstract Operations ===

function getMethod(obj, key) {
  var value = obj[key];
  if (value == null) return undefined;
  if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
  return value;
}

function getSpecies(obj) {
  var ctor = obj.constructor;

  if (ctor !== undefined) {
    ctor = ctor[SymbolSpecies];

    if (ctor === null) {
      ctor = undefined;
    }
  }

  return ctor !== undefined ? ctor : Observable;
}

function isObservable(x) {
  return x instanceof Observable; // SPEC: Brand check
}

function hostReportError(e) {
  if (hostReportError.log) {
    hostReportError.log(e);
  } else {
    setTimeout(function () {
      throw e;
    });
  }
}

function enqueue(fn) {
  Promise.resolve().then(function () {
    try {
      fn();
    } catch (e) {
      hostReportError(e);
    }
  });
}

function cleanupSubscription(subscription) {
  var cleanup = subscription._cleanup;
  if (cleanup === undefined) return;
  subscription._cleanup = undefined;

  if (!cleanup) {
    return;
  }

  try {
    if (typeof cleanup === 'function') {
      cleanup();
    } else {
      var unsubscribe = getMethod(cleanup, 'unsubscribe');

      if (unsubscribe) {
        unsubscribe.call(cleanup);
      }
    }
  } catch (e) {
    hostReportError(e);
  }
}

function closeSubscription(subscription) {
  subscription._observer = undefined;
  subscription._queue = undefined;
  subscription._state = 'closed';
}

function flushSubscription(subscription) {
  var queue = subscription._queue;

  if (!queue) {
    return;
  }

  subscription._queue = undefined;
  subscription._state = 'ready';

  for (var i = 0; i < queue.length; ++i) {
    notifySubscription(subscription, queue[i].type, queue[i].value);
    if (subscription._state === 'closed') break;
  }
}

function notifySubscription(subscription, type, value) {
  subscription._state = 'running';
  var observer = subscription._observer;

  try {
    var m = getMethod(observer, type);

    switch (type) {
      case 'next':
        if (m) m.call(observer, value);
        break;

      case 'error':
        closeSubscription(subscription);
        if (m) m.call(observer, value);else throw value;
        break;

      case 'complete':
        closeSubscription(subscription);
        if (m) m.call(observer);
        break;
    }
  } catch (e) {
    hostReportError(e);
  }

  if (subscription._state === 'closed') cleanupSubscription(subscription);else if (subscription._state === 'running') subscription._state = 'ready';
}

function onNotify(subscription, type, value) {
  if (subscription._state === 'closed') return;

  if (subscription._state === 'buffering') {
    subscription._queue.push({
      type: type,
      value: value
    });

    return;
  }

  if (subscription._state !== 'ready') {
    subscription._state = 'buffering';
    subscription._queue = [{
      type: type,
      value: value
    }];
    enqueue(function () {
      return flushSubscription(subscription);
    });
    return;
  }

  notifySubscription(subscription, type, value);
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(observer, subscriber) {
    _classCallCheck(this, Subscription);

    // ASSERT: observer is an object
    // ASSERT: subscriber is callable
    this._cleanup = undefined;
    this._observer = observer;
    this._queue = undefined;
    this._state = 'initializing';
    var subscriptionObserver = new SubscriptionObserver(this);

    try {
      this._cleanup = subscriber.call(undefined, subscriptionObserver);
    } catch (e) {
      subscriptionObserver.error(e);
    }

    if (this._state === 'initializing') this._state = 'ready';
  }

  _createClass(Subscription, [{
    key: "unsubscribe",
    value: function unsubscribe() {
      if (this._state !== 'closed') {
        closeSubscription(this);
        cleanupSubscription(this);
      }
    }
  }, {
    key: "closed",
    get: function () {
      return this._state === 'closed';
    }
  }]);

  return Subscription;
}();

var SubscriptionObserver =
/*#__PURE__*/
function () {
  function SubscriptionObserver(subscription) {
    _classCallCheck(this, SubscriptionObserver);

    this._subscription = subscription;
  }

  _createClass(SubscriptionObserver, [{
    key: "next",
    value: function next(value) {
      onNotify(this._subscription, 'next', value);
    }
  }, {
    key: "error",
    value: function error(value) {
      onNotify(this._subscription, 'error', value);
    }
  }, {
    key: "complete",
    value: function complete() {
      onNotify(this._subscription, 'complete');
    }
  }, {
    key: "closed",
    get: function () {
      return this._subscription._state === 'closed';
    }
  }]);

  return SubscriptionObserver;
}();

var Observable =
/*#__PURE__*/
function () {
  function Observable(subscriber) {
    _classCallCheck(this, Observable);

    if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
    if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
    this._subscriber = subscriber;
  }

  _createClass(Observable, [{
    key: "subscribe",
    value: function subscribe(observer) {
      if (typeof observer !== 'object' || observer === null) {
        observer = {
          next: observer,
          error: arguments[1],
          complete: arguments[2]
        };
      }

      return new Subscription(observer, this._subscriber);
    }
  }, {
    key: "forEach",
    value: function forEach(fn) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        if (typeof fn !== 'function') {
          reject(new TypeError(fn + ' is not a function'));
          return;
        }

        function done() {
          subscription.unsubscribe();
          resolve();
        }

        var subscription = _this.subscribe({
          next: function (value) {
            try {
              fn(value, done);
            } catch (e) {
              reject(e);
              subscription.unsubscribe();
            }
          },
          error: reject,
          complete: resolve
        });
      });
    }
  }, {
    key: "map",
    value: function map(fn) {
      var _this2 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
      var C = getSpecies(this);
      return new C(function (observer) {
        return _this2.subscribe({
          next: function (value) {
            try {
              value = fn(value);
            } catch (e) {
              return observer.error(e);
            }

            observer.next(value);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            observer.complete();
          }
        });
      });
    }
  }, {
    key: "filter",
    value: function filter(fn) {
      var _this3 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
      var C = getSpecies(this);
      return new C(function (observer) {
        return _this3.subscribe({
          next: function (value) {
            try {
              if (!fn(value)) return;
            } catch (e) {
              return observer.error(e);
            }

            observer.next(value);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            observer.complete();
          }
        });
      });
    }
  }, {
    key: "reduce",
    value: function reduce(fn) {
      var _this4 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
      var C = getSpecies(this);
      var hasSeed = arguments.length > 1;
      var hasValue = false;
      var seed = arguments[1];
      var acc = seed;
      return new C(function (observer) {
        return _this4.subscribe({
          next: function (value) {
            var first = !hasValue;
            hasValue = true;

            if (!first || hasSeed) {
              try {
                acc = fn(acc, value);
              } catch (e) {
                return observer.error(e);
              }
            } else {
              acc = value;
            }
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
            observer.next(acc);
            observer.complete();
          }
        });
      });
    }
  }, {
    key: "concat",
    value: function concat() {
      var _this5 = this;

      for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
        sources[_key] = arguments[_key];
      }

      var C = getSpecies(this);
      return new C(function (observer) {
        var subscription;
        var index = 0;

        function startNext(next) {
          subscription = next.subscribe({
            next: function (v) {
              observer.next(v);
            },
            error: function (e) {
              observer.error(e);
            },
            complete: function () {
              if (index === sources.length) {
                subscription = undefined;
                observer.complete();
              } else {
                startNext(C.from(sources[index++]));
              }
            }
          });
        }

        startNext(_this5);
        return function () {
          if (subscription) {
            subscription.unsubscribe();
            subscription = undefined;
          }
        };
      });
    }
  }, {
    key: "flatMap",
    value: function flatMap(fn) {
      var _this6 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
      var C = getSpecies(this);
      return new C(function (observer) {
        var subscriptions = [];

        var outer = _this6.subscribe({
          next: function (value) {
            if (fn) {
              try {
                value = fn(value);
              } catch (e) {
                return observer.error(e);
              }
            }

            var inner = C.from(value).subscribe({
              next: function (value) {
                observer.next(value);
              },
              error: function (e) {
                observer.error(e);
              },
              complete: function () {
                var i = subscriptions.indexOf(inner);
                if (i >= 0) subscriptions.splice(i, 1);
                completeIfDone();
              }
            });
            subscriptions.push(inner);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            completeIfDone();
          }
        });

        function completeIfDone() {
          if (outer.closed && subscriptions.length === 0) observer.complete();
        }

        return function () {
          subscriptions.forEach(function (s) {
            return s.unsubscribe();
          });
          outer.unsubscribe();
        };
      });
    }
  }, {
    key: SymbolObservable,
    value: function () {
      return this;
    }
  }], [{
    key: "from",
    value: function from(x) {
      var C = typeof this === 'function' ? this : Observable;
      if (x == null) throw new TypeError(x + ' is not an object');
      var method = getMethod(x, SymbolObservable);

      if (method) {
        var observable = method.call(x);
        if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
        if (isObservable(observable) && observable.constructor === C) return observable;
        return new C(function (observer) {
          return observable.subscribe(observer);
        });
      }

      if (hasSymbol('iterator')) {
        method = getMethod(x, SymbolIterator);

        if (method) {
          return new C(function (observer) {
            enqueue(function () {
              if (observer.closed) return;
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _item = _step.value;
                  observer.next(_item);
                  if (observer.closed) return;
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              observer.complete();
            });
          });
        }
      }

      if (Array.isArray(x)) {
        return new C(function (observer) {
          enqueue(function () {
            if (observer.closed) return;

            for (var i = 0; i < x.length; ++i) {
              observer.next(x[i]);
              if (observer.closed) return;
            }

            observer.complete();
          });
        });
      }

      throw new TypeError(x + ' is not observable');
    }
  }, {
    key: "of",
    value: function of() {
      for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        items[_key2] = arguments[_key2];
      }

      var C = typeof this === 'function' ? this : Observable;
      return new C(function (observer) {
        enqueue(function () {
          if (observer.closed) return;

          for (var i = 0; i < items.length; ++i) {
            observer.next(items[i]);
            if (observer.closed) return;
          }

          observer.complete();
        });
      });
    }
  }, {
    key: SymbolSpecies,
    get: function () {
      return this;
    }
  }]);

  return Observable;
}();

exports.Observable = Observable;

if (hasSymbols()) {
  Object.defineProperty(Observable, Symbol('extensions'), {
    value: {
      symbol: SymbolObservable,
      hostReportError: hostReportError
    },
    configurable: true
  });
}

/***/ }),

/***/ 42480:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 52361:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 94616:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 85811:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 62828:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 30907:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),

/***/ 83878:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),

/***/ 97326:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),

/***/ 15671:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 43144:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83997);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ 4942:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83997);

function _defineProperty(obj, key, value) {
  key = (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 94578:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inheritsLoose; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89611);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 59199:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),

/***/ 25267:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),

/***/ 45987:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutProperties; }
/* harmony export */ });
/* harmony import */ var _objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63366);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = (0,_objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),

/***/ 63366:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),

/***/ 89611:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 97685:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(83878);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(25267);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return (0,arrayWithHoles/* default */.Z)(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || (0,nonIterableRest/* default */.Z)();
}

/***/ }),

/***/ 74902:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(30907);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__(59199);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,iterableToArray/* default */.Z)(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ }),

/***/ 83997:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toPropertyKey; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function _toPrimitive(input, hint) {
  if ((0,esm_typeof/* default */.Z)(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if ((0,esm_typeof/* default */.Z)(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return (0,esm_typeof/* default */.Z)(key) === "symbol" ? key : String(key);
}

/***/ }),

/***/ 71002:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),

/***/ 40181:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30907);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ }),

/***/ 20943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 47568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 51438:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 52951:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}


/***/ }),

/***/ 76166:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _createSuper; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(82662);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(82222);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_possible_constructor_return.mjs



function _possibleConstructorReturn(self, call) {
  if (call && ((0,_type_of/* default */.Z)(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0,_get_prototype_of/* default */.Z)(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0,_get_prototype_of/* default */.Z)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

/***/ }),

/***/ 14924:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 82662:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}

/***/ }),

/***/ 28668:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _set_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44998);


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) (0,_set_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}


/***/ }),

/***/ 13375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 26042:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 44998:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}


/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ }),

/***/ 29815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 82222:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};


/***/ }),

/***/ 91566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 6154:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ lib_axios; }
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/bind.js


function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/utils.js




// utils is a library of generic helper functions non-specific to axios

const {toString: utils_toString} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = utils_toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
}

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
}

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : global)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  }

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
}

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
}

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const utils_hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    if (reducer(descriptor, name, obj) !== false) {
      reducedDescriptors[name] = descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
}

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
}

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  }

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
}

const noop = () => {}

const toFiniteNumber = (value, defaultValue) => {
  value = +value;
  return Number.isFinite(value) ? value : defaultValue;
}

const ALPHA = 'abcdefghijklmnopqrstuvwxyz'

const DIGIT = '0123456789';

const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
}

const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {length} = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length|0]
  }

  return str;
}

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  }

  return visit(obj, 0);
}

const isAsyncFn = kindOfTest('AsyncFunction');

const isThenable = (thing) =>
  thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);

/* harmony default export */ var utils = ({
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty: utils_hasOwnProperty,
  hasOwnProp: utils_hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/AxiosError.js




/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

const AxiosError_prototype = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(AxiosError_prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(AxiosError_prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

/* harmony default export */ var core_AxiosError = (AxiosError);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/null.js
// eslint-disable-next-line strict
/* harmony default export */ var helpers_null = (null);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/toFormData.js
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];




// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored


/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return utils.isPlainObject(thing) || utils.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return utils.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return utils.isArray(arr) && !arr.some(isVisitable);
}

const predicates = utils.toFlatObject(utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!utils.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (helpers_null || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils.isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && utils.isSpecCompliantForm(formData);

  if (!utils.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils.isBlob(value)) {
      throw new core_AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils.isArray(value) && isFlatArray(value)) ||
        ((utils.isFileList(value) || utils.endsWith(key, '[]')) && (arr = utils.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(utils.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (utils.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils.forEach(value, function each(el, key) {
      const result = !(utils.isUndefined(el) || el === null) && visitor.call(
        formData, el, utils.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/* harmony default export */ var helpers_toFormData = (toFormData);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/AxiosURLSearchParams.js




/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && helpers_toFormData(params, this, options);
}

const AxiosURLSearchParams_prototype = AxiosURLSearchParams.prototype;

AxiosURLSearchParams_prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

AxiosURLSearchParams_prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode);
  } : encode;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/* harmony default export */ var helpers_AxiosURLSearchParams = (AxiosURLSearchParams);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/buildURL.js





/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function buildURL_encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || buildURL_encode;

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils.isURLSearchParams(params) ?
      params.toString() :
      new helpers_AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/InterceptorManager.js




class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

/* harmony default export */ var core_InterceptorManager = (InterceptorManager);

;// CONCATENATED MODULE: ./node_modules/axios/lib/defaults/transitional.js


/* harmony default export */ var defaults_transitional = ({
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/URLSearchParams.js



/* harmony default export */ var classes_URLSearchParams = (typeof URLSearchParams !== 'undefined' ? URLSearchParams : helpers_AxiosURLSearchParams);

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/FormData.js


/* harmony default export */ var classes_FormData = (typeof FormData !== 'undefined' ? FormData : null);

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/Blob.js


/* harmony default export */ var classes_Blob = (typeof Blob !== 'undefined' ? Blob : null);

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/index.js




/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const isStandardBrowserEnv = (() => {
  let product;
  if (typeof navigator !== 'undefined' && (
    (product = navigator.product) === 'ReactNative' ||
    product === 'NativeScript' ||
    product === 'NS')
  ) {
    return false;
  }

  return typeof window !== 'undefined' && typeof document !== 'undefined';
})();

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
 const isStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();


/* harmony default export */ var browser = ({
  isBrowser: true,
  classes: {
    URLSearchParams: classes_URLSearchParams,
    FormData: classes_FormData,
    Blob: classes_Blob
  },
  isStandardBrowserEnv,
  isStandardBrowserWebWorkerEnv,
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/toURLEncodedForm.js






function toURLEncodedForm(data, options) {
  return helpers_toFormData(data, new browser.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (browser.isNode && utils.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/formDataToJSON.js




/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];
    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
    const obj = {};

    utils.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/* harmony default export */ var helpers_formDataToJSON = (formDataToJSON);

;// CONCATENATED MODULE: ./node_modules/axios/lib/defaults/index.js










const DEFAULT_CONTENT_TYPE = {
  'Content-Type': undefined
};

/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: defaults_transitional,

  adapter: ['xhr', 'http'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils.isObject(data);

    if (isObjectPayload && utils.isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = utils.isFormData(data);

    if (isFormData) {
      if (!hasJSONContentType) {
        return data;
      }
      return hasJSONContentType ? JSON.stringify(helpers_formDataToJSON(data)) : data;
    }

    if (utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return helpers_toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (data && utils.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw core_AxiosError.from(e, core_AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: browser.classes.FormData,
    Blob: browser.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

/* harmony default export */ var lib_defaults = (defaults);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/parseHeaders.js




// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils.toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
/* harmony default export */ var parseHeaders = (rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/AxiosHeaders.js





const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils.isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!utils.isString(value)) return;

  if (utils.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = utils.toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = utils.findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      utils.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (utils.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite)
    } else if(utils.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (utils.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (utils.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = utils.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (utils.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    utils.forEach(this, (value, header) => {
      const key = utils.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    utils.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils.isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

utils.freezeMethods(AxiosHeaders.prototype);
utils.freezeMethods(AxiosHeaders);

/* harmony default export */ var core_AxiosHeaders = (AxiosHeaders);

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/transformData.js






/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || lib_defaults;
  const context = response || config;
  const headers = core_AxiosHeaders.from(context.headers);
  let data = context.data;

  utils.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/isCancel.js


function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/CanceledError.js





/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  core_AxiosError.call(this, message == null ? 'canceled' : message, core_AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, core_AxiosError, {
  __CANCEL__: true
});

/* harmony default export */ var cancel_CanceledError = (CanceledError);

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/settle.js




/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new core_AxiosError(
      'Request failed with status code ' + response.status,
      [core_AxiosError.ERR_BAD_REQUEST, core_AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/cookies.js





/* harmony default export */ var cookies = (browser.isStandardBrowserEnv ?

// Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        const cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

// Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })());

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isAbsoluteURL.js


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/combineURLs.js


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/buildFullPath.js





/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isURLSameOrigin.js





/* harmony default export */ var isURLSameOrigin = (browser.isStandardBrowserEnv ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      let href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
          urlParsingNode.pathname :
          '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      const parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
          parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })());

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/parseProtocol.js


function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/speedometer.js


/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/* harmony default export */ var helpers_speedometer = (speedometer);

;// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/xhr.js
















function progressEventReducer(listener, isDownloadStream) {
  let bytesNotified = 0;
  const _speedometer = helpers_speedometer(50, 250);

  return e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e
    };

    data[isDownloadStream ? 'download' : 'upload'] = true;

    listener(data);
  };
}

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

/* harmony default export */ var xhr = (isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    let requestData = config.data;
    const requestHeaders = core_AxiosHeaders.from(config.headers).normalize();
    const responseType = config.responseType;
    let onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData)) {
      if (browser.isStandardBrowserEnv || browser.isStandardBrowserWebWorkerEnv) {
        requestHeaders.setContentType(false); // Let the browser set it
      } else {
        requestHeaders.setContentType('multipart/form-data;', false); // mobile/desktop app frameworks
      }
    }

    let request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      const username = config.auth.username || '';
      const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.set('Authorization', 'Basic ' + btoa(username + ':' + password));
    }

    const fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = core_AxiosHeaders.from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new core_AxiosError('Request aborted', core_AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new core_AxiosError('Network Error', core_AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = config.transitional || defaults_transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new core_AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? core_AxiosError.ETIMEDOUT : core_AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (browser.isStandardBrowserEnv) {
      // Add xsrf header
      const xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath))
        && config.xsrfCookieName && cookies.read(config.xsrfCookieName);

      if (xsrfValue) {
        requestHeaders.set(config.xsrfHeaderName, xsrfValue);
      }
    }

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', progressEventReducer(config.onDownloadProgress, true));
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', progressEventReducer(config.onUploadProgress));
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new cancel_CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(fullPath);

    if (protocol && browser.protocols.indexOf(protocol) === -1) {
      reject(new core_AxiosError('Unsupported protocol ' + protocol + ':', core_AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/adapters.js





const knownAdapters = {
  http: helpers_null,
  xhr: xhr
}

utils.forEach(knownAdapters, (fn, value) => {
  if(fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

/* harmony default export */ var adapters = ({
  getAdapter: (adapters) => {
    adapters = utils.isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      if((adapter = utils.isString(nameOrAdapter) ? knownAdapters[nameOrAdapter.toLowerCase()] : nameOrAdapter)) {
        break;
      }
    }

    if (!adapter) {
      if (adapter === false) {
        throw new core_AxiosError(
          `Adapter ${nameOrAdapter} is not supported by the environment`,
          'ERR_NOT_SUPPORT'
        );
      }

      throw new Error(
        utils.hasOwnProp(knownAdapters, nameOrAdapter) ?
          `Adapter '${nameOrAdapter}' is not available in the build` :
          `Unknown adapter '${nameOrAdapter}'`
      );
    }

    if (!utils.isFunction(adapter)) {
      throw new TypeError('adapter is not a function');
    }

    return adapter;
  },
  adapters: knownAdapters
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/dispatchRequest.js









/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new cancel_CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = core_AxiosHeaders.from(config.headers);

  // Transform request data
  config.data = transformData.call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || lib_defaults.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );

    response.headers = core_AxiosHeaders.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = core_AxiosHeaders.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/mergeConfig.js





const headersToObject = (thing) => thing instanceof core_AxiosHeaders ? thing.toJSON() : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, caseless) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge.call({caseless}, target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, caseless) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };

  utils.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/env/data.js
const VERSION = "1.4.0";
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/validator.js





const validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new core_AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        core_AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new core_AxiosError('options must be an object', core_AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new core_AxiosError('option ' + opt + ' must be ' + result, core_AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new core_AxiosError('Unknown option ' + opt, core_AxiosError.ERR_BAD_OPTION);
    }
  }
}

/* harmony default export */ var validator = ({
  assertOptions,
  validators
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/Axios.js











const Axios_validators = validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new core_InterceptorManager(),
      response: new core_InterceptorManager()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        forcedJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        clarifyTimeoutError: Axios_validators.transitional(Axios_validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (utils.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        }
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: Axios_validators.function,
          serialize: Axios_validators.function
        }, true);
      }
    }

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    let contextHeaders;

    // Flatten headers
    contextHeaders = headers && utils.merge(
      headers.common,
      headers[config.method]
    );

    contextHeaders && utils.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = core_AxiosHeaders.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

/* harmony default export */ var core_Axios = (Axios);

;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/CancelToken.js




/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new cancel_CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

/* harmony default export */ var cancel_CancelToken = (CancelToken);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/spread.js


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isAxiosError.js




/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/HttpStatusCode.js
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

/* harmony default export */ var helpers_HttpStatusCode = (HttpStatusCode);

;// CONCATENATED MODULE: ./node_modules/axios/lib/axios.js



















/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new core_Axios(defaultConfig);
  const instance = bind(core_Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, core_Axios.prototype, context, {allOwnKeys: true});

  // Copy context to instance
  utils.extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(lib_defaults);

// Expose Axios class to allow class inheritance
axios.Axios = core_Axios;

// Expose Cancel & CancelToken
axios.CanceledError = cancel_CanceledError;
axios.CancelToken = cancel_CancelToken;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = helpers_toFormData;

// Expose AxiosError class
axios.AxiosError = core_AxiosError;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios.mergeConfig = mergeConfig;

axios.AxiosHeaders = core_AxiosHeaders;

axios.formToJSON = thing => helpers_formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);

axios.HttpStatusCode = helpers_HttpStatusCode;

axios.default = axios;

// this module should only have a default export
/* harmony default export */ var lib_axios = (axios);


/***/ }),

/***/ 25821:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ inspect; }
/* harmony export */ });
/* harmony import */ var _nodejsCustomInspectSymbol_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45695);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* eslint-disable flowtype/no-weak-types */

var MAX_ARRAY_LENGTH = 10;
var MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (_typeof(value)) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? "[function ".concat(value.name, "]") : '[function]';

    case 'object':
      if (value === null) {
        return 'null';
      }

      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (previouslySeenValues.indexOf(value) !== -1) {
    return '[Circular]';
  }

  var seenValues = [].concat(previouslySeenValues, [value]);
  var customInspectFn = getCustomFn(value);

  if (customInspectFn !== undefined) {
    var customValue = customInspectFn.call(value); // check for infinite recursion

    if (customValue !== value) {
      return typeof customValue === 'string' ? customValue : formatValue(customValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function formatObject(object, seenValues) {
  var keys = Object.keys(object);

  if (keys.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  var properties = keys.map(function (key) {
    var value = formatValue(object[key], seenValues);
    return key + ': ' + value;
  });
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  var len = Math.min(MAX_ARRAY_LENGTH, array.length);
  var remaining = array.length - len;
  var items = [];

  for (var i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push("... ".concat(remaining, " more items"));
  }

  return '[' + items.join(', ') + ']';
}

function getCustomFn(object) {
  var customInspectFn = object[String(_nodejsCustomInspectSymbol_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)];

  if (typeof customInspectFn === 'function') {
    return customInspectFn;
  }

  if (typeof object.inspect === 'function') {
    return object.inspect;
  }
}

function getObjectTag(object) {
  var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    var name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}


/***/ }),

/***/ 45695:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
/* harmony default export */ __webpack_exports__["Z"] = (nodejsCustomInspectSymbol);


/***/ }),

/***/ 29749:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ye": function() { return /* binding */ Location; },
  "WU": function() { return /* binding */ Token; },
  "UG": function() { return /* binding */ isNode; }
});

;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/invariant.mjs
function invariant(condition, message) {
  var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')

  if (!booleanCondition) {
    throw new Error(message != null ? message : 'Unexpected invariant triggered.');
  }
}

// EXTERNAL MODULE: ./node_modules/graphql/jsutils/nodejsCustomInspectSymbol.mjs
var nodejsCustomInspectSymbol = __webpack_require__(45695);
;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/defineInspect.mjs


/**
 * The `defineInspect()` function defines `inspect()` prototype method as alias of `toJSON`
 */

function defineInspect(classObject) {
  var fn = classObject.prototype.toJSON;
  typeof fn === 'function' || invariant(0);
  classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')

  if (nodejsCustomInspectSymbol/* default */.Z) {
    classObject.prototype[nodejsCustomInspectSymbol/* default */.Z] = fn;
  }
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/ast.mjs


/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */
var Location = /*#__PURE__*/function () {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  function Location(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }

  var _proto = Location.prototype;

  _proto.toJSON = function toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  };

  return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

defineInspect(Location);
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */

var Token = /*#__PURE__*/function () {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  function Token(kind, start, end, line, column, prev, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column;
    this.value = value;
    this.prev = prev;
    this.next = null;
  }

  var _proto2 = Token.prototype;

  _proto2.toJSON = function toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  };

  return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

defineInspect(Token);
/**
 * @internal
 */

function isNode(maybeNode) {
  return maybeNode != null && typeof maybeNode.kind === 'string';
}
/**
 * The list of all possible AST node types.
 */


/***/ }),

/***/ 87392:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LZ": function() { return /* binding */ printBlockString; },
/* harmony export */   "W7": function() { return /* binding */ dedentBlockStringValue; }
/* harmony export */ });
/* unused harmony export getBlockStringIndentation */
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */
function dedentBlockStringValue(rawString) {
  // Expand a block string's raw value into independent lines.
  var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.

  var commonIndent = getBlockStringIndentation(rawString);

  if (commonIndent !== 0) {
    for (var i = 1; i < lines.length; i++) {
      lines[i] = lines[i].slice(commonIndent);
    }
  } // Remove leading and trailing blank lines.


  var startLine = 0;

  while (startLine < lines.length && isBlank(lines[startLine])) {
    ++startLine;
  }

  var endLine = lines.length;

  while (endLine > startLine && isBlank(lines[endLine - 1])) {
    --endLine;
  } // Return a string of the lines joined with U+000A.


  return lines.slice(startLine, endLine).join('\n');
}

function isBlank(str) {
  for (var i = 0; i < str.length; ++i) {
    if (str[i] !== ' ' && str[i] !== '\t') {
      return false;
    }
  }

  return true;
}
/**
 * @internal
 */


function getBlockStringIndentation(value) {
  var _commonIndent;

  var isFirstLine = true;
  var isEmptyLine = true;
  var indent = 0;
  var commonIndent = null;

  for (var i = 0; i < value.length; ++i) {
    switch (value.charCodeAt(i)) {
      case 13:
        //  \r
        if (value.charCodeAt(i + 1) === 10) {
          ++i; // skip \r\n as one symbol
        }

      // falls through

      case 10:
        //  \n
        isFirstLine = false;
        isEmptyLine = true;
        indent = 0;
        break;

      case 9: //   \t

      case 32:
        //  <space>
        ++indent;
        break;

      default:
        if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) {
          commonIndent = indent;
        }

        isEmptyLine = false;
    }
  }

  return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */

function printBlockString(value) {
  var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isSingleLine = value.indexOf('\n') === -1;
  var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
  var hasTrailingQuote = value[value.length - 1] === '"';
  var hasTrailingSlash = value[value.length - 1] === '\\';
  var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
  var result = ''; // Format a multi-line block quote to account for leading space.

  if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) {
    result += '\n' + indentation;
  }

  result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;

  if (printAsMultipleLines) {
    result += '\n';
  }

  return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}


/***/ }),

/***/ 12561:
/***/ (function(module) {

"use strict";
module.exports = {"version":"3.11.0"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(97239), __webpack_exec__(6840), __webpack_exec__(90387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);